var Zauzoo = Zauzoo || {}; Zauzoo["module"] =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonpZauzoo__name_"];
/******/ 	window["webpackJsonpZauzoo__name_"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				var _m = moreModules[moduleId];
/******/
/******/ 				// Check if module is deduplicated
/******/ 				switch(typeof _m) {
/******/ 				case "object":
/******/ 					// Module can be created from a template
/******/ 					modules[moduleId] = (function(_m) {
/******/ 						var args = _m.slice(1), templateId = _m[0];
/******/ 						return function (a,b,c) {
/******/ 							modules[templateId].apply(this, [a,b,c].concat(args));
/******/ 						};
/******/ 					}(_m));
/******/ 					break;
/******/ 				case "function":
/******/ 					// Normal module
/******/ 					modules[moduleId] = _m;
/******/ 					break;
/******/ 				default:
/******/ 					// Module is a copy of another module
/******/ 					modules[moduleId] = modules[_m];
/******/ 					break;
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		1:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + "." + ({"0":"reactAce","2":"reactEmailEditor"}[chunkId]||chunkId) + "-" + "6f8fe77d" + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1275);
	__webpack_require__(1273);
	module.exports = __webpack_require__(2159);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(252);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1638)();
	}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/******************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	/* global global, define, Symbol, Reflect, Promise, SuppressedError */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __esDecorate;
	var __runInitializers;
	var __propKey;
	var __setFunctionName;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __spreadArray;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __classPrivateFieldIn;
	var __createBinding;
	var __addDisposableResource;
	var __disposeResources;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __esDecorate = function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
	        function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
	        var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
	        var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
	        var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
	        var _, done = false;
	        for (var i = decorators.length - 1; i >= 0; i--) {
	            var context = {};
	            for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
	            for (var p in contextIn.access) context.access[p] = contextIn.access[p];
	            context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
	            var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
	            if (kind === "accessor") {
	                if (result === void 0) continue;
	                if (result === null || typeof result !== "object") throw new TypeError("Object expected");
	                if (_ = accept(result.get)) descriptor.get = _;
	                if (_ = accept(result.set)) descriptor.set = _;
	                if (_ = accept(result.init)) initializers.unshift(_);
	            }
	            else if (_ = accept(result)) {
	                if (kind === "field") initializers.unshift(_);
	                else descriptor[key] = _;
	            }
	        }
	        if (target) Object.defineProperty(target, contextIn.name, descriptor);
	        done = true;
	    };
	
	    __runInitializers = function (thisArg, initializers, value) {
	        var useValue = arguments.length > 2;
	        for (var i = 0; i < initializers.length; i++) {
	            value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
	        }
	        return useValue ? value : void 0;
	    };
	
	    __propKey = function (x) {
	        return typeof x === "symbol" ? x : "".concat(x);
	    };
	
	    __setFunctionName = function (f, name, prefix) {
	        if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
	        return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (g && (g = 0, op[0] && (_ = 0)), _) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __exportStar = function(m, o) {
	        for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
	    };
	
	    __createBinding = Object.create ? (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        var desc = Object.getOwnPropertyDescriptor(m, k);
	        if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	            desc = { enumerable: true, get: function() { return m[k]; } };
	        }
	        Object.defineProperty(o, k2, desc);
	    }) : (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    });
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    /** @deprecated */
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    /** @deprecated */
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __spreadArray = function (to, from, pack) {
	        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	            if (ar || !(i in from)) {
	                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	                ar[i] = from[i];
	            }
	        }
	        return to.concat(ar || Array.prototype.slice.call(from));
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
	        function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    var __setModuleDefault = Object.create ? (function(o, v) {
	        Object.defineProperty(o, "default", { enumerable: true, value: v });
	    }) : function(o, v) {
	        o["default"] = v;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	        __setModuleDefault(result, mod);
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, state, kind, f) {
	        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
	        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
	        return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, state, value, kind, f) {
	        if (kind === "m") throw new TypeError("Private method is not writable");
	        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
	        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
	        return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
	    };
	
	    __classPrivateFieldIn = function (state, receiver) {
	        if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
	        return typeof state === "function" ? receiver === state : state.has(receiver);
	    };
	
	    __addDisposableResource = function (env, value, async) {
	        if (value !== null && value !== void 0) {
	            if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
	            var dispose, inner;
	            if (async) {
	                if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
	                dispose = value[Symbol.asyncDispose];
	            }
	            if (dispose === void 0) {
	                if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
	                dispose = value[Symbol.dispose];
	                if (async) inner = dispose;
	            }
	            if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
	            if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
	            env.stack.push({ value: value, dispose: dispose, async: async });
	        }
	        else if (async) {
	            env.stack.push({ async: true });
	        }
	        return value;
	    };
	
	    var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
	        var e = new Error(message);
	        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
	    };
	
	    __disposeResources = function (env) {
	        function fail(e) {
	            env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
	            env.hasError = true;
	        }
	        function next() {
	            while (env.stack.length) {
	                var rec = env.stack.pop();
	                try {
	                    var result = rec.dispose && rec.dispose.call(rec.value);
	                    if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
	                }
	                catch (e) {
	                    fail(e);
	                }
	            }
	            if (env.hasError) throw env.error;
	        }
	        return next();
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__esDecorate", __esDecorate);
	    exporter("__runInitializers", __runInitializers);
	    exporter("__propKey", __propKey);
	    exporter("__setFunctionName", __setFunctionName);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__spreadArray", __spreadArray);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	    exporter("__classPrivateFieldIn", __classPrivateFieldIn);
	    exporter("__addDisposableResource", __addDisposableResource);
	    exporter("__disposeResources", __disposeResources);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(5), __webpack_require__(1), __webpack_require__(31)) :
		typeof define === 'function' && define.amd ? define(['exports', 'mobx', 'react', 'react-dom'], factory) :
		(factory((global.mobxReact = {}),global.mobx,global.React,global.ReactDOM));
	}(this, (function (exports,mobx,React,reactDom) { 'use strict';
	
	var React__default = 'default' in React ? React['default'] : React;
	
	// These functions can be stubbed out in specific environments
	var unstable_batchedUpdates$1 = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	var asyncGenerator = function () {
	  function AwaitValue(value) {
	    this.value = value;
	  }
	
	  function AsyncGenerator(gen) {
	    var front, back;
	
	    function send(key, arg) {
	      return new Promise(function (resolve, reject) {
	        var request = {
	          key: key,
	          arg: arg,
	          resolve: resolve,
	          reject: reject,
	          next: null
	        };
	
	        if (back) {
	          back = back.next = request;
	        } else {
	          front = back = request;
	          resume(key, arg);
	        }
	      });
	    }
	
	    function resume(key, arg) {
	      try {
	        var result = gen[key](arg);
	        var value = result.value;
	
	        if (value instanceof AwaitValue) {
	          Promise.resolve(value.value).then(function (arg) {
	            resume("next", arg);
	          }, function (arg) {
	            resume("throw", arg);
	          });
	        } else {
	          settle(result.done ? "return" : "normal", result.value);
	        }
	      } catch (err) {
	        settle("throw", err);
	      }
	    }
	
	    function settle(type, value) {
	      switch (type) {
	        case "return":
	          front.resolve({
	            value: value,
	            done: true
	          });
	          break;
	
	        case "throw":
	          front.reject(value);
	          break;
	
	        default:
	          front.resolve({
	            value: value,
	            done: false
	          });
	          break;
	      }
	
	      front = front.next;
	
	      if (front) {
	        resume(front.key, front.arg);
	      } else {
	        back = null;
	      }
	    }
	
	    this._invoke = send;
	
	    if (typeof gen.return !== "function") {
	      this.return = undefined;
	    }
	  }
	
	  if (typeof Symbol === "function" && Symbol.asyncIterator) {
	    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
	      return this;
	    };
	  }
	
	  AsyncGenerator.prototype.next = function (arg) {
	    return this._invoke("next", arg);
	  };
	
	  AsyncGenerator.prototype.throw = function (arg) {
	    return this._invoke("throw", arg);
	  };
	
	  AsyncGenerator.prototype.return = function (arg) {
	    return this._invoke("return", arg);
	  };
	
	  return {
	    wrap: function (fn) {
	      return function () {
	        return new AsyncGenerator(fn.apply(this, arguments));
	      };
	    },
	    await: function (value) {
	      return new AwaitValue(value);
	    }
	  };
	}();
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var EventEmitter = function () {
	    function EventEmitter() {
	        classCallCheck(this, EventEmitter);
	        this.listeners = [];
	    }
	
	    createClass(EventEmitter, [{
	        key: "on",
	        value: function on(cb) {
	            var _this = this;
	
	            this.listeners.push(cb);
	            return function () {
	                var index = _this.listeners.indexOf(cb);
	                if (index !== -1) _this.listeners.splice(index, 1);
	            };
	        }
	    }, {
	        key: "emit",
	        value: function emit(data) {
	            this.listeners.forEach(function (fn) {
	                return fn(data);
	            });
	        }
	    }]);
	    return EventEmitter;
	}();
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty$1 = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	var hoistNonReactStatics = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty$1(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};
	
	// Copied from React.PropTypes
	function createChainableTypeChecker(validate) {
	    function checkType(isRequired, props, propName, componentName, location, propFullName) {
	        for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	            rest[_key - 6] = arguments[_key];
	        }
	
	        return mobx.untracked(function () {
	            componentName = componentName || "<<anonymous>>";
	            propFullName = propFullName || propName;
	            if (props[propName] == null) {
	                if (isRequired) {
	                    var actual = props[propName] === null ? "null" : "undefined";
	                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
	                }
	                return null;
	            } else {
	                return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
	            }
	        });
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	    return chainedCheckType;
	}
	
	// Copied from React.PropTypes
	function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === "symbol") {
	        return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue["@@toStringTag"] === "Symbol") {
	        return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === "function" && propValue instanceof Symbol) {
	        return true;
	    }
	
	    return false;
	}
	
	// Copied from React.PropTypes
	function getPropType(propValue) {
	    var propType = typeof propValue === "undefined" ? "undefined" : _typeof(propValue);
	    if (Array.isArray(propValue)) {
	        return "array";
	    }
	    if (propValue instanceof RegExp) {
	        // Old webkits (at least until Android 4.0) return 'function' rather than
	        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	        // passes PropTypes.object.
	        return "object";
	    }
	    if (isSymbol(propType, propValue)) {
	        return "symbol";
	    }
	    return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// Copied from React.PropTypes
	function getPreciseType(propValue) {
	    var propType = getPropType(propValue);
	    if (propType === "object") {
	        if (propValue instanceof Date) {
	            return "date";
	        } else if (propValue instanceof RegExp) {
	            return "regexp";
	        }
	    }
	    return propType;
	}
	
	function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
	    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
	        return mobx.untracked(function () {
	            if (allowNativeType) {
	                if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
	            }
	            var mobxChecker = void 0;
	            switch (mobxType) {
	                case "Array":
	                    mobxChecker = mobx.isObservableArray;
	                    break;
	                case "Object":
	                    mobxChecker = mobx.isObservableObject;
	                    break;
	                case "Map":
	                    mobxChecker = mobx.isObservableMap;
	                    break;
	                default:
	                    throw new Error("Unexpected mobxType: " + mobxType);
	            }
	            var propValue = props[propName];
	            if (!mobxChecker(propValue)) {
	                var preciseType = getPreciseType(propValue);
	                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
	                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
	            }
	            return null;
	        });
	    });
	}
	
	function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
	    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
	        for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	            rest[_key2 - 5] = arguments[_key2];
	        }
	
	        return mobx.untracked(function () {
	            if (typeof typeChecker !== "function") {
	                return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
	            }
	            var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
	            if (error instanceof Error) return error;
	            var propValue = props[propName];
	            for (var i = 0; i < propValue.length; i++) {
	                error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
	                if (error instanceof Error) return error;
	            }
	            return null;
	        });
	    });
	}
	
	var observableArray = createObservableTypeCheckerCreator(false, "Array");
	var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
	var observableMap = createObservableTypeCheckerCreator(false, "Map");
	var observableObject = createObservableTypeCheckerCreator(false, "Object");
	var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
	var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
	var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");
	
	
	
	var propTypes = Object.freeze({
		observableArray: observableArray,
		observableArrayOf: observableArrayOf,
		observableMap: observableMap,
		observableObject: observableObject,
		arrayOrObservableArray: arrayOrObservableArray,
		arrayOrObservableArrayOf: arrayOrObservableArrayOf,
		objectOrObservableObject: objectOrObservableObject
	});
	
	function isStateless(component) {
	    // `function() {}` has prototype, but `() => {}` doesn't
	    // `() => {}` via Babel has prototype too.
	    return !(component.prototype && component.prototype.render);
	}
	
	var injectorContextTypes = {
	    mobxStores: objectOrObservableObject
	};
	Object.seal(injectorContextTypes);
	
	var proxiedInjectorProps = {
	    contextTypes: {
	        get: function get$$1() {
	            return injectorContextTypes;
	        },
	        set: function set$$1(_) {
	            console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
	        },
	        configurable: true,
	        enumerable: false
	    },
	    isMobxInjector: {
	        value: true,
	        writable: true,
	        configurable: true,
	        enumerable: true
	    }
	
	    /**
	     * Store Injection
	     */
	};function createStoreInjector(grabStoresFn, component, injectNames) {
	    var _class, _temp2;
	
	    var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
	    if (injectNames) displayName += "-with-" + injectNames;
	
	    var Injector = (_temp2 = _class = function (_Component) {
	        inherits(Injector, _Component);
	
	        function Injector() {
	            var _ref;
	
	            var _temp, _this, _ret;
	
	            classCallCheck(this, Injector);
	
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
	                _this.wrappedInstance = instance;
	            }, _temp), possibleConstructorReturn(_this, _ret);
	        }
	
	        createClass(Injector, [{
	            key: "render",
	            value: function render() {
	                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
	                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
	                // See this test: 'using a custom injector is not too reactive' in inject.js
	                var newProps = {};
	                for (var key in this.props) {
	                    if (this.props.hasOwnProperty(key)) {
	                        newProps[key] = this.props[key];
	                    }
	                }var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
	                for (var _key2 in additionalProps) {
	                    newProps[_key2] = additionalProps[_key2];
	                }
	
	                if (!isStateless(component)) {
	                    newProps.ref = this.storeRef;
	                }
	
	                return React.createElement(component, newProps);
	            }
	        }]);
	        return Injector;
	    }(React.Component), _class.displayName = displayName, _temp2);
	
	    // Static fields from component should be visible on the generated Injector
	
	    hoistNonReactStatics(Injector, component);
	
	    Injector.wrappedComponent = component;
	    Object.defineProperties(Injector, proxiedInjectorProps);
	
	    return Injector;
	}
	
	function grabStoresByName(storeNames) {
	    return function (baseStores, nextProps) {
	        storeNames.forEach(function (storeName) {
	            if (storeName in nextProps // prefer props over stores
	            ) return;
	            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
	            nextProps[storeName] = baseStores[storeName];
	        });
	        return nextProps;
	    };
	}
	
	/**
	 * higher order component that injects stores to a child.
	 * takes either a varargs list of strings, which are stores read from the context,
	 * or a function that manually maps the available stores from the context to props:
	 * storesToProps(mobxStores, props, context) => newProps
	 */
	function inject() /* fn(stores, nextProps) or ...storeNames */{
	    var grabStoresFn = void 0;
	    if (typeof arguments[0] === "function") {
	        grabStoresFn = arguments[0];
	        return function (componentClass) {
	            var injected = createStoreInjector(grabStoresFn, componentClass);
	            injected.isMobxInjector = false; // supress warning
	            // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
	            // see #111
	            injected = observer(injected);
	            injected.isMobxInjector = true; // restore warning
	            return injected;
	        };
	    } else {
	        var storeNames = [];
	        for (var i = 0; i < arguments.length; i++) {
	            storeNames[i] = arguments[i];
	        }grabStoresFn = grabStoresByName(storeNames);
	        return function (componentClass) {
	            return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
	        };
	    }
	}
	
	/**
	 * dev tool support
	 */
	var isDevtoolsEnabled = false;
	
	var isUsingStaticRendering = false;
	
	var warnedAboutObserverInjectDeprecation = false;
	
	// WeakMap<Node, Object>;
	var componentByNodeRegistery = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
	var renderReporter = new EventEmitter();
	
	function findDOMNode$2(component) {
	    if (reactDom.findDOMNode) {
	        try {
	            return reactDom.findDOMNode(component);
	        } catch (e) {
	            // findDOMNode will throw in react-test-renderer, see:
	            // See https://github.com/mobxjs/mobx-react/issues/216
	            // Is there a better heuristic?
	            return null;
	        }
	    }
	    return null;
	}
	
	function reportRendering(component) {
	    var node = findDOMNode$2(component);
	    if (node && componentByNodeRegistery) componentByNodeRegistery.set(node, component);
	
	    renderReporter.emit({
	        event: "render",
	        renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
	        totalTime: Date.now() - component.__$mobRenderStart,
	        component: component,
	        node: node
	    });
	}
	
	function trackComponents() {
	    if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
	    if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
	}
	
	function useStaticRendering(useStaticRendering) {
	    isUsingStaticRendering = useStaticRendering;
	}
	
	/**
	 * Errors reporter
	 */
	
	var errorsReporter = new EventEmitter();
	
	/**
	 * Utilities
	 */
	
	function patch(target, funcName) {
	    var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var base = target[funcName];
	    var mixinFunc = reactiveMixin[funcName];
	    var f = !base ? mixinFunc : runMixinFirst === true ? function () {
	        mixinFunc.apply(this, arguments);
	        base.apply(this, arguments);
	    } : function () {
	        base.apply(this, arguments);
	        mixinFunc.apply(this, arguments);
	    };
	
	    // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
	    // ...but that breaks react-hot-loader, see #231...
	    target[funcName] = f;
	}
	
	function shallowEqual(objA, objB) {
	    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
	    if (is(objA, objB)) return true;
	    if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || objB === null) {
	        return false;
	    }
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	    if (keysA.length !== keysB.length) return false;
	    for (var i = 0; i < keysA.length; i++) {
	        if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function is(x, y) {
	    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
	    if (x === y) {
	        return x !== 0 || 1 / x === 1 / y;
	    } else {
	        return x !== x && y !== y;
	    }
	}
	
	/**
	 * ReactiveMixin
	 */
	var reactiveMixin = {
	    componentWillMount: function componentWillMount() {
	        var _this = this;
	
	        if (isUsingStaticRendering === true) return;
	        // Generate friendly name for debugging
	        var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
	        var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalFiber && this._reactInternalFiber._debugID;
	
	        /**
	         * If props are shallowly modified, react will render anyway,
	         * so atom.reportChanged() should not result in yet another re-render
	         */
	        var skipRender = false;
	        /**
	         * forceUpdate will re-assign this.props. We don't want that to cause a loop,
	         * so detect these changes
	         */
	        var isForcingUpdate = false;
	
	        function makePropertyObservableReference(propName) {
	            var valueHolder = this[propName];
	            var atom = new mobx.Atom("reactive " + propName);
	            Object.defineProperty(this, propName, {
	                configurable: true,
	                enumerable: true,
	                get: function get$$1() {
	                    atom.reportObserved();
	                    return valueHolder;
	                },
	                set: function set$$1(v) {
	                    if (!isForcingUpdate && !shallowEqual(valueHolder, v)) {
	                        valueHolder = v;
	                        skipRender = true;
	                        atom.reportChanged();
	                        skipRender = false;
	                    } else {
	                        valueHolder = v;
	                    }
	                }
	            });
	        }
	
	        // make this.props an observable reference, see #124
	        makePropertyObservableReference.call(this, "props");
	        // make state an observable reference
	        makePropertyObservableReference.call(this, "state");
	
	        // wire up reactive render
	        var baseRender = this.render.bind(this);
	        var reaction = null;
	        var isRenderingPending = false;
	
	        var initialRender = function initialRender() {
	            reaction = new mobx.Reaction(initialName + "#" + rootNodeID + ".render()", function () {
	                if (!isRenderingPending) {
	                    // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
	                    // This unidiomatic React usage but React will correctly warn about this so we continue as usual
	                    // See #85 / Pull #44
	                    isRenderingPending = true;
	                    if (typeof _this.componentWillReact === "function") _this.componentWillReact(); // TODO: wrap in action?
	                    if (_this.__$mobxIsUnmounted !== true) {
	                        // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
	                        // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
	                        // However, people also claim this migth happen during unit tests..
	                        var hasError = true;
	                        try {
	                            isForcingUpdate = true;
	                            if (!skipRender) React.Component.prototype.forceUpdate.call(_this);
	                            hasError = false;
	                        } finally {
	                            isForcingUpdate = false;
	                            if (hasError) reaction.dispose();
	                        }
	                    }
	                }
	            });
	            reaction.reactComponent = _this;
	            reactiveRender.$mobx = reaction;
	            _this.render = reactiveRender;
	            return reactiveRender();
	        };
	
	        var reactiveRender = function reactiveRender() {
	            isRenderingPending = false;
	            var exception = undefined;
	            var rendering = undefined;
	            reaction.track(function () {
	                if (isDevtoolsEnabled) {
	                    _this.__$mobRenderStart = Date.now();
	                }
	                try {
	                    rendering = mobx.extras.allowStateChanges(false, baseRender);
	                } catch (e) {
	                    exception = e;
	                }
	                if (isDevtoolsEnabled) {
	                    _this.__$mobRenderEnd = Date.now();
	                }
	            });
	            if (exception) {
	                errorsReporter.emit(exception);
	                throw exception;
	            }
	            return rendering;
	        };
	
	        this.render = initialRender;
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        if (isUsingStaticRendering === true) return;
	        this.render.$mobx && this.render.$mobx.dispose();
	        this.__$mobxIsUnmounted = true;
	        if (isDevtoolsEnabled) {
	            var node = findDOMNode$2(this);
	            if (node && componentByNodeRegistery) {
	                componentByNodeRegistery.delete(node);
	            }
	            renderReporter.emit({
	                event: "destroy",
	                component: this,
	                node: node
	            });
	        }
	    },
	
	    componentDidMount: function componentDidMount() {
	        if (isDevtoolsEnabled) {
	            reportRendering(this);
	        }
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        if (isDevtoolsEnabled) {
	            reportRendering(this);
	        }
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        if (isUsingStaticRendering) {
	            console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
	        }
	        // update on any state changes (as is the default)
	        if (this.state !== nextState) {
	            return true;
	        }
	        // update if props are shallowly not equal, inspired by PureRenderMixin
	        // we could return just 'false' here, and avoid the `skipRender` checks etc
	        // however, it is nicer if lifecycle events are triggered like usually,
	        // so we return true here if props are shallowly modified.
	        return !shallowEqual(this.props, nextProps);
	    }
	
	    /**
	     * Observer function / decorator
	     */
	};function observer(arg1, arg2) {
	    if (typeof arg1 === "string") {
	        throw new Error("Store names should be provided as array");
	    }
	    if (Array.isArray(arg1)) {
	        // component needs stores
	        if (!warnedAboutObserverInjectDeprecation) {
	            warnedAboutObserverInjectDeprecation = true;
	            console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
	        }
	        if (!arg2) {
	            // invoked as decorator
	            return function (componentClass) {
	                return observer(arg1, componentClass);
	            };
	        } else {
	            return inject.apply(null, arg1)(observer(arg2));
	        }
	    }
	    var componentClass = arg1;
	
	    if (componentClass.isMobxInjector === true) {
	        console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
	    }
	
	    // Stateless function component:
	    // If it is function but doesn't seem to be a react class constructor,
	    // wrap it to a react class automatically
	    if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !React.Component.isPrototypeOf(componentClass)) {
	        var _class, _temp;
	
	        return observer((_temp = _class = function (_Component) {
	            inherits(_class, _Component);
	
	            function _class() {
	                classCallCheck(this, _class);
	                return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	            }
	
	            createClass(_class, [{
	                key: "render",
	                value: function render() {
	                    return componentClass.call(this, this.props, this.context);
	                }
	            }]);
	            return _class;
	        }(React.Component), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
	    }
	
	    if (!componentClass) {
	        throw new Error("Please pass a valid component to 'observer'");
	    }
	
	    var target = componentClass.prototype || componentClass;
	    mixinLifecycleEvents(target);
	    componentClass.isMobXReactObserver = true;
	    return componentClass;
	}
	
	function mixinLifecycleEvents(target) {
	    patch(target, "componentWillMount", true);["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
	        patch(target, funcName);
	    });
	    if (!target.shouldComponentUpdate) {
	        target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
	    }
	}
	
	// TODO: support injection somehow as well?
	var Observer = observer(function (_ref) {
	    var children = _ref.children,
	        observerInject = _ref.inject,
	        render = _ref.render;
	
	    var component = children || render;
	    if (typeof component === "undefined") {
	        return null;
	    }
	    if (!observerInject) {
	        return component();
	    }
	    var InjectComponent = inject(observerInject)(component);
	    return React__default.createElement(InjectComponent, null);
	});
	
	Observer.displayName = "Observer";
	
	var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
	    var extraKey = key === "children" ? "render" : "children";
	    if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
	        return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
	    }
	
	    if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
	        return;
	    }
	    return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
	};
	
	Observer.propTypes = {
	    render: ObserverPropsCheck,
	    children: ObserverPropsCheck
	};
	
	var _class;
	var _temp;
	
	var specialReactKeys = { children: true, key: true, ref: true };
	
	var Provider = (_temp = _class = function (_Component) {
	    inherits(Provider, _Component);
	
	    function Provider() {
	        classCallCheck(this, Provider);
	        return possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
	    }
	
	    createClass(Provider, [{
	        key: "render",
	        value: function render() {
	            return React.Children.only(this.props.children);
	        }
	    }, {
	        key: "getChildContext",
	        value: function getChildContext() {
	            var stores = {};
	            // inherit stores
	            var baseStores = this.context.mobxStores;
	            if (baseStores) for (var key in baseStores) {
	                stores[key] = baseStores[key];
	            }
	            // add own stores
	            for (var _key in this.props) {
	                if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning") stores[_key] = this.props[_key];
	            }return {
	                mobxStores: stores
	            };
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            // Maybe this warning is too aggressive?
	            if (Object.keys(nextProps).length !== Object.keys(this.props).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
	            if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
	                if (!specialReactKeys[key] && this.props[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
	            }
	        }
	    }]);
	    return Provider;
	}(React.Component), _class.contextTypes = {
	    mobxStores: objectOrObservableObject
	}, _class.childContextTypes = {
	    mobxStores: objectOrObservableObject.isRequired
	}, _temp);
	
	if (!React.Component) throw new Error("mobx-react requires React to be available");
	if (!mobx.extras) throw new Error("mobx-react requires mobx to be available");
	
	if (typeof reactDom.unstable_batchedUpdates === "function") mobx.extras.setReactionScheduler(reactDom.unstable_batchedUpdates);else if (typeof unstable_batchedUpdates$1 === "function") mobx.extras.setReactionScheduler(unstable_batchedUpdates$1);
	
	var onError = function onError(fn) {
	    return errorsReporter.on(fn);
	};
	
	/* DevTool support */
	// See: https://github.com/andykog/mobx-devtools/blob/d8976c24b8cb727ed59f9a0bc905a009df79e221/src/backend/installGlobalHook.js
	
	if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
	    var mobx$1 = { spy: mobx.spy, extras: mobx.extras };
	    var mobxReact = { renderReporter: renderReporter, componentByNodeRegistery: componentByNodeRegistery, trackComponents: trackComponents };
	    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx$1);
	}
	
	exports.propTypes = propTypes;
	exports.PropTypes = propTypes;
	exports.onError = onError;
	exports.observer = observer;
	exports.Observer = Observer;
	exports.renderReporter = renderReporter;
	exports.componentByNodeRegistery = componentByNodeRegistery;
	exports.trackComponents = trackComponents;
	exports.useStaticRendering = useStaticRendering;
	exports.Provider = Provider;
	exports.inject = inject;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** MobX - (c) Michel Weststrate 2015, 2016 - MIT Licensed */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	/**
	 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
	 *
	 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
	 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
	 */
	var BaseAtom = /** @class */ (function () {
	    /**
	     * Create a new atom. For debugging purposes it is recommended to give it a name.
	     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
	     */
	    function BaseAtom(name) {
	        if (name === void 0) { name = "Atom@" + getNextId(); }
	        this.name = name;
	        this.isPendingUnobservation = true; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
	        this.observers = [];
	        this.observersIndexes = {};
	        this.diffValue = 0;
	        this.lastAccessedBy = 0;
	        this.lowestObserverState = exports.IDerivationState.NOT_TRACKING;
	    }
	    BaseAtom.prototype.onBecomeUnobserved = function () {
	        // noop
	    };
	    /**
	     * Invoke this method to notify mobx that your atom has been used somehow.
	     */
	    BaseAtom.prototype.reportObserved = function () {
	        reportObserved(this);
	    };
	    /**
	     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
	     */
	    BaseAtom.prototype.reportChanged = function () {
	        startBatch();
	        propagateChanged(this);
	        endBatch();
	    };
	    BaseAtom.prototype.toString = function () {
	        return this.name;
	    };
	    return BaseAtom;
	}());
	var Atom = /** @class */ (function (_super) {
	    __extends(Atom, _super);
	    /**
	     * Create a new atom. For debugging purposes it is recommended to give it a name.
	     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
	     */
	    function Atom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
	        if (name === void 0) { name = "Atom@" + getNextId(); }
	        if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
	        if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
	        var _this = _super.call(this, name) || this;
	        _this.name = name;
	        _this.onBecomeObservedHandler = onBecomeObservedHandler;
	        _this.onBecomeUnobservedHandler = onBecomeUnobservedHandler;
	        _this.isPendingUnobservation = false; // for effective unobserving.
	        _this.isBeingTracked = false;
	        return _this;
	    }
	    Atom.prototype.reportObserved = function () {
	        startBatch();
	        _super.prototype.reportObserved.call(this);
	        if (!this.isBeingTracked) {
	            this.isBeingTracked = true;
	            this.onBecomeObservedHandler();
	        }
	        endBatch();
	        return !!globalState.trackingDerivation;
	        // return doesn't really give useful info, because it can be as well calling computed which calls atom (no reactions)
	        // also it could not trigger when calculating reaction dependent on Atom because Atom's value was cached by computed called by given reaction.
	    };
	    Atom.prototype.onBecomeUnobserved = function () {
	        this.isBeingTracked = false;
	        this.onBecomeUnobservedHandler();
	    };
	    return Atom;
	}(BaseAtom));
	var isAtom = createInstanceofPredicate("Atom", BaseAtom);
	
	function hasInterceptors(interceptable) {
	    return interceptable.interceptors && interceptable.interceptors.length > 0;
	}
	function registerInterceptor(interceptable, handler) {
	    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
	    interceptors.push(handler);
	    return once(function () {
	        var idx = interceptors.indexOf(handler);
	        if (idx !== -1)
	            interceptors.splice(idx, 1);
	    });
	}
	function interceptChange(interceptable, change) {
	    var prevU = untrackedStart();
	    try {
	        var interceptors = interceptable.interceptors;
	        if (interceptors)
	            for (var i = 0, l = interceptors.length; i < l; i++) {
	                change = interceptors[i](change);
	                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
	                if (!change)
	                    break;
	            }
	        return change;
	    }
	    finally {
	        untrackedEnd(prevU);
	    }
	}
	
	function hasListeners(listenable) {
	    return listenable.changeListeners && listenable.changeListeners.length > 0;
	}
	function registerListener(listenable, handler) {
	    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
	    listeners.push(handler);
	    return once(function () {
	        var idx = listeners.indexOf(handler);
	        if (idx !== -1)
	            listeners.splice(idx, 1);
	    });
	}
	function notifyListeners(listenable, change) {
	    var prevU = untrackedStart();
	    var listeners = listenable.changeListeners;
	    if (!listeners)
	        return;
	    listeners = listeners.slice();
	    for (var i = 0, l = listeners.length; i < l; i++) {
	        listeners[i](change);
	    }
	    untrackedEnd(prevU);
	}
	
	function isSpyEnabled() {
	    return !!globalState.spyListeners.length;
	}
	function spyReport(event) {
	    if (!globalState.spyListeners.length)
	        return;
	    var listeners = globalState.spyListeners;
	    for (var i = 0, l = listeners.length; i < l; i++)
	        listeners[i](event);
	}
	function spyReportStart(event) {
	    var change = objectAssign({}, event, { spyReportStart: true });
	    spyReport(change);
	}
	var END_EVENT = { spyReportEnd: true };
	function spyReportEnd(change) {
	    if (change)
	        spyReport(objectAssign({}, change, END_EVENT));
	    else
	        spyReport(END_EVENT);
	}
	function spy(listener) {
	    globalState.spyListeners.push(listener);
	    return once(function () {
	        var idx = globalState.spyListeners.indexOf(listener);
	        if (idx !== -1)
	            globalState.spyListeners.splice(idx, 1);
	    });
	}
	
	function iteratorSymbol() {
	    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
	}
	var IS_ITERATING_MARKER = "__$$iterating";
	function arrayAsIterator(array) {
	    // returning an array for entries(), values() etc for maps was a mis-interpretation of the specs..,
	    // yet it is quite convenient to be able to use the response both as array directly and as iterator
	    // it is suboptimal, but alas...
	    invariant(array[IS_ITERATING_MARKER] !== true, "Illegal state: cannot recycle array as iterator");
	    addHiddenFinalProp(array, IS_ITERATING_MARKER, true);
	    var idx = -1;
	    addHiddenFinalProp(array, "next", function next() {
	        idx++;
	        return {
	            done: idx >= this.length,
	            value: idx < this.length ? this[idx] : undefined
	        };
	    });
	    return array;
	}
	function declareIterator(prototType, iteratorFactory) {
	    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
	}
	
	var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
	// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
	var safariPrototypeSetterInheritanceBug = (function () {
	    var v = false;
	    var p = {};
	    Object.defineProperty(p, "0", {
	        set: function () {
	            v = true;
	        }
	    });
	    Object.create(p)["0"] = 1;
	    return v === false;
	})();
	/**
	 * This array buffer contains two lists of properties, so that all arrays
	 * can recycle their property definitions, which significantly improves performance of creating
	 * properties on the fly.
	 */
	var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
	// Typescript workaround to make sure ObservableArray extends Array
	var StubArray = /** @class */ (function () {
	    function StubArray() {
	    }
	    return StubArray;
	}());
	function inherit(ctor, proto) {
	    if (typeof Object["setPrototypeOf"] !== "undefined") {
	        Object["setPrototypeOf"](ctor.prototype, proto);
	    }
	    else if (typeof ctor.prototype.__proto__ !== "undefined") {
	        ctor.prototype.__proto__ = proto;
	    }
	    else {
	        ctor["prototype"] = proto;
	    }
	}
	inherit(StubArray, Array.prototype);
	// Weex freeze Array.prototype
	// Make them writeable and configurable in prototype chain
	// https://github.com/alibaba/weex/pull/1529
	if (Object.isFrozen(Array)) {
	    
	    [
	        "constructor",
	        "push",
	        "shift",
	        "concat",
	        "pop",
	        "unshift",
	        "replace",
	        "find",
	        "findIndex",
	        "splice",
	        "reverse",
	        "sort"
	    ].forEach(function (key) {
	        Object.defineProperty(StubArray.prototype, key, {
	            configurable: true,
	            writable: true,
	            value: Array.prototype[key]
	        });
	    });
	}
	var ObservableArrayAdministration = /** @class */ (function () {
	    function ObservableArrayAdministration(name, enhancer, array, owned) {
	        this.array = array;
	        this.owned = owned;
	        this.values = [];
	        this.lastKnownLength = 0;
	        this.interceptors = null;
	        this.changeListeners = null;
	        this.atom = new BaseAtom(name || "ObservableArray@" + getNextId());
	        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
	    }
	    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined)
	            return this.dehancer(value);
	        return value;
	    };
	    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
	        if (this.dehancer !== undefined)
	            return values.map(this.dehancer);
	        return values;
	    };
	    ObservableArrayAdministration.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately === void 0) { fireImmediately = false; }
	        if (fireImmediately) {
	            listener({
	                object: this.array,
	                type: "splice",
	                index: 0,
	                added: this.values.slice(),
	                addedCount: this.values.length,
	                removed: [],
	                removedCount: 0
	            });
	        }
	        return registerListener(this, listener);
	    };
	    ObservableArrayAdministration.prototype.getArrayLength = function () {
	        this.atom.reportObserved();
	        return this.values.length;
	    };
	    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
	        if (typeof newLength !== "number" || newLength < 0)
	            throw new Error("[mobx.array] Out of range: " + newLength);
	        var currentLength = this.values.length;
	        if (newLength === currentLength)
	            return;
	        else if (newLength > currentLength) {
	            var newItems = new Array(newLength - currentLength);
	            for (var i = 0; i < newLength - currentLength; i++)
	                newItems[i] = undefined; // No Array.fill everywhere...
	            this.spliceWithArray(currentLength, 0, newItems);
	        }
	        else
	            this.spliceWithArray(newLength, currentLength - newLength);
	    };
	    // adds / removes the necessary numeric properties to this object
	    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
	        if (oldLength !== this.lastKnownLength)
	            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
	        this.lastKnownLength += delta;
	        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
	            reserveArrayBuffer(oldLength + delta + 1);
	    };
	    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
	        var _this = this;
	        checkIfStateModificationsAreAllowed(this.atom);
	        var length = this.values.length;
	        if (index === undefined)
	            index = 0;
	        else if (index > length)
	            index = length;
	        else if (index < 0)
	            index = Math.max(0, length + index);
	        if (arguments.length === 1)
	            deleteCount = length - index;
	        else if (deleteCount === undefined || deleteCount === null)
	            deleteCount = 0;
	        else
	            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
	        if (newItems === undefined)
	            newItems = [];
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: this.array,
	                type: "splice",
	                index: index,
	                removedCount: deleteCount,
	                added: newItems
	            });
	            if (!change)
	                return EMPTY_ARRAY;
	            deleteCount = change.removedCount;
	            newItems = change.added;
	        }
	        newItems = newItems.map(function (v) { return _this.enhancer(v, undefined); });
	        var lengthDelta = newItems.length - deleteCount;
	        this.updateArrayLength(length, lengthDelta); // create or remove new entries
	        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
	        if (deleteCount !== 0 || newItems.length !== 0)
	            this.notifyArraySplice(index, newItems, res);
	        return this.dehanceValues(res);
	    };
	    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
	        if (newItems.length < MAX_SPLICE_SIZE) {
	            return (_a = this.values).splice.apply(_a, [index, deleteCount].concat(newItems));
	        }
	        else {
	            var res = this.values.slice(index, index + deleteCount);
	            this.values = this.values
	                .slice(0, index)
	                .concat(newItems, this.values.slice(index + deleteCount));
	            return res;
	        }
	        var _a;
	    };
	    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
	        var notifySpy = !this.owned && isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                object: this.array,
	                type: "update",
	                index: index,
	                newValue: newValue,
	                oldValue: oldValue
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(change);
	        this.atom.reportChanged();
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy)
	            spyReportEnd();
	    };
	    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
	        var notifySpy = !this.owned && isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                object: this.array,
	                type: "splice",
	                index: index,
	                removed: removed,
	                added: added,
	                removedCount: removed.length,
	                addedCount: added.length
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(change);
	        this.atom.reportChanged();
	        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy)
	            spyReportEnd();
	    };
	    return ObservableArrayAdministration;
	}());
	var ObservableArray = /** @class */ (function (_super) {
	    __extends(ObservableArray, _super);
	    function ObservableArray(initialValues, enhancer, name, owned) {
	        if (name === void 0) { name = "ObservableArray@" + getNextId(); }
	        if (owned === void 0) { owned = false; }
	        var _this = _super.call(this) || this;
	        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
	        addHiddenFinalProp(_this, "$mobx", adm);
	        if (initialValues && initialValues.length) {
	            _this.spliceWithArray(0, 0, initialValues);
	        }
	        if (safariPrototypeSetterInheritanceBug) {
	            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
	            // defined on the instance. After that it works fine, even if this property is deleted.
	            Object.defineProperty(adm.array, "0", ENTRY_0);
	        }
	        return _this;
	    }
	    ObservableArray.prototype.intercept = function (handler) {
	        return this.$mobx.intercept(handler);
	    };
	    ObservableArray.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately === void 0) { fireImmediately = false; }
	        return this.$mobx.observe(listener, fireImmediately);
	    };
	    ObservableArray.prototype.clear = function () {
	        return this.splice(0);
	    };
	    ObservableArray.prototype.concat = function () {
	        var arrays = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            arrays[_i] = arguments[_i];
	        }
	        this.$mobx.atom.reportObserved();
	        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return (isObservableArray(a) ? a.peek() : a); }));
	    };
	    ObservableArray.prototype.replace = function (newItems) {
	        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
	    };
	    /**
	     * Converts this array back to a (shallow) javascript structure.
	     * For a deep clone use mobx.toJS
	     */
	    ObservableArray.prototype.toJS = function () {
	        return this.slice();
	    };
	    ObservableArray.prototype.toJSON = function () {
	        // Used by JSON.stringify
	        return this.toJS();
	    };
	    ObservableArray.prototype.peek = function () {
	        this.$mobx.atom.reportObserved();
	        return this.$mobx.dehanceValues(this.$mobx.values);
	    };
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
	    ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
	        if (fromIndex === void 0) { fromIndex = 0; }
	        var idx = this.findIndex.apply(this, arguments);
	        return idx === -1 ? undefined : this.get(idx);
	    };
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
	    ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
	        if (fromIndex === void 0) { fromIndex = 0; }
	        var items = this.peek(), l = items.length;
	        for (var i = fromIndex; i < l; i++)
	            if (predicate.call(thisArg, items[i], i, this))
	                return i;
	        return -1;
	    };
	    /*
	     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
	     * since these functions alter the inner structure of the array, the have side effects.
	     * Because the have side effects, they should not be used in computed function,
	     * and for that reason the do not call dependencyState.notifyObserved
	     */
	    ObservableArray.prototype.splice = function (index, deleteCount) {
	        var newItems = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            newItems[_i - 2] = arguments[_i];
	        }
	        switch (arguments.length) {
	            case 0:
	                return [];
	            case 1:
	                return this.$mobx.spliceWithArray(index);
	            case 2:
	                return this.$mobx.spliceWithArray(index, deleteCount);
	        }
	        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
	    };
	    ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
	        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
	    };
	    ObservableArray.prototype.push = function () {
	        var items = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            items[_i] = arguments[_i];
	        }
	        var adm = this.$mobx;
	        adm.spliceWithArray(adm.values.length, 0, items);
	        return adm.values.length;
	    };
	    ObservableArray.prototype.pop = function () {
	        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
	    };
	    ObservableArray.prototype.shift = function () {
	        return this.splice(0, 1)[0];
	    };
	    ObservableArray.prototype.unshift = function () {
	        var items = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            items[_i] = arguments[_i];
	        }
	        var adm = this.$mobx;
	        adm.spliceWithArray(0, 0, items);
	        return adm.values.length;
	    };
	    ObservableArray.prototype.reverse = function () {
	        // reverse by default mutates in place before returning the result
	        // which makes it both a 'derivation' and a 'mutation'.
	        // so we deviate from the default and just make it an dervitation
	        var clone = this.slice();
	        return clone.reverse.apply(clone, arguments);
	    };
	    ObservableArray.prototype.sort = function (compareFn) {
	        // sort by default mutates in place before returning the result
	        // which goes against all good practices. Let's not change the array in place!
	        var clone = this.slice();
	        return clone.sort.apply(clone, arguments);
	    };
	    ObservableArray.prototype.remove = function (value) {
	        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
	        if (idx > -1) {
	            this.splice(idx, 1);
	            return true;
	        }
	        return false;
	    };
	    ObservableArray.prototype.move = function (fromIndex, toIndex) {
	        function checkIndex(index) {
	            if (index < 0) {
	                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
	            }
	            var length = this.$mobx.values.length;
	            if (index >= length) {
	                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
	            }
	        }
	        checkIndex.call(this, fromIndex);
	        checkIndex.call(this, toIndex);
	        if (fromIndex === toIndex) {
	            return;
	        }
	        var oldItems = this.$mobx.values;
	        var newItems;
	        if (fromIndex < toIndex) {
	            newItems = oldItems.slice(0, fromIndex).concat(oldItems.slice(fromIndex + 1, toIndex + 1), [
	                oldItems[fromIndex]
	            ], oldItems.slice(toIndex + 1));
	        }
	        else {
	            // toIndex < fromIndex
	            newItems = oldItems.slice(0, toIndex).concat([
	                oldItems[fromIndex]
	            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
	        }
	        this.replace(newItems);
	    };
	    // See #734, in case property accessors are unreliable...
	    ObservableArray.prototype.get = function (index) {
	        var impl = this.$mobx;
	        if (impl) {
	            if (index < impl.values.length) {
	                impl.atom.reportObserved();
	                return impl.dehanceValue(impl.values[index]);
	            }
	            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl
	                .values
	                .length + "). Please check length first. Out of bound indices will not be tracked by MobX");
	        }
	        return undefined;
	    };
	    // See #734, in case property accessors are unreliable...
	    ObservableArray.prototype.set = function (index, newValue) {
	        var adm = this.$mobx;
	        var values = adm.values;
	        if (index < values.length) {
	            // update at index in range
	            checkIfStateModificationsAreAllowed(adm.atom);
	            var oldValue = values[index];
	            if (hasInterceptors(adm)) {
	                var change = interceptChange(adm, {
	                    type: "update",
	                    object: this,
	                    index: index,
	                    newValue: newValue
	                });
	                if (!change)
	                    return;
	                newValue = change.newValue;
	            }
	            newValue = adm.enhancer(newValue, oldValue);
	            var changed = newValue !== oldValue;
	            if (changed) {
	                values[index] = newValue;
	                adm.notifyArrayChildUpdate(index, newValue, oldValue);
	            }
	        }
	        else if (index === values.length) {
	            // add a new item
	            adm.spliceWithArray(index, 0, [newValue]);
	        }
	        else {
	            // out of bounds
	            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
	        }
	    };
	    return ObservableArray;
	}(StubArray));
	declareIterator(ObservableArray.prototype, function () {
	    return arrayAsIterator(this.slice());
	});
	Object.defineProperty(ObservableArray.prototype, "length", {
	    enumerable: false,
	    configurable: true,
	    get: function () {
	        return this.$mobx.getArrayLength();
	    },
	    set: function (newLength) {
	        this.$mobx.setArrayLength(newLength);
	    }
	});
	[
	    "every",
	    "filter",
	    "forEach",
	    "indexOf",
	    "join",
	    "lastIndexOf",
	    "map",
	    "reduce",
	    "reduceRight",
	    "slice",
	    "some",
	    "toString",
	    "toLocaleString"
	].forEach(function (funcName) {
	    var baseFunc = Array.prototype[funcName];
	    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
	    addHiddenProp(ObservableArray.prototype, funcName, function () {
	        return baseFunc.apply(this.peek(), arguments);
	    });
	});
	/**
	 * We don't want those to show up in `for (const key in ar)` ...
	 */
	makeNonEnumerable(ObservableArray.prototype, [
	    "constructor",
	    "intercept",
	    "observe",
	    "clear",
	    "concat",
	    "get",
	    "replace",
	    "toJS",
	    "toJSON",
	    "peek",
	    "find",
	    "findIndex",
	    "splice",
	    "spliceWithArray",
	    "push",
	    "pop",
	    "set",
	    "shift",
	    "unshift",
	    "reverse",
	    "sort",
	    "remove",
	    "move",
	    "toString",
	    "toLocaleString"
	]);
	// See #364
	var ENTRY_0 = createArrayEntryDescriptor(0);
	function createArrayEntryDescriptor(index) {
	    return {
	        enumerable: false,
	        configurable: false,
	        get: function () {
	            // TODO: Check `this`?, see #752?
	            return this.get(index);
	        },
	        set: function (value) {
	            this.set(index, value);
	        }
	    };
	}
	function createArrayBufferItem(index) {
	    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
	}
	function reserveArrayBuffer(max) {
	    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
	        createArrayBufferItem(index);
	    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
	}
	reserveArrayBuffer(1000);
	var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
	function isObservableArray(thing) {
	    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
	}
	
	var UNCHANGED = {};
	var ObservableValue = /** @class */ (function (_super) {
	    __extends(ObservableValue, _super);
	    function ObservableValue(value, enhancer, name, notifySpy) {
	        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
	        if (notifySpy === void 0) { notifySpy = true; }
	        var _this = _super.call(this, name) || this;
	        _this.enhancer = enhancer;
	        _this.hasUnreportedChange = false;
	        _this.dehancer = undefined;
	        _this.value = enhancer(value, undefined, name);
	        if (notifySpy && isSpyEnabled()) {
	            // only notify spy if this is a stand-alone observable
	            spyReport({ type: "create", object: _this, newValue: _this.value });
	        }
	        return _this;
	    }
	    ObservableValue.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined)
	            return this.dehancer(value);
	        return value;
	    };
	    ObservableValue.prototype.set = function (newValue) {
	        var oldValue = this.value;
	        newValue = this.prepareNewValue(newValue);
	        if (newValue !== UNCHANGED) {
	            var notifySpy = isSpyEnabled();
	            if (notifySpy) {
	                spyReportStart({
	                    type: "update",
	                    object: this,
	                    newValue: newValue,
	                    oldValue: oldValue
	                });
	            }
	            this.setNewValue(newValue);
	            if (notifySpy)
	                spyReportEnd();
	        }
	    };
	    ObservableValue.prototype.prepareNewValue = function (newValue) {
	        checkIfStateModificationsAreAllowed(this);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: this,
	                type: "update",
	                newValue: newValue
	            });
	            if (!change)
	                return UNCHANGED;
	            newValue = change.newValue;
	        }
	        // apply modifier
	        newValue = this.enhancer(newValue, this.value, this.name);
	        return this.value !== newValue ? newValue : UNCHANGED;
	    };
	    ObservableValue.prototype.setNewValue = function (newValue) {
	        var oldValue = this.value;
	        this.value = newValue;
	        this.reportChanged();
	        if (hasListeners(this)) {
	            notifyListeners(this, {
	                type: "update",
	                object: this,
	                newValue: newValue,
	                oldValue: oldValue
	            });
	        }
	    };
	    ObservableValue.prototype.get = function () {
	        this.reportObserved();
	        return this.dehanceValue(this.value);
	    };
	    ObservableValue.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableValue.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately)
	            listener({
	                object: this,
	                type: "update",
	                newValue: this.value,
	                oldValue: undefined
	            });
	        return registerListener(this, listener);
	    };
	    ObservableValue.prototype.toJSON = function () {
	        return this.get();
	    };
	    ObservableValue.prototype.toString = function () {
	        return this.name + "[" + this.value + "]";
	    };
	    ObservableValue.prototype.valueOf = function () {
	        return toPrimitive(this.get());
	    };
	    return ObservableValue;
	}(BaseAtom));
	ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
	var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);
	
	var messages = {
	    m001: "It is not allowed to assign new values to @action fields",
	    m002: "`runInAction` expects a function",
	    m003: "`runInAction` expects a function without arguments",
	    m004: "autorun expects a function",
	    m005: "Warning: attempted to pass an action to autorun. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
	    m006: "Warning: attempted to pass an action to autorunAsync. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
	    m007: "reaction only accepts 2 or 3 arguments. If migrating from MobX 2, please provide an options object",
	    m008: "wrapping reaction expression in `asReference` is no longer supported, use options object instead",
	    m009: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'. It looks like it was used on a property.",
	    m010: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'",
	    m011: "First argument to `computed` should be an expression. If using computed as decorator, don't pass it arguments",
	    m012: "computed takes one or two arguments if used as function",
	    m013: "[mobx.expr] 'expr' should only be used inside other reactive functions.",
	    m014: "extendObservable expected 2 or more arguments",
	    m015: "extendObservable expects an object as first argument",
	    m016: "extendObservable should not be used on maps, use map.merge instead",
	    m017: "all arguments of extendObservable should be objects",
	    m018: "extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540",
	    m019: "[mobx.isObservable] isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.",
	    m020: "modifiers can only be used for individual object properties",
	    m021: "observable expects zero or one arguments",
	    m022: "@observable can not be used on getters, use @computed instead",
	    m024: "whyRun() can only be used if a derivation is active, or by passing an computed value / reaction explicitly. If you invoked whyRun from inside a computation; the computation is currently suspended but re-evaluating because somebody requested its value.",
	    m025: "whyRun can only be used on reactions and computed values",
	    m026: "`action` can only be invoked on functions",
	    m028: "It is not allowed to set `useStrict` when a derivation is running",
	    m029: "INTERNAL ERROR only onBecomeUnobserved shouldn't be called twice in a row",
	    m030a: "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: ",
	    m030b: "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ",
	    m031: "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: ",
	    m032: "* This computation is suspended (not in use by any reaction) and won't run automatically.\n	Didn't expect this computation to be suspended at this point?\n	  1. Make sure this computation is used by a reaction (reaction, autorun, observer).\n	  2. Check whether you are using this computation synchronously (in the same stack as they reaction that needs it).",
	    m033: "`observe` doesn't support the fire immediately property for observable maps.",
	    m034: "`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead",
	    m035: "Cannot make the designated object observable; it is not extensible",
	    m036: "It is not possible to get index atoms from arrays",
	    m037: "Hi there! I'm sorry you have just run into an exception.\nIf your debugger ends up here, know that some reaction (like the render() of an observer component, autorun or reaction)\nthrew an exception and that mobx caught it, to avoid that it brings the rest of your application down.\nThe original cause of the exception (the code that caused this reaction to run (again)), is still in the stack.\n\nHowever, more interesting is the actual stack trace of the error itself.\nHopefully the error is an instanceof Error, because in that case you can inspect the original stack of the error from where it was thrown.\nSee `error.stack` property, or press the very subtle \"(...)\" link you see near the console.error message that probably brought you here.\nThat stack is more interesting than the stack of this console.error itself.\n\nIf the exception you see is an exception you created yourself, make sure to use `throw new Error(\"Oops\")` instead of `throw \"Oops\"`,\nbecause the javascript environment will only preserve the original stack trace in the first form.\n\nYou can also make sure the debugger pauses the next time this very same exception is thrown by enabling \"Pause on caught exception\".\n(Note that it might pause on many other, unrelated exception as well).\n\nIf that all doesn't help you out, feel free to open an issue https://github.com/mobxjs/mobx/issues!\n",
	    m038: "Missing items in this list?\n    1. Check whether all used values are properly marked as observable (use isObservable to verify)\n    2. Make sure you didn't dereference values too early. MobX observes props, not primitives. E.g: use 'person.name' instead of 'name' in your computation.\n"
	};
	function getMessage(id) {
	    return messages[id];
	}
	
	function createAction(actionName, fn) {
	    invariant(typeof fn === "function", getMessage("m026"));
	    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
	    var res = function () {
	        return executeAction(actionName, fn, this, arguments);
	    };
	    res.originalFn = fn;
	    res.isMobxAction = true;
	    return res;
	}
	function executeAction(actionName, fn, scope, args) {
	    var runInfo = startAction(actionName, fn, scope, args);
	    try {
	        return fn.apply(scope, args);
	    }
	    finally {
	        endAction(runInfo);
	    }
	}
	function startAction(actionName, fn, scope, args) {
	    var notifySpy = isSpyEnabled() && !!actionName;
	    var startTime = 0;
	    if (notifySpy) {
	        startTime = Date.now();
	        var l = (args && args.length) || 0;
	        var flattendArgs = new Array(l);
	        if (l > 0)
	            for (var i = 0; i < l; i++)
	                flattendArgs[i] = args[i];
	        spyReportStart({
	            type: "action",
	            name: actionName,
	            fn: fn,
	            object: scope,
	            arguments: flattendArgs
	        });
	    }
	    var prevDerivation = untrackedStart();
	    startBatch();
	    var prevAllowStateChanges = allowStateChangesStart(true);
	    return {
	        prevDerivation: prevDerivation,
	        prevAllowStateChanges: prevAllowStateChanges,
	        notifySpy: notifySpy,
	        startTime: startTime
	    };
	}
	function endAction(runInfo) {
	    allowStateChangesEnd(runInfo.prevAllowStateChanges);
	    endBatch();
	    untrackedEnd(runInfo.prevDerivation);
	    if (runInfo.notifySpy)
	        spyReportEnd({ time: Date.now() - runInfo.startTime });
	}
	function useStrict(strict) {
	    invariant(globalState.trackingDerivation === null, getMessage("m028"));
	    globalState.strictMode = strict;
	    globalState.allowStateChanges = !strict;
	}
	function isStrictModeEnabled() {
	    return globalState.strictMode;
	}
	function allowStateChanges(allowStateChanges, func) {
	    // TODO: deprecate / refactor this function in next major
	    // Currently only used by `@observer`
	    // Proposed change: remove first param, rename to `forbidStateChanges`,
	    // require error callback instead of the hardcoded error message now used
	    // Use `inAction` instead of allowStateChanges in derivation.ts to check strictMode
	    var prev = allowStateChangesStart(allowStateChanges);
	    var res;
	    try {
	        res = func();
	    }
	    finally {
	        allowStateChangesEnd(prev);
	    }
	    return res;
	}
	function allowStateChangesStart(allowStateChanges) {
	    var prev = globalState.allowStateChanges;
	    globalState.allowStateChanges = allowStateChanges;
	    return prev;
	}
	function allowStateChangesEnd(prev) {
	    globalState.allowStateChanges = prev;
	}
	
	/**
	 * Constructs a decorator, that normalizes the differences between
	 * TypeScript and Babel. Mainly caused by the fact that legacy-decorator cannot assign
	 * values during instance creation to properties that have a getter setter.
	 *
	 * - Sigh -
	 *
	 * Also takes care of the difference between @decorator field and @decorator(args) field, and different forms of values.
	 * For performance (cpu and mem) reasons the properties are always defined on the prototype (at least initially).
	 * This means that these properties despite being enumerable might not show up in Object.keys() (but they will show up in for...in loops).
	 */
	function createClassPropertyDecorator(
	/**
	 * This function is invoked once, when the property is added to a new instance.
	 * When this happens is not strictly determined due to differences in TS and Babel:
	 * Typescript: Usually when constructing the new instance
	 * Babel, sometimes Typescript: during the first get / set
	 * Both: when calling `runLazyInitializers(instance)`
	 */
	onInitialize, get, set, enumerable, 
	/**
	 * Can this decorator invoked with arguments? e.g. @decorator(args)
	 */
	allowCustomArguments) {
	    function classPropertyDecorator(target, key, descriptor, customArgs, argLen) {
	        if (argLen === void 0) { argLen = 0; }
	        invariant(allowCustomArguments || quacksLikeADecorator(arguments), "This function is a decorator, but it wasn't invoked like a decorator");
	        if (!descriptor) {
	            // typescript (except for getter / setters)
	            var newDescriptor = {
	                enumerable: enumerable,
	                configurable: true,
	                get: function () {
	                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true)
	                        typescriptInitializeProperty(this, key, undefined, onInitialize, customArgs, descriptor);
	                    return get.call(this, key);
	                },
	                set: function (v) {
	                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true) {
	                        typescriptInitializeProperty(this, key, v, onInitialize, customArgs, descriptor);
	                    }
	                    else {
	                        set.call(this, key, v);
	                    }
	                }
	            };
	            if (arguments.length < 3 || (arguments.length === 5 && argLen < 3)) {
	                // Typescript target is ES3, so it won't define property for us
	                // or using Reflect.decorate polyfill, which will return no descriptor
	                // (see https://github.com/mobxjs/mobx/issues/333)
	                Object.defineProperty(target, key, newDescriptor);
	            }
	            return newDescriptor;
	        }
	        else {
	            // babel and typescript getter / setter props
	            if (!hasOwnProperty(target, "__mobxLazyInitializers")) {
	                addHiddenProp(target, "__mobxLazyInitializers", (target.__mobxLazyInitializers && target.__mobxLazyInitializers.slice()) || [] // support inheritance
	                );
	            }
	            var value_1 = descriptor.value, initializer_1 = descriptor.initializer;
	            target.__mobxLazyInitializers.push(function (instance) {
	                onInitialize(instance, key, initializer_1 ? initializer_1.call(instance) : value_1, customArgs, descriptor);
	            });
	            return {
	                enumerable: enumerable,
	                configurable: true,
	                get: function () {
	                    if (this.__mobxDidRunLazyInitializers !== true)
	                        runLazyInitializers(this);
	                    return get.call(this, key);
	                },
	                set: function (v) {
	                    if (this.__mobxDidRunLazyInitializers !== true)
	                        runLazyInitializers(this);
	                    set.call(this, key, v);
	                }
	            };
	        }
	    }
	    if (allowCustomArguments) {
	        /** If custom arguments are allowed, we should return a function that returns a decorator */
	        return function () {
	            /** Direct invocation: @decorator bla */
	            if (quacksLikeADecorator(arguments))
	                return classPropertyDecorator.apply(null, arguments);
	            /** Indirect invocation: @decorator(args) bla */
	            var outerArgs = arguments;
	            var argLen = arguments.length;
	            return function (target, key, descriptor) {
	                return classPropertyDecorator(target, key, descriptor, outerArgs, argLen);
	            };
	        };
	    }
	    return classPropertyDecorator;
	}
	function typescriptInitializeProperty(instance, key, v, onInitialize, customArgs, baseDescriptor) {
	    if (!hasOwnProperty(instance, "__mobxInitializedProps"))
	        addHiddenProp(instance, "__mobxInitializedProps", {});
	    instance.__mobxInitializedProps[key] = true;
	    onInitialize(instance, key, v, customArgs, baseDescriptor);
	}
	function runLazyInitializers(instance) {
	    if (instance.__mobxDidRunLazyInitializers === true)
	        return;
	    if (instance.__mobxLazyInitializers) {
	        addHiddenProp(instance, "__mobxDidRunLazyInitializers", true);
	        instance.__mobxDidRunLazyInitializers &&
	            instance.__mobxLazyInitializers.forEach(function (initializer) { return initializer(instance); });
	    }
	}
	function quacksLikeADecorator(args) {
	    return (args.length === 2 || args.length === 3) && typeof args[1] === "string";
	}
	
	var actionFieldDecorator = createClassPropertyDecorator(function (target, key, value, args, originalDescriptor) {
	    var actionName = args && args.length === 1 ? args[0] : value.name || key || "<unnamed action>";
	    var wrappedAction = action(actionName, value);
	    addHiddenProp(target, key, wrappedAction);
	}, function (key) {
	    return this[key];
	}, function () {
	    invariant(false, getMessage("m001"));
	}, false, true);
	var boundActionDecorator = createClassPropertyDecorator(function (target, key, value) {
	    defineBoundAction(target, key, value);
	}, function (key) {
	    return this[key];
	}, function () {
	    invariant(false, getMessage("m001"));
	}, false, false);
	var action = function action(arg1, arg2, arg3, arg4) {
	    if (arguments.length === 1 && typeof arg1 === "function")
	        return createAction(arg1.name || "<unnamed action>", arg1);
	    if (arguments.length === 2 && typeof arg2 === "function")
	        return createAction(arg1, arg2);
	    if (arguments.length === 1 && typeof arg1 === "string")
	        return namedActionDecorator(arg1);
	    return namedActionDecorator(arg2).apply(null, arguments);
	};
	action.bound = function boundAction(arg1, arg2, arg3) {
	    if (typeof arg1 === "function") {
	        var action_1 = createAction("<not yet bound action>", arg1);
	        action_1.autoBind = true;
	        return action_1;
	    }
	    return boundActionDecorator.apply(null, arguments);
	};
	function namedActionDecorator(name) {
	    return function (target, prop, descriptor) {
	        if (descriptor && typeof descriptor.value === "function") {
	            // TypeScript @action method() { }. Defined on proto before being decorated
	            // Don't use the field decorator if we are just decorating a method
	            descriptor.value = createAction(name, descriptor.value);
	            descriptor.enumerable = false;
	            descriptor.configurable = true;
	            return descriptor;
	        }
	        if (descriptor !== undefined && descriptor.get !== undefined) {
	            throw new Error("[mobx] action is not expected to be used with getters");
	        }
	        // bound instance methods
	        return actionFieldDecorator(name).apply(this, arguments);
	    };
	}
	function runInAction(arg1, arg2, arg3) {
	    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
	    var fn = typeof arg1 === "function" ? arg1 : arg2;
	    var scope = typeof arg1 === "function" ? arg2 : arg3;
	    invariant(typeof fn === "function", getMessage("m002"));
	    invariant(fn.length === 0, getMessage("m003"));
	    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
	    return executeAction(actionName, fn, scope, undefined);
	}
	function isAction(thing) {
	    return typeof thing === "function" && thing.isMobxAction === true;
	}
	function defineBoundAction(target, propertyName, fn) {
	    var res = function () {
	        return executeAction(propertyName, fn, target, arguments);
	    };
	    res.isMobxAction = true;
	    addHiddenProp(target, propertyName, res);
	}
	
	var toString = Object.prototype.toString;
	function deepEqual(a, b) {
	    return eq(a, b);
	}
	// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
	// Internal recursive comparison function for `isEqual`.
	function eq(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b)
	        return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null)
	        return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a)
	        return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== "function" && type !== "object" && typeof b != "object")
	        return false;
	    return deepEq(a, b, aStack, bStack);
	}
	// Internal recursive comparison function for `isEqual`.
	function deepEq(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    a = unwrap(a);
	    b = unwrap(b);
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b))
	        return false;
	    switch (className) {
	        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	        case "[object RegExp]":
	        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	        case "[object String]":
	            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	            // equivalent to `new String("5")`.
	            return "" + a === "" + b;
	        case "[object Number]":
	            // `NaN`s are equivalent, but non-reflexive.
	            // Object(NaN) is equivalent to NaN.
	            if (+a !== +a)
	                return +b !== +b;
	            // An `egal` comparison is performed for other numeric values.
	            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	        case "[object Date]":
	        case "[object Boolean]":
	            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	            // millisecond representations. Note that invalid dates with millisecond representations
	            // of `NaN` are not equivalent.
	            return +a === +b;
	        case "[object Symbol]":
	            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
	    }
	    var areArrays = className === "[object Array]";
	    if (!areArrays) {
	        if (typeof a != "object" || typeof b != "object")
	            return false;
	        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	        // from different frames are.
	        var aCtor = a.constructor, bCtor = b.constructor;
	        if (aCtor !== bCtor &&
	            !(typeof aCtor === "function" &&
	                aCtor instanceof aCtor &&
	                typeof bCtor === "function" &&
	                bCtor instanceof bCtor) &&
	            ("constructor" in a && "constructor" in b)) {
	            return false;
	        }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	        // Linear search. Performance is inversely proportional to the number of
	        // unique nested structures.
	        if (aStack[length] === a)
	            return bStack[length] === b;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	        // Compare array lengths to determine if a deep comparison is necessary.
	        length = a.length;
	        if (length !== b.length)
	            return false;
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (length--) {
	            if (!eq(a[length], b[length], aStack, bStack))
	                return false;
	        }
	    }
	    else {
	        // Deep compare objects.
	        var keys = Object.keys(a), key;
	        length = keys.length;
	        // Ensure that both objects contain the same number of properties before comparing deep equality.
	        if (Object.keys(b).length !== length)
	            return false;
	        while (length--) {
	            // Deep compare each member
	            key = keys[length];
	            if (!(has(b, key) && eq(a[key], b[key], aStack, bStack)))
	                return false;
	        }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	}
	function unwrap(a) {
	    if (isObservableArray(a))
	        return a.peek();
	    if (isObservableMap(a))
	        return a.entries();
	    if (isES6Map(a))
	        return iteratorToArray(a.entries());
	    return a;
	}
	function has(a, key) {
	    return Object.prototype.hasOwnProperty.call(a, key);
	}
	
	function identityComparer(a, b) {
	    return a === b;
	}
	function structuralComparer(a, b) {
	    return deepEqual(a, b);
	}
	function defaultComparer(a, b) {
	    return areBothNaN(a, b) || identityComparer(a, b);
	}
	var comparer = {
	    identity: identityComparer,
	    structural: structuralComparer,
	    default: defaultComparer
	};
	
	function autorun(arg1, arg2, arg3) {
	    var name, view, scope;
	    if (typeof arg1 === "string") {
	        name = arg1;
	        view = arg2;
	        scope = arg3;
	    }
	    else {
	        name = arg1.name || "Autorun@" + getNextId();
	        view = arg1;
	        scope = arg2;
	    }
	    invariant(typeof view === "function", getMessage("m004"));
	    invariant(isAction(view) === false, getMessage("m005"));
	    if (scope)
	        view = view.bind(scope);
	    var reaction = new Reaction(name, function () {
	        this.track(reactionRunner);
	    });
	    function reactionRunner() {
	        view(reaction);
	    }
	    reaction.schedule();
	    return reaction.getDisposer();
	}
	function when(arg1, arg2, arg3, arg4) {
	    var name, predicate, effect, scope;
	    if (typeof arg1 === "string") {
	        name = arg1;
	        predicate = arg2;
	        effect = arg3;
	        scope = arg4;
	    }
	    else {
	        name = "When@" + getNextId();
	        predicate = arg1;
	        effect = arg2;
	        scope = arg3;
	    }
	    var disposer = autorun(name, function (r) {
	        if (predicate.call(scope)) {
	            r.dispose();
	            var prevUntracked = untrackedStart();
	            effect.call(scope);
	            untrackedEnd(prevUntracked);
	        }
	    });
	    return disposer;
	}
	function autorunAsync(arg1, arg2, arg3, arg4) {
	    var name, func, delay, scope;
	    if (typeof arg1 === "string") {
	        name = arg1;
	        func = arg2;
	        delay = arg3;
	        scope = arg4;
	    }
	    else {
	        name = arg1.name || "AutorunAsync@" + getNextId();
	        func = arg1;
	        delay = arg2;
	        scope = arg3;
	    }
	    invariant(isAction(func) === false, getMessage("m006"));
	    if (delay === void 0)
	        delay = 1;
	    if (scope)
	        func = func.bind(scope);
	    var isScheduled = false;
	    var r = new Reaction(name, function () {
	        if (!isScheduled) {
	            isScheduled = true;
	            setTimeout(function () {
	                isScheduled = false;
	                if (!r.isDisposed)
	                    r.track(reactionRunner);
	            }, delay);
	        }
	    });
	    function reactionRunner() {
	        func(r);
	    }
	    r.schedule();
	    return r.getDisposer();
	}
	function reaction(expression, effect, arg3) {
	    if (arguments.length > 3) {
	        fail(getMessage("m007"));
	    }
	    if (isModifierDescriptor(expression)) {
	        fail(getMessage("m008"));
	    }
	    var opts;
	    if (typeof arg3 === "object") {
	        opts = arg3;
	    }
	    else {
	        opts = {};
	    }
	    opts.name =
	        opts.name || expression.name || effect.name || "Reaction@" + getNextId();
	    opts.fireImmediately = arg3 === true || opts.fireImmediately === true;
	    opts.delay = opts.delay || 0;
	    opts.compareStructural = opts.compareStructural || opts.struct || false;
	    // TODO: creates ugly spy events, use `effect = (r) => runInAction(opts.name, () => effect(r))` instead
	    effect = action(opts.name, opts.context ? effect.bind(opts.context) : effect);
	    if (opts.context) {
	        expression = expression.bind(opts.context);
	    }
	    var firstTime = true;
	    var isScheduled = false;
	    var value;
	    var equals = opts.equals
	        ? opts.equals
	        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
	    var r = new Reaction(opts.name, function () {
	        if (firstTime || opts.delay < 1) {
	            reactionRunner();
	        }
	        else if (!isScheduled) {
	            isScheduled = true;
	            setTimeout(function () {
	                isScheduled = false;
	                reactionRunner();
	            }, opts.delay);
	        }
	    });
	    function reactionRunner() {
	        if (r.isDisposed)
	            return;
	        var changed = false;
	        r.track(function () {
	            var nextValue = expression(r);
	            changed = firstTime || !equals(value, nextValue);
	            value = nextValue;
	        });
	        if (firstTime && opts.fireImmediately)
	            effect(value, r);
	        if (!firstTime && changed === true)
	            effect(value, r);
	        if (firstTime)
	            firstTime = false;
	    }
	    r.schedule();
	    return r.getDisposer();
	}
	
	/**
	 * A node in the state dependency root that observes other nodes, and can be observed itself.
	 *
	 * ComputedValue will remember the result of the computation for the duration of the batch, or
	 * while being observed.
	 *
	 * During this time it will recompute only when one of its direct dependencies changed,
	 * but only when it is being accessed with `ComputedValue.get()`.
	 *
	 * Implementation description:
	 * 1. First time it's being accessed it will compute and remember result
	 *    give back remembered result until 2. happens
	 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
	 * 3. When it's being accessed, recompute if any shallow dependency changed.
	 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
	 *    go to step 2. either way
	 *
	 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
	 */
	var ComputedValue = /** @class */ (function () {
	    /**
	     * Create a new computed value based on a function expression.
	     *
	     * The `name` property is for debug purposes only.
	     *
	     * The `equals` property specifies the comparer function to use to determine if a newly produced
	     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
	     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
	     * Structural comparison can be convenient if you always produce an new aggregated object and
	     * don't want to notify observers if it is structurally the same.
	     * This is useful for working with vectors, mouse coordinates etc.
	     */
	    function ComputedValue(derivation, scope, equals, name, setter) {
	        this.derivation = derivation;
	        this.scope = scope;
	        this.equals = equals;
	        this.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	        this.observing = []; // nodes we are looking at. Our value depends on these nodes
	        this.newObserving = null; // during tracking it's an array with new observed observers
	        this.isPendingUnobservation = false;
	        this.observers = [];
	        this.observersIndexes = {};
	        this.diffValue = 0;
	        this.runId = 0;
	        this.lastAccessedBy = 0;
	        this.lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	        this.unboundDepsCount = 0;
	        this.__mapid = "#" + getNextId();
	        this.value = new CaughtException(null);
	        this.isComputing = false; // to check for cycles
	        this.isRunningSetter = false;
	        this.isTracing = TraceMode.NONE;
	        this.name = name || "ComputedValue@" + getNextId();
	        if (setter)
	            this.setter = createAction(name + "-setter", setter);
	    }
	    ComputedValue.prototype.onBecomeStale = function () {
	        propagateMaybeChanged(this);
	    };
	    ComputedValue.prototype.onBecomeUnobserved = function () {
	        clearObserving(this);
	        this.value = undefined;
	    };
	    /**
	     * Returns the current value of this computed value.
	     * Will evaluate its computation first if needed.
	     */
	    ComputedValue.prototype.get = function () {
	        invariant(!this.isComputing, "Cycle detected in computation " + this.name, this.derivation);
	        if (globalState.inBatch === 0) {
	            // This is an minor optimization which could be omitted to simplify the code
	            // The computedValue is accessed outside of any mobx stuff. Batch observing should be enough and don't need
	            // tracking as it will never be called again inside this batch.
	            startBatch();
	            if (shouldCompute(this)) {
	                if (this.isTracing !== TraceMode.NONE) {
	                    console.log("[mobx.trace] '" + this
	                        .name + "' is being read outside a reactive context and doing a full recompute");
	                }
	                this.value = this.computeValue(false);
	            }
	            endBatch();
	        }
	        else {
	            reportObserved(this);
	            if (shouldCompute(this))
	                if (this.trackAndCompute())
	                    propagateChangeConfirmed(this);
	        }
	        var result = this.value;
	        if (isCaughtException(result))
	            throw result.cause;
	        return result;
	    };
	    ComputedValue.prototype.peek = function () {
	        var res = this.computeValue(false);
	        if (isCaughtException(res))
	            throw res.cause;
	        return res;
	    };
	    ComputedValue.prototype.set = function (value) {
	        if (this.setter) {
	            invariant(!this.isRunningSetter, "The setter of computed value '" + this
	                .name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
	            this.isRunningSetter = true;
	            try {
	                this.setter.call(this.scope, value);
	            }
	            finally {
	                this.isRunningSetter = false;
	            }
	        }
	        else
	            invariant(false, "[ComputedValue '" + this
	                .name + "'] It is not possible to assign a new value to a computed value.");
	    };
	    ComputedValue.prototype.trackAndCompute = function () {
	        if (isSpyEnabled()) {
	            spyReport({
	                object: this.scope,
	                type: "compute",
	                fn: this.derivation
	            });
	        }
	        var oldValue = this.value;
	        var wasSuspended = 
	        /* see #1208 */ this.dependenciesState === exports.IDerivationState.NOT_TRACKING;
	        var newValue = (this.value = this.computeValue(true));
	        return (wasSuspended ||
	            isCaughtException(oldValue) ||
	            isCaughtException(newValue) ||
	            !this.equals(oldValue, newValue));
	    };
	    ComputedValue.prototype.computeValue = function (track) {
	        this.isComputing = true;
	        globalState.computationDepth++;
	        var res;
	        if (track) {
	            res = trackDerivedFunction(this, this.derivation, this.scope);
	        }
	        else {
	            try {
	                res = this.derivation.call(this.scope);
	            }
	            catch (e) {
	                res = new CaughtException(e);
	            }
	        }
	        globalState.computationDepth--;
	        this.isComputing = false;
	        return res;
	    };
	    ComputedValue.prototype.observe = function (listener, fireImmediately) {
	        var _this = this;
	        var firstTime = true;
	        var prevValue = undefined;
	        return autorun(function () {
	            var newValue = _this.get();
	            if (!firstTime || fireImmediately) {
	                var prevU = untrackedStart();
	                listener({
	                    type: "update",
	                    object: _this,
	                    newValue: newValue,
	                    oldValue: prevValue
	                });
	                untrackedEnd(prevU);
	            }
	            firstTime = false;
	            prevValue = newValue;
	        });
	    };
	    ComputedValue.prototype.toJSON = function () {
	        return this.get();
	    };
	    ComputedValue.prototype.toString = function () {
	        return this.name + "[" + this.derivation.toString() + "]";
	    };
	    ComputedValue.prototype.valueOf = function () {
	        return toPrimitive(this.get());
	    };
	    ComputedValue.prototype.whyRun = function () {
	        var isTracking = Boolean(globalState.trackingDerivation);
	        var observing = unique(this.isComputing ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
	        var observers = unique(getObservers(this).map(function (dep) { return dep.name; }));
	        return ("\nWhyRun? computation '" + this.name + "':\n * Running because: " + (isTracking
	            ? "[active] the value of this computation is needed by a reaction"
	            : this.isComputing
	                ? "[get] The value of this computed was requested outside a reaction"
	                : "[idle] not running at the moment") + "\n" +
	            (this.dependenciesState === exports.IDerivationState.NOT_TRACKING
	                ? getMessage("m032")
	                : " * This computation will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this.isComputing && isTracking
	                    ? " (... or any observable accessed during the remainder of the current run)"
	                    : "") + "\n    " + getMessage("m038") + "\n\n  * If the outcome of this computation changes, the following observers will be re-run:\n    " + joinStrings(observers) + "\n"));
	    };
	    return ComputedValue;
	}());
	ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
	var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);
	
	var ObservableObjectAdministration = /** @class */ (function () {
	    function ObservableObjectAdministration(target, name) {
	        this.target = target;
	        this.name = name;
	        this.values = {};
	        this.changeListeners = null;
	        this.interceptors = null;
	    }
	    /**
	     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
	     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
	     * for callback details
	     */
	    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
	        invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
	        return registerListener(this, callback);
	    };
	    ObservableObjectAdministration.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    return ObservableObjectAdministration;
	}());
	function asObservableObject(target, name) {
	    if (isObservableObject(target) && target.hasOwnProperty("$mobx"))
	        return target.$mobx;
	    invariant(Object.isExtensible(target), getMessage("m035"));
	    if (!isPlainObject(target))
	        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
	    if (!name)
	        name = "ObservableObject@" + getNextId();
	    var adm = new ObservableObjectAdministration(target, name);
	    addHiddenFinalProp(target, "$mobx", adm);
	    return adm;
	}
	function defineObservablePropertyFromDescriptor(adm, propName, descriptor, defaultEnhancer) {
	    if (adm.values[propName] && !isComputedValue(adm.values[propName])) {
	        // already observable property
	        invariant("value" in descriptor, "The property " + propName + " in " + adm.name + " is already observable, cannot redefine it as computed property");
	        adm.target[propName] = descriptor.value; // the property setter will make 'value' reactive if needed.
	        return;
	    }
	    // not yet observable property
	    if ("value" in descriptor) {
	        // not a computed value
	        if (isModifierDescriptor(descriptor.value)) {
	            // x : ref(someValue)
	            var modifierDescriptor = descriptor.value;
	            defineObservableProperty(adm, propName, modifierDescriptor.initialValue, modifierDescriptor.enhancer);
	        }
	        else if (isAction(descriptor.value) && descriptor.value.autoBind === true) {
	            defineBoundAction(adm.target, propName, descriptor.value.originalFn);
	        }
	        else if (isComputedValue(descriptor.value)) {
	            // x: computed(someExpr)
	            defineComputedPropertyFromComputedValue(adm, propName, descriptor.value);
	        }
	        else {
	            // x: someValue
	            defineObservableProperty(adm, propName, descriptor.value, defaultEnhancer);
	        }
	    }
	    else {
	        // get x() { return 3 } set x(v) { }
	        defineComputedProperty(adm, propName, descriptor.get, descriptor.set, comparer.default, true);
	    }
	}
	function defineObservableProperty(adm, propName, newValue, enhancer) {
	    assertPropertyConfigurable(adm.target, propName);
	    if (hasInterceptors(adm)) {
	        var change = interceptChange(adm, {
	            object: adm.target,
	            name: propName,
	            type: "add",
	            newValue: newValue
	        });
	        if (!change)
	            return;
	        newValue = change.newValue;
	    }
	    var observable = (adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false));
	    newValue = observable.value; // observableValue might have changed it
	    Object.defineProperty(adm.target, propName, generateObservablePropConfig(propName));
	    notifyPropertyAddition(adm, adm.target, propName, newValue);
	}
	function defineComputedProperty(adm, propName, getter, setter, equals, asInstanceProperty) {
	    if (asInstanceProperty)
	        assertPropertyConfigurable(adm.target, propName);
	    adm.values[propName] = new ComputedValue(getter, adm.target, equals, adm.name + "." + propName, setter);
	    if (asInstanceProperty) {
	        Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
	    }
	}
	function defineComputedPropertyFromComputedValue(adm, propName, computedValue) {
	    var name = adm.name + "." + propName;
	    computedValue.name = name;
	    if (!computedValue.scope)
	        computedValue.scope = adm.target;
	    adm.values[propName] = computedValue;
	    Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
	}
	var observablePropertyConfigs = {};
	var computedPropertyConfigs = {};
	function generateObservablePropConfig(propName) {
	    return (observablePropertyConfigs[propName] ||
	        (observablePropertyConfigs[propName] = {
	            configurable: true,
	            enumerable: true,
	            get: function () {
	                return this.$mobx.values[propName].get();
	            },
	            set: function (v) {
	                setPropertyValue(this, propName, v);
	            }
	        }));
	}
	function generateComputedPropConfig(propName) {
	    return (computedPropertyConfigs[propName] ||
	        (computedPropertyConfigs[propName] = {
	            configurable: true,
	            enumerable: false,
	            get: function () {
	                return this.$mobx.values[propName].get();
	            },
	            set: function (v) {
	                return this.$mobx.values[propName].set(v);
	            }
	        }));
	}
	function setPropertyValue(instance, name, newValue) {
	    var adm = instance.$mobx;
	    var observable = adm.values[name];
	    // intercept
	    if (hasInterceptors(adm)) {
	        var change = interceptChange(adm, {
	            type: "update",
	            object: instance,
	            name: name,
	            newValue: newValue
	        });
	        if (!change)
	            return;
	        newValue = change.newValue;
	    }
	    newValue = observable.prepareNewValue(newValue);
	    // notify spy & observers
	    if (newValue !== UNCHANGED) {
	        var notify = hasListeners(adm);
	        var notifySpy = isSpyEnabled();
	        var change = notify || notifySpy
	            ? {
	                type: "update",
	                object: instance,
	                oldValue: observable.value,
	                name: name,
	                newValue: newValue
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(change);
	        observable.setNewValue(newValue);
	        if (notify)
	            notifyListeners(adm, change);
	        if (notifySpy)
	            spyReportEnd();
	    }
	}
	function notifyPropertyAddition(adm, object, name, newValue) {
	    var notify = hasListeners(adm);
	    var notifySpy = isSpyEnabled();
	    var change = notify || notifySpy
	        ? {
	            type: "add",
	            object: object,
	            name: name,
	            newValue: newValue
	        }
	        : null;
	    if (notifySpy)
	        spyReportStart(change);
	    if (notify)
	        notifyListeners(adm, change);
	    if (notifySpy)
	        spyReportEnd();
	}
	var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
	function isObservableObject(thing) {
	    if (isObject(thing)) {
	        // Initializers run lazily when transpiling to babel, so make sure they are run...
	        runLazyInitializers(thing);
	        return isObservableObjectAdministration(thing.$mobx);
	    }
	    return false;
	}
	
	/**
	 * Returns true if the provided value is reactive.
	 * @param value object, function or array
	 * @param property if property is specified, checks whether value.property is reactive.
	 */
	function isObservable(value, property) {
	    if (value === null || value === undefined)
	        return false;
	    if (property !== undefined) {
	        if (isObservableArray(value) || isObservableMap(value))
	            throw new Error(getMessage("m019"));
	        else if (isObservableObject(value)) {
	            var o = value.$mobx;
	            return o.values && !!o.values[property];
	        }
	        return false;
	    }
	    // For first check, see #701
	    return (isObservableObject(value) ||
	        !!value.$mobx ||
	        isAtom(value) ||
	        isReaction(value) ||
	        isComputedValue(value));
	}
	
	function createDecoratorForEnhancer(enhancer) {
	    invariant(!!enhancer, ":(");
	    return createClassPropertyDecorator(function (target, name, baseValue, _, baseDescriptor) {
	        assertPropertyConfigurable(target, name);
	        invariant(!baseDescriptor || !baseDescriptor.get, getMessage("m022"));
	        var adm = asObservableObject(target, undefined);
	        defineObservableProperty(adm, name, baseValue, enhancer);
	    }, function (name) {
	        var observable = this.$mobx.values[name];
	        if (observable === undefined // See #505
	        )
	            return undefined;
	        return observable.get();
	    }, function (name, value) {
	        setPropertyValue(this, name, value);
	    }, true, false);
	}
	
	function extendObservable(target) {
	    var properties = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        properties[_i - 1] = arguments[_i];
	    }
	    return extendObservableHelper(target, deepEnhancer, properties);
	}
	function extendShallowObservable(target) {
	    var properties = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        properties[_i - 1] = arguments[_i];
	    }
	    return extendObservableHelper(target, referenceEnhancer, properties);
	}
	function extendObservableHelper(target, defaultEnhancer, properties) {
	    invariant(arguments.length >= 2, getMessage("m014"));
	    invariant(typeof target === "object", getMessage("m015"));
	    invariant(!isObservableMap(target), getMessage("m016"));
	    properties.forEach(function (propSet) {
	        invariant(typeof propSet === "object", getMessage("m017"));
	        invariant(!isObservable(propSet), getMessage("m018"));
	    });
	    var adm = asObservableObject(target);
	    var definedProps = {};
	    // Note could be optimised if properties.length === 1
	    for (var i = properties.length - 1; i >= 0; i--) {
	        var propSet = properties[i];
	        for (var key in propSet)
	            if (definedProps[key] !== true && hasOwnProperty(propSet, key)) {
	                definedProps[key] = true;
	                if (target === propSet && !isPropertyConfigurable(target, key))
	                    continue; // see #111, skip non-configurable or non-writable props for `observable(object)`.
	                var descriptor = Object.getOwnPropertyDescriptor(propSet, key);
	                defineObservablePropertyFromDescriptor(adm, key, descriptor, defaultEnhancer);
	            }
	    }
	    return target;
	}
	
	var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
	var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
	var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
	var deepStructDecorator = createDecoratorForEnhancer(deepStructEnhancer);
	var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
	/**
	 * Turns an object, array or function into a reactive structure.
	 * @param v the value which should become observable.
	 */
	function createObservable(v) {
	    if (v === void 0) { v = undefined; }
	    // @observable someProp;
	    if (typeof arguments[1] === "string")
	        return deepDecorator.apply(null, arguments);
	    invariant(arguments.length <= 1, getMessage("m021"));
	    invariant(!isModifierDescriptor(v), getMessage("m020"));
	    // it is an observable already, done
	    if (isObservable(v))
	        return v;
	    // something that can be converted and mutated?
	    var res = deepEnhancer(v, undefined, undefined);
	    // this value could be converted to a new observable data structure, return it
	    if (res !== v)
	        return res;
	    // otherwise, just box it
	    return observable.box(v);
	}
	var observableFactories = {
	    box: function (value, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("box");
	        return new ObservableValue(value, deepEnhancer, name);
	    },
	    shallowBox: function (value, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowBox");
	        return new ObservableValue(value, referenceEnhancer, name);
	    },
	    array: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("array");
	        return new ObservableArray(initialValues, deepEnhancer, name);
	    },
	    shallowArray: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowArray");
	        return new ObservableArray(initialValues, referenceEnhancer, name);
	    },
	    map: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("map");
	        return new ObservableMap(initialValues, deepEnhancer, name);
	    },
	    shallowMap: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowMap");
	        return new ObservableMap(initialValues, referenceEnhancer, name);
	    },
	    object: function (props, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("object");
	        var res = {};
	        // convert to observable object
	        asObservableObject(res, name);
	        // add properties
	        extendObservable(res, props);
	        return res;
	    },
	    shallowObject: function (props, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowObject");
	        var res = {};
	        asObservableObject(res, name);
	        extendShallowObservable(res, props);
	        return res;
	    },
	    ref: function () {
	        if (arguments.length < 2) {
	            // although ref creates actually a modifier descriptor, the type of the resultig properties
	            // of the object is `T` in the end, when the descriptors are interpreted
	            return createModifierDescriptor(referenceEnhancer, arguments[0]);
	        }
	        else {
	            return refDecorator.apply(null, arguments);
	        }
	    },
	    shallow: function () {
	        if (arguments.length < 2) {
	            // although ref creates actually a modifier descriptor, the type of the resultig properties
	            // of the object is `T` in the end, when the descriptors are interpreted
	            return createModifierDescriptor(shallowEnhancer, arguments[0]);
	        }
	        else {
	            return shallowDecorator.apply(null, arguments);
	        }
	    },
	    deep: function () {
	        if (arguments.length < 2) {
	            // although ref creates actually a modifier descriptor, the type of the resultig properties
	            // of the object is `T` in the end, when the descriptors are interpreted
	            return createModifierDescriptor(deepEnhancer, arguments[0]);
	        }
	        else {
	            return deepDecorator.apply(null, arguments);
	        }
	    },
	    struct: function () {
	        if (arguments.length < 2) {
	            // although ref creates actually a modifier descriptor, the type of the resultig properties
	            // of the object is `T` in the end, when the descriptors are interpreted
	            return createModifierDescriptor(deepStructEnhancer, arguments[0]);
	        }
	        else {
	            return deepStructDecorator.apply(null, arguments);
	        }
	    }
	};
	var observable = createObservable;
	// weird trick to keep our typings nicely with our funcs, and still extend the observable function
	Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
	observable.deep.struct = observable.struct;
	observable.ref.struct = function () {
	    if (arguments.length < 2) {
	        return createModifierDescriptor(refStructEnhancer, arguments[0]);
	    }
	    else {
	        return refStructDecorator.apply(null, arguments);
	    }
	};
	function incorrectlyUsedAsDecorator(methodName) {
	    fail("Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
	}
	
	function isModifierDescriptor(thing) {
	    return typeof thing === "object" && thing !== null && thing.isMobxModifierDescriptor === true;
	}
	function createModifierDescriptor(enhancer, initialValue) {
	    invariant(!isModifierDescriptor(initialValue), "Modifiers cannot be nested");
	    return {
	        isMobxModifierDescriptor: true,
	        initialValue: initialValue,
	        enhancer: enhancer
	    };
	}
	function deepEnhancer(v, _, name) {
	    if (isModifierDescriptor(v))
	        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
	    // it is an observable already, done
	    if (isObservable(v))
	        return v;
	    // something that can be converted and mutated?
	    if (Array.isArray(v))
	        return observable.array(v, name);
	    if (isPlainObject(v))
	        return observable.object(v, name);
	    if (isES6Map(v))
	        return observable.map(v, name);
	    return v;
	}
	function shallowEnhancer(v, _, name) {
	    if (isModifierDescriptor(v))
	        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
	    if (v === undefined || v === null)
	        return v;
	    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v))
	        return v;
	    if (Array.isArray(v))
	        return observable.shallowArray(v, name);
	    if (isPlainObject(v))
	        return observable.shallowObject(v, name);
	    if (isES6Map(v))
	        return observable.shallowMap(v, name);
	    return fail("The shallow modifier / decorator can only used in combination with arrays, objects and maps");
	}
	function referenceEnhancer(newValue) {
	    // never turn into an observable
	    return newValue;
	}
	function deepStructEnhancer(v, oldValue, name) {
	    // don't confuse structurally compare enhancer with ref enhancer! The latter is probably
	    // more suited for immutable objects
	    if (deepEqual(v, oldValue))
	        return oldValue;
	    // it is an observable already, done
	    if (isObservable(v))
	        return v;
	    // something that can be converted and mutated?
	    if (Array.isArray(v))
	        return new ObservableArray(v, deepStructEnhancer, name);
	    if (isES6Map(v))
	        return new ObservableMap(v, deepStructEnhancer, name);
	    if (isPlainObject(v)) {
	        var res = {};
	        asObservableObject(res, name);
	        extendObservableHelper(res, deepStructEnhancer, [v]);
	        return res;
	    }
	    return v;
	}
	function refStructEnhancer(v, oldValue, name) {
	    if (deepEqual(v, oldValue))
	        return oldValue;
	    return v;
	}
	
	/**
	 * During a transaction no views are updated until the end of the transaction.
	 * The transaction will be run synchronously nonetheless.
	 *
	 * @param action a function that updates some reactive state
	 * @returns any value that was returned by the 'action' parameter.
	 */
	function transaction(action, thisArg) {
	    if (thisArg === void 0) { thisArg = undefined; }
	    startBatch();
	    try {
	        return action.apply(thisArg);
	    }
	    finally {
	        endBatch();
	    }
	}
	
	var ObservableMapMarker = {};
	var ObservableMap = /** @class */ (function () {
	    function ObservableMap(initialData, enhancer, name) {
	        if (enhancer === void 0) { enhancer = deepEnhancer; }
	        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
	        this.enhancer = enhancer;
	        this.name = name;
	        this.$mobx = ObservableMapMarker;
	        this._data = Object.create(null);
	        this._hasMap = Object.create(null); // hasMap, not hashMap >-).
	        this._keys = new ObservableArray(undefined, referenceEnhancer, this.name + ".keys()", true);
	        this.interceptors = null;
	        this.changeListeners = null;
	        this.dehancer = undefined;
	        this.merge(initialData);
	    }
	    ObservableMap.prototype._has = function (key) {
	        return typeof this._data[key] !== "undefined";
	    };
	    ObservableMap.prototype.has = function (key) {
	        if (!this.isValidKey(key))
	            return false;
	        key = "" + key;
	        if (this._hasMap[key])
	            return this._hasMap[key].get();
	        return this._updateHasMapEntry(key, false).get();
	    };
	    ObservableMap.prototype.set = function (key, value) {
	        this.assertValidKey(key);
	        key = "" + key;
	        var hasKey = this._has(key);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: hasKey ? "update" : "add",
	                object: this,
	                newValue: value,
	                name: key
	            });
	            if (!change)
	                return this;
	            value = change.newValue;
	        }
	        if (hasKey) {
	            this._updateValue(key, value);
	        }
	        else {
	            this._addValue(key, value);
	        }
	        return this;
	    };
	    ObservableMap.prototype.delete = function (key) {
	        var _this = this;
	        this.assertValidKey(key);
	        key = "" + key;
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: "delete",
	                object: this,
	                name: key
	            });
	            if (!change)
	                return false;
	        }
	        if (this._has(key)) {
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "delete",
	                    object: this,
	                    oldValue: this._data[key].value,
	                    name: key
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart(change);
	            transaction(function () {
	                _this._keys.remove(key);
	                _this._updateHasMapEntry(key, false);
	                var observable$$1 = _this._data[key];
	                observable$$1.setNewValue(undefined);
	                _this._data[key] = undefined;
	            });
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy)
	                spyReportEnd();
	            return true;
	        }
	        return false;
	    };
	    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
	        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
	        var entry = this._hasMap[key];
	        if (entry) {
	            entry.setNewValue(value);
	        }
	        else {
	            entry = this._hasMap[key] = new ObservableValue(value, referenceEnhancer, this.name + "." + key + "?", false);
	        }
	        return entry;
	    };
	    ObservableMap.prototype._updateValue = function (name, newValue) {
	        var observable$$1 = this._data[name];
	        newValue = observable$$1.prepareNewValue(newValue);
	        if (newValue !== UNCHANGED) {
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "update",
	                    object: this,
	                    oldValue: observable$$1.value,
	                    name: name,
	                    newValue: newValue
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart(change);
	            observable$$1.setNewValue(newValue);
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy)
	                spyReportEnd();
	        }
	    };
	    ObservableMap.prototype._addValue = function (name, newValue) {
	        var _this = this;
	        transaction(function () {
	            var observable$$1 = (_this._data[name] = new ObservableValue(newValue, _this.enhancer, _this.name + "." + name, false));
	            newValue = observable$$1.value; // value might have been changed
	            _this._updateHasMapEntry(name, true);
	            _this._keys.push(name);
	        });
	        var notifySpy = isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                type: "add",
	                object: this,
	                name: name,
	                newValue: newValue
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(change);
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy)
	            spyReportEnd();
	    };
	    ObservableMap.prototype.get = function (key) {
	        key = "" + key;
	        if (this.has(key))
	            return this.dehanceValue(this._data[key].get());
	        return this.dehanceValue(undefined);
	    };
	    ObservableMap.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined) {
	            return this.dehancer(value);
	        }
	        return value;
	    };
	    ObservableMap.prototype.keys = function () {
	        return arrayAsIterator(this._keys.slice());
	    };
	    ObservableMap.prototype.values = function () {
	        return arrayAsIterator(this._keys.map(this.get, this));
	    };
	    ObservableMap.prototype.entries = function () {
	        var _this = this;
	        return arrayAsIterator(this._keys.map(function (key) { return [key, _this.get(key)]; }));
	    };
	    ObservableMap.prototype.forEach = function (callback, thisArg) {
	        var _this = this;
	        this.keys().forEach(function (key) { return callback.call(thisArg, _this.get(key), key, _this); });
	    };
	    /** Merge another object into this object, returns this. */
	    ObservableMap.prototype.merge = function (other) {
	        var _this = this;
	        if (isObservableMap(other)) {
	            other = other.toJS();
	        }
	        transaction(function () {
	            if (isPlainObject(other))
	                Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
	            else if (Array.isArray(other))
	                other.forEach(function (_a) {
	                    var key = _a[0], value = _a[1];
	                    return _this.set(key, value);
	                });
	            else if (isES6Map(other))
	                other.forEach(function (value, key) { return _this.set(key, value); });
	            else if (other !== null && other !== undefined)
	                fail("Cannot initialize map from " + other);
	        });
	        return this;
	    };
	    ObservableMap.prototype.clear = function () {
	        var _this = this;
	        transaction(function () {
	            untracked(function () {
	                _this.keys().forEach(_this.delete, _this);
	            });
	        });
	    };
	    ObservableMap.prototype.replace = function (values) {
	        var _this = this;
	        transaction(function () {
	            // grab all the keys that are present in the new map but not present in the current map
	            // and delete them from the map, then merge the new map
	            // this will cause reactions only on changed values
	            var newKeys = getMapLikeKeys(values);
	            var oldKeys = _this.keys();
	            var missingKeys = oldKeys.filter(function (k) { return newKeys.indexOf(k) === -1; });
	            missingKeys.forEach(function (k) { return _this.delete(k); });
	            _this.merge(values);
	        });
	        return this;
	    };
	    Object.defineProperty(ObservableMap.prototype, "size", {
	        get: function () {
	            return this._keys.length;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns a shallow non observable object clone of this map.
	     * Note that the values might still be observable. For a deep clone use mobx.toJS.
	     */
	    ObservableMap.prototype.toJS = function () {
	        var _this = this;
	        var res = {};
	        this.keys().forEach(function (key) { return (res[key] = _this.get(key)); });
	        return res;
	    };
	    ObservableMap.prototype.toJSON = function () {
	        // Used by JSON.stringify
	        return this.toJS();
	    };
	    ObservableMap.prototype.isValidKey = function (key) {
	        if (key === null || key === undefined)
	            return false;
	        if (typeof key === "string" || typeof key === "number" || typeof key === "boolean")
	            return true;
	        return false;
	    };
	    ObservableMap.prototype.assertValidKey = function (key) {
	        if (!this.isValidKey(key))
	            throw new Error("[mobx.map] Invalid key: '" + key + "', only strings, numbers and booleans are accepted as key in observable maps.");
	    };
	    ObservableMap.prototype.toString = function () {
	        var _this = this;
	        return (this.name +
	            "[{ " +
	            this.keys().map(function (key) { return key + ": " + ("" + _this.get(key)); }).join(", ") +
	            " }]");
	    };
	    /**
	     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
	     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
	     * for callback details
	     */
	    ObservableMap.prototype.observe = function (listener, fireImmediately) {
	        invariant(fireImmediately !== true, getMessage("m033"));
	        return registerListener(this, listener);
	    };
	    ObservableMap.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    return ObservableMap;
	}());
	declareIterator(ObservableMap.prototype, function () {
	    return this.entries();
	});
	function map(initialValues) {
	    deprecated("`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead");
	    return observable.map(initialValues);
	}
	/* 'var' fixes small-build issue */
	var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);
	
	var EMPTY_ARRAY = [];
	Object.freeze(EMPTY_ARRAY);
	function getGlobal() {
	    return typeof window !== "undefined" ? window : global;
	}
	function getNextId() {
	    return ++globalState.mobxGuid;
	}
	function fail(message, thing) {
	    invariant(false, message, thing);
	    throw "X"; // unreachable
	}
	function invariant(check, message, thing) {
	    if (!check)
	        throw new Error("[mobx] Invariant failed: " + message + (thing ? " in '" + thing + "'" : ""));
	}
	/**
	 * Prints a deprecation message, but only one time.
	 * Returns false if the deprecated message was already printed before
	 */
	var deprecatedMessages = [];
	function deprecated(msg) {
	    if (deprecatedMessages.indexOf(msg) !== -1)
	        return false;
	    deprecatedMessages.push(msg);
	    console.error("[mobx] Deprecated: " + msg);
	    return true;
	}
	/**
	 * Makes sure that the provided function is invoked at most once.
	 */
	function once(func) {
	    var invoked = false;
	    return function () {
	        if (invoked)
	            return;
	        invoked = true;
	        return func.apply(this, arguments);
	    };
	}
	var noop = function () { };
	function unique(list) {
	    var res = [];
	    list.forEach(function (item) {
	        if (res.indexOf(item) === -1)
	            res.push(item);
	    });
	    return res;
	}
	function joinStrings(things, limit, separator) {
	    if (limit === void 0) { limit = 100; }
	    if (separator === void 0) { separator = " - "; }
	    if (!things)
	        return "";
	    var sliced = things.slice(0, limit);
	    return "" + sliced.join(separator) + (things.length > limit
	        ? " (... and " + (things.length - limit) + "more)"
	        : "");
	}
	function isObject(value) {
	    return value !== null && typeof value === "object";
	}
	function isPlainObject(value) {
	    if (value === null || typeof value !== "object")
	        return false;
	    var proto = Object.getPrototypeOf(value);
	    return proto === Object.prototype || proto === null;
	}
	function objectAssign() {
	    var res = arguments[0];
	    for (var i = 1, l = arguments.length; i < l; i++) {
	        var source = arguments[i];
	        for (var key in source)
	            if (hasOwnProperty(source, key)) {
	                res[key] = source[key];
	            }
	    }
	    return res;
	}
	var prototypeHasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwnProperty(object, propName) {
	    return prototypeHasOwnProperty.call(object, propName);
	}
	function makeNonEnumerable(object, propNames) {
	    for (var i = 0; i < propNames.length; i++) {
	        addHiddenProp(object, propNames[i], object[propNames[i]]);
	    }
	}
	function addHiddenProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: true,
	        configurable: true,
	        value: value
	    });
	}
	function addHiddenFinalProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: false,
	        configurable: true,
	        value: value
	    });
	}
	function isPropertyConfigurable(object, prop) {
	    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
	    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
	}
	function assertPropertyConfigurable(object, prop) {
	    invariant(isPropertyConfigurable(object, prop), "Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
	}
	function createInstanceofPredicate(name, clazz) {
	    var propName = "isMobX" + name;
	    clazz.prototype[propName] = true;
	    return function (x) {
	        return isObject(x) && x[propName] === true;
	    };
	}
	function areBothNaN(a, b) {
	    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
	}
	/**
	 * Returns whether the argument is an array, disregarding observability.
	 */
	function isArrayLike(x) {
	    return Array.isArray(x) || isObservableArray(x);
	}
	function isES6Map(thing) {
	    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map)
	        return true;
	    return false;
	}
	function getMapLikeKeys(map$$1) {
	    if (isPlainObject(map$$1))
	        return Object.keys(map$$1);
	    if (Array.isArray(map$$1))
	        return map$$1.map(function (_a) {
	            var key = _a[0];
	            return key;
	        });
	    if (isES6Map(map$$1))
	        return Array.from(map$$1.keys());
	    if (isObservableMap(map$$1))
	        return map$$1.keys();
	    return fail("Cannot get keys from " + map$$1);
	}
	function iteratorToArray(it) {
	    var res = [];
	    while (true) {
	        var r = it.next();
	        if (r.done)
	            break;
	        res.push(r.value);
	    }
	    return res;
	}
	function primitiveSymbol() {
	    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
	}
	function toPrimitive(value) {
	    return value === null ? null : typeof value === "object" ? "" + value : value;
	}
	
	/**
	 * These values will persist if global state is reset
	 */
	var persistentKeys = ["mobxGuid", "resetId", "spyListeners", "strictMode", "runId"];
	var MobXGlobals = /** @class */ (function () {
	    function MobXGlobals() {
	        /**
	         * MobXGlobals version.
	         * MobX compatiblity with other versions loaded in memory as long as this version matches.
	         * It indicates that the global state still stores similar information
	         */
	        this.version = 5;
	        /**
	         * Currently running derivation
	         */
	        this.trackingDerivation = null;
	        /**
	         * Are we running a computation currently? (not a reaction)
	         */
	        this.computationDepth = 0;
	        /**
	         * Each time a derivation is tracked, it is assigned a unique run-id
	         */
	        this.runId = 0;
	        /**
	         * 'guid' for general purpose. Will be persisted amongst resets.
	         */
	        this.mobxGuid = 0;
	        /**
	         * Are we in a batch block? (and how many of them)
	         */
	        this.inBatch = 0;
	        /**
	         * Observables that don't have observers anymore, and are about to be
	         * suspended, unless somebody else accesses it in the same batch
	         *
	         * @type {IObservable[]}
	         */
	        this.pendingUnobservations = [];
	        /**
	         * List of scheduled, not yet executed, reactions.
	         */
	        this.pendingReactions = [];
	        /**
	         * Are we currently processing reactions?
	         */
	        this.isRunningReactions = false;
	        /**
	         * Is it allowed to change observables at this point?
	         * In general, MobX doesn't allow that when running computations and React.render.
	         * To ensure that those functions stay pure.
	         */
	        this.allowStateChanges = true;
	        /**
	         * If strict mode is enabled, state changes are by default not allowed
	         */
	        this.strictMode = false;
	        /**
	         * Used by createTransformer to detect that the global state has been reset.
	         */
	        this.resetId = 0;
	        /**
	         * Spy callbacks
	         */
	        this.spyListeners = [];
	        /**
	         * Globally attached error handlers that react specifically to errors in reactions
	         */
	        this.globalReactionErrorHandlers = [];
	    }
	    return MobXGlobals;
	}());
	var globalState = new MobXGlobals();
	var shareGlobalStateCalled = false;
	var runInIsolationCalled = false;
	var warnedAboutMultipleInstances = false;
	{
	    var global_1 = getGlobal();
	    if (!global_1.__mobxInstanceCount) {
	        global_1.__mobxInstanceCount = 1;
	    }
	    else {
	        global_1.__mobxInstanceCount++;
	        setTimeout(function () {
	            if (!shareGlobalStateCalled && !runInIsolationCalled && !warnedAboutMultipleInstances) {
	                warnedAboutMultipleInstances = true;
	                console.warn("[mobx] Warning: there are multiple mobx instances active. This might lead to unexpected results. See https://github.com/mobxjs/mobx/issues/1082 for details.");
	            }
	        }, 1);
	    }
	}
	function isolateGlobalState() {
	    runInIsolationCalled = true;
	    getGlobal().__mobxInstanceCount--;
	}
	function shareGlobalState() {
	    // TODO: remove in 4.0; just use peer dependencies instead.
	    deprecated("Using `shareGlobalState` is not recommended, use peer dependencies instead. See https://github.com/mobxjs/mobx/issues/1082 for details.");
	    shareGlobalStateCalled = true;
	    var global = getGlobal();
	    var ownState = globalState;
	    /**
	     * Backward compatibility check
	     */
	    if (global.__mobservableTrackingStack || global.__mobservableViewStack)
	        throw new Error("[mobx] An incompatible version of mobservable is already loaded.");
	    if (global.__mobxGlobal && global.__mobxGlobal.version !== ownState.version)
	        throw new Error("[mobx] An incompatible version of mobx is already loaded.");
	    if (global.__mobxGlobal)
	        globalState = global.__mobxGlobal;
	    else
	        global.__mobxGlobal = ownState;
	}
	function getGlobalState() {
	    return globalState;
	}
	
	/**
	 * For testing purposes only; this will break the internal state of existing observables,
	 * but can be used to get back at a stable state after throwing errors
	 */
	function resetGlobalState() {
	    globalState.resetId++;
	    var defaultGlobals = new MobXGlobals();
	    for (var key in defaultGlobals)
	        if (persistentKeys.indexOf(key) === -1)
	            globalState[key] = defaultGlobals[key];
	    globalState.allowStateChanges = !globalState.strictMode;
	}
	
	function getAtom(thing, property) {
	    if (typeof thing === "object" && thing !== null) {
	        if (isObservableArray(thing)) {
	            invariant(property === undefined, getMessage("m036"));
	            return thing.$mobx.atom;
	        }
	        if (isObservableMap(thing)) {
	            var anyThing = thing;
	            if (property === undefined)
	                return getAtom(anyThing._keys);
	            var observable = anyThing._data[property] || anyThing._hasMap[property];
	            invariant(!!observable, "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
	            return observable;
	        }
	        // Initializers run lazily when transpiling to babel, so make sure they are run...
	        runLazyInitializers(thing);
	        if (property && !thing.$mobx)
	            thing[property]; // See #1072 // TODO: remove in 4.0
	        if (isObservableObject(thing)) {
	            if (!property)
	                return fail("please specify a property");
	            var observable = thing.$mobx.values[property];
	            invariant(!!observable, "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
	            return observable;
	        }
	        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
	            return thing;
	        }
	    }
	    else if (typeof thing === "function") {
	        if (isReaction(thing.$mobx)) {
	            // disposer function
	            return thing.$mobx;
	        }
	    }
	    return fail("Cannot obtain atom from " + thing);
	}
	function getAdministration(thing, property) {
	    invariant(thing, "Expecting some object");
	    if (property !== undefined)
	        return getAdministration(getAtom(thing, property));
	    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
	        return thing;
	    if (isObservableMap(thing))
	        return thing;
	    // Initializers run lazily when transpiling to babel, so make sure they are run...
	    runLazyInitializers(thing);
	    if (thing.$mobx)
	        return thing.$mobx;
	    invariant(false, "Cannot obtain administration from " + thing);
	}
	function getDebugName(thing, property) {
	    var named;
	    if (property !== undefined)
	        named = getAtom(thing, property);
	    else if (isObservableObject(thing) || isObservableMap(thing))
	        named = getAdministration(thing);
	    else
	        named = getAtom(thing); // valid for arrays as well
	    return named.name;
	}
	
	function getDependencyTree(thing, property) {
	    return nodeToDependencyTree(getAtom(thing, property));
	}
	function nodeToDependencyTree(node) {
	    var result = {
	        name: node.name
	    };
	    if (node.observing && node.observing.length > 0)
	        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
	    return result;
	}
	function getObserverTree(thing, property) {
	    return nodeToObserverTree(getAtom(thing, property));
	}
	function nodeToObserverTree(node) {
	    var result = {
	        name: node.name
	    };
	    if (hasObservers(node))
	        result.observers = getObservers(node).map(nodeToObserverTree);
	    return result;
	}
	
	function hasObservers(observable) {
	    return observable.observers && observable.observers.length > 0;
	}
	function getObservers(observable) {
	    return observable.observers;
	}
	function addObserver(observable, node) {
	    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
	    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
	    // invariantObservers(observable);
	    var l = observable.observers.length;
	    if (l) {
	        // because object assignment is relatively expensive, let's not store data about index 0.
	        observable.observersIndexes[node.__mapid] = l;
	    }
	    observable.observers[l] = node;
	    if (observable.lowestObserverState > node.dependenciesState)
	        observable.lowestObserverState = node.dependenciesState;
	    // invariantObservers(observable);
	    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
	}
	function removeObserver(observable, node) {
	    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
	    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
	    // invariantObservers(observable);
	    if (observable.observers.length === 1) {
	        // deleting last observer
	        observable.observers.length = 0;
	        queueForUnobservation(observable);
	    }
	    else {
	        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
	        var list = observable.observers;
	        var map = observable.observersIndexes;
	        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
	        if (filler !== node) {
	            // otherwise node was the last element, which already got removed from array
	            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
	            if (index) {
	                // map store all indexes but 0, see comment in `addObserver`
	                map[filler.__mapid] = index;
	            }
	            else {
	                delete map[filler.__mapid];
	            }
	            list[index] = filler;
	        }
	        delete map[node.__mapid];
	    }
	    // invariantObservers(observable);
	    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
	}
	function queueForUnobservation(observable) {
	    if (!observable.isPendingUnobservation) {
	        // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
	        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
	        observable.isPendingUnobservation = true;
	        globalState.pendingUnobservations.push(observable);
	    }
	}
	/**
	 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
	 * During a batch `onBecomeUnobserved` will be called at most once per observable.
	 * Avoids unnecessary recalculations.
	 */
	function startBatch() {
	    globalState.inBatch++;
	}
	function endBatch() {
	    if (--globalState.inBatch === 0) {
	        runReactions();
	        // the batch is actually about to finish, all unobserving should happen here.
	        var list = globalState.pendingUnobservations;
	        for (var i = 0; i < list.length; i++) {
	            var observable = list[i];
	            observable.isPendingUnobservation = false;
	            if (observable.observers.length === 0) {
	                observable.onBecomeUnobserved();
	                // NOTE: onBecomeUnobserved might push to `pendingUnobservations`
	            }
	        }
	        globalState.pendingUnobservations = [];
	    }
	}
	function reportObserved(observable) {
	    var derivation = globalState.trackingDerivation;
	    if (derivation !== null) {
	        /**
	         * Simple optimization, give each derivation run an unique id (runId)
	         * Check if last time this observable was accessed the same runId is used
	         * if this is the case, the relation is already known
	         */
	        if (derivation.runId !== observable.lastAccessedBy) {
	            observable.lastAccessedBy = derivation.runId;
	            derivation.newObserving[derivation.unboundDepsCount++] = observable;
	        }
	    }
	    else if (observable.observers.length === 0) {
	        queueForUnobservation(observable);
	    }
	}
	/**
	 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
	 * It will propagate changes to observers from previous run
	 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
	 * Hopefully self reruning autoruns aren't a feature people should depend on
	 * Also most basic use cases should be ok
	 */
	// Called by Atom when its value changes
	function propagateChanged(observable) {
	    // invariantLOS(observable, "changed start");
	    if (observable.lowestObserverState === exports.IDerivationState.STALE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE) {
	            if (d.isTracing !== TraceMode.NONE) {
	                logTraceInfo(d, observable);
	            }
	            d.onBecomeStale();
	        }
	        d.dependenciesState = exports.IDerivationState.STALE;
	    }
	    // invariantLOS(observable, "changed end");
	}
	// Called by ComputedValue when it recalculate and its value changed
	function propagateChangeConfirmed(observable) {
	    // invariantLOS(observable, "confirmed start");
	    if (observable.lowestObserverState === exports.IDerivationState.STALE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.POSSIBLY_STALE)
	            d.dependenciesState = exports.IDerivationState.STALE;
	        else if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
	        )
	            observable.lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	    }
	    // invariantLOS(observable, "confirmed end");
	}
	// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
	function propagateMaybeChanged(observable) {
	    // invariantLOS(observable, "maybe start");
	    if (observable.lowestObserverState !== exports.IDerivationState.UP_TO_DATE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.POSSIBLY_STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE) {
	            d.dependenciesState = exports.IDerivationState.POSSIBLY_STALE;
	            if (d.isTracing !== TraceMode.NONE) {
	                logTraceInfo(d, observable);
	            }
	            d.onBecomeStale();
	        }
	    }
	    // invariantLOS(observable, "maybe end");
	}
	function logTraceInfo(derivation, observable) {
	    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
	    if (derivation.isTracing === TraceMode.BREAK) {
	        var lines = [];
	        printDepTree(getDependencyTree(derivation), lines, 1);
	        // prettier-ignore
	        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString() : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
	    }
	}
	function printDepTree(tree, lines, depth) {
	    if (lines.length >= 1000) {
	        lines.push("(and many more)");
	        return;
	    }
	    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
	    if (tree.dependencies)
	        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
	}
	
	(function (IDerivationState) {
	    // before being run or (outside batch and not being observed)
	    // at this point derivation is not holding any data about dependency tree
	    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
	    // no shallow dependency changed since last computation
	    // won't recalculate derivation
	    // this is what makes mobx fast
	    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
	    // some deep dependency changed, but don't know if shallow dependency changed
	    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
	    // currently only ComputedValue will propagate POSSIBLY_STALE
	    //
	    // having this state is second big optimization:
	    // don't have to recompute on every dependency change, but only when it's needed
	    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
	    // A shallow dependency has changed since last computation and the derivation
	    // will need to recompute when it's needed next.
	    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
	})(exports.IDerivationState || (exports.IDerivationState = {}));
	var TraceMode;
	(function (TraceMode) {
	    TraceMode[TraceMode["NONE"] = 0] = "NONE";
	    TraceMode[TraceMode["LOG"] = 1] = "LOG";
	    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
	})(TraceMode || (TraceMode = {}));
	var CaughtException = /** @class */ (function () {
	    function CaughtException(cause) {
	        this.cause = cause;
	        // Empty
	    }
	    return CaughtException;
	}());
	function isCaughtException(e) {
	    return e instanceof CaughtException;
	}
	/**
	 * Finds out whether any dependency of the derivation has actually changed.
	 * If dependenciesState is 1 then it will recalculate dependencies,
	 * if any dependency changed it will propagate it by changing dependenciesState to 2.
	 *
	 * By iterating over the dependencies in the same order that they were reported and
	 * stopping on the first change, all the recalculations are only called for ComputedValues
	 * that will be tracked by derivation. That is because we assume that if the first x
	 * dependencies of the derivation doesn't change then the derivation should run the same way
	 * up until accessing x-th dependency.
	 */
	function shouldCompute(derivation) {
	    switch (derivation.dependenciesState) {
	        case exports.IDerivationState.UP_TO_DATE:
	            return false;
	        case exports.IDerivationState.NOT_TRACKING:
	        case exports.IDerivationState.STALE:
	            return true;
	        case exports.IDerivationState.POSSIBLY_STALE: {
	            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
	            var obs = derivation.observing, l = obs.length;
	            for (var i = 0; i < l; i++) {
	                var obj = obs[i];
	                if (isComputedValue(obj)) {
	                    try {
	                        obj.get();
	                    }
	                    catch (e) {
	                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
	                        untrackedEnd(prevUntracked);
	                        return true;
	                    }
	                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
	                    // and `derivation` is an observer of `obj`
	                    if (derivation.dependenciesState === exports.IDerivationState.STALE) {
	                        untrackedEnd(prevUntracked);
	                        return true;
	                    }
	                }
	            }
	            changeDependenciesStateTo0(derivation);
	            untrackedEnd(prevUntracked);
	            return false;
	        }
	    }
	}
	function isComputingDerivation() {
	    return globalState.trackingDerivation !== null; // filter out actions inside computations
	}
	function checkIfStateModificationsAreAllowed(atom) {
	    var hasObservers$$1 = atom.observers.length > 0;
	    // Should never be possible to change an observed observable from inside computed, see #798
	    if (globalState.computationDepth > 0 && hasObservers$$1)
	        fail(getMessage("m031") + atom.name);
	    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
	    if (!globalState.allowStateChanges && hasObservers$$1)
	        fail(getMessage(globalState.strictMode ? "m030a" : "m030b") + atom.name);
	}
	/**
	 * Executes the provided function `f` and tracks which observables are being accessed.
	 * The tracking information is stored on the `derivation` object and the derivation is registered
	 * as observer of any of the accessed observables.
	 */
	function trackDerivedFunction(derivation, f, context) {
	    // pre allocate array allocation + room for variation in deps
	    // array will be trimmed by bindDependencies
	    changeDependenciesStateTo0(derivation);
	    derivation.newObserving = new Array(derivation.observing.length + 100);
	    derivation.unboundDepsCount = 0;
	    derivation.runId = ++globalState.runId;
	    var prevTracking = globalState.trackingDerivation;
	    globalState.trackingDerivation = derivation;
	    var result;
	    try {
	        result = f.call(context);
	    }
	    catch (e) {
	        result = new CaughtException(e);
	    }
	    globalState.trackingDerivation = prevTracking;
	    bindDependencies(derivation);
	    return result;
	}
	/**
	 * diffs newObserving with observing.
	 * update observing to be newObserving with unique observables
	 * notify observers that become observed/unobserved
	 */
	function bindDependencies(derivation) {
	    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
	    var prevObserving = derivation.observing;
	    var observing = (derivation.observing = derivation.newObserving);
	    var lowestNewObservingDerivationState = exports.IDerivationState.UP_TO_DATE;
	    // Go through all new observables and check diffValue: (this list can contain duplicates):
	    //   0: first occurrence, change to 1 and keep it
	    //   1: extra occurrence, drop it
	    var i0 = 0, l = derivation.unboundDepsCount;
	    for (var i = 0; i < l; i++) {
	        var dep = observing[i];
	        if (dep.diffValue === 0) {
	            dep.diffValue = 1;
	            if (i0 !== i)
	                observing[i0] = dep;
	            i0++;
	        }
	        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
	        // not hitting the condition
	        if (dep.dependenciesState > lowestNewObservingDerivationState) {
	            lowestNewObservingDerivationState = dep.dependenciesState;
	        }
	    }
	    observing.length = i0;
	    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
	    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
	    //   0: it's not in new observables, unobserve it
	    //   1: it keeps being observed, don't want to notify it. change to 0
	    l = prevObserving.length;
	    while (l--) {
	        var dep = prevObserving[l];
	        if (dep.diffValue === 0) {
	            removeObserver(dep, derivation);
	        }
	        dep.diffValue = 0;
	    }
	    // Go through all new observables and check diffValue: (now it should be unique)
	    //   0: it was set to 0 in last loop. don't need to do anything.
	    //   1: it wasn't observed, let's observe it. set back to 0
	    while (i0--) {
	        var dep = observing[i0];
	        if (dep.diffValue === 1) {
	            dep.diffValue = 0;
	            addObserver(dep, derivation);
	        }
	    }
	    // Some new observed derivations may become stale during this derivation computation
	    // so they have had no chance to propagate staleness (#916)
	    if (lowestNewObservingDerivationState !== exports.IDerivationState.UP_TO_DATE) {
	        derivation.dependenciesState = lowestNewObservingDerivationState;
	        derivation.onBecomeStale();
	    }
	}
	function clearObserving(derivation) {
	    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
	    var obs = derivation.observing;
	    derivation.observing = [];
	    var i = obs.length;
	    while (i--)
	        removeObserver(obs[i], derivation);
	    derivation.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	}
	function untracked(action) {
	    var prev = untrackedStart();
	    var res = action();
	    untrackedEnd(prev);
	    return res;
	}
	function untrackedStart() {
	    var prev = globalState.trackingDerivation;
	    globalState.trackingDerivation = null;
	    return prev;
	}
	function untrackedEnd(prev) {
	    globalState.trackingDerivation = prev;
	}
	/**
	 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
	 *
	 */
	function changeDependenciesStateTo0(derivation) {
	    if (derivation.dependenciesState === exports.IDerivationState.UP_TO_DATE)
	        return;
	    derivation.dependenciesState = exports.IDerivationState.UP_TO_DATE;
	    var obs = derivation.observing;
	    var i = obs.length;
	    while (i--)
	        obs[i].lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	}
	
	function log(msg) {
	    console.log(msg);
	    return msg;
	}
	function whyRun(thing, prop) {
	    deprecated("`whyRun` is deprecated in favor of `trace`");
	    thing = getAtomFromArgs(arguments);
	    if (!thing)
	        return log(getMessage("m024"));
	    if (isComputedValue(thing) || isReaction(thing))
	        return log(thing.whyRun());
	    return fail(getMessage("m025"));
	}
	function trace() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var enterBreakPoint = false;
	    if (typeof args[args.length - 1] === "boolean")
	        enterBreakPoint = args.pop();
	    var derivation = getAtomFromArgs(args);
	    if (!derivation) {
	        return fail("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
	    }
	    if (derivation.isTracing === TraceMode.NONE) {
	        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
	    }
	    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
	}
	function getAtomFromArgs(args) {
	    switch (args.length) {
	        case 0:
	            return globalState.trackingDerivation;
	        case 1:
	            return getAtom(args[0]);
	        case 2:
	            return getAtom(args[0], args[1]);
	    }
	}
	
	var Reaction = /** @class */ (function () {
	    function Reaction(name, onInvalidate) {
	        if (name === void 0) { name = "Reaction@" + getNextId(); }
	        this.name = name;
	        this.onInvalidate = onInvalidate;
	        this.observing = []; // nodes we are looking at. Our value depends on these nodes
	        this.newObserving = [];
	        this.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	        this.diffValue = 0;
	        this.runId = 0;
	        this.unboundDepsCount = 0;
	        this.__mapid = "#" + getNextId();
	        this.isDisposed = false;
	        this._isScheduled = false;
	        this._isTrackPending = false;
	        this._isRunning = false;
	        this.isTracing = TraceMode.NONE;
	    }
	    Reaction.prototype.onBecomeStale = function () {
	        this.schedule();
	    };
	    Reaction.prototype.schedule = function () {
	        if (!this._isScheduled) {
	            this._isScheduled = true;
	            globalState.pendingReactions.push(this);
	            runReactions();
	        }
	    };
	    Reaction.prototype.isScheduled = function () {
	        return this._isScheduled;
	    };
	    /**
	     * internal, use schedule() if you intend to kick off a reaction
	     */
	    Reaction.prototype.runReaction = function () {
	        if (!this.isDisposed) {
	            startBatch();
	            this._isScheduled = false;
	            if (shouldCompute(this)) {
	                this._isTrackPending = true;
	                this.onInvalidate();
	                if (this._isTrackPending && isSpyEnabled()) {
	                    // onInvalidate didn't trigger track right away..
	                    spyReport({
	                        object: this,
	                        type: "scheduled-reaction"
	                    });
	                }
	            }
	            endBatch();
	        }
	    };
	    Reaction.prototype.track = function (fn) {
	        startBatch();
	        var notify = isSpyEnabled();
	        var startTime;
	        if (notify) {
	            startTime = Date.now();
	            spyReportStart({
	                object: this,
	                type: "reaction",
	                fn: fn
	            });
	        }
	        this._isRunning = true;
	        var result = trackDerivedFunction(this, fn, undefined);
	        this._isRunning = false;
	        this._isTrackPending = false;
	        if (this.isDisposed) {
	            // disposed during last run. Clean up everything that was bound after the dispose call.
	            clearObserving(this);
	        }
	        if (isCaughtException(result))
	            this.reportExceptionInDerivation(result.cause);
	        if (notify) {
	            spyReportEnd({
	                time: Date.now() - startTime
	            });
	        }
	        endBatch();
	    };
	    Reaction.prototype.reportExceptionInDerivation = function (error) {
	        var _this = this;
	        if (this.errorHandler) {
	            this.errorHandler(error, this);
	            return;
	        }
	        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this;
	        var messageToUser = getMessage("m037");
	        console.error(message || messageToUser /* latter will not be true, make sure uglify doesn't remove */, error);
	        /** If debugging brought you here, please, read the above message :-). Tnx! */
	        if (isSpyEnabled()) {
	            spyReport({
	                type: "error",
	                message: message,
	                error: error,
	                object: this
	            });
	        }
	        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
	    };
	    Reaction.prototype.dispose = function () {
	        if (!this.isDisposed) {
	            this.isDisposed = true;
	            if (!this._isRunning) {
	                // if disposed while running, clean up later. Maybe not optimal, but rare case
	                startBatch();
	                clearObserving(this);
	                endBatch();
	            }
	        }
	    };
	    Reaction.prototype.getDisposer = function () {
	        var r = this.dispose.bind(this);
	        r.$mobx = this;
	        r.onError = registerErrorHandler;
	        return r;
	    };
	    Reaction.prototype.toString = function () {
	        return "Reaction[" + this.name + "]";
	    };
	    Reaction.prototype.whyRun = function () {
	        var observing = unique(this._isRunning ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
	        return "\nWhyRun? reaction '" + this.name + "':\n * Status: [" + (this.isDisposed
	            ? "stopped"
	            : this._isRunning ? "running" : this.isScheduled() ? "scheduled" : "idle") + "]\n * This reaction will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this._isRunning
	            ? " (... or any observable accessed during the remainder of the current run)"
	            : "") + "\n\t" + getMessage("m038") + "\n";
	    };
	    Reaction.prototype.trace = function (enterBreakPoint) {
	        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
	        trace(this, enterBreakPoint);
	    };
	    return Reaction;
	}());
	function registerErrorHandler(handler) {
	    invariant(this && this.$mobx && isReaction(this.$mobx), "Invalid `this`");
	    invariant(!this.$mobx.errorHandler, "Only one onErrorHandler can be registered");
	    this.$mobx.errorHandler = handler;
	}
	function onReactionError(handler) {
	    globalState.globalReactionErrorHandlers.push(handler);
	    return function () {
	        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
	        if (idx >= 0)
	            globalState.globalReactionErrorHandlers.splice(idx, 1);
	    };
	}
	/**
	 * Magic number alert!
	 * Defines within how many times a reaction is allowed to re-trigger itself
	 * until it is assumed that this is gonna be a never ending loop...
	 */
	var MAX_REACTION_ITERATIONS = 100;
	var reactionScheduler = function (f) { return f(); };
	function runReactions() {
	    // Trampolining, if runReactions are already running, new reactions will be picked up
	    if (globalState.inBatch > 0 || globalState.isRunningReactions)
	        return;
	    reactionScheduler(runReactionsHelper);
	}
	function runReactionsHelper() {
	    globalState.isRunningReactions = true;
	    var allReactions = globalState.pendingReactions;
	    var iterations = 0;
	    // While running reactions, new reactions might be triggered.
	    // Hence we work with two variables and check whether
	    // we converge to no remaining reactions after a while.
	    while (allReactions.length > 0) {
	        if (++iterations === MAX_REACTION_ITERATIONS) {
	            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
	                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
	            allReactions.splice(0); // clear reactions
	        }
	        var remainingReactions = allReactions.splice(0);
	        for (var i = 0, l = remainingReactions.length; i < l; i++)
	            remainingReactions[i].runReaction();
	    }
	    globalState.isRunningReactions = false;
	}
	var isReaction = createInstanceofPredicate("Reaction", Reaction);
	function setReactionScheduler(fn) {
	    var baseScheduler = reactionScheduler;
	    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
	}
	
	function asReference(value) {
	    deprecated("asReference is deprecated, use observable.ref instead");
	    return observable.ref(value);
	}
	function asStructure(value) {
	    deprecated("asStructure is deprecated. Use observable.struct, computed.struct or reaction options instead.");
	    return observable.struct(value);
	}
	function asFlat(value) {
	    deprecated("asFlat is deprecated, use observable.shallow instead");
	    return observable.shallow(value);
	}
	function asMap(data) {
	    deprecated("asMap is deprecated, use observable.map or observable.shallowMap instead");
	    return observable.map(data || {});
	}
	
	function createComputedDecorator(equals) {
	    return createClassPropertyDecorator(function (target, name, _, __, originalDescriptor) {
	        invariant(typeof originalDescriptor !== "undefined", getMessage("m009"));
	        invariant(typeof originalDescriptor.get === "function", getMessage("m010"));
	        var adm = asObservableObject(target, "");
	        defineComputedProperty(adm, name, originalDescriptor.get, originalDescriptor.set, equals, false);
	    }, function (name) {
	        var observable = this.$mobx.values[name];
	        if (observable === undefined // See #505
	        )
	            return undefined;
	        return observable.get();
	    }, function (name, value) {
	        this.$mobx.values[name].set(value);
	    }, false, false);
	}
	var computedDecorator = createComputedDecorator(comparer.default);
	var computedStructDecorator = createComputedDecorator(comparer.structural);
	/**
	 * Decorator for class properties: @computed get value() { return expr; }.
	 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
	 */
	var computed = function computed(arg1, arg2, arg3) {
	    if (typeof arg2 === "string") {
	        return computedDecorator.apply(null, arguments);
	    }
	    invariant(typeof arg1 === "function", getMessage("m011"));
	    invariant(arguments.length < 3, getMessage("m012"));
	    var opts = typeof arg2 === "object" ? arg2 : {};
	    opts.setter = typeof arg2 === "function" ? arg2 : opts.setter;
	    var equals = opts.equals
	        ? opts.equals
	        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
	    return new ComputedValue(arg1, opts.context, equals, opts.name || arg1.name || "", opts.setter);
	};
	computed.struct = computedStructDecorator;
	computed.equals = createComputedDecorator;
	
	function isComputed(value, property) {
	    if (value === null || value === undefined)
	        return false;
	    if (property !== undefined) {
	        if (isObservableObject(value) === false)
	            return false;
	        if (!value.$mobx.values[property])
	            return false;
	        var atom = getAtom(value, property);
	        return isComputedValue(atom);
	    }
	    return isComputedValue(value);
	}
	
	function observe(thing, propOrCb, cbOrFire, fireImmediately) {
	    if (typeof cbOrFire === "function")
	        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
	    else
	        return observeObservable(thing, propOrCb, cbOrFire);
	}
	function observeObservable(thing, listener, fireImmediately) {
	    return getAdministration(thing).observe(listener, fireImmediately);
	}
	function observeObservableProperty(thing, property, listener, fireImmediately) {
	    return getAdministration(thing, property).observe(listener, fireImmediately);
	}
	
	function intercept(thing, propOrHandler, handler) {
	    if (typeof handler === "function")
	        return interceptProperty(thing, propOrHandler, handler);
	    else
	        return interceptInterceptable(thing, propOrHandler);
	}
	function interceptInterceptable(thing, handler) {
	    return getAdministration(thing).intercept(handler);
	}
	function interceptProperty(thing, property, handler) {
	    return getAdministration(thing, property).intercept(handler);
	}
	
	/**
	 * expr can be used to create temporarily views inside views.
	 * This can be improved to improve performance if a value changes often, but usually doesn't affect the outcome of an expression.
	 *
	 * In the following example the expression prevents that a component is rerender _each time_ the selection changes;
	 * instead it will only rerenders when the current todo is (de)selected.
	 *
	 * reactiveComponent((props) => {
	 *     const todo = props.todo;
	 *     const isSelected = mobx.expr(() => props.viewState.selection === todo);
	 *     return <div className={isSelected ? "todo todo-selected" : "todo"}>{todo.title}</div>
	 * });
	 *
	 */
	function expr(expr, scope) {
	    if (!isComputingDerivation())
	        console.warn(getMessage("m013"));
	    // optimization: would be more efficient if the expr itself wouldn't be evaluated first on the next change, but just a 'changed' signal would be fired
	    return computed(expr, { context: scope }).get();
	}
	
	function toJS(source, detectCycles, __alreadySeen) {
	    if (detectCycles === void 0) { detectCycles = true; }
	    if (__alreadySeen === void 0) { __alreadySeen = []; }
	    // optimization: using ES6 map would be more efficient!
	    // optimization: lift this function outside toJS, this makes recursion expensive
	    function cache(value) {
	        if (detectCycles)
	            __alreadySeen.push([source, value]);
	        return value;
	    }
	    if (isObservable(source)) {
	        if (detectCycles && __alreadySeen === null)
	            __alreadySeen = [];
	        if (detectCycles && source !== null && typeof source === "object") {
	            for (var i = 0, l = __alreadySeen.length; i < l; i++)
	                if (__alreadySeen[i][0] === source)
	                    return __alreadySeen[i][1];
	        }
	        if (isObservableArray(source)) {
	            var res = cache([]);
	            var toAdd = source.map(function (value) { return toJS(value, detectCycles, __alreadySeen); });
	            res.length = toAdd.length;
	            for (var i = 0, l = toAdd.length; i < l; i++)
	                res[i] = toAdd[i];
	            return res;
	        }
	        if (isObservableObject(source)) {
	            var res = cache({});
	            for (var key in source)
	                res[key] = toJS(source[key], detectCycles, __alreadySeen);
	            return res;
	        }
	        if (isObservableMap(source)) {
	            var res_1 = cache({});
	            source.forEach(function (value, key) { return (res_1[key] = toJS(value, detectCycles, __alreadySeen)); });
	            return res_1;
	        }
	        if (isObservableValue(source))
	            return toJS(source.get(), detectCycles, __alreadySeen);
	    }
	    return source;
	}
	
	function createTransformer(transformer, onCleanup) {
	    invariant(typeof transformer === "function" && transformer.length < 2, "createTransformer expects a function that accepts one argument");
	    // Memoizes: object id -> reactive view that applies transformer to the object
	    var objectCache = {};
	    // If the resetId changes, we will clear the object cache, see #163
	    // This construction is used to avoid leaking refs to the objectCache directly
	    var resetId = globalState.resetId;
	    // Local transformer class specifically for this transformer
	    var Transformer = /** @class */ (function (_super) {
	        __extends(Transformer, _super);
	        function Transformer(sourceIdentifier, sourceObject) {
	            var _this = _super.call(this, function () { return transformer(sourceObject); }, undefined, comparer.default, "Transformer-" + transformer.name + "-" + sourceIdentifier, undefined) || this;
	            _this.sourceIdentifier = sourceIdentifier;
	            _this.sourceObject = sourceObject;
	            return _this;
	        }
	        Transformer.prototype.onBecomeUnobserved = function () {
	            var lastValue = this.value;
	            _super.prototype.onBecomeUnobserved.call(this);
	            delete objectCache[this.sourceIdentifier];
	            if (onCleanup)
	                onCleanup(lastValue, this.sourceObject);
	        };
	        return Transformer;
	    }(ComputedValue));
	    return function (object) {
	        if (resetId !== globalState.resetId) {
	            objectCache = {};
	            resetId = globalState.resetId;
	        }
	        var identifier = getMemoizationId(object);
	        var reactiveTransformer = objectCache[identifier];
	        if (reactiveTransformer)
	            return reactiveTransformer.get();
	        // Not in cache; create a reactive view
	        reactiveTransformer = objectCache[identifier] = new Transformer(identifier, object);
	        return reactiveTransformer.get();
	    };
	}
	function getMemoizationId(object) {
	    if (typeof object === "string" || typeof object === "number")
	        return object;
	    if (object === null || typeof object !== "object")
	        throw new Error("[mobx] transform expected some kind of object or primitive value, got: " + object);
	    var tid = object.$transformId;
	    if (tid === undefined) {
	        tid = getNextId();
	        addHiddenProp(object, "$transformId", tid);
	    }
	    return tid;
	}
	
	function interceptReads(thing, propOrHandler, handler) {
	    var target;
	    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
	        target = getAdministration(thing);
	    }
	    else if (isObservableObject(thing)) {
	        if (typeof propOrHandler !== "string")
	            return fail("InterceptReads can only be used with a specific property, not with an object in general");
	        target = getAdministration(thing, propOrHandler);
	    }
	    else {
	        return fail("Expected observable map, object or array as first array");
	    }
	    if (target.dehancer !== undefined)
	        return fail("An intercept reader was already established");
	    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
	    return function () {
	        target.dehancer = undefined;
	    };
	}
	
	/**
	 * (c) Michel Weststrate 2015 - 2016
	 * MIT Licensed
	 *
	 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
	 * this is a good place to start:
	 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
	 *
	 * Source folders:
	 * ===============
	 *
	 * - api/     Most of the public static methods exposed by the module can be found here.
	 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
	 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
	 * - utils/   Utility stuff.
	 *
	 */
	var extras = {
	    allowStateChanges: allowStateChanges,
	    deepEqual: deepEqual,
	    getAtom: getAtom,
	    getDebugName: getDebugName,
	    getDependencyTree: getDependencyTree,
	    getAdministration: getAdministration,
	    getGlobalState: getGlobalState,
	    getObserverTree: getObserverTree,
	    interceptReads: interceptReads,
	    isComputingDerivation: isComputingDerivation,
	    isSpyEnabled: isSpyEnabled,
	    onReactionError: onReactionError,
	    reserveArrayBuffer: reserveArrayBuffer,
	    resetGlobalState: resetGlobalState,
	    isolateGlobalState: isolateGlobalState,
	    shareGlobalState: shareGlobalState,
	    spyReport: spyReport,
	    spyReportEnd: spyReportEnd,
	    spyReportStart: spyReportStart,
	    setReactionScheduler: setReactionScheduler
	};
	var everything = {
	    Reaction: Reaction,
	    untracked: untracked,
	    Atom: Atom,
	    BaseAtom: BaseAtom,
	    useStrict: useStrict,
	    isStrictModeEnabled: isStrictModeEnabled,
	    spy: spy,
	    comparer: comparer,
	    asReference: asReference,
	    asFlat: asFlat,
	    asStructure: asStructure,
	    asMap: asMap,
	    isModifierDescriptor: isModifierDescriptor,
	    isObservableObject: isObservableObject,
	    isBoxedObservable: isObservableValue,
	    isObservableArray: isObservableArray,
	    ObservableMap: ObservableMap,
	    isObservableMap: isObservableMap,
	    map: map,
	    transaction: transaction,
	    observable: observable,
	    computed: computed,
	    isObservable: isObservable,
	    isComputed: isComputed,
	    extendObservable: extendObservable,
	    extendShallowObservable: extendShallowObservable,
	    observe: observe,
	    intercept: intercept,
	    autorun: autorun,
	    autorunAsync: autorunAsync,
	    when: when,
	    reaction: reaction,
	    action: action,
	    isAction: isAction,
	    runInAction: runInAction,
	    expr: expr,
	    toJS: toJS,
	    createTransformer: createTransformer,
	    whyRun: whyRun,
	    isArrayLike: isArrayLike,
	    extras: extras
	};
	var warnedAboutDefaultExport = false;
	var _loop_1 = function (p) {
	    var val = everything[p];
	    Object.defineProperty(everything, p, {
	        get: function () {
	            if (!warnedAboutDefaultExport) {
	                warnedAboutDefaultExport = true;
	                console.warn("Using default export (`import mobx from 'mobx'`) is deprecated " +
	                    "and won’t work in mobx@4.0.0\n" +
	                    "Use `import * as mobx from 'mobx'` instead");
	            }
	            return val;
	        }
	    });
	};
	for (var p in everything) {
	    _loop_1(p);
	}
	if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
	    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({ spy: spy, extras: extras });
	}
	
	exports.extras = extras;
	exports['default'] = everything;
	exports.Reaction = Reaction;
	exports.untracked = untracked;
	exports.Atom = Atom;
	exports.BaseAtom = BaseAtom;
	exports.useStrict = useStrict;
	exports.isStrictModeEnabled = isStrictModeEnabled;
	exports.spy = spy;
	exports.comparer = comparer;
	exports.asReference = asReference;
	exports.asFlat = asFlat;
	exports.asStructure = asStructure;
	exports.asMap = asMap;
	exports.isModifierDescriptor = isModifierDescriptor;
	exports.isObservableObject = isObservableObject;
	exports.isBoxedObservable = isObservableValue;
	exports.isObservableArray = isObservableArray;
	exports.ObservableMap = ObservableMap;
	exports.isObservableMap = isObservableMap;
	exports.map = map;
	exports.transaction = transaction;
	exports.observable = observable;
	exports.computed = computed;
	exports.isObservable = isObservable;
	exports.isComputed = isComputed;
	exports.extendObservable = extendObservable;
	exports.extendShallowObservable = extendShallowObservable;
	exports.observe = observe;
	exports.intercept = intercept;
	exports.autorun = autorun;
	exports.autorunAsync = autorunAsync;
	exports.when = when;
	exports.reaction = reaction;
	exports.action = action;
	exports.isAction = isAction;
	exports.runInAction = runInAction;
	exports.expr = expr;
	exports.toJS = toJS;
	exports.createTransformer = createTransformer;
	exports.whyRun = whyRun;
	exports.trace = trace;
	exports.isArrayLike = isArrayLike;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(1000);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(999);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(224);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(224);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(587);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var flatten = __webpack_require__(480);
	var mdEntity_1 = tslib_1.__importDefault(__webpack_require__(2116));
	var mobx_1 = __webpack_require__(5);
	var formUtils_1 = __webpack_require__(14);
	var storage_1 = __webpack_require__(173);
	var locales_1 = __webpack_require__(15);
	var MdEntityService = /** @class */ (function () {
	    function MdEntityService() {
	        this.entityMap = mobx_1.observable.shallowMap(null);
	        this.ENTITY_REGISTRY = {};
	        this.FORM_DEFINITION_REGISTRY = {};
	        this.CLOSED_CONTENT_REGISTRY = {};
	    }
	    MdEntityService.prototype.getEntityConfig = function (entityName) {
	        return this.ENTITY_REGISTRY[entityName];
	    };
	    MdEntityService.prototype.setEntityConfig = function (entityConfig) {
	        this.ENTITY_REGISTRY[entityConfig.entityName] = entityConfig;
	    };
	    MdEntityService.prototype.getFormDefinition = function (formName) {
	        return this.FORM_DEFINITION_REGISTRY[formName];
	    };
	    MdEntityService.prototype.setFormDefinition = function (formName, formDefinition) {
	        this.FORM_DEFINITION_REGISTRY[formName] = formDefinition;
	    };
	    MdEntityService.prototype.getEntityDetailRoute = function (entityName) {
	        var entityConfig = this.getEntityConfig(entityName);
	        if (!entityConfig)
	            throw new Error("EntityConfig of " + entityName + " is null. Check @entityConfig class annotation on object " + entityName);
	        if (!entityConfig.detailroute)
	            throw new Error("detailRoute on EntityConfig object " + entityName + " is not configured");
	        return entityConfig.detailroute;
	    };
	    MdEntityService.prototype.getClosedContent = function (formName) {
	        return this.CLOSED_CONTENT_REGISTRY[formName];
	    };
	    MdEntityService.prototype.setClosedContent = function (formName, closedContent) {
	        this.CLOSED_CONTENT_REGISTRY[formName] = closedContent;
	    };
	    MdEntityService.prototype.getEntity = function (entityName) {
	        return this.entityMap.get(entityName);
	    };
	    /**
	     * Dotahne ze serveru entity ze zadanych entityNames, ktere neexistuji v metamodel/entities
	     * Pokud je zadane pole withLovs, tak k nim jeste dotahne lovItems, pokud nejsou jeste dotazene (lovitems == undefined)
	     * Pokud se neco dotahovalo aktualizuje metamodel/entities
	     *  Vrati promise resolvovany do (doplneneho) entityObject
	     * @param entityNamesOrSpecs - pole jmen entit [Party, ...] (potom se predpoklada, ze je to without lov) nebo pole objektu [{entity: 'Country', lov: true}, ...]
	       */
	    MdEntityService.prototype.fetchEntities = function (entityNamesOrSpecs) {
	        var _this = this;
	        console.log('fetchEntities %O', entityNamesOrSpecs);
	        var entitySpecs = entityNamesOrSpecs.filter(function (v) { return !!v; }).map(function (v) { return (typeof v === 'string') ? { entity: v } : v; });
	        this.fetchEntitiesFromCache(entitySpecs, this.entityMap);
	        var unresolvedEntitySpecs = entitySpecs.filter(function (v) { return !_this.entityMap.has(v.entity); });
	        var unresolvedLovNames = entitySpecs.filter(function (v) { return v.lov; }).filter(function (v) {
	            var entityObject = _this.entityMap.get(v.entity);
	            return (!entityObject || entityObject.lovItems == undefined);
	        }).map(function (v) { return v.entity; });
	        var promiseArray = [(unresolvedEntitySpecs.length) ? this.fetchMissingEntities(unresolvedEntitySpecs.map(function (s) { return s.entity; })) : [],
	            (unresolvedLovNames.length) ? this.fetchMissingEntityLovs(unresolvedLovNames) : {}];
	        return Promise.all(promiseArray)
	            .then(function (_a) {
	            var entityArray = _a[0], lovObject = _a[1];
	            var lang = locales_1.loc.lang;
	            for (var _i = 0, entityArray_1 = entityArray; _i < entityArray_1.length; _i++) {
	                var entity = entityArray_1[_i];
	                var lovItems = lovObject[entity.id];
	                if (lovItems != undefined) {
	                    entity.lovItems = lovItems;
	                    delete lovObject[entity.id];
	                }
	                _this.entityMap.set(entity.id, entity);
	                (0, storage_1.setItemToLocalStorage)("MdEntity", lang, entity.id, entity);
	            }
	            for (var entityName in lovObject) {
	                var entityObject = _this.entityMap.get(entityName);
	                entityObject.lovItems = lovObject[entityName];
	                _this.entityMap.set(entityName, entityObject);
	                (0, storage_1.setItemToLocalStorage)("MdEntity", lang, entityName, entityObject);
	            }
	            return _this.entityMap;
	        });
	    };
	    MdEntityService.prototype.fetchMissingEntities = function (entityNames) {
	        return axios_config_1.default.get('/core/metamodel/entity', { params: { entityName: entityNames } })
	            .then(function (response) { return response.data.map(function (v) { return new mdEntity_1.default(v); }); });
	    };
	    MdEntityService.prototype.fetchMissingEntityLovs = function (entityNames, tenantIds) {
	        if (tenantIds === void 0) { tenantIds = undefined; }
	        return axios_config_1.default.get('/core/metamodel/lovitem', { params: { entityName: entityNames, tenantIds: tenantIds } })
	            .then(function (response) { return response.data; });
	    };
	    /**
	     *
	     * @param mainEntityNames - pole jmen hlavnich entit, ktere dotahneme bez lov a k nim potom dotahneme entity vsech fieldu s localValueSource vcetne lov
	     * @param entityNamesOrSpecs - pole jmen entit ktere dotahneme bez lovs, nebo pole objektu [{entity: 'Country', lov: true}, ...]
	     */
	    MdEntityService.prototype.fetchEntityMetadata = function (mainEntityNames, entityNamesOrSpecs) {
	        var _this = this;
	        entityNamesOrSpecs = (entityNamesOrSpecs) ? entityNamesOrSpecs : [];
	        var entitySpecs = entityNamesOrSpecs.map(function (v) { return (typeof v === 'string') ? { entity: v } : v; });
	        return this.fetchEntities(mainEntityNames)
	            .then(function (entityMap) {
	            var allFields = flatten(mainEntityNames.map(function (entityName) { return entityMap.get(entityName).getFields(); }));
	            var fieldSpecs = allFields.filter(function (f) { return f.hasLocalValueSource(); }).map(function (f) { return ({ entity: f.valueSource, lov: true }); });
	            var allEntitySpecs = fieldSpecs.concat(entitySpecs);
	            var objectifiedSpecs = allEntitySpecs.reduce(function (acc, spec) {
	                var old = acc[spec.entity];
	                if (old) {
	                    old.lov = old.lov || spec.lov;
	                }
	                else {
	                    acc[spec.entity] = spec;
	                }
	                return acc;
	            }, {});
	            return _this.fetchEntities(Object.values(objectifiedSpecs));
	        });
	    };
	    MdEntityService.prototype.fetchEntitiesFromCache = function (entitySpecs, entityMap) {
	        var lang = locales_1.loc.lang;
	        for (var _i = 0, entitySpecs_1 = entitySpecs; _i < entitySpecs_1.length; _i++) {
	            var entitySpec = entitySpecs_1[_i];
	            if (entityMap.has(entitySpec.entity)) {
	                continue;
	            }
	            var entityStr = (0, storage_1.getItemFromLocalStorage)("MdEntity", lang, entitySpec.entity);
	            if (entityStr) {
	                var entity = new mdEntity_1.default(JSON.parse(entityStr));
	                entityMap.set(entity.id, entity);
	            }
	        }
	    };
	    MdEntityService.prototype.fetchNextEntityNumber = function (entityName, partyId, profitCenterId, invoiceTypeId) {
	        return axios_config_1.default.post('/core/meta/next-entity-number', { entityName: entityName, partyId: partyId, profitCenterId: profitCenterId, invoiceTypeId: invoiceTypeId })
	            .then(function (response) { return response.data.entityNumber; });
	    };
	    MdEntityService.prototype.getLovItem = function (entityName, id) {
	        return axios_config_1.default.get("/core/meta/search/" + entityName + "/" + id)
	            .then(function (response) { return response.data; });
	    };
	    MdEntityService.prototype.spelExpression = function (expression, additionalParams) {
	        if (additionalParams === void 0) { additionalParams = {}; }
	        var struct = Object.assign({}, additionalParams, { expression: expression });
	        return axios_config_1.default.post("/core/meta/spel-expression", struct, { showPrettyError: true })
	            .then(function (response) { return (0, formUtils_1.lovValue)(response.data); });
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdEntityService.prototype, "entityMap", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], MdEntityService.prototype, "fetchEntities", null);
	    return MdEntityService;
	}());
	var mdEntityService = new MdEntityService();
	exports.default = mdEntityService;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EntityConfig = exports.SECURABLE = exports.PERMISSION = exports.SECURABLE_TYPE = exports.MODULE = exports.CONFIGLEVEL = void 0;
	var CONFIGLEVEL;
	(function (CONFIGLEVEL) {
	    CONFIGLEVEL["GLOBAL"] = "GLOBAL";
	    CONFIGLEVEL["TENANTGROUP"] = "TENANTGROUP";
	    CONFIGLEVEL["TENANT"] = "TENANT";
	    CONFIGLEVEL["USER"] = "USER";
	})(CONFIGLEVEL || (exports.CONFIGLEVEL = CONFIGLEVEL = {}));
	var MODULE;
	(function (MODULE) {
	    MODULE["core"] = "core";
	    MODULE["invoicing"] = "invoicing";
	    MODULE["ordering"] = "ordering";
	    MODULE["party"] = "party";
	    MODULE["product"] = "product";
	    MODULE["shipment"] = "shipment";
	    MODULE["accounting"] = "accounting";
	    MODULE["humanresource"] = "humanresource";
	    MODULE["sbtool"] = "sbtool";
	    MODULE["ecommerce"] = "ecommerce";
	})(MODULE || (exports.MODULE = MODULE = {}));
	var SECURABLE_TYPE;
	(function (SECURABLE_TYPE) {
	    SECURABLE_TYPE["PAGE"] = "PAGE";
	    SECURABLE_TYPE["BULKACTION"] = "BULKACTION";
	    SECURABLE_TYPE["DETAILACTION"] = "DETAILACTION";
	    SECURABLE_TYPE["API"] = "API";
	})(SECURABLE_TYPE || (exports.SECURABLE_TYPE = SECURABLE_TYPE = {}));
	var PERMISSION;
	(function (PERMISSION) {
	    PERMISSION["Read"] = "Read";
	    PERMISSION["New"] = "New";
	    PERMISSION["Update"] = "Update";
	    PERMISSION["Delete"] = "Delete";
	    PERMISSION["Execute"] = "Execute";
	    PERMISSION["Export"] = "Export";
	    PERMISSION["Import"] = "Import";
	    PERMISSION["PublicGrid"] = "PublicGrid";
	    PERMISSION["TenantGrid"] = "TenantGrid";
	    PERMISSION["TenantGroupGrid"] = "TenantGroupGrid";
	})(PERMISSION || (exports.PERMISSION = PERMISSION = {}));
	var _SECURABLE = {
	    issuedInvoiceList: { name: 'issuedInvoiceList', module: MODULE.invoicing, type: SECURABLE_TYPE.PAGE, detailHeader: "Issued invoices list permission" },
	    invoiceDetail: { name: 'invoiceDetail', module: MODULE.invoicing, type: SECURABLE_TYPE.PAGE, detailHeader: "Invoice detail permission" },
	    invoiceTemplateList: { name: 'invoiceTemplateList', module: MODULE.invoicing, type: SECURABLE_TYPE.PAGE, detailHeader: "Invoice template list permission" },
	    invoiceTemplateDetail: { name: 'invoiceTemplateDetail', module: MODULE.invoicing, type: SECURABLE_TYPE.PAGE, detailHeader: "Invoice template detail permission" },
	    issueInvoice: { name: 'issueInvoice', module: MODULE.invoicing, type: SECURABLE_TYPE.DETAILACTION, detailHeader: "Issue invoice permission" },
	    issueInvoices: { name: 'issueInvoices', module: MODULE.invoicing, type: SECURABLE_TYPE.BULKACTION },
	    downloadInvoices: { name: 'downloadInvoices', module: MODULE.invoicing, type: SECURABLE_TYPE.BULKACTION },
	    emailInvoices: { name: 'emailInvoices', module: MODULE.invoicing, type: SECURABLE_TYPE.BULKACTION },
	    cancelInvoice: { name: 'cancelInvoice', module: MODULE.invoicing, type: SECURABLE_TYPE.DETAILACTION },
	    reopenInvoice: { name: 'reopenInvoice', module: MODULE.invoicing, type: SECURABLE_TYPE.DETAILACTION },
	    sendInvoice: { name: 'sendInvoice', module: MODULE.invoicing, type: SECURABLE_TYPE.DETAILACTION },
	    invoiceSettlement: { name: 'invoiceSettlement', module: MODULE.invoicing, type: SECURABLE_TYPE.DETAILACTION },
	    vatRateOverride: { name: 'vatRateOverride', module: MODULE.invoicing, type: SECURABLE_TYPE.DETAILACTION },
	    assignProducts: { name: 'assignProducts', module: MODULE.product, type: SECURABLE_TYPE.BULKACTION },
	    assignProductsCustomPrice: { name: 'assignProductsCustomPrice', module: MODULE.product, type: SECURABLE_TYPE.BULKACTION },
	    vehicleNotification: { name: 'vehicleNotification', module: MODULE.product, type: SECURABLE_TYPE.DETAILACTION },
	    vehiclesNotification: { name: 'vehiclesNotification', module: MODULE.product, type: SECURABLE_TYPE.BULKACTION },
	    brimMessageList: { name: 'brimMessageList', module: MODULE.product, type: SECURABLE_TYPE.PAGE },
	    brimMessageAction: { name: 'brimMessageAction', module: MODULE.product, type: SECURABLE_TYPE.BULKACTION },
	    customerNotification: { name: 'customerNotification', module: MODULE.party, type: SECURABLE_TYPE.DETAILACTION },
	    customerRegistration: { name: 'customerRegistration', module: MODULE.party, type: SECURABLE_TYPE.DETAILACTION },
	    setPassword: { name: 'setPassword', module: MODULE.core, type: SECURABLE_TYPE.DETAILACTION },
	    impersonate: { name: 'impersonate', module: MODULE.core, type: SECURABLE_TYPE.DETAILACTION },
	    partyGridUpdate: { name: 'partyGridUpdate', module: MODULE.party, type: SECURABLE_TYPE.BULKACTION },
	    invoiceGridUpdate: { name: 'invoiceGridUpdate', module: MODULE.invoicing, type: SECURABLE_TYPE.BULKACTION },
	    productGridUpdate: { name: 'productGridUpdate', module: MODULE.product, type: SECURABLE_TYPE.BULKACTION },
	    shipmentGridUpdate: { name: 'shipmentGridUpdate', module: MODULE.shipment, type: SECURABLE_TYPE.BULKACTION },
	    shipmentRepackagingGridUpdate: { name: 'shipmentRepackagingGridUpdate', module: MODULE.shipment, type: SECURABLE_TYPE.BULKACTION },
	    shipmentVisitDetail: { name: 'shipmentVisitDetail', module: MODULE.shipment, type: SECURABLE_TYPE.PAGE, permission: PERMISSION.New },
	    shipmentRepackagingAdvance: { name: 'shipmentRepackagingAdvance', module: MODULE.shipment, type: SECURABLE_TYPE.BULKACTION },
	    shipmentRepackagingSetResource: { name: 'shipmentRepackagingSetResource', module: MODULE.shipment, type: SECURABLE_TYPE.DETAILACTION },
	    shipmentRepackagingSetNorm: { name: 'shipmentRepackagingSetNorm', module: MODULE.shipment, type: SECURABLE_TYPE.DETAILACTION },
	    activityList: { name: 'activityList', module: MODULE.core, type: SECURABLE_TYPE.PAGE, permission: PERMISSION.Delete },
	    employeeAttendance: { name: "employeeAttendance", module: MODULE.humanresource, type: SECURABLE_TYPE.DETAILACTION },
	    jobList: { name: "jobList", module: MODULE.core, type: SECURABLE_TYPE.PAGE, detailHeader: "Jobs list permissions" },
	    jobDetail: { name: "jobDetail", module: MODULE.core, type: SECURABLE_TYPE.PAGE, detailHeader: "Job detail permissions" },
	    gridImport: { name: "gridImport", module: MODULE.core, type: SECURABLE_TYPE.BULKACTION, detailHeader: "Grid Import permissions" },
	    entityFieldDetail: { name: "entityFieldDetail", module: MODULE.core, type: SECURABLE_TYPE.PAGE },
	    documentTemplateDetail: { name: "documentTemplateDetail", module: MODULE.core, type: SECURABLE_TYPE.PAGE },
	};
	exports.SECURABLE = _SECURABLE;
	var EntityConfig = /** @class */ (function () {
	    function EntityConfig(entityName, entityConstructorFunction) {
	        this.entityName = entityName;
	        this.entityConstructorFunction = entityConstructorFunction;
	    }
	    EntityConfig.prototype.getFormName = function (historyObject) {
	        return this.entityName + "Form";
	    };
	    return EntityConfig;
	}());
	exports.EntityConfig = EntityConfig;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.FieldText = void 0;
	exports.isForTenant = isForTenant;
	exports.showForTenant = showForTenant;
	exports.hideForTenant = hideForTenant;
	exports.isForVatRateCountry = isForVatRateCountry;
	exports.showForVatRateCountry = showForVatRateCountry;
	exports.hideForVatRateCountry = hideForVatRateCountry;
	exports.showForValue = showForValue;
	exports.getLovItem = getLovItem;
	exports.lovLabel = lovLabel;
	exports.lovValue = lovValue;
	exports.lovParam = lovParam;
	exports.pickLov = pickLov;
	exports.replaceIdWithLov = replaceIdWithLov;
	exports.formatValue = formatValue;
	exports.generateTuples = generateTuples;
	exports.preSave = preSave;
	exports.FieldGroup = FieldGroup;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_router_1 = __webpack_require__(65);
	var jsonUtils_1 = __webpack_require__(193);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var isNumber = __webpack_require__(239);
	var isString = __webpack_require__(163);
	var utils_1 = __webpack_require__(37);
	var react_bootstrap_1 = __webpack_require__(72);
	var react_bootstrap_2 = __webpack_require__(72);
	var react_bootstrap_3 = __webpack_require__(72);
	var react_bootstrap_4 = __webpack_require__(72);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	function isForTenant() {
	    var tenantIds = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        tenantIds[_i] = arguments[_i];
	    }
	    var currentTenant = securityService_1.default.currentTenant;
	    return (currentTenant && tenantIds.includes(currentTenant.tenantId));
	}
	function showForTenant(Component) {
	    var tenantIds = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        tenantIds[_i - 1] = arguments[_i];
	    }
	    return (isForTenant.apply(void 0, tenantIds)) ? Component : null;
	}
	function hideForTenant(Component) {
	    var tenantIds = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        tenantIds[_i - 1] = arguments[_i];
	    }
	    return (isForTenant.apply(void 0, tenantIds)) ? null : Component;
	}
	function isForVatRateCountry() {
	    var countries = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        countries[_i] = arguments[_i];
	    }
	    var currentTenant = securityService_1.default.currentTenant;
	    return (currentTenant && countries.includes(lovValue(currentTenant.vatRateCountry)));
	}
	function showForVatRateCountry(Component) {
	    var countries = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        countries[_i - 1] = arguments[_i];
	    }
	    return (isForVatRateCountry.apply(void 0, countries)) ? Component : null;
	}
	function hideForVatRateCountry(Component) {
	    var countries = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        countries[_i - 1] = arguments[_i];
	    }
	    return (isForVatRateCountry.apply(void 0, countries)) ? null : Component;
	}
	/**
	 * zobrazi Component pokud value je true
	 * @param Component
	 * @param value
	 * @returns {null}
	 */
	function showForValue(Component, value) {
	    return (value) ? Component : null;
	}
	function getLovItem(lovItems, id) {
	    return lovItems.find(function (lov) { return lov.value === id; });
	}
	function lovLabel(value) {
	    return ((value && typeof value.label !== 'undefined') ? value.label : value);
	}
	function lovValue(value) {
	    return ((value && typeof value.value !== 'undefined') ? value.value : value);
	}
	function lovParam(value, name) {
	    return ((value) ? value[name] : null);
	}
	function pickLov(object) {
	    return (object && object.value) ? { value: object.value, label: object.label } : null;
	}
	function replaceIdWithLov(value, entity) {
	    if (isNumber(value) || isString(value)) {
	        return entity.getLovItem(value, false);
	    }
	    else {
	        return value;
	    }
	}
	function formatValue(value, mdField) {
	    return (mdField) ? mdField.formatValue(value) : lovLabel(value);
	}
	var FieldText = function (_a) {
	    var label = _a.label, value = _a.value, mdField = _a.mdField, linkProps = _a.linkProps, style = _a.style, alwaysShow = _a.alwaysShow;
	    return ((value == null && !alwaysShow) ? react_1.default.createElement("span", null) : ((linkProps) ? (react_1.default.createElement(react_router_1.Link, tslib_1.__assign({}, linkProps, { style: style, query: (0, utils_1.addTenantToQuery)(linkProps.query) }),
	        react_1.default.createElement("span", null,
	            (label) ? react_1.default.createElement("span", { className: "zz-grey-text zz-mr-2" },
	                label,
	                ": ") : null,
	            react_1.default.createElement("span", { className: "zz-mr-10" }, formatValue(value, mdField))))) : (react_1.default.createElement("span", { style: style },
	        (label) ? react_1.default.createElement("span", { className: "zz-grey-text zz-mr-2" },
	            label,
	            ": ") : null,
	        react_1.default.createElement("span", { className: "zz-mr-10" }, formatValue(value, mdField))))));
	};
	exports.FieldText = FieldText;
	function generateTuples(rootObject, tuples, validateAllForms) {
	    (0, jsonUtils_1.walk)(rootObject, function (object, level) {
	        if (object.$formMap) {
	            var _tuples = object.$formMap.values().filter(function (form) { return form.$open || validateAllForms || form.nested; }).map(function (form) { return ({ form: form, object: object }); });
	            tuples.push.apply(tuples, _tuples);
	        }
	    });
	}
	/**
	 * 1. najde otevrene formy (ve $formMap), zkusi je zvalidovat, pokud OK, zavre je.
	 * 2. pokud zadana customValidate funkce, tak ji zavola a chyby ulozi do rootObject.$errors
	 * @param rootObject
	 * @param customValidate
	 * @param validateAllForms - ignoruje priznak form.$open
	 * @returns {boolean} - true pokud ani 1. ani 2. nevrati zadnou chybu, jinak false
	 */
	function preSave(rootObject, customValidate, validateAllForms) {
	    // najdu otevrene form objekty
	    var openTuples = [];
	    generateTuples(rootObject, openTuples, validateAllForms);
	    //// editable grids forms
	    if (rootObject.$movingBlocks) {
	        for (var _i = 0, _a = rootObject.$movingBlocks.getEditedBlocks(); _i < _a.length; _i++) {
	            var grid = _a[_i];
	            for (var _b = 0, _c = grid.getEditedRows(); _b < _c.length; _b++) {
	                var rowObject = _c[_b];
	                generateTuples(rowObject, openTuples, validateAllForms);
	            }
	        }
	    }
	    var cleanTuples = [];
	    rootObject.$errors = [];
	    console.log('Generated tuples %O on rootObject %O', openTuples, rootObject);
	    for (var _d = 0, openTuples_1 = openTuples; _d < openTuples_1.length; _d++) {
	        var _e = openTuples_1[_d], form = _e.form, object = _e.object;
	        var res = form.validateForm(object, rootObject.$errors);
	        if (res) {
	            cleanTuples.push({ form: form, object: object });
	        }
	    }
	    if (customValidate) {
	        rootObject.$errors = rootObject.$errors.concat(customValidate(rootObject));
	    }
	    var isOK = (rootObject.$errors.length === 0);
	    if (isOK) {
	        for (var _f = 0, cleanTuples_1 = cleanTuples; _f < cleanTuples_1.length; _f++) {
	            var _g = cleanTuples_1[_f], form = _g.form, object = _g.object;
	            object.$added = undefined;
	            form.$open = false;
	            form.$pristineObject = undefined;
	        }
	    }
	    else {
	        uiService_1.default.hideToolbarActionFlag();
	    }
	    return isOK;
	}
	function FieldGroup(_a) {
	    var _b = _a.id, id = _b === void 0 ? null : _b, _c = _a.label, label = _c === void 0 ? null : _c, _d = _a.help, help = _d === void 0 ? null : _d, bsSize = _a.bsSize, props = tslib_1.__rest(_a, ["id", "label", "help", "bsSize"]);
	    return (react_1.default.createElement(react_bootstrap_1.FormGroup, { controlId: id, bsSize: bsSize },
	        react_1.default.createElement(react_bootstrap_2.ControlLabel, null, label),
	        react_1.default.createElement(react_bootstrap_4.FormControl, tslib_1.__assign({}, props)),
	        help && react_1.default.createElement(react_bootstrap_3.HelpBlock, null, help)));
	}


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.loc = void 0;
	exports.changeLanguage = changeLanguage;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var escape_html_1 = tslib_1.__importDefault(__webpack_require__(1272));
	var intl_messageformat_1 = tslib_1.__importDefault(__webpack_require__(1343));
	var storage_1 = __webpack_require__(173);
	var jsonUtils_1 = __webpack_require__(193);
	__webpack_require__(1628);
	__webpack_require__(1633);
	__webpack_require__(1629);
	__webpack_require__(1630);
	__webpack_require__(1631);
	__webpack_require__(1632);
	__webpack_require__(1634);
	var momentLocalizer = __webpack_require__(1906);
	//require('intl/locale-data/jsonp/en.js');
	// locale data
	var locales = {
	    en: __webpack_require__(1352),
	    cs: __webpack_require__(1350),
	    sk: __webpack_require__(1356),
	    de: __webpack_require__(1351),
	    hu: __webpack_require__(1353),
	    pl: __webpack_require__(1354),
	    ro: __webpack_require__(1355),
	    uk: __webpack_require__(1357),
	};
	console.log(locales);
	momentLocalizer(moment_1.default);
	moment_1.default.updateLocale("en", {
	    longDateFormat: {
	        L: "DD/MM/YYYY",
	        l: "D/M/YYYY",
	        LT: "HH:mm",
	        LTS: "HH:mm:ss",
	        LL: "D MMMM YYYY",
	        ll: "D MMM YYYY",
	        LLL: "D MMMM YYYY HH:mm",
	        lll: "DD/MM/YYYY HH:mm",
	        LLLL: "dddd, D MMMM YYYY HH:mm",
	    },
	});
	// editovane lll kvuli datetimepicker s casem
	moment_1.default.updateLocale("cs", {
	    longDateFormat: {
	        L: "DD.MM.YYYY",
	        l: "D. M. YYYY",
	        LT: "H:mm",
	        LTS: "H:mm:ss",
	        LL: "D. MMMM YYYY",
	        ll: "D. MMM YYYY",
	        LLL: "D. MMMM YYYY H:mm",
	        lll: "DD.MM.YYYY HH:mm",
	        LLLL: "dddd D. MMMM YYYY H:mm",
	    },
	});
	moment_1.default.updateLocale("sk", {
	    longDateFormat: {
	        L: "DD.MM.YYYY",
	        l: "D. M. YYYY",
	        LT: "H:mm",
	        LTS: "H:mm:ss",
	        LL: "D. MMMM YYYY",
	        ll: "D. MMM YYYY",
	        LLL: "D. MMMM YYYY H:mm",
	        lll: "DD.MM.YYYY HH:mm",
	        LLLL: "dddd D. MMMM YYYY H:mm",
	    },
	});
	moment_1.default.updateLocale("ro", {
	    longDateFormat: {
	        L: "DD.MM.YYYY",
	        l: "D. M. YYYY",
	        LT: "H:mm",
	        LTS: "H:mm:ss",
	        LL: "D. MMMM YYYY",
	        ll: "D. MMM YYYY",
	        LLL: "D. MMMM YYYY H:mm",
	        lll: "DD.MM.YYYY HH:mm",
	        LLLL: "dddd D. MMMM YYYY H:mm",
	    },
	});
	moment_1.default.updateLocale("pl", {
	    longDateFormat: {
	        L: "DD.MM.YYYY",
	        l: "D. M. YYYY",
	        LT: "H:mm",
	        LTS: "H:mm:ss",
	        LL: "D. MMMM YYYY",
	        ll: "D. MMM YYYY",
	        LLL: "D. MMMM YYYY H:mm",
	        lll: "DD.MM.YYYY HH:mm",
	        LLLL: "dddd D. MMMM YYYY H:mm",
	    },
	});
	moment_1.default.updateLocale("uk", {
	    longDateFormat: {
	        L: "DD.MM.YYYY",
	        l: "D. M. YYYY",
	        LT: "H:mm",
	        LTS: "H:mm:ss",
	        LL: "D. MMMM YYYY",
	        ll: "D. MMM YYYY",
	        LLL: "D. MMMM YYYY H:mm",
	        lll: "DD.MM.YYYY HH:mm",
	        LLLL: "dddd D. MMMM YYYY H:mm",
	    },
	});
	moment_1.default.updateLocale("de", {
	    longDateFormat: {
	        L: "DD.MM.YYYY",
	        l: "D. M. YYYY",
	        LT: "H:mm",
	        LTS: "H:mm:ss",
	        LL: "D. MMMM YYYY",
	        ll: "D. MMM YYYY",
	        LLL: "D. MMMM YYYY H:mm",
	        lll: "DD.MM.YYYY HH:mm",
	        LLLL: "dddd D. MMMM YYYY H:mm",
	    },
	});
	moment_1.default.updateLocale("hu", {
	    longDateFormat: {
	        L: "YYYY.MM.DD",
	        l: "YYYY M. D.",
	        LT: "H:mm",
	        LTS: "H:mm:ss",
	        LL: "YYYY MMMM D.",
	        ll: "YYYY MMM D.",
	        LLL: "YYYY MMMM D. H:mm",
	        lll: "YYYY.MM.DD HH:mm",
	        LLLL: "YYYY MMMM dddd D. H:mm",
	    },
	});
	moment_1.default.relativeTimeThreshold("M", 12);
	// aby byl moment dostupny v uzivatelsky definovanych eval vyrazech defaultnich hodnot policek (v MdEntity#initDefaultValues())
	window.moment = moment_1.default;
	var Loc = /** @class */ (function () {
	    function Loc() {
	        this.messageFormatCache = new Map();
	        this.available = ["en", "cs", "de", "hu", "pl", "ro", "sk", "uk"];
	        this.countries = {
	            en: "gb",
	            cs: "cz",
	            de: "de",
	            hu: "hu",
	            pl: "pl",
	            ro: "ro",
	            sk: "sk",
	            uk: "ua",
	        };
	        this._lang = null;
	        this.defaultLang = "en";
	    }
	    Object.defineProperty(Loc.prototype, "lang", {
	        get: function () {
	            if (!this._lang) {
	                this._lang = this.resolveLang();
	                moment_1.default.locale(this._lang);
	            }
	            return this._lang;
	        },
	        set: function (_l) {
	            if (this.available.includes(_l)) {
	                this._lang = _l;
	                (0, storage_1.writeCookie)("lang", _l, 365);
	                moment_1.default.locale(_l);
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Loc.prototype, "country", {
	        get: function () {
	            return this.countries[this.lang];
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Nejdriv to zkusim vzit z cookie
	     * @returns {*}
	     * @private
	     */
	    Loc.prototype.resolveLang = function () {
	        console.debug("resolving lang ");
	        var _l = (0, storage_1.getCookie)("lang");
	        if (_l) {
	            if (this.available.includes(_l)) {
	                return _l;
	            }
	        }
	        var nav = window.navigator;
	        var locale = nav.language || "";
	        _l = locale.slice(0, 2);
	        if (this.available.includes(_l)) {
	            return _l;
	        }
	        else {
	            return "en";
	        }
	    };
	    /**
	     * Get the formatted message by key
	     * @param {string} key The string representing key in locale data file
	     * @param {Object} variables Variables in message
	     * @returns {string} message
	     */
	    Loc.prototype.get = function (key, variables) {
	        var la = this.lang;
	        if (!locales[la]) {
	            return key;
	        }
	        var msg = (0, jsonUtils_1.getDescendantProp)(locales[la], key);
	        if (msg == null) {
	            msg = (0, jsonUtils_1.getDescendantProp)(locales["en"], key);
	        }
	        if (msg == null) {
	            console.error("localization key \"".concat(key, "\" not defined in ").concat(la));
	            return key;
	        }
	        if (variables) {
	            variables = Object.assign({}, variables);
	            // HTML message with variables. Escape it to avoid XSS attack.
	            for (var i in variables) {
	                var value = variables[i];
	                if (typeof value === "string" &&
	                    value.indexOf("<") >= 0 &&
	                    value.indexOf(">") >= 0) {
	                    value = (0, escape_html_1.default)(value);
	                }
	                variables[i] = value;
	            }
	        }
	        return this.format(msg, variables, la);
	    };
	    Loc.prototype.format = function (msg, variables, la) {
	        try {
	            var intlMessageFormat = this.messageFormatCache.get(msg);
	            if (!intlMessageFormat) {
	                intlMessageFormat = new intl_messageformat_1.default(msg, la); // TODO memorize
	                this.messageFormatCache.set(msg, intlMessageFormat);
	            }
	            msg = intlMessageFormat.format(variables);
	            return msg;
	        }
	        catch (err) {
	            console.error("localization format message failed for message='".concat(msg, "'"), err);
	            return msg;
	        }
	    };
	    /**
	     * Get the formatted html message by key.
	     * @param {string} key The string representing key in locale data file
	     * @param {Object} variables Variables in message
	     * @returns {React.Element} message
	     */
	    Loc.prototype.getHTML = function (key, variables) {
	        var msg = this.get(key, variables);
	        return msg != null
	            ? react_1.default.createElement("span", {
	                dangerouslySetInnerHTML: {
	                    __html: msg,
	                },
	            })
	            : key;
	    };
	    /**
	     * use {@link get()}
	     */
	    Loc.prototype.i18n = function (strings) {
	        var values = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            values[_i - 1] = arguments[_i];
	        }
	        var la = this.lang;
	        var str = "";
	        for (var i = 0; i < strings.length - 1; i++) {
	            str += strings[i] + "{" + i + "}";
	        }
	        str += strings[strings.length - 1];
	        str = this.readTransByLang(str, la);
	        return this.format(str, values, la);
	    };
	    Loc.prototype.readTransByLang = function (str, lang) {
	        var messages = locales[lang];
	        if (messages) {
	            var trans = messages[str];
	            return trans ? trans : this.getDefaultTrans(str);
	        }
	        return this.getDefaultTrans(str);
	    };
	    Loc.prototype.getDefaultTrans = function (str) {
	        var messages = locales[this.defaultLang];
	        var trans = messages[str];
	        if (!trans) {
	            trans = str;
	        }
	        return trans;
	    };
	    return Loc;
	}());
	exports.loc = new Loc();
	function changeLanguage(lang, event) {
	    console.log("onSelectLanguage: event = %o, lang = %o", event, lang);
	    if (event)
	        event.preventDefault();
	    exports.loc.lang = lang;
	    window.localStorage.clear();
	    window.location.reload(true);
	}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(588);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1051), __esModule: true };

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.fieldStyles = void 0;
	exports.createForm = createForm;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	exports.fieldStyles = {
	    small: {
	        textField: {
	            style: {
	                fontSize: 14,
	                height: 60,
	                marginBottom: 2
	            },
	            floatingLabelStyle: {
	                top: 27
	            },
	            hintStyle: { lineHeight: '24px' },
	            inputStyle: { marginTop: 9 },
	            errorStyle: { top: -13 } // lepsi by bylo nastavit bottom, jenze v kodu TextField se bottom nastavuje natvrdo na fontSize + 3 = 15px, takze nastavime top a vyuzijme toho ze "When both top and bottom are specified, the top property takes precedence and the bottom property is ignored."
	        },
	        textArea: {
	            style: {
	                fontSize: 14,
	                marginTop: -12
	            },
	            floatingLabelStyle: {},
	            hintStyle: { lineHeight: '24px' },
	            errorStyle: { top: -5 }
	        },
	        styledSelect: {
	            style: {
	                fontSize: 14,
	                height: 60,
	                marginBottom: 2
	            },
	            floatingLabelStyle: {
	                top: 27
	            }
	        },
	        checkbox: {
	            style: {
	                paddingTop: 20
	            },
	            labelStyle: {
	                fontSize: 14
	            }
	        },
	        radioButton: {
	            style: {},
	            labelStyle: {
	                fontSize: 14
	            }
	        },
	        default: {
	            style: {
	                fontSize: 14,
	                height: 60,
	                marginBottom: 2
	            },
	            floatingLabelStyle: {
	                top: 27
	            }
	        }
	    },
	    big: {
	        textField: {
	            style: {},
	            floatingLabelStyle: {}
	        },
	        textArea: {
	            style: {},
	            floatingLabelStyle: {}
	        },
	        styledSelect: {
	            style: {
	                fontSize: 18,
	                height: 60,
	                marginBottom: 2
	            },
	            floatingLabelStyle: {}
	        },
	        checkbox: {
	            style: {},
	        },
	        radioButton: {
	            style: {},
	        },
	        default: {
	            style: {},
	            floatingLabelStyle: {}
	        }
	    },
	    huge: {
	        textField: {
	            style: {
	                fontSize: 26,
	                height: 100,
	                marginBottom: 4
	            },
	            floatingLabelStyle: {
	                top: 37
	            },
	            hintStyle: { lineHeight: '34px' },
	            inputStyle: { marginTop: 19 },
	            errorStyle: { top: -23 } // lepsi by bylo nastavit bottom, jenze v kodu TextField se bottom nastavuje natvrdo na fontSize + 3 = 15px, takze nastavime top a vyuzijme toho ze "When both top and bottom are specified, the top property takes precedence and the bottom property is ignored."
	        },
	        styledSelect: {
	            style: {
	                fontSize: 26,
	                height: 100,
	                marginBottom: 4
	            },
	            floatingLabelStyle: {
	                top: 37
	            },
	            hintStyle: { lineHeight: '34px' },
	            inputStyle: { marginTop: 19 },
	            errorStyle: { top: -23 }
	        },
	    }
	};
	function createForm(definition, ClosedContent) {
	    return function (FormComponent) {
	        var hocFormClass = (0, mobx_react_1.observer)(/** @class */ (function (_super) {
	            tslib_1.__extends(class_1, _super);
	            function class_1(props) {
	                var _this = _super.call(this, props) || this;
	                _this.validate = function () {
	                    var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject;
	                    var form = dataObject.getForm(definition.formName);
	                    rootObject.$errors = [];
	                    return form.validateForm(dataObject, rootObject.$errors);
	                };
	                return _this;
	            }
	            class_1.prototype.componentWillMount = function () {
	                var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entity = _a.entity, entities = _a.entities, extractFieldFn = _a.extractFieldFn;
	                //console.log('%c %s componentWillMount', 'background-color: magenta', definition.formName);
	                var form = dataObject.getForm(definition.formName);
	                form.initForm(entity, entities, dataObject, rootObject, extractFieldFn);
	                form.updateAllFieldsPropValue(dataObject);
	                //setDataAction(rootObject, 'createForm( + FormComponent.name + )#componentWillMount()');
	            };
	            class_1.prototype.componentWillReceiveProps = function (nextProps) {
	                var dataObject = nextProps.dataObject, rootObject = nextProps.rootObject, entity = nextProps.entity, entities = nextProps.entities, extractFieldFn = nextProps.extractFieldFn;
	                console.log('%c %s componentWillReceiveProps %O', 'background-color: magenta', definition.formName, nextProps);
	                if (this.props.dataObject !== dataObject) {
	                    var form = dataObject.getForm(definition.formName);
	                    if (!form.fields) {
	                        form.initForm(entity, entities, dataObject, rootObject, extractFieldFn);
	                    }
	                    form.updateAllFieldsPropValue(dataObject);
	                }
	            };
	            class_1.prototype.render = function () {
	                return react_1.default.createElement(FormComponent, tslib_1.__assign({}, this.props, { formName: definition.formName, form: this.props.dataObject.getForm(definition.formName), validate: this.validate }));
	            };
	            return class_1;
	        }(react_1.default.Component)));
	        mdEntityService_1.default.setFormDefinition(definition.formName, definition);
	        if (ClosedContent) {
	            mdEntityService_1.default.setClosedContent(definition.formName, ClosedContent);
	        }
	        return hocFormClass;
	    };
	}


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	  return target;
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MdCheckbox = exports.MdSelectField = exports.MdTextField = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var TextField_1 = tslib_1.__importDefault(__webpack_require__(186));
	var Checkbox_1 = tslib_1.__importDefault(__webpack_require__(210));
	var SelectField_1 = tslib_1.__importDefault(__webpack_require__(493));
	var mobx_1 = __webpack_require__(5);
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var colors_1 = __webpack_require__(29);
	var ValidationWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    display: flex;\n    position:relative;\n    width:100%;\n"], ["\n    display: flex;\n    position:relative;\n    width:100%;\n"])));
	var SpinnerSpan = styled_components_1.default.span(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n    position: absolute;\n    bottom: 18px;\n    right: 0;\n    color: ", ";\n    display: ", ";\n"], ["\n    position: absolute;\n    bottom: 18px;\n    right: 0;\n    color: ", ";\n    display: ", ";\n"])), colors_1.grey500, function (props) { return props.validating ? 'inline' : 'none'; });
	var ActionSpan = styled_components_1.default.span(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n    position: absolute;\n    bottom: 18px;\n    right: 0;\n    color: ", ";\n"], ["\n    position: absolute;\n    bottom: 18px;\n    right: 0;\n    color: ", ";\n"])), colors_1.indigo500);
	var ActionAnchor = styled_components_1.default.a(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
	var MdTextField = function (_a) {
	    var mdField = _a.mdField, numberFormat = _a.numberFormat, showValidationIcon = _a.showValidationIcon, validating = _a.validating, onAction = _a.onAction, onActionEnable = _a.onActionEnable, other = tslib_1.__rest(_a, ["mdField", "numberFormat", "showValidationIcon", "validating", "onAction", "onActionEnable"]);
	    return (showValidationIcon) ? (react_1.default.createElement(ValidationWrapper, null,
	        react_1.default.createElement(TextField_1.default, tslib_1.__assign({}, other)),
	        react_1.default.createElement(SpinnerSpan, { className: "fa fa-spin fa-spinner", validating: validating }),
	        (onAction && !validating && !other.errorText && onActionEnable(other.value)) ? react_1.default.createElement(ActionAnchor, { onClick: onAction },
	            " ",
	            react_1.default.createElement(ActionSpan, { className: "fa fa-clone" }),
	            " ") : null)) : (react_1.default.createElement(TextField_1.default, tslib_1.__assign({}, other)));
	};
	exports.MdTextField = MdTextField;
	var MdSelectField = /** @class */ (function (_super) {
	    tslib_1.__extends(MdSelectField, _super);
	    function MdSelectField() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onChange = function (evt, index, value) {
	            _this.props.onChange(value);
	        };
	        return _this;
	    }
	    MdSelectField.prototype.render = function () {
	        var _a = this.props, mdField = _a.mdField, numberFormat = _a.numberFormat, onChange = _a.onChange, other = tslib_1.__rest(_a, ["mdField", "numberFormat", "onChange"]);
	        return (react_1.default.createElement(SelectField_1.default, tslib_1.__assign({ onChange: this.onChange }, other)));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], MdSelectField.prototype, "onChange", void 0);
	    return MdSelectField;
	}(react_1.default.PureComponent));
	exports.MdSelectField = MdSelectField;
	var MdCheckbox = function (_a) {
	    var mdField = _a.mdField, numberFormat = _a.numberFormat, fullWidth = _a.fullWidth, hintStyle = _a.hintStyle, errorStyle = _a.errorStyle, errorText = _a.errorText, floatingLabelStyle = _a.floatingLabelStyle, other = tslib_1.__rest(_a, ["mdField", "numberFormat", "fullWidth", "hintStyle", "errorStyle", "errorText", "floatingLabelStyle"]);
	    return (react_1.default.createElement(Checkbox_1.default, tslib_1.__assign({}, other)));
	};
	exports.MdCheckbox = MdCheckbox;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var metaConstant_1 = __webpack_require__(13);
	var react_router_1 = __webpack_require__(65);
	var last = __webpack_require__(138);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var mobx_1 = __webpack_require__(5);
	var documentService_1 = tslib_1.__importDefault(__webpack_require__(110));
	var favicon_1 = __webpack_require__(562);
	var locales_1 = __webpack_require__(15);
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var PageAncestor = /** @class */ (function (_super) {
	    tslib_1.__extends(PageAncestor, _super);
	    function PageAncestor() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.dirtyDialogRefHandler = function (c) { return _this.dirtyDialogRef = c; };
	        _this.deleteDialogRefHandler = function (c) { return _this.deletedDialogRef = c; };
	        _this.onBack = function (evt) {
	            _this.context.router.goBack();
	        };
	        _this.goBackOrHome = function () {
	            if (react_router_1.History.length <= 1) {
	                _this.context.router.transitionTo('home');
	            }
	            else {
	                _this.context.router.goBack();
	            }
	        };
	        _this.onTabChange = function (tabName) {
	            _this.tabChange(tabName, function (tab) {
	                _this.findRootObject().$movingBlocks.activeBlockTab = tab;
	            });
	        };
	        _this.mediaQueryListener = function (changed) {
	            console.log('mediaQueryListener islarge = ' + changed.matches);
	            var obj = _this.findRootObject();
	            obj.$movingBlocks.fixActiveTab();
	            _this.forceUpdate();
	            setTimeout(function () {
	                obj.$movingBlocks.searchExposedGrids(obj);
	            }, 0);
	        };
	        return _this;
	    }
	    PageAncestor.willTransitionTo = function (transition, params, query, callback) {
	        var _this = this;
	        console.log('willTransitionTo: transition = %O, params = %O, query = %O, route = %s, module = %s', transition, params, query, this.name, this.handler.module);
	        // check if autenticated
	        var currentUser = securityService_1.default.currentUser;
	        if (!currentUser) {
	            securityService_1.default.readCurrentUserContext()
	                .then(function (userContextDto) {
	                if (userContextDto) {
	                    securityService_1.default.setUserContextDto(userContextDto);
	                    window.sessionStorage.setItem('tenantId', securityService_1.default.currentTenant.tenantId.toString());
	                    window.TENANT_ID = securityService_1.default.currentTenant.tenantId.toString();
	                    var _cachedSRT = window.localStorage.getItem("serverRestartTime");
	                    if (userContextDto.serverRestartTime !== _cachedSRT) {
	                        console.log('Cached SRT %s, server SRT %s -> going to clear cache', _cachedSRT, userContextDto.serverRestartTime);
	                        window.localStorage.clear();
	                        window.localStorage.setItem("serverRestartTime", userContextDto.serverRestartTime);
	                    }
	                    if (_this.handler.protectedPage && !securityService_1.default.hasRight((typeof _this.handler.protectedPage === 'boolean') ? _this.name : _this.handler.protectedPage, metaConstant_1.PERMISSION.Read)) {
	                        console.warn("No Read permission to " + _this.handler.title);
	                        transition.abort();
	                    }
	                    (0, favicon_1.handleFavicon)(_this.handler);
	                }
	                else {
	                    commonService_1.default.redirectAfterLogin = transition.path;
	                    transition.redirect('loginPage');
	                }
	                callback();
	            });
	            return;
	        }
	        if (this.handler.protectedPage && !securityService_1.default.hasRight((typeof this.handler.protectedPage === 'boolean') ? this.name : this.handler.protectedPage, metaConstant_1.PERMISSION.Read)) {
	            console.warn("No Read permission to " + this.name);
	            transition.abort();
	        }
	        (0, favicon_1.handleFavicon)(this.handler);
	        callback();
	    };
	    PageAncestor.willTransitionFrom = function (transition, component, callback) {
	        console.log('willTransitionFrom: transition = %O, component = %O', transition, component);
	        var rootObject, origComponent = component;
	        // // redux unwrap
	        // if (typeof component.getWrappedInstance === 'function') {
	        //   try {
	        //     origComponent = component.getWrappedInstance();
	        //   } catch (e) {
	        //     console.log('getWrappedInstance error: ', e);
	        //   }
	        // }
	        // react-dnd unwrap
	        if (component.refs.child) {
	            origComponent = component.refs.child;
	        }
	        rootObject = (origComponent && typeof origComponent.findRootObject === 'function') ? origComponent.findRootObject() : undefined;
	        if (rootObject && rootObject.$dirty) {
	            new Promise(function (resolve, reject) {
	                origComponent.dirtyDialogRef.open(resolve, reject);
	            })
	                .then(function () {
	                callback();
	            })
	                .catch(function (e) {
	                transition.cancel();
	            });
	            return;
	        }
	        else {
	            callback();
	        }
	        (0, favicon_1.removeFaviconLink)();
	    };
	    PageAncestor.prototype.openDeleteDialog = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            _this.deletedDialogRef.open(resolve, reject, locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Do you really want to delete this item?"], ["Do you really want to delete this item?"]))));
	        });
	    };
	    PageAncestor.prototype.idChanged = function (oldId, newId) {
	        return (this.properId(newId) && newId !== oldId);
	    };
	    PageAncestor.prototype.properId = function (id) {
	        return (id && id !== 'copy' && id !== 'new');
	    };
	    PageAncestor.prototype.findRootObject = function () {
	        return null;
	    };
	    PageAncestor.prototype.tabChange = function (tabName, storeFn) {
	        if (tabName && !!tabName.target)
	            return; // workaround kvuli material-ui error https://github.com/callemall/material-ui/issues/2189
	        console.log('onTabChange ', tabName);
	        storeFn(tabName);
	        var routeName = last(this.context.router.getCurrentRoutes()).name, params = this.props.params, query = Object.assign({}, this.props.query, { tab: tabName });
	        var path = this.context.router.makePath(routeName, params, query);
	        window.history.replaceState({ path: path }, '', path);
	        //this.context.router.replaceWith(routeName, params,query);
	        console.log("%c query", "color: red", this.context.router.getCurrentQuery());
	    };
	    /**
	     * Grid k aktivaci (init + search v timeoutu)
	     * @param grid
	     */
	    PageAncestor.prototype.activateTab = function (grid) {
	        if (!grid.data) {
	            grid.search(this.findRootObject(), true);
	        }
	    };
	    PageAncestor.prototype.docSavingPromise = function (gridDocument, params) {
	        var promise = Promise.resolve(null);
	        if (gridDocument && gridDocument.documents) {
	            var newDocs = gridDocument.documents.filter(function (d) { return d.$new; });
	            if (newDocs.length) {
	                promise = Promise.all(newDocs.map(function (doc) { return documentService_1.default.saveDocument(doc, params); }));
	            }
	        }
	        return promise;
	    };
	    PageAncestor.contextTypes = {
	        router: prop_types_1.default.func.isRequired,
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PageAncestor.prototype, "activateTab", null);
	    return PageAncestor;
	}(react_1.default.Component));
	exports.default = PageAncestor;
	var templateObject_1;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var uniq = __webpack_require__(1487);
	var isEmpty = __webpack_require__(284);
	var sum = __webpack_require__(1484);
	var flatten = __webpack_require__(480);
	var grid_1 = tslib_1.__importStar(__webpack_require__(50));
	var gridConfig_1 = tslib_1.__importDefault(__webpack_require__(264));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var utils_1 = __webpack_require__(37);
	var grid_2 = __webpack_require__(50);
	var domUtils_1 = __webpack_require__(91);
	var mobx_1 = __webpack_require__(5);
	var grid_3 = __webpack_require__(50);
	var gridSpecialCondition_1 = __webpack_require__(937);
	var formUtils_1 = __webpack_require__(14);
	var multiUpdateDialog_1 = __webpack_require__(568);
	var storage_1 = __webpack_require__(173);
	var eventDomain_1 = __webpack_require__(74);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var locales_1 = __webpack_require__(15);
	var chart_1 = tslib_1.__importDefault(__webpack_require__(2100));
	var axios_config_2 = tslib_1.__importDefault(__webpack_require__(59));
	var gridUtils_1 = __webpack_require__(83);
	var GridService = /** @class */ (function () {
	    function GridService() {
	        this.gridLocationMap = mobx_1.observable.shallowMap(null);
	        this.gridMap = new mobx_1.ObservableMap();
	    }
	    /**
	     * vlozi do GridStore objekty Grid pro gridLocations ktere tam dosud nebyly
	     */
	    GridService.prototype.fetchGrids = function () {
	        var _this = this;
	        var gridLocations = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            gridLocations[_i] = arguments[_i];
	        }
	        var unresolvedGridLocations = gridLocations.filter(function (v) { return !_this.gridLocationMap.has(v); });
	        console.debug('gridService#fetchGrids unresolvedGridLocations = %o', unresolvedGridLocations);
	        if (unresolvedGridLocations.length === 0) {
	            return Promise.resolve(this.gridLocationMap);
	        }
	        var promiseArray = [];
	        var gridArrayFromCache = this.fetchGridsFromCache(unresolvedGridLocations, this.gridLocationMap);
	        if (gridArrayFromCache.length) {
	            promiseArray.push(Promise.resolve(gridArrayFromCache));
	        }
	        if (unresolvedGridLocations.length) {
	            console.log("fetchGrids: still %s  unresolvedGridLocations to fetch from server", unresolvedGridLocations.length);
	            var gridArrayFromServerPromise = axios_config_1.default.get('/core/grid-config', { params: { gridLocation: unresolvedGridLocations } }).then(function (response) { return response.data; });
	            promiseArray.push(gridArrayFromServerPromise);
	        }
	        var gridJsonArray;
	        return Promise.all(promiseArray).then(function (arrayOfGridArrays) {
	            gridJsonArray = flatten(arrayOfGridArrays);
	            var entitiesToFetch = gridJsonArray.filter(function (g) { return !!g.entityName; }).map(function (g) { return g.entityName; });
	            entitiesToFetch.push({ entity: 'FILTEROPERATOR', lov: true });
	            return mdEntityService_1.default.fetchEntities(uniq(entitiesToFetch));
	        }).then(function (entityMap) {
	            console.log("fetchGrids promise resolved: %O", gridJsonArray);
	            var lang = locales_1.loc.lang;
	            for (var _i = 0, gridJsonArray_1 = gridJsonArray; _i < gridJsonArray_1.length; _i++) {
	                var gridLocationJson = gridJsonArray_1[_i];
	                var gridLocation = new grid_3.GridLocation(entityMap.get(gridLocationJson.entityName), gridLocationJson);
	                _this.gridLocationMap.set(gridLocation.gridLocation, gridLocation);
	                if (!gridLocation.$cached) {
	                    (0, storage_1.setItemToLocalStorage)("GridLocation", lang, gridLocation.gridLocation, gridLocation);
	                }
	            }
	            return _this.gridLocationMap;
	        });
	    };
	    GridService.prototype.initGrid = function (gridLocation) {
	        var gridLocationDto = this.gridLocationMap.get(gridLocation);
	        if (!gridLocationDto) {
	            return null;
	        }
	        else {
	            var grid = new grid_1.default(gridLocationDto);
	            this.gridMap.set(gridLocation, grid);
	            return grid;
	        }
	    };
	    GridService.prototype.removeGrid = function (gridLocation) {
	        this.gridMap.delete(gridLocation);
	    };
	    GridService.prototype.getOrCreateGrid = function (gridLocation) {
	        var grid = this.gridMap.get(gridLocation);
	        return (grid) ? grid : this.initGrid(gridLocation);
	    };
	    GridService.prototype.getGrid = function (gridLocation) {
	        return this.gridMap.get(gridLocation);
	    };
	    GridService.prototype.fetchGridsFromCache = function (gridLocations, gridLocationMap) {
	        var lang = locales_1.loc.lang;
	        var oldSize = gridLocations.length;
	        var gridArray = [];
	        for (var i = gridLocations.length - 1; i >= 0; i--) {
	            var gridLocation = gridLocations[i];
	            if (gridLocationMap.has(gridLocation)) {
	                continue;
	            }
	            var gridLocationStr = (0, storage_1.getItemFromLocalStorage)("GridLocation", lang, gridLocation);
	            if (gridLocationStr) {
	                var gridLoc = JSON.parse(gridLocationStr);
	                gridLoc.$cached = true;
	                gridArray.push(gridLoc);
	                gridLocations.splice(i, 1);
	            }
	        }
	        console.log("fetchGridsFromCache from %s requested gridLocations, %s found in cache, %s gridLocations to fetch from server", oldSize, gridArray.length, gridLocations.length);
	        return gridArray;
	    };
	    /**
	     * urceno pouze pro admin editaci gridLocation
	     * @param gridLocation
	     * @returns {*}
	     */
	    GridService.prototype.readGridLocation = function (gridLocation) {
	        var gridLocationJson;
	        return axios_config_1.default.get('/core/grid-location/' + gridLocation)
	            .then(function (response) {
	            gridLocationJson = response.data;
	            return mdEntityService_1.default.fetchEntities(['GridLocation', gridLocationJson.entityName]);
	        }).then(function (entityMap) {
	            return new grid_3.GridLocation(mdEntityService_1.default.getEntity(gridLocationJson.entityName), gridLocationJson);
	        });
	    };
	    /**
	     * urceno pouze pro admin editaci gridLocationField
	     * @param fieldKey
	     * @returns {*}
	     */
	    GridService.prototype.readGridLocationField = function (fieldKey) {
	        return axios_config_1.default.get("/core/grid-location/field/" + fieldKey)
	            .then(function (response) { return new grid_1.GridLocationFieldDto(response.data); });
	    };
	    GridService.prototype.saveGridLocationFieldDto = function (gridLocationFieldObject) {
	        return axios_config_1.default.post('/core/grid-location/field', gridLocationFieldObject, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    /**
	     * urceno pouze pro admin editaci gridConfig
	     * @param gridId
	     * @returns - gridConfig
	     */
	    GridService.prototype.readGridConfig = function (gridId) {
	        var _this = this;
	        var gridConfigJson;
	        return axios_config_1.default.get('/core/grid-config/' + gridId)
	            .then(function (response) {
	            gridConfigJson = response.data;
	            return Promise.all([mdEntityService_1.default.fetchEntities([{ entity: 'FILTEROPERATOR', lov: true }, gridConfigJson.entityName]), _this.fetchGrids(gridConfigJson.gridLocation)]);
	        }).then(function (_a) {
	            var entityMap = _a[0], gridLocationMap = _a[1];
	            return new gridConfig_1.default(_this.gridLocationMap.get(gridConfigJson.gridLocation), gridConfigJson);
	        });
	    };
	    GridService.prototype.readSpecialCondition = function (specialConditionId) {
	        return axios_config_1.default.get('/core/grid-special-condition/' + specialConditionId)
	            .then(function (response) { return new gridSpecialCondition_1.GridSpecialCondition(response.data); });
	    };
	    GridService.prototype.saveSpecialCondition = function (specialCondition) {
	        return axios_config_1.default.post('/core/grid-special-condition', specialCondition)
	            .then(function (response) { return response.data; });
	    };
	    GridService.prototype.deleteSpecialCondition = function (specialConditionId) {
	        return axios_config_1.default.delete('/core/grid-special-condition/' + specialConditionId, { showPrettyError: true });
	    };
	    /**
	     * fetchne entity s Lovs se seznamy hodnot v conditions.
	     * Side effect - vola {@link MdEntityService#fetchEntities()}, takze je ulozi do #metamodel.entities
	     * @param conditions
	     * @returns {Promise.<entityObject>}
	       */
	    GridService.prototype.fetchConditionLovs = function (conditions) {
	        var valueSources = uniq(conditions.filter(function (c) { return (c.field && c.field.hasLocalValueSource()); }).map(function (c) { return ({
	            entity: c.field.valueSource,
	            lov: true
	        }); }));
	        return mdEntityService_1.default.fetchEntities(valueSources);
	    };
	    /*
	     * Spocita width, min-width a max-width pro sloupce gridu.
	     *
	     * return Array[widths, min-widths, max-widths]
	     */
	    GridService.prototype.computeGridWidths = function (data, gridConfig) {
	        //console.time("computeGridWidths");
	        // maximalni hodnota, kterou muze nabyvat min-width
	        var MAXIMAL_COLUMN_MIN_WIDTH_PX = gridConfig.maxColumnWidth;
	        // hodnata pro max-width sloupcu
	        var MAXIMAL_COLUMN_WIDTH_PX = 7000;
	        // retezec, ktery se doplni z text headeru pro vypocet sirky (zastupuje symobl razeni a filtru)
	        var HEADER_ADDITIONAL_STRING = 'AA';
	        // sirka pripocitavana ke spocitane sirce sloupce (aby text nebyl od uplneho kraje k uplnemu kraji)
	        var CELL_PADDING_PX = 5;
	        var matrix = [];
	        var headers = gridConfig.columns.map(function (gcCol) {
	            var v = gcCol.gridHeaderLabelActive;
	            return ((v) ? v.trim() : "") + HEADER_ADDITIONAL_STRING;
	        });
	        matrix.push.apply(matrix, headers);
	        //console.log("Array: %o", matrix);
	        if (data) {
	            for (var _i = 0, _a = data.pageMap.values(); _i < _a.length; _i++) {
	                var rows = _a[_i];
	                for (var _b = 0, rows_1 = rows; _b < rows_1.length; _b++) {
	                    var row = rows_1[_b];
	                    for (var i = 0; i < row.cells.length; i++) {
	                        var cellValue = row.cells[i].value;
	                        var str = (cellValue) ? ((typeof cellValue == 'string') ? cellValue.trim() : row.cells[i].value.toString().trim()) : "";
	                        if (matrix[i].length < str.length) {
	                            matrix[i] = str;
	                        }
	                    }
	                }
	            }
	        }
	        //let absoluteLengths = _.zip(...matrix).map(col => _.max(col));
	        // let absoluteMax = sum(absoluteLengths);
	        // puvodni vypocet sirky sloupcu - podle nejdelsich textu
	        // let gridWidths = absoluteLengths.map(v => Math.round(10000 * v / absoluteMax)/100 + "%");
	        // vypocet min-width pro sloupce - pomoci fiktivnich DIVu
	        // horni hranice pro min-width je MAXIMAL_COLUMN_MAX_WIDTH_PX
	        var gridMinWidthsPX = matrix.map(function (v) {
	            var elemDiv = document.createElement('div');
	            elemDiv.style.cssText = 'font-family:\'Roboto Condensed\',\'Helvetica Neue\',Helvetica,Arial,sans-serif;font-size:13px;position:absolute;left:0px;top:0px;z-index:0;visibility:hidden;';
	            elemDiv.textContent = v;
	            document.body.appendChild(elemDiv);
	            var elemWidth = elemDiv.clientWidth + CELL_PADDING_PX;
	            document.body.removeChild(elemDiv);
	            return elemWidth < MAXIMAL_COLUMN_MIN_WIDTH_PX ? elemWidth : MAXIMAL_COLUMN_MIN_WIDTH_PX;
	        });
	        // udelame sumu minWidths
	        var sumGridMinWidths = sum(gridMinWidthsPX);
	        // spocitame width pro sloupce tak, aby odpovidaly pomerum min-width
	        var gridWidthsPrct = gridMinWidthsPX.map(function (v) { return ((100 * v) / sumGridMinWidths); });
	        // spocitame maxWidths (jen vytvorime array)
	        var gridMaxWidthsPX = Array.from(new Array(gridWidthsPrct.length), function () { return MAXIMAL_COLUMN_WIDTH_PX; });
	        //console.timeEnd("computeGridWidths");
	        //  console.debug('computeGridWidths: %O', gridWidthsPrct);
	        //  console.debug('computeGridMinWidths: %O', gridMinWidthsPX);
	        //  console.debug('computeGridMaxWidths: %O', gridMaxWidthsPX);
	        return [gridWidthsPrct, gridMinWidthsPX, gridMaxWidthsPX];
	    };
	    GridService.prototype.validateCondition = function (condition, errorMessages, index, allOperators) {
	        if (!condition.field || !condition.operator) {
	            errorMessages.push({ message: (index + 1) + ". Filter must have column and operator" });
	            return false;
	        }
	        var operatorLov = allOperators.find(function (li) { return li.value === condition.operator; });
	        var cardinality = operatorLov.inputCount;
	        if (cardinality == 1 || cardinality == "N") {
	            if (isEmpty(condition.values) || condition.values[0] == null) {
	                errorMessages.push({ message: (index + 1) + ". Filter must have value" });
	                return false;
	            }
	        }
	        else if (cardinality == 2) {
	            if (isEmpty(condition.values) || condition.values.length < 2 || condition.values[0] == null || condition.values[1] == null) {
	                errorMessages.push({ message: (index + 1) + ". Filter must have two values" });
	                return false;
	            }
	        }
	        return true;
	    };
	    GridService.prototype.validateSortColumn = function (sortColumns, sortColumn, errorMessages, index) {
	        if (!sortColumn.field || !sortColumn.sortOrder) {
	            errorMessages.push({ message: (index + 1) + ". Grid ordering must have column and direction" });
	            return false;
	        }
	        if (sortColumn.fixed) {
	            if (sortColumns.filter(function (v, i) { return (!v.fixed && i < index); }).length > 0) {
	                errorMessages.push({ message: " Fixed ordering must be at the beginning of the ordering list (eg. It is not allowed to have first ordering non fixed and second fixed." });
	                return false;
	            }
	        }
	        return true;
	    };
	    GridService.prototype.computeConfigLevels = function (gridLocation, gridConfig) {
	        var disabled = !gridConfig || gridConfig.gridId < 0;
	        var configlevelOptions = mdEntityService_1.default.getEntity("CONFIGLEVEL").lovItems;
	        var securableId = (0, formUtils_1.lovValue)(gridLocation.securable);
	        if (securableId) {
	            var mapa_1 = { GLOBAL: "PublicGrid", TENANT: "TenantGrid", TENANTGROUP: "TenantGroupGrid" };
	            var permissionList_1 = securityService_1.default.permissionList(securableId);
	            var currentClValue_1 = (gridConfig) ? (0, formUtils_1.lovValue)(gridConfig.configLevel) : null;
	            configlevelOptions = configlevelOptions.filter(function (lov) {
	                var clValue = (0, formUtils_1.lovValue)(lov);
	                var requiredPermission = mapa_1[clValue];
	                return !requiredPermission || (permissionList_1 && permissionList_1.includes(requiredPermission) || clValue === currentClValue_1);
	            });
	            var requiredPermission = mapa_1[currentClValue_1];
	            disabled = disabled || (requiredPermission && !permissionList_1.includes(requiredPermission));
	        }
	        return { configlevelOptions: configlevelOptions, disabled: disabled };
	    };
	    GridService.prototype.getRowIds = function (grid, firstRows) {
	        var params = grid.createParams();
	        params.page = 1;
	        return axios_config_1.default.get("/core/grid/".concat(grid.activeGridConfig.gridId, "/rows-ids/").concat(firstRows), { params: params })
	            .then(function (response) { return response.data; });
	    };
	    GridService.prototype.innerSearch = function (gridId, params) {
	        return axios_config_1.default.get('/core/grid/' + gridId, { params: params });
	    };
	    GridService.prototype.search = function (grid, refresh, page) {
	        var _this = this;
	        if (refresh === void 0) { refresh = true; }
	        if (page === void 0) { page = 1; }
	        var params = grid.createParams();
	        params.page = page;
	        console.debug("%c running search with gridLocation = %s, gridId = %s, searchTerm = %s, masterId = %s, params = %O", "background-color: green", grid.gridLocation, grid.activeGridConfig.gridId, grid.searchTerm, grid.masterId, params);
	        var _gridData;
	        return this.innerSearch(grid.activeGridConfig.gridId, params)
	            .then((0, mobx_1.action)("gridService-search-callback-1", function (response) {
	            _gridData = response.data;
	            if (refresh || !grid.data) {
	                grid.data = new grid_2.GridData(grid, response.data);
	            }
	            //gridConfig cache busting
	            if (grid.data.configDateCreated === grid.activeGridConfig.dateCreated) {
	                return Promise.resolve(grid);
	            }
	            else {
	                console.log('Timestamp of configDateCreated (' + grid.data.configDateCreated + ') is different than date in cache (' + grid.activeGridConfig.dateCreated + ') => refetching deleting from cache');
	                return _this.readGridConfig(grid.activeGridConfig.gridId)
	                    .then((0, mobx_1.action)("gridService-grid-config-callback", function (newGridConfig) {
	                    newGridConfig.gridWidths = gridService.computeGridWidths(null, newGridConfig);
	                    grid.assignActiveGridConfig(newGridConfig);
	                    grid.replaceGridConfig(newGridConfig);
	                    _this.gridLocationMap.get(grid.gridLocation).replaceGridConfig(newGridConfig);
	                    (0, storage_1.removeItemFromLocalStorage)("GridLocation", locales_1.loc.lang, grid.gridLocation);
	                    return grid;
	                }));
	            }
	        }))
	            .then((0, mobx_1.action)("gridService-search-callback-2", function (response) {
	            grid.loading = false;
	            var page = (_gridData.page != null) ? _gridData.page : 1;
	            grid.data.initData(page, _gridData.rows, _gridData.aggregateRows);
	            grid.gridWidths = _this.computeGridWidths(grid.data, grid.activeGridConfig);
	            return grid;
	        }), function (err) {
	            grid.loading = false;
	            throw err;
	        });
	    };
	    GridService.prototype.chart = function (grid, customColumns) {
	        var params = grid.createFullParams();
	        var rowIds = params.rowid;
	        params.rowid = undefined;
	        return axios_config_1.default.post('/core/grid/' + grid.activeGridConfig.gridId + "/chart", { rowIds: rowIds, customColumns: customColumns }, { params: params })
	            .then((0, mobx_1.action)("gridService-chart-callback-1", function (response) {
	            return new chart_1.default(response.data);
	        }));
	    };
	    GridService.prototype.exportUrl = function (grid, format, inline) {
	        var params = grid.createFullParams();
	        params.inline = inline;
	        return (0, domUtils_1.buildURL)('/api/core/grid/export/' + format + '/' + grid.activeGridConfig.gridId, (0, utils_1.addTenantToQuery)(params));
	    };
	    GridService.prototype.documentExportUrl = function (grid, documentTypeId, inline) {
	        var params = grid.createFullParams();
	        params.inline = inline;
	        return (0, domUtils_1.buildURL)('/api/core/grid/generate-document/' + documentTypeId + '/' + grid.activeGridConfig.gridId, (0, utils_1.addTenantToQuery)(params));
	    };
	    GridService.prototype.documentDownloadUrl = function (grid, documentLocation, documentCountObject, inline) {
	        var finalParams = grid.createFullParams(documentCountObject.gridParams);
	        finalParams.inline = inline;
	        finalParams.duplexPrinting = documentCountObject.duplexPrinting;
	        return (0, domUtils_1.buildURL)('/api/core/grid/download-document/' + documentLocation + '/' + documentCountObject.selectedFormat + '/' + grid.activeGridConfig.gridId, (0, utils_1.addTenantToQuery)(finalParams));
	    };
	    GridService.prototype.setDefault = function (gridId, gridLocation) {
	        return axios_config_1.default.post('/core/grid-config/set-default', { gridId: gridId, gridLocation: gridLocation });
	    };
	    GridService.prototype.formatRow = function (gridId, rowObject, paramSpec) {
	        return axios_config_1.default.post('/core/grid/format-row/' + gridId, rowObject, { params: paramSpec })
	            .then(function (response) { return response.data; });
	    };
	    GridService.prototype.multiUpdate = function (multiUpdateDto) {
	        return axios_config_1.default.post('/core/grid-multi-update', multiUpdateDto)
	            .then(function (response) { return new multiUpdateDialog_1.MultiUpdateDto(response.data); });
	    };
	    GridService.prototype.generateActivity = function (grid, gridActivityDto, part) {
	        return axios_config_1.default.post('/core/grid/generate-activity/' + part, gridActivityDto, { showPrettyError: true })
	            .then(function (response) { return new eventDomain_1.GridActivityDto(response.data); });
	    };
	    GridService.prototype.getColumnsFromSql = function (sqlCommand, gridLocation) {
	        return axios_config_1.default.post('/core/grid-config/parse-sql', { sqlCommand: sqlCommand, "gridLocation": gridLocation.gridLocation }, { showPrettyError: true })
	            .then(function (response) { return new gridConfig_1.default(gridLocation, response.data); });
	    };
	    GridService.prototype.doMultipleEmail = function (gridBulkEntityDto, entityName, part) {
	        return axios_config_2.default.post('/core/grid/email-multiple/' + entityName + "/" + part, gridBulkEntityDto, { showPrettyError: true })
	            .then(function (response) { return new gridUtils_1.GridBulkEntityDto(response.data); });
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridService.prototype, "gridLocationMap", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridService.prototype, "gridMap", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridService.prototype, "gridConfig", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridService.prototype, "gridLocationObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridService.prototype, "specialConditionObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridService.prototype, "gridLocationFieldObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridService.prototype, "fetchGrids", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridService.prototype, "initGrid", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridService.prototype, "removeGrid", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridService.prototype, "getRowIds", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridService.prototype, "search", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridService.prototype, "chart", null);
	    return GridService;
	}());
	var gridService = new GridService();
	exports.default = gridService;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_select_1 = tslib_1.__importDefault(__webpack_require__(1866));
	var transitions_1 = tslib_1.__importDefault(__webpack_require__(42));
	__webpack_require__(1285);
	var mobx_1 = __webpack_require__(5);
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var colors_1 = __webpack_require__(29);
	var selectSearchDialog_1 = tslib_1.__importDefault(__webpack_require__(311));
	var locales_1 = __webpack_require__(15);
	var InputDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    width: 100%;\n    height: 100%;\n    visibility: hidden;\n"], ["\n    width: 100%;\n    height: 100%;\n    visibility: hidden;\n"])));
	var SearchSpan = styled_components_1.default.span(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n    position: absolute;\n    bottom: 18px;\n    right: 0;\n    color: ", ";\n"], ["\n    position: absolute;\n    bottom: 18px;\n    right: 0;\n    color: ", ";\n"])), colors_1.grey500);
	var SearchAnchor = styled_components_1.default.a(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
	/**
	 * Komponenta StyledSelect v designu Material-UI.
	 *
	 * Komponenta pro vyber z nekolika moznosti s vyhledavanim. Podporuje mod "multi", ve kterem lze zvolit vice moznosti
	 * zaroven. V "ne-multi" modu se komponenta v toku dokumentu chova jako komponenta TextField z material UI.
	 *
	 * V modu "multi" je komponenta dostylovana tak aby zapadala do material designu. V takovem pripade ma nastavenou
	 * vysku na automatickou (height: auto) a minimalni vysku na 48px (min-height: 48px). Pro praci s velikosti kopmonenty
	 * je treba prekryt minimalni vysku komponenty (min-height) namisto klasicke vysky (height), jak je tomu u TextField
	 * z material-ui.
	 *
	 */
	var StyledSelect = /** @class */ (function (_super) {
	    tslib_1.__extends(StyledSelect, _super);
	    function StyledSelect(props) {
	        var _this = _super.call(this, props) || this;
	        _this.onBlurEvent = function (e) {
	            _this.setState({ focused: false });
	            if (_this.props.onBlur) {
	                _this.props.onBlur(e);
	            }
	        };
	        _this.onFocusEvent = function (e) {
	            _this.setState({ focused: true });
	            if (_this.props.onFocus) {
	                _this.props.onFocus(e);
	            }
	        };
	        _this.onChangeEvent = function (value) {
	            value = ((value && value.value === null && value.label === '---') || (!_this.props.multi && (0, mobx_1.isArrayLike)(value))) ? null : value; // to || (!this.props.multi &&isArray(value)) je https://github.com/JedWatson/react-select/issues/1215
	            if (_this.props.onChange) {
	                _this.props.onChange(value);
	            }
	            if (_this.props.onValueEmpty && !value) {
	                _this.props.onValueEmpty();
	            }
	        };
	        _this.onSearch = function () {
	            console.log('onSearch');
	            new Promise(function (resolve, reject) {
	                return _this.selectSearchDialogRef.open(resolve, reject);
	            }).then((0, mobx_1.action)("close-new-party-diaglog", function (foundPartyLov) {
	                _this.onChangeEvent(foundPartyLov);
	            })).catch(function (e) { });
	        };
	        _this.identity = function (a) { return a; };
	        _this.selectSearchDialogRefHandler = function (comp) { return _this.selectSearchDialogRef = comp; };
	        _this.state = {
	            focused: false
	        };
	        return _this;
	    }
	    StyledSelect.prototype.componentDidMount = function () {
	        var _a = this.props, name = _a.name, floatingLabelText = _a.floatingLabelText;
	        this._uniqueId = (name + '-' + floatingLabelText + '-' + Math.floor(Math.random() * 0xFFFF)).replace(/[^A-Za-z0-9-]/gi, '');
	    };
	    StyledSelect.prototype.render = function () {
	        var _a = this.props, errorText = _a.errorText, loadOptions = _a.loadOptions, cache = _a.cache, clearable = _a.clearable, disabled = _a.disabled, filterOption = _a.filterOption, filterOptions = _a.filterOptions, floatingLabelStyle = _a.floatingLabelStyle, floatingLabelText = _a.floatingLabelText, id = _a.id, ignoreCase = _a.ignoreCase, multi = _a.multi, name = _a.name, options = _a.options, searchable = _a.searchable, searchPromptText = _a.searchPromptText, value = _a.value, valueRenderer = _a.valueRenderer, async = _a.async, minimumInput = _a.minimumInput, hintText = _a.hintText, asterixForAll = _a.asterixForAll, fullWidth = _a.fullWidth, mdField = _a.mdField, advancedSearchGL = _a.advancedSearchGL, advancedSearchMasterId = _a.advancedSearchMasterId, advancedSearchContentStyle = _a.advancedSearchContentStyle, advancedSearchShowGridConfig = _a.advancedSearchShowGridConfig, advancedSearchTitle = _a.advancedSearchTitle, other = tslib_1.__rest(_a, ["errorText", "loadOptions", "cache", "clearable", "disabled", "filterOption", "filterOptions", "floatingLabelStyle", "floatingLabelText", "id", "ignoreCase", "multi", "name", "options", "searchable", "searchPromptText", "value", "valueRenderer", "async", "minimumInput", "hintText", "asterixForAll", "fullWidth", "mdField", "advancedSearchGL", "advancedSearchMasterId", "advancedSearchContentStyle", "advancedSearchShowGridConfig", "advancedSearchTitle"]);
	        var inputId = id || this._uniqueId;
	        var styles = {
	            root: {
	                fontSize: 16,
	                lineHeight: '24px',
	                width: fullWidth ? '100%' : 256,
	                height: floatingLabelText ? 72 : 48,
	                display: 'inline-block',
	                position: 'relative',
	                fontFamily: 'Roboto+Condensed, sans-serif',
	                transition: transitions_1.default.easeOut('200ms', 'height'),
	            }
	        };
	        var selectClassName = "StyledSelect";
	        if (this.state.focused) {
	            selectClassName += " is-focused";
	        }
	        if ((value && (value.toString().length > 0))) {
	            selectClassName += " has-value";
	        }
	        if (errorText) {
	            selectClassName += " is-error";
	        }
	        if (multi) {
	            selectClassName += " is-multi";
	        }
	        if (async) {
	            selectClassName += " is-async";
	        }
	        if ((0, mobx_1.isArrayLike)(options) && !Array.isArray(options)) {
	            options = options.slice();
	        }
	        if ((0, mobx_1.isArrayLike)(value) && !Array.isArray(value)) {
	            value = value.slice();
	        }
	        if (async && asterixForAll) {
	            if (!searchPromptText)
	                searchPromptText = locales_1.loc.get("search.hintText");
	            if (!filterOption)
	                filterOption = this.identity;
	        }
	        // <input className="rowAligner" type="text" style={{width: '100%', height: '100%', visibility: 'hidden'}} />
	        var floatingLabelTextElement = floatingLabelText ? (react_1.default.createElement("label", { className: "SelectLabel", htmlFor: inputId, style: floatingLabelStyle }, floatingLabelText)) : null;
	        var nativeStyle = {};
	        if (advancedSearchGL) {
	            clearable = false;
	            nativeStyle["width"] = "95%";
	        }
	        return (react_1.default.createElement("div", { className: selectClassName, style: Object.assign(styles.root, this.props.style) },
	            floatingLabelTextElement,
	            react_1.default.createElement(InputDiv, { className: "rowAligner", type: "text" }),
	            (advancedSearchGL) ? react_1.default.createElement(SearchAnchor, { onClick: this.onSearch },
	                " ",
	                react_1.default.createElement(SearchSpan, { className: "fa fa-search" }),
	                " ") : null,
	            (advancedSearchGL) ? (react_1.default.createElement(selectSearchDialog_1.default, { ref: this.selectSearchDialogRefHandler, gridLocation: advancedSearchGL, masterId: advancedSearchMasterId, contentStyle: advancedSearchContentStyle, showGridConfig: advancedSearchShowGridConfig, title: advancedSearchTitle })) : null,
	            (async) ?
	                react_1.default.createElement(react_select_1.default.Async, { onFocus: this.onFocusEvent, onBlur: this.onBlurEvent, onChange: this.onChangeEvent, name: name, valueRenderer: valueRenderer, value: value, multi: multi, loadOptions: loadOptions, disabled: disabled, clearable: clearable, minimumInput: minimumInput, autoload: minimumInput === 0, cache: cache, filterOptions: filterOptions, filterOption: filterOption, searchPromptText: searchPromptText, placeholder: hintText, ignoreAccents: false, wrapperStyle: nativeStyle })
	                :
	                    react_1.default.createElement(react_select_1.default, { onFocus: this.onFocusEvent, onBlur: this.onBlurEvent, onChange: this.onChangeEvent, name: name, valueRenderer: valueRenderer, value: value, options: options, clearable: clearable, searchable: searchable, multi: multi, disabled: disabled, placeholder: hintText, matchProp: "label", style: nativeStyle }),
	            react_1.default.createElement("hr", { className: "underscore-grey" }),
	            react_1.default.createElement("hr", { className: "underscore-blue" }),
	            react_1.default.createElement("div", { className: "errorText" }, errorText)));
	    };
	    StyledSelect.defaultProps = {
	        minimumInput: 1,
	        cache: false
	    };
	    return StyledSelect;
	}(react_1.default.PureComponent));
	exports.default = StyledSelect;
	var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Validate = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var isEqual = __webpack_require__(125);
	var bluebird_1 = __webpack_require__(1007);
	var Observable_1 = __webpack_require__(94);
	var Subject_1 = __webpack_require__(260);
	var isPromise_1 = __webpack_require__(556);
	__webpack_require__(1981);
	__webpack_require__(1982);
	__webpack_require__(911);
	__webpack_require__(910);
	__webpack_require__(1980);
	var definedRules = tslib_1.__importStar(__webpack_require__(56));
	/**
	 * Vytvori RuleType[] ze vstupu (field a Validate children)
	 * @param children
	 * @param field
	 * @param value
	 * @returns {RuleType[]}
	 */
	function createRules(children, field, value) {
	    var rules = react_1.default.Children.toArray(children).filter(function (c) { return c; }).map(function (c) {
	        return { fn: c.type, args: tslib_1.__assign({ value: value }, c.props), name: c.type.name };
	    });
	    // pridame definition validatory
	    if (field.validators) {
	        for (var _i = 0, _a = field.validators; _i < _a.length; _i++) {
	            var v = _a[_i];
	            var fn = definedRules[v.validation];
	            if (!fn)
	                throw new Error('Rule ' + v.validation + ' is not defined');
	            rules.push({ fn: fn, name: fn.name, args: tslib_1.__assign({ value: value, qualifyExpr: v.qualifyExpr }, v.parameters) });
	        }
	    }
	    // console.log('rules ', rules);
	    // validate the rules
	    for (var _b = 0, rules_1 = rules; _b < rules_1.length; _b++) {
	        var r = rules_1[_b];
	        if (typeof r.fn !== 'function') {
	            throw new Error('Rule type is not a function'); // TODO better message
	        }
	    }
	    return rules;
	}
	function validate(rules, dataObject) {
	    return new Promise(function (resolve, reject) {
	        var asyncRules = [];
	        var wasPromise = false;
	        var warningResult;
	        // resolve all synchronous rules first to prevent server load, save async
	        // rules to array to deal with later
	        for (var _i = 0, rules_2 = rules; _i < rules_2.length; _i++) {
	            var rule = rules_2[_i];
	            var fn = rule.fn, args = rule.args, name = rule.name;
	            var qualifyExpr = args.qualifyExpr, otherArgs = tslib_1.__rest(args, ["qualifyExpr"]);
	            var qualifyResult = true;
	            if (qualifyExpr && dataObject) {
	                var that = dataObject; // saby this bylo dostupne v eval, tedy je tam dustupne jako that
	                qualifyResult = eval(qualifyExpr);
	            }
	            var result = (qualifyResult) ? fn(otherArgs) : { valid: true };
	            if (wasPromise || (0, isPromise_1.isPromise)(result)) {
	                wasPromise = true;
	                asyncRules.push({ name: name, result: Promise.resolve(result) });
	            }
	            else {
	                var valid = result.valid, reason = result.reason;
	                if (!valid) {
	                    resolve({ valid: false, error: reason, rule: name, rules: rules });
	                    return;
	                }
	                else if (valid && reason) {
	                    warningResult = { valid: valid, error: reason, rule: name, rules: rules };
	                }
	            }
	        }
	        (0, bluebird_1.reduce)(asyncRules, function (isOk, _a) {
	            var name = _a.name, result = _a.result;
	            if (!isOk) {
	                return false;
	            }
	            else {
	                return result
	                    .then(function (_a) {
	                    var valid = _a.valid, reason = _a.reason;
	                    if (!valid) {
	                        resolve({ valid: false, error: reason, rule: name, rules: rules });
	                        return false;
	                    }
	                    else {
	                        if (!warningResult && reason)
	                            warningResult = { valid: valid, error: reason, rule: name, rules: rules };
	                        return true;
	                    }
	                });
	            }
	        }, true).then(function (isOk) {
	            if (isOk) {
	                var res = { valid: true, rules: rules };
	                if (warningResult) {
	                    res.error = warningResult.error;
	                    res.rule = warningResult.rule;
	                }
	                resolve(res);
	            }
	        });
	    });
	}
	;
	var Validate = /** @class */ (function (_super) {
	    tslib_1.__extends(Validate, _super);
	    function Validate() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Validate.prototype.componentDidMount = function () {
	        var _this = this;
	        var _a = this.props, children = _a.children, value = _a.value;
	        //console.log('Validate componentDidMount ', field.name);
	        this.subjectStream = new Subject_1.Subject();
	        this.cachedRules = createRules(children, this.props.field, value);
	        this.subjectStream
	            .startWith(this.cachedRules)
	            //.debounceTime(300) -- kdyz tam je tohle, tak styledDatePicker, ktery emituje onChange az na blur (ne hned pri psani) nestihne zmenit validacni stav pred uzivenim formulare
	            .switchMap(function (rules) { return Observable_1.Observable.fromPromise(validate(rules, _this.props.dataObject)); })
	            .subscribe(function (validationResult) {
	            //console.debug("field.touched = %s !field.disableValidation = %s", this.props.field.touched, !this.props.field.disableValidation);
	            _this.props.field.handleValidation({
	                validationResult: validationResult,
	                showValidation: _this.props.field.touched && !_this.props.field.disableValidation //allTouched(validationResult.rules, this.props.needTouch, this.touched)
	            }, 'startWith');
	            if (_this.props.onSuccess && _this.props.field.touched && !_this.props.field.disableValidation && validationResult.valid) {
	                _this.props.onSuccess();
	            }
	        });
	    };
	    Validate.prototype.componentWillUnmount = function () {
	        this.props.field.valid = undefined;
	        this.subjectStream.unsubscribe();
	        this.cachedRules = undefined;
	    };
	    Validate.prototype.componentWillReceiveProps = function (nextProps) {
	        var _a = this.props, value = _a.value, field = _a.field;
	        var nextField = nextProps.field, nextValue = nextProps.value, dataObject = nextProps.dataObject;
	        //console.log('Validate componentWillReceiveProps field = %s, field.disableValidation = %s, nextField .disableValidation= %s, value = %s, nextValue = %s, cachedRules = %o ', field.name, field.disableValidation, nextField.disableValidation, value, nextValue, this.cachedRules);
	        if (!isEqual(value, nextValue)) {
	            // if (value !== nextValue) { - strict equality zpusobi nekonecne cykly na invoice
	            for (var _i = 0, _b = this.cachedRules; _i < _b.length; _i++) {
	                var rule = _b[_i];
	                rule.args.value = nextValue;
	            }
	            nextField.touched = true;
	            nextField.props.validating = true;
	            this.subjectStream.next(this.cachedRules);
	        }
	    };
	    Validate.prototype.render = function () {
	        return null;
	    };
	    return Validate;
	}(react_1.default.Component));
	exports.Validate = Validate;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;
	
	var _entries = __webpack_require__(589);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.prefix = prefix;
	exports.getClassSet = getClassSet;
	exports.splitBsProps = splitBsProps;
	exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
	exports.addStyle = addStyle;
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleConfig = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	    if (typeof last === 'function') {
	      return fn.apply(undefined, args);
	    }
	    return function (Component) {
	      return fn.apply(undefined, args.concat([Component]));
	    };
	  };
	} // TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
	
	function prefix(props, variant) {
	  !(props.bsClass != null) ?  false ? (0, _invariant2.default)(false, 'A `bsClass` prop is required for this component') : (0, _invariant2.default)(false) : void 0;
	  return props.bsClass + (variant ? '-' + variant : '');
	}
	
	var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	
	  propTypes.bsClass = _propTypes2.default.string;
	  defaultProps.bsClass = defaultClass;
	
	  return Component;
	});
	
	var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _propTypes2.default.oneOf(existing);
	
	  // expose the values on the propType function for documentation
	  Component.STYLES = existing;
	  propType._values = existing;
	
	  Component.propTypes = (0, _extends3.default)({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	
	var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	
	  var values = [];
	  existing.forEach(function (size) {
	    var mappedSize = _StyleConfig.SIZE_MAP[size];
	    if (mappedSize && mappedSize !== size) {
	      values.push(mappedSize);
	    }
	
	    values.push(size);
	  });
	
	  var propType = _propTypes2.default.oneOf(values);
	  propType._values = values;
	
	  // expose the values on the propType function for documentation
	  Component.SIZES = existing;
	
	  Component.propTypes = (0, _extends3.default)({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    if (!Component.defaultProps) {
	      Component.defaultProps = {};
	    }
	    Component.defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	
	function getClassSet(props) {
	  var _classes;
	
	  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
	
	  if (props.bsSize) {
	    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
	    classes[prefix(props, bsSize)] = true;
	  }
	
	  if (props.bsStyle) {
	    classes[prefix(props, props.bsStyle)] = true;
	  }
	
	  return classes;
	}
	
	function getBsProps(props) {
	  return {
	    bsClass: props.bsClass,
	    bsSize: props.bsSize,
	    bsStyle: props.bsStyle,
	    bsRole: props.bsRole
	  };
	}
	
	function isBsProp(propName) {
	  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
	}
	
	function splitBsProps(props) {
	  var elementProps = {};
	  (0, _entries2.default)(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (!isBsProp(propName)) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	function splitBsPropsAndOmit(props, omittedPropNames) {
	  var isOmittedProp = {};
	  omittedPropNames.forEach(function (propName) {
	    isOmittedProp[propName] = true;
	  });
	
	  var elementProps = {};
	  (0, _entries2.default)(props).forEach(function (_ref2) {
	    var propName = _ref2[0],
	        propValue = _ref2[1];
	
	    if (!isBsProp(propName) && !isOmittedProp[propName]) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	/**
	 * Add a style variant to a Component. Mutates the propTypes of the component
	 * in order to validate the new variant.
	 */
	function addStyle(Component) {
	  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    styleVariant[_key2 - 1] = arguments[_key2];
	  }
	
	  bsStyles(styleVariant, Component);
	}
	
	var _curry = exports._curry = curry;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assertString;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function assertString(input) {
	  var isString = typeof input === 'string' || input instanceof String;
	
	  if (!isString) {
	    var invalidType;
	
	    if (input === null) {
	      invalidType = 'null';
	    } else {
	      invalidType = _typeof(input);
	
	      if (invalidType === 'object' && input.constructor && input.constructor.hasOwnProperty('name')) {
	        invalidType = input.constructor.name;
	      } else {
	        invalidType = "a ".concat(invalidType);
	      }
	    }
	
	    throw new TypeError("Expected string but received ".concat(invalidType, "."));
	  }
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SecuredZzUploadFlatButton = exports.ZzUploadFlatButton = exports.WithDeleteDialogZzFlatButton = exports.SecuredZzRaisedButton = exports.SecuredZzFlatButton = exports.ZzFlatButton = exports.ZzDropdownButton = exports.ZzSplitButton = exports.ZzFlatButtonRoute = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var colors_1 = __webpack_require__(29);
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var RaisedButton_1 = tslib_1.__importDefault(__webpack_require__(152));
	var utils_1 = __webpack_require__(37);
	var react_bootstrap_1 = __webpack_require__(72);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	__webpack_require__(1277);
	var disabledHoc_1 = __webpack_require__(2119);
	/* **************************************************************************************
	 *******     ZzFlatButtonRoute     *******************************************************
	 ****************************************************************************************/
	var ZzFlatButtonRoute__styleOnToolbar = {
	    padding: 0,
	    margin: 0
	};
	var ZzFlatButtonRoute__styleOnGridToolbar = {
	    padding: 0,
	    margin: 0,
	    color: colors_1.grey700
	};
	var ZzFlatButtonRoute = /** @class */ (function (_super) {
	    tslib_1.__extends(ZzFlatButtonRoute, _super);
	    function ZzFlatButtonRoute() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onClick = function (event) {
	            event.preventDefault();
	            var _a = _this.props, routeName = _a.routeName, params = _a.params, query = _a.query;
	            _this.context.router.transitionTo(routeName, params, query);
	        };
	        return _this;
	    }
	    ZzFlatButtonRoute.prototype.render = function () {
	        var _a = this.props, routeName = _a.routeName, params = _a.params, query = _a.query, style = _a.style, disabled = _a.disabled, onToolbar = _a.onToolbar, onGridToolbar = _a.onGridToolbar, permission = _a.permission, securableType = _a.securableType, securable = _a.securable, module = _a.module, children = _a.children, other = tslib_1.__rest(_a, ["routeName", "params", "query", "style", "disabled", "onToolbar", "onGridToolbar", "permission", "securableType", "securable", "module", "children"]);
	        var _style = (style && onGridToolbar) ? Object.assign({}, ZzFlatButtonRoute__styleOnGridToolbar, style) : (onGridToolbar ? ZzFlatButtonRoute__styleOnGridToolbar : style);
	        if (!securityService_1.default.hasRouterRight(this.context.router, module, securableType, securable, permission)) {
	            return react_1.default.createElement("noscript", null);
	        }
	        return (disabled) ? (react_1.default.createElement(FlatButton_1.default, tslib_1.__assign({ onClick: this.onClick, disabled: true, style: _style }, other), children)) : (react_1.default.createElement("a", { href: this.context.router.makeHref(routeName, params, (0, utils_1.addTenantToQuery)(query)), onClick: this.onClick },
	            react_1.default.createElement(FlatButton_1.default, tslib_1.__assign({ style: _style }, other), children)));
	    };
	    ZzFlatButtonRoute.contextTypes = {
	        router: prop_types_1.default.func.isRequired
	    };
	    return ZzFlatButtonRoute;
	}(react_1.default.Component));
	exports.ZzFlatButtonRoute = ZzFlatButtonRoute;
	var ZzSplitButton = function (_a) {
	    var primary = _a.primary, secondary = _a.secondary, title = _a.title, disabled = _a.disabled, onClick = _a.onClick, children = _a.children, id = _a.id, bsStyle = _a.bsStyle;
	    return (react_1.default.createElement(react_bootstrap_1.SplitButton, { bsStyle: bsStyle || "zz", disabled: disabled, onClick: onClick, title: title.toUpperCase(), id: id }, children));
	};
	exports.ZzSplitButton = ZzSplitButton;
	/* **************************************************************************************
	 *******     ZzDropdownButton     *******************************************************
	 ****************************************************************************************/
	var ZzDropdownButton = function (_a) {
	    var primary = _a.primary, secondary = _a.secondary, onToolbar = _a.onToolbar, title = _a.title, disabled = _a.disabled, onClick = _a.onClick, children = _a.children, id = _a.id;
	    return (react_1.default.createElement(react_bootstrap_1.DropdownButton, { bsStyle: "zz", disabled: disabled, onClick: onClick, title: title.toUpperCase(), id: id }, children));
	};
	exports.ZzDropdownButton = ZzDropdownButton;
	/* **************************************************************************************
	 *******     ZzFlatButton     *******************************************************
	 ****************************************************************************************/
	var ZzFlatButton = function (_a) {
	    var module = _a.module, securableType = _a.securableType, securable = _a.securable, permission = _a.permission, detailId = _a.detailId, other = tslib_1.__rest(_a, ["module", "securableType", "securable", "permission", "detailId"]);
	    return (react_1.default.createElement(FlatButton_1.default, tslib_1.__assign({}, other)));
	};
	exports.ZzFlatButton = ZzFlatButton;
	exports.SecuredZzFlatButton = (0, disabledHoc_1.disabledHoc)(FlatButton_1.default);
	exports.SecuredZzRaisedButton = (0, disabledHoc_1.disabledHoc)(RaisedButton_1.default);
	exports.WithDeleteDialogZzFlatButton = (0, disabledHoc_1.withDeleteDialogHoc)(FlatButton_1.default);
	/* **************************************************************************************
	 *******     ZzUploadFlatButton     *******************************************************
	 ****************************************************************************************/
	var uploadStyles = {
	    uploadButton: {
	        verticalAlign: 'middle',
	    },
	    uploadInput: {
	        cursor: 'pointer',
	        position: 'absolute',
	        top: 0,
	        bottom: 0,
	        right: 0,
	        left: 0,
	        width: '100%',
	        opacity: 0,
	    },
	};
	var ZzUploadFlatButton = /** @class */ (function (_super) {
	    tslib_1.__extends(ZzUploadFlatButton, _super);
	    function ZzUploadFlatButton() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onChange = function (e) {
	            var files = e.target.files || e.dataTransfer.files;
	            _this.props.handleFileUpload(files);
	        };
	        _this.onClick = function (event) {
	            event.target.value = null;
	        };
	        return _this;
	    }
	    ZzUploadFlatButton.prototype.render = function () {
	        var _a = this.props, module = _a.module, securableType = _a.securableType, securable = _a.securable, permission = _a.permission, style = _a.style, handleFileUpload = _a.handleFileUpload, accept = _a.accept, disabled = _a.disabled, other = tslib_1.__rest(_a, ["module", "securableType", "securable", "permission", "style", "handleFileUpload", "accept", "disabled"]);
	        style = (style) ? Object.assign({}, uploadStyles.uploadButton, style) : uploadStyles.uploadButton;
	        return (react_1.default.createElement(FlatButton_1.default, tslib_1.__assign({ labelPosition: "before", containerElement: 'label', style: style, disabled: disabled }, other),
	            react_1.default.createElement("input", { type: "file", disabled: disabled, style: uploadStyles.uploadInput, onChange: this.onChange, onClick: this.onClick, accept: accept })));
	    };
	    return ZzUploadFlatButton;
	}(react_1.default.Component));
	exports.ZzUploadFlatButton = ZzUploadFlatButton;
	exports.SecuredZzUploadFlatButton = (0, disabledHoc_1.disabledHoc)(ZzUploadFlatButton);
	//


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var red50 = exports.red50 = '#ffebee';
	var red100 = exports.red100 = '#ffcdd2';
	var red200 = exports.red200 = '#ef9a9a';
	var red300 = exports.red300 = '#e57373';
	var red400 = exports.red400 = '#ef5350';
	var red500 = exports.red500 = '#f44336';
	var red600 = exports.red600 = '#e53935';
	var red700 = exports.red700 = '#d32f2f';
	var red800 = exports.red800 = '#c62828';
	var red900 = exports.red900 = '#b71c1c';
	var redA100 = exports.redA100 = '#ff8a80';
	var redA200 = exports.redA200 = '#ff5252';
	var redA400 = exports.redA400 = '#ff1744';
	var redA700 = exports.redA700 = '#d50000';
	
	var pink50 = exports.pink50 = '#fce4ec';
	var pink100 = exports.pink100 = '#f8bbd0';
	var pink200 = exports.pink200 = '#f48fb1';
	var pink300 = exports.pink300 = '#f06292';
	var pink400 = exports.pink400 = '#ec407a';
	var pink500 = exports.pink500 = '#e91e63';
	var pink600 = exports.pink600 = '#d81b60';
	var pink700 = exports.pink700 = '#c2185b';
	var pink800 = exports.pink800 = '#ad1457';
	var pink900 = exports.pink900 = '#880e4f';
	var pinkA100 = exports.pinkA100 = '#ff80ab';
	var pinkA200 = exports.pinkA200 = '#ff4081';
	var pinkA400 = exports.pinkA400 = '#f50057';
	var pinkA700 = exports.pinkA700 = '#c51162';
	
	var purple50 = exports.purple50 = '#f3e5f5';
	var purple100 = exports.purple100 = '#e1bee7';
	var purple200 = exports.purple200 = '#ce93d8';
	var purple300 = exports.purple300 = '#ba68c8';
	var purple400 = exports.purple400 = '#ab47bc';
	var purple500 = exports.purple500 = '#9c27b0';
	var purple600 = exports.purple600 = '#8e24aa';
	var purple700 = exports.purple700 = '#7b1fa2';
	var purple800 = exports.purple800 = '#6a1b9a';
	var purple900 = exports.purple900 = '#4a148c';
	var purpleA100 = exports.purpleA100 = '#ea80fc';
	var purpleA200 = exports.purpleA200 = '#e040fb';
	var purpleA400 = exports.purpleA400 = '#d500f9';
	var purpleA700 = exports.purpleA700 = '#aa00ff';
	
	var deepPurple50 = exports.deepPurple50 = '#ede7f6';
	var deepPurple100 = exports.deepPurple100 = '#d1c4e9';
	var deepPurple200 = exports.deepPurple200 = '#b39ddb';
	var deepPurple300 = exports.deepPurple300 = '#9575cd';
	var deepPurple400 = exports.deepPurple400 = '#7e57c2';
	var deepPurple500 = exports.deepPurple500 = '#673ab7';
	var deepPurple600 = exports.deepPurple600 = '#5e35b1';
	var deepPurple700 = exports.deepPurple700 = '#512da8';
	var deepPurple800 = exports.deepPurple800 = '#4527a0';
	var deepPurple900 = exports.deepPurple900 = '#311b92';
	var deepPurpleA100 = exports.deepPurpleA100 = '#b388ff';
	var deepPurpleA200 = exports.deepPurpleA200 = '#7c4dff';
	var deepPurpleA400 = exports.deepPurpleA400 = '#651fff';
	var deepPurpleA700 = exports.deepPurpleA700 = '#6200ea';
	
	var indigo50 = exports.indigo50 = '#e8eaf6';
	var indigo100 = exports.indigo100 = '#c5cae9';
	var indigo200 = exports.indigo200 = '#9fa8da';
	var indigo300 = exports.indigo300 = '#7986cb';
	var indigo400 = exports.indigo400 = '#5c6bc0';
	var indigo500 = exports.indigo500 = '#3f51b5';
	var indigo600 = exports.indigo600 = '#3949ab';
	var indigo700 = exports.indigo700 = '#303f9f';
	var indigo800 = exports.indigo800 = '#283593';
	var indigo900 = exports.indigo900 = '#1a237e';
	var indigoA100 = exports.indigoA100 = '#8c9eff';
	var indigoA200 = exports.indigoA200 = '#536dfe';
	var indigoA400 = exports.indigoA400 = '#3d5afe';
	var indigoA700 = exports.indigoA700 = '#304ffe';
	
	var blue50 = exports.blue50 = '#e3f2fd';
	var blue100 = exports.blue100 = '#bbdefb';
	var blue200 = exports.blue200 = '#90caf9';
	var blue300 = exports.blue300 = '#64b5f6';
	var blue400 = exports.blue400 = '#42a5f5';
	var blue500 = exports.blue500 = '#2196f3';
	var blue600 = exports.blue600 = '#1e88e5';
	var blue700 = exports.blue700 = '#1976d2';
	var blue800 = exports.blue800 = '#1565c0';
	var blue900 = exports.blue900 = '#0d47a1';
	var blueA100 = exports.blueA100 = '#82b1ff';
	var blueA200 = exports.blueA200 = '#448aff';
	var blueA400 = exports.blueA400 = '#2979ff';
	var blueA700 = exports.blueA700 = '#2962ff';
	
	var lightBlue50 = exports.lightBlue50 = '#e1f5fe';
	var lightBlue100 = exports.lightBlue100 = '#b3e5fc';
	var lightBlue200 = exports.lightBlue200 = '#81d4fa';
	var lightBlue300 = exports.lightBlue300 = '#4fc3f7';
	var lightBlue400 = exports.lightBlue400 = '#29b6f6';
	var lightBlue500 = exports.lightBlue500 = '#03a9f4';
	var lightBlue600 = exports.lightBlue600 = '#039be5';
	var lightBlue700 = exports.lightBlue700 = '#0288d1';
	var lightBlue800 = exports.lightBlue800 = '#0277bd';
	var lightBlue900 = exports.lightBlue900 = '#01579b';
	var lightBlueA100 = exports.lightBlueA100 = '#80d8ff';
	var lightBlueA200 = exports.lightBlueA200 = '#40c4ff';
	var lightBlueA400 = exports.lightBlueA400 = '#00b0ff';
	var lightBlueA700 = exports.lightBlueA700 = '#0091ea';
	
	var cyan50 = exports.cyan50 = '#e0f7fa';
	var cyan100 = exports.cyan100 = '#b2ebf2';
	var cyan200 = exports.cyan200 = '#80deea';
	var cyan300 = exports.cyan300 = '#4dd0e1';
	var cyan400 = exports.cyan400 = '#26c6da';
	var cyan500 = exports.cyan500 = '#00bcd4';
	var cyan600 = exports.cyan600 = '#00acc1';
	var cyan700 = exports.cyan700 = '#0097a7';
	var cyan800 = exports.cyan800 = '#00838f';
	var cyan900 = exports.cyan900 = '#006064';
	var cyanA100 = exports.cyanA100 = '#84ffff';
	var cyanA200 = exports.cyanA200 = '#18ffff';
	var cyanA400 = exports.cyanA400 = '#00e5ff';
	var cyanA700 = exports.cyanA700 = '#00b8d4';
	
	var teal50 = exports.teal50 = '#e0f2f1';
	var teal100 = exports.teal100 = '#b2dfdb';
	var teal200 = exports.teal200 = '#80cbc4';
	var teal300 = exports.teal300 = '#4db6ac';
	var teal400 = exports.teal400 = '#26a69a';
	var teal500 = exports.teal500 = '#009688';
	var teal600 = exports.teal600 = '#00897b';
	var teal700 = exports.teal700 = '#00796b';
	var teal800 = exports.teal800 = '#00695c';
	var teal900 = exports.teal900 = '#004d40';
	var tealA100 = exports.tealA100 = '#a7ffeb';
	var tealA200 = exports.tealA200 = '#64ffda';
	var tealA400 = exports.tealA400 = '#1de9b6';
	var tealA700 = exports.tealA700 = '#00bfa5';
	
	var green50 = exports.green50 = '#e8f5e9';
	var green100 = exports.green100 = '#c8e6c9';
	var green200 = exports.green200 = '#a5d6a7';
	var green300 = exports.green300 = '#81c784';
	var green400 = exports.green400 = '#66bb6a';
	var green500 = exports.green500 = '#4caf50';
	var green600 = exports.green600 = '#43a047';
	var green700 = exports.green700 = '#388e3c';
	var green800 = exports.green800 = '#2e7d32';
	var green900 = exports.green900 = '#1b5e20';
	var greenA100 = exports.greenA100 = '#b9f6ca';
	var greenA200 = exports.greenA200 = '#69f0ae';
	var greenA400 = exports.greenA400 = '#00e676';
	var greenA700 = exports.greenA700 = '#00c853';
	
	var lightGreen50 = exports.lightGreen50 = '#f1f8e9';
	var lightGreen100 = exports.lightGreen100 = '#dcedc8';
	var lightGreen200 = exports.lightGreen200 = '#c5e1a5';
	var lightGreen300 = exports.lightGreen300 = '#aed581';
	var lightGreen400 = exports.lightGreen400 = '#9ccc65';
	var lightGreen500 = exports.lightGreen500 = '#8bc34a';
	var lightGreen600 = exports.lightGreen600 = '#7cb342';
	var lightGreen700 = exports.lightGreen700 = '#689f38';
	var lightGreen800 = exports.lightGreen800 = '#558b2f';
	var lightGreen900 = exports.lightGreen900 = '#33691e';
	var lightGreenA100 = exports.lightGreenA100 = '#ccff90';
	var lightGreenA200 = exports.lightGreenA200 = '#b2ff59';
	var lightGreenA400 = exports.lightGreenA400 = '#76ff03';
	var lightGreenA700 = exports.lightGreenA700 = '#64dd17';
	
	var lime50 = exports.lime50 = '#f9fbe7';
	var lime100 = exports.lime100 = '#f0f4c3';
	var lime200 = exports.lime200 = '#e6ee9c';
	var lime300 = exports.lime300 = '#dce775';
	var lime400 = exports.lime400 = '#d4e157';
	var lime500 = exports.lime500 = '#cddc39';
	var lime600 = exports.lime600 = '#c0ca33';
	var lime700 = exports.lime700 = '#afb42b';
	var lime800 = exports.lime800 = '#9e9d24';
	var lime900 = exports.lime900 = '#827717';
	var limeA100 = exports.limeA100 = '#f4ff81';
	var limeA200 = exports.limeA200 = '#eeff41';
	var limeA400 = exports.limeA400 = '#c6ff00';
	var limeA700 = exports.limeA700 = '#aeea00';
	
	var yellow50 = exports.yellow50 = '#fffde7';
	var yellow100 = exports.yellow100 = '#fff9c4';
	var yellow200 = exports.yellow200 = '#fff59d';
	var yellow300 = exports.yellow300 = '#fff176';
	var yellow400 = exports.yellow400 = '#ffee58';
	var yellow500 = exports.yellow500 = '#ffeb3b';
	var yellow600 = exports.yellow600 = '#fdd835';
	var yellow700 = exports.yellow700 = '#fbc02d';
	var yellow800 = exports.yellow800 = '#f9a825';
	var yellow900 = exports.yellow900 = '#f57f17';
	var yellowA100 = exports.yellowA100 = '#ffff8d';
	var yellowA200 = exports.yellowA200 = '#ffff00';
	var yellowA400 = exports.yellowA400 = '#ffea00';
	var yellowA700 = exports.yellowA700 = '#ffd600';
	
	var amber50 = exports.amber50 = '#fff8e1';
	var amber100 = exports.amber100 = '#ffecb3';
	var amber200 = exports.amber200 = '#ffe082';
	var amber300 = exports.amber300 = '#ffd54f';
	var amber400 = exports.amber400 = '#ffca28';
	var amber500 = exports.amber500 = '#ffc107';
	var amber600 = exports.amber600 = '#ffb300';
	var amber700 = exports.amber700 = '#ffa000';
	var amber800 = exports.amber800 = '#ff8f00';
	var amber900 = exports.amber900 = '#ff6f00';
	var amberA100 = exports.amberA100 = '#ffe57f';
	var amberA200 = exports.amberA200 = '#ffd740';
	var amberA400 = exports.amberA400 = '#ffc400';
	var amberA700 = exports.amberA700 = '#ffab00';
	
	var orange50 = exports.orange50 = '#fff3e0';
	var orange100 = exports.orange100 = '#ffe0b2';
	var orange200 = exports.orange200 = '#ffcc80';
	var orange300 = exports.orange300 = '#ffb74d';
	var orange400 = exports.orange400 = '#ffa726';
	var orange500 = exports.orange500 = '#ff9800';
	var orange600 = exports.orange600 = '#fb8c00';
	var orange700 = exports.orange700 = '#f57c00';
	var orange800 = exports.orange800 = '#ef6c00';
	var orange900 = exports.orange900 = '#e65100';
	var orangeA100 = exports.orangeA100 = '#ffd180';
	var orangeA200 = exports.orangeA200 = '#ffab40';
	var orangeA400 = exports.orangeA400 = '#ff9100';
	var orangeA700 = exports.orangeA700 = '#ff6d00';
	
	var deepOrange50 = exports.deepOrange50 = '#fbe9e7';
	var deepOrange100 = exports.deepOrange100 = '#ffccbc';
	var deepOrange200 = exports.deepOrange200 = '#ffab91';
	var deepOrange300 = exports.deepOrange300 = '#ff8a65';
	var deepOrange400 = exports.deepOrange400 = '#ff7043';
	var deepOrange500 = exports.deepOrange500 = '#ff5722';
	var deepOrange600 = exports.deepOrange600 = '#f4511e';
	var deepOrange700 = exports.deepOrange700 = '#e64a19';
	var deepOrange800 = exports.deepOrange800 = '#d84315';
	var deepOrange900 = exports.deepOrange900 = '#bf360c';
	var deepOrangeA100 = exports.deepOrangeA100 = '#ff9e80';
	var deepOrangeA200 = exports.deepOrangeA200 = '#ff6e40';
	var deepOrangeA400 = exports.deepOrangeA400 = '#ff3d00';
	var deepOrangeA700 = exports.deepOrangeA700 = '#dd2c00';
	
	var brown50 = exports.brown50 = '#efebe9';
	var brown100 = exports.brown100 = '#d7ccc8';
	var brown200 = exports.brown200 = '#bcaaa4';
	var brown300 = exports.brown300 = '#a1887f';
	var brown400 = exports.brown400 = '#8d6e63';
	var brown500 = exports.brown500 = '#795548';
	var brown600 = exports.brown600 = '#6d4c41';
	var brown700 = exports.brown700 = '#5d4037';
	var brown800 = exports.brown800 = '#4e342e';
	var brown900 = exports.brown900 = '#3e2723';
	
	var blueGrey50 = exports.blueGrey50 = '#eceff1';
	var blueGrey100 = exports.blueGrey100 = '#cfd8dc';
	var blueGrey200 = exports.blueGrey200 = '#b0bec5';
	var blueGrey300 = exports.blueGrey300 = '#90a4ae';
	var blueGrey400 = exports.blueGrey400 = '#78909c';
	var blueGrey500 = exports.blueGrey500 = '#607d8b';
	var blueGrey600 = exports.blueGrey600 = '#546e7a';
	var blueGrey700 = exports.blueGrey700 = '#455a64';
	var blueGrey800 = exports.blueGrey800 = '#37474f';
	var blueGrey900 = exports.blueGrey900 = '#263238';
	
	var grey50 = exports.grey50 = '#fafafa';
	var grey100 = exports.grey100 = '#f5f5f5';
	var grey200 = exports.grey200 = '#eeeeee';
	var grey300 = exports.grey300 = '#e0e0e0';
	var grey400 = exports.grey400 = '#bdbdbd';
	var grey500 = exports.grey500 = '#9e9e9e';
	var grey600 = exports.grey600 = '#757575';
	var grey700 = exports.grey700 = '#616161';
	var grey800 = exports.grey800 = '#424242';
	var grey900 = exports.grey900 = '#212121';
	
	var black = exports.black = '#000000';
	var white = exports.white = '#ffffff';
	
	var transparent = exports.transparent = 'rgba(0, 0, 0, 0)';
	var fullBlack = exports.fullBlack = 'rgba(0, 0, 0, 1)';
	var darkBlack = exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
	var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
	var minBlack = exports.minBlack = 'rgba(0, 0, 0, 0.26)';
	var faintBlack = exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
	var fullWhite = exports.fullWhite = 'rgba(255, 255, 255, 1)';
	var darkWhite = exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
	var lightWhite = exports.lightWhite = 'rgba(255, 255, 255, 0.54)';

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MdBlockArray = exports.MdVerticalDivider = exports.MdDivider = exports.BlockComp = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var arrayUtils_1 = __webpack_require__(78);
	__webpack_require__(452);
	var mobx_react_1 = __webpack_require__(4);
	var domUtils_1 = __webpack_require__(91);
	var colors_1 = __webpack_require__(29);
	exports.BlockComp = (0, mobx_react_1.observer)(function (_a) {
	    var header = _a.header, style = _a.style, headerStyle = _a.headerStyle, className = _a.className, noPadding = _a.noPadding, children = _a.children, other = tslib_1.__rest(_a, ["header", "style", "headerStyle", "className", "noPadding", "children"]);
	    var bcClass = (0, domUtils_1.classNames)({ 'block-comp': !noPadding, 'block-comp-no-padding': noPadding }, className);
	    if (header) {
	        var margin = (noPadding) ? '10px 15px 5px 15px' : '0 0 10px 0';
	        return (react_1.default.createElement("div", { className: bcClass, style: style },
	            react_1.default.createElement("h5", { style: Object.assign({ margin: margin, fontSize: '18px' }, headerStyle) }, header),
	            react_1.default.createElement("div", null, children)));
	    }
	    else {
	        return (react_1.default.createElement("div", { className: bcClass, style: style }, children));
	    }
	});
	var MdDivider = function (_a) {
	    var inset = _a.inset, hide = _a.hide, marginTop = _a.marginTop, marginBottom = _a.marginBottom, marginRight = _a.marginRight, marginLeft = _a.marginLeft;
	    return ((!hide) ? react_1.default.createElement("hr", { style: {
	            marginTop: (marginTop == null) ? 0 : marginTop,
	            marginBottom: (marginBottom == null) ? 0 : marginBottom,
	            marginLeft: (marginLeft == null) ? ((inset) ? 20 : 0) : marginLeft,
	            marginRight: (inset) ? 20 : ((marginRight == null) ? 0 : marginRight),
	            border: 'none',
	            height: 1,
	            backgroundColor: colors_1.grey300
	        } }) : react_1.default.createElement("noscript", null));
	};
	exports.MdDivider = MdDivider;
	var MdVerticalDivider = function (_a) {
	    var inset = _a.inset, hide = _a.hide;
	    return ((!hide) ? react_1.default.createElement("div", { style: {
	            marginTop: (inset) ? 20 : 0,
	            marginBottom: (inset) ? 20 : 0,
	            width: 1,
	            minWidth: 1,
	            backgroundColor: colors_1.grey300
	        } }) : react_1.default.createElement("noscript", null));
	};
	exports.MdVerticalDivider = MdVerticalDivider;
	var MdBlockArray = function (_a) {
	    var className = _a.className, inset = _a.inset, children = _a.children;
	    return (react_1.default.createElement("div", { className: className }, (0, arrayUtils_1.addSeparator)(react_1.default.Children.toArray(children), react_1.default.createElement(exports.MdDivider, { inset: inset }))));
	};
	exports.MdBlockArray = MdBlockArray;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1757);


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mobx_1 = __webpack_require__(5);
	var last = __webpack_require__(138);
	var variables_1 = __webpack_require__(96);
	var UiService = /** @class */ (function () {
	    function UiService() {
	        this.transitionArray = [];
	        this.showToolbarAction = false;
	        this.showDialogAction = false;
	        this.globalMediaQuery = window.matchMedia('only screen and (min-width: ' + variables_1.screenLg + 'px)');
	    }
	    UiService.prototype.addMediaQueryListener = function (listener) {
	        this.globalMediaQuery.addListener(listener);
	    };
	    UiService.prototype.removeMediaQueryListener = function (listener) {
	        this.globalMediaQuery.removeListener(listener);
	    };
	    UiService.prototype.showToolbarActionFlag = function () {
	        this.showToolbarAction = true;
	    };
	    UiService.prototype.hideToolbarActionFlag = function () {
	        this.showToolbarAction = false;
	    };
	    UiService.prototype.getToolbarActionFlag = function () {
	        return this.showToolbarAction;
	    };
	    UiService.prototype.showDialogActionFlag = function () {
	        this.showDialogAction = true;
	    };
	    UiService.prototype.hideDialogActionFlag = function () {
	        this.showDialogAction = false;
	    };
	    UiService.prototype.getDialogActionFlag = function () {
	        return this.showDialogAction;
	    };
	    UiService.prototype.updateTransition = function (transitionItem) {
	        if (transitionItem.rootPage) {
	            this.transitionArray = mobx_1.observable.shallowArray([transitionItem]);
	        }
	        else {
	            if (transitionItem.newQuery.direction === 'up') {
	                this.transitionArray.pop();
	            }
	            else {
	                var lastTransitionItem = last(this.transitionArray);
	                if (!lastTransitionItem || lastTransitionItem.newRouteName !== transitionItem.newRouteName) {
	                    this.transitionArray.push(transitionItem);
	                }
	            }
	        }
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UiService.prototype, "transitionArray", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UiService.prototype, "showToolbarAction", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UiService.prototype, "showDialogAction", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], UiService.prototype, "updateTransition", null);
	    return UiService;
	}());
	var uiService = new UiService();
	exports.default = uiService;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DomainAncestor = void 0;
	exports.entityConfig = entityConfig;
	exports.fieldInfo = fieldInfo;
	var tslib_1 = __webpack_require__(3);
	var metaConstant_1 = __webpack_require__(13);
	var mobx_1 = __webpack_require__(5);
	var form_1 = tslib_1.__importDefault(__webpack_require__(52));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_2 = __webpack_require__(5);
	function entityConfig(clazz, detailRoute) {
	    return function (constructor) {
	        var entityConfig = (clazz) ? new clazz() : new metaConstant_1.EntityConfig(constructor.name);
	        entityConfig.entityConstructorFunction = constructor;
	        entityConfig.detailroute = detailRoute;
	        mdEntityService_1.default.setEntityConfig(entityConfig);
	    };
	}
	function fieldInfo(fieldClazz) {
	    return function (hostClazz, key) {
	        //console.debug('fieldInfo decorator for %s setting fieldClazz %O on %O', key, fieldClazz, hostClazz);
	        if (!fieldClazz) {
	            throw new Error("fieldInfo decorator for " + key + " on " + hostClazz.constructor.name + " does not have fieldClazz defined. Check order of Class declaration.");
	        }
	        if (!hostClazz.constructor.fieldConstructors)
	            hostClazz.constructor.fieldConstructors = {};
	        hostClazz.constructor.fieldConstructors[key] = (fieldClazz.name) ? function (o) { return fieldClazz; } : fieldClazz;
	    };
	}
	var DomainAncestor = /** @class */ (function () {
	    function DomainAncestor(json) {
	        this.$errors = mobx_1.observable.shallowArray();
	        this.$formMap = mobx_1.observable.shallowMap();
	        this.fromJson(json);
	        this.initializeEntityRef();
	    }
	    DomainAncestor.getInstance = function (name) {
	        var _a;
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var entityConfig = mdEntityService_1.default.getEntityConfig(name);
	        if (!entityConfig) {
	            throw new Error("EntityConfig not found for " + name);
	        }
	        return new ((_a = entityConfig.entityConstructorFunction).bind.apply(_a, tslib_1.__spreadArray([void 0], args, false)))();
	    };
	    /**
	     * creates class from json, is used mainly in constructor
	     * @param json
	     * @param mapFields - list of ObservableMap properties (they need special treatment)
	     * @return {DomainAncestor}
	     */
	    DomainAncestor.prototype.fromJson = function (json) {
	        var _this = this;
	        var mapFields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            mapFields[_i - 1] = arguments[_i];
	        }
	        if (json) {
	            var _loop_1 = function (key) {
	                if (json.hasOwnProperty(key)) {
	                    var rawValue = json[key];
	                    if ((0, mobx_2.isArrayLike)(rawValue)) {
	                        this_1[key] = rawValue.map(function (js) { return _this.extractValue(key, js); });
	                    }
	                    else {
	                        if (mapFields && mapFields.indexOf(key) !== -1) {
	                            var mapa = new mobx_1.ObservableMap();
	                            var mapObject = json[key];
	                            for (var mapKey in mapObject) {
	                                if (mapObject.hasOwnProperty(mapKey)) {
	                                    var mapValue = mapObject[mapKey];
	                                    mapa.set(mapKey, ((0, mobx_2.isArrayLike)(mapValue)) ? mapValue.map(function (js) { return _this.extractValue(key, js); }) : this_1.extractValue(key, mapValue));
	                                }
	                            }
	                            this_1[key] = mapa;
	                        }
	                        else {
	                            this_1[key] = this_1.extractValue(key, json[key]);
	                        }
	                    }
	                }
	            };
	            var this_1 = this;
	            for (var key in json) {
	                _loop_1(key);
	            }
	        }
	        return this;
	    };
	    DomainAncestor.prototype.prepareForServer = function () {
	        return this;
	    };
	    DomainAncestor.prototype.cloneShallow = function () {
	        var newObj = new this.constructor(null);
	        for (var key in this) {
	            newObj[key] = this[key];
	        }
	        return newObj;
	    };
	    DomainAncestor.prototype.copyStandardFields = function (newObject) {
	        for (var key in newObject) {
	            if (!key.startsWith('$')) {
	                this[key] = newObject[key];
	            }
	        }
	    };
	    DomainAncestor.prototype.cloneDeep = function () {
	        var copyFn = function (rawValue) { return (rawValue instanceof DomainAncestor) ? rawValue.cloneDeep() : rawValue; };
	        var newObj = new this.constructor(null);
	        for (var key in this) {
	            var rawValue = this[key];
	            if ((0, mobx_2.isArrayLike)(rawValue)) {
	                newObj[key] = rawValue.map(function (js) { return copyFn(js); });
	            }
	            else {
	                if (rawValue instanceof mobx_1.ObservableMap) {
	                    var mapa = new mobx_1.ObservableMap();
	                    for (var _i = 0, _a = rawValue.entries(); _i < _a.length; _i++) {
	                        var entry = _a[_i];
	                        mapa.set(entry[0], copyFn(entry[1]));
	                    }
	                    newObj[key] = mapa;
	                }
	                else {
	                    newObj[key] = copyFn(rawValue);
	                }
	            }
	        }
	        return newObj;
	    };
	    /**
	     * Smaze vsechny own properties a nasledne priradi own properties copied objektu
	     * @param copied
	     * @return void
	     */
	    DomainAncestor.prototype.shallowOwnCopyProperties = function (copied) {
	        for (var key in this) {
	            if (this.hasOwnProperty(key)) {
	                this[key] = null;
	            }
	        }
	        for (var key in copied) {
	            if (copied.hasOwnProperty(key)) {
	                this[key] = copied[key];
	            }
	        }
	    };
	    DomainAncestor.prototype.extractValue = function (key, jsonValue) {
	        if (jsonValue) {
	            var thisConstructorFn = this.constructor;
	            if (thisConstructorFn.fieldConstructors) {
	                var fieldConstructorFn = thisConstructorFn.fieldConstructors[key];
	                if (fieldConstructorFn) {
	                    var fieldConstructor = fieldConstructorFn(this);
	                    return (jsonValue instanceof fieldConstructor) ? jsonValue : new fieldConstructor(jsonValue);
	                    //console.log("extractValue key %s value %O, newValue %O", key, jsonValue, newValue);
	                }
	            }
	        }
	        return jsonValue;
	    };
	    DomainAncestor.prototype.initializeEntityRef = function () {
	        if (this.$mdEntityRef == null) {
	            this.$mdEntityRef = mdEntityService_1.default.getEntity(this.constructor.name);
	            if (this.$mdEntityRef) {
	                if (this["@class"] == null) {
	                    this["@class"] = this.$mdEntityRef.clazzName;
	                }
	                else {
	                    if (this["@class"] !== this.$mdEntityRef.clazzName) {
	                        throw new Error("@class property " + this["@class"] + " differs from mdEntity's " + this.$mdEntityRef.clazzName + " in " + this.constructor.name);
	                    }
	                }
	            }
	        }
	    };
	    DomainAncestor.prototype.getId = function () {
	        return this.id;
	    };
	    DomainAncestor.prototype.setId = function (id) {
	        this.id = id;
	    };
	    DomainAncestor.prototype.hasErrors = function () {
	        return this.$errors && this.$errors.length > 0;
	    };
	    DomainAncestor.prototype.createLov = function () {
	        return {
	            value: this.getId(),
	            label: this.label
	        };
	    };
	    DomainAncestor.prototype.cleanAfterSave = function (returningJson, cleanMovingBlocks) {
	        var _this = this;
	        if (cleanMovingBlocks === void 0) { cleanMovingBlocks = true; }
	        var retainProperties = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            retainProperties[_i - 2] = arguments[_i];
	        }
	        var oldNew = this.$new;
	        this.$dirty = false;
	        this.$new = undefined;
	        this.$added = undefined;
	        var retainObject = (retainProperties && retainProperties.length) ? retainProperties.reduce(function (a, e) { return (a[e] = _this[e], a); }, {}) : null;
	        this.fromJson(returningJson);
	        if (retainObject) {
	            Object.entries(retainObject).forEach(function (_a) {
	                var k = _a[0], v = _a[1];
	                return _this[k] = v;
	            });
	        }
	        if (cleanMovingBlocks && this.$movingBlocks) {
	            this.$movingBlocks.cleanAfterSave(this);
	        }
	        if (this.$formMap) {
	            for (var _a = 0, _b = this.$formMap.values(); _a < _b.length; _a++) {
	                var form = _b[_a];
	                form.updateAllFieldsPropValue(this);
	            }
	        }
	        return oldNew;
	    };
	    DomainAncestor.prototype.cleanOnCopy = function () {
	        this.$new = true;
	        this.$dirty = true;
	        this.userCreated = undefined;
	        this.dateCreated = undefined;
	        this.dateUpdated = undefined;
	        this.setId(null);
	    };
	    DomainAncestor.prototype.initAfterRead = function (isNew) {
	        this.initializeEntityRef();
	        if (isNew) {
	            this.initDefaultValues();
	            this.$dirty = true;
	        }
	        return this;
	    };
	    DomainAncestor.prototype.getForm = function (formName) {
	        var form = this.$formMap.get(formName);
	        if (!form) {
	            form = new form_1.default(formName, mdEntityService_1.default.getFormDefinition(formName));
	            this.$formMap.set(formName, form);
	        }
	        return form;
	    };
	    DomainAncestor.prototype.getFormFields = function (formName) {
	        var form = this.getForm(formName);
	        return form.fields;
	    };
	    DomainAncestor.prototype.getFormField = function (formName, fieldName) {
	        var form = this.getForm(formName);
	        return form.getField(fieldName);
	    };
	    DomainAncestor.prototype.initDefaultValues = function () {
	        this.initializeEntityRef();
	        // inicializace default hodnot
	        for (var _i = 0, _a = this.$mdEntityRef.getFields(); _i < _a.length; _i++) {
	            var mdField = _a[_i];
	            var defaultValue = mdField.defaultValue;
	            if (defaultValue) {
	                var that = this; // saby this bylo dostupne v eval, tedy je tam dustupne jako that
	                if (defaultValue.startsWith('@')) {
	                    eval(defaultValue.substring(1));
	                }
	                else if (this[mdField.fieldName] == null) {
	                    this[mdField.fieldName] = mdField.computeDefaultValue();
	                }
	            }
	        }
	        // dynamic fields
	        var dynFields = this["fields"];
	        if (dynFields) {
	            dynFields.forEach(function (df) {
	                df.value = df.$mdFieldRef.computeDefaultValue();
	            });
	        }
	        return this;
	    };
	    DomainAncestor.prototype.createDataObjectDto = function () {
	        return {
	            dataObject: this,
	            gridData: (this.$movingBlocks) ? this.$movingBlocks.getGridData() : {}
	        };
	    };
	    DomainAncestor.prototype.getTuple = function (name) {
	        return (this.tupleMap) ? this.tupleMap[name] : null;
	    };
	    DomainAncestor.prototype.setTuple = function (name, value) {
	        if (!this.tupleMap)
	            this.tupleMap = {};
	        this.tupleMap[name] = value;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DomainAncestor.prototype, "id", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DomainAncestor.prototype, "$dirty", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DomainAncestor.prototype, "$new", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DomainAncestor.prototype, "$added", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DomainAncestor.prototype, "$loading", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DomainAncestor.prototype, "$errors", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DomainAncestor.prototype, "$formMap", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DomainAncestor.prototype, "$headerTab", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DomainAncestor.prototype, "userCreated", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DomainAncestor.prototype, "dateCreated", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DomainAncestor.prototype, "dateUpdated", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DomainAncestor.prototype, "label", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DomainAncestor.prototype, "active", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DomainAncestor.prototype, "tupleMap", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DomainAncestor.prototype, "tenantId", void 0);
	    return DomainAncestor;
	}());
	exports.DomainAncestor = DomainAncestor;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ErrorComp = ErrorComp;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_bootstrap_1 = __webpack_require__(72);
	var uniqBy = __webpack_require__(488);
	__webpack_require__(1282);
	function ErrorComp(_a) {
	    var messages = _a.messages, style = _a.style, onDismiss = _a.onDismiss, header = _a.header, bsStyle = _a.bsStyle, className = _a.className, dismissLabel = _a.dismissLabel;
	    if (!bsStyle)
	        bsStyle = 'danger';
	    if (!className)
	        className = 'error-comp';
	    return (messages && messages.length) ? (react_1.default.createElement(react_bootstrap_1.Alert, { bsStyle: bsStyle, className: className, style: style, onDismiss: onDismiss },
	        (header) ? react_1.default.createElement("h4", null, header) : null,
	        react_1.default.createElement("ul", null, uniqBy(messages, function (v) { return v.propertyPath + v.message; }).map(function (m, i) {
	            return (react_1.default.createElement("li", { key: i },
	                " ",
	                ((m.propertyPath) ? ('Field ' + m.propertyPath + ' : ') : '') + m.message,
	                " "));
	        })),
	        (dismissLabel) ? react_1.default.createElement(react_bootstrap_1.Button, { onClick: onDismiss }, dismissLabel) : null)) : react_1.default.createElement("noscript", null);
	}


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var last = __webpack_require__(138);
	var mobx_1 = __webpack_require__(5);
	var securityDomain_1 = __webpack_require__(97);
	var SecurityService = /** @class */ (function () {
	    function SecurityService() {
	        this.processUserContext = function (response) {
	            console.log("processUserContext ", response);
	            var userContextDto = response.data;
	            var tenantIdStr = userContextDto.tenant.tenantId.toString();
	            window.sessionStorage.setItem('tenantId', tenantIdStr);
	            window.TENANT_ID = tenantIdStr;
	            // clear localStorare
	            window.localStorage.clear();
	            securityService.setUserContextDto(userContextDto);
	            return userContextDto;
	        };
	    }
	    SecurityService.prototype.setUserContextDto = function (userContextDto) {
	        this.currentUser = new securityDomain_1.UserSession(userContextDto.userSession);
	        this.currentTenant = new securityDomain_1.Tenant(userContextDto.tenant);
	        this.availableTenants = userContextDto.availableTenants;
	        this.tenantParams = userContextDto.tenantParams;
	        this.restrictionData = new securityDomain_1.RestrictionData(userContextDto.restrictionData);
	    };
	    SecurityService.prototype.login = function (username, password) {
	        return axios_config_1.default.get('/core/security/current-user-context', {
	            headers: {
	                authorization: "Basic " + btoa(username + ":" + password)
	            }
	        }).then(this.processUserContext);
	    };
	    SecurityService.prototype.impersonate = function (username) {
	        return axios_config_1.default.post("/core/security/impersonate/" + username)
	            .then(this.processUserContext);
	    };
	    SecurityService.prototype.logout = function () {
	        return axios_config_1.default.post('/core/security/logout');
	    };
	    SecurityService.prototype.readCurrentUserContext = function (config) {
	        console.log('Reading current user');
	        return axios_config_1.default.get('/core/security/current-user-context', config).then(function (response) {
	            return response.data;
	        }, function (error) {
	            if (error.response.status === 401) {
	                console.log('Not authenticated - 401 from readCurrentUser()');
	                return null;
	            }
	            else {
	                throw error;
	            }
	        });
	    };
	    SecurityService.prototype.getLastTenantId = function (username) {
	        return axios_config_1.default.get('/public/last-tenant-id', {
	            params: { username: username }
	        }).then(function (response) { return response.data; });
	    };
	    SecurityService.prototype.getTenantParamFromServer = function (tenantId, paramKey) {
	        return axios_config_1.default.get('/public/tenant-param/' + tenantId + '/' + paramKey).then(function (response) { return response.data; });
	    };
	    SecurityService.prototype.readUser = function (username) {
	        return axios_config_1.default.get('/core/security/user/' + username)
	            .then(function (response) { return new securityDomain_1.User(response.data); });
	    };
	    SecurityService.prototype.readUserProfile = function (username) {
	        return axios_config_1.default.get('/core/security/user-profile/' + username)
	            .then(function (response) { return new securityDomain_1.UserProfileDto(response.data); });
	    };
	    SecurityService.prototype.saveUserProfile = function (username, userProfileDto) {
	        return axios_config_1.default.post('/core/security/user-profile/' + username, userProfileDto)
	            .then(function (response) { return response.data; });
	    };
	    SecurityService.prototype.userExist = function (username) {
	        return axios_config_1.default.get('/core/security/user-exist/' + username)
	            .then(function (response) { return response.data; });
	    };
	    SecurityService.prototype.userCreate = function (user) {
	        return axios_config_1.default.put('/core/security/user', user, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    SecurityService.prototype.userUpdate = function (user) {
	        return axios_config_1.default.post('/core/security/user', user, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    SecurityService.prototype.deleteUser = function (username) {
	        return axios_config_1.default.delete('/core/security/user/' + username, { showPrettyError: true });
	    };
	    SecurityService.prototype.changeLastTenant = function (tenantId) {
	        return axios_config_1.default.post("/core/security/change-tenant/" + tenantId);
	    };
	    SecurityService.prototype.resetPassword = function (user, mode) {
	        return axios_config_1.default.post('/core/security/user-reset-password/' + mode, user, { showPrettyError: true });
	    };
	    SecurityService.prototype.readSecurityRole = function (roleId) {
	        return axios_config_1.default.get('/core/security/security-role/' + roleId)
	            .then(function (response) { return new securityDomain_1.SecurityRole(response.data); });
	    };
	    SecurityService.prototype.saveSecurityRole = function (securityRole) {
	        return axios_config_1.default.post('/core/security/security-role', securityRole)
	            .then(function (response) { return response.data; });
	    };
	    SecurityService.prototype.deleteSecurityRole = function (roleId) {
	        return axios_config_1.default.delete('/core/security/security-role/' + roleId, { showPrettyError: true });
	    };
	    SecurityService.prototype.getSecurables = function () {
	        return (this.securables) ? Promise.resolve(this.securables)
	            : axios_config_1.default.get('/core/security/securables').then(function (response) { return response.data; });
	    };
	    SecurityService.prototype.permissionList = function (securable) {
	        return this.currentUser && this.currentUser.permissionList(securable);
	    };
	    SecurityService.prototype.hasRight = function (securable, permission, detailId) {
	        return this.currentUser && this.currentUser.hasRight(securable, permission, detailId);
	    };
	    /**
	     *
	     * @param router
	     * @param module
	     * @param securableType
	     * @param securable - string nebo {name: string, module: string} - potom ma toto module prednost pred module prop a module z page
	     * @param permission
	     * @param detailId
	     * @returns {*}
	     */
	    SecurityService.prototype.hasRouterRight = function (router, module, securableType, securable, permission, detailId) {
	        //console.debug('hasRouterRight ', module, securableType, securable, permission);
	        if (permission) {
	            var lastRoute = null;
	            var resolvedSecurable = securable;
	            if (!module) {
	                lastRoute = last(router.getCurrentRoutes());
	                module = lastRoute.handler.module;
	            }
	            if (!securable) {
	                if (!lastRoute)
	                    lastRoute = last(router.getCurrentRoutes());
	                resolvedSecurable = lastRoute.name;
	            }
	            else {
	                if (typeof securable === 'object' && securable.name) {
	                    if (securable.module)
	                        module = securable.module;
	                    if (securable.type)
	                        securableType = securable.type;
	                    resolvedSecurable = securable.name;
	                }
	            }
	            return this.hasRight(resolvedSecurable, permission, detailId);
	        }
	        else {
	            return true;
	        }
	    };
	    SecurityService.prototype.getTenantParam = function (param) {
	        return (this.tenantParams && this.tenantParams[param]);
	    };
	    SecurityService.prototype.generateToken = function (username, userToken) {
	        return axios_config_1.default.post('/core/security/user-token-generate/' + username, userToken)
	            .then(function (response) { return new securityDomain_1.UserToken(response.data); });
	    };
	    SecurityService.prototype.deleteToken = function (tokenId) {
	        return axios_config_1.default.delete('/core/security/user-token/' + tokenId);
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurityService.prototype, "loginObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurityService.prototype, "currentUser", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurityService.prototype, "currentTenant", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurityService.prototype, "availableTenants", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurityService.prototype, "restrictionData", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurityService.prototype, "userObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurityService.prototype, "passwordObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurityService.prototype, "userProfileObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurityService.prototype, "securityRoleObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurityService.prototype, "securables", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurityService.prototype, "tenantParams", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurityService.prototype, "tenantObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SecurityService.prototype, "processUserContext", void 0);
	    return SecurityService;
	}());
	var securityService = new SecurityService();
	exports.default = securityService;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FlatButton = __webpack_require__(1518);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FlatButton2.default;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var _this = this;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.throttleWithRaf = exports.TENANT_GROUP_THRESHOLD = void 0;
	exports.formatId = formatId;
	exports.parseId = parseId;
	exports.clone = clone;
	exports.addTenantToQuery = addTenantToQuery;
	exports.isTenantNumber = isTenantNumber;
	exports.getParam = getParam;
	exports.compare = compare;
	exports.debounce = debounce;
	var isString = __webpack_require__(163);
	var isNumber = __webpack_require__(239);
	var isBoolean = __webpack_require__(1474);
	exports.TENANT_GROUP_THRESHOLD = 1000000;
	function formatId() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return args.join('_');
	}
	/**
	 * Parse id into string array
	 *     e.g. 'Party_fullName' => ['Party', 'fullName']
	 * @param id
	 * @returns {*|Array}
	 */
	function parseId(id) {
	    return id.split("_");
	}
	function clone(object) {
	    return (object) ? Object.assign(Object.create(Object.getPrototypeOf(object)), object) : object;
	}
	function addTenantToQuery(query) {
	    query = query || {};
	    query.t = window.TENANT_ID;
	    return query;
	}
	function isTenantNumber(tenantId) {
	    return (tenantId != null && tenantId > 0 && tenantId < exports.TENANT_GROUP_THRESHOLD);
	}
	function getParam(name) {
	    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
	    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
	}
	function compare(v1, v2, locale) {
	    if (v1 == null && v2 == null) {
	        return 0;
	    }
	    else if (v1 == null) {
	        return 1;
	    }
	    else if (v2 == null) {
	        return -1;
	    }
	    else {
	        if (isString(v1)) {
	            return v1.localeCompare(v2, locale);
	        }
	        else if (isNumber(v1)) {
	            return v1 - v2;
	        }
	        else if (isBoolean(v1)) {
	            return (+v1) - (+v2);
	        }
	        else {
	            throw new Error("type if v1 = " + (typeof v1));
	        }
	    }
	}
	function debounce(func, wait, immediate) {
	    if (!wait)
	        return func;
	    var timeout;
	    return function () {
	        var context = this, args = arguments;
	        var later = function () {
	            timeout = null;
	            if (!immediate)
	                func.apply(context, args);
	        };
	        var callNow = immediate && !timeout;
	        clearTimeout(timeout);
	        timeout = setTimeout(later, wait);
	        if (callNow)
	            func.apply(context, args);
	    };
	}
	var throttleWithRaf = function (fn) {
	    var running = false;
	    return function () {
	        if (running)
	            return;
	        running = true;
	        window.requestAnimationFrame(function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            fn.apply(_this, args);
	            running = false;
	        });
	    };
	};
	exports.throttleWithRaf = throttleWithRaf;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var last = __webpack_require__(138);
	var gridComp_1 = tslib_1.__importStar(__webpack_require__(44));
	var mobx_react_1 = __webpack_require__(4);
	var GridCompConnected = /** @class */ (function (_super) {
	    tslib_1.__extends(GridCompConnected, _super);
	    function GridCompConnected(props) {
	        var _this = _super.call(this, props) || this;
	        _this.onGridChange = function (grid) {
	            console.debug('onGridChange(%o)', grid);
	            var routeName = last(_this.context.router.getCurrentRoutes()).name, params = _this.context.router.getCurrentParams();
	            if (grid.activeGridConfig)
	                params.gridId = grid.activeGridConfig.gridId;
	            var query = grid.createParams();
	            console.debug('replaceWith %s, %o, %o', routeName, params, query);
	            _this.context.router.replaceWith(routeName, params, query);
	        };
	        // componentWillUnmount() {
	        //   console.log('componentWillUnmount');
	        //   GridService.removeGrid(this.props.grid.gridLocation);
	        // }
	        _this.gridCompRef = function (comp) {
	            _this._gridCompRef = comp;
	        };
	        console.debug('GridCompConnected#constructor, props: %o', props);
	        return _this;
	    }
	    GridCompConnected.prototype.componentWillMount = function () {
	        console.debug('GridCompConnected#componentWillMount(), props: %o', this.props);
	        var _a = this.props, query = _a.query, grid = _a.grid;
	        grid.data = null;
	        grid.searchTerm = query.searchTerm || '';
	        grid.assignActiveGridConfig(grid.getActiveGridConfig(this.props.gridId));
	        if (query.sort)
	            grid.sort = query.sort;
	        console.log(grid.activeGridConfig);
	        grid.setConditionQueryObject(query);
	        if (query.specialConditions) {
	            grid.specialConditions = query.specialConditions.map(function (scId) { return grid.$gridLocationRef.specialConditions.find(function (sc) { return sc.value == scId; }); }) // pozor musi byt ==, protoze scId je string
	                .filter(function (sc) { return sc; });
	        }
	        console.log("query.specialConditions = %O, grid.specialConditions = %O, grid.$gridLocationRef.specialConditions = %O", query.specialConditions, grid.specialConditions, grid.$gridLocationRef.specialConditions);
	    };
	    GridCompConnected.prototype.componentDidMount = function () {
	        var grid = this.props.grid;
	        if (grid.activeGridConfig && !grid.activeGridConfig.refreshOnPage) {
	            return;
	        }
	        this._gridCompRef.search();
	    };
	    GridCompConnected.prototype.render = function () {
	        var _a = this.props, grid = _a.grid, entities = _a.entities, bulkActions = _a.bulkActions, children = _a.children, multiUpdateSecurable = _a.multiUpdateSecurable, showExpand = _a.showExpand, ExpandComponent = _a.ExpandComponent, multiDeleteSecurable = _a.multiDeleteSecurable, multiDeleteSaveFn = _a.multiDeleteSaveFn, refreshEntities = _a.refreshEntities;
	        //console.debug('GridCompConnected#render, props: %o', this.props);
	        return (react_1.default.createElement(gridComp_1.default, { ref: this.gridCompRef, grid: grid, uiLocation: gridComp_1.UILOCATION.page, onGridChange: this.onGridChange, entities: entities, bulkActions: bulkActions, multiUpdateSecurable: multiUpdateSecurable, showExpand: showExpand, ExpandComponent: ExpandComponent, multiDeleteSecurable: multiDeleteSecurable, multiDeleteSaveFn: multiDeleteSaveFn, refreshEntities: refreshEntities }, children));
	    };
	    GridCompConnected.contextTypes = {
	        router: prop_types_1.default.func.isRequired
	    };
	    GridCompConnected = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], GridCompConnected);
	    return GridCompConnected;
	}(react_1.default.Component));
	exports.default = GridCompConnected;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(177)(module)))

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.optionsSearch = optionsSearch;
	var tslib_1 = __webpack_require__(3);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	function optionsSearch(entityName, params, searchTerm) {
	    console.log("searching %s, params = %o, serarchTerm = %o", entityName, params, searchTerm);
	    return axios_config_1.default.get('/core/meta/search/' + entityName, { params: Object.assign({ searchTerm: searchTerm }, params) })
	        .then(function (response) { return ({ options: response.data }); });
	}


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
	  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
	
	  easeOut: function easeOut(duration, property, delay, easeFunction) {
	    easeFunction = easeFunction || this.easeOutFunction;
	
	    if (property && Object.prototype.toString.call(property) === '[object Array]') {
	      var transitions = '';
	      for (var i = 0; i < property.length; i++) {
	        if (transitions) transitions += ',';
	        transitions += this.create(duration, property[i], delay, easeFunction);
	      }
	
	      return transitions;
	    } else {
	      return this.create(duration, property, delay, easeFunction);
	    }
	  },
	  create: function create(duration, property, delay, easeFunction) {
	    duration = duration || '450ms';
	    property = property || 'all';
	    delay = delay || '0ms';
	    easeFunction = easeFunction || 'linear';
	
	    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
	  }
	};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseChildIndex = exports.getReactEventByType = exports.renderByOrder = exports.isChildrenEqual = exports.isSingleChildEqual = exports.filterSvgElements = exports.isSsr = exports.validateWidthHeight = exports.filterEventsOfChild = exports.filterEventAttributes = exports.getPresentationAttributes = exports.withoutType = exports.findChildByType = exports.findAllByType = exports.getDisplayName = exports.TOOLTIP_TYPES = exports.LEGEND_TYPES = exports.SCALE_TYPES = exports.EVENT_ATTRIBUTES = exports.PRESENTATION_ATTRIBUTES = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(115));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(163));
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(100));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(62));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _DataUtils = __webpack_require__(66);
	
	var _ShallowEqual = __webpack_require__(394);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var PRESENTATION_ATTRIBUTES = {
	  'aria-current': _propTypes["default"].string,
	  // state
	  'aria-details': _propTypes["default"].any,
	  'aria-disabled': _propTypes["default"].any,
	  // state
	  'aria-hidden': _propTypes["default"].any,
	  // state
	  'aria-invalid': _propTypes["default"].any,
	  // state
	  'aria-keyshortcuts': _propTypes["default"].any,
	  'aria-label': _propTypes["default"].any,
	  'aria-roledescription': _propTypes["default"].any,
	  // Widget Attributes
	  'aria-autocomplete': _propTypes["default"].any,
	  'aria-checked': _propTypes["default"].any,
	  'aria-expanded': _propTypes["default"].any,
	  'aria-haspopup': _propTypes["default"].any,
	  'aria-level': _propTypes["default"].any,
	  'aria-modal': _propTypes["default"].any,
	  'aria-multiline': _propTypes["default"].any,
	  'aria-multiselectable': _propTypes["default"].any,
	  'aria-orientation': _propTypes["default"].any,
	  'aria-placeholder': _propTypes["default"].any,
	  'aria-pressed': _propTypes["default"].any,
	  'aria-readonly': _propTypes["default"].any,
	  'aria-required': _propTypes["default"].any,
	  'aria-selected': _propTypes["default"].any,
	  'aria-sort': _propTypes["default"].any,
	  'aria-valuemax': _propTypes["default"].any,
	  'aria-valuemin': _propTypes["default"].any,
	  'aria-valuenow': _propTypes["default"].any,
	  'aria-valuetext': _propTypes["default"].any,
	  // Live Region Attributes
	  'aria-atomic': _propTypes["default"].any,
	  'aria-busy': _propTypes["default"].any,
	  'aria-live': _propTypes["default"].any,
	  'aria-relevant': _propTypes["default"].any,
	  // Drag-and-Drop Attributes
	  'aria-dropeffect': _propTypes["default"].any,
	  'aria-grabbed': _propTypes["default"].any,
	  // Relationship Attributes
	  'aria-activedescendant': _propTypes["default"].any,
	  'aria-colcount': _propTypes["default"].any,
	  'aria-colindex': _propTypes["default"].any,
	  'aria-colspan': _propTypes["default"].any,
	  'aria-controls': _propTypes["default"].any,
	  'aria-describedby': _propTypes["default"].any,
	  'aria-errormessage': _propTypes["default"].any,
	  'aria-flowto': _propTypes["default"].any,
	  'aria-labelledby': _propTypes["default"].any,
	  'aria-owns': _propTypes["default"].any,
	  'aria-posinset': _propTypes["default"].any,
	  'aria-rowcount': _propTypes["default"].any,
	  'aria-rowindex': _propTypes["default"].any,
	  'aria-rowspan': _propTypes["default"].any,
	  'aria-setsize': _propTypes["default"].any,
	  alignmentBaseline: _propTypes["default"].string,
	  angle: _propTypes["default"].number,
	  baselineShift: _propTypes["default"].string,
	  clip: _propTypes["default"].string,
	  clipPath: _propTypes["default"].string,
	  clipRule: _propTypes["default"].string,
	  color: _propTypes["default"].string,
	  colorInterpolation: _propTypes["default"].string,
	  colorInterpolationFilters: _propTypes["default"].string,
	  colorProfile: _propTypes["default"].string,
	  colorRendering: _propTypes["default"].string,
	  cursor: _propTypes["default"].string,
	  direction: _propTypes["default"].oneOf(['ltr', 'rtl', 'inherit']),
	  display: _propTypes["default"].string,
	  dominantBaseline: _propTypes["default"].string,
	  enableBackground: _propTypes["default"].string,
	  fill: _propTypes["default"].string,
	  fillOpacity: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  fillRule: _propTypes["default"].oneOf(['nonzero', 'evenodd', 'inherit']),
	  filter: _propTypes["default"].string,
	  floodColor: _propTypes["default"].string,
	  floodOpacity: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  font: _propTypes["default"].string,
	  fontFamily: _propTypes["default"].string,
	  fontSize: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  fontSizeAdjust: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  fontStretch: _propTypes["default"].oneOf(['normal', 'wider', 'narrower', 'ultra-condensed', 'extra-condensed', 'condensed', 'semi-condensed', 'semi-expanded', 'expanded', 'extra-expanded', 'ultra-expanded', 'inherit']),
	  fontStyle: _propTypes["default"].oneOf(['normal', 'italic', 'oblique', 'inherit']),
	  fontVariant: _propTypes["default"].oneOf(['normal', 'small-caps', 'inherit']),
	  fontWeight: _propTypes["default"].oneOf(['normal', 'bold', 'bolder', 'lighter', 100, 200, 300, 400, 500, 600, 700, 800, 900, 'inherit']),
	  glyphOrientationHorizontal: _propTypes["default"].string,
	  glyphOrientationVertical: _propTypes["default"].string,
	  imageRendering: _propTypes["default"].oneOf(['auto', 'optimizeSpeed', 'optimizeQuality', 'inherit']),
	  kerning: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  letterSpacing: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  lightingColor: _propTypes["default"].string,
	  lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  markerEnd: _propTypes["default"].string,
	  markerMid: _propTypes["default"].string,
	  markerStart: _propTypes["default"].string,
	  mask: _propTypes["default"].string,
	  opacity: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  overflow: _propTypes["default"].oneOf(['visible', 'hidden', 'scroll', 'auto', 'inherit']),
	  pointerEvents: _propTypes["default"].oneOf(['visiblePainted', 'visibleFill', 'visibleStroke', 'visible', 'painted', 'fill', 'stroke', 'all', 'none', 'inherit']),
	  shapeRendering: _propTypes["default"].oneOf(['auto', 'optimizeSpeed', 'crispEdges', 'geometricPrecision', 'inherit']),
	  stopColor: _propTypes["default"].string,
	  stopOpacity: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  stroke: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  strokeDasharray: _propTypes["default"].string,
	  strokeDashoffset: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  strokeLinecap: _propTypes["default"].oneOf(['butt', 'round', 'square', 'inherit']),
	  strokeLinejoin: _propTypes["default"].oneOf(['miter', 'round', 'bevel', 'inherit']),
	  strokeMiterlimit: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  strokeOpacity: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  strokeWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  textAnchor: _propTypes["default"].oneOf(['start', 'middle', 'end', 'inherit']),
	  textDecoration: _propTypes["default"].oneOf(['none', 'underline', 'overline', 'line-through', 'blink', 'inherit']),
	  textRendering: _propTypes["default"].oneOf(['auto', 'optimizeSpeed', 'optimizeLegibility', 'geometricPrecision', 'inherit']),
	  unicodeBidi: _propTypes["default"].oneOf(['normal', 'embed', 'bidi-override', 'inherit']),
	  visibility: _propTypes["default"].oneOf(['visible', 'hidden', 'collapse', 'inherit']),
	  wordSpacing: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  writingMode: _propTypes["default"].oneOf(['lr-tb', 'rl-tb', 'tb-rl', 'lr', 'rl', 'tb', 'inherit']),
	  transform: _propTypes["default"].string,
	  role: _propTypes["default"].string,
	  focusable: _propTypes["default"].string,
	  tabIndex: _propTypes["default"].string,
	  style: _propTypes["default"].object,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  dx: _propTypes["default"].number,
	  dy: _propTypes["default"].number,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  r: _propTypes["default"].number,
	  // The radius of Rectangle
	  radius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array])
	};
	exports.PRESENTATION_ATTRIBUTES = PRESENTATION_ATTRIBUTES;
	var EVENT_ATTRIBUTES = {
	  onClick: _propTypes["default"].func,
	  onMouseDown: _propTypes["default"].func,
	  onMouseUp: _propTypes["default"].func,
	  onMouseOver: _propTypes["default"].func,
	  onMouseMove: _propTypes["default"].func,
	  onMouseOut: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onTouchEnd: _propTypes["default"].func,
	  onTouchMove: _propTypes["default"].func,
	  onTouchStart: _propTypes["default"].func,
	  onTouchCancel: _propTypes["default"].func
	};
	exports.EVENT_ATTRIBUTES = EVENT_ATTRIBUTES;
	var REACT_BROWSER_EVENT_MAP = {
	  click: 'onClick',
	  mousedown: 'onMouseDown',
	  mouseup: 'onMouseUp',
	  mouseover: 'onMouseOver',
	  mousemove: 'onMouseMove',
	  mouseout: 'onMouseOut',
	  mouseenter: 'onMouseEnter',
	  mouseleave: 'onMouseLeave',
	  touchcancel: 'onTouchCancel',
	  touchend: 'onTouchEnd',
	  touchmove: 'onTouchMove',
	  touchstart: 'onTouchStart'
	};
	var SCALE_TYPES = ['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold'];
	exports.SCALE_TYPES = SCALE_TYPES;
	var LEGEND_TYPES = ['plainline', 'line', 'square', 'rect', 'circle', 'cross', 'diamond', 'star', 'triangle', 'wye', 'none'];
	exports.LEGEND_TYPES = LEGEND_TYPES;
	var TOOLTIP_TYPES = ['none'];
	/**
	 * Get the display name of a component
	 * @param  {Object} Comp Specified Component
	 * @return {String}      Display name of Component
	 */
	
	exports.TOOLTIP_TYPES = TOOLTIP_TYPES;
	
	var getDisplayName = function getDisplayName(Comp) {
	  if (typeof Comp === 'string') {
	    return Comp;
	  }
	
	  if (!Comp) {
	    return '';
	  }
	
	  return Comp.displayName || Comp.name || 'Component';
	};
	/*
	 * Find and return all matched children by type. `type` can be a React element class or
	 * string
	 */
	
	
	exports.getDisplayName = getDisplayName;
	
	var findAllByType = function findAllByType(children, type) {
	  var result = [];
	  var types = [];
	
	  if ((0, _isArray2["default"])(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react["default"].Children.forEach(children, function (child) {
	    var childType = child && child.type && (child.type.displayName || child.type.name);
	
	    if (types.indexOf(childType) !== -1) {
	      result.push(child);
	    }
	  });
	
	  return result;
	};
	/*
	 * Return the first matched child by type, return null otherwise.
	 * `type` can be a React element class or string.
	 */
	
	
	exports.findAllByType = findAllByType;
	
	var findChildByType = function findChildByType(children, type) {
	  var result = findAllByType(children, type);
	  return result && result[0];
	};
	/*
	 * Create a new array of children excluding the ones matched the type
	 */
	
	
	exports.findChildByType = findChildByType;
	
	var withoutType = function withoutType(children, type) {
	  var newChildren = [];
	  var types;
	
	  if ((0, _isArray2["default"])(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react["default"].Children.forEach(children, function (child) {
	    if (child && child.type && child.type.displayName && types.indexOf(child.type.displayName) !== -1) {
	      return;
	    }
	
	    newChildren.push(child);
	  });
	
	  return newChildren;
	};
	/**
	 * get all the presentation attribute of svg element
	 * @param  {Object} el A react element or the props of a react element
	 * @return {Object}    attributes or null
	 */
	
	
	exports.withoutType = withoutType;
	
	var getPresentationAttributes = function getPresentationAttributes(el) {
	  if (!el || (0, _isFunction2["default"])(el)) {
	    return null;
	  }
	
	  var props = _react["default"].isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject2["default"])(props)) {
	    return null;
	  }
	
	  var out = null; // eslint-disable-next-line no-restricted-syntax
	
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && PRESENTATION_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = props[i];
	    }
	  }
	
	  return out;
	};
	
	exports.getPresentationAttributes = getPresentationAttributes;
	
	var getEventHandlerOfElement = function getEventHandlerOfElement(originalHandler, props) {
	  return function (e) {
	    originalHandler(props, e);
	    return null;
	  };
	};
	/**
	 * get all the event attribute of svg element
	 * @param  {Object}   el           A react element or the props of a react element
	 * @param  {Function} newHandler   New handler of event
	 * @param  {Boolean}  wrapCallback Wrap callback and return more parameters or not
	 * @return {Object}                attributes or null
	 */
	
	
	var filterEventAttributes = function filterEventAttributes(el, newHandler) {
	  var wrapCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!el || (0, _isFunction2["default"])(el)) {
	    return null;
	  }
	
	  var props = _react["default"].isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject2["default"])(props)) {
	    return null;
	  }
	
	  var out = null; // eslint-disable-next-line no-restricted-syntax
	
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = newHandler || (wrapCallback ? getEventHandlerOfElement(props[i], props) : props[i]);
	    }
	  }
	
	  return out;
	};
	
	exports.filterEventAttributes = filterEventAttributes;
	
	var getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
	  return function (e) {
	    originalHandler(data, index, e);
	    return null;
	  };
	};
	
	var filterEventsOfChild = function filterEventsOfChild(props, data, index) {
	  if (!(0, _isObject2["default"])(props)) {
	    return null;
	  }
	
	  var out = null; // eslint-disable-next-line no-restricted-syntax
	
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i] && (0, _isFunction2["default"])(props[i])) {
	      if (!out) out = {};
	      out[i] = getEventHandlerOfChild(props[i], data, index);
	    }
	  }
	
	  return out;
	};
	/**
	 * validate the width and height props of a chart element
	 * @param  {Object} el A chart element
	 * @return {Boolean}   true If the props width and height are number, and greater than 0
	 */
	
	
	exports.filterEventsOfChild = filterEventsOfChild;
	
	var validateWidthHeight = function validateWidthHeight(el) {
	  if (!el || !el.props) {
	    return false;
	  }
	
	  var _el$props = el.props,
	      width = _el$props.width,
	      height = _el$props.height;
	
	  if (!(0, _DataUtils.isNumber)(width) || width <= 0 || !(0, _DataUtils.isNumber)(height) || height <= 0) {
	    return false;
	  }
	
	  return true;
	};
	
	exports.validateWidthHeight = validateWidthHeight;
	
	var isSsr = function isSsr() {
	  return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
	};
	
	exports.isSsr = isSsr;
	var SVG_TAGS = ['a', 'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor', 'animateMotion', 'animateTransform', 'circle', 'clipPath', 'color-profile', 'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColormatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'font', 'font-face', 'font-face-format', 'font-face-name', 'font-face-url', 'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line', 'lineGradient', 'marker', 'mask', 'metadata', 'missing-glyph', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'script', 'set', 'stop', 'style', 'svg', 'switch', 'symbol', 'text', 'textPath', 'title', 'tref', 'tspan', 'use', 'view', 'vkern'];
	
	var isSvgElement = function isSvgElement(child) {
	  return child && child.type && (0, _isString2["default"])(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
	};
	/**
	 * Filter all the svg elements of children
	 * @param  {Array} children The children of a react element
	 * @return {Array}          All the svg elements
	 */
	
	
	var filterSvgElements = function filterSvgElements(children) {
	  var svgElements = [];
	
	  _react["default"].Children.forEach(children, function (entry) {
	    if (entry && entry.type && (0, _isString2["default"])(entry.type) && SVG_TAGS.indexOf(entry.type) >= 0) {
	      svgElements.push(entry);
	    }
	  });
	
	  return svgElements;
	};
	
	exports.filterSvgElements = filterSvgElements;
	
	var isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
	  if ((0, _isNil2["default"])(nextChild) && (0, _isNil2["default"])(prevChild)) {
	    return true;
	  }
	
	  if (!(0, _isNil2["default"])(nextChild) && !(0, _isNil2["default"])(prevChild)) {
	    var _ref = nextChild.props || {},
	        nextChildren = _ref.children,
	        nextProps = _objectWithoutProperties(_ref, ["children"]);
	
	    var _ref2 = prevChild.props || {},
	        prevChildren = _ref2.children,
	        prevProps = _objectWithoutProperties(_ref2, ["children"]);
	
	    if (nextChildren && prevChildren) {
	      // eslint-disable-next-line no-use-before-define
	      return (0, _ShallowEqual.shallowEqual)(nextProps, prevProps) && isChildrenEqual(nextChildren, prevChildren);
	    }
	
	    if (!nextChildren && !prevChildren) {
	      return (0, _ShallowEqual.shallowEqual)(nextProps, prevProps);
	    }
	
	    return false;
	  }
	
	  return false;
	};
	/**
	 * Wether props of children changed
	 * @param  {Object} nextChildren The latest children
	 * @param  {Object} prevChildren The prev children
	 * @return {Boolean}             equal or not
	 */
	
	
	exports.isSingleChildEqual = isSingleChildEqual;
	
	var isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
	  if (nextChildren === prevChildren) {
	    return true;
	  }
	
	  if (_react.Children.count(nextChildren) !== _react.Children.count(prevChildren)) {
	    return false;
	  }
	
	  var count = _react.Children.count(nextChildren);
	
	  if (count === 0) {
	    return true;
	  }
	
	  if (count === 1) {
	    return isSingleChildEqual((0, _isArray2["default"])(nextChildren) ? nextChildren[0] : nextChildren, (0, _isArray2["default"])(prevChildren) ? prevChildren[0] : prevChildren);
	  }
	
	  for (var _i = 0; _i < count; _i++) {
	    var nextChild = nextChildren[_i];
	    var prevChild = prevChildren[_i];
	
	    if ((0, _isArray2["default"])(nextChild) || (0, _isArray2["default"])(prevChild)) {
	      if (!isChildrenEqual(nextChild, prevChild)) {
	        return false;
	      }
	    } else if (!isSingleChildEqual(nextChild, prevChild)) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	exports.isChildrenEqual = isChildrenEqual;
	
	var renderByOrder = function renderByOrder(children, renderMap) {
	  var elements = [];
	  var record = {};
	
	  _react.Children.forEach(children, function (child, index) {
	    if (child && isSvgElement(child)) {
	      elements.push(child);
	    } else if (child && renderMap[getDisplayName(child.type)]) {
	      var displayName = getDisplayName(child.type);
	      var _renderMap$displayNam = renderMap[displayName],
	          handler = _renderMap$displayNam.handler,
	          once = _renderMap$displayNam.once;
	
	      if (once && !record[displayName] || !once) {
	        var results = handler(child, displayName, index);
	
	        if ((0, _isArray2["default"])(results)) {
	          elements = [elements].concat(_toConsumableArray(results));
	        } else {
	          elements.push(results);
	        }
	
	        record[displayName] = true;
	      }
	    }
	  });
	
	  return elements;
	};
	
	exports.renderByOrder = renderByOrder;
	
	var getReactEventByType = function getReactEventByType(e) {
	  var type = e && e.type;
	
	  if (type && REACT_BROWSER_EVENT_MAP[type]) {
	    return REACT_BROWSER_EVENT_MAP[type];
	  }
	
	  return null;
	};
	
	exports.getReactEventByType = getReactEventByType;
	
	var parseChildIndex = function parseChildIndex(child, children) {
	  var result = -1;
	
	  _react.Children.forEach(children, function (entry, index) {
	    if (entry === child) {
	      result = index;
	    }
	  });
	
	  return result;
	};
	
	exports.parseChildIndex = parseChildIndex;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.GridCompositeComp = exports.BULKACTIONTYPE = exports.UILOCATION = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var react_router_1 = __webpack_require__(65);
	var react_bootstrap_1 = __webpack_require__(72);
	var Badge_1 = tslib_1.__importDefault(__webpack_require__(489));
	var formUtils_1 = __webpack_require__(14);
	var fields_1 = __webpack_require__(20);
	var IconButton_1 = tslib_1.__importDefault(__webpack_require__(126));
	var FontIcon_1 = tslib_1.__importDefault(__webpack_require__(164));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var MenuItem_1 = tslib_1.__importDefault(__webpack_require__(101));
	var Divider_1 = tslib_1.__importDefault(__webpack_require__(241));
	var file_download_1 = tslib_1.__importDefault(__webpack_require__(778));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var grid_1 = __webpack_require__(50);
	var gridHeader_1 = tslib_1.__importDefault(__webpack_require__(2095));
	var icons_1 = __webpack_require__(63);
	var jsonUtils_1 = __webpack_require__(193);
	var errorComp_1 = __webpack_require__(34);
	var utils_1 = __webpack_require__(37);
	var loading_1 = __webpack_require__(262);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var securityService_2 = tslib_1.__importDefault(__webpack_require__(35));
	var metaConstant_1 = __webpack_require__(13);
	var specialConditionFilter_1 = tslib_1.__importDefault(__webpack_require__(2097));
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var virtualList_1 = tslib_1.__importDefault(__webpack_require__(2099));
	var mdField_1 = __webpack_require__(57);
	var multiUpdateDialog_1 = __webpack_require__(568);
	var arrayUtils_1 = __webpack_require__(78);
	var generateActivityDialog_1 = tslib_1.__importDefault(__webpack_require__(2084));
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var domUtils_1 = __webpack_require__(91);
	var Subject_1 = __webpack_require__(260);
	var Observable_1 = __webpack_require__(94);
	__webpack_require__(309);
	__webpack_require__(910);
	__webpack_require__(911);
	var locales_1 = __webpack_require__(15);
	var chartComp_1 = __webpack_require__(2050);
	var superFilter_1 = tslib_1.__importDefault(__webpack_require__(2098));
	__webpack_require__(1292);
	__webpack_require__(665);
	var storage_1 = __webpack_require__(173);
	var colors_1 = __webpack_require__(29);
	var debounce = __webpack_require__(479);
	var last = __webpack_require__(138);
	var get = __webpack_require__(207);
	var MdCheckBoxOutlineBlank = __webpack_require__(1826);
	var MdCheckBox = __webpack_require__(1827);
	var MdRefresh = __webpack_require__(1833);
	var MdSync = __webpack_require__(1835);
	var MdSyncDisabled = __webpack_require__(1834);
	var MdCloudDownload = __webpack_require__(1828);
	var MdMenu = __webpack_require__(1829);
	var SvgDone = __webpack_require__(298);
	var SvgClear = __webpack_require__(248);
	var FaCopy = __webpack_require__(1818);
	var FaSearch = __webpack_require__(526);
	var FaBookmark = __webpack_require__(1813);
	var FaBookmarkO = __webpack_require__(1812);
	var MdChartPie = __webpack_require__(1832);
	var MdChartPieOutlined = __webpack_require__(1831);
	var FaEraser = __webpack_require__(1819);
	var material_ui_1 = __webpack_require__(127);
	var gridService_2 = tslib_1.__importDefault(__webpack_require__(22));
	var documentDomain_1 = __webpack_require__(109);
	var gridImportDialog_1 = __webpack_require__(2096);
	var HEADER_ROW_HEIGHT = 28;
	var GridComp__buttonStyle = {
	    width: 32,
	    height: 40,
	    padding: "8px 4px",
	    verticalAlign: "top",
	};
	var GridComp__iconStyle = { height: 18, width: 18 };
	var GridComp__iconStyleSM = { height: 16, width: 16, color: colors_1.grey400 };
	var BUTTON_STYLE = { height: grid_1.ROW_HEIGHT, width: 28, padding: 4 };
	var ICON_STYLE = { fontSize: 13 };
	var UILOCATION;
	(function (UILOCATION) {
	    UILOCATION["page"] = "page";
	    UILOCATION["dialog"] = "dialog";
	    UILOCATION["main"] = "main";
	    UILOCATION["main_right"] = "main_right";
	    UILOCATION["tab"] = "tab";
	    UILOCATION["dashboard"] = "dashboard";
	})(UILOCATION || (exports.UILOCATION = UILOCATION = {}));
	var BULKACTIONTYPE;
	(function (BULKACTIONTYPE) {
	    BULKACTIONTYPE["ACTION"] = "ACTION";
	})(BULKACTIONTYPE || (exports.BULKACTIONTYPE = BULKACTIONTYPE = {}));
	exports.GridCompositeComp = (0, mobx_react_1.observer)(function (_a) {
	    var grid = _a.grid, uiLocation = _a.uiLocation, children = _a.children;
	    return (react_1.default.createElement("div", { className: "row" + " md-grid--" + uiLocation }, children));
	});
	var pagingSearchStream = new Subject_1.Subject();
	pagingSearchStream
	    .mergeMap(function (struct) {
	    return Promise.all([
	        struct,
	        struct.grid.search(struct.rootObject, false, struct.page, true),
	    ]);
	}, null, 2)
	    .subscribe((0, mobx_1.action)("subscribe-actionCb", function (_a) {
	    var struct = _a[0], grid = _a[1];
	    console.log("pagingSearchStream resolved page %s", struct.page);
	}));
	var dataRefreshSearchStream = new Subject_1.Subject();
	dataRefreshSearchStream
	    .debounceTime(300)
	    .switchMap(function (struct) {
	    return Observable_1.Observable.fromPromise(struct.grid.search(struct.rootObject, true, 1));
	})
	    .subscribe((0, mobx_1.action)("subscribe-actionCb", function () {
	    console.log("dataRefreshSearchStream resolved");
	}));
	var GridComp = /** @class */ (function (_super) {
	    tslib_1.__extends(GridComp, _super);
	    function GridComp(props) {
	        var _this = _super.call(this, props) || this;
	        _this.headerPaddingRight = 0;
	        _this.maxChartRows = 500;
	        _this.showChart = false;
	        _this.showExceedChartRows = false;
	        _this.selectedForChart = _this.maxChartRows;
	        _this.loadingNewRowsIds = false;
	        _this.createDataChangeEventSource = function () {
	            var _a = _this.props, grid = _a.grid, rootObject = _a.rootObject, refreshEntities = _a.refreshEntities;
	            if (grid.refreshData) {
	                console.log("Creating event source");
	                var entityNames_1 = refreshEntities && refreshEntities.length
	                    ? refreshEntities
	                    : [grid.$gridLocationRef.entityName];
	                _this.dataChangeEventSource = new EventSource((0, domUtils_1.buildURL)("/api/core/meta/entity-change", { entityName: entityNames_1 }));
	                _this.dataChangeEventSource.onmessage = function (e) {
	                    console.log("%c SSE MESSAGE: %o", "background-color: blue", e);
	                    var mdhEvent = JSON.parse(e.data);
	                    if (entityNames_1.includes(mdhEvent.entityName) &&
	                        (!grid.isEditable() || !grid.$dirty)) {
	                        dataRefreshSearchStream.next({ grid: grid, page: 1, rootObject: rootObject });
	                    }
	                };
	                _this.dataChangeEventSource.onerror = function (e) {
	                    console.log("%c SSE ERROR: %o", "background-color: red", e);
	                    if (_this.dataChangeEventSource.readyState == 2) {
	                        setTimeout(_this.createDataChangeEventSource, 5000);
	                    }
	                };
	                _this.dataChangeEventSource.onopen = function (e) {
	                    console.log("%c SSE OPEN: %o", "background-color: green", e);
	                };
	            }
	        };
	        _this.rowContainerRefHandler = function (comp) {
	            _this.rowContainerRef = comp;
	        };
	        _this.virtualListRefHandler = function (comp) {
	            _this.virtualListRef = comp;
	        };
	        _this.gridHeaderRefHandler = function (comp) {
	            _this.gridHeaderRef = comp;
	        };
	        /* *******   PRIVATE METHODS ************ */
	        _this.search = function (scrollToTop) {
	            return _this.props.grid.search(_this.props.rootObject)
	                .then((0, mobx_1.action)("gridComp-search-callback", function () {
	                if (scrollToTop && _this.virtualListRef) {
	                    _this.virtualListRef.scrollTop();
	                }
	            }));
	        };
	        _this.pagingSearch = function (page) {
	            var _a = _this.props, grid = _a.grid, rootObject = _a.rootObject;
	            if (!grid.data.requestedPages.has(page)) {
	                grid.data.requestedPages.add(page);
	                pagingSearchStream.next({ grid: grid, page: page, rootObject: rootObject });
	            }
	        };
	        _this.onResize = function () {
	            var newHPR = _this._computeNewHPR();
	            if (newHPR !== null && _this.headerPaddingRight !== newHPR) {
	                _this.headerPaddingRight = newHPR;
	                _this.forceUpdate();
	            }
	        };
	        _this.onScrollGrid = function () {
	            // v pripade ze je header, posuneme ho do spravne pozice
	            if (_this.gridHeaderRef) {
	                _this.gridHeaderRef.style.left = -_this.rowContainerRef.scrollLeft + "px";
	            }
	        };
	        /* *******   EVENT HENDLERS ************ */
	        _this.onSelectGridConfig = function (event, gc) {
	            console.log("onSelectGridConfig gridId = " + gc.gridId);
	            var grid = _this.props.grid;
	            grid.assignActiveGridConfig(gc);
	            grid.searchTerm = "";
	            grid.conditionArray = null;
	            grid.data = null;
	            if (_this.props.onGridChange) {
	                _this.props.onGridChange(grid);
	            }
	            if (!(grid.activeGridConfig && !grid.activeGridConfig.refreshOnPage)) {
	                _this.search(true);
	            }
	            if (_this.showExceedChartRows)
	                _this.showExceedChartRows = false;
	        };
	        _this.onSetDefault = function (event, gridConfig) {
	            console.log("onSetDefault %O", gridConfig);
	            var grid = _this.props.grid;
	            gridService_1.default.setDefault(gridConfig.gridId, gridConfig.gridLocation).then(function (response) {
	                for (var _i = 0, _a = grid.gridConfigs; _i < _a.length; _i++) {
	                    var gc = _a[_i];
	                    gc.defaultGrid = undefined;
	                }
	                gridConfig.defaultGrid = true;
	                (0, storage_1.removeItemFromLocalStorage)("GridLocation", locales_1.loc.lang, gridConfig.gridLocation);
	            });
	        };
	        _this.onSelectGridManage = function (eventKey, event) {
	            if (!event)
	                event = eventKey; // protoze jednou je to volane tak a jednou tak
	            event.preventDefault();
	            var grid = _this.props.grid;
	            var params = {
	                gridLocation: grid.gridLocation,
	                gridId: grid.activeGridConfig ? grid.activeGridConfig.gridId : undefined,
	            };
	            _this.context.router.transitionTo("gridAdmin", params);
	        };
	        _this.onSearchTermChange = function (evt) {
	            var grid = _this.props.grid;
	            grid.searchTerm = evt.target.value || "";
	        };
	        _this.onSearchTermSubmit = function (evt) {
	            evt.preventDefault();
	            var grid = _this.props.grid;
	            console.log("onSearchTermSubmit: %s", grid.searchTerm);
	            if (_this.props.onGridChange) {
	                _this.props.onGridChange(grid);
	            }
	            _this.search(true);
	        };
	        _this.onClickColumnSort = function (sortObject) {
	            console.log("onClickColumnSort %o", sortObject);
	            var grid = _this.props.grid;
	            grid.sortArray = [sortObject];
	            if (_this.props.onGridChange) {
	                _this.props.onGridChange(grid);
	            }
	            _this.search(true);
	        };
	        _this.changeAndSearch = function () {
	            console.log("changeAndSearch");
	            if (_this.props.onGridChange) {
	                _this.props.onGridChange(_this.props.grid);
	            }
	            _this.search(true);
	        };
	        _this.onShowSelection = function (evt) {
	            console.log("onShowSelection %O", evt);
	            var grid = _this.props.grid;
	            grid.selectedRowIds = new Set();
	            grid.deselectedRowIds = new Set();
	            grid.selectedAllRows = false;
	            grid.showSelection = !grid.showSelection;
	            if (_this.virtualListRef) {
	                _this.virtualListRef.forceUpdate();
	            }
	        };
	        _this.selectFirstRows = function (e, onSelected) {
	            var grid = _this.props.grid;
	            if (grid.selectedAllRows)
	                grid.selectedAllRows = false;
	            if (!grid.showSelection)
	                _this.onShowSelection(e);
	            grid.selectedRowIds = new Set();
	            var rowIds = grid.data.rowIds();
	            if (rowIds.length < _this.selectedForChart) {
	                //next row ids need to be fetched
	                _this.loadingNewRowsIds = true;
	                gridService_2.default
	                    .getRowIds(grid, _this.selectedForChart)
	                    .then(function (fetchedIds) {
	                    _this.fillSelectedRowIds(fetchedIds, grid, _this.selectedForChart);
	                    if (_this.virtualListRef)
	                        _this.virtualListRef.forceUpdate();
	                    _this.loadingNewRowsIds = false;
	                    onSelected();
	                });
	            }
	            else {
	                _this.fillSelectedRowIds(rowIds, grid, _this.selectedForChart);
	                if (_this.virtualListRef)
	                    _this.virtualListRef.forceUpdate();
	                onSelected();
	            }
	        };
	        _this.onCheckCbxAll = function (e) {
	            var grid = _this.props.grid;
	            grid.selectedAllRows = !grid.selectedAllRows;
	            if (grid.selectedAllRows) {
	                grid.selectedRowIds = new Set(grid.data.rowIds());
	                grid.deselectedRowIds = new Set();
	            }
	            else {
	                grid.selectedRowIds = new Set();
	                grid.deselectedRowIds = new Set();
	            }
	            if (_this.virtualListRef)
	                _this.virtualListRef.forceUpdate();
	        };
	        _this.onClickRow = function (clickedRowId, e) {
	            var grid = _this.props.grid;
	            console.debug("processRowSelection: %o", clickedRowId);
	            // provedeme pouze pokud je zapnuto oznacovani radku
	            if (grid.showSelection) {
	                // odstranime vsechny oznaceni
	                window.getSelection().removeAllRanges();
	                // zkopirujeme si mapu oznacenych radku
	                var lastSelected_1 = grid.lastClickedRow;
	                var clonedSet_1 = new Set(grid.selectedRowIds);
	                if (clonedSet_1.has(clickedRowId)) {
	                    // pokud jsme klikli na oznaceny radek, odebereme ho z oznaceni
	                    clonedSet_1.delete(clickedRowId);
	                    if (grid.selectedAllRows)
	                        grid.deselectedRowIds.add(clickedRowId);
	                }
	                else {
	                    // pokud jsme klikli na neoznaceny radek, pridame ho do oznaceni
	                    clonedSet_1.add(clickedRowId);
	                    if (grid.selectedAllRows)
	                        grid.deselectedRowIds.delete(clickedRowId);
	                }
	                // pokud byl pri kliknuti drzen shift a zaroven existoval klik predtim
	                // a zaroven se nekliklo na jeden a ten samy radek
	                if (e.shiftKey && lastSelected_1 && lastSelected_1 !== clickedRowId) {
	                    var startStop_1 = false;
	                    // Projedeme vsechny radky
	                    _this.props.grid.data.flatRows().every(function (row) {
	                        // pokud jsme nasli zacatek nebo konec oznaceni
	                        if (row.rowId === clickedRowId || row.rowId === lastSelected_1) {
	                            // pokud jsme narazili na zacatek oznaceni - nastavime startStop na true
	                            // zastaveni cylku pokud jsme na konci oznaceni (startStop == false)
	                            return (startStop_1 = !startStop_1);
	                        }
	                        else if (startStop_1) {
	                            // pokud jsme uprostred oznaceneho bloku - invertujeme oznaceni radku
	                            if (clonedSet_1.has(row.rowId)) {
	                                clonedSet_1.delete(row.rowId);
	                                if (grid.selectedAllRows)
	                                    grid.deselectedRowIds.add(clickedRowId);
	                            }
	                            else {
	                                clonedSet_1.add(row.rowId);
	                                if (grid.selectedAllRows)
	                                    grid.deselectedRowIds.delete(clickedRowId);
	                            }
	                        }
	                        // true, aby cyklus pokracoval dal
	                        return true;
	                    });
	                }
	                grid.selectedRowIds = clonedSet_1;
	                grid.lastClickedRow = clickedRowId;
	            }
	            if (_this.virtualListRef) {
	                _this.virtualListRef.forceUpdate();
	            }
	        };
	        _this.onClickRefresh = function (evt) {
	            var grid = _this.props.grid;
	            console.log("onClickRefresh %o", evt);
	            _this.search()
	                .then(function (x) {
	                if (grid.isEditable()) {
	                    grid.deletedRowIds = new Set();
	                    grid.$dirty = false;
	                }
	            });
	        };
	        _this.onClickClearAndRefresh = function (evt) {
	            var grid = _this.props.grid;
	            grid.searchTerm = "";
	            grid.conditionArray = [];
	            grid.initSuperFilter();
	            grid.resetSpecialConditions(grid.activeGridConfig);
	            if (_this.props.onGridChange) {
	                _this.props.onGridChange(grid);
	            }
	            _this.onClickRefresh(evt);
	        };
	        _this.onClickSync = function (evt) {
	            _this.props.grid.refreshData = !_this.props.grid.refreshData;
	            if (_this.props.grid.refreshData) {
	                _this.createDataChangeEventSource();
	            }
	            else {
	                _this.destroyDataChangeEventSource();
	            }
	        };
	        _this.onEditRow = function (item) {
	            var _a = _this.props, grid = _a.grid, onEditFormLoad = _a.onEditFormLoad, editFormName = _a.editFormName, rootObject = _a.rootObject;
	            console.log("onEditRow %O", item);
	            var rowObject = item.rowObject;
	            var form = rowObject.getForm(editFormName);
	            var onEditFormLoadPromise = onEditFormLoad
	                ? onEditFormLoad(rowObject)
	                : Promise.resolve(rowObject);
	            onEditFormLoadPromise.then(function (x) {
	                form.$open = true;
	                form.$pristineObject = rowObject.cloneDeep();
	                rootObject.$dirty = true;
	                grid.$dirty = true;
	                if (_this.virtualListRef)
	                    _this.virtualListRef.forceUpdate();
	            });
	        };
	        _this.onExpandRow = function (rowId) {
	            var _a = _this.props, grid = _a.grid, onEditFormLoad = _a.onEditFormLoad, editFormName = _a.editFormName, rootObject = _a.rootObject;
	            console.log("onExpandRow %s %s", rowId);
	            var item = grid.findRow(rowId);
	            item.expanded = !item.expanded ? (item.rowObject ? 2 : 1) : 0;
	            if (_this.virtualListRef)
	                _this.virtualListRef.forceUpdate();
	        };
	        _this.onExpandAllRows = function () {
	            var _a = _this.props, grid = _a.grid, onEditFormLoad = _a.onEditFormLoad, editFormName = _a.editFormName, rootObject = _a.rootObject;
	            console.log("onExpandAllRows");
	            grid.expandAllRows = !grid.expandAllRows;
	            for (var _i = 0, _b = grid.data.flatRows(); _i < _b.length; _i++) {
	                var item = _b[_i];
	                item.expanded = grid.expandAllRows
	                    ? !item.expanded
	                        ? item.rowObject
	                            ? 2
	                            : 1
	                        : item.expanded
	                    : 0;
	            }
	            if (_this.virtualListRef)
	                _this.virtualListRef.forceUpdate();
	        };
	        _this.onClickChart = function () {
	            if (_this.showChart == false) {
	                if (_this.chartCanBeShown()) {
	                    _this.showChart = true;
	                }
	                else {
	                    _this.showExceedChartRows = !_this.showExceedChartRows;
	                    if (_this.showExceedChartRows)
	                        _this.selectedForChart = _this.maxChartRows;
	                }
	            }
	            else {
	                _this.showChart = false;
	            }
	        };
	        /**
	         * arraySpec = [{item, index, toDelete: true}, ....]
	         * @param arraySpec
	         */
	        _this.onDeleteRow = function (rows) {
	            var _a = _this.props, grid = _a.grid, rootObject = _a.rootObject;
	            console.log("onDeleteRow rows = %O", rows);
	            if (!rows.length)
	                return;
	            var rowIds = rows
	                .filter(function (row) { return !row.rowObject.$added; })
	                .map(function (row) { return row.rowId; });
	            if (_this.props.editOverrideFn) {
	                grid.addDeletedId(rowIds);
	                _this.props.editOverrideFn(rootObject, null, rows).then(function () {
	                    if (_this.virtualListRef)
	                        _this.virtualListRef.forceUpdate();
	                });
	            }
	            else {
	                grid.addDeletedId(rowIds);
	                grid.data.deleteRows(rows);
	                grid.data.totalCount = grid.data.totalCount - rows.length;
	                if (rows.length > 0) {
	                    grid.$dirty = true;
	                    rootObject.$dirty = true;
	                }
	                if (_this.virtualListRef)
	                    _this.virtualListRef.forceUpdate();
	            }
	        };
	        _this.onDismissAlert = function () {
	            var grid = _this.props.grid;
	            grid.errors = null;
	        };
	        _this.bulkDelete = function (grid) {
	            var selectedCount = grid.getSelectedCount();
	            console.log("Deleteting count: %s", selectedCount);
	            if (!selectedCount)
	                return;
	            if (_this.props.multiDeleteSaveFn) {
	                return new Promise(function (resolve, reject) {
	                    _this.multiDeleteDialogRef.open(resolve, reject, "Do you really want to delete " +
	                        selectedCount +
	                        " " +
	                        grid.$gridLocationRef.$entityRef.label +
	                        " ?");
	                })
	                    .then(function () {
	                    uiService_1.default.showToolbarActionFlag();
	                    return _this.props.multiDeleteSaveFn(grid.createFullParams());
	                })
	                    .then(function () {
	                    uiService_1.default.hideToolbarActionFlag();
	                    return _this.search();
	                })
	                    .catch(function (e) { });
	            }
	            else {
	                return _this.onDeleteRow(grid.getSelectedRows());
	            }
	        };
	        _this.multiUpdateDialogRefHandler = function (comp) {
	            _this.multiUpdateDialogRef = comp;
	        };
	        _this.gridImportDialogRefHandler = function (comp) {
	            _this.gridImportDialogRef = comp;
	        };
	        _this.bulkUpdate = function (grid) {
	            if (!grid.data)
	                return;
	            return new Promise(function (resolve, reject) {
	                _this.multiUpdateDialogRef.open(resolve, reject, grid, _this.props.editFormName, _this.props.rootObject);
	                //this.forceUpdate();
	                _this.multiUpdateDialogRef.forceUpdate();
	            })
	                .then(function (res) {
	                if (res.saveRequired) {
	                    return _this.props.multiUpdateSaveFn(null);
	                }
	                else {
	                    _this.search();
	                }
	            })
	                .catch(function (e) { });
	        };
	        _this.generateActivityDialogRefHandler = function (comp) {
	            _this.generateActivityDialogRef = comp;
	        };
	        _this.onGenerateActivity = function (aclov) {
	            var grid = _this.props.grid;
	            console.log("activityConfig: ", aclov);
	            if (!grid.data)
	                return;
	            return new Promise(function (resolve, reject) {
	                _this.generateActivityDialogRef.open(resolve, reject, grid, aclov);
	                _this.generateActivityDialogRef.forceUpdate();
	            }).catch(function (e) { });
	        };
	        _this.multiDeleteDialogRefHandler = function (comp) { return (_this.multiDeleteDialogRef = comp); };
	        _this.bulkImport = function (grid) {
	            return new Promise(function (resolve, reject) {
	                _this.gridImportDialogRef.open(resolve, reject, grid);
	                _this.gridImportDialogRef.forceUpdate();
	            })
	                .catch(function (e) { });
	        };
	        _this.usesVirtualScrolling = function (grid) {
	            return grid.data &&
	                grid.data.totalCount >
	                    (grid.activeGridConfig ? grid.activeGridConfig.gridScrollSize : 50);
	        };
	        _this.renderItem = function (item, index) {
	            var _a = _this.props, grid = _a.grid, showEdit = _a.showEdit, showDelete = _a.showDelete, showExpand = _a.showExpand, deleteRowIcon = _a.deleteRowIcon, editForm = _a.editForm, editFormName = _a.editFormName, hideCopyRow = _a.hideCopyRow, disableDeleteFn = _a.disableDeleteFn, disableEditFn = _a.disableEditFn, ExpandComponent = _a.ExpandComponent, rootObject = _a.rootObject, prepareFormatRowParamsFn = _a.prepareFormatRowParamsFn, editOverrideFn = _a.editOverrideFn, copyRowObjectFn = _a.copyRowObjectFn, onEditFormLoad = _a.onEditFormLoad;
	            if (!item) {
	                return react_1.default.createElement("div", { key: index, className: "md-grid-row md-grid-row-load" });
	            }
	            var rowObject = item.rowObject;
	            var disableDelete = disableDeleteFn ? disableDeleteFn(rowObject) : false;
	            var disableEdit = disableEditFn ? disableEditFn(rowObject) : false;
	            var rowClass = item.expanded ? "" : "md-grid-row";
	            var selected = grid.selectedRowIds.has(item.rowId);
	            if (selected) {
	                rowClass += " md-grid-row-selected";
	            }
	            var form = rowObject && editFormName ? rowObject.getForm(editFormName) : null;
	            if (grid.isEditable() && form && form.$open) {
	                return (react_1.default.createElement(EditFormComp, { gridComp: _this, editForm: editForm, item: item, key: index, editFormName: editFormName, grid: grid, hideCopyRow: hideCopyRow, onDeleteRow: _this.onDeleteRow, rootObject: rootObject, prepareFormatRowParamsFn: prepareFormatRowParamsFn, editOverrideFn: editOverrideFn, copyRowObjectFn: copyRowObjectFn, onEditFormLoad: onEditFormLoad }));
	            }
	            else {
	                return (react_1.default.createElement("div", { key: index, className: rowClass },
	                    grid.showSelection ? (react_1.default.createElement("div", { className: "md-grid-cell", style: {
	                            float: "left",
	                            minWidth: "28px",
	                            width: "28px",
	                            paddingTop: 2,
	                        } }, !item.aggregateType ? (react_1.default.createElement(fields_1.MdCheckbox, { name: "selectRowCheckbox", checked: selected, onClick: _this.onClickRow.bind(_this, item.rowId) })) : null)) : (""),
	                    showEdit ? (react_1.default.createElement("div", { className: "md-grid-cell", style: { float: "left", minWidth: 20, width: 20 } }, !item.aggregateType ? (react_1.default.createElement(IconButton_1.default, { onClick: _this.onEditRow.bind(_this, item), tooltip: "Edit", style: {
	                            height: item.rowHeight,
	                            width: 20,
	                            padding: "4px 0",
	                        }, disabled: disableEdit, iconStyle: rowObject.$dirty
	                            ? { fontSize: 13, color: colors_1.pink500 }
	                            : {
	                                fontSize: 13,
	                                color: colors_1.grey700,
	                            } },
	                        react_1.default.createElement(FontIcon_1.default, { className: "fa fa-pencil" }))) : null)) : (""),
	                    showDelete ? (react_1.default.createElement("div", { className: "md-grid-cell", style: { float: "left", minWidth: 24, width: 24 } }, !item.aggregateType ? (react_1.default.createElement(IconButton_1.default, { onClick: _this.onDeleteRow.bind(_this, [item]), tooltip: "Delete", disabled: disableDelete, style: {
	                            height: item.rowHeight,
	                            width: 24,
	                            padding: "4px 4px 4px 0",
	                        }, iconStyle: { fontSize: 13, color: colors_1.grey700 } },
	                        react_1.default.createElement(FontIcon_1.default, { className: deleteRowIcon }))) : null)) : (""),
	                    showExpand ? (react_1.default.createElement("div", { className: "md-grid-cell", style: { float: "left", minWidth: 20, width: 20 } }, !item.aggregateType ? (react_1.default.createElement(IconButton_1.default, { onClick: _this.onExpandRow.bind(_this, item.rowId), style: { height: grid_1.ROW_HEIGHT, width: 20, padding: "4px 0" }, iconStyle: { fontSize: 13, color: colors_1.grey700 } }, item.expanded ? (react_1.default.createElement(FontIcon_1.default, { className: "fa fa-caret-down" })) : (react_1.default.createElement(FontIcon_1.default, { className: "fa fa-caret-right" })))) : null)) : (""),
	                    react_1.default.createElement("div", { className: "md-grid-data-row", style: {
	                            marginRight: (grid.showSelection ? 28 : 0) +
	                                (showEdit ? 20 : 0) +
	                                (showDelete ? 24 : 0) +
	                                (showExpand ? 24 : 0),
	                        } },
	                        item.cells.map(function (gridCell, columnIndex) {
	                            return _this.renderCell(item, gridCell, columnIndex);
	                        }),
	                        item.expanded && ExpandComponent ? (react_1.default.createElement(ExpandWrapperComp, { ExpandComponent: ExpandComponent, gridComp: _this, item: item })) : null)));
	            }
	        };
	        _this.onAction = function (item, id, columnIndex, evt) {
	            var grid = _this.props.grid;
	            var field = grid.activeGridConfig.columns[columnIndex].field;
	            //console.debug("functionName %s ... %s ... %s ... %s", functionName, cellId, index, evt.target.checked);
	            _this.props.functionMap[field.functionName](id, item, evt.target.checked);
	        };
	        _this.onCheck = function (item, id, columnIndex, evt) {
	            var grid = _this.props.grid;
	            var field = grid.activeGridConfig.columns[columnIndex].field;
	            //console.debug("functionName %s ... %s ... %s ... %s", functionName, cellId, index, evt.target.checked);
	            _this.props.functionMap[field.functionNameSetter()](id, item, evt.target.checked);
	        };
	        _this.renderCell = function (item, gridCell, columnIndex) {
	            var _a = _this.props, grid = _a.grid, functionMap = _a.functionMap;
	            var field = grid.activeGridConfig.columns[columnIndex].field;
	            if (!field)
	                return react_1.default.createElement("div", null);
	            var formattedValue = field.formatValue(gridCell.value);
	            if (item.aggregateType && formattedValue != null && formattedValue !== "") {
	                formattedValue =
	                    grid_1.AGGREGATETYPE_MAP[item.aggregateType].glyph + "\u00A0" + formattedValue;
	            }
	            if (field.dataType === mdField_1.DATATYPE.BOOLEAN) {
	                formattedValue =
	                    formattedValue === "true" ? (react_1.default.createElement(SvgDone, { size: 18 })) : formattedValue === "false" ? (react_1.default.createElement(SvgClear, { size: 18 })) : (formattedValue);
	            }
	            var customRoute = field.detailRoute && gridCell.dataId != null;
	            var columnWidths = grid.activeGridWidths;
	            var styleObject = {
	                width: columnWidths[0][columnIndex] + "%",
	                minWidth: columnWidths[1][columnIndex] + "px",
	                maxWidth: columnWidths[2][columnIndex] + "px",
	                textAlign: field.textAlign ? field.textAlign : undefined,
	            };
	            var css = "md-grid-cell";
	            if (!customRoute)
	                css += " no-a";
	            if (gridCell.cssClass)
	                css += " " + gridCell.cssClass;
	            var route = customRoute
	                ? field.detailRoute
	                : field.$entityRef
	                    ? field.$entityRef.detailRoute
	                    : undefined;
	            var id = customRoute ? gridCell.dataId : item.rowId;
	            return field.displayType || id == null || !route ? (react_1.default.createElement("div", { key: columnIndex, className: css, style: styleObject, title: gridCell.tooltip }, field.displayType === mdField_1.DISPLAYTYPE.BUTTON ? (react_1.default.createElement(FlatButton_1.default, { primary: true, style: { height: grid_1.ROW_HEIGHT, lineHeight: grid_1.ROW_HEIGHT + "px" }, label: gridCell.value, labelPosition: "after", onClick: _this.onAction.bind(_this, item, id, columnIndex) })) : field.displayType === mdField_1.DISPLAYTYPE.CHECKBOX ? (react_1.default.createElement(fields_1.MdCheckbox, { name: field.fieldName, checked: functionMap[field.functionNameGetter()](id, item), onCheck: _this.onCheck.bind(_this, item, id, columnIndex) })) : field.displayType === mdField_1.DISPLAYTYPE.ICON ? (react_1.default.createElement(IconButton_1.default, { onClick: _this.onAction.bind(_this, item, id, columnIndex), tooltip: field.label, style: BUTTON_STYLE, iconStyle: ICON_STYLE },
	                react_1.default.createElement(FontIcon_1.default, { className: gridCell.glyph }))) : (((typeof formattedValue === 'string' || formattedValue instanceof String) && formattedValue.startsWith("https://")) ? react_1.default.createElement("a", { href: formattedValue }, formattedValue) : formattedValue))) : (react_1.default.createElement(react_router_1.Link, { key: columnIndex, className: css, style: styleObject, to: route, params: { id: id }, title: gridCell.tooltip, query: (0, utils_1.addTenantToQuery)({ gridLocation: grid.gridLocation }) },
	                " ",
	                formattedValue,
	                " "));
	        };
	        console.debug("GridComp#constructor, props: %o", props);
	        return _this;
	    }
	    GridComp.prototype.componentWillMount = function () {
	        this.onResizeDebounced = debounce(this.onResize, 100);
	    };
	    GridComp.prototype.componentWillReceiveProps = function (nextProps) {
	        console.log("componentWillReceiveProps: old searchTerm = %s, new searchTerm = %s", this.props.grid.searchTerm, nextProps.grid.searchTerm);
	    };
	    GridComp.prototype.componentDidMount = function () {
	        console.debug("gridComp %s componentDidMount: rowContainer = %O", this.props.grid.gridLocation, this.rowContainerRef);
	        window.addEventListener("resize", this.onResizeDebounced);
	        this.createDataChangeEventSource();
	    };
	    GridComp.prototype.componentDidUpdate = function (prevProps) {
	        if (this.rowContainerRef &&
	            !this.horizontalScrollRegistered &&
	            !this.usesVirtualScrolling(this.props.grid)) {
	            this.rowContainerRef.addEventListener("scroll", this.onScrollGrid);
	            this.horizontalScrollRegistered = true;
	        }
	    };
	    GridComp.prototype.componentWillUnmount = function () {
	        window.removeEventListener("resize", this.onResizeDebounced);
	        if (this.rowContainerRef) {
	            this.rowContainerRef.removeEventListener("scroll", this.onScrollGrid);
	        }
	        this.destroyDataChangeEventSource();
	    };
	    GridComp.prototype.destroyDataChangeEventSource = function () {
	        if (this.dataChangeEventSource) {
	            console.debug("Destroing event source");
	            this.dataChangeEventSource.close();
	        }
	    };
	    GridComp.prototype._computeNewHPR = function () {
	        var _cont = this.rowContainerRef;
	        if (!_cont)
	            return null;
	        return _cont.scrollHeight > _cont.clientHeight ? 15 : 0;
	    };
	    GridComp.prototype.chartCanBeShown = function () {
	        var grid = this.props.grid;
	        if (grid == null) {
	            return false;
	        }
	        if (grid.getTotalCount() == "null" ||
	            grid.getTotalCount() == "undefined" ||
	            (grid.getTotalCount() > this.maxChartRows && grid.selectedAllRows)) {
	            return false;
	        }
	        return (grid.getTotalCount() <= this.maxChartRows ||
	            (grid.selectedRowIds.size > 0 &&
	                grid.selectedRowIds.size <= this.maxChartRows));
	    };
	    GridComp.prototype.fillSelectedRowIds = function (rowIds, grid, selectedCount) {
	        for (var i = 0; i < selectedCount; i++) {
	            grid.selectedRowIds.add(rowIds[i]);
	        }
	    };
	    GridComp.prototype.render = function () {
	        var _this = this;
	        var _a, _b;
	        var _c = this.props, grid = _c.grid, children = _c.children, uiLocation = _c.uiLocation, gridClassName = _c.gridClassName, multiSelect = _c.multiSelect, bodyStyle = _c.bodyStyle, hideToolbar = _c.hideToolbar, hideRefresh = _c.hideRefresh, hideGridConfig = _c.hideGridConfig, showEdit = _c.showEdit, showDelete = _c.showDelete, showExpand = _c.showExpand, entities = _c.entities, bulkActions = _c.bulkActions, multiUpdateSecurable = _c.multiUpdateSecurable, onGridChange = _c.onGridChange, multiDeleteSaveFn = _c.multiDeleteSaveFn, multiDeleteSecurable = _c.multiDeleteSecurable;
	        console.debug("gridComp %s rendering: dataCount = %s, deleted = %O, searchTerm = %s", grid.gridLocation, grid.getTotalCount(), grid.deletedRowIds, grid.searchTerm);
	        var dropdownId = grid.gridLocation + "_dropdown";
	        var gridClassNames = (0, domUtils_1.classNames)("md-grid", "md-grid--" + uiLocation, gridClassName);
	        this.headerPaddingRight = this._computeNewHPR();
	        var canEditGrid = true;
	        if (grid.$gridLocationRef.gridType === grid_1.GRIDTYPE.SQLQUERY) {
	            var securableId = (0, formUtils_1.lovValue)(grid.$gridLocationRef.securable);
	            var permissionList = securityService_2.default.permissionList(securableId);
	            canEditGrid = permissionList && permissionList.length >= 2;
	        }
	        if (!grid.activeGridConfig && canEditGrid) {
	            return (react_1.default.createElement("div", { className: gridClassNames },
	                react_1.default.createElement(react_bootstrap_1.Navbar, { fluid: true, style: { marginBottom: 10, minHeight: "initial", fontSize: 14 } },
	                    react_1.default.createElement(react_bootstrap_1.Nav, null,
	                        react_1.default.createElement(react_bootstrap_1.NavItem, { eventKey: 3, href: this.context.router.makeHref("gridAdmin", { gridLocation: grid.gridLocation }, (0, utils_1.addTenantToQuery)()), onClick: this.onSelectGridManage }, locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Create Grid"], ["Create Grid"]))))))));
	        }
	        var gridConfigMenu = (react_1.default.createElement(react_bootstrap_1.NavDropdown, { id: dropdownId, eventKey: 3, title: grid.activeGridConfig.label, disabled: this.showChart },
	            grid.gridConfigs.map(function (gc, index) {
	                var routeName = last(_this.context.router.getCurrentRoutes())
	                    .name;
	                var routeDef = uiLocation === UILOCATION.page
	                    ? _this.context.router.makeHref(routeName, Object.assign({}, _this.context.router.getCurrentParams(), {
	                        gridId: gc.gridId,
	                    }), (0, utils_1.addTenantToQuery)())
	                    : "";
	                return (react_1.default.createElement(GridSelectMenuItem, { key: gc.gridId, onSelect: _this.onSelectGridConfig, onSetDefault: _this.onSetDefault, route: routeDef, gc: gc }));
	            }),
	            canEditGrid ? react_1.default.createElement(react_bootstrap_1.MenuItem, { divider: true }) : null,
	            canEditGrid ? (react_1.default.createElement(react_bootstrap_1.MenuItem, { href: this.context.router.makeHref("gridAdmin", {
	                    gridLocation: grid.gridLocation,
	                    gridId: grid.activeGridConfig.gridId,
	                }, (0, utils_1.addTenantToQuery)()), onSelect: this.onSelectGridManage },
	                " ", locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Manage"], ["Manage"]))),
	                " ")) : null));
	        var columnWidths = grid.activeGridWidths;
	        var muiMenuItemStyle = { fontSize: 14, lineHeight: "40px" };
	        var exportActionsEnabled = grid.isSelectedRows();
	        var builtinExportActions = [
	            { label: "Excel", format: documentDomain_1.DOCUMENTFORMAT.XLS },
	            { label: "Excel 2007", format: documentDomain_1.DOCUMENTFORMAT.XLSX },
	            { label: "CSV", format: documentDomain_1.DOCUMENTFORMAT.CSV },
	            { label: "XML Grid", format: documentDomain_1.DOCUMENTFORMAT.XML },
	            { label: "XML Object", format: documentDomain_1.DOCUMENTFORMAT.XML_OBJECT },
	        ];
	        // if (uiLocation === 'main' || uiLocation === 'tab') {
	        //   if (grid.data && grid.data.rows && grid.data.rows.length && grid.data.rows.length <= 600) {
	        //     if (!bodyStyle) bodyStyle = {};
	        //     bodyStyle.minHeight = ROW_HEIGHT * (grid.data.rows.length + 2) + 8;
	        //   }
	        // }
	        var usesVirtualScrolling = this.usesVirtualScrolling(grid);
	        var dataContainerDivStyle = {
	            marginBottom: 20,
	            minHeight: grid.isEditable() ? 400 : null,
	        };
	        var scrollContainer = this.rowContainerRef;
	        if (uiLocation === UILOCATION.main ||
	            uiLocation === UILOCATION.tab ||
	            uiLocation === UILOCATION.main_right) {
	            if (usesVirtualScrolling) {
	                scrollContainer = window;
	            }
	        }
	        var localBulkActions = bulkActions ? bulkActions.slice() : [];
	        if (multiUpdateSecurable) {
	            localBulkActions.push({
	                type: BULKACTIONTYPE.ACTION,
	                label: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Update rows"], ["Update rows"]))),
	                fn: this.bulkUpdate,
	                that: this,
	                securable: multiUpdateSecurable,
	            });
	        }
	        if (showDelete || (multiDeleteSaveFn && multiDeleteSecurable)) {
	            localBulkActions.push({
	                type: BULKACTIONTYPE.ACTION,
	                label: locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["Delete rows"], ["Delete rows"]))),
	                fn: this.bulkDelete,
	                that: this,
	                securable: multiDeleteSecurable,
	            });
	        }
	        localBulkActions = localBulkActions.filter(function (action) {
	            return !action.securable ||
	                securityService_1.default.hasRight(action.securable.name, action.securable.permission ? action.securable.permission : metaConstant_1.PERMISSION.Execute);
	        });
	        if ((_a = grid.$gridLocationRef.importConfigs) === null || _a === void 0 ? void 0 : _a.length) {
	            localBulkActions.push({
	                type: BULKACTIONTYPE.ACTION,
	                label: locales_1.loc.i18n(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["Import records"], ["Import records"]))),
	                fn: this.bulkImport,
	                that: this,
	            });
	        }
	        var Navbar_style = {
	            marginBottom: 10,
	            minHeight: "initial",
	            fontSize: 14,
	        };
	        var MdGridHeaderWrapper_style = { paddingRight: this.headerPaddingRight };
	        if (uiLocation === UILOCATION.main_right || uiLocation === UILOCATION.tab) {
	            Object.assign(Navbar_style, { position: "sticky", top: 40, zIndex: 2 });
	            Object.assign(MdGridHeaderWrapper_style, {
	                position: "sticky",
	                top: 80,
	                backgroundColor: "white",
	                zIndex: 2,
	            });
	        }
	        var isSQLQueryGrid = grid.$gridLocationRef.gridType === grid_1.GRIDTYPE.SQLQUERY;
	        return (react_1.default.createElement("div", { className: gridClassNames },
	            multiDeleteSaveFn && multiDeleteSecurable ? (react_1.default.createElement(confirmationDialog_1.default, { ref: this.multiDeleteDialogRefHandler, cancelButtonText: locales_1.loc.i18n(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["Cancel"], ["Cancel"]))), okButtonText: "OK" })) : null,
	            hideToolbar ? ("") : (react_1.default.createElement(react_bootstrap_1.Navbar, { fluid: true, style: Navbar_style },
	                !hideGridConfig ? react_1.default.createElement(react_bootstrap_1.Nav, { navbar: true }, gridConfigMenu) : null,
	                multiSelect && !isSQLQueryGrid ? (react_1.default.createElement(icons_1.MdIconButton, { onClick: this.onShowSelection, style: GridComp__buttonStyle, iconStyle: GridComp__iconStyle, disabled: this.showChart }, grid.showSelection ? (react_1.default.createElement(MdCheckBox, null)) : (react_1.default.createElement(MdCheckBoxOutlineBlank, null)))) : null,
	                grid.$dirty || grid.clientGrid || hideRefresh ? null : (react_1.default.createElement(icons_1.MdIconButton, { onClick: this.onClickRefresh, style: GridComp__buttonStyle, iconStyle: GridComp__iconStyle, disabled: this.showChart },
	                    react_1.default.createElement(MdRefresh, null))),
	                react_1.default.createElement(icons_1.ZzIconButtonMenu, { disabled: !exportActionsEnabled || this.showChart, buttonIcon: react_1.default.createElement(MdCloudDownload, null), style: { verticalAlign: "top" }, iconStyle: GridComp__iconStyle },
	                    builtinExportActions.map(function (action, index) { return (react_1.default.createElement(MenuItem_1.default, { key: index + 10, style: muiMenuItemStyle, innerDivStyle: { padding: 0 } },
	                        react_1.default.createElement("div", { className: "mui-menu-item" },
	                            react_1.default.createElement("a", { href: gridService_1.default.exportUrl(grid, action.format, true), className: "mui-menu-item-link-1", target: "_blank" }, action.label),
	                            react_1.default.createElement("a", { href: gridService_1.default.exportUrl(grid, action.format, false) },
	                                react_1.default.createElement(file_download_1.default, { style: { verticalAlign: "middle" }, color: colors_1.grey500 }))))); }),
	                    grid.$gridLocationRef.assignedDocumentTypes
	                        ? grid.$gridLocationRef.assignedDocumentTypes.map(function (linkObj, index) { return (react_1.default.createElement(MenuItem_1.default, { key: index, style: muiMenuItemStyle, innerDivStyle: { padding: 0 } },
	                            react_1.default.createElement("div", { className: "mui-menu-item" },
	                                react_1.default.createElement("a", { href: gridService_1.default.documentExportUrl(grid, linkObj.value, true), className: "mui-menu-item-link-1", target: "_blank" }, linkObj.label),
	                                react_1.default.createElement("a", { href: gridService_1.default.documentExportUrl(grid, linkObj.value, false) },
	                                    react_1.default.createElement(file_download_1.default, { style: { verticalAlign: "middle" }, color: colors_1.grey500 }))))); })
	                        : null),
	                react_1.default.createElement(specialConditionFilter_1.default, { grid: grid, search: this.search, onGridChange: onGridChange, disabled: this.showChart }),
	                grid.$gridLocationRef.enableRefreshOnData ? (react_1.default.createElement(icons_1.MdIconButton, { onClick: this.onClickSync, style: {
	                        width: 28,
	                        height: 40,
	                        padding: "8px 2px",
	                        verticalAlign: "top",
	                    }, iconStyle: GridComp__iconStyle }, grid.refreshData ? react_1.default.createElement(MdSync, null) : react_1.default.createElement(MdSyncDisabled, null))) : null,
	                (0, arrayUtils_1.notEmpty)(localBulkActions) ||
	                    (0, arrayUtils_1.notEmpty)(grid.$gridLocationRef.assignedActivityConfigs) ? (react_1.default.createElement(icons_1.ZzIconButtonMenu, { disabled: !exportActionsEnabled || this.showChart, buttonIcon: react_1.default.createElement(MdMenu, null), style: { verticalAlign: "top" }, iconStyle: GridComp__iconStyle }, (0, arrayUtils_1.addSeparatorBetweenArrays)(react_1.default.createElement(Divider_1.default, null), localBulkActions.map(function (action, index) { return (react_1.default.createElement(MenuItem_1.default, { key: index, primaryText: action.label, style: muiMenuItemStyle, onClick: action.fn.bind(action.that, grid) })); }), grid.$gridLocationRef.assignedActivityConfigs.map(function (activityConfig, index) { return (react_1.default.createElement(MenuItem_1.default, { key: index, primaryText: activityConfig.label, style: muiMenuItemStyle, onClick: _this.onGenerateActivity.bind(_this, activityConfig) })); })))) : null,
	                react_1.default.createElement(ChartIconOverlay, { grid: grid, showExceedChartRows: this.showExceedChartRows, onShowExceedChartRowsChange: function (show) {
	                        return (_this.showExceedChartRows = show);
	                    }, onClickChart: this.onClickChart, showChart: this.showChart, loadingNewRowsIds: this.loadingNewRowsIds, maxChartRows: this.maxChartRows, selectFirstRows: this.selectFirstRows, selectedForChart: this.selectedForChart, onSelectedForChartChange: function (value) {
	                        return (_this.selectedForChart = value);
	                    } }),
	                react_1.default.createElement("div", { style: {
	                        display: "inline-block",
	                        lineHeight: "40px",
	                        verticalAlign: "top",
	                    }, className: (0, domUtils_1.classNames)({
	                        "color-red-500": grid.data && grid.data.truncated,
	                    }) },
	                    " ",
	                    grid.data && grid.data.totalCount
	                        ? grid.data.totalCount + locales_1.loc.i18n(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject([" rows"], [" rows"]))) +
	                            (grid.data.truncated ? " (truncated)" : "")
	                        : "",
	                    " "),
	                children,
	                react_1.default.createElement("form", { className: "navbar-form navbar-right", role: "search", onSubmit: this.onSearchTermSubmit },
	                    react_1.default.createElement(icons_1.MdIconButton, { onClick: this.onClickClearAndRefresh, style: {
	                            width: 32,
	                            height: 40,
	                            padding: "6px 4px 10px 4px",
	                            verticalAlign: "top",
	                        }, iconStyle: GridComp__iconStyleSM },
	                        react_1.default.createElement(FaEraser, null)),
	                    react_1.default.createElement(formUtils_1.FieldGroup, { type: "text", placeholder: locales_1.loc.i18n(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["Search"], ["Search"]))), onChange: this.onSearchTermChange, value: grid.searchTerm, bsSize: "small" }),
	                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "left", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "searchTooltip", style: { fontSize: 13 }, className: "left-aligned-tooltip" }, grid.activeGridConfig.searchLabel.map(function (text, i) { return (react_1.default.createElement("span", { key: i },
	                            text,
	                            react_1.default.createElement("br", null))); })) },
	                        react_1.default.createElement(FaSearch, { onClick: this.onSearchTermSubmit, style: {
	                                position: "absolute",
	                                top: 12,
	                                right: 15,
	                                color: colors_1.grey400,
	                            } }))))),
	            grid.errors ? (react_1.default.createElement(errorComp_1.ErrorComp, { messages: grid.errors, onDismiss: this.onDismissAlert })) : null,
	            grid.activeGridConfig.getSuperFilters().length ? (react_1.default.createElement(superFilter_1.default, { grid: grid, gridConfig: grid.activeGridConfig, refreshGrid: this.changeAndSearch })) : null,
	            !this.showChart && (react_1.default.createElement("div", { className: "md-grid-header-wrapper", style: MdGridHeaderWrapper_style },
	                react_1.default.createElement("div", { className: "md-grid-header", ref: this.gridHeaderRefHandler },
	                    grid.showSelection ? (react_1.default.createElement("div", { className: "md-grid-header-cell", style: { float: "left", minWidth: "28px", width: "28px" } },
	                        react_1.default.createElement(fields_1.MdCheckbox, { name: "selectAllCheckbox", onCheck: this.onCheckCbxAll, checked: grid.selectedAllRows }))) : null,
	                    showEdit ? (react_1.default.createElement("div", { className: "md-grid-header-cell", style: {
	                            float: "left",
	                            minWidth: 20,
	                            height: HEADER_ROW_HEIGHT,
	                            width: 20,
	                            textAlign: "center",
	                        } }, "E")) : null,
	                    showDelete ? (grid.deletedRowIds && grid.deletedRowIds.size ? (react_1.default.createElement(Badge_1.default, { badgeContent: grid.deletedRowIds.size, primary: true, badgeStyle: { fontSize: 8, width: 12, height: 12 }, style: { float: "left", padding: "0 8px 0 0" } },
	                        react_1.default.createElement("div", { className: "md-grid-header-cell", style: {
	                                float: "left",
	                                minWidth: 24,
	                                height: HEADER_ROW_HEIGHT,
	                                width: 24,
	                                textAlign: "center",
	                            } }, "D"))) : (react_1.default.createElement("div", { className: "md-grid-header-cell", style: {
	                            float: "left",
	                            minWidth: 24,
	                            height: HEADER_ROW_HEIGHT,
	                            width: 24,
	                            textAlign: "center",
	                        } }, "D"))) : null,
	                    showExpand ? (react_1.default.createElement("div", { className: "md-grid-header-cell", style: {
	                            float: "left",
	                            minWidth: 20,
	                            height: HEADER_ROW_HEIGHT,
	                            width: 20,
	                            textAlign: "center",
	                        } },
	                        react_1.default.createElement(IconButton_1.default, { onClick: this.onExpandAllRows, style: {
	                                height: HEADER_ROW_HEIGHT,
	                                width: 20,
	                                padding: "4px 0",
	                            }, iconStyle: { fontSize: 13, color: colors_1.grey700 } }, grid.expandAllRows ? (react_1.default.createElement(FontIcon_1.default, { className: "fa fa-caret-down" })) : (react_1.default.createElement(FontIcon_1.default, { className: "fa fa-caret-right" }))),
	                        " ",
	                        ": null")) : null,
	                    react_1.default.createElement("div", { className: "md-grid-data-row", style: {
	                            marginRight: (grid.showSelection ? 28 : 0) +
	                                (showEdit ? 20 : 0) +
	                                (showDelete ? 24 : 0) +
	                                (showExpand ? 24 : 0),
	                        } }, grid.activeGridConfig.columns.map(function (gcCol, columnIndex) {
	                        if (!gcCol.field)
	                            return react_1.default.createElement("div", null);
	                        var sortObject = grid.sortArray
	                            ? grid.sortArray.find(function (so) { return so.field.fieldName === gcCol.field.fieldName; })
	                            : null;
	                        var conditionObject = grid.conditionArray
	                            ? grid.conditionArray.find(function (gcc) { return gcc.columnName === gcCol.field.fieldName; })
	                            : null;
	                        var styleObject = {
	                            width: columnWidths[0][columnIndex] + "%",
	                            minWidth: columnWidths[1][columnIndex] + "px",
	                            maxWidth: columnWidths[2][columnIndex] + "px",
	                            textAlign: gcCol.field.textAlign
	                                ? gcCol.field.textAlign
	                                : undefined,
	                        };
	                        return (react_1.default.createElement("div", { key: columnIndex, className: "md-grid-header-cell", style: styleObject },
	                            react_1.default.createElement(gridHeader_1.default, { gridConfigField: gcCol, field: gcCol.field, sortObject: sortObject, conditionObject: conditionObject, grid: grid, entities: entities, gridConfig: grid.activeGridConfig, onClickLink: _this.onClickColumnSort, refreshGrid: _this.changeAndSearch })));
	                    }))))),
	            react_1.default.createElement("div", { ref: this.rowContainerRefHandler, className: "md-grid-body", style: bodyStyle },
	                grid.loading ? react_1.default.createElement(loading_1.LoadingElement, null) : null,
	                this.showChart ? (react_1.default.createElement(chartComp_1.ChartGridWrapperComp, { grid: grid })) : grid.data ? (grid.data.totalCount === 0 ? (locales_1.loc.get("core.grid.no-data")) : usesVirtualScrolling ? (react_1.default.createElement("div", { style: dataContainerDivStyle },
	                    react_1.default.createElement(virtualList_1.default, { ref: this.virtualListRefHandler, gridData: grid.data, renderItem: this.renderItem, container: scrollContainer, header: this.gridHeaderRef, search: this.pagingSearch }),
	                    grid.data.aggregateRows.map(function (item, index) {
	                        return _this.renderItem(item, -index - 1);
	                    }))) : (react_1.default.createElement("div", { style: dataContainerDivStyle },
	                    grid.data.flatRows().map(this.renderItem),
	                    grid.data.aggregateRows.map(function (item, index) {
	                        return _this.renderItem(item, -index - 1);
	                    })))) : null),
	            multiUpdateSecurable && (react_1.default.createElement(multiUpdateDialog_1.MultiUpdateDialog, { ref: this.multiUpdateDialogRefHandler })),
	            (0, arrayUtils_1.notEmpty)(grid.$gridLocationRef.assignedActivityConfigs) && (react_1.default.createElement(generateActivityDialog_1.default, { ref: this.generateActivityDialogRefHandler })),
	            !!((_b = grid.$gridLocationRef.importConfigs) === null || _b === void 0 ? void 0 : _b.length) && (react_1.default.createElement(gridImportDialog_1.GridImportDialog, { ref: this.gridImportDialogRefHandler }))));
	    };
	    GridComp.contextTypes = {
	        router: prop_types_1.default.func.isRequired,
	        muiTheme: prop_types_1.default.object,
	    };
	    GridComp.defaultProps = {
	        multiSelect: true,
	        copyRowObjectFn: function (x) { return x; },
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridComp.prototype, "showChart", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridComp.prototype, "showExceedChartRows", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridComp.prototype, "selectedForChart", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridComp.prototype, "loadingNewRowsIds", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "search", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "pagingSearch", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "onResize", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "onScrollGrid", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "onSelectGridConfig", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "onSetDefault", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "onSelectGridManage", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "onSearchTermChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "onSearchTermSubmit", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "onClickColumnSort", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "changeAndSearch", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "onShowSelection", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "selectFirstRows", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "onCheckCbxAll", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "onClickRow", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "onClickRefresh", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "onClickClearAndRefresh", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "onClickSync", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "onEditRow", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "onExpandRow", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "onExpandAllRows", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "onClickChart", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComp.prototype, "onDeleteRow", void 0);
	    GridComp = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], GridComp);
	    return GridComp;
	}(react_1.default.Component));
	exports.default = GridComp;
	var GridSelectMenuItem__li_a_style = { paddingRight: 15 };
	var GridSelectMenuItem = /** @class */ (function (_super) {
	    tslib_1.__extends(GridSelectMenuItem, _super);
	    function GridSelectMenuItem() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onClick = function (evt) {
	            evt.preventDefault();
	            _this.props.onSelect(evt, _this.props.gc);
	        };
	        _this.onClick2 = function (evt) {
	            evt.preventDefault();
	            _this.props.onSetDefault(evt, _this.props.gc);
	        };
	        return _this;
	    }
	    GridSelectMenuItem.prototype.render = function () {
	        var _a = this.props, gc = _a.gc, route = _a.route;
	        return (react_1.default.createElement("li", { style: { display: "flex", justifyContent: "space-between" } },
	            react_1.default.createElement("a", { role: "menuitem", tabIndex: -1, href: route, onClick: this.onClick, style: { flexGrow: 1 } }, gc.label),
	            react_1.default.createElement("a", { href: "", onClick: this.onClick2, style: GridSelectMenuItem__li_a_style }, gc.defaultGrid ? react_1.default.createElement(FaBookmark, null) : react_1.default.createElement(FaBookmarkO, null))));
	    };
	    GridSelectMenuItem = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], GridSelectMenuItem);
	    return GridSelectMenuItem;
	}(react_1.default.Component));
	var EditFormComp = /** @class */ (function (_super) {
	    tslib_1.__extends(EditFormComp, _super);
	    function EditFormComp() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onRollbackRow = function (evt) {
	            evt.stopPropagation();
	            var _a = _this.props, grid = _a.grid, editFormName = _a.editFormName, item = _a.item, gridComp = _a.gridComp, onDeleteRow = _a.onDeleteRow;
	            console.log("onRollbackRow %O", item);
	            var form = item.rowObject.getForm(editFormName);
	            form.$open = false;
	            if (item.rowObject.$added) {
	                onDeleteRow([item]);
	            }
	            else {
	                item.rowObject = form.$pristineObject;
	            }
	            form.$pristineObject = undefined;
	            item.rowHeight = grid_1.ROW_HEIGHT;
	            gridComp.forceUpdate();
	        };
	        _this.onCommitRow = function (evt) {
	            evt.stopPropagation();
	            var _a = _this.props, item = _a.item, gridComp = _a.gridComp;
	            console.log("onCommitRow %O", item);
	            return _this.onCommitRowInner(item)
	                .then(function (result) {
	                gridComp.forceUpdate();
	            })
	                .catch(function (error) { });
	        };
	        _this.onCommitRowInner = function (item) {
	            var _a = _this.props, grid = _a.grid, editFormName = _a.editFormName, rootObject = _a.rootObject, editOverrideFn = _a.editOverrideFn, prepareFormatRowParamsFn = _a.prepareFormatRowParamsFn;
	            var rowObject = item.rowObject;
	            var form = rowObject.getForm(editFormName);
	            var res = form.validateForm(rowObject);
	            // pro explicitne zadefinovane nestedForms (nasobne radky, ktere nejsou samostatne)
	            if (form.nestedForms) {
	                var _loop_1 = function (nestedFormDef) {
	                    var nestedObject = get(rowObject, nestedFormDef.path);
	                    (0, jsonUtils_1.callOnObjectOrArray)(nestedObject, function (obj) {
	                        var nestedForm = obj.getForm(nestedFormDef.formName);
	                        var resN = nestedForm.validateForm(obj);
	                        res = res && resN;
	                    });
	                };
	                for (var _i = 0, _b = form.nestedForms; _i < _b.length; _i++) {
	                    var nestedFormDef = _b[_i];
	                    _loop_1(nestedFormDef);
	                }
	            }
	            if (!res) {
	                return Promise.reject(new Error("VALIDATION_ERROR"));
	            }
	            if (editOverrideFn) {
	                form.$open = false; // zkusime zavrit hned (invoice only zatim)
	                return editOverrideFn(rootObject, [item], null).then((0, mobx_1.action)("editOverrideFn-actionCb", function () {
	                    form.$open = false;
	                    grid.$dirty = true;
	                    form.$pristineObject = undefined;
	                    console.log("onCommit - after editOverrideFn rootObject = %O", rootObject);
	                    item.rowHeight = grid_1.ROW_HEIGHT;
	                    return item;
	                }));
	            }
	            else {
	                var paramSpec = Object.assign({ masterId: grid.masterId }, prepareFormatRowParamsFn
	                    ? prepareFormatRowParamsFn(rootObject, rowObject)
	                    : null);
	                return gridService_1.default.formatRow(grid.activeGridConfig.gridId, rowObject, paramSpec).then(function (gridRow) {
	                    item.cells = gridRow.cells;
	                    // OK
	                    form.$open = false;
	                    rowObject.$added = undefined;
	                    rowObject.$dirty = true;
	                    grid.$dirty = true;
	                    rootObject.$dirty = true;
	                    form.$pristineObject = undefined;
	                    console.log("onCommitInner - after formatRow %o", rowObject);
	                    item.rowHeight = grid_1.ROW_HEIGHT;
	                    return item;
	                });
	            }
	        };
	        _this.onCopyRow = function (evt) {
	            evt.stopPropagation();
	            var _a = _this.props, grid = _a.grid, editFormName = _a.editFormName, rootObject = _a.rootObject, onEditFormLoad = _a.onEditFormLoad, copyRowObjectFn = _a.copyRowObjectFn, item = _a.item, gridComp = _a.gridComp;
	            console.log("onCopyRow %O", item);
	            return _this.onCommitRowInner(item)
	                .then(function (result) {
	                var newRowObject = item.rowObject.cloneDeep();
	                newRowObject.$formMap.clear();
	                newRowObject.$added = true;
	                newRowObject.$new = true;
	                newRowObject = copyRowObjectFn(newRowObject);
	                grid.addRow(newRowObject);
	                return onEditFormLoad
	                    ? onEditFormLoad(newRowObject)
	                    : Promise.resolve(newRowObject);
	            })
	                .then(function (rowObject) {
	                var form = rowObject.getForm(editFormName);
	                form.$open = true;
	                //form.$pristineObject = cloneDeep(newRowObject);
	                rootObject.$dirty = true;
	                grid.$dirty = true;
	                gridComp.forceUpdate();
	                return 1;
	            })
	                .catch(function (error) { });
	        };
	        _this.formRefHandler = function (comp) { return (_this.formRef = comp); };
	        return _this;
	    }
	    EditFormComp.prototype.componentDidMount = function () {
	        //console.log('%c %s EditFormComp componentDidMount', 'background-color: red', this.props.editFormName);
	        this.setRowHeight();
	    };
	    // VirtualList reuse components, because they have the same key, only data are changed in componentDidUpdate
	    EditFormComp.prototype.componentDidUpdate = function (prevProps, prevState) {
	        //console.log('%c %s  EditFormComp componentDidUpdate', 'background-color: red', this.props.editFormName);
	        this.setRowHeight();
	    };
	    EditFormComp.prototype.setRowHeight = function () {
	        var _a = this.props, item = _a.item, gridComp = _a.gridComp;
	        if (this.formRef) {
	            var rec = this.formRef.getBoundingClientRect();
	            if (rec) {
	                item.rowHeight = rec.height;
	            }
	        }
	        //console.log("setRowHeight: rowProps.gridRow.rowHeight = " + item.rowHeight);
	        gridComp.forceUpdate();
	    };
	    EditFormComp.prototype.render = function () {
	        var _a = this.props, editForm = _a.editForm, item = _a.item, hideCopyRow = _a.hideCopyRow;
	        var clonedForm = react_1.default.cloneElement(editForm, {
	            dataObject: item.rowObject,
	        });
	        return (react_1.default.createElement("form", { ref: this.formRefHandler },
	            react_1.default.createElement("div", { className: "md-item--open" },
	                clonedForm,
	                react_1.default.createElement(SvgDone, { className: "active-item--check  zz-mr-15", size: 24, onClick: this.onCommitRow }),
	                react_1.default.createElement(SvgClear, { className: "active-item--check", size: 24, onClick: this.onRollbackRow }),
	                hideCopyRow ? null : (react_1.default.createElement(FaCopy, { className: "active-item--check zz-ml-15", size: 18, onClick: this.onCopyRow })))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EditFormComp.prototype, "onRollbackRow", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EditFormComp.prototype, "onCommitRow", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EditFormComp.prototype, "onCommitRowInner", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EditFormComp.prototype, "onCopyRow", void 0);
	    EditFormComp = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EditFormComp);
	    return EditFormComp;
	}(react_1.default.Component));
	var ExpandWrapperComp = /** @class */ (function (_super) {
	    tslib_1.__extends(ExpandWrapperComp, _super);
	    function ExpandWrapperComp() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.expandoRefHandler = function (comp) { return (_this.expandoRef = comp); };
	        return _this;
	    }
	    ExpandWrapperComp.prototype.componentDidMount = function () {
	        //console.log('%c %s EditFormComp componentDidMount', 'background-color: red', this.props.editFormName);
	        this.setRowHeight();
	    };
	    // VirtualList reuse components, because they have the same key, only data are changed in componentDidUpdate
	    ExpandWrapperComp.prototype.componentDidUpdate = function (prevProps, prevState) {
	        //console.log('%c %s  EditFormComp componentDidUpdate', 'background-color: red', this.props.editFormName);
	        this.setRowHeight();
	    };
	    ExpandWrapperComp.prototype.setRowHeight = function () {
	        var _a = this.props, item = _a.item, gridComp = _a.gridComp;
	        if (this.expandoRef) {
	            var rec = this.expandoRef.getBoundingClientRect();
	            if (rec) {
	                item.rowHeight = rec.height + grid_1.ROW_HEIGHT + 8;
	            }
	        }
	        console.log("setRowHeight: rowProps.gridRow.rowHeight = " + item.rowHeight);
	        gridComp.forceUpdate();
	    };
	    ExpandWrapperComp.prototype.render = function () {
	        var _a = this.props, ExpandComponent = _a.ExpandComponent, item = _a.item;
	        return (react_1.default.createElement("div", { ref: this.expandoRefHandler },
	            react_1.default.createElement(ExpandComponent, { item: item })));
	    };
	    ExpandWrapperComp = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ExpandWrapperComp);
	    return ExpandWrapperComp;
	}(react_1.default.Component));
	var ChartButton = function (props) {
	    return (react_1.default.createElement("div", { style: {
	            display: "inline-flex",
	            alignItems: "center",
	            verticalAlign: "top",
	        }, onClick: function (e) { return e.stopPropagation(); } },
	        react_1.default.createElement(icons_1.MdIconButton, { onClick: props.onClickChart, style: {
	                width: 28,
	                height: 40,
	                padding: "8px 2px",
	                verticalAlign: "top",
	            }, iconStyle: GridComp__iconStyle, disabled: props.grid.loading }, props.showChart ? react_1.default.createElement(MdChartPie, null) : react_1.default.createElement(MdChartPieOutlined, null)),
	        (!!props.grid.selectedRowIds.size || props.grid.selectedAllRows) && (react_1.default.createElement("div", { style: {
	                display: "inline-block",
	                marginRight: 10,
	                marginBottom: 2,
	            } }, "(".concat(props.grid.selectedAllRows
	            ? props.grid.getTotalCount()
	            : props.grid.selectedRowIds.size, ")")))));
	};
	var ChartIconOverlay = /** @class */ (function (_super) {
	    tslib_1.__extends(ChartIconOverlay, _super);
	    function ChartIconOverlay() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.boundHadleWindowClick = _this.hadleWindowClick.bind(_this);
	        return _this;
	    }
	    ChartIconOverlay.prototype.hadleWindowClick = function () {
	        if (this.props.showExceedChartRows) {
	            this.props.onShowExceedChartRowsChange(false);
	        }
	    };
	    ChartIconOverlay.prototype.componentDidMount = function () {
	        window.addEventListener("click", this.boundHadleWindowClick);
	    };
	    ChartIconOverlay.prototype.componentWillUnmount = function () {
	        window.removeEventListener("click", this.boundHadleWindowClick);
	    };
	    ChartIconOverlay.prototype.render = function () {
	        var p = this.props;
	        var isSQLQueryGrid = p.grid.$gridLocationRef.gridType === grid_1.GRIDTYPE.SQLQUERY;
	        return p.showExceedChartRows ? (
	        //necessary workaround. OverlayTrigger in bootstrap version 0.33 does have `show` property private
	        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { trigger: isSQLQueryGrid ? "hover" : "click", defaultOverlayShown: true, key: "graph-botom-popover-overlay", placement: "bottom", overlay: react_1.default.createElement(react_bootstrap_1.Popover, { id: "graph-botom-popover-overlay", className: "graph-button-popover", title: locales_1.loc.i18n(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["chart.rowExceed"], ["chart.rowExceed"]))), onClick: function (e) { return e.stopPropagation(); } }, p.loadingNewRowsIds ? (react_1.default.createElement("div", { className: "rows-ids-loader" },
	                react_1.default.createElement("div", null, locales_1.loc.i18n(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["chart.fetchingIds"], ["chart.fetchingIds"])))),
	                react_1.default.createElement(loading_1.LoadingIcon, null))) : isSQLQueryGrid ? (react_1.default.createElement("div", { style: { padding: "8px 14px", maxWidth: 250 } }, locales_1.loc.i18n(templateObject_11 || (templateObject_11 = tslib_1.__makeTemplateObject(["chart.pleaseFilter500"], ["chart.pleaseFilter500"]))))) : (react_1.default.createElement("div", { style: { display: "flex" } },
	                react_1.default.createElement("div", null,
	                    react_1.default.createElement(MenuItem_1.default, { onClick: function (e) {
	                            p.selectFirstRows(e, function () {
	                                p.onShowExceedChartRowsChange(false);
	                            });
	                        } }, locales_1.loc.i18n(templateObject_12 || (templateObject_12 = tslib_1.__makeTemplateObject(["chart.selectTop"], ["chart.selectTop"])))),
	                    react_1.default.createElement(MenuItem_1.default, { onClick: function (e) {
	                            p.selectFirstRows(e, function () {
	                                p.onClickChart();
	                                p.onShowExceedChartRowsChange(false);
	                            });
	                        } }, locales_1.loc.i18n(templateObject_13 || (templateObject_13 = tslib_1.__makeTemplateObject(["chart.goTo"], ["chart.goTo"]))))),
	                react_1.default.createElement(material_ui_1.TextField, { id: "chart-rows-text-field", type: "number", style: { width: 50, margin: "auto" }, min: 0, max: p.maxChartRows, value: p.selectedForChart, onChange: function (e) {
	                        var value = e.target.value;
	                        if (value > p.maxChartRows)
	                            value = p.maxChartRows;
	                        if (value < 1 && value != "")
	                            value = 1;
	                        p.onSelectedForChartChange(value);
	                    }, onBlur: function (e) {
	                        if (!e.target.value)
	                            p.onSelectedForChartChange(1);
	                    } })))) },
	            react_1.default.createElement(ChartButton, { onClickChart: p.onClickChart, showChart: p.showChart, grid: this.props.grid }))) : (react_1.default.createElement(ChartButton, { onClickChart: p.onClickChart, showChart: p.showChart, grid: this.props.grid }));
	    };
	    return ChartIconOverlay;
	}(react_1.default.Component));
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SvgIcon = __webpack_require__(1545);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SvgIcon2.default;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(1585);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(212);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _setDisplayName = __webpack_require__(773);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(774);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = function pure(BaseComponent) {
	  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
	    return !(0, _shallowEqual2.default)(props, nextProps);
	  });
	
	  if (false) {
	    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
	  }
	
	  return hoc(BaseComponent);
	};
	
	exports.default = pure;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var dialogAncestor_1 = __webpack_require__(87);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	/**
	 * title muze byt nedefinovany - pak se pouzije z defaultniho state, nebo prijit pres props, nebo projit z open (nejvyssi priorita)
	 */
	var ConfirmationDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(ConfirmationDialog, _super);
	    function ConfirmationDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            title: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["You have unsaved information, are you sure you want to leave this page?"], ["You have unsaved information, are you sure you want to leave this page?"])))
	        };
	        _this.ok = function () {
	            console.log('ConfirmationDialog OK');
	            _this.dialogOpen = false;
	            _this.resolve("ok");
	        };
	        _this.cancel = function () {
	            console.log('ConfirmationDialog CANCEL');
	            _this.dialogOpen = false;
	            _this.reject("cancel");
	        };
	        return _this;
	    }
	    ConfirmationDialog.prototype.open = function (resolve, reject, title) {
	        console.log('ConfirmationDialog: Opening confirmation dialog');
	        this.resolve = resolve;
	        this.reject = reject;
	        this.dialogOpen = true;
	        this.setState({
	            title: (title) ? title : ((this.props.title) ? this.props.title : this.state.title)
	        });
	    };
	    ConfirmationDialog.prototype.render = function () {
	        var _a = this.props, cancelButtonText = _a.cancelButtonText, okButtonText = _a.okButtonText, contentComponent = _a.contentComponent;
	        var actions = [
	            react_1.default.createElement(FlatButton_1.default, { label: cancelButtonText, primary: true, onClick: this.cancel }),
	            react_1.default.createElement(FlatButton_1.default, { label: okButtonText, secondary: true, onClick: this.ok }),
	        ];
	        return (react_1.default.createElement(Dialog_1.default, { title: this.state.title, actions: actions, modal: true, open: this.dialogOpen, contentStyle: { width: 450, zIndex: 3000 } }, contentComponent));
	    };
	    ConfirmationDialog.defaultProps = {
	        cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No, return back"], ["No, return back"]))),
	        okButtonText: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Yes, continue"], ["Yes, continue"])))
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ConfirmationDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ConfirmationDialog.prototype, "ok", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ConfirmationDialog.prototype, "cancel", void 0);
	    ConfirmationDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ConfirmationDialog);
	    return ConfirmationDialog;
	}(dialogAncestor_1.DialogAncestor));
	exports.default = ConfirmationDialog;
	var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Party = exports.PartyBankAccount = exports.PartyRel = exports.PartyFeature = exports.PartyNote = exports.PartyContact = exports.Address = exports.PartyInfo = exports.AddressPlace = exports.PartyRole = exports.PARTYNOTETYPE = exports.ADDRESSPLACETYPE = exports.PARTYFEATURETYPE = exports.PARTYCONTACTCATEGORY = exports.ADDRESSTYPE = exports.PARTYCATEGORY = exports.COUNTRY = exports.PARTYROLE = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var metaConstant_1 = __webpack_require__(13);
	var formUtils_1 = __webpack_require__(14);
	var partyService_1 = tslib_1.__importDefault(__webpack_require__(175));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var minBy = __webpack_require__(728);
	exports.PARTYROLE = {
	    CUSTOMER_ROLE: 1,
	    CONTACT_ROLE: 2,
	    SALESREP_ROLE: 3,
	    USER_ROLE: 4,
	    PRICE_GROUP_ROLE: 5,
	    OWNER_ROLE: 6,
	    EMAIL_INVOICE: 7,
	    EMAIL_NOTIFICATION: 8,
	    EMAIL_REGISTRATION: 9,
	    OPERATOR: 10,
	    SUPPLIER_ROLE: 11,
	    EMPLOYEE: 14,
	    PACKAGING: 24,
	    HAULER: 29,
	    EMPLOYER: 30,
	    DRIVER: 31
	};
	// COUNTRIES
	var COUNTRY;
	(function (COUNTRY) {
	    COUNTRY["CZ"] = "CZ";
	    COUNTRY["SK"] = "SK";
	    COUNTRY["HU"] = "HU";
	    COUNTRY["RO"] = "RO";
	})(COUNTRY || (exports.COUNTRY = COUNTRY = {}));
	var PARTYCATEGORY;
	(function (PARTYCATEGORY) {
	    PARTYCATEGORY["PE"] = "PE";
	    PARTYCATEGORY["CO"] = "CO";
	    PARTYCATEGORY["EN"] = "EN";
	})(PARTYCATEGORY || (exports.PARTYCATEGORY = PARTYCATEGORY = {}));
	var ADDRESSTYPE;
	(function (ADDRESSTYPE) {
	    ADDRESSTYPE["PERMANENT"] = "PERMANENT";
	    ADDRESSTYPE["CORRESPONDENT"] = "CORRESPONDENT";
	    ADDRESSTYPE["DELIVERY"] = "DELIVERY";
	    ADDRESSTYPE["OTHER"] = "OTHER";
	})(ADDRESSTYPE || (exports.ADDRESSTYPE = ADDRESSTYPE = {}));
	var PARTYCONTACTCATEGORY;
	(function (PARTYCONTACTCATEGORY) {
	    PARTYCONTACTCATEGORY["PHONE"] = "PHONE";
	    PARTYCONTACTCATEGORY["EMAIL"] = "EMAIL";
	    PARTYCONTACTCATEGORY["WEB"] = "WEB";
	})(PARTYCONTACTCATEGORY || (exports.PARTYCONTACTCATEGORY = PARTYCONTACTCATEGORY = {}));
	var PARTYFEATURETYPE;
	(function (PARTYFEATURETYPE) {
	    PARTYFEATURETYPE["INVOICE_DATA"] = "INVOICE_DATA";
	    PARTYFEATURETYPE["VOLVO_LOGINS"] = "VOLVO_LOGINS";
	    PARTYFEATURETYPE["AUTONEUM_DATA"] = "AUTONEUM_DATA";
	})(PARTYFEATURETYPE || (exports.PARTYFEATURETYPE = PARTYFEATURETYPE = {}));
	var ADDRESSPLACETYPE;
	(function (ADDRESSPLACETYPE) {
	    ADDRESSPLACETYPE["EXPEDITION"] = "EXPEDITION";
	    ADDRESSPLACETYPE["INCOMING"] = "INCOMING";
	})(ADDRESSPLACETYPE || (exports.ADDRESSPLACETYPE = ADDRESSPLACETYPE = {}));
	var PARTYNOTETYPE;
	(function (PARTYNOTETYPE) {
	    PARTYNOTETYPE["VEHICLE_NOTIFICATION"] = "VEHICLE_NOTIFICATION";
	    PARTYNOTETYPE["INVOICE"] = "INVOICE";
	})(PARTYNOTETYPE || (exports.PARTYNOTETYPE = PARTYNOTETYPE = {}));
	var PartyRole = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyRole, _super);
	    function PartyRole(json) {
	        return _super.call(this, json) || this;
	    }
	    PartyRole.prototype.getId = function () {
	        return this.partyRoleId;
	    };
	    PartyRole.prototype.setId = function (id) {
	        this.partyRoleId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyRole.prototype, "partyRoleId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyRole.prototype, "roleType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyRole.prototype, "party", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyRole.prototype, "validFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyRole.prototype, "validTo", void 0);
	    PartyRole = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], PartyRole);
	    return PartyRole;
	}(DomainAncestor_1.DomainAncestor));
	exports.PartyRole = PartyRole;
	var AddressPlace = /** @class */ (function (_super) {
	    tslib_1.__extends(AddressPlace, _super);
	    function AddressPlace(json) {
	        return _super.call(this, json) || this;
	    }
	    AddressPlace.prototype.getId = function () {
	        return this.addressPlaceId;
	    };
	    AddressPlace.prototype.setId = function (id) {
	        this.addressPlaceId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], AddressPlace.prototype, "addressPlaceId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], AddressPlace.prototype, "address", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], AddressPlace.prototype, "party", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], AddressPlace.prototype, "placeType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], AddressPlace.prototype, "name", void 0);
	    AddressPlace = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], AddressPlace);
	    return AddressPlace;
	}(DomainAncestor_1.DomainAncestor));
	exports.AddressPlace = AddressPlace;
	var PartyInfo = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyInfo, _super);
	    function PartyInfo(json) {
	        var _this = _super.call(this, json) || this;
	        _this.permanentAddress = new Address(json["permanentAddress"]);
	        if (!!json["defaultBankAccount"]) {
	            _this.defaultBankAccount = new PartyBankAccount(json["defaultBankAccount"]);
	        }
	        return _this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyInfo.prototype, "id", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyInfo.prototype, "vatId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyInfo.prototype, "permanentAddress", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyInfo.prototype, "defaultBankAccount", void 0);
	    PartyInfo = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], PartyInfo);
	    return PartyInfo;
	}(DomainAncestor_1.DomainAncestor));
	exports.PartyInfo = PartyInfo;
	var Address = /** @class */ (function (_super) {
	    tslib_1.__extends(Address, _super);
	    function Address(json) {
	        return _super.call(this, json) || this;
	    }
	    Address.addressLineFromItems = function (street, city, zip, country) {
	        return ((street) ? street : '')
	            + ((city || zip) ? ',' : '')
	            + ((city) ? ' ' + city : '')
	            + ((zip) ? ' ' + zip : '')
	            + ((country) ? ', ' + country.label : '');
	    };
	    Address.prototype.getId = function () {
	        return this.addressId;
	    };
	    Address.prototype.setId = function (id) {
	        this.addressId = id;
	    };
	    Address.prototype.fullStreet = function () {
	        return [
	            (!this.street) ? this.city : this.street,
	            [this.descriptiveNumber, this.orientationalNumber].filter(function (s) { return s; }).join("/")
	        ].filter(function (s) { return s; }).join(" ");
	    };
	    Address.prototype.addressLine = function () {
	        var street = this.fullStreet();
	        return this.fullStreet()
	            + ((this.city || this.zip) ? ',' : '')
	            + ((this.city) ? ' ' + this.city : '')
	            + ((this.zip) ? ' ' + this.zip : '')
	            + ((this.administrativeArea) ? ', ' + this.administrativeArea : '')
	            + ((this.country) ? ', ' + this.country.label : '');
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "addressId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "party", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "addressType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "street", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "toHands", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "descriptiveNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "orientationalNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "city", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "zip", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "country", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "administrativeArea", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "locationType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "placeId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "locationLat", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "locationLng", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "ftlEscalationMinutes", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "ltlEscalationMinutes", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Address.prototype, "defaultDisponentParty", void 0);
	    Address = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], Address);
	    return Address;
	}(DomainAncestor_1.DomainAncestor));
	exports.Address = Address;
	var PartyContact = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyContact, _super);
	    function PartyContact(json) {
	        return _super.call(this, json) || this;
	    }
	    PartyContact.prototype.getId = function () {
	        return this.partyContactId;
	    };
	    PartyContact.prototype.setId = function (id) {
	        this.partyContactId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyContact.prototype, "partyContactId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyContact.prototype, "contactType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyContact.prototype, "party", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyContact.prototype, "validFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyContact.prototype, "validTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyContact.prototype, "orderByType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyContact.prototype, "value", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyContact.prototype, "comment", void 0);
	    PartyContact = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], PartyContact);
	    return PartyContact;
	}(DomainAncestor_1.DomainAncestor));
	exports.PartyContact = PartyContact;
	var PartyNote = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyNote, _super);
	    function PartyNote(json) {
	        return _super.call(this, json) || this;
	    }
	    PartyNote.prototype.getId = function () {
	        return this.partyNoteId;
	    };
	    PartyNote.prototype.setId = function (id) {
	        this.partyNoteId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyNote.prototype, "partyNoteId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyNote.prototype, "content", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyNote.prototype, "party", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyNote.prototype, "noteType", void 0);
	    PartyNote = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], PartyNote);
	    return PartyNote;
	}(DomainAncestor_1.DomainAncestor));
	exports.PartyNote = PartyNote;
	var PartyFeature = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyFeature, _super);
	    function PartyFeature(json) {
	        return _super.call(this, json) || this;
	    }
	    PartyFeature.prototype.getId = function () {
	        return this.partyFeatureId;
	    };
	    PartyFeature.prototype.setId = function (id) {
	        this.partyFeatureId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyFeature.prototype, "partyFeatureId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyFeature.prototype, "featureType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyFeature.prototype, "party", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyFeature.prototype, "value1", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyFeature.prototype, "value2", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyFeature.prototype, "value3", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyFeature.prototype, "value4", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyFeature.prototype, "value5", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyFeature.prototype, "value6", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyFeature.prototype, "value7", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyFeature.prototype, "value8", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyFeature.prototype, "value9", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyFeature.prototype, "value10", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyFeature.prototype, "value11", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyFeature.prototype, "value12", void 0);
	    PartyFeature = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)(/** @class */ (function (_super) {
	            tslib_1.__extends(class_1, _super);
	            function class_1() {
	                return _super.call(this, "PartyFeature") || this;
	            }
	            class_1.prototype.getFormName = function (historyObject) {
	                return historyObject.fullObject.featureType + 'Form';
	            };
	            return class_1;
	        }(metaConstant_1.EntityConfig)))
	    ], PartyFeature);
	    return PartyFeature;
	}(DomainAncestor_1.DomainAncestor));
	exports.PartyFeature = PartyFeature;
	var PartyRel = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyRel, _super);
	    function PartyRel(json) {
	        return _super.call(this, json) || this;
	    }
	    PartyRel.prototype.getId = function () {
	        return this.partyRelId;
	    };
	    PartyRel.prototype.setId = function (id) {
	        this.partyRelId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyRel.prototype, "partyRelId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyRel.prototype, "relType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyRel.prototype, "fromParty", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyRel.prototype, "toParty", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyRel.prototype, "fromPartyOrderByType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyRel.prototype, "toPartyOrderByType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyRel.prototype, "description", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyRel.prototype, "comments", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyRel.prototype, "validFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyRel.prototype, "validTo", void 0);
	    PartyRel = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], PartyRel);
	    return PartyRel;
	}(DomainAncestor_1.DomainAncestor));
	exports.PartyRel = PartyRel;
	var PartyBankAccount = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyBankAccount, _super);
	    function PartyBankAccount(json) {
	        return _super.call(this, json) || this;
	    }
	    PartyBankAccount.prototype.getId = function () {
	        return this.partyBankAccountId;
	    };
	    PartyBankAccount.prototype.setId = function (id) {
	        this.partyBankAccountId = id;
	    };
	    PartyBankAccount.prototype.getFullAccount = function () {
	        var bankEntity = mdEntityService_1.default.getEntity("Bank");
	        var bankCode = bankEntity.getLovItemParam((0, formUtils_1.lovValue)(this.bank), "bankCode");
	        return ((this.accountPrefix) ? (this.accountPrefix + "-") : "") + this.accountNumber + ((bankCode) ? ("/" + bankCode) : "");
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyBankAccount.prototype, "partyBankAccountId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyBankAccount.prototype, "bank", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyBankAccount.prototype, "party", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyBankAccount.prototype, "accountPrefix", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyBankAccount.prototype, "accountNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyBankAccount.prototype, "iban", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyBankAccount.prototype, "currency", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyBankAccount.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyBankAccount.prototype, "validFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyBankAccount.prototype, "validTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyBankAccount.prototype, "hasApiToken", void 0);
	    PartyBankAccount = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], PartyBankAccount);
	    return PartyBankAccount;
	}(DomainAncestor_1.DomainAncestor));
	exports.PartyBankAccount = PartyBankAccount;
	var Party = /** @class */ (function (_super) {
	    tslib_1.__extends(Party, _super);
	    function Party(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.contacts)
	            _this.contacts = [];
	        if (!_this.addresses)
	            _this.addresses = [];
	        if (!_this.notes)
	            _this.notes = [];
	        if (!_this.features)
	            _this.features = [];
	        if (!_this.roles)
	            _this.roles = [];
	        if (!_this.bankAccounts)
	            _this.bankAccounts = [];
	        return _this;
	    }
	    Party.prototype.getId = function () {
	        return this.partyId;
	    };
	    Party.prototype.setId = function (id) {
	        this.partyId = id;
	    };
	    Party.prototype.roleName = function () {
	        // min protoze party pojmenujeme podle role s nejnizsim roleTypeId
	        var minRole = minBy(this.roles, function (role) { return (0, formUtils_1.lovValue)(role.roleType); });
	        return (minRole) ? (0, formUtils_1.lovLabel)(minRole.roleType) : "Party";
	    };
	    Party.prototype.partyIcon = function () {
	        // min protoze party pojmenujeme podle role s nejnizsim roleTypeId
	        var minRole = minBy(this.roles, function (role) { return (0, formUtils_1.lovValue)(role.roleType); });
	        return (minRole) ? (0, formUtils_1.lovParam)(minRole.roleType, "icon") : "user";
	    };
	    /**
	     * bacha pouziva se v default vyrazech ulozenych v DB
	     * @param roleType
	     * @return {boolean}
	     */
	    Party.prototype.hasRole = function (roleType) {
	        return this.roles.findIndex(function (role) { return (0, formUtils_1.lovValue)(role.roleType) === roleType; }) !== -1;
	    };
	    Party.prototype.hasOneOfRoles = function () {
	        var roleTypes = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            roleTypes[_i] = arguments[_i];
	        }
	        return this.roles.findIndex(function (role) { return roleTypes.includes((0, formUtils_1.lovValue)(role.roleType)); }) !== -1;
	    };
	    /**
	     *
	     * @param roleType
	     */
	    Party.prototype.addRole = function (roleType) {
	        this.roles.push(partyService_1.default.newRole(roleType));
	    };
	    Party.prototype.partyLabel = function () {
	        return this.fullName + ((this.ico) ? ' (' + this.ico + ')' : '');
	    };
	    Party.prototype.partyLov = function () {
	        return {
	            value: this.partyId,
	            label: this.partyLabel(),
	            roleTypes: this.roles.map(function (r) { return r.roleType.value; })
	        };
	    };
	    Party.prototype.partyPermanentAddress = function () {
	        if (this.addresses) {
	            return this.addresses.find(function (address) { return (0, formUtils_1.lovValue)(address.addressType) === ADDRESSTYPE.PERMANENT; });
	        }
	        else {
	            return null;
	        }
	    };
	    Party.prototype.partyCorrespondentAddress = function () {
	        if (this.addresses) {
	            return this.addresses.find(function (address) { return (0, formUtils_1.lovValue)(address.addressType) === ADDRESSTYPE.CORRESPONDENT; });
	        }
	        else {
	            return null;
	        }
	    };
	    Party.prototype.getPartyFeature = function (featureType) {
	        return this.features.find(function (f) { return f.featureType === featureType; });
	    };
	    Party.prototype.getAccountingMatchingId = function () {
	        var partyFeature = this.getPartyFeature(PARTYFEATURETYPE.INVOICE_DATA);
	        return (partyFeature != null) ? partyFeature.value1 : null;
	    };
	    Party.prototype.getInvoicingPeriod = function () {
	        var partyFeature = this.getPartyFeature(PARTYFEATURETYPE.INVOICE_DATA);
	        return (partyFeature != null) ? partyFeature.value4 : null;
	    };
	    Party.prototype.getInvoicingStartDate = function () {
	        var partyFeature = this.getPartyFeature(PARTYFEATURETYPE.INVOICE_DATA);
	        return (partyFeature != null) ? partyFeature.value5 : null;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "partyId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "fullName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "firstName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "lastName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "titleBefore", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "dateOfBirth", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "birthNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "birthLastName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "salutation", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "placeOfBirth", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "ico", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "dic", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "icoDph", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "commercialRegister", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "nationality", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "taxDomicile", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "gender", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "partyCategory", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "defaultSendType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "defaultAttachmentType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "defaultCurrency", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "defaultLanguage", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "defaultPaymentCond", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "legalForm", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "naceCode", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "marketingSource", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "defaultProfitCenter", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "vatIdCheckDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "closeDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "vatRateOverride", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "hrNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(PartyContact)
	    ], Party.prototype, "contacts", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(Address)
	    ], Party.prototype, "addresses", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(PartyNote)
	    ], Party.prototype, "notes", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(PartyFeature)
	    ], Party.prototype, "features", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(PartyRole)
	    ], Party.prototype, "roles", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(PartyBankAccount)
	    ], Party.prototype, "bankAccounts", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "$creditEntries", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Party.prototype, "$creditSums", void 0);
	    Party = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)(/** @class */ (function (_super) {
	            tslib_1.__extends(class_2, _super);
	            function class_2() {
	                return _super.call(this, "Party") || this;
	            }
	            class_2.prototype.getFormName = function (historyObject) {
	                return (historyObject.fullObject.partyCategory === PARTYCATEGORY.PE) ? "PartyFoForm" : "PartyPoForm";
	            };
	            return class_2;
	        }(metaConstant_1.EntityConfig)), "partyDetail")
	    ], Party);
	    return Party;
	}(DomainAncestor_1.DomainAncestor));
	exports.Party = Party;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TIME_PATTERN_HH_mm_ss = exports.TIME_PATTERN_HH_mm = void 0;
	exports.formatInterval = formatInterval;
	exports.isValid = isValid;
	exports.formatPeriod = formatPeriod;
	exports.formatDate = formatDate;
	exports.formatDateIso = formatDateIso;
	exports.formatDateTime = formatDateTime;
	exports.formatTime = formatTime;
	exports.sortAndCheckInterval = sortAndCheckInterval;
	exports.isFullMonth = isFullMonth;
	exports.stripTime = stripTime;
	var tslib_1 = __webpack_require__(3);
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var left_pad_1 = tslib_1.__importDefault(__webpack_require__(1358));
	var DEFAULT_DATE_FORMAT = 'L';
	var DEFAULT_DATETIME_FORMAT = "L LTS";
	var DEFAULT_TIME_FORMAT = "HH:mm";
	exports.TIME_PATTERN_HH_mm = "^[0-2]?\\d:[0-5]\\d$";
	exports.TIME_PATTERN_HH_mm_ss = "^[0-2]?\\d:[0-5]\\d(:[0-5]\\d)?$";
	function formatInterval(valueFrom, valueTo, showInfinityInterval) {
	    if (showInfinityInterval === void 0) { showInfinityInterval = true; }
	    var str = ((valueFrom) ? (0, moment_1.default)(valueFrom).format(DEFAULT_DATE_FORMAT) : '\u221E') + ' - ' + ((valueTo) ? (0, moment_1.default)(valueTo).format(DEFAULT_DATE_FORMAT) : '\u221E');
	    return (showInfinityInterval || valueFrom || valueTo) ? str : '';
	}
	function isValid(objekt, keDni) {
	    if (!keDni) {
	        return true;
	    }
	    var momentKeDni = (0, moment_1.default)(keDni);
	    return ((!objekt.validFrom || momentKeDni.isSameOrAfter(objekt.validFrom))
	        &&
	            (!objekt.validTo || momentKeDni.isSameOrBefore(objekt.validTo)));
	}
	function formatAny(value, format) {
	    if (!value) {
	        return value;
	    }
	    else {
	        var valueM = (0, moment_1.default)(value);
	        if (valueM.isValid()) {
	            return valueM.format(format);
	        }
	        else {
	            return value;
	        }
	    }
	}
	function formatPeriod(value, asHHmmss) {
	    if (asHHmmss === void 0) { asHHmmss = false; }
	    if (!value) {
	        return value;
	    }
	    else {
	        var duration = moment_1.default.duration(value);
	        return (asHHmmss) ? ((0, left_pad_1.default)(Math.trunc(duration.asHours()), 2, '0') + ":" + (0, left_pad_1.default)(duration.minutes(), 2, '0') + ((duration.seconds() > 0) ? ":" + (0, left_pad_1.default)(duration.seconds(), 2, '0') : "")) : duration.humanize();
	    }
	}
	/**
	 * If value is date or moment or string as date, it is formateed, otherwise is just returned
	 * @param value
	 * @param format
	 * @returns {*}
	 */
	function formatDate(value, format) {
	    if (format === void 0) { format = DEFAULT_DATE_FORMAT; }
	    return formatAny(value, format);
	}
	function formatDateIso(value) {
	    return formatAny(value, "YYYY-MM-DD");
	}
	/**
	 * If value is date or moment or string as date, it is formateed, otherwise is just returned
	 * @param value
	 * @param format
	 * @returns {*}
	 */
	function formatDateTime(value, format) {
	    if (format === void 0) { format = DEFAULT_DATETIME_FORMAT; }
	    return formatAny(value, format);
	}
	function formatTime(value, format) {
	    if (format === void 0) { format = DEFAULT_TIME_FORMAT; }
	    return formatAny(value, format);
	}
	/**
	 * setridi list objektu implementujicich ValidEntityIntf a zkontroluje ze se neprekryvaji,
	 * vrati false pokud se prekryvaji nebo je validTo mensi nez validFrom na temze elementu
	 *
	 * @param interval
	 * @param <T>
	 * @return
	 */
	function sortAndCheckInterval(intervals) {
	    if (!intervals || !intervals.length)
	        return true;
	    intervals = intervals.sort(function (o1, o2) { return (!o1.validFrom) ? -1 : ((!o2.validFrom) ? 1 : (0, moment_1.default)(o1.validFrom).valueOf() - (0, moment_1.default)(o2.validFrom).valueOf()); });
	    var lowerBoundInfinityCount = 0, higherBoundInfinityCount = 0;
	    var previousValue = null;
	    for (var _i = 0, intervals_1 = intervals; _i < intervals_1.length; _i++) {
	        var t = intervals_1[_i];
	        if (!t.validFrom)
	            lowerBoundInfinityCount++;
	        if (!t.validTo)
	            higherBoundInfinityCount++;
	        if (t.validFrom && t.validTo && (0, moment_1.default)(t.validFrom).isAfter(t.validTo)) {
	            return false;
	        }
	        if (previousValue) {
	            if (!previousValue.validTo || !t.validFrom || !(0, moment_1.default)(previousValue.validTo).isBefore(t.validFrom)) {
	                return false;
	            }
	        }
	        previousValue = t;
	    }
	    if (lowerBoundInfinityCount > 1)
	        return false;
	    if (higherBoundInfinityCount > 1)
	        return false;
	    return true;
	}
	function isFullMonth(start, end) {
	    var start2 = (0, moment_1.default)(start);
	    start2.startOf("month");
	    var end2 = (0, moment_1.default)(end);
	    end2.endOf("month").startOf('day');
	    return start2.isSame(start) && end2.isSame(end) && start2.month() === end2.month() && start2.year() === end2.year();
	}
	function stripTime(datetime) {
	    return new Date(datetime.setHours(0, 0, 0, 0));
	}


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ClientGrid = exports.GridData = exports.GridRow = exports.GridLocation = exports.GridLocationFieldDto = exports.GridLocationField = exports.ROW_HEIGHT = exports.AGGREGATETYPE_MAP = exports.AGGREGATETYPE = exports.FILTEROPERATOR = exports.GRIDTYPE = void 0;
	var tslib_1 = __webpack_require__(3);
	var remove = __webpack_require__(485);
	var findIndex = __webpack_require__(722);
	var first = __webpack_require__(1470);
	var isString = __webpack_require__(163);
	var isEmpty = __webpack_require__(284);
	var gridConfig_1 = tslib_1.__importDefault(__webpack_require__(264));
	var gridConfigCondition_1 = tslib_1.__importDefault(__webpack_require__(194));
	var formUtils_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(37);
	var mobx_1 = __webpack_require__(5);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var DomainAncestor_1 = __webpack_require__(33);
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var constant_1 = __webpack_require__(399);
	var locales_1 = __webpack_require__(15);
	var error_1 = __webpack_require__(2257);
	var metaDomain_1 = __webpack_require__(220);
	var stringUtils_1 = __webpack_require__(174);
	var GRIDTYPE;
	(function (GRIDTYPE) {
	    GRIDTYPE["HIBERNATESQLQUERY"] = "HIBERNATESQLQUERY";
	    GRIDTYPE["JAVACONFIG"] = "JAVACONFIG";
	    GRIDTYPE["SQLQUERY"] = "SQLQUERY";
	})(GRIDTYPE || (exports.GRIDTYPE = GRIDTYPE = {}));
	// COUNTRIES
	var FILTEROPERATOR;
	(function (FILTEROPERATOR) {
	    FILTEROPERATOR["IN"] = "IN";
	    FILTEROPERATOR["NOTIN"] = "NOTIN";
	    FILTEROPERATOR["EQUAL"] = "EQUAL";
	    FILTEROPERATOR["NOTEQUAL"] = "NOTEQUAL";
	    FILTEROPERATOR["STARTSWITH"] = "STARTSWITH";
	    FILTEROPERATOR["NOTSTARTSWITH"] = "NOTSTARTSWITH";
	    FILTEROPERATOR["ENDSWITH"] = "ENDSWITH";
	    FILTEROPERATOR["NOTENDSWITH"] = "NOTENDSWITH";
	    FILTEROPERATOR["GREATERTHAN"] = "GREATERTHAN";
	    FILTEROPERATOR["GREATEROREQUALTHAN"] = "GREATEROREQUALTHAN";
	    FILTEROPERATOR["LESSTHAN"] = "LESSTHAN";
	    FILTEROPERATOR["LESSOREQUALTHAN"] = "LESSOREQUALTHAN";
	    FILTEROPERATOR["CONTAINS"] = "CONTAINS";
	    FILTEROPERATOR["NOTCONTAINS"] = "NOTCONTAINS";
	    FILTEROPERATOR["LASTXDAYS"] = "LASTXDAYS";
	    FILTEROPERATOR["NEXTXDAYS"] = "NEXTXDAYS";
	    FILTEROPERATOR["FROMTO"] = "FROMTO";
	    FILTEROPERATOR["ISTRUE"] = "ISTRUE";
	    FILTEROPERATOR["ISFALSE"] = "ISFALSE";
	    FILTEROPERATOR["ISNULL"] = "ISNULL";
	    FILTEROPERATOR["ISNOTNULL"] = "ISNOTNULL";
	})(FILTEROPERATOR || (exports.FILTEROPERATOR = FILTEROPERATOR = {}));
	var AGGREGATETYPE;
	(function (AGGREGATETYPE) {
	    AGGREGATETYPE["SUM"] = "SUM";
	    AGGREGATETYPE["AVG"] = "AVG";
	})(AGGREGATETYPE || (exports.AGGREGATETYPE = AGGREGATETYPE = {}));
	exports.AGGREGATETYPE_MAP = {
	    SUM: { glyph: '\u03A3' },
	    AVG: { glyph: '\u2300' }
	};
	var FILTEROPERATOR_MAP = {
	    IN: function (field, value, params) { return params.map(function (p) { return (0, formUtils_1.lovValue)(p); }).includes((field.valueSourceType) ? (0, formUtils_1.lovValue)(value) : value); },
	    NOTIN: function (field, value, params) { return !params.map(function (p) { return (0, formUtils_1.lovValue)(p); }).includes((field.valueSourceType) ? (0, formUtils_1.lovValue)(value) : value); },
	    EQUAL: function (field, value, params) { return ((field.valueSourceType) ? (0, formUtils_1.lovValue)(value) : value) == (0, formUtils_1.lovValue)(params[0]); },
	    NOTEQUAL: function (field, value, params) { return ((field.valueSourceType) ? (0, formUtils_1.lovValue)(value) : value) != (0, formUtils_1.lovValue)(params[0]); },
	    STARTSWITH: function (field, value, params) { return ((field.valueSourceType) ? (0, formUtils_1.lovLabel)(value) : value).toLowerCase().startsWith((0, formUtils_1.lovLabel)(params[0]).toLowerCase()); },
	    NOTSTARTSWITH: function (field, value, params) { return !((field.valueSourceType) ? (0, formUtils_1.lovLabel)(value) : value).toLowerCase().startsWith((0, formUtils_1.lovLabel)(params[0]).toLowerCase()); },
	    ENDSWITH: function (field, value, params) { return ((field.valueSourceType) ? (0, formUtils_1.lovLabel)(value) : value).toLowerCase().endsWith((0, formUtils_1.lovLabel)(params[0]).toLowerCase()); },
	    NOTENDSWITH: function (field, value, params) { return !((field.valueSourceType) ? (0, formUtils_1.lovLabel)(value) : value).toLowerCase().endsWith((0, formUtils_1.lovLabel)(params[0]).toLowerCase()); },
	    GREATERTHAN: function (field, value, params) { return ((field.valueSourceType) ? (0, formUtils_1.lovLabel)(value) : value) > (0, formUtils_1.lovLabel)(params[0]); },
	    GREATEROREQUALTHAN: function (field, value, params) { return ((field.valueSourceType) ? (0, formUtils_1.lovLabel)(value) : value) >= (0, formUtils_1.lovLabel)(params[0]); },
	    LESSTHAN: function (field, value, params) { return ((field.valueSourceType) ? (0, formUtils_1.lovLabel)(value) : value) < (0, formUtils_1.lovLabel)(params[0]); },
	    LESSOREQUALTHAN: function (field, value, params) { return ((field.valueSourceType) ? (0, formUtils_1.lovLabel)(value) : value) <= (0, formUtils_1.lovLabel)(params[0]); },
	    CONTAINS: function (field, value, params) { return ((field.valueSourceType) ? (0, formUtils_1.lovLabel)(value) : value).toLowerCase().indexOf((0, formUtils_1.lovLabel)(params[0]).toLowerCase()) != -1; },
	    NOTCONTAINS: function (field, value, params) { return ((field.valueSourceType) ? (0, formUtils_1.lovLabel)(value) : value).toLowerCase().indexOf((0, formUtils_1.lovLabel)(params[0]).toLowerCase()) == -1; },
	    LASTXDAYS: function (field, value, params) {
	        var days = params[0];
	        var valueDate = (0, moment_1.default)(value);
	        var systemDate = (0, moment_1.default)();
	        return !valueDate.isBefore(systemDate.subtract(days, 'd')) && !valueDate.isAfter(systemDate);
	    },
	    NEXTXDAYS: function (field, value, params) {
	        var days = params[0];
	        var valueDate = (0, moment_1.default)(value);
	        var systemDate = (0, moment_1.default)();
	        return !valueDate.isAfter(systemDate.add(days, 'd')) && !valueDate.isBefore(systemDate);
	    },
	    FROMTO: function (field, value, params) {
	        value = ((field.valueSourceType) ? (0, formUtils_1.lovLabel)(value) : value);
	        return value >= (0, formUtils_1.lovLabel)(params[0]) && value <= (0, formUtils_1.lovLabel)(params[1]);
	    },
	    ISTRUE: function (field, value, params) { return value == true; },
	    ISFALSE: function (field, value, params) { return value == false; },
	    ISNULL: function (field, value, params) { return value == null; },
	    ISNOTNULL: function (field, value, params) { return value != null; }
	};
	exports.ROW_HEIGHT = 28;
	var GridLocationField = /** @class */ (function (_super) {
	    tslib_1.__extends(GridLocationField, _super);
	    function GridLocationField() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    GridLocationField = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], GridLocationField);
	    return GridLocationField;
	}(DomainAncestor_1.DomainAncestor));
	exports.GridLocationField = GridLocationField;
	var GridLocationFieldDto = /** @class */ (function (_super) {
	    tslib_1.__extends(GridLocationFieldDto, _super);
	    function GridLocationFieldDto(json) {
	        return _super.call(this, json) || this;
	    }
	    GridLocationFieldDto.prototype.fromJson = function (json) {
	        _super.prototype.fromJson.call(this, json, "locales");
	        if (!this.locales)
	            this.locales = new mobx_1.ObservableMap();
	        return this;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridLocationFieldDto.prototype, "gridLocationField", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(metaDomain_1.LocaleLabel)
	    ], GridLocationFieldDto.prototype, "locales", void 0);
	    GridLocationFieldDto = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], GridLocationFieldDto);
	    return GridLocationFieldDto;
	}(DomainAncestor_1.DomainAncestor));
	exports.GridLocationFieldDto = GridLocationFieldDto;
	var GridLocation = /** @class */ (function (_super) {
	    tslib_1.__extends(GridLocation, _super);
	    function GridLocation(mdEntity, json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.specialConditions)
	            _this.specialConditions = [];
	        if (!_this.assignedDocumentTypes)
	            _this.assignedDocumentTypes = [];
	        if (!_this.assignedActivityConfigs)
	            _this.assignedActivityConfigs = [];
	        _this.$entityRef = mdEntity;
	        _this.gridConfigs = (_this.gridConfigs) ? _this.gridConfigs.map(function (gridConfigJson) { return new gridConfig_1.default(_this, gridConfigJson); }) : [];
	        _this.implicitConditions = (_this.implicitConditions) ? _this.implicitConditions.map(function (jsonGcc) { return new gridConfigCondition_1.default(_this, jsonGcc); }) : [];
	        if (!_this.fields)
	            _this.fields = new mobx_1.ObservableMap();
	        return _this;
	    }
	    GridLocation.prototype.fromJson = function (json) {
	        _super.prototype.fromJson.call(this, json, "fields");
	        return this;
	    };
	    GridLocation.prototype.getEntityRef = function () {
	        return this.$entityRef;
	    };
	    GridLocation.prototype.replaceGridConfig = function (newGridConfig) {
	        for (var i = 0; i < this.gridConfigs.length; i++) {
	            if (this.gridConfigs[i].gridId === newGridConfig.gridId) {
	                this.gridConfigs[i] = newGridConfig;
	                break;
	            }
	        }
	    };
	    GridLocation.prototype.getActiveGridConfig = function () {
	        var agc = first(this.gridConfigs.filter(function (gc) { return gc.defaultGrid; }));
	        if (!agc)
	            agc = first(this.gridConfigs);
	        return agc;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(GridLocationField)
	    ], GridLocation.prototype, "fields", void 0);
	    GridLocation = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], GridLocation);
	    return GridLocation;
	}(DomainAncestor_1.DomainAncestor));
	exports.GridLocation = GridLocation;
	var GridRow = /** @class */ (function (_super) {
	    tslib_1.__extends(GridRow, _super);
	    function GridRow(json, grid) {
	        var _this = _super.call(this, json) || this;
	        _this.rowHeight = exports.ROW_HEIGHT;
	        if (_this.rowObject && !(_this.rowObject instanceof DomainAncestor_1.DomainAncestor)) {
	            _this.rowObject = DomainAncestor_1.DomainAncestor.getInstance(grid.$gridLocationRef.entityName, _this.rowObject).initAfterRead(false);
	        }
	        return _this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridRow.prototype, "rowId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridRow.prototype, "rowObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridRow.prototype, "rowHeight", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridRow.prototype, "cells", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridRow.prototype, "aggregateType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridRow.prototype, "expanded", void 0);
	    return GridRow;
	}(DomainAncestor_1.DomainAncestor));
	exports.GridRow = GridRow;
	var GridData = /** @class */ (function () {
	    function GridData(grid, json) {
	        this.requestedPages = new Set();
	        this.grid = grid;
	        this.config = json.config;
	        this.totalCount = (json.totalCount != null) ? json.totalCount : 0;
	        this.pageSize = (json.pageSize != null) ? json.pageSize : constant_1.MAX_INTEGER;
	        this.configDateCreated = json.configDateCreated;
	        this.truncated = json.truncated;
	        if (!this.aggregateRows)
	            this.aggregateRows = [];
	        this.pageMap = new mobx_1.ObservableMap();
	    }
	    GridData.prototype.flatRows = function (sparse) {
	        if (sparse === void 0) { sparse = false; }
	        return this.pageMap.entries().sort(function (_a, _b) {
	            var k1 = _a[0], rs1 = _a[1];
	            var k2 = _b[0], rs2 = _b[1];
	            return (parseInt(k1) - parseInt(k2));
	        }).reduce(function (acc, _a) {
	            var key = _a[0], rows = _a[1];
	            return acc.concat(rows.slice(0));
	        }, []);
	    };
	    GridData.prototype.rowIds = function () {
	        var _this = this;
	        var keyArray = this.pageMap.keys().map(function (str) { return parseInt(str); }).sort();
	        return keyArray.reduce(function (acc, page) { return acc.concat(_this.pageMap.get(page.toString()).map(function (row) { return row.rowId; })); }, []);
	    };
	    GridData.prototype.getRow = function (index) {
	        var rows = this.pageMap.get(index.plane.toString());
	        return (rows) ? rows[index.local] : null;
	    };
	    GridData.prototype.findRow = function (id) {
	        for (var _i = 0, _a = this.pageMap.values(); _i < _a.length; _i++) {
	            var rows = _a[_i];
	            var row = rows.find(function (gridRow) { return gridRow.rowId == id; });
	            if (row)
	                return row;
	        }
	        return null;
	    };
	    GridData.prototype.findRowIndex = function (rowId) {
	        for (var _i = 0, _a = this.pageMap.entries(); _i < _a.length; _i++) {
	            var entry = _a[_i];
	            var local = entry[1].findIndex(function (row) { return row.rowId == rowId; });
	            if (local >= 0) {
	                return { plane: parseInt(entry[0]), local: local };
	            }
	        }
	        return null;
	    };
	    GridData.prototype.isFirstIndex = function (index) {
	        return (index.plane === 1 && index.local === 0);
	    };
	    GridData.prototype.isLastIndex = function (index) {
	        var sum = 0, _pageSize = this.pageSize;
	        for (var i = 1; i < index.plane; i++) {
	            sum += _pageSize;
	            _pageSize *= 2;
	        }
	        sum += index.local;
	        return (sum >= this.totalCount);
	    };
	    GridData.prototype.nextIndex = function (index) {
	        var _pageSize = this.pageSize * Math.pow(2, index.plane - 1);
	        if (index.local < (_pageSize - 1)) {
	            return { plane: index.plane, local: index.local + 1 };
	        }
	        else {
	            var newPlane = index.plane + 1;
	            var rows = this.pageMap.get(newPlane.toString());
	            return (rows) ? { plane: newPlane, local: 0 } : null;
	        }
	    };
	    GridData.prototype.previousIndex = function (index) {
	        if (index.local > 0) {
	            return { plane: index.plane, local: index.local - 1 };
	        }
	        else {
	            var newPlane = index.plane - 1;
	            var rows = this.pageMap.get(newPlane.toString());
	            return (rows) ? { plane: newPlane, local: (this.pageSize * Math.pow(2, newPlane - 1) - 1) } : null;
	        }
	    };
	    // public isLastIndex(index: PageMapIndex) : boolean {
	    //   if (!this.pageMap || !this.pageMap.size) return true;
	    //
	    //   let maxPage: number = Math.max(...this.pageMap.keys().map(str => parseInt(str)));
	    //   return (maxPage === index.plane && index.local === (this.pageMap.get(maxPage.toString()).length - 1) );
	    // }
	    GridData.prototype.initData = function (page, rows, aggregateRows) {
	        var _this = this;
	        if (rows) {
	            this.pageMap.set(page.toString(), mobx_1.observable.array(rows.map(function (rowJson) { return new GridRow(rowJson, _this.grid); })));
	        }
	        if (aggregateRows) {
	            this.mergeAggregates(aggregateRows, rows.length);
	        }
	    };
	    GridData.prototype.rowCount = function () {
	        return this.pageMap.values().reduce(function (acc, rows) { return (acc + rows.length); }, 0);
	    };
	    GridData.prototype.isEmpty = function () {
	        if (this.pageMap.size == 0) {
	            return true;
	        }
	        else {
	            for (var _i = 0, _a = this.pageMap.values(); _i < _a.length; _i++) {
	                var plane = _a[_i];
	                if (plane.length)
	                    return false;
	            }
	            return true;
	        }
	    };
	    GridData.prototype.addRow = function (page, row) {
	        var rowArray = this.pageMap.get(page);
	        if (!rowArray) {
	            rowArray = [];
	            this.pageMap.set(page, rowArray);
	        }
	        rowArray.push(row);
	        console.warn(rowArray);
	        this.totalCount += 1;
	    };
	    GridData.prototype.addFirstRow = function (page, row) {
	        var rowArray = this.pageMap.get(page);
	        if (!rowArray) {
	            rowArray = [];
	            this.pageMap.set(page, rowArray);
	        }
	        rowArray.unshift(row);
	        this.totalCount += 1;
	    };
	    GridData.prototype.deleteRows = function (rows) {
	        for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
	            var row = rows_1[_i];
	            for (var _a = 0, _b = this.pageMap.values(); _a < _b.length; _a++) {
	                var plane = _b[_a];
	                var index = plane.indexOf(row);
	                if (index !== -1) {
	                    plane.splice(index, 1);
	                    break;
	                }
	            }
	        }
	    };
	    GridData.prototype.sliceSparse = function (firstIndex, lastIndex) {
	        var pole = [];
	        var pageSize = this.pageSize * Math.pow(2, firstIndex.plane - 1);
	        for (var page = firstIndex.plane; page <= lastIndex.plane; page++) {
	            var plane = this.pageMap.get(page.toString());
	            var _first = (page === firstIndex.plane) ? firstIndex.local : 0;
	            var _last = (page === lastIndex.plane) ? (lastIndex.local + 1) : pageSize;
	            if (plane) {
	                pole.push.apply(pole, plane.slice(_first, _last));
	            }
	            else {
	                pole.push.apply(pole, new Array(_last - _first));
	            }
	            pageSize *= pageSize;
	        }
	        return pole;
	    };
	    GridData.prototype.mergeAggregates = function (aggregateRows, newRowCount) {
	        if (!this.aggregateRows || !this.aggregateRows.length) {
	            this.aggregateRows = aggregateRows;
	        }
	        else {
	            for (var r = 0; r < this.aggregateRows.length; r++) {
	                var thisAggRow = this.aggregateRows[r];
	                var aggRow = aggregateRows[r];
	                for (var i = 0; i < thisAggRow.cells.length; i++) {
	                    var thisCell = thisAggRow.cells[i];
	                    var newValue = aggRow.cells[i].value;
	                    var thisValue = thisCell.value;
	                    if (newValue) {
	                        switch (thisAggRow.aggregateType) {
	                            case AGGREGATETYPE.SUM:
	                                thisCell.value = thisValue + newValue;
	                                break;
	                            case AGGREGATETYPE.AVG:
	                                var thisRowCount = this.rowCount();
	                                thisCell.value = (thisValue * thisRowCount + newValue * newRowCount) / (thisRowCount + newRowCount);
	                                break;
	                            default:
	                                throw new error_1.Error(thisAggRow.aggregateType + " not supported");
	                        }
	                    }
	                }
	            }
	        }
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridData.prototype, "pageMap", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridData.prototype, "aggregateRows", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridData.prototype, "totalCount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridData.prototype, "truncated", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridData.prototype, "pageSize", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridData.prototype, "start", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridData.prototype, "configDateCreated", void 0);
	    return GridData;
	}());
	exports.GridData = GridData;
	var Grid = /** @class */ (function () {
	    function Grid(gridLocation, masterId) {
	        // searchTerm
	        this.searchTerm = '';
	        this.showSelection = false;
	        this.selectedRowIds = new Set();
	        this.deselectedRowIds = new Set();
	        this.selectedAllRows = false;
	        // string gridLocation
	        this.gridLocation = gridLocation.gridLocation;
	        this.$gridLocationRef = gridLocation;
	        this.$entityRef = gridLocation.$entityRef;
	        // zatim shallow copy
	        this.gridConfigs = gridLocation.gridConfigs.slice();
	        for (var _i = 0, _a = this.gridConfigs; _i < _a.length; _i++) {
	            var gridConfig = _a[_i];
	            if (!gridConfig.gridWidths)
	                gridConfig.gridWidths = gridService_1.default.computeGridWidths(null, gridConfig);
	        }
	        this.masterId = masterId;
	        this.assignActiveGridConfig(this.getActiveGridConfig());
	    }
	    Grid.prototype.assignActiveGridConfig = function (gridConfig) {
	        this.activeGridConfig = gridConfig;
	        if (gridConfig && gridConfig.sortColumns) {
	            this.sortArray = gridConfig.sortColumns.map(function (sc) { return ({ field: sc.field, desc: sc.sortOrder === 'DESC' }); });
	        }
	        this.resetSpecialConditions(gridConfig);
	        this.refreshData = gridConfig && gridConfig.refreshOnData && this.$gridLocationRef.enableRefreshOnData;
	    };
	    Grid.prototype.resetSpecialConditions = function (gridConfig) {
	        this.specialConditions = (gridConfig && gridConfig.specialConditions) ? gridConfig.specialConditions.slice() : [];
	    };
	    Grid.prototype.getGridConfig = function (gridId) {
	        return this.gridConfigs.find(function (gc) { return gc.gridId == gridId; });
	    };
	    Grid.prototype.deleteGridConfig = function (gridId) {
	        remove(this.gridConfigs, function (gc) { return gc.gridId == gridId; });
	    };
	    Grid.prototype.replaceGridConfig = function (gridConfig) {
	        var index = findIndex(this.gridConfigs, function (gc) { return gc.gridId === gridConfig.gridId; });
	        if (index >= 0) {
	            this.gridConfigs.splice(index, 1, gridConfig);
	        }
	        else {
	            this.gridConfigs.push(gridConfig);
	        }
	    };
	    /**
	     * Vrati aktivni gridConfig, pokud je zadany gridId, zkousi hledat ten
	     * @param gridId -nepovinny paramter
	     */
	    Grid.prototype.getActiveGridConfig = function (gridId) {
	        var agc;
	        if (gridId) {
	            agc = this.gridConfigs.find(function (gc) { return gc.gridId == gridId; });
	        }
	        if (!agc) {
	            agc = this.activeGridConfig;
	        }
	        if (!agc) {
	            agc = first(this.gridConfigs.filter(function (gc) { return gc.defaultGrid; }));
	        }
	        if (!agc) {
	            agc = first(this.gridConfigs);
	        }
	        return agc;
	    };
	    Object.defineProperty(Grid.prototype, "activeGridWidths", {
	        get: function () {
	            return (this.gridWidths) ? this.gridWidths : this.activeGridConfig.gridWidths;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Grid.prototype, "sort", {
	        /**
	         * vrati pole stringu [fieldName1_ASC, fieldName2_DESC, ..]
	         */
	        get: function () {
	            return (this.sortArray) ? this.sortArray.map(function (o) { return o.field.fieldName + ((o.desc) ? "_DESC" : "_ASC"); }) : null;
	        },
	        /**
	         * setne sortArray - [ {field: field1Ref, desc: true/false}, ... ]  ze stringu (nebo pole stringu) fieldName1_ASC
	         */
	        set: function (sortValue) {
	            var _this = this;
	            if (sortValue) {
	                if (isString(sortValue)) {
	                    sortValue = [sortValue];
	                }
	                this.sortArray = sortValue.map(function (str) {
	                    var fieldName = str.replace(/(_ASC$)|(_DESC$)/i, "");
	                    return { field: _this.getField(fieldName), desc: (str.endsWith("_DESC")) };
	                });
	            }
	            else {
	                this.sortArray = [];
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Grid.prototype.getField = function (fieldName) {
	        return (this.$entityRef) ? this.$entityRef.getField(fieldName) : this.getActiveGridConfig().columns.find(function (c) { return c.field.fieldName === fieldName; }).field;
	    };
	    /**
	     * vytvori z conditionArray (pole gridConfigCondition) ->  { filter: [fieldName1_EQUAL, fieldName2_IN, ...],  fieldName1: [value11, value12, ...], fieldName2: [value21, value22, ...], .... }
	     */
	    Grid.prototype.getConditionQueryObject = function () {
	        if (isEmpty(this.conditionArray)) {
	            return {};
	        }
	        else {
	            var queryObject = { filter: [] };
	            for (var _i = 0, _a = this.conditionArray; _i < _a.length; _i++) {
	                var gcc = _a[_i];
	                queryObject.filter.push(gcc.columnName + "_" + gcc.operator);
	                queryObject[gcc.columnName] = (gcc.values) ? gcc.values.map(function (v) { return (0, formUtils_1.lovValue)(v); }).filter(function (v, i, a) { return a.indexOf(v) === i; }) : gcc.values;
	            }
	            return queryObject;
	        }
	    };
	    Grid.prototype.getTotalCount = function () {
	        if (typeof this.data === 'undefined') {
	            return 'undefined';
	        }
	        else if (!this.data) {
	            return 'null';
	        }
	        else {
	            return this.data.totalCount;
	        }
	    };
	    /**
	     * setne conditionArray (pole gridConfigCondition) z { filter: [fieldName1_EQUAL, fieldName2_IN, ...],  fieldName1: [value11, value12, ...], fieldName2: [value21, value22, ...], .... }
	     */
	    Grid.prototype.setConditionQueryObject = function (query) {
	        console.log("query", query);
	        if (isEmpty(query.filter)) {
	            this.conditionArray = null;
	        }
	        else {
	            this.conditionArray = [];
	            for (var _i = 0, _a = query.filter; _i < _a.length; _i++) {
	                var oper = _a[_i];
	                var gcc = new gridConfigCondition_1.default(this.$gridLocationRef, null);
	                var _b = (0, stringUtils_1.splitByLastSubstring)(oper), fieldName = _b[0], operator = _b[1];
	                gcc.field = this.getField(fieldName);
	                gcc.operator = operator;
	                gcc.values = query[fieldName];
	                if (gcc.values)
	                    gcc.values = gcc.values.filter(function (v, i, a) { return a.indexOf(v) === i; }); // uniq
	                this.conditionArray.push(gcc);
	            }
	        }
	    };
	    Grid.prototype.addRow = function (rowObject) {
	        if (!this.data) {
	            this.data = new GridData(this, {});
	        }
	        this.data.addRow("1", new GridRow({ rowId: null, cells: [], rowObject: rowObject }, this));
	        this.$dirty = true;
	    };
	    Grid.prototype.addFirstRow = function (rowObject) {
	        if (!this.data) {
	            this.data = new GridData(this, {});
	        }
	        this.data.addFirstRow("1", new GridRow({ rowId: null, cells: [], rowObject: rowObject }, this));
	        this.$dirty = true;
	    };
	    Grid.prototype.addDeletedId = function (rowIds) {
	        var _this = this;
	        if (!this.deletedRowIds)
	            this.deletedRowIds = new Set();
	        if (rowIds != null) {
	            rowIds.forEach(function (rowId) { return _this.deletedRowIds.add(rowId); });
	        }
	    };
	    Grid.prototype.getEditedRows = function () {
	        return this.data.flatRows().filter(function (item) { return item.rowObject.$dirty; }).map(function (item) { return item.rowObject; });
	    };
	    Grid.prototype.isSelectedRows = function () {
	        return this.data && !this.data.isEmpty() && (!this.showSelection || (this.selectedRowIds && this.selectedRowIds.size > 0));
	    };
	    Grid.prototype.getSelectedCount = function () {
	        // pokud jsou zobrazeny select checkboxy a neni selectAllRows -> selectedRowIds size
	        //                                       a je selectAllRows - totalCount - deselectRowIds size
	        //  nejsou select checkboxy ->  totalCount
	        if (this.showSelection) {
	            if (this.selectedAllRows) {
	                return (this.data.totalCount - this.deselectedRowIds.size);
	            }
	            else {
	                return this.selectedRowIds.size;
	            }
	        }
	        else {
	            return this.data.totalCount;
	        }
	    };
	    /**
	     * Pozor, pouze pro nestrankove gridy
	     * @returns {GridRow[]}
	     */
	    Grid.prototype.getSelectedRows = function () {
	        var _this = this;
	        if (!this.data)
	            return [];
	        var rows = this.data.flatRows();
	        return (this.showSelection) ? rows.filter(function (gridRow) { return _this.selectedRowIds.has(gridRow.rowId); }) : rows;
	    };
	    Grid.prototype.findRow = function (id) {
	        return (this.data) ? this.data.findRow(id) : null;
	    };
	    Grid.prototype.search = function (dataObject, refresh, page, keepSelection) {
	        if (refresh === void 0) { refresh = true; }
	        if (page === void 0) { page = 1; }
	        if (keepSelection === void 0) { keepSelection = false; }
	        if (!this.activeGridConfig) {
	            console.debug('GridComp#search(): activeGridConfig not set, ending for grid ' + this.gridLocation);
	            return Promise.resolve(null);
	        }
	        if (!keepSelection) {
	            this.selectedRowIds = new Set();
	            this.deselectedRowIds = new Set();
	            this.selectedAllRows = false;
	        }
	        if (this.$gridLocationRef.masterCondition && !this.masterId) {
	            console.debug('GridComp#search(): masterId is not set, ending for grid ' + this.gridLocation);
	            return Promise.resolve(null);
	        }
	        if (refresh)
	            this.loading = true;
	        return gridService_1.default.search(this, refresh, page);
	    };
	    ;
	    Grid.prototype.createParams = function () {
	        var params = Object.assign({
	            searchTerm: (this.searchTerm) ? this.searchTerm.trim() : this.searchTerm,
	            sort: this.sort,
	            masterId: this.masterId
	        }, this.getConditionQueryObject());
	        if (this.specialConditions && this.specialConditions.length) {
	            params.specialConditions = this.specialConditions.map(function (lov) { return lov.value; });
	        }
	        return params;
	    };
	    Grid.prototype.createFullParams = function (anyParams) {
	        // pokud jsou zobrazeny select checkboxy a neni selectAllRows -> selectedRowIds
	        //                                       a je selectAllRows - search & deselectRowIds
	        //  nejsou select checkboxy ->  search
	        if (this.showSelection) {
	            if (this.selectedAllRows) {
	                return Object.assign({}, anyParams, this.createParams(), { allRows: true, rowid: Array.from(this.deselectedRowIds), gridId: this.activeGridConfig.gridId });
	            }
	            else {
	                return Object.assign({}, anyParams, { rowid: Array.from(this.selectedRowIds), gridId: this.activeGridConfig.gridId });
	            }
	        }
	        else {
	            return Object.assign({}, anyParams, this.createParams(), { allRows: true, gridId: this.activeGridConfig.gridId });
	        }
	    };
	    Grid.prototype.updateGridConditions = function (condition, mdField) {
	        if (!this.conditionArray)
	            this.conditionArray = [];
	        var oldConditionIndex = this.conditionArray.findIndex(function (gcc) { return gcc.columnName === mdField.fieldName; });
	        if (condition) {
	            if (oldConditionIndex >= 0) {
	                this.conditionArray.splice(oldConditionIndex, 1, condition);
	            }
	            else {
	                this.conditionArray.push(condition);
	            }
	        }
	        else {
	            if (oldConditionIndex >= 0) {
	                this.conditionArray.splice(oldConditionIndex, 1);
	            }
	        }
	    };
	    Grid.prototype.getSuperFilters = function () {
	        return (!this.conditionArray) ? [] : this.conditionArray.filter(function (gcc) { return gcc.superFilter; });
	    };
	    Grid.prototype.initSuperFilter = function () {
	        var _this = this;
	        console.log("initSuperFilter conditionArray = ", this.conditionArray);
	        if (!this.conditionArray)
	            this.conditionArray = [];
	        this.activeGridConfig.getSuperFilters().forEach(function (gcc) {
	            var oldConditionIndex = _this.conditionArray.findIndex(function (oldGcc) { return oldGcc.columnName === gcc.field.fieldName; });
	            if (oldConditionIndex === -1) {
	                _this.conditionArray.push(gcc.clone());
	            }
	            else {
	                var condition = _this.conditionArray[oldConditionIndex].clone();
	                condition.superFilter = true;
	                _this.conditionArray.splice(oldConditionIndex, 1, condition);
	            }
	        });
	        console.log("initSuperFilter size = " + this.getSuperFilters().length);
	        this.getSuperFilters().forEach(function (gcc) { return gcc.convertToLov(); });
	    };
	    Grid.prototype.getBlockName = function () {
	        return this.gridLocation;
	    };
	    Grid.prototype.isEditable = function () {
	        return this.$gridLocationRef.editable;
	    };
	    Grid.prototype.isClientBlock = function () {
	        return this.clientGrid;
	    };
	    Object.defineProperty(Grid.prototype, "label", {
	        get: function () {
	            return this.$gridLocationRef.label;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Grid.prototype.selectAllRows = function (selected) {
	        this.selectedAllRows = selected;
	        if (selected) {
	            this.selectedRowIds = new Set(this.data.rowIds());
	            this.deselectedRowIds = new Set();
	        }
	        else {
	            this.selectedRowIds = new Set();
	            this.deselectedRowIds = new Set();
	        }
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Grid.prototype, "sortArray", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Grid.prototype, "activeGridConfig", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable.ref
	    ], Grid.prototype, "gridWidths", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Grid.prototype, "searchTerm", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Grid.prototype, "conditionArray", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Grid.prototype, "masterId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Grid.prototype, "loading", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Grid.prototype, "refreshData", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Grid.prototype, "showSelection", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Grid.prototype, "selectedRowIds", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Grid.prototype, "deselectedRowIds", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Grid.prototype, "selectedAllRows", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Grid.prototype, "lastClickedRow", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Grid.prototype, "deletedRowIds", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Grid.prototype, "errors", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Grid.prototype, "specialConditions", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Grid.prototype, "data", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Grid.prototype, "$dirty", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Grid.prototype, "expandAllRows", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], Grid.prototype, "assignActiveGridConfig", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], Grid.prototype, "deleteGridConfig", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], Grid.prototype, "replaceGridConfig", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], Grid.prototype, "setConditionQueryObject", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], Grid.prototype, "addRow", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], Grid.prototype, "addFirstRow", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], Grid.prototype, "addDeletedId", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], Grid.prototype, "search", null);
	    return Grid;
	}());
	exports.default = Grid;
	var ClientGrid = /** @class */ (function (_super) {
	    tslib_1.__extends(ClientGrid, _super);
	    function ClientGrid(gridLocation, clientGridDataPropertyName, masterId, tooltipFnMap, cssFnMap) {
	        var _this = _super.call(this, gridLocation, masterId) || this;
	        _this.clientGrid = true;
	        _this.clientGridDataPropertyName = clientGridDataPropertyName;
	        _this.tooltipFnMap = tooltipFnMap;
	        _this.cssFnMap = cssFnMap;
	        return _this;
	    }
	    ClientGrid.prototype.generateGridData = function (dataObject) {
	        if (!this.activeGridConfig) {
	            console.debug('ClientGrid#search(): activeGridConfig not set, ending');
	            return;
	        }
	        console.debug("generateGridData dataObject = %O", dataObject);
	        var columns = this.activeGridConfig.columns;
	        var rowObjects = dataObject[this.clientGridDataPropertyName];
	        var rows = [];
	        for (var _i = 0, rowObjects_1 = rowObjects; _i < rowObjects_1.length; _i++) {
	            var rowObject = rowObjects_1[_i];
	            if (!this.clientFilterRow(rowObject) || (this.customFilterFunction && !this.customFilterFunction(dataObject, rowObject)))
	                continue;
	            var cells = [];
	            for (var _a = 0, columns_1 = columns; _a < columns_1.length; _a++) {
	                var column = columns_1[_a];
	                var fieldName = column.field.fieldName;
	                var value = (column.field.valueSourceType) ? (0, formUtils_1.lovLabel)(rowObject[fieldName]) : rowObject[fieldName];
	                var tooltip = (this.tooltipFnMap && this.tooltipFnMap[fieldName]) ? this.tooltipFnMap[fieldName](rowObject) : undefined;
	                var cssClass = (this.cssFnMap && this.cssFnMap[fieldName]) ? this.cssFnMap[fieldName](rowObject) : undefined;
	                var cell = {
	                    value: value,
	                    tooltip: tooltip,
	                    cssClass: cssClass
	                };
	                cells.push(cell);
	            }
	            var row = {
	                rowId: rowObject.id,
	                rowObject: rowObject,
	                cells: cells
	            };
	            rows.push(row);
	        }
	        this.data = new GridData(this, {});
	        this.data.initData(1, rows, null);
	        this.data.totalCount = this.data.rowCount();
	        if (this.activeGridConfig) {
	            this.gridWidths = gridService_1.default.computeGridWidths(this.data, this.activeGridConfig);
	        }
	    };
	    ClientGrid.prototype.clientSort = function () {
	        // sortArray : [{field: MdField, desc: false/true}, ....]
	        var _this = this;
	        if (!this.data || !this.data.pageMap)
	            return;
	        if (this.data.pageMap.size > 1)
	            throw new error_1.Error("ClientSort must run on pageMap size = 1");
	        var rows = this.data.pageMap.get("1");
	        console.log("BEFOR SORT", rows);
	        if (rows && rows.length && this.sortArray && this.sortArray.length) {
	            var lc_1 = locales_1.loc.lang;
	            rows = rows.sort(function (r1, r2) {
	                for (var _i = 0, _a = _this.sortArray; _i < _a.length; _i++) {
	                    var sortSpec = _a[_i];
	                    var value1 = (sortSpec.field.valueSourceType) ? (0, formUtils_1.lovLabel)(r1.rowObject[sortSpec.field.fieldName]) : r1.rowObject[sortSpec.field.fieldName];
	                    var value2 = (sortSpec.field.valueSourceType) ? (0, formUtils_1.lovLabel)(r2.rowObject[sortSpec.field.fieldName]) : r2.rowObject[sortSpec.field.fieldName];
	                    var res = (sortSpec.desc) ? (0, utils_1.compare)(value2, value1, lc_1) : (0, utils_1.compare)(value1, value2, locales_1.loc);
	                    if (res !== 0) {
	                        return res;
	                    }
	                }
	                return 0;
	            });
	            this.data.pageMap.set("1", mobx_1.observable.array(rows));
	        }
	        console.log("AFTER SORT", rows);
	    };
	    ClientGrid.prototype.clientFilterRow = function (rowObject) {
	        var _this = this;
	        var result = true;
	        if (this.searchTerm) {
	            result = this.activeGridConfig.columns.filter(function (gcCol) { return gcCol.field.searchTermType; }).reduce(function (acc, gcCol) {
	                if (acc)
	                    return true;
	                return _this.filterCondition(rowObject, gcCol.field, gcCol.field.searchTermType, [_this.searchTerm]);
	            }, false);
	        }
	        if (result && !isEmpty(this.conditionArray)) {
	            result = this.conditionArray.reduce(function (acc, co) {
	                if (!acc)
	                    return false;
	                return _this.filterCondition(rowObject, co.field, co.operator, co.values);
	            }, true);
	        }
	        console.log("clientFilterRow %O => %s", rowObject, result);
	        return result;
	    };
	    ClientGrid.prototype.filterCondition = function (rowObject, field, operator, params) {
	        var fn = FILTEROPERATOR_MAP[operator];
	        return fn(field, rowObject[field.fieldName], params);
	    };
	    ClientGrid.prototype.search = function (dataObject, refresh) {
	        if (refresh === void 0) { refresh = true; }
	        this.generateGridData(dataObject);
	        this.clientSort();
	        return Promise.resolve(null);
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ClientGrid.prototype, "clientSort", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ClientGrid.prototype, "search", null);
	    return ClientGrid;
	}(Grid));
	exports.ClientGrid = ClientGrid;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var IconButton_1 = tslib_1.__importDefault(__webpack_require__(126));
	var last_1 = tslib_1.__importDefault(__webpack_require__(138));
	var icons_1 = __webpack_require__(63);
	var LinearProgress_1 = tslib_1.__importDefault(__webpack_require__(490));
	var arrow_back_1 = tslib_1.__importDefault(__webpack_require__(1605));
	var LongArrowLeft = __webpack_require__(1822);
	var LongArrowRight = __webpack_require__(1823);
	var LevelUp = __webpack_require__(1821);
	var FaSearch = __webpack_require__(526);
	var history_1 = tslib_1.__importDefault(__webpack_require__(777));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var eventService_1 = tslib_1.__importDefault(__webpack_require__(120));
	var historyBlocks_1 = __webpack_require__(263);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var Toolbar_1 = __webpack_require__(767);
	var mobx_react_1 = __webpack_require__(4);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var colors_1 = __webpack_require__(29);
	//const __iconStyle = {width: 40, height: 40, padding: 8};
	var __iconIconStyle = { width: 18, height: 18 };
	var __iconIconRIFAStyle = { width: 14, height: 14 };
	var __styleOverride = {
	    padding: 0,
	    margin: 0
	};
	var __progressBarStyleOverride = {
	    height: 2,
	    width: "100%",
	    backgroundColor: colors_1.blueGrey50
	};
	var Toolmenu = /** @class */ (function (_super) {
	    tslib_1.__extends(Toolmenu, _super);
	    function Toolmenu() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            openHistoryDrawer: false,
	            loadingHistoryDrawer: false
	        };
	        _this.handleHistory = function (evt) {
	            var _a = _this.props, entityName = _a.entityName, entityId = _a.entityId;
	            console.log('handleHistory %s, id %s', entityName, entityId);
	            if (_this.state.openHistoryDrawer) {
	                _this.setState({
	                    openHistoryDrawer: false
	                });
	            }
	            else {
	                _this.setState({ openHistoryDrawer: true, loadingHistoryDrawer: true });
	                var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['EventHistory', 'HistoryObject', 'HistoryObjectField']);
	                var historyPromise = eventService_1.default.readHistory(entityName, entityId);
	                return Promise.all([metadataPromise, historyPromise])
	                    .then(function (_a) {
	                    var entityMap = _a[0], eventHistories = _a[1];
	                    eventService_1.default.eventHistories = eventHistories;
	                    _this.setState({ loadingHistoryDrawer: false });
	                });
	            }
	        };
	        _this.handleHistoryRequestChange = function (open) {
	            if (!open) {
	                eventService_1.default.eventHistories = null;
	            }
	            _this.setState({ openHistoryDrawer: open });
	        };
	        _this.onSearchTermChange = function (evt) {
	            _this.setState({ searchTerm: evt.target.value || '' });
	        };
	        _this.onSearchTermSubmit = function (evt) {
	            evt.preventDefault();
	            console.log('onSearchTermSubmit: %s', _this.state.searchTerm);
	        };
	        _this.onEnterSearch = function (evt) {
	            console.log('onEnterSearch');
	            return gridService_1.default.fetchGrids(_this.props.chainGridLocation)
	                .then(function (gridLocations) {
	                _this.setState({ searchTermTooltip: gridLocations.get(_this.props.chainGridLocation).getActiveGridConfig().searchLabel });
	            });
	        };
	        return _this;
	    }
	    Toolmenu.prototype.componentDidMount = function () {
	        console.log("Toolmenu componentDidMount , params = %O", this.context.router.getCurrentParams());
	        this.computeChain(this.props);
	    };
	    Toolmenu.prototype.componentWillReceiveProps = function (nextProps) {
	        console.log("Toolmenu componentWillReceiveProps , params = %O", this.context.router.getCurrentParams());
	        this.computeChain(nextProps);
	    };
	    Toolmenu.prototype.computeChain = function (props) {
	        var _this = this;
	        var chainGridLocation = props.chainGridLocation, activeTab = props.activeTab;
	        var chainIconNextProps = null, chainIconPreviousProps = null;
	        var previousPromise, nextPromise;
	        if (chainGridLocation) {
	            var params_1 = this.context.router.getCurrentParams();
	            if (params_1.id) {
	                var grid = gridService_1.default.getGrid(chainGridLocation);
	                if (grid && grid.data) {
	                    var routeName = (0, last_1.default)(this.context.router.getCurrentRoutes()).name;
	                    // hack protoze soucasna integrace router & path nefunguje
	                    var query = Object.assign({}, this.context.router.getCurrentQuery());
	                    if (activeTab)
	                        query.tab = activeTab;
	                    var gridData_1 = grid.data;
	                    var currentIndex_1 = gridData_1.findRowIndex(params_1.id);
	                    if (currentIndex_1) {
	                        if (!gridData_1.isFirstIndex(currentIndex_1)) {
	                            var previousIndex = gridData_1.previousIndex(currentIndex_1);
	                            previousPromise = (previousIndex) ? Promise.resolve(previousIndex) : grid.search(null, false, currentIndex_1.plane - 1)
	                                .then(function () {
	                                return gridData_1.previousIndex(currentIndex_1);
	                            });
	                            previousPromise.then(function (pi) {
	                                var row = gridData_1.getRow(pi);
	                                if (row && row.rowId != null) {
	                                    chainIconPreviousProps = {
	                                        routeName: routeName,
	                                        query: query,
	                                        params: Object.assign({}, params_1, { id: row.rowId }),
	                                    };
	                                }
	                            });
	                        }
	                        if (!gridData_1.isLastIndex(currentIndex_1)) {
	                            var nextIndex = gridData_1.nextIndex(currentIndex_1);
	                            nextPromise = (nextIndex) ? Promise.resolve(nextIndex) : grid.search(null, false, currentIndex_1.plane + 1)
	                                .then(function () {
	                                return gridData_1.nextIndex(currentIndex_1);
	                            });
	                            nextPromise.then(function (pi) {
	                                var row = gridData_1.getRow(pi);
	                                if (row && row.rowId != null) {
	                                    chainIconNextProps = {
	                                        routeName: routeName,
	                                        query: query,
	                                        params: Object.assign({}, params_1, { id: row.rowId }),
	                                    };
	                                }
	                            });
	                        }
	                    }
	                    if (!nextPromise)
	                        nextPromise = Promise.resolve(null);
	                    if (!previousPromise)
	                        previousPromise = Promise.resolve(null);
	                    Promise.all([previousPromise, nextPromise])
	                        .then(function () {
	                        _this.setState({ chainIconPreviousProps: chainIconPreviousProps, chainIconNextProps: chainIconNextProps });
	                    });
	                }
	            }
	        }
	    };
	    Toolmenu.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, children = _a.children, chainGridLocation = _a.chainGridLocation, backAction = _a.backAction, backDisabled = _a.backDisabled, style = _a.style, historize = _a.historize, entityName = _a.entityName, entityId = _a.entityId, activeTab = _a.activeTab, // hack protoze soucasna integrace router & path nefunguje
	        other = tslib_1.__rest(_a, ["children", "chainGridLocation", "backAction", "backDisabled", "style", "historize", "entityName", "entityId", "activeTab"]);
	        var _b = this.state, chainIconPreviousProps = _b.chainIconPreviousProps, chainIconNextProps = _b.chainIconNextProps, searchTermTooltip = _b.searchTermTooltip, openHistoryDrawer = _b.openHistoryDrawer, loadingHistoryDrawer = _b.loadingHistoryDrawer;
	        console.log('%c render toolmenu %s  %s , query = %O', "background-color: #DDDDFF", chainGridLocation, activeTab, this.context.router.getCurrentQuery());
	        style = (!style) ? {} : style;
	        Object.assign(style, { justifyContent: 'space-between' });
	        var lastTA;
	        if (uiService_1.default.transitionArray && uiService_1.default.transitionArray.length) {
	            lastTA = Object.assign({}, (0, last_1.default)(uiService_1.default.transitionArray));
	            lastTA.query = Object.assign({}, lastTA.query, { direction: 'up' });
	        }
	        // prava
	        var arrayChildren = react_1.default.Children.toArray(children).filter(function (child) {
	            return securityService_1.default.hasRouterRight(_this.context.router, child.props.module, child.props.securableType, child.props.securable, child.props.permission, child.props.detailId);
	        });
	        var augmentedChildren = arrayChildren.map(function (child, index) {
	            return react_1.default.cloneElement(child, {
	                key: index,
	                style: Object.assign({}, __styleOverride, child.props.style)
	            });
	        });
	        if (historize) {
	            augmentedChildren.unshift(react_1.default.createElement(icons_1.MdIconButton, { key: -1, onToolbar: true, onClick: this.handleHistory, disabled: !entityId },
	                react_1.default.createElement(history_1.default, null)));
	        }
	        var searchTermTooltipFrag = (searchTermTooltip) ? searchTermTooltip.map(function (text, i) { return (react_1.default.createElement("span", { key: i },
	            text,
	            react_1.default.createElement("br", null))); }) : null;
	        return (react_1.default.createElement("div", { style: { position: 'sticky', top: 40, zIndex: 100, left: 0, right: 0 } },
	            (openHistoryDrawer) ? react_1.default.createElement(historyBlocks_1.EventHistoryDrawer, { eventHistories: eventService_1.default.eventHistories, entities: mdEntityService_1.default.entityMap, open: openHistoryDrawer, loading: loadingHistoryDrawer, onRequestChange: this.handleHistoryRequestChange }) : null,
	            react_1.default.createElement(Toolbar_1.Toolbar, null,
	                react_1.default.createElement(Toolbar_1.ToolbarGroup, { firstChild: true }, augmentedChildren),
	                react_1.default.createElement(Toolbar_1.ToolbarGroup, { lastChild: true },
	                    (chainGridLocation && 1 !== 1) ? (react_1.default.createElement(IconButton_1.default, { onMouseEnter: this.onEnterSearch, onClick: backAction, style: { paddingRight: 0, paddingLeft: 0, width: 25, height: 40 }, iconStyle: __iconIconRIFAStyle, tooltipPosition: "bottom-center", tooltip: searchTermTooltipFrag },
	                        react_1.default.createElement(FaSearch, null))) : null,
	                    (backAction) ? (react_1.default.createElement(IconButton_1.default, { onClick: backAction, style: { paddingRight: 0, paddingLeft: 0, width: 25, height: 40 }, iconStyle: __iconIconStyle, disabled: backDisabled },
	                        react_1.default.createElement(arrow_back_1.default, null))) : null,
	                    react_1.default.createElement(icons_1.ZzIconButtonRoute, tslib_1.__assign({}, lastTA, { style: { paddingLeft: 0, width: 25 }, iconStyle: __iconIconRIFAStyle, disabled: !lastTA }),
	                        react_1.default.createElement(LevelUp, null)),
	                    (chainGridLocation) ? (react_1.default.createElement(icons_1.ZzIconButtonRoute, tslib_1.__assign({ style: { paddingRight: 0, paddingLeft: 0, width: 25 }, iconStyle: __iconIconRIFAStyle, disabled: !chainIconPreviousProps }, chainIconPreviousProps),
	                        react_1.default.createElement(LongArrowLeft, null))) : null,
	                    (chainGridLocation) ? (react_1.default.createElement(icons_1.ZzIconButtonRoute, tslib_1.__assign({ style: { paddingLeft: 0, width: 25 }, iconStyle: __iconIconRIFAStyle, disabled: !chainIconNextProps }, chainIconNextProps),
	                        react_1.default.createElement(LongArrowRight, null))) : null)),
	            (uiService_1.default.getToolbarActionFlag()) ? react_1.default.createElement(LinearProgress_1.default, { mode: "indeterminate", style: __progressBarStyleOverride }) : react_1.default.createElement("div", { style: __progressBarStyleOverride })));
	    };
	    Toolmenu.contextTypes = {
	        muiTheme: prop_types_1.default.object,
	        router: prop_types_1.default.func.isRequired
	    };
	    Toolmenu = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], Toolmenu);
	    return Toolmenu;
	}(react_1.default.Component));
	exports.default = Toolmenu;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.FIELDDEFSIZE = exports.FIELDDEFDISPLAYTYPE = void 0;
	var tslib_1 = __webpack_require__(3);
	var createForm_1 = __webpack_require__(18);
	var mobx_1 = __webpack_require__(5);
	var mdField_1 = __webpack_require__(57);
	var isFunction = __webpack_require__(55);
	var FIELDDEFDISPLAYTYPE;
	(function (FIELDDEFDISPLAYTYPE) {
	    FIELDDEFDISPLAYTYPE["textArea"] = "textArea";
	    FIELDDEFDISPLAYTYPE["checkbox"] = "checkbox";
	    FIELDDEFDISPLAYTYPE["radioButton"] = "radioButton";
	})(FIELDDEFDISPLAYTYPE || (exports.FIELDDEFDISPLAYTYPE = FIELDDEFDISPLAYTYPE = {}));
	var FIELDDEFSIZE;
	(function (FIELDDEFSIZE) {
	    FIELDDEFSIZE["small"] = "small";
	    FIELDDEFSIZE["big"] = "big";
	    FIELDDEFSIZE["huge"] = "huge";
	})(FIELDDEFSIZE || (exports.FIELDDEFSIZE = FIELDDEFSIZE = {}));
	var Form = /** @class */ (function () {
	    function Form(formName, formDefinition) {
	        this.formName = formName;
	        this.formDefinition = formDefinition;
	    }
	    Form.prototype.isFormValid = function () {
	        if (this.fields) {
	            for (var _i = 0, _a = Object.values(this.fields); _i < _a.length; _i++) {
	                var field = _a[_i];
	                if (field.valid === false)
	                    return false;
	            }
	        }
	        return true;
	    };
	    Form.prototype.getField = function (fieldName) {
	        return this.fields[fieldName];
	    };
	    Form.prototype.showAllValidations = function () {
	        for (var _i = 0, _a = Object.values(this.fields); _i < _a.length; _i++) {
	            var field = _a[_i];
	            field.showValidation = true;
	            field.props.errorText = field.errorText;
	        }
	    };
	    Form.prototype.validateForm = function (dataObject, errorArray) {
	        var res = this.isFormValid();
	        if (!res) {
	            this.showAllValidations();
	            if (errorArray)
	                errorArray.push({ message: 'Form has errors, please correct them first' });
	            return false;
	        }
	        else {
	            if (this.onCommit) {
	                this.onCommit(dataObject);
	            }
	            return true;
	        }
	    };
	    ;
	    Form.prototype.getValue = function (dataObject, field) {
	        var fieldObj = (typeof field === 'string' || field instanceof String) ? this.getField(field) : field;
	        return fieldObj.mdField.initMuiInput((fieldObj.getFieldValueFn) ? fieldObj.getFieldValueFn(dataObject) : dataObject[fieldObj.name]);
	        // if (fieldObj.getFieldValueFn) {
	        //   return fieldObj.getFieldValueFn(dataObject);
	        // } else {
	        //   let val = dataObject[fieldObj.name];
	        //   return fieldObj.mdField.initMuiInput(val);
	        // }
	    };
	    Form.prototype.updateAllFieldsPropValue = function (dataObject) {
	        console.debug('_updateFieldsValue on %O', dataObject);
	        if (this.fields && typeof this.fields === 'object') {
	            // nastaveni value
	            for (var _i = 0, _a = Object.values(this.fields); _i < _a.length; _i++) {
	                var field = _a[_i];
	                this.updateFieldPropValue(field, dataObject);
	            }
	        }
	    };
	    Form.prototype.updateFieldsPropValue = function (dataObject) {
	        var fieldNames = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            fieldNames[_i - 1] = arguments[_i];
	        }
	        if (!this.fields)
	            return;
	        for (var _a = 0, fieldNames_1 = fieldNames; _a < fieldNames_1.length; _a++) {
	            var fieldName = fieldNames_1[_a];
	            var field = this.fields[fieldName];
	            if (!field)
	                throw new Error("Field " + fieldName + " not found on form " + this.formName);
	            this.updateFieldPropValue(field, dataObject);
	        }
	    };
	    Form.prototype.updateFieldPropValue = function (field, dataObject) {
	        field.disableValidation = true;
	        if (field.mdField.dataType === mdField_1.DATATYPE.BOOLEAN) {
	            field.props.checked = this.getValue(dataObject, field);
	        }
	        else {
	            field.props.value = this.getValue(dataObject, field);
	        }
	    };
	    Form.prototype.setValue = function (entity, dataObject, field, value) {
	        field.disableValidation = false;
	        if (field.setFieldValueFn) {
	            field.setFieldValueFn(dataObject, value, entity);
	        }
	        else {
	            dataObject[field.name] = (value === '') ? null : value;
	        }
	    };
	    Form.prototype.initForm = function (entity, entities, dataObject, rootObject, extractFieldFn) {
	        this.fields = this.setupFields(dataObject, rootObject, entity, entities, extractFieldFn);
	        this.onCommit = this.formDefinition.onCommit;
	        this.nestedForms = this.formDefinition.nestedForms;
	        this.nested = this.formDefinition.nested;
	        if (this.$open == null && !this.formDefinition.closedOnNew)
	            this.$open = dataObject.$new;
	        if (this.$open && !this.$pristineObject)
	            this.$pristineObject = dataObject.cloneShallow();
	    };
	    Form.prototype.createField = function (fieldDef, dataObject, rootObject, entity, entities, extractFieldFn) {
	        var _this = this;
	        //console.debug('createForm: field: %o on entity %o', field, entity);
	        var resolvedEntity = (fieldDef.entityName) ? entities.get(fieldDef.entityName) : entity;
	        var mdFieldName = (fieldDef.fieldName) ? fieldDef.fieldName : fieldDef.name;
	        var mdField = (extractFieldFn) ? extractFieldFn(dataObject, fieldDef) : ((resolvedEntity) ? resolvedEntity.getField(mdFieldName) : null);
	        if (!mdField)
	            mdField = fieldDef.mdField;
	        if (!mdField)
	            throw new Error("MdField " + mdFieldName + " not found on form " + this.formDefinition.formName + " on entity " + (resolvedEntity ? resolvedEntity.id : 'null') + ", neither on (client) fields definition");
	        var fieldDefGroup = (fieldDef.size) ? createForm_1.fieldStyles[fieldDef.size] : createForm_1.fieldStyles.small;
	        var isTextField = false;
	        // TextField style overrides (zmenseni)
	        var styleDef = fieldDefGroup.default;
	        if (fieldDef.displayType === FIELDDEFDISPLAYTYPE.textArea) {
	            styleDef = fieldDefGroup.textArea;
	        }
	        else if (fieldDef.displayType === FIELDDEFDISPLAYTYPE.checkbox) {
	            styleDef = fieldDefGroup.checkbox;
	        }
	        else if (fieldDef.displayType === FIELDDEFDISPLAYTYPE.radioButton) {
	            styleDef = fieldDefGroup.radioButton;
	        }
	        else if (mdField.valueSourceType) {
	            styleDef = fieldDefGroup.styledSelect;
	        }
	        else {
	            // zatim zbytek textField
	            styleDef = fieldDefGroup.textField;
	            isTextField = true;
	        }
	        var rawValidations = (isFunction(fieldDef.validators)) ? fieldDef.validators(mdField) : fieldDef.validators;
	        var validations = (rawValidations) ? rawValidations.map(function (v) { return (typeof v === 'string') ? { validation: v } : v; }) : null;
	        if (mdField.validations && mdField.validations.length) {
	            validations = (validations && validations.length) ? validations.concat(mdField.validations.slice()) : mdField.validations.slice();
	        }
	        var fieldObject = {
	            name: fieldDef.name,
	            setFieldValueFn: fieldDef.setFieldValueFn,
	            getFieldValueFn: fieldDef.getFieldValueFn,
	            textLabel: fieldDef.label || mdField.formLabelActive,
	            mdField: mdField,
	            validators: validations,
	            showValidation: false,
	            valid: true,
	            errorText: null
	        };
	        var propsObject = {
	            mdField: mdField,
	            fullWidth: true,
	            name: fieldDef.name,
	            style: Object.assign({}, styleDef.style, fieldDef.style),
	            hintStyle: styleDef.hintStyle,
	            inputStyle: styleDef.inputStyle,
	            errorStyle: styleDef.errorStyle,
	            numberFormat: (fieldDef.numberFormat) ? fieldDef.numberFormat : mdField.numberFormat,
	            errorText: null,
	            validating: false,
	            options: null
	        };
	        if (fieldDef.displayType === FIELDDEFDISPLAYTYPE.checkbox || fieldDef.displayType === FIELDDEFDISPLAYTYPE.radioButton) {
	            propsObject.labelStyle = styleDef.labelStyle;
	        }
	        if (isTextField) {
	            propsObject.autoComplete = fieldDef.name;
	        }
	        fieldObject.props = propsObject;
	        // tucne a hvezdicka pro povinne
	        var editLabel = fieldDef.label || mdField.formLabelActive;
	        var floatingLabelStyle = Object.assign({}, styleDef.floatingLabelStyle);
	        if (fieldObject.validators && fieldDef.size !== FIELDDEFSIZE.huge && fieldObject.validators.find(function (v) { return v.validation === 'IsRequired'; })) {
	            editLabel = editLabel + " *";
	        }
	        if (!fieldDef.usePlaceholder)
	            propsObject.floatingLabelStyle = floatingLabelStyle;
	        var cbName = this.formDefinition.formName + "." + fieldObject.name;
	        switch (mdField.dataType) {
	            case mdField_1.DATATYPE.BOOLEAN:
	                propsObject.label = editLabel;
	                propsObject.checked = null;
	                propsObject.value = null; // potrebuju sledovat porad, viz MultiUpdateFieldForm
	                break;
	            default:
	                propsObject.value = null;
	                if (fieldDef.usePlaceholder) {
	                    propsObject.hintText = editLabel;
	                }
	                else {
	                    propsObject.floatingLabelText = editLabel;
	                }
	        }
	        if (mdField.maxLength != null) {
	            propsObject.maxLength = mdField.maxLength;
	        }
	        if (mdField.hasLocalValueSource()) {
	            var valueSourceEntity = entities.get(mdField.valueSource);
	            if (valueSourceEntity && valueSourceEntity.lovItems) {
	                propsObject.options = mobx_1.observable.shallowArray(valueSourceEntity.lovItems.slice());
	                if (fieldDef.displayType !== FIELDDEFDISPLAYTYPE.radioButton && !fieldDef.omitNullOption)
	                    propsObject.options.unshift({ value: null, label: '---' });
	                propsObject.searchable = (valueSourceEntity.lovItems.length > 4);
	            }
	            propsObject.clearable = false;
	        }
	        fieldObject = (0, mobx_1.observable)(fieldObject);
	        // event handlery, ktere uzaviraji fieldObject do closure az po klonu observable
	        switch (mdField.dataType) {
	            case mdField_1.DATATYPE.BOOLEAN:
	                fieldObject.props.onCheck = (0, mobx_1.action)(cbName + " onCheck()", function (evt) {
	                    //let {dataObject, rootObject} = this.props;
	                    var value = evt.target.checked;
	                    // kvuli mobx3 - kdyz dela object observable tak ho klonuje, takze fieldObject a propsObject closure ma jinej, starej objekt
	                    //let fieldObject2: FieldObjectType = dataObject.getFormField(this.formDefinition.formName, fieldDef.name as any);
	                    _this.setValue(entity, dataObject, fieldObject, value);
	                    fieldObject.props.checked = value;
	                    rootObject.$dirty = true;
	                    dataObject.$dirty = true;
	                    //setDataAction(rootObject, 'createForm field ' + fieldDef.name + ' onCheck()');
	                    console.debug('createForm field ' + fieldDef.name + ' onCheck(): value = %O, on object %O, props = %O', value, dataObject, fieldObject.props);
	                });
	                break;
	            default:
	                fieldObject.props.onChange = (0, mobx_1.action)(cbName + " onChange()", function (evt) {
	                    //let {dataObject, rootObject} = this.props;
	                    var value = (evt != null && evt.target) ? evt.target.value : evt;
	                    // kvuli mobx3 - kdyz dela object observable tak ho klonuje, takze fieldObject a propsObject closure ma jinej, starej objekt
	                    //let fieldObject2: FieldObjectType = dataObject.getFormField(this.formDefinition.formName, fieldDef.name as any);
	                    _this.setValue(entity, dataObject, fieldObject, value);
	                    fieldObject.props.value = value;
	                    rootObject.$dirty = true;
	                    dataObject.$dirty = true;
	                    console.debug('createForm field ' + fieldDef.name + ' onChange(): value = %O, on object %O, props = %O', value, dataObject, fieldObject.props);
	                });
	        }
	        propsObject.onBlur = function (evt) {
	            // kvuli mobx3 - kdyz dela object observable tak ho klonuje, takze fieldObject a propsObject closure ma jinej, starej objekt
	            //let fieldObject2: FieldObjectType = dataObject.getFormField(this.formDefinition.formName, fieldDef.name as any);
	            fieldObject.showValidation = true;
	            //this.props.setDataAction(this.props.rootObject, 'createForm field ' + fieldObject.name + ' onBlur()');
	        };
	        fieldObject.handleValidation = function (_a, caller) {
	            // kvuli mobx3 - kdyz dela object observable tak ho klonuje, takze fieldObject a propsObject closure ma jinej, starej objekt
	            //let fieldObject2: FieldObjectType = dataObject.getFormField(this.formDefinition.formName, fieldDef.name as any);
	            var validationResult = _a.validationResult, showValidation = _a.showValidation;
	            //console.log("%c handleValidation (%s) : field = %s, validationResult = %O, showValidation = %s", 'background-color: lightblue', caller, fieldObject.name, validationResult, showValidation);
	            fieldObject.showValidation = showValidation;
	            fieldObject.valid = validationResult.valid;
	            fieldObject.errorText = validationResult.error;
	            fieldObject.props.errorText = (showValidation) ? fieldObject.errorText : null;
	            if (validationResult.valid && validationResult.error) {
	                if (fieldObject.props.errorStyle) {
	                    fieldObject.props.errorStyle = tslib_1.__assign(tslib_1.__assign({}, fieldObject.props.errorStyle), { color: 'orange' });
	                }
	                else {
	                    fieldObject.props.errorStyle = { color: 'orange' };
	                }
	            }
	            fieldObject.props.validating = false;
	        };
	        return fieldObject;
	    };
	    Form.prototype.setupFields = function (dataObject, rootObject, entity, entities, extractFieldFn) {
	        var _this = this;
	        console.log('setupFields for ' + this.formDefinition.formName);
	        var fields = this.formDefinition.fields.reduce(function (acc, fieldDef) {
	            acc[fieldDef.name] = _this.createField(fieldDef, dataObject, rootObject, entity, entities, extractFieldFn);
	            return acc;
	        }, {});
	        return fields;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Form.prototype, "fields", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Form.prototype, "$open", void 0);
	    return Form;
	}());
	exports.default = Form;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(149);
	var core = __webpack_require__(231);
	var hide = __webpack_require__(429);
	var redefine = __webpack_require__(623);
	var ctx = __webpack_require__(427);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var SvgEdit = __webpack_require__(379);
	var SvgDelete = __webpack_require__(249);
	var SvgDone = __webpack_require__(298);
	var SvgClear = __webpack_require__(248);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	__webpack_require__(665);
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	// dataObject,
	//   openContent,
	//   closedContent,
	//   onDelete,
	//   formName,
	//   closedStyle,
	//   validate, rootObject, entity, entities, setDataAction, index, containerObject,
	var OpenButtonLineDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: flex-end;\n"], ["\n  display: flex;\n  align-items: flex-end;\n"])));
	var ActiveItem = /** @class */ (function (_super) {
	    tslib_1.__extends(ActiveItem, _super);
	    function ActiveItem() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onClick = function (evt) {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, formName = _a.formName;
	            var form = dataObject.getForm(formName);
	            if (!form.$open) {
	                form.$open = true;
	                form.$pristineObject = dataObject.cloneShallow();
	                //rootObject.$dirty = true;
	                console.log('onClick form.$pristineObject %O,  dataObject %O', form.$pristineObject, dataObject);
	            }
	        };
	        _this.onCommit = function (evt) {
	            evt.stopPropagation();
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, validate = _a.validate, formName = _a.formName;
	            var res = validate(dataObject);
	            if (!res)
	                return;
	            var form = dataObject.getForm(formName);
	            form.$open = false;
	            dataObject.$added = undefined;
	            form.$pristineObject = undefined;
	            console.log('onCommit %O', dataObject);
	        };
	        _this.onRollback = function (evt) {
	            evt.stopPropagation();
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, formName = _a.formName;
	            var form = dataObject.getForm(formName);
	            form.$open = false;
	            if (dataObject.$added) {
	                _this.props.onDelete(evt);
	            }
	            else {
	                dataObject.shallowOwnCopyProperties(form.$pristineObject);
	                form.updateAllFieldsPropValue(dataObject);
	            }
	            console.log('onRollback form.$pristineObject %O, dataObject %O', form.$pristineObject, dataObject);
	            form.$pristineObject = undefined;
	        };
	        _this.onDelete = function (evt) {
	            var _a = _this.props, onDelete = _a.onDelete, rootObject = _a.rootObject;
	            rootObject.$dirty = true;
	            onDelete(evt);
	        };
	        return _this;
	    }
	    ActiveItem.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, openContent = _a.openContent, closedContent = _a.closedContent, onDelete = _a.onDelete, disableEditing = _a.disableEditing, formName = _a.formName, closedStyle = _a.closedStyle, openButtons = _a.openButtons, openClassName = _a.openClassName, validate = _a.validate, rootObject = _a.rootObject, entity = _a.entity, entities = _a.entities, index = _a.index, other = tslib_1.__rest(_a, ["dataObject", "openContent", "closedContent", "onDelete", "disableEditing", "formName", "closedStyle", "openButtons", "openClassName", "validate", "rootObject", "entity", "entities", "index"]);
	        var form = dataObject.getForm(formName);
	        return (form.$open) ? (react_1.default.createElement("div", { className: (openClassName) ? openClassName : "active-item--open" },
	            openContent,
	            react_1.default.createElement(OpenButtonLineDiv, null,
	                react_1.default.createElement(SvgDone, { className: "active-item--check  zz-mr-15", size: 24, onClick: this.onCommit }),
	                react_1.default.createElement(SvgClear, { className: "active-item--check", size: 24, onClick: this.onRollback }),
	                (openButtons) ? openButtons : null))) : (react_1.default.createElement("div", { className: 'active-item--closed', style: closedStyle },
	            closedContent,
	            react_1.default.createElement("div", { className: "active-item--action-group" },
	                !disableEditing && react_1.default.createElement(SvgEdit, { className: "active-item--action", onClick: this.onClick }),
	                (onDelete && !disableEditing) ? (react_1.default.createElement(SvgDelete, { className: "active-item--action zz-ml-5", onClick: this.onDelete })) : null)));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ActiveItem.prototype, "onClick", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ActiveItem.prototype, "onCommit", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ActiveItem.prototype, "onRollback", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ActiveItem.prototype, "onDelete", void 0);
	    ActiveItem = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ActiveItem);
	    return ActiveItem;
	}(react_1.default.Component));
	exports.default = ActiveItem;
	var templateObject_1;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(151),
	    isObject = __webpack_require__(100);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.valid = valid;
	exports.invalid = invalid;
	exports.validWarn = validWarn;
	exports.IsEmail = IsEmail;
	exports.IsMobilePhone = IsMobilePhone;
	exports.IsRequired = IsRequired;
	exports.IsNumber = IsNumber;
	exports.Max = Max;
	exports.Min = Min;
	exports.NumberFormat = NumberFormat;
	exports.HasNumber = HasNumber;
	exports.HasLength = HasLength;
	exports.AreSame = AreSame;
	exports.PrimaryKeyString = PrimaryKeyString;
	exports.ForbiddenNames = ForbiddenNames;
	exports.Pattern = Pattern;
	exports.CountryPhoneFormat = CountryPhoneFormat;
	exports.MinDateOrPrevious = MinDateOrPrevious;
	var tslib_1 = __webpack_require__(3);
	var validator_1 = tslib_1.__importDefault(__webpack_require__(576));
	var mdField_1 = __webpack_require__(57);
	var locales_1 = __webpack_require__(15);
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var constant_1 = __webpack_require__(399);
	function valid() {
	    return { valid: true, reason: null };
	}
	function invalid(reason) {
	    return { valid: false, reason: reason };
	}
	function validWarn(reason) {
	    return { valid: true, reason: reason };
	}
	function IsEmail(_a) {
	    var value = _a.value;
	    return (validator_1.default.isEmail(value)) ?
	        valid() : invalid('Please enter a valid email.');
	}
	function IsMobilePhone(_a) {
	    var value = _a.value;
	    return (validator_1.default.isMobilePhone(value, ['bg-BG', 'cs-CZ', 'de-DE', 'da-DK', 'el-GR', 'en-AU', 'en-CA', 'en-GB', 'en-US', 'es-ES', 'fr-FR', 'hu-HU', 'it-IT', 'lt-LT', 'pl-PL', 'ro-RO', 'ru-RU', 'sl-SI', 'sk-SK', 'sr-RS', 'sv-SE', 'tr-TR', 'uk-UA'], { strictMode: true })) ?
	        valid() : invalid(locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Please enter a valid mobile phone number"], ["Please enter a valid mobile phone number"]))));
	}
	function IsRequired(_a) {
	    var value = _a.value, condition = _a.condition;
	    return ((value != null && value !== '') || condition === false) ?
	        valid() : invalid('This field is required');
	}
	function IsNumber(_a) {
	    var value = _a.value;
	    return (value == null || !isNaN(value)) ?
	        valid() : invalid('Please enter a valid number');
	}
	function Max(_a) {
	    var value = _a.value, max = _a.max;
	    if (!isNaN(value) && /\S/.test(value)) {
	        return (Number(value) <= max) ? valid() : invalid('Maximum value is ' + max);
	    }
	    else {
	        return valid();
	        // TODO: dates
	    }
	}
	Max.parameters = {
	    max: mdField_1.DATATYPE.NUMBER
	};
	function Min(_a) {
	    var value = _a.value, min = _a.min;
	    if (!isNaN(value) && /\S/.test(value)) {
	        return (Number(value) >= min) ? valid() : invalid('Minimum value is ' + min);
	    }
	    else {
	        return valid();
	        // TODO: dates
	    }
	}
	Min.parameters = {
	    min: mdField_1.DATATYPE.NUMBER
	};
	function NumberFormat(_a) {
	    var value = _a.value, precision = _a.precision, scale = _a.scale;
	    return (value == null || new RegExp("^(\\-?\\d{0," + precision + "}\\.\\d{0," + scale + "}|\\-?\\d{0," + precision + "}|\\-?\\.\\d{0," + scale + "})$").test(value)) ?
	        valid() : invalid('Value does not have a correct format');
	}
	NumberFormat.parameters = {
	    precision: mdField_1.DATATYPE.NUMBER,
	    scale: mdField_1.DATATYPE.NUMBER
	};
	function HasNumber(_a) {
	    var value = _a.value;
	    return (value != null && value.match(/.*[0-9]+.*/i) != null) ?
	        valid() : invalid('This field should contain at least one digit.');
	}
	function HasLength(_a) {
	    var value = _a.value, min = _a.min, max = _a.max;
	    if (value == null) {
	        return invalid('Value cannot be null.');
	    }
	    if (min != null && value.length < min) {
	        return invalid("Length should be at least ".concat(min, "."));
	    }
	    if (max != null && value.length > max) {
	        return invalid("Length should be at most ".concat(max, "."));
	    }
	    return valid();
	}
	HasLength.parameters = {
	    max: mdField_1.DATATYPE.NUMBER,
	    min: mdField_1.DATATYPE.NUMBER
	};
	function AreSame(_a) {
	    var value1 = _a.value1, value2 = _a.value2;
	    return value1 === value2 ?
	        valid() : invalid('Values have to match.');
	}
	function PrimaryKeyString(_a) {
	    var value = _a.value;
	    return (!value || new RegExp('^[a-z0-9-]+$', 'i').test(value)) ?
	        valid() : invalid('String can contain only letters and numbers and dash');
	}
	function ForbiddenNames(_a) {
	    var value = _a.value, names = _a.names;
	    return (value && names.includes(value)) ?
	        invalid('Value must not be one of ' + names) : valid();
	}
	function Pattern(_a) {
	    var value = _a.value, pattern = _a.pattern;
	    return (!value || new RegExp(pattern).test(value)) ?
	        valid() : invalid('Value does not have a correct format');
	}
	function CountryPhoneFormat(_a) {
	    var value = _a.value, pattern = _a.pattern;
	    if (!value || new RegExp(pattern).test(value)) {
	        if (new RegExp(constant_1.CZECH_PHONE_CODE_PREFIX).test(value))
	            return (new RegExp(constant_1.CZECH_PHONE_PATTERN).test(value)) ? valid() : invalid('Value does not have a correct format');
	        return valid();
	    }
	    else
	        return invalid('Value does not have a correct format');
	}
	function MinDateOrPrevious(_a) {
	    var value = _a.value, min = _a.min, previous = _a.previous;
	    if (!value)
	        return valid();
	    value = (0, moment_1.default)(value, "YYYY-MM-DD");
	    min.startOf("day");
	    previous.startOf("day");
	    if (value.isSame(previous) || value.diff(min, "days") >= 0) {
	        return valid();
	    }
	    else {
	        return invalid('Min value is ' + min.format("DD.MM.YYYY"));
	    }
	}
	Min.parameters = {
	    pattern: mdField_1.DATATYPE.STRING
	};
	var templateObject_1;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DISPLAYTYPE = exports.FIELDTYPE = exports.TEXTALIGN = exports.DATATYPE = exports.VALUESOURCETYPE = void 0;
	var tslib_1 = __webpack_require__(3);
	var stringUtils_1 = __webpack_require__(174);
	var utils_1 = __webpack_require__(37);
	var numberUtils_1 = __webpack_require__(143);
	var dateUtils_1 = __webpack_require__(49);
	var mobx_1 = __webpack_require__(5);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var VALUESOURCETYPE;
	(function (VALUESOURCETYPE) {
	    VALUESOURCETYPE["LOCAL"] = "LOCAL";
	    VALUESOURCETYPE["ASYNC"] = "ASYNC";
	})(VALUESOURCETYPE || (exports.VALUESOURCETYPE = VALUESOURCETYPE = {}));
	var DATATYPE;
	(function (DATATYPE) {
	    DATATYPE["BOOLEAN"] = "BOOLEAN";
	    DATATYPE["NUMBER"] = "NUMBER";
	    DATATYPE["NUMBERCURRENCY"] = "NUMBERCURRENCY";
	    DATATYPE["STRING"] = "STRING";
	    DATATYPE["DATE"] = "DATE";
	    DATATYPE["TIME"] = "TIME";
	    DATATYPE["DATETIME"] = "DATETIME";
	    DATATYPE["PERIOD"] = "PERIOD";
	    DATATYPE["DURATION"] = "DURATION";
	})(DATATYPE || (exports.DATATYPE = DATATYPE = {}));
	var TEXTALIGN;
	(function (TEXTALIGN) {
	    TEXTALIGN["left"] = "left";
	    TEXTALIGN["right"] = "right";
	    TEXTALIGN["center"] = "center";
	})(TEXTALIGN || (exports.TEXTALIGN = TEXTALIGN = {}));
	var FIELDTYPE;
	(function (FIELDTYPE) {
	    FIELDTYPE["STANDARD"] = "STANDARD";
	    FIELDTYPE["UNMANAGED"] = "UNMANAGED";
	    FIELDTYPE["VIRTUAL"] = "VIRTUAL";
	    FIELDTYPE["URL"] = "URL";
	    FIELDTYPE["FUNCTION"] = "FUNCTION";
	    FIELDTYPE["SQLRESULT"] = "SQLRESULT";
	    FIELDTYPE["DYNAMIC"] = "DYNAMIC";
	})(FIELDTYPE || (exports.FIELDTYPE = FIELDTYPE = {}));
	var DISPLAYTYPE;
	(function (DISPLAYTYPE) {
	    DISPLAYTYPE["BUTTON"] = "BUTTON";
	    DISPLAYTYPE["ICON"] = "ICON";
	    DISPLAYTYPE["CHECKBOX"] = "CHECKBOX";
	})(DISPLAYTYPE || (exports.DISPLAYTYPE = DISPLAYTYPE = {}));
	var MdField = /** @class */ (function () {
	    function MdField(json, mdEntity) {
	        this.fromJson(json);
	        this.$entityRef = mdEntity;
	    }
	    MdField.prototype.fromJson = function (json) {
	        for (var key in json) {
	            if (json.hasOwnProperty(key)) {
	                this[key] = json[key];
	            }
	        }
	        this.fieldKey = (0, utils_1.formatId)(this.entityName, this.fieldName);
	    };
	    Object.defineProperty(MdField.prototype, "gridHeaderLabelActive", {
	        get: function () {
	            return (this.gridHeaderLabel != null) ? this.gridHeaderLabel : this.label;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(MdField.prototype, "gridHeaderTooltipActive", {
	        get: function () {
	            return (this.gridHeaderTooltip != null) ? this.gridHeaderTooltip : this.tooltip;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(MdField.prototype, "formLabelActive", {
	        get: function () {
	            return (this.formLabel != null) ? this.formLabel : this.label;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    MdField.prototype.formatValue = function (value) {
	        if (value != null && typeof value.label !== 'undefined') {
	            return value.label;
	        }
	        else {
	            switch (this.dataType) {
	                case DATATYPE.DATE:
	                    return (0, dateUtils_1.formatDate)(value);
	                case DATATYPE.DATETIME:
	                    return (0, dateUtils_1.formatDateTime)(value);
	                case DATATYPE.NUMBER:
	                    return (0, numberUtils_1.formatNumber)(value, this.numberFormat);
	                case DATATYPE.NUMBERCURRENCY:
	                    return (value) ? (0, numberUtils_1.formatNumber)(value.price, this.numberFormat) + ((value.currency) ? ' ' + value.currency : '') : value;
	                case DATATYPE.BOOLEAN:
	                    return value == null ? '' : (value + '');
	                case DATATYPE.PERIOD:
	                    return (0, dateUtils_1.formatPeriod)(value);
	                case DATATYPE.DURATION:
	                    return (0, dateUtils_1.formatPeriod)(value, true);
	                default:
	                    return (value) ? value.toString() : null;
	            }
	        }
	    };
	    MdField.prototype.hasLocalValueSource = function () {
	        return (this.valueSource && this.valueSourceType === VALUESOURCETYPE.LOCAL);
	    };
	    MdField.prototype.functionNameGetter = function () {
	        return 'get' + (0, stringUtils_1.capitalizeFirstLetter)(this.functionName);
	    };
	    MdField.prototype.functionNameSetter = function () {
	        return 'set' + (0, stringUtils_1.capitalizeFirstLetter)(this.functionName);
	    };
	    MdField.prototype.initMuiInput = function (val) {
	        return (this.valueSourceType || this.dataType === DATATYPE.DATE || this.dataType === DATATYPE.DATETIME) ? val
	            : ((val == null) ? ((this.dataType === DATATYPE.BOOLEAN) ? false : '') : val);
	    };
	    MdField.prototype.computeDefaultValue = function () {
	        if (this.defaultValue) {
	            var _value_1 = (this.defaultValue.startsWith('#')) ? eval(this.defaultValue.substring(1)) : this.defaultValue;
	            // musime z toho udelat lovItem
	            if (this.hasLocalValueSource()) {
	                var valueSourceEntity = mdEntityService_1.default.getEntity(this.valueSource);
	                if (valueSourceEntity) {
	                    _value_1 = valueSourceEntity.lovItems.find(function (lov) { return lov.value.toString() === _value_1; }); // pozor defaultValue je String
	                }
	            }
	            return _value_1;
	        }
	        else {
	            return undefined;
	        }
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdField.prototype, "searchTermType", void 0);
	    return MdField;
	}());
	exports.default = MdField;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IconBase = function IconBase(_ref, _ref2) {
	  var children = _ref.children;
	  var color = _ref.color;
	  var size = _ref.size;
	  var style = _ref.style;
	  var width = _ref.width;
	  var height = _ref.height;
	
	  var props = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style', 'width', 'height']);
	
	  var _ref2$reactIconBase = _ref2.reactIconBase;
	  var reactIconBase = _ref2$reactIconBase === undefined ? {} : _ref2$reactIconBase;
	
	  var computedSize = size || reactIconBase.size || '1em';
	  return _react2.default.createElement('svg', _extends({
	    children: children,
	    fill: 'currentColor',
	    preserveAspectRatio: 'xMidYMid meet',
	    height: height || computedSize,
	    width: width || computedSize
	  }, reactIconBase, props, {
	    style: _extends({
	      verticalAlign: 'middle',
	      color: color || reactIconBase.color
	    }, reactIconBase.style || {}, style)
	  }));
	};
	
	IconBase.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  style: _propTypes2.default.object
	};
	
	IconBase.contextTypes = {
	  reactIconBase: _propTypes2.default.shape(IconBase.propTypes)
	};
	
	exports.default = IconBase;
	module.exports = exports['default'];

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.uploadAxios = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var axios_1 = tslib_1.__importDefault(__webpack_require__(314));
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var jsonUtils_1 = __webpack_require__(193);
	var utils_1 = __webpack_require__(37);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var locales_1 = __webpack_require__(15);
	var ssTenantId = sessionStorage.getItem('tenantId');
	if (!isNaN(ssTenantId))
	    window.TENANT_ID = ssTenantId;
	if (!window.TENANT_ID) {
	    var parTenantId = (0, utils_1.getParam)('t');
	    if (parTenantId)
	        parTenantId = parTenantId.trim();
	    if (!isNaN(parTenantId))
	        window.TENANT_ID = parTenantId;
	    if (window.TENANT_ID) {
	        sessionStorage.setItem('tenantId', window.TENANT_ID);
	    }
	}
	console.debug('axios init, tenant = ' + window.TENANT_ID);
	var ZAUZOO_EXCEPTION_MARKER = 'ZAUZOO_EXCEPTION_MARKER';
	var mdAxios = axios_1.default.create({
	    baseURL: '/api',
	    headers: {
	        'X-Requested-With': 'XMLHttpRequest',
	        'Content-Type': 'application/json; charset=UTF-8',
	        'Accept': 'application/json',
	        'Accept-Language': locales_1.loc.lang
	    },
	    transformRequest: [jsonUtils_1.stringify]
	});
	mdAxios.interceptors.request.use(onRequestFullFilled, onRequestRejected);
	mdAxios.interceptors.response.use(onResponseFullFilled, onResponseRejected);
	exports.default = mdAxios;
	var uploadAxios = axios_1.default.create({
	    baseURL: '/api',
	    headers: {
	        'X-Requested-With': 'XMLHttpRequest',
	        'Content-Type': 'multipart/form-data',
	        'Accept-Language': locales_1.loc.lang
	    }
	});
	exports.uploadAxios = uploadAxios;
	uploadAxios.interceptors.request.use(onRequestFullFilled, onRequestRejected);
	uploadAxios.interceptors.response.use(onResponseFullFilled, onResponseRejected);
	function onRequestFullFilled(config) {
	    var tenantId = window.TENANT_ID;
	    //console.log('intercepting request %O, tenantId = ' + tenantId, config);
	    if (tenantId && config.headers['X-Tenant'] == null) {
	        config.headers['X-Tenant'] = tenantId;
	    }
	    return config;
	}
	function onRequestRejected(error) {
	    // Do something with request error
	    return Promise.reject(error);
	}
	function onResponseFullFilled(response) {
	    // pokud response.data jsou string a konci na specialni text, tak doslo na serveru k vyjimce pri json serializaci kdyz uz byla odpoved streamovana na klienta a tudiz nelze zmenit status 200
	    // takze jsem pouze pridal ZAUZOO_EXCEPTION_MARKER a podle toho to poznam
	    if (typeof response.data === 'string' && response.data.endsWith(ZAUZOO_EXCEPTION_MARKER)) {
	        commonService_1.default.loading(false);
	        if (commonService_1.default.notificationSystem) {
	            doNotify(response);
	        }
	        else {
	            window.location.replace("/login");
	        }
	    }
	    return response;
	}
	function onResponseRejected(error) {
	    // Do something with response error
	    console.log('Error %O', error);
	    commonService_1.default.loading(false);
	    uiService_1.default.hideToolbarActionFlag();
	    var errorResponse = error.response;
	    if (errorResponse.status == 401) {
	        var _r = commonService_1.default.router;
	        if (_r) {
	            commonService_1.default.redirectAfterLogin = _r.getCurrentPath();
	            _r.transitionTo('loginPage');
	        }
	    }
	    else if (errorResponse.status != 503) {
	        if (commonService_1.default.notificationSystem) {
	            if ((errorResponse.status !== 400 || !error.config.showPrettyError)) {
	                doNotify(errorResponse);
	            }
	        }
	        else {
	            var _r = commonService_1.default.router;
	            if (_r) {
	                _r.transitionTo('home');
	            }
	            else {
	                window.location.replace("/");
	            }
	        }
	    }
	    error.getMessages = function () {
	        return (error.response && error.response.data) ? error.response.data.messages : undefined;
	    };
	    error.getMessagesString = function () {
	        return (error.response && error.response.data && error.response.data.messages && error.response.data.messages.length) ? error.response.data.messages.map(function (m) { return m.message; }).join(", ") : undefined;
	    };
	    return Promise.reject(error);
	}
	function doNotify(error) {
	    if (!commonService_1.default.notificationSystem)
	        return;
	    var content;
	    if (error.data) {
	        if (typeof error.data === 'string') {
	            var pos = error.data.lastIndexOf(ZAUZOO_EXCEPTION_MARKER);
	            var str = (pos === -1) ? error.data : error.data.substring(0, pos);
	            content = (react_1.default.createElement("p", null, str));
	        }
	        else if (error.data.severity) {
	            content = (react_1.default.createElement("ul", null, error.data.messages.map(function (err, index) { return (react_1.default.createElement("li", { key: index },
	                " ",
	                ((err.propertyPath) ? (err.propertyPath + ' ') : '') + err.message + ((err.rootBeanClass) ? " ( on " + err.rootBeanClass + ')' : ''),
	                " ")); })));
	        }
	        else {
	            content = (react_1.default.createElement("div", null,
	                react_1.default.createElement("p", null, error.data.error),
	                react_1.default.createElement("p", null,
	                    react_1.default.createElement("pre", null,
	                        error.data.exception,
	                        " + ' - ' + ",
	                        error.data.message))));
	        }
	    }
	    else {
	        content = (react_1.default.createElement("p", null, error.statusText));
	    }
	    commonService_1.default.notifyError(null, "Server error " + error.status, content);
	}


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  global.Immutable = factory();
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step > 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    findEntry: function(predicate, context) {
	      var found;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findLastEntry: function(predicate, context) {
	      return this.toSeq().reverse().findEntry(predicate, context);
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  // Temporary warning about using length
	  (function () {
	    try {
	      Object.defineProperty(IterablePrototype, 'length', {
	        get: function () {
	          if (!Iterable.noLengthWarning) {
	            var stack;
	            try {
	              throw new Error();
	            } catch (error) {
	              stack = error.stack;
	            }
	            if (stack.indexOf('_wrapObject') === -1) {
	              console && console.warn && console.warn(
	                'iterable.length has been deprecated, '+
	                'use iterable.size or iterable.count(). '+
	                'This warning will become a silent error in a future version. ' +
	                stack
	              );
	              return this.size;
	            }
	          }
	        }
	      });
	    } catch (e) {}
	  })();
	
	
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toSeq().reverse().findKey(predicate, context);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.findLastKey(function(value ) {return is(value, searchValue)});
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.toKeyedSeq().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	
	      // var index =
	      // return this.toSeq().reverse().indexOf(searchValue);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var key = this.toKeyedSeq().findLastKey(predicate, context);
	      return key === undefined ? -1 : key;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : value;
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(113);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ZzIconButtonMenu = exports.ZzMenuItem = exports.ZzIconButtonRoute = exports.MdIconButton = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var IconButton_1 = tslib_1.__importDefault(__webpack_require__(126));
	var IconMenu_1 = tslib_1.__importDefault(__webpack_require__(357));
	var utils_1 = __webpack_require__(37);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var metaConstant_1 = __webpack_require__(13);
	var MenuItem_1 = tslib_1.__importDefault(__webpack_require__(101));
	var mobx_react_1 = __webpack_require__(4);
	var colors_1 = __webpack_require__(29);
	/* **************************************************************************************
	 *******     MdIconButton     *******************************************************
	 ****************************************************************************************/
	var MdIconButton__styleOnToolbar = { width: 40, height: 40, padding: 8 };
	var MdIconButton_iconStyle = { color: colors_1.grey600 };
	var MdIconButton = function (_a) {
	    var tooltip = _a.tooltip, fontIcon = _a.fontIcon, style = _a.style, iconStyle = _a.iconStyle, onClick = _a.onClick, className = _a.className, disabled = _a.disabled, onToolbar = _a.onToolbar, children = _a.children;
	    return (react_1.default.createElement(IconButton_1.default, { onClick: onClick, tooltip: tooltip, disabled: disabled, className: className, style: (onToolbar && style) ? Object.assign({}, MdIconButton__styleOnToolbar, style) : (onToolbar ? MdIconButton__styleOnToolbar : style), iconStyle: iconStyle ? Object.assign({}, MdIconButton_iconStyle, iconStyle) : MdIconButton_iconStyle }, children));
	};
	exports.MdIconButton = MdIconButton;
	/* **************************************************************************************
	 *******     ZzIconButtonRoute     *******************************************************
	 ****************************************************************************************/
	var ZzIconButtonRoute__style = { width: 40, height: 40, padding: 8 };
	var ZzIconButtonRoute__iconStyle = { width: 18, height: 18, color: colors_1.grey600 };
	var ZzIconButtonRoute__iconStyleBig = { width: 24, height: 24, color: colors_1.grey600 };
	var ZzIconButtonRoute = /** @class */ (function (_super) {
	    tslib_1.__extends(ZzIconButtonRoute, _super);
	    function ZzIconButtonRoute() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onClick = function (event) {
	            event.preventDefault();
	            var _a = _this.props, routeName = _a.routeName, params = _a.params, query = _a.query;
	            _this.context.router.transitionTo(routeName, params, query);
	        };
	        return _this;
	    }
	    ZzIconButtonRoute.prototype.render = function () {
	        var _a = this.props, tooltip = _a.tooltip, routeName = _a.routeName, params = _a.params, query = _a.query, style = _a.style, iconStyle = _a.iconStyle, disabled = _a.disabled, big = _a.big, module = _a.module, securableType = _a.securableType, securable = _a.securable, permission = _a.permission, children = _a.children;
	        if (!securityService_1.default.hasRouterRight(this.context.router, module, securableType, securable, permission)) {
	            return react_1.default.createElement("noscript", null);
	        }
	        var _iconStyle = (big) ? ZzIconButtonRoute__iconStyleBig : ZzIconButtonRoute__iconStyle;
	        return (disabled) ? (react_1.default.createElement(IconButton_1.default, { tooltip: tooltip, disabled: true, style: style ? Object.assign({}, ZzIconButtonRoute__style, style) : ZzIconButtonRoute__style, iconStyle: iconStyle ? Object.assign({}, _iconStyle, iconStyle) : _iconStyle }, children)) : (react_1.default.createElement("a", { href: this.context.router.makeHref(routeName, params, (0, utils_1.addTenantToQuery)(query)), onClick: this.onClick },
	            react_1.default.createElement(IconButton_1.default, { tooltip: tooltip, style: Object.assign({}, ZzIconButtonRoute__style, style), iconStyle: iconStyle ? Object.assign({}, _iconStyle, iconStyle) : _iconStyle }, children)));
	    };
	    ZzIconButtonRoute.contextTypes = {
	        router: prop_types_1.default.func.isRequired
	    };
	    return ZzIconButtonRoute;
	}(react_1.default.Component));
	exports.ZzIconButtonRoute = ZzIconButtonRoute;
	var ZzMenuItem = function (_a) {
	    var securable = _a.securable, permission = _a.permission, other = tslib_1.__rest(_a, ["securable", "permission"]);
	    return (react_1.default.createElement(MenuItem_1.default, tslib_1.__assign({}, other)));
	};
	exports.ZzMenuItem = ZzMenuItem;
	var ZzIconButtonMenu__style = { width: 40, height: 40, padding: 8 };
	var ZzIconButtonMenu__iconStyle = { color: colors_1.grey600 };
	var ZzIconButtonMenu__anchorOrigin = { horizontal: 'left', vertical: 'top' };
	var ZzIconButtonMenu__styleOverride = { fontSize: 14, lineHeight: '40px' };
	var ZzIconButtonMenu = /** @class */ (function (_super) {
	    tslib_1.__extends(ZzIconButtonMenu, _super);
	    function ZzIconButtonMenu() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ZzIconButtonMenu.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, buttonTooltip = _a.buttonTooltip, buttonIcon = _a.buttonIcon, children = _a.children, disabled = _a.disabled, onClick = _a.onClick, style = _a.style, iconButtonStyle = _a.iconButtonStyle, iconStyle = _a.iconStyle, securableType = _a.securableType;
	        var prunedChildren = react_1.default.Children.toArray(children).filter(function (child) {
	            return !securableType || !child || !child.props || !child.props.securable || securityService_1.default.hasRouterRight(_this.context.router, child.props.securable.module, securableType, child.props.securable.name, (child.props.permission) ? child.props.permission : metaConstant_1.PERMISSION.Execute);
	        });
	        return (!prunedChildren.length && !onClick) ? react_1.default.createElement("noscript", null) : (react_1.default.createElement(IconMenu_1.default, { iconButtonElement: react_1.default.createElement(IconButton_1.default, { tooltip: buttonTooltip, disabled: disabled, style: iconButtonStyle ? Object.assign({}, ZzIconButtonMenu__style, iconButtonStyle) : ZzIconButtonMenu__style, iconStyle: iconStyle ? Object.assign({}, ZzIconButtonMenu__iconStyle, iconStyle) : ZzIconButtonMenu__iconStyle }, buttonIcon), style: style, onClick: onClick, useLayerForClickAway: true, anchorOrigin: ZzIconButtonMenu__anchorOrigin, targetOrigin: ZzIconButtonMenu__anchorOrigin }, prunedChildren.map(function (child, index) {
	            var _a = child.props, style = _a.style, securable = _a.securable, permission = _a.permission, other = tslib_1.__rest(_a, ["style", "securable", "permission"]);
	            return react_1.default.cloneElement(child, tslib_1.__assign({ key: index, style: Object.assign({}, ZzIconButtonMenu__styleOverride, child.props.style) }, other));
	        })));
	    };
	    ZzIconButtonMenu.contextTypes = {
	        router: prop_types_1.default.func.isRequired
	    };
	    ZzIconButtonMenu = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ZzIconButtonMenu);
	    return ZzIconButtonMenu;
	}(react_1.default.Component));
	exports.ZzIconButtonMenu = ZzIconButtonMenu;


/***/ }),
/* 64 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.DefaultRoute = __webpack_require__(858);
	exports.Link = __webpack_require__(1859);
	exports.NotFoundRoute = __webpack_require__(859);
	exports.Redirect = __webpack_require__(860);
	exports.Route = __webpack_require__(381);
	exports.ActiveHandler = __webpack_require__(382);
	exports.RouteHandler = exports.ActiveHandler;
	
	exports.HashLocation = __webpack_require__(863);
	exports.HistoryLocation = __webpack_require__(531);
	exports.RefreshLocation = __webpack_require__(864);
	exports.StaticLocation = __webpack_require__(865);
	exports.TestLocation = __webpack_require__(1862);
	
	exports.ImitateBrowserBehavior = __webpack_require__(857);
	exports.ScrollToTopBehavior = __webpack_require__(1857);
	
	exports.History = __webpack_require__(250);
	exports.Navigation = __webpack_require__(1853);
	exports.State = __webpack_require__(1855);
	
	exports.createRoute = __webpack_require__(215).createRoute;
	exports.createDefaultRoute = __webpack_require__(215).createDefaultRoute;
	exports.createNotFoundRoute = __webpack_require__(215).createNotFoundRoute;
	exports.createRedirect = __webpack_require__(215).createRedirect;
	exports.createRoutesFromReactChildren = __webpack_require__(862);
	
	exports.create = __webpack_require__(861);
	exports.run = __webpack_require__(1863);

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLinearRegression = exports.findEntryInArray = exports.interpolateNumber = exports.hasDuplicate = exports.getAnyElementOfObject = exports.getPercentValue = exports.uniqueId = exports.isNumOrStr = exports.isNumber = exports.isPercent = exports.mathSign = void 0;
	
	var _get2 = _interopRequireDefault(__webpack_require__(207));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(62));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(355));
	
	var _isNumber2 = _interopRequireDefault(__webpack_require__(239));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(163));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var mathSign = function mathSign(value) {
	  if (value === 0) {
	    return 0;
	  }
	
	  if (value > 0) {
	    return 1;
	  }
	
	  return -1;
	};
	
	exports.mathSign = mathSign;
	
	var isPercent = function isPercent(value) {
	  return (0, _isString2["default"])(value) && value.indexOf('%') === value.length - 1;
	};
	
	exports.isPercent = isPercent;
	
	var isNumber = function isNumber(value) {
	  return (0, _isNumber2["default"])(value) && !(0, _isNaN2["default"])(value);
	};
	
	exports.isNumber = isNumber;
	
	var isNumOrStr = function isNumOrStr(value) {
	  return isNumber(value) || (0, _isString2["default"])(value);
	};
	
	exports.isNumOrStr = isNumOrStr;
	var idCounter = 0;
	
	var uniqueId = function uniqueId(prefix) {
	  var id = ++idCounter;
	  return "".concat(prefix || '').concat(id);
	};
	/**
	 * Get percent value of a total value
	 * @param {Number|String} percent A percent
	 * @param {Number} totalValue     Total value
	 * @param {NUmber} defaultValue   The value returned when percent is undefined or invalid
	 * @param {Boolean} validate      If set to be true, the result will be validated
	 * @return {Number} value
	 */
	
	
	exports.uniqueId = uniqueId;
	
	var getPercentValue = function getPercentValue(percent, totalValue) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!isNumber(percent) && !(0, _isString2["default"])(percent)) {
	    return defaultValue;
	  }
	
	  var value;
	
	  if (isPercent(percent)) {
	    var index = percent.indexOf('%');
	    value = totalValue * parseFloat(percent.slice(0, index)) / 100;
	  } else {
	    value = +percent;
	  }
	
	  if ((0, _isNaN2["default"])(value)) {
	    value = defaultValue;
	  }
	
	  if (validate && value > totalValue) {
	    value = totalValue;
	  }
	
	  return value;
	};
	
	exports.getPercentValue = getPercentValue;
	
	var getAnyElementOfObject = function getAnyElementOfObject(obj) {
	  if (!obj) {
	    return null;
	  }
	
	  var keys = Object.keys(obj);
	
	  if (keys && keys.length) {
	    return obj[keys[0]];
	  }
	
	  return null;
	};
	
	exports.getAnyElementOfObject = getAnyElementOfObject;
	
	var hasDuplicate = function hasDuplicate(ary) {
	  if (!(0, _isArray2["default"])(ary)) {
	    return false;
	  }
	
	  var len = ary.length;
	  var cache = {};
	
	  for (var i = 0; i < len; i++) {
	    if (!cache[ary[i]]) {
	      cache[ary[i]] = true;
	    } else {
	      return true;
	    }
	  }
	
	  return false;
	};
	
	exports.hasDuplicate = hasDuplicate;
	
	var interpolateNumber = function interpolateNumber(numberA, numberB) {
	  if (isNumber(numberA) && isNumber(numberB)) {
	    return function (t) {
	      return numberA + t * (numberB - numberA);
	    };
	  }
	
	  return function () {
	    return numberB;
	  };
	};
	
	exports.interpolateNumber = interpolateNumber;
	
	var findEntryInArray = function findEntryInArray(ary, specifiedKey, specifiedValue) {
	  if (!ary || !ary.length) {
	    return null;
	  }
	
	  return ary.find(function (entry) {
	    return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, _get2["default"])(entry, specifiedKey)) === specifiedValue;
	  });
	};
	/**
	 * The least square linear regression
	 * @param {Array} data The array of points
	 * @returns {Object} The domain of x, and the parameter of linear function
	 */
	
	
	exports.findEntryInArray = findEntryInArray;
	
	var getLinearRegression = function getLinearRegression(data) {
	  if (!data || !data.length) {
	    return null;
	  }
	
	  var len = data.length;
	  var xsum = 0;
	  var ysum = 0;
	  var xysum = 0;
	  var xxsum = 0;
	  var xmin = Infinity;
	  var xmax = -Infinity;
	
	  for (var i = 0; i < len; i++) {
	    xsum += data[i].cx;
	    ysum += data[i].cy;
	    xysum += data[i].cx * data[i].cy;
	    xxsum += data[i].cx * data[i].cx;
	    xmin = Math.min(xmin, data[i].cx);
	    xmax = Math.max(xmax, data[i].cx);
	  }
	
	  var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
	  return {
	    xmin: xmin,
	    xmax: xmax,
	    a: a,
	    b: (ysum - a * xsum) / len
	  };
	};
	
	exports.getLinearRegression = getLinearRegression;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.StyleSheetManager = exports.ServerStyleSheet = exports.withTheme = exports.ThemeProvider = exports.injectGlobal = exports.keyframes = exports.css = undefined;
	
	var _flatten = __webpack_require__(925);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	var _stringifyRules = __webpack_require__(2030);
	
	var _stringifyRules2 = _interopRequireDefault(_stringifyRules);
	
	var _generateAlphabeticName = __webpack_require__(2025);
	
	var _generateAlphabeticName2 = _interopRequireDefault(_generateAlphabeticName);
	
	var _css = __webpack_require__(2013);
	
	var _css2 = _interopRequireDefault(_css);
	
	var _ServerStyleSheet = __webpack_require__(397);
	
	var _ServerStyleSheet2 = _interopRequireDefault(_ServerStyleSheet);
	
	var _StyleSheetManager = __webpack_require__(922);
	
	var _StyleSheetManager2 = _interopRequireDefault(_StyleSheetManager);
	
	var _StyledComponent2 = __webpack_require__(2020);
	
	var _StyledComponent3 = _interopRequireDefault(_StyledComponent2);
	
	var _ComponentStyle2 = __webpack_require__(2019);
	
	var _ComponentStyle3 = _interopRequireDefault(_ComponentStyle2);
	
	var _styled2 = __webpack_require__(2016);
	
	var _styled3 = _interopRequireDefault(_styled2);
	
	var _keyframes2 = __webpack_require__(2015);
	
	var _keyframes3 = _interopRequireDefault(_keyframes2);
	
	var _injectGlobal2 = __webpack_require__(2014);
	
	var _injectGlobal3 = _interopRequireDefault(_injectGlobal2);
	
	var _constructWithOptions2 = __webpack_require__(2012);
	
	var _constructWithOptions3 = _interopRequireDefault(_constructWithOptions2);
	
	var _ThemeProvider = __webpack_require__(398);
	
	var _ThemeProvider2 = _interopRequireDefault(_ThemeProvider);
	
	var _withTheme = __webpack_require__(2017);
	
	var _withTheme2 = _interopRequireDefault(_withTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Instantiate singletons */
	
	
	/* Import components */
	
	
	/* Import singleton constructors */
	
	
	/* Import singletons */
	var ComponentStyle = (0, _ComponentStyle3.default)(_generateAlphabeticName2.default, _flatten2.default, _stringifyRules2.default);
	
	/* Import Higher Order Components */
	
	var constructWithOptions = (0, _constructWithOptions3.default)(_css2.default);
	var StyledComponent = (0, _StyledComponent3.default)(ComponentStyle, constructWithOptions);
	
	/* Instantiate exported singletons */
	var keyframes = (0, _keyframes3.default)(_generateAlphabeticName2.default, _stringifyRules2.default, _css2.default);
	var injectGlobal = (0, _injectGlobal3.default)(_stringifyRules2.default, _css2.default);
	var styled = (0, _styled3.default)(StyledComponent, constructWithOptions);
	
	/* Export everything */
	exports.default = styled;
	exports.css = _css2.default;
	exports.keyframes = keyframes;
	exports.injectGlobal = injectGlobal;
	exports.ThemeProvider = _ThemeProvider2.default;
	exports.withTheme = _withTheme2.default;
	exports.ServerStyleSheet = _ServerStyleSheet2.default;
	exports.StyleSheetManager = _StyleSheetManager2.default;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(850);
	
	var _createChainableTypeChecker = __webpack_require__(371);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
	  }
	
	  if (!(0, _reactIs.isValidElementType)(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);
	module.exports = exports['default'];

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EditorState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BlockTree = __webpack_require__(642);
	var ContentState = __webpack_require__(445);
	var EditorBidiService = __webpack_require__(1224);
	var Immutable = __webpack_require__(60);
	var SelectionState = __webpack_require__(235);
	
	var OrderedSet = Immutable.OrderedSet,
	    Record = Immutable.Record,
	    Stack = Immutable.Stack;
	
	
	var defaultRecord = {
	  allowUndo: true,
	  currentContent: null,
	  decorator: null,
	  directionMap: null,
	  forceSelection: false,
	  inCompositionMode: false,
	  inlineStyleOverride: null,
	  lastChangeType: null,
	  nativelyRenderedContent: null,
	  redoStack: Stack(),
	  selection: null,
	  treeMap: null,
	  undoStack: Stack()
	};
	
	var EditorStateRecord = Record(defaultRecord);
	
	var EditorState = function () {
	  EditorState.createEmpty = function createEmpty(decorator) {
	    return EditorState.createWithContent(ContentState.createFromText(''), decorator);
	  };
	
	  EditorState.createWithContent = function createWithContent(contentState, decorator) {
	    var firstKey = contentState.getBlockMap().first().getKey();
	    return EditorState.create({
	      currentContent: contentState,
	      undoStack: Stack(),
	      redoStack: Stack(),
	      decorator: decorator || null,
	      selection: SelectionState.createEmpty(firstKey)
	    });
	  };
	
	  EditorState.create = function create(config) {
	    var currentContent = config.currentContent,
	        decorator = config.decorator;
	
	    var recordConfig = _extends({}, config, {
	      treeMap: generateNewTreeMap(currentContent, decorator),
	      directionMap: EditorBidiService.getDirectionMap(currentContent)
	    });
	    return new EditorState(new EditorStateRecord(recordConfig));
	  };
	
	  EditorState.set = function set(editorState, put) {
	    var map = editorState.getImmutable().withMutations(function (state) {
	      var existingDecorator = state.get('decorator');
	      var decorator = existingDecorator;
	      if (put.decorator === null) {
	        decorator = null;
	      } else if (put.decorator) {
	        decorator = put.decorator;
	      }
	
	      var newContent = put.currentContent || editorState.getCurrentContent();
	
	      if (decorator !== existingDecorator) {
	        var treeMap = state.get('treeMap');
	        var newTreeMap;
	        if (decorator && existingDecorator) {
	          newTreeMap = regenerateTreeForNewDecorator(newContent, newContent.getBlockMap(), treeMap, decorator, existingDecorator);
	        } else {
	          newTreeMap = generateNewTreeMap(newContent, decorator);
	        }
	
	        state.merge({
	          decorator: decorator,
	          treeMap: newTreeMap,
	          nativelyRenderedContent: null
	        });
	        return;
	      }
	
	      var existingContent = editorState.getCurrentContent();
	      if (newContent !== existingContent) {
	        state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), newContent.getEntityMap(), decorator));
	      }
	
	      state.merge(put);
	    });
	
	    return new EditorState(map);
	  };
	
	  EditorState.prototype.toJS = function toJS() {
	    return this.getImmutable().toJS();
	  };
	
	  EditorState.prototype.getAllowUndo = function getAllowUndo() {
	    return this.getImmutable().get('allowUndo');
	  };
	
	  EditorState.prototype.getCurrentContent = function getCurrentContent() {
	    return this.getImmutable().get('currentContent');
	  };
	
	  EditorState.prototype.getUndoStack = function getUndoStack() {
	    return this.getImmutable().get('undoStack');
	  };
	
	  EditorState.prototype.getRedoStack = function getRedoStack() {
	    return this.getImmutable().get('redoStack');
	  };
	
	  EditorState.prototype.getSelection = function getSelection() {
	    return this.getImmutable().get('selection');
	  };
	
	  EditorState.prototype.getDecorator = function getDecorator() {
	    return this.getImmutable().get('decorator');
	  };
	
	  EditorState.prototype.isInCompositionMode = function isInCompositionMode() {
	    return this.getImmutable().get('inCompositionMode');
	  };
	
	  EditorState.prototype.mustForceSelection = function mustForceSelection() {
	    return this.getImmutable().get('forceSelection');
	  };
	
	  EditorState.prototype.getNativelyRenderedContent = function getNativelyRenderedContent() {
	    return this.getImmutable().get('nativelyRenderedContent');
	  };
	
	  EditorState.prototype.getLastChangeType = function getLastChangeType() {
	    return this.getImmutable().get('lastChangeType');
	  };
	
	  /**
	   * While editing, the user may apply inline style commands with a collapsed
	   * cursor, intending to type text that adopts the specified style. In this
	   * case, we track the specified style as an "override" that takes precedence
	   * over the inline style of the text adjacent to the cursor.
	   *
	   * If null, there is no override in place.
	   */
	
	
	  EditorState.prototype.getInlineStyleOverride = function getInlineStyleOverride() {
	    return this.getImmutable().get('inlineStyleOverride');
	  };
	
	  EditorState.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
	    return EditorState.set(editorState, { inlineStyleOverride: inlineStyleOverride });
	  };
	
	  /**
	   * Get the appropriate inline style for the editor state. If an
	   * override is in place, use it. Otherwise, the current style is
	   * based on the location of the selection state.
	   */
	
	
	  EditorState.prototype.getCurrentInlineStyle = function getCurrentInlineStyle() {
	    var override = this.getInlineStyleOverride();
	    if (override != null) {
	      return override;
	    }
	
	    var content = this.getCurrentContent();
	    var selection = this.getSelection();
	
	    if (selection.isCollapsed()) {
	      return getInlineStyleForCollapsedSelection(content, selection);
	    }
	
	    return getInlineStyleForNonCollapsedSelection(content, selection);
	  };
	
	  EditorState.prototype.getBlockTree = function getBlockTree(blockKey) {
	    return this.getImmutable().getIn(['treeMap', blockKey]);
	  };
	
	  EditorState.prototype.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
	    var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
	    return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
	  };
	
	  EditorState.prototype.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
	    var content = this.getCurrentContent();
	    var blockMap = content.getBlockMap();
	    var last = blockMap.last();
	    var end = last.getLength();
	    return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
	  };
	
	  EditorState.prototype.getDirectionMap = function getDirectionMap() {
	    return this.getImmutable().get('directionMap');
	  };
	
	  /**
	   * Incorporate native DOM selection changes into the EditorState. This
	   * method can be used when we simply want to accept whatever the DOM
	   * has given us to represent selection, and we do not need to re-render
	   * the editor.
	   *
	   * To forcibly move the DOM selection, see `EditorState.forceSelection`.
	   */
	
	
	  EditorState.acceptSelection = function acceptSelection(editorState, selection) {
	    return updateSelection(editorState, selection, false);
	  };
	
	  /**
	   * At times, we need to force the DOM selection to be where we
	   * need it to be. This can occur when the anchor or focus nodes
	   * are non-text nodes, for instance. In this case, we want to trigger
	   * a re-render of the editor, which in turn forces selection into
	   * the correct place in the DOM. The `forceSelection` method
	   * accomplishes this.
	   *
	   * This method should be used in cases where you need to explicitly
	   * move the DOM selection from one place to another without a change
	   * in ContentState.
	   */
	
	
	  EditorState.forceSelection = function forceSelection(editorState, selection) {
	    if (!selection.getHasFocus()) {
	      selection = selection.set('hasFocus', true);
	    }
	    return updateSelection(editorState, selection, true);
	  };
	
	  /**
	   * Move selection to the end of the editor without forcing focus.
	   */
	
	
	  EditorState.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
	    var content = editorState.getCurrentContent();
	    var lastBlock = content.getLastBlock();
	    var lastKey = lastBlock.getKey();
	    var length = lastBlock.getLength();
	
	    return EditorState.acceptSelection(editorState, new SelectionState({
	      anchorKey: lastKey,
	      anchorOffset: length,
	      focusKey: lastKey,
	      focusOffset: length,
	      isBackward: false
	    }));
	  };
	
	  /**
	   * Force focus to the end of the editor. This is useful in scenarios
	   * where we want to programmatically focus the input and it makes sense
	   * to allow the user to continue working seamlessly.
	   */
	
	
	  EditorState.moveFocusToEnd = function moveFocusToEnd(editorState) {
	    var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
	    return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
	  };
	
	  /**
	   * Push the current ContentState onto the undo stack if it should be
	   * considered a boundary state, and set the provided ContentState as the
	   * new current content.
	   */
	
	
	  EditorState.push = function push(editorState, contentState, changeType) {
	    if (editorState.getCurrentContent() === contentState) {
	      return editorState;
	    }
	
	    var forceSelection = changeType !== 'insert-characters';
	    var directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());
	
	    if (!editorState.getAllowUndo()) {
	      return EditorState.set(editorState, {
	        currentContent: contentState,
	        directionMap: directionMap,
	        lastChangeType: changeType,
	        selection: contentState.getSelectionAfter(),
	        forceSelection: forceSelection,
	        inlineStyleOverride: null
	      });
	    }
	
	    var selection = editorState.getSelection();
	    var currentContent = editorState.getCurrentContent();
	    var undoStack = editorState.getUndoStack();
	    var newContent = contentState;
	
	    if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
	      undoStack = undoStack.push(currentContent);
	      newContent = newContent.set('selectionBefore', selection);
	    } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
	      // Preserve the previous selection.
	      newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
	    }
	
	    var inlineStyleOverride = editorState.getInlineStyleOverride();
	
	    // Don't discard inline style overrides for the following change types:
	    var overrideChangeTypes = ['adjust-depth', 'change-block-type', 'split-block'];
	
	    if (overrideChangeTypes.indexOf(changeType) === -1) {
	      inlineStyleOverride = null;
	    }
	
	    var editorStateChanges = {
	      currentContent: newContent,
	      directionMap: directionMap,
	      undoStack: undoStack,
	      redoStack: Stack(),
	      lastChangeType: changeType,
	      selection: contentState.getSelectionAfter(),
	      forceSelection: forceSelection,
	      inlineStyleOverride: inlineStyleOverride
	    };
	
	    return EditorState.set(editorState, editorStateChanges);
	  };
	
	  /**
	   * Make the top ContentState in the undo stack the new current content and
	   * push the current content onto the redo stack.
	   */
	
	
	  EditorState.undo = function undo(editorState) {
	    if (!editorState.getAllowUndo()) {
	      return editorState;
	    }
	
	    var undoStack = editorState.getUndoStack();
	    var newCurrentContent = undoStack.peek();
	    if (!newCurrentContent) {
	      return editorState;
	    }
	
	    var currentContent = editorState.getCurrentContent();
	    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
	
	    return EditorState.set(editorState, {
	      currentContent: newCurrentContent,
	      directionMap: directionMap,
	      undoStack: undoStack.shift(),
	      redoStack: editorState.getRedoStack().push(currentContent),
	      forceSelection: true,
	      inlineStyleOverride: null,
	      lastChangeType: 'undo',
	      nativelyRenderedContent: null,
	      selection: currentContent.getSelectionBefore()
	    });
	  };
	
	  /**
	   * Make the top ContentState in the redo stack the new current content and
	   * push the current content onto the undo stack.
	   */
	
	
	  EditorState.redo = function redo(editorState) {
	    if (!editorState.getAllowUndo()) {
	      return editorState;
	    }
	
	    var redoStack = editorState.getRedoStack();
	    var newCurrentContent = redoStack.peek();
	    if (!newCurrentContent) {
	      return editorState;
	    }
	
	    var currentContent = editorState.getCurrentContent();
	    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
	
	    return EditorState.set(editorState, {
	      currentContent: newCurrentContent,
	      directionMap: directionMap,
	      undoStack: editorState.getUndoStack().push(currentContent),
	      redoStack: redoStack.shift(),
	      forceSelection: true,
	      inlineStyleOverride: null,
	      lastChangeType: 'redo',
	      nativelyRenderedContent: null,
	      selection: newCurrentContent.getSelectionAfter()
	    });
	  };
	
	  /**
	   * Not for public consumption.
	   */
	
	
	  function EditorState(immutable) {
	    _classCallCheck(this, EditorState);
	
	    this._immutable = immutable;
	  }
	
	  /**
	   * Not for public consumption.
	   */
	
	
	  EditorState.prototype.getImmutable = function getImmutable() {
	    return this._immutable;
	  };
	
	  return EditorState;
	}();
	
	/**
	 * Set the supplied SelectionState as the new current selection, and set
	 * the `force` flag to trigger manual selection placement by the view.
	 */
	
	
	function updateSelection(editorState, selection, forceSelection) {
	  return EditorState.set(editorState, {
	    selection: selection,
	    forceSelection: forceSelection,
	    nativelyRenderedContent: null,
	    inlineStyleOverride: null
	  });
	}
	
	/**
	 * Regenerate the entire tree map for a given ContentState and decorator.
	 * Returns an OrderedMap that maps all available ContentBlock objects.
	 */
	function generateNewTreeMap(contentState, decorator) {
	  return contentState.getBlockMap().map(function (block) {
	    return BlockTree.generate(contentState, block, decorator);
	  }).toOrderedMap();
	}
	
	/**
	 * Regenerate tree map objects for all ContentBlocks that have changed
	 * between the current editorState and newContent. Returns an OrderedMap
	 * with only changed regenerated tree map objects.
	 */
	function regenerateTreeForNewBlocks(editorState, newBlockMap, newEntityMap, decorator) {
	  var contentState = editorState.getCurrentContent().set('entityMap', newEntityMap);
	  var prevBlockMap = contentState.getBlockMap();
	  var prevTreeMap = editorState.getImmutable().get('treeMap');
	  return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
	    return block !== prevBlockMap.get(key);
	  }).map(function (block) {
	    return BlockTree.generate(contentState, block, decorator);
	  }));
	}
	
	/**
	 * Generate tree map objects for a new decorator object, preserving any
	 * decorations that are unchanged from the previous decorator.
	 *
	 * Note that in order for this to perform optimally, decoration Lists for
	 * decorators should be preserved when possible to allow for direct immutable
	 * List comparison.
	 */
	function regenerateTreeForNewDecorator(content, blockMap, previousTreeMap, decorator, existingDecorator) {
	  return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
	    return decorator.getDecorations(block, content) !== existingDecorator.getDecorations(block, content);
	  }).map(function (block) {
	    return BlockTree.generate(content, block, decorator);
	  }));
	}
	
	/**
	 * Return whether a change should be considered a boundary state, given
	 * the previous change type. Allows us to discard potential boundary states
	 * during standard typing or deletion behavior.
	 */
	function mustBecomeBoundary(editorState, changeType) {
	  var lastChangeType = editorState.getLastChangeType();
	  return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
	}
	
	function getInlineStyleForCollapsedSelection(content, selection) {
	  var startKey = selection.getStartKey();
	  var startOffset = selection.getStartOffset();
	  var startBlock = content.getBlockForKey(startKey);
	
	  // If the cursor is not at the start of the block, look backward to
	  // preserve the style of the preceding character.
	  if (startOffset > 0) {
	    return startBlock.getInlineStyleAt(startOffset - 1);
	  }
	
	  // The caret is at position zero in this block. If the block has any
	  // text at all, use the style of the first character.
	  if (startBlock.getLength()) {
	    return startBlock.getInlineStyleAt(0);
	  }
	
	  // Otherwise, look upward in the document to find the closest character.
	  return lookUpwardForInlineStyle(content, startKey);
	}
	
	function getInlineStyleForNonCollapsedSelection(content, selection) {
	  var startKey = selection.getStartKey();
	  var startOffset = selection.getStartOffset();
	  var startBlock = content.getBlockForKey(startKey);
	
	  // If there is a character just inside the selection, use its style.
	  if (startOffset < startBlock.getLength()) {
	    return startBlock.getInlineStyleAt(startOffset);
	  }
	
	  // Check if the selection at the end of a non-empty block. Use the last
	  // style in the block.
	  if (startOffset > 0) {
	    return startBlock.getInlineStyleAt(startOffset - 1);
	  }
	
	  // Otherwise, look upward in the document to find the closest character.
	  return lookUpwardForInlineStyle(content, startKey);
	}
	
	function lookUpwardForInlineStyle(content, fromKey) {
	  var lastNonEmpty = content.getBlockMap().reverse().skipUntil(function (_, k) {
	    return k === fromKey;
	  }).skip(1).skipUntil(function (block, _) {
	    return block.getLength();
	  }).first();
	
	  if (lastNonEmpty) return lastNonEmpty.getInlineStyleAt(lastNonEmpty.getLength() - 1);
	  return OrderedSet();
	}
	
	module.exports = EditorState;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.Well = exports.Tooltip = exports.ToggleButtonGroup = exports.ToggleButton = exports.Thumbnail = exports.Tabs = exports.TabPane = exports.Table = exports.TabContent = exports.TabContainer = exports.Tab = exports.SplitButton = exports.SafeAnchor = exports.Row = exports.ResponsiveEmbed = exports.Radio = exports.ProgressBar = exports.Popover = exports.PanelGroup = exports.Panel = exports.PaginationButton = exports.Pagination = exports.Pager = exports.PageItem = exports.PageHeader = exports.OverlayTrigger = exports.Overlay = exports.NavItem = exports.NavDropdown = exports.NavbarBrand = exports.Navbar = exports.Nav = exports.ModalTitle = exports.ModalHeader = exports.ModalFooter = exports.ModalBody = exports.Modal = exports.MenuItem = exports.Media = exports.ListGroupItem = exports.ListGroup = exports.Label = exports.Jumbotron = exports.InputGroup = exports.Image = exports.HelpBlock = exports.Grid = exports.Glyphicon = exports.FormGroup = exports.FormControl = exports.Form = exports.Fade = exports.DropdownButton = exports.Dropdown = exports.Collapse = exports.Col = exports.ControlLabel = exports.CloseButton = exports.Clearfix = exports.Checkbox = exports.CarouselItem = exports.Carousel = exports.ButtonToolbar = exports.ButtonGroup = exports.Button = exports.BreadcrumbItem = exports.Breadcrumb = exports.Badge = exports.Alert = exports.Accordion = undefined;
	
	var _Accordion2 = __webpack_require__(1649);
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	var _Alert2 = __webpack_require__(1650);
	
	var _Alert3 = _interopRequireDefault(_Alert2);
	
	var _Badge2 = __webpack_require__(1651);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _Breadcrumb2 = __webpack_require__(1652);
	
	var _Breadcrumb3 = _interopRequireDefault(_Breadcrumb2);
	
	var _BreadcrumbItem2 = __webpack_require__(793);
	
	var _BreadcrumbItem3 = _interopRequireDefault(_BreadcrumbItem2);
	
	var _Button2 = __webpack_require__(292);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _ButtonGroup2 = __webpack_require__(501);
	
	var _ButtonGroup3 = _interopRequireDefault(_ButtonGroup2);
	
	var _ButtonToolbar2 = __webpack_require__(1653);
	
	var _ButtonToolbar3 = _interopRequireDefault(_ButtonToolbar2);
	
	var _Carousel2 = __webpack_require__(1654);
	
	var _Carousel3 = _interopRequireDefault(_Carousel2);
	
	var _CarouselItem2 = __webpack_require__(794);
	
	var _CarouselItem3 = _interopRequireDefault(_CarouselItem2);
	
	var _Checkbox2 = __webpack_require__(1656);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Clearfix2 = __webpack_require__(1657);
	
	var _Clearfix3 = _interopRequireDefault(_Clearfix2);
	
	var _CloseButton2 = __webpack_require__(502);
	
	var _CloseButton3 = _interopRequireDefault(_CloseButton2);
	
	var _ControlLabel2 = __webpack_require__(1659);
	
	var _ControlLabel3 = _interopRequireDefault(_ControlLabel2);
	
	var _Col2 = __webpack_require__(1658);
	
	var _Col3 = _interopRequireDefault(_Col2);
	
	var _Collapse2 = __webpack_require__(503);
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	var _Dropdown2 = __webpack_require__(364);
	
	var _Dropdown3 = _interopRequireDefault(_Dropdown2);
	
	var _DropdownButton2 = __webpack_require__(1660);
	
	var _DropdownButton3 = _interopRequireDefault(_DropdownButton2);
	
	var _Fade2 = __webpack_require__(365);
	
	var _Fade3 = _interopRequireDefault(_Fade2);
	
	var _Form2 = __webpack_require__(1662);
	
	var _Form3 = _interopRequireDefault(_Form2);
	
	var _FormControl2 = __webpack_require__(1663);
	
	var _FormControl3 = _interopRequireDefault(_FormControl2);
	
	var _FormGroup2 = __webpack_require__(1666);
	
	var _FormGroup3 = _interopRequireDefault(_FormGroup2);
	
	var _Glyphicon2 = __webpack_require__(504);
	
	var _Glyphicon3 = _interopRequireDefault(_Glyphicon2);
	
	var _Grid2 = __webpack_require__(796);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _HelpBlock2 = __webpack_require__(1667);
	
	var _HelpBlock3 = _interopRequireDefault(_HelpBlock2);
	
	var _Image2 = __webpack_require__(1668);
	
	var _Image3 = _interopRequireDefault(_Image2);
	
	var _InputGroup2 = __webpack_require__(1669);
	
	var _InputGroup3 = _interopRequireDefault(_InputGroup2);
	
	var _Jumbotron2 = __webpack_require__(1672);
	
	var _Jumbotron3 = _interopRequireDefault(_Jumbotron2);
	
	var _Label2 = __webpack_require__(1673);
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	var _ListGroup2 = __webpack_require__(1674);
	
	var _ListGroup3 = _interopRequireDefault(_ListGroup2);
	
	var _ListGroupItem2 = __webpack_require__(797);
	
	var _ListGroupItem3 = _interopRequireDefault(_ListGroupItem2);
	
	var _Media2 = __webpack_require__(366);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MenuItem2 = __webpack_require__(1681);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _Modal2 = __webpack_require__(1682);
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	var _ModalBody2 = __webpack_require__(798);
	
	var _ModalBody3 = _interopRequireDefault(_ModalBody2);
	
	var _ModalFooter2 = __webpack_require__(799);
	
	var _ModalFooter3 = _interopRequireDefault(_ModalFooter2);
	
	var _ModalHeader2 = __webpack_require__(800);
	
	var _ModalHeader3 = _interopRequireDefault(_ModalHeader2);
	
	var _ModalTitle2 = __webpack_require__(801);
	
	var _ModalTitle3 = _interopRequireDefault(_ModalTitle2);
	
	var _Nav2 = __webpack_require__(802);
	
	var _Nav3 = _interopRequireDefault(_Nav2);
	
	var _Navbar2 = __webpack_require__(1685);
	
	var _Navbar3 = _interopRequireDefault(_Navbar2);
	
	var _NavbarBrand2 = __webpack_require__(804);
	
	var _NavbarBrand3 = _interopRequireDefault(_NavbarBrand2);
	
	var _NavDropdown2 = __webpack_require__(1684);
	
	var _NavDropdown3 = _interopRequireDefault(_NavDropdown2);
	
	var _NavItem2 = __webpack_require__(803);
	
	var _NavItem3 = _interopRequireDefault(_NavItem2);
	
	var _Overlay2 = __webpack_require__(805);
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	var _OverlayTrigger2 = __webpack_require__(1689);
	
	var _OverlayTrigger3 = _interopRequireDefault(_OverlayTrigger2);
	
	var _PageHeader2 = __webpack_require__(1690);
	
	var _PageHeader3 = _interopRequireDefault(_PageHeader2);
	
	var _PageItem2 = __webpack_require__(1691);
	
	var _PageItem3 = _interopRequireDefault(_PageItem2);
	
	var _Pager2 = __webpack_require__(1692);
	
	var _Pager3 = _interopRequireDefault(_Pager2);
	
	var _Pagination2 = __webpack_require__(1693);
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	var _PaginationButton2 = __webpack_require__(807);
	
	var _PaginationButton3 = _interopRequireDefault(_PaginationButton2);
	
	var _Panel2 = __webpack_require__(1694);
	
	var _Panel3 = _interopRequireDefault(_Panel2);
	
	var _PanelGroup2 = __webpack_require__(808);
	
	var _PanelGroup3 = _interopRequireDefault(_PanelGroup2);
	
	var _Popover2 = __webpack_require__(1695);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _ProgressBar2 = __webpack_require__(1696);
	
	var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);
	
	var _Radio2 = __webpack_require__(1697);
	
	var _Radio3 = _interopRequireDefault(_Radio2);
	
	var _ResponsiveEmbed2 = __webpack_require__(1698);
	
	var _ResponsiveEmbed3 = _interopRequireDefault(_ResponsiveEmbed2);
	
	var _Row2 = __webpack_require__(1699);
	
	var _Row3 = _interopRequireDefault(_Row2);
	
	var _SafeAnchor2 = __webpack_require__(154);
	
	var _SafeAnchor3 = _interopRequireDefault(_SafeAnchor2);
	
	var _SplitButton2 = __webpack_require__(1700);
	
	var _SplitButton3 = _interopRequireDefault(_SplitButton2);
	
	var _Tab2 = __webpack_require__(1702);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _TabContainer2 = __webpack_require__(505);
	
	var _TabContainer3 = _interopRequireDefault(_TabContainer2);
	
	var _TabContent2 = __webpack_require__(506);
	
	var _TabContent3 = _interopRequireDefault(_TabContent2);
	
	var _Table2 = __webpack_require__(1703);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TabPane2 = __webpack_require__(809);
	
	var _TabPane3 = _interopRequireDefault(_TabPane2);
	
	var _Tabs2 = __webpack_require__(1704);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Thumbnail2 = __webpack_require__(1705);
	
	var _Thumbnail3 = _interopRequireDefault(_Thumbnail2);
	
	var _ToggleButton2 = __webpack_require__(810);
	
	var _ToggleButton3 = _interopRequireDefault(_ToggleButton2);
	
	var _ToggleButtonGroup2 = __webpack_require__(1706);
	
	var _ToggleButtonGroup3 = _interopRequireDefault(_ToggleButtonGroup2);
	
	var _Tooltip2 = __webpack_require__(1707);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _Well2 = __webpack_require__(1708);
	
	var _Well3 = _interopRequireDefault(_Well2);
	
	var _utils2 = __webpack_require__(1712);
	
	var _utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Accordion = _Accordion3.default;
	exports.Alert = _Alert3.default;
	exports.Badge = _Badge3.default;
	exports.Breadcrumb = _Breadcrumb3.default;
	exports.BreadcrumbItem = _BreadcrumbItem3.default;
	exports.Button = _Button3.default;
	exports.ButtonGroup = _ButtonGroup3.default;
	exports.ButtonToolbar = _ButtonToolbar3.default;
	exports.Carousel = _Carousel3.default;
	exports.CarouselItem = _CarouselItem3.default;
	exports.Checkbox = _Checkbox3.default;
	exports.Clearfix = _Clearfix3.default;
	exports.CloseButton = _CloseButton3.default;
	exports.ControlLabel = _ControlLabel3.default;
	exports.Col = _Col3.default;
	exports.Collapse = _Collapse3.default;
	exports.Dropdown = _Dropdown3.default;
	exports.DropdownButton = _DropdownButton3.default;
	exports.Fade = _Fade3.default;
	exports.Form = _Form3.default;
	exports.FormControl = _FormControl3.default;
	exports.FormGroup = _FormGroup3.default;
	exports.Glyphicon = _Glyphicon3.default;
	exports.Grid = _Grid3.default;
	exports.HelpBlock = _HelpBlock3.default;
	exports.Image = _Image3.default;
	exports.InputGroup = _InputGroup3.default;
	exports.Jumbotron = _Jumbotron3.default;
	exports.Label = _Label3.default;
	exports.ListGroup = _ListGroup3.default;
	exports.ListGroupItem = _ListGroupItem3.default;
	exports.Media = _Media3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.Modal = _Modal3.default;
	exports.ModalBody = _ModalBody3.default;
	exports.ModalFooter = _ModalFooter3.default;
	exports.ModalHeader = _ModalHeader3.default;
	exports.ModalTitle = _ModalTitle3.default;
	exports.Nav = _Nav3.default;
	exports.Navbar = _Navbar3.default;
	exports.NavbarBrand = _NavbarBrand3.default;
	exports.NavDropdown = _NavDropdown3.default;
	exports.NavItem = _NavItem3.default;
	exports.Overlay = _Overlay3.default;
	exports.OverlayTrigger = _OverlayTrigger3.default;
	exports.PageHeader = _PageHeader3.default;
	exports.PageItem = _PageItem3.default;
	exports.Pager = _Pager3.default;
	exports.Pagination = _Pagination3.default;
	exports.PaginationButton = _PaginationButton3.default;
	exports.Panel = _Panel3.default;
	exports.PanelGroup = _PanelGroup3.default;
	exports.Popover = _Popover3.default;
	exports.ProgressBar = _ProgressBar3.default;
	exports.Radio = _Radio3.default;
	exports.ResponsiveEmbed = _ResponsiveEmbed3.default;
	exports.Row = _Row3.default;
	exports.SafeAnchor = _SafeAnchor3.default;
	exports.SplitButton = _SplitButton3.default;
	exports.Tab = _Tab3.default;
	exports.TabContainer = _TabContainer3.default;
	exports.TabContent = _TabContent3.default;
	exports.Table = _Table3.default;
	exports.TabPane = _TabPane3.default;
	exports.Tabs = _Tabs3.default;
	exports.Thumbnail = _Thumbnail3.default;
	exports.ToggleButton = _ToggleButton3.default;
	exports.ToggleButtonGroup = _ToggleButtonGroup3.default;
	exports.Tooltip = _Tooltip3.default;
	exports.Well = _Well3.default;
	exports.utils = _utils;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {"use strict";
	var es5 = __webpack_require__(196);
	var canEvaluate = typeof navigator == "undefined";
	
	var errorObj = {e: {}};
	var tryCatchTarget;
	var globalObject = typeof self !== "undefined" ? self :
	    typeof window !== "undefined" ? window :
	    typeof global !== "undefined" ? global :
	    this !== undefined ? this : null;
	
	function tryCatcher() {
	    try {
	        var target = tryCatchTarget;
	        tryCatchTarget = null;
	        return target.apply(this, arguments);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	
	var inherits = function(Child, Parent) {
	    var hasProp = {}.hasOwnProperty;
	
	    function T() {
	        this.constructor = Child;
	        this.constructor$ = Parent;
	        for (var propertyName in Parent.prototype) {
	            if (hasProp.call(Parent.prototype, propertyName) &&
	                propertyName.charAt(propertyName.length-1) !== "$"
	           ) {
	                this[propertyName + "$"] = Parent.prototype[propertyName];
	            }
	        }
	    }
	    T.prototype = Parent.prototype;
	    Child.prototype = new T();
	    return Child.prototype;
	};
	
	
	function isPrimitive(val) {
	    return val == null || val === true || val === false ||
	        typeof val === "string" || typeof val === "number";
	
	}
	
	function isObject(value) {
	    return typeof value === "function" ||
	           typeof value === "object" && value !== null;
	}
	
	function maybeWrapAsError(maybeError) {
	    if (!isPrimitive(maybeError)) return maybeError;
	
	    return new Error(safeToString(maybeError));
	}
	
	function withAppended(target, appendee) {
	    var len = target.length;
	    var ret = new Array(len + 1);
	    var i;
	    for (i = 0; i < len; ++i) {
	        ret[i] = target[i];
	    }
	    ret[i] = appendee;
	    return ret;
	}
	
	function getDataPropertyOrDefault(obj, key, defaultValue) {
	    if (es5.isES5) {
	        var desc = Object.getOwnPropertyDescriptor(obj, key);
	
	        if (desc != null) {
	            return desc.get == null && desc.set == null
	                    ? desc.value
	                    : defaultValue;
	        }
	    } else {
	        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
	    }
	}
	
	function notEnumerableProp(obj, name, value) {
	    if (isPrimitive(obj)) return obj;
	    var descriptor = {
	        value: value,
	        configurable: true,
	        enumerable: false,
	        writable: true
	    };
	    es5.defineProperty(obj, name, descriptor);
	    return obj;
	}
	
	function thrower(r) {
	    throw r;
	}
	
	var inheritedDataKeys = (function() {
	    var excludedPrototypes = [
	        Array.prototype,
	        Object.prototype,
	        Function.prototype
	    ];
	
	    var isExcludedProto = function(val) {
	        for (var i = 0; i < excludedPrototypes.length; ++i) {
	            if (excludedPrototypes[i] === val) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    if (es5.isES5) {
	        var getKeys = Object.getOwnPropertyNames;
	        return function(obj) {
	            var ret = [];
	            var visitedKeys = Object.create(null);
	            while (obj != null && !isExcludedProto(obj)) {
	                var keys;
	                try {
	                    keys = getKeys(obj);
	                } catch (e) {
	                    return ret;
	                }
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    if (visitedKeys[key]) continue;
	                    visitedKeys[key] = true;
	                    var desc = Object.getOwnPropertyDescriptor(obj, key);
	                    if (desc != null && desc.get == null && desc.set == null) {
	                        ret.push(key);
	                    }
	                }
	                obj = es5.getPrototypeOf(obj);
	            }
	            return ret;
	        };
	    } else {
	        var hasProp = {}.hasOwnProperty;
	        return function(obj) {
	            if (isExcludedProto(obj)) return [];
	            var ret = [];
	
	            /*jshint forin:false */
	            enumeration: for (var key in obj) {
	                if (hasProp.call(obj, key)) {
	                    ret.push(key);
	                } else {
	                    for (var i = 0; i < excludedPrototypes.length; ++i) {
	                        if (hasProp.call(excludedPrototypes[i], key)) {
	                            continue enumeration;
	                        }
	                    }
	                    ret.push(key);
	                }
	            }
	            return ret;
	        };
	    }
	
	})();
	
	var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
	function isClass(fn) {
	    try {
	        if (typeof fn === "function") {
	            var keys = es5.names(fn.prototype);
	
	            var hasMethods = es5.isES5 && keys.length > 1;
	            var hasMethodsOtherThanConstructor = keys.length > 0 &&
	                !(keys.length === 1 && keys[0] === "constructor");
	            var hasThisAssignmentAndStaticMethods =
	                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
	
	            if (hasMethods || hasMethodsOtherThanConstructor ||
	                hasThisAssignmentAndStaticMethods) {
	                return true;
	            }
	        }
	        return false;
	    } catch (e) {
	        return false;
	    }
	}
	
	function toFastProperties(obj) {
	    /*jshint -W027,-W055,-W031*/
	    function FakeConstructor() {}
	    FakeConstructor.prototype = obj;
	    var receiver = new FakeConstructor();
	    function ic() {
	        return typeof receiver.foo;
	    }
	    ic();
	    ic();
	    return obj;
	    eval(obj);
	}
	
	var rident = /^[a-z$_][a-z$_0-9]*$/i;
	function isIdentifier(str) {
	    return rident.test(str);
	}
	
	function filledRange(count, prefix, suffix) {
	    var ret = new Array(count);
	    for(var i = 0; i < count; ++i) {
	        ret[i] = prefix + i + suffix;
	    }
	    return ret;
	}
	
	function safeToString(obj) {
	    try {
	        return obj + "";
	    } catch (e) {
	        return "[no string representation]";
	    }
	}
	
	function isError(obj) {
	    return obj instanceof Error ||
	        (obj !== null &&
	           typeof obj === "object" &&
	           typeof obj.message === "string" &&
	           typeof obj.name === "string");
	}
	
	function markAsOriginatingFromRejection(e) {
	    try {
	        notEnumerableProp(e, "isOperational", true);
	    }
	    catch(ignore) {}
	}
	
	function originatesFromRejection(e) {
	    if (e == null) return false;
	    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
	        e["isOperational"] === true);
	}
	
	function canAttachTrace(obj) {
	    return isError(obj) && es5.propertyIsWritable(obj, "stack");
	}
	
	var ensureErrorObject = (function() {
	    if (!("stack" in new Error())) {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            try {throw new Error(safeToString(value));}
	            catch(err) {return err;}
	        };
	    } else {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            return new Error(safeToString(value));
	        };
	    }
	})();
	
	function classString(obj) {
	    return {}.toString.call(obj);
	}
	
	function copyDescriptors(from, to, filter) {
	    var keys = es5.names(from);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        if (filter(key)) {
	            try {
	                es5.defineProperty(to, key, es5.getDescriptor(from, key));
	            } catch (ignore) {}
	        }
	    }
	}
	
	var asArray = function(v) {
	    if (es5.isArray(v)) {
	        return v;
	    }
	    return null;
	};
	
	if (typeof Symbol !== "undefined" && Symbol.iterator) {
	    var ArrayFrom = typeof Array.from === "function" ? function(v) {
	        return Array.from(v);
	    } : function(v) {
	        var ret = [];
	        var it = v[Symbol.iterator]();
	        var itResult;
	        while (!((itResult = it.next()).done)) {
	            ret.push(itResult.value);
	        }
	        return ret;
	    };
	
	    asArray = function(v) {
	        if (es5.isArray(v)) {
	            return v;
	        } else if (v != null && typeof v[Symbol.iterator] === "function") {
	            return ArrayFrom(v);
	        }
	        return null;
	    };
	}
	
	var isNode = typeof process !== "undefined" &&
	        classString(process).toLowerCase() === "[object process]";
	
	var hasEnvVariables = typeof process !== "undefined" &&
	    "object" !== "undefined";
	
	function env(key) {
	    return hasEnvVariables ? ({"NODE_ENV":"production"})[key] : undefined;
	}
	
	function getNativePromise() {
	    if (typeof Promise === "function") {
	        try {
	            var promise = new Promise(function(){});
	            if ({}.toString.call(promise) === "[object Promise]") {
	                return Promise;
	            }
	        } catch (e) {}
	    }
	}
	
	function domainBind(self, cb) {
	    return self.bind(cb);
	}
	
	var ret = {
	    isClass: isClass,
	    isIdentifier: isIdentifier,
	    inheritedDataKeys: inheritedDataKeys,
	    getDataPropertyOrDefault: getDataPropertyOrDefault,
	    thrower: thrower,
	    isArray: es5.isArray,
	    asArray: asArray,
	    notEnumerableProp: notEnumerableProp,
	    isPrimitive: isPrimitive,
	    isObject: isObject,
	    isError: isError,
	    canEvaluate: canEvaluate,
	    errorObj: errorObj,
	    tryCatch: tryCatch,
	    inherits: inherits,
	    withAppended: withAppended,
	    maybeWrapAsError: maybeWrapAsError,
	    toFastProperties: toFastProperties,
	    filledRange: filledRange,
	    toString: safeToString,
	    canAttachTrace: canAttachTrace,
	    ensureErrorObject: ensureErrorObject,
	    originatesFromRejection: originatesFromRejection,
	    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
	    classString: classString,
	    copyDescriptors: copyDescriptors,
	    hasDevTools: typeof chrome !== "undefined" && chrome &&
	                 typeof chrome.loadTimes === "function",
	    isNode: isNode,
	    hasEnvVariables: hasEnvVariables,
	    env: env,
	    global: globalObject,
	    getNativePromise: getNativePromise,
	    domainBind: domainBind
	};
	ret.isRecentNode = ret.isNode && (function() {
	    var version;
	    if (process.versions && process.versions.node) {    
	        version = process.versions.node.split(".").map(Number);
	    } else if (process.version) {
	        version = process.version.split(".").map(Number);
	    }
	    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
	})();
	
	if (ret.isNode) ret.toFastProperties(process);
	
	try {throw new Error(); } catch (e) {ret.lastLineError = e;}
	module.exports = ret;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(140)))

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Task = exports.TaskObject = exports.TaskNote = exports.TaskDto = exports.GridActivityDto = exports.EntityStatus = exports.PartyActivity = exports.bccEmailAddress = exports.ccEmailAddress = exports.toEmailAddress = exports.PartyActivityObject = exports.ActivityTemplate = exports.ActivityConfig = exports.EventHistory = exports.HistoryObject = exports.HistoryObjectField = exports.EmailRecipient = exports.ViberMessage = exports.SmsMessage = exports.EventTest = exports.EventTemplate = exports.EventType = exports.TASKSTATUS = exports.TASKTYPE = exports.ACTIVITYCATEGORY = exports.ACTIVITYLOCATION = exports.ACTIVITYTYPE_MAP = exports.ACTIVITYTYPE = exports.RECIPIENTTYPE = exports.DMLOPERATION = exports.SENDTYPE = exports.EVENTTYPE = exports.EVENTCATEGORY_MAP = exports.EVENTCATEGORY = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var documentDomain_1 = __webpack_require__(109);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var EVENTCATEGORY;
	(function (EVENTCATEGORY) {
	    EVENTCATEGORY["INFO_EVENT"] = "INFO_EVENT";
	    EVENTCATEGORY["DATA_EVENT"] = "DATA_EVENT";
	    EVENTCATEGORY["EMAIL_EVENT"] = "EMAIL_EVENT";
	    EVENTCATEGORY["PRINT_EVENT"] = "PRINT_EVENT";
	    EVENTCATEGORY["VOLVO_MQ_EVENT"] = "VOLVO_MQ_EVENT";
	    EVENTCATEGORY["SFTP_EVENT"] = "SFTP_EVENT";
	    EVENTCATEGORY["SMS_EVENT"] = "SMS_EVENT";
	    EVENTCATEGORY["VIBER_EVENT"] = "VIBER_EVENT";
	})(EVENTCATEGORY || (exports.EVENTCATEGORY = EVENTCATEGORY = {}));
	exports.EVENTCATEGORY_MAP = {
	    INFO_EVENT: { icon: "Message" },
	    DATA_EVENT: { icon: "Edit" },
	    EMAIL_EVENT: { icon: "Email" },
	    PRINT_EVENT: { icon: "Print" },
	    VOLVO_MQ_EVENT: { icon: "Send" },
	    SFTP_EVENT: { icon: "Send" },
	    SMS_EVENT: { icon: "SmsMessage" },
	    VIBER_EVENT: { icon: "SmsMessage" }
	};
	var EVENTTYPE;
	(function (EVENTTYPE) {
	    EVENTTYPE["INVOICE_CONCEPT_SENT_EMAIL"] = "INVOICE_CONCEPT_SENT_EMAIL";
	    EVENTTYPE["INVOICE_SENT_EMAIL"] = "INVOICE_SENT_EMAIL";
	    EVENTTYPE["INVOICE_SENT_PRINT"] = "INVOICE_SENT_PRINT";
	    EVENTTYPE["INVOICE_SENT_ACCOUNTING"] = "INVOICE_SENT_ACCOUNTING";
	    EVENTTYPE["INVOICE_SENT_TAX_OFFICE"] = "INVOICE_SENT_TAX_OFFICE";
	    EVENTTYPE["INVOICE_SENT_ARCHIVE"] = "INVOICE_SENT_ARCHIVE";
	    EVENTTYPE["INVOICE_GENERATED"] = "INVOICE_GENERATED";
	    EVENTTYPE["INVOICE_INTERNAL_EMAIL"] = "INVOICE_INTERNAL_EMAIL";
	    EVENTTYPE["PROCESS_BRIMMESSAGE"] = "PROCESS_BRIMMESSAGE";
	    EVENTTYPE["BRIMMESSAGE_NOTIFICATION"] = "BRIMMESSAGE_NOTIFICATION";
	    // treba party, product, vehicle
	    EVENTTYPE["INFO"] = "INFO";
	    EVENTTYPE["DML"] = "DML";
	    EVENTTYPE["OPEN"] = "OPEN";
	    EVENTTYPE["CLOSE"] = "CLOSE";
	    EVENTTYPE["SCHEDULED"] = "SCHEDULED";
	    // treba invoice
	    EVENTTYPE["COMPLETED"] = "COMPLETED";
	    EVENTTYPE["CANCELED"] = "CANCELED";
	    EVENTTYPE["REOPENED"] = "REOPENED";
	    EVENTTYPE["SHIPMENT_GATE_ARRIVAL_TO_DRIVER_SMS"] = "SHIPMENT_GATE_ARRIVAL_TO_DRIVER_SMS";
	    EVENTTYPE["SHIPMENT_GATE_ARRIVAL_TO_VENDOR_SMS"] = "SHIPMENT_GATE_ARRIVAL_TO_VENDOR_SMS";
	    EVENTTYPE["ACC_DOCUMENT_CONCEPT_SENT_EMAIL"] = "ACC_DOCUMENT_CONCEPT_SENT_EMAIL";
	    EVENTTYPE["ACC_DOCUMENT_SENT_EMAIL"] = "ACC_DOCUMENT_SENT_EMAIL";
	    EVENTTYPE["ACC_DOCUMENT_SENT_PRINT"] = "ACC_DOCUMENT_SENT_PRINT";
	    EVENTTYPE["ACC_DOCUMENT_SENT_ACCOUNTING"] = "ACC_DOCUMENT_SENT_ACCOUNTING";
	})(EVENTTYPE || (exports.EVENTTYPE = EVENTTYPE = {}));
	var SENDTYPE;
	(function (SENDTYPE) {
	    SENDTYPE["POST"] = "POST";
	    SENDTYPE["EMAIL"] = "EMAIL";
	})(SENDTYPE || (exports.SENDTYPE = SENDTYPE = {}));
	var DMLOPERATION;
	(function (DMLOPERATION) {
	    DMLOPERATION["INSERT"] = "INSERT";
	    DMLOPERATION["UPDATE"] = "UPDATE";
	    DMLOPERATION["DELETE"] = "DELETE";
	})(DMLOPERATION || (exports.DMLOPERATION = DMLOPERATION = {}));
	var RECIPIENTTYPE;
	(function (RECIPIENTTYPE) {
	    RECIPIENTTYPE["TO"] = "TO";
	    RECIPIENTTYPE["CC"] = "CC";
	    RECIPIENTTYPE["BCC"] = "BCC";
	})(RECIPIENTTYPE || (exports.RECIPIENTTYPE = RECIPIENTTYPE = {}));
	var ACTIVITYTYPE;
	(function (ACTIVITYTYPE) {
	    ACTIVITYTYPE["EMAIL"] = "EMAIL";
	    ACTIVITYTYPE["MEETING"] = "MEETING";
	    ACTIVITYTYPE["PHONE"] = "PHONE";
	    ACTIVITYTYPE["SMS"] = "SMS";
	    ACTIVITYTYPE["USERMESSAGE"] = "USERMESSAGE";
	})(ACTIVITYTYPE || (exports.ACTIVITYTYPE = ACTIVITYTYPE = {}));
	exports.ACTIVITYTYPE_MAP = {
	    EMAIL: { icon: "Email" }
	};
	var ACTIVITYLOCATION;
	(function (ACTIVITYLOCATION) {
	    ACTIVITYLOCATION["Vehicle"] = "Vehicle";
	    ACTIVITYLOCATION["Customer"] = "Customer";
	})(ACTIVITYLOCATION || (exports.ACTIVITYLOCATION = ACTIVITYLOCATION = {}));
	var ACTIVITYCATEGORY;
	(function (ACTIVITYCATEGORY) {
	    ACTIVITYCATEGORY["MULTIEMAIL"] = "MULTIEMAIL";
	    ACTIVITYCATEGORY["TASK"] = "TASK";
	    ACTIVITYCATEGORY["PRODUCTVEHICLECHANGE"] = "PRODUCTVEHICLECHANGE";
	    ACTIVITYCATEGORY["CUSTOMERREGISTRATION"] = "CUSTOMERREGISTRATION";
	})(ACTIVITYCATEGORY || (exports.ACTIVITYCATEGORY = ACTIVITYCATEGORY = {}));
	var TASKTYPE;
	(function (TASKTYPE) {
	    TASKTYPE["TODO"] = "TODO";
	    TASKTYPE["VEHICLE_NOTIFICATION"] = "VEHICLE_NOTIFICATION";
	    TASKTYPE["PARTY_NOTIFICATION"] = "PARTY_NOTIFICATION";
	})(TASKTYPE || (exports.TASKTYPE = TASKTYPE = {}));
	var TASKSTATUS;
	(function (TASKSTATUS) {
	    TASKSTATUS["SCHEDULED"] = "SCHEDULED";
	    TASKSTATUS["OPEN"] = "OPEN";
	    TASKSTATUS["CLOSED"] = "CLOSED";
	})(TASKSTATUS || (exports.TASKSTATUS = TASKSTATUS = {}));
	var EventType = /** @class */ (function (_super) {
	    tslib_1.__extends(EventType, _super);
	    function EventType(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.tenantGroups)
	            _this.tenantGroups = [];
	        if (!_this.tenants)
	            _this.tenants = [];
	        if (!_this.gridLocations)
	            _this.gridLocations = [];
	        return _this;
	    }
	    EventType.prototype.getId = function () {
	        return this.eventTypeId;
	    };
	    EventType.prototype.setId = function (id) {
	        this.eventTypeId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventType.prototype, "eventTypeId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventType.prototype, "eventName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventType.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventType.prototype, "eventType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventType.prototype, "eventCategory", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventType.prototype, "tenantGroups", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventType.prototype, "tenants", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventType.prototype, "gridLocations", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventType.prototype, "smsDeliveryReceipt", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventType.prototype, "smsDeliveryFailureAlert", void 0);
	    EventType = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], EventType);
	    return EventType;
	}(DomainAncestor_1.DomainAncestor));
	exports.EventType = EventType;
	var EventTemplate = /** @class */ (function (_super) {
	    tslib_1.__extends(EventTemplate, _super);
	    function EventTemplate(json) {
	        return _super.call(this, json) || this;
	    }
	    EventTemplate.prototype.fromJson = function (json) {
	        _super.prototype.fromJson.call(this, json, "resources");
	        if (!this.resources)
	            this.resources = new mobx_1.ObservableMap();
	        if (!this.invoiceTypeIds)
	            this.invoiceTypeIds = [];
	        return this;
	    };
	    // musi zmenit klic mapy dle jmena uvnitr
	    EventTemplate.prototype.prepareForServer = function () {
	        this.resources = mobx_1.observable.map(this.resources.values().reduce(function (acc, value) {
	            acc[value.name] = value;
	            return acc;
	        }, {}));
	        return _super.prototype.prepareForServer.call(this);
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventTemplate.prototype, "eventType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventTemplate.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventTemplate.prototype, "validFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventTemplate.prototype, "validTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventTemplate.prototype, "profitCenter", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventTemplate.prototype, "language", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventTemplate.prototype, "defaultEmailSubject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventTemplate.prototype, "defaultEmailBody", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventTemplate.prototype, "templateIndex", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventTemplate.prototype, "emailFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventTemplate.prototype, "replyTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventTemplate.prototype, "cc", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventTemplate.prototype, "bcc", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventTemplate.prototype, "toAddress", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventTemplate.prototype, "toAddressCode", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventTemplate.prototype, "$testObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventTemplate.prototype, "invoiceTypeIds", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(documentDomain_1.DocumentTemplateResource)
	    ], EventTemplate.prototype, "resources", void 0);
	    EventTemplate = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], EventTemplate);
	    return EventTemplate;
	}(DomainAncestor_1.DomainAncestor));
	exports.EventTemplate = EventTemplate;
	var EventTest = /** @class */ (function (_super) {
	    tslib_1.__extends(EventTest, _super);
	    function EventTest(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventTest.prototype, "$eventHistory", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable.ref
	    ], EventTest.prototype, "$mdEntity", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable.ref
	    ], EventTest.prototype, "$testObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventTest.prototype, "$sendEmail", void 0);
	    EventTest = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], EventTest);
	    return EventTest;
	}(DomainAncestor_1.DomainAncestor));
	exports.EventTest = EventTest;
	var SmsMessage = /** @class */ (function (_super) {
	    tslib_1.__extends(SmsMessage, _super);
	    function SmsMessage(json) {
	        return _super.call(this, json) || this;
	    }
	    SmsMessage.prototype.getId = function () {
	        return this.messageId;
	    };
	    SmsMessage.prototype.setId = function (id) {
	        this.messageId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SmsMessage.prototype, "messageId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SmsMessage.prototype, "smsprovider", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SmsMessage.prototype, "smsText", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SmsMessage.prototype, "toNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SmsMessage.prototype, "eventType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SmsMessage.prototype, "success", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SmsMessage.prototype, "errorCode", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SmsMessage.prototype, "errorDescription", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SmsMessage.prototype, "deliverySuccess", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SmsMessage.prototype, "deliveryTime", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SmsMessage.prototype, "deliveryErrorCode", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SmsMessage.prototype, "deliveryErrorDescription", void 0);
	    SmsMessage = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], SmsMessage);
	    return SmsMessage;
	}(DomainAncestor_1.DomainAncestor));
	exports.SmsMessage = SmsMessage;
	var ViberMessage = /** @class */ (function (_super) {
	    tslib_1.__extends(ViberMessage, _super);
	    function ViberMessage(json) {
	        return _super.call(this, json) || this;
	    }
	    ViberMessage.prototype.getId = function () {
	        return this.messageId;
	    };
	    ViberMessage.prototype.setId = function (id) {
	        this.messageId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ViberMessage.prototype, "messageId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ViberMessage.prototype, "messageText", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ViberMessage.prototype, "toUserId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ViberMessage.prototype, "eventType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ViberMessage.prototype, "success", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ViberMessage.prototype, "errorCode", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ViberMessage.prototype, "errorDescription", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ViberMessage.prototype, "deliverySuccess", void 0);
	    ViberMessage = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ViberMessage);
	    return ViberMessage;
	}(DomainAncestor_1.DomainAncestor));
	exports.ViberMessage = ViberMessage;
	var EmailRecipient = /** @class */ (function (_super) {
	    tslib_1.__extends(EmailRecipient, _super);
	    function EmailRecipient(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EmailRecipient.prototype, "recipientType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EmailRecipient.prototype, "emailAddress", void 0);
	    EmailRecipient = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], EmailRecipient);
	    return EmailRecipient;
	}(DomainAncestor_1.DomainAncestor));
	exports.EmailRecipient = EmailRecipient;
	var HistoryObjectField = /** @class */ (function (_super) {
	    tslib_1.__extends(HistoryObjectField, _super);
	    // @observable oldValueObject: DomainAncestor;
	    // @observable newValueObject: DomainAncestor;
	    function HistoryObjectField(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], HistoryObjectField.prototype, "historyObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], HistoryObjectField.prototype, "fieldName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], HistoryObjectField.prototype, "oldValue", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], HistoryObjectField.prototype, "newValue", void 0);
	    HistoryObjectField = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], HistoryObjectField);
	    return HistoryObjectField;
	}(DomainAncestor_1.DomainAncestor));
	exports.HistoryObjectField = HistoryObjectField;
	var HistoryObject = /** @class */ (function (_super) {
	    tslib_1.__extends(HistoryObject, _super);
	    function HistoryObject(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.fields)
	            _this.fields = [];
	        return _this;
	    }
	    HistoryObject.prototype.getId = function () {
	        return this.historyObjectId;
	    };
	    HistoryObject.prototype.setId = function (id) {
	        this.historyObjectId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], HistoryObject.prototype, "historyObjectId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], HistoryObject.prototype, "eventHistory", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], HistoryObject.prototype, "entityId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], HistoryObject.prototype, "entityName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], HistoryObject.prototype, "parentEntityId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], HistoryObject.prototype, "parentEntityName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], HistoryObject.prototype, "operation", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], HistoryObject.prototype, "version", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], HistoryObject.prototype, "entityLabel", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(HistoryObjectField)
	    ], HistoryObject.prototype, "fields", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(function (ho) {
	            var entityConfig = mdEntityService_1.default.getEntityConfig(ho.entityName);
	            if (!entityConfig)
	                throw new Error("EntityConfig for " + ho.entityName + " not found in Registry");
	            return entityConfig.entityConstructorFunction;
	        })
	    ], HistoryObject.prototype, "fullObject", void 0);
	    HistoryObject = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], HistoryObject);
	    return HistoryObject;
	}(DomainAncestor_1.DomainAncestor));
	exports.HistoryObject = HistoryObject;
	var EventHistory = /** @class */ (function (_super) {
	    tslib_1.__extends(EventHistory, _super);
	    function EventHistory(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.historyObjects)
	            _this.historyObjects = [];
	        if (!_this.emailRecipients)
	            _this.emailRecipients = [];
	        if (!_this.documents)
	            _this.documents = [];
	        return _this;
	    }
	    EventHistory.prototype.getId = function () {
	        return this.eventHistoryId;
	    };
	    EventHistory.prototype.setId = function (id) {
	        this.eventHistoryId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventHistory.prototype, "eventHistoryId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventHistory.prototype, "entityId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventHistory.prototype, "entityName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventHistory.prototype, "eventCategory", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventHistory.prototype, "eventType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(HistoryObject)
	    ], EventHistory.prototype, "historyObjects", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(EmailRecipient)
	    ], EventHistory.prototype, "emailRecipients", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventHistory.prototype, "emailFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventHistory.prototype, "emailSubject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventHistory.prototype, "emailBody", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventHistory.prototype, "message", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventHistory.prototype, "toNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(SmsMessage)
	    ], EventHistory.prototype, "smsMessage", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(SmsMessage)
	    ], EventHistory.prototype, "viberMessage", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(documentDomain_1.Document)
	    ], EventHistory.prototype, "documents", void 0);
	    EventHistory = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], EventHistory);
	    return EventHistory;
	}(DomainAncestor_1.DomainAncestor));
	exports.EventHistory = EventHistory;
	var ActivityConfig = /** @class */ (function (_super) {
	    tslib_1.__extends(ActivityConfig, _super);
	    function ActivityConfig(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.tenantGroups)
	            _this.tenantGroups = [];
	        if (!_this.tenants)
	            _this.tenants = [];
	        if (!_this.gridLocations)
	            _this.gridLocations = [];
	        return _this;
	    }
	    ActivityConfig.prototype.getId = function () {
	        return this.activityConfigId;
	    };
	    ActivityConfig.prototype.setId = function (id) {
	        this.activityConfigId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityConfig.prototype, "activityConfigId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityConfig.prototype, "activityName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityConfig.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityConfig.prototype, "activityType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityConfig.prototype, "activityCategory", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityConfig.prototype, "rootEntity", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityConfig.prototype, "tenantGroups", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityConfig.prototype, "tenants", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityConfig.prototype, "gridLocations", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityConfig.prototype, "location", void 0);
	    ActivityConfig = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ActivityConfig);
	    return ActivityConfig;
	}(DomainAncestor_1.DomainAncestor));
	exports.ActivityConfig = ActivityConfig;
	var ActivityTemplate = /** @class */ (function (_super) {
	    tslib_1.__extends(ActivityTemplate, _super);
	    function ActivityTemplate(json) {
	        return _super.call(this, json) || this;
	    }
	    ActivityTemplate.prototype.fromJson = function (json) {
	        _super.prototype.fromJson.call(this, json, "resources");
	        if (!this.resources)
	            this.resources = new mobx_1.ObservableMap();
	        return this;
	    };
	    // musi zmenit klic mapy dle jmena uvnitr
	    ActivityTemplate.prototype.prepareForServer = function () {
	        this.resources = mobx_1.observable.map(this.resources.values().reduce(function (acc, value) {
	            acc[value.name] = value;
	            return acc;
	        }, {}));
	        return _super.prototype.prepareForServer.call(this);
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplate.prototype, "activityConfig", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplate.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplate.prototype, "validFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplate.prototype, "validTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplate.prototype, "language", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplate.prototype, "profitCenter", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplate.prototype, "defaultEmailSubject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplate.prototype, "defaultEmailBody", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplate.prototype, "templateIndex", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplate.prototype, "emailFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplate.prototype, "replyTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplate.prototype, "cc", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplate.prototype, "bcc", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplate.prototype, "toAddress", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplate.prototype, "activityPaths", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplate.prototype, "backOfficeEmail", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplate.prototype, "defaultEmailDesign", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(documentDomain_1.DocumentTemplateResource)
	    ], ActivityTemplate.prototype, "resources", void 0);
	    ActivityTemplate = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ActivityTemplate);
	    return ActivityTemplate;
	}(DomainAncestor_1.DomainAncestor));
	exports.ActivityTemplate = ActivityTemplate;
	var PartyActivityObject = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyActivityObject, _super);
	    function PartyActivityObject(json) {
	        return _super.call(this, json) || this;
	    }
	    PartyActivityObject.prototype.getId = function () {
	        return this.partyActivityObjectId;
	    };
	    PartyActivityObject.prototype.setId = function (id) {
	        this.partyActivityObjectId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyActivityObject.prototype, "partyActivityObjectId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyActivityObject.prototype, "partyActivity", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyActivityObject.prototype, "entityId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyActivityObject.prototype, "entityName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyActivityObject.prototype, "fullObject", void 0);
	    PartyActivityObject = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], PartyActivityObject);
	    return PartyActivityObject;
	}(DomainAncestor_1.DomainAncestor));
	exports.PartyActivityObject = PartyActivityObject;
	var toEmailAddress = function (emailRecipients) { return (emailRecipients) ? emailRecipients.filter(function (er) { return er.recipientType === RECIPIENTTYPE.TO; }).map(function (er) { return er.emailAddress; }) : []; };
	exports.toEmailAddress = toEmailAddress;
	var ccEmailAddress = function (emailRecipients) { return (emailRecipients) ? emailRecipients.filter(function (er) { return er.recipientType === RECIPIENTTYPE.CC; }).map(function (er) { return er.emailAddress; }) : []; };
	exports.ccEmailAddress = ccEmailAddress;
	var bccEmailAddress = function (emailRecipients) { return (emailRecipients) ? emailRecipients.filter(function (er) { return er.recipientType === RECIPIENTTYPE.BCC; }).map(function (er) { return er.emailAddress; }) : []; };
	exports.bccEmailAddress = bccEmailAddress;
	var PartyActivity = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyActivity, _super);
	    function PartyActivity(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.emailRecipients)
	            _this.emailRecipients = [];
	        if (!_this.objects)
	            _this.objects = [];
	        return _this;
	    }
	    PartyActivity.prototype.getId = function () {
	        return this.partyActivityId;
	    };
	    PartyActivity.prototype.setId = function (id) {
	        this.partyActivityId = id;
	    };
	    PartyActivity.prototype.getTo = function () {
	        return (0, exports.toEmailAddress)(this.emailRecipients);
	    };
	    PartyActivity.prototype.getCc = function () {
	        return (0, exports.ccEmailAddress)(this.emailRecipients);
	    };
	    PartyActivity.prototype.getBcc = function () {
	        return (0, exports.bccEmailAddress)(this.emailRecipients);
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyActivity.prototype, "partyActivityId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyActivity.prototype, "businessDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyActivity.prototype, "activityConfig", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyActivity.prototype, "activityType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyActivity.prototype, "activityCategory", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyActivity.prototype, "customer", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyActivity.prototype, "persons", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(PartyActivityObject)
	    ], PartyActivity.prototype, "objects", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyActivity.prototype, "emailSubject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyActivity.prototype, "emailBody", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyActivity.prototype, "emailFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyActivity.prototype, "replyTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyActivity.prototype, "activitySent", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(EmailRecipient)
	    ], PartyActivity.prototype, "emailRecipients", void 0);
	    PartyActivity = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], PartyActivity);
	    return PartyActivity;
	}(DomainAncestor_1.DomainAncestor));
	exports.PartyActivity = PartyActivity;
	var EntityStatus = /** @class */ (function (_super) {
	    tslib_1.__extends(EntityStatus, _super);
	    function EntityStatus(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityStatus.prototype, "entityObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityStatus.prototype, "messages", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityStatus.prototype, "emails", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityStatus.prototype, "status", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityStatus.prototype, "partyActivity", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityStatus.prototype, "operation", void 0);
	    return EntityStatus;
	}(DomainAncestor_1.DomainAncestor));
	exports.EntityStatus = EntityStatus;
	var GridActivityDto = /** @class */ (function (_super) {
	    tslib_1.__extends(GridActivityDto, _super);
	    function GridActivityDto(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridActivityDto.prototype, "activityConfigId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridActivityDto.prototype, "gridId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridActivityDto.prototype, "type", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridActivityDto.prototype, "subjectTemplate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridActivityDto.prototype, "bodyTemplate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(EntityStatus)
	    ], GridActivityDto.prototype, "statuses", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridActivityDto.prototype, "gridParams", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridActivityDto.prototype, "part", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridActivityDto.prototype, "showErrors", void 0);
	    return GridActivityDto;
	}(DomainAncestor_1.DomainAncestor));
	exports.GridActivityDto = GridActivityDto;
	var TaskDto = /** @class */ (function (_super) {
	    tslib_1.__extends(TaskDto, _super);
	    function TaskDto(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.statuses)
	            _this.statuses = [];
	        return _this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskDto.prototype, "type", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskDto.prototype, "taskType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskDto.prototype, "subjectTemplate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskDto.prototype, "bodyTemplate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskDto.prototype, "scheduledDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(EntityStatus)
	    ], TaskDto.prototype, "statuses", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskDto.prototype, "$scheduledDateError", void 0);
	    return TaskDto;
	}(DomainAncestor_1.DomainAncestor));
	exports.TaskDto = TaskDto;
	var TaskNote = /** @class */ (function (_super) {
	    tslib_1.__extends(TaskNote, _super);
	    function TaskNote(json) {
	        return _super.call(this, json) || this;
	    }
	    TaskNote.prototype.getId = function () {
	        return this.taskNoteId;
	    };
	    TaskNote.prototype.setId = function (id) {
	        this.taskNoteId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskNote.prototype, "taskNoteId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskNote.prototype, "content", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskNote.prototype, "task", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskNote.prototype, "closingNote", void 0);
	    TaskNote = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], TaskNote);
	    return TaskNote;
	}(DomainAncestor_1.DomainAncestor));
	exports.TaskNote = TaskNote;
	var TaskObject = /** @class */ (function (_super) {
	    tslib_1.__extends(TaskObject, _super);
	    function TaskObject(json) {
	        return _super.call(this, json) || this;
	    }
	    TaskObject.prototype.getId = function () {
	        return this.taskObjectId;
	    };
	    TaskObject.prototype.setId = function (id) {
	        this.taskObjectId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskObject.prototype, "taskObjectId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskObject.prototype, "task", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskObject.prototype, "entityId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskObject.prototype, "entityName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskObject.prototype, "fullObject", void 0);
	    TaskObject = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], TaskObject);
	    return TaskObject;
	}(DomainAncestor_1.DomainAncestor));
	exports.TaskObject = TaskObject;
	var Task = /** @class */ (function (_super) {
	    tslib_1.__extends(Task, _super);
	    function Task(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.notes)
	            _this.notes = [];
	        if (!_this.persons)
	            _this.persons = [];
	        if (!_this.partyActivities)
	            _this.partyActivities = [];
	        if (!_this.objects)
	            _this.objects = [];
	        return _this;
	    }
	    Task.prototype.getId = function () {
	        return this.taskId;
	    };
	    Task.prototype.setId = function (id) {
	        this.taskId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Task.prototype, "taskId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Task.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Task.prototype, "scheduledDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Task.prototype, "activityConfig", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Task.prototype, "taskType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Task.prototype, "taskStatus", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Task.prototype, "customer", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Task.prototype, "owner", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Task.prototype, "closingDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(TaskNote)
	    ], Task.prototype, "notes", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(PartyActivity)
	    ], Task.prototype, "partyActivities", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(TaskObject)
	    ], Task.prototype, "objects", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Task.prototype, "persons", void 0);
	    Task = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)(undefined, "taskDetail")
	    ], Task);
	    return Task;
	}(DomainAncestor_1.DomainAncestor));
	exports.Task = Task;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.routes = exports.PAGE = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_router_1 = __webpack_require__(65);
	var metaConstant_1 = __webpack_require__(13);
	var application_1 = tslib_1.__importDefault(__webpack_require__(2049));
	var home_1 = tslib_1.__importDefault(__webpack_require__(2058));
	var customerList_1 = tslib_1.__importDefault(__webpack_require__(2167));
	var contactPersonList_1 = tslib_1.__importDefault(__webpack_require__(2166));
	var salesRepList_1 = tslib_1.__importDefault(__webpack_require__(2172));
	var partyList_1 = tslib_1.__importDefault(__webpack_require__(2171));
	var partyDetail_1 = tslib_1.__importDefault(__webpack_require__(2170));
	var issuedInvoiceList_1 = tslib_1.__importDefault(__webpack_require__(2158));
	var invoiceDetail_1 = tslib_1.__importDefault(__webpack_require__(2154));
	var vehicleList_1 = tslib_1.__importDefault(__webpack_require__(2185));
	var vehicleDetail_1 = tslib_1.__importDefault(__webpack_require__(2184));
	var productList_1 = tslib_1.__importDefault(__webpack_require__(2183));
	var productDetail_1 = tslib_1.__importDefault(__webpack_require__(2182));
	var priceComponentList_1 = tslib_1.__importDefault(__webpack_require__(2181));
	var priceComponentDetail_1 = tslib_1.__importDefault(__webpack_require__(2180));
	var userList_1 = tslib_1.__importDefault(__webpack_require__(2129));
	var userDetail_1 = tslib_1.__importDefault(__webpack_require__(2127));
	var userProfile_1 = tslib_1.__importDefault(__webpack_require__(2130));
	var setPassword_1 = tslib_1.__importDefault(__webpack_require__(2126));
	var securityRoleList_1 = tslib_1.__importDefault(__webpack_require__(2125));
	var securityRoleDetail_1 = tslib_1.__importDefault(__webpack_require__(2124));
	var loginPage_1 = tslib_1.__importDefault(__webpack_require__(2123));
	var entityList_1 = tslib_1.__importDefault(__webpack_require__(2115));
	var entityDetail_1 = tslib_1.__importDefault(__webpack_require__(2113));
	var entityFieldDetail_1 = tslib_1.__importDefault(__webpack_require__(2114));
	var jobList_1 = tslib_1.__importDefault(__webpack_require__(2108));
	var jobDetail_1 = tslib_1.__importDefault(__webpack_require__(2106));
	var gridLocationList_1 = tslib_1.__importDefault(__webpack_require__(2104));
	var gridLocationDetail_1 = tslib_1.__importDefault(__webpack_require__(2102));
	var gridConfigDetail_1 = tslib_1.__importDefault(__webpack_require__(2101));
	var gridSpecialConditionDetail_1 = tslib_1.__importDefault(__webpack_require__(2105));
	var documentTypeList_1 = tslib_1.__importDefault(__webpack_require__(2073));
	var documentTypeDetail_1 = tslib_1.__importDefault(__webpack_require__(2072));
	var documentTemplateDetail_1 = tslib_1.__importDefault(__webpack_require__(2071));
	var eventTypeList_1 = tslib_1.__importDefault(__webpack_require__(2090));
	var eventTypeDetail_1 = tslib_1.__importDefault(__webpack_require__(2089));
	var eventTemplateDetail_1 = tslib_1.__importDefault(__webpack_require__(2088));
	var gridAdminView_1 = tslib_1.__importDefault(__webpack_require__(2094));
	var responsiveTest_1 = tslib_1.__importDefault(__webpack_require__(2044));
	var serverOverview_1 = tslib_1.__importDefault(__webpack_require__(2045));
	var activityConfigList_1 = tslib_1.__importDefault(__webpack_require__(2075));
	var activityConfigDetail_1 = tslib_1.__importDefault(__webpack_require__(2074));
	var activityTemplateDetail_1 = tslib_1.__importDefault(__webpack_require__(2077));
	var taskDetail_1 = tslib_1.__importDefault(__webpack_require__(2091));
	var taskList_1 = tslib_1.__importDefault(__webpack_require__(2092));
	var activityList_1 = tslib_1.__importDefault(__webpack_require__(2076));
	var contractDetail_1 = tslib_1.__importDefault(__webpack_require__(2069));
	var contractList_1 = tslib_1.__importDefault(__webpack_require__(2070));
	var referenceList_1 = tslib_1.__importDefault(__webpack_require__(2043));
	var referenceDetail_1 = tslib_1.__importDefault(__webpack_require__(2042));
	var invoiceTemplateList_1 = tslib_1.__importDefault(__webpack_require__(2157));
	var invoiceTemplateDetail_1 = tslib_1.__importDefault(__webpack_require__(2156));
	var certificateList_1 = tslib_1.__importDefault(__webpack_require__(2041));
	var CertificateDetail_1 = tslib_1.__importDefault(__webpack_require__(2040));
	var bankTransactionList_1 = tslib_1.__importDefault(__webpack_require__(2038));
	var addressPlacestList_1 = tslib_1.__importDefault(__webpack_require__(2165));
	var shipmentOutgoingList_1 = tslib_1.__importDefault(__webpack_require__(2251));
	var shipmentIncomingList_1 = tslib_1.__importDefault(__webpack_require__(2250));
	var shipmentDetail_1 = tslib_1.__importDefault(__webpack_require__(2249));
	var shipmentRepackagingList_1 = tslib_1.__importDefault(__webpack_require__(2253));
	var shipmentRepackagingDetail_1 = tslib_1.__importDefault(__webpack_require__(2252));
	var shipmentVisitList_1 = tslib_1.__importDefault(__webpack_require__(2256));
	var shipmentVisitDetail_1 = tslib_1.__importDefault(__webpack_require__(2255));
	var supplierList_1 = tslib_1.__importDefault(__webpack_require__(2173));
	var eventList_1 = tslib_1.__importDefault(__webpack_require__(2087));
	var shipmentReport_1 = tslib_1.__importDefault(__webpack_require__(2254));
	var invoiceReport_1 = tslib_1.__importDefault(__webpack_require__(2155));
	var timeSheetReport_1 = tslib_1.__importDefault(__webpack_require__(2136));
	var gridLocationFieldDetail_1 = tslib_1.__importDefault(__webpack_require__(2103));
	var entityNumberGenGroupList_1 = tslib_1.__importDefault(__webpack_require__(2153));
	var entityNumberGenGroupDetail_1 = tslib_1.__importDefault(__webpack_require__(2152));
	var criteriaList_1 = tslib_1.__importDefault(__webpack_require__(2229));
	var criterionDetail_1 = tslib_1.__importDefault(__webpack_require__(2230));
	var projectsList_1 = tslib_1.__importDefault(__webpack_require__(2239));
	var projectDetail_1 = tslib_1.__importDefault(__webpack_require__(2237));
	var subCriterionDetail_1 = tslib_1.__importDefault(__webpack_require__(2231));
	var projectVersionDetail_1 = tslib_1.__importDefault(__webpack_require__(2238));
	var materialsList_1 = tslib_1.__importDefault(__webpack_require__(2235));
	var energyCarriersList_1 = tslib_1.__importDefault(__webpack_require__(2232));
	var lifespanList_1 = tslib_1.__importDefault(__webpack_require__(2233));
	var roomTypesList_1 = tslib_1.__importDefault(__webpack_require__(2240));
	var materialUsageGroupsList_1 = tslib_1.__importDefault(__webpack_require__(2234));
	var areaList_1 = tslib_1.__importDefault(__webpack_require__(2236));
	var paramKeyList_1 = tslib_1.__importDefault(__webpack_require__(2132));
	var paramKeyDetail_1 = tslib_1.__importDefault(__webpack_require__(2131));
	var haulerList_1 = tslib_1.__importDefault(__webpack_require__(2169));
	var driverList_1 = tslib_1.__importDefault(__webpack_require__(2168));
	var brimMessagesList_1 = tslib_1.__importDefault(__webpack_require__(2064));
	var pages = [
	    { name: "loginPage", path: "login", module: metaConstant_1.MODULE.core, handler: loginPage_1.default },
	    { name: "entityList", path: "core/entity/:gridId?", module: metaConstant_1.MODULE.core, handler: entityList_1.default },
	    { name: "entityDetail", path: "core/entity/detail/:id", module: metaConstant_1.MODULE.core, handler: entityDetail_1.default },
	    { name: "entityFieldDetail", path: "core/entity/field/:id", module: metaConstant_1.MODULE.core, handler: entityFieldDetail_1.default },
	    { name: "gridLocationList", path: "core/grid-location/:gridId?", module: metaConstant_1.MODULE.core, handler: gridLocationList_1.default },
	    { name: "gridLocationDetail", path: "core/grid-location/detail/:id?", module: metaConstant_1.MODULE.core, handler: gridLocationDetail_1.default },
	    { name: "gridConfigDetail", path: "core/grid-config/detail/:id", module: metaConstant_1.MODULE.core, handler: gridConfigDetail_1.default },
	    { name: "gridSpecialConditionDetail", path: "core/grid-special-condition/:id", module: metaConstant_1.MODULE.core, handler: gridSpecialConditionDetail_1.default },
	    { name: "gridLocationFieldDetail", path: "core/grid-location/field/:id", module: metaConstant_1.MODULE.core, handler: gridLocationFieldDetail_1.default },
	    { name: "documentTypeList", path: "core/document-type/grid/:gridId?", module: metaConstant_1.MODULE.core, handler: documentTypeList_1.default },
	    { name: "documentTypeDetail", path: "core/document-type/detail/:id", module: metaConstant_1.MODULE.core, handler: documentTypeDetail_1.default },
	    { name: "documentTemplateDetail", path: "core/document-type/template/:id", module: metaConstant_1.MODULE.core, handler: documentTemplateDetail_1.default },
	    { name: "eventTypeList", path: "core/event-type/grid/:gridId?", module: metaConstant_1.MODULE.core, handler: eventTypeList_1.default },
	    { name: "eventTypeDetail", path: "core/event-type/detail/:id", module: metaConstant_1.MODULE.core, handler: eventTypeDetail_1.default },
	    { name: "eventTemplateDetail", path: "core/event-type/template/:id", module: metaConstant_1.MODULE.core, handler: eventTemplateDetail_1.default },
	    { name: "activityConfigList", path: "core/activity-config/grid/:gridId?", module: metaConstant_1.MODULE.core, handler: activityConfigList_1.default },
	    { name: "activityConfigDetail", path: "core/activity-config/detail/:id", module: metaConstant_1.MODULE.core, handler: activityConfigDetail_1.default },
	    { name: "activityTemplateDetail", path: "core/activity-config/template/:id", module: metaConstant_1.MODULE.core, handler: activityTemplateDetail_1.default },
	    { name: "activityList", path: "activity/grid/:gridId?", module: metaConstant_1.MODULE.core, handler: activityList_1.default },
	    { name: "eventList", path: "event/grid/:gridId?", module: metaConstant_1.MODULE.core, handler: eventList_1.default },
	    { name: "taskList", path: "task/grid/:gridId?", module: metaConstant_1.MODULE.core, handler: taskList_1.default },
	    { name: "taskDetail", path: "task/detail/:id", module: metaConstant_1.MODULE.core, handler: taskDetail_1.default },
	    { name: "contractList", path: "contract/grid/:gridId?", module: metaConstant_1.MODULE.core, handler: contractList_1.default },
	    { name: "contractDetail", path: "contract/detail/:id", module: metaConstant_1.MODULE.core, handler: contractDetail_1.default },
	    { name: "jobList", path: "core/job/:gridId?", module: metaConstant_1.MODULE.core, handler: jobList_1.default },
	    { name: "jobDetail", path: "core/job/detail/:id", module: metaConstant_1.MODULE.core, handler: jobDetail_1.default },
	    { name: "partyCustomers", path: "party/grid/customer/:gridId?", module: metaConstant_1.MODULE.party, handler: customerList_1.default },
	    { name: "partyContacts", path: "party/grid/contact-person/:gridId?", module: metaConstant_1.MODULE.party, handler: contactPersonList_1.default },
	    { name: "partySalesReps", path: "party/grid/sales-rep/:gridId?", module: metaConstant_1.MODULE.party, handler: salesRepList_1.default },
	    { name: "partySuppliers", path: "party/grid/supplier/:gridId?", module: metaConstant_1.MODULE.party, handler: supplierList_1.default },
	    { name: "partyHaulers", path: "party/grid/hauler/:gridId?", module: metaConstant_1.MODULE.party, handler: haulerList_1.default },
	    { name: "partyDrivers", path: "party/grid/driver/:gridId?", module: metaConstant_1.MODULE.party, handler: driverList_1.default },
	    { name: "partyAll", path: "party/grid/all/:gridId?", module: metaConstant_1.MODULE.party, handler: partyList_1.default },
	    { name: "partyDetail", path: "party/detail/:id", module: metaConstant_1.MODULE.party, handler: partyDetail_1.default },
	    { name: "addressPlacesList", path: "party/address-places/:id", module: metaConstant_1.MODULE.party, handler: addressPlacestList_1.default },
	    { name: "issuedInvoiceList", path: "issued-invoice/grid/:gridId?", module: metaConstant_1.MODULE.invoicing, handler: issuedInvoiceList_1.default },
	    { name: "invoiceTemplateList", path: "invoice-template/grid/:gridId?", module: metaConstant_1.MODULE.invoicing, handler: invoiceTemplateList_1.default },
	    { name: "invoiceDetail", path: "invoice/detail/:id", module: metaConstant_1.MODULE.invoicing, handler: invoiceDetail_1.default },
	    { name: "invoiceTemplateDetail", path: "invoice-template/detail/:id", module: metaConstant_1.MODULE.invoicing, handler: invoiceTemplateDetail_1.default },
	    { name: "invoiceReport", path: "invoice-report/grid/:gridId?", module: metaConstant_1.MODULE.invoicing, handler: invoiceReport_1.default },
	    { name: "entityNumberGenGroupList", path: "entity-number-gen-group/grid/:gridId?", module: metaConstant_1.MODULE.invoicing, handler: entityNumberGenGroupList_1.default },
	    { name: "entityNumberGenGroupDetail", path: "entity-number-gen-group/detail/:id", module: metaConstant_1.MODULE.invoicing, handler: entityNumberGenGroupDetail_1.default },
	    { name: "bankTransactionList", path: "bank-transaction-account/grid/:id/:gridId?", module: metaConstant_1.MODULE.accounting, handler: bankTransactionList_1.default },
	    { name: "vehicleList", path: "vehicle/grid/:gridId?", module: metaConstant_1.MODULE.product, handler: vehicleList_1.default },
	    { name: "vehicleDetail", path: "vehicle/detail/:id", module: metaConstant_1.MODULE.product, handler: vehicleDetail_1.default },
	    { name: "brimMessageList", path: "brim-messages/grid/:gridId?", module: metaConstant_1.MODULE.product, handler: brimMessagesList_1.default },
	    { name: "productList", path: "product/grid/:gridId?", module: metaConstant_1.MODULE.product, handler: productList_1.default },
	    { name: "productDetail", path: "product/detail/:id", module: metaConstant_1.MODULE.product, handler: productDetail_1.default },
	    { name: "priceComponentList", path: "price/grid/:gridId?", module: metaConstant_1.MODULE.product, handler: priceComponentList_1.default },
	    { name: "priceComponentDetail", path: "price/detail/:id", module: metaConstant_1.MODULE.product, handler: priceComponentDetail_1.default },
	    { name: "shipmentOutgoingList", path: "shipment-outgoing/grid/:gridId?", module: metaConstant_1.MODULE.shipment, handler: shipmentOutgoingList_1.default },
	    { name: "shipmentIncomingList", path: "shipment-incoming/grid/:gridId?", module: metaConstant_1.MODULE.shipment, handler: shipmentIncomingList_1.default },
	    { name: "shipmentDetail", path: "shipment/detail/:id", module: metaConstant_1.MODULE.shipment, handler: shipmentDetail_1.default },
	    { name: "shipmentRepackagingList", path: "shipment-repackaging/grid/:gridId?", module: metaConstant_1.MODULE.shipment, handler: shipmentRepackagingList_1.default },
	    { name: "shipmentRepackagingDetail", path: "shipment-repackaging/detail/:id", module: metaConstant_1.MODULE.shipment, handler: shipmentRepackagingDetail_1.default },
	    { name: "shipmentVisitList", path: "shipment-visit/grid/:gridId?", module: metaConstant_1.MODULE.shipment, handler: shipmentVisitList_1.default },
	    { name: "shipmentVisitDetail", path: "shipment-visit/detail/:id", module: metaConstant_1.MODULE.shipment, handler: shipmentVisitDetail_1.default },
	    { name: "shipmentReport", path: "shipment-report/grid/:gridId?", module: metaConstant_1.MODULE.shipment, handler: shipmentReport_1.default },
	    { name: "timeSheetReport", path: "time-sheet-report/grid/:gridId?", module: metaConstant_1.MODULE.humanresource, handler: timeSheetReport_1.default },
	    { name: "userList", path: "user/grid/:gridId?", module: metaConstant_1.MODULE.core, handler: userList_1.default },
	    { name: "userDetail", path: "user/detail/:id", module: metaConstant_1.MODULE.core, handler: userDetail_1.default },
	    { name: "userProfile", path: "user/profile/:tab?", module: metaConstant_1.MODULE.core, handler: userProfile_1.default },
	    { name: "setPassword", path: "user/set-password/:mode/:id?", module: metaConstant_1.MODULE.core, handler: setPassword_1.default },
	    { name: "securityRoleList", path: "security-role/grid/:gridId?", module: metaConstant_1.MODULE.core, handler: securityRoleList_1.default },
	    { name: "securityRoleDetail", path: "security-role/detail/:id", module: metaConstant_1.MODULE.core, handler: securityRoleDetail_1.default },
	    { name: "serverOverview", path: "administration/server/:tab?", module: metaConstant_1.MODULE.core, handler: serverOverview_1.default },
	    { name: "referenceList", path: "administration/reference-list", module: metaConstant_1.MODULE.core, handler: referenceList_1.default },
	    { name: "referenceDetail", path: "administration/reference-detail/:id/:gridId?", module: metaConstant_1.MODULE.core, handler: referenceDetail_1.default },
	    { name: "certificateList", path: "administration/certificate/grid/:gridId?", module: metaConstant_1.MODULE.core, handler: certificateList_1.default },
	    { name: "certificateDetail", path: "administration/certificate/detail/:id", module: metaConstant_1.MODULE.core, handler: CertificateDetail_1.default },
	    { name: "gridAdmin", path: "core/grid/admin/:gridLocation/:gridId?", module: metaConstant_1.MODULE.core, handler: gridAdminView_1.default },
	    { name: "responsiveTest", path: "administration/responsive-test", module: metaConstant_1.MODULE.core, handler: responsiveTest_1.default },
	    { name: "sbToolCriteriaList", path: "sbtool/criteria-page/grid/:gridId?", module: metaConstant_1.MODULE.sbtool, handler: criteriaList_1.default },
	    { name: "sbToolCriteriaDetail", path: "sbtool/criteria-page/detail/:id", module: metaConstant_1.MODULE.sbtool, handler: criterionDetail_1.default },
	    { name: "sbToolSubCriterionDetail", path: "sbtool/sub-criteria-page/detail/:id", module: metaConstant_1.MODULE.sbtool, handler: subCriterionDetail_1.default },
	    { name: "sbToolProjectsList", path: "sbtool/projects-page/grid/:gridId?", module: metaConstant_1.MODULE.sbtool, handler: projectsList_1.default },
	    { name: "sbToolProjectDetail", path: "sbtool/projects-page/detail/:id", module: metaConstant_1.MODULE.sbtool, handler: projectDetail_1.default },
	    { name: "sbToolProjectVersionDetail", path: "sbtool/project-versions-page/detail/:id", module: metaConstant_1.MODULE.sbtool, handler: projectVersionDetail_1.default },
	    { name: "sbToolMaterialsList", path: "sbtool/materials-page/grid/:gridId?", module: metaConstant_1.MODULE.sbtool, handler: materialsList_1.default },
	    { name: "sbToolEnergyCarriersList", path: "sbtool/energy-carriers-page/grid/:gridId?", module: metaConstant_1.MODULE.sbtool, handler: energyCarriersList_1.default },
	    { name: "sbToolLifespanList", path: "sbtool/lifespan-page/grid/:gridId?", module: metaConstant_1.MODULE.sbtool, handler: lifespanList_1.default },
	    { name: "sbToolRoomTypeList", path: "sbtool/room-types-page/grid/:gridId?", module: metaConstant_1.MODULE.sbtool, handler: roomTypesList_1.default },
	    { name: "sbToolMaterialUsageGroupList", path: "sbtool/material-usage-groups-page/grid/:gridId?", module: metaConstant_1.MODULE.sbtool, handler: materialUsageGroupsList_1.default },
	    { name: "sbToolAreaList", path: "sbtool/areas-page/grid/:gridId?", module: metaConstant_1.MODULE.sbtool, handler: areaList_1.default },
	    { name: "paramKeyList", path: "param-key/grid/:gridId?", module: metaConstant_1.MODULE.core, handler: paramKeyList_1.default },
	    { name: "paramKeyDetail", path: "param-key/detail/:id", module: metaConstant_1.MODULE.core, handler: paramKeyDetail_1.default },
	];
	exports.PAGE = pages.reduce(function (acc, value) {
	    value.type = metaConstant_1.SECURABLE_TYPE.PAGE;
	    acc[value.name] = value;
	    return acc;
	}, {});
	exports.routes = (react_1.default.createElement(react_router_1.Route, { path: "/", handler: application_1.default },
	    react_1.default.createElement(react_router_1.DefaultRoute, { name: "home", handler: home_1.default }),
	    pages.map(function (page, index) { return react_1.default.createElement(react_router_1.Route, { key: index, name: page.name, path: page.path, handler: page.handler }); })));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Dialog = __webpack_require__(1514);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Dialog2.default;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentAdd = function ContentAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z' })
	  );
	};
	ContentAdd = (0, _pure2.default)(ContentAdd);
	ContentAdd.displayName = 'ContentAdd';
	ContentAdd.muiName = 'SvgIcon';
	
	exports.default = ContentAdd;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.moveItem = moveItem;
	exports.removeItem = removeItem;
	exports.joinNonNull = joinNonNull;
	exports.addSeparator = addSeparator;
	exports.addSeparatorBetweenArrays = addSeparatorBetweenArrays;
	exports.areArraysEqual = areArraysEqual;
	exports.toArray = toArray;
	exports.notEmpty = notEmpty;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var mobx_1 = __webpack_require__(5);
	function moveItem(array, old_index, new_index) {
	    if (new_index >= array.length) {
	        var k = new_index - array.length;
	        while ((k--) + 1) {
	            array.push(undefined);
	        }
	    }
	    array.splice(new_index, 0, array.splice(old_index, 1)[0]);
	}
	function removeItem(array, item) {
	    if (array) {
	        var indexOf = array.indexOf(item);
	        if (indexOf !== -1) {
	            array.splice(indexOf, 1);
	        }
	    }
	}
	/**
	 *
	 * @param array
	 * @param separator
	 * @returns {*}
	 */
	function joinNonNull(array, separator) {
	    if (!array || !array.length) {
	        return '';
	    }
	    else {
	        return array.filter(function (v) { return !!v || v === 0; }).join(separator);
	    }
	}
	function addSeparator(array, separator) {
	    if (array && array.length > 1) {
	        var newArray = [array[0]];
	        for (var i = 1; i < array.length; i++) {
	            newArray.push(react_1.default.cloneElement(separator, { key: 'sep' + i }));
	            newArray.push(array[i]);
	        }
	        return newArray;
	    }
	    else {
	        return array;
	    }
	}
	function addSeparatorBetweenArrays(separator) {
	    var arrays = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        arrays[_i - 1] = arguments[_i];
	    }
	    var returnArray;
	    if (!arrays || arrays.length === 0) {
	        returnArray = [];
	    }
	    else if (arrays.length === 1) {
	        returnArray = (arrays[0]) ? arrays[0] : [];
	    }
	    else {
	        var newArray = (arrays[0]) ? arrays[0] : [];
	        for (var i = 1; i < arrays.length; i++) {
	            var oneArray = arrays[i];
	            if (oneArray && oneArray.length) {
	                if (newArray.length)
	                    newArray.push(react_1.default.cloneElement(separator, { key: 'sep' + i }));
	                for (var h = 0; h < oneArray.length; h++) {
	                    newArray.push(oneArray[h]);
	                }
	            }
	        }
	        returnArray = newArray;
	    }
	    return (returnArray && returnArray.length) ? returnArray.filter(function (x) { return x; }) : returnArray;
	}
	function areArraysEqual(a, b) {
	    if (!a || !b)
	        return false;
	    if (a.length != b.length)
	        return false;
	    for (var i = 0, length = a.length; i < length; i++) {
	        if (a[i] != b[i])
	            return false;
	    }
	    return true;
	}
	function toArray(a) {
	    if (a == null) {
	        return [];
	    }
	    else {
	        return ((0, mobx_1.isArrayLike)(a)) ? a : [a];
	    }
	}
	function notEmpty(a) {
	    return (a && !!a.length);
	}


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var events_1 = __webpack_require__(664);
	var CommonService = /** @class */ (function () {
	    function CommonService() {
	        this.emitter = new events_1.EventEmitter();
	    }
	    CommonService.prototype.emit = function (event) {
	        var params = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            params[_i - 1] = arguments[_i];
	        }
	        this.emitter.emit(event, params);
	    };
	    CommonService.prototype.loading = function (isOn) {
	        this.emit("LOADING", isOn);
	    };
	    CommonService.prototype.notifyError = function (message, title, children, autoDismiss) {
	        if (autoDismiss === void 0) { autoDismiss = 5; }
	        if (this.notificationSystem) {
	            this.notificationSystem.addNotification({
	                title: (title) ? title : 'Error',
	                message: message,
	                position: 'tr',
	                autoDismiss: autoDismiss,
	                level: 'error',
	                children: children
	            });
	        }
	    };
	    CommonService.prototype.notifySuccess = function (message, title, children, autoDismiss, position) {
	        if (autoDismiss === void 0) { autoDismiss = 5; }
	        if (position === void 0) { position = 'br'; }
	        if (this.notificationSystem) {
	            this.notificationSystem.addNotification({
	                title: (title) ? title : 'Success',
	                message: message,
	                position: position,
	                autoDismiss: autoDismiss,
	                level: 'success',
	                children: children
	            });
	        }
	    };
	    CommonService.prototype.notifyInfo = function (message, title, children, autoDismiss) {
	        if (autoDismiss === void 0) { autoDismiss = 5; }
	        if (this.notificationSystem) {
	            this.notificationSystem.addNotification({
	                title: (title) ? title : 'Info',
	                message: message,
	                position: 'br',
	                autoDismiss: autoDismiss,
	                level: 'info',
	                children: children
	            });
	        }
	    };
	    CommonService.prototype.notifyWarning = function (message, title, children, autoDismiss) {
	        if (autoDismiss === void 0) { autoDismiss = 5; }
	        if (this.notificationSystem) {
	            this.notificationSystem.addNotification({
	                title: (title) ? title : 'Warning',
	                message: message,
	                position: 'br',
	                autoDismiss: autoDismiss,
	                level: 'warning',
	                children: children
	            });
	        }
	    };
	    Object.defineProperty(CommonService.prototype, "router", {
	        get: function () {
	            return this._router;
	        },
	        set: function (router) {
	            this._router = router;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return CommonService;
	}());
	var commonService = new CommonService();
	exports.default = commonService;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var DateTimePicker_1 = tslib_1.__importDefault(__webpack_require__(1891));
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var domUtils_1 = __webpack_require__(91);
	__webpack_require__(1274);
	__webpack_require__(1284);
	var StyledDatePicker = /** @class */ (function (_super) {
	    tslib_1.__extends(StyledDatePicker, _super);
	    function StyledDatePicker(props) {
	        var _this = _super.call(this, props) || this;
	        _this.onBlurEvent = function (e) {
	            _this.setState({ focused: false });
	        };
	        _this.onFocusEvent = function (e) {
	            _this.setState({ focused: true });
	        };
	        _this.onChangeWrapper = function (value) {
	            var _a = _this.props, onChange = _a.onChange, time = _a.time;
	            if (onChange) {
	                onChange((!time && value instanceof Date) ? (0, moment_1.default)(value).format("YYYY-MM-DD") : value);
	            }
	        };
	        _this.state = {
	            focused: false
	        };
	        return _this;
	    }
	    StyledDatePicker.prototype.componentDidMount = function () {
	        var _a = this.props, name = _a.name, hintText = _a.hintText, floatingLabelText = _a.floatingLabelText;
	        this._uniqueId = (name + '-' + hintText + '-' + floatingLabelText + '-' + Math.floor(Math.random() * 0xFFFF)).replace(/[^A-Za-z0-9-]/gi, '');
	    };
	    StyledDatePicker.prototype.render = function () {
	        var _a = this.props, defaultValue = _a.defaultValue, value = _a.value, onChange = _a.onChange, onToggle = _a.onToggle, min = _a.min, max = _a.max, calendar = _a.calendar, time = _a.time, step = _a.step, fullWidth = _a.fullWidth, placeholder = _a.placeholder, name = _a.name, autoFocus = _a.autoFocus, style = _a.style, errorText = _a.errorText, floatingLabelStyle = _a.floatingLabelStyle, floatingLabelText = _a.floatingLabelText, id = _a.id, hideCalendar = _a.hideCalendar, format = _a.format, disabled = _a.disabled, other = tslib_1.__rest(_a, ["defaultValue", "value", "onChange", "onToggle", "min", "max", "calendar", "time", "step", "fullWidth", "placeholder", "name", "autoFocus", "style", "errorText", "floatingLabelStyle", "floatingLabelText", "id", "hideCalendar", "format", "disabled"]);
	        // vytvorim date object
	        if (value && !(value instanceof Date)) {
	            value = new Date(value);
	        }
	        var inputId = id || this._uniqueId;
	        var localStyles = {
	            position: 'relative',
	        };
	        if (fullWidth) {
	            localStyles.width = "100%";
	        }
	        var floatingLabelTextElement = floatingLabelText ? (react_1.default.createElement("label", { className: "DatePickerLabel", htmlFor: inputId, style: floatingLabelStyle }, floatingLabelText)) : null;
	        var _classes = (0, domUtils_1.classNames)('StyledDatePicker', {
	            'is-focused': this.state.focused,
	            'is-error': !!errorText,
	            'has-value': (value && (value.toString().length > 0)),
	            'no-calendar': hideCalendar
	        });
	        return (react_1.default.createElement("div", { className: _classes, style: Object.assign(localStyles, style) },
	            floatingLabelTextElement,
	            react_1.default.createElement("div", { style: { position: 'relative', height: '100%' } },
	                react_1.default.createElement(DateTimePicker_1.default, { onFocus: this.onFocusEvent, onBlur: this.onBlurEvent, defaultValue: defaultValue, value: value, onChange: this.onChangeWrapper, onToggle: onToggle, calendar: calendar, time: time, step: step, min: min, max: max, placeholder: placeholder, format: format, disabled: disabled }),
	                react_1.default.createElement("hr", { className: "underscore underscore-grey" }),
	                react_1.default.createElement("hr", { className: "underscore underscore-blue" })),
	            ((errorText) ? (react_1.default.createElement("div", { className: "errorText" }, errorText)) : '')));
	    };
	    StyledDatePicker.defaultProps = {
	        time: false,
	        step: 5,
	    };
	    return StyledDatePicker;
	}(react_1.default.PureComponent));
	exports.default = StyledDatePicker;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var propTypes = {
	  className: _propTypes["default"].string,
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
	};
	
	function Layer(props) {
	  var children = props.children,
	      className = props.className,
	      others = _objectWithoutProperties(props, ["children", "className"]);
	
	  var layerClass = (0, _classnames["default"])('recharts-layer', className);
	  return _react["default"].createElement("g", _extends({
	    className: layerClass
	  }, others), children);
	}
	
	Layer.propTypes = propTypes;
	var _default = Layer;
	exports["default"] = _default;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ClosedFormBlock = exports.ClosedFormField = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_router_1 = __webpack_require__(65);
	var mobx_1 = __webpack_require__(5);
	var formUtils_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(37);
	__webpack_require__(1290);
	var ClosedFormField = function (_a) {
	    var label = _a.label, value = _a.value, mdField = _a.mdField, linkProps = _a.linkProps, style = _a.style, alwaysShow = _a.alwaysShow, children = _a.children;
	    var childrenCount = react_1.default.Children.count(children);
	    return ((childrenCount == 0) ? ((linkProps) ? (react_1.default.createElement(react_router_1.Link, tslib_1.__assign({}, linkProps, { style: style, query: (0, utils_1.addTenantToQuery)(linkProps.query) }),
	        react_1.default.createElement("div", { className: "value-label" }, (0, mobx_1.isArrayLike)(value) ? value.map(function (v) { return (0, formUtils_1.formatValue)(v, mdField); }).join(', ') : (0, formUtils_1.formatValue)(value, mdField)))) : (react_1.default.createElement("div", { className: "value-label" }, (0, mobx_1.isArrayLike)(value) ? value.map(function (v) { return (0, formUtils_1.formatValue)(v, mdField); }).join(', ') : (0, formUtils_1.formatValue)(value, mdField)))) : ((childrenCount == 1) ? (react_1.default.Children.only(children)) : (react_1.default.createElement("div", { className: "value-label" }, children))));
	};
	exports.ClosedFormField = ClosedFormField;
	var ClosedFormBlock = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled, alwaysShow = _a.alwaysShow, singleColumn = _a.singleColumn, children = _a.children;
	    // hack na dva sloupce - cekame na subgridy
	    var childrenArray = react_1.default.Children.toArray(children);
	    var biggerHalf = (singleColumn) ? childrenArray.length : Math.ceil(childrenArray.length / 2);
	    var gridItems1 = [];
	    var gridItems2 = [];
	    react_1.default.Children.forEach(children, function (child, index) {
	        if (child && (child.props.value != null || alwaysShow || child.props.alwaysShow || react_1.default.Children.count(child.props.children) > 0)) {
	            var _gi = (index < biggerHalf) ? gridItems1 : gridItems2;
	            _gi.push((react_1.default.isValidElement(child.props.label)) ? child.props.label :
	                react_1.default.createElement("div", { className: "item-label", key: index },
	                    child.props.label,
	                    ":"));
	            _gi.push(child);
	        }
	    });
	    return (react_1.default.createElement("div", { className: "form-closed-gridgroup" },
	        react_1.default.createElement("div", { className: "form-closed-grid" }, tslib_1.__spreadArray([], gridItems1, true)),
	        (!singleColumn) ? (react_1.default.createElement("div", { className: "form-closed-grid" }, tslib_1.__spreadArray([], gridItems2, true))) : null));
	};
	exports.ClosedFormBlock = ClosedFormBlock;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.GridBulkEntityDto = exports.MovingBlocks = exports.GridComposite = void 0;
	var tslib_1 = __webpack_require__(3);
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var gridComp_1 = __webpack_require__(44);
	var mobx_1 = __webpack_require__(5);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var DomainAncestor_1 = __webpack_require__(33);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var eventDomain_1 = __webpack_require__(74);
	var commonDomain_1 = __webpack_require__(310);
	var GridComposite = /** @class */ (function () {
	    function GridComposite(blockName, label) {
	        var groupMembers = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            groupMembers[_i - 2] = arguments[_i];
	        }
	        this.blockName = blockName;
	        this.label = label;
	        if (groupMembers.length < 1) {
	            throw new Error("There must be at least 1 grid");
	        }
	        this.groupMembers = groupMembers;
	    }
	    GridComposite.prototype.isEditable = function () {
	        return false;
	    };
	    GridComposite.prototype.isClientBlock = function () {
	        return false;
	    };
	    GridComposite.prototype.getBlockName = function () {
	        return this.blockName;
	    };
	    GridComposite.prototype.search = function (dataObject, refresh) {
	        if (refresh === void 0) { refresh = true; }
	        var promises = this.groupMembers.map(function (grid) { return grid.search(dataObject, refresh); });
	        return Promise.all(promises);
	    };
	    Object.defineProperty(GridComposite.prototype, "data", {
	        get: function () {
	            return this.groupMembers[0].data;
	        },
	        set: function (data) {
	        },
	        enumerable: false,
	        configurable: true
	    });
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridComposite.prototype, "$dirty", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridComposite.prototype, "label", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridComposite.prototype, "search", null);
	    return GridComposite;
	}());
	exports.GridComposite = GridComposite;
	var MovingBlocks = /** @class */ (function () {
	    function MovingBlocks(standAloneBlockName, tabbedBlocks, activeBlockTab) {
	        var blocks = [];
	        for (var _i = 3; _i < arguments.length; _i++) {
	            blocks[_i - 3] = arguments[_i];
	        }
	        if (blocks.length < 1) {
	            throw new Error("There must be at least 1 grid");
	        }
	        this.blockArray = blocks;
	        this.standAloneBlockName = standAloneBlockName;
	        this.activeBlockTab = activeBlockTab;
	        this.tabbedBlocks = tabbedBlocks;
	        this.computeDerivedInfo();
	        this.fixActiveTab();
	        // kvuli chainum na subgridech
	        for (var _a = 0, blocks_1 = blocks; _a < blocks_1.length; _a++) {
	            var block = blocks_1[_a];
	            if (block instanceof grid_1.default) {
	                gridService_1.default.gridMap.set(block.gridLocation, block);
	            }
	        }
	    }
	    MovingBlocks.prototype.computeDerivedInfo = function () {
	        var _this = this;
	        this.standAloneBlockIndex = this.blockArray.findIndex(function (g) { return g.getBlockName() === _this.standAloneBlockName; });
	        if (this.standAloneBlockName && this.standAloneBlockIndex === -1) {
	            throw new Error("standAloneBlockName " + this.standAloneBlockName + " not found in blocks");
	        }
	        this.standAloneBlock = this.blockArray.find(function (g) { return g.getBlockName() === _this.standAloneBlockName; });
	        this.prunedBlockArray = this.blockArray.filter(function (g) { return g.getBlockName() !== _this.standAloneBlockName; });
	    };
	    MovingBlocks.prototype.reinit = function (standAloneBlockName, visibleBlockNames) {
	        this.standAloneBlockName = standAloneBlockName;
	        if (!this.hiddenBlocks)
	            this.hiddenBlocks = [];
	        var _loop_1 = function (blockName) {
	            if (!this_1.getBlock(blockName)) {
	                var i = this_1.hiddenBlocks.findIndex(function (b) { return b.getBlockName() === blockName; });
	                if (i >= 0) {
	                    this_1.blockArray.push(this_1.hiddenBlocks[i]);
	                    this_1.hiddenBlocks.splice(i, 1);
	                }
	            }
	        };
	        var this_1 = this;
	        // nejdriv pridame schovane
	        for (var _i = 0, visibleBlockNames_1 = visibleBlockNames; _i < visibleBlockNames_1.length; _i++) {
	            var blockName = visibleBlockNames_1[_i];
	            _loop_1(blockName);
	        }
	        // potom schovame chybejici
	        var newBlockArray = [];
	        for (var _a = 0, _b = this.blockArray; _a < _b.length; _a++) {
	            var block = _b[_a];
	            var h = visibleBlockNames.indexOf(block.getBlockName());
	            if (h === -1) {
	                this.hiddenBlocks.push(block);
	            }
	            else {
	                newBlockArray.push(block);
	            }
	        }
	        this.blockArray = newBlockArray;
	        console.log('MovingBlocks reinit: new visible blocks: %O', this.blockArray.map(function (b) { return b.getBlockName(); }));
	        this.computeDerivedInfo();
	        this.fixActiveTab();
	    };
	    MovingBlocks.prototype.fixActiveTab = function () {
	        var _this = this;
	        var arrayToUse = (uiService_1.default.globalMediaQuery.matches) ? this.prunedBlockArray : this.blockArray;
	        if (this.tabbedBlocks && !arrayToUse.find(function (b) { return b.getBlockName() === _this.activeBlockTab; })) {
	            this.activeBlockTab = (arrayToUse.length) ? arrayToUse[0].getBlockName() : null;
	            console.log("FIXING active tab to " + this.activeBlockTab);
	        }
	    };
	    MovingBlocks.prototype.getBlock = function (blockName) {
	        return this.blockArray.find(function (g) { return g.getBlockName() === blockName; });
	    };
	    MovingBlocks.prototype.getBlockFromPruned = function (blockName) {
	        return this.prunedBlockArray.find(function (g) { return g.getBlockName() === blockName; });
	    };
	    MovingBlocks.prototype.getTabBlocks = function () {
	        return (uiService_1.default.globalMediaQuery.matches) ? this.prunedBlockArray : this.blockArray;
	    };
	    MovingBlocks.prototype.getUiLocation = function (blockName) {
	        return (uiService_1.default.globalMediaQuery.matches && this.standAloneBlockName === blockName) ? gridComp_1.UILOCATION.main_right : gridComp_1.UILOCATION.tab;
	    };
	    MovingBlocks.prototype.getEditedBlocks = function () {
	        var _this = this;
	        return this.blockArray.filter(function (g) { return _this.isEditedBlock(g); });
	    };
	    MovingBlocks.prototype.isEditedBlock = function (block) {
	        return block.isEditable() && block.$dirty;
	    };
	    MovingBlocks.prototype.getGridData = function () {
	        return this.getEditedBlocks().reduce(function (acc, block) {
	            acc[block.getBlockName()] = {
	                deletedRowIds: (block.deletedRowIds) ? Array.from(block.deletedRowIds) : [],
	                editedRows: block.getEditedRows()
	            };
	            return acc;
	        }, {});
	    };
	    /**
	     * Pokud isWide je true, vytrhne z gridCompArray standAloneGrid a vrati ho.  gridCompArray je zmeneno.
	     * @param isWide
	     * @param gridCompArray
	     * @returns {*}
	     */
	    MovingBlocks.prototype.pluckStandAloneBlock = function (gridCompArray) {
	        if (uiService_1.default.globalMediaQuery.matches) {
	            var standAloneGridComp = gridCompArray.splice(this.standAloneBlockIndex, 1)[0];
	            return standAloneGridComp;
	        }
	        return null;
	    };
	    MovingBlocks.prototype.firstTabBlock = function () {
	        return (uiService_1.default.globalMediaQuery.matches && this.standAloneBlockIndex === 0 && this.blockArray.length > 1) ? this.blockArray[1] : this.blockArray[0];
	    };
	    MovingBlocks.prototype.doOnExposedBlocks = function (callback) {
	        if (this.blockArray.length === 1) {
	            return callback(this.blockArray[0]);
	        }
	        // pokud neni nastaven  standAloneBlockName a activeBlockTab nejsou taby => zavolej na vsechny
	        if (!this.standAloneBlockName && !this.activeBlockTab) {
	            var res = void 0;
	            for (var _i = 0, _a = this.blockArray; _i < _a.length; _i++) {
	                var block = _a[_i];
	                res = callback(block) && res;
	            }
	            return res;
	        }
	        if (uiService_1.default.globalMediaQuery.matches) {
	            var secondBlock = this.getBlockFromPruned(this.activeBlockTab);
	            if (!secondBlock)
	                secondBlock = this.prunedBlockArray[0];
	            var res1 = callback(this.standAloneBlock);
	            var res2 = callback(secondBlock);
	            return res1 || res2;
	        }
	        else {
	            var firstBlock = this.getBlock(this.activeBlockTab);
	            if (!firstBlock)
	                firstBlock = this.blockArray[0];
	            return callback(firstBlock);
	        }
	    };
	    MovingBlocks.prototype.isExposed = function (blockName) {
	        if (uiService_1.default.globalMediaQuery.matches) {
	            if (this.standAloneBlockName === blockName)
	                return true;
	            var secondBlock = this.getBlockFromPruned(this.activeBlockTab);
	            if (!secondBlock)
	                secondBlock = this.prunedBlockArray[0];
	            return (secondBlock && secondBlock.getBlockName() === blockName);
	        }
	        else {
	            var firstBlock = this.getBlock(this.activeBlockTab);
	            if (!firstBlock)
	                firstBlock = this.blockArray[0];
	            return (firstBlock && firstBlock.getBlockName() === blockName);
	        }
	    };
	    MovingBlocks.prototype.searchExposedGrids = function (dataObject, force) {
	        if (force === void 0) { force = false; }
	        this.doOnExposedBlocks(function (block) {
	            if (!block.data || force) {
	                block.search(dataObject, true);
	                return true;
	            }
	            else {
	                return false;
	            }
	        });
	    };
	    MovingBlocks.prototype.cleanAfterSave = function (dataObject) {
	        for (var _i = 0, _a = this.blockArray; _i < _a.length; _i++) {
	            var block = _a[_i];
	            if (this.isEditedBlock(block) || block.isClientBlock()) {
	                block.deletedRowIds = new Set();
	                block.$dirty = false;
	                if (block.isClientBlock() || this.isExposed(block.getBlockName())) {
	                    block.search(dataObject, true);
	                }
	                else {
	                    block.data = null;
	                }
	            }
	        }
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MovingBlocks.prototype, "blockArray", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MovingBlocks.prototype, "activeBlockTab", void 0);
	    return MovingBlocks;
	}());
	exports.MovingBlocks = MovingBlocks;
	var GridBulkEntityDto = /** @class */ (function (_super) {
	    tslib_1.__extends(GridBulkEntityDto, _super);
	    function GridBulkEntityDto(json) {
	        return _super.call(this, json) || this;
	    }
	    GridBulkEntityDto.prototype.issuableCount = function () {
	        return (this.entityStatuses && this.entityStatuses.length) ? this.entityStatuses.filter(function (cs) { return cs.status !== commonDomain_1.SEVERITY.ERROR; }).length : 0;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(eventDomain_1.EntityStatus)
	    ], GridBulkEntityDto.prototype, "entityStatuses", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridBulkEntityDto.prototype, "gridParams", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridBulkEntityDto.prototype, "part", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridBulkEntityDto.prototype, "count", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridBulkEntityDto.prototype, "showErrors", void 0);
	    return GridBulkEntityDto;
	}(DomainAncestor_1.DomainAncestor));
	exports.GridBulkEntityDto = GridBulkEntityDto;


/***/ }),
/* 84 */,
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var DOMProperty = __webpack_require__(246);
	var ReactDOMComponentFlags = __webpack_require__(827);
	
	var invariant = __webpack_require__(28);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/* todo: I want this to actually be an array of Function | string but that causes errors */
	if (true) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_StyleSheet", {
	  value: __webpack_require__(2).shape({
	    create: __webpack_require__(2).func.isRequired
	  })
	});
	
	/* eslint-disable no-undef */

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SteppingDialogAncestor = exports.DialogAncestor = void 0;
	exports.entityStatusCss = entityStatusCss;
	exports.entityStatusText = entityStatusText;
	exports.validationMessageCss = validationMessageCss;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var mobx_1 = __webpack_require__(5);
	var commonDomain_1 = __webpack_require__(310);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var LinearProgress_1 = tslib_1.__importDefault(__webpack_require__(490));
	var __progressBarStyleOverride = {
	    height: 2,
	    width: "100%",
	    backgroundColor: "white"
	};
	var DialogAncestor = /** @class */ (function (_super) {
	    tslib_1.__extends(DialogAncestor, _super);
	    function DialogAncestor() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.dialogOpen = false;
	        return _this;
	    }
	    DialogAncestor.prototype.hasErrors = function () {
	        return this.$errors && this.$errors.length > 0;
	    };
	    DialogAncestor.prototype.titleWithProgress = function (titleStr) {
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", null, titleStr),
	            (uiService_1.default.getDialogActionFlag()) ? react_1.default.createElement(LinearProgress_1.default, { mode: "indeterminate", style: __progressBarStyleOverride }) : react_1.default.createElement("div", { style: __progressBarStyleOverride })));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DialogAncestor.prototype, "dialogOpen", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DialogAncestor.prototype, "$errors", void 0);
	    return DialogAncestor;
	}(react_1.default.Component));
	exports.DialogAncestor = DialogAncestor;
	var SteppingDialogAncestor = /** @class */ (function (_super) {
	    tslib_1.__extends(SteppingDialogAncestor, _super);
	    function SteppingDialogAncestor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return SteppingDialogAncestor;
	}(DialogAncestor));
	exports.SteppingDialogAncestor = SteppingDialogAncestor;
	function entityStatusCss(entityStatus) {
	    return (entityStatus.status === commonDomain_1.SEVERITY.ERROR) ? "color-red-500" :
	        ((entityStatus.status === commonDomain_1.SEVERITY.WARNING) ? "color-amber-600" :
	            ((entityStatus.status === commonDomain_1.SEVERITY.NOOP) ? "color-grey-500" : "color-green-500"));
	}
	function entityStatusText(entityStatus) {
	    return (!entityStatus.status || entityStatus.status === commonDomain_1.SEVERITY.INFO) ? "OK" :
	        ((entityStatus.status === commonDomain_1.SEVERITY.NOOP) ? "UNMODIFIED" : entityStatus.status);
	}
	function validationMessageCss(validationMessage) {
	    return (validationMessage.severity === commonDomain_1.SEVERITY.ERROR) ? "color-red-500" :
	        ((validationMessage.severity === commonDomain_1.SEVERITY.WARNING) ? "color-amber-600" :
	            ((validationMessage.severity === commonDomain_1.SEVERITY.INFO) ? "color-blue-500" : null));
	}


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var TextField_1 = tslib_1.__importDefault(__webpack_require__(186));
	var numberUtils_1 = __webpack_require__(143);
	/**
	 * Requirement is to show number formated if unfocused and unformated if focused,
	 * that is to format number on onBlur and deformat on onFocus.
	 * props's onChange is called with value parsed into number if possible, or string if not a number
	 * Component must have a valueStr to keep a precise entered string and valueNum to distinguish change coming out of the outside
	 * These cannot be on state because setState in onChange is not seen in subsequent componentWillReceiveProps
	 * But there is additional state's valueStr set in onChange to cause a rerender
	 */
	//@observer
	var NumberField = /** @class */ (function (_super) {
	    tslib_1.__extends(NumberField, _super);
	    function NumberField() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            focused: false
	        };
	        _this.onBlur = function (e) {
	            var _a = _this.props, onBlur = _a.onBlur, numberFormat = _a.numberFormat;
	            var valueNum = _this.state.valueNum;
	            //console.log('onBlur: this.props.value = ' + this.props.value + ", valueStr = " + formatNumber(this.props.value));
	            _this.setState({
	                focused: false,
	                valueStr: (0, numberUtils_1.formatNumber)(valueNum, numberFormat)
	            }, function () {
	                if (onBlur) {
	                    onBlur(e);
	                }
	            });
	        };
	        _this.onFocus = function (e) {
	            var onFocus = _this.props.onFocus;
	            var valueNum = _this.state.valueNum;
	            _this.setState({
	                focused: true,
	                valueStr: (0, numberUtils_1.toPlainString)(valueNum)
	            }, function () {
	                if (onFocus) {
	                    onFocus(e);
	                }
	            });
	        };
	        _this.onChange = function (e) {
	            var onChange = _this.props.onChange;
	            var _valueStr = e.target.value;
	            var _valueNum = (0, numberUtils_1.parseNumber)(_valueStr);
	            console.log('onChange(), setting valueStr = %s, valueNum = %f', _valueStr, _valueNum);
	            _this.setState({
	                valueStr: _valueStr,
	                valueNum: _valueNum
	            }, function () {
	                if (onChange) {
	                    onChange(_valueNum);
	                }
	            });
	        };
	        return _this;
	    }
	    NumberField.prototype.componentWillMount = function () {
	        var _a = this.props, value = _a.value, numberFormat = _a.numberFormat;
	        this.setState({
	            valueStr: (this.state.focused) ? (0, numberUtils_1.toPlainString)(value) : (0, numberUtils_1.formatNumber)(value, numberFormat),
	            valueNum: value
	        });
	    };
	    NumberField.prototype.componentWillReceiveProps = function (nextProps) {
	        var value = nextProps.value, numberFormat = nextProps.numberFormat;
	        var _a = this.state, focused = _a.focused, valueNum = _a.valueNum;
	        //console.log('componentWillReceiveProps %s : nextProps.value = %f, this.valueNum = %f, will recompute valueStr %s', ((this.props.mdField)?this.props.mdField.fieldName:null), value, valueNum, value !== valueNum);
	        if (value !== valueNum) {
	            this.setState({
	                valueStr: (focused) ? (0, numberUtils_1.toPlainString)(value) : (0, numberUtils_1.formatNumber)(value, numberFormat),
	                valueNum: value
	            });
	        }
	    };
	    NumberField.prototype.render = function () {
	        var _a = this.props, value = _a.value, numberFormat = _a.numberFormat, onBlur = _a.onBlur, onFocus = _a.onFocus, onChange = _a.onChange, mdField = _a.mdField, labelStyle = _a.labelStyle, label = _a.label, maxLength = _a.maxLength, clearable = _a.clearable, searchable = _a.searchable, onCheck = _a.onCheck, options = _a.options, checked = _a.checked, other = tslib_1.__rest(_a, ["value", "numberFormat", "onBlur", "onFocus", "onChange", "mdField", "labelStyle", "label", "maxLength", "clearable", "searchable", "onCheck", "options", "checked"]);
	        return (react_1.default.createElement(TextField_1.default, tslib_1.__assign({ value: this.state.valueStr, onChange: this.onChange, onBlur: this.onBlur, onFocus: this.onFocus }, other)));
	    };
	    return NumberField;
	}(react_1.default.PureComponent));
	exports.default = NumberField;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports.default = createChainedFunction;
	module.exports = exports['default'];

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.clsx = void 0;
	exports.findOverlayPlacement = findOverlayPlacement;
	exports.computeHeight = computeHeight;
	exports.topDifference = topDifference;
	exports.topFromWindow = topFromWindow;
	exports.buildURL = buildURL;
	exports.classNames = classNames;
	var tslib_1 = __webpack_require__(3);
	var react_dom_1 = tslib_1.__importDefault(__webpack_require__(31));
	var isObject = __webpack_require__(100);
	var isDate = __webpack_require__(1475);
	var mobx_1 = __webpack_require__(5);
	function findOverlayPlacement(triggerEl, width, height) {
	    var bodyRect = document.body.getBoundingClientRect(), elemRect = triggerEl.getBoundingClientRect();
	    var offset = bodyRect.bottom - elemRect.bottom;
	    if (offset > height) {
	        return "bottom";
	    }
	    offset = bodyRect.right - elemRect.right;
	    if (offset > width) {
	        return "right";
	    }
	    offset = elemRect.top - bodyRect.top;
	    if (offset > height) {
	        return "top";
	    }
	    return "left";
	}
	function computeHeight(bodyRect, aceRef) {
	    if (aceRef) {
	        var aceElement = react_dom_1.default.findDOMNode(aceRef);
	        if (aceElement) {
	            var aceRect = aceElement.getBoundingClientRect();
	            return (bodyRect.height - (aceRect.top - bodyRect.top) - 10);
	        }
	    }
	    return null;
	}
	function topDifference(element, container) {
	    return topFromWindow(element) - topFromWindow(container);
	}
	function topFromWindow(element) {
	    if (!element || element === window)
	        return 0;
	    return element.offsetTop + topFromWindow(element.offsetParent);
	}
	function encode(val) {
	    return encodeURIComponent(val).
	        replace(/%40/gi, '@').
	        replace(/%3A/gi, ':').
	        replace(/%24/g, '$').
	        replace(/%2C/gi, ',').
	        replace(/%20/g, '+').
	        replace(/%5B/gi, '[').
	        replace(/%5D/gi, ']');
	}
	function isURLSearchParams(val) {
	    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	function buildURL(url, params, paramsSerializer) {
	    if (!params) {
	        return url;
	    }
	    var serializedParams;
	    if (paramsSerializer) {
	        serializedParams = paramsSerializer(params);
	    }
	    else if (isURLSearchParams(params)) {
	        serializedParams = params.toString();
	    }
	    else {
	        var parts_1 = [];
	        Object.entries(params).forEach(function (_a, index) {
	            var key = _a[0], val = _a[1];
	            if (val === null || typeof val === 'undefined') {
	                return;
	            }
	            if ((0, mobx_1.isArrayLike)(val)) {
	                key = key + '[]';
	            }
	            if (!(0, mobx_1.isArrayLike)(val)) {
	                val = [val];
	            }
	            val.forEach(function (v) {
	                if (isDate(v)) {
	                    v = v.toISOString();
	                }
	                else if (isObject(v)) {
	                    v = JSON.stringify(v);
	                }
	                parts_1.push(encode(key) + '=' + encode(v));
	            });
	        });
	        serializedParams = parts_1.join('&');
	    }
	    if (serializedParams) {
	        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	    }
	    return url;
	}
	var hasOwn = {}.hasOwnProperty;
	function classNames() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var classes = [];
	    for (var i = 0; i < arguments.length; i++) {
	        var arg = arguments[i];
	        if (!arg)
	            continue;
	        var argType = typeof arg;
	        if (argType === 'string' || argType === 'number') {
	            classes.push(arg);
	        }
	        else if (Array.isArray(arg)) {
	            classes.push(classNames.apply(null, arg));
	        }
	        else if (argType === 'object') {
	            for (var key in arg) {
	                if (hasOwn.call(arg, key) && arg[key]) {
	                    classes.push(key);
	                }
	            }
	        }
	    }
	    return classes.join(' ');
	}
	var clsx = function () {
	    var styles = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        styles[_i] = arguments[_i];
	    }
	    return styles.reduce(function (acc, style) { return (tslib_1.__assign(tslib_1.__assign({}, acc), style)); }, {});
	};
	exports.clsx = clsx;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(626);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 93 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var idCount = 0;
	
	var _ = module.exports = {
	
	  has: has,
	
	  result: function result(value) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return typeof value === 'function' ? value.apply(undefined, args) : value;
	  },
	
	  isShallowEqual: function isShallowEqual(a, b) {
	    if (a === b) return true;
	    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
	
	    if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object' && (typeof b === 'undefined' ? 'undefined' : _typeof(b)) !== 'object') return a === b;
	
	    if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== (typeof b === 'undefined' ? 'undefined' : _typeof(b))) return false;
	
	    return shallowEqual(a, b);
	  },
	  transform: function transform(obj, cb, seed) {
	    _.each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	    return seed;
	  },
	  each: function each(obj, cb, thisArg) {
	    if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	    for (var key in obj) {
	      if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	    }
	  },
	  pick: function pick(obj, keys) {
	    keys = [].concat(keys);
	    return _.transform(obj, function (mapped, val, key) {
	      if (keys.indexOf(key) !== -1) mapped[key] = val;
	    }, {});
	  },
	  pickProps: function pickProps(props, componentClass) {
	    return _.pick(props, Object.keys(componentClass.propTypes));
	  },
	  omit: function omit(obj, keys) {
	    keys = [].concat(keys);
	    return _.transform(obj, function (mapped, val, key) {
	      if (keys.indexOf(key) === -1) mapped[key] = val;
	    }, {});
	  },
	  omitOwnProps: function omitOwnProps(component) {
	    for (var _len2 = arguments.length, others = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      others[_key2 - 1] = arguments[_key2];
	    }
	
	    var keys = others.reduce(function (arr, compClass) {
	      return arr.concat(Object.keys(compClass.propTypes));
	    }, Object.keys(component.constructor.propTypes));
	
	    return _.omit(component.props, keys);
	  },
	  find: function find(arr, cb, thisArg) {
	    var result;
	    if (Array.isArray(arr)) {
	      arr.every(function (val, idx) {
	        if (cb.call(thisArg, val, idx, arr)) return result = val, false;
	        return true;
	      });
	      return result;
	    } else for (var key in arr) {
	      if (has(arr, key)) if (cb.call(thisArg, arr[key], key, arr)) return arr[key];
	    }
	  },
	  chunk: function chunk(array, chunkSize) {
	    var index = 0,
	        length = array ? array.length : 0,
	        result = [];
	
	    chunkSize = Math.max(+chunkSize || 1, 1);
	
	    while (index < length) {
	      result.push(array.slice(index, index += chunkSize));
	    }return result;
	  },
	  splat: function splat(obj) {
	    return obj == null ? [] : [].concat(obj);
	  },
	  noop: function noop() {},
	  uniqueId: function uniqueId(prefix) {
	    return '' + ((prefix == null ? '' : prefix) + ++idCount);
	  }
	};
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	function eql(a, b) {
	  return a === b;
	}
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 */
	function shallowEqual(objA, objB) {
	
	  if (objA == null || objB == null) return false;
	
	  var keysA = Object.keys(objA),
	      keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!has(objB, keysA[i]) || !eql(objA[keysA[i]], objB[keysA[i]])) return false;
	  }return true;
	}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(192);
	var toSubscriber_1 = __webpack_require__(2010);
	var observable_1 = __webpack_require__(554);
	var pipe_1 = __webpack_require__(2009);
	/**
	 * A representation of any set of values over any amount of time. This is the most basic building block
	 * of RxJS.
	 *
	 * @class Observable<T>
	 */
	var Observable = (function () {
	    /**
	     * @constructor
	     * @param {Function} subscribe the function that is called when the Observable is
	     * initially subscribed to. This function is given a Subscriber, to which new values
	     * can be `next`ed, or an `error` method can be called to raise an error, or
	     * `complete` can be called to notify of a successful completion.
	     */
	    function Observable(subscribe) {
	        this._isScalar = false;
	        if (subscribe) {
	            this._subscribe = subscribe;
	        }
	    }
	    /**
	     * Creates a new Observable, with this Observable as the source, and the passed
	     * operator defined as the new observable's operator.
	     * @method lift
	     * @param {Operator} operator the operator defining the operation to take on the observable
	     * @return {Observable} a new observable with the Operator applied
	     */
	    Observable.prototype.lift = function (operator) {
	        var observable = new Observable();
	        observable.source = this;
	        observable.operator = operator;
	        return observable;
	    };
	    /**
	     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
	     *
	     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
	     *
	     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
	     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
	     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
	     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
	     * thought.
	     *
	     * Apart from starting the execution of an Observable, this method allows you to listen for values
	     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
	     * following ways.
	     *
	     * The first way is creating an object that implements {@link Observer} interface. It should have methods
	     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
	     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
	     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
	     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
	     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
	     * be left uncaught.
	     *
	     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
	     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
	     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
	     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
	     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
	     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
	     *
	     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
	     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
	     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
	     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
	     *
	     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
	     * It is an Observable itself that decides when these functions will be called. For example {@link of}
	     * by default emits all its values synchronously. Always check documentation for how given Observable
	     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
	     *
	     * @example <caption>Subscribe with an Observer</caption>
	     * const sumObserver = {
	     *   sum: 0,
	     *   next(value) {
	     *     console.log('Adding: ' + value);
	     *     this.sum = this.sum + value;
	     *   },
	     *   error() { // We actually could just remove this method,
	     *   },        // since we do not really care about errors right now.
	     *   complete() {
	     *     console.log('Sum equals: ' + this.sum);
	     *   }
	     * };
	     *
	     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
	     * .subscribe(sumObserver);
	     *
	     * // Logs:
	     * // "Adding: 1"
	     * // "Adding: 2"
	     * // "Adding: 3"
	     * // "Sum equals: 6"
	     *
	     *
	     * @example <caption>Subscribe with functions</caption>
	     * let sum = 0;
	     *
	     * Rx.Observable.of(1, 2, 3)
	     * .subscribe(
	     *   function(value) {
	     *     console.log('Adding: ' + value);
	     *     sum = sum + value;
	     *   },
	     *   undefined,
	     *   function() {
	     *     console.log('Sum equals: ' + sum);
	     *   }
	     * );
	     *
	     * // Logs:
	     * // "Adding: 1"
	     * // "Adding: 2"
	     * // "Adding: 3"
	     * // "Sum equals: 6"
	     *
	     *
	     * @example <caption>Cancel a subscription</caption>
	     * const subscription = Rx.Observable.interval(1000).subscribe(
	     *   num => console.log(num),
	     *   undefined,
	     *   () => console.log('completed!') // Will not be called, even
	     * );                                // when cancelling subscription
	     *
	     *
	     * setTimeout(() => {
	     *   subscription.unsubscribe();
	     *   console.log('unsubscribed!');
	     * }, 2500);
	     *
	     * // Logs:
	     * // 0 after 1s
	     * // 1 after 2s
	     * // "unsubscribed!" after 2.5s
	     *
	     *
	     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
	     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
	     *  Observable.
	     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
	     *  the error will be thrown as unhandled.
	     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
	     * @return {ISubscription} a subscription reference to the registered handlers
	     * @method subscribe
	     */
	    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
	        var operator = this.operator;
	        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
	        if (operator) {
	            operator.call(sink, this.source);
	        }
	        else {
	            sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
	        }
	        if (sink.syncErrorThrowable) {
	            sink.syncErrorThrowable = false;
	            if (sink.syncErrorThrown) {
	                throw sink.syncErrorValue;
	            }
	        }
	        return sink;
	    };
	    Observable.prototype._trySubscribe = function (sink) {
	        try {
	            return this._subscribe(sink);
	        }
	        catch (err) {
	            sink.syncErrorThrown = true;
	            sink.syncErrorValue = err;
	            sink.error(err);
	        }
	    };
	    /**
	     * @method forEach
	     * @param {Function} next a handler for each value emitted by the observable
	     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
	     * @return {Promise} a promise that either resolves on observable completion or
	     *  rejects with the handled error
	     */
	    Observable.prototype.forEach = function (next, PromiseCtor) {
	        var _this = this;
	        if (!PromiseCtor) {
	            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
	                PromiseCtor = root_1.root.Rx.config.Promise;
	            }
	            else if (root_1.root.Promise) {
	                PromiseCtor = root_1.root.Promise;
	            }
	        }
	        if (!PromiseCtor) {
	            throw new Error('no Promise impl found');
	        }
	        return new PromiseCtor(function (resolve, reject) {
	            // Must be declared in a separate statement to avoid a RefernceError when
	            // accessing subscription below in the closure due to Temporal Dead Zone.
	            var subscription;
	            subscription = _this.subscribe(function (value) {
	                if (subscription) {
	                    // if there is a subscription, then we can surmise
	                    // the next handling is asynchronous. Any errors thrown
	                    // need to be rejected explicitly and unsubscribe must be
	                    // called manually
	                    try {
	                        next(value);
	                    }
	                    catch (err) {
	                        reject(err);
	                        subscription.unsubscribe();
	                    }
	                }
	                else {
	                    // if there is NO subscription, then we're getting a nexted
	                    // value synchronously during subscription. We can just call it.
	                    // If it errors, Observable's `subscribe` will ensure the
	                    // unsubscription logic is called, then synchronously rethrow the error.
	                    // After that, Promise will trap the error and send it
	                    // down the rejection path.
	                    next(value);
	                }
	            }, reject, resolve);
	        });
	    };
	    /** @deprecated internal use only */ Observable.prototype._subscribe = function (subscriber) {
	        return this.source.subscribe(subscriber);
	    };
	    /**
	     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
	     * @method Symbol.observable
	     * @return {Observable} this instance of the observable
	     */
	    Observable.prototype[observable_1.observable] = function () {
	        return this;
	    };
	    /* tslint:enable:max-line-length */
	    /**
	     * Used to stitch together functional operators into a chain.
	     * @method pipe
	     * @return {Observable} the Observable result of all of the operators having
	     * been called in the order they were passed in.
	     *
	     * @example
	     *
	     * import { map, filter, scan } from 'rxjs/operators';
	     *
	     * Rx.Observable.interval(1000)
	     *   .pipe(
	     *     filter(x => x % 2 === 0),
	     *     map(x => x + x),
	     *     scan((acc, x) => acc + x)
	     *   )
	     *   .subscribe(x => console.log(x))
	     */
	    Observable.prototype.pipe = function () {
	        var operations = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            operations[_i - 0] = arguments[_i];
	        }
	        if (operations.length === 0) {
	            return this;
	        }
	        return pipe_1.pipeFromArray(operations)(this);
	    };
	    /* tslint:enable:max-line-length */
	    Observable.prototype.toPromise = function (PromiseCtor) {
	        var _this = this;
	        if (!PromiseCtor) {
	            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
	                PromiseCtor = root_1.root.Rx.config.Promise;
	            }
	            else if (root_1.root.Promise) {
	                PromiseCtor = root_1.root.Promise;
	            }
	        }
	        if (!PromiseCtor) {
	            throw new Error('no Promise impl found');
	        }
	        return new PromiseCtor(function (resolve, reject) {
	            var value;
	            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
	        });
	    };
	    // HACK: Since TypeScript inherits static properties too, we have to
	    // fight against TypeScript here so Subject can have a different static create signature
	    /**
	     * Creates a new cold Observable by calling the Observable constructor
	     * @static true
	     * @owner Observable
	     * @method create
	     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
	     * @return {Observable} a new cold observable
	     */
	    Observable.create = function (subscribe) {
	        return new Observable(subscribe);
	    };
	    return Observable;
	}());
	exports.Observable = Observable;
	//# sourceMappingURL=Observable.js.map

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.11' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 96 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.GOOGLE_API_KEY = exports.FIELD_HEIGHT = exports.tabStyle = exports.navbarHeight = exports.screenLg = exports.screenMd = exports.screenSm = exports.screenXs = void 0;
	exports.screenXs = 480;
	exports.screenSm = 768;
	exports.screenMd = 992;
	exports.screenLg = 1200;
	exports.navbarHeight = 40;
	exports.tabStyle = { height: 36 };
	exports.FIELD_HEIGHT = 54;
	exports.GOOGLE_API_KEY = "AIzaSyD3Yrf-31-8sL58tKfWwWI_-RpKM4wMw3Y";


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SecurityRole = exports.UserProfileDto = exports.UserEntityPreference = exports.ExtendedPreferences = exports.RestrictionData = exports.PARAMKEY = exports.User = exports.RESTRICTION = exports.UserToken = exports.Tenant = exports.UserSession = exports.SecurablePermission = exports.SecurablePermissionDetail = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var metaConstant_1 = __webpack_require__(13);
	var SecurablePermissionDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(SecurablePermissionDetail, _super);
	    function SecurablePermissionDetail(json) {
	        return _super.call(this, json) || this;
	    }
	    SecurablePermissionDetail.prototype.getPermissionList = function () {
	        return tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray([], (this.readPermission ? [metaConstant_1.PERMISSION.Read] : []), true), (this.newPermission ? [metaConstant_1.PERMISSION.New] : []), true), (this.updatePermission ? [metaConstant_1.PERMISSION.Update] : []), true), (this.deletePermission ? [metaConstant_1.PERMISSION.Delete] : []), true), (this.executePermission ? [metaConstant_1.PERMISSION.Execute] : []), true), (this.exportPermission ? [metaConstant_1.PERMISSION.Export] : []), true), (this.importPermission ? [metaConstant_1.PERMISSION.Import] : []), true);
	    };
	    SecurablePermissionDetail.prototype.isPermission = function (permission) {
	        switch (permission) {
	            case metaConstant_1.PERMISSION.Read:
	                return this.readPermission;
	            case metaConstant_1.PERMISSION.New:
	                return this.newPermission;
	            case metaConstant_1.PERMISSION.Update:
	                return this.updatePermission;
	            case metaConstant_1.PERMISSION.Delete:
	                return this.deletePermission;
	            case metaConstant_1.PERMISSION.Execute:
	                return this.executePermission;
	            case metaConstant_1.PERMISSION.Export:
	                return this.exportPermission;
	            case metaConstant_1.PERMISSION.Import:
	                return this.importPermission;
	        }
	    };
	    SecurablePermissionDetail.prototype.setPermission = function (permission, value) {
	        switch (permission) {
	            case metaConstant_1.PERMISSION.Read:
	                this.readPermission = value;
	                break;
	            case metaConstant_1.PERMISSION.New:
	                this.newPermission = value;
	                break;
	            case metaConstant_1.PERMISSION.Update:
	                this.updatePermission = value;
	                break;
	            case metaConstant_1.PERMISSION.Delete:
	                this.deletePermission = value;
	                break;
	            case metaConstant_1.PERMISSION.Execute:
	                this.executePermission = value;
	                break;
	            case metaConstant_1.PERMISSION.Export:
	                this.exportPermission = value;
	                break;
	            case metaConstant_1.PERMISSION.Import:
	                this.importPermission = value;
	                break;
	        }
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermissionDetail.prototype, "detailId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermissionDetail.prototype, "readPermission", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermissionDetail.prototype, "newPermission", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermissionDetail.prototype, "updatePermission", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermissionDetail.prototype, "deletePermission", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermissionDetail.prototype, "executePermission", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermissionDetail.prototype, "exportPermission", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermissionDetail.prototype, "importPermission", void 0);
	    SecurablePermissionDetail = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], SecurablePermissionDetail);
	    return SecurablePermissionDetail;
	}(DomainAncestor_1.DomainAncestor));
	exports.SecurablePermissionDetail = SecurablePermissionDetail;
	var SecurablePermission = /** @class */ (function (_super) {
	    tslib_1.__extends(SecurablePermission, _super);
	    function SecurablePermission(json) {
	        return _super.call(this, json) || this;
	    }
	    SecurablePermission.prototype.fromJson = function (json) {
	        _super.prototype.fromJson.call(this, json, "detailPermissions");
	        if (!this.detailPermissions)
	            this.detailPermissions = new mobx_1.ObservableMap();
	        return this;
	    };
	    SecurablePermission.prototype.getPermissionList = function () {
	        return tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray([], (this.readPermission ? [metaConstant_1.PERMISSION.Read] : []), true), (this.newPermission ? [metaConstant_1.PERMISSION.New] : []), true), (this.updatePermission ? [metaConstant_1.PERMISSION.Update] : []), true), (this.deletePermission ? [metaConstant_1.PERMISSION.Delete] : []), true), (this.executePermission ? [metaConstant_1.PERMISSION.Execute] : []), true), (this.exportPermission ? [metaConstant_1.PERMISSION.Export] : []), true), (this.importPermission ? [metaConstant_1.PERMISSION.Import] : []), true), (this.publicGridPermission ? [metaConstant_1.PERMISSION.PublicGrid] : []), true), (this.tenantGridPermission ? [metaConstant_1.PERMISSION.TenantGrid] : []), true), (this.tenantGroupGridPermission ? [metaConstant_1.PERMISSION.TenantGroupGrid] : []), true);
	    };
	    SecurablePermission.prototype.isPermission = function (permission) {
	        switch (permission) {
	            case metaConstant_1.PERMISSION.Read:
	                return this.readPermission;
	            case metaConstant_1.PERMISSION.New:
	                return this.newPermission;
	            case metaConstant_1.PERMISSION.Update:
	                return this.updatePermission;
	            case metaConstant_1.PERMISSION.Delete:
	                return this.deletePermission;
	            case metaConstant_1.PERMISSION.Execute:
	                return this.executePermission;
	            case metaConstant_1.PERMISSION.Export:
	                return this.exportPermission;
	            case metaConstant_1.PERMISSION.Import:
	                return this.importPermission;
	            case metaConstant_1.PERMISSION.PublicGrid:
	                return this.publicGridPermission;
	            case metaConstant_1.PERMISSION.TenantGrid:
	                return this.tenantGridPermission;
	            case metaConstant_1.PERMISSION.TenantGroupGrid:
	                return this.tenantGroupGridPermission;
	        }
	    };
	    SecurablePermission.prototype.modifyPermissions = function (permissions) {
	        this.readPermission = permissions.includes(metaConstant_1.PERMISSION.Read);
	        this.newPermission = permissions.includes(metaConstant_1.PERMISSION.New);
	        this.updatePermission = permissions.includes(metaConstant_1.PERMISSION.Update);
	        this.deletePermission = permissions.includes(metaConstant_1.PERMISSION.Delete);
	        this.executePermission = permissions.includes(metaConstant_1.PERMISSION.Execute);
	        this.exportPermission = permissions.includes(metaConstant_1.PERMISSION.Export);
	        this.importPermission = permissions.includes(metaConstant_1.PERMISSION.Import);
	        this.publicGridPermission = permissions.includes(metaConstant_1.PERMISSION.PublicGrid);
	        this.tenantGridPermission = permissions.includes(metaConstant_1.PERMISSION.TenantGrid);
	        this.tenantGroupGridPermission = permissions.includes(metaConstant_1.PERMISSION.TenantGroupGrid);
	        return this;
	    };
	    SecurablePermission.prototype.setPermission = function (permission, value) {
	        switch (permission) {
	            case metaConstant_1.PERMISSION.Read:
	                this.readPermission = value;
	                break;
	            case metaConstant_1.PERMISSION.New:
	                this.newPermission = value;
	                break;
	            case metaConstant_1.PERMISSION.Update:
	                this.updatePermission = value;
	                break;
	            case metaConstant_1.PERMISSION.Delete:
	                this.deletePermission = value;
	                break;
	            case metaConstant_1.PERMISSION.Execute:
	                this.executePermission = value;
	                break;
	            case metaConstant_1.PERMISSION.Export:
	                this.exportPermission = value;
	                break;
	            case metaConstant_1.PERMISSION.Import:
	                this.importPermission = value;
	                break;
	            case metaConstant_1.PERMISSION.PublicGrid:
	                this.publicGridPermission = value;
	                break;
	            case metaConstant_1.PERMISSION.TenantGrid:
	                this.tenantGridPermission = value;
	                break;
	            case metaConstant_1.PERMISSION.TenantGroupGrid:
	                this.tenantGroupGridPermission = value;
	                break;
	        }
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermission.prototype, "securityRole", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermission.prototype, "securable", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermission.prototype, "readPermission", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermission.prototype, "newPermission", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermission.prototype, "updatePermission", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermission.prototype, "deletePermission", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermission.prototype, "executePermission", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermission.prototype, "exportPermission", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermission.prototype, "importPermission", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermission.prototype, "publicGridPermission", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermission.prototype, "tenantGroupGridPermission", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurablePermission.prototype, "tenantGridPermission", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(SecurablePermissionDetail)
	    ], SecurablePermission.prototype, "detailPermissions", void 0);
	    SecurablePermission = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], SecurablePermission);
	    return SecurablePermission;
	}(DomainAncestor_1.DomainAncestor));
	exports.SecurablePermission = SecurablePermission;
	var UserSession = /** @class */ (function (_super) {
	    tslib_1.__extends(UserSession, _super);
	    function UserSession(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.restrictions)
	            _this.restrictions = [];
	        if (!_this.entityPreferences)
	            _this.entityPreferences = {};
	        return _this;
	    }
	    UserSession.prototype.fromJson = function (json) {
	        _super.prototype.fromJson.call(this, json);
	        if (this.permissionMap) {
	            this.permissionMap = Object.entries(this.permissionMap).reduce(function (acc, _a) {
	                var key = _a[0], spJson = _a[1];
	                acc[key] = new SecurablePermission(spJson);
	                return acc;
	            }, {});
	        }
	        return this;
	    };
	    UserSession.prototype.permissionList = function (securable) {
	        if (this.permissionMap) {
	            var securablePermission = this.permissionMap[securable];
	            if (securablePermission) {
	                return securablePermission.getPermissionList();
	            }
	        }
	        return null;
	    };
	    UserSession.prototype.detailIdList = function (securable) {
	        if (this.permissionMap) {
	            var securablePermission = this.permissionMap[securable];
	            if (securablePermission) {
	                return securablePermission.detailPermissions.keys();
	            }
	        }
	        return [];
	    };
	    UserSession.prototype.hasRight = function (securable, permission, detailId) {
	        if (this.permissionMap) {
	            var securablePermission = this.permissionMap[securable];
	            if (securablePermission) {
	                var securableConfig = metaConstant_1.SECURABLE[securable];
	                if (securableConfig && securableConfig.detailHeader && ![metaConstant_1.PERMISSION.PublicGrid, metaConstant_1.PERMISSION.TenantGrid, metaConstant_1.PERMISSION.TenantGroupGrid].includes(permission)) {
	                    if (detailId) {
	                        var securablePermissionDetail = securablePermission.detailPermissions.get(detailId);
	                        return (securablePermissionDetail) ? securablePermissionDetail.isPermission(permission) : false;
	                    }
	                    else {
	                        return securablePermission.detailPermissions.values().some(function (spd) { return spd.isPermission(permission); });
	                    }
	                }
	                else {
	                    return securablePermission.isPermission(permission);
	                }
	            }
	        }
	        return false;
	    };
	    UserSession.prototype.hasRestriction = function (restriction) {
	        return this.restrictions.includes(restriction);
	    };
	    UserSession.prototype.confirmDelete = function (entityName) {
	        var entityPref = this.entityPreferences[entityName];
	        return (entityPref) ? entityPref.confirmDelete : false;
	    };
	    UserSession.prototype.extendedPreferences = function (entityName) {
	        var entityPref = this.entityPreferences[entityName];
	        return (entityPref) ? entityPref.extendedPreferences : null;
	    };
	    UserSession.prototype.getId = function () {
	        return this.username;
	    };
	    UserSession.prototype.getMePartyLov = function () {
	        return { value: this.partyId, label: this.displayName };
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserSession.prototype, "username", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserSession.prototype, "email", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserSession.prototype, "firstName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserSession.prototype, "lastName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserSession.prototype, "titleBefore", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserSession.prototype, "titleAfter", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserSession.prototype, "position", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserSession.prototype, "internalLine", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserSession.prototype, "mobile", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserSession.prototype, "hrNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserSession.prototype, "displayName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserSession.prototype, "partyId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserSession.prototype, "permissionMap", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserSession.prototype, "restrictions", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserSession.prototype, "entityPreferences", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserSession.prototype, "dashboardItems", void 0);
	    UserSession = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], UserSession);
	    return UserSession;
	}(DomainAncestor_1.DomainAncestor));
	exports.UserSession = UserSession;
	var Tenant = /** @class */ (function (_super) {
	    tslib_1.__extends(Tenant, _super);
	    function Tenant(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Tenant.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Tenant.prototype, "tenantGroup", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Tenant.prototype, "party", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Tenant.prototype, "localCurrency", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Tenant.prototype, "defaultCurrency", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Tenant.prototype, "vatRateCountry", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Tenant.prototype, "monetaryRounding", void 0);
	    Tenant = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], Tenant);
	    return Tenant;
	}(DomainAncestor_1.DomainAncestor));
	exports.Tenant = Tenant;
	var UserToken = /** @class */ (function (_super) {
	    tslib_1.__extends(UserToken, _super);
	    function UserToken(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserToken.prototype, "tokenId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserToken.prototype, "tokenString", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserToken.prototype, "tokenName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserToken.prototype, "user", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserToken.prototype, "closeDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserToken.prototype, "validFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserToken.prototype, "validTo", void 0);
	    UserToken = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], UserToken);
	    return UserToken;
	}(DomainAncestor_1.DomainAncestor));
	exports.UserToken = UserToken;
	var RESTRICTION;
	(function (RESTRICTION) {
	    RESTRICTION["YARD_MGMT_HAULER_VEHICLE"] = "YARD_MGMT_HAULER_VEHICLE";
	    RESTRICTION["YARD_MGMT_HAULER_DRIVER"] = "YARD_MGMT_HAULER_DRIVER";
	    RESTRICTION["LIMIT_PARTY_BY_USER_PROFITCENTER"] = "LIMIT_PARTY_BY_USER_PROFITCENTER";
	    RESTRICTION["LIMIT_VEHICLE_BY_USER_PROFITCENTER"] = "LIMIT_VEHICLE_BY_USER_PROFITCENTER";
	    RESTRICTION["LIMIT_PRODUCT_BY_USER_PROFITCENTER"] = "LIMIT_PRODUCT_BY_USER_PROFITCENTER";
	    RESTRICTION["LIMIT_INVOICE_BY_USER_PROFITCENTER"] = "LIMIT_INVOICE_BY_USER_PROFITCENTER";
	    RESTRICTION["SIMPLE_SHIPMENT_VISIT"] = "SIMPLE_SHIPMENT_VISIT";
	})(RESTRICTION || (exports.RESTRICTION = RESTRICTION = {}));
	var User = /** @class */ (function (_super) {
	    tslib_1.__extends(User, _super);
	    function User(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.gridConfigs)
	            _this.gridConfigs = [];
	        if (!_this.tenants)
	            _this.tenants = [];
	        if (!_this.securityRoles)
	            _this.securityRoles = [];
	        if (!_this.profitCenters)
	            _this.profitCenters = [];
	        if (!_this.defaultGridConfig)
	            _this.defaultGridConfig = {};
	        if (!_this.permissionMap)
	            _this.permissionMap = {};
	        return _this;
	    }
	    User.prototype.fromJson = function (json) {
	        _super.prototype.fromJson.call(this, json);
	        this.permissionMap = (this.permissionMap) ? Object.entries(this.permissionMap).reduce(function (acc, _a) {
	            var key = _a[0], spJson = _a[1];
	            acc[key] = new SecurablePermission(spJson);
	            return acc;
	        }, {}) : {};
	        return this;
	    };
	    User.prototype.getId = function () {
	        return this.username;
	    };
	    User.prototype.setId = function (id) {
	        this.username = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "username", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "enabled", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "locked", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "expired", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "password1", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "password2", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "oldPassword", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "rememberMe", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "expirationMinutes", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "passwordPolicy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "accountExpiration", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "defaultTenant", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "party", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "permissionMap", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "restrictions", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "gridConfigs", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "tenants", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "securityRoles", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "profitCenters", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], User.prototype, "defaultGridConfig", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(UserToken)
	    ], User.prototype, "tokens", void 0);
	    User = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], User);
	    return User;
	}(DomainAncestor_1.DomainAncestor));
	exports.User = User;
	var PARAMKEY;
	(function (PARAMKEY) {
	    PARAMKEY["BATCH_INVOICE_SPLIT_PROFIT_CENTER"] = "BATCH_INVOICE_SPLIT_PROFIT_CENTER";
	    PARAMKEY["PREFERRED_RATE_SOURCE"] = "PREFERRED_RATE_SOURCE";
	    PARAMKEY["GDPR_LOGIN_TEXT"] = "GDPR_LOGIN_TEXT";
	})(PARAMKEY || (exports.PARAMKEY = PARAMKEY = {}));
	var RestrictionData = /** @class */ (function (_super) {
	    tslib_1.__extends(RestrictionData, _super);
	    function RestrictionData(json) {
	        return _super.call(this, json) || this;
	    }
	    RestrictionData.prototype.showComing = function () {
	        return (!this.lastComingTime || !!this.lastLeavingTime);
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], RestrictionData.prototype, "employer", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], RestrictionData.prototype, "userProfitCenterIds", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], RestrictionData.prototype, "lastComingTime", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], RestrictionData.prototype, "lastLeavingTime", void 0);
	    RestrictionData = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], RestrictionData);
	    return RestrictionData;
	}(DomainAncestor_1.DomainAncestor));
	exports.RestrictionData = RestrictionData;
	var ExtendedPreferences = /** @class */ (function (_super) {
	    tslib_1.__extends(ExtendedPreferences, _super);
	    function ExtendedPreferences(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.enabledInvoiceWarnings)
	            _this.enabledInvoiceWarnings = [];
	        return _this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ExtendedPreferences.prototype, "enabledInvoiceWarnings", void 0);
	    ExtendedPreferences = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ExtendedPreferences);
	    return ExtendedPreferences;
	}(DomainAncestor_1.DomainAncestor));
	exports.ExtendedPreferences = ExtendedPreferences;
	var UserEntityPreference = /** @class */ (function (_super) {
	    tslib_1.__extends(UserEntityPreference, _super);
	    function UserEntityPreference(json) {
	        return _super.call(this, json) || this;
	    }
	    UserEntityPreference.prototype.fromJson = function (json) {
	        _super.prototype.fromJson.call(this, json);
	        if (!this.extendedPreferences)
	            this.extendedPreferences = new ExtendedPreferences({});
	        return this;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserEntityPreference.prototype, "user", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserEntityPreference.prototype, "entityName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserEntityPreference.prototype, "confirmDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(ExtendedPreferences)
	    ], UserEntityPreference.prototype, "extendedPreferences", void 0);
	    UserEntityPreference = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], UserEntityPreference);
	    return UserEntityPreference;
	}(DomainAncestor_1.DomainAncestor));
	exports.UserEntityPreference = UserEntityPreference;
	var UserProfileDto = /** @class */ (function (_super) {
	    tslib_1.__extends(UserProfileDto, _super);
	    function UserProfileDto(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.entityPreferences)
	            _this.entityPreferences = [];
	        return _this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(User)
	    ], UserProfileDto.prototype, "user", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(UserEntityPreference)
	    ], UserProfileDto.prototype, "entityPreferences", void 0);
	    UserProfileDto = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], UserProfileDto);
	    return UserProfileDto;
	}(DomainAncestor_1.DomainAncestor));
	exports.UserProfileDto = UserProfileDto;
	var SecurityRole = /** @class */ (function (_super) {
	    tslib_1.__extends(SecurityRole, _super);
	    function SecurityRole(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.users)
	            _this.users = [];
	        if (!_this.permissions)
	            _this.permissions = [];
	        return _this;
	    }
	    SecurityRole.prototype.getId = function () {
	        return this.roleId;
	    };
	    SecurityRole.prototype.setId = function (id) {
	        this.roleId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurityRole.prototype, "roleId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurityRole.prototype, "roleName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurityRole.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurityRole.prototype, "users", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(SecurablePermission)
	    ], SecurityRole.prototype, "permissions", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurityRole.prototype, "restrictions", void 0);
	    SecurityRole = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], SecurityRole);
	    return SecurityRole;
	}(DomainAncestor_1.DomainAncestor));
	exports.SecurityRole = SecurityRole;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var Size = exports.Size = {
	  LARGE: 'large',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	};
	
	var SIZE_MAP = exports.SIZE_MAP = {
	  large: 'lg',
	  medium: 'md',
	  small: 'sm',
	  xsmall: 'xs',
	  lg: 'lg',
	  md: 'md',
	  sm: 'sm',
	  xs: 'xs'
	};
	
	var DEVICE_SIZES = exports.DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
	
	var State = exports.State = {
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	};
	
	var Style = exports.Style = {
	  DEFAULT: 'default',
	  PRIMARY: 'primary',
	  LINK: 'link',
	  INVERSE: 'inverse'
	};

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ }),
/* 100 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _MenuItem = __webpack_require__(491);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MenuItem2.default;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedButton = __webpack_require__(139);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tabs = context.muiTheme.tabs;
	
	
	  return {
	    root: {
	      color: props.selected ? tabs.selectedTextColor : tabs.textColor,
	      fontWeight: 500,
	      fontSize: 14,
	      width: props.width,
	      textTransform: 'uppercase',
	      padding: 0
	    },
	    button: {
	      display: 'flex',
	      flexDirection: 'column',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: props.label && props.icon ? 72 : 48
	    }
	  };
	}
	
	var Tab = function (_Component) {
	  (0, _inherits3.default)(Tab, _Component);
	
	  function Tab() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tab.__proto__ || (0, _getPrototypeOf2.default)(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTap = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(_this.props.value, event, _this);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tab, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          icon = _props.icon,
	          index = _props.index,
	          onActive = _props.onActive,
	          onClick = _props.onClick,
	          selected = _props.selected,
	          label = _props.label,
	          buttonStyle = _props.buttonStyle,
	          style = _props.style,
	          value = _props.value,
	          width = _props.width,
	          other = (0, _objectWithoutProperties3.default)(_props, ['icon', 'index', 'onActive', 'onClick', 'selected', 'label', 'buttonStyle', 'style', 'value', 'width']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      var iconElement = void 0;
	      if (icon && _react2.default.isValidElement(icon)) {
	        iconElement = _react2.default.cloneElement(icon, {
	          style: {
	            fontSize: 24,
	            color: icon.props && icon.props.style && icon.props.style.color ? icon.props.style.color : styles.root.color,
	            marginBottom: label ? 5 : 0
	          }
	        });
	      }
	
	      var rippleOpacity = 0.3;
	      var rippleColor = this.context.muiTheme.tabs.selectedTextColor;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          focusRippleColor: rippleColor,
	          touchRippleColor: rippleColor,
	          focusRippleOpacity: rippleOpacity,
	          touchRippleOpacity: rippleOpacity,
	          onClick: this.handleTouchTap
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: (0, _simpleAssign2.default)(styles.button, buttonStyle) },
	          iconElement,
	          label
	        )
	      );
	    }
	  }]);
	  return Tab;
	}(_react.Component);
	
	Tab.muiName = 'Tab';
	Tab.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Tab.propTypes =  false ? {
	  /**
	   * Override the inline-styles of the button element.
	   */
	  buttonStyle: _propTypes2.default.object,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Sets the icon of the tab, you can pass `FontIcon` or `SvgIcon` elements.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  index: _propTypes2.default.any,
	  /**
	   * Sets the text value of the tab item to the string specified.
	   */
	  label: _propTypes2.default.node,
	  /**
	   * Fired when the active tab changes by touch or tap.
	   * Use this event to specify any functionality when an active tab changes.
	   * For example - we are using this to route to home when the third tab becomes active.
	   * This function will always recieve the active tab as it\'s first argument.
	   */
	  onActive: _propTypes2.default.func,
	  /**
	   * @ignore
	   * This property is overriden by the Tabs component.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Defines if the current tab is selected or not.
	   * The Tabs component is responsible for setting this property.
	   */
	  selected: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * If value prop passed to Tabs component, this value prop is also required.
	   * It assigns a value to the tab so that it can be selected by the Tabs.
	   */
	  value: _propTypes2.default.any,
	  /**
	   * @ignore
	   * This property is overriden by the Tabs component.
	   */
	  width: _propTypes2.default.string
	} : {};
	exports.default = Tab;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseDomainOfCategoryAxis = exports.getBandSizeOfAxis = exports.parseSpecifiedDomain = exports.MAX_VALUE_REG = exports.MIN_VALUE_REG = exports.getDomainOfStackGroups = exports.getStackedDataOfItem = exports.getBaseValueOfBar = exports.getCateCoordinateOfBar = exports.getCateCoordinateOfLine = exports.getTicksOfScale = exports.calculateDomainOfTicks = exports.getStackGroupsByAxisId = exports.getStackedData = exports.offsetSign = exports.truncateByDomain = exports.findPositionOfBar = exports.checkDomainOfScale = exports.parseScale = exports.combineEventHandlers = exports.getTicksOfAxis = exports.getCoordinatesOfGrid = exports.isCategorialAxis = exports.getDomainOfItemsWithSameAxis = exports.parseErrorBarsOfAxis = exports.getDomainOfErrorBars = exports.appendOffsetOfLegend = exports.getBarPosition = exports.getBarSizeList = exports.getLegendProps = exports.getMainColorOfGraphicItem = exports.calculateActiveTickIndex = exports.getDomainOfDataByKey = exports.getValueByDataKey = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(125));
	
	var _sortBy2 = _interopRequireDefault(__webpack_require__(486));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(355));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(163));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(62));
	
	var _max2 = _interopRequireDefault(__webpack_require__(724));
	
	var _min2 = _interopRequireDefault(__webpack_require__(727));
	
	var _flatMap2 = _interopRequireDefault(__webpack_require__(1471));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _get2 = _interopRequireDefault(__webpack_require__(207));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(115));
	
	var _rechartsScale = __webpack_require__(1937);
	
	var d3Scales = _interopRequireWildcard(__webpack_require__(627));
	
	var _d3Shape = __webpack_require__(439);
	
	var _DataUtils = __webpack_require__(66);
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(307));
	
	var _Legend = _interopRequireDefault(__webpack_require__(547));
	
	var _ReactUtils = __webpack_require__(43);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getValueByDataKey = function getValueByDataKey(obj, dataKey, defaultValue) {
	  if ((0, _isNil2["default"])(obj) || (0, _isNil2["default"])(dataKey)) {
	    return defaultValue;
	  }
	
	  if ((0, _DataUtils.isNumOrStr)(dataKey)) {
	    return (0, _get2["default"])(obj, dataKey, defaultValue);
	  }
	
	  if ((0, _isFunction2["default"])(dataKey)) {
	    return dataKey(obj);
	  }
	
	  return defaultValue;
	};
	/**
	 * Get domain of data by key
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {String}  key       The unique key of a group of data
	 * @param  {String}  type      The type of axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array} Domain of data
	 */
	
	
	exports.getValueByDataKey = getValueByDataKey;
	
	var getDomainOfDataByKey = function getDomainOfDataByKey(data, key, type, filterNil) {
	  var flattenData = (0, _flatMap2["default"])(data, function (entry) {
	    return getValueByDataKey(entry, key);
	  });
	
	  if (type === 'number') {
	    var domain = flattenData.filter(function (entry) {
	      return (0, _DataUtils.isNumber)(entry) || parseFloat(entry, 10);
	    });
	    return domain.length ? [(0, _min2["default"])(domain), (0, _max2["default"])(domain)] : [Infinity, -Infinity];
	  }
	
	  var validateData = filterNil ? flattenData.filter(function (entry) {
	    return !(0, _isNil2["default"])(entry);
	  }) : flattenData;
	  return validateData.map(function (entry) {
	    return (0, _DataUtils.isNumOrStr)(entry) ? entry : '';
	  });
	};
	
	exports.getDomainOfDataByKey = getDomainOfDataByKey;
	
	var calculateActiveTickIndex = function calculateActiveTickIndex(coordinate, ticks, unsortedTicks, axis) {
	  var index = -1;
	  var len = ticks.length;
	
	  if (len > 1) {
	    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
	      var range = axis.range; // ticks are distributed in a circle
	
	      for (var i = 0; i < len; i++) {
	        var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
	        var cur = unsortedTicks[i].coordinate;
	        var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
	        var sameDirectionCoord = void 0;
	
	        if ((0, _DataUtils.mathSign)(cur - before) !== (0, _DataUtils.mathSign)(after - cur)) {
	          var diffInterval = [];
	
	          if ((0, _DataUtils.mathSign)(after - cur) === (0, _DataUtils.mathSign)(range[1] - range[0])) {
	            sameDirectionCoord = after;
	            var curInRange = cur + range[1] - range[0];
	            diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
	            diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
	          } else {
	            sameDirectionCoord = before;
	            var afterInRange = after + range[1] - range[0];
	            diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
	            diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
	          }
	
	          var sameInterval = [Math.min(cur, (sameDirectionCoord + cur) / 2), Math.max(cur, (sameDirectionCoord + cur) / 2)];
	
	          if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
	            index = unsortedTicks[i].index;
	            break;
	          }
	        } else {
	          var min = Math.min(before, after);
	          var max = Math.max(before, after);
	
	          if (coordinate > (min + cur) / 2 && coordinate <= (max + cur) / 2) {
	            index = unsortedTicks[i].index;
	            break;
	          }
	        }
	      }
	    } else {
	      // ticks are distributed in a single direction
	      for (var _i = 0; _i < len; _i++) {
	        if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
	          index = ticks[_i].index;
	          break;
	        }
	      }
	    }
	  } else {
	    index = 0;
	  }
	
	  return index;
	};
	/**
	 * Get the main color of each graphic item
	 * @param  {ReactElement} item A graphic item
	 * @return {String}            Color
	 */
	
	
	exports.calculateActiveTickIndex = calculateActiveTickIndex;
	
	var getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
	  var displayName = item.type.displayName;
	  var _item$props = item.props,
	      stroke = _item$props.stroke,
	      fill = _item$props.fill;
	  var result;
	
	  switch (displayName) {
	    case 'Line':
	      result = stroke;
	      break;
	
	    case 'Area':
	    case 'Radar':
	      result = stroke && stroke !== 'none' ? stroke : fill;
	      break;
	
	    default:
	      result = fill;
	      break;
	  }
	
	  return result;
	};
	
	exports.getMainColorOfGraphicItem = getMainColorOfGraphicItem;
	
	var getLegendProps = function getLegendProps(_ref) {
	  var children = _ref.children,
	      formatedGraphicalItems = _ref.formatedGraphicalItems,
	      legendWidth = _ref.legendWidth,
	      legendContent = _ref.legendContent;
	  var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend["default"]);
	
	  if (!legendItem) {
	    return null;
	  }
	
	  var legendData;
	
	  if (legendItem.props && legendItem.props.payload) {
	    legendData = legendItem.props && legendItem.props.payload;
	  } else if (legendContent === 'children') {
	    legendData = (formatedGraphicalItems || []).reduce(function (result, _ref2) {
	      var item = _ref2.item,
	          props = _ref2.props;
	      var data = props.sectors || props.data || [];
	      return result.concat(data.map(function (entry) {
	        return {
	          type: legendItem.props.iconType || item.props.legendType,
	          value: entry.name,
	          color: entry.fill,
	          payload: entry
	        };
	      }));
	    }, []);
	  } else {
	    legendData = (formatedGraphicalItems || []).map(function (_ref3) {
	      var item = _ref3.item;
	      var _item$props2 = item.props,
	          dataKey = _item$props2.dataKey,
	          name = _item$props2.name,
	          legendType = _item$props2.legendType,
	          hide = _item$props2.hide;
	      return {
	        inactive: hide,
	        dataKey: dataKey,
	        type: legendItem.props.iconType || legendType || 'square',
	        color: getMainColorOfGraphicItem(item),
	        value: name || dataKey,
	        payload: item.props
	      };
	    });
	  }
	
	  return _objectSpread({}, legendItem.props, {}, _Legend["default"].getWithHeight(legendItem, legendWidth), {
	    payload: legendData,
	    item: legendItem
	  });
	};
	/**
	 * Calculate the size of all groups for stacked bar graph
	 * @param  {Object} stackGroups The items grouped by axisId and stackId
	 * @return {Object} The size of all groups
	 */
	
	
	exports.getLegendProps = getLegendProps;
	
	var getBarSizeList = function getBarSizeList(_ref4) {
	  var globalSize = _ref4.barSize,
	      _ref4$stackGroups = _ref4.stackGroups,
	      stackGroups = _ref4$stackGroups === void 0 ? {} : _ref4$stackGroups;
	
	  if (!stackGroups) {
	    return {};
	  }
	
	  var result = {};
	  var numericAxisIds = Object.keys(stackGroups);
	
	  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
	    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
	    var stackIds = Object.keys(sgs);
	
	    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
	      var _sgs$stackIds$j = sgs[stackIds[j]],
	          items = _sgs$stackIds$j.items,
	          cateAxisId = _sgs$stackIds$j.cateAxisId;
	      var barItems = items.filter(function (item) {
	        return (0, _ReactUtils.getDisplayName)(item.type).indexOf('Bar') >= 0;
	      });
	
	      if (barItems && barItems.length) {
	        var selfSize = barItems[0].props.barSize;
	        var cateId = barItems[0].props[cateAxisId];
	
	        if (!result[cateId]) {
	          result[cateId] = [];
	        }
	
	        result[cateId].push({
	          item: barItems[0],
	          stackList: barItems.slice(1),
	          barSize: (0, _isNil2["default"])(selfSize) ? globalSize : selfSize
	        });
	      }
	    }
	  }
	
	  return result;
	};
	/**
	   * Calculate the size of each bar and the gap between two bars
	   * @param  {Number} bandSize  The size of each category
	   * @param  {sizeList} sizeList  The size of all groups
	   * @param  {maxBarSize} maxBarSize The maximum size of bar
	   * @return {Number} The size of each bar and the gap between two bars
	   */
	
	
	exports.getBarSizeList = getBarSizeList;
	
	var getBarPosition = function getBarPosition(_ref5) {
	  var barGap = _ref5.barGap,
	      barCategoryGap = _ref5.barCategoryGap,
	      bandSize = _ref5.bandSize,
	      _ref5$sizeList = _ref5.sizeList,
	      sizeList = _ref5$sizeList === void 0 ? [] : _ref5$sizeList,
	      maxBarSize = _ref5.maxBarSize;
	  var len = sizeList.length;
	  if (len < 1) return null;
	  var realBarGap = (0, _DataUtils.getPercentValue)(barGap, bandSize, 0, true);
	  var result; // whether or not is barSize setted by user
	
	  if (sizeList[0].barSize === +sizeList[0].barSize) {
	    var useFull = false;
	    var fullBarSize = bandSize / len;
	    var sum = sizeList.reduce(function (res, entry) {
	      return res + entry.barSize || 0;
	    }, 0);
	    sum += (len - 1) * realBarGap;
	
	    if (sum >= bandSize) {
	      sum -= (len - 1) * realBarGap;
	      realBarGap = 0;
	    }
	
	    if (sum >= bandSize && fullBarSize > 0) {
	      useFull = true;
	      fullBarSize *= 0.9;
	      sum = len * fullBarSize;
	    }
	
	    var offset = (bandSize - sum) / 2 >> 0;
	    var prev = {
	      offset: offset - realBarGap,
	      size: 0
	    };
	    result = sizeList.reduce(function (res, entry) {
	      var newRes = [].concat(_toConsumableArray(res), [{
	        item: entry.item,
	        position: {
	          offset: prev.offset + prev.size + realBarGap,
	          size: useFull ? fullBarSize : entry.barSize
	        }
	      }]);
	      prev = newRes[newRes.length - 1].position;
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({
	            item: item,
	            position: prev
	          });
	        });
	      }
	
	      return newRes;
	    }, []);
	  } else {
	    var _offset = (0, _DataUtils.getPercentValue)(barCategoryGap, bandSize, 0, true);
	
	    if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) {
	      realBarGap = 0;
	    }
	
	    var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
	
	    if (originalSize > 1) {
	      originalSize >>= 0;
	    }
	
	    var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
	    result = sizeList.reduce(function (res, entry, i) {
	      var newRes = [].concat(_toConsumableArray(res), [{
	        item: entry.item,
	        position: {
	          offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
	          size: size
	        }
	      }]);
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({
	            item: item,
	            position: newRes[newRes.length - 1].position
	          });
	        });
	      }
	
	      return newRes;
	    }, []);
	  }
	
	  return result;
	};
	
	exports.getBarPosition = getBarPosition;
	
	var appendOffsetOfLegend = function appendOffsetOfLegend(offset, items, props, legendBox) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      margin = props.margin;
	  var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	  var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	  var legendProps = getLegendProps({
	    children: children,
	    items: items,
	    legendWidth: legendWidth,
	    legendHeight: legendHeight
	  });
	  var newOffset = offset;
	
	  if (legendProps) {
	    var box = legendBox || {};
	    var align = legendProps.align,
	        verticalAlign = legendProps.verticalAlign,
	        layout = legendProps.layout;
	
	    if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'center') && (0, _DataUtils.isNumber)(offset[align])) {
	      newOffset = _objectSpread({}, offset, _defineProperty({}, align, newOffset[align] + (box.width || 0)));
	    }
	
	    if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && (0, _DataUtils.isNumber)(offset[verticalAlign])) {
	      newOffset = _objectSpread({}, offset, _defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
	    }
	  }
	
	  return newOffset;
	};
	
	exports.appendOffsetOfLegend = appendOffsetOfLegend;
	
	var getDomainOfErrorBars = function getDomainOfErrorBars(data, item, dataKey, axisType) {
	  var children = item.props.children;
	  var errorBars = (0, _ReactUtils.findAllByType)(children, _ErrorBar["default"]).filter(function (errorBarChild) {
	    var direction = errorBarChild.props.direction;
	    return (0, _isNil2["default"])(direction) || (0, _isNil2["default"])(axisType) ? true : axisType.indexOf(direction) >= 0;
	  });
	
	  if (errorBars && errorBars.length) {
	    var keys = errorBars.map(function (errorBarChild) {
	      return errorBarChild.props.dataKey;
	    });
	    return data.reduce(function (result, entry) {
	      var entryValue = getValueByDataKey(entry, dataKey, 0);
	      var mainValue = (0, _isArray2["default"])(entryValue) ? [(0, _min2["default"])(entryValue), (0, _max2["default"])(entryValue)] : [entryValue, entryValue];
	      var errorDomain = keys.reduce(function (prevErrorArr, k) {
	        var errorValue = getValueByDataKey(entry, k, 0);
	        var lowerValue = mainValue[0] - Math.abs((0, _isArray2["default"])(errorValue) ? errorValue[0] : errorValue);
	        var upperValue = mainValue[1] + Math.abs((0, _isArray2["default"])(errorValue) ? errorValue[1] : errorValue);
	        return [Math.min(lowerValue, prevErrorArr[0]), Math.max(upperValue, prevErrorArr[1])];
	      }, [Infinity, -Infinity]);
	      return [Math.min(errorDomain[0], result[0]), Math.max(errorDomain[1], result[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  return null;
	};
	
	exports.getDomainOfErrorBars = getDomainOfErrorBars;
	
	var parseErrorBarsOfAxis = function parseErrorBarsOfAxis(data, items, dataKey, axisType) {
	  var domains = items.map(function (item) {
	    return getDomainOfErrorBars(data, item, dataKey, axisType);
	  }).filter(function (entry) {
	    return !(0, _isNil2["default"])(entry);
	  });
	
	  if (domains && domains.length) {
	    return domains.reduce(function (result, entry) {
	      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  return null;
	};
	/**
	 * Get domain of data by the configuration of item element
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {Array}   items     The instances of item
	 * @param  {String}  type      The type of axis, number - Number Axis, category - Category Axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array}        Domain
	 */
	
	
	exports.parseErrorBarsOfAxis = parseErrorBarsOfAxis;
	
	var getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, filterNil) {
	  var domains = items.map(function (item) {
	    var dataKey = item.props.dataKey;
	
	    if (type === 'number' && dataKey) {
	      return getDomainOfErrorBars(data, item, dataKey) || getDomainOfDataByKey(data, dataKey, type, filterNil);
	    }
	
	    return getDomainOfDataByKey(data, dataKey, type, filterNil);
	  });
	
	  if (type === 'number') {
	    // Calculate the domain of number axis
	    return domains.reduce(function (result, entry) {
	      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  var tag = {}; // Get the union set of category axis
	
	  return domains.reduce(function (result, entry) {
	    for (var i = 0, len = entry.length; i < len; i++) {
	      if (!tag[entry[i]]) {
	        tag[entry[i]] = true;
	        result.push(entry[i]);
	      }
	    }
	
	    return result;
	  }, []);
	};
	
	exports.getDomainOfItemsWithSameAxis = getDomainOfItemsWithSameAxis;
	
	var isCategorialAxis = function isCategorialAxis(layout, axisType) {
	  return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
	};
	/**
	 * Calculate the Coordinates of grid
	 * @param  {Array} ticks The ticks in axis
	 * @param {Number} min   The minimun value of axis
	 * @param {Number} max   The maximun value of axis
	 * @return {Array}       Coordinates
	 */
	
	
	exports.isCategorialAxis = isCategorialAxis;
	
	var getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, min, max) {
	  var hasMin, hasMax;
	  var values = ticks.map(function (entry) {
	    if (entry.coordinate === min) {
	      hasMin = true;
	    }
	
	    if (entry.coordinate === max) {
	      hasMax = true;
	    }
	
	    return entry.coordinate;
	  });
	
	  if (!hasMin) {
	    values.push(min);
	  }
	
	  if (!hasMax) {
	    values.push(max);
	  }
	
	  return values;
	};
	/**
	 * Get the ticks of an axis
	 * @param  {Object}  axis The configuration of an axis
	 * @param {Boolean} isGrid Whether or not are the ticks in grid
	 * @param {Boolean} isAll Return the ticks of all the points or not
	 * @return {Array}  Ticks
	 */
	
	
	exports.getCoordinatesOfGrid = getCoordinatesOfGrid;
	
	var getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
	  if (!axis) return null;
	  var scale = axis.scale;
	  var duplicateDomain = axis.duplicateDomain,
	      type = axis.type,
	      range = axis.range;
	  var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / 2 : 0;
	  offset = axis.axisType === 'angleAxis' ? (0, _DataUtils.mathSign)(range[0] - range[1]) * 2 * offset : offset; // The ticks setted by user should only affect the ticks adjacent to axis line
	
	  if (isGrid && (axis.ticks || axis.niceTicks)) {
	    return (axis.ticks || axis.niceTicks).map(function (entry) {
	      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
	      return {
	        coordinate: scale(scaleContent) + offset,
	        value: entry,
	        offset: offset
	      };
	    });
	  }
	
	  if (axis.isCategorial && axis.categoricalDomain) {
	    return axis.categoricalDomain.map(function (entry, index) {
	      return {
	        coordinate: scale(entry),
	        value: entry,
	        index: index,
	        offset: offset
	      };
	    });
	  }
	
	  if (scale.ticks && !isAll) {
	    return scale.ticks(axis.tickCount).map(function (entry) {
	      return {
	        coordinate: scale(entry) + offset,
	        value: entry,
	        offset: offset
	      };
	    });
	  } // When axis has duplicated text, serial numbers are used to generate scale
	
	
	  return scale.domain().map(function (entry, index) {
	    return {
	      coordinate: scale(entry) + offset,
	      value: duplicateDomain ? duplicateDomain[entry] : entry,
	      index: index,
	      offset: offset
	    };
	  });
	};
	/**
	 * combine the handlers
	 * @param  {Function} defaultHandler Internal private handler
	 * @param  {Function} parentHandler  Handler function specified in parent component
	 * @param  {Function} childHandler   Handler function specified in child component
	 * @return {Function}                The combined handler
	 */
	
	
	exports.getTicksOfAxis = getTicksOfAxis;
	
	var combineEventHandlers = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
	  var customizedHandler;
	
	  if ((0, _isFunction2["default"])(childHandler)) {
	    customizedHandler = childHandler;
	  } else if ((0, _isFunction2["default"])(parentHandler)) {
	    customizedHandler = parentHandler;
	  }
	
	  if ((0, _isFunction2["default"])(defaultHandler) || customizedHandler) {
	    return function (arg1, arg2, arg3, arg4) {
	      if ((0, _isFunction2["default"])(defaultHandler)) {
	        defaultHandler(arg1, arg2, arg3, arg4);
	      }
	
	      if ((0, _isFunction2["default"])(customizedHandler)) {
	        customizedHandler(arg1, arg2, arg3, arg4);
	      }
	    };
	  }
	
	  return null;
	};
	/**
	 * Parse the scale function of axis
	 * @param  {Object}   axis          The option of axis
	 * @param  {String}   chartType     The displayName of chart
	 * @return {Function}               The scale funcion
	 */
	
	
	exports.combineEventHandlers = combineEventHandlers;
	
	var parseScale = function parseScale(axis, chartType) {
	  var scale = axis.scale,
	      type = axis.type,
	      layout = axis.layout,
	      axisType = axis.axisType;
	
	  if (scale === 'auto') {
	    if (layout === 'radial' && axisType === 'radiusAxis') {
	      return {
	        scale: d3Scales.scaleBand(),
	        realScaleType: 'band'
	      };
	    }
	
	    if (layout === 'radial' && axisType === 'angleAxis') {
	      return {
	        scale: d3Scales.scaleLinear(),
	        realScaleType: 'linear'
	      };
	    }
	
	    if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0)) {
	      return {
	        scale: d3Scales.scalePoint(),
	        realScaleType: 'point'
	      };
	    }
	
	    if (type === 'category') {
	      return {
	        scale: d3Scales.scaleBand(),
	        realScaleType: 'band'
	      };
	    }
	
	    return {
	      scale: d3Scales.scaleLinear(),
	      realScaleType: 'linear'
	    };
	  }
	
	  if ((0, _isString2["default"])(scale)) {
	    var name = "scale".concat(scale.slice(0, 1).toUpperCase()).concat(scale.slice(1));
	    return {
	      scale: (d3Scales[name] || d3Scales.scalePoint)(),
	      realScaleType: d3Scales[name] ? name : 'point'
	    };
	  }
	
	  return (0, _isFunction2["default"])(scale) ? {
	    scale: scale
	  } : {
	    scale: d3Scales.scalePoint(),
	    realScaleType: 'point'
	  };
	};
	
	exports.parseScale = parseScale;
	var EPS = 1e-4;
	
	var checkDomainOfScale = function checkDomainOfScale(scale) {
	  var domain = scale.domain();
	
	  if (!domain || domain.length <= 2) {
	    return;
	  }
	
	  var len = domain.length;
	  var range = scale.range();
	  var min = Math.min(range[0], range[1]) - EPS;
	  var max = Math.max(range[0], range[1]) + EPS;
	  var first = scale(domain[0]);
	  var last = scale(domain[len - 1]);
	
	  if (first < min || first > max || last < min || last > max) {
	    scale.domain([domain[0], domain[len - 1]]);
	  }
	};
	
	exports.checkDomainOfScale = checkDomainOfScale;
	
	var findPositionOfBar = function findPositionOfBar(barPosition, child) {
	  if (!barPosition) {
	    return null;
	  }
	
	  for (var i = 0, len = barPosition.length; i < len; i++) {
	    if (barPosition[i].item === child) {
	      return barPosition[i].position;
	    }
	  }
	
	  return null;
	};
	
	exports.findPositionOfBar = findPositionOfBar;
	
	var truncateByDomain = function truncateByDomain(value, domain) {
	  if (!domain || domain.length !== 2 || !(0, _DataUtils.isNumber)(domain[0]) || !(0, _DataUtils.isNumber)(domain[1])) {
	    return value;
	  }
	
	  var min = Math.min(domain[0], domain[1]);
	  var max = Math.max(domain[0], domain[1]);
	  var result = [value[0], value[1]];
	
	  if (!(0, _DataUtils.isNumber)(value[0]) || value[0] < min) {
	    result[0] = min;
	  }
	
	  if (!(0, _DataUtils.isNumber)(value[1]) || value[1] > max) {
	    result[1] = max;
	  }
	
	  if (result[0] > max) {
	    result[0] = max;
	  }
	
	  if (result[1] < min) {
	    result[1] = min;
	  }
	
	  return result;
	};
	/* eslint no-param-reassign: 0 */
	
	
	exports.truncateByDomain = truncateByDomain;
	
	var offsetSign = function offsetSign(series) {
	  var n = series.length;
	
	  if (n <= 0) {
	    return;
	  }
	
	  for (var j = 0, m = series[0].length; j < m; ++j) {
	    var positive = 0;
	    var negative = 0;
	
	    for (var i = 0; i < n; ++i) {
	      var value = (0, _isNaN2["default"])(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
	      /* eslint-disable prefer-destructuring */
	
	      if (value >= 0) {
	        series[i][j][0] = positive;
	        series[i][j][1] = positive + value;
	        positive = series[i][j][1];
	      } else {
	        series[i][j][0] = negative;
	        series[i][j][1] = negative + value;
	        negative = series[i][j][1];
	      }
	      /* eslint-enable prefer-destructuring */
	
	    }
	  }
	};
	
	exports.offsetSign = offsetSign;
	var STACK_OFFSET_MAP = {
	  sign: offsetSign,
	  expand: _d3Shape.stackOffsetExpand,
	  none: _d3Shape.stackOffsetNone,
	  silhouette: _d3Shape.stackOffsetSilhouette,
	  wiggle: _d3Shape.stackOffsetWiggle
	};
	
	var getStackedData = function getStackedData(data, stackItems, offsetType) {
	  var dataKeys = stackItems.map(function (item) {
	    return item.props.dataKey;
	  });
	  var stack = (0, _d3Shape.stack)().keys(dataKeys).value(function (d, key) {
	    return +getValueByDataKey(d, key, 0);
	  }).order(_d3Shape.stackOrderNone).offset(STACK_OFFSET_MAP[offsetType]);
	  return stack(data);
	};
	
	exports.getStackedData = getStackedData;
	
	var getStackGroupsByAxisId = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
	  if (!data) {
	    return null;
	  } // reversing items to affect render order (for layering)
	
	
	  var items = reverseStackOrder ? _items.reverse() : _items;
	  var stackGroups = items.reduce(function (result, item) {
	    var _item$props3 = item.props,
	        stackId = _item$props3.stackId,
	        hide = _item$props3.hide;
	
	    if (hide) {
	      return result;
	    }
	
	    var axisId = item.props[numericAxisId];
	    var parentGroup = result[axisId] || {
	      hasStack: false,
	      stackGroups: {}
	    };
	
	    if ((0, _DataUtils.isNumOrStr)(stackId)) {
	      var childGroup = parentGroup.stackGroups[stackId] || {
	        numericAxisId: numericAxisId,
	        cateAxisId: cateAxisId,
	        items: []
	      };
	      childGroup.items.push(item);
	      parentGroup.hasStack = true;
	      parentGroup.stackGroups[stackId] = childGroup;
	    } else {
	      parentGroup.stackGroups[(0, _DataUtils.uniqueId)('_stackId_')] = {
	        numericAxisId: numericAxisId,
	        cateAxisId: cateAxisId,
	        items: [item]
	      };
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, axisId, parentGroup));
	  }, {});
	  return Object.keys(stackGroups).reduce(function (result, axisId) {
	    var group = stackGroups[axisId];
	
	    if (group.hasStack) {
	      group.stackGroups = Object.keys(group.stackGroups).reduce(function (res, stackId) {
	        var g = group.stackGroups[stackId];
	        return _objectSpread({}, res, _defineProperty({}, stackId, {
	          numericAxisId: numericAxisId,
	          cateAxisId: cateAxisId,
	          items: g.items,
	          stackedData: getStackedData(data, g.items, offsetType)
	        }));
	      }, {});
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, axisId, group));
	  }, {});
	};
	/**
	 * get domain of ticks
	 * @param  {Array} ticks Ticks of axis
	 * @param  {String} type  The type of axis
	 * @return {Array} domain
	 */
	
	
	exports.getStackGroupsByAxisId = getStackGroupsByAxisId;
	
	var calculateDomainOfTicks = function calculateDomainOfTicks(ticks, type) {
	  if (type === 'number') {
	    return [(0, _min2["default"])(ticks), (0, _max2["default"])(ticks)];
	  }
	
	  return ticks;
	};
	/**
	 * Configure the scale function of axis
	 * @param {Object} scale The scale function
	 * @param {Object} opts  The configuration of axis
	 * @return {Object}      null
	 */
	
	
	exports.calculateDomainOfTicks = calculateDomainOfTicks;
	
	var getTicksOfScale = function getTicksOfScale(scale, opts) {
	  var realScaleType = opts.realScaleType,
	      type = opts.type,
	      tickCount = opts.tickCount,
	      originalDomain = opts.originalDomain,
	      allowDecimals = opts.allowDecimals;
	  var scaleType = realScaleType || opts.scale;
	
	  if (scaleType !== 'auto' && scaleType !== 'linear') {
	    return null;
	  }
	
	  if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
	    // Calculate the ticks by the number of grid when the axis is a number axis
	    var domain = scale.domain();
	    var tickValues = (0, _rechartsScale.getNiceTickValues)(domain, tickCount, allowDecimals);
	    scale.domain(calculateDomainOfTicks(tickValues, type));
	    return {
	      niceTicks: tickValues
	    };
	  }
	
	  if (tickCount && type === 'number') {
	    var _domain = scale.domain();
	
	    var _tickValues = (0, _rechartsScale.getTickValuesFixedDomain)(_domain, tickCount, allowDecimals);
	
	    return {
	      niceTicks: _tickValues
	    };
	  }
	
	  return null;
	};
	
	exports.getTicksOfScale = getTicksOfScale;
	
	var getCateCoordinateOfLine = function getCateCoordinateOfLine(_ref6) {
	  var axis = _ref6.axis,
	      ticks = _ref6.ticks,
	      bandSize = _ref6.bandSize,
	      entry = _ref6.entry,
	      index = _ref6.index,
	      dataKey = _ref6.dataKey;
	
	  if (axis.type === 'category') {
	    // find coordinate of category axis by the value of category
	    if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, _isNil2["default"])(entry[axis.dataKey])) {
	      var matchedTick = (0, _DataUtils.findEntryInArray)(ticks, 'value', entry[axis.dataKey]);
	
	      if (matchedTick) {
	        return matchedTick.coordinate + bandSize / 2;
	      }
	    }
	
	    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
	  }
	
	  var value = getValueByDataKey(entry, !(0, _isNil2["default"])(dataKey) ? dataKey : axis.dataKey);
	  return !(0, _isNil2["default"])(value) ? axis.scale(value) : null;
	};
	
	exports.getCateCoordinateOfLine = getCateCoordinateOfLine;
	
	var getCateCoordinateOfBar = function getCateCoordinateOfBar(_ref7) {
	  var axis = _ref7.axis,
	      ticks = _ref7.ticks,
	      offset = _ref7.offset,
	      bandSize = _ref7.bandSize,
	      entry = _ref7.entry,
	      index = _ref7.index;
	
	  if (axis.type === 'category') {
	    return ticks[index] ? ticks[index].coordinate + offset : null;
	  }
	
	  var value = getValueByDataKey(entry, axis.dataKey, axis.domain[index]);
	  return !(0, _isNil2["default"])(value) ? axis.scale(value) - bandSize / 2 + offset : null;
	};
	
	exports.getCateCoordinateOfBar = getCateCoordinateOfBar;
	
	var getBaseValueOfBar = function getBaseValueOfBar(_ref8) {
	  var numericAxis = _ref8.numericAxis;
	  var domain = numericAxis.scale.domain();
	
	  if (numericAxis.type === 'number') {
	    var min = Math.min(domain[0], domain[1]);
	    var max = Math.max(domain[0], domain[1]);
	
	    if (min <= 0 && max >= 0) {
	      return 0;
	    }
	
	    if (max < 0) {
	      return max;
	    }
	
	    return min;
	  }
	
	  return domain[0];
	};
	
	exports.getBaseValueOfBar = getBaseValueOfBar;
	
	var getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
	  var stackId = item.props.stackId;
	
	  if ((0, _DataUtils.isNumOrStr)(stackId)) {
	    var group = stackGroups[stackId];
	
	    if (group && group.items.length) {
	      var itemIndex = -1;
	
	      for (var i = 0, len = group.items.length; i < len; i++) {
	        if (group.items[i] === item) {
	          itemIndex = i;
	          break;
	        }
	      }
	
	      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
	    }
	  }
	
	  return null;
	};
	
	exports.getStackedDataOfItem = getStackedDataOfItem;
	
	var getDomainOfSingle = function getDomainOfSingle(data) {
	  return data.reduce(function (result, entry) {
	    return [(0, _min2["default"])(entry.concat([result[0]]).filter(_DataUtils.isNumber)), (0, _max2["default"])(entry.concat([result[1]]).filter(_DataUtils.isNumber))];
	  }, [Infinity, -Infinity]);
	};
	
	var getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
	  return Object.keys(stackGroups).reduce(function (result, stackId) {
	    var group = stackGroups[stackId];
	    var stackedData = group.stackedData;
	    var domain = stackedData.reduce(function (res, entry) {
	      var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
	      return [Math.min(res[0], s[0]), Math.max(res[1], s[1])];
	    }, [Infinity, -Infinity]);
	    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
	  }, [Infinity, -Infinity]).map(function (result) {
	    return result === Infinity || result === -Infinity ? 0 : result;
	  });
	};
	
	exports.getDomainOfStackGroups = getDomainOfStackGroups;
	var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
	exports.MIN_VALUE_REG = MIN_VALUE_REG;
	var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
	exports.MAX_VALUE_REG = MAX_VALUE_REG;
	
	var parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
	  if (!(0, _isArray2["default"])(specifiedDomain)) {
	    return dataDomain;
	  }
	
	  var domain = [];
	  /* eslint-disable prefer-destructuring */
	
	  if ((0, _DataUtils.isNumber)(specifiedDomain[0])) {
	    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
	  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
	    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
	    domain[0] = dataDomain[0] - value;
	  } else if ((0, _isFunction2["default"])(specifiedDomain[0])) {
	    domain[0] = specifiedDomain[0](dataDomain[0]);
	  } else {
	    domain[0] = dataDomain[0];
	  }
	
	  if ((0, _DataUtils.isNumber)(specifiedDomain[1])) {
	    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
	  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
	    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
	
	    domain[1] = dataDomain[1] + _value;
	  } else if ((0, _isFunction2["default"])(specifiedDomain[1])) {
	    domain[1] = specifiedDomain[1](dataDomain[1]);
	  } else {
	    domain[1] = dataDomain[1];
	  }
	  /* eslint-enable prefer-destructuring */
	
	
	  return domain;
	};
	/**
	 * Calculate the size between two category
	 * @param  {Object} axis  The options of axis
	 * @param  {Array}  ticks The ticks of axis
	 * @return {Number} Size
	 */
	
	
	exports.parseSpecifiedDomain = parseSpecifiedDomain;
	
	var getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks) {
	  if (axis && axis.scale && axis.scale.bandwidth) {
	    return axis.scale.bandwidth();
	  }
	
	  if (axis && ticks && ticks.length >= 2) {
	    var orderedTicks = (0, _sortBy2["default"])(ticks, function (o) {
	      return o.coordinate;
	    });
	    var bandSize = Infinity;
	
	    for (var i = 1, len = orderedTicks.length; i < len; i++) {
	      var cur = orderedTicks[i];
	      var prev = orderedTicks[i - 1];
	      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
	    }
	
	    return bandSize === Infinity ? 0 : bandSize;
	  }
	
	  return 0;
	};
	/**
	 * parse the domain of a category axis when a domain is specified
	 * @param   {Array}        specifiedDomain  The domain specified by users
	 * @param   {Array}        calculatedDomain The domain calculated by dateKey
	 * @param   {ReactElement} axisChild        The axis element
	 * @returns {Array}        domains
	 */
	
	
	exports.getBandSizeOfAxis = getBandSizeOfAxis;
	
	var parseDomainOfCategoryAxis = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
	  if (!specifiedDomain || !specifiedDomain.length) {
	    return calculatedDomain;
	  }
	
	  if ((0, _isEqual2["default"])(specifiedDomain, (0, _get2["default"])(axisChild, 'type.defaultProps.domain'))) {
	    return calculatedDomain;
	  }
	
	  return specifiedDomain;
	};
	
	exports.parseDomainOfCategoryAxis = parseDomainOfCategoryAxis;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftModifier
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(112);
	var ContentStateInlineStyle = __webpack_require__(1209);
	var DraftFeatureFlags = __webpack_require__(183);
	var Immutable = __webpack_require__(60);
	
	var applyEntityToContentState = __webpack_require__(1228);
	var getCharacterRemovalRange = __webpack_require__(1249);
	var getContentStateFragment = __webpack_require__(334);
	var insertFragmentIntoContentState = __webpack_require__(1254);
	var insertTextIntoContentState = __webpack_require__(1255);
	var invariant = __webpack_require__(28);
	var modifyBlockForContentState = __webpack_require__(1266);
	var removeEntitiesAtEdges = __webpack_require__(663);
	var removeRangeFromContentState = __webpack_require__(1268);
	var splitBlockInContentState = __webpack_require__(1270);
	
	var OrderedSet = Immutable.OrderedSet;
	
	/**
	 * `DraftModifier` provides a set of convenience methods that apply
	 * modifications to a `ContentState` object based on a target `SelectionState`.
	 *
	 * Any change to a `ContentState` should be decomposable into a series of
	 * transaction functions that apply the required changes and return output
	 * `ContentState` objects.
	 *
	 * These functions encapsulate some of the most common transaction sequences.
	 */
	
	var DraftModifier = {
	  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace);
	    var withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace);
	
	    var character = CharacterMetadata.create({
	      style: inlineStyle || OrderedSet(),
	      entity: entityKey || null
	    });
	
	    return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
	  },
	
	  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
	    !targetRange.isCollapsed() ?  false ? invariant(false, 'Target range must be collapsed for `insertText`.') : invariant(false) : void 0;
	    return DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
	  },
	
	  moveText: function moveText(contentState, removalRange, targetRange) {
	    var movedFragment = getContentStateFragment(contentState, removalRange);
	
	    var afterRemoval = DraftModifier.removeRange(contentState, removalRange, 'backward');
	
	    return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
	  },
	
	  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, targetRange);
	    var withoutText = removeRangeFromContentState(withoutEntities, targetRange);
	
	    return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment);
	  },
	
	  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
	    var startKey = void 0,
	        endKey = void 0,
	        startBlock = void 0,
	        endBlock = void 0;
	    if (rangeToRemove.getIsBackward()) {
	      rangeToRemove = rangeToRemove.merge({
	        anchorKey: rangeToRemove.getFocusKey(),
	        anchorOffset: rangeToRemove.getFocusOffset(),
	        focusKey: rangeToRemove.getAnchorKey(),
	        focusOffset: rangeToRemove.getAnchorOffset(),
	        isBackward: false
	      });
	    }
	    startKey = rangeToRemove.getAnchorKey();
	    endKey = rangeToRemove.getFocusKey();
	    startBlock = contentState.getBlockForKey(startKey);
	    endBlock = contentState.getBlockForKey(endKey);
	    var startOffset = rangeToRemove.getStartOffset();
	    var endOffset = rangeToRemove.getEndOffset();
	
	    var startEntityKey = startBlock.getEntityAt(startOffset);
	    var endEntityKey = endBlock.getEntityAt(endOffset - 1);
	
	    // Check whether the selection state overlaps with a single entity.
	    // If so, try to remove the appropriate substring of the entity text.
	    if (startKey === endKey) {
	      if (startEntityKey && startEntityKey === endEntityKey) {
	        var _adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
	        return removeRangeFromContentState(contentState, _adjustedRemovalRange);
	      }
	    }
	    var adjustedRemovalRange = rangeToRemove;
	    if (DraftFeatureFlags.draft_segmented_entities_behavior) {
	      // Adjust the selection to properly delete segemented and immutable
	      // entities
	      adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
	    }
	
	    var withoutEntities = removeEntitiesAtEdges(contentState, adjustedRemovalRange);
	    return removeRangeFromContentState(withoutEntities, adjustedRemovalRange);
	  },
	
	  splitBlock: function splitBlock(contentState, selectionState) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
	    var withoutText = removeRangeFromContentState(withoutEntities, selectionState);
	
	    return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
	  },
	
	  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
	    return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
	  },
	
	  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
	    return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
	  },
	
	  setBlockType: function setBlockType(contentState, selectionState, blockType) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({ type: blockType, depth: 0 });
	    });
	  },
	
	  setBlockData: function setBlockData(contentState, selectionState, blockData) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({ data: blockData });
	    });
	  },
	
	  mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({ data: block.getData().merge(blockData) });
	    });
	  },
	
	  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
	    return applyEntityToContentState(withoutEntities, selectionState, entityKey);
	  }
	};
	
	module.exports = DraftModifier;

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Paper = __webpack_require__(1531);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Paper2.default;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _TabTemplate = __webpack_require__(1548);
	
	var _TabTemplate2 = _interopRequireDefault(_TabTemplate);
	
	var _InkBar = __webpack_require__(1547);
	
	var _InkBar2 = _interopRequireDefault(_InkBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tabs = context.muiTheme.tabs;
	
	
	  return {
	    tabItemContainer: {
	      width: '100%',
	      backgroundColor: tabs.backgroundColor,
	      whiteSpace: 'nowrap',
	      display: 'flex'
	    }
	  };
	}
	
	var Tabs = function (_Component) {
	  (0, _inherits3.default)(Tabs, _Component);
	
	  function Tabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = { selectedIndex: 0 }, _this.handleTabTouchTap = function (value, event, tab) {
	      var valueLink = _this.getValueLink(_this.props);
	      var index = tab.props.index;
	
	      if (valueLink.value && valueLink.value !== value || _this.state.selectedIndex !== index) {
	        valueLink.requestChange(value, event, tab);
	      }
	
	      _this.setState({ selectedIndex: index });
	
	      if (tab.props.onActive) {
	        tab.props.onActive(tab);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tabs, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var valueLink = this.getValueLink(this.props);
	      var initialIndex = this.props.initialSelectedIndex;
	
	      this.setState({
	        selectedIndex: valueLink.value !== undefined ? this.getSelectedIndex(this.props) : initialIndex < this.getTabCount() ? initialIndex : 0
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps, nextContext) {
	      var valueLink = this.getValueLink(newProps);
	      var newState = {
	        muiTheme: nextContext.muiTheme || this.context.muiTheme
	      };
	
	      if (valueLink.value !== undefined) {
	        newState.selectedIndex = this.getSelectedIndex(newProps);
	      }
	
	      this.setState(newState);
	    }
	  }, {
	    key: 'getTabs',
	    value: function getTabs() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      var tabs = [];
	
	      _react.Children.forEach(props.children, function (tab) {
	        if ((0, _react.isValidElement)(tab)) {
	          tabs.push(tab);
	        }
	      });
	
	      return tabs;
	    }
	  }, {
	    key: 'getTabCount',
	    value: function getTabCount() {
	      return this.getTabs().length;
	    }
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	
	  }, {
	    key: 'getValueLink',
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'getSelectedIndex',
	    value: function getSelectedIndex(props) {
	      var valueLink = this.getValueLink(props);
	      var selectedIndex = -1;
	
	      this.getTabs(props).forEach(function (tab, index) {
	        if (valueLink.value === tab.props.value) {
	          selectedIndex = index;
	        }
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected(tab, index) {
	      var valueLink = this.getValueLink(this.props);
	      return valueLink.value ? valueLink.value === tab.props.value : this.state.selectedIndex === index;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          contentContainerClassName = _props.contentContainerClassName,
	          contentContainerStyle = _props.contentContainerStyle,
	          initialSelectedIndex = _props.initialSelectedIndex,
	          inkBarStyle = _props.inkBarStyle,
	          onChange = _props.onChange,
	          style = _props.style,
	          tabItemContainerStyle = _props.tabItemContainerStyle,
	          tabTemplate = _props.tabTemplate,
	          tabTemplateStyle = _props.tabTemplateStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['contentContainerClassName', 'contentContainerStyle', 'initialSelectedIndex', 'inkBarStyle', 'onChange', 'style', 'tabItemContainerStyle', 'tabTemplate', 'tabTemplateStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var valueLink = this.getValueLink(this.props);
	      var tabValue = valueLink.value;
	      var tabContent = [];
	      var width = 100 / this.getTabCount();
	
	      var tabs = this.getTabs().map(function (tab, index) {
	         false ? (0, _warning2.default)(tab.type && tab.type.muiName === 'Tab', 'Material-UI: Tabs only accepts Tab Components as children.\n        Found ' + (tab.type.muiName || tab.type) + ' as child number ' + (index + 1) + ' of Tabs') : void 0;
	
	         false ? (0, _warning2.default)(!tabValue || tab.props.value !== undefined, 'Material-UI: Tabs value prop has been passed, but Tab ' + index + '\n        does not have a value prop. Needs value if Tabs is going\n        to be a controlled component.') : void 0;
	
	        tabContent.push(tab.props.children ? (0, _react.createElement)(tabTemplate || _TabTemplate2.default, {
	          key: index,
	          selected: _this2.getSelected(tab, index),
	          style: tabTemplateStyle
	        }, tab.props.children) : undefined);
	
	        return (0, _react.cloneElement)(tab, {
	          key: index,
	          index: index,
	          selected: _this2.getSelected(tab, index),
	          width: width + '%',
	          onClick: _this2.handleTabTouchTap
	        });
	      });
	
	      var realSelectedIndex = valueLink.value ? this.getSelectedIndex(this.props) : this.state.selectedIndex;
	
	      var inkBar = realSelectedIndex !== -1 ? _react2.default.createElement(_InkBar2.default, {
	        left: width * realSelectedIndex + '%',
	        width: width + '%',
	        style: inkBarStyle
	      }) : null;
	
	      var inkBarContainerWidth = tabItemContainerStyle ? tabItemContainerStyle.width : '100%';
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.tabItemContainer, tabItemContainerStyle)) },
	          tabs
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { width: inkBarContainerWidth } },
	          inkBar
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: prepareStyles((0, _simpleAssign2.default)({}, contentContainerStyle)),
	            className: contentContainerClassName
	          },
	          tabContent
	        )
	      );
	    }
	  }]);
	  return Tabs;
	}(_react.Component);
	
	Tabs.defaultProps = {
	  initialSelectedIndex: 0,
	  onChange: function onChange() {}
	};
	Tabs.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Tabs.propTypes =  false ? {
	  /**
	   * Should be used to pass `Tab` components.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The css class name of the content's container.
	   */
	  contentContainerClassName: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the content's container.
	   */
	  contentContainerStyle: _propTypes2.default.object,
	  /**
	   * Specify initial visible tab index.
	   * If `initialSelectedIndex` is set but larger than the total amount of specified tabs,
	   * `initialSelectedIndex` will revert back to default.
	   * If `initialSelectedIndex` is set to any negative value, no tab will be selected intially.
	   */
	  initialSelectedIndex: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the InkBar.
	   */
	  inkBarStyle: _propTypes2.default.object,
	  /**
	   * Called when the selected value change.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the tab-labels container.
	   */
	  tabItemContainerStyle: _propTypes2.default.object,
	  /**
	   * Override the default tab template used to wrap the content of each tab element.
	   */
	  tabTemplate: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the tab template.
	   */
	  tabTemplateStyle: _propTypes2.default.object,
	  /**
	   * Makes Tabs controllable and selects the tab whose value prop matches this prop.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = Tabs;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only maps over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @return {object} Object containing the ordered map of results.
	 */
	function map(children, func, context) {
	  var index = 0;
	
	  return _react2.default.Children.map(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return child;
	    }
	
	    return func.call(context, child, index++);
	  });
	}
	
	/**
	 * Iterates through children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for context.
	 */
	// TODO: This module should be ElementChildren, and should use named exports.
	
	function forEach(children, func, context) {
	  var index = 0;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    func.call(context, child, index++);
	  });
	}
	
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	function count(children) {
	  var result = 0;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    ++result;
	  });
	
	  return result;
	}
	
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @returns {array} of children that meet the func return statement
	 */
	function filter(children, func, context) {
	  var index = 0;
	  var result = [];
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result.push(child);
	    }
	  });
	
	  return result;
	}
	
	function find(children, func, context) {
	  var index = 0;
	  var result = void 0;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = child;
	    }
	  });
	
	  return result;
	}
	
	function every(children, func, context) {
	  var index = 0;
	  var result = true;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!result) {
	      return;
	    }
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    if (!func.call(context, child, index++)) {
	      result = false;
	    }
	  });
	
	  return result;
	}
	
	function some(children, func, context) {
	  var index = 0;
	  var result = false;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = true;
	    }
	  });
	
	  return result;
	}
	
	function toArray(children) {
	  var result = [];
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    result.push(child);
	  });
	
	  return result;
	}
	
	exports.default = {
	  map: map,
	  forEach: forEach,
	  count: count,
	  find: find,
	  filter: filter,
	  every: every,
	  some: some,
	  toArray: toArray
	};
	module.exports = exports['default'];

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var _a;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.nonReplacedDocumentFp = exports.Contract = exports.Document = exports.DocumentTemplate = exports.DocumentTemplateResource = exports.DocumentType = exports.CONTRACTTYPE_MAP = exports.DOCUMENTATTACHMENTTYPE = exports.CONTRACTSTATUS = exports.CONTRACTTYPE = exports.DOCUMENTFORMAT = exports.DOCUMENTSTATUS = exports.DOCUMENTLOCATION = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var stringUtils_1 = __webpack_require__(174);
	var colors_1 = __webpack_require__(29);
	var DOCUMENTLOCATION;
	(function (DOCUMENTLOCATION) {
	    DOCUMENTLOCATION["Invoice"] = "Invoice";
	})(DOCUMENTLOCATION || (exports.DOCUMENTLOCATION = DOCUMENTLOCATION = {}));
	var DOCUMENTSTATUS;
	(function (DOCUMENTSTATUS) {
	    DOCUMENTSTATUS["REPLACED"] = "REPLACED";
	    DOCUMENTSTATUS["VALID"] = "VALID";
	})(DOCUMENTSTATUS || (exports.DOCUMENTSTATUS = DOCUMENTSTATUS = {}));
	var DOCUMENTFORMAT;
	(function (DOCUMENTFORMAT) {
	    DOCUMENTFORMAT["PDF"] = "PDF";
	    DOCUMENTFORMAT["PS"] = "PS";
	    DOCUMENTFORMAT["DOCX"] = "DOCX";
	    DOCUMENTFORMAT["DOC"] = "DOC";
	    DOCUMENTFORMAT["XLSX"] = "XLSX";
	    DOCUMENTFORMAT["XLS"] = "XLS";
	    DOCUMENTFORMAT["TXT"] = "TXT";
	    DOCUMENTFORMAT["CSV"] = "CSV";
	    DOCUMENTFORMAT["XML"] = "XML";
	    DOCUMENTFORMAT["XML_OBJECT"] = "XML_OBJECT";
	    DOCUMENTFORMAT["ZIP"] = "ZIP";
	})(DOCUMENTFORMAT || (exports.DOCUMENTFORMAT = DOCUMENTFORMAT = {}));
	var CONTRACTTYPE;
	(function (CONTRACTTYPE) {
	    CONTRACTTYPE["CUSTOMER_CONTRACT"] = "CUSTOMER_CONTRACT";
	    CONTRACTTYPE["DIRECT_DEBIT"] = "DIRECT_DEBIT";
	})(CONTRACTTYPE || (exports.CONTRACTTYPE = CONTRACTTYPE = {}));
	var CONTRACTSTATUS;
	(function (CONTRACTSTATUS) {
	    CONTRACTSTATUS["DRAFT"] = "DRAFT";
	    CONTRACTSTATUS["SEND_FOR_SIGNING"] = "SEND_FOR_SIGNING";
	    CONTRACTSTATUS["SIGNED"] = "SIGNED";
	    CONTRACTSTATUS["EXPIRED"] = "EXPIRED";
	    CONTRACTSTATUS["CANCELED"] = "CANCELED";
	})(CONTRACTSTATUS || (exports.CONTRACTSTATUS = CONTRACTSTATUS = {}));
	var DOCUMENTATTACHMENTTYPE;
	(function (DOCUMENTATTACHMENTTYPE) {
	    DOCUMENTATTACHMENTTYPE["NO_INCLUDE"] = "NO_INCLUDE";
	    DOCUMENTATTACHMENTTYPE["SEPARATE_INCLUDE"] = "SEPARATE_INCLUDE";
	    DOCUMENTATTACHMENTTYPE["PDF_INCLUDE"] = "PDF_INCLUDE";
	})(DOCUMENTATTACHMENTTYPE || (exports.DOCUMENTATTACHMENTTYPE = DOCUMENTATTACHMENTTYPE = {}));
	exports.CONTRACTTYPE_MAP = (_a = {},
	    _a[CONTRACTTYPE.CUSTOMER_CONTRACT] = { backgroundColor: colors_1.blue500 },
	    _a[CONTRACTTYPE.DIRECT_DEBIT] = { backgroundColor: colors_1.amber500 },
	    _a);
	var DocumentType = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentType, _super);
	    function DocumentType(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.tenantGroups)
	            _this.tenantGroups = [];
	        if (!_this.tenants)
	            _this.tenants = [];
	        if (!_this.gridLocations)
	            _this.gridLocations = [];
	        return _this;
	    }
	    DocumentType.prototype.getId = function () {
	        return this.documentTypeId;
	    };
	    DocumentType.prototype.setId = function (id) {
	        this.documentTypeId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentType.prototype, "documentTypeId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentType.prototype, "documentName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentType.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentType.prototype, "type", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentType.prototype, "format", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentType.prototype, "templateType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentType.prototype, "cardinality", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentType.prototype, "langSource", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentType.prototype, "location", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentType.prototype, "tenantGroups", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentType.prototype, "tenants", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentType.prototype, "gridLocations", void 0);
	    DocumentType = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], DocumentType);
	    return DocumentType;
	}(DomainAncestor_1.DomainAncestor));
	exports.DocumentType = DocumentType;
	var DocumentTemplateResource = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentTemplateResource, _super);
	    function DocumentTemplateResource(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentTemplateResource.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentTemplateResource.prototype, "lastModified", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentTemplateResource.prototype, "size", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentTemplateResource.prototype, "contentType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentTemplateResource.prototype, "type", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentTemplateResource.prototype, "qualifyExpression", void 0);
	    DocumentTemplateResource = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], DocumentTemplateResource);
	    return DocumentTemplateResource;
	}(DomainAncestor_1.DomainAncestor));
	exports.DocumentTemplateResource = DocumentTemplateResource;
	var DocumentTemplate = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentTemplate, _super);
	    function DocumentTemplate(json) {
	        return _super.call(this, json) || this;
	    }
	    DocumentTemplate.prototype.fromJson = function (json) {
	        _super.prototype.fromJson.call(this, json, "resources");
	        if (!this.resources)
	            this.resources = new mobx_1.ObservableMap();
	        if (!this.computations)
	            this.computations = [];
	        if (!this.invoiceTypeIds)
	            this.invoiceTypeIds = [];
	        this.templateStr = (this.template) ? (0, stringUtils_1.decodeString)(this.template) : '';
	        return this;
	    };
	    // musi zmenit klic mapy dle jmena uvnitr
	    DocumentTemplate.prototype.prepareForServer = function () {
	        this.resources = mobx_1.observable.map(this.resources.values().reduce(function (acc, value) {
	            acc[value.name] = value;
	            return acc;
	        }, {}));
	        this.template = (0, stringUtils_1.encodeString)(this.templateStr);
	        return _super.prototype.prepareForServer.call(this);
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentTemplate.prototype, "documentType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentTemplate.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentTemplate.prototype, "validFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentTemplate.prototype, "validTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentTemplate.prototype, "profitCenter", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentTemplate.prototype, "invoiceTypeIds", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentTemplate.prototype, "language", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentTemplate.prototype, "useSaxonForXslt", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentTemplate.prototype, "documentNameExpression", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentTemplate.prototype, "templateIndex", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentTemplate.prototype, "templateStr", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(DocumentTemplateResource)
	    ], DocumentTemplate.prototype, "resources", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentTemplate.prototype, "computations", void 0);
	    DocumentTemplate = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], DocumentTemplate);
	    return DocumentTemplate;
	}(DomainAncestor_1.DomainAncestor));
	exports.DocumentTemplate = DocumentTemplate;
	var Document = /** @class */ (function (_super) {
	    tslib_1.__extends(Document, _super);
	    function Document(json) {
	        return _super.call(this, json) || this;
	    }
	    Document.prototype.getId = function () {
	        return this.documentId;
	    };
	    Document.prototype.setId = function (id) {
	        this.documentId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Document.prototype, "documentId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Document.prototype, "documentUuid", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Document.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Document.prototype, "documentType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Document.prototype, "icon", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Document.prototype, "status", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Document.prototype, "attachmentType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable.ref
	    ], Document.prototype, "replacementDocument", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Document.prototype, "contentType", void 0);
	    Document = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], Document);
	    return Document;
	}(DomainAncestor_1.DomainAncestor));
	exports.Document = Document;
	var Contract = /** @class */ (function (_super) {
	    tslib_1.__extends(Contract, _super);
	    function Contract(json) {
	        return _super.call(this, json) || this;
	    }
	    Contract.prototype.getId = function () {
	        return this.contractId;
	    };
	    Contract.prototype.setId = function (id) {
	        this.contractId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Contract.prototype, "contractId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Contract.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Contract.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Contract.prototype, "contractNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Contract.prototype, "contractType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Contract.prototype, "contractStatus", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Contract.prototype, "customer", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Contract.prototype, "sendForSigningDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Contract.prototype, "signingDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Contract.prototype, "$gridDocument", void 0);
	    Contract = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], Contract);
	    return Contract;
	}(DomainAncestor_1.DomainAncestor));
	exports.Contract = Contract;
	var nonReplacedDocumentFp = function (document) { return (document.status !== DOCUMENTSTATUS.REPLACED); };
	exports.nonReplacedDocumentFp = nonReplacedDocumentFp;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var utils_1 = __webpack_require__(37);
	var domUtils_1 = __webpack_require__(91);
	var base64_js_1 = tslib_1.__importDefault(__webpack_require__(593));
	var mobx_1 = __webpack_require__(5);
	var documentDomain_1 = __webpack_require__(109);
	var DocumentService = /** @class */ (function () {
	    function DocumentService() {
	    }
	    DocumentService.prototype.documentUrl = function (documentUuid, spec) {
	        return (0, domUtils_1.buildURL)('/api/core/document/' + documentUuid, (0, utils_1.addTenantToQuery)(spec));
	    };
	    DocumentService.prototype.documentTemporaryUrl = function (uuid, spec) {
	        return (0, domUtils_1.buildURL)('/api/core/document-temporary/' + uuid, (0, utils_1.addTenantToQuery)(spec));
	    };
	    DocumentService.prototype.readDocuments = function (params) {
	        return axios_config_1.default.get('/core/document', { params: params })
	            .then(function (response) { return response.data.map(function (d) { return new documentDomain_1.Document(d); }); });
	    };
	    DocumentService.prototype.saveDocument = function (document, params) {
	        return axios_config_1.default.post('/core/document', document, { params: params })
	            .then(function (response) { return response.data; });
	    };
	    DocumentService.prototype.deleteDocument = function (documentUuid, params) {
	        return axios_config_1.default.delete('/core/document/' + documentUuid, { params: params })
	            .then(function (response) { return response.data; });
	    };
	    DocumentService.prototype.readDocumentType = function (documentTypeId) {
	        return axios_config_1.default.get('/document-type/' + documentTypeId)
	            .then(function (response) { return new documentDomain_1.DocumentType(response.data); });
	    };
	    DocumentService.prototype.saveDocumentType = function (documentType) {
	        return axios_config_1.default.post('/document-type', documentType, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    DocumentService.prototype.deleteDocumentType = function (documentTypeId) {
	        return axios_config_1.default.delete('/document-type/' + documentTypeId, { showPrettyError: true });
	    };
	    DocumentService.prototype.readDocumentTemplate = function (id) {
	        var strings = (0, utils_1.parseId)(id);
	        return axios_config_1.default.get('/document-template/' + strings[0] + '/' + strings[1])
	            .then(function (response) { return new documentDomain_1.DocumentTemplate(response.data); });
	    };
	    DocumentService.prototype.saveDocumentTemplate = function (documentTemplate) {
	        return axios_config_1.default.post('/document-template', documentTemplate, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    DocumentService.prototype.deleteDocumentTemplate = function (documentTypeId, templateIndex) {
	        return axios_config_1.default.delete('/document-template/' + documentTypeId + '/' + templateIndex, { showPrettyError: true });
	    };
	    DocumentService.prototype.test = function (documentTemplateObject) {
	        return axios_config_1.default.post('/core/document/test', documentTemplateObject)
	            .then(function (response) { return response.data; });
	    };
	    DocumentService.prototype.documentCount = function (entityName, documentLocation, gridParams) {
	        return axios_config_1.default.post('/core/document-count/' + entityName + '/' + documentLocation, gridParams, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    DocumentService.prototype.loadFile = function (file) {
	        return new Promise(function (resolve, reject) {
	            var reader = new FileReader();
	            reader.onload = resolve;
	            reader.onerror = reject;
	            reader.readAsArrayBuffer(file);
	        }).then(function (event) {
	            var byteArray = new Uint8Array(event.target.result);
	            return new documentDomain_1.DocumentTemplateResource({
	                $new: true,
	                lastModified: new Date(file.lastModified),
	                name: file.name,
	                size: file.size,
	                contentType: file.type,
	                content: base64_js_1.default.fromByteArray(byteArray)
	            });
	        });
	    };
	    ;
	    DocumentService.prototype.isUploadType = function (document) {
	        return !document.documentType;
	    };
	    DocumentService.prototype.printDocument = function (documentUuid) {
	        var iframe = document.createElement('iframe');
	        iframe.style.display = 'none';
	        iframe.src = this.documentUrl(documentUuid, { inline: true });
	        document.body.appendChild(iframe);
	        iframe.onload = function () {
	            setTimeout(function () {
	                iframe.focus();
	                iframe.contentWindow.print();
	            });
	        };
	    };
	    // ////////// Contract ////////////////////////////////////////////////////////////////////////////////
	    DocumentService.prototype.readContract = function (id) {
	        return axios_config_1.default.get('/core/contract/' + id)
	            .then(function (response) { return new documentDomain_1.Contract(response.data); });
	    };
	    DocumentService.prototype.saveContract = function (contract) {
	        return axios_config_1.default.post('/core/contract', contract, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    DocumentService.prototype.deleteContract = function (contractId) {
	        return axios_config_1.default.delete('/core/contract/' + contractId, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    DocumentService.prototype.readPartyContracts = function (partyId) {
	        return axios_config_1.default.get('/core/contract/party/' + partyId)
	            .then(function (response) { return response.data.map(function (d) { return new documentDomain_1.Contract(d); }); });
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentService.prototype, "documentTypeObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentService.prototype, "documentTemplateObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentService.prototype, "documentCountObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DocumentService.prototype, "contractObject", void 0);
	    return DocumentService;
	}());
	exports.default = new DocumentService();


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var mobx_1 = __webpack_require__(5);
	var projectVersionDomain_1 = __webpack_require__(959);
	var projectVersionParameterValueDomain_1 = __webpack_require__(265);
	var projectCriterionVersionDomain_1 = __webpack_require__(2220);
	var projectVersionMaterialDomain_1 = __webpack_require__(962);
	var criterionDomain_1 = __webpack_require__(573);
	var projectVersionEnergyCarrierDomain_1 = __webpack_require__(961);
	var projectVersionRoomDomain_1 = __webpack_require__(963);
	var ProjectVersionService = /** @class */ (function () {
	    function ProjectVersionService() {
	        this.criteriaList = (0, mobx_1.observable)([]);
	        this.criterionVersions = (0, mobx_1.observable)([]);
	    }
	    Object.defineProperty(ProjectVersionService.prototype, "criterionResults", {
	        get: function () {
	            return this._criterionResults ? this._criterionResults : {};
	        },
	        set: function (value) {
	            this._criterionResults = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    ProjectVersionService.prototype.readProjectVersion = function (id) {
	        return axios_config_1.default.get('sbtool/project-version/' + id)
	            .then(function (response) { return new projectVersionDomain_1.ProjectVersion(response.data); });
	    };
	    ProjectVersionService.prototype.readProjectsVersionCriteria = function (id) {
	        return axios_config_1.default.get('sbtool/project-version/' + id + "/criteria")
	            .then(function (response) { return response.data.map(function (d) { return new criterionDomain_1.Criterion(d); }); });
	    };
	    ProjectVersionService.prototype.saveProjectVersion = function (projectVersionObject) {
	        return axios_config_1.default.post('sbtool/project-version', projectVersionObject)
	            .then(function (response) { return response.data; });
	    };
	    ProjectVersionService.prototype.copyProjectVersion = function (oldVersionId, projectVersionObject) {
	        return axios_config_1.default.post('sbtool/project-version/' + oldVersionId + '/copy', projectVersionObject)
	            .then(function (response) { return response.data; });
	    };
	    ProjectVersionService.prototype.deleteProjectVersion = function (id) {
	        return axios_config_1.default.delete('sbtool/project-version/' + id, { showPrettyError: true });
	    };
	    ProjectVersionService.prototype.readProjectVersionValues = function (projectVersionId, criterionId, versionId) {
	        return axios_config_1.default.get('sbtool/project-version/' + projectVersionId + "/values/" + criterionId + "/" + versionId)
	            .then(function (response) { return response.data.map(function (param) { return new projectVersionParameterValueDomain_1.ProjectVersionParamValue(param).initAfterRead(false); }); });
	    };
	    ProjectVersionService.prototype.saveProjectVersionValues = function (projectVersionId, criterionId, criterionVersionId, newName, params) {
	        var url = 'sbtool/project-version/' + projectVersionId + "/values/" + criterionId + "/" + criterionVersionId;
	        if (newName) {
	            url += '/newName/' + newName;
	        }
	        return axios_config_1.default.post(url, params)
	            .then(function (response) { });
	    };
	    ProjectVersionService.prototype.getProjectVersionResults = function (projectVersionId) {
	        return axios_config_1.default.get('sbtool/project-version/' + projectVersionId + "/results")
	            .then(function (response) { return response.data; });
	    };
	    ProjectVersionService.prototype.readProjectCriteriaVersions = function (projectVersionId) {
	        return axios_config_1.default.get('sbtool/project-version/' + projectVersionId + "/criterion-versions")
	            .then(function (response) { return response.data.map(function (param) { return new projectCriterionVersionDomain_1.ProjectCriterionVersion(param).initAfterRead(false); }); });
	    };
	    ProjectVersionService.prototype.copyProjectCriterionVersion = function (projectVersionId, versionId, copy) {
	        return axios_config_1.default.post('sbtool/project-version/' + projectVersionId + "/criterion-versions/" + versionId, copy)
	            .then(function (response) { return new projectCriterionVersionDomain_1.ProjectCriterionVersion(response.data).initAfterRead(false); });
	    };
	    ProjectVersionService.prototype.setDefaultCriterionVersion = function (projectVersionId, versionId) {
	        return axios_config_1.default.post('sbtool/project-version/' + projectVersionId + "/criterion-versions/" + versionId + "/default")
	            .then(function (response) { });
	    };
	    ProjectVersionService.prototype.deleteCriterionVersion = function (projectVersionId, versionId) {
	        return axios_config_1.default.delete('sbtool/project-version/' + projectVersionId + "/criterion-versions/" + versionId)
	            .then(function (response) { });
	    };
	    ProjectVersionService.prototype.saveProjectVersionMaterial = function (projectVersionId, material) {
	        return axios_config_1.default.post('sbtool/project-version/' + projectVersionId + "/materials", material)
	            .then(function (response) { return response.data; });
	    };
	    ProjectVersionService.prototype.readProjectVersionMaterial = function (materialId) {
	        return axios_config_1.default.get("sbtool/project-version/materials/" + materialId)
	            .then(function (response) { return new projectVersionMaterialDomain_1.ProjectVersionMaterial(response.data); });
	    };
	    ProjectVersionService.prototype.deleteProjectVersionMaterial = function (materialId) {
	        return axios_config_1.default.delete("sbtool/project-version/materials/" + materialId)
	            .then(function (response) { });
	    };
	    ProjectVersionService.prototype.saveProjectVersionEnergyCarrier = function (projectVersionId, energyCarrier) {
	        return axios_config_1.default.post('sbtool/project-version/' + projectVersionId + "/energy-carriers", energyCarrier)
	            .then(function (response) { return response.data; });
	    };
	    ProjectVersionService.prototype.readProjectVersionMaterialEnergyCarrier = function (energyCarrierId) {
	        return axios_config_1.default.get("sbtool/project-version/energy-carriers/" + energyCarrierId)
	            .then(function (response) { return new projectVersionEnergyCarrierDomain_1.ProjectVersionEnergyCarrier(response.data); });
	    };
	    ProjectVersionService.prototype.deleteProjectVersionEnergyCarrier = function (materialId) {
	        return axios_config_1.default.delete("sbtool/project-version/energy-carriers/" + materialId)
	            .then(function (response) { });
	    };
	    ProjectVersionService.prototype.roomTypesSearch = function () {
	        return axios_config_1.default.get('sbtool/project-version/roomTypes')
	            .then(function (response) {
	            return { options: response.data.map(function (d) { return new projectVersionRoomDomain_1.ProjectVersionRoom(d); }) };
	        });
	    };
	    ProjectVersionService.prototype.saveProjectVersionRoom = function (projectVersionId, room) {
	        return axios_config_1.default.post('sbtool/project-version/' + projectVersionId + "/rooms", room)
	            .then(function (response) { return response.data; });
	    };
	    ProjectVersionService.prototype.deleteProjectVersionRoom = function (roomId) {
	        return axios_config_1.default.delete("sbtool/project-version/rooms/" + roomId)
	            .then(function (response) { });
	    };
	    ProjectVersionService.prototype.saveProjectVersionArea = function (projectVersionId, area) {
	        return axios_config_1.default.post('sbtool/project-version/' + projectVersionId + "/areas", area)
	            .then(function (response) { return response.data; });
	    };
	    ProjectVersionService.prototype.deleteProjectVersionArea = function (areaId) {
	        return axios_config_1.default.delete("sbtool/project-version/areas/" + areaId)
	            .then(function (response) { });
	    };
	    ProjectVersionService.prototype.saveProjectVersionWindow = function (projectVersionId, window) {
	        return axios_config_1.default.post('sbtool/project-version/' + projectVersionId + "/windows", window)
	            .then(function (response) { return response.data; });
	    };
	    ProjectVersionService.prototype.deleteProjectVersionWindow = function (windowId) {
	        return axios_config_1.default.delete("sbtool/project-version/windows/" + windowId)
	            .then(function (response) { });
	    };
	    ProjectVersionService.prototype.getProjectVersionAreaBySubCriterionCode = function (projectVersionId, subCriterionCode) {
	        return axios_config_1.default.get("/sbtool/project-version/areas?projectVersionId=".concat(projectVersionId, "&subCriterionCode=").concat(subCriterionCode))
	            .then(function (response) { return response.data; });
	    };
	    ProjectVersionService.prototype.saveProjectVersionLop = function (projectVersionId, lop) {
	        return axios_config_1.default.post('sbtool/project-version/' + projectVersionId + '/lops', lop)
	            .then(function (response) { return response.data; });
	    };
	    ProjectVersionService.prototype.deleteProjectVersionLop = function (lopId) {
	        return axios_config_1.default.delete("/sbtool/project-version/lops/" + lopId)
	            .then(function (response) { });
	    };
	    ProjectVersionService.prototype.saveProjectVersionTree = function (projectVersionId, tree) {
	        return axios_config_1.default.post('sbtool/project-version/' + projectVersionId + '/trees', tree)
	            .then(function (response) { return response.data; });
	    };
	    ProjectVersionService.prototype.deleteProjectVersionTree = function (treeId) {
	        return axios_config_1.default.delete("/sbtool/project-version/trees/" + treeId)
	            .then(function (response) { });
	    };
	    ProjectVersionService.prototype.getVersionResult = function (versionId) {
	        return axios_config_1.default.get('sbtool/project/' + versionId + '/results')
	            .then(function (response) { return response.data; });
	    };
	    ProjectVersionService.prototype.saveProjectVersionLopsFillings = function (projectVersionId, lop) {
	        return axios_config_1.default.post('sbtool/project-version/' + projectVersionId + '/lopfillings', lop)
	            .then(function (response) { return response.data; });
	    };
	    ProjectVersionService.prototype.deleteProjectVersionLopsFillings = function (lopId) {
	        return axios_config_1.default.delete("/sbtool/project-version/lopfillings/" + lopId)
	            .then(function (response) { });
	    };
	    ProjectVersionService.prototype.saveProjectVersionLopsProfiles = function (projectVersionId, lop) {
	        return axios_config_1.default.post('sbtool/project-version/' + projectVersionId + '/lopprofiles', lop)
	            .then(function (response) { return response.data; });
	    };
	    ProjectVersionService.prototype.deleteProjectVersionLopsProfiles = function (lopId) {
	        return axios_config_1.default.delete("/sbtool/project-version/lopprofiles/" + lopId)
	            .then(function (response) { });
	    };
	    ProjectVersionService.prototype.saveProjectVersionParking = function (projectVersionId, lop) {
	        return axios_config_1.default.post('sbtool/project-version/' + projectVersionId + '/parkings', lop)
	            .then(function (response) { return response.data; });
	    };
	    ProjectVersionService.prototype.deleteProjectVersionParking = function (lopId) {
	        return axios_config_1.default.delete("/sbtool/project-version/parkings/" + lopId)
	            .then(function (response) { });
	    };
	    ProjectVersionService.prototype.saveProjectVersionRunoffCoefficient = function (projectVersionId, runoffCoefficient) {
	        return axios_config_1.default.post('sbtool/project-version/' + projectVersionId + '/runoff-coefficient', runoffCoefficient)
	            .then(function (response) { return response.data; });
	    };
	    ProjectVersionService.prototype.deleteProjectVersionRunoffCoefficient = function (coefficient) {
	        return axios_config_1.default.delete("/sbtool/project-version/runoff-coefficient/" + coefficient)
	            .then(function (response) { });
	    };
	    ProjectVersionService.prototype.saveProjectVersionIdentification = function (projectVersionId, capacity) {
	        return axios_config_1.default.post('sbtool/project-version/' + projectVersionId + '/identification', capacity)
	            .then(function (response) { return response.data; });
	    };
	    ProjectVersionService.prototype.deleteProjectVersionIdentification = function (projectVersionId) {
	        return axios_config_1.default.delete("/sbtool/project-version/identification/" + projectVersionId)
	            .then(function (response) { });
	    };
	    ProjectVersionService.prototype.finishProject = function (projectVersionId) {
	        return axios_config_1.default.get('sbtool/project-version/' + projectVersionId + '/close')
	            .then(function (response) { return response.data; });
	    };
	    ProjectVersionService.prototype.downloadCertificate = function (projectVersionId) {
	        return axios_config_1.default.get('sbtool/project-version/download-certificate/' + projectVersionId, {
	            responseType: 'blob',
	        })
	            .then(function (response) { return response; });
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionService.prototype, "projectVersion", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionService.prototype, "_criterionResults", void 0);
	    return ProjectVersionService;
	}());
	exports.default = new ProjectVersionService();


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CharacterMetadata
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(60),
	    Map = _require.Map,
	    OrderedSet = _require.OrderedSet,
	    Record = _require.Record;
	
	// Immutable.map is typed such that the value for every key in the map
	// must be the same type
	
	
	var EMPTY_SET = OrderedSet();
	
	var defaultRecord = {
	  style: EMPTY_SET,
	  entity: null
	};
	
	var CharacterMetadataRecord = Record(defaultRecord);
	
	var CharacterMetadata = function (_CharacterMetadataRec) {
	  _inherits(CharacterMetadata, _CharacterMetadataRec);
	
	  function CharacterMetadata() {
	    _classCallCheck(this, CharacterMetadata);
	
	    return _possibleConstructorReturn(this, _CharacterMetadataRec.apply(this, arguments));
	  }
	
	  CharacterMetadata.prototype.getStyle = function getStyle() {
	    return this.get('style');
	  };
	
	  CharacterMetadata.prototype.getEntity = function getEntity() {
	    return this.get('entity');
	  };
	
	  CharacterMetadata.prototype.hasStyle = function hasStyle(style) {
	    return this.getStyle().includes(style);
	  };
	
	  CharacterMetadata.applyStyle = function applyStyle(record, style) {
	    var withStyle = record.set('style', record.getStyle().add(style));
	    return CharacterMetadata.create(withStyle);
	  };
	
	  CharacterMetadata.removeStyle = function removeStyle(record, style) {
	    var withoutStyle = record.set('style', record.getStyle().remove(style));
	    return CharacterMetadata.create(withoutStyle);
	  };
	
	  CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
	    var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
	    return CharacterMetadata.create(withEntity);
	  };
	
	  /**
	   * Use this function instead of the `CharacterMetadata` constructor.
	   * Since most content generally uses only a very small number of
	   * style/entity permutations, we can reuse these objects as often as
	   * possible.
	   */
	
	
	  CharacterMetadata.create = function create(config) {
	    if (!config) {
	      return EMPTY;
	    }
	
	    var defaultConfig = {
	      style: EMPTY_SET,
	      entity: null
	    };
	
	    // Fill in unspecified properties, if necessary.
	    var configMap = Map(defaultConfig).merge(config);
	
	    var existing = pool.get(configMap);
	    if (existing) {
	      return existing;
	    }
	
	    var newCharacter = new CharacterMetadata(configMap);
	    pool = pool.set(configMap, newCharacter);
	    return newCharacter;
	  };
	
	  return CharacterMetadata;
	}(CharacterMetadataRecord);
	
	var EMPTY = new CharacterMetadata();
	var pool = Map([[Map(defaultRecord), EMPTY]]);
	
	CharacterMetadata.EMPTY = EMPTY;
	
	module.exports = CharacterMetadata;

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1387),
	    baseMatchesProperty = __webpack_require__(1388),
	    identity = __webpack_require__(208),
	    isArray = __webpack_require__(62),
	    property = __webpack_require__(1481);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 115 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ }),
/* 116 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(205),
	    pullAll = __webpack_require__(484);
	
	/**
	 * Removes all given values from `array` using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	 * to remove elements from an array by predicate.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {...*} [values] The values to remove.
	 * @returns {Array} Returns `array`.
	 * @example
	 *
	 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	 *
	 * _.pull(array, 'a', 'c');
	 * console.log(array);
	 * // => ['b', 'b']
	 */
	var pull = baseRest(pullAll);
	
	module.exports = pull;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var horizontal = _propTypes2.default.oneOf(['left', 'middle', 'right']);
	var vertical = _propTypes2.default.oneOf(['top', 'center', 'bottom']);
	
	exports.default = {
	
	  corners: _propTypes2.default.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),
	
	  horizontal: horizontal,
	
	  vertical: vertical,
	
	  origin: _propTypes2.default.shape({
	    horizontal: horizontal,
	    vertical: vertical
	  }),
	
	  cornersAndCenter: _propTypes2.default.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),
	
	  stringOrNumber: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5])
	
	};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TabTemplate = exports.muiTheme = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var typography_1 = tslib_1.__importDefault(__webpack_require__(776));
	var colors_1 = __webpack_require__(29);
	exports.muiTheme = {
	    fontFamily: 'Roboto+Condensed, sans-serif',
	    palette: {
	        primary1Color: colors_1.indigo500,
	        primary2Color: colors_1.indigo700
	        //primary3Color: Colors.indigo100,
	        //textColor: '#666',
	    },
	    toolbar: {
	        backgroundColor: colors_1.blueGrey50,
	        height: 40,
	        titleFontSize: 20
	    },
	    tableRowColumn: {
	        height: 28,
	        spacing: 16
	    },
	    tableHeaderColumn: {
	        height: 28,
	        spacing: 16
	    },
	    button: {
	        height: 40,
	        iconButtonSize: 40,
	        minWidth: 40
	        //textTransform: 'none'
	    },
	    menuItem: {
	        height: 40
	    },
	    floatingActionButton: {
	        /*  buttonSize: 56, */
	        miniSize: 28
	    },
	    tabs: {
	        backgroundColor: 'white',
	        textColor: typography_1.default.textLightBlack,
	        selectedTextColor: typography_1.default.textDarkBlack
	    }
	};
	exports.TabTemplate = react_1.default.createClass({
	    render: function () {
	        var styles = {
	            'width': '100%',
	            minHeight: 0,
	            flexGrow: 1,
	            display: (this.props.selected) ? "flex" : "none"
	        };
	        return (react_1.default.createElement("div", { style: styles }, this.props.children));
	    }
	});


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var utils_1 = __webpack_require__(37);
	var formUtils_1 = __webpack_require__(14);
	var mobx_1 = __webpack_require__(5);
	var eventDomain_1 = __webpack_require__(74);
	var EventService = /** @class */ (function () {
	    function EventService() {
	    }
	    // ////////// History  ////////////////////////////////////////////////////////////////////////////////
	    EventService.prototype.readHistory = function (entityName, entityId) {
	        return axios_config_1.default.get('/core/event/history/' + entityName + '/' + entityId)
	            .then(function (response) { return response.data.eventHistories.map(function (ehJson) { return new eventDomain_1.EventHistory(ehJson); }); });
	    };
	    EventService.prototype.readEventHistory = function (id) {
	        return axios_config_1.default.get('/core/event/history/' + id)
	            .then(function (response) { return new eventDomain_1.EventHistory(response.data); });
	    };
	    // ////////// Event Active Action  ////////////////////////////////////////////////////////////////////////////////
	    EventService.prototype.openObject = function (mdEntity, id) {
	        return axios_config_1.default.post('/core/event/open', { mdEntity: mdEntity.id, id: id }, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    EventService.prototype.closeObject = function (mdEntity, id, forceClose) {
	        if (forceClose === void 0) { forceClose = false; }
	        return axios_config_1.default.post('/core/event/close', { mdEntity: mdEntity.id, id: id }, { showPrettyError: true, params: { forceClose: forceClose } })
	            .then(function (response) { return response.data; });
	    };
	    // ////////// Event Type ////////////////////////////////////////////////////////////////////////////////
	    EventService.prototype.readEventType = function (eventTypeId) {
	        return axios_config_1.default.get('/core/event/event-type/' + eventTypeId)
	            .then(function (response) { return new eventDomain_1.EventType(response.data); });
	    };
	    EventService.prototype.saveEventType = function (eventType) {
	        return axios_config_1.default.post('/core/event/event-type', eventType, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    EventService.prototype.deleteEventType = function (eventTypeId) {
	        return axios_config_1.default.delete('/core/event/event-type/' + eventTypeId, { showPrettyError: true });
	    };
	    // ////////// Event Template ////////////////////////////////////////////////////////////////////////////////
	    EventService.prototype.readEventTemplate = function (id) {
	        var strings = (0, utils_1.parseId)(id);
	        return axios_config_1.default.get('/core/event/event-template/' + strings[0] + '/' + strings[1])
	            .then(function (response) { return new eventDomain_1.EventTemplate(response.data); });
	    };
	    EventService.prototype.saveEventTemplate = function (eventTemplate) {
	        return axios_config_1.default.post('/core/event/event-template', eventTemplate, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    EventService.prototype.deleteEventTemplate = function (eventTypeId, templateIndex) {
	        return axios_config_1.default.delete('/core/event/event-template/' + eventTypeId + '/' + templateIndex, { showPrettyError: true });
	    };
	    EventService.prototype.test = function (eventTemplate, mdEntity, id, dryRun) {
	        return axios_config_1.default.post('/core/event/test', { eventTemplate: eventTemplate, dryRun: dryRun, testSpec: { mdEntity: (0, formUtils_1.lovValue)(mdEntity), id: id } }, { showPrettyError: true })
	            .then(function (response) { return new eventDomain_1.EventHistory(response.data); });
	    };
	    // ////////// Activity Config ////////////////////////////////////////////////////////////////////////////////
	    EventService.prototype.readActivityConfig = function (activityConfigId) {
	        return axios_config_1.default.get('/core/event/activity-config/' + activityConfigId)
	            .then(function (response) { return new eventDomain_1.ActivityConfig(response.data); });
	    };
	    EventService.prototype.saveActivityConfig = function (activityConfig) {
	        return axios_config_1.default.post('/core/event/activity-config', activityConfig, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    EventService.prototype.deleteActivityConfig = function (activityConfigId) {
	        return axios_config_1.default.delete('/core/event/activity-config/' + activityConfigId, { showPrettyError: true });
	    };
	    // ////////// Activity Template ////////////////////////////////////////////////////////////////////////////////
	    EventService.prototype.readActivityTemplate = function (id) {
	        var strings = (0, utils_1.parseId)(id);
	        var url = '/core/event/activity-template/' + strings[0] + '/' + strings[1];
	        return axios_config_1.default.get(url)
	            .then(function (response) { return new eventDomain_1.ActivityTemplate(response.data); });
	    };
	    EventService.prototype.readActivityTemplates = function (activityConfigId) {
	        var url = '/core/event/activity-template/' + activityConfigId;
	        return axios_config_1.default.get(url)
	            .then(function (response) { return response.data.map(function (json) { return new eventDomain_1.ActivityTemplate(json); }); });
	    };
	    EventService.prototype.saveActivityTemplate = function (activityTemplate) {
	        return axios_config_1.default.post('/core/event/activity-template', activityTemplate, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    EventService.prototype.deleteActivityTemplate = function (activityConfigId, templateIndex) {
	        return axios_config_1.default.delete('/core/event/activity-template/' + activityConfigId + '/' + templateIndex, { showPrettyError: true });
	    };
	    // ////////// Party Activity ////////////////////////////////////////////////////////////////////////////////
	    EventService.prototype.readPartyActivity = function (id) {
	        return axios_config_1.default.get('/core/event/activity/' + id)
	            .then(function (response) { return new eventDomain_1.PartyActivity(response.data); });
	    };
	    EventService.prototype.deletePartyActivity = function (gridParams) {
	        return axios_config_1.default.post("/core/event/activity-delete", gridParams);
	    };
	    // ////////// Task ////////////////////////////////////////////////////////////////////////////////
	    EventService.prototype.prepareTaskActivity = function (location, gridParams) {
	        return axios_config_1.default.post('/core/event/task-activity/' + location, gridParams)
	            .then(function (response) { return response.data.map(function (item) { return new eventDomain_1.EntityStatus(item); }); });
	    };
	    EventService.prototype.createTask = function (taskDto) {
	        return axios_config_1.default.put('/core/event/task', taskDto, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    EventService.prototype.updateTask = function (task) {
	        return axios_config_1.default.post('/core/event/task', task, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    EventService.prototype.deleteTask = function (taskId) {
	        return axios_config_1.default.delete('/core/event/task/' + taskId, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    EventService.prototype.readTask = function (id) {
	        return axios_config_1.default.get('/core/event/task/' + id)
	            .then(function (response) { return new eventDomain_1.Task(response.data); });
	    };
	    EventService.prototype.createTaskNote = function (taskNote) {
	        return axios_config_1.default.put('/core/event/task-note', taskNote, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    EventService.prototype.closeTask = function (taskNote) {
	        return axios_config_1.default.post('/core/event/task-close', taskNote, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    EventService.prototype.reopenTask = function (taskId) {
	        return axios_config_1.default.post('/core/event/task-reopen/' + taskId, null, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    EventService.prototype.assignTask = function (taskId, username) {
	        return axios_config_1.default.post("/core/event/task-assign/" + taskId + "/" + username, null, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventService.prototype, "eventTypeObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventService.prototype, "eventTemplateObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventService.prototype, "activityConfigObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventService.prototype, "activityTemplateObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventService.prototype, "eventHistories", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EventService.prototype, "taskObject", void 0);
	    return EventService;
	}());
	var eventService = new EventService();
	exports.default = eventService;


/***/ }),
/* 121 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PROJECT_VERSION_CAPACITIES_GRID = exports.PROJECT_RUNOFF_COEFFICIENT_GRID = exports.PROJECT_VERSION_PARKING_GRID = exports.PROJECT_VERSION_LOP_PROFILES_GRID = exports.PROJECT_VERSION_LOP_FILLINGS_GRID = exports.PROJECT_VERSION_TREE_LIST = exports.PROJECT_VERSION_LOP_LIST = exports.PROJECT_VERSION_WINDOW_LIST = exports.PROJECT_VERSION_DOOR_LIST = exports.PROJECT_VERSION_AREA_LIST = exports.AREA_LIST = exports.MATERIAL_USAGE_GROUPS_LIST = exports.PROJECT_VERSION_ROOMS_LIST = exports.PROJECT_VERSION_ROOM_CATEGORIES_LIST = exports.PROJECT_VERSION_ROOM_TYPES_LIST = exports.LIFESPAN_LIST = exports.PROJECT_VERSION_AREA_PEFKE_GRID = exports.PROJECT_VERSION_AREA_VPREP_GRID = exports.PROJECT_VERSION_AREA_ZELZS_GRID = exports.PROJECT_VERSION_AREA_ZELZF_GRID = exports.PROJECT_VERSION_AREA_ZELST_GRID = exports.PROJECT_VERSION_AREA_ZELZP_GRID = exports.PROJECT_VERSION_AREA_ZELPO_GRID = exports.PROJECT_VERSION_WOOD_BASED_MATERIALS_GRID = exports.PROJECT_VERSION_EPD_CERTIFIED_MATERIALS_LIST = exports.PROJECT_VERSION_RECYCLABLE_MATERIALS_LIST = exports.PROJECT_MATERIAL_GRID = exports.PROJECT_VERSION_MATERIALS_GRID = exports.PROJECT_VERSION_ENERGY_CARRIERS_LIST = exports.PROJECT_VERSIONS_LIST = exports.PROJECTS_LIST = exports.MATERIALS_LIST = exports.ENERGY_CARRIERS_LIST = exports.SUB_CRITERION_PARAM_VALUES_LIST = exports.SUB_CRITERIA_LIST = exports.CRITERION_SCORE_LIST = exports.CRITERIA_LIST = void 0;
	exports.CRITERIA_LIST = "CriteriaList";
	exports.CRITERION_SCORE_LIST = "CriterionScoreList";
	exports.SUB_CRITERIA_LIST = "SubCriteriaList";
	exports.SUB_CRITERION_PARAM_VALUES_LIST = "SubCriterionParamValuesList";
	exports.ENERGY_CARRIERS_LIST = "EnergyCarriersList";
	exports.MATERIALS_LIST = "MaterialsList";
	exports.PROJECTS_LIST = "ProjectsList";
	exports.PROJECT_VERSIONS_LIST = "ProjectVersionsList";
	exports.PROJECT_VERSION_ENERGY_CARRIERS_LIST = "ProjectVersionEnergyCarriersList";
	exports.PROJECT_VERSION_MATERIALS_GRID = "ProjectVersionMaterialsList";
	exports.PROJECT_MATERIAL_GRID = "ProjectMaterialsList";
	exports.PROJECT_VERSION_RECYCLABLE_MATERIALS_LIST = "ProjectMaterialListRecyclable";
	exports.PROJECT_VERSION_EPD_CERTIFIED_MATERIALS_LIST = "ProjectMaterialListEPDCertified";
	exports.PROJECT_VERSION_WOOD_BASED_MATERIALS_GRID = "ProjectMaterialListWoodBasedCertified";
	exports.PROJECT_VERSION_AREA_ZELPO_GRID = "ProjectVersionAreaListZELPO";
	exports.PROJECT_VERSION_AREA_ZELZP_GRID = "ProjectVersionAreaListZELZP";
	exports.PROJECT_VERSION_AREA_ZELST_GRID = "ProjectVersionAreaListZELST";
	exports.PROJECT_VERSION_AREA_ZELZF_GRID = "ProjectVersionAreaListZELZF";
	exports.PROJECT_VERSION_AREA_ZELZS_GRID = "ProjectVersionAreaListZELZS";
	exports.PROJECT_VERSION_AREA_VPREP_GRID = "ProjectVersionAreaListVPREP";
	exports.PROJECT_VERSION_AREA_PEFKE_GRID = "ProjectVersionAreaListVPREP";
	exports.LIFESPAN_LIST = "LifespanList";
	exports.PROJECT_VERSION_ROOM_TYPES_LIST = "ProjectVersionRoomTypesList";
	exports.PROJECT_VERSION_ROOM_CATEGORIES_LIST = "ProjectVersionRoomCategoriesList";
	exports.PROJECT_VERSION_ROOMS_LIST = "ProjectVersionRoomList";
	exports.MATERIAL_USAGE_GROUPS_LIST = "MaterialUsageGroupsList";
	exports.AREA_LIST = "AreaList";
	exports.PROJECT_VERSION_AREA_LIST = "ProjectVersionAreaList";
	exports.PROJECT_VERSION_DOOR_LIST = "ProjectVersionDoorList";
	exports.PROJECT_VERSION_WINDOW_LIST = "ProjectVersionWindowList";
	exports.PROJECT_VERSION_LOP_LIST = "ProjectVersionLopList";
	exports.PROJECT_VERSION_TREE_LIST = "ProjectVersionTreeList";
	exports.PROJECT_VERSION_LOP_FILLINGS_GRID = "ProjectVersionLopFillings";
	exports.PROJECT_VERSION_LOP_PROFILES_GRID = "ProjectVersionLopProfiles";
	exports.PROJECT_VERSION_PARKING_GRID = "ProjectVersionParkingList";
	exports.PROJECT_RUNOFF_COEFFICIENT_GRID = "ProjectVersionRunoffCoefficientGrid";
	exports.PROJECT_VERSION_CAPACITIES_GRID = "ProjectVersionCapacityList";


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(586);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentBlockNode
	 * @format
	 * 
	 *
	 * This file is a fork of ContentBlock adding support for nesting references by
	 * providing links to children, parent, prevSibling, and nextSibling.
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CharacterMetadata = __webpack_require__(112);
	var Immutable = __webpack_require__(60);
	
	var findRangesImmutable = __webpack_require__(272);
	
	var List = Immutable.List,
	    Map = Immutable.Map,
	    OrderedSet = Immutable.OrderedSet,
	    Record = Immutable.Record,
	    Repeat = Immutable.Repeat;
	
	
	var EMPTY_SET = OrderedSet();
	
	var defaultRecord = {
	  parent: null,
	  characterList: List(),
	  data: Map(),
	  depth: 0,
	  key: '',
	  text: '',
	  type: 'unstyled',
	  children: List(),
	  prevSibling: null,
	  nextSibling: null
	};
	
	var haveEqualStyle = function haveEqualStyle(charA, charB) {
	  return charA.getStyle() === charB.getStyle();
	};
	
	var haveEqualEntity = function haveEqualEntity(charA, charB) {
	  return charA.getEntity() === charB.getEntity();
	};
	
	var decorateCharacterList = function decorateCharacterList(config) {
	  if (!config) {
	    return config;
	  }
	
	  var characterList = config.characterList,
	      text = config.text;
	
	
	  if (text && !characterList) {
	    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
	  }
	
	  return config;
	};
	
	var ContentBlockNode = function (_Record) {
	  _inherits(ContentBlockNode, _Record);
	
	  function ContentBlockNode() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRecord;
	
	    _classCallCheck(this, ContentBlockNode);
	
	    return _possibleConstructorReturn(this, _Record.call(this, decorateCharacterList(props)));
	  }
	
	  ContentBlockNode.prototype.getKey = function getKey() {
	    return this.get('key');
	  };
	
	  ContentBlockNode.prototype.getType = function getType() {
	    return this.get('type');
	  };
	
	  ContentBlockNode.prototype.getText = function getText() {
	    return this.get('text');
	  };
	
	  ContentBlockNode.prototype.getCharacterList = function getCharacterList() {
	    return this.get('characterList');
	  };
	
	  ContentBlockNode.prototype.getLength = function getLength() {
	    return this.getText().length;
	  };
	
	  ContentBlockNode.prototype.getDepth = function getDepth() {
	    return this.get('depth');
	  };
	
	  ContentBlockNode.prototype.getData = function getData() {
	    return this.get('data');
	  };
	
	  ContentBlockNode.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getStyle() : EMPTY_SET;
	  };
	
	  ContentBlockNode.prototype.getEntityAt = function getEntityAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getEntity() : null;
	  };
	
	  ContentBlockNode.prototype.getChildKeys = function getChildKeys() {
	    return this.get('children');
	  };
	
	  ContentBlockNode.prototype.getParentKey = function getParentKey() {
	    return this.get('parent');
	  };
	
	  ContentBlockNode.prototype.getPrevSiblingKey = function getPrevSiblingKey() {
	    return this.get('prevSibling');
	  };
	
	  ContentBlockNode.prototype.getNextSiblingKey = function getNextSiblingKey() {
	    return this.get('nextSibling');
	  };
	
	  ContentBlockNode.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
	  };
	
	  ContentBlockNode.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
	  };
	
	  return ContentBlockNode;
	}(Record(defaultRecord));
	
	module.exports = ContentBlockNode;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(711);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(473);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _IconButton = __webpack_require__(1525);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _IconButton2.default;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = exports.Toggle = exports.TimePicker = exports.TextField = exports.TableRowColumn = exports.TableRow = exports.TableHeaderColumn = exports.TableHeader = exports.TableFooter = exports.TableBody = exports.Table = exports.Tab = exports.Tabs = exports.Snackbar = exports.Stepper = exports.StepLabel = exports.StepContent = exports.StepButton = exports.Step = exports.SvgIcon = exports.Subheader = exports.Slider = exports.SelectField = exports.RefreshIndicator = exports.RaisedButton = exports.RadioButtonGroup = exports.RadioButton = exports.Popover = exports.Paper = exports.MuiThemeProvider = exports.MenuItem = exports.Menu = exports.makeSelectable = exports.ListItem = exports.List = exports.LinearProgress = exports.IconMenu = exports.IconButton = exports.GridTile = exports.GridList = exports.FontIcon = exports.FloatingActionButton = exports.FlatButton = exports.DropDownMenu = exports.Drawer = exports.Divider = exports.Dialog = exports.DatePicker = exports.CircularProgress = exports.Chip = exports.Checkbox = exports.CardText = exports.CardTitle = exports.CardMedia = exports.CardHeader = exports.CardActions = exports.Card = exports.BottomNavigationItem = exports.BottomNavigation = exports.Badge = exports.Avatar = exports.AutoComplete = exports.AppBar = undefined;
	
	var _AppBar2 = __webpack_require__(1491);
	
	var _AppBar3 = _interopRequireDefault(_AppBar2);
	
	var _AutoComplete2 = __webpack_require__(1493);
	
	var _AutoComplete3 = _interopRequireDefault(_AutoComplete2);
	
	var _Avatar2 = __webpack_require__(356);
	
	var _Avatar3 = _interopRequireDefault(_Avatar2);
	
	var _Badge2 = __webpack_require__(489);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _BottomNavigation2 = __webpack_require__(1497);
	
	var _BottomNavigation3 = _interopRequireDefault(_BottomNavigation2);
	
	var _BottomNavigationItem2 = __webpack_require__(739);
	
	var _BottomNavigationItem3 = _interopRequireDefault(_BottomNavigationItem2);
	
	var _Card2 = __webpack_require__(1499);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardActions2 = __webpack_require__(740);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardHeader2 = __webpack_require__(742);
	
	var _CardHeader3 = _interopRequireDefault(_CardHeader2);
	
	var _CardMedia2 = __webpack_require__(743);
	
	var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	var _CardTitle2 = __webpack_require__(745);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardText2 = __webpack_require__(744);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _Checkbox2 = __webpack_require__(210);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Chip2 = __webpack_require__(211);
	
	var _Chip3 = _interopRequireDefault(_Chip2);
	
	var _CircularProgress2 = __webpack_require__(1503);
	
	var _CircularProgress3 = _interopRequireDefault(_CircularProgress2);
	
	var _DatePicker2 = __webpack_require__(746);
	
	var _DatePicker3 = _interopRequireDefault(_DatePicker2);
	
	var _Dialog2 = __webpack_require__(76);
	
	var _Dialog3 = _interopRequireDefault(_Dialog2);
	
	var _Divider2 = __webpack_require__(241);
	
	var _Divider3 = _interopRequireDefault(_Divider2);
	
	var _Drawer2 = __webpack_require__(286);
	
	var _Drawer3 = _interopRequireDefault(_Drawer2);
	
	var _DropDownMenu2 = __webpack_require__(747);
	
	var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);
	
	var _FlatButton2 = __webpack_require__(36);
	
	var _FlatButton3 = _interopRequireDefault(_FlatButton2);
	
	var _FloatingActionButton2 = __webpack_require__(1521);
	
	var _FloatingActionButton3 = _interopRequireDefault(_FloatingActionButton2);
	
	var _FontIcon2 = __webpack_require__(164);
	
	var _FontIcon3 = _interopRequireDefault(_FontIcon2);
	
	var _GridList2 = __webpack_require__(1524);
	
	var _GridList3 = _interopRequireDefault(_GridList2);
	
	var _GridTile2 = __webpack_require__(748);
	
	var _GridTile3 = _interopRequireDefault(_GridTile2);
	
	var _IconButton2 = __webpack_require__(126);
	
	var _IconButton3 = _interopRequireDefault(_IconButton2);
	
	var _IconMenu2 = __webpack_require__(357);
	
	var _IconMenu3 = _interopRequireDefault(_IconMenu2);
	
	var _LinearProgress2 = __webpack_require__(490);
	
	var _LinearProgress3 = _interopRequireDefault(_LinearProgress2);
	
	var _List2 = __webpack_require__(1529);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(359);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _makeSelectable2 = __webpack_require__(749);
	
	var _makeSelectable3 = _interopRequireDefault(_makeSelectable2);
	
	var _Menu2 = __webpack_require__(750);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _MenuItem2 = __webpack_require__(101);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _MuiThemeProvider2 = __webpack_require__(1586);
	
	var _MuiThemeProvider3 = _interopRequireDefault(_MuiThemeProvider2);
	
	var _Paper2 = __webpack_require__(106);
	
	var _Paper3 = _interopRequireDefault(_Paper2);
	
	var _Popover2 = __webpack_require__(1533);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _RadioButton2 = __webpack_require__(287);
	
	var _RadioButton3 = _interopRequireDefault(_RadioButton2);
	
	var _RadioButtonGroup2 = __webpack_require__(243);
	
	var _RadioButtonGroup3 = _interopRequireDefault(_RadioButtonGroup2);
	
	var _RaisedButton2 = __webpack_require__(152);
	
	var _RaisedButton3 = _interopRequireDefault(_RaisedButton2);
	
	var _RefreshIndicator2 = __webpack_require__(1536);
	
	var _RefreshIndicator3 = _interopRequireDefault(_RefreshIndicator2);
	
	var _SelectField2 = __webpack_require__(493);
	
	var _SelectField3 = _interopRequireDefault(_SelectField2);
	
	var _Slider2 = __webpack_require__(1539);
	
	var _Slider3 = _interopRequireDefault(_Slider2);
	
	var _Subheader2 = __webpack_require__(756);
	
	var _Subheader3 = _interopRequireDefault(_Subheader2);
	
	var _SvgIcon2 = __webpack_require__(45);
	
	var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);
	
	var _Step2 = __webpack_require__(752);
	
	var _Step3 = _interopRequireDefault(_Step2);
	
	var _StepButton2 = __webpack_require__(753);
	
	var _StepButton3 = _interopRequireDefault(_StepButton2);
	
	var _StepContent2 = __webpack_require__(754);
	
	var _StepContent3 = _interopRequireDefault(_StepContent2);
	
	var _StepLabel2 = __webpack_require__(494);
	
	var _StepLabel3 = _interopRequireDefault(_StepLabel2);
	
	var _Stepper2 = __webpack_require__(755);
	
	var _Stepper3 = _interopRequireDefault(_Stepper2);
	
	var _Snackbar2 = __webpack_require__(1542);
	
	var _Snackbar3 = _interopRequireDefault(_Snackbar2);
	
	var _Tabs2 = __webpack_require__(1549);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Tab2 = __webpack_require__(102);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _Table2 = __webpack_require__(761);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TableBody2 = __webpack_require__(757);
	
	var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	var _TableFooter2 = __webpack_require__(758);
	
	var _TableFooter3 = _interopRequireDefault(_TableFooter2);
	
	var _TableHeader2 = __webpack_require__(759);
	
	var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	var _TableHeaderColumn2 = __webpack_require__(495);
	
	var _TableHeaderColumn3 = _interopRequireDefault(_TableHeaderColumn2);
	
	var _TableRow2 = __webpack_require__(760);
	
	var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	var _TableRowColumn2 = __webpack_require__(361);
	
	var _TableRowColumn3 = _interopRequireDefault(_TableRowColumn2);
	
	var _TextField2 = __webpack_require__(186);
	
	var _TextField3 = _interopRequireDefault(_TextField2);
	
	var _TimePicker2 = __webpack_require__(1561);
	
	var _TimePicker3 = _interopRequireDefault(_TimePicker2);
	
	var _Toggle2 = __webpack_require__(362);
	
	var _Toggle3 = _interopRequireDefault(_Toggle2);
	
	var _Toolbar2 = __webpack_require__(767);
	
	var _Toolbar3 = _interopRequireDefault(_Toolbar2);
	
	var _ToolbarGroup2 = __webpack_require__(764);
	
	var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);
	
	var _ToolbarSeparator2 = __webpack_require__(765);
	
	var _ToolbarSeparator3 = _interopRequireDefault(_ToolbarSeparator2);
	
	var _ToolbarTitle2 = __webpack_require__(766);
	
	var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AppBar = _AppBar3.default;
	exports.AutoComplete = _AutoComplete3.default;
	exports.Avatar = _Avatar3.default;
	exports.Badge = _Badge3.default;
	exports.BottomNavigation = _BottomNavigation3.default;
	exports.BottomNavigationItem = _BottomNavigationItem3.default;
	exports.Card = _Card3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardHeader = _CardHeader3.default;
	exports.CardMedia = _CardMedia3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardText = _CardText3.default;
	exports.Checkbox = _Checkbox3.default;
	exports.Chip = _Chip3.default;
	exports.CircularProgress = _CircularProgress3.default;
	exports.DatePicker = _DatePicker3.default;
	exports.Dialog = _Dialog3.default;
	exports.Divider = _Divider3.default;
	exports.Drawer = _Drawer3.default;
	exports.DropDownMenu = _DropDownMenu3.default;
	exports.FlatButton = _FlatButton3.default;
	exports.FloatingActionButton = _FloatingActionButton3.default;
	exports.FontIcon = _FontIcon3.default;
	exports.GridList = _GridList3.default;
	exports.GridTile = _GridTile3.default;
	exports.IconButton = _IconButton3.default;
	exports.IconMenu = _IconMenu3.default;
	exports.LinearProgress = _LinearProgress3.default;
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.makeSelectable = _makeSelectable3.default;
	exports.Menu = _Menu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.MuiThemeProvider = _MuiThemeProvider3.default;
	exports.Paper = _Paper3.default;
	exports.Popover = _Popover3.default;
	exports.RadioButton = _RadioButton3.default;
	exports.RadioButtonGroup = _RadioButtonGroup3.default;
	exports.RaisedButton = _RaisedButton3.default;
	exports.RefreshIndicator = _RefreshIndicator3.default;
	exports.SelectField = _SelectField3.default;
	exports.Slider = _Slider3.default;
	exports.Subheader = _Subheader3.default;
	exports.SvgIcon = _SvgIcon3.default;
	exports.Step = _Step3.default;
	exports.StepButton = _StepButton3.default;
	exports.StepContent = _StepContent3.default;
	exports.StepLabel = _StepLabel3.default;
	exports.Stepper = _Stepper3.default;
	exports.Snackbar = _Snackbar3.default;
	exports.Tabs = _Tabs3.default;
	exports.Tab = _Tab3.default;
	exports.Table = _Table3.default;
	exports.TableBody = _TableBody3.default;
	exports.TableFooter = _TableFooter3.default;
	exports.TableHeader = _TableHeader3.default;
	exports.TableHeaderColumn = _TableHeaderColumn3.default;
	exports.TableRow = _TableRow3.default;
	exports.TableRowColumn = _TableRowColumn3.default;
	exports.TextField = _TextField3.default;
	exports.TimePicker = _TimePicker3.default;
	exports.Toggle = _Toggle3.default;
	exports.Toolbar = _Toolbar3.default;
	exports.ToolbarGroup = _ToolbarGroup3.default;
	exports.ToolbarSeparator = _ToolbarSeparator3.default;
	exports.ToolbarTitle = _ToolbarTitle3.default;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.date = exports.number = exports.setNumber = undefined;
	exports.setDate = setDate;
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ = __webpack_require__(93);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var localePropType = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]);
	
	var REQUIRED_NUMBER_FORMATS = ['default'];
	
	var REQUIRED_DATE_FORMATS = ['default', 'date', 'time', 'header', 'footer', 'dayOfMonth', 'month', 'year', 'decade', 'century'];
	
	function _format(localizer, formatter, value, format, culture) {
	  var result = typeof format === 'function' ? format(value, culture, localizer) : formatter.call(localizer, value, format, culture);
	
	  (0, _invariant2.default)(result == null || typeof result === 'string', '`localizer format(..)` must return a string, null, or undefined');
	
	  return result;
	}
	
	function checkFormats(requiredFormats, formats) {
	  if (false) requiredFormats.forEach(function (f) {
	    return (0, _invariant2.default)((0, _.has)(formats, f), 'localizer missing required format: `%s`', f);
	  });
	}
	
	var _numberLocalizer = createWrapper('NumberPicker');
	
	function setNumber(_ref) {
	  var _format2 = _ref.format,
	      _parse = _ref.parse,
	      _ref$decimalChar = _ref.decimalChar,
	      decimalChar = _ref$decimalChar === undefined ? function () {
	    return '.';
	  } : _ref$decimalChar,
	      _ref$precision = _ref.precision,
	      precision = _ref$precision === undefined ? function () {
	    return null;
	  } : _ref$precision,
	      formats = _ref.formats,
	      propType = _ref.propType;
	
	  (0, _invariant2.default)(typeof _format2 === 'function', 'number localizer `format(..)` must be a function');
	  (0, _invariant2.default)(typeof _parse === 'function', 'number localizer `parse(..)` must be a function');
	
	  checkFormats(REQUIRED_NUMBER_FORMATS, formats);
	
	  formats.editFormat = formats.editFormat || function (str) {
	    return parseFloat(str);
	  };
	
	  _numberLocalizer = {
	    formats: formats,
	    precision: precision,
	    decimalChar: decimalChar,
	    propType: propType || localePropType,
	
	    format: function format(value, str, culture) {
	      return _format(this, _format2, value, str, culture);
	    },
	    parse: function parse(value, culture, format) {
	      var result = _parse.call(this, value, culture, format);
	      (0, _invariant2.default)(result == null || typeof result === 'number', 'number localizer `parse(..)` must return a number, null, or undefined');
	      return result;
	    }
	  };
	}
	
	exports.setNumber = setNumber;
	var _dateLocalizer = createWrapper('DateTimePicker');
	
	function setDate(spec) {
	  (0, _invariant2.default)(typeof spec.format === 'function', 'date localizer `format(..)` must be a function');
	  (0, _invariant2.default)(typeof spec.parse === 'function', 'date localizer `parse(..)` must be a function');
	  (0, _invariant2.default)(typeof spec.firstOfWeek === 'function', 'date localizer `firstOfWeek(..)` must be a function');
	  checkFormats(REQUIRED_DATE_FORMATS, spec.formats);
	
	  _dateLocalizer = {
	    formats: spec.formats,
	    propType: spec.propType || localePropType,
	    startOfWeek: spec.firstOfWeek,
	    format: function format(value, str, culture) {
	      return _format(this, spec.format, value, str, culture);
	    },
	    parse: function parse(value, culture) {
	      var result = spec.parse.call(this, value, culture);
	      (0, _invariant2.default)(result == null || result instanceof Date && !isNaN(result.getTime()), 'date localizer `parse(..)` must return a valid Date, null, or undefined');
	      return result;
	    }
	  };
	}
	
	var number = exports.number = {
	  propType: function propType() {
	    var _numberLocalizer2;
	
	    return (_numberLocalizer2 = _numberLocalizer).propType.apply(_numberLocalizer2, arguments);
	  },
	  getFormat: function getFormat(key, format) {
	    return format || _numberLocalizer.formats[key];
	  },
	  parse: function parse() {
	    var _numberLocalizer3;
	
	    return (_numberLocalizer3 = _numberLocalizer).parse.apply(_numberLocalizer3, arguments);
	  },
	  format: function format() {
	    var _numberLocalizer4;
	
	    return (_numberLocalizer4 = _numberLocalizer).format.apply(_numberLocalizer4, arguments);
	  },
	  decimalChar: function decimalChar() {
	    var _numberLocalizer5;
	
	    return (_numberLocalizer5 = _numberLocalizer).decimalChar.apply(_numberLocalizer5, arguments);
	  },
	  precision: function precision() {
	    var _numberLocalizer6;
	
	    return (_numberLocalizer6 = _numberLocalizer).precision.apply(_numberLocalizer6, arguments);
	  }
	};
	
	var date = exports.date = {
	  propType: function propType() {
	    var _dateLocalizer2;
	
	    return (_dateLocalizer2 = _dateLocalizer).propType.apply(_dateLocalizer2, arguments);
	  },
	  getFormat: function getFormat(key, format) {
	    return format || _dateLocalizer.formats[key];
	  },
	  parse: function parse() {
	    var _dateLocalizer3;
	
	    return (_dateLocalizer3 = _dateLocalizer).parse.apply(_dateLocalizer3, arguments);
	  },
	  format: function format() {
	    var _dateLocalizer4;
	
	    return (_dateLocalizer4 = _dateLocalizer).format.apply(_dateLocalizer4, arguments);
	  },
	  startOfWeek: function startOfWeek() {
	    var _dateLocalizer5;
	
	    return (_dateLocalizer5 = _dateLocalizer).startOfWeek.apply(_dateLocalizer5, arguments);
	  }
	};
	
	exports.default = { number: number, date: date };
	
	
	function createWrapper() {
	  var dummy = {};
	
	  if (false) {
	    ['formats', 'parse', 'format', 'firstOfWeek', 'precision', 'propType'].forEach(function (name) {
	      return Object.defineProperty(dummy, name, {
	        enumerable: true,
	        get: function get() {
	          throw new Error('[React Widgets] You are attempting to use a widget that requires localization ' + '(Calendar, DateTimePicker, NumberPicker). ' + 'However there is no localizer set. Please configure a localizer. \n\n' + 'see http://jquense.github.io/react-widgets/docs/#/i18n for more info.');
	        }
	      });
	    });
	  }
	  return dummy;
	}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "configBezier", {
	  enumerable: true,
	  get: function get() {
	    return _easing.configBezier;
	  }
	});
	Object.defineProperty(exports, "configSpring", {
	  enumerable: true,
	  get: function get() {
	    return _easing.configSpring;
	  }
	});
	Object.defineProperty(exports, "translateStyle", {
	  enumerable: true,
	  get: function get() {
	    return _util.translateStyle;
	  }
	});
	Object.defineProperty(exports, "AnimateGroup", {
	  enumerable: true,
	  get: function get() {
	    return _AnimateGroup.default;
	  }
	});
	exports.default = void 0;
	
	var _Animate = _interopRequireDefault(__webpack_require__(902));
	
	var _easing = __webpack_require__(903);
	
	var _util = __webpack_require__(395);
	
	var _AnimateGroup = _interopRequireDefault(__webpack_require__(1963));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _Animate.default;
	exports.default = _default;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var isString = __webpack_require__(163);
	var Calendar_1 = tslib_1.__importDefault(__webpack_require__(876));
	var react_bootstrap_1 = __webpack_require__(72);
	var RaisedButton_1 = tslib_1.__importDefault(__webpack_require__(152));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var createForm_1 = __webpack_require__(18);
	var domUtils_1 = __webpack_require__(91);
	var dateUtils_1 = __webpack_require__(49);
	var StyledDateInterval = /** @class */ (function (_super) {
	    tslib_1.__extends(StyledDateInterval, _super);
	    function StyledDateInterval() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            focused: false,
	            showPopover: false,
	            localValueFrom: null,
	            localValueTo: null,
	            valueStr: null,
	            overlayPlacement: null
	        };
	        _this.onBlur = function (e) {
	            console.log('onBlur: %O', e);
	            var _a = _this.state, localValueFrom = _a.localValueFrom, localValueTo = _a.localValueTo;
	            _this.setState({
	                focused: false
	            });
	            _this.onChangeFromWrapper(localValueFrom);
	            _this.onChangeToWrapper(localValueTo);
	        };
	        _this.onFocus = function (e) {
	            _this.setState({
	                focused: true,
	                showPopover: true,
	                target: e.target,
	                overlayPlacement: (0, domUtils_1.findOverlayPlacement)(e.target, 550, 450)
	            });
	        };
	        _this.ok = function (e) {
	            var _a = _this.state, localValueFrom = _a.localValueFrom, localValueTo = _a.localValueTo;
	            _this.onChangeFromWrapper(localValueFrom);
	            _this.onChangeToWrapper(localValueTo);
	            _this.setState({ showPopover: false });
	        };
	        _this.cancel = function (e) {
	            var _a = _this.props, valueFrom = _a.valueFrom, valueTo = _a.valueTo;
	            _this.setState({
	                showPopover: false,
	                localValueFrom: (isString(valueFrom)) ? (0, moment_1.default)(valueFrom).toDate() : valueFrom,
	                localValueTo: (isString(valueTo)) ? (0, moment_1.default)(valueTo).toDate() : valueTo,
	                valueStr: (0, dateUtils_1.formatInterval)(valueFrom, valueTo)
	            });
	        };
	        _this.onChangeText = function (e) {
	            var _valueStr = e.target.value;
	            var _a = _this.parseInterval(_valueStr), v1 = _a[0], v2 = _a[1];
	            console.log('onChange(), setting state valueStr = %s', _valueStr);
	            _this.setState({
	                localValueFrom: v1,
	                localValueTo: v2,
	                valueStr: _valueStr
	            });
	        };
	        _this.onChangeFromLocal = function (value) {
	            _this.setState({
	                localValueFrom: value,
	                valueStr: (0, dateUtils_1.formatInterval)(value, _this.state.localValueTo)
	            });
	        };
	        _this.onChangeToLocal = function (value) {
	            _this.setState({
	                localValueTo: value,
	                valueStr: (0, dateUtils_1.formatInterval)(_this.state.localValueFrom, value)
	            });
	        };
	        _this.toPreviousMonth = function (e) {
	            var _from = (0, moment_1.default)().subtract(1, 'months').startOf('month').toDate(), _to = (0, moment_1.default)().subtract(1, 'months').endOf('month').startOf('day').toDate();
	            _this.setState({
	                localValueFrom: _from,
	                localValueTo: _to,
	                valueStr: (0, dateUtils_1.formatInterval)(_from, _to)
	            });
	        };
	        _this.toThisMonth = function (e) {
	            var _from = (0, moment_1.default)().startOf('month').toDate(), _to = (0, moment_1.default)().endOf('month').startOf('day').toDate();
	            _this.setState({
	                localValueFrom: _from,
	                localValueTo: _to,
	                valueStr: (0, dateUtils_1.formatInterval)(_from, _to)
	            });
	        };
	        _this.toNextMonth = function (e) {
	            var _from = (0, moment_1.default)().add(1, 'months').startOf('month').toDate(), _to = (0, moment_1.default)().add(1, 'months').endOf('month').startOf('day').toDate();
	            _this.setState({
	                localValueFrom: _from,
	                localValueTo: _to,
	                valueStr: (0, dateUtils_1.formatInterval)(_from, _to)
	            });
	        };
	        _this.toThisYear = function (e) {
	            var _from = (0, moment_1.default)().startOf('year').toDate(), _to = (0, moment_1.default)().endOf('year').startOf('day').toDate();
	            _this.setState({
	                localValueFrom: _from,
	                localValueTo: _to,
	                valueStr: (0, dateUtils_1.formatInterval)(_from, _to)
	            });
	        };
	        _this.toNextYear = function (e) {
	            var _from = (0, moment_1.default)().add(1, 'years').startOf('year').toDate(), _to = (0, moment_1.default)().add(1, 'years').endOf('year').startOf('day').toDate();
	            _this.setState({
	                localValueFrom: _from,
	                localValueTo: _to,
	                valueStr: (0, dateUtils_1.formatInterval)(_from, _to)
	            });
	        };
	        return _this;
	    }
	    StyledDateInterval.prototype.onChangeFromWrapper = function (value) {
	        this.props.onChangeFrom((value instanceof Date) ? (0, moment_1.default)(value).format("YYYY-MM-DD") : value);
	    };
	    StyledDateInterval.prototype.onChangeToWrapper = function (value) {
	        this.props.onChangeTo((value instanceof Date) ? (0, moment_1.default)(value).format("YYYY-MM-DD") : value);
	    };
	    StyledDateInterval.prototype.parseInterval = function (valueStr) {
	        if (!valueStr)
	            return [null, null];
	        var pole = valueStr.split('-');
	        var validFromStr = pole[0].trim();
	        var validToStr = (pole.length >= 2) ? pole[1].trim() : null;
	        if (validFromStr === '\u221E')
	            validFromStr = null;
	        if (validToStr === '\u221E')
	            validToStr = null;
	        var validFrom = (validFromStr) ? (0, moment_1.default)(validFromStr, "L") : null;
	        var validTo = (validToStr) ? (0, moment_1.default)(validToStr, "L") : null;
	        validFrom = (validFrom && validFrom.isValid()) ? validFrom.toDate() : null;
	        validTo = (validTo && validTo.isValid()) ? validTo.toDate() : null;
	        return [validFrom, validTo];
	    };
	    StyledDateInterval.prototype.componentWillMount = function () {
	        var _a = this.props, valueFrom = _a.valueFrom, valueTo = _a.valueTo;
	        console.log('componentWillMount');
	        this.setState({
	            localValueFrom: (valueFrom) ? (0, moment_1.default)(valueFrom).toDate() : null,
	            localValueTo: (valueTo) ? (0, moment_1.default)(valueTo).toDate() : null,
	            valueStr: (0, dateUtils_1.formatInterval)(valueFrom, valueTo)
	        });
	    };
	    StyledDateInterval.prototype.componentWillReceiveProps = function (nextProps) {
	        var valueFrom = nextProps.valueFrom, valueTo = nextProps.valueTo;
	        var _a = this.props, oldValueFrom = _a.oldValueFrom, oldValueTo = _a.oldValueTo;
	        if (valueFrom !== oldValueFrom || valueTo !== oldValueTo) {
	            this.setState({
	                localValueFrom: (valueFrom) ? (0, moment_1.default)(valueFrom).toDate() : null,
	                localValueTo: (valueTo) ? (0, moment_1.default)(valueTo).toDate() : null,
	                valueStr: (0, dateUtils_1.formatInterval)(valueFrom, valueTo)
	            });
	        }
	    };
	    StyledDateInterval.prototype.render = function () {
	        var _a = this.props, valueFrom = _a.valueFrom, valueTo = _a.valueTo, onChangeFrom = _a.onChangeFrom, onChangeTo = _a.onChangeTo, style = _a.style, onBlur = _a.onBlur, onFocus = _a.onFocus, onChange = _a.onChange, other = tslib_1.__rest(_a, ["valueFrom", "valueTo", "onChangeFrom", "onChangeTo", "style", "onBlur", "onFocus", "onChange"]);
	        var _b = this.state, localValueFrom = _b.localValueFrom, localValueTo = _b.localValueTo, valueStr = _b.valueStr, overlayPlacement = _b.overlayPlacement;
	        var calendarStyle = { maxWidth: 230, margin: 10, border: 0 };
	        var inputWrapperStyle = { padding: "0 10px" };
	        var buttonPeriodStyle = { fontSize: 16 };
	        var buttonActionStyle = { margin: "0 10px" };
	        var popoverBottom = (react_1.default.createElement(react_bootstrap_1.Overlay, { show: this.state.showPopover, onHide: this.cancel, target: this.state.target, placement: overlayPlacement },
	            react_1.default.createElement(react_bootstrap_1.Popover, { id: "popover-positioned-bottom" },
	                react_1.default.createElement("div", { style: { display: 'flex' } },
	                    react_1.default.createElement(FlatButton_1.default, { style: buttonPeriodStyle, label: "Previous Month", secondary: true, onClick: this.toPreviousMonth }),
	                    react_1.default.createElement(FlatButton_1.default, { style: buttonPeriodStyle, label: "This Month", secondary: true, onClick: this.toThisMonth }),
	                    react_1.default.createElement(FlatButton_1.default, { style: buttonPeriodStyle, label: "Next Month", secondary: true, onClick: this.toNextMonth }),
	                    react_1.default.createElement(FlatButton_1.default, { style: buttonPeriodStyle, label: "This year", secondary: true, onClick: this.toThisYear }),
	                    react_1.default.createElement(FlatButton_1.default, { style: buttonPeriodStyle, label: "Next year", secondary: true, onClick: this.toNextYear })),
	                react_1.default.createElement("div", { style: { display: 'flex' } },
	                    react_1.default.createElement("div", null,
	                        react_1.default.createElement("div", { style: inputWrapperStyle },
	                            react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({ value: localValueFrom, onChange: this.onChangeFromLocal, hideCalendar: true }, createForm_1.fieldStyles.small.textField))),
	                        react_1.default.createElement(Calendar_1.default, { value: localValueFrom, onChange: this.onChangeFromLocal, style: calendarStyle })),
	                    react_1.default.createElement("div", null,
	                        react_1.default.createElement("div", { style: inputWrapperStyle },
	                            react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({ value: localValueTo, onChange: this.onChangeToLocal, hideCalendar: true }, createForm_1.fieldStyles.small.textField))),
	                        react_1.default.createElement(Calendar_1.default, { value: localValueTo, onChange: this.onChangeToLocal, style: calendarStyle }))),
	                react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'flex-end' } },
	                    react_1.default.createElement(RaisedButton_1.default, { onClick: this.ok, label: "Ok", primary: true, style: buttonActionStyle }),
	                    react_1.default.createElement(RaisedButton_1.default, { onClick: this.cancel, label: "Cancel", primary: true, style: buttonActionStyle })))));
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, other, { value: valueStr, onChange: this.onChangeText, onBlur: this.onBlur, onFocus: this.onFocus }, createForm_1.fieldStyles.small.textField)),
	            popoverBottom));
	    };
	    return StyledDateInterval;
	}(react_1.default.PureComponent));
	exports.default = StyledDateInterval;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var productDomain_1 = __webpack_require__(158);
	var mobx_1 = __webpack_require__(5);
	var productVehicleAssignDialog_1 = __webpack_require__(571);
	var ProductService = /** @class */ (function () {
	    function ProductService() {
	    }
	    // ////////// VEHICLE ////////////////////////////////////////////////////////////////////////////////
	    ProductService.prototype.readVehicle = function (vehicleId, allPrices) {
	        return axios_config_1.default.get('/vehicle/' + vehicleId, { params: { allPrices: allPrices } })
	            .then(function (response) { return new productDomain_1.Vehicle(response.data); });
	    };
	    ProductService.prototype.readProductVehiclePrice = function (productId, vehicleId, partyId, currency) {
	        return axios_config_1.default.get('/product/product-vehicle-price/' + productId + '/' + vehicleId + '/' + partyId, { params: { currency: currency } })
	            .then(function (response) { return response.data; });
	    };
	    /**
	     * spec :  {registrationNumber: 456456}, {vin: 346456456}
	     * @param spec
	     * @returns {*}
	     */
	    ProductService.prototype.vehicleExist = function (spec) {
	        return axios_config_1.default.get('/vehicle/vehicle-exist', { params: spec })
	            .then(function (response) { return response.data; });
	    };
	    ProductService.prototype.vehicleSave = function (vehicleDto) {
	        return axios_config_1.default.post('/vehicle', vehicleDto, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    ProductService.prototype.deleteVehicle = function (vehicleId) {
	        return axios_config_1.default.delete('/vehicle/' + vehicleId, { showPrettyError: true });
	    };
	    // ////////// PRODUCT ////////////////////////////////////////////////////////////////////////////////
	    ProductService.prototype.assignProducts = function (PVADObject, part) {
	        return axios_config_1.default.post('/vehicle/assign-products/' + part, PVADObject, { showPrettyError: true })
	            .then(function (response) { return new productVehicleAssignDialog_1.PVADObjectDto(response.data); });
	    };
	    ProductService.prototype.readProduct = function (productId, billedFrom, billedTo) {
	        return axios_config_1.default.get('/product/' + productId, { params: { billedFrom: billedFrom, billedTo: billedTo } })
	            .then(function (response) { console.log(response); return new productDomain_1.Product(response.data); });
	    };
	    ProductService.prototype.readProductPrice = function (productId, partyId, currency) {
	        return axios_config_1.default.get('/product/product-price/' + productId + '/' + partyId, { params: { currency: currency } })
	            .then(function (response) { return response.data; });
	    };
	    ProductService.prototype.productSave = function (product) {
	        return axios_config_1.default.post('/product', product)
	            .then(function (response) { return response.data; });
	    };
	    ProductService.prototype.deleteProduct = function (productId) {
	        return axios_config_1.default.delete('/product/' + productId, { showPrettyError: true });
	    };
	    ProductService.prototype.isProductNumberUnique = function (productNumber) {
	        return axios_config_1.default.get('/product/product-number-exist', { params: { productNumber: productNumber } })
	            .then(function (response) { return response.data; });
	    };
	    // ////////// PRICECOMPOMENT ////////////////////////////////////////////////////////////////////////////////
	    ProductService.prototype.readPriceComponent = function (priceComponentId) {
	        return axios_config_1.default.get('/price-component/' + priceComponentId)
	            .then(function (response) { return new productDomain_1.PriceComponent(response.data); });
	    };
	    ProductService.prototype.searchPriceComponents = function (productId, vehicleId, partyId, priceLevel) {
	        return axios_config_1.default.get('/price-component', { params: { productId: productId, vehicleId: vehicleId, partyId: partyId, priceLevel: priceLevel } })
	            .then(function (response) { return response.data.map(function (v) { return new productDomain_1.PriceComponent(v); }); });
	    };
	    ProductService.prototype.initPriceComponent = function (partyId) {
	        return axios_config_1.default.get('/price-component/init-new', { params: { partyId: partyId } })
	            .then(function (response) { return new productDomain_1.PriceComponent(response.data); });
	    };
	    ProductService.prototype.priceComponentSave = function (priceComponent) {
	        return axios_config_1.default.post('/price-component', priceComponent, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    ProductService.prototype.deletePriceComponent = function (priceComponentId) {
	        return axios_config_1.default.delete('/price-component/' + priceComponentId, { showPrettyError: true });
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProductService.prototype, "priceComponentObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProductService.prototype, "vehicleObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProductService.prototype, "productObject", void 0);
	    return ProductService;
	}());
	var productService = new ProductService();
	exports.default = productService;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ShipmentVisit = exports.ShipmentRepackagingResource = exports.ShipmentRepackaging = exports.Shipment = exports.SHIPMENTVISITSTEP = exports.SHIPMENTREPACKAGINGSTATUS_COLORS = exports.SHIPMENTREPACKAGINGSTATUS = exports.SHIPMENTSTATUS_GRID_CSS = exports.SHIPMENTSTATUS_COLORS = exports.SHIPMENTSTATUS = exports.SHIPMENTDIRECTION = void 0;
	var tslib_1 = __webpack_require__(3);
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var metaConstant_1 = __webpack_require__(13);
	var colors_1 = __webpack_require__(29);
	var formUtils_1 = __webpack_require__(14);
	var dateUtils_1 = __webpack_require__(49);
	var SHIPMENTDIRECTION;
	(function (SHIPMENTDIRECTION) {
	    SHIPMENTDIRECTION["OUTGOING"] = "OUTGOING";
	    SHIPMENTDIRECTION["INCOMING"] = "INCOMING";
	})(SHIPMENTDIRECTION || (exports.SHIPMENTDIRECTION = SHIPMENTDIRECTION = {}));
	var SHIPMENTSTATUS;
	(function (SHIPMENTSTATUS) {
	    SHIPMENTSTATUS["NOTREADY"] = "NOTREADY";
	    SHIPMENTSTATUS["PARTIALLYREADY"] = "PARTIALLYREADY";
	    SHIPMENTSTATUS["READY"] = "READY";
	    SHIPMENTSTATUS["DOCUMENT"] = "DOCUMENT";
	})(SHIPMENTSTATUS || (exports.SHIPMENTSTATUS = SHIPMENTSTATUS = {}));
	exports.SHIPMENTSTATUS_COLORS = {
	    NOTREADY: colors_1.red500,
	    PARTIALLYREADY: colors_1.yellow500,
	    READY: colors_1.green500,
	    DOCUMENT: colors_1.blue500
	};
	exports.SHIPMENTSTATUS_GRID_CSS = {
	    NOTREADY: "fa fa-circle color-red-500",
	    PARTIALLYREADY: "fa fa-circle color-yellow-500",
	    READY: "fa fa-circle color-green-500",
	    DOCUMENT: "fa fa-circle color-blue-500"
	};
	var SHIPMENTREPACKAGINGSTATUS;
	(function (SHIPMENTREPACKAGINGSTATUS) {
	    SHIPMENTREPACKAGINGSTATUS["REPACKAGE"] = "REPACKAGE";
	    SHIPMENTREPACKAGINGSTATUS["PARTIALLYCOMPLETED"] = "PARTIALLYCOMPLETED";
	    SHIPMENTREPACKAGINGSTATUS["COMPLETED"] = "COMPLETED";
	})(SHIPMENTREPACKAGINGSTATUS || (exports.SHIPMENTREPACKAGINGSTATUS = SHIPMENTREPACKAGINGSTATUS = {}));
	exports.SHIPMENTREPACKAGINGSTATUS_COLORS = {
	    REPACKAGENEXTDAY: colors_1.grey500,
	    REPACKAGE: colors_1.red500,
	    PARTIALLYCOMPLETED: colors_1.yellow500,
	    COMPLETED: colors_1.green500
	};
	var SHIPMENTVISITSTEP;
	(function (SHIPMENTVISITSTEP) {
	    SHIPMENTVISITSTEP["PREPARED_VISIT"] = "PREPARED_VISIT";
	    SHIPMENTVISITSTEP["VEHICLE_ARRIVED"] = "VEHICLE_ARRIVED";
	    SHIPMENTVISITSTEP["VEHICLE_ENTERED"] = "VEHICLE_ENTERED";
	    SHIPMENTVISITSTEP["VEHICLE_LEFT"] = "VEHICLE_LEFT";
	})(SHIPMENTVISITSTEP || (exports.SHIPMENTVISITSTEP = SHIPMENTVISITSTEP = {}));
	var Shipment = /** @class */ (function (_super) {
	    tslib_1.__extends(Shipment, _super);
	    function Shipment(json) {
	        return _super.call(this, json) || this;
	    }
	    Shipment.prototype.getId = function () {
	        return this.shipmentId;
	    };
	    Shipment.prototype.setId = function (id) {
	        this.shipmentId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "shipmentId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "shipmentDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "shipmentStatus", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "shipmentDirection", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "shippedFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "shippedTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "hauler", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "shippedToAddress", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "shippedFromPlaceDesc", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "shippedFromPlace", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "shippedToPlaceDesc", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "shippedToPlace", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "registrationNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "plannedPaletteCount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "loadedPaletteCount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "notLoadedPaletteCount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "unloadedPaletteCount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "notUnloadedPaletteCount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "loadingNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "unloadingNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "loadingTruckCount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "unloadingTruckCount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "pickingList", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "shipmentVisit", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "transportationType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "maxWaitingTime", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "disponentParty", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "vehicle", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "requestedLoadingStart", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "requestedLoadingEnd", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "requestedUnloadingStart", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "requestedUnloadingEnd", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "visitOrder", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Shipment.prototype, "$shipmentVisit", void 0);
	    Shipment = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)(/** @class */ (function (_super) {
	            tslib_1.__extends(class_1, _super);
	            function class_1() {
	                return _super.call(this, "Shipment") || this;
	            }
	            class_1.prototype.getFormName = function (historyObject) {
	                return (historyObject.fullObject.shipmentDirection === SHIPMENTDIRECTION.OUTGOING) ? "ShipmentOutgoingForm" : "ShipmentIncomingForm";
	            };
	            return class_1;
	        }(metaConstant_1.EntityConfig)), "shipmentDetail")
	    ], Shipment);
	    return Shipment;
	}(DomainAncestor_1.DomainAncestor));
	exports.Shipment = Shipment;
	var ShipmentRepackaging = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentRepackaging, _super);
	    function ShipmentRepackaging(json) {
	        return _super.call(this, json) || this;
	    }
	    ShipmentRepackaging.prototype.getId = function () {
	        return this.shipmentRepackagingId;
	    };
	    ShipmentRepackaging.prototype.setId = function (id) {
	        this.shipmentRepackagingId = id;
	    };
	    ShipmentRepackaging.prototype.getRepackagingStatusIconClass = function (keDni, status) {
	        if ((0, formUtils_1.lovValue)(status) == SHIPMENTREPACKAGINGSTATUS.REPACKAGE) {
	            return ((!this.shipmentDate || (0, moment_1.default)(this.shipmentDate).isAfter(keDni)) ? colors_1.grey500 : colors_1.red500);
	        }
	        else {
	            return exports.SHIPMENTREPACKAGINGSTATUS_COLORS[(0, formUtils_1.lovValue)(status)];
	        }
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackaging.prototype, "shipmentRepackagingId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackaging.prototype, "shipmentDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackaging.prototype, "shipmentTime", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackaging.prototype, "repackagingStatus", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackaging.prototype, "shippedTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackaging.prototype, "packageType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackaging.prototype, "repackagingCode", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackaging.prototype, "boxQuantity", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackaging.prototype, "customerNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackaging.prototype, "paletteCount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackaging.prototype, "paletteItemCount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackaging.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackaging.prototype, "priority", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackaging.prototype, "product", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackaging.prototype, "shippedToAddress", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackaging.prototype, "repackedDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackaging.prototype, "shipmentVisit", void 0);
	    ShipmentRepackaging = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ShipmentRepackaging);
	    return ShipmentRepackaging;
	}(DomainAncestor_1.DomainAncestor));
	exports.ShipmentRepackaging = ShipmentRepackaging;
	var ShipmentRepackagingResource = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentRepackagingResource, _super);
	    function ShipmentRepackagingResource(json) {
	        return _super.call(this, json) || this;
	    }
	    ShipmentRepackagingResource.prototype.getId = function () {
	        return this.workDate;
	    };
	    ShipmentRepackagingResource.prototype.setId = function (id) {
	        this.workDate = id;
	    };
	    ShipmentRepackagingResource.prototype.getDailyNorm = function () {
	        return Math.ceil(this.availableResources * this.dailyPalleteNorm);
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackagingResource.prototype, "workDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackagingResource.prototype, "availableResources", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackagingResource.prototype, "dailyPalleteNorm", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackagingResource.prototype, "completedThisDay", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackagingResource.prototype, "toRepackThisDay", void 0);
	    ShipmentRepackagingResource = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ShipmentRepackagingResource);
	    return ShipmentRepackagingResource;
	}(DomainAncestor_1.DomainAncestor));
	exports.ShipmentRepackagingResource = ShipmentRepackagingResource;
	var ShipmentVisit = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentVisit, _super);
	    function ShipmentVisit(json) {
	        return _super.call(this, json) || this;
	    }
	    ShipmentVisit.prototype.getId = function () {
	        return this.shipmentVisitId;
	    };
	    ShipmentVisit.prototype.setId = function (id) {
	        this.shipmentVisitId = id;
	    };
	    ShipmentVisit.prototype.shipmentVisitLabel = function () {
	        return [this.registrationNumber, this.driverPhone].join(" ") + " - " + (0, dateUtils_1.formatDateTime)(this.visitTime);
	    };
	    ShipmentVisit.prototype.shipmentVisitLov = function () {
	        return {
	            value: this.shipmentVisitId,
	            label: this.shipmentVisitLabel()
	        };
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "shipmentVisitId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "visitTime", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "visitEnd", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "entranceTime", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "gateLoadingDuration", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "vendorLoadingDuration", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "registrationNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "driverPhone", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "directionOutgoing", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "directionPackaging", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "directionIncoming", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "packagingSender", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "step", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "shipments", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "$shipmentVisitShipmentsGrid", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "$shipmentVisitSuppliers", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "$supplierId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "$syncRegistrationNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "$syncShipmentStatus", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "$syncShippedFromPlace", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "$direction", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "$nextTime", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "$showSmsToDriver", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisit.prototype, "$visitsToDelete", void 0);
	    ShipmentVisit = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ShipmentVisit);
	    return ShipmentVisit;
	}(DomainAncestor_1.DomainAncestor));
	exports.ShipmentVisit = ShipmentVisit;


/***/ }),
/* 133 */,
/* 134 */
[2357, 421, 319, 179],
/* 135 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPrefixedValue;
	var regex = /-webkit-|-moz-|-ms-/;
	
	function isPrefixedValue(value) {
	  return typeof value === 'string' && regex.test(value);
	}
	module.exports = exports['default'];

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var nullthrows = function nullthrows(x) {
	  if (x != null) {
	    return x;
	  }
	  throw new Error("Got unexpected null or undefined");
	};
	
	module.exports = nullthrows;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(151),
	    getPrototype = __webpack_require__(475),
	    isObjectLike = __webpack_require__(116);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _events = __webpack_require__(363);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _keycode = __webpack_require__(99);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _FocusRipple = __webpack_require__(498);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(771);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styleInjected = false;
	var listening = false;
	var tabPressed = false;
	
	function injectStyle() {
	  if (!styleInjected) {
	    // Remove inner padding and border in Firefox 4+.
	    var style = document.createElement('style');
	    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';
	
	    document.body.appendChild(style);
	    styleInjected = true;
	  }
	}
	
	function listenForTabPresses() {
	  if (!listening) {
	    _events2.default.on(window, 'keydown', function (event) {
	      tabPressed = (0, _keycode2.default)(event) === 'tab';
	    });
	    listening = true;
	  }
	}
	
	var EnhancedButton = function (_Component) {
	  (0, _inherits3.default)(EnhancedButton, _Component);
	
	  function EnhancedButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedButton.__proto__ || (0, _getPrototypeOf2.default)(EnhancedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleKeyDown = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'enter' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	        if ((0, _keycode2.default)(event) === 'esc' && _this.state.isKeyboardFocused) {
	          _this.removeKeyboardFocus(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleKeyUp = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'space' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	      }
	      _this.props.onKeyUp(event);
	    }, _this.handleBlur = function (event) {
	      _this.cancelFocusTimeout();
	      _this.removeKeyboardFocus(event);
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (event) event.persist();
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        // setTimeout is needed because the focus event fires first
	        // Wait so that we can capture if this was a keyboard focus
	        // or touch focus
	        _this.focusTimeout = setTimeout(function () {
	          if (tabPressed) {
	            _this.setKeyboardFocus(event);
	            tabPressed = false;
	          }
	        }, 150);
	
	        _this.props.onFocus(event);
	      }
	    }, _this.handleTouchTap = function (event) {
	      _this.cancelFocusTimeout();
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.removeKeyboardFocus(event);
	        _this.props.onClick(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          disableKeyboardFocus = _props.disableKeyboardFocus,
	          keyboardFocused = _props.keyboardFocused;
	
	      if (!disabled && keyboardFocused && !disableKeyboardFocus) {
	        this.setState({ isKeyboardFocused: true });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      injectStyle();
	      listenForTabPresses();
	      if (this.state.isKeyboardFocused) {
	        this.button.focus();
	        this.props.onKeyboardFocus(null, true);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        if (nextProps.onKeyboardFocus) {
	          nextProps.onKeyboardFocus(null, false);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.focusTimeout) {
	        clearTimeout(this.focusTimeout);
	      }
	    }
	  }, {
	    key: 'isKeyboardFocused',
	    value: function isKeyboardFocused() {
	      return this.state.isKeyboardFocused;
	    }
	  }, {
	    key: 'removeKeyboardFocus',
	    value: function removeKeyboardFocus(event) {
	      if (this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        this.props.onKeyboardFocus(event, false);
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus(event) {
	      if (!this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: true });
	        this.props.onKeyboardFocus(event, true);
	      }
	    }
	  }, {
	    key: 'cancelFocusTimeout',
	    value: function cancelFocusTimeout() {
	      if (this.focusTimeout) {
	        clearTimeout(this.focusTimeout);
	        this.focusTimeout = null;
	      }
	    }
	  }, {
	    key: 'createButtonChildren',
	    value: function createButtonChildren() {
	      var _props2 = this.props,
	          centerRipple = _props2.centerRipple,
	          children = _props2.children,
	          disabled = _props2.disabled,
	          disableFocusRipple = _props2.disableFocusRipple,
	          disableKeyboardFocus = _props2.disableKeyboardFocus,
	          disableTouchRipple = _props2.disableTouchRipple,
	          focusRippleColor = _props2.focusRippleColor,
	          focusRippleOpacity = _props2.focusRippleOpacity,
	          touchRippleColor = _props2.touchRippleColor,
	          touchRippleOpacity = _props2.touchRippleOpacity;
	      var isKeyboardFocused = this.state.isKeyboardFocused;
	
	      // Focus Ripple
	
	      var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_FocusRipple2.default, {
	        color: focusRippleColor,
	        opacity: focusRippleOpacity,
	        show: isKeyboardFocused,
	        style: {
	          overflow: 'hidden'
	        },
	        key: 'focusRipple'
	      }) : undefined;
	
	      // Touch Ripple
	      var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(
	        _TouchRipple2.default,
	        {
	          centerRipple: centerRipple,
	          color: touchRippleColor,
	          opacity: touchRippleOpacity,
	          key: 'touchRipple'
	        },
	        children
	      ) : undefined;
	
	      return [focusRipple, touchRipple, touchRipple ? undefined : children];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          centerRipple = _props3.centerRipple,
	          children = _props3.children,
	          containerElement = _props3.containerElement,
	          disabled = _props3.disabled,
	          disableFocusRipple = _props3.disableFocusRipple,
	          disableKeyboardFocus = _props3.disableKeyboardFocus,
	          disableTouchRipple = _props3.disableTouchRipple,
	          focusRippleColor = _props3.focusRippleColor,
	          focusRippleOpacity = _props3.focusRippleOpacity,
	          href = _props3.href,
	          keyboardFocused = _props3.keyboardFocused,
	          touchRippleColor = _props3.touchRippleColor,
	          touchRippleOpacity = _props3.touchRippleOpacity,
	          onBlur = _props3.onBlur,
	          onClick = _props3.onClick,
	          onFocus = _props3.onFocus,
	          onKeyUp = _props3.onKeyUp,
	          onKeyDown = _props3.onKeyDown,
	          onKeyboardFocus = _props3.onKeyboardFocus,
	          style = _props3.style,
	          tabIndex = _props3.tabIndex,
	          type = _props3.type,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'href', 'keyboardFocused', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onClick', 'onFocus', 'onKeyUp', 'onKeyDown', 'onKeyboardFocus', 'style', 'tabIndex', 'type']);
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          enhancedButton = _context$muiTheme.enhancedButton;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        border: 10,
	        boxSizing: 'border-box',
	        display: 'inline-block',
	        fontFamily: this.context.muiTheme.baseTheme.fontFamily,
	        WebkitTapHighlightColor: enhancedButton.tapHighlightColor, // Remove mobile color flashing (deprecated)
	        cursor: disabled ? 'default' : 'pointer',
	        textDecoration: 'none',
	        margin: 0,
	        padding: 0,
	        outline: 'none',
	        fontSize: 'inherit',
	        fontWeight: 'inherit',
	        position: 'relative', // This is needed so that ripples do not bleed past border radius.
	        verticalAlign: href ? 'middle' : null
	      }, style);
	
	      // Passing both background:none & backgroundColor can break due to object iteration order
	      if (!mergedStyles.backgroundColor && !mergedStyles.background) {
	        mergedStyles.background = 'none';
	      }
	
	      if (disabled && href) {
	        return _react2.default.createElement(
	          'span',
	          (0, _extends3.default)({}, other, {
	            style: mergedStyles
	          }),
	          children
	        );
	      }
	
	      var buttonProps = (0, _extends3.default)({}, other, {
	        style: prepareStyles(mergedStyles),
	        ref: function ref(node) {
	          return _this2.button = node;
	        },
	        disabled: disabled,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyUp: this.handleKeyUp,
	        onKeyDown: this.handleKeyDown,
	        onClick: this.handleTouchTap,
	        tabIndex: disabled || disableKeyboardFocus ? -1 : tabIndex
	      });
	
	      if (href) buttonProps.href = href;
	
	      var buttonChildren = this.createButtonChildren();
	
	      if (_react2.default.isValidElement(containerElement)) {
	        return _react2.default.cloneElement(containerElement, buttonProps, buttonChildren);
	      }
	
	      if (!href && containerElement === 'button') {
	        buttonProps.type = type;
	      }
	
	      return _react2.default.createElement(href ? 'a' : containerElement, buttonProps, buttonChildren);
	    }
	  }]);
	  return EnhancedButton;
	}(_react.Component);
	
	EnhancedButton.defaultProps = {
	  containerElement: 'button',
	  onBlur: function onBlur() {},
	  onClick: function onClick() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyUp: function onKeyUp() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  tabIndex: 0,
	  type: 'button'
	};
	EnhancedButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	EnhancedButton.propTypes =  false ? {
	  centerRipple: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  disableFocusRipple: _propTypes2.default.bool,
	  disableKeyboardFocus: _propTypes2.default.bool,
	  disableTouchRipple: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  focusRippleColor: _propTypes2.default.string,
	  focusRippleOpacity: _propTypes2.default.number,
	  href: _propTypes2.default.string,
	  keyboardFocused: _propTypes2.default.bool,
	  onBlur: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  onKeyUp: _propTypes2.default.func,
	  onKeyboardFocus: _propTypes2.default.func,
	  style: _propTypes2.default.object,
	  tabIndex: _propTypes2.default.number,
	  touchRippleColor: _propTypes2.default.string,
	  touchRippleOpacity: _propTypes2.default.number,
	  type: _propTypes2.default.string
	} : {};
	exports.default = EnhancedButton;

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.inRangeOfSector = exports.formatAngleOfSector = exports.getAngleOfPoint = exports.distanceBetweenPoints = exports.formatAxisMap = exports.getMaxRadius = exports.polarToCartesian = exports.radianToDegree = exports.degreeToRadian = exports.RADIAN = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(115));
	
	var _DataUtils = __webpack_require__(66);
	
	var _ChartUtils = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var RADIAN = Math.PI / 180;
	exports.RADIAN = RADIAN;
	
	var degreeToRadian = function degreeToRadian(angle) {
	  return angle * Math.PI / 180;
	};
	
	exports.degreeToRadian = degreeToRadian;
	
	var radianToDegree = function radianToDegree(angleInRadian) {
	  return angleInRadian * 180 / Math.PI;
	};
	
	exports.radianToDegree = radianToDegree;
	
	var polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
	  return {
	    x: cx + Math.cos(-RADIAN * angle) * radius,
	    y: cy + Math.sin(-RADIAN * angle) * radius
	  };
	};
	
	exports.polarToCartesian = polarToCartesian;
	
	var getMaxRadius = function getMaxRadius(width, height) {
	  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    top: 0,
	    right: 0,
	    bottom: 0,
	    left: 0
	  };
	  return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
	};
	/**
	 * Calculate the scale function, position, width, height of axes
	 * @param  {Object} props     Latest props
	 * @param  {Object} axisMap   The configuration of axes
	 * @param  {Object} offset    The offset of main part in the svg element
	 * @param  {Object} axisType  The type of axes, radius-axis or angle-axis
	 * @param  {String} chartName The name of chart
	 * @return {Object} Configuration
	 */
	
	
	exports.getMaxRadius = getMaxRadius;
	
	var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
	  var width = props.width,
	      height = props.height;
	  var startAngle = props.startAngle,
	      endAngle = props.endAngle;
	  var cx = (0, _DataUtils.getPercentValue)(props.cx, width, width / 2);
	  var cy = (0, _DataUtils.getPercentValue)(props.cy, height, height / 2);
	  var maxRadius = getMaxRadius(width, height, offset);
	  var innerRadius = (0, _DataUtils.getPercentValue)(props.innerRadius, maxRadius, 0);
	  var outerRadius = (0, _DataUtils.getPercentValue)(props.outerRadius, maxRadius, maxRadius * 0.8);
	  var ids = Object.keys(axisMap);
	  return ids.reduce(function (result, id) {
	    var axis = axisMap[id];
	    var domain = axis.domain,
	        reversed = axis.reversed;
	    var range;
	
	    if ((0, _isNil2["default"])(axis.range)) {
	      if (axisType === 'angleAxis') {
	        range = [startAngle, endAngle];
	      } else if (axisType === 'radiusAxis') {
	        range = [innerRadius, outerRadius];
	      }
	
	      if (reversed) {
	        range = [range[1], range[0]];
	      }
	    } else {
	      range = axis.range;
	      var _range = range;
	
	      var _range2 = _slicedToArray(_range, 2);
	
	      startAngle = _range2[0];
	      endAngle = _range2[1];
	    }
	
	    var _parseScale = (0, _ChartUtils.parseScale)(axis, chartName),
	        realScaleType = _parseScale.realScaleType,
	        scale = _parseScale.scale;
	
	    scale.domain(domain).range(range);
	    (0, _ChartUtils.checkDomainOfScale)(scale);
	    var ticks = (0, _ChartUtils.getTicksOfScale)(scale, _objectSpread({}, axis, {
	      realScaleType: realScaleType
	    }));
	
	    var finalAxis = _objectSpread({}, axis, {}, ticks, {
	      range: range,
	      radius: outerRadius,
	      realScaleType: realScaleType,
	      scale: scale,
	      cx: cx,
	      cy: cy,
	      innerRadius: innerRadius,
	      outerRadius: outerRadius,
	      startAngle: startAngle,
	      endAngle: endAngle
	    });
	
	    return _objectSpread({}, result, _defineProperty({}, id, finalAxis));
	  }, {});
	};
	
	exports.formatAxisMap = formatAxisMap;
	
	var distanceBetweenPoints = function distanceBetweenPoints(point, anotherPoint) {
	  var x1 = point.x,
	      y1 = point.y;
	  var x2 = anotherPoint.x,
	      y2 = anotherPoint.y;
	  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
	};
	
	exports.distanceBetweenPoints = distanceBetweenPoints;
	
	var getAngleOfPoint = function getAngleOfPoint(_ref, _ref2) {
	  var x = _ref.x,
	      y = _ref.y;
	  var cx = _ref2.cx,
	      cy = _ref2.cy;
	  var radius = distanceBetweenPoints({
	    x: x,
	    y: y
	  }, {
	    x: cx,
	    y: cy
	  });
	
	  if (radius <= 0) {
	    return {
	      radius: radius
	    };
	  }
	
	  var cos = (x - cx) / radius;
	  var angleInRadian = Math.acos(cos);
	
	  if (y > cy) {
	    angleInRadian = 2 * Math.PI - angleInRadian;
	  }
	
	  return {
	    radius: radius,
	    angle: radianToDegree(angleInRadian),
	    angleInRadian: angleInRadian
	  };
	};
	
	exports.getAngleOfPoint = getAngleOfPoint;
	
	var formatAngleOfSector = function formatAngleOfSector(_ref3) {
	  var startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	  var startCnt = Math.floor(startAngle / 360);
	  var endCnt = Math.floor(endAngle / 360);
	  var min = Math.min(startCnt, endCnt);
	  return {
	    startAngle: startAngle - min * 360,
	    endAngle: endAngle - min * 360
	  };
	};
	
	exports.formatAngleOfSector = formatAngleOfSector;
	
	var reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
	  var startAngle = _ref4.startAngle,
	      endAngle = _ref4.endAngle;
	  var startCnt = Math.floor(startAngle / 360);
	  var endCnt = Math.floor(endAngle / 360);
	  var min = Math.min(startCnt, endCnt);
	  return angle + min * 360;
	};
	
	var inRangeOfSector = function inRangeOfSector(_ref5, sector) {
	  var x = _ref5.x,
	      y = _ref5.y;
	
	  var _getAngleOfPoint = getAngleOfPoint({
	    x: x,
	    y: y
	  }, sector),
	      radius = _getAngleOfPoint.radius,
	      angle = _getAngleOfPoint.angle;
	
	  var innerRadius = sector.innerRadius,
	      outerRadius = sector.outerRadius;
	
	  if (radius < innerRadius || radius > outerRadius) {
	    return false;
	  }
	
	  if (radius === 0) {
	    return true;
	  }
	
	  var _formatAngleOfSector = formatAngleOfSector(sector),
	      startAngle = _formatAngleOfSector.startAngle,
	      endAngle = _formatAngleOfSector.endAngle;
	
	  var formatAngle = angle;
	  var inRange;
	
	  if (startAngle <= endAngle) {
	    while (formatAngle > endAngle) {
	      formatAngle -= 360;
	    }
	
	    while (formatAngle < startAngle) {
	      formatAngle += 360;
	    }
	
	    inRange = formatAngle >= startAngle && formatAngle <= endAngle;
	  } else {
	    while (formatAngle > startAngle) {
	      formatAngle -= 360;
	    }
	
	    while (formatAngle < endAngle) {
	      formatAngle += 360;
	    }
	
	    inRange = formatAngle >= endAngle && formatAngle <= startAngle;
	  }
	
	  if (inRange) {
	    return _objectSpread({}, sector, {
	      radius: radius,
	      angle: reverseFormatAngleOfSetor(formatAngle, sector)
	    });
	  }
	
	  return null;
	};
	
	exports.inRangeOfSector = inRangeOfSector;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DEFAULT_CURRENCY_FORMAT = void 0;
	exports.formatNumber = formatNumber;
	exports.parseNumber = parseNumber;
	exports.toPlainString = toPlainString;
	exports.formatMonetaryAmount = formatMonetaryAmount;
	exports.roundTo = roundTo;
	var tslib_1 = __webpack_require__(3);
	var numeral_1 = tslib_1.__importDefault(__webpack_require__(1635));
	var formUtils_1 = __webpack_require__(14);
	// load a language
	numeral_1.default.language('cs', {
	    delimiters: {
	        thousands: ' ',
	        decimal: ','
	    },
	    abbreviations: {
	        thousand: 'k',
	        million: 'm',
	        billion: 'b',
	        trillion: 't'
	    },
	    ordinal: function (num) {
	        return '.';
	    },
	    currency: {
	        symbol: 'Kč'
	    }
	});
	// switch between languages
	numeral_1.default.language('cs');
	var DEFAULT_NUMBER_FORMAT = '0[.][00000000]';
	exports.DEFAULT_CURRENCY_FORMAT = '0,0.00[000000]';
	/**
	 * If value is number, it is formateed, otherwise is just returned
	 * @param value
	 * @param format
	 * @returns {*}
	 */
	function formatNumber(value, format) {
	    if (format === void 0) { format = DEFAULT_NUMBER_FORMAT; }
	    var cislo = (value == null || value === '' || isNaN(value)) ? /*null*/ value : (0, numeral_1.default)(value).format(format);
	    return (typeof cislo === 'object') ? ((cislo === null) ? null : cislo.toString()) : cislo;
	}
	/**
	 * If value is parseable to number is parsed to number, otherwise is just returned
	 * @param value
	 * @returns {number}
	 */
	function parseNumber(value) {
	    if (value == null || value === '') {
	        return null;
	    }
	    else {
	        if (value.replace)
	            value = value.replace(',', '.');
	        return (isNaN(value) || (value.endsWith && value.endsWith('.'))) ? value : Number(value);
	    }
	}
	function toPlainString(value) {
	    return (value != null) ? ((isNegativeZero(value)) ? "-0" : value.toString()) : value;
	}
	function isNegativeZero(x) {
	    return x === 0 && (1 / x < 0);
	}
	function formatMonetaryAmount(amount, currencyLov) {
	    return formatNumber(amount, exports.DEFAULT_CURRENCY_FORMAT) + " " + (0, formUtils_1.lovValue)(currencyLov);
	}
	function roundTo(num, precision) {
	    var factor = Math.pow(10, precision);
	    return Math.round(num * factor) / factor;
	}


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var RadioButtonGroup_1 = tslib_1.__importDefault(__webpack_require__(243));
	var RadioButton_1 = tslib_1.__importDefault(__webpack_require__(287));
	var formUtils_1 = __webpack_require__(14);
	var colors_1 = __webpack_require__(29);
	var isFunction = __webpack_require__(55);
	/**
	 * Requirement is to show number formated if unfocused and unformated if focused,
	 * that is to format number on onBlur and deformat on onFocus.
	 * props's onChange is called with value parsed into number if possible, or string if not a number
	 * Component must have a valueStr to keep a precise entered string and valueNum to distinguish change coming out of the outside
	 * These cannot be on state because setState in onChange is not seen in subsequent componentWillReceiveProps
	 * But there is additional state's valueStr set in onChange to cause a rerender
	 */
	//@observer
	var RadioButtonField = /** @class */ (function (_super) {
	    tslib_1.__extends(RadioButtonField, _super);
	    function RadioButtonField() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onChangeInner = function (evt) {
	            var lov = _this.props.options.find(function (v) { return v.value == evt.target.value; });
	            _this.props.onChange(lov);
	        };
	        return _this;
	    }
	    RadioButtonField.prototype.render = function () {
	        var _a = this.props, name = _a.name, value = _a.value, labelStyle = _a.labelStyle, inputStyle = _a.inputStyle, options = _a.options, onChange = _a.onChange, optionStyle = _a.optionStyle, groupStyle = _a.groupStyle, iconStyle = _a.iconStyle, iconStyleFn = _a.iconStyleFn, style = _a.style, errorText = _a.errorText, disabled = _a.disabled, other = tslib_1.__rest(_a, ["name", "value", "labelStyle", "inputStyle", "options", "onChange", "optionStyle", "groupStyle", "iconStyle", "iconStyleFn", "style", "errorText", "disabled"]);
	        return (react_1.default.createElement("div", { style: style },
	            react_1.default.createElement(RadioButtonGroup_1.default, { name: name, valueSelected: (0, formUtils_1.lovValue)(value), onChange: this.onChangeInner, style: groupStyle }, options.map(function (lov, index) { return react_1.default.createElement(RadioButton_1.default, { key: index, value: lov.value, label: lov.label, labelStyle: labelStyle, iconStyle: (iconStyleFn) ? iconStyleFn(lov.value) : iconStyle, inputStyle: inputStyle, style: optionStyle, disabled: (isFunction(disabled)) ? disabled(lov) : disabled }); })),
	            react_1.default.createElement("div", { style: { fontSize: 12, color: colors_1.red500 } }, errorText)));
	    };
	    return RadioButtonField;
	}(react_1.default.PureComponent));
	exports.default = RadioButtonField;


/***/ }),
/* 145 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PROJECT_VERSION_CAPACITIES_ENTITY = exports.PROJECT_RUNOFF_COEFFICIENT_ENTITY = exports.PROJECT_VERSION_PARKING_ENTITY = exports.PROJECT_VERSION_LOP_PROFILES_ENTITY = exports.PROJECT_VERSION_LOP_FILLINGS_ENTITY = exports.PROJECT_VERSION_TREE_ENTITY = exports.PROJECT_VERSION_WINDOW_ENTITY = exports.PROJECT_VERSION_DOOR_ENTITY = exports.PROJECT_VERSION_AREA_ENTITY = exports.AREA_ENTITY = exports.PROJECT_VERSION_ROOM_CATEGORY_ENTITY = exports.PROJECT_VERSION_ROOM_TYPE_ENTITY = exports.PROJECT_VERSION_ROOM_ENTITY = exports.PROJECT_VERSION_PARAM_VALUE_ENTITY = exports.PROJECT_VERSION_LIFESPAN_ENTITY = exports.PROJECT_MATERIAL_ENTITY = exports.PROJECT_VERSION_MATERIAL_ENTITY = exports.PROJECT_VERSION_ENERGY_CARRIER_ENTITY = exports.PROJECT_CRITERION_VERSION_ENTITY = exports.PROJECT_VERSION_ENTITY = exports.PROJECT_ENTITY = exports.MATERIAL_USAGE_GROUP_ENTITY = exports.MATERIAL_CATEGORY_ENTITY = exports.MATERIAL_ENTITY = exports.ENERGY_CARRIER_ENTITY = exports.SUB_CRITERION_PARAM_VALUE_ENTITY = exports.SUB_CRITERION_PARAM_ENTITY = exports.SUB_CRITERION_ENTITY = exports.CRITERION_SCORE_ENTITY = exports.CRITERION_ENTITY = void 0;
	exports.CRITERION_ENTITY = "Criterion";
	exports.CRITERION_SCORE_ENTITY = "CriterionScore";
	exports.SUB_CRITERION_ENTITY = "SubCriterion";
	exports.SUB_CRITERION_PARAM_ENTITY = "SubCriterionParameter";
	exports.SUB_CRITERION_PARAM_VALUE_ENTITY = "SubCriterionParameterValue";
	exports.ENERGY_CARRIER_ENTITY = "EnergyCarrier";
	exports.MATERIAL_ENTITY = "Material";
	exports.MATERIAL_CATEGORY_ENTITY = "MaterialCategory";
	exports.MATERIAL_USAGE_GROUP_ENTITY = "MaterialUsageGroup";
	exports.PROJECT_ENTITY = "Project";
	exports.PROJECT_VERSION_ENTITY = "ProjectVersion";
	exports.PROJECT_CRITERION_VERSION_ENTITY = "ProjectCriterionVersion";
	exports.PROJECT_VERSION_ENERGY_CARRIER_ENTITY = "ProjectVersionEnergyCarrier";
	exports.PROJECT_VERSION_MATERIAL_ENTITY = "ProjectVersionMaterial";
	exports.PROJECT_MATERIAL_ENTITY = "ProjectMaterial";
	exports.PROJECT_VERSION_LIFESPAN_ENTITY = "Lifespan";
	exports.PROJECT_VERSION_PARAM_VALUE_ENTITY = "ProjectVersionParamValue";
	exports.PROJECT_VERSION_ROOM_ENTITY = "ProjectVersionRoom";
	exports.PROJECT_VERSION_ROOM_TYPE_ENTITY = "ProjectVersionRoomType";
	exports.PROJECT_VERSION_ROOM_CATEGORY_ENTITY = "ProjectVersionRoomCategory";
	exports.AREA_ENTITY = "Area";
	exports.PROJECT_VERSION_AREA_ENTITY = "ProjectVersionArea";
	exports.PROJECT_VERSION_DOOR_ENTITY = "ProjectVersionDoor";
	exports.PROJECT_VERSION_WINDOW_ENTITY = "ProjectVersionWindow";
	exports.PROJECT_VERSION_TREE_ENTITY = "ProjectVersionTree";
	exports.PROJECT_VERSION_LOP_FILLINGS_ENTITY = "ProjectVersionLopFilling";
	exports.PROJECT_VERSION_LOP_PROFILES_ENTITY = "ProjectVersionLopProfile";
	exports.PROJECT_VERSION_PARKING_ENTITY = "ProjectVersionParking";
	exports.PROJECT_RUNOFF_COEFFICIENT_ENTITY = "ProjectVersionRunoffCoefficient";
	exports.PROJECT_VERSION_CAPACITIES_ENTITY = "ProjectVersionCapacity";


/***/ }),
/* 146 */,
/* 147 */,
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(179);
	var core = __webpack_require__(95);
	var ctx = __webpack_require__(414);
	var hide = __webpack_require__(226);
	var has = __webpack_require__(198);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 149 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var UserAgentData = __webpack_require__(1297);
	var VersionRange = __webpack_require__(1298);
	
	var mapObject = __webpack_require__(1309);
	var memoizeStringOnly = __webpack_require__(459);
	
	/**
	 * Checks to see whether `name` and `version` satisfy `query`.
	 *
	 * @param {string} name Name of the browser, device, engine or platform
	 * @param {?string} version Version of the browser, engine or platform
	 * @param {string} query Query of form "Name [range expression]"
	 * @param {?function} normalizer Optional pre-processor for range expression
	 * @return {boolean}
	 */
	function compare(name, version, query, normalizer) {
	  // check for exact match with no version
	  if (name === query) {
	    return true;
	  }
	
	  // check for non-matching names
	  if (!query.startsWith(name)) {
	    return false;
	  }
	
	  // full comparison with version
	  var range = query.slice(name.length);
	  if (version) {
	    range = normalizer ? normalizer(range) : range;
	    return VersionRange.contains(range, version);
	  }
	
	  return false;
	}
	
	/**
	 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
	 * platform.
	 *
	 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
	 *
	 * @param {string} version
	 * @return {string}
	 */
	function normalizePlatformVersion(version) {
	  if (UserAgentData.platformName === 'Windows') {
	    return version.replace(/^\s*NT/, '');
	  }
	
	  return version;
	}
	
	/**
	 * Provides client-side access to the authoritative PHP-generated User Agent
	 * information supplied by the server.
	 */
	var UserAgent = {
	  /**
	   * Check if the User Agent browser matches `query`.
	   *
	   * `query` should be a string like "Chrome" or "Chrome > 33".
	   *
	   * Valid browser names include:
	   *
	   * - ACCESS NetFront
	   * - AOL
	   * - Amazon Silk
	   * - Android
	   * - BlackBerry
	   * - BlackBerry PlayBook
	   * - Chrome
	   * - Chrome for iOS
	   * - Chrome frame
	   * - Facebook PHP SDK
	   * - Facebook for iOS
	   * - Firefox
	   * - IE
	   * - IE Mobile
	   * - Mobile Safari
	   * - Motorola Internet Browser
	   * - Nokia
	   * - Openwave Mobile Browser
	   * - Opera
	   * - Opera Mini
	   * - Opera Mobile
	   * - Safari
	   * - UIWebView
	   * - Unknown
	   * - webOS
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `BrowserDetector` class and
	   * related classes in the same file (see calls to `new UserAgentBrowser` here:
	   * https://fburl.com/50728104).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isBrowser: function isBrowser(query) {
	    return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
	  },
	
	
	  /**
	   * Check if the User Agent browser uses a 32 or 64 bit architecture.
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "32" or "64".
	   * @return {boolean}
	   */
	  isBrowserArchitecture: function isBrowserArchitecture(query) {
	    return compare(UserAgentData.browserArchitecture, null, query);
	  },
	
	
	  /**
	   * Check if the User Agent device matches `query`.
	   *
	   * `query` should be a string like "iPhone" or "iPad".
	   *
	   * Valid device names include:
	   *
	   * - Kindle
	   * - Kindle Fire
	   * - Unknown
	   * - iPad
	   * - iPhone
	   * - iPod
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `DeviceDetector` class and
	   * related classes in the same file (see calls to `new UserAgentDevice` here:
	   * https://fburl.com/50728332).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name"
	   * @return {boolean}
	   */
	  isDevice: function isDevice(query) {
	    return compare(UserAgentData.deviceName, null, query);
	  },
	
	
	  /**
	   * Check if the User Agent rendering engine matches `query`.
	   *
	   * `query` should be a string like "WebKit" or "WebKit >= 537".
	   *
	   * Valid engine names include:
	   *
	   * - Gecko
	   * - Presto
	   * - Trident
	   * - WebKit
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `RenderingEngineDetector`
	   * class related classes in the same file (see calls to `new
	   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isEngine: function isEngine(query) {
	    return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
	  },
	
	
	  /**
	   * Check if the User Agent platform matches `query`.
	   *
	   * `query` should be a string like "Windows" or "iOS 5 - 6".
	   *
	   * Valid platform names include:
	   *
	   * - Android
	   * - BlackBerry OS
	   * - Java ME
	   * - Linux
	   * - Mac OS X
	   * - Mac OS X Calendar
	   * - Mac OS X Internet Account
	   * - Symbian
	   * - SymbianOS
	   * - Windows
	   * - Windows Mobile
	   * - Windows Phone
	   * - iOS
	   * - iOS Facebook Integration Account
	   * - iOS Facebook Social Sharing UI
	   * - webOS
	   * - Chrome OS
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `PlatformDetector` class and
	   * related classes in the same file (see calls to `new UserAgentPlatform`
	   * here: https://fburl.com/50729226).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isPlatform: function isPlatform(query) {
	    return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
	  },
	
	
	  /**
	   * Check if the User Agent platform is a 32 or 64 bit architecture.
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "32" or "64".
	   * @return {boolean}
	   */
	  isPlatformArchitecture: function isPlatformArchitecture(query) {
	    return compare(UserAgentData.platformArchitecture, null, query);
	  }
	};
	
	module.exports = mapObject(UserAgent, memoizeStringOnly);

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(238),
	    getRawTag = __webpack_require__(1425),
	    objectToString = __webpack_require__(1453);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RaisedButton = __webpack_require__(1534);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RaisedButton2.default;

/***/ }),
/* 153 */,
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _createChainedFunction = __webpack_require__(90);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  href: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'a'
	};
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	var SafeAnchor = function (_React$Component) {
	  (0, _inherits3.default)(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props, context) {
	    (0, _classCallCheck3.default)(this, SafeAnchor);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  SafeAnchor.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        href = _props.href,
	        onClick = _props.onClick;
	
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (event.key === ' ') {
	      event.preventDefault();
	      this.handleClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        disabled = _props2.disabled,
	        onKeyDown = _props2.onKeyDown,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['componentClass', 'disabled', 'onKeyDown']);
	
	
	    if (isTrivialHref(props.href)) {
	      props.role = props.role || 'button';
	      // we want to make sure there is a href attribute on the node
	      // otherwise, the cursor incorrectly styled (except with role='button')
	      props.href = props.href || '#';
	    }
	
	    if (disabled) {
	      props.tabIndex = -1;
	      props.style = (0, _extends3.default)({ pointerEvents: 'none' }, props.style);
	    }
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, props, {
	      onClick: this.handleClick,
	      onKeyDown: (0, _createChainedFunction2.default)(this.handleKeyDown, onKeyDown)
	    }));
	  };
	
	  return SafeAnchor;
	}(_react2.default.Component);
	
	SafeAnchor.propTypes = propTypes;
	SafeAnchor.defaultProps = defaultProps;
	
	exports.default = SafeAnchor;
	module.exports = exports['default'];

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64),
	    _assign = __webpack_require__(40);
	
	var CallbackQueue = __webpack_require__(825);
	var PooledClass = __webpack_require__(214);
	var ReactFeatureFlags = __webpack_require__(830);
	var ReactReconciler = __webpack_require__(247);
	var Transaction = __webpack_require__(376);
	
	var invariant = __webpack_require__(28);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _localizers = __webpack_require__(128);
	
	var _localizers2 = _interopRequireDefault(_localizers);
	
	var _filter = __webpack_require__(880);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filterTypes = Object.keys(_filter2.default).filter(function (i) {
	  return i !== 'filter';
	});
	
	function getInteractionPropType(key) {
	  var types = [_propTypes2.default.bool, _propTypes2.default.oneOf([key])],
	      propType = _propTypes2.default.oneOfType(types);
	
	  propType.acceptsArray = _propTypes2.default.oneOfType(types.concat(_propTypes2.default.array));
	
	  return propType;
	}
	
	module.exports = {
	
	  elementType: createChainableTypeChecker(function (props, propName, componentName) {
	
	    if (typeof props[propName] !== 'function') {
	      if (_react2.default.isValidElement(props[propName])) return new Error('Invalid prop `' + propName + '` specified in  `' + componentName + '`.' + ' Expected an Element `type`, not an actual Element');
	
	      if (typeof props[propName] !== 'string') return new Error('Invalid prop `' + propName + '` specified in  `' + componentName + '`.' + ' Expected an Element `type` such as a tag name or return value of createReactClass(...)');
	    }
	    return null;
	  }),
	
	  numberFormat: createChainableTypeChecker(function () {
	    var _localizers$number;
	
	    return (_localizers$number = _localizers2.default.number).propType.apply(_localizers$number, arguments);
	  }),
	
	  dateFormat: createChainableTypeChecker(function () {
	    var _localizers$date;
	
	    return (_localizers$date = _localizers2.default.date).propType.apply(_localizers$date, arguments);
	  }),
	
	  disabled: getInteractionPropType('disabled'),
	  readOnly: getInteractionPropType('readOnly'),
	
	  accessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  message: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
	
	  filter: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.bool, _propTypes2.default.oneOf(filterTypes)])
	};
	
	function createChainableTypeChecker(validate) {
	
	  function checkType(isRequired, props, propName, componentName) {
	    componentName = componentName || '<<anonymous>>';
	
	    for (var _len = arguments.length, args = Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
	      args[_key - 4] = arguments[_key];
	    }
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required prop `' + propName + '` was not specified in  `' + componentName + '`.');
	      }
	    } else return validate.apply(undefined, [props, propName, componentName].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var _a, _b, _c;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Payment = exports.InvoiceTemplate = exports.InvoiceTemplateItem = exports.IssueInvoicesDto = exports.Rate = exports.canDeleteInvoiceDocument = exports.Invoice = exports.PaymentRelation = exports.InvoiceRelation = exports.VatRate = exports.VatRateValue = exports.InvoiceVatRecap = exports.InvoiceItem = exports.INVOICEWARNING = exports.INVOICEPAYMENTMATCHTYPE = exports.PAYMENTRELATIONTYPE = exports.relationArray = exports.linkingPerInvoiceTypes = exports.relationTypesToFinalInvoice = exports.INVOICERELATIONTYPE = exports.PAYMENT_TYPE = exports.INVOICE_TYPE = exports.INVOICEITEMTYPE = exports.DEFAULT_MONETARY_ROUNDING = exports.INVOICESTATUS = void 0;
	exports.relationArrayInverse = relationArrayInverse;
	var tslib_1 = __webpack_require__(3);
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var documentDomain_1 = __webpack_require__(109);
	var formUtils_1 = __webpack_require__(14);
	var documentService_1 = tslib_1.__importDefault(__webpack_require__(110));
	var commonDomain_1 = __webpack_require__(310);
	var eventDomain_1 = __webpack_require__(74);
	var numberUtils_1 = __webpack_require__(143);
	var metaDomain_1 = __webpack_require__(220);
	// INVOICE STATUS
	// issued:  CONCEPT -> ISSUED (-> CANCELED)
	// received:  RECEIVED -> BOOKED (-> CANCELED)
	var INVOICESTATUS;
	(function (INVOICESTATUS) {
	    INVOICESTATUS["CONCEPT"] = "CONCEPT";
	    INVOICESTATUS["ISSUED"] = "ISSUED";
	    INVOICESTATUS["CANCELED"] = "CANCELED";
	    INVOICESTATUS["RECEIVED"] = "RECEIVED";
	    INVOICESTATUS["BOOKED"] = "BOOKED";
	})(INVOICESTATUS || (exports.INVOICESTATUS = INVOICESTATUS = {}));
	exports.DEFAULT_MONETARY_ROUNDING = 6;
	// INVOICE ITEM TYPE
	var INVOICEITEMTYPE;
	(function (INVOICEITEMTYPE) {
	    INVOICEITEMTYPE["FREEITEM"] = "FREEITEM";
	    INVOICEITEMTYPE["PRODUCTITEM"] = "PRODUCTITEM";
	    INVOICEITEMTYPE["PRODUCTVEHICLEITEM"] = "PRODUCTVEHICLEITEM";
	    INVOICEITEMTYPE["ROUNDINGDIFF"] = "ROUNDINGDIFF";
	})(INVOICEITEMTYPE || (exports.INVOICEITEMTYPE = INVOICEITEMTYPE = {}));
	// INVOICE_TYPE
	var INVOICE_TYPE;
	(function (INVOICE_TYPE) {
	    INVOICE_TYPE[INVOICE_TYPE["FI"] = 1] = "FI";
	    INVOICE_TYPE[INVOICE_TYPE["CN"] = 2] = "CN";
	    INVOICE_TYPE[INVOICE_TYPE["PR"] = 3] = "PR";
	    INVOICE_TYPE[INVOICE_TYPE["DP"] = 4] = "DP";
	    INVOICE_TYPE[INVOICE_TYPE["AD"] = 5] = "AD";
	})(INVOICE_TYPE || (exports.INVOICE_TYPE = INVOICE_TYPE = {}));
	var PAYMENT_TYPE;
	(function (PAYMENT_TYPE) {
	    PAYMENT_TYPE[PAYMENT_TYPE["ACCOUNT_TRANSFER"] = 1] = "ACCOUNT_TRANSFER";
	    PAYMENT_TYPE[PAYMENT_TYPE["CASH"] = 2] = "CASH";
	    PAYMENT_TYPE[PAYMENT_TYPE["CREDIT_NOTE"] = 3] = "CREDIT_NOTE";
	    PAYMENT_TYPE[PAYMENT_TYPE["MUTUAL_CREDIT"] = 4] = "MUTUAL_CREDIT";
	    PAYMENT_TYPE[PAYMENT_TYPE["CUSTOMER_CREDIT"] = 5] = "CUSTOMER_CREDIT";
	})(PAYMENT_TYPE || (exports.PAYMENT_TYPE = PAYMENT_TYPE = {}));
	var INVOICERELATIONTYPE;
	(function (INVOICERELATIONTYPE) {
	    INVOICERELATIONTYPE["CN_TO_FI"] = "CN_TO_FI";
	    INVOICERELATIONTYPE["CN_TO_AD"] = "CN_TO_AD";
	    INVOICERELATIONTYPE["DP_TO_FI"] = "DP_TO_FI";
	    INVOICERELATIONTYPE["PR_TO_FI"] = "PR_TO_FI";
	    INVOICERELATIONTYPE["AD_TO_DP"] = "AD_TO_DP";
	    INVOICERELATIONTYPE["AD_TO_FI"] = "AD_TO_FI";
	})(INVOICERELATIONTYPE || (exports.INVOICERELATIONTYPE = INVOICERELATIONTYPE = {}));
	exports.relationTypesToFinalInvoice = (_a = {},
	    _a[INVOICE_TYPE.CN] = [INVOICERELATIONTYPE.CN_TO_FI, INVOICERELATIONTYPE.CN_TO_AD],
	    _a[INVOICE_TYPE.PR] = [INVOICERELATIONTYPE.PR_TO_FI],
	    _a[INVOICE_TYPE.DP] = [INVOICERELATIONTYPE.DP_TO_FI],
	    _a[INVOICE_TYPE.AD] = [INVOICERELATIONTYPE.AD_TO_FI, INVOICERELATIONTYPE.AD_TO_DP],
	    _a[INVOICE_TYPE.FI] = [],
	    _a);
	exports.linkingPerInvoiceTypes = (_b = {},
	    _b[INVOICE_TYPE.CN] = [INVOICE_TYPE.FI, INVOICE_TYPE.AD],
	    _b[INVOICE_TYPE.PR] = [],
	    _b[INVOICE_TYPE.DP] = [],
	    _b[INVOICE_TYPE.AD] = [INVOICE_TYPE.DP],
	    _b[INVOICE_TYPE.FI] = [INVOICE_TYPE.PR, INVOICE_TYPE.DP, INVOICE_TYPE.AD],
	    _b);
	exports.relationArray = (_c = {},
	    _c[INVOICERELATIONTYPE.CN_TO_FI] = [INVOICE_TYPE.CN, INVOICE_TYPE.FI],
	    _c[INVOICERELATIONTYPE.CN_TO_AD] = [INVOICE_TYPE.CN, INVOICE_TYPE.AD],
	    _c[INVOICERELATIONTYPE.DP_TO_FI] = [INVOICE_TYPE.DP, INVOICE_TYPE.FI],
	    _c[INVOICERELATIONTYPE.PR_TO_FI] = [INVOICE_TYPE.PR, INVOICE_TYPE.FI],
	    _c[INVOICERELATIONTYPE.AD_TO_FI] = [INVOICE_TYPE.AD, INVOICE_TYPE.FI],
	    _c[INVOICERELATIONTYPE.AD_TO_DP] = [INVOICE_TYPE.AD, INVOICE_TYPE.DP],
	    _c);
	function relationArrayInverse(invoiceTypeFrom, invoiceTypeTo) {
	    for (var _i = 0, _a = Object.entries(exports.relationArray); _i < _a.length; _i++) {
	        var _b = _a[_i], key = _b[0], value = _b[1];
	        if (value[0] === invoiceTypeFrom && value[1] === invoiceTypeTo) {
	            return key;
	        }
	    }
	    return undefined;
	}
	var PAYMENTRELATIONTYPE;
	(function (PAYMENTRELATIONTYPE) {
	    PAYMENTRELATIONTYPE["PAY_TO_INV"] = "PAY_TO_INV";
	    PAYMENTRELATIONTYPE["PAY_TO_AD"] = "PAY_TO_AD";
	})(PAYMENTRELATIONTYPE || (exports.PAYMENTRELATIONTYPE = PAYMENTRELATIONTYPE = {}));
	var INVOICEPAYMENTMATCHTYPE;
	(function (INVOICEPAYMENTMATCHTYPE) {
	    INVOICEPAYMENTMATCHTYPE["VS"] = "VS";
	    INVOICEPAYMENTMATCHTYPE["BANKACCOUNT"] = "BANKACCOUNT";
	    INVOICEPAYMENTMATCHTYPE["BANKACCOUNT_AMOUNT"] = "BANKACCOUNT_AMOUNT";
	    INVOICEPAYMENTMATCHTYPE["CREDIT_NOTE"] = "CREDIT_NOTE";
	    INVOICEPAYMENTMATCHTYPE["MANUAL"] = "MANUAL";
	})(INVOICEPAYMENTMATCHTYPE || (exports.INVOICEPAYMENTMATCHTYPE = INVOICEPAYMENTMATCHTYPE = {}));
	var INVOICEWARNING;
	(function (INVOICEWARNING) {
	    INVOICEWARNING["differentFields"] = "differentFields";
	    INVOICEWARNING["differentVatRates"] = "differentVatRates";
	    INVOICEWARNING["vehicleOwners"] = "vehicleOwners";
	    INVOICEWARNING["exchangeRateDifferent"] = "exchangeRateDifferent";
	    INVOICEWARNING["negativeItemExists"] = "negativeItemExists";
	    INVOICEWARNING["positiveItemExists"] = "positiveItemExists";
	})(INVOICEWARNING || (exports.INVOICEWARNING = INVOICEWARNING = {}));
	var InvoiceItem = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceItem, _super);
	    function InvoiceItem(json) {
	        return _super.call(this, json) || this;
	    }
	    InvoiceItem.prototype.getId = function () {
	        return this.invoiceItemId;
	    };
	    InvoiceItem.prototype.setId = function (id) {
	        this.invoiceItemId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "invoiceItemId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "invoice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "itemIndex", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "itemType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "product", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "vehicle", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "party", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "productNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "description", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "unitOfMeasure", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "vatRateRef", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "quantity", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "unitPrice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "unitPriceLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "basePrice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "basePriceLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "adjustmentKoef", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "adjustmentAmount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "adjustmentAmountLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "basePriceWithAdjustment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "basePriceWithAdjustmentLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "invoiceAdjustmentAmount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "invoiceAdjustmentAmountLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "priceWithoutVat", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "priceWithoutVatLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "vatRate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "vatAmount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "vatAmountLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "itemPrice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "itemPriceLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItem.prototype, "taxType", void 0);
	    InvoiceItem = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], InvoiceItem);
	    return InvoiceItem;
	}(DomainAncestor_1.DomainAncestor));
	exports.InvoiceItem = InvoiceItem;
	var InvoiceVatRecap = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceVatRecap, _super);
	    function InvoiceVatRecap(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceVatRecap.prototype, "basis", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceVatRecap.prototype, "basisLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceVatRecap.prototype, "amount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceVatRecap.prototype, "amountLcy", void 0);
	    InvoiceVatRecap = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], InvoiceVatRecap);
	    return InvoiceVatRecap;
	}(DomainAncestor_1.DomainAncestor));
	exports.InvoiceVatRecap = InvoiceVatRecap;
	var VatRateValue = /** @class */ (function (_super) {
	    tslib_1.__extends(VatRateValue, _super);
	    function VatRateValue(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], VatRateValue.prototype, "vatRate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], VatRateValue.prototype, "validFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], VatRateValue.prototype, "validTo", void 0);
	    VatRateValue = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], VatRateValue);
	    return VatRateValue;
	}(DomainAncestor_1.DomainAncestor));
	exports.VatRateValue = VatRateValue;
	var VatRate = /** @class */ (function (_super) {
	    tslib_1.__extends(VatRate, _super);
	    function VatRate(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.values)
	            _this.values = [];
	        return _this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], VatRate.prototype, "vatRateId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], VatRate.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], VatRate.prototype, "validFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], VatRate.prototype, "validTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], VatRate.prototype, "vatRateCountry", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], VatRate.prototype, "noVat", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(VatRateValue)
	    ], VatRate.prototype, "values", void 0);
	    VatRate = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], VatRate);
	    return VatRate;
	}(DomainAncestor_1.DomainAncestor));
	exports.VatRate = VatRate;
	var InvoiceRelation = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceRelation, _super);
	    function InvoiceRelation(json) {
	        return _super.call(this, json) || this;
	    }
	    InvoiceRelation.prototype.getOtherInvoice = function (invoice) {
	        return (this.fromInvoice && invoice.invoiceId == this.fromInvoice.value) ? this.toInvoice // == - porebuju aby se null rovnalo undefined
	            : ((this.toInvoice && invoice.invoiceId == this.toInvoice.value) ? this.fromInvoice : undefined);
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceRelation.prototype, "fromInvoice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceRelation.prototype, "toInvoice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceRelation.prototype, "relationType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceRelation.prototype, "currency", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceRelation.prototype, "contributedAmount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceRelation.prototype, "valueDate", void 0);
	    InvoiceRelation = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], InvoiceRelation);
	    return InvoiceRelation;
	}(DomainAncestor_1.DomainAncestor));
	exports.InvoiceRelation = InvoiceRelation;
	var PaymentRelation = /** @class */ (function (_super) {
	    tslib_1.__extends(PaymentRelation, _super);
	    function PaymentRelation(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PaymentRelation.prototype, "payment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PaymentRelation.prototype, "invoice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PaymentRelation.prototype, "relationType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PaymentRelation.prototype, "currency", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PaymentRelation.prototype, "contributedAmount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PaymentRelation.prototype, "valueDate", void 0);
	    PaymentRelation = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], PaymentRelation);
	    return PaymentRelation;
	}(DomainAncestor_1.DomainAncestor));
	exports.PaymentRelation = PaymentRelation;
	var Invoice = /** @class */ (function (_super) {
	    tslib_1.__extends(Invoice, _super);
	    function Invoice(json) {
	        return _super.call(this, json) || this;
	    }
	    Invoice.prototype.fromJson = function (json) {
	        _super.prototype.fromJson.call(this, json, "vatRecap");
	        if (!this.items)
	            this.items = [];
	        if (!this.documents)
	            this.documents = [];
	        if (!this.fields)
	            this.fields = [];
	        if (!this.fromRels)
	            this.fromRels = [];
	        if (!this.toRels)
	            this.toRels = [];
	        if (!this.vatRecap)
	            this.vatRecap = new mobx_1.ObservableMap();
	        (0, metaDomain_1.initDynamicFields)("Invoice", this);
	        return this;
	    };
	    Invoice.prototype.getId = function () {
	        return this.invoiceId;
	    };
	    Invoice.prototype.setId = function (id) {
	        _super.prototype.setId.call(this, id);
	        this.invoiceId = id;
	    };
	    Invoice.prototype.invoiceLabel = function () {
	        return this.invoiceNumber;
	    };
	    Invoice.prototype.invoiceLov = function () {
	        return { value: this.invoiceId, label: this.invoiceLabel() };
	    };
	    Invoice.prototype.invoiceIsCurrencyDifferent = function () {
	        return ((0, formUtils_1.lovValue)(this.localCurrency) !== (0, formUtils_1.lovValue)(this.invoiceCurrency));
	    };
	    Invoice.prototype.invoiceNegativeItemExists = function () {
	        return (this.items.filter(function (item) { return item.basePrice < 0; }).length > 0);
	    };
	    Invoice.prototype.invoicePositiveItemExists = function () {
	        return (this.items.filter(function (item) { return item.basePrice > 0; }).length > 0);
	    };
	    Invoice.prototype.invoiceComputeHuDeliveryDate = function () {
	        // if  due date is later than period last date
	        // then  due date
	        // else issue date
	        //
	        if (this.dueDate && this.endInvoicePeriod) {
	            return ((0, moment_1.default)(this.dueDate).isAfter((0, moment_1.default)(this.endInvoicePeriod))) ? this.dueDate : this.invoiceDate;
	        }
	        else {
	            return null;
	        }
	    };
	    Invoice.prototype.isSent = function () {
	        return this.dateEmailedToCustomer || this.dateSentByPostToCustomer;
	    };
	    Invoice.prototype.getInvoiceParamsForNumberGenSearch = function () {
	        return {
	            entityName: "Invoice",
	            invoiceDate: this.invoiceDate
	        };
	    };
	    Invoice.prototype.getFinalInvoiceRels = function () {
	        var typesToFinalInvoice = exports.relationTypesToFinalInvoice[(0, formUtils_1.lovValue)(this.invoiceType)];
	        return this.fromRels.filter(function (ir) { return typesToFinalInvoice.includes((0, formUtils_1.lovValue)(ir.relationType)); });
	    };
	    Invoice.prototype.getLinkedInvoices = function () {
	        return tslib_1.__spreadArray(tslib_1.__spreadArray([], this.fromRels.map(function (r) { return r.toInvoice; }), true), this.toRels.map(function (r) { return r.fromInvoice; }), true);
	    };
	    Invoice.prototype.createInvoiceInInvoiceRelation = function () {
	        return {
	            value: this.invoiceId,
	            label: this.label,
	            invoiceType: this.invoiceType,
	            invoiceNumber: this.invoiceNumber,
	            invoiceDate: this.invoiceDate,
	            totalAdjustedPrice: this.totalAdjustedPrice
	        };
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "invoiceId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "invoiceNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "invoiceStatus", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "invoiceDirection", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "billedFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "billedTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "billedTo2", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "profitCenter", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "invoiceDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "invoiceTime", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "taxDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "dueDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "deliveryDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "deliveryNoteDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "orderDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "startInvoicePeriod", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "endInvoicePeriod", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "periodicInvoice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "orderNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "contractNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "deliveryNoteNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "internalComment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "paymentCond", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "paymentType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "localCurrency", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "invoiceCurrency", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "invoiceType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "language", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "copiedFromInvoiceId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "sendType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "monetaryRounding", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "exchangeRate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "basePrice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "basePriceLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "itemAdjustmentKoef", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "itemAdjustmentAmount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "itemAdjustmentAmountLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "basePriceWithAdjustment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "basePriceWithAdjustmentLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "invoiceAdjustmentKoef", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "invoiceAdjustmentAmount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "invoiceAdjustmentAmountLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "priceWithoutVat", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "priceWithoutVatLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "vatAmount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "vatAmountLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "totalPrice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "totalPriceLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "pennyAdjustment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "pennyAdjustmentLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "totalAdjustedPrice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "totalAdjustedPriceLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "dateEmailedToCustomer", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "dateSentByPostToCustomer", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "dateSentToAccounting", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "dateSentToTaxOffice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "dateSentToArchive", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "taxOfficeConfirmationNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "taxOfficeConfirmationTime", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "taxOfficeConfirmationError", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "paidAmount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "invoicePaid", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "invoiceCredited", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "issueDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "cnOutstanding", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromFullName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromIco", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromDic", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromIcoDph", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromCommercialRegister", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromPhone", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromFax", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromEmail", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromUrl", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "toFullName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "toIco", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "toDic", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "toIcoDph", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromStreet", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromCity", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromZip", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromCountry", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "toPermanentStreet", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "toPermanentCity", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "toPermanentZip", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "toPermanentCountry", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "toCorrespondentStreet", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "toCorrespondentCity", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "toCorrespondentZip", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "toCorrespondentCountry", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromAccountPrefix", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromAccountNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromIban", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromBankName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromBankCode", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromBankSwift", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromBankAddress", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromBankCountry", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromAccountPrefixLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromAccountNumberLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromIbanLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromBankNameLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromBankCodeLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromBankSwiftLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromBankAddressLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "fromBankCountryLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "accountingMatchingId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "issuedBy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "orderedBy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "statusFontCss", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "entityNumberGen", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "accountingNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "accountingProfitCenter", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "costCenter", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "internalOrder", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "relatedInvoice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(InvoiceVatRecap)
	    ], Invoice.prototype, "vatRecap", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(InvoiceItem)
	    ], Invoice.prototype, "items", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(documentDomain_1.Document)
	    ], Invoice.prototype, "documents", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(metaDomain_1.DynamicField)
	    ], Invoice.prototype, "fields", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(InvoiceRelation)
	    ], Invoice.prototype, "fromRels", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(InvoiceRelation)
	    ], Invoice.prototype, "toRels", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "linkedInvoiceIds", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "$generateInvoiceNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "$negativeItemExists", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "$negativeItemResolved", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "$positiveItemExists", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "$positiveItemResolved", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "$exchangeRateResolved", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "$exchangeRateDifferent", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "$vatRateResolved", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "$vatRateDifferent", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "$differentFields", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "$vehicleOwners", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "$vehicleOwnersResolved", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Invoice.prototype, "$invoiceGraph", void 0);
	    Invoice = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], Invoice);
	    return Invoice;
	}(DomainAncestor_1.DomainAncestor));
	exports.Invoice = Invoice;
	var canDeleteInvoiceDocument = function (invoice, document) { return (invoice.invoiceStatus === INVOICESTATUS.CONCEPT && documentService_1.default.isUploadType(document)); };
	exports.canDeleteInvoiceDocument = canDeleteInvoiceDocument;
	var Rate = /** @class */ (function (_super) {
	    tslib_1.__extends(Rate, _super);
	    function Rate(json) {
	        return _super.call(this, json) || this;
	    }
	    return Rate;
	}(DomainAncestor_1.DomainAncestor));
	exports.Rate = Rate;
	var IssueInvoicesDto = /** @class */ (function (_super) {
	    tslib_1.__extends(IssueInvoicesDto, _super);
	    function IssueInvoicesDto(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.rates)
	            _this.rates = [];
	        return _this;
	    }
	    IssueInvoicesDto.prototype.customerNoErrorCount = function () {
	        return (this.customerStatuses && this.customerStatuses.length) ? this.customerStatuses.filter(function (cs) { return cs.status !== commonDomain_1.SEVERITY.ERROR; }).length : 0;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], IssueInvoicesDto.prototype, "invoiceDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], IssueInvoicesDto.prototype, "taxDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], IssueInvoicesDto.prototype, "startInvoicePeriod", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], IssueInvoicesDto.prototype, "endInvoicePeriod", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], IssueInvoicesDto.prototype, "paymentType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], IssueInvoicesDto.prototype, "customerIds", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], IssueInvoicesDto.prototype, "profitCenter", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(eventDomain_1.EntityStatus)
	    ], IssueInvoicesDto.prototype, "customerStatuses", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], IssueInvoicesDto.prototype, "issuedBy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], IssueInvoicesDto.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], IssueInvoicesDto.prototype, "internalComment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], IssueInvoicesDto.prototype, "invoiceAdjustmentKoef", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], IssueInvoicesDto.prototype, "part", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], IssueInvoicesDto.prototype, "count", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], IssueInvoicesDto.prototype, "showErrors", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], IssueInvoicesDto.prototype, "reverseChargeText", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(Rate)
	    ], IssueInvoicesDto.prototype, "rates", void 0);
	    IssueInvoicesDto = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], IssueInvoicesDto);
	    return IssueInvoicesDto;
	}(DomainAncestor_1.DomainAncestor));
	exports.IssueInvoicesDto = IssueInvoicesDto;
	var InvoiceTemplateItem = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceTemplateItem, _super);
	    function InvoiceTemplateItem(json) {
	        return _super.call(this, json) || this;
	    }
	    InvoiceTemplateItem.prototype.getId = function () {
	        return this.invoiceTemplateItemId;
	    };
	    InvoiceTemplateItem.prototype.setId = function (id) {
	        this.invoiceTemplateItemId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "invoiceTemplateItemId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "invoiceTemplate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "itemIndex", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "itemType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "product", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "vehicle", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "party", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "productNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "description", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "unitOfMeasure", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "vatRateRef", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "quantity", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "unitPrice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "unitPriceExpression", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "basePrice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "basePriceExpression", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "adjustmentKoef", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "adjustmentAmount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "basePriceWithAdjustment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "invoiceAdjustmentAmount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "priceWithoutVat", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "vatRate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "vatAmount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "itemPrice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "taxType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItem.prototype, "$useExpression", void 0);
	    InvoiceTemplateItem = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], InvoiceTemplateItem);
	    return InvoiceTemplateItem;
	}(DomainAncestor_1.DomainAncestor));
	exports.InvoiceTemplateItem = InvoiceTemplateItem;
	var InvoiceTemplate = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceTemplate, _super);
	    function InvoiceTemplate(json) {
	        return _super.call(this, json) || this;
	    }
	    InvoiceTemplate.prototype.fromJson = function (json) {
	        _super.prototype.fromJson.call(this, json);
	        if (!this.items)
	            this.items = [];
	        if (!this.fields)
	            this.fields = [];
	        (0, metaDomain_1.initDynamicFields)("InvoiceTemplate", this);
	        return this;
	    };
	    InvoiceTemplate.prototype.getId = function () {
	        return this.invoiceTemplateId;
	    };
	    InvoiceTemplate.prototype.setId = function (id) {
	        this.invoiceTemplateId = id;
	        this.id = id;
	    };
	    InvoiceTemplate.prototype.invoiceTemplateLov = function () {
	        return { value: this.invoiceTemplateId, label: this.name };
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "invoiceTemplateId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "description", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "active", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "closeDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "billedTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "billedTo2", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "profitCenter", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "internalComment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "paymentCond", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "paymentType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "invoiceCurrency", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "invoiceType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "language", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "eventType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "monetaryRounding", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "basePrice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "itemAdjustmentKoef", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "itemAdjustmentAmount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "basePriceWithAdjustment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "invoiceAdjustmentKoef", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "invoiceAdjustmentAmount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "priceWithoutVat", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "vatAmount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "totalPrice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "pennyAdjustment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "totalAdjustedPrice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "validFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "validTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "disableScheduling", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "remittanceType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "remittanceSkipCount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "holidayHandling", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "issueInvoice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "markAsSentByPost", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "issuedBy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "orderedBy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "lastGenerateDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "nextGenerateDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "startInvoicePeriodExpression", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "endInvoicePeriodExpression", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "periodicInvoice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "invoiceDateExpression", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "taxDateExpression", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "entityNumberGen", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "accountingNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "accountingProfitCenter", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "costCenter", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplate.prototype, "internalOrder", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(InvoiceTemplateItem)
	    ], InvoiceTemplate.prototype, "items", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(metaDomain_1.DynamicField)
	    ], InvoiceTemplate.prototype, "fields", void 0);
	    InvoiceTemplate = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], InvoiceTemplate);
	    return InvoiceTemplate;
	}(DomainAncestor_1.DomainAncestor));
	exports.InvoiceTemplate = InvoiceTemplate;
	var Payment = /** @class */ (function (_super) {
	    tslib_1.__extends(Payment, _super);
	    function Payment(json) {
	        return _super.call(this, json) || this;
	    }
	    Payment.prototype.fromJson = function (json) {
	        _super.prototype.fromJson.call(this, json);
	        if (!this.paymentRels)
	            this.paymentRels = [];
	        return this;
	    };
	    Payment.prototype.getId = function () {
	        return this.paymentId;
	    };
	    Payment.prototype.setId = function (id) {
	        this.paymentId = id;
	        this.id = id;
	    };
	    Payment.prototype.getFullAmount = function () {
	        return (0, numberUtils_1.formatNumber)(this.amount, numberUtils_1.DEFAULT_CURRENCY_FORMAT) + " " + (0, formUtils_1.lovValue)(this.currency);
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Payment.prototype, "paymentId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Payment.prototype, "valueDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Payment.prototype, "amount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Payment.prototype, "currency", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Payment.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Payment.prototype, "paymentType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Payment.prototype, "bankTransaction", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Payment.prototype, "matchType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(PaymentRelation)
	    ], Payment.prototype, "paymentRels", void 0);
	    Payment = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], Payment);
	    return Payment;
	}(DomainAncestor_1.DomainAncestor));
	exports.Payment = Payment;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Product = exports.Vehicle = exports.ProductVehicle = exports.PriceComponent = exports.PROFITCENTER = exports.PRICECOMPLEVEL_COLORS = exports.PRICECOMPLEVEL = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var metaConstant_1 = __webpack_require__(13);
	var mobx_1 = __webpack_require__(5);
	var colors_1 = __webpack_require__(29);
	var PRICECOMPLEVEL;
	(function (PRICECOMPLEVEL) {
	    PRICECOMPLEVEL["PRODUCT"] = "PRODUCT";
	    PRICECOMPLEVEL["PRODUCTCUSTGROUP"] = "PRODUCTCUSTGROUP";
	    PRICECOMPLEVEL["PRODUCTCUSTOMER"] = "PRODUCTCUSTOMER";
	    PRICECOMPLEVEL["PRODUCTVEHICLE"] = "PRODUCTVEHICLE";
	})(PRICECOMPLEVEL || (exports.PRICECOMPLEVEL = PRICECOMPLEVEL = {}));
	exports.PRICECOMPLEVEL_COLORS = {
	    PRODUCT: colors_1.green500,
	    PRODUCTCUSTGROUP: colors_1.orange500,
	    PRODUCTCUSTOMER: colors_1.blue500,
	    PRODUCTVEHICLE: colors_1.red500
	};
	exports.PROFITCENTER = {
	    DYNAFLEET: 1,
	    OPTIFLEET: 2
	};
	var PriceComponent = /** @class */ (function (_super) {
	    tslib_1.__extends(PriceComponent, _super);
	    function PriceComponent(json) {
	        return _super.call(this, json) || this;
	    }
	    PriceComponent.prototype.getId = function () {
	        return this.priceComponentId;
	    };
	    PriceComponent.prototype.setId = function (id) {
	        this.priceComponentId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PriceComponent.prototype, "priceComponentId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PriceComponent.prototype, "priceLevel", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PriceComponent.prototype, "product", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PriceComponent.prototype, "vehicle", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PriceComponent.prototype, "party", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PriceComponent.prototype, "priceCurrency", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PriceComponent.prototype, "price", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PriceComponent.prototype, "profitCenter", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PriceComponent.prototype, "priceLcy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PriceComponent.prototype, "validFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PriceComponent.prototype, "validTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PriceComponent.prototype, "comment", void 0);
	    PriceComponent = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)(/** @class */ (function (_super) {
	            tslib_1.__extends(class_1, _super);
	            function class_1() {
	                return _super.call(this, "PriceComponent") || this;
	            }
	            class_1.prototype.getFormName = function (historyObject) {
	                return (historyObject.parentEntityName === 'Vehicle') ? "PriceComponentAssignedForm"
	                    : ((historyObject.parentEntityName === 'Product') ? "PriceComponentProductForm" : "PriceComponentForm");
	            };
	            return class_1;
	        }(metaConstant_1.EntityConfig)))
	    ], PriceComponent);
	    return PriceComponent;
	}(DomainAncestor_1.DomainAncestor));
	exports.PriceComponent = PriceComponent;
	var ProductVehicle = /** @class */ (function (_super) {
	    tslib_1.__extends(ProductVehicle, _super);
	    function ProductVehicle(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProductVehicle.prototype, "product", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProductVehicle.prototype, "vehicle", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProductVehicle.prototype, "validFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProductVehicle.prototype, "validTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProductVehicle.prototype, "validPrice", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(PriceComponent)
	    ], ProductVehicle.prototype, "prices", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProductVehicle.prototype, "activePriceComponentId", void 0);
	    ProductVehicle = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ProductVehicle);
	    return ProductVehicle;
	}(DomainAncestor_1.DomainAncestor));
	exports.ProductVehicle = ProductVehicle;
	var Vehicle = /** @class */ (function (_super) {
	    tslib_1.__extends(Vehicle, _super);
	    function Vehicle(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.productVehicles)
	            _this.productVehicles = [];
	        return _this;
	    }
	    Vehicle.prototype.getId = function () {
	        return this.vehicleId;
	    };
	    Vehicle.prototype.setId = function (id) {
	        this.vehicleId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Vehicle.prototype, "vehicleId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Vehicle.prototype, "registrationNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Vehicle.prototype, "vin", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Vehicle.prototype, "chassis", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Vehicle.prototype, "chassisSeries", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Vehicle.prototype, "model", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Vehicle.prototype, "party", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Vehicle.prototype, "vehicleType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Vehicle.prototype, "vehicleBrand", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Vehicle.prototype, "vehicleNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Vehicle.prototype, "activationDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Vehicle.prototype, "active", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Vehicle.prototype, "note", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Vehicle.prototype, "operatorParty", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Vehicle.prototype, "driverParty", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Vehicle.prototype, "closeDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Vehicle.prototype, "lastNotificationCheck", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Vehicle.prototype, "sourceSystemDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(ProductVehicle)
	    ], Vehicle.prototype, "productVehicles", void 0);
	    Vehicle = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)(undefined, "vehicleDetail")
	    ], Vehicle);
	    return Vehicle;
	}(DomainAncestor_1.DomainAncestor));
	exports.Vehicle = Vehicle;
	var Product = /** @class */ (function (_super) {
	    tslib_1.__extends(Product, _super);
	    function Product(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.prices)
	            _this.prices = [];
	        return _this;
	    }
	    Product.prototype.getId = function () {
	        return this.productId;
	    };
	    Product.prototype.setId = function (id) {
	        this.productId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Product.prototype, "productId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Product.prototype, "productNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Product.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Product.prototype, "productType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Product.prototype, "specification", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Product.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Product.prototype, "introductionDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Product.prototype, "salesDiscontinuationDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Product.prototype, "supportDiscontinuationDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Product.prototype, "unitOfMeasure", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Product.prototype, "profitCenter", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Product.prototype, "revenueCategory", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Product.prototype, "vatRate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Product.prototype, "closeDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Product.prototype, "taxType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(PriceComponent)
	    ], Product.prototype, "prices", void 0);
	    Product = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], Product);
	    return Product;
	}(DomainAncestor_1.DomainAncestor));
	exports.Product = Product;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mobx_1 = __webpack_require__(5);
	var projectVersionService_1 = tslib_1.__importDefault(__webpack_require__(111));
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var ParamsService = /** @class */ (function () {
	    function ParamsService() {
	        var _this = this;
	        this.paramsValues = (0, mobx_1.observable)([]);
	        // recalculating project version params numbers
	        // for example params 2,4,6 convert to 1,2,3 for correct saving on BE
	        this.recalculateParamsNumbers = function () {
	            if (!_this.selectedSubCriterion) {
	                throw new Error("Sub criterion is not selected");
	            }
	            var newParamsValues = [];
	            var oldParamsValues = _this.paramsValues.peek();
	            var paramsForCurrentSubCriterion = oldParamsValues.filter(function (p) { return _this.selectedSubCriterion.parameters.find(function (sb) { return sb.paramId === p.parameter.paramId; }); });
	            var paramsForAnotherSubCriteria = oldParamsValues.filter(function (p) { return _this.selectedSubCriterion.parameters.find(function (sb) { return sb.paramId === p.parameter.paramId; }) === undefined; });
	            var maxParamNumber = Math.max.apply(Math, paramsForCurrentSubCriterion.map(function (p) { return p.paramNumber; }));
	            if (isFinite(maxParamNumber)) {
	                var currentParamNumber_1 = 1;
	                var _loop_1 = function (i) {
	                    var lineParams = paramsForCurrentSubCriterion.filter(function (p) { return p.paramNumber === i; });
	                    // if line of params is empty, continue
	                    if (lineParams.length === 0) {
	                        return "continue";
	                    }
	                    lineParams.forEach(function (p) {
	                        p.paramNumber = currentParamNumber_1;
	                    });
	                    currentParamNumber_1++;
	                    newParamsValues.push.apply(newParamsValues, lineParams);
	                };
	                for (var i = 1; i <= maxParamNumber; i++) {
	                    _loop_1(i);
	                }
	            }
	            newParamsValues.push.apply(newParamsValues, paramsForAnotherSubCriteria);
	            _this.paramsValues.replace(newParamsValues);
	        };
	        this.getNextParamNumber = function (subCriterion) {
	            var numbersOfParams = _this.paramsValues
	                .filter(function (p) { return subCriterion.parameters.find(function (p1) { return p1.paramId === p.parameter.paramId; }); })
	                .map(function (p) { return p.paramNumber; });
	            var paramNumber = 1;
	            if (numbersOfParams.length > 0) {
	                paramNumber = (Math.max.apply(Math, numbersOfParams) + 1);
	            }
	            return paramNumber;
	        };
	        this.loadResults = function () {
	            var projectVersion = projectVersionService_1.default.projectVersion.versionId;
	            console.warn("Loading project version results");
	            uiService_1.default.showToolbarActionFlag();
	            projectVersionService_1.default.getProjectVersionResults(projectVersion).then(function (results) {
	                projectVersionService_1.default.criterionResults = results;
	                uiService_1.default.hideToolbarActionFlag();
	            });
	        };
	        this.loadCriterionVersions = function () {
	            var projectVersion = projectVersionService_1.default.projectVersion.versionId;
	            console.warn("Loading criteria versions");
	            uiService_1.default.showToolbarActionFlag();
	            projectVersionService_1.default.readProjectCriteriaVersions(projectVersion).then(function (versions) {
	                projectVersionService_1.default.criterionVersions.replace(versions);
	                uiService_1.default.hideToolbarActionFlag();
	            });
	        };
	        this.loadParams = function () {
	            var criterion = _this.selectedCriterion;
	            var selectedCriterionVersion = _this.selectedCriterionVersion;
	            uiService_1.default.showToolbarActionFlag();
	            console.warn("Loading params for criterion version " + selectedCriterionVersion.name);
	            _this.parametersLoaded = false;
	            projectVersionService_1.default.readProjectVersionValues(projectVersionService_1.default.projectVersion.versionId, criterion.criterionId, selectedCriterionVersion.versionId).then(function (params) {
	                _this.paramsValues.replace(params);
	                uiService_1.default.hideToolbarActionFlag();
	                _this.parametersLoaded = true;
	            });
	        };
	        this.selectCriterionVersion = function (id) {
	            var criterion = _this.selectedCriterion;
	            if (criterion) {
	                if (id) {
	                    _this.selectedCriterionVersion = projectVersionService_1.default.criterionVersions.find(function (cv) { return cv.versionId === id; });
	                }
	                else {
	                    _this.selectedCriterionVersion = projectVersionService_1.default.criterionVersions
	                        .find(function (cv) { return cv.criterion.criterionId === criterion.criterionId && cv.isDefault === true; });
	                }
	                console.warn("Selected criterion version : " + _this.selectedCriterionVersion.versionId);
	                _this.criterionVersionName = _this.selectedCriterionVersion.name;
	                _this.loadParams();
	            }
	        };
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ParamsService.prototype, "selectedCriterion", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ParamsService.prototype, "selectedSubCriterion", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ParamsService.prototype, "selectedCriterionVersion", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ParamsService.prototype, "criterionVersionName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ParamsService.prototype, "parametersLoaded", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ParamsService.prototype, "loadResults", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ParamsService.prototype, "loadCriterionVersions", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ParamsService.prototype, "loadParams", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ParamsService.prototype, "selectCriterionVersion", void 0);
	    return ParamsService;
	}());
	exports.default = new ParamsService();


/***/ }),
/* 160 */
[2332, 225],
/* 161 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule generateRandomKey
	 * @format
	 * 
	 */
	
	'use strict';
	
	var seenKeys = {};
	var MULTIPLIER = Math.pow(2, 24);
	
	function generateRandomKey() {
	  var key = void 0;
	  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
	    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
	  }
	  seenKeys[key] = true;
	  return key;
	}
	
	module.exports = generateRandomKey;

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(151),
	    isArray = __webpack_require__(62),
	    isObjectLike = __webpack_require__(116);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FontIcon = __webpack_require__(1522);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FontIcon2.default;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _classCallCheck = _interopDefault(__webpack_require__(1574));
	var _createClass = _interopDefault(__webpack_require__(1575));
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(1580));
	var _inherits = _interopDefault(__webpack_require__(1577));
	var _typeof = _interopDefault(__webpack_require__(772));
	var _objectWithoutProperties = _interopDefault(__webpack_require__(1579));
	var _objectSpread = _interopDefault(__webpack_require__(1578));
	var React = _interopDefault(__webpack_require__(1));
	var PropTypes = _interopDefault(__webpack_require__(2));
	var shallowEqual = _interopDefault(__webpack_require__(276));
	var warning = _interopDefault(__webpack_require__(70));
	
	function defineProperty(object, property, attr) {
	  return Object.defineProperty(object, property, attr);
	} // Passive options
	// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
	
	
	var passiveOption = function () {
	  var cache = null;
	  return function () {
	    if (cache !== null) {
	      return cache;
	    }
	
	    var supportsPassiveOption = false;
	
	    try {
	      window.addEventListener('test', null, defineProperty({}, 'passive', {
	        get: function get() {
	          supportsPassiveOption = true;
	        }
	      }));
	    } catch (err) {//
	    }
	
	    cache = supportsPassiveOption;
	    return supportsPassiveOption;
	  }();
	}();
	
	var defaultEventOptions = {
	  capture: false,
	  passive: false
	};
	
	function mergeDefaultEventOptions(options) {
	  return _objectSpread({}, defaultEventOptions, options);
	}
	
	function getEventListenerArgs(eventName, callback, options) {
	  var args = [eventName, callback];
	  args.push(passiveOption ? options : options.capture);
	  return args;
	}
	
	function on(target, eventName, callback, options) {
	  // eslint-disable-next-line prefer-spread
	  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	}
	
	function off(target, eventName, callback, options) {
	  // eslint-disable-next-line prefer-spread
	  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	}
	
	function forEachListener(props, iteratee) {
	  var children = props.children,
	      target = props.target,
	      eventProps = _objectWithoutProperties(props, ["children", "target"]);
	
	  Object.keys(eventProps).forEach(function (name) {
	    if (name.substring(0, 2) !== 'on') {
	      return;
	    }
	
	    var prop = eventProps[name];
	
	    var type = _typeof(prop);
	
	    var isObject = type === 'object';
	    var isFunction = type === 'function';
	
	    if (!isObject && !isFunction) {
	      return;
	    }
	
	    var capture = name.substr(-7).toLowerCase() === 'capture';
	    var eventName = name.substring(2).toLowerCase();
	    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;
	
	    if (isObject) {
	      iteratee(eventName, prop.handler, prop.options);
	    } else {
	      iteratee(eventName, prop, mergeDefaultEventOptions({
	        capture: capture
	      }));
	    }
	  });
	}
	
	function withOptions(handler, options) {
	   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
	  return {
	    handler: handler,
	    options: mergeDefaultEventOptions(options)
	  };
	}
	
	var EventListener =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(EventListener, _React$Component);
	
	  function EventListener() {
	    _classCallCheck(this, EventListener);
	
	    return _possibleConstructorReturn(this, (EventListener.__proto__ || Object.getPrototypeOf(EventListener)).apply(this, arguments));
	  }
	
	  _createClass(EventListener, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.addListeners();
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return !shallowEqual(this.props, nextProps);
	    }
	  }, {
	    key: "componentWillUpdate",
	    value: function componentWillUpdate() {
	      this.removeListeners();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.addListeners();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: "addListeners",
	    value: function addListeners() {
	      this.applyListeners(on);
	    }
	  }, {
	    key: "removeListeners",
	    value: function removeListeners() {
	      this.applyListeners(off);
	    }
	  }, {
	    key: "applyListeners",
	    value: function applyListeners(onOrOff) {
	      var target = this.props.target;
	
	      if (target) {
	        var element = target;
	
	        if (typeof target === 'string') {
	          element = window[target];
	        }
	
	        forEachListener(this.props, onOrOff.bind(null, element));
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	
	  return EventListener;
	}(React.Component);
	
	EventListener.propTypes =  false ? {
	  /**
	   * You can provide a single child too.
	   */
	  children: PropTypes.node,
	
	  /**
	   * The DOM target to listen to.
	   */
	  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
	} : {};
	
	exports.withOptions = withOptions;
	exports.default = EventListener;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var PooledClass = __webpack_require__(214);
	
	var emptyFunction = __webpack_require__(113);
	var warning = __webpack_require__(61);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var assign = __webpack_require__(251);
	var ReactPropTypes = __webpack_require__(1).PropTypes;
	var Route = __webpack_require__(215);
	
	var PropTypes = assign({}, ReactPropTypes, {
	
	  /**
	   * Indicates that a prop should be falsy.
	   */
	  falsy: function falsy(props, propName, componentName) {
	    if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	  },
	
	  /**
	   * Indicates that a prop should be a Route object.
	   */
	  route: ReactPropTypes.instanceOf(Route),
	
	  /**
	   * Indicates that a prop should be a Router object.
	   */
	  //router: ReactPropTypes.instanceOf(Router) // TODO
	  router: ReactPropTypes.func
	
	});
	
	module.exports = PropTypes;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _version = _react2.default.version.split('.').map(parseFloat);
	
	module.exports = {
	  version: function version() {
	    return _version;
	  },
	  findDOMNode: function findDOMNode(component) {
	    return _reactDom2.default.findDOMNode(component);
	  },
	  batchedUpdates: function batchedUpdates(cb) {
	    _reactDom2.default.unstable_batchedUpdates(cb);
	  }
	};

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _every2 = _interopRequireDefault(__webpack_require__(721));
	
	var _find2 = _interopRequireDefault(__webpack_require__(1469));
	
	var _sortBy2 = _interopRequireDefault(__webpack_require__(486));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _range2 = _interopRequireDefault(__webpack_require__(731));
	
	var _throttle2 = _interopRequireDefault(__webpack_require__(734));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(115));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _Surface = _interopRequireDefault(__webpack_require__(308));
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(387));
	
	var _Legend = _interopRequireDefault(__webpack_require__(547));
	
	var _Curve = _interopRequireDefault(__webpack_require__(257));
	
	var _Cross = _interopRequireDefault(__webpack_require__(900));
	
	var _Sector = _interopRequireDefault(__webpack_require__(391));
	
	var _Dot = _interopRequireDefault(__webpack_require__(218));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(258));
	
	var _ReactUtils = __webpack_require__(43);
	
	var _CartesianAxis = _interopRequireDefault(__webpack_require__(892));
	
	var _Brush = _interopRequireDefault(__webpack_require__(891));
	
	var _DOMUtils = __webpack_require__(392);
	
	var _DataUtils = __webpack_require__(66);
	
	var _ChartUtils = __webpack_require__(103);
	
	var _DetectReferenceElementsDomain = __webpack_require__(1959);
	
	var _PolarUtils = __webpack_require__(142);
	
	var _ShallowEqual = __webpack_require__(394);
	
	var _Events = __webpack_require__(1960);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ORIENT_MAP = {
	  xAxis: ['bottom', 'top'],
	  yAxis: ['left', 'right']
	};
	var originCoordinate = {
	  x: 0,
	  y: 0
	};
	
	var generateCategoricalChart = function generateCategoricalChart(_ref) {
	  var chartName = _ref.chartName,
	      GraphicalChild = _ref.GraphicalChild,
	      _ref$eventType = _ref.eventType,
	      eventType = _ref$eventType === void 0 ? 'axis' : _ref$eventType,
	      axisComponents = _ref.axisComponents,
	      legendContent = _ref.legendContent,
	      formatAxisMap = _ref.formatAxisMap,
	      defaultProps = _ref.defaultProps,
	      propTypes = _ref.propTypes;
	
	  var CategoricalChartWrapper =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(CategoricalChartWrapper, _Component);
	
	    /**
	     * Returns default, reset state for the categorical chart.
	     * @param {Object} props Props object to use when creating the default state
	     * @return {Object} Whole new state
	     */
	    function CategoricalChartWrapper(_props) {
	      var _this;
	
	      _classCallCheck(this, CategoricalChartWrapper);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(CategoricalChartWrapper).call(this, _props));
	
	      _this.handleLegendBBoxUpdate = function (box) {
	        if (box && _this.legendInstance) {
	          var _this$state = _this.state,
	              dataStartIndex = _this$state.dataStartIndex,
	              dataEndIndex = _this$state.dataEndIndex,
	              updateId = _this$state.updateId;
	
	          _this.setState(_this.updateStateOfAxisMapsOffsetAndStackGroups({
	            props: _this.props,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex,
	            updateId: updateId
	          }));
	        }
	      };
	
	      _this.handleReceiveSyncEvent = function (cId, chartId, data) {
	        var _this$props = _this.props,
	            syncId = _this$props.syncId,
	            layout = _this$props.layout;
	        var updateId = _this.state.updateId;
	
	        if (syncId === cId && chartId !== _this.uniqueChartId) {
	          var dataStartIndex = data.dataStartIndex,
	              dataEndIndex = data.dataEndIndex;
	
	          if (!(0, _isNil2["default"])(data.dataStartIndex) || !(0, _isNil2["default"])(data.dataEndIndex)) {
	            _this.setState(_objectSpread({
	              dataStartIndex: dataStartIndex,
	              dataEndIndex: dataEndIndex
	            }, _this.updateStateOfAxisMapsOffsetAndStackGroups({
	              props: _this.props,
	              dataStartIndex: dataStartIndex,
	              dataEndIndex: dataEndIndex,
	              updateId: updateId
	            })));
	          } else if (!(0, _isNil2["default"])(data.activeTooltipIndex)) {
	            var chartX = data.chartX,
	                chartY = data.chartY,
	                activeTooltipIndex = data.activeTooltipIndex;
	            var _this$state2 = _this.state,
	                offset = _this$state2.offset,
	                tooltipTicks = _this$state2.tooltipTicks;
	
	            if (!offset) {
	              return;
	            }
	
	            var viewBox = _objectSpread({}, offset, {
	              x: offset.left,
	              y: offset.top
	            }); // When a categotical chart is combined with another chart, the value of chartX
	            // and chartY may beyond the boundaries.
	
	
	            var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
	            var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
	            var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
	
	            var activePayload = _this.getTooltipContent(activeTooltipIndex);
	
	            var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
	              x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
	              y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
	            } : originCoordinate;
	
	            _this.setState(_objectSpread({}, data, {
	              activeLabel: activeLabel,
	              activeCoordinate: activeCoordinate,
	              activePayload: activePayload
	            }));
	          } else {
	            _this.setState(data);
	          }
	        }
	      };
	
	      _this.handleBrushChange = function (_ref2) {
	        var startIndex = _ref2.startIndex,
	            endIndex = _ref2.endIndex;
	
	        // Only trigger changes if the extents of the brush have actually changed
	        if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
	          var updateId = _this.state.updateId;
	
	          _this.setState(function () {
	            return _objectSpread({
	              dataStartIndex: startIndex,
	              dataEndIndex: endIndex
	            }, _this.updateStateOfAxisMapsOffsetAndStackGroups({
	              props: _this.props,
	              dataStartIndex: startIndex,
	              dataEndIndex: endIndex,
	              updateId: updateId
	            }));
	          });
	
	          _this.triggerSyncEvent({
	            dataStartIndex: startIndex,
	            dataEndIndex: endIndex
	          });
	        }
	      };
	
	      _this.handleMouseEnter = function (e) {
	        var onMouseEnter = _this.props.onMouseEnter;
	
	        var mouse = _this.getMouseInfo(e);
	
	        if (mouse) {
	          var nextState = _objectSpread({}, mouse, {
	            isTooltipActive: true
	          });
	
	          _this.setState(nextState);
	
	          _this.triggerSyncEvent(nextState);
	
	          if ((0, _isFunction2["default"])(onMouseEnter)) {
	            onMouseEnter(nextState, e);
	          }
	        }
	      };
	
	      _this.triggeredAfterMouseMove = function (e) {
	        var onMouseMove = _this.props.onMouseMove;
	
	        var mouse = _this.getMouseInfo(e);
	
	        var nextState = mouse ? _objectSpread({}, mouse, {
	          isTooltipActive: true
	        }) : {
	          isTooltipActive: false
	        };
	
	        _this.setState(nextState);
	
	        _this.triggerSyncEvent(nextState);
	
	        if ((0, _isFunction2["default"])(onMouseMove)) {
	          onMouseMove(nextState, e);
	        }
	      };
	
	      _this.handleItemMouseEnter = function (el) {
	        _this.setState(function () {
	          return {
	            isTooltipActive: true,
	            activeItem: el,
	            activePayload: el.tooltipPayload,
	            activeCoordinate: el.tooltipPosition || {
	              x: el.cx,
	              y: el.cy
	            }
	          };
	        });
	      };
	
	      _this.handleItemMouseLeave = function () {
	        _this.setState(function () {
	          return {
	            isTooltipActive: false
	          };
	        });
	      };
	
	      _this.handleMouseMove = function (e) {
	        if (e && (0, _isFunction2["default"])(e.persist)) {
	          e.persist();
	        }
	
	        _this.triggeredAfterMouseMove(e);
	      };
	
	      _this.handleMouseLeave = function (e) {
	        var onMouseLeave = _this.props.onMouseLeave;
	        var nextState = {
	          isTooltipActive: false
	        };
	
	        _this.setState(nextState);
	
	        _this.triggerSyncEvent(nextState);
	
	        if ((0, _isFunction2["default"])(onMouseLeave)) {
	          onMouseLeave(nextState, e);
	        }
	      };
	
	      _this.handleOuterEvent = function (e) {
	        var eventName = (0, _ReactUtils.getReactEventByType)(e);
	
	        if (eventName && (0, _isFunction2["default"])(_this.props[eventName])) {
	          var mouse = _this.getMouseInfo(e);
	
	          var handler = _this.props[eventName];
	          handler(mouse, e);
	        }
	      };
	
	      _this.handleClick = function (e) {
	        var onClick = _this.props.onClick;
	
	        if ((0, _isFunction2["default"])(onClick)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onClick(mouse, e);
	        }
	      };
	
	      _this.handleMouseDown = function (e) {
	        var onMouseDown = _this.props.onMouseDown;
	
	        if ((0, _isFunction2["default"])(onMouseDown)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onMouseDown(mouse, e);
	        }
	      };
	
	      _this.handleMouseUp = function (e) {
	        var onMouseUp = _this.props.onMouseUp;
	
	        if ((0, _isFunction2["default"])(onMouseUp)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onMouseUp(mouse, e);
	        }
	      };
	
	      _this.handleTouchMove = function (e) {
	        if (e.changedTouches != null && e.changedTouches.length > 0) {
	          _this.handleMouseMove(e.changedTouches[0]);
	        }
	      };
	
	      _this.handleTouchStart = function (e) {
	        if (e.changedTouches != null && e.changedTouches.length > 0) {
	          _this.handleMouseDown(e.changedTouches[0]);
	        }
	      };
	
	      _this.handleTouchEnd = function (e) {
	        if (e.changedTouches != null && e.changedTouches.length > 0) {
	          _this.handleMouseUp(e.changedTouches[0]);
	        }
	      };
	
	      _this.verticalCoordinatesGenerator = function (_ref3) {
	        var xAxis = _ref3.xAxis,
	            width = _ref3.width,
	            height = _ref3.height,
	            offset = _ref3.offset;
	        return (0, _ChartUtils.getCoordinatesOfGrid)(_CartesianAxis["default"].getTicks(_objectSpread({}, _CartesianAxis["default"].defaultProps, {}, xAxis, {
	          ticks: (0, _ChartUtils.getTicksOfAxis)(xAxis, true),
	          viewBox: {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          }
	        })), offset.left, offset.left + offset.width);
	      };
	
	      _this.horizontalCoordinatesGenerator = function (_ref4) {
	        var yAxis = _ref4.yAxis,
	            width = _ref4.width,
	            height = _ref4.height,
	            offset = _ref4.offset;
	        return (0, _ChartUtils.getCoordinatesOfGrid)(_CartesianAxis["default"].getTicks(_objectSpread({}, _CartesianAxis["default"].defaultProps, {}, yAxis, {
	          ticks: (0, _ChartUtils.getTicksOfAxis)(yAxis, true),
	          viewBox: {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          }
	        })), offset.top, offset.top + offset.height);
	      };
	
	      _this.axesTicksGenerator = function (axis) {
	        return (0, _ChartUtils.getTicksOfAxis)(axis, true);
	      };
	
	      _this.tooltipTicksGenerator = function (axisMap) {
	        var axis = (0, _DataUtils.getAnyElementOfObject)(axisMap);
	        var tooltipTicks = (0, _ChartUtils.getTicksOfAxis)(axis, false, true);
	        return {
	          tooltipTicks: tooltipTicks,
	          orderedTooltipTicks: (0, _sortBy2["default"])(tooltipTicks, function (o) {
	            return o.coordinate;
	          }),
	          tooltipAxis: axis,
	          tooltipAxisBandSize: (0, _ChartUtils.getBandSizeOfAxis)(axis)
	        };
	      };
	
	      _this.renderCursor = function (element) {
	        var _this$state3 = _this.state,
	            isTooltipActive = _this$state3.isTooltipActive,
	            activeCoordinate = _this$state3.activeCoordinate,
	            activePayload = _this$state3.activePayload,
	            offset = _this$state3.offset;
	
	        if (!element || !element.props.cursor || !isTooltipActive || !activeCoordinate) {
	          return null;
	        }
	
	        var layout = _this.props.layout;
	        var restProps;
	        var cursorComp = _Curve["default"];
	
	        if (chartName === 'ScatterChart') {
	          restProps = activeCoordinate;
	          cursorComp = _Cross["default"];
	        } else if (chartName === 'BarChart') {
	          restProps = _this.getCursorRectangle();
	          cursorComp = _Rectangle["default"];
	        } else if (layout === 'radial') {
	          var _this$getCursorPoints = _this.getCursorPoints(),
	              cx = _this$getCursorPoints.cx,
	              cy = _this$getCursorPoints.cy,
	              radius = _this$getCursorPoints.radius,
	              startAngle = _this$getCursorPoints.startAngle,
	              endAngle = _this$getCursorPoints.endAngle;
	
	          restProps = {
	            cx: cx,
	            cy: cy,
	            startAngle: startAngle,
	            endAngle: endAngle,
	            innerRadius: radius,
	            outerRadius: radius
	          };
	          cursorComp = _Sector["default"];
	        } else {
	          restProps = {
	            points: _this.getCursorPoints()
	          };
	          cursorComp = _Curve["default"];
	        }
	
	        var key = element.key || '_recharts-cursor';
	
	        var cursorProps = _objectSpread({
	          stroke: '#ccc',
	          pointerEvents: 'none'
	        }, offset, {}, restProps, {}, (0, _ReactUtils.getPresentationAttributes)(element.props.cursor), {
	          payload: activePayload,
	          key: key,
	          className: 'recharts-tooltip-cursor'
	        });
	
	        return (0, _react.isValidElement)(element.props.cursor) ? (0, _react.cloneElement)(element.props.cursor, cursorProps) : (0, _react.createElement)(cursorComp, cursorProps);
	      };
	
	      _this.renderPolarAxis = function (element, displayName, index) {
	        var axisType = element.type.axisType;
	
	        var axisMap = _this.state["".concat(axisType, "Map")];
	
	        var axisOption = axisMap[element.props["".concat(axisType, "Id")]];
	        return (0, _react.cloneElement)(element, _objectSpread({}, axisOption, {
	          className: axisType,
	          key: element.key || "".concat(displayName, "-").concat(index),
	          ticks: (0, _ChartUtils.getTicksOfAxis)(axisOption, true)
	        }));
	      };
	
	      _this.renderXAxis = function (element, displayName, index) {
	        var xAxisMap = _this.state.xAxisMap;
	        var axisObj = xAxisMap[element.props.xAxisId];
	        return _this.renderAxis(axisObj, element, displayName, index);
	      };
	
	      _this.renderYAxis = function (element, displayName, index) {
	        var yAxisMap = _this.state.yAxisMap;
	        var axisObj = yAxisMap[element.props.yAxisId];
	        return _this.renderAxis(axisObj, element, displayName, index);
	      };
	
	      _this.renderGrid = function (element) {
	        var _this$state4 = _this.state,
	            xAxisMap = _this$state4.xAxisMap,
	            yAxisMap = _this$state4.yAxisMap,
	            offset = _this$state4.offset;
	        var _this$props2 = _this.props,
	            width = _this$props2.width,
	            height = _this$props2.height;
	        var xAxis = (0, _DataUtils.getAnyElementOfObject)(xAxisMap);
	        var yAxisWithFiniteDomain = (0, _find2["default"])(yAxisMap, function (axis) {
	          return (0, _every2["default"])(axis.domain, Number.isFinite);
	        });
	        var yAxis = yAxisWithFiniteDomain || (0, _DataUtils.getAnyElementOfObject)(yAxisMap);
	        var props = element.props || {};
	        return (0, _react.cloneElement)(element, {
	          key: element.key || 'grid',
	          x: (0, _DataUtils.isNumber)(props.x) ? props.x : offset.left,
	          y: (0, _DataUtils.isNumber)(props.y) ? props.y : offset.top,
	          width: (0, _DataUtils.isNumber)(props.width) ? props.width : offset.width,
	          height: (0, _DataUtils.isNumber)(props.height) ? props.height : offset.height,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          offset: offset,
	          chartWidth: width,
	          chartHeight: height,
	          verticalCoordinatesGenerator: props.verticalCoordinatesGenerator || _this.verticalCoordinatesGenerator,
	          horizontalCoordinatesGenerator: props.horizontalCoordinatesGenerator || _this.horizontalCoordinatesGenerator
	        });
	      };
	
	      _this.renderPolarGrid = function (element) {
	        var _this$state5 = _this.state,
	            radiusAxisMap = _this$state5.radiusAxisMap,
	            angleAxisMap = _this$state5.angleAxisMap;
	        var radiusAxis = (0, _DataUtils.getAnyElementOfObject)(radiusAxisMap);
	        var angleAxis = (0, _DataUtils.getAnyElementOfObject)(angleAxisMap);
	        var cx = angleAxis.cx,
	            cy = angleAxis.cy,
	            innerRadius = angleAxis.innerRadius,
	            outerRadius = angleAxis.outerRadius;
	        return (0, _react.cloneElement)(element, {
	          polarAngles: (0, _ChartUtils.getTicksOfAxis)(angleAxis, true).map(function (entry) {
	            return entry.coordinate;
	          }),
	          polarRadius: (0, _ChartUtils.getTicksOfAxis)(radiusAxis, true).map(function (entry) {
	            return entry.coordinate;
	          }),
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          key: element.key || 'polar-grid'
	        });
	      };
	
	      _this.renderBrush = function (element) {
	        var _this$props3 = _this.props,
	            margin = _this$props3.margin,
	            data = _this$props3.data;
	        var _this$state6 = _this.state,
	            offset = _this$state6.offset,
	            dataStartIndex = _this$state6.dataStartIndex,
	            dataEndIndex = _this$state6.dataEndIndex,
	            updateId = _this$state6.updateId; // TODO: update brush when children update
	
	        return (0, _react.cloneElement)(element, {
	          key: element.key || '_recharts-brush',
	          onChange: (0, _ChartUtils.combineEventHandlers)(_this.handleBrushChange, null, element.props.onChange),
	          data: data,
	          x: (0, _DataUtils.isNumber)(element.props.x) ? element.props.x : offset.left,
	          y: (0, _DataUtils.isNumber)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
	          width: (0, _DataUtils.isNumber)(element.props.width) ? element.props.width : offset.width,
	          startIndex: dataStartIndex,
	          endIndex: dataEndIndex,
	          updateId: "brush-".concat(updateId)
	        });
	      };
	
	      _this.renderReferenceElement = function (element, displayName, index) {
	        if (!element) {
	          return null;
	        }
	
	        var _assertThisInitialize = _assertThisInitialized(_this),
	            clipPathId = _assertThisInitialize.clipPathId;
	
	        var _this$state7 = _this.state,
	            xAxisMap = _this$state7.xAxisMap,
	            yAxisMap = _this$state7.yAxisMap,
	            offset = _this$state7.offset;
	        var _element$props = element.props,
	            xAxisId = _element$props.xAxisId,
	            yAxisId = _element$props.yAxisId;
	        return (0, _react.cloneElement)(element, {
	          key: element.key || "".concat(displayName, "-").concat(index),
	          xAxis: xAxisMap[xAxisId],
	          yAxis: yAxisMap[yAxisId],
	          viewBox: {
	            x: offset.left,
	            y: offset.top,
	            width: offset.width,
	            height: offset.height
	          },
	          clipPathId: clipPathId
	        });
	      };
	
	      _this.renderGraphicChild = function (element, displayName, index) {
	        var item = _this.filterFormatItem(element, displayName, index);
	
	        if (!item) {
	          return null;
	        }
	
	        var graphicalItem = (0, _react.cloneElement)(element, item.props);
	        var _this$state8 = _this.state,
	            isTooltipActive = _this$state8.isTooltipActive,
	            tooltipAxis = _this$state8.tooltipAxis,
	            activeTooltipIndex = _this$state8.activeTooltipIndex,
	            activeLabel = _this$state8.activeLabel;
	        var children = _this.props.children;
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	        var _item$props = item.props,
	            points = _item$props.points,
	            isRange = _item$props.isRange,
	            baseLine = _item$props.baseLine;
	        var _item$item$props = item.item.props,
	            activeDot = _item$item$props.activeDot,
	            hide = _item$item$props.hide;
	        var hasActive = !hide && isTooltipActive && tooltipItem && activeDot && activeTooltipIndex >= 0;
	
	        function findWithPayload(entry) {
	          return tooltipAxis.dataKey(entry.payload);
	        }
	
	        if (hasActive) {
	          var activePoint, basePoint;
	
	          if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
	            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey);
	            activePoint = (0, _DataUtils.findEntryInArray)(points, specifiedKey, activeLabel);
	            basePoint = isRange && baseLine && (0, _DataUtils.findEntryInArray)(baseLine, specifiedKey, activeLabel);
	          } else {
	            activePoint = points[activeTooltipIndex];
	            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
	          }
	
	          if (!(0, _isNil2["default"])(activePoint)) {
	            return [graphicalItem].concat(_toConsumableArray(_this.renderActivePoints({
	              item: item,
	              activePoint: activePoint,
	              basePoint: basePoint,
	              childIndex: activeTooltipIndex,
	              isRange: isRange
	            })));
	          }
	        }
	
	        if (isRange) {
	          return [graphicalItem, null, null];
	        }
	
	        return [graphicalItem, null];
	      };
	
	      _this.renderCustomized = function (element) {
	        return (0, _react.cloneElement)(element, _objectSpread({}, _this.props, {}, _this.state));
	      };
	
	      var defaultState = _this.constructor.createDefaultState(_props);
	
	      var _updateId = 0;
	      _this.state = _objectSpread({}, defaultState, {
	        updateId: 0
	      }, _this.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
	        props: _props
	      }, defaultState, {
	        updateId: _updateId
	      })));
	      _this.uniqueChartId = (0, _isNil2["default"])(_props.id) ? (0, _DataUtils.uniqueId)('recharts') : _props.id;
	      _this.clipPathId = "".concat(_this.uniqueChartId, "-clip");
	
	      if (_props.throttleDelay) {
	        _this.triggeredAfterMouseMove = (0, _throttle2["default"])(_this.triggeredAfterMouseMove, _props.throttleDelay);
	      }
	
	      return _this;
	    }
	    /* eslint-disable  react/no-did-mount-set-state */
	
	
	    _createClass(CategoricalChartWrapper, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        if (!(0, _isNil2["default"])(this.props.syncId)) {
	          this.addListener();
	        }
	      } // eslint-disable-next-line camelcase
	
	    }, {
	      key: "componentWillReceiveProps",
	      value: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        var _this$props4 = this.props,
	            data = _this$props4.data,
	            children = _this$props4.children,
	            width = _this$props4.width,
	            height = _this$props4.height,
	            layout = _this$props4.layout,
	            stackOffset = _this$props4.stackOffset,
	            margin = _this$props4.margin;
	        var updateId = this.state.updateId;
	
	        if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || nextProps.layout !== layout || nextProps.stackOffset !== stackOffset || !(0, _ShallowEqual.shallowEqual)(nextProps.margin, margin)) {
	          var defaultState = this.constructor.createDefaultState(nextProps);
	          this.setState(_objectSpread({}, defaultState, {
	            updateId: updateId + 1
	          }, this.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
	            props: nextProps
	          }, defaultState, {
	            updateId: updateId + 1
	          }))));
	        } else if (!(0, _ReactUtils.isChildrenEqual)(nextProps.children, children)) {
	          // update configuration in chilren
	          var hasGlobalData = !(0, _isNil2["default"])(nextProps.data);
	          var newUpdateId = hasGlobalData ? updateId : updateId + 1;
	          this.setState(function (prevState) {
	            return _objectSpread({
	              updateId: newUpdateId
	            }, _this2.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
	              props: nextProps
	            }, prevState, {
	              updateId: newUpdateId
	            })));
	          });
	        } // add syncId
	
	
	        if ((0, _isNil2["default"])(this.props.syncId) && !(0, _isNil2["default"])(nextProps.syncId)) {
	          this.addListener();
	        } // remove syncId
	
	
	        if (!(0, _isNil2["default"])(this.props.syncId) && (0, _isNil2["default"])(nextProps.syncId)) {
	          this.removeListener();
	        }
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        if (!(0, _isNil2["default"])(this.props.syncId)) {
	          this.removeListener();
	        }
	
	        if (typeof this.triggeredAfterMouseMove.cancel === 'function') {
	          this.triggeredAfterMouseMove.cancel();
	        }
	      }
	      /**
	      * Get the configuration of all x-axis or y-axis
	      * @param  {Object} props          Latest props
	      * @param  {String} axisType       The type of axis
	      * @param  {Array}  graphicalItems The instances of item
	      * @param  {Object} stackGroups    The items grouped by axisId and stackId
	      * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
	      * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
	      * @return {Object}          Configuration
	      */
	
	    }, {
	      key: "getAxisMap",
	      value: function getAxisMap(props, _ref5) {
	        var _ref5$axisType = _ref5.axisType,
	            axisType = _ref5$axisType === void 0 ? 'xAxis' : _ref5$axisType,
	            AxisComp = _ref5.AxisComp,
	            graphicalItems = _ref5.graphicalItems,
	            stackGroups = _ref5.stackGroups,
	            dataStartIndex = _ref5.dataStartIndex,
	            dataEndIndex = _ref5.dataEndIndex;
	        var children = props.children;
	        var axisIdKey = "".concat(axisType, "Id"); // Get all the instance of Axis
	
	        var axes = (0, _ReactUtils.findAllByType)(children, AxisComp);
	        var axisMap = {};
	
	        if (axes && axes.length) {
	          axisMap = this.getAxisMapByAxes(props, {
	            axes: axes,
	            graphicalItems: graphicalItems,
	            axisType: axisType,
	            axisIdKey: axisIdKey,
	            stackGroups: stackGroups,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          });
	        } else if (graphicalItems && graphicalItems.length) {
	          axisMap = this.getAxisMapByItems(props, {
	            Axis: AxisComp,
	            graphicalItems: graphicalItems,
	            axisType: axisType,
	            axisIdKey: axisIdKey,
	            stackGroups: stackGroups,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          });
	        }
	
	        return axisMap;
	      }
	      /**
	       * Get the configuration of axis by the options of axis instance
	       * @param  {Object} props         Latest props
	       * @param {Array}  axes           The instance of axes
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}      Configuration
	       */
	
	    }, {
	      key: "getAxisMapByAxes",
	      value: function getAxisMapByAxes(props, _ref6) {
	        var _this3 = this;
	
	        var axes = _ref6.axes,
	            graphicalItems = _ref6.graphicalItems,
	            axisType = _ref6.axisType,
	            axisIdKey = _ref6.axisIdKey,
	            stackGroups = _ref6.stackGroups,
	            dataStartIndex = _ref6.dataStartIndex,
	            dataEndIndex = _ref6.dataEndIndex;
	        var layout = props.layout,
	            children = props.children,
	            stackOffset = props.stackOffset;
	        var isCategorial = (0, _ChartUtils.isCategorialAxis)(layout, axisType); // Eliminate duplicated axes
	
	        var axisMap = axes.reduce(function (result, child) {
	          var _child$props = child.props,
	              type = _child$props.type,
	              dataKey = _child$props.dataKey,
	              allowDataOverflow = _child$props.allowDataOverflow,
	              allowDuplicatedCategory = _child$props.allowDuplicatedCategory,
	              scale = _child$props.scale,
	              ticks = _child$props.ticks;
	          var axisId = child.props[axisIdKey];
	
	          var displayedData = _this3.constructor.getDisplayedData(props, {
	            graphicalItems: graphicalItems.filter(function (item) {
	              return item.props[axisIdKey] === axisId;
	            }),
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          });
	
	          var len = displayedData.length;
	
	          if (!result[axisId]) {
	            var domain, duplicateDomain, categoricalDomain;
	
	            if (dataKey) {
	              domain = (0, _ChartUtils.getDomainOfDataByKey)(displayedData, dataKey, type);
	
	              if (type === 'category' && isCategorial) {
	                var duplicate = (0, _DataUtils.hasDuplicate)(domain);
	
	                if (allowDuplicatedCategory && duplicate) {
	                  duplicateDomain = domain; // When category axis has duplicated text, serial numbers are used to generate scale
	
	                  domain = (0, _range2["default"])(0, len);
	                } else if (!allowDuplicatedCategory) {
	                  // remove duplicated category
	                  domain = (0, _ChartUtils.parseDomainOfCategoryAxis)(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
	                    return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
	                  }, []);
	                }
	              } else if (type === 'category') {
	                if (!allowDuplicatedCategory) {
	                  domain = (0, _ChartUtils.parseDomainOfCategoryAxis)(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
	                    return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, _isNil2["default"])(entry) ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
	                  }, []);
	                } else {
	                  // eliminate undefined or null or empty string
	                  domain = domain.filter(function (entry) {
	                    return entry !== '' && !(0, _isNil2["default"])(entry);
	                  });
	                }
	              } else if (type === 'number') {
	                var errorBarsDomain = (0, _ChartUtils.parseErrorBarsOfAxis)(displayedData, graphicalItems.filter(function (item) {
	                  return item.props[axisIdKey] === axisId && !item.props.hide;
	                }), dataKey, axisType);
	
	                if (errorBarsDomain) {
	                  domain = errorBarsDomain;
	                }
	              }
	
	              if (isCategorial && (type === 'number' || scale !== 'auto')) {
	                categoricalDomain = (0, _ChartUtils.getDomainOfDataByKey)(displayedData, dataKey, 'category');
	              }
	            } else if (isCategorial) {
	              domain = (0, _range2["default"])(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') {
	              // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
	              domain = stackOffset === 'expand' ? [0, 1] : (0, _ChartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	            } else {
	              domain = (0, _ChartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (item) {
	                return item.props[axisIdKey] === axisId && !item.props.hide;
	              }), type, true);
	            }
	
	            if (type === 'number') {
	              // To detect wether there is any reference lines whose props alwaysShow is true
	              domain = (0, _DetectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType, ticks);
	
	              if (child.props.domain) {
	                domain = (0, _ChartUtils.parseSpecifiedDomain)(child.props.domain, domain, allowDataOverflow);
	              }
	            }
	
	            return _objectSpread({}, result, _defineProperty({}, axisId, _objectSpread({}, child.props, {
	              axisType: axisType,
	              domain: domain,
	              categoricalDomain: categoricalDomain,
	              duplicateDomain: duplicateDomain,
	              originalDomain: child.props.domain,
	              isCategorial: isCategorial,
	              layout: layout
	            })));
	          }
	
	          return result;
	        }, {});
	        return axisMap;
	      }
	      /**
	       * Get the configuration of axis by the options of item,
	       * this kind of axis does not display in chart
	       * @param  {Object} props         Latest props
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {ReactElement} Axis    Axis Component
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}               Configuration
	       */
	
	    }, {
	      key: "getAxisMapByItems",
	      value: function getAxisMapByItems(props, _ref7) {
	        var graphicalItems = _ref7.graphicalItems,
	            Axis = _ref7.Axis,
	            axisType = _ref7.axisType,
	            axisIdKey = _ref7.axisIdKey,
	            stackGroups = _ref7.stackGroups,
	            dataStartIndex = _ref7.dataStartIndex,
	            dataEndIndex = _ref7.dataEndIndex;
	        var layout = props.layout,
	            children = props.children;
	        var displayedData = this.constructor.getDisplayedData(props, {
	          graphicalItems: graphicalItems,
	          dataStartIndex: dataStartIndex,
	          dataEndIndex: dataEndIndex
	        });
	        var len = displayedData.length;
	        var isCategorial = (0, _ChartUtils.isCategorialAxis)(layout, axisType);
	        var index = -1; // The default type of x-axis is category axis,
	        // The default contents of x-axis is the serial numbers of data
	        // The default type of y-axis is number axis
	        // The default contents of y-axis is the domain of data
	
	        var axisMap = graphicalItems.reduce(function (result, child) {
	          var axisId = child.props[axisIdKey];
	
	          if (!result[axisId]) {
	            index++;
	            var domain;
	
	            if (isCategorial) {
	              domain = (0, _range2["default"])(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
	              domain = (0, _ChartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	              domain = (0, _DetectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            } else {
	              domain = (0, _ChartUtils.parseSpecifiedDomain)(Axis.defaultProps.domain, (0, _ChartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (item) {
	                return item.props[axisIdKey] === axisId && !item.props.hide;
	              }), 'number'), Axis.defaultProps.allowDataOverflow);
	              domain = (0, _DetectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            }
	
	            return _objectSpread({}, result, _defineProperty({}, axisId, _objectSpread({
	              axisType: axisType
	            }, Axis.defaultProps, {
	              hide: true,
	              orientation: ORIENT_MAP[axisType] && ORIENT_MAP[axisType][index % 2],
	              domain: domain,
	              originalDomain: Axis.defaultProps.domain,
	              isCategorial: isCategorial,
	              layout: layout // specify scale when no Axis
	              // scale: isCategorial ? 'band' : 'linear',
	
	            })));
	          }
	
	          return result;
	        }, {});
	        return axisMap;
	      }
	    }, {
	      key: "getActiveCoordinate",
	      value: function getActiveCoordinate(tooltipTicks, activeIndex, rangeObj) {
	        var layout = this.props.layout;
	        var entry = tooltipTicks.find(function (tick) {
	          return tick && tick.index === activeIndex;
	        });
	
	        if (entry) {
	          if (layout === 'horizontal') {
	            return {
	              x: entry.coordinate,
	              y: rangeObj.y
	            };
	          }
	
	          if (layout === 'vertical') {
	            return {
	              x: rangeObj.x,
	              y: entry.coordinate
	            };
	          }
	
	          if (layout === 'centric') {
	            var _angle = entry.coordinate;
	            var _radius = rangeObj.radius;
	            return _objectSpread({}, rangeObj, {}, (0, _PolarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, _radius, _angle), {
	              angle: _angle,
	              radius: _radius
	            });
	          }
	
	          var radius = entry.coordinate;
	          var angle = rangeObj.angle;
	          return _objectSpread({}, rangeObj, {}, (0, _PolarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, radius, angle), {
	            angle: angle,
	            radius: radius
	          });
	        }
	
	        return originCoordinate;
	      }
	      /**
	       * Get the information of mouse in chart, return null when the mouse is not in the chart
	       * @param  {Object} event    The event object
	       * @return {Object}          Mouse data
	       */
	
	    }, {
	      key: "getMouseInfo",
	      value: function getMouseInfo(event) {
	        if (!this.container) {
	          return null;
	        }
	
	        var containerOffset = (0, _DOMUtils.getOffset)(this.container);
	        var e = (0, _DOMUtils.calculateChartCoordinate)(event, containerOffset);
	        var rangeObj = this.inRange(e.chartX, e.chartY);
	
	        if (!rangeObj) {
	          return null;
	        }
	
	        var _this$state9 = this.state,
	            xAxisMap = _this$state9.xAxisMap,
	            yAxisMap = _this$state9.yAxisMap;
	
	        if (eventType !== 'axis' && xAxisMap && yAxisMap) {
	          var xScale = (0, _DataUtils.getAnyElementOfObject)(xAxisMap).scale;
	          var yScale = (0, _DataUtils.getAnyElementOfObject)(yAxisMap).scale;
	          var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
	          var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
	          return _objectSpread({}, e, {
	            xValue: xValue,
	            yValue: yValue
	          });
	        }
	
	        var _this$state10 = this.state,
	            ticks = _this$state10.orderedTooltipTicks,
	            axis = _this$state10.tooltipAxis,
	            tooltipTicks = _this$state10.tooltipTicks;
	        var pos = this.calculateTooltipPos(rangeObj);
	        var activeIndex = (0, _ChartUtils.calculateActiveTickIndex)(pos, ticks, tooltipTicks, axis);
	
	        if (activeIndex >= 0 && tooltipTicks) {
	          var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
	          var activePayload = this.getTooltipContent(activeIndex, activeLabel);
	          var activeCoordinate = this.getActiveCoordinate(ticks, activeIndex, rangeObj);
	          return _objectSpread({}, e, {
	            activeTooltipIndex: activeIndex,
	            activeLabel: activeLabel,
	            activePayload: activePayload,
	            activeCoordinate: activeCoordinate
	          });
	        }
	
	        return null;
	      }
	      /**
	       * Get the content to be displayed in the tooltip
	       * @param  {Number} activeIndex    Active index of data
	       * @param  {String} activeLabel    Active label of data
	       * @return {Array}                 The content of tooltip
	       */
	
	    }, {
	      key: "getTooltipContent",
	      value: function getTooltipContent(activeIndex, activeLabel) {
	        var _this$state11 = this.state,
	            graphicalItems = _this$state11.graphicalItems,
	            tooltipAxis = _this$state11.tooltipAxis;
	        var displayedData = this.constructor.getDisplayedData(this.props, this.state);
	
	        if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) {
	          return null;
	        } // get data by activeIndex when the axis don't allow duplicated category
	
	
	        return graphicalItems.reduce(function (result, child) {
	          var hide = child.props.hide;
	
	          if (hide) {
	            return result;
	          }
	
	          var _child$props2 = child.props,
	              dataKey = _child$props2.dataKey,
	              name = _child$props2.name,
	              unit = _child$props2.unit,
	              formatter = _child$props2.formatter,
	              data = _child$props2.data,
	              tooltipType = _child$props2.tooltipType;
	          var payload;
	
	          if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
	            // graphic child has data props
	            payload = (0, _DataUtils.findEntryInArray)(data || displayedData, tooltipAxis.dataKey, activeLabel);
	          } else {
	            payload = data && data[activeIndex] || displayedData[activeIndex];
	          }
	
	          if (!payload) {
	            return result;
	          }
	
	          return [].concat(_toConsumableArray(result), [_objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(child), {
	            dataKey: dataKey,
	            unit: unit,
	            formatter: formatter,
	            name: name || dataKey,
	            color: (0, _ChartUtils.getMainColorOfGraphicItem)(child),
	            value: (0, _ChartUtils.getValueByDataKey)(payload, dataKey),
	            type: tooltipType,
	            payload: payload
	          })]);
	        }, []);
	      }
	    }, {
	      key: "getFormatItems",
	      value: function getFormatItems(props, currentState) {
	        var _this4 = this;
	
	        var graphicalItems = currentState.graphicalItems,
	            stackGroups = currentState.stackGroups,
	            offset = currentState.offset,
	            updateId = currentState.updateId,
	            dataStartIndex = currentState.dataStartIndex,
	            dataEndIndex = currentState.dataEndIndex;
	        var barSize = props.barSize,
	            layout = props.layout,
	            barGap = props.barGap,
	            barCategoryGap = props.barCategoryGap,
	            globalMaxBarSize = props.maxBarSize;
	
	        var _this$constructor$get = this.constructor.getAxisNameByLayout(layout),
	            numericAxisName = _this$constructor$get.numericAxisName,
	            cateAxisName = _this$constructor$get.cateAxisName;
	
	        var hasBar = this.constructor.hasBar(graphicalItems);
	        var sizeList = hasBar && (0, _ChartUtils.getBarSizeList)({
	          barSize: barSize,
	          stackGroups: stackGroups
	        });
	        var formatedItems = [];
	        graphicalItems.forEach(function (item, index) {
	          var displayedData = _this4.constructor.getDisplayedData(props, {
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          }, item);
	
	          var _item$props2 = item.props,
	              dataKey = _item$props2.dataKey,
	              childMaxBarSize = _item$props2.maxBarSize;
	          var numericAxisId = item.props["".concat(numericAxisName, "Id")];
	          var cateAxisId = item.props["".concat(cateAxisName, "Id")];
	          var axisObj = axisComponents.reduce(function (result, entry) {
	            var _objectSpread4;
	
	            var axisMap = currentState["".concat(entry.axisType, "Map")];
	            var id = item.props["".concat(entry.axisType, "Id")];
	            var axis = axisMap && axisMap[id];
	            return _objectSpread({}, result, (_objectSpread4 = {}, _defineProperty(_objectSpread4, entry.axisType, axis), _defineProperty(_objectSpread4, "".concat(entry.axisType, "Ticks"), (0, _ChartUtils.getTicksOfAxis)(axis)), _objectSpread4));
	          }, {});
	          var cateAxis = axisObj[cateAxisName];
	          var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
	          var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, _ChartUtils.getStackedDataOfItem)(item, stackGroups[numericAxisId].stackGroups);
	          var bandSize = (0, _ChartUtils.getBandSizeOfAxis)(cateAxis, cateTicks);
	          var maxBarSize = (0, _isNil2["default"])(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
	          var barPosition = hasBar && (0, _ChartUtils.getBarPosition)({
	            barGap: barGap,
	            barCategoryGap: barCategoryGap,
	            bandSize: bandSize,
	            sizeList: sizeList[cateAxisId],
	            maxBarSize: maxBarSize
	          });
	          var componsedFn = item && item.type && item.type.getComposedData;
	
	          if (componsedFn) {
	            var _objectSpread5;
	
	            formatedItems.push({
	              props: _objectSpread({}, componsedFn(_objectSpread({}, axisObj, {
	                displayedData: displayedData,
	                props: props,
	                dataKey: dataKey,
	                item: item,
	                bandSize: bandSize,
	                barPosition: barPosition,
	                offset: offset,
	                stackedData: stackedData,
	                layout: layout,
	                dataStartIndex: dataStartIndex,
	                dataEndIndex: dataEndIndex,
	                onItemMouseLeave: (0, _ChartUtils.combineEventHandlers)(_this4.handleItemMouseLeave, null, item.props.onMouseLeave),
	                onItemMouseEnter: (0, _ChartUtils.combineEventHandlers)(_this4.handleItemMouseEnter, null, item.props.onMouseEnter)
	              })), (_objectSpread5 = {
	                key: item.key || "item-".concat(index)
	              }, _defineProperty(_objectSpread5, numericAxisName, axisObj[numericAxisName]), _defineProperty(_objectSpread5, cateAxisName, axisObj[cateAxisName]), _defineProperty(_objectSpread5, "animationId", updateId), _objectSpread5)),
	              childIndex: (0, _ReactUtils.parseChildIndex)(item, props.children),
	              item: item
	            });
	          }
	        });
	        return formatedItems;
	      }
	    }, {
	      key: "getCursorRectangle",
	      value: function getCursorRectangle() {
	        var layout = this.props.layout;
	        var _this$state12 = this.state,
	            activeCoordinate = _this$state12.activeCoordinate,
	            offset = _this$state12.offset,
	            tooltipAxisBandSize = _this$state12.tooltipAxisBandSize;
	        var halfSize = tooltipAxisBandSize / 2;
	        return {
	          stroke: 'none',
	          fill: '#ccc',
	          x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
	          y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
	          width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
	          height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
	        };
	      }
	    }, {
	      key: "getCursorPoints",
	      value: function getCursorPoints() {
	        var layout = this.props.layout;
	        var _this$state13 = this.state,
	            activeCoordinate = _this$state13.activeCoordinate,
	            offset = _this$state13.offset;
	        var x1, y1, x2, y2;
	
	        if (layout === 'horizontal') {
	          x1 = activeCoordinate.x;
	          x2 = x1;
	          y1 = offset.top;
	          y2 = offset.top + offset.height;
	        } else if (layout === 'vertical') {
	          y1 = activeCoordinate.y;
	          y2 = y1;
	          x1 = offset.left;
	          x2 = offset.left + offset.width;
	        } else if (!(0, _isNil2["default"])(activeCoordinate.cx) || !(0, _isNil2["default"])(activeCoordinate.cy)) {
	          if (layout === 'centric') {
	            var cx = activeCoordinate.cx,
	                cy = activeCoordinate.cy,
	                innerRadius = activeCoordinate.innerRadius,
	                outerRadius = activeCoordinate.outerRadius,
	                angle = activeCoordinate.angle;
	            var innerPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, angle);
	            var outerPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, angle);
	            x1 = innerPoint.x;
	            y1 = innerPoint.y;
	            x2 = outerPoint.x;
	            y2 = outerPoint.y;
	          } else {
	            var _cx = activeCoordinate.cx,
	                _cy = activeCoordinate.cy,
	                radius = activeCoordinate.radius,
	                startAngle = activeCoordinate.startAngle,
	                endAngle = activeCoordinate.endAngle;
	            var startPoint = (0, _PolarUtils.polarToCartesian)(_cx, _cy, radius, startAngle);
	            var endPoint = (0, _PolarUtils.polarToCartesian)(_cx, _cy, radius, endAngle);
	            return {
	              points: [startPoint, endPoint],
	              cx: _cx,
	              cy: _cy,
	              radius: radius,
	              startAngle: startAngle,
	              endAngle: endAngle
	            };
	          }
	        }
	
	        return [{
	          x: x1,
	          y: y1
	        }, {
	          x: x2,
	          y: y2
	        }];
	      }
	    }, {
	      key: "calculateTooltipPos",
	      value: function calculateTooltipPos(rangeObj) {
	        var layout = this.props.layout;
	
	        if (layout === 'horizontal') {
	          return rangeObj.x;
	        }
	
	        if (layout === 'vertical') {
	          return rangeObj.y;
	        }
	
	        if (layout === 'centric') {
	          return rangeObj.angle;
	        }
	
	        return rangeObj.radius;
	      }
	    }, {
	      key: "inRange",
	      value: function inRange(x, y) {
	        var layout = this.props.layout;
	
	        if (layout === 'horizontal' || layout === 'vertical') {
	          var offset = this.state.offset;
	          var isInRange = x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
	          return isInRange ? {
	            x: x,
	            y: y
	          } : null;
	        }
	
	        var _this$state14 = this.state,
	            angleAxisMap = _this$state14.angleAxisMap,
	            radiusAxisMap = _this$state14.radiusAxisMap;
	
	        if (angleAxisMap && radiusAxisMap) {
	          var angleAxis = (0, _DataUtils.getAnyElementOfObject)(angleAxisMap);
	          return (0, _PolarUtils.inRangeOfSector)({
	            x: x,
	            y: y
	          }, angleAxis);
	        }
	
	        return null;
	      }
	    }, {
	      key: "parseEventsOfWrapper",
	      value: function parseEventsOfWrapper() {
	        var children = this.props.children;
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	        var tooltipEvents = tooltipItem && eventType === 'axis' ? {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseMove: this.handleMouseMove,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchMove: this.handleTouchMove,
	          onTouchStart: this.handleTouchStart,
	          onTouchEnd: this.handleTouchEnd
	        } : {};
	        var outerEvents = (0, _ReactUtils.filterEventAttributes)(this.props, this.handleOuterEvent);
	        return _objectSpread({}, outerEvents, {}, tooltipEvents);
	      }
	      /**
	       * The AxisMaps are expensive to render on large data sets
	       * so provide the ability to store them in state and only update them when necessary
	       * they are dependent upon the start and end index of
	       * the brush so it's important that this method is called _after_
	       * the state is updated with any new start/end indices
	       *
	       * @param {Object} props          The props object to be used for updating the axismaps
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @param {Number} updateId       The update id
	       * @return {Object} state New state to set
	       */
	
	    }, {
	      key: "updateStateOfAxisMapsOffsetAndStackGroups",
	      value: function updateStateOfAxisMapsOffsetAndStackGroups(_ref8) {
	        var _this5 = this;
	
	        var props = _ref8.props,
	            dataStartIndex = _ref8.dataStartIndex,
	            dataEndIndex = _ref8.dataEndIndex,
	            updateId = _ref8.updateId;
	
	        if (!(0, _ReactUtils.validateWidthHeight)({
	          props: props
	        })) {
	          return null;
	        }
	
	        var children = props.children,
	            layout = props.layout,
	            stackOffset = props.stackOffset,
	            data = props.data,
	            reverseStackOrder = props.reverseStackOrder;
	
	        var _this$constructor$get2 = this.constructor.getAxisNameByLayout(layout),
	            numericAxisName = _this$constructor$get2.numericAxisName,
	            cateAxisName = _this$constructor$get2.cateAxisName;
	
	        var graphicalItems = (0, _ReactUtils.findAllByType)(children, GraphicalChild);
	        var stackGroups = (0, _ChartUtils.getStackGroupsByAxisId)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
	        var axisObj = axisComponents.reduce(function (result, entry) {
	          var name = "".concat(entry.axisType, "Map");
	          return _objectSpread({}, result, _defineProperty({}, name, _this5.getAxisMap(props, _objectSpread({}, entry, {
	            graphicalItems: graphicalItems,
	            stackGroups: entry.axisType === numericAxisName && stackGroups,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          }))));
	        }, {});
	        var offset = this.calculateOffset(_objectSpread({}, axisObj, {
	          props: props,
	          graphicalItems: graphicalItems
	        }));
	        Object.keys(axisObj).forEach(function (key) {
	          axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
	        });
	        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
	        var ticksObj = this.tooltipTicksGenerator(cateAxisMap);
	        var formatedGraphicalItems = this.getFormatItems(props, _objectSpread({}, axisObj, {
	          dataStartIndex: dataStartIndex,
	          dataEndIndex: dataEndIndex,
	          updateId: updateId,
	          graphicalItems: graphicalItems,
	          stackGroups: stackGroups,
	          offset: offset
	        }));
	        return _objectSpread({
	          formatedGraphicalItems: formatedGraphicalItems,
	          graphicalItems: graphicalItems,
	          offset: offset,
	          stackGroups: stackGroups
	        }, ticksObj, {}, axisObj);
	      }
	      /* eslint-disable  no-underscore-dangle */
	
	    }, {
	      key: "addListener",
	      value: function addListener() {
	        _Events.eventCenter.on(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners + 1);
	        }
	      }
	    }, {
	      key: "removeListener",
	      value: function removeListener() {
	        _Events.eventCenter.removeListener(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners - 1);
	        }
	      }
	      /**
	       * Calculate the offset of main part in the svg element
	       * @param  {Object} props          Latest props
	       * @param  {Array}  graphicalItems The instances of item
	       * @param  {Object} xAxisMap       The configuration of x-axis
	       * @param  {Object} yAxisMap       The configuration of y-axis
	       * @return {Object} The offset of main part in the svg element
	       */
	
	    }, {
	      key: "calculateOffset",
	      value: function calculateOffset(_ref9) {
	        var props = _ref9.props,
	            graphicalItems = _ref9.graphicalItems,
	            _ref9$xAxisMap = _ref9.xAxisMap,
	            xAxisMap = _ref9$xAxisMap === void 0 ? {} : _ref9$xAxisMap,
	            _ref9$yAxisMap = _ref9.yAxisMap,
	            yAxisMap = _ref9$yAxisMap === void 0 ? {} : _ref9$yAxisMap;
	        var width = props.width,
	            height = props.height,
	            children = props.children;
	        var margin = props.margin || {};
	        var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush["default"]);
	        var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend["default"]);
	        var offsetH = Object.keys(yAxisMap).reduce(function (result, id) {
	          var entry = yAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _objectSpread({}, result, _defineProperty({}, orientation, result[orientation] + entry.width));
	          }
	
	          return result;
	        }, {
	          left: margin.left || 0,
	          right: margin.right || 0
	        });
	        var offsetV = Object.keys(xAxisMap).reduce(function (result, id) {
	          var entry = xAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _objectSpread({}, result, _defineProperty({}, orientation, result[orientation] + entry.height));
	          }
	
	          return result;
	        }, {
	          top: margin.top || 0,
	          bottom: margin.bottom || 0
	        });
	
	        var offset = _objectSpread({}, offsetV, {}, offsetH);
	
	        var brushBottom = offset.bottom;
	
	        if (brushItem) {
	          offset.bottom += brushItem.props.height || _Brush["default"].defaultProps.height;
	        }
	
	        if (legendItem && this.legendInstance) {
	          var legendBox = this.legendInstance.getBBox();
	          offset = (0, _ChartUtils.appendOffsetOfLegend)(offset, graphicalItems, props, legendBox);
	        }
	
	        return _objectSpread({
	          brushBottom: brushBottom
	        }, offset, {
	          width: width - offset.left - offset.right,
	          height: height - offset.top - offset.bottom
	        });
	      }
	    }, {
	      key: "triggerSyncEvent",
	      value: function triggerSyncEvent(data) {
	        var syncId = this.props.syncId;
	
	        if (!(0, _isNil2["default"])(syncId)) {
	          _Events.eventCenter.emit(_Events.SYNC_EVENT, syncId, this.uniqueChartId, data);
	        }
	      }
	    }, {
	      key: "filterFormatItem",
	      value: function filterFormatItem(item, displayName, childIndex) {
	        var formatedGraphicalItems = this.state.formatedGraphicalItems;
	
	        for (var i = 0, len = formatedGraphicalItems.length; i < len; i++) {
	          var entry = formatedGraphicalItems[i];
	
	          if (entry.item === item || entry.props.key === item.key || displayName === (0, _ReactUtils.getDisplayName)(entry.item.type) && childIndex === entry.childIndex) {
	            return entry;
	          }
	        }
	
	        return null;
	      }
	    }, {
	      key: "renderAxis",
	
	      /**
	       * Draw axis
	       * @param {Object} axisOptions The options of axis
	       * @param {Object} element      The axis element
	       * @param {String} displayName  The display name of axis
	       * @param {Number} index        The index of element
	       * @return {ReactElement}       The instance of x-axes
	       */
	      value: function renderAxis(axisOptions, element, displayName, index) {
	        var _this$props5 = this.props,
	            width = _this$props5.width,
	            height = _this$props5.height;
	        return _react["default"].createElement(_CartesianAxis["default"], _extends({}, axisOptions, {
	          className: "recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType),
	          key: element.key || "".concat(displayName, "-").concat(index),
	          viewBox: {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          },
	          ticksGenerator: this.axesTicksGenerator
	        }));
	      }
	      /**
	       * Draw grid
	       * @param  {ReactElement} element the grid item
	       * @return {ReactElement} The instance of grid
	       */
	
	    }, {
	      key: "renderLegend",
	
	      /**
	       * Draw legend
	       * @return {ReactElement}            The instance of Legend
	       */
	      value: function renderLegend() {
	        var _this6 = this;
	
	        var formatedGraphicalItems = this.state.formatedGraphicalItems;
	        var _this$props6 = this.props,
	            children = _this$props6.children,
	            width = _this$props6.width,
	            height = _this$props6.height;
	        var margin = this.props.margin || {};
	        var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	        var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	        var props = (0, _ChartUtils.getLegendProps)({
	          children: children,
	          formatedGraphicalItems: formatedGraphicalItems,
	          legendWidth: legendWidth,
	          legendHeight: legendHeight,
	          legendContent: legendContent
	        });
	
	        if (!props) {
	          return null;
	        }
	
	        var item = props.item,
	            otherProps = _objectWithoutProperties(props, ["item"]);
	
	        return (0, _react.cloneElement)(item, _objectSpread({}, otherProps, {
	          chartWidth: width,
	          chartHeight: height,
	          margin: margin,
	          ref: function ref(legend) {
	            _this6.legendInstance = legend;
	          },
	          onBBoxUpdate: this.handleLegendBBoxUpdate
	        }));
	      }
	      /**
	       * Draw Tooltip
	       * @return {ReactElement}  The instance of Tooltip
	       */
	
	    }, {
	      key: "renderTooltip",
	      value: function renderTooltip() {
	        var children = this.props.children;
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	        if (!tooltipItem) {
	          return null;
	        }
	
	        var _this$state15 = this.state,
	            isTooltipActive = _this$state15.isTooltipActive,
	            activeCoordinate = _this$state15.activeCoordinate,
	            activePayload = _this$state15.activePayload,
	            activeLabel = _this$state15.activeLabel,
	            offset = _this$state15.offset;
	        return (0, _react.cloneElement)(tooltipItem, {
	          viewBox: _objectSpread({}, offset, {
	            x: offset.left,
	            y: offset.top
	          }),
	          active: isTooltipActive,
	          label: activeLabel,
	          payload: isTooltipActive ? activePayload : [],
	          coordinate: activeCoordinate
	        });
	      }
	    }, {
	      key: "renderActivePoints",
	      value: function renderActivePoints(_ref10) {
	        var item = _ref10.item,
	            activePoint = _ref10.activePoint,
	            basePoint = _ref10.basePoint,
	            childIndex = _ref10.childIndex,
	            isRange = _ref10.isRange;
	        var result = [];
	        var key = item.props.key;
	        var _item$item$props2 = item.item.props,
	            activeDot = _item$item$props2.activeDot,
	            dataKey = _item$item$props2.dataKey;
	
	        var dotProps = _objectSpread({
	          index: childIndex,
	          dataKey: dataKey,
	          cx: activePoint.x,
	          cy: activePoint.y,
	          r: 4,
	          fill: (0, _ChartUtils.getMainColorOfGraphicItem)(item.item),
	          strokeWidth: 2,
	          stroke: '#fff',
	          payload: activePoint.payload,
	          value: activePoint.value,
	          key: "".concat(key, "-activePoint-").concat(childIndex)
	        }, (0, _ReactUtils.getPresentationAttributes)(activeDot), {}, (0, _ReactUtils.filterEventAttributes)(activeDot));
	
	        result.push(this.constructor.renderActiveDot(activeDot, dotProps, childIndex));
	
	        if (basePoint) {
	          result.push(this.constructor.renderActiveDot(activeDot, _objectSpread({}, dotProps, {
	            cx: basePoint.x,
	            cy: basePoint.y,
	            key: "".concat(key, "-basePoint-").concat(childIndex)
	          }), childIndex));
	        } else if (isRange) {
	          result.push(null);
	        }
	
	        return result;
	      }
	    }, {
	      key: "renderClipPath",
	      value: function renderClipPath() {
	        var clipPathId = this.clipPathId;
	        var _this$state$offset = this.state.offset,
	            left = _this$state$offset.left,
	            top = _this$state$offset.top,
	            height = _this$state$offset.height,
	            width = _this$state$offset.width;
	        return _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	          id: clipPathId
	        }, _react["default"].createElement("rect", {
	          x: left,
	          y: top,
	          height: height,
	          width: width
	        })));
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this7 = this;
	
	        if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	          return null;
	        }
	
	        var _this$props7 = this.props,
	            children = _this$props7.children,
	            className = _this$props7.className,
	            width = _this$props7.width,
	            height = _this$props7.height,
	            style = _this$props7.style,
	            compact = _this$props7.compact,
	            others = _objectWithoutProperties(_this$props7, ["children", "className", "width", "height", "style", "compact"]);
	
	        var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	        var map = {
	          CartesianGrid: {
	            handler: this.renderGrid,
	            once: true
	          },
	          ReferenceArea: {
	            handler: this.renderReferenceElement
	          },
	          ReferenceLine: {
	            handler: this.renderReferenceElement
	          },
	          ReferenceDot: {
	            handler: this.renderReferenceElement
	          },
	          XAxis: {
	            handler: this.renderXAxis
	          },
	          YAxis: {
	            handler: this.renderYAxis
	          },
	          Brush: {
	            handler: this.renderBrush,
	            once: true
	          },
	          Bar: {
	            handler: this.renderGraphicChild
	          },
	          Line: {
	            handler: this.renderGraphicChild
	          },
	          Area: {
	            handler: this.renderGraphicChild
	          },
	          Radar: {
	            handler: this.renderGraphicChild
	          },
	          RadialBar: {
	            handler: this.renderGraphicChild
	          },
	          Scatter: {
	            handler: this.renderGraphicChild
	          },
	          Pie: {
	            handler: this.renderGraphicChild
	          },
	          Funnel: {
	            handler: this.renderGraphicChild
	          },
	          Tooltip: {
	            handler: this.renderCursor,
	            once: true
	          },
	          PolarGrid: {
	            handler: this.renderPolarGrid,
	            once: true
	          },
	          PolarAngleAxis: {
	            handler: this.renderPolarAxis
	          },
	          PolarRadiusAxis: {
	            handler: this.renderPolarAxis
	          },
	          Customized: {
	            handler: this.renderCustomized
	          }
	        }; // The "compact" mode is mainly used as the panorama within Brush
	
	        if (compact) {
	          return _react["default"].createElement(_Surface["default"], _extends({}, attrs, {
	            width: width,
	            height: height
	          }), this.renderClipPath(), (0, _ReactUtils.renderByOrder)(children, map));
	        }
	
	        var events = this.parseEventsOfWrapper();
	        return _react["default"].createElement("div", _extends({
	          className: (0, _classnames["default"])('recharts-wrapper', className),
	          style: _objectSpread({
	            position: 'relative',
	            cursor: 'default',
	            width: width,
	            height: height
	          }, style)
	        }, events, {
	          ref: function ref(node) {
	            _this7.container = node;
	          }
	        }), _react["default"].createElement(_Surface["default"], _extends({}, attrs, {
	          width: width,
	          height: height
	        }), this.renderClipPath(), (0, _ReactUtils.renderByOrder)(children, map)), this.renderLegend(), this.renderTooltip());
	      }
	    }], [{
	      key: "getAxisNameByLayout",
	      value: function getAxisNameByLayout(layout) {
	        if (layout === 'horizontal') {
	          return {
	            numericAxisName: 'yAxis',
	            cateAxisName: 'xAxis'
	          };
	        }
	
	        if (layout === 'vertical') {
	          return {
	            numericAxisName: 'xAxis',
	            cateAxisName: 'yAxis'
	          };
	        }
	
	        if (layout === 'centric') {
	          return {
	            numericAxisName: 'radiusAxis',
	            cateAxisName: 'angleAxis'
	          };
	        }
	
	        return {
	          numericAxisName: 'angleAxis',
	          cateAxisName: 'radiusAxis'
	        };
	      }
	    }, {
	      key: "renderActiveDot",
	      value: function renderActiveDot(option, props) {
	        var dot;
	
	        if ((0, _react.isValidElement)(option)) {
	          dot = (0, _react.cloneElement)(option, props);
	        } else if ((0, _isFunction2["default"])(option)) {
	          dot = option(props);
	        } else {
	          dot = _react["default"].createElement(_Dot["default"], props);
	        }
	
	        return _react["default"].createElement(_Layer["default"], {
	          className: "recharts-active-dot",
	          key: props.key
	        }, dot);
	      }
	    }]);
	
	    return CategoricalChartWrapper;
	  }(_react.Component);
	
	  CategoricalChartWrapper.displayName = chartName;
	  CategoricalChartWrapper.propTypes = _objectSpread({
	    syncId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	    compact: _propTypes["default"].bool,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number,
	    data: _propTypes["default"].arrayOf(_propTypes["default"].object),
	    layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	    stackOffset: _propTypes["default"].oneOf(['sign', 'expand', 'none', 'wiggle', 'silhouette']),
	    throttleDelay: _propTypes["default"].number,
	    margin: _propTypes["default"].shape({
	      top: _propTypes["default"].number,
	      right: _propTypes["default"].number,
	      bottom: _propTypes["default"].number,
	      left: _propTypes["default"].number
	    }),
	    barCategoryGap: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    barGap: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    barSize: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    maxBarSize: _propTypes["default"].number,
	    style: _propTypes["default"].object,
	    className: _propTypes["default"].string,
	    children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
	    defaultShowTooltip: _propTypes["default"].bool,
	    onClick: _propTypes["default"].func,
	    onMouseLeave: _propTypes["default"].func,
	    onMouseEnter: _propTypes["default"].func,
	    onMouseMove: _propTypes["default"].func,
	    onMouseDown: _propTypes["default"].func,
	    onMouseUp: _propTypes["default"].func,
	    reverseStackOrder: _propTypes["default"].bool,
	    id: _propTypes["default"].string
	  }, propTypes);
	  CategoricalChartWrapper.defaultProps = _objectSpread({
	    layout: 'horizontal',
	    stackOffset: 'none',
	    barCategoryGap: '10%',
	    barGap: 4,
	    margin: {
	      top: 5,
	      right: 5,
	      bottom: 5,
	      left: 5
	    },
	    reverseStackOrder: false
	  }, defaultProps);
	
	  CategoricalChartWrapper.createDefaultState = function (props) {
	    var children = props.children,
	        defaultShowTooltip = props.defaultShowTooltip;
	    var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush["default"]);
	    var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
	    var endIndex = brushItem && brushItem.props && brushItem.props.endIndex || props.data && props.data.length - 1 || 0;
	    return {
	      chartX: 0,
	      chartY: 0,
	      dataStartIndex: startIndex,
	      dataEndIndex: endIndex,
	      activeTooltipIndex: -1,
	      isTooltipActive: !(0, _isNil2["default"])(defaultShowTooltip) ? defaultShowTooltip : false
	    };
	  };
	
	  CategoricalChartWrapper.hasBar = function (graphicalItems) {
	    if (!graphicalItems || !graphicalItems.length) {
	      return false;
	    }
	
	    return graphicalItems.some(function (item) {
	      var name = (0, _ReactUtils.getDisplayName)(item && item.type);
	      return name && name.indexOf('Bar') >= 0;
	    });
	  };
	
	  CategoricalChartWrapper.getDisplayedData = function (props, _ref11, item) {
	    var graphicalItems = _ref11.graphicalItems,
	        dataStartIndex = _ref11.dataStartIndex,
	        dataEndIndex = _ref11.dataEndIndex;
	    var itemsData = (graphicalItems || []).reduce(function (result, child) {
	      var itemData = child.props.data;
	
	      if (itemData && itemData.length) {
	        return [].concat(_toConsumableArray(result), _toConsumableArray(itemData));
	      }
	
	      return result;
	    }, []);
	
	    if (itemsData && itemsData.length > 0) {
	      return itemsData;
	    }
	
	    if (item && item.props && item.props.data && item.props.data.length > 0) {
	      return item.props.data;
	    }
	
	    var data = props.data;
	
	    if (data && data.length && (0, _DataUtils.isNumber)(dataStartIndex) && (0, _DataUtils.isNumber)(dataEndIndex)) {
	      return data.slice(dataStartIndex, dataEndIndex + 1);
	    }
	
	    return [];
	  };
	
	  return CategoricalChartWrapper;
	};
	
	var _default = generateCategoricalChart;
	exports["default"] = _default;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(100));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(115));
	
	var _last2 = _interopRequireDefault(__webpack_require__(138));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(62));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Label = _interopRequireDefault(__webpack_require__(190));
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _ReactUtils = __webpack_require__(43);
	
	var _ChartUtils = __webpack_require__(103);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var propTypes = {
	  id: _propTypes["default"].string,
	  data: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  valueAccessor: _propTypes["default"].func,
	  clockWise: _propTypes["default"].bool,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func])
	};
	var defaultProps = {
	  valueAccessor: function valueAccessor(entry) {
	    return (0, _isArray2["default"])(entry.value) ? (0, _last2["default"])(entry.value) : entry.value;
	  }
	};
	
	function LabelList(props) {
	  var data = props.data,
	      valueAccessor = props.valueAccessor,
	      dataKey = props.dataKey,
	      clockWise = props.clockWise,
	      id = props.id,
	      others = _objectWithoutProperties(props, ["data", "valueAccessor", "dataKey", "clockWise", "id"]);
	
	  if (!data || !data.length) {
	    return null;
	  }
	
	  return _react["default"].createElement(_Layer["default"], {
	    className: "recharts-label-list"
	  }, data.map(function (entry, index) {
	    var value = (0, _isNil2["default"])(dataKey) ? valueAccessor(entry, index) : (0, _ChartUtils.getValueByDataKey)(entry && entry.payload, dataKey);
	    var idProps = (0, _isNil2["default"])(id) ? {} : {
	      id: "".concat(id, "-").concat(index)
	    };
	    return _react["default"].createElement(_Label["default"], _extends({}, (0, _ReactUtils.getPresentationAttributes)(entry), others, idProps, {
	      index: index,
	      value: value,
	      viewBox: _Label["default"].parseViewBox((0, _isNil2["default"])(clockWise) ? entry : _objectSpread({}, entry, {
	        clockWise: clockWise
	      })),
	      key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
	
	    }));
	  }));
	}
	
	LabelList.propTypes = propTypes;
	LabelList.displayName = 'LabelList';
	
	var parseLabelList = function parseLabelList(label, data) {
	  if (!label) {
	    return null;
	  }
	
	  if (label === true) {
	    return _react["default"].createElement(LabelList, {
	      key: "labelList-implicit",
	      data: data
	    });
	  }
	
	  if (_react["default"].isValidElement(label) || (0, _isFunction2["default"])(label)) {
	    return _react["default"].createElement(LabelList, {
	      key: "labelList-implicit",
	      data: data,
	      content: label
	    });
	  }
	
	  if ((0, _isObject2["default"])(label)) {
	    return _react["default"].createElement(LabelList, _extends({
	      data: data
	    }, label, {
	      key: "labelList-implicit"
	    }));
	  }
	
	  return null;
	};
	
	var renderCallByParent = function renderCallByParent(parentProps, data) {
	  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
	    return null;
	  }
	
	  var children = parentProps.children;
	  var explicitChilren = (0, _ReactUtils.findAllByType)(children, LabelList).map(function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      data: data,
	      key: "labelList-".concat(index)
	    });
	  });
	
	  if (!ckeckPropsLabel) {
	    return explicitChilren;
	  }
	
	  var implicitLabelList = parseLabelList(parentProps.label, data);
	  return [implicitLabelList].concat(_toConsumableArray(explicitChilren));
	};
	
	LabelList.renderCallByParent = renderCallByParent;
	LabelList.defaultProps = defaultProps;
	var _default = LabelList;
	exports["default"] = _default;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.clones = exports.CONTEXT_KEY = exports.LOCAL_ATTR = exports.SC_ATTR = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BrowserStyleSheet = __webpack_require__(2018);
	
	var _BrowserStyleSheet2 = _interopRequireDefault(_BrowserStyleSheet);
	
	var _ServerStyleSheet = __webpack_require__(397);
	
	var _ServerStyleSheet2 = _interopRequireDefault(_ServerStyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SC_ATTR = exports.SC_ATTR = 'data-styled-components';
	var LOCAL_ATTR = exports.LOCAL_ATTR = 'data-styled-components-is-local';
	var CONTEXT_KEY = exports.CONTEXT_KEY = '__styled-components-stylesheet__';
	
	/* eslint-disable flowtype/object-type-delimiter */
	
	/* eslint-enable flowtype/object-type-delimiter */
	
	var instance = null;
	// eslint-disable-next-line no-use-before-define
	var clones = exports.clones = [];
	
	var StyleSheet = function () {
	  function StyleSheet(tagConstructor) {
	    var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var names = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    _classCallCheck(this, StyleSheet);
	
	    this.hashes = {};
	    this.deferredInjections = {};
	    this.stylesCacheable = typeof document !== 'undefined';
	
	    this.tagConstructor = tagConstructor;
	    this.tags = tags;
	    this.names = names;
	    this.constructComponentTagMap();
	  }
	  // helper for `ComponentStyle` to know when it cache static styles.
	  // staticly styled-component can not safely cache styles on the server
	  // without all `ComponentStyle` instances saving a reference to the
	  // the styleSheet instance they last rendered with,
	  // or listening to creation / reset events. otherwise you might create
	  // a component with one stylesheet and render it another api response
	  // with another, losing styles on from your server-side render.
	
	
	  StyleSheet.prototype.constructComponentTagMap = function constructComponentTagMap() {
	    var _this = this;
	
	    this.componentTags = {};
	
	    this.tags.forEach(function (tag) {
	      Object.keys(tag.components).forEach(function (componentId) {
	        _this.componentTags[componentId] = tag;
	      });
	    });
	  };
	
	  /* Best level of caching—get the name from the hash straight away. */
	
	
	  StyleSheet.prototype.getName = function getName(hash) {
	    return this.hashes[hash.toString()];
	  };
	
	  /* Second level of caching—if the name is already in the dom, don't
	   * inject anything and record the hash for getName next time. */
	
	
	  StyleSheet.prototype.alreadyInjected = function alreadyInjected(hash, name) {
	    if (!this.names[name]) return false;
	
	    this.hashes[hash.toString()] = name;
	    return true;
	  };
	
	  /* Third type of caching—don't inject components' componentId twice. */
	
	
	  StyleSheet.prototype.hasInjectedComponent = function hasInjectedComponent(componentId) {
	    return !!this.componentTags[componentId];
	  };
	
	  StyleSheet.prototype.deferredInject = function deferredInject(componentId, isLocal, css) {
	    if (this === instance) {
	      clones.forEach(function (clone) {
	        clone.deferredInject(componentId, isLocal, css);
	      });
	    }
	
	    this.getOrCreateTag(componentId, isLocal);
	    this.deferredInjections[componentId] = css;
	  };
	
	  StyleSheet.prototype.inject = function inject(componentId, isLocal, css, hash, name) {
	    if (this === instance) {
	      clones.forEach(function (clone) {
	        clone.inject(componentId, isLocal, css);
	      });
	    }
	
	    var tag = this.getOrCreateTag(componentId, isLocal);
	
	    var deferredInjection = this.deferredInjections[componentId];
	    if (deferredInjection) {
	      tag.inject(componentId, deferredInjection);
	      delete this.deferredInjections[componentId];
	    }
	
	    tag.inject(componentId, css, name);
	
	    if (hash && name) {
	      this.hashes[hash.toString()] = name;
	    }
	  };
	
	  StyleSheet.prototype.toHTML = function toHTML() {
	    return this.tags.map(function (tag) {
	      return tag.toHTML();
	    }).join('');
	  };
	
	  StyleSheet.prototype.toReactElements = function toReactElements() {
	    return this.tags.map(function (tag, i) {
	      return tag.toReactElement('sc-' + i);
	    });
	  };
	
	  StyleSheet.prototype.getOrCreateTag = function getOrCreateTag(componentId, isLocal) {
	    var existingTag = this.componentTags[componentId];
	    if (existingTag) {
	      return existingTag;
	    }
	
	    var lastTag = this.tags[this.tags.length - 1];
	    var componentTag = !lastTag || lastTag.isFull() || lastTag.isLocal !== isLocal ? this.createNewTag(isLocal) : lastTag;
	    this.componentTags[componentId] = componentTag;
	    componentTag.addComponent(componentId);
	    return componentTag;
	  };
	
	  StyleSheet.prototype.createNewTag = function createNewTag(isLocal) {
	    var newTag = this.tagConstructor(isLocal);
	    this.tags.push(newTag);
	    return newTag;
	  };
	
	  StyleSheet.reset = function reset(isServer) {
	    instance = StyleSheet.create(isServer);
	  };
	
	  /* We can make isServer totally implicit once Jest 20 drops and we
	   * can change environment on a per-test basis. */
	
	
	  StyleSheet.create = function create() {
	    var isServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : typeof document === 'undefined';
	
	    return (isServer ? _ServerStyleSheet2.default : _BrowserStyleSheet2.default).create();
	  };
	
	  StyleSheet.clone = function clone(oldSheet) {
	    var newSheet = new StyleSheet(oldSheet.tagConstructor, oldSheet.tags.map(function (tag) {
	      return tag.clone();
	    }), _extends({}, oldSheet.names));
	
	    newSheet.hashes = _extends({}, oldSheet.hashes);
	    newSheet.deferredInjections = _extends({}, oldSheet.deferredInjections);
	    clones.push(newSheet);
	
	    return newSheet;
	  };
	
	  _createClass(StyleSheet, null, [{
	    key: 'instance',
	    get: function get() {
	      return instance || (instance = StyleSheet.create());
	    }
	  }]);
	
	  return StyleSheet;
	}();
	
	exports.default = StyleSheet;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.writeCookie = writeCookie;
	exports.getCookie = getCookie;
	exports.setItemToLocalStorage = setItemToLocalStorage;
	exports.getItemFromLocalStorage = getItemFromLocalStorage;
	exports.removeItemFromLocalStorage = removeItemFromLocalStorage;
	var jsonUtils_1 = __webpack_require__(193);
	function writeCookie(name, value, days) {
	    var expires;
	    if (days) {
	        var date = new Date();
	        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
	        expires = "; expires=" + date.toUTCString();
	    }
	    else {
	        expires = "";
	    }
	    document.cookie = name + "=" + value + expires + "; path=/";
	}
	function getCookie(cname) {
	    var name = cname + "=";
	    var ca = document.cookie.split(';');
	    for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) == ' ')
	            c = c.substring(1);
	        if (c.indexOf(name) == 0)
	            return c.substring(name.length, c.length);
	    }
	    return "";
	}
	function storagePrefix(objectType, lang, objektId) {
	    return objectType + "_" + lang + "_" + window.TENANT_ID + "_" + objektId;
	}
	function setItemToLocalStorage(objectType, lang, objektId, objekt) {
	    window.localStorage.setItem(storagePrefix(objectType, lang, objektId), (0, jsonUtils_1.stringify)(objekt));
	}
	function getItemFromLocalStorage(objectType, lang, objektId) {
	    return window.localStorage.getItem(storagePrefix(objectType, lang, objektId));
	}
	function removeItemFromLocalStorage(objectType, lang, objektId) {
	    window.localStorage.removeItem(storagePrefix(objectType, lang, objektId));
	}


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.capitalizeFirstLetter = capitalizeFirstLetter;
	exports.encodeString = encodeString;
	exports.decodeString = decodeString;
	exports.acronym = acronym;
	exports.abbreviate = abbreviate;
	exports.chunkString = chunkString;
	exports.splitByLastSubstring = splitByLastSubstring;
	exports.splitAndTrim = splitAndTrim;
	var tslib_1 = __webpack_require__(3);
	var textEncoderLite_1 = __webpack_require__(2048);
	var base64_js_1 = tslib_1.__importDefault(__webpack_require__(593));
	function capitalizeFirstLetter(str) {
	    if (str) {
	        return str.charAt(0).toUpperCase() + str.slice(1);
	    }
	    else {
	        return str;
	    }
	}
	function encodeString(str) {
	    var uint8array = (0, textEncoderLite_1.encode)(str);
	    return base64_js_1.default.fromByteArray(uint8array);
	}
	function decodeString(base64String) {
	    var uint8array = base64_js_1.default.toByteArray(base64String);
	    return (0, textEncoderLite_1.decode)(uint8array);
	}
	function acronym(str, maxLength) {
	    if (maxLength === void 0) { maxLength = 0; }
	    var acronym = str.match(/\b(\w)/g).join('');
	    return (maxLength) ? acronym.substr(0, maxLength) : acronym;
	}
	function abbreviate(str, maxLength) {
	    return (str) ? ((str.length > maxLength) ? str.substr(0, maxLength - 1) + '...' : str) : str;
	}
	;
	function chunkString(str, length, pad) {
	    return (str) ? str.match(new RegExp('.{1,' + length + '}', 'g')).join(pad) : str;
	}
	function splitByLastSubstring(src) {
	    if (!src) {
	        return null;
	    }
	    else {
	        var lastIndex = src.lastIndexOf('_');
	        return [src.substr(0, lastIndex), src.substr(lastIndex + 1)];
	    }
	}
	function splitAndTrim(str, splitter) {
	    return (str == null) ? null : str.split(splitter).filter(function (s) { return !!s; }).map(function (s) { return s.trim(); });
	}


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var partyDomain_1 = __webpack_require__(48);
	var mobx_1 = __webpack_require__(5);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var eventDomain_1 = __webpack_require__(74);
	var accountingDomain_1 = __webpack_require__(560);
	var PartyService = /** @class */ (function () {
	    function PartyService() {
	    }
	    PartyService.prototype.readParty = function (partyId) {
	        return axios_config_1.default.get('/party/' + partyId)
	            .then(function (response) { return new partyDomain_1.Party(response.data); });
	    };
	    PartyService.prototype.searchParty = function (email) {
	        return axios_config_1.default.get('/party/party-search', { params: { email: email } })
	            .then(function (response) { return response.data.map(function (json) { return new partyDomain_1.Party(json); }); });
	    };
	    /**
	     * spec :  {ico: 456456}, {birthNumber: 346456456}, {ico: 456456, birthNumber: 346456456}
	     * @param spec
	     * @returns {*}
	       */
	    PartyService.prototype.partyExist = function (spec) {
	        return axios_config_1.default.get('/party/party-exist', { params: spec })
	            .then(function (response) { return response.data; });
	    };
	    PartyService.prototype.partyVatIdExist = function (spec) {
	        return axios_config_1.default.get('/party/party-vatid-exist', { params: spec })
	            .then(function (response) { return response.data; });
	    };
	    PartyService.prototype.partyVatIdDownload = function (spec) {
	        return axios_config_1.default.get('/party/party-vatid-download', { params: spec })
	            .then(function (response) { return response.data; });
	    };
	    PartyService.prototype.partyIdExist = function (spec) {
	        return axios_config_1.default.get('/party/party-id-exist', { params: spec })
	            .then(function (response) { return response.data; });
	    };
	    PartyService.prototype.partyIdDownload = function (spec) {
	        return axios_config_1.default.get('/party/party-id-download', { params: spec })
	            .then(function (response) { return response.data; });
	    };
	    PartyService.prototype.addressParse = function (spec) {
	        return axios_config_1.default.get('/party/address-parse', { params: spec })
	            .then(function (response) { return response.data; });
	    };
	    PartyService.prototype.partySave = function (partyDto) {
	        console.log('partySave %O', partyDto);
	        return axios_config_1.default.post('/party', partyDto, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    PartyService.prototype.deleteParty = function (partyId) {
	        return axios_config_1.default.delete('/party/' + partyId, { showPrettyError: true });
	    };
	    PartyService.prototype.manualCustomerRegistration = function (partyId) {
	        return axios_config_1.default.post('/party/customer-registration/' + partyId, null, { showPrettyError: true })
	            .then(function (response) { return response.data.map(function (json) { return new eventDomain_1.PartyActivity(json); }); });
	    };
	    PartyService.prototype.newRole = function (roleType) {
	        return new partyDomain_1.PartyRole({ roleType: mdEntityService_1.default.getEntity('PartyRoleType').getLovItem(roleType) });
	    };
	    PartyService.prototype.viberUserCheck = function (spec) {
	        return axios_config_1.default.get("/viber/user-check", { params: spec })
	            .then(function (response) { return response.data; });
	    };
	    PartyService.prototype.getViberBotUrl = function () {
	        return axios_config_1.default.get("/viber/bot-url")
	            .then(function (response) { return response.data; });
	    };
	    // ////////// PARTY CREDIT ENTRIES ////////////////////////////////////////////////////////////////////////////////
	    PartyService.prototype.readCreditEntries = function (partyId) {
	        return axios_config_1.default.get('/party/credit-entry', { params: { partyId: partyId } })
	            .then(function (response) { return ({ entries: response.data.entries.map(function (json) { return new accountingDomain_1.PartyCreditEntry(json); }), sums: response.data.sums }); });
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyService.prototype, "partyObject", void 0);
	    return PartyService;
	}());
	exports.default = new PartyService();


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var formUtils_1 = __webpack_require__(14);
	var mobx_1 = __webpack_require__(5);
	var shipmentDomain_1 = __webpack_require__(132);
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var ShipmentService = /** @class */ (function () {
	    function ShipmentService() {
	    }
	    ShipmentService.prototype.readShipment = function (shipmentId, params) {
	        return axios_config_1.default.get('/shipment/' + shipmentId, { params: params })
	            .then(function (response) { return new shipmentDomain_1.Shipment(response.data); });
	    };
	    ShipmentService.prototype.readShipments = function (registrationNumber, shipmentDate, shipmentDateOperator, supplierId, direction, currentShipmentVisit, ignoreVisitOrder) {
	        return ((ignoreVisitOrder) ?
	            axios_config_1.default.get('/shipments', { params: { registrationNumber: registrationNumber, shipmentDate: shipmentDate, shipmentDateOperator: shipmentDateOperator, supplierId: supplierId, direction: direction } })
	            :
	                this.readShipmentVisits(registrationNumber, null, shipmentDate, undefined, undefined, direction, null)
	                    .then(function (visits) {
	                    var olderVisitCount = visits.filter(function (visit) { return visit.shipmentVisitId !== currentShipmentVisit.shipmentVisitId && (0, moment_1.default)(visit.dateCreated).isBefore(currentShipmentVisit.dateCreated); }).length;
	                    console.log("olderVisitCount %s", olderVisitCount);
	                    return axios_config_1.default.get('/shipments', { params: { registrationNumber: registrationNumber, shipmentDate: shipmentDate, shipmentDateOperator: shipmentDateOperator, supplierId: supplierId, direction: direction, visitOrder: olderVisitCount + 1 } });
	                })).then(function (response) { return response.data.map(function (d) { return new shipmentDomain_1.Shipment(d); }).filter(function (sh) { return !sh.shipmentVisit || (0, formUtils_1.lovValue)(sh.shipmentVisit) === currentShipmentVisit.shipmentVisitId; }); });
	    };
	    ShipmentService.prototype.saveShipment = function (shipment) {
	        return axios_config_1.default.post('/shipment', shipment, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    ShipmentService.prototype.deleteShipment = function (shipmentId) {
	        return axios_config_1.default.delete('/shipment/' + shipmentId, { showPrettyError: true });
	    };
	    ShipmentService.prototype.readShipmentRepackaging = function (shipmentRepackagingId, params) {
	        return axios_config_1.default.get('/shipment-repackaging/' + shipmentRepackagingId, { params: params })
	            .then(function (response) { return new shipmentDomain_1.ShipmentRepackaging(response.data); });
	    };
	    ShipmentService.prototype.saveShipmentRepackaging = function (shipmentRepackaging) {
	        return axios_config_1.default.post('/shipment-repackaging', shipmentRepackaging, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    ShipmentService.prototype.deleteShipmentRepackaging = function (shipmentRepackagingId) {
	        return axios_config_1.default.delete('/shipment-repackaging/' + shipmentRepackagingId, { showPrettyError: true });
	    };
	    ShipmentService.prototype.readShipmentRepackagingResource = function (toolbarDate, params) {
	        return axios_config_1.default.get('/shipment-repackaging-resource/' + (0, moment_1.default)(toolbarDate).format("YYYY-MM-DD"), { params: params })
	            .then(function (response) { return new shipmentDomain_1.ShipmentRepackagingResource(response.data); });
	    };
	    ShipmentService.prototype.saveShipmentRepackagingResource = function (shipmentRepackagingResource) {
	        return axios_config_1.default.post('/shipment-repackaging-resource', shipmentRepackagingResource, { showPrettyError: true });
	    };
	    ShipmentService.prototype.readShipmentVisit = function (shipmentVisitId, readShipments) {
	        if (readShipments === void 0) { readShipments = false; }
	        return axios_config_1.default.get('/shipment-visit/' + shipmentVisitId, { params: { readShipments: readShipments } })
	            .then(function (response) { return new shipmentDomain_1.ShipmentVisit(response.data); });
	    };
	    ShipmentService.prototype.readShipmentVisits = function (registrationNumber, visitDate, dateCreated, unassigned, visitEndFilled, direction, step) {
	        return axios_config_1.default.get('/shipment-visits', { params: { registrationNumber: registrationNumber, visitDate: visitDate, dateCreated: dateCreated, unassigned: unassigned, visitEndFilled: visitEndFilled, direction: direction, step: step } })
	            .then(function (response) { return response.data.map(function (d) { return new shipmentDomain_1.ShipmentVisit(d); }); });
	    };
	    ShipmentService.prototype.saveShipmentVisit = function (shipmentVisit, syncRegistrationNumber, syncShipmentStatus, syncShippedFromPlace, gridParams, visitIdsToDelete) {
	        return axios_config_1.default.post('/shipment-visit', shipmentVisit, { showPrettyError: true, params: tslib_1.__assign(tslib_1.__assign({ syncRegistrationNumber: syncRegistrationNumber, syncShipmentStatus: syncShipmentStatus, syncShippedFromPlace: syncShippedFromPlace }, gridParams), { visitIdsToDelete: visitIdsToDelete }) })
	            .then(function (response) { return response.data; });
	    };
	    ShipmentService.prototype.deleteShipmentVisit = function (shipmentVisitId) {
	        return axios_config_1.default.delete('/shipment-visit/' + shipmentVisitId, { showPrettyError: true });
	    };
	    ShipmentService.prototype.computeField = function (fieldName, params) {
	        return axios_config_1.default.get("/shipment/compute", { params: Object.assign({ fieldName: fieldName }, params) })
	            .then(function (response) { return response.data; });
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentService.prototype, "shipmentObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentService.prototype, "shipmentRepackagingObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentService.prototype, "shipmentVisitObject", void 0);
	    return ShipmentService;
	}());
	exports.default = new ShipmentService();


/***/ }),
/* 177 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var es5 = __webpack_require__(196);
	var Objectfreeze = es5.freeze;
	var util = __webpack_require__(73);
	var inherits = util.inherits;
	var notEnumerableProp = util.notEnumerableProp;
	
	function subError(nameProperty, defaultMessage) {
	    function SubError(message) {
	        if (!(this instanceof SubError)) return new SubError(message);
	        notEnumerableProp(this, "message",
	            typeof message === "string" ? message : defaultMessage);
	        notEnumerableProp(this, "name", nameProperty);
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            Error.call(this);
	        }
	    }
	    inherits(SubError, Error);
	    return SubError;
	}
	
	var _TypeError, _RangeError;
	var Warning = subError("Warning", "warning");
	var CancellationError = subError("CancellationError", "cancellation error");
	var TimeoutError = subError("TimeoutError", "timeout error");
	var AggregateError = subError("AggregateError", "aggregate error");
	try {
	    _TypeError = TypeError;
	    _RangeError = RangeError;
	} catch(e) {
	    _TypeError = subError("TypeError", "type error");
	    _RangeError = subError("RangeError", "range error");
	}
	
	var methods = ("join pop push shift unshift slice filter forEach some " +
	    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
	
	for (var i = 0; i < methods.length; ++i) {
	    if (typeof Array.prototype[methods[i]] === "function") {
	        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
	    }
	}
	
	es5.defineProperty(AggregateError.prototype, "length", {
	    value: 0,
	    configurable: false,
	    writable: true,
	    enumerable: true
	});
	AggregateError.prototype["isOperational"] = true;
	var level = 0;
	AggregateError.prototype.toString = function() {
	    var indent = Array(level * 4 + 1).join(" ");
	    var ret = "\n" + indent + "AggregateError of:" + "\n";
	    level++;
	    indent = Array(level * 4 + 1).join(" ");
	    for (var i = 0; i < this.length; ++i) {
	        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
	        var lines = str.split("\n");
	        for (var j = 0; j < lines.length; ++j) {
	            lines[j] = indent + lines[j];
	        }
	        str = lines.join("\n");
	        ret += str + "\n";
	    }
	    level--;
	    return ret;
	};
	
	function OperationalError(message) {
	    if (!(this instanceof OperationalError))
	        return new OperationalError(message);
	    notEnumerableProp(this, "name", "OperationalError");
	    notEnumerableProp(this, "message", message);
	    this.cause = message;
	    this["isOperational"] = true;
	
	    if (message instanceof Error) {
	        notEnumerableProp(this, "message", message.message);
	        notEnumerableProp(this, "stack", message.stack);
	    } else if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, this.constructor);
	    }
	
	}
	inherits(OperationalError, Error);
	
	var errorTypes = Error["__BluebirdErrorTypes__"];
	if (!errorTypes) {
	    errorTypes = Objectfreeze({
	        CancellationError: CancellationError,
	        TimeoutError: TimeoutError,
	        OperationalError: OperationalError,
	        RejectionError: OperationalError,
	        AggregateError: AggregateError
	    });
	    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
	        value: errorTypes,
	        writable: false,
	        enumerable: false,
	        configurable: false
	    });
	}
	
	module.exports = {
	    Error: Error,
	    TypeError: _TypeError,
	    RangeError: _RangeError,
	    CancellationError: errorTypes.CancellationError,
	    OperationalError: errorTypes.OperationalError,
	    TimeoutError: errorTypes.TimeoutError,
	    AggregateError: errorTypes.AggregateError,
	    Warning: Warning
	};


/***/ }),
/* 179 */
149,
/* 180 */
[2342, 197, 599, 423, 160],
/* 181 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 182 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftFeatureFlags
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftFeatureFlags = __webpack_require__(1220);
	
	module.exports = DraftFeatureFlags;

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(55),
	    isLength = __webpack_require__(481);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TextField = __webpack_require__(1551);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextField2.default;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertColorToString = convertColorToString;
	exports.convertHexToRGB = convertHexToRGB;
	exports.decomposeColor = decomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value, min, max) {
	  if (value < min) {
	    return min;
	  }
	  if (value > max) {
	    return max;
	  }
	  return value;
	}
	
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	function convertColorToString(color) {
	  var type = color.type,
	      values = color.values;
	
	
	  if (type.indexOf('rgb') > -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    for (var i = 0; i < 3; i++) {
	      values[i] = parseInt(values[i]);
	    }
	  }
	
	  var colorString = void 0;
	
	  if (type.indexOf('hsl') > -1) {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
	  } else {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
	  }
	
	  if (values.length === 4) {
	    colorString += ', ' + color.values[3] + ')';
	  } else {
	    colorString += ')';
	  }
	
	  return colorString;
	}
	
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 *  @returns {string} A CSS rgb color string
	 */
	function convertHexToRGB(color) {
	  if (color.length === 4) {
	    var extendedColor = '#';
	    for (var i = 1; i < color.length; i++) {
	      extendedColor += color.charAt(i) + color.charAt(i);
	    }
	    color = extendedColor;
	  }
	
	  var values = {
	    r: parseInt(color.substr(1, 2), 16),
	    g: parseInt(color.substr(3, 2), 16),
	    b: parseInt(color.substr(5, 2), 16)
	  };
	
	  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
	}
	
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values and color names.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {{type: string, values: number[]}} A MUI color object
	 */
	function decomposeColor(color) {
	  if (color.charAt(0) === '#') {
	    return decomposeColor(convertHexToRGB(color));
	  }
	
	  var marker = color.indexOf('(');
	
	   false ? (0, _warning2.default)(marker !== -1, 'Material-UI: The ' + color + ' color was not parsed correctly,\n  because it has an unsupported format (color name or RGB %). This may cause issues in component rendering.') : void 0;
	
	  var type = color.substring(0, marker);
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	
	  return { type: type, values: values };
	}
	
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
	 */
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	
	  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
	}
	
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	function getLuminance(color) {
	  color = decomposeColor(color);
	
	  if (color.type.indexOf('rgb') > -1) {
	    var rgb = color.values.map(function (val) {
	      val /= 255; // normalized
	      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	    });
	    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
	  } else if (color.type.indexOf('hsl') > -1) {
	    return color.values[2] / 100;
	  }
	}
	
	/**
	 * Darken or lighten a colour, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function emphasize(color) {
	  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
	
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function fade(color, value) {
	  color = decomposeColor(color);
	  value = clamp(value, 0, 1);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	  color.values[3] = value;
	
	  return convertColorToString(color);
	}
	
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function darken(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	  return convertColorToString(color);
	}
	
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function lighten(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return convertColorToString(color);
	}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _dateArithmetic = __webpack_require__(1155);
	
	var _dateArithmetic2 = _interopRequireDefault(_dateArithmetic);
	
	var _constants = __webpack_require__(539);
	
	var _localizers = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dates = _extends({}, _dateArithmetic2.default, {
	  parse: function parse(date, format, culture) {
	    return _localizers.date.parse(date, format, culture);
	  },
	  format: function format(date, _format, culture) {
	    return _localizers.date.format(date, _format, culture);
	  },
	  monthsInYear: function monthsInYear(year) {
	    var months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
	        date = new Date(year, 0, 1);
	
	    return months.map(function (i) {
	      return dates.month(date, i);
	    });
	  },
	  firstVisibleDay: function firstVisibleDay(date, culture) {
	    var firstOfMonth = dates.startOf(date, 'month');
	    return dates.startOf(firstOfMonth, 'week', _localizers.date.startOfWeek(culture));
	  },
	  lastVisibleDay: function lastVisibleDay(date, culture) {
	    var endOfMonth = dates.endOf(date, 'month');
	
	    return dates.endOf(endOfMonth, 'week', _localizers.date.startOfWeek(culture));
	  },
	  visibleDays: function visibleDays(date, culture) {
	    var current = dates.firstVisibleDay(date, culture),
	        last = dates.lastVisibleDay(date, culture),
	        days = [];
	
	    while (dates.lte(current, last, 'day')) {
	      days.push(current);
	      current = dates.add(current, 1, 'day');
	    }
	
	    return days;
	  },
	  move: function move(date, min, max, unit, direction) {
	    var isMonth = unit === 'month',
	        isUpOrDown = direction === _constants.directions.UP || direction === _constants.directions.DOWN,
	        rangeUnit = _constants.calendarViewUnits[unit],
	        addUnit = isMonth && isUpOrDown ? 'week' : _constants.calendarViewUnits[unit],
	        amount = isMonth || !isUpOrDown ? 1 : 4,
	        newDate;
	
	    if (direction === _constants.directions.UP || direction === _constants.directions.LEFT) amount *= -1;
	
	    newDate = dates.add(date, amount, addUnit);
	
	    return dates.inRange(newDate, min, max, rangeUnit) ? newDate : date;
	  },
	  merge: function merge(date, time, defaultDate) {
	    if (time == null && date == null) return null;
	
	    if (time == null) time = defaultDate || new Date();
	    if (date == null) date = defaultDate || new Date();
	
	    date = dates.startOf(date, 'day');
	    date = dates.hours(date, dates.hours(time));
	    date = dates.minutes(date, dates.minutes(time));
	    date = dates.seconds(date, dates.seconds(time));
	    return dates.milliseconds(date, dates.milliseconds(time));
	  },
	  sameMonth: function sameMonth(dateA, dateB) {
	    return dates.eq(dateA, dateB, 'month');
	  },
	  today: function today() {
	    return this.startOf(new Date(), 'day');
	  },
	  yesterday: function yesterday() {
	    return this.add(this.startOf(new Date(), 'day'), -1, 'day');
	  },
	  tomorrow: function tomorrow() {
	    return this.add(this.startOf(new Date(), 'day'), 1, 'day');
	  }
	});
	
	exports.default = dates;
	module.exports = exports['default'];

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.notify = notify;
	exports.instanceId = instanceId;
	exports.isFirstFocusedRender = isFirstFocusedRender;
	
	var _ = __webpack_require__(93);
	
	function notify(handler, args) {
	  handler && handler.apply(null, [].concat(args));
	}
	
	function instanceId(component) {
	  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  component.__id || (component.__id = (0, _.uniqueId)('rw_'));
	  return (component.props.id || component.__id) + suffix;
	}
	
	function isFirstFocusedRender(component) {
	  return component._firstFocus || component.state.focused && (component._firstFocus = true);
	}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(100));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(115));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _Text = _interopRequireDefault(__webpack_require__(217));
	
	var _ReactUtils = __webpack_require__(43);
	
	var _DataUtils = __webpack_require__(66);
	
	var _PolarUtils = __webpack_require__(142);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var cartesianViewBoxShape = _propTypes["default"].shape({
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number
	});
	
	var polarViewBoxShape = _propTypes["default"].shape({
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  innerRadius: _propTypes["default"].number,
	  outerRadius: _propTypes["default"].number,
	  startAngle: _propTypes["default"].number,
	  endAngle: _propTypes["default"].number
	});
	
	var propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes["default"].oneOfType([cartesianViewBoxShape, polarViewBoxShape]),
	  formatter: _propTypes["default"].func,
	  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  offset: _propTypes["default"].number,
	  position: _propTypes["default"].oneOf(['top', 'left', 'right', 'bottom', 'inside', 'outside', 'insideLeft', 'insideRight', 'insideTop', 'insideBottom', 'insideTopLeft', 'insideBottomLeft', 'insideTopRight', 'insideBottomRight', 'insideStart', 'insideEnd', 'end', 'center', 'centerTop', 'centerBottom']),
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
	  className: _propTypes["default"].string,
	  content: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func])
	});
	
	var defaultProps = {
	  offset: 5
	};
	
	var getLabel = function getLabel(props) {
	  var value = props.value,
	      formatter = props.formatter;
	  var label = (0, _isNil2["default"])(props.children) ? value : props.children;
	
	  if ((0, _isFunction2["default"])(formatter)) {
	    return formatter(label);
	  }
	
	  return label;
	};
	
	var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	  return sign * deltaAngle;
	};
	
	var renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
	  var position = labelProps.position,
	      viewBox = labelProps.viewBox,
	      offset = labelProps.offset,
	      className = labelProps.className;
	  var cx = viewBox.cx,
	      cy = viewBox.cy,
	      innerRadius = viewBox.innerRadius,
	      outerRadius = viewBox.outerRadius,
	      startAngle = viewBox.startAngle,
	      endAngle = viewBox.endAngle,
	      clockWise = viewBox.clockWise;
	  var radius = (innerRadius + outerRadius) / 2;
	  var deltaAngle = getDeltaAngle(startAngle, endAngle);
	  var sign = deltaAngle >= 0 ? 1 : -1;
	  var labelAngle, direction;
	
	  if (position === 'insideStart') {
	    labelAngle = startAngle + sign * offset;
	    direction = clockWise;
	  } else if (position === 'insideEnd') {
	    labelAngle = endAngle - sign * offset;
	    direction = !clockWise;
	  } else if (position === 'end') {
	    labelAngle = endAngle + sign * offset;
	    direction = clockWise;
	  }
	
	  direction = deltaAngle <= 0 ? direction : !direction;
	  var startPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, labelAngle);
	  var endPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
	  var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
	  var id = (0, _isNil2["default"])(labelProps.id) ? (0, _DataUtils.uniqueId)('recharts-radial-line-') : labelProps.id;
	  return _react["default"].createElement("text", _extends({}, attrs, {
	    dominantBaseline: "central",
	    className: (0, _classnames["default"])('recharts-radial-bar-label', className)
	  }), _react["default"].createElement("defs", null, _react["default"].createElement("path", {
	    id: id,
	    d: path
	  })), _react["default"].createElement("textPath", {
	    xlinkHref: "#".concat(id)
	  }, label));
	};
	
	var getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
	  var viewBox = props.viewBox,
	      offset = props.offset,
	      position = props.position;
	  var cx = viewBox.cx,
	      cy = viewBox.cy,
	      innerRadius = viewBox.innerRadius,
	      outerRadius = viewBox.outerRadius,
	      startAngle = viewBox.startAngle,
	      endAngle = viewBox.endAngle;
	  var midAngle = (startAngle + endAngle) / 2;
	
	  if (position === 'outside') {
	    var _polarToCartesian = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius + offset, midAngle),
	        _x = _polarToCartesian.x,
	        _y = _polarToCartesian.y;
	
	    return {
	      x: _x,
	      y: _y,
	      textAnchor: _x >= cx ? 'start' : 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'center') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'centerTop') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'centerBottom') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'end'
	    };
	  }
	
	  var r = (innerRadius + outerRadius) / 2;
	
	  var _polarToCartesian2 = (0, _PolarUtils.polarToCartesian)(cx, cy, r, midAngle),
	      x = _polarToCartesian2.x,
	      y = _polarToCartesian2.y;
	
	  return {
	    x: x,
	    y: y,
	    textAnchor: 'middle',
	    verticalAnchor: 'middle'
	  };
	};
	
	var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
	  var viewBox = props.viewBox,
	      offset = props.offset,
	      position = props.position;
	  var x = viewBox.x,
	      y = viewBox.y,
	      width = viewBox.width,
	      height = viewBox.height;
	  var sign = height >= 0 ? 1 : -1;
	
	  if (position === 'top') {
	    return {
	      x: x + width / 2,
	      y: y - sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: sign > 0 ? 'end' : 'start'
	    };
	  }
	
	  if (position === 'bottom') {
	    return {
	      x: x + width / 2,
	      y: y + height + sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'left') {
	    return {
	      x: x - offset,
	      y: y + height / 2,
	      textAnchor: 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'right') {
	    return {
	      x: x + width + offset,
	      y: y + height / 2,
	      textAnchor: 'start',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideLeft') {
	    return {
	      x: x + offset,
	      y: y + height / 2,
	      textAnchor: 'start',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideRight') {
	    return {
	      x: x + width - offset,
	      y: y + height / 2,
	      textAnchor: 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideTop') {
	    return {
	      x: x + width / 2,
	      y: y + sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideBottom') {
	    return {
	      x: x + width / 2,
	      y: y + height - sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if (position === 'insideTopLeft') {
	    return {
	      x: x + offset,
	      y: y + sign * offset,
	      textAnchor: 'start',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideTopRight') {
	    return {
	      x: x + width - offset,
	      y: y + sign * offset,
	      textAnchor: 'end',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideBottomLeft') {
	    return {
	      x: x + offset,
	      y: y + height - sign * offset,
	      textAnchor: 'start',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if (position === 'insideBottomRight') {
	    return {
	      x: x + width - offset,
	      y: y + height - sign * offset,
	      textAnchor: 'end',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if ((0, _isObject2["default"])(position) && ((0, _DataUtils.isNumber)(position.x) || (0, _DataUtils.isPercent)(position.x)) && ((0, _DataUtils.isNumber)(position.y) || (0, _DataUtils.isPercent)(position.y))) {
	    return {
	      x: x + (0, _DataUtils.getPercentValue)(position.x, width),
	      y: y + (0, _DataUtils.getPercentValue)(position.y, height),
	      textAnchor: 'end',
	      verticalAnchor: 'end'
	    };
	  }
	
	  return {
	    x: x + width / 2,
	    y: y + height / 2,
	    textAnchor: 'middle',
	    verticalAnchor: 'middle'
	  };
	};
	
	var isPolar = function isPolar(viewBox) {
	  return (0, _DataUtils.isNumber)(viewBox.cx);
	};
	
	function Label(props) {
	  var viewBox = props.viewBox,
	      position = props.position,
	      value = props.value,
	      children = props.children,
	      content = props.content,
	      _props$className = props.className,
	      className = _props$className === void 0 ? '' : _props$className;
	
	  if (!viewBox || (0, _isNil2["default"])(value) && (0, _isNil2["default"])(children) && !(0, _react.isValidElement)(content) && !(0, _isFunction2["default"])(content)) {
	    return null;
	  }
	
	  if ((0, _react.isValidElement)(content)) {
	    return (0, _react.cloneElement)(content, props);
	  }
	
	  var label;
	
	  if ((0, _isFunction2["default"])(content)) {
	    label = content(props);
	
	    if ((0, _react.isValidElement)(label)) {
	      return label;
	    }
	  } else {
	    label = getLabel(props);
	  }
	
	  var isPolarLabel = isPolar(viewBox);
	  var attrs = (0, _ReactUtils.getPresentationAttributes)(props);
	  var events = (0, _ReactUtils.filterEventAttributes)(props);
	
	  if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) {
	    return renderRadialLabel(props, label, attrs);
	  }
	
	  var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
	  return _react["default"].createElement(_Text["default"], _extends({
	    className: (0, _classnames["default"])('recharts-label', className)
	  }, attrs, positionAttrs, events), label);
	}
	
	Label.displayName = 'Label';
	Label.defaultProps = defaultProps;
	Label.propTypes = propTypes;
	
	var parseViewBox = function parseViewBox(props) {
	  var cx = props.cx,
	      cy = props.cy,
	      angle = props.angle,
	      startAngle = props.startAngle,
	      endAngle = props.endAngle,
	      r = props.r,
	      radius = props.radius,
	      innerRadius = props.innerRadius,
	      outerRadius = props.outerRadius,
	      x = props.x,
	      y = props.y,
	      top = props.top,
	      left = props.left,
	      width = props.width,
	      height = props.height,
	      clockWise = props.clockWise;
	
	  if ((0, _DataUtils.isNumber)(width) && (0, _DataUtils.isNumber)(height)) {
	    if ((0, _DataUtils.isNumber)(x) && (0, _DataUtils.isNumber)(y)) {
	      return {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      };
	    }
	
	    if ((0, _DataUtils.isNumber)(top) && (0, _DataUtils.isNumber)(left)) {
	      return {
	        x: top,
	        y: left,
	        width: width,
	        height: height
	      };
	    }
	  }
	
	  if ((0, _DataUtils.isNumber)(x) && (0, _DataUtils.isNumber)(y)) {
	    return {
	      x: x,
	      y: y,
	      width: 0,
	      height: 0
	    };
	  }
	
	  if ((0, _DataUtils.isNumber)(cx) && (0, _DataUtils.isNumber)(cy)) {
	    return {
	      cx: cx,
	      cy: cy,
	      startAngle: startAngle || angle || 0,
	      endAngle: endAngle || angle || 0,
	      innerRadius: innerRadius || 0,
	      outerRadius: outerRadius || radius || r || 0,
	      clockWise: clockWise
	    };
	  }
	
	  if (props.viewBox) {
	    return props.viewBox;
	  }
	
	  return {};
	};
	
	var parseLabel = function parseLabel(label, viewBox) {
	  if (!label) {
	    return null;
	  }
	
	  if (label === true) {
	    return _react["default"].createElement(Label, {
	      key: "label-implicit",
	      viewBox: viewBox
	    });
	  }
	
	  if ((0, _DataUtils.isNumOrStr)(label)) {
	    return _react["default"].createElement(Label, {
	      key: "label-implicit",
	      viewBox: viewBox,
	      value: label
	    });
	  }
	
	  if ((0, _react.isValidElement)(label)) {
	    if (label.type === Label) {
	      return (0, _react.cloneElement)(label, {
	        key: 'label-implicit',
	        viewBox: viewBox
	      });
	    }
	
	    return _react["default"].createElement(Label, {
	      key: "label-implicit",
	      content: label,
	      viewBox: viewBox
	    });
	  }
	
	  if ((0, _isFunction2["default"])(label)) {
	    return _react["default"].createElement(Label, {
	      key: "label-implicit",
	      content: label,
	      viewBox: viewBox
	    });
	  }
	
	  if ((0, _isObject2["default"])(label)) {
	    return _react["default"].createElement(Label, _extends({
	      viewBox: viewBox
	    }, label, {
	      key: "label-implicit"
	    }));
	  }
	
	  return null;
	};
	
	var renderCallByParent = function renderCallByParent(parentProps, viewBox) {
	  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
	    return null;
	  }
	
	  var children = parentProps.children;
	  var parentViewBox = parseViewBox(parentProps);
	  var explicitChilren = (0, _ReactUtils.findAllByType)(children, Label).map(function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      viewBox: viewBox || parentViewBox,
	      key: "label-".concat(index)
	    });
	  });
	
	  if (!ckeckPropsLabel) {
	    return explicitChilren;
	  }
	
	  var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
	  return [implicitLabel].concat(_toConsumableArray(explicitChilren));
	};
	
	Label.parseViewBox = parseViewBox;
	Label.renderCallByParent = renderCallByParent;
	var _default = Label;
	exports["default"] = _default;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LabeledScaleHelper = exports.ScaleHelper = exports.rectWithCoords = exports.rectWithPoints = exports.formatAxisMap = void 0;
	
	var _every2 = _interopRequireDefault(__webpack_require__(721));
	
	var _mapValues2 = _interopRequireDefault(__webpack_require__(1479));
	
	var _ChartUtils = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Calculate the scale function, position, width, height of axes
	 * @param  {Object} props     Latest props
	 * @param  {Object} axisMap   The configuration of axes
	 * @param  {Object} offset    The offset of main part in the svg element
	 * @param  {String} axisType  The type of axes, x-axis or y-axis
	 * @param  {String} chartName The name of chart
	 * @return {Object} Configuration
	 */
	var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
	  var width = props.width,
	      height = props.height,
	      layout = props.layout;
	  var ids = Object.keys(axisMap);
	  var steps = {
	    left: offset.left,
	    leftMirror: offset.left,
	    right: width - offset.right,
	    rightMirror: width - offset.right,
	    top: offset.top,
	    topMirror: offset.top,
	    bottom: height - offset.bottom,
	    bottomMirror: height - offset.bottom
	  };
	  return ids.reduce(function (result, id) {
	    var axis = axisMap[id];
	    var orientation = axis.orientation,
	        domain = axis.domain,
	        _axis$padding = axis.padding,
	        padding = _axis$padding === void 0 ? {} : _axis$padding,
	        mirror = axis.mirror,
	        reversed = axis.reversed;
	    var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
	    var range, x, y, needSpace;
	
	    if (axisType === 'xAxis') {
	      range = [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)];
	    } else if (axisType === 'yAxis') {
	      range = layout === 'horizontal' ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)] : [offset.top + (padding.top || 0), offset.top + offset.height - (padding.bottom || 0)];
	    } else {
	      range = axis.range;
	    }
	
	    if (reversed) {
	      range = [range[1], range[0]];
	    }
	
	    var _parseScale = (0, _ChartUtils.parseScale)(axis, chartName),
	        scale = _parseScale.scale,
	        realScaleType = _parseScale.realScaleType;
	
	    scale.domain(domain).range(range);
	    (0, _ChartUtils.checkDomainOfScale)(scale);
	    var ticks = (0, _ChartUtils.getTicksOfScale)(scale, _objectSpread({}, axis, {
	      realScaleType: realScaleType
	    }));
	
	    if (axisType === 'xAxis') {
	      needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	      x = offset.left;
	      y = steps[offsetKey] - needSpace * axis.height;
	    } else if (axisType === 'yAxis') {
	      needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	      x = steps[offsetKey] - needSpace * axis.width;
	      y = offset.top;
	    }
	
	    var finalAxis = _objectSpread({}, axis, {}, ticks, {
	      realScaleType: realScaleType,
	      x: x,
	      y: y,
	      scale: scale,
	      width: axisType === 'xAxis' ? offset.width : axis.width,
	      height: axisType === 'yAxis' ? offset.height : axis.height
	    });
	
	    finalAxis.bandSize = (0, _ChartUtils.getBandSizeOfAxis)(finalAxis, ticks);
	
	    if (!axis.hide && axisType === 'xAxis') {
	      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
	    } else if (!axis.hide) {
	      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, id, finalAxis));
	  }, {});
	};
	
	exports.formatAxisMap = formatAxisMap;
	
	var rectWithPoints = function rectWithPoints(_ref, _ref2) {
	  var x1 = _ref.x,
	      y1 = _ref.y;
	  var x2 = _ref2.x,
	      y2 = _ref2.y;
	  return {
	    x: Math.min(x1, x2),
	    y: Math.min(y1, y2),
	    width: Math.abs(x2 - x1),
	    height: Math.abs(y2 - y1)
	  };
	};
	/**
	 * Compute the x, y, width, and height of a box from two reference points.
	 * @param  {Object} coords     x1, x2, y1, and y2
	 * @return {Object} object
	 */
	
	
	exports.rectWithPoints = rectWithPoints;
	
	var rectWithCoords = function rectWithCoords(_ref3) {
	  var x1 = _ref3.x1,
	      y1 = _ref3.y1,
	      x2 = _ref3.x2,
	      y2 = _ref3.y2;
	  return rectWithPoints({
	    x: x1,
	    y: y1
	  }, {
	    x: x2,
	    y: y2
	  });
	};
	
	exports.rectWithCoords = rectWithCoords;
	
	var ScaleHelper =
	/*#__PURE__*/
	function () {
	  _createClass(ScaleHelper, null, [{
	    key: "create",
	    value: function create(obj) {
	      return new ScaleHelper(obj);
	    }
	  }]);
	
	  function ScaleHelper(scale) {
	    _classCallCheck(this, ScaleHelper);
	
	    this.scale = scale;
	  }
	
	  _createClass(ScaleHelper, [{
	    key: "apply",
	    value: function apply(value) {
	      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          bandAware = _ref4.bandAware,
	          position = _ref4.position;
	
	      if (value === undefined) {
	        return undefined;
	      }
	
	      if (position) {
	        switch (position) {
	          case 'start':
	            {
	              return this.scale(value);
	            }
	
	          case 'middle':
	            {
	              var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
	              return this.scale(value) + offset;
	            }
	
	          case 'end':
	            {
	              var _offset = this.bandwidth ? this.bandwidth() : 0;
	
	              return this.scale(value) + _offset;
	            }
	
	          default:
	            {
	              return this.scale(value);
	            }
	        }
	      }
	
	      if (bandAware) {
	        var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
	
	        return this.scale(value) + _offset2;
	      }
	
	      return this.scale(value);
	    }
	  }, {
	    key: "isInRange",
	    value: function isInRange(value) {
	      var range = this.range();
	      var first = range[0];
	      var last = range[range.length - 1];
	      return first <= last ? value >= first && value <= last : value >= last && value <= first;
	    }
	  }, {
	    key: "domain",
	    get: function get() {
	      return this.scale.domain;
	    }
	  }, {
	    key: "range",
	    get: function get() {
	      return this.scale.range;
	    }
	  }, {
	    key: "rangeMin",
	    get: function get() {
	      return this.range()[0];
	    }
	  }, {
	    key: "rangeMax",
	    get: function get() {
	      return this.range()[1];
	    }
	  }, {
	    key: "bandwidth",
	    get: function get() {
	      return this.scale.bandwidth;
	    }
	  }]);
	
	  return ScaleHelper;
	}();
	
	exports.ScaleHelper = ScaleHelper;
	ScaleHelper.EPS = 1e-4;
	
	var LabeledScaleHelper =
	/*#__PURE__*/
	function () {
	  _createClass(LabeledScaleHelper, null, [{
	    key: "create",
	    value: function create(obj) {
	      return new this(obj);
	    }
	  }]);
	
	  function LabeledScaleHelper(scales) {
	    _classCallCheck(this, LabeledScaleHelper);
	
	    this.scales = (0, _mapValues2["default"])(scales, ScaleHelper.create);
	    Object.assign(this, this.scales);
	  }
	
	  _createClass(LabeledScaleHelper, [{
	    key: "apply",
	    value: function apply(coords) {
	      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          bandAware = _ref5.bandAware;
	
	      var scales = this.scales;
	      return (0, _mapValues2["default"])(coords, function (value, label) {
	        return scales[label].apply(value, {
	          bandAware: bandAware
	        });
	      });
	    }
	  }, {
	    key: "isInRange",
	    value: function isInRange(coords) {
	      var scales = this.scales;
	      return (0, _every2["default"])(coords, function (value, label) {
	        return scales[label].isInRange(value);
	      });
	    }
	  }]);
	
	  return LabeledScaleHelper;
	}();
	
	exports.LabeledScaleHelper = LabeledScaleHelper;

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	// CommonJS / Node have global context exposed as "global" variable.
	// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
	// the global "global" var for now.
	var __window = typeof window !== 'undefined' && window;
	var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
	    self instanceof WorkerGlobalScope && self;
	var __global = typeof global !== 'undefined' && global;
	var _root = __window || __global || __self;
	exports.root = _root;
	// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
	// This is needed when used with angular/tsickle which inserts a goog.module statement.
	// Wrap in IIFE
	(function () {
	    if (!_root) {
	        throw new Error('RxJS could not find any global context (window, self, global)');
	    }
	})();
	//# sourceMappingURL=root.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.stringify = stringify;
	exports.addReferences = addReferences;
	exports.isLovValueObjectOnly = isLovValueObjectOnly;
	exports.walk = walk;
	exports.callOnObjectOrArray = callOnObjectOrArray;
	exports.cloneDeep = cloneDeep;
	exports.getDescendantProp = getDescendantProp;
	exports.createIfAbsent = createIfAbsent;
	var cloneDeepWith = __webpack_require__(1465);
	var mobx_1 = __webpack_require__(5);
	function stringify(data) {
	    return JSON.stringify(data, function (key, value) {
	        return (key.startsWith('$')) ? undefined : value;
	    });
	}
	function addReference(root, object, level) {
	    console.debug('addReference object = %o, level = %s', object, level);
	    for (var i in object) {
	        if (object.hasOwnProperty(i)) {
	            var subObject = object[i];
	            if (subObject !== null && typeof (subObject) == "object") {
	                if ((0, mobx_1.isArrayLike)(subObject)) {
	                    for (var _i = 0, subObject_1 = subObject; _i < subObject_1.length; _i++) { // item has type of {}
	                        var item = subObject_1[_i];
	                        var itemAny = item;
	                        addReference(root, itemAny, level + 1);
	                        itemAny.$parentArray = subObject;
	                        itemAny.$parentObject = object;
	                        itemAny.$rootObject = root;
	                    }
	                }
	                else {
	                    addReference(root, subObject, level + 1);
	                    subObject.$parentObject = object;
	                    subObject.$rootObject = root;
	                }
	            }
	        }
	    }
	}
	function addReferences(dataObject) {
	    addReference(dataObject, dataObject, 0);
	    dataObject.$rootObject = dataObject;
	    return dataObject;
	}
	function isLovValueObjectOnly(object) {
	    var keyCount = Object.keys(object).length;
	    return object.hasOwnProperty("value") && object.hasOwnProperty("label") && (keyCount === 2 || (keyCount === 3 && object.hasOwnProperty("params")));
	}
	/**
	 * Zavola funkci fn(object, level) na dodany object a potom projde vsechny properties objectu a pokud je to object zavola rekurzivne walk(), totez pro kazdy prvek pokud je to array
	 * @param object
	 * @param level
	 * @param fn
	 */
	function walk(object, fn) {
	    var visited = new Set();
	    walkInner(object, 0, 'ROOT', fn, visited);
	}
	function walkInner(object, level, keyName, fn, visited) {
	    console.debug('%s. walk %s = %O', level, keyName, object);
	    if (visited.has(object))
	        return;
	    visited.add(object);
	    fn(object, level);
	    for (var key in object) {
	        if (object.hasOwnProperty(key) && !key.startsWith('$')) {
	            var subObject = object[key];
	            if (subObject !== null && typeof (subObject) == "object") {
	                if ((0, mobx_1.isArrayLike)(subObject)) {
	                    for (var i = 0, len = subObject.length; i < len; i++) {
	                        var subObjectElement = subObject[i];
	                        if (subObjectElement)
	                            walkInner(subObjectElement, level + 1, key + '[' + i + ']', fn, visited);
	                    }
	                }
	                else if (subObject instanceof mobx_1.ObservableMap) {
	                    var omapValues = subObject.values();
	                    for (var i = 0, len = omapValues.length; i < len; i++) {
	                        var omapValue = omapValues[i];
	                        if (omapValue)
	                            walkInner(omapValue, level + 1, key + '[' + i + ']', fn, visited);
	                    }
	                }
	                else {
	                    // vyloucime lovValues objekty
	                    if (subObject && !isLovValueObjectOnly(subObject)) {
	                        walkInner(subObject, level + 1, key, fn, visited);
	                    }
	                }
	            }
	        }
	    }
	}
	/**
	 * Zavola funkci fn(object) na dodany object (pokud object neni null), ale pokud je dodany objekt array zavola funkci pro kazdy prvek pole
	 * @param object
	 * @param fn
	 */
	function callOnObjectOrArray(object, fn) {
	    if (object) {
	        if ((0, mobx_1.isArrayLike)(object)) {
	            for (var _i = 0, object_1 = object; _i < object_1.length; _i++) {
	                var item = object_1[_i];
	                fn(item);
	            }
	        }
	        else {
	            fn(object);
	        }
	    }
	}
	/**
	 * zavola lodash cloneDeep, ale pomoci customizeru neklonuje properties zacinajici na $
	 * @param object
	 * @returns {*}
	 */
	function cloneDeep(object) {
	    return cloneDeepWith(object, function (value, key) {
	        if (key && key.startsWith && key.startsWith('$')) {
	            return value;
	        }
	    });
	}
	function getDescendantProp(objectLiteral, dottedKey) {
	    if (objectLiteral[dottedKey]) {
	        return objectLiteral[dottedKey];
	    }
	    var msg = dottedKey.split(".").reduce(function (a, b) {
	        return (a != undefined) ? a[b] : a;
	    }, objectLiteral);
	    return msg;
	}
	/**
	 * Returns value V of property with key _key_ from object _object_  <br>
	 * If property does not exists it is created with function fn: (k: string) => V
	 * @param object
	 * @param key
	 * @param fn
	 */
	function createIfAbsent(object, key, fn) {
	    var value = object[key];
	    if (value === undefined) {
	        value = fn(key);
	        object[key] = value;
	    }
	    return value;
	}


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mdField_1 = tslib_1.__importStar(__webpack_require__(57));
	var grid_1 = __webpack_require__(50);
	var mobx_1 = __webpack_require__(5);
	var DomainAncestor_1 = __webpack_require__(33);
	var formUtils_1 = __webpack_require__(14);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var gridConfig_1 = tslib_1.__importDefault(__webpack_require__(264));
	var GridConfigCondition = /** @class */ (function (_super) {
	    tslib_1.__extends(GridConfigCondition, _super);
	    function GridConfigCondition(entitySource, json) {
	        var _this = _super.call(this, json) || this;
	        _this.$entitySource = entitySource;
	        if (_this.field)
	            _this.field = (entitySource && _this.field.fieldType !== mdField_1.FIELDTYPE.SQLRESULT) ? entitySource.getEntityRef().getField(_this.field.fieldName) : new mdField_1.default(_this.field);
	        return _this;
	    }
	    GridConfigCondition_1 = GridConfigCondition;
	    GridConfigCondition.prototype.getId = function () {
	        return this.field.fieldKey;
	    };
	    GridConfigCondition.prototype.setId = function (id) {
	    };
	    Object.defineProperty(GridConfigCondition.prototype, "columnName", {
	        get: function () {
	            return (this.field) ? this.field.fieldName : undefined;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(GridConfigCondition.prototype, "fieldKey", {
	        get: function () {
	            return (this.field) ? this.field.fieldKey : undefined;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    GridConfigCondition.prototype.getEntityRef = function () {
	        return this.$entitySource.getEntityRef();
	    };
	    GridConfigCondition.prototype.clone = function () {
	        var newGcc = new GridConfigCondition_1(this.$entitySource, this);
	        if (this.values)
	            newGcc.values = this.values.slice(0);
	        return newGcc;
	    };
	    GridConfigCondition.prototype.convertToLov = function () {
	        if (this.values && this.values.length && this.field.valueSourceType === mdField_1.VALUESOURCETYPE.LOCAL) {
	            var valueSource_1 = mdEntityService_1.default.getEntity(this.field.valueSource);
	            this.values = this.values.map(function (v) { return (0, formUtils_1.replaceIdWithLov)(v, valueSource_1); });
	        }
	    };
	    Object.defineProperty(GridConfigCondition.prototype, "gridHeaderLabelActive", {
	        get: function () {
	            if (this.field) {
	                var gridLocation = void 0;
	                if (this.$entitySource instanceof gridConfig_1.default) {
	                    gridLocation = this.$entitySource.$gridLocationRef;
	                }
	                else if (this.$entitySource instanceof grid_1.GridLocation) {
	                    gridLocation = this.$entitySource;
	                }
	                var gridLocationField = (gridLocation) ? gridLocation.fields.get(this.field.fieldName) : null;
	                var headerLabelActive = (gridLocationField) ? gridLocationField.gridHeaderLabel : null;
	                return (headerLabelActive != null) ? headerLabelActive : this.field.gridHeaderLabelActive;
	            }
	            else {
	                return '';
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    var GridConfigCondition_1;
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfigCondition.prototype, "field", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfigCondition.prototype, "operator", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfigCondition.prototype, "values", void 0);
	    GridConfigCondition = GridConfigCondition_1 = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], GridConfigCondition);
	    return GridConfigCondition;
	}(DomainAncestor_1.DomainAncestor));
	exports.default = GridConfigCondition;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.invoiceTemplateItemGridLocation = exports.invoiceItemGridLocation = void 0;
	var tslib_1 = __webpack_require__(3);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var invoiceDomain_1 = __webpack_require__(157);
	var mobx_1 = __webpack_require__(5);
	exports.invoiceItemGridLocation = 'invoiceItemList';
	exports.invoiceTemplateItemGridLocation = 'invoiceTemplateItemList';
	var InvoiceService = /** @class */ (function () {
	    function InvoiceService() {
	    }
	    InvoiceService.prototype.readInvoice = function (invoiceId, params) {
	        return axios_config_1.default.get('/invoice/' + invoiceId, { params: params })
	            .then(function (response) { return new invoiceDomain_1.Invoice(response.data); });
	    };
	    InvoiceService.prototype.issuedNew = function (paymentTypeId, billedToId) {
	        return axios_config_1.default.get('/invoice/issued-new', { params: { paymentTypeId: paymentTypeId, billedToId: billedToId } })
	            .then(function (response) {
	            var invoice = new invoiceDomain_1.Invoice(response.data);
	            invoice.$new = true;
	            return invoice;
	        });
	    };
	    InvoiceService.prototype.invoiceSave = function (invoice) {
	        return axios_config_1.default.post('/invoice/save', invoice, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    InvoiceService.prototype.deleteInvoice = function (invoiceId) {
	        return axios_config_1.default.delete('/invoice/' + invoiceId, { showPrettyError: true });
	    };
	    InvoiceService.prototype.recalculate = function (invoice, params) {
	        return axios_config_1.default.post('/invoice/recalculate', invoice, { params: params })
	            .then(function (response) { return response.data; });
	    };
	    InvoiceService.prototype.recalculateWithClean = function (invoice, params) {
	        return this.recalculate(invoice, params)
	            .then((0, mobx_1.action)("recalculate-actionCb", function (invoiceJson) {
	            invoice.fromJson(invoiceJson);
	            var grid = invoice.$movingBlocks.getBlock(exports.invoiceItemGridLocation);
	            grid.search(invoice);
	            return invoice;
	        }));
	    };
	    InvoiceService.prototype.prepareIssue = function (invoice) {
	        return axios_config_1.default.post('/invoice/prepare-issue', invoice)
	            .then(function (response) { return response.data; });
	    };
	    InvoiceService.prototype.doIssue = function (invoice) {
	        return axios_config_1.default.post('/invoice/do-issue', invoice, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    InvoiceService.prototype.previewInvoice = function (invoice) {
	        return axios_config_1.default.post('/invoice/preview', invoice, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    InvoiceService.prototype.cancelInvoice = function (invoice) {
	        return axios_config_1.default.post('/invoice/cancel/' + invoice.invoiceId, {}, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    InvoiceService.prototype.reopenInvoice = function (invoice) {
	        return axios_config_1.default.post('/invoice/reopen/' + invoice.invoiceId, {}, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    InvoiceService.prototype.addAllVehicles = function (invoice) {
	        return axios_config_1.default.post('/invoice/add-all-vehicles', invoice, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    InvoiceService.prototype.vatRateValue = function (vatRateId, validAt) {
	        return axios_config_1.default.get('/invoice/vat-rate-value/' + vatRateId, { params: { validAt: validAt } })
	            .then(function (response) { return response.data; });
	    };
	    InvoiceService.prototype.invoiceNumberExists = function (spec) {
	        return axios_config_1.default.get('/invoice/invoice-exist', { params: spec })
	            .then(function (response) { return response.data; });
	    };
	    InvoiceService.prototype.prepareMultipleIssue = function (gridParams) {
	        return axios_config_1.default.post('/invoice/prepare-issue-multiple', gridParams, { showPrettyError: true })
	            .then(function (response) { return new invoiceDomain_1.IssueInvoicesDto(response.data); });
	    };
	    InvoiceService.prototype.doMultipleIssue = function (issueInvoicesObject, part) {
	        return axios_config_1.default.post('/invoice/issue-multiple/' + part, issueInvoicesObject, { showPrettyError: true })
	            .then(function (response) { return new invoiceDomain_1.IssueInvoicesDto(response.data); });
	    };
	    InvoiceService.prototype.emailAddresses = function (invoiceObject) {
	        return axios_config_1.default.post('/invoice/email-addresses', invoiceObject)
	            .then(function (response) { return response.data; });
	    };
	    InvoiceService.prototype.sendInvoice = function (invoiceObject, markOnly, insertSeparateDocsIntoMain, eventType, emails) {
	        return axios_config_1.default.post('/invoice/send/' + invoiceObject.invoiceId, { markOnly: markOnly, insertSeparateDocsIntoMain: insertSeparateDocsIntoMain, eventType: eventType, emails: emails })
	            .then(function (response) { return response.data; });
	    };
	    InvoiceService.prototype.generateInvoiceFromTemplate = function (invoiceTemplateId, billedToId) {
	        return axios_config_1.default.get('/invoice/from-template/' + invoiceTemplateId, { params: { billedToId: billedToId } })
	            .then(function (response) { return new invoiceDomain_1.Invoice(response.data); });
	    };
	    // ////////// INVOICE TEMPLATE ////////////////////////////////////////////////////////////////////////////////
	    InvoiceService.prototype.readInvoiceTemplate = function (invoiceTemplateId, params) {
	        return axios_config_1.default.get('/invoice-template/' + invoiceTemplateId, { params: params })
	            .then(function (response) { return new invoiceDomain_1.InvoiceTemplate(response.data); });
	    };
	    InvoiceService.prototype.invoiceTemplateSave = function (invoiceTemplate) {
	        return axios_config_1.default.post('/invoice-template/save', invoiceTemplate, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    InvoiceService.prototype.deleteInvoiceTemplate = function (invoiceTemplateId) {
	        return axios_config_1.default.delete('/invoice-template/' + invoiceTemplateId, { showPrettyError: true });
	    };
	    InvoiceService.prototype.recalculateTemplate = function (invoiceTemplate, params) {
	        return axios_config_1.default.post('/invoice-template/recalculate', invoiceTemplate, { params: params })
	            .then(function (response) { return response.data; });
	    };
	    InvoiceService.prototype.recalculateTemplateWithClean = function (invoiceTemplate, params) {
	        return this.recalculateTemplate(invoiceTemplate, params)
	            .then((0, mobx_1.action)("recalculateTemplate-actionCb", function (invoiceTemplateJson) {
	            invoiceTemplate.fromJson(invoiceTemplateJson);
	            var grid = invoiceTemplate.$movingBlocks.getBlock(exports.invoiceTemplateItemGridLocation);
	            grid.search(invoiceTemplate);
	        }));
	    };
	    // ////////// INVOICE PAYMENT ////////////////////////////////////////////////////////////////////////////////
	    InvoiceService.prototype.readInvoiceGraph = function (invoiceId) {
	        return axios_config_1.default.get('/invoice-graph/' + invoiceId)
	            .then(function (response) { return response.data; });
	    };
	    InvoiceService.prototype.saveInvoicePayment = function (payment, invoiceId) {
	        return axios_config_1.default.post('/payment', payment, { showPrettyError: true, params: { invoiceId: invoiceId } })
	            .then(function (response) { return response.data; });
	    };
	    InvoiceService.prototype.deleteInvoicePayment = function (paymentId, invoiceId) {
	        return axios_config_1.default.delete('/payment/' + paymentId, { showPrettyError: true, params: { invoiceId: invoiceId } })
	            .then(function (response) { return response.data; });
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceService.prototype, "invoiceObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceService.prototype, "invoiceTemplateObject", void 0);
	    return InvoiceService;
	}());
	exports.default = new InvoiceService();


/***/ }),
/* 196 */
/***/ (function(module, exports) {

	var isES5 = (function(){
	    "use strict";
	    return this === undefined;
	})();
	
	if (isES5) {
	    module.exports = {
	        freeze: Object.freeze,
	        defineProperty: Object.defineProperty,
	        getDescriptor: Object.getOwnPropertyDescriptor,
	        keys: Object.keys,
	        names: Object.getOwnPropertyNames,
	        getPrototypeOf: Object.getPrototypeOf,
	        isArray: Array.isArray,
	        isES5: isES5,
	        propertyIsWritable: function(obj, prop) {
	            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
	            return !!(!descriptor || descriptor.writable || descriptor.set);
	        }
	    };
	} else {
	    var has = {}.hasOwnProperty;
	    var str = {}.toString;
	    var proto = {}.constructor.prototype;
	
	    var ObjectKeys = function (o) {
	        var ret = [];
	        for (var key in o) {
	            if (has.call(o, key)) {
	                ret.push(key);
	            }
	        }
	        return ret;
	    };
	
	    var ObjectGetDescriptor = function(o, key) {
	        return {value: o[key]};
	    };
	
	    var ObjectDefineProperty = function (o, key, desc) {
	        o[key] = desc.value;
	        return o;
	    };
	
	    var ObjectFreeze = function (obj) {
	        return obj;
	    };
	
	    var ObjectGetPrototypeOf = function (obj) {
	        try {
	            return Object(obj).constructor.prototype;
	        }
	        catch (e) {
	            return proto;
	        }
	    };
	
	    var ArrayIsArray = function (obj) {
	        try {
	            return str.call(obj) === "[object Array]";
	        }
	        catch(e) {
	            return false;
	        }
	    };
	
	    module.exports = {
	        isArray: ArrayIsArray,
	        keys: ObjectKeys,
	        names: ObjectKeys,
	        defineProperty: ObjectDefineProperty,
	        getDescriptor: ObjectGetDescriptor,
	        freeze: ObjectFreeze,
	        getPrototypeOf: ObjectGetPrototypeOf,
	        isES5: isES5,
	        propertyIsWritable: function() {
	            return true;
	        }
	    };
	}


/***/ }),
/* 197 */
[2327, 227],
/* 198 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 199 */
[2353, 600, 415],
/* 200 */
[2332, 181],
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentBlock
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CharacterMetadata = __webpack_require__(112);
	var Immutable = __webpack_require__(60);
	
	var findRangesImmutable = __webpack_require__(272);
	
	var List = Immutable.List,
	    Map = Immutable.Map,
	    OrderedSet = Immutable.OrderedSet,
	    Record = Immutable.Record,
	    Repeat = Immutable.Repeat;
	
	
	var EMPTY_SET = OrderedSet();
	
	var defaultRecord = {
	  key: '',
	  type: 'unstyled',
	  text: '',
	  characterList: List(),
	  depth: 0,
	  data: Map()
	};
	
	var ContentBlockRecord = Record(defaultRecord);
	
	var decorateCharacterList = function decorateCharacterList(config) {
	  if (!config) {
	    return config;
	  }
	
	  var characterList = config.characterList,
	      text = config.text;
	
	
	  if (text && !characterList) {
	    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
	  }
	
	  return config;
	};
	
	var ContentBlock = function (_ContentBlockRecord) {
	  _inherits(ContentBlock, _ContentBlockRecord);
	
	  function ContentBlock(config) {
	    _classCallCheck(this, ContentBlock);
	
	    return _possibleConstructorReturn(this, _ContentBlockRecord.call(this, decorateCharacterList(config)));
	  }
	
	  ContentBlock.prototype.getKey = function getKey() {
	    return this.get('key');
	  };
	
	  ContentBlock.prototype.getType = function getType() {
	    return this.get('type');
	  };
	
	  ContentBlock.prototype.getText = function getText() {
	    return this.get('text');
	  };
	
	  ContentBlock.prototype.getCharacterList = function getCharacterList() {
	    return this.get('characterList');
	  };
	
	  ContentBlock.prototype.getLength = function getLength() {
	    return this.getText().length;
	  };
	
	  ContentBlock.prototype.getDepth = function getDepth() {
	    return this.get('depth');
	  };
	
	  ContentBlock.prototype.getData = function getData() {
	    return this.get('data');
	  };
	
	  ContentBlock.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getStyle() : EMPTY_SET;
	  };
	
	  ContentBlock.prototype.getEntityAt = function getEntityAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getEntity() : null;
	  };
	
	  /**
	   * Execute a callback for every contiguous range of styles within the block.
	   */
	
	
	  ContentBlock.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
	  };
	
	  /**
	   * Execute a callback for every contiguous range of entities within the block.
	   */
	
	
	  ContentBlock.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
	  };
	
	  return ContentBlock;
	}(ContentBlockRecord);
	
	function haveEqualStyle(charA, charB) {
	  return charA.getStyle() === charB.getStyle();
	}
	
	function haveEqualEntity(charA, charB) {
	  return charA.getEntity() === charB.getEntity();
	}
	
	module.exports = ContentBlock;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Draft
	 * @format
	 * 
	 */
	
	'use strict';
	
	var AtomicBlockUtils = __webpack_require__(1207);
	var BlockMapBuilder = __webpack_require__(271);
	var CharacterMetadata = __webpack_require__(112);
	var CompositeDraftDecorator = __webpack_require__(1208);
	var ContentBlock = __webpack_require__(201);
	var ContentState = __webpack_require__(445);
	var DefaultDraftBlockRenderMap = __webpack_require__(446);
	var DefaultDraftInlineStyle = __webpack_require__(643);
	var DraftEditor = __webpack_require__(1210);
	var DraftEditorBlock = __webpack_require__(644);
	var DraftEntity = __webpack_require__(332);
	var DraftModifier = __webpack_require__(104);
	var DraftEntityInstance = __webpack_require__(645);
	var EditorState = __webpack_require__(71);
	var KeyBindingUtil = __webpack_require__(447);
	var RichTextEditorUtil = __webpack_require__(648);
	var SelectionState = __webpack_require__(235);
	
	var convertFromDraftStateToRaw = __webpack_require__(1229);
	var convertFromHTMLToContentBlocks = __webpack_require__(649);
	var convertFromRawToDraftState = __webpack_require__(1230);
	var generateRandomKey = __webpack_require__(161);
	var getDefaultKeyBinding = __webpack_require__(650);
	var getVisibleSelectionRect = __webpack_require__(1253);
	
	var DraftPublic = {
	  Editor: DraftEditor,
	  EditorBlock: DraftEditorBlock,
	  EditorState: EditorState,
	
	  CompositeDecorator: CompositeDraftDecorator,
	  Entity: DraftEntity,
	  EntityInstance: DraftEntityInstance,
	
	  BlockMapBuilder: BlockMapBuilder,
	  CharacterMetadata: CharacterMetadata,
	  ContentBlock: ContentBlock,
	  ContentState: ContentState,
	  SelectionState: SelectionState,
	
	  AtomicBlockUtils: AtomicBlockUtils,
	  KeyBindingUtil: KeyBindingUtil,
	  Modifier: DraftModifier,
	  RichUtils: RichTextEditorUtil,
	
	  DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap,
	  DefaultDraftInlineStyle: DefaultDraftInlineStyle,
	
	  convertFromHTML: convertFromHTMLToContentBlocks,
	  convertFromRaw: convertFromRawToDraftState,
	  convertToRaw: convertFromDraftStateToRaw,
	  genKey: generateRandomKey,
	  getDefaultKeyBinding: getDefaultKeyBinding,
	  getVisibleSelectionRect: getVisibleSelectionRect
	};
	
	module.exports = DraftPublic;

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * Unicode-enabled replacesments for basic String functions.
	 *
	 * All the functions in this module assume that the input string is a valid
	 * UTF-16 encoding of a Unicode sequence. If it's not the case, the behavior
	 * will be undefined.
	 *
	 * WARNING: Since this module is typechecks-enforced, you may find new bugs
	 * when replacing normal String functions with ones provided here.
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(28);
	
	// These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
	// surrogate code unit.
	var SURROGATE_HIGH_START = 0xD800;
	var SURROGATE_HIGH_END = 0xDBFF;
	var SURROGATE_LOW_START = 0xDC00;
	var SURROGATE_LOW_END = 0xDFFF;
	var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;
	
	/**
	 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
	 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
	 */
	function isCodeUnitInSurrogateRange(codeUnit) {
	  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
	}
	
	/**
	 * Returns whether the two characters starting at `index` form a surrogate pair.
	 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
	 * (s, 1) returns false.
	 *
	 * @param {string} str
	 * @param {number} index
	 * @return {boolean}
	 */
	function isSurrogatePair(str, index) {
	  !(0 <= index && index < str.length) ?  false ? invariant(false, 'isSurrogatePair: Invalid index %s for string length %s.', index, str.length) : invariant(false) : void 0;
	  if (index + 1 === str.length) {
	    return false;
	  }
	  var first = str.charCodeAt(index);
	  var second = str.charCodeAt(index + 1);
	  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
	}
	
	/**
	 * @param {string} str  Non-empty string
	 * @return {boolean}    True if the input includes any surrogate code units
	 */
	function hasSurrogateUnit(str) {
	  return SURROGATE_UNITS_REGEX.test(str);
	}
	
	/**
	 * Return the length of the original Unicode character at given position in the
	 * String by looking into the UTF-16 code unit; that is equal to 1 for any
	 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
	 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
	 * representing non-BMP characters ([U+10000..U+10FFFF]).
	 *
	 * Examples:
	 * - '\u0020' => 1
	 * - '\u3020' => 1
	 * - '\uD835' => 2
	 * - '\uD835\uDDEF' => 2
	 * - '\uDDEF' => 2
	 *
	 * @param {string} str  Non-empty string
	 * @param {number} pos  Position in the string to look for one code unit
	 * @return {number}      Number 1 or 2
	 */
	function getUTF16Length(str, pos) {
	  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#length
	 *
	 * @param {string} str  Valid Unicode string
	 * @return {number}     The number of Unicode characters in the string
	 */
	function strlen(str) {
	  // Call the native functions if there's no surrogate char
	  if (!hasSurrogateUnit(str)) {
	    return str.length;
	  }
	
	  var len = 0;
	  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
	    len++;
	  }
	  return len;
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#substr()
	 *
	 * @param {string} str      Valid Unicode string
	 * @param {number} start    Location in Unicode sequence to begin extracting
	 * @param {?number} length  The number of Unicode characters to extract
	 *                          (default: to the end of the string)
	 * @return {string}         Extracted sub-string
	 */
	function substr(str, start, length) {
	  start = start || 0;
	  length = length === undefined ? Infinity : length || 0;
	
	  // Call the native functions if there's no surrogate char
	  if (!hasSurrogateUnit(str)) {
	    return str.substr(start, length);
	  }
	
	  // Obvious cases
	  var size = str.length;
	  if (size <= 0 || start > size || length <= 0) {
	    return '';
	  }
	
	  // Find the actual starting position
	  var posA = 0;
	  if (start > 0) {
	    for (; start > 0 && posA < size; start--) {
	      posA += getUTF16Length(str, posA);
	    }
	    if (posA >= size) {
	      return '';
	    }
	  } else if (start < 0) {
	    for (posA = size; start < 0 && 0 < posA; start++) {
	      posA -= getUTF16Length(str, posA - 1);
	    }
	    if (posA < 0) {
	      posA = 0;
	    }
	  }
	
	  // Find the actual ending position
	  var posB = size;
	  if (length < size) {
	    for (posB = posA; length > 0 && posB < size; length--) {
	      posB += getUTF16Length(str, posB);
	    }
	  }
	
	  return str.substring(posA, posB);
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#substring()
	 *
	 * @param {string} str    Valid Unicode string
	 * @param {number} start  Location in Unicode sequence to begin extracting
	 * @param {?number} end   Location in Unicode sequence to end extracting
	 *                        (default: end of the string)
	 * @return {string}       Extracted sub-string
	 */
	function substring(str, start, end) {
	  start = start || 0;
	  end = end === undefined ? Infinity : end || 0;
	
	  if (start < 0) {
	    start = 0;
	  }
	  if (end < 0) {
	    end = 0;
	  }
	
	  var length = Math.abs(end - start);
	  start = start < end ? start : end;
	  return substr(str, start, length);
	}
	
	/**
	 * Get a list of Unicode code-points from a String
	 *
	 * @param {string} str        Valid Unicode string
	 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
	 */
	function getCodePoints(str) {
	  var codePoints = [];
	  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
	    codePoints.push(str.codePointAt(pos));
	  }
	  return codePoints;
	}
	
	var UnicodeUtils = {
	  getCodePoints: getCodePoints,
	  getUTF16Length: getUTF16Length,
	  hasSurrogateUnit: hasSurrogateUnit,
	  isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
	  isSurrogatePair: isSurrogatePair,
	  strlen: strlen,
	  substring: substring,
	  substr: substr
	};
	
	module.exports = UnicodeUtils;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(208),
	    overRest = __webpack_require__(718),
	    setToString = __webpack_require__(719);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1383),
	    getValue = __webpack_require__(1426);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(472);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 208 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(693),
	    baseKeys = __webpack_require__(703),
	    isArrayLike = __webpack_require__(185);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Checkbox = __webpack_require__(1500);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Checkbox2.default;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Chip = __webpack_require__(1501);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chip2.default;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(276);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  set: function set(style, key, value) {
	    style[key] = value;
	  }
	};

/***/ }),
/* 214 */
[2457, 64],
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var assign = __webpack_require__(251);
	var invariant = __webpack_require__(68);
	var warning = __webpack_require__(532);
	var PathUtils = __webpack_require__(530);
	
	var _currentRoute;
	
	var Route = (function () {
	  _createClass(Route, null, [{
	    key: 'createRoute',
	
	    /**
	     * Creates and returns a new route. Options may be a URL pathname string
	     * with placeholders for named params or an object with any of the following
	     * properties:
	     *
	     * - name                     The name of the route. This is used to lookup a
	     *                            route relative to its parent route and should be
	     *                            unique among all child routes of the same parent
	     * - path                     A URL pathname string with optional placeholders
	     *                            that specify the names of params to extract from
	     *                            the URL when the path matches. Defaults to `/${name}`
	     *                            when there is a name given, or the path of the parent
	     *                            route, or /
	     * - ignoreScrollBehavior     True to make this route (and all descendants) ignore
	     *                            the scroll behavior of the router
	     * - isDefault                True to make this route the default route among all
	     *                            its siblings
	     * - isNotFound               True to make this route the "not found" route among
	     *                            all its siblings
	     * - onEnter                  A transition hook that will be called when the
	     *                            router is going to enter this route
	     * - onLeave                  A transition hook that will be called when the
	     *                            router is going to leave this route
	     * - handler                  A React component that will be rendered when
	     *                            this route is active
	     * - parentRoute              The parent route to use for this route. This option
	     *                            is automatically supplied when creating routes inside
	     *                            the callback to another invocation of createRoute. You
	     *                            only ever need to use this when declaring routes
	     *                            independently of one another to manually piece together
	     *                            the route hierarchy
	     *
	     * The callback may be used to structure your route hierarchy. Any call to
	     * createRoute, createDefaultRoute, createNotFoundRoute, or createRedirect
	     * inside the callback automatically uses this route as its parent.
	     */
	    value: function createRoute(options, callback) {
	      options = options || {};
	
	      if (typeof options === 'string') options = { path: options };
	
	      var parentRoute = _currentRoute;
	
	      if (parentRoute) {
	        warning(options.parentRoute == null || options.parentRoute === parentRoute, 'You should not use parentRoute with createRoute inside another route\'s child callback; it is ignored');
	      } else {
	        parentRoute = options.parentRoute;
	      }
	
	      var name = options.name;
	      var path = options.path || name;
	
	      if (path && !(options.isDefault || options.isNotFound)) {
	        if (PathUtils.isAbsolute(path)) {
	          if (parentRoute) {
	            invariant(path === parentRoute.path || parentRoute.paramNames.length === 0, 'You cannot nest path "%s" inside "%s"; the parent requires URL parameters', path, parentRoute.path);
	          }
	        } else if (parentRoute) {
	          // Relative paths extend their parent.
	          path = PathUtils.join(parentRoute.path, path);
	        } else {
	          path = '/' + path;
	        }
	      } else {
	        path = parentRoute ? parentRoute.path : '/';
	      }
	
	      if (options.isNotFound && !/\*$/.test(path)) path += '*'; // Auto-append * to the path of not found routes.
	
	      var route = new Route(name, path, options.ignoreScrollBehavior, options.isDefault, options.isNotFound, options.onEnter, options.onLeave, options.handler);
	
	      if (parentRoute) {
	        if (route.isDefault) {
	          invariant(parentRoute.defaultRoute == null, '%s may not have more than one default route', parentRoute);
	
	          parentRoute.defaultRoute = route;
	        } else if (route.isNotFound) {
	          invariant(parentRoute.notFoundRoute == null, '%s may not have more than one not found route', parentRoute);
	
	          parentRoute.notFoundRoute = route;
	        }
	
	        parentRoute.appendChild(route);
	      }
	
	      // Any routes created in the callback
	      // use this route as their parent.
	      if (typeof callback === 'function') {
	        var currentRoute = _currentRoute;
	        _currentRoute = route;
	        callback.call(route, route);
	        _currentRoute = currentRoute;
	      }
	
	      return route;
	    }
	
	    /**
	     * Creates and returns a route that is rendered when its parent matches
	     * the current URL.
	     */
	  }, {
	    key: 'createDefaultRoute',
	    value: function createDefaultRoute(options) {
	      return Route.createRoute(assign({}, options, { isDefault: true }));
	    }
	
	    /**
	     * Creates and returns a route that is rendered when its parent matches
	     * the current URL but none of its siblings do.
	     */
	  }, {
	    key: 'createNotFoundRoute',
	    value: function createNotFoundRoute(options) {
	      return Route.createRoute(assign({}, options, { isNotFound: true }));
	    }
	
	    /**
	     * Creates and returns a route that automatically redirects the transition
	     * to another route. In addition to the normal options to createRoute, this
	     * function accepts the following options:
	     *
	     * - from         An alias for the `path` option. Defaults to *
	     * - to           The path/route/route name to redirect to
	     * - params       The params to use in the redirect URL. Defaults
	     *                to using the current params
	     * - query        The query to use in the redirect URL. Defaults
	     *                to using the current query
	     */
	  }, {
	    key: 'createRedirect',
	    value: function createRedirect(options) {
	      return Route.createRoute(assign({}, options, {
	        path: options.path || options.from || '*',
	        onEnter: function onEnter(transition, params, query) {
	          transition.redirect(options.to, options.params || params, options.query || query);
	        }
	      }));
	    }
	  }]);
	
	  function Route(name, path, ignoreScrollBehavior, isDefault, isNotFound, onEnter, onLeave, handler) {
	    _classCallCheck(this, Route);
	
	    this.name = name;
	    this.path = path;
	    this.paramNames = PathUtils.extractParamNames(this.path);
	    this.ignoreScrollBehavior = !!ignoreScrollBehavior;
	    this.isDefault = !!isDefault;
	    this.isNotFound = !!isNotFound;
	    this.onEnter = onEnter;
	    this.onLeave = onLeave;
	    this.handler = handler;
	  }
	
	  /**
	   * Appends the given route to this route's child routes.
	   */
	
	  _createClass(Route, [{
	    key: 'appendChild',
	    value: function appendChild(route) {
	      invariant(route instanceof Route, 'route.appendChild must use a valid Route');
	
	      if (!this.childRoutes) this.childRoutes = [];
	
	      this.childRoutes.push(route);
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var string = '<Route';
	
	      if (this.name) string += ' name="' + this.name + '"';
	
	      string += ' path="' + this.path + '">';
	
	      return string;
	    }
	  }]);
	
	  return Route;
	})();
	
	module.exports = Route;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (nodeOrComponent) {
	  var reconcileChildren = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultReconcile;
	
	
	  return {
	    propTypes: {
	      ariaActiveDescendantKey: _propTypes2.default.string.isRequired
	    },
	
	    contextTypes: {
	      activeDescendants: shape
	    },
	
	    childContextTypes: {
	      activeDescendants: shape
	    },
	
	    ariaActiveDescendant: function ariaActiveDescendant(id) {
	      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.ariaActiveDescendantKey;
	      var activeDescendants = this.context.activeDescendants;
	
	      var current = this.__ariaActiveDescendantId;
	
	      if (id === undefined) return current;
	
	      id = reconcileChildren.call(this, key, id);
	
	      if (id === undefined) id = current;else {
	        this.__ariaActiveDescendantId = id;
	        flushAriaToNode(id, nodeOrComponent, this);
	      }
	
	      activeDescendants && activeDescendants.reconcile(key, id);
	    },
	    getChildContext: function getChildContext() {
	      var _this = this;
	
	      return this._context || (this._context = {
	        activeDescendants: {
	          reconcile: function reconcile(key, id) {
	            return _this.ariaActiveDescendant(id, key);
	          }
	        }
	      });
	    }
	  };
	};
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compat = __webpack_require__(168);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shape = _propTypes2.default.shape({
	  //setActive: PropTypes.func,
	  reconcile: _propTypes2.default.func
	});
	
	function defaultReconcile(key, id) {
	  return id;
	}
	
	function flushAriaToNode(id, nodeOrComponent, ctx) {
	  var node = typeof nodeOrComponent === 'function' ? nodeOrComponent(ctx) : typeof nodeOrComponent === 'string' ? ctx.refs[nodeOrComponent] : ctx;
	
	  if (node) {
	    if (id) _compat2.default.findDOMNode(node).setAttribute('aria-activedescendant', id);else _compat2.default.findDOMNode(node).removeAttribute('aria-activedescendant');
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(115));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reduceCssCalc = _interopRequireDefault(__webpack_require__(1971));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _DataUtils = __webpack_require__(66);
	
	var _ReactUtils = __webpack_require__(43);
	
	var _DOMUtils = __webpack_require__(392);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
	
	var calculateWordWidths = function calculateWordWidths(props) {
	  try {
	    var words = !(0, _isNil2["default"])(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
	    var wordsWithComputedWidth = words.map(function (word) {
	      return {
	        word: word,
	        width: (0, _DOMUtils.getStringSize)(word, props.style).width
	      };
	    });
	    var spaceWidth = (0, _DOMUtils.getStringSize)("\xA0", props.style).width;
	    return {
	      wordsWithComputedWidth: wordsWithComputedWidth,
	      spaceWidth: spaceWidth
	    };
	  } catch (e) {
	    return null;
	  }
	};
	
	var Text =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Text, _Component);
	
	  function Text(_props) {
	    var _this;
	
	    _classCallCheck(this, Text);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Text).call(this, _props));
	
	    _this.getWordsWithoutCalculate = function (props) {
	      var words = !(0, _isNil2["default"])(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
	      return [{
	        words: words
	      }];
	    };
	
	    _this.state = {
	      wordsByLines: _this.getWordsByLines(_props, true)
	    };
	    return _this;
	  }
	
	  _createClass(Text, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateWordsByLines(this.props, true);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.width !== this.props.width || prevProps.scaleToFit !== this.props.scaleToFit || prevProps.children !== this.props.children || prevProps.style !== this.props.style) {
	        var needCalculate = this.props.children !== prevProps.children || this.props.style !== prevProps.style;
	        this.updateWordsByLines(this.props, needCalculate);
	      }
	    }
	  }, {
	    key: "updateWordsByLines",
	    value: function updateWordsByLines(props, needCalculate) {
	      this.setState({
	        wordsByLines: this.getWordsByLines(props, needCalculate)
	      });
	    }
	  }, {
	    key: "getWordsByLines",
	    value: function getWordsByLines(props, needCalculate) {
	      // Only perform calculations if using features that require them (multiline, scaleToFit)
	      if ((props.width || props.scaleToFit) && !(0, _ReactUtils.isSsr)()) {
	        if (needCalculate) {
	          var wordWidths = calculateWordWidths(props);
	
	          if (wordWidths) {
	            var wordsWithComputedWidth = wordWidths.wordsWithComputedWidth,
	                spaceWidth = wordWidths.spaceWidth;
	            this.wordsWithComputedWidth = wordsWithComputedWidth;
	            this.spaceWidth = spaceWidth;
	          } else {
	            return this.getWordsWithoutCalculate(props);
	          }
	        }
	
	        return this.calculateWordsByLines(this.wordsWithComputedWidth, this.spaceWidth, props.width);
	      }
	
	      return this.getWordsWithoutCalculate(props);
	    }
	  }, {
	    key: "calculateWordsByLines",
	    value: function calculateWordsByLines(wordsWithComputedWidth, spaceWidth, lineWidth) {
	      var scaleToFit = this.props.scaleToFit;
	      return (wordsWithComputedWidth || []).reduce(function (result, _ref) {
	        var word = _ref.word,
	            width = _ref.width;
	        var currentLine = result[result.length - 1];
	
	        if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
	          // Word can be added to an existing line
	          currentLine.words.push(word);
	          currentLine.width += width + spaceWidth;
	        } else {
	          // Add first word to line or word is too long to scaleToFit on existing line
	          var newLine = {
	            words: [word],
	            width: width
	          };
	          result.push(newLine);
	        }
	
	        return result;
	      }, []);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          dx = _this$props.dx,
	          dy = _this$props.dy,
	          textAnchor = _this$props.textAnchor,
	          verticalAnchor = _this$props.verticalAnchor,
	          scaleToFit = _this$props.scaleToFit,
	          angle = _this$props.angle,
	          lineHeight = _this$props.lineHeight,
	          capHeight = _this$props.capHeight,
	          className = _this$props.className,
	          textProps = _objectWithoutProperties(_this$props, ["dx", "dy", "textAnchor", "verticalAnchor", "scaleToFit", "angle", "lineHeight", "capHeight", "className"]);
	
	      var wordsByLines = this.state.wordsByLines;
	
	      if (!(0, _DataUtils.isNumOrStr)(textProps.x) || !(0, _DataUtils.isNumOrStr)(textProps.y)) {
	        return null;
	      }
	
	      var x = textProps.x + ((0, _DataUtils.isNumber)(dx) ? dx : 0);
	      var y = textProps.y + ((0, _DataUtils.isNumber)(dy) ? dy : 0);
	      var startDy;
	
	      switch (verticalAnchor) {
	        case 'start':
	          startDy = (0, _reduceCssCalc["default"])("calc(".concat(capHeight, ")"));
	          break;
	
	        case 'middle':
	          startDy = (0, _reduceCssCalc["default"])("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
	          break;
	
	        default:
	          startDy = (0, _reduceCssCalc["default"])("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
	          break;
	      }
	
	      var transforms = [];
	
	      if (scaleToFit) {
	        var lineWidth = wordsByLines[0].width;
	        transforms.push("scale(".concat(this.props.width / lineWidth, ")"));
	      }
	
	      if (angle) {
	        transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
	      }
	
	      if (transforms.length) {
	        textProps.transform = transforms.join(' ');
	      }
	
	      return _react["default"].createElement("text", _extends({}, (0, _ReactUtils.getPresentationAttributes)(textProps), (0, _ReactUtils.filterEventAttributes)(textProps), {
	        x: x,
	        y: y,
	        className: (0, _classnames["default"])('recharts-text', className),
	        textAnchor: textAnchor
	      }), wordsByLines.map(function (line, index) {
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement("tspan", {
	            x: x,
	            dy: index === 0 ? startDy : lineHeight,
	            key: index
	          }, line.words.join(' '))
	        );
	      }));
	    }
	  }]);
	
	  return Text;
	}(_react.Component);
	
	Text.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  scaleToFit: _propTypes["default"].bool,
	  angle: _propTypes["default"].number,
	  textAnchor: _propTypes["default"].oneOf(['start', 'middle', 'end', 'inherit']),
	  verticalAnchor: _propTypes["default"].oneOf(['start', 'middle', 'end']),
	  style: _propTypes["default"].object
	});
	Text.defaultProps = {
	  x: 0,
	  y: 0,
	  lineHeight: '1em',
	  capHeight: '0.71em',
	  // Magic number from d3
	  scaleToFit: false,
	  textAnchor: 'start',
	  verticalAnchor: 'end' // Maintain compat with existing charts / default SVG behavior
	
	};
	var _default = Text;
	exports["default"] = _default;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _ReactUtils = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Dot =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Dot, _PureComponent);
	
	  function Dot() {
	    _classCallCheck(this, Dot);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Dot).apply(this, arguments));
	  }
	
	  _createClass(Dot, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          r = _this$props.r,
	          className = _this$props.className;
	      var layerClass = (0, _classnames["default"])('recharts-dot', className);
	
	      if (cx === +cx && cy === +cy && r === +r) {
	        return _react["default"].createElement("circle", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props, null, true), {
	          className: layerClass,
	          cx: cx,
	          cy: cy,
	          r: r
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Dot;
	}(_react.PureComponent);
	
	Dot.displayName = 'Dot';
	Dot.propTypes = {
	  className: _propTypes["default"].string,
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  r: _propTypes["default"].number
	};
	var _default = Dot;
	exports["default"] = _default;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isFunction_1 = __webpack_require__(918);
	var Subscription_1 = __webpack_require__(396);
	var Observer_1 = __webpack_require__(908);
	var rxSubscriber_1 = __webpack_require__(555);
	/**
	 * Implements the {@link Observer} interface and extends the
	 * {@link Subscription} class. While the {@link Observer} is the public API for
	 * consuming the values of an {@link Observable}, all Observers get converted to
	 * a Subscriber, in order to provide Subscription-like capabilities such as
	 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
	 * implementing operators, but it is rarely used as a public API.
	 *
	 * @class Subscriber<T>
	 */
	var Subscriber = (function (_super) {
	    __extends(Subscriber, _super);
	    /**
	     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
	     * defined Observer or a `next` callback function.
	     * @param {function(e: ?any): void} [error] The `error` callback of an
	     * Observer.
	     * @param {function(): void} [complete] The `complete` callback of an
	     * Observer.
	     */
	    function Subscriber(destinationOrNext, error, complete) {
	        _super.call(this);
	        this.syncErrorValue = null;
	        this.syncErrorThrown = false;
	        this.syncErrorThrowable = false;
	        this.isStopped = false;
	        switch (arguments.length) {
	            case 0:
	                this.destination = Observer_1.empty;
	                break;
	            case 1:
	                if (!destinationOrNext) {
	                    this.destination = Observer_1.empty;
	                    break;
	                }
	                if (typeof destinationOrNext === 'object') {
	                    // HACK(benlesh): To resolve an issue where Node users may have multiple
	                    // copies of rxjs in their node_modules directory.
	                    if (isTrustedSubscriber(destinationOrNext)) {
	                        var trustedSubscriber = destinationOrNext[rxSubscriber_1.rxSubscriber]();
	                        this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
	                        this.destination = trustedSubscriber;
	                        trustedSubscriber.add(this);
	                    }
	                    else {
	                        this.syncErrorThrowable = true;
	                        this.destination = new SafeSubscriber(this, destinationOrNext);
	                    }
	                    break;
	                }
	            default:
	                this.syncErrorThrowable = true;
	                this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
	                break;
	        }
	    }
	    Subscriber.prototype[rxSubscriber_1.rxSubscriber] = function () { return this; };
	    /**
	     * A static factory for a Subscriber, given a (potentially partial) definition
	     * of an Observer.
	     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
	     * @param {function(e: ?any): void} [error] The `error` callback of an
	     * Observer.
	     * @param {function(): void} [complete] The `complete` callback of an
	     * Observer.
	     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
	     * Observer represented by the given arguments.
	     */
	    Subscriber.create = function (next, error, complete) {
	        var subscriber = new Subscriber(next, error, complete);
	        subscriber.syncErrorThrowable = false;
	        return subscriber;
	    };
	    /**
	     * The {@link Observer} callback to receive notifications of type `next` from
	     * the Observable, with a value. The Observable may call this method 0 or more
	     * times.
	     * @param {T} [value] The `next` value.
	     * @return {void}
	     */
	    Subscriber.prototype.next = function (value) {
	        if (!this.isStopped) {
	            this._next(value);
	        }
	    };
	    /**
	     * The {@link Observer} callback to receive notifications of type `error` from
	     * the Observable, with an attached {@link Error}. Notifies the Observer that
	     * the Observable has experienced an error condition.
	     * @param {any} [err] The `error` exception.
	     * @return {void}
	     */
	    Subscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            this.isStopped = true;
	            this._error(err);
	        }
	    };
	    /**
	     * The {@link Observer} callback to receive a valueless notification of type
	     * `complete` from the Observable. Notifies the Observer that the Observable
	     * has finished sending push-based notifications.
	     * @return {void}
	     */
	    Subscriber.prototype.complete = function () {
	        if (!this.isStopped) {
	            this.isStopped = true;
	            this._complete();
	        }
	    };
	    Subscriber.prototype.unsubscribe = function () {
	        if (this.closed) {
	            return;
	        }
	        this.isStopped = true;
	        _super.prototype.unsubscribe.call(this);
	    };
	    Subscriber.prototype._next = function (value) {
	        this.destination.next(value);
	    };
	    Subscriber.prototype._error = function (err) {
	        this.destination.error(err);
	        this.unsubscribe();
	    };
	    Subscriber.prototype._complete = function () {
	        this.destination.complete();
	        this.unsubscribe();
	    };
	    /** @deprecated internal use only */ Subscriber.prototype._unsubscribeAndRecycle = function () {
	        var _a = this, _parent = _a._parent, _parents = _a._parents;
	        this._parent = null;
	        this._parents = null;
	        this.unsubscribe();
	        this.closed = false;
	        this.isStopped = false;
	        this._parent = _parent;
	        this._parents = _parents;
	        return this;
	    };
	    return Subscriber;
	}(Subscription_1.Subscription));
	exports.Subscriber = Subscriber;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SafeSubscriber = (function (_super) {
	    __extends(SafeSubscriber, _super);
	    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
	        _super.call(this);
	        this._parentSubscriber = _parentSubscriber;
	        var next;
	        var context = this;
	        if (isFunction_1.isFunction(observerOrNext)) {
	            next = observerOrNext;
	        }
	        else if (observerOrNext) {
	            next = observerOrNext.next;
	            error = observerOrNext.error;
	            complete = observerOrNext.complete;
	            if (observerOrNext !== Observer_1.empty) {
	                context = Object.create(observerOrNext);
	                if (isFunction_1.isFunction(context.unsubscribe)) {
	                    this.add(context.unsubscribe.bind(context));
	                }
	                context.unsubscribe = this.unsubscribe.bind(this);
	            }
	        }
	        this._context = context;
	        this._next = next;
	        this._error = error;
	        this._complete = complete;
	    }
	    SafeSubscriber.prototype.next = function (value) {
	        if (!this.isStopped && this._next) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (!_parentSubscriber.syncErrorThrowable) {
	                this.__tryOrUnsub(this._next, value);
	            }
	            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (this._error) {
	                if (!_parentSubscriber.syncErrorThrowable) {
	                    this.__tryOrUnsub(this._error, err);
	                    this.unsubscribe();
	                }
	                else {
	                    this.__tryOrSetError(_parentSubscriber, this._error, err);
	                    this.unsubscribe();
	                }
	            }
	            else if (!_parentSubscriber.syncErrorThrowable) {
	                this.unsubscribe();
	                throw err;
	            }
	            else {
	                _parentSubscriber.syncErrorValue = err;
	                _parentSubscriber.syncErrorThrown = true;
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.complete = function () {
	        var _this = this;
	        if (!this.isStopped) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (this._complete) {
	                var wrappedComplete = function () { return _this._complete.call(_this._context); };
	                if (!_parentSubscriber.syncErrorThrowable) {
	                    this.__tryOrUnsub(wrappedComplete);
	                    this.unsubscribe();
	                }
	                else {
	                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
	                    this.unsubscribe();
	                }
	            }
	            else {
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
	        try {
	            fn.call(this._context, value);
	        }
	        catch (err) {
	            this.unsubscribe();
	            throw err;
	        }
	    };
	    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
	        try {
	            fn.call(this._context, value);
	        }
	        catch (err) {
	            parent.syncErrorValue = err;
	            parent.syncErrorThrown = true;
	            return true;
	        }
	        return false;
	    };
	    /** @deprecated internal use only */ SafeSubscriber.prototype._unsubscribe = function () {
	        var _parentSubscriber = this._parentSubscriber;
	        this._context = null;
	        this._parentSubscriber = null;
	        _parentSubscriber.unsubscribe();
	    };
	    return SafeSubscriber;
	}(Subscriber));
	function isTrustedSubscriber(obj) {
	    return obj instanceof Subscriber || ('syncErrorThrowable' in obj && obj[rxSubscriber_1.rxSubscriber]);
	}
	//# sourceMappingURL=Subscriber.js.map

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DynamicField = exports.MdEntityDto = exports.MdFieldDto = exports.DynamicFieldConfig = exports.LocaleLabel = exports.EntityValidationTable = exports.FieldValidationTable = exports.FieldDefaultTable = void 0;
	exports.initDynamicFields = initDynamicFields;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var utils_1 = __webpack_require__(37);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var FieldDefaultTable = /** @class */ (function (_super) {
	    tslib_1.__extends(FieldDefaultTable, _super);
	    function FieldDefaultTable(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldDefaultTable.prototype, "entityName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldDefaultTable.prototype, "fieldName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldDefaultTable.prototype, "index", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldDefaultTable.prototype, "configLevel", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldDefaultTable.prototype, "tenantGroup", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldDefaultTable.prototype, "tenant", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldDefaultTable.prototype, "user", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldDefaultTable.prototype, "value", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldDefaultTable.prototype, "language", void 0);
	    FieldDefaultTable = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], FieldDefaultTable);
	    return FieldDefaultTable;
	}(DomainAncestor_1.DomainAncestor));
	exports.FieldDefaultTable = FieldDefaultTable;
	var FieldValidationTable = /** @class */ (function (_super) {
	    tslib_1.__extends(FieldValidationTable, _super);
	    function FieldValidationTable(json) {
	        return _super.call(this, json) || this;
	    }
	    FieldValidationTable.prototype.fromJson = function (json) {
	        _super.prototype.fromJson.call(this, json, "parameters");
	        if (!this.parameters)
	            this.parameters = new mobx_1.ObservableMap();
	        return this;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldValidationTable.prototype, "entityName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldValidationTable.prototype, "fieldName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldValidationTable.prototype, "index", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldValidationTable.prototype, "configLevel", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldValidationTable.prototype, "tenantGroup", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldValidationTable.prototype, "tenant", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldValidationTable.prototype, "user", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldValidationTable.prototype, "validation", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldValidationTable.prototype, "language", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldValidationTable.prototype, "parameters", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldValidationTable.prototype, "qualifyExpr", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], FieldValidationTable.prototype, "serverSide", void 0);
	    FieldValidationTable = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], FieldValidationTable);
	    return FieldValidationTable;
	}(DomainAncestor_1.DomainAncestor));
	exports.FieldValidationTable = FieldValidationTable;
	var EntityValidationTable = /** @class */ (function (_super) {
	    tslib_1.__extends(EntityValidationTable, _super);
	    function EntityValidationTable(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityValidationTable.prototype, "entityName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityValidationTable.prototype, "index", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityValidationTable.prototype, "configLevel", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityValidationTable.prototype, "tenantGroup", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityValidationTable.prototype, "tenant", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityValidationTable.prototype, "user", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityValidationTable.prototype, "validation", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityValidationTable.prototype, "language", void 0);
	    EntityValidationTable = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], EntityValidationTable);
	    return EntityValidationTable;
	}(DomainAncestor_1.DomainAncestor));
	exports.EntityValidationTable = EntityValidationTable;
	var LocaleLabel = /** @class */ (function (_super) {
	    tslib_1.__extends(LocaleLabel, _super);
	    function LocaleLabel(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], LocaleLabel.prototype, "locale", void 0);
	    return LocaleLabel;
	}(DomainAncestor_1.DomainAncestor));
	exports.LocaleLabel = LocaleLabel;
	// private String entityName;
	//
	// @Id
	// @NotNull
	// @Size(max = 100)
	// @Column(length = 100, nullable = false)
	// private String fieldName;
	//
	// @NotNull
	// @Size(max = 100)
	// @Column(length = 100, nullable = false)
	// private String defaultLabel;
	//
	// @NotNull
	// @Enumerated(EnumType.STRING)
	// @Column(length = 30, nullable = false)
	// private CLIENTDATATYPE dataType;
	var DynamicFieldConfig = /** @class */ (function (_super) {
	    tslib_1.__extends(DynamicFieldConfig, _super);
	    function DynamicFieldConfig(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.tenantGroups)
	            _this.tenantGroups = [];
	        if (!_this.tenants)
	            _this.tenants = [];
	        return _this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DynamicFieldConfig.prototype, "entityName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DynamicFieldConfig.prototype, "fieldName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DynamicFieldConfig.prototype, "defaultLabel", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DynamicFieldConfig.prototype, "dataType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DynamicFieldConfig.prototype, "tenantGroups", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DynamicFieldConfig.prototype, "tenants", void 0);
	    DynamicFieldConfig = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], DynamicFieldConfig);
	    return DynamicFieldConfig;
	}(DomainAncestor_1.DomainAncestor));
	exports.DynamicFieldConfig = DynamicFieldConfig;
	var MdFieldDto = /** @class */ (function (_super) {
	    tslib_1.__extends(MdFieldDto, _super);
	    function MdFieldDto(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.locales)
	            _this.locales = new mobx_1.ObservableMap();
	        if (!_this.defaults)
	            _this.defaults = [];
	        if (!_this.validations)
	            _this.validations = [];
	        return _this;
	    }
	    MdFieldDto.prototype.fromJson = function (json) {
	        _super.prototype.fromJson.call(this, json, "locales");
	        return this;
	    };
	    MdFieldDto.prototype.getId = function () {
	        return (0, utils_1.formatId)(this.entityName, this.fieldName);
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdFieldDto.prototype, "entityName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdFieldDto.prototype, "fieldName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdFieldDto.prototype, "fieldType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(DynamicFieldConfig)
	    ], MdFieldDto.prototype, "dynamicFieldConfig", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(FieldDefaultTable)
	    ], MdFieldDto.prototype, "defaults", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(FieldValidationTable)
	    ], MdFieldDto.prototype, "validations", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(LocaleLabel)
	    ], MdFieldDto.prototype, "locales", void 0);
	    MdFieldDto = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], MdFieldDto);
	    return MdFieldDto;
	}(DomainAncestor_1.DomainAncestor));
	exports.MdFieldDto = MdFieldDto;
	var MdEntityDto = /** @class */ (function (_super) {
	    tslib_1.__extends(MdEntityDto, _super);
	    function MdEntityDto(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(EntityValidationTable)
	    ], MdEntityDto.prototype, "validations", void 0);
	    MdEntityDto = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], MdEntityDto);
	    return MdEntityDto;
	}(DomainAncestor_1.DomainAncestor));
	exports.MdEntityDto = MdEntityDto;
	var DynamicField = /** @class */ (function (_super) {
	    tslib_1.__extends(DynamicField, _super);
	    function DynamicField(json) {
	        return _super.call(this, json) || this;
	    }
	    DynamicField.prototype.fromJson = function (json) {
	        var mapFields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            mapFields[_i - 1] = arguments[_i];
	        }
	        _super.prototype.fromJson.apply(this, tslib_1.__spreadArray([json], mapFields, false));
	        var _a = (0, utils_1.parseId)(this.dynamicFieldConfig), entityName = _a[0], fieldName = _a[1];
	        this.fieldName = fieldName;
	        var fieldEntity = mdEntityService_1.default.getEntity(entityName);
	        this.$mdFieldRef = fieldEntity.getField(fieldName);
	        return this;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DynamicField.prototype, "value", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DynamicField.prototype, "dynamicFieldConfig", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DynamicField.prototype, "fieldName", void 0);
	    DynamicField = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], DynamicField);
	    return DynamicField;
	}(DomainAncestor_1.DomainAncestor));
	exports.DynamicField = DynamicField;
	function initDynamicFields(entityName, dataObject) {
	    var dynFields = dataObject.fields.reduce(function (acc, dynField) {
	        acc[dynField.fieldName] = dynField;
	        return acc;
	    }, {});
	    var invoiceEntity = mdEntityService_1.default.getEntity(entityName);
	    if (invoiceEntity) {
	        invoiceEntity.getDynamicFields().forEach(function (mdField) {
	            if (!dynFields[mdField.fieldName]) {
	                dataObject.fields.push(new DynamicField({ dynamicFieldConfig: mdField.fieldKey, label: mdField.label }));
	            }
	        });
	    }
	    dataObject.fields = dataObject.fields.sort(function (a, b) { return a.label.localeCompare(b.label); });
	}


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(2259);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (!component.unmounted) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)(mixin, set);
	module.exports = exports['default'];

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = merge;
	
	function merge() {
	  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaults = arguments.length > 1 ? arguments[1] : undefined;
	
	  for (var key in defaults) {
	    if (typeof obj[key] === 'undefined') {
	      obj[key] = defaults[key];
	    }
	  }
	
	  return obj;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1054), __esModule: true };

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(1002);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(1001);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 225 */
181,
/* 226 */
[2334, 180, 268, 160],
/* 227 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 228 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 229 */
[2347, 605, 416],
/* 230 */
[2355, 415],
/* 231 */
95,
/* 232 */
227,
/* 233 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(182));
	
	var _default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	exports.default = _default;
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	  return false;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectionState
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Immutable = __webpack_require__(60);
	
	var Record = Immutable.Record;
	
	
	var defaultRecord = {
	  anchorKey: '',
	  anchorOffset: 0,
	  focusKey: '',
	  focusOffset: 0,
	  isBackward: false,
	  hasFocus: false
	};
	
	var SelectionStateRecord = Record(defaultRecord);
	
	var SelectionState = function (_SelectionStateRecord) {
	  _inherits(SelectionState, _SelectionStateRecord);
	
	  function SelectionState() {
	    _classCallCheck(this, SelectionState);
	
	    return _possibleConstructorReturn(this, _SelectionStateRecord.apply(this, arguments));
	  }
	
	  SelectionState.prototype.serialize = function serialize() {
	    return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
	  };
	
	  SelectionState.prototype.getAnchorKey = function getAnchorKey() {
	    return this.get('anchorKey');
	  };
	
	  SelectionState.prototype.getAnchorOffset = function getAnchorOffset() {
	    return this.get('anchorOffset');
	  };
	
	  SelectionState.prototype.getFocusKey = function getFocusKey() {
	    return this.get('focusKey');
	  };
	
	  SelectionState.prototype.getFocusOffset = function getFocusOffset() {
	    return this.get('focusOffset');
	  };
	
	  SelectionState.prototype.getIsBackward = function getIsBackward() {
	    return this.get('isBackward');
	  };
	
	  SelectionState.prototype.getHasFocus = function getHasFocus() {
	    return this.get('hasFocus');
	  };
	
	  /**
	   * Return whether the specified range overlaps with an edge of the
	   * SelectionState.
	   */
	
	
	  SelectionState.prototype.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
	    var anchorKey = this.getAnchorKey();
	    var focusKey = this.getFocusKey();
	
	    if (anchorKey === focusKey && anchorKey === blockKey) {
	      var selectionStart = this.getStartOffset();
	      var selectionEnd = this.getEndOffset();
	      return start <= selectionEnd && selectionStart <= end;
	    }
	
	    if (blockKey !== anchorKey && blockKey !== focusKey) {
	      return false;
	    }
	
	    var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();
	
	    return start <= offsetToCheck && end >= offsetToCheck;
	  };
	
	  SelectionState.prototype.isCollapsed = function isCollapsed() {
	    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
	  };
	
	  SelectionState.prototype.getStartKey = function getStartKey() {
	    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
	  };
	
	  SelectionState.prototype.getStartOffset = function getStartOffset() {
	    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
	  };
	
	  SelectionState.prototype.getEndKey = function getEndKey() {
	    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
	  };
	
	  SelectionState.prototype.getEndOffset = function getEndOffset() {
	    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
	  };
	
	  SelectionState.createEmpty = function createEmpty(key) {
	    return new SelectionState({
	      anchorKey: key,
	      anchorOffset: 0,
	      focusKey: key,
	      focusOffset: 0,
	      isBackward: false,
	      hasFocus: false
	    });
	  };
	
	  return SelectionState;
	}(SelectionStateRecord);
	
	module.exports = SelectionState;

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * This function is used to mark string literals representing CSS class names
	 * so that they can be transformed statically. This allows for modularization
	 * and minification of CSS class names.
	 *
	 * In static_upstream, this function is actually implemented, but it should
	 * eventually be replaced with something more descriptive, and the transform
	 * that is used in the main stack should be ported for use elsewhere.
	 *
	 * @param string|object className to modularize, or an object of key/values.
	 *                      In the object case, the values are conditions that
	 *                      determine if the className keys should be included.
	 * @param [string ...]  Variable list of classNames in the string case.
	 * @return string       Renderable space-separated CSS className.
	 */
	function cx(classNames) {
	  if (typeof classNames == 'object') {
	    return Object.keys(classNames).filter(function (className) {
	      return classNames[className];
	    }).map(replace).join(' ');
	  }
	  return Array.prototype.map.call(arguments, replace).join(' ');
	}
	
	function replace(str) {
	  return str.replace(/\//g, '-');
	}
	
	module.exports = cx;

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPrefixedValue;
	function getPrefixedValue(prefixedValue, value, keepUnprefixed) {
	  if (keepUnprefixed) {
	    return [prefixedValue, value];
	  }
	  return prefixedValue;
	}
	module.exports = exports["default"];

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(124);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(151),
	    isObjectLike = __webpack_require__(116);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(151),
	    isObjectLike = __webpack_require__(116);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Divider = __webpack_require__(1515);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Divider2.default;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(165);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _RenderToLayer = __webpack_require__(769);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _propTypes3 = __webpack_require__(118);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _Paper = __webpack_require__(106);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _lodash = __webpack_require__(690);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PopoverAnimationDefault = __webpack_require__(1532);
	
	var _PopoverAnimationDefault2 = _interopRequireDefault(_PopoverAnimationDefault);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'none'
	  }
	};
	
	var Popover = function (_Component) {
	  (0, _inherits3.default)(Popover, _Component);
	
	  function Popover(props, context) {
	    (0, _classCallCheck3.default)(this, Popover);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).call(this, props, context));
	
	    _this.timeout = null;
	
	    _this.renderLayer = function () {
	      var _this$props = _this.props,
	          animated = _this$props.animated,
	          animation = _this$props.animation,
	          anchorEl = _this$props.anchorEl,
	          anchorOrigin = _this$props.anchorOrigin,
	          autoCloseWhenOffScreen = _this$props.autoCloseWhenOffScreen,
	          canAutoPosition = _this$props.canAutoPosition,
	          children = _this$props.children,
	          onRequestClose = _this$props.onRequestClose,
	          style = _this$props.style,
	          targetOrigin = _this$props.targetOrigin,
	          useLayerForClickAway = _this$props.useLayerForClickAway,
	          scrollableContainer = _this$props.scrollableContainer,
	          other = (0, _objectWithoutProperties3.default)(_this$props, ['animated', 'animation', 'anchorEl', 'anchorOrigin', 'autoCloseWhenOffScreen', 'canAutoPosition', 'children', 'onRequestClose', 'style', 'targetOrigin', 'useLayerForClickAway', 'scrollableContainer']);
	
	
	      var styleRoot = style;
	
	      if (!animated) {
	        styleRoot = {
	          position: 'fixed',
	          zIndex: _this.context.muiTheme.zIndex.popover
	        };
	
	        if (!_this.state.open) {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          _Paper2.default,
	          (0, _extends3.default)({ style: (0, _simpleAssign2.default)(styleRoot, style) }, other),
	          children
	        );
	      }
	
	      var Animation = animation || _PopoverAnimationDefault2.default;
	
	      return _react2.default.createElement(
	        Animation,
	        (0, _extends3.default)({
	          targetOrigin: targetOrigin,
	          style: styleRoot
	        }, other, {
	          open: _this.state.open && !_this.state.closing
	        }),
	        children
	      );
	    };
	
	    _this.componentClickAway = function () {
	      _this.requestClose('clickAway');
	    };
	
	    _this.setPlacement = function (scrolling) {
	      if (!_this.state.open) {
	        return;
	      }
	
	      if (!_this.popoverRefs.layer.getLayer()) {
	        return;
	      }
	
	      var targetEl = _this.popoverRefs.layer.getLayer().children[0];
	      if (!targetEl) {
	        return;
	      }
	
	      var _this$props2 = _this.props,
	          targetOrigin = _this$props2.targetOrigin,
	          anchorOrigin = _this$props2.anchorOrigin;
	
	      var anchorEl = _this.props.anchorEl || _this.anchorEl;
	
	      var anchor = _this.getAnchorPosition(anchorEl);
	      var target = _this.getTargetPosition(targetEl);
	
	      var targetPosition = {
	        top: anchor[anchorOrigin.vertical] - target[targetOrigin.vertical],
	        left: anchor[anchorOrigin.horizontal] - target[targetOrigin.horizontal]
	      };
	
	      if (scrolling && _this.props.autoCloseWhenOffScreen) {
	        _this.autoCloseWhenOffScreen(anchor);
	      }
	
	      if (_this.props.canAutoPosition) {
	        target = _this.getTargetPosition(targetEl); // update as height may have changed
	        targetPosition = _this.applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition);
	      }
	
	      targetEl.style.top = targetPosition.top + 'px';
	      targetEl.style.left = targetPosition.left + 'px';
	      targetEl.style.maxHeight = window.innerHeight + 'px';
	    };
	
	    _this.handleResize = (0, _lodash2.default)(_this.setPlacement, 100);
	    _this.handleScroll = (0, _lodash2.default)(_this.setPlacement.bind(_this, true), 50);
	
	    _this.popoverRefs = {};
	
	    _this.state = {
	      open: props.open,
	      closing: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Popover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.placementTimeout = setTimeout(this.setPlacement);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.open === this.props.open) {
	        return;
	      }
	
	      if (nextProps.open) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	        this.anchorEl = nextProps.anchorEl || this.props.anchorEl;
	        this.setState({
	          open: true,
	          closing: false
	        });
	      } else {
	        if (nextProps.animated) {
	          if (this.timeout !== null) return;
	          this.setState({ closing: true });
	          this.timeout = setTimeout(function () {
	            _this2.setState({
	              open: false
	            }, function () {
	              _this2.timeout = null;
	            });
	          }, 500);
	        } else {
	          this.setState({
	            open: false
	          });
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      clearTimeout(this.placementTimeout);
	      this.placementTimeout = setTimeout(this.setPlacement);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.handleResize.cancel();
	      this.handleScroll.cancel();
	
	      if (this.placementTimeout) {
	        clearTimeout(this.placementTimeout);
	        this.placementTimeout = null;
	      }
	
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	      }
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(reason) {
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(reason);
	      }
	    }
	  }, {
	    key: 'getAnchorPosition',
	    value: function getAnchorPosition(el) {
	      if (!el) {
	        el = _reactDom2.default.findDOMNode(this);
	      }
	
	      var rect = el.getBoundingClientRect();
	      var a = {
	        top: rect.top,
	        left: rect.left,
	        width: el.offsetWidth,
	        height: el.offsetHeight
	      };
	
	      a.right = rect.right || a.left + a.width;
	      a.bottom = rect.bottom || a.top + a.height;
	      a.middle = a.left + (a.right - a.left) / 2;
	      a.center = a.top + (a.bottom - a.top) / 2;
	
	      return a;
	    }
	  }, {
	    key: 'getTargetPosition',
	    value: function getTargetPosition(targetEl) {
	      return {
	        top: 0,
	        center: targetEl.offsetHeight / 2,
	        bottom: targetEl.offsetHeight,
	        left: 0,
	        middle: targetEl.offsetWidth / 2,
	        right: targetEl.offsetWidth
	      };
	    }
	  }, {
	    key: 'autoCloseWhenOffScreen',
	    value: function autoCloseWhenOffScreen(anchorPosition) {
	      if (anchorPosition.top < 0 || anchorPosition.top > window.innerHeight || anchorPosition.left < 0 || anchorPosition.left > window.innerWidth) {
	        this.requestClose('offScreen');
	      }
	    }
	  }, {
	    key: 'getOverlapMode',
	    value: function getOverlapMode(anchor, target, median) {
	      if ([anchor, target].indexOf(median) >= 0) return 'auto';
	      if (anchor === target) return 'inclusive';
	      return 'exclusive';
	    }
	  }, {
	    key: 'getPositions',
	    value: function getPositions(anchor, target) {
	      var a = (0, _extends3.default)({}, anchor);
	      var t = (0, _extends3.default)({}, target);
	
	      var positions = {
	        x: ['left', 'right'].filter(function (p) {
	          return p !== t.horizontal;
	        }),
	        y: ['top', 'bottom'].filter(function (p) {
	          return p !== t.vertical;
	        })
	      };
	
	      var overlap = {
	        x: this.getOverlapMode(a.horizontal, t.horizontal, 'middle'),
	        y: this.getOverlapMode(a.vertical, t.vertical, 'center')
	      };
	
	      positions.x.splice(overlap.x === 'auto' ? 0 : 1, 0, 'middle');
	      positions.y.splice(overlap.y === 'auto' ? 0 : 1, 0, 'center');
	
	      if (overlap.y !== 'auto') {
	        a.vertical = a.vertical === 'top' ? 'bottom' : 'top';
	        if (overlap.y === 'inclusive') {
	          t.vertical = t.vertical;
	        }
	      }
	
	      if (overlap.x !== 'auto') {
	        a.horizontal = a.horizontal === 'left' ? 'right' : 'left';
	        if (overlap.y === 'inclusive') {
	          t.horizontal = t.horizontal;
	        }
	      }
	
	      return {
	        positions: positions,
	        anchorPos: a
	      };
	    }
	  }, {
	    key: 'applyAutoPositionIfNeeded',
	    value: function applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition) {
	      var _getPositions = this.getPositions(anchorOrigin, targetOrigin),
	          positions = _getPositions.positions,
	          anchorPos = _getPositions.anchorPos;
	
	      if (targetPosition.top < 0 || targetPosition.top + target.bottom > window.innerHeight) {
	        var newTop = anchor[anchorPos.vertical] - target[positions.y[0]];
	        if (newTop + target.bottom <= window.innerHeight) {
	          targetPosition.top = Math.max(0, newTop);
	        } else {
	          newTop = anchor[anchorPos.vertical] - target[positions.y[1]];
	          if (newTop + target.bottom <= window.innerHeight) {
	            targetPosition.top = Math.max(0, newTop);
	          }
	        }
	      }
	
	      if (targetPosition.left < 0 || targetPosition.left + target.right > window.innerWidth) {
	        var newLeft = anchor[anchorPos.horizontal] - target[positions.x[0]];
	        if (newLeft + target.right <= window.innerWidth) {
	          targetPosition.left = Math.max(0, newLeft);
	        } else {
	          newLeft = anchor[anchorPos.horizontal] - target[positions.x[1]];
	          if (newLeft + target.right <= window.innerWidth) {
	            targetPosition.left = Math.max(0, newLeft);
	          }
	        }
	      }
	
	      return targetPosition;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: this.props.scrollableContainer,
	          onScroll: this.handleScroll,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(_RenderToLayer2.default, {
	          ref: function ref(_ref) {
	            return _this3.popoverRefs.layer = _ref;
	          },
	          open: this.state.open,
	          componentClickAway: this.componentClickAway,
	          useLayerForClickAway: this.props.useLayerForClickAway,
	          render: this.renderLayer
	        })
	      );
	    }
	  }]);
	  return Popover;
	}(_react.Component);
	
	Popover.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'left'
	  },
	  animated: true,
	  autoCloseWhenOffScreen: true,
	  canAutoPosition: true,
	  onRequestClose: function onRequestClose() {},
	  open: false,
	  scrollableContainer: 'window',
	  style: {
	    overflowY: 'auto'
	  },
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  useLayerForClickAway: true,
	  zDepth: 1
	};
	Popover.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Popover.propTypes =  false ? {
	  /**
	   * This is the DOM element that will be used to set the position of the
	   * popover.
	   */
	  anchorEl: _propTypes2.default.object,
	  /**
	   * This is the point on the anchor where the popover's
	   * `targetOrigin` will attach to.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it is added to the DOM.
	   */
	  animated: _propTypes2.default.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * If true, the popover will hide when the anchor is scrolled off the screen.
	   */
	  autoCloseWhenOffScreen: _propTypes2.default.bool,
	  /**
	   * If true, the popover (potentially) ignores `targetOrigin`
	   * and `anchorOrigin` to make itself fit on screen,
	   * which is useful for mobile devices.
	   */
	  canAutoPosition: _propTypes2.default.bool,
	  /**
	   * The content of the popover.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Callback function fired when the popover is requested to be closed.
	   *
	   * @param {string} reason The reason for the close request. Possibles values
	   * are 'clickAway' and 'offScreen'.
	   */
	  onRequestClose: _propTypes2.default.func,
	  /**
	   * If true, the popover is visible.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * Represents the parent scrollable container.
	   * It can be an element or a string like `window`.
	   */
	  scrollableContainer: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * This is the point on the popover which will attach to
	   * the anchor's origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying
	   * elements, and trigger an `onRequestClose('clickAway')` call.
	   */
	  useLayerForClickAway: _propTypes2.default.bool,
	  /**
	   * The zDepth of the popover.
	   */
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = Popover;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RadioButton = __webpack_require__(751);
	
	var _RadioButton2 = _interopRequireDefault(_RadioButton);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadioButtonGroup = function (_Component) {
	  (0, _inherits3.default)(RadioButtonGroup, _Component);
	
	  function RadioButtonGroup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RadioButtonGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioButtonGroup.__proto__ || (0, _getPrototypeOf2.default)(RadioButtonGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      numberCheckedRadioButtons: 0,
	      selected: ''
	    }, _this.handleChange = function (event, newSelection) {
	      _this.updateRadioButtons(newSelection);
	
	      // Successful update
	      if (_this.state.numberCheckedRadioButtons === 0) {
	        if (_this.props.onChange) _this.props.onChange(event, newSelection);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RadioButtonGroup, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var cnt = 0;
	      var selected = '';
	      var _props = this.props,
	          valueSelected = _props.valueSelected,
	          defaultSelected = _props.defaultSelected;
	
	      if (valueSelected !== undefined) {
	        selected = valueSelected;
	      } else if (defaultSelected !== undefined) {
	        selected = defaultSelected;
	      }
	
	      _react2.default.Children.forEach(this.props.children, function (option) {
	        if (_this2.hasCheckAttribute(option)) cnt++;
	      }, this);
	
	      this.setState({
	        numberCheckedRadioButtons: cnt,
	        selected: selected
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hasOwnProperty('valueSelected')) {
	        this.setState({
	          selected: nextProps.valueSelected
	        });
	      }
	    }
	  }, {
	    key: 'hasCheckAttribute',
	    value: function hasCheckAttribute(radioButton) {
	      return radioButton.props.hasOwnProperty('checked') && radioButton.props.checked;
	    }
	  }, {
	    key: 'updateRadioButtons',
	    value: function updateRadioButtons(newSelection) {
	      if (this.state.numberCheckedRadioButtons === 0) {
	        this.setState({ selected: newSelection });
	      } else {
	         false ? (0, _warning2.default)(false, 'Material-UI: Cannot select a different radio button while another radio button\n        has the \'checked\' property set to true.') : void 0;
	      }
	    }
	  }, {
	    key: 'getSelectedValue',
	    value: function getSelectedValue() {
	      return this.state.selected;
	    }
	  }, {
	    key: 'setSelectedValue',
	    value: function setSelectedValue(newSelectionValue) {
	      this.updateRadioButtons(newSelectionValue);
	    }
	  }, {
	    key: 'clearValue',
	    value: function clearValue() {
	      this.setSelectedValue('');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var options = _react2.default.Children.map(this.props.children, function (option) {
	        var _option$props = option.props,
	            name = _option$props.name,
	            value = _option$props.value,
	            label = _option$props.label,
	            onCheck = _option$props.onCheck,
	            other = (0, _objectWithoutProperties3.default)(_option$props, ['name', 'value', 'label', 'onCheck']);
	
	
	        return _react2.default.createElement(_RadioButton2.default, (0, _extends3.default)({}, other, {
	          ref: option.props.value,
	          name: _this3.props.name,
	          key: option.props.value,
	          value: option.props.value,
	          label: option.props.label,
	          labelPosition: _this3.props.labelPosition,
	          onCheck: _this3.handleChange,
	          checked: option.props.value === _this3.state.selected
	        }));
	      }, this);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: prepareStyles((0, _simpleAssign2.default)({}, this.props.style)),
	          className: this.props.className
	        },
	        options
	      );
	    }
	  }]);
	  return RadioButtonGroup;
	}(_react.Component);
	
	RadioButtonGroup.defaultProps = {
	  style: {}
	};
	RadioButtonGroup.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	RadioButtonGroup.propTypes =  false ? {
	  /**
	   * Should be used to pass `RadioButton` components.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The `value` property of the radio button that will be
	   * selected by default. This takes precedence over the `checked` property
	   * of the `RadioButton` elements.
	   */
	  defaultSelected: _propTypes2.default.any,
	  /**
	   * Where the label will be placed for all child radio buttons.
	   * This takes precedence over the `labelPosition` property of the
	   * `RadioButton` elements.
	   */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * The name that will be applied to all child radio buttons.
	   */
	  name: _propTypes2.default.string.isRequired,
	  /**
	   * Callback function that is fired when a radio button has
	   * been checked.
	   *
	   * @param {object} event `change` event targeting the selected
	   * radio button.
	   * @param {*} value The `value` of the selected radio button.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The `value` of the currently selected radio button.
	   */
	  valueSelected: _propTypes2.default.any
	} : {};
	exports.default = RadioButtonGroup;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(233);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(511);
	var setInnerHTML = __webpack_require__(378);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(519);
	var setTextContent = __webpack_require__(843);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var invariant = __webpack_require__(28);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1780);
	var ReactInstrumentation = __webpack_require__(141);
	
	var warning = __webpack_require__(61);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdClear = function MdClear(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 10.7l-9.3 9.3 9.3 9.3-2.3 2.3-9.3-9.3-9.3 9.3-2.3-2.3 9.3-9.3-9.3-9.3 2.3-2.3 9.3 9.3 9.3-9.3z' })
	        )
	    );
	};
	
	exports.default = MdClear;
	module.exports = exports['default'];

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdDelete = function MdDelete(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 6.6v3.4h-23.2v-3.4h5.7l1.8-1.6h8.2l1.8 1.6h5.7z m-21.6 25v-20h20v20c0 1.8-1.6 3.4-3.4 3.4h-13.2c-1.8 0-3.4-1.6-3.4-3.4z' })
	        )
	    );
	};
	
	exports.default = MdDelete;
	module.exports = exports['default'];

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(68);
	var canUseDOM = __webpack_require__(317);
	
	var History = {
	
	  /**
	   * The current number of entries in the history.
	   *
	   * Note: This property is read-only.
	   */
	  length: 1,
	
	  /**
	   * Sends the browser back one entry in the history.
	   */
	  back: function back() {
	    invariant(canUseDOM, 'Cannot use History.back without a DOM');
	
	    // Do this first so that History.length will
	    // be accurate in location change listeners.
	    History.length -= 1;
	
	    window.history.back();
	  }
	
	};
	
	module.exports = History;

/***/ }),
/* 251 */
/***/ (function(module, exports) {

	'use strict';
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = Object.keys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var ReactBaseClasses = __webpack_require__(885);
	var ReactChildren = __webpack_require__(1926);
	var ReactDOMFactories = __webpack_require__(1927);
	var ReactElement = __webpack_require__(253);
	var ReactPropTypes = __webpack_require__(1928);
	var ReactVersion = __webpack_require__(1929);
	
	var createReactClass = __webpack_require__(1930);
	var onlyChild = __webpack_require__(1934);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var ReactCurrentOwner = __webpack_require__(169);
	
	var warning = __webpack_require__(61);
	var canDefineProperty = __webpack_require__(889);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(887);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _ReactUtils = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var XAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(XAxis, _PureComponent);
	
	  function XAxis() {
	    _classCallCheck(this, XAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(XAxis).apply(this, arguments));
	  }
	
	  _createClass(XAxis, [{
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return XAxis;
	}(_react.PureComponent);
	
	XAxis.displayName = 'XAxis';
	XAxis.propTypes = {
	  allowDecimals: _propTypes["default"].bool,
	  allowDuplicatedCategory: _propTypes["default"].bool,
	  hide: _propTypes["default"].bool,
	  // The name of data displayed in the axis
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unique id of x-axis
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  domain: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func, _propTypes["default"].oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  // The width of axis which is usually calculated internally
	  width: _propTypes["default"].number,
	  // The height of axis, which need to be setted by user
	  height: _propTypes["default"].number,
	  mirror: _propTypes["default"].bool,
	  // The orientation of axis
	  orientation: _propTypes["default"].oneOf(['top', 'bottom']),
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes["default"].array,
	  // The count of ticks
	  tickCount: _propTypes["default"].number,
	  // The formatter function of tick
	  tickFormatter: _propTypes["default"].func,
	  padding: _propTypes["default"].shape({
	    left: _propTypes["default"].number,
	    right: _propTypes["default"].number
	  }),
	  allowDataOverflow: _propTypes["default"].bool,
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(_ReactUtils.SCALE_TYPES), _propTypes["default"].func]),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tickLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  minTickGap: _propTypes["default"].number,
	  tickSize: _propTypes["default"].number,
	  interval: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes["default"].bool
	};
	XAxis.defaultProps = {
	  allowDecimals: true,
	  hide: false,
	  orientation: 'bottom',
	  width: 0,
	  height: 30,
	  mirror: false,
	  xAxisId: 0,
	  tickCount: 5,
	  type: 'category',
	  domain: [0, 'auto'],
	  padding: {
	    left: 0,
	    right: 0
	  },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false,
	  allowDuplicatedCategory: true
	};
	var _default = XAxis;
	exports["default"] = _default;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var YAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(YAxis, _PureComponent);
	
	  function YAxis() {
	    _classCallCheck(this, YAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(YAxis).apply(this, arguments));
	  }
	
	  _createClass(YAxis, [{
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return YAxis;
	}(_react.PureComponent);
	
	YAxis.displayName = 'YAxis';
	YAxis.propTypes = {
	  allowDecimals: _propTypes["default"].bool,
	  allowDuplicatedCategory: _propTypes["default"].bool,
	  hide: _propTypes["default"].bool,
	  // The name of data displayed in the axis
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unique id of y-axis
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  domain: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func, _propTypes["default"].oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes["default"].array,
	  // The count of ticks
	  tickCount: _propTypes["default"].number,
	  // The formatter function of tick
	  tickFormatter: _propTypes["default"].func,
	  // The width of axis, which need to be setted by user
	  width: _propTypes["default"].number,
	  // The height of axis which is usually calculated in Chart
	  height: _propTypes["default"].number,
	  mirror: _propTypes["default"].bool,
	  // The orientation of axis
	  orientation: _propTypes["default"].oneOf(['left', 'right']),
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  padding: _propTypes["default"].shape({
	    top: _propTypes["default"].number,
	    bottom: _propTypes["default"].number
	  }),
	  allowDataOverflow: _propTypes["default"].bool,
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), _propTypes["default"].func]),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tickLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  minTickGap: _propTypes["default"].number,
	  tickSize: _propTypes["default"].number,
	  interval: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes["default"].bool
	};
	YAxis.defaultProps = {
	  allowDuplicatedCategory: true,
	  allowDecimals: true,
	  hide: false,
	  orientation: 'left',
	  width: 60,
	  height: 0,
	  mirror: false,
	  yAxisId: 0,
	  tickCount: 5,
	  type: 'number',
	  domain: [0, 'auto'],
	  padding: {
	    top: 0,
	    bottom: 0
	  },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false
	};
	var _default = YAxis;
	exports["default"] = _default;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _ReactUtils = __webpack_require__(43);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function Cell() {
	  return null;
	}
	
	Cell.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES);
	Cell.displayName = 'Cell';
	var _default = Cell;
	exports["default"] = _default;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(62));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _d3Shape = __webpack_require__(439);
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _ReactUtils = __webpack_require__(43);
	
	var _DataUtils = __webpack_require__(66);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CURVE_FACTORIES = {
	  curveBasisClosed: _d3Shape.curveBasisClosed,
	  curveBasisOpen: _d3Shape.curveBasisOpen,
	  curveBasis: _d3Shape.curveBasis,
	  curveLinearClosed: _d3Shape.curveLinearClosed,
	  curveLinear: _d3Shape.curveLinear,
	  curveMonotoneX: _d3Shape.curveMonotoneX,
	  curveMonotoneY: _d3Shape.curveMonotoneY,
	  curveNatural: _d3Shape.curveNatural,
	  curveStep: _d3Shape.curveStep,
	  curveStepAfter: _d3Shape.curveStepAfter,
	  curveStepBefore: _d3Shape.curveStepBefore
	};
	
	var defined = function defined(p) {
	  return p.x === +p.x && p.y === +p.y;
	};
	
	var getX = function getX(p) {
	  return p.x;
	};
	
	var getY = function getY(p) {
	  return p.y;
	};
	
	var getCurveFactory = function getCurveFactory(type, layout) {
	  if ((0, _isFunction2["default"])(type)) {
	    return type;
	  }
	
	  var name = "curve".concat(type.slice(0, 1).toUpperCase()).concat(type.slice(1));
	
	  if (name === 'curveMonotone' && layout) {
	    return CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
	  }
	
	  return CURVE_FACTORIES[name] || _d3Shape.curveLinear;
	};
	
	var Curve =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Curve, _PureComponent);
	
	  function Curve() {
	    _classCallCheck(this, Curve);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Curve).apply(this, arguments));
	  }
	
	  _createClass(Curve, [{
	    key: "getPath",
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _this$props = this.props,
	          type = _this$props.type,
	          points = _this$props.points,
	          baseLine = _this$props.baseLine,
	          layout = _this$props.layout,
	          connectNulls = _this$props.connectNulls;
	      var curveFactory = getCurveFactory(type, layout);
	      var formatPoints = connectNulls ? points.filter(function (entry) {
	        return defined(entry);
	      }) : points;
	      var lineFunction;
	
	      if ((0, _isArray2["default"])(baseLine)) {
	        var formatBaseLine = connectNulls ? baseLine.filter(function (base) {
	          return defined(base);
	        }) : baseLine;
	        var areaPoints = formatPoints.map(function (entry, index) {
	          return _objectSpread({}, entry, {
	            base: formatBaseLine[index]
	          });
	        });
	
	        if (layout === 'vertical') {
	          lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(function (d) {
	            return d.base.x;
	          });
	        } else {
	          lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(function (d) {
	            return d.base.y;
	          });
	        }
	
	        lineFunction.defined(defined).curve(curveFactory);
	        return lineFunction(areaPoints);
	      }
	
	      if (layout === 'vertical' && (0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(baseLine);
	      } else if ((0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(baseLine);
	      } else {
	        lineFunction = (0, _d3Shape.line)().x(getX).y(getY);
	      }
	
	      lineFunction.defined(defined).curve(curveFactory);
	      return lineFunction(formatPoints);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          className = _this$props2.className,
	          points = _this$props2.points,
	          path = _this$props2.path,
	          pathRef = _this$props2.pathRef;
	
	      if ((!points || !points.length) && !path) {
	        return null;
	      }
	
	      var realPath = points && points.length ? this.getPath() : path;
	      return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props, null, true), {
	        className: (0, _classnames["default"])('recharts-curve', className),
	        d: realPath,
	        ref: pathRef
	      }));
	    }
	  }]);
	
	  return Curve;
	}(_react.PureComponent);
	
	Curve.displayName = 'Curve';
	Curve.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  type: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes["default"].func]),
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
	  points: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  connectNulls: _propTypes["default"].bool,
	  path: _propTypes["default"].string,
	  pathRef: _propTypes["default"].func
	});
	Curve.defaultProps = {
	  type: 'linear',
	  points: [],
	  connectNulls: false
	};
	var _default = Curve;
	exports["default"] = _default;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(129));
	
	var _ReactUtils = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getRectangePath = function getRectangePath(x, y, width, height, radius) {
	  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
	  var ySign = height >= 0 ? 1 : -1;
	  var xSign = width >= 0 ? 1 : -1;
	  var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
	  var path;
	
	  if (maxRadius > 0 && radius instanceof Array) {
	    var newRadius = [];
	
	    for (var i = 0, len = 4; i < len; i++) {
	      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
	    }
	
	    path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
	
	    if (newRadius[0] > 0) {
	      path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
	    }
	
	    path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
	
	    if (newRadius[1] > 0) {
	      path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
	    }
	
	    path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
	
	    if (newRadius[2] > 0) {
	      path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
	    }
	
	    path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
	
	    if (newRadius[3] > 0) {
	      path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
	    }
	
	    path += 'Z';
	  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
	    var _newRadius = Math.min(maxRadius, radius);
	
	    path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
	  } else {
	    path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
	  }
	
	  return path;
	};
	
	var Rectangle =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Rectangle, _PureComponent);
	
	  function Rectangle() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Rectangle);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Rectangle)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      totalLength: -1
	    };
	    return _this;
	  }
	
	  _createClass(Rectangle, [{
	    key: "componentDidMount",
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (this.node && this.node.getTotalLength) {
	        try {
	          var totalLength = this.node.getTotalLength();
	
	          if (totalLength) {
	            this.setState({
	              totalLength: totalLength
	            });
	          }
	        } catch (err) {// calculate total length error
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          width = _this$props.width,
	          height = _this$props.height,
	          radius = _this$props.radius,
	          className = _this$props.className;
	      var totalLength = this.state.totalLength;
	      var _this$props2 = this.props,
	          animationEasing = _this$props2.animationEasing,
	          animationDuration = _this$props2.animationDuration,
	          animationBegin = _this$props2.animationBegin,
	          isAnimationActive = _this$props2.isAnimationActive,
	          isUpdateAnimationActive = _this$props2.isUpdateAnimationActive;
	
	      if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-rectangle', className);
	
	      if (!isUpdateAnimationActive) {
	        return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: layerClass,
	          d: getRectangePath(x, y, width, height, radius)
	        }));
	      }
	
	      return _react["default"].createElement(_reactSmooth["default"], {
	        canBegin: totalLength > 0,
	        from: {
	          width: width,
	          height: height,
	          x: x,
	          y: y
	        },
	        to: {
	          width: width,
	          height: height,
	          x: x,
	          y: y
	        },
	        duration: animationDuration,
	        animationEasing: animationEasing,
	        isActive: isUpdateAnimationActive
	      }, function (_ref) {
	        var currWidth = _ref.width,
	            currHeight = _ref.height,
	            currX = _ref.x,
	            currY = _ref.y;
	        return _react["default"].createElement(_reactSmooth["default"], {
	          canBegin: totalLength > 0,
	          from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
	          to: "".concat(totalLength, "px 0px"),
	          attributeName: "strokeDasharray",
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing
	        }, _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(_this2.props), (0, _ReactUtils.filterEventAttributes)(_this2.props), {
	          className: layerClass,
	          d: getRectangePath(currX, currY, currWidth, currHeight, radius),
	          ref: function ref(node) {
	            _this2.node = node;
	          }
	        })));
	      });
	    }
	  }]);
	
	  return Rectangle;
	}(_react.PureComponent);
	
	Rectangle.displayName = 'Rectangle';
	Rectangle.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  radius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
	  isAnimationActive: _propTypes["default"].bool,
	  isUpdateAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	});
	Rectangle.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  // The radius of border
	  // The radius of four corners when radius is a number
	  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
	  radius: 0,
	  isAnimationActive: false,
	  isUpdateAnimationActive: false,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	};
	var _default = Rectangle;
	exports["default"] = _default;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = void 0;
	
	/* eslint no-console: 0 */
	var isDev = ("production") !== 'production';
	
	var warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};
	
	exports.warn = warn;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(94);
	var Subscriber_1 = __webpack_require__(219);
	var Subscription_1 = __webpack_require__(396);
	var ObjectUnsubscribedError_1 = __webpack_require__(2005);
	var SubjectSubscription_1 = __webpack_require__(1979);
	var rxSubscriber_1 = __webpack_require__(555);
	/**
	 * @class SubjectSubscriber<T>
	 */
	var SubjectSubscriber = (function (_super) {
	    __extends(SubjectSubscriber, _super);
	    function SubjectSubscriber(destination) {
	        _super.call(this, destination);
	        this.destination = destination;
	    }
	    return SubjectSubscriber;
	}(Subscriber_1.Subscriber));
	exports.SubjectSubscriber = SubjectSubscriber;
	/**
	 * @class Subject<T>
	 */
	var Subject = (function (_super) {
	    __extends(Subject, _super);
	    function Subject() {
	        _super.call(this);
	        this.observers = [];
	        this.closed = false;
	        this.isStopped = false;
	        this.hasError = false;
	        this.thrownError = null;
	    }
	    Subject.prototype[rxSubscriber_1.rxSubscriber] = function () {
	        return new SubjectSubscriber(this);
	    };
	    Subject.prototype.lift = function (operator) {
	        var subject = new AnonymousSubject(this, this);
	        subject.operator = operator;
	        return subject;
	    };
	    Subject.prototype.next = function (value) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        if (!this.isStopped) {
	            var observers = this.observers;
	            var len = observers.length;
	            var copy = observers.slice();
	            for (var i = 0; i < len; i++) {
	                copy[i].next(value);
	            }
	        }
	    };
	    Subject.prototype.error = function (err) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        this.hasError = true;
	        this.thrownError = err;
	        this.isStopped = true;
	        var observers = this.observers;
	        var len = observers.length;
	        var copy = observers.slice();
	        for (var i = 0; i < len; i++) {
	            copy[i].error(err);
	        }
	        this.observers.length = 0;
	    };
	    Subject.prototype.complete = function () {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        this.isStopped = true;
	        var observers = this.observers;
	        var len = observers.length;
	        var copy = observers.slice();
	        for (var i = 0; i < len; i++) {
	            copy[i].complete();
	        }
	        this.observers.length = 0;
	    };
	    Subject.prototype.unsubscribe = function () {
	        this.isStopped = true;
	        this.closed = true;
	        this.observers = null;
	    };
	    Subject.prototype._trySubscribe = function (subscriber) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else {
	            return _super.prototype._trySubscribe.call(this, subscriber);
	        }
	    };
	    /** @deprecated internal use only */ Subject.prototype._subscribe = function (subscriber) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else if (this.hasError) {
	            subscriber.error(this.thrownError);
	            return Subscription_1.Subscription.EMPTY;
	        }
	        else if (this.isStopped) {
	            subscriber.complete();
	            return Subscription_1.Subscription.EMPTY;
	        }
	        else {
	            this.observers.push(subscriber);
	            return new SubjectSubscription_1.SubjectSubscription(this, subscriber);
	        }
	    };
	    Subject.prototype.asObservable = function () {
	        var observable = new Observable_1.Observable();
	        observable.source = this;
	        return observable;
	    };
	    Subject.create = function (destination, source) {
	        return new AnonymousSubject(destination, source);
	    };
	    return Subject;
	}(Observable_1.Observable));
	exports.Subject = Subject;
	/**
	 * @class AnonymousSubject<T>
	 */
	var AnonymousSubject = (function (_super) {
	    __extends(AnonymousSubject, _super);
	    function AnonymousSubject(destination, source) {
	        _super.call(this);
	        this.destination = destination;
	        this.source = source;
	    }
	    AnonymousSubject.prototype.next = function (value) {
	        var destination = this.destination;
	        if (destination && destination.next) {
	            destination.next(value);
	        }
	    };
	    AnonymousSubject.prototype.error = function (err) {
	        var destination = this.destination;
	        if (destination && destination.error) {
	            this.destination.error(err);
	        }
	    };
	    AnonymousSubject.prototype.complete = function () {
	        var destination = this.destination;
	        if (destination && destination.complete) {
	            this.destination.complete();
	        }
	    };
	    /** @deprecated internal use only */ AnonymousSubject.prototype._subscribe = function (subscriber) {
	        var source = this.source;
	        if (source) {
	            return this.source.subscribe(subscriber);
	        }
	        else {
	            return Subscription_1.Subscription.EMPTY;
	        }
	    };
	    return AnonymousSubject;
	}(Subject));
	exports.AnonymousSubject = AnonymousSubject;
	//# sourceMappingURL=Subject.js.map

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StatusActiveComp = exports.StatusActiveComp__h5_style = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var colors_1 = __webpack_require__(29);
	var IconButton_1 = tslib_1.__importDefault(__webpack_require__(126));
	var IconMenu_1 = tslib_1.__importDefault(__webpack_require__(357));
	var MenuItem_1 = tslib_1.__importDefault(__webpack_require__(101));
	var lens_1 = tslib_1.__importDefault(__webpack_require__(500));
	var eventService_1 = tslib_1.__importDefault(__webpack_require__(120));
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var __anchorOrigin = { horizontal: 'left', vertical: 'top' };
	var iconButton__style = { width: 32, height: 32, padding: "0 8px 0 0" };
	exports.StatusActiveComp__h5_style = { margin: 0, lineHeight: '32px', fontSize: '18px', fontWeight: 'bold' };
	var StatusActiveComp = /** @class */ (function (_super) {
	    tslib_1.__extends(StatusActiveComp, _super);
	    function StatusActiveComp() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onClose = function () {
	            var _a = _this.props, activeObject = _a.activeObject, entity = _a.entity, id = _a.id;
	            console.log('onClose');
	            ((activeObject.$new) ? Promise.resolve({ active: false, closeDate: (0, moment_1.default)().startOf("day").toDate() }) : eventService_1.default.closeObject(entity, id))
	                .then((0, mobx_1.action)("onClose-handler", function (data) {
	                activeObject.active = data.active;
	                activeObject.closeDate = data.closeDate;
	            }));
	        };
	        _this.onOpen = function () {
	            var _a = _this.props, activeObject = _a.activeObject, entity = _a.entity, id = _a.id;
	            console.log('onOpen');
	            ((activeObject.$new) ? Promise.resolve({ active: true }) : eventService_1.default.openObject(entity, id))
	                .then((0, mobx_1.action)("onOpen-handler", function (data) {
	                activeObject.active = data.active;
	                activeObject.closeDate = data.closeDate;
	            }));
	        };
	        return _this;
	    }
	    StatusActiveComp.prototype.render = function () {
	        var _a = this.props, activeObject = _a.activeObject, other = tslib_1.__rest(_a, ["activeObject"]);
	        return (react_1.default.createElement(IconMenu_1.default, { iconButtonElement: react_1.default.createElement(IconButton_1.default, { style: iconButton__style, iconStyle: { color: activeObject.active ? colors_1.green500 : colors_1.grey500 } },
	                react_1.default.createElement(lens_1.default, null)), anchorOrigin: __anchorOrigin, targetOrigin: __anchorOrigin }, (activeObject.active) ? react_1.default.createElement(MenuItem_1.default, { primaryText: "Close", onClick: this.onClose }) : react_1.default.createElement(MenuItem_1.default, { primaryText: "Open", onClick: this.onOpen })));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], StatusActiveComp.prototype, "onClose", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], StatusActiveComp.prototype, "onOpen", void 0);
	    StatusActiveComp = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], StatusActiveComp);
	    return StatusActiveComp;
	}(react_1.default.Component));
	exports.StatusActiveComp = StatusActiveComp;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.LoadingElement = exports.LoadingIcon = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	__webpack_require__(1280);
	var LoadingIcon = function () { return react_1.default.createElement("i", { className: "fa fa-3x fa-refresh fa-spin" }); };
	exports.LoadingIcon = LoadingIcon;
	var LoadingElement = function () { return (react_1.default.createElement("div", { className: "component--loading" },
	    react_1.default.createElement("div", null,
	        react_1.default.createElement(exports.LoadingIcon, null)))); };
	exports.LoadingElement = LoadingElement;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PartyActivityTable = exports.EventHistoryDrawer = exports.ViberMessageEventHistory = exports.SmsMessageEventHistory = exports.EmailEventHistory = exports.EmailHeader = exports.CustomHistoryBlock = exports.EventHistoryBlock = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var arrayUtils_1 = __webpack_require__(78);
	var blockComp_1 = __webpack_require__(30);
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var Drawer_1 = tslib_1.__importDefault(__webpack_require__(286));
	var loading_1 = __webpack_require__(262);
	var variables_1 = __webpack_require__(96);
	var documentComp_1 = tslib_1.__importDefault(__webpack_require__(400));
	var react_bootstrap_1 = __webpack_require__(72);
	var formUtils_1 = __webpack_require__(14);
	var dateUtils_1 = __webpack_require__(49);
	__webpack_require__(666);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var eventDomain_1 = __webpack_require__(74);
	var form_1 = tslib_1.__importDefault(__webpack_require__(52));
	var commonDomain_1 = __webpack_require__(310);
	var mobx_react_1 = __webpack_require__(4);
	var dialogAncestor_1 = __webpack_require__(87);
	var icons = tslib_1.__importStar(__webpack_require__(563));
	var react_router_1 = __webpack_require__(65);
	var utils_1 = __webpack_require__(37);
	var locales_1 = __webpack_require__(15);
	var colors_1 = __webpack_require__(29);
	/* **************************************************************************************
	 *******     EventHistoryDiff     *******************************************************
	 ****************************************************************************************/
	var __iconStyleAdd = { color: colors_1.grey400, width: 22, height: 22 };
	var __iconStyleDelete = { color: colors_1.grey400, width: 19, height: 19 };
	var nee = function () { return false; };
	var EventHistoryFieldDiffBlock = function (_a) {
	    var historyObject = _a.historyObject, entity = _a.entity;
	    return (historyObject.fields && historyObject.fields.length ? (react_1.default.createElement("table", { className: "zz-simple-table" },
	        react_1.default.createElement("thead", null,
	            react_1.default.createElement("tr", null,
	                react_1.default.createElement("th", null, locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Field"], ["Field"])))),
	                react_1.default.createElement("th", null, locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Old value"], ["Old value"])))),
	                react_1.default.createElement("th", null, locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["New value"], ["New value"])))))),
	        react_1.default.createElement("tbody", null, historyObject.fields.map(function (field, index) {
	            var mdField = entity.getField(field.fieldName);
	            return (react_1.default.createElement("tr", { key: index },
	                react_1.default.createElement("td", null, mdField ? mdField.formLabelActive : field.fieldName),
	                react_1.default.createElement("td", null, mdField ? mdField.formatValue(field.oldValue) : field.oldValue),
	                react_1.default.createElement("td", null, mdField ? mdField.formatValue(field.newValue) : field.newValue)));
	        })))) : null);
	};
	var ErrorBlock = function (_a) {
	    var index = _a.index, operationText = _a.operationText, label = _a.label, text = _a.text;
	    return (react_1.default.createElement("div", { className: "eh-object", key: index },
	        react_1.default.createElement("div", { className: "eh-object-header" },
	            react_1.default.createElement("span", { className: "operation" }, operationText),
	            react_1.default.createElement("span", { className: "text" }, label)),
	        react_1.default.createElement("div", { className: "eh-object-full" },
	            react_1.default.createElement("p", null, text))));
	};
	var EventHistoryBlock = function (_a) {
	    var eventHistory = _a.eventHistory, entities = _a.entities;
	    var EventCatIcon = icons[eventDomain_1.EVENTCATEGORY_MAP[eventHistory.eventCategory].icon];
	    return (react_1.default.createElement("div", { className: "event-history" },
	        react_1.default.createElement("div", { className: "eh-header" },
	            react_1.default.createElement("div", { className: "eh-header-left" },
	                react_1.default.createElement(EventCatIcon, null),
	                react_1.default.createElement("div", { className: "text" }, (0, formUtils_1.lovLabel)(eventHistory.eventType))),
	            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "bottom", delayShow: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: eventHistory.eventHistoryId + "_dateTooltip" }, (0, dateUtils_1.formatDateTime)(eventHistory.dateCreated)) },
	                react_1.default.createElement("span", null,
	                    eventHistory.userCreated,
	                    ", ",
	                    (0, moment_1.default)(eventHistory.dateCreated).fromNow()))),
	        (eventHistory.message) ? (react_1.default.createElement("div", { className: "eh-objects" }, eventHistory.message)) : null,
	        (eventHistory.eventCategory === eventDomain_1.EVENTCATEGORY.DATA_EVENT && eventHistory.historyObjects.length) ?
	            react_1.default.createElement("div", { className: "eh-objects" }, (0, arrayUtils_1.addSeparator)(eventHistory.historyObjects.map(function (historyObject, index) {
	                var entity = entities.get(historyObject.entityName);
	                var operationText = (historyObject.operation === eventDomain_1.DMLOPERATION.INSERT) ? locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["ADDED"], ["ADDED"]))) : ((historyObject.operation === eventDomain_1.DMLOPERATION.DELETE) ? locales_1.loc.i18n(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["DELETED"], ["DELETED"]))) : locales_1.loc.i18n(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["UPDATED"], ["UPDATED"]))));
	                if (!entity) {
	                    return react_1.default.createElement(ErrorBlock, { text: "Entity " + historyObject.entityName + " does not exists in Entities map", operationText: operationText, key: index, index: index, label: (0, formUtils_1.lovLabel)(entity) });
	                }
	                // full render
	                if ((historyObject.operation === eventDomain_1.DMLOPERATION.INSERT || historyObject.operation === eventDomain_1.DMLOPERATION.DELETE) && historyObject.fullObject) {
	                    var entityConfig = mdEntityService_1.default.getEntityConfig(historyObject.entityName);
	                    var formName = entityConfig.getFormName(historyObject);
	                    var ClosedContent = mdEntityService_1.default.getClosedContent(formName);
	                    if (!ClosedContent) {
	                        return react_1.default.createElement(ErrorBlock, { text: "ClosedContent for formName " + formName + " does not exists in CLOSED_CONTENT_REGISTRY", operationText: operationText, key: index, index: index, label: (0, formUtils_1.lovLabel)(entity) });
	                    }
	                    var formDefinition = mdEntityService_1.default.getFormDefinition(formName);
	                    if (!formDefinition) {
	                        return react_1.default.createElement(ErrorBlock, { text: "Form Definition for formName " + formName + " does not exists in FORM_DEFINITION_REGISTRY", operationText: operationText, key: index, index: index, label: (0, formUtils_1.lovLabel)(entity) });
	                    }
	                    var form = (historyObject.fullObject.getForm) ? historyObject.fullObject.getForm(formName) : new form_1.default(formName, formDefinition);
	                    var fields = form.setupFields(historyObject.fullObject, historyObject.fullObject, entity, entities, null);
	                    return (react_1.default.createElement("div", { className: "eh-object", key: index },
	                        react_1.default.createElement("div", { className: "eh-object-header" },
	                            react_1.default.createElement("span", { className: "operation" }, operationText),
	                            react_1.default.createElement("span", { className: "text" }, entity.label)),
	                        react_1.default.createElement("div", { className: "eh-object-full" }, react_1.default.createElement(ClosedContent, {
	                            dataObject: historyObject.fullObject,
	                            rootObject: historyObject.fullObject,
	                            entities: entities,
	                            entity: entity,
	                            fields: fields,
	                            key: index,
	                            disabled: true
	                        }, null)),
	                        react_1.default.createElement(EventHistoryFieldDiffBlock, { entity: entity, historyObject: historyObject })));
	                }
	                // diff render
	                return (react_1.default.createElement("div", { className: "eh-object", key: index },
	                    react_1.default.createElement("div", { className: "eh-object-header" },
	                        react_1.default.createElement("span", { className: "operation" }, operationText),
	                        react_1.default.createElement("span", { className: "text" }, "".concat(entity.label, " - ").concat(historyObject.entityLabel))),
	                    react_1.default.createElement(EventHistoryFieldDiffBlock, { entity: entity, historyObject: historyObject })));
	            }), react_1.default.createElement(blockComp_1.MdDivider, null)))
	            : null,
	        (eventHistory.eventCategory === eventDomain_1.EVENTCATEGORY.DATA_EVENT && eventHistory.documents.length) ?
	            react_1.default.createElement("div", { className: "eh-documents" },
	                react_1.default.createElement(documentComp_1.default, { documents: eventHistory.documents, entities: entities, style: { flex: '1 1 auto' }, enableUpload: false, documentEntity: entities.get('Document'), canDeleteFn: nee }))
	            : null,
	        (eventHistory.eventCategory === eventDomain_1.EVENTCATEGORY.EMAIL_EVENT) ? react_1.default.createElement(exports.EmailEventHistory, { eventHistory: eventHistory }) : null,
	        (eventHistory.eventCategory === eventDomain_1.EVENTCATEGORY.SMS_EVENT) ? react_1.default.createElement(exports.SmsMessageEventHistory, { eventHistory: eventHistory }) : null,
	        (eventHistory.eventCategory === eventDomain_1.EVENTCATEGORY.VIBER_EVENT) ? react_1.default.createElement(exports.ViberMessageEventHistory, { eventHistory: eventHistory }) : null));
	};
	exports.EventHistoryBlock = EventHistoryBlock;
	var CustomHistoryBlock = function (_a) {
	    var icon = _a.icon, name = _a.name, dateCreated = _a.dateCreated, userCreated = _a.userCreated, objectElement = _a.objectElement;
	    var EventCatIcon = icons[icon];
	    return (react_1.default.createElement("div", { className: "event-history" },
	        react_1.default.createElement("div", { className: "eh-header" },
	            react_1.default.createElement("div", { className: "eh-header-left" },
	                react_1.default.createElement(EventCatIcon, null),
	                react_1.default.createElement("div", { className: "text" }, name)),
	            react_1.default.createElement("div", null,
	                userCreated,
	                ", ",
	                (0, moment_1.default)(dateCreated).fromNow())),
	        react_1.default.createElement("div", { className: "eh-objects" },
	            react_1.default.createElement("div", { className: "eh-object" },
	                react_1.default.createElement("div", { className: "eh-object-full" }, objectElement)))));
	};
	exports.CustomHistoryBlock = CustomHistoryBlock;
	var EmailHeader = function (_a) {
	    var emailFrom = _a.emailFrom, emailRecipients = _a.emailRecipients;
	    var to = (0, eventDomain_1.toEmailAddress)(emailRecipients);
	    var cc = (0, eventDomain_1.ccEmailAddress)(emailRecipients);
	    var bcc = (0, eventDomain_1.bccEmailAddress)(emailRecipients);
	    return (react_1.default.createElement("table", { className: "eh-email-table" },
	        react_1.default.createElement("tbody", null,
	            react_1.default.createElement("tr", null,
	                react_1.default.createElement("td", null, "From: "),
	                react_1.default.createElement("td", null, emailFrom)),
	            (to.length) ? react_1.default.createElement("tr", null,
	                react_1.default.createElement("td", null, "To"),
	                react_1.default.createElement("td", null,
	                    " ",
	                    to.join(", "),
	                    " ")) : null,
	            (cc.length) ? react_1.default.createElement("tr", null,
	                react_1.default.createElement("td", null, "Cc"),
	                react_1.default.createElement("td", null,
	                    " ",
	                    cc.join(", "),
	                    " ")) : null,
	            (bcc.length) ? react_1.default.createElement("tr", null,
	                react_1.default.createElement("td", null, "Bcc"),
	                react_1.default.createElement("td", null,
	                    " ",
	                    bcc.join(", "),
	                    " ")) : null)));
	};
	exports.EmailHeader = EmailHeader;
	var EmailEventHistory = function (_a) {
	    var eventHistory = _a.eventHistory;
	    return (react_1.default.createElement("div", { className: "eh-email" },
	        react_1.default.createElement("h5", null, eventHistory.emailSubject),
	        react_1.default.createElement(exports.EmailHeader, { emailFrom: eventHistory.emailFrom, emailRecipients: eventHistory.emailRecipients }),
	        react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: eventHistory.emailBody } })));
	};
	exports.EmailEventHistory = EmailEventHistory;
	var SmsMessageEventHistory = function (_a) {
	    var eventHistory = _a.eventHistory;
	    return (react_1.default.createElement("div", { className: "eh-email" },
	        react_1.default.createElement("div", { className: "eh-object-header" },
	            react_1.default.createElement("span", { className: "operation" }, "Phone Number"),
	            react_1.default.createElement("span", { className: "text" }, eventHistory.smsMessage.toNumber)),
	        react_1.default.createElement("div", { className: "eh-object-header" },
	            react_1.default.createElement("span", { className: "operation" }, "Message"),
	            react_1.default.createElement("span", { className: "text" }, (0, formUtils_1.lovLabel)(eventHistory.smsMessage.smsText))),
	        (!eventHistory.smsMessage.success) ? (react_1.default.createElement("div", { className: "eh-object-header" },
	            react_1.default.createElement("span", { className: "operation" }, "Error"),
	            react_1.default.createElement("span", { className: "text", style: { color: colors_1.red500 } }, eventHistory.smsMessage.errorDescription))) : null,
	        (eventHistory.smsMessage.deliverySuccess === true) ? (react_1.default.createElement("div", { className: "eh-object-header" },
	            react_1.default.createElement("span", { className: "text", style: { color: colors_1.green500 } },
	                "Delivered on ",
	                (0, dateUtils_1.formatDateTime)(eventHistory.smsMessage.deliveryTime)))) : null,
	        (eventHistory.smsMessage.deliverySuccess === false) ? (react_1.default.createElement("div", { className: "eh-object-header" },
	            react_1.default.createElement("span", { className: "text", style: { color: colors_1.orange700 } },
	                "Delivery Failed confirmation on ",
	                (0, dateUtils_1.formatDateTime)(eventHistory.smsMessage.deliveryTime)))) : null));
	};
	exports.SmsMessageEventHistory = SmsMessageEventHistory;
	var ViberMessageEventHistory = function (_a) {
	    var eventHistory = _a.eventHistory;
	    return (react_1.default.createElement("div", { className: "eh-email" },
	        react_1.default.createElement("div", { className: "eh-object-header" },
	            react_1.default.createElement("span", { className: "operation" }, "Viber user id"),
	            react_1.default.createElement("span", { className: "text" }, eventHistory.viberMessage.toUserId)),
	        react_1.default.createElement("div", { className: "eh-object-header" },
	            react_1.default.createElement("span", { className: "operation" }, "Message"),
	            react_1.default.createElement("span", { className: "text" }, (0, formUtils_1.lovLabel)(eventHistory.viberMessage.messageText))),
	        (eventHistory.viberMessage.errorDescription) ? (react_1.default.createElement("div", { className: "eh-object-header" },
	            react_1.default.createElement("span", { className: "operation" }, "Error"),
	            react_1.default.createElement("span", { className: "text", style: { color: colors_1.red500 } }, eventHistory.viberMessage.errorDescription))) : null,
	        (eventHistory.viberMessage.deliverySuccess === true) ? (react_1.default.createElement("div", { className: "eh-object-header" },
	            react_1.default.createElement("span", { className: "text", style: { color: colors_1.green500 } },
	                "Delivered on ",
	                (0, dateUtils_1.formatDateTime)(eventHistory.viberMessage.dateUpdated)))) : null,
	        (eventHistory.viberMessage.deliverySuccess === false) ? (react_1.default.createElement("div", { className: "eh-object-header" },
	            react_1.default.createElement("span", { className: "text", style: { color: colors_1.orange700 } }, "Delivery Failed confirmation"))) : null));
	};
	exports.ViberMessageEventHistory = ViberMessageEventHistory;
	var EventHistoryDrawer = function (_a) {
	    var eventHistories = _a.eventHistories, entities = _a.entities, open = _a.open, loading = _a.loading, onRequestChange = _a.onRequestChange;
	    var screenWidth = document.body.getBoundingClientRect().width;
	    return (react_1.default.createElement(Drawer_1.default, { openSecondary: true, open: open, width: ((screenWidth < variables_1.screenSm) ? 0.9 : 0.6) * screenWidth, docked: false, onRequestChange: onRequestChange, containerStyle: { paddingTop: 40 } },
	        (loading) ? react_1.default.createElement(loading_1.LoadingElement, null) : null,
	        (eventHistories && eventHistories.length) ?
	            (0, arrayUtils_1.addSeparator)(eventHistories.map(function (eventHistory, index) { return (react_1.default.createElement(exports.EventHistoryBlock, { eventHistory: eventHistory, entities: entities, key: index })); }), react_1.default.createElement(blockComp_1.MdDivider, { inset: true })) : null));
	};
	exports.EventHistoryDrawer = EventHistoryDrawer;
	exports.PartyActivityTable = (0, mobx_react_1.observer)(function (_a) {
	    var statuses = _a.statuses, showErrors = _a.showErrors;
	    return (react_1.default.createElement("table", { className: "table table-condensed fullwrap" },
	        react_1.default.createElement("tbody", null, statuses.filter(function (es) { return showErrors || es.status !== commonDomain_1.SEVERITY.ERROR; }).map(function (es, index) {
	            var _className = (0, dialogAncestor_1.entityStatusCss)(es);
	            return (react_1.default.createElement("tr", { key: index },
	                react_1.default.createElement("td", { className: _className },
	                    (es.partyActivity && (0, arrayUtils_1.notEmpty)(es.partyActivity.objects)) ? (react_1.default.createElement("div", null, es.partyActivity.objects.map(function (pao, index) { return react_1.default.createElement("div", { key: index, style: { marginLeft: 10 } }, (0, formUtils_1.lovLabel)(pao.fullObject)); }))) : null,
	                    (es.partyActivity) ? react_1.default.createElement("div", null,
	                        "Customer:",
	                        react_1.default.createElement(react_router_1.Link, { to: "partyDetail", params: { id: (0, formUtils_1.lovValue)(es.partyActivity.customer) }, query: (0, utils_1.addTenantToQuery)() },
	                            react_1.default.createElement("span", { className: _className }, (0, formUtils_1.lovLabel)(es.partyActivity.customer)))) : null,
	                    (es.partyActivity && (0, arrayUtils_1.notEmpty)(es.partyActivity.persons)) ? (react_1.default.createElement("div", null,
	                        react_1.default.createElement("span", null, "Persons"),
	                        es.partyActivity.persons.map(function (person, index) { return react_1.default.createElement("div", { key: index, style: { marginLeft: 10 } },
	                            react_1.default.createElement(react_router_1.Link, { to: "partyDetail", params: { id: (0, formUtils_1.lovValue)(person) }, query: (0, utils_1.addTenantToQuery)() },
	                                react_1.default.createElement("span", { className: _className }, (0, formUtils_1.lovLabel)(person)))); }))) : null,
	                    ((0, arrayUtils_1.notEmpty)(es.messages)) ? (react_1.default.createElement("table", { style: { marginLeft: 20 } },
	                        react_1.default.createElement("tbody", null, es.messages.map(function (messageObj, index) { return (react_1.default.createElement("tr", { key: index },
	                            react_1.default.createElement("td", { className: (0, dialogAncestor_1.validationMessageCss)(messageObj) }, messageObj.message))); })))) : null),
	                react_1.default.createElement("td", { className: _className }, (es.partyActivity) ? react_1.default.createElement(exports.EmailHeader, { emailFrom: es.partyActivity.emailFrom, emailRecipients: es.partyActivity.emailRecipients }) : null),
	                react_1.default.createElement("td", { className: _className }, (0, dialogAncestor_1.entityStatusText)(es))));
	        }))));
	});
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var gridConfigCondition_1 = tslib_1.__importDefault(__webpack_require__(194));
	var gridConfigSort_1 = tslib_1.__importDefault(__webpack_require__(936));
	var gridConfigColumn_1 = tslib_1.__importDefault(__webpack_require__(935));
	var mobx_1 = __webpack_require__(5);
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var DomainAncestor_1 = __webpack_require__(33);
	var GridConfig = /** @class */ (function (_super) {
	    tslib_1.__extends(GridConfig, _super);
	    function GridConfig(gridLocation, json) {
	        var _this = _super.call(this, json) || this;
	        _this.$gridLocationRef = gridLocation;
	        _this.conditions = (_this.conditions) ? _this.conditions.map(function (jsonGcc) { return new gridConfigCondition_1.default(_this, jsonGcc); }) : [];
	        _this.columns = (_this.columns) ? _this.columns.map(function (jsonGcc) { return new gridConfigColumn_1.default(_this, jsonGcc); }) : [];
	        _this.sortColumns = (_this.sortColumns) ? _this.sortColumns.map(function (jsonGcc) { return new gridConfigSort_1.default(_this, jsonGcc); }) : [];
	        if (!_this.specialConditions)
	            _this.specialConditions = [];
	        if (!_this.$errorMap)
	            _this.$errorMap = new mobx_1.ObservableMap();
	        return _this;
	    }
	    GridConfig_1 = GridConfig;
	    GridConfig.newInstance = function (gridLocation) {
	        var gridConfig = new GridConfig_1(gridLocation, {
	            $new: true,
	            configLevel: metaConstant_1.CONFIGLEVEL.USER,
	            gridScrollSize: gridLocation.defaultScrollSize,
	            gridPageSize: gridLocation.defaultPageSize,
	            maxColumnWidth: gridLocation.defaultMaxColumnWidth,
	            hardRowLimit: gridLocation.defaultHardRowLimit,
	            refreshOnPage: gridLocation.defaultRefreshOnPage,
	            refreshOnData: gridLocation.defaultRefreshOnData,
	            gridName: ''
	        });
	        gridConfig.gridLocation = gridLocation.gridLocation;
	        gridConfig.$gridLocationRef = gridLocation;
	        gridConfig.entityName = gridLocation.entityName;
	        return gridConfig;
	    };
	    GridConfig.prototype.getId = function () {
	        return this.gridId;
	    };
	    GridConfig.prototype.setId = function (id) {
	        this.gridId = id;
	    };
	    GridConfig.prototype.getEntityRef = function () {
	        return this.$gridLocationRef.$entityRef;
	    };
	    GridConfig.prototype.clone = function () {
	        var newGridConfig = new GridConfig_1(this.$gridLocationRef, null);
	        Object.assign(newGridConfig, this);
	        newGridConfig.columns = [];
	        newGridConfig.conditions = [];
	        newGridConfig.sortColumns = [];
	        newGridConfig.$errorMap = new mobx_1.ObservableMap();
	        // copy columns
	        for (var _i = 0, _a = this.columns; _i < _a.length; _i++) {
	            var s = _a[_i];
	            newGridConfig.columns.push(new gridConfigColumn_1.default(newGridConfig, s));
	        }
	        // copy conditions
	        for (var _b = 0, _c = this.conditions; _b < _c.length; _b++) {
	            var c = _c[_b];
	            newGridConfig.conditions.push(c.clone());
	        }
	        // copy sortColumns
	        for (var _d = 0, _e = this.sortColumns; _d < _e.length; _d++) {
	            var s = _e[_d];
	            newGridConfig.sortColumns.push(new gridConfigSort_1.default(newGridConfig, s));
	        }
	        return newGridConfig;
	    };
	    Object.defineProperty(GridConfig.prototype, "searchLabel", {
	        get: function () {
	            return this.columns.filter(function (gcCol) { return gcCol.field && gcCol.field.searchTermType; }).map(function (gcCol) {
	                var operatorLabel = mdEntityService_1.default.entityMap.get('FILTEROPERATOR').lovItems.find(function (v) { return v.value === gcCol.field.searchTermType; }).label;
	                return gcCol.field.label + ": " + operatorLabel;
	            });
	        },
	        enumerable: false,
	        configurable: true
	    });
	    GridConfig.prototype.getSuperFilters = function () {
	        return this.conditions.filter(function (gcc) { return gcc.superFilter; });
	    };
	    var GridConfig_1;
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "columns", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "conditions", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "gridId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "configLevel", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "user", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "tenant", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "tenantGroup", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "gridName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "sortColumns", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "gridWidths", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "defaultGrid", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "gridScrollSize", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "gridPageSize", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "maxColumnWidth", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "hardRowLimit", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "refreshOnPage", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "refreshOnData", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "gridRowCss", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "$errorMap", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "specialConditions", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfig.prototype, "sqlCommand", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridConfig.prototype, "clone", null);
	    tslib_1.__decorate([
	        mobx_1.computed
	    ], GridConfig.prototype, "searchLabel", null);
	    GridConfig = GridConfig_1 = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], GridConfig);
	    return GridConfig;
	}(DomainAncestor_1.DomainAncestor));
	exports.default = GridConfig;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectVersionParamValue = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var ProjectVersionParamValue = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionParamValue, _super);
	    function ProjectVersionParamValue(json) {
	        return _super.call(this, json) || this;
	    }
	    ProjectVersionParamValue.prototype.getId = function () {
	        return this.valueId;
	    };
	    ProjectVersionParamValue.prototype.setId = function (id) {
	        this.valueId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionParamValue.prototype, "valueId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionParamValue.prototype, "paramNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionParamValue.prototype, "value", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionParamValue.prototype, "projectVersion", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionParamValue.prototype, "parameter", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionParamValue.prototype, "count", void 0);
	    ProjectVersionParamValue = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ProjectVersionParamValue);
	    return ProjectVersionParamValue;
	}(DomainAncestor_1.DomainAncestor));
	exports.ProjectVersionParamValue = ProjectVersionParamValue;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(411);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 268 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 269 */
[2327, 232],
/* 270 */
[2357, 433, 437, 149],
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BlockMapBuilder
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(60);
	
	var OrderedMap = Immutable.OrderedMap;
	
	
	var BlockMapBuilder = {
	  createFromArray: function createFromArray(blocks) {
	    return OrderedMap(blocks.map(function (block) {
	      return [block.getKey(), block];
	    }));
	  }
	};
	
	module.exports = BlockMapBuilder;

/***/ }),
/* 272 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findRangesImmutable
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Search through an array to find contiguous stretches of elements that
	 * match a specified filter function.
	 *
	 * When ranges are found, execute a specified `found` function to supply
	 * the values to the caller.
	 */
	function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
	  if (!haystack.size) {
	    return;
	  }
	
	  var cursor = 0;
	
	  haystack.reduce(function (value, nextValue, nextIndex) {
	    if (!areEqualFn(value, nextValue)) {
	      if (filterFn(value)) {
	        foundFn(cursor, nextIndex);
	      }
	      cursor = nextIndex;
	    }
	    return nextValue;
	  });
	
	  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
	}
	
	module.exports = findRangesImmutable;

/***/ }),
/* 273 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventHandled
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Utility method for determining whether or not the value returned
	 * from a handler indicates that it was handled.
	 */
	function isEventHandled(value) {
	  return value === 'handled' || value === true;
	}
	
	module.exports = isEventHandled;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeTextWithStrategy
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(104);
	
	/**
	 * For a collapsed selection state, remove text based on the specified strategy.
	 * If the selection state is not collapsed, remove the entire selected range.
	 */
	function removeTextWithStrategy(editorState, strategy, direction) {
	  var selection = editorState.getSelection();
	  var content = editorState.getCurrentContent();
	  var target = selection;
	  if (selection.isCollapsed()) {
	    if (direction === 'forward') {
	      if (editorState.isSelectionAtEndOfContent()) {
	        return content;
	      }
	    } else if (editorState.isSelectionAtStartOfContent()) {
	      return content;
	    }
	
	    target = strategy(editorState);
	    if (target === selection) {
	      return content;
	    }
	  }
	  return DraftModifier.removeRange(content, target, direction);
	}
	
	module.exports = removeTextWithStrategy;

/***/ }),
/* 275 */
203,
/* 276 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 277 */,
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(470),
	    isFlattenable = __webpack_require__(1436);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(695),
	    baseAssignValue = __webpack_require__(471);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1361),
	    Map = __webpack_require__(464),
	    Promise = __webpack_require__(1363),
	    Set = __webpack_require__(691),
	    WeakMap = __webpack_require__(1364),
	    baseGetTag = __webpack_require__(151),
	    toSource = __webpack_require__(720);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(283),
	    isArrayLike = __webpack_require__(185),
	    isIndex = __webpack_require__(348),
	    isObject = __webpack_require__(100);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(240);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 283 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(703),
	    getTag = __webpack_require__(280),
	    isArguments = __webpack_require__(352),
	    isArray = __webpack_require__(62),
	    isArrayLike = __webpack_require__(185),
	    isBuffer = __webpack_require__(354),
	    isPrototype = __webpack_require__(349),
	    isTypedArray = __webpack_require__(482);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultUtils = undefined;
	exports.dateTimeFormat = dateTimeFormat;
	exports.getYear = getYear;
	exports.setYear = setYear;
	exports.addDays = addDays;
	exports.addMonths = addMonths;
	exports.addYears = addYears;
	exports.cloneDate = cloneDate;
	exports.cloneAsDate = cloneAsDate;
	exports.getDaysInMonth = getDaysInMonth;
	exports.getFirstDayOfMonth = getFirstDayOfMonth;
	exports.getFirstDayOfWeek = getFirstDayOfWeek;
	exports.getWeekArray = getWeekArray;
	exports.localizedWeekday = localizedWeekday;
	exports.formatIso = formatIso;
	exports.isEqualDate = isEqualDate;
	exports.isBeforeDate = isBeforeDate;
	exports.isAfterDate = isAfterDate;
	exports.isBetweenDates = isBetweenDates;
	exports.monthDiff = monthDiff;
	exports.yearDiff = yearDiff;
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dayAbbreviation = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
	var dayList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	var monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	var monthLongList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	function dateTimeFormat(locale, options) {
	   false ? (0, _warning2.default)(locale === 'en-US', 'Material-UI: The ' + locale + ' locale is not supported by the built-in DateTimeFormat.\n  Use the `DateTimeFormat` prop to supply an alternative implementation.') : void 0;
	
	  this.format = function (date) {
	    if (options.month === 'short' && options.weekday === 'short' && options.day === '2-digit') {
	      return dayList[date.getDay()] + ', ' + monthList[date.getMonth()] + ' ' + date.getDate();
	    } else if (options.year === 'numeric' && options.month === 'numeric' && options.day === 'numeric') {
	      return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
	    } else if (options.year === 'numeric' && options.month === 'long') {
	      return monthLongList[date.getMonth()] + ' ' + date.getFullYear();
	    } else if (options.weekday === 'narrow') {
	      return dayAbbreviation[date.getDay()];
	    } else if (options.year === 'numeric') {
	      return date.getFullYear().toString();
	    } else if (options.day === 'numeric') {
	      return date.getDate();
	    } else {
	       false ? (0, _warning2.default)(false, 'Material-UI: Wrong usage of DateTimeFormat') : void 0;
	    }
	  };
	}
	
	function getYear(d) {
	  return d.getFullYear();
	}
	
	function setYear(d, year) {
	  var newDate = cloneDate(d);
	  newDate.setFullYear(year);
	  return newDate;
	}
	
	function addDays(d, days) {
	  var newDate = cloneDate(d);
	  newDate.setDate(d.getDate() + days);
	  return newDate;
	}
	
	function addMonths(d, months) {
	  var newDate = cloneDate(d);
	  newDate.setMonth(d.getMonth() + months);
	  return newDate;
	}
	
	function addYears(d, years) {
	  var newDate = cloneDate(d);
	  newDate.setFullYear(d.getFullYear() + years);
	  return newDate;
	}
	
	function cloneDate(d) {
	  return new Date(d.getTime());
	}
	
	function cloneAsDate(d) {
	  var clonedDate = cloneDate(d);
	  clonedDate.setHours(0, 0, 0, 0);
	  return clonedDate;
	}
	
	function getDaysInMonth(d) {
	  var resultDate = getFirstDayOfMonth(d);
	
	  resultDate.setMonth(resultDate.getMonth() + 1);
	  resultDate.setDate(resultDate.getDate() - 1);
	
	  return resultDate.getDate();
	}
	
	function getFirstDayOfMonth(d) {
	  return new Date(d.getFullYear(), d.getMonth(), 1);
	}
	
	function getFirstDayOfWeek() {
	  var now = new Date();
	  return new Date(now.setDate(now.getDate() - now.getDay()));
	}
	
	function getWeekArray(d, firstDayOfWeek) {
	  var dayArray = [];
	  var daysInMonth = getDaysInMonth(d);
	  var weekArray = [];
	  var week = [];
	
	  for (var i = 1; i <= daysInMonth; i++) {
	    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i));
	  }
	
	  var addWeek = function addWeek(week) {
	    var emptyDays = 7 - week.length;
	    for (var _i = 0; _i < emptyDays; ++_i) {
	      week[weekArray.length ? 'push' : 'unshift'](null);
	    }
	    weekArray.push(week);
	  };
	
	  dayArray.forEach(function (day) {
	    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
	      addWeek(week);
	      week = [];
	    }
	    week.push(day);
	    if (dayArray.indexOf(day) === dayArray.length - 1) {
	      addWeek(week);
	    }
	  });
	
	  return weekArray;
	}
	
	function localizedWeekday(DateTimeFormat, locale, day, firstDayOfWeek) {
	  var weekdayFormatter = new DateTimeFormat(locale, { weekday: 'narrow' });
	  var firstDayDate = getFirstDayOfWeek();
	
	  return weekdayFormatter.format(addDays(firstDayDate, day + firstDayOfWeek));
	}
	
	// Convert date to ISO 8601 (YYYY-MM-DD) date string, accounting for current timezone
	function formatIso(date) {
	  return new Date(date.toDateString() + ' 12:00:00 +0000').toISOString().substring(0, 10);
	}
	
	function isEqualDate(d1, d2) {
	  return d1 && d2 && d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
	}
	
	function isBeforeDate(d1, d2) {
	  var date1 = cloneAsDate(d1);
	  var date2 = cloneAsDate(d2);
	
	  return date1.getTime() < date2.getTime();
	}
	
	function isAfterDate(d1, d2) {
	  var date1 = cloneAsDate(d1);
	  var date2 = cloneAsDate(d2);
	
	  return date1.getTime() > date2.getTime();
	}
	
	function isBetweenDates(dateToCheck, startDate, endDate) {
	  return !isBeforeDate(dateToCheck, startDate) && !isAfterDate(dateToCheck, endDate);
	}
	
	function monthDiff(d1, d2) {
	  var m = void 0;
	  m = (d1.getFullYear() - d2.getFullYear()) * 12;
	  m += d1.getMonth();
	  m -= d2.getMonth();
	  return m;
	}
	
	function yearDiff(d1, d2) {
	  return ~~(monthDiff(d1, d2) / 12);
	}
	
	var defaultUtils = exports.defaultUtils = {
	  getYear: getYear,
	  setYear: setYear,
	  addDays: addDays,
	  addMonths: addMonths,
	  addYears: addYears,
	  getFirstDayOfMonth: getFirstDayOfMonth,
	  getWeekArray: getWeekArray,
	  monthDiff: monthDiff
	};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Drawer = __webpack_require__(1516);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Drawer2.default;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.RadioButtonGroup = exports.RadioButton = undefined;
	
	var _RadioButton2 = __webpack_require__(751);
	
	var _RadioButton3 = _interopRequireDefault(_RadioButton2);
	
	var _RadioButtonGroup2 = __webpack_require__(243);
	
	var _RadioButtonGroup3 = _interopRequireDefault(_RadioButtonGroup2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.RadioButton = _RadioButton3.default;
	exports.RadioButtonGroup = _RadioButtonGroup3.default;
	exports.default = _RadioButton3.default;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Stepper = exports.StepLabel = exports.StepContent = exports.StepButton = exports.Step = undefined;
	
	var _Step2 = __webpack_require__(752);
	
	var _Step3 = _interopRequireDefault(_Step2);
	
	var _StepButton2 = __webpack_require__(753);
	
	var _StepButton3 = _interopRequireDefault(_StepButton2);
	
	var _StepContent2 = __webpack_require__(754);
	
	var _StepContent3 = _interopRequireDefault(_StepContent2);
	
	var _StepLabel2 = __webpack_require__(494);
	
	var _StepLabel3 = _interopRequireDefault(_StepLabel2);
	
	var _Stepper2 = __webpack_require__(755);
	
	var _Stepper3 = _interopRequireDefault(_Stepper2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Step = _Step3.default;
	exports.StepButton = _StepButton3.default;
	exports.StepContent = _StepContent3.default;
	exports.StepLabel = _StepLabel3.default;
	exports.Stepper = _Stepper3.default;

/***/ }),
/* 289 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addHours = addHours;
	exports.addMinutes = addMinutes;
	exports.addSeconds = addSeconds;
	exports.formatTime = formatTime;
	exports.rad2deg = rad2deg;
	exports.getTouchEventOffsetValues = getTouchEventOffsetValues;
	exports.isInner = isInner;
	function addHours(d, hours) {
	  var newDate = clone(d);
	  newDate.setHours(d.getHours() + hours);
	  return newDate;
	}
	
	function addMinutes(d, minutes) {
	  var newDate = clone(d);
	  newDate.setMinutes(d.getMinutes() + minutes);
	  return newDate;
	}
	
	function addSeconds(d, seconds) {
	  var newDate = clone(d);
	  newDate.setSeconds(d.getMinutes() + seconds);
	  return newDate;
	}
	
	function clone(d) {
	  return new Date(d.getTime());
	}
	
	/**
	 * @param date [Date] A Date object.
	 * @param format [String] One of 'ampm', '24hr', defaults to 'ampm'.
	 * @param pedantic [Boolean] Check time-picker/time-picker.jsx file.
	 *
	 * @return String A string representing the formatted time.
	 */
	function formatTime(date) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ampm';
	  var pedantic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!date) return '';
	  var hours = date.getHours();
	  var mins = date.getMinutes().toString();
	
	  if (format === 'ampm') {
	    var isAM = hours < 12;
	    hours = hours % 12;
	    var additional = isAM ? ' am' : ' pm';
	    hours = (hours || 12).toString();
	
	    if (mins.length < 2) mins = '0' + mins;
	
	    if (pedantic) {
	      // Treat midday/midnight specially http://www.nist.gov/pml/div688/times.cfm
	      if (hours === '12' && mins === '00') {
	        return additional === ' pm' ? '12 noon' : '12 midnight';
	      }
	    }
	
	    return hours + (mins === '00' ? '' : ':' + mins) + additional;
	  }
	
	  hours = hours.toString();
	
	  if (hours.length < 2) hours = '0' + hours;
	  if (mins.length < 2) mins = '0' + mins;
	
	  return hours + ':' + mins;
	}
	
	function rad2deg(rad) {
	  return rad * 57.29577951308232;
	}
	
	function getTouchEventOffsetValues(event) {
	  var el = event.target;
	  var boundingRect = el.getBoundingClientRect();
	
	  return {
	    offsetX: event.clientX - boundingRect.left,
	    offsetY: event.clientY - boundingRect.top
	  };
	}
	
	function isInner(props) {
	  if (props.type !== 'hour') {
	    return false;
	  }
	  return props.value < 1 || props.value > 12;
	}

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(1040);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(1581);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationMoreVert = function NavigationMoreVert(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	NavigationMoreVert = (0, _pure2.default)(NavigationMoreVert);
	NavigationMoreVert.displayName = 'NavigationMoreVert';
	NavigationMoreVert.muiName = 'SvgIcon';
	
	exports.default = NavigationMoreVert;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(223);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _StyleConfig = __webpack_require__(98);
	
	var _SafeAnchor = __webpack_require__(154);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  active: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  block: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  componentClass: _elementType2.default,
	  href: _propTypes2.default.string,
	  /**
	   * Defines HTML button type attribute
	   * @defaultValue 'button'
	   */
	  type: _propTypes2.default.oneOf(['button', 'reset', 'submit'])
	};
	
	var defaultProps = {
	  active: false,
	  block: false,
	  disabled: false
	};
	
	var Button = function (_React$Component) {
	  (0, _inherits3.default)(Button, _React$Component);
	
	  function Button() {
	    (0, _classCallCheck3.default)(this, Button);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
	    return _react2.default.createElement(_SafeAnchor2.default, (0, _extends4.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, elementProps.disabled && 'disabled')
	    }));
	  };
	
	  Button.prototype.renderButton = function renderButton(_ref, className) {
	    var componentClass = _ref.componentClass,
	        elementProps = (0, _objectWithoutProperties3.default)(_ref, ['componentClass']);
	
	    var Component = componentClass || 'button';
	
	    return _react2.default.createElement(Component, (0, _extends4.default)({}, elementProps, {
	      type: elementProps.type || 'button',
	      className: className
	    }));
	  };
	
	  Button.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        active = _props.active,
	        block = _props.block,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['active', 'block', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
	    var fullClassName = (0, _classnames2.default)(className, classes);
	
	    if (elementProps.href) {
	      return this.renderAnchor(elementProps, fullClassName);
	    }
	
	    return this.renderButton(elementProps, fullClassName);
	  };
	
	  return Button;
	}(_react2.default.Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)([].concat((0, _values2.default)(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
	module.exports = exports['default'];

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var EventPluginRegistry = __webpack_require__(512);
	var EventPluginUtils = __webpack_require__(513);
	var ReactErrorUtils = __webpack_require__(517);
	
	var accumulateInto = __webpack_require__(836);
	var forEachAccumulated = __webpack_require__(837);
	var invariant = __webpack_require__(28);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(293);
	var EventPluginUtils = __webpack_require__(513);
	
	var accumulateInto = __webpack_require__(836);
	var forEachAccumulated = __webpack_require__(837);
	var warning = __webpack_require__(61);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(166);
	
	var getEventTarget = __webpack_require__(522);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.noop = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.bottom = bottom;
	exports.cloneLayout = cloneLayout;
	exports.cloneLayoutItem = cloneLayoutItem;
	exports.childrenEqual = childrenEqual;
	exports.collides = collides;
	exports.compact = compact;
	exports.compactItem = compactItem;
	exports.correctBounds = correctBounds;
	exports.getLayoutItem = getLayoutItem;
	exports.getFirstCollision = getFirstCollision;
	exports.getAllCollisions = getAllCollisions;
	exports.getStatics = getStatics;
	exports.moveElement = moveElement;
	exports.moveElementAwayFromCollision = moveElementAwayFromCollision;
	exports.perc = perc;
	exports.setTransform = setTransform;
	exports.setTopLeft = setTopLeft;
	exports.sortLayoutItems = sortLayoutItems;
	exports.sortLayoutItemsByRowCol = sortLayoutItemsByRowCol;
	exports.sortLayoutItemsByColRow = sortLayoutItemsByColRow;
	exports.synchronizeLayoutWithChildren = synchronizeLayoutWithChildren;
	exports.validateLayout = validateLayout;
	exports.autoBindHandlers = autoBindHandlers;
	
	var _lodash = __webpack_require__(338);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// All callbacks are of the signature (layout, oldItem, newItem, placeholder, e).
	var isProduction = ("production") === "production";
	var DEBUG = false;
	
	/**
	 * Return the bottom coordinate of the layout.
	 *
	 * @param  {Array} layout Layout array.
	 * @return {Number}       Bottom coordinate.
	 */
	function bottom(layout) {
	  var max = 0,
	      bottomY = void 0;
	  for (var _i = 0, len = layout.length; _i < len; _i++) {
	    bottomY = layout[_i].y + layout[_i].h;
	    if (bottomY > max) max = bottomY;
	  }
	  return max;
	}
	
	function cloneLayout(layout) {
	  var newLayout = Array(layout.length);
	  for (var _i2 = 0, len = layout.length; _i2 < len; _i2++) {
	    newLayout[_i2] = cloneLayoutItem(layout[_i2]);
	  }
	  return newLayout;
	}
	
	// Fast path to cloning, since this is monomorphic
	function cloneLayoutItem(layoutItem) {
	  return {
	    w: layoutItem.w,
	    h: layoutItem.h,
	    x: layoutItem.x,
	    y: layoutItem.y,
	    i: layoutItem.i,
	    minW: layoutItem.minW,
	    maxW: layoutItem.maxW,
	    minH: layoutItem.minH,
	    maxH: layoutItem.maxH,
	    moved: Boolean(layoutItem.moved),
	    static: Boolean(layoutItem.static),
	    // These can be null
	    isDraggable: layoutItem.isDraggable,
	    isResizable: layoutItem.isResizable
	  };
	}
	
	/**
	 * Comparing React `children` is a bit difficult. This is a good way to compare them.
	 * This will catch differences in keys, order, and length.
	 */
	function childrenEqual(a, b) {
	  return (0, _lodash2.default)(_react2.default.Children.map(a, function (c) {
	    return c.key;
	  }), _react2.default.Children.map(b, function (c) {
	    return c.key;
	  }));
	}
	
	/**
	 * Given two layoutitems, check if they collide.
	 */
	function collides(l1, l2) {
	  if (l1 === l2) return false; // same element
	  if (l1.x + l1.w <= l2.x) return false; // l1 is left of l2
	  if (l1.x >= l2.x + l2.w) return false; // l1 is right of l2
	  if (l1.y + l1.h <= l2.y) return false; // l1 is above l2
	  if (l1.y >= l2.y + l2.h) return false; // l1 is below l2
	  return true; // boxes overlap
	}
	
	/**
	 * Given a layout, compact it. This involves going down each y coordinate and removing gaps
	 * between items.
	 *
	 * @param  {Array} layout Layout.
	 * @param  {Boolean} verticalCompact Whether or not to compact the layout
	 *   vertically.
	 * @return {Array}       Compacted Layout.
	 */
	function compact(layout, compactType, cols) {
	  // Statics go in the compareWith array right away so items flow around them.
	  var compareWith = getStatics(layout);
	  // We go through the items by row and column.
	  var sorted = sortLayoutItems(layout, compactType);
	  // Holding for new items.
	  var out = Array(layout.length);
	
	  for (var _i3 = 0, len = sorted.length; _i3 < len; _i3++) {
	    var l = cloneLayoutItem(sorted[_i3]);
	
	    // Don't move static elements
	    if (!l.static) {
	      l = compactItem(compareWith, l, compactType, cols, sorted);
	
	      // Add to comparison array. We only collide with items before this one.
	      // Statics are already in this array.
	      compareWith.push(l);
	    }
	
	    // Add to output array to make sure they still come out in the right order.
	    out[layout.indexOf(sorted[_i3])] = l;
	
	    // Clear moved flag, if it exists.
	    l.moved = false;
	  }
	
	  return out;
	}
	
	var heightWidth = { x: "w", y: "h" };
	/**
	 * Before moving item down, it will check if the movement will cause collisions and move those items down before.
	 */
	function resolveCompactionCollision(layout, item, moveToCoord, axis) {
	  var sizeProp = heightWidth[axis];
	  item[axis] += 1;
	  var itemIndex = layout.indexOf(item);
	
	  // Go through each item we collide with.
	  for (var _i4 = itemIndex + 1; _i4 < layout.length; _i4++) {
	    var otherItem = layout[_i4];
	    // Ignore static items
	    if (otherItem.static) continue;
	
	    // Optimization: we can break early if we know we're past this el
	    // We can do this b/c it's a sorted layout
	    if (otherItem.y > item.y + item.h) break;
	
	    if (collides(item, otherItem)) {
	      resolveCompactionCollision(layout, otherItem, moveToCoord + item[sizeProp], axis);
	    }
	  }
	
	  item[axis] = moveToCoord;
	}
	
	/**
	 * Compact an item in the layout.
	 */
	function compactItem(compareWith, l, compactType, cols, fullLayout) {
	  var compactV = compactType === "vertical";
	  var compactH = compactType === "horizontal";
	  if (compactV) {
	    // Bottom 'y' possible is the bottom of the layout.
	    // This allows you to do nice stuff like specify {y: Infinity}
	    // This is here because the layout must be sorted in order to get the correct bottom `y`.
	    l.y = Math.min(bottom(compareWith), l.y);
	    // Move the element up as far as it can go without colliding.
	    while (l.y > 0 && !getFirstCollision(compareWith, l)) {
	      l.y--;
	    }
	  } else if (compactH) {
	    l.y = Math.min(bottom(compareWith), l.y);
	    // Move the element left as far as it can go without colliding.
	    while (l.x > 0 && !getFirstCollision(compareWith, l)) {
	      l.x--;
	    }
	  }
	
	  // Move it down, and keep moving it down if it's colliding.
	  var collides = void 0;
	  while (collides = getFirstCollision(compareWith, l)) {
	    if (compactH) {
	      resolveCompactionCollision(fullLayout, l, collides.x + collides.w, "x");
	    } else {
	      resolveCompactionCollision(fullLayout, l, collides.y + collides.h, "y");
	    }
	    // Since we can't grow without bounds horizontally, if we've overflown, let's move it down and try again.
	    if (compactH && l.x + l.w > cols) {
	      l.x = cols - l.w;
	      l.y++;
	    }
	  }
	  return l;
	}
	
	/**
	 * Given a layout, make sure all elements fit within its bounds.
	 *
	 * @param  {Array} layout Layout array.
	 * @param  {Number} bounds Number of columns.
	 */
	function correctBounds(layout, bounds) {
	  var collidesWith = getStatics(layout);
	  for (var _i5 = 0, len = layout.length; _i5 < len; _i5++) {
	    var l = layout[_i5];
	    // Overflows right
	    if (l.x + l.w > bounds.cols) l.x = bounds.cols - l.w;
	    // Overflows left
	    if (l.x < 0) {
	      l.x = 0;
	      l.w = bounds.cols;
	    }
	    if (!l.static) collidesWith.push(l);else {
	      // If this is static and collides with other statics, we must move it down.
	      // We have to do something nicer than just letting them overlap.
	      while (getFirstCollision(collidesWith, l)) {
	        l.y++;
	      }
	    }
	  }
	  return layout;
	}
	
	/**
	 * Get a layout item by ID. Used so we can override later on if necessary.
	 *
	 * @param  {Array}  layout Layout array.
	 * @param  {String} id     ID
	 * @return {LayoutItem}    Item at ID.
	 */
	function getLayoutItem(layout, id) {
	  for (var _i6 = 0, len = layout.length; _i6 < len; _i6++) {
	    if (layout[_i6].i === id) return layout[_i6];
	  }
	}
	
	/**
	 * Returns the first item this layout collides with.
	 * It doesn't appear to matter which order we approach this from, although
	 * perhaps that is the wrong thing to do.
	 *
	 * @param  {Object} layoutItem Layout item.
	 * @return {Object|undefined}  A colliding layout item, or undefined.
	 */
	function getFirstCollision(layout, layoutItem) {
	  for (var _i7 = 0, len = layout.length; _i7 < len; _i7++) {
	    if (collides(layout[_i7], layoutItem)) return layout[_i7];
	  }
	}
	
	function getAllCollisions(layout, layoutItem) {
	  return layout.filter(function (l) {
	    return collides(l, layoutItem);
	  });
	}
	
	/**
	 * Get all static elements.
	 * @param  {Array} layout Array of layout objects.
	 * @return {Array}        Array of static layout items..
	 */
	function getStatics(layout) {
	  return layout.filter(function (l) {
	    return l.static;
	  });
	}
	
	/**
	 * Move an element. Responsible for doing cascading movements of other elements.
	 *
	 * @param  {Array}      layout            Full layout to modify.
	 * @param  {LayoutItem} l                 element to move.
	 * @param  {Number}     [x]               X position in grid units.
	 * @param  {Number}     [y]               Y position in grid units.
	 */
	function moveElement(layout, l, x, y, isUserAction, preventCollision, compactType, cols) {
	  if (l.static) return layout;
	
	  // Short-circuit if nothing to do.
	  if (l.y === y && l.x === x) return layout;
	
	  log("Moving element " + l.i + " to [" + String(x) + "," + String(y) + "] from [" + l.x + "," + l.y + "]");
	  var oldX = l.x;
	  var oldY = l.y;
	
	  // This is quite a bit faster than extending the object
	  if (typeof x === 'number') l.x = x;
	  if (typeof y === 'number') l.y = y;
	  l.moved = true;
	
	  // If this collides with anything, move it.
	  // When doing this comparison, we have to sort the items we compare with
	  // to ensure, in the case of multiple collisions, that we're getting the
	  // nearest collision.
	  var sorted = sortLayoutItems(layout, compactType);
	  var movingUp = compactType === "vertical" && typeof y === 'number' ? oldY >= y : compactType === "horizontal" && typeof x === 'number' ? oldX >= x : false;
	  if (movingUp) sorted = sorted.reverse();
	  var collisions = getAllCollisions(sorted, l);
	
	  // There was a collision; abort
	  if (preventCollision && collisions.length) {
	    log("Collision prevented on " + l.i + ", reverting.");
	    l.x = oldX;
	    l.y = oldY;
	    l.moved = false;
	    return layout;
	  }
	
	  // Move each item that collides away from this element.
	  for (var _i8 = 0, len = collisions.length; _i8 < len; _i8++) {
	    var collision = collisions[_i8];
	    log("Resolving collision between " + l.i + " at [" + l.x + "," + l.y + "] and " + collision.i + " at [" + collision.x + "," + collision.y + "]");
	
	    // Short circuit so we can't infinite loop
	    if (collision.moved) continue;
	
	    // Don't move static items - we have to move *this* element away
	    if (collision.static) {
	      layout = moveElementAwayFromCollision(layout, collision, l, isUserAction, compactType, cols);
	    } else {
	      layout = moveElementAwayFromCollision(layout, l, collision, isUserAction, compactType, cols);
	    }
	  }
	
	  return layout;
	}
	
	/**
	 * This is where the magic needs to happen - given a collision, move an element away from the collision.
	 * We attempt to move it up if there's room, otherwise it goes below.
	 *
	 * @param  {Array} layout            Full layout to modify.
	 * @param  {LayoutItem} collidesWith Layout item we're colliding with.
	 * @param  {LayoutItem} itemToMove   Layout item we're moving.
	 */
	function moveElementAwayFromCollision(layout, collidesWith, itemToMove, isUserAction, compactType, cols) {
	  var compactH = compactType === "horizontal";
	  var compactV = compactType === "vertical";
	  var preventCollision = false; // we're already colliding
	
	  // If there is enough space above the collision to put this element, move it there.
	  // We only do this on the main collision as this can get funky in cascades and cause
	  // unwanted swapping behavior.
	  if (isUserAction) {
	    // Reset isUserAction flag because we're not in the main collision anymore.
	    isUserAction = false;
	
	    // Make a mock item so we don't modify the item here, only modify in moveElement.
	    var fakeItem = {
	      x: compactH ? Math.max(collidesWith.x - itemToMove.w, 0) : itemToMove.x,
	      y: compactV ? Math.max(collidesWith.y - itemToMove.h, 0) : itemToMove.y,
	      w: itemToMove.w,
	      h: itemToMove.h,
	      i: "-1"
	    };
	
	    // No collision? If so, we can go up there; otherwise, we'll end up moving down as normal
	    if (!getFirstCollision(layout, fakeItem)) {
	      log("Doing reverse collision on " + itemToMove.i + " up to [" + fakeItem.x + "," + fakeItem.y + "].");
	      return moveElement(layout, itemToMove, compactH ? fakeItem.x : undefined, compactV ? fakeItem.y : undefined, isUserAction, preventCollision, compactType, cols);
	    }
	  }
	
	  return moveElement(layout, itemToMove, compactH ? itemToMove.x + 1 : undefined, compactV ? itemToMove.y + 1 : undefined, isUserAction, preventCollision, compactType, cols);
	}
	
	/**
	 * Helper to convert a number to a percentage string.
	 *
	 * @param  {Number} num Any number
	 * @return {String}     That number as a percentage.
	 */
	function perc(num) {
	  return num * 100 + "%";
	}
	
	function setTransform(_ref) {
	  var top = _ref.top,
	      left = _ref.left,
	      width = _ref.width,
	      height = _ref.height;
	
	  // Replace unitless items with px
	  var translate = "translate(" + left + "px," + top + "px)";
	  return {
	    transform: translate,
	    WebkitTransform: translate,
	    MozTransform: translate,
	    msTransform: translate,
	    OTransform: translate,
	    width: width + "px",
	    height: height + "px",
	    position: "absolute"
	  };
	}
	
	function setTopLeft(_ref2) {
	  var top = _ref2.top,
	      left = _ref2.left,
	      width = _ref2.width,
	      height = _ref2.height;
	
	  return {
	    top: top + "px",
	    left: left + "px",
	    width: width + "px",
	    height: height + "px",
	    position: "absolute"
	  };
	}
	
	/**
	 * Get layout items sorted from top left to right and down.
	 *
	 * @return {Array} Array of layout objects.
	 * @return {Array}        Layout, sorted static items first.
	 */
	function sortLayoutItems(layout, compactType) {
	  if (compactType === "horizontal") return sortLayoutItemsByColRow(layout);else return sortLayoutItemsByRowCol(layout);
	}
	
	function sortLayoutItemsByRowCol(layout) {
	  return [].concat(layout).sort(function (a, b) {
	    if (a.y > b.y || a.y === b.y && a.x > b.x) {
	      return 1;
	    } else if (a.y === b.y && a.x === b.x) {
	      // Without this, we can get different sort results in IE vs. Chrome/FF
	      return 0;
	    }
	    return -1;
	  });
	}
	
	function sortLayoutItemsByColRow(layout) {
	  return [].concat(layout).sort(function (a, b) {
	    if (a.x > b.x || a.x === b.x && a.y > b.y) {
	      return 1;
	    }
	    return -1;
	  });
	}
	
	/**
	 * Generate a layout using the initialLayout and children as a template.
	 * Missing entries will be added, extraneous ones will be truncated.
	 *
	 * @param  {Array}  initialLayout Layout passed in through props.
	 * @param  {String} breakpoint    Current responsive breakpoint.
	 * @param  {?String} compact      Compaction option.
	 * @return {Array}                Working layout.
	 */
	function synchronizeLayoutWithChildren(initialLayout, children, cols, compactType) {
	  initialLayout = initialLayout || [];
	
	  // Generate one layout item per child.
	  var layout = [];
	  _react2.default.Children.forEach(children, function (child, i) {
	    // Don't overwrite if it already exists.
	    var exists = getLayoutItem(initialLayout, String(child.key));
	    if (exists) {
	      layout[i] = cloneLayoutItem(exists);
	    } else {
	      if (!isProduction && child.props._grid) {
	        console.warn("`_grid` properties on children have been deprecated as of React 15.2. " + // eslint-disable-line
	        "Please use `data-grid` or add your properties directly to the `layout`.");
	      }
	      var g = child.props["data-grid"] || child.props._grid;
	
	      // Hey, this item has a data-grid property, use it.
	      if (g) {
	        if (!isProduction) {
	          validateLayout([g], "ReactGridLayout.children");
	        }
	        layout[i] = cloneLayoutItem(_extends({}, g, { i: child.key }));
	      } else {
	        // Nothing provided: ensure this is added to the bottom
	        layout[i] = cloneLayoutItem({
	          w: 1,
	          h: 1,
	          x: 0,
	          y: bottom(layout),
	          i: String(child.key)
	        });
	      }
	    }
	  });
	
	  // Correct the layout.
	  layout = correctBounds(layout, { cols: cols });
	  layout = compact(layout, compactType, cols);
	
	  return layout;
	}
	
	/**
	 * Validate a layout. Throws errors.
	 *
	 * @param  {Array}  layout        Array of layout items.
	 * @param  {String} [contextName] Context name for errors.
	 * @throw  {Error}                Validation error.
	 */
	function validateLayout(layout) {
	  var contextName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Layout";
	
	  var subProps = ["x", "y", "w", "h"];
	  if (!Array.isArray(layout)) throw new Error(contextName + " must be an array!");
	  for (var _i9 = 0, len = layout.length; _i9 < len; _i9++) {
	    var item = layout[_i9];
	    for (var j = 0; j < subProps.length; j++) {
	      if (typeof item[subProps[j]] !== "number") {
	        throw new Error("ReactGridLayout: " + contextName + "[" + _i9 + "]." + subProps[j] + " must be a number!");
	      }
	    }
	    if (item.i && typeof item.i !== "string") {
	      throw new Error("ReactGridLayout: " + contextName + "[" + _i9 + "].i must be a string!");
	    }
	    if (item.static !== undefined && typeof item.static !== "boolean") {
	      throw new Error("ReactGridLayout: " + contextName + "[" + _i9 + "].static must be a boolean!");
	    }
	  }
	}
	
	// Flow can't really figure this out, so we just use Object
	function autoBindHandlers(el, fns) {
	  fns.forEach(function (key) {
	    return el[key] = el[key].bind(el);
	  });
	}
	
	function log() {
	  var _console;
	
	  if (!DEBUG) return;
	  // eslint-disable-next-line no-console
	  (_console = console).log.apply(_console, arguments);
	}
	
	var noop = exports.noop = function noop() {};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdDone = function MdDone(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm15 27l17.7-17.7 2.3 2.3-20 20-9.3-9.3 2.3-2.3z' })
	        )
	    );
	};
	
	exports.default = MdDone;
	module.exports = exports['default'];

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	/**
	 * Actions that modify the URL.
	 */
	'use strict';
	
	var LocationActions = {
	
	  /**
	   * Indicates a new location is being pushed to the history stack.
	   */
	  PUSH: 'push',
	
	  /**
	   * Indicates the current location should be replaced.
	   */
	  REPLACE: 'replace',
	
	  /**
	   * Indicates the most recent entry should be removed from the history stack.
	   */
	  POP: 'pop'
	
	};
	
	module.exports = LocationActions;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(93);
	
	//backport PureRenderEqual
	module.exports = {
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return !_.isShallowEqual(this.props, nextProps) || !_.isShallowEqual(this.state, nextState);
	  }
	};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  contextTypes: {
	    isRtl: _propTypes2.default.bool
	  },
	
	  isRtl: function isRtl() {
	    return !!this.context.isRtl;
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.widgetEditable = exports.widgetEnabled = undefined;
	exports.isDisabled = isDisabled;
	exports.isReadOnly = isReadOnly;
	exports.isDisabledItem = isDisabledItem;
	exports.isReadOnlyItem = isReadOnlyItem;
	exports.contains = contains;
	exports.move = move;
	
	var _dataHelpers = __webpack_require__(540);
	
	function isDisabled(props) {
	  return props.disabled === true || props.disabled === 'disabled';
	}
	
	function isReadOnly(props) {
	  return props.readOnly === true || props.readOnly === 'readOnly';
	}
	
	function isDisabledItem(item, props) {
	  return isDisabled(props) || contains(item, props.disabled, props.valueField);
	}
	
	function isReadOnlyItem(item, props) {
	  return isReadOnly(props) || contains(item, props.readOnly, props.valueField);
	}
	
	function contains(item, values, valueField) {
	  return Array.isArray(values) ? values.some(function (value) {
	    return (0, _dataHelpers.valueMatcher)(item, value, valueField);
	  }) : (0, _dataHelpers.valueMatcher)(item, values, valueField);
	}
	
	function move(dir, item, props, list) {
	  var isDisabledOrReadonly = function isDisabledOrReadonly(item) {
	    return isDisabledItem(item, props) || isReadOnlyItem(item, props);
	  },
	      stop = dir === 'next' ? list.last() : list.first(),
	      next = list[dir](item);
	
	  while (next !== stop && isDisabledOrReadonly(next)) {
	    next = list[dir](next);
	  }return isDisabledOrReadonly(next) ? item : next;
	}
	
	var widgetEnabled = exports.widgetEnabled = interactionDecorator(true);
	
	var widgetEditable = exports.widgetEditable = interactionDecorator(false);
	
	function interactionDecorator(disabledOnly) {
	  function wrap(method) {
	    return function decoratedMethod() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      if (!(isDisabled(this.props) || !disabledOnly && isReadOnly(this.props))) return method.apply(this, args);
	    };
	  }
	
	  return function decorate(target, key, desc) {
	    if (desc.initializer) {
	      var init = desc.initializer;
	      desc.initializer = function () {
	        return wrap(init());
	      };
	    } else desc.value = wrap(desc.value);
	    return desc;
	  };
	}

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var camelize = __webpack_require__(542),
	    hyphenate = __webpack_require__(1921),
	    _getComputedStyle = __webpack_require__(1917),
	    removeStyle = __webpack_require__(1918);
	
	var has = Object.prototype.hasOwnProperty;
	
	module.exports = function style(node, property, value) {
	  var css = '',
	      props = property;
	
	  if (typeof property === 'string') {
	
	    if (value === undefined) return node.style[camelize(property)] || _getComputedStyle(node).getPropertyValue(hyphenate(property));else (props = {})[property] = value;
	  }
	
	  for (var key in props) if (has.call(props, key)) {
	    !props[key] && props[key] !== 0 ? removeStyle(node, hyphenate(key)) : css += hyphenate(key) + ':' + props[key] + ';';
	  }
	
	  node.style.cssText += ';' + css;
	};

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 306 */
64,
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _ReactUtils = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ErrorBar =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ErrorBar, _Component);
	
	  function ErrorBar() {
	    _classCallCheck(this, ErrorBar);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ErrorBar).apply(this, arguments));
	  }
	
	  _createClass(ErrorBar, [{
	    key: "renderErrorBars",
	    value: function renderErrorBars() {
	      var _this$props = this.props,
	          offset = _this$props.offset,
	          layout = _this$props.layout,
	          width = _this$props.width,
	          dataKey = _this$props.dataKey,
	          data = _this$props.data,
	          dataPointFormatter = _this$props.dataPointFormatter,
	          xAxis = _this$props.xAxis,
	          yAxis = _this$props.yAxis,
	          others = _objectWithoutProperties(_this$props, ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"]);
	
	      var props = (0, _ReactUtils.getPresentationAttributes)(others);
	      return data.map(function (entry, i) {
	        var _dataPointFormatter = dataPointFormatter(entry, dataKey),
	            x = _dataPointFormatter.x,
	            y = _dataPointFormatter.y,
	            value = _dataPointFormatter.value,
	            errorVal = _dataPointFormatter.errorVal;
	
	        if (!errorVal) {
	          return null;
	        }
	
	        var xMid, yMid, xMin, yMin, xMax, yMax, scale, coordsTop, coordsMid, coordsBot, lowBound, highBound;
	
	        if (Array.isArray(errorVal)) {
	          var _errorVal = _slicedToArray(errorVal, 2);
	
	          lowBound = _errorVal[0];
	          highBound = _errorVal[1];
	        } else {
	          lowBound = highBound = errorVal;
	        }
	
	        if (layout === 'vertical') {
	          scale = xAxis.scale;
	          xMid = value;
	          yMid = y + offset;
	          xMin = scale(xMid - lowBound);
	          yMin = yMid + width;
	          xMax = scale(xMid + highBound);
	          yMax = yMid - width;
	          coordsTop = {
	            x1: xMax,
	            y1: yMin,
	            x2: xMax,
	            y2: yMax
	          };
	          coordsMid = {
	            x1: xMin,
	            y1: yMid,
	            x2: xMax,
	            y2: yMid
	          };
	          coordsBot = {
	            x1: xMin,
	            y1: yMin,
	            x2: xMin,
	            y2: yMax
	          };
	        } else if (layout === 'horizontal') {
	          scale = yAxis.scale;
	          xMid = x + offset;
	          yMid = value;
	          xMin = xMid - width;
	          xMax = xMid + width;
	          yMin = scale(yMid - lowBound);
	          yMax = scale(yMid + highBound);
	          coordsTop = {
	            x1: xMin,
	            y1: yMax,
	            x2: xMax,
	            y2: yMax
	          };
	          coordsMid = {
	            x1: xMid,
	            y1: yMin,
	            x2: xMid,
	            y2: yMax
	          };
	          coordsBot = {
	            x1: xMin,
	            y1: yMin,
	            x2: xMax,
	            y2: yMin
	          };
	        }
	
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement(_Layer["default"], _extends({
	            className: "recharts-errorBar",
	            key: "bar-".concat(i)
	          }, props), _react["default"].createElement("line", coordsTop), _react["default"].createElement("line", coordsMid), _react["default"].createElement("line", coordsBot))
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-errorBars"
	      }, this.renderErrorBars());
	    }
	  }]);
	
	  return ErrorBar;
	}(_react.Component);
	
	ErrorBar.propTypes = {
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  data: _propTypes["default"].array,
	  xAxis: _propTypes["default"].object,
	  yAxis: _propTypes["default"].object,
	  layout: _propTypes["default"].string,
	  dataPointFormatter: _propTypes["default"].func,
	  stroke: _propTypes["default"].string,
	  strokeWidth: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  offset: _propTypes["default"].number
	};
	ErrorBar.defaultProps = {
	  stroke: 'black',
	  strokeWidth: 1.5,
	  width: 5,
	  offset: 0,
	  layout: 'horizontal'
	};
	var _default = ErrorBar;
	exports["default"] = _default;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _ReactUtils = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var propTypes = {
	  width: _propTypes["default"].number.isRequired,
	  height: _propTypes["default"].number.isRequired,
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  className: _propTypes["default"].string,
	  style: _propTypes["default"].object,
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
	};
	
	function Surface(props) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      viewBox = props.viewBox,
	      className = props.className,
	      style = props.style,
	      others = _objectWithoutProperties(props, ["children", "width", "height", "viewBox", "className", "style"]);
	
	  var svgView = viewBox || {
	    width: width,
	    height: height,
	    x: 0,
	    y: 0
	  };
	  var layerClass = (0, _classnames["default"])('recharts-surface', className);
	  var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	  return _react["default"].createElement("svg", _extends({}, attrs, {
	    className: layerClass,
	    width: width,
	    height: height,
	    style: style,
	    viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height),
	    version: "1.1"
	  }), children);
	}
	
	Surface.propTypes = propTypes;
	var _default = Surface;
	exports["default"] = _default;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(94);
	var mergeMap_1 = __webpack_require__(1992);
	Observable_1.Observable.prototype.mergeMap = mergeMap_1.mergeMap;
	Observable_1.Observable.prototype.flatMap = mergeMap_1.mergeMap;
	//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SEVERITY = exports.CODEBLOCKLOCATION = exports.CODEBLOCK = void 0;
	var CODEBLOCK;
	(function (CODEBLOCK) {
	    CODEBLOCK["SHIPMENT_EMPLOYEE_SMS_TO_ADDRESS"] = "SHIPMENT_EMPLOYEE_SMS_TO_ADDRESS";
	})(CODEBLOCK || (exports.CODEBLOCK = CODEBLOCK = {}));
	var CODEBLOCKLOCATION;
	(function (CODEBLOCKLOCATION) {
	    CODEBLOCKLOCATION["TO_ADDRESS"] = "TO_ADDRESS";
	})(CODEBLOCKLOCATION || (exports.CODEBLOCKLOCATION = CODEBLOCKLOCATION = {}));
	var SEVERITY;
	(function (SEVERITY) {
	    SEVERITY["INFO"] = "INFO";
	    SEVERITY["WARNING"] = "WARNING";
	    SEVERITY["ERROR"] = "ERROR";
	    SEVERITY["NOOP"] = "NOOP";
	})(SEVERITY || (exports.SEVERITY = SEVERITY = {}));


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var dialogAncestor_1 = __webpack_require__(87);
	var gridComp_1 = __webpack_require__(44);
	var gridComp_2 = tslib_1.__importDefault(__webpack_require__(44));
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var SelectSearchDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(SelectSearchDialog, _super);
	    function SelectSearchDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.selectObject = function (rowId, item) {
	            console.log('selectObject %s .. %O', rowId, item);
	            return mdEntityService_1.default.getLovItem(_this.grid.$entityRef.id, rowId)
	                .then(function (lv) {
	                _this.dialogOpen = false;
	                _this.resolve(lv);
	            });
	        };
	        _this.selectObjectFullJson = function (rowId, item) {
	            console.log('selectObjectFullJson %s .. %O', rowId, item);
	            _this.dialogOpen = false;
	            _this.resolve(item.rowObject);
	        };
	        _this.getCheckbox = function (rowId, item) {
	            var result = (!!_this.selected.get(rowId + ""));
	            return result;
	        };
	        _this.setCheckbox = function (rowId, item, checked) {
	            console.log('setCheckbox %s .. %O ... %s', rowId, item, checked);
	            if (checked) {
	                _this.selected.set(rowId + "", item.rowObject);
	            }
	            else {
	                _this.selected.delete(rowId + "");
	            }
	            _this.forceUpdate();
	        };
	        _this.cancel = function (evt) {
	            console.log('SelectSearchDialog#cancel evt = %O', evt);
	            _this.dialogOpen = false;
	            _this.$errors = [];
	            _this.reject("cancel");
	        };
	        _this.ok = function (evt) {
	            console.log('SelectSearchDialog#ok selected = %O', _this.selected);
	            _this.dialogOpen = false;
	            _this.$errors = [];
	            _this.resolve(Array.from(_this.selected.values()));
	        };
	        return _this;
	    }
	    SelectSearchDialog.prototype.open = function (resolve, reject, gridSearchModifierFn, title, masterId) {
	        var _this = this;
	        this.resolve = resolve;
	        this.reject = reject;
	        this.selected = new Map();
	        this.dialogOpen = true;
	        this.title = title;
	        return gridService_1.default.fetchGrids(this.props.gridLocation)
	            .then(function (gridLocationMap) {
	            _this.grid = new grid_1.default(gridLocationMap.get(_this.props.gridLocation), masterId ? masterId : _this.props.masterId);
	            if (gridSearchModifierFn)
	                gridSearchModifierFn(_this.grid);
	            return gridService_1.default.search(_this.grid);
	        });
	    };
	    SelectSearchDialog.prototype.render = function () {
	        if (!(this.grid && this.dialogOpen))
	            return null;
	        var _a = this.props, title = _a.title, showGridConfig = _a.showGridConfig, contentStyle = _a.contentStyle, showOk = _a.showOk;
	        var finalTitle = this.title ? this.title : (title ? title : "Search");
	        var actions = [react_1.default.createElement(FlatButton_1.default, { key: "0", label: "Cancel", primary: true, onClick: this.cancel })];
	        if (showOk) {
	            actions.unshift(react_1.default.createElement(FlatButton_1.default, { label: "OK", secondary: true, onClick: this.ok }));
	        }
	        return (react_1.default.createElement(Dialog_1.default, { title: finalTitle, actions: actions, modal: true, open: this.dialogOpen, contentStyle: contentStyle },
	            react_1.default.createElement(gridComp_2.default, { grid: this.grid, multiSelect: false, hideGridConfig: !showGridConfig, uiLocation: gridComp_1.UILOCATION.dialog, bodyStyle: { paddingBottom: 7 }, functionMap: {
	                    selectObject: this.selectObject.bind(this),
	                    selectObjectFullJson: this.selectObjectFullJson.bind(this),
	                    getCheckbox: this.getCheckbox.bind(this),
	                    setCheckbox: this.setCheckbox.bind(this)
	                }, entities: mdEntityService_1.default.entityMap })));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SelectSearchDialog.prototype, "grid", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SelectSearchDialog.prototype, "selected", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SelectSearchDialog.prototype, "title", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SelectSearchDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SelectSearchDialog.prototype, "selectObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SelectSearchDialog.prototype, "selectObjectFullJson", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SelectSearchDialog.prototype, "getCheckbox", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SelectSearchDialog.prototype, "setCheckbox", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SelectSearchDialog.prototype, "cancel", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SelectSearchDialog.prototype, "ok", void 0);
	    SelectSearchDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SelectSearchDialog);
	    return SelectSearchDialog;
	}(dialogAncestor_1.DialogAncestor));
	exports.default = SelectSearchDialog;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var mobx_react_1 = __webpack_require__(4);
	var documentComp_1 = tslib_1.__importDefault(__webpack_require__(400));
	var domUtils_1 = __webpack_require__(91);
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var documentService_1 = tslib_1.__importDefault(__webpack_require__(110));
	var documentDomain_1 = __webpack_require__(109);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var blockComp_1 = __webpack_require__(30);
	var arrayUtils_1 = __webpack_require__(78);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var utils_1 = __webpack_require__(37);
	var icons_1 = __webpack_require__(63);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var metaConstant_1 = __webpack_require__(13);
	var routes_1 = __webpack_require__(75);
	var colors_1 = __webpack_require__(29);
	var SectionHeaderDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    font-size: 15px;\n    color: ", "\n"], ["\n    font-size: 15px;\n    color: ", "\n"])), colors_1.grey400);
	var MainDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  padding-left: 20px;\n  display: flex;\n  flex-direction: row;\n"], ["\n  padding-left: 20px;\n  display: flex;\n  flex-direction: row;\n"])));
	var ContractHeaderDiv = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
	var ContractsDiv = styled_components_1.default.div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
	var DocumentsDiv = styled_components_1.default.div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  min-width: 50%;\n"], ["\n  min-width: 50%;\n"])));
	var ContractWrapperDiv = styled_components_1.default.div(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  min-width: 50%;\n"], ["\n  min-width: 50%;\n"])));
	var contractDetailRoute = "contractDetail";
	var GridDocumentComp = /** @class */ (function (_super) {
	    tslib_1.__extends(GridDocumentComp, _super);
	    function GridDocumentComp() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onAddContract = function () {
	            console.log('onAddContract');
	        };
	        _this.saveFn = function (documents) {
	            var _a = _this.props, rootObject = _a.rootObject, grid = _a.grid;
	            if (rootObject.$new) {
	                return Promise.resolve(null);
	            }
	            else {
	                return Promise.all(documents.filter(function (doc) { return doc.$new; }).map(function (doc) { return documentService_1.default.saveDocument(doc, grid.params); }))
	                    .then(function (x) {
	                    return grid.search(rootObject);
	                });
	            }
	        };
	        _this.deleteFn = function (document) {
	            var _a = _this.props, rootObject = _a.rootObject, grid = _a.grid;
	            if (rootObject.$new || document.$new) {
	                return Promise.resolve(null);
	            }
	            else {
	                uiService_1.default.showToolbarActionFlag();
	                return documentService_1.default.deleteDocument(document.documentUuid, grid.params)
	                    .then(function (x) {
	                    uiService_1.default.hideToolbarActionFlag();
	                    return grid.search(rootObject);
	                });
	            }
	        };
	        _this.onClickContract = function (contract, event) {
	            console.log(event);
	            event.preventDefault();
	            _this.context.router.transitionTo(contractDetailRoute, { id: contract.contractId });
	        };
	        return _this;
	    }
	    GridDocumentComp.prototype.render = function () {
	        var _a;
	        var _this = this;
	        var _b = this.props, children = _b.children, uiLocation = _b.uiLocation, grid = _b.grid, entities = _b.entities, rootObject = _b.rootObject, className = _b.className;
	        var gridClassNames = (0, domUtils_1.classNames)((_a = {}, _a['md-grid--' + uiLocation] = !!uiLocation, _a), className);
	        return (react_1.default.createElement(MainDiv, { className: gridClassNames },
	            react_1.default.createElement(DocumentsDiv, null,
	                react_1.default.createElement(SectionHeaderDiv, null, "DOCUMENTS"),
	                react_1.default.createElement(documentComp_1.default, { documents: grid.documents, entities: entities, style: { flex: '1 1 auto' }, enableUpload: true, documentEntity: entities.get('Document'), rootObject: rootObject, saveFn: this.saveFn, deleteFn: this.deleteFn })),
	            (grid.showContract) ? (react_1.default.createElement(ContractWrapperDiv, null,
	                react_1.default.createElement(ContractHeaderDiv, null,
	                    react_1.default.createElement(SectionHeaderDiv, null, "CONTRACTS"),
	                    (rootObject && !rootObject.$new && grid.customer) ? (react_1.default.createElement(icons_1.ZzIconButtonRoute, { big: true, routeName: "contractDetail", params: { id: 'new' }, module: metaConstant_1.MODULE.core, permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.contractDetail, query: { contractStatus: documentDomain_1.CONTRACTSTATUS.DRAFT, contractType: documentDomain_1.CONTRACTTYPE.CUSTOMER_CONTRACT, customerValue: grid.customer.partyId, customerLabel: grid.customer.partyLabel() } },
	                        react_1.default.createElement(add_1.default, null))) : null),
	                (grid.contracts) ? (react_1.default.createElement(ContractsDiv, null, (0, arrayUtils_1.addSeparator)(grid.contracts.map(function (contract, index) {
	                    var contractEntity = mdEntityService_1.default.getEntity("Contract");
	                    var ClosedContent = mdEntityService_1.default.getClosedContent("ContractForm");
	                    var form = contract.getForm("ContractForm");
	                    var fields = form.setupFields(contract, contract, contractEntity, entities, null);
	                    return (react_1.default.createElement("a", { className: "no-link", key: index, href: _this.context.router.makeHref(contractDetailRoute, { id: contract.contractId }, (0, utils_1.addTenantToQuery)()), onClick: _this.onClickContract.bind(_this, contract) }, react_1.default.createElement(ClosedContent, {
	                        dataObject: contract,
	                        rootObject: contract,
	                        entities: entities,
	                        entity: contractEntity,
	                        fields: fields,
	                        disabled: true,
	                        standAlone: true
	                    }, null)));
	                }), react_1.default.createElement(blockComp_1.MdDivider, { marginRight: 50, marginTop: 10 })))) : null)) : null));
	    };
	    GridDocumentComp.contextTypes = {
	        router: prop_types_1.default.func.isRequired,
	        muiTheme: prop_types_1.default.object
	    };
	    GridDocumentComp = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], GridDocumentComp);
	    return GridDocumentComp;
	}(react_1.default.Component));
	exports.default = GridDocumentComp;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.GridDocument = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_1 = __webpack_require__(5);
	var documentService_1 = tslib_1.__importDefault(__webpack_require__(110));
	var GridDocument = /** @class */ (function () {
	    function GridDocument(blockName, label, params, showContract, customer, documents) {
	        this.blockName = blockName;
	        this.label = label;
	        this.params = params;
	        this.showContract = showContract;
	        this.customer = customer;
	        this.documents = documents;
	    }
	    GridDocument.prototype.isEditable = function () {
	        return false;
	    };
	    GridDocument.prototype.isClientBlock = function () {
	        return false;
	    };
	    GridDocument.prototype.getBlockName = function () {
	        return this.blockName;
	    };
	    GridDocument.prototype.search = function (dataObject, refresh) {
	        var _this = this;
	        if (refresh === void 0) { refresh = true; }
	        return Promise.all([documentService_1.default.readDocuments(this.params), (this.showContract && this.customer) ? documentService_1.default.readPartyContracts(this.customer.partyId) : Promise.resolve([])])
	            .then(function (_a) {
	            var documents = _a[0], contracts = _a[1];
	            _this.documents = documents;
	            _this.contracts = contracts;
	        });
	    };
	    Object.defineProperty(GridDocument.prototype, "data", {
	        get: function () {
	            return this.documents;
	        },
	        set: function (data) {
	            this.documents = data;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridDocument.prototype, "params", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridDocument.prototype, "customer", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridDocument.prototype, "documents", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridDocument.prototype, "contracts", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridDocument.prototype, "$dirty", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridDocument.prototype, "label", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridDocument.prototype, "search", null);
	    return GridDocument;
	}());
	exports.GridDocument = GridDocument;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(980);

/***/ }),
/* 315 */,
/* 316 */,
/* 317 */
/***/ (function(module, exports) {

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	module.exports = canUseDOM;

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 319 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(1074)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(601)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 321 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 322 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 323 */
198,
/* 324 */
[2342, 269, 614, 436, 200],
/* 325 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 326 */
[2353, 1099, 322],
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.END_DRAG = exports.DROP = exports.HOVER = exports.PUBLISH_DRAG_SOURCE = exports.BEGIN_DRAG = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.beginDrag = beginDrag;
	exports.publishDragSource = publishDragSource;
	exports.hover = hover;
	exports.drop = drop;
	exports.endDrag = endDrag;
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isArray = __webpack_require__(62);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(100);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _matchesType = __webpack_require__(632);
	
	var _matchesType2 = _interopRequireDefault(_matchesType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BEGIN_DRAG = exports.BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
	var PUBLISH_DRAG_SOURCE = exports.PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
	var HOVER = exports.HOVER = 'dnd-core/HOVER';
	var DROP = exports.DROP = 'dnd-core/DROP';
	var END_DRAG = exports.END_DRAG = 'dnd-core/END_DRAG';
	
	function beginDrag(sourceIds) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { publishSource: true, clientOffset: null };
		var publishSource = options.publishSource,
		    clientOffset = options.clientOffset,
		    getSourceClientOffset = options.getSourceClientOffset;
	
		(0, _invariant2.default)((0, _isArray2.default)(sourceIds), 'Expected sourceIds to be an array.');
	
		var monitor = this.getMonitor();
		var registry = this.getRegistry();
		(0, _invariant2.default)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
	
		for (var i = 0; i < sourceIds.length; i++) {
			(0, _invariant2.default)(registry.getSource(sourceIds[i]), 'Expected sourceIds to be registered.');
		}
	
		var sourceId = null;
		for (var _i = sourceIds.length - 1; _i >= 0; _i--) {
			if (monitor.canDragSource(sourceIds[_i])) {
				sourceId = sourceIds[_i];
				break;
			}
		}
		if (sourceId === null) {
			return;
		}
	
		var sourceClientOffset = null;
		if (clientOffset) {
			(0, _invariant2.default)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
			sourceClientOffset = getSourceClientOffset(sourceId);
		}
	
		var source = registry.getSource(sourceId);
		var item = source.beginDrag(monitor, sourceId);
		(0, _invariant2.default)((0, _isObject2.default)(item), 'Item must be an object.');
	
		registry.pinSource(sourceId);
	
		var itemType = registry.getSourceType(sourceId);
		return {
			type: BEGIN_DRAG,
			itemType: itemType,
			item: item,
			sourceId: sourceId,
			clientOffset: clientOffset,
			sourceClientOffset: sourceClientOffset,
			isSourcePublic: publishSource
		};
	}
	
	function publishDragSource() {
		var monitor = this.getMonitor();
		if (!monitor.isDragging()) {
			return;
		}
	
		return { type: PUBLISH_DRAG_SOURCE };
	}
	
	function hover(targetIdsArg) {
		var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
		    _ref$clientOffset = _ref.clientOffset,
		    clientOffset = _ref$clientOffset === undefined ? null : _ref$clientOffset;
	
		(0, _invariant2.default)((0, _isArray2.default)(targetIdsArg), 'Expected targetIds to be an array.');
		var targetIds = targetIdsArg.slice(0);
	
		var monitor = this.getMonitor();
		var registry = this.getRegistry();
		(0, _invariant2.default)(monitor.isDragging(), 'Cannot call hover while not dragging.');
		(0, _invariant2.default)(!monitor.didDrop(), 'Cannot call hover after drop.');
	
		// First check invariants.
		for (var i = 0; i < targetIds.length; i++) {
			var targetId = targetIds[i];
			(0, _invariant2.default)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
	
			var target = registry.getTarget(targetId);
			(0, _invariant2.default)(target, 'Expected targetIds to be registered.');
		}
	
		var draggedItemType = monitor.getItemType();
	
		// Remove those targetIds that don't match the targetType.  This
		// fixes shallow isOver which would only be non-shallow because of
		// non-matching targets.
		for (var _i2 = targetIds.length - 1; _i2 >= 0; _i2--) {
			var _targetId = targetIds[_i2];
			var targetType = registry.getTargetType(_targetId);
			if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
				targetIds.splice(_i2, 1);
			}
		}
	
		// Finally call hover on all matching targets.
		for (var _i3 = 0; _i3 < targetIds.length; _i3++) {
			var _targetId2 = targetIds[_i3];
			var _target = registry.getTarget(_targetId2);
			_target.hover(monitor, _targetId2);
		}
	
		return {
			type: HOVER,
			targetIds: targetIds,
			clientOffset: clientOffset
		};
	}
	
	function drop() {
		var _this = this;
	
		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
		var monitor = this.getMonitor();
		var registry = this.getRegistry();
		(0, _invariant2.default)(monitor.isDragging(), 'Cannot call drop while not dragging.');
		(0, _invariant2.default)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
	
		var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
	
		targetIds.reverse();
		targetIds.forEach(function (targetId, index) {
			var target = registry.getTarget(targetId);
	
			var dropResult = target.drop(monitor, targetId);
			(0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isObject2.default)(dropResult), 'Drop result must either be an object or undefined.');
			if (typeof dropResult === 'undefined') {
				dropResult = index === 0 ? {} : monitor.getDropResult();
			}
	
			_this.store.dispatch({
				type: DROP,
				dropResult: _extends({}, options, dropResult)
			});
		});
	}
	
	function endDrag() {
		var monitor = this.getMonitor();
		var registry = this.getRegistry();
		(0, _invariant2.default)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
	
		var sourceId = monitor.getSourceId();
		var source = registry.getSource(sourceId, true);
		source.endDrag(monitor, sourceId);
	
		registry.unpinSource();
	
		return { type: END_DRAG };
	}

/***/ }),
/* 328 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.addSource = addSource;
	exports.addTarget = addTarget;
	exports.removeSource = removeSource;
	exports.removeTarget = removeTarget;
	var ADD_SOURCE = exports.ADD_SOURCE = 'dnd-core/ADD_SOURCE';
	var ADD_TARGET = exports.ADD_TARGET = 'dnd-core/ADD_TARGET';
	var REMOVE_SOURCE = exports.REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
	var REMOVE_TARGET = exports.REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
	
	function addSource(sourceId) {
		return {
			type: ADD_SOURCE,
			sourceId: sourceId
		};
	}
	
	function addTarget(targetId) {
		return {
			type: ADD_TARGET,
			targetId: targetId
		};
	}
	
	function removeSource(sourceId) {
		return {
			type: REMOVE_SOURCE,
			sourceId: sourceId
		};
	}
	
	function removeTarget(targetId) {
		return {
			type: REMOVE_TARGET,
			targetId: targetId
		};
	}

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(182));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 330 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = style;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(640));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__(1185));
	
	var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(1180));
	
	var _removeStyle = _interopRequireDefault(__webpack_require__(1181));
	
	var _properties = __webpack_require__(639);
	
	var _isTransform = _interopRequireDefault(__webpack_require__(1182));
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	
	    if (!value && value !== 0) {
	      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ": " + transforms + ";";
	  }
	
	  node.style.cssText += ';' + css;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntity
	 * @format
	 * 
	 */
	
	var DraftEntityInstance = __webpack_require__(645);
	var Immutable = __webpack_require__(60);
	
	var invariant = __webpack_require__(28);
	
	var Map = Immutable.Map;
	
	
	var instances = Map();
	var instanceKey = 0;
	
	/**
	 * Temporary utility for generating the warnings
	 */
	function logWarning(oldMethodCall, newMethodCall) {
	  console.warn('WARNING: ' + oldMethodCall + ' will be deprecated soon!\nPlease use "' + newMethodCall + '" instead.');
	}
	
	/**
	 * A "document entity" is an object containing metadata associated with a
	 * piece of text in a ContentBlock.
	 *
	 * For example, a `link` entity might include a `uri` property. When a
	 * ContentBlock is rendered in the browser, text that refers to that link
	 * entity may be rendered as an anchor, with the `uri` as the href value.
	 *
	 * In a ContentBlock, every position in the text may correspond to zero
	 * or one entities. This correspondence is tracked using a key string,
	 * generated via DraftEntity.create() and used to obtain entity metadata
	 * via DraftEntity.get().
	 */
	var DraftEntity = {
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.getLastCreatedEntityKey' instead.
	   * ---
	   * Get the random key string from whatever entity was last created.
	   * We need this to support the new API, as part of transitioning to put Entity
	   * storage in contentState.
	   */
	  getLastCreatedEntityKey: function getLastCreatedEntityKey() {
	    logWarning('DraftEntity.getLastCreatedEntityKey', 'contentState.getLastCreatedEntityKey');
	    return DraftEntity.__getLastCreatedEntityKey();
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.createEntity' instead.
	   * ---
	   * Create a DraftEntityInstance and store it for later retrieval.
	   *
	   * A random key string will be generated and returned. This key may
	   * be used to track the entity's usage in a ContentBlock, and for
	   * retrieving data about the entity at render time.
	   */
	  create: function create(type, mutability, data) {
	    logWarning('DraftEntity.create', 'contentState.createEntity');
	    return DraftEntity.__create(type, mutability, data);
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.addEntity' instead.
	   * ---
	   * Add an existing DraftEntityInstance to the DraftEntity map. This is
	   * useful when restoring instances from the server.
	   */
	  add: function add(instance) {
	    logWarning('DraftEntity.add', 'contentState.addEntity');
	    return DraftEntity.__add(instance);
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.getEntity' instead.
	   * ---
	   * Retrieve the entity corresponding to the supplied key string.
	   */
	  get: function get(key) {
	    logWarning('DraftEntity.get', 'contentState.getEntity');
	    return DraftEntity.__get(key);
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.mergeEntityData' instead.
	   * ---
	   * Entity instances are immutable. If you need to update the data for an
	   * instance, this method will merge your data updates and return a new
	   * instance.
	   */
	  mergeData: function mergeData(key, toMerge) {
	    logWarning('DraftEntity.mergeData', 'contentState.mergeEntityData');
	    return DraftEntity.__mergeData(key, toMerge);
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.replaceEntityData' instead.
	   * ---
	   * Completely replace the data for a given instance.
	   */
	  replaceData: function replaceData(key, newData) {
	    logWarning('DraftEntity.replaceData', 'contentState.replaceEntityData');
	    return DraftEntity.__replaceData(key, newData);
	  },
	
	  // ***********************************WARNING******************************
	  // --- the above public API will be deprecated in the next version of Draft!
	  // The methods below this line are private - don't call them directly.
	
	  /**
	   * Get the random key string from whatever entity was last created.
	   * We need this to support the new API, as part of transitioning to put Entity
	   * storage in contentState.
	   */
	  __getLastCreatedEntityKey: function __getLastCreatedEntityKey() {
	    return '' + instanceKey;
	  },
	
	  /**
	   * Create a DraftEntityInstance and store it for later retrieval.
	   *
	   * A random key string will be generated and returned. This key may
	   * be used to track the entity's usage in a ContentBlock, and for
	   * retrieving data about the entity at render time.
	   */
	  __create: function __create(type, mutability, data) {
	    return DraftEntity.__add(new DraftEntityInstance({ type: type, mutability: mutability, data: data || {} }));
	  },
	
	  /**
	   * Add an existing DraftEntityInstance to the DraftEntity map. This is
	   * useful when restoring instances from the server.
	   */
	  __add: function __add(instance) {
	    var key = '' + ++instanceKey;
	    instances = instances.set(key, instance);
	    return key;
	  },
	
	  /**
	   * Retrieve the entity corresponding to the supplied key string.
	   */
	  __get: function __get(key) {
	    var instance = instances.get(key);
	    !!!instance ?  false ? invariant(false, 'Unknown DraftEntity key: %s.', key) : invariant(false) : void 0;
	    return instance;
	  },
	
	  /**
	   * Entity instances are immutable. If you need to update the data for an
	   * instance, this method will merge your data updates and return a new
	   * instance.
	   */
	  __mergeData: function __mergeData(key, toMerge) {
	    var instance = DraftEntity.__get(key);
	    var newData = _extends({}, instance.getData(), toMerge);
	    var newInstance = instance.set('data', newData);
	    instances = instances.set(key, newInstance);
	    return newInstance;
	  },
	
	  /**
	   * Completely replace the data for a given instance.
	   */
	  __replaceData: function __replaceData(key, newData) {
	    var instance = DraftEntity.__get(key);
	    var newInstance = instance.set('data', newData);
	    instances = instances.set(key, newInstance);
	    return newInstance;
	  }
	};
	
	module.exports = DraftEntity;

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftOffsetKey
	 * @format
	 * 
	 */
	
	'use strict';
	
	var KEY_DELIMITER = '-';
	
	var DraftOffsetKey = {
	  encode: function encode(blockKey, decoratorKey, leafKey) {
	    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
	  },
	
	  decode: function decode(offsetKey) {
	    var _offsetKey$split = offsetKey.split(KEY_DELIMITER),
	        blockKey = _offsetKey$split[0],
	        decoratorKey = _offsetKey$split[1],
	        leafKey = _offsetKey$split[2];
	
	    return {
	      blockKey: blockKey,
	      decoratorKey: parseInt(decoratorKey, 10),
	      leafKey: parseInt(leafKey, 10)
	    };
	  }
	};
	
	module.exports = DraftOffsetKey;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getContentStateFragment
	 * @format
	 * 
	 */
	
	'use strict';
	
	var randomizeBlockMapKeys = __webpack_require__(662);
	var removeEntitiesAtEdges = __webpack_require__(663);
	
	var getContentStateFragment = function getContentStateFragment(contentState, selectionState) {
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  // Edge entities should be stripped to ensure that we don't preserve
	  // invalid partial entities when the fragment is reused. We do, however,
	  // preserve entities that are entirely within the selection range.
	  var contentWithoutEdgeEntities = removeEntitiesAtEdges(contentState, selectionState);
	
	  var blockMap = contentWithoutEdgeEntities.getBlockMap();
	  var blockKeys = blockMap.keySeq();
	  var startIndex = blockKeys.indexOf(startKey);
	  var endIndex = blockKeys.indexOf(endKey) + 1;
	
	  return randomizeBlockMapKeys(blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
	    var text = block.getText();
	    var chars = block.getCharacterList();
	
	    if (startKey === endKey) {
	      return block.merge({
	        text: text.slice(startOffset, endOffset),
	        characterList: chars.slice(startOffset, endOffset)
	      });
	    }
	
	    if (blockKey === startKey) {
	      return block.merge({
	        text: text.slice(startOffset),
	        characterList: chars.slice(startOffset)
	      });
	    }
	
	    if (blockKey === endKey) {
	      return block.merge({
	        text: text.slice(0, endOffset),
	        characterList: chars.slice(0, endOffset)
	      });
	    }
	
	    return block;
	  }));
	};
	
	module.exports = getContentStateFragment;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(1307);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = isEqual;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(177)(module)))

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1439),
	    listCacheDelete = __webpack_require__(1440),
	    listCacheGet = __webpack_require__(1441),
	    listCacheHas = __webpack_require__(1442),
	    listCacheSet = __webpack_require__(1443);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(465),
	    setCacheAdd = __webpack_require__(1455),
	    setCacheHas = __webpack_require__(1456);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(283);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(699),
	    createBaseEach = __webpack_require__(1414);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(240);
	
	/**
	 * The base implementation of methods like `_.max` and `_.min` which accepts a
	 * `comparator` to determine the extremum value.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The iteratee invoked per iteration.
	 * @param {Function} comparator The comparator used to compare values.
	 * @returns {*} Returns the extremum value.
	 */
	function baseExtremum(array, iteratee, comparator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index],
	        current = iteratee(value);
	
	    if (current != null && (computed === undefined
	          ? (current === current && !isSymbol(current))
	          : comparator(current, computed)
	        )) {
	      var computed = current,
	          result = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseExtremum;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(340),
	    arrayIncludes = __webpack_require__(468),
	    arrayIncludesWith = __webpack_require__(469),
	    cacheHas = __webpack_require__(345),
	    createSet = __webpack_require__(1419),
	    setToArray = __webpack_require__(478);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ }),
/* 345 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(62),
	    isKey = __webpack_require__(477),
	    stringToPath = __webpack_require__(1464),
	    toString = __webpack_require__(737);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1437);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 348 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 349 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(206);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(711);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(177)(module)))

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1377),
	    isObjectLike = __webpack_require__(116);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(185),
	    isObjectLike = __webpack_require__(116);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(124),
	    stubFalse = __webpack_require__(1483);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(177)(module)))

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var isNumber = __webpack_require__(239);
	
	/**
	 * Checks if `value` is `NaN`.
	 *
	 * **Note:** This method is based on
	 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	 * `undefined` and other non-number values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 * @example
	 *
	 * _.isNaN(NaN);
	 * // => true
	 *
	 * _.isNaN(new Number(NaN));
	 * // => true
	 *
	 * isNaN(undefined);
	 * // => true
	 *
	 * _.isNaN(undefined);
	 * // => false
	 */
	function isNaN(value) {
	  // An `NaN` primitive is the only value that is not equal to itself.
	  // Perform the `toStringTag` check first to avoid errors with some
	  // ActiveX objects in IE.
	  return isNumber(value) && value != +value;
	}
	
	module.exports = isNaN;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Avatar = __webpack_require__(1494);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Avatar2.default;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.IconMenu = undefined;
	
	var _IconMenu2 = __webpack_require__(1526);
	
	var _IconMenu3 = _interopRequireDefault(_IconMenu2);
	
	var _MenuItem2 = __webpack_require__(491);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.IconMenu = _IconMenu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _IconMenu3.default;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Subheader = __webpack_require__(756);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = function (_Component) {
	  (0, _inherits3.default)(List, _Component);
	
	  function List() {
	    (0, _classCallCheck3.default)(this, List);
	    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(List, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var hasSubheader = false;
	
	      var firstChild = _react.Children.toArray(children)[0];
	      if ((0, _react.isValidElement)(firstChild) && firstChild.type === _Subheader2.default) {
	        hasSubheader = true;
	      }
	
	      var styles = {
	        root: {
	          padding: (hasSubheader ? 0 : 8) + 'px 0px 8px 0px'
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return List;
	}(_react.Component);
	
	List.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	List.propTypes =  false ? {
	  /**
	   * These are usually `ListItem`s that are passed to
	   * be part of the list.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = List;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(212);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _colorManipulator = __webpack_require__(187);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(139);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _IconButton = __webpack_require__(126);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _expandLess = __webpack_require__(781);
	
	var _expandLess2 = _interopRequireDefault(_expandLess);
	
	var _expandMore = __webpack_require__(782);
	
	var _expandMore2 = _interopRequireDefault(_expandMore);
	
	var _NestedList = __webpack_require__(1528);
	
	var _NestedList2 = _interopRequireDefault(_NestedList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var autoGenerateNestedIndicator = props.autoGenerateNestedIndicator,
	      insetChildren = props.insetChildren,
	      leftAvatar = props.leftAvatar,
	      leftCheckbox = props.leftCheckbox,
	      leftIcon = props.leftIcon,
	      nestedItems = props.nestedItems,
	      nestedLevel = props.nestedLevel,
	      rightAvatar = props.rightAvatar,
	      rightIcon = props.rightIcon,
	      rightIconButton = props.rightIconButton,
	      rightToggle = props.rightToggle,
	      secondaryText = props.secondaryText,
	      secondaryTextLines = props.secondaryTextLines;
	  var muiTheme = context.muiTheme;
	  var listItem = muiTheme.listItem;
	
	
	  var textColor = muiTheme.baseTheme.palette.textColor;
	  var hoverColor = props.hoverColor || (0, _colorManipulator.fade)(textColor, 0.1);
	  var singleAvatar = !secondaryText && (leftAvatar || rightAvatar);
	  var singleNoAvatar = !secondaryText && !(leftAvatar || rightAvatar);
	  var twoLine = secondaryText && secondaryTextLines === 1;
	  var threeLine = secondaryText && secondaryTextLines > 1;
	
	  var isKeyboardFocused = (props.isKeyboardFocused !== undefined ? props : state).isKeyboardFocused;
	
	  var styles = {
	    root: {
	      backgroundColor: (isKeyboardFocused || state.hovered) && !state.rightIconButtonHovered && !state.rightIconButtonKeyboardFocused ? hoverColor : null,
	      color: textColor,
	      display: 'block',
	      fontSize: 16,
	      lineHeight: '16px',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	
	    // This inner div is needed so that ripples will span the entire container
	    innerDiv: {
	      marginLeft: nestedLevel * listItem.nestedLevelDepth,
	      paddingLeft: leftIcon || leftAvatar || leftCheckbox || insetChildren ? 72 : 16,
	      paddingRight: rightIcon || rightAvatar || rightIconButton || nestedItems.length && autoGenerateNestedIndicator ? 56 : rightToggle ? 72 : 16,
	      paddingBottom: singleAvatar ? 20 : 16,
	      paddingTop: singleNoAvatar || threeLine ? 16 : 20,
	      position: 'relative'
	    },
	
	    icons: {
	      height: 24,
	      width: 24,
	      display: 'block',
	      position: 'absolute',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      margin: 12
	    },
	
	    leftIcon: {
	      left: 4
	    },
	
	    rightIcon: {
	      right: 4
	    },
	
	    avatars: {
	      position: 'absolute',
	      top: singleAvatar ? 8 : 16
	    },
	
	    label: {
	      cursor: 'pointer'
	    },
	
	    leftAvatar: {
	      left: 16
	    },
	
	    rightAvatar: {
	      right: 16
	    },
	
	    leftCheckbox: {
	      position: 'absolute',
	      display: 'block',
	      width: 24,
	      top: twoLine ? 24 : singleAvatar ? 16 : 12,
	      left: 16
	    },
	
	    primaryText: {},
	
	    rightIconButton: {
	      position: 'absolute',
	      display: 'block',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      right: 4
	    },
	
	    rightToggle: {
	      position: 'absolute',
	      display: 'block',
	      width: 54,
	      top: twoLine ? 25 : singleAvatar ? 17 : 13,
	      right: 8
	    },
	
	    secondaryText: {
	      fontSize: 14,
	      lineHeight: threeLine ? '18px' : '16px',
	      height: threeLine ? 36 : 16,
	      margin: 0,
	      marginTop: 4,
	      color: listItem.secondaryTextColor,
	
	      // needed for 2 and 3 line ellipsis
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: threeLine ? null : 'nowrap',
	      display: threeLine ? '-webkit-box' : null,
	      WebkitLineClamp: threeLine ? 2 : null,
	      WebkitBoxOrient: threeLine ? 'vertical' : null
	    }
	  };
	
	  return styles;
	}
	
	var ListItem = function (_Component) {
	  (0, _inherits3.default)(ListItem, _Component);
	
	  function ListItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      open: false,
	      rightIconButtonHovered: false,
	      rightIconButtonKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleTouchTap = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	
	      if (_this.props.primaryTogglesNestedList) {
	        _this.handleNestedListToggle(event);
	      }
	    }, _this.handleNestedListToggle = function (event) {
	      if (_this.props.leftCheckbox) {
	        event.preventDefault();
	      }
	      event.stopPropagation();
	
	      if (_this.props.open === null) {
	        _this.setState({ open: !_this.state.open }, function () {
	          _this.props.onNestedListToggle(_this);
	        });
	      } else {
	        // Exposing `this` in the callback is quite a bad API.
	        // I'm doing a one level deep clone to expose a fake state.open.
	        _this.props.onNestedListToggle((0, _extends3.default)({}, _this, {
	          state: {
	            open: !_this.state.open
	          }
	        }));
	      }
	    }, _this.handleRightIconButtonKeyboardFocus = function (event, isKeyboardFocused) {
	      if (isKeyboardFocused) {
	        _this.setState({
	          isKeyboardFocused: false,
	          rightIconButtonKeyboardFocused: isKeyboardFocused
	        });
	      }
	
	      var iconButton = _this.props.rightIconButton;
	
	      if (iconButton && iconButton.props.onKeyboardFocus) iconButton.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleRightIconButtonMouseLeave = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: false });
	      if (iconButton && iconButton.props.onMouseLeave) iconButton.props.onMouseLeave(event);
	    }, _this.handleRightIconButtonMouseEnter = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: true });
	      if (iconButton && iconButton.props.onMouseEnter) iconButton.props.onMouseEnter(event);
	    }, _this.handleRightIconButtonMouseUp = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onMouseUp) iconButton.props.onMouseUp(event);
	    }, _this.handleRightIconButtonTouchTap = function (event) {
	      var iconButton = _this.props.rightIconButton;
	
	      // Stop the event from bubbling up to the list-item
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onClick) iconButton.props.onClick(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchEnd(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ListItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        open: this.props.open === null ? this.props.initiallyOpen === true : this.props.open
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // update the state when the component is controlled.
	      if (nextProps.open !== null) this.setState({ open: nextProps.open });
	      if (nextProps.disabled && this.state.hovered) this.setState({ hovered: false });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	
	    // This method is needed by the `MenuItem` component.
	
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState(focusState) {
	      if (this.button) {
	        var buttonEl = _reactDom2.default.findDOMNode(this.button);
	
	        switch (focusState) {
	          case 'none':
	            buttonEl.blur();
	            break;
	          case 'focused':
	            buttonEl.focus();
	            break;
	          case 'keyboard-focused':
	            this.button.setKeyboardFocus();
	            buttonEl.focus();
	            break;
	        }
	      }
	    }
	  }, {
	    key: 'createDisabledElement',
	    value: function createDisabledElement(styles, contentChildren, additionalProps) {
	      var _props = this.props,
	          innerDivStyle = _props.innerDivStyle,
	          style = _props.style;
	
	
	      var mergedDivStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedDivStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createLabelElement',
	    value: function createLabelElement(styles, contentChildren, additionalProps) {
	      var _props2 = this.props,
	          innerDivStyle = _props2.innerDivStyle,
	          style = _props2.style;
	
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, styles.label, style);
	
	      return _react2.default.createElement(
	        'label',
	        (0, _extends3.default)({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedLabelStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createTextElement',
	    value: function createTextElement(styles, data, key) {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      if (_react2.default.isValidElement(data)) {
	        var style = (0, _simpleAssign2.default)({}, styles, data.props.style);
	        if (typeof data.type === 'string') {
	          // if element is a native dom node
	          style = prepareStyles(style);
	        }
	        return _react2.default.cloneElement(data, {
	          key: key,
	          style: style
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { key: key, style: prepareStyles(styles) },
	        data
	      );
	    }
	  }, {
	    key: 'pushElement',
	    value: function pushElement(children, element, baseStyles, additionalProps) {
	      if (element) {
	        var styles = (0, _simpleAssign2.default)({}, baseStyles, element.props.style);
	        children.push(_react2.default.cloneElement(element, (0, _extends3.default)({
	          key: children.length,
	          style: styles
	        }, additionalProps)));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          autoGenerateNestedIndicator = _props3.autoGenerateNestedIndicator,
	          children = _props3.children,
	          containerElement = _props3.containerElement,
	          disabled = _props3.disabled,
	          disableKeyboardFocus = _props3.disableKeyboardFocus,
	          hoverColor = _props3.hoverColor,
	          initiallyOpen = _props3.initiallyOpen,
	          innerDivStyle = _props3.innerDivStyle,
	          insetChildren = _props3.insetChildren,
	          leftAvatar = _props3.leftAvatar,
	          leftCheckbox = _props3.leftCheckbox,
	          leftIcon = _props3.leftIcon,
	          nestedItems = _props3.nestedItems,
	          nestedLevel = _props3.nestedLevel,
	          nestedListStyle = _props3.nestedListStyle,
	          onKeyboardFocus = _props3.onKeyboardFocus,
	          isKeyboardFocused = _props3.isKeyboardFocused,
	          onMouseEnter = _props3.onMouseEnter,
	          onMouseLeave = _props3.onMouseLeave,
	          onNestedListToggle = _props3.onNestedListToggle,
	          onTouchStart = _props3.onTouchStart,
	          onClick = _props3.onClick,
	          rightAvatar = _props3.rightAvatar,
	          rightIcon = _props3.rightIcon,
	          rightIconButton = _props3.rightIconButton,
	          rightToggle = _props3.rightToggle,
	          primaryText = _props3.primaryText,
	          primaryTogglesNestedList = _props3.primaryTogglesNestedList,
	          secondaryText = _props3.secondaryText,
	          secondaryTextLines = _props3.secondaryTextLines,
	          style = _props3.style,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['autoGenerateNestedIndicator', 'children', 'containerElement', 'disabled', 'disableKeyboardFocus', 'hoverColor', 'initiallyOpen', 'innerDivStyle', 'insetChildren', 'leftAvatar', 'leftCheckbox', 'leftIcon', 'nestedItems', 'nestedLevel', 'nestedListStyle', 'onKeyboardFocus', 'isKeyboardFocused', 'onMouseEnter', 'onMouseLeave', 'onNestedListToggle', 'onTouchStart', 'onClick', 'rightAvatar', 'rightIcon', 'rightIconButton', 'rightToggle', 'primaryText', 'primaryTogglesNestedList', 'secondaryText', 'secondaryTextLines', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var contentChildren = [children];
	
	      if (leftIcon) {
	        var additionalProps = {
	          color: leftIcon.props.color || this.context.muiTheme.listItem.leftIconColor
	        };
	        this.pushElement(contentChildren, leftIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.leftIcon), additionalProps);
	      }
	
	      if (rightIcon) {
	        var _additionalProps = {
	          color: rightIcon.props.color || this.context.muiTheme.listItem.rightIconColor
	        };
	        this.pushElement(contentChildren, rightIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.rightIcon), _additionalProps);
	      }
	
	      if (leftAvatar) {
	        this.pushElement(contentChildren, leftAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.leftAvatar));
	      }
	
	      if (rightAvatar) {
	        this.pushElement(contentChildren, rightAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.rightAvatar));
	      }
	
	      if (leftCheckbox) {
	        this.pushElement(contentChildren, leftCheckbox, (0, _simpleAssign2.default)({}, styles.leftCheckbox));
	      }
	
	      // RightIconButtonElement
	      var hasNestListItems = nestedItems.length;
	      var hasRightElement = rightAvatar || rightIcon || rightIconButton || rightToggle;
	      var needsNestedIndicator = hasNestListItems && autoGenerateNestedIndicator && !hasRightElement;
	
	      if (rightIconButton || needsNestedIndicator) {
	        var rightIconButtonElement = rightIconButton;
	        var rightIconButtonHandlers = {
	          onKeyboardFocus: this.handleRightIconButtonKeyboardFocus,
	          onMouseEnter: this.handleRightIconButtonMouseEnter,
	          onMouseLeave: this.handleRightIconButtonMouseLeave,
	          onClick: this.handleRightIconButtonTouchTap,
	          onMouseDown: this.handleRightIconButtonMouseUp,
	          onMouseUp: this.handleRightIconButtonMouseUp
	        };
	
	        // Create a nested list indicator icon if we don't have an icon on the right
	        if (needsNestedIndicator) {
	          rightIconButtonElement = this.state.open ? _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandLess2.default, null)
	          ) : _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandMore2.default, null)
	          );
	          rightIconButtonHandlers.onClick = this.handleNestedListToggle;
	        }
	
	        this.pushElement(contentChildren, rightIconButtonElement, (0, _simpleAssign2.default)({}, styles.rightIconButton), rightIconButtonHandlers);
	      }
	
	      if (rightToggle) {
	        this.pushElement(contentChildren, rightToggle, (0, _simpleAssign2.default)({}, styles.rightToggle));
	      }
	
	      if (primaryText) {
	        var primaryTextElement = this.createTextElement(styles.primaryText, primaryText, 'primaryText');
	        contentChildren.push(primaryTextElement);
	      }
	
	      if (secondaryText) {
	        var secondaryTextElement = this.createTextElement(styles.secondaryText, secondaryText, 'secondaryText');
	        contentChildren.push(secondaryTextElement);
	      }
	
	      var nestedList = nestedItems.length ? _react2.default.createElement(
	        _NestedList2.default,
	        { nestedLevel: nestedLevel, open: this.state.open, style: nestedListStyle },
	        nestedItems
	      ) : undefined;
	
	      var simpleLabel = !primaryTogglesNestedList && (leftCheckbox || rightToggle);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        simpleLabel ? this.createLabelElement(styles, contentChildren, other) : disabled ? this.createDisabledElement(styles, contentChildren, other) : _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({
	            containerElement: containerElement
	          }, other, {
	            disableKeyboardFocus: disableKeyboardFocus || this.state.rightIconButtonKeyboardFocused,
	            onKeyboardFocus: this.handleKeyboardFocus,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseEnter: this.handleMouseEnter,
	            onTouchStart: this.handleTouchStart,
	            onTouchEnd: this.handleTouchEnd,
	            onClick: this.handleTouchTap,
	            disabled: disabled,
	            ref: function ref(node) {
	              return _this2.button = node;
	            },
	            style: (0, _simpleAssign2.default)({}, styles.root, style)
	          }),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.innerDiv, innerDivStyle)) },
	            contentChildren
	          )
	        ),
	        nestedList
	      );
	    }
	  }]);
	  return ListItem;
	}(_react.Component);
	
	ListItem.muiName = 'ListItem';
	ListItem.defaultProps = {
	  autoGenerateNestedIndicator: true,
	  containerElement: 'span',
	  disableKeyboardFocus: false,
	  disabled: false,
	  initiallyOpen: false,
	  insetChildren: false,
	  nestedItems: [],
	  nestedLevel: 0,
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onNestedListToggle: function onNestedListToggle() {},
	  onTouchEnd: function onTouchEnd() {},
	  onTouchStart: function onTouchStart() {},
	  open: null,
	  primaryTogglesNestedList: false,
	  secondaryTextLines: 1
	};
	ListItem.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ListItem.propTypes =  false ? {
	  /**
	   * If true, generate a nested-list-indicator icon when nested list
	   * items are detected. Note that an indicator will not be created
	   * if a `rightIcon` or `rightIconButton` has been provided to
	   * the element.
	   */
	  autoGenerateNestedIndicator: _propTypes2.default.bool,
	  /**
	   * Children passed into the `ListItem`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The element to use as the container for the ListItem. Either a string to
	   * use a DOM element or a ReactElement. This is useful for wrapping the
	   * ListItem in a custom Link component. If a ReactElement is given, ensure
	   * that it passes all of its given props through to the underlying DOM
	   * element and renders its children prop for proper integration.
	   */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * If true, the element will not be able to be focused by the keyboard.
	   */
	  disableKeyboardFocus: _propTypes2.default.bool,
	  /**
	   * If true, the element will not be clickable
	   * and will not display hover effects.
	   * This is automatically disabled if either `leftCheckbox`
	   * or `rightToggle` is set.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	  * Override the hover background color.
	  */
	  hoverColor: _propTypes2.default.string,
	  /**
	   * If true, the nested `ListItem`s are initially displayed.
	   */
	  initiallyOpen: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the inner div element.
	   */
	  innerDivStyle: _propTypes2.default.object,
	  /**
	   * If true, the children will be indented by 72px.
	   * This is useful if there is no left avatar or left icon.
	   */
	  insetChildren: _propTypes2.default.bool,
	  /**
	   * Use to control if the list item should render as keyboard focused.  If
	   * undefined (default), this will be automatically managed.  If provided,
	   * it will change the components style.  Note that this will not change the
	   * actual focus - and should only be used when you want to simulate
	   * keyboard focus (eg. in a rich text input autocomplete).
	   */
	  isKeyboardFocused: _propTypes2.default.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the left side.
	   */
	  leftAvatar: _propTypes2.default.element,
	  /**
	   * This is the `Checkbox` element to be displayed on the left side.
	   */
	  leftCheckbox: _propTypes2.default.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _propTypes2.default.element,
	  /**
	   * An array of `ListItem`s to nest underneath the current `ListItem`.
	   */
	  nestedItems: _propTypes2.default.arrayOf(_propTypes2.default.element),
	  /**
	   * Controls how deep a `ListItem` appears.
	   * This property is automatically managed, so modify at your own risk.
	   */
	  nestedLevel: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the nested items' `NestedList`.
	   */
	  nestedListStyle: _propTypes2.default.object,
	  /**
	   * Callback function fired when the list item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the list item.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `ListItem` is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `ListItem`.
	   * @param {boolean} isKeyboardFocused If true, the `ListItem` is focused.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `ListItem` toggles its nested list.
	   *
	   * @param {object} listItem The `ListItem`.
	   */
	  onNestedListToggle: _propTypes2.default.func,
	  /** @ignore */
	  onTouchEnd: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Control toggle state of nested list.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * This is the block element that contains the primary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  primaryText: _propTypes2.default.node,
	  /**
	   * If true, clicking or tapping the primary text of the `ListItem`
	   * toggles the nested list.
	   */
	  primaryTogglesNestedList: _propTypes2.default.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the right side.
	   */
	  rightAvatar: _propTypes2.default.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _propTypes2.default.element,
	  /**
	   * This is the `IconButton` to be displayed on the right side.
	   * Hovering over this button will remove the `ListItem` hover.
	   * Also, clicking on this button will not trigger a
	   * ripple on the `ListItem`; the event will be stopped and prevented
	   * from bubbling up to cause a `ListItem` click.
	   */
	  rightIconButton: _propTypes2.default.element,
	  /**
	   * This is the `Toggle` element to display on the right side.
	   */
	  rightToggle: _propTypes2.default.element,
	  /**
	   * This is the block element that contains the secondary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  secondaryText: _propTypes2.default.node,
	  /**
	   * Can be 1 or 2. This is the number of secondary
	   * text lines before ellipsis will show.
	   */
	  secondaryTextLines: _propTypes2.default.oneOf([1, 2]),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = ListItem;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toArray2 = __webpack_require__(592);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(212);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _ClickAwayListener = __webpack_require__(496);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _keycode = __webpack_require__(99);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _propTypes3 = __webpack_require__(118);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _List = __webpack_require__(358);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _menuUtils = __webpack_require__(1530);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var desktop = props.desktop,
	      maxHeight = props.maxHeight,
	      width = props.width;
	  var muiTheme = context.muiTheme;
	
	
	  var styles = {
	    root: {
	      // Nested div because the List scales x faster than it scales y
	      zIndex: muiTheme.zIndex.menu,
	      maxHeight: maxHeight,
	      overflowY: maxHeight ? 'auto' : null
	    },
	    divider: {
	      marginTop: 7,
	      marginBottom: 8
	    },
	    list: {
	      display: 'table-cell',
	      paddingBottom: desktop ? 16 : 8,
	      paddingTop: desktop ? 16 : 8,
	      userSelect: 'none',
	      width: width
	    },
	    selectedMenuItem: {
	      color: muiTheme.menuItem.selectedTextColor
	    }
	  };
	
	  return styles;
	}
	
	var Menu = function (_Component) {
	  (0, _inherits3.default)(Menu, _Component);
	
	  function Menu(props, context) {
	    (0, _classCallCheck3.default)(this, Menu);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var filteredChildren = _this.getFilteredChildren(props.children);
	    var selectedIndex = _this.getLastSelectedIndex(props, filteredChildren);
	
	    var newFocusIndex = props.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
	    if (newFocusIndex !== -1 && props.onMenuItemFocusChange) {
	      props.onMenuItemFocusChange(null, newFocusIndex);
	    }
	    _this.state = {
	      focusIndex: newFocusIndex,
	      isKeyboardFocused: props.initiallyKeyboardFocused,
	      keyWidth: props.desktop ? 64 : 56
	    };
	
	    _this.hotKeyHolder = new _menuUtils.HotKeyHolder();
	    return _this;
	  }
	
	  (0, _createClass3.default)(Menu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      this.setScollPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var selectedIndex = void 0;
	      var filteredChildren = this.getFilteredChildren(nextProps.children);
	
	      if (this.props.multiple !== true) {
	        selectedIndex = this.getLastSelectedIndex(nextProps, filteredChildren);
	      } else {
	        selectedIndex = this.state.focusIndex;
	      }
	
	      var newFocusIndex = nextProps.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
	      if (newFocusIndex !== this.state.focusIndex && this.props.onMenuItemFocusChange) {
	        this.props.onMenuItemFocusChange(null, newFocusIndex);
	      }
	      this.setState({
	        focusIndex: newFocusIndex,
	        keyWidth: nextProps.desktop ? 64 : 56
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.autoWidth) this.setWidth();
	    }
	  }, {
	    key: 'getValueLink',
	
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'setKeyboardFocused',
	    value: function setKeyboardFocused(keyboardFocused) {
	      this.setState({
	        isKeyboardFocused: keyboardFocused
	      });
	    }
	  }, {
	    key: 'getFilteredChildren',
	    value: function getFilteredChildren(children) {
	      var filteredChildren = [];
	      _react2.default.Children.forEach(children, function (child) {
	        if (child) {
	          filteredChildren.push(child);
	        }
	      });
	      return filteredChildren;
	    }
	  }, {
	    key: 'cloneMenuItem',
	    value: function cloneMenuItem(child, childIndex, styles, index) {
	      var _this2 = this;
	
	      var childIsDisabled = child.props.disabled;
	
	      var selectedChildStyles = {};
	      if (!childIsDisabled) {
	        var selected = this.isChildSelected(child, this.props);
	
	        if (selected) {
	          (0, _simpleAssign2.default)(selectedChildStyles, styles.selectedMenuItem, this.props.selectedMenuItemStyle);
	        }
	      }
	      var mergedChildStyles = (0, _simpleAssign2.default)({}, child.props.style, this.props.menuItemStyle, selectedChildStyles);
	
	      var extraProps = {
	        desktop: this.props.desktop,
	        style: mergedChildStyles
	      };
	      if (!childIsDisabled) {
	        var isFocused = childIndex === this.state.focusIndex;
	        var focusState = 'none';
	        if (isFocused) {
	          focusState = this.state.isKeyboardFocused ? 'keyboard-focused' : 'focused';
	        }
	
	        (0, _simpleAssign2.default)(extraProps, {
	          focusState: focusState,
	          onClick: function onClick(event) {
	            _this2.handleMenuItemTouchTap(event, child, index);
	            if (child.props.onClick) child.props.onClick(event);
	          },
	          ref: isFocused ? 'focusedMenuItem' : null
	        });
	      }
	      return _react2.default.cloneElement(child, extraProps);
	    }
	  }, {
	    key: 'decrementKeyboardFocusIndex',
	    value: function decrementKeyboardFocusIndex(event) {
	      var index = this.state.focusIndex;
	
	      index--;
	      if (index < 0) index = 0;
	
	      this.setFocusIndex(event, index, true);
	    }
	  }, {
	    key: 'getMenuItemCount',
	    value: function getMenuItemCount(filteredChildren) {
	      var menuItemCount = 0;
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	        var childIsDisabled = child.props.disabled;
	        if (!childIsADivider && !childIsDisabled) menuItemCount++;
	      });
	      return menuItemCount;
	    }
	  }, {
	    key: 'getLastSelectedIndex',
	    value: function getLastSelectedIndex(props, filteredChildren) {
	      var _this3 = this;
	
	      var selectedIndex = -1;
	      var menuItemIndex = 0;
	
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	
	        if (_this3.isChildSelected(child, props)) selectedIndex = menuItemIndex;
	        if (!childIsADivider) menuItemIndex++;
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'setFocusIndexStartsWith',
	    value: function setFocusIndexStartsWith(event, keys) {
	      var foundIndex = -1;
	      _react2.default.Children.forEach(this.props.children, function (child, index) {
	        if (foundIndex >= 0) {
	          return;
	        }
	        var primaryText = child.props.primaryText;
	
	        if (typeof primaryText === 'string' && primaryText.substr(0, keys.length).toLowerCase() === keys.toLowerCase()) {
	          foundIndex = index;
	        }
	      });
	      if (foundIndex >= 0) {
	        this.setFocusIndex(event, foundIndex, true);
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'handleMenuItemTouchTap',
	    value: function handleMenuItemTouchTap(event, item, index) {
	      var children = this.props.children;
	      var multiple = this.props.multiple;
	      var valueLink = this.getValueLink(this.props);
	      var menuValue = valueLink.value;
	      var itemValue = item.props.value;
	      var focusIndex = _react2.default.isValidElement(children) ? 0 : children.indexOf(item);
	
	      this.setFocusIndex(event, focusIndex, false);
	
	      if (multiple) {
	        menuValue = menuValue || [];
	
	        var itemIndex = menuValue.indexOf(itemValue);
	
	        var _menuValue = menuValue,
	            _menuValue2 = (0, _toArray3.default)(_menuValue),
	            newMenuValue = _menuValue2.slice(0);
	
	        if (itemIndex === -1) {
	          newMenuValue.push(itemValue);
	        } else {
	          newMenuValue.splice(itemIndex, 1);
	        }
	
	        valueLink.requestChange(event, newMenuValue);
	      } else if (!multiple && itemValue !== menuValue) {
	        valueLink.requestChange(event, itemValue);
	      }
	
	      this.props.onItemTouchTap(event, item, index);
	    }
	  }, {
	    key: 'incrementKeyboardFocusIndex',
	    value: function incrementKeyboardFocusIndex(event, filteredChildren) {
	      var index = this.state.focusIndex;
	      var maxIndex = this.getMenuItemCount(filteredChildren) - 1;
	
	      index++;
	      if (index > maxIndex) index = maxIndex;
	
	      this.setFocusIndex(event, index, true);
	    }
	  }, {
	    key: 'isChildSelected',
	    value: function isChildSelected(child, props) {
	      var menuValue = this.getValueLink(props).value;
	      var childValue = child.props.value;
	
	      if (props.multiple) {
	        return menuValue && menuValue.length && menuValue.indexOf(childValue) !== -1;
	      } else {
	        return child.props.hasOwnProperty('value') && menuValue === childValue;
	      }
	    }
	  }, {
	    key: 'setFocusIndex',
	    value: function setFocusIndex(event, newIndex, isKeyboardFocused) {
	      if (this.props.onMenuItemFocusChange) {
	        // Do this even if `newIndex === this.state.focusIndex` to allow users
	        // to detect up-arrow on the first MenuItem or down-arrow on the last.
	        this.props.onMenuItemFocusChange(event, newIndex);
	      }
	      this.setState({
	        focusIndex: newIndex,
	        isKeyboardFocused: isKeyboardFocused
	      });
	    }
	  }, {
	    key: 'setScollPosition',
	    value: function setScollPosition() {
	      var desktop = this.props.desktop;
	      var focusedMenuItem = this.refs.focusedMenuItem;
	      var menuItemHeight = desktop ? 32 : 48;
	
	      if (focusedMenuItem) {
	        var selectedOffSet = _reactDom2.default.findDOMNode(focusedMenuItem).offsetTop;
	
	        // Make the focused item be the 2nd item in the list the user sees
	        var scrollTop = selectedOffSet - menuItemHeight;
	        if (scrollTop < menuItemHeight) scrollTop = 0;
	
	        _reactDom2.default.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
	      }
	    }
	  }, {
	    key: 'cancelScrollEvent',
	    value: function cancelScrollEvent(event) {
	      event.stopPropagation();
	      event.preventDefault();
	      return false;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = _reactDom2.default.findDOMNode(this);
	      var listEl = _reactDom2.default.findDOMNode(this.refs.list);
	      var elWidth = el.offsetWidth;
	      var keyWidth = this.state.keyWidth;
	      var minWidth = keyWidth * 1.5;
	      var keyIncrements = elWidth / keyWidth;
	      var newWidth = void 0;
	
	      keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
	      newWidth = keyIncrements * keyWidth;
	
	      if (newWidth < minWidth) newWidth = minWidth;
	
	      el.style.width = newWidth + 'px';
	      listEl.style.width = newWidth + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          autoWidth = _props.autoWidth,
	          children = _props.children,
	          desktop = _props.desktop,
	          disableAutoFocus = _props.disableAutoFocus,
	          initiallyKeyboardFocused = _props.initiallyKeyboardFocused,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          multiple = _props.multiple,
	          onItemTouchTap = _props.onItemTouchTap,
	          onEscKeyDown = _props.onEscKeyDown,
	          onMenuItemFocusChange = _props.onMenuItemFocusChange,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          menuItemStyle = _props.menuItemStyle,
	          style = _props.style,
	          value = _props.value,
	          valueLink = _props.valueLink,
	          width = _props.width,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'children', 'desktop', 'disableAutoFocus', 'initiallyKeyboardFocused', 'listStyle', 'maxHeight', 'multiple', 'onItemTouchTap', 'onEscKeyDown', 'onMenuItemFocusChange', 'selectedMenuItemStyle', 'menuItemStyle', 'style', 'value', 'valueLink', 'width']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedListStyles = (0, _simpleAssign2.default)(styles.list, listStyle);
	
	      var filteredChildren = this.getFilteredChildren(children);
	
	      var menuItemIndex = 0;
	      var newChildren = _react2.default.Children.map(filteredChildren, function (child, index) {
	        var childIsDisabled = child.props.disabled;
	        var childName = child.type ? child.type.muiName : '';
	        var newChild = child;
	
	        switch (childName) {
	          case 'MenuItem':
	            newChild = _this4.cloneMenuItem(child, menuItemIndex, styles, index);
	            break;
	
	          case 'Divider':
	            newChild = _react2.default.cloneElement(child, {
	              style: (0, _simpleAssign2.default)({}, styles.divider, child.props.style)
	            });
	            break;
	        }
	
	        if (childName === 'MenuItem' && !childIsDisabled) {
	          menuItemIndex++;
	        }
	
	        return newChild;
	      });
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: this.handleClickAway },
	        _react2.default.createElement(
	          'div',
	          {
	            onKeyDown: this.handleKeyDown,
	            onWheel: this.handleOnWheel,
	            style: prepareStyles(mergedRootStyles),
	            ref: 'scrollContainer',
	            role: 'presentation'
	          },
	          _react2.default.createElement(
	            _List2.default,
	            (0, _extends3.default)({}, other, {
	              ref: 'list',
	              style: mergedListStyles,
	              role: 'menu'
	            }),
	            newChildren
	          )
	        )
	      );
	    }
	  }]);
	  return Menu;
	}(_react.Component);
	
	Menu.defaultProps = {
	  autoWidth: true,
	  desktop: false,
	  disableAutoFocus: false,
	  initiallyKeyboardFocused: false,
	  maxHeight: null,
	  multiple: false,
	  onChange: function onChange() {},
	  onEscKeyDown: function onEscKeyDown() {},
	  onItemTouchTap: function onItemTouchTap() {},
	  onKeyDown: function onKeyDown() {}
	};
	Menu.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.handleClickAway = function (event) {
	    if (event.defaultPrevented) {
	      return;
	    }
	
	    var focusIndex = _this5.state.focusIndex;
	
	    if (focusIndex < 0) {
	      return;
	    }
	
	    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
	    var focusedItem = filteredChildren[focusIndex];
	    if (focusedItem.props.menuItems && focusedItem.props.menuItems.length > 0) {
	      return;
	    }
	
	    _this5.setFocusIndex(event, -1, false);
	  };
	
	  this.handleKeyDown = function (event) {
	    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
	    var key = (0, _keycode2.default)(event);
	    switch (key) {
	      case 'down':
	        event.preventDefault();
	        _this5.incrementKeyboardFocusIndex(event, filteredChildren);
	        break;
	      case 'esc':
	        _this5.props.onEscKeyDown(event);
	        break;
	      case 'tab':
	        event.preventDefault();
	        if (event.shiftKey) {
	          _this5.decrementKeyboardFocusIndex(event);
	        } else {
	          _this5.incrementKeyboardFocusIndex(event, filteredChildren);
	        }
	        break;
	      case 'up':
	        event.preventDefault();
	        _this5.decrementKeyboardFocusIndex(event);
	        break;
	      default:
	        if (key && key.length === 1) {
	          var hotKeys = _this5.hotKeyHolder.append(key);
	          if (_this5.setFocusIndexStartsWith(event, hotKeys)) {
	            event.preventDefault();
	          }
	        }
	    }
	    _this5.props.onKeyDown(event);
	  };
	
	  this.handleOnWheel = function (event) {
	    var scrollContainer = _this5.refs.scrollContainer;
	    // Only scroll lock if the the Menu is scrollable.
	    if (scrollContainer.scrollHeight <= scrollContainer.clientHeight) return;
	
	    var scrollTop = scrollContainer.scrollTop,
	        scrollHeight = scrollContainer.scrollHeight,
	        clientHeight = scrollContainer.clientHeight;
	
	    var wheelDelta = event.deltaY;
	    var isDeltaPositive = wheelDelta > 0;
	
	    if (isDeltaPositive && wheelDelta > scrollHeight - clientHeight - scrollTop) {
	      scrollContainer.scrollTop = scrollHeight;
	      return _this5.cancelScrollEvent(event);
	    } else if (!isDeltaPositive && -wheelDelta > scrollTop) {
	      scrollContainer.scrollTop = 0;
	      return _this5.cancelScrollEvent(event);
	    }
	  };
	};
	
	Menu.propTypes =  false ? {
	  /**
	   * If true, the width of the menu will be set automatically
	   * according to the widths of its children,
	   * using proper keyline increments (64px for desktop,
	   * 56px otherwise).
	   */
	  autoWidth: _propTypes2.default.bool,
	  /**
	   * The content of the menu. This is usually used to pass `MenuItem`
	   * elements.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, the menu item will render with compact desktop styles.
	   */
	  desktop: _propTypes2.default.bool,
	  /**
	   * If true, the menu will not be auto-focused.
	   */
	  disableAutoFocus: _propTypes2.default.bool,
	  /**
	   * If true, the menu will be keyboard-focused initially.
	   */
	  initiallyKeyboardFocused: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * The maximum height of the menu in pixels. If specified,
	   * the menu will be scrollable if it is taller than the provided
	   * height.
	   */
	  maxHeight: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _propTypes2.default.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _propTypes2.default.bool,
	  /**
	   * Callback function fired when a menu item with `value` not
	   * equal to the current `value` of the menu is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {any}  value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function fired when the menu is focused and the *Esc* key
	   * is pressed.
	   *
	   * @param {object} event `keydown` event targeting the menu.
	   */
	  onEscKeyDown: _propTypes2.default.func,
	  /**
	   * Callback function fired when a menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {object} menuItem The menu item.
	   * @param {number} index The index of the menu item.
	   */
	  onItemTouchTap: _propTypes2.default.func,
	  /** @ignore */
	  onKeyDown: _propTypes2.default.func,
	  /**
	   * Callback function fired when the focus on a `MenuItem` is changed.
	   * There will be some "duplicate" changes reported if two different
	   * focusing event happen, for example if a `MenuItem` is focused via
	   * the keyboard and then it is clicked on.
	   *
	   * @param {object} event The event that triggered the focus change.
	   * The event can be null since the focus can be changed for non-event
	   * reasons such as prop changes.
	   * @param {number} newFocusIndex The index of the newly focused
	   * `MenuItem` or `-1` if focus was lost.
	   */
	  onMenuItemFocusChange: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   * This component also supports valueLink.
	   */
	  value: _propTypes2.default.any,
	  /**
	   * ValueLink for the menu's `value`.
	   */
	  valueLink: _propTypes2.default.object,
	  /**
	   * The width of the menu. If not specified, the menu's width
	   * will be set according to the widths of its children, using
	   * proper keyline increments (64px for desktop, 56px otherwise).
	   */
	  width: _propTypes4.default.stringOrNumber
	} : {};
	exports.default = Menu;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableRowColumn = context.muiTheme.tableRowColumn;
	
	
	  var styles = {
	    root: {
	      paddingLeft: tableRowColumn.spacing,
	      paddingRight: tableRowColumn.spacing,
	      height: tableRowColumn.height,
	      textAlign: 'left',
	      fontSize: 13,
	      overflow: 'hidden',
	      whiteSpace: 'nowrap',
	      textOverflow: 'ellipsis'
	    }
	  };
	
	  if (_react2.default.Children.count(props.children) === 1 && !isNaN(props.children)) {
	    styles.textAlign = 'right';
	  }
	
	  return styles;
	}
	
	var TableRowColumn = function (_Component) {
	  (0, _inherits3.default)(TableRowColumn, _Component);
	
	  function TableRowColumn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableRowColumn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableRowColumn.__proto__ || (0, _getPrototypeOf2.default)(TableRowColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event, _this.props.columnNumber);
	      }
	    }, _this.onMouseEnter = function (event) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: true });
	        if (_this.props.onHover) {
	          _this.props.onHover(event, _this.props.columnNumber);
	        }
	      }
	    }, _this.onMouseLeave = function (event) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: false });
	        if (_this.props.onHoverExit) {
	          _this.props.onHoverExit(event, _this.props.columnNumber);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableRowColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          columnNumber = _props.columnNumber,
	          hoverable = _props.hoverable,
	          onClick = _props.onClick,
	          onHover = _props.onHover,
	          onHoverExit = _props.onHoverExit,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var handlers = {
	        onClick: this.onClick,
	        onMouseEnter: this.onMouseEnter,
	        onMouseLeave: this.onMouseLeave
	      };
	
	      return _react2.default.createElement(
	        'td',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, handlers, other),
	        children
	      );
	    }
	  }]);
	  return TableRowColumn;
	}(_react.Component);
	
	TableRowColumn.defaultProps = {
	  hoverable: false
	};
	TableRowColumn.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TableRowColumn.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * @ignore
	   * Number to identify the header row. This property
	   * is automatically populated when used with TableHeader.
	   */
	  columnNumber: _propTypes2.default.number,
	  /**
	   * @ignore
	   * If true, this column responds to hover events.
	   */
	  hoverable: _propTypes2.default.bool,
	  /** @ignore */
	  onClick: _propTypes2.default.func,
	  /** @ignore */
	  onHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Callback function for hover exit event.
	   */
	  onHoverExit: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = TableRowColumn;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Toggle = __webpack_require__(1562);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Toggle2.default;

/***/ }),
/* 363 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  once: function once(el, type, callback) {
	    var typeArray = type ? type.split(' ') : [];
	    var recursiveFunction = function recursiveFunction(event) {
	      event.target.removeEventListener(event.type, recursiveFunction);
	      return callback(event);
	    };
	
	    for (var i = typeArray.length - 1; i >= 0; i--) {
	      this.on(el, typeArray[i], recursiveFunction);
	    }
	  },
	  on: function on(el, type, callback) {
	    if (el.addEventListener) {
	      el.addEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.attachEvent('on' + type, function () {
	        callback.call(el);
	      });
	    }
	  },
	  off: function off(el, type, callback) {
	    if (el.removeEventListener) {
	      el.removeEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.detachEvent('on' + type, callback);
	    }
	  },
	  isKeyboard: function isKeyboard(event) {
	    return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
	  }
	};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _activeElement = __webpack_require__(633);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(234);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _keycode = __webpack_require__(99);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(368);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _isRequiredForA11y = __webpack_require__(370);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(221);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ButtonGroup = __webpack_require__(501);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _DropdownMenu = __webpack_require__(1661);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownToggle = __webpack_require__(795);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _createChainedFunction = __webpack_require__(90);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _PropTypes = __webpack_require__(1709);
	
	var _ValidComponentChildren = __webpack_require__(108);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TOGGLE_ROLE = _DropdownToggle2.default.defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu2.default.defaultProps.bsRole;
	
	var propTypes = {
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _propTypes2.default.bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  componentClass: _elementType2.default,
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
	   * @type {node}
	   */
	  children: (0, _all2.default)((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _propTypes2.default.bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _propTypes2.default.bool,
	
	  defaultOpen: _propTypes2.default.bool,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
	   *
	   * ```js
	   * function(Boolean isOpen, Object event, { String source }) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _propTypes2.default.func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _propTypes2.default.string,
	
	  /**
	   * Which event when fired outside the component will cause it to be closed
	   */
	  rootCloseEvent: _propTypes2.default.oneOf(['click', 'mousedown']),
	
	  /**
	   * @private
	   */
	  onMouseEnter: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onMouseLeave: _propTypes2.default.func
	};
	
	var defaultProps = {
	  componentClass: _ButtonGroup2.default
	};
	
	var Dropdown = function (_React$Component) {
	  (0, _inherits3.default)(Dropdown, _React$Component);
	
	  function Dropdown(props, context) {
	    (0, _classCallCheck3.default)(this, Dropdown);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	
	    _this._focusInDropdown = false;
	    _this.lastOpenEventType = null;
	    return _this;
	  }
	
	  Dropdown.prototype.componentDidMount = function componentDidMount() {
	    this.focusNextOnOpen();
	  };
	
	  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!nextProps.open && this.props.open) {
	      this._focusInDropdown = (0, _contains2.default)(_reactDom2.default.findDOMNode(this.menu), (0, _activeElement2.default)(document));
	    }
	  };
	
	  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var open = this.props.open;
	
	    var prevOpen = prevProps.open;
	
	    if (open && !prevOpen) {
	      this.focusNextOnOpen();
	    }
	
	    if (!open && prevOpen) {
	      // if focus hasn't already moved from the menu let's return it
	      // to the toggle
	      if (this._focusInDropdown) {
	        this._focusInDropdown = false;
	        this.focus();
	      }
	    }
	  };
	
	  Dropdown.prototype.focus = function focus() {
	    var toggle = _reactDom2.default.findDOMNode(this.toggle);
	
	    if (toggle && toggle.focus) {
	      toggle.focus();
	    }
	  };
	
	  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
	    var menu = this.menu;
	
	    if (!menu.focusNext) {
	      return;
	    }
	
	    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	      menu.focusNext();
	    }
	  };
	
	  Dropdown.prototype.handleClick = function handleClick(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    this.toggleOpen(event, { source: 'click' });
	  };
	
	  Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
	    if (!this.props.open) {
	      return;
	    }
	
	    this.toggleOpen(event, eventDetails);
	  };
	
	  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    switch (event.keyCode) {
	      case _keycode2.default.codes.down:
	        if (!this.props.open) {
	          this.toggleOpen(event, { source: 'keydown' });
	        } else if (this.menu.focusNext) {
	          this.menu.focusNext();
	        }
	        event.preventDefault();
	        break;
	      case _keycode2.default.codes.esc:
	      case _keycode2.default.codes.tab:
	        this.handleClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
	    var open = !this.props.open;
	
	    if (open) {
	      this.lastOpenEventType = eventDetails.source;
	    }
	
	    if (this.props.onToggle) {
	      this.props.onToggle(open, event, eventDetails);
	    }
	  };
	
	  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
	    var _this2 = this;
	
	    var id = _ref.id,
	        onSelect = _ref.onSelect,
	        rootCloseEvent = _ref.rootCloseEvent,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['id', 'onSelect', 'rootCloseEvent']);
	
	    var ref = function ref(c) {
	      _this2.menu = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2.default)(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2.default)(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3.default)({}, props, {
	      ref: ref,
	      labelledBy: id,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
	      onClose: (0, _createChainedFunction2.default)(child.props.onClose, this.handleClose),
	      onSelect: (0, _createChainedFunction2.default)(child.props.onSelect, onSelect, function (key, event) {
	        return _this2.handleClose(event, { source: 'select' });
	      }),
	      rootCloseEvent: rootCloseEvent
	    }));
	  };
	
	  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
	    var _this3 = this;
	
	    var ref = function ref(c) {
	      _this3.toggle = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2.default)(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2.default)(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3.default)({}, props, {
	      ref: ref,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
	      onClick: (0, _createChainedFunction2.default)(child.props.onClick, this.handleClick),
	      onKeyDown: (0, _createChainedFunction2.default)(child.props.onKeyDown, this.handleKeyDown)
	    }));
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _classes,
	        _this4 = this;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        id = _props.id,
	        dropup = _props.dropup,
	        disabled = _props.disabled,
	        pullRight = _props.pullRight,
	        open = _props.open,
	        onSelect = _props.onSelect,
	        role = _props.role,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);
	
	
	    delete props.onToggle;
	
	    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);
	
	    if (dropup) {
	      classes[bsClass] = false;
	      classes.dropup = true;
	    }
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends3.default)({}, props, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        switch (child.props.bsRole) {
	          case TOGGLE_ROLE:
	            return _this4.renderToggle(child, {
	              id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
	            });
	          case MENU_ROLE:
	            return _this4.renderMenu(child, {
	              id: id, open: open, pullRight: pullRight, bsClass: bsClass, onSelect: onSelect, rootCloseEvent: rootCloseEvent
	            });
	          default:
	            return child;
	        }
	      })
	    );
	  };
	
	  return Dropdown;
	}(_react2.default.Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('dropdown', Dropdown);
	
	var UncontrolledDropdown = (0, _uncontrollable2.default)(Dropdown, { open: 'onToggle' });
	
	UncontrolledDropdown.Toggle = _DropdownToggle2.default;
	UncontrolledDropdown.Menu = _DropdownMenu2.default;
	
	exports.default = UncontrolledDropdown;
	module.exports = exports['default'];

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(814);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  in: _propTypes2.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _propTypes2.default.bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2.default.bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _propTypes2.default.number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _propTypes2.default.func
	};
	
	var defaultProps = {
	  in: false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false
	};
	
	var Fade = function (_React$Component) {
	  (0, _inherits3.default)(Fade, _React$Component);
	
	  function Fade() {
	    (0, _classCallCheck3.default)(this, Fade);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Fade.prototype.render = function render() {
	    return _react2.default.createElement(_Transition2.default, (0, _extends3.default)({}, this.props, {
	      className: (0, _classnames2.default)(this.props.className, 'fade'),
	      enteredClassName: 'in',
	      enteringClassName: 'in'
	    }));
	  };
	
	  return Fade;
	}(_react2.default.Component);
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	
	exports.default = Fade;
	module.exports = exports['default'];

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _MediaBody = __webpack_require__(1675);
	
	var _MediaBody2 = _interopRequireDefault(_MediaBody);
	
	var _MediaHeading = __webpack_require__(1676);
	
	var _MediaHeading2 = _interopRequireDefault(_MediaHeading);
	
	var _MediaLeft = __webpack_require__(1677);
	
	var _MediaLeft2 = _interopRequireDefault(_MediaLeft);
	
	var _MediaList = __webpack_require__(1678);
	
	var _MediaList2 = _interopRequireDefault(_MediaList);
	
	var _MediaListItem = __webpack_require__(1679);
	
	var _MediaListItem2 = _interopRequireDefault(_MediaListItem);
	
	var _MediaRight = __webpack_require__(1680);
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Media = function (_React$Component) {
	  (0, _inherits3.default)(Media, _React$Component);
	
	  function Media() {
	    (0, _classCallCheck3.default)(this, Media);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Media.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Media;
	}(_react2.default.Component);
	
	Media.propTypes = propTypes;
	Media.defaultProps = defaultProps;
	
	Media.Heading = _MediaHeading2.default;
	Media.Body = _MediaBody2.default;
	Media.Left = _MediaLeft2.default;
	Media.Right = _MediaRight2.default;
	Media.List = _MediaList2.default;
	Media.ListItem = _MediaListItem2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media', Media);
	module.exports = exports['default'];

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _entries = __webpack_require__(589);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	exports.default = splitComponentProps;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function splitComponentProps(props, Component) {
	  var componentPropTypes = Component.propTypes;
	
	  var parentProps = {};
	  var childProps = {};
	
	  (0, _entries2.default)(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (componentPropTypes[propName]) {
	      parentProps[propName] = propValue;
	    } else {
	      childProps[propName] = propValue;
	    }
	  });
	
	  return [parentProps, childProps];
	}
	module.exports = exports["default"];

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__(371);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}
	module.exports = exports['default'];

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(371);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);
	module.exports = exports['default'];

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 371 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	module.exports = exports['default'];

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = checkDecoratorArguments;
	function checkDecoratorArguments(functionName, signature) {
		if (false) {
			for (var i = 0; i < (arguments.length <= 2 ? 0 : arguments.length - 2); i += 1) {
				var arg = arguments.length <= i + 2 ? undefined : arguments[i + 2];
				if (arg && arg.prototype && arg.prototype.render) {
					// eslint-disable-next-line no-console
					console.error('You seem to be applying the arguments in the wrong order. ' + ('It should be ' + functionName + '(' + signature + ')(Component), not the other way around. ') + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
					return;
				}
			}
		}
	}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var EventPluginRegistry = __webpack_require__(512);
	var ReactEventEmitterMixin = __webpack_require__(1772);
	var ViewportMetrics = __webpack_require__(835);
	
	var getVendorPrefixedEventName = __webpack_require__(1804);
	var isEventSupported = __webpack_require__(523);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(296);
	var ViewportMetrics = __webpack_require__(835);
	
	var getEventModifierState = __webpack_require__(521);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var invariant = __webpack_require__(28);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 377 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(105);
	var DOMNamespaces = __webpack_require__(511);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(519);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdEdit = function MdEdit(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm34.5 11.7l-3 3.1-6.3-6.3 3.1-3q0.5-0.5 1.2-0.5t1.1 0.5l3.9 3.9q0.5 0.4 0.5 1.1t-0.5 1.2z m-29.5 17.1l18.4-18.5 6.3 6.3-18.4 18.4h-6.3v-6.2z' })
	        )
	    );
	};
	
	exports.default = MdEdit;
	module.exports = exports['default'];

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findInArray = findInArray;
	exports.isFunction = isFunction;
	exports.isNum = isNum;
	exports.int = int;
	exports.dontSetMe = dontSetMe;
	
	// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
	function findInArray(array
	/*: Array<any> | TouchList*/
	, callback
	/*: Function*/
	)
	/*: any*/
	{
	  for (var i = 0, length = array.length; i < length; i++) {
	    if (callback.apply(callback, [array[i], i, array])) return array[i];
	  }
	}
	
	function isFunction(func
	/*: any*/
	)
	/*: boolean %checks*/
	{
	  // $FlowIgnore[method-unbinding]
	  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
	}
	
	function isNum(num
	/*: any*/
	)
	/*: boolean %checks*/
	{
	  return typeof num === 'number' && !isNaN(num);
	}
	
	function int(a
	/*: string*/
	)
	/*: number*/
	{
	  return parseInt(a, 10);
	}
	
	function dontSetMe(props
	/*: Object*/
	, propName
	/*: string*/
	, componentName
	/*: string*/
	)
	/*: ?Error*/
	{
	  if (props[propName]) {
	    return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
	  }
	}

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var invariant = __webpack_require__(68);
	var PropTypes = __webpack_require__(167);
	var RouteHandler = __webpack_require__(382);
	
	/**
	 * <Route> components specify components that are rendered to the page when the
	 * URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is requested,
	 * the tree is searched depth-first to find a route whose path matches the URL.
	 * When one is found, all routes in the tree that lead to it are considered
	 * "active" and their components are rendered into the DOM, nested in the same
	 * order as they are in the tree.
	 *
	 * The preferred way to configure a router is using JSX. The XML-like syntax is
	 * a great way to visualize how routes are laid out in an application.
	 *
	 *   var routes = [
	 *     <Route handler={App}>
	 *       <Route name="login" handler={Login}/>
	 *       <Route name="logout" handler={Logout}/>
	 *       <Route name="about" handler={About}/>
	 *     </Route>
	 *   ];
	 *   
	 *   Router.run(routes, function (Handler) {
	 *     React.render(<Handler/>, document.body);
	 *   });
	 *
	 * Handlers for Route components that contain children can render their active
	 * child route using a <RouteHandler> element.
	 *
	 *   var App = React.createClass({
	 *     render: function () {
	 *       return (
	 *         <div className="application">
	 *           <RouteHandler/>
	 *         </div>
	 *       );
	 *     }
	 *   });
	 *
	 * If no handler is provided for the route, it will render a matched child route.
	 */
	
	var Route = (function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    _classCallCheck(this, Route);
	
	    _get(Object.getPrototypeOf(Route.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  _createClass(Route, [{
	    key: 'render',
	    value: function render() {
	      invariant(false, '%s elements are for router configuration only and should not be rendered', this.constructor.name);
	    }
	  }]);
	
	  return Route;
	})(React.Component);
	
	Route.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.string,
	  handler: PropTypes.func,
	  ignoreScrollBehavior: PropTypes.bool
	};
	
	Route.defaultProps = {
	  handler: RouteHandler
	};
	
	module.exports = Route;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var ContextWrapper = __webpack_require__(1858);
	var assign = __webpack_require__(251);
	var PropTypes = __webpack_require__(167);
	
	var REF_NAME = '__routeHandler__';
	
	/**
	 * A <RouteHandler> component renders the active child route handler
	 * when routes are nested.
	 */
	
	var RouteHandler = (function (_React$Component) {
	  _inherits(RouteHandler, _React$Component);
	
	  function RouteHandler() {
	    _classCallCheck(this, RouteHandler);
	
	    _get(Object.getPrototypeOf(RouteHandler.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  _createClass(RouteHandler, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        routeDepth: this.context.routeDepth + 1
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._updateRouteComponent(this.refs[REF_NAME]);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._updateRouteComponent(this.refs[REF_NAME]);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._updateRouteComponent(null);
	    }
	  }, {
	    key: '_updateRouteComponent',
	    value: function _updateRouteComponent(component) {
	      this.context.router.setRouteComponentAtDepth(this.getRouteDepth(), component);
	    }
	  }, {
	    key: 'getRouteDepth',
	    value: function getRouteDepth() {
	      return this.context.routeDepth;
	    }
	  }, {
	    key: 'createChildRouteHandler',
	    value: function createChildRouteHandler(props) {
	      var route = this.context.router.getRouteAtDepth(this.getRouteDepth());
	
	      if (route == null) return null;
	
	      var childProps = assign({}, props || this.props, {
	        ref: REF_NAME,
	        params: this.context.router.getCurrentParams(),
	        query: this.context.router.getCurrentQuery()
	      });
	
	      return React.createElement(route.handler, childProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var handler = this.createChildRouteHandler();
	      // <script/> for things like <CSSTransitionGroup/> that don't like null
	      return handler ? React.createElement(
	        ContextWrapper,
	        null,
	        handler
	      ) : React.createElement('script', null);
	    }
	  }]);
	
	  return RouteHandler;
	})(React.Component);
	
	RouteHandler.contextTypes = {
	  routeDepth: PropTypes.number.isRequired,
	  router: PropTypes.router.isRequired
	};
	
	RouteHandler.childContextTypes = {
	  routeDepth: PropTypes.number.isRequired
	};
	
	module.exports = RouteHandler;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
	                                                                                                                                                                                                                                                                                Copyright (c) 2018 Jed Watson.
	                                                                                                                                                                                                                                                                                Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                              */
	
	
	var _reactInputAutosize = __webpack_require__(1869);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _defaultArrowRenderer = __webpack_require__(870);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(871);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(533);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(534);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Option = __webpack_require__(868);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(869);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var shouldShowValue = function shouldShowValue(state, props) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		if (!inputValue) return true;
	
		if (!onSelectResetsInput) {
			return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
		}
	
		return false;
	};
	
	var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
	};
	
	/**
	 * Retrieve a value from the given options and valueKey
	 * @param {String|Number|Array} value	- the selected value(s)
	 * @param {Object}		 props	- the Select component's props (or nextProps)
	 */
	var expandValue = function expandValue(value, props) {
		var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options,
		    valueKey = props.valueKey;
	
		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (String(options[i][valueKey]) === String(value)) return options[i];
		}
	};
	
	var handleRequired = function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	};
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
	
				if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
					this.setState({ inputValue: this.handleInputValueChange('') });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
	
					var scrollTop = menuNode.scrollTop;
					var scrollBottom = scrollTop + menuNode.offsetHeight;
					var optionTop = focusedOptionNode.offsetTop;
					var optionBottom = optionTop + focusedOptionNode.offsetHeight;
	
					if (scrollTop > optionTop || scrollBottom < optionBottom) {
						menuNode.scrollTop = focusedOptionNode.offsetTop;
					}
	
					// We still set hasScrolledToOption to true even if we didn't
					// actually need to scroll, as we've still confirmed that the
					// option is in view.
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
				var pref = document.addEventListener ? '' : 'on';
	
				document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
				document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					if (!this.state.isFocused) {
						this._openAfterFocus = this.props.openOnClick;
						this.focus();
					} else if (!this.state.isOpen) {
						this.setState({
							isOpen: true,
							isPseudoFocused: false,
							focusedOption: null
						});
					}
	
					return;
				}
	
				// prevent default event handlers
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen,
						focusedOption: null
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					var toOpen = true;
	
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					if (this._focusAfterClear) {
						toOpen = false;
						this._focusAfterClear = false;
					}
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: toOpen,
						isPseudoFocused: false,
						focusedOption: null
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
					this.setState({ focusedOption: null });
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (this.state.isOpen) {
					// prevent default event handlers
					event.stopPropagation();
					event.preventDefault();
					// close the menu
					this.closeMenu();
				} else {
					// If the menu isn't open, let the event bubble to the main handleMouseDown
					this.setState({
						isOpen: true
					});
				}
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
	
				var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.
	
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
	
				this.setState({
					isFocused: true,
					isOpen: !!toOpen
				});
	
				this._focusAfterClear = false;
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					inputValue: newInputValue,
					isOpen: true,
					isPseudoFocused: false
				});
			}
		}, {
			key: 'setInputValue',
			value: function setInputValue(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				this.setState({
					inputValue: newValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							break;
						}
						event.preventDefault();
						this.selectFocusedOption();
						break;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						break;
					case 27:
						// escape
						event.preventDefault();
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							break;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							break;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						event.preventDefault();
						this.focusPreviousOption();
						break;
					case 40:
						// down
						event.preventDefault();
						this.focusNextOption();
						break;
					case 33:
						// page up
						event.preventDefault();
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						event.preventDefault();
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusStartOption();
						break;
					case 46:
						// delete
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
				}
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param {String|Number|Array} value		- the value of the select input
	   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value) {
				var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this2 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this2.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				if (this.props.onChange) {
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this3 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				if (this.props.multi) {
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this3.getValueArray(_this3.props.value);
						if (valueArray.some(function (i) {
							return i[_this3.props.valueKey] === value[_this3.props.valueKey];
						})) {
							_this3.removeValue(value);
						} else {
							_this3.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this3.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (!this.props.closeOnSelect) {
					return;
				}
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this4 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.preventDefault();
	
				this.setValue(this.getResetValue());
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false
				}, this.focus);
	
				this._focusAfterClear = true;
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					var newState = {
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
						isOpen: true
					};
					if (this.props.onSelectResetsInput) {
						newState.inputValue = '';
					}
					this.setState(newState);
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var _potentialIndex = focusedIndex + this.props.pageSize;
					if (_potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = _potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this5 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
					return showPlaceholder ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								disabled: _this5.props.disabled || value.clearableValue === false,
								id: _this5._instancePrefix + '-value-' + i,
								instancePrefix: _this5._instancePrefix,
								key: 'value-' + i + '-' + value[_this5.props.valueKey],
								onClick: onClick,
								onRemove: _this5.removeValue,
								placeholder: _this5.props.placeholder,
								value: value,
								values: valueArray
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (shouldShowValue(this.state, this.props)) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							disabled: this.props.disabled,
							id: this._instancePrefix + '-value-item',
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							placeholder: this.props.placeholder,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this6 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				var value = this.state.inputValue;
				if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
					// it hides input value when it is not focused and was not reset on select
					value = '';
				}
	
				var inputProps = _extends({}, this.props.inputProps, {
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-expanded': '' + isOpen,
					'aria-haspopup': '' + isOpen,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-owns': ariaOwns,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this6.input = _ref;
					},
					role: 'combobox',
					required: this.state.required,
					tabIndex: this.props.tabIndex,
					value: value
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var divProps = _objectWithoutProperties(this.props.inputProps, []);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-disabled': '' + this.props.disabled,
						'aria-label': this.props['aria-label'],
						'aria-labelledby': this.props['aria-labelledby'],
						className: className,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this6.input = _ref2;
						},
						role: 'combobox',
						style: { border: 0, width: 1, display: 'inline-block' },
						tabIndex: this.props.tabIndex || 0
					}));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{
						'aria-label': ariaLabel,
						className: 'Select-clear-zone',
						onMouseDown: this.clearValue,
						onTouchEnd: this.handleTouchEndClearValue,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						title: ariaLabel
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						trimFilter: this.props.trimFilter,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onOptionRef: this.onOptionRef,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						removeValue: this.removeValue,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this7 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this7.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						disabled: this.props.disabled,
						name: this.props.name,
						ref: function ref(_ref3) {
							return _this7.value = _ref3;
						},
						type: 'hidden',
						value: value
					});
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', {
						disabled: _this7.props.disabled,
						key: 'hidden.' + index,
						name: _this7.props.name,
						ref: 'value' + index,
						type: 'hidden',
						value: stringifyValue(item[_this7.props.valueKey])
					});
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this8 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this8.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{
							className: 'Select-menu',
							id: this._instancePrefix + '-list',
							onMouseDown: this.handleMouseDownOnMenu,
							onScroll: this.handleMenuScroll,
							ref: function ref(_ref4) {
								return _this8.menu = _ref4;
							},
							role: 'listbox',
							style: this.props.menuStyle,
							tabIndex: -1
						},
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'has-value': valueArray.length,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'Select--multi': this.props.multi,
					'Select--rtl': this.props.rtl,
					'Select--single': !this.props.multi
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this9.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this9.control = _ref6;
							},
							className: 'Select-control',
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchMove: this.handleTouchMove,
							onTouchStart: this.handleTouchStart,
							style: this.props.style
						},
						_react2.default.createElement(
							'div',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // html id of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // create the drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether delete removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: stringOrNumber, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onCloseResetsInput: true,
		onSelectResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dates = __webpack_require__(188);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VIEW_UNITS = ['month', 'year', 'decade', 'century'];
	
	function clamp(date, min, max) {
	  return _dates2.default.max(_dates2.default.min(date, max), min);
	}
	
	var CalendarView = function (_React$Component) {
	  _inherits(CalendarView, _React$Component);
	
	  function CalendarView() {
	    _classCallCheck(this, CalendarView);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CalendarView.prototype.render = function render() {
	    var className = this.props.className;
	
	
	    return _react2.default.createElement('table', _extends({}, this.props, {
	      role: 'grid',
	      tabIndex: '-1',
	      className: (0, _classnames2.default)(className, 'rw-nav-view', 'rw-calendar-grid')
	    }));
	  };
	
	  return CalendarView;
	}(_react2.default.Component);
	
	var CalendarViewCell = (_temp2 = _class = function (_React$Component2) {
	  _inherits(CalendarViewCell, _React$Component2);
	
	  function CalendarViewCell() {
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, CalendarViewCell);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [this].concat(args))), _this2), _this2.handleChange = function () {
	      var _this2$props = _this2.props,
	          onChange = _this2$props.onChange,
	          min = _this2$props.min,
	          max = _this2$props.max,
	          date = _this2$props.date;
	
	      onChange(clamp(date, min, max));
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  CalendarViewCell.prototype.isEqual = function isEqual(date) {
	    return _dates2.default.eq(this.props.date, date, this.props.unit);
	  };
	
	  CalendarViewCell.prototype.isEmpty = function isEmpty() {
	    var _props = this.props,
	        unit = _props.unit,
	        min = _props.min,
	        max = _props.max,
	        date = _props.date;
	
	    return !_dates2.default.inRange(date, min, max, unit);
	  };
	
	  CalendarViewCell.prototype.isNow = function isNow() {
	    return this.isEqual(this.props.now);
	  };
	
	  CalendarViewCell.prototype.isFocused = function isFocused() {
	    return this.isEqual(this.props.focused);
	  };
	
	  CalendarViewCell.prototype.isSelected = function isSelected() {
	    return this.isEqual(this.props.selected);
	  };
	
	  CalendarViewCell.prototype.isOffView = function isOffView() {
	    var _props2 = this.props,
	        viewUnit = _props2.viewUnit,
	        focused = _props2.focused,
	        date = _props2.date;
	
	    return viewUnit && _dates2.default[viewUnit](date) !== _dates2.default[viewUnit](focused);
	  };
	
	  CalendarViewCell.prototype.render = function render() {
	    var _props3 = this.props,
	        children = _props3.children,
	        id = _props3.id,
	        label = _props3.label,
	        disabled = _props3.disabled;
	
	
	    if (this.isEmpty()) {
	      return _react2.default.createElement(
	        'td',
	        { className: 'rw-empty-cell', role: 'presentation' },
	        '\xA0'
	      );
	    }
	
	    return _react2.default.createElement(
	      'td',
	      {
	        role: 'gridcell',
	        id: id,
	        title: label,
	        'aria-label': label,
	        'aria-readonly': disabled,
	        'aria-selected': this.isSelected()
	      },
	      _react2.default.createElement(
	        'span',
	        {
	          'aria-labelledby': id,
	          onClick: this.handleChange,
	          className: (0, _classnames2.default)('rw-btn', this.isNow() && 'rw-now', this.isOffView() && 'rw-off-range', this.isFocused() && 'rw-state-focus', this.isSelected() && 'rw-state-selected')
	        },
	        children
	      )
	    );
	  };
	
	  return CalendarViewCell;
	}(_react2.default.Component), _class.propTypes = {
	  id: _propTypes2.default.string,
	  label: _propTypes2.default.string,
	  today: _propTypes2.default.instanceOf(Date),
	  selected: _propTypes2.default.instanceOf(Date),
	  focused: _propTypes2.default.instanceOf(Date),
	  min: _propTypes2.default.instanceOf(Date),
	  max: _propTypes2.default.instanceOf(Date),
	  unit: _propTypes2.default.oneOf(['day'].concat(VIEW_UNITS)),
	  viewUnit: _propTypes2.default.oneOf(VIEW_UNITS),
	  onChange: _propTypes2.default.func.isRequired
	}, _temp2);
	
	
	CalendarView.Row = function (props) {
	  return _react2.default.createElement('tr', _extends({ role: 'row' }, props));
	};
	CalendarView.Cell = CalendarViewCell;
	
	exports.default = CalendarView;
	module.exports = exports['default'];

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var offset = __webpack_require__(541),
	    getWindow = __webpack_require__(303);
	
	module.exports = function height(node, client) {
	  var win = getWindow(node);
	  return win ? win.innerHeight : client ? node.clientHeight : offset(node).height;
	};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ZAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ZAxis, _PureComponent);
	
	  function ZAxis() {
	    _classCallCheck(this, ZAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ZAxis).apply(this, arguments));
	  }
	
	  _createClass(ZAxis, [{
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ZAxis;
	}(_react.PureComponent);
	
	ZAxis.displayName = 'ZAxis';
	ZAxis.propTypes = {
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  // The name of data displayed in the axis
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unique id of z-axis
	  zAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The key of data displayed in the axis
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  // The range of axis
	  range: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), _propTypes["default"].func])
	};
	ZAxis.defaultProps = {
	  zAxisId: 0,
	  range: [64, 64],
	  scale: 'auto',
	  type: 'number'
	};
	var _default = ZAxis;
	exports["default"] = _default;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(115));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _uniqBy2 = _interopRequireDefault(__webpack_require__(488));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = __webpack_require__(129);
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _DefaultTooltipContent = _interopRequireDefault(__webpack_require__(1953));
	
	var _ReactUtils = __webpack_require__(43);
	
	var _DataUtils = __webpack_require__(66);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CLS_PREFIX = 'recharts-tooltip-wrapper';
	var EPS = 1;
	
	var defaultUniqBy = function defaultUniqBy(entry) {
	  return entry.dataKey;
	};
	
	var getUniqPaylod = function getUniqPaylod(option, payload) {
	  if (option === true) {
	    return (0, _uniqBy2["default"])(payload, defaultUniqBy);
	  }
	
	  if ((0, _isFunction2["default"])(option)) {
	    return (0, _uniqBy2["default"])(payload, option);
	  }
	
	  return payload;
	};
	
	var propTypes = {
	  allowEscapeViewBox: _propTypes["default"].shape({
	    x: _propTypes["default"]["boolean"],
	    y: _propTypes["default"]["boolean"]
	  }),
	  content: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  active: _propTypes["default"].bool,
	  separator: _propTypes["default"].string,
	  formatter: _propTypes["default"].func,
	  offset: _propTypes["default"].number,
	  itemStyle: _propTypes["default"].object,
	  labelStyle: _propTypes["default"].object,
	  wrapperStyle: _propTypes["default"].object,
	  contentStyle: _propTypes["default"].object,
	  cursor: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].element, _propTypes["default"].object]),
	  coordinate: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number
	  }),
	  position: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number
	  }),
	  label: _propTypes["default"].any,
	  payload: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    name: _propTypes["default"].any,
	    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].array]),
	    unit: _propTypes["default"].any,
	    type: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES)
	  })),
	  paylodUniqBy: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].bool]),
	  isAnimationActive: _propTypes["default"].bool,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  itemSorter: _propTypes["default"].func,
	  filterNull: _propTypes["default"].bool,
	  useTranslate3d: _propTypes["default"].bool
	};
	var defaultProps = {
	  active: false,
	  allowEscapeViewBox: {
	    x: false,
	    y: false
	  },
	  offset: 10,
	  viewBox: {
	    x1: 0,
	    x2: 0,
	    y1: 0,
	    y2: 0
	  },
	  coordinate: {
	    x: 0,
	    y: 0
	  },
	  cursorStyle: {},
	  separator: ' : ',
	  wrapperStyle: {},
	  contentStyle: {},
	  itemStyle: {},
	  labelStyle: {},
	  cursor: true,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationEasing: 'ease',
	  animationDuration: 400,
	  filterNull: true,
	  useTranslate3d: false
	};
	
	var renderContent = function renderContent(content, props) {
	  if (_react["default"].isValidElement(content)) {
	    return _react["default"].cloneElement(content, props);
	  }
	
	  if ((0, _isFunction2["default"])(content)) {
	    return content(props);
	  }
	
	  return _react["default"].createElement(_DefaultTooltipContent["default"], props);
	};
	
	var Tooltip =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Tooltip, _PureComponent);
	
	  function Tooltip() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Tooltip);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    };
	
	    _this.getTranslate = function (_ref) {
	      var key = _ref.key,
	          tooltipDimension = _ref.tooltipDimension,
	          viewBoxDimension = _ref.viewBoxDimension;
	      var _this$props = _this.props,
	          allowEscapeViewBox = _this$props.allowEscapeViewBox,
	          coordinate = _this$props.coordinate,
	          offset = _this$props.offset,
	          position = _this$props.position,
	          viewBox = _this$props.viewBox;
	
	      if (position && (0, _DataUtils.isNumber)(position[key])) {
	        return position[key];
	      }
	
	      var restricted = coordinate[key] - tooltipDimension - offset;
	      var unrestricted = coordinate[key] + offset;
	
	      if (allowEscapeViewBox[key]) {
	        return unrestricted;
	      }
	
	      var tooltipBoundary = coordinate[key] + tooltipDimension + offset;
	      var viewBoxBoundary = viewBox[key] + viewBoxDimension;
	
	      if (tooltipBoundary > viewBoxBoundary) {
	        return Math.max(restricted, viewBox[key]);
	      }
	
	      return Math.max(unrestricted, viewBox[key]);
	    };
	
	    return _this;
	  }
	
	  _createClass(Tooltip, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: "updateBBox",
	    value: function updateBBox() {
	      var _this$state = this.state,
	          boxWidth = _this$state.boxWidth,
	          boxHeight = _this$state.boxHeight;
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames,
	          _this2 = this;
	
	      var _this$props2 = this.props,
	          payload = _this$props2.payload,
	          isAnimationActive = _this$props2.isAnimationActive,
	          animationDuration = _this$props2.animationDuration,
	          animationEasing = _this$props2.animationEasing,
	          filterNull = _this$props2.filterNull,
	          paylodUniqBy = _this$props2.paylodUniqBy;
	      var finalPayload = getUniqPaylod(paylodUniqBy, filterNull && payload && payload.length ? payload.filter(function (entry) {
	        return !(0, _isNil2["default"])(entry.value);
	      }) : payload);
	      var hasPayload = finalPayload && finalPayload.length;
	      var _this$props3 = this.props,
	          content = _this$props3.content,
	          viewBox = _this$props3.viewBox,
	          coordinate = _this$props3.coordinate,
	          position = _this$props3.position,
	          active = _this$props3.active,
	          wrapperStyle = _this$props3.wrapperStyle;
	
	      var outerStyle = _objectSpread({
	        pointerEvents: 'none',
	        visibility: active && hasPayload ? 'visible' : 'hidden',
	        position: 'absolute',
	        top: 0
	      }, wrapperStyle);
	
	      var translateX, translateY;
	
	      if (position && (0, _DataUtils.isNumber)(position.x) && (0, _DataUtils.isNumber)(position.y)) {
	        translateX = position.x;
	        translateY = position.y;
	      } else {
	        var _this$state2 = this.state,
	            boxWidth = _this$state2.boxWidth,
	            boxHeight = _this$state2.boxHeight;
	
	        if (boxWidth > 0 && boxHeight > 0 && coordinate) {
	          translateX = this.getTranslate({
	            key: 'x',
	            tooltipDimension: boxWidth,
	            viewBoxDimension: viewBox.width
	          });
	          translateY = this.getTranslate({
	            key: 'y',
	            tooltipDimension: boxHeight,
	            viewBoxDimension: viewBox.height
	          });
	        } else {
	          outerStyle.visibility = 'hidden';
	        }
	      }
	
	      outerStyle = _objectSpread({}, (0, _reactSmooth.translateStyle)({
	        transform: this.props.useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
	      }), {}, outerStyle);
	
	      if (isAnimationActive && active) {
	        outerStyle = _objectSpread({}, (0, _reactSmooth.translateStyle)({
	          transition: "transform ".concat(animationDuration, "ms ").concat(animationEasing)
	        }), {}, outerStyle);
	      }
	
	      var cls = (0, _classnames["default"])(CLS_PREFIX, (_classNames = {}, _defineProperty(_classNames, "".concat(CLS_PREFIX, "-right"), (0, _DataUtils.isNumber)(translateX) && coordinate && (0, _DataUtils.isNumber)(coordinate.x) && translateX >= coordinate.x), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-left"), (0, _DataUtils.isNumber)(translateX) && coordinate && (0, _DataUtils.isNumber)(coordinate.x) && translateX < coordinate.x), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-bottom"), (0, _DataUtils.isNumber)(translateY) && coordinate && (0, _DataUtils.isNumber)(coordinate.y) && translateY >= coordinate.y), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-top"), (0, _DataUtils.isNumber)(translateY) && coordinate && (0, _DataUtils.isNumber)(coordinate.y) && translateY < coordinate.y), _classNames));
	      return _react["default"].createElement("div", {
	        className: cls,
	        style: outerStyle,
	        ref: function ref(node) {
	          _this2.wrapperNode = node;
	        }
	      }, renderContent(content, _objectSpread({}, this.props, {
	        payload: finalPayload
	      })));
	    }
	  }]);
	
	  return Tooltip;
	}(_react.PureComponent);
	
	Tooltip.displayName = 'Tooltip';
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	var _default = Tooltip;
	exports["default"] = _default;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _ReactUtils = __webpack_require__(43);
	
	var _Dot = _interopRequireDefault(__webpack_require__(218));
	
	var _Polygon = _interopRequireDefault(__webpack_require__(390));
	
	var _Text = _interopRequireDefault(__webpack_require__(217));
	
	var _PolarUtils = __webpack_require__(142);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var RADIAN = Math.PI / 180;
	var eps = 1e-5;
	
	var PolarAngleAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(PolarAngleAxis, _PureComponent);
	
	  function PolarAngleAxis() {
	    _classCallCheck(this, PolarAngleAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PolarAngleAxis).apply(this, arguments));
	  }
	
	  _createClass(PolarAngleAxis, [{
	    key: "getTickLineCoord",
	
	    /**
	     * Calculate the coordinate of line endpoint
	     * @param  {Object} data The Data if ticks
	     * @return {Object} (x0, y0): The start point of text,
	     *                  (x1, y1): The end point close to text,
	     *                  (x2, y2): The end point close to axis
	     */
	    value: function getTickLineCoord(data) {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          radius = _this$props.radius,
	          orientation = _this$props.orientation,
	          tickLine = _this$props.tickLine;
	      var tickLineSize = tickLine && tickLine.size || 8;
	      var p1 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, data.coordinate);
	      var p2 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.coordinate);
	      return {
	        x1: p1.x,
	        y1: p1.y,
	        x2: p2.x,
	        y2: p2.y
	      };
	    }
	    /**
	     * Get the text-anchor of each tick
	     * @param  {Object} data Data of ticks
	     * @return {String} text-anchor
	     */
	
	  }, {
	    key: "getTickTextAnchor",
	    value: function getTickTextAnchor(data) {
	      var orientation = this.props.orientation;
	      var cos = Math.cos(-data.coordinate * RADIAN);
	      var textAnchor;
	
	      if (cos > eps) {
	        textAnchor = orientation === 'outer' ? 'start' : 'end';
	      } else if (cos < -eps) {
	        textAnchor = orientation === 'outer' ? 'end' : 'start';
	      } else {
	        textAnchor = 'middle';
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: "renderAxisLine",
	    value: function renderAxisLine() {
	      var _this$props2 = this.props,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          radius = _this$props2.radius,
	          axisLine = _this$props2.axisLine,
	          axisLineType = _this$props2.axisLineType;
	
	      var props = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (axisLineType === 'circle') {
	        return _react["default"].createElement(_Dot["default"], _extends({
	          className: "recharts-polar-angle-axis-line"
	        }, props, {
	          cx: cx,
	          cy: cy,
	          r: radius
	        }));
	      }
	
	      var ticks = this.props.ticks;
	      var points = ticks.map(function (entry) {
	        return (0, _PolarUtils.polarToCartesian)(cx, cy, radius, entry.coordinate);
	      });
	      return _react["default"].createElement(_Polygon["default"], _extends({
	        className: "recharts-polar-angle-axis-line"
	      }, props, {
	        points: points
	      }));
	    }
	  }, {
	    key: "renderTicks",
	    value: function renderTicks() {
	      var _this = this;
	
	      var _this$props3 = this.props,
	          ticks = _this$props3.ticks,
	          tick = _this$props3.tick,
	          tickLine = _this$props3.tickLine,
	          tickFormatter = _this$props3.tickFormatter,
	          stroke = _this$props3.stroke;
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	
	      var tickLineProps = _objectSpread({}, axisProps, {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	
	      var items = ticks.map(function (entry, i) {
	        var lineCoord = _this.getTickLineCoord(entry);
	
	        var textAnchor = _this.getTickTextAnchor(entry);
	
	        var tickProps = _objectSpread({
	          textAnchor: textAnchor
	        }, axisProps, {
	          stroke: 'none',
	          fill: stroke
	        }, customTickProps, {
	          index: i,
	          payload: entry,
	          x: lineCoord.x2,
	          y: lineCoord.y2
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-polar-angle-axis-tick",
	          key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), tickLine && _react["default"].createElement("line", _extends({
	          className: "recharts-polar-angle-axis-tick-line"
	        }, tickLineProps, lineCoord)), tick && _this.constructor.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value));
	      });
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-polar-angle-axis-ticks"
	      }, items);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          ticks = _this$props4.ticks,
	          radius = _this$props4.radius,
	          axisLine = _this$props4.axisLine;
	
	      if (radius <= 0 || !ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-polar-angle-axis"
	      }, axisLine && this.renderAxisLine(), this.renderTicks());
	    }
	  }], [{
	    key: "renderTickItem",
	    value: function renderTickItem(option, props, value) {
	      var tickItem;
	
	      if (_react["default"].isValidElement(option)) {
	        tickItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react["default"].createElement(_Text["default"], _extends({}, props, {
	          className: "recharts-polar-angle-axis-tick-value"
	        }), value);
	      }
	
	      return tickItem;
	    }
	  }]);
	
	  return PolarAngleAxis;
	}(_react.PureComponent);
	
	PolarAngleAxis.displayName = 'PolarAngleAxis';
	PolarAngleAxis.axisType = 'angleAxis';
	PolarAngleAxis.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  angleAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].func]),
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  radius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  hide: _propTypes["default"].bool,
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(_ReactUtils.SCALE_TYPES), _propTypes["default"].func]),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  axisLineType: _propTypes["default"].oneOf(['polygon', 'circle']),
	  tickLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  ticks: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    value: _propTypes["default"].any,
	    coordinate: _propTypes["default"].number
	  })),
	  stroke: _propTypes["default"].string,
	  orientation: _propTypes["default"].oneOf(['inner', 'outer']),
	  tickFormatter: _propTypes["default"].func,
	  allowDuplicatedCategory: _propTypes["default"].bool
	});
	PolarAngleAxis.defaultProps = {
	  type: 'category',
	  angleAxisId: 0,
	  scale: 'auto',
	  cx: 0,
	  cy: 0,
	  domain: [0, 'auto'],
	  orientation: 'outer',
	  axisLine: true,
	  tickLine: true,
	  tick: true,
	  hide: false,
	  allowDuplicatedCategory: true
	};
	var _default = PolarAngleAxis;
	exports["default"] = _default;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _minBy2 = _interopRequireDefault(__webpack_require__(728));
	
	var _maxBy2 = _interopRequireDefault(__webpack_require__(725));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Text = _interopRequireDefault(__webpack_require__(217));
	
	var _Label = _interopRequireDefault(__webpack_require__(190));
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _ReactUtils = __webpack_require__(43);
	
	var _PolarUtils = __webpack_require__(142);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var PolarRadiusAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(PolarRadiusAxis, _PureComponent);
	
	  function PolarRadiusAxis() {
	    _classCallCheck(this, PolarRadiusAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PolarRadiusAxis).apply(this, arguments));
	  }
	
	  _createClass(PolarRadiusAxis, [{
	    key: "getTickValueCoord",
	
	    /**
	     * Calculate the coordinate of tick
	     * @param  {Number} coordinate The radius of tick
	     * @return {Object} (x, y)
	     */
	    value: function getTickValueCoord(_ref) {
	      var coordinate = _ref.coordinate;
	      var _this$props = this.props,
	          angle = _this$props.angle,
	          cx = _this$props.cx,
	          cy = _this$props.cy;
	      return (0, _PolarUtils.polarToCartesian)(cx, cy, coordinate, angle);
	    }
	  }, {
	    key: "getTickTextAnchor",
	    value: function getTickTextAnchor() {
	      var orientation = this.props.orientation;
	      var textAnchor;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = 'end';
	          break;
	
	        case 'right':
	          textAnchor = 'start';
	          break;
	
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: "getViewBox",
	    value: function getViewBox() {
	      var _this$props2 = this.props,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          angle = _this$props2.angle,
	          ticks = _this$props2.ticks;
	      var maxRadiusTick = (0, _maxBy2["default"])(ticks, function (entry) {
	        return entry.coordinate || 0;
	      });
	      var minRadiusTick = (0, _minBy2["default"])(ticks, function (entry) {
	        return entry.coordinate || 0;
	      });
	      return {
	        cx: cx,
	        cy: cy,
	        startAngle: angle,
	        endAngle: angle,
	        innerRadius: minRadiusTick.coordinate || 0,
	        outerRadius: maxRadiusTick.coordinate || 0
	      };
	    }
	  }, {
	    key: "renderAxisLine",
	    value: function renderAxisLine() {
	      var _this$props3 = this.props,
	          cx = _this$props3.cx,
	          cy = _this$props3.cy,
	          angle = _this$props3.angle,
	          ticks = _this$props3.ticks,
	          axisLine = _this$props3.axisLine,
	          others = _objectWithoutProperties(_this$props3, ["cx", "cy", "angle", "ticks", "axisLine"]);
	
	      var extent = ticks.reduce(function (result, entry) {
	        return [Math.min(result[0], entry.coordinate), Math.max(result[1], entry.coordinate)];
	      }, [Infinity, -Infinity]);
	      var point0 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[0], angle);
	      var point1 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[1], angle);
	
	      var props = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine), {
	        x1: point0.x,
	        y1: point0.y,
	        x2: point1.x,
	        y2: point1.y
	      });
	
	      return _react["default"].createElement("line", _extends({
	        className: "recharts-polar-radius-axis-line"
	      }, props));
	    }
	  }, {
	    key: "renderTicks",
	    value: function renderTicks() {
	      var _this = this;
	
	      var _this$props4 = this.props,
	          ticks = _this$props4.ticks,
	          tick = _this$props4.tick,
	          angle = _this$props4.angle,
	          tickFormatter = _this$props4.tickFormatter,
	          stroke = _this$props4.stroke,
	          others = _objectWithoutProperties(_this$props4, ["ticks", "tick", "angle", "tickFormatter", "stroke"]);
	
	      var textAnchor = this.getTickTextAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(others);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	      var items = ticks.map(function (entry, i) {
	        var coord = _this.getTickValueCoord(entry);
	
	        var tickProps = _objectSpread({
	          textAnchor: textAnchor,
	          transform: "rotate(".concat(90 - angle, ", ").concat(coord.x, ", ").concat(coord.y, ")")
	        }, axisProps, {
	          stroke: 'none',
	          fill: stroke
	        }, customTickProps, {
	          index: i
	        }, coord, {
	          payload: entry
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-polar-radius-axis-tick",
	          key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), _this.constructor.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value));
	      });
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-polar-radius-axis-ticks"
	      }, items);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props5 = this.props,
	          ticks = _this$props5.ticks,
	          axisLine = _this$props5.axisLine,
	          tick = _this$props5.tick;
	
	      if (!ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-polar-radius-axis"
	      }, axisLine && this.renderAxisLine(), tick && this.renderTicks(), _Label["default"].renderCallByParent(this.props, this.getViewBox()));
	    }
	  }], [{
	    key: "renderTickItem",
	    value: function renderTickItem(option, props, value) {
	      var tickItem;
	
	      if (_react["default"].isValidElement(option)) {
	        tickItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react["default"].createElement(_Text["default"], _extends({}, props, {
	          className: "recharts-polar-radius-axis-tick-value"
	        }), value);
	      }
	
	      return tickItem;
	    }
	  }]);
	
	  return PolarRadiusAxis;
	}(_react.PureComponent);
	
	PolarRadiusAxis.displayName = 'PolarRadiusAxis';
	PolarRadiusAxis.axisType = 'radiusAxis';
	PolarRadiusAxis.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  hide: _propTypes["default"].bool,
	  radiusAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  angle: _propTypes["default"].number,
	  tickCount: _propTypes["default"].number,
	  ticks: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    value: _propTypes["default"].any,
	    coordinate: _propTypes["default"].number
	  })),
	  orientation: _propTypes["default"].oneOf(['left', 'right', 'middle']),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func]),
	  stroke: _propTypes["default"].string,
	  tickFormatter: _propTypes["default"].func,
	  domain: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['auto', 'dataMin', 'dataMax'])])),
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), _propTypes["default"].func]),
	  allowDataOverflow: _propTypes["default"].bool,
	  allowDuplicatedCategory: _propTypes["default"].bool
	});
	PolarRadiusAxis.defaultProps = {
	  type: 'number',
	  radiusAxisId: 0,
	  cx: 0,
	  cy: 0,
	  angle: 0,
	  orientation: 'right',
	  stroke: '#ccc',
	  axisLine: true,
	  tick: true,
	  tickCount: 5,
	  domain: [0, 'auto'],
	  allowDataOverflow: false,
	  scale: 'auto',
	  allowDuplicatedCategory: true
	};
	var _default = PolarRadiusAxis;
	exports["default"] = _default;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _ReactUtils = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getPolygonPoints = function getPolygonPoints(points) {
	  return points.reduce(function (result, entry) {
	    if (entry.x === +entry.x && entry.y === +entry.y) {
	      result.push([entry.x, entry.y]);
	    }
	
	    return result;
	  }, []).join(' ');
	};
	
	var Polygon =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Polygon, _PureComponent);
	
	  function Polygon() {
	    _classCallCheck(this, Polygon);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Polygon).apply(this, arguments));
	  }
	
	  _createClass(Polygon, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          points = _this$props.points,
	          className = _this$props.className;
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-polygon', className);
	      return _react["default"].createElement("polygon", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        points: getPolygonPoints(points)
	      }));
	    }
	  }]);
	
	  return Polygon;
	}(_react.PureComponent);
	
	Polygon.displayName = 'Polygon';
	Polygon.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number
	  }))
	});
	var _default = Polygon;
	exports["default"] = _default;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _ReactUtils = __webpack_require__(43);
	
	var _PolarUtils = __webpack_require__(142);
	
	var _DataUtils = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
	  return sign * deltaAngle;
	};
	
	var getTangentCircle = function getTangentCircle(_ref) {
	  var cx = _ref.cx,
	      cy = _ref.cy,
	      radius = _ref.radius,
	      angle = _ref.angle,
	      sign = _ref.sign,
	      isExternal = _ref.isExternal,
	      cornerRadius = _ref.cornerRadius,
	      cornerIsExternal = _ref.cornerIsExternal;
	  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
	
	  var theta = Math.asin(cornerRadius / centerRadius) / _PolarUtils.RADIAN;
	
	  var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
	  var center = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius, centerAngle); // The coordinate of point which is tangent to the circle
	
	  var circleTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, centerAngle); // The coordinate of point which is tangent to the radius line
	
	  var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
	  var lineTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius * Math.cos(theta * _PolarUtils.RADIAN), lineTangencyAngle);
	  return {
	    center: center,
	    circleTangency: circleTangency,
	    lineTangency: lineTangency,
	    theta: theta
	  };
	};
	
	var getSectorPath = function getSectorPath(_ref2) {
	  var cx = _ref2.cx,
	      cy = _ref2.cy,
	      innerRadius = _ref2.innerRadius,
	      outerRadius = _ref2.outerRadius,
	      startAngle = _ref2.startAngle,
	      endAngle = _ref2.endAngle;
	  var angle = getDeltaAngle(startAngle, endAngle); // When the angle of sector equals to 360, star point and end point coincide
	
	  var tempEndAngle = startAngle + angle;
	  var outerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, startAngle);
	  var outerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, tempEndAngle);
	  var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
	
	  if (innerRadius > 0) {
	    var innerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, startAngle);
	    var innerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, tempEndAngle);
	    path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
	  } else {
	    path += "L ".concat(cx, ",").concat(cy, " Z");
	  }
	
	  return path;
	};
	
	var getSectorWithCorner = function getSectorWithCorner(_ref3) {
	  var cx = _ref3.cx,
	      cy = _ref3.cy,
	      innerRadius = _ref3.innerRadius,
	      outerRadius = _ref3.outerRadius,
	      cornerRadius = _ref3.cornerRadius,
	      forceCornerRadius = _ref3.forceCornerRadius,
	      cornerIsExternal = _ref3.cornerIsExternal,
	      startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	
	  var _getTangentCircle = getTangentCircle({
	    cx: cx,
	    cy: cy,
	    radius: outerRadius,
	    angle: startAngle,
	    sign: sign,
	    cornerRadius: cornerRadius,
	    cornerIsExternal: cornerIsExternal
	  }),
	      soct = _getTangentCircle.circleTangency,
	      solt = _getTangentCircle.lineTangency,
	      sot = _getTangentCircle.theta;
	
	  var _getTangentCircle2 = getTangentCircle({
	    cx: cx,
	    cy: cy,
	    radius: outerRadius,
	    angle: endAngle,
	    sign: -sign,
	    cornerRadius: cornerRadius,
	    cornerIsExternal: cornerIsExternal
	  }),
	      eoct = _getTangentCircle2.circleTangency,
	      eolt = _getTangentCircle2.lineTangency,
	      eot = _getTangentCircle2.theta;
	
	  var outerArcAngle = Math.abs(startAngle - endAngle) - sot - eot;
	
	  if (outerArcAngle < 0) {
	    if (forceCornerRadius) {
	      return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
	    }
	
	    return getSectorPath({
	      cx: cx,
	      cy: cy,
	      innerRadius: innerRadius,
	      outerRadius: outerRadius,
	      startAngle: startAngle,
	      endAngle: endAngle
	    });
	  }
	
	  var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
	
	  if (innerRadius > 0) {
	    var _getTangentCircle3 = getTangentCircle({
	      cx: cx,
	      cy: cy,
	      radius: innerRadius,
	      angle: startAngle,
	      sign: sign,
	      isExternal: true,
	      cornerRadius: cornerRadius,
	      cornerIsExternal: cornerIsExternal
	    }),
	        sict = _getTangentCircle3.circleTangency,
	        silt = _getTangentCircle3.lineTangency,
	        sit = _getTangentCircle3.theta;
	
	    var _getTangentCircle4 = getTangentCircle({
	      cx: cx,
	      cy: cy,
	      radius: innerRadius,
	      angle: endAngle,
	      sign: -sign,
	      isExternal: true,
	      cornerRadius: cornerRadius,
	      cornerIsExternal: cornerIsExternal
	    }),
	        eict = _getTangentCircle4.circleTangency,
	        eilt = _getTangentCircle4.lineTangency,
	        eit = _getTangentCircle4.theta;
	
	    var innerArcAngle = Math.abs(startAngle - endAngle) - sit - eit;
	
	    if (innerArcAngle < 0) {
	      return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
	    }
	
	    path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
	  } else {
	    path += "L".concat(cx, ",").concat(cy, "Z");
	  }
	
	  return path;
	};
	
	var Sector =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Sector, _PureComponent);
	
	  function Sector() {
	    _classCallCheck(this, Sector);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Sector).apply(this, arguments));
	  }
	
	  _createClass(Sector, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          innerRadius = _this$props.innerRadius,
	          outerRadius = _this$props.outerRadius,
	          cornerRadius = _this$props.cornerRadius,
	          forceCornerRadius = _this$props.forceCornerRadius,
	          cornerIsExternal = _this$props.cornerIsExternal,
	          startAngle = _this$props.startAngle,
	          endAngle = _this$props.endAngle,
	          className = _this$props.className;
	
	      if (outerRadius < innerRadius || startAngle === endAngle) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-sector', className);
	      var deltaRadius = outerRadius - innerRadius;
	      var cr = (0, _DataUtils.getPercentValue)(cornerRadius, deltaRadius, 0, true);
	      var path;
	
	      if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
	        path = getSectorWithCorner({
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          cornerRadius: Math.min(cr, deltaRadius / 2),
	          forceCornerRadius: forceCornerRadius,
	          cornerIsExternal: cornerIsExternal,
	          startAngle: startAngle,
	          endAngle: endAngle
	        });
	      } else {
	        path = getSectorPath({
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          startAngle: startAngle,
	          endAngle: endAngle
	        });
	      }
	
	      return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        d: path
	      }));
	    }
	  }]);
	
	  return Sector;
	}(_react.PureComponent);
	
	Sector.displayName = 'Sector';
	Sector.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  innerRadius: _propTypes["default"].number,
	  outerRadius: _propTypes["default"].number,
	  startAngle: _propTypes["default"].number,
	  endAngle: _propTypes["default"].number,
	  cornerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  forceCornerRadius: _propTypes["default"].bool,
	  cornerIsExternal: _propTypes["default"].bool
	});
	Sector.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  startAngle: 0,
	  endAngle: 0,
	  cornerRadius: 0,
	  forceCornerRadius: false,
	  cornerIsExternal: false
	};
	var _default = Sector;
	exports["default"] = _default;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateChartCoordinate = exports.getOffset = exports.getStringSize = exports.getStyleString = void 0;
	
	var _ReactUtils = __webpack_require__(43);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var stringCache = {
	  widthCache: {},
	  cacheCount: 0
	};
	var MAX_CACHE_NUM = 2000;
	var SPAN_STYLE = {
	  position: 'absolute',
	  top: '-20000px',
	  left: 0,
	  padding: 0,
	  margin: 0,
	  border: 'none',
	  whiteSpace: 'pre'
	};
	var STYLE_LIST = ['minWidth', 'maxWidth', 'width', 'minHeight', 'maxHeight', 'height', 'top', 'left', 'fontSize', 'lineHeight', 'padding', 'margin', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
	var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
	
	function autoCompleteStyle(name, value) {
	  if (STYLE_LIST.indexOf(name) >= 0 && value === +value) {
	    return "".concat(value, "px");
	  }
	
	  return value;
	}
	
	function camelToMiddleLine(text) {
	  var strs = text.split('');
	  var formatStrs = strs.reduce(function (result, entry) {
	    if (entry === entry.toUpperCase()) {
	      return [].concat(_toConsumableArray(result), ['-', entry.toLowerCase()]);
	    }
	
	    return [].concat(_toConsumableArray(result), [entry]);
	  }, []);
	  return formatStrs.join('');
	}
	
	var getStyleString = function getStyleString(style) {
	  return Object.keys(style).reduce(function (result, s) {
	    return "".concat(result).concat(camelToMiddleLine(s), ":").concat(autoCompleteStyle(s, style[s]), ";");
	  }, '');
	};
	
	exports.getStyleString = getStyleString;
	
	var getStringSize = function getStringSize(text) {
	  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (text === undefined || text === null || (0, _ReactUtils.isSsr)()) {
	    return {
	      width: 0,
	      height: 0
	    };
	  }
	
	  var str = "".concat(text);
	  var styleString = getStyleString(style);
	  var cacheKey = "".concat(str, "-").concat(styleString);
	
	  if (stringCache.widthCache[cacheKey]) {
	    return stringCache.widthCache[cacheKey];
	  }
	
	  try {
	    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
	
	    if (!measurementSpan) {
	      measurementSpan = document.createElement('span');
	      measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
	      document.body.appendChild(measurementSpan);
	    } // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
	    // https://en.wikipedia.org/wiki/Content_Security_Policy
	
	
	    var measurementSpanStyle = _objectSpread({}, SPAN_STYLE, {}, style);
	
	    Object.keys(measurementSpanStyle).map(function (styleKey) {
	      measurementSpan.style[styleKey] = measurementSpanStyle[styleKey];
	      return styleKey;
	    });
	    measurementSpan.textContent = str;
	    var rect = measurementSpan.getBoundingClientRect();
	    var result = {
	      width: rect.width,
	      height: rect.height
	    };
	    stringCache.widthCache[cacheKey] = result;
	
	    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
	      stringCache.cacheCount = 0;
	      stringCache.widthCache = {};
	    }
	
	    return result;
	  } catch (e) {
	    return {
	      width: 0,
	      height: 0
	    };
	  }
	};
	
	exports.getStringSize = getStringSize;
	
	var getOffset = function getOffset(el) {
	  var html = el.ownerDocument.documentElement;
	  var box = {
	    top: 0,
	    left: 0
	  }; // If we don't have gBCR, just use 0,0 rather than error
	  // BlackBerry 5, iOS 3 (original iPhone)
	
	  if (typeof el.getBoundingClientRect !== 'undefined') {
	    box = el.getBoundingClientRect();
	  }
	
	  return {
	    top: box.top + window.pageYOffset - html.clientTop,
	    left: box.left + window.pageXOffset - html.clientLeft
	  };
	};
	/**
	 * Calculate coordinate of cursor in chart
	 * @param  {Object} event  Event object
	 * @param  {Object} offset The offset of main part in the svg element
	 * @return {Object}        {chartX, chartY}
	 */
	
	
	exports.getOffset = getOffset;
	
	var calculateChartCoordinate = function calculateChartCoordinate(event, offset) {
	  return {
	    chartX: Math.round(event.pageX - offset.left),
	    chartY: Math.round(event.pageY - offset.top)
	  };
	};
	
	exports.calculateChartCoordinate = calculateChartCoordinate;

/***/ }),
/* 393 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ifOverflowMatches = void 0;
	
	var ifOverflowMatches = function ifOverflowMatches(props, value) {
	  var alwaysShow = props.alwaysShow;
	  var ifOverflow = props.ifOverflow;
	
	  if (alwaysShow) {
	    ifOverflow = 'extendDomain';
	  }
	
	  return ifOverflow === value;
	};
	
	exports.ifOverflowMatches = ifOverflowMatches;

/***/ }),
/* 394 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = shallowEqual;
	
	function shallowEqual(a, b) {
	  /* eslint-disable no-restricted-syntax */
	  for (var key in a) {
	    if ({}.hasOwnProperty.call(a, key) && (!{}.hasOwnProperty.call(b, key) || a[key] !== b[key])) {
	      return false;
	    }
	  }
	
	  for (var _key in b) {
	    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a, _key)) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = exports.getTransitionVal = exports.compose = exports.translateStyle = exports.mapObject = exports.debugf = exports.debug = exports.log = exports.generatePrefixStyle = exports.getDashCase = exports.identity = exports.getIntersectionKeys = void 0;
	
	var _intersection2 = _interopRequireDefault(__webpack_require__(723));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/* eslint no-console: 0 */
	var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
	var IN_LINE_PREFIX_LIST = ['-webkit-', '-moz-', '-o-', '-ms-'];
	var IN_COMPATIBLE_PROPERTY = ['transform', 'transformOrigin', 'transition'];
	
	var getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
	  return (0, _intersection2.default)(Object.keys(preObj), Object.keys(nextObj));
	};
	
	exports.getIntersectionKeys = getIntersectionKeys;
	
	var identity = function identity(param) {
	  return param;
	};
	/*
	 * @description: convert camel case to dash case
	 * string => string
	 */
	
	
	exports.identity = identity;
	
	var getDashCase = function getDashCase(name) {
	  return name.replace(/([A-Z])/g, function (v) {
	    return "-".concat(v.toLowerCase());
	  });
	};
	/*
	 * @description: add compatible style prefix
	 * (string, string) => object
	 */
	
	
	exports.getDashCase = getDashCase;
	
	var generatePrefixStyle = function generatePrefixStyle(name, value) {
	  if (IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) {
	    return _defineProperty({}, name, value);
	  }
	
	  var isTransition = name === 'transition';
	  var camelName = name.replace(/(\w)/, function (v) {
	    return v.toUpperCase();
	  });
	  var styleVal = value;
	  return PREFIX_LIST.reduce(function (result, property, i) {
	    if (isTransition) {
	      styleVal = value.replace(/(transform|transform-origin)/gim, "".concat(IN_LINE_PREFIX_LIST[i], "$1"));
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, property + camelName, styleVal));
	  }, {});
	};
	
	exports.generatePrefixStyle = generatePrefixStyle;
	
	var log = function log() {
	  var _console;
	
	  (_console = console).log.apply(_console, arguments);
	};
	/*
	 * @description: log the value of a varible
	 * string => any => any
	 */
	
	
	exports.log = log;
	
	var debug = function debug(name) {
	  return function (item) {
	    log(name, item);
	    return item;
	  };
	};
	/*
	 * @description: log name, args, return value of a function
	 * function => function
	 */
	
	
	exports.debug = debug;
	
	var debugf = function debugf(tag, f) {
	  return function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var res = f.apply(void 0, args);
	    var name = tag || f.name || 'anonymous function';
	    var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
	    log("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
	    return res;
	  };
	};
	/*
	 * @description: map object on every element in this object.
	 * (function, object) => object
	 */
	
	
	exports.debugf = debugf;
	
	var mapObject = function mapObject(fn, obj) {
	  return Object.keys(obj).reduce(function (res, key) {
	    return _objectSpread({}, res, _defineProperty({}, key, fn(key, obj[key])));
	  }, {});
	};
	/*
	 * @description: add compatible prefix to style
	 * object => object
	 */
	
	
	exports.mapObject = mapObject;
	
	var translateStyle = function translateStyle(style) {
	  return Object.keys(style).reduce(function (res, key) {
	    return _objectSpread({}, res, generatePrefixStyle(key, res[key]));
	  }, style);
	};
	
	exports.translateStyle = translateStyle;
	
	var compose = function compose() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse(); // first function can receive multiply arguments
	
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(void 0, arguments));
	  };
	};
	
	exports.compose = compose;
	
	var getTransitionVal = function getTransitionVal(props, duration, easing) {
	  return props.map(function (prop) {
	    return "".concat(getDashCase(prop), " ").concat(duration, "ms ").concat(easing);
	  }).join(',');
	};
	
	exports.getTransitionVal = getTransitionVal;
	var isDev = ("production") !== 'production';
	
	var warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};
	
	exports.warn = warn;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isArray_1 = __webpack_require__(916);
	var isObject_1 = __webpack_require__(919);
	var isFunction_1 = __webpack_require__(918);
	var tryCatch_1 = __webpack_require__(2011);
	var errorObject_1 = __webpack_require__(915);
	var UnsubscriptionError_1 = __webpack_require__(2006);
	/**
	 * Represents a disposable resource, such as the execution of an Observable. A
	 * Subscription has one important method, `unsubscribe`, that takes no argument
	 * and just disposes the resource held by the subscription.
	 *
	 * Additionally, subscriptions may be grouped together through the `add()`
	 * method, which will attach a child Subscription to the current Subscription.
	 * When a Subscription is unsubscribed, all its children (and its grandchildren)
	 * will be unsubscribed as well.
	 *
	 * @class Subscription
	 */
	var Subscription = (function () {
	    /**
	     * @param {function(): void} [unsubscribe] A function describing how to
	     * perform the disposal of resources when the `unsubscribe` method is called.
	     */
	    function Subscription(unsubscribe) {
	        /**
	         * A flag to indicate whether this Subscription has already been unsubscribed.
	         * @type {boolean}
	         */
	        this.closed = false;
	        this._parent = null;
	        this._parents = null;
	        this._subscriptions = null;
	        if (unsubscribe) {
	            this._unsubscribe = unsubscribe;
	        }
	    }
	    /**
	     * Disposes the resources held by the subscription. May, for instance, cancel
	     * an ongoing Observable execution or cancel any other type of work that
	     * started when the Subscription was created.
	     * @return {void}
	     */
	    Subscription.prototype.unsubscribe = function () {
	        var hasErrors = false;
	        var errors;
	        if (this.closed) {
	            return;
	        }
	        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
	        this.closed = true;
	        this._parent = null;
	        this._parents = null;
	        // null out _subscriptions first so any child subscriptions that attempt
	        // to remove themselves from this subscription will noop
	        this._subscriptions = null;
	        var index = -1;
	        var len = _parents ? _parents.length : 0;
	        // if this._parent is null, then so is this._parents, and we
	        // don't have to remove ourselves from any parent subscriptions.
	        while (_parent) {
	            _parent.remove(this);
	            // if this._parents is null or index >= len,
	            // then _parent is set to null, and the loop exits
	            _parent = ++index < len && _parents[index] || null;
	        }
	        if (isFunction_1.isFunction(_unsubscribe)) {
	            var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
	            if (trial === errorObject_1.errorObject) {
	                hasErrors = true;
	                errors = errors || (errorObject_1.errorObject.e instanceof UnsubscriptionError_1.UnsubscriptionError ?
	                    flattenUnsubscriptionErrors(errorObject_1.errorObject.e.errors) : [errorObject_1.errorObject.e]);
	            }
	        }
	        if (isArray_1.isArray(_subscriptions)) {
	            index = -1;
	            len = _subscriptions.length;
	            while (++index < len) {
	                var sub = _subscriptions[index];
	                if (isObject_1.isObject(sub)) {
	                    var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
	                    if (trial === errorObject_1.errorObject) {
	                        hasErrors = true;
	                        errors = errors || [];
	                        var err = errorObject_1.errorObject.e;
	                        if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
	                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
	                        }
	                        else {
	                            errors.push(err);
	                        }
	                    }
	                }
	            }
	        }
	        if (hasErrors) {
	            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
	        }
	    };
	    /**
	     * Adds a tear down to be called during the unsubscribe() of this
	     * Subscription.
	     *
	     * If the tear down being added is a subscription that is already
	     * unsubscribed, is the same reference `add` is being called on, or is
	     * `Subscription.EMPTY`, it will not be added.
	     *
	     * If this subscription is already in an `closed` state, the passed
	     * tear down logic will be executed immediately.
	     *
	     * @param {TeardownLogic} teardown The additional logic to execute on
	     * teardown.
	     * @return {Subscription} Returns the Subscription used or created to be
	     * added to the inner subscriptions list. This Subscription can be used with
	     * `remove()` to remove the passed teardown logic from the inner subscriptions
	     * list.
	     */
	    Subscription.prototype.add = function (teardown) {
	        if (!teardown || (teardown === Subscription.EMPTY)) {
	            return Subscription.EMPTY;
	        }
	        if (teardown === this) {
	            return this;
	        }
	        var subscription = teardown;
	        switch (typeof teardown) {
	            case 'function':
	                subscription = new Subscription(teardown);
	            case 'object':
	                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
	                    return subscription;
	                }
	                else if (this.closed) {
	                    subscription.unsubscribe();
	                    return subscription;
	                }
	                else if (typeof subscription._addParent !== 'function' /* quack quack */) {
	                    var tmp = subscription;
	                    subscription = new Subscription();
	                    subscription._subscriptions = [tmp];
	                }
	                break;
	            default:
	                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
	        }
	        var subscriptions = this._subscriptions || (this._subscriptions = []);
	        subscriptions.push(subscription);
	        subscription._addParent(this);
	        return subscription;
	    };
	    /**
	     * Removes a Subscription from the internal list of subscriptions that will
	     * unsubscribe during the unsubscribe process of this Subscription.
	     * @param {Subscription} subscription The subscription to remove.
	     * @return {void}
	     */
	    Subscription.prototype.remove = function (subscription) {
	        var subscriptions = this._subscriptions;
	        if (subscriptions) {
	            var subscriptionIndex = subscriptions.indexOf(subscription);
	            if (subscriptionIndex !== -1) {
	                subscriptions.splice(subscriptionIndex, 1);
	            }
	        }
	    };
	    Subscription.prototype._addParent = function (parent) {
	        var _a = this, _parent = _a._parent, _parents = _a._parents;
	        if (!_parent || _parent === parent) {
	            // If we don't have a parent, or the new parent is the same as the
	            // current parent, then set this._parent to the new parent.
	            this._parent = parent;
	        }
	        else if (!_parents) {
	            // If there's already one parent, but not multiple, allocate an Array to
	            // store the rest of the parent Subscriptions.
	            this._parents = [parent];
	        }
	        else if (_parents.indexOf(parent) === -1) {
	            // Only add the new parent to the _parents list if it's not already there.
	            _parents.push(parent);
	        }
	    };
	    Subscription.EMPTY = (function (empty) {
	        empty.closed = true;
	        return empty;
	    }(new Subscription()));
	    return Subscription;
	}());
	exports.Subscription = Subscription;
	function flattenUnsubscriptionErrors(errors) {
	    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError_1.UnsubscriptionError) ? err.errors : err); }, []);
	}
	//# sourceMappingURL=Subscription.js.map

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleSheet = __webpack_require__(172);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _StyleSheetManager = __webpack_require__(922);
	
	var _StyleSheetManager2 = _interopRequireDefault(_StyleSheetManager);
	
	var _nonce = __webpack_require__(926);
	
	var _nonce2 = _interopRequireDefault(_nonce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	/* eslint-disable no-underscore-dangle */
	
	
	var babelPluginFlowReactPropTypes_proptype_Tag = __webpack_require__(172).babelPluginFlowReactPropTypes_proptype_Tag || __webpack_require__(2).any;
	
	var ServerTag = function () {
	  function ServerTag(isLocal) {
	    _classCallCheck(this, ServerTag);
	
	    this.isLocal = isLocal;
	    this.components = {};
	    this.size = 0;
	    this.names = [];
	  }
	
	  ServerTag.prototype.isFull = function isFull() {
	    return false;
	  };
	
	  ServerTag.prototype.addComponent = function addComponent(componentId) {
	    if (false) {
	      throw new Error('Trying to add Component \'' + componentId + '\' twice!');
	    }
	    this.components[componentId] = { componentId: componentId, css: '' };
	    this.size += 1;
	  };
	
	  ServerTag.prototype.concatenateCSS = function concatenateCSS() {
	    var _this = this;
	
	    return Object.keys(this.components).reduce(function (styles, k) {
	      return styles + _this.components[k].css;
	    }, '');
	  };
	
	  ServerTag.prototype.inject = function inject(componentId, css, name) {
	    var comp = this.components[componentId];
	
	    if (false) {
	      throw new Error('Must add a new component before you can inject css into it');
	    }
	    if (comp.css === '') comp.css = '/* sc-component-id: ' + componentId + ' */\n';
	
	    comp.css += css.replace(/\n*$/, '\n');
	
	    if (name) this.names.push(name);
	  };
	
	  ServerTag.prototype.toHTML = function toHTML() {
	    var attrs = ['type="text/css"', _StyleSheet.SC_ATTR + '="' + this.names.join(' ') + '"', _StyleSheet.LOCAL_ATTR + '="' + (this.isLocal ? 'true' : 'false') + '"'];
	
	    var nonce = (0, _nonce2.default)();
	
	    if (nonce) {
	      attrs.push('nonce="' + nonce + '"');
	    }
	
	    return '<style ' + attrs.join(' ') + '>' + this.concatenateCSS() + '</style>';
	  };
	
	  ServerTag.prototype.toReactElement = function toReactElement(key) {
	    var _attrs;
	
	    var attrs = (_attrs = {}, _attrs[_StyleSheet.SC_ATTR] = this.names.join(' '), _attrs[_StyleSheet.LOCAL_ATTR] = this.isLocal.toString(), _attrs);
	
	    var nonce = (0, _nonce2.default)();
	
	    if (nonce) {
	      attrs.nonce = nonce;
	    }
	
	    return _react2.default.createElement('style', _extends({
	      key: key,
	      type: 'text/css'
	    }, attrs, {
	      dangerouslySetInnerHTML: { __html: this.concatenateCSS() }
	    }));
	  };
	
	  ServerTag.prototype.clone = function clone() {
	    var _this2 = this;
	
	    var copy = new ServerTag(this.isLocal);
	    copy.names = [].concat(this.names);
	    copy.size = this.size;
	    copy.components = Object.keys(this.components).reduce(function (acc, key) {
	      acc[key] = _extends({}, _this2.components[key]); // eslint-disable-line no-param-reassign
	      return acc;
	    }, {});
	
	    return copy;
	  };
	
	  return ServerTag;
	}();
	
	var ServerStyleSheet = function () {
	  function ServerStyleSheet() {
	    _classCallCheck(this, ServerStyleSheet);
	
	    this.instance = _StyleSheet2.default.clone(_StyleSheet2.default.instance);
	  }
	
	  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
	    if (this.closed) {
	      throw new Error("Can't collect styles once you've called getStyleTags!");
	    }
	    return _react2.default.createElement(
	      _StyleSheetManager2.default,
	      { sheet: this.instance },
	      children
	    );
	  };
	
	  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
	    if (!this.closed) {
	      _StyleSheet.clones.splice(_StyleSheet.clones.indexOf(this.instance), 1);
	      this.closed = true;
	    }
	
	    return this.instance.toHTML();
	  };
	
	  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
	    if (!this.closed) {
	      _StyleSheet.clones.splice(_StyleSheet.clones.indexOf(this.instance), 1);
	      this.closed = true;
	    }
	
	    return this.instance.toReactElements();
	  };
	
	  ServerStyleSheet.create = function create() {
	    return new _StyleSheet2.default(function (isLocal) {
	      return new ServerTag(isLocal);
	    });
	  };
	
	  return ServerStyleSheet;
	}();
	
	exports.default = ServerStyleSheet;
	module.exports = exports['default'];

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CONTEXT_CHANNEL_SHAPE = exports.CHANNEL_NEXT = exports.CHANNEL = undefined;
	
	var _ThemeProvider$childC, _ThemeProvider$contex;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isPlainObject = __webpack_require__(689);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _createBroadcast = __webpack_require__(923);
	
	var _createBroadcast2 = _interopRequireDefault(_createBroadcast);
	
	var _once = __webpack_require__(2029);
	
	var _once2 = _interopRequireDefault(_once);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* globals React$Element */
	
	
	var babelPluginFlowReactPropTypes_proptype_Broadcast = __webpack_require__(923).babelPluginFlowReactPropTypes_proptype_Broadcast || __webpack_require__(2).any;
	
	// NOTE: DO NOT CHANGE, changing this is a semver major change!
	var CHANNEL = exports.CHANNEL = '__styled-components__';
	var CHANNEL_NEXT = exports.CHANNEL_NEXT = CHANNEL + 'next__';
	
	var CONTEXT_CHANNEL_SHAPE = exports.CONTEXT_CHANNEL_SHAPE = _propTypes2.default.shape({
	  getTheme: _propTypes2.default.func,
	  subscribe: _propTypes2.default.func,
	  unsubscribe: _propTypes2.default.func
	});
	
	if (true) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Theme', {
	  value: __webpack_require__(2).shape({})
	});
	
	
	var warnChannelDeprecated = void 0;
	if (false) {
	  warnChannelDeprecated = (0, _once2.default)(function () {
	    // eslint-disable-next-line no-console
	    console.error('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
	  });
	}
	
	var isFunction = function isFunction(test) {
	  return typeof test === 'function';
	};
	
	/**
	 * Provide a theme to an entire react component tree via context and event listeners (have to do
	 * both context and event emitter as pure components block context updates)
	 */
	
	var ThemeProvider = function (_Component) {
	  _inherits(ThemeProvider, _Component);
	
	  function ThemeProvider() {
	    _classCallCheck(this, ThemeProvider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.unsubscribeToOuterId = -1;
	
	    _this.getTheme = _this.getTheme.bind(_this);
	    return _this;
	  }
	
	  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
	    // with the outer theme
	    var outerContext = this.context[CHANNEL_NEXT];
	    if (outerContext !== undefined) {
	      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
	        _this2.outerTheme = theme;
	      });
	    }
	    this.broadcast = (0, _createBroadcast2.default)(this.getTheme());
	  };
	
	  ThemeProvider.prototype.getChildContext = function getChildContext() {
	    var _this3 = this,
	        _extends2;
	
	    return _extends({}, this.context, (_extends2 = {}, _extends2[CHANNEL_NEXT] = {
	      getTheme: this.getTheme,
	      subscribe: this.broadcast.subscribe,
	      unsubscribe: this.broadcast.unsubscribe
	    }, _extends2[CHANNEL] = function (subscriber) {
	      if (false) {
	        warnChannelDeprecated();
	      }
	
	      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
	      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
	      return function () {
	        return _this3.broadcast.unsubscribe(unsubscribeId);
	      };
	    }, _extends2));
	  };
	
	  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.theme !== nextProps.theme) {
	      this.broadcast.publish(this.getTheme(nextProps.theme));
	    }
	  };
	
	  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribeToOuterId !== -1) {
	      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
	    }
	  };
	
	  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
	
	
	  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
	    var theme = passedTheme || this.props.theme;
	    if (isFunction(theme)) {
	      var mergedTheme = theme(this.outerTheme);
	      if (false) {
	        throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
	      }
	      return mergedTheme;
	    }
	    if (!(0, _isPlainObject2.default)(theme)) {
	      throw new Error('[ThemeProvider] Please make your theme prop a plain object');
	    }
	    return _extends({}, this.outerTheme, theme);
	  };
	
	  ThemeProvider.prototype.render = function render() {
	    if (!this.props.children) {
	      return null;
	    }
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return ThemeProvider;
	}(_react.Component);
	
	ThemeProvider.propTypes = {
	  children: __webpack_require__(2).any,
	  theme: __webpack_require__(2).oneOfType([__webpack_require__(2).shape({}), __webpack_require__(2).func]).isRequired
	};
	
	
	ThemeProvider.childContextTypes = (_ThemeProvider$childC = {}, _ThemeProvider$childC[CHANNEL] = _propTypes2.default.func, _ThemeProvider$childC[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$childC);
	ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);
	
	exports.default = ThemeProvider;

/***/ }),
/* 399 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.CZECH_PHONE_PATTERN = exports.CZECH_PHONE_CODE_PREFIX = exports.PHONE_PATTERN = exports.MAX_INTEGER = void 0;
	exports.MAX_INTEGER = 0x7ffffff0;
	exports.PHONE_PATTERN = "^\\+(?:[0-9] ?){6,14}[0-9]$";
	exports.CZECH_PHONE_CODE_PREFIX = "^\\+420";
	exports.CZECH_PHONE_PATTERN = "^\\+420(\\d{9}$)";


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var formUtils_1 = __webpack_require__(14);
	var documentService_1 = tslib_1.__importDefault(__webpack_require__(110));
	var react_dropzone_1 = tslib_1.__importDefault(__webpack_require__(845));
	__webpack_require__(1288);
	var documentDomain_1 = __webpack_require__(109);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var stringUtils_1 = __webpack_require__(174);
	var colors_1 = __webpack_require__(29);
	var react_bootstrap_1 = __webpack_require__(72);
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var icons_1 = __webpack_require__(63);
	var MenuItem_1 = tslib_1.__importDefault(__webpack_require__(101));
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var remove_circle_outline_1 = tslib_1.__importDefault(__webpack_require__(1598));
	var attach_file_1 = tslib_1.__importDefault(__webpack_require__(1600));
	var import_contacts_1 = tslib_1.__importDefault(__webpack_require__(1595));
	var DocumentComp = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentComp, _super);
	    function DocumentComp() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            $loading: false
	        };
	        _this.onDrop = function (files) {
	            var _a = _this.props, documents = _a.documents, rootObject = _a.rootObject, documentEntity = _a.documentEntity, saveFn = _a.saveFn, defaultAttachmentType = _a.defaultAttachmentType;
	            console.log('onDrop ', files);
	            _this.setState({ $loading: true });
	            uiService_1.default.showToolbarActionFlag();
	            var promiseArray = files.map(function (file) { return documentService_1.default.loadFile(file); });
	            Promise.all(promiseArray).then(function (resultArray) {
	                for (var _i = 0, resultArray_1 = resultArray; _i < resultArray_1.length; _i++) {
	                    var resource = resultArray_1[_i];
	                    var newDoc = new documentDomain_1.Document({
	                        $new: true,
	                        name: resource.name,
	                        size: resource.size,
	                        contentType: resource.contentType,
	                        lastModified: resource.lastModified,
	                        documentType: null,
	                        data: resource.content,
	                        attachmentType: ((0, formUtils_1.lovValue)(defaultAttachmentType) == documentDomain_1.DOCUMENTATTACHMENTTYPE.PDF_INCLUDE && resource.contentType !== "application/pdf") ? documentDomain_1.DOCUMENTATTACHMENTTYPE.SEPARATE_INCLUDE : defaultAttachmentType,
	                    });
	                    documents.push(newDoc);
	                }
	                if (saveFn) {
	                    return saveFn(documents).then(function (res) {
	                        _this.setState({ $loading: false });
	                        uiService_1.default.hideToolbarActionFlag();
	                    });
	                }
	                else {
	                    rootObject.$dirty = true;
	                    _this.setState({ $loading: false });
	                    uiService_1.default.hideToolbarActionFlag();
	                }
	            }, function (err) {
	                _this.setState({ $loading: false });
	                uiService_1.default.hideToolbarActionFlag();
	            });
	        };
	        _this.onDelete = function (document) {
	            var _a = _this.props, documents = _a.documents, rootObject = _a.rootObject, deleteFn = _a.deleteFn;
	            console.log('onDelete ', document);
	            var deletedDocs = documents.splice(documents.indexOf(document), 1);
	            if (deleteFn && deletedDocs.length) {
	                return deleteFn(deletedDocs[0]);
	            }
	            else {
	                rootObject.$dirty = true;
	            }
	        };
	        _this.onClickCheckbox = function (value, doc, evt) {
	            var rootObject = _this.props.rootObject;
	            console.log("onClickCheckbox, %s", value);
	            var DOCUMENTATTACHMENTTYPE = mdEntityService_1.default.getEntity('DOCUMENTATTACHMENTTYPE');
	            doc.attachmentType = DOCUMENTATTACHMENTTYPE.getLovItem(value);
	            rootObject.$dirty = true;
	            doc.$dirty = true;
	        };
	        _this.onPrint = function (doc) {
	            console.log('onPrint', doc);
	            documentService_1.default.printDocument(doc.documentUuid);
	        };
	        return _this;
	    }
	    DocumentComp.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, documents = _a.documents, rootObject = _a.rootObject, style = _a.style, enableUpload = _a.enableUpload, canDeleteFn = _a.canDeleteFn, showFilterFn = _a.showFilterFn, showIncludeCheckbox = _a.showIncludeCheckbox;
	        var DOCUMENTATTACHMENTTYPEEntity = mdEntityService_1.default.getEntity('DOCUMENTATTACHMENTTYPE');
	        return (react_1.default.createElement("div", { style: Object.assign({ display: 'flex' }, style) },
	            (documents) ?
	                documents.filter(function (doc, index) { return showFilterFn(doc); })
	                    .sort(function (doc1, doc2) { return ((0, moment_1.default)(doc1.dateCreated)).valueOf() - ((0, moment_1.default)(doc2.dateCreated)).valueOf(); })
	                    .map(function (doc, index) { return (react_1.default.createElement("div", { key: doc.documentId, className: "document-block" },
	                    react_1.default.createElement("div", { className: "document-block-header" }, (0, stringUtils_1.abbreviate)((documentService_1.default.isUploadType(doc)) ? doc.name : (0, formUtils_1.lovLabel)(doc.documentType), 18)),
	                    react_1.default.createElement("div", { className: "document-block-icons" },
	                        (doc.documentId) ? (react_1.default.createElement("a", { href: documentService_1.default.documentUrl(doc.documentUuid, { inline: true }), target: "_blank" },
	                            react_1.default.createElement("span", { className: 'fa fa-' + doc.icon }))) : null,
	                        (doc.documentId) ? (react_1.default.createElement("a", { href: documentService_1.default.documentUrl(doc.documentUuid, {}) },
	                            react_1.default.createElement("span", { className: 'fa fa-download' }))) : null,
	                        (canDeleteFn(rootObject, doc)) ? (react_1.default.createElement("a", { className: "document-block-icon-delete", onClick: _this.onDelete.bind(_this, doc) },
	                            react_1.default.createElement("span", { className: "fa fa-trash" }))) : null),
	                    react_1.default.createElement("div", { className: "document-block-icons" },
	                        (!doc.documentType && doc.documentId && showIncludeCheckbox) ? (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "top", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "includeAttachmentTooltip", style: { fontSize: 13 } }, "How to include attachment in email or Invoice PDF") },
	                            react_1.default.createElement("div", { style: { width: 17, display: "flex", alignItems: "center", justifyContent: "center" } },
	                                react_1.default.createElement(icons_1.ZzIconButtonMenu, { buttonIcon: ((0, formUtils_1.lovValue)(doc.attachmentType) === documentDomain_1.DOCUMENTATTACHMENTTYPE.SEPARATE_INCLUDE) ? react_1.default.createElement(attach_file_1.default, { color: "#3F51B5" }) :
	                                        (((0, formUtils_1.lovValue)(doc.attachmentType) === documentDomain_1.DOCUMENTATTACHMENTTYPE.PDF_INCLUDE) ? react_1.default.createElement(import_contacts_1.default, { color: "#3F51B5" }) :
	                                            (((0, formUtils_1.lovValue)(doc.attachmentType) === documentDomain_1.DOCUMENTATTACHMENTTYPE.NO_INCLUDE) ? react_1.default.createElement(remove_circle_outline_1.default, { color: "#3F51B5" }) : react_1.default.createElement(add_1.default, { color: "#3F51B5" }))) }, DOCUMENTATTACHMENTTYPEEntity.lovItems.filter(function (lv) { return lv.value != documentDomain_1.DOCUMENTATTACHMENTTYPE.PDF_INCLUDE || doc.contentType === "application/pdf"; }).map(function (lovItem, index) { return react_1.default.createElement(MenuItem_1.default, { primaryText: lovItem.label, key: index, onClick: _this.onClickCheckbox.bind(_this, lovItem.value, doc) }); }))))) : null,
	                        (doc.documentId) ? (react_1.default.createElement("a", { onClick: _this.onPrint.bind(_this, doc) },
	                            react_1.default.createElement("span", { className: "fa fa-print" }))) : null))); }) : null,
	            (enableUpload) ? (react_1.default.createElement("div", null,
	                react_1.default.createElement(react_dropzone_1.default, { onDrop: this.onDrop, style: { width: 100, height: 120, border: '2px dashed ' + colors_1.grey400, color: colors_1.grey400, fontSize: 12, display: "flex", alignItems: "center" } },
	                    react_1.default.createElement("div", { style: { textAlign: 'center' } }, "Drop some files here, or click to select files to upload.")))) : null));
	    };
	    DocumentComp.defaultProps = {
	        showFilterFn: function (document) { return (true); },
	        canDeleteFn: function (rootObject, document) { return (true); }
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], DocumentComp.prototype, "onDrop", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], DocumentComp.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], DocumentComp.prototype, "onClickCheckbox", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], DocumentComp.prototype, "onPrint", void 0);
	    DocumentComp = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], DocumentComp);
	    return DocumentComp;
	}(react_1.default.Component));
	exports.default = DocumentComp;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var _this = this;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.FilterFieldComp = exports.CONDITIONVALUEFORMCONTEXT = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var validate_1 = __webpack_require__(24);
	var mobx_react_1 = __webpack_require__(4);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var fields_1 = __webpack_require__(20);
	var mdField_1 = __webpack_require__(57);
	var grid_1 = __webpack_require__(50);
	var commonDataService_1 = __webpack_require__(41);
	var createForm_1 = __webpack_require__(18);
	var arrayUtils_1 = __webpack_require__(78);
	var dateUtils_1 = __webpack_require__(49);
	var locales_1 = __webpack_require__(15);
	var rules_1 = __webpack_require__(56);
	var checkBoxGroupField_1 = tslib_1.__importStar(__webpack_require__(2056));
	var colors_1 = __webpack_require__(29);
	var CONDITIONVALUEFORMCONTEXT;
	(function (CONDITIONVALUEFORMCONTEXT) {
	    CONDITIONVALUEFORMCONTEXT["GRIDDEF"] = "GRIDDEF";
	    CONDITIONVALUEFORMCONTEXT["GRIDFILTER"] = "GRIDFILTER";
	    CONDITIONVALUEFORMCONTEXT["SUPERFILTER"] = "SUPERFILTER";
	    CONDITIONVALUEFORMCONTEXT["MULTIUPDATE"] = "MULTIUPDATE";
	})(CONDITIONVALUEFORMCONTEXT || (exports.CONDITIONVALUEFORMCONTEXT = CONDITIONVALUEFORMCONTEXT = {}));
	var ConditionValueForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ConditionValueForm, _super);
	    function ConditionValueForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.validatorsfn = function (mdField, dataObject) {
	            var rules = (mdField.dataType === mdField_1.DATATYPE.TIME || mdField.dataType === mdField_1.DATATYPE.DURATION) ? [react_1.default.createElement(rules_1.Pattern, { key: 1, pattern: dateUtils_1.TIME_PATTERN_HH_mm_ss })]
	                : ((mdField.dataType === mdField_1.DATATYPE.NUMBER || mdField.dataType === mdField_1.DATATYPE.NUMBERCURRENCY) ? [react_1.default.createElement(rules_1.IsNumber, { key: 1 })] : []);
	            if (!dataObject.superFilter) {
	                rules.push(react_1.default.createElement(rules_1.IsRequired, { key: rules.length + 1 }));
	            }
	            return rules;
	        };
	        _this.onChangeSuperFilter = function (values) {
	            var _a = _this.props, dataObject = _a.dataObject, formName = _a.formName;
	            var _b = dataObject.getForm(formName).fields, field0 = _b.field0, field1 = _b.field1, fieldMulti = _b.fieldMulti;
	            console.log("onChangeSuperFilter: ", values);
	            fieldMulti.props.onChange(values);
	            if (_this.props.onSuccess)
	                _this.props.onSuccess();
	        };
	        return _this;
	    }
	    ConditionValueForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, disabled = _a.disabled, formName = _a.formName, context = _a.context;
	        // tyto jsou virtualni, definovane pomoci get/setFieldValueFn, neexistuji na GridConfigCondition, proto musim pretypovat fields
	        var _b = dataObject.getForm(formName).fields, field0 = _b.field0, field1 = _b.field1, fieldMulti = _b.fieldMulti;
	        var operator = dataObject.operator;
	        console.log('conditionValue render: field0.valid = %s, field0.showValidation = %s, field0.value = %O, mdField = %o', field0.valid, field0.showValidation, field0.getFieldValueFn(dataObject), field0.mdField);
	        if (['EQUAL', 'NOTEQUAL', 'STARTSWITH', 'NOTSTARTSWITH', 'ENDSWITH', 'NOTENDSWITH', 'GREATERTHAN', 'GREATEROREQUALTHAN',
	            'LESSTHAN', 'LESSOREQUALTHAN', 'CONTAINS', 'NOTCONTAINS', 'LASTXDAYS', 'NEXTXDAYS'].includes(operator)) {
	            return (react_1.default.createElement("div", null,
	                react_1.default.createElement(exports.FilterFieldComp, tslib_1.__assign({}, field0.props, { hintText: (context === CONDITIONVALUEFORMCONTEXT.SUPERFILTER) ? field0.textLabel : locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Fill Value"], ["Fill Value"]))), disabled: disabled, operator: operator, context: context })),
	                react_1.default.createElement(validate_1.Validate, { field: field0, value: field0.props.value }, this.validatorsfn(field0.mdField, dataObject))));
	        }
	        else if (['IN', 'NOTIN'].includes(operator)) {
	            var fieldMultiProps = (context === CONDITIONVALUEFORMCONTEXT.SUPERFILTER) ? tslib_1.__assign(tslib_1.__assign({}, fieldMulti.props), { onChange: this.onChangeSuperFilter }) : fieldMulti.props;
	            return (react_1.default.createElement("div", null,
	                react_1.default.createElement(exports.FilterFieldComp, tslib_1.__assign({}, fieldMultiProps, { hintText: (context === CONDITIONVALUEFORMCONTEXT.SUPERFILTER) ? fieldMulti.textLabel : "Choose values", multi: true, disabled: disabled, operator: operator, context: context })),
	                react_1.default.createElement(validate_1.Validate, { field: fieldMulti, value: fieldMulti.props.value, onSuccess: this.props.onSuccess }, (dataObject.superFilter) ? null : react_1.default.createElement(rules_1.IsRequired, null))));
	        }
	        else if (operator === 'FROMTO') {
	            return (react_1.default.createElement("div", { style: { display: 'flex' } },
	                react_1.default.createElement(exports.FilterFieldComp, tslib_1.__assign({}, field0.props, { hintText: (context === CONDITIONVALUEFORMCONTEXT.SUPERFILTER) ? field0.textLabel : locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Fill Value: From"], ["Fill Value: From"]))), disabled: disabled, operator: operator, context: context })),
	                react_1.default.createElement(validate_1.Validate, { field: field0, value: field0.props.value }, this.validatorsfn(field0.mdField, dataObject)),
	                react_1.default.createElement("div", { style: { alignSelf: 'center' } }, " -"),
	                react_1.default.createElement(exports.FilterFieldComp, tslib_1.__assign({}, field1.props, { hintText: (context === CONDITIONVALUEFORMCONTEXT.SUPERFILTER) ? field1.textLabel : locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Fill Value: To"], ["Fill Value: To"]))), disabled: disabled, operator: operator, context: context })),
	                react_1.default.createElement(validate_1.Validate, { field: field1, value: field1.props.value }, this.validatorsfn(field1.mdField, dataObject))));
	        }
	        else if (['ISTRUE', 'ISFALSE', 'ISNULL', 'ISNOTNULL'].includes(operator)) {
	            return null;
	        }
	        else {
	            return null;
	        }
	    };
	    ConditionValueForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'ConditionValueForm',
	            fields: [{
	                    name: 'field0',
	                    usePlaceholder: true,
	                    setFieldValueFn: function (dataObject, value) { return dataObject.values[0] = value; },
	                    getFieldValueFn: function (dataObject) { return (dataObject.values && dataObject.values.length) ? dataObject.values[0] : undefined; }
	                }, {
	                    name: 'field1',
	                    usePlaceholder: true,
	                    setFieldValueFn: function (dataObject, value) { return dataObject.values[1] = value; },
	                    getFieldValueFn: function (dataObject) { return (dataObject.values && dataObject.values.length >= 2) ? dataObject.values[1] : undefined; }
	                }, {
	                    name: 'fieldMulti',
	                    usePlaceholder: true,
	                    setFieldValueFn: function (dataObject, value) { return dataObject.values = (value) ? (0, arrayUtils_1.toArray)(value) : value; },
	                    getFieldValueFn: function (dataObject) { return dataObject.values; }
	                }]
	        }, function () { return react_1.default.createElement("noscript", null); }),
	        mobx_react_1.observer
	    ], ConditionValueForm);
	    return ConditionValueForm;
	}(react_1.default.Component));
	exports.default = ConditionValueForm;
	exports.FilterFieldComp = (0, mobx_react_1.observer)(function (_a) {
	    var mdField = _a.mdField, operator = _a.operator, showBooleanField = _a.showBooleanField, context = _a.context, other = tslib_1.__rest(_a, ["mdField", "operator", "showBooleanField", "context"]);
	    var options = other.options, style = other.style, localOther = tslib_1.__rest(other, ["options", "style"]);
	    var localStyle = style;
	    if (context === CONDITIONVALUEFORMCONTEXT.SUPERFILTER) {
	        localStyle = tslib_1.__assign(tslib_1.__assign({}, localStyle), { height: 40, color: colors_1.grey700 });
	        localOther.labelStyle = tslib_1.__assign(tslib_1.__assign({}, localOther.labelStyle), { color: colors_1.grey700 });
	        localOther.inputStyle = tslib_1.__assign(tslib_1.__assign({}, localOther.inputStyle), { marginTop: 0, color: colors_1.grey700 });
	        localOther.hintStyle = tslib_1.__assign(tslib_1.__assign({}, localOther.hintStyle), { bottom: 10, color: colors_1.grey700 });
	    }
	    if (mdField.valueSource) {
	        if (mdField.valueSourceType === mdField_1.VALUESOURCETYPE.ASYNC) {
	            return react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, localOther, { async: true, asterixForAll: true, loadOptions: commonDataService_1.optionsSearch.bind(_this, mdField.valueSource, { _context: context }), clearable: true, style: localStyle, options: options }));
	        }
	        else {
	            if (options && options.length)
	                options = options.filter(function (lov) { return lov.value !== null; });
	            return (context === CONDITIONVALUEFORMCONTEXT.SUPERFILTER) ? react_1.default.createElement(checkBoxGroupField_1.default, tslib_1.__assign({ options: options, style: localStyle, groupStyle: checkBoxGroupField_1.CHECKBOXGROUPSTYLE.HORIZONTAL }, localOther)) :
	                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({ options: options, style: localStyle }, localOther));
	        }
	    }
	    else {
	        if (!mdField.dataType)
	            throw 'Field ' + mdField.fieldKey + ' has no valueSource nor a dataType';
	        switch (mdField.dataType) {
	            case mdField_1.DATATYPE.NUMBER:
	            case mdField_1.DATATYPE.NUMBERCURRENCY:
	                return (react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, localOther, { style: localStyle })));
	            case mdField_1.DATATYPE.STRING:
	            case mdField_1.DATATYPE.TIME:
	            case mdField_1.DATATYPE.DURATION:
	                return (react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, localOther, { maxLength: 255, style: localStyle })));
	            case mdField_1.DATATYPE.DATE:
	                return ((operator === grid_1.FILTEROPERATOR.LASTXDAYS || operator === grid_1.FILTEROPERATOR.NEXTXDAYS) ?
	                    react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, localOther, { style: localStyle })) : react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, localOther, { style: localStyle })));
	            case mdField_1.DATATYPE.DATETIME:
	                return ((operator === grid_1.FILTEROPERATOR.LASTXDAYS || operator === grid_1.FILTEROPERATOR.NEXTXDAYS) ?
	                    react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, localOther, { style: localStyle })) : react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, localOther, { time: true, style: localStyle })));
	            case mdField_1.DATATYPE.BOOLEAN:
	                return ((showBooleanField) ? react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, localOther, { clearable: false, style: localStyle, options: [{ value: "true", label: locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))) }, {
	                            value: "false",
	                            label: locales_1.loc.i18n(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["No"], ["No"])))
	                        }] })) : null);
	            default:
	                return null;
	        }
	    }
	});
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mobx_1 = __webpack_require__(5);
	var tenantDomain_1 = __webpack_require__(944);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var TenantService = /** @class */ (function () {
	    function TenantService() {
	    }
	    TenantService.prototype.readParamTableRow = function (paramTableId) {
	        return axios_config_1.default.get("/core/param-table/".concat(paramTableId))
	            .then(function (res) { return new tenantDomain_1.ParamTable(res.data); });
	    };
	    TenantService.prototype.saveParamTable = function (paramTable, isNew) {
	        isNew = isNew === undefined || isNew === null ? false : isNew;
	        return axios_config_1.default.post("/core/param-table/save?isNew=".concat(isNew), paramTable, { showPrettyError: true })
	            .then(function (res) { return res.data; });
	    };
	    TenantService.prototype.deleteTableParam = function (paramTableId) {
	        return axios_config_1.default.delete("/core/param-table/delete/".concat(paramTableId), { showPrettyError: true });
	    };
	    TenantService.prototype.checkIfValueIsAssignableToParamKey = function (paramKey, value) {
	        return axios_config_1.default.post("/core/param-table/value-check", {
	            paramKey: paramKey,
	            value: value
	        }, { showPrettyError: true })
	            .then(function (res) { return res.data; });
	    };
	    TenantService.prototype.getTenantLovItem = function (tenantId) {
	        return axios_config_1.default.get("/core/tenant/".concat(tenantId), { showPrettyError: true })
	            .then(function (res) { return res.data; });
	    };
	    //GET /core/tenant/binded-tenants?entityName[]=DocumentType&DocumentTypeIds[]=1&DocumentTypeIds[]=2
	    TenantService.prototype.getBindedTenants = function (entities, ids) {
	        return axios_config_1.default.get("/core/tenant/binded-tenants?", { params: tslib_1.__assign({ entityName: entities }, ids) })
	            .then(function (res) { return res.data; });
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TenantService.prototype, "paramTableObject", void 0);
	    return TenantService;
	}());
	exports.default = new TenantService();


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.setSelectTenantGroup = exports.getSelectTenantGroup = exports.setSelectTenant = exports.getSelectTenant = void 0;
	var mobx_1 = __webpack_require__(5);
	var getSelectTenant = function (objekt, tenantId) {
	    //console.log('getSelectTenant on %O,  %s .. %s = %s', objekt, tenantId, index, objekt.tenants.includes(tenantId));
	    return objekt.tenants.includes(tenantId);
	};
	exports.getSelectTenant = getSelectTenant;
	exports.setSelectTenant = (0, mobx_1.action)("setSelectTenant-action", function (objekt, tenantId, item, checked) {
	    var ti = objekt.tenants.indexOf(tenantId);
	    if (checked) {
	        if (ti === -1)
	            objekt.tenants.push(tenantId);
	    }
	    else {
	        if (ti >= 0)
	            objekt.tenants.splice(ti, 1);
	    }
	    objekt.$dirty = true;
	    console.log('setSelectTenant objekt = %o, tenantId = %s,  item = %o, checked = %s', objekt, tenantId, item, checked);
	});
	var getSelectTenantGroup = function (objekt, tenantGroupId) {
	    //console.log('getSelectTenant %s .. %s', tenantId, index);
	    return objekt.tenantGroups.includes(tenantGroupId);
	};
	exports.getSelectTenantGroup = getSelectTenantGroup;
	exports.setSelectTenantGroup = (0, mobx_1.action)("setSelectTenantGroup-action", function (objekt, tenantGroupId, item, checked) {
	    console.log('setSelectTenant %s .. %so...%s', tenantGroupId, item, checked);
	    var ti = objekt.tenantGroups.indexOf(tenantGroupId);
	    if (checked) {
	        if (ti === -1)
	            objekt.tenantGroups.push(tenantGroupId);
	    }
	    else {
	        if (ti >= 0)
	            objekt.tenantGroups.splice(ti, 1);
	    }
	    objekt.$dirty = true;
	});


/***/ }),
/* 404 */
/***/ (function(module, exports) {

	"use strict";
	/* ***************************** ENTITY ***************************** */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ENTITY_NUMBER_GEN_LIST = exports.ENTITY_NUMBER_GEN_GROUP_LIST = exports.ENTITY_NUMBER_GEN_GROUP_ENTITY = exports.ENTITY_NUMBER_GEN_ENTITY = void 0;
	exports.ENTITY_NUMBER_GEN_ENTITY = "EntityNumberGen";
	exports.ENTITY_NUMBER_GEN_GROUP_ENTITY = "EntityNumberGenGroup";
	/* ****************************** GRID ****************************** */
	exports.ENTITY_NUMBER_GEN_GROUP_LIST = "entityNumberGenGroupList";
	exports.ENTITY_NUMBER_GEN_LIST = "entityNumberGenList";


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UNIT_OF_MEASURE = void 0;
	exports.priceValue = priceValue;
	var isEmpty = __webpack_require__(284);
	var UNIT_OF_MEASURE;
	(function (UNIT_OF_MEASURE) {
	    UNIT_OF_MEASURE["pcs"] = "pcs";
	})(UNIT_OF_MEASURE || (exports.UNIT_OF_MEASURE = UNIT_OF_MEASURE = {}));
	function priceValue(priceObj) {
	    if (isEmpty(priceObj)) {
	        return null; // we do not want Error for empty price object
	    }
	    else if (isPrice(priceObj)) {
	        return priceObj.price;
	    }
	    else if (typeof priceObj === 'number') {
	        return priceObj;
	    }
	    throw new Error("Expected Price or number, got '".concat(priceObj, "'."));
	}
	function isPrice(priceObj) {
	    return priceObj.price !== undefined;
	}


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mobx_1 = __webpack_require__(5);
	var axios_config_1 = tslib_1.__importStar(__webpack_require__(59));
	var projectDomain_1 = __webpack_require__(575);
	var ProjectService = /** @class */ (function () {
	    function ProjectService() {
	    }
	    ProjectService.prototype.readProject = function (projectId) {
	        return axios_config_1.default.get('sbtool/project/' + projectId)
	            .then(function (response) { return new projectDomain_1.Project(response.data); });
	    };
	    ProjectService.prototype.saveProject = function (project) {
	        return axios_config_1.default.post('/sbtool/project', project)
	            .then(function (response) { return response.data; });
	    };
	    ProjectService.prototype.deleteProject = function (projectId) {
	        return axios_config_1.default.delete('/sbtool/project/' + projectId)
	            .then(function (response) { return response.data; });
	    };
	    ProjectService.prototype.getProjectVersions = function (projectId) {
	        return axios_config_1.default.get('sbtool/project/' + projectId + '/versions')
	            .then(function (response) { return response.data; });
	    };
	    ProjectService.prototype.uploadProjectImage = function (projectId, data) {
	        return axios_config_1.uploadAxios.post("/sbtool/project/".concat(projectId, "/image"), data, { showPrettyError: true })
	            .then(function (res) { return res; });
	    };
	    ProjectService.prototype.getProjectImage = function (projectId) {
	        return axios_config_1.default.get('/sbtool/project/image/' + projectId)
	            .then(function (response) { return response.data; });
	    };
	    ProjectService.prototype.getVersionsScore = function (projectId) {
	        return axios_config_1.default.get("/sbtool/project/".concat(projectId, "/score"))
	            .then(function (response) { return response.data; });
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectService.prototype, "projectObject", void 0);
	    return ProjectService;
	}());
	exports.default = new ProjectService();


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ShipmentVisitClosedContent = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var formUtils_1 = __webpack_require__(14);
	var blockComp_1 = __webpack_require__(30);
	var validate_1 = __webpack_require__(24);
	var mobx_react_1 = __webpack_require__(4);
	var shipmentDomain_1 = __webpack_require__(132);
	var form_1 = __webpack_require__(52);
	var mobx_1 = __webpack_require__(5);
	var locales_1 = __webpack_require__(15);
	var rules_1 = __webpack_require__(56);
	var constant_1 = __webpack_require__(399);
	var shipmentService_1 = tslib_1.__importDefault(__webpack_require__(176));
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var commonDataService_1 = __webpack_require__(41);
	var mdField_1 = tslib_1.__importStar(__webpack_require__(57));
	var colors_1 = __webpack_require__(29);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var partyDomain_1 = __webpack_require__(48);
	var closedForm_1 = __webpack_require__(82);
	var dateUtils_1 = __webpack_require__(49);
	var shipmentVisitComps_1 = __webpack_require__(966);
	var grid_1 = __webpack_require__(50);
	var selectSearchDialog_1 = tslib_1.__importDefault(__webpack_require__(311));
	var gridConfigCondition_1 = tslib_1.__importDefault(__webpack_require__(194));
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var radioButtonField_1 = tslib_1.__importDefault(__webpack_require__(144));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var gridComp_1 = tslib_1.__importStar(__webpack_require__(44));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var visitNewShipmentGridLocation = 'visitNewShipmentList';
	var ShipmentVisitClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields },
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: 'ID', value: dataObject.shipmentVisitId, linkProps: { to: 'shipmentVisitDetail', params: { id: dataObject.shipmentVisitId } } }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.registrationNumber.textLabel, value: dataObject.registrationNumber }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.driverPhone.textLabel, value: dataObject.driverPhone }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.visitTime.textLabel, value: dataObject.visitTime, mdField: fields.visitTime.mdField }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.entranceTime.textLabel, value: dataObject.entranceTime, mdField: fields.entranceTime.mdField }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.visitEnd.textLabel, value: dataObject.visitEnd, mdField: fields.visitEnd.mdField }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.gateLoadingDuration.textLabel, value: dataObject.gateLoadingDuration, mdField: fields.gateLoadingDuration.mdField }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.vendorLoadingDuration.textLabel, value: dataObject.vendorLoadingDuration, mdField: fields.vendorLoadingDuration.mdField }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.directionOutgoing.textLabel, value: dataObject.directionOutgoing }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.directionPackaging.textLabel, value: dataObject.directionPackaging }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.directionIncoming.textLabel, value: dataObject.directionIncoming }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.packagingSender.textLabel, value: dataObject.packagingSender })));
	};
	exports.ShipmentVisitClosedContent = ShipmentVisitClosedContent;
	var ShipmentVisitDriverForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentVisitDriverForm, _super);
	    function ShipmentVisitDriverForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.allShipments = [];
	        _this.newInicialized = false;
	        _this.showSenderSelectBox = false;
	        _this.currentTime = new Date().toISOString();
	        _this.selectSearchDialogRefHandler = function (comp) { return _this.selectSearchDialogRef = comp; };
	        _this.onSubmit = function (e) {
	            console.log('form submited');
	            e.preventDefault();
	            var _a = _this.props, dataObject = _a.dataObject, onSubmit = _a.onSubmit, entities = _a.entities;
	            return onSubmit(dataObject, function () {
	                var shipmentVisitStepEntity = entities.get("SHIPMENTVISITSTEP");
	                dataObject.step = shipmentVisitStepEntity.getLovItem(shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_ARRIVED);
	                dataObject.visitTime = new Date().toISOString();
	            }).then(function () {
	            });
	        };
	        _this.handleDirectionPackaging = function (evt) {
	            var _a = _this.props, entities = _a.entities, dataObject = _a.dataObject, form = _a.form, rootObject = _a.rootObject;
	            form.getField("directionPackaging").props.onCheck(evt);
	            if (!dataObject.directionPackaging) {
	                dataObject.packagingSender = undefined;
	                form.updateFieldsPropValue(dataObject, "packagingSender");
	            }
	        };
	        _this.handleSupplier = function () {
	            var _a = _this.props, entities = _a.entities, dataObject = _a.dataObject, form = _a.form, rootObject = _a.rootObject;
	            if (dataObject.$supplierId) {
	                return shipmentService_1.default.readShipments(undefined, (0, dateUtils_1.formatDateIso)(new Date()), grid_1.FILTEROPERATOR.LESSOREQUALTHAN, dataObject.$supplierId.value, shipmentDomain_1.SHIPMENTDIRECTION.INCOMING, dataObject, true)
	                    .then((0, mobx_1.action)("readShipments-acb", function (shipments) {
	                    dataObject.shipments = shipments;
	                    return shipmentService_1.default.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService_1.default.shipmentVisitObject);
	                }));
	            }
	            else {
	                dataObject.shipments = _this.allShipments.filter(function (s) { return s.shipmentDirection === (0, formUtils_1.lovValue)(dataObject.$direction); });
	                return shipmentService_1.default.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService_1.default.shipmentVisitObject);
	            }
	        };
	        _this.handleSuccessRegistrationNumber = function () {
	            var _a = _this.props, entity = _a.entity, dataObject = _a.dataObject, form = _a.form, rootObject = _a.rootObject, entities = _a.entities;
	            var shipmentdirectionEntity = entities.get("SHIPMENTDIRECTION");
	            console.debug('handleSuccessRegistrationNumber %s - valid %s', dataObject.registrationNumber);
	            shipmentService_1.default.readShipmentVisits(dataObject.registrationNumber, null, null, null, null, null, shipmentDomain_1.SHIPMENTVISITSTEP.PREPARED_VISIT)
	                .then((0, mobx_1.action)("readShipmentVisits-cb", function (visits) {
	                if (visits.length === 1) {
	                    console.log("handleSuccessRegistrationNumber - found one visit %o", visits[0]);
	                    rootObject.$dirty = false;
	                    _this.context.router.transitionTo("shipmentVisitDetail", { id: visits[0].shipmentVisitId });
	                }
	                else if (visits.length > 1) {
	                    console.log("handleSuccessRegistrationNumber - found more than 1 visit %o", visits);
	                    new Promise(function (resolve, reject) {
	                        return _this.selectSearchDialogRef.open(resolve, reject, function (grid) {
	                            if (!grid.conditionArray)
	                                grid.conditionArray = [];
	                            grid.conditionArray.push(new gridConfigCondition_1.default(grid.$gridLocationRef, {
	                                field: entity.getField("registrationNumber"),
	                                operator: grid_1.FILTEROPERATOR.EQUAL,
	                                values: [dataObject.registrationNumber]
	                            }));
	                            grid.conditionArray.push(new gridConfigCondition_1.default(grid.$gridLocationRef, {
	                                field: entity.getField("step"),
	                                operator: grid_1.FILTEROPERATOR.EQUAL,
	                                values: [shipmentDomain_1.SHIPMENTVISITSTEP.PREPARED_VISIT]
	                            }));
	                        });
	                    }).then((0, mobx_1.action)("close-new-party-diaglog", function (visit) {
	                        console.log("handleSuccessRegistrationNumber - selected %o", visit);
	                        rootObject.$dirty = false;
	                        _this.context.router.transitionTo("shipmentVisitDetail", { id: visit.shipmentVisitId });
	                    })).catch(function (e) {
	                    });
	                }
	                else {
	                    // not found
	                    console.log("handleSuccessRegistrationNumber - not found");
	                    return shipmentService_1.default.readShipments(dataObject.registrationNumber, (0, dateUtils_1.formatDateIso)(new Date()), grid_1.FILTEROPERATOR.LESSOREQUALTHAN, undefined, null, dataObject, false)
	                        .then((0, mobx_1.action)("readShipments-acb", function (shipments) {
	                        console.log("handleSuccessRegistrationNumber - not found - readShipments %o", shipments);
	                        dataObject.$supplierId = null;
	                        dataObject.directionPackaging = false;
	                        dataObject.directionOutgoing = false;
	                        dataObject.directionIncoming = false;
	                        dataObject.$direction = undefined;
	                        form.updateFieldsPropValue(dataObject, "$supplierId", "directionPackaging");
	                        _this.newInicialized = true;
	                        _this.allShipments = shipments;
	                        var outgoingShipments = shipments.filter(function (s) { return s.shipmentDirection === shipmentDomain_1.SHIPMENTDIRECTION.OUTGOING; });
	                        var incomingShipments = shipments.filter(function (s) { return s.shipmentDirection === shipmentDomain_1.SHIPMENTDIRECTION.INCOMING; });
	                        if (outgoingShipments.length > 0) {
	                            dataObject.$direction = shipmentdirectionEntity.getLovItem(shipmentDomain_1.SHIPMENTDIRECTION.OUTGOING);
	                            dataObject.directionOutgoing = true;
	                            dataObject.shipments = outgoingShipments;
	                        }
	                        else if (incomingShipments.length > 0) {
	                            dataObject.$direction = shipmentdirectionEntity.getLovItem(shipmentDomain_1.SHIPMENTDIRECTION.INCOMING);
	                            dataObject.directionIncoming = true;
	                            dataObject.shipments = incomingShipments;
	                        }
	                        else {
	                            dataObject.shipments = [];
	                        }
	                        return shipmentService_1.default.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService_1.default.shipmentVisitObject);
	                    }));
	                }
	            }));
	        };
	        _this.handleDirectionChange = function (newLov) {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            dataObject.$direction = newLov;
	            dataObject.directionOutgoing = ((0, formUtils_1.lovValue)(newLov) === shipmentDomain_1.SHIPMENTDIRECTION.OUTGOING);
	            dataObject.directionIncoming = ((0, formUtils_1.lovValue)(newLov) === shipmentDomain_1.SHIPMENTDIRECTION.INCOMING);
	            dataObject.directionPackaging = false;
	            dataObject.$supplierId = null;
	            dataObject.shipments = _this.allShipments.filter(function (s) { return s.shipmentDirection === (0, formUtils_1.lovValue)(newLov); });
	            form.updateFieldsPropValue(dataObject, "$supplierId", "directionPackaging");
	            return shipmentService_1.default.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService_1.default.shipmentVisitObject);
	        };
	        _this.newVisit = function (evt) {
	            _this.newInicialized = false;
	            _this.context.router.transitionTo("shipmentVisitDetail", { id: 'new' }, {});
	        };
	        return _this;
	    }
	    ShipmentVisitDriverForm.prototype.componentWillMount = function () {
	        this.showSenderSelectBox = !!this.props.dataObject.packagingSender;
	        this.setPlus(this.props.dataObject);
	    };
	    ;
	    ShipmentVisitDriverForm.prototype.componentDidUpdate = function (prevProps, prevState, prevContext) {
	        console.log("componentDidUpdate");
	        this.setPlus(this.props.dataObject);
	    };
	    ShipmentVisitDriverForm.prototype.setPlus = function (dataObject) {
	        console.log("setPlus 1 ", dataObject.driverPhone);
	        if (!dataObject.driverPhone) {
	            dataObject.driverPhone = "+";
	            this.props.form.updateFieldsPropValue(dataObject, "driverPhone");
	            console.log("setPlus 2 ", dataObject.driverPhone);
	        }
	    };
	    ShipmentVisitDriverForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entity = _a.entity, entities = _a.entities, form = _a.form, formName = _a.formName;
	        var fields = form.fields;
	        var _b = dataObject.getFormFields(formName), registrationNumber = _b.registrationNumber, driverPhone = _b.driverPhone, directionPackaging = _b.directionPackaging, $supplierId = _b.$supplierId, packagingSender = _b.packagingSender, entranceTime = _b.entranceTime;
	        var shipmentdirectionEntity = entities.get("SHIPMENTDIRECTION");
	        return (react_1.default.createElement("form", { style: { marginTop: 10, display: "flex", flexDirection: "column" }, onSubmit: this.onSubmit, autoComplete: "off" },
	            react_1.default.createElement(selectSearchDialog_1.default, { ref: this.selectSearchDialogRefHandler, gridLocation: "shipmentVisitSearch", showGridConfig: false, title: "Select Shipment Visit", contentStyle: { width: '80%', maxWidth: 1280 } }),
	            react_1.default.createElement(shipmentVisitComps_1.BigFlagBar, null),
	            react_1.default.createElement(blockComp_1.BlockComp, null,
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                        react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, registrationNumber.props, { disabled: !dataObject.$new, floatingLabelFixed: true, floatingLabelStyle: tslib_1.__assign(tslib_1.__assign({}, registrationNumber.props.floatingLabelStyle), { fontSize: 35, color: colors_1.grey900 }), autoComplete: "off" })),
	                        react_1.default.createElement(validate_1.Validate, { field: registrationNumber, value: registrationNumber.props.value, onSuccess: this.handleSuccessRegistrationNumber })),
	                    (!dataObject.$new || this.newInicialized) && (react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                        react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, driverPhone.props, { floatingLabelFixed: true, floatingLabelStyle: tslib_1.__assign(tslib_1.__assign({}, driverPhone.props.floatingLabelStyle), { fontSize: 35, color: colors_1.grey900 }), autoComplete: "off" })),
	                        react_1.default.createElement(validate_1.Validate, { field: driverPhone, value: driverPhone.props.value },
	                            react_1.default.createElement(rules_1.CountryPhoneFormat, { pattern: constant_1.PHONE_PATTERN }))))),
	                (dataObject.$new && this.newInicialized) && (react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12" },
	                        react_1.default.createElement(radioButtonField_1.default, { value: dataObject.$direction, onChange: this.handleDirectionChange, options: shipmentdirectionEntity.lovItems, style: { marginTop: 20 }, groupStyle: { display: 'flex', height: 50, justifyContent: "center" }, optionStyle: { width: 'initial', marginRight: 15, fontSize: 25, height: 40 }, labelStyle: { whiteSpace: 'nowrap', marginLeft: -10 }, iconStyleFn: function (v) { return ({ fill: v === shipmentDomain_1.SHIPMENTDIRECTION.OUTGOING ? colors_1.blue500 : colors_1.red500, height: 30, width: 30 }); } })))),
	                (!dataObject.$new) && (react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-12", style: { justifyContent: "center" } },
	                        react_1.default.createElement("span", { style: { fontSize: 25, color: colors_1.grey500 } },
	                            (0, formUtils_1.lovLabel)(dataObject.$direction),
	                            " Visit ")))),
	                ((0, formUtils_1.lovValue)(dataObject.$direction) === shipmentDomain_1.SHIPMENTDIRECTION.INCOMING) && dataObject.$new &&
	                    react_1.default.createElement("div", { className: "row", style: { marginTop: 10 } },
	                        react_1.default.createElement("div", { className: "fx col-xs-12" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, $supplierId.props, { disabled: !dataObject.$new, floatingLabelText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Supplier"], ["Supplier"]))), async: true, clearable: true, asterixForAll: true, floatingLabelStyle: tslib_1.__assign(tslib_1.__assign({}, $supplierId.props.floatingLabelStyle), { fontSize: 35, color: colors_1.grey900 }), loadOptions: commonDataService_1.optionsSearch.bind(this, (0, formUtils_1.lovValue)('Shipment'), { potentialSuppliers: true, visitTime: this.currentTime }) })),
	                            react_1.default.createElement(validate_1.Validate, { field: $supplierId, value: $supplierId.props.value, onSuccess: this.handleSupplier }))),
	                ((0, formUtils_1.lovValue)(dataObject.$direction) === shipmentDomain_1.SHIPMENTDIRECTION.OUTGOING) && (react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-4", style: { alignSelf: "center" } },
	                        react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, directionPackaging.props, { onCheck: this.handleDirectionPackaging, style: { height: 30, width: 'auto', marginRight: 20, marginTop: 20 }, labelStyle: { whiteSpace: 'nowrap', fontSize: 25, color: colors_1.grey900 } }))),
	                    (dataObject.directionPackaging) && (react_1.default.createElement("div", { className: "fx col-xs-8" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, packagingSender.props, { async: true, clearable: true, asterixForAll: true, floatingLabelText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["shipment.packagingSender"], ["shipment.packagingSender"]))), loadOptions: commonDataService_1.optionsSearch.bind(this, (0, formUtils_1.lovValue)('Party'), { role: [partyDomain_1.PARTYROLE.PACKAGING] }) })),
	                        react_1.default.createElement(validate_1.Validate, { field: packagingSender, value: packagingSender.props.value }))))),
	                dataObject.$direction && (react_1.default.createElement("div", { style: { marginTop: 20 } },
	                    react_1.default.createElement(gridComp_1.default, { ref: visitNewShipmentGridLocation, grid: dataObject.$shipmentVisitShipmentsGrid, uiLocation: gridComp_1.UILOCATION.main, entities: mdEntityService_1.default.entityMap, rootObject: dataObject, hideToolbar: true }))),
	                (dataObject.$direction) ? (react_1.default.createElement("div", { className: "row", style: { marginTop: 20 } },
	                    react_1.default.createElement("div", { className: "fx col-xs-10" },
	                        react_1.default.createElement(buttons_1.SecuredZzRaisedButton, { type: "submit", label: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Save"], ["Save"]))), disabled: !dataObject.registrationNumber || !dataObject.driverPhone || uiService_1.default.getToolbarActionFlag(), permission: metaConstant_1.PERMISSION.New, securable: metaConstant_1.SECURABLE.shipmentVisitDetail, secondary: true, style: { height: 60, width: 140 }, labelStyle: { fontSize: 20 } }),
	                        !dataObject.$new && react_1.default.createElement(FlatButton_1.default, { label: locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["Reset"], ["Reset"]))), disabled: uiService_1.default.getToolbarActionFlag(), onClick: this.newVisit, primary: true, style: { height: 60, width: 140, marginLeft: 20 }, labelStyle: { fontSize: 20 } })))) : null)));
	    };
	    ShipmentVisitDriverForm.contextTypes = {
	        router: prop_types_1.default.func.isRequired,
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisitDriverForm.prototype, "newInicialized", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisitDriverForm.prototype, "showSenderSelectBox", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitDriverForm.prototype, "setPlus", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitDriverForm.prototype, "onSubmit", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitDriverForm.prototype, "handleDirectionPackaging", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitDriverForm.prototype, "handleSupplier", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitDriverForm.prototype, "handleSuccessRegistrationNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitDriverForm.prototype, "handleDirectionChange", void 0);
	    ShipmentVisitDriverForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'ShipmentVisitDriverForm',
	            fields: [{
	                    name: 'registrationNumber',
	                    validators: ['IsRequired'],
	                    size: form_1.FIELDDEFSIZE.huge
	                }, {
	                    name: 'visitTime'
	                }, {
	                    name: 'visitEnd'
	                }, {
	                    name: 'driverPhone',
	                    validators: ['IsRequired'],
	                    size: form_1.FIELDDEFSIZE.huge
	                }, {
	                    name: "directionPackaging"
	                }, {
	                    name: "directionOutgoing"
	                }, {
	                    name: "directionIncoming"
	                }, {
	                    name: "$supplierId",
	                    mdField: new mdField_1.default({ label: 'Supplier', valueSourceType: mdField_1.VALUESOURCETYPE.ASYNC }),
	                    size: form_1.FIELDDEFSIZE.huge
	                }, {
	                    name: "packagingSender",
	                    size: form_1.FIELDDEFSIZE.huge
	                }, {
	                    name: "entranceTime"
	                }, {
	                    name: "gateLoadingDuration"
	                }, {
	                    name: "vendorLoadingDuration"
	                }]
	        }, exports.ShipmentVisitClosedContent),
	        mobx_react_1.observer
	    ], ShipmentVisitDriverForm);
	    return ShipmentVisitDriverForm;
	}(react_1.default.Component));
	exports.default = ShipmentVisitDriverForm;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 408 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.commaDecimal = exports.dotDecimal = exports.arabicLocales = exports.englishLocales = exports.decimal = exports.alphanumeric = exports.alpha = void 0;
	var alpha = {
	  'en-US': /^[A-Z]+$/i,
	  'bg-BG': /^[А-Я]+$/i,
	  'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
	  'da-DK': /^[A-ZÆØÅ]+$/i,
	  'de-DE': /^[A-ZÄÖÜß]+$/i,
	  'el-GR': /^[Α-ω]+$/i,
	  'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
	  'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
	  'it-IT': /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
	  'nb-NO': /^[A-ZÆØÅ]+$/i,
	  'nl-NL': /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
	  'nn-NO': /^[A-ZÆØÅ]+$/i,
	  'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
	  'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
	  'pt-PT': /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
	  'ru-RU': /^[А-ЯЁ]+$/i,
	  'sl-SI': /^[A-ZČĆĐŠŽ]+$/i,
	  'sk-SK': /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
	  'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
	  'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
	  'sv-SE': /^[A-ZÅÄÖ]+$/i,
	  'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
	  'uk-UA': /^[А-ЩЬЮЯЄIЇҐі]+$/i,
	  'ku-IQ': /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
	  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
	};
	exports.alpha = alpha;
	var alphanumeric = {
	  'en-US': /^[0-9A-Z]+$/i,
	  'bg-BG': /^[0-9А-Я]+$/i,
	  'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
	  'da-DK': /^[0-9A-ZÆØÅ]+$/i,
	  'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
	  'el-GR': /^[0-9Α-ω]+$/i,
	  'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
	  'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
	  'it-IT': /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
	  'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
	  'nb-NO': /^[0-9A-ZÆØÅ]+$/i,
	  'nl-NL': /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
	  'nn-NO': /^[0-9A-ZÆØÅ]+$/i,
	  'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
	  'pt-PT': /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
	  'ru-RU': /^[0-9А-ЯЁ]+$/i,
	  'sl-SI': /^[0-9A-ZČĆĐŠŽ]+$/i,
	  'sk-SK': /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
	  'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
	  'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
	  'sv-SE': /^[0-9A-ZÅÄÖ]+$/i,
	  'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
	  'uk-UA': /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
	  'ku-IQ': /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
	  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
	};
	exports.alphanumeric = alphanumeric;
	var decimal = {
	  'en-US': '.',
	  ar: '٫'
	};
	exports.decimal = decimal;
	var englishLocales = ['AU', 'GB', 'HK', 'IN', 'NZ', 'ZA', 'ZM'];
	exports.englishLocales = englishLocales;
	
	for (var locale, i = 0; i < englishLocales.length; i++) {
	  locale = "en-".concat(englishLocales[i]);
	  alpha[locale] = alpha['en-US'];
	  alphanumeric[locale] = alphanumeric['en-US'];
	  decimal[locale] = decimal['en-US'];
	} // Source: http://www.localeplanet.com/java/
	
	
	var arabicLocales = ['AE', 'BH', 'DZ', 'EG', 'IQ', 'JO', 'KW', 'LB', 'LY', 'MA', 'QM', 'QA', 'SA', 'SD', 'SY', 'TN', 'YE'];
	exports.arabicLocales = arabicLocales;
	
	for (var _locale, _i = 0; _i < arabicLocales.length; _i++) {
	  _locale = "ar-".concat(arabicLocales[_i]);
	  alpha[_locale] = alpha.ar;
	  alphanumeric[_locale] = alphanumeric.ar;
	  decimal[_locale] = decimal.ar;
	} // Source: https://en.wikipedia.org/wiki/Decimal_mark
	
	
	var dotDecimal = [];
	exports.dotDecimal = dotDecimal;
	var commaDecimal = ['bg-BG', 'cs-CZ', 'da-DK', 'de-DE', 'el-GR', 'es-ES', 'fr-FR', 'it-IT', 'ku-IQ', 'hu-HU', 'nb-NO', 'nn-NO', 'nl-NL', 'pl-PL', 'pt-PT', 'ru-RU', 'sl-SI', 'sr-RS@latin', 'sr-RS', 'sv-SE', 'tr-TR', 'uk-UA'];
	exports.commaDecimal = commaDecimal;
	
	for (var _i2 = 0; _i2 < dotDecimal.length; _i2++) {
	  decimal[dotDecimal[_i2]] = decimal['en-US'];
	}
	
	for (var _i3 = 0; _i3 < commaDecimal.length; _i3++) {
	  decimal[commaDecimal[_i3]] = ',';
	}
	
	alpha['pt-BR'] = alpha['pt-PT'];
	alphanumeric['pt-BR'] = alphanumeric['pt-PT'];
	decimal['pt-BR'] = decimal['pt-PT']; // see #862
	
	alpha['pl-Pl'] = alpha['pl-PL'];
	alphanumeric['pl-Pl'] = alphanumeric['pl-PL'];
	decimal['pl-Pl'] = decimal['pl-PL'];

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isIP;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
	var ipv6Block = /^[0-9A-F]{1,4}$/i;
	
	function isIP(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  (0, _assertString.default)(str);
	  version = String(version);
	
	  if (!version) {
	    return isIP(str, 4) || isIP(str, 6);
	  } else if (version === '4') {
	    if (!ipv4Maybe.test(str)) {
	      return false;
	    }
	
	    var parts = str.split('.').sort(function (a, b) {
	      return a - b;
	    });
	    return parts[3] <= 255;
	  } else if (version === '6') {
	    var blocks = str.split(':');
	    var foundOmissionBlock = false; // marker to indicate ::
	    // At least some OS accept the last 32 bits of an IPv6 address
	    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
	    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
	    // and '::a.b.c.d' is deprecated, but also valid.
	
	    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
	    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;
	
	    if (blocks.length > expectedNumberOfBlocks) {
	      return false;
	    } // initial or final ::
	
	
	    if (str === '::') {
	      return true;
	    } else if (str.substr(0, 2) === '::') {
	      blocks.shift();
	      blocks.shift();
	      foundOmissionBlock = true;
	    } else if (str.substr(str.length - 2) === '::') {
	      blocks.pop();
	      blocks.pop();
	      foundOmissionBlock = true;
	    }
	
	    for (var i = 0; i < blocks.length; ++i) {
	      // test for a :: which can not be at the string start/end
	      // since those cases have been handled above
	      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
	        if (foundOmissionBlock) {
	          return false; // multiple :: in address
	        }
	
	        foundOmissionBlock = true;
	      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) {// it has been checked before that the last
	        // block is a valid IPv4 address
	      } else if (!ipv6Block.test(blocks[i])) {
	        return false;
	      }
	    }
	
	    if (foundOmissionBlock) {
	      return blocks.length >= 1;
	    }
	
	    return blocks.length === expectedNumberOfBlocks;
	  }
	
	  return false;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(122);
	var normalizeHeaderName = __webpack_require__(994);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(582);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(582);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(140)))

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1044), __esModule: true };

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(998);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(997);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 413 */
321,
/* 414 */
[2331, 1057],
/* 415 */
322,
/* 416 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 417 */
[2341, 197, 1071, 416, 420, 598, 1062],
/* 418 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(180).f;
	var has = __webpack_require__(198);
	var TAG = __webpack_require__(134)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 420 */
[2350, 421, 319],
/* 421 */
[2351, 95, 179, 318],
/* 422 */
325,
/* 423 */
[2356, 227],
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(179);
	var core = __webpack_require__(95);
	var LIBRARY = __webpack_require__(318);
	var wksExt = __webpack_require__(425);
	var defineProperty = __webpack_require__(180).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(134);


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1079);
	var global = __webpack_require__(179);
	var hide = __webpack_require__(226);
	var Iterators = __webpack_require__(228);
	var TO_STRING_TAG = __webpack_require__(134)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 427 */
[2331, 1092],
/* 428 */
416,
/* 429 */
[2334, 324, 432, 200],
/* 430 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 431 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 432 */
268,
/* 433 */
[2351, 231, 149, 1103],
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(53);
	var defined = __webpack_require__(322);
	var fails = __webpack_require__(181);
	var spaces = __webpack_require__(435);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 435 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 436 */
[2356, 232],
/* 437 */
319,
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateProperty;
	
	var _hyphenateStyleName = __webpack_require__(1321);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hyphenateProperty(property) {
	  return (0, _hyphenateStyleName2.default)(property);
	}
	module.exports = exports['default'];

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ v1.3.7 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(1153)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Path) { 'use strict';
	
	function constant(x) {
	  return function constant() {
	    return x;
	  };
	}
	
	var abs = Math.abs;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var max = Math.max;
	var min = Math.min;
	var sin = Math.sin;
	var sqrt = Math.sqrt;
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = y32 * x10 - x32 * y10;
	  if (t * t < epsilon) return;
	  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	function arc() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * cos(a0), r1 * sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * cos(a1), r0 * sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
	          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * sin(ap)),
	            p1 = asin(rp / r1 * sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * cos(a01),
	          y01 = r1 * sin(a01),
	          x10 = r0 * cos(a10),
	          y10 = r0 * sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * cos(a11),
	            y11 = r1 * sin(a11),
	            x00 = r0 * cos(a00),
	            y00 = r0 * sin(a00),
	            oc;
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
	          var ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
	              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = min(rc, (r0 - lc) / (kc - 1));
	          rc1 = min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [cos(a) * r, sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	}
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	function curveLinear(context) {
	  return new Linear(context);
	}
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	function line() {
	  var x$1 = x,
	      y$1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$1(d, i, data), +y$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant(+_), line) : x$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant(+_), line) : y$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	}
	
	function area() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant(0),
	      y1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function identity(d) {
	  return d;
	}
	
	function pie() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant(0),
	      endAngle = constant(tau),
	      padAngle = constant(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
	  };
	
	  return pie;
	}
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function lineRadial(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	function lineRadial$1() {
	  return lineRadial(line().curve(curveRadialLinear));
	}
	
	function areaRadial() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	}
	
	function pointRadial(x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	}
	
	var slice = Array.prototype.slice;
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x$1 = x,
	      y$1 = y,
	      context = null;
	
	  function link() {
	    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	    if (!context) context = buffer = d3Path.path();
	    curve(context, +x$1.apply(this, (argv[0] = s, argv)), +y$1.apply(this, argv), +x$1.apply(this, (argv[0] = t, argv)), +y$1.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function(_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function(_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function(_) {
	    return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant(+_), link) : x$1;
	  };
	
	  link.y = function(_) {
	    return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant(+_), link) : y$1;
	  };
	
	  link.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial$1(context, x0, y0, x1, y1) {
	  var p0 = pointRadial(x0, y0),
	      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
	      p2 = pointRadial(x1, y0),
	      p3 = pointRadial(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link(curveHorizontal);
	}
	
	function linkVertical() {
	  return link(curveVertical);
	}
	
	function linkRadial() {
	  var l = link(curveRadial$1);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3),
	    tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810,
	    kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10),
	    kx = Math.sin(tau / 10) * kr,
	    ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5,
	    s = Math.sqrt(3) / 2,
	    k = 1 / Math.sqrt(12),
	    a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	function symbol() {
	  var type = constant(circle),
	      size = constant(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	}
	
	function noop() {}
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basis(context) {
	  return new Basis(context);
	}
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basisClosed(context) {
	  return new BasisClosed(context);
	}
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basisOpen(context) {
	  return new BasisOpen(context);
	}
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = (function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	})(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = (function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	function linearClosed(context) {
	  return new LinearClosed(context);
	}
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	function natural(context) {
	  return new Natural(context);
	}
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	function step(context) {
	  return new Step(context, 0.5);
	}
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	function none(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	}
	
	function none$1(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	}
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	function stack() {
	  var keys = constant([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	}
	
	function expand(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	}
	
	function diverging(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = 0, d[1] = dy;
	      }
	    }
	  }
	}
	
	function silhouette(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	}
	
	function wiggle(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	}
	
	function appearance(series) {
	  var peaks = series.map(peak);
	  return none$1(series).sort(function(a, b) { return peaks[a] - peaks[b]; });
	}
	
	function peak(series) {
	  var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
	  while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
	  return j;
	}
	
	function ascending(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	}
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	function descending$1(series) {
	  return ascending(series).reverse();
	}
	
	function insideOut(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = appearance(series),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	}
	
	function reverse(series) {
	  return none$1(series).reverse();
	}
	
	exports.arc = arc;
	exports.area = area;
	exports.areaRadial = areaRadial;
	exports.curveBasis = basis;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBundle = bundle;
	exports.curveCardinal = cardinal;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveLinear = curveLinear;
	exports.curveLinearClosed = linearClosed;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.line = line;
	exports.lineRadial = lineRadial$1;
	exports.linkHorizontal = linkHorizontal;
	exports.linkRadial = linkRadial;
	exports.linkVertical = linkVertical;
	exports.pie = pie;
	exports.pointRadial = pointRadial;
	exports.radialArea = areaRadial;
	exports.radialLine = lineRadial$1;
	exports.stack = stack;
	exports.stackOffsetDiverging = diverging;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAppearance = appearance;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	exports.symbol = symbol;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.symbols = symbols;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ }),
/* 440 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = isDisposable;
	
	function isDisposable(obj) {
	  return Boolean(obj && typeof obj.dispose === 'function');
	}
	
	module.exports = exports['default'];

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(182));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "stateToHTML", {
	  enumerable: true,
	  get: function get() {
	    return _stateToHTML["default"];
	  }
	});
	
	var _stateToHTML = _interopRequireDefault(__webpack_require__(1189));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	/**
	 * Returns an array of all `ContentBlock` instances within two block keys
	 *
	 * @param  {object} contentState A draft.js `ContentState` instance
	 * @param  {string} anchorKey    The block key to start searching from
	 * @param  {string} focusKey     The block key until which to search
	 *
	 * @return {array} An array containing the found content blocks
	 */
	var _default = function _default(contentState, anchorKey, focusKey) {
	  var isSameBlock = anchorKey === focusKey;
	  var startingBlock = contentState.getBlockForKey(anchorKey);
	
	  if (!startingBlock) {
	    return [];
	  }
	
	  var selectedBlocks = [startingBlock];
	
	  if (!isSameBlock) {
	    var blockKey = anchorKey;
	
	    while (blockKey !== focusKey) {
	      var nextBlock = contentState.getBlockAfter(blockKey);
	
	      if (!nextBlock) {
	        selectedBlocks = [];
	        break;
	      }
	
	      selectedBlocks.push(nextBlock);
	      blockKey = nextBlock.getKey();
	    }
	  }
	
	  return selectedBlocks;
	};
	
	exports["default"] = _default;

/***/ }),
/* 444 */
443,
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlockMapBuilder = __webpack_require__(271);
	var CharacterMetadata = __webpack_require__(112);
	var ContentBlock = __webpack_require__(201);
	var ContentBlockNode = __webpack_require__(123);
	var DraftEntity = __webpack_require__(332);
	var DraftFeatureFlags = __webpack_require__(183);
	var Immutable = __webpack_require__(60);
	var SelectionState = __webpack_require__(235);
	
	var generateRandomKey = __webpack_require__(161);
	var sanitizeDraftText = __webpack_require__(451);
	
	var List = Immutable.List,
	    Record = Immutable.Record,
	    Repeat = Immutable.Repeat;
	
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	
	var defaultRecord = {
	  entityMap: null,
	  blockMap: null,
	  selectionBefore: null,
	  selectionAfter: null
	};
	
	var ContentBlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
	
	var ContentStateRecord = Record(defaultRecord);
	
	var ContentState = function (_ContentStateRecord) {
	  _inherits(ContentState, _ContentStateRecord);
	
	  function ContentState() {
	    _classCallCheck(this, ContentState);
	
	    return _possibleConstructorReturn(this, _ContentStateRecord.apply(this, arguments));
	  }
	
	  ContentState.prototype.getEntityMap = function getEntityMap() {
	    // TODO: update this when we fully remove DraftEntity
	    return DraftEntity;
	  };
	
	  ContentState.prototype.getBlockMap = function getBlockMap() {
	    return this.get('blockMap');
	  };
	
	  ContentState.prototype.getSelectionBefore = function getSelectionBefore() {
	    return this.get('selectionBefore');
	  };
	
	  ContentState.prototype.getSelectionAfter = function getSelectionAfter() {
	    return this.get('selectionAfter');
	  };
	
	  ContentState.prototype.getBlockForKey = function getBlockForKey(key) {
	    var block = this.getBlockMap().get(key);
	    return block;
	  };
	
	  ContentState.prototype.getKeyBefore = function getKeyBefore(key) {
	    return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
	      return v === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getKeyAfter = function getKeyAfter(key) {
	    return this.getBlockMap().keySeq().skipUntil(function (v) {
	      return v === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getBlockAfter = function getBlockAfter(key) {
	    return this.getBlockMap().skipUntil(function (_, k) {
	      return k === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getBlockBefore = function getBlockBefore(key) {
	    return this.getBlockMap().reverse().skipUntil(function (_, k) {
	      return k === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getBlocksAsArray = function getBlocksAsArray() {
	    return this.getBlockMap().toArray();
	  };
	
	  ContentState.prototype.getFirstBlock = function getFirstBlock() {
	    return this.getBlockMap().first();
	  };
	
	  ContentState.prototype.getLastBlock = function getLastBlock() {
	    return this.getBlockMap().last();
	  };
	
	  ContentState.prototype.getPlainText = function getPlainText(delimiter) {
	    return this.getBlockMap().map(function (block) {
	      return block ? block.getText() : '';
	    }).join(delimiter || '\n');
	  };
	
	  ContentState.prototype.getLastCreatedEntityKey = function getLastCreatedEntityKey() {
	    // TODO: update this when we fully remove DraftEntity
	    return DraftEntity.__getLastCreatedEntityKey();
	  };
	
	  ContentState.prototype.hasText = function hasText() {
	    var blockMap = this.getBlockMap();
	    return blockMap.size > 1 || blockMap.first().getLength() > 0;
	  };
	
	  ContentState.prototype.createEntity = function createEntity(type, mutability, data) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__create(type, mutability, data);
	    return this;
	  };
	
	  ContentState.prototype.mergeEntityData = function mergeEntityData(key, toMerge) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__mergeData(key, toMerge);
	    return this;
	  };
	
	  ContentState.prototype.replaceEntityData = function replaceEntityData(key, newData) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__replaceData(key, newData);
	    return this;
	  };
	
	  ContentState.prototype.addEntity = function addEntity(instance) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__add(instance);
	    return this;
	  };
	
	  ContentState.prototype.getEntity = function getEntity(key) {
	    // TODO: update this when we fully remove DraftEntity
	    return DraftEntity.__get(key);
	  };
	
	  ContentState.createFromBlockArray = function createFromBlockArray(
	  // TODO: update flow type when we completely deprecate the old entity API
	  blocks, entityMap) {
	    // TODO: remove this when we completely deprecate the old entity API
	    var theBlocks = Array.isArray(blocks) ? blocks : blocks.contentBlocks;
	    var blockMap = BlockMapBuilder.createFromArray(theBlocks);
	    var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
	    return new ContentState({
	      blockMap: blockMap,
	      entityMap: entityMap || DraftEntity,
	      selectionBefore: selectionState,
	      selectionAfter: selectionState
	    });
	  };
	
	  ContentState.createFromText = function createFromText(text) {
	    var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\r\n?|\n/g;
	
	    var strings = text.split(delimiter);
	    var blocks = strings.map(function (block) {
	      block = sanitizeDraftText(block);
	      return new ContentBlockNodeRecord({
	        key: generateRandomKey(),
	        text: block,
	        type: 'unstyled',
	        characterList: List(Repeat(CharacterMetadata.EMPTY, block.length))
	      });
	    });
	    return ContentState.createFromBlockArray(blocks);
	  };
	
	  return ContentState;
	}(ContentStateRecord);
	
	module.exports = ContentState;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultDraftBlockRenderMap
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _require = __webpack_require__(60),
	    Map = _require.Map;
	
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(236);
	
	var UL_WRAP = React.createElement('ul', { className: cx('public/DraftStyleDefault/ul') });
	var OL_WRAP = React.createElement('ol', { className: cx('public/DraftStyleDefault/ol') });
	var PRE_WRAP = React.createElement('pre', { className: cx('public/DraftStyleDefault/pre') });
	
	var DefaultDraftBlockRenderMap = Map({
	  'header-one': {
	    element: 'h1'
	  },
	  'header-two': {
	    element: 'h2'
	  },
	  'header-three': {
	    element: 'h3'
	  },
	  'header-four': {
	    element: 'h4'
	  },
	  'header-five': {
	    element: 'h5'
	  },
	  'header-six': {
	    element: 'h6'
	  },
	  'unordered-list-item': {
	    element: 'li',
	    wrapper: UL_WRAP
	  },
	  'ordered-list-item': {
	    element: 'li',
	    wrapper: OL_WRAP
	  },
	  blockquote: {
	    element: 'blockquote'
	  },
	  atomic: {
	    element: 'figure'
	  },
	  'code-block': {
	    element: 'pre',
	    wrapper: PRE_WRAP
	  },
	  unstyled: {
	    element: 'div',
	    aliasedElements: ['p']
	  }
	});
	
	module.exports = DefaultDraftBlockRenderMap;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyBindingUtil
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(150);
	
	var isOSX = UserAgent.isPlatform('Mac OS X');
	
	var KeyBindingUtil = {
	  /**
	   * Check whether the ctrlKey modifier is *not* being used in conjunction with
	   * the altKey modifier. If they are combined, the result is an `altGraph`
	   * key modifier, which should not be handled by this set of key bindings.
	   */
	  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
	    return !!e.ctrlKey && !e.altKey;
	  },
	
	  isOptionKeyCommand: function isOptionKeyCommand(e) {
	    return isOSX && e.altKey;
	  },
	
	  hasCommandModifier: function hasCommandModifier(e) {
	    return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
	  }
	};
	
	module.exports = KeyBindingUtil;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findAncestorOffsetKey
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getSelectionOffsetKeyForNode = __webpack_require__(656);
	
	/**
	 * Get the key from the node's nearest offset-aware ancestor.
	 */
	function findAncestorOffsetKey(node) {
	  var searchNode = node;
	  while (searchNode && searchNode !== document.documentElement) {
	    var key = getSelectionOffsetKeyForNode(searchNode);
	    if (key != null) {
	      return key;
	    }
	    searchNode = searchNode.parentNode;
	  }
	  return null;
	}
	
	module.exports = findAncestorOffsetKey;

/***/ }),
/* 449 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEntityKeyForSelection
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Return the entity key that should be used when inserting text for the
	 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
	 * and `SEGMENTED` entities should not be used for insertion behavior.
	 */
	function getEntityKeyForSelection(contentState, targetSelection) {
	  var entityKey;
	
	  if (targetSelection.isCollapsed()) {
	    var key = targetSelection.getAnchorKey();
	    var offset = targetSelection.getAnchorOffset();
	    if (offset > 0) {
	      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);
	      if (entityKey !== contentState.getBlockForKey(key).getEntityAt(offset)) {
	        return null;
	      }
	      return filterKey(contentState.getEntityMap(), entityKey);
	    }
	    return null;
	  }
	
	  var startKey = targetSelection.getStartKey();
	  var startOffset = targetSelection.getStartOffset();
	  var startBlock = contentState.getBlockForKey(startKey);
	
	  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);
	
	  return filterKey(contentState.getEntityMap(), entityKey);
	}
	
	/**
	 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
	 * return it. If not, return null.
	 */
	function filterKey(entityMap, entityKey) {
	  if (entityKey) {
	    var entity = entityMap.__get(entityKey);
	    return entity.getMutability() === 'MUTABLE' ? entityKey : null;
	  }
	  return null;
	}
	
	module.exports = getEntityKeyForSelection;

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule moveSelectionBackward
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Given a collapsed selection, move the focus `maxDistance` backward within
	 * the selected block. If the selection will go beyond the start of the block,
	 * move focus to the end of the previous block, but no further.
	 *
	 * This function is not Unicode-aware, so surrogate pairs will be treated
	 * as having length 2.
	 */
	function moveSelectionBackward(editorState, maxDistance) {
	  var selection = editorState.getSelection();
	  var content = editorState.getCurrentContent();
	  var key = selection.getStartKey();
	  var offset = selection.getStartOffset();
	
	  var focusKey = key;
	  var focusOffset = 0;
	
	  if (maxDistance > offset) {
	    var keyBefore = content.getKeyBefore(key);
	    if (keyBefore == null) {
	      focusKey = key;
	    } else {
	      focusKey = keyBefore;
	      var blockBefore = content.getBlockForKey(keyBefore);
	      focusOffset = blockBefore.getText().length;
	    }
	  } else {
	    focusOffset = offset - maxDistance;
	  }
	
	  return selection.merge({
	    focusKey: focusKey,
	    focusOffset: focusOffset,
	    isBackward: true
	  });
	}
	
	module.exports = moveSelectionBackward;

/***/ }),
/* 451 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule sanitizeDraftText
	 * @format
	 * 
	 */
	
	'use strict';
	
	var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');
	
	function sanitizeDraftText(input) {
	  return input.replace(REGEX_BLOCK_DELIMITER, '');
	}
	
	module.exports = sanitizeDraftText;

/***/ }),
/* 452 */
203,
/* 453 */
203,
/* 454 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	module.exports = {
	  BACKSPACE: 8,
	  TAB: 9,
	  RETURN: 13,
	  ALT: 18,
	  ESC: 27,
	  SPACE: 32,
	  PAGE_UP: 33,
	  PAGE_DOWN: 34,
	  END: 35,
	  HOME: 36,
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40,
	  DELETE: 46,
	  COMMA: 188,
	  PERIOD: 190,
	  A: 65,
	  Z: 90,
	  ZERO: 48,
	  NUMPAD_0: 96,
	  NUMPAD_9: 105
	};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var getStyleProperty = __webpack_require__(1304);
	
	/**
	 * @param {DOMNode} element [description]
	 * @param {string} name Overflow style property name.
	 * @return {boolean} True if the supplied ndoe is scrollable.
	 */
	function _isNodeScrollable(element, name) {
	  var overflow = Style.get(element, name);
	  return overflow === 'auto' || overflow === 'scroll';
	}
	
	/**
	 * Utilities for querying and mutating style properties.
	 */
	var Style = {
	  /**
	   * Gets the style property for the supplied node. This will return either the
	   * computed style, if available, or the declared style.
	   *
	   * @param {DOMNode} node
	   * @param {string} name Style property name.
	   * @return {?string} Style property value.
	   */
	  get: getStyleProperty,
	
	  /**
	   * Determines the nearest ancestor of a node that is scrollable.
	   *
	   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
	   *
	   * @param {?DOMNode} node Node from which to start searching.
	   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
	   */
	  getScrollParent: function getScrollParent(node) {
	    if (!node) {
	      return null;
	    }
	    var ownerDocument = node.ownerDocument;
	    while (node && node !== ownerDocument.body) {
	      if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
	        return node;
	      }
	      node = node.parentNode;
	    }
	    return ownerDocument.defaultView || ownerDocument.parentWindow;
	  }
	
	};
	
	module.exports = Style;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Constants to represent text directionality
	 *
	 * Also defines a *global* direciton, to be used in bidi algorithms as a
	 * default fallback direciton, when no better direction is found or provided.
	 *
	 * NOTE: Use `setGlobalDir()`, or update `initGlobalDir()`, to set the initial
	 *       global direction value based on the application.
	 *
	 * Part of the implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(28);
	
	var NEUTRAL = 'NEUTRAL'; // No strong direction
	var LTR = 'LTR'; // Left-to-Right direction
	var RTL = 'RTL'; // Right-to-Left direction
	
	var globalDir = null;
	
	// == Helpers ==
	
	/**
	 * Check if a directionality value is a Strong one
	 */
	function isStrong(dir) {
	  return dir === LTR || dir === RTL;
	}
	
	/**
	 * Get string value to be used for `dir` HTML attribute or `direction` CSS
	 * property.
	 */
	function getHTMLDir(dir) {
	  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  return dir === LTR ? 'ltr' : 'rtl';
	}
	
	/**
	 * Get string value to be used for `dir` HTML attribute or `direction` CSS
	 * property, but returns null if `dir` has same value as `otherDir`.
	 * `null`.
	 */
	function getHTMLDirIfDifferent(dir, otherDir) {
	  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  !isStrong(otherDir) ?  false ? invariant(false, '`otherDir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  return dir === otherDir ? null : getHTMLDir(dir);
	}
	
	// == Global Direction ==
	
	/**
	 * Set the global direction.
	 */
	function setGlobalDir(dir) {
	  globalDir = dir;
	}
	
	/**
	 * Initialize the global direction
	 */
	function initGlobalDir() {
	  setGlobalDir(LTR);
	}
	
	/**
	 * Get the global direction
	 */
	function getGlobalDir() {
	  if (!globalDir) {
	    this.initGlobalDir();
	  }
	  !globalDir ?  false ? invariant(false, 'Global direction not set.') : invariant(false) : void 0;
	  return globalDir;
	}
	
	var UnicodeBidiDirection = {
	  // Values
	  NEUTRAL: NEUTRAL,
	  LTR: LTR,
	  RTL: RTL,
	  // Helpers
	  isStrong: isStrong,
	  getHTMLDir: getHTMLDir,
	  getHTMLDirIfDifferent: getHTMLDirIfDifferent,
	  // Global Direction
	  setGlobalDir: setGlobalDir,
	  initGlobalDir: initGlobalDir,
	  getGlobalDir: getGlobalDir
	};
	
	module.exports = UnicodeBidiDirection;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var getDocumentScrollElement = __webpack_require__(1300);
	var getUnboundedScrollPosition = __webpack_require__(677);
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are bounded. This means that if the scroll position is
	 * negative or exceeds the element boundaries (which is possible using inertial
	 * scrolling), you will get zero or the maximum scroll position, respectively.
	 *
	 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getScrollPosition(scrollable) {
	  var documentScrollElement = getDocumentScrollElement(scrollable.ownerDocument || scrollable.document);
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    scrollable = documentScrollElement;
	  }
	  var scrollPosition = getUnboundedScrollPosition(scrollable);
	
	  var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;
	
	  var xMax = scrollable.scrollWidth - viewport.clientWidth;
	  var yMax = scrollable.scrollHeight - viewport.clientHeight;
	
	  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
	  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));
	
	  return scrollPosition;
	}
	
	module.exports = getScrollPosition;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(678);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalizeString;
	function capitalizeString(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}
	module.exports = exports["default"];

/***/ }),
/* 463 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixValue;
	function prefixValue(plugins, property, value, style, metaData) {
	  for (var i = 0, len = plugins.length; i < len; ++i) {
	    var processedValue = plugins[i](property, value, style, metaData);
	
	    // we can stop processing if a value is returned
	    // as all plugin criteria are unique
	    if (processedValue) {
	      return processedValue;
	    }
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(206),
	    root = __webpack_require__(124);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1444),
	    mapCacheDelete = __webpack_require__(1445),
	    mapCacheGet = __webpack_require__(1446),
	    mapCacheHas = __webpack_require__(1447),
	    mapCacheSet = __webpack_require__(1448);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(339),
	    stackClear = __webpack_require__(1458),
	    stackDelete = __webpack_require__(1459),
	    stackGet = __webpack_require__(1460),
	    stackHas = __webpack_require__(1461),
	    stackSet = __webpack_require__(1462);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 467 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(702);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 469 */
/***/ (function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ }),
/* 470 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(709);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(346),
	    toKey = __webpack_require__(282);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1379),
	    isObjectLike = __webpack_require__(116);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(692);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(717);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(467),
	    stubArray = __webpack_require__(733);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(62),
	    isSymbol = __webpack_require__(240);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 478 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(100),
	    now = __webpack_require__(1480),
	    toNumber = __webpack_require__(487);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(278);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ }),
/* 481 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1385),
	    baseUnary = __webpack_require__(184),
	    nodeUtil = __webpack_require__(351);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(693),
	    baseKeysIn = __webpack_require__(1386),
	    isArrayLike = __webpack_require__(185);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	var basePullAll = __webpack_require__(1392);
	
	/**
	 * This method is like `_.pull` except that it accepts an array of values to remove.
	 *
	 * **Note:** Unlike `_.difference`, this method mutates `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to remove.
	 * @returns {Array} Returns `array`.
	 * @example
	 *
	 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	 *
	 * _.pullAll(array, ['a', 'c']);
	 * console.log(array);
	 * // => ['b', 'b']
	 */
	function pullAll(array, values) {
	  return (array && array.length && values && values.length)
	    ? basePullAll(array, values)
	    : array;
	}
	
	module.exports = pullAll;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(114),
	    basePullAt = __webpack_require__(1393);
	
	/**
	 * Removes all elements from `array` that `predicate` returns truthy for
	 * and returns an array of the removed elements. The predicate is invoked
	 * with three arguments: (value, index, array).
	 *
	 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	 * to pull elements from an array by value.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new array of removed elements.
	 * @example
	 *
	 * var array = [1, 2, 3, 4];
	 * var evens = _.remove(array, function(n) {
	 *   return n % 2 == 0;
	 * });
	 *
	 * console.log(array);
	 * // => [1, 3]
	 *
	 * console.log(evens);
	 * // => [2, 4]
	 */
	function remove(array, predicate) {
	  var result = [];
	  if (!(array && array.length)) {
	    return result;
	  }
	  var index = -1,
	      indexes = [],
	      length = array.length;
	
	  predicate = baseIteratee(predicate, 3);
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result.push(value);
	      indexes.push(index);
	    }
	  }
	  basePullAt(array, indexes);
	  return result;
	}
	
	module.exports = remove;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(278),
	    baseOrderBy = __webpack_require__(1389),
	    baseRest = __webpack_require__(205),
	    isIterateeCall = __webpack_require__(281);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(100),
	    isSymbol = __webpack_require__(240);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(114),
	    baseUniq = __webpack_require__(344);
	
	/**
	 * This method is like `_.uniq` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * uniqueness is computed. The order of result values is determined by the
	 * order they occur in the array. The iteratee is invoked with one argument:
	 * (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	 * // => [2.1, 1.2]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniqBy(array, iteratee) {
	  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
	}
	
	module.exports = uniqBy;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Badge = __webpack_require__(1495);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Badge2.default;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _LinearProgress = __webpack_require__(1527);
	
	var _LinearProgress2 = _interopRequireDefault(_LinearProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _LinearProgress2.default;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(212);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Popover = __webpack_require__(242);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _check = __webpack_require__(1608);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _ListItem = __webpack_require__(359);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Menu = __webpack_require__(360);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _propTypes3 = __webpack_require__(118);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nestedMenuStyle = {
	  position: 'relative'
	};
	
	function getStyles(props, context) {
	  var disabledColor = context.muiTheme.baseTheme.palette.disabledColor;
	  var textColor = context.muiTheme.baseTheme.palette.textColor;
	  var indent = props.desktop ? 64 : 72;
	  var sidePadding = props.desktop ? 24 : 16;
	
	  var styles = {
	    root: {
	      color: props.disabled ? disabledColor : textColor,
	      cursor: props.disabled ? 'default' : 'pointer',
	      minHeight: props.desktop ? '32px' : '48px',
	      lineHeight: props.desktop ? '32px' : '48px',
	      fontSize: props.desktop ? 15 : 16,
	      whiteSpace: 'nowrap'
	    },
	
	    innerDivStyle: {
	      paddingLeft: props.leftIcon || props.insetChildren || props.checked ? indent : sidePadding,
	      paddingRight: props.rightIcon ? indent : sidePadding,
	      paddingBottom: 0,
	      paddingTop: 0
	    },
	
	    secondaryText: {
	      float: 'right'
	    },
	
	    leftIconDesktop: {
	      margin: 0,
	      left: 24,
	      top: 4
	    },
	
	    rightIconDesktop: {
	      margin: 0,
	      right: 24,
	      top: 4,
	      fill: context.muiTheme.menuItem.rightIconDesktopFill
	    }
	  };
	
	  return styles;
	}
	
	var MenuItem = function (_Component) {
	  (0, _inherits3.default)(MenuItem, _Component);
	
	  function MenuItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, MenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuItem.__proto__ || (0, _getPrototypeOf2.default)(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.cloneMenuItem = function (item) {
	      return _react2.default.cloneElement(item, {
	        onClick: function onClick(event) {
	          if (!item.props.menuItems) {
	            _this.handleRequestClose();
	          }
	
	          if (item.props.onClick) {
	            item.props.onClick(event);
	          }
	        }
	      });
	    }, _this.handleTouchTap = function (event) {
	      event.preventDefault();
	
	      _this.setState({
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this)
	      });
	
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _this.handleRequestClose = function () {
	      _this.setState({
	        open: false,
	        anchorEl: null
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(MenuItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.open && nextProps.focusState === 'none') {
	        this.handleRequestClose();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.open) {
	        this.setState({
	          open: false
	        });
	      }
	    }
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState() {
	      this.refs.listItem.applyFocusState(this.props.focusState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checked = _props.checked,
	          children = _props.children,
	          desktop = _props.desktop,
	          disabled = _props.disabled,
	          focusState = _props.focusState,
	          innerDivStyle = _props.innerDivStyle,
	          insetChildren = _props.insetChildren,
	          leftIcon = _props.leftIcon,
	          menuItems = _props.menuItems,
	          rightIcon = _props.rightIcon,
	          secondaryText = _props.secondaryText,
	          style = _props.style,
	          animation = _props.animation,
	          anchorOrigin = _props.anchorOrigin,
	          targetOrigin = _props.targetOrigin,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['checked', 'children', 'desktop', 'disabled', 'focusState', 'innerDivStyle', 'insetChildren', 'leftIcon', 'menuItems', 'rightIcon', 'secondaryText', 'style', 'animation', 'anchorOrigin', 'targetOrigin', 'value']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedInnerDivStyles = (0, _simpleAssign2.default)(styles.innerDivStyle, innerDivStyle);
	
	      // Left Icon
	      var leftIconElement = leftIcon ? leftIcon : checked ? _react2.default.createElement(_check2.default, null) : null;
	      if (leftIconElement) {
	        var mergedLeftIconStyles = desktop ? (0, _simpleAssign2.default)(styles.leftIconDesktop, leftIconElement.props.style) : leftIconElement.props.style;
	        leftIconElement = _react2.default.cloneElement(leftIconElement, { style: mergedLeftIconStyles });
	      }
	
	      // Right Icon
	      var rightIconElement = void 0;
	      if (rightIcon) {
	        var mergedRightIconStyles = desktop ? (0, _simpleAssign2.default)(styles.rightIconDesktop, rightIcon.props.style) : rightIcon.props.style;
	        rightIconElement = _react2.default.cloneElement(rightIcon, { style: mergedRightIconStyles });
	      }
	
	      // Secondary Text
	      var secondaryTextElement = void 0;
	      if (secondaryText) {
	        var secondaryTextIsAnElement = _react2.default.isValidElement(secondaryText);
	        var mergedSecondaryTextStyles = secondaryTextIsAnElement ? (0, _simpleAssign2.default)(styles.secondaryText, secondaryText.props.style) : null;
	
	        secondaryTextElement = secondaryTextIsAnElement ? _react2.default.cloneElement(secondaryText, { style: mergedSecondaryTextStyles }) : _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.secondaryText) },
	          secondaryText
	        );
	      }
	      var childMenuPopover = void 0;
	      if (menuItems) {
	        childMenuPopover = _react2.default.createElement(
	          _Popover2.default,
	          {
	            animation: animation,
	            anchorOrigin: anchorOrigin,
	            anchorEl: this.state.anchorEl,
	            open: this.state.open,
	            targetOrigin: targetOrigin,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { desktop: desktop, disabled: disabled, style: nestedMenuStyle },
	            _react2.default.Children.map(menuItems, this.cloneMenuItem)
	          )
	        );
	        other.onClick = this.handleTouchTap;
	      }
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          hoverColor: this.context.muiTheme.menuItem.hoverColor,
	          innerDivStyle: mergedInnerDivStyles,
	          insetChildren: insetChildren,
	          leftIcon: leftIconElement,
	          ref: 'listItem',
	          rightIcon: rightIconElement,
	          role: 'menuitem',
	          style: mergedRootStyles
	        }),
	        children,
	        secondaryTextElement,
	        childMenuPopover
	      );
	    }
	  }]);
	  return MenuItem;
	}(_react.Component);
	
	MenuItem.muiName = 'MenuItem';
	MenuItem.defaultProps = {
	  anchorOrigin: { horizontal: 'right', vertical: 'top' },
	  checked: false,
	  desktop: false,
	  disabled: false,
	  focusState: 'none',
	  insetChildren: false,
	  targetOrigin: { horizontal: 'left', vertical: 'top' }
	};
	MenuItem.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	MenuItem.propTypes =  false ? {
	  /**
	   * Location of the anchor for the popover of nested `MenuItem`
	   * elements.
	   * Options:
	   * horizontal: [left, middle, right]
	   * vertical: [top, center, bottom].
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * If true, a left check mark will be rendered.
	   */
	  checked: _propTypes2.default.bool,
	  /**
	   * Elements passed as children to the underlying `ListItem`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   * If true, the menu item will render with compact desktop
	   * styles.
	   */
	  desktop: _propTypes2.default.bool,
	  /**
	   * If true, the menu item will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The focus state of the menu item. This prop is used to set the focus
	   * state of the underlying `ListItem`.
	   */
	  focusState: _propTypes2.default.oneOf(['none', 'focused', 'keyboard-focused']),
	  /**
	   * Override the inline-styles of the inner div.
	   */
	  innerDivStyle: _propTypes2.default.object,
	  /**
	   * If true, the children will be indented.
	   * This is only needed when there is no `leftIcon`.
	   */
	  insetChildren: _propTypes2.default.bool,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _propTypes2.default.element,
	  /**
	   * `MenuItem` elements to nest within the menu item.
	   */
	  menuItems: _propTypes2.default.node,
	  /**
	   * Callback function fired when the menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Can be used to render primary text within the menu item.
	   */
	  primaryText: _propTypes2.default.node,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _propTypes2.default.element,
	  /**
	   * Can be used to render secondary text within the menu item.
	   */
	  secondaryText: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Location on the popover of nested `MenuItem` elements that will attach
	   * to the anchor's origin.
	   * Options:
	   * horizontal: [left, middle, right]
	   * vertical: [top, center, bottom].
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * The value of the menu item.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = MenuItem;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(106);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes3 = __webpack_require__(118);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'center');
	
	  return {
	    root: {
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('450ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    }
	  };
	}
	
	var PopoverAnimationVertical = function (_Component) {
	  (0, _inherits3.default)(PopoverAnimationVertical, _Component);
	
	  function PopoverAnimationVertical() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverAnimationVertical);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationVertical.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationVertical)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverAnimationVertical, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth;
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        this.props.children
	      );
	    }
	  }]);
	  return PopoverAnimationVertical;
	}(_react.Component);
	
	PopoverAnimationVertical.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationVertical.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	PopoverAnimationVertical.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  targetOrigin: _propTypes4.default.origin.isRequired,
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = PopoverAnimationVertical;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SelectField = __webpack_require__(1537);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SelectField2.default;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _typeof2 = __webpack_require__(224);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _checkCircle = __webpack_require__(1590);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var active = _ref.active,
	      completed = _ref.completed,
	      disabled = _ref.disabled;
	  var muiTheme = _ref2.muiTheme,
	      stepper = _ref2.stepper;
	  var _muiTheme$stepper = muiTheme.stepper,
	      textColor = _muiTheme$stepper.textColor,
	      disabledTextColor = _muiTheme$stepper.disabledTextColor,
	      iconColor = _muiTheme$stepper.iconColor,
	      inactiveIconColor = _muiTheme$stepper.inactiveIconColor;
	  var baseTheme = muiTheme.baseTheme;
	  var orientation = stepper.orientation;
	
	
	  var styles = {
	    root: {
	      height: orientation === 'horizontal' ? 72 : 64,
	      color: textColor,
	      display: 'flex',
	      alignItems: 'center',
	      fontFamily: baseTheme.fontFamily,
	      fontSize: 14,
	      paddingLeft: 14,
	      paddingRight: 14
	    },
	    icon: {
	      color: iconColor,
	      display: 'block',
	      fontSize: 24,
	      width: 24,
	      height: 24
	    },
	    iconContainer: {
	      paddingRight: 8
	    }
	  };
	
	  if (active) {
	    styles.root.fontWeight = 500;
	  }
	
	  if (!completed && !active) {
	    styles.icon.color = inactiveIconColor;
	  }
	
	  if (disabled) {
	    styles.icon.color = inactiveIconColor;
	    styles.root.color = disabledTextColor;
	    styles.root.cursor = 'default';
	  }
	
	  return styles;
	};
	
	var renderIcon = function renderIcon(completed, icon, styles) {
	  var iconType = typeof icon === 'undefined' ? 'undefined' : (0, _typeof3.default)(icon);
	
	  if (iconType === 'number' || iconType === 'string') {
	    if (completed) {
	      return _react2.default.createElement(_checkCircle2.default, {
	        color: styles.icon.color,
	        style: styles.icon
	      });
	    }
	
	    return _react2.default.createElement(
	      _SvgIcon2.default,
	      { color: styles.icon.color, style: styles.icon },
	      _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	      _react2.default.createElement(
	        'text',
	        {
	          x: '12',
	          y: '16',
	          textAnchor: 'middle',
	          fontSize: '12',
	          fill: '#fff'
	        },
	        icon
	      )
	    );
	  }
	
	  return icon;
	};
	
	var StepLabel = function StepLabel(props, context) {
	  var active = props.active,
	      children = props.children,
	      completed = props.completed,
	      userIcon = props.icon,
	      iconContainerStyle = props.iconContainerStyle,
	      last = props.last,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['active', 'children', 'completed', 'icon', 'iconContainerStyle', 'last', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	  var icon = renderIcon(completed, userIcon, styles);
	
	  return _react2.default.createElement(
	    'span',
	    (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	    icon && _react2.default.createElement(
	      'span',
	      { style: prepareStyles((0, _simpleAssign2.default)(styles.iconContainer, iconContainerStyle)) },
	      icon
	    ),
	    children
	  );
	};
	
	StepLabel.muiName = 'StepLabel';
	
	StepLabel.propTypes =  false ? {
	  /**
	   * Sets active styling. Overrides disabled coloring.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * The label text node
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Sets completed styling. Overrides disabled coloring.
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * Sets disabled styling.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * Override the inline-styles of the icon container element.
	   */
	  iconContainerStyle: _propTypes2.default.object,
	  /**
	   * @ignore
	   */
	  last: _propTypes2.default.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	StepLabel.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	
	exports.default = StepLabel;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Tooltip = __webpack_require__(770);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableHeaderColumn = context.muiTheme.tableHeaderColumn;
	
	
	  return {
	    root: {
	      fontWeight: 'normal',
	      fontSize: 12,
	      paddingLeft: tableHeaderColumn.spacing,
	      paddingRight: tableHeaderColumn.spacing,
	      height: tableHeaderColumn.height,
	      textAlign: 'left',
	      whiteSpace: 'nowrap',
	      textOverflow: 'ellipsis',
	      color: tableHeaderColumn.textColor,
	      position: 'relative'
	    },
	    tooltip: {
	      boxSizing: 'border-box',
	      marginTop: tableHeaderColumn.height / 2
	    }
	  };
	}
	
	var TableHeaderColumn = function (_Component) {
	  (0, _inherits3.default)(TableHeaderColumn, _Component);
	
	  function TableHeaderColumn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableHeaderColumn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeaderColumn.__proto__ || (0, _getPrototypeOf2.default)(TableHeaderColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onMouseEnter = function () {
	      if (_this.props.tooltip !== undefined) {
	        _this.setState({ hovered: true });
	      }
	    }, _this.onMouseLeave = function () {
	      if (_this.props.tooltip !== undefined) {
	        _this.setState({ hovered: false });
	      }
	    }, _this.onClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event, _this.props.columnNumber);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableHeaderColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          columnNumber = _props.columnNumber,
	          hoverable = _props.hoverable,
	          onClick = _props.onClick,
	          onHover = _props.onHover,
	          onHoverExit = _props.onHoverExit,
	          style = _props.style,
	          tooltip = _props.tooltip,
	          tooltipStyle = _props.tooltipStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style', 'tooltip', 'tooltipStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var handlers = {
	        onMouseEnter: this.onMouseEnter,
	        onMouseLeave: this.onMouseLeave,
	        onClick: this.onClick
	      };
	
	      var tooltipNode = void 0;
	
	      if (tooltip !== undefined) {
	        tooltipNode = _react2.default.createElement(_Tooltip2.default, {
	          label: tooltip,
	          show: this.state.hovered,
	          style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyle)
	        });
	      }
	
	      return _react2.default.createElement(
	        'th',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, handlers, other),
	        tooltipNode,
	        children
	      );
	    }
	  }]);
	  return TableHeaderColumn;
	}(_react.Component);
	
	TableHeaderColumn.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TableHeaderColumn.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Number to identify the header row. This property
	   * is automatically populated when used with TableHeader.
	   */
	  columnNumber: _propTypes2.default.number,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  hoverable: _propTypes2.default.bool,
	  /** @ignore */
	  onClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  onHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  onHoverExit: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The string to supply to the tooltip. If not
	   * string is supplied no tooltip will be shown.
	   */
	  tooltip: _propTypes2.default.string,
	  /**
	   * Additional styling that can be applied to the tooltip.
	   */
	  tooltipStyle: _propTypes2.default.object
	} : {};
	exports.default = TableHeaderColumn;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(363);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isDescendant = function isDescendant(el, target) {
	  if (target !== null) {
	    return el === target || isDescendant(el, target.parentNode);
	  }
	  return false;
	};
	
	var clickAwayEvents = ['mouseup', 'touchend'];
	var bind = function bind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.on(document, event, callback);
	  });
	};
	var unbind = function unbind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.off(document, event, callback);
	  });
	};
	
	var ClickAwayListener = function (_Component) {
	  (0, _inherits3.default)(ClickAwayListener, _Component);
	
	  function ClickAwayListener() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClickAwayListener);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClickAwayListener.__proto__ || (0, _getPrototypeOf2.default)(ClickAwayListener)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      // IE11 support, which trigger the handleClickAway even after the unbind
	      if (_this.isCurrentlyMounted) {
	        var el = _reactDom2.default.findDOMNode(_this);
	
	        if (document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
	          _this.props.onClickAway(event);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClickAwayListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.isCurrentlyMounted = true;
	      if (this.props.onClickAway) {
	        bind(this.handleClickAway);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.onClickAway !== this.props.onClickAway) {
	        unbind(this.handleClickAway);
	        if (this.props.onClickAway) {
	          bind(this.handleClickAway);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.isCurrentlyMounted = false;
	      unbind(this.handleClickAway);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return ClickAwayListener;
	}(_react.Component);
	
	ClickAwayListener.propTypes =  false ? {
	  children: _propTypes2.default.element,
	  onClickAway: _propTypes2.default.func
	} : {};
	exports.default = ClickAwayListener;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(165);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(99);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(498);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(771);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	var _Paper = __webpack_require__(106);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      cursor: props.disabled ? 'not-allowed' : 'pointer',
	      position: 'relative',
	      overflow: 'visible',
	      display: 'table',
	      height: 'auto',
	      width: '100%'
	    },
	    input: {
	      position: 'absolute',
	      cursor: 'inherit',
	      pointerEvents: 'all',
	      opacity: 0,
	      width: '100%',
	      height: '100%',
	      zIndex: 2,
	      left: 0,
	      boxSizing: 'border-box',
	      padding: 0,
	      margin: 0
	    },
	    controls: {
	      display: 'flex',
	      width: '100%',
	      height: '100%'
	    },
	    label: {
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      width: 'calc(100% - 60px)',
	      lineHeight: '24px',
	      color: baseTheme.palette.textColor,
	      fontFamily: baseTheme.fontFamily
	    },
	    wrap: {
	      transition: _transitions2.default.easeOut(),
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      flexShrink: 0,
	      width: 60 - baseTheme.spacing.desktopGutterLess,
	      marginRight: props.labelPosition === 'right' ? baseTheme.spacing.desktopGutterLess : 0,
	      marginLeft: props.labelPosition === 'left' ? baseTheme.spacing.desktopGutterLess : 0
	    },
	    ripple: {
	      color: props.rippleColor || baseTheme.palette.primary1Color,
	      height: '200%',
	      width: '200%',
	      top: -12,
	      left: -12
	    }
	  };
	}
	
	var EnhancedSwitch = function (_Component) {
	  (0, _inherits3.default)(EnhancedSwitch, _Component);
	
	  function EnhancedSwitch() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedSwitch.__proto__ || (0, _getPrototypeOf2.default)(EnhancedSwitch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleChange = function (event) {
	      _this.tabPressed = false;
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      var isInputChecked = _this.refs.checkbox.checked;
	
	      if (!_this.props.hasOwnProperty('checked') && _this.props.onParentShouldUpdate) {
	        _this.props.onParentShouldUpdate(isInputChecked);
	      }
	
	      if (_this.props.onSwitch) {
	        _this.props.onSwitch(event, isInputChecked);
	      }
	    }, _this.handleKeyDown = function (event) {
	      var code = (0, _keycode2.default)(event);
	
	      if (code === 'tab') {
	        _this.tabPressed = true;
	      }
	      if (_this.state.isKeyboardFocused && code === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleKeyUp = function (event) {
	      if (_this.state.isKeyboardFocused && (0, _keycode2.default)(event) === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.refs.touchRipple.start(event);
	      }
	    }, _this.handleMouseUp = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleMouseLeave = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleTouchStart = function (event) {
	      _this.refs.touchRipple.start(event);
	    }, _this.handleTouchEnd = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      // setTimeout is needed becuase the focus event fires first
	      // Wait so that we can capture if this was a keyboard focus
	      // or touch focus
	      setTimeout(function () {
	        if (_this.tabPressed) {
	          _this.setState({
	            isKeyboardFocused: true
	          });
	        }
	      }, 150);
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedSwitch, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var inputNode = this.refs.checkbox;
	      if ((!this.props.switched || inputNode.checked !== this.props.switched) && this.props.onParentShouldUpdate) {
	        this.props.onParentShouldUpdate(inputNode.checked);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var hasCheckedProp = nextProps.hasOwnProperty('checked');
	      var hasNewDefaultProp = nextProps.hasOwnProperty('defaultChecked') && nextProps.defaultChecked !== this.props.defaultChecked;
	
	      if (hasCheckedProp || hasNewDefaultProp) {
	        var switched = nextProps.checked || nextProps.defaultChecked || false;
	
	        this.setState({
	          switched: switched
	        });
	
	        if (this.props.onParentShouldUpdate && switched !== this.props.switched) {
	          this.props.onParentShouldUpdate(switched);
	        }
	      }
	    }
	  }, {
	    key: 'isSwitched',
	    value: function isSwitched() {
	      return this.refs.checkbox.checked;
	    }
	
	    // no callback here because there is no event
	
	  }, {
	    key: 'setSwitched',
	    value: function setSwitched(newSwitchedValue) {
	      if (!this.props.hasOwnProperty('checked') || this.props.checked === false) {
	        if (this.props.onParentShouldUpdate) {
	          this.props.onParentShouldUpdate(newSwitchedValue);
	        }
	        this.refs.checkbox.checked = newSwitchedValue;
	      } else {
	         false ? (0, _warning2.default)(false, 'Material-UI: Cannot call set method while checked is defined as a property.') : void 0;
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.checkbox.value;
	    }
	
	    // Checkbox inputs only use SPACE to change their state. Using ENTER will
	    // update the ui but not the input.
	
	
	    /**
	     * Because both the ripples and the checkbox input cannot share pointer
	     * events, the checkbox input takes control of pointer events and calls
	     * ripple animations manually.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          value = _props.value,
	          checked = _props.checked,
	          iconStyle = _props.iconStyle,
	          inputStyle = _props.inputStyle,
	          inputType = _props.inputType,
	          label = _props.label,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          onSwitch = _props.onSwitch,
	          onBlur = _props.onBlur,
	          onFocus = _props.onFocus,
	          onMouseUp = _props.onMouseUp,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          onTouchEnd = _props.onTouchEnd,
	          onParentShouldUpdate = _props.onParentShouldUpdate,
	          disabled = _props.disabled,
	          disableTouchRipple = _props.disableTouchRipple,
	          disableFocusRipple = _props.disableFocusRipple,
	          className = _props.className,
	          rippleColor = _props.rippleColor,
	          rippleStyle = _props.rippleStyle,
	          style = _props.style,
	          switched = _props.switched,
	          switchElement = _props.switchElement,
	          thumbStyle = _props.thumbStyle,
	          trackStyle = _props.trackStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['name', 'value', 'checked', 'iconStyle', 'inputStyle', 'inputType', 'label', 'labelStyle', 'labelPosition', 'onSwitch', 'onBlur', 'onFocus', 'onMouseUp', 'onMouseDown', 'onMouseLeave', 'onTouchStart', 'onTouchEnd', 'onParentShouldUpdate', 'disabled', 'disableTouchRipple', 'disableFocusRipple', 'className', 'rippleColor', 'rippleStyle', 'style', 'switched', 'switchElement', 'thumbStyle', 'trackStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var wrapStyles = (0, _simpleAssign2.default)(styles.wrap, iconStyle);
	      var mergedRippleStyle = (0, _simpleAssign2.default)(styles.ripple, rippleStyle);
	
	      if (thumbStyle) {
	        wrapStyles.marginLeft /= 2;
	        wrapStyles.marginRight /= 2;
	      }
	
	      var labelElement = label && _react2.default.createElement(
	        'label',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	        label
	      );
	
	      var showTouchRipple = !disabled && !disableTouchRipple;
	      var showFocusRipple = !disabled && !disableFocusRipple;
	
	      var touchRipple = _react2.default.createElement(_TouchRipple2.default, {
	        ref: 'touchRipple',
	        key: 'touchRipple',
	        style: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        centerRipple: true
	      });
	
	      var focusRipple = _react2.default.createElement(_FocusRipple2.default, {
	        key: 'focusRipple',
	        innerStyle: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        show: this.state.isKeyboardFocused
	      });
	
	      var ripples = [showTouchRipple ? touchRipple : null, showFocusRipple ? focusRipple : null];
	
	      var touchHandlers = showTouchRipple ? {
	        onMouseUp: this.handleMouseUp,
	        onMouseDown: this.handleMouseDown,
	        onMouseLeave: this.handleMouseLeave,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd
	      } : {};
	
	      var inputElement = _react2.default.createElement('input', (0, _extends3.default)({}, other, {
	        ref: 'checkbox',
	        type: inputType,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.input, inputStyle)),
	        name: name,
	        value: value,
	        checked: this.state.switched,
	        disabled: disabled,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onChange: this.handleChange
	      }, touchHandlers));
	
	      // If toggle component (indicated by whether the style includes thumb) manually lay out
	      // elements in order to nest ripple elements
	      var switchOrThumbElement = !thumbStyle ? _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        switchElement,
	        ripples
	      ) : _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, trackStyle)) }),
	        _react2.default.createElement(
	          _Paper2.default,
	          { style: thumbStyle, zDepth: 1, circle: true },
	          ' ',
	          ripples,
	          ' '
	        )
	      );
	
	      var elementsInOrder = labelPosition === 'right' ? _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        switchOrThumbElement,
	        labelElement
	      ) : _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        labelElement,
	        switchOrThumbElement
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'root', className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyDown: this.handleKeyDown,
	          onKeyUp: this.handleKeyUp
	        }),
	        inputElement,
	        elementsInOrder
	      );
	    }
	  }]);
	  return EnhancedSwitch;
	}(_react.Component);
	
	EnhancedSwitch.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	EnhancedSwitch.propTypes =  false ? {
	  checked: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  defaultChecked: _propTypes2.default.bool,
	  disableFocusRipple: _propTypes2.default.bool,
	  disableTouchRipple: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  iconStyle: _propTypes2.default.object,
	  inputStyle: _propTypes2.default.object,
	  inputType: _propTypes2.default.string.isRequired,
	  label: _propTypes2.default.node,
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  labelStyle: _propTypes2.default.object,
	  name: _propTypes2.default.string,
	  onBlur: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onMouseDown: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onMouseUp: _propTypes2.default.func,
	  onParentShouldUpdate: _propTypes2.default.func,
	  onSwitch: _propTypes2.default.func,
	  onTouchEnd: _propTypes2.default.func,
	  onTouchStart: _propTypes2.default.func,
	  rippleColor: _propTypes2.default.string,
	  rippleStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  switchElement: _propTypes2.default.element.isRequired,
	  switched: _propTypes2.default.bool.isRequired,
	  thumbStyle: _propTypes2.default.object,
	  trackStyle: _propTypes2.default.object,
	  value: _propTypes2.default.any
	} : {};
	exports.default = EnhancedSwitch;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(212);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(213);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ScaleIn = __webpack_require__(1570);
	
	var _ScaleIn2 = _interopRequireDefault(_ScaleIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pulsateDuration = 750;
	
	var FocusRipple = function (_Component) {
	  (0, _inherits3.default)(FocusRipple, _Component);
	
	  function FocusRipple() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FocusRipple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FocusRipple.__proto__ || (0, _getPrototypeOf2.default)(FocusRipple)).call.apply(_ref, [this].concat(args))), _this), _this.pulsate = function () {
	      var innerCircle = _reactDom2.default.findDOMNode(_this.refs.innerCircle);
	      if (!innerCircle) return;
	
	      var startScale = 'scale(1)';
	      var endScale = 'scale(0.85)';
	      var currentScale = innerCircle.style.transform || startScale;
	      var nextScale = currentScale === startScale ? endScale : startScale;
	
	      _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale);
	      _this.timeout = setTimeout(_this.pulsate, pulsateDuration);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FocusRipple, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      } else {
	        if (this.timeout) clearTimeout(this.timeout);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'getRippleElement',
	    value: function getRippleElement(props) {
	      var color = props.color,
	          innerStyle = props.innerStyle,
	          opacity = props.opacity;
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          ripple = _context$muiTheme.ripple;
	
	
	      var innerStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        opacity: opacity ? opacity : 0.16,
	        backgroundColor: color || ripple.color,
	        transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
	      }, innerStyle);
	
	      return _react2.default.createElement('div', { ref: 'innerCircle', style: prepareStyles((0, _simpleAssign2.default)({}, innerStyles)) });
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
	      var height = el.offsetHeight;
	      var width = el.offsetWidth;
	      var size = Math.max(height, width);
	
	      var oldTop = 0;
	      // For browsers that don't support endsWith()
	      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
	        oldTop = parseInt(el.style.top);
	      }
	      el.style.height = size + 'px';
	      el.style.top = height / 2 - size / 2 + oldTop + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          show = _props.show,
	          style = _props.style;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        height: '100%',
	        width: '100%',
	        position: 'absolute',
	        top: 0,
	        left: 0
	      }, style);
	
	      var ripple = show ? this.getRippleElement(this.props) : null;
	
	      return _react2.default.createElement(
	        _ScaleIn2.default,
	        {
	          maxScale: 0.85,
	          style: mergedRootStyles
	        },
	        ripple
	      );
	    }
	  }]);
	  return FocusRipple;
	}(_react.Component);
	
	FocusRipple.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	FocusRipple.propTypes =  false ? {
	  color: _propTypes2.default.string,
	  innerStyle: _propTypes2.default.object,
	  opacity: _propTypes2.default.number,
	  show: _propTypes2.default.bool,
	  style: _propTypes2.default.object
	} : {};
	exports.default = FocusRipple;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(290);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _SlideInChild = __webpack_require__(1572);
	
	var _SlideInChild2 = _interopRequireDefault(_SlideInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideIn = function (_Component) {
	  (0, _inherits3.default)(SlideIn, _Component);
	
	  function SlideIn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SlideIn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SlideIn.__proto__ || (0, _getPrototypeOf2.default)(SlideIn)).call.apply(_ref, [this].concat(args))), _this), _this.getLeaveDirection = function () {
	      return _this.props.direction;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SlideIn, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          children = _props.children,
	          childStyle = _props.childStyle,
	          direction = _props.direction,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['enterDelay', 'children', 'childStyle', 'direction', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _SlideInChild2.default,
	          {
	            key: child.key,
	            direction: direction,
	            enterDelay: enterDelay,
	            getLeaveDirection: _this2.getLeaveDirection,
	            style: childStyle
	          },
	          child
	        );
	      }, this);
	
	      return _react2.default.createElement(
	        _TransitionGroup2.default,
	        (0, _extends3.default)({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	  return SlideIn;
	}(_react.Component);
	
	SlideIn.defaultProps = {
	  enterDelay: 0,
	  direction: 'left'
	};
	SlideIn.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	SlideIn.propTypes =  false ? {
	  childStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  direction: _propTypes2.default.oneOf(['left', 'right', 'up', 'down']),
	  enterDelay: _propTypes2.default.number,
	  style: _propTypes2.default.object
	} : {};
	exports.default = SlideIn;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLens = function ImageLens(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z' })
	  );
	};
	ImageLens = (0, _pure2.default)(ImageLens);
	ImageLens.displayName = 'ImageLens';
	ImageLens.muiName = 'SvgIcon';
	
	exports.default = ImageLens;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(368);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _Button = __webpack_require__(292);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  vertical: _propTypes2.default.bool,
	  justified: _propTypes2.default.bool,
	
	  /**
	   * Display block buttons; only useful when used with the "vertical" prop.
	   * @type {bool}
	   */
	  block: (0, _all2.default)(_propTypes2.default.bool, function (_ref) {
	    var block = _ref.block,
	        vertical = _ref.vertical;
	    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
	  })
	};
	
	var defaultProps = {
	  block: false,
	  justified: false,
	  vertical: false
	};
	
	var ButtonGroup = function (_React$Component) {
	  (0, _inherits3.default)(ButtonGroup, _React$Component);
	
	  function ButtonGroup() {
	    (0, _classCallCheck3.default)(this, ButtonGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonGroup.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        block = _props.block,
	        justified = _props.justified,
	        vertical = _props.vertical,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['block', 'justified', 'vertical', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps)] = !vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'vertical')] = vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2[(0, _bootstrapUtils.prefix)(_Button2.default.defaultProps, 'block')] = block, _extends2));
	
	    return _react2.default.createElement('div', (0, _extends4.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ButtonGroup;
	}(_react2.default.Component);
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('btn-group', ButtonGroup);
	module.exports = exports['default'];

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  label: _propTypes2.default.string.isRequired,
	  onClick: _propTypes2.default.func
	};
	
	var defaultProps = {
	  label: 'Close'
	};
	
	var CloseButton = function (_React$Component) {
	  (0, _inherits3.default)(CloseButton, _React$Component);
	
	  function CloseButton() {
	    (0, _classCallCheck3.default)(this, CloseButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  CloseButton.prototype.render = function render() {
	    var _props = this.props,
	        label = _props.label,
	        onClick = _props.onClick;
	
	    return _react2.default.createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close',
	        onClick: onClick
	      },
	      _react2.default.createElement(
	        'span',
	        { 'aria-hidden': 'true' },
	        '\xD7'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      )
	    );
	  };
	
	  return CloseButton;
	}(_react2.default.Component);
	
	CloseButton.propTypes = propTypes;
	CloseButton.defaultProps = defaultProps;
	
	exports.default = CloseButton;
	module.exports = exports['default'];

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__(331);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(814);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _capitalize = __webpack_require__(811);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _createChainedFunction = __webpack_require__(90);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	};
	
	// reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	function triggerBrowserReflow(node) {
	  node.offsetHeight; // eslint-disable-line no-unused-expressions
	}
	
	function getDimensionValue(dimension, elem) {
	  var value = elem['offset' + (0, _capitalize2.default)(dimension)];
	  var margins = MARGINS[dimension];
	
	  return value + parseInt((0, _style2.default)(elem, margins[0]), 10) + parseInt((0, _style2.default)(elem, margins[1]), 10);
	}
	
	var propTypes = {
	  /**
	   * Show the component; triggers the expand or collapse animation
	   */
	  in: _propTypes2.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is collapsed
	   */
	  unmountOnExit: _propTypes2.default.bool,
	
	  /**
	   * Run the expand animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2.default.bool,
	
	  /**
	   * Duration of the collapse animation in milliseconds, to ensure that
	   * finishing callbacks are fired even if the original browser transition end
	   * events are canceled
	   */
	  timeout: _propTypes2.default.number,
	
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * The dimension used when collapsing, or a function that returns the
	   * dimension
	   *
	   * _Note: Bootstrap only partially supports 'width'!
	   * You will need to supply your own CSS animation for the `.width` CSS class._
	   */
	  dimension: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['height', 'width']), _propTypes2.default.func]),
	
	  /**
	   * Function that returns the height or width of the animating DOM node
	   *
	   * Allows for providing some custom logic for how much the Collapse component
	   * should animate in its specified dimension. Called with the current
	   * dimension prop value and the DOM node.
	   */
	  getDimensionValue: _propTypes2.default.func,
	
	  /**
	   * ARIA role of collapsible element
	   */
	  role: _propTypes2.default.string
	};
	
	var defaultProps = {
	  in: false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  dimension: 'height',
	  getDimensionValue: getDimensionValue
	};
	
	var Collapse = function (_React$Component) {
	  (0, _inherits3.default)(Collapse, _React$Component);
	
	  function Collapse(props, context) {
	    (0, _classCallCheck3.default)(this, Collapse);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleEntered = _this.handleEntered.bind(_this);
	    _this.handleExit = _this.handleExit.bind(_this);
	    _this.handleExiting = _this.handleExiting.bind(_this);
	    return _this;
	  }
	
	  Collapse.prototype._dimension = function _dimension() {
	    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
	  };
	
	  // for testing
	
	
	  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
	    return elem['scroll' + (0, _capitalize2.default)(dimension)] + 'px';
	  };
	
	  /* -- Expanding -- */
	
	
	  Collapse.prototype.handleEnter = function handleEnter(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.handleEntered = function handleEntered(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = null;
	  };
	
	  Collapse.prototype.handleEntering = function handleEntering(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
	  };
	
	  /* -- Collapsing -- */
	
	
	  Collapse.prototype.handleExit = function handleExit(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
	    triggerBrowserReflow(elem);
	  };
	
	  Collapse.prototype.handleExiting = function handleExiting(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.render = function render() {
	    var _props = this.props,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className']);
	
	
	    delete props.dimension;
	    delete props.getDimensionValue;
	
	    var handleEnter = (0, _createChainedFunction2.default)(this.handleEnter, onEnter);
	    var handleEntering = (0, _createChainedFunction2.default)(this.handleEntering, onEntering);
	    var handleEntered = (0, _createChainedFunction2.default)(this.handleEntered, onEntered);
	    var handleExit = (0, _createChainedFunction2.default)(this.handleExit, onExit);
	    var handleExiting = (0, _createChainedFunction2.default)(this.handleExiting, onExiting);
	
	    var classes = {
	      width: this._dimension() === 'width'
	    };
	
	    return _react2.default.createElement(_Transition2.default, (0, _extends3.default)({}, props, {
	      'aria-expanded': props.role ? props.in : null,
	      className: (0, _classnames2.default)(className, classes),
	      exitedClassName: 'collapse',
	      exitingClassName: 'collapsing',
	      enteredClassName: 'collapse in',
	      enteringClassName: 'collapsing',
	      onEnter: handleEnter,
	      onEntering: handleEntering,
	      onEntered: handleEntered,
	      onExit: handleExit,
	      onExiting: handleExiting
	    }));
	  };
	
	  return Collapse;
	}(_react2.default.Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	
	exports.default = Collapse;
	module.exports = exports['default'];

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
	   */
	  glyph: _propTypes2.default.string.isRequired
	};
	
	var Glyphicon = function (_React$Component) {
	  (0, _inherits3.default)(Glyphicon, _React$Component);
	
	  function Glyphicon() {
	    (0, _classCallCheck3.default)(this, Glyphicon);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Glyphicon.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        glyph = _props.glyph,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['glyph', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, glyph)] = true, _extends2));
	
	    return _react2.default.createElement('span', (0, _extends4.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Glyphicon;
	}(_react2.default.Component);
	
	Glyphicon.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('glyphicon', Glyphicon);
	module.exports = exports['default'];

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uncontrollable = __webpack_require__(221);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TAB = 'tab';
	var PANE = 'pane';
	
	var idPropType = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var propTypes = {
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: function id(props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(undefined, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
	      }
	    }
	
	    return error;
	  },
	
	
	  /**
	   * A function that takes an `eventKey` and `type` and returns a unique id for
	   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
	   * function, meaning it should always return the _same_ id for the same set
	   * of inputs. The default value requires that an `id` to be set for the
	   * `<TabContainer>`.
	   *
	   * The `type` argument will either be `"tab"` or `"pane"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _propTypes2.default.func,
	
	  /**
	   * A callback fired when a tab is selected.
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * The `eventKey` of the currently active tab.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2.default.any
	};
	
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2.default.shape({
	    activeKey: _propTypes2.default.any,
	    onSelect: _propTypes2.default.func.isRequired,
	    getTabId: _propTypes2.default.func.isRequired,
	    getPaneId: _propTypes2.default.func.isRequired
	  })
	};
	
	var TabContainer = function (_React$Component) {
	  (0, _inherits3.default)(TabContainer, _React$Component);
	
	  function TabContainer() {
	    (0, _classCallCheck3.default)(this, TabContainer);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  TabContainer.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        activeKey = _props.activeKey,
	        onSelect = _props.onSelect,
	        generateChildId = _props.generateChildId,
	        id = _props.id;
	
	
	    var getId = generateChildId || function (key, type) {
	      return id ? id + '-' + type + '-' + key : null;
	    };
	
	    return {
	      $bs_tabContainer: {
	        activeKey: activeKey,
	        onSelect: onSelect,
	        getTabId: function getTabId(key) {
	          return getId(key, TAB);
	        },
	        getPaneId: function getPaneId(key) {
	          return getId(key, PANE);
	        }
	      }
	    };
	  };
	
	  TabContainer.prototype.render = function render() {
	    var _props2 = this.props,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['children']);
	
	
	    delete props.generateChildId;
	    delete props.onSelect;
	    delete props.activeKey;
	
	    return _react2.default.cloneElement(_react2.default.Children.only(children), props);
	  };
	
	  return TabContainer;
	}(_react2.default.Component);
	
	TabContainer.propTypes = propTypes;
	TabContainer.childContextTypes = childContextTypes;
	
	exports.default = (0, _uncontrollable2.default)(TabContainer, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default,
	
	  /**
	   * Sets a default animation strategy for all children `<TabPane>`s. Use
	   * `false` to disable, `true` to enable the default `<Fade>` animation or any
	   * `<Transition>` component.
	   */
	  animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when they are no longer visible
	   */
	  unmountOnExit: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2.default.shape({
	    activeKey: _propTypes2.default.any
	  })
	};
	
	var childContextTypes = {
	  $bs_tabContent: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	    activeKey: _propTypes2.default.any,
	    mountOnEnter: _propTypes2.default.bool,
	    unmountOnExit: _propTypes2.default.bool,
	    onPaneEnter: _propTypes2.default.func.isRequired,
	    onPaneExited: _propTypes2.default.func.isRequired,
	    exiting: _propTypes2.default.bool.isRequired
	  })
	};
	
	var TabContent = function (_React$Component) {
	  (0, _inherits3.default)(TabContent, _React$Component);
	
	  function TabContent(props, context) {
	    (0, _classCallCheck3.default)(this, TabContent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
	    _this.handlePaneExited = _this.handlePaneExited.bind(_this);
	
	    // Active entries in state will be `null` unless `animation` is set. Need
	    // to track active child in case keys swap and the active child changes
	    // but the active key does not.
	    _this.state = {
	      activeKey: null,
	      activeChild: null
	    };
	    return _this;
	  }
	
	  TabContent.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit;
	
	
	    var stateActiveKey = this.state.activeKey;
	    var containerActiveKey = this.getContainerActiveKey();
	
	    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
	    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
	
	    return {
	      $bs_tabContent: {
	        bsClass: bsClass,
	        animation: animation,
	        activeKey: activeKey,
	        mountOnEnter: mountOnEnter,
	        unmountOnExit: unmountOnExit,
	        onPaneEnter: this.handlePaneEnter,
	        onPaneExited: this.handlePaneExited,
	        exiting: exiting
	      }
	    };
	  };
	
	  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.animation && this.state.activeChild) {
	      this.setState({ activeKey: null, activeChild: null });
	    }
	  };
	
	  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
	    var tabContainer = this.context.$bs_tabContainer;
	    return tabContainer && tabContainer.activeKey;
	  };
	
	  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
	    if (!this.props.animation) {
	      return false;
	    }
	
	    // It's possible that this child should be transitioning out.
	    if (childKey !== this.getContainerActiveKey()) {
	      return false;
	    }
	
	    this.setState({
	      activeKey: childKey,
	      activeChild: child
	    });
	
	    return true;
	  };
	
	  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
	    // This might happen as everything is unmounting.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState(function (_ref) {
	      var activeChild = _ref.activeChild;
	
	      if (activeChild !== child) {
	        return null;
	      }
	
	      return {
	        activeKey: null,
	        activeChild: null
	      };
	    });
	  };
	
	  TabContent.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        className = _props2.className,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['componentClass', 'className']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'content'))
	    }));
	  };
	
	  return TabContent;
	}(_react2.default.Component);
	
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;
	TabContent.contextTypes = contextTypes;
	TabContent.childContextTypes = childContextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('tab', TabContent);
	module.exports = exports['default'];

/***/ }),
/* 507 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FILE = exports.FILE = '__NATIVE_FILE__';
	var URL = exports.URL = '__NATIVE_URL__';
	var TEXT = exports.TEXT = '__NATIVE_TEXT__';

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DragDropContext = __webpack_require__(818);
	
	Object.defineProperty(exports, 'DragDropContext', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragDropContext).default;
	  }
	});
	
	var _DragDropContextProvider = __webpack_require__(1731);
	
	Object.defineProperty(exports, 'DragDropContextProvider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragDropContextProvider).default;
	  }
	});
	
	var _DragLayer = __webpack_require__(1732);
	
	Object.defineProperty(exports, 'DragLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragLayer).default;
	  }
	});
	
	var _DragSource = __webpack_require__(1733);
	
	Object.defineProperty(exports, 'DragSource', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragSource).default;
	  }
	});
	
	var _DropTarget = __webpack_require__(1734);
	
	Object.defineProperty(exports, 'DropTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropTarget).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 509 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = shallowEqual;
	function shallowEqual(objA, objB) {
		if (objA === objB) {
			return true;
		}
	
		var keysA = Object.keys(objA);
		var keysB = Object.keys(objB);
	
		if (keysA.length !== keysB.length) {
			return false;
		}
	
		// Test for A's keys different from B.
		var hasOwn = Object.prototype.hasOwnProperty;
		for (var i = 0; i < keysA.length; i += 1) {
			if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
				return false;
			}
	
			var valA = objA[keysA[i]];
			var valB = objB[keysA[i]];
	
			if (valA !== valB) {
				return false;
			}
		}
	
		return true;
	}

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(245);
	var Danger = __webpack_require__(1749);
	var ReactDOMComponentTree = __webpack_require__(85);
	var ReactInstrumentation = __webpack_require__(141);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(519);
	var setInnerHTML = __webpack_require__(378);
	var setTextContent = __webpack_require__(843);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 511 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var invariant = __webpack_require__(28);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var ReactErrorUtils = __webpack_require__(517);
	
	var invariant = __webpack_require__(28);
	var warning = __webpack_require__(61);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 514 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var ReactPropTypesSecret = __webpack_require__(1778);
	var propTypesFactory = __webpack_require__(785);
	
	var React = __webpack_require__(252);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(28);
	var warning = __webpack_require__(61);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var invariant = __webpack_require__(28);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var ReactCurrentOwner = __webpack_require__(169);
	var ReactInstanceMap = __webpack_require__(295);
	var ReactInstrumentation = __webpack_require__(141);
	var ReactUpdates = __webpack_require__(155);
	
	var invariant = __webpack_require__(28);
	var warning = __webpack_require__(61);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 521 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(105);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 524 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var emptyFunction = __webpack_require__(113);
	var warning = __webpack_require__(61);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSearch = function FaSearch(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm27.2 18.6q0-4.2-2.9-7.1t-7.1-2.9-7 2.9-3 7.1 2.9 7 7.1 3 7.1-3 2.9-7z m11.4 18.5q0 1.2-0.8 2.1t-2 0.8q-1.2 0-2-0.8l-7.7-7.7q-4 2.8-8.9 2.8-3.2 0-6.1-1.3t-5-3.3-3.4-5-1.2-6.1 1.2-6.1 3.4-5.1 5-3.3 6.1-1.2 6.1 1.2 5 3.3 3.4 5.1 1.2 6.1q0 4.9-2.7 8.9l7.6 7.6q0.8 0.9 0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaSearch;
	module.exports = exports['default'];

/***/ }),
/* 527 */,
/* 528 */
/***/ (function(module, exports) {

	var CONSTANTS = {
	
	  // Positions
	  positions: {
	    tl: 'tl',
	    tr: 'tr',
	    tc: 'tc',
	    bl: 'bl',
	    br: 'br',
	    bc: 'bc'
	  },
	
	  // Levels
	  levels: {
	    success: 'success',
	    error: 'error',
	    warning: 'warning',
	    info: 'info'
	  },
	
	  // Notification defaults
	  notification: {
	    title: null,
	    message: null,
	    level: null,
	    position: 'tr',
	    autoDismiss: 5,
	    dismissible: 'both',
	    action: null
	  }
	};
	
	
	module.exports = CONSTANTS;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.matchesSelector = matchesSelector;
	exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
	exports.addEvent = addEvent;
	exports.removeEvent = removeEvent;
	exports.outerHeight = outerHeight;
	exports.outerWidth = outerWidth;
	exports.innerHeight = innerHeight;
	exports.innerWidth = innerWidth;
	exports.offsetXYFromParent = offsetXYFromParent;
	exports.createCSSTransform = createCSSTransform;
	exports.createSVGTransform = createSVGTransform;
	exports.getTranslation = getTranslation;
	exports.getTouch = getTouch;
	exports.getTouchIdentifier = getTouchIdentifier;
	exports.addUserSelectStyles = addUserSelectStyles;
	exports.removeUserSelectStyles = removeUserSelectStyles;
	exports.addClassName = addClassName;
	exports.removeClassName = removeClassName;
	
	var _shims = __webpack_require__(380);
	
	var _getPrefix = _interopRequireWildcard(__webpack_require__(1851));
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var matchesSelectorFunc = '';
	
	function matchesSelector(el
	/*: Node*/
	, selector
	/*: string*/
	)
	/*: boolean*/
	{
	  if (!matchesSelectorFunc) {
	    matchesSelectorFunc = (0, _shims.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
	      // $FlowIgnore: Doesn't think elements are indexable
	      return (0, _shims.isFunction)(el[method]);
	    });
	  } // Might not be found entirely (not an Element?) - in that case, bail
	  // $FlowIgnore: Doesn't think elements are indexable
	
	
	  if (!(0, _shims.isFunction)(el[matchesSelectorFunc])) return false; // $FlowIgnore: Doesn't think elements are indexable
	
	  return el[matchesSelectorFunc](selector);
	} // Works up the tree to the draggable itself attempting to match selector.
	
	
	function matchesSelectorAndParentsTo(el
	/*: Node*/
	, selector
	/*: string*/
	, baseNode
	/*: Node*/
	)
	/*: boolean*/
	{
	  var node = el;
	
	  do {
	    if (matchesSelector(node, selector)) return true;
	    if (node === baseNode) return false;
	    node = node.parentNode;
	  } while (node);
	
	  return false;
	}
	
	function addEvent(el
	/*: ?Node*/
	, event
	/*: string*/
	, handler
	/*: Function*/
	, inputOptions
	/*: Object*/
	)
	/*: void*/
	{
	  if (!el) return;
	
	  var options = _objectSpread({
	    capture: true
	  }, inputOptions); // $FlowIgnore[method-unbinding]
	
	
	  if (el.addEventListener) {
	    el.addEventListener(event, handler, options);
	  } else if (el.attachEvent) {
	    el.attachEvent('on' + event, handler);
	  } else {
	    // $FlowIgnore: Doesn't think elements are indexable
	    el['on' + event] = handler;
	  }
	}
	
	function removeEvent(el
	/*: ?Node*/
	, event
	/*: string*/
	, handler
	/*: Function*/
	, inputOptions
	/*: Object*/
	)
	/*: void*/
	{
	  if (!el) return;
	
	  var options = _objectSpread({
	    capture: true
	  }, inputOptions); // $FlowIgnore[method-unbinding]
	
	
	  if (el.removeEventListener) {
	    el.removeEventListener(event, handler, options);
	  } else if (el.detachEvent) {
	    el.detachEvent('on' + event, handler);
	  } else {
	    // $FlowIgnore: Doesn't think elements are indexable
	    el['on' + event] = null;
	  }
	}
	
	function outerHeight(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  // This is deliberately excluding margin for our calculations, since we are using
	  // offsetTop which is including margin. See getBoundPosition
	  var height = node.clientHeight;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  height += (0, _shims.int)(computedStyle.borderTopWidth);
	  height += (0, _shims.int)(computedStyle.borderBottomWidth);
	  return height;
	}
	
	function outerWidth(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  // This is deliberately excluding margin for our calculations, since we are using
	  // offsetLeft which is including margin. See getBoundPosition
	  var width = node.clientWidth;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  width += (0, _shims.int)(computedStyle.borderLeftWidth);
	  width += (0, _shims.int)(computedStyle.borderRightWidth);
	  return width;
	}
	
	function innerHeight(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  var height = node.clientHeight;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  height -= (0, _shims.int)(computedStyle.paddingTop);
	  height -= (0, _shims.int)(computedStyle.paddingBottom);
	  return height;
	}
	
	function innerWidth(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  var width = node.clientWidth;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  width -= (0, _shims.int)(computedStyle.paddingLeft);
	  width -= (0, _shims.int)(computedStyle.paddingRight);
	  return width;
	}
	/*:: interface EventWithOffset {
	  clientX: number, clientY: number
	}*/
	
	
	// Get from offsetParent
	function offsetXYFromParent(evt
	/*: EventWithOffset*/
	, offsetParent
	/*: HTMLElement*/
	, scale
	/*: number*/
	)
	/*: ControlPosition*/
	{
	  var isBody = offsetParent === offsetParent.ownerDocument.body;
	  var offsetParentRect = isBody ? {
	    left: 0,
	    top: 0
	  } : offsetParent.getBoundingClientRect();
	  var x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
	  var y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
	  return {
	    x: x,
	    y: y
	  };
	}
	
	function createCSSTransform(controlPos
	/*: ControlPosition*/
	, positionOffset
	/*: PositionOffsetControlPosition*/
	)
	/*: Object*/
	{
	  var translation = getTranslation(controlPos, positionOffset, 'px');
	  return _defineProperty({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix.default), translation);
	}
	
	function createSVGTransform(controlPos
	/*: ControlPosition*/
	, positionOffset
	/*: PositionOffsetControlPosition*/
	)
	/*: string*/
	{
	  var translation = getTranslation(controlPos, positionOffset, '');
	  return translation;
	}
	
	function getTranslation(_ref2, positionOffset
	/*: PositionOffsetControlPosition*/
	, unitSuffix
	/*: string*/
	)
	/*: string*/
	{
	  var x = _ref2.x,
	      y = _ref2.y;
	  var translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
	
	  if (positionOffset) {
	    var defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
	    var defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
	    translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
	  }
	
	  return translation;
	}
	
	function getTouch(e
	/*: MouseTouchEvent*/
	, identifier
	/*: number*/
	)
	/*: ?{clientX: number, clientY: number}*/
	{
	  return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, function (t) {
	    return identifier === t.identifier;
	  }) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, function (t) {
	    return identifier === t.identifier;
	  });
	}
	
	function getTouchIdentifier(e
	/*: MouseTouchEvent*/
	)
	/*: ?number*/
	{
	  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
	  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
	} // User-select Hacks:
	//
	// Useful for preventing blue highlights all over everything when dragging.
	// Note we're passing `document` b/c we could be iframed
	
	
	function addUserSelectStyles(doc
	/*: ?Document*/
	) {
	  if (!doc) return;
	  var styleEl = doc.getElementById('react-draggable-style-el');
	
	  if (!styleEl) {
	    styleEl = doc.createElement('style');
	    styleEl.type = 'text/css';
	    styleEl.id = 'react-draggable-style-el';
	    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
	    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
	    doc.getElementsByTagName('head')[0].appendChild(styleEl);
	  }
	
	  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
	}
	
	function removeUserSelectStyles(doc
	/*: ?Document*/
	) {
	  if (!doc) return;
	
	  try {
	    if (doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection'); // $FlowIgnore: IE
	
	    if (doc.selection) {
	      // $FlowIgnore: IE
	      doc.selection.empty();
	    } else {
	      // Remove selection caused by scroll, unless it's a focused input
	      // (we use doc.defaultView in case we're in an iframe)
	      var selection = (doc.defaultView || window).getSelection();
	
	      if (selection && selection.type !== 'Caret') {
	        selection.removeAllRanges();
	      }
	    }
	  } catch (e) {// probably IE
	  }
	}
	
	function addClassName(el
	/*: HTMLElement*/
	, className
	/*: string*/
	) {
	  if (el.classList) {
	    el.classList.add(className);
	  } else {
	    if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) {
	      el.className += " ".concat(className);
	    }
	  }
	}
	
	function removeClassName(el
	/*: HTMLElement*/
	, className
	/*: string*/
	) {
	  if (el.classList) {
	    el.classList.remove(className);
	  } else {
	    el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
	  }
	}

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(68);
	var assign = __webpack_require__(251);
	var qs = __webpack_require__(1645);
	
	var paramCompileMatcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|[*.()\[\]\\+|{}^$]/g;
	var paramInjectMatcher = /:([a-zA-Z_$][a-zA-Z0-9_$?]*[?]?)|[*]/g;
	var paramInjectTrailingSlashMatcher = /\/\/\?|\/\?\/|\/\?(?![^\/=]+=.*$)/g;
	var queryMatcher = /\?(.*)$/;
	
	var _compiledPatterns = {};
	
	function compilePattern(pattern) {
	  if (!(pattern in _compiledPatterns)) {
	    var paramNames = [];
	    var source = pattern.replace(paramCompileMatcher, function (match, paramName) {
	      if (paramName) {
	        paramNames.push(paramName);
	        return '([^/?#]+)';
	      } else if (match === '*') {
	        paramNames.push('splat');
	        return '(.*?)';
	      } else {
	        return '\\' + match;
	      }
	    });
	
	    _compiledPatterns[pattern] = {
	      matcher: new RegExp('^' + source + '$', 'i'),
	      paramNames: paramNames
	    };
	  }
	
	  return _compiledPatterns[pattern];
	}
	
	var PathUtils = {
	
	  /**
	   * Returns true if the given path is absolute.
	   */
	  isAbsolute: function isAbsolute(path) {
	    return path.charAt(0) === '/';
	  },
	
	  /**
	   * Joins two URL paths together.
	   */
	  join: function join(a, b) {
	    return a.replace(/\/*$/, '/') + b;
	  },
	
	  /**
	   * Returns an array of the names of all parameters in the given pattern.
	   */
	  extractParamNames: function extractParamNames(pattern) {
	    return compilePattern(pattern).paramNames;
	  },
	
	  /**
	   * Extracts the portions of the given URL path that match the given pattern
	   * and returns an object of param name => value pairs. Returns null if the
	   * pattern does not match the given path.
	   */
	  extractParams: function extractParams(pattern, path) {
	    var _compilePattern = compilePattern(pattern);
	
	    var matcher = _compilePattern.matcher;
	    var paramNames = _compilePattern.paramNames;
	
	    var match = path.match(matcher);
	
	    if (!match) return null;
	
	    var params = {};
	
	    paramNames.forEach(function (paramName, index) {
	      params[paramName] = match[index + 1];
	    });
	
	    return params;
	  },
	
	  /**
	   * Returns a version of the given route path with params interpolated. Throws
	   * if there is a dynamic segment of the route path for which there is no param.
	   */
	  injectParams: function injectParams(pattern, params) {
	    params = params || {};
	
	    var splatIndex = 0;
	
	    return pattern.replace(paramInjectMatcher, function (match, paramName) {
	      paramName = paramName || 'splat';
	
	      // If param is optional don't check for existence
	      if (paramName.slice(-1) === '?') {
	        paramName = paramName.slice(0, -1);
	
	        if (params[paramName] == null) return '';
	      } else {
	        invariant(params[paramName] != null, 'Missing "%s" parameter for path "%s"', paramName, pattern);
	      }
	
	      var segment;
	      if (paramName === 'splat' && Array.isArray(params[paramName])) {
	        segment = params[paramName][splatIndex++];
	
	        invariant(segment != null, 'Missing splat # %s for path "%s"', splatIndex, pattern);
	      } else {
	        segment = params[paramName];
	      }
	
	      return segment;
	    }).replace(paramInjectTrailingSlashMatcher, '/');
	  },
	
	  /**
	   * Returns an object that is the result of parsing any query string contained
	   * in the given path, null if the path contains no query string.
	   */
	  extractQuery: function extractQuery(path) {
	    var match = path.match(queryMatcher);
	    return match && qs.parse(match[1]);
	  },
	
	  /**
	   * Returns a version of the given path without the query string.
	   */
	  withoutQuery: function withoutQuery(path) {
	    return path.replace(queryMatcher, '');
	  },
	
	  /**
	   * Returns a version of the given path with the parameters in the given
	   * query merged into the query string.
	   */
	  withQuery: function withQuery(path, query) {
	    var existingQuery = PathUtils.extractQuery(path);
	
	    if (existingQuery) query = query ? assign(existingQuery, query) : existingQuery;
	
	    var queryString = qs.stringify(query, { arrayFormat: 'brackets' });
	
	    if (queryString) return PathUtils.withoutQuery(path) + '?' + queryString;
	
	    return PathUtils.withoutQuery(path);
	  }
	
	};
	
	module.exports = PathUtils;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var LocationActions = __webpack_require__(299);
	var History = __webpack_require__(250);
	
	var _listeners = [];
	var _isListening = false;
	
	function notifyChange(type) {
	  var change = {
	    path: HistoryLocation.getCurrentPath(),
	    type: type
	  };
	
	  _listeners.forEach(function (listener) {
	    listener.call(HistoryLocation, change);
	  });
	}
	
	function onPopState(event) {
	  if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	  notifyChange(LocationActions.POP);
	}
	
	/**
	 * A Location that uses HTML5 history.
	 */
	var HistoryLocation = {
	
	  addChangeListener: function addChangeListener(listener) {
	    _listeners.push(listener);
	
	    if (!_isListening) {
	      if (window.addEventListener) {
	        window.addEventListener('popstate', onPopState, false);
	      } else {
	        window.attachEvent('onpopstate', onPopState);
	      }
	
	      _isListening = true;
	    }
	  },
	
	  removeChangeListener: function removeChangeListener(listener) {
	    _listeners = _listeners.filter(function (l) {
	      return l !== listener;
	    });
	
	    if (_listeners.length === 0) {
	      if (window.addEventListener) {
	        window.removeEventListener('popstate', onPopState, false);
	      } else {
	        window.removeEvent('onpopstate', onPopState);
	      }
	
	      _isListening = false;
	    }
	  },
	
	  push: function push(path) {
	    window.history.pushState({ path: path }, '', path);
	    History.length += 1;
	    notifyChange(LocationActions.PUSH);
	  },
	
	  replace: function replace(path) {
	    window.history.replaceState({ path: path }, '', path);
	    notifyChange(LocationActions.REPLACE);
	  },
	
	  pop: History.back,
	
	  getCurrentPath: function getCurrentPath() {
	    return decodeURI(window.location.pathname + window.location.search);
	  },
	
	  toString: function toString() {
	    return '<HistoryLocation>';
	  }
	
	};
	
	module.exports = HistoryLocation;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of https://github.com/facebook/react/tree/0.13-stable.
	 * An additional grant of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */
	
	"use strict";
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function warning() {};
	
	if (__DEV__) {
	  warning = function (condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.length < 10 || /^[s\W]*$/.test(format)) {
	      throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      console.warn(message);
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(872);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _trim = __webpack_require__(1868);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValid = function isValid(value) {
		return typeof value !== 'undefined' && value !== null && value !== '';
	};
	
	var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (props.trimFilter) {
			filterValue = (0, _trim2.default)(filterValue);
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
			if (!filterValue) return true;
	
			var value = option[props.valueKey];
			var label = option[props.labelKey];
			var hasValue = isValid(value);
			var hasLabel = isValid(label);
	
			if (!hasValue && !hasLabel) {
				return false;
			}
	
			var valueTest = hasValue ? String(value) : null;
			var labelTest = hasLabel ? String(label) : null;
	
			if (props.ignoreAccents) {
				if (valueTest && props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (labelTest && props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
	
			if (props.ignoreCase) {
				if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
	
			return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	};
	
	exports.default = filterOptions;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuRenderer = function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    focusOption = _ref.focusOption,
		    inputValue = _ref.inputValue,
		    instancePrefix = _ref.instancePrefix,
		    onFocus = _ref.onFocus,
		    onOptionRef = _ref.onOptionRef,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    removeValue = _ref.removeValue,
		    selectValue = _ref.selectValue,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.some(function (x) {
				return x[valueKey] === option[valueKey];
			});
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					focusOption: focusOption,
					inputValue: inputValue,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					},
					removeValue: removeValue,
					selectValue: selectValue
				},
				optionRenderer(option, i, inputValue)
			);
		});
	};
	
	menuRenderer.propTypes = {
		focusOption: _propTypes2.default.func,
		focusedOption: _propTypes2.default.object,
		inputValue: _propTypes2.default.string,
		instancePrefix: _propTypes2.default.string,
		onFocus: _propTypes2.default.func,
		onOptionRef: _propTypes2.default.func,
		onSelect: _propTypes2.default.func,
		optionClassName: _propTypes2.default.string,
		optionComponent: _propTypes2.default.func,
		optionRenderer: _propTypes2.default.func,
		options: _propTypes2.default.array,
		removeValue: _propTypes2.default.func,
		selectValue: _propTypes2.default.func,
		valueArray: _propTypes2.default.array,
		valueKey: _propTypes2.default.string
	};
	
	exports.default = menuRenderer;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1889);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Button = function (_React$Component) {
	  _inherits(Button, _React$Component);
	
	  function Button() {
	    _classCallCheck(this, Button);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Button.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        disabled = _props.disabled,
	        label = _props.label,
	        icon = _props.icon,
	        busy = _props.busy,
	        active = _props.active,
	        children = _props.children,
	        _props$component = _props.component,
	        Tag = _props$component === undefined ? 'button' : _props$component,
	        props = _objectWithoutProperties(_props, ['className', 'disabled', 'label', 'icon', 'busy', 'active', 'children', 'component']);
	
	    var type = props.type;
	
	    if (Tag === 'button') type = type || 'button';
	
	    return _react2.default.createElement(
	      Tag,
	      _extends({}, props, {
	        tabIndex: '-1',
	        title: label,
	        type: type,
	        disabled: disabled,
	        'aria-disabled': disabled,
	        'aria-label': label,
	        className: (0, _classnames2.default)(className, 'rw-btn', active && !disabled && 'rw-state-active')
	      }),
	      icon && _react2.default.createElement('span', {
	        'aria-hidden': true,
	        className: (0, _classnames2.default)('rw-i', 'rw-i-' + icon, busy && 'rw-loading')
	      }),
	      children
	    );
	  };
	
	  return Button;
	}(_react2.default.Component);
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(93),
	    has = _require.has;
	
	module.exports = {
	  componentWillUnmount: function componentWillUnmount() {
	    var timers = this._timers || {};
	
	    this._unmounted = true;
	
	    for (var k in timers) {
	      if (has(timers, k)) this.clearTimeout(k);
	    }
	  },
	  clearTimeout: function clearTimeout(key) {
	    var timers = this._timers || {};
	    window.clearTimeout(timers[key]);
	  },
	  setTimeout: function setTimeout(key, cb, duration) {
	    var _this = this;
	
	    var timers = this._timers || (this._timers = Object.create(null));
	
	    if (this._unmounted) return;
	
	    this.clearTimeout(key);
	    timers[key] = window.setTimeout(function () {
	      if (!_this._unmounted) cb();
	    }, duration);
	  }
	};

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _animate = __webpack_require__(1910);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { animate: _animate2.default };
	module.exports = exports['default'];

/***/ }),
/* 539 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _calendarViewHierarch, _calendarViewUnits;
	
	var views = {
	  MONTH: 'month',
	  YEAR: 'year',
	  DECADE: 'decade',
	  CENTURY: 'century'
	};
	
	var directions = exports.directions = {
	  LEFT: 'LEFT',
	  RIGHT: 'RIGHT',
	  UP: 'UP',
	  DOWN: 'DOWN'
	};
	
	var datePopups = exports.datePopups = {
	  TIME: 'time',
	  CALENDAR: 'calendar'
	};
	
	var calendarViews = exports.calendarViews = views;
	
	var calendarViewHierarchy = exports.calendarViewHierarchy = (_calendarViewHierarch = {}, _calendarViewHierarch[views.MONTH] = views.YEAR, _calendarViewHierarch[views.YEAR] = views.DECADE, _calendarViewHierarch[views.DECADE] = views.CENTURY, _calendarViewHierarch);
	
	var calendarViewUnits = exports.calendarViewUnits = (_calendarViewUnits = {}, _calendarViewUnits[views.MONTH] = 'day', _calendarViewUnits[views.YEAR] = views.MONTH, _calendarViewUnits[views.DECADE] = views.YEAR, _calendarViewUnits[views.CENTURY] = views.DECADE, _calendarViewUnits);

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.dataValue = dataValue;
	exports.dataText = dataText;
	exports.dataIndexOf = dataIndexOf;
	exports.valueMatcher = valueMatcher;
	exports.dataItem = dataItem;
	
	var _ = __webpack_require__(93);
	
	function accessor(data, field) {
	  var value = data;
	
	  if (typeof field === 'function') value = field(data);else if (data == null) value = data;else if (typeof field === 'string' && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && field in data) value = data[field];
	
	  return value;
	}
	
	function dataValue(item, valueField) {
	  return valueField && item && (0, _.has)(item, valueField) ? item[valueField] : item;
	}
	
	function dataText(item, textField) {
	  var value = accessor(item, textField);
	  return value == null ? '' : value + '';
	}
	
	function dataIndexOf(data, item, valueField) {
	  var idx = -1,
	      len = data.length,
	      isValueEqual = function isValueEqual(datum) {
	    return valueMatcher(item, datum, valueField);
	  };
	
	  while (++idx < len) {
	    var datum = data[idx];
	    if (datum === item || isValueEqual(datum)) return idx;
	  }
	
	  return -1;
	}
	
	/**
	 * I don't know that the shallow equal makes sense here but am too afraid to
	 * remove it.
	 */
	function valueMatcher(a, b, valueField) {
	  return (0, _.isShallowEqual)(dataValue(a, valueField), dataValue(b, valueField));
	}
	
	function dataItem(data, item, valueField) {
	  var idx = dataIndexOf(data, dataValue(item, valueField), valueField);
	
	  if (idx !== -1) return data[idx];
	
	  return item;
	}

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var contains = __webpack_require__(1914),
	    getWindow = __webpack_require__(303),
	    ownerDocument = __webpack_require__(881);
	
	module.exports = function offset(node) {
	  var doc = ownerDocument(node),
	      win = getWindow(doc),
	      docElem = doc && doc.documentElement,
	      box = { top: 0, left: 0, height: 0, width: 0 };
	
	  if (!doc) return;
	
	  // Make sure it's not a disconnected DOM node
	  if (!contains(docElem, node)) return box;
	
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();
	
	  if (box.width || box.height) {
	
	    box = {
	      top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	      left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	      width: (box.width == null ? node.offsetWidth : box.width) || 0,
	      height: (box.height == null ? node.offsetHeight : box.height) || 0
	    };
	  }
	
	  return box;
	};

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	
	'use strict';
	var camelize = __webpack_require__(1920);
	var msPattern = /^-ms-/;
	
	module.exports = function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	};

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(125));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(355));
	
	var _max2 = _interopRequireDefault(__webpack_require__(724));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _get2 = _interopRequireDefault(__webpack_require__(207));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(115));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(62));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(129));
	
	var _Curve = _interopRequireDefault(__webpack_require__(257));
	
	var _Dot = _interopRequireDefault(__webpack_require__(218));
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(171));
	
	var _ReactUtils = __webpack_require__(43);
	
	var _DataUtils = __webpack_require__(66);
	
	var _ChartUtils = __webpack_require__(103);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Area =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Area, _PureComponent);
	
	  function Area() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Area);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Area)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: true
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-area-');
	
	    _this.cachePrevData = function (points, baseLine) {
	      _this.setState({
	        prevPoints: points,
	        prevBaseLine: baseLine
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Area, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points,
	          baseLine = _this$props.baseLine;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points, baseLine);
	      }
	    }
	  }, {
	    key: "renderDots",
	    value: function renderDots(needClip, clipPathId) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      if (isAnimationActive && !isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props2 = this.props,
	          dot = _this$props2.dot,
	          points = _this$props2.points,
	          dataKey = _this$props2.dataKey;
	      var areaProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dotEvents = (0, _ReactUtils.filterEventAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _objectSpread({
	          key: "dot-".concat(i),
	          r: 3
	        }, areaProps, {}, customDotProps, {}, dotEvents, {
	          dataKey: dataKey,
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          value: entry.value,
	          payload: entry.payload
	        });
	
	        return _this2.constructor.renderDotItem(dot, dotProps);
	      });
	      var dotsProps = {
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      };
	      return _react["default"].createElement(_Layer["default"], _extends({
	        className: "recharts-area-dots"
	      }, dotsProps), dots);
	    }
	  }, {
	    key: "renderHorizontalRect",
	    value: function renderHorizontalRect(alpha) {
	      var _this$props3 = this.props,
	          baseLine = _this$props3.baseLine,
	          points = _this$props3.points,
	          strokeWidth = _this$props3.strokeWidth;
	      var startX = points[0].x;
	      var endX = points[points.length - 1].x;
	      var width = alpha * Math.abs(startX - endX);
	      var maxY = (0, _max2["default"])(points.map(function (entry) {
	        return entry.y || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxY = Math.max(baseLine, maxY);
	      } else if (baseLine && (0, _isArray2["default"])(baseLine) && baseLine.length) {
	        maxY = Math.max((0, _max2["default"])(baseLine.map(function (entry) {
	          return entry.y || 0;
	        })), maxY);
	      }
	
	      if ((0, _DataUtils.isNumber)(maxY)) {
	        return _react["default"].createElement("rect", {
	          x: startX < endX ? startX : startX - width,
	          y: 0,
	          width: width,
	          height: parseInt(maxY + (strokeWidth || 1), 10)
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: "renderVerticalRect",
	    value: function renderVerticalRect(alpha) {
	      var _this$props4 = this.props,
	          baseLine = _this$props4.baseLine,
	          points = _this$props4.points,
	          strokeWidth = _this$props4.strokeWidth;
	      var startY = points[0].y;
	      var endY = points[points.length - 1].y;
	      var height = alpha * Math.abs(startY - endY);
	      var maxX = (0, _max2["default"])(points.map(function (entry) {
	        return entry.x || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxX = Math.max(baseLine, maxX);
	      } else if (baseLine && (0, _isArray2["default"])(baseLine) && baseLine.length) {
	        maxX = Math.max((0, _max2["default"])(baseLine.map(function (entry) {
	          return entry.x || 0;
	        })), maxX);
	      }
	
	      if ((0, _DataUtils.isNumber)(maxX)) {
	        return _react["default"].createElement("rect", {
	          x: 0,
	          y: startY < endY ? startY : startY - height,
	          width: maxX + (strokeWidth || 1),
	          height: parseInt(height, 10)
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: "renderClipRect",
	    value: function renderClipRect(alpha) {
	      var layout = this.props.layout;
	
	      if (layout === 'vertical') {
	        return this.renderVerticalRect(alpha);
	      }
	
	      return this.renderHorizontalRect(alpha);
	    }
	  }, {
	    key: "renderAreaStatically",
	    value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
	      var _this$props5 = this.props,
	          layout = _this$props5.layout,
	          type = _this$props5.type,
	          stroke = _this$props5.stroke,
	          connectNulls = _this$props5.connectNulls,
	          isRange = _this$props5.isRange;
	      return _react["default"].createElement(_Layer["default"], {
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      }, _react["default"].createElement(_Curve["default"], _extends({}, this.props, {
	        points: points,
	        baseLine: baseLine,
	        stroke: "none",
	        className: "recharts-area-area"
	      })), stroke !== 'none' && _react["default"].createElement(_Curve["default"], _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: "recharts-area-curve",
	        layout: layout,
	        type: type,
	        connectNulls: connectNulls,
	        fill: "none",
	        points: points
	      })), stroke !== 'none' && isRange && _react["default"].createElement(_Curve["default"], _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: "recharts-area-curve",
	        layout: layout,
	        type: type,
	        connectNulls: connectNulls,
	        fill: "none",
	        points: baseLine
	      })));
	    }
	  }, {
	    key: "renderAreaWithAnimation",
	    value: function renderAreaWithAnimation(needClip, clipPathId) {
	      var _this3 = this;
	
	      var _this$props6 = this.props,
	          points = _this$props6.points,
	          baseLine = _this$props6.baseLine,
	          isAnimationActive = _this$props6.isAnimationActive,
	          animationBegin = _this$props6.animationBegin,
	          animationDuration = _this$props6.animationDuration,
	          animationEasing = _this$props6.animationEasing,
	          animationId = _this$props6.animationId;
	      var _this$state = this.state,
	          prevPoints = _this$state.prevPoints,
	          prevBaseLine = _this$state.prevBaseLine; // const clipPathId = _.isNil(id) ? this.id : id;
	
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "area-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	
	        if (prevPoints) {
	          var prevPointsDiffFactor = prevPoints.length / points.length; // update animtaion
	
	          var stepPoints = points.map(function (entry, index) {
	            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
	
	            if (prevPoints[prevPointIndex]) {
	              var prev = prevPoints[prevPointIndex];
	              var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	              var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	              return _objectSpread({}, entry, {
	                x: interpolatorX(t),
	                y: interpolatorY(t)
	              });
	            }
	
	            return entry;
	          });
	          var stepBaseLine;
	
	          if ((0, _DataUtils.isNumber)(baseLine)) {
	            var interpolator = (0, _DataUtils.interpolateNumber)(prevBaseLine, baseLine);
	            stepBaseLine = interpolator(t);
	          } else if ((0, _isNil2["default"])(baseLine) || (0, _isNaN2["default"])(baseLine)) {
	            var _interpolator = (0, _DataUtils.interpolateNumber)(prevBaseLine, 0);
	
	            stepBaseLine = _interpolator(t);
	          } else {
	            stepBaseLine = baseLine.map(function (entry, index) {
	              var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
	
	              if (prevBaseLine[prevPointIndex]) {
	                var prev = prevBaseLine[prevPointIndex];
	                var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	                var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	                return _objectSpread({}, entry, {
	                  x: interpolatorX(t),
	                  y: interpolatorY(t)
	                });
	              }
	
	              return entry;
	            });
	          }
	
	          return _this3.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
	        }
	
	        return _react["default"].createElement(_Layer["default"], null, _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	          id: "animationClipPath-".concat(clipPathId)
	        }, _this3.renderClipRect(t))), _react["default"].createElement(_Layer["default"], {
	          clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
	        }, _this3.renderAreaStatically(points, baseLine, needClip, clipPathId)));
	      });
	    }
	  }, {
	    key: "renderArea",
	    value: function renderArea(needClip, clipPathId) {
	      var _this$props7 = this.props,
	          points = _this$props7.points,
	          baseLine = _this$props7.baseLine,
	          isAnimationActive = _this$props7.isAnimationActive;
	      var _this$state2 = this.state,
	          prevPoints = _this$state2.prevPoints,
	          prevBaseLine = _this$state2.prevBaseLine,
	          totalLength = _this$state2.totalLength;
	
	      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqual2["default"])(prevPoints, points) || !(0, _isEqual2["default"])(prevBaseLine, baseLine))) {
	        return this.renderAreaWithAnimation(needClip, clipPathId);
	      }
	
	      return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props8 = this.props,
	          hide = _this$props8.hide,
	          dot = _this$props8.dot,
	          points = _this$props8.points,
	          className = _this$props8.className,
	          top = _this$props8.top,
	          left = _this$props8.left,
	          xAxis = _this$props8.xAxis,
	          yAxis = _this$props8.yAxis,
	          width = _this$props8.width,
	          height = _this$props8.height,
	          isAnimationActive = _this$props8.isAnimationActive,
	          id = _this$props8.id;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames["default"])('recharts-area', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2["default"])(id) ? this.id : id;
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, needClip ? _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react["default"].createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: parseInt(height, 10)
	      }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, points));
	    }
	  }]);
	
	  return Area;
	}(_react.PureComponent);
	
	Area.displayName = 'Area';
	Area.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  type: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes["default"].func]),
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxis: _propTypes["default"].object,
	  xAxis: _propTypes["default"].object,
	  stackId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  connectNulls: _propTypes["default"].bool,
	  activeDot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  // dot configuration
	  dot: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].object, _propTypes["default"].bool]),
	  label: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].object, _propTypes["default"].bool]),
	  hide: _propTypes["default"].bool,
	  // have curve configuration
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
	  isRange: _propTypes["default"].bool,
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array])
	  })),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  animationId: _propTypes["default"].number,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  id: _propTypes["default"].string
	});
	Area.defaultProps = {
	  stroke: '#3182bd',
	  fill: '#3182bd',
	  fillOpacity: 0.6,
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'line',
	  connectNulls: false,
	  // points of area
	  points: [],
	  dot: false,
	  activeDot: true,
	  hide: false,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	};
	
	Area.getBaseValue = function (props, xAxis, yAxis) {
	  var layout = props.layout,
	      baseValue = props.baseValue;
	
	  if ((0, _DataUtils.isNumber)(baseValue)) {
	    return baseValue;
	  }
	
	  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var domain = numericAxis.scale.domain();
	
	  if (numericAxis.type === 'number') {
	    var max = Math.max(domain[0], domain[1]);
	    var min = Math.min(domain[0], domain[1]);
	
	    if (baseValue === 'dataMin') {
	      return min;
	    }
	
	    if (baseValue === 'dataMax') {
	      return max;
	    }
	
	    return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
	  }
	
	  if (baseValue === 'dataMin') {
	    return domain[0];
	  }
	
	  if (baseValue === 'dataMax') {
	    return domain[1];
	  }
	
	  return domain[0];
	};
	
	Area.getComposedData = function (_ref2) {
	  var props = _ref2.props,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks,
	      bandSize = _ref2.bandSize,
	      dataKey = _ref2.dataKey,
	      stackedData = _ref2.stackedData,
	      dataStartIndex = _ref2.dataStartIndex,
	      displayedData = _ref2.displayedData,
	      offset = _ref2.offset;
	  var layout = props.layout;
	  var hasStack = stackedData && stackedData.length;
	  var baseValue = Area.getBaseValue(props, xAxis, yAxis);
	  var isRange = false;
	  var points = displayedData.map(function (entry, index) {
	    var value;
	
	    if (hasStack) {
	      value = stackedData[dataStartIndex + index];
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray2["default"])(value)) {
	        value = [baseValue, value];
	      } else {
	        isRange = true;
	      }
	    }
	
	    if (layout === 'horizontal') {
	      return {
	        x: (0, _ChartUtils.getCateCoordinateOfLine)({
	          axis: xAxis,
	          ticks: xAxisTicks,
	          bandSize: bandSize,
	          entry: entry,
	          index: index
	        }),
	        y: (0, _isNil2["default"])(value[1]) ? null : yAxis.scale(value[1]),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil2["default"])(value[1]) ? null : xAxis.scale(value[1]),
	      y: (0, _ChartUtils.getCateCoordinateOfLine)({
	        axis: yAxis,
	        ticks: yAxisTicks,
	        bandSize: bandSize,
	        entry: entry,
	        index: index
	      }),
	      value: value,
	      payload: entry
	    };
	  });
	  var baseLine;
	
	  if (hasStack || isRange) {
	    baseLine = points.map(function (entry) {
	      if (layout === 'horizontal') {
	        return {
	          x: entry.x,
	          y: !(0, _isNil2["default"])((0, _get2["default"])(entry, 'value[0]')) ? yAxis.scale((0, _get2["default"])(entry, 'value[0]')) : null
	        };
	      }
	
	      return {
	        x: !(0, _isNil2["default"])((0, _get2["default"])(entry, 'value[0]')) ? xAxis.scale((0, _get2["default"])(entry, 'value[0]')) : null,
	        y: entry.y
	      };
	    });
	  } else if (layout === 'horizontal') {
	    baseLine = yAxis.scale(baseValue);
	  } else {
	    baseLine = xAxis.scale(baseValue);
	  }
	
	  return _objectSpread({
	    points: points,
	    baseLine: baseLine,
	    layout: layout,
	    isRange: isRange
	  }, offset);
	};
	
	Area.renderDotItem = function (option, props) {
	  var dotItem;
	
	  if (_react["default"].isValidElement(option)) {
	    dotItem = _react["default"].cloneElement(option, props);
	  } else if ((0, _isFunction2["default"])(option)) {
	    dotItem = option(props);
	  } else {
	    dotItem = _react["default"].createElement(_Dot["default"], _extends({}, props, {
	      className: "recharts-area-dot"
	    }));
	  }
	
	  return dotItem;
	};
	
	var _default = Area;
	exports["default"] = _default;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(115));
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(125));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(62));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(129));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(258));
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(307));
	
	var _Cell = _interopRequireDefault(__webpack_require__(256));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(171));
	
	var _DataUtils = __webpack_require__(66);
	
	var _ReactUtils = __webpack_require__(43);
	
	var _ChartUtils = __webpack_require__(103);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Bar =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Bar, _PureComponent);
	
	  function Bar() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Bar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Bar)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-bar-');
	
	    _this.cachePrevData = function (data) {
	      _this.setState({
	        prevData: data
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      _this.props.onAnimationEnd();
	    };
	
	    _this.handleAnimationStart = function () {
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      _this.props.onAnimationStart();
	    };
	
	    return _this;
	  }
	
	  _createClass(Bar, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          data = _this$props.data;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(data);
	      }
	    }
	  }, {
	    key: "renderRectanglesStatically",
	    value: function renderRectanglesStatically(data) {
	      var _this2 = this;
	
	      var shape = this.props.shape;
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      return data && data.map(function (entry, i) {
	        var props = _objectSpread({}, baseProps, {}, entry, {
	          index: i
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-bar-rectangle"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "rectangle-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }), _this2.constructor.renderRectangle(shape, props));
	      });
	    }
	  }, {
	    key: "renderRectanglesWithAnimation",
	    value: function renderRectanglesWithAnimation() {
	      var _this3 = this;
	
	      var _this$props2 = this.props,
	          data = _this$props2.data,
	          layout = _this$props2.layout,
	          isAnimationActive = _this$props2.isAnimationActive,
	          animationBegin = _this$props2.animationBegin,
	          animationDuration = _this$props2.animationDuration,
	          animationEasing = _this$props2.animationEasing,
	          animationId = _this$props2.animationId;
	      var prevData = this.state.prevData;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "bar-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = data.map(function (entry, index) {
	          var prev = prevData && prevData[index];
	
	          if (prev) {
	            var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	            var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	            var interpolatorWidth = (0, _DataUtils.interpolateNumber)(prev.width, entry.width);
	            var interpolatorHeight = (0, _DataUtils.interpolateNumber)(prev.height, entry.height);
	            return _objectSpread({}, entry, {
	              x: interpolatorX(t),
	              y: interpolatorY(t),
	              width: interpolatorWidth(t),
	              height: interpolatorHeight(t)
	            });
	          }
	
	          if (layout === 'horizontal') {
	            var _interpolatorHeight = (0, _DataUtils.interpolateNumber)(0, entry.height);
	
	            var h = _interpolatorHeight(t);
	
	            return _objectSpread({}, entry, {
	              y: entry.y + entry.height - h,
	              height: h
	            });
	          }
	
	          var interpolator = (0, _DataUtils.interpolateNumber)(0, entry.width);
	          var w = interpolator(t);
	          return _objectSpread({}, entry, {
	            width: w
	          });
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this3.renderRectanglesStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderRectangles",
	    value: function renderRectangles() {
	      var _this$props3 = this.props,
	          data = _this$props3.data,
	          isAnimationActive = _this$props3.isAnimationActive;
	      var prevData = this.state.prevData;
	
	      if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqual2["default"])(prevData, data))) {
	        return this.renderRectanglesWithAnimation();
	      }
	
	      return this.renderRectanglesStatically(data);
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground() {
	      var _this4 = this;
	
	      var data = this.props.data;
	      var backgroundProps = (0, _ReactUtils.getPresentationAttributes)(this.props.background);
	      return data.map(function (entry, i) {
	        // eslint-disable-next-line no-unused-vars
	        var value = entry.value,
	            background = entry.background,
	            rest = _objectWithoutProperties(entry, ["value", "background"]);
	
	        if (!background) {
	          return null;
	        }
	
	        var props = _objectSpread({}, rest, {
	          fill: '#eee'
	        }, background, {}, backgroundProps, {}, (0, _ReactUtils.filterEventsOfChild)(_this4.props, entry, i), {
	          index: i,
	          key: "background-bar-".concat(i),
	          className: 'recharts-bar-background-rectangle'
	        });
	
	        return _this4.constructor.renderRectangle(_this4.props.background, props);
	      });
	    }
	  }, {
	    key: "renderErrorBar",
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props4 = this.props,
	          data = _this$props4.data,
	          xAxis = _this$props4.xAxis,
	          yAxis = _this$props4.yAxis,
	          layout = _this$props4.layout,
	          children = _this$props4.children;
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar["default"]);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        return _react["default"].cloneElement(item, {
	          key: "error-bar-".concat(i),
	          // eslint-disable-line react/no-array-index-key
	          data: data,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: layout,
	          offset: offset,
	          dataPointFormatter: dataPointFormatter
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props5 = this.props,
	          hide = _this$props5.hide,
	          data = _this$props5.data,
	          className = _this$props5.className,
	          xAxis = _this$props5.xAxis,
	          yAxis = _this$props5.yAxis,
	          left = _this$props5.left,
	          top = _this$props5.top,
	          width = _this$props5.width,
	          height = _this$props5.height,
	          isAnimationActive = _this$props5.isAnimationActive,
	          background = _this$props5.background,
	          id = _this$props5.id;
	
	      if (hide || !data || !data.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var layerClass = (0, _classnames["default"])('recharts-bar', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2["default"])(id) ? this.id : id;
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, needClip ? _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react["default"].createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: height
	      }))) : null, _react["default"].createElement(_Layer["default"], {
	        className: "recharts-bar-rectangles",
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, data));
	    }
	  }], [{
	    key: "renderRectangle",
	    value: function renderRectangle(option, props) {
	      var rectangle;
	
	      if (_react["default"].isValidElement(option)) {
	        rectangle = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        rectangle = option(props);
	      } else {
	        rectangle = _react["default"].createElement(_Rectangle["default"], props);
	      }
	
	      return rectangle;
	    }
	  }]);
	
	  return Bar;
	}(_react.PureComponent);
	
	Bar.displayName = 'Bar';
	Bar.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  layout: _propTypes["default"].oneOf(['vertical', 'horizontal']),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxis: _propTypes["default"].object,
	  xAxis: _propTypes["default"].object,
	  stackId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  barSize: _propTypes["default"].number,
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  minPointSize: _propTypes["default"].number,
	  maxBarSize: _propTypes["default"].number,
	  hide: _propTypes["default"].bool,
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element]),
	  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number,
	    radius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
	    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].array])
	  })),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  animationId: _propTypes["default"].number,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  id: _propTypes["default"].string
	});
	Bar.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'rect',
	  minPointSize: 0,
	  hide: false,
	  // data of bar
	  data: [],
	  layout: 'vertical',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 400,
	  animationEasing: 'ease',
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	};
	
	Bar.getComposedData = function (_ref2) {
	  var props = _ref2.props,
	      item = _ref2.item,
	      barPosition = _ref2.barPosition,
	      bandSize = _ref2.bandSize,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks,
	      stackedData = _ref2.stackedData,
	      dataStartIndex = _ref2.dataStartIndex,
	      displayedData = _ref2.displayedData,
	      offset = _ref2.offset;
	  var pos = (0, _ChartUtils.findPositionOfBar)(barPosition, item);
	
	  if (!pos) {
	    return [];
	  }
	
	  var layout = props.layout;
	  var _item$props = item.props,
	      dataKey = _item$props.dataKey,
	      children = _item$props.children,
	      minPointSize = _item$props.minPointSize;
	  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
	  var baseValue = (0, _ChartUtils.getBaseValueOfBar)({
	    props: props,
	    numericAxis: numericAxis
	  });
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell["default"]);
	  var rects = displayedData.map(function (entry, index) {
	    var value, x, y, width, height, background;
	
	    if (stackedData) {
	      value = (0, _ChartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray2["default"])(value)) {
	        value = [baseValue, value];
	      }
	    }
	
	    if (layout === 'horizontal') {
	      x = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: xAxis,
	        ticks: xAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      y = yAxis.scale(value[1]);
	      width = pos.size;
	      height = yAxis.scale(value[0]) - yAxis.scale(value[1]);
	      background = {
	        x: x,
	        y: yAxis.y,
	        width: width,
	        height: yAxis.height
	      };
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
	        var delta = (0, _DataUtils.mathSign)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
	        y -= delta;
	        height += delta;
	      }
	    } else {
	      x = xAxis.scale(value[0]);
	      y = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: yAxis,
	        ticks: yAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      width = xAxis.scale(value[1]) - xAxis.scale(value[0]);
	      height = pos.size;
	      background = {
	        x: xAxis.x,
	        y: y,
	        width: xAxis.width,
	        height: height
	      };
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
	        var _delta = (0, _DataUtils.mathSign)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
	
	        width += _delta;
	      }
	    }
	
	    return _objectSpread({}, entry, {
	      x: x,
	      y: y,
	      width: width,
	      height: height,
	      value: stackedData ? value : value[1],
	      payload: entry,
	      background: background
	    }, cells && cells[index] && cells[index].props);
	  });
	  return _objectSpread({
	    data: rects,
	    layout: layout
	  }, offset);
	};
	
	var _default = Bar;
	exports["default"] = _default;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(125));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(115));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(129));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _Curve = _interopRequireDefault(__webpack_require__(257));
	
	var _Dot = _interopRequireDefault(__webpack_require__(218));
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(171));
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(307));
	
	var _DataUtils = __webpack_require__(66);
	
	var _ReactUtils = __webpack_require__(43);
	
	var _ChartUtils = __webpack_require__(103);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Line =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Line, _PureComponent);
	
	  function Line() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Line);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Line)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: true,
	      totalLength: 0
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-line-');
	
	    _this.cachePrevData = function (points) {
	      _this.setState({
	        prevPoints: points
	      });
	    };
	
	    _this.pathRef = function (node) {
	      _this.mainCurve = node;
	    };
	
	    _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      _this.props.onAnimationEnd();
	    };
	
	    _this.handleAnimationStart = function () {
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      _this.props.onAnimationStart();
	    };
	
	    return _this;
	  }
	
	  _createClass(Line, [{
	    key: "componentDidMount",
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (!this.props.isAnimationActive) {
	        return;
	      }
	
	      var totalLength = this.getTotalLength();
	      this.setState({
	        totalLength: totalLength
	      });
	    } // eslint-disable-next-line camelcase
	
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points);
	      }
	    }
	  }, {
	    key: "getTotalLength",
	    value: function getTotalLength() {
	      var curveDom = this.mainCurve;
	
	      try {
	        return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
	      } catch (err) {
	        return 0;
	      }
	    }
	  }, {
	    key: "getStrokeDasharray",
	    value: function getStrokeDasharray(length, totalLength, lines) {
	      var lineLength = lines.reduce(function (pre, next) {
	        return pre + next;
	      });
	      var count = parseInt(length / lineLength, 10);
	      var remainLength = length % lineLength;
	      var restLength = totalLength - length;
	      var remainLines = [];
	
	      for (var i = 0, sum = 0;; sum += lines[i], ++i) {
	        if (sum + lines[i] > remainLength) {
	          remainLines = [].concat(_toConsumableArray(lines.slice(0, i)), [remainLength - sum]);
	          break;
	        }
	      }
	
	      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];
	      return [].concat(_toConsumableArray(this.constructor.repeat(lines, count)), _toConsumableArray(remainLines), emptyLines).map(function (line) {
	        return "".concat(line, "px");
	      }).join(', ');
	    }
	  }, {
	    key: "renderErrorBar",
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props2 = this.props,
	          points = _this$props2.points,
	          xAxis = _this$props2.xAxis,
	          yAxis = _this$props2.yAxis,
	          layout = _this$props2.layout,
	          children = _this$props2.children;
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar["default"]);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint.payload, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        return _react["default"].cloneElement(item, {
	          key: i,
	          // eslint-disable-line react/no-array-index-key
	          data: points,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: layout,
	          dataPointFormatter: dataPointFormatter
	        });
	      });
	    }
	  }, {
	    key: "renderDots",
	    value: function renderDots(needClip, clipPathId) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props3 = this.props,
	          dot = _this$props3.dot,
	          points = _this$props3.points,
	          dataKey = _this$props3.dataKey;
	      var lineProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dotEvents = (0, _ReactUtils.filterEventAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _objectSpread({
	          key: "dot-".concat(i),
	          r: 3
	        }, lineProps, {}, customDotProps, {}, dotEvents, {
	          value: entry.value,
	          dataKey: dataKey,
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          payload: entry.payload
	        });
	
	        return _this2.constructor.renderDotItem(dot, dotProps);
	      });
	      var dotsProps = {
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      };
	      return _react["default"].createElement(_Layer["default"], _extends({
	        className: "recharts-line-dots",
	        key: "dots"
	      }, dotsProps), dots);
	    }
	  }, {
	    key: "renderCurveStatically",
	    value: function renderCurveStatically(points, needClip, clipPathId, props) {
	      var _this$props4 = this.props,
	          type = _this$props4.type,
	          layout = _this$props4.layout,
	          connectNulls = _this$props4.connectNulls;
	
	      var curveProps = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	        fill: 'none',
	        className: 'recharts-line-curve',
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
	        points: points
	      }, props, {
	        type: type,
	        layout: layout,
	        connectNulls: connectNulls
	      });
	
	      return _react["default"].createElement(_Curve["default"], _extends({}, curveProps, {
	        pathRef: this.pathRef
	      }));
	    }
	  }, {
	    key: "renderCurveWithAnimation",
	    value: function renderCurveWithAnimation(needClip, clipPathId) {
	      var _this3 = this;
	
	      var _this$props5 = this.props,
	          points = _this$props5.points,
	          strokeDasharray = _this$props5.strokeDasharray,
	          isAnimationActive = _this$props5.isAnimationActive,
	          animationBegin = _this$props5.animationBegin,
	          animationDuration = _this$props5.animationDuration,
	          animationEasing = _this$props5.animationEasing,
	          animationId = _this$props5.animationId,
	          width = _this$props5.width,
	          height = _this$props5.height;
	      var _this$state = this.state,
	          prevPoints = _this$state.prevPoints,
	          totalLength = _this$state.totalLength;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "line-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	
	        if (prevPoints) {
	          var prevPointsDiffFactor = prevPoints.length / points.length;
	          var stepData = points.map(function (entry, index) {
	            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
	
	            if (prevPoints[prevPointIndex]) {
	              var prev = prevPoints[prevPointIndex];
	              var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	              var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	              return _objectSpread({}, entry, {
	                x: interpolatorX(t),
	                y: interpolatorY(t)
	              });
	            } // magic number of faking previous x and y location
	
	
	            if (_this3.animateNewValues) {
	              var _interpolatorX = (0, _DataUtils.interpolateNumber)(width * 2, entry.x);
	
	              var _interpolatorY = (0, _DataUtils.interpolateNumber)(height / 2, entry.y);
	
	              return _objectSpread({}, entry, {
	                x: _interpolatorX(t),
	                y: _interpolatorY(t)
	              });
	            }
	
	            return _objectSpread({}, entry, {
	              x: entry.x,
	              y: entry.y
	            });
	          });
	          return _this3.renderCurveStatically(stepData, needClip, clipPathId);
	        }
	
	        var interpolator = (0, _DataUtils.interpolateNumber)(0, totalLength);
	        var curLength = interpolator(t);
	        var currentStrokeDasharray;
	
	        if (strokeDasharray) {
	          var lines = strokeDasharray.split(/[,\s]+/gim).map(function (num) {
	            return parseFloat(num);
	          });
	          currentStrokeDasharray = _this3.getStrokeDasharray(curLength, totalLength, lines);
	        } else {
	          currentStrokeDasharray = "".concat(curLength, "px ").concat(totalLength - curLength, "px");
	        }
	
	        return _this3.renderCurveStatically(points, needClip, clipPathId, {
	          strokeDasharray: currentStrokeDasharray
	        });
	      });
	    }
	  }, {
	    key: "renderCurve",
	    value: function renderCurve(needClip, clipPathId) {
	      var _this$props6 = this.props,
	          points = _this$props6.points,
	          isAnimationActive = _this$props6.isAnimationActive;
	      var _this$state2 = this.state,
	          prevPoints = _this$state2.prevPoints,
	          totalLength = _this$state2.totalLength;
	
	      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqual2["default"])(prevPoints, points))) {
	        return this.renderCurveWithAnimation(needClip, clipPathId);
	      }
	
	      return this.renderCurveStatically(points, needClip, clipPathId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props7 = this.props,
	          hide = _this$props7.hide,
	          dot = _this$props7.dot,
	          points = _this$props7.points,
	          className = _this$props7.className,
	          xAxis = _this$props7.xAxis,
	          yAxis = _this$props7.yAxis,
	          top = _this$props7.top,
	          left = _this$props7.left,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          isAnimationActive = _this$props7.isAnimationActive,
	          id = _this$props7.id;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames["default"])('recharts-line', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2["default"])(id) ? this.id : id;
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, needClip ? _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react["default"].createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: height
	      }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(), (hasSinglePoint || dot) && this.renderDots(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, points));
	    }
	  }], [{
	    key: "repeat",
	    value: function repeat(lines, count) {
	      var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray(lines), [0]) : lines;
	      var result = [];
	
	      for (var i = 0; i < count; ++i) {
	        result = [].concat(_toConsumableArray(result), _toConsumableArray(linesUnit));
	      }
	
	      return result;
	    }
	  }, {
	    key: "renderDotItem",
	    value: function renderDotItem(option, props) {
	      var dotItem;
	
	      if (_react["default"].isValidElement(option)) {
	        dotItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        dotItem = option(props);
	      } else {
	        var className = (0, _classnames["default"])('recharts-line-dot', option ? option.className : '');
	        dotItem = _react["default"].createElement(_Dot["default"], _extends({}, props, {
	          className: className
	        }));
	      }
	
	      return dotItem;
	    }
	  }]);
	
	  return Line;
	}(_react.PureComponent);
	
	Line.displayName = 'Line';
	Line.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  type: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes["default"].func]),
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxis: _propTypes["default"].object,
	  xAxis: _propTypes["default"].object,
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  connectNulls: _propTypes["default"].bool,
	  hide: _propTypes["default"].bool,
	  // whether have dot in line
	  activeDot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  dot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  top: _propTypes["default"].number,
	  left: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    value: _propTypes["default"].value
	  })),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animateNewValues: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  animationId: _propTypes["default"].number,
	  id: _propTypes["default"].string
	});
	Line.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  connectNulls: false,
	  activeDot: true,
	  dot: true,
	  legendType: 'line',
	  stroke: '#3182bd',
	  strokeWidth: 1,
	  fill: '#fff',
	  points: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animateNewValues: true,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  hide: false,
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	};
	
	Line.getComposedData = function (_ref2) {
	  var props = _ref2.props,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks,
	      dataKey = _ref2.dataKey,
	      bandSize = _ref2.bandSize,
	      displayedData = _ref2.displayedData,
	      offset = _ref2.offset;
	  var layout = props.layout;
	  var points = displayedData.map(function (entry, index) {
	    var value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	    if (layout === 'horizontal') {
	      return {
	        x: (0, _ChartUtils.getCateCoordinateOfLine)({
	          axis: xAxis,
	          ticks: xAxisTicks,
	          bandSize: bandSize,
	          entry: entry,
	          index: index
	        }),
	        y: (0, _isNil2["default"])(value) ? null : yAxis.scale(value),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil2["default"])(value) ? null : xAxis.scale(value),
	      y: (0, _ChartUtils.getCateCoordinateOfLine)({
	        axis: yAxis,
	        ticks: yAxisTicks,
	        bandSize: bandSize,
	        entry: entry,
	        index: index
	      }),
	      value: value,
	      payload: entry
	    };
	  });
	  return _objectSpread({
	    points: points,
	    layout: layout
	  }, offset);
	};
	
	var _default = Line;
	exports["default"] = _default;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(125));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(115));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(129));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(171));
	
	var _ReactUtils = __webpack_require__(43);
	
	var _ZAxis = _interopRequireDefault(__webpack_require__(386));
	
	var _Curve = _interopRequireDefault(__webpack_require__(257));
	
	var _Symbols = _interopRequireDefault(__webpack_require__(549));
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(307));
	
	var _Cell = _interopRequireDefault(__webpack_require__(256));
	
	var _DataUtils = __webpack_require__(66);
	
	var _ChartUtils = __webpack_require__(103);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Scatter =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Scatter, _PureComponent);
	
	  function Scatter() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Scatter);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Scatter)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevPoints = function (points) {
	      _this.setState({
	        prevPoints: points
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	    };
	
	    _this.handleAnimationStart = function () {
	      _this.setState({
	        isAnimationFinished: false
	      });
	    };
	
	    _this.id = (0, _DataUtils.uniqueId)('recharts-scatter-');
	    return _this;
	  }
	
	  _createClass(Scatter, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevPoints(points);
	      }
	    }
	  }, {
	    key: "renderSymbolsStatically",
	    value: function renderSymbolsStatically(points) {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          shape = _this$props2.shape,
	          activeShape = _this$props2.activeShape,
	          activeIndex = _this$props2.activeIndex;
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      return points.map(function (entry, i) {
	        var props = _objectSpread({
	          key: "symbol-".concat(i)
	        }, baseProps, {}, entry);
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-scatter-symbol"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "symbol-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }), _this2.constructor.renderSymbolItem(activeIndex === i ? activeShape : shape, props));
	      });
	    }
	  }, {
	    key: "renderSymbolsWithAnimation",
	    value: function renderSymbolsWithAnimation() {
	      var _this3 = this;
	
	      var _this$props3 = this.props,
	          points = _this$props3.points,
	          isAnimationActive = _this$props3.isAnimationActive,
	          animationBegin = _this$props3.animationBegin,
	          animationDuration = _this$props3.animationDuration,
	          animationEasing = _this$props3.animationEasing,
	          animationId = _this$props3.animationId;
	      var prevPoints = this.state.prevPoints;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "pie-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = points.map(function (entry, index) {
	          var prev = prevPoints && prevPoints[index];
	
	          if (prev) {
	            var interpolatorCx = (0, _DataUtils.interpolateNumber)(prev.cx, entry.cx);
	            var interpolatorCy = (0, _DataUtils.interpolateNumber)(prev.cy, entry.cy);
	            var interpolatorSize = (0, _DataUtils.interpolateNumber)(prev.size, entry.size);
	            return _objectSpread({}, entry, {
	              cx: interpolatorCx(t),
	              cy: interpolatorCy(t),
	              size: interpolatorSize(t)
	            });
	          }
	
	          var interpolator = (0, _DataUtils.interpolateNumber)(0, entry.size);
	          return _objectSpread({}, entry, {
	            size: interpolator(t)
	          });
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this3.renderSymbolsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderSymbols",
	    value: function renderSymbols() {
	      var _this$props4 = this.props,
	          points = _this$props4.points,
	          isAnimationActive = _this$props4.isAnimationActive;
	      var prevPoints = this.state.prevPoints;
	
	      if (isAnimationActive && points && points.length && (!prevPoints || !(0, _isEqual2["default"])(prevPoints, points))) {
	        return this.renderSymbolsWithAnimation();
	      }
	
	      return this.renderSymbolsStatically(points);
	    }
	  }, {
	    key: "renderErrorBar",
	    value: function renderErrorBar() {
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props5 = this.props,
	          points = _this$props5.points,
	          xAxis = _this$props5.xAxis,
	          yAxis = _this$props5.yAxis,
	          children = _this$props5.children;
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar["default"]);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      function dataPointFormatterY(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.node.y,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      function dataPointFormatterX(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.node.x,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        var direction = item.props.direction;
	        return _react["default"].cloneElement(item, {
	          key: i,
	          // eslint-disable-line react/no-array-index-key
	          data: points,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: direction === 'x' ? 'vertical' : 'horizontal',
	          dataPointFormatter: direction === 'x' ? dataPointFormatterX : dataPointFormatterY
	        });
	      });
	    }
	  }, {
	    key: "renderLine",
	    value: function renderLine() {
	      var _this$props6 = this.props,
	          points = _this$props6.points,
	          line = _this$props6.line,
	          lineType = _this$props6.lineType,
	          lineJointType = _this$props6.lineJointType;
	      var scatterProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLineProps = (0, _ReactUtils.getPresentationAttributes)(line);
	      var linePoints, lineItem;
	
	      if (lineType === 'joint') {
	        linePoints = points.map(function (entry) {
	          return {
	            x: entry.cx,
	            y: entry.cy
	          };
	        });
	      } else if (lineType === 'fitting') {
	        var _getLinearRegression = (0, _DataUtils.getLinearRegression)(points),
	            xmin = _getLinearRegression.xmin,
	            xmax = _getLinearRegression.xmax,
	            a = _getLinearRegression.a,
	            b = _getLinearRegression.b;
	
	        var linearExp = function linearExp(x) {
	          return a * x + b;
	        };
	
	        linePoints = [{
	          x: xmin,
	          y: linearExp(xmin)
	        }, {
	          x: xmax,
	          y: linearExp(xmax)
	        }];
	      }
	
	      var lineProps = _objectSpread({}, scatterProps, {
	        fill: 'none',
	        stroke: scatterProps && scatterProps.fill
	      }, customLineProps, {
	        points: linePoints
	      });
	
	      if (_react["default"].isValidElement(line)) {
	        lineItem = _react["default"].cloneElement(line, lineProps);
	      } else if ((0, _isFunction2["default"])(line)) {
	        lineItem = line(lineProps);
	      } else {
	        lineItem = _react["default"].createElement(_Curve["default"], _extends({}, lineProps, {
	          type: lineJointType
	        }));
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-scatter-line",
	        key: "recharts-scatter-line"
	      }, lineItem);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props7 = this.props,
	          hide = _this$props7.hide,
	          points = _this$props7.points,
	          line = _this$props7.line,
	          className = _this$props7.className,
	          xAxis = _this$props7.xAxis,
	          yAxis = _this$props7.yAxis,
	          left = _this$props7.left,
	          top = _this$props7.top,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          id = _this$props7.id;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var _this$state = this.state,
	          isAnimationActive = _this$state.isAnimationActive,
	          isAnimationFinished = _this$state.isAnimationFinished;
	      var layerClass = (0, _classnames["default"])('recharts-scatter', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2["default"])(id) ? this.id : id;
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass,
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      }, needClip ? _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react["default"].createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: height
	      }))) : null, line && this.renderLine(), this.renderErrorBar(), _react["default"].createElement(_Layer["default"], {
	        key: "recharts-scatter-symbols"
	      }, this.renderSymbols()), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, points));
	    }
	  }], [{
	    key: "renderSymbolItem",
	    value: function renderSymbolItem(option, props) {
	      var symbol;
	
	      if (_react["default"].isValidElement(option)) {
	        symbol = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        symbol = option(props);
	      } else {
	        symbol = _react["default"].createElement(_Symbols["default"], _extends({}, props, {
	          type: option
	        }));
	      }
	
	      return symbol;
	    }
	  }]);
	
	  return Scatter;
	}(_react.PureComponent);
	
	Scatter.displayName = 'Scatter';
	Scatter.propTypes = _objectSpread({}, _ReactUtils.EVENT_ATTRIBUTES, {}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  zAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  line: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  lineType: _propTypes["default"].oneOf(['fitting', 'joint']),
	  lineJointType: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes["default"].func]),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  className: _propTypes["default"].string,
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  activeIndex: _propTypes["default"].number,
	  activeShape: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']), _propTypes["default"].element, _propTypes["default"].func]),
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    cx: _propTypes["default"].number,
	    cy: _propTypes["default"].number,
	    size: _propTypes["default"].number,
	    node: _propTypes["default"].shape({
	      x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	      y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	      z: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	    }),
	    payload: _propTypes["default"].any
	  })),
	  hide: _propTypes["default"].bool,
	  isAnimationActive: _propTypes["default"].bool,
	  animationId: _propTypes["default"].number,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	});
	Scatter.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  zAxisId: 0,
	  legendType: 'circle',
	  lineType: 'joint',
	  lineJointType: 'linear',
	  data: [],
	  shape: 'circle',
	  hide: false,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 400,
	  animationEasing: 'linear'
	};
	
	Scatter.getComposedData = function (_ref2) {
	  var xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      zAxis = _ref2.zAxis,
	      item = _ref2.item,
	      displayedData = _ref2.displayedData,
	      onItemMouseLeave = _ref2.onItemMouseLeave,
	      onItemMouseEnter = _ref2.onItemMouseEnter,
	      offset = _ref2.offset,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks;
	  var tooltipType = item.props.tooltipType;
	  var cells = (0, _ReactUtils.findAllByType)(item.props.children, _Cell["default"]);
	  var xAxisDataKey = (0, _isNil2["default"])(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
	  var yAxisDataKey = (0, _isNil2["default"])(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
	  var zAxisDataKey = zAxis && zAxis.dataKey;
	  var defaultRangeZ = zAxis ? zAxis.range : _ZAxis["default"].defaultProps.range;
	  var defaultZ = defaultRangeZ && defaultRangeZ[0];
	  var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
	  var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
	  var points = displayedData.map(function (entry, index) {
	    var x = entry[xAxisDataKey];
	    var y = entry[yAxisDataKey];
	    var z = !(0, _isNil2["default"])(zAxisDataKey) && entry[zAxisDataKey] || '-';
	    var tooltipPayload = [{
	      name: xAxis.name || xAxis.dataKey,
	      unit: xAxis.unit || '',
	      value: x,
	      payload: entry,
	      dataKey: xAxisDataKey,
	      type: tooltipType
	    }, {
	      name: yAxis.name || yAxis.dataKey,
	      unit: yAxis.unit || '',
	      value: y,
	      payload: entry,
	      dataKey: yAxisDataKey,
	      type: tooltipType
	    }];
	
	    if (z !== '-') {
	      tooltipPayload.push({
	        name: zAxis.name || zAxis.dataKey,
	        unit: zAxis.unit || '',
	        value: z,
	        payload: entry,
	        dataKey: zAxisDataKey,
	        type: tooltipType
	      });
	    }
	
	    var cx = (0, _ChartUtils.getCateCoordinateOfLine)({
	      axis: xAxis,
	      ticks: xAxisTicks,
	      bandSize: xBandSize,
	      entry: entry,
	      index: index,
	      dataKey: xAxisDataKey
	    });
	    var cy = (0, _ChartUtils.getCateCoordinateOfLine)({
	      axis: yAxis,
	      ticks: yAxisTicks,
	      bandSize: yBandSize,
	      entry: entry,
	      index: index,
	      dataKey: yAxisDataKey
	    });
	    var size = z !== '-' ? zAxis.scale(z) : defaultZ;
	    var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
	    return _objectSpread({}, entry, {
	      cx: cx,
	      cy: cy,
	      x: cx - radius,
	      y: cy - radius,
	      xAxis: xAxis,
	      yAxis: yAxis,
	      zAxis: zAxis,
	      width: 2 * radius,
	      height: 2 * radius,
	      size: size,
	      node: {
	        x: x,
	        y: y,
	        z: z
	      },
	      tooltipPayload: tooltipPayload,
	      tooltipPosition: {
	        x: cx,
	        y: cy
	      },
	      payload: entry
	    }, cells && cells[index] && cells[index].props);
	  });
	  return _objectSpread({
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter,
	    points: points
	  }, offset);
	};
	
	var _default = Scatter;
	exports["default"] = _default;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _uniqBy2 = _interopRequireDefault(__webpack_require__(488));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _DefaultLegendContent = _interopRequireDefault(__webpack_require__(1952));
	
	var _DataUtils = __webpack_require__(66);
	
	var _ReactUtils = __webpack_require__(43);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var defaultUniqBy = function defaultUniqBy(entry) {
	  return entry.value;
	};
	
	var getUniqPaylod = function getUniqPaylod(option, payload) {
	  if (option === true) {
	    return (0, _uniqBy2["default"])(payload, defaultUniqBy);
	  }
	
	  if ((0, _isFunction2["default"])(option)) {
	    return (0, _uniqBy2["default"])(payload, option);
	  }
	
	  return payload;
	};
	
	var renderContent = function renderContent(content, props) {
	  if (_react["default"].isValidElement(content)) {
	    return _react["default"].cloneElement(content, props);
	  }
	
	  if ((0, _isFunction2["default"])(content)) {
	    return content(props);
	  }
	
	  return _react["default"].createElement(_DefaultLegendContent["default"], props);
	};
	
	var EPS = 1;
	
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var Legend =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Legend, _PureComponent);
	
	  function Legend() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Legend);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Legend)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    };
	    return _this;
	  }
	
	  _createClass(Legend, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: "getBBox",
	    value: function getBBox() {
	      var _this$state = this.state,
	          boxWidth = _this$state.boxWidth,
	          boxHeight = _this$state.boxHeight;
	
	      if (boxWidth >= 0 && boxHeight >= 0) {
	        return {
	          width: boxWidth,
	          height: boxHeight
	        };
	      }
	
	      return null;
	    }
	  }, {
	    key: "getDefaultPosition",
	    value: function getDefaultPosition(style) {
	      var _this$props = this.props,
	          layout = _this$props.layout,
	          align = _this$props.align,
	          verticalAlign = _this$props.verticalAlign,
	          margin = _this$props.margin,
	          chartWidth = _this$props.chartWidth,
	          chartHeight = _this$props.chartHeight;
	      var hPos, vPos;
	
	      if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
	        if (align === 'center' && layout === 'vertical') {
	          var box = this.getBBox() || {
	            width: 0
	          };
	          hPos = {
	            left: ((chartWidth || 0) - box.width) / 2
	          };
	        } else {
	          hPos = align === 'right' ? {
	            right: margin && margin.right || 0
	          } : {
	            left: margin && margin.left || 0
	          };
	        }
	      }
	
	      if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
	        if (verticalAlign === 'middle') {
	          var _box = this.getBBox() || {
	            height: 0
	          };
	
	          vPos = {
	            top: ((chartHeight || 0) - _box.height) / 2
	          };
	        } else {
	          vPos = verticalAlign === 'bottom' ? {
	            bottom: margin && margin.bottom || 0
	          } : {
	            top: margin && margin.top || 0
	          };
	        }
	      }
	
	      return _objectSpread({}, hPos, {}, vPos);
	    }
	  }, {
	    key: "updateBBox",
	    value: function updateBBox() {
	      var _this$state2 = this.state,
	          boxWidth = _this$state2.boxWidth,
	          boxHeight = _this$state2.boxHeight;
	      var onBBoxUpdate = this.props.onBBoxUpdate;
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          }, function () {
	            if (onBBoxUpdate) {
	              onBBoxUpdate(box);
	            }
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        }, function () {
	          if (onBBoxUpdate) {
	            onBBoxUpdate(null);
	          }
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          content = _this$props2.content,
	          width = _this$props2.width,
	          height = _this$props2.height,
	          wrapperStyle = _this$props2.wrapperStyle,
	          paylodUniqBy = _this$props2.paylodUniqBy,
	          payload = _this$props2.payload;
	
	      var outerStyle = _objectSpread({
	        position: 'absolute',
	        width: width || 'auto',
	        height: height || 'auto'
	      }, this.getDefaultPosition(wrapperStyle), {}, wrapperStyle);
	
	      return _react["default"].createElement("div", {
	        className: "recharts-legend-wrapper",
	        style: outerStyle,
	        ref: function ref(node) {
	          _this2.wrapperNode = node;
	        }
	      }, renderContent(content, _objectSpread({}, this.props, {
	        payload: getUniqPaylod(paylodUniqBy, payload)
	      })));
	    }
	  }], [{
	    key: "getWithHeight",
	    value: function getWithHeight(item, chartWidth) {
	      var layout = item.props.layout;
	
	      if (layout === 'vertical' && (0, _DataUtils.isNumber)(item.props.height)) {
	        return {
	          height: item.props.height
	        };
	      }
	
	      if (layout === 'horizontal') {
	        return {
	          width: item.props.width || chartWidth
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Legend;
	}(_react.PureComponent);
	
	Legend.displayName = 'Legend';
	Legend.propTypes = {
	  content: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  wrapperStyle: _propTypes["default"].object,
	  chartWidth: _propTypes["default"].number,
	  chartHeight: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  iconSize: _propTypes["default"].number,
	  iconType: _propTypes["default"].oneOf(ICON_TYPES),
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  align: _propTypes["default"].oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes["default"].oneOf(['top', 'bottom', 'middle']),
	  margin: _propTypes["default"].shape({
	    top: _propTypes["default"].number,
	    left: _propTypes["default"].number,
	    bottom: _propTypes["default"].number,
	    right: _propTypes["default"].number
	  }),
	  payload: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    value: _propTypes["default"].any,
	    id: _propTypes["default"].any,
	    type: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  paylodUniqBy: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].bool]),
	  formatter: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  onBBoxUpdate: _propTypes["default"].func
	};
	Legend.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'bottom'
	};
	var _default = Legend;
	exports["default"] = _default;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Surface", {
	  enumerable: true,
	  get: function get() {
	    return _Surface2["default"];
	  }
	});
	Object.defineProperty(exports, "Layer", {
	  enumerable: true,
	  get: function get() {
	    return _Layer2["default"];
	  }
	});
	Object.defineProperty(exports, "Legend", {
	  enumerable: true,
	  get: function get() {
	    return _Legend2["default"];
	  }
	});
	Object.defineProperty(exports, "Tooltip", {
	  enumerable: true,
	  get: function get() {
	    return _Tooltip2["default"];
	  }
	});
	Object.defineProperty(exports, "ResponsiveContainer", {
	  enumerable: true,
	  get: function get() {
	    return _ResponsiveContainer2["default"];
	  }
	});
	Object.defineProperty(exports, "Cell", {
	  enumerable: true,
	  get: function get() {
	    return _Cell2["default"];
	  }
	});
	Object.defineProperty(exports, "Text", {
	  enumerable: true,
	  get: function get() {
	    return _Text2["default"];
	  }
	});
	Object.defineProperty(exports, "Label", {
	  enumerable: true,
	  get: function get() {
	    return _Label2["default"];
	  }
	});
	Object.defineProperty(exports, "LabelList", {
	  enumerable: true,
	  get: function get() {
	    return _LabelList2["default"];
	  }
	});
	Object.defineProperty(exports, "Customized", {
	  enumerable: true,
	  get: function get() {
	    return _Customized2["default"];
	  }
	});
	Object.defineProperty(exports, "Sector", {
	  enumerable: true,
	  get: function get() {
	    return _Sector2["default"];
	  }
	});
	Object.defineProperty(exports, "Curve", {
	  enumerable: true,
	  get: function get() {
	    return _Curve2["default"];
	  }
	});
	Object.defineProperty(exports, "Rectangle", {
	  enumerable: true,
	  get: function get() {
	    return _Rectangle2["default"];
	  }
	});
	Object.defineProperty(exports, "Polygon", {
	  enumerable: true,
	  get: function get() {
	    return _Polygon2["default"];
	  }
	});
	Object.defineProperty(exports, "Dot", {
	  enumerable: true,
	  get: function get() {
	    return _Dot2["default"];
	  }
	});
	Object.defineProperty(exports, "Cross", {
	  enumerable: true,
	  get: function get() {
	    return _Cross2["default"];
	  }
	});
	Object.defineProperty(exports, "Symbols", {
	  enumerable: true,
	  get: function get() {
	    return _Symbols2["default"];
	  }
	});
	Object.defineProperty(exports, "PolarGrid", {
	  enumerable: true,
	  get: function get() {
	    return _PolarGrid2["default"];
	  }
	});
	Object.defineProperty(exports, "PolarRadiusAxis", {
	  enumerable: true,
	  get: function get() {
	    return _PolarRadiusAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "PolarAngleAxis", {
	  enumerable: true,
	  get: function get() {
	    return _PolarAngleAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "Pie", {
	  enumerable: true,
	  get: function get() {
	    return _Pie2["default"];
	  }
	});
	Object.defineProperty(exports, "Radar", {
	  enumerable: true,
	  get: function get() {
	    return _Radar2["default"];
	  }
	});
	Object.defineProperty(exports, "RadialBar", {
	  enumerable: true,
	  get: function get() {
	    return _RadialBar2["default"];
	  }
	});
	Object.defineProperty(exports, "Brush", {
	  enumerable: true,
	  get: function get() {
	    return _Brush2["default"];
	  }
	});
	Object.defineProperty(exports, "ReferenceLine", {
	  enumerable: true,
	  get: function get() {
	    return _ReferenceLine2["default"];
	  }
	});
	Object.defineProperty(exports, "ReferenceDot", {
	  enumerable: true,
	  get: function get() {
	    return _ReferenceDot2["default"];
	  }
	});
	Object.defineProperty(exports, "ReferenceArea", {
	  enumerable: true,
	  get: function get() {
	    return _ReferenceArea2["default"];
	  }
	});
	Object.defineProperty(exports, "CartesianAxis", {
	  enumerable: true,
	  get: function get() {
	    return _CartesianAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "CartesianGrid", {
	  enumerable: true,
	  get: function get() {
	    return _CartesianGrid2["default"];
	  }
	});
	Object.defineProperty(exports, "Line", {
	  enumerable: true,
	  get: function get() {
	    return _Line2["default"];
	  }
	});
	Object.defineProperty(exports, "Area", {
	  enumerable: true,
	  get: function get() {
	    return _Area2["default"];
	  }
	});
	Object.defineProperty(exports, "Bar", {
	  enumerable: true,
	  get: function get() {
	    return _Bar2["default"];
	  }
	});
	Object.defineProperty(exports, "Scatter", {
	  enumerable: true,
	  get: function get() {
	    return _Scatter2["default"];
	  }
	});
	Object.defineProperty(exports, "XAxis", {
	  enumerable: true,
	  get: function get() {
	    return _XAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "YAxis", {
	  enumerable: true,
	  get: function get() {
	    return _YAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "ZAxis", {
	  enumerable: true,
	  get: function get() {
	    return _ZAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "ErrorBar", {
	  enumerable: true,
	  get: function get() {
	    return _ErrorBar2["default"];
	  }
	});
	Object.defineProperty(exports, "LineChart", {
	  enumerable: true,
	  get: function get() {
	    return _LineChart2["default"];
	  }
	});
	Object.defineProperty(exports, "BarChart", {
	  enumerable: true,
	  get: function get() {
	    return _BarChart2["default"];
	  }
	});
	Object.defineProperty(exports, "PieChart", {
	  enumerable: true,
	  get: function get() {
	    return _PieChart2["default"];
	  }
	});
	Object.defineProperty(exports, "Treemap", {
	  enumerable: true,
	  get: function get() {
	    return _Treemap2["default"];
	  }
	});
	Object.defineProperty(exports, "Sankey", {
	  enumerable: true,
	  get: function get() {
	    return _Sankey2["default"];
	  }
	});
	Object.defineProperty(exports, "RadarChart", {
	  enumerable: true,
	  get: function get() {
	    return _RadarChart2["default"];
	  }
	});
	Object.defineProperty(exports, "ScatterChart", {
	  enumerable: true,
	  get: function get() {
	    return _ScatterChart2["default"];
	  }
	});
	Object.defineProperty(exports, "AreaChart", {
	  enumerable: true,
	  get: function get() {
	    return _AreaChart2["default"];
	  }
	});
	Object.defineProperty(exports, "RadialBarChart", {
	  enumerable: true,
	  get: function get() {
	    return _RadialBarChart2["default"];
	  }
	});
	Object.defineProperty(exports, "ComposedChart", {
	  enumerable: true,
	  get: function get() {
	    return _ComposedChart2["default"];
	  }
	});
	Object.defineProperty(exports, "Funnel", {
	  enumerable: true,
	  get: function get() {
	    return _Funnel2["default"];
	  }
	});
	Object.defineProperty(exports, "FunnelChart", {
	  enumerable: true,
	  get: function get() {
	    return _FunnelChart2["default"];
	  }
	});
	Object.defineProperty(exports, "Trapezoid", {
	  enumerable: true,
	  get: function get() {
	    return _Trapezoid2["default"];
	  }
	});
	
	__webpack_require__(1956);
	
	var _Surface2 = _interopRequireDefault(__webpack_require__(308));
	
	var _Layer2 = _interopRequireDefault(__webpack_require__(81));
	
	var _Legend2 = _interopRequireDefault(__webpack_require__(547));
	
	var _Tooltip2 = _interopRequireDefault(__webpack_require__(387));
	
	var _ResponsiveContainer2 = _interopRequireDefault(__webpack_require__(1954));
	
	var _Cell2 = _interopRequireDefault(__webpack_require__(256));
	
	var _Text2 = _interopRequireDefault(__webpack_require__(217));
	
	var _Label2 = _interopRequireDefault(__webpack_require__(190));
	
	var _LabelList2 = _interopRequireDefault(__webpack_require__(171));
	
	var _Customized2 = _interopRequireDefault(__webpack_require__(1951));
	
	var _Sector2 = _interopRequireDefault(__webpack_require__(391));
	
	var _Curve2 = _interopRequireDefault(__webpack_require__(257));
	
	var _Rectangle2 = _interopRequireDefault(__webpack_require__(258));
	
	var _Polygon2 = _interopRequireDefault(__webpack_require__(390));
	
	var _Dot2 = _interopRequireDefault(__webpack_require__(218));
	
	var _Cross2 = _interopRequireDefault(__webpack_require__(900));
	
	var _Symbols2 = _interopRequireDefault(__webpack_require__(549));
	
	var _PolarGrid2 = _interopRequireDefault(__webpack_require__(1955));
	
	var _PolarRadiusAxis2 = _interopRequireDefault(__webpack_require__(389));
	
	var _PolarAngleAxis2 = _interopRequireDefault(__webpack_require__(388));
	
	var _Pie2 = _interopRequireDefault(__webpack_require__(897));
	
	var _Radar2 = _interopRequireDefault(__webpack_require__(898));
	
	var _RadialBar2 = _interopRequireDefault(__webpack_require__(899));
	
	var _Brush2 = _interopRequireDefault(__webpack_require__(891));
	
	var _ReferenceLine2 = _interopRequireDefault(__webpack_require__(895));
	
	var _ReferenceDot2 = _interopRequireDefault(__webpack_require__(894));
	
	var _ReferenceArea2 = _interopRequireDefault(__webpack_require__(893));
	
	var _CartesianAxis2 = _interopRequireDefault(__webpack_require__(892));
	
	var _CartesianGrid2 = _interopRequireDefault(__webpack_require__(1939));
	
	var _Line2 = _interopRequireDefault(__webpack_require__(545));
	
	var _Area2 = _interopRequireDefault(__webpack_require__(543));
	
	var _Bar2 = _interopRequireDefault(__webpack_require__(544));
	
	var _Scatter2 = _interopRequireDefault(__webpack_require__(546));
	
	var _XAxis2 = _interopRequireDefault(__webpack_require__(254));
	
	var _YAxis2 = _interopRequireDefault(__webpack_require__(255));
	
	var _ZAxis2 = _interopRequireDefault(__webpack_require__(386));
	
	var _ErrorBar2 = _interopRequireDefault(__webpack_require__(307));
	
	var _LineChart2 = _interopRequireDefault(__webpack_require__(1944));
	
	var _BarChart2 = _interopRequireDefault(__webpack_require__(1941));
	
	var _PieChart2 = _interopRequireDefault(__webpack_require__(1945));
	
	var _Treemap2 = _interopRequireDefault(__webpack_require__(1950));
	
	var _Sankey2 = _interopRequireDefault(__webpack_require__(1948));
	
	var _RadarChart2 = _interopRequireDefault(__webpack_require__(1946));
	
	var _ScatterChart2 = _interopRequireDefault(__webpack_require__(1949));
	
	var _AreaChart2 = _interopRequireDefault(__webpack_require__(1940));
	
	var _RadialBarChart2 = _interopRequireDefault(__webpack_require__(1947));
	
	var _ComposedChart2 = _interopRequireDefault(__webpack_require__(1942));
	
	var _Funnel2 = _interopRequireDefault(__webpack_require__(896));
	
	var _FunnelChart2 = _interopRequireDefault(__webpack_require__(1943));
	
	var _Trapezoid2 = _interopRequireDefault(__webpack_require__(901));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _d3Shape = __webpack_require__(439);
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _ReactUtils = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var SYMBOL_FACTORIES = {
	  symbolCircle: _d3Shape.symbolCircle,
	  symbolCross: _d3Shape.symbolCross,
	  symbolDiamond: _d3Shape.symbolDiamond,
	  symbolSquare: _d3Shape.symbolSquare,
	  symbolStar: _d3Shape.symbolStar,
	  symbolTriangle: _d3Shape.symbolTriangle,
	  symbolWye: _d3Shape.symbolWye
	};
	var RADIAN = Math.PI / 180;
	
	var getSymbolFactory = function getSymbolFactory(type) {
	  var name = "symbol".concat(type.slice(0, 1).toUpperCase()).concat(type.slice(1));
	  return SYMBOL_FACTORIES[name] || _d3Shape.symbolCircle;
	};
	
	var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
	  if (sizeType === 'area') {
	    return size;
	  }
	
	  switch (type) {
	    case 'cross':
	      return 5 * size * size / 9;
	
	    case 'diamond':
	      return 0.5 * size * size / Math.sqrt(3);
	
	    case 'square':
	      return size * size;
	
	    case 'star':
	      {
	        var angle = 18 * RADIAN;
	        return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
	      }
	
	    case 'triangle':
	      return Math.sqrt(3) * size * size / 4;
	
	    case 'wye':
	      return (21 - 10 * Math.sqrt(3)) * size * size / 8;
	
	    default:
	      return Math.PI * size * size / 4;
	  }
	};
	
	var Symbols =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Symbols, _PureComponent);
	
	  function Symbols() {
	    _classCallCheck(this, Symbols);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Symbols).apply(this, arguments));
	  }
	
	  _createClass(Symbols, [{
	    key: "getPath",
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _this$props = this.props,
	          size = _this$props.size,
	          sizeType = _this$props.sizeType,
	          type = _this$props.type;
	      var symbolFactory = getSymbolFactory(type);
	      var symbol = (0, _d3Shape.symbol)().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
	      return symbol();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          className = _this$props2.className,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          size = _this$props2.size;
	
	      if (cx === +cx && cy === +cy && size === +size) {
	        return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: (0, _classnames["default"])('recharts-symbols', className),
	          transform: "translate(".concat(cx, ", ").concat(cy, ")"),
	          d: this.getPath()
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Symbols;
	}(_react.PureComponent);
	
	Symbols.displayName = 'Symbols';
	Symbols.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  type: _propTypes["default"].oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  size: _propTypes["default"].number,
	  sizeType: _propTypes["default"].oneOf(['area', 'diameter'])
	});
	Symbols.defaultProps = {
	  type: 'circle',
	  size: 64,
	  sizeType: 'area'
	};
	var _default = Symbols;
	exports["default"] = _default;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(94);
	var ScalarObservable_1 = __webpack_require__(552);
	var EmptyObservable_1 = __webpack_require__(551);
	var isScheduler_1 = __webpack_require__(557);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ArrayObservable = (function (_super) {
	    __extends(ArrayObservable, _super);
	    function ArrayObservable(array, scheduler) {
	        _super.call(this);
	        this.array = array;
	        this.scheduler = scheduler;
	        if (!scheduler && array.length === 1) {
	            this._isScalar = true;
	            this.value = array[0];
	        }
	    }
	    ArrayObservable.create = function (array, scheduler) {
	        return new ArrayObservable(array, scheduler);
	    };
	    /**
	     * Creates an Observable that emits some values you specify as arguments,
	     * immediately one after the other, and then emits a complete notification.
	     *
	     * <span class="informal">Emits the arguments you provide, then completes.
	     * </span>
	     *
	     * <img src="./img/of.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that only
	     * emits the arguments given, and the complete notification thereafter. It can
	     * be used for composing with other Observables, such as with {@link concat}.
	     * By default, it uses a `null` IScheduler, which means the `next`
	     * notifications are sent synchronously, although with a different IScheduler
	     * it is possible to determine when those notifications will be delivered.
	     *
	     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
	     * var numbers = Rx.Observable.of(10, 20, 30);
	     * var letters = Rx.Observable.of('a', 'b', 'c');
	     * var interval = Rx.Observable.interval(1000);
	     * var result = numbers.concat(letters).concat(interval);
	     * result.subscribe(x => console.log(x));
	     *
	     * @see {@link create}
	     * @see {@link empty}
	     * @see {@link never}
	     * @see {@link throw}
	     *
	     * @param {...T} values Arguments that represent `next` values to be emitted.
	     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
	     * the emissions of the `next` notifications.
	     * @return {Observable<T>} An Observable that emits each given input value.
	     * @static true
	     * @name of
	     * @owner Observable
	     */
	    ArrayObservable.of = function () {
	        var array = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            array[_i - 0] = arguments[_i];
	        }
	        var scheduler = array[array.length - 1];
	        if (isScheduler_1.isScheduler(scheduler)) {
	            array.pop();
	        }
	        else {
	            scheduler = null;
	        }
	        var len = array.length;
	        if (len > 1) {
	            return new ArrayObservable(array, scheduler);
	        }
	        else if (len === 1) {
	            return new ScalarObservable_1.ScalarObservable(array[0], scheduler);
	        }
	        else {
	            return new EmptyObservable_1.EmptyObservable(scheduler);
	        }
	    };
	    ArrayObservable.dispatch = function (state) {
	        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
	        if (index >= count) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(array[index]);
	        if (subscriber.closed) {
	            return;
	        }
	        state.index = index + 1;
	        this.schedule(state);
	    };
	    /** @deprecated internal use only */ ArrayObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var array = this.array;
	        var count = array.length;
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(ArrayObservable.dispatch, 0, {
	                array: array, index: index, count: count, subscriber: subscriber
	            });
	        }
	        else {
	            for (var i = 0; i < count && !subscriber.closed; i++) {
	                subscriber.next(array[i]);
	            }
	            subscriber.complete();
	        }
	    };
	    return ArrayObservable;
	}(Observable_1.Observable));
	exports.ArrayObservable = ArrayObservable;
	//# sourceMappingURL=ArrayObservable.js.map

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(94);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var EmptyObservable = (function (_super) {
	    __extends(EmptyObservable, _super);
	    function EmptyObservable(scheduler) {
	        _super.call(this);
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable that emits no items to the Observer and immediately
	     * emits a complete notification.
	     *
	     * <span class="informal">Just emits 'complete', and nothing else.
	     * </span>
	     *
	     * <img src="./img/empty.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that only
	     * emits the complete notification. It can be used for composing with other
	     * Observables, such as in a {@link mergeMap}.
	     *
	     * @example <caption>Emit the number 7, then complete.</caption>
	     * var result = Rx.Observable.empty().startWith(7);
	     * result.subscribe(x => console.log(x));
	     *
	     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
	     * var interval = Rx.Observable.interval(1000);
	     * var result = interval.mergeMap(x =>
	     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
	     * );
	     * result.subscribe(x => console.log(x));
	     *
	     * // Results in the following to the console:
	     * // x is equal to the count on the interval eg(0,1,2,3,...)
	     * // x will occur every 1000ms
	     * // if x % 2 is equal to 1 print abc
	     * // if x % 2 is not equal to 1 nothing will be output
	     *
	     * @see {@link create}
	     * @see {@link never}
	     * @see {@link of}
	     * @see {@link throw}
	     *
	     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
	     * the emission of the complete notification.
	     * @return {Observable} An "empty" Observable: emits only the complete
	     * notification.
	     * @static true
	     * @name empty
	     * @owner Observable
	     */
	    EmptyObservable.create = function (scheduler) {
	        return new EmptyObservable(scheduler);
	    };
	    EmptyObservable.dispatch = function (arg) {
	        var subscriber = arg.subscriber;
	        subscriber.complete();
	    };
	    /** @deprecated internal use only */ EmptyObservable.prototype._subscribe = function (subscriber) {
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(EmptyObservable.dispatch, 0, { subscriber: subscriber });
	        }
	        else {
	            subscriber.complete();
	        }
	    };
	    return EmptyObservable;
	}(Observable_1.Observable));
	exports.EmptyObservable = EmptyObservable;
	//# sourceMappingURL=EmptyObservable.js.map

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(94);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ScalarObservable = (function (_super) {
	    __extends(ScalarObservable, _super);
	    function ScalarObservable(value, scheduler) {
	        _super.call(this);
	        this.value = value;
	        this.scheduler = scheduler;
	        this._isScalar = true;
	        if (scheduler) {
	            this._isScalar = false;
	        }
	    }
	    ScalarObservable.create = function (value, scheduler) {
	        return new ScalarObservable(value, scheduler);
	    };
	    ScalarObservable.dispatch = function (state) {
	        var done = state.done, value = state.value, subscriber = state.subscriber;
	        if (done) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(value);
	        if (subscriber.closed) {
	            return;
	        }
	        state.done = true;
	        this.schedule(state);
	    };
	    /** @deprecated internal use only */ ScalarObservable.prototype._subscribe = function (subscriber) {
	        var value = this.value;
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(ScalarObservable.dispatch, 0, {
	                done: false, value: value, subscriber: subscriber
	            });
	        }
	        else {
	            subscriber.next(value);
	            if (!subscriber.closed) {
	                subscriber.complete();
	            }
	        }
	    };
	    return ScalarObservable;
	}(Observable_1.Observable));
	exports.ScalarObservable = ScalarObservable;
	//# sourceMappingURL=ScalarObservable.js.map

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(192);
	function symbolIteratorPonyfill(root) {
	    var Symbol = root.Symbol;
	    if (typeof Symbol === 'function') {
	        if (!Symbol.iterator) {
	            Symbol.iterator = Symbol('iterator polyfill');
	        }
	        return Symbol.iterator;
	    }
	    else {
	        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
	        var Set_1 = root.Set;
	        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') {
	            return '@@iterator';
	        }
	        var Map_1 = root.Map;
	        // required for compatability with es6-shim
	        if (Map_1) {
	            var keys = Object.getOwnPropertyNames(Map_1.prototype);
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
	                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) {
	                    return key;
	                }
	            }
	        }
	        return '@@iterator';
	    }
	}
	exports.symbolIteratorPonyfill = symbolIteratorPonyfill;
	exports.iterator = symbolIteratorPonyfill(root_1.root);
	/**
	 * @deprecated use iterator instead
	 */
	exports.$$iterator = exports.iterator;
	//# sourceMappingURL=iterator.js.map

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(192);
	function getSymbolObservable(context) {
	    var $$observable;
	    var Symbol = context.Symbol;
	    if (typeof Symbol === 'function') {
	        if (Symbol.observable) {
	            $$observable = Symbol.observable;
	        }
	        else {
	            $$observable = Symbol('observable');
	            Symbol.observable = $$observable;
	        }
	    }
	    else {
	        $$observable = '@@observable';
	    }
	    return $$observable;
	}
	exports.getSymbolObservable = getSymbolObservable;
	exports.observable = getSymbolObservable(root_1.root);
	/**
	 * @deprecated use observable instead
	 */
	exports.$$observable = exports.observable;
	//# sourceMappingURL=observable.js.map

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(192);
	var Symbol = root_1.root.Symbol;
	exports.rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
	    Symbol.for('rxSubscriber') : '@@rxSubscriber';
	/**
	 * @deprecated use rxSubscriber instead
	 */
	exports.$$rxSubscriber = exports.rxSubscriber;
	//# sourceMappingURL=rxSubscriber.js.map

/***/ }),
/* 556 */
/***/ (function(module, exports) {

	"use strict";
	function isPromise(value) {
	    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
	}
	exports.isPromise = isPromise;
	//# sourceMappingURL=isPromise.js.map

/***/ }),
/* 557 */
/***/ (function(module, exports) {

	"use strict";
	function isScheduler(value) {
	    return value && typeof value.schedule === 'function';
	}
	exports.isScheduler = isScheduler;
	//# sourceMappingURL=isScheduler.js.map

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isStyledComponent;
	
	var babelPluginFlowReactPropTypes_proptype_Target = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_Target || __webpack_require__(2).any;
	
	function isStyledComponent(target) /* : %checks */{
	  return typeof target === 'function' && typeof target.styledComponentId === 'string';
	}
	module.exports = exports['default'];

/***/ }),
/* 559 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = doHash;
	// murmurhash2 via https://gist.github.com/raycmorgan/588423
	
	function doHash(str, seed) {
	  var m = 0x5bd1e995;
	  var r = 24;
	  var h = seed ^ str.length;
	  var length = str.length;
	  var currentIndex = 0;
	
	  while (length >= 4) {
	    var k = UInt32(str, currentIndex);
	
	    k = Umul32(k, m);
	    k ^= k >>> r;
	    k = Umul32(k, m);
	
	    h = Umul32(h, m);
	    h ^= k;
	
	    currentIndex += 4;
	    length -= 4;
	  }
	
	  switch (length) {
	    case 3:
	      h ^= UInt16(str, currentIndex);
	      h ^= str.charCodeAt(currentIndex + 2) << 16;
	      h = Umul32(h, m);
	      break;
	
	    case 2:
	      h ^= UInt16(str, currentIndex);
	      h = Umul32(h, m);
	      break;
	
	    case 1:
	      h ^= str.charCodeAt(currentIndex);
	      h = Umul32(h, m);
	      break;
	  }
	
	  h ^= h >>> 13;
	  h = Umul32(h, m);
	  h ^= h >>> 15;
	
	  return h >>> 0;
	}
	
	function UInt32(str, pos) {
	  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
	}
	
	function UInt16(str, pos) {
	  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
	}
	
	function Umul32(n, m) {
	  n = n | 0;
	  m = m | 0;
	  var nlo = n & 0xffff;
	  var nhi = n >>> 16;
	  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
	  return res;
	}
	module.exports = exports["default"];

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PartyCreditEntry = exports.BankTransaction = exports.BANKTRANSACTIONTYPE = void 0;
	var tslib_1 = __webpack_require__(3);
	var numberUtils_1 = __webpack_require__(143);
	var DomainAncestor_1 = __webpack_require__(33);
	var formUtils_1 = __webpack_require__(14);
	var mobx_1 = __webpack_require__(5);
	var BANKTRANSACTIONTYPE;
	(function (BANKTRANSACTIONTYPE) {
	    BANKTRANSACTIONTYPE["PAYMENT_IN"] = "PAYMENT_IN";
	    BANKTRANSACTIONTYPE["PAYMENT_OUT"] = "PAYMENT_OUT";
	    BANKTRANSACTIONTYPE["STANDINGORDER"] = "STANDINGORDER";
	    BANKTRANSACTIONTYPE["DIRECTDEBIT"] = "DIRECTDEBIT";
	    BANKTRANSACTIONTYPE["CARDPAYMENT"] = "CARDPAYMENT";
	    BANKTRANSACTIONTYPE["CASHPAYMENT"] = "CASHPAYMENT";
	    BANKTRANSACTIONTYPE["FEE"] = "FEE";
	    BANKTRANSACTIONTYPE["INTEREST"] = "INTEREST";
	    BANKTRANSACTIONTYPE["OTHER"] = "OTHER";
	})(BANKTRANSACTIONTYPE || (exports.BANKTRANSACTIONTYPE = BANKTRANSACTIONTYPE = {}));
	var BankTransaction = /** @class */ (function (_super) {
	    tslib_1.__extends(BankTransaction, _super);
	    function BankTransaction(json) {
	        return _super.call(this, json) || this;
	    }
	    BankTransaction.prototype.fromJson = function (json) {
	        _super.prototype.fromJson.call(this, json);
	        return this;
	    };
	    BankTransaction.prototype.getId = function () {
	        return this.bankTransactionId;
	    };
	    BankTransaction.prototype.setId = function (id) {
	        this.bankTransactionId = id;
	        this.id = id;
	    };
	    BankTransaction.prototype.getFullAmount = function () {
	        return (0, numberUtils_1.formatNumber)(this.amount, numberUtils_1.DEFAULT_CURRENCY_FORMAT) + " " + (0, formUtils_1.lovValue)(this.currency);
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "bankTransactionId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "account", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "valueDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "amount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "currency", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "bankReference", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "counterPartyAccountNo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "counterPartyAccountName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "counterPartyBankCode", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "counterPartyBankName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "bic", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "transactionType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "fioType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "vs", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "ss", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "ks", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "userReference", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "messageForBeneficiary", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "description", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "executedBy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "counterParty", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BankTransaction.prototype, "timeOfInvoiceMatch", void 0);
	    BankTransaction = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], BankTransaction);
	    return BankTransaction;
	}(DomainAncestor_1.DomainAncestor));
	exports.BankTransaction = BankTransaction;
	var PartyCreditEntry = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyCreditEntry, _super);
	    function PartyCreditEntry(json) {
	        return _super.call(this, json) || this;
	    }
	    PartyCreditEntry.prototype.fromJson = function (json) {
	        _super.prototype.fromJson.call(this, json);
	        return this;
	    };
	    PartyCreditEntry.prototype.getId = function () {
	        return this.creditEntryId;
	    };
	    PartyCreditEntry.prototype.setId = function (id) {
	        this.creditEntryId = id;
	        this.id = id;
	    };
	    PartyCreditEntry.prototype.getFullAmount = function () {
	        return (0, numberUtils_1.formatNumber)(this.amount, numberUtils_1.DEFAULT_CURRENCY_FORMAT) + " " + (0, formUtils_1.lovValue)(this.currency);
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyCreditEntry.prototype, "creditEntryId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyCreditEntry.prototype, "party", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyCreditEntry.prototype, "valueDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyCreditEntry.prototype, "amount", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyCreditEntry.prototype, "currency", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyCreditEntry.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyCreditEntry.prototype, "paymentType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyCreditEntry.prototype, "creditNote", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyCreditEntry.prototype, "bankTransaction", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyCreditEntry.prototype, "invoicePayment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyCreditEntry.prototype, "matchType", void 0);
	    PartyCreditEntry = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], PartyCreditEntry);
	    return PartyCreditEntry;
	}(DomainAncestor_1.DomainAncestor));
	exports.PartyCreditEntry = PartyCreditEntry;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MdCertificateBeanConfig = exports.MdCertificate = exports.CERTFORMAT = exports.CERTTYPE = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var CERTTYPE;
	(function (CERTTYPE) {
	    CERTTYPE["CAROOT"] = "CAROOT";
	    CERTTYPE["CAINTERMEDIATE"] = "CAINTERMEDIATE";
	    CERTTYPE["PUBLIC"] = "PUBLIC";
	    CERTTYPE["PRIVATE"] = "PRIVATE";
	})(CERTTYPE || (exports.CERTTYPE = CERTTYPE = {}));
	var CERTFORMAT;
	(function (CERTFORMAT) {
	    CERTFORMAT["X509_BASE64"] = "X509_BASE64";
	    CERTFORMAT["X509_BINARY"] = "X509_BINARY";
	    CERTFORMAT["PKCS_12"] = "PKCS_12";
	})(CERTFORMAT || (exports.CERTFORMAT = CERTFORMAT = {}));
	var MdCertificate = /** @class */ (function (_super) {
	    tslib_1.__extends(MdCertificate, _super);
	    function MdCertificate(json) {
	        return _super.call(this, json) || this;
	    }
	    MdCertificate.prototype.getId = function () {
	        return this.certificateId;
	    };
	    MdCertificate.prototype.setId = function (id) {
	        this.certificateId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdCertificate.prototype, "certificateId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdCertificate.prototype, "serialNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdCertificate.prototype, "issuerId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdCertificate.prototype, "certType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdCertificate.prototype, "valid", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdCertificate.prototype, "changeDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdCertificate.prototype, "fromDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdCertificate.prototype, "toDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdCertificate.prototype, "validError", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdCertificate.prototype, "subjectCn", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdCertificate.prototype, "issuerCn", void 0);
	    MdCertificate = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], MdCertificate);
	    return MdCertificate;
	}(DomainAncestor_1.DomainAncestor));
	exports.MdCertificate = MdCertificate;
	var MdCertificateBeanConfig = /** @class */ (function (_super) {
	    tslib_1.__extends(MdCertificateBeanConfig, _super);
	    function MdCertificateBeanConfig(json) {
	        return _super.call(this, json) || this;
	    }
	    MdCertificateBeanConfig.prototype.getId = function () {
	        return this.beanName;
	    };
	    MdCertificateBeanConfig.prototype.setId = function (id) {
	        this.beanName = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdCertificateBeanConfig.prototype, "beanName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdCertificateBeanConfig.prototype, "certificate", void 0);
	    MdCertificateBeanConfig = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], MdCertificateBeanConfig);
	    return MdCertificateBeanConfig;
	}(DomainAncestor_1.DomainAncestor));
	exports.MdCertificateBeanConfig = MdCertificateBeanConfig;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.handleFavicon = handleFavicon;
	exports.removeFaviconLink = removeFaviconLink;
	var tslib_1 = __webpack_require__(3);
	var isString_1 = tslib_1.__importDefault(__webpack_require__(163));
	var iconCache = {};
	/**
	 * viewClass - pokud je string je to primo iconName, jinak se ceka viewClass.icinLink nebo viewClass.icon (name)
	 * @param viewClass
	 */
	function handleFavicon(viewClass) {
	    if (!viewClass)
	        return;
	    var iconName = ((0, isString_1.default)(viewClass)) ? viewClass : viewClass.icon;
	    if (iconName) {
	        window.setTimeout(function () {
	            var iconLink = createFaviconLink(iconName, '#000');
	            document.getElementsByTagName('head')[0].appendChild(iconLink);
	        }, 160);
	    }
	}
	function createFaviconLink(icon, color, bg) {
	    var link = iconCache[icon];
	    if (link) {
	        return link;
	    }
	    var container = document.createElement('div'), span = document.createElement('span'), body = document.body, content, canvas = document.createElement('canvas'), getContext = function (w) {
	        canvas.width = canvas.height = w;
	        context = canvas.getContext('2d');
	        context.font = 'normal normal normal 32px/' + w + 'px FontAwesome';
	        context.textBaseline = 'middle';
	        return context;
	    }, context = getContext(32), iconWidth;
	    link = document.createElement('link');
	    if (!window.getComputedStyle || !canvas.toDataURL || !document.querySelectorAll) {
	        return null;
	    }
	    container.style.display = 'none';
	    span.className = 'fa fa-' + icon.replace(/^fa-/, '');
	    container.appendChild(span);
	    body.appendChild(container);
	    content = window.getComputedStyle(span, ':before').getPropertyValue('content').replace(/['"]/g, '');
	    console.log('favicon content ' + content);
	    body.removeChild(container);
	    iconWidth = context.measureText(content).width;
	    if (iconWidth > canvas.width) {
	        context = getContext(iconWidth);
	    }
	    if (bg) {
	        context.rect(0, 0, canvas.width, canvas.height);
	        context.fillStyle = bg;
	        context.fill();
	    }
	    context.fillStyle = color;
	    context.fillText(content, (canvas.width - iconWidth) / 2, canvas.height / 2);
	    link.setAttribute('rel', 'icon');
	    link.setAttribute('type', 'image/png');
	    link.setAttribute('href', canvas.toDataURL('image/png'));
	    iconCache[icon] = link;
	    return link;
	}
	function removeFaviconLink() {
	    for (var icons = document.querySelectorAll('link[rel*=icon]'), i = 0, l = icons.length; i < l; i++) {
	        icons[i].parentNode.removeChild(icons[i]);
	    }
	}


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SmsMessage = exports.Send = exports.Message = exports.Close = exports.Add = exports.EventNote = exports.Print = exports.Edit = exports.Email = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var email_1 = tslib_1.__importDefault(__webpack_require__(1594));
	var message_1 = tslib_1.__importDefault(__webpack_require__(1596));
	var sms_1 = tslib_1.__importDefault(__webpack_require__(1612));
	var mode_edit_1 = tslib_1.__importDefault(__webpack_require__(1601));
	var print_1 = tslib_1.__importDefault(__webpack_require__(1593));
	var event_note_1 = tslib_1.__importDefault(__webpack_require__(1611));
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var send_1 = tslib_1.__importDefault(__webpack_require__(1599));
	var close_1 = tslib_1.__importDefault(__webpack_require__(1609));
	var colors_1 = __webpack_require__(29);
	var Email = function () { return (react_1.default.createElement(email_1.default, { color: colors_1.grey400 })); };
	exports.Email = Email;
	var Edit = function () { return (react_1.default.createElement(mode_edit_1.default, { color: colors_1.grey400 })); };
	exports.Edit = Edit;
	var Print = function () { return (react_1.default.createElement(print_1.default, { color: colors_1.grey400 })); };
	exports.Print = Print;
	var EventNote = function () { return (react_1.default.createElement(event_note_1.default, { color: colors_1.grey400 })); };
	exports.EventNote = EventNote;
	var Add = function () { return (react_1.default.createElement(add_1.default, { color: colors_1.grey400 })); };
	exports.Add = Add;
	var Close = function () { return (react_1.default.createElement(close_1.default, { color: colors_1.grey400 })); };
	exports.Close = Close;
	var Message = function () { return (react_1.default.createElement(message_1.default, { color: colors_1.grey400 })); };
	exports.Message = Message;
	var Send = function () { return (react_1.default.createElement(send_1.default, { color: colors_1.grey400 })); };
	exports.Send = Send;
	var SmsMessage = function () { return (react_1.default.createElement(sms_1.default, { color: colors_1.grey400 })); };
	exports.SmsMessage = SmsMessage;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var draft_js_1 = __webpack_require__(202);
	var mobx_react_1 = __webpack_require__(4);
	__webpack_require__(1281);
	var EmailBodyEditor = /** @class */ (function (_super) {
	    tslib_1.__extends(EmailBodyEditor, _super);
	    function EmailBodyEditor() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleKeyCommand = function (command) {
	            var newState = draft_js_1.RichUtils.handleKeyCommand(_this.props.editorState, command);
	            if (newState) {
	                _this.props.onChange(newState);
	                return 'handled';
	            }
	            return 'not-handled';
	        };
	        _this.onTab = function (e) {
	            var maxDepth = 4;
	            _this.props.onChange(draft_js_1.RichUtils.onTab(e, _this.props.editorState, maxDepth));
	        };
	        _this.toggleBlockType = function (blockType) {
	            _this.props.onChange(draft_js_1.RichUtils.toggleBlockType(_this.props.editorState, blockType));
	        };
	        _this.toggleInlineStyle = function (inlineStyle) {
	            _this.props.onChange(draft_js_1.RichUtils.toggleInlineStyle(_this.props.editorState, inlineStyle));
	        };
	        _this.focus = function () { return _this.editorRef.focus(); };
	        _this.editorRefHandler = function (c) { return _this.editorRef = c; };
	        return _this;
	    }
	    EmailBodyEditor.prototype.componentDidMount = function () {
	        this.focus();
	    };
	    EmailBodyEditor.prototype.render = function () {
	        // If the user changes block type before entering any text, we can
	        // either style the placeholder or hide it. Let's just hide it now.
	        var className = 'RichEditor-editor';
	        var contentState = this.props.editorState.getCurrentContent();
	        if (!contentState.hasText()) {
	            if (contentState.getBlockMap().first().getType() !== 'unstyled') {
	                className += ' RichEditor-hidePlaceholder';
	            }
	        }
	        return (react_1.default.createElement("div", { className: "RichEditor-root", style: this.props.style },
	            react_1.default.createElement(BlockStyleControls, { editorState: this.props.editorState, onToggle: this.toggleBlockType }),
	            react_1.default.createElement(InlineStyleControls, { editorState: this.props.editorState, onToggle: this.toggleInlineStyle }),
	            react_1.default.createElement("div", { className: className, onClick: this.focus },
	                react_1.default.createElement(draft_js_1.Editor, { blockStyleFn: getBlockStyle, customStyleMap: styleMap, editorState: this.props.editorState, handleKeyCommand: this.handleKeyCommand, onChange: this.props.onChange, onTab: this.onTab, ref: this.editorRefHandler, spellCheck: true }))));
	    };
	    EmailBodyEditor = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EmailBodyEditor);
	    return EmailBodyEditor;
	}(react_1.default.Component));
	exports.default = EmailBodyEditor;
	// Custom overrides for "code" style.
	var styleMap = {
	    CODE: {
	        backgroundColor: 'rgba(0, 0, 0, 0.05)',
	        fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
	        fontSize: 16,
	        padding: 2,
	    },
	};
	function getBlockStyle(block) {
	    switch (block.getType()) {
	        case 'blockquote': return 'RichEditor-blockquote';
	        default: return null;
	    }
	}
	var StyleButton = /** @class */ (function (_super) {
	    tslib_1.__extends(StyleButton, _super);
	    function StyleButton() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onToggle = function (e) {
	            e.preventDefault();
	            _this.props.onToggle(_this.props.style);
	        };
	        return _this;
	    }
	    StyleButton.prototype.render = function () {
	        var className = 'RichEditor-styleButton';
	        if (this.props.active) {
	            className += ' RichEditor-activeButton';
	        }
	        return (react_1.default.createElement("span", { className: className, onMouseDown: this.onToggle }, this.props.label));
	    };
	    return StyleButton;
	}(react_1.default.Component));
	var BLOCK_TYPES = [
	    { label: 'H1', style: 'header-one' },
	    { label: 'H2', style: 'header-two' },
	    { label: 'H3', style: 'header-three' },
	    { label: 'H4', style: 'header-four' },
	    { label: 'H5', style: 'header-five' },
	    { label: 'H6', style: 'header-six' },
	    { label: 'Blockquote', style: 'blockquote' },
	    { label: 'UL', style: 'unordered-list-item' },
	    { label: 'OL', style: 'ordered-list-item' },
	    { label: 'Code Block', style: 'code-block' },
	];
	var BlockStyleControls = function (props) {
	    var editorState = props.editorState;
	    var selection = editorState.getSelection();
	    var blockType = editorState
	        .getCurrentContent()
	        .getBlockForKey(selection.getStartKey())
	        .getType();
	    return (react_1.default.createElement("div", { className: "RichEditor-controls" }, BLOCK_TYPES.map(function (type) {
	        return react_1.default.createElement(StyleButton, { key: type.label, active: type.style === blockType, label: type.label, onToggle: props.onToggle, style: type.style });
	    })));
	};
	var INLINE_STYLES = [
	    { label: 'Bold', style: 'BOLD' },
	    { label: 'Italic', style: 'ITALIC' },
	    { label: 'Underline', style: 'UNDERLINE' },
	    { label: 'Monospace', style: 'CODE' },
	];
	var InlineStyleControls = function (props) {
	    var currentStyle = props.editorState.getCurrentInlineStyle();
	    return (react_1.default.createElement("div", { className: "RichEditor-controls" }, INLINE_STYLES.map(function (type) {
	        return react_1.default.createElement(StyleButton, { key: type.label, active: currentStyle.has(type.style), label: type.label, onToggle: props.onToggle, style: type.style });
	    })));
	};


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var react_dropzone_1 = tslib_1.__importDefault(__webpack_require__(845));
	var mdField_1 = tslib_1.__importDefault(__webpack_require__(57));
	var createForm_1 = __webpack_require__(18);
	var blockComp_1 = __webpack_require__(30);
	var icons_1 = __webpack_require__(63);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var formUtils_1 = __webpack_require__(14);
	var documentService_1 = tslib_1.__importDefault(__webpack_require__(110));
	var arrayUtils_1 = __webpack_require__(78);
	var blockComp_2 = __webpack_require__(30);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var loading_1 = __webpack_require__(262);
	var mobx_react_1 = __webpack_require__(4);
	var mdField_2 = __webpack_require__(57);
	var mdField_3 = __webpack_require__(57);
	var mobx_1 = __webpack_require__(5);
	var DocumentTemplateResourceList = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentTemplateResourceList, _super);
	    function DocumentTemplateResourceList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onOpenDropzone = function () {
	            _this._dropzone.open();
	        };
	        _this.onDrop = function (files) {
	            console.log('onDrop ', files);
	            _this.props.documentTemplateObject.$loading = true;
	            var promiseArray = files.map(function (file) { return documentService_1.default.loadFile(file); });
	            Promise.all(promiseArray).then(function (resultArray) {
	                for (var _i = 0, resultArray_1 = resultArray; _i < resultArray_1.length; _i++) {
	                    var resource = resultArray_1[_i];
	                    _this.props.documentTemplateObject.resources.set(resource.name, resource);
	                }
	                _this.props.documentTemplateObject.$dirty = true;
	                _this.props.documentTemplateObject.$loading = false;
	            }, function (err) {
	                _this.props.documentTemplateObject.$loading = false;
	            });
	        };
	        return _this;
	    }
	    DocumentTemplateResourceList.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, documentTemplateObject = _a.documentTemplateObject, entities = _a.entities, showType = _a.showType;
	        var header = (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
	            react_1.default.createElement("div", null, "Resources"),
	            react_1.default.createElement(icons_1.MdIconButton, { onClick: this.onOpenDropzone },
	                react_1.default.createElement(add_1.default, null))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true, header: header, style: { display: 'flex', flexDirection: 'column' } },
	            (documentTemplateObject.$loading) ? react_1.default.createElement(loading_1.LoadingElement, null) : null,
	            react_1.default.createElement(react_dropzone_1.default, { ref: function (c) { return _this._dropzone = c; }, onDrop: this.onDrop, style: { display: 'none' } }),
	            (0, arrayUtils_1.addSeparator)(documentTemplateObject.resources.entries()
	                .sort(function (a, b) { return a[0].localeCompare(b[0]); })
	                .map(function (pair, index, array) { return react_1.default.createElement(DocumentTemplateResourceForm, { dataObject: pair[1], rootObject: documentTemplateObject, key: index, entities: entities, entity: entities.get('DocumentTemplateResource'), index: index, showType: showType }); }), react_1.default.createElement(blockComp_2.MdDivider, { inset: true }))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], DocumentTemplateResourceList.prototype, "onDrop", void 0);
	    DocumentTemplateResourceList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], DocumentTemplateResourceList);
	    return DocumentTemplateResourceList;
	}(react_1.default.Component));
	exports.default = DocumentTemplateResourceList;
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { fontSize: 14, lineHeight: '14px', minHeight: 20 } },
	        react_1.default.createElement("a", { href: "data:" + dataObject.contentType + ";base64," + dataObject.content, target: "_blank", style: { marginRight: 10 } }, dataObject.name),
	        react_1.default.createElement(formUtils_1.FieldText, { label: fields.size.textLabel, value: dataObject.size, mdField: fields.size.mdField }),
	        react_1.default.createElement(formUtils_1.FieldText, { label: fields.contentType.textLabel, value: dataObject.contentType }),
	        react_1.default.createElement(formUtils_1.FieldText, { label: fields.lastModified.textLabel, value: dataObject.lastModified, mdField: fields.lastModified.mdField }),
	        react_1.default.createElement(formUtils_1.FieldText, { label: fields.type.textLabel, value: dataObject.type }),
	        react_1.default.createElement(formUtils_1.FieldText, { label: fields.qualifyExpression.textLabel, value: dataObject.qualifyExpression })));
	};
	var DocumentTemplateResourceForm = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentTemplateResourceForm, _super);
	    function DocumentTemplateResourceForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDelete = function (evt) {
	            evt.stopPropagation();
	            console.log('onDelete %o', _this.props.dataObject);
	            _this.props.rootObject.resources =
	                _this.props.rootObject.resources.values().reduce(function (acc, resource) {
	                    if (resource !== _this.props.dataObject) {
	                        acc.set(resource.name, resource);
	                    }
	                    return acc;
	                }, mobx_1.observable.map());
	        };
	        return _this;
	    }
	    DocumentTemplateResourceForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, index = _a.index, entities = _a.entities, showType = _a.showType, formName = _a.formName, entity = _a.entity;
	        var fields = dataObject.getFormFields(formName);
	        var name = fields.name, lastModified = fields.lastModified, size = fields.size, contentType = fields.contentType, type = fields.type, qualifyExpression = fields.qualifyExpression;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", null,
	                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props)),
	                react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value })),
	            showType ?
	                react_1.default.createElement("div", null,
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, type.props)))
	                : null,
	            react_1.default.createElement("div", null,
	                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, qualifyExpression.props)))));
	        var _b = this.props, showTypeRenamed = _b.showType, activeItemProps = tslib_1.__rest(_b, ["showType"]);
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), key: index, onDelete: this.onDelete }, activeItemProps)));
	    };
	    DocumentTemplateResourceForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: ' DocumentTemplateResourceForm',
	            closedOnNew: true,
	            fields: [{
	                    name: 'name',
	                    validators: ['IsRequired'],
	                    mdField: new mdField_1.default({ label: 'Name', dataType: mdField_3.DATATYPE.STRING })
	                }, {
	                    name: 'contentType',
	                    mdField: new mdField_1.default({ label: 'Type', dataType: mdField_3.DATATYPE.STRING })
	                }, {
	                    name: 'lastModified',
	                    mdField: new mdField_1.default({ label: 'File timestamp', dataType: mdField_3.DATATYPE.DATETIME })
	                }, {
	                    name: 'type',
	                    mdField: new mdField_1.default({ label: 'Usage', valueSource: 'DOCUMENTTEMPLATERESOURCETYPE', valueSourceType: mdField_2.VALUESOURCETYPE.LOCAL })
	                }, {
	                    name: 'size',
	                    mdField: new mdField_1.default({ label: 'Size', dataType: mdField_3.DATATYPE.NUMBER })
	                }, {
	                    name: 'qualifyExpression',
	                    mdField: new mdField_1.default({ label: 'Qualify Expression', dataType: mdField_3.DATATYPE.STRING })
	                }]
	        }, ClosedContent),
	        mobx_react_1.observer
	    ], DocumentTemplateResourceForm);
	    return DocumentTemplateResourceForm;
	}(react_1.default.Component));


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var Subject_1 = __webpack_require__(260);
	__webpack_require__(309);
	var eventService_1 = tslib_1.__importDefault(__webpack_require__(120));
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var taskActivityBlocks_1 = __webpack_require__(933);
	var itemStream = new Subject_1.Subject();
	itemStream
	    .mergeMap(function (item) { return Promise.all([item, eventService_1.default.readPartyActivity(item.rowId), mdEntityService_1.default.fetchEntities(["PartyActivity"])]); }, null, 5)
	    .subscribe((0, mobx_1.action)("subscribe-actionCb", function (_a) {
	    var item = _a[0], activity = _a[1], entityMap = _a[2];
	    item.rowObject = activity;
	    item.expanded = 2;
	    console.log("ActivityExpando resolved activity %s", activity.partyActivityId);
	}));
	var MDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-left: 24px;\n"], ["\n  margin-left: 24px;\n"])));
	var ActivityExpando = /** @class */ (function (_super) {
	    tslib_1.__extends(ActivityExpando, _super);
	    function ActivityExpando() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ActivityExpando.prototype.componentDidMount = function () {
	        var item = this.props.item;
	        var activity = item.rowObject;
	        if (!activity) {
	            itemStream.next(item);
	        }
	    };
	    ActivityExpando.prototype.componentDidUpdate = function (prevProps, prevState) {
	        var item = this.props.item;
	        var activity = item.rowObject;
	        if (!activity && prevProps.item.rowId !== item.rowId) {
	            itemStream.next(item);
	        }
	    };
	    ActivityExpando.prototype.render = function () {
	        var item = this.props.item;
	        var activity = item.rowObject;
	        console.log("ActivityExpando render vehicle %s, expanded = %s", (activity) ? activity.partyActivityId : null, item.expanded);
	        if (item.expanded === 1) {
	            return (react_1.default.createElement(MDiv, null,
	                react_1.default.createElement("i", { className: "fa fa-refresh fa-2x fa-spin color-blue-grey-200" })));
	        }
	        return react_1.default.createElement(taskActivityBlocks_1.ActivityBlock, { activity: activity });
	    };
	    ActivityExpando = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ActivityExpando);
	    return ActivityExpando;
	}(react_1.default.Component));
	exports.default = ActivityExpando;
	var templateObject_1;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var fields_1 = __webpack_require__(20);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var errorComp_1 = __webpack_require__(34);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var dialogAncestor_1 = __webpack_require__(87);
	var eventDomain_1 = __webpack_require__(74);
	var emailBodyEditor_1 = tslib_1.__importDefault(__webpack_require__(564));
	var draft_js_1 = __webpack_require__(202);
	var draft_js_export_html_1 = __webpack_require__(442);
	var eventService_1 = tslib_1.__importDefault(__webpack_require__(120));
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var formUtils_1 = __webpack_require__(14);
	var createForm_1 = __webpack_require__(18);
	var react_bootstrap_1 = __webpack_require__(72);
	var Chip_1 = tslib_1.__importDefault(__webpack_require__(211));
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var commonDataService_1 = __webpack_require__(41);
	var partyDomain_1 = __webpack_require__(48);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var utils_1 = __webpack_require__(37);
	var colors_1 = __webpack_require__(29);
	var FlexDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
	var TaskDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(TaskDialog, _super);
	    function TaskDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.ok = function () {
	            console.log('TaskDialog OK');
	            commonService_1.default.loading(true);
	            _this.taskDto.bodyTemplate = (0, draft_js_export_html_1.stateToHTML)(_this.editorState.getCurrentContent());
	            eventService_1.default.createTask(_this.taskDto)
	                .then((0, mobx_1.action)("createTask-action", function () {
	                commonService_1.default.loading(false);
	                _this.dialogOpen = false;
	                _this.taskDto = null;
	                _this.resolve(null);
	            }), function (error) {
	                _this.$errors = error.getMessages();
	            });
	        };
	        _this.cancel = function (evt) {
	            console.log('TaskDialog#cancel evt = %O', evt);
	            _this.taskDto = null;
	            _this.dialogOpen = false;
	            _this.reject(null);
	        };
	        _this.onChangeSubject = function (evt) {
	            _this.taskDto.subjectTemplate = evt.target.value;
	        };
	        _this.onChangeScheduledDate = function (value) {
	            _this.taskDto.scheduledDate = value;
	            if (value && (0, moment_1.default)().startOf('day').isAfter(value)) {
	                _this.taskDto.$scheduledDateError = "Date must be current day or bigger";
	            }
	            else {
	                _this.taskDto.$scheduledDateError = undefined;
	            }
	        };
	        _this.onChangeBody = function (editorState) {
	            _this.editorState = editorState;
	        };
	        return _this;
	    }
	    TaskDialog.prototype.open = function (resolve, reject, gridParams) {
	        var _this = this;
	        var _a = this.props, entities = _a.entities, location = _a.location, taskType = _a.taskType;
	        uiService_1.default.showToolbarActionFlag();
	        console.log('TaskDialog: Opening dialog for ', gridParams);
	        this.resolve = resolve;
	        this.reject = reject;
	        this.$errors = null;
	        this.editorState = draft_js_1.EditorState.createEmpty();
	        Promise.all([mdEntityService_1.default.fetchEntities([{ entity: "ACTIVITYTYPE", lov: true }, { entity: "TASKTYPE", lov: true }]), eventService_1.default.prepareTaskActivity(location, gridParams)])
	            .then((0, mobx_1.action)("open-promise-actionCb", function (_a) {
	            var entities = _a[0], statuses = _a[1];
	            _this.taskDto = new eventDomain_1.TaskDto({
	                statuses: statuses,
	                taskType: taskType,
	                type: entities.get("ACTIVITYTYPE").getLovItem(eventDomain_1.ACTIVITYTYPE.EMAIL),
	            });
	            _this.dialogOpen = true;
	            uiService_1.default.hideToolbarActionFlag();
	        }))
	            .catch(function (error) {
	            _this.reject(error);
	        });
	    };
	    TaskDialog.prototype.componentWillUnmount = function () {
	        this.taskDto = null;
	    };
	    TaskDialog.prototype.render = function () {
	        var _a = this.props, entities = _a.entities, taskType = _a.taskType;
	        if (!(this.taskDto && this.dialogOpen))
	            return null;
	        console.debug("rendering TaskDialog ", this.taskDto);
	        var allHasEmail = (this.taskDto.statuses.length === this.taskDto.statuses.filter(function (es) { return es.partyActivity.persons.filter(function (pLov) { return pLov._emailAddresses && pLov._emailAddresses.length; }).length; }).length);
	        return (react_1.default.createElement(Dialog_1.default, { actions: [react_1.default.createElement(FlatButton_1.default, { key: "0", label: "Cancel", tabIndex: 0, primary: true, onClick: this.cancel }), react_1.default.createElement(FlatButton_1.default, { key: "1", label: "Ok", disabled: !allHasEmail || !this.taskDto.scheduledDate || !!this.taskDto.$scheduledDateError, secondary: true, onClick: this.ok })
	            ], modal: true, title: entities.get("TASKTYPE").getLovItemLabel(taskType), open: this.dialogOpen, contentStyle: { width: '80%', maxWidth: 800 }, bodyStyle: { overflowY: 'auto' } },
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: this.$errors }),
	            react_1.default.createElement("div", { style: { display: 'flex', marginBottom: 15 } },
	                react_1.default.createElement("div", { style: { paddingTop: 25, marginRight: 20 } }, "Email will be send to these Sales reps on"),
	                react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({ value: this.taskDto.scheduledDate, onChange: this.onChangeScheduledDate, hintText: "Scheduled Date", errorText: this.taskDto.$scheduledDateError }, createForm_1.fieldStyles.small.textField))),
	            react_1.default.createElement("div", { style: { marginBottom: 10 } }, this.taskDto.statuses.map(function (es, i) { return (react_1.default.createElement(TaskPartyActivityComp, { entityStatus: es, index: i, key: i })); })),
	            react_1.default.createElement(fields_1.MdTextField, { value: this.taskDto.subjectTemplate, onChange: this.onChangeSubject, fullWidth: true, style: { marginTop: 10 }, hintText: "Subject" }),
	            react_1.default.createElement(emailBodyEditor_1.default, { editorState: this.editorState, onChange: this.onChangeBody, style: { height: 400 } })));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskDialog.prototype, "editorState", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskDialog.prototype, "taskDto", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], TaskDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], TaskDialog.prototype, "ok", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], TaskDialog.prototype, "cancel", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], TaskDialog.prototype, "onChangeSubject", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], TaskDialog.prototype, "onChangeScheduledDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], TaskDialog.prototype, "onChangeBody", void 0);
	    TaskDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], TaskDialog);
	    return TaskDialog;
	}(dialogAncestor_1.DialogAncestor));
	exports.default = TaskDialog;
	var TaskPartyActivityComp = /** @class */ (function (_super) {
	    tslib_1.__extends(TaskPartyActivityComp, _super);
	    function TaskPartyActivityComp() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.addMe = function (evt) {
	            console.log('TaskDialog#addMe evt = %O', evt);
	            var entityStatus = _this.props.entityStatus;
	            var mePartyLov = securityService_1.default.currentUser.getMePartyLov();
	            var index = entityStatus.partyActivity.persons.findIndex(function (pLov) { return pLov.value === mePartyLov.value; });
	            if (index === -1) {
	                mePartyLov["emailAddresses"] = [securityService_1.default.currentUser.email];
	                entityStatus.partyActivity.persons.push(mePartyLov);
	            }
	        };
	        _this.onChangeAddPerson = function (valueLov) {
	            console.log('TaskDialog#addPerson value = %O', valueLov);
	            var entityStatus = _this.props.entityStatus;
	            if (valueLov) {
	                var index = entityStatus.partyActivity.persons.findIndex(function (pLov) { return pLov.value === valueLov.value; });
	                if (index === -1) {
	                    entityStatus.partyActivity.persons.push(valueLov);
	                }
	            }
	        };
	        _this.onChangeCc = function (evt) {
	            var entityStatus = _this.props.entityStatus;
	            _this.ccText = evt.target.value;
	            entityStatus.emails = (_this.ccText) ? _this.ccText.split(',').filter(function (s) { return s; }).map(function (s) { return s.trim(); }) : [];
	        };
	        return _this;
	    }
	    TaskPartyActivityComp.prototype.componentWillMount = function () {
	        var entityStatus = this.props.entityStatus;
	        var strings = (0, eventDomain_1.ccEmailAddress)(entityStatus.partyActivity.emailRecipients);
	        this.ccText = strings.join(", ");
	        entityStatus.emails = strings;
	    };
	    TaskPartyActivityComp.prototype.render = function () {
	        var entityStatus = this.props.entityStatus;
	        var isValid = entityStatus.partyActivity.persons.filter(function (pLov) { return pLov._emailAddresses && pLov._emailAddresses.length; }).length;
	        return (react_1.default.createElement("div", { style: { position: 'relative' } },
	            react_1.default.createElement("div", { style: {
	                    position: 'absolute',
	                    right: 5,
	                    top: 0,
	                    fontSize: 12,
	                    color: colors_1.grey400
	                } }, (0, formUtils_1.lovLabel)(entityStatus.partyActivity.customer)),
	            react_1.default.createElement(FlexDiv, { style: { display: 'flex', flexWrap: 'wrap' } }, entityStatus.partyActivity.persons.map(function (pLov, index) { return react_1.default.createElement(PersonChip, { partyActivity: entityStatus.partyActivity, index: index, pLov: pLov, key: pLov.value }); })),
	            react_1.default.createElement("div", { className: "row", style: { marginTop: 10 } },
	                react_1.default.createElement("div", { className: "fx col-xs-6", style: { paddingLeft: 5 } },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { name: "addPerson", floatingLabelText: "Add Person", value: this.newPerson, async: true, fullWidth: true, onChange: this.onChangeAddPerson, clearable: false, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.CONTACT_ROLE, partyDomain_1.PARTYROLE.SALESREP_ROLE], emailAddresses: true }) }))),
	                react_1.default.createElement("div", { className: "col-xs-2", style: { paddingRight: 25, paddingTop: 10 } },
	                    react_1.default.createElement(FlatButton_1.default, { label: "Add Me", secondary: true, onClick: this.addMe })),
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, createForm_1.fieldStyles.small.textField, { value: this.ccText, onChange: this.onChangeCc, fullWidth: true, floatingLabelText: "CC Emails (delimited by comma)" })))),
	            (!isValid) ? react_1.default.createElement("div", { className: "color-red-500" }, "No Person with email address selected") : null));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskPartyActivityComp.prototype, "newPerson", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskPartyActivityComp.prototype, "ccText", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], TaskPartyActivityComp.prototype, "addMe", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], TaskPartyActivityComp.prototype, "onChangeAddPerson", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], TaskPartyActivityComp.prototype, "onChangeCc", void 0);
	    TaskPartyActivityComp = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], TaskPartyActivityComp);
	    return TaskPartyActivityComp;
	}(react_1.default.Component));
	var __chipStyle = {
	    margin: "4px 8px 4px 0"
	};
	var PersonChip = /** @class */ (function (_super) {
	    tslib_1.__extends(PersonChip, _super);
	    function PersonChip() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleRequestDelete = function (evt) {
	            var _a = _this.props, partyActivity = _a.partyActivity, index = _a.index;
	            console.log("deleting: " + index);
	            partyActivity.persons.splice(index, 1);
	        };
	        _this.routeName = "partyDetail";
	        _this.onClick = function (event) {
	            event.preventDefault();
	            var pLov = _this.props.pLov;
	            _this.context.router.transitionTo(_this.routeName, { id: pLov.value });
	        };
	        return _this;
	    }
	    PersonChip.prototype.render = function () {
	        var pLov = this.props.pLov;
	        var emails = pLov._emailAddresses;
	        return (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "top", delayShow: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: pLov.value + "_personTooltip" }, (emails && emails.length) ? emails.join(", ") : "") },
	            react_1.default.createElement(Chip_1.default, { onRequestDelete: this.handleRequestDelete, style: __chipStyle },
	                react_1.default.createElement("a", { href: this.context.router.makeHref(this.routeName, { id: pLov.value }, (0, utils_1.addTenantToQuery)()), onClick: this.onClick }, (0, formUtils_1.lovLabel)(pLov)))));
	    };
	    PersonChip.contextTypes = {
	        router: prop_types_1.default.func.isRequired
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PersonChip.prototype, "handleRequestDelete", void 0);
	    PersonChip = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], PersonChip);
	    return PersonChip;
	}(react_1.default.Component));
	var templateObject_1;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MultiUpdateDialog = exports.MultiUpdateDto = exports.MultiUpdateField = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mdField_1 = tslib_1.__importStar(__webpack_require__(57));
	var form_1 = tslib_1.__importDefault(__webpack_require__(52));
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var validate_1 = __webpack_require__(24);
	var errorComp_1 = __webpack_require__(34);
	var icons_1 = __webpack_require__(63);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var mobx_1 = __webpack_require__(5);
	var DomainAncestor_1 = __webpack_require__(33);
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var formUtils_1 = __webpack_require__(14);
	var mobx_react_1 = __webpack_require__(4);
	var dialogAncestor_1 = __webpack_require__(87);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var conditionValueForm_1 = __webpack_require__(401);
	var pull = __webpack_require__(117);
	var SvgDelete = __webpack_require__(249);
	//@entityConfig()
	var MultiUpdateField = /** @class */ (function (_super) {
	    tslib_1.__extends(MultiUpdateField, _super);
	    function MultiUpdateField(mdEntity, fv, fn) {
	        if (fv === void 0) { fv = ""; }
	        if (fn === void 0) { fn = null; }
	        var _this = _super.call(this, null) || this;
	        _this.$entityRef = mdEntity;
	        _this.fieldValue = fv;
	        _this.fieldName = fn;
	        return _this;
	    }
	    MultiUpdateField.prototype.getMdEntity = function () {
	        return this.$entityRef;
	    };
	    MultiUpdateField.prototype.getMdField = function () {
	        if (!this.$fieldRef || this.$fieldRef.fieldName !== this.fieldName) {
	            this.$fieldRef = this.$entityRef.getField(this.fieldName);
	        }
	        return this.$fieldRef;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MultiUpdateField.prototype, "fieldName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MultiUpdateField.prototype, "fieldValue", void 0);
	    return MultiUpdateField;
	}(DomainAncestor_1.DomainAncestor));
	exports.MultiUpdateField = MultiUpdateField;
	//@entityConfig()
	var MultiUpdateDto = /** @class */ (function (_super) {
	    tslib_1.__extends(MultiUpdateDto, _super);
	    function MultiUpdateDto(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.fields)
	            _this.fields = [];
	        return _this;
	    }
	    MultiUpdateDto.newInstance = function (entityRef, fields, gridParams) {
	        var dto = new MultiUpdateDto();
	        dto.$entityRef = entityRef;
	        dto.entityName = entityRef.id;
	        dto.fields = mobx_1.observable.array(fields);
	        dto.gridParams = gridParams;
	        return dto;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(MultiUpdateField)
	    ], MultiUpdateDto.prototype, "fields", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MultiUpdateDto.prototype, "gridParams", void 0);
	    return MultiUpdateDto;
	}(DomainAncestor_1.DomainAncestor));
	exports.MultiUpdateDto = MultiUpdateDto;
	var extractFieldFn = function (dataObject, fieldDef) {
	    var mdField = dataObject.getMdField();
	    return (mdField) ? mdField : new mdField_1.default({ label: 'test', dataType: mdField_1.DATATYPE.STRING });
	};
	/* ************************************************************************************************
	 * ***********   DIALOG  *************************************************************
	 * ********************************************************************************************** */
	var MultiUpdateDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(MultiUpdateDialog, _super);
	    function MultiUpdateDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._customValidateForm = function (field) {
	            _this.$errors = [];
	            if (!field.fieldName) {
	                _this.$errors.push({ message: "Field name is required" });
	            }
	            return !_this.hasErrors();
	        };
	        _this.ok = function () {
	            var res = true;
	            for (var _i = 0, _a = _this.multiUpdateDto.fields; _i < _a.length; _i++) {
	                var field = _a[_i];
	                var form = field.getForm("MultiUpdateFieldForm");
	                res = form.validateForm(field) && res;
	                res = _this._customValidateForm(field) && res;
	            }
	            if (res) {
	                if (_this.editGrid) {
	                    var selectedRows = _this.grid.getSelectedRows();
	                    for (var _b = 0, selectedRows_1 = selectedRows; _b < selectedRows_1.length; _b++) {
	                        var gridRow = selectedRows_1[_b];
	                        var form = gridRow.rowObject.getForm(_this.editFormName);
	                        form.initForm(_this.multiUpdateDto.$entityRef, mdEntityService_1.default.entityMap, gridRow.rowObject, _this.rootObject, null);
	                        for (var _c = 0, _d = _this.multiUpdateDto.fields; _c < _d.length; _c++) {
	                            var fieldMU = _d[_c];
	                            form.setValue(_this.multiUpdateDto.$entityRef, gridRow.rowObject, form.getField(fieldMU.fieldName), fieldMU.fieldValue);
	                        }
	                        gridRow.rowObject.$dirty = true;
	                        _this.rootObject.$dirty = true;
	                        _this.grid.$dirty = true;
	                    }
	                    _this.dialogOpen = false;
	                    _this.resolve({ saveRequired: true });
	                }
	                else {
	                    commonService_1.default.loading(true);
	                    gridService_1.default.multiUpdate(_this.multiUpdateDto)
	                        .then(function (mud) {
	                        commonService_1.default.loading(false);
	                        _this.dialogOpen = false;
	                        _this.resolve({ saveRequired: false });
	                        commonService_1.default.notifySuccess("Fields ".concat(_this.multiUpdateDto.fields.map(function (muf) { return muf.getMdField().gridHeaderLabelActive; }).join(", "), " were updated on ").concat(mud.count, "  ").concat(_this.multiUpdateDto.$entityRef.label));
	                    }, function (error) {
	                        _this.$errors = error.getMessages();
	                    });
	                }
	            }
	        };
	        _this.cancel = function () {
	            _this.dialogOpen = false;
	            _this.reject("cancel");
	        };
	        _this.addField = function (evt) {
	            _this.multiUpdateDto.fields.push(new MultiUpdateField(_this.multiUpdateDto.$entityRef));
	        };
	        return _this;
	    }
	    MultiUpdateDialog.prototype.open = function (resolve, reject, grid, editFormName, rootObject) {
	        var gridParams = grid.createFullParams();
	        console.log('MultiUpdateDialog: Opening dialog for gridParams', gridParams);
	        this.resolve = resolve;
	        this.reject = reject;
	        this.dialogOpen = true;
	        this.grid = grid;
	        this.rootObject = rootObject;
	        this.multiUpdateDto = MultiUpdateDto.newInstance(grid.$entityRef, [new MultiUpdateField(grid.$entityRef)], gridParams);
	        this.editFormName = editFormName;
	        this.editGrid = (editFormName && (grid.isEditable() || grid.clientGrid));
	    };
	    MultiUpdateDialog.prototype.render = function () {
	        //console.log('MultiUpdateDialog: going to render dialog');
	        var _this = this;
	        if (!(this.multiUpdateDto && this.dialogOpen))
	            return null;
	        console.log('MultiUpdateDialog: rendering dialog');
	        var fieldOptions;
	        if (this.editGrid) {
	            var formDefinition = mdEntityService_1.default.getFormDefinition(this.editFormName);
	            if (!formDefinition)
	                throw new Error("Form Definition for formName " + this.editFormName + " does not exists in FORM_DEFINITION_REGISTRY");
	            var form = new form_1.default(this.editFormName, formDefinition);
	            var object = DomainAncestor_1.DomainAncestor.getInstance(this.multiUpdateDto.$entityRef.id, null);
	            var fields = form.setupFields(object, object, this.multiUpdateDto.$entityRef, mdEntityService_1.default.entityMap, null);
	            fieldOptions = Object.values(fields).filter(function (field) { return field.mdField.multiUpdate; })
	                .map(function (field) { return ({ value: field.name, label: field.mdField.label }); });
	        }
	        else {
	            fieldOptions = this.multiUpdateDto.$entityRef.getFields().filter(function (field) { return field.multiUpdate; })
	                .map(function (field) { return ({ value: field.fieldName, label: field.label }); });
	        }
	        var actions = [
	            react_1.default.createElement(FlatButton_1.default, { label: "Cancel", primary: true, onClick: this.cancel }),
	            react_1.default.createElement(FlatButton_1.default, { label: "Update", secondary: true, onClick: this.ok }),
	        ];
	        return (react_1.default.createElement(Dialog_1.default, { title: "Update Fields on ".concat(this.grid.getSelectedCount(), " ").concat(this.multiUpdateDto.$entityRef.label), actions: actions, modal: true, open: this.dialogOpen, contentStyle: { width: '60%', maxWidth: 'none' }, bodyStyle: { overflow: 'visible' } },
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: this.$errors }),
	            react_1.default.createElement("div", { style: { display: 'flex' } },
	                react_1.default.createElement("div", { style: { marginRight: 10, width: "40%" } }, "Select Field"),
	                react_1.default.createElement("div", { style: { marginRight: 10, width: "50%" } }, "Fill new value")),
	            this.multiUpdateDto.fields.map(function (field, index) {
	                return react_1.default.createElement(MultiUpdateFieldForm, { entities: mdEntityService_1.default.entityMap, key: index, index: index, dataObject: field, rootObject: _this.multiUpdateDto, fieldOptions: fieldOptions, extractFieldFn: extractFieldFn });
	            }),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("h5", { style: { display: 'flex', alignItems: 'center', margin: '0 0 0 5px', fontSize: 18 } },
	                    react_1.default.createElement("span", null, "Add Field"),
	                    react_1.default.createElement(icons_1.MdIconButton, { onClick: this.addField },
	                        react_1.default.createElement(add_1.default, null))))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], MultiUpdateDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], MultiUpdateDialog.prototype, "ok", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], MultiUpdateDialog.prototype, "cancel", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], MultiUpdateDialog.prototype, "addField", void 0);
	    MultiUpdateDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], MultiUpdateDialog);
	    return MultiUpdateDialog;
	}(dialogAncestor_1.DialogAncestor));
	exports.MultiUpdateDialog = MultiUpdateDialog;
	var MultiUpdateFieldForm = /** @class */ (function (_super) {
	    tslib_1.__extends(MultiUpdateFieldForm, _super);
	    function MultiUpdateFieldForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDelete = function (evt) {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject;
	            evt.stopPropagation();
	            console.log('onDelete %o', dataObject);
	            pull(rootObject.fields, dataObject);
	        };
	        _this.onChangeFieldName = function (newField) {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            dataObject.fieldName = (0, formUtils_1.lovValue)(newField);
	            dataObject.fieldValue = "";
	            form.updateFieldsPropValue(dataObject, "fieldValue");
	            console.log('onChangeFieldName %s', dataObject.fieldName);
	            var entitySpec = (dataObject.getMdField().hasLocalValueSource()) ? [{
	                    entity: dataObject.getMdField().valueSource,
	                    lov: true
	                }] : [];
	            return mdEntityService_1.default.fetchEntities(entitySpec)
	                .then((0, mobx_1.action)("onChangeFieldName-actionCb", function (entityMap) {
	                form.fields = form.setupFields(dataObject, rootObject, dataObject.getMdEntity(), _this.props.entities, function (dataObject, fieldDef) { return dataObject.getMdField(); });
	            }));
	        };
	        return _this;
	    }
	    MultiUpdateFieldForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, index = _a.index, form = _a.form, fieldOptions = _a.fieldOptions;
	        var _b = form.fields, fieldName = _b.fieldName, fieldValue = _b.fieldValue;
	        if (fieldValue.props.mdField.dataType === mdField_1.DATATYPE.BOOLEAN) {
	            fieldValue.props.onChange = function (evt) {
	                var value = (0, formUtils_1.lovValue)(evt);
	                fieldValue.props.value = evt;
	                dataObject.fieldValue = JSON.parse(value);
	            };
	        }
	        return (react_1.default.createElement("div", { style: { display: 'flex' } },
	            react_1.default.createElement("div", { style: { marginRight: 10, width: "40%" } },
	                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { name: "fieldColumn", value: dataObject.fieldName, options: fieldOptions, fullWidth: true, onChange: this.onChangeFieldName, clearable: false }))),
	            react_1.default.createElement("div", { style: { marginRight: 10, width: "50%" } }, (dataObject.fieldName) ?
	                react_1.default.createElement("div", null,
	                    react_1.default.createElement(conditionValueForm_1.FilterFieldComp, tslib_1.__assign({}, fieldValue.props, { showBooleanField: true, context: conditionValueForm_1.CONDITIONVALUEFORMCONTEXT.MULTIUPDATE })),
	                    react_1.default.createElement(validate_1.Validate, { field: fieldValue, value: fieldValue.props.value })) : null),
	            react_1.default.createElement(icons_1.MdIconButton, { style: { alignSelf: 'center' }, onClick: this.onDelete, disabled: !index },
	                react_1.default.createElement(SvgDelete, { size: 24 }))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], MultiUpdateFieldForm.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], MultiUpdateFieldForm.prototype, "onChangeFieldName", void 0);
	    MultiUpdateFieldForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'MultiUpdateFieldForm',
	            fields: [{
	                    name: 'fieldValue',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.fieldValue = (0, formUtils_1.lovValue)(value); },
	                    validators: function (mdField) { return (mdField.dataType === mdField_1.DATATYPE.NUMBER || mdField.dataType === mdField_1.DATATYPE.NUMBERCURRENCY) ? ['IsNumber'] : []; },
	                    usePlaceholder: true
	                }]
	        }, function () { return react_1.default.createElement("noscript", null); }),
	        mobx_react_1.observer
	    ], MultiUpdateFieldForm);
	    return MultiUpdateFieldForm;
	}(react_1.default.Component));


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var utils_1 = __webpack_require__(37);
	var mobx_1 = __webpack_require__(5);
	var jobDomain_1 = __webpack_require__(939);
	var JobService = /** @class */ (function () {
	    function JobService() {
	    }
	    JobService.prototype.readAvailableJobs = function () {
	        return axios_config_1.default.get('/core/job-available')
	            .then(function (response) { return response.data; });
	    };
	    JobService.prototype.readJob = function (id) {
	        var strings = (0, utils_1.parseId)(id);
	        return axios_config_1.default.get('/core/job/' + strings[0] + '/' + strings[1])
	            .then(function (response) { return new jobDomain_1.JobInfo(response.data); });
	    };
	    JobService.prototype.jobSave = function (jobDto) {
	        return axios_config_1.default.post('/core/job', jobDto, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    JobService.prototype.triggerExist = function (name) {
	        return axios_config_1.default.get('/core/job-trigger-exists', { params: { name: name } })
	            .then(function (response) { return response.data; });
	    };
	    JobService.prototype.cronCheck = function (cronexpression) {
	        return axios_config_1.default.get('/core/job-trigger-check-cron', { params: { cronexpression: cronexpression } })
	            .then(function (response) { return response.data; });
	    };
	    JobService.prototype.oneOff = function (jobObject) {
	        return axios_config_1.default.post('/core/job-one-off', jobObject, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    JobService.prototype.deleteJob = function (jobObject) {
	        return axios_config_1.default.delete('/core/job/' + jobObject.group + '/' + jobObject.name, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    JobService.prototype.switchState = function (trigger) {
	        return axios_config_1.default.post('/core/job-trigger-switch-state', trigger, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobService.prototype, "availableJobs", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobService.prototype, "jobObject", void 0);
	    return JobService;
	}());
	exports.default = new JobService();


/***/ }),
/* 570 */
/***/ (function(module, exports) {

	"use strict";
	/* ***************************** ENTITY ***************************** */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PARAM_TABLE_LIST = exports.TENANT_GROUP_ENTITY = exports.TENANT_ENTITY = exports.PARAM_TABLE_ENTITY = void 0;
	exports.PARAM_TABLE_ENTITY = "ParamTable";
	exports.TENANT_ENTITY = "Tenant";
	exports.TENANT_GROUP_ENTITY = "TenantGroup";
	/* ****************************** GRID ****************************** */
	exports.PARAM_TABLE_LIST = "paramTableList";


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PVADObjectDto = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pull = __webpack_require__(117);
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mdField_1 = tslib_1.__importStar(__webpack_require__(57));
	var createForm_1 = __webpack_require__(18);
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var styledDateInterval_1 = tslib_1.__importDefault(__webpack_require__(130));
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var fields_1 = __webpack_require__(20);
	var validate_1 = __webpack_require__(24);
	var numberUtils_1 = __webpack_require__(143);
	var productService_1 = tslib_1.__importDefault(__webpack_require__(131));
	var errorComp_1 = __webpack_require__(34);
	var SvgDelete = __webpack_require__(249);
	var icons_1 = __webpack_require__(63);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var mobx_1 = __webpack_require__(5);
	var DomainAncestor_1 = __webpack_require__(33);
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var formUtils_1 = __webpack_require__(14);
	var mobx_react_1 = __webpack_require__(4);
	var dialogAncestor_1 = __webpack_require__(87);
	var form_1 = __webpack_require__(52);
	var commonDomain_1 = __webpack_require__(310);
	var Stepper_1 = __webpack_require__(288);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var metaConstant_1 = __webpack_require__(13);
	var eventDomain_1 = __webpack_require__(74);
	var commonDataService_1 = __webpack_require__(41);
	var utils_1 = __webpack_require__(37);
	var react_router_1 = __webpack_require__(65);
	var PVADProductDto = /** @class */ (function (_super) {
	    tslib_1.__extends(PVADProductDto, _super);
	    function PVADProductDto() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PVADProductDto.prototype, "price", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PVADProductDto.prototype, "product", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PVADProductDto.prototype, "validFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PVADProductDto.prototype, "validTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PVADProductDto.prototype, "priceValidFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PVADProductDto.prototype, "setValidityFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PVADProductDto.prototype, "setValidityTo", void 0);
	    PVADProductDto = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], PVADProductDto);
	    return PVADProductDto;
	}(DomainAncestor_1.DomainAncestor));
	var PVADObjectDto = /** @class */ (function (_super) {
	    tslib_1.__extends(PVADObjectDto, _super);
	    function PVADObjectDto(json) {
	        return _super.call(this, json) || this;
	    }
	    PVADObjectDto.prototype.toBeModifiedVehicleCount = function () {
	        return (this.vehicleStatuses && this.vehicleStatuses.length) ? this.vehicleStatuses.filter(function (cs) { return cs.status !== commonDomain_1.SEVERITY.ERROR && cs.status !== commonDomain_1.SEVERITY.NOOP; }).length : 0;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(PVADProductDto)
	    ], PVADObjectDto.prototype, "products", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PVADObjectDto.prototype, "gridParams", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(eventDomain_1.EntityStatus)
	    ], PVADObjectDto.prototype, "vehicleStatuses", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PVADObjectDto.prototype, "part", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PVADObjectDto.prototype, "showErrors", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PVADObjectDto.prototype, "showNoOp", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PVADObjectDto.prototype, "selectedCount", void 0);
	    PVADObjectDto = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], PVADObjectDto);
	    return PVADObjectDto;
	}(DomainAncestor_1.DomainAncestor));
	exports.PVADObjectDto = PVADObjectDto;
	var ProductVehicleAssignDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(ProductVehicleAssignDialog, _super);
	    function ProductVehicleAssignDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._customValidateForm = function (product) {
	            _this.$errors = [];
	            if (product.price == null && product.priceValidFrom) {
	                _this.$errors.push({ message: "Price validFrom cannot be specified without price" });
	            }
	            return !_this.hasErrors();
	        };
	        _this.prepare = function () {
	            var res = true;
	            for (var _i = 0, _a = _this.PVADObject.products; _i < _a.length; _i++) {
	                var product = _a[_i];
	                var form = product.getForm("PVAForm");
	                res = form.validateForm(product) && res;
	                res = _this._customValidateForm(product) && res;
	            }
	            if (!res)
	                return;
	            commonService_1.default.loading(true);
	            productService_1.default.assignProducts(_this.PVADObject, 1).then(function (newPVADObject) {
	                commonService_1.default.loading(false);
	                _this.PVADObject.part = 2;
	                _this.PVADObject.showErrors = true;
	                _this.PVADObject.vehicleStatuses = newPVADObject.vehicleStatuses;
	            }, function (error) {
	                _this.$errors = error.getMessages();
	            });
	        };
	        _this.ok = function () {
	            commonService_1.default.loading(true);
	            productService_1.default.assignProducts(_this.PVADObject, 2).then(function (newPVADObject) {
	                commonService_1.default.loading(false);
	                _this.PVADObject.part = 3;
	                _this.PVADObject.showErrors = false;
	                _this.PVADObject.vehicleStatuses = newPVADObject.vehicleStatuses;
	            }, function (error) {
	                _this.$errors = error.getMessages();
	            });
	        };
	        _this.onShowErrors = function (evt) {
	            _this.PVADObject.showErrors = evt.target.checked;
	        };
	        _this.onShowNoOp = function (evt) {
	            _this.PVADObject.showNoOp = evt.target.checked;
	        };
	        _this.cancel = function () {
	            _this.dialogOpen = false;
	            _this.reject("cancel");
	        };
	        _this.close = function () {
	            _this.PVADObject = null;
	            _this.resolve(null);
	        };
	        _this.addProduct = function (evt) {
	            _this.PVADObject.products.push(new PVADProductDto());
	        };
	        return _this;
	    }
	    ProductVehicleAssignDialog.prototype.open = function (resolve, reject, grid) {
	        var _this = this;
	        var gridParams = grid.createFullParams();
	        console.log('ProductVehicleAssignDialog: Opening dialog for ', gridParams);
	        this.resolve = resolve;
	        this.reject = reject;
	        mdEntityService_1.default.fetchEntityMetadata(['ProductVehicle'])
	            .then((0, mobx_1.action)("open-callback", function (entities) {
	            _this.PVADObject = new PVADObjectDto({
	                products: [new PVADProductDto()],
	                gridParams: gridParams,
	                selectedCount: grid.getSelectedCount(),
	                vehicleStatuses: [],
	                part: 1,
	                showErrors: null
	            });
	            _this.dialogOpen = true;
	        }));
	    };
	    ProductVehicleAssignDialog.prototype.render = function () {
	        var _this = this;
	        if (!(this.PVADObject && this.dialogOpen))
	            return null;
	        var issuableCount = this.PVADObject.toBeModifiedVehicleCount();
	        var cancelButton = react_1.default.createElement(FlatButton_1.default, { key: "cancel", label: "Cancel", tabIndex: 0, primary: true, onClick: this.cancel });
	        var showErrorCheckbox = react_1.default.createElement(fields_1.MdCheckbox, { key: "showErrors", label: "Show Errors", checked: this.PVADObject.showErrors, labelStyle: { whiteSpace: 'nowrap' }, style: { display: 'inline-block', width: 140, verticalAlign: 'middle' }, onCheck: this.onShowErrors });
	        var showNoOpCheckbox = react_1.default.createElement(fields_1.MdCheckbox, { key: "showUnmodified", label: "Show Unmodified", checked: this.PVADObject.showNoOp, labelStyle: { whiteSpace: 'nowrap' }, style: { display: 'inline-block', width: 170, verticalAlign: 'middle' }, onCheck: this.onShowNoOp });
	        var actions;
	        if (this.PVADObject.part === 1) {
	            actions = [cancelButton, react_1.default.createElement(FlatButton_1.default, { key: "check", label: "Check", secondary: true, onClick: this.prepare })];
	        }
	        else if (this.PVADObject.part === 2) {
	            actions = [showErrorCheckbox, showNoOpCheckbox, cancelButton, react_1.default.createElement(FlatButton_1.default, { key: "recheck", label: "Recheck", secondary: true, onClick: this.prepare }), react_1.default.createElement(FlatButton_1.default, { key: "assignProducts", label: "Assign Products !", secondary: true, onClick: this.ok, disabled: issuableCount === 0 })];
	        }
	        else if (this.PVADObject.part === 3) {
	            actions = [showErrorCheckbox, showNoOpCheckbox, react_1.default.createElement(FlatButton_1.default, { key: "close", label: "Close", primary: true, onClick: this.close })];
	        }
	        return (react_1.default.createElement(Dialog_1.default, { actions: actions, modal: true, open: this.dialogOpen, autoScrollBodyContent: true, bodyStyle: { minHeight: 400 }, contentStyle: { position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', filter: 'blur(0)', width: '80%', maxWidth: 'none' } },
	            react_1.default.createElement(Stepper_1.Stepper, { activeStep: this.PVADObject.part - 1 },
	                react_1.default.createElement(Stepper_1.Step, null,
	                    react_1.default.createElement(Stepper_1.StepLabel, { className: "mui-stepper-icon-hack" },
	                        " ", "Check (".concat(this.PVADObject.selectedCount, ")"),
	                        " ")),
	                react_1.default.createElement(Stepper_1.Step, null,
	                    react_1.default.createElement(Stepper_1.StepLabel, { className: "mui-stepper-icon-hack" },
	                        " ", "Assign products (".concat(issuableCount, ")"),
	                        " ")),
	                react_1.default.createElement(Stepper_1.Step, null,
	                    react_1.default.createElement(Stepper_1.StepLabel, { className: "mui-stepper-icon-hack" },
	                        " ", "Done (".concat((this.PVADObject.part === 3) ? issuableCount : 0, ")"),
	                        "  "))),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: this.$errors }),
	            (this.PVADObject.part === 1) ? (react_1.default.createElement("div", null,
	                this.PVADObject.products.map(function (product, index) {
	                    return react_1.default.createElement(PVAForm, { entities: mdEntityService_1.default.entityMap, key: index, index: index, entity: mdEntityService_1.default.getEntity('ProductVehicle'), dataObject: product, rootObject: _this.PVADObject });
	                }),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("h5", { style: { display: 'flex', alignItems: 'center', margin: '0 0 0 5px', fontSize: 18 } },
	                        react_1.default.createElement("span", null, "Add Product"),
	                        react_1.default.createElement(icons_1.MdIconButton, { onClick: this.addProduct },
	                            react_1.default.createElement(add_1.default, null)))))) : (react_1.default.createElement("div", { style: { overflowY: 'auto', maxHeight: 500 } },
	                react_1.default.createElement("table", { className: "table table-condensed fullwrap" },
	                    react_1.default.createElement("tbody", null, this.PVADObject.vehicleStatuses.filter(function (is) { return (_this.PVADObject.showNoOp || is.status !== commonDomain_1.SEVERITY.NOOP) && (_this.PVADObject.showErrors || is.status !== commonDomain_1.SEVERITY.ERROR); }).map(function (is, index) {
	                        var _className = (0, dialogAncestor_1.entityStatusCss)(is);
	                        return (react_1.default.createElement("tr", { key: index },
	                            react_1.default.createElement("td", null,
	                                react_1.default.createElement(react_router_1.Link, { to: "vehicleDetail", params: { id: (0, formUtils_1.lovValue)(is.entityObject) }, query: (0, utils_1.addTenantToQuery)() },
	                                    react_1.default.createElement("span", { className: _className }, (0, formUtils_1.lovLabel)(is.entityObject))),
	                                (is.messages && is.messages.length) ? (react_1.default.createElement("table", { style: { marginLeft: 20 } },
	                                    react_1.default.createElement("tbody", null, is.messages.map(function (messageObj, index) { return (react_1.default.createElement("tr", { key: index },
	                                        react_1.default.createElement("td", { className: (0, dialogAncestor_1.validationMessageCss)(messageObj) }, messageObj.message))); })))) : null),
	                            react_1.default.createElement("td", { className: _className }, (0, dialogAncestor_1.entityStatusText)(is))));
	                    })))))));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProductVehicleAssignDialog.prototype, "PVADObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProductVehicleAssignDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProductVehicleAssignDialog.prototype, "prepare", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProductVehicleAssignDialog.prototype, "ok", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProductVehicleAssignDialog.prototype, "onShowErrors", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProductVehicleAssignDialog.prototype, "onShowNoOp", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProductVehicleAssignDialog.prototype, "cancel", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProductVehicleAssignDialog.prototype, "close", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProductVehicleAssignDialog.prototype, "addProduct", void 0);
	    ProductVehicleAssignDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProductVehicleAssignDialog);
	    return ProductVehicleAssignDialog;
	}(dialogAncestor_1.SteppingDialogAncestor));
	exports.default = ProductVehicleAssignDialog;
	var PVAForm = /** @class */ (function (_super) {
	    tslib_1.__extends(PVAForm, _super);
	    function PVAForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDelete = function (evt) {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject;
	            evt.stopPropagation();
	            console.log('onDelete %o', dataObject);
	            pull(rootObject.products, dataObject);
	        };
	        return _this;
	    }
	    PVAForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, index = _a.index, formName = _a.formName;
	        var _b = dataObject.getFormFields(formName), price = _b.price, product = _b.product, validFrom = _b.validFrom, validTo = _b.validTo, priceValidFrom = _b.priceValidFrom, setValidityFrom = _b.setValidityFrom, setValidityTo = _b.setValidityTo;
	        var checkboxLabelStyle = Object.assign({ whiteSpace: 'nowrap' }, setValidityFrom.props.labelStyle);
	        var checkboxStyle = Object.assign({}, setValidityFrom.props.style, { paddingTop: 0 });
	        var withPricePermission = securityService_1.default.hasRight(metaConstant_1.SECURABLE.assignProductsCustomPrice.name, metaConstant_1.PERMISSION.Execute);
	        return (react_1.default.createElement("div", { style: { display: 'flex' } },
	            react_1.default.createElement("div", { style: { marginRight: 10, flexGrow: 3 } },
	                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, product.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Product', {}), clearable: true, asterixForAll: true })),
	                react_1.default.createElement(validate_1.Validate, { field: product, value: product.props.value })),
	            react_1.default.createElement("div", { style: { paddingRight: 10 } },
	                react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, setValidityFrom.props, { iconStyle: { marginRight: 2 }, labelStyle: checkboxLabelStyle, style: checkboxStyle, label: setValidityFrom.props.label })),
	                react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, setValidityTo.props, { iconStyle: { marginRight: 2 }, labelStyle: checkboxLabelStyle, style: checkboxStyle, label: setValidityTo.props.label }))),
	            (dataObject.setValidityFrom || dataObject.setValidityTo) ?
	                react_1.default.createElement("div", { style: { marginRight: 10, flexGrow: 1 } },
	                    react_1.default.createElement(styledDateInterval_1.default, tslib_1.__assign({}, validFrom.props, { valueFrom: validFrom.props.value, valueTo: validTo.props.value, onChangeFrom: validFrom.props.onChange, onChangeTo: validTo.props.onChange }))) : null,
	            (withPricePermission) ? (react_1.default.createElement("div", { style: { marginRight: 10, flexGrow: 1 } },
	                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, price.props)),
	                react_1.default.createElement(validate_1.Validate, { field: price, value: price.props.value }))) : null,
	            (withPricePermission) ? (react_1.default.createElement("div", { style: { marginRight: 10, flexGrow: 1 } },
	                react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, priceValidFrom.props)))) : null,
	            react_1.default.createElement(icons_1.MdIconButton, { style: { alignSelf: 'center' }, onClick: this.onDelete, disabled: !index },
	                react_1.default.createElement(SvgDelete, { size: 24 }))));
	    };
	    PVAForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'PVAForm',
	            fields: [{
	                    name: 'product',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'validFrom',
	                    label: "Product dates"
	                }, {
	                    name: 'validTo'
	                }, {
	                    name: 'price',
	                    validators: ['IsNumber'],
	                    mdField: new mdField_1.default({ label: 'Price', numberFormat: numberUtils_1.DEFAULT_CURRENCY_FORMAT, dataType: mdField_1.DATATYPE.NUMBER })
	                }, {
	                    name: 'priceValidFrom',
	                    mdField: new mdField_1.default({ label: 'Price Valid from', dataType: mdField_1.DATATYPE.DATE })
	                }, {
	                    name: 'setValidityFrom',
	                    mdField: new mdField_1.default({ label: 'Set Product From', dataType: mdField_1.DATATYPE.BOOLEAN }),
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.checkbox
	                }, {
	                    name: 'setValidityTo',
	                    mdField: new mdField_1.default({ label: 'Set Product To', dataType: mdField_1.DATATYPE.BOOLEAN }),
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.checkbox
	                }]
	        }, function () { return react_1.default.createElement("noscript", null); }),
	        mobx_react_1.observer
	    ], PVAForm);
	    return PVAForm;
	}(react_1.default.Component));


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MiniRowName = exports.MiniCardBlock = exports.MiniChartsRow = exports.EmptyCircle = exports.GridContainer = exports.Column = exports.RowName = exports.GridRow = exports.CardBlock = exports.ChartsRow = void 0;
	var tslib_1 = __webpack_require__(3);
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	exports.ChartsRow = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: grid;\n  // pass version props for amount of columns\n  grid-template-columns: ", ";\n  justify-items: center;\n  border-bottom: 1px solid grey;\n"], ["\n  display: grid;\n  // pass version props for amount of columns\n  grid-template-columns: ", ";\n  justify-items: center;\n  border-bottom: 1px solid grey;\n"])), function (props) { return props.versions && "repeat(".concat(props.versions.length, ", minmax( 200px, 1fr))"); });
	exports.CardBlock = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items : center;\n  & .score {\n    font-size: 2rem;\n    color: #000000;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items : center;\n  & .score {\n    font-size: 2rem;\n    color: #000000;\n  }\n"])));
	exports.GridRow = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n\n"], ["\n  display: flex;\n  align-items: center;\n\n"])));
	exports.RowName = styled_components_1.default.span(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\ncolor: #000000;\n  width: 250px;\n  height: 157px;\n  margin: 0;\n  font-size: 1.5rem;\n"], ["\ncolor: #000000;\n  width: 250px;\n  height: 157px;\n  margin: 0;\n  font-size: 1.5rem;\n"])));
	exports.Column = styled_components_1.default.div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
	exports.GridContainer = styled_components_1.default.div(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  display: grid;\n  grid-template-columns: ", ";\n  max-width: calc(100% - 400px);\n"], ["\n  display: grid;\n  grid-template-columns: ", ";\n  max-width: calc(100% - 400px);\n"])), function (props) { return props.versions && "repeat(".concat(props.versions.length, ", minmax( 160px, 1fr))"); });
	exports.EmptyCircle = styled_components_1.default.div(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  width: 60px;\n  height: 60px;\n  border-width: 5px;\n  border-style: dotted;\n  border-color: ", ";\n  border-radius: 50% 50%;\n  margin: 30px 50px;\n  opacity: 50%;\n"], ["\n  width: 60px;\n  height: 60px;\n  border-width: 5px;\n  border-style: dotted;\n  border-color: ", ";\n  border-radius: 50% 50%;\n  margin: 30px 50px;\n  opacity: 50%;\n"
	    /////////////////////////////
	    // MINIMIZED VIEW
	    /////////////////////////////
	])), function (props) { return props.color; });
	/////////////////////////////
	// MINIMIZED VIEW
	/////////////////////////////
	exports.MiniChartsRow = styled_components_1.default.div(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  display: grid;\n  // pass version props for amount of columns\n  grid-template-columns: ", ";\n  justify-items: center;\n  //border-bottom: 1px solid grey;\n"], ["\n  display: grid;\n  // pass version props for amount of columns\n  grid-template-columns: ", ";\n  justify-items: center;\n  //border-bottom: 1px solid grey;\n"])), function (props) { return props.versions && "repeat(".concat(props.versions.length, ", minmax(60px, 1fr))"); });
	exports.MiniCardBlock = styled_components_1.default.div(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items : center;\n  & .score {\n    font-size:1.5rem;\n    color: #000000;\n  }\n"], ["\n  display: flex;\n  align-items : center;\n  & .score {\n    font-size:1.5rem;\n    color: #000000;\n  }\n"])));
	exports.MiniRowName = styled_components_1.default.span(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["\n  color: #000000;\n  font-size: 1.5rem;\n"], ["\n  color: #000000;\n  font-size: 1.5rem;\n"])));
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.CRITERIONTYPE = exports.Criterion = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var Criterion = /** @class */ (function (_super) {
	    tslib_1.__extends(Criterion, _super);
	    function Criterion(json) {
	        return _super.call(this, json) || this;
	    }
	    Criterion.prototype.getId = function () {
	        return this.criterionId;
	    };
	    Criterion.prototype.setId = function (id) {
	        this.criterionId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Criterion.prototype, "criterionId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Criterion.prototype, "code", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Criterion.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Criterion.prototype, "description", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Criterion.prototype, "subCriteria", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Criterion.prototype, "copyable", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Criterion.prototype, "criterionType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Criterion.prototype, "type", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Criterion.prototype, "link", void 0);
	    Criterion = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], Criterion);
	    return Criterion;
	}(DomainAncestor_1.DomainAncestor));
	exports.Criterion = Criterion;
	var CRITERIONTYPE;
	(function (CRITERIONTYPE) {
	    CRITERIONTYPE["SIMPLE"] = "SIMPLE";
	    CRITERIONTYPE["COMPLEX"] = "COMPLEX";
	})(CRITERIONTYPE || (exports.CRITERIONTYPE = CRITERIONTYPE = {}));


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.VALUETYPE = exports.PARAMTYPE = exports.SubCriterionParameter = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var SubCriterionParameter = /** @class */ (function (_super) {
	    tslib_1.__extends(SubCriterionParameter, _super);
	    function SubCriterionParameter(json) {
	        return _super.call(this, json) || this;
	    }
	    SubCriterionParameter.prototype.getId = function () {
	        return this.paramId;
	    };
	    SubCriterionParameter.prototype.setId = function (id) {
	        this.paramId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SubCriterionParameter.prototype, "paramId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SubCriterionParameter.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SubCriterionParameter.prototype, "number", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SubCriterionParameter.prototype, "parameters", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SubCriterionParameter.prototype, "paramType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SubCriterionParameter.prototype, "valueType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SubCriterionParameter.prototype, "optional", void 0);
	    SubCriterionParameter = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], SubCriterionParameter);
	    return SubCriterionParameter;
	}(DomainAncestor_1.DomainAncestor));
	exports.SubCriterionParameter = SubCriterionParameter;
	var PARAMTYPE;
	(function (PARAMTYPE) {
	    PARAMTYPE["SELECT"] = "SELECT";
	    PARAMTYPE["TEXT"] = "TEXT";
	})(PARAMTYPE || (exports.PARAMTYPE = PARAMTYPE = {}));
	var VALUETYPE;
	(function (VALUETYPE) {
	    VALUETYPE["STRING"] = "STRING";
	    VALUETYPE["NUMBER"] = "NUMBER";
	    VALUETYPE["PARAM_ID"] = "PARAM_ID";
	    VALUETYPE["PERCENTS"] = "PERCENTS";
	    VALUETYPE["BOOLEAN"] = "BOOLEAN";
	    VALUETYPE["MULTI"] = "MULTI";
	})(VALUETYPE || (exports.VALUETYPE = VALUETYPE = {}));


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EVALUATIONTYPE = exports.EVALUATIONPHASE = exports.SCHOOLLEVEL = exports.BUILDINGTYPE = exports.DOCUMENTATIONLEVEL = exports.Project = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var Project = /** @class */ (function (_super) {
	    tslib_1.__extends(Project, _super);
	    function Project(json) {
	        return _super.call(this, json) || this;
	    }
	    Project.prototype.getId = function () {
	        return this.projectId;
	    };
	    Project.prototype.setId = function (id) {
	        this.projectId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "projectId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "description", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "address", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "cadastralParcelNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "documentationCreator", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "documentationCreated", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "documentationLevel", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "evaluator", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "projectCreated", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "certified_person", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "area", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "countOfHousingUnits", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "countOfPeople", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "buildingType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "schoolLevel", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "cellarCompartment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "garage", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "zpkm", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "projectVersions", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "cadastralParcelArea", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "documentationVersion", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "projectEvaluationFinished", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "estimatedCosts", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "anticipatedCommissioning", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "evaluationPhase", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Project.prototype, "evaluationType", void 0);
	    Project = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], Project);
	    return Project;
	}(DomainAncestor_1.DomainAncestor));
	exports.Project = Project;
	var DOCUMENTATIONLEVEL;
	(function (DOCUMENTATIONLEVEL) {
	    DOCUMENTATIONLEVEL["STS"] = "STS";
	    DOCUMENTATIONLEVEL["DUR"] = "DUR";
	    DOCUMENTATIONLEVEL["DSP"] = "DSP";
	    DOCUMENTATIONLEVEL["DOS"] = "DOS";
	    DOCUMENTATIONLEVEL["DZS"] = "DZS";
	    DOCUMENTATIONLEVEL["DPS"] = "DPS";
	    DOCUMENTATIONLEVEL["RDS"] = "RDS";
	    DOCUMENTATIONLEVEL["DSPS"] = "DSPS";
	})(DOCUMENTATIONLEVEL || (exports.DOCUMENTATIONLEVEL = DOCUMENTATIONLEVEL = {}));
	var BUILDINGTYPE;
	(function (BUILDINGTYPE) {
	    BUILDINGTYPE[BUILDINGTYPE["BD"] = 1] = "BD";
	    BUILDINGTYPE[BUILDINGTYPE["RD"] = 2] = "RD";
	    BUILDINGTYPE[BUILDINGTYPE["EDU"] = 3] = "EDU";
	    BUILDINGTYPE[BUILDINGTYPE["AB"] = 4] = "AB";
	    BUILDINGTYPE[BUILDINGTYPE["UNI"] = 5] = "UNI";
	})(BUILDINGTYPE || (exports.BUILDINGTYPE = BUILDINGTYPE = {}));
	var SCHOOLLEVEL;
	(function (SCHOOLLEVEL) {
	    SCHOOLLEVEL["FIRST"] = "FIRST";
	    SCHOOLLEVEL["SECOND"] = "SECOND";
	    SCHOOLLEVEL["THIRD"] = "THIRD";
	})(SCHOOLLEVEL || (exports.SCHOOLLEVEL = SCHOOLLEVEL = {}));
	var EVALUATIONPHASE;
	(function (EVALUATIONPHASE) {
	    EVALUATIONPHASE["EVALUATION_QUALITY_DESIGN"] = "hodnocen\u00ED kvality n\u00E1vrhu budovy (projekt)";
	    EVALUATIONPHASE["EVALUATION_QUALITY"] = "hodnocen\u00ED kvality budovy (dokon\u010Den\u00E1 stavba po kolaudaci)";
	})(EVALUATIONPHASE || (exports.EVALUATIONPHASE = EVALUATIONPHASE = {}));
	var EVALUATIONTYPE;
	(function (EVALUATIONTYPE) {
	    EVALUATIONTYPE["NEW_CONSTRUCTION_RECONSTRUCTION"] = "novostavba vs. rekonstrukce";
	    EVALUATIONTYPE["SHELL_AND_CORE"] = "shell and core (pro novostavbu i pro rekonstrukci)";
	})(EVALUATIONTYPE || (exports.EVALUATIONTYPE = EVALUATIONTYPE = {}));


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _toDate = _interopRequireDefault(__webpack_require__(578));
	
	var _toFloat = _interopRequireDefault(__webpack_require__(976));
	
	var _toInt = _interopRequireDefault(__webpack_require__(2320));
	
	var _toBoolean = _interopRequireDefault(__webpack_require__(2319));
	
	var _equals = _interopRequireDefault(__webpack_require__(2265));
	
	var _contains = _interopRequireDefault(__webpack_require__(2264));
	
	var _matches = _interopRequireDefault(__webpack_require__(2316));
	
	var _isEmail = _interopRequireDefault(__webpack_require__(2279));
	
	var _isURL = _interopRequireDefault(__webpack_require__(2311));
	
	var _isMACAddress = _interopRequireDefault(__webpack_require__(2299));
	
	var _isIP = _interopRequireDefault(__webpack_require__(409));
	
	var _isIPRange = _interopRequireDefault(__webpack_require__(2284));
	
	var _isFQDN = _interopRequireDefault(__webpack_require__(577));
	
	var _isBoolean = _interopRequireDefault(__webpack_require__(2273));
	
	var _isAlpha = _interopRequireWildcard(__webpack_require__(2268));
	
	var _isAlphanumeric = _interopRequireWildcard(__webpack_require__(2269));
	
	var _isNumeric = _interopRequireDefault(__webpack_require__(2306));
	
	var _isPort = _interopRequireDefault(__webpack_require__(2307));
	
	var _isLowercase = _interopRequireDefault(__webpack_require__(2298));
	
	var _isUppercase = _interopRequireDefault(__webpack_require__(2313));
	
	var _isAscii = _interopRequireDefault(__webpack_require__(2270));
	
	var _isFullWidth = _interopRequireDefault(__webpack_require__(970));
	
	var _isHalfWidth = _interopRequireDefault(__webpack_require__(971));
	
	var _isVariableWidth = _interopRequireDefault(__webpack_require__(2314));
	
	var _isMultibyte = _interopRequireDefault(__webpack_require__(2305));
	
	var _isSurrogatePair = _interopRequireDefault(__webpack_require__(2310));
	
	var _isInt = _interopRequireDefault(__webpack_require__(973));
	
	var _isFloat = _interopRequireWildcard(__webpack_require__(2281));
	
	var _isDecimal = _interopRequireDefault(__webpack_require__(2277));
	
	var _isHexadecimal = _interopRequireDefault(__webpack_require__(972));
	
	var _isDivisibleBy = _interopRequireDefault(__webpack_require__(2278));
	
	var _isHexColor = _interopRequireDefault(__webpack_require__(2283));
	
	var _isISRC = _interopRequireDefault(__webpack_require__(2290));
	
	var _isMD = _interopRequireDefault(__webpack_require__(2300));
	
	var _isHash = _interopRequireDefault(__webpack_require__(2282));
	
	var _isJWT = _interopRequireDefault(__webpack_require__(2295));
	
	var _isJSON = _interopRequireDefault(__webpack_require__(2294));
	
	var _isEmpty = _interopRequireDefault(__webpack_require__(2280));
	
	var _isLength = _interopRequireDefault(__webpack_require__(2297));
	
	var _isByteLength = _interopRequireDefault(__webpack_require__(969));
	
	var _isUUID = _interopRequireDefault(__webpack_require__(2312));
	
	var _isMongoId = _interopRequireDefault(__webpack_require__(2304));
	
	var _isAfter = _interopRequireDefault(__webpack_require__(2267));
	
	var _isBefore = _interopRequireDefault(__webpack_require__(2272));
	
	var _isIn = _interopRequireDefault(__webpack_require__(2293));
	
	var _isCreditCard = _interopRequireDefault(__webpack_require__(2274));
	
	var _isIdentityCard = _interopRequireDefault(__webpack_require__(2292));
	
	var _isISIN = _interopRequireDefault(__webpack_require__(2286));
	
	var _isISBN = _interopRequireDefault(__webpack_require__(2285));
	
	var _isISSN = _interopRequireDefault(__webpack_require__(2291));
	
	var _isMobilePhone = _interopRequireWildcard(__webpack_require__(2303));
	
	var _isCurrency = _interopRequireDefault(__webpack_require__(2275));
	
	var _isISO = _interopRequireDefault(__webpack_require__(2289));
	
	var _isRFC = _interopRequireDefault(__webpack_require__(2309));
	
	var _isISO31661Alpha = _interopRequireDefault(__webpack_require__(2287));
	
	var _isISO31661Alpha2 = _interopRequireDefault(__webpack_require__(2288));
	
	var _isBase = _interopRequireDefault(__webpack_require__(2271));
	
	var _isDataURI = _interopRequireDefault(__webpack_require__(2276));
	
	var _isMagnetURI = _interopRequireDefault(__webpack_require__(2301));
	
	var _isMimeType = _interopRequireDefault(__webpack_require__(2302));
	
	var _isLatLong = _interopRequireDefault(__webpack_require__(2296));
	
	var _isPostalCode = _interopRequireWildcard(__webpack_require__(2308));
	
	var _ltrim = _interopRequireDefault(__webpack_require__(974));
	
	var _rtrim = _interopRequireDefault(__webpack_require__(975));
	
	var _trim = _interopRequireDefault(__webpack_require__(2321));
	
	var _escape = _interopRequireDefault(__webpack_require__(2266));
	
	var _unescape = _interopRequireDefault(__webpack_require__(2322));
	
	var _stripLow = _interopRequireDefault(__webpack_require__(2318));
	
	var _whitelist = _interopRequireDefault(__webpack_require__(2323));
	
	var _blacklist = _interopRequireDefault(__webpack_require__(968));
	
	var _isWhitelisted = _interopRequireDefault(__webpack_require__(2315));
	
	var _normalizeEmail = _interopRequireDefault(__webpack_require__(2317));
	
	var _toString = _interopRequireDefault(__webpack_require__(580));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var version = '10.11.0';
	var validator = {
	  version: version,
	  toDate: _toDate.default,
	  toFloat: _toFloat.default,
	  toInt: _toInt.default,
	  toBoolean: _toBoolean.default,
	  equals: _equals.default,
	  contains: _contains.default,
	  matches: _matches.default,
	  isEmail: _isEmail.default,
	  isURL: _isURL.default,
	  isMACAddress: _isMACAddress.default,
	  isIP: _isIP.default,
	  isIPRange: _isIPRange.default,
	  isFQDN: _isFQDN.default,
	  isBoolean: _isBoolean.default,
	  isAlpha: _isAlpha.default,
	  isAlphaLocales: _isAlpha.locales,
	  isAlphanumeric: _isAlphanumeric.default,
	  isAlphanumericLocales: _isAlphanumeric.locales,
	  isNumeric: _isNumeric.default,
	  isPort: _isPort.default,
	  isLowercase: _isLowercase.default,
	  isUppercase: _isUppercase.default,
	  isAscii: _isAscii.default,
	  isFullWidth: _isFullWidth.default,
	  isHalfWidth: _isHalfWidth.default,
	  isVariableWidth: _isVariableWidth.default,
	  isMultibyte: _isMultibyte.default,
	  isSurrogatePair: _isSurrogatePair.default,
	  isInt: _isInt.default,
	  isFloat: _isFloat.default,
	  isFloatLocales: _isFloat.locales,
	  isDecimal: _isDecimal.default,
	  isHexadecimal: _isHexadecimal.default,
	  isDivisibleBy: _isDivisibleBy.default,
	  isHexColor: _isHexColor.default,
	  isISRC: _isISRC.default,
	  isMD5: _isMD.default,
	  isHash: _isHash.default,
	  isJWT: _isJWT.default,
	  isJSON: _isJSON.default,
	  isEmpty: _isEmpty.default,
	  isLength: _isLength.default,
	  isByteLength: _isByteLength.default,
	  isUUID: _isUUID.default,
	  isMongoId: _isMongoId.default,
	  isAfter: _isAfter.default,
	  isBefore: _isBefore.default,
	  isIn: _isIn.default,
	  isCreditCard: _isCreditCard.default,
	  isIdentityCard: _isIdentityCard.default,
	  isISIN: _isISIN.default,
	  isISBN: _isISBN.default,
	  isISSN: _isISSN.default,
	  isMobilePhone: _isMobilePhone.default,
	  isMobilePhoneLocales: _isMobilePhone.locales,
	  isPostalCode: _isPostalCode.default,
	  isPostalCodeLocales: _isPostalCode.locales,
	  isCurrency: _isCurrency.default,
	  isISO8601: _isISO.default,
	  isRFC3339: _isRFC.default,
	  isISO31661Alpha2: _isISO31661Alpha.default,
	  isISO31661Alpha3: _isISO31661Alpha2.default,
	  isBase64: _isBase.default,
	  isDataURI: _isDataURI.default,
	  isMagnetURI: _isMagnetURI.default,
	  isMimeType: _isMimeType.default,
	  isLatLong: _isLatLong.default,
	  ltrim: _ltrim.default,
	  rtrim: _rtrim.default,
	  trim: _trim.default,
	  escape: _escape.default,
	  unescape: _unescape.default,
	  stripLow: _stripLow.default,
	  whitelist: _whitelist.default,
	  blacklist: _blacklist.default,
	  isWhitelisted: _isWhitelisted.default,
	  normalizeEmail: _normalizeEmail.default,
	  toString: _toString.default
	};
	var _default = validator;
	exports.default = _default;
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFQDN;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	var _merge = _interopRequireDefault(__webpack_require__(222));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_fqdn_options = {
	  require_tld: true,
	  allow_underscores: false,
	  allow_trailing_dot: false
	};
	
	function isFQDN(str, options) {
	  (0, _assertString.default)(str);
	  options = (0, _merge.default)(options, default_fqdn_options);
	  /* Remove the optional trailing dot before checking validity */
	
	  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
	    str = str.substring(0, str.length - 1);
	  }
	
	  var parts = str.split('.');
	
	  for (var i = 0; i < parts.length; i++) {
	    if (parts[i].length > 63) {
	      return false;
	    }
	  }
	
	  if (options.require_tld) {
	    var tld = parts.pop();
	
	    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
	      return false;
	    } // disallow spaces
	
	
	    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
	      return false;
	    }
	  }
	
	  for (var part, _i = 0; _i < parts.length; _i++) {
	    part = parts[_i];
	
	    if (options.allow_underscores) {
	      part = part.replace(/_/g, '');
	    }
	
	    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
	      return false;
	    } // disallow full-width chars
	
	
	    if (/[\uff01-\uff5e]/.test(part)) {
	      return false;
	    }
	
	    if (part[0] === '-' || part[part.length - 1] === '-') {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toDate(date) {
	  (0, _assertString.default)(date);
	  date = Date.parse(date);
	  return !isNaN(date) ? new Date(date) : null;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 579 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var includes = function includes(arr, val) {
	  return arr.some(function (arrVal) {
	    return val === arrVal;
	  });
	};
	
	var _default = includes;
	exports.default = _default;
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 580 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toString;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function toString(input) {
	  if (_typeof(input) === 'object' && input !== null) {
	    if (typeof input.toString === 'function') {
	      input = input.toString();
	    } else {
	      input = '[object Object]';
	    }
	  } else if (input === null || typeof input === 'undefined' || isNaN(input) && !input.length) {
	    input = '';
	  }
	
	  return String(input);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 581 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(122);
	var settle = __webpack_require__(986);
	var buildURL = __webpack_require__(989);
	var parseHeaders = __webpack_require__(995);
	var isURLSameOrigin = __webpack_require__(993);
	var createError = __webpack_require__(585);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(988);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(991);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        if (request.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 583 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 584 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(985);
	
	/**
	 * Create an Error with the specified message, config, error code, and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, response);
	};


/***/ }),
/* 586 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1047), __esModule: true };

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1049), __esModule: true };

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1050), __esModule: true };

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1052), __esModule: true };

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(588);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(411);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
	};

/***/ }),
/* 593 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(NEXT_FILTER) {
	var util = __webpack_require__(73);
	var getKeys = __webpack_require__(196).keys;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function catchFilter(instances, cb, promise) {
	    return function(e) {
	        var boundTo = promise._boundValue();
	        predicateLoop: for (var i = 0; i < instances.length; ++i) {
	            var item = instances[i];
	
	            if (item === Error ||
	                (item != null && item.prototype instanceof Error)) {
	                if (e instanceof item) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (typeof item === "function") {
	                var matchesPredicate = tryCatch(item).call(boundTo, e);
	                if (matchesPredicate === errorObj) {
	                    return matchesPredicate;
	                } else if (matchesPredicate) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (util.isObject(e)) {
	                var keys = getKeys(item);
	                for (var j = 0; j < keys.length; ++j) {
	                    var key = keys[j];
	                    if (item[key] != e[key]) {
	                        continue predicateLoop;
	                    }
	                }
	                return tryCatch(cb).call(boundTo, e);
	            }
	        }
	        return NEXT_FILTER;
	    };
	}
	
	return catchFilter;
	};


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var util = __webpack_require__(73);
	var maybeWrapAsError = util.maybeWrapAsError;
	var errors = __webpack_require__(178);
	var OperationalError = errors.OperationalError;
	var es5 = __webpack_require__(196);
	
	function isUntypedError(obj) {
	    return obj instanceof Error &&
	        es5.getPrototypeOf(obj) === Error.prototype;
	}
	
	var rErrorKey = /^(?:name|message|stack|cause)$/;
	function wrapAsOperationalError(obj) {
	    var ret;
	    if (isUntypedError(obj)) {
	        ret = new OperationalError(obj);
	        ret.name = obj.name;
	        ret.message = obj.message;
	        ret.stack = obj.stack;
	        var keys = es5.keys(obj);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!rErrorKey.test(key)) {
	                ret[key] = obj[key];
	            }
	        }
	        return ret;
	    }
	    util.markAsOriginatingFromRejection(obj);
	    return obj;
	}
	
	function nodebackForPromise(promise, multiArgs) {
	    return function(err, value) {
	        if (promise === null) return;
	        if (err) {
	            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
	            promise._attachExtraTrace(wrapped);
	            promise._reject(wrapped);
	        } else if (!multiArgs) {
	            promise._fulfill(value);
	        } else {
	            var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	            promise._fulfill(args);
	        }
	        promise = null;
	    };
	}
	
	module.exports = nodebackForPromise;


/***/ }),
/* 596 */,
/* 597 */
[2329, 413, 134],
/* 598 */
[2333, 227, 179],
/* 599 */
[2336, 160, 225, 598],
/* 600 */
[2337, 413],
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(318);
	var $export = __webpack_require__(148);
	var redefine = __webpack_require__(608);
	var hide = __webpack_require__(226);
	var Iterators = __webpack_require__(228);
	var $iterCreate = __webpack_require__(1066);
	var setToStringTag = __webpack_require__(419);
	var getPrototypeOf = __webpack_require__(604);
	var ITERATOR = __webpack_require__(134)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 602 */
[2344, 267, 268, 199, 423, 198, 599, 160],
/* 603 */
[2345, 605, 416],
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(198);
	var toObject = __webpack_require__(230);
	var IE_PROTO = __webpack_require__(420)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 605 */
[2346, 198, 199, 1059, 420],
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(148);
	var core = __webpack_require__(95);
	var fails = __webpack_require__(225);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 607 */
[2348, 160, 229, 199, 267],
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(226);


/***/ }),
/* 609 */
[2354, 422],
/* 610 */
[2358, 597, 134, 228, 95],
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(321);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 612 */
[2328, 326, 625, 1112],
/* 613 */
[2333, 232, 149],
/* 614 */
[2336, 200, 181, 613],
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(232);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 616 */
228,
/* 617 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 618 */
[2344, 621, 432, 326, 436, 323, 614, 200],
/* 619 */
[2346, 323, 326, 612, 624],
/* 620 */
[2347, 619, 428],
/* 621 */
267,
/* 622 */
[2348, 200, 620, 326, 621],
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(149);
	var hide = __webpack_require__(429);
	var has = __webpack_require__(323);
	var SRC = __webpack_require__(437)('src');
	var $toString = __webpack_require__(1096);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(231).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 624 */
[2350, 433, 437],
/* 625 */
[2354, 325],
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var emptyObject = __webpack_require__(336);
	var _invariant = __webpack_require__(28);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ v2.2.2 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(1149), __webpack_require__(1148), __webpack_require__(1152), __webpack_require__(1151), __webpack_require__(628), __webpack_require__(1154)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-collection', 'd3-array', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Collection,d3Array,d3Interpolate,d3Format,d3Time,d3TimeFormat) { 'use strict';
	
	function initRange(domain, range) {
	  switch (arguments.length) {
	    case 0: break;
	    case 1: this.range(domain); break;
	    default: this.range(range).domain(domain); break;
	  }
	  return this;
	}
	
	function initInterpolator(domain, interpolator) {
	  switch (arguments.length) {
	    case 0: break;
	    case 1: this.interpolator(domain); break;
	    default: this.interpolator(interpolator).domain(domain); break;
	  }
	  return this;
	}
	
	var array = Array.prototype;
	
	var map = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal() {
	  var index = d3Collection.map(),
	      domain = [],
	      range = [],
	      unknown = implicit;
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range[(i - 1) % range.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), scale) : range.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal(domain, range).unknown(unknown);
	  };
	
	  initRange.apply(scale, arguments);
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range[1] < range[0],
	        start = range[reverse - 0],
	        stop = range[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band(domain(), range)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return initRange.apply(rescale(), arguments);
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band.apply(null, arguments).paddingInner(1));
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function number(x) {
	  return +x;
	}
	
	var unit = [0, 1];
	
	function identity(x) {
	  return x;
	}
	
	function normalize(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(isNaN(b) ? NaN : 0.5);
	}
	
	function clamper(domain) {
	  var a = domain[0], b = domain[domain.length - 1], t;
	  if (a > b) t = a, a = b, b = t;
	  return function(x) { return Math.max(a, Math.min(b, x)); };
	}
	
	// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
	function bimap(domain, range, interpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
	  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
	  else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range, interpolate) {
	  var j = Math.min(domain.length, range.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range = range.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = normalize(domain[i], domain[i + 1]);
	    r[i] = interpolate(range[i], range[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp())
	      .unknown(source.unknown());
	}
	
	function transformer() {
	  var domain = unit,
	      range = unit,
	      interpolate = d3Interpolate.interpolate,
	      transform,
	      untransform,
	      unknown,
	      clamp = identity,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
	  }
	
	  scale.invert = function(y) {
	    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), d3Interpolate.interpolateNumber)))(y)));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map.call(_, number), clamp === identity || (clamp = clamper(domain)), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range = slice.call(_), interpolate = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = _ ? clamper(domain) : identity, scale) : clamp !== identity;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate = _, rescale()) : interpolate;
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  return function(t, u) {
	    transform = t, untransform = u;
	    return rescale();
	  };
	}
	
	function continuous(transform, untransform) {
	  return transformer()(transform, untransform);
	}
	
	function tickFormat(start, stop, count, specifier) {
	  var step = d3Array.tickStep(start, stop, count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	}
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    var d = domain();
	    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = d3Array.tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = d3Array.tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = d3Array.tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(identity, identity);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  initRange.apply(scale, arguments);
	
	  return linearish(scale);
	}
	
	function identity$1(domain) {
	  var unknown;
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map.call(_, number), scale) : domain.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return identity$1(domain).unknown(unknown);
	  };
	
	  domain = arguments.length ? map.call(domain, number) : [0, 1];
	
	  return linearish(scale);
	}
	
	function nice(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	}
	
	function transformLog(x) {
	  return Math.log(x);
	}
	
	function transformExp(x) {
	  return Math.exp(x);
	}
	
	function transformLogn(x) {
	  return -Math.log(-x);
	}
	
	function transformExpn(x) {
	  return -Math.exp(-x);
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function loggish(transform) {
	  var scale = transform(transformLog, transformExp),
	      domain = scale.domain,
	      base = 10,
	      logs,
	      pows;
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) {
	      logs = reflect(logs), pows = reflect(pows);
	      transform(transformLogn, transformExpn);
	    } else {
	      transform(transformLog, transformExp);
	    }
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  return scale;
	}
	
	function log() {
	  var scale = loggish(transformer()).domain([1, 10]);
	
	  scale.copy = function() {
	    return copy(scale, log()).base(scale.base());
	  };
	
	  initRange.apply(scale, arguments);
	
	  return scale;
	}
	
	function transformSymlog(c) {
	  return function(x) {
	    return Math.sign(x) * Math.log1p(Math.abs(x / c));
	  };
	}
	
	function transformSymexp(c) {
	  return function(x) {
	    return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
	  };
	}
	
	function symlogish(transform) {
	  var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
	
	  scale.constant = function(_) {
	    return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
	  };
	
	  return linearish(scale);
	}
	
	function symlog() {
	  var scale = symlogish(transformer());
	
	  scale.copy = function() {
	    return copy(scale, symlog()).constant(scale.constant());
	  };
	
	  return initRange.apply(scale, arguments);
	}
	
	function transformPow(exponent) {
	  return function(x) {
	    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	  };
	}
	
	function transformSqrt(x) {
	  return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
	}
	
	function transformSquare(x) {
	  return x < 0 ? -x * x : x * x;
	}
	
	function powish(transform) {
	  var scale = transform(identity, identity),
	      exponent = 1;
	
	  function rescale() {
	    return exponent === 1 ? transform(identity, identity)
	        : exponent === 0.5 ? transform(transformSqrt, transformSquare)
	        : transform(transformPow(exponent), transformPow(1 / exponent));
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, rescale()) : exponent;
	  };
	
	  return linearish(scale);
	}
	
	function pow() {
	  var scale = powish(transformer());
	
	  scale.copy = function() {
	    return copy(scale, pow()).exponent(scale.exponent());
	  };
	
	  initRange.apply(scale, arguments);
	
	  return scale;
	}
	
	function sqrt() {
	  return pow.apply(null, arguments).exponent(0.5);
	}
	
	function quantile() {
	  var domain = [],
	      range = [],
	      thresholds = [],
	      unknown;
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : range[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile()
	        .domain(domain)
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return initRange.apply(scale, arguments);
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range = [0, 1],
	      unknown;
	
	  function scale(x) {
	    return x <= x ? range[d3Array.bisect(domain, x, 0, n)] : unknown;
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range = slice.call(_)).length - 1, rescale()) : range.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : scale;
	  };
	
	  scale.thresholds = function() {
	    return domain.slice();
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return initRange.apply(linearish(scale), arguments);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range = [0, 1],
	      unknown,
	      n = 1;
	
	  function scale(x) {
	    return x <= x ? range[d3Array.bisect(domain, x, 0, n)] : unknown;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return initRange.apply(scale, arguments);
	}
	
	var durationSecond = 1000,
	    durationMinute = durationSecond * 60,
	    durationHour = durationMinute * 60,
	    durationDay = durationHour * 24,
	    durationWeek = durationDay * 7,
	    durationMonth = durationDay * 30,
	    durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
	  var scale = continuous(identity, identity),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format(".%L"),
	      formatSecond = format(":%S"),
	      formatMinute = format("%I:%M"),
	      formatHour = format("%I %p"),
	      formatDay = format("%a %d"),
	      formatWeek = format("%b %d"),
	      formatMonth = format("%B"),
	      formatYear = format("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = Math.max(d3Array.tickStep(start, stop, interval), 1);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
	  };
	
	  return scale;
	}
	
	function time() {
	  return initRange.apply(calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
	}
	
	function utcTime() {
	  return initRange.apply(calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]), arguments);
	}
	
	function transformer$1() {
	  var x0 = 0,
	      x1 = 1,
	      t0,
	      t1,
	      k10,
	      transform,
	      interpolator = identity,
	      clamp = false,
	      unknown;
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  return function(t) {
	    transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
	    return scale;
	  };
	}
	
	function copy$1(source, target) {
	  return target
	      .domain(source.domain())
	      .interpolator(source.interpolator())
	      .clamp(source.clamp())
	      .unknown(source.unknown());
	}
	
	function sequential() {
	  var scale = linearish(transformer$1()(identity));
	
	  scale.copy = function() {
	    return copy$1(scale, sequential());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialLog() {
	  var scale = loggish(transformer$1()).domain([1, 10]);
	
	  scale.copy = function() {
	    return copy$1(scale, sequentialLog()).base(scale.base());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialSymlog() {
	  var scale = symlogish(transformer$1());
	
	  scale.copy = function() {
	    return copy$1(scale, sequentialSymlog()).constant(scale.constant());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialPow() {
	  var scale = powish(transformer$1());
	
	  scale.copy = function() {
	    return copy$1(scale, sequentialPow()).exponent(scale.exponent());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialSqrt() {
	  return sequentialPow.apply(null, arguments).exponent(0.5);
	}
	
	function sequentialQuantile() {
	  var domain = [],
	      interpolator = identity;
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return interpolator((d3Array.bisect(domain, x) - 1) / (domain.length - 1));
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return scale;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequentialQuantile(interpolator).domain(domain);
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function transformer$2() {
	  var x0 = 0,
	      x1 = 0.5,
	      x2 = 1,
	      t0,
	      t1,
	      t2,
	      k10,
	      k21,
	      interpolator = identity,
	      transform,
	      clamp = false,
	      unknown;
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (x < t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), t2 = transform(x2 = +_[2]), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), scale) : [x0, x1, x2];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  return function(t) {
	    transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1);
	    return scale;
	  };
	}
	
	function diverging() {
	  var scale = linearish(transformer$2()(identity));
	
	  scale.copy = function() {
	    return copy$1(scale, diverging());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingLog() {
	  var scale = loggish(transformer$2()).domain([0.1, 1, 10]);
	
	  scale.copy = function() {
	    return copy$1(scale, divergingLog()).base(scale.base());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingSymlog() {
	  var scale = symlogish(transformer$2());
	
	  scale.copy = function() {
	    return copy$1(scale, divergingSymlog()).constant(scale.constant());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingPow() {
	  var scale = powish(transformer$2());
	
	  scale.copy = function() {
	    return copy$1(scale, divergingPow()).exponent(scale.exponent());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingSqrt() {
	  return divergingPow.apply(null, arguments).exponent(0.5);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity$1;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleSymlog = symlog;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.scaleSequential = sequential;
	exports.scaleSequentialLog = sequentialLog;
	exports.scaleSequentialPow = sequentialPow;
	exports.scaleSequentialSqrt = sequentialSqrt;
	exports.scaleSequentialSymlog = sequentialSymlog;
	exports.scaleSequentialQuantile = sequentialQuantile;
	exports.scaleDiverging = diverging;
	exports.scaleDivergingLog = divergingLog;
	exports.scaleDivergingPow = divergingPow;
	exports.scaleDivergingSqrt = divergingSqrt;
	exports.scaleDivergingSymlog = divergingSymlog;
	exports.tickFormat = tickFormat;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ v1.1.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	var t0 = new Date,
	    t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
	  }
	
	  interval.floor = function(date) {
	    return floori(date = new Date(+date)), date;
	  };
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [], previous;
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
	    while (previous < start && start < stop);
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds());
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	var utcYears = utcYear.range;
	
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! decimal.js-light v2.5.0 https://github.com/MikeMcl/decimal.js-light/LICENCE */
	;(function (globalScope) {
	  'use strict';
	
	
	  /*
	   *  decimal.js-light v2.5.0
	   *  An arbitrary-precision Decimal type for JavaScript.
	   *  https://github.com/MikeMcl/decimal.js-light
	   *  Copyright (c) 2018 Michael Mclaughlin <M8ch88l@gmail.com>
	   *  MIT Expat Licence
	   */
	
	
	  // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
	
	
	    // The limit on the value of `precision`, and on the value of the first argument to
	    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
	  var MAX_DIGITS = 1e9,                        // 0 to 1e9
	
	
	    // The initial configuration properties of the Decimal constructor.
	    Decimal = {
	
	      // These values must be integers within the stated ranges (inclusive).
	      // Most of these values can be changed during run-time using `Decimal.config`.
	
	      // The maximum number of significant digits of the result of a calculation or base conversion.
	      // E.g. `Decimal.config({ precision: 20 });`
	      precision: 20,                         // 1 to MAX_DIGITS
	
	      // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
	      // `toFixed`, `toPrecision` and `toSignificantDigits`.
	      //
	      // ROUND_UP         0 Away from zero.
	      // ROUND_DOWN       1 Towards zero.
	      // ROUND_CEIL       2 Towards +Infinity.
	      // ROUND_FLOOR      3 Towards -Infinity.
	      // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
	      // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
	      // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
	      // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
	      // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
	      //
	      // E.g.
	      // `Decimal.rounding = 4;`
	      // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
	      rounding: 4,                           // 0 to 8
	
	      // The exponent value at and beneath which `toString` returns exponential notation.
	      // JavaScript numbers: -7
	      toExpNeg: -7,                          // 0 to -MAX_E
	
	      // The exponent value at and above which `toString` returns exponential notation.
	      // JavaScript numbers: 21
	      toExpPos:  21,                         // 0 to MAX_E
	
	      // The natural logarithm of 10.
	      // 115 digits
	      LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
	    },
	
	
	  // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
	
	
	    external = true,
	
	    decimalError = '[DecimalError] ',
	    invalidArgument = decimalError + 'Invalid argument: ',
	    exponentOutOfRange = decimalError + 'Exponent out of range: ',
	
	    mathfloor = Math.floor,
	    mathpow = Math.pow,
	
	    isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
	
	    ONE,
	    BASE = 1e7,
	    LOG_BASE = 7,
	    MAX_SAFE_INTEGER = 9007199254740991,
	    MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE),    // 1286742750677284
	
	    // Decimal.prototype object
	    P = {};
	
	
	  // Decimal prototype methods
	
	
	  /*
	   *  absoluteValue                       abs
	   *  comparedTo                          cmp
	   *  decimalPlaces                       dp
	   *  dividedBy                           div
	   *  dividedToIntegerBy                  idiv
	   *  equals                              eq
	   *  exponent
	   *  greaterThan                         gt
	   *  greaterThanOrEqualTo                gte
	   *  isInteger                           isint
	   *  isNegative                          isneg
	   *  isPositive                          ispos
	   *  isZero
	   *  lessThan                            lt
	   *  lessThanOrEqualTo                   lte
	   *  logarithm                           log
	   *  minus                               sub
	   *  modulo                              mod
	   *  naturalExponential                  exp
	   *  naturalLogarithm                    ln
	   *  negated                             neg
	   *  plus                                add
	   *  precision                           sd
	   *  squareRoot                          sqrt
	   *  times                               mul
	   *  toDecimalPlaces                     todp
	   *  toExponential
	   *  toFixed
	   *  toInteger                           toint
	   *  toNumber
	   *  toPower                             pow
	   *  toPrecision
	   *  toSignificantDigits                 tosd
	   *  toString
	   *  valueOf                             val
	   */
	
	
	  /*
	   * Return a new Decimal whose value is the absolute value of this Decimal.
	   *
	   */
	  P.absoluteValue = P.abs = function () {
	    var x = new this.constructor(this);
	    if (x.s) x.s = 1;
	    return x;
	  };
	
	
	  /*
	   * Return
	   *   1    if the value of this Decimal is greater than the value of `y`,
	   *  -1    if the value of this Decimal is less than the value of `y`,
	   *   0    if they have the same value
	   *
	   */
	  P.comparedTo = P.cmp = function (y) {
	    var i, j, xdL, ydL,
	      x = this;
	
	    y = new x.constructor(y);
	
	    // Signs differ?
	    if (x.s !== y.s) return x.s || -y.s;
	
	    // Compare exponents.
	    if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
	
	    xdL = x.d.length;
	    ydL = y.d.length;
	
	    // Compare digit by digit.
	    for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
	      if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
	    }
	
	    // Compare lengths.
	    return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
	  };
	
	
	  /*
	   * Return the number of decimal places of the value of this Decimal.
	   *
	   */
	  P.decimalPlaces = P.dp = function () {
	    var x = this,
	      w = x.d.length - 1,
	      dp = (w - x.e) * LOG_BASE;
	
	    // Subtract the number of trailing zeros of the last word.
	    w = x.d[w];
	    if (w) for (; w % 10 == 0; w /= 10) dp--;
	
	    return dp < 0 ? 0 : dp;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.dividedBy = P.div = function (y) {
	    return divide(this, new this.constructor(y));
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
	   * by the value of `y`, truncated to `precision` significant digits.
	   *
	   */
	  P.dividedToIntegerBy = P.idiv = function (y) {
	    var x = this,
	      Ctor = x.constructor;
	    return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
	   *
	   */
	  P.equals = P.eq = function (y) {
	    return !this.cmp(y);
	  };
	
	
	  /*
	   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
	   *
	   */
	  P.exponent = function () {
	    return getBase10Exponent(this);
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
	   * false.
	   *
	   */
	  P.greaterThan = P.gt = function (y) {
	    return this.cmp(y) > 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
	   * otherwise return false.
	   *
	   */
	  P.greaterThanOrEqualTo = P.gte = function (y) {
	    return this.cmp(y) >= 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is an integer, otherwise return false.
	   *
	   */
	  P.isInteger = P.isint = function () {
	    return this.e > this.d.length - 2;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is negative, otherwise return false.
	   *
	   */
	  P.isNegative = P.isneg = function () {
	    return this.s < 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is positive, otherwise return false.
	   *
	   */
	  P.isPositive = P.ispos = function () {
	    return this.s > 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is 0, otherwise return false.
	   *
	   */
	  P.isZero = function () {
	    return this.s === 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is less than `y`, otherwise return false.
	   *
	   */
	  P.lessThan = P.lt = function (y) {
	    return this.cmp(y) < 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
	   *
	   */
	  P.lessThanOrEqualTo = P.lte = function (y) {
	    return this.cmp(y) < 1;
	  };
	
	
	  /*
	   * Return the logarithm of the value of this Decimal to the specified base, truncated to
	   * `precision` significant digits.
	   *
	   * If no base is specified, return log[10](x).
	   *
	   * log[base](x) = ln(x) / ln(base)
	   *
	   * The maximum error of the result is 1 ulp (unit in the last place).
	   *
	   * [base] {number|string|Decimal} The base of the logarithm.
	   *
	   */
	  P.logarithm = P.log = function (base) {
	    var r,
	      x = this,
	      Ctor = x.constructor,
	      pr = Ctor.precision,
	      wpr = pr + 5;
	
	    // Default base is 10.
	    if (base === void 0) {
	      base = new Ctor(10);
	    } else {
	      base = new Ctor(base);
	
	      // log[-b](x) = NaN
	      // log[0](x)  = NaN
	      // log[1](x)  = NaN
	      if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
	    }
	
	    // log[b](-x) = NaN
	    // log[b](0) = -Infinity
	    if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
	
	    // log[b](1) = 0
	    if (x.eq(ONE)) return new Ctor(0);
	
	    external = false;
	    r = divide(ln(x, wpr), ln(base, wpr), wpr);
	    external = true;
	
	    return round(r, pr);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.minus = P.sub = function (y) {
	    var x = this;
	    y = new x.constructor(y);
	    return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.modulo = P.mod = function (y) {
	    var q,
	      x = this,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    y = new Ctor(y);
	
	    // x % 0 = NaN
	    if (!y.s) throw Error(decimalError + 'NaN');
	
	    // Return x if x is 0.
	    if (!x.s) return round(new Ctor(x), pr);
	
	    // Prevent rounding of intermediate calculations.
	    external = false;
	    q = divide(x, y, 0, 1).times(y);
	    external = true;
	
	    return x.minus(q);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
	   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
	   * significant digits.
	   *
	   */
	  P.naturalExponential = P.exp = function () {
	    return exp(this);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
	   * truncated to `precision` significant digits.
	   *
	   */
	  P.naturalLogarithm = P.ln = function () {
	    return ln(this);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
	   * -1.
	   *
	   */
	  P.negated = P.neg = function () {
	    var x = new this.constructor(this);
	    x.s = -x.s || 0;
	    return x;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.plus = P.add = function (y) {
	    var x = this;
	    y = new x.constructor(y);
	    return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
	  };
	
	
	  /*
	   * Return the number of significant digits of the value of this Decimal.
	   *
	   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
	   *
	   */
	  P.precision = P.sd = function (z) {
	    var e, sd, w,
	      x = this;
	
	    if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
	
	    e = getBase10Exponent(x) + 1;
	    w = x.d.length - 1;
	    sd = w * LOG_BASE + 1;
	    w = x.d[w];
	
	    // If non-zero...
	    if (w) {
	
	      // Subtract the number of trailing zeros of the last word.
	      for (; w % 10 == 0; w /= 10) sd--;
	
	      // Add the number of digits of the first word.
	      for (w = x.d[0]; w >= 10; w /= 10) sd++;
	    }
	
	    return z && e > sd ? e : sd;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
	   * significant digits.
	   *
	   */
	  P.squareRoot = P.sqrt = function () {
	    var e, n, pr, r, s, t, wpr,
	      x = this,
	      Ctor = x.constructor;
	
	    // Negative or zero?
	    if (x.s < 1) {
	      if (!x.s) return new Ctor(0);
	
	      // sqrt(-x) = NaN
	      throw Error(decimalError + 'NaN');
	    }
	
	    e = getBase10Exponent(x);
	    external = false;
	
	    // Initial estimate.
	    s = Math.sqrt(+x);
	
	    // Math.sqrt underflow/overflow?
	    // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
	    if (s == 0 || s == 1 / 0) {
	      n = digitsToString(x.d);
	      if ((n.length + e) % 2 == 0) n += '0';
	      s = Math.sqrt(n);
	      e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
	
	      if (s == 1 / 0) {
	        n = '1e' + e;
	      } else {
	        n = s.toExponential();
	        n = n.slice(0, n.indexOf('e') + 1) + e;
	      }
	
	      r = new Ctor(n);
	    } else {
	      r = new Ctor(s.toString());
	    }
	
	    pr = Ctor.precision;
	    s = wpr = pr + 3;
	
	    // Newton-Raphson iteration.
	    for (;;) {
	      t = r;
	      r = t.plus(divide(x, t, wpr + 2)).times(0.5);
	
	      if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
	        n = n.slice(wpr - 3, wpr + 1);
	
	        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
	        // 4999, i.e. approaching a rounding boundary, continue the iteration.
	        if (s == wpr && n == '4999') {
	
	          // On the first iteration only, check to see if rounding up gives the exact result as the
	          // nines may infinitely repeat.
	          round(t, pr + 1, 0);
	
	          if (t.times(t).eq(x)) {
	            r = t;
	            break;
	          }
	        } else if (n != '9999') {
	          break;
	        }
	
	        wpr += 4;
	      }
	    }
	
	    external = true;
	
	    return round(r, pr);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.times = P.mul = function (y) {
	    var carry, e, i, k, r, rL, t, xdL, ydL,
	      x = this,
	      Ctor = x.constructor,
	      xd = x.d,
	      yd = (y = new Ctor(y)).d;
	
	    // Return 0 if either is 0.
	    if (!x.s || !y.s) return new Ctor(0);
	
	    y.s *= x.s;
	    e = x.e + y.e;
	    xdL = xd.length;
	    ydL = yd.length;
	
	    // Ensure xd points to the longer array.
	    if (xdL < ydL) {
	      r = xd;
	      xd = yd;
	      yd = r;
	      rL = xdL;
	      xdL = ydL;
	      ydL = rL;
	    }
	
	    // Initialise the result array with zeros.
	    r = [];
	    rL = xdL + ydL;
	    for (i = rL; i--;) r.push(0);
	
	    // Multiply!
	    for (i = ydL; --i >= 0;) {
	      carry = 0;
	      for (k = xdL + i; k > i;) {
	        t = r[k] + yd[i] * xd[k - i - 1] + carry;
	        r[k--] = t % BASE | 0;
	        carry = t / BASE | 0;
	      }
	
	      r[k] = (r[k] + carry) % BASE | 0;
	    }
	
	    // Remove trailing zeros.
	    for (; !r[--rL];) r.pop();
	
	    if (carry) ++e;
	    else r.shift();
	
	    y.d = r;
	    y.e = e;
	
	    return external ? round(y, Ctor.precision) : y;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
	   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
	   *
	   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toDecimalPlaces = P.todp = function (dp, rm) {
	    var x = this,
	      Ctor = x.constructor;
	
	    x = new Ctor(x);
	    if (dp === void 0) return x;
	
	    checkInt32(dp, 0, MAX_DIGITS);
	
	    if (rm === void 0) rm = Ctor.rounding;
	    else checkInt32(rm, 0, 8);
	
	    return round(x, dp + getBase10Exponent(x) + 1, rm);
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in exponential notation rounded to
	   * `dp` fixed decimal places using rounding mode `rounding`.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toExponential = function (dp, rm) {
	    var str,
	      x = this,
	      Ctor = x.constructor;
	
	    if (dp === void 0) {
	      str = toString(x, true);
	    } else {
	      checkInt32(dp, 0, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	
	      x = round(new Ctor(x), dp + 1, rm);
	      str = toString(x, true, dp + 1);
	    }
	
	    return str;
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
	   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
	   * omitted.
	   *
	   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
	   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
	   * (-0).toFixed(3) is '0.000'.
	   * (-0.5).toFixed(0) is '-0'.
	   *
	   */
	  P.toFixed = function (dp, rm) {
	    var str, y,
	      x = this,
	      Ctor = x.constructor;
	
	    if (dp === void 0) return toString(x);
	
	    checkInt32(dp, 0, MAX_DIGITS);
	
	    if (rm === void 0) rm = Ctor.rounding;
	    else checkInt32(rm, 0, 8);
	
	    y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
	    str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
	
	    // To determine whether to add the minus sign look at the value before it was rounded,
	    // i.e. look at `x` rather than `y`.
	    return x.isneg() && !x.isZero() ? '-' + str : str;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
	   * rounding mode `rounding`.
	   *
	   */
	  P.toInteger = P.toint = function () {
	    var x = this,
	      Ctor = x.constructor;
	    return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
	  };
	
	
	  /*
	   * Return the value of this Decimal converted to a number primitive.
	   *
	   */
	  P.toNumber = function () {
	    return +this;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
	   * truncated to `precision` significant digits.
	   *
	   * For non-integer or very large exponents pow(x, y) is calculated using
	   *
	   *   x^y = exp(y*ln(x))
	   *
	   * The maximum error is 1 ulp (unit in last place).
	   *
	   * y {number|string|Decimal} The power to which to raise this Decimal.
	   *
	   */
	  P.toPower = P.pow = function (y) {
	    var e, k, pr, r, sign, yIsInt,
	      x = this,
	      Ctor = x.constructor,
	      guard = 12,
	      yn = +(y = new Ctor(y));
	
	    // pow(x, 0) = 1
	    if (!y.s) return new Ctor(ONE);
	
	    x = new Ctor(x);
	
	    // pow(0, y > 0) = 0
	    // pow(0, y < 0) = Infinity
	    if (!x.s) {
	      if (y.s < 1) throw Error(decimalError + 'Infinity');
	      return x;
	    }
	
	    // pow(1, y) = 1
	    if (x.eq(ONE)) return x;
	
	    pr = Ctor.precision;
	
	    // pow(x, 1) = x
	    if (y.eq(ONE)) return round(x, pr);
	
	    e = y.e;
	    k = y.d.length - 1;
	    yIsInt = e >= k;
	    sign = x.s;
	
	    if (!yIsInt) {
	
	      // pow(x < 0, y non-integer) = NaN
	      if (sign < 0) throw Error(decimalError + 'NaN');
	
	    // If y is a small integer use the 'exponentiation by squaring' algorithm.
	    } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
	      r = new Ctor(ONE);
	
	      // Max k of 9007199254740991 takes 53 loop iterations.
	      // Maximum digits array length; leaves [28, 34] guard digits.
	      e = Math.ceil(pr / LOG_BASE + 4);
	
	      external = false;
	
	      for (;;) {
	        if (k % 2) {
	          r = r.times(x);
	          truncate(r.d, e);
	        }
	
	        k = mathfloor(k / 2);
	        if (k === 0) break;
	
	        x = x.times(x);
	        truncate(x.d, e);
	      }
	
	      external = true;
	
	      return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
	    }
	
	    // Result is negative if x is negative and the last digit of integer y is odd.
	    sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
	
	    x.s = 1;
	    external = false;
	    r = y.times(ln(x, pr + guard));
	    external = true;
	    r = exp(r);
	    r.s = sign;
	
	    return r;
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal rounded to `sd` significant digits
	   * using rounding mode `rounding`.
	   *
	   * Return exponential notation if `sd` is less than the number of digits necessary to represent
	   * the integer part of the value in normal notation.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toPrecision = function (sd, rm) {
	    var e, str,
	      x = this,
	      Ctor = x.constructor;
	
	    if (sd === void 0) {
	      e = getBase10Exponent(x);
	      str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
	    } else {
	      checkInt32(sd, 1, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	
	      x = round(new Ctor(x), sd, rm);
	      e = getBase10Exponent(x);
	      str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
	    }
	
	    return str;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
	   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
	   * omitted.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toSignificantDigits = P.tosd = function (sd, rm) {
	    var x = this,
	      Ctor = x.constructor;
	
	    if (sd === void 0) {
	      sd = Ctor.precision;
	      rm = Ctor.rounding;
	    } else {
	      checkInt32(sd, 1, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	    }
	
	    return round(new Ctor(x), sd, rm);
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal.
	   *
	   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
	   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
	   *
	   */
	  P.toString = P.valueOf = P.val = P.toJSON = function () {
	    var x = this,
	      e = getBase10Exponent(x),
	      Ctor = x.constructor;
	
	    return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
	  };
	
	
	  // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
	
	
	  /*
	   *  add                 P.minus, P.plus
	   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
	   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
	   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
	   *  exp                 P.exp, P.pow
	   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
	   *                      P.toString, divide, round, toString, exp, ln
	   *  getLn10             P.log, ln
	   *  getZeroString       digitsToString, toString
	   *  ln                  P.log, P.ln, P.pow, exp
	   *  parseDecimal        Decimal
	   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
	   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
	   *                      divide, getLn10, exp, ln
	   *  subtract            P.minus, P.plus
	   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
	   *  truncate            P.pow
	   *
	   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
	   *                      getLn10, exp, ln, parseDecimal, Decimal, config
	   */
	
	
	  function add(x, y) {
	    var carry, d, e, i, k, len, xd, yd,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    // If either is zero...
	    if (!x.s || !y.s) {
	
	      // Return x if y is zero.
	      // Return y if y is non-zero.
	      if (!y.s) y = new Ctor(x);
	      return external ? round(y, pr) : y;
	    }
	
	    xd = x.d;
	    yd = y.d;
	
	    // x and y are finite, non-zero numbers with the same sign.
	
	    k = x.e;
	    e = y.e;
	    xd = xd.slice();
	    i = k - e;
	
	    // If base 1e7 exponents differ...
	    if (i) {
	      if (i < 0) {
	        d = xd;
	        i = -i;
	        len = yd.length;
	      } else {
	        d = yd;
	        e = k;
	        len = xd.length;
	      }
	
	      // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
	      k = Math.ceil(pr / LOG_BASE);
	      len = k > len ? k + 1 : len + 1;
	
	      if (i > len) {
	        i = len;
	        d.length = 1;
	      }
	
	      // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
	      d.reverse();
	      for (; i--;) d.push(0);
	      d.reverse();
	    }
	
	    len = xd.length;
	    i = yd.length;
	
	    // If yd is longer than xd, swap xd and yd so xd points to the longer array.
	    if (len - i < 0) {
	      i = len;
	      d = yd;
	      yd = xd;
	      xd = d;
	    }
	
	    // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
	    for (carry = 0; i;) {
	      carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
	      xd[i] %= BASE;
	    }
	
	    if (carry) {
	      xd.unshift(carry);
	      ++e;
	    }
	
	    // Remove trailing zeros.
	    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
	    for (len = xd.length; xd[--len] == 0;) xd.pop();
	
	    y.d = xd;
	    y.e = e;
	
	    return external ? round(y, pr) : y;
	  }
	
	
	  function checkInt32(i, min, max) {
	    if (i !== ~~i || i < min || i > max) {
	      throw Error(invalidArgument + i);
	    }
	  }
	
	
	  function digitsToString(d) {
	    var i, k, ws,
	      indexOfLastWord = d.length - 1,
	      str = '',
	      w = d[0];
	
	    if (indexOfLastWord > 0) {
	      str += w;
	      for (i = 1; i < indexOfLastWord; i++) {
	        ws = d[i] + '';
	        k = LOG_BASE - ws.length;
	        if (k) str += getZeroString(k);
	        str += ws;
	      }
	
	      w = d[i];
	      ws = w + '';
	      k = LOG_BASE - ws.length;
	      if (k) str += getZeroString(k);
	    } else if (w === 0) {
	      return '0';
	    }
	
	    // Remove trailing zeros of last w.
	    for (; w % 10 === 0;) w /= 10;
	
	    return str + w;
	  }
	
	
	  var divide = (function () {
	
	    // Assumes non-zero x and k, and hence non-zero result.
	    function multiplyInteger(x, k) {
	      var temp,
	        carry = 0,
	        i = x.length;
	
	      for (x = x.slice(); i--;) {
	        temp = x[i] * k + carry;
	        x[i] = temp % BASE | 0;
	        carry = temp / BASE | 0;
	      }
	
	      if (carry) x.unshift(carry);
	
	      return x;
	    }
	
	    function compare(a, b, aL, bL) {
	      var i, r;
	
	      if (aL != bL) {
	        r = aL > bL ? 1 : -1;
	      } else {
	        for (i = r = 0; i < aL; i++) {
	          if (a[i] != b[i]) {
	            r = a[i] > b[i] ? 1 : -1;
	            break;
	          }
	        }
	      }
	
	      return r;
	    }
	
	    function subtract(a, b, aL) {
	      var i = 0;
	
	      // Subtract b from a.
	      for (; aL--;) {
	        a[aL] -= i;
	        i = a[aL] < b[aL] ? 1 : 0;
	        a[aL] = i * BASE + a[aL] - b[aL];
	      }
	
	      // Remove leading zeros.
	      for (; !a[0] && a.length > 1;) a.shift();
	    }
	
	    return function (x, y, pr, dp) {
	      var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz,
	        Ctor = x.constructor,
	        sign = x.s == y.s ? 1 : -1,
	        xd = x.d,
	        yd = y.d;
	
	      // Either 0?
	      if (!x.s) return new Ctor(x);
	      if (!y.s) throw Error(decimalError + 'Division by zero');
	
	      e = x.e - y.e;
	      yL = yd.length;
	      xL = xd.length;
	      q = new Ctor(sign);
	      qd = q.d = [];
	
	      // Result exponent may be one less than e.
	      for (i = 0; yd[i] == (xd[i] || 0); ) ++i;
	      if (yd[i] > (xd[i] || 0)) --e;
	
	      if (pr == null) {
	        sd = pr = Ctor.precision;
	      } else if (dp) {
	        sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
	      } else {
	        sd = pr;
	      }
	
	      if (sd < 0) return new Ctor(0);
	
	      // Convert precision in number of base 10 digits to base 1e7 digits.
	      sd = sd / LOG_BASE + 2 | 0;
	      i = 0;
	
	      // divisor < 1e7
	      if (yL == 1) {
	        k = 0;
	        yd = yd[0];
	        sd++;
	
	        // k is the carry.
	        for (; (i < xL || k) && sd--; i++) {
	          t = k * BASE + (xd[i] || 0);
	          qd[i] = t / yd | 0;
	          k = t % yd | 0;
	        }
	
	      // divisor >= 1e7
	      } else {
	
	        // Normalise xd and yd so highest order digit of yd is >= BASE/2
	        k = BASE / (yd[0] + 1) | 0;
	
	        if (k > 1) {
	          yd = multiplyInteger(yd, k);
	          xd = multiplyInteger(xd, k);
	          yL = yd.length;
	          xL = xd.length;
	        }
	
	        xi = yL;
	        rem = xd.slice(0, yL);
	        remL = rem.length;
	
	        // Add zeros to make remainder as long as divisor.
	        for (; remL < yL;) rem[remL++] = 0;
	
	        yz = yd.slice();
	        yz.unshift(0);
	        yd0 = yd[0];
	
	        if (yd[1] >= BASE / 2) ++yd0;
	
	        do {
	          k = 0;
	
	          // Compare divisor and remainder.
	          cmp = compare(yd, rem, yL, remL);
	
	          // If divisor < remainder.
	          if (cmp < 0) {
	
	            // Calculate trial digit, k.
	            rem0 = rem[0];
	            if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
	
	            // k will be how many times the divisor goes into the current remainder.
	            k = rem0 / yd0 | 0;
	
	            //  Algorithm:
	            //  1. product = divisor * trial digit (k)
	            //  2. if product > remainder: product -= divisor, k--
	            //  3. remainder -= product
	            //  4. if product was < remainder at 2:
	            //    5. compare new remainder and divisor
	            //    6. If remainder > divisor: remainder -= divisor, k++
	
	            if (k > 1) {
	              if (k >= BASE) k = BASE - 1;
	
	              // product = divisor * trial digit.
	              prod = multiplyInteger(yd, k);
	              prodL = prod.length;
	              remL = rem.length;
	
	              // Compare product and remainder.
	              cmp = compare(prod, rem, prodL, remL);
	
	              // product > remainder.
	              if (cmp == 1) {
	                k--;
	
	                // Subtract divisor from product.
	                subtract(prod, yL < prodL ? yz : yd, prodL);
	              }
	            } else {
	
	              // cmp is -1.
	              // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
	              // to avoid it. If k is 1 there is a need to compare yd and rem again below.
	              if (k == 0) cmp = k = 1;
	              prod = yd.slice();
	            }
	
	            prodL = prod.length;
	            if (prodL < remL) prod.unshift(0);
	
	            // Subtract product from remainder.
	            subtract(rem, prod, remL);
	
	            // If product was < previous remainder.
	            if (cmp == -1) {
	              remL = rem.length;
	
	              // Compare divisor and new remainder.
	              cmp = compare(yd, rem, yL, remL);
	
	              // If divisor < new remainder, subtract divisor from remainder.
	              if (cmp < 1) {
	                k++;
	
	                // Subtract divisor from remainder.
	                subtract(rem, yL < remL ? yz : yd, remL);
	              }
	            }
	
	            remL = rem.length;
	          } else if (cmp === 0) {
	            k++;
	            rem = [0];
	          }    // if cmp === 1, k will be 0
	
	          // Add the next digit, k, to the result array.
	          qd[i++] = k;
	
	          // Update the remainder.
	          if (cmp && rem[0]) {
	            rem[remL++] = xd[xi] || 0;
	          } else {
	            rem = [xd[xi]];
	            remL = 1;
	          }
	
	        } while ((xi++ < xL || rem[0] !== void 0) && sd--);
	      }
	
	      // Leading zero?
	      if (!qd[0]) qd.shift();
	
	      q.e = e;
	
	      return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
	    };
	  })();
	
	
	  /*
	   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
	   * significant digits.
	   *
	   * Taylor/Maclaurin series.
	   *
	   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
	   *
	   * Argument reduction:
	   *   Repeat x = x / 32, k += 5, until |x| < 0.1
	   *   exp(x) = exp(x / 2^k)^(2^k)
	   *
	   * Previously, the argument was initially reduced by
	   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
	   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
	   * found to be slower than just dividing repeatedly by 32 as above.
	   *
	   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
	   *
	   *  exp(x) is non-terminating for any finite, non-zero x.
	   *
	   */
	  function exp(x, sd) {
	    var denominator, guard, pow, sum, t, wpr,
	      i = 0,
	      k = 0,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
	
	    // exp(0) = 1
	    if (!x.s) return new Ctor(ONE);
	
	    if (sd == null) {
	      external = false;
	      wpr = pr;
	    } else {
	      wpr = sd;
	    }
	
	    t = new Ctor(0.03125);
	
	    while (x.abs().gte(0.1)) {
	      x = x.times(t);    // x = x / 2^5
	      k += 5;
	    }
	
	    // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
	    guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
	    wpr += guard;
	    denominator = pow = sum = new Ctor(ONE);
	    Ctor.precision = wpr;
	
	    for (;;) {
	      pow = round(pow.times(x), wpr);
	      denominator = denominator.times(++i);
	      t = sum.plus(divide(pow, denominator, wpr));
	
	      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
	        while (k--) sum = round(sum.times(sum), wpr);
	        Ctor.precision = pr;
	        return sd == null ? (external = true, round(sum, pr)) : sum;
	      }
	
	      sum = t;
	    }
	  }
	
	
	  // Calculate the base 10 exponent from the base 1e7 exponent.
	  function getBase10Exponent(x) {
	    var e = x.e * LOG_BASE,
	      w = x.d[0];
	
	    // Add the number of digits of the first word of the digits array.
	    for (; w >= 10; w /= 10) e++;
	    return e;
	  }
	
	
	  function getLn10(Ctor, sd, pr) {
	
	    if (sd > Ctor.LN10.sd()) {
	
	
	      // Reset global state in case the exception is caught.
	      external = true;
	      if (pr) Ctor.precision = pr;
	      throw Error(decimalError + 'LN10 precision limit exceeded');
	    }
	
	    return round(new Ctor(Ctor.LN10), sd);
	  }
	
	
	  function getZeroString(k) {
	    var zs = '';
	    for (; k--;) zs += '0';
	    return zs;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
	   * digits.
	   *
	   *  ln(n) is non-terminating (n != 1)
	   *
	   */
	  function ln(y, sd) {
	    var c, c0, denominator, e, numerator, sum, t, wpr, x2,
	      n = 1,
	      guard = 10,
	      x = y,
	      xd = x.d,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    // ln(-x) = NaN
	    // ln(0) = -Infinity
	    if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
	
	    // ln(1) = 0
	    if (x.eq(ONE)) return new Ctor(0);
	
	    if (sd == null) {
	      external = false;
	      wpr = pr;
	    } else {
	      wpr = sd;
	    }
	
	    if (x.eq(10)) {
	      if (sd == null) external = true;
	      return getLn10(Ctor, wpr);
	    }
	
	    wpr += guard;
	    Ctor.precision = wpr;
	    c = digitsToString(xd);
	    c0 = c.charAt(0);
	    e = getBase10Exponent(x);
	
	    if (Math.abs(e) < 1.5e15) {
	
	      // Argument reduction.
	      // The series converges faster the closer the argument is to 1, so using
	      // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
	      // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
	      // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
	      // later be divided by this number, then separate out the power of 10 using
	      // ln(a*10^b) = ln(a) + b*ln(10).
	
	      // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
	      //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
	      // max n is 6 (gives 0.7 - 1.3)
	      while (c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3) {
	        x = x.times(y);
	        c = digitsToString(x.d);
	        c0 = c.charAt(0);
	        n++;
	      }
	
	      e = getBase10Exponent(x);
	
	      if (c0 > 1) {
	        x = new Ctor('0.' + c);
	        e++;
	      } else {
	        x = new Ctor(c0 + '.' + c.slice(1));
	      }
	    } else {
	
	      // The argument reduction method above may result in overflow if the argument y is a massive
	      // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
	      // function using ln(x*10^e) = ln(x) + e*ln(10).
	      t = getLn10(Ctor, wpr + 2, pr).times(e + '');
	      x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
	
	      Ctor.precision = pr;
	      return sd == null ? (external = true, round(x, pr)) : x;
	    }
	
	    // x is reduced to a value near 1.
	
	    // Taylor series.
	    // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
	    // where x = (y - 1)/(y + 1)    (|x| < 1)
	    sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
	    x2 = round(x.times(x), wpr);
	    denominator = 3;
	
	    for (;;) {
	      numerator = round(numerator.times(x2), wpr);
	      t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
	
	      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
	        sum = sum.times(2);
	
	        // Reverse the argument reduction.
	        if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
	        sum = divide(sum, new Ctor(n), wpr);
	
	        Ctor.precision = pr;
	        return sd == null ? (external = true, round(sum, pr)) : sum;
	      }
	
	      sum = t;
	      denominator += 2;
	    }
	  }
	
	
	  /*
	   * Parse the value of a new Decimal `x` from string `str`.
	   */
	  function parseDecimal(x, str) {
	    var e, i, len;
	
	    // Decimal point?
	    if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
	
	    // Exponential form?
	    if ((i = str.search(/e/i)) > 0) {
	
	      // Determine exponent.
	      if (e < 0) e = i;
	      e += +str.slice(i + 1);
	      str = str.substring(0, i);
	    } else if (e < 0) {
	
	      // Integer.
	      e = str.length;
	    }
	
	    // Determine leading zeros.
	    for (i = 0; str.charCodeAt(i) === 48;) ++i;
	
	    // Determine trailing zeros.
	    for (len = str.length; str.charCodeAt(len - 1) === 48;) --len;
	    str = str.slice(i, len);
	
	    if (str) {
	      len -= i;
	      e = e - i - 1;
	      x.e = mathfloor(e / LOG_BASE);
	      x.d = [];
	
	      // Transform base
	
	      // e is the base 10 exponent.
	      // i is where to slice str to get the first word of the digits array.
	      i = (e + 1) % LOG_BASE;
	      if (e < 0) i += LOG_BASE;
	
	      if (i < len) {
	        if (i) x.d.push(+str.slice(0, i));
	        for (len -= LOG_BASE; i < len;) x.d.push(+str.slice(i, i += LOG_BASE));
	        str = str.slice(i);
	        i = LOG_BASE - str.length;
	      } else {
	        i -= len;
	      }
	
	      for (; i--;) str += '0';
	      x.d.push(+str);
	
	      if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
	    } else {
	
	      // Zero.
	      x.s = 0;
	      x.e = 0;
	      x.d = [0];
	    }
	
	    return x;
	  }
	
	
	  /*
	   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
	   */
	   function round(x, sd, rm) {
	    var i, j, k, n, rd, doRound, w, xdi,
	      xd = x.d;
	
	    // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
	    // w: the word of xd which contains the rounding digit, a base 1e7 number.
	    // xdi: the index of w within xd.
	    // n: the number of digits of w.
	    // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
	    // they had leading zeros)
	    // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
	
	    // Get the length of the first word of the digits array xd.
	    for (n = 1, k = xd[0]; k >= 10; k /= 10) n++;
	    i = sd - n;
	
	    // Is the rounding digit in the first word of xd?
	    if (i < 0) {
	      i += LOG_BASE;
	      j = sd;
	      w = xd[xdi = 0];
	    } else {
	      xdi = Math.ceil((i + 1) / LOG_BASE);
	      k = xd.length;
	      if (xdi >= k) return x;
	      w = k = xd[xdi];
	
	      // Get the number of digits of w.
	      for (n = 1; k >= 10; k /= 10) n++;
	
	      // Get the index of rd within w.
	      i %= LOG_BASE;
	
	      // Get the index of rd within w, adjusted for leading zeros.
	      // The number of leading zeros of w is given by LOG_BASE - n.
	      j = i - LOG_BASE + n;
	    }
	
	    if (rm !== void 0) {
	      k = mathpow(10, n - j - 1);
	
	      // Get the rounding digit at index j of w.
	      rd = w / k % 10 | 0;
	
	      // Are there any non-zero digits after the rounding digit?
	      doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
	
	      // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
	      // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
	      // 714.
	
	      doRound = rm < 4
	        ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
	        : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 &&
	
	          // Check whether the digit to the left of the rounding digit is odd.
	          ((i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10) & 1 ||
	            rm == (x.s < 0 ? 8 : 7));
	    }
	
	    if (sd < 1 || !xd[0]) {
	      if (doRound) {
	        k = getBase10Exponent(x);
	        xd.length = 1;
	
	        // Convert sd to decimal places.
	        sd = sd - k - 1;
	
	        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
	        xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
	        x.e = mathfloor(-sd / LOG_BASE) || 0;
	      } else {
	        xd.length = 1;
	
	        // Zero.
	        xd[0] = x.e = x.s = 0;
	      }
	
	      return x;
	    }
	
	    // Remove excess digits.
	    if (i == 0) {
	      xd.length = xdi;
	      k = 1;
	      xdi--;
	    } else {
	      xd.length = xdi + 1;
	      k = mathpow(10, LOG_BASE - i);
	
	      // E.g. 56700 becomes 56000 if 7 is the rounding digit.
	      // j > 0 means i > number of leading zeros of w.
	      xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
	    }
	
	    if (doRound) {
	      for (;;) {
	
	        // Is the digit to be rounded up in the first word of xd?
	        if (xdi == 0) {
	          if ((xd[0] += k) == BASE) {
	            xd[0] = 1;
	            ++x.e;
	          }
	
	          break;
	        } else {
	          xd[xdi] += k;
	          if (xd[xdi] != BASE) break;
	          xd[xdi--] = 0;
	          k = 1;
	        }
	      }
	    }
	
	    // Remove trailing zeros.
	    for (i = xd.length; xd[--i] === 0;) xd.pop();
	
	    if (external && (x.e > MAX_E || x.e < -MAX_E)) {
	      throw Error(exponentOutOfRange + getBase10Exponent(x));
	    }
	
	    return x;
	  }
	
	
	  function subtract(x, y) {
	    var d, e, i, j, k, len, xd, xe, xLTy, yd,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    // Return y negated if x is zero.
	    // Return x if y is zero and x is non-zero.
	    if (!x.s || !y.s) {
	      if (y.s) y.s = -y.s;
	      else y = new Ctor(x);
	      return external ? round(y, pr) : y;
	    }
	
	    xd = x.d;
	    yd = y.d;
	
	    // x and y are non-zero numbers with the same sign.
	
	    e = y.e;
	    xe = x.e;
	    xd = xd.slice();
	    k = xe - e;
	
	    // If exponents differ...
	    if (k) {
	      xLTy = k < 0;
	
	      if (xLTy) {
	        d = xd;
	        k = -k;
	        len = yd.length;
	      } else {
	        d = yd;
	        e = xe;
	        len = xd.length;
	      }
	
	      // Numbers with massively different exponents would result in a very high number of zeros
	      // needing to be prepended, but this can be avoided while still ensuring correct rounding by
	      // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
	      i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
	
	      if (k > i) {
	        k = i;
	        d.length = 1;
	      }
	
	      // Prepend zeros to equalise exponents.
	      d.reverse();
	      for (i = k; i--;) d.push(0);
	      d.reverse();
	
	    // Base 1e7 exponents equal.
	    } else {
	
	      // Check digits to determine which is the bigger number.
	
	      i = xd.length;
	      len = yd.length;
	      xLTy = i < len;
	      if (xLTy) len = i;
	
	      for (i = 0; i < len; i++) {
	        if (xd[i] != yd[i]) {
	          xLTy = xd[i] < yd[i];
	          break;
	        }
	      }
	
	      k = 0;
	    }
	
	    if (xLTy) {
	      d = xd;
	      xd = yd;
	      yd = d;
	      y.s = -y.s;
	    }
	
	    len = xd.length;
	
	    // Append zeros to xd if shorter.
	    // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
	    for (i = yd.length - len; i > 0; --i) xd[len++] = 0;
	
	    // Subtract yd from xd.
	    for (i = yd.length; i > k;) {
	      if (xd[--i] < yd[i]) {
	        for (j = i; j && xd[--j] === 0;) xd[j] = BASE - 1;
	        --xd[j];
	        xd[i] += BASE;
	      }
	
	      xd[i] -= yd[i];
	    }
	
	    // Remove trailing zeros.
	    for (; xd[--len] === 0;) xd.pop();
	
	    // Remove leading zeros and adjust exponent accordingly.
	    for (; xd[0] === 0; xd.shift()) --e;
	
	    // Zero?
	    if (!xd[0]) return new Ctor(0);
	
	    y.d = xd;
	    y.e = e;
	
	    //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
	    return external ? round(y, pr) : y;
	  }
	
	
	  function toString(x, isExp, sd) {
	    var k,
	      e = getBase10Exponent(x),
	      str = digitsToString(x.d),
	      len = str.length;
	
	    if (isExp) {
	      if (sd && (k = sd - len) > 0) {
	        str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
	      } else if (len > 1) {
	        str = str.charAt(0) + '.' + str.slice(1);
	      }
	
	      str = str + (e < 0 ? 'e' : 'e+') + e;
	    } else if (e < 0) {
	      str = '0.' + getZeroString(-e - 1) + str;
	      if (sd && (k = sd - len) > 0) str += getZeroString(k);
	    } else if (e >= len) {
	      str += getZeroString(e + 1 - len);
	      if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
	    } else {
	      if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
	      if (sd && (k = sd - len) > 0) {
	        if (e + 1 === len) str += '.';
	        str += getZeroString(k);
	      }
	    }
	
	    return x.s < 0 ? '-' + str : str;
	  }
	
	
	  // Does not strip trailing zeros.
	  function truncate(arr, len) {
	    if (arr.length > len) {
	      arr.length = len;
	      return true;
	    }
	  }
	
	
	  // Decimal methods
	
	
	  /*
	   *  clone
	   *  config/set
	   */
	
	
	  /*
	   * Create and return a Decimal constructor with the same configuration properties as this Decimal
	   * constructor.
	   *
	   */
	  function clone(obj) {
	    var i, p, ps;
	
	    /*
	     * The Decimal constructor and exported function.
	     * Return a new Decimal instance.
	     *
	     * value {number|string|Decimal} A numeric value.
	     *
	     */
	    function Decimal(value) {
	      var x = this;
	
	      // Decimal called without new.
	      if (!(x instanceof Decimal)) return new Decimal(value);
	
	      // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
	      // which points to Object.
	      x.constructor = Decimal;
	
	      // Duplicate.
	      if (value instanceof Decimal) {
	        x.s = value.s;
	        x.e = value.e;
	        x.d = (value = value.d) ? value.slice() : value;
	        return;
	      }
	
	      if (typeof value === 'number') {
	
	        // Reject Infinity/NaN.
	        if (value * 0 !== 0) {
	          throw Error(invalidArgument + value);
	        }
	
	        if (value > 0) {
	          x.s = 1;
	        } else if (value < 0) {
	          value = -value;
	          x.s = -1;
	        } else {
	          x.s = 0;
	          x.e = 0;
	          x.d = [0];
	          return;
	        }
	
	        // Fast path for small integers.
	        if (value === ~~value && value < 1e7) {
	          x.e = 0;
	          x.d = [value];
	          return;
	        }
	
	        return parseDecimal(x, value.toString());
	      } else if (typeof value !== 'string') {
	        throw Error(invalidArgument + value);
	      }
	
	      // Minus sign?
	      if (value.charCodeAt(0) === 45) {
	        value = value.slice(1);
	        x.s = -1;
	      } else {
	        x.s = 1;
	      }
	
	      if (isDecimal.test(value)) parseDecimal(x, value);
	      else throw Error(invalidArgument + value);
	    }
	
	    Decimal.prototype = P;
	
	    Decimal.ROUND_UP = 0;
	    Decimal.ROUND_DOWN = 1;
	    Decimal.ROUND_CEIL = 2;
	    Decimal.ROUND_FLOOR = 3;
	    Decimal.ROUND_HALF_UP = 4;
	    Decimal.ROUND_HALF_DOWN = 5;
	    Decimal.ROUND_HALF_EVEN = 6;
	    Decimal.ROUND_HALF_CEIL = 7;
	    Decimal.ROUND_HALF_FLOOR = 8;
	
	    Decimal.clone = clone;
	    Decimal.config = Decimal.set = config;
	
	    if (obj === void 0) obj = {};
	    if (obj) {
	      ps = ['precision', 'rounding', 'toExpNeg', 'toExpPos', 'LN10'];
	      for (i = 0; i < ps.length;) if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
	    }
	
	    Decimal.config(obj);
	
	    return Decimal;
	  }
	
	
	  /*
	   * Configure global settings for a Decimal constructor.
	   *
	   * `obj` is an object with one or more of the following properties,
	   *
	   *   precision  {number}
	   *   rounding   {number}
	   *   toExpNeg   {number}
	   *   toExpPos   {number}
	   *
	   * E.g. Decimal.config({ precision: 20, rounding: 4 })
	   *
	   */
	  function config(obj) {
	    if (!obj || typeof obj !== 'object') {
	      throw Error(decimalError + 'Object expected');
	    }
	    var i, p, v,
	      ps = [
	        'precision', 1, MAX_DIGITS,
	        'rounding', 0, 8,
	        'toExpNeg', -1 / 0, 0,
	        'toExpPos', 0, 1 / 0
	      ];
	
	    for (i = 0; i < ps.length; i += 3) {
	      if ((v = obj[p = ps[i]]) !== void 0) {
	        if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
	        else throw Error(invalidArgument + p + ': ' + v);
	      }
	    }
	
	    if ((v = obj[p = 'LN10']) !== void 0) {
	        if (v == Math.LN10) this[p] = new this(v);
	        else throw Error(invalidArgument + p + ': ' + v);
	    }
	
	    return this;
	  }
	
	
	  // Create and configure initial Decimal constructor.
	  Decimal = clone(Decimal);
	
	  Decimal['default'] = Decimal.Decimal = Decimal;
	
	  // Internal constant.
	  ONE = new Decimal(1);
	
	
	  // Export.
	
	
	  // AMD.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return Decimal;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Node and other environments that support module.exports.
	  } else if (typeof module != 'undefined' && module.exports) {
	    module.exports = Decimal;
	
	    // Browser.
	  } else {
	    if (!globalScope) {
	      globalScope = typeof self != 'undefined' && self && self.self == self
	        ? self : Function('return this')();
	    }
	
	    globalScope.Decimal = Decimal;
	  }
	})(this);


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = dirtyHandlerIds;
	exports.areDirty = areDirty;
	
	var _xor = __webpack_require__(1489);
	
	var _xor2 = _interopRequireDefault(_xor);
	
	var _intersection = __webpack_require__(723);
	
	var _intersection2 = _interopRequireDefault(_intersection);
	
	var _dragDrop = __webpack_require__(327);
	
	var _registry = __webpack_require__(328);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NONE = [];
	var ALL = [];
	
	function dirtyHandlerIds() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NONE;
		var action = arguments[1];
		var dragOperation = arguments[2];
	
		switch (action.type) {
			case _dragDrop.HOVER:
				break;
			case _registry.ADD_SOURCE:
			case _registry.ADD_TARGET:
			case _registry.REMOVE_TARGET:
			case _registry.REMOVE_SOURCE:
				return NONE;
			case _dragDrop.BEGIN_DRAG:
			case _dragDrop.PUBLISH_DRAG_SOURCE:
			case _dragDrop.END_DRAG:
			case _dragDrop.DROP:
			default:
				return ALL;
		}
	
		var targetIds = action.targetIds;
		var prevTargetIds = dragOperation.targetIds;
	
		var result = (0, _xor2.default)(targetIds, prevTargetIds);
	
		var didChange = false;
		if (result.length === 0) {
			for (var i = 0; i < targetIds.length; i++) {
				if (targetIds[i] !== prevTargetIds[i]) {
					didChange = true;
					break;
				}
			}
		} else {
			didChange = true;
		}
	
		if (!didChange) {
			return NONE;
		}
	
		var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
		var innermostTargetId = targetIds[targetIds.length - 1];
	
		if (prevInnermostTargetId !== innermostTargetId) {
			if (prevInnermostTargetId) {
				result.push(prevInnermostTargetId);
			}
			if (innermostTargetId) {
				result.push(innermostTargetId);
			}
		}
	
		return result;
	}
	
	function areDirty(state, handlerIds) {
		if (state === NONE) {
			return false;
		}
	
		if (state === ALL || typeof handlerIds === 'undefined') {
			return true;
		}
	
		return (0, _intersection2.default)(handlerIds, state).length > 0;
	}

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = dragOffset;
	exports.getSourceClientOffset = getSourceClientOffset;
	exports.getDifferenceFromInitialOffset = getDifferenceFromInitialOffset;
	
	var _dragDrop = __webpack_require__(327);
	
	var initialState = {
		initialSourceClientOffset: null,
		initialClientOffset: null,
		clientOffset: null
	};
	
	function areOffsetsEqual(offsetA, offsetB) {
		if (offsetA === offsetB) {
			return true;
		}
		return offsetA && offsetB && offsetA.x === offsetB.x && offsetA.y === offsetB.y;
	}
	
	function dragOffset() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		var action = arguments[1];
	
		switch (action.type) {
			case _dragDrop.BEGIN_DRAG:
				return {
					initialSourceClientOffset: action.sourceClientOffset,
					initialClientOffset: action.clientOffset,
					clientOffset: action.clientOffset
				};
			case _dragDrop.HOVER:
				if (areOffsetsEqual(state.clientOffset, action.clientOffset)) {
					return state;
				}
				return _extends({}, state, {
					clientOffset: action.clientOffset
				});
			case _dragDrop.END_DRAG:
			case _dragDrop.DROP:
				return initialState;
			default:
				return state;
		}
	}
	
	function getSourceClientOffset(state) {
		var clientOffset = state.clientOffset,
		    initialClientOffset = state.initialClientOffset,
		    initialSourceClientOffset = state.initialSourceClientOffset;
	
		if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
			return null;
		}
		return {
			x: clientOffset.x + initialSourceClientOffset.x - initialClientOffset.x,
			y: clientOffset.y + initialSourceClientOffset.y - initialClientOffset.y
		};
	}
	
	function getDifferenceFromInitialOffset(state) {
		var clientOffset = state.clientOffset,
		    initialClientOffset = state.initialClientOffset;
	
		if (!clientOffset || !initialClientOffset) {
			return null;
		}
		return {
			x: clientOffset.x - initialClientOffset.x,
			y: clientOffset.y - initialClientOffset.y
		};
	}

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = matchesType;
	
	var _isArray = __webpack_require__(62);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function matchesType(targetType, draggedItemType) {
		if ((0, _isArray2.default)(targetType)) {
			return targetType.some(function (t) {
				return t === draggedItemType;
			});
		} else {
			return targetType === draggedItemType;
		}
	}

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(233));
	
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  try {
	    return doc.activeElement;
	  } catch (e) {
	    /* ie throws if no active element */
	  }
	}
	
	module.exports = exports["default"];

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(635));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 635 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = offset;
	
	var _contains = _interopRequireDefault(__webpack_require__(234));
	
	var _isWindow = _interopRequireDefault(__webpack_require__(330));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(233));
	
	function offset(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      win = (0, _isWindow.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = {
	    top: 0,
	    left: 0,
	    height: 0,
	    width: 0
	  };
	  if (!doc) return; // Make sure it's not a disconnected DOM node
	
	  if (!(0, _contains.default)(docElem, node)) return box;
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height
	
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	  return box;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(330));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(182));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = camelizeStyleName;
	
	var _camelize = _interopRequireDefault(__webpack_require__(1183));
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	var msPattern = /^-ms-/;
	
	function camelizeStyleName(string) {
	  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = exports["default"];

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(182));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BlockTree
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(60);
	
	var emptyFunction = __webpack_require__(113);
	var findRangesImmutable = __webpack_require__(272);
	
	var List = Immutable.List,
	    Repeat = Immutable.Repeat,
	    Record = Immutable.Record;
	
	
	var returnTrue = emptyFunction.thatReturnsTrue;
	
	var FINGERPRINT_DELIMITER = '-';
	
	var defaultLeafRange = {
	  start: null,
	  end: null
	};
	
	var LeafRange = Record(defaultLeafRange);
	
	var defaultDecoratorRange = {
	  start: null,
	  end: null,
	  decoratorKey: null,
	  leaves: null
	};
	
	var DecoratorRange = Record(defaultDecoratorRange);
	
	var BlockTree = {
	  /**
	   * Generate a block tree for a given ContentBlock/decorator pair.
	   */
	  generate: function generate(contentState, block, decorator) {
	    var textLength = block.getLength();
	    if (!textLength) {
	      return List.of(new DecoratorRange({
	        start: 0,
	        end: 0,
	        decoratorKey: null,
	        leaves: List.of(new LeafRange({ start: 0, end: 0 }))
	      }));
	    }
	
	    var leafSets = [];
	    var decorations = decorator ? decorator.getDecorations(block, contentState) : List(Repeat(null, textLength));
	
	    var chars = block.getCharacterList();
	
	    findRangesImmutable(decorations, areEqual, returnTrue, function (start, end) {
	      leafSets.push(new DecoratorRange({
	        start: start,
	        end: end,
	        decoratorKey: decorations.get(start),
	        leaves: generateLeaves(chars.slice(start, end).toList(), start)
	      }));
	    });
	
	    return List(leafSets);
	  },
	
	  /**
	   * Create a string representation of the given tree map. This allows us
	   * to rapidly determine whether a tree has undergone a significant
	   * structural change.
	   */
	  getFingerprint: function getFingerprint(tree) {
	    return tree.map(function (leafSet) {
	      var decoratorKey = leafSet.get('decoratorKey');
	      var fingerprintString = decoratorKey !== null ? decoratorKey + '.' + (leafSet.get('end') - leafSet.get('start')) : '';
	      return '' + fingerprintString + '.' + leafSet.get('leaves').size;
	    }).join(FINGERPRINT_DELIMITER);
	  }
	};
	
	/**
	 * Generate LeafRange records for a given character list.
	 */
	function generateLeaves(characters, offset) {
	  var leaves = [];
	  var inlineStyles = characters.map(function (c) {
	    return c.getStyle();
	  }).toList();
	  findRangesImmutable(inlineStyles, areEqual, returnTrue, function (start, end) {
	    leaves.push(new LeafRange({
	      start: start + offset,
	      end: end + offset
	    }));
	  });
	  return List(leaves);
	}
	
	function areEqual(a, b) {
	  return a === b;
	}
	
	module.exports = BlockTree;

/***/ }),
/* 643 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultDraftInlineStyle
	 * @format
	 * 
	 */
	
	'use strict';
	
	module.exports = {
	  BOLD: {
	    fontWeight: 'bold'
	  },
	
	  CODE: {
	    fontFamily: 'monospace',
	    wordWrap: 'break-word'
	  },
	
	  ITALIC: {
	    fontStyle: 'italic'
	  },
	
	  STRIKETHROUGH: {
	    textDecoration: 'line-through'
	  },
	
	  UNDERLINE: {
	    textDecoration: 'underline'
	  }
	};

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorBlock.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DraftEditorLeaf = __webpack_require__(1216);
	var DraftOffsetKey = __webpack_require__(333);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(31);
	var Scroll = __webpack_require__(671);
	var Style = __webpack_require__(455);
	var UnicodeBidi = __webpack_require__(672);
	var UnicodeBidiDirection = __webpack_require__(456);
	
	var cx = __webpack_require__(236);
	var getElementPosition = __webpack_require__(1301);
	var getScrollPosition = __webpack_require__(457);
	var getViewportDimensions = __webpack_require__(1305);
	var invariant = __webpack_require__(28);
	var nullthrows = __webpack_require__(136);
	
	var SCROLL_BUFFER = 10;
	
	/**
	 * Return whether a block overlaps with either edge of the `SelectionState`.
	 */
	var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
	  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
	};
	
	/**
	 * The default block renderer for a `DraftEditor` component.
	 *
	 * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
	 * appropriate decorator and inline style components.
	 */
	
	var DraftEditorBlock = function (_React$Component) {
	  _inherits(DraftEditorBlock, _React$Component);
	
	  function DraftEditorBlock() {
	    _classCallCheck(this, DraftEditorBlock);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorBlock.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
	  };
	
	  /**
	   * When a block is mounted and overlaps the selection state, we need to make
	   * sure that the cursor is visible to match native behavior. This may not
	   * be the case if the user has pressed `RETURN` or pasted some content, since
	   * programatically creating these new blocks and setting the DOM selection
	   * will miss out on the browser natively scrolling to that position.
	   *
	   * To replicate native behavior, if the block overlaps the selection state
	   * on mount, force the scroll position. Check the scroll state of the scroll
	   * parent, and adjust it to align the entire block to the bottom of the
	   * scroll parent.
	   */
	
	
	  DraftEditorBlock.prototype.componentDidMount = function componentDidMount() {
	    var selection = this.props.selection;
	    var endKey = selection.getEndKey();
	    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
	      return;
	    }
	
	    var blockNode = ReactDOM.findDOMNode(this);
	    var scrollParent = Style.getScrollParent(blockNode);
	    var scrollPosition = getScrollPosition(scrollParent);
	    var scrollDelta = void 0;
	
	    if (scrollParent === window) {
	      var nodePosition = getElementPosition(blockNode);
	      var nodeBottom = nodePosition.y + nodePosition.height;
	      var viewportHeight = getViewportDimensions().height;
	      scrollDelta = nodeBottom - viewportHeight;
	      if (scrollDelta > 0) {
	        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
	      }
	    } else {
	      !(blockNode instanceof HTMLElement) ?  false ? invariant(false, 'blockNode is not an HTMLElement') : invariant(false) : void 0;
	      var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
	      var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
	      scrollDelta = blockBottom - scrollBottom;
	      if (scrollDelta > 0) {
	        Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
	      }
	    }
	  };
	
	  DraftEditorBlock.prototype._renderChildren = function _renderChildren() {
	    var _this2 = this;
	
	    var block = this.props.block;
	    var blockKey = block.getKey();
	    var text = block.getText();
	    var lastLeafSet = this.props.tree.size - 1;
	    var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);
	
	    return this.props.tree.map(function (leafSet, ii) {
	      var leavesForLeafSet = leafSet.get('leaves');
	      var lastLeaf = leavesForLeafSet.size - 1;
	      var leaves = leavesForLeafSet.map(function (leaf, jj) {
	        var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
	        var start = leaf.get('start');
	        var end = leaf.get('end');
	        return React.createElement(DraftEditorLeaf, {
	          key: offsetKey,
	          offsetKey: offsetKey,
	          block: block,
	          start: start,
	          selection: hasSelection ? _this2.props.selection : null,
	          forceSelection: _this2.props.forceSelection,
	          text: text.slice(start, end),
	          styleSet: block.getInlineStyleAt(start),
	          customStyleMap: _this2.props.customStyleMap,
	          customStyleFn: _this2.props.customStyleFn,
	          isLast: ii === lastLeafSet && jj === lastLeaf
	        });
	      }).toArray();
	
	      var decoratorKey = leafSet.get('decoratorKey');
	      if (decoratorKey == null) {
	        return leaves;
	      }
	
	      if (!_this2.props.decorator) {
	        return leaves;
	      }
	
	      var decorator = nullthrows(_this2.props.decorator);
	
	      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
	      if (!DecoratorComponent) {
	        return leaves;
	      }
	
	      var decoratorProps = decorator.getPropsForKey(decoratorKey);
	      var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, ii, 0);
	      var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end'));
	
	      // Resetting dir to the same value on a child node makes Chrome/Firefox
	      // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/
	      var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this2.props.direction);
	
	      return React.createElement(
	        DecoratorComponent,
	        _extends({}, decoratorProps, {
	          contentState: _this2.props.contentState,
	          decoratedText: decoratedText,
	          dir: dir,
	          key: decoratorOffsetKey,
	          entityKey: block.getEntityAt(leafSet.get('start')),
	          offsetKey: decoratorOffsetKey }),
	        leaves
	      );
	    }).toArray();
	  };
	
	  DraftEditorBlock.prototype.render = function render() {
	    var _props = this.props,
	        direction = _props.direction,
	        offsetKey = _props.offsetKey;
	
	    var className = cx({
	      'public/DraftStyleDefault/block': true,
	      'public/DraftStyleDefault/ltr': direction === 'LTR',
	      'public/DraftStyleDefault/rtl': direction === 'RTL'
	    });
	
	    return React.createElement(
	      'div',
	      { 'data-offset-key': offsetKey, className: className },
	      this._renderChildren()
	    );
	  };
	
	  return DraftEditorBlock;
	}(React.Component);
	
	module.exports = DraftEditorBlock;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntityInstance
	 * @legacyServerCallableInstance
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Immutable = __webpack_require__(60);
	
	var Record = Immutable.Record;
	
	
	var DraftEntityInstanceRecord = Record({
	  type: 'TOKEN',
	  mutability: 'IMMUTABLE',
	  data: Object
	});
	
	/**
	 * An instance of a document entity, consisting of a `type` and relevant
	 * `data`, metadata about the entity.
	 *
	 * For instance, a "link" entity might provide a URI, and a "mention"
	 * entity might provide the mentioned user's ID. These pieces of data
	 * may be used when rendering the entity as part of a ContentBlock DOM
	 * representation. For a link, the data would be used as an href for
	 * the rendered anchor. For a mention, the ID could be used to retrieve
	 * a hovercard.
	 */
	
	var DraftEntityInstance = function (_DraftEntityInstanceR) {
	  _inherits(DraftEntityInstance, _DraftEntityInstanceR);
	
	  function DraftEntityInstance() {
	    _classCallCheck(this, DraftEntityInstance);
	
	    return _possibleConstructorReturn(this, _DraftEntityInstanceR.apply(this, arguments));
	  }
	
	  DraftEntityInstance.prototype.getType = function getType() {
	    return this.get('type');
	  };
	
	  DraftEntityInstance.prototype.getMutability = function getMutability() {
	    return this.get('mutability');
	  };
	
	  DraftEntityInstance.prototype.getData = function getData() {
	    return this.get('data');
	  };
	
	  return DraftEntityInstance;
	}(DraftEntityInstanceRecord);
	
	module.exports = DraftEntityInstance;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftRemovableWord
	 * @format
	 * 
	 */
	
	'use strict';
	
	var TokenizeUtil = __webpack_require__(1294);
	
	var punctuation = TokenizeUtil.getPunctuation();
	
	// The apostrophe and curly single quotes behave in a curious way: when
	// surrounded on both sides by word characters, they behave as word chars; when
	// either neighbor is punctuation or an end of the string, they behave as
	// punctuation.
	var CHAMELEON_CHARS = '[\'\u2018\u2019]';
	
	// Remove the underscore, which should count as part of the removable word. The
	// "chameleon chars" also count as punctuation in this regex.
	var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;
	
	var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
	var DELETE_REGEX = new RegExp(DELETE_STRING);
	
	var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
	var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);
	
	function getRemovableWord(text, isBackward) {
	  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
	  return matches ? matches[0] : text;
	}
	
	var DraftRemovableWord = {
	  getBackward: function getBackward(text) {
	    return getRemovableWord(text, true);
	  },
	
	  getForward: function getForward(text) {
	    return getRemovableWord(text, false);
	  }
	};
	
	module.exports = DraftRemovableWord;

/***/ }),
/* 647 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftStringKey
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftStringKey = {
	  stringify: function stringify(key) {
	    return '_' + String(key);
	  },
	
	  unstringify: function unstringify(key) {
	    return key.slice(1);
	  }
	};
	
	module.exports = DraftStringKey;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule RichTextEditorUtil
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(104);
	var EditorState = __webpack_require__(71);
	var SelectionState = __webpack_require__(235);
	
	var adjustBlockDepthForContentState = __webpack_require__(1226);
	var nullthrows = __webpack_require__(136);
	
	var RichTextEditorUtil = {
	  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
	    var selection = editorState.getSelection();
	    var contentState = editorState.getCurrentContent();
	    var entityMap = contentState.getEntityMap();
	    return contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
	      var entity = v.getEntity();
	      return !!entity && entityMap.__get(entity).getType() === 'LINK';
	    });
	  },
	
	  getCurrentBlockType: function getCurrentBlockType(editorState) {
	    var selection = editorState.getSelection();
	    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
	  },
	
	  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
	    return { url: uri.toString() };
	  },
	
	  handleKeyCommand: function handleKeyCommand(editorState, command) {
	    switch (command) {
	      case 'bold':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'BOLD');
	      case 'italic':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'ITALIC');
	      case 'underline':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'UNDERLINE');
	      case 'code':
	        return RichTextEditorUtil.toggleCode(editorState);
	      case 'backspace':
	      case 'backspace-word':
	      case 'backspace-to-start-of-line':
	        return RichTextEditorUtil.onBackspace(editorState);
	      case 'delete':
	      case 'delete-word':
	      case 'delete-to-end-of-block':
	        return RichTextEditorUtil.onDelete(editorState);
	      default:
	        // they may have custom editor commands; ignore those
	        return null;
	    }
	  },
	
	  insertSoftNewline: function insertSoftNewline(editorState) {
	    var contentState = DraftModifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);
	
	    var newEditorState = EditorState.push(editorState, contentState, 'insert-characters');
	
	    return EditorState.forceSelection(newEditorState, contentState.getSelectionAfter());
	  },
	
	  /**
	   * For collapsed selections at the start of styled blocks, backspace should
	   * just remove the existing style.
	   */
	  onBackspace: function onBackspace(editorState) {
	    var selection = editorState.getSelection();
	    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
	      return null;
	    }
	
	    // First, try to remove a preceding atomic block.
	    var content = editorState.getCurrentContent();
	    var startKey = selection.getStartKey();
	    var blockBefore = content.getBlockBefore(startKey);
	
	    if (blockBefore && blockBefore.getType() === 'atomic') {
	      var blockMap = content.getBlockMap()['delete'](blockBefore.getKey());
	      var withoutAtomicBlock = content.merge({
	        blockMap: blockMap,
	        selectionAfter: selection
	      });
	      if (withoutAtomicBlock !== content) {
	        return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
	      }
	    }
	
	    // If that doesn't succeed, try to remove the current block style.
	    var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);
	
	    if (withoutBlockStyle) {
	      return EditorState.push(editorState, withoutBlockStyle, 'change-block-type');
	    }
	
	    return null;
	  },
	
	  onDelete: function onDelete(editorState) {
	    var selection = editorState.getSelection();
	    if (!selection.isCollapsed()) {
	      return null;
	    }
	
	    var content = editorState.getCurrentContent();
	    var startKey = selection.getStartKey();
	    var block = content.getBlockForKey(startKey);
	    var length = block.getLength();
	
	    // The cursor is somewhere within the text. Behave normally.
	    if (selection.getStartOffset() < length) {
	      return null;
	    }
	
	    var blockAfter = content.getBlockAfter(startKey);
	
	    if (!blockAfter || blockAfter.getType() !== 'atomic') {
	      return null;
	    }
	
	    var atomicBlockTarget = selection.merge({
	      focusKey: blockAfter.getKey(),
	      focusOffset: blockAfter.getLength()
	    });
	
	    var withoutAtomicBlock = DraftModifier.removeRange(content, atomicBlockTarget, 'forward');
	
	    if (withoutAtomicBlock !== content) {
	      return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
	    }
	
	    return null;
	  },
	
	  onTab: function onTab(event, editorState, maxDepth) {
	    var selection = editorState.getSelection();
	    var key = selection.getAnchorKey();
	    if (key !== selection.getFocusKey()) {
	      return editorState;
	    }
	
	    var content = editorState.getCurrentContent();
	    var block = content.getBlockForKey(key);
	    var type = block.getType();
	    if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
	      return editorState;
	    }
	
	    event.preventDefault();
	
	    // Only allow indenting one level beyond the block above, and only if
	    // the block above is a list item as well.
	    var blockAbove = content.getBlockBefore(key);
	    if (!blockAbove) {
	      return editorState;
	    }
	
	    var typeAbove = blockAbove.getType();
	    if (typeAbove !== 'unordered-list-item' && typeAbove !== 'ordered-list-item') {
	      return editorState;
	    }
	
	    var depth = block.getDepth();
	    if (!event.shiftKey && depth === maxDepth) {
	      return editorState;
	    }
	
	    maxDepth = Math.min(blockAbove.getDepth() + 1, maxDepth);
	
	    var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);
	
	    return EditorState.push(editorState, withAdjustment, 'adjust-depth');
	  },
	
	  toggleBlockType: function toggleBlockType(editorState, blockType) {
	    var selection = editorState.getSelection();
	    var startKey = selection.getStartKey();
	    var endKey = selection.getEndKey();
	    var content = editorState.getCurrentContent();
	    var target = selection;
	
	    // Triple-click can lead to a selection that includes offset 0 of the
	    // following block. The `SelectionState` for this case is accurate, but
	    // we should avoid toggling block type for the trailing block because it
	    // is a confusing interaction.
	    if (startKey !== endKey && selection.getEndOffset() === 0) {
	      var blockBefore = nullthrows(content.getBlockBefore(endKey));
	      endKey = blockBefore.getKey();
	      target = target.merge({
	        anchorKey: startKey,
	        anchorOffset: selection.getStartOffset(),
	        focusKey: endKey,
	        focusOffset: blockBefore.getLength(),
	        isBackward: false
	      });
	    }
	
	    var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
	      return k !== startKey;
	    }).reverse().skipWhile(function (_, k) {
	      return k !== endKey;
	    }).some(function (v) {
	      return v.getType() === 'atomic';
	    });
	
	    if (hasAtomicBlock) {
	      return editorState;
	    }
	
	    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;
	
	    return EditorState.push(editorState, DraftModifier.setBlockType(content, target, typeToSet), 'change-block-type');
	  },
	
	  toggleCode: function toggleCode(editorState) {
	    var selection = editorState.getSelection();
	    var anchorKey = selection.getAnchorKey();
	    var focusKey = selection.getFocusKey();
	
	    if (selection.isCollapsed() || anchorKey !== focusKey) {
	      return RichTextEditorUtil.toggleBlockType(editorState, 'code-block');
	    }
	
	    return RichTextEditorUtil.toggleInlineStyle(editorState, 'CODE');
	  },
	
	  /**
	   * Toggle the specified inline style for the selection. If the
	   * user's selection is collapsed, apply or remove the style for the
	   * internal state. If it is not collapsed, apply the change directly
	   * to the document state.
	   */
	  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
	    var selection = editorState.getSelection();
	    var currentStyle = editorState.getCurrentInlineStyle();
	
	    // If the selection is collapsed, toggle the specified style on or off and
	    // set the result as the new inline style override. This will then be
	    // used as the inline style for the next character to be inserted.
	    if (selection.isCollapsed()) {
	      return EditorState.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
	    }
	
	    // If characters are selected, immediately apply or remove the
	    // inline style on the document state itself.
	    var content = editorState.getCurrentContent();
	    var newContent;
	
	    // If the style is already present for the selection range, remove it.
	    // Otherwise, apply it.
	    if (currentStyle.has(inlineStyle)) {
	      newContent = DraftModifier.removeInlineStyle(content, selection, inlineStyle);
	    } else {
	      newContent = DraftModifier.applyInlineStyle(content, selection, inlineStyle);
	    }
	
	    return EditorState.push(editorState, newContent, 'change-inline-style');
	  },
	
	  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
	    var withoutLink = DraftModifier.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);
	
	    return EditorState.push(editorState, withoutLink, 'apply-entity');
	  },
	
	  /**
	   * When a collapsed cursor is at the start of the first styled block, or
	   * an empty styled block, changes block to 'unstyled'. Returns null if
	   * block or selection does not meet that criteria.
	   */
	  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
	    var selection = editorState.getSelection();
	    var offset = selection.getAnchorOffset();
	    if (selection.isCollapsed() && offset === 0) {
	      var key = selection.getAnchorKey();
	      var content = editorState.getCurrentContent();
	      var block = content.getBlockForKey(key);
	
	      var firstBlock = content.getFirstBlock();
	      if (block.getLength() > 0 && block !== firstBlock) {
	        return null;
	      }
	
	      var type = block.getType();
	      var blockBefore = content.getBlockBefore(key);
	      if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block' && blockBefore.getLength() !== 0) {
	        return null;
	      }
	
	      if (type !== 'unstyled') {
	        return DraftModifier.setBlockType(content, selection, 'unstyled');
	      }
	    }
	    return null;
	  }
	};
	
	module.exports = RichTextEditorUtil;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromHTMLToContentBlocks
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _knownListItemDepthCl,
	    _assign = __webpack_require__(40);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var CharacterMetadata = __webpack_require__(112);
	var ContentBlock = __webpack_require__(201);
	var ContentBlockNode = __webpack_require__(123);
	var DefaultDraftBlockRenderMap = __webpack_require__(446);
	var DraftEntity = __webpack_require__(332);
	var DraftFeatureFlags = __webpack_require__(183);
	var Immutable = __webpack_require__(60);
	
	var _require = __webpack_require__(60),
	    Set = _require.Set;
	
	var URI = __webpack_require__(1295);
	
	var cx = __webpack_require__(236);
	var generateRandomKey = __webpack_require__(161);
	var getSafeBodyFromHTML = __webpack_require__(655);
	var invariant = __webpack_require__(28);
	var sanitizeDraftText = __webpack_require__(451);
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	
	var List = Immutable.List,
	    OrderedSet = Immutable.OrderedSet;
	
	
	var NBSP = '&nbsp;';
	var SPACE = ' ';
	
	// Arbitrary max indent
	var MAX_DEPTH = 4;
	
	// used for replacing characters in HTML
	var REGEX_CR = new RegExp('\r', 'g');
	var REGEX_LF = new RegExp('\n', 'g');
	var REGEX_NBSP = new RegExp(NBSP, 'g');
	var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
	var REGEX_ZWS = new RegExp('&#8203;?', 'g');
	
	// https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
	var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
	var notBoldValues = ['light', 'lighter', '100', '200', '300', '400'];
	
	// Block tag flow is different because LIs do not have
	// a deterministic style ;_;
	var inlineTags = {
	  b: 'BOLD',
	  code: 'CODE',
	  del: 'STRIKETHROUGH',
	  em: 'ITALIC',
	  i: 'ITALIC',
	  s: 'STRIKETHROUGH',
	  strike: 'STRIKETHROUGH',
	  strong: 'BOLD',
	  u: 'UNDERLINE'
	};
	
	var knownListItemDepthClasses = (_knownListItemDepthCl = {}, _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth0'), 0), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth1'), 1), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth2'), 2), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth3'), 3), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth4'), 4), _knownListItemDepthCl);
	
	var anchorAttr = ['className', 'href', 'rel', 'target', 'title'];
	
	var imgAttr = ['alt', 'className', 'height', 'src', 'width'];
	
	var lastBlock = void 0;
	
	var EMPTY_CHUNK = {
	  text: '',
	  inlines: [],
	  entities: [],
	  blocks: []
	};
	
	var EMPTY_BLOCK = {
	  children: List(),
	  depth: 0,
	  key: '',
	  type: ''
	};
	
	var getListBlockType = function getListBlockType(tag, lastList) {
	  if (tag === 'li') {
	    return lastList === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
	  }
	  return null;
	};
	
	var getBlockMapSupportedTags = function getBlockMapSupportedTags(blockRenderMap) {
	  var unstyledElement = blockRenderMap.get('unstyled').element;
	  var tags = Set([]);
	
	  blockRenderMap.forEach(function (draftBlock) {
	    if (draftBlock.aliasedElements) {
	      draftBlock.aliasedElements.forEach(function (tag) {
	        tags = tags.add(tag);
	      });
	    }
	
	    tags = tags.add(draftBlock.element);
	  });
	
	  return tags.filter(function (tag) {
	    return tag && tag !== unstyledElement;
	  }).toArray().sort();
	};
	
	// custom element conversions
	var getMultiMatchedType = function getMultiMatchedType(tag, lastList, multiMatchExtractor) {
	  for (var ii = 0; ii < multiMatchExtractor.length; ii++) {
	    var matchType = multiMatchExtractor[ii](tag, lastList);
	    if (matchType) {
	      return matchType;
	    }
	  }
	  return null;
	};
	
	var getBlockTypeForTag = function getBlockTypeForTag(tag, lastList, blockRenderMap) {
	  var matchedTypes = blockRenderMap.filter(function (draftBlock) {
	    return draftBlock.element === tag || draftBlock.wrapper === tag || draftBlock.aliasedElements && draftBlock.aliasedElements.some(function (alias) {
	      return alias === tag;
	    });
	  }).keySeq().toSet().toArray().sort();
	
	  // if we dont have any matched type, return unstyled
	  // if we have one matched type return it
	  // if we have multi matched types use the multi-match function to gather type
	  switch (matchedTypes.length) {
	    case 0:
	      return 'unstyled';
	    case 1:
	      return matchedTypes[0];
	    default:
	      return getMultiMatchedType(tag, lastList, [getListBlockType]) || 'unstyled';
	  }
	};
	
	var processInlineTag = function processInlineTag(tag, node, currentStyle) {
	  var styleToCheck = inlineTags[tag];
	  if (styleToCheck) {
	    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
	  } else if (node instanceof HTMLElement) {
	    var htmlElement = node;
	    currentStyle = currentStyle.withMutations(function (style) {
	      var fontWeight = htmlElement.style.fontWeight;
	      var fontStyle = htmlElement.style.fontStyle;
	      var textDecoration = htmlElement.style.textDecoration;
	
	      if (boldValues.indexOf(fontWeight) >= 0) {
	        style.add('BOLD');
	      } else if (notBoldValues.indexOf(fontWeight) >= 0) {
	        style.remove('BOLD');
	      }
	
	      if (fontStyle === 'italic') {
	        style.add('ITALIC');
	      } else if (fontStyle === 'normal') {
	        style.remove('ITALIC');
	      }
	
	      if (textDecoration === 'underline') {
	        style.add('UNDERLINE');
	      }
	      if (textDecoration === 'line-through') {
	        style.add('STRIKETHROUGH');
	      }
	      if (textDecoration === 'none') {
	        style.remove('UNDERLINE');
	        style.remove('STRIKETHROUGH');
	      }
	    }).toOrderedSet();
	  }
	  return currentStyle;
	};
	
	var joinChunks = function joinChunks(A, B, experimentalHasNestedBlocks) {
	  // Sometimes two blocks will touch in the DOM and we need to strip the
	  // extra delimiter to preserve niceness.
	  var lastInA = A.text.slice(-1);
	  var firstInB = B.text.slice(0, 1);
	
	  if (lastInA === '\r' && firstInB === '\r' && !experimentalHasNestedBlocks) {
	    A.text = A.text.slice(0, -1);
	    A.inlines.pop();
	    A.entities.pop();
	    A.blocks.pop();
	  }
	
	  // Kill whitespace after blocks
	  if (lastInA === '\r') {
	    if (B.text === SPACE || B.text === '\n') {
	      return A;
	    } else if (firstInB === SPACE || firstInB === '\n') {
	      B.text = B.text.slice(1);
	      B.inlines.shift();
	      B.entities.shift();
	    }
	  }
	
	  return {
	    text: A.text + B.text,
	    inlines: A.inlines.concat(B.inlines),
	    entities: A.entities.concat(B.entities),
	    blocks: A.blocks.concat(B.blocks)
	  };
	};
	
	/**
	 * Check to see if we have anything like <p> <blockquote> <h1>... to create
	 * block tags from. If we do, we can use those and ignore <div> tags. If we
	 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
	 */
	var containsSemanticBlockMarkup = function containsSemanticBlockMarkup(html, blockTags) {
	  return blockTags.some(function (tag) {
	    return html.indexOf('<' + tag) !== -1;
	  });
	};
	
	var hasValidLinkText = function hasValidLinkText(link) {
	  !(link instanceof HTMLAnchorElement) ?  false ? invariant(false, 'Link must be an HTMLAnchorElement.') : invariant(false) : void 0;
	  var protocol = link.protocol;
	  return protocol === 'http:' || protocol === 'https:' || protocol === 'mailto:';
	};
	
	var getWhitespaceChunk = function getWhitespaceChunk(inEntity) {
	  var entities = new Array(1);
	  if (inEntity) {
	    entities[0] = inEntity;
	  }
	  return _extends({}, EMPTY_CHUNK, {
	    text: SPACE,
	    inlines: [OrderedSet()],
	    entities: entities
	  });
	};
	
	var getSoftNewlineChunk = function getSoftNewlineChunk() {
	  return _extends({}, EMPTY_CHUNK, {
	    text: '\n',
	    inlines: [OrderedSet()],
	    entities: new Array(1)
	  });
	};
	
	var getChunkedBlock = function getChunkedBlock() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _extends({}, EMPTY_BLOCK, props);
	};
	
	var getBlockDividerChunk = function getBlockDividerChunk(block, depth) {
	  var parentKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  return {
	    text: '\r',
	    inlines: [OrderedSet()],
	    entities: new Array(1),
	    blocks: [getChunkedBlock({
	      parent: parentKey,
	      key: generateRandomKey(),
	      type: block,
	      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
	    })]
	  };
	};
	
	/**
	 *  If we're pasting from one DraftEditor to another we can check to see if
	 *  existing list item depth classes are being used and preserve this style
	 */
	var getListItemDepth = function getListItemDepth(node) {
	  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  Object.keys(knownListItemDepthClasses).some(function (depthClass) {
	    if (node.classList.contains(depthClass)) {
	      depth = knownListItemDepthClasses[depthClass];
	    }
	  });
	  return depth;
	};
	
	var genFragment = function genFragment(entityMap, node, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, inEntity, parentKey) {
	  var lastLastBlock = lastBlock;
	  var nodeName = node.nodeName.toLowerCase();
	  var newEntityMap = entityMap;
	  var nextBlockType = 'unstyled';
	  var newBlock = false;
	  var inBlockType = inBlock && getBlockTypeForTag(inBlock, lastList, blockRenderMap);
	  var chunk = _extends({}, EMPTY_CHUNK);
	  var newChunk = null;
	  var blockKey = void 0;
	
	  // Base Case
	  if (nodeName === '#text') {
	    var _text = node.textContent;
	    var nodeTextContent = _text.trim();
	
	    // We should not create blocks for leading spaces that are
	    // existing around ol/ul and their children list items
	    if (lastList && nodeTextContent === '' && node.parentElement) {
	      var parentNodeName = node.parentElement.nodeName.toLowerCase();
	      if (parentNodeName === 'ol' || parentNodeName === 'ul') {
	        return { chunk: _extends({}, EMPTY_CHUNK), entityMap: entityMap };
	      }
	    }
	
	    if (nodeTextContent === '' && inBlock !== 'pre') {
	      return { chunk: getWhitespaceChunk(inEntity), entityMap: entityMap };
	    }
	    if (inBlock !== 'pre') {
	      // Can't use empty string because MSWord
	      _text = _text.replace(REGEX_LF, SPACE);
	    }
	
	    // save the last block so we can use it later
	    lastBlock = nodeName;
	
	    return {
	      chunk: {
	        text: _text,
	        inlines: Array(_text.length).fill(inlineStyle),
	        entities: Array(_text.length).fill(inEntity),
	        blocks: []
	      },
	      entityMap: entityMap
	    };
	  }
	
	  // save the last block so we can use it later
	  lastBlock = nodeName;
	
	  // BR tags
	  if (nodeName === 'br') {
	    if (lastLastBlock === 'br' && (!inBlock || inBlockType === 'unstyled')) {
	      return {
	        chunk: getBlockDividerChunk('unstyled', depth, parentKey),
	        entityMap: entityMap
	      };
	    }
	    return { chunk: getSoftNewlineChunk(), entityMap: entityMap };
	  }
	
	  // IMG tags
	  if (nodeName === 'img' && node instanceof HTMLImageElement && node.attributes.getNamedItem('src') && node.attributes.getNamedItem('src').value) {
	    var image = node;
	    var entityConfig = {};
	
	    imgAttr.forEach(function (attr) {
	      var imageAttribute = image.getAttribute(attr);
	      if (imageAttribute) {
	        entityConfig[attr] = imageAttribute;
	      }
	    });
	    // Forcing this node to have children because otherwise no entity will be
	    // created for this node.
	    // The child text node cannot just have a space or return as content -
	    // we strip those out.
	    // See https://github.com/facebook/draft-js/issues/231 for some context.
	    node.textContent = '\uD83D\uDCF7';
	
	    // TODO: update this when we remove DraftEntity entirely
	    inEntity = DraftEntity.__create('IMAGE', 'MUTABLE', entityConfig || {});
	  }
	
	  // Inline tags
	  inlineStyle = processInlineTag(nodeName, node, inlineStyle);
	
	  // Handle lists
	  if (nodeName === 'ul' || nodeName === 'ol') {
	    if (lastList) {
	      depth += 1;
	    }
	    lastList = nodeName;
	  }
	
	  if (!experimentalTreeDataSupport && nodeName === 'li' && node instanceof HTMLElement) {
	    depth = getListItemDepth(node, depth);
	  }
	
	  var blockType = getBlockTypeForTag(nodeName, lastList, blockRenderMap);
	  var inListBlock = lastList && inBlock === 'li' && nodeName === 'li';
	  var inBlockOrHasNestedBlocks = (!inBlock || experimentalTreeDataSupport) && blockTags.indexOf(nodeName) !== -1;
	
	  // Block Tags
	  if (inListBlock || inBlockOrHasNestedBlocks) {
	    chunk = getBlockDividerChunk(blockType, depth, parentKey);
	    blockKey = chunk.blocks[0].key;
	    inBlock = nodeName;
	    newBlock = !experimentalTreeDataSupport;
	  }
	
	  // this is required so that we can handle 'ul' and 'ol'
	  if (inListBlock) {
	    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
	  }
	
	  // Recurse through children
	  var child = node.firstChild;
	  if (child != null) {
	    nodeName = child.nodeName.toLowerCase();
	  }
	
	  var entityId = null;
	
	  while (child) {
	    if (child instanceof HTMLAnchorElement && child.href && hasValidLinkText(child)) {
	      (function () {
	        var anchor = child;
	        var entityConfig = {};
	
	        anchorAttr.forEach(function (attr) {
	          var anchorAttribute = anchor.getAttribute(attr);
	          if (anchorAttribute) {
	            entityConfig[attr] = anchorAttribute;
	          }
	        });
	
	        entityConfig.url = new URI(anchor.href).toString();
	        // TODO: update this when we remove DraftEntity completely
	        entityId = DraftEntity.__create('LINK', 'MUTABLE', entityConfig || {});
	      })();
	    } else {
	      entityId = undefined;
	    }
	
	    var _genFragment = genFragment(newEntityMap, child, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, entityId || inEntity, experimentalTreeDataSupport ? blockKey : null),
	        generatedChunk = _genFragment.chunk,
	        maybeUpdatedEntityMap = _genFragment.entityMap;
	
	    newChunk = generatedChunk;
	    newEntityMap = maybeUpdatedEntityMap;
	
	    chunk = joinChunks(chunk, newChunk, experimentalTreeDataSupport);
	    var sibling = child.nextSibling;
	
	    // Put in a newline to break up blocks inside blocks
	    if (!parentKey && sibling && blockTags.indexOf(nodeName) >= 0 && inBlock) {
	      chunk = joinChunks(chunk, getSoftNewlineChunk());
	    }
	    if (sibling) {
	      nodeName = sibling.nodeName.toLowerCase();
	    }
	    child = sibling;
	  }
	
	  if (newBlock) {
	    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth, parentKey));
	  }
	
	  return { chunk: chunk, entityMap: newEntityMap };
	};
	
	var getChunkForHTML = function getChunkForHTML(html, DOMBuilder, blockRenderMap, entityMap) {
	  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, '');
	
	  var supportedBlockTags = getBlockMapSupportedTags(blockRenderMap);
	
	  var safeBody = DOMBuilder(html);
	  if (!safeBody) {
	    return null;
	  }
	  lastBlock = null;
	
	  // Sometimes we aren't dealing with content that contains nice semantic
	  // tags. In this case, use divs to separate everything out into paragraphs
	  // and hope for the best.
	  var workingBlocks = containsSemanticBlockMarkup(html, supportedBlockTags) ? supportedBlockTags : ['div'];
	
	  // Start with -1 block depth to offset the fact that we are passing in a fake
	  // UL block to start with.
	  var fragment = genFragment(entityMap, safeBody, OrderedSet(), 'ul', null, workingBlocks, -1, blockRenderMap);
	
	  var chunk = fragment.chunk;
	  var newEntityMap = fragment.entityMap;
	
	  // join with previous block to prevent weirdness on paste
	  if (chunk.text.indexOf('\r') === 0) {
	    chunk = {
	      text: chunk.text.slice(1),
	      inlines: chunk.inlines.slice(1),
	      entities: chunk.entities.slice(1),
	      blocks: chunk.blocks
	    };
	  }
	
	  // Kill block delimiter at the end
	  if (chunk.text.slice(-1) === '\r') {
	    chunk.text = chunk.text.slice(0, -1);
	    chunk.inlines = chunk.inlines.slice(0, -1);
	    chunk.entities = chunk.entities.slice(0, -1);
	    chunk.blocks.pop();
	  }
	
	  // If we saw no block tags, put an unstyled one in
	  if (chunk.blocks.length === 0) {
	    chunk.blocks.push(_extends({}, EMPTY_CHUNK, {
	      type: 'unstyled',
	      depth: 0
	    }));
	  }
	
	  // Sometimes we start with text that isn't in a block, which is then
	  // followed by blocks. Need to fix up the blocks to add in
	  // an unstyled block for this content
	  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
	    chunk.blocks.unshift({ type: 'unstyled', depth: 0 });
	  }
	
	  return { chunk: chunk, entityMap: newEntityMap };
	};
	
	var convertChunkToContentBlocks = function convertChunkToContentBlocks(chunk) {
	  if (!chunk || !chunk.text || !Array.isArray(chunk.blocks)) {
	    return null;
	  }
	
	  var initialState = {
	    cacheRef: {},
	    contentBlocks: []
	  };
	
	  var start = 0;
	
	  var rawBlocks = chunk.blocks,
	      rawInlines = chunk.inlines,
	      rawEntities = chunk.entities;
	
	
	  var BlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
	
	  return chunk.text.split('\r').reduce(function (acc, textBlock, index) {
	    // Make absolutely certain that our text is acceptable.
	    textBlock = sanitizeDraftText(textBlock);
	
	    var block = rawBlocks[index];
	    var end = start + textBlock.length;
	    var inlines = rawInlines.slice(start, end);
	    var entities = rawEntities.slice(start, end);
	    var characterList = List(inlines.map(function (style, index) {
	      var data = { style: style, entity: null };
	      if (entities[index]) {
	        data.entity = entities[index];
	      }
	      return CharacterMetadata.create(data);
	    }));
	    start = end + 1;
	
	    var depth = block.depth,
	        type = block.type,
	        parent = block.parent;
	
	
	    var key = block.key || generateRandomKey();
	    var parentTextNodeKey = null; // will be used to store container text nodes
	
	    // childrens add themselves to their parents since we are iterating in order
	    if (parent) {
	      var parentIndex = acc.cacheRef[parent];
	      var parentRecord = acc.contentBlocks[parentIndex];
	
	      // if parent has text we need to split it into a separate unstyled element
	      if (parentRecord.getChildKeys().isEmpty() && parentRecord.getText()) {
	        var parentCharacterList = parentRecord.getCharacterList();
	        var parentText = parentRecord.getText();
	        parentTextNodeKey = generateRandomKey();
	
	        var textNode = new ContentBlockNode({
	          key: parentTextNodeKey,
	          text: parentText,
	          characterList: parentCharacterList,
	          parent: parent,
	          nextSibling: key
	        });
	
	        acc.contentBlocks.push(textNode);
	
	        parentRecord = parentRecord.withMutations(function (block) {
	          block.set('characterList', List()).set('text', '').set('children', parentRecord.children.push(textNode.getKey()));
	        });
	      }
	
	      acc.contentBlocks[parentIndex] = parentRecord.set('children', parentRecord.children.push(key));
	    }
	
	    var blockNode = new BlockNodeRecord({
	      key: key,
	      parent: parent,
	      type: type,
	      depth: depth,
	      text: textBlock,
	      characterList: characterList,
	      prevSibling: parentTextNodeKey || (index === 0 || rawBlocks[index - 1].parent !== parent ? null : rawBlocks[index - 1].key),
	      nextSibling: index === rawBlocks.length - 1 || rawBlocks[index + 1].parent !== parent ? null : rawBlocks[index + 1].key
	    });
	
	    // insert node
	    acc.contentBlocks.push(blockNode);
	
	    // cache ref for building links
	    acc.cacheRef[blockNode.key] = index;
	
	    return acc;
	  }, initialState).contentBlocks;
	};
	
	var convertFromHTMLtoContentBlocks = function convertFromHTMLtoContentBlocks(html) {
	  var DOMBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSafeBodyFromHTML;
	  var blockRenderMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultDraftBlockRenderMap;
	
	  // Be ABSOLUTELY SURE that the dom builder you pass here won't execute
	  // arbitrary code in whatever environment you're running this in. For an
	  // example of how we try to do this in-browser, see getSafeBodyFromHTML.
	
	  // TODO: replace DraftEntity with an OrderedMap here
	  var chunkData = getChunkForHTML(html, DOMBuilder, blockRenderMap, DraftEntity);
	
	  if (chunkData == null) {
	    return null;
	  }
	
	  var chunk = chunkData.chunk,
	      entityMap = chunkData.entityMap;
	
	  var contentBlocks = convertChunkToContentBlocks(chunk);
	
	  return {
	    contentBlocks: contentBlocks,
	    entityMap: entityMap
	  };
	};
	
	module.exports = convertFromHTMLtoContentBlocks;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDefaultKeyBinding
	 * @format
	 * 
	 */
	
	'use strict';
	
	var KeyBindingUtil = __webpack_require__(447);
	var Keys = __webpack_require__(454);
	var UserAgent = __webpack_require__(150);
	
	var isOSX = UserAgent.isPlatform('Mac OS X');
	var isWindows = UserAgent.isPlatform('Windows');
	
	// Firefox on OSX had a bug resulting in navigation instead of cursor movement.
	// This bug was fixed in Firefox 29. Feature detection is virtually impossible
	// so we just check the version number. See #342765.
	var shouldFixFirefoxMovement = isOSX && UserAgent.isBrowser('Firefox < 29');
	
	var hasCommandModifier = KeyBindingUtil.hasCommandModifier,
	    isCtrlKeyCommand = KeyBindingUtil.isCtrlKeyCommand;
	
	
	function shouldRemoveWord(e) {
	  return isOSX && e.altKey || isCtrlKeyCommand(e);
	}
	
	/**
	 * Get the appropriate undo/redo command for a Z key command.
	 */
	function getZCommand(e) {
	  if (!hasCommandModifier(e)) {
	    return null;
	  }
	  return e.shiftKey ? 'redo' : 'undo';
	}
	
	function getDeleteCommand(e) {
	  // Allow default "cut" behavior for Windows on Shift + Delete.
	  if (isWindows && e.shiftKey) {
	    return null;
	  }
	  return shouldRemoveWord(e) ? 'delete-word' : 'delete';
	}
	
	function getBackspaceCommand(e) {
	  if (hasCommandModifier(e) && isOSX) {
	    return 'backspace-to-start-of-line';
	  }
	  return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
	}
	
	/**
	 * Retrieve a bound key command for the given event.
	 */
	function getDefaultKeyBinding(e) {
	  switch (e.keyCode) {
	    case 66:
	      // B
	      return hasCommandModifier(e) ? 'bold' : null;
	    case 68:
	      // D
	      return isCtrlKeyCommand(e) ? 'delete' : null;
	    case 72:
	      // H
	      return isCtrlKeyCommand(e) ? 'backspace' : null;
	    case 73:
	      // I
	      return hasCommandModifier(e) ? 'italic' : null;
	    case 74:
	      // J
	      return hasCommandModifier(e) ? 'code' : null;
	    case 75:
	      // K
	      return !isWindows && isCtrlKeyCommand(e) ? 'secondary-cut' : null;
	    case 77:
	      // M
	      return isCtrlKeyCommand(e) ? 'split-block' : null;
	    case 79:
	      // O
	      return isCtrlKeyCommand(e) ? 'split-block' : null;
	    case 84:
	      // T
	      return isOSX && isCtrlKeyCommand(e) ? 'transpose-characters' : null;
	    case 85:
	      // U
	      return hasCommandModifier(e) ? 'underline' : null;
	    case 87:
	      // W
	      return isOSX && isCtrlKeyCommand(e) ? 'backspace-word' : null;
	    case 89:
	      // Y
	      if (isCtrlKeyCommand(e)) {
	        return isWindows ? 'redo' : 'secondary-paste';
	      }
	      return null;
	    case 90:
	      // Z
	      return getZCommand(e) || null;
	    case Keys.RETURN:
	      return 'split-block';
	    case Keys.DELETE:
	      return getDeleteCommand(e);
	    case Keys.BACKSPACE:
	      return getBackspaceCommand(e);
	    // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.
	    case Keys.LEFT:
	      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;
	    case Keys.RIGHT:
	      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;
	    default:
	      return null;
	  }
	}
	
	module.exports = getDefaultKeyBinding;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDraftEditorSelectionWithNodes
	 * @format
	 * 
	 */
	
	'use strict';
	
	var findAncestorOffsetKey = __webpack_require__(448);
	var getSelectionOffsetKeyForNode = __webpack_require__(656);
	var getUpdatedSelectionState = __webpack_require__(658);
	var invariant = __webpack_require__(28);
	var nullthrows = __webpack_require__(136);
	
	/**
	 * Convert the current selection range to an anchor/focus pair of offset keys
	 * and values that can be interpreted by components.
	 */
	function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
	  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
	  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE;
	
	  // If the selection range lies only on text nodes, the task is simple.
	  // Find the nearest offset-aware elements and use the
	  // offset values supplied by the selection range.
	  if (anchorIsTextNode && focusIsTextNode) {
	    return {
	      selectionState: getUpdatedSelectionState(editorState, nullthrows(findAncestorOffsetKey(anchorNode)), anchorOffset, nullthrows(findAncestorOffsetKey(focusNode)), focusOffset),
	      needsRecovery: false
	    };
	  }
	
	  var anchorPoint = null;
	  var focusPoint = null;
	  var needsRecovery = true;
	
	  // An element is selected. Convert this selection range into leaf offset
	  // keys and offset values for consumption at the component level. This
	  // is common in Firefox, where select-all and triple click behavior leads
	  // to entire elements being selected.
	  //
	  // Note that we use the `needsRecovery` parameter in the callback here. This
	  // is because when certain elements are selected, the behavior for subsequent
	  // cursor movement (e.g. via arrow keys) is uncertain and may not match
	  // expectations at the component level. For example, if an entire <div> is
	  // selected and the user presses the right arrow, Firefox keeps the selection
	  // on the <div>. If we allow subsequent keypresses to insert characters
	  // natively, they will be inserted into a browser-created text node to the
	  // right of that <div>. This is obviously undesirable.
	  //
	  // With the `needsRecovery` flag, we inform the caller that it is responsible
	  // for manually setting the selection state on the rendered document to
	  // ensure proper selection state maintenance.
	
	  if (anchorIsTextNode) {
	    anchorPoint = {
	      key: nullthrows(findAncestorOffsetKey(anchorNode)),
	      offset: anchorOffset
	    };
	    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
	  } else if (focusIsTextNode) {
	    focusPoint = {
	      key: nullthrows(findAncestorOffsetKey(focusNode)),
	      offset: focusOffset
	    };
	    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
	  } else {
	    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
	    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
	
	    // If the selection is collapsed on an empty block, don't force recovery.
	    // This way, on arrow key selection changes, the browser can move the
	    // cursor from a non-zero offset on one block, through empty blocks,
	    // to a matching non-zero offset on other text blocks.
	    if (anchorNode === focusNode && anchorOffset === focusOffset) {
	      needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== 'BR';
	    }
	  }
	
	  return {
	    selectionState: getUpdatedSelectionState(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
	    needsRecovery: needsRecovery
	  };
	}
	
	/**
	 * Identify the first leaf descendant for the given node.
	 */
	function getFirstLeaf(node) {
	  while (node.firstChild && (
	  // data-blocks has no offset
	  node.firstChild instanceof Element && node.firstChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.firstChild))) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Identify the last leaf descendant for the given node.
	 */
	function getLastLeaf(node) {
	  while (node.lastChild && (
	  // data-blocks has no offset
	  node.lastChild instanceof Element && node.lastChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.lastChild))) {
	    node = node.lastChild;
	  }
	  return node;
	}
	
	function getPointForNonTextNode(editorRoot, startNode, childOffset) {
	  var node = startNode;
	  var offsetKey = findAncestorOffsetKey(node);
	
	  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ?  false ? invariant(false, 'Unknown node in selection range.') : invariant(false) : void 0;
	
	  // If the editorRoot is the selection, step downward into the content
	  // wrapper.
	  if (editorRoot === node) {
	    node = node.firstChild;
	    !(node instanceof Element && node.getAttribute('data-contents') === 'true') ?  false ? invariant(false, 'Invalid DraftEditorContents structure.') : invariant(false) : void 0;
	    if (childOffset > 0) {
	      childOffset = node.childNodes.length;
	    }
	  }
	
	  // If the child offset is zero and we have an offset key, we're done.
	  // If there's no offset key because the entire editor is selected,
	  // find the leftmost ("first") leaf in the tree and use that as the offset
	  // key.
	  if (childOffset === 0) {
	    var key = null;
	    if (offsetKey != null) {
	      key = offsetKey;
	    } else {
	      var firstLeaf = getFirstLeaf(node);
	      key = nullthrows(getSelectionOffsetKeyForNode(firstLeaf));
	    }
	    return { key: key, offset: 0 };
	  }
	
	  var nodeBeforeCursor = node.childNodes[childOffset - 1];
	  var leafKey = null;
	  var textLength = null;
	
	  if (!getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
	    // Our target node may be a leaf or a text node, in which case we're
	    // already where we want to be and can just use the child's length as
	    // our offset.
	    leafKey = nullthrows(offsetKey);
	    textLength = getTextContentLength(nodeBeforeCursor);
	  } else {
	    // Otherwise, we'll look at the child to the left of the cursor and find
	    // the last leaf node in its subtree.
	    var lastLeaf = getLastLeaf(nodeBeforeCursor);
	    leafKey = nullthrows(getSelectionOffsetKeyForNode(lastLeaf));
	    textLength = getTextContentLength(lastLeaf);
	  }
	
	  return {
	    key: leafKey,
	    offset: textLength
	  };
	}
	
	/**
	 * Return the length of a node's textContent, regarding single newline
	 * characters as zero-length. This allows us to avoid problems with identifying
	 * the correct selection offset for empty blocks in IE, in which we
	 * render newlines instead of break tags.
	 */
	function getTextContentLength(node) {
	  var textContent = node.textContent;
	  return textContent === '\n' ? 0 : textContent.length;
	}
	
	module.exports = getDraftEditorSelectionWithNodes;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getFragmentFromSelection
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getContentStateFragment = __webpack_require__(334);
	
	function getFragmentFromSelection(editorState) {
	  var selectionState = editorState.getSelection();
	
	  if (selectionState.isCollapsed()) {
	    return null;
	  }
	
	  return getContentStateFragment(editorState.getCurrentContent(), selectionState);
	}
	
	module.exports = getFragmentFromSelection;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNextDelimiterBlockKey
	 * @format
	 * 
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	
	var ContentBlockNode = __webpack_require__(123);
	
	var getNextDelimiterBlockKey = function getNextDelimiterBlockKey(block, blockMap) {
	  var isExperimentalTreeBlock = block instanceof ContentBlockNode;
	
	  if (!isExperimentalTreeBlock) {
	    return null;
	  }
	
	  var nextSiblingKey = block.getNextSiblingKey();
	
	  if (nextSiblingKey) {
	    return nextSiblingKey;
	  }
	
	  var parent = block.getParentKey();
	
	  if (!parent) {
	    return null;
	  }
	
	  var nextNonDescendantBlock = blockMap.get(parent);
	  while (nextNonDescendantBlock && !nextNonDescendantBlock.getNextSiblingKey()) {
	    var parentKey = nextNonDescendantBlock.getParentKey();
	    nextNonDescendantBlock = parentKey ? blockMap.get(parentKey) : null;
	  }
	
	  if (!nextNonDescendantBlock) {
	    return null;
	  }
	
	  return nextNonDescendantBlock.getNextSiblingKey();
	};
	
	module.exports = getNextDelimiterBlockKey;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangeClientRects
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(150);
	
	var invariant = __webpack_require__(28);
	
	var isChrome = UserAgent.isBrowser('Chrome');
	
	// In Chrome, the client rects will include the entire bounds of all nodes that
	// begin (have a start tag) within the selection, even if the selection does
	// not overlap the entire node. To resolve this, we split the range at each
	// start tag and join the client rects together.
	// https://code.google.com/p/chromium/issues/detail?id=324437
	/* eslint-disable consistent-return */
	function getRangeClientRectsChrome(range) {
	  var tempRange = range.cloneRange();
	  var clientRects = [];
	
	  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
	    // If we've climbed up to the common ancestor, we can now use the
	    // original start point and stop climbing the tree.
	    var atCommonAncestor = ancestor === range.commonAncestorContainer;
	    if (atCommonAncestor) {
	      tempRange.setStart(range.startContainer, range.startOffset);
	    } else {
	      tempRange.setStart(tempRange.endContainer, 0);
	    }
	    var rects = Array.from(tempRange.getClientRects());
	    clientRects.push(rects);
	    if (atCommonAncestor) {
	      var _ref;
	
	      clientRects.reverse();
	      return (_ref = []).concat.apply(_ref, clientRects);
	    }
	    tempRange.setEndBefore(ancestor);
	  }
	
	   true ?  false ? invariant(false, 'Found an unexpected detached subtree when getting range client rects.') : invariant(false) : void 0;
	}
	/* eslint-enable consistent-return */
	
	/**
	 * Like range.getClientRects() but normalizes for browser bugs.
	 */
	var getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
	  return Array.from(range.getClientRects());
	};
	
	module.exports = getRangeClientRects;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getSafeBodyFromHTML
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(150);
	
	var invariant = __webpack_require__(28);
	
	var isOldIE = UserAgent.isBrowser('IE <= 9');
	
	// Provides a dom node that will not execute scripts
	// https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
	// https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM
	
	function getSafeBodyFromHTML(html) {
	  var doc;
	  var root = null;
	  // Provides a safe context
	  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
	    doc = document.implementation.createHTMLDocument('foo');
	    !doc.documentElement ?  false ? invariant(false, 'Missing doc.documentElement') : invariant(false) : void 0;
	    doc.documentElement.innerHTML = html;
	    root = doc.getElementsByTagName('body')[0];
	  }
	  return root;
	}
	
	module.exports = getSafeBodyFromHTML;

/***/ }),
/* 656 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getSelectionOffsetKeyForNode
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Get offset key from a node or it's child nodes. Return the first offset key
	 * found on the DOM tree of given node.
	 */
	
	function getSelectionOffsetKeyForNode(node) {
	  if (node instanceof Element) {
	    var offsetKey = node.getAttribute('data-offset-key');
	    if (offsetKey) {
	      return offsetKey;
	    }
	    for (var ii = 0; ii < node.childNodes.length; ii++) {
	      var childOffsetKey = getSelectionOffsetKeyForNode(node.childNodes[ii]);
	      if (childOffsetKey) {
	        return childOffsetKey;
	      }
	    }
	  }
	  return null;
	}
	
	module.exports = getSelectionOffsetKeyForNode;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentFromFiles
	 * @format
	 * 
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(28);
	
	var TEXT_CLIPPING_REGEX = /\.textClipping$/;
	
	var TEXT_TYPES = {
	  'text/plain': true,
	  'text/html': true,
	  'text/rtf': true
	};
	
	// Somewhat arbitrary upper bound on text size. Let's not lock up the browser.
	var TEXT_SIZE_UPPER_BOUND = 5000;
	
	/**
	 * Extract the text content from a file list.
	 */
	function getTextContentFromFiles(files, callback) {
	  var readCount = 0;
	  var results = [];
	  files.forEach(function ( /*blob*/file) {
	    readFile(file, function ( /*string*/text) {
	      readCount++;
	      text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));
	      if (readCount == files.length) {
	        callback(results.join('\r'));
	      }
	    });
	  });
	}
	
	/**
	 * todo isaac: Do work to turn html/rtf into a content fragment.
	 */
	function readFile(file, callback) {
	  if (!global.FileReader || file.type && !(file.type in TEXT_TYPES)) {
	    callback('');
	    return;
	  }
	
	  if (file.type === '') {
	    var contents = '';
	    // Special-case text clippings, which have an empty type but include
	    // `.textClipping` in the file name. `readAsText` results in an empty
	    // string for text clippings, so we force the file name to serve
	    // as the text value for the file.
	    if (TEXT_CLIPPING_REGEX.test(file.name)) {
	      contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
	    }
	    callback(contents);
	    return;
	  }
	
	  var reader = new FileReader();
	  reader.onload = function () {
	    var result = reader.result;
	    !(typeof result === 'string') ?  false ? invariant(false, 'We should be calling "FileReader.readAsText" which returns a string') : invariant(false) : void 0;
	    callback(result);
	  };
	  reader.onerror = function () {
	    callback('');
	  };
	  reader.readAsText(file);
	}
	
	module.exports = getTextContentFromFiles;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUpdatedSelectionState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftOffsetKey = __webpack_require__(333);
	
	var nullthrows = __webpack_require__(136);
	
	function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
	  var selection = nullthrows(editorState.getSelection());
	  if (false) {
	    if (!anchorKey || !focusKey) {
	      /*eslint-disable no-console */
	      console.warn('Invalid selection state.', arguments, editorState.toJS());
	      /*eslint-enable no-console */
	      return selection;
	    }
	  }
	
	  var anchorPath = DraftOffsetKey.decode(anchorKey);
	  var anchorBlockKey = anchorPath.blockKey;
	  var anchorLeaf = editorState.getBlockTree(anchorBlockKey).getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);
	
	  var focusPath = DraftOffsetKey.decode(focusKey);
	  var focusBlockKey = focusPath.blockKey;
	  var focusLeaf = editorState.getBlockTree(focusBlockKey).getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);
	
	  var anchorLeafStart = anchorLeaf.get('start');
	  var focusLeafStart = focusLeaf.get('start');
	
	  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
	  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;
	
	  var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;
	
	  if (areEqual) {
	    return selection;
	  }
	
	  var isBackward = false;
	  if (anchorBlockKey === focusBlockKey) {
	    var anchorLeafEnd = anchorLeaf.get('end');
	    var focusLeafEnd = focusLeaf.get('end');
	    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
	      isBackward = focusOffset < anchorOffset;
	    } else {
	      isBackward = focusLeafStart < anchorLeafStart;
	    }
	  } else {
	    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
	      return v === anchorBlockKey || v === focusBlockKey;
	    }).first();
	    isBackward = startKey === focusBlockKey;
	  }
	
	  return selection.merge({
	    anchorKey: anchorBlockKey,
	    anchorOffset: anchorBlockOffset,
	    focusKey: focusBlockKey,
	    focusOffset: focusBlockOffset,
	    isBackward: isBackward
	  });
	}
	
	module.exports = getUpdatedSelectionState;

/***/ }),
/* 659 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertIntoList
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Maintain persistence for target list when appending and prepending.
	 */
	function insertIntoList(targetList, toInsert, offset) {
	  if (offset === targetList.count()) {
	    toInsert.forEach(function (c) {
	      targetList = targetList.push(c);
	    });
	  } else if (offset === 0) {
	    toInsert.reverse().forEach(function (c) {
	      targetList = targetList.unshift(c);
	    });
	  } else {
	    var head = targetList.slice(0, offset);
	    var tail = targetList.slice(offset);
	    targetList = head.concat(toInsert, tail).toList();
	  }
	  return targetList;
	}
	
	module.exports = insertIntoList;

/***/ }),
/* 660 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isSelectionAtLeafStart
	 * @format
	 * 
	 */
	
	'use strict';
	
	function isSelectionAtLeafStart(editorState) {
	  var selection = editorState.getSelection();
	  var anchorKey = selection.getAnchorKey();
	  var blockTree = editorState.getBlockTree(anchorKey);
	  var offset = selection.getStartOffset();
	
	  var isAtStart = false;
	
	  blockTree.some(function (leafSet) {
	    if (offset === leafSet.get('start')) {
	      isAtStart = true;
	      return true;
	    }
	
	    if (offset < leafSet.get('end')) {
	      return leafSet.get('leaves').some(function (leaf) {
	        var leafStart = leaf.get('start');
	        if (offset === leafStart) {
	          isAtStart = true;
	          return true;
	        }
	
	        return false;
	      });
	    }
	
	    return false;
	  });
	
	  return isAtStart;
	}
	
	module.exports = isSelectionAtLeafStart;

/***/ }),
/* 661 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule moveSelectionForward
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Given a collapsed selection, move the focus `maxDistance` forward within
	 * the selected block. If the selection will go beyond the end of the block,
	 * move focus to the start of the next block, but no further.
	 *
	 * This function is not Unicode-aware, so surrogate pairs will be treated
	 * as having length 2.
	 */
	function moveSelectionForward(editorState, maxDistance) {
	  var selection = editorState.getSelection();
	  var key = selection.getStartKey();
	  var offset = selection.getStartOffset();
	  var content = editorState.getCurrentContent();
	
	  var focusKey = key;
	  var focusOffset;
	
	  var block = content.getBlockForKey(key);
	
	  if (maxDistance > block.getText().length - offset) {
	    focusKey = content.getKeyAfter(key);
	    focusOffset = 0;
	  } else {
	    focusOffset = offset + maxDistance;
	  }
	
	  return selection.merge({ focusKey: focusKey, focusOffset: focusOffset });
	}
	
	module.exports = moveSelectionForward;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule randomizeBlockMapKeys
	 * @format
	 * 
	 */
	
	'use strict';
	
	var ContentBlockNode = __webpack_require__(123);
	var Immutable = __webpack_require__(60);
	
	var generateRandomKey = __webpack_require__(161);
	
	var OrderedMap = Immutable.OrderedMap;
	
	
	var randomizeContentBlockNodeKeys = function randomizeContentBlockNodeKeys(blockMap) {
	  var newKeysRef = {};
	
	  // we keep track of root blocks in order to update subsequent sibling links
	  var lastRootBlock = void 0;
	
	  return OrderedMap(blockMap.withMutations(function (blockMapState) {
	    blockMapState.forEach(function (block, index) {
	      var oldKey = block.getKey();
	      var nextKey = block.getNextSiblingKey();
	      var prevKey = block.getPrevSiblingKey();
	      var childrenKeys = block.getChildKeys();
	      var parentKey = block.getParentKey();
	
	      // new key that we will use to build linking
	      var key = generateRandomKey();
	
	      // we will add it here to re-use it later
	      newKeysRef[oldKey] = key;
	
	      if (nextKey) {
	        var nextBlock = blockMapState.get(nextKey);
	        if (nextBlock) {
	          blockMapState.setIn([nextKey, 'prevSibling'], key);
	        } else {
	          // this can happen when generating random keys for fragments
	          blockMapState.setIn([oldKey, 'nextSibling'], null);
	        }
	      }
	
	      if (prevKey) {
	        var prevBlock = blockMapState.get(prevKey);
	        if (prevBlock) {
	          blockMapState.setIn([prevKey, 'nextSibling'], key);
	        } else {
	          // this can happen when generating random keys for fragments
	          blockMapState.setIn([oldKey, 'prevSibling'], null);
	        }
	      }
	
	      if (parentKey && blockMapState.get(parentKey)) {
	        var parentBlock = blockMapState.get(parentKey);
	        var parentChildrenList = parentBlock.getChildKeys();
	        blockMapState.setIn([parentKey, 'children'], parentChildrenList.set(parentChildrenList.indexOf(block.getKey()), key));
	      } else {
	        // blocks will then be treated as root block nodes
	        blockMapState.setIn([oldKey, 'parent'], null);
	
	        if (lastRootBlock) {
	          blockMapState.setIn([lastRootBlock.getKey(), 'nextSibling'], key);
	          blockMapState.setIn([oldKey, 'prevSibling'], newKeysRef[lastRootBlock.getKey()]);
	        }
	
	        lastRootBlock = blockMapState.get(oldKey);
	      }
	
	      childrenKeys.forEach(function (childKey) {
	        var childBlock = blockMapState.get(childKey);
	        if (childBlock) {
	          blockMapState.setIn([childKey, 'parent'], key);
	        } else {
	          blockMapState.setIn([oldKey, 'children'], block.getChildKeys().filter(function (child) {
	            return child !== childKey;
	          }));
	        }
	      });
	    });
	  }).toArray().map(function (block) {
	    return [newKeysRef[block.getKey()], block.set('key', newKeysRef[block.getKey()])];
	  }));
	};
	
	var randomizeContentBlockKeys = function randomizeContentBlockKeys(blockMap) {
	  return OrderedMap(blockMap.toArray().map(function (block) {
	    var key = generateRandomKey();
	    return [key, block.set('key', key)];
	  }));
	};
	
	var randomizeBlockMapKeys = function randomizeBlockMapKeys(blockMap) {
	  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;
	
	  if (!isTreeBasedBlockMap) {
	    return randomizeContentBlockKeys(blockMap);
	  }
	
	  return randomizeContentBlockNodeKeys(blockMap);
	};
	
	module.exports = randomizeBlockMapKeys;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeEntitiesAtEdges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(112);
	
	var findRangesImmutable = __webpack_require__(272);
	var invariant = __webpack_require__(28);
	
	function removeEntitiesAtEdges(contentState, selectionState) {
	  var blockMap = contentState.getBlockMap();
	  var entityMap = contentState.getEntityMap();
	
	  var updatedBlocks = {};
	
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var startBlock = blockMap.get(startKey);
	  var updatedStart = removeForBlock(entityMap, startBlock, startOffset);
	
	  if (updatedStart !== startBlock) {
	    updatedBlocks[startKey] = updatedStart;
	  }
	
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	  var endBlock = blockMap.get(endKey);
	  if (startKey === endKey) {
	    endBlock = updatedStart;
	  }
	
	  var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);
	
	  if (updatedEnd !== endBlock) {
	    updatedBlocks[endKey] = updatedEnd;
	  }
	
	  if (!Object.keys(updatedBlocks).length) {
	    return contentState.set('selectionAfter', selectionState);
	  }
	
	  return contentState.merge({
	    blockMap: blockMap.merge(updatedBlocks),
	    selectionAfter: selectionState
	  });
	}
	
	function getRemovalRange(characters, key, offset) {
	  var removalRange;
	  findRangesImmutable(characters, function (a, b) {
	    return a.getEntity() === b.getEntity();
	  }, function (element) {
	    return element.getEntity() === key;
	  }, function (start, end) {
	    if (start <= offset && end >= offset) {
	      removalRange = { start: start, end: end };
	    }
	  });
	  !(typeof removalRange === 'object') ?  false ? invariant(false, 'Removal range must exist within character list.') : invariant(false) : void 0;
	  return removalRange;
	}
	
	function removeForBlock(entityMap, block, offset) {
	  var chars = block.getCharacterList();
	  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
	  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
	  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
	  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;
	
	  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
	    var entity = entityMap.__get(entityAfterCursor);
	    if (entity.getMutability() !== 'MUTABLE') {
	      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset),
	          start = _getRemovalRange.start,
	          end = _getRemovalRange.end;
	
	      var current;
	      while (start < end) {
	        current = chars.get(start);
	        chars = chars.set(start, CharacterMetadata.applyEntity(current, null));
	        start++;
	      }
	      return block.set('characterList', chars);
	    }
	  }
	
	  return block;
	}
	
	module.exports = removeEntitiesAtEdges;

/***/ }),
/* 664 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 665 */
203,
/* 666 */
203,
/* 667 */
203,
/* 668 */
203,
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var PhotosMimeType = __webpack_require__(1293);
	
	var createArrayFromMixed = __webpack_require__(675);
	var emptyFunction = __webpack_require__(113);
	
	var CR_LF_REGEX = new RegExp('\r\n', 'g');
	var LF_ONLY = '\n';
	
	var RICH_TEXT_TYPES = {
	  'text/rtf': 1,
	  'text/html': 1
	};
	
	/**
	 * If DataTransferItem is a file then return the Blob of data.
	 *
	 * @param {object} item
	 * @return {?blob}
	 */
	function getFileFromDataTransfer(item) {
	  if (item.kind == 'file') {
	    return item.getAsFile();
	  }
	}
	
	var DataTransfer = function () {
	  /**
	   * @param {object} data
	   */
	  function DataTransfer(data) {
	    _classCallCheck(this, DataTransfer);
	
	    this.data = data;
	
	    // Types could be DOMStringList or array
	    this.types = data.types ? createArrayFromMixed(data.types) : [];
	  }
	
	  /**
	   * Is this likely to be a rich text data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isRichText = function isRichText() {
	    // If HTML is available, treat this data as rich text. This way, we avoid
	    // using a pasted image if it is packaged with HTML -- this may occur with
	    // pastes from MS Word, for example.  However this is only rich text if
	    // there's accompanying text.
	    if (this.getHTML() && this.getText()) {
	      return true;
	    }
	
	    // When an image is copied from a preview window, you end up with two
	    // DataTransferItems one of which is a file's metadata as text.  Skip those.
	    if (this.isImage()) {
	      return false;
	    }
	
	    return this.types.some(function (type) {
	      return RICH_TEXT_TYPES[type];
	    });
	  };
	
	  /**
	   * Get raw text.
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getText = function getText() {
	    var text;
	    if (this.data.getData) {
	      if (!this.types.length) {
	        text = this.data.getData('Text');
	      } else if (this.types.indexOf('text/plain') != -1) {
	        text = this.data.getData('text/plain');
	      }
	    }
	    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
	  };
	
	  /**
	   * Get HTML paste data
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getHTML = function getHTML() {
	    if (this.data.getData) {
	      if (!this.types.length) {
	        return this.data.getData('Text');
	      } else if (this.types.indexOf('text/html') != -1) {
	        return this.data.getData('text/html');
	      }
	    }
	  };
	
	  /**
	   * Is this a link data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isLink = function isLink() {
	    return this.types.some(function (type) {
	      return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
	    });
	  };
	
	  /**
	   * Get a link url.
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getLink = function getLink() {
	    if (this.data.getData) {
	      if (this.types.indexOf('text/x-moz-url') != -1) {
	        var url = this.data.getData('text/x-moz-url').split('\n');
	        return url[0];
	      }
	      return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
	    }
	
	    return null;
	  };
	
	  /**
	   * Is this an image data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isImage = function isImage() {
	    var isImage = this.types.some(function (type) {
	      // Firefox will have a type of application/x-moz-file for images during
	      // dragging
	      return type.indexOf('application/x-moz-file') != -1;
	    });
	
	    if (isImage) {
	      return true;
	    }
	
	    var items = this.getFiles();
	    for (var i = 0; i < items.length; i++) {
	      var type = items[i].type;
	      if (!PhotosMimeType.isImage(type)) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	  DataTransfer.prototype.getCount = function getCount() {
	    if (this.data.hasOwnProperty('items')) {
	      return this.data.items.length;
	    } else if (this.data.hasOwnProperty('mozItemCount')) {
	      return this.data.mozItemCount;
	    } else if (this.data.files) {
	      return this.data.files.length;
	    }
	    return null;
	  };
	
	  /**
	   * Get files.
	   *
	   * @return {array}
	   */
	
	
	  DataTransfer.prototype.getFiles = function getFiles() {
	    if (this.data.items) {
	      // createArrayFromMixed doesn't properly handle DataTransferItemLists.
	      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction.thatReturnsArgument);
	    } else if (this.data.files) {
	      return Array.prototype.slice.call(this.data.files);
	    } else {
	      return [];
	    }
	  };
	
	  /**
	   * Are there any files to fetch?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.hasFiles = function hasFiles() {
	    return this.getFiles().length > 0;
	  };
	
	  return DataTransfer;
	}();
	
	module.exports = DataTransfer;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(113);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 671 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * @param {DOMElement} element
	 * @param {DOMDocument} doc
	 * @return {boolean}
	 */
	function _isViewportScrollElement(element, doc) {
	  return !!doc && (element === doc.documentElement || element === doc.body);
	}
	
	/**
	 * Scroll Module. This class contains 4 simple static functions
	 * to be used to access Element.scrollTop/scrollLeft properties.
	 * To solve the inconsistencies between browsers when either
	 * document.body or document.documentElement is supplied,
	 * below logic will be used to alleviate the issue:
	 *
	 * 1. If 'element' is either 'document.body' or 'document.documentElement,
	 *    get whichever element's 'scroll{Top,Left}' is larger.
	 * 2. If 'element' is either 'document.body' or 'document.documentElement',
	 *    set the 'scroll{Top,Left}' on both elements.
	 */
	
	var Scroll = {
	  /**
	   * @param {DOMElement} element
	   * @return {number}
	   */
	  getTop: function getTop(element) {
	    var doc = element.ownerDocument;
	    return _isViewportScrollElement(element, doc) ?
	    // In practice, they will either both have the same value,
	    // or one will be zero and the other will be the scroll position
	    // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
	    doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @param {number} newTop
	   */
	  setTop: function setTop(element, newTop) {
	    var doc = element.ownerDocument;
	    if (_isViewportScrollElement(element, doc)) {
	      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
	    } else {
	      element.scrollTop = newTop;
	    }
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @return {number}
	   */
	  getLeft: function getLeft(element) {
	    var doc = element.ownerDocument;
	    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @param {number} newLeft
	   */
	  setLeft: function setLeft(element, newLeft) {
	    var doc = element.ownerDocument;
	    if (_isViewportScrollElement(element, doc)) {
	      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
	    } else {
	      element.scrollLeft = newLeft;
	    }
	  }
	};
	
	module.exports = Scroll;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Basic (stateless) API for text direction detection
	 *
	 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	var UnicodeBidiDirection = __webpack_require__(456);
	
	var invariant = __webpack_require__(28);
	
	/**
	 * RegExp ranges of characters with a *Strong* Bidi_Class value.
	 *
	 * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
	 *
	 * NOTE: For performance reasons, we only support Unicode's
	 *       Basic Multilingual Plane (BMP) for now.
	 */
	var RANGE_BY_BIDI_TYPE = {
	
	  L: 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BB' + '\u01BC-\u01BF\u01C0-\u01C3\u01C4-\u0293\u0294\u0295-\u02AF\u02B0-\u02B8' + '\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377' + '\u037A\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1' + '\u03A3-\u03F5\u03F7-\u0481\u0482\u048A-\u052F\u0531-\u0556\u0559' + '\u055A-\u055F\u0561-\u0587\u0589\u0903\u0904-\u0939\u093B\u093D' + '\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0950\u0958-\u0961\u0964-\u0965' + '\u0966-\u096F\u0970\u0971\u0972-\u0980\u0982-\u0983\u0985-\u098C' + '\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD' + '\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09CE\u09D7\u09DC-\u09DD' + '\u09DF-\u09E1\u09E6-\u09EF\u09F0-\u09F1\u09F4-\u09F9\u09FA\u0A03' + '\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33' + '\u0A35-\u0A36\u0A38-\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F' + '\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0' + '\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0AD0' + '\u0AE0-\u0AE1\u0AE6-\u0AEF\u0AF0\u0B02-\u0B03\u0B05-\u0B0C\u0B0F-\u0B10' + '\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40' + '\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0B5C-\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F' + '\u0B70\u0B71\u0B72-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95' + '\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9' + '\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7' + '\u0BE6-\u0BEF\u0BF0-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10' + '\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C59\u0C60-\u0C61' + '\u0C66-\u0C6F\u0C7F\u0C82-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8' + '\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CBE\u0CBF\u0CC0-\u0CC4\u0CC6' + '\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0CDE\u0CE0-\u0CE1\u0CE6-\u0CEF' + '\u0CF1-\u0CF2\u0D02-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D' + '\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D60-\u0D61' + '\u0D66-\u0D6F\u0D70-\u0D75\u0D79\u0D7A-\u0D7F\u0D82-\u0D83\u0D85-\u0D96' + '\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF' + '\u0DE6-\u0DEF\u0DF2-\u0DF3\u0DF4\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45' + '\u0E46\u0E4F\u0E50-\u0E59\u0E5A-\u0E5B\u0E81-\u0E82\u0E84\u0E87-\u0E88' + '\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7' + '\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6' + '\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F01-\u0F03\u0F04-\u0F12\u0F13\u0F14' + '\u0F15-\u0F17\u0F1A-\u0F1F\u0F20-\u0F29\u0F2A-\u0F33\u0F34\u0F36\u0F38' + '\u0F3E-\u0F3F\u0F40-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C' + '\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FCF\u0FD0-\u0FD4\u0FD5-\u0FD8' + '\u0FD9-\u0FDA\u1000-\u102A\u102B-\u102C\u1031\u1038\u103B-\u103C\u103F' + '\u1040-\u1049\u104A-\u104F\u1050-\u1055\u1056-\u1057\u105A-\u105D\u1061' + '\u1062-\u1064\u1065-\u1066\u1067-\u106D\u106E-\u1070\u1075-\u1081' + '\u1083-\u1084\u1087-\u108C\u108E\u108F\u1090-\u1099\u109A-\u109C' + '\u109E-\u109F\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FB\u10FC' + '\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288' + '\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5' + '\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u1368' + '\u1369-\u137C\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166D-\u166E' + '\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EB-\u16ED\u16EE-\u16F0' + '\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735-\u1736' + '\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5' + '\u17C7-\u17C8\u17D4-\u17D6\u17D7\u17D8-\u17DA\u17DC\u17E0-\u17E9' + '\u1810-\u1819\u1820-\u1842\u1843\u1844-\u1877\u1880-\u18A8\u18AA' + '\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930-\u1931' + '\u1933-\u1938\u1946-\u194F\u1950-\u196D\u1970-\u1974\u1980-\u19AB' + '\u19B0-\u19C0\u19C1-\u19C7\u19C8-\u19C9\u19D0-\u19D9\u19DA\u1A00-\u1A16' + '\u1A19-\u1A1A\u1A1E-\u1A1F\u1A20-\u1A54\u1A55\u1A57\u1A61\u1A63-\u1A64' + '\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AA6\u1AA7\u1AA8-\u1AAD' + '\u1B04\u1B05-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B45-\u1B4B' + '\u1B50-\u1B59\u1B5A-\u1B60\u1B61-\u1B6A\u1B74-\u1B7C\u1B82\u1B83-\u1BA0' + '\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAE-\u1BAF\u1BB0-\u1BB9\u1BBA-\u1BE5\u1BE7' + '\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1BFC-\u1BFF\u1C00-\u1C23\u1C24-\u1C2B' + '\u1C34-\u1C35\u1C3B-\u1C3F\u1C40-\u1C49\u1C4D-\u1C4F\u1C50-\u1C59' + '\u1C5A-\u1C77\u1C78-\u1C7D\u1C7E-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1' + '\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF2-\u1CF3\u1CF5-\u1CF6\u1D00-\u1D2B' + '\u1D2C-\u1D6A\u1D6B-\u1D77\u1D78\u1D79-\u1D9A\u1D9B-\u1DBF\u1E00-\u1F15' + '\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D' + '\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC' + '\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E' + '\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D' + '\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2135-\u2138\u2139' + '\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2182\u2183-\u2184' + '\u2185-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF' + '\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7C-\u2C7D\u2C7E-\u2CE4' + '\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F' + '\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE' + '\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005\u3006\u3007' + '\u3021-\u3029\u302E-\u302F\u3031-\u3035\u3038-\u303A\u303B\u303C' + '\u3041-\u3096\u309D-\u309E\u309F\u30A1-\u30FA\u30FC-\u30FE\u30FF' + '\u3105-\u312D\u3131-\u318E\u3190-\u3191\u3192-\u3195\u3196-\u319F' + '\u31A0-\u31BA\u31F0-\u31FF\u3200-\u321C\u3220-\u3229\u322A-\u3247' + '\u3248-\u324F\u3260-\u327B\u327F\u3280-\u3289\u328A-\u32B0\u32C0-\u32CB' + '\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5' + '\u4E00-\u9FCC\uA000-\uA014\uA015\uA016-\uA48C\uA4D0-\uA4F7\uA4F8-\uA4FD' + '\uA4FE-\uA4FF\uA500-\uA60B\uA60C\uA610-\uA61F\uA620-\uA629\uA62A-\uA62B' + '\uA640-\uA66D\uA66E\uA680-\uA69B\uA69C-\uA69D\uA6A0-\uA6E5\uA6E6-\uA6EF' + '\uA6F2-\uA6F7\uA722-\uA76F\uA770\uA771-\uA787\uA789-\uA78A\uA78B-\uA78E' + '\uA790-\uA7AD\uA7B0-\uA7B1\uA7F7\uA7F8-\uA7F9\uA7FA\uA7FB-\uA801' + '\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA823-\uA824\uA827\uA830-\uA835' + '\uA836-\uA837\uA840-\uA873\uA880-\uA881\uA882-\uA8B3\uA8B4-\uA8C3' + '\uA8CE-\uA8CF\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8F8-\uA8FA\uA8FB\uA900-\uA909' + '\uA90A-\uA925\uA92E-\uA92F\uA930-\uA946\uA952-\uA953\uA95F\uA960-\uA97C' + '\uA983\uA984-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uA9C1-\uA9CD' + '\uA9CF\uA9D0-\uA9D9\uA9DE-\uA9DF\uA9E0-\uA9E4\uA9E6\uA9E7-\uA9EF' + '\uA9F0-\uA9F9\uA9FA-\uA9FE\uAA00-\uAA28\uAA2F-\uAA30\uAA33-\uAA34' + '\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F\uAA60-\uAA6F' + '\uAA70\uAA71-\uAA76\uAA77-\uAA79\uAA7A\uAA7B\uAA7D\uAA7E-\uAAAF\uAAB1' + '\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAADD\uAADE-\uAADF' + '\uAAE0-\uAAEA\uAAEB\uAAEE-\uAAEF\uAAF0-\uAAF1\uAAF2\uAAF3-\uAAF4\uAAF5' + '\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E' + '\uAB30-\uAB5A\uAB5B\uAB5C-\uAB5F\uAB64-\uAB65\uABC0-\uABE2\uABE3-\uABE4' + '\uABE6-\uABE7\uABE9-\uABEA\uABEB\uABEC\uABF0-\uABF9\uAC00-\uD7A3' + '\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uF8FF\uF900-\uFA6D\uFA70-\uFAD9' + '\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF6F\uFF70' + '\uFF71-\uFF9D\uFF9E-\uFF9F\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF' + '\uFFD2-\uFFD7\uFFDA-\uFFDC',
	
	  R: '\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05D0-\u05EA\u05EB-\u05EF' + '\u05F0-\u05F2\u05F3-\u05F4\u05F5-\u05FF\u07C0-\u07C9\u07CA-\u07EA' + '\u07F4-\u07F5\u07FA\u07FB-\u07FF\u0800-\u0815\u081A\u0824\u0828' + '\u082E-\u082F\u0830-\u083E\u083F\u0840-\u0858\u085C-\u085D\u085E' + '\u085F-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB37\uFB38-\uFB3C' + '\uFB3D\uFB3E\uFB3F\uFB40-\uFB41\uFB42\uFB43-\uFB44\uFB45\uFB46-\uFB4F',
	
	  AL: '\u0608\u060B\u060D\u061B\u061C\u061D\u061E-\u061F\u0620-\u063F\u0640' + '\u0641-\u064A\u066D\u066E-\u066F\u0671-\u06D3\u06D4\u06D5\u06E5-\u06E6' + '\u06EE-\u06EF\u06FA-\u06FC\u06FD-\u06FE\u06FF\u0700-\u070D\u070E\u070F' + '\u0710\u0712-\u072F\u074B-\u074C\u074D-\u07A5\u07B1\u07B2-\u07BF' + '\u08A0-\u08B2\u08B3-\u08E3\uFB50-\uFBB1\uFBB2-\uFBC1\uFBC2-\uFBD2' + '\uFBD3-\uFD3D\uFD40-\uFD4F\uFD50-\uFD8F\uFD90-\uFD91\uFD92-\uFDC7' + '\uFDC8-\uFDCF\uFDF0-\uFDFB\uFDFC\uFDFE-\uFDFF\uFE70-\uFE74\uFE75' + '\uFE76-\uFEFC\uFEFD-\uFEFE'
	
	};
	
	var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
	
	var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
	
	/**
	 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
	 *
	 * @param str  A text block; e.g. paragraph, table cell, tag
	 * @return     A character with strong bidi direction, or null if not found
	 */
	function firstStrongChar(str) {
	  var match = REGEX_STRONG.exec(str);
	  return match == null ? null : match[0];
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL).
	 *
	 * @param str  A text block; e.g. paragraph, table cell, tag
	 * @return     The resolved direction
	 */
	function firstStrongCharDir(str) {
	  var strongChar = firstStrongChar(str);
	  if (strongChar == null) {
	    return UnicodeBidiDirection.NEUTRAL;
	  }
	  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection.RTL : UnicodeBidiDirection.LTR;
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
	 * direction, if no strong character is found.
	 *
	 * This function is supposed to be used in respect to Higher-Level Protocol
	 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
	 *
	 * @param str       A text block; e.g. paragraph, table cell, tag
	 * @param fallback  Fallback direction, used if no strong direction detected
	 *                  for the block (default = NEUTRAL)
	 * @return          The resolved direction
	 */
	function resolveBlockDir(str, fallback) {
	  fallback = fallback || UnicodeBidiDirection.NEUTRAL;
	  if (!str.length) {
	    return fallback;
	  }
	  var blockDir = firstStrongCharDir(str);
	  return blockDir === UnicodeBidiDirection.NEUTRAL ? fallback : blockDir;
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
	 * direction, if no strong character is found.
	 *
	 * NOTE: This function is similar to resolveBlockDir(), but uses the global
	 * direction as the fallback, so it *always* returns a Strong direction,
	 * making it useful for integration in places that you need to make the final
	 * decision, like setting some CSS class.
	 *
	 * This function is supposed to be used in respect to Higher-Level Protocol
	 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                The resolved Strong direction
	 */
	function getDirection(str, strongFallback) {
	  if (!strongFallback) {
	    strongFallback = UnicodeBidiDirection.getGlobalDir();
	  }
	  !UnicodeBidiDirection.isStrong(strongFallback) ?  false ? invariant(false, 'Fallback direction must be a strong direction') : invariant(false) : void 0;
	  return resolveBlockDir(str, strongFallback);
	}
	
	/**
	 * Returns true if getDirection(arguments...) returns LTR.
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                True if the resolved direction is LTR
	 */
	function isDirectionLTR(str, strongFallback) {
	  return getDirection(str, strongFallback) === UnicodeBidiDirection.LTR;
	}
	
	/**
	 * Returns true if getDirection(arguments...) returns RTL.
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                True if the resolved direction is RTL
	 */
	function isDirectionRTL(str, strongFallback) {
	  return getDirection(str, strongFallback) === UnicodeBidiDirection.RTL;
	}
	
	var UnicodeBidi = {
	  firstStrongChar: firstStrongChar,
	  firstStrongCharDir: firstStrongCharDir,
	  resolveBlockDir: resolveBlockDir,
	  getDirection: getDirection,
	  isDirectionLTR: isDirectionLTR,
	  isDirectionRTL: isDirectionRTL
	};
	
	module.exports = UnicodeBidi;

/***/ }),
/* 673 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(673);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(28);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 676 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 677 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 678 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.processStyleName = undefined;
	exports.createMarkupForStyles = createMarkupForStyles;
	
	var _camelizeStyleName = __webpack_require__(674);
	
	var _camelizeStyleName2 = _interopRequireDefault(_camelizeStyleName);
	
	var _dangerousStyleValue = __webpack_require__(1313);
	
	var _dangerousStyleValue2 = _interopRequireDefault(_dangerousStyleValue);
	
	var _hyphenateStyleName = __webpack_require__(458);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _memoizeStringOnly = __webpack_require__(459);
	
	var _memoizeStringOnly2 = _interopRequireDefault(_memoizeStringOnly);
	
	var _warning = __webpack_require__(61);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var processStyleName = exports.processStyleName = (0, _memoizeStringOnly2.default)(_hyphenateStyleName2.default); /**
	                                                                                                                   * Copyright 2013-present, Facebook, Inc.
	                                                                                                                   * All rights reserved.
	                                                                                                                   *
	                                                                                                                   * This source code is licensed under the BSD-style license found in the
	                                                                                                                   * LICENSE file in the root directory of this source tree. An additional grant
	                                                                                                                   * of patent rights can be found in the PATENTS file in the same directory.
	                                                                                                                   *
	                                                                                                                   * @providesModule CSSPropertyOperations
	                                                                                                                   */
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function warnHyphenatedStyleName(name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported style property %s. Did you mean %s?%s', name, (0, _camelizeStyleName2.default)(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function warnBadVendoredStyleName(name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function checkRenderMessage(owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function warnValidStyle(name, value, component) {
	    //eslint-disable-line no-var
	    var owner = void 0;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	
	function createMarkupForStyles(styles, component) {
	  var serialized = '';
	  for (var styleName in styles) {
	    var isCustomProp = styleName.indexOf('--') === 0;
	    if (!styles.hasOwnProperty(styleName)) {
	      continue;
	    }
	    if (styleName === 'label') {
	      continue;
	    }
	    var styleValue = styles[styleName];
	    if (false) {
	      warnValidStyle(styleName, styleValue, component);
	    }
	    if (styleValue != null) {
	      if (isCustomProp) {
	        serialized += styleName + ':' + styleValue + ';';
	      } else {
	        serialized += processStyleName(styleName) + ':';
	        serialized += (0, _dangerousStyleValue2.default)(styleName, styleValue, component) + ';';
	      }
	    }
	  }
	  return serialized || null;
	}

/***/ }),
/* 680 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = {
	  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
	  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
	};
	
	function flex(property, value) {
	  if (property === 'display' && values.hasOwnProperty(value)) {
	    return values[value];
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 681 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value, style) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    if (value.indexOf('column') > -1) {
	      style.WebkitBoxOrient = 'vertical';
	    } else {
	      style.WebkitBoxOrient = 'horizontal';
	    }
	    if (value.indexOf('reverse') > -1) {
	      style.WebkitBoxDirection = 'reverse';
	    } else {
	      style.WebkitBoxDirection = 'normal';
	    }
	  }
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _isPrefixedValue = __webpack_require__(135);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 683 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 684 */
[2365, 462],
/* 685 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addNewValuesOnly;
	function addIfNew(list, value) {
	  if (list.indexOf(value) === -1) {
	    list.push(value);
	  }
	}
	
	function addNewValuesOnly(list, values) {
	  if (Array.isArray(values)) {
	    for (var i = 0, len = values.length; i < len; ++i) {
	      addIfNew(list, values[i]);
	    }
	  } else {
	    addIfNew(list, values);
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 686 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isObject;
	function isObject(value) {
	  return value instanceof Object && !Array.isArray(value);
	}
	module.exports = exports["default"];

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixProperty;
	
	var _capitalizeString = __webpack_require__(462);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function prefixProperty(prefixProperties, property, style) {
	  if (prefixProperties.hasOwnProperty(property)) {
	    var requiredPrefixes = prefixProperties[property];
	    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
	      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports.extend = extend;
	var hop = Object.prototype.hasOwnProperty;
	
	function extend(obj) {
	    var sources = Array.prototype.slice.call(arguments, 1),
	        i, len, source, key;
	
	    for (i = 0, len = sources.length; i < len; i += 1) {
	        source = sources[i];
	        if (!source) { continue; }
	
	        for (key in source) {
	            if (hop.call(source, key)) {
	                obj[key] = source[key];
	            }
	        }
	    }
	
	    return obj;
	}
	exports.hop = hop;
	
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var isObject = __webpack_require__(1349);
	
	function isObjectObject(o) {
	  return isObject(o) === true
	    && Object.prototype.toString.call(o) === '[object Object]';
	}
	
	module.exports = function isPlainObject(o) {
	  var ctor,prot;
	
	  if (isObjectObject(o) === false) return false;
	
	  // If has modified constructor
	  ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;
	
	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;
	
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	
	  // Most likely a plain Object
	  return true;
	};


/***/ }),
/* 690 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(206),
	    root = __webpack_require__(124);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(124);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1399),
	    isArguments = __webpack_require__(352),
	    isArray = __webpack_require__(62),
	    isBuffer = __webpack_require__(354),
	    isIndex = __webpack_require__(348),
	    isTypedArray = __webpack_require__(482);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 694 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(471),
	    eq = __webpack_require__(283);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(466),
	    arrayEach = __webpack_require__(1366),
	    assignValue = __webpack_require__(695),
	    baseAssign = __webpack_require__(1368),
	    baseAssignIn = __webpack_require__(1369),
	    cloneBuffer = __webpack_require__(1404),
	    copyArray = __webpack_require__(708),
	    copySymbols = __webpack_require__(1411),
	    copySymbolsIn = __webpack_require__(1412),
	    getAllKeys = __webpack_require__(712),
	    getAllKeysIn = __webpack_require__(713),
	    getTag = __webpack_require__(280),
	    initCloneArray = __webpack_require__(1433),
	    initCloneByTag = __webpack_require__(1434),
	    initCloneObject = __webpack_require__(1435),
	    isArray = __webpack_require__(62),
	    isBuffer = __webpack_require__(354),
	    isMap = __webpack_require__(1476),
	    isObject = __webpack_require__(100),
	    isSet = __webpack_require__(1477),
	    keys = __webpack_require__(209);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	  } else if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(340),
	    arrayIncludes = __webpack_require__(468),
	    arrayIncludesWith = __webpack_require__(469),
	    arrayMap = __webpack_require__(162),
	    baseUnary = __webpack_require__(184),
	    cacheHas = __webpack_require__(345);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ }),
/* 698 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1373),
	    keys = __webpack_require__(209);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(470),
	    isArray = __webpack_require__(62);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 701 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.gt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is greater than `other`,
	 *  else `false`.
	 */
	function baseGt(value, other) {
	  return value > other;
	}
	
	module.exports = baseGt;


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(698),
	    baseIsNaN = __webpack_require__(1382),
	    strictIndexOf = __webpack_require__(1463);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(349),
	    nativeKeys = __webpack_require__(1451);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 704 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.lt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than `other`,
	 *  else `false`.
	 */
	function baseLt(value, other) {
	  return value < other;
	}
	
	module.exports = baseLt;


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(342),
	    isArrayLike = __webpack_require__(185);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 706 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(346),
	    last = __webpack_require__(138),
	    parent = __webpack_require__(1454),
	    toKey = __webpack_require__(282);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ }),
/* 708 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(206);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(340),
	    arraySome = __webpack_require__(694),
	    cacheHas = __webpack_require__(345);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 711 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(700),
	    getSymbols = __webpack_require__(476),
	    keys = __webpack_require__(209);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(700),
	    getSymbolsIn = __webpack_require__(714),
	    keysIn = __webpack_require__(483);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(470),
	    getPrototype = __webpack_require__(475),
	    getSymbols = __webpack_require__(476),
	    stubArray = __webpack_require__(733);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(100);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 716 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 717 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1365);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1395),
	    shortOut = __webpack_require__(1457);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 720 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(1367),
	    baseEvery = __webpack_require__(1371),
	    baseIteratee = __webpack_require__(114),
	    isArray = __webpack_require__(62),
	    isIterateeCall = __webpack_require__(281);
	
	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * Iteration is stopped once `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * **Note:** This method returns `true` for
	 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	 * elements of empty collections.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.every(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, guard) {
	  var func = isArray(collection) ? arrayEvery : baseEvery;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = every;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(698),
	    baseIteratee = __webpack_require__(114),
	    toInteger = __webpack_require__(736);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(162),
	    baseIntersection = __webpack_require__(1376),
	    baseRest = __webpack_require__(205),
	    castArrayLikeObject = __webpack_require__(1403);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(343),
	    baseGt = __webpack_require__(701),
	    identity = __webpack_require__(208);
	
	/**
	 * Computes the maximum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * _.max([4, 2, 8, 6]);
	 * // => 8
	 *
	 * _.max([]);
	 * // => undefined
	 */
	function max(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseGt)
	    : undefined;
	}
	
	module.exports = max;


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(343),
	    baseGt = __webpack_require__(701),
	    baseIteratee = __webpack_require__(114);
	
	/**
	 * This method is like `_.max` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.maxBy(objects, function(o) { return o.n; });
	 * // => { 'n': 2 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.maxBy(objects, 'n');
	 * // => { 'n': 2 }
	 */
	function maxBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
	    : undefined;
	}
	
	module.exports = maxBy;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(465);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(343),
	    baseLt = __webpack_require__(704),
	    identity = __webpack_require__(208);
	
	/**
	 * Computes the minimum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * _.min([4, 2, 8, 6]);
	 * // => 2
	 *
	 * _.min([]);
	 * // => undefined
	 */
	function min(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseLt)
	    : undefined;
	}
	
	module.exports = min;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(343),
	    baseIteratee = __webpack_require__(114),
	    baseLt = __webpack_require__(704);
	
	/**
	 * This method is like `_.min` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.minBy(objects, function(o) { return o.n; });
	 * // => { 'n': 1 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.minBy(objects, 'n');
	 * // => { 'n': 1 }
	 */
	function minBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseLt)
	    : undefined;
	}
	
	module.exports = minBy;


/***/ }),
/* 729 */
/***/ (function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(162),
	    baseClone = __webpack_require__(696),
	    baseUnset = __webpack_require__(707),
	    castPath = __webpack_require__(346),
	    copyObject = __webpack_require__(279),
	    customOmitClone = __webpack_require__(1420),
	    flatRest = __webpack_require__(1423),
	    getAllKeysIn = __webpack_require__(713);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(1417);
	
	/**
	 * Creates an array of numbers (positive and/or negative) progressing from
	 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	 * `start` is specified without an `end` or `step`. If `end` is not specified,
	 * it's set to `start` with `start` then set to `0`.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the range of numbers.
	 * @see _.inRange, _.rangeRight
	 * @example
	 *
	 * _.range(4);
	 * // => [0, 1, 2, 3]
	 *
	 * _.range(-4);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * _.range(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * _.range(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.range(0);
	 * // => []
	 */
	var range = createRange();
	
	module.exports = range;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	var createRound = __webpack_require__(1418);
	
	/**
	 * Computes `number` rounded to `precision`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.10.0
	 * @category Math
	 * @param {number} number The number to round.
	 * @param {number} [precision=0] The precision to round to.
	 * @returns {number} Returns the rounded number.
	 * @example
	 *
	 * _.round(4.006);
	 * // => 4
	 *
	 * _.round(4.006, 2);
	 * // => 4.01
	 *
	 * _.round(4060, -2);
	 * // => 4100
	 */
	var round = createRound('round');
	
	module.exports = round;


/***/ }),
/* 733 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(479),
	    isObject = __webpack_require__(100);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(487);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(735);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1400);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(697),
	    baseRest = __webpack_require__(205),
	    isArrayLikeObject = __webpack_require__(353);
	
	/**
	 * Creates an array excluding all given values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.pull`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.xor
	 * @example
	 *
	 * _.without([2, 1, 2, 3], 1, 2);
	 * // => [3]
	 */
	var without = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedButton = __webpack_require__(139);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var selected = props.selected;
	  var bottomNavigation = context.muiTheme.bottomNavigation;
	
	
	  var color = selected ? bottomNavigation.selectedColor : bottomNavigation.unselectedColor;
	
	  var styles = {
	    root: {
	      transition: 'padding-top 0.3s',
	      paddingTop: selected ? 6 : 8,
	      paddingBottom: 10,
	      paddingLeft: 12,
	      paddingRight: 12,
	      minWidth: 80,
	      maxWidth: 168
	    },
	    label: {
	      fontSize: selected ? bottomNavigation.selectedFontSize : bottomNavigation.unselectedFontSize,
	      transition: 'color 0.3s, font-size 0.3s',
	      color: color
	    },
	    icon: {
	      display: 'block',
	      /**
	       * Used to ensure SVG icons are centered
	       */
	      width: '100%'
	    },
	    iconColor: color
	  };
	
	  return styles;
	}
	
	var BottomNavigationItem = function BottomNavigationItem(props, context) {
	  var label = props.label,
	      icon = props.icon,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['label', 'icon', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var styledIcon = (0, _react.cloneElement)(icon, {
	    style: (0, _simpleAssign2.default)({}, styles.icon, icon.props.style),
	    color: icon.props.color || styles.iconColor
	  });
	
	  return _react2.default.createElement(
	    _EnhancedButton2.default,
	    (0, _extends3.default)({}, other, { style: (0, _simpleAssign2.default)({}, styles.root, style) }),
	    styledIcon,
	    _react2.default.createElement(
	      'div',
	      { style: prepareStyles(styles.label) },
	      label
	    )
	  );
	};
	
	BottomNavigationItem.propTypes =  false ? {
	  /**
	   * Set the icon representing the view for this item.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * Set the label describing the view for this item.
	   */
	  label: _propTypes2.default.node,
	  /**
	   * @ignore
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	BottomNavigationItem.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = BottomNavigationItem;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles() {
	  return {
	    root: {
	      padding: 8,
	      position: 'relative'
	    },
	    action: {
	      marginRight: 8
	    }
	  };
	}
	
	var CardActions = function (_Component) {
	  (0, _inherits3.default)(CardActions, _Component);
	
	  function CardActions() {
	    (0, _classCallCheck3.default)(this, CardActions);
	    return (0, _possibleConstructorReturn3.default)(this, (CardActions.__proto__ || (0, _getPrototypeOf2.default)(CardActions)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardActions, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'showExpandableButton', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var styledChildren = _react2.default.Children.map(children, function (child) {
	        if (_react2.default.isValidElement(child)) {
	          return _react2.default.cloneElement(child, {
	            style: (0, _simpleAssign2.default)({}, styles.action, child.props.style)
	          });
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        styledChildren
	      );
	    }
	  }]);
	  return CardActions;
	}(_react.Component);
	
	CardActions.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CardActions.propTypes =  false ? {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * Can be used to render elements inside the Card Action.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = CardActions;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _keyboardArrowUp = __webpack_require__(1603);
	
	var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);
	
	var _keyboardArrowDown = __webpack_require__(1602);
	
	var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);
	
	var _IconButton = __webpack_require__(126);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles() {
	  return {
	    root: {
	      top: 0,
	      bottom: 0,
	      right: 4,
	      margin: 'auto',
	      position: 'absolute'
	    }
	  };
	}
	
	var CardExpandable = function (_Component) {
	  (0, _inherits3.default)(CardExpandable, _Component);
	
	  function CardExpandable() {
	    (0, _classCallCheck3.default)(this, CardExpandable);
	    return (0, _possibleConstructorReturn3.default)(this, (CardExpandable.__proto__ || (0, _getPrototypeOf2.default)(CardExpandable)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardExpandable, [{
	    key: 'render',
	    value: function render() {
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _IconButton2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          onClick: this.props.onExpanding,
	          iconStyle: this.props.iconStyle
	        },
	        this.props.expanded ? this.props.openIcon : this.props.closeIcon
	      );
	    }
	  }]);
	  return CardExpandable;
	}(_react.Component);
	
	CardExpandable.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CardExpandable.defaultProps = {
	  closeIcon: _react2.default.createElement(_keyboardArrowDown2.default, null),
	  openIcon: _react2.default.createElement(_keyboardArrowUp2.default, null)
	};
	CardExpandable.propTypes =  false ? {
	  closeIcon: _propTypes2.default.node,
	  expanded: _propTypes2.default.bool,
	  iconStyle: _propTypes2.default.object,
	  onExpanding: _propTypes2.default.func.isRequired,
	  openIcon: _propTypes2.default.node,
	  style: _propTypes2.default.object
	} : {};
	exports.default = CardExpandable;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Avatar = __webpack_require__(356);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var card = context.muiTheme.card;
	
	
	  return {
	    root: {
	      padding: 16,
	      fontWeight: card.fontWeight,
	      boxSizing: 'border-box',
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    text: {
	      display: 'inline-block',
	      verticalAlign: 'top',
	      whiteSpace: 'normal',
	      paddingRight: '90px'
	    },
	    avatar: {
	      marginRight: 16
	    },
	    title: {
	      color: props.titleColor || card.titleColor,
	      display: 'block',
	      fontSize: 15
	    },
	    subtitle: {
	      color: props.subtitleColor || card.subtitleColor,
	      display: 'block',
	      fontSize: 14
	    }
	  };
	}
	
	var CardHeader = function (_Component) {
	  (0, _inherits3.default)(CardHeader, _Component);
	
	  function CardHeader() {
	    (0, _classCallCheck3.default)(this, CardHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (CardHeader.__proto__ || (0, _getPrototypeOf2.default)(CardHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          avatarProp = _props.avatar,
	          children = _props.children,
	          closeIcon = _props.closeIcon,
	          expandable = _props.expandable,
	          openIcon = _props.openIcon,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          subtitle = _props.subtitle,
	          subtitleColor = _props.subtitleColor,
	          subtitleStyle = _props.subtitleStyle,
	          textStyle = _props.textStyle,
	          title = _props.title,
	          titleColor = _props.titleColor,
	          titleStyle = _props.titleStyle,
	          iconStyle = _props.iconStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'avatar', 'children', 'closeIcon', 'expandable', 'openIcon', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'textStyle', 'title', 'titleColor', 'titleStyle', 'iconStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var avatar = avatarProp;
	
	      if ((0, _react.isValidElement)(avatarProp)) {
	        avatar = _react2.default.cloneElement(avatar, {
	          style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style)
	        });
	      } else if (avatar !== null) {
	        avatar = _react2.default.createElement(_Avatar2.default, { src: avatarProp, style: styles.avatar });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        avatar,
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.text, textStyle)) },
	          _react2.default.createElement(
	            'span',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
	            title
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.subtitle, subtitleStyle)) },
	            subtitle
	          )
	        ),
	        children
	      );
	    }
	  }]);
	  return CardHeader;
	}(_react.Component);
	
	CardHeader.muiName = 'CardHeader';
	CardHeader.defaultProps = {
	  avatar: null
	};
	CardHeader.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CardHeader.propTypes =  false ? {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * This is the [Avatar](/#/components/avatar) element to be displayed on the Card Header.
	   * If `avatar` is an `Avatar` or other element, it will be rendered.
	   * If `avatar` is a string, it will be used as the image `src` for an `Avatar`.
	   */
	  avatar: _propTypes2.default.node,
	  /**
	   * Can be used to render elements inside the Card Header.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Can be used to pass a closeIcon if you don't like the default expandable close Icon.
	   */
	  closeIcon: _propTypes2.default.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * Override the iconStyle of the Icon Button.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Can be used to pass a openIcon if you don't like the default expandable open Icon.
	   */
	  openIcon: _propTypes2.default.node,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Can be used to render a subtitle in Card Header.
	   */
	  subtitle: _propTypes2.default.node,
	  /**
	   * Override the subtitle color.
	   */
	  subtitleColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the subtitle.
	   */
	  subtitleStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the text.
	   */
	  textStyle: _propTypes2.default.object,
	  /**
	   * Can be used to render a title in Card Header.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * Override the title color.
	   */
	  titleColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the title.
	   */
	  titleStyle: _propTypes2.default.object
	} : {};
	exports.default = CardHeader;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var cardMedia = context.muiTheme.cardMedia;
	
	
	  return {
	    root: {
	      position: 'relative'
	    },
	    overlayContainer: {
	      position: 'absolute',
	      top: 0,
	      bottom: 0,
	      right: 0,
	      left: 0
	    },
	    overlay: {
	      height: '100%',
	      position: 'relative'
	    },
	    overlayContent: {
	      position: 'absolute',
	      bottom: 0,
	      right: 0,
	      left: 0,
	      paddingTop: 8,
	      background: cardMedia.overlayContentBackground
	    },
	    media: {},
	    mediaChild: {
	      verticalAlign: 'top',
	      maxWidth: '100%',
	      minWidth: '100%',
	      width: '100%'
	    }
	  };
	}
	
	var CardMedia = function (_Component) {
	  (0, _inherits3.default)(CardMedia, _Component);
	
	  function CardMedia() {
	    (0, _classCallCheck3.default)(this, CardMedia);
	    return (0, _possibleConstructorReturn3.default)(this, (CardMedia.__proto__ || (0, _getPrototypeOf2.default)(CardMedia)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardMedia, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          mediaStyle = _props.mediaStyle,
	          overlay = _props.overlay,
	          overlayContainerStyle = _props.overlayContainerStyle,
	          overlayContentStyle = _props.overlayContentStyle,
	          overlayStyle = _props.overlayStyle,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'mediaStyle', 'overlay', 'overlayContainerStyle', 'overlayContentStyle', 'overlayStyle', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
	      var extendedMediaStyle = (0, _simpleAssign2.default)(styles.media, mediaStyle);
	      var extendedOverlayContainerStyle = (0, _simpleAssign2.default)(styles.overlayContainer, overlayContainerStyle);
	      var extendedOverlayContentStyle = (0, _simpleAssign2.default)(styles.overlayContent, overlayContentStyle);
	      var extendedOverlayStyle = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
	      var titleColor = this.context.muiTheme.cardMedia.titleColor;
	      var subtitleColor = this.context.muiTheme.cardMedia.subtitleColor;
	      var color = this.context.muiTheme.cardMedia.color;
	
	      var styledChildren = _react2.default.Children.map(children, function (child) {
	        if (!child) {
	          return child;
	        }
	
	        return _react2.default.cloneElement(child, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.mediaChild, child.props.style))
	        });
	      });
	
	      var overlayChildren = _react2.default.Children.map(overlay, function (child) {
	        var childMuiName = child && child.type ? child.type.muiName : null;
	
	        if (childMuiName === 'CardHeader' || childMuiName === 'CardTitle') {
	          return _react2.default.cloneElement(child, {
	            titleColor: titleColor,
	            subtitleColor: subtitleColor
	          });
	        } else if (childMuiName === 'CardText') {
	          return _react2.default.cloneElement(child, {
	            color: color
	          });
	        } else {
	          return child;
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(extendedMediaStyle) },
	          styledChildren
	        ),
	        overlay ? _react2.default.createElement(
	          'div',
	          { style: prepareStyles(extendedOverlayContainerStyle) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(extendedOverlayStyle) },
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles(extendedOverlayContentStyle) },
	              overlayChildren
	            )
	          )
	        ) : ''
	      );
	    }
	  }]);
	  return CardMedia;
	}(_react.Component);
	
	CardMedia.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CardMedia.propTypes =  false ? {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * Can be used to render elements inside the Card Media.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the Card Media.
	   */
	  mediaStyle: _propTypes2.default.object,
	  /**
	   * Can be used to render overlay element in Card Media.
	   */
	  overlay: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the overlay container.
	   */
	  overlayContainerStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the overlay content.
	   */
	  overlayContentStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the overlay element.
	   */
	  overlayStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = CardMedia;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var cardText = context.muiTheme.cardText;
	
	
	  return {
	    root: {
	      padding: 16,
	      fontSize: 14,
	      color: props.color || cardText.textColor
	    }
	  };
	}
	
	var CardText = function (_Component) {
	  (0, _inherits3.default)(CardText, _Component);
	
	  function CardText() {
	    (0, _classCallCheck3.default)(this, CardText);
	    return (0, _possibleConstructorReturn3.default)(this, (CardText.__proto__ || (0, _getPrototypeOf2.default)(CardText)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardText, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          color = _props.color,
	          expandable = _props.expandable,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'color', 'expandable', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        children
	      );
	    }
	  }]);
	  return CardText;
	}(_react.Component);
	
	CardText.muiName = 'CardText';
	CardText.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CardText.propTypes =  false ? {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * Can be used to render elements inside the Card Text.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Override the CardText color.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = CardText;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var card = context.muiTheme.card;
	
	
	  return {
	    root: {
	      padding: 16,
	      position: 'relative'
	    },
	    title: {
	      fontSize: 24,
	      color: props.titleColor || card.titleColor,
	      display: 'block',
	      lineHeight: '36px'
	    },
	    subtitle: {
	      fontSize: 14,
	      color: props.subtitleColor || card.subtitleColor,
	      display: 'block'
	    }
	  };
	}
	
	var CardTitle = function (_Component) {
	  (0, _inherits3.default)(CardTitle, _Component);
	
	  function CardTitle() {
	    (0, _classCallCheck3.default)(this, CardTitle);
	    return (0, _possibleConstructorReturn3.default)(this, (CardTitle.__proto__ || (0, _getPrototypeOf2.default)(CardTitle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          closeIcon = _props.closeIcon,
	          expandable = _props.expandable,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          subtitle = _props.subtitle,
	          subtitleColor = _props.subtitleColor,
	          subtitleStyle = _props.subtitleStyle,
	          title = _props.title,
	          titleColor = _props.titleColor,
	          titleStyle = _props.titleStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'closeIcon', 'expandable', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'title', 'titleColor', 'titleStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)({}, styles.root, style);
	      var extendedTitleStyle = (0, _simpleAssign2.default)({}, styles.title, titleStyle);
	      var extendedSubtitleStyle = (0, _simpleAssign2.default)({}, styles.subtitle, subtitleStyle);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(extendedTitleStyle) },
	          title
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(extendedSubtitleStyle) },
	          subtitle
	        ),
	        children
	      );
	    }
	  }]);
	  return CardTitle;
	}(_react.Component);
	
	CardTitle.muiName = 'CardTitle';
	CardTitle.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CardTitle.propTypes =  false ? {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * Can be used to render elements inside the Card Title.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Can be used to pass a closeIcon if you don't like the default expandable close Icon.
	   */
	  closeIcon: _propTypes2.default.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Can be used to render a subtitle in the Card Title.
	   */
	  subtitle: _propTypes2.default.node,
	  /**
	   * Override the subtitle color.
	   */
	  subtitleColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the subtitle.
	   */
	  subtitleStyle: _propTypes2.default.object,
	  /**
	   * Can be used to render a title in the Card Title.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * Override the title color.
	   */
	  titleColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the title.
	   */
	  titleStyle: _propTypes2.default.object
	} : {};
	exports.default = CardTitle;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _DatePicker = __webpack_require__(1510);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DatePicker2.default;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.DropDownMenu = undefined;
	
	var _DropDownMenu2 = __webpack_require__(1517);
	
	var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);
	
	var _MenuItem2 = __webpack_require__(491);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DropDownMenu = _DropDownMenu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _DropDownMenu3.default;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(591);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _titleBar;
	
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      gridTile = _context$muiTheme.gridTile;
	
	
	  var actionPos = props.actionIcon && props.actionPosition;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      display: 'block',
	      height: '100%',
	      overflow: 'hidden'
	    },
	    titleBar: (_titleBar = {
	      position: 'absolute',
	      left: 0,
	      right: 0
	    }, (0, _defineProperty3.default)(_titleBar, props.titlePosition, 0), (0, _defineProperty3.default)(_titleBar, 'height', props.subtitle ? 68 : 48), (0, _defineProperty3.default)(_titleBar, 'background', props.titleBackground), (0, _defineProperty3.default)(_titleBar, 'display', 'flex'), (0, _defineProperty3.default)(_titleBar, 'alignItems', 'center'), _titleBar),
	    titleWrap: {
	      flexGrow: 1,
	      marginLeft: actionPos !== 'left' ? baseTheme.spacing.desktopGutterLess : 0,
	      marginRight: actionPos === 'left' ? baseTheme.spacing.desktopGutterLess : 0,
	      color: gridTile.textColor,
	      overflow: 'hidden'
	    },
	    title: {
	      fontSize: '16px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    subtitle: {
	      fontSize: '12px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    actionIcon: {
	      order: actionPos === 'left' ? -1 : 1
	    },
	    childImg: {
	      height: '100%',
	      transform: 'translateX(-50%)',
	      position: 'relative',
	      left: '50%'
	    }
	  };
	  return styles;
	}
	
	var GridTile = function (_Component) {
	  (0, _inherits3.default)(GridTile, _Component);
	
	  function GridTile() {
	    (0, _classCallCheck3.default)(this, GridTile);
	    return (0, _possibleConstructorReturn3.default)(this, (GridTile.__proto__ || (0, _getPrototypeOf2.default)(GridTile)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GridTile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: 'ensureImageCover',
	    value: function ensureImageCover() {
	      var _this2 = this;
	
	      var imgEl = this.refs.img;
	
	      if (imgEl) {
	        var fit = function fit() {
	          if (imgEl.offsetWidth < imgEl.parentNode.offsetWidth) {
	            var isRtl = _this2.context.muiTheme.isRtl;
	
	            imgEl.style.height = 'auto';
	            if (isRtl) {
	              imgEl.style.right = '0';
	            } else {
	              imgEl.style.left = '0';
	            }
	            imgEl.style.width = '100%';
	            imgEl.style.top = '50%';
	            imgEl.style.transform = imgEl.style.WebkitTransform = 'translateY(-50%)';
	          }
	          imgEl.removeEventListener('load', fit);
	          imgEl = null; // prevent closure memory leak
	        };
	        if (imgEl.complete) {
	          fit();
	        } else {
	          imgEl.addEventListener('load', fit);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          subtitle = _props.subtitle,
	          titlePosition = _props.titlePosition,
	          titleBackground = _props.titleBackground,
	          titleStyle = _props.titleStyle,
	          subtitleStyle = _props.subtitleStyle,
	          actionIcon = _props.actionIcon,
	          actionPosition = _props.actionPosition,
	          style = _props.style,
	          children = _props.children,
	          containerElement = _props.containerElement,
	          other = (0, _objectWithoutProperties3.default)(_props, ['title', 'subtitle', 'titlePosition', 'titleBackground', 'titleStyle', 'subtitleStyle', 'actionIcon', 'actionPosition', 'style', 'children', 'containerElement']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	
	      var titleBar = null;
	
	      if (title) {
	        titleBar = _react2.default.createElement(
	          'div',
	          { key: 'titlebar', style: prepareStyles(styles.titleBar) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.titleWrap) },
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
	              title
	            ),
	            subtitle ? _react2.default.createElement(
	              'div',
	              { style: prepareStyles((0, _simpleAssign2.default)(styles.subtitle, subtitleStyle)) },
	              subtitle
	            ) : null
	          ),
	          actionIcon ? _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.actionIcon) },
	            actionIcon
	          ) : null
	        );
	      }
	
	      var newChildren = children;
	
	      // if there is a single image passed as children
	      // clone it and add our styles
	      if (_react2.default.Children.count(children) === 1) {
	        newChildren = _react2.default.Children.map(children, function (child) {
	          if (child.type === 'img') {
	            return _react2.default.cloneElement(child, {
	              key: 'img',
	              ref: 'img',
	              style: prepareStyles((0, _simpleAssign2.default)({}, styles.childImg, child.props.style))
	            });
	          } else {
	            return child;
	          }
	        });
	      }
	
	      var containerProps = (0, _extends3.default)({
	        style: prepareStyles(mergedRootStyles)
	      }, other);
	
	      return _react2.default.isValidElement(containerElement) ? _react2.default.cloneElement(containerElement, containerProps, [newChildren, titleBar]) : _react2.default.createElement(containerElement, containerProps, [newChildren, titleBar]);
	    }
	  }]);
	  return GridTile;
	}(_react.Component);
	
	GridTile.defaultProps = {
	  titlePosition: 'bottom',
	  titleBackground: 'rgba(0, 0, 0, 0.4)',
	  actionPosition: 'right',
	  cols: 1,
	  rows: 1,
	  containerElement: 'div'
	};
	GridTile.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	GridTile.propTypes =  false ? {
	  /**
	   * An IconButton element to be used as secondary action target
	   * (primary action target is the tile itself).
	   */
	  actionIcon: _propTypes2.default.element,
	  /**
	   * Position of secondary action IconButton.
	   */
	  actionPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Theoretically you can pass any node as children, but the main use case is to pass an img,
	   * in whichcase GridTile takes care of making the image "cover" available space
	   * (similar to background-size: cover or to object-fit:cover).
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Width of the tile in number of grid cells.
	   */
	  cols: _propTypes2.default.number,
	  /**
	   * Either a string used as tag name for the tile root element, or a ReactElement.
	   * This is useful when you have, for example, a custom implementation of
	   * a navigation link (that knows about your routes) and you want to use it as the primary tile action.
	   * In case you pass a ReactElement, please ensure that it passes all props,
	   * accepts styles overrides and render it's children.
	   */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * Height of the tile in number of grid cells.
	   */
	  rows: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * String or element serving as subtitle (support text).
	   */
	  subtitle: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the subtitle element.
	   */
	  subtitleStyle: _propTypes2.default.object,
	  /**
	   * Title to be displayed on tile.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * Style used for title bar background.
	   * Useful for setting custom gradients for example
	   */
	  titleBackground: _propTypes2.default.string,
	  /**
	   * Position of the title bar (container of title, subtitle and action icon).
	   */
	  titlePosition: _propTypes2.default.oneOf(['top', 'bottom']),
	  /**
	   * Override the inline-styles of the title element.
	   */
	  titleStyle: _propTypes2.default.object
	} : {};
	exports.default = GridTile;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeSelectable = undefined;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _colorManipulator = __webpack_require__(187);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeSelectable = function makeSelectable(MyComponent) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(_class, _Component);
	
	    function _class() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      (0, _classCallCheck3.default)(this, _class);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(args))), _this), _this.hasSelectedDescendant = function (previousValue, child) {
	        if (_react2.default.isValidElement(child) && child.props.nestedItems && child.props.nestedItems.length > 0) {
	          return child.props.nestedItems.reduce(_this.hasSelectedDescendant, previousValue);
	        }
	        return previousValue || _this.isChildSelected(child, _this.props);
	      }, _this.handleItemTouchTap = function (event, item) {
	        var itemValue = item.props.value;
	
	        if (itemValue !== _this.props.value) {
	          if (_this.props.onChange) {
	            _this.props.onChange(event, itemValue);
	          }
	        }
	      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(_class, [{
	      key: 'extendChild',
	      value: function extendChild(child, styles, selectedItemStyle) {
	        var _this2 = this;
	
	        if (child && child.type && child.type.muiName === 'ListItem') {
	          var selected = this.isChildSelected(child, this.props);
	          var selectedChildrenStyles = void 0;
	          if (selected) {
	            selectedChildrenStyles = (0, _simpleAssign2.default)({}, styles, selectedItemStyle);
	          }
	
	          var mergedChildrenStyles = (0, _simpleAssign2.default)({}, child.props.style, selectedChildrenStyles);
	
	          this.keyIndex += 1;
	
	          return _react2.default.cloneElement(child, {
	            onClick: function onClick(event) {
	              _this2.handleItemTouchTap(event, child);
	              if (child.props.onClick) {
	                child.props.onClick(event);
	              }
	            },
	            key: this.keyIndex,
	            style: mergedChildrenStyles,
	            nestedItems: child.props.nestedItems.map(function (child) {
	              return _this2.extendChild(child, styles, selectedItemStyle);
	            }),
	            initiallyOpen: this.isInitiallyOpen(child)
	          });
	        } else {
	          return child;
	        }
	      }
	    }, {
	      key: 'isInitiallyOpen',
	      value: function isInitiallyOpen(child) {
	        if (child.props.initiallyOpen) {
	          return child.props.initiallyOpen;
	        }
	        return this.hasSelectedDescendant(false, child);
	      }
	    }, {
	      key: 'isChildSelected',
	      value: function isChildSelected(child, props) {
	        return props.value === child.props.value;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        var _props = this.props,
	            children = _props.children,
	            selectedItemStyle = _props.selectedItemStyle,
	            other = (0, _objectWithoutProperties3.default)(_props, ['children', 'selectedItemStyle']);
	
	
	        this.keyIndex = 0;
	        var styles = {};
	
	        if (!selectedItemStyle) {
	          var textColor = this.context.muiTheme.baseTheme.palette.textColor;
	          styles.backgroundColor = (0, _colorManipulator.fade)(textColor, 0.2);
	        }
	
	        return _react2.default.createElement(
	          MyComponent,
	          (0, _extends3.default)({}, other, this.state),
	          _react.Children.map(children, function (child) {
	            return _this3.extendChild(child, styles, selectedItemStyle);
	          })
	        );
	      }
	    }]);
	    return _class;
	  }(_react.Component), _class.propTypes = {
	    children: _propTypes2.default.node,
	    onChange: _propTypes2.default.func,
	    selectedItemStyle: _propTypes2.default.object,
	    value: _propTypes2.default.any
	  }, _class.contextTypes = {
	    muiTheme: _propTypes2.default.object.isRequired
	  }, _temp2;
	};
	
	exports.makeSelectable = makeSelectable;
	exports.default = makeSelectable;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.Menu = undefined;
	
	var _Menu2 = __webpack_require__(360);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _MenuItem2 = __webpack_require__(101);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Menu = _Menu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _Menu3.default;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedSwitch = __webpack_require__(497);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	var _radioButtonUnchecked = __webpack_require__(1616);
	
	var _radioButtonUnchecked2 = _interopRequireDefault(_radioButtonUnchecked);
	
	var _radioButtonChecked = __webpack_require__(1615);
	
	var _radioButtonChecked2 = _interopRequireDefault(_radioButtonChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var radioButton = context.muiTheme.radioButton;
	
	
	  return {
	    icon: {
	      height: radioButton.size,
	      width: radioButton.size
	    },
	    target: {
	      transition: _transitions2.default.easeOut(),
	      position: 'absolute',
	      opacity: 1,
	      transform: 'scale(1)',
	      fill: radioButton.borderColor
	    },
	    fill: {
	      position: 'absolute',
	      opacity: 1,
	      transform: 'scale(0)',
	      transformOrigin: '50% 50%',
	      transition: _transitions2.default.easeOut(),
	      fill: radioButton.checkedColor
	    },
	    targetWhenChecked: {
	      opacity: 0,
	      transform: 'scale(0)'
	    },
	    fillWhenChecked: {
	      opacity: 1,
	      transform: 'scale(1)'
	    },
	    targetWhenDisabled: {
	      fill: radioButton.disabledColor
	    },
	    fillWhenDisabled: {
	      fill: radioButton.disabledColor
	    },
	    label: {
	      color: props.disabled ? radioButton.labelDisabledColor : radioButton.labelColor
	    },
	    ripple: {
	      color: props.checked ? radioButton.checkedColor : radioButton.borderColor
	    }
	  };
	}
	
	var RadioButton = function (_Component) {
	  (0, _inherits3.default)(RadioButton, _Component);
	
	  function RadioButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RadioButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioButton.__proto__ || (0, _getPrototypeOf2.default)(RadioButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleSwitch = function (event) {
	      if (_this.props.onCheck) {
	        _this.props.onCheck(event, _this.props.value);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  // Only called when selected, not when unselected.
	
	
	  (0, _createClass3.default)(RadioButton, [{
	    key: 'isChecked',
	    value: function isChecked() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	
	    // Use RadioButtonGroup.setSelectedValue(newSelectionValue) to set a
	    // RadioButton's checked value.
	
	  }, {
	    key: 'setChecked',
	    value: function setChecked(newCheckedValue) {
	      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.enhancedSwitch.getValue();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checkedIcon = _props.checkedIcon,
	          checked = _props.checked,
	          iconStyle = _props.iconStyle,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          onCheck = _props.onCheck,
	          uncheckedIcon = _props.uncheckedIcon,
	          disabled = _props.disabled,
	          other = (0, _objectWithoutProperties3.default)(_props, ['checkedIcon', 'checked', 'iconStyle', 'labelStyle', 'labelPosition', 'onCheck', 'uncheckedIcon', 'disabled']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      var uncheckedStyles = (0, _simpleAssign2.default)(styles.target, checked && styles.targetWhenChecked, iconStyle, disabled && styles.targetWhenDisabled);
	
	      var checkedStyles = (0, _simpleAssign2.default)(styles.fill, checked && styles.fillWhenChecked, iconStyle, disabled && styles.fillWhenDisabled);
	
	      var uncheckedElement = _react2.default.isValidElement(uncheckedIcon) ? _react2.default.cloneElement(uncheckedIcon, {
	        style: (0, _simpleAssign2.default)(uncheckedStyles, uncheckedIcon.props.style)
	      }) : _react2.default.createElement(_radioButtonUnchecked2.default, { style: uncheckedStyles });
	
	      var checkedElement = _react2.default.isValidElement(checkedIcon) ? _react2.default.cloneElement(checkedIcon, {
	        style: (0, _simpleAssign2.default)(checkedStyles, checkedIcon.props.style)
	      }) : _react2.default.createElement(_radioButtonChecked2.default, { style: checkedStyles });
	
	      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
	      var mergedLabelStyle = (0, _simpleAssign2.default)(styles.label, labelStyle);
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, {
	        ref: 'enhancedSwitch',
	        inputType: 'radio',
	        checked: checked,
	        switched: checked,
	        disabled: disabled,
	        rippleColor: styles.ripple.color,
	        iconStyle: mergedIconStyle,
	        labelStyle: mergedLabelStyle,
	        labelPosition: labelPosition,
	        onSwitch: this.handleSwitch,
	        switchElement: _react2.default.createElement(
	          'div',
	          null,
	          uncheckedElement,
	          checkedElement
	        )
	      }));
	    }
	  }]);
	  return RadioButton;
	}(_react.Component);
	
	RadioButton.defaultProps = {
	  checked: false,
	  disabled: false,
	  labelPosition: 'right'
	};
	RadioButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	RadioButton.propTypes =  false ? {
	  /**
	   * @ignore
	   * checked if true
	   * Used internally by `RadioButtonGroup`.
	   */
	  checked: _propTypes2.default.bool,
	  /**
	   * The icon element to show when the radio button is checked.
	   */
	  checkedIcon: _propTypes2.default.element,
	  /**
	   * If true, the radio button is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the input element.
	   */
	  inputStyle: _propTypes2.default.object,
	  /**
	   * @ignore
	   * Used internally by `RadioButtonGroup`. Use the `labelPosition` property of `RadioButtonGroup` instead.
	   * Where the label will be placed next to the radio button.
	   */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Override the inline-styles of the label element.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * @ignore
	   * Callback function fired when the radio button is checked. Note that this
	   * function will not be called if the radio button is part of a
	   * radio button group: in this case, use the `onChange` property of
	   * `RadioButtonGroup`.
	   *
	   * @param {object} event `change` event targeting the element.
	   * @param {string} value The element's `value`.
	   */
	  onCheck: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The icon element to show when the radio button is unchecked.
	   */
	  uncheckedIcon: _propTypes2.default.element,
	  /**
	   * The value of the radio button.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = RadioButton;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var index = _ref.index;
	  var stepper = _ref2.stepper;
	  var orientation = stepper.orientation;
	
	  var styles = {
	    root: {
	      flex: '0 0 auto'
	    }
	  };
	
	  if (index > 0) {
	    if (orientation === 'horizontal') {
	      styles.root.marginLeft = -6;
	    } else if (orientation === 'vertical') {
	      styles.root.marginTop = -14;
	    }
	  }
	
	  return styles;
	};
	
	var Step = function (_Component) {
	  (0, _inherits3.default)(Step, _Component);
	
	  function Step() {
	    var _ref3;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Step);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Step.__proto__ || (0, _getPrototypeOf2.default)(Step)).call.apply(_ref3, [this].concat(args))), _this), _this.renderChild = function (child) {
	      var _this$props = _this.props,
	          active = _this$props.active,
	          completed = _this$props.completed,
	          disabled = _this$props.disabled,
	          index = _this$props.index,
	          last = _this$props.last;
	
	
	      var icon = index + 1;
	
	      return _react2.default.cloneElement(child, (0, _simpleAssign2.default)({ active: active, completed: completed, disabled: disabled, icon: icon, last: last }, child.props));
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Step, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          completed = _props.completed,
	          disabled = _props.disabled,
	          index = _props.index,
	          last = _props.last,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'completed', 'disabled', 'index', 'last', 'children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.Children.map(children, this.renderChild)
	      );
	    }
	  }]);
	  return Step;
	}(_react.Component);
	
	Step.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	Step.propTypes =  false ? {
	  /**
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * Should be `Step` sub-components such as `StepLabel`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepButton` is a child of `Step`. Is passed to child components.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Used internally for numbering.
	   */
	  index: _propTypes2.default.number,
	  /**
	   * @ignore
	   */
	  last: _propTypes2.default.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Step;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(139);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _StepLabel = __webpack_require__(494);
	
	var _StepLabel2 = _interopRequireDefault(_StepLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isLabel = function isLabel(child) {
	  return child && child.type && child.type.muiName === 'StepLabel';
	};
	
	var getStyles = function getStyles(props, context, state) {
	  var hovered = state.hovered;
	  var _context$muiTheme$ste = context.muiTheme.stepper,
	      backgroundColor = _context$muiTheme$ste.backgroundColor,
	      hoverBackgroundColor = _context$muiTheme$ste.hoverBackgroundColor;
	
	
	  var styles = {
	    root: {
	      padding: 0,
	      backgroundColor: hovered ? hoverBackgroundColor : backgroundColor,
	      transition: _transitions2.default.easeOut()
	    }
	  };
	
	  if (context.stepper.orientation === 'vertical') {
	    styles.root.width = '100%';
	  }
	
	  return styles;
	};
	
	var StepButton = function (_Component) {
	  (0, _inherits3.default)(StepButton, _Component);
	
	  function StepButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, StepButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = StepButton.__proto__ || (0, _getPrototypeOf2.default)(StepButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touched: false
	    }, _this.handleMouseEnter = function (event) {
	      var onMouseEnter = _this.props.onMouseEnter;
	      // Cancel hover styles for touch devices
	
	      if (!_this.state.touched) {
	        _this.setState({ hovered: true });
	      }
	      if (typeof onMouseEnter === 'function') {
	        onMouseEnter(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	      _this.setState({ hovered: false });
	      if (typeof onMouseLeave === 'function') {
	        onMouseLeave(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      var onTouchStart = _this.props.onTouchStart;
	
	      if (!_this.state.touched) {
	        _this.setState({ touched: true });
	      }
	      if (typeof onTouchStart === 'function') {
	        onTouchStart(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(StepButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          completed = _props.completed,
	          disabled = _props.disabled,
	          icon = _props.icon,
	          iconContainerStyle = _props.iconContainerStyle,
	          last = _props.last,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'disabled', 'icon', 'iconContainerStyle', 'last', 'onMouseEnter', 'onMouseLeave', 'onTouchStart', 'style']);
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var child = isLabel(children) ? children : _react2.default.createElement(
	        _StepLabel2.default,
	        null,
	        children
	      );
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({
	          disabled: disabled,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart
	        }, other),
	        _react2.default.cloneElement(child, { active: active, completed: completed, disabled: disabled, icon: icon, iconContainerStyle: iconContainerStyle })
	      );
	    }
	  }]);
	  return StepButton;
	}(_react.Component);
	
	StepButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	StepButton.propTypes =  false ? {
	  /**
	   * Passed from `Step` Is passed to StepLabel.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Sets completed styling. Is passed to StepLabel.
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * Disables the button and sets disabled styling. Is passed to StepLabel.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * Override the inline-styles of the icon container element.
	   */
	  iconContainerStyle: _propTypes2.default.object,
	  /** @ignore */
	  last: _propTypes2.default.bool,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = StepButton;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ExpandTransition = __webpack_require__(1568);
	
	var _ExpandTransition2 = _interopRequireDefault(_ExpandTransition);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ExpandTransition(props) {
	  return _react2.default.createElement(_ExpandTransition2.default, props);
	}
	
	var getStyles = function getStyles(props, context) {
	  var styles = {
	    root: {
	      marginTop: -14,
	      marginLeft: 14 + 11, // padding + 1/2 icon
	      paddingLeft: 24 - 11 + 8,
	      paddingRight: 16,
	      overflow: 'hidden'
	    }
	  };
	
	  if (!props.last) {
	    styles.root.borderLeft = '1px solid ' + context.muiTheme.stepper.connectorLineColor;
	  }
	
	  return styles;
	};
	
	var StepContent = function (_Component) {
	  (0, _inherits3.default)(StepContent, _Component);
	
	  function StepContent() {
	    (0, _classCallCheck3.default)(this, StepContent);
	    return (0, _possibleConstructorReturn3.default)(this, (StepContent.__proto__ || (0, _getPrototypeOf2.default)(StepContent)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StepContent, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          completed = _props.completed,
	          last = _props.last,
	          style = _props.style,
	          transition = _props.transition,
	          transitionDuration = _props.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'last', 'style', 'transition', 'transitionDuration']);
	      var _context = this.context,
	          stepper = _context.stepper,
	          prepareStyles = _context.muiTheme.prepareStyles;
	
	
	      if (stepper.orientation !== 'vertical') {
	         false ? (0, _warning2.default)(false, 'Material-UI: <StepContent /> is only designed for use with the vertical stepper.') : void 0;
	        return null;
	      }
	
	      var styles = getStyles(this.props, this.context);
	      var transitionProps = {
	        enterDelay: transitionDuration,
	        transitionDuration: transitionDuration,
	        open: active
	      };
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.createElement(transition, transitionProps, _react2.default.createElement(
	          'div',
	          { style: { overflow: 'hidden' } },
	          children
	        ))
	      );
	    }
	  }]);
	  return StepContent;
	}(_react.Component);
	
	StepContent.defaultProps = {
	  transition: ExpandTransition,
	  transitionDuration: 450
	};
	StepContent.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	StepContent.propTypes =  false ? {
	  /**
	   * Expands the content
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * Step content
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  last: _propTypes2.default.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * ReactTransitionGroup component.
	   */
	  transition: _propTypes2.default.func,
	  /**
	   * Adjust the duration of the content expand transition. Passed as a prop to the transition component.
	   */
	  transitionDuration: _propTypes2.default.number
	} : {};
	exports.default = StepContent;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StepConnector = __webpack_require__(1543);
	
	var _StepConnector2 = _interopRequireDefault(_StepConnector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(props) {
	  var orientation = props.orientation;
	
	  return {
	    root: {
	      display: 'flex',
	      flexDirection: orientation === 'horizontal' ? 'row' : 'column',
	      alignContent: 'center',
	      alignItems: orientation === 'horizontal' ? 'center' : 'stretch',
	      justifyContent: 'space-between'
	    }
	  };
	};
	
	var Stepper = function (_Component) {
	  (0, _inherits3.default)(Stepper, _Component);
	
	  function Stepper() {
	    (0, _classCallCheck3.default)(this, Stepper);
	    return (0, _possibleConstructorReturn3.default)(this, (Stepper.__proto__ || (0, _getPrototypeOf2.default)(Stepper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Stepper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var orientation = this.props.orientation;
	
	      return { stepper: { orientation: orientation } };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeStep = _props.activeStep,
	          children = _props.children,
	          connector = _props.connector,
	          linear = _props.linear,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      /**
	       * One day, we may be able to use real CSS tools
	       * For now, we need to create our own "pseudo" elements
	       * and nth child selectors, etc
	       * That's what some of this garbage is for :)
	       */
	      var numChildren = _react.Children.count(children);
	      var steps = _react.Children.map(children, function (step, index) {
	        var controlProps = { index: index };
	
	        if (activeStep === index) {
	          controlProps.active = true;
	        } else if (linear && activeStep > index) {
	          controlProps.completed = true;
	        } else if (linear && activeStep < index) {
	          controlProps.disabled = true;
	        }
	
	        if (index + 1 === numChildren) {
	          controlProps.last = true;
	        }
	
	        return [index > 0 && connector, _react2.default.cloneElement(step, (0, _simpleAssign2.default)(controlProps, step.props))];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        steps
	      );
	    }
	  }]);
	  return Stepper;
	}(_react.Component);
	
	Stepper.defaultProps = {
	  connector: _react2.default.createElement(_StepConnector2.default, null),
	  orientation: 'horizontal',
	  linear: true
	};
	Stepper.contextTypes = { muiTheme: _propTypes2.default.object.isRequired };
	Stepper.childContextTypes = { stepper: _propTypes2.default.object };
	Stepper.propTypes =  false ? {
	  /**
	   * Set the active step (zero based index). This will enable `Step` control helpers.
	   */
	  activeStep: _propTypes2.default.number,
	  /**
	   * Should be two or more `<Step />` components.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * A component to be placed between each step.
	   */
	  connector: _propTypes2.default.node,
	  /**
	   * If set to `true`, the `Stepper` will assist in controlling steps for linear flow
	   */
	  linear: _propTypes2.default.bool,
	  /**
	   * The stepper orientation (layout flow direction)
	   */
	  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Stepper;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Subheader = __webpack_require__(1544);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Subheader2.default;

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toConsumableArray2 = __webpack_require__(266);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _typeof2 = __webpack_require__(224);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Checkbox = __webpack_require__(210);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TableRowColumn = __webpack_require__(361);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	var _ClickAwayListener = __webpack_require__(496);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableBody = function (_Component) {
	  (0, _inherits3.default)(TableBody, _Component);
	
	  function TableBody() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableBody);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableBody.__proto__ || (0, _getPrototypeOf2.default)(TableBody)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedRows: []
	    }, _this.isControlled = false, _this.handleClickAway = function () {
	      if (_this.props.deselectOnClickaway && _this.state.selectedRows.length > 0) {
	        var selectedRows = [];
	        _this.setState({ selectedRows: selectedRows });
	        if (_this.props.onRowSelection) {
	          _this.props.onRowSelection(selectedRows);
	        }
	      }
	    }, _this.onRowClick = function (event, rowNumber) {
	      event.stopPropagation();
	
	      if (_this.props.selectable) {
	        // Prevent text selection while selecting rows.
	        if (window.getSelection().rangeCount > 0 && window.getSelection().getRangeAt(0).getClientRects.length > 0) {
	          window.getSelection().removeAllRanges();
	        }
	        _this.processRowSelection(event, rowNumber);
	      }
	    }, _this.onCellClick = function (event, rowNumber, columnNumber) {
	      event.stopPropagation();
	      if (_this.props.onCellClick) {
	        _this.props.onCellClick(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	    }, _this.onCellHover = function (event, rowNumber, columnNumber) {
	      if (_this.props.onCellHover) {
	        _this.props.onCellHover(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	      _this.onRowHover(event, rowNumber);
	    }, _this.onCellHoverExit = function (event, rowNumber, columnNumber) {
	      if (_this.props.onCellHoverExit) {
	        _this.props.onCellHoverExit(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	      _this.onRowHoverExit(event, rowNumber);
	    }, _this.onRowHover = function (event, rowNumber) {
	      if (_this.props.onRowHover) {
	        _this.props.onRowHover(rowNumber);
	      }
	    }, _this.onRowHoverExit = function (event, rowNumber) {
	      if (_this.props.onRowHoverExit) {
	        _this.props.onRowHoverExit(rowNumber);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableBody, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.preScanRows) {
	        this.setState({
	          selectedRows: this.getSelectedRows(this.props)
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.preScanRows) {
	        this.setState({ // eslint-disable-line react/no-did-mount-set-state
	          selectedRows: this.getSelectedRows(this.props)
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.allRowsSelected !== nextProps.allRowsSelected) {
	        if (!nextProps.allRowsSelected) {
	          this.setState({
	            selectedRows: []
	          });
	          return;
	        }
	      }
	
	      this.setState({
	        selectedRows: this.getSelectedRows(nextProps)
	      });
	    }
	  }, {
	    key: 'createRows',
	    value: function createRows() {
	      var _this2 = this;
	
	      var numChildren = _react2.default.Children.count(this.props.children);
	      var rowNumber = 0;
	      var handlers = {
	        onCellClick: this.onCellClick,
	        onCellHover: this.onCellHover,
	        onCellHoverExit: this.onCellHoverExit,
	        onRowHover: this.onRowHover,
	        onRowHoverExit: this.onRowHoverExit,
	        onRowClick: this.onRowClick
	      };
	
	      return _react2.default.Children.map(this.props.children, function (child) {
	        if (_react2.default.isValidElement(child)) {
	          var props = {
	            hoverable: _this2.props.showRowHover,
	            selected: _this2.isRowSelected(rowNumber),
	            striped: _this2.props.stripedRows && rowNumber % 2 === 0,
	            rowNumber: rowNumber++
	          };
	
	          if (rowNumber === numChildren) {
	            props.displayBorder = false;
	          }
	
	          var children = [_this2.createRowCheckboxColumn(props)];
	
	          _react2.default.Children.forEach(child.props.children, function (child) {
	            children.push(child);
	          });
	
	          return _react2.default.cloneElement(child, (0, _extends3.default)({}, props, handlers), children);
	        }
	      });
	    }
	  }, {
	    key: 'createRowCheckboxColumn',
	    value: function createRowCheckboxColumn(rowProps) {
	      if (!this.props.displayRowCheckbox) {
	        return null;
	      }
	
	      var name = rowProps.rowNumber + '-cb';
	      var disabled = !this.props.selectable;
	
	      return _react2.default.createElement(
	        _TableRowColumn2.default,
	        {
	          key: name,
	          columnNumber: 0,
	          style: {
	            width: 24,
	            cursor: disabled ? 'default' : 'inherit'
	          }
	        },
	        _react2.default.createElement(_Checkbox2.default, {
	          name: name,
	          value: 'selected',
	          disabled: disabled,
	          checked: rowProps.selected
	        })
	      );
	    }
	  }, {
	    key: 'getSelectedRows',
	    value: function getSelectedRows(props) {
	      var _this3 = this;
	
	      var selectedRows = [];
	
	      if (props.selectable) {
	        var index = 0;
	        _react2.default.Children.forEach(props.children, function (child) {
	          if (_react2.default.isValidElement(child)) {
	            if (child.props.selected !== undefined) {
	              _this3.isControlled = true;
	            }
	
	            if (child.props.selected && (selectedRows.length === 0 || props.multiSelectable)) {
	              selectedRows.push(index);
	            }
	
	            index++;
	          }
	        });
	      }
	
	      return selectedRows;
	    }
	  }, {
	    key: 'isRowSelected',
	    value: function isRowSelected(rowNumber) {
	      var _this4 = this;
	
	      if (this.props.allRowsSelected) {
	        return true;
	      }
	
	      return this.state.selectedRows.some(function (row) {
	        if ((typeof row === 'undefined' ? 'undefined' : (0, _typeof3.default)(row)) === 'object') {
	          if (_this4.isValueInRange(rowNumber, row)) {
	            return true;
	          }
	        } else {
	          if (row === rowNumber) {
	            return true;
	          }
	        }
	
	        return false;
	      });
	    }
	  }, {
	    key: 'isValueInRange',
	    value: function isValueInRange(value, range) {
	      if (!range) return false;
	
	      if (range.start <= value && value <= range.end || range.end <= value && value <= range.start) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'processRowSelection',
	    value: function processRowSelection(event, rowNumber) {
	      var selectedRows = [].concat((0, _toConsumableArray3.default)(this.state.selectedRows));
	
	      if (event.shiftKey && this.props.multiSelectable && selectedRows.length > 0) {
	        var lastIndex = selectedRows.length - 1;
	        var lastSelection = selectedRows[lastIndex];
	
	        if ((typeof lastSelection === 'undefined' ? 'undefined' : (0, _typeof3.default)(lastSelection)) === 'object') {
	          lastSelection.end = rowNumber;
	        } else {
	          selectedRows.splice(lastIndex, 1, {
	            start: lastSelection,
	            end: rowNumber
	          });
	        }
	      } else if ((event.ctrlKey && !event.metaKey || event.metaKey && !event.ctrlKey) && this.props.multiSelectable) {
	        var idx = selectedRows.indexOf(rowNumber);
	        if (idx < 0) {
	          var foundRange = false;
	          for (var i = 0; i < selectedRows.length; i++) {
	            var range = selectedRows[i];
	            if ((typeof range === 'undefined' ? 'undefined' : (0, _typeof3.default)(range)) !== 'object') continue;
	
	            if (this.isValueInRange(rowNumber, range)) {
	              var _selectedRows;
	
	              foundRange = true;
	              var values = this.splitRange(range, rowNumber);
	              (_selectedRows = selectedRows).splice.apply(_selectedRows, [i, 1].concat((0, _toConsumableArray3.default)(values)));
	            }
	          }
	
	          if (!foundRange) selectedRows.push(rowNumber);
	        } else {
	          selectedRows.splice(idx, 1);
	        }
	      } else {
	        if (selectedRows.length === 1 && selectedRows[0] === rowNumber) {
	          selectedRows = [];
	        } else {
	          selectedRows = [rowNumber];
	        }
	      }
	
	      if (!this.isControlled) {
	        this.setState({ selectedRows: selectedRows });
	      }
	
	      if (this.props.onRowSelection) {
	        this.props.onRowSelection(this.flattenRanges(selectedRows));
	      }
	    }
	  }, {
	    key: 'splitRange',
	    value: function splitRange(range, splitPoint) {
	      var splitValues = [];
	      var startOffset = range.start - splitPoint;
	      var endOffset = range.end - splitPoint;
	
	      // Process start half
	      splitValues.push.apply(splitValues, (0, _toConsumableArray3.default)(this.genRangeOfValues(splitPoint, startOffset)));
	
	      // Process end half
	      splitValues.push.apply(splitValues, (0, _toConsumableArray3.default)(this.genRangeOfValues(splitPoint, endOffset)));
	
	      return splitValues;
	    }
	  }, {
	    key: 'genRangeOfValues',
	    value: function genRangeOfValues(start, offset) {
	      var values = [];
	      var dir = offset > 0 ? -1 : 1; // This forces offset to approach 0 from either direction.
	      while (offset !== 0) {
	        values.push(start + offset);
	        offset += dir;
	      }
	
	      return values;
	    }
	  }, {
	    key: 'flattenRanges',
	    value: function flattenRanges(selectedRows) {
	      var _this5 = this;
	
	      return selectedRows.reduce(function (rows, row) {
	        if ((typeof row === 'undefined' ? 'undefined' : (0, _typeof3.default)(row)) === 'object') {
	          var values = _this5.genRangeOfValues(row.end, row.start - row.end);
	          rows.push.apply(rows, [row.end].concat((0, _toConsumableArray3.default)(values)));
	        } else {
	          rows.push(row);
	        }
	
	        return rows;
	      }, []).sort();
	    }
	  }, {
	    key: 'getColumnId',
	    value: function getColumnId(columnNumber) {
	      return columnNumber - 1;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          allRowsSelected = _props.allRowsSelected,
	          multiSelectable = _props.multiSelectable,
	          onCellClick = _props.onCellClick,
	          onCellHover = _props.onCellHover,
	          onCellHoverExit = _props.onCellHoverExit,
	          onRowHover = _props.onRowHover,
	          onRowHoverExit = _props.onRowHoverExit,
	          onRowSelection = _props.onRowSelection,
	          selectable = _props.selectable,
	          deselectOnClickaway = _props.deselectOnClickaway,
	          showRowHover = _props.showRowHover,
	          stripedRows = _props.stripedRows,
	          displayRowCheckbox = _props.displayRowCheckbox,
	          preScanRows = _props.preScanRows,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'allRowsSelected', 'multiSelectable', 'onCellClick', 'onCellHover', 'onCellHoverExit', 'onRowHover', 'onRowHoverExit', 'onRowSelection', 'selectable', 'deselectOnClickaway', 'showRowHover', 'stripedRows', 'displayRowCheckbox', 'preScanRows']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: this.handleClickAway },
	        _react2.default.createElement(
	          'tbody',
	          (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
	          this.createRows()
	        )
	      );
	    }
	  }]);
	  return TableBody;
	}(_react.Component);
	
	TableBody.muiName = 'TableBody';
	TableBody.defaultProps = {
	  allRowsSelected: false,
	  deselectOnClickaway: true,
	  displayRowCheckbox: true,
	  multiSelectable: false,
	  preScanRows: true,
	  selectable: true,
	  style: {}
	};
	TableBody.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TableBody.propTypes =  false ? {
	  /**
	   * @ignore
	   * Set to true to indicate that all rows should be selected.
	   */
	  allRowsSelected: _propTypes2.default.bool,
	  /**
	   * Children passed to table body.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Controls whether or not to deselect all selected
	   * rows after clicking outside the table.
	   */
	  deselectOnClickaway: _propTypes2.default.bool,
	  /**
	   * Controls the display of the row checkbox. The default value is true.
	   */
	  displayRowCheckbox: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * If true, multiple table rows can be selected.
	   * CTRL/CMD+Click and SHIFT+Click are valid actions.
	   * The default value is false.
	   */
	  multiSelectable: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Callback function for when a cell is clicked.
	   */
	  onCellClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table cell is hovered. rowNumber
	   * is the row number of the hovered row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table row is no longer
	   * hovered. rowNumber is the row number of the row
	   * that is no longer hovered.
	   */
	  onRowHoverExit: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a row is selected. selectedRows is an
	   * array of all row selections. If all rows have been selected,
	   * the string "all" will be returned instead to indicate that
	   * all rows have been selected.
	   */
	  onRowSelection: _propTypes2.default.func,
	  /**
	   * Controls whether or not the rows are pre-scanned to determine
	   * initial state. If your table has a large number of rows and
	   * you are experiencing a delay in rendering, turn off this property.
	   */
	  preScanRows: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * If true, table rows can be selected. If multiple
	   * row selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _propTypes2.default.bool,
	  /**
	   * If true, table rows will be highlighted when
	   * the cursor is hovering over the row. The default
	   * value is false.
	   */
	  showRowHover: _propTypes2.default.bool,
	  /**
	   * If true, every other table row starting
	   * with the first row will be striped. The default value is false.
	   */
	  stripedRows: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = TableBody;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(266);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TableRowColumn = __webpack_require__(361);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableFooter = context.muiTheme.tableFooter;
	
	
	  return {
	    cell: {
	      borderTop: '1px solid ' + tableFooter.borderColor,
	      verticalAlign: 'bottom',
	      padding: 20,
	      textAlign: 'left',
	      whiteSpace: 'nowrap'
	    }
	  };
	}
	
	var TableFooter = function (_Component) {
	  (0, _inherits3.default)(TableFooter, _Component);
	
	  function TableFooter() {
	    (0, _classCallCheck3.default)(this, TableFooter);
	    return (0, _possibleConstructorReturn3.default)(this, (TableFooter.__proto__ || (0, _getPrototypeOf2.default)(TableFooter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TableFooter, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          adjustForCheckbox = _props.adjustForCheckbox,
	          children = _props.children,
	          className = _props.className,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['adjustForCheckbox', 'children', 'className', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var footerRows = _react2.default.Children.map(children, function (child, rowNumber) {
	        var newChildProps = {
	          displayBorder: false,
	          key: 'f-' + rowNumber,
	          rowNumber: rowNumber,
	          style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
	        };
	
	        var newDescendants = void 0;
	
	        if (adjustForCheckbox) {
	          newDescendants = [_react2.default.createElement(_TableRowColumn2.default, { key: 'fpcb' + rowNumber, style: { width: 24 } })].concat((0, _toConsumableArray3.default)(_react2.default.Children.toArray(child.props.children)));
	        } else {
	          newDescendants = child.props.children;
	        }
	
	        return _react2.default.cloneElement(child, newChildProps, newDescendants);
	      });
	
	      return _react2.default.createElement(
	        'tfoot',
	        (0, _extends3.default)({ className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
	        footerRows
	      );
	    }
	  }]);
	  return TableFooter;
	}(_react.Component);
	
	TableFooter.muiName = 'TableFooter';
	TableFooter.defaultProps = {
	  adjustForCheckbox: true,
	  style: {}
	};
	TableFooter.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TableFooter.propTypes =  false ? {
	  /**
	   * @ignore
	   * Controls whether or not header rows should be adjusted
	   * for a checkbox column. If the select all checkbox is true,
	   * this property will not influence the number of columns.
	   * This is mainly useful for "super header" rows so that
	   * the checkbox column does not create an offset that needs
	   * to be accounted for manually.
	   */
	  adjustForCheckbox: _propTypes2.default.bool,
	  /**
	   * Children passed to table footer.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = TableFooter;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Checkbox = __webpack_require__(210);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TableHeaderColumn = __webpack_require__(495);
	
	var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableHeader = context.muiTheme.tableHeader;
	
	
	  return {
	    root: {
	      borderBottom: '1px solid ' + tableHeader.borderColor
	    }
	  };
	}
	
	var TableHeader = function (_Component) {
	  (0, _inherits3.default)(TableHeader, _Component);
	
	  function TableHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeader.__proto__ || (0, _getPrototypeOf2.default)(TableHeader)).call.apply(_ref, [this].concat(args))), _this), _this.handleCheckAll = function (event, checked) {
	      if (_this.props.onSelectAll) {
	        _this.props.onSelectAll(checked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableHeader, [{
	    key: 'createSuperHeaderRows',
	    value: function createSuperHeaderRows() {
	      var numChildren = _react2.default.Children.count(this.props.children);
	      if (numChildren === 1) return undefined;
	
	      var superHeaders = [];
	      for (var index = 0; index < numChildren - 1; index++) {
	        var child = this.props.children[index];
	
	        if (!_react2.default.isValidElement(child)) continue;
	
	        var props = {
	          key: 'sh' + index,
	          rowNumber: index
	        };
	        superHeaders.push(this.createSuperHeaderRow(child, props));
	      }
	
	      if (superHeaders.length) return superHeaders;
	    }
	  }, {
	    key: 'createSuperHeaderRow',
	    value: function createSuperHeaderRow(child, props) {
	      var children = [];
	      if (this.props.adjustForCheckbox) {
	        children.push(this.getCheckboxPlaceholder(props));
	      }
	      _react2.default.Children.forEach(child.props.children, function (child) {
	        children.push(child);
	      });
	
	      return _react2.default.cloneElement(child, props, children);
	    }
	  }, {
	    key: 'createBaseHeaderRow',
	    value: function createBaseHeaderRow() {
	      var childrenArray = _react2.default.Children.toArray(this.props.children);
	      var numChildren = childrenArray.length;
	      if (numChildren < 1) {
	        return null;
	      }
	
	      var child = childrenArray[numChildren - 1];
	
	      var props = {
	        key: 'h' + numChildren,
	        rowNumber: numChildren
	      };
	
	      var children = [this.getSelectAllCheckboxColumn(props)];
	      _react2.default.Children.forEach(child.props.children, function (child) {
	        children.push(child);
	      });
	
	      return _react2.default.cloneElement(child, props, children);
	    }
	  }, {
	    key: 'getCheckboxPlaceholder',
	    value: function getCheckboxPlaceholder(props) {
	      if (!this.props.adjustForCheckbox) return null;
	
	      var disabled = !this.props.enableSelectAll;
	      var key = 'hpcb' + props.rowNumber;
	      return _react2.default.createElement(_TableHeaderColumn2.default, {
	        key: key,
	        style: {
	          width: 24,
	          cursor: disabled ? 'default' : 'inherit'
	        }
	      });
	    }
	  }, {
	    key: 'getSelectAllCheckboxColumn',
	    value: function getSelectAllCheckboxColumn(props) {
	      if (!this.props.displaySelectAll) return this.getCheckboxPlaceholder(props);
	
	      var disabled = !this.props.enableSelectAll;
	      var checkbox = _react2.default.createElement(_Checkbox2.default, {
	        key: 'selectallcb',
	        name: 'selectallcb',
	        value: 'selected',
	        disabled: disabled,
	        checked: this.props.selectAllSelected,
	        onCheck: this.handleCheckAll
	      });
	
	      var key = 'hpcb' + props.rowNumber;
	      return _react2.default.createElement(
	        _TableHeaderColumn2.default,
	        {
	          key: key,
	          style: {
	            width: 24,
	            cursor: disabled ? 'not-allowed' : 'inherit'
	          }
	        },
	        checkbox
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var superHeaderRows = this.createSuperHeaderRows();
	      var baseHeaderRow = this.createBaseHeaderRow();
	
	      return _react2.default.createElement(
	        'thead',
	        { className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        superHeaderRows,
	        baseHeaderRow
	      );
	    }
	  }]);
	  return TableHeader;
	}(_react.Component);
	
	TableHeader.muiName = 'TableHeader';
	TableHeader.defaultProps = {
	  adjustForCheckbox: true,
	  displaySelectAll: true,
	  enableSelectAll: true,
	  selectAllSelected: false
	};
	TableHeader.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TableHeader.propTypes =  false ? {
	  /**
	   * Controls whether or not header rows should be
	   * adjusted for a checkbox column. If the select all
	   * checkbox is true, this property will not influence
	   * the number of columns. This is mainly useful for
	   * "super header" rows so that the checkbox column
	   * does not create an offset that needs to be accounted
	   * for manually.
	   */
	  adjustForCheckbox: _propTypes2.default.bool,
	  /**
	   * Children passed to table header.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Controls whether or not the select all checkbox is displayed.
	   */
	  displaySelectAll: _propTypes2.default.bool,
	  /**
	   * If set to true, the select all button will be interactable.
	   * If set to false, the button will not be interactable.
	   * To hide the checkbox, set displaySelectAll to false.
	   */
	  enableSelectAll: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Callback when select all has been checked.
	   */
	  onSelectAll: _propTypes2.default.func,
	  /**
	   * @ignore
	   * True when select all has been checked.
	   */
	  selectAllSelected: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = TableHeader;

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var tableRow = context.muiTheme.tableRow;
	
	
	  var cellBgColor = 'inherit';
	  if (props.hovered || state.hovered) {
	    cellBgColor = tableRow.hoverColor;
	  } else if (props.selected) {
	    cellBgColor = tableRow.selectedColor;
	  } else if (props.striped) {
	    cellBgColor = tableRow.stripeColor;
	  }
	
	  return {
	    root: {
	      borderBottom: props.displayBorder && '1px solid ' + tableRow.borderColor,
	      color: tableRow.textColor,
	      height: tableRow.height
	    },
	    cell: {
	      backgroundColor: cellBgColor
	    }
	  };
	}
	
	var TableRow = function (_Component) {
	  (0, _inherits3.default)(TableRow, _Component);
	
	  function TableRow() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableRow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableRow.__proto__ || (0, _getPrototypeOf2.default)(TableRow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onCellClick = function (event, columnIndex) {
	      if (_this.props.selectable && _this.props.onCellClick) {
	        _this.props.onCellClick(event, _this.props.rowNumber, columnIndex);
	      }
	      event.ctrlKey = true;
	      _this.onRowClick(event);
	    }, _this.onCellHover = function (event, columnIndex) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: true });
	        if (_this.props.onCellHover) _this.props.onCellHover(event, _this.props.rowNumber, columnIndex);
	        _this.onRowHover(event);
	      }
	    }, _this.onCellHoverExit = function (event, columnIndex) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: false });
	        if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(event, _this.props.rowNumber, columnIndex);
	        _this.onRowHoverExit(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableRow, [{
	    key: 'onRowClick',
	    value: function onRowClick(event) {
	      if (this.props.selectable && this.props.onRowClick) {
	        this.props.onRowClick(event, this.props.rowNumber);
	      }
	    }
	  }, {
	    key: 'onRowHover',
	    value: function onRowHover(event) {
	      if (this.props.onRowHover) {
	        this.props.onRowHover(event, this.props.rowNumber);
	      }
	    }
	  }, {
	    key: 'onRowHoverExit',
	    value: function onRowHoverExit(event) {
	      if (this.props.onRowHoverExit) {
	        this.props.onRowHoverExit(event, this.props.rowNumber);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          displayBorder = _props.displayBorder,
	          hoverable = _props.hoverable,
	          hovered = _props.hovered,
	          onCellClick = _props.onCellClick,
	          onCellHover = _props.onCellHover,
	          onCellHoverExit = _props.onCellHoverExit,
	          onRowClick = _props.onRowClick,
	          onRowHover = _props.onRowHover,
	          onRowHoverExit = _props.onRowHoverExit,
	          rowNumber = _props.rowNumber,
	          selectable = _props.selectable,
	          selected = _props.selected,
	          striped = _props.striped,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'displayBorder', 'hoverable', 'hovered', 'onCellClick', 'onCellHover', 'onCellHoverExit', 'onRowClick', 'onRowHover', 'onRowHoverExit', 'rowNumber', 'selectable', 'selected', 'striped', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var rowColumns = _react2.default.Children.map(this.props.children, function (child, columnNumber) {
	        if (_react2.default.isValidElement(child)) {
	          return _react2.default.cloneElement(child, {
	            columnNumber: columnNumber,
	            hoverable: _this2.props.hoverable,
	            key: _this2.props.rowNumber + '-' + columnNumber,
	            onClick: _this2.onCellClick,
	            onHover: _this2.onCellHover,
	            onHoverExit: _this2.onCellHoverExit,
	            style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
	          });
	        }
	      });
	
	      return _react2.default.createElement(
	        'tr',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, other),
	        rowColumns
	      );
	    }
	  }]);
	  return TableRow;
	}(_react.Component);
	
	TableRow.defaultProps = {
	  displayBorder: true,
	  hoverable: false,
	  hovered: false,
	  selectable: true,
	  striped: false
	};
	TableRow.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TableRow.propTypes =  false ? {
	  /**
	   * Children passed to table row.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If true, row border will be displayed for the row.
	   * If false, no border will be drawn.
	   */
	  displayBorder: _propTypes2.default.bool,
	  /**
	   * Controls whether or not the row responds to hover events.
	   */
	  hoverable: _propTypes2.default.bool,
	  /**
	   * Controls whether or not the row should be rendered as being
	   * hovered. This property is evaluated in addition to this.state.hovered
	   * and can be used to synchronize the hovered state with some other
	   * external events.
	   */
	  hovered: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Called when a row cell is clicked.
	   * rowNumber is the row number and columnId is
	   * the column number or the column key.
	   */
	  onCellClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table cell is hovered.
	   * rowNumber is the row number of the hovered row
	   * and columnId is the column number or the column key of the cell.
	   */
	  onCellHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when row is clicked.
	   */
	  onRowClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table row is no longer hovered.
	   * rowNumber is the row number of the row that is no longer hovered.
	   */
	  onRowHoverExit: _propTypes2.default.func,
	  /**
	   * Number to identify the row. This property is
	   * automatically populated when used with the TableBody component.
	   */
	  rowNumber: _propTypes2.default.number,
	  /**
	   * If true, table rows can be selected. If multiple row
	   * selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _propTypes2.default.bool,
	  /**
	   * Indicates that a particular row is selected.
	   * This property can be used to programmatically select rows.
	   */
	  selected: _propTypes2.default.bool,
	  /**
	   * Indicates whether or not the row is striped.
	   */
	  striped: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = TableRow;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.TableRowColumn = exports.TableRow = exports.TableHeaderColumn = exports.TableHeader = exports.TableFooter = exports.TableBody = exports.Table = undefined;
	
	var _Table2 = __webpack_require__(1546);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TableBody2 = __webpack_require__(757);
	
	var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	var _TableFooter2 = __webpack_require__(758);
	
	var _TableFooter3 = _interopRequireDefault(_TableFooter2);
	
	var _TableHeader2 = __webpack_require__(759);
	
	var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	var _TableHeaderColumn2 = __webpack_require__(495);
	
	var _TableHeaderColumn3 = _interopRequireDefault(_TableHeaderColumn2);
	
	var _TableRow2 = __webpack_require__(760);
	
	var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	var _TableRowColumn2 = __webpack_require__(361);
	
	var _TableRowColumn3 = _interopRequireDefault(_TableRowColumn2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Table = _Table3.default;
	exports.TableBody = _TableBody3.default;
	exports.TableFooter = _TableFooter3.default;
	exports.TableHeader = _TableHeader3.default;
	exports.TableHeaderColumn = _TableHeaderColumn3.default;
	exports.TableRow = _TableRow3.default;
	exports.TableRowColumn = _TableRowColumn3.default;
	exports.default = _Table3.default;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _slicedToArray2 = __webpack_require__(412);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _timeUtils = __webpack_require__(289);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var styles = {
	    root: {
	      directionInvariant: true,
	      display: 'inline-block',
	      position: 'absolute',
	      width: 32,
	      height: 32,
	      borderRadius: '100%',
	      left: 'calc(50% - 16px)',
	      top: 10,
	      textAlign: 'center',
	      paddingTop: 5,
	      userSelect: 'none', /* Chrome all / Safari all */
	      fontSize: '1.1em',
	      pointerEvents: 'none',
	      boxSizing: 'border-box'
	    }
	  };
	
	  var muiTheme = context.muiTheme;
	
	
	  var pos = props.value;
	
	  if (props.type === 'hour') {
	    pos %= 12;
	  } else {
	    pos = pos / 5;
	  }
	
	  var positions = [[0, 5], [54.5, 16.6], [94.4, 59.5], [109, 114], [94.4, 168.5], [54.5, 208.4], [0, 223], [-54.5, 208.4], [-94.4, 168.5], [-109, 114], [-94.4, 59.5], [-54.5, 19.6]];
	
	  var innerPositions = [[0, 40], [36.9, 49.9], [64, 77], [74, 114], [64, 151], [37, 178], [0, 188], [-37, 178], [-64, 151], [-74, 114], [-64, 77], [-37, 50]];
	
	  if (props.isSelected) {
	    styles.root.backgroundColor = muiTheme.timePicker.accentColor;
	    styles.root.color = muiTheme.timePicker.selectTextColor;
	  }
	
	  var transformPos = positions[pos];
	
	  if ((0, _timeUtils.isInner)(props)) {
	    styles.root.width = 28;
	    styles.root.height = 28;
	    styles.root.left = 'calc(50% - 14px)';
	    transformPos = innerPositions[pos];
	  }
	
	  var _transformPos = transformPos,
	      _transformPos2 = (0, _slicedToArray3.default)(_transformPos, 2),
	      x = _transformPos2[0],
	      y = _transformPos2[1];
	
	  styles.root.transform = 'translate(' + x + 'px, ' + y + 'px)';
	
	  return styles;
	}
	
	var ClockNumber = function (_Component) {
	  (0, _inherits3.default)(ClockNumber, _Component);
	
	  function ClockNumber() {
	    (0, _classCallCheck3.default)(this, ClockNumber);
	    return (0, _possibleConstructorReturn3.default)(this, (ClockNumber.__proto__ || (0, _getPrototypeOf2.default)(ClockNumber)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ClockNumber, [{
	    key: 'render',
	    value: function render() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var clockNumber = this.props.value === 0 ? '00' : this.props.value;
	
	      return _react2.default.createElement(
	        'span',
	        { style: prepareStyles(styles.root) },
	        clockNumber
	      );
	    }
	  }]);
	  return ClockNumber;
	}(_react.Component);
	
	ClockNumber.defaultProps = {
	  value: 0,
	  type: 'minute',
	  isSelected: false
	};
	ClockNumber.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ClockNumber.propTypes =  false ? {
	  isSelected: _propTypes2.default.bool,
	  onSelected: _propTypes2.default.func,
	  type: _propTypes2.default.oneOf(['hour', 'minute']),
	  value: _propTypes2.default.number
	} : {};
	exports.default = ClockNumber;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _timeUtils = __webpack_require__(289);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calcAngle(value, base) {
	  value %= base;
	  var angle = 360 / base * value;
	  return angle;
	}
	
	function getStyles(props, context, state) {
	  var hasSelected = props.hasSelected,
	      type = props.type,
	      value = props.value;
	  var inner = state.inner;
	  var timePicker = context.muiTheme.timePicker;
	
	  var angle = type === 'hour' ? calcAngle(value, 12) : calcAngle(value, 60);
	
	  var styles = {
	    root: {
	      height: inner ? '30%' : '40%',
	      background: timePicker.accentColor,
	      width: 2,
	      left: 'calc(50% - 1px)',
	      position: 'absolute',
	      bottom: '50%',
	      transformOrigin: 'bottom',
	      pointerEvents: 'none',
	      transform: 'rotateZ(' + angle + 'deg)'
	    },
	    mark: {
	      boxSizing: 'content-box',
	      background: timePicker.selectTextColor,
	      border: '4px solid ' + timePicker.accentColor,
	      display: hasSelected && 'none',
	      width: 7,
	      height: 7,
	      position: 'absolute',
	      top: -5,
	      left: -6,
	      borderRadius: '100%'
	    }
	  };
	
	  return styles;
	}
	
	var ClockPointer = function (_Component) {
	  (0, _inherits3.default)(ClockPointer, _Component);
	
	  function ClockPointer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockPointer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockPointer.__proto__ || (0, _getPrototypeOf2.default)(ClockPointer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      inner: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockPointer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        inner: (0, _timeUtils.isInner)(this.props)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        inner: (0, _timeUtils.isInner)(nextProps)
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.value === null) {
	        return _react2.default.createElement('span', null);
	      }
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement('div', { style: prepareStyles(styles.mark) })
	      );
	    }
	  }]);
	  return ClockPointer;
	}(_react.Component);
	
	ClockPointer.defaultProps = {
	  hasSelected: false,
	  value: null,
	  type: 'minute'
	};
	ClockPointer.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ClockPointer.propTypes =  false ? {
	  hasSelected: _propTypes2.default.bool,
	  type: _propTypes2.default.oneOf(['hour', 'minute']),
	  value: _propTypes2.default.number
	} : {};
	exports.default = ClockPointer;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var firstChild = props.firstChild,
	      lastChild = props.lastChild;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      button = _context$muiTheme.button,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  var marginHorizontal = baseTheme.spacing.desktopGutter;
	  var marginVertical = (toolbar.height - button.height) / 2;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      marginLeft: firstChild ? -marginHorizontal : undefined,
	      marginRight: lastChild ? -marginHorizontal : undefined,
	      display: 'flex',
	      justifyContent: 'space-between',
	      alignItems: 'center'
	    },
	    dropDownMenu: {
	      root: {
	        color: toolbar.color, // removes hover color change, we want to keep it
	        marginRight: baseTheme.spacing.desktopGutter,
	        flex: 1,
	        whiteSpace: 'nowrap'
	      },
	      controlBg: {
	        backgroundColor: toolbar.menuHoverColor,
	        borderRadius: 0
	      },
	      underline: {
	        display: 'none'
	      }
	    },
	    button: {
	      margin: marginVertical + 'px ' + marginHorizontal + 'px',
	      position: 'relative'
	    },
	    icon: {
	      root: {
	        cursor: 'pointer',
	        lineHeight: toolbar.height + 'px',
	        paddingLeft: baseTheme.spacing.desktopGutter
	      }
	    },
	    span: {
	      color: toolbar.iconColor,
	      lineHeight: toolbar.height + 'px'
	    }
	  };
	
	  return styles;
	}
	
	var ToolbarGroup = function (_Component) {
	  (0, _inherits3.default)(ToolbarGroup, _Component);
	
	  function ToolbarGroup() {
	    (0, _classCallCheck3.default)(this, ToolbarGroup);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarGroup.__proto__ || (0, _getPrototypeOf2.default)(ToolbarGroup)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarGroup, [{
	    key: 'handleMouseLeaveFontIcon',
	    value: function handleMouseLeaveFontIcon(style) {
	      return function (event) {
	        event.target.style.zIndex = 'auto';
	        event.target.style.color = style.root.color;
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          firstChild = _props.firstChild,
	          lastChild = _props.lastChild,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'firstChild', 'lastChild', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var newChildren = _react2.default.Children.map(children, function (currentChild) {
	        if (!currentChild) {
	          return null;
	        }
	        if (!currentChild.type) {
	          return currentChild;
	        }
	        switch (currentChild.type.muiName) {
	          case 'DropDownMenu':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.dropDownMenu.root, currentChild.props.style),
	              underlineStyle: styles.dropDownMenu.underline
	            });
	          case 'RaisedButton':
	          case 'FlatButton':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.button, currentChild.props.style)
	            });
	          case 'FontIcon':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.icon.root, currentChild.props.style),
	              color: currentChild.props.color || _this2.context.muiTheme.toolbar.iconColor,
	              hoverColor: currentChild.props.hoverColor || _this2.context.muiTheme.toolbar.hoverColor
	            });
	          case 'ToolbarSeparator':
	          case 'ToolbarTitle':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.span, currentChild.props.style)
	            });
	          default:
	            return currentChild;
	        }
	      }, this);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        newChildren
	      );
	    }
	  }]);
	  return ToolbarGroup;
	}(_react.Component);
	
	ToolbarGroup.defaultProps = {
	  firstChild: false,
	  lastChild: false
	};
	ToolbarGroup.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ToolbarGroup.propTypes =  false ? {
	  /**
	   * Can be any node or number of nodes.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Set this to true for if the `ToolbarGroup` is the first child of `Toolbar`
	   * to prevent setting the left gap.
	   */
	  firstChild: _propTypes2.default.bool,
	  /**
	   * Set this to true for if the `ToolbarGroup` is the last child of `Toolbar`
	   * to prevent setting the right gap.
	   */
	  lastChild: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = ToolbarGroup;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      backgroundColor: toolbar.separatorColor,
	      display: 'block',
	      height: baseTheme.spacing.desktopGutterMore,
	      marginLeft: baseTheme.spacing.desktopGutter,
	      width: 1
	    }
	  };
	}
	
	var ToolbarSeparator = function (_Component) {
	  (0, _inherits3.default)(ToolbarSeparator, _Component);
	
	  function ToolbarSeparator() {
	    (0, _classCallCheck3.default)(this, ToolbarSeparator);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarSeparator.__proto__ || (0, _getPrototypeOf2.default)(ToolbarSeparator)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarSeparator, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement('span', (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }));
	    }
	  }]);
	  return ToolbarSeparator;
	}(_react.Component);
	
	ToolbarSeparator.muiName = 'ToolbarSeparator';
	ToolbarSeparator.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ToolbarSeparator.propTypes =  false ? {
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = ToolbarSeparator;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      paddingRight: baseTheme.spacing.desktopGutterLess,
	      lineHeight: toolbar.height + 'px',
	      fontSize: toolbar.titleFontSize,
	      fontFamily: baseTheme.fontFamily,
	      position: 'relative',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden'
	    }
	  };
	}
	
	var ToolbarTitle = function (_Component) {
	  (0, _inherits3.default)(ToolbarTitle, _Component);
	
	  function ToolbarTitle() {
	    (0, _classCallCheck3.default)(this, ToolbarTitle);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarTitle.__proto__ || (0, _getPrototypeOf2.default)(ToolbarTitle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          text = _props.text,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'text']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'span',
	        (0, _extends3.default)({
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style))
	        }, other),
	        text
	      );
	    }
	  }]);
	  return ToolbarTitle;
	}(_react.Component);
	
	ToolbarTitle.muiName = 'ToolbarTitle';
	ToolbarTitle.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ToolbarTitle.propTypes =  false ? {
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The text to be displayed.
	   */
	  text: _propTypes2.default.node
	} : {};
	exports.default = ToolbarTitle;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = undefined;
	
	var _Toolbar2 = __webpack_require__(1563);
	
	var _Toolbar3 = _interopRequireDefault(_Toolbar2);
	
	var _ToolbarGroup2 = __webpack_require__(764);
	
	var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);
	
	var _ToolbarSeparator2 = __webpack_require__(765);
	
	var _ToolbarSeparator3 = _interopRequireDefault(_ToolbarSeparator2);
	
	var _ToolbarTitle2 = __webpack_require__(766);
	
	var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Toolbar = _Toolbar3.default;
	exports.ToolbarGroup = _ToolbarGroup3.default;
	exports.ToolbarSeparator = _ToolbarSeparator3.default;
	exports.ToolbarTitle = _ToolbarTitle3.default;
	exports.default = _Toolbar3.default;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _AutoLockScrolling = __webpack_require__(1564);
	
	var _AutoLockScrolling2 = _interopRequireDefault(_AutoLockScrolling);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var overlay = context.muiTheme.overlay;
	
	
	  var style = {
	    root: {
	      position: 'fixed',
	      height: '100%',
	      width: '100%',
	      top: 0,
	      left: '-100%',
	      opacity: 0,
	      backgroundColor: overlay.backgroundColor,
	      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)', // Remove mobile color flashing (deprecated)
	
	      // Two ways to promote overlay to its own render layer
	      willChange: 'opacity',
	      transform: 'translateZ(0)',
	
	      transition: props.transitionEnabled && _transitions2.default.easeOut('0ms', 'left', '400ms') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    }
	  };
	
	  if (props.show) {
	    (0, _simpleAssign2.default)(style.root, {
	      left: 0,
	      opacity: 1,
	      transition: _transitions2.default.easeOut('0ms', 'left') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    });
	  }
	
	  return style;
	}
	
	var Overlay = function (_Component) {
	  (0, _inherits3.default)(Overlay, _Component);
	
	  function Overlay() {
	    (0, _classCallCheck3.default)(this, Overlay);
	    return (0, _possibleConstructorReturn3.default)(this, (Overlay.__proto__ || (0, _getPrototypeOf2.default)(Overlay)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Overlay, [{
	    key: 'setOpacity',
	    value: function setOpacity(opacity) {
	      this.refs.overlay.style.opacity = opacity;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoLockScrolling = _props.autoLockScrolling,
	          show = _props.show,
	          style = _props.style,
	          transitionEnabled = _props.transitionEnabled,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoLockScrolling', 'show', 'style', 'transitionEnabled']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { ref: 'overlay', style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        autoLockScrolling && _react2.default.createElement(_AutoLockScrolling2.default, { lock: show })
	      );
	    }
	  }]);
	  return Overlay;
	}(_react.Component);
	
	Overlay.defaultProps = {
	  autoLockScrolling: true,
	  style: {},
	  transitionEnabled: true
	};
	Overlay.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Overlay.propTypes =  false ? {
	  autoLockScrolling: _propTypes2.default.bool,
	  show: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  transitionEnabled: _propTypes2.default.bool
	} : {};
	exports.default = Overlay;

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _dom = __webpack_require__(784);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// heavily inspired by https://github.com/Khan/react-components/blob/master/js/layered-component-mixin.jsx
	var RenderToLayer = function (_Component) {
	  (0, _inherits3.default)(RenderToLayer, _Component);
	
	  function RenderToLayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RenderToLayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RenderToLayer.__proto__ || (0, _getPrototypeOf2.default)(RenderToLayer)).call.apply(_ref, [this].concat(args))), _this), _this.onClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      if (!_this.props.componentClickAway) {
	        return;
	      }
	
	      if (!_this.props.open) {
	        return;
	      }
	
	      var el = _this.layer;
	      if (event.target !== el && event.target === window || document.documentElement.contains(event.target) && !_dom2.default.isDescendant(el, event.target)) {
	        _this.props.componentClickAway(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RenderToLayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unrenderLayer();
	    }
	  }, {
	    key: 'getLayer',
	    value: function getLayer() {
	      return this.layer;
	    }
	  }, {
	    key: 'unrenderLayer',
	    value: function unrenderLayer() {
	      if (!this.layer) {
	        return;
	      }
	
	      if (this.props.useLayerForClickAway) {
	        this.layer.style.position = 'relative';
	        this.layer.removeEventListener('touchstart', this.onClickAway);
	        this.layer.removeEventListener('click', this.onClickAway);
	      } else {
	        window.removeEventListener('touchstart', this.onClickAway);
	        window.removeEventListener('click', this.onClickAway);
	      }
	
	      (0, _reactDom.unmountComponentAtNode)(this.layer);
	      document.body.removeChild(this.layer);
	      this.layer = null;
	    }
	
	    /**
	     * By calling this method in componentDidMount() and
	     * componentDidUpdate(), you're effectively creating a "wormhole" that
	     * funnels React's hierarchical updates through to a DOM node on an
	     * entirely different part of the page.
	     */
	
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer() {
	      var _this2 = this;
	
	      var _props = this.props,
	          open = _props.open,
	          render = _props.render;
	
	
	      if (open) {
	        if (!this.layer) {
	          this.layer = document.createElement('div');
	          document.body.appendChild(this.layer);
	
	          if (this.props.useLayerForClickAway) {
	            this.layer.addEventListener('touchstart', this.onClickAway);
	            this.layer.addEventListener('click', this.onClickAway);
	            this.layer.style.position = 'fixed';
	            this.layer.style.top = 0;
	            this.layer.style.bottom = 0;
	            this.layer.style.left = 0;
	            this.layer.style.right = 0;
	            this.layer.style.zIndex = this.context.muiTheme.zIndex.layer;
	          } else {
	            setTimeout(function () {
	              window.addEventListener('touchstart', _this2.onClickAway);
	              window.addEventListener('click', _this2.onClickAway);
	            }, 0);
	          }
	        }
	
	        var layerElement = render();
	        this.layerElement = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, layerElement, this.layer);
	      } else {
	        this.unrenderLayer();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return RenderToLayer;
	}(_react.Component);
	
	RenderToLayer.defaultProps = {
	  useLayerForClickAway: true
	};
	RenderToLayer.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	RenderToLayer.propTypes =  false ? {
	  componentClickAway: _propTypes2.default.func,
	  open: _propTypes2.default.bool.isRequired,
	  render: _propTypes2.default.func.isRequired,
	  useLayerForClickAway: _propTypes2.default.bool
	} : {};
	exports.default = RenderToLayer;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var verticalPosition = props.verticalPosition;
	  var horizontalPosition = props.horizontalPosition;
	  var touchMarginOffset = props.touch ? 10 : 0;
	  var touchOffsetTop = props.touch ? -20 : -10;
	  var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;
	
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      zIndex = _context$muiTheme.zIndex,
	      tooltip = _context$muiTheme.tooltip,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  var styles = {
	    root: {
	      position: 'absolute',
	      fontFamily: baseTheme.fontFamily,
	      fontSize: '10px',
	      lineHeight: '22px',
	      padding: '0 8px',
	      zIndex: zIndex.tooltip,
	      color: tooltip.color,
	      overflow: 'hidden',
	      top: -10000,
	      borderRadius: borderRadius,
	      userSelect: 'none',
	      opacity: 0,
	      right: horizontalPosition === 'left' ? 12 : null,
	      left: horizontalPosition === 'center' ? (state.offsetWidth - 48) / 2 * -1 : horizontalPosition === 'right' ? 12 : null,
	      transition: _transitions2.default.easeOut('0ms', 'top', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    label: {
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    ripple: {
	      position: 'absolute',
	      left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
	      top: verticalPosition === 'bottom' ? 0 : '100%',
	      transform: 'translate(-50%, -50%)',
	      borderRadius: '50%',
	      backgroundColor: 'transparent',
	      transition: _transitions2.default.easeOut('0ms', 'width', '450ms') + ', ' + _transitions2.default.easeOut('0ms', 'height', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    },
	    rootWhenShown: {
	      top: verticalPosition === 'top' ? touchOffsetTop : 36,
	      opacity: tooltip.opacity,
	      transform: 'translate(0px, ' + offset + 'px)',
	      transition: _transitions2.default.easeOut('0ms', 'top', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    rootWhenTouched: {
	      fontSize: '14px',
	      lineHeight: '32px',
	      padding: '0 16px'
	    },
	    rippleWhenShown: {
	      backgroundColor: tooltip.rippleBackgroundColor,
	      transition: _transitions2.default.easeOut('450ms', 'width', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'height', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    }
	  };
	
	  return styles;
	}
	
	var Tooltip = function (_Component) {
	  (0, _inherits3.default)(Tooltip, _Component);
	
	  function Tooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      offsetWidth: null
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setRippleSize();
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setRippleSize();
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var ripple = this.refs.ripple;
	      var tooltip = this.refs.tooltip;
	      var tooltipWidth = parseInt(tooltip.offsetWidth, 10) / (this.props.horizontalPosition === 'center' ? 2 : 1);
	      var tooltipHeight = parseInt(tooltip.offsetHeight, 10);
	
	      var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
	      if (this.props.show) {
	        ripple.style.height = rippleDiameter + 'px';
	        ripple.style.width = rippleDiameter + 'px';
	      } else {
	        ripple.style.width = '0px';
	        ripple.style.height = '0px';
	      }
	    }
	  }, {
	    key: 'setTooltipPosition',
	    value: function setTooltipPosition() {
	      this.setState({ offsetWidth: this.refs.tooltip.offsetWidth });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          horizontalPosition = _props.horizontalPosition,
	          label = _props.label,
	          show = _props.show,
	          touch = _props.touch,
	          verticalPosition = _props.verticalPosition,
	          other = (0, _objectWithoutProperties3.default)(_props, ['horizontalPosition', 'label', 'show', 'touch', 'verticalPosition']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, {
	          ref: 'tooltip',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, this.props.show && styles.rootWhenShown, this.props.touch && styles.rootWhenTouched, this.props.style))
	        }),
	        _react2.default.createElement('div', {
	          ref: 'ripple',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.ripple, this.props.show && styles.rippleWhenShown))
	        }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          label
	        )
	      );
	    }
	  }]);
	  return Tooltip;
	}(_react.Component);
	
	Tooltip.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Tooltip.propTypes =  false ? {
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  horizontalPosition: _propTypes2.default.oneOf(['left', 'right', 'center']),
	  label: _propTypes2.default.node.isRequired,
	  show: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  touch: _propTypes2.default.bool,
	  verticalPosition: _propTypes2.default.oneOf(['top', 'bottom'])
	} : {};
	exports.default = Tooltip;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(266);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _toArray2 = __webpack_require__(592);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionGroup = __webpack_require__(290);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _dom = __webpack_require__(784);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	var _CircleRipple = __webpack_require__(1566);
	
	var _CircleRipple2 = _interopRequireDefault(_CircleRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Remove the first element of the array
	var shift = function shift(_ref) {
	  var _ref2 = (0, _toArray3.default)(_ref),
	      newArray = _ref2.slice(1);
	
	  return newArray;
	};
	
	var TouchRipple = function (_Component) {
	  (0, _inherits3.default)(TouchRipple, _Component);
	
	  function TouchRipple(props, context) {
	    (0, _classCallCheck3.default)(this, TouchRipple);
	
	    // Touch start produces a mouse down event for compat reasons. To avoid
	    // showing ripples twice we skip showing a ripple for the first mouse down
	    // after a touch start. Note we don't store ignoreNextMouseDown in this.state
	    // to avoid re-rendering when we change it.
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call(this, props, context));
	
	    _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.start(event, false);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.end();
	    };
	
	    _this.handleMouseLeave = function () {
	      _this.end();
	    };
	
	    _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      // If the user is swiping (not just tapping), save the position so we can
	      // abort ripples if the user appears to be scrolling.
	      if (_this.props.abortOnScroll && event.touches) {
	        _this.startListeningForScrollAbort(event);
	        _this.startTime = Date.now();
	      }
	      _this.start(event, true);
	    };
	
	    _this.handleTouchEnd = function () {
	      _this.end();
	    };
	
	    _this.handleTouchMove = function (event) {
	      // Stop trying to abort if we're already 300ms into the animation
	      var timeSinceStart = Math.abs(Date.now() - _this.startTime);
	      if (timeSinceStart > 300) {
	        _this.stopListeningForScrollAbort();
	        return;
	      }
	
	      // If the user is scrolling...
	      var deltaY = Math.abs(event.touches[0].clientY - _this.firstTouchY);
	      var deltaX = Math.abs(event.touches[0].clientX - _this.firstTouchX);
	      // Call it a scroll after an arbitrary 6px (feels reasonable in testing)
	      if (deltaY > 6 || deltaX > 6) {
	        var currentRipples = _this.state.ripples;
	        var ripple = currentRipples[0];
	        // This clone will replace the ripple in ReactTransitionGroup with a
	        // version that will disappear immediately when removed from the DOM
	        var abortedRipple = _react2.default.cloneElement(ripple, { aborted: true });
	        // Remove the old ripple and replace it with the new updated one
	        currentRipples = shift(currentRipples);
	        currentRipples = [].concat((0, _toConsumableArray3.default)(currentRipples), [abortedRipple]);
	        _this.setState({ ripples: currentRipples }, function () {
	          // Call end after we've set the ripple to abort otherwise the setState
	          // in end() merges with this and the ripple abort fails
	          _this.end();
	        });
	      }
	    };
	
	    _this.ignoreNextMouseDown = false;
	
	    _this.state = {
	      // This prop allows us to only render the ReactTransitionGroup
	      // on the first click of the component, making the inital render faster.
	      hasRipples: false,
	      nextKey: 0,
	      ripples: []
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(TouchRipple, [{
	    key: 'start',
	    value: function start(event, isRippleTouchGenerated) {
	      var theme = this.context.muiTheme.ripple;
	
	      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
	        this.ignoreNextMouseDown = false;
	        return;
	      }
	
	      var ripples = this.state.ripples;
	
	      // Add a ripple to the ripples array
	      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_CircleRipple2.default, {
	        key: this.state.nextKey,
	        style: !this.props.centerRipple ? this.getRippleStyle(event) : {},
	        color: this.props.color || theme.color,
	        opacity: this.props.opacity,
	        touchGenerated: isRippleTouchGenerated
	      })]);
	
	      this.ignoreNextMouseDown = isRippleTouchGenerated;
	      this.setState({
	        hasRipples: true,
	        nextKey: this.state.nextKey + 1,
	        ripples: ripples
	      });
	    }
	  }, {
	    key: 'end',
	    value: function end() {
	      var currentRipples = this.state.ripples;
	      this.setState({
	        ripples: shift(currentRipples)
	      });
	      if (this.props.abortOnScroll) {
	        this.stopListeningForScrollAbort();
	      }
	    }
	
	    // Check if the user seems to be scrolling and abort the animation if so
	
	  }, {
	    key: 'startListeningForScrollAbort',
	    value: function startListeningForScrollAbort(event) {
	      this.firstTouchY = event.touches[0].clientY;
	      this.firstTouchX = event.touches[0].clientX;
	      // Note that when scolling Chrome throttles this event to every 200ms
	      // Also note we don't listen for scroll events directly as there's no general
	      // way to cover cases like scrolling within containers on the page
	      document.body.addEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'stopListeningForScrollAbort',
	    value: function stopListeningForScrollAbort() {
	      document.body.removeEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'getRippleStyle',
	    value: function getRippleStyle(event) {
	      var el = _reactDom2.default.findDOMNode(this);
	      var elHeight = el.offsetHeight;
	      var elWidth = el.offsetWidth;
	      var offset = _dom2.default.offset(el);
	      var isTouchEvent = event.touches && event.touches.length;
	      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
	      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
	      var pointerX = pageX - offset.left;
	      var pointerY = pageY - offset.top;
	      var topLeftDiag = this.calcDiag(pointerX, pointerY);
	      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
	      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
	      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
	      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
	      var rippleSize = rippleRadius * 2;
	      var left = pointerX - rippleRadius;
	      var top = pointerY - rippleRadius;
	
	      return {
	        directionInvariant: true,
	        height: rippleSize,
	        width: rippleSize,
	        top: top,
	        left: left
	      };
	    }
	  }, {
	    key: 'calcDiag',
	    value: function calcDiag(a, b) {
	      return Math.sqrt(a * a + b * b);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          style = _props.style;
	      var _state = this.state,
	          hasRipples = _state.hasRipples,
	          ripples = _state.ripples;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var rippleGroup = void 0;
	
	      if (hasRipples) {
	        var mergedStyles = (0, _simpleAssign2.default)({
	          height: '100%',
	          width: '100%',
	          position: 'absolute',
	          top: 0,
	          left: 0,
	          overflow: 'hidden',
	          pointerEvents: 'none',
	          zIndex: 1 // This is also needed so that ripples do not bleed past a parent border radius.
	        }, style);
	
	        rippleGroup = _react2.default.createElement(
	          _TransitionGroup2.default,
	          { style: prepareStyles(mergedStyles) },
	          ripples
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onMouseUp: this.handleMouseUp,
	          onMouseDown: this.handleMouseDown,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart,
	          onTouchEnd: this.handleTouchEnd
	        },
	        rippleGroup,
	        children
	      );
	    }
	  }]);
	  return TouchRipple;
	}(_react.Component);
	
	TouchRipple.defaultProps = {
	  abortOnScroll: true
	};
	TouchRipple.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TouchRipple.propTypes =  false ? {
	  abortOnScroll: _propTypes2.default.bool,
	  centerRipple: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  color: _propTypes2.default.string,
	  opacity: _propTypes2.default.number,
	  style: _propTypes2.default.object
	} : {};
	exports.default = TouchRipple;

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }
	
	function _typeof(obj) {
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return _typeof2(obj);
	    };
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
	    };
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setStatic = __webpack_require__(1584);
	
	var _setStatic2 = _interopRequireDefault(_setStatic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setDisplayName = function setDisplayName(displayName) {
	  return (0, _setStatic2.default)('displayName', displayName);
	};
	
	exports.default = setDisplayName;

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getDisplayName = __webpack_require__(1583);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
	};
	
	exports.default = wrapDisplayName;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(266);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.default = getMuiTheme;
	
	var _lodash = __webpack_require__(1360);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _colorManipulator = __webpack_require__(187);
	
	var _lightBaseTheme = __webpack_require__(1587);
	
	var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);
	
	var _zIndex = __webpack_require__(1589);
	
	var _zIndex2 = _interopRequireDefault(_zIndex);
	
	var _autoprefixer = __webpack_require__(1617);
	
	var _autoprefixer2 = _interopRequireDefault(_autoprefixer);
	
	var _callOnce = __webpack_require__(1620);
	
	var _callOnce2 = _interopRequireDefault(_callOnce);
	
	var _rtl = __webpack_require__(1621);
	
	var _rtl2 = _interopRequireDefault(_rtl);
	
	var _compose = __webpack_require__(1582);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _typography = __webpack_require__(776);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _colors = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get the MUI theme corresponding to a base theme.
	 * It's possible to override the computed theme values
	 * by providing a second argument. The calculated
	 * theme will be deeply merged with the second argument.
	 */
	function getMuiTheme(muiTheme) {
	  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    more[_key - 1] = arguments[_key];
	  }
	
	  muiTheme = _lodash2.default.apply(undefined, [{
	    zIndex: _zIndex2.default,
	    isRtl: false,
	    userAgent: undefined
	  }, _lightBaseTheme2.default, muiTheme].concat(more));
	
	  var _muiTheme = muiTheme,
	      spacing = _muiTheme.spacing,
	      fontFamily = _muiTheme.fontFamily,
	      palette = _muiTheme.palette;
	
	  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };
	
	  muiTheme = (0, _lodash2.default)({
	    appBar: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      height: spacing.desktopKeylineIncrement,
	      titleFontWeight: _typography2.default.fontWeightNormal,
	      padding: spacing.desktopGutter
	    },
	    avatar: {
	      color: palette.canvasColor,
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.26)
	    },
	    badge: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    bottomNavigation: {
	      backgroundColor: palette.canvasColor,
	      unselectedColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      selectedColor: palette.primary1Color,
	      height: 56,
	      unselectedFontSize: 12,
	      selectedFontSize: 14
	    },
	    button: {
	      height: 36,
	      minWidth: 88,
	      iconButtonSize: spacing.iconSize * 2
	    },
	    card: {
	      titleColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      subtitleColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    cardMedia: {
	      color: _colors.darkWhite,
	      overlayContentBackground: _colors.lightBlack,
	      titleColor: _colors.darkWhite,
	      subtitleColor: _colors.lightWhite
	    },
	    cardText: {
	      textColor: palette.textColor
	    },
	    checkbox: {
	      boxColor: palette.textColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    chip: {
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12),
	      deleteIconColor: (0, _colorManipulator.fade)(palette.textColor, 0.26),
	      textColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      fontSize: 14,
	      fontWeight: _typography2.default.fontWeightNormal,
	      shadow: '0 1px 6px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12)
	    },
	    datePicker: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      calendarTextColor: palette.textColor,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor,
	      calendarYearBackgroundColor: palette.canvasColor,
	      headerColor: palette.pickerHeaderColor || palette.primary1Color
	    },
	    dialog: {
	      titleFontSize: 22,
	      bodyFontSize: 16,
	      bodyColor: (0, _colorManipulator.fade)(palette.textColor, 0.6)
	    },
	    dropDownMenu: {
	      accentColor: palette.borderColor
	    },
	    enhancedButton: {
	      tapHighlightColor: _colors.transparent
	    },
	    flatButton: {
	      color: _colors.transparent,
	      buttonFilterColor: '#999999',
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      textColor: palette.textColor,
	      primaryTextColor: palette.primary1Color,
	      secondaryTextColor: palette.accent1Color,
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    floatingActionButton: {
	      buttonSize: 56,
	      miniSize: 40,
	      color: palette.primary1Color,
	      iconColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryIconColor: palette.alternateTextColor,
	      disabledTextColor: palette.disabledColor,
	      disabledColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12)
	    },
	    gridTile: {
	      textColor: _colors.white
	    },
	    icon: {
	      color: palette.canvasColor,
	      backgroundColor: palette.primary1Color
	    },
	    inkBar: {
	      backgroundColor: palette.accent1Color
	    },
	    drawer: {
	      width: spacing.desktopKeylineIncrement * 4,
	      color: palette.canvasColor
	    },
	    listItem: {
	      nestedLevelDepth: 18,
	      secondaryTextColor: palette.secondaryTextColor,
	      leftIconColor: _colors.grey600,
	      rightIconColor: _colors.grey600
	    },
	    menu: {
	      backgroundColor: palette.canvasColor,
	      containerBackgroundColor: palette.canvasColor
	    },
	    menuItem: {
	      dataHeight: 32,
	      height: 48,
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1),
	      padding: spacing.desktopGutter,
	      selectedTextColor: palette.accent1Color,
	      rightIconDesktopFill: _colors.grey600
	    },
	    menuSubheader: {
	      padding: spacing.desktopGutter,
	      borderColor: palette.borderColor,
	      textColor: palette.primary1Color
	    },
	    overlay: {
	      backgroundColor: _colors.lightBlack
	    },
	    paper: {
	      color: palette.textColor,
	      backgroundColor: palette.canvasColor,
	      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
	        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[5]);
	      })
	    },
	    radioButton: {
	      borderColor: palette.textColor,
	      backgroundColor: palette.alternateTextColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      size: 24,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    raisedButton: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      disabledColor: (0, _colorManipulator.darken)(palette.alternateTextColor, 0.1),
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    refreshIndicator: {
	      strokeColor: palette.borderColor,
	      loadingStrokeColor: palette.primary1Color
	    },
	    ripple: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.87)
	    },
	    slider: {
	      trackSize: 2,
	      trackColor: palette.primary3Color,
	      trackColorSelected: palette.accent3Color,
	      handleSize: 12,
	      handleSizeDisabled: 8,
	      handleSizeActive: 18,
	      handleColorZero: palette.primary3Color,
	      handleFillColor: palette.alternateTextColor,
	      selectionColor: palette.primary1Color,
	      rippleColor: palette.primary1Color
	    },
	    snackbar: {
	      textColor: palette.alternateTextColor,
	      backgroundColor: palette.textColor,
	      actionColor: palette.accent1Color
	    },
	    subheader: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    stepper: {
	      backgroundColor: 'transparent',
	      hoverBackgroundColor: (0, _colorManipulator.fade)(_colors.black, 0.06),
	      iconColor: palette.primary1Color,
	      hoveredIconColor: _colors.grey700,
	      inactiveIconColor: _colors.grey500,
	      textColor: (0, _colorManipulator.fade)(_colors.black, 0.87),
	      disabledTextColor: (0, _colorManipulator.fade)(_colors.black, 0.26),
	      connectorLineColor: _colors.grey400
	    },
	    svgIcon: {
	      color: palette.textColor
	    },
	    table: {
	      backgroundColor: palette.canvasColor
	    },
	    tableFooter: {
	      borderColor: palette.borderColor,
	      textColor: palette.accent3Color
	    },
	    tableHeader: {
	      borderColor: palette.borderColor
	    },
	    tableHeaderColumn: {
	      textColor: palette.accent3Color,
	      height: 56,
	      spacing: 24
	    },
	    tableRow: {
	      hoverColor: palette.accent2Color,
	      stripeColor: (0, _colorManipulator.fade)((0, _colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
	      selectedColor: palette.borderColor,
	      textColor: palette.textColor,
	      borderColor: palette.borderColor,
	      height: 48
	    },
	    tableRowColumn: {
	      height: 48,
	      spacing: 24
	    },
	    tabs: {
	      backgroundColor: palette.primary1Color,
	      textColor: (0, _colorManipulator.fade)(palette.alternateTextColor, 0.7),
	      selectedTextColor: palette.alternateTextColor
	    },
	    textField: {
	      textColor: palette.textColor,
	      hintColor: palette.disabledColor,
	      floatingLabelColor: palette.disabledColor,
	      disabledTextColor: palette.disabledColor,
	      errorColor: _colors.red500,
	      focusColor: palette.primary1Color,
	      backgroundColor: 'transparent',
	      borderColor: palette.borderColor
	    },
	    timePicker: {
	      color: palette.alternateTextColor,
	      textColor: palette.alternateTextColor,
	      accentColor: palette.primary1Color,
	      clockColor: palette.textColor,
	      clockCircleColor: palette.clockCircleColor,
	      headerColor: palette.pickerHeaderColor || palette.primary1Color,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor
	    },
	    toggle: {
	      thumbOnColor: palette.primary1Color,
	      thumbOffColor: palette.accent2Color,
	      thumbDisabledColor: palette.borderColor,
	      thumbRequiredColor: palette.primary1Color,
	      trackOnColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5),
	      trackOffColor: palette.primary3Color,
	      trackDisabledColor: palette.primary3Color,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor,
	      trackRequiredColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5)
	    },
	    toolbar: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      backgroundColor: (0, _colorManipulator.darken)(palette.accent2Color, 0.05),
	      height: 56,
	      titleFontSize: 20,
	      iconColor: (0, _colorManipulator.fade)(palette.textColor, 0.4),
	      separatorColor: (0, _colorManipulator.fade)(palette.textColor, 0.175),
	      menuHoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1)
	    },
	    tooltip: {
	      color: _colors.white,
	      rippleBackgroundColor: _colors.grey700,
	      opacity: 0.9
	    }
	  }, muiTheme, {
	    baseTheme: baseTheme, // To provide backward compatibility.
	    rawTheme: baseTheme // To provide backward compatibility.
	  });
	
	  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
	    return t(muiTheme);
	  }).filter(function (t) {
	    return t;
	  });
	
	  muiTheme.prepareStyles = _compose2.default.apply(undefined, (0, _toConsumableArray3.default)(transformers));
	
	  return muiTheme;
	}

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _colors = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Typography = function Typography() {
	  (0, _classCallCheck3.default)(this, Typography);
	
	  // text colors
	  this.textFullBlack = _colors.fullBlack;
	  this.textDarkBlack = _colors.darkBlack;
	  this.textLightBlack = _colors.lightBlack;
	  this.textMinBlack = _colors.minBlack;
	  this.textFullWhite = _colors.fullWhite;
	  this.textDarkWhite = _colors.darkWhite;
	  this.textLightWhite = _colors.lightWhite;
	
	  // font weight
	  this.fontWeightLight = 300;
	  this.fontWeightNormal = 400;
	  this.fontWeightMedium = 500;
	
	  this.fontStyleButtonFontSize = 14;
	};
	
	exports.default = new Typography();

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHistory = function ActionHistory(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z' })
	  );
	};
	ActionHistory = (0, _pure2.default)(ActionHistory);
	ActionHistory.displayName = 'ActionHistory';
	ActionHistory.muiName = 'SvgIcon';
	
	exports.default = ActionHistory;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileFileDownload = function FileFileDownload(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z' })
	  );
	};
	FileFileDownload = (0, _pure2.default)(FileFileDownload);
	FileFileDownload.displayName = 'FileFileDownload';
	FileFileDownload.muiName = 'SvgIcon';
	
	exports.default = FileFileDownload;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronLeft = function NavigationChevronLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
	  );
	};
	NavigationChevronLeft = (0, _pure2.default)(NavigationChevronLeft);
	NavigationChevronLeft.displayName = 'NavigationChevronLeft';
	NavigationChevronLeft.muiName = 'SvgIcon';
	
	exports.default = NavigationChevronLeft;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronRight = function NavigationChevronRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
	  );
	};
	NavigationChevronRight = (0, _pure2.default)(NavigationChevronRight);
	NavigationChevronRight.displayName = 'NavigationChevronRight';
	NavigationChevronRight.muiName = 'SvgIcon';
	
	exports.default = NavigationChevronRight;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandLess = function NavigationExpandLess(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z' })
	  );
	};
	NavigationExpandLess = (0, _pure2.default)(NavigationExpandLess);
	NavigationExpandLess.displayName = 'NavigationExpandLess';
	NavigationExpandLess.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandLess;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandMore = function NavigationExpandMore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' })
	  );
	};
	NavigationExpandMore = (0, _pure2.default)(NavigationExpandMore);
	NavigationExpandMore.displayName = 'NavigationExpandMore';
	NavigationExpandMore.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandMore;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.extendChildren = extendChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function extendChildren(children, extendedProps, extendedChildren) {
	  return _react2.default.Children.map(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return child;
	    }
	
	    var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;
	
	    var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;
	
	    return _react2.default.cloneElement(child, newProps, newChildren);
	  });
	}

/***/ }),
/* 784 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  isDescendant: function isDescendant(parent, child) {
	    var node = child.parentNode;
	
	    while (node !== null) {
	      if (node === parent) return true;
	      node = node.parentNode;
	    }
	
	    return false;
	  },
	  offset: function offset(el) {
	    var rect = el.getBoundingClientRect();
	    return {
	      top: rect.top + document.body.scrollTop,
	      left: rect.left + document.body.scrollLeft
	    };
	  }
	};

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(1639);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 786 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 787 */
/***/ (function(module, exports) {

	module.exports = {
		L : 1,
		M : 0,
		Q : 3,
		H : 2
	};
	


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	var math = __webpack_require__(789);
	
	function QRPolynomial(num, shift) {
	
		if (num.length == undefined) {
			throw new Error(num.length + "/" + shift);
		}
	
		var offset = 0;
	
		while (offset < num.length && num[offset] == 0) {
			offset++;
		}
	
		this.num = new Array(num.length - offset + shift);
		for (var i = 0; i < num.length - offset; i++) {
			this.num[i] = num[i + offset];
		}
	}
	
	QRPolynomial.prototype = {
	
		get : function(index) {
			return this.num[index];
		},
		
		getLength : function() {
			return this.num.length;
		},
		
		multiply : function(e) {
		
			var num = new Array(this.getLength() + e.getLength() - 1);
		
			for (var i = 0; i < this.getLength(); i++) {
				for (var j = 0; j < e.getLength(); j++) {
					num[i + j] ^= math.gexp(math.glog(this.get(i) ) + math.glog(e.get(j) ) );
				}
			}
		
			return new QRPolynomial(num, 0);
		},
		
		mod : function(e) {
		
			if (this.getLength() - e.getLength() < 0) {
				return this;
			}
		
			var ratio = math.glog(this.get(0) ) - math.glog(e.get(0) );
		
			var num = new Array(this.getLength() );
			
			for (var i = 0; i < this.getLength(); i++) {
				num[i] = this.get(i);
			}
			
			for (var i = 0; i < e.getLength(); i++) {
				num[i] ^= math.gexp(math.glog(e.get(i) ) + ratio);
			}
		
			// recursive call
			return new QRPolynomial(num, 0).mod(e);
		}
	};
	
	module.exports = QRPolynomial;


/***/ }),
/* 789 */
/***/ (function(module, exports) {

	var QRMath = {
	
		glog : function(n) {
		
			if (n < 1) {
				throw new Error("glog(" + n + ")");
			}
			
			return QRMath.LOG_TABLE[n];
		},
		
		gexp : function(n) {
		
			while (n < 0) {
				n += 255;
			}
		
			while (n >= 256) {
				n -= 255;
			}
		
			return QRMath.EXP_TABLE[n];
		},
		
		EXP_TABLE : new Array(256),
		
		LOG_TABLE : new Array(256)
	
	};
		
	for (var i = 0; i < 8; i++) {
		QRMath.EXP_TABLE[i] = 1 << i;
	}
	for (var i = 8; i < 256; i++) {
		QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
			^ QRMath.EXP_TABLE[i - 5]
			^ QRMath.EXP_TABLE[i - 6]
			^ QRMath.EXP_TABLE[i - 8];
	}
	for (var i = 0; i < 255; i++) {
		QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
	}
	
	module.exports = QRMath;


/***/ }),
/* 790 */
/***/ (function(module, exports) {

	module.exports = {
		MODE_NUMBER :		1 << 0,
		MODE_ALPHA_NUM : 	1 << 1,
		MODE_8BIT_BYTE : 	1 << 2,
		MODE_KANJI :		1 << 3
	};


/***/ }),
/* 791 */
/***/ (function(module, exports) {

	// Load modules
	
	
	// Declare internals
	
	var internals = {};
	
	
	exports.arrayToObject = function (source) {
	
	    var obj = {};
	    for (var i = 0, il = source.length; i < il; ++i) {
	        if (typeof source[i] !== 'undefined') {
	
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	
	exports.merge = function (target, source) {
	
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        }
	        else {
	            target[source] = true;
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        target = [target].concat(source);
	        return target;
	    }
	
	    if (Array.isArray(target) &&
	        !Array.isArray(source)) {
	
	        target = exports.arrayToObject(target);
	    }
	
	    var keys = Object.keys(source);
	    for (var k = 0, kl = keys.length; k < kl; ++k) {
	        var key = keys[k];
	        var value = source[key];
	
	        if (!target[key]) {
	            target[key] = value;
	        }
	        else {
	            target[key] = exports.merge(target[key], value);
	        }
	    }
	
	    return target;
	};
	
	
	exports.decode = function (str) {
	
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	
	exports.compact = function (obj, refs) {
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return obj;
	    }
	
	    refs = refs || [];
	    var lookup = refs.indexOf(obj);
	    if (lookup !== -1) {
	        return refs[lookup];
	    }
	
	    refs.push(obj);
	
	    if (Array.isArray(obj)) {
	        var compacted = [];
	
	        for (var i = 0, il = obj.length; i < il; ++i) {
	            if (typeof obj[i] !== 'undefined') {
	                compacted.push(obj[i]);
	            }
	        }
	
	        return compacted;
	    }
	
	    var keys = Object.keys(obj);
	    for (i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        obj[key] = exports.compact(obj[key], refs);
	    }
	
	    return obj;
	};
	
	
	exports.isRegExp = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	
	exports.isBuffer = function (obj) {
	
	    if (obj === null ||
	        typeof obj === 'undefined') {
	
	        return false;
	    }
	
	    return !!(obj.constructor &&
	        obj.constructor.isBuffer &&
	        obj.constructor.isBuffer(obj));
	};


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1636)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(154);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * If set to true, renders `span` instead of `a`
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * `href` attribute for the inner `a` element
	   */
	  href: _propTypes2.default.string,
	  /**
	   * `title` attribute for the inner `a` element
	   */
	  title: _propTypes2.default.node,
	  /**
	   * `target` attribute for the inner `a` element
	   */
	  target: _propTypes2.default.string
	};
	
	var defaultProps = {
	  active: false
	};
	
	var BreadcrumbItem = function (_React$Component) {
	  (0, _inherits3.default)(BreadcrumbItem, _React$Component);
	
	  function BreadcrumbItem() {
	    (0, _classCallCheck3.default)(this, BreadcrumbItem);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  BreadcrumbItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        href = _props.href,
	        title = _props.title,
	        target = _props.target,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['active', 'href', 'title', 'target', 'className']);
	
	    // Don't try to render these props on non-active <span>.
	
	    var linkProps = { href: href, title: title, target: target };
	
	    return _react2.default.createElement(
	      'li',
	      { className: (0, _classnames2.default)(className, { active: active }) },
	      active ? _react2.default.createElement('span', props) : _react2.default.createElement(_SafeAnchor2.default, (0, _extends3.default)({}, props, linkProps))
	    );
	  };
	
	  return BreadcrumbItem;
	}(_react2.default.Component);
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	
	exports.default = BreadcrumbItem;
	module.exports = exports['default'];

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionEvents = __webpack_require__(1710);
	
	var _TransitionEvents2 = _interopRequireDefault(_TransitionEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: This should use a timeout instead of TransitionEvents, or else just
	// not wait until transition end to trigger continuing animations.
	
	var propTypes = {
	  direction: _propTypes2.default.oneOf(['prev', 'next']),
	  onAnimateOutEnd: _propTypes2.default.func,
	  active: _propTypes2.default.bool,
	  animateIn: _propTypes2.default.bool,
	  animateOut: _propTypes2.default.bool,
	  index: _propTypes2.default.number
	};
	
	var defaultProps = {
	  active: false,
	  animateIn: false,
	  animateOut: false
	};
	
	var CarouselItem = function (_React$Component) {
	  (0, _inherits3.default)(CarouselItem, _React$Component);
	
	  function CarouselItem(props, context) {
	    (0, _classCallCheck3.default)(this, CarouselItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);
	
	    _this.state = {
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.active !== nextProps.active) {
	      this.setState({ direction: null });
	    }
	  };
	
	  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    var active = this.props.active;
	
	    var prevActive = prevProps.active;
	
	    if (!active && prevActive) {
	      _TransitionEvents2.default.addEndEventListener(_reactDom2.default.findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (active !== prevActive) {
	      setTimeout(function () {
	        return _this2.startAnimation();
	      }, 20);
	    }
	  };
	
	  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    if (this.props.onAnimateOutEnd) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  };
	
	  CarouselItem.prototype.startAnimation = function startAnimation() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  };
	
	  CarouselItem.prototype.render = function render() {
	    var _props = this.props,
	        direction = _props.direction,
	        active = _props.active,
	        animateIn = _props.animateIn,
	        animateOut = _props.animateOut,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);
	
	
	    delete props.onAnimateOutEnd;
	    delete props.index;
	
	    var classes = {
	      item: true,
	      active: active && !animateIn || animateOut
	    };
	    if (direction && active && animateIn) {
	      classes[direction] = true;
	    }
	    if (this.state.direction && (animateIn || animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, props, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return CarouselItem;
	}(_react2.default.Component);
	
	CarouselItem.propTypes = propTypes;
	CarouselItem.defaultProps = defaultProps;
	
	exports.default = CarouselItem;
	module.exports = exports['default'];

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(292);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SafeAnchor = __webpack_require__(154);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  noCaret: _propTypes2.default.bool,
	  open: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  useAnchor: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	var DropdownToggle = function (_React$Component) {
	  (0, _inherits3.default)(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    (0, _classCallCheck3.default)(this, DropdownToggle);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownToggle.prototype.render = function render() {
	    var _props = this.props,
	        noCaret = _props.noCaret,
	        open = _props.open,
	        useAnchor = _props.useAnchor,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);
	
	
	    delete props.bsRole;
	
	    var Component = useAnchor ? _SafeAnchor2.default : _Button2.default;
	    var useCaret = !noCaret;
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    // FIXME: Should this really fall back to `title` as children?
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends3.default)({}, props, {
	        role: 'button',
	        className: (0, _classnames2.default)(className, bsClass),
	        'aria-haspopup': true,
	        'aria-expanded': open
	      }),
	      children || props.title,
	      useCaret && ' ',
	      useCaret && _react2.default.createElement('span', { className: 'caret' })
	    );
	  };
	
	  return DropdownToggle;
	}(_react2.default.Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);
	module.exports = exports['default'];

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Turn any fixed-width grid layout into a full-width layout by this property.
	   *
	   * Adds `container-fluid` class.
	   */
	  fluid: _propTypes2.default.bool,
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  fluid: false
	};
	
	var Grid = function (_React$Component) {
	  (0, _inherits3.default)(Grid, _React$Component);
	
	  function Grid() {
	    (0, _classCallCheck3.default)(this, Grid);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Grid.prototype.render = function render() {
	    var _props = this.props,
	        fluid = _props.fluid,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['fluid', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.prefix)(bsProps, fluid && 'fluid');
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Grid;
	}(_react2.default.Component);
	
	Grid.propTypes = propTypes;
	Grid.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('container', Grid);
	module.exports = exports['default'];

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(223);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _StyleConfig = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  active: _propTypes2.default.any,
	  disabled: _propTypes2.default.any,
	  header: _propTypes2.default.node,
	  listItem: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  href: _propTypes2.default.string,
	  type: _propTypes2.default.string
	};
	
	var defaultProps = {
	  listItem: false
	};
	
	var ListGroupItem = function (_React$Component) {
	  (0, _inherits3.default)(ListGroupItem, _React$Component);
	
	  function ListGroupItem() {
	    (0, _classCallCheck3.default)(this, ListGroupItem);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
	    if (_react2.default.isValidElement(header)) {
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2.default)(header.props.className, headingClassName)
	      });
	    }
	
	    return _react2.default.createElement(
	      'h4',
	      { className: headingClassName },
	      header
	    );
	  };
	
	  ListGroupItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        className = _props.className,
	        header = _props.header,
	        listItem = _props.listItem,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active,
	      disabled: disabled
	    });
	
	    var Component = void 0;
	
	    if (elementProps.href) {
	      Component = 'a';
	    } else if (elementProps.onClick) {
	      Component = 'button';
	      elementProps.type = elementProps.type || 'button';
	    } else if (listItem) {
	      Component = 'li';
	    } else {
	      Component = 'span';
	    }
	
	    elementProps.className = (0, _classnames2.default)(className, classes);
	
	    // TODO: Deprecate `header` prop.
	    if (header) {
	      return _react2.default.createElement(
	        Component,
	        elementProps,
	        this.renderHeader(header, (0, _bootstrapUtils.prefix)(bsProps, 'heading')),
	        _react2.default.createElement(
	          'p',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'text') },
	          children
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      Component,
	      elementProps,
	      children
	    );
	  };
	
	  return ListGroupItem;
	}(_react2.default.Component);
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('list-group-item', (0, _bootstrapUtils.bsStyles)((0, _values2.default)(_StyleConfig.State), ListGroupItem));
	module.exports = exports['default'];

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalBody = function (_React$Component) {
	  (0, _inherits3.default)(ModalBody, _React$Component);
	
	  function ModalBody() {
	    (0, _classCallCheck3.default)(this, ModalBody);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-body', ModalBody);
	module.exports = exports['default'];

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalFooter = function (_React$Component) {
	  (0, _inherits3.default)(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    (0, _classCallCheck3.default)(this, ModalFooter);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalFooter.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ModalFooter;
	}(_react2.default.Component);
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-footer', ModalFooter);
	module.exports = exports['default'];

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _createChainedFunction = __webpack_require__(90);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _CloseButton = __webpack_require__(502);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: `aria-label` should be `closeLabel`.
	
	var propTypes = {
	  /**
	   * Provides an accessible label for the close
	   * button. It is used for Assistive Technology when the label text is not
	   * readable.
	   */
	  closeLabel: _propTypes2.default.string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _propTypes2.default.bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside
	   * a Modal component, the onHide will automatically be propagated up to the
	   * parent Modal `onHide`.
	   */
	  onHide: _propTypes2.default.func
	};
	
	var defaultProps = {
	  closeLabel: 'Close',
	  closeButton: false
	};
	
	var contextTypes = {
	  $bs_modal: _propTypes2.default.shape({
	    onHide: _propTypes2.default.func
	  })
	};
	
	var ModalHeader = function (_React$Component) {
	  (0, _inherits3.default)(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    (0, _classCallCheck3.default)(this, ModalHeader);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props,
	        closeLabel = _props.closeLabel,
	        closeButton = _props.closeButton,
	        onHide = _props.onHide,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['closeLabel', 'closeButton', 'onHide', 'className', 'children']);
	
	
	    var modal = this.context.$bs_modal;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      closeButton && _react2.default.createElement(_CloseButton2.default, {
	        label: closeLabel,
	        onClick: (0, _createChainedFunction2.default)(modal && modal.onHide, onHide)
	      }),
	      children
	    );
	  };
	
	  return ModalHeader;
	}(_react2.default.Component);
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	ModalHeader.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-header', ModalHeader);
	module.exports = exports['default'];

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var ModalTitle = function (_React$Component) {
	  (0, _inherits3.default)(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    (0, _classCallCheck3.default)(this, ModalTitle);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalTitle.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ModalTitle;
	}(_react2.default.Component);
	
	ModalTitle.propTypes = propTypes;
	ModalTitle.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-title', ModalTitle);
	module.exports = exports['default'];

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(99);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(368);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _createChainedFunction = __webpack_require__(90);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(108);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
	
	// TODO: This `bsStyle` is very unlike the others. Should we rename it?
	
	// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
	// Consider renaming or replacing them.
	
	var propTypes = {
	  /**
	   * Marks the NavItem with a matching `eventKey` as active. Has a
	   * higher precedence over `activeHref`.
	   */
	  activeKey: _propTypes2.default.any,
	
	  /**
	   * Marks the child NavItem with a matching `href` prop as active.
	   */
	  activeHref: _propTypes2.default.string,
	
	  /**
	   * NavItems are be positioned vertically.
	   */
	  stacked: _propTypes2.default.bool,
	
	  justified: (0, _all2.default)(_propTypes2.default.bool, function (_ref) {
	    var justified = _ref.justified,
	        navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	
	  /**
	   * A callback fired when a NavItem is selected.
	   *
	   * ```js
	   * function (
	   *  Any eventKey,
	   *  SyntheticEvent event?
	   * )
	   * ```
	   */
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * ARIA role for the Nav, in the context of a TabContainer, the default will
	   * be set to "tablist", but can be overridden by the Nav when set explicitly.
	   *
	   * When the role is set to "tablist" NavItem focus is managed according to
	   * the ARIA authoring practices for tabs:
	   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
	   */
	  role: _propTypes2.default.string,
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _propTypes2.default.bool,
	
	  /**
	   * Float the Nav to the right. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullRight: _propTypes2.default.bool,
	
	  /**
	   * Float the Nav to the left. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullLeft: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    onSelect: _propTypes2.default.func
	  }),
	
	  $bs_tabContainer: _propTypes2.default.shape({
	    activeKey: _propTypes2.default.any,
	    onSelect: _propTypes2.default.func.isRequired,
	    getTabId: _propTypes2.default.func.isRequired,
	    getPaneId: _propTypes2.default.func.isRequired
	  })
	};
	
	var Nav = function (_React$Component) {
	  (0, _inherits3.default)(Nav, _React$Component);
	
	  function Nav() {
	    (0, _classCallCheck3.default)(this, Nav);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    if (!this._needsRefocus) {
	      return;
	    }
	
	    this._needsRefocus = false;
	
	    var children = this.props.children;
	
	    var _getActiveProps = this.getActiveProps(),
	        activeKey = _getActiveProps.activeKey,
	        activeHref = _getActiveProps.activeHref;
	
	    var activeChild = _ValidComponentChildren2.default.find(children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    });
	
	    var childrenArray = _ValidComponentChildren2.default.toArray(children);
	    var activeChildIndex = childrenArray.indexOf(activeChild);
	
	    var childNodes = _reactDom2.default.findDOMNode(this).children;
	    var activeNode = childNodes && childNodes[activeChildIndex];
	
	    if (!activeNode || !activeNode.firstChild) {
	      return;
	    }
	
	    activeNode.firstChild.focus();
	  };
	
	  Nav.prototype.getActiveProps = function getActiveProps() {
	    var tabContainer = this.context.$bs_tabContainer;
	
	    if (tabContainer) {
	       false ? (0, _warning2.default)(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;
	
	      return tabContainer;
	    }
	
	    return this.props;
	  };
	
	  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
	    var _this3 = this;
	
	    var children = this.props.children;
	
	    var validChildren = children.filter(function (child) {
	      return child.props.eventKey != null && !child.props.disabled;
	    });
	
	    var _getActiveProps2 = this.getActiveProps(),
	        activeKey = _getActiveProps2.activeKey,
	        activeHref = _getActiveProps2.activeHref;
	
	    var activeChild = _ValidComponentChildren2.default.find(children, function (child) {
	      return _this3.isActive(child, activeKey, activeHref);
	    });
	
	    // This assumes the active child is not disabled.
	    var activeChildIndex = validChildren.indexOf(activeChild);
	    if (activeChildIndex === -1) {
	      // Something has gone wrong. Select the first valid child we can find.
	      return validChildren[0];
	    }
	
	    var nextIndex = activeChildIndex + offset;
	    var numValidChildren = validChildren.length;
	
	    if (nextIndex >= numValidChildren) {
	      nextIndex = 0;
	    } else if (nextIndex < 0) {
	      nextIndex = numValidChildren - 1;
	    }
	
	    return validChildren[nextIndex];
	  };
	
	  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
	    var _this4 = this;
	
	    if (!tabContainer && navRole !== 'tablist') {
	      // No tab props here.
	      return null;
	    }
	
	    var _child$props = child.props,
	        id = _child$props.id,
	        controls = _child$props['aria-controls'],
	        eventKey = _child$props.eventKey,
	        role = _child$props.role,
	        onKeyDown = _child$props.onKeyDown,
	        tabIndex = _child$props.tabIndex;
	
	
	    if (tabContainer) {
	       false ? (0, _warning2.default)(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      id = tabContainer.getTabId(eventKey);
	      controls = tabContainer.getPaneId(eventKey);
	    }
	
	    if (navRole === 'tablist') {
	      role = role || 'tab';
	      onKeyDown = (0, _createChainedFunction2.default)(function (event) {
	        return _this4.handleTabKeyDown(onSelect, event);
	      }, onKeyDown);
	      tabIndex = active ? tabIndex : -1;
	    }
	
	    return {
	      id: id,
	      role: role,
	      onKeyDown: onKeyDown,
	      'aria-controls': controls,
	      tabIndex: tabIndex
	    };
	  };
	
	  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
	    var nextActiveChild = void 0;
	
	    switch (event.keyCode) {
	      case _keycode2.default.codes.left:
	      case _keycode2.default.codes.up:
	        nextActiveChild = this.getNextActiveChild(-1);
	        break;
	      case _keycode2.default.codes.right:
	      case _keycode2.default.codes.down:
	        nextActiveChild = this.getNextActiveChild(1);
	        break;
	      default:
	        // It was a different key; don't handle this keypress.
	        return;
	    }
	
	    event.preventDefault();
	
	    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
	      onSelect(nextActiveChild.props.eventKey);
	    }
	
	    this._needsRefocus = true;
	  };
	
	  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
	    var props = _ref2.props;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  Nav.prototype.render = function render() {
	    var _extends2,
	        _this5 = this;
	
	    var _props = this.props,
	        stacked = _props.stacked,
	        justified = _props.justified,
	        onSelect = _props.onSelect,
	        propsRole = _props.role,
	        propsNavbar = _props.navbar,
	        pullRight = _props.pullRight,
	        pullLeft = _props.pullLeft,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);
	
	
	    var tabContainer = this.context.$bs_tabContainer;
	    var role = propsRole || (tabContainer ? 'tablist' : null);
	
	    var _getActiveProps3 = this.getActiveProps(),
	        activeKey = _getActiveProps3.activeKey,
	        activeHref = _getActiveProps3.activeHref;
	
	    delete props.activeKey; // Accessed via this.getActiveProps().
	    delete props.activeHref; // Accessed via this.getActiveProps().
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'stacked')] = stacked, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2));
	
	    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
	    var pullLeftClassName = void 0;
	    var pullRightClassName = void 0;
	
	    if (navbar) {
	      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	      classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;
	
	      pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
	      pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
	    } else {
	      pullRightClassName = 'pull-right';
	      pullLeftClassName = 'pull-left';
	    }
	
	    classes[pullRightClassName] = pullRight;
	    classes[pullLeftClassName] = pullLeft;
	
	    return _react2.default.createElement(
	      'ul',
	      (0, _extends4.default)({}, elementProps, {
	        role: role,
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        var active = _this5.isActive(child, activeKey, activeHref);
	        var childOnSelect = (0, _createChainedFunction2.default)(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
	
	        return (0, _react.cloneElement)(child, (0, _extends4.default)({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
	          active: active,
	          activeKey: activeKey,
	          activeHref: activeHref,
	          onSelect: childOnSelect
	        }));
	      })
	    );
	  };
	
	  return Nav;
	}(_react2.default.Component);
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	Nav.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));
	module.exports = exports['default'];

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(154);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(90);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  active: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  href: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  eventKey: _propTypes2.default.any
	};
	
	var defaultProps = {
	  active: false,
	  disabled: false
	};
	
	var NavItem = function (_React$Component) {
	  (0, _inherits3.default)(NavItem, _React$Component);
	
	  function NavItem(props, context) {
	    (0, _classCallCheck3.default)(this, NavItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  NavItem.prototype.handleClick = function handleClick(e) {
	    if (this.props.onSelect) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, e);
	      }
	    }
	  };
	
	  NavItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        onClick = _props.onClick,
	        className = _props.className,
	        style = _props.style,
	        props = (0, _objectWithoutProperties3.default)(_props, ['active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    // These are injected down by `<Nav>` for building `<SubNav>`s.
	    delete props.activeKey;
	    delete props.activeHref;
	
	    if (!props.role) {
	      if (props.href === '#') {
	        props.role = 'button';
	      }
	    } else if (props.role === 'tab') {
	      props['aria-selected'] = active;
	    }
	
	    return _react2.default.createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2.default)(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2.default.createElement(_SafeAnchor2.default, (0, _extends3.default)({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2.default)(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return NavItem;
	}(_react2.default.Component);
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	
	exports.default = NavItem;
	module.exports = exports['default'];

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string
	  })
	};
	
	var NavbarBrand = function (_React$Component) {
	  (0, _inherits3.default)(NavbarBrand, _React$Component);
	
	  function NavbarBrand() {
	    (0, _classCallCheck3.default)(this, NavbarBrand);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarBrand.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'brand');
	
	    if (_react2.default.isValidElement(children)) {
	      return _react2.default.cloneElement(children, {
	        className: (0, _classnames2.default)(children.props.className, className, bsClassName)
	      });
	    }
	
	    return _react2.default.createElement(
	      'span',
	      (0, _extends3.default)({}, props, { className: (0, _classnames2.default)(className, bsClassName) }),
	      children
	    );
	  };
	
	  return NavbarBrand;
	}(_react2.default.Component);
	
	NavbarBrand.contextTypes = contextTypes;
	
	exports.default = NavbarBrand;
	module.exports = exports['default'];

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Overlay = __webpack_require__(1717);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(365);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Overlay2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2.default.bool,
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2.default.bool,
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Use animation
	   */
	  animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * Sets the direction of the Overlay.
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left'])
	});
	
	var defaultProps = {
	  animation: _Fade2.default,
	  rootClose: false,
	  show: false,
	  placement: 'right'
	};
	
	var Overlay = function (_React$Component) {
	  (0, _inherits3.default)(Overlay, _React$Component);
	
	  function Overlay() {
	    (0, _classCallCheck3.default)(this, Overlay);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        animation = _props.animation,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['animation', 'children']);
	
	
	    var transition = animation === true ? _Fade2.default : animation || null;
	
	    var child = void 0;
	
	    if (!transition) {
	      child = (0, _react.cloneElement)(children, {
	        className: (0, _classnames2.default)(children.props.className, 'in')
	      });
	    } else {
	      child = children;
	    }
	
	    return _react2.default.createElement(
	      _Overlay2.default,
	      (0, _extends3.default)({}, props, {
	        transition: transition
	      }),
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = propTypes;
	Overlay.defaultProps = defaultProps;
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(154);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(90);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool,
	  previous: _propTypes2.default.bool,
	  next: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  eventKey: _propTypes2.default.any
	};
	
	var defaultProps = {
	  disabled: false,
	  previous: false,
	  next: false
	};
	
	var PagerItem = function (_React$Component) {
	  (0, _inherits3.default)(PagerItem, _React$Component);
	
	  function PagerItem(props, context) {
	    (0, _classCallCheck3.default)(this, PagerItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  PagerItem.prototype.handleSelect = function handleSelect(e) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (onSelect || disabled) {
	      e.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, e);
	    }
	  };
	
	  PagerItem.prototype.render = function render() {
	    var _props2 = this.props,
	        disabled = _props2.disabled,
	        previous = _props2.previous,
	        next = _props2.next,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    return _react2.default.createElement(
	      'li',
	      {
	        className: (0, _classnames2.default)(className, { disabled: disabled, previous: previous, next: next }),
	        style: style
	      },
	      _react2.default.createElement(_SafeAnchor2.default, (0, _extends3.default)({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2.default)(onClick, this.handleSelect)
	      }))
	    );
	  };
	
	  return PagerItem;
	}(_react2.default.Component);
	
	PagerItem.propTypes = propTypes;
	PagerItem.defaultProps = defaultProps;
	
	exports.default = PagerItem;
	module.exports = exports['default'];

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _SafeAnchor = __webpack_require__(154);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(90);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: This should be `<Pagination.Item>`.
	
	// TODO: This should use `componentClass` like other components.
	
	var propTypes = {
	  componentClass: _elementType2.default,
	  className: _propTypes2.default.string,
	  eventKey: _propTypes2.default.any,
	  onSelect: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func
	};
	
	var defaultProps = {
	  componentClass: _SafeAnchor2.default,
	  active: false,
	  disabled: false
	};
	
	var PaginationButton = function (_React$Component) {
	  (0, _inherits3.default)(PaginationButton, _React$Component);
	
	  function PaginationButton(props, context) {
	    (0, _classCallCheck3.default)(this, PaginationButton);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  PaginationButton.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  PaginationButton.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['componentClass', 'active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    if (Component === _SafeAnchor2.default) {
	      // Assume that custom components want `eventKey`.
	      delete props.eventKey;
	    }
	
	    delete props.onSelect;
	
	    return _react2.default.createElement(
	      'li',
	      {
	        className: (0, _classnames2.default)(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2.default.createElement(Component, (0, _extends3.default)({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2.default)(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return PaginationButton;
	}(_react2.default.Component);
	
	PaginationButton.propTypes = propTypes;
	PaginationButton.defaultProps = defaultProps;
	
	exports.default = PaginationButton;
	module.exports = exports['default'];

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(587);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _createChainedFunction = __webpack_require__(90);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(108);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  accordion: _propTypes2.default.bool,
	  activeKey: _propTypes2.default.any,
	  defaultActiveKey: _propTypes2.default.any,
	  onSelect: _propTypes2.default.func,
	  role: _propTypes2.default.string
	};
	
	var defaultProps = {
	  accordion: false
	};
	
	// TODO: Use uncontrollable.
	
	var PanelGroup = function (_React$Component) {
	  (0, _inherits3.default)(PanelGroup, _React$Component);
	
	  function PanelGroup(props, context) {
	    (0, _classCallCheck3.default)(this, PanelGroup);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	
	    _this.state = {
	      activeKey: props.defaultActiveKey
	    };
	    return _this;
	  }
	
	  PanelGroup.prototype.handleSelect = function handleSelect(key, e) {
	    e.preventDefault();
	
	    if (this.props.onSelect) {
	      this.props.onSelect(key, e);
	    }
	
	    if (this.state.activeKey === key) {
	      key = null;
	    }
	
	    this.setState({ activeKey: key });
	  };
	
	  PanelGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        accordion = _props.accordion,
	        propsActiveKey = _props.activeKey,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['accordion', 'activeKey', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultActiveKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeKey = void 0;
	    if (accordion) {
	      activeKey = propsActiveKey != null ? propsActiveKey : this.state.activeKey;
	      elementProps.role = elementProps.role || 'tablist';
	    }
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        var childProps = {
	          bsStyle: child.props.bsStyle || bsProps.bsStyle
	        };
	
	        if (accordion) {
	          (0, _assign2.default)(childProps, {
	            headerRole: 'tab',
	            panelRole: 'tabpanel',
	            collapsible: true,
	            expanded: child.props.eventKey === activeKey,
	            onSelect: (0, _createChainedFunction2.default)(_this2.handleSelect, child.props.onSelect)
	          });
	        }
	
	        return (0, _react.cloneElement)(child, childProps);
	      })
	    );
	  };
	
	  return PanelGroup;
	}(_react2.default.Component);
	
	PanelGroup.propTypes = propTypes;
	PanelGroup.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('panel-group', PanelGroup);
	module.exports = exports['default'];

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _createChainedFunction = __webpack_require__(90);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _Fade = __webpack_require__(365);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Uniquely identify the `<TabPane>` among its siblings.
	   */
	  eventKey: _propTypes2.default.any,
	
	  /**
	   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
	   * `true` to enable the default `<Fade>` animation or any `<Transition>`
	   * component.
	   */
	  animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	
	  /** @private * */
	  id: _propTypes2.default.string,
	
	  /** @private * */
	  'aria-labelledby': _propTypes2.default.string,
	
	  /**
	   * If not explicitly specified and rendered in the context of a
	   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
	   * If otherwise not explicitly specified, `tab-pane`.
	   */
	  bsClass: _propTypes2.default.string,
	
	  /**
	   * Transition onEnter callback when animation is not `false`
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Transition onEntering callback when animation is not `false`
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Transition onEntered callback when animation is not `false`
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Transition onExit callback when animation is not `false`
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Transition onExiting callback when animation is not `false`
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Transition onExited callback when animation is not `false`
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the tab (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2.default.bool
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2.default.shape({
	    getTabId: _propTypes2.default.func,
	    getPaneId: _propTypes2.default.func
	  }),
	  $bs_tabContent: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	    activeKey: _propTypes2.default.any,
	    mountOnEnter: _propTypes2.default.bool,
	    unmountOnExit: _propTypes2.default.bool,
	    onPaneEnter: _propTypes2.default.func.isRequired,
	    onPaneExited: _propTypes2.default.func.isRequired,
	    exiting: _propTypes2.default.bool.isRequired
	  })
	};
	
	/**
	 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
	 * conflict with the top level one.
	 */
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2.default.oneOf([null])
	};
	
	var TabPane = function (_React$Component) {
	  (0, _inherits3.default)(TabPane, _React$Component);
	
	  function TabPane(props, context) {
	    (0, _classCallCheck3.default)(this, TabPane);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	
	    _this.in = false;
	    return _this;
	  }
	
	  TabPane.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_tabContainer: null
	    };
	  };
	
	  TabPane.prototype.componentDidMount = function componentDidMount() {
	    if (this.shouldBeIn()) {
	      // In lieu of the action event firing.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this.in) {
	      if (!this.shouldBeIn()) {
	        // We shouldn't be active any more. Notify the parent.
	        this.handleExited();
	      }
	    } else if (this.shouldBeIn()) {
	      // We are the active child. Notify the parent.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.in) {
	      // In lieu of the action event firing.
	      this.handleExited();
	    }
	  };
	
	  TabPane.prototype.getAnimation = function getAnimation() {
	    if (this.props.animation != null) {
	      return this.props.animation;
	    }
	
	    var tabContent = this.context.$bs_tabContent;
	    return tabContent && tabContent.animation;
	  };
	
	  TabPane.prototype.handleEnter = function handleEnter() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    this.in = tabContent.onPaneEnter(this, this.props.eventKey);
	  };
	
	  TabPane.prototype.handleExited = function handleExited() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    tabContent.onPaneExited(this);
	    this.in = false;
	  };
	
	  TabPane.prototype.isActive = function isActive() {
	    var tabContent = this.context.$bs_tabContent;
	    var activeKey = tabContent && tabContent.activeKey;
	
	    return this.props.eventKey === activeKey;
	  };
	
	  TabPane.prototype.shouldBeIn = function shouldBeIn() {
	    return this.getAnimation() && this.isActive();
	  };
	
	  TabPane.prototype.render = function render() {
	    var _props = this.props,
	        eventKey = _props.eventKey,
	        className = _props.className,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        propsMountOnEnter = _props.mountOnEnter,
	        propsUnmountOnExit = _props.unmountOnExit,
	        props = (0, _objectWithoutProperties3.default)(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);
	    var _context = this.context,
	        tabContent = _context.$bs_tabContent,
	        tabContainer = _context.$bs_tabContainer;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var active = this.isActive();
	    var animation = this.getAnimation();
	
	    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
	    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;
	
	    if (!active && !animation && unmountOnExit) {
	      return null;
	    }
	
	    var Transition = animation === true ? _Fade2.default : animation || null;
	
	    if (tabContent) {
	      bsProps.bsClass = (0, _bootstrapUtils.prefix)(tabContent, 'pane');
	    }
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active
	    });
	
	    if (tabContainer) {
	       false ? (0, _warning2.default)(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      elementProps.id = tabContainer.getPaneId(eventKey);
	      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
	    }
	
	    var pane = _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      role: 'tabpanel',
	      'aria-hidden': !active,
	      className: (0, _classnames2.default)(className, classes)
	    }));
	
	    if (Transition) {
	      var exiting = tabContent && tabContent.exiting;
	
	      return _react2.default.createElement(
	        Transition,
	        {
	          'in': active && !exiting,
	          onEnter: (0, _createChainedFunction2.default)(this.handleEnter, onEnter),
	          onEntering: onEntering,
	          onEntered: onEntered,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: (0, _createChainedFunction2.default)(this.handleExited, onExited),
	          mountOnEnter: mountOnEnter,
	          unmountOnExit: unmountOnExit
	        },
	        pane
	      );
	    }
	
	    return pane;
	  };
	
	  return TabPane;
	}(_react2.default.Component);
	
	TabPane.propTypes = propTypes;
	TabPane.contextTypes = contextTypes;
	TabPane.childContextTypes = childContextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('tab-pane', TabPane);
	module.exports = exports['default'];

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(292);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * The `<input>` `type`
	   * @type {[type]}
	   */
	  type: _propTypes2.default.oneOf(['checkbox', 'radio']),
	
	  /**
	   * The HTML input name, used to group like checkboxes or radio buttons together
	   * semantically
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * The checked state of the input, managed by `<ToggleButtonGroup>`` automatically
	   */
	  checked: _propTypes2.default.bool,
	
	  /**
	   * The disabled state of both the label and input
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * [onChange description]
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * The value of the input, and unique identifier in the ToggleButtonGroup
	   */
	  value: _propTypes2.default.any.isRequired
	};
	
	var ToggleButton = function (_React$Component) {
	  (0, _inherits3.default)(ToggleButton, _React$Component);
	
	  function ToggleButton() {
	    (0, _classCallCheck3.default)(this, ToggleButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ToggleButton.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        name = _props.name,
	        checked = _props.checked,
	        type = _props.type,
	        onChange = _props.onChange,
	        value = _props.value,
	        props = (0, _objectWithoutProperties3.default)(_props, ['children', 'name', 'checked', 'type', 'onChange', 'value']);
	
	    var disabled = props.disabled;
	
	    return _react2.default.createElement(
	      _Button2.default,
	      (0, _extends3.default)({}, props, {
	        active: !!checked,
	        componentClass: 'label'
	      }),
	      _react2.default.createElement('input', {
	        name: name,
	        type: type,
	        autoComplete: 'off',
	        value: value,
	        checked: !!checked,
	        disabled: !!disabled,
	        onChange: onChange
	      }),
	      children
	    );
	  };
	
	  return ToggleButton;
	}(_react2.default.Component);
	
	ToggleButton.propTypes = propTypes;
	
	exports.default = ToggleButton;
	module.exports = exports['default'];

/***/ }),
/* 811 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = capitalize;
	function capitalize(string) {
	  return "" + string.charAt(0).toUpperCase() + string.slice(1);
	}
	module.exports = exports["default"];

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(369);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(372);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(244);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _LegacyPortal = __webpack_require__(1714);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
	
	      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
	    }, _this.getMountNode = function () {
	      return _this._portalContainerNode;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this.setContainer();
	    this.forceUpdate(this.props.onRendered);
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.container !== this.props.container) {
	      this.setContainer(nextProps);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._portalContainerNode = null;
	  };
	
	  Portal.prototype.render = function render() {
	    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
	module.exports = exports['default'];

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _contains = __webpack_require__(234);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(815);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__(244);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.addEventListeners = function () {
	      var event = _this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(_this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);
	
	      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);
	
	      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
	    };
	
	    _this.removeEventListeners = function () {
	      if (_this.documentMouseCaptureListener) {
	        _this.documentMouseCaptureListener.remove();
	      }
	
	      if (_this.documentMouseListener) {
	        _this.documentMouseListener.remove();
	      }
	
	      if (_this.documentKeyupListener) {
	        _this.documentKeyupListener.remove();
	      }
	    };
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
	    if (!this.props.disabled) {
	      this.addEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (!this.props.disabled && prevProps.disabled) {
	      this.addEventListeners();
	    } else if (this.props.disabled && !prevProps.disabled) {
	      this.removeEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (!this.props.disabled) {
	      this.removeEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _propTypes2.default.func,
	  /**
	   * Children to render.
	   */
	  children: _propTypes2.default.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _propTypes2.default.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _on = __webpack_require__(329);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _properties = __webpack_require__(639);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecycle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.updateStatus = function () {
	      if (_this.nextStatus !== null) {
	        // nextStatus will always be ENTERING or EXITING.
	        _this.cancelNextCallback();
	        var node = _reactDom2.default.findDOMNode(_this);
	
	        if (_this.nextStatus === ENTERING) {
	          _this.props.onEnter(node);
	
	          _this.safeSetState({ status: ENTERING }, function () {
	            _this.props.onEntering(node);
	
	            _this.onTransitionEnd(node, function () {
	              _this.safeSetState({ status: ENTERED }, function () {
	                _this.props.onEntered(node);
	              });
	            });
	          });
	        } else {
	          _this.props.onExit(node);
	
	          _this.safeSetState({ status: EXITING }, function () {
	            _this.props.onExiting(node);
	
	            _this.onTransitionEnd(node, function () {
	              _this.safeSetState({ status: EXITED }, function () {
	                _this.props.onExited(node);
	              });
	            });
	          });
	        }
	
	        _this.nextStatus = null;
	      } else if (_this.props.unmountOnExit && _this.state.status === EXITED) {
	        _this.setState({ status: UNMOUNTED });
	      }
	    };
	
	    _this.cancelNextCallback = function () {
	      if (_this.nextCallback !== null) {
	        _this.nextCallback.cancel();
	        _this.nextCallback = null;
	      }
	    };
	
	    _this.safeSetState = function (nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      _this.setState(nextState, _this.setNextCallback(callback));
	    };
	
	    _this.setNextCallback = function (callback) {
	      var active = true;
	
	      _this.nextCallback = function (event) {
	        if (active) {
	          active = false;
	          _this.nextCallback = null;
	
	          callback(event);
	        }
	      };
	
	      _this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return _this.nextCallback;
	    };
	
	    _this.onTransitionEnd = function (node, handler) {
	      _this.setNextCallback(handler);
	
	      if (node) {
	        (0, _on2.default)(node, transitionEndEvent, _this.nextCallback);
	        setTimeout(_this.nextCallback, _this.props.timeout);
	      } else {
	        setTimeout(_this.nextCallback, 0);
	      }
	    };
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (props.transitionAppear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var status = this.state.status;
	
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	    Object.keys(Transition.propTypes).forEach(function (key) {
	      return delete childProps[key];
	    });
	
	    var transitionClassName = void 0;
	    if (status === EXITED) {
	      transitionClassName = this.props.exitedClassName;
	    } else if (status === ENTERING) {
	      transitionClassName = this.props.enteringClassName;
	    } else if (status === ENTERED) {
	      transitionClassName = this.props.enteredClassName;
	    } else if (status === EXITING) {
	      transitionClassName = this.props.exitingClassName;
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, _extends({}, childProps, {
	      className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	    }));
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  in: _propTypes2.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _propTypes2.default.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2.default.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _propTypes2.default.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _propTypes2.default.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _propTypes2.default.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _propTypes2.default.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _propTypes2.default.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _propTypes2.default.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports.default = Transition;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(329);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(441);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(330);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(233);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isSafari = exports.isFirefox = undefined;
	
	var _memoize = __webpack_require__(726);
	
	var _memoize2 = _interopRequireDefault(_memoize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isFirefox = exports.isFirefox = (0, _memoize2.default)(function () {
	  return (/firefox/i.test(navigator.userAgent)
	  );
	});
	var isSafari = exports.isSafari = (0, _memoize2.default)(function () {
	  return Boolean(window.safari);
	});

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.unpackBackendForEs5Users = exports.createChildContext = exports.CHILD_CONTEXT_TYPES = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = DragDropContext;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dndCore = __webpack_require__(1166);
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _hoistNonReactStatics = __webpack_require__(460);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _checkDecoratorArguments = __webpack_require__(373);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CHILD_CONTEXT_TYPES = exports.CHILD_CONTEXT_TYPES = {
		dragDropManager: _propTypes2.default.object.isRequired
	};
	
	var createChildContext = exports.createChildContext = function createChildContext(backend, context) {
		return {
			dragDropManager: new _dndCore.DragDropManager(backend, context)
		};
	};
	
	var unpackBackendForEs5Users = exports.unpackBackendForEs5Users = function unpackBackendForEs5Users(backendOrModule) {
		// Auto-detect ES6 default export for people still using ES5
		var backend = backendOrModule;
		if ((typeof backend === 'undefined' ? 'undefined' : _typeof(backend)) === 'object' && typeof backend.default === 'function') {
			backend = backend.default;
		}
		(0, _invariant2.default)(typeof backend === 'function', 'Expected the backend to be a function or an ES6 module exporting a default function. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-drop-context.html');
		return backend;
	};
	
	function DragDropContext(backendOrModule) {
		_checkDecoratorArguments2.default.apply(undefined, ['DragDropContext', 'backend'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
	
		var backend = unpackBackendForEs5Users(backendOrModule);
		var childContext = createChildContext(backend);
	
		return function decorateContext(DecoratedComponent) {
			var _class, _temp;
	
			var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
			var DragDropContextContainer = (_temp = _class = function (_Component) {
				_inherits(DragDropContextContainer, _Component);
	
				function DragDropContextContainer() {
					_classCallCheck(this, DragDropContextContainer);
	
					return _possibleConstructorReturn(this, (DragDropContextContainer.__proto__ || Object.getPrototypeOf(DragDropContextContainer)).apply(this, arguments));
				}
	
				_createClass(DragDropContextContainer, [{
					key: 'getDecoratedComponentInstance',
					value: function getDecoratedComponentInstance() {
						(0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
						return this.child;
					}
				}, {
					key: 'getManager',
					value: function getManager() {
						return childContext.dragDropManager;
					}
				}, {
					key: 'getChildContext',
					value: function getChildContext() {
						return childContext;
					}
				}, {
					key: 'render',
					value: function render() {
						var _this2 = this;
	
						return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
							ref: function ref(child) {
								_this2.child = child;
							}
						}));
					}
				}]);
	
				return DragDropContextContainer;
			}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragDropContext(' + displayName + ')', _class.childContextTypes = CHILD_CONTEXT_TYPES, _temp);
	
	
			return (0, _hoistNonReactStatics2.default)(DragDropContextContainer, DecoratedComponent);
		};
	}

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = areOptionsEqual;
	
	var _shallowEqual = __webpack_require__(509);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function areOptionsEqual(nextOptions, currentOptions) {
		if (currentOptions === nextOptions) {
			return true;
		}
	
		return currentOptions !== null && nextOptions !== null && (0, _shallowEqual2.default)(currentOptions, nextOptions);
	}

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = decorateHandler;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _disposables = __webpack_require__(1159);
	
	var _isPlainObject = __webpack_require__(137);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _hoistNonReactStatics = __webpack_require__(460);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _shallowEqual = __webpack_require__(509);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _shallowEqualScalar = __webpack_require__(822);
	
	var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isClassComponent = function isClassComponent(Comp) {
		return Boolean(Comp && Comp.prototype && typeof Comp.prototype.render === 'function');
	};
	
	function decorateHandler(_ref) {
		var _class, _temp;
	
		var DecoratedComponent = _ref.DecoratedComponent,
		    createHandler = _ref.createHandler,
		    createMonitor = _ref.createMonitor,
		    createConnector = _ref.createConnector,
		    registerHandler = _ref.registerHandler,
		    containerDisplayName = _ref.containerDisplayName,
		    getType = _ref.getType,
		    collect = _ref.collect,
		    options = _ref.options;
		var _options$arePropsEqua = options.arePropsEqual,
		    arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;
	
		var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
		var DragDropContainer = (_temp = _class = function (_Component) {
			_inherits(DragDropContainer, _Component);
	
			_createClass(DragDropContainer, [{
				key: 'getHandlerId',
				value: function getHandlerId() {
					return this.handlerId;
				}
			}, {
				key: 'getDecoratedComponentInstance',
				value: function getDecoratedComponentInstance() {
					return this.decoratedComponentInstance;
				}
			}, {
				key: 'shouldComponentUpdate',
				value: function shouldComponentUpdate(nextProps, nextState) {
					return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
				}
			}]);
	
			function DragDropContainer(props, context) {
				_classCallCheck(this, DragDropContainer);
	
				var _this = _possibleConstructorReturn(this, (DragDropContainer.__proto__ || Object.getPrototypeOf(DragDropContainer)).call(this, props, context));
	
				_this.handleChange = _this.handleChange.bind(_this);
				_this.handleChildRef = _this.handleChildRef.bind(_this);
	
				(0, _invariant2.default)(_typeof(_this.context.dragDropManager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	
				_this.manager = _this.context.dragDropManager;
				_this.handlerMonitor = createMonitor(_this.manager);
				_this.handlerConnector = createConnector(_this.manager.getBackend());
				_this.handler = createHandler(_this.handlerMonitor);
	
				_this.disposable = new _disposables.SerialDisposable();
				_this.receiveProps(props);
				_this.state = _this.getCurrentState();
				_this.dispose();
				return _this;
			}
	
			_createClass(DragDropContainer, [{
				key: 'componentDidMount',
				value: function componentDidMount() {
					this.isCurrentlyMounted = true;
					this.disposable = new _disposables.SerialDisposable();
					this.currentType = null;
					this.receiveProps(this.props);
					this.handleChange();
				}
			}, {
				key: 'componentWillReceiveProps',
				value: function componentWillReceiveProps(nextProps) {
					if (!arePropsEqual(nextProps, this.props)) {
						this.receiveProps(nextProps);
						this.handleChange();
					}
				}
			}, {
				key: 'componentWillUnmount',
				value: function componentWillUnmount() {
					this.dispose();
					this.isCurrentlyMounted = false;
				}
			}, {
				key: 'receiveProps',
				value: function receiveProps(props) {
					this.handler.receiveProps(props);
					this.receiveType(getType(props));
				}
			}, {
				key: 'receiveType',
				value: function receiveType(type) {
					if (type === this.currentType) {
						return;
					}
	
					this.currentType = type;
	
					var _registerHandler = registerHandler(type, this.handler, this.manager),
					    handlerId = _registerHandler.handlerId,
					    unregister = _registerHandler.unregister;
	
					this.handlerId = handlerId;
					this.handlerMonitor.receiveHandlerId(handlerId);
					this.handlerConnector.receiveHandlerId(handlerId);
	
					var globalMonitor = this.manager.getMonitor();
					var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, { handlerIds: [handlerId] });
	
					this.disposable.setDisposable(new _disposables.CompositeDisposable(new _disposables.Disposable(unsubscribe), new _disposables.Disposable(unregister)));
				}
			}, {
				key: 'handleChange',
				value: function handleChange() {
					if (!this.isCurrentlyMounted) {
						return;
					}
	
					var nextState = this.getCurrentState();
					if (!(0, _shallowEqual2.default)(nextState, this.state)) {
						this.setState(nextState);
					}
				}
			}, {
				key: 'dispose',
				value: function dispose() {
					this.disposable.dispose();
					this.handlerConnector.receiveHandlerId(null);
				}
			}, {
				key: 'handleChildRef',
				value: function handleChildRef(component) {
					this.decoratedComponentInstance = component;
					this.handler.receiveComponent(component);
				}
			}, {
				key: 'getCurrentState',
				value: function getCurrentState() {
					var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor);
	
					if (false) {
						(0, _invariant2.default)((0, _isPlainObject2.default)(nextState), 'Expected `collect` specified as the second argument to ' + '%s for %s to return a plain object of props to inject. ' + 'Instead, received %s.', containerDisplayName, displayName, nextState);
					}
	
					return nextState;
				}
			}, {
				key: 'render',
				value: function render() {
					return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
						ref: isClassComponent(DecoratedComponent) ? this.handleChildRef : null
					}));
				}
			}]);
	
			return DragDropContainer;
		}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = containerDisplayName + '(' + displayName + ')', _class.contextTypes = {
			dragDropManager: _propTypes2.default.object.isRequired
		}, _temp);
	
	
		return (0, _hoistNonReactStatics2.default)(DragDropContainer, DecoratedComponent);
	}

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isValidType;
	
	var _isArray = __webpack_require__(62);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidType(type, allowArray) {
		return typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol' || allowArray && (0, _isArray2.default)(type) && type.every(function (t) {
			return isValidType(t, false);
		});
	}

/***/ }),
/* 822 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = shallowEqualScalar;
	function shallowEqualScalar(objA, objB) {
		if (objA === objB) {
			return true;
		}
	
		if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
			return false;
		}
	
		var keysA = Object.keys(objA);
		var keysB = Object.keys(objB);
	
		if (keysA.length !== keysB.length) {
			return false;
		}
	
		// Test for A's keys different from B.
		var hasOwn = Object.prototype.hasOwnProperty;
		for (var i = 0; i < keysA.length; i += 1) {
			if (!hasOwn.call(objB, keysA[i])) {
				return false;
			}
	
			var valA = objA[keysA[i]];
			var valB = objB[keysA[i]];
	
			if (valA !== valB || (typeof valA === 'undefined' ? 'undefined' : _typeof(valA)) === 'object' || (typeof valB === 'undefined' ? 'undefined' : _typeof(valB)) === 'object') {
				return false;
			}
		}
	
		return true;
	}

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = wrapConnectorHooks;
	
	var _react = __webpack_require__(1);
	
	var _cloneWithRef = __webpack_require__(1743);
	
	var _cloneWithRef2 = _interopRequireDefault(_cloneWithRef);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function throwIfCompositeComponentElement(element) {
		// Custom components can no longer be wrapped directly in React DnD 2.0
		// so that we don't need to depend on findDOMNode() from react-dom.
		if (typeof element.type === 'string') {
			return;
		}
	
		var displayName = element.type.displayName || element.type.name || 'the component';
	
		throw new Error('Only native element nodes can now be passed to React DnD connectors.' + ('You can either wrap ' + displayName + ' into a <div>, or turn it into a ') + 'drag source or a drop target itself.');
	}
	
	function wrapHookToRecognizeElement(hook) {
		return function () {
			var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
			// When passed a node, call the hook straight away.
			if (!(0, _react.isValidElement)(elementOrNode)) {
				var node = elementOrNode;
				hook(node, options);
				return undefined;
			}
	
			// If passed a ReactElement, clone it and attach this function as a ref.
			// This helps us achieve a neat API where user doesn't even know that refs
			// are being used under the hood.
			var element = elementOrNode;
			throwIfCompositeComponentElement(element);
	
			// When no options are passed, use the hook directly
			var ref = options ? function (node) {
				return hook(node, options);
			} : hook;
	
			return (0, _cloneWithRef2.default)(element, ref);
		};
	}
	
	function wrapConnectorHooks(hooks) {
		var wrappedHooks = {};
	
		Object.keys(hooks).forEach(function (key) {
			var hook = hooks[key];
			var wrappedHook = wrapHookToRecognizeElement(hook);
			wrappedHooks[key] = function () {
				return wrappedHook;
			};
		});
	
		return wrappedHooks;
	}

/***/ }),
/* 824 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(214);
	
	var invariant = __webpack_require__(28);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(246);
	var ReactDOMComponentTree = __webpack_require__(85);
	var ReactInstrumentation = __webpack_require__(141);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1805);
	var warning = __webpack_require__(61);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 827 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var LinkedValueUtils = __webpack_require__(515);
	var ReactDOMComponentTree = __webpack_require__(85);
	var ReactUpdates = __webpack_require__(155);
	
	var warning = __webpack_require__(61);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 829 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 830 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var invariant = __webpack_require__(28);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1765);
	
	var containsNode = __webpack_require__(335);
	var focusNode = __webpack_require__(676);
	var getActiveElement = __webpack_require__(337);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var DOMLazyTree = __webpack_require__(245);
	var DOMProperty = __webpack_require__(246);
	var React = __webpack_require__(252);
	var ReactBrowserEventEmitter = __webpack_require__(374);
	var ReactCurrentOwner = __webpack_require__(169);
	var ReactDOMComponentTree = __webpack_require__(85);
	var ReactDOMContainerInfo = __webpack_require__(1759);
	var ReactDOMFeatureFlags = __webpack_require__(1761);
	var ReactFeatureFlags = __webpack_require__(830);
	var ReactInstanceMap = __webpack_require__(295);
	var ReactInstrumentation = __webpack_require__(141);
	var ReactMarkupChecksum = __webpack_require__(1775);
	var ReactReconciler = __webpack_require__(247);
	var ReactUpdateQueue = __webpack_require__(518);
	var ReactUpdates = __webpack_require__(155);
	
	var emptyObject = __webpack_require__(336);
	var instantiateReactComponent = __webpack_require__(841);
	var invariant = __webpack_require__(28);
	var setInnerHTML = __webpack_require__(378);
	var shouldUpdateReactComponent = __webpack_require__(524);
	var warning = __webpack_require__(61);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var React = __webpack_require__(252);
	
	var invariant = __webpack_require__(28);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 835 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var invariant = __webpack_require__(28);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 837 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(834);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(105);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(85);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64),
	    _assign = __webpack_require__(40);
	
	var ReactCompositeComponent = __webpack_require__(1756);
	var ReactEmptyComponent = __webpack_require__(829);
	var ReactHostComponent = __webpack_require__(831);
	
	var getNextDebugID = __webpack_require__(1932);
	var invariant = __webpack_require__(28);
	var warning = __webpack_require__(61);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 842 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(105);
	var escapeTextContentForBrowser = __webpack_require__(377);
	var setInnerHTML = __webpack_require__(378);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var ReactCurrentOwner = __webpack_require__(169);
	var REACT_ELEMENT_TYPE = __webpack_require__(1771);
	
	var getIteratorFn = __webpack_require__(1802);
	var invariant = __webpack_require__(28);
	var KeyEscapeUtils = __webpack_require__(514);
	var warning = __webpack_require__(61);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(2));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else if(typeof exports === 'object')
			exports["Dropzone"] = factory(require("react"), require("prop-types"));
		else
			root["Dropzone"] = factory(root["react"], root["prop-types"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		var _propTypes = __webpack_require__(3);
		
		var _propTypes2 = _interopRequireDefault(_propTypes);
		
		var _attrAccept = __webpack_require__(4);
		
		var _attrAccept2 = _interopRequireDefault(_attrAccept);
		
		var _getDataTransferItems = __webpack_require__(5);
		
		var _getDataTransferItems2 = _interopRequireDefault(_getDataTransferItems);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
		
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint prefer-template: 0 */
		
		var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;
		
		function fileAccepted(file, accept) {
		  // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
		  // that MIME type will always be accepted
		  return file.type === 'application/x-moz-file' || (0, _attrAccept2.default)(file, accept);
		}
		
		var Dropzone = function (_React$Component) {
		  _inherits(Dropzone, _React$Component);
		
		  _createClass(Dropzone, null, [{
		    key: 'onDocumentDragOver',
		    value: function onDocumentDragOver(evt) {
		      // allow the entire document to be a drag target
		      evt.preventDefault();
		    }
		  }]);
		
		  function Dropzone(props, context) {
		    _classCallCheck(this, Dropzone);
		
		    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));
		
		    _this.renderChildren = function (children, isDragActive, isDragReject) {
		      if (typeof children === 'function') {
		        return children(_extends({}, _this.state, { isDragActive: isDragActive, isDragReject: isDragReject }));
		      }
		      return children;
		    };
		
		    _this.onClick = _this.onClick.bind(_this);
		    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
		    _this.onDragStart = _this.onDragStart.bind(_this);
		    _this.onDragEnter = _this.onDragEnter.bind(_this);
		    _this.onDragLeave = _this.onDragLeave.bind(_this);
		    _this.onDragOver = _this.onDragOver.bind(_this);
		    _this.onDrop = _this.onDrop.bind(_this);
		    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
		    _this.setRef = _this.setRef.bind(_this);
		    _this.setRefs = _this.setRefs.bind(_this);
		    _this.onInputElementClick = _this.onInputElementClick.bind(_this);
		    _this.isFileDialogActive = false;
		    _this.state = {
		      draggedFiles: [],
		      acceptedFiles: [],
		      rejectedFiles: []
		    };
		    return _this;
		  }
		
		  _createClass(Dropzone, [{
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      var preventDropOnDocument = this.props.preventDropOnDocument;
		
		      this.dragTargets = [];
		
		      if (preventDropOnDocument) {
		        document.addEventListener('dragover', Dropzone.onDocumentDragOver, false);
		        document.addEventListener('drop', this.onDocumentDrop, false);
		      }
		      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
		      // Tried implementing addEventListener, but didn't work out
		      document.body.onfocus = this.onFileDialogCancel;
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      var preventDropOnDocument = this.props.preventDropOnDocument;
		
		      if (preventDropOnDocument) {
		        document.removeEventListener('dragover', Dropzone.onDocumentDragOver);
		        document.removeEventListener('drop', this.onDocumentDrop);
		      }
		      this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
		      // Can be replaced with removeEventListener, if addEventListener works
		      document.body.onfocus = null;
		    }
		  }, {
		    key: 'onDocumentDrop',
		    value: function onDocumentDrop(evt) {
		      if (this.node.contains(evt.target)) {
		        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
		        return;
		      }
		      evt.preventDefault();
		      this.dragTargets = [];
		    }
		  }, {
		    key: 'onDragStart',
		    value: function onDragStart(evt) {
		      if (this.props.onDragStart) {
		        this.props.onDragStart.call(this, evt);
		      }
		    }
		  }, {
		    key: 'onDragEnter',
		    value: function onDragEnter(evt) {
		      evt.preventDefault();
		
		      // Count the dropzone and any children that are entered.
		      if (this.dragTargets.indexOf(evt.target) === -1) {
		        this.dragTargets.push(evt.target);
		      }
		
		      this.setState({ draggedFiles: (0, _getDataTransferItems2.default)(evt) });
		
		      if (this.props.onDragEnter) {
		        this.props.onDragEnter.call(this, evt);
		      }
		    }
		  }, {
		    key: 'onDragOver',
		    value: function onDragOver(evt) {
		      // eslint-disable-line class-methods-use-this
		      evt.preventDefault();
		      evt.stopPropagation();
		      try {
		        evt.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
		      } catch (err) {
		        // continue regardless of error
		      }
		
		      if (this.props.onDragOver) {
		        this.props.onDragOver.call(this, evt);
		      }
		      return false;
		    }
		  }, {
		    key: 'onDragLeave',
		    value: function onDragLeave(evt) {
		      var _this2 = this;
		
		      evt.preventDefault();
		
		      // Only deactivate once the dropzone and all children have been left.
		      this.dragTargets = this.dragTargets.filter(function (el) {
		        return el !== evt.target && _this2.node.contains(el);
		      });
		      if (this.dragTargets.length > 0) {
		        return;
		      }
		
		      // Clear dragging files state
		      this.setState({ draggedFiles: [] });
		
		      if (this.props.onDragLeave) {
		        this.props.onDragLeave.call(this, evt);
		      }
		    }
		  }, {
		    key: 'onDrop',
		    value: function onDrop(evt) {
		      var _this3 = this;
		
		      var _props = this.props,
		          onDrop = _props.onDrop,
		          onDropAccepted = _props.onDropAccepted,
		          onDropRejected = _props.onDropRejected,
		          multiple = _props.multiple,
		          disablePreview = _props.disablePreview,
		          accept = _props.accept;
		
		      var fileList = (0, _getDataTransferItems2.default)(evt);
		      var acceptedFiles = [];
		      var rejectedFiles = [];
		
		      // Stop default browser behavior
		      evt.preventDefault();
		
		      // Reset the counter along with the drag on a drop.
		      this.dragTargets = [];
		      this.isFileDialogActive = false;
		
		      fileList.forEach(function (file) {
		        if (!disablePreview) {
		          try {
		            file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
		          } catch (err) {
		            if (process.env.NODE_ENV !== 'production') {
		              console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
		            }
		          }
		        }
		
		        if (fileAccepted(file, accept) && _this3.fileMatchSize(file)) {
		          acceptedFiles.push(file);
		        } else {
		          rejectedFiles.push(file);
		        }
		      });
		
		      if (!multiple) {
		        // if not in multi mode add any extra accepted files to rejected.
		        // This will allow end users to easily ignore a multi file drop in "single" mode.
		        rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
		      }
		
		      if (onDrop) {
		        onDrop.call(this, acceptedFiles, rejectedFiles, evt);
		      }
		
		      if (rejectedFiles.length > 0 && onDropRejected) {
		        onDropRejected.call(this, rejectedFiles, evt);
		      }
		
		      if (acceptedFiles.length > 0 && onDropAccepted) {
		        onDropAccepted.call(this, acceptedFiles, evt);
		      }
		
		      // Clear files value
		      this.draggedFiles = null;
		
		      // Reset drag state
		      this.setState({
		        draggedFiles: [],
		        acceptedFiles: acceptedFiles,
		        rejectedFiles: rejectedFiles
		      });
		    }
		  }, {
		    key: 'onClick',
		    value: function onClick(evt) {
		      var _props2 = this.props,
		          onClick = _props2.onClick,
		          disableClick = _props2.disableClick;
		
		      if (!disableClick) {
		        evt.stopPropagation();
		
		        if (onClick) {
		          onClick.call(this, evt);
		        }
		
		        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
		        // this is so react can handle state changes in the onClick prop above above
		        // see: https://github.com/okonet/react-dropzone/issues/450
		        setTimeout(this.open.bind(this), 0);
		      }
		    }
		  }, {
		    key: 'onInputElementClick',
		    value: function onInputElementClick(evt) {
		      evt.stopPropagation();
		      if (this.props.inputProps && this.props.inputProps.onClick) {
		        this.props.inputProps.onClick();
		      }
		    }
		  }, {
		    key: 'onFileDialogCancel',
		    value: function onFileDialogCancel() {
		      // timeout will not recognize context of this method
		      var onFileDialogCancel = this.props.onFileDialogCancel;
		      var fileInputEl = this.fileInputEl;
		      var isFileDialogActive = this.isFileDialogActive;
		      // execute the timeout only if the onFileDialogCancel is defined and FileDialog
		      // is opened in the browser
		
		      if (onFileDialogCancel && isFileDialogActive) {
		        setTimeout(function () {
		          // Returns an object as FileList
		          var FileList = fileInputEl.files;
		          if (!FileList.length) {
		            isFileDialogActive = false;
		            onFileDialogCancel();
		          }
		        }, 300);
		      }
		    }
		  }, {
		    key: 'setRef',
		    value: function setRef(ref) {
		      this.node = ref;
		    }
		  }, {
		    key: 'setRefs',
		    value: function setRefs(ref) {
		      this.fileInputEl = ref;
		    }
		  }, {
		    key: 'fileMatchSize',
		    value: function fileMatchSize(file) {
		      return file.size <= this.props.maxSize && file.size >= this.props.minSize;
		    }
		  }, {
		    key: 'allFilesAccepted',
		    value: function allFilesAccepted(files) {
		      var _this4 = this;
		
		      return files.every(function (file) {
		        return fileAccepted(file, _this4.props.accept);
		      });
		    }
		
		    /**
		     * Open system file upload dialog.
		     *
		     * @public
		     */
		
		  }, {
		    key: 'open',
		    value: function open() {
		      this.isFileDialogActive = true;
		      this.fileInputEl.value = null;
		      this.fileInputEl.click();
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _props3 = this.props,
		          accept = _props3.accept,
		          activeClassName = _props3.activeClassName,
		          inputProps = _props3.inputProps,
		          multiple = _props3.multiple,
		          name = _props3.name,
		          rejectClassName = _props3.rejectClassName,
		          children = _props3.children,
		          rest = _objectWithoutProperties(_props3, ['accept', 'activeClassName', 'inputProps', 'multiple', 'name', 'rejectClassName', 'children']);
		
		      var activeStyle = rest.activeStyle,
		          className = rest.className,
		          rejectStyle = rest.rejectStyle,
		          style = rest.style,
		          props = _objectWithoutProperties(rest, ['activeStyle', 'className', 'rejectStyle', 'style']);
		
		      var draggedFiles = this.state.draggedFiles;
		
		      var filesCount = draggedFiles.length;
		      var isMultipleAllowed = multiple || filesCount <= 1;
		      var isDragActive = filesCount > 0 && this.allFilesAccepted(draggedFiles);
		      var isDragReject = filesCount > 0 && (!isDragActive || !isMultipleAllowed);
		
		      className = className || '';
		
		      if (isDragActive && activeClassName) {
		        className += ' ' + activeClassName;
		      }
		      if (isDragReject && rejectClassName) {
		        className += ' ' + rejectClassName;
		      }
		
		      if (!className && !style && !activeStyle && !rejectStyle) {
		        style = {
		          width: 200,
		          height: 200,
		          borderWidth: 2,
		          borderColor: '#666',
		          borderStyle: 'dashed',
		          borderRadius: 5
		        };
		        activeStyle = {
		          borderStyle: 'solid',
		          borderColor: '#6c6',
		          backgroundColor: '#eee'
		        };
		        rejectStyle = {
		          borderStyle: 'solid',
		          borderColor: '#c66',
		          backgroundColor: '#eee'
		        };
		      }
		
		      var appliedStyle = void 0;
		      if (activeStyle && isDragActive) {
		        appliedStyle = _extends({}, style, activeStyle);
		      } else if (rejectStyle && isDragReject) {
		        appliedStyle = _extends({}, style, rejectStyle);
		      } else {
		        appliedStyle = _extends({}, style);
		      }
		
		      var inputAttributes = {
		        accept: accept,
		        type: 'file',
		        style: { display: 'none' },
		        multiple: supportMultiple && multiple,
		        ref: this.setRefs,
		        onChange: this.onDrop
		      };
		
		      if (name && name.length) {
		        inputAttributes.name = name;
		      }
		
		      // Remove custom properties before passing them to the wrapper div element
		      var customProps = ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize'];
		      var divProps = _extends({}, props);
		      customProps.forEach(function (prop) {
		        return delete divProps[prop];
		      });
		
		      return _react2.default.createElement(
		        'div',
		        _extends({
		          className: className,
		          style: appliedStyle
		        }, divProps /* expand user provided props first so event handlers are never overridden */, {
		          onClick: this.onClick,
		          onDragStart: this.onDragStart,
		          onDragEnter: this.onDragEnter,
		          onDragOver: this.onDragOver,
		          onDragLeave: this.onDragLeave,
		          onDrop: this.onDrop,
		          ref: this.setRef
		        }),
		        this.renderChildren(children, isDragActive, isDragReject),
		        _react2.default.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
		      );
		    }
		  }]);
		
		  return Dropzone;
		}(_react2.default.Component);
		
		Dropzone.propTypes = {
		  /**
		   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
		   * Keep in mind that mime type determination is not reliable accross platforms. CSV files,
		   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
		   * Windows. In some cases there might not be a mime type set at all.
		   * See: https://github.com/okonet/react-dropzone/issues/276
		   */
		  accept: _propTypes2.default.string,
		
		  /**
		   * Contents of the dropzone
		   */
		  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
		
		  /**
		   * Disallow clicking on the dropzone container to open file dialog
		   */
		  disableClick: _propTypes2.default.bool,
		
		  /**
		   * Enable/disable preview generation
		   */
		  disablePreview: _propTypes2.default.bool,
		
		  /**
		   * If false, allow dropped items to take over the current browser window
		   */
		  preventDropOnDocument: _propTypes2.default.bool,
		
		  /**
		   * Pass additional attributes to the `<input type="file"/>` tag
		   */
		  inputProps: _propTypes2.default.object,
		
		  /**
		   * Allow dropping multiple files
		   */
		  multiple: _propTypes2.default.bool,
		
		  /**
		   * `name` attribute for the input tag
		   */
		  name: _propTypes2.default.string,
		
		  /**
		   * Maximum file size
		   */
		  maxSize: _propTypes2.default.number,
		
		  /**
		   * Minimum file size
		   */
		  minSize: _propTypes2.default.number,
		
		  /**
		   * className
		   */
		  className: _propTypes2.default.string,
		
		  /**
		   * className for accepted state
		   */
		  activeClassName: _propTypes2.default.string,
		
		  /**
		   * className for rejected state
		   */
		  rejectClassName: _propTypes2.default.string,
		
		  /**
		   * CSS styles to apply
		   */
		  style: _propTypes2.default.object,
		
		  /**
		   * CSS styles to apply when drop will be accepted
		   */
		  activeStyle: _propTypes2.default.object,
		
		  /**
		   * CSS styles to apply when drop will be rejected
		   */
		  rejectStyle: _propTypes2.default.object,
		
		  /**
		   * onClick callback
		   * @param {Event} event
		   */
		  onClick: _propTypes2.default.func,
		
		  /**
		   * onDrop callback
		   */
		  onDrop: _propTypes2.default.func,
		
		  /**
		   * onDropAccepted callback
		   */
		  onDropAccepted: _propTypes2.default.func,
		
		  /**
		   * onDropRejected callback
		   */
		  onDropRejected: _propTypes2.default.func,
		
		  /**
		   * onDragStart callback
		   */
		  onDragStart: _propTypes2.default.func,
		
		  /**
		   * onDragEnter callback
		   */
		  onDragEnter: _propTypes2.default.func,
		
		  /**
		   * onDragOver callback
		   */
		  onDragOver: _propTypes2.default.func,
		
		  /**
		   * onDragLeave callback
		   */
		  onDragLeave: _propTypes2.default.func,
		
		  /**
		   * Provide a callback on clicking the cancel button of the file dialog
		   */
		  onFileDialogCancel: _propTypes2.default.func
		};
		
		Dropzone.defaultProps = {
		  preventDropOnDocument: true,
		  disablePreview: false,
		  disableClick: false,
		  multiple: true,
		  maxSize: Infinity,
		  minSize: 0
		};
		
		exports.default = Dropzone;
		module.exports = exports['default'];
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		// shim for using process in browser
		var process = module.exports = {};
		
		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.
		
		var cachedSetTimeout;
		var cachedClearTimeout;
		
		function defaultSetTimout() {
		    throw new Error('setTimeout has not been defined');
		}
		function defaultClearTimeout () {
		    throw new Error('clearTimeout has not been defined');
		}
		(function () {
		    try {
		        if (typeof setTimeout === 'function') {
		            cachedSetTimeout = setTimeout;
		        } else {
		            cachedSetTimeout = defaultSetTimout;
		        }
		    } catch (e) {
		        cachedSetTimeout = defaultSetTimout;
		    }
		    try {
		        if (typeof clearTimeout === 'function') {
		            cachedClearTimeout = clearTimeout;
		        } else {
		            cachedClearTimeout = defaultClearTimeout;
		        }
		    } catch (e) {
		        cachedClearTimeout = defaultClearTimeout;
		    }
		} ())
		function runTimeout(fun) {
		    if (cachedSetTimeout === setTimeout) {
		        //normal enviroments in sane situations
		        return setTimeout(fun, 0);
		    }
		    // if setTimeout wasn't available but was latter defined
		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		        cachedSetTimeout = setTimeout;
		        return setTimeout(fun, 0);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedSetTimeout(fun, 0);
		    } catch(e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
		            return cachedSetTimeout.call(null, fun, 0);
		        } catch(e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
		            return cachedSetTimeout.call(this, fun, 0);
		        }
		    }
		
		
		}
		function runClearTimeout(marker) {
		    if (cachedClearTimeout === clearTimeout) {
		        //normal enviroments in sane situations
		        return clearTimeout(marker);
		    }
		    // if clearTimeout wasn't available but was latter defined
		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		        cachedClearTimeout = clearTimeout;
		        return clearTimeout(marker);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedClearTimeout(marker);
		    } catch (e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
		            return cachedClearTimeout.call(null, marker);
		        } catch (e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
		            return cachedClearTimeout.call(this, marker);
		        }
		    }
		
		
		
		}
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
		
		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
		
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = runTimeout(cleanUpNextTick);
		    draining = true;
		
		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    runClearTimeout(timeout);
		}
		
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        runTimeout(drainQueue);
		    }
		};
		
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
		
		function noop() {}
		
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		process.prependListener = noop;
		process.prependOnceListener = noop;
		
		process.listeners = function (name) { return [] }
		
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
		
		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
		module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,y,d=t&s.G,h=t&s.P,v=d?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=d?o:o[n]||(o[n]={});d&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],y=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,y),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
		"use strict";
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = getDataTransferFiles;
		function getDataTransferFiles(event) {
		  var dataTransferItemsList = [];
		  if (event.dataTransfer) {
		    var dt = event.dataTransfer;
		    if (dt.files && dt.files.length) {
		      dataTransferItemsList = dt.files;
		    } else if (dt.items && dt.items.length) {
		      // During the drag even the dataTransfer.files is null
		      // but Chrome implements some drag store, which is accesible via dataTransfer.items
		      dataTransferItemsList = dt.items;
		    }
		  } else if (event.target && event.target.files) {
		    dataTransferItemsList = event.target.files;
		  }
		  // Convert from DataTransferItemsList to the native Array
		  return Array.prototype.slice.call(dataTransferItemsList);
		}
		module.exports = exports["default"];
	
	/***/ })
	/******/ ])
	});
	;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 846 */,
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(338);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(297);
	
	var _GridItem = __webpack_require__(1808);
	
	var _GridItem2 = _interopRequireDefault(_GridItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// End Types
	
	/**
	 * A reactive, fluid grid layout with draggable, resizable components.
	 */
	
	// Types
	var ReactGridLayout = function (_React$Component) {
	  _inherits(ReactGridLayout, _React$Component);
	
	  // TODO publish internal ReactClass displayName transform
	  function ReactGridLayout(props, context) {
	    _classCallCheck(this, ReactGridLayout);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    (0, _utils.autoBindHandlers)(_this, ["onDragStart", "onDrag", "onDragStop", "onResizeStart", "onResize", "onResizeStop"]);
	    return _this;
	  }
	
	  ReactGridLayout.prototype.componentDidMount = function componentDidMount() {
	    this.setState({ mounted: true });
	    // Possibly call back with layout on mount. This should be done after correcting the layout width
	    // to ensure we don't rerender with the wrong width.
	    this.onLayoutMaybeChanged(this.state.layout, this.props.layout);
	  };
	
	  ReactGridLayout.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var newLayoutBase = void 0;
	    // Legacy support for compactType
	    // Allow parent to set layout directly.
	    if (!(0, _lodash2.default)(nextProps.layout, this.props.layout) || nextProps.compactType !== this.props.compactType) {
	      newLayoutBase = nextProps.layout;
	    } else if (!(0, _utils.childrenEqual)(this.props.children, nextProps.children)) {
	      // If children change, also regenerate the layout. Use our state
	      // as the base in case because it may be more up to date than
	      // what is in props.
	      newLayoutBase = this.state.layout;
	    }
	
	    // We need to regenerate the layout.
	    if (newLayoutBase) {
	      var newLayout = (0, _utils.synchronizeLayoutWithChildren)(newLayoutBase, nextProps.children, nextProps.cols, this.compactType(nextProps));
	      var _oldLayout = this.state.layout;
	      this.setState({ layout: newLayout });
	      this.onLayoutMaybeChanged(newLayout, _oldLayout);
	    }
	  };
	
	  /**
	   * Calculates a pixel value for the container.
	   * @return {String} Container height in pixels.
	   */
	
	
	  ReactGridLayout.prototype.containerHeight = function containerHeight() {
	    if (!this.props.autoSize) return;
	    var nbRow = (0, _utils.bottom)(this.state.layout);
	    var containerPaddingY = this.props.containerPadding ? this.props.containerPadding[1] : this.props.margin[1];
	    return nbRow * this.props.rowHeight + (nbRow - 1) * this.props.margin[1] + containerPaddingY * 2 + "px";
	  };
	
	  ReactGridLayout.prototype.compactType = function compactType(props) {
	    if (!props) props = this.props;
	    return props.verticalCompact === false ? null : props.compactType;
	  };
	
	  /**
	   * When dragging starts
	   * @param {String} i Id of the child
	   * @param {Number} x X position of the move
	   * @param {Number} y Y position of the move
	   * @param {Event} e The mousedown event
	   * @param {Element} node The current dragging DOM element
	   */
	
	
	  ReactGridLayout.prototype.onDragStart = function onDragStart(i, x, y, _ref) {
	    var e = _ref.e,
	        node = _ref.node;
	    var layout = this.state.layout;
	
	    var l = (0, _utils.getLayoutItem)(layout, i);
	    if (!l) return;
	
	    this.setState({
	      oldDragItem: (0, _utils.cloneLayoutItem)(l),
	      oldLayout: this.state.layout
	    });
	
	    return this.props.onDragStart(layout, l, l, null, e, node);
	  };
	
	  /**
	   * Each drag movement create a new dragelement and move the element to the dragged location
	   * @param {String} i Id of the child
	   * @param {Number} x X position of the move
	   * @param {Number} y Y position of the move
	   * @param {Event} e The mousedown event
	   * @param {Element} node The current dragging DOM element
	   */
	
	
	  ReactGridLayout.prototype.onDrag = function onDrag(i, x, y, _ref2) {
	    var e = _ref2.e,
	        node = _ref2.node;
	    var oldDragItem = this.state.oldDragItem;
	    var layout = this.state.layout;
	    var cols = this.props.cols;
	
	    var l = (0, _utils.getLayoutItem)(layout, i);
	    if (!l) return;
	
	    // Create placeholder (display only)
	    var placeholder = {
	      w: l.w,
	      h: l.h,
	      x: l.x,
	      y: l.y,
	      placeholder: true,
	      i: i
	    };
	
	    // Move the element to the dragged location.
	    var isUserAction = true;
	    layout = (0, _utils.moveElement)(layout, l, x, y, isUserAction, this.props.preventCollision, this.compactType(), cols);
	
	    this.props.onDrag(layout, oldDragItem, l, placeholder, e, node);
	
	    this.setState({
	      layout: (0, _utils.compact)(layout, this.compactType(), cols),
	      activeDrag: placeholder
	    });
	  };
	
	  /**
	   * When dragging stops, figure out which position the element is closest to and update its x and y.
	   * @param  {String} i Index of the child.
	   * @param {Number} x X position of the move
	   * @param {Number} y Y position of the move
	   * @param {Event} e The mousedown event
	   * @param {Element} node The current dragging DOM element
	   */
	
	
	  ReactGridLayout.prototype.onDragStop = function onDragStop(i, x, y, _ref3) {
	    var e = _ref3.e,
	        node = _ref3.node;
	    var oldDragItem = this.state.oldDragItem;
	    var layout = this.state.layout;
	    var _props = this.props,
	        cols = _props.cols,
	        preventCollision = _props.preventCollision;
	
	    var l = (0, _utils.getLayoutItem)(layout, i);
	    if (!l) return;
	
	    // Move the element here
	    var isUserAction = true;
	    layout = (0, _utils.moveElement)(layout, l, x, y, isUserAction, preventCollision, this.compactType(), cols);
	
	    this.props.onDragStop(layout, oldDragItem, l, null, e, node);
	
	    // Set state
	    var newLayout = (0, _utils.compact)(layout, this.compactType(), cols);
	    var oldLayout = this.state.oldLayout;
	
	    this.setState({
	      activeDrag: null,
	      layout: newLayout,
	      oldDragItem: null,
	      oldLayout: null
	    });
	
	    this.onLayoutMaybeChanged(newLayout, oldLayout);
	  };
	
	  ReactGridLayout.prototype.onLayoutMaybeChanged = function onLayoutMaybeChanged(newLayout, oldLayout) {
	    if (!oldLayout) oldLayout = this.state.layout;
	    if (!(0, _lodash2.default)(oldLayout, newLayout)) {
	      this.props.onLayoutChange(newLayout);
	    }
	  };
	
	  ReactGridLayout.prototype.onResizeStart = function onResizeStart(i, w, h, _ref4) {
	    var e = _ref4.e,
	        node = _ref4.node;
	    var layout = this.state.layout;
	
	    var l = (0, _utils.getLayoutItem)(layout, i);
	    if (!l) return;
	
	    this.setState({
	      oldResizeItem: (0, _utils.cloneLayoutItem)(l),
	      oldLayout: this.state.layout
	    });
	
	    this.props.onResizeStart(layout, l, l, null, e, node);
	  };
	
	  ReactGridLayout.prototype.onResize = function onResize(i, w, h, _ref5) {
	    var e = _ref5.e,
	        node = _ref5.node;
	    var _state = this.state,
	        layout = _state.layout,
	        oldResizeItem = _state.oldResizeItem;
	    var _props2 = this.props,
	        cols = _props2.cols,
	        preventCollision = _props2.preventCollision;
	
	    var l = (0, _utils.getLayoutItem)(layout, i);
	    if (!l) return;
	
	    // Something like quad tree should be used
	    // to find collisions faster
	    var hasCollisions = void 0;
	    if (preventCollision) {
	      var collisions = (0, _utils.getAllCollisions)(layout, _extends({}, l, { w: w, h: h })).filter(function (layoutItem) {
	        return layoutItem.i !== l.i;
	      });
	      hasCollisions = collisions.length > 0;
	
	      // If we're colliding, we need adjust the placeholder.
	      if (hasCollisions) {
	        // adjust w && h to maximum allowed space
	        var leastX = Infinity,
	            leastY = Infinity;
	        collisions.forEach(function (layoutItem) {
	          if (layoutItem.x > l.x) leastX = Math.min(leastX, layoutItem.x);
	          if (layoutItem.y > l.y) leastY = Math.min(leastY, layoutItem.y);
	        });
	
	        if (Number.isFinite(leastX)) l.w = leastX - l.x;
	        if (Number.isFinite(leastY)) l.h = leastY - l.y;
	      }
	    }
	
	    if (!hasCollisions) {
	      // Set new width and height.
	      l.w = w;
	      l.h = h;
	    }
	
	    // Create placeholder element (display only)
	    var placeholder = {
	      w: l.w,
	      h: l.h,
	      x: l.x,
	      y: l.y,
	      static: true,
	      i: i
	    };
	
	    this.props.onResize(layout, oldResizeItem, l, placeholder, e, node);
	
	    // Re-compact the layout and set the drag placeholder.
	    this.setState({
	      layout: (0, _utils.compact)(layout, this.compactType(), cols),
	      activeDrag: placeholder
	    });
	  };
	
	  ReactGridLayout.prototype.onResizeStop = function onResizeStop(i, w, h, _ref6) {
	    var e = _ref6.e,
	        node = _ref6.node;
	    var _state2 = this.state,
	        layout = _state2.layout,
	        oldResizeItem = _state2.oldResizeItem;
	    var cols = this.props.cols;
	
	    var l = (0, _utils.getLayoutItem)(layout, i);
	
	    this.props.onResizeStop(layout, oldResizeItem, l, null, e, node);
	
	    // Set state
	    var newLayout = (0, _utils.compact)(layout, this.compactType(), cols);
	    var oldLayout = this.state.oldLayout;
	
	    this.setState({
	      activeDrag: null,
	      layout: newLayout,
	      oldResizeItem: null,
	      oldLayout: null
	    });
	
	    this.onLayoutMaybeChanged(newLayout, oldLayout);
	  };
	
	  /**
	   * Create a placeholder object.
	   * @return {Element} Placeholder div.
	   */
	
	
	  ReactGridLayout.prototype.placeholder = function placeholder() {
	    var activeDrag = this.state.activeDrag;
	
	    if (!activeDrag) return null;
	    var _props3 = this.props,
	        width = _props3.width,
	        cols = _props3.cols,
	        margin = _props3.margin,
	        containerPadding = _props3.containerPadding,
	        rowHeight = _props3.rowHeight,
	        maxRows = _props3.maxRows,
	        useCSSTransforms = _props3.useCSSTransforms;
	
	    // {...this.state.activeDrag} is pretty slow, actually
	
	    return _react2.default.createElement(
	      _GridItem2.default,
	      {
	        w: activeDrag.w,
	        h: activeDrag.h,
	        x: activeDrag.x,
	        y: activeDrag.y,
	        i: activeDrag.i,
	        className: "react-grid-placeholder",
	        containerWidth: width,
	        cols: cols,
	        margin: margin,
	        containerPadding: containerPadding || margin,
	        maxRows: maxRows,
	        rowHeight: rowHeight,
	        isDraggable: false,
	        isResizable: false,
	        useCSSTransforms: useCSSTransforms
	      },
	      _react2.default.createElement("div", null)
	    );
	  };
	
	  /**
	   * Given a grid item, set its style attributes & surround in a <Draggable>.
	   * @param  {Element} child React element.
	   * @return {Element}       Element wrapped in draggable and properly placed.
	   */
	
	
	  ReactGridLayout.prototype.processGridItem = function processGridItem(child) {
	    if (!child || !child.key) return;
	    var l = (0, _utils.getLayoutItem)(this.state.layout, String(child.key));
	    if (!l) return null;
	    var _props4 = this.props,
	        width = _props4.width,
	        cols = _props4.cols,
	        margin = _props4.margin,
	        containerPadding = _props4.containerPadding,
	        rowHeight = _props4.rowHeight,
	        maxRows = _props4.maxRows,
	        isDraggable = _props4.isDraggable,
	        isResizable = _props4.isResizable,
	        useCSSTransforms = _props4.useCSSTransforms,
	        draggableCancel = _props4.draggableCancel,
	        draggableHandle = _props4.draggableHandle;
	    var mounted = this.state.mounted;
	
	    // Parse 'static'. Any properties defined directly on the grid item will take precedence.
	
	    var draggable = Boolean(!l.static && isDraggable && (l.isDraggable || l.isDraggable == null));
	    var resizable = Boolean(!l.static && isResizable && (l.isResizable || l.isResizable == null));
	
	    return _react2.default.createElement(
	      _GridItem2.default,
	      {
	        containerWidth: width,
	        cols: cols,
	        margin: margin,
	        containerPadding: containerPadding || margin,
	        maxRows: maxRows,
	        rowHeight: rowHeight,
	        cancel: draggableCancel,
	        handle: draggableHandle,
	        onDragStop: this.onDragStop,
	        onDragStart: this.onDragStart,
	        onDrag: this.onDrag,
	        onResizeStart: this.onResizeStart,
	        onResize: this.onResize,
	        onResizeStop: this.onResizeStop,
	        isDraggable: draggable,
	        isResizable: resizable,
	        useCSSTransforms: useCSSTransforms && mounted,
	        usePercentages: !mounted,
	        w: l.w,
	        h: l.h,
	        x: l.x,
	        y: l.y,
	        i: l.i,
	        minH: l.minH,
	        minW: l.minW,
	        maxH: l.maxH,
	        maxW: l.maxW,
	        "static": l.static
	      },
	      child
	    );
	  };
	
	  ReactGridLayout.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props5 = this.props,
	        className = _props5.className,
	        style = _props5.style;
	
	
	    var mergedClassName = (0, _classnames2.default)("react-grid-layout", className);
	    var mergedStyle = _extends({
	      height: this.containerHeight()
	    }, style);
	
	    return _react2.default.createElement(
	      "div",
	      { className: mergedClassName, style: mergedStyle },
	      _react2.default.Children.map(this.props.children, function (child) {
	        return _this2.processGridItem(child);
	      }),
	      this.placeholder()
	    );
	  };
	
	  return ReactGridLayout;
	}(_react2.default.Component);
	
	ReactGridLayout.displayName = "ReactGridLayout";
	ReactGridLayout.propTypes = {
	  //
	  // Basic props
	  //
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	
	  // This can be set explicitly. If it is not set, it will automatically
	  // be set to the container width. Note that resizes will *not* cause this to adjust.
	  // If you need that behavior, use WidthProvider.
	  width: _propTypes2.default.number,
	
	  // If true, the container height swells and contracts to fit contents
	  autoSize: _propTypes2.default.bool,
	  // # of cols.
	  cols: _propTypes2.default.number,
	
	  // A selector that will not be draggable.
	  draggableCancel: _propTypes2.default.string,
	  // A selector for the draggable handler
	  draggableHandle: _propTypes2.default.string,
	
	  // Deprecated
	  verticalCompact: function verticalCompact(props) {
	    if (props.verticalCompact === false && ("production") !== "production") {
	      console.warn(
	      // eslint-disable-line no-console
	      "`verticalCompact` on <ReactGridLayout> is deprecated and will be removed soon. " + 'Use `compactType`: "horizontal" | "vertical" | null.');
	    }
	  },
	  // Choose vertical or hotizontal compaction
	  compactType: _propTypes2.default.oneOf(["vertical", "horizontal"]),
	
	  // layout is an array of object with the format:
	  // {x: Number, y: Number, w: Number, h: Number, i: String}
	  layout: function layout(props) {
	    var layout = props.layout;
	    // I hope you're setting the data-grid property on the grid items
	    if (layout === undefined) return;
	    (0, _utils.validateLayout)(layout, "layout");
	  },
	
	  //
	  // Grid Dimensions
	  //
	
	  // Margin between items [x, y] in px
	  margin: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  // Padding inside the container [x, y] in px
	  containerPadding: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  // Rows have a static height, but you can change this based on breakpoints if you like
	  rowHeight: _propTypes2.default.number,
	  // Default Infinity, but you can specify a max here if you like.
	  // Note that this isn't fully fleshed out and won't error if you specify a layout that
	  // extends beyond the row capacity. It will, however, not allow users to drag/resize
	  // an item past the barrier. They can push items beyond the barrier, though.
	  // Intentionally not documented for this reason.
	  maxRows: _propTypes2.default.number,
	
	  //
	  // Flags
	  //
	  isDraggable: _propTypes2.default.bool,
	  isResizable: _propTypes2.default.bool,
	  // If true, grid items won't change position when being dragged over.
	  preventCollision: _propTypes2.default.bool,
	  // Use CSS transforms instead of top/left
	  useCSSTransforms: _propTypes2.default.bool,
	
	  //
	  // Callbacks
	  //
	
	  // Callback so you can save the layout. Calls after each drag & resize stops.
	  onLayoutChange: _propTypes2.default.func,
	
	  // Calls when drag starts. Callback is of the signature (layout, oldItem, newItem, placeholder, e, ?node).
	  // All callbacks below have the same signature. 'start' and 'stop' callbacks omit the 'placeholder'.
	  onDragStart: _propTypes2.default.func,
	  // Calls on each drag movement.
	  onDrag: _propTypes2.default.func,
	  // Calls when drag is complete.
	  onDragStop: _propTypes2.default.func,
	  //Calls when resize starts.
	  onResizeStart: _propTypes2.default.func,
	  // Calls when resize movement happens.
	  onResize: _propTypes2.default.func,
	  // Calls when resize is complete.
	  onResizeStop: _propTypes2.default.func,
	
	  //
	  // Other validations
	  //
	
	  // Children must not have duplicate keys.
	  children: function children(props, propName) {
	    var children = props[propName];
	
	    // Check children keys for duplicates. Throw if found.
	    var keys = {};
	    _react2.default.Children.forEach(children, function (child) {
	      if (keys[child.key]) {
	        throw new Error('Duplicate child key "' + child.key + '" found! This will cause problems in ReactGridLayout.');
	      }
	      keys[child.key] = true;
	    });
	  }
	};
	ReactGridLayout.defaultProps = {
	  autoSize: true,
	  cols: 12,
	  className: "",
	  style: {},
	  draggableHandle: "",
	  draggableCancel: "",
	  containerPadding: null,
	  rowHeight: 150,
	  maxRows: Infinity, // infinite vertical growth
	  layout: [],
	  margin: [10, 10],
	  isDraggable: true,
	  isResizable: true,
	  useCSSTransforms: true,
	  verticalCompact: true,
	  compactType: "vertical",
	  preventCollision: false,
	  onLayoutChange: _utils.noop,
	  onDragStart: _utils.noop,
	  onDrag: _utils.noop,
	  onDragStop: _utils.noop,
	  onResizeStart: _utils.noop,
	  onResize: _utils.noop,
	  onResizeStop: _utils.noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  this.state = {
	    activeDrag: null,
	    layout: (0, _utils.synchronizeLayoutWithChildren)(this.props.layout, this.props.children, this.props.cols,
	    // Legacy support for verticalCompact: false
	    this.compactType()),
	    mounted: false,
	    oldDragItem: null,
	    oldLayout: null,
	    oldResizeItem: null
	  };
	};
	
	exports.default = ReactGridLayout;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getBreakpointFromWidth = getBreakpointFromWidth;
	exports.getColsFromBreakpoint = getColsFromBreakpoint;
	exports.findOrGenerateResponsiveLayout = findOrGenerateResponsiveLayout;
	exports.sortBreakpoints = sortBreakpoints;
	
	var _utils = __webpack_require__(297);
	
	/**
	 * Given a width, find the highest breakpoint that matches is valid for it (width > breakpoint).
	 *
	 * @param  {Object} breakpoints Breakpoints object (e.g. {lg: 1200, md: 960, ...})
	 * @param  {Number} width Screen width.
	 * @return {String}       Highest breakpoint that is less than width.
	 */
	function getBreakpointFromWidth(breakpoints, width) {
	  var sorted = sortBreakpoints(breakpoints);
	  var matching = sorted[0];
	  for (var i = 1, len = sorted.length; i < len; i++) {
	    var breakpointName = sorted[i];
	    if (width > breakpoints[breakpointName]) matching = breakpointName;
	  }
	  return matching;
	}
	
	/**
	 * Given a breakpoint, get the # of cols set for it.
	 * @param  {String} breakpoint Breakpoint name.
	 * @param  {Object} cols       Map of breakpoints to cols.
	 * @return {Number}            Number of cols.
	 */
	
	
	function getColsFromBreakpoint(breakpoint, cols) {
	  if (!cols[breakpoint]) {
	    throw new Error("ResponsiveReactGridLayout: `cols` entry for breakpoint " + breakpoint + " is missing!");
	  }
	  return cols[breakpoint];
	}
	
	/**
	 * Given existing layouts and a new breakpoint, find or generate a new layout.
	 *
	 * This finds the layout above the new one and generates from it, if it exists.
	 *
	 * @param  {Object} layouts     Existing layouts.
	 * @param  {Array} breakpoints All breakpoints.
	 * @param  {String} breakpoint New breakpoint.
	 * @param  {String} breakpoint Last breakpoint (for fallback).
	 * @param  {Number} cols       Column count at new breakpoint.
	 * @param  {Boolean} verticalCompact Whether or not to compact the layout
	 *   vertically.
	 * @return {Array}             New layout.
	 */
	function findOrGenerateResponsiveLayout(layouts, breakpoints, breakpoint, lastBreakpoint, cols, compactType) {
	  // If it already exists, just return it.
	  if (layouts[breakpoint]) return (0, _utils.cloneLayout)(layouts[breakpoint]);
	  // Find or generate the next layout
	  var layout = layouts[lastBreakpoint];
	  var breakpointsSorted = sortBreakpoints(breakpoints);
	  var breakpointsAbove = breakpointsSorted.slice(breakpointsSorted.indexOf(breakpoint));
	  for (var i = 0, len = breakpointsAbove.length; i < len; i++) {
	    var b = breakpointsAbove[i];
	    if (layouts[b]) {
	      layout = layouts[b];
	      break;
	    }
	  }
	  layout = (0, _utils.cloneLayout)(layout || []); // clone layout so we don't modify existing items
	  return (0, _utils.compact)((0, _utils.correctBounds)(layout, { cols: cols }), compactType, cols);
	}
	
	/**
	 * Given breakpoints, return an array of breakpoints sorted by width. This is usually
	 * e.g. ['xxs', 'xs', 'sm', ...]
	 *
	 * @param  {Object} breakpoints Key/value pair of breakpoint names to widths.
	 * @return {Array}              Sorted breakpoints.
	 */
	function sortBreakpoints(breakpoints) {
	  var keys = Object.keys(breakpoints);
	  return keys.sort(function (a, b) {
	    return breakpoints[a] - breakpoints[b];
	  });
	}

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaUser = function FaUser(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.9 31.4q0 2.6-1.6 4.2t-4.3 1.5h-19.5q-2.7 0-4.4-1.5t-1.6-4.2q0-1.2 0.1-2.3t0.3-2.5 0.6-2.4 0.9-2.2 1.4-1.8 1.9-1.2 2.5-0.4q0.2 0 1 0.5t1.6 1 2.4 1.1 3 0.5 3-0.5 2.4-1.1 1.7-1 0.9-0.5q1.4 0 2.5 0.4t1.9 1.2 1.4 1.8 0.9 2.2 0.6 2.4 0.4 2.5 0 2.3z m-7.1-20q0 3.6-2.5 6.1t-6.1 2.5-6-2.5-2.6-6.1 2.6-6 6-2.5 6.1 2.5 2.5 6z' })
	        )
	    );
	};
	
	exports.default = FaUser;
	module.exports = exports['default'];

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1837);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 851 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDraggable = __webpack_require__(1850);
	
	var _utils = __webpack_require__(1846);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Resizable =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Resizable, _React$Component);
	
	  function Resizable() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      slackW: 0,
	      slackH: 0
	    });
	
	    return _this;
	  }
	
	  var _proto = Resizable.prototype;
	
	  _proto.lockAspectRatio = function lockAspectRatio(width, height, aspectRatio) {
	    height = width / aspectRatio;
	    width = height * aspectRatio;
	    return [width, height];
	  } // If you do this, be careful of constraints
	  ;
	
	  _proto.runConstraints = function runConstraints(width, height) {
	    var _ref = [this.props.minConstraints, this.props.maxConstraints],
	        min = _ref[0],
	        max = _ref[1];
	    if (!min && !max) return [width, height]; // Fit width & height to aspect ratio
	
	    if (this.props.lockAspectRatio) {
	      if (height === this.props.height) {
	        var ratio = this.props.width / this.props.height;
	        height = width / ratio;
	        width = height * ratio;
	      } else {
	        // Take into account vertical resize with N/S handles on locked aspect
	        // ratio. Calculate the change height-first, instead of width-first
	        var _ratio = this.props.height / this.props.width;
	
	        width = height / _ratio;
	        height = width * _ratio;
	      }
	    }
	
	    var oldW = width,
	        oldH = height; // Add slack to the values used to calculate bound position. This will ensure that if
	    // we start removing slack, the element won't react to it right away until it's been
	    // completely removed.
	
	    var _this$state = this.state,
	        slackW = _this$state.slackW,
	        slackH = _this$state.slackH;
	    width += slackW;
	    height += slackH;
	
	    if (min) {
	      width = Math.max(min[0], width);
	      height = Math.max(min[1], height);
	    }
	
	    if (max) {
	      width = Math.min(max[0], width);
	      height = Math.min(max[1], height);
	    } // If the numbers changed, we must have introduced some slack. Record it for the next iteration.
	
	
	    slackW += oldW - width;
	    slackH += oldH - height;
	
	    if (slackW !== this.state.slackW || slackH !== this.state.slackH) {
	      this.setState({
	        slackW: slackW,
	        slackH: slackH
	      });
	    }
	
	    return [width, height];
	  }
	  /**
	   * Wrapper around drag events to provide more useful data.
	   *
	   * @param  {String} handlerName Handler name to wrap.
	   * @return {Function}           Handler function.
	   */
	  ;
	
	  _proto.resizeHandler = function resizeHandler(handlerName, axis) {
	    var _this2 = this;
	
	    return function (e, _ref2) {
	      var node = _ref2.node,
	          deltaX = _ref2.deltaX,
	          deltaY = _ref2.deltaY;
	      deltaX /= _this2.props.transformScale;
	      deltaY /= _this2.props.transformScale; // Axis restrictions
	
	      var canDragX = (_this2.props.axis === 'both' || _this2.props.axis === 'x') && ['n', 's'].indexOf(axis) === -1;
	      var canDragY = (_this2.props.axis === 'both' || _this2.props.axis === 'y') && ['e', 'w'].indexOf(axis) === -1; // reverse delta if using top or left drag handles
	
	      if (canDragX && axis[axis.length - 1] === 'w') {
	        deltaX = -deltaX;
	      }
	
	      if (canDragY && axis[0] === 'n') {
	        deltaY = -deltaY;
	      } // Update w/h
	
	
	      var width = _this2.props.width + (canDragX ? deltaX : 0);
	      var height = _this2.props.height + (canDragY ? deltaY : 0); // Early return if no change
	
	      var widthChanged = width !== _this2.props.width,
	          heightChanged = height !== _this2.props.height;
	      if (handlerName === 'onResize' && !widthChanged && !heightChanged) return;
	
	      var _this2$runConstraints = _this2.runConstraints(width, height);
	
	      width = _this2$runConstraints[0];
	      height = _this2$runConstraints[1];
	      // Set the appropriate state for this handler.
	      var newState = {};
	
	      if (handlerName === 'onResizeStart') {// nothing
	      } else if (handlerName === 'onResizeStop') {
	        newState.slackW = newState.slackH = 0;
	      } else {
	        // Early return if no change after constraints
	        if (width === _this2.props.width && height === _this2.props.height) return;
	      }
	
	      var hasCb = typeof _this2.props[handlerName] === 'function';
	
	      if (hasCb) {
	        // $FlowIgnore isn't refining this correctly to SyntheticEvent
	        if (typeof e.persist === 'function') e.persist();
	
	        _this2.setState(newState, function () {
	          return _this2.props[handlerName](e, {
	            node: node,
	            size: {
	              width: width,
	              height: height
	            },
	            handle: axis
	          });
	        });
	      } else {
	        _this2.setState(newState);
	      }
	    };
	  };
	
	  _proto.renderResizeHandle = function renderResizeHandle(resizeHandle) {
	    var handle = this.props.handle;
	
	    if (handle) {
	      if (typeof handle === 'function') {
	        return handle(resizeHandle);
	      }
	
	      return handle;
	    }
	
	    return _react.default.createElement("span", {
	      className: "react-resizable-handle react-resizable-handle-" + resizeHandle
	    });
	  };
	
	  _proto.render = function render() {
	    var _this3 = this;
	
	    // eslint-disable-next-line no-unused-vars
	    var _this$props = this.props,
	        children = _this$props.children,
	        draggableOpts = _this$props.draggableOpts,
	        width = _this$props.width,
	        height = _this$props.height,
	        handleSize = _this$props.handleSize,
	        lockAspectRatio = _this$props.lockAspectRatio,
	        axis = _this$props.axis,
	        minConstraints = _this$props.minConstraints,
	        maxConstraints = _this$props.maxConstraints,
	        onResize = _this$props.onResize,
	        onResizeStop = _this$props.onResizeStop,
	        onResizeStart = _this$props.onResizeStart,
	        resizeHandles = _this$props.resizeHandles,
	        transformScale = _this$props.transformScale,
	        p = _objectWithoutPropertiesLoose(_this$props, ["children", "draggableOpts", "width", "height", "handleSize", "lockAspectRatio", "axis", "minConstraints", "maxConstraints", "onResize", "onResizeStop", "onResizeStart", "resizeHandles", "transformScale"]);
	
	    var className = p.className ? p.className + " react-resizable" : 'react-resizable'; // What we're doing here is getting the child of this element, and cloning it with this element's props.
	    // We are then defining its children as:
	    // Its original children (resizable's child's children), and
	    // One or more draggable handles.
	
	    return (0, _utils.cloneElement)(children, _objectSpread({}, p, {
	      className: className,
	      children: [children.props.children, resizeHandles.map(function (h) {
	        return _react.default.createElement(_reactDraggable.DraggableCore, _extends({}, draggableOpts, {
	          key: "resizableHandle-" + h,
	          onStop: _this3.resizeHandler('onResizeStop', h),
	          onStart: _this3.resizeHandler('onResizeStart', h),
	          onDrag: _this3.resizeHandler('onResize', h)
	        }), _this3.renderResizeHandle(h));
	      })]
	    }));
	  };
	
	  return Resizable;
	}(_react.default.Component);
	
	exports.default = Resizable;
	
	_defineProperty(Resizable, "propTypes", {
	  //
	  // Required Props
	  //
	  // Require that one and only one child be present.
	  children: _propTypes.default.element.isRequired,
	  // Initial w/h
	  width: _propTypes.default.number.isRequired,
	  height: _propTypes.default.number.isRequired,
	  //
	  // Optional props
	  //
	  // Custom resize handle
	  handle: _propTypes.default.element,
	  // If you change this, be sure to update your css
	  handleSize: _propTypes.default.array,
	  // Defines which resize handles should be rendered (default: 'se')
	  // Allows for any combination of:
	  // 's' - South handle (bottom-center)
	  // 'w' - West handle (left-center)
	  // 'e' - East handle (right-center)
	  // 'n' - North handle (top-center)
	  // 'sw' - Southwest handle (bottom-left)
	  // 'nw' - Northwest handle (top-left)
	  // 'se' - Southeast handle (bottom-right)
	  // 'ne' - Northeast handle (top-center)
	  resizeHandles: _propTypes.default.arrayOf(_propTypes.default.oneOf(['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne'])),
	  transformScale: _propTypes.default.number,
	  // If true, will only allow width/height to move in lockstep
	  lockAspectRatio: _propTypes.default.bool,
	  // Restricts resizing to a particular axis (default: 'both')
	  // 'both' - allows resizing by width or height
	  // 'x' - only allows the width to be changed
	  // 'y' - only allows the height to be changed
	  // 'none' - disables resizing altogether
	  axis: _propTypes.default.oneOf(['both', 'x', 'y', 'none']),
	  // Min/max size
	  minConstraints: _propTypes.default.arrayOf(_propTypes.default.number),
	  maxConstraints: _propTypes.default.arrayOf(_propTypes.default.number),
	  // Callbacks
	  onResizeStop: _propTypes.default.func,
	  onResizeStart: _propTypes.default.func,
	  onResize: _propTypes.default.func,
	  // These will be passed wholesale to react-draggable's DraggableCore
	  draggableOpts: _propTypes.default.object
	});
	
	_defineProperty(Resizable, "defaultProps", {
	  handleSize: [20, 20],
	  lockAspectRatio: false,
	  axis: 'both',
	  minConstraints: [20, 20],
	  maxConstraints: [Infinity, Infinity],
	  resizeHandles: ['se'],
	  transformScale: 1
	});

/***/ }),
/* 853 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = log;
	
	/*eslint no-console:0*/
	function log() {
	  var _console;
	
	  if (undefined) (_console = console).log.apply(_console, arguments);
	}

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBoundPosition = getBoundPosition;
	exports.snapToGrid = snapToGrid;
	exports.canDragX = canDragX;
	exports.canDragY = canDragY;
	exports.getControlPosition = getControlPosition;
	exports.createCoreData = createCoreData;
	exports.createDraggableData = createDraggableData;
	
	var _shims = __webpack_require__(380);
	
	var _domFns = __webpack_require__(529);
	
	function getBoundPosition(draggable
	/*: Draggable*/
	, x
	/*: number*/
	, y
	/*: number*/
	)
	/*: [number, number]*/
	{
	  // If no bounds, short-circuit and move on
	  if (!draggable.props.bounds) return [x, y]; // Clone new bounds
	
	  var bounds = draggable.props.bounds;
	  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
	  var node = findDOMNode(draggable);
	
	  if (typeof bounds === 'string') {
	    var ownerDocument = node.ownerDocument;
	    var ownerWindow = ownerDocument.defaultView;
	    var boundNode;
	
	    if (bounds === 'parent') {
	      boundNode = node.parentNode;
	    } else {
	      boundNode = ownerDocument.querySelector(bounds);
	    }
	
	    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
	      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
	    }
	
	    var boundNodeEl
	    /*: HTMLElement*/
	    = boundNode; // for Flow, can't seem to refine correctly
	
	    var nodeStyle = ownerWindow.getComputedStyle(node);
	    var boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl); // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
	
	    bounds = {
	      left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
	      top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
	      right: (0, _domFns.innerWidth)(boundNodeEl) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
	      bottom: (0, _domFns.innerHeight)(boundNodeEl) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
	    };
	  } // Keep x and y below right and bottom limits...
	
	
	  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
	  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom); // But above left and top limits.
	
	  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
	  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);
	  return [x, y];
	}
	
	function snapToGrid(grid
	/*: [number, number]*/
	, pendingX
	/*: number*/
	, pendingY
	/*: number*/
	)
	/*: [number, number]*/
	{
	  var x = Math.round(pendingX / grid[0]) * grid[0];
	  var y = Math.round(pendingY / grid[1]) * grid[1];
	  return [x, y];
	}
	
	function canDragX(draggable
	/*: Draggable*/
	)
	/*: boolean*/
	{
	  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
	}
	
	function canDragY(draggable
	/*: Draggable*/
	)
	/*: boolean*/
	{
	  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
	} // Get {x, y} positions from event.
	
	
	function getControlPosition(e
	/*: MouseTouchEvent*/
	, touchIdentifier
	/*: ?number*/
	, draggableCore
	/*: DraggableCore*/
	)
	/*: ?ControlPosition*/
	{
	  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
	  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
	
	  var node = findDOMNode(draggableCore); // User can provide an offsetParent if desired.
	
	  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
	  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
	} // Create an data object exposed by <DraggableCore>'s events
	
	
	function createCoreData(draggable
	/*: DraggableCore*/
	, x
	/*: number*/
	, y
	/*: number*/
	)
	/*: DraggableData*/
	{
	  var state = draggable.state;
	  var isStart = !(0, _shims.isNum)(state.lastX);
	  var node = findDOMNode(draggable);
	
	  if (isStart) {
	    // If this is our first move, use the x and y as last coords.
	    return {
	      node: node,
	      deltaX: 0,
	      deltaY: 0,
	      lastX: x,
	      lastY: y,
	      x: x,
	      y: y
	    };
	  } else {
	    // Otherwise calculate proper values.
	    return {
	      node: node,
	      deltaX: x - state.lastX,
	      deltaY: y - state.lastY,
	      lastX: state.lastX,
	      lastY: state.lastY,
	      x: x,
	      y: y
	    };
	  }
	} // Create an data exposed by <Draggable>'s events
	
	
	function createDraggableData(draggable
	/*: Draggable*/
	, coreData
	/*: DraggableData*/
	)
	/*: DraggableData*/
	{
	  var scale = draggable.props.scale;
	  return {
	    node: coreData.node,
	    x: draggable.state.x + coreData.deltaX / scale,
	    y: draggable.state.y + coreData.deltaY / scale,
	    deltaX: coreData.deltaX / scale,
	    deltaY: coreData.deltaY / scale,
	    lastX: draggable.state.x,
	    lastY: draggable.state.y
	  };
	} // A lot faster than stringify/parse
	
	
	function cloneBounds(bounds
	/*: Bounds*/
	)
	/*: Bounds*/
	{
	  return {
	    left: bounds.left,
	    top: bounds.top,
	    right: bounds.right,
	    bottom: bounds.bottom
	  };
	}
	
	function findDOMNode(draggable
	/*: Draggable | DraggableCore*/
	)
	/*: HTMLElement*/
	{
	  var node = draggable.findDOMNode();
	
	  if (!node) {
	    throw new Error('<DraggableCore>: Unmounted during event!');
	  } // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
	
	
	  return node;
	}

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	/**
	 * Represents a cancellation caused by navigating away
	 * before the previous transition has fully resolved.
	 */
	"use strict";
	
	function Cancellation() {}
	
	module.exports = Cancellation;

/***/ }),
/* 856 */
/***/ (function(module, exports) {

	/**
	 * Encapsulates a redirect to the given route.
	 */
	"use strict";
	
	function Redirect(to, params, query) {
	  this.to = to;
	  this.params = params;
	  this.query = query;
	}
	
	module.exports = Redirect;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var LocationActions = __webpack_require__(299);
	
	/**
	 * A scroll behavior that attempts to imitate the default behavior
	 * of modern browsers.
	 */
	var ImitateBrowserBehavior = {
	
	  updateScrollPosition: function updateScrollPosition(position, actionType) {
	    switch (actionType) {
	      case LocationActions.PUSH:
	      case LocationActions.REPLACE:
	        window.scrollTo(0, 0);
	        break;
	      case LocationActions.POP:
	        if (position) {
	          window.scrollTo(position.x, position.y);
	        } else {
	          window.scrollTo(0, 0);
	        }
	        break;
	    }
	  }
	
	};
	
	module.exports = ImitateBrowserBehavior;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(167);
	var RouteHandler = __webpack_require__(382);
	var Route = __webpack_require__(381);
	
	/**
	 * A <DefaultRoute> component is a special kind of <Route> that
	 * renders when its parent matches but none of its siblings do.
	 * Only one such route may be used at any given level in the
	 * route hierarchy.
	 */
	
	var DefaultRoute = (function (_Route) {
	  _inherits(DefaultRoute, _Route);
	
	  function DefaultRoute() {
	    _classCallCheck(this, DefaultRoute);
	
	    _get(Object.getPrototypeOf(DefaultRoute.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  return DefaultRoute;
	})(Route);
	
	DefaultRoute.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.falsy,
	  children: PropTypes.falsy,
	  handler: PropTypes.func.isRequired
	};
	
	DefaultRoute.defaultProps = {
	  handler: RouteHandler
	};
	
	module.exports = DefaultRoute;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(167);
	var RouteHandler = __webpack_require__(382);
	var Route = __webpack_require__(381);
	
	/**
	 * A <NotFoundRoute> is a special kind of <Route> that
	 * renders when the beginning of its parent's path matches
	 * but none of its siblings do, including any <DefaultRoute>.
	 * Only one such route may be used at any given level in the
	 * route hierarchy.
	 */
	
	var NotFoundRoute = (function (_Route) {
	  _inherits(NotFoundRoute, _Route);
	
	  function NotFoundRoute() {
	    _classCallCheck(this, NotFoundRoute);
	
	    _get(Object.getPrototypeOf(NotFoundRoute.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  return NotFoundRoute;
	})(Route);
	
	NotFoundRoute.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.falsy,
	  children: PropTypes.falsy,
	  handler: PropTypes.func.isRequired
	};
	
	NotFoundRoute.defaultProps = {
	  handler: RouteHandler
	};
	
	module.exports = NotFoundRoute;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(167);
	var Route = __webpack_require__(381);
	
	/**
	 * A <Redirect> component is a special kind of <Route> that always
	 * redirects to another route when it matches.
	 */
	
	var Redirect = (function (_Route) {
	  _inherits(Redirect, _Route);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    _get(Object.getPrototypeOf(Redirect.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  return Redirect;
	})(Route);
	
	Redirect.propTypes = {
	  path: PropTypes.string,
	  from: PropTypes.string, // Alias for path.
	  to: PropTypes.string,
	  handler: PropTypes.falsy
	};
	
	// Redirects should not have a default handler
	Redirect.defaultProps = {};
	
	module.exports = Redirect;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint -W058 */
	'use strict';
	
	var React = __webpack_require__(1);
	var warning = __webpack_require__(532);
	var invariant = __webpack_require__(68);
	var canUseDOM = __webpack_require__(317);
	var LocationActions = __webpack_require__(299);
	var ImitateBrowserBehavior = __webpack_require__(857);
	var HashLocation = __webpack_require__(863);
	var HistoryLocation = __webpack_require__(531);
	var RefreshLocation = __webpack_require__(864);
	var StaticLocation = __webpack_require__(865);
	var ScrollHistory = __webpack_require__(1854);
	var createRoutesFromReactChildren = __webpack_require__(862);
	var isReactChildren = __webpack_require__(1861);
	var Transition = __webpack_require__(1856);
	var PropTypes = __webpack_require__(167);
	var Redirect = __webpack_require__(856);
	var History = __webpack_require__(250);
	var Cancellation = __webpack_require__(855);
	var Match = __webpack_require__(1852);
	var Route = __webpack_require__(215);
	var supportsHistory = __webpack_require__(1864);
	var PathUtils = __webpack_require__(530);
	
	/**
	 * The default location for new routers.
	 */
	var DEFAULT_LOCATION = canUseDOM ? HashLocation : '/';
	
	/**
	 * The default scroll behavior for new routers.
	 */
	var DEFAULT_SCROLL_BEHAVIOR = canUseDOM ? ImitateBrowserBehavior : null;
	
	function hasProperties(object, properties) {
	  for (var propertyName in properties) if (properties.hasOwnProperty(propertyName) && object[propertyName] !== properties[propertyName]) return false;
	
	  return true;
	}
	
	function hasMatch(routes, route, prevParams, nextParams, prevQuery, nextQuery) {
	  return routes.some(function (r) {
	    if (r !== route) return false;
	
	    var paramNames = route.paramNames;
	    var paramName;
	
	    // Ensure that all params the route cares about did not change.
	    for (var i = 0, len = paramNames.length; i < len; ++i) {
	      paramName = paramNames[i];
	
	      if (nextParams[paramName] !== prevParams[paramName]) return false;
	    }
	
	    // Ensure the query hasn't changed.
	    return hasProperties(prevQuery, nextQuery) && hasProperties(nextQuery, prevQuery);
	  });
	}
	
	function addRoutesToNamedRoutes(routes, namedRoutes) {
	  var route;
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    route = routes[i];
	
	    if (route.name) {
	      invariant(namedRoutes[route.name] == null, 'You may not have more than one route named "%s"', route.name);
	
	      namedRoutes[route.name] = route;
	    }
	
	    if (route.childRoutes) addRoutesToNamedRoutes(route.childRoutes, namedRoutes);
	  }
	}
	
	function routeIsActive(activeRoutes, routeName) {
	  return activeRoutes.some(function (route) {
	    return route.name === routeName;
	  });
	}
	
	function paramsAreActive(activeParams, params) {
	  for (var property in params) if (String(activeParams[property]) !== String(params[property])) return false;
	
	  return true;
	}
	
	function queryIsActive(activeQuery, query) {
	  for (var property in query) if (String(activeQuery[property]) !== String(query[property])) return false;
	
	  return true;
	}
	
	/**
	 * Creates and returns a new router using the given options. A router
	 * is a ReactComponent class that knows how to react to changes in the
	 * URL and keep the contents of the page in sync.
	 *
	 * Options may be any of the following:
	 *
	 * - routes           (required) The route config
	 * - location         The location to use. Defaults to HashLocation when
	 *                    the DOM is available, "/" otherwise
	 * - scrollBehavior   The scroll behavior to use. Defaults to ImitateBrowserBehavior
	 *                    when the DOM is available, null otherwise
	 * - onError          A function that is used to handle errors
	 * - onAbort          A function that is used to handle aborted transitions
	 *
	 * When rendering in a server-side environment, the location should simply
	 * be the URL path that was used in the request, including the query string.
	 */
	function createRouter(options) {
	  options = options || {};
	
	  if (isReactChildren(options)) options = { routes: options };
	
	  var mountedComponents = [];
	  var location = options.location || DEFAULT_LOCATION;
	  var scrollBehavior = options.scrollBehavior || DEFAULT_SCROLL_BEHAVIOR;
	  var state = {};
	  var nextState = {};
	  var pendingTransition = null;
	  var dispatchHandler = null;
	
	  if (typeof location === 'string') location = new StaticLocation(location);
	
	  if (location instanceof StaticLocation) {
	    warning(!canUseDOM || ("production") === 'test', 'You should not use a static location in a DOM environment because ' + 'the router will not be kept in sync with the current URL');
	  } else {
	    invariant(canUseDOM || location.needsDOM === false, 'You cannot use %s without a DOM', location);
	  }
	
	  // Automatically fall back to full page refreshes in
	  // browsers that don't support the HTML history API.
	  if (location === HistoryLocation && !supportsHistory()) location = RefreshLocation;
	
	  var Router = React.createClass({
	
	    displayName: 'Router',
	
	    statics: {
	
	      isRunning: false,
	
	      cancelPendingTransition: function cancelPendingTransition() {
	        if (pendingTransition) {
	          pendingTransition.cancel();
	          pendingTransition = null;
	        }
	      },
	
	      clearAllRoutes: function clearAllRoutes() {
	        Router.cancelPendingTransition();
	        Router.namedRoutes = {};
	        Router.routes = [];
	      },
	
	      /**
	       * Adds routes to this router from the given children object (see ReactChildren).
	       */
	      addRoutes: function addRoutes(routes) {
	        if (isReactChildren(routes)) routes = createRoutesFromReactChildren(routes);
	
	        addRoutesToNamedRoutes(routes, Router.namedRoutes);
	
	        Router.routes.push.apply(Router.routes, routes);
	      },
	
	      /**
	       * Replaces routes of this router from the given children object (see ReactChildren).
	       */
	      replaceRoutes: function replaceRoutes(routes) {
	        Router.clearAllRoutes();
	        Router.addRoutes(routes);
	        Router.refresh();
	      },
	
	      /**
	       * Performs a match of the given path against this router and returns an object
	       * with the { routes, params, pathname, query } that match. Returns null if no
	       * match can be made.
	       */
	      match: function match(path) {
	        return Match.findMatch(Router.routes, path);
	      },
	
	      /**
	       * Returns an absolute URL path created from the given route
	       * name, URL parameters, and query.
	       */
	      makePath: function makePath(to, params, query) {
	        var path;
	        if (PathUtils.isAbsolute(to)) {
	          path = to;
	        } else {
	          var route = to instanceof Route ? to : Router.namedRoutes[to];
	
	          invariant(route instanceof Route, 'Cannot find a route named "%s"', to);
	
	          path = route.path;
	        }
	
	        return PathUtils.withQuery(PathUtils.injectParams(path, params), query);
	      },
	
	      /**
	       * Returns a string that may safely be used as the href of a link
	       * to the route with the given name, URL parameters, and query.
	       */
	      makeHref: function makeHref(to, params, query) {
	        var path = Router.makePath(to, params, query);
	        return location === HashLocation ? '#' + path : path;
	      },
	
	      /**
	       * Transitions to the URL specified in the arguments by pushing
	       * a new URL onto the history stack.
	       */
	      transitionTo: function transitionTo(to, params, query) {
	        var path = Router.makePath(to, params, query);
	
	        if (pendingTransition) {
	          // Replace so pending location does not stay in history.
	          location.replace(path);
	        } else {
	          location.push(path);
	        }
	      },
	
	      /**
	       * Transitions to the URL specified in the arguments by replacing
	       * the current URL in the history stack.
	       */
	      replaceWith: function replaceWith(to, params, query) {
	        location.replace(Router.makePath(to, params, query));
	      },
	
	      /**
	       * Transitions to the previous URL if one is available. Returns true if the
	       * router was able to go back, false otherwise.
	       *
	       * Note: The router only tracks history entries in your application, not the
	       * current browser session, so you can safely call this function without guarding
	       * against sending the user back to some other site. However, when using
	       * RefreshLocation (which is the fallback for HistoryLocation in browsers that
	       * don't support HTML5 history) this method will *always* send the client back
	       * because we cannot reliably track history length.
	       */
	      goBack: function goBack() {
	        if (History.length > 1 || location === RefreshLocation) {
	          location.pop();
	          return true;
	        }
	
	        warning(false, 'goBack() was ignored because there is no router history');
	
	        return false;
	      },
	
	      handleAbort: options.onAbort || function (abortReason) {
	        if (location instanceof StaticLocation) throw new Error('Unhandled aborted transition! Reason: ' + abortReason);
	
	        if (abortReason instanceof Cancellation) {
	          return;
	        } else if (abortReason instanceof Redirect) {
	          location.replace(Router.makePath(abortReason.to, abortReason.params, abortReason.query));
	        } else {
	          location.pop();
	        }
	      },
	
	      handleError: options.onError || function (error) {
	        // Throw so we don't silently swallow async errors.
	        throw error; // This error probably originated in a transition hook.
	      },
	
	      handleLocationChange: function handleLocationChange(change) {
	        Router.dispatch(change.path, change.type);
	      },
	
	      /**
	       * Performs a transition to the given path and calls callback(error, abortReason)
	       * when the transition is finished. If both arguments are null the router's state
	       * was updated. Otherwise the transition did not complete.
	       *
	       * In a transition, a router first determines which routes are involved by beginning
	       * with the current route, up the route tree to the first parent route that is shared
	       * with the destination route, and back down the tree to the destination route. The
	       * willTransitionFrom hook is invoked on all route handlers we're transitioning away
	       * from, in reverse nesting order. Likewise, the willTransitionTo hook is invoked on
	       * all route handlers we're transitioning to.
	       *
	       * Both willTransitionFrom and willTransitionTo hooks may either abort or redirect the
	       * transition. To resolve asynchronously, they may use the callback argument. If no
	       * hooks wait, the transition is fully synchronous.
	       */
	      dispatch: function dispatch(path, action) {
	        Router.cancelPendingTransition();
	
	        var prevPath = state.path;
	        var isRefreshing = action == null;
	
	        if (prevPath === path && !isRefreshing) return; // Nothing to do!
	
	        // Record the scroll position as early as possible to
	        // get it before browsers try update it automatically.
	        if (prevPath && action === LocationActions.PUSH) Router.recordScrollPosition(prevPath);
	
	        var match = Router.match(path);
	
	        warning(match != null, 'No route matches path "%s". Make sure you have <Route path="%s"> somewhere in your routes', path, path);
	
	        if (match == null) match = {};
	
	        var prevRoutes = state.routes || [];
	        var prevParams = state.params || {};
	        var prevQuery = state.query || {};
	
	        var nextRoutes = match.routes || [];
	        var nextParams = match.params || {};
	        var nextQuery = match.query || {};
	
	        var fromRoutes, toRoutes;
	        if (prevRoutes.length) {
	          fromRoutes = prevRoutes.filter(function (route) {
	            return !hasMatch(nextRoutes, route, prevParams, nextParams, prevQuery, nextQuery);
	          });
	
	          toRoutes = nextRoutes.filter(function (route) {
	            return !hasMatch(prevRoutes, route, prevParams, nextParams, prevQuery, nextQuery);
	          });
	        } else {
	          fromRoutes = [];
	          toRoutes = nextRoutes;
	        }
	
	        var transition = new Transition(path, Router.replaceWith.bind(Router, path));
	        pendingTransition = transition;
	
	        var fromComponents = mountedComponents.slice(prevRoutes.length - fromRoutes.length);
	
	        Transition.from(transition, fromRoutes, fromComponents, function (error) {
	          if (error || transition.abortReason) return dispatchHandler.call(Router, error, transition); // No need to continue.
	
	          Transition.to(transition, toRoutes, nextParams, nextQuery, function (error) {
	            dispatchHandler.call(Router, error, transition, {
	              path: path,
	              action: action,
	              pathname: match.pathname,
	              routes: nextRoutes,
	              params: nextParams,
	              query: nextQuery
	            });
	          });
	        });
	      },
	
	      /**
	       * Starts this router and calls callback(router, state) when the route changes.
	       *
	       * If the router's location is static (i.e. a URL path in a server environment)
	       * the callback is called only once. Otherwise, the location should be one of the
	       * Router.*Location objects (e.g. Router.HashLocation or Router.HistoryLocation).
	       */
	      run: function run(callback) {
	        invariant(!Router.isRunning, 'Router is already running');
	
	        dispatchHandler = function (error, transition, newState) {
	          if (error) Router.handleError(error);
	
	          if (pendingTransition !== transition) return;
	
	          pendingTransition = null;
	
	          if (transition.abortReason) {
	            Router.handleAbort(transition.abortReason);
	          } else {
	            callback.call(Router, Router, nextState = newState);
	          }
	        };
	
	        if (!(location instanceof StaticLocation)) {
	          if (location.addChangeListener) location.addChangeListener(Router.handleLocationChange);
	
	          Router.isRunning = true;
	        }
	
	        // Bootstrap using the current path.
	        Router.refresh();
	      },
	
	      refresh: function refresh() {
	        Router.dispatch(location.getCurrentPath(), null);
	      },
	
	      stop: function stop() {
	        Router.cancelPendingTransition();
	
	        if (location.removeChangeListener) location.removeChangeListener(Router.handleLocationChange);
	
	        Router.isRunning = false;
	      },
	
	      getLocation: function getLocation() {
	        return location;
	      },
	
	      getScrollBehavior: function getScrollBehavior() {
	        return scrollBehavior;
	      },
	
	      getRouteAtDepth: function getRouteAtDepth(routeDepth) {
	        var routes = state.routes;
	        return routes && routes[routeDepth];
	      },
	
	      setRouteComponentAtDepth: function setRouteComponentAtDepth(routeDepth, component) {
	        mountedComponents[routeDepth] = component;
	      },
	
	      /**
	       * Returns the current URL path + query string.
	       */
	      getCurrentPath: function getCurrentPath() {
	        return state.path;
	      },
	
	      /**
	       * Returns the current URL path without the query string.
	       */
	      getCurrentPathname: function getCurrentPathname() {
	        return state.pathname;
	      },
	
	      /**
	       * Returns an object of the currently active URL parameters.
	       */
	      getCurrentParams: function getCurrentParams() {
	        return state.params;
	      },
	
	      /**
	       * Returns an object of the currently active query parameters.
	       */
	      getCurrentQuery: function getCurrentQuery() {
	        return state.query;
	      },
	
	      /**
	       * Returns an array of the currently active routes.
	       */
	      getCurrentRoutes: function getCurrentRoutes() {
	        return state.routes;
	      },
	
	      /**
	       * Returns true if the given route, params, and query are active.
	       */
	      isActive: function isActive(to, params, query) {
	        if (PathUtils.isAbsolute(to)) return to === state.path;
	
	        return routeIsActive(state.routes, to) && paramsAreActive(state.params, params) && (query == null || queryIsActive(state.query, query));
	      }
	
	    },
	
	    mixins: [ScrollHistory],
	
	    propTypes: {
	      children: PropTypes.falsy
	    },
	
	    childContextTypes: {
	      routeDepth: PropTypes.number.isRequired,
	      router: PropTypes.router.isRequired
	    },
	
	    getChildContext: function getChildContext() {
	      return {
	        routeDepth: 1,
	        router: Router
	      };
	    },
	
	    getInitialState: function getInitialState() {
	      return state = nextState;
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this.setState(state = nextState);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	      Router.stop();
	    },
	
	    render: function render() {
	      var route = Router.getRouteAtDepth(0);
	      return route ? React.createElement(route.handler, this.props) : null;
	    }
	
	  });
	
	  Router.clearAllRoutes();
	
	  if (options.routes) Router.addRoutes(options.routes);
	
	  return Router;
	}
	
	module.exports = createRouter;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint -W084 */
	'use strict';
	
	var React = __webpack_require__(1);
	var assign = __webpack_require__(251);
	var warning = __webpack_require__(532);
	var DefaultRoute = __webpack_require__(858);
	var NotFoundRoute = __webpack_require__(859);
	var Redirect = __webpack_require__(860);
	var Route = __webpack_require__(215);
	
	function checkPropTypes(componentName, propTypes, props) {
	  componentName = componentName || 'UnknownComponent';
	
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error = propTypes[propName](props, propName, componentName);
	
	      if (error instanceof Error) warning(false, error.message);
	    }
	  }
	}
	
	function createRouteOptions(props) {
	  var options = assign({}, props);
	  var handler = options.handler;
	
	  if (handler) {
	    options.onEnter = handler.willTransitionTo;
	    options.onLeave = handler.willTransitionFrom;
	  }
	
	  return options;
	}
	
	function createRouteFromReactElement(element) {
	  if (!React.isValidElement(element)) return;
	
	  var type = element.type;
	  var props = assign({}, type.defaultProps, element.props);
	
	  if (type.propTypes) checkPropTypes(type.displayName, type.propTypes, props);
	
	  if (type === DefaultRoute) return Route.createDefaultRoute(createRouteOptions(props));
	
	  if (type === NotFoundRoute) return Route.createNotFoundRoute(createRouteOptions(props));
	
	  if (type === Redirect) return Route.createRedirect(createRouteOptions(props));
	
	  return Route.createRoute(createRouteOptions(props), function () {
	    if (props.children) createRoutesFromReactChildren(props.children);
	  });
	}
	
	/**
	 * Creates and returns an array of routes created from the given
	 * ReactChildren, all of which should be one of <Route>, <DefaultRoute>,
	 * <NotFoundRoute>, or <Redirect>, e.g.:
	 *
	 *   var { createRoutesFromReactChildren, Route, Redirect } = require('react-router');
	 *
	 *   var routes = createRoutesFromReactChildren(
	 *     <Route path="/" handler={App}>
	 *       <Route name="user" path="/user/:userId" handler={User}>
	 *         <Route name="task" path="tasks/:taskId" handler={Task}/>
	 *         <Redirect from="todos/:taskId" to="task"/>
	 *       </Route>
	 *     </Route>
	 *   );
	 */
	function createRoutesFromReactChildren(children) {
	  var routes = [];
	
	  React.Children.forEach(children, function (child) {
	    if (child = createRouteFromReactElement(child)) routes.push(child);
	  });
	
	  return routes;
	}
	
	module.exports = createRoutesFromReactChildren;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var LocationActions = __webpack_require__(299);
	var History = __webpack_require__(250);
	
	var _listeners = [];
	var _isListening = false;
	var _actionType;
	
	function notifyChange(type) {
	  if (type === LocationActions.PUSH) History.length += 1;
	
	  var change = {
	    path: HashLocation.getCurrentPath(),
	    type: type
	  };
	
	  _listeners.forEach(function (listener) {
	    listener.call(HashLocation, change);
	  });
	}
	
	function ensureSlash() {
	  var path = HashLocation.getCurrentPath();
	
	  if (path.charAt(0) === '/') return true;
	
	  HashLocation.replace('/' + path);
	
	  return false;
	}
	
	function onHashChange() {
	  if (ensureSlash()) {
	    // If we don't have an _actionType then all we know is the hash
	    // changed. It was probably caused by the user clicking the Back
	    // button, but may have also been the Forward button or manual
	    // manipulation. So just guess 'pop'.
	    var curActionType = _actionType;
	    _actionType = null;
	    notifyChange(curActionType || LocationActions.POP);
	  }
	}
	
	/**
	 * A Location that uses `window.location.hash`.
	 */
	var HashLocation = {
	
	  addChangeListener: function addChangeListener(listener) {
	    _listeners.push(listener);
	
	    // Do this BEFORE listening for hashchange.
	    ensureSlash();
	
	    if (!_isListening) {
	      if (window.addEventListener) {
	        window.addEventListener('hashchange', onHashChange, false);
	      } else {
	        window.attachEvent('onhashchange', onHashChange);
	      }
	
	      _isListening = true;
	    }
	  },
	
	  removeChangeListener: function removeChangeListener(listener) {
	    _listeners = _listeners.filter(function (l) {
	      return l !== listener;
	    });
	
	    if (_listeners.length === 0) {
	      if (window.removeEventListener) {
	        window.removeEventListener('hashchange', onHashChange, false);
	      } else {
	        window.removeEvent('onhashchange', onHashChange);
	      }
	
	      _isListening = false;
	    }
	  },
	
	  push: function push(path) {
	    _actionType = LocationActions.PUSH;
	    window.location.hash = path;
	  },
	
	  replace: function replace(path) {
	    _actionType = LocationActions.REPLACE;
	    window.location.replace(window.location.pathname + window.location.search + '#' + path);
	  },
	
	  pop: function pop() {
	    _actionType = LocationActions.POP;
	    History.back();
	  },
	
	  getCurrentPath: function getCurrentPath() {
	    return decodeURI(
	    // We can't use window.location.hash here because it's not
	    // consistent across browsers - Firefox will pre-decode it!
	    window.location.href.split('#')[1] || '');
	  },
	
	  toString: function toString() {
	    return '<HashLocation>';
	  }
	
	};
	
	module.exports = HashLocation;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var HistoryLocation = __webpack_require__(531);
	var History = __webpack_require__(250);
	
	/**
	 * A Location that uses full page refreshes. This is used as
	 * the fallback for HistoryLocation in browsers that do not
	 * support the HTML5 history API.
	 */
	var RefreshLocation = {
	
	  push: function push(path) {
	    window.location = path;
	  },
	
	  replace: function replace(path) {
	    window.location.replace(path);
	  },
	
	  pop: History.back,
	
	  getCurrentPath: HistoryLocation.getCurrentPath,
	
	  toString: function toString() {
	    return '<RefreshLocation>';
	  }
	
	};
	
	module.exports = RefreshLocation;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(68);
	
	function throwCannotModify() {
	  invariant(false, 'You cannot modify a static location');
	}
	
	/**
	 * A location that only ever contains a single path. Useful in
	 * stateless environments like servers where there is no path history,
	 * only the path that was used in the request.
	 */
	
	var StaticLocation = (function () {
	  function StaticLocation(path) {
	    _classCallCheck(this, StaticLocation);
	
	    this.path = path;
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  _createClass(StaticLocation, [{
	    key: 'getCurrentPath',
	    value: function getCurrentPath() {
	      return this.path;
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return '<StaticLocation path="' + this.path + '">';
	    }
	  }]);
	
	  return StaticLocation;
	})();
	
	StaticLocation.prototype.push = throwCannotModify;
	StaticLocation.prototype.replace = throwCannotModify;
	StaticLocation.prototype.pop = throwCannotModify;
	
	module.exports = StaticLocation;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(383);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(872);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this._callback = null;
	
					this.setState({
						isLoading: false,
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					var options = data && data.options || [];
	
					if (cache) {
						cache[inputValue] = options;
					}
	
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var newInputValue = inputValue;
	
				if (onInputChange) {
					var value = onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
						newInputValue = '' + value;
					}
				}
	
				var transformedInputValue = newInputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				this.setState({ inputValue: newInputValue });
				this.loadOptions(transformedInputValue);
	
				// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
				return newInputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    placeholder = _props3.placeholder;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultFilterOptions = __webpack_require__(533);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(534);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Select = __webpack_require__(383);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option, options: options });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    promptTextCreator = _props2.promptTextCreator,
				    showNewOptionAtTop = _props2.showNewOptionAtTop;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						if (showNewOptionAtTop) {
							filteredOptions.unshift(this._createPlaceholderOption);
						} else {
							filteredOptions.push(this._createPlaceholderOption);
						}
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.props.options;
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var isOptionUnique = function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		if (!options || !options.length) {
			return true;
		}
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	var isValidNewOption = function isValidNewOption(_ref4) {
		var label = _ref4.label;
		return !!label;
	};
	
	var newOptionCreator = function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
	
		return option;
	};
	
	var promptTextCreator = function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	};
	
	var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
			default:
				return false;
		}
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
		showNewOptionAtTop: true
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func,
	
		// Where to show prompt/placeholder option text.
		// true: new option prompt at top of list (default)
		// false: new option prompt at bottom of list
		showNewOptionAtTop: _propTypes2.default.bool
	};
	
	exports.default = CreatableSelect;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blockEvent = __webpack_require__(1867);
	
	var _blockEvent2 = _interopRequireDefault(_blockEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: _blockEvent2.default,
						onClick: _blockEvent2.default },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						'aria-label': option.label,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrowRenderer = function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};
	
	exports.default = arrowRenderer;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearRenderer = function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};
	
	exports.default = clearRenderer;

/***/ }),
/* 872 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	var stripDiacritics = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};
	
	exports.default = stripDiacritics;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(535);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _static = __webpack_require__(1873);
	
	var _static2 = _interopRequireDefault(_static);
	
	var _SplitPane = __webpack_require__(874);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function PaneStyle(_ref) {
	  var split = _ref.split,
	      initialSize = _ref.initialSize,
	      size = _ref.size,
	      minSize = _ref.minSize,
	      maxSize = _ref.maxSize,
	      resizersSize = _ref.resizersSize;
	
	  var value = size || initialSize;
	  var vertical = split === 'vertical';
	  var styleProp = {
	    minSize: vertical ? 'minWidth' : 'minHeight',
	    maxSize: vertical ? 'maxWidth' : 'maxHeight',
	    size: vertical ? 'width' : 'height'
	  };
	
	  var style = {
	    display: 'flex',
	    outline: 'none'
	  };
	
	  style[styleProp.minSize] = (0, _SplitPane.convertSizeToCssValue)(minSize, resizersSize);
	  style[styleProp.maxSize] = (0, _SplitPane.convertSizeToCssValue)(maxSize, resizersSize);
	
	  switch ((0, _SplitPane.getUnit)(value)) {
	    case 'ratio':
	      style.flex = value;
	      break;
	    case '%':
	    case 'px':
	      style.flexGrow = 0;
	      style[styleProp.size] = (0, _SplitPane.convertSizeToCssValue)(value, resizersSize);
	      break;
	  }
	
	  return style;
	}
	
	var Pane = function (_PureComponent) {
	  _inherits(Pane, _PureComponent);
	
	  function Pane() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Pane);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Pane.__proto__ || Object.getPrototypeOf(Pane)).call.apply(_ref2, [this].concat(args))), _this), _this.setRef = function (element) {
	      _this.props.innerRef(_this.props.index, element);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Pane, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className;
	
	      var prefixedStyle = (0, _static2.default)(PaneStyle(this.props));
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: className,
	          style: prefixedStyle,
	          ref: this.setRef
	        },
	        children
	      );
	    }
	  }]);
	
	  return Pane;
	}(_react.PureComponent);
	
	Pane.propTypes = {
	  children: _propTypes2.default.node,
	  innerRef: _propTypes2.default.func,
	  index: _propTypes2.default.number,
	  className: _propTypes2.default.string,
	  initialSize: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  minSize: _propTypes2.default.string,
	  maxSize: _propTypes2.default.string
	};
	
	Pane.defaultProps = {
	  initialSize: '1',
	  split: 'vertical',
	  minSize: '0',
	  maxSize: '100%'
	};
	
	exports.default = Pane;
	module.exports = exports['default'];

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.getUnit = getUnit;
	exports.convertSizeToCssValue = convertSizeToCssValue;
	
	var _react = __webpack_require__(535);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _glamorous = __webpack_require__(1320);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _Resizer = __webpack_require__(1871);
	
	var _Resizer2 = _interopRequireDefault(_Resizer);
	
	var _Pane = __webpack_require__(873);
	
	var _Pane2 = _interopRequireDefault(_Pane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_PANE_SIZE = '1';
	var DEFAULT_PANE_MIN_SIZE = '0';
	var DEFAULT_PANE_MAX_SIZE = '100%';
	
	var ColumnStyle = _glamorous2.default.div({
	  display: 'flex',
	  height: '100%',
	  flexDirection: 'column',
	  flex: 1,
	  outline: 'none',
	  overflow: 'hidden',
	  userSelect: 'text'
	});
	
	var RowStyle = _glamorous2.default.div({
	  display: 'flex',
	  height: '100%',
	  flexDirection: 'row',
	  flex: 1,
	  outline: 'none',
	  overflow: 'hidden',
	  userSelect: 'text'
	});
	
	function convert(str, size) {
	  var tokens = str.match(/([0-9]+)([px|%]*)/);
	  var value = tokens[1];
	  var unit = tokens[2];
	  return toPx(value, unit, size);
	}
	
	function toPx(value) {
	  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';
	  var size = arguments[2];
	
	  switch (unit) {
	    case '%':
	      {
	        return +(size * value / 100).toFixed(2);
	      }
	    default:
	      {
	        return +value;
	      }
	  }
	}
	
	function removeNullChildren(children) {
	  return _react2.default.Children.toArray(children).filter(function (c) {
	    return c;
	  });
	}
	
	function getUnit(size) {
	  if (size.endsWith('px')) {
	    return 'px';
	  }
	
	  if (size.endsWith('%')) {
	    return '%';
	  }
	
	  return 'ratio';
	}
	
	function convertSizeToCssValue(value, resizersSize) {
	  if (getUnit(value) !== '%') {
	    return value;
	  }
	
	  if (!resizersSize) {
	    return value;
	  }
	
	  var idx = value.search('%');
	  var percent = value.slice(0, idx) / 100;
	  if (percent === 0) {
	    return value;
	  }
	
	  return 'calc(' + value + ' - ' + resizersSize + 'px*' + percent + ')';
	}
	
	function convertToUnit(size, unit, containerSize) {
	  switch (unit) {
	    case '%':
	      return (size / containerSize * 100).toFixed(2) + '%';
	    case 'px':
	      return size.toFixed(2) + 'px';
	    case 'ratio':
	      return (size * 100).toFixed(0);
	  }
	}
	
	var SplitPane = function (_Component) {
	  _inherits(SplitPane, _Component);
	
	  function SplitPane(props) {
	    _classCallCheck(this, SplitPane);
	
	    var _this = _possibleConstructorReturn(this, (SplitPane.__proto__ || Object.getPrototypeOf(SplitPane)).call(this, props));
	
	    _this.onMouseDown = function (event, resizerIndex) {
	      if (event.button !== 0) {
	        return;
	      }
	
	      event.preventDefault();
	
	      _this.onDown(resizerIndex, event.clientX, event.clientY);
	    };
	
	    _this.onTouchStart = function (event, resizerIndex) {
	      event.preventDefault();
	
	      var _event$touches$ = event.touches[0],
	          clientX = _event$touches$.clientX,
	          clientY = _event$touches$.clientY;
	
	
	      _this.onDown(resizerIndex, clientX, clientY);
	    };
	
	    _this.onDown = function (resizerIndex, clientX, clientY) {
	      var _this$props = _this.props,
	          allowResize = _this$props.allowResize,
	          onResizeStart = _this$props.onResizeStart,
	          split = _this$props.split;
	
	
	      if (!allowResize) {
	        return;
	      }
	
	      _this.resizerIndex = resizerIndex;
	      _this.dimensionsSnapshot = _this.getDimensionsSnapshot(_this.props);
	      _this.startClientX = clientX;
	      _this.startClientY = clientY;
	
	      document.addEventListener('mousemove', _this.onMouseMove);
	      document.addEventListener('mouseup', _this.onMouseUp);
	
	      document.addEventListener('touchmove', _this.onTouchMove);
	      document.addEventListener('touchend', _this.onMouseUp);
	      document.addEventListener('touchcancel', _this.onMouseUp);
	
	      if (onResizeStart) {
	        onResizeStart();
	      }
	    };
	
	    _this.onMouseMove = function (event) {
	      event.preventDefault();
	
	      _this.onMove(event.clientX, event.clientY);
	    };
	
	    _this.onTouchMove = function (event) {
	      event.preventDefault();
	
	      var _event$touches$2 = event.touches[0],
	          clientX = _event$touches$2.clientX,
	          clientY = _event$touches$2.clientY;
	
	
	      _this.onMove(clientX, clientY);
	    };
	
	    _this.onMouseUp = function (event) {
	      event.preventDefault();
	
	      document.removeEventListener('mouseup', _this.onMouseUp);
	      document.removeEventListener('mousemove', _this.onMouseMove);
	
	      document.removeEventListener('touchmove', _this.onTouchMove);
	      document.removeEventListener('touchend', _this.onMouseUp);
	      document.addEventListener('touchcancel', _this.onMouseUp);
	
	      if (_this.props.onResizeEnd) {
	        _this.props.onResizeEnd(_this.state.sizes);
	      }
	    };
	
	    _this.setPaneRef = function (idx, el) {
	      if (!_this.paneElements) {
	        _this.paneElements = [];
	      }
	
	      _this.paneElements[idx] = el;
	    };
	
	    _this.state = {
	      sizes: _this.getPanePropSize(props)
	    };
	    return _this;
	  }
	
	  _createClass(SplitPane, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ sizes: this.getPanePropSize(nextProps) });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('mouseup', this.onMouseUp);
	      document.removeEventListener('mousemove', this.onMouseMove);
	
	      document.removeEventListener('touchmove', this.onTouchMove);
	      document.removeEventListener('touchend', this.onMouseUp);
	    }
	  }, {
	    key: 'getDimensionsSnapshot',
	    value: function getDimensionsSnapshot(props) {
	      var split = props.split;
	      var paneDimensions = this.getPaneDimensions();
	      var splitPaneDimensions = this.splitPane.getBoundingClientRect();
	      var minSizes = this.getPanePropMinMaxSize(props, 'minSize');
	      var maxSizes = this.getPanePropMinMaxSize(props, 'maxSize');
	
	      var resizersSize = this.getResizersSize(removeNullChildren(this.props.children));
	      var splitPaneSizePx = split === 'vertical' ? splitPaneDimensions.width - resizersSize : splitPaneDimensions.height - resizersSize;
	
	      var minSizesPx = minSizes.map(function (s) {
	        return convert(s, splitPaneSizePx);
	      });
	      var maxSizesPx = maxSizes.map(function (s) {
	        return convert(s, splitPaneSizePx);
	      });
	      var sizesPx = paneDimensions.map(function (d) {
	        return split === 'vertical' ? d.width : d.height;
	      });
	
	      return {
	        resizersSize: resizersSize,
	        paneDimensions: paneDimensions,
	        splitPaneSizePx: splitPaneSizePx,
	        minSizesPx: minSizesPx,
	        maxSizesPx: maxSizesPx,
	        sizesPx: sizesPx
	      };
	    }
	  }, {
	    key: 'getPanePropSize',
	    value: function getPanePropSize(props) {
	      return removeNullChildren(props.children).map(function (child) {
	        var value = child.props['size'] || child.props['initialSize'];
	        if (value === undefined) {
	          return DEFAULT_PANE_SIZE;
	        }
	
	        return String(value);
	      });
	    }
	  }, {
	    key: 'getPanePropMinMaxSize',
	    value: function getPanePropMinMaxSize(props, key) {
	      return removeNullChildren(props.children).map(function (child) {
	        var value = child.props[key];
	        if (value === undefined) {
	          return key === 'maxSize' ? DEFAULT_PANE_MAX_SIZE : DEFAULT_PANE_MIN_SIZE;
	        }
	
	        return value;
	      });
	    }
	  }, {
	    key: 'getPaneDimensions',
	    value: function getPaneDimensions() {
	      return this.paneElements.filter(function (el) {
	        return el;
	      }).map(function (el) {
	        return el.getBoundingClientRect();
	      });
	    }
	  }, {
	    key: 'getSizes',
	    value: function getSizes() {
	      return this.state.sizes;
	    }
	  }, {
	    key: 'onMove',
	    value: function onMove(clientX, clientY) {
	      var _props = this.props,
	          split = _props.split,
	          onChange = _props.onChange;
	
	      var resizerIndex = this.resizerIndex;
	      var _dimensionsSnapshot = this.dimensionsSnapshot,
	          sizesPx = _dimensionsSnapshot.sizesPx,
	          minSizesPx = _dimensionsSnapshot.minSizesPx,
	          maxSizesPx = _dimensionsSnapshot.maxSizesPx,
	          splitPaneSizePx = _dimensionsSnapshot.splitPaneSizePx,
	          paneDimensions = _dimensionsSnapshot.paneDimensions;
	
	
	      var sizeDim = split === 'vertical' ? 'width' : 'height';
	      var primary = paneDimensions[resizerIndex];
	      var secondary = paneDimensions[resizerIndex + 1];
	      var maxSize = primary[sizeDim] + secondary[sizeDim];
	
	      var primaryMinSizePx = minSizesPx[resizerIndex];
	      var secondaryMinSizePx = minSizesPx[resizerIndex + 1];
	      var primaryMaxSizePx = Math.min(maxSizesPx[resizerIndex], maxSize);
	      var secondaryMaxSizePx = Math.min(maxSizesPx[resizerIndex + 1], maxSize);
	
	      var moveOffset = split === 'vertical' ? this.startClientX - clientX : this.startClientY - clientY;
	
	      var primarySizePx = primary[sizeDim] - moveOffset;
	      var secondarySizePx = secondary[sizeDim] + moveOffset;
	
	      var primaryHasReachedLimit = false;
	      var secondaryHasReachedLimit = false;
	
	      if (primarySizePx < primaryMinSizePx) {
	        primarySizePx = primaryMinSizePx;
	        primaryHasReachedLimit = true;
	      } else if (primarySizePx > primaryMaxSizePx) {
	        primarySizePx = primaryMaxSizePx;
	        primaryHasReachedLimit = true;
	      }
	
	      if (secondarySizePx < secondaryMinSizePx) {
	        secondarySizePx = secondaryMinSizePx;
	        secondaryHasReachedLimit = true;
	      } else if (secondarySizePx > secondaryMaxSizePx) {
	        secondarySizePx = secondaryMaxSizePx;
	        secondaryHasReachedLimit = true;
	      }
	
	      if (primaryHasReachedLimit) {
	        secondarySizePx = primary[sizeDim] + secondary[sizeDim] - primarySizePx;
	      } else if (secondaryHasReachedLimit) {
	        primarySizePx = primary[sizeDim] + secondary[sizeDim] - secondarySizePx;
	      }
	
	      sizesPx[resizerIndex] = primarySizePx;
	      sizesPx[resizerIndex + 1] = secondarySizePx;
	
	      var sizes = this.getSizes().concat();
	      var updateRatio = void 0;
	
	      [primarySizePx, secondarySizePx].forEach(function (paneSize, idx) {
	        var unit = getUnit(sizes[resizerIndex + idx]);
	        if (unit !== 'ratio') {
	          sizes[resizerIndex + idx] = convertToUnit(paneSize, unit, splitPaneSizePx);
	        } else {
	          updateRatio = true;
	        }
	      });
	
	      if (updateRatio) {
	        var ratioCount = 0;
	        var lastRatioIdx = void 0;
	        sizes = sizes.map(function (size, idx) {
	          if (getUnit(size) === 'ratio') {
	            ratioCount++;
	            lastRatioIdx = idx;
	
	            return convertToUnit(sizesPx[idx], 'ratio');
	          }
	
	          return size;
	        });
	
	        if (ratioCount === 1) {
	          sizes[lastRatioIdx] = '1';
	        }
	      }
	
	      onChange && onChange(sizes);
	
	      this.setState({
	        sizes: sizes
	      });
	    }
	  }, {
	    key: 'getResizersSize',
	    value: function getResizersSize(children) {
	      return (children.length - 1) * this.props.resizerSize;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          split = _props2.split;
	
	      var notNullChildren = removeNullChildren(this.props.children);
	      var sizes = this.getSizes();
	      var resizersSize = this.getResizersSize(notNullChildren);
	
	      var elements = notNullChildren.reduce(function (acc, child, idx) {
	        var pane = void 0;
	        var resizerIndex = idx - 1;
	        var isPane = child.type === _Pane2.default;
	        var paneProps = {
	          index: idx,
	          'data-type': 'Pane',
	          split: split,
	          key: 'Pane-' + idx,
	          innerRef: _this2.setPaneRef,
	          resizersSize: resizersSize,
	          size: sizes[idx]
	        };
	
	        if (isPane) {
	          pane = (0, _react.cloneElement)(child, paneProps);
	        } else {
	          pane = _react2.default.createElement(
	            _Pane2.default,
	            paneProps,
	            child
	          );
	        }
	
	        if (acc.length === 0) {
	          return [].concat(_toConsumableArray(acc), [pane]);
	        } else {
	          var resizer = _react2.default.createElement(_Resizer2.default, {
	            index: resizerIndex,
	            key: 'Resizer-' + resizerIndex,
	            split: split,
	            onMouseDown: _this2.onMouseDown,
	            onTouchStart: _this2.onTouchStart
	          });
	
	          return [].concat(_toConsumableArray(acc), [resizer, pane]);
	        }
	      }, []);
	
	      var StyleComponent = split === 'vertical' ? RowStyle : ColumnStyle;
	
	      return _react2.default.createElement(
	        StyleComponent,
	        {
	          className: className,
	          'data-type': 'SplitPane',
	          'data-split': split,
	          innerRef: function innerRef(el) {
	            _this2.splitPane = el;
	          }
	        },
	        elements
	      );
	    }
	  }]);
	
	  return SplitPane;
	}(_react.Component);
	
	SplitPane.propTypes = {
	  children: _propTypes2.default.arrayOf(_propTypes2.default.node).isRequired,
	  className: _propTypes2.default.string,
	  split: _propTypes2.default.oneOf(['vertical', 'horizontal']),
	  resizerSize: _propTypes2.default.number,
	  onChange: _propTypes2.default.func,
	  onResizeStart: _propTypes2.default.func,
	  onResizeEnd: _propTypes2.default.func
	};
	
	SplitPane.defaultProps = {
	  split: 'vertical',
	  resizerSize: 1,
	  allowResize: true
	};
	
	exports.default = SplitPane;

/***/ }),
/* 875 */
462,
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _VIEW, _OPPOSITE_DIRECTION, _MULTIPLIER, _desc, _value2, _obj; //values, omit
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _compat = __webpack_require__(168);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _Widget = __webpack_require__(877);
	
	var _Widget2 = _interopRequireDefault(_Widget);
	
	var _Header = __webpack_require__(1895);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(1894);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Month = __webpack_require__(1899);
	
	var _Month2 = _interopRequireDefault(_Month);
	
	var _Year = __webpack_require__(1904);
	
	var _Year2 = _interopRequireDefault(_Year);
	
	var _Decade = __webpack_require__(1893);
	
	var _Decade2 = _interopRequireDefault(_Decade);
	
	var _Century = __webpack_require__(1890);
	
	var _Century2 = _interopRequireDefault(_Century);
	
	var _localizers = __webpack_require__(128);
	
	var _propTypes3 = __webpack_require__(156);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _uncontrollable = __webpack_require__(221);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _SlideTransition = __webpack_require__(1902);
	
	var _SlideTransition2 = _interopRequireDefault(_SlideTransition);
	
	var _dates = __webpack_require__(188);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _constants = __webpack_require__(539);
	
	var constants = _interopRequireWildcard(_constants);
	
	var _2 = __webpack_require__(93);
	
	var _3 = _interopRequireDefault(_2);
	
	var _widgetHelpers = __webpack_require__(189);
	
	var _interaction = __webpack_require__(302);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var dir = constants.directions,
	    values = function values(obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	},
	    invert = function invert(obj) {
	  return _3.default.transform(obj, function (o, val, key) {
	    o[val] = key;
	  }, {});
	};
	
	var views = constants.calendarViews,
	    VIEW_OPTIONS = values(views),
	    ALT_VIEW = invert(constants.calendarViewHierarchy),
	    NEXT_VIEW = constants.calendarViewHierarchy,
	    VIEW_UNIT = constants.calendarViewUnits,
	    VIEW = (_VIEW = {}, _VIEW[views.MONTH] = _Month2.default, _VIEW[views.YEAR] = _Year2.default, _VIEW[views.DECADE] = _Decade2.default, _VIEW[views.CENTURY] = _Century2.default, _VIEW);
	
	var ARROWS_TO_DIRECTION = {
	  ArrowDown: dir.DOWN,
	  ArrowUp: dir.UP,
	  ArrowRight: dir.RIGHT,
	  ArrowLeft: dir.LEFT
	};
	
	var OPPOSITE_DIRECTION = (_OPPOSITE_DIRECTION = {}, _OPPOSITE_DIRECTION[dir.LEFT] = dir.RIGHT, _OPPOSITE_DIRECTION[dir.RIGHT] = dir.LEFT, _OPPOSITE_DIRECTION);
	
	var MULTIPLIER = (_MULTIPLIER = {}, _MULTIPLIER[views.YEAR] = 1, _MULTIPLIER[views.DECADE] = 10, _MULTIPLIER[views.CENTURY] = 100, _MULTIPLIER);
	
	var format = function format(props, f) {
	  return _localizers.date.getFormat(f, props[f + 'Format']);
	};
	
	var propTypes = {
	
	  disabled: _propTypes4.default.disabled,
	  readOnly: _propTypes4.default.readOnly,
	
	  onChange: _propTypes2.default.func,
	  value: _propTypes2.default.instanceOf(Date),
	
	  min: _propTypes2.default.instanceOf(Date),
	  max: _propTypes2.default.instanceOf(Date),
	
	  currentDate: _propTypes2.default.instanceOf(Date),
	  onCurrentDateChange: _propTypes2.default.func,
	
	  view: _propTypes2.default.oneOf(VIEW_OPTIONS),
	  initialView: _propTypes2.default.oneOf(VIEW_OPTIONS),
	
	  finalView: function finalView(props, propName, componentName) {
	    for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      args[_key - 3] = arguments[_key];
	    }
	
	    var err = _propTypes2.default.oneOf(VIEW_OPTIONS).apply(undefined, [props, propName, componentName].concat(args));
	
	    if (err) return err;
	    if (VIEW_OPTIONS.indexOf(props[propName]) < VIEW_OPTIONS.indexOf(props.initialView)) return new Error(('The `' + propName + '` prop: `' + props[propName] + '` cannot be \'lower\' than the `initialView`\n        prop. This creates a range that cannot be rendered.').replace(/\n\t/g, ''));
	  },
	
	
	  onViewChange: _propTypes2.default.func,
	  onNavigate: _propTypes2.default.func,
	  culture: _propTypes2.default.string,
	  footer: _propTypes2.default.bool,
	
	  dayComponent: _propTypes4.default.elementType,
	  headerFormat: _propTypes4.default.dateFormat,
	  footerFormat: _propTypes4.default.dateFormat,
	
	  dayFormat: _propTypes4.default.dateFormat,
	  dateFormat: _propTypes4.default.dateFormat,
	  monthFormat: _propTypes4.default.dateFormat,
	  yearFormat: _propTypes4.default.dateFormat,
	  decadeFormat: _propTypes4.default.dateFormat,
	  centuryFormat: _propTypes4.default.dateFormat,
	
	  messages: _propTypes2.default.shape({
	    moveBack: _propTypes2.default.string,
	    moveForward: _propTypes2.default.string
	  })
	};
	
	var Calendar = (0, _createReactClass2.default)((_obj = {
	
	  displayName: 'Calendar',
	
	  mixins: [__webpack_require__(537), __webpack_require__(1907), __webpack_require__(300), __webpack_require__(879), __webpack_require__(216)(), __webpack_require__(878)({
	    willHandle: function willHandle() {
	      if (+this.props.tabIndex === -1) return false;
	    }
	  })],
	
	  propTypes: propTypes,
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedIndex: 0,
	      view: this.props.initialView || 'month'
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	
	      value: null,
	      min: new Date(1900, 0, 1),
	      max: new Date(2099, 11, 31),
	      currentDate: new Date(),
	
	      initialView: 'month',
	      finalView: 'century',
	
	      tabIndex: '0',
	      footer: false,
	
	      ariaActiveDescendantKey: 'calendar',
	      messages: msgs({})
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.changeCurrentDate(this.props.value);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var bottom = VIEW_OPTIONS.indexOf(nextProps.initialView),
	        top = VIEW_OPTIONS.indexOf(nextProps.finalView),
	        current = VIEW_OPTIONS.indexOf(this.state.view),
	        view = this.state.view,
	        val = this.inRangeValue(nextProps.value);
	
	    if (current < bottom) this.setState({ view: view = nextProps.initialView });else if (current > top) this.setState({ view: view = nextProps.finalView });
	
	    //if the value changes reset views to the new one
	    if (!_dates2.default.eq(val, dateOrNull(this.props.value), VIEW_UNIT[view])) {
	      this.changeCurrentDate(val, nextProps.currentDate);
	    }
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        className = _props.className,
	        value = _props.value,
	        footerFormat = _props.footerFormat,
	        disabled = _props.disabled,
	        readOnly = _props.readOnly,
	        finalView = _props.finalView,
	        footer = _props.footer,
	        messages = _props.messages,
	        min = _props.min,
	        max = _props.max,
	        culture = _props.culture,
	        duration = _props.duration,
	        tabIndex = _props.tabIndex,
	        currentDate = _props.currentDate;
	    var _state = this.state,
	        view = _state.view,
	        slideDirection = _state.slideDirection,
	        focused = _state.focused;
	
	
	    var View = VIEW[view],
	        unit = VIEW_UNIT[view],
	        todaysDate = new Date(),
	        todayNotInRange = !_dates2.default.inRange(todaysDate, min, max, view);
	
	    unit = unit === 'day' ? 'date' : unit;
	
	    var viewID = (0, _widgetHelpers.instanceId)(this, '_calendar'),
	        labelID = (0, _widgetHelpers.instanceId)(this, '_calendar_label'),
	        key = view + '_' + _dates2.default[view](currentDate);
	
	    var elementProps = _3.default.omitOwnProps(this),
	        viewProps = _3.default.pickProps(this.props, View);
	
	    var isDisabled = disabled || readOnly;
	
	    messages = msgs(this.props.messages);
	
	    return _react2.default.createElement(
	      _Widget2.default,
	      _extends({}, elementProps, {
	        role: 'group',
	        focused: focused,
	        disabled: disabled,
	        readOnly: readOnly,
	        tabIndex: tabIndex || 0,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        className: (0, _classnames2.default)(className, 'rw-calendar')
	      }),
	      _react2.default.createElement(_Header2.default, {
	        label: this._label(),
	        labelId: labelID,
	        messages: messages,
	        upDisabled: isDisabled || view === finalView,
	        prevDisabled: isDisabled || !_dates2.default.inRange(this.nextDate(dir.LEFT), min, max, view),
	        nextDisabled: isDisabled || !_dates2.default.inRange(this.nextDate(dir.RIGHT), min, max, view),
	        onViewChange: this.navigate.bind(null, dir.UP, null),
	        onMoveLeft: this.navigate.bind(null, dir.LEFT, null),
	        onMoveRight: this.navigate.bind(null, dir.RIGHT, null)
	      }),
	      _react2.default.createElement(
	        _SlideTransition2.default,
	        {
	          ref: 'animation',
	          duration: duration,
	          direction: slideDirection,
	          onAnimate: function onAnimate() {
	            return focused && _this.focus();
	          }
	        },
	        _react2.default.createElement(View, _extends({}, viewProps, {
	          key: key,
	          id: viewID,
	          value: value,
	          today: todaysDate,
	          focused: currentDate,
	          onChange: this.change,
	          onKeyDown: this.handleKeyDown,
	          'aria-labelledby': labelID,
	          ariaActiveDescendantKey: 'calendarView'
	        }))
	      ),
	      footer && _react2.default.createElement(_Footer2.default, {
	        value: todaysDate,
	        format: footerFormat,
	        culture: culture,
	        disabled: disabled || todayNotInRange,
	        readOnly: readOnly,
	        onClick: this.select
	      })
	    );
	  },
	  navigate: function navigate(direction, date) {
	    var view = this.state.view,
	        slideDir = direction === dir.LEFT || direction === dir.UP ? 'right' : 'left';
	
	    if (!date) date = [dir.LEFT, dir.RIGHT].indexOf(direction) !== -1 ? this.nextDate(direction) : this.props.currentDate;
	
	    if (direction === dir.DOWN) view = ALT_VIEW[view] || view;
	
	    if (direction === dir.UP) view = NEXT_VIEW[view] || view;
	
	    if (this.isValidView(view) && _dates2.default.inRange(date, this.props.min, this.props.max, view)) {
	      (0, _widgetHelpers.notify)(this.props.onNavigate, [date, slideDir, view]);
	      this.focus(true);
	
	      this.changeCurrentDate(date);
	
	      this.setState({
	        slideDirection: slideDir,
	        view: view
	      });
	    }
	  },
	  focus: function focus() {
	    if (+this.props.tabIndex > -1) _compat2.default.findDOMNode(this).focus();
	  },
	  change: function change(date) {
	    if (this.state.view === this.props.initialView) {
	      this.changeCurrentDate(date);
	      (0, _widgetHelpers.notify)(this.props.onChange, date);
	      this.focus();
	      return;
	    }
	
	    this.navigate(dir.DOWN, date);
	  },
	  changeCurrentDate: function changeCurrentDate(date) {
	    var currentDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.currentDate;
	
	    var inRangeDate = this.inRangeValue(date ? new Date(date) : currentDate);
	    if (_dates2.default.eq(inRangeDate, dateOrNull(currentDate), VIEW_UNIT[this.state.view])) return;
	    (0, _widgetHelpers.notify)(this.props.onCurrentDateChange, inRangeDate);
	  },
	  select: function select(date) {
	    var view = this.props.initialView,
	        slideDir = view !== this.state.view || _dates2.default.gt(date, this.state.currentDate) ? 'left' // move down to a the view
	    : 'right';
	
	    (0, _widgetHelpers.notify)(this.props.onChange, date);
	
	    if (this.isValidView(view) && _dates2.default.inRange(date, this.props.min, this.props.max, view)) {
	      this.focus();
	
	      this.changeCurrentDate(date);
	
	      this.setState({
	        slideDirection: slideDir,
	        view: view
	      });
	    }
	  },
	  nextDate: function nextDate(direction) {
	    var method = direction === dir.LEFT ? 'subtract' : 'add',
	        view = this.state.view,
	        unit = view === views.MONTH ? view : views.YEAR,
	        multi = MULTIPLIER[view] || 1;
	
	    return _dates2.default[method](this.props.currentDate, 1 * multi, unit);
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    var ctrl = e.ctrlKey,
	        key = e.key,
	        direction = ARROWS_TO_DIRECTION[key],
	        current = this.props.currentDate,
	        view = this.state.view,
	        unit = VIEW_UNIT[view],
	        currentDate = current;
	
	    if (key === 'Enter') {
	      e.preventDefault();
	      return this.change(current);
	    }
	
	    if (direction) {
	      if (ctrl) {
	        e.preventDefault();
	        this.navigate(direction);
	      } else {
	        if (this.isRtl() && OPPOSITE_DIRECTION[direction]) direction = OPPOSITE_DIRECTION[direction];
	
	        currentDate = _dates2.default.move(currentDate, this.props.min, this.props.max, view, direction);
	
	        if (!_dates2.default.eq(current, currentDate, unit)) {
	          e.preventDefault();
	
	          if (_dates2.default.gt(currentDate, current, view)) this.navigate(dir.RIGHT, currentDate);else if (_dates2.default.lt(currentDate, current, view)) this.navigate(dir.LEFT, currentDate);else this.changeCurrentDate(currentDate);
	        }
	      }
	    }
	
	    (0, _widgetHelpers.notify)(this.props.onKeyDown, [e]);
	  },
	  _label: function _label() {
	    var _props2 = this.props,
	        culture = _props2.culture,
	        props = _objectWithoutProperties(_props2, ['culture']),
	        view = this.state.view,
	        dt = this.props.currentDate;
	
	    if (view === 'month') return _localizers.date.format(dt, format(props, 'header'), culture);else if (view === 'year') return _localizers.date.format(dt, format(props, 'year'), culture);else if (view === 'decade') return _localizers.date.format(_dates2.default.startOf(dt, 'decade'), format(props, 'decade'), culture);else if (view === 'century') return _localizers.date.format(_dates2.default.startOf(dt, 'century'), format(props, 'century'), culture);
	  },
	  inRangeValue: function inRangeValue(_value) {
	    var value = dateOrNull(_value);
	
	    if (value === null) return value;
	
	    return _dates2.default.max(_dates2.default.min(value, this.props.max), this.props.min);
	  },
	  isValidView: function isValidView(next) {
	    var bottom = VIEW_OPTIONS.indexOf(this.props.initialView),
	        top = VIEW_OPTIONS.indexOf(this.props.finalView),
	        current = VIEW_OPTIONS.indexOf(next);
	
	    return current >= bottom && current <= top;
	  }
	}, (_applyDecoratedDescriptor(_obj, 'navigate', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'navigate'), _obj), _applyDecoratedDescriptor(_obj, 'change', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'change'), _obj), _applyDecoratedDescriptor(_obj, 'select', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'select'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyDown', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyDown'), _obj)), _obj));
	
	function dateOrNull(dt) {
	  if (dt && !isNaN(dt.getTime())) return dt;
	  return null;
	}
	
	function msgs(msgs) {
	  return _extends({
	    moveBack: 'navigate back',
	    moveForward: 'navigate forward'
	  }, msgs);
	}
	
	exports.default = (0, _uncontrollable2.default)(Calendar, {
	  value: 'onChange',
	  currentDate: 'onCurrentDateChange',
	  view: 'onViewChange'
	}, ['focus']);
	module.exports = exports['default'];

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Widget = (_temp = _class = function (_React$Component) {
	  _inherits(Widget, _React$Component);
	
	  function Widget() {
	    _classCallCheck(this, Widget);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Widget.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        tabIndex = _props.tabIndex,
	        open = _props.open,
	        dropUp = _props.dropUp,
	        disabled = _props.disabled,
	        readOnly = _props.readOnly,
	        focused = _props.focused,
	        props = _objectWithoutProperties(_props, ['className', 'tabIndex', 'open', 'dropUp', 'disabled', 'readOnly', 'focused']);
	
	    var isRtl = !!this.context.isRtl;
	    var openClass = 'rw-open' + (dropUp ? '-up' : '');
	
	    tabIndex = tabIndex != null ? tabIndex : '-1';
	
	    return _react2.default.createElement('div', _extends({}, props, {
	      tabIndex: tabIndex,
	      className: (0, _classnames2.default)(className, 'rw-widget', isRtl && 'rw-rtl', open && openClass, focused && 'rw-state-focus', disabled && 'rw-state-disabled', readOnly && 'rw-state-readonly')
	    }));
	  };
	
	  return Widget;
	}(_react2.default.Component), _class.propTypes = {
	  tabIndex: _propTypes2.default.node,
	  focused: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  readOnly: _propTypes2.default.bool,
	  open: _propTypes2.default.bool,
	  dropUp: _propTypes2.default.bool
	}, _class.contextTypes = {
	  isRtl: _propTypes2.default.bool
	}, _temp);
	exports.default = Widget;
	module.exports = exports['default'];

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = FocusMixin;
	
	var _widgetHelpers = __webpack_require__(189);
	
	var _interaction = __webpack_require__(302);
	
	var _compat = __webpack_require__(168);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function FocusMixin(_ref) {
	  var _desc, _value, _obj;
	
	  var willHandle = _ref.willHandle,
	      didHandle = _ref.didHandle;
	
	  function _handleFocus(inst, focused, event) {
	    var handler = inst.props[focused ? 'onFocus' : 'onBlur'];
	
	    if (handler && event) event.persist();
	
	    if (willHandle && willHandle.call(inst, focused, event) === false) return;
	
	    inst.setTimeout('focus', function () {
	      _compat2.default.batchedUpdates(function () {
	        if (didHandle) didHandle.call(inst, focused, event);
	
	        if (focused !== inst.state.focused) {
	          (0, _widgetHelpers.notify)(handler, event);
	          if (inst._mounted) inst.setState({ focused: focused });
	        }
	      });
	    });
	  }
	
	  return _obj = {
	    handleBlur: function handleBlur(event) {
	      _handleFocus(this, false, event);
	    },
	    handleFocus: function handleFocus(event) {
	      _handleFocus(this, true, event);
	    },
	    componentDidMount: function componentDidMount() {
	      this._mounted = true;
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      this._mounted = false;
	    }
	  }, (_applyDecoratedDescriptor(_obj, 'handleBlur', [_interaction.widgetEnabled], Object.getOwnPropertyDescriptor(_obj, 'handleBlur'), _obj), _applyDecoratedDescriptor(_obj, 'handleFocus', [_interaction.widgetEnabled], Object.getOwnPropertyDescriptor(_obj, 'handleFocus'), _obj)), _obj;
	}
	module.exports = exports['default'];

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var PropTypes = __webpack_require__(2);
	
	module.exports = {
	
	  propTypes: {
	    isRtl: PropTypes.bool
	  },
	
	  contextTypes: {
	    isRtl: PropTypes.bool
	  },
	
	  childContextTypes: {
	    isRtl: PropTypes.bool
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      isRtl: !!(this.props.isRtl || this.context && this.context.isRtl)
	    };
	  },
	  isRtl: function isRtl() {
	    return !!(this.props.isRtl || this.context && this.context.isRtl);
	  }
	};

/***/ }),
/* 880 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var common = {
	  eq: function eq(a, b) {
	    return a === b;
	  },
	  neq: function neq(a, b) {
	    return a !== b;
	  },
	  gt: function gt(a, b) {
	    return a > b;
	  },
	  gte: function gte(a, b) {
	    return a >= b;
	  },
	  lt: function lt(a, b) {
	    return a < b;
	  },
	  lte: function lte(a, b) {
	    return a <= b;
	  },
	  contains: function contains(a, b) {
	    return a.indexOf(b) !== -1;
	  },
	  startsWith: function startsWith(a, b) {
	    return a.lastIndexOf(b, 0) === 0;
	  },
	  endsWith: function endsWith(a, b) {
	    var pos = a.length - b.length,
	        lastIndex = a.indexOf(b, pos);
	
	    return lastIndex !== -1 && lastIndex === pos;
	  }
	};
	
	exports.default = common;
	module.exports = exports['default'];

/***/ }),
/* 881 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var offset = __webpack_require__(541),
	    getWindow = __webpack_require__(303);
	
	module.exports = function width(node, client) {
	  var win = getWindow(node);
	  return win ? win.innerWidth : client ? node.clientWidth : offset(node).width;
	};

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === "object") {
	    factory(exports);
	  } else {
	    factory(root.babelHelpers = {});
	  }
	})(this, function (global) {
	  var babelHelpers = global;
	
	  babelHelpers.interopRequireDefault = function (obj) {
	    return obj && obj.__esModule ? obj : {
	      "default": obj
	    };
	  };
	
	  babelHelpers._extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	})

/***/ }),
/* 884 */
/***/ (function(module, exports) {

	'use strict';
	
	var rUpper = /([A-Z])/g;
	
	module.exports = function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	};

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(306),
	    _assign = __webpack_require__(40);
	
	var ReactNoopUpdateQueue = __webpack_require__(888);
	
	var canDefineProperty = __webpack_require__(889);
	var emptyObject = __webpack_require__(336);
	var invariant = __webpack_require__(28);
	var lowPriorityWarning = __webpack_require__(1933);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(306);
	
	var ReactCurrentOwner = __webpack_require__(169);
	
	var invariant = __webpack_require__(28);
	var warning = __webpack_require__(61);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 887 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(61);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 890 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.memoize = exports.reverse = exports.compose = exports.map = exports.range = exports.curry = exports.PLACE_HOLDER = void 0;
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var identity = function identity(i) {
	  return i;
	};
	
	var PLACE_HOLDER = {
	  '@@functional/placeholder': true
	};
	exports.PLACE_HOLDER = PLACE_HOLDER;
	
	var isPlaceHolder = function isPlaceHolder(val) {
	  return val === PLACE_HOLDER;
	};
	
	var curry0 = function curry0(fn) {
	  return function _curried() {
	    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) {
	      return _curried;
	    }
	
	    return fn.apply(void 0, arguments);
	  };
	};
	
	var curryN = function curryN(n, fn) {
	  if (n === 1) {
	    return fn;
	  }
	
	  return curry0(function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var argsLength = args.filter(function (arg) {
	      return arg !== PLACE_HOLDER;
	    }).length;
	
	    if (argsLength >= n) {
	      return fn.apply(void 0, args);
	    }
	
	    return curryN(n - argsLength, curry0(function () {
	      for (var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        restArgs[_key2] = arguments[_key2];
	      }
	
	      var newArgs = args.map(function (arg) {
	        return isPlaceHolder(arg) ? restArgs.shift() : arg;
	      });
	      return fn.apply(void 0, _toConsumableArray(newArgs).concat(restArgs));
	    }));
	  });
	};
	
	var curry = function curry(fn) {
	  return curryN(fn.length, fn);
	};
	
	exports.curry = curry;
	
	var range = function range(begin, end) {
	  var arr = [];
	
	  for (var i = begin; i < end; ++i) {
	    arr[i - begin] = i;
	  }
	
	  return arr;
	};
	
	exports.range = range;
	var map = curry(function (fn, arr) {
	  if (Array.isArray(arr)) {
	    return arr.map(fn);
	  }
	
	  return Object.keys(arr).map(function (key) {
	    return arr[key];
	  }).map(fn);
	});
	exports.map = map;
	
	var compose = function compose() {
	  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    args[_key3] = arguments[_key3];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse(); // first function can receive multiply arguments
	
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(void 0, arguments));
	  };
	};
	
	exports.compose = compose;
	
	var reverse = function reverse(arr) {
	  if (Array.isArray(arr)) {
	    return arr.reverse();
	  } // can be string
	
	
	  return arr.split('').reverse.join('');
	};
	
	exports.reverse = reverse;
	
	var memoize = function memoize(fn) {
	  var lastArgs = null;
	  var lastResult = null;
	  return function () {
	    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    if (lastArgs && args.every(function (val, i) {
	      return val === lastArgs[i];
	    })) {
	      return lastResult;
	    }
	
	    lastArgs = args;
	    lastResult = fn.apply(void 0, args);
	    return lastResult;
	  };
	};
	
	exports.memoize = memoize;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _range2 = _interopRequireDefault(__webpack_require__(731));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _d3Scale = __webpack_require__(627);
	
	var _ChartUtils = __webpack_require__(103);
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _Text = _interopRequireDefault(__webpack_require__(217));
	
	var _DataUtils = __webpack_require__(66);
	
	var _CssPrefixUtils = __webpack_require__(1958);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Brush =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Brush, _PureComponent);
	
	  function Brush(props) {
	    var _this;
	
	    _classCallCheck(this, Brush);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Brush).call(this, props));
	
	    _this.handleDrag = function (e) {
	      if (_this.leaveTimer) {
	        clearTimeout(_this.leaveTimer);
	        _this.leaveTimer = null;
	      }
	
	      if (_this.state.isTravellerMoving) {
	        _this.handleTravellerMove(e);
	      } else if (_this.state.isSlideMoving) {
	        _this.handleSlideDrag(e);
	      }
	    };
	
	    _this.handleTouchMove = function (e) {
	      if (e.changedTouches != null && e.changedTouches.length > 0) {
	        _this.handleDrag(e.changedTouches[0]);
	      }
	    };
	
	    _this.handleDragEnd = function () {
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: false
	      });
	    };
	
	    _this.handleLeaveWrapper = function () {
	      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
	        _this.leaveTimer = setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
	      }
	    };
	
	    _this.handleEnterSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: true
	      });
	    };
	
	    _this.handleLeaveSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: false
	      });
	    };
	
	    _this.handleSlideDragStart = function (e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: true,
	        slideMoveStartX: event.pageX
	      });
	    };
	
	    _this.travellerDragStartHandlers = {
	      startX: _this.handleTravellerDragStart.bind(_assertThisInitialized(_this), 'startX'),
	      endX: _this.handleTravellerDragStart.bind(_assertThisInitialized(_this), 'endX')
	    };
	    _this.state = props.data && props.data.length ? _this.updateScale(props) : {};
	    return _this;
	  } // eslint-disable-next-line camelcase
	
	
	  _createClass(Brush, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          data = _this$props.data,
	          width = _this$props.width,
	          x = _this$props.x,
	          travellerWidth = _this$props.travellerWidth,
	          updateId = _this$props.updateId;
	
	      if ((nextProps.data !== data || nextProps.updateId !== updateId) && nextProps.data && nextProps.data.length) {
	        this.setState(this.updateScale(nextProps));
	      } else if (nextProps.width !== width || nextProps.x !== x || nextProps.travellerWidth !== travellerWidth) {
	        this.scale.range([nextProps.x, nextProps.x + nextProps.width - nextProps.travellerWidth]);
	        this.scaleValues = this.scale.domain().map(function (entry) {
	          return _this2.scale(entry);
	        });
	        this.setState({
	          startX: this.scale(nextProps.startIndex),
	          endX: this.scale(nextProps.endIndex)
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.scale = null;
	      this.scaleValues = null;
	
	      if (this.leaveTimer) {
	        clearTimeout(this.leaveTimer);
	        this.leaveTimer = null;
	      }
	    }
	  }, {
	    key: "getIndex",
	    value: function getIndex(_ref) {
	      var startX = _ref.startX,
	          endX = _ref.endX;
	      var _this$props2 = this.props,
	          gap = _this$props2.gap,
	          data = _this$props2.data;
	      var lastIndex = data.length - 1;
	      var min = Math.min(startX, endX);
	      var max = Math.max(startX, endX);
	      var minIndex = this.constructor.getIndexInRange(this.scaleValues, min);
	      var maxIndex = this.constructor.getIndexInRange(this.scaleValues, max);
	      return {
	        startIndex: minIndex - minIndex % gap,
	        endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
	      };
	    }
	  }, {
	    key: "getTextOfTick",
	    value: function getTextOfTick(index) {
	      var _this$props3 = this.props,
	          data = _this$props3.data,
	          tickFormatter = _this$props3.tickFormatter,
	          dataKey = _this$props3.dataKey;
	      var text = (0, _ChartUtils.getValueByDataKey)(data[index], dataKey, index);
	      return (0, _isFunction2["default"])(tickFormatter) ? tickFormatter(text) : text;
	    }
	  }, {
	    key: "handleSlideDrag",
	    value: function handleSlideDrag(e) {
	      var _this$state = this.state,
	          slideMoveStartX = _this$state.slideMoveStartX,
	          startX = _this$state.startX,
	          endX = _this$state.endX;
	      var _this$props4 = this.props,
	          x = _this$props4.x,
	          width = _this$props4.width,
	          travellerWidth = _this$props4.travellerWidth,
	          startIndex = _this$props4.startIndex,
	          endIndex = _this$props4.endIndex,
	          onChange = _this$props4.onChange;
	      var delta = e.pageX - slideMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - startX, x - endX);
	      }
	
	      var newIndex = this.getIndex({
	        startX: startX + delta,
	        endX: endX + delta
	      });
	
	      if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
	        onChange(newIndex);
	      }
	
	      this.setState({
	        startX: startX + delta,
	        endX: endX + delta,
	        slideMoveStartX: e.pageX
	      });
	    }
	  }, {
	    key: "handleTravellerDragStart",
	    value: function handleTravellerDragStart(id, e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	      this.setState({
	        isSlideMoving: false,
	        isTravellerMoving: true,
	        movingTravellerId: id,
	        brushMoveStartX: event.pageX
	      });
	    }
	  }, {
	    key: "handleTravellerMove",
	    value: function handleTravellerMove(e) {
	      var _this$setState;
	
	      var _this$state2 = this.state,
	          brushMoveStartX = _this$state2.brushMoveStartX,
	          movingTravellerId = _this$state2.movingTravellerId,
	          endX = _this$state2.endX,
	          startX = _this$state2.startX;
	      var prevValue = this.state[movingTravellerId];
	      var _this$props5 = this.props,
	          x = _this$props5.x,
	          width = _this$props5.width,
	          travellerWidth = _this$props5.travellerWidth,
	          onChange = _this$props5.onChange,
	          gap = _this$props5.gap,
	          data = _this$props5.data;
	      var params = {
	        startX: this.state.startX,
	        endX: this.state.endX
	      };
	      var delta = e.pageX - brushMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - prevValue);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - prevValue);
	      }
	
	      params[movingTravellerId] = prevValue + delta;
	      var newIndex = this.getIndex(params);
	      var startIndex = newIndex.startIndex,
	          endIndex = newIndex.endIndex;
	
	      var isFullGap = function isFullGap() {
	        var lastIndex = data.length - 1;
	
	        if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) {
	          return true;
	        }
	
	        return false;
	      };
	
	      this.setState((_this$setState = {}, _defineProperty(_this$setState, movingTravellerId, prevValue + delta), _defineProperty(_this$setState, "brushMoveStartX", e.pageX), _this$setState), function () {
	        if (onChange) {
	          if (isFullGap()) {
	            onChange(newIndex);
	          }
	        }
	      });
	    }
	  }, {
	    key: "updateScale",
	    value: function updateScale(props) {
	      var _this3 = this;
	
	      var data = props.data,
	          startIndex = props.startIndex,
	          endIndex = props.endIndex,
	          x = props.x,
	          width = props.width,
	          travellerWidth = props.travellerWidth;
	      var len = data.length;
	      this.scale = (0, _d3Scale.scalePoint)().domain((0, _range2["default"])(0, len)).range([x, x + width - travellerWidth]);
	      this.scaleValues = this.scale.domain().map(function (entry) {
	        return _this3.scale(entry);
	      });
	      return {
	        isTextActive: false,
	        isSlideMoving: false,
	        isTravellerMoving: false,
	        startX: this.scale(startIndex),
	        endX: this.scale(endIndex)
	      };
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground() {
	      var _this$props6 = this.props,
	          x = _this$props6.x,
	          y = _this$props6.y,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          fill = _this$props6.fill,
	          stroke = _this$props6.stroke;
	      return _react["default"].createElement("rect", {
	        stroke: stroke,
	        fill: fill,
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      });
	    }
	  }, {
	    key: "renderPanorama",
	    value: function renderPanorama() {
	      var _this$props7 = this.props,
	          x = _this$props7.x,
	          y = _this$props7.y,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          data = _this$props7.data,
	          children = _this$props7.children,
	          padding = _this$props7.padding;
	
	      var chartElement = _react.Children.only(children);
	
	      if (!chartElement) {
	        return null;
	      }
	
	      return _react["default"].cloneElement(chartElement, {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        margin: padding,
	        compact: true,
	        data: data
	      });
	    }
	  }, {
	    key: "renderTraveller",
	    value: function renderTraveller(travellerX, id) {
	      var _this$props8 = this.props,
	          y = _this$props8.y,
	          travellerWidth = _this$props8.travellerWidth,
	          height = _this$props8.height,
	          stroke = _this$props8.stroke;
	      var lineY = Math.floor(y + height / 2) - 1;
	      var x = Math.max(travellerX, this.props.x);
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-brush-traveller",
	        onMouseEnter: this.handleEnterSlideOrTraveller,
	        onMouseLeave: this.handleLeaveSlideOrTraveller,
	        onMouseDown: this.travellerDragStartHandlers[id],
	        onTouchStart: this.travellerDragStartHandlers[id],
	        style: {
	          cursor: 'col-resize'
	        }
	      }, _react["default"].createElement("rect", {
	        x: x,
	        y: y,
	        width: travellerWidth,
	        height: height,
	        fill: stroke,
	        stroke: "none"
	      }), _react["default"].createElement("line", {
	        x1: x + 1,
	        y1: lineY,
	        x2: x + travellerWidth - 1,
	        y2: lineY,
	        fill: "none",
	        stroke: "#fff"
	      }), _react["default"].createElement("line", {
	        x1: x + 1,
	        y1: lineY + 2,
	        x2: x + travellerWidth - 1,
	        y2: lineY + 2,
	        fill: "none",
	        stroke: "#fff"
	      }));
	    }
	  }, {
	    key: "renderSlide",
	    value: function renderSlide(startX, endX) {
	      var _this$props9 = this.props,
	          y = _this$props9.y,
	          height = _this$props9.height,
	          stroke = _this$props9.stroke;
	      return _react["default"].createElement("rect", {
	        className: "recharts-brush-slide",
	        onMouseEnter: this.handleEnterSlideOrTraveller,
	        onMouseLeave: this.handleLeaveSlideOrTraveller,
	        onMouseDown: this.handleSlideDragStart,
	        onTouchStart: this.handleSlideDragStart,
	        style: {
	          cursor: 'move'
	        },
	        stroke: "none",
	        fill: stroke,
	        fillOpacity: 0.2,
	        x: Math.min(startX, endX),
	        y: y,
	        width: Math.abs(endX - startX),
	        height: height
	      });
	    }
	  }, {
	    key: "renderText",
	    value: function renderText() {
	      var _this$props10 = this.props,
	          startIndex = _this$props10.startIndex,
	          endIndex = _this$props10.endIndex,
	          y = _this$props10.y,
	          height = _this$props10.height,
	          travellerWidth = _this$props10.travellerWidth,
	          stroke = _this$props10.stroke;
	      var _this$state3 = this.state,
	          startX = _this$state3.startX,
	          endX = _this$state3.endX;
	      var offset = 5;
	      var attrs = {
	        pointerEvents: 'none',
	        fill: stroke
	      };
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-brush-texts"
	      }, _react["default"].createElement(_Text["default"], _extends({
	        textAnchor: "end",
	        verticalAnchor: "middle",
	        x: Math.min(startX, endX) - offset,
	        y: y + height / 2
	      }, attrs), this.getTextOfTick(startIndex)), _react["default"].createElement(_Text["default"], _extends({
	        textAnchor: "start",
	        verticalAnchor: "middle",
	        x: Math.max(startX, endX) + travellerWidth + offset,
	        y: y + height / 2
	      }, attrs), this.getTextOfTick(endIndex)));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props11 = this.props,
	          data = _this$props11.data,
	          className = _this$props11.className,
	          children = _this$props11.children,
	          x = _this$props11.x,
	          y = _this$props11.y,
	          width = _this$props11.width,
	          height = _this$props11.height,
	          alwaysShowText = _this$props11.alwaysShowText;
	      var _this$state4 = this.state,
	          startX = _this$state4.startX,
	          endX = _this$state4.endX,
	          isTextActive = _this$state4.isTextActive,
	          isSlideMoving = _this$state4.isSlideMoving,
	          isTravellerMoving = _this$state4.isTravellerMoving;
	
	      if (!data || !data.length || !(0, _DataUtils.isNumber)(x) || !(0, _DataUtils.isNumber)(y) || !(0, _DataUtils.isNumber)(width) || !(0, _DataUtils.isNumber)(height) || width <= 0 || height <= 0) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-brush', className);
	      var isPanoramic = _react["default"].Children.count(children) === 1;
	      var style = (0, _CssPrefixUtils.generatePrefixStyle)('userSelect', 'none');
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass,
	        onMouseMove: this.handleDrag,
	        onMouseLeave: this.handleLeaveWrapper,
	        onMouseUp: this.handleDragEnd,
	        onTouchEnd: this.handleDragEnd,
	        onTouchMove: this.handleTouchMove,
	        style: style
	      }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTraveller(startX, 'startX'), this.renderTraveller(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || alwaysShowText) && this.renderText());
	    }
	  }], [{
	    key: "getIndexInRange",
	    value: function getIndexInRange(range, x) {
	      var len = range.length;
	      var start = 0;
	      var end = len - 1;
	
	      while (end - start > 1) {
	        var middle = Math.floor((start + end) / 2);
	
	        if (range[middle] > x) {
	          end = middle;
	        } else {
	          start = middle;
	        }
	      }
	
	      return x >= range[end] ? end : start;
	    }
	  }]);
	
	  return Brush;
	}(_react.PureComponent);
	
	Brush.displayName = 'Brush';
	Brush.propTypes = {
	  className: _propTypes["default"].string,
	  fill: _propTypes["default"].string,
	  stroke: _propTypes["default"].string,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number.isRequired,
	  travellerWidth: _propTypes["default"].number,
	  gap: _propTypes["default"].number,
	  padding: _propTypes["default"].shape({
	    top: _propTypes["default"].number,
	    right: _propTypes["default"].number,
	    bottom: _propTypes["default"].number,
	    left: _propTypes["default"].number
	  }),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  data: _propTypes["default"].array,
	  startIndex: _propTypes["default"].number,
	  endIndex: _propTypes["default"].number,
	  tickFormatter: _propTypes["default"].func,
	  children: _propTypes["default"].node,
	  onChange: _propTypes["default"].func,
	  updateId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  leaveTimeOut: _propTypes["default"].number,
	  alwaysShowText: _propTypes["default"].bool
	};
	Brush.defaultProps = {
	  height: 40,
	  travellerWidth: 5,
	  gap: 1,
	  fill: '#fff',
	  stroke: '#666',
	  padding: {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  },
	  leaveTimeOut: 1000,
	  alwaysShowText: false
	};
	var _default = Brush;
	exports["default"] = _default;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _ShallowEqual = __webpack_require__(394);
	
	var _DOMUtils = __webpack_require__(392);
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _Text = _interopRequireDefault(__webpack_require__(217));
	
	var _Label = _interopRequireDefault(__webpack_require__(190));
	
	var _ReactUtils = __webpack_require__(43);
	
	var _DataUtils = __webpack_require__(66);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CartesianAxis =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(CartesianAxis, _Component);
	
	  function CartesianAxis() {
	    _classCallCheck(this, CartesianAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(CartesianAxis).apply(this, arguments));
	  }
	
	  _createClass(CartesianAxis, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(_ref, state) {
	      var viewBox = _ref.viewBox,
	          restProps = _objectWithoutProperties(_ref, ["viewBox"]);
	
	      // props.viewBox is sometimes generated every time -
	      // check that specially as object equality is likely to fail
	      var _this$props = this.props,
	          viewBoxOld = _this$props.viewBox,
	          restPropsOld = _objectWithoutProperties(_this$props, ["viewBox"]);
	
	      return !(0, _ShallowEqual.shallowEqual)(viewBox, viewBoxOld) || !(0, _ShallowEqual.shallowEqual)(restProps, restPropsOld) || !(0, _ShallowEqual.shallowEqual)(state, this.state);
	    }
	    /**
	     * Calculate the coordinates of endpoints in ticks
	     * @param  {Object} data The data of a simple tick
	     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
	     *  (x2, y2): The coordinate of endpoint close to axis
	     */
	
	  }, {
	    key: "getTickLineCoord",
	    value: function getTickLineCoord(data) {
	      var _this$props2 = this.props,
	          x = _this$props2.x,
	          y = _this$props2.y,
	          width = _this$props2.width,
	          height = _this$props2.height,
	          orientation = _this$props2.orientation,
	          tickSize = _this$props2.tickSize,
	          mirror = _this$props2.mirror,
	          tickMargin = _this$props2.tickMargin;
	      var x1, x2, y1, y2, tx, ty;
	      var sign = mirror ? -1 : 1;
	      var finalTickSize = data.tickSize || tickSize;
	      var tickCoord = (0, _DataUtils.isNumber)(data.tickCoord) ? data.tickCoord : data.coordinate;
	
	      switch (orientation) {
	        case 'top':
	          x1 = x2 = data.coordinate;
	          y2 = y + !mirror * height;
	          y1 = y2 - sign * finalTickSize;
	          ty = y1 - sign * tickMargin;
	          tx = tickCoord;
	          break;
	
	        case 'left':
	          y1 = y2 = data.coordinate;
	          x2 = x + !mirror * width;
	          x1 = x2 - sign * finalTickSize;
	          tx = x1 - sign * tickMargin;
	          ty = tickCoord;
	          break;
	
	        case 'right':
	          y1 = y2 = data.coordinate;
	          x2 = x + mirror * width;
	          x1 = x2 + sign * finalTickSize;
	          tx = x1 + sign * tickMargin;
	          ty = tickCoord;
	          break;
	
	        default:
	          x1 = x2 = data.coordinate;
	          y2 = y + mirror * height;
	          y1 = y2 + sign * finalTickSize;
	          ty = y1 + sign * tickMargin;
	          tx = tickCoord;
	          break;
	      }
	
	      return {
	        line: {
	          x1: x1,
	          y1: y1,
	          x2: x2,
	          y2: y2
	        },
	        tick: {
	          x: tx,
	          y: ty
	        }
	      };
	    }
	  }, {
	    key: "getTickTextAnchor",
	    value: function getTickTextAnchor() {
	      var _this$props3 = this.props,
	          orientation = _this$props3.orientation,
	          mirror = _this$props3.mirror;
	      var textAnchor;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = mirror ? 'start' : 'end';
	          break;
	
	        case 'right':
	          textAnchor = mirror ? 'end' : 'start';
	          break;
	
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: "getTickVerticalAnchor",
	    value: function getTickVerticalAnchor() {
	      var _this$props4 = this.props,
	          orientation = _this$props4.orientation,
	          mirror = _this$props4.mirror;
	      var verticalAnchor = 'end';
	
	      switch (orientation) {
	        case 'left':
	        case 'right':
	          verticalAnchor = 'middle';
	          break;
	
	        case 'top':
	          verticalAnchor = mirror ? 'start' : 'end';
	          break;
	
	        default:
	          verticalAnchor = mirror ? 'end' : 'start';
	          break;
	      }
	
	      return verticalAnchor;
	    }
	  }, {
	    key: "renderAxisLine",
	    value: function renderAxisLine() {
	      var _this$props5 = this.props,
	          x = _this$props5.x,
	          y = _this$props5.y,
	          width = _this$props5.width,
	          height = _this$props5.height,
	          orientation = _this$props5.orientation,
	          axisLine = _this$props5.axisLine,
	          mirror = _this$props5.mirror;
	
	      var props = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (orientation === 'top' || orientation === 'bottom') {
	        var needHeight = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	        props = _objectSpread({}, props, {
	          x1: x,
	          y1: y + needHeight * height,
	          x2: x + width,
	          y2: y + needHeight * height
	        });
	      } else {
	        var needWidth = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	        props = _objectSpread({}, props, {
	          x1: x + needWidth * width,
	          y1: y,
	          x2: x + needWidth * width,
	          y2: y + height
	        });
	      }
	
	      return _react["default"].createElement("line", _extends({
	        className: "recharts-cartesian-axis-line"
	      }, props));
	    }
	  }, {
	    key: "renderTicks",
	
	    /**
	     * render the ticks
	     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
	     * @return {ReactComponent} renderedTicks
	     */
	    value: function renderTicks(ticks) {
	      var _this = this;
	
	      var _this$props6 = this.props,
	          tickLine = _this$props6.tickLine,
	          stroke = _this$props6.stroke,
	          tick = _this$props6.tick,
	          tickFormatter = _this$props6.tickFormatter,
	          unit = _this$props6.unit;
	      var finalTicks = CartesianAxis.getTicks(_objectSpread({}, this.props, {
	        ticks: ticks
	      }));
	      var textAnchor = this.getTickTextAnchor();
	      var verticalAnchor = this.getTickVerticalAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	
	      var tickLineProps = _objectSpread({}, axisProps, {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	
	      var items = finalTicks.map(function (entry, i) {
	        var _this$getTickLineCoor = _this.getTickLineCoord(entry),
	            lineCoord = _this$getTickLineCoor.line,
	            tickCoord = _this$getTickLineCoor.tick;
	
	        var tickProps = _objectSpread({
	          textAnchor: textAnchor,
	          verticalAnchor: verticalAnchor
	        }, axisProps, {
	          stroke: 'none',
	          fill: stroke
	        }, customTickProps, {}, tickCoord, {
	          index: i,
	          payload: entry,
	          visibleTicksCount: finalTicks.length
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-cartesian-axis-tick",
	          key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), tickLine && _react["default"].createElement("line", _extends({
	          className: "recharts-cartesian-axis-tick-line"
	        }, tickLineProps, lineCoord)), tick && _this.constructor.renderTickItem(tick, tickProps, "".concat((0, _isFunction2["default"])(tickFormatter) ? tickFormatter(entry.value) : entry.value).concat(unit || '')));
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-axis-ticks"
	      }, items);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props7 = this.props,
	          axisLine = _this$props7.axisLine,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          ticksGenerator = _this$props7.ticksGenerator,
	          className = _this$props7.className,
	          hide = _this$props7.hide;
	
	      if (hide) {
	        return null;
	      }
	
	      var _this$props8 = this.props,
	          ticks = _this$props8.ticks,
	          noTicksProps = _objectWithoutProperties(_this$props8, ["ticks"]);
	
	      var finalTicks = ticks;
	
	      if ((0, _isFunction2["default"])(ticksGenerator)) {
	        finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
	      }
	
	      if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) {
	        return null;
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: (0, _classnames["default"])('recharts-cartesian-axis', className)
	      }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks), _Label["default"].renderCallByParent(this.props));
	    }
	  }], [{
	    key: "getTicks",
	    value: function getTicks(props) {
	      var tick = props.tick,
	          ticks = props.ticks,
	          viewBox = props.viewBox,
	          minTickGap = props.minTickGap,
	          orientation = props.orientation,
	          interval = props.interval,
	          tickFormatter = props.tickFormatter,
	          unit = props.unit;
	
	      if (!ticks || !ticks.length || !tick) {
	        return [];
	      }
	
	      if ((0, _DataUtils.isNumber)(interval) || (0, _ReactUtils.isSsr)()) {
	        return CartesianAxis.getNumberIntervalTicks(ticks, (0, _DataUtils.isNumber)(interval) ? interval : 0);
	      }
	
	      if (interval === 'preserveStartEnd') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks,
	          tickFormatter: tickFormatter,
	          viewBox: viewBox,
	          orientation: orientation,
	          minTickGap: minTickGap,
	          unit: unit
	        }, true);
	      }
	
	      if (interval === 'preserveStart') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks,
	          tickFormatter: tickFormatter,
	          viewBox: viewBox,
	          orientation: orientation,
	          minTickGap: minTickGap,
	          unit: unit
	        });
	      }
	
	      return CartesianAxis.getTicksEnd({
	        ticks: ticks,
	        tickFormatter: tickFormatter,
	        viewBox: viewBox,
	        orientation: orientation,
	        minTickGap: minTickGap,
	        unit: unit
	      });
	    }
	  }, {
	    key: "getNumberIntervalTicks",
	    value: function getNumberIntervalTicks(ticks, interval) {
	      return ticks.filter(function (entry, i) {
	        return i % (interval + 1) === 0;
	      });
	    }
	  }, {
	    key: "getTicksStart",
	    value: function getTicksStart(_ref2, preserveEnd) {
	      var ticks = _ref2.ticks,
	          tickFormatter = _ref2.tickFormatter,
	          viewBox = _ref2.viewBox,
	          orientation = _ref2.orientation,
	          minTickGap = _ref2.minTickGap,
	          unit = _ref2.unit;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
	      var result = (ticks || []).slice(); // we need add the width of 'unit' only when sizeKey === 'width'
	
	      var unitSize = unit && sizeKey === 'width' ? (0, _DOMUtils.getStringSize)(unit)[sizeKey] : 0;
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	      var start, end;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      if (preserveEnd) {
	        // Try to guarantee the tail to be displayed
	        var tail = ticks[len - 1];
	        var tailContent = (0, _isFunction2["default"])(tickFormatter) ? tickFormatter(tail.value) : tail.value;
	        var tailSize = (0, _DOMUtils.getStringSize)(tailContent)[sizeKey] + unitSize;
	        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
	        result[len - 1] = tail = _objectSpread({}, tail, {
	          tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
	        });
	        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;
	
	        if (isTailShow) {
	          end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
	          result[len - 1] = _objectSpread({}, tail, {
	            isShow: true
	          });
	        }
	      }
	
	      var count = preserveEnd ? len - 1 : len;
	
	      for (var _i = 0; _i < count; _i++) {
	        var entry = result[_i];
	        var content = (0, _isFunction2["default"])(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey] + unitSize;
	
	        if (_i === 0) {
	          var gap = sign * (entry.coordinate - sign * size / 2 - start);
	          result[_i] = entry = _objectSpread({}, entry, {
	            tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[_i] = entry = _objectSpread({}, entry, {
	            tickCoord: entry.coordinate
	          });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          start = entry.tickCoord + sign * (size / 2 + minTickGap);
	          result[_i] = _objectSpread({}, entry, {
	            isShow: true
	          });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }, {
	    key: "getTicksEnd",
	    value: function getTicksEnd(_ref3) {
	      var ticks = _ref3.ticks,
	          tickFormatter = _ref3.tickFormatter,
	          viewBox = _ref3.viewBox,
	          orientation = _ref3.orientation,
	          minTickGap = _ref3.minTickGap,
	          unit = _ref3.unit;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height'; // we need add the width of 'unit' only when sizeKey === 'width'
	
	      var unitSize = unit && sizeKey === 'width' ? (0, _DOMUtils.getStringSize)(unit)[sizeKey] : 0;
	      var result = (ticks || []).slice();
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	      var start, end;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      for (var _i2 = len - 1; _i2 >= 0; _i2--) {
	        var entry = result[_i2];
	        var content = (0, _isFunction2["default"])(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey] + unitSize;
	
	        if (_i2 === len - 1) {
	          var gap = sign * (entry.coordinate + sign * size / 2 - end);
	          result[_i2] = entry = _objectSpread({}, entry, {
	            tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[_i2] = entry = _objectSpread({}, entry, {
	            tickCoord: entry.coordinate
	          });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          end = entry.tickCoord - sign * (size / 2 + minTickGap);
	          result[_i2] = _objectSpread({}, entry, {
	            isShow: true
	          });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }, {
	    key: "renderTickItem",
	    value: function renderTickItem(option, props, value) {
	      var tickItem;
	
	      if (_react["default"].isValidElement(option)) {
	        tickItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react["default"].createElement(_Text["default"], _extends({}, props, {
	          className: "recharts-cartesian-axis-tick-value"
	        }), value);
	      }
	
	      return tickItem;
	    }
	  }]);
	
	  return CartesianAxis;
	}(_react.Component);
	
	CartesianAxis.displayName = 'CartesianAxis';
	CartesianAxis.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  orientation: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'right']),
	  // The viewBox of svg
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tickLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  mirror: _propTypes["default"].bool,
	  tickMargin: _propTypes["default"].number.isRequired,
	  minTickGap: _propTypes["default"].number,
	  ticks: _propTypes["default"].array,
	  tickSize: _propTypes["default"].number,
	  stroke: _propTypes["default"].string,
	  tickFormatter: _propTypes["default"].func,
	  ticksGenerator: _propTypes["default"].func,
	  interval: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])])
	});
	CartesianAxis.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  viewBox: {
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  // The orientation of axis
	  orientation: 'bottom',
	  // The ticks
	  ticks: [],
	  stroke: '#666',
	  tickLine: true,
	  axisLine: true,
	  tick: true,
	  mirror: false,
	  minTickGap: 5,
	  // The width or height of tick
	  tickSize: 6,
	  tickMargin: 2,
	  interval: 'preserveEnd'
	};
	var _default = CartesianAxis;
	exports["default"] = _default;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _Label = _interopRequireDefault(__webpack_require__(190));
	
	var _CartesianUtils = __webpack_require__(191);
	
	var _IfOverflowMatches = __webpack_require__(393);
	
	var _DataUtils = __webpack_require__(66);
	
	var _LogUtils = __webpack_require__(259);
	
	var _ReactUtils = __webpack_require__(43);
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(258));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ReferenceArea =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ReferenceArea, _PureComponent);
	
	  function ReferenceArea() {
	    _classCallCheck(this, ReferenceArea);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceArea).apply(this, arguments));
	  }
	
	  _createClass(ReferenceArea, [{
	    key: "getRect",
	    value: function getRect(hasX1, hasX2, hasY1, hasY2) {
	      var _this$props = this.props,
	          xValue1 = _this$props.x1,
	          xValue2 = _this$props.x2,
	          yValue1 = _this$props.y1,
	          yValue2 = _this$props.y2,
	          xAxis = _this$props.xAxis,
	          yAxis = _this$props.yAxis;
	
	      var scale = _CartesianUtils.LabeledScaleHelper.create({
	        x: xAxis.scale,
	        y: yAxis.scale
	      });
	
	      var p1 = {
	        x: hasX1 ? scale.x.apply(xValue1) : scale.x.rangeMin,
	        y: hasY1 ? scale.y.apply(yValue1) : scale.y.rangeMin
	      };
	      var p2 = {
	        x: hasX2 ? scale.x.apply(xValue2) : scale.x.rangeMax,
	        y: hasY2 ? scale.y.apply(yValue2) : scale.y.rangeMax
	      };
	
	      if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && (!scale.isInRange(p1) || !scale.isInRange(p2))) {
	        return null;
	      }
	
	      return (0, _CartesianUtils.rectWithPoints)(p1, p2);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          x1 = _this$props2.x1,
	          x2 = _this$props2.x2,
	          y1 = _this$props2.y1,
	          y2 = _this$props2.y2,
	          className = _this$props2.className,
	          alwaysShow = _this$props2.alwaysShow,
	          clipPathId = _this$props2.clipPathId;
	      (0, _LogUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
	      var hasX1 = (0, _DataUtils.isNumOrStr)(x1);
	      var hasX2 = (0, _DataUtils.isNumOrStr)(x2);
	      var hasY1 = (0, _DataUtils.isNumOrStr)(y1);
	      var hasY2 = (0, _DataUtils.isNumOrStr)(y2);
	      var shape = this.props.shape;
	
	      if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) {
	        return null;
	      }
	
	      var rect = this.getRect(hasX1, hasX2, hasY1, hasY2);
	
	      if (!rect && !shape) {
	        return null;
	      }
	
	      var clipPath = (0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
	      return _react["default"].createElement(_Layer["default"], {
	        className: (0, _classnames["default"])('recharts-reference-area', className)
	      }, this.constructor.renderRect(shape, _objectSpread({
	        clipPath: clipPath
	      }, this.props, {}, rect)), _Label["default"].renderCallByParent(this.props, rect));
	    }
	  }], [{
	    key: "renderRect",
	    value: function renderRect(option, props) {
	      var rect;
	
	      if (_react["default"].isValidElement(option)) {
	        rect = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        rect = option(props);
	      } else {
	        rect = _react["default"].createElement(_Rectangle["default"], _extends({}, props, {
	          className: "recharts-reference-area-rect"
	        }));
	      }
	
	      return rect;
	    }
	  }]);
	
	  return ReferenceArea;
	}(_react.PureComponent);
	
	ReferenceArea.displayName = 'ReferenceArea';
	ReferenceArea.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  xAxis: _propTypes["default"].object,
	  yAxis: _propTypes["default"].object,
	  isFront: _propTypes["default"].bool,
	  alwaysShow: _propTypes["default"].bool,
	  ifOverflow: _propTypes["default"].oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
	  x1: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  x2: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  y1: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  y2: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element])
	});
	ReferenceArea.defaultProps = {
	  isFront: false,
	  ifOverflow: 'discard',
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#ccc',
	  fillOpacity: 0.5,
	  stroke: 'none',
	  strokeWidth: 1
	};
	var _default = ReferenceArea;
	exports["default"] = _default;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _Dot = _interopRequireDefault(__webpack_require__(218));
	
	var _ReactUtils = __webpack_require__(43);
	
	var _Label = _interopRequireDefault(__webpack_require__(190));
	
	var _DataUtils = __webpack_require__(66);
	
	var _IfOverflowMatches = __webpack_require__(393);
	
	var _CartesianUtils = __webpack_require__(191);
	
	var _LogUtils = __webpack_require__(259);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ReferenceDot =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ReferenceDot, _PureComponent);
	
	  function ReferenceDot() {
	    _classCallCheck(this, ReferenceDot);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceDot).apply(this, arguments));
	  }
	
	  _createClass(ReferenceDot, [{
	    key: "getCoordinate",
	    value: function getCoordinate() {
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          xAxis = _this$props.xAxis,
	          yAxis = _this$props.yAxis;
	
	      var scales = _CartesianUtils.LabeledScaleHelper.create({
	        x: xAxis.scale,
	        y: yAxis.scale
	      });
	
	      var result = scales.apply({
	        x: x,
	        y: y
	      }, {
	        bandAware: true
	      });
	
	      if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && !scales.isInRange(result)) {
	        return null;
	      }
	
	      return result;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          x = _this$props2.x,
	          y = _this$props2.y,
	          r = _this$props2.r,
	          alwaysShow = _this$props2.alwaysShow,
	          clipPathId = _this$props2.clipPathId;
	      var isX = (0, _DataUtils.isNumOrStr)(x);
	      var isY = (0, _DataUtils.isNumOrStr)(y);
	      (0, _LogUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
	
	      if (!isX || !isY) {
	        return null;
	      }
	
	      var coordinate = this.getCoordinate();
	
	      if (!coordinate) {
	        return null;
	      }
	
	      var cx = coordinate.x,
	          cy = coordinate.y;
	      var _this$props3 = this.props,
	          shape = _this$props3.shape,
	          className = _this$props3.className;
	      var clipPath = (0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
	
	      var dotProps = _objectSpread({
	        clipPath: clipPath
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	        cx: cx,
	        cy: cy
	      });
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: (0, _classnames["default"])('recharts-reference-dot', className)
	      }, this.constructor.renderDot(shape, dotProps), _Label["default"].renderCallByParent(this.props, {
	        x: cx - r,
	        y: cy - r,
	        width: 2 * r,
	        height: 2 * r
	      }));
	    }
	  }], [{
	    key: "renderDot",
	    value: function renderDot(option, props) {
	      var dot;
	
	      if (_react["default"].isValidElement(option)) {
	        dot = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        dot = option(props);
	      } else {
	        dot = _react["default"].createElement(_Dot["default"], _extends({}, props, {
	          cx: props.cx,
	          cy: props.cy,
	          className: "recharts-reference-dot-dot"
	        }));
	      }
	
	      return dot;
	    }
	  }]);
	
	  return ReferenceDot;
	}(_react.PureComponent);
	
	ReferenceDot.displayName = 'ReferenceDot';
	ReferenceDot.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  r: _propTypes["default"].number,
	  xAxis: _propTypes["default"].shape({
	    scale: _propTypes["default"].func
	  }),
	  yAxis: _propTypes["default"].shape({
	    scale: _propTypes["default"].func
	  }),
	  isFront: _propTypes["default"].bool,
	  alwaysShow: _propTypes["default"].bool,
	  ifOverflow: _propTypes["default"].oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
	  x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element]),
	  clipPathId: _propTypes["default"].string
	});
	ReferenceDot.defaultProps = {
	  isFront: false,
	  ifOverflow: 'discard',
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#fff',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1
	};
	var _default = ReferenceDot;
	exports["default"] = _default;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _some2 = _interopRequireDefault(__webpack_require__(1482));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _ReactUtils = __webpack_require__(43);
	
	var _Label = _interopRequireDefault(__webpack_require__(190));
	
	var _IfOverflowMatches = __webpack_require__(393);
	
	var _DataUtils = __webpack_require__(66);
	
	var _CartesianUtils = __webpack_require__(191);
	
	var _LogUtils = __webpack_require__(259);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var renderLine = function renderLine(option, props) {
	  var line;
	
	  if (_react["default"].isValidElement(option)) {
	    line = _react["default"].cloneElement(option, props);
	  } else if ((0, _isFunction2["default"])(option)) {
	    line = option(props);
	  } else {
	    line = _react["default"].createElement("line", _extends({}, props, {
	      className: "recharts-reference-line-line"
	    }));
	  }
	
	  return line;
	};
	
	var ReferenceLine =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ReferenceLine, _PureComponent);
	
	  function ReferenceLine() {
	    _classCallCheck(this, ReferenceLine);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceLine).apply(this, arguments));
	  }
	
	  _createClass(ReferenceLine, [{
	    key: "getEndPoints",
	    value: function getEndPoints(scales, isFixedX, isFixedY, isSegment) {
	      var _this$props = this.props,
	          _this$props$viewBox = _this$props.viewBox,
	          x = _this$props$viewBox.x,
	          y = _this$props$viewBox.y,
	          width = _this$props$viewBox.width,
	          height = _this$props$viewBox.height,
	          position = _this$props.position;
	
	      if (isFixedY) {
	        var _this$props2 = this.props,
	            yCoord = _this$props2.y,
	            orientation = _this$props2.yAxis.orientation;
	        var coord = scales.y.apply(yCoord, {
	          position: position
	        });
	
	        if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && !scales.y.isInRange(coord)) {
	          return null;
	        }
	
	        var points = [{
	          x: x + width,
	          y: coord
	        }, {
	          x: x,
	          y: coord
	        }];
	        return orientation === 'left' ? points.reverse() : points;
	      }
	
	      if (isFixedX) {
	        var _this$props3 = this.props,
	            xCoord = _this$props3.x,
	            _orientation = _this$props3.xAxis.orientation;
	
	        var _coord = scales.x.apply(xCoord, {
	          position: position
	        });
	
	        if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && !scales.x.isInRange(_coord)) {
	          return null;
	        }
	
	        var _points = [{
	          x: _coord,
	          y: y + height
	        }, {
	          x: _coord,
	          y: y
	        }];
	        return _orientation === 'top' ? _points.reverse() : _points;
	      }
	
	      if (isSegment) {
	        var segment = this.props.segment;
	
	        var _points2 = segment.map(function (p) {
	          return scales.apply(p, {
	            position: position
	          });
	        });
	
	        if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && (0, _some2["default"])(_points2, function (p) {
	          return !scales.isInRange(p);
	        })) {
	          return null;
	        }
	
	        return _points2;
	      }
	
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          fixedX = _this$props4.x,
	          fixedY = _this$props4.y,
	          segment = _this$props4.segment,
	          xAxis = _this$props4.xAxis,
	          yAxis = _this$props4.yAxis,
	          shape = _this$props4.shape,
	          className = _this$props4.className,
	          alwaysShow = _this$props4.alwaysShow,
	          clipPathId = _this$props4.clipPathId;
	      (0, _LogUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
	
	      var scales = _CartesianUtils.LabeledScaleHelper.create({
	        x: xAxis.scale,
	        y: yAxis.scale
	      });
	
	      var isX = (0, _DataUtils.isNumOrStr)(fixedX);
	      var isY = (0, _DataUtils.isNumOrStr)(fixedY);
	      var isSegment = segment && segment.length === 2;
	      var endPoints = this.getEndPoints(scales, isX, isY, isSegment);
	
	      if (!endPoints) {
	        return null;
	      }
	
	      var _endPoints = _slicedToArray(endPoints, 2),
	          _endPoints$ = _endPoints[0],
	          x1 = _endPoints$.x,
	          y1 = _endPoints$.y,
	          _endPoints$2 = _endPoints[1],
	          x2 = _endPoints$2.x,
	          y2 = _endPoints$2.y;
	
	      var clipPath = (0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
	
	      var props = _objectSpread({
	        clipPath: clipPath
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2
	      });
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: (0, _classnames["default"])('recharts-reference-line', className)
	      }, renderLine(shape, props), _Label["default"].renderCallByParent(this.props, (0, _CartesianUtils.rectWithCoords)({
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2
	      })));
	    }
	  }]);
	
	  return ReferenceLine;
	}(_react.PureComponent);
	
	ReferenceLine.displayName = 'ReferenceLine';
	ReferenceLine.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  xAxis: _propTypes["default"].object,
	  yAxis: _propTypes["default"].object,
	  isFront: _propTypes["default"].bool,
	  alwaysShow: _propTypes["default"].bool,
	  ifOverflow: _propTypes["default"].oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
	  x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  segment: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	  })),
	  position: _propTypes["default"].oneOf(['middle', 'start', 'end']),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  shape: _propTypes["default"].func
	});
	ReferenceLine.defaultProps = {
	  isFront: false,
	  ifOverflow: 'discard',
	  xAxisId: 0,
	  yAxisId: 0,
	  fill: 'none',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1,
	  position: 'middle'
	};
	var _default = ReferenceLine;
	exports["default"] = _default;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(125));
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(137));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _omit2 = _interopRequireDefault(__webpack_require__(730));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(163));
	
	var _isNumber2 = _interopRequireDefault(__webpack_require__(239));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(129));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _Trapezoid = _interopRequireDefault(__webpack_require__(901));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(171));
	
	var _Cell = _interopRequireDefault(__webpack_require__(256));
	
	var _ReactUtils = __webpack_require__(43);
	
	var _DataUtils = __webpack_require__(66);
	
	var _ChartUtils = __webpack_require__(103);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Funnel =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Funnel, _PureComponent);
	
	  function Funnel() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Funnel);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Funnel)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevData = function (trapezoids) {
	      _this.setState({
	        prevTrapezoids: trapezoids
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Funnel, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          trapezoids = _this$props.trapezoids;
	
	      if (nextProps.isAnimationActive !== this.props.isAnimationActive) {
	        this.cachePrevData([]);
	      } else if (nextProps.animationId !== animationId) {
	        this.cachePrevData(trapezoids);
	      }
	    }
	  }, {
	    key: "isActiveIndex",
	    value: function isActiveIndex(i) {
	      var activeIndex = this.props.activeIndex;
	
	      if (Array.isArray(activeIndex)) {
	        return activeIndex.indexOf(i) !== -1;
	      }
	
	      return i === activeIndex;
	    }
	  }, {
	    key: "renderTrapezoidsStatically",
	    value: function renderTrapezoidsStatically(trapezoids) {
	      var _this2 = this;
	
	      var activeShape = this.props.activeShape;
	      return trapezoids.map(function (entry, i) {
	        var trapezoidOptions = _this2.isActiveIndex(i) ? activeShape : null;
	
	        var trapezoidProps = _objectSpread({}, entry, {
	          stroke: entry.stroke
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-funnel-trapezoid"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "trapezoid-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }), _this2.constructor.renderTrapezoidItem(trapezoidOptions, trapezoidProps));
	      });
	    }
	  }, {
	    key: "renderTrapezoidsWithAnimation",
	    value: function renderTrapezoidsWithAnimation() {
	      var _this3 = this;
	
	      var _this$props2 = this.props,
	          trapezoids = _this$props2.trapezoids,
	          isAnimationActive = _this$props2.isAnimationActive,
	          animationBegin = _this$props2.animationBegin,
	          animationDuration = _this$props2.animationDuration,
	          animationEasing = _this$props2.animationEasing,
	          animationId = _this$props2.animationId;
	      var prevTrapezoids = this.state.prevTrapezoids;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "funnel-".concat(animationId),
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = trapezoids.map(function (entry, index) {
	          var prev = prevTrapezoids && prevTrapezoids[index];
	
	          if (prev) {
	            var _interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	
	            var _interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	            var _interpolatorUpperWidth = (0, _DataUtils.interpolateNumber)(prev.upperWidth, entry.upperWidth);
	
	            var _interpolatorLowerWidth = (0, _DataUtils.interpolateNumber)(prev.lowerWidth, entry.lowerWidth);
	
	            var _interpolatorHeight = (0, _DataUtils.interpolateNumber)(prev.height, entry.height);
	
	            return _objectSpread({}, entry, {
	              x: _interpolatorX(t),
	              y: _interpolatorY(t),
	              upperWidth: _interpolatorUpperWidth(t),
	              lowerWidth: _interpolatorLowerWidth(t),
	              height: _interpolatorHeight(t)
	            });
	          }
	
	          var interpolatorX = (0, _DataUtils.interpolateNumber)(entry.x + entry.upperWidth / 2, entry.x);
	          var interpolatorY = (0, _DataUtils.interpolateNumber)(entry.y + entry.height / 2, entry.y);
	          var interpolatorUpperWidth = (0, _DataUtils.interpolateNumber)(0, entry.upperWidth);
	          var interpolatorLowerWidth = (0, _DataUtils.interpolateNumber)(0, entry.lowerWidth);
	          var interpolatorHeight = (0, _DataUtils.interpolateNumber)(0, entry.height);
	          return _objectSpread({}, entry, {
	            x: interpolatorX(t),
	            y: interpolatorY(t),
	            upperWidth: interpolatorUpperWidth(t),
	            lowerWidth: interpolatorLowerWidth(t),
	            height: interpolatorHeight(t)
	          });
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this3.renderTrapezoidsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderTrapezoids",
	    value: function renderTrapezoids() {
	      var _this$props3 = this.props,
	          trapezoids = _this$props3.trapezoids,
	          isAnimationActive = _this$props3.isAnimationActive;
	      var prevTrapezoids = this.state.prevTrapezoids;
	
	      if (isAnimationActive && trapezoids && trapezoids.length && (!prevTrapezoids || !(0, _isEqual2["default"])(prevTrapezoids, trapezoids))) {
	        return this.renderTrapezoidsWithAnimation();
	      }
	
	      return this.renderTrapezoidsStatically(trapezoids);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          hide = _this$props4.hide,
	          trapezoids = _this$props4.trapezoids,
	          className = _this$props4.className,
	          isAnimationActive = _this$props4.isAnimationActive;
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      if (hide || !trapezoids || !trapezoids.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-trapezoids', className);
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, this.renderTrapezoids(), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, trapezoids));
	    }
	  }], [{
	    key: "renderTrapezoidItem",
	    value: function renderTrapezoidItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      if ((0, _isPlainObject2["default"])(option)) {
	        return _react["default"].createElement(_Trapezoid["default"], _extends({}, props, option));
	      }
	
	      return _react["default"].createElement(_Trapezoid["default"], props);
	    }
	  }]);
	
	  return Funnel;
	}(_react.PureComponent);
	
	Funnel.displayName = 'Funnel';
	Funnel.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  animationId: _propTypes["default"].number,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  nameKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  data: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  trapezoids: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  hide: _propTypes["default"].bool,
	  activeShape: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  activeIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].number)]),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear'])
	});
	Funnel.defaultProps = {
	  stroke: '#fff',
	  fill: '#808080',
	  legendType: 'rect',
	  labelLine: true,
	  hide: false,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 400,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  nameKey: 'name'
	};
	
	Funnel.getRealFunnelData = function (item) {
	  var _item$props = item.props,
	      data = _item$props.data,
	      children = _item$props.children;
	  var presentationProps = (0, _ReactUtils.getPresentationAttributes)(item.props);
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell["default"]);
	
	  if (data && data.length) {
	    return data.map(function (entry, index) {
	      return _objectSpread({
	        payload: entry
	      }, presentationProps, {}, entry, {}, cells && cells[index] && cells[index].props);
	    });
	  }
	
	  if (cells && cells.length) {
	    return cells.map(function (cell) {
	      return _objectSpread({}, presentationProps, {}, cell.props);
	    });
	  }
	
	  return [];
	};
	
	Funnel.getRealWidthHeight = function (item, offset) {
	  var customWidth = item.props.width;
	  var width = offset.width,
	      height = offset.height,
	      left = offset.left,
	      right = offset.right,
	      top = offset.top,
	      bottom = offset.bottom;
	  var realHeight = height;
	  var realWidth = width;
	
	  if ((0, _isNumber2["default"])(customWidth)) {
	    realWidth = customWidth;
	  } else if ((0, _isString2["default"])(customWidth)) {
	    realWidth = realWidth * parseFloat(customWidth) / 100;
	  }
	
	  return {
	    realWidth: realWidth - left - right - 50,
	    realHeight: realHeight - bottom - top,
	    offsetX: (width - realWidth) / 2,
	    offsetY: (height - realHeight) / 2
	  };
	};
	
	Funnel.getComposedData = function (_ref2) {
	  var item = _ref2.item,
	      offset = _ref2.offset,
	      onItemMouseLeave = _ref2.onItemMouseLeave,
	      onItemMouseEnter = _ref2.onItemMouseEnter;
	  var funnelData = Funnel.getRealFunnelData(item);
	  var _item$props2 = item.props,
	      dataKey = _item$props2.dataKey,
	      nameKey = _item$props2.nameKey,
	      tooltipType = _item$props2.tooltipType;
	  var left = offset.left,
	      top = offset.top;
	
	  var _Funnel$getRealWidthH = Funnel.getRealWidthHeight(item, offset),
	      realHeight = _Funnel$getRealWidthH.realHeight,
	      realWidth = _Funnel$getRealWidthH.realWidth,
	      offsetX = _Funnel$getRealWidthH.offsetX,
	      offsetY = _Funnel$getRealWidthH.offsetY;
	
	  var maxValue = (0, _ChartUtils.getValueByDataKey)(funnelData[0], dataKey, 0);
	  var len = funnelData.length;
	  var rowHeight = realHeight / len;
	  var trapezoids = funnelData.map(function (entry, i) {
	    var val = (0, _ChartUtils.getValueByDataKey)(entry, dataKey, 0);
	    var name = (0, _ChartUtils.getValueByDataKey)(entry, nameKey, i);
	    var nextVal = 0;
	
	    if (i !== len - 1) {
	      nextVal = (0, _ChartUtils.getValueByDataKey)(funnelData[i + 1], dataKey, 0);
	    }
	
	    var x = (maxValue - val) * realWidth / (2 * maxValue) + top + 25 + offsetX;
	    var y = realHeight / len * i + left + offsetY;
	    var upperWidth = val / maxValue * realWidth;
	    var lowerWidth = nextVal / maxValue * realWidth;
	    var tooltipPayload = [{
	      name: name,
	      value: val,
	      payload: entry,
	      dataKey: dataKey,
	      type: tooltipType
	    }];
	    var tooltipPosition = {
	      x: x + upperWidth / 2,
	      y: y + rowHeight / 2
	    };
	    return _objectSpread({
	      x: x,
	      y: y,
	      width: Math.max(upperWidth, lowerWidth),
	      upperWidth: upperWidth,
	      lowerWidth: lowerWidth,
	      height: rowHeight,
	      name: name,
	      val: val,
	      tooltipPayload: tooltipPayload,
	      tooltipPosition: tooltipPosition
	    }, (0, _omit2["default"])(entry, 'width'), {
	      payload: entry
	    });
	  });
	  return {
	    trapezoids: trapezoids,
	    data: funnelData,
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter
	  };
	};
	
	var _default = Funnel;
	exports["default"] = _default;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(125));
	
	var _get2 = _interopRequireDefault(__webpack_require__(207));
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(137));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(115));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(129));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _Sector = _interopRequireDefault(__webpack_require__(391));
	
	var _Curve = _interopRequireDefault(__webpack_require__(257));
	
	var _Text = _interopRequireDefault(__webpack_require__(217));
	
	var _Label = _interopRequireDefault(__webpack_require__(190));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(171));
	
	var _Cell = _interopRequireDefault(__webpack_require__(256));
	
	var _ReactUtils = __webpack_require__(43);
	
	var _PolarUtils = __webpack_require__(142);
	
	var _DataUtils = __webpack_require__(66);
	
	var _ChartUtils = __webpack_require__(103);
	
	var _LogUtils = __webpack_require__(259);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Pie =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Pie, _PureComponent);
	
	  function Pie() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Pie);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Pie)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-pie-');
	
	    _this.cachePrevData = function (sectors) {
	      _this.setState({
	        prevSectors: sectors
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Pie, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          sectors = _this$props.sectors;
	
	      if (nextProps.isAnimationActive !== this.props.isAnimationActive) {
	        this.cachePrevData([]);
	      } else if (nextProps.animationId !== animationId) {
	        this.cachePrevData(sectors);
	      }
	    }
	  }, {
	    key: "isActiveIndex",
	    value: function isActiveIndex(i) {
	      var activeIndex = this.props.activeIndex;
	
	      if (Array.isArray(activeIndex)) {
	        return activeIndex.indexOf(i) !== -1;
	      }
	
	      return i === activeIndex;
	    }
	  }, {
	    key: "renderLabels",
	    value: function renderLabels(sectors) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props2 = this.props,
	          label = _this$props2.label,
	          labelLine = _this$props2.labelLine,
	          dataKey = _this$props2.dataKey,
	          valueKey = _this$props2.valueKey;
	      var pieProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	      var customLabelLineProps = (0, _ReactUtils.getPresentationAttributes)(labelLine);
	      var offsetRadius = label && label.offsetRadius || 20;
	      var labels = sectors.map(function (entry, i) {
	        var midAngle = (entry.startAngle + entry.endAngle) / 2;
	        var endPoint = (0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
	
	        var labelProps = _objectSpread({}, pieProps, {}, entry, {
	          stroke: 'none'
	        }, customLabelProps, {
	          index: i,
	          textAnchor: _this2.constructor.getTextAnchor(endPoint.x, entry.cx)
	        }, endPoint);
	
	        var lineProps = _objectSpread({}, pieProps, {}, entry, {
	          fill: 'none',
	          stroke: entry.fill
	        }, customLabelLineProps, {
	          index: i,
	          points: [(0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint],
	          key: 'line'
	        });
	
	        var realDataKey = dataKey; // TODO: compatible to lower versions
	
	        if ((0, _isNil2["default"])(dataKey) && (0, _isNil2["default"])(valueKey)) {
	          realDataKey = 'value';
	        } else if ((0, _isNil2["default"])(dataKey)) {
	          realDataKey = valueKey;
	        }
	
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement(_Layer["default"], {
	            key: "label-".concat(i)
	          }, labelLine && _this2.constructor.renderLabelLineItem(labelLine, lineProps), _this2.constructor.renderLabelItem(label, labelProps, (0, _ChartUtils.getValueByDataKey)(entry, realDataKey)))
	        );
	      });
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-pie-labels"
	      }, labels);
	    }
	  }, {
	    key: "renderSectorsStatically",
	    value: function renderSectorsStatically(sectors) {
	      var _this3 = this;
	
	      var _this$props3 = this.props,
	          activeShape = _this$props3.activeShape,
	          blendStroke = _this$props3.blendStroke;
	      return sectors.map(function (entry, i) {
	        var sectorOptions = _this3.isActiveIndex(i) ? activeShape : null;
	
	        var sectorProps = _objectSpread({}, entry, {
	          stroke: blendStroke ? entry.fill : entry.stroke
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-pie-sector"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this3.props, entry, i), {
	          key: "sector-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }), _this3.constructor.renderSectorItem(sectorOptions, sectorProps));
	      });
	    }
	  }, {
	    key: "renderSectorsWithAnimation",
	    value: function renderSectorsWithAnimation() {
	      var _this4 = this;
	
	      var _this$props4 = this.props,
	          sectors = _this$props4.sectors,
	          isAnimationActive = _this$props4.isAnimationActive,
	          animationBegin = _this$props4.animationBegin,
	          animationDuration = _this$props4.animationDuration,
	          animationEasing = _this$props4.animationEasing,
	          animationId = _this$props4.animationId;
	      var prevSectors = this.state.prevSectors;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "pie-".concat(animationId),
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = [];
	        var first = sectors && sectors[0];
	        var curAngle = first.startAngle;
	        sectors.forEach(function (entry, index) {
	          var prev = prevSectors && prevSectors[index];
	          var paddingAngle = index > 0 ? (0, _get2["default"])(entry, 'paddingAngle', 0) : 0;
	
	          if (prev) {
	            var angleIp = (0, _DataUtils.interpolateNumber)(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
	
	            var latest = _objectSpread({}, entry, {
	              startAngle: curAngle + paddingAngle,
	              endAngle: curAngle + angleIp(t) + paddingAngle
	            });
	
	            stepData.push(latest);
	            curAngle = latest.endAngle;
	          } else {
	            var endAngle = entry.endAngle,
	                startAngle = entry.startAngle;
	            var interpolatorAngle = (0, _DataUtils.interpolateNumber)(0, endAngle - startAngle);
	            var deltaAngle = interpolatorAngle(t);
	
	            var _latest = _objectSpread({}, entry, {
	              startAngle: curAngle + paddingAngle,
	              endAngle: curAngle + deltaAngle + paddingAngle
	            });
	
	            stepData.push(_latest);
	            curAngle = _latest.endAngle;
	          }
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this4.renderSectorsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderSectors",
	    value: function renderSectors() {
	      var _this$props5 = this.props,
	          sectors = _this$props5.sectors,
	          isAnimationActive = _this$props5.isAnimationActive;
	      var prevSectors = this.state.prevSectors;
	
	      if (isAnimationActive && sectors && sectors.length && (!prevSectors || !(0, _isEqual2["default"])(prevSectors, sectors))) {
	        return this.renderSectorsWithAnimation();
	      }
	
	      return this.renderSectorsStatically(sectors);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          hide = _this$props6.hide,
	          sectors = _this$props6.sectors,
	          className = _this$props6.className,
	          label = _this$props6.label,
	          cx = _this$props6.cx,
	          cy = _this$props6.cy,
	          innerRadius = _this$props6.innerRadius,
	          outerRadius = _this$props6.outerRadius,
	          isAnimationActive = _this$props6.isAnimationActive,
	          prevSectors = _this$props6.prevSectors;
	
	      if (hide || !sectors || !sectors.length || !(0, _DataUtils.isNumber)(cx) || !(0, _DataUtils.isNumber)(cy) || !(0, _DataUtils.isNumber)(innerRadius) || !(0, _DataUtils.isNumber)(outerRadius)) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-pie', className);
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, this.renderSectors(), label && this.renderLabels(sectors), _Label["default"].renderCallByParent(this.props, null, false), (!isAnimationActive || prevSectors && (0, _isEqual2["default"])(prevSectors, sectors)) && _LabelList["default"].renderCallByParent(this.props, sectors, false));
	    }
	  }], [{
	    key: "getTextAnchor",
	    value: function getTextAnchor(x, cx) {
	      if (x > cx) {
	        return 'start';
	      }
	
	      if (x < cx) {
	        return 'end';
	      }
	
	      return 'middle';
	    }
	  }, {
	    key: "renderLabelLineItem",
	    value: function renderLabelLineItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      return _react["default"].createElement(_Curve["default"], _extends({}, props, {
	        type: "linear",
	        className: "recharts-pie-label-line"
	      }));
	    }
	  }, {
	    key: "renderLabelItem",
	    value: function renderLabelItem(option, props, value) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      var label = value;
	
	      if ((0, _isFunction2["default"])(option)) {
	        label = option(props);
	
	        if (_react["default"].isValidElement(label)) {
	          return label;
	        }
	      }
	
	      return _react["default"].createElement(_Text["default"], _extends({}, props, {
	        alignmentBaseline: "middle",
	        className: "recharts-pie-label-text"
	      }), label);
	    }
	  }, {
	    key: "renderSectorItem",
	    value: function renderSectorItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      if ((0, _isPlainObject2["default"])(option)) {
	        return _react["default"].createElement(_Sector["default"], _extends({}, props, option));
	      }
	
	      return _react["default"].createElement(_Sector["default"], props);
	    }
	  }]);
	
	  return Pie;
	}(_react.PureComponent);
	
	Pie.displayName = 'Pie';
	Pie.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  animationId: _propTypes["default"].number,
	  cx: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  cy: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  startAngle: _propTypes["default"].number,
	  endAngle: _propTypes["default"].number,
	  paddingAngle: _propTypes["default"].number,
	  innerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  outerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  cornerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  nameKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  valueKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  data: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  blendStroke: _propTypes["default"].bool,
	  minAngle: _propTypes["default"].number,
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  maxRadius: _propTypes["default"].number,
	  sectors: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  hide: _propTypes["default"].bool,
	  labelLine: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].bool]),
	  label: _propTypes["default"].oneOfType([_propTypes["default"].shape({
	    offsetRadius: _propTypes["default"].number
	  }), _propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].bool]),
	  activeShape: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  activeIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].number)]),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear']),
	  id: _propTypes["default"].string
	});
	Pie.defaultProps = {
	  stroke: '#fff',
	  fill: '#808080',
	  legendType: 'rect',
	  // The abscissa of pole
	  cx: '50%',
	  // The ordinate of pole
	  cy: '50%',
	  // The start angle of first sector
	  startAngle: 0,
	  // The direction of drawing sectors
	  endAngle: 360,
	  // The inner radius of sectors
	  innerRadius: 0,
	  // The outer radius of sectors
	  outerRadius: '80%',
	  paddingAngle: 0,
	  labelLine: true,
	  hide: false,
	  minAngle: 0,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 400,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  nameKey: 'name',
	  // Match each sector's stroke color to it's fill color
	  blendStroke: false
	};
	
	Pie.parseDeltaAngle = function (_ref2) {
	  var startAngle = _ref2.startAngle,
	      endAngle = _ref2.endAngle;
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	  return sign * deltaAngle;
	};
	
	Pie.getRealPieData = function (item) {
	  var _item$props = item.props,
	      data = _item$props.data,
	      children = _item$props.children;
	  var presentationProps = (0, _ReactUtils.getPresentationAttributes)(item.props);
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell["default"]);
	
	  if (data && data.length) {
	    return data.map(function (entry, index) {
	      return _objectSpread({
	        payload: entry
	      }, presentationProps, {}, entry, {}, cells && cells[index] && cells[index].props);
	    });
	  }
	
	  if (cells && cells.length) {
	    return cells.map(function (cell) {
	      return _objectSpread({}, presentationProps, {}, cell.props);
	    });
	  }
	
	  return [];
	};
	
	Pie.parseCoordinateOfPie = function (item, offset) {
	  var top = offset.top,
	      left = offset.left,
	      width = offset.width,
	      height = offset.height;
	  var maxPieRadius = (0, _PolarUtils.getMaxRadius)(width, height);
	  var cx = left + (0, _DataUtils.getPercentValue)(item.props.cx, width, width / 2);
	  var cy = top + (0, _DataUtils.getPercentValue)(item.props.cy, height, height / 2);
	  var innerRadius = (0, _DataUtils.getPercentValue)(item.props.innerRadius, maxPieRadius, 0);
	  var outerRadius = (0, _DataUtils.getPercentValue)(item.props.outerRadius, maxPieRadius, maxPieRadius * 0.8);
	  var maxRadius = item.props.maxRadius || Math.sqrt(width * width + height * height) / 2;
	  return {
	    cx: cx,
	    cy: cy,
	    innerRadius: innerRadius,
	    outerRadius: outerRadius,
	    maxRadius: maxRadius
	  };
	};
	
	Pie.getComposedData = function (_ref3) {
	  var item = _ref3.item,
	      offset = _ref3.offset,
	      onItemMouseLeave = _ref3.onItemMouseLeave,
	      onItemMouseEnter = _ref3.onItemMouseEnter;
	  var pieData = Pie.getRealPieData(item);
	
	  if (!pieData || !pieData.length) {
	    return [];
	  }
	
	  var _item$props2 = item.props,
	      cornerRadius = _item$props2.cornerRadius,
	      startAngle = _item$props2.startAngle,
	      endAngle = _item$props2.endAngle,
	      paddingAngle = _item$props2.paddingAngle,
	      dataKey = _item$props2.dataKey,
	      nameKey = _item$props2.nameKey,
	      valueKey = _item$props2.valueKey,
	      tooltipType = _item$props2.tooltipType;
	  var minAngle = Math.abs(item.props.minAngle);
	  var coordinate = Pie.parseCoordinateOfPie(item, offset);
	  var len = pieData.length;
	  var deltaAngle = Pie.parseDeltaAngle({
	    startAngle: startAngle,
	    endAngle: endAngle
	  });
	  var absDeltaAngle = Math.abs(deltaAngle);
	  var totalPadingAngle = (absDeltaAngle >= 360 ? len : len - 1) * paddingAngle;
	  var realTotalAngle = absDeltaAngle - len * minAngle - totalPadingAngle;
	  var realDataKey = dataKey;
	
	  if ((0, _isNil2["default"])(dataKey) && (0, _isNil2["default"])(valueKey)) {
	    (0, _LogUtils.warn)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
	    realDataKey = 'value';
	  } else if ((0, _isNil2["default"])(dataKey)) {
	    (0, _LogUtils.warn)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
	    realDataKey = valueKey;
	  }
	
	  var sum = pieData.reduce(function (result, entry) {
	    var val = (0, _ChartUtils.getValueByDataKey)(entry, realDataKey, 0);
	    return result + ((0, _DataUtils.isNumber)(val) ? val : 0);
	  }, 0);
	  var sectors;
	
	  if (sum > 0) {
	    var prev;
	    sectors = pieData.map(function (entry, i) {
	      var val = (0, _ChartUtils.getValueByDataKey)(entry, realDataKey, 0);
	      var name = (0, _ChartUtils.getValueByDataKey)(entry, nameKey, i);
	      var percent = ((0, _DataUtils.isNumber)(val) ? val : 0) / sum;
	      var tempStartAngle;
	
	      if (i) {
	        tempStartAngle = prev.endAngle + (0, _DataUtils.mathSign)(deltaAngle) * paddingAngle;
	      } else {
	        tempStartAngle = startAngle;
	      }
	
	      var tempEndAngle = tempStartAngle + (0, _DataUtils.mathSign)(deltaAngle) * (minAngle + percent * realTotalAngle);
	      var midAngle = (tempStartAngle + tempEndAngle) / 2;
	      var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
	      var tooltipPayload = [{
	        name: name,
	        value: val,
	        payload: entry,
	        dataKey: realDataKey,
	        type: tooltipType
	      }];
	      var tooltipPosition = (0, _PolarUtils.polarToCartesian)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
	      prev = _objectSpread({
	        percent: percent,
	        cornerRadius: cornerRadius,
	        name: name,
	        tooltipPayload: tooltipPayload,
	        midAngle: midAngle,
	        middleRadius: middleRadius,
	        tooltipPosition: tooltipPosition
	      }, entry, {}, coordinate, {
	        value: (0, _ChartUtils.getValueByDataKey)(entry, realDataKey),
	        startAngle: tempStartAngle,
	        endAngle: tempEndAngle,
	        payload: entry,
	        paddingAngle: (0, _DataUtils.mathSign)(deltaAngle) * paddingAngle
	      });
	      return prev;
	    });
	  }
	
	  return _objectSpread({}, coordinate, {
	    sectors: sectors,
	    data: pieData,
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter
	  });
	};
	
	var _default = Pie;
	exports["default"] = _default;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(125));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(129));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _DataUtils = __webpack_require__(66);
	
	var _ReactUtils = __webpack_require__(43);
	
	var _PolarUtils = __webpack_require__(142);
	
	var _ChartUtils = __webpack_require__(103);
	
	var _Polygon = _interopRequireDefault(__webpack_require__(390));
	
	var _Dot = _interopRequireDefault(__webpack_require__(218));
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(171));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Radar =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Radar, _PureComponent);
	
	  function Radar() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Radar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Radar)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevData = function (points) {
	      _this.setState({
	        prevPoints: points
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    _this.handleMouseEnter = function (e) {
	      var onMouseEnter = _this.props.onMouseEnter;
	
	      if (onMouseEnter) {
	        onMouseEnter(_this.props, e);
	      }
	    };
	
	    _this.handleMouseLeave = function (e) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	      if (onMouseLeave) {
	        onMouseLeave(_this.props, e);
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Radar, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points);
	      }
	    }
	  }, {
	    key: "renderDots",
	    value: function renderDots(points) {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          dot = _this$props2.dot,
	          dataKey = _this$props2.dataKey;
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _objectSpread({
	          key: "dot-".concat(i),
	          r: 3
	        }, baseProps, {}, customDotProps, {
	          dataKey: dataKey,
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          payload: entry
	        });
	
	        return _this2.constructor.renderDotItem(dot, dotProps);
	      });
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-radar-dots"
	      }, dots);
	    }
	  }, {
	    key: "renderPolygonStatically",
	    value: function renderPolygonStatically(points) {
	      var _this$props3 = this.props,
	          shape = _this$props3.shape,
	          dot = _this$props3.dot;
	      var radar;
	
	      if (_react["default"].isValidElement(shape)) {
	        radar = _react["default"].cloneElement(shape, _objectSpread({}, this.props, {
	          points: points
	        }));
	      } else if ((0, _isFunction2["default"])(shape)) {
	        radar = shape(_objectSpread({}, this.props, {
	          points: points
	        }));
	      } else {
	        radar = _react["default"].createElement(_Polygon["default"], _extends({}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave
	        }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          points: points
	        }));
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-radar-polygon"
	      }, radar, dot ? this.renderDots(points) : null);
	    }
	  }, {
	    key: "renderPolygonWithAnimation",
	    value: function renderPolygonWithAnimation() {
	      var _this3 = this;
	
	      var _this$props4 = this.props,
	          points = _this$props4.points,
	          isAnimationActive = _this$props4.isAnimationActive,
	          animationBegin = _this$props4.animationBegin,
	          animationDuration = _this$props4.animationDuration,
	          animationEasing = _this$props4.animationEasing,
	          animationId = _this$props4.animationId;
	      var prevPoints = this.state.prevPoints;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "radar-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	        var prevPointsDiffFactor = prevPoints && prevPoints.length / points.length;
	        var stepData = points.map(function (entry, index) {
	          var prev = prevPoints && prevPoints[Math.floor(index * prevPointsDiffFactor)];
	
	          if (prev) {
	            var _interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	
	            var _interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	            return _objectSpread({}, entry, {
	              x: _interpolatorX(t),
	              y: _interpolatorY(t)
	            });
	          }
	
	          var interpolatorX = (0, _DataUtils.interpolateNumber)(entry.cx, entry.x);
	          var interpolatorY = (0, _DataUtils.interpolateNumber)(entry.cy, entry.y);
	          return _objectSpread({}, entry, {
	            x: interpolatorX(t),
	            y: interpolatorY(t)
	          });
	        });
	        return _this3.renderPolygonStatically(stepData);
	      });
	    }
	  }, {
	    key: "renderPolygon",
	    value: function renderPolygon() {
	      var _this$props5 = this.props,
	          points = _this$props5.points,
	          isAnimationActive = _this$props5.isAnimationActive;
	      var prevPoints = this.state.prevPoints;
	
	      if (isAnimationActive && points && points.length && (!prevPoints || !(0, _isEqual2["default"])(prevPoints, points))) {
	        return this.renderPolygonWithAnimation();
	      }
	
	      return this.renderPolygonStatically(points);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          hide = _this$props6.hide,
	          className = _this$props6.className,
	          points = _this$props6.points,
	          isAnimationActive = _this$props6.isAnimationActive;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var layerClass = (0, _classnames["default"])('recharts-radar', className);
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, this.renderPolygon(), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, points));
	    }
	  }], [{
	    key: "renderDotItem",
	    value: function renderDotItem(option, props) {
	      var dotItem;
	
	      if (_react["default"].isValidElement(option)) {
	        dotItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        dotItem = option(props);
	      } else {
	        dotItem = _react["default"].createElement(_Dot["default"], _extends({}, props, {
	          className: "recharts-radar-dot"
	        }));
	      }
	
	      return dotItem;
	    }
	  }]);
	
	  return Radar;
	}(_react.PureComponent);
	
	Radar.displayName = 'Radar';
	Radar.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].func]).isRequired,
	  angleAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  radiusAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    cx: _propTypes["default"].number,
	    cy: _propTypes["default"].number,
	    angle: _propTypes["default"].number,
	    radius: _propTypes["default"].number,
	    value: _propTypes["default"].number,
	    payload: _propTypes["default"].object
	  })),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  activeDot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  // whether have dot in poly line
	  dot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  label: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].bool]),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  hide: _propTypes["default"].bool,
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animationId: _propTypes["default"].number,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	});
	Radar.defaultProps = {
	  angleAxisId: 0,
	  radiusAxisId: 0,
	  hide: false,
	  activeDot: true,
	  dot: false,
	  legendType: 'rect',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	};
	
	Radar.getComposedData = function (_ref2) {
	  var radiusAxis = _ref2.radiusAxis,
	      angleAxis = _ref2.angleAxis,
	      displayedData = _ref2.displayedData,
	      dataKey = _ref2.dataKey,
	      bandSize = _ref2.bandSize;
	  var cx = angleAxis.cx,
	      cy = angleAxis.cy;
	  var points = displayedData.map(function (entry, i) {
	    var name = (0, _ChartUtils.getValueByDataKey)(entry, angleAxis.dataKey, i);
	    var value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey, 0);
	    var angle = angleAxis.scale(name) + (bandSize || 0);
	    var radius = radiusAxis.scale(value);
	    return _objectSpread({}, (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle), {
	      name: name,
	      value: value,
	      cx: cx,
	      cy: cy,
	      radius: radius,
	      angle: angle,
	      payload: entry
	    });
	  });
	  return {
	    points: points
	  };
	};
	
	var _default = Radar;
	exports["default"] = _default;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(125));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(62));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(129));
	
	var _Sector = _interopRequireDefault(__webpack_require__(391));
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _ReactUtils = __webpack_require__(43);
	
	var _LabelList = _interopRequireDefault(__webpack_require__(171));
	
	var _Cell = _interopRequireDefault(__webpack_require__(256));
	
	var _DataUtils = __webpack_require__(66);
	
	var _ChartUtils = __webpack_require__(103);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var RadialBar =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(RadialBar, _PureComponent);
	
	  function RadialBar() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, RadialBar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RadialBar)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevData = function (data) {
	      _this.setState({
	        prevData: data
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(RadialBar, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          data = _this$props.data;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(data);
	      }
	    }
	  }, {
	    key: "getDeltaAngle",
	    value: function getDeltaAngle() {
	      var _this$props2 = this.props,
	          startAngle = _this$props2.startAngle,
	          endAngle = _this$props2.endAngle;
	      var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	      return sign * deltaAngle;
	    }
	  }, {
	    key: "renderSectorsStatically",
	    value: function renderSectorsStatically(sectors) {
	      var _this2 = this;
	
	      var _this$props3 = this.props,
	          shape = _this$props3.shape,
	          activeShape = _this$props3.activeShape,
	          activeIndex = _this$props3.activeIndex,
	          cornerRadius = _this$props3.cornerRadius,
	          others = _objectWithoutProperties(_this$props3, ["shape", "activeShape", "activeIndex", "cornerRadius"]);
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(others);
	      return sectors.map(function (entry, i) {
	        var props = _objectSpread({}, baseProps, {
	          cornerRadius: cornerRadius
	        }, entry, {}, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "sector-".concat(i),
	          className: 'recharts-radial-bar-sector',
	          forceCornerRadius: others.forceCornerRadius,
	          cornerIsExternal: others.cornerIsExternal
	        });
	
	        return _this2.constructor.renderSectorShape(i === activeIndex ? activeShape : shape, props);
	      });
	    }
	  }, {
	    key: "renderSectorsWithAnimation",
	    value: function renderSectorsWithAnimation() {
	      var _this3 = this;
	
	      var _this$props4 = this.props,
	          data = _this$props4.data,
	          isAnimationActive = _this$props4.isAnimationActive,
	          animationBegin = _this$props4.animationBegin,
	          animationDuration = _this$props4.animationDuration,
	          animationEasing = _this$props4.animationEasing,
	          animationId = _this$props4.animationId;
	      var prevData = this.state.prevData;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "radialBar-".concat(animationId),
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = data.map(function (entry, index) {
	          var prev = prevData && prevData[index];
	
	          if (prev) {
	            var interpolatorStartAngle = (0, _DataUtils.interpolateNumber)(prev.startAngle, entry.startAngle);
	            var interpolatorEndAngle = (0, _DataUtils.interpolateNumber)(prev.endAngle, entry.endAngle);
	            return _objectSpread({}, entry, {
	              startAngle: interpolatorStartAngle(t),
	              endAngle: interpolatorEndAngle(t)
	            });
	          }
	
	          var endAngle = entry.endAngle,
	              startAngle = entry.startAngle;
	          var interpolator = (0, _DataUtils.interpolateNumber)(startAngle, endAngle);
	          return _objectSpread({}, entry, {
	            endAngle: interpolator(t)
	          });
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this3.renderSectorsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderSectors",
	    value: function renderSectors() {
	      var _this$props5 = this.props,
	          data = _this$props5.data,
	          isAnimationActive = _this$props5.isAnimationActive;
	      var prevData = this.state.prevData;
	
	      if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqual2["default"])(prevData, data))) {
	        return this.renderSectorsWithAnimation();
	      }
	
	      return this.renderSectorsStatically(data);
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground(sectors) {
	      var _this4 = this;
	
	      var cornerRadius = this.props.cornerRadius;
	      var backgroundProps = (0, _ReactUtils.getPresentationAttributes)(this.props.background);
	      return sectors.map(function (entry, i) {
	        // eslint-disable-next-line no-unused-vars
	        var value = entry.value,
	            background = entry.background,
	            rest = _objectWithoutProperties(entry, ["value", "background"]);
	
	        if (!background) {
	          return null;
	        }
	
	        var props = _objectSpread({
	          cornerRadius: cornerRadius
	        }, rest, {
	          fill: '#eee'
	        }, background, {}, backgroundProps, {}, (0, _ReactUtils.filterEventsOfChild)(_this4.props, entry, i), {
	          index: i,
	          key: "sector-".concat(i),
	          className: 'recharts-radial-bar-background-sector'
	        });
	
	        return _this4.constructor.renderSectorShape(background, props);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          hide = _this$props6.hide,
	          data = _this$props6.data,
	          className = _this$props6.className,
	          background = _this$props6.background,
	          isAnimationActive = _this$props6.isAnimationActive;
	
	      if (hide || !data || !data.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var layerClass = (0, _classnames["default"])('recharts-area', className);
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, background && _react["default"].createElement(_Layer["default"], {
	        className: "recharts-radial-bar-background"
	      }, this.renderBackground(data)), _react["default"].createElement(_Layer["default"], {
	        className: "recharts-radial-bar-sectors"
	      }, this.renderSectors(data)), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(_objectSpread({}, this.props, {
	        clockWise: this.getDeltaAngle() < 0
	      }), data));
	    }
	  }], [{
	    key: "renderSectorShape",
	    value: function renderSectorShape(shape, props) {
	      var sectorShape;
	
	      if (_react["default"].isValidElement(shape)) {
	        sectorShape = _react["default"].cloneElement(shape, props);
	      } else if ((0, _isFunction2["default"])(shape)) {
	        sectorShape = shape(props);
	      } else {
	        sectorShape = _react["default"].createElement(_Sector["default"], props);
	      }
	
	      return sectorShape;
	    }
	  }]);
	
	  return RadialBar;
	}(_react.PureComponent);
	
	RadialBar.displayName = 'RadialBar';
	RadialBar.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  angleAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  radiusAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element]),
	  activeShape: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  activeIndex: _propTypes["default"].number,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  cornerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  forceCornerRadius: _propTypes["default"].bool,
	  cornerIsExternal: _propTypes["default"].bool,
	  minPointSize: _propTypes["default"].number,
	  maxBarSize: _propTypes["default"].number,
	  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    cx: _propTypes["default"].number,
	    cy: _propTypes["default"].number,
	    innerRadius: _propTypes["default"].number,
	    outerRadius: _propTypes["default"].number,
	    value: _propTypes["default"].value
	  })),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  label: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].object]),
	  background: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  hide: _propTypes["default"].bool,
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear', 'spring'])
	});
	RadialBar.defaultProps = {
	  angleAxisId: 0,
	  radiusAxisId: 0,
	  minPointSize: 0,
	  hide: false,
	  legendType: 'rect',
	  data: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  forceCornerRadius: false,
	  cornerIsExternal: false
	};
	
	RadialBar.getComposedData = function (_ref2) {
	  var item = _ref2.item,
	      props = _ref2.props,
	      radiusAxis = _ref2.radiusAxis,
	      radiusAxisTicks = _ref2.radiusAxisTicks,
	      angleAxis = _ref2.angleAxis,
	      angleAxisTicks = _ref2.angleAxisTicks,
	      displayedData = _ref2.displayedData,
	      dataKey = _ref2.dataKey,
	      stackedData = _ref2.stackedData,
	      barPosition = _ref2.barPosition,
	      bandSize = _ref2.bandSize,
	      dataStartIndex = _ref2.dataStartIndex;
	  var pos = (0, _ChartUtils.findPositionOfBar)(barPosition, item);
	
	  if (!pos) {
	    return [];
	  }
	
	  var cx = angleAxis.cx,
	      cy = angleAxis.cy;
	  var layout = props.layout;
	  var _item$props = item.props,
	      children = _item$props.children,
	      minPointSize = _item$props.minPointSize;
	  var numericAxis = layout === 'radial' ? angleAxis : radiusAxis;
	  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
	  var baseValue = (0, _ChartUtils.getBaseValueOfBar)({
	    props: props,
	    numericAxis: numericAxis
	  });
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell["default"]);
	  var sectors = displayedData.map(function (entry, index) {
	    var value, innerRadius, outerRadius, startAngle, endAngle, backgroundSector;
	
	    if (stackedData) {
	      value = (0, _ChartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray2["default"])(value)) {
	        value = [baseValue, value];
	      }
	    }
	
	    if (layout === 'radial') {
	      innerRadius = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: radiusAxis,
	        ticks: radiusAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      endAngle = angleAxis.scale(value[1]);
	      startAngle = angleAxis.scale(value[0]);
	      outerRadius = innerRadius + pos.size;
	      var deltaAngle = endAngle - startAngle;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(deltaAngle) < Math.abs(minPointSize)) {
	        var delta = (0, _DataUtils.mathSign)(deltaAngle || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaAngle));
	        endAngle += delta;
	      }
	
	      backgroundSector = {
	        background: {
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          startAngle: props.startAngle,
	          endAngle: props.endAngle
	        }
	      };
	    } else {
	      innerRadius = radiusAxis.scale(value[0]);
	      outerRadius = radiusAxis.scale(value[1]);
	      startAngle = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: angleAxis,
	        ticks: angleAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      endAngle = startAngle + pos.size;
	      var deltaRadius = outerRadius - innerRadius;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(deltaRadius) < Math.abs(minPointSize)) {
	        var _delta = (0, _DataUtils.mathSign)(deltaRadius || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaRadius));
	
	        outerRadius += _delta;
	      }
	    }
	
	    return _objectSpread({}, entry, {}, backgroundSector, {
	      payload: entry,
	      value: stackedData ? value : value[1],
	      cx: cx,
	      cy: cy,
	      innerRadius: innerRadius,
	      outerRadius: outerRadius,
	      startAngle: startAngle,
	      endAngle: endAngle
	    }, cells && cells[index] && cells[index].props);
	  });
	  return {
	    data: sectors,
	    layout: layout
	  };
	};
	
	var _default = RadialBar;
	exports["default"] = _default;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _DataUtils = __webpack_require__(66);
	
	var _ReactUtils = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Cross =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Cross, _PureComponent);
	
	  function Cross() {
	    _classCallCheck(this, Cross);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Cross).apply(this, arguments));
	  }
	
	  _createClass(Cross, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          width = _this$props.width,
	          height = _this$props.height,
	          top = _this$props.top,
	          left = _this$props.left,
	          className = _this$props.className;
	
	      if (!(0, _DataUtils.isNumber)(x) || !(0, _DataUtils.isNumber)(y) || !(0, _DataUtils.isNumber)(width) || !(0, _DataUtils.isNumber)(height) || !(0, _DataUtils.isNumber)(top) || !(0, _DataUtils.isNumber)(left)) {
	        return null;
	      }
	
	      return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: (0, _classnames["default"])('recharts-cross', className),
	        d: this.constructor.getPath(x, y, width, height, top, left)
	      }));
	    }
	  }], [{
	    key: "getPath",
	    value: function getPath(x, y, width, height, top, left) {
	      return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
	    }
	  }]);
	
	  return Cross;
	}(_react.PureComponent);
	
	Cross.displayName = 'Cross';
	Cross.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  top: _propTypes["default"].number,
	  left: _propTypes["default"].number,
	  className: _propTypes["default"].string
	});
	Cross.defaultProps = {
	  x: 0,
	  y: 0,
	  top: 0,
	  left: 0,
	  width: 0,
	  height: 0
	};
	var _default = Cross;
	exports["default"] = _default;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(129));
	
	var _ReactUtils = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
	  var widthGap = upperWidth - lowerWidth;
	  var path;
	  path = "M ".concat(x, ",").concat(y);
	  path += "L ".concat(x + upperWidth, ",").concat(y);
	  path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
	  path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
	  path += "L ".concat(x, ",").concat(y, " Z");
	  return path;
	};
	
	var Trapezoid =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Trapezoid, _PureComponent);
	
	  function Trapezoid() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Trapezoid);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Trapezoid)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      totalLength: -1
	    };
	    return _this;
	  }
	
	  _createClass(Trapezoid, [{
	    key: "componentDidMount",
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (this.node && this.node.getTotalLength) {
	        try {
	          var totalLength = this.node.getTotalLength();
	
	          if (totalLength) {
	            this.setState({
	              totalLength: totalLength
	            });
	          }
	        } catch (err) {// calculate total length error
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          upperWidth = _this$props.upperWidth,
	          lowerWidth = _this$props.lowerWidth,
	          height = _this$props.height,
	          className = _this$props.className;
	      var totalLength = this.state.totalLength;
	      var _this$props2 = this.props,
	          animationEasing = _this$props2.animationEasing,
	          animationDuration = _this$props2.animationDuration,
	          animationBegin = _this$props2.animationBegin,
	          isUpdateAnimationActive = _this$props2.isUpdateAnimationActive;
	
	      if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-trapezoid', className);
	
	      if (!isUpdateAnimationActive) {
	        return _react["default"].createElement("g", null, _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: layerClass,
	          d: getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
	        })));
	      }
	
	      return _react["default"].createElement(_reactSmooth["default"], {
	        canBegin: totalLength > 0,
	        from: {
	          upperWidth: 0,
	          lowerWidth: 0,
	          height: height,
	          x: x,
	          y: y
	        },
	        to: {
	          upperWidth: upperWidth,
	          lowerWidth: lowerWidth,
	          height: height,
	          x: x,
	          y: y
	        },
	        duration: animationDuration,
	        animationEasing: animationEasing,
	        isActive: isUpdateAnimationActive
	      }, function (_ref) {
	        var currUpperWidth = _ref.upperWidth,
	            currLowerWidth = _ref.lowerWidth,
	            currHeight = _ref.height,
	            currX = _ref.x,
	            currY = _ref.y;
	        return _react["default"].createElement(_reactSmooth["default"], {
	          canBegin: totalLength > 0,
	          from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
	          to: "".concat(totalLength, "px 0px"),
	          attributeName: "strokeDasharray",
	          begin: animationBegin,
	          duration: animationDuration,
	          easing: animationEasing
	        }, _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(_this2.props), (0, _ReactUtils.filterEventAttributes)(_this2.props), {
	          className: layerClass,
	          d: getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
	          ref: function ref(node) {
	            _this2.node = node;
	          }
	        })));
	      });
	    }
	  }]);
	
	  return Trapezoid;
	}(_react.PureComponent);
	
	Trapezoid.displayName = 'Trapezoid';
	Trapezoid.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  upperWidth: _propTypes["default"].number,
	  lowerWidth: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  isUpdateAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	});
	Trapezoid.defaultProps = {
	  x: 0,
	  y: 0,
	  upperWidth: 0,
	  lowerWidth: 0,
	  height: 0,
	  isUpdateAnimationActive: false,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	};
	var _default = Trapezoid;
	exports["default"] = _default;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(125));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _AnimateManager = _interopRequireDefault(__webpack_require__(1965));
	
	var _easing = __webpack_require__(903);
	
	var _configUpdate = _interopRequireDefault(__webpack_require__(1966));
	
	var _util = __webpack_require__(395);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var Animate =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Animate, _PureComponent);
	
	  function Animate(props, context) {
	    var _this;
	
	    _classCallCheck(this, Animate);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Animate).call(this, props, context));
	    var _this$props = _this.props,
	        isActive = _this$props.isActive,
	        attributeName = _this$props.attributeName,
	        from = _this$props.from,
	        to = _this$props.to,
	        steps = _this$props.steps,
	        children = _this$props.children;
	    _this.handleStyleChange = _this.handleStyleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.changeStyle = _this.changeStyle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	
	    if (!isActive) {
	      _this.state = {
	        style: {}
	      }; // if children is a function and animation is not active, set style to 'to'
	
	      if (typeof children === 'function') {
	        _this.state = {
	          style: to
	        };
	      }
	
	      return _possibleConstructorReturn(_this);
	    }
	
	    if (steps && steps.length) {
	      _this.state = {
	        style: steps[0].style
	      };
	    } else if (from) {
	      if (typeof children === 'function') {
	        _this.state = {
	          style: from
	        };
	        return _possibleConstructorReturn(_this);
	      }
	
	      _this.state = {
	        style: attributeName ? _defineProperty({}, attributeName, from) : from
	      };
	    } else {
	      _this.state = {
	        style: {}
	      };
	    }
	
	    return _this;
	  }
	
	  _createClass(Animate, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props2 = this.props,
	          isActive = _this$props2.isActive,
	          canBegin = _this$props2.canBegin;
	      this.mounted = true;
	
	      if (!isActive || !canBegin) {
	        return;
	      }
	
	      this.runAnimation(this.props);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props3 = this.props,
	          isActive = _this$props3.isActive,
	          canBegin = _this$props3.canBegin,
	          attributeName = _this$props3.attributeName,
	          shouldReAnimate = _this$props3.shouldReAnimate;
	
	      if (!canBegin) {
	        return;
	      }
	
	      if (!isActive) {
	        // eslint-disable-next-line react/no-did-update-set-state
	        this.setState({
	          style: attributeName ? _defineProperty({}, attributeName, this.props.to) : this.props.to
	        });
	        return;
	      }
	
	      if ((0, _isEqual2.default)(prevProps.to, this.props.to) && prevProps.canBegin && prevProps.isActive) {
	        return;
	      }
	
	      var isTriggered = !prevProps.canBegin || !prevProps.isActive;
	
	      if (this.manager) {
	        this.manager.stop();
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	
	      var from = isTriggered || shouldReAnimate ? this.props.from : prevProps.to; // eslint-disable-next-line react/no-did-update-set-state
	
	      this.setState({
	        style: attributeName ? _defineProperty({}, attributeName, from) : from
	      });
	      this.runAnimation(_objectSpread({}, this.props, {
	        from: from,
	        begin: 0
	      }));
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	
	      if (this.unSubscribe) {
	        this.unSubscribe();
	      }
	
	      if (this.manager) {
	        this.manager.stop();
	        this.manager = null;
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	    }
	  }, {
	    key: "runJSAnimation",
	    value: function runJSAnimation(props) {
	      var _this2 = this;
	
	      var from = props.from,
	          to = props.to,
	          duration = props.duration,
	          easing = props.easing,
	          begin = props.begin,
	          onAnimationEnd = props.onAnimationEnd,
	          onAnimationStart = props.onAnimationStart;
	      var startAnimation = (0, _configUpdate.default)(from, to, (0, _easing.configEasing)(easing), duration, this.changeStyle);
	
	      var finalStartAnimation = function finalStartAnimation() {
	        _this2.stopJSAnimation = startAnimation();
	      };
	
	      this.manager.start([onAnimationStart, begin, finalStartAnimation, duration, onAnimationEnd]);
	    }
	  }, {
	    key: "runStepAnimation",
	    value: function runStepAnimation(props) {
	      var _this3 = this;
	
	      var steps = props.steps,
	          begin = props.begin,
	          onAnimationStart = props.onAnimationStart;
	      var _steps$ = steps[0],
	          initialStyle = _steps$.style,
	          _steps$$duration = _steps$.duration,
	          initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
	
	      var addStyle = function addStyle(sequence, nextItem, index) {
	        if (index === 0) {
	          return sequence;
	        }
	
	        var duration = nextItem.duration,
	            _nextItem$easing = nextItem.easing,
	            easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing,
	            style = nextItem.style,
	            nextProperties = nextItem.properties,
	            onAnimationEnd = nextItem.onAnimationEnd;
	        var preItem = index > 0 ? steps[index - 1] : nextItem;
	        var properties = nextProperties || Object.keys(style);
	
	        if (typeof easing === 'function' || easing === 'spring') {
	          return _toConsumableArray(sequence).concat([_this3.runJSAnimation.bind(_this3, {
	            from: preItem.style,
	            to: style,
	            duration: duration,
	            easing: easing
	          }), duration]);
	        }
	
	        var transition = (0, _util.getTransitionVal)(properties, duration, easing);
	
	        var newStyle = _objectSpread({}, preItem.style, style, {
	          transition: transition
	        });
	
	        return _toConsumableArray(sequence).concat([newStyle, duration, onAnimationEnd]).filter(_util.identity);
	      };
	
	      return this.manager.start([onAnimationStart].concat(_toConsumableArray(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
	    }
	  }, {
	    key: "runAnimation",
	    value: function runAnimation(props) {
	      if (!this.manager) {
	        this.manager = (0, _AnimateManager.default)();
	      }
	
	      var begin = props.begin,
	          duration = props.duration,
	          attributeName = props.attributeName,
	          propsTo = props.to,
	          easing = props.easing,
	          onAnimationStart = props.onAnimationStart,
	          onAnimationEnd = props.onAnimationEnd,
	          steps = props.steps,
	          children = props.children;
	      var manager = this.manager;
	      this.unSubscribe = manager.subscribe(this.handleStyleChange);
	
	      if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
	        this.runJSAnimation(props);
	        return;
	      }
	
	      if (steps.length > 1) {
	        this.runStepAnimation(props);
	        return;
	      }
	
	      var to = attributeName ? _defineProperty({}, attributeName, propsTo) : propsTo;
	      var transition = (0, _util.getTransitionVal)(Object.keys(to), duration, easing);
	      manager.start([onAnimationStart, begin, _objectSpread({}, to, {
	        transition: transition
	      }), duration, onAnimationEnd]);
	    }
	  }, {
	    key: "handleStyleChange",
	    value: function handleStyleChange(style) {
	      this.changeStyle(style);
	    }
	  }, {
	    key: "changeStyle",
	    value: function changeStyle(style) {
	      if (this.mounted) {
	        this.setState({
	          style: style
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          children = _this$props4.children,
	          begin = _this$props4.begin,
	          duration = _this$props4.duration,
	          attributeName = _this$props4.attributeName,
	          easing = _this$props4.easing,
	          isActive = _this$props4.isActive,
	          steps = _this$props4.steps,
	          from = _this$props4.from,
	          to = _this$props4.to,
	          canBegin = _this$props4.canBegin,
	          onAnimationEnd = _this$props4.onAnimationEnd,
	          shouldReAnimate = _this$props4.shouldReAnimate,
	          onAnimationReStart = _this$props4.onAnimationReStart,
	          others = _objectWithoutProperties(_this$props4, ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"]);
	
	      var count = _react.Children.count(children);
	
	      var stateStyle = (0, _util.translateStyle)(this.state.style);
	
	      if (typeof children === 'function') {
	        return children(stateStyle);
	      }
	
	      if (!isActive || count === 0) {
	        return children;
	      }
	
	      var cloneContainer = function cloneContainer(container) {
	        var _container$props = container.props,
	            _container$props$styl = _container$props.style,
	            style = _container$props$styl === void 0 ? {} : _container$props$styl,
	            className = _container$props.className;
	        var res = (0, _react.cloneElement)(container, _objectSpread({}, others, {
	          style: _objectSpread({}, style, stateStyle),
	          className: className
	        }));
	        return res;
	      };
	
	      if (count === 1) {
	        return cloneContainer(_react.Children.only(children));
	      }
	
	      return _react.default.createElement("div", null, _react.Children.map(children, function (child) {
	        return cloneContainer(child);
	      }));
	    }
	  }]);
	
	  return Animate;
	}(_react.PureComponent);
	
	Animate.displayName = 'Animate';
	Animate.propTypes = {
	  from: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
	  to: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
	  attributeName: _propTypes.default.string,
	  // animation duration
	  duration: _propTypes.default.number,
	  begin: _propTypes.default.number,
	  easing: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	  steps: _propTypes.default.arrayOf(_propTypes.default.shape({
	    duration: _propTypes.default.number.isRequired,
	    style: _propTypes.default.object.isRequired,
	    easing: _propTypes.default.oneOfType([_propTypes.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']), _propTypes.default.func]),
	    // transition css properties(dash case), optional
	    properties: _propTypes.default.arrayOf('string'),
	    onAnimationEnd: _propTypes.default.func
	  })),
	  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	  isActive: _propTypes.default.bool,
	  canBegin: _propTypes.default.bool,
	  onAnimationEnd: _propTypes.default.func,
	  // decide if it should reanimate with initial from style when props change
	  shouldReAnimate: _propTypes.default.bool,
	  onAnimationStart: _propTypes.default.func,
	  onAnimationReStart: _propTypes.default.func
	};
	Animate.defaultProps = {
	  begin: 0,
	  duration: 1000,
	  from: '',
	  to: '',
	  attributeName: '',
	  easing: 'ease',
	  isActive: true,
	  canBegin: true,
	  steps: [],
	  onAnimationEnd: function onAnimationEnd() {},
	  onAnimationStart: function onAnimationStart() {}
	};
	var _default = Animate;
	exports.default = _default;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.configEasing = exports.configSpring = exports.configBezier = void 0;
	
	var _util = __webpack_require__(395);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var ACCURACY = 1e-4;
	
	var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
	  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
	};
	
	var multyTime = function multyTime(params, t) {
	  return params.map(function (param, i) {
	    return param * Math.pow(t, i);
	  }).reduce(function (pre, curr) {
	    return pre + curr;
	  });
	};
	
	var cubicBezier = function cubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	    return multyTime(params, t);
	  };
	};
	
	var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	
	    var newParams = _toConsumableArray(params.map(function (param, i) {
	      return param * i;
	    }).slice(1)).concat([0]);
	
	    return multyTime(newParams, t);
	  };
	}; // calculate cubic-bezier using Newton's method
	
	
	var configBezier = function configBezier() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var x1 = args[0],
	      y1 = args[1],
	      x2 = args[2],
	      y2 = args[3];
	
	  if (args.length === 1) {
	    switch (args[0]) {
	      case 'linear':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	        break;
	
	      case 'ease':
	        x1 = 0.25;
	        y1 = 0.1;
	        x2 = 0.25;
	        y2 = 1.0;
	        break;
	
	      case 'ease-in':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	        break;
	
	      case 'ease-out':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	        break;
	
	      case 'ease-in-out':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	        break;
	
	      default:
	        {
	          var easing = args[0].split('(');
	
	          if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
	            var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function (x) {
	              return parseFloat(x);
	            });
	
	            var _easing$1$split$0$spl2 = _slicedToArray(_easing$1$split$0$spl, 4);
	
	            x1 = _easing$1$split$0$spl2[0];
	            y1 = _easing$1$split$0$spl2[1];
	            x2 = _easing$1$split$0$spl2[2];
	            y2 = _easing$1$split$0$spl2[3];
	          } else {
	            (0, _util.warn)(false, '[configBezier]: arguments should be one of ' + 'oneOf \'linear\', \'ease\', \'ease-in\', \'ease-out\', ' + '\'ease-in-out\',\'cubic-bezier(x1,y1,x2,y2)\', instead received %s', args);
	          }
	        }
	    }
	  }
	
	  (0, _util.warn)([x1, x2, y1, y2].every(function (num) {
	    return typeof num === 'number' && num >= 0 && num <= 1;
	  }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
	  var curveX = cubicBezier(x1, x2);
	  var curveY = cubicBezier(y1, y2);
	  var derCurveX = derivativeCubicBezier(x1, x2);
	
	  var rangeValue = function rangeValue(value) {
	    if (value > 1) {
	      return 1;
	    } else if (value < 0) {
	      return 0;
	    }
	
	    return value;
	  };
	
	  var bezier = function bezier(_t) {
	    var t = _t > 1 ? 1 : _t;
	    var x = t;
	
	    for (var i = 0; i < 8; ++i) {
	      var evalT = curveX(x) - t;
	      var derVal = derCurveX(x);
	
	      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
	        return curveY(x);
	      }
	
	      x = rangeValue(x - evalT / derVal);
	    }
	
	    return curveY(x);
	  };
	
	  bezier.isStepper = false;
	  return bezier;
	};
	
	exports.configBezier = configBezier;
	
	var configSpring = function configSpring() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$stiff = config.stiff,
	      stiff = _config$stiff === void 0 ? 100 : _config$stiff,
	      _config$damping = config.damping,
	      damping = _config$damping === void 0 ? 8 : _config$damping,
	      _config$dt = config.dt,
	      dt = _config$dt === void 0 ? 17 : _config$dt;
	
	  var stepper = function stepper(currX, destX, currV) {
	    var FSpring = -(currX - destX) * stiff;
	    var FDamping = currV * damping;
	    var newV = currV + (FSpring - FDamping) * dt / 1000;
	    var newX = currV * dt / 1000 + currX;
	
	    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
	      return [destX, 0];
	    }
	
	    return [newX, newV];
	  };
	
	  stepper.isStepper = true;
	  stepper.dt = dt;
	  return stepper;
	};
	
	exports.configSpring = configSpring;
	
	var configEasing = function configEasing() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var easing = args[0];
	
	  if (typeof easing === 'string') {
	    switch (easing) {
	      case 'ease':
	      case 'ease-in-out':
	      case 'ease-out':
	      case 'ease-in':
	      case 'linear':
	        return configBezier(easing);
	
	      case 'spring':
	        return configSpring();
	
	      default:
	        if (easing.split('(')[0] === 'cubic-bezier') {
	          return configBezier(easing);
	        }
	
	        (0, _util.warn)(false, '[configEasing]: first argument should be one of \'ease\', \'ease-in\', ' + '\'ease-out\', \'ease-in-out\',\'cubic-bezier(x1,y1,x2,y2)\', \'linear\' and \'spring\', instead  received %s', args);
	    }
	  }
	
	  if (typeof easing === 'function') {
	    return easing;
	  }
	
	  (0, _util.warn)(false, '[configEasing]: first argument type should be function or ' + 'string, instead received %s', args);
	  return null;
	};
	
	exports.configEasing = configEasing;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _reactLifecyclesCompat = __webpack_require__(851);
	
	var _PropTypes = __webpack_require__(907);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(851);
	
	var _ChildMapping = __webpack_require__(1970);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: {
	        isMounting: !this.appeared
	      }
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	
	    return _react.default.createElement(Component, props, children);
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes.default.object.isRequired
	};
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(1968));
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(1969));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(905));
	
	var _Transition = _interopRequireDefault(__webpack_require__(904));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition.default,
	  TransitionGroup: _TransitionGroup.default,
	  ReplaceTransition: _ReplaceTransition.default,
	  CSSTransition: _CSSTransition.default
	};

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ }),
/* 908 */
/***/ (function(module, exports) {

	"use strict";
	exports.empty = {
	    closed: true,
	    next: function (value) { },
	    error: function (err) { throw err; },
	    complete: function () { }
	};
	//# sourceMappingURL=Observer.js.map

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(219);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var OuterSubscriber = (function (_super) {
	    __extends(OuterSubscriber, _super);
	    function OuterSubscriber() {
	        _super.apply(this, arguments);
	    }
	    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.destination.next(innerValue);
	    };
	    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
	        this.destination.error(error);
	    };
	    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.destination.complete();
	    };
	    return OuterSubscriber;
	}(Subscriber_1.Subscriber));
	exports.OuterSubscriber = OuterSubscriber;
	//# sourceMappingURL=OuterSubscriber.js.map

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(94);
	var debounceTime_1 = __webpack_require__(1990);
	Observable_1.Observable.prototype.debounceTime = debounceTime_1.debounceTime;
	//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(94);
	var switchMap_1 = __webpack_require__(1994);
	Observable_1.Observable.prototype.switchMap = switchMap_1.switchMap;
	//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var root_1 = __webpack_require__(192);
	var Observable_1 = __webpack_require__(94);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var PromiseObservable = (function (_super) {
	    __extends(PromiseObservable, _super);
	    function PromiseObservable(promise, scheduler) {
	        _super.call(this);
	        this.promise = promise;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Converts a Promise to an Observable.
	     *
	     * <span class="informal">Returns an Observable that just emits the Promise's
	     * resolved value, then completes.</span>
	     *
	     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
	     * Observable. If the Promise resolves with a value, the output Observable
	     * emits that resolved value as a `next`, and then completes. If the Promise
	     * is rejected, then the output Observable emits the corresponding Error.
	     *
	     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
	     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     * @see {@link bindCallback}
	     * @see {@link from}
	     *
	     * @param {PromiseLike<T>} promise The promise to be converted.
	     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
	     * the delivery of the resolved value (or the rejection).
	     * @return {Observable<T>} An Observable which wraps the Promise.
	     * @static true
	     * @name fromPromise
	     * @owner Observable
	     */
	    PromiseObservable.create = function (promise, scheduler) {
	        return new PromiseObservable(promise, scheduler);
	    };
	    /** @deprecated internal use only */ PromiseObservable.prototype._subscribe = function (subscriber) {
	        var _this = this;
	        var promise = this.promise;
	        var scheduler = this.scheduler;
	        if (scheduler == null) {
	            if (this._isScalar) {
	                if (!subscriber.closed) {
	                    subscriber.next(this.value);
	                    subscriber.complete();
	                }
	            }
	            else {
	                promise.then(function (value) {
	                    _this.value = value;
	                    _this._isScalar = true;
	                    if (!subscriber.closed) {
	                        subscriber.next(value);
	                        subscriber.complete();
	                    }
	                }, function (err) {
	                    if (!subscriber.closed) {
	                        subscriber.error(err);
	                    }
	                })
	                    .then(null, function (err) {
	                    // escape the promise trap, throw unhandled errors
	                    root_1.root.setTimeout(function () { throw err; });
	                });
	            }
	        }
	        else {
	            if (this._isScalar) {
	                if (!subscriber.closed) {
	                    return scheduler.schedule(dispatchNext, 0, { value: this.value, subscriber: subscriber });
	                }
	            }
	            else {
	                promise.then(function (value) {
	                    _this.value = value;
	                    _this._isScalar = true;
	                    if (!subscriber.closed) {
	                        subscriber.add(scheduler.schedule(dispatchNext, 0, { value: value, subscriber: subscriber }));
	                    }
	                }, function (err) {
	                    if (!subscriber.closed) {
	                        subscriber.add(scheduler.schedule(dispatchError, 0, { err: err, subscriber: subscriber }));
	                    }
	                })
	                    .then(null, function (err) {
	                    // escape the promise trap, throw unhandled errors
	                    root_1.root.setTimeout(function () { throw err; });
	                });
	            }
	        }
	    };
	    return PromiseObservable;
	}(Observable_1.Observable));
	exports.PromiseObservable = PromiseObservable;
	function dispatchNext(arg) {
	    var value = arg.value, subscriber = arg.subscriber;
	    if (!subscriber.closed) {
	        subscriber.next(value);
	        subscriber.complete();
	    }
	}
	function dispatchError(arg) {
	    var err = arg.err, subscriber = arg.subscriber;
	    if (!subscriber.closed) {
	        subscriber.error(err);
	    }
	}
	//# sourceMappingURL=PromiseObservable.js.map

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var subscribeToResult_1 = __webpack_require__(920);
	var OuterSubscriber_1 = __webpack_require__(909);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link mergeAll}.</span>
	 *
	 * <img src="./img/mergeMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an Observable, and then merging those resulting Observables and
	 * emitting the results of this merger.
	 *
	 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
	 * var letters = Rx.Observable.of('a', 'b', 'c');
	 * var result = letters.mergeMap(x =>
	 *   Rx.Observable.interval(1000).map(i => x+i)
	 * );
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // a0
	 * // b0
	 * // c0
	 * // a1
	 * // b1
	 * // c1
	 * // continues to list a,b,c with respective ascending integers
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaustMap}
	 * @see {@link merge}
	 * @see {@link mergeAll}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and merging the results of the Observables obtained
	 * from this transformation.
	 * @method mergeMap
	 * @owner Observable
	 */
	function mergeMap(project, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return function mergeMapOperatorFunction(source) {
	        if (typeof resultSelector === 'number') {
	            concurrent = resultSelector;
	            resultSelector = null;
	        }
	        return source.lift(new MergeMapOperator(project, resultSelector, concurrent));
	    };
	}
	exports.mergeMap = mergeMap;
	var MergeMapOperator = (function () {
	    function MergeMapOperator(project, resultSelector, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	    }
	    MergeMapOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
	    };
	    return MergeMapOperator;
	}());
	exports.MergeMapOperator = MergeMapOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MergeMapSubscriber = (function (_super) {
	    __extends(MergeMapSubscriber, _super);
	    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        _super.call(this, destination);
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	        this.hasCompleted = false;
	        this.buffer = [];
	        this.active = 0;
	        this.index = 0;
	    }
	    MergeMapSubscriber.prototype._next = function (value) {
	        if (this.active < this.concurrent) {
	            this._tryNext(value);
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    MergeMapSubscriber.prototype._tryNext = function (value) {
	        var result;
	        var index = this.index++;
	        try {
	            result = this.project(value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.active++;
	        this._innerSub(result, value, index);
	    };
	    MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
	        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
	    };
	    MergeMapSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0 && this.buffer.length === 0) {
	            this.destination.complete();
	        }
	    };
	    MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (this.resultSelector) {
	            this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            this.destination.next(innerValue);
	        }
	    };
	    MergeMapSubscriber.prototype._notifyResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var result;
	        try {
	            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
	        var buffer = this.buffer;
	        this.remove(innerSub);
	        this.active--;
	        if (buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        else if (this.active === 0 && this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return MergeMapSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.MergeMapSubscriber = MergeMapSubscriber;
	//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var AsyncAction_1 = __webpack_require__(2003);
	var AsyncScheduler_1 = __webpack_require__(2004);
	/**
	 *
	 * Async Scheduler
	 *
	 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
	 *
	 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
	 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
	 * in intervals.
	 *
	 * If you just want to "defer" task, that is to perform it right after currently
	 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
	 * better choice will be the {@link asap} scheduler.
	 *
	 * @example <caption>Use async scheduler to delay task</caption>
	 * const task = () => console.log('it works!');
	 *
	 * Rx.Scheduler.async.schedule(task, 2000);
	 *
	 * // After 2 seconds logs:
	 * // "it works!"
	 *
	 *
	 * @example <caption>Use async scheduler to repeat task in intervals</caption>
	 * function task(state) {
	 *   console.log(state);
	 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
	 *                                   // which we reschedule with new state and delay
	 * }
	 *
	 * Rx.Scheduler.async.schedule(task, 3000, 0);
	 *
	 * // Logs:
	 * // 0 after 3s
	 * // 1 after 4s
	 * // 2 after 5s
	 * // 3 after 6s
	 *
	 * @static true
	 * @name async
	 * @owner Scheduler
	 */
	exports.async = new AsyncScheduler_1.AsyncScheduler(AsyncAction_1.AsyncAction);
	//# sourceMappingURL=async.js.map

/***/ }),
/* 915 */
/***/ (function(module, exports) {

	"use strict";
	// typeof any so that it we don't have to cast when comparing a result to the error object
	exports.errorObject = { e: {} };
	//# sourceMappingURL=errorObject.js.map

/***/ }),
/* 916 */
/***/ (function(module, exports) {

	"use strict";
	exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
	//# sourceMappingURL=isArray.js.map

/***/ }),
/* 917 */
/***/ (function(module, exports) {

	"use strict";
	exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
	//# sourceMappingURL=isArrayLike.js.map

/***/ }),
/* 918 */
/***/ (function(module, exports) {

	"use strict";
	function isFunction(x) {
	    return typeof x === 'function';
	}
	exports.isFunction = isFunction;
	//# sourceMappingURL=isFunction.js.map

/***/ }),
/* 919 */
/***/ (function(module, exports) {

	"use strict";
	function isObject(x) {
	    return x != null && typeof x === 'object';
	}
	exports.isObject = isObject;
	//# sourceMappingURL=isObject.js.map

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(192);
	var isArrayLike_1 = __webpack_require__(917);
	var isPromise_1 = __webpack_require__(556);
	var isObject_1 = __webpack_require__(919);
	var Observable_1 = __webpack_require__(94);
	var iterator_1 = __webpack_require__(553);
	var InnerSubscriber_1 = __webpack_require__(1976);
	var observable_1 = __webpack_require__(554);
	function subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
	    var destination = new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
	    if (destination.closed) {
	        return null;
	    }
	    if (result instanceof Observable_1.Observable) {
	        if (result._isScalar) {
	            destination.next(result.value);
	            destination.complete();
	            return null;
	        }
	        else {
	            destination.syncErrorThrowable = true;
	            return result.subscribe(destination);
	        }
	    }
	    else if (isArrayLike_1.isArrayLike(result)) {
	        for (var i = 0, len = result.length; i < len && !destination.closed; i++) {
	            destination.next(result[i]);
	        }
	        if (!destination.closed) {
	            destination.complete();
	        }
	    }
	    else if (isPromise_1.isPromise(result)) {
	        result.then(function (value) {
	            if (!destination.closed) {
	                destination.next(value);
	                destination.complete();
	            }
	        }, function (err) { return destination.error(err); })
	            .then(null, function (err) {
	            // Escaping the Promise trap: globally throw unhandled errors
	            root_1.root.setTimeout(function () { throw err; });
	        });
	        return destination;
	    }
	    else if (result && typeof result[iterator_1.iterator] === 'function') {
	        var iterator = result[iterator_1.iterator]();
	        do {
	            var item = iterator.next();
	            if (item.done) {
	                destination.complete();
	                break;
	            }
	            destination.next(item.value);
	            if (destination.closed) {
	                break;
	            }
	        } while (true);
	    }
	    else if (result && typeof result[observable_1.observable] === 'function') {
	        var obs = result[observable_1.observable]();
	        if (typeof obs.subscribe !== 'function') {
	            destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
	        }
	        else {
	            return obs.subscribe(new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
	        }
	    }
	    else {
	        var value = isObject_1.isObject(result) ? 'an invalid object' : "'" + result + "'";
	        var msg = ("You provided " + value + " where a stream was expected.")
	            + ' You can provide an Observable, Promise, Array, or Iterable.';
	        destination.error(new TypeError(msg));
	    }
	    return null;
	}
	exports.subscribeToResult = subscribeToResult;
	//# sourceMappingURL=subscribeToResult.js.map

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(140)))

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StyleSheetManager$ch;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleSheet = __webpack_require__(172);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _ServerStyleSheet = __webpack_require__(397);
	
	var _ServerStyleSheet2 = _interopRequireDefault(_ServerStyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StyleSheetManager = function (_Component) {
	  _inherits(StyleSheetManager, _Component);
	
	  function StyleSheetManager() {
	    _classCallCheck(this, StyleSheetManager);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  StyleSheetManager.prototype.getChildContext = function getChildContext() {
	    var _ref;
	
	    return _ref = {}, _ref[_StyleSheet.CONTEXT_KEY] = this.props.sheet, _ref;
	  };
	
	  StyleSheetManager.prototype.render = function render() {
	    /* eslint-disable react/prop-types */
	    // Flow v0.43.1 will report an error accessing the `children` property,
	    // but v0.47.0 will not. It is necessary to use a type cast instead of
	    // a "fixme" comment to satisfy both Flow versions.
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return StyleSheetManager;
	}(_react.Component);
	
	StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[_StyleSheet.CONTEXT_KEY] = _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_StyleSheet2.default), _propTypes2.default.instanceOf(_ServerStyleSheet2.default)]).isRequired, _StyleSheetManager$ch);
	
	StyleSheetManager.propTypes = {
	  sheet: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_StyleSheet2.default), _propTypes2.default.instanceOf(_ServerStyleSheet2.default)]).isRequired
	};
	
	exports.default = StyleSheetManager;
	module.exports = exports['default'];

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	if (true) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_Broadcast", {
	  value: __webpack_require__(2).shape({
	    publish: __webpack_require__(2).func.isRequired,
	    subscribe: __webpack_require__(2).func.isRequired,
	    unsubscribe: __webpack_require__(2).func.isRequired
	  })
	});
	/**
	 * Creates a broadcast that can be listened to, i.e. simple event emitter
	 *
	 * @see https://github.com/ReactTraining/react-broadcast
	 */
	
	var createBroadcast = function createBroadcast(initialState) {
	  var listeners = {};
	  var id = 0;
	  var state = initialState;
	
	  function publish(nextState) {
	    state = nextState;
	
	    // eslint-disable-next-line guard-for-in, no-restricted-syntax
	    for (var key in listeners) {
	      var _listener = listeners[key];
	      if (_listener === undefined) {
	        // eslint-disable-next-line no-continue
	        continue;
	      }
	
	      _listener(state);
	    }
	  }
	
	  function subscribe(listener) {
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    listener(state);
	    return currentId;
	  }
	
	  function unsubscribe(unsubID) {
	    listeners[unsubID] = undefined;
	  }
	
	  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
	};
	
	exports.default = createBroadcast;
	module.exports = exports["default"];

/***/ }),
/* 924 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (props, fallbackTheme, defaultProps) {
	  // Props should take precedence over ThemeProvider, which should take precedence over
	  // defaultProps, but React automatically puts defaultProps on props.
	
	  /* eslint-disable react/prop-types */
	  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
	  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
	  /* eslint-enable */
	
	  return theme;
	};
	
	module.exports = exports["default"];

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.objToCss = undefined;
	
	var _hyphenateStyleName = __webpack_require__(458);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _isPlainObject = __webpack_require__(689);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(2).any;
	
	var objToCss = exports.objToCss = function objToCss(obj, prevKey) {
	  var css = Object.keys(obj).filter(function (key) {
	    var chunk = obj[key];
	    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
	  }).map(function (key) {
	    if ((0, _isPlainObject2.default)(obj[key])) return objToCss(obj[key], key);
	    return (0, _hyphenateStyleName2.default)(key) + ': ' + obj[key] + ';';
	  }).join(' ');
	  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
	};
	
	var flatten = function flatten(chunks, executionContext) {
	  return chunks.reduce(function (ruleSet, chunk) {
	    /* Remove falsey values */
	    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
	      return ruleSet;
	    }
	    /* Flatten ruleSet */
	    if (Array.isArray(chunk)) {
	      return [].concat(ruleSet, flatten(chunk, executionContext));
	    }
	
	    /* Handle other components */
	    if (chunk.hasOwnProperty('styledComponentId')) {
	      // $FlowFixMe not sure how to make this pass
	      return [].concat(ruleSet, ['.' + chunk.styledComponentId]);
	    }
	
	    /* Either execute or defer the function */
	    if (typeof chunk === 'function') {
	      return executionContext ? ruleSet.concat.apply(ruleSet, flatten([chunk(executionContext)], executionContext)) : ruleSet.concat(chunk);
	    }
	
	    /* Handle objects */
	    return ruleSet.concat(
	    // $FlowFixMe have to add %checks somehow to isPlainObject
	    (0, _isPlainObject2.default)(chunk) ? objToCss(chunk) : chunk.toString());
	  }, []);
	};
	
	exports.default = flatten;

/***/ }),
/* 926 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
	};
	/* eslint-disable camelcase, no-undef */
	
	module.exports = exports['default'];

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var mobx_1 = __webpack_require__(5);
	var certificateDomain_1 = __webpack_require__(561);
	var domUtils_1 = __webpack_require__(91);
	var CertificateService = /** @class */ (function () {
	    function CertificateService() {
	    }
	    // ////////// Certificate ////////////////////////////////////////////////////////////////////////////////
	    CertificateService.prototype.deleteCertificate = function (certificateId) {
	        return axios_config_1.default.delete('/core/security/certificate/' + certificateId);
	    };
	    CertificateService.prototype.readCertificate = function (id) {
	        return axios_config_1.default.get('/core/security/certificate/' + id)
	            .then(function (response) { return new certificateDomain_1.MdCertificate(response.data); });
	    };
	    CertificateService.prototype.exportCertificateUrl = function (certFormat, certificateId, password) {
	        return (0, domUtils_1.buildURL)('/api/core/security/certificate/export/' + certFormat + '/' + certificateId, { password: password });
	    };
	    CertificateService.prototype.readCertificateBeanConfigs = function () {
	        return axios_config_1.default.get('/core/security/certificate-config')
	            .then(function (response) { return response.data.map(function (json) { return new certificateDomain_1.MdCertificateBeanConfig(json); }); });
	    };
	    CertificateService.prototype.saveCertificateBeanConfigs = function (configs) {
	        return axios_config_1.default.post('/core/security/certificate-config', configs);
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], CertificateService.prototype, "certificateListsMV", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], CertificateService.prototype, "certificateObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], CertificateService.prototype, "certificateConfigs", void 0);
	    return CertificateService;
	}());
	var certificateService = new CertificateService();
	exports.default = certificateService;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ChartType = exports.COLORS = void 0;
	exports.seriesTypeToLovItem = seriesTypeToLovItem;
	var colors_1 = __webpack_require__(29);
	exports.COLORS = [
	    colors_1.orange400,
	    colors_1.deepOrange500,
	    colors_1.yellow500,
	    colors_1.lightBlue400,
	    colors_1.orange200,
	    colors_1.deepOrange300,
	    colors_1.blueGrey200,
	    colors_1.blueGrey400,
	    colors_1.cyan400,
	    colors_1.cyan200,
	    colors_1.lightBlue200,
	    colors_1.yellow400,
	    colors_1.orange500,
	    colors_1.cyan100,
	    colors_1.lightBlue100,
	    colors_1.blueGrey100
	];
	var ChartType;
	(function (ChartType) {
	    ChartType["BAR"] = "bar";
	    ChartType["LINE"] = "line";
	    ChartType["AREA"] = "area";
	})(ChartType || (exports.ChartType = ChartType = {}));
	function seriesTypeToLovItem(st) {
	    return { value: st, label: st };
	}


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Watermark = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var colors_1 = __webpack_require__(29);
	var DivBck = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    position:absolute;\n    z-index:1;\n    display:block;\n    min-height:50%;\n    min-width:50%;\n    top: 20%;\n    right: 25%;\n"], ["\n    position:absolute;\n    z-index:1;\n    display:block;\n    min-height:50%;\n    min-width:50%;\n    top: 20%;\n    right: 25%;\n"])));
	var PText = styled_components_1.default.p(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n    color: ", ";\n    opacity: 0.4;\n    font-size: ", "px;    \n    transform:rotate(330deg);\n"], ["\n    color: ", ";\n    opacity: 0.4;\n    font-size: ", "px;    \n    transform:rotate(330deg);\n"])), colors_1.grey500, function (props) { return props.fontSize ? props.fontSize : 120; });
	var Watermark = function (_a) {
	    var text = _a.text, fontSize = _a.fontSize;
	    return (react_1.default.createElement(DivBck, null,
	        react_1.default.createElement(PText, { fontSize: fontSize }, text)));
	};
	exports.Watermark = Watermark;
	var templateObject_1, templateObject_2;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var blockComp_1 = __webpack_require__(30);
	var locales_1 = __webpack_require__(15);
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var LocalizeFields = /** @class */ (function (_super) {
	    tslib_1.__extends(LocalizeFields, _super);
	    function LocalizeFields() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleLabelChange = function (locLabel, event) {
	            locLabel.label = event.target.value;
	        };
	        return _this;
	    }
	    LocalizeFields.prototype.render = function () {
	        var _this = this;
	        return (react_1.default.createElement("div", null, this.props.fields.map(function (_a) {
	            var fieldName = _a.fieldName, locArray = _a.locArray;
	            return (react_1.default.createElement(blockComp_1.BlockComp, { key: fieldName, style: { marginTop: 10 }, header: fieldName },
	                react_1.default.createElement("table", null,
	                    react_1.default.createElement("tbody", null, locArray.sort(function (a, b) { return a.locale.localeCompare(b.locale); }).map(function (locLabel) { return (react_1.default.createElement("tr", { key: locLabel.locale },
	                        react_1.default.createElement("td", { style: { padding: "0 10px" } }, locales_1.loc.get(locLabel.locale)),
	                        react_1.default.createElement("td", null,
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, createForm_1.fieldStyles.small.textField, { style: { height: 40 }, inputStyle: { marginTop: 0 }, name: fieldName, value: locLabel.label, disabled: locLabel.locale === locales_1.loc.defaultLang, onChange: _this.handleLabelChange.bind(_this, locLabel) }))))); })))));
	        })));
	    };
	    LocalizeFields = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], LocalizeFields);
	    return LocalizeFields;
	}(react_1.default.Component));
	exports.default = LocalizeFields;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var mobx_1 = __webpack_require__(5);
	var dataImportDomain_1 = __webpack_require__(2063);
	var DataImportService = /** @class */ (function () {
	    function DataImportService() {
	    }
	    // ////////// DataImport - BrimMessage  ////////////////////////////////////////////////////////////////////////////////
	    DataImportService.prototype.validateBrimMessage = function (gridParams) {
	        return axios_config_1.default.post('/brim-message/validate', gridParams)
	            .then(function (response) { return response.data; });
	    };
	    DataImportService.prototype.acceptBrimMessage = function (gridParams) {
	        return axios_config_1.default.post('/brim-message/accept', gridParams)
	            .then(function (response) { return response.data; });
	    };
	    DataImportService.prototype.rejectBrimMessgage = function (gridParams) {
	        return axios_config_1.default.post('/brim-message/reject', gridParams)
	            .then(function (response) { return response.data; });
	    };
	    DataImportService.prototype.getBrimMessageDetail = function (brimMessageId, initPrices) {
	        return axios_config_1.default.get('/brim-message/' + brimMessageId, { params: { initPrices: initPrices } })
	            .then(function (response) {
	            console.log(response.data);
	            return new dataImportDomain_1.ImportEntryBrimMessage(response.data);
	        });
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], DataImportService.prototype, "brimMessageObject", void 0);
	    return DataImportService;
	}());
	var dataImportService = new DataImportService();
	exports.default = dataImportService;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EmailAddressesEditorDialog = exports.EmailAddressesEditor = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var mobx_react_1 = __webpack_require__(4);
	var fields_1 = __webpack_require__(20);
	var dialogAncestor_1 = __webpack_require__(87);
	var mobx_1 = __webpack_require__(5);
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var formUtils_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(37);
	var react_router_1 = __webpack_require__(65);
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var validator_1 = tslib_1.__importDefault(__webpack_require__(576));
	var partyService_1 = tslib_1.__importDefault(__webpack_require__(175));
	var _label_style = { fontSize: 13 };
	var FlexRowDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: start;\n  gap: 10px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: start;\n  gap: 10px;\n"])));
	var EmailAddressesEditor = /** @class */ (function (_super) {
	    tslib_1.__extends(EmailAddressesEditor, _super);
	    function EmailAddressesEditor() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        // @action onDismiss = () => {
	        //   const objekt = this.props.objekt;
	        //   if (objekt.tupleMap) {
	        //     objekt.tupleMap.emailedPersons = undefined;
	        //     objekt.tupleMap.excludedPersons = undefined;
	        //   }
	        // };
	        _this.onCheckSelected = function (index, evt, checked) {
	            var emails = _this.props.emails;
	            var holder = emails[index];
	            console.log('onCheckSelected', holder, evt, checked);
	            holder.selected = checked;
	        };
	        _this.onChangeAddEmail = function (evt) {
	            _this.setState({ addEmailText: evt.target.value });
	        };
	        _this.addEmail = function (evt) {
	            if (validator_1.default.isEmail(_this.state.addEmailText)) {
	                partyService_1.default.searchParty(_this.state.addEmailText)
	                    .then(function (parties) {
	                    var party = parties.pop();
	                    _this.props.emails.push({
	                        value: _this.state.addEmailText,
	                        selected: true,
	                        partyLov: (party) ? party.partyLov() : undefined
	                    });
	                    _this.setState({
	                        addEmailText: '',
	                        addEmailError: ''
	                    });
	                });
	            }
	            else {
	                _this.setState({
	                    addEmailText: _this.state.addEmailText,
	                    addEmailError: "Email is not valid"
	                });
	            }
	        };
	        return _this;
	    }
	    EmailAddressesEditor.prototype.componentWillMount = function () {
	        this.setState({
	            addEmailText: '',
	            addEmailError: ''
	        });
	    };
	    EmailAddressesEditor.prototype.render = function () {
	        var _this = this;
	        var emails = this.props.emails;
	        return (react_1.default.createElement("div", null,
	            emails.map(function (holder, index) { return (react_1.default.createElement(FlexRowDiv, { key: index },
	                react_1.default.createElement("div", null,
	                    react_1.default.createElement(fields_1.MdCheckbox, { name: holder.value, checked: holder.selected, labelStyle: _label_style, label: holder.value, onCheck: _this.onCheckSelected.bind(_this, index) })),
	                holder.partyLov &&
	                    react_1.default.createElement(react_router_1.Link, { to: "partyDetail", style: { fontSize: 13 }, params: { id: (0, formUtils_1.lovValue)(holder.partyLov) }, query: (0, utils_1.addTenantToQuery)() }, " (" + (0, formUtils_1.lovLabel)(holder.partyLov) + ")"))); }),
	            react_1.default.createElement(FlexRowDiv, null,
	                react_1.default.createElement(fields_1.MdTextField, { value: this.state.addEmailText, name: "addEmailTextField", errorText: this.state.addEmailError, onChange: this.onChangeAddEmail, hintText: "Add another email" }),
	                react_1.default.createElement(FlatButton_1.default, { label: "Add Email", secondary: true, onClick: this.addEmail }))));
	    };
	    ;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EmailAddressesEditor.prototype, "onCheckSelected", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EmailAddressesEditor.prototype, "onChangeAddEmail", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EmailAddressesEditor.prototype, "addEmail", void 0);
	    EmailAddressesEditor = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EmailAddressesEditor);
	    return EmailAddressesEditor;
	}(react_1.default.Component));
	exports.EmailAddressesEditor = EmailAddressesEditor;
	var EmailAddressesEditorDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(EmailAddressesEditorDialog, _super);
	    function EmailAddressesEditorDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.sendHandler = function (evt) {
	            console.log('EmailAddressesEditorDialog#ok evt = %O', evt);
	            _this.dialogOpen = false;
	            _this.$errors = [];
	            _this.resolve({ emails: _this.dto.emails, insertSeparateDocsIntoMain: _this.insertSeparateDocsIntoMain });
	        };
	        _this.cancelHandler = function (evt) {
	            console.log('EmailAddressesEditorDialog#cancel evt = %O', evt);
	            _this.dialogOpen = false;
	            _this.$errors = [];
	            _this.reject("cancel");
	        };
	        return _this;
	    }
	    EmailAddressesEditorDialog.prototype.open = function (resolve, reject, dto, showIncludeSeparate, title) {
	        this.resolve = resolve;
	        this.reject = reject;
	        this.dialogOpen = true;
	        this.dto = dto;
	        this.insertSeparateDocsIntoMain = false;
	        this.showIncludeSeparate = showIncludeSeparate;
	        this.setState({
	            title: title
	        });
	    };
	    // @action onChangeCertFormat = (lovItem) => {
	    //   console.log('onChangeCertFormat lovItem = %O', lovItem);
	    //   this.dto.certFormat = lovItem;
	    //   this.dto.password = "";
	    // };
	    // @action onChangePassword = (evt) => {
	    //   this.dto.password = evt.target.value;
	    // };
	    //
	    EmailAddressesEditorDialog.prototype.render = function () {
	        var _this = this;
	        if (!(this.dialogOpen))
	            return null;
	        return (react_1.default.createElement(Dialog_1.default, { title: this.state.title, actions: [react_1.default.createElement(FlatButton_1.default, { key: "1", label: "Send !", secondary: true, onClick: this.sendHandler, disabled: this.dto.emails.filter(function (e) { return e.selected; }).length == 0 }), react_1.default.createElement(FlatButton_1.default, { key: "2", label: "Cancel", primary: true, onClick: this.cancelHandler })], modal: true, open: this.dialogOpen, bodyStyle: { minHeight: 180 }, contentStyle: {
	                position: 'absolute',
	                left: '50%',
	                top: '50%',
	                transform: 'translate(-50%, -50%)',
	                filter: 'blur(0)'
	            } },
	            react_1.default.createElement(EmailAddressesEditor, { emails: this.dto.emails }),
	            this.showIncludeSeparate && (react_1.default.createElement("div", { style: { marginTop: 20 } },
	                react_1.default.createElement(fields_1.MdCheckbox, { name: "insertSeparateDocsIntoMain", checked: this.insertSeparateDocsIntoMain, labelStyle: _label_style, label: "Insert separate docs into main document", onCheck: function (e) { return _this.insertSeparateDocsIntoMain = e.target.checked; } })))));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EmailAddressesEditorDialog.prototype, "insertSeparateDocsIntoMain", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EmailAddressesEditorDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EmailAddressesEditorDialog.prototype, "sendHandler", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EmailAddressesEditorDialog.prototype, "cancelHandler", void 0);
	    EmailAddressesEditorDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EmailAddressesEditorDialog);
	    return EmailAddressesEditorDialog;
	}(dialogAncestor_1.DialogAncestor));
	exports.EmailAddressesEditorDialog = EmailAddressesEditorDialog;
	var templateObject_1;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ActivityBlock = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var historyBlocks_1 = __webpack_require__(263);
	var eventDomain_1 = __webpack_require__(74);
	var icons = tslib_1.__importStar(__webpack_require__(563));
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var colors_1 = __webpack_require__(29);
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var watermark_1 = __webpack_require__(929);
	var MDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    margin-left: 20px;\n    display: flex;\n    align-items: center;\n"], ["\n    margin-left: 20px;\n    display: flex;\n    align-items: center;\n"])));
	var DateSpan = styled_components_1.default.span(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n    margin-left: 6px;\n    font-size: 18px;\n    color: ", ";\n"], ["\n    margin-left: 6px;\n    font-size: 18px;\n    color: ", ";\n"])), colors_1.grey400);
	var MainDiv = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
	var ActivityBlock = function (_a) {
	    var activity = _a.activity;
	    var Icon = icons[eventDomain_1.ACTIVITYTYPE_MAP[activity.activityType.value].icon];
	    if (activity) {
	        switch (activity.activityType.value) {
	            case eventDomain_1.ACTIVITYTYPE.EMAIL:
	                return (react_1.default.createElement(MainDiv, null,
	                    (!activity.activitySent) ? react_1.default.createElement(watermark_1.Watermark, { text: "Not sent yet", fontSize: 70 }) : null,
	                    react_1.default.createElement(MDiv, null,
	                        react_1.default.createElement(Icon, null),
	                        " ",
	                        (activity.activitySent) ? react_1.default.createElement(DateSpan, null, (0, moment_1.default)(activity.activitySent).fromNow()) : null,
	                        " "),
	                    react_1.default.createElement(historyBlocks_1.EmailEventHistory, { eventHistory: activity })));
	        }
	    }
	    return null;
	};
	exports.ActivityBlock = ActivityBlock;
	var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var RaisedButton_1 = tslib_1.__importDefault(__webpack_require__(152));
	var fields_1 = __webpack_require__(20);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var grid_1 = __webpack_require__(50);
	var gridConfig_1 = tslib_1.__importDefault(__webpack_require__(264));
	var gridConfigCondition_1 = tslib_1.__importDefault(__webpack_require__(194));
	var gridConfigSort_1 = tslib_1.__importDefault(__webpack_require__(936));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var conditionValueForm_1 = tslib_1.__importStar(__webpack_require__(401));
	var errorComp_1 = __webpack_require__(34);
	var blockComp_1 = __webpack_require__(30);
	var localizeField_1 = tslib_1.__importDefault(__webpack_require__(2057));
	var columnSelector_1 = tslib_1.__importDefault(__webpack_require__(2093));
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var createForm_1 = __webpack_require__(18);
	var formUtils_1 = __webpack_require__(14);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var storage_1 = __webpack_require__(173);
	var radioButtonField_1 = tslib_1.__importDefault(__webpack_require__(144));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var metaConstant_1 = __webpack_require__(13);
	var locales_1 = __webpack_require__(15);
	var sqlSelectDialog_1 = tslib_1.__importDefault(__webpack_require__(2053));
	var isEmpty = __webpack_require__(284);
	var remove = __webpack_require__(485);
	var isEqual = __webpack_require__(125);
	var GridAdminComp = /** @class */ (function (_super) {
	    tslib_1.__extends(GridAdminComp, _super);
	    function GridAdminComp() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.validateGridConfigName = function () { return _this.validateTextField('gridName', locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Name of grid is required."], ["Name of grid is required."])))); };
	        _this.onBlurGridConfigName = function () {
	            _this.validateGridConfigName();
	        };
	        _this.validateGridScrollSize = function () { return _this.validateTextField('gridScrollSize', locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Grid scroll size is required positive number."], ["Grid scroll size is required positive number."]))), true); };
	        _this.onBlurGridScrollSize = function () {
	            _this.validateGridScrollSize();
	        };
	        _this.validateGridPageSize = function () { return _this.validateTextField('gridPageSize', locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Grid page size is required positive number."], ["Grid page size is required positive number."]))), true); };
	        _this.onBlurGridPageSize = function () {
	            _this.validateGridPageSize();
	        };
	        _this.validateMaxColumnWidth = function () { return _this.validateTextField('maxColumnWidth', locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["Max column widh is required positive number."], ["Max column widh is required positive number."]))), true); };
	        _this.onBlurMaxColumnWidth = function () {
	            _this.validateMaxColumnWidth();
	        };
	        _this.validateHardRowLimit = function () { return _this.validateTextField('hardRowLimit', locales_1.loc.i18n(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["Hard row limit is required positive number."], ["Hard row limit is required positive number."]))), true, false); };
	        _this.onBlurHardRowLimit = function () {
	            _this.validateHardRowLimit();
	        };
	        _this.onClickAddFilter = function (evt) {
	            console.log('onClickAddFilter');
	            var gridConfig = _this.props.gridConfig;
	            var condition = new gridConfigCondition_1.default(gridConfig, null);
	            gridConfig.conditions.push(condition);
	        };
	        _this.setupConditionField = function (condition, setValues) {
	            var form = condition.getForm("ConditionValueForm");
	            console.log('setupConditionField field0.props.value = %O, options = %O', form.fields["field0"].props.value, form.fields["field0"].props.options);
	            form.fields = form.setupFields(condition, gridService_1.default.gridConfig, condition.getEntityRef(), _this.props.entities, _this.extractFieldFn);
	            if (setValues) {
	                form.updateAllFieldsPropValue(condition);
	            }
	            console.log('setupConditionField field0.props.value = %O, options = %O', form.fields["field0"].props.value, form.fields["field0"].props.options);
	        };
	        _this.onClickAddSort = function (evt) {
	            console.log('onClickAddSort');
	            var gridConfig = _this.props.gridConfig;
	            var sort = new gridConfigSort_1.default(gridConfig, null);
	            gridConfig.sortColumns.push(sort);
	        };
	        _this.handleSpecialCondition = function (valueArray) {
	            var gridConfig = _this.props.gridConfig;
	            console.log('handleSpecialCondition %O', valueArray);
	            gridConfig.specialConditions = valueArray;
	            gridConfig.$dirty = true;
	        };
	        _this.onChangeConfigLevel = function (newConfigLevel) {
	            var gridConfig = _this.props.gridConfig;
	            console.log('onChangeConfigLevel ' + newConfigLevel);
	            gridConfig.configLevel = newConfigLevel;
	            switch (newConfigLevel.value) {
	                case metaConstant_1.CONFIGLEVEL.USER:
	                    gridConfig.tenantGroup = null;
	                    gridConfig.tenant = null;
	                    break;
	                case metaConstant_1.CONFIGLEVEL.TENANT:
	                    gridConfig.user = null;
	                    gridConfig.tenantGroup = null;
	                    if (securityService_1.default.availableTenants.length === 1)
	                        gridConfig.tenant = securityService_1.default.availableTenants[0];
	                    break;
	                case metaConstant_1.CONFIGLEVEL.TENANTGROUP:
	                    gridConfig.tenant = null;
	                    gridConfig.user = null;
	                    var tenantGroupLovs = _this.tenantGroupLovs();
	                    if (tenantGroupLovs.length === 1)
	                        gridConfig.tenantGroup = tenantGroupLovs[0];
	                    break;
	                case metaConstant_1.CONFIGLEVEL.GLOBAL:
	                    gridConfig.tenantGroup = null;
	                    gridConfig.tenant = null;
	                    gridConfig.user = null;
	                    break;
	            }
	        };
	        _this.onChangeTenantGroup = function (tenantGroupLov) {
	            _this.props.gridConfig.tenantGroup = tenantGroupLov;
	        };
	        _this.onChangeTenant = function (tenantLov) {
	            _this.props.gridConfig.tenant = tenantLov;
	        };
	        _this.extractFieldFn = function (dataObject, fieldDef) { return dataObject.field; };
	        _this.onClickDefineSelect = function (evt) {
	            new Promise(function (resolve, reject) {
	                _this.sqlSelectDialogRef.open(resolve, reject, _this.props.gridConfig.sqlCommand, _this.props.gridLocation);
	            }).then(function (gridConfig) {
	                console.log('gridConfig: %O', gridConfig);
	                _this.props.gridConfig.columns = gridConfig.columns;
	                _this.props.gridConfig.sqlCommand = gridConfig.sqlCommand;
	            }).catch(function (e) {
	            });
	        };
	        _this.sqlSelectDialogRefHandler = function (comp) { return _this.sqlSelectDialogRef = comp; };
	        return _this;
	    }
	    GridAdminComp.prototype.componentDidMount = function () {
	        var _this = this;
	        var _a = this.props, gridConfig = _a.gridConfig, gridLocation = _a.gridLocation;
	        if (gridConfig.sortColumns && gridConfig.sortColumns.length && gridLocation.entityName) {
	            return axios_config_1.default.get("/core/meta/entity/" + gridLocation.entityName + "/indexes")
	                .then((0, mobx_1.action)("indexes-read-action", function (response) {
	                _this.indexes = response.data;
	            }));
	        }
	    };
	    GridAdminComp.prototype.save = function () {
	        var _a = this.props, grid = _a.grid, gridLocation = _a.gridLocation, gridConfig = _a.gridConfig;
	        // odstranim prazdne sloupce
	        remove(gridConfig.columns, function (v) { return !v.field; });
	        // predelam na lovValue
	        for (var _i = 0, _b = gridConfig.conditions; _i < _b.length; _i++) {
	            var condition = _b[_i];
	            if ((0, mobx_1.isArrayLike)(condition.values)) {
	                condition.values = condition.values.map(function (v) { return (0, formUtils_1.lovValue)(v); });
	            }
	        }
	        if ((0, formUtils_1.lovValue)(gridConfig.configLevel) === metaConstant_1.CONFIGLEVEL.USER) {
	            gridConfig.user = securityService_1.default.currentUser.createLov();
	        }
	        if (this.validate()) {
	            uiService_1.default.showToolbarActionFlag();
	            return axios_config_1.default.post('/core/grid-config', gridConfig)
	                .then((0, mobx_1.action)("save-callback", function (response) {
	                var newGridConfig = new gridConfig_1.default(gridLocation, response.data);
	                newGridConfig.gridWidths = gridService_1.default.computeGridWidths(null, newGridConfig);
	                gridService_1.default.gridConfig = newGridConfig;
	                if (grid)
	                    grid.replaceGridConfig(newGridConfig);
	                (0, storage_1.removeItemFromLocalStorage)("GridLocation", locales_1.loc.lang, newGridConfig.gridLocation);
	                uiService_1.default.hideToolbarActionFlag();
	                return newGridConfig;
	            }));
	        }
	        else {
	            return Promise.resolve(null);
	        }
	    };
	    ;
	    GridAdminComp.prototype.pushIfTrue = function (array, value) {
	        if (value)
	            array.push({ message: value });
	    };
	    GridAdminComp.prototype.validate = function () {
	        var _a = this.props, gridConfig = _a.gridConfig, entities = _a.entities;
	        gridConfig.$errors = [];
	        this.pushIfTrue(gridConfig.$errors, this.validateGridConfigName());
	        this.pushIfTrue(gridConfig.$errors, this.validateGridScrollSize());
	        this.pushIfTrue(gridConfig.$errors, this.validateGridPageSize());
	        this.pushIfTrue(gridConfig.$errors, this.validateMaxColumnWidth());
	        this.pushIfTrue(gridConfig.$errors, this.validateHardRowLimit());
	        if (isEmpty(gridConfig.columns)) {
	            gridConfig.$errors.push({ message: locales_1.loc.i18n(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["At least one column must be selected."], ["At least one column must be selected."]))) });
	        }
	        var allOperators = entities.get('FILTEROPERATOR').lovItems;
	        gridConfig.conditions.forEach(function (condition, index) {
	            var form = condition.getForm('ConditionValueForm');
	            form.validateForm(condition, gridConfig.$errors);
	            gridService_1.default.validateCondition(condition, gridConfig.$errors, index, allOperators);
	        });
	        gridConfig.sortColumns.forEach(function (sortColumn, index) { return gridService_1.default.validateSortColumn(gridConfig.sortColumns, sortColumn, gridConfig.$errors, index); });
	        switch ((0, formUtils_1.lovValue)(gridConfig.configLevel)) {
	            case metaConstant_1.CONFIGLEVEL.USER:
	                if (!gridConfig.user)
	                    gridConfig.$errors.push({ message: locales_1.loc.i18n(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["For User Grid, user must be selected."], ["For User Grid, user must be selected."]))) });
	                break;
	            case metaConstant_1.CONFIGLEVEL.TENANT:
	                if (!gridConfig.tenant)
	                    gridConfig.$errors.push({ message: locales_1.loc.i18n(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["For Tenant Grid, Tenant must be selected."], ["For Tenant Grid, Tenant must be selected."]))) });
	                break;
	            case metaConstant_1.CONFIGLEVEL.TENANTGROUP:
	                if (!gridConfig.tenantGroup)
	                    gridConfig.$errors.push({ message: locales_1.loc.i18n(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["For Tenant Group Grid, Tenant Group must be selected."], ["For Tenant Group Grid, Tenant Group must be selected."]))) });
	                break;
	        }
	        return isEmpty(gridConfig.$errors);
	    };
	    //  text fields change handlers
	    GridAdminComp.prototype.onChangeTextField = function (fieldName, isNumber, evt) {
	        var gridConfig = this.props.gridConfig;
	        console.debug('onChangeTextField %s, value = %s', fieldName, evt.target.value);
	        gridConfig[fieldName] = evt.target.value;
	    };
	    GridAdminComp.prototype.onChangeCheckbox = function (fieldName, evt, checked) {
	        var gridConfig = this.props.gridConfig;
	        console.debug('onChangeCheckbox %s, evt = %o, checked = %o', fieldName, evt, checked);
	        gridConfig[fieldName] = checked;
	    };
	    GridAdminComp.prototype.onChangeSelect = function (fieldName, value) {
	        var gridConfig = this.props.gridConfig;
	        console.debug('onChangeSelect %s, value = %s', fieldName, value);
	        gridConfig[fieldName] = value;
	    };
	    GridAdminComp.prototype.validateTextField = function (fieldName, message, isPositiveNumber, required) {
	        if (required === void 0) { required = true; }
	        var gridConfig = this.props.gridConfig;
	        var value = gridConfig[fieldName];
	        console.debug('validateTextField %s, value = %s', fieldName, value);
	        if (!value && !required) {
	            return null;
	        }
	        var error;
	        if (isPositiveNumber) {
	            value = parseInt(value);
	            if (!Number.isInteger(value)) {
	                error = message;
	            }
	            else if (value < 0) {
	                error = message;
	            }
	        }
	        else if (!value) {
	            error = message;
	        }
	        gridConfig.$errorMap.set(fieldName, error);
	        return error;
	    };
	    GridAdminComp.prototype.onChangeConditionColumn = function (condition, newColKey) {
	        var _this = this;
	        newColKey = (0, formUtils_1.lovValue)(newColKey);
	        console.log('onChangeConditionColumn: ', newColKey, condition);
	        var gridConfig = this.props.gridConfig;
	        condition.field = gridConfig.getEntityRef().getFieldByKey(newColKey);
	        condition.operator = null;
	        condition.values = [];
	        return gridService_1.default.fetchConditionLovs([condition])
	            .then(function (entityMap) {
	            _this.setupConditionField(condition, false);
	        });
	    };
	    ;
	    GridAdminComp.prototype.onChangeConditionOperator = function (condition, newOperator) {
	        newOperator = (0, formUtils_1.lovValue)(newOperator);
	        console.log('onChangeConditionOperator: ', newOperator, condition);
	        var _a = this.props, gridConfig = _a.gridConfig, entities = _a.entities;
	        condition.operator = newOperator;
	        if (newOperator) {
	            var allOperators = entities.get('FILTEROPERATOR').lovItems;
	            var operatorLov = allOperators.find(function (v) { return v.value === newOperator; });
	            if (operatorLov["inputCount"] === 'N') {
	                condition.values = [];
	            }
	            else {
	                condition.values = new Array(parseInt(operatorLov["inputCount"]));
	            }
	        }
	        else {
	            condition.values = [];
	        }
	        condition.getForm("ConditionValueForm").updateFieldsPropValue(condition, "field0", "field1", "fieldMulti");
	    };
	    ;
	    GridAdminComp.prototype.onChangeSearchTermOperator = function (field, newOperator) {
	        newOperator = (0, formUtils_1.lovValue)(newOperator);
	        console.log('onChangeSearchTermOperator: ', newOperator, field);
	        field.searchTermType = newOperator;
	    };
	    ;
	    GridAdminComp.prototype.onCheckSuperFilter = function (condition, evt) {
	        console.log('onCheckSuperFilter: ', evt.target.checked, condition);
	        var _a = this.props, gridConfig = _a.gridConfig, entities = _a.entities;
	        condition.superFilter = evt.target.checked;
	    };
	    GridAdminComp.prototype.onDeleteCondition = function (index) {
	        console.log('onDeleteCondition: ', index);
	        var gridConfig = this.props.gridConfig;
	        gridConfig.conditions.splice(index, 1);
	    };
	    GridAdminComp.prototype.onChangeSortField = function (sort, newColKey) {
	        newColKey = (0, formUtils_1.lovValue)(newColKey);
	        console.log('onChangeSortField: ', newColKey, sort);
	        var gridConfig = this.props.gridConfig;
	        sort.field = gridConfig.getEntityRef().getFieldByKey(newColKey);
	    };
	    ;
	    GridAdminComp.prototype.onChangeSortOrder = function (sort, newOrder) {
	        newOrder = (0, formUtils_1.lovValue)(newOrder);
	        console.log('onChangeSortOrder: ', newOrder, sort);
	        var gridConfig = this.props.gridConfig;
	        sort.sortOrder = newOrder;
	    };
	    GridAdminComp.prototype.onCheckSortFixed = function (sort, evt, checked) {
	        console.log('onCheckSortFixed: checked = ' + checked);
	        var gridConfig = this.props.gridConfig;
	        sort.fixed = checked;
	    };
	    ;
	    GridAdminComp.prototype.onDeleteSort = function (index) {
	        console.log('onDeleteSort: ', index);
	        var gridConfig = this.props.gridConfig;
	        gridConfig.sortColumns.splice(index, 1);
	    };
	    GridAdminComp.prototype.tenantGroupLovs = function () {
	        var tgIds = new Set(securityService_1.default.availableTenants.map(function (lov) { return lov["tg"]; }));
	        return mdEntityService_1.default.getEntity("TenantGroup").lovItems.filter(function (lov) { return tgIds.has(lov.value); });
	    };
	    /* ****************   REACT METHODS ************************************************************ */
	    GridAdminComp.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, grid = _a.grid, entities = _a.entities, gridConfig = _a.gridConfig, gridLocation = _a.gridLocation, adminMode = _a.adminMode, other = tslib_1.__rest(_a, ["grid", "entities", "gridConfig", "gridLocation", "adminMode"]);
	        console.debug('%c render - gridConfig %O', 'background-color: yellow', gridConfig);
	        if (!gridConfig)
	            return react_1.default.createElement("noscript", null);
	        var inputStyle = { fontSize: 14, marginRight: 20 };
	        var allOperators = entities.get('FILTEROPERATOR').lovItems;
	        var fieldOptions = (gridLocation.$entityRef) ? gridLocation.$entityRef.getFields().filter(function (field) { return field.filterable; }).map(function (field) { return ({ value: field.fieldKey, label: field.label }); }) : [];
	        var sortOrderOptions = [{ value: 'ASC', label: locales_1.loc.i18n(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["Ascending"], ["Ascending"]))) }, { value: 'DESC', label: locales_1.loc.i18n(templateObject_11 || (templateObject_11 = tslib_1.__makeTemplateObject(["Descending"], ["Descending"]))) }];
	        var _b = gridService_1.default.computeConfigLevels(gridLocation, gridConfig), configlevelOptions = _b.configlevelOptions, disabled = _b.disabled;
	        var tenantGroupLovs = this.tenantGroupLovs();
	        var indexLikeSortOrder = {
	            indexName: "gridSortOrder",
	            columns: gridConfig.sortColumns.map(function (gcs) { return ({ columnName: gcs.getFieldName(), sortOrder: gcs.sortOrder }); })
	        };
	        var sortOrderIndexFound = this.indexes
	            && !!this.indexes.filter(function (idx) { return isEqual(idx.columns.slice(0, indexLikeSortOrder.columns.length), indexLikeSortOrder.columns); }).length;
	        var sortOrderFilled = indexLikeSortOrder.columns.every(function (c) { return !!c.sortOrder && !!c.columnName; });
	        return (react_1.default.createElement("form", null,
	            react_1.default.createElement("h4", { style: { marginTop: 20 } }, (gridConfig.gridId) ? locales_1.loc.i18n(templateObject_12 || (templateObject_12 = tslib_1.__makeTemplateObject(["Edit Grid"], ["Edit Grid"]))) : locales_1.loc.i18n(templateObject_13 || (templateObject_13 = tslib_1.__makeTemplateObject(["New Grid"], ["New Grid"])))),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: gridConfig.$errors }),
	            react_1.default.createElement(blockComp_1.BlockComp, { header: locales_1.loc.i18n(templateObject_14 || (templateObject_14 = tslib_1.__makeTemplateObject(["1. Setup grid name"], ["1. Setup grid name"]))), style: { marginBottom: 30 } },
	                react_1.default.createElement("div", { style: { display: 'flex', whiteSpace: 'nowrap' } },
	                    react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'baseline' } },
	                        react_1.default.createElement(fields_1.MdTextField, { name: "gridName", floatingLabelText: locales_1.loc.i18n(templateObject_15 || (templateObject_15 = tslib_1.__makeTemplateObject(["Grid Name"], ["Grid Name"]))), style: inputStyle, required: true, errorText: gridConfig.$errorMap.get("gridName"), value: gridConfig.gridName, disabled: disabled, onChange: this.onChangeTextField.bind(this, 'gridName', false), onBlur: this.onBlurGridConfigName }),
	                        react_1.default.createElement(localizeField_1.default, null)),
	                    react_1.default.createElement("div", { style: { marginLeft: 30, alignSelf: 'flex-end', display: 'flex', alignItems: 'flex-end', width: "100%" } },
	                        react_1.default.createElement(radioButtonField_1.default, { name: "configLevelRB", value: gridConfig.configLevel, onChange: this.onChangeConfigLevel, options: configlevelOptions, groupStyle: { display: 'flex' }, optionStyle: { width: 'initial', marginRight: 15 }, labelStyle: { whiteSpace: 'nowrap', marginLeft: -10 }, style: { marginBottom: 5 }, disabled: disabled }),
	                        ((0, formUtils_1.lovValue)(gridConfig.configLevel) === metaConstant_1.CONFIGLEVEL.TENANTGROUP) ?
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { name: "tenantGroupS", value: gridConfig.tenantGroup, options: tenantGroupLovs, fullWidth: true, onChange: this.onChangeTenantGroup, clearable: false, disabled: disabled }))
	                            : null,
	                        ((0, formUtils_1.lovValue)(gridConfig.configLevel) === metaConstant_1.CONFIGLEVEL.TENANT) ?
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { name: "tenantS", value: gridConfig.tenant, options: securityService_1.default.availableTenants, fullWidth: true, onChange: this.onChangeTenant, clearable: false, disabled: disabled }))
	                            : null))),
	            react_1.default.createElement(blockComp_1.MdDivider, { marginBottom: 20 }),
	            (gridLocation.gridType === grid_1.GRIDTYPE.SQLQUERY) ? (react_1.default.createElement(blockComp_1.BlockComp, { header: locales_1.loc.i18n(templateObject_16 || (templateObject_16 = tslib_1.__makeTemplateObject(["2. SQL Report"], ["2. SQL Report"]))), style: { marginBottom: 30 } },
	                react_1.default.createElement(RaisedButton_1.default, { label: locales_1.loc.i18n(templateObject_17 || (templateObject_17 = tslib_1.__makeTemplateObject(["Define SQL select"], ["Define SQL select"]))), onClick: this.onClickDefineSelect, primary: true, disabled: disabled, style: { marginBottom: 30 } }),
	                react_1.default.createElement(sqlSelectDialog_1.default, { ref: this.sqlSelectDialogRefHandler, title: "SQL select" }),
	                react_1.default.createElement("table", { className: "zz-simple-table" },
	                    react_1.default.createElement("thead", null,
	                        react_1.default.createElement("tr", null,
	                            react_1.default.createElement("th", null, "Column"),
	                            react_1.default.createElement("th", null, "Type"),
	                            react_1.default.createElement("th", null, "Number format"),
	                            react_1.default.createElement("th", null, "Text align"),
	                            react_1.default.createElement("th", null, "Search Term"))),
	                    react_1.default.createElement("tbody", null, gridConfig.columns.map(function (c, i) {
	                        var operatorOptions = (c.field && c.field.availableOperators) ? allOperators
	                            .filter(function (li) { return c.field.availableOperators.includes(li.value); }) : [];
	                        return react_1.default.createElement("tr", { key: i },
	                            react_1.default.createElement("td", null, c.field.label),
	                            react_1.default.createElement("td", null, c.field.dataType),
	                            react_1.default.createElement("td", null, c.field.numberFormat),
	                            react_1.default.createElement("td", null, c.field.textAlign),
	                            react_1.default.createElement("td", null,
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { name: "searchTermType", value: c.field.searchTermType, options: operatorOptions, fullWidth: true, onChange: _this.onChangeSearchTermOperator.bind(_this, c.field), clearable: true }))));
	                    }))))) : (react_1.default.createElement(blockComp_1.BlockComp, { header: locales_1.loc.i18n(templateObject_18 || (templateObject_18 = tslib_1.__makeTemplateObject(["2. Choose Grid Columns"], ["2. Choose Grid Columns"]))), style: { marginBottom: 30 } },
	                react_1.default.createElement(columnSelector_1.default, { gridConfig: gridConfig, entity: gridLocation.$entityRef, disabled: disabled }))),
	            react_1.default.createElement(blockComp_1.MdDivider, { marginBottom: 20 }),
	            (gridLocation.gridType !== grid_1.GRIDTYPE.SQLQUERY) ? (react_1.default.createElement(blockComp_1.BlockComp, { header: locales_1.loc.i18n(templateObject_19 || (templateObject_19 = tslib_1.__makeTemplateObject(["3. Setup Filters"], ["3. Setup Filters"]))), style: { marginBottom: 30 } },
	                react_1.default.createElement("table", { className: "table" },
	                    react_1.default.createElement("thead", null,
	                        react_1.default.createElement("tr", null,
	                            react_1.default.createElement("td", { style: { width: '27%' } }, locales_1.loc.i18n(templateObject_20 || (templateObject_20 = tslib_1.__makeTemplateObject(["Column Name"], ["Column Name"])))),
	                            react_1.default.createElement("td", { style: { width: '17%' } }, locales_1.loc.i18n(templateObject_21 || (templateObject_21 = tslib_1.__makeTemplateObject(["Operator"], ["Operator"])))),
	                            react_1.default.createElement("td", { style: { width: '44%' } }, locales_1.loc.i18n(templateObject_22 || (templateObject_22 = tslib_1.__makeTemplateObject(["Value"], ["Value"])))),
	                            react_1.default.createElement("td", { style: { width: '9%' } }, locales_1.loc.i18n(templateObject_23 || (templateObject_23 = tslib_1.__makeTemplateObject(["Sticky"], ["Sticky"])))),
	                            react_1.default.createElement("td", { style: { width: '3%' } }))),
	                    react_1.default.createElement("tbody", null, gridConfig.conditions.map(function (condition, index) {
	                        var operatorOptions = (condition.field) ? allOperators
	                            .filter(function (li) { return condition.field.availableOperators.includes(li.value); }) : [];
	                        var borderStyle = (index > 0) ? { borderTop: 'inherit' } : {};
	                        return (react_1.default.createElement("tr", { key: index },
	                            react_1.default.createElement("td", { style: borderStyle },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { name: "conditionColumn", value: condition.fieldKey, options: fieldOptions, fullWidth: true, onChange: _this.onChangeConditionColumn.bind(_this, condition), clearable: false, disabled: condition.implicit || disabled }))),
	                            react_1.default.createElement("td", { style: borderStyle },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { name: "conditionOperator", value: condition.operator, options: operatorOptions, fullWidth: true, onChange: _this.onChangeConditionOperator.bind(_this, condition), clearable: false, disabled: condition.implicit || disabled }))),
	                            react_1.default.createElement("td", { style: borderStyle }, (condition.field) ?
	                                react_1.default.createElement(conditionValueForm_1.default, { dataObject: condition, rootObject: gridConfig, entities: entities, disabled: condition.implicit || disabled, context: conditionValueForm_1.CONDITIONVALUEFORMCONTEXT.GRIDDEF, entity: condition.getEntityRef(), extractFieldFn: _this.extractFieldFn })
	                                :
	                                    null),
	                            react_1.default.createElement("td", { style: borderStyle },
	                                react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, createForm_1.fieldStyles.small.checkbox, { name: "superFilter", value: condition.superFilter, onCheck: _this.onCheckSuperFilter.bind(_this, condition), defaultChecked: condition.superFilter, disabled: condition.implicit || disabled }))),
	                            react_1.default.createElement("td", { style: Object.assign(borderStyle, { verticalAlign: 'middle' }) }, (condition.implicit || disabled) ? '' : (react_1.default.createElement("a", { className: "font-button-link", onClick: _this.onDeleteCondition.bind(_this, index) },
	                                react_1.default.createElement("span", { className: "fa fa-trash" }))))));
	                    }))),
	                react_1.default.createElement(RaisedButton_1.default, { label: locales_1.loc.i18n(templateObject_24 || (templateObject_24 = tslib_1.__makeTemplateObject(["Add Filter"], ["Add Filter"]))), onClick: this.onClickAddFilter, primary: true, disabled: disabled, icon: react_1.default.createElement(add_1.default, null) }))) : null,
	            (gridLocation.specialConditions.length) ? (react_1.default.createElement(blockComp_1.BlockComp, { header: locales_1.loc.i18n(templateObject_25 || (templateObject_25 = tslib_1.__makeTemplateObject(["4. Special Conditions"], ["4. Special Conditions"]))), style: { marginTop: 30, marginBottom: 5 } },
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { onChange: this.handleSpecialCondition, value: gridConfig.specialConditions, options: gridLocation.specialConditions, disabled: disabled, multi: true, fullWidth: true, searchable: false, clearable: false })))))) : null,
	            (gridLocation.gridType !== grid_1.GRIDTYPE.SQLQUERY) ? (react_1.default.createElement(blockComp_1.MdDivider, { marginBottom: 20 })) : null,
	            (gridLocation.gridType !== grid_1.GRIDTYPE.SQLQUERY) ? (react_1.default.createElement(blockComp_1.BlockComp, { header: locales_1.loc.i18n(templateObject_26 || (templateObject_26 = tslib_1.__makeTemplateObject(["5. Setup Grid Ordering"], ["5. Setup Grid Ordering"]))), style: { marginBottom: 30 } },
	                gridConfig.sortColumns.length && !sortOrderIndexFound && this.indexes && sortOrderFilled &&
	                    (react_1.default.createElement(errorComp_1.ErrorComp, { bsStyle: "warning", header: "Current ordering is not supported by appropriate index. Performance will be less than ideal. Existing indexes: ", messages: this.indexes.map(function (idx) { return ({ message: idx.columns.map(function (c) { return c.columnName + " " + c.sortOrder; }).join(", ") }); }) })),
	                react_1.default.createElement("table", { className: "table" },
	                    react_1.default.createElement("thead", null,
	                        react_1.default.createElement("tr", null,
	                            react_1.default.createElement("td", { style: { width: '40%' } }, locales_1.loc.i18n(templateObject_27 || (templateObject_27 = tslib_1.__makeTemplateObject(["Column Name"], ["Column Name"])))),
	                            react_1.default.createElement("td", { style: { width: '30%' } }, locales_1.loc.i18n(templateObject_28 || (templateObject_28 = tslib_1.__makeTemplateObject(["ASC / DESC"], ["ASC / DESC"])))),
	                            react_1.default.createElement("td", { style: { width: '25%' } }, locales_1.loc.i18n(templateObject_29 || (templateObject_29 = tslib_1.__makeTemplateObject(["Lock Ordering"], ["Lock Ordering"])))),
	                            react_1.default.createElement("td", { style: { width: '5%' } }))),
	                    react_1.default.createElement("tbody", null, gridConfig.sortColumns.map(function (sort, index) {
	                        var borderStyle = (index > 0) ? { borderTop: 'inherit' } : {};
	                        return (react_1.default.createElement("tr", { key: index },
	                            react_1.default.createElement("td", { style: borderStyle },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { name: "sortColumn", value: sort.fieldKey, options: fieldOptions, onChange: _this.onChangeSortField.bind(_this, sort), clearable: false, disabled: disabled }))),
	                            react_1.default.createElement("td", { style: borderStyle },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { name: "sortOrder", value: sort.sortOrder, options: sortOrderOptions, onChange: _this.onChangeSortOrder.bind(_this, sort), clearable: false, disabled: disabled }))),
	                            react_1.default.createElement("td", { style: Object.assign(borderStyle, { verticalAlign: 'middle' }) },
	                                react_1.default.createElement(fields_1.MdCheckbox, { style: Object.assign({ marginTop: 10 }, createForm_1.fieldStyles.small.default), name: "sortFixed", value: new Boolean(sort.fixed).toString(), defaultChecked: sort.fixed, label: "Fixn\u00ED \u0159azen\u00ED", onCheck: _this.onCheckSortFixed.bind(_this, sort), disabled: disabled })),
	                            react_1.default.createElement("td", { style: Object.assign(borderStyle, { verticalAlign: 'middle' }) }, (disabled) ? '' : (react_1.default.createElement("a", { className: "font-button-link", onClick: _this.onDeleteSort.bind(_this, index) },
	                                react_1.default.createElement("span", { className: "fa fa-trash" }))))));
	                    }))),
	                react_1.default.createElement(RaisedButton_1.default, { label: locales_1.loc.i18n(templateObject_30 || (templateObject_30 = tslib_1.__makeTemplateObject(["Add Ordering"], ["Add Ordering"]))), onClick: this.onClickAddSort, primary: true, disabled: disabled, icon: react_1.default.createElement(add_1.default, null) }))) : null,
	            (adminMode) ? (react_1.default.createElement(blockComp_1.MdDivider, { marginBottom: 20 })) : null,
	            (adminMode || gridLocation.gridType === grid_1.GRIDTYPE.SQLQUERY) ? (react_1.default.createElement(blockComp_1.BlockComp, { header: "6. Advanced options", style: { marginBottom: 30 } },
	                react_1.default.createElement("div", { style: { display: 'flex' } },
	                    react_1.default.createElement(fields_1.MdTextField, { name: "gridScrollSize", floatingLabelText: "Max scroll Size", style: inputStyle, required: true, errorText: gridConfig.$errorMap.get("gridScrollSize"), value: gridConfig.gridScrollSize, onChange: this.onChangeTextField.bind(this, 'gridScrollSize', true), onBlur: this.onBlurGridScrollSize, disabled: disabled }),
	                    react_1.default.createElement(fields_1.MdTextField, { name: "gridPageSize", floatingLabelText: "Page Size", style: inputStyle, required: true, errorText: gridConfig.$errorMap.get("gridPageSize"), value: gridConfig.gridPageSize, onChange: this.onChangeTextField.bind(this, 'gridPageSize', true), onBlur: this.onBlurGridPageSize, disabled: disabled || gridLocation.editable || gridLocation.gridType === grid_1.GRIDTYPE.JAVACONFIG }),
	                    react_1.default.createElement(fields_1.MdTextField, { name: "maxColumnWidth", floatingLabelText: "Max column width", style: inputStyle, required: true, errorText: gridConfig.$errorMap.get("maxColumnWidth"), value: gridConfig.maxColumnWidth, onChange: this.onChangeTextField.bind(this, 'maxColumnWidth', true), onBlur: this.onBlurMaxColumnWidth, disabled: disabled })),
	                react_1.default.createElement("div", { style: { display: 'flex' } },
	                    react_1.default.createElement(fields_1.MdTextField, { name: "hardRowLimit", floatingLabelText: "Hard row limit", style: inputStyle, errorText: gridConfig.$errorMap.get("hardRowLimit"), value: gridConfig.hardRowLimit, onChange: this.onChangeTextField.bind(this, 'hardRowLimit', true), onBlur: this.onBlurHardRowLimit(), disabled: disabled }),
	                    react_1.default.createElement(fields_1.MdCheckbox, { name: "refreshOnPage", label: "Refresh on page load", style: tslib_1.__assign(tslib_1.__assign({}, inputStyle), { marginTop: 30 }), checked: gridConfig.refreshOnPage, onCheck: this.onChangeCheckbox.bind(this, 'refreshOnPage'), disabled: disabled }),
	                    react_1.default.createElement(fields_1.MdCheckbox, { name: "refreshOnData", label: "Refresh on data change", style: tslib_1.__assign(tslib_1.__assign({}, inputStyle), { marginTop: 30 }), checked: gridConfig.refreshOnData, onCheck: this.onChangeCheckbox.bind(this, 'refreshOnData'), disabled: disabled })),
	                react_1.default.createElement("div", { style: { display: 'flex' } },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { name: "gridRowCss", floatingLabelText: "Grid Row CSS", onChange: this.onChangeSelect.bind(this, 'gridRowCss'), value: gridConfig.gridRowCss, options: mdEntityService_1.default.getEntity("GRIDROWCSS").lovItems, disabled: disabled, searchable: false, clearable: false }))))) : null));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridAdminComp.prototype, "indexes", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "save", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "validate", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "onChangeTextField", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "onChangeCheckbox", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "onChangeSelect", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "validateTextField", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "onClickAddFilter", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "onChangeConditionColumn", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "onChangeConditionOperator", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "onChangeSearchTermOperator", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "onCheckSuperFilter", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "onDeleteCondition", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "onChangeSortField", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "onChangeSortOrder", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "onCheckSortFixed", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "onClickAddSort", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "onDeleteSort", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "handleSpecialCondition", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "onChangeConfigLevel", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "onChangeTenantGroup", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "onChangeTenant", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminComp.prototype, "onClickDefineSelect", void 0);
	    GridAdminComp = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], GridAdminComp);
	    return GridAdminComp;
	}(react_1.default.Component));
	exports.default = GridAdminComp;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mobx_1 = __webpack_require__(5);
	var DomainAncestor_1 = __webpack_require__(33);
	var mdField_1 = tslib_1.__importStar(__webpack_require__(57));
	var GridConfigColumn = /** @class */ (function (_super) {
	    tslib_1.__extends(GridConfigColumn, _super);
	    function GridConfigColumn(gridConfig, json) {
	        var _this = _super.call(this, json) || this;
	        _this.$gridConfigRef = gridConfig;
	        if (_this.field)
	            _this.field = (gridConfig && _this.field.fieldType !== mdField_1.FIELDTYPE.SQLRESULT) ? gridConfig.getEntityRef().getField(_this.field.fieldName) : new mdField_1.default(_this.field);
	        return _this;
	    }
	    Object.defineProperty(GridConfigColumn.prototype, "label", {
	        get: function () {
	            return this.field.label;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(GridConfigColumn.prototype, "gridHeaderLabelActive", {
	        get: function () {
	            if (this.field) {
	                var gridLocationField = this.$gridConfigRef.$gridLocationRef.fields.get(this.field.fieldName);
	                var headerLabelActive = (gridLocationField) ? gridLocationField.gridHeaderLabel : null;
	                return (headerLabelActive != null) ? headerLabelActive : this.field.gridHeaderLabelActive;
	            }
	            else {
	                return '';
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfigColumn.prototype, "field", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfigColumn.prototype, "sum", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfigColumn.prototype, "avg", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfigColumn.prototype, "$selected", void 0);
	    GridConfigColumn = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], GridConfigColumn);
	    return GridConfigColumn;
	}(DomainAncestor_1.DomainAncestor));
	exports.default = GridConfigColumn;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SORTORDER = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_1 = __webpack_require__(5);
	var DomainAncestor_1 = __webpack_require__(33);
	var mdField_1 = tslib_1.__importStar(__webpack_require__(57));
	var SORTORDER;
	(function (SORTORDER) {
	    SORTORDER["ASC"] = "ASC";
	    SORTORDER["DESC"] = "DESC";
	})(SORTORDER || (exports.SORTORDER = SORTORDER = {}));
	var GridConfigSort = /** @class */ (function (_super) {
	    tslib_1.__extends(GridConfigSort, _super);
	    function GridConfigSort(gridConfig, json) {
	        var _this = _super.call(this, json) || this;
	        _this.$gridConfigRef = gridConfig;
	        if (_this.field)
	            _this.field = (gridConfig && _this.field.fieldType !== mdField_1.FIELDTYPE.SQLRESULT) ? gridConfig.getEntityRef().getField(_this.field.fieldName) : new mdField_1.default(_this.field);
	        return _this;
	    }
	    Object.defineProperty(GridConfigSort.prototype, "fieldKey", {
	        get: function () {
	            return (this.field) ? this.field.fieldKey : undefined;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    GridConfigSort.prototype.getFieldName = function () {
	        return (this.field) ? this.field.fieldName : undefined;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfigSort.prototype, "field", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfigSort.prototype, "fixed", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridConfigSort.prototype, "sortOrder", void 0);
	    return GridConfigSort;
	}(DomainAncestor_1.DomainAncestor));
	exports.default = GridConfigSort;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.GridSpecialCondition = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var GridSpecialCondition = /** @class */ (function (_super) {
	    tslib_1.__extends(GridSpecialCondition, _super);
	    function GridSpecialCondition(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.gridConfigs)
	            _this.gridConfigs = [];
	        return _this;
	    }
	    GridSpecialCondition.prototype.getId = function () {
	        return this.specialConditionId;
	    };
	    GridSpecialCondition.prototype.setId = function (id) {
	        this.specialConditionId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridSpecialCondition.prototype, "specialConditionId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridSpecialCondition.prototype, "gridLocation", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridSpecialCondition.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridSpecialCondition.prototype, "description", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridSpecialCondition.prototype, "sql", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridSpecialCondition.prototype, "gridConfigs", void 0);
	    GridSpecialCondition = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], GridSpecialCondition);
	    return GridSpecialCondition;
	}(DomainAncestor_1.DomainAncestor));
	exports.GridSpecialCondition = GridSpecialCondition;


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.setSelectGridLocation = exports.getSelectGridLocation = void 0;
	var mobx_1 = __webpack_require__(5);
	var getSelectGridLocation = function (objekt, gridLocation) {
	    return objekt.gridLocations.includes(gridLocation);
	};
	exports.getSelectGridLocation = getSelectGridLocation;
	exports.setSelectGridLocation = (0, mobx_1.action)("setSelectGridLocation-action", function (objekt, gridLocation, item, checked) {
	    console.log('setSelectGridLocation %s .. %s...%s', gridLocation, item, checked);
	    var ti = objekt.gridLocations.indexOf(gridLocation);
	    if (checked) {
	        if (ti === -1)
	            objekt.gridLocations.push(gridLocation);
	    }
	    else {
	        if (ti >= 0)
	            objekt.gridLocations.splice(ti, 1);
	    }
	    objekt.$dirty = true;
	});


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TriggerInfo = exports.JobInfo = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var JobInfo = /** @class */ (function (_super) {
	    tslib_1.__extends(JobInfo, _super);
	    function JobInfo(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "group", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "detailComponent", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "beanName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "beanMethod", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "arguments", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "oldBusinessDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "newBusinessDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "eodMap", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "documentTypes", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "eventType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "limitByProfitCenter", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "onlyForDomesticCustomers", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "waitForTaxConfirmation", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "profitCenters", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "invoiceTypes", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "mainDocument", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "mainDocumentNameExpression", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "attachedDocuments", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "archivingFormat", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "archiveFilenameExpression", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "tenants", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "bankApiTypes", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "limit", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "queueTypes", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "importType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "directory", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "filenamePattern", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], JobInfo.prototype, "invalidate", void 0);
	    JobInfo = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], JobInfo);
	    return JobInfo;
	}(DomainAncestor_1.DomainAncestor));
	exports.JobInfo = JobInfo;
	var TriggerInfo = /** @class */ (function (_super) {
	    tslib_1.__extends(TriggerInfo, _super);
	    function TriggerInfo(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TriggerInfo.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TriggerInfo.prototype, "group", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TriggerInfo.prototype, "cronExpression", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TriggerInfo.prototype, "misfirePolicy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TriggerInfo.prototype, "addHolidayCalendar", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TriggerInfo.prototype, "previousRun", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TriggerInfo.prototype, "nextRun", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TriggerInfo.prototype, "state", void 0);
	    TriggerInfo = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], TriggerInfo);
	    return TriggerInfo;
	}(DomainAncestor_1.DomainAncestor));
	exports.TriggerInfo = TriggerInfo;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DynamicFieldsBlock = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var blockComp_1 = __webpack_require__(30);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var mdField_1 = __webpack_require__(57);
	var fields_1 = __webpack_require__(20);
	var DynamicFieldsBlock = /** @class */ (function (_super) {
	    tslib_1.__extends(DynamicFieldsBlock, _super);
	    function DynamicFieldsBlock() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DynamicFieldsBlock.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entity = _a.entity, entities = _a.entities, header = _a.header;
	        return (react_1.default.createElement(blockComp_1.BlockComp, { header: header }, dataObject.fields.map(function (dynField) { return (react_1.default.createElement("div", { className: "row" },
	            react_1.default.createElement("div", { className: "fx col-xs-4" }, dynField.label),
	            react_1.default.createElement("div", { className: "fx col-xs-8" },
	                react_1.default.createElement(DynamicFieldComp, { dynamicField: dynField, entities: entities, entity: entity, rootObject: rootObject })))); })));
	    };
	    DynamicFieldsBlock = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], DynamicFieldsBlock);
	    return DynamicFieldsBlock;
	}(react_1.default.Component));
	exports.DynamicFieldsBlock = DynamicFieldsBlock;
	var inputStyle = { fontSize: 14, marginRight: 20 };
	var DynamicFieldComp = /** @class */ (function (_super) {
	    tslib_1.__extends(DynamicFieldComp, _super);
	    function DynamicFieldComp() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onCheck = function (evt, checked) {
	            var _a = _this.props, dynamicField = _a.dynamicField, rootObject = _a.rootObject;
	            console.log('onCheck checked: ' + checked);
	            dynamicField.value = checked;
	            rootObject.$dirty = true;
	        };
	        _this.onChange = function (evt) {
	            var _a = _this.props, dynamicField = _a.dynamicField, rootObject = _a.rootObject;
	            console.log('onChange value: ' + evt.target.value);
	            dynamicField.value = evt.target.value;
	            rootObject.$dirty = true;
	        };
	        return _this;
	    }
	    DynamicFieldComp.prototype.render = function () {
	        var _a = this.props, rootObject = _a.rootObject, entity = _a.entity, entities = _a.entities, dynamicField = _a.dynamicField;
	        switch (dynamicField.$mdFieldRef.dataType) {
	            case mdField_1.DATATYPE.BOOLEAN:
	                return (react_1.default.createElement(fields_1.MdCheckbox, { name: dynamicField.fieldName, checked: dynamicField.value, onCheck: this.onCheck }));
	            case mdField_1.DATATYPE.STRING:
	                return (react_1.default.createElement(fields_1.MdTextField, { style: inputStyle, value: dynamicField.value, name: dynamicField.fieldName, onChange: this.onChange }));
	            default:
	                throw new Error(dynamicField.$mdFieldRef.dataType + " not implemented yet");
	        }
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], DynamicFieldComp.prototype, "onCheck", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], DynamicFieldComp.prototype, "onChange", void 0);
	    DynamicFieldComp = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], DynamicFieldComp);
	    return DynamicFieldComp;
	}(react_1.default.Component));


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var metaDomain_1 = __webpack_require__(220);
	var mobx_1 = __webpack_require__(5);
	var MdConfigService = /** @class */ (function () {
	    function MdConfigService() {
	    }
	    MdConfigService.prototype.readEntityDto = function (entityName) {
	        return axios_config_1.default.get('/core/meta/entity/' + entityName)
	            .then(function (response) { return new metaDomain_1.MdEntityDto(response.data); });
	    };
	    MdConfigService.prototype.saveEntityDto = function (entityObject) {
	        return axios_config_1.default.post('/core/meta/entity', entityObject, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    MdConfigService.prototype.readFieldDto = function (fieldKey) {
	        return axios_config_1.default.get('/core/meta/field/' + fieldKey)
	            .then(function (response) { return new metaDomain_1.MdFieldDto(response.data); });
	    };
	    MdConfigService.prototype.saveFieldDto = function (fieldObject) {
	        return axios_config_1.default.post('/core/meta/field', fieldObject, { showPrettyError: true })
	            .then(function (response) { return response.data; });
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdConfigService.prototype, "entityObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdConfigService.prototype, "fieldObject", void 0);
	    return MdConfigService;
	}());
	var mdConfigService = new MdConfigService();
	exports.default = mdConfigService;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SecurablesResolved = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var formUtils_1 = __webpack_require__(14);
	var colors_1 = __webpack_require__(29);
	__webpack_require__(453);
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var jsonUtils_1 = __webpack_require__(193);
	var SvgDone = __webpack_require__(298);
	var SvgClear = __webpack_require__(248);
	var TH_STYLE = { position: "sticky", top: 82, zIndex: 100, backgroundColor: colors_1.white };
	var TD_STYLE = { paddingTop: 5, paddingBottom: 5 };
	var TD_STYLE_GREY = { paddingTop: 5, paddingBottom: 5, backgroundColor: colors_1.grey200 };
	var SecurablesResolved = /** @class */ (function (_super) {
	    tslib_1.__extends(SecurablesResolved, _super);
	    function SecurablesResolved() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SecurablesResolved.prototype.render = function () {
	        var _a = this.props, entities = _a.entities, permissionMap = _a.permissionMap, securables = _a.securables;
	        var permissionKeys = Object.keys(metaConstant_1.PERMISSION);
	        var permissionKeysDetailable = permissionKeys.filter(function (p) { return ![metaConstant_1.PERMISSION.PublicGrid, metaConstant_1.PERMISSION.TenantGrid, metaConstant_1.PERMISSION.TenantGroupGrid].includes(p); });
	        var permissionModuleMap = Object.values(permissionMap).reduce(function (acc, sp) {
	            (0, jsonUtils_1.createIfAbsent)(acc, sp.module, function (k) { return []; }).push(sp);
	            return acc;
	        }, {});
	        return (react_1.default.createElement("table", { className: "zz-simple-table", style: { position: "relative", margin: 20 } },
	            react_1.default.createElement("thead", null,
	                react_1.default.createElement("tr", null,
	                    react_1.default.createElement("th", { style: TH_STYLE }),
	                    permissionKeys.map(function (p, i) { return (react_1.default.createElement("th", { key: i, style: TH_STYLE }, p)); }),
	                    react_1.default.createElement("th", { style: TH_STYLE }))),
	            Object.entries(permissionModuleMap).map(function (_a) {
	                var module = _a[0], securablePermissions = _a[1];
	                var moduleLov = (0, formUtils_1.getLovItem)(entities.get('MODULE').lovItems, module);
	                var securableDefMap = securables[module];
	                return (react_1.default.createElement("tbody", { key: module },
	                    react_1.default.createElement("tr", null,
	                        react_1.default.createElement("td", { colSpan: permissionKeys.length + 1, style: { paddingTop: 10, paddingBottom: 10 } },
	                            react_1.default.createElement("div", { className: "secu-module-header", style: { justifyContent: "center" } },
	                                react_1.default.createElement("span", { className: (0, formUtils_1.lovParam)(moduleLov, 'icon') }),
	                                react_1.default.createElement("div", { className: "text" }, (0, formUtils_1.lovLabel)(moduleLov))))),
	                    securablePermissions.map(function (securablePermission, index) {
	                        var securableDef = securableDefMap[securablePermission.securable.value];
	                        var securableConfig = metaConstant_1.SECURABLE[(0, formUtils_1.lovValue)(securablePermission.securable)];
	                        return ((securableConfig && securableConfig.detailHeader) ? (react_1.default.createElement("tr", { key: index },
	                            react_1.default.createElement("td", { style: tslib_1.__assign(tslib_1.__assign({}, TD_STYLE), { paddingRight: 0, paddingBottom: 0 }), colSpan: permissionKeys.length + 1 - 3 },
	                                react_1.default.createElement("table", { className: "zz-small-table", style: { width: "100%" } },
	                                    react_1.default.createElement("thead", null,
	                                        react_1.default.createElement("tr", null,
	                                            react_1.default.createElement("th", { title: securablePermission.getTuple("contributingRole") },
	                                                react_1.default.createElement("span", { style: { fontSize: 14, marginLeft: -10, fontWeight: "normal", color: colors_1.grey700 } }, (0, formUtils_1.lovLabel)(securablePermission.securable))),
	                                            permissionKeysDetailable.map(function (permKey, index) { return react_1.default.createElement("th", { key: index, style: { fontSize: 12 } }, permKey); }))),
	                                    securablePermission.detailPermissions.values().map(function (spd, index) { return (react_1.default.createElement("tr", { key: index },
	                                        react_1.default.createElement("td", { style: { fontSize: 12 } }, (spd.label) ? spd.label : spd.detailId),
	                                        react_1.default.createElement(SecCellDet, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.Read, spd: spd }),
	                                        react_1.default.createElement(SecCellDet, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.New, spd: spd }),
	                                        react_1.default.createElement(SecCellDet, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.Update, spd: spd }),
	                                        react_1.default.createElement(SecCellDet, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.Delete, spd: spd }),
	                                        react_1.default.createElement(SecCellDet, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.Execute, spd: spd }),
	                                        react_1.default.createElement(SecCellDet, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.Export, spd: spd }),
	                                        react_1.default.createElement(SecCellDet, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.Import, spd: spd }))); }))),
	                            react_1.default.createElement(SecCell, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.PublicGrid, securablePermission: securablePermission, style: { verticalAlign: 'top' } }),
	                            react_1.default.createElement(SecCell, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.TenantGrid, securablePermission: securablePermission, style: { verticalAlign: 'top' } }),
	                            react_1.default.createElement(SecCell, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.TenantGroupGrid, securablePermission: securablePermission, style: { verticalAlign: 'top' } }))) : (react_1.default.createElement("tr", { key: index },
	                            react_1.default.createElement("td", { style: TD_STYLE, title: securablePermission.getTuple("contributingRole") }, (0, formUtils_1.lovLabel)(securablePermission.securable)),
	                            react_1.default.createElement(SecCell, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.Read, securablePermission: securablePermission }),
	                            react_1.default.createElement(SecCell, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.New, securablePermission: securablePermission }),
	                            react_1.default.createElement(SecCell, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.Update, securablePermission: securablePermission }),
	                            react_1.default.createElement(SecCell, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.Delete, securablePermission: securablePermission }),
	                            react_1.default.createElement(SecCell, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.Execute, securablePermission: securablePermission }),
	                            react_1.default.createElement(SecCell, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.Export, securablePermission: securablePermission }),
	                            react_1.default.createElement(SecCell, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.Import, securablePermission: securablePermission }),
	                            react_1.default.createElement(SecCell, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.PublicGrid, securablePermission: securablePermission }),
	                            react_1.default.createElement(SecCell, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.TenantGrid, securablePermission: securablePermission }),
	                            react_1.default.createElement(SecCell, { securableDef: securableDef, permission: metaConstant_1.PERMISSION.TenantGroupGrid, securablePermission: securablePermission }))));
	                    })));
	            })));
	    };
	    SecurablesResolved = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SecurablesResolved);
	    return SecurablesResolved;
	}(react_1.default.Component));
	exports.SecurablesResolved = SecurablesResolved;
	var GREEN_STYLE = { color: colors_1.green500 };
	var RED_STYLE = { color: colors_1.red400 };
	function SecCell(_a) {
	    var securableDef = _a.securableDef, permission = _a.permission, securablePermission = _a.securablePermission, style = _a.style;
	    var tdStyle = (securableDef.availablePermissions.includes(permission)) ? TD_STYLE : TD_STYLE_GREY;
	    if (style)
	        tdStyle = tslib_1.__assign(tslib_1.__assign({}, tdStyle), style);
	    return (react_1.default.createElement("td", { style: tdStyle }, (securablePermission.isPermission(permission)) ? react_1.default.createElement(SvgDone, { style: GREEN_STYLE, size: 16 }) :
	        ((securableDef.availablePermissions.includes(permission)) ? react_1.default.createElement(SvgClear, { style: RED_STYLE, size: 16 }) : react_1.default.createElement("div", null))));
	}
	function SecCellDet(_a) {
	    var securableDef = _a.securableDef, permission = _a.permission, spd = _a.spd;
	    var tdStyle = (securableDef.availablePermissions.includes(permission)) ? {} : { backgroundColor: colors_1.grey200 };
	    return (react_1.default.createElement("td", { style: tdStyle }, (spd.isPermission(permission)) ? react_1.default.createElement(SvgDone, { style: GREEN_STYLE, size: 12 }) :
	        ((securableDef.availablePermissions.includes(permission)) ? react_1.default.createElement(SvgClear, { style: RED_STYLE, size: 12 }) : react_1.default.createElement("div", null))));
	}


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pull = __webpack_require__(117);
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var blockComp_1 = __webpack_require__(30);
	var icons_1 = __webpack_require__(63);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var arrayUtils_1 = __webpack_require__(78);
	var blockComp_2 = __webpack_require__(30);
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var formUtils_1 = __webpack_require__(14);
	var securityDomain_1 = __webpack_require__(97);
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var dateUtils_1 = __webpack_require__(49);
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var SvgDelete = __webpack_require__(249);
	var colors_1 = __webpack_require__(29);
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var UserTokenList = /** @class */ (function (_super) {
	    tslib_1.__extends(UserTokenList, _super);
	    function UserTokenList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.addToken = function () {
	            console.debug('addToken');
	            var _a = _this.props, userObject = _a.userObject, entities = _a.entities;
	            var newToken = new securityDomain_1.UserToken({
	                active: true,
	                $new: true,
	                $added: true,
	                validFrom: (0, moment_1.default)().format("YYYY-MM-DD")
	            }).initDefaultValues();
	            userObject.tokens.push(newToken);
	        };
	        return _this;
	    }
	    UserTokenList.prototype.render = function () {
	        var _a = this.props, userObject = _a.userObject, entities = _a.entities;
	        var header = (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
	            react_1.default.createElement("div", null, "API Tokens"),
	            react_1.default.createElement(icons_1.MdIconButton, { onClick: this.addToken },
	                react_1.default.createElement(add_1.default, null))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { header: header, noPadding: true, style: { display: 'flex', flexDirection: 'column' } }, (0, arrayUtils_1.addSeparator)(userObject.tokens.map(function (userToken, index) { return react_1.default.createElement(UserTokenForm, { dataObject: userToken, rootObject: userObject, key: index, entities: entities, entity: entities.get('UserToken'), index: index }); }), react_1.default.createElement(blockComp_2.MdDivider, { inset: true }))));
	    };
	    UserTokenList.contextTypes = {
	        router: prop_types_1.default.func.isRequired,
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], UserTokenList.prototype, "addToken", void 0);
	    UserTokenList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], UserTokenList);
	    return UserTokenList;
	}(react_1.default.Component));
	exports.default = UserTokenList;
	var UserTokenForm = /** @class */ (function (_super) {
	    tslib_1.__extends(UserTokenForm, _super);
	    function UserTokenForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDelete = function (evt) {
	            evt.stopPropagation();
	            console.log('onDelete %o', _this.props.dataObject);
	            pull(_this.props.rootObject.tokens, _this.props.dataObject);
	            return securityService_1.default.deleteToken(_this.props.dataObject.tokenId);
	        };
	        _this.generateToken = function (evt) {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject;
	            securityService_1.default.generateToken(rootObject.username, dataObject).then(function (ut) {
	                dataObject.tokenId = ut.tokenId;
	                dataObject.tokenString = ut.tokenString;
	                dataObject.$new = false;
	            });
	        };
	        return _this;
	    }
	    UserTokenForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, index = _a.index, entities = _a.entities, entity = _a.entity, formName = _a.formName;
	        var fields = dataObject.getFormFields(formName);
	        var tokenName = fields.tokenName, active = fields.active, validFrom = fields.validFrom, validTo = fields.validTo;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, tokenName.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-3" },
	                    react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, validFrom.props, { disabled: true }))),
	                react_1.default.createElement("div", { className: "fx col-xs-3" },
	                    react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, validTo.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-2" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, active.props, { style: { height: 36, alignSelf: 'flex-end', marginLeft: 10 } }))))));
	        var closedContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { style: { display: 'flex', fontSize: 14, lineHeight: '14px', marginLeft: 15, marginBottom: 10 } },
	                react_1.default.createElement(formUtils_1.FieldText, { label: fields.tokenId.textLabel, value: dataObject.tokenId, style: { marginTop: '10px' } }),
	                react_1.default.createElement(formUtils_1.FieldText, { label: fields.tokenName.textLabel, value: dataObject.tokenName, style: { marginTop: '10px' } }),
	                react_1.default.createElement("span", { className: "zz-ml-10 zz-mt-10" }, (0, dateUtils_1.formatInterval)(dataObject.validFrom, dataObject.validTo)),
	                react_1.default.createElement("span", { className: "zz-ml-10 zz-mt-10" },
	                    react_1.default.createElement(SvgDelete, { className: "zz-ml-5", style: { height: 20, width: 20, cursor: 'hand' }, onClick: this.onDelete }))),
	            (dataObject.tokenString) ? (react_1.default.createElement("div", { className: "zz-mt-10 zz-ml-15" },
	                react_1.default.createElement("p", { style: { color: colors_1.red500 } }, "Please copy this string, for security reasons, it will not be shown again:"),
	                react_1.default.createElement("p", { style: { color: colors_1.blue500, fontFamily: 'monospace' } }, dataObject.tokenString))) : null));
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: (dataObject.$new) ? "active-item--open" : "" },
	                (dataObject.$new) ? openContent : null,
	                (!dataObject.$new) ? closedContent : null,
	                (dataObject.$new) ? react_1.default.createElement(FlatButton_1.default, { label: "Generate!", primary: true, onClick: this.generateToken }) : null)));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserTokenForm.prototype, "showMap", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], UserTokenForm.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], UserTokenForm.prototype, "generateToken", void 0);
	    UserTokenForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'UserTokenForm',
	            fields: [{
	                    name: 'tokenId'
	                }, {
	                    name: 'tokenName'
	                }, {
	                    name: 'active'
	                }, {
	                    name: 'closeDate'
	                }, {
	                    name: 'validFrom'
	                }, {
	                    name: 'validTo'
	                }]
	        }, function () { return react_1.default.createElement("noscript", null); }),
	        mobx_react_1.observer
	    ], UserTokenForm);
	    return UserTokenForm;
	}(react_1.default.Component));


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ParamTable = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var utils_1 = __webpack_require__(37);
	var EditableTenantAncestor_1 = __webpack_require__(2046);
	var ParamTable = /** @class */ (function (_super) {
	    tslib_1.__extends(ParamTable, _super);
	    function ParamTable(json) {
	        return _super.call(this, json) || this;
	    }
	    ParamTable.prototype.getFlattenId = function () {
	        return (this.paramKey && (this.tenantId || this.tenantId === 0)) ? (0, utils_1.formatId)(this.paramKey.label, this.tenantId) : null;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ParamTable.prototype, "paramKey", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ParamTable.prototype, "tenantId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ParamTable.prototype, "value", void 0);
	    ParamTable = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ParamTable);
	    return ParamTable;
	}(EditableTenantAncestor_1.EditableTenantAncestor));
	exports.ParamTable = ParamTable;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var formUtils_1 = __webpack_require__(14);
	var arrayUtils_1 = __webpack_require__(78);
	var colors_1 = __webpack_require__(29);
	__webpack_require__(667);
	var mobx_react_1 = __webpack_require__(4);
	var invoiceDomain_1 = __webpack_require__(157);
	var domUtils_1 = __webpack_require__(91);
	var numberUtils_1 = __webpack_require__(143);
	var InvoiceSumTable = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceSumTable, _super);
	    function InvoiceSumTable() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    InvoiceSumTable.prototype.render = function () {
	        var _a = this.props, invoiceObject = _a.invoiceObject, entities = _a.entities, invoiceEntity = _a.invoiceEntity, style = _a.style, minimal = _a.minimal;
	        // basePrice = (sum(item.basePrice))cr
	        // itemAdjustmentAmount = (sum(item.adjustmentAmount))cr
	        // basePriceWithAdjustment =  basePrice + itemAdjustmentAmount
	        // invoiceAdjustmentAmount = (basePriceWithAdjustment * invoiceAdjustmentKoef)cr
	        // priceWithoutVat = basePriceWithAdjustment + invoiceAdjustmentAmount
	        // vatAmount = (sum(item.vatAmount))cr
	        // totalPrice = priceWithoutVat + vatAmount
	        // Prejmenovani na Invoice:
	        //
	        //   totalAdjustmentAmount -> itemAdjustmentAmount
	        // totalAdjustmentAmountLcy -> itemAdjustmentAmountLcy
	        // totalAdjustmentKoef -> itemAdjustmentKoef
	        var basePrice = invoiceEntity.getField('basePrice'), itemAdjustmentAmount = invoiceEntity.getField('itemAdjustmentAmount'), // Sum (invoiceItem.adjustmentAmount)
	        itemAdjustmentKoef = invoiceEntity.getField('itemAdjustmentKoef'), // itemAdjustmentAmount / basePrice
	        basePriceWithAdjustment = invoiceEntity.getField('basePriceWithAdjustment'), // basePrice + itemAdjustmentAmount
	        invoiceAdjustmentKoef = invoiceEntity.getField('invoiceAdjustmentKoef'), // zadano
	        invoiceAdjustmentAmount = invoiceEntity.getField('invoiceAdjustmentAmount'), // (basePriceWithAdjustment * invoiceAdjustmentKoef)cr
	        priceWithoutVat = invoiceEntity.getField('priceWithoutVat'), vatAmount = invoiceEntity.getField('vatAmount'), totalPrice = invoiceEntity.getField('totalPrice'), // sum (invoiceItem.itemPrice)
	        pennyAdjustment = invoiceEntity.getField('pennyAdjustment'), totalAdjustedPrice = invoiceEntity.getField('totalAdjustedPrice'), invoiceCurrencyLabel = (0, formUtils_1.lovLabel)(invoiceObject.invoiceCurrency), invoiceCurrencyValue = (0, formUtils_1.lovValue)(invoiceObject.invoiceCurrency), localCurrencyLabel = (0, formUtils_1.lovLabel)(invoiceObject.localCurrency), localCurrencyValue = (0, formUtils_1.lovValue)(invoiceObject.localCurrency);
	        var vatRecapEntries = (invoiceObject.vatRecap) ? invoiceObject.vatRecap.entries() : null;
	        invoiceObject.monetaryRounding;
	        var unpaidPrice = ((0, formUtils_1.lovValue)(invoiceObject.invoiceType) == invoiceDomain_1.INVOICE_TYPE.CN) ? 0 : invoiceObject.totalAdjustedPrice - invoiceObject.paidAmount;
	        var unpaidPriceLcy = (invoiceObject.totalAdjustedPrice && invoiceCurrencyValue !== localCurrencyValue) ? (0, numberUtils_1.roundTo)(unpaidPrice * (invoiceObject.totalAdjustedPriceLcy / invoiceObject.totalAdjustedPrice), 2) : null;
	        return (react_1.default.createElement("table", { className: "invoice-sum-table", style: style },
	            react_1.default.createElement("thead", null,
	                react_1.default.createElement("tr", null,
	                    react_1.default.createElement("th", { style: { backgroundColor: colors_1.grey300 } }),
	                    (invoiceObject.itemAdjustmentAmount || invoiceObject.invoiceAdjustmentAmount) ? react_1.default.createElement("th", null, basePrice.gridHeaderLabelActive) : null,
	                    (invoiceObject.itemAdjustmentAmount) ? react_1.default.createElement("th", null, itemAdjustmentAmount.gridHeaderLabelActive) : null,
	                    (invoiceObject.invoiceAdjustmentAmount) ? react_1.default.createElement("th", null, invoiceAdjustmentAmount.gridHeaderLabelActive) : null,
	                    react_1.default.createElement("th", null, priceWithoutVat.gridHeaderLabelActive),
	                    react_1.default.createElement("th", null, vatAmount.gridHeaderLabelActive),
	                    react_1.default.createElement("th", null, totalPrice.gridHeaderLabelActive),
	                    (invoiceObject.pennyAdjustment || invoiceObject.pennyAdjustmentLcy) ? react_1.default.createElement("th", null, pennyAdjustment.gridHeaderLabelActive) : null,
	                    (invoiceObject.pennyAdjustment || invoiceObject.pennyAdjustmentLcy) ? react_1.default.createElement("th", null, totalAdjustedPrice.gridHeaderLabelActive) : null,
	                    (unpaidPrice || unpaidPriceLcy) ? react_1.default.createElement("th", null, "Unsettled") : null)),
	            react_1.default.createElement("tbody", null,
	                react_1.default.createElement("tr", null,
	                    react_1.default.createElement("td", null, invoiceCurrencyLabel),
	                    (invoiceObject.itemAdjustmentAmount || invoiceObject.invoiceAdjustmentAmount) ? react_1.default.createElement("td", null, basePrice.formatValue(invoiceObject.basePrice)) : null,
	                    (invoiceObject.itemAdjustmentAmount) ? react_1.default.createElement("td", null,
	                        " ",
	                        react_1.default.createElement("div", null, itemAdjustmentAmount.formatValue(invoiceObject.itemAdjustmentAmount)),
	                        react_1.default.createElement("div", { style: { fontSize: 10 } }, itemAdjustmentKoef.formatValue(invoiceObject.itemAdjustmentKoef)),
	                        "  ") : null,
	                    (invoiceObject.invoiceAdjustmentAmount) ? react_1.default.createElement("td", null, invoiceAdjustmentAmount.formatValue(invoiceObject.invoiceAdjustmentAmount)) : null,
	                    react_1.default.createElement("td", null, priceWithoutVat.formatValue(invoiceObject.priceWithoutVat)),
	                    react_1.default.createElement("td", null, vatAmount.formatValue(invoiceObject.vatAmount)),
	                    react_1.default.createElement("td", { className: (0, domUtils_1.classNames)({ 'color-green-500': !unpaidPrice && !invoiceObject.pennyAdjustment }, { "invoice-sum-table--big": !minimal }) }, (0, arrayUtils_1.joinNonNull)([totalPrice.formatValue(invoiceObject.totalPrice), invoiceCurrencyLabel], ' ')),
	                    (invoiceObject.pennyAdjustment || invoiceObject.pennyAdjustmentLcy) ? react_1.default.createElement("td", null, pennyAdjustment.formatValue(invoiceObject.pennyAdjustment)) : null,
	                    (invoiceObject.pennyAdjustment || invoiceObject.pennyAdjustmentLcy) ? react_1.default.createElement("td", { className: (0, domUtils_1.classNames)({ 'color-green-500': !unpaidPrice }, { "invoice-sum-table--big": !minimal }) }, totalAdjustedPrice.formatValue(invoiceObject.totalAdjustedPrice) + ' ' + invoiceCurrencyLabel) : null,
	                    (unpaidPrice) ? react_1.default.createElement("td", { className: (0, domUtils_1.classNames)("color-red-500", { "invoice-sum-table--big": !minimal }) }, totalAdjustedPrice.formatValue(unpaidPrice) + ' ' + invoiceCurrencyLabel) : null),
	                (invoiceCurrencyValue !== localCurrencyValue) ? (react_1.default.createElement("tr", null,
	                    react_1.default.createElement("td", null, localCurrencyLabel),
	                    (invoiceObject.itemAdjustmentAmountLcy || invoiceObject.invoiceAdjustmentAmountLcy) ? react_1.default.createElement("td", null, basePrice.formatValue(invoiceObject.basePriceLcy)) : null,
	                    (invoiceObject.itemAdjustmentAmountLcy) ? react_1.default.createElement("td", null,
	                        " ",
	                        react_1.default.createElement("div", null, itemAdjustmentAmount.formatValue(invoiceObject.itemAdjustmentAmountLcy)),
	                        react_1.default.createElement("div", { style: { fontSize: 10 } }, itemAdjustmentKoef.formatValue(invoiceObject.itemAdjustmentKoef)),
	                        "  ") : null,
	                    (invoiceObject.invoiceAdjustmentAmountLcy) ? react_1.default.createElement("td", null, invoiceAdjustmentAmount.formatValue(invoiceObject.invoiceAdjustmentAmountLcy)) : null,
	                    react_1.default.createElement("td", null, priceWithoutVat.formatValue(invoiceObject.priceWithoutVatLcy)),
	                    react_1.default.createElement("td", null, vatAmount.formatValue(invoiceObject.vatAmountLcy)),
	                    react_1.default.createElement("td", { className: (0, domUtils_1.classNames)({ 'color-green-500': !unpaidPriceLcy && !invoiceObject.pennyAdjustmentLcy }, { "invoice-sum-table--big": !minimal }) }, (0, arrayUtils_1.joinNonNull)([totalPrice.formatValue(invoiceObject.totalPriceLcy), localCurrencyLabel], ' ')),
	                    (invoiceObject.pennyAdjustment || invoiceObject.pennyAdjustmentLcy) ? react_1.default.createElement("td", null, pennyAdjustment.formatValue(invoiceObject.pennyAdjustmentLcy)) : null,
	                    (invoiceObject.pennyAdjustment || invoiceObject.pennyAdjustmentLcy) ? react_1.default.createElement("td", { className: (0, domUtils_1.classNames)({ 'color-green-500': !unpaidPriceLcy }, { "invoice-sum-table--big": !minimal }) }, totalAdjustedPrice.formatValue(invoiceObject.totalAdjustedPriceLcy) + ' ' + localCurrencyLabel) : null,
	                    (unpaidPriceLcy) ? react_1.default.createElement("td", { className: (0, domUtils_1.classNames)("color-red-500", { "invoice-sum-table--big": !minimal }) }, totalAdjustedPrice.formatValue(unpaidPriceLcy) + ' ' + localCurrencyLabel) : null)) : null,
	                (vatRecapEntries && vatRecapEntries.length) ? react_1.default.createElement("tr", null,
	                    react_1.default.createElement("td", { colSpan: 9, style: { textAlign: 'left', borderLeft: '0', borderRight: '0' } }, 'VAT Recapitulation')) : null,
	                (vatRecapEntries && vatRecapEntries.length) ? (vatRecapEntries.map(function (pair) { return (react_1.default.createElement("tr", { key: pair[0] },
	                    react_1.default.createElement("td", null, itemAdjustmentKoef.formatValue(pair[0])),
	                    (invoiceObject.itemAdjustmentAmount || invoiceObject.invoiceAdjustmentAmount) ? react_1.default.createElement("td", null) : null,
	                    (invoiceObject.itemAdjustmentKoef) ? react_1.default.createElement("td", null) : null,
	                    (invoiceObject.itemAdjustmentAmount) ? react_1.default.createElement("td", null) : null,
	                    (invoiceObject.itemAdjustmentAmount) ? react_1.default.createElement("td", null) : null,
	                    (invoiceObject.invoiceAdjustmentKoef) ? react_1.default.createElement("td", null) : null,
	                    (invoiceObject.invoiceAdjustmentAmount) ? react_1.default.createElement("td", null) : null,
	                    react_1.default.createElement("td", null, priceWithoutVat.formatValue(pair[1].basisLcy)),
	                    react_1.default.createElement("td", null, vatAmount.formatValue(pair[1].amountLcy) + ' ' + localCurrencyLabel))); })) : null)));
	    };
	    InvoiceSumTable = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], InvoiceSumTable);
	    return InvoiceSumTable;
	}(react_1.default.Component));
	exports.default = InvoiceSumTable;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EntityNumberGenGroup = exports.EntityNumberGen = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var EntityNumberGen = /** @class */ (function (_super) {
	    tslib_1.__extends(EntityNumberGen, _super);
	    function EntityNumberGen(json) {
	        return _super.call(this, json) || this;
	    }
	    EntityNumberGen.prototype.getId = function () {
	        return this.entityNumberGenId;
	    };
	    EntityNumberGen.prototype.setId = function (id) {
	        this.entityNumberGenId = id;
	    };
	    EntityNumberGen.prototype.getNumberLength = function () {
	        return this.prefixConstant.length + this.padding;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityNumberGen.prototype, "entityNumberGenId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityNumberGen.prototype, "group", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityNumberGen.prototype, "validFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityNumberGen.prototype, "validTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityNumberGen.prototype, "prefixConstant", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityNumberGen.prototype, "padding", void 0);
	    EntityNumberGen = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], EntityNumberGen);
	    return EntityNumberGen;
	}(DomainAncestor_1.DomainAncestor));
	exports.EntityNumberGen = EntityNumberGen;
	var EntityNumberGenGroup = /** @class */ (function (_super) {
	    tslib_1.__extends(EntityNumberGenGroup, _super);
	    function EntityNumberGenGroup(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.numberGenList)
	            _this.numberGenList = [];
	        if (!_this.invoiceTypeIds)
	            _this.invoiceTypeIds = [];
	        if (!_this.profitCenterIds)
	            _this.profitCenterIds = [];
	        return _this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityNumberGenGroup.prototype, "entityNumberGenGroupId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityNumberGenGroup.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityNumberGenGroup.prototype, "entityName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityNumberGenGroup.prototype, "party", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityNumberGenGroup.prototype, "invoiceTypeIds", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityNumberGenGroup.prototype, "profitCenterIds", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(EntityNumberGen)
	    ], EntityNumberGenGroup.prototype, "numberGenList", void 0);
	    EntityNumberGenGroup = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], EntityNumberGenGroup);
	    return EntityNumberGenGroup;
	}(DomainAncestor_1.DomainAncestor));
	exports.EntityNumberGenGroup = EntityNumberGenGroup;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mobx_1 = __webpack_require__(5);
	var entityNumberGenDomain_1 = __webpack_require__(946);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var EntityNumberGenService = /** @class */ (function () {
	    function EntityNumberGenService() {
	    }
	    EntityNumberGenService.prototype.readEntityNumberGenGroup = function (genGroupId) {
	        return axios_config_1.default.get("/entity-number-gen/group/".concat(genGroupId))
	            .then(function (response) { return new entityNumberGenDomain_1.EntityNumberGenGroup(response.data); });
	    };
	    EntityNumberGenService.prototype.deleteGenGroup = function (genGroupId) {
	        return axios_config_1.default.delete("/entity-number-gen/group/".concat(genGroupId), { showPrettyError: true });
	    };
	    EntityNumberGenService.prototype.saveGenGroup = function (entityGenGroup) {
	        return axios_config_1.default.post("/entity-number-gen/group", entityGenGroup, { showPrettyError: true })
	            .then(function (res) { return res.data; });
	    };
	    EntityNumberGenService.prototype.checkIfEntityNumberGenPrefixExist = function (prefixConstant) {
	        return axios_config_1.default.get("/entity-number-gen/exist?prefixConstant=".concat(prefixConstant), { showPrettyError: true })
	            .then(function (res) { return res.data; });
	    };
	    EntityNumberGenService.prototype.checkSameGenNumberPossibility = function (prefixConstant, padding) {
	        return axios_config_1.default.get("/entity-number-gen/generation-possibility?prefixConstant=".concat(prefixConstant, "&padding=").concat(padding), { showPrettyError: true })
	            .then(function (res) { return res.data; });
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityNumberGenService.prototype, "entityGenGroupObject", void 0);
	    return EntityNumberGenService;
	}());
	exports.default = new EntityNumberGenService();


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var formUtils_1 = __webpack_require__(14);
	var errorComp_1 = __webpack_require__(34);
	var partyFoForm_1 = tslib_1.__importDefault(__webpack_require__(953));
	var partyPoForm_1 = tslib_1.__importDefault(__webpack_require__(954));
	var partyService_1 = tslib_1.__importDefault(__webpack_require__(175));
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var partyDomain_1 = __webpack_require__(48);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var dialogAncestor_1 = __webpack_require__(87);
	var partyContactList_1 = tslib_1.__importDefault(__webpack_require__(951));
	var partyAddressList_1 = tslib_1.__importDefault(__webpack_require__(950));
	var partyRoleForm_1 = tslib_1.__importDefault(__webpack_require__(955));
	var NewPartyDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(NewPartyDialog, _super);
	    function NewPartyDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.ok = function () {
	            var result = (0, formUtils_1.preSave)(_this.partyObject, null);
	            if (!result) {
	                return;
	            }
	            partyService_1.default.partySave(_this.partyObject.createDataObjectDto())
	                .then(function (partyJson) {
	                var wasNew = _this.partyObject.cleanAfterSave(partyJson);
	                _this.dialogOpen = false;
	                _this.resolve(_this.partyObject.partyLov());
	            }, function (error) {
	                _this.$errors = error.getMessages();
	            });
	        };
	        _this.cancel = function (evt) {
	            console.log('InvoiceIssueDialog#cancel evt = %O', evt);
	            _this.dialogOpen = false;
	            _this.$errors = [];
	            _this.reject("cancel");
	        };
	        _this._mainForm = function (partyObject, propsForCreateForm) {
	            return (partyObject.partyCategory === partyDomain_1.PARTYCATEGORY.PE) ? react_1.default.createElement(partyFoForm_1.default, tslib_1.__assign({}, propsForCreateForm, { open: true })) : react_1.default.createElement(partyPoForm_1.default, tslib_1.__assign({}, propsForCreateForm, { open: true }));
	        };
	        return _this;
	    }
	    NewPartyDialog.prototype.open = function (resolve, reject, partyObject) {
	        this.resolve = resolve;
	        this.reject = reject;
	        this.$errors = [];
	        this.dialogOpen = true;
	        this.partyObject = partyObject;
	    };
	    NewPartyDialog.prototype.render = function () {
	        if (!(this.partyObject && this.dialogOpen))
	            return null;
	        var actions = [
	            react_1.default.createElement(FlatButton_1.default, { label: "Cancel", primary: true, onClick: this.cancel }),
	            react_1.default.createElement(FlatButton_1.default, { label: "Save", secondary: true, onClick: this.ok })
	        ];
	        var propsForCreateForm = {
	            dataObject: this.partyObject,
	            rootObject: this.partyObject,
	            entity: mdEntityService_1.default.getEntity('Party'),
	            entities: mdEntityService_1.default.entityMap
	        };
	        var partyTypeName = (this.partyObject.roles.length > 0) ? (0, formUtils_1.lovLabel)(this.partyObject.roles[0].roleType) : "Party";
	        return (react_1.default.createElement(Dialog_1.default, { title: "Create new ".concat(partyTypeName), actions: actions, modal: true, open: this.dialogOpen, autoScrollBodyContent: true, contentStyle: { position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', filter: 'blur(0)' } },
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: this.$errors }),
	            this._mainForm(this.partyObject, propsForCreateForm),
	            react_1.default.createElement(partyRoleForm_1.default, { dataObject: this.partyObject, rootObject: this.partyObject, entity: mdEntityService_1.default.getEntity("PartyRole"), entities: mdEntityService_1.default.entityMap }),
	            react_1.default.createElement(partyAddressList_1.default, { partyObject: this.partyObject, entities: mdEntityService_1.default.entityMap }),
	            react_1.default.createElement(partyContactList_1.default, { partyObject: this.partyObject, rootObject: this.partyObject, entities: mdEntityService_1.default.entityMap })));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], NewPartyDialog.prototype, "partyObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], NewPartyDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], NewPartyDialog.prototype, "ok", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], NewPartyDialog.prototype, "cancel", void 0);
	    NewPartyDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], NewPartyDialog);
	    return NewPartyDialog;
	}(dialogAncestor_1.DialogAncestor));
	exports.default = NewPartyDialog;


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PartyActiveComp = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var colors_1 = __webpack_require__(29);
	var IconButton_1 = tslib_1.__importDefault(__webpack_require__(126));
	var IconMenu_1 = tslib_1.__importDefault(__webpack_require__(357));
	var MenuItem_1 = tslib_1.__importDefault(__webpack_require__(101));
	var eventService_1 = tslib_1.__importDefault(__webpack_require__(120));
	var mobx_1 = __webpack_require__(5);
	var partyDomain_1 = __webpack_require__(48);
	var Avatar_1 = tslib_1.__importDefault(__webpack_require__(356));
	var mobx_react_1 = __webpack_require__(4);
	var navigation_arrow_drop_right_1 = tslib_1.__importDefault(__webpack_require__(1604));
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var __anchorOrigin = { horizontal: 'left', vertical: 'top' };
	var iconButton__style = { width: 32, height: 32, padding: "0 8px 0 0" };
	var PartyActiveComp = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyActiveComp, _super);
	    function PartyActiveComp() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onClose = function () {
	            var _a = _this.props, partyObject = _a.partyObject, entity = _a.entity;
	            console.log('onClose');
	            ((partyObject.$new) ? Promise.resolve({
	                active: false,
	                closeDate: (0, moment_1.default)().startOf("day").toDate()
	            }) : eventService_1.default.closeObject(entity, partyObject.partyId))
	                .then((0, mobx_1.action)("onClose-handler", function (data) {
	                partyObject.active = data.active;
	                partyObject.closeDate = data.closeDate;
	            }))
	                .catch(function (error) {
	                var response = error.response;
	                if (response && response.status === 400) {
	                    return new Promise(function (resolve, reject) {
	                        console.log(error.getMessages());
	                        return _this.forceCloseConfirmationRef.open(resolve, reject, error.getMessagesString());
	                    }).then(function () {
	                        return eventService_1.default.closeObject(entity, partyObject.partyId, true);
	                    }).then(function (data) {
	                        partyObject.active = data.active;
	                        partyObject.closeDate = data.closeDate;
	                    }).catch(function (e) {
	                    });
	                }
	                partyObject.$errors = error.getMessages();
	            });
	        };
	        _this.onOpen = function () {
	            var _a = _this.props, partyObject = _a.partyObject, entity = _a.entity;
	            console.log('onOpen');
	            ((partyObject.$new) ? Promise.resolve({ active: true }) : eventService_1.default.openObject(entity, partyObject.partyId))
	                .then((0, mobx_1.action)("onOpen-handler", function (data) {
	                partyObject.active = data.active;
	                partyObject.closeDate = data.closeDate;
	            }));
	        };
	        _this.onPE = function () {
	            var partyObject = _this.props.partyObject;
	            partyObject.partyCategory = partyDomain_1.PARTYCATEGORY.PE;
	            partyObject.$dirty = true;
	        };
	        _this.onCO = function () {
	            var partyObject = _this.props.partyObject;
	            partyObject.partyCategory = partyDomain_1.PARTYCATEGORY.CO;
	            partyObject.$dirty = true;
	        };
	        _this.onEN = function () {
	            var partyObject = _this.props.partyObject;
	            partyObject.partyCategory = partyDomain_1.PARTYCATEGORY.EN;
	            partyObject.$dirty = true;
	        };
	        _this.forceCloseConfirmationRefHandler = function (comp) { return _this.forceCloseConfirmationRef = comp; };
	        return _this;
	    }
	    PartyActiveComp.prototype.render = function () {
	        var _a = this.props, partyObject = _a.partyObject, partyCategoryEntity = _a.partyCategoryEntity, other = tslib_1.__rest(_a, ["partyObject", "partyCategoryEntity"]);
	        var iconButtonElement = (react_1.default.createElement(IconButton_1.default, { style: iconButton__style },
	            react_1.default.createElement(Avatar_1.default, { color: colors_1.white, backgroundColor: partyObject.active ? colors_1.green500 : colors_1.grey500, size: 20 }, partyObject.partyCategory.substr(0, 1))));
	        var menuItems = [];
	        switch (partyObject.partyCategory) {
	            case partyDomain_1.PARTYCATEGORY.CO:
	                menuItems.push(react_1.default.createElement(MenuItem_1.default, { primaryText: partyCategoryEntity.getLovItemLabel(partyDomain_1.PARTYCATEGORY.PE), onClick: this.onPE }));
	                menuItems.push(react_1.default.createElement(MenuItem_1.default, { primaryText: partyCategoryEntity.getLovItemLabel(partyDomain_1.PARTYCATEGORY.EN), onClick: this.onEN }));
	                break;
	            case partyDomain_1.PARTYCATEGORY.PE:
	                menuItems.push(react_1.default.createElement(MenuItem_1.default, { primaryText: partyCategoryEntity.getLovItemLabel(partyDomain_1.PARTYCATEGORY.CO), onClick: this.onCO }));
	                menuItems.push(react_1.default.createElement(MenuItem_1.default, { primaryText: partyCategoryEntity.getLovItemLabel(partyDomain_1.PARTYCATEGORY.EN), onClick: this.onEN }));
	                break;
	            case partyDomain_1.PARTYCATEGORY.EN:
	                menuItems.push(react_1.default.createElement(MenuItem_1.default, { primaryText: partyCategoryEntity.getLovItemLabel(partyDomain_1.PARTYCATEGORY.PE), onClick: this.onPE }));
	                menuItems.push(react_1.default.createElement(MenuItem_1.default, { primaryText: partyCategoryEntity.getLovItemLabel(partyDomain_1.PARTYCATEGORY.CO), onClick: this.onCO }));
	                break;
	        }
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.forceCloseConfirmationRefHandler, cancelButtonText: "Cancel", okButtonText: "Ok" }),
	            react_1.default.createElement(IconMenu_1.default, { iconButtonElement: iconButtonElement, anchorOrigin: __anchorOrigin, targetOrigin: __anchorOrigin },
	                (partyObject.active) ? react_1.default.createElement(MenuItem_1.default, { primaryText: "Close", onClick: this.onClose }) : react_1.default.createElement(MenuItem_1.default, { primaryText: "Open", onClick: this.onOpen }),
	                react_1.default.createElement(MenuItem_1.default, { primaryText: "Change Category", rightIcon: react_1.default.createElement(navigation_arrow_drop_right_1.default, null), menuItems: menuItems }))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyActiveComp.prototype, "onClose", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyActiveComp.prototype, "onOpen", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyActiveComp.prototype, "onPE", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyActiveComp.prototype, "onCO", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyActiveComp.prototype, "onEN", void 0);
	    PartyActiveComp = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], PartyActiveComp);
	    return PartyActiveComp;
	}(react_1.default.Component));
	exports.PartyActiveComp = PartyActiveComp;


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pull = __webpack_require__(117);
	var FontIcon_1 = tslib_1.__importDefault(__webpack_require__(164));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var blockComp_1 = __webpack_require__(30);
	var icons_1 = __webpack_require__(63);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var arrayUtils_1 = __webpack_require__(78);
	var blockComp_2 = __webpack_require__(30);
	var mobx_react_1 = __webpack_require__(4);
	var partyDomain_1 = __webpack_require__(48);
	var mobx_1 = __webpack_require__(5);
	var formUtils_1 = __webpack_require__(14);
	var partyService_1 = tslib_1.__importDefault(__webpack_require__(175));
	var variables_1 = __webpack_require__(96);
	var Colors = tslib_1.__importStar(__webpack_require__(29));
	var commonDataService_1 = __webpack_require__(41);
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var PartyAddressList = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyAddressList, _super);
	    function PartyAddressList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.addAddress = function () {
	            console.debug('addAddress');
	            var _a = _this.props, partyObject = _a.partyObject, entities = _a.entities;
	            var newAddress = new partyDomain_1.Address({ $new: true, $added: true }).initDefaultValues();
	            partyObject.addresses.push(newAddress);
	            partyObject.$dirty = true;
	        };
	        return _this;
	    }
	    PartyAddressList.prototype.render = function () {
	        var _a = this.props, partyObject = _a.partyObject, entities = _a.entities;
	        var header = (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
	            react_1.default.createElement("div", null, "Addresses"),
	            react_1.default.createElement(icons_1.MdIconButton, { onClick: this.addAddress },
	                react_1.default.createElement(add_1.default, null))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { header: header, noPadding: true, style: { display: 'flex', flexDirection: 'column' } }, (0, arrayUtils_1.addSeparator)(partyObject.addresses.map(function (address, index) { return react_1.default.createElement(AddressForm, { dataObject: address, rootObject: partyObject, key: index, entities: entities, entity: entities.get('Address'), index: index }); }), react_1.default.createElement(blockComp_2.MdDivider, { inset: true }))));
	    };
	    PartyAddressList.contextTypes = {
	        router: prop_types_1.default.func.isRequired,
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyAddressList.prototype, "addAddress", void 0);
	    PartyAddressList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], PartyAddressList);
	    return PartyAddressList;
	}(react_1.default.Component));
	exports.default = PartyAddressList;
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, openMap = _a.openMap;
	    var fontIconStyle = { fontSize: 16 };
	    var otherPar = {};
	    if (dataObject.placeId) {
	        fontIconStyle.fontWeight = "bold";
	        fontIconStyle.cursor = "pointer";
	        otherPar.onClick = openMap;
	    }
	    return (react_1.default.createElement("div", { style: { display: 'flex', fontSize: 14, lineHeight: '14px' } },
	        react_1.default.createElement(FontIcon_1.default, tslib_1.__assign({ className: "fa fa-envelope-o", color: !dataObject.active ? '#666' : (dataObject.addressType) ? Colors[dataObject.addressType["color"]] : null, style: fontIconStyle }, otherPar)),
	        react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', marginLeft: 20 }, className: !dataObject.active ? "text-thru" : "" },
	            (dataObject.name) ? react_1.default.createElement("div", null, dataObject.name) : '',
	            react_1.default.createElement("div", { style: (dataObject.name) ? { marginTop: 5 } : {} }, dataObject.addressLine()),
	            (dataObject.toHands || dataObject.comment) ? (react_1.default.createElement("div", { style: { fontSize: 12, color: Colors.grey500, marginTop: 2 } }, [((dataObject.toHands) ? ('To hands: ' + dataObject.toHands) : ''), dataObject.comment].filter(function (v) { return v; }).join(', '))) : '',
	            react_1.default.createElement("div", { className: "form-text-row" },
	                react_1.default.createElement(formUtils_1.FieldText, { label: fields.ftlEscalationMinutes.textLabel, value: dataObject.ftlEscalationMinutes, style: { marginTop: '10px' } }),
	                react_1.default.createElement(formUtils_1.FieldText, { label: fields.ltlEscalationMinutes.textLabel, value: dataObject.ltlEscalationMinutes, style: { marginTop: '10px' } })),
	            react_1.default.createElement("div", { className: "form-text-row" },
	                react_1.default.createElement(formUtils_1.FieldText, { label: fields.defaultDisponentParty.textLabel, value: dataObject.defaultDisponentParty, style: { marginTop: '10px' } })))));
	};
	var AddressForm = /** @class */ (function (_super) {
	    tslib_1.__extends(AddressForm, _super);
	    function AddressForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDelete = function (evt) {
	            evt.stopPropagation();
	            console.log('onDelete %o', _this.props.dataObject);
	            pull(_this.props.rootObject.addresses, _this.props.dataObject);
	        };
	        _this.updateFromRegister = function (evt) {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('updateFromRegister');
	            partyService_1.default.partyVatIdDownload({ vatId: rootObject.dic, nationality: (0, formUtils_1.lovValue)(rootObject.nationality), language: (0, formUtils_1.lovValue)(rootObject.defaultLanguage) })
	                .then((0, mobx_1.action)("partyVatIdDownload-actionCb", function (json) {
	                if (json) {
	                    dataObject.cleanAfterSave(json, true, "addressId", "comment", "party");
	                    form.updateAllFieldsPropValue(dataObject);
	                    dataObject.$dirty = true;
	                    rootObject.$dirty = true;
	                }
	            }));
	        };
	        _this.reparse = function (evt) {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('reparse');
	            var nationality = (0, formUtils_1.lovValue)(dataObject.country);
	            nationality = (nationality) ? nationality : (0, formUtils_1.lovValue)(rootObject.nationality);
	            partyService_1.default.addressParse({ addressLine: dataObject.addressLine(), nationality: nationality, language: (0, formUtils_1.lovValue)(rootObject.defaultLanguage) })
	                .then((0, mobx_1.action)("addressParse-actionCb", function (json) {
	                if (json) {
	                    dataObject.cleanAfterSave(json, true, "addressId", "comment", "name", "party", "addressType");
	                    form.updateAllFieldsPropValue(dataObject);
	                    dataObject.$dirty = true;
	                    rootObject.$dirty = true;
	                }
	            }));
	        };
	        _this.openMap = function (evt) {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('openMap');
	            _this.showMap = !_this.showMap;
	        };
	        return _this;
	    }
	    AddressForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, index = _a.index, entities = _a.entities, entity = _a.entity, formName = _a.formName;
	        var fields = dataObject.getFormFields(formName);
	        var addressType = fields.addressType, name = fields.name, street = fields.street, toHands = fields.toHands, descriptiveNumber = fields.descriptiveNumber, orientationalNumber = fields.orientationalNumber, city = fields.city, zip = fields.zip, comment = fields.comment, country = fields.country, administrativeArea = fields.administrativeArea, ftlEscalationMinutes = fields.ftlEscalationMinutes, ltlEscalationMinutes = fields.ltlEscalationMinutes, defaultDisponentParty = fields.defaultDisponentParty, active = fields.active;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, addressType.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: addressType, value: addressType.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, toHands.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, street.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: street, value: street.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-2" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, descriptiveNumber.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-2" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, orientationalNumber.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-2" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, city.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: city, value: city.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-2" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, zip.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: zip, value: zip.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, country.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, administrativeArea.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-5" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, ftlEscalationMinutes.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: ftlEscalationMinutes, value: ftlEscalationMinutes.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, ltlEscalationMinutes.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: ltlEscalationMinutes, value: ltlEscalationMinutes.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-10" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, defaultDisponentParty.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.CONTACT_ROLE], disponent: true }), clearable: true })),
	                    react_1.default.createElement(validate_1.Validate, { field: defaultDisponentParty, value: defaultDisponentParty.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-2" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, active.props, { style: { alignSelf: 'center' } })),
	                    react_1.default.createElement(validate_1.Validate, { field: active, value: active.props.value })))));
	        var openButtons = (react_1.default.createElement("div", null,
	            ((0, formUtils_1.lovValue)(dataObject.addressType) === partyDomain_1.ADDRESSTYPE.PERMANENT && rootObject.dic) ? react_1.default.createElement(FlatButton_1.default, { label: "Update from EU register", primary: true, onClick: this.updateFromRegister }) : null,
	            react_1.default.createElement(FlatButton_1.default, { label: "Reparse", primary: true, onClick: this.reparse })));
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields, openMap: this.openMap }), key: index, onDelete: this.onDelete, validate: this.props.validate, openButtons: openButtons }, this.props)),
	            (this.showMap) ? (react_1.default.createElement("iframe", { width: "100%", height: "450", frameBorder: "0", style: { border: 0, paddingLeft: 20, paddingRight: 20 }, src: "https://www.google.com/maps/embed/v1/place?key=".concat(variables_1.GOOGLE_API_KEY, "&q=place_id:").concat(dataObject.placeId), allowFullScreen: true })) : null));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], AddressForm.prototype, "showMap", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], AddressForm.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], AddressForm.prototype, "updateFromRegister", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], AddressForm.prototype, "reparse", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], AddressForm.prototype, "openMap", void 0);
	    AddressForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'AddressForm',
	            fields: [{
	                    name: 'addressType',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'name'
	                }, {
	                    name: 'toHands'
	                }, {
	                    name: 'street'
	                }, {
	                    name: 'descriptiveNumber'
	                }, {
	                    name: 'orientationalNumber'
	                }, {
	                    name: 'city',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'administrativeArea'
	                }, {
	                    name: 'zip'
	                }, {
	                    name: 'country'
	                }, {
	                    name: 'comment'
	                }, {
	                    name: 'ftlEscalationMinutes',
	                    validators: ['IsNumber', { validation: 'Max', parameters: { max: 999 } }, { validation: 'Min', parameters: { min: 1 } }]
	                }, {
	                    name: 'ltlEscalationMinutes',
	                    validators: ['IsNumber', { validation: 'Max', parameters: { max: 999 } }, { validation: 'Min', parameters: { min: 1 } }]
	                }, {
	                    name: 'defaultDisponentParty'
	                }, {
	                    name: 'active'
	                }]
	        }, ClosedContent),
	        mobx_react_1.observer
	    ], AddressForm);
	    return AddressForm;
	}(react_1.default.Component));


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pull = __webpack_require__(117);
	var FontIcon_1 = tslib_1.__importDefault(__webpack_require__(164));
	var fields_1 = __webpack_require__(20);
	var formUtils_1 = __webpack_require__(14);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var blockComp_1 = __webpack_require__(30);
	var icons_1 = __webpack_require__(63);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var arrayUtils_1 = __webpack_require__(78);
	var blockComp_2 = __webpack_require__(30);
	var partyDomain_1 = __webpack_require__(48);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var colors_1 = __webpack_require__(29);
	var rules_1 = __webpack_require__(56);
	var partyService_1 = tslib_1.__importDefault(__webpack_require__(175));
	var react_qr_svg_1 = __webpack_require__(1844);
	var ViberUserCheck = function (_a) {
	    var value = _a.value;
	    if (!value)
	        return (0, rules_1.valid)();
	    return partyService_1.default.viberUserCheck({ id: value })
	        .then(function (exists) { return (exists === true) ? (0, rules_1.valid)() : (0, rules_1.invalid)("User not found"); });
	};
	var PartyContactList = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyContactList, _super);
	    function PartyContactList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.addContact = function () {
	            console.debug('addContact');
	            var _a = _this.props, partyObject = _a.partyObject, rootObject = _a.rootObject, entities = _a.entities;
	            var newContact = new partyDomain_1.PartyContact({ $new: true, $added: true }).initDefaultValues();
	            partyObject.contacts.push(newContact);
	            rootObject.$dirty = true;
	        };
	        return _this;
	    }
	    PartyContactList.prototype.render = function () {
	        var _a = this.props, partyObject = _a.partyObject, entities = _a.entities, rootObject = _a.rootObject;
	        var header = (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
	            react_1.default.createElement("div", null, "Contacts"),
	            react_1.default.createElement(icons_1.MdIconButton, { onClick: this.addContact },
	                react_1.default.createElement(add_1.default, null))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { header: header, noPadding: true, style: { display: 'flex', flexDirection: 'column' } }, (0, arrayUtils_1.addSeparator)(partyObject.contacts.map(function (contact, index) { return react_1.default.createElement(PartyContactForm, { dataObject: contact, rootObject: partyObject, key: index, entities: entities, entity: entities.get('PartyContact'), index: index }); }), react_1.default.createElement(blockComp_2.MdDivider, { inset: true }))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyContactList.prototype, "addContact", void 0);
	    PartyContactList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], PartyContactList);
	    return PartyContactList;
	}(react_1.default.Component));
	exports.default = PartyContactList;
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields;
	    var PARTYCONTACTCATEGORY = entities.get('PARTYCONTACTCATEGORY');
	    var catLov = (dataObject.contactType) ? PARTYCONTACTCATEGORY.getLovItem(dataObject.contactType.category) : null;
	    return (react_1.default.createElement("div", { style: { display: 'flex', fontSize: 14, lineHeight: '14px' } },
	        react_1.default.createElement(FontIcon_1.default, { className: (catLov) ? catLov["icon"] : '', color: colors_1.indigo500, style: { fontSize: 16 } }),
	        react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', marginLeft: 20, wordBreak: 'break-all' } },
	            react_1.default.createElement("div", null, dataObject.value),
	            react_1.default.createElement("div", { style: { fontSize: 12, color: colors_1.grey500, marginTop: 2 } }, (0, formUtils_1.lovLabel)(dataObject.contactType)),
	            (dataObject.comment) ? (react_1.default.createElement("div", { style: { fontSize: 12, color: colors_1.grey500, marginTop: 2 } }, dataObject.comment)) : '')));
	};
	var PartyContactForm = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyContactForm, _super);
	    function PartyContactForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDelete = function (evt) {
	            evt.stopPropagation();
	            console.log('onDelete %o', _this.props.dataObject);
	            pull(_this.props.rootObject.contacts, _this.props.dataObject);
	        };
	        _this.fetchViberBotUrl = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
	            var dataObject, _a;
	            return tslib_1.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        dataObject = this.props.dataObject;
	                        if (!(!this.viberBotUrl && !!dataObject.contactType && dataObject.contactType.label == "viber")) return [3 /*break*/, 2];
	                        _a = this;
	                        return [4 /*yield*/, partyService_1.default.getViberBotUrl()];
	                    case 1:
	                        _a.viberBotUrl = _b.sent();
	                        _b.label = 2;
	                    case 2: return [2 /*return*/];
	                }
	            });
	        }); };
	        _this.componentDidMount = _this.fetchViberBotUrl;
	        _this.componentDidUpdate = _this.fetchViberBotUrl;
	        return _this;
	    }
	    PartyContactForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, entity = _a.entity, formName = _a.formName, rootObject = _a.rootObject, index = _a.index, entities = _a.entities;
	        var fields = dataObject.getFormFields(formName);
	        var value = fields.value, comment = fields.comment, contactType = fields.contactType;
	        var isViberContact = !!dataObject.contactType && dataObject.contactType.label == "viber";
	        var openContent = (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
	            react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'row' } },
	                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, value.props)),
	                react_1.default.createElement(validate_1.Validate, { field: value, value: value.props.value }),
	                isViberContact &&
	                    react_1.default.createElement(validate_1.Validate, { field: value, value: value.props.value },
	                        react_1.default.createElement(ViberUserCheck, null)),
	                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, contactType.props)),
	                react_1.default.createElement(validate_1.Validate, { field: contactType, value: contactType.props.value })),
	            isViberContact &&
	                react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
	                    this.viberBotUrl &&
	                        react_1.default.createElement(react_qr_svg_1.QRCode, { level: "L", style: { marginTop: "20px" }, value: this.viberBotUrl }),
	                    react_1.default.createElement("div", { style: { marginTop: "15px" } }, "Scan this QR code to open the bot profile. Send a message to the bot and you will get back your user ID. Enter it here as the value.")),
	            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props))));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), key: index, onDelete: this.onDelete, validate: this.props.validate }, this.props)));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyContactForm.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyContactForm.prototype, "viberBotUrl", void 0);
	    PartyContactForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'PartyContactForm',
	            fields: [{
	                    name: 'value',
	                    validators: ['IsRequired'],
	                    style: { marginRight: 5 }
	                }, {
	                    name: 'comment'
	                }, {
	                    name: 'contactType',
	                    validators: ['IsRequired']
	                }]
	        }, ClosedContent),
	        mobx_react_1.observer
	    ], PartyContactForm);
	    return PartyContactForm;
	}(react_1.default.Component));


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PartyCreditSumTable = exports.PartyCreditEntryTable = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var mobx_react_1 = __webpack_require__(4);
	var dateUtils_1 = __webpack_require__(49);
	var formUtils_1 = __webpack_require__(14);
	var stringUtils_1 = __webpack_require__(174);
	var numberUtils_1 = __webpack_require__(143);
	var domUtils_1 = __webpack_require__(91);
	exports.PartyCreditEntryTable = (0, mobx_react_1.observer)(function (_a) {
	    var creditEntries = _a.creditEntries, style = _a.style;
	    return (creditEntries && creditEntries.length) ? (react_1.default.createElement("table", { className: "zz-simple-table", style: style },
	        react_1.default.createElement("thead", null,
	            react_1.default.createElement("tr", null,
	                react_1.default.createElement("th", null, "Value Date"),
	                react_1.default.createElement("th", null, "Amount"),
	                react_1.default.createElement("th", null, "PaymentType"),
	                react_1.default.createElement("th", null, "Bank Transaction"),
	                react_1.default.createElement("th", null, "Credit Note"),
	                react_1.default.createElement("th", null, "Match Type"))),
	        react_1.default.createElement("tbody", null, creditEntries.map(function (creditEntry, index) {
	            //let mdField = entity.getField(field.fieldName);
	            var moneyClass = (0, domUtils_1.classNames)({ 'color-green-500': creditEntry.amount > 0, 'color-red-500': creditEntry.amount < 0 });
	            return (react_1.default.createElement("tr", { key: index },
	                react_1.default.createElement("td", { className: moneyClass }, (0, dateUtils_1.formatDate)(creditEntry.valueDate)),
	                react_1.default.createElement("td", { className: moneyClass }, creditEntry.getFullAmount()),
	                react_1.default.createElement("td", { className: moneyClass }, (0, formUtils_1.lovLabel)(creditEntry.paymentType)),
	                react_1.default.createElement("td", { className: moneyClass }, (0, stringUtils_1.abbreviate)((0, formUtils_1.lovLabel)(creditEntry.bankTransaction), 60)),
	                react_1.default.createElement("td", { className: moneyClass }, (0, formUtils_1.lovLabel)(creditEntry.creditNote)),
	                react_1.default.createElement("td", { className: moneyClass }, (0, formUtils_1.lovLabel)(creditEntry.matchType))));
	        })))) : null;
	});
	exports.PartyCreditSumTable = (0, mobx_react_1.observer)(function (_a) {
	    var sums = _a.sums, style = _a.style;
	    return (sums && sums.length) ? (react_1.default.createElement("div", { style: { display: 'flex' } },
	        react_1.default.createElement("div", { style: { marginRight: 10, marginTop: 10 } }, "Credit sums: "),
	        react_1.default.createElement("table", { className: "zz-simple-table", style: Object.assign({ minWidth: 'unset' }, style) },
	            react_1.default.createElement("tbody", null, sums.map(function (price, index) {
	                //let mdField = entity.getField(field.fieldName);
	                var moneyClass = (0, domUtils_1.classNames)({ 'color-green-500': price.price > 0, 'color-red-500': price.price < 0 });
	                return (react_1.default.createElement("tr", { key: index },
	                    react_1.default.createElement("td", { className: moneyClass, style: { borderTop: 'unset' } }, (0, numberUtils_1.formatNumber)(price.price, numberUtils_1.DEFAULT_CURRENCY_FORMAT)),
	                    react_1.default.createElement("td", { className: moneyClass, style: { borderTop: 'unset' } }, price.currency)));
	            }))))) : null;
	});


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var blockComp_1 = __webpack_require__(30);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var statusActiveComp_1 = __webpack_require__(261);
	var partyDomain_1 = __webpack_require__(48);
	var mobx_react_1 = __webpack_require__(4);
	var partyActiveComp_1 = __webpack_require__(949);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var closedForm_1 = __webpack_require__(82);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var securityDomain_1 = __webpack_require__(97);
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", null,
	        react_1.default.createElement("div", { style: { display: 'flex' } },
	            disabled ? null : react_1.default.createElement(partyActiveComp_1.PartyActiveComp, { partyObject: dataObject, entity: entity, partyCategoryEntity: mdEntityService_1.default.getEntity("PARTYCATEGORY") }),
	            react_1.default.createElement("h5", { style: statusActiveComp_1.StatusActiveComp__h5_style },
	                " ",
	                [dataObject.titleBefore, dataObject.fullName].filter(function (v) { return v; }).join(' '),
	                " ")),
	        react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields },
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.dateOfBirth.textLabel, value: dataObject.dateOfBirth, mdField: fields.dateOfBirth.mdField }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.birthNumber.textLabel, value: dataObject.birthNumber }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.gender.textLabel, value: dataObject.gender }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.birthLastName.textLabel, value: dataObject.birthLastName }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.salutation.textLabel, value: dataObject.salutation }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.placeOfBirth.textLabel, value: dataObject.placeOfBirth }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.nationality.textLabel, value: dataObject.nationality }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.taxDomicile.textLabel, value: dataObject.taxDomicile }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.defaultProfitCenter.textLabel, value: dataObject.defaultProfitCenter }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.hrNumber.textLabel, value: dataObject.hrNumber }))));
	};
	var PartyFoForm = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyFoForm, _super);
	    function PartyFoForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PartyFoForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity, open = _a.open, formName = _a.formName;
	        var fields = dataObject.getFormFields(formName);
	        var firstName = fields.firstName, lastName = fields.lastName, titleBefore = fields.titleBefore, dateOfBirth = fields.dateOfBirth, birthNumber = fields.birthNumber, birthLastName = fields.birthLastName, salutation = fields.salutation, placeOfBirth = fields.placeOfBirth, nationality = fields.nationality, taxDomicile = fields.taxDomicile, gender = fields.gender, defaultProfitCenter = fields.defaultProfitCenter, hrNumber = fields.hrNumber;
	        var defaultProfitCenterOptions = (securityService_1.default.currentUser.hasRestriction(securityDomain_1.RESTRICTION.LIMIT_PARTY_BY_USER_PROFITCENTER)) ?
	            defaultProfitCenter.props.options.filter(function (lv) { return securityService_1.default.restrictionData.userProfitCenterIds.includes(lv.value); }) : defaultProfitCenter.props.options;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, firstName.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, lastName.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: lastName, value: lastName.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, titleBefore.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, dateOfBirth.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, birthNumber.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, gender.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, birthLastName.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, salutation.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, placeOfBirth.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, nationality.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, taxDomicile.props))),
	                (dataObject.hasRole(partyDomain_1.PARTYROLE.USER_ROLE)) ? (react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, defaultProfitCenter.props, { options: defaultProfitCenterOptions })))) : null,
	                (dataObject.hasRole(partyDomain_1.PARTYROLE.EMPLOYEE)) ? (react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, hrNumber.props)))) : null)));
	        return (open) ? openContent : (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true },
	            react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate }, this.props))));
	    };
	    PartyFoForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'PartyFoForm',
	            fields: [{
	                    name: 'firstName'
	                }, {
	                    name: 'lastName',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'titleBefore'
	                }, {
	                    name: 'dateOfBirth'
	                }, {
	                    name: 'birthNumber'
	                }, {
	                    name: 'gender'
	                }, {
	                    name: 'birthLastName'
	                }, {
	                    name: 'salutation'
	                }, {
	                    name: 'placeOfBirth'
	                }, {
	                    name: 'nationality'
	                }, {
	                    name: 'taxDomicile'
	                }, {
	                    name: 'fullName'
	                }, {
	                    name: 'defaultProfitCenter'
	                }, {
	                    name: 'hrNumber'
	                }],
	            onCommit: function (dataObject) {
	                dataObject.fullName = [dataObject.firstName, dataObject.lastName].filter(function (v) { return v; }).join(' ');
	            }
	        }, ClosedContent),
	        mobx_react_1.observer
	    ], PartyFoForm);
	    return PartyFoForm;
	}(react_1.default.Component));
	exports.default = PartyFoForm;


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var formUtils_1 = __webpack_require__(14);
	var partyService_1 = tslib_1.__importDefault(__webpack_require__(175));
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var blockComp_1 = __webpack_require__(30);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var rules_1 = __webpack_require__(56);
	var statusActiveComp_1 = __webpack_require__(261);
	var mobx_react_1 = __webpack_require__(4);
	var partyDomain_1 = __webpack_require__(48);
	var pull = __webpack_require__(117);
	var mobx_1 = __webpack_require__(5);
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var colors_1 = __webpack_require__(29);
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var partyActiveComp_1 = __webpack_require__(949);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var metaConstant_1 = __webpack_require__(13);
	var closedForm_1 = __webpack_require__(82);
	var securityDomain_1 = __webpack_require__(97);
	function PartyExist(_a) {
	    var value = _a.value, partyId = _a.partyId;
	    if (!value)
	        return (0, rules_1.valid)();
	    return partyService_1.default.partyExist({ ico: value, partyId: partyId })
	        .then(function (exists) { return (exists) ? (0, rules_1.invalid)("Customer with ICO ".concat(value, " already exists")) : (0, rules_1.valid)(); });
	}
	function PartyVatIdExist(_a) {
	    var value = _a.value, nationality = _a.nationality;
	    if (!value)
	        return (0, rules_1.valid)();
	    return partyService_1.default.partyVatIdExist({ vatId: value, nationality: nationality })
	        .then(function (exists) { return (exists === true) ? (0, rules_1.valid)() : ((exists === false) ? (0, rules_1.validWarn)("VAT ID not found in EU register") : (0, rules_1.validWarn)("EU register is down")); });
	}
	function PartyIdExist(_a) {
	    var value = _a.value;
	    if (!value)
	        return (0, rules_1.valid)();
	    return partyService_1.default.partyIdExist({ id: value })
	        .then(function (exists) { return (exists === true) ? (0, rules_1.valid)() : ((exists === false) ? (0, rules_1.validWarn)("ID not found in ARES") : (0, rules_1.validWarn)("ARES is down")); });
	}
	var SpanCheck = styled_components_1.default.span(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n  margin-left: 3px;\n"], ["\n  color: ", ";\n  margin-left: 3px;\n"])), colors_1.green500);
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", null,
	        react_1.default.createElement("div", { style: { display: 'flex' } },
	            disabled ? null : react_1.default.createElement(partyActiveComp_1.PartyActiveComp, { partyObject: dataObject, entity: entity, partyCategoryEntity: mdEntityService_1.default.getEntity("PARTYCATEGORY") }),
	            react_1.default.createElement("h5", { style: statusActiveComp_1.StatusActiveComp__h5_style },
	                " ",
	                dataObject.fullName)),
	        react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields },
	            ((0, formUtils_1.isForVatRateCountry)(partyDomain_1.COUNTRY.RO)) ? null : react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.ico.textLabel, value: dataObject.ico }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.dic.textLabel },
	                react_1.default.createElement("span", null, dataObject.dic),
	                (dataObject.vatIdCheckDate) ? react_1.default.createElement(SpanCheck, { className: "fa fa-check" }) : null),
	            ((0, formUtils_1.isForVatRateCountry)(partyDomain_1.COUNTRY.SK, partyDomain_1.COUNTRY.HU)) ? react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.icoDph.textLabel, value: dataObject.icoDph }) : null,
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.defaultCurrency.textLabel, value: dataObject.defaultCurrency }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.defaultLanguage.textLabel, value: dataObject.defaultLanguage }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.defaultPaymentCond.textLabel, value: dataObject.defaultPaymentCond }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.legalForm.textLabel, value: dataObject.legalForm }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.naceCode.textLabel, value: dataObject.naceCode }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.marketingSource.textLabel, value: dataObject.marketingSource }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.nationality.textLabel, value: dataObject.nationality }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.taxDomicile.textLabel, value: dataObject.taxDomicile }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.defaultSendType.textLabel, value: dataObject.defaultSendType }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.defaultAttachmentType.textLabel, value: dataObject.defaultAttachmentType }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.defaultProfitCenter.textLabel, value: dataObject.defaultProfitCenter }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.vatRateOverride.textLabel, value: dataObject.vatRateOverride }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.commercialRegister.textLabel, value: dataObject.commercialRegister }),
	            (dataObject.partyCategory === partyDomain_1.PARTYCATEGORY.EN) ? react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.firstName.textLabel, value: dataObject.firstName }) : null,
	            (dataObject.partyCategory === partyDomain_1.PARTYCATEGORY.EN) ? react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.lastName.textLabel, value: dataObject.lastName }) : null,
	            (dataObject.partyCategory === partyDomain_1.PARTYCATEGORY.EN) ? react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.dateOfBirth.textLabel, value: dataObject.dateOfBirth, mdField: fields.dateOfBirth.mdField }) : null,
	            (dataObject.partyCategory === partyDomain_1.PARTYCATEGORY.EN) ? react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.birthNumber.textLabel, value: dataObject.birthNumber }) : null,
	            (dataObject.partyCategory === partyDomain_1.PARTYCATEGORY.EN) ? react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.gender.textLabel, value: dataObject.gender }) : null,
	            (dataObject.partyCategory === partyDomain_1.PARTYCATEGORY.EN) ? react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.birthLastName.textLabel, value: dataObject.birthLastName }) : null,
	            (dataObject.partyCategory === partyDomain_1.PARTYCATEGORY.EN) ? react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.salutation.textLabel, value: dataObject.salutation }) : null,
	            (dataObject.partyCategory === partyDomain_1.PARTYCATEGORY.EN) ? react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.placeOfBirth.textLabel, value: dataObject.placeOfBirth }) : null)));
	};
	var PartyPoForm = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyPoForm, _super);
	    function PartyPoForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDic = function (evt) {
	            evt.preventDefault();
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            console.log('onDic', evt);
	            partyService_1.default.partyVatIdDownload({ vatId: dataObject.dic, nationality: (0, formUtils_1.lovValue)(dataObject.nationality), language: (0, formUtils_1.lovValue)(dataObject.defaultLanguage) })
	                .then((0, mobx_1.action)("partyVatIdDownload-actionCb", _this.processPartyInfo));
	        };
	        _this.onIco = function (evt) {
	            evt.preventDefault();
	            var dataObject = _this.props.dataObject;
	            console.log('onIco', evt);
	            partyService_1.default.partyIdDownload({ id: dataObject.ico })
	                .then((0, mobx_1.action)("partyIdDownload-actionCb", _this.processPartyInfo));
	        };
	        _this.onSuccessDic = function () {
	            var _a = _this.props, form = _a.form, dataObject = _a.dataObject;
	            if (form.getField("dic").errorText) {
	                dataObject.vatIdCheckDate = null;
	            }
	            else {
	                dataObject.vatIdCheckDate = new Date();
	            }
	        };
	        _this.processPartyInfo = function (json) {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            if (json) {
	                var oldPA = dataObject.partyPermanentAddress();
	                if (oldPA) {
	                    pull(dataObject.addresses, oldPA);
	                }
	                var partyInfo = new partyDomain_1.PartyInfo(json);
	                var address = partyInfo.permanentAddress;
	                var bankAccount_1 = partyInfo.defaultBankAccount;
	                if (address) {
	                    dataObject.fullName = address.name;
	                    dataObject.nationality = address.country;
	                    dataObject.taxDomicile = address.country;
	                }
	                dataObject.ico = partyInfo.id;
	                dataObject.dic = partyInfo.vatId;
	                form.updateFieldsPropValue(dataObject, "ico", "dic", "fullName", "nationality", "taxDomicile");
	                if (address) {
	                    address.name = null;
	                    dataObject.addresses.push(address);
	                }
	                if (bankAccount_1) {
	                    if (!dataObject.bankAccounts.find(function (account) {
	                        return account.accountNumber == bankAccount_1.accountNumber
	                            && account.bank.value == bankAccount_1.bank.value
	                            && account.accountPrefix == bankAccount_1.accountPrefix
	                            && account.currency.value == bankAccount_1.currency.value;
	                    })) {
	                        dataObject.bankAccounts = tslib_1.__spreadArray(tslib_1.__spreadArray([], dataObject.bankAccounts, true), [bankAccount_1], false);
	                    }
	                }
	            }
	        };
	        _this.onDicEnable = function (value) {
	            return ((_this.props.dataObject.$new || _this.props.dataObject.$dirty) && value && value.length > 2);
	        };
	        _this.onIcoEnable = function (value) {
	            return ((_this.props.dataObject.$new || _this.props.dataObject.$dirty) && value);
	        };
	        return _this;
	    }
	    PartyPoForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity, open = _a.open, formName = _a.formName;
	        var fields = dataObject.getFormFields(formName);
	        var fullName = fields.fullName, ico = fields.ico, dic = fields.dic, icoDph = fields.icoDph, defaultCurrency = fields.defaultCurrency, defaultLanguage = fields.defaultLanguage, defaultPaymentCond = fields.defaultPaymentCond, legalForm = fields.legalForm, naceCode = fields.naceCode, marketingSource = fields.marketingSource, nationality = fields.nationality, taxDomicile = fields.taxDomicile, commercialRegister = fields.commercialRegister, defaultSendType = fields.defaultSendType, defaultAttachmentType = fields.defaultAttachmentType, defaultProfitCenter = fields.defaultProfitCenter, firstName = fields.firstName, lastName = fields.lastName, titleBefore = fields.titleBefore, dateOfBirth = fields.dateOfBirth, birthNumber = fields.birthNumber, gender = fields.gender, birthLastName = fields.birthLastName, placeOfBirth = fields.placeOfBirth, vatRateOverride = fields.vatRateOverride;
	        var defaultProfitCenterOptions = (securityService_1.default.currentUser.hasRestriction(securityDomain_1.RESTRICTION.LIMIT_PARTY_BY_USER_PROFITCENTER)) ?
	            defaultProfitCenter.props.options.filter(function (lv) { return securityService_1.default.restrictionData.userProfitCenterIds.includes(lv.value); }) : defaultProfitCenter.props.options;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, fullName.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: fullName, value: fullName.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                (0, formUtils_1.hideForVatRateCountry)(react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, ico.props, { showValidationIcon: true, onAction: this.onIco, onActionEnable: this.onIcoEnable })),
	                    react_1.default.createElement(validate_1.Validate, { field: ico, value: ico.props.value },
	                        react_1.default.createElement(PartyExist, { partyId: dataObject.partyId }),
	                        react_1.default.createElement(PartyIdExist, null))), partyDomain_1.COUNTRY.RO),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, dic.props, { showValidationIcon: true, onAction: this.onDic, onActionEnable: this.onDicEnable })),
	                    react_1.default.createElement(validate_1.Validate, { field: dic, value: dic.props.value, onSuccess: this.onSuccessDic },
	                        react_1.default.createElement(PartyVatIdExist, { nationality: (0, formUtils_1.lovValue)(dataObject.nationality) }))),
	                (0, formUtils_1.showForVatRateCountry)((react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, icoDph.props)))), partyDomain_1.COUNTRY.SK, partyDomain_1.COUNTRY.HU)),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, defaultCurrency.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, defaultLanguage.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, defaultPaymentCond.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, legalForm.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, naceCode.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, marketingSource.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, nationality.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, taxDomicile.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: taxDomicile, value: taxDomicile.props.value, dataObject: dataObject })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, defaultSendType.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, defaultProfitCenter.props, { options: defaultProfitCenterOptions })),
	                    react_1.default.createElement(validate_1.Validate, { field: defaultProfitCenter, value: defaultProfitCenter.props.value, dataObject: dataObject })),
	                (securityService_1.default.hasRight(metaConstant_1.SECURABLE.vatRateOverride.name, metaConstant_1.PERMISSION.Update)) ? (react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, vatRateOverride.props)))) : null,
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, defaultAttachmentType.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, commercialRegister.props)))),
	            (dataObject.partyCategory === partyDomain_1.PARTYCATEGORY.EN) ? (react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, firstName.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: lastName, value: lastName.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, lastName.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: lastName, value: lastName.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, titleBefore.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, dateOfBirth.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, birthNumber.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, gender.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, birthLastName.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, placeOfBirth.props))))) : null));
	        return (open) ? openContent : (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true },
	            react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate }, this.props))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyPoForm.prototype, "onDic", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyPoForm.prototype, "onIco", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyPoForm.prototype, "onSuccessDic", void 0);
	    PartyPoForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'PartyPoForm',
	            fields: [{
	                    name: 'fullName',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'ico'
	                }, {
	                    name: 'dic'
	                }, {
	                    name: 'icoDph'
	                }, {
	                    name: 'defaultCurrency'
	                }, {
	                    name: 'defaultLanguage'
	                }, {
	                    name: 'defaultPaymentCond'
	                }, {
	                    name: 'legalForm'
	                }, {
	                    name: 'naceCode'
	                }, {
	                    name: 'marketingSource'
	                }, {
	                    name: 'nationality'
	                }, {
	                    name: 'taxDomicile'
	                }, {
	                    name: 'commercialRegister'
	                }, {
	                    name: 'defaultSendType'
	                }, {
	                    name: 'defaultAttachmentType',
	                }, {
	                    name: 'defaultProfitCenter'
	                }, {
	                    name: 'firstName',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'lastName',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'titleBefore'
	                }, {
	                    name: 'dateOfBirth'
	                }, {
	                    name: 'birthNumber'
	                }, {
	                    name: 'gender'
	                }, {
	                    name: 'birthLastName'
	                }, {
	                    name: 'salutation'
	                }, {
	                    name: 'placeOfBirth'
	                }, {
	                    name: 'vatRateOverride'
	                }]
	        }, ClosedContent),
	        mobx_react_1.observer
	    ], PartyPoForm);
	    return PartyPoForm;
	}(react_1.default.Component));
	exports.default = PartyPoForm;
	var templateObject_1;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var formUtils_1 = __webpack_require__(14);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var blockComp_1 = __webpack_require__(30);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var Chip_1 = tslib_1.__importDefault(__webpack_require__(211));
	var colors_1 = __webpack_require__(29);
	var mobx_react_1 = __webpack_require__(4);
	var partyDomain_1 = __webpack_require__(48);
	var mobx_1 = __webpack_require__(5);
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields;
	    return (react_1.default.createElement("div", { style: { fontSize: 14, lineHeight: '14px', minHeight: 20 } }, (0, formUtils_1.lovLabel)(dataObject.roleType)));
	};
	var PartyRoleForm = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyRoleForm, _super);
	    function PartyRoleForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onChangeRoleType = function (e) {
	            var _a = _this.props, dataObject = _a.dataObject, formName = _a.formName, onChangeRole = _a.onChangeRole;
	            var form = dataObject.getForm(formName);
	            form.getField("roleType").props.onChange(e);
	            form.updateFieldsPropValue(dataObject, "roleType");
	            if (onChangeRole)
	                onChangeRole();
	        };
	        return _this;
	    }
	    PartyRoleForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, formName = _a.formName, entity = _a.entity;
	        var fields = dataObject.getFormFields(formName);
	        var roleType = fields.roleType;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, roleType.props, { hintText: "Choose values", multi: true, searchable: false, onChange: this.onChangeRoleType }))));
	        var closedContentArray = (react_1.default.createElement("div", { style: { fontSize: 14, lineHeight: '14px', minHeight: 20, display: 'flex', flexWrap: 'wrap', margin: -4 } }, dataObject.roles.map(function (role, index) { return react_1.default.createElement(Chip_1.default, { key: index, style: { margin: 3, backgroundColor: colors_1.blueGrey50 } }, (0, formUtils_1.lovLabel)(role.roleType)); })));
	        var header = (react_1.default.createElement("div", null,
	            react_1.default.createElement("span", null, "Roles")));
	        var _b = this.props, onChangeRole = _b.onChangeRole, activeItemProps = tslib_1.__rest(_b, ["onChangeRole"]);
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true, header: header, style: { display: 'flex', flexDirection: 'column' } },
	            react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: closedContentArray }, activeItemProps))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyRoleForm.prototype, "onChangeRoleType", void 0);
	    PartyRoleForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'PartyRoleForm',
	            closedOnNew: true,
	            fields: [{
	                    name: 'roleType',
	                    usePlaceholder: true,
	                    setFieldValueFn: function (dataObject, value, entity) { return dataObject.roles = mergeRoles(dataObject, value, entity); },
	                    getFieldValueFn: function (dataObject) { return dataObject.roles.map(function (v) { return v.roleType; }); }
	                }]
	        }, ClosedContent),
	        mobx_react_1.observer
	    ], PartyRoleForm);
	    return PartyRoleForm;
	}(react_1.default.Component));
	exports.default = PartyRoleForm;
	function mergeRoles(party, lovs, partyRoleEntity) {
	    var newArray = [];
	    var _loop_1 = function (role) {
	        var foundIndex = lovs.findIndex(function (lov) { return lov.value === role.roleType.value; });
	        if (foundIndex >= 0) {
	            newArray.push(role);
	            lovs.splice(foundIndex, 1);
	        }
	    };
	    for (var _i = 0, _a = party.roles; _i < _a.length; _i++) {
	        var role = _a[_i];
	        _loop_1(role);
	    }
	    for (var _b = 0, lovs_1 = lovs; _b < lovs_1.length; _b++) {
	        var lov = lovs_1[_b];
	        newArray.push(new partyDomain_1.PartyRole({ $new: true, $added: true, roleType: lov }).initDefaultValues());
	    }
	    return newArray;
	}


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PriceBox = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var mobx_react_1 = __webpack_require__(4);
	var react_bootstrap_1 = __webpack_require__(72);
	var productService_1 = tslib_1.__importDefault(__webpack_require__(131));
	var productDomain_1 = __webpack_require__(158);
	var mobx_1 = __webpack_require__(5);
	var formUtils_1 = __webpack_require__(14);
	var dateUtils_1 = __webpack_require__(49);
	var colors_1 = __webpack_require__(29);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var Subject_1 = __webpack_require__(260);
	__webpack_require__(309);
	var utils_1 = __webpack_require__(37);
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var itemStream = new Subject_1.Subject();
	itemStream
	    .mergeMap(function (item) { return Promise.all([item, productService_1.default.readVehicle(item.rowId, true), mdEntityService_1.default.fetchEntities(["PriceComponent"])]); }, null, 5)
	    .subscribe((0, mobx_1.action)("subscribe-actionCb", function (_a) {
	    var item = _a[0], vehicle = _a[1], entityMap = _a[2];
	    item.rowObject = vehicle;
	    item.expanded = 2;
	    console.log("VehicleExpando resolved vehicle %s", vehicle.vehicleId);
	}));
	var _productIntervalStyle = {
	    fontStyle: 'italic',
	    color: colors_1.grey400
	};
	var VehicleExpando = /** @class */ (function (_super) {
	    tslib_1.__extends(VehicleExpando, _super);
	    function VehicleExpando() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    VehicleExpando.prototype.componentDidMount = function () {
	        var item = this.props.item;
	        var vehicle = item.rowObject;
	        //console.log("VehicleExpando componentDidMount, missing data going to add to resolver: " + (!vehicle || !vehicle.productVehicles));
	        if (!vehicle) {
	            itemStream.next(item);
	        }
	    };
	    // VirtualList reuse components, because they have the same key, only data are changed in componentDidUpdate
	    VehicleExpando.prototype.componentDidUpdate = function (prevProps, prevState) {
	        var item = this.props.item;
	        var vehicle = item.rowObject;
	        //console.log("VehicleExpando componentDidUpdate, prev rowId = %O, new rowId = %O, missing data going to add to resolver: " + (!vehicle || !vehicle.productVehicles) ,
	        //  prevProps.item.rowId, item.rowId);
	        if (!vehicle && prevProps.item.rowId !== item.rowId) {
	            itemStream.next(item);
	        }
	    };
	    VehicleExpando.prototype.render = function () {
	        var item = this.props.item;
	        var vehicle = item.rowObject;
	        //console.log("VehicleExpando render vehicle %s, expanded = %s", (vehicle)?vehicle.vehicleId:null, item.expanded);
	        var priceComponentEntity = mdEntityService_1.default.getEntity("PriceComponent");
	        var priceField = (priceComponentEntity) ? priceComponentEntity.getField("price") : null;
	        var now = (0, moment_1.default)().startOf('day');
	        if (item.expanded === 1) {
	            return (react_1.default.createElement("div", { style: { marginLeft: 24 } },
	                react_1.default.createElement("i", { className: "fa fa-refresh fa-2x fa-spin color-blue-grey-200" })));
	        }
	        return (vehicle && vehicle.productVehicles && priceField) ? (react_1.default.createElement("div", { style: { marginLeft: 22, display: 'table', borderSpacing: 4 } }, vehicle.productVehicles.map(function (pv) {
	            var _productStyle = { display: 'table-cell', paddingRight: 10 };
	            if (!(0, dateUtils_1.isValid)(pv, now))
	                _productStyle["color"] = colors_1.grey400;
	            return (react_1.default.createElement("div", { key: (0, formUtils_1.lovValue)(pv.product), style: { display: 'table-row' } },
	                react_1.default.createElement("div", { style: _productStyle },
	                    react_1.default.createElement("span", null, (0, formUtils_1.lovLabel)(pv.product)),
	                    react_1.default.createElement("span", { style: _productIntervalStyle }, ' ' + (0, dateUtils_1.formatInterval)(pv.validFrom, pv.validTo))),
	                (pv.prices) ? pv.prices.map(function (pc) { return react_1.default.createElement(PriceBox, { key: pc.priceComponentId, pv: pv, pc: pc, priceField: priceField }); }) : null));
	        }))) : null;
	    };
	    VehicleExpando = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], VehicleExpando);
	    return VehicleExpando;
	}(react_1.default.Component));
	exports.default = VehicleExpando;
	var PriceBox = /** @class */ (function (_super) {
	    tslib_1.__extends(PriceBox, _super);
	    function PriceBox() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.routeName = "priceComponentDetail";
	        _this.onClick = function (event) {
	            event.preventDefault();
	            var pc = _this.props.pc;
	            _this.context.router.transitionTo(_this.routeName, { id: pc.priceComponentId });
	        };
	        return _this;
	    }
	    PriceBox.prototype.render = function () {
	        var _a = this.props, pc = _a.pc, pv = _a.pv, priceField = _a.priceField, disableLink = _a.disableLink, style = _a.style;
	        var now = (0, moment_1.default)().startOf('day');
	        var _pcStyle = { display: 'table-cell', borderRadius: 3, border: '1px solid', paddingLeft: 5, paddingRight: 5, color: productDomain_1.PRICECOMPLEVEL_COLORS[(0, formUtils_1.lovValue)(pc.priceLevel)] };
	        if (pv && pc.priceComponentId === pv.activePriceComponentId) {
	            _pcStyle["borderWidth"] = 2;
	            _pcStyle["fontWeight"] = "bold";
	        }
	        if (!(0, dateUtils_1.isValid)(pc, now)) {
	            _pcStyle["textDecoration"] = "line-through";
	        }
	        if (style) {
	            Object.assign(_pcStyle, style);
	        }
	        var content = (pc.priceComponentId && !disableLink) ? (react_1.default.createElement("a", { className: "no-link", style: _pcStyle, href: this.context.router.makeHref(this.routeName, { id: pc.priceComponentId }, (0, utils_1.addTenantToQuery)()), onClick: this.onClick },
	            priceField.formatValue(pc.price),
	            " ",
	            (0, formUtils_1.lovLabel)(pc.priceCurrency))) : (react_1.default.createElement("div", { style: _pcStyle },
	            priceField.formatValue(pc.price),
	            " ",
	            (0, formUtils_1.lovLabel)(pc.priceCurrency)));
	        return (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "top", delayShow: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: pc.id + "_dateIntervalTooltip" }, (0, dateUtils_1.formatInterval)(pc.validFrom, pc.validTo)) }, content));
	    };
	    PriceBox.contextTypes = {
	        router: prop_types_1.default.func.isRequired
	    };
	    return PriceBox;
	}(react_1.default.Component));
	exports.PriceBox = PriceBox;


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ColorCircle = exports.MenuHeader = exports.StyledMenuItem = exports.StyledMenu = void 0;
	var tslib_1 = __webpack_require__(3);
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	exports.StyledMenu = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 350px;\n  border-radius: 8px;\n  background-color: #f0f0f0;\n"], ["\n  width: 350px;\n  border-radius: 8px;\n  background-color: #f0f0f0;\n"])));
	exports.StyledMenuItem = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  background-color: ", ";\n  max-height: 100px;\n  padding: 2px 20px;\n  width: 350px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  border-bottom: ", ";\n  & span {\n    max-width: 280px;\n    font-size: 1.5rem;\n  }\n"], ["\n  background-color: ", ";\n  max-height: 100px;\n  padding: 2px 20px;\n  width: 350px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  border-bottom: ", ";\n  & span {\n    max-width: 280px;\n    font-size: 1.5rem;\n  }\n"])), function (props) { return props.selected && "#fff"; }, function (props) { return props.selected ? "1px solid #009688" : "1px solid #fff"; });
	exports.MenuHeader = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  cursor:pointer;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding-left: 10px;\n  border-radius: 8px;\n  color: ", ";\n  background-color: ", ";\n  border-bottom: 1px solid #fff;\n  & h4 {\n    color: ", ";\n    padding-left: 10px;\n  }\n "], ["\n  cursor:pointer;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding-left: 10px;\n  border-radius: 8px;\n  color: ", ";\n  background-color: ", ";\n  border-bottom: 1px solid #fff;\n  & h4 {\n    color: ", ";\n    padding-left: 10px;\n  }\n "])), function (props) { return props.isActive ? "#fff" : "#000"; }, function (props) { return props.isActive ? "#009688" : "#E2E2E2"; }, function (props) { return props.isActive ? "#fff" : "#000"; });
	exports.ColorCircle = styled_components_1.default.div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  background-color: ", ";\n  border: 2px solid #009688;\n  border-radius: 50% 50%;\n  width: 1rem;\n  height: 1rem;\n  margin-right: 20px;\n"], ["\n  background-color: ", ";\n  border: 2px solid #009688;\n  border-radius: 50% 50%;\n  width: 1rem;\n  height: 1rem;\n  margin-right: 20px;\n"])), function (props) { return props.value > -1 ? "#009688" : "#fff"; });
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SUBCRITERIONVALUESTYPE = exports.SubCriterion = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	// import {PROJECT_VERSION_READONLY} from "../../gridsContants";
	var SubCriterion = /** @class */ (function (_super) {
	    tslib_1.__extends(SubCriterion, _super);
	    function SubCriterion(json) {
	        return _super.call(this, json) || this;
	    }
	    SubCriterion.prototype.getId = function () {
	        return this.subCriterionId;
	    };
	    SubCriterion.prototype.setId = function (id) {
	        this.subCriterionId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SubCriterion.prototype, "subCriterionId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SubCriterion.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SubCriterion.prototype, "code", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SubCriterion.prototype, "description", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SubCriterion.prototype, "type", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SubCriterion.prototype, "parameters", void 0);
	    SubCriterion = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], SubCriterion);
	    return SubCriterion;
	}(DomainAncestor_1.DomainAncestor));
	exports.SubCriterion = SubCriterion;
	var SUBCRITERIONVALUESTYPE;
	(function (SUBCRITERIONVALUESTYPE) {
	    SUBCRITERIONVALUESTYPE["LIST"] = "LIST";
	    SUBCRITERIONVALUESTYPE["SELECT"] = "SELECT";
	    SUBCRITERIONVALUESTYPE["MULTISELECT"] = "MULTISELECT";
	    SUBCRITERIONVALUESTYPE["INPUTS"] = "INPUTS";
	    SUBCRITERIONVALUESTYPE["MATERIALS"] = "MATERIALS";
	    SUBCRITERIONVALUESTYPE["ENERGY_CARRIERS"] = "ENERGY_CARRIERS";
	    SUBCRITERIONVALUESTYPE["SHARED_SUBCRITERION"] = "SHARED_SUBCRITERION";
	    SUBCRITERIONVALUESTYPE["AREAS"] = "AREAS";
	    SUBCRITERIONVALUESTYPE["RECYCLABLE_MATERIALS_GRID"] = "RECYCLABLE_MATERIALS_GRID";
	    SUBCRITERIONVALUESTYPE["EPD_CERTIFIED_MATERIALS_GRID"] = "EPD_CERTIFIED_MATERIALS_GRID";
	    SUBCRITERIONVALUESTYPE["WOOD_BASED_MATERIALS_GRID"] = "WOOD_BASED_MATERIALS_GRID";
	    SUBCRITERIONVALUESTYPE["AREAS_ZELPO_GRID"] = "AREAS_ZELPO_GRID";
	    SUBCRITERIONVALUESTYPE["AREAS_ZELZP_GRID"] = "AREAS_ZELZP_GRID";
	    SUBCRITERIONVALUESTYPE["AREAS_ZELZF_GRID"] = "AREAS_ZELZF_GRID";
	    SUBCRITERIONVALUESTYPE["AREAS_ZELZS_GRID"] = "AREAS_ZELZS_GRID";
	    SUBCRITERIONVALUESTYPE["AREAS_ZELST_GRID"] = "AREAS_ZELST_GRID";
	    SUBCRITERIONVALUESTYPE["AREAS_VPREP_GRID"] = "AREAS_VPREP_GRID";
	    SUBCRITERIONVALUESTYPE["AREAS_PEFKE_GRID"] = "AREAS_PEFKE_GRID";
	})(SUBCRITERIONVALUESTYPE || (exports.SUBCRITERIONVALUESTYPE = SUBCRITERIONVALUESTYPE = {}));


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectVersion = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var ProjectVersion = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersion, _super);
	    function ProjectVersion(json) {
	        return _super.call(this, json) || this;
	    }
	    ProjectVersion.prototype.getId = function () {
	        return this.versionId;
	    };
	    ProjectVersion.prototype.setId = function (id) {
	        this.versionId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersion.prototype, "versionId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersion.prototype, "version", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersion.prototype, "description", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersion.prototype, "project", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersion.prototype, "firstComment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersion.prototype, "secondComment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersion.prototype, "thirdComment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersion.prototype, "fourthComment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersion.prototype, "isCustom", void 0);
	    ProjectVersion = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ProjectVersion);
	    return ProjectVersion;
	}(DomainAncestor_1.DomainAncestor));
	exports.ProjectVersion = ProjectVersion;


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DOORSECURITYTYPE = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var ProjectVersionDoor = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionDoor, _super);
	    function ProjectVersionDoor(json) {
	        return _super.call(this, json) || this;
	    }
	    ProjectVersionDoor.prototype.getId = function () {
	        return this.doorId;
	    };
	    ProjectVersionDoor.prototype.setId = function (id) {
	        this.doorId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "doorId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "projectVersion", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "roomFrom", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "roomTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "reachableOnlyByLadder", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "doorType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "height", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "width", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "threshold", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "frameMaterial", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "frameMaterialMass", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "leafMaterial1", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "leafMaterial1Mass", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "leafMaterial2", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "leafMaterial2Mass", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "leafMaterial3", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "leafMaterial3Mass", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "remoteControl", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "entranceAtLeast1250mmWide", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "suitableForHandicapped", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "protectedAgainstWheelchair", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "lockNotMoreThen1000mmAbove", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "handleNotMoreThen1000mmAbove", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoor.prototype, "markedContrastingly", void 0);
	    ProjectVersionDoor = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ProjectVersionDoor);
	    return ProjectVersionDoor;
	}(DomainAncestor_1.DomainAncestor));
	exports.default = ProjectVersionDoor;
	var DOORSECURITYTYPE;
	(function (DOORSECURITYTYPE) {
	    DOORSECURITYTYPE["FIRST"] = "1";
	    DOORSECURITYTYPE["SECOND"] = "2";
	    DOORSECURITYTYPE["THIRD"] = "3";
	    DOORSECURITYTYPE["FOURTH"] = "4";
	    DOORSECURITYTYPE["FIFTH"] = "5";
	    DOORSECURITYTYPE["SIXTH"] = "6";
	})(DOORSECURITYTYPE || (exports.DOORSECURITYTYPE = DOORSECURITYTYPE = {}));


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ENERGYCARRIERTYPE = exports.ProjectVersionEnergyCarrier = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var ProjectVersionEnergyCarrier = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionEnergyCarrier, _super);
	    function ProjectVersionEnergyCarrier(json) {
	        return _super.call(this, json) || this;
	    }
	    ProjectVersionEnergyCarrier.prototype.getId = function () {
	        return this.energyCarrierId;
	    };
	    ProjectVersionEnergyCarrier.prototype.setId = function (id) {
	        this.energyCarrierId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionEnergyCarrier.prototype, "energyCarrierId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionEnergyCarrier.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionEnergyCarrier.prototype, "energyConversionFactor", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionEnergyCarrier.prototype, "co2Equivalent", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionEnergyCarrier.prototype, "so2Equivalent", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionEnergyCarrier.prototype, "noxEquivalent", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionEnergyCarrier.prototype, "energyConsumption", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionEnergyCarrier.prototype, "type", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionEnergyCarrier.prototype, "originalEnergyCarrier", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionEnergyCarrier.prototype, "projectVersion", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionEnergyCarrier.prototype, "isCustom", void 0);
	    ProjectVersionEnergyCarrier = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ProjectVersionEnergyCarrier);
	    return ProjectVersionEnergyCarrier;
	}(DomainAncestor_1.DomainAncestor));
	exports.ProjectVersionEnergyCarrier = ProjectVersionEnergyCarrier;
	var ENERGYCARRIERTYPE;
	(function (ENERGYCARRIERTYPE) {
	    ENERGYCARRIERTYPE["HEATING"] = "HEATING";
	    ENERGYCARRIERTYPE["VENTILATION"] = "VENTILATION";
	    ENERGYCARRIERTYPE["COOLING"] = "COOLING";
	    ENERGYCARRIERTYPE["HUMIDITY"] = "HUMIDITY";
	    ENERGYCARRIERTYPE["LIGHTING"] = "LIGHTING";
	    ENERGYCARRIERTYPE["HOT_WATER"] = "HOT_WATER";
	    ENERGYCARRIERTYPE["AUXILIARY"] = "AUXILIARY";
	})(ENERGYCARRIERTYPE || (exports.ENERGYCARRIERTYPE = ENERGYCARRIERTYPE = {}));


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectVersionMaterial = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var ProjectVersionMaterial = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionMaterial, _super);
	    function ProjectVersionMaterial(json) {
	        return _super.call(this, json) || this;
	    }
	    ProjectVersionMaterial.prototype.getId = function () {
	        return this.materialId;
	    };
	    ProjectVersionMaterial.prototype.setId = function (id) {
	        this.materialId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "materialId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "code", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "density", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "mass", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "primaryEnergy", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "co2Equivalent", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "so2Equivalent", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "po4Equivalent", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "r11Equivalent", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "c2h4Equivalent", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "thermalCoefficient", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "renewableWeight", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "recycledWeight", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "regionallyMadeWeight", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "area", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "volume", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "lifespan", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "woodBased", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "epdcertification", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "epdCertificationWeight", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "pefcCertificationWeight", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "pefcRequestWeight", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "fscCertificationWeight", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "fscRequestWeight", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "healthSafetyRequirement", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "comment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "originalMaterial", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "projectVersion", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionMaterial.prototype, "materialUsageGroup", void 0);
	    ProjectVersionMaterial = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ProjectVersionMaterial);
	    return ProjectVersionMaterial;
	}(DomainAncestor_1.DomainAncestor));
	exports.ProjectVersionMaterial = ProjectVersionMaterial;


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.RADONEXPOSURELEVEL = exports.ProjectVersionRoom = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var ProjectVersionRoom = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionRoom, _super);
	    function ProjectVersionRoom(json) {
	        return _super.call(this, json) || this;
	    }
	    ProjectVersionRoom.prototype.getId = function () {
	        return this.roomId;
	    };
	    ProjectVersionRoom.prototype.setId = function (id) {
	        this.roomId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionRoom.prototype, "roomId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionRoom.prototype, "roomNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionRoom.prototype, "roomName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionRoom.prototype, "area", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionRoom.prototype, "roomType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionRoom.prototype, "roomCategory", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionRoom.prototype, "radonExposureLevel", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionRoom.prototype, "projectVersion", void 0);
	    ProjectVersionRoom = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ProjectVersionRoom);
	    return ProjectVersionRoom;
	}(DomainAncestor_1.DomainAncestor));
	exports.ProjectVersionRoom = ProjectVersionRoom;
	var RADONEXPOSURELEVEL;
	(function (RADONEXPOSURELEVEL) {
	    RADONEXPOSURELEVEL["CONTACT_FLOOR"] = "CONTACT_FLOOR";
	    RADONEXPOSURELEVEL["FLOOR_NEXT_TO_CONTACT"] = "FLOOR_NEXT_TO_CONTACT";
	    RADONEXPOSURELEVEL["UPPER_FLOOR"] = "UPPER_FLOOR";
	})(RADONEXPOSURELEVEL || (exports.RADONEXPOSURELEVEL = RADONEXPOSURELEVEL = {}));


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var criterionDomain_1 = __webpack_require__(573);
	var mobx_1 = __webpack_require__(5);
	var criterionScoreDomain_1 = __webpack_require__(2218);
	var subCriterionDomain_1 = __webpack_require__(958);
	var subCriterionParameterValueDomain_1 = __webpack_require__(2219);
	var CriterionService = /** @class */ (function () {
	    function CriterionService() {
	    }
	    CriterionService.prototype.readCriteria = function () {
	        return axios_config_1.default.get('sbtool/criteria')
	            .then(function (response) { return response.data.map(function (d) { return new criterionDomain_1.Criterion(d); }); });
	    };
	    CriterionService.prototype.readCriterion = function (criterionId) {
	        return axios_config_1.default.get('sbtool/criteria/' + criterionId)
	            .then(function (response) { return new criterionDomain_1.Criterion(response.data); });
	    };
	    CriterionService.prototype.readSubCriterion = function (criterionId) {
	        return axios_config_1.default.get('sbtool/criteria/sub-criteria/' + criterionId)
	            .then(function (response) { return new subCriterionDomain_1.SubCriterion(response.data); });
	    };
	    CriterionService.prototype.readCriterionScore = function (scoreId) {
	        return axios_config_1.default.get('sbtool/criteria-score/' + scoreId)
	            .then(function (response) { return new criterionScoreDomain_1.CriterionScore(response.data); });
	    };
	    CriterionService.prototype.readSubCriterionParamValue = function (scoreId) {
	        return axios_config_1.default.get('sbtool/sub-criterion/params/' + scoreId)
	            .then(function (response) { return new subCriterionParameterValueDomain_1.SubCriterionParameterValue(response.data); });
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], CriterionService.prototype, "criterionObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], CriterionService.prototype, "subCriterionObject", void 0);
	    return CriterionService;
	}());
	exports.default = new CriterionService();


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ShipmentRequestedTime = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var dialogAncestor_1 = __webpack_require__(87);
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var errorComp_1 = __webpack_require__(34);
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var createForm_1 = __webpack_require__(18);
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var SvgEdit = __webpack_require__(379);
	var SvgDone = __webpack_require__(298);
	var SvgClear = __webpack_require__(248);
	var SvgCalendar = __webpack_require__(1814);
	var dateUtils_1 = __webpack_require__(49);
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var radioButtonField_1 = tslib_1.__importDefault(__webpack_require__(144));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var OpenButtonLineDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: flex-end;\n"], ["\n  display: flex;\n  align-items: flex-end;\n"])));
	var minuteOptions = [{ value: 15, label: "15 min" }, { value: 35, label: "35 min" }, { value: 60, label: "60 min" }];
	/**
	 * Pokud je alespon jedna null, zobrazim -> zobrazim minutesValue = 35
	 * Pokud j
	 */
	var ShipmentRequestedTime = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentRequestedTime, _super);
	    function ShipmentRequestedTime() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.$open = false;
	        _this.$showCalendar = false;
	        _this.shipmentRequestedTimeDialogRefHandler = function (comp) { return _this.shipmentRequestedTimeDialogRef = comp; };
	        _this.openTimeEdit = function () {
	            console.debug('openTimeEdit');
	            _this.$open = true;
	        };
	        _this.onChangeStartDate = function (value) {
	            console.debug('onChangeStartDate ', value);
	            var timeEnd = _this.props.timeEnd;
	            var timeStartM = (0, moment_1.default)(value).startOf('minute');
	            if (value && timeEnd) {
	                var durationInMinutes_1 = (0, moment_1.default)(timeEnd).diff(value, 'minutes');
	                var foundOption = minuteOptions.find(function (o) { return o.value === durationInMinutes_1; });
	                _this.minutesValue = (foundOption) ? foundOption.value : 0;
	            }
	            else if (value && !timeEnd && _this.minutesValue) {
	                timeEnd = timeStartM.clone().add(_this.minutesValue, 'minutes').toDate();
	            }
	            _this.props.changeTimeFn(timeStartM.toDate(), timeEnd);
	        };
	        _this.onChangeEndDate = function (value) {
	            console.debug('onChangeEndDate ', value);
	            var timeStart = _this.props.timeStart;
	            var timeEndM = (0, moment_1.default)(value).startOf('minute');
	            if (value && timeStart) {
	                var durationInMinutes_2 = (0, moment_1.default)(value).diff(timeStart, 'minutes');
	                var foundOption = minuteOptions.find(function (o) { return o.value === durationInMinutes_2; });
	                _this.minutesValue = (foundOption) ? foundOption.value : 0;
	            }
	            else if (value && !timeStart && _this.minutesValue) {
	                timeStart = timeEndM.clone().add(-_this.minutesValue, 'minutes').toDate();
	            }
	            _this.props.changeTimeFn(timeStart, timeEndM.toDate());
	        };
	        _this.onChangeMinutes = function (value) {
	            console.debug('onChangeMinutes ', value);
	            var _a = _this.props, timeStart = _a.timeStart, timeEnd = _a.timeEnd;
	            _this.minutesValue = (value) ? value.value : 0;
	            if (_this.minutesValue && timeEnd) {
	                var newTimeStart = (0, moment_1.default)(timeEnd).add(-_this.minutesValue, 'minutes').toDate();
	                _this.props.changeTimeFn(newTimeStart, timeEnd);
	            }
	            else if (_this.minutesValue && timeStart) {
	                var newTimeEnd = (0, moment_1.default)(timeStart).add(_this.minutesValue, 'minutes').toDate();
	                _this.props.changeTimeFn(timeStart, newTimeEnd);
	            }
	        };
	        _this.onCommit = function (evt) {
	            _this.$open = false;
	        };
	        _this.onRollback = function (evt) {
	            _this.$open = false;
	        };
	        _this.onCalendar = function (evt) {
	            new Promise(function (resolve, reject) {
	                _this.shipmentRequestedTimeDialogRef.open(resolve, reject);
	            }).then(function (res) {
	                //grid.search(null);
	            })
	                .catch(function (error) {
	                console.log('rejecting ShipmentUpdateDialog with ', error);
	            });
	        };
	        return _this;
	    }
	    ShipmentRequestedTime.prototype.componentWillMount = function () {
	        var _a = this.props, timeStart = _a.timeStart, timeEnd = _a.timeEnd;
	        if (!timeStart || !timeEnd)
	            this.minutesValue = 35;
	    };
	    ShipmentRequestedTime.prototype.render = function () {
	        var _a = this.props, timeStart = _a.timeStart, timeEnd = _a.timeEnd, dialogTitle = _a.dialogTitle;
	        var sameDay = (0, moment_1.default)(timeStart).startOf('day').isSame((0, moment_1.default)(timeEnd).startOf('day'));
	        var endTimeFormated = (sameDay) ? (0, dateUtils_1.formatTime)(timeEnd) : (0, dateUtils_1.formatDateTime)(timeEnd, "L HH:mm");
	        var durationInMinutes = (0, moment_1.default)(timeEnd).diff(timeStart, 'minutes');
	        var foundOption = minuteOptions.find(function (o) { return o.value === durationInMinutes; });
	        var openContent = (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'baseline', flexDirection: 'column' } },
	            react_1.default.createElement(radioButtonField_1.default, tslib_1.__assign({ name: "minutesRbf", options: minuteOptions, value: this.minutesValue, onChange: this.onChangeMinutes }, createForm_1.fieldStyles.small.radioButton, { groupStyle: { display: 'flex', flexWrap: 'wrap' }, optionStyle: { width: 'initial', marginRight: 5 }, labelStyle: { whiteSpace: 'nowrap', marginLeft: -10 } })),
	            react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({ value: this.props.timeStart, onChange: this.onChangeStartDate, time: true, floatingLabelText: "Start time" }, createForm_1.fieldStyles.small.textField)),
	            react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({ value: this.props.timeEnd, onChange: this.onChangeEndDate, time: true, floatingLabelText: "End time" }, createForm_1.fieldStyles.small.textField))));
	        console.debug("render: timeStart " + timeStart + ", timeEnd " + timeEnd + ", durationInMinutes " + durationInMinutes);
	        var closedContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("span", null,
	                (0, dateUtils_1.formatDateTime)(timeStart, "L HH:mm"),
	                " - ",
	                endTimeFormated,
	                "  "),
	            (durationInMinutes != 0) && (react_1.default.createElement("span", null,
	                " (",
	                durationInMinutes,
	                " min)"))));
	        return (this.$open) ? (react_1.default.createElement("div", { className: "active-item--open" },
	            react_1.default.createElement(ShipmentRequestedTimeDialog, { title: dialogTitle, ref: this.shipmentRequestedTimeDialogRefHandler, entities: mdEntityService_1.default.entityMap }),
	            openContent,
	            react_1.default.createElement(OpenButtonLineDiv, null,
	                react_1.default.createElement(SvgDone, { className: "active-item--check  zz-mr-15", size: 24, onClick: this.onCommit }),
	                react_1.default.createElement(SvgClear, { className: "active-item--check", size: 24, onClick: this.onRollback }),
	                react_1.default.createElement(SvgCalendar, { className: "active-item--check", size: 18, onClick: this.onCalendar })))) : (react_1.default.createElement("div", { className: 'active-item--closed', style: { paddingLeft: 0, paddingTop: 0 } },
	            react_1.default.createElement(ShipmentRequestedTimeDialog, { title: dialogTitle, ref: this.shipmentRequestedTimeDialogRefHandler, entities: mdEntityService_1.default.entityMap }),
	            closedContent,
	            react_1.default.createElement("div", { className: "active-item--action-group" },
	                react_1.default.createElement(SvgEdit, { className: "active-item--action", onClick: this.openTimeEdit }))));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRequestedTime.prototype, "$open", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRequestedTime.prototype, "$showCalendar", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRequestedTime.prototype, "minutesValue", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentRequestedTime.prototype, "openTimeEdit", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentRequestedTime.prototype, "onChangeStartDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentRequestedTime.prototype, "onChangeEndDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentRequestedTime.prototype, "onChangeMinutes", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentRequestedTime.prototype, "onCommit", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentRequestedTime.prototype, "onRollback", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentRequestedTime.prototype, "onCalendar", void 0);
	    ShipmentRequestedTime = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ShipmentRequestedTime);
	    return ShipmentRequestedTime;
	}(react_1.default.Component));
	exports.ShipmentRequestedTime = ShipmentRequestedTime;
	var ShipmentRequestedTimeDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentRequestedTimeDialog, _super);
	    function ShipmentRequestedTimeDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.ok = function () {
	            _this.$errors = [];
	            if (_this.hasErrors()) {
	                return;
	            }
	            _this.dialogOpen = false;
	            _this.resolve("ok");
	        };
	        _this.cancel = function (evt) {
	            _this.dialogOpen = false;
	            _this.$errors = [];
	            _this.reject("cancel");
	        };
	        return _this;
	    }
	    ShipmentRequestedTimeDialog.prototype.open = function (resolve, reject) {
	        this.resolve = resolve;
	        this.reject = reject;
	        this.$errors = [];
	        this.dialogOpen = true;
	    };
	    ShipmentRequestedTimeDialog.prototype.render = function () {
	        if (!(this.dialogOpen))
	            return null;
	        var actions = [
	            react_1.default.createElement(FlatButton_1.default, { key: 1, label: "Cancel", primary: true, onClick: this.cancel }),
	            react_1.default.createElement(FlatButton_1.default, { key: 2, label: "Ok", secondary: true, onClick: this.ok })
	        ];
	        return (react_1.default.createElement(Dialog_1.default, { title: this.props.title, actions: actions, modal: true, open: this.dialogOpen, autoScrollBodyContent: true, contentStyle: { position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', filter: 'blur(0)' }, bodyStyle: { minHeight: 600 } },
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: this.$errors }),
	            react_1.default.createElement("div", null,
	                react_1.default.createElement("iframe", { id: "inlineFrameExample", width: "700", height: "600", src: "/fe2/test-calendar2", style: { border: "0" } }))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentRequestedTimeDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentRequestedTimeDialog.prototype, "ok", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentRequestedTimeDialog.prototype, "cancel", void 0);
	    ShipmentRequestedTimeDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ShipmentRequestedTimeDialog);
	    return ShipmentRequestedTimeDialog;
	}(dialogAncestor_1.DialogAncestor));
	var templateObject_1;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ShipmentVisitStepper = exports.BigFlagBar = void 0;
	var tslib_1 = __webpack_require__(3);
	var colors_1 = __webpack_require__(29);
	var locales_1 = __webpack_require__(15);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var Stepper_1 = __webpack_require__(288);
	var dateUtils_1 = __webpack_require__(49);
	var formUtils_1 = __webpack_require__(14);
	var react_bootstrap_1 = __webpack_require__(72);
	var __flagStyles = { marginRight: 10, cursor: "pointer" };
	var BigFlagBar = function () { return (react_1.default.createElement("div", { style: { fontSize: 36, paddingLeft: 10, marginTop: 10, backgroundColor: colors_1.grey100, alignSelf: "flex-end" } }, Object.entries(locales_1.loc.countries).filter(function (_a) {
	    var lang = _a[0], country = _a[1];
	    return lang !== locales_1.loc.lang;
	}).map(function (_a) {
	    var lang = _a[0], country = _a[1];
	    return (react_1.default.createElement("span", { key: lang, onClick: function () { return (0, locales_1.changeLanguage)(lang, undefined); }, className: "flag-icon flag-icon-" + country, style: __flagStyles }));
	}))); };
	exports.BigFlagBar = BigFlagBar;
	var MyTooltip = function (_a) {
	    var text = _a.text, tooltipText = _a.tooltipText;
	    return (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "bottom", delayShow: 300, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, null, tooltipText) },
	        react_1.default.createElement("span", null, text)));
	};
	var ShipmentVisitStepper = function (_a) {
	    var dataObject = _a.dataObject, entities = _a.entities;
	    var shipmentVisitStepLovs = entities.get("SHIPMENTVISITSTEP").lovItems;
	    var activeStepNumber = shipmentVisitStepLovs.map(function (lov) { return lov.value; }).indexOf((0, formUtils_1.lovValue)(dataObject.step));
	    return (react_1.default.createElement(Stepper_1.Stepper, { activeStep: activeStepNumber, style: { marginBottom: 20 } },
	        react_1.default.createElement(Stepper_1.Step, null,
	            react_1.default.createElement(Stepper_1.StepLabel, { className: "mui-stepper-icon-hack" },
	                react_1.default.createElement("div", null,
	                    react_1.default.createElement("div", { style: { fontWeight: "bold" } }, shipmentVisitStepLovs[0].label),
	                    react_1.default.createElement(MyTooltip, { text: dataObject.dateCreated ? (0, dateUtils_1.formatDateTime)(dataObject.dateCreated, "L HH:mm") : "", tooltipText: "Created" })))),
	        react_1.default.createElement(Stepper_1.Step, null,
	            react_1.default.createElement(Stepper_1.StepLabel, { className: "mui-stepper-icon-hack" },
	                react_1.default.createElement("div", null,
	                    react_1.default.createElement("div", { style: { fontWeight: "bold" } }, shipmentVisitStepLovs[1].label),
	                    react_1.default.createElement("div", null,
	                        dataObject.visitTime && react_1.default.createElement(MyTooltip, { text: (0, dateUtils_1.formatDateTime)(dataObject.visitTime, "L HH:mm"), tooltipText: "Visit time" }),
	                        dataObject.gateLoadingDuration && react_1.default.createElement(MyTooltip, { text: " (" + (0, dateUtils_1.formatPeriod)(dataObject.gateLoadingDuration, true) + ")", tooltipText: "Gate loading duration" }))))),
	        react_1.default.createElement(Stepper_1.Step, null,
	            react_1.default.createElement(Stepper_1.StepLabel, { className: "mui-stepper-icon-hack" },
	                react_1.default.createElement("div", null,
	                    react_1.default.createElement("div", { style: { fontWeight: "bold" } }, shipmentVisitStepLovs[2].label),
	                    react_1.default.createElement("div", null,
	                        dataObject.entranceTime && react_1.default.createElement(MyTooltip, { text: (0, dateUtils_1.formatDateTime)(dataObject.entranceTime, "L HH:mm"), tooltipText: "Entrance time" }),
	                        dataObject.vendorLoadingDuration && react_1.default.createElement(MyTooltip, { text: " (" + (0, dateUtils_1.formatPeriod)(dataObject.vendorLoadingDuration, true) + ")", tooltipText: "Vendor loading duration" }))))),
	        react_1.default.createElement(Stepper_1.Step, null,
	            react_1.default.createElement(Stepper_1.StepLabel, { className: "mui-stepper-icon-hack" },
	                react_1.default.createElement("div", null,
	                    react_1.default.createElement("div", { style: { fontWeight: "bold" } }, shipmentVisitStepLovs[3].label),
	                    react_1.default.createElement(MyTooltip, { text: dataObject.visitEnd ? (0, dateUtils_1.formatDateTime)(dataObject.visitEnd, "L HH:mm") : "", tooltipText: "Visit end" }))))));
	};
	exports.ShipmentVisitStepper = ShipmentVisitStepper;


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * UAParser.js v0.7.21
	 * Lightweight JavaScript-based User-Agent string parser
	 * https://github.com/faisalman/ua-parser-js
	 *
	 * Copyright © 2012-2019 Faisal Salman <f@faisalman.com>
	 * Licensed under MIT License
	 */
	
	(function (window, undefined) {
	
	    'use strict';
	
	    //////////////
	    // Constants
	    /////////////
	
	
	    var LIBVERSION  = '0.7.21',
	        EMPTY       = '',
	        UNKNOWN     = '?',
	        FUNC_TYPE   = 'function',
	        UNDEF_TYPE  = 'undefined',
	        OBJ_TYPE    = 'object',
	        STR_TYPE    = 'string',
	        MAJOR       = 'major', // deprecated
	        MODEL       = 'model',
	        NAME        = 'name',
	        TYPE        = 'type',
	        VENDOR      = 'vendor',
	        VERSION     = 'version',
	        ARCHITECTURE= 'architecture',
	        CONSOLE     = 'console',
	        MOBILE      = 'mobile',
	        TABLET      = 'tablet',
	        SMARTTV     = 'smarttv',
	        WEARABLE    = 'wearable',
	        EMBEDDED    = 'embedded';
	
	
	    ///////////
	    // Helper
	    //////////
	
	
	    var util = {
	        extend : function (regexes, extensions) {
	            var mergedRegexes = {};
	            for (var i in regexes) {
	                if (extensions[i] && extensions[i].length % 2 === 0) {
	                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
	                } else {
	                    mergedRegexes[i] = regexes[i];
	                }
	            }
	            return mergedRegexes;
	        },
	        has : function (str1, str2) {
	          if (typeof str1 === "string") {
	            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
	          } else {
	            return false;
	          }
	        },
	        lowerize : function (str) {
	            return str.toLowerCase();
	        },
	        major : function (version) {
	            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
	        },
	        trim : function (str) {
	          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	        }
	    };
	
	
	    ///////////////
	    // Map helper
	    //////////////
	
	
	    var mapper = {
	
	        rgx : function (ua, arrays) {
	
	            var i = 0, j, k, p, q, matches, match;
	
	            // loop through all regexes maps
	            while (i < arrays.length && !matches) {
	
	                var regex = arrays[i],       // even sequence (0,2,4,..)
	                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
	                j = k = 0;
	
	                // try matching uastring with regexes
	                while (j < regex.length && !matches) {
	
	                    matches = regex[j++].exec(ua);
	
	                    if (!!matches) {
	                        for (p = 0; p < props.length; p++) {
	                            match = matches[++k];
	                            q = props[p];
	                            // check if given property is actually array
	                            if (typeof q === OBJ_TYPE && q.length > 0) {
	                                if (q.length == 2) {
	                                    if (typeof q[1] == FUNC_TYPE) {
	                                        // assign modified match
	                                        this[q[0]] = q[1].call(this, match);
	                                    } else {
	                                        // assign given value, ignore regex match
	                                        this[q[0]] = q[1];
	                                    }
	                                } else if (q.length == 3) {
	                                    // check whether function or regex
	                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
	                                        // call function (usually string mapper)
	                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
	                                    } else {
	                                        // sanitize match using given regex
	                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
	                                    }
	                                } else if (q.length == 4) {
	                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
	                                }
	                            } else {
	                                this[q] = match ? match : undefined;
	                            }
	                        }
	                    }
	                }
	                i += 2;
	            }
	        },
	
	        str : function (str, map) {
	
	            for (var i in map) {
	                // check if array
	                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
	                    for (var j = 0; j < map[i].length; j++) {
	                        if (util.has(map[i][j], str)) {
	                            return (i === UNKNOWN) ? undefined : i;
	                        }
	                    }
	                } else if (util.has(map[i], str)) {
	                    return (i === UNKNOWN) ? undefined : i;
	                }
	            }
	            return str;
	        }
	    };
	
	
	    ///////////////
	    // String map
	    //////////////
	
	
	    var maps = {
	
	        browser : {
	            oldsafari : {
	                version : {
	                    '1.0'   : '/8',
	                    '1.2'   : '/1',
	                    '1.3'   : '/3',
	                    '2.0'   : '/412',
	                    '2.0.2' : '/416',
	                    '2.0.3' : '/417',
	                    '2.0.4' : '/419',
	                    '?'     : '/'
	                }
	            }
	        },
	
	        device : {
	            amazon : {
	                model : {
	                    'Fire Phone' : ['SD', 'KF']
	                }
	            },
	            sprint : {
	                model : {
	                    'Evo Shift 4G' : '7373KT'
	                },
	                vendor : {
	                    'HTC'       : 'APA',
	                    'Sprint'    : 'Sprint'
	                }
	            }
	        },
	
	        os : {
	            windows : {
	                version : {
	                    'ME'        : '4.90',
	                    'NT 3.11'   : 'NT3.51',
	                    'NT 4.0'    : 'NT4.0',
	                    '2000'      : 'NT 5.0',
	                    'XP'        : ['NT 5.1', 'NT 5.2'],
	                    'Vista'     : 'NT 6.0',
	                    '7'         : 'NT 6.1',
	                    '8'         : 'NT 6.2',
	                    '8.1'       : 'NT 6.3',
	                    '10'        : ['NT 6.4', 'NT 10.0'],
	                    'RT'        : 'ARM'
	                }
	            }
	        }
	    };
	
	
	    //////////////
	    // Regex map
	    /////////////
	
	
	    var regexes = {
	
	        browser : [[
	
	            // Presto based
	            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
	            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
	            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
	            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
	            ], [NAME, VERSION], [
	
	            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
	            ], [[NAME, 'Opera Mini'], VERSION], [
	
	            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
	            ], [[NAME, 'Opera'], VERSION], [
	
	            // Mixed
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
	                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer
	            // Trident based
	            /(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i,
	                                                                                // Avant/IEMobile/SlimBrowser
	            /(bidubrowser|baidubrowser)[\/\s]?([\w\.]+)/i,                      // Baidu Browser
	            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer
	
	            // Webkit/KHTML based
	            /(rekonq)\/([\w\.]*)/i,                                             // Rekonq
	            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i
	                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
	            ], [NAME, VERSION], [
	
	            /(konqueror)\/([\w\.]+)/i                                           // Konqueror
	            ], [[NAME, 'Konqueror'], VERSION], [
	
	            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
	            ], [[NAME, 'IE'], VERSION], [
	
	            /(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i                          // Microsoft Edge
	            ], [[NAME, 'Edge'], VERSION], [
	
	            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
	            ], [[NAME, 'Yandex'], VERSION], [
	
	            /(Avast)\/([\w\.]+)/i                                               // Avast Secure Browser
	            ], [[NAME, 'Avast Secure Browser'], VERSION], [
	
	            /(AVG)\/([\w\.]+)/i                                                 // AVG Secure Browser
	            ], [[NAME, 'AVG Secure Browser'], VERSION], [
	
	            /(puffin)\/([\w\.]+)/i                                              // Puffin
	            ], [[NAME, 'Puffin'], VERSION], [
	
	            /(focus)\/([\w\.]+)/i                                               // Firefox Focus
	            ], [[NAME, 'Firefox Focus'], VERSION], [
	
	            /(opt)\/([\w\.]+)/i                                                 // Opera Touch
	            ], [[NAME, 'Opera Touch'], VERSION], [
	
	            /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i         // UCBrowser
	            ], [[NAME, 'UCBrowser'], VERSION], [
	
	            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
	            ], [[NAME, /_/g, ' '], VERSION], [
	
	            /(windowswechat qbcore)\/([\w\.]+)/i                                // WeChat Desktop for Windows Built-in Browser
	            ], [[NAME, 'WeChat(Win) Desktop'], VERSION], [
	
	            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
	            ], [[NAME, 'WeChat'], VERSION], [
	
	            /(brave)\/([\w\.]+)/i                                               // Brave browser
	            ], [[NAME, 'Brave'], VERSION], [
	
	            /(qqbrowserlite)\/([\w\.]+)/i                                       // QQBrowserLite
	            ], [NAME, VERSION], [
	
	            /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
	            ], [NAME, VERSION], [
	
	            /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
	            ], [NAME, VERSION], [
	
	            /(baiduboxapp)[\/\s]?([\w\.]+)/i                                    // Baidu App
	            ], [NAME, VERSION], [
	
	            /(2345Explorer)[\/\s]?([\w\.]+)/i                                   // 2345 Browser
	            ], [NAME, VERSION], [
	
	            /(MetaSr)[\/\s]?([\w\.]+)/i                                         // SouGouBrowser
	            ], [NAME], [
	
	            /(LBBROWSER)/i                                                      // LieBao Browser
	            ], [NAME], [
	
	            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
	            ], [VERSION, [NAME, 'MIUI Browser']], [
	
	            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
	            ], [VERSION, [NAME, 'Facebook']], [
	
	            /safari\s(line)\/([\w\.]+)/i,                                       // Line App for iOS
	            /android.+(line)\/([\w\.]+)\/iab/i                                  // Line App for Android
	            ], [NAME, VERSION], [
	
	            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
	            ], [VERSION, [NAME, 'Chrome Headless']], [
	
	            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
	            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [
	
	            /((?:oculus|samsung)browser)\/([\w\.]+)/i
	            ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser
	
	            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
	            ], [VERSION, [NAME, 'Android Browser']], [
	
	            /(sailfishbrowser)\/([\w\.]+)/i                                     // Sailfish Browser
	            ], [[NAME, 'Sailfish Browser'], VERSION], [
	
	            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
	                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
	            ], [NAME, VERSION], [
	
	            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
	            ], [[NAME, 'Dolphin'], VERSION], [
	
	            /(qihu|qhbrowser|qihoobrowser|360browser)/i                         // 360
	            ], [[NAME, '360 Browser']], [
	
	            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
	            ], [[NAME, 'Chrome'], VERSION], [
	
	            /(coast)\/([\w\.]+)/i                                               // Opera Coast
	            ], [[NAME, 'Opera Coast'], VERSION], [
	
	            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
	            ], [VERSION, [NAME, 'Firefox']], [
	
	            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
	            ], [VERSION, [NAME, 'Mobile Safari']], [
	
	            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
	            ], [VERSION, NAME], [
	
	            /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
	            ], [[NAME, 'GSA'], VERSION], [
	
	            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
	            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [
	
	            /(webkit|khtml)\/([\w\.]+)/i
	            ], [NAME, VERSION], [
	
	            // Gecko based
	            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
	            ], [[NAME, 'Netscape'], VERSION], [
	            /(swiftfox)/i,                                                      // Swiftfox
	            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
	                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
	            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,
	
	                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
	            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla
	
	            // Other
	            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
	                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
	            /(links)\s\(([\w\.]+)/i,                                            // Links
	            /(gobrowser)\/?([\w\.]*)/i,                                         // GoBrowser
	            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
	            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
	            ], [NAME, VERSION]
	        ],
	
	        cpu : [[
	
	            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
	            ], [[ARCHITECTURE, 'amd64']], [
	
	            /(ia32(?=;))/i                                                      // IA32 (quicktime)
	            ], [[ARCHITECTURE, util.lowerize]], [
	
	            /((?:i[346]|x)86)[;\)]/i                                            // IA32
	            ], [[ARCHITECTURE, 'ia32']], [
	
	            // PocketPC mistakenly identified as PowerPC
	            /windows\s(ce|mobile);\sppc;/i
	            ], [[ARCHITECTURE, 'arm']], [
	
	            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
	            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [
	
	            /(sun4\w)[;\)]/i                                                    // SPARC
	            ], [[ARCHITECTURE, 'sparc']], [
	
	            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
	                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
	            ], [[ARCHITECTURE, util.lowerize]]
	        ],
	
	        device : [[
	
	            /\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i                        // iPad/PlayBook
	            ], [MODEL, VENDOR, [TYPE, TABLET]], [
	
	            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [
	
	            /(apple\s{0,1}tv)/i                                                 // Apple TV
	            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple'], [TYPE, SMARTTV]], [
	
	            /(archos)\s(gamepad2?)/i,                                           // Archos
	            /(hp).+(touchpad)/i,                                                // HP TouchPad
	            /(hp).+(tablet)/i,                                                  // HP Tablet
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
	            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /(kf[A-z]+)\sbuild\/.+silk\//i                                      // Kindle Fire HD
	            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
	            /(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i                         // Fire Phone
	            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
	            /android.+aft([bms])\sbuild/i                                       // Fire TV
	            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [
	
	            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
	            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
	            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [
	
	            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
	            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
	                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
	            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
	            /(asus)-?(\w+)/i                                                    // Asus
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
	            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
	                                                                                // Asus Tablets
	            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i
	            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [
	
	            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
	            /(sony)?(?:sgp.+)\sbuild\//i
	            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
	            /android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i
	            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	
	            /\s(ouya)\s/i,                                                      // Ouya
	            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
	            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
	
	            /android.+;\s(shield)\sbuild/i                                      // Nvidia
	            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
	
	            /(playstation\s[34portablevi]+)/i                                   // Playstation
	            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [
	
	            /(sprint\s(\w+))/i                                                  // Sprint Phones
	            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [
	
	            /(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i,                        // HTC
	            /(zte)-(\w*)/i,                                                     // ZTE
	            /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
	                                                                                // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
	            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [
	
	            /(nexus\s9)/i                                                       // HTC Nexus 9
	            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
	
	            /d\/huawei([\w\s-]+)[;\)]/i,
	            /(nexus\s6p|vog-l29|ane-lx1|eml-l29)/i                              // Huawei
	            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [
	
	            /android.+(bah2?-a?[lw]\d{2})/i                                     // Huawei MediaPad
	            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, TABLET]], [
	
	            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
	            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
	            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
	            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [
	
	                                                                                // Motorola
	            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
	            /mot[\s-]?(\w*)/i,
	            /(XT\d{3,4}) build\//i,
	            /(nexus\s6)/i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
	            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [
	
	            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
	            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [
	
	            /hbbtv.+maple;(\d+)/i
	            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [
	
	            /\(dtv[\);].+(aquos)/i                                              // Sharp
	            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
	
	            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
	            /((SM-T\w+))/i
	            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
	            /smart-tv.+(samsung)/i
	            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
	            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
	            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,
	            /sec-((sgh\w+))/i
	            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [
	
	            /sie-(\w*)/i                                                        // Siemens
	            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
	
	            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
	            /(nokia)[\s_-]?([\w-]*)/i
	            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [
	
	            /android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i                   // Acer
	            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [
	
	            /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
	            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
	            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
	            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
	            /(lg) netcast\.tv/i                                                 // LG SmartTV
	            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
	            /(nexus\s[45])/i,                                                   // LG
	            /lg[e;\s\/-]+(\w*)/i,
	            /android.+lg(\-?[\d\w]+)\s+build/i
	            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [
	
	            /(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i             // Lenovo tablets
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
	            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
	            /(lenovo)[_\s-]?([\w-]+)/i
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /linux;.+((jolla));/i                                               // Jolla
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
	            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
	
	            /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /crkey/i                                                            // Google Chromecast
	            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google'], [TYPE, SMARTTV]], [
	
	            /android.+;\s(glass)\s\d/i                                          // Google Glass
	            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [
	
	            /android.+;\s(pixel c)[\s)]/i                                       // Google Pixel C
	            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [
	
	            /android.+;\s(pixel( [23])?( xl)?)[\s)]/i                              // Google Pixel
	            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [
	
	            /android.+;\s(\w+)\s+build\/hm\1/i,                                 // Xiaomi Hongmi 'numeric' models
	            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
	            /android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,    
	                                                                                // Xiaomi Mi
	            /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i       // Redmi Phones
	            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
	            /android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i            // Mi Pad tablets
	            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
	            /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu
	            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
	            /(mz)-([\w-]{2,})/i
	            ], [[VENDOR, 'Meizu'], MODEL, [TYPE, MOBILE]], [
	
	            /android.+a000(1)\s+build/i,                                        // OnePlus
	            /android.+oneplus\s(a\d{4})[\s)]/i
	            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [
	
	            /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
	            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
	
	            /android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i                      // Dell Venue Tablets
	            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
	            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
	            ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [
	
	            /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
	            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
	
	            /android.+;\s(k88)\sbuild/i                                         // ZTE K Series Tablet
	            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
	            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
	
	            /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
	            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
	            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
	
	            /(android).+[;\/]\s+([YR]\d{2})\s+build/i,
	            /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i        // Dragon Touch Tablet
	            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i                            // Insignia Tablets
	            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i                    // NextBook Tablets
	            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
	            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones
	
	            /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i                     // LvTel Phones
	            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
	
	            /android.+;\s(PH-1)\s/i
	            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [                // Essential PH-1
	
	            /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
	            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i          // Le Pan Tablets
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
	            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
	            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
	
	            /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
	            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
	
	            /android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i                      // Gigaset Tablets
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
	            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
	            ], [[TYPE, util.lowerize], VENDOR, MODEL], [
	
	            /[\s\/\(](smart-?tv)[;\)]/i                                         // SmartTV
	            ], [[TYPE, SMARTTV]], [
	
	            /(android[\w\.\s\-]{0,9});.+build/i                                 // Generic Android Device
	            ], [MODEL, [VENDOR, 'Generic']]
	        ],
	
	        engine : [[
	
	            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
	            ], [VERSION, [NAME, 'EdgeHTML']], [
	
	            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
	            ], [VERSION, [NAME, 'Blink']], [
	
	            /(presto)\/([\w\.]+)/i,                                             // Presto
	            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,     
	                                                                                // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
	            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
	            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
	            ], [NAME, VERSION], [
	
	            /rv\:([\w\.]{1,9}).+(gecko)/i                                       // Gecko
	            ], [VERSION, NAME]
	        ],
	
	        os : [[
	
	            // Windows based
	            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
	            ], [NAME, VERSION], [
	            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
	            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,                   // Windows Phone
	            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
	            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
	            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
	            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [
	
	            // Mobile/Embedded OS
	            /\((bb)(10);/i                                                      // BlackBerry 10
	            ], [[NAME, 'BlackBerry'], VERSION], [
	            /(blackberry)\w*\/?([\w\.]*)/i,                                     // Blackberry
	            /(tizen|kaios)[\/\s]([\w\.]+)/i,                                    // Tizen/KaiOS
	            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i
	                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki/Sailfish OS
	            ], [NAME, VERSION], [
	            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i                  // Symbian
	            ], [[NAME, 'Symbian'], VERSION], [
	            /\((series40);/i                                                    // Series 40
	            ], [NAME], [
	            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
	            ], [[NAME, 'Firefox OS'], VERSION], [
	
	            // Console
	            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation
	
	            // GNU/Linux based
	            /(mint)[\/\s\(]?(\w*)/i,                                            // Mint
	            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
	            /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
	                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
	                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
	            /(hurd|linux)\s?([\w\.]*)/i,                                        // Hurd/Linux
	            /(gnu)\s?([\w\.]*)/i                                                // GNU
	            ], [NAME, VERSION], [
	
	            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
	            ], [[NAME, 'Chromium OS'], VERSION],[
	
	            // Solaris
	            /(sunos)\s?([\w\.\d]*)/i                                            // Solaris
	            ], [[NAME, 'Solaris'], VERSION], [
	
	            // BSD based
	            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i                    // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
	            ], [NAME, VERSION],[
	
	            /(haiku)\s(\w+)/i                                                   // Haiku
	            ], [NAME, VERSION],[
	
	            /cfnetwork\/.+darwin/i,
	            /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i             // iOS
	            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
	
	            /(mac\sos\sx)\s?([\w\s\.]*)/i,
	            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
	            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [
	
	            // Other
	            /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,                             // Solaris
	            /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,                                // AIX
	            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,
	                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
	            /(unix)\s?([\w\.]*)/i                                               // UNIX
	            ], [NAME, VERSION]
	        ]
	    };
	
	
	    /////////////////
	    // Constructor
	    ////////////////
	    var UAParser = function (uastring, extensions) {
	
	        if (typeof uastring === 'object') {
	            extensions = uastring;
	            uastring = undefined;
	        }
	
	        if (!(this instanceof UAParser)) {
	            return new UAParser(uastring, extensions).getResult();
	        }
	
	        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
	        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
	
	        this.getBrowser = function () {
	            var browser = { name: undefined, version: undefined };
	            mapper.rgx.call(browser, ua, rgxmap.browser);
	            browser.major = util.major(browser.version); // deprecated
	            return browser;
	        };
	        this.getCPU = function () {
	            var cpu = { architecture: undefined };
	            mapper.rgx.call(cpu, ua, rgxmap.cpu);
	            return cpu;
	        };
	        this.getDevice = function () {
	            var device = { vendor: undefined, model: undefined, type: undefined };
	            mapper.rgx.call(device, ua, rgxmap.device);
	            return device;
	        };
	        this.getEngine = function () {
	            var engine = { name: undefined, version: undefined };
	            mapper.rgx.call(engine, ua, rgxmap.engine);
	            return engine;
	        };
	        this.getOS = function () {
	            var os = { name: undefined, version: undefined };
	            mapper.rgx.call(os, ua, rgxmap.os);
	            return os;
	        };
	        this.getResult = function () {
	            return {
	                ua      : this.getUA(),
	                browser : this.getBrowser(),
	                engine  : this.getEngine(),
	                os      : this.getOS(),
	                device  : this.getDevice(),
	                cpu     : this.getCPU()
	            };
	        };
	        this.getUA = function () {
	            return ua;
	        };
	        this.setUA = function (uastring) {
	            ua = uastring;
	            return this;
	        };
	        return this;
	    };
	
	    UAParser.VERSION = LIBVERSION;
	    UAParser.BROWSER = {
	        NAME    : NAME,
	        MAJOR   : MAJOR, // deprecated
	        VERSION : VERSION
	    };
	    UAParser.CPU = {
	        ARCHITECTURE : ARCHITECTURE
	    };
	    UAParser.DEVICE = {
	        MODEL   : MODEL,
	        VENDOR  : VENDOR,
	        TYPE    : TYPE,
	        CONSOLE : CONSOLE,
	        MOBILE  : MOBILE,
	        SMARTTV : SMARTTV,
	        TABLET  : TABLET,
	        WEARABLE: WEARABLE,
	        EMBEDDED: EMBEDDED
	    };
	    UAParser.ENGINE = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };
	    UAParser.OS = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };
	
	    ///////////
	    // Export
	    //////////
	
	
	    // check js environment
	    if (typeof(exports) !== UNDEF_TYPE) {
	        // nodejs env
	        if (typeof module !== UNDEF_TYPE && module.exports) {
	            exports = module.exports = UAParser;
	        }
	        exports.UAParser = UAParser;
	    } else {
	        // requirejs env (optional)
	        if (true) {
	            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	                return UAParser;
	            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        } else if (window) {
	            // browser env
	            window.UAParser = UAParser;
	        }
	    }
	
	    // jQuery/Zepto specific (optional)
	    // Note:
	    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
	    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
	    //   and we should catch that.
	    var $ = window && (window.jQuery || window.Zepto);
	    if ($ && !$.ua) {
	        var parser = new UAParser();
	        $.ua = parser.getResult();
	        $.ua.get = function () {
	            return parser.getUA();
	        };
	        $.ua.set = function (uastring) {
	            parser.setUA(uastring);
	            var result = parser.getResult();
	            for (var prop in result) {
	                $.ua[prop] = result[prop];
	            }
	        };
	    }
	
	})(typeof window === 'object' ? window : this);


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = blacklist;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function blacklist(str, chars) {
	  (0, _assertString.default)(str);
	  return str.replace(new RegExp("[".concat(chars, "]+"), 'g'), '');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isByteLength;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	/* eslint-disable prefer-rest-params */
	function isByteLength(str, options) {
	  (0, _assertString.default)(str);
	  var min;
	  var max;
	
	  if (_typeof(options) === 'object') {
	    min = options.min || 0;
	    max = options.max;
	  } else {
	    // backwards compatibility: isByteLength(str, min [, max])
	    min = arguments[1];
	    max = arguments[2];
	  }
	
	  var len = encodeURI(str).split(/%..|./).length - 1;
	  return len >= min && (typeof max === 'undefined' || len <= max);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFullWidth;
	exports.fullWidth = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
	exports.fullWidth = fullWidth;
	
	function isFullWidth(str) {
	  (0, _assertString.default)(str);
	  return fullWidth.test(str);
	}

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHalfWidth;
	exports.halfWidth = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
	exports.halfWidth = halfWidth;
	
	function isHalfWidth(str) {
	  (0, _assertString.default)(str);
	  return halfWidth.test(str);
	}

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHexadecimal;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hexadecimal = /^[0-9A-F]+$/i;
	
	function isHexadecimal(str) {
	  (0, _assertString.default)(str);
	  return hexadecimal.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isInt;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
	var intLeadingZeroes = /^[-+]?[0-9]+$/;
	
	function isInt(str, options) {
	  (0, _assertString.default)(str);
	  options = options || {}; // Get the regex to use for testing, based on whether
	  // leading zeroes are allowed or not.
	
	  var regex = options.hasOwnProperty('allow_leading_zeroes') && !options.allow_leading_zeroes ? int : intLeadingZeroes; // Check min/max/lt/gt
	
	  var minCheckPassed = !options.hasOwnProperty('min') || str >= options.min;
	  var maxCheckPassed = !options.hasOwnProperty('max') || str <= options.max;
	  var ltCheckPassed = !options.hasOwnProperty('lt') || str < options.lt;
	  var gtCheckPassed = !options.hasOwnProperty('gt') || str > options.gt;
	  return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ltrim;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ltrim(str, chars) {
	  (0, _assertString.default)(str);
	  var pattern = chars ? new RegExp("^[".concat(chars, "]+"), 'g') : /^\s+/g;
	  return str.replace(pattern, '');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rtrim;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rtrim(str, chars) {
	  (0, _assertString.default)(str);
	  var pattern = chars ? new RegExp("[".concat(chars, "]")) : /\s/;
	  var idx = str.length - 1;
	
	  for (; idx >= 0 && pattern.test(str[idx]); idx--) {
	    ;
	  }
	
	  return idx < str.length ? str.substr(0, idx + 1) : str;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toFloat;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toFloat(str) {
	  (0, _assertString.default)(str);
	  return parseFloat(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 977 */
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// rawAsap provides everything we need except exception management.
	var rawAsap = __webpack_require__(979);
	// RawTasks are recycled to reduce GC churn.
	var freeTasks = [];
	// We queue errors to ensure they are thrown in right order (FIFO).
	// Array-as-queue is good enough here, since we are just dealing with exceptions.
	var pendingErrors = [];
	var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);
	
	function throwFirstError() {
	    if (pendingErrors.length) {
	        throw pendingErrors.shift();
	    }
	}
	
	/**
	 * Calls a task as soon as possible after returning, in its own event, with priority
	 * over other events like animation, reflow, and repaint. An error thrown from an
	 * event will not interrupt, nor even substantially slow down the processing of
	 * other events, but will be rather postponed to a lower priority event.
	 * @param {{call}} task A callable object, typically a function that takes no
	 * arguments.
	 */
	module.exports = asap;
	function asap(task) {
	    var rawTask;
	    if (freeTasks.length) {
	        rawTask = freeTasks.pop();
	    } else {
	        rawTask = new RawTask();
	    }
	    rawTask.task = task;
	    rawAsap(rawTask);
	}
	
	// We wrap tasks with recyclable task objects.  A task object implements
	// `call`, just like a function.
	function RawTask() {
	    this.task = null;
	}
	
	// The sole purpose of wrapping the task is to catch the exception and recycle
	// the task object after its single use.
	RawTask.prototype.call = function () {
	    try {
	        this.task.call();
	    } catch (error) {
	        if (asap.onerror) {
	            // This hook exists purely for testing purposes.
	            // Its name will be periodically randomized to break any code that
	            // depends on its existence.
	            asap.onerror(error);
	        } else {
	            // In a web browser, exceptions are not fatal. However, to avoid
	            // slowing down the queue of pending tasks, we rethrow the error in a
	            // lower priority turn.
	            pendingErrors.push(error);
	            requestErrorThrow();
	        }
	    } finally {
	        this.task = null;
	        freeTasks[freeTasks.length] = this;
	    }
	};


/***/ }),
/* 979 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(122);
	var bind = __webpack_require__(586);
	var Axios = __webpack_require__(982);
	var defaults = __webpack_require__(410);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(583);
	axios.CancelToken = __webpack_require__(981);
	axios.isCancel = __webpack_require__(584);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(996);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(583);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(410);
	var utils = __webpack_require__(122);
	var InterceptorManager = __webpack_require__(983);
	var dispatchRequest = __webpack_require__(984);
	var isAbsoluteURL = __webpack_require__(992);
	var combineURLs = __webpack_require__(990);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(122);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(122);
	var transformData = __webpack_require__(987);
	var isCancel = __webpack_require__(584);
	var defaults = __webpack_require__(410);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 985 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.response = response;
	  return error;
	};


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(585);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response
	    ));
	  }
	};


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(122);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 988 */
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(122);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 990 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(122);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 992 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(122);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(122);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(122);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 996 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1045), __esModule: true };

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1046), __esModule: true };

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1048), __esModule: true };

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1053), __esModule: true };

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1055), __esModule: true };

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1056), __esModule: true };

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = balanced;
	function balanced(a, b, str) {
	  if (a instanceof RegExp) a = maybeMatch(a, str);
	  if (b instanceof RegExp) b = maybeMatch(b, str);
	
	  var r = range(a, b, str);
	
	  return r && {
	    start: r[0],
	    end: r[1],
	    pre: str.slice(0, r[0]),
	    body: str.slice(r[0] + a.length, r[1]),
	    post: str.slice(r[1] + b.length)
	  };
	}
	
	function maybeMatch(reg, str) {
	  var m = str.match(reg);
	  return m ? m[0] : null;
	}
	
	balanced.range = range;
	function range(a, b, str) {
	  var begs, beg, left, right, result;
	  var ai = str.indexOf(a);
	  var bi = str.indexOf(b, ai + 1);
	  var i = ai;
	
	  if (ai >= 0 && bi > 0) {
	    begs = [];
	    left = str.length;
	
	    while (i >= 0 && !result) {
	      if (i == ai) {
	        begs.push(i);
	        ai = str.indexOf(a, i + 1);
	      } else if (begs.length == 1) {
	        result = [ begs.pop(), bi ];
	      } else {
	        beg = begs.pop();
	        if (beg < left) {
	          left = beg;
	          right = bi;
	        }
	
	        bi = str.indexOf(b, i + 1);
	      }
	
	      i = ai < bi && ai >= 0 ? ai : bi;
	    }
	
	    if (begs.length) {
	      result = [ left, right ];
	    }
	  }
	
	  return result;
	}


/***/ }),
/* 1004 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var SomePromiseArray = Promise._SomePromiseArray;
	function any(promises) {
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(1);
	    ret.setUnwrap();
	    ret.init();
	    return promise;
	}
	
	Promise.any = function (promises) {
	    return any(promises);
	};
	
	Promise.prototype.any = function () {
	    return any(this);
	};
	
	};


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	var firstLineError;
	try {throw new Error(); } catch (e) {firstLineError = e;}
	var schedule = __webpack_require__(1028);
	var Queue = __webpack_require__(1025);
	var util = __webpack_require__(73);
	
	function Async() {
	    this._customScheduler = false;
	    this._isTickUsed = false;
	    this._lateQueue = new Queue(16);
	    this._normalQueue = new Queue(16);
	    this._haveDrainedQueues = false;
	    this._trampolineEnabled = true;
	    var self = this;
	    this.drainQueues = function () {
	        self._drainQueues();
	    };
	    this._schedule = schedule;
	}
	
	Async.prototype.setScheduler = function(fn) {
	    var prev = this._schedule;
	    this._schedule = fn;
	    this._customScheduler = true;
	    return prev;
	};
	
	Async.prototype.hasCustomScheduler = function() {
	    return this._customScheduler;
	};
	
	Async.prototype.enableTrampoline = function() {
	    this._trampolineEnabled = true;
	};
	
	Async.prototype.disableTrampolineIfNecessary = function() {
	    if (util.hasDevTools) {
	        this._trampolineEnabled = false;
	    }
	};
	
	Async.prototype.haveItemsQueued = function () {
	    return this._isTickUsed || this._haveDrainedQueues;
	};
	
	
	Async.prototype.fatalError = function(e, isNode) {
	    if (isNode) {
	        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
	            "\n");
	        process.exit(2);
	    } else {
	        this.throwLater(e);
	    }
	};
	
	Async.prototype.throwLater = function(fn, arg) {
	    if (arguments.length === 1) {
	        arg = fn;
	        fn = function () { throw arg; };
	    }
	    if (typeof setTimeout !== "undefined") {
	        setTimeout(function() {
	            fn(arg);
	        }, 0);
	    } else try {
	        this._schedule(function() {
	            fn(arg);
	        });
	    } catch (e) {
	        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	};
	
	function AsyncInvokeLater(fn, receiver, arg) {
	    this._lateQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncInvoke(fn, receiver, arg) {
	    this._normalQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncSettlePromises(promise) {
	    this._normalQueue._pushOne(promise);
	    this._queueTick();
	}
	
	if (!util.hasDevTools) {
	    Async.prototype.invokeLater = AsyncInvokeLater;
	    Async.prototype.invoke = AsyncInvoke;
	    Async.prototype.settlePromises = AsyncSettlePromises;
	} else {
	    Async.prototype.invokeLater = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvokeLater.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                setTimeout(function() {
	                    fn.call(receiver, arg);
	                }, 100);
	            });
	        }
	    };
	
	    Async.prototype.invoke = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvoke.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                fn.call(receiver, arg);
	            });
	        }
	    };
	
	    Async.prototype.settlePromises = function(promise) {
	        if (this._trampolineEnabled) {
	            AsyncSettlePromises.call(this, promise);
	        } else {
	            this._schedule(function() {
	                promise._settlePromises();
	            });
	        }
	    };
	}
	
	function _drainQueue(queue) {
	    while (queue.length() > 0) {
	        _drainQueueStep(queue);
	    }
	}
	
	function _drainQueueStep(queue) {
	    var fn = queue.shift();
	    if (typeof fn !== "function") {
	        fn._settlePromises();
	    } else {
	        var receiver = queue.shift();
	        var arg = queue.shift();
	        fn.call(receiver, arg);
	    }
	}
	
	Async.prototype._drainQueues = function () {
	    _drainQueue(this._normalQueue);
	    this._reset();
	    this._haveDrainedQueues = true;
	    _drainQueue(this._lateQueue);
	};
	
	Async.prototype._queueTick = function () {
	    if (!this._isTickUsed) {
	        this._isTickUsed = true;
	        this._schedule(this.drainQueues);
	    }
	};
	
	Async.prototype._reset = function () {
	    this._isTickUsed = false;
	};
	
	module.exports = Async;
	module.exports.firstLineError = firstLineError;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(140)))

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
	var calledBind = false;
	var rejectThis = function(_, e) {
	    this._reject(e);
	};
	
	var targetRejected = function(e, context) {
	    context.promiseRejectionQueued = true;
	    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
	};
	
	var bindingResolved = function(thisArg, context) {
	    if (((this._bitField & 50397184) === 0)) {
	        this._resolveCallback(context.target);
	    }
	};
	
	var bindingRejected = function(e, context) {
	    if (!context.promiseRejectionQueued) this._reject(e);
	};
	
	Promise.prototype.bind = function (thisArg) {
	    if (!calledBind) {
	        calledBind = true;
	        Promise.prototype._propagateFrom = debug.propagateFromFunction();
	        Promise.prototype._boundValue = debug.boundValueFunction();
	    }
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	    ret._propagateFrom(this, 1);
	    var target = this._target();
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        var context = {
	            promiseRejectionQueued: false,
	            promise: ret,
	            target: target,
	            bindingPromise: maybePromise
	        };
	        target._then(INTERNAL, targetRejected, undefined, ret, context);
	        maybePromise._then(
	            bindingResolved, bindingRejected, undefined, ret, context);
	        ret._setOnCancel(maybePromise);
	    } else {
	        ret._resolveCallback(target);
	    }
	    return ret;
	};
	
	Promise.prototype._setBoundTo = function (obj) {
	    if (obj !== undefined) {
	        this._bitField = this._bitField | 2097152;
	        this._boundTo = obj;
	    } else {
	        this._bitField = this._bitField & (~2097152);
	    }
	};
	
	Promise.prototype._isBound = function () {
	    return (this._bitField & 2097152) === 2097152;
	};
	
	Promise.bind = function (thisArg, value) {
	    return Promise.resolve(value).bind(thisArg);
	};
	};


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var old;
	if (typeof Promise !== "undefined") old = Promise;
	function noConflict() {
	    try { if (Promise === bluebird) Promise = old; }
	    catch (e) {}
	    return bluebird;
	}
	var bluebird = __webpack_require__(1021)();
	bluebird.noConflict = noConflict;
	module.exports = bluebird;


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var cr = Object.create;
	if (cr) {
	    var callerCache = cr(null);
	    var getterCache = cr(null);
	    callerCache[" size"] = getterCache[" size"] = 0;
	}
	
	module.exports = function(Promise) {
	var util = __webpack_require__(73);
	var canEvaluate = util.canEvaluate;
	var isIdentifier = util.isIdentifier;
	
	var getMethodCaller;
	var getGetter;
	if (true) {
	var makeMethodCaller = function (methodName) {
	    return new Function("ensureMethod", "                                    \n\
	        return function(obj) {                                               \n\
	            'use strict'                                                     \n\
	            var len = this.length;                                           \n\
	            ensureMethod(obj, 'methodName');                                 \n\
	            switch(len) {                                                    \n\
	                case 1: return obj.methodName(this[0]);                      \n\
	                case 2: return obj.methodName(this[0], this[1]);             \n\
	                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
	                case 0: return obj.methodName();                             \n\
	                default:                                                     \n\
	                    return obj.methodName.apply(obj, this);                  \n\
	            }                                                                \n\
	        };                                                                   \n\
	        ".replace(/methodName/g, methodName))(ensureMethod);
	};
	
	var makeGetter = function (propertyName) {
	    return new Function("obj", "                                             \n\
	        'use strict';                                                        \n\
	        return obj.propertyName;                                             \n\
	        ".replace("propertyName", propertyName));
	};
	
	var getCompiled = function(name, compiler, cache) {
	    var ret = cache[name];
	    if (typeof ret !== "function") {
	        if (!isIdentifier(name)) {
	            return null;
	        }
	        ret = compiler(name);
	        cache[name] = ret;
	        cache[" size"]++;
	        if (cache[" size"] > 512) {
	            var keys = Object.keys(cache);
	            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
	            cache[" size"] = keys.length - 256;
	        }
	    }
	    return ret;
	};
	
	getMethodCaller = function(name) {
	    return getCompiled(name, makeMethodCaller, callerCache);
	};
	
	getGetter = function(name) {
	    return getCompiled(name, makeGetter, getterCache);
	};
	}
	
	function ensureMethod(obj, methodName) {
	    var fn;
	    if (obj != null) fn = obj[methodName];
	    if (typeof fn !== "function") {
	        var message = "Object " + util.classString(obj) + " has no method '" +
	            util.toString(methodName) + "'";
	        throw new Promise.TypeError(message);
	    }
	    return fn;
	}
	
	function caller(obj) {
	    var methodName = this.pop();
	    var fn = ensureMethod(obj, methodName);
	    return fn.apply(obj, this);
	}
	Promise.prototype.call = function (methodName) {
	    var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	    if (true) {
	        if (canEvaluate) {
	            var maybeCaller = getMethodCaller(methodName);
	            if (maybeCaller !== null) {
	                return this._then(
	                    maybeCaller, undefined, undefined, args, undefined);
	            }
	        }
	    }
	    args.push(methodName);
	    return this._then(caller, undefined, undefined, args, undefined);
	};
	
	function namedGetter(obj) {
	    return obj[this];
	}
	function indexedGetter(obj) {
	    var index = +this;
	    if (index < 0) index = Math.max(0, index + obj.length);
	    return obj[index];
	}
	Promise.prototype.get = function (propertyName) {
	    var isIndex = (typeof propertyName === "number");
	    var getter;
	    if (!isIndex) {
	        if (canEvaluate) {
	            var maybeGetter = getGetter(propertyName);
	            getter = maybeGetter !== null ? maybeGetter : namedGetter;
	        } else {
	            getter = namedGetter;
	        }
	    } else {
	        getter = indexedGetter;
	    }
	    return this._then(getter, undefined, undefined, propertyName, undefined);
	};
	};


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, PromiseArray, apiRejection, debug) {
	var util = __webpack_require__(73);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	Promise.prototype["break"] = Promise.prototype.cancel = function() {
	    if (!debug.cancellation()) return this._warn("cancellation is disabled");
	
	    var promise = this;
	    var child = promise;
	    while (promise._isCancellable()) {
	        if (!promise._cancelBy(child)) {
	            if (child._isFollowing()) {
	                child._followee().cancel();
	            } else {
	                child._cancelBranched();
	            }
	            break;
	        }
	
	        var parent = promise._cancellationParent;
	        if (parent == null || !parent._isCancellable()) {
	            if (promise._isFollowing()) {
	                promise._followee().cancel();
	            } else {
	                promise._cancelBranched();
	            }
	            break;
	        } else {
	            if (promise._isFollowing()) promise._followee().cancel();
	            promise._setWillBeCancelled();
	            child = promise;
	            promise = parent;
	        }
	    }
	};
	
	Promise.prototype._branchHasCancelled = function() {
	    this._branchesRemainingToCancel--;
	};
	
	Promise.prototype._enoughBranchesHaveCancelled = function() {
	    return this._branchesRemainingToCancel === undefined ||
	           this._branchesRemainingToCancel <= 0;
	};
	
	Promise.prototype._cancelBy = function(canceller) {
	    if (canceller === this) {
	        this._branchesRemainingToCancel = 0;
	        this._invokeOnCancel();
	        return true;
	    } else {
	        this._branchHasCancelled();
	        if (this._enoughBranchesHaveCancelled()) {
	            this._invokeOnCancel();
	            return true;
	        }
	    }
	    return false;
	};
	
	Promise.prototype._cancelBranched = function() {
	    if (this._enoughBranchesHaveCancelled()) {
	        this._cancel();
	    }
	};
	
	Promise.prototype._cancel = function() {
	    if (!this._isCancellable()) return;
	    this._setCancelled();
	    async.invoke(this._cancelPromises, this, undefined);
	};
	
	Promise.prototype._cancelPromises = function() {
	    if (this._length() > 0) this._settlePromises();
	};
	
	Promise.prototype._unsetOnCancel = function() {
	    this._onCancelField = undefined;
	};
	
	Promise.prototype._isCancellable = function() {
	    return this.isPending() && !this._isCancelled();
	};
	
	Promise.prototype.isCancellable = function() {
	    return this.isPending() && !this.isCancelled();
	};
	
	Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
	    if (util.isArray(onCancelCallback)) {
	        for (var i = 0; i < onCancelCallback.length; ++i) {
	            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
	        }
	    } else if (onCancelCallback !== undefined) {
	        if (typeof onCancelCallback === "function") {
	            if (!internalOnly) {
	                var e = tryCatch(onCancelCallback).call(this._boundValue());
	                if (e === errorObj) {
	                    this._attachExtraTrace(e.e);
	                    async.throwLater(e.e);
	                }
	            }
	        } else {
	            onCancelCallback._resultCancelled(this);
	        }
	    }
	};
	
	Promise.prototype._invokeOnCancel = function() {
	    var onCancelCallback = this._onCancel();
	    this._unsetOnCancel();
	    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
	};
	
	Promise.prototype._invokeInternalOnCancel = function() {
	    if (this._isCancellable()) {
	        this._doInvokeOnCancel(this._onCancel(), true);
	        this._unsetOnCancel();
	    }
	};
	
	Promise.prototype._resultCancelled = function() {
	    this.cancel();
	};
	
	};


/***/ }),
/* 1010 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var longStackTraces = false;
	var contextStack = [];
	
	Promise.prototype._promiseCreated = function() {};
	Promise.prototype._pushContext = function() {};
	Promise.prototype._popContext = function() {return null;};
	Promise._peekContext = Promise.prototype._peekContext = function() {};
	
	function Context() {
	    this._trace = new Context.CapturedTrace(peekContext());
	}
	Context.prototype._pushContext = function () {
	    if (this._trace !== undefined) {
	        this._trace._promiseCreated = null;
	        contextStack.push(this._trace);
	    }
	};
	
	Context.prototype._popContext = function () {
	    if (this._trace !== undefined) {
	        var trace = contextStack.pop();
	        var ret = trace._promiseCreated;
	        trace._promiseCreated = null;
	        return ret;
	    }
	    return null;
	};
	
	function createContext() {
	    if (longStackTraces) return new Context();
	}
	
	function peekContext() {
	    var lastIndex = contextStack.length - 1;
	    if (lastIndex >= 0) {
	        return contextStack[lastIndex];
	    }
	    return undefined;
	}
	Context.CapturedTrace = null;
	Context.create = createContext;
	Context.deactivateLongStackTraces = function() {};
	Context.activateLongStackTraces = function() {
	    var Promise_pushContext = Promise.prototype._pushContext;
	    var Promise_popContext = Promise.prototype._popContext;
	    var Promise_PeekContext = Promise._peekContext;
	    var Promise_peekContext = Promise.prototype._peekContext;
	    var Promise_promiseCreated = Promise.prototype._promiseCreated;
	    Context.deactivateLongStackTraces = function() {
	        Promise.prototype._pushContext = Promise_pushContext;
	        Promise.prototype._popContext = Promise_popContext;
	        Promise._peekContext = Promise_PeekContext;
	        Promise.prototype._peekContext = Promise_peekContext;
	        Promise.prototype._promiseCreated = Promise_promiseCreated;
	        longStackTraces = false;
	    };
	    longStackTraces = true;
	    Promise.prototype._pushContext = Context.prototype._pushContext;
	    Promise.prototype._popContext = Context.prototype._popContext;
	    Promise._peekContext = Promise.prototype._peekContext = peekContext;
	    Promise.prototype._promiseCreated = function() {
	        var ctx = this._peekContext();
	        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
	    };
	};
	return Context;
	};


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function(Promise, Context) {
	var getDomain = Promise._getDomain;
	var async = Promise._async;
	var Warning = __webpack_require__(178).Warning;
	var util = __webpack_require__(73);
	var es5 = __webpack_require__(196);
	var canAttachTrace = util.canAttachTrace;
	var unhandledRejectionHandled;
	var possiblyUnhandledRejection;
	var bluebirdFramePattern =
	    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
	var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
	var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
	var stackFramePattern = null;
	var formatStack = null;
	var indentStackFrames = false;
	var printWarning;
	var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
	                        (false ||
	                         util.env("BLUEBIRD_DEBUG") ||
	                         util.env("NODE_ENV") === "development"));
	
	var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
	    (debugging || util.env("BLUEBIRD_WARNINGS")));
	
	var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
	    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
	
	var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
	    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
	
	Promise.prototype.suppressUnhandledRejections = function() {
	    var target = this._target();
	    target._bitField = ((target._bitField & (~1048576)) |
	                      524288);
	};
	
	Promise.prototype._ensurePossibleRejectionHandled = function () {
	    if ((this._bitField & 524288) !== 0) return;
	    this._setRejectionIsUnhandled();
	    var self = this;
	    setTimeout(function() {
	        self._notifyUnhandledRejection();
	    }, 1);
	};
	
	Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
	    fireRejectionEvent("rejectionHandled",
	                                  unhandledRejectionHandled, undefined, this);
	};
	
	Promise.prototype._setReturnedNonUndefined = function() {
	    this._bitField = this._bitField | 268435456;
	};
	
	Promise.prototype._returnedNonUndefined = function() {
	    return (this._bitField & 268435456) !== 0;
	};
	
	Promise.prototype._notifyUnhandledRejection = function () {
	    if (this._isRejectionUnhandled()) {
	        var reason = this._settledValue();
	        this._setUnhandledRejectionIsNotified();
	        fireRejectionEvent("unhandledRejection",
	                                      possiblyUnhandledRejection, reason, this);
	    }
	};
	
	Promise.prototype._setUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField | 262144;
	};
	
	Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField & (~262144);
	};
	
	Promise.prototype._isUnhandledRejectionNotified = function () {
	    return (this._bitField & 262144) > 0;
	};
	
	Promise.prototype._setRejectionIsUnhandled = function () {
	    this._bitField = this._bitField | 1048576;
	};
	
	Promise.prototype._unsetRejectionIsUnhandled = function () {
	    this._bitField = this._bitField & (~1048576);
	    if (this._isUnhandledRejectionNotified()) {
	        this._unsetUnhandledRejectionIsNotified();
	        this._notifyUnhandledRejectionIsHandled();
	    }
	};
	
	Promise.prototype._isRejectionUnhandled = function () {
	    return (this._bitField & 1048576) > 0;
	};
	
	Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
	    return warn(message, shouldUseOwnTrace, promise || this);
	};
	
	Promise.onPossiblyUnhandledRejection = function (fn) {
	    var domain = getDomain();
	    possiblyUnhandledRejection =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	Promise.onUnhandledRejectionHandled = function (fn) {
	    var domain = getDomain();
	    unhandledRejectionHandled =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	var disableLongStackTraces = function() {};
	Promise.longStackTraces = function () {
	    if (async.haveItemsQueued() && !config.longStackTraces) {
	        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (!config.longStackTraces && longStackTracesIsSupported()) {
	        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
	        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
	        var Promise_dereferenceTrace = Promise.prototype._dereferenceTrace;
	        config.longStackTraces = true;
	        disableLongStackTraces = function() {
	            if (async.haveItemsQueued() && !config.longStackTraces) {
	                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	            }
	            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
	            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
	            Promise.prototype._dereferenceTrace = Promise_dereferenceTrace;
	            Context.deactivateLongStackTraces();
	            async.enableTrampoline();
	            config.longStackTraces = false;
	        };
	        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
	        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
	        Promise.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
	        Context.activateLongStackTraces();
	        async.disableTrampolineIfNecessary();
	    }
	};
	
	Promise.hasLongStackTraces = function () {
	    return config.longStackTraces && longStackTracesIsSupported();
	};
	
	var fireDomEvent = (function() {
	    try {
	        if (typeof CustomEvent === "function") {
	            var event = new CustomEvent("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var eventData = {
	                    detail: event,
	                    cancelable: true
	                };
	                es5.defineProperty(
	                    eventData, "promise", {value: event.promise});
	                es5.defineProperty(eventData, "reason", {value: event.reason});
	                var domEvent = new CustomEvent(name.toLowerCase(), eventData);
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else if (typeof Event === "function") {
	            var event = new Event("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = new Event(name.toLowerCase(), {
	                    cancelable: true
	                });
	                domEvent.detail = event;
	                es5.defineProperty(domEvent, "promise", {value: event.promise});
	                es5.defineProperty(domEvent, "reason", {value: event.reason});
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else {
	            var event = document.createEvent("CustomEvent");
	            event.initCustomEvent("testingtheevent", false, true, {});
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = document.createEvent("CustomEvent");
	                domEvent.initCustomEvent(name.toLowerCase(), false, true,
	                    event);
	                return !util.global.dispatchEvent(domEvent);
	            };
	        }
	    } catch (e) {}
	    return function() {
	        return false;
	    };
	})();
	
	var fireGlobalEvent = (function() {
	    if (util.isNode) {
	        return function() {
	            return process.emit.apply(process, arguments);
	        };
	    } else {
	        if (!util.global) {
	            return function() {
	                return false;
	            };
	        }
	        return function(name) {
	            var methodName = "on" + name.toLowerCase();
	            var method = util.global[methodName];
	            if (!method) return false;
	            method.apply(util.global, [].slice.call(arguments, 1));
	            return true;
	        };
	    }
	})();
	
	function generatePromiseLifecycleEventObject(name, promise) {
	    return {promise: promise};
	}
	
	var eventToObjectGenerator = {
	    promiseCreated: generatePromiseLifecycleEventObject,
	    promiseFulfilled: generatePromiseLifecycleEventObject,
	    promiseRejected: generatePromiseLifecycleEventObject,
	    promiseResolved: generatePromiseLifecycleEventObject,
	    promiseCancelled: generatePromiseLifecycleEventObject,
	    promiseChained: function(name, promise, child) {
	        return {promise: promise, child: child};
	    },
	    warning: function(name, warning) {
	        return {warning: warning};
	    },
	    unhandledRejection: function (name, reason, promise) {
	        return {reason: reason, promise: promise};
	    },
	    rejectionHandled: generatePromiseLifecycleEventObject
	};
	
	var activeFireEvent = function (name) {
	    var globalEventFired = false;
	    try {
	        globalEventFired = fireGlobalEvent.apply(null, arguments);
	    } catch (e) {
	        async.throwLater(e);
	        globalEventFired = true;
	    }
	
	    var domEventFired = false;
	    try {
	        domEventFired = fireDomEvent(name,
	                    eventToObjectGenerator[name].apply(null, arguments));
	    } catch (e) {
	        async.throwLater(e);
	        domEventFired = true;
	    }
	
	    return domEventFired || globalEventFired;
	};
	
	Promise.config = function(opts) {
	    opts = Object(opts);
	    if ("longStackTraces" in opts) {
	        if (opts.longStackTraces) {
	            Promise.longStackTraces();
	        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
	            disableLongStackTraces();
	        }
	    }
	    if ("warnings" in opts) {
	        var warningsOption = opts.warnings;
	        config.warnings = !!warningsOption;
	        wForgottenReturn = config.warnings;
	
	        if (util.isObject(warningsOption)) {
	            if ("wForgottenReturn" in warningsOption) {
	                wForgottenReturn = !!warningsOption.wForgottenReturn;
	            }
	        }
	    }
	    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
	        if (async.haveItemsQueued()) {
	            throw new Error(
	                "cannot enable cancellation after promises are in use");
	        }
	        Promise.prototype._clearCancellationData =
	            cancellationClearCancellationData;
	        Promise.prototype._propagateFrom = cancellationPropagateFrom;
	        Promise.prototype._onCancel = cancellationOnCancel;
	        Promise.prototype._setOnCancel = cancellationSetOnCancel;
	        Promise.prototype._attachCancellationCallback =
	            cancellationAttachCancellationCallback;
	        Promise.prototype._execute = cancellationExecute;
	        propagateFromFunction = cancellationPropagateFrom;
	        config.cancellation = true;
	    }
	    if ("monitoring" in opts) {
	        if (opts.monitoring && !config.monitoring) {
	            config.monitoring = true;
	            Promise.prototype._fireEvent = activeFireEvent;
	        } else if (!opts.monitoring && config.monitoring) {
	            config.monitoring = false;
	            Promise.prototype._fireEvent = defaultFireEvent;
	        }
	    }
	    return Promise;
	};
	
	function defaultFireEvent() { return false; }
	
	Promise.prototype._fireEvent = defaultFireEvent;
	Promise.prototype._execute = function(executor, resolve, reject) {
	    try {
	        executor(resolve, reject);
	    } catch (e) {
	        return e;
	    }
	};
	Promise.prototype._onCancel = function () {};
	Promise.prototype._setOnCancel = function (handler) { ; };
	Promise.prototype._attachCancellationCallback = function(onCancel) {
	    ;
	};
	Promise.prototype._captureStackTrace = function () {};
	Promise.prototype._attachExtraTrace = function () {};
	Promise.prototype._dereferenceTrace = function () {};
	Promise.prototype._clearCancellationData = function() {};
	Promise.prototype._propagateFrom = function (parent, flags) {
	    ;
	    ;
	};
	
	function cancellationExecute(executor, resolve, reject) {
	    var promise = this;
	    try {
	        executor(resolve, reject, function(onCancel) {
	            if (typeof onCancel !== "function") {
	                throw new TypeError("onCancel must be a function, got: " +
	                                    util.toString(onCancel));
	            }
	            promise._attachCancellationCallback(onCancel);
	        });
	    } catch (e) {
	        return e;
	    }
	}
	
	function cancellationAttachCancellationCallback(onCancel) {
	    if (!this._isCancellable()) return this;
	
	    var previousOnCancel = this._onCancel();
	    if (previousOnCancel !== undefined) {
	        if (util.isArray(previousOnCancel)) {
	            previousOnCancel.push(onCancel);
	        } else {
	            this._setOnCancel([previousOnCancel, onCancel]);
	        }
	    } else {
	        this._setOnCancel(onCancel);
	    }
	}
	
	function cancellationOnCancel() {
	    return this._onCancelField;
	}
	
	function cancellationSetOnCancel(onCancel) {
	    this._onCancelField = onCancel;
	}
	
	function cancellationClearCancellationData() {
	    this._cancellationParent = undefined;
	    this._onCancelField = undefined;
	}
	
	function cancellationPropagateFrom(parent, flags) {
	    if ((flags & 1) !== 0) {
	        this._cancellationParent = parent;
	        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
	        if (branchesRemainingToCancel === undefined) {
	            branchesRemainingToCancel = 0;
	        }
	        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
	    }
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	
	function bindingPropagateFrom(parent, flags) {
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	var propagateFromFunction = bindingPropagateFrom;
	
	function boundValueFunction() {
	    var ret = this._boundTo;
	    if (ret !== undefined) {
	        if (ret instanceof Promise) {
	            if (ret.isFulfilled()) {
	                return ret.value();
	            } else {
	                return undefined;
	            }
	        }
	    }
	    return ret;
	}
	
	function longStackTracesCaptureStackTrace() {
	    this._trace = new CapturedTrace(this._peekContext());
	}
	
	function longStackTracesAttachExtraTrace(error, ignoreSelf) {
	    if (canAttachTrace(error)) {
	        var trace = this._trace;
	        if (trace !== undefined) {
	            if (ignoreSelf) trace = trace._parent;
	        }
	        if (trace !== undefined) {
	            trace.attachExtraTrace(error);
	        } else if (!error.__stackCleaned__) {
	            var parsed = parseStackAndMessage(error);
	            util.notEnumerableProp(error, "stack",
	                parsed.message + "\n" + parsed.stack.join("\n"));
	            util.notEnumerableProp(error, "__stackCleaned__", true);
	        }
	    }
	}
	
	function longStackTracesDereferenceTrace() {
	    this._trace = undefined;
	}
	
	function checkForgottenReturns(returnValue, promiseCreated, name, promise,
	                               parent) {
	    if (returnValue === undefined && promiseCreated !== null &&
	        wForgottenReturn) {
	        if (parent !== undefined && parent._returnedNonUndefined()) return;
	        if ((promise._bitField & 65535) === 0) return;
	
	        if (name) name = name + " ";
	        var handlerLine = "";
	        var creatorLine = "";
	        if (promiseCreated._trace) {
	            var traceLines = promiseCreated._trace.stack.split("\n");
	            var stack = cleanStack(traceLines);
	            for (var i = stack.length - 1; i >= 0; --i) {
	                var line = stack[i];
	                if (!nodeFramePattern.test(line)) {
	                    var lineMatches = line.match(parseLinePattern);
	                    if (lineMatches) {
	                        handlerLine  = "at " + lineMatches[1] +
	                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
	                    }
	                    break;
	                }
	            }
	
	            if (stack.length > 0) {
	                var firstUserLine = stack[0];
	                for (var i = 0; i < traceLines.length; ++i) {
	
	                    if (traceLines[i] === firstUserLine) {
	                        if (i > 0) {
	                            creatorLine = "\n" + traceLines[i - 1];
	                        }
	                        break;
	                    }
	                }
	
	            }
	        }
	        var msg = "a promise was created in a " + name +
	            "handler " + handlerLine + "but was not returned from it, " +
	            "see http://goo.gl/rRqMUw" +
	            creatorLine;
	        promise._warn(msg, true, promiseCreated);
	    }
	}
	
	function deprecated(name, replacement) {
	    var message = name +
	        " is deprecated and will be removed in a future version.";
	    if (replacement) message += " Use " + replacement + " instead.";
	    return warn(message);
	}
	
	function warn(message, shouldUseOwnTrace, promise) {
	    if (!config.warnings) return;
	    var warning = new Warning(message);
	    var ctx;
	    if (shouldUseOwnTrace) {
	        promise._attachExtraTrace(warning);
	    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
	        ctx.attachExtraTrace(warning);
	    } else {
	        var parsed = parseStackAndMessage(warning);
	        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
	    }
	
	    if (!activeFireEvent("warning", warning)) {
	        formatAndLogError(warning, "", true);
	    }
	}
	
	function reconstructStack(message, stacks) {
	    for (var i = 0; i < stacks.length - 1; ++i) {
	        stacks[i].push("From previous event:");
	        stacks[i] = stacks[i].join("\n");
	    }
	    if (i < stacks.length) {
	        stacks[i] = stacks[i].join("\n");
	    }
	    return message + "\n" + stacks.join("\n");
	}
	
	function removeDuplicateOrEmptyJumps(stacks) {
	    for (var i = 0; i < stacks.length; ++i) {
	        if (stacks[i].length === 0 ||
	            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
	            stacks.splice(i, 1);
	            i--;
	        }
	    }
	}
	
	function removeCommonRoots(stacks) {
	    var current = stacks[0];
	    for (var i = 1; i < stacks.length; ++i) {
	        var prev = stacks[i];
	        var currentLastIndex = current.length - 1;
	        var currentLastLine = current[currentLastIndex];
	        var commonRootMeetPoint = -1;
	
	        for (var j = prev.length - 1; j >= 0; --j) {
	            if (prev[j] === currentLastLine) {
	                commonRootMeetPoint = j;
	                break;
	            }
	        }
	
	        for (var j = commonRootMeetPoint; j >= 0; --j) {
	            var line = prev[j];
	            if (current[currentLastIndex] === line) {
	                current.pop();
	                currentLastIndex--;
	            } else {
	                break;
	            }
	        }
	        current = prev;
	    }
	}
	
	function cleanStack(stack) {
	    var ret = [];
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        var isTraceLine = "    (No stack trace)" === line ||
	            stackFramePattern.test(line);
	        var isInternalFrame = isTraceLine && shouldIgnore(line);
	        if (isTraceLine && !isInternalFrame) {
	            if (indentStackFrames && line.charAt(0) !== " ") {
	                line = "    " + line;
	            }
	            ret.push(line);
	        }
	    }
	    return ret;
	}
	
	function stackFramesAsArray(error) {
	    var stack = error.stack.replace(/\s+$/g, "").split("\n");
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
	            break;
	        }
	    }
	    if (i > 0 && error.name != "SyntaxError") {
	        stack = stack.slice(i);
	    }
	    return stack;
	}
	
	function parseStackAndMessage(error) {
	    var stack = error.stack;
	    var message = error.toString();
	    stack = typeof stack === "string" && stack.length > 0
	                ? stackFramesAsArray(error) : ["    (No stack trace)"];
	    return {
	        message: message,
	        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
	    };
	}
	
	function formatAndLogError(error, title, isSoft) {
	    if (typeof console !== "undefined") {
	        var message;
	        if (util.isObject(error)) {
	            var stack = error.stack;
	            message = title + formatStack(stack, error);
	        } else {
	            message = title + String(error);
	        }
	        if (typeof printWarning === "function") {
	            printWarning(message, isSoft);
	        } else if (typeof console.log === "function" ||
	            typeof console.log === "object") {
	            console.log(message);
	        }
	    }
	}
	
	function fireRejectionEvent(name, localHandler, reason, promise) {
	    var localEventFired = false;
	    try {
	        if (typeof localHandler === "function") {
	            localEventFired = true;
	            if (name === "rejectionHandled") {
	                localHandler(promise);
	            } else {
	                localHandler(reason, promise);
	            }
	        }
	    } catch (e) {
	        async.throwLater(e);
	    }
	
	    if (name === "unhandledRejection") {
	        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
	            formatAndLogError(reason, "Unhandled rejection ");
	        }
	    } else {
	        activeFireEvent(name, promise);
	    }
	}
	
	function formatNonError(obj) {
	    var str;
	    if (typeof obj === "function") {
	        str = "[function " +
	            (obj.name || "anonymous") +
	            "]";
	    } else {
	        str = obj && typeof obj.toString === "function"
	            ? obj.toString() : util.toString(obj);
	        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
	        if (ruselessToString.test(str)) {
	            try {
	                var newStr = JSON.stringify(obj);
	                str = newStr;
	            }
	            catch(e) {
	
	            }
	        }
	        if (str.length === 0) {
	            str = "(empty array)";
	        }
	    }
	    return ("(<" + snip(str) + ">, no stack trace)");
	}
	
	function snip(str) {
	    var maxChars = 41;
	    if (str.length < maxChars) {
	        return str;
	    }
	    return str.substr(0, maxChars - 3) + "...";
	}
	
	function longStackTracesIsSupported() {
	    return typeof captureStackTrace === "function";
	}
	
	var shouldIgnore = function() { return false; };
	var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
	function parseLineInfo(line) {
	    var matches = line.match(parseLineInfoRegex);
	    if (matches) {
	        return {
	            fileName: matches[1],
	            line: parseInt(matches[2], 10)
	        };
	    }
	}
	
	function setBounds(firstLineError, lastLineError) {
	    if (!longStackTracesIsSupported()) return;
	    var firstStackLines = (firstLineError.stack || "").split("\n");
	    var lastStackLines = (lastLineError.stack || "").split("\n");
	    var firstIndex = -1;
	    var lastIndex = -1;
	    var firstFileName;
	    var lastFileName;
	    for (var i = 0; i < firstStackLines.length; ++i) {
	        var result = parseLineInfo(firstStackLines[i]);
	        if (result) {
	            firstFileName = result.fileName;
	            firstIndex = result.line;
	            break;
	        }
	    }
	    for (var i = 0; i < lastStackLines.length; ++i) {
	        var result = parseLineInfo(lastStackLines[i]);
	        if (result) {
	            lastFileName = result.fileName;
	            lastIndex = result.line;
	            break;
	        }
	    }
	    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
	        firstFileName !== lastFileName || firstIndex >= lastIndex) {
	        return;
	    }
	
	    shouldIgnore = function(line) {
	        if (bluebirdFramePattern.test(line)) return true;
	        var info = parseLineInfo(line);
	        if (info) {
	            if (info.fileName === firstFileName &&
	                (firstIndex <= info.line && info.line <= lastIndex)) {
	                return true;
	            }
	        }
	        return false;
	    };
	}
	
	function CapturedTrace(parent) {
	    this._parent = parent;
	    this._promisesCreated = 0;
	    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
	    captureStackTrace(this, CapturedTrace);
	    if (length > 32) this.uncycle();
	}
	util.inherits(CapturedTrace, Error);
	Context.CapturedTrace = CapturedTrace;
	
	CapturedTrace.prototype.uncycle = function() {
	    var length = this._length;
	    if (length < 2) return;
	    var nodes = [];
	    var stackToIndex = {};
	
	    for (var i = 0, node = this; node !== undefined; ++i) {
	        nodes.push(node);
	        node = node._parent;
	    }
	    length = this._length = i;
	    for (var i = length - 1; i >= 0; --i) {
	        var stack = nodes[i].stack;
	        if (stackToIndex[stack] === undefined) {
	            stackToIndex[stack] = i;
	        }
	    }
	    for (var i = 0; i < length; ++i) {
	        var currentStack = nodes[i].stack;
	        var index = stackToIndex[currentStack];
	        if (index !== undefined && index !== i) {
	            if (index > 0) {
	                nodes[index - 1]._parent = undefined;
	                nodes[index - 1]._length = 1;
	            }
	            nodes[i]._parent = undefined;
	            nodes[i]._length = 1;
	            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
	
	            if (index < length - 1) {
	                cycleEdgeNode._parent = nodes[index + 1];
	                cycleEdgeNode._parent.uncycle();
	                cycleEdgeNode._length =
	                    cycleEdgeNode._parent._length + 1;
	            } else {
	                cycleEdgeNode._parent = undefined;
	                cycleEdgeNode._length = 1;
	            }
	            var currentChildLength = cycleEdgeNode._length + 1;
	            for (var j = i - 2; j >= 0; --j) {
	                nodes[j]._length = currentChildLength;
	                currentChildLength++;
	            }
	            return;
	        }
	    }
	};
	
	CapturedTrace.prototype.attachExtraTrace = function(error) {
	    if (error.__stackCleaned__) return;
	    this.uncycle();
	    var parsed = parseStackAndMessage(error);
	    var message = parsed.message;
	    var stacks = [parsed.stack];
	
	    var trace = this;
	    while (trace !== undefined) {
	        stacks.push(cleanStack(trace.stack.split("\n")));
	        trace = trace._parent;
	    }
	    removeCommonRoots(stacks);
	    removeDuplicateOrEmptyJumps(stacks);
	    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
	    util.notEnumerableProp(error, "__stackCleaned__", true);
	};
	
	var captureStackTrace = (function stackDetection() {
	    var v8stackFramePattern = /^\s*at\s*/;
	    var v8stackFormatter = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if (error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    if (typeof Error.stackTraceLimit === "number" &&
	        typeof Error.captureStackTrace === "function") {
	        Error.stackTraceLimit += 6;
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        var captureStackTrace = Error.captureStackTrace;
	
	        shouldIgnore = function(line) {
	            return bluebirdFramePattern.test(line);
	        };
	        return function(receiver, ignoreUntil) {
	            Error.stackTraceLimit += 6;
	            captureStackTrace(receiver, ignoreUntil);
	            Error.stackTraceLimit -= 6;
	        };
	    }
	    var err = new Error();
	
	    if (typeof err.stack === "string" &&
	        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
	        stackFramePattern = /@/;
	        formatStack = v8stackFormatter;
	        indentStackFrames = true;
	        return function captureStackTrace(o) {
	            o.stack = new Error().stack;
	        };
	    }
	
	    var hasStackAfterThrow;
	    try { throw new Error(); }
	    catch(e) {
	        hasStackAfterThrow = ("stack" in e);
	    }
	    if (!("stack" in err) && hasStackAfterThrow &&
	        typeof Error.stackTraceLimit === "number") {
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        return function captureStackTrace(o) {
	            Error.stackTraceLimit += 6;
	            try { throw new Error(); }
	            catch(e) { o.stack = e.stack; }
	            Error.stackTraceLimit -= 6;
	        };
	    }
	
	    formatStack = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if ((typeof error === "object" ||
	            typeof error === "function") &&
	            error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    return null;
	
	})([]);
	
	if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
	    printWarning = function (message) {
	        console.warn(message);
	    };
	    if (util.isNode && process.stderr.isTTY) {
	        printWarning = function(message, isSoft) {
	            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
	            console.warn(color + message + "\u001b[0m\n");
	        };
	    } else if (!util.isNode && typeof (new Error().stack) === "string") {
	        printWarning = function(message, isSoft) {
	            console.warn("%c" + message,
	                        isSoft ? "color: darkorange" : "color: red");
	        };
	    }
	}
	
	var config = {
	    warnings: warnings,
	    longStackTraces: false,
	    cancellation: false,
	    monitoring: false
	};
	
	if (longStackTraces) Promise.longStackTraces();
	
	return {
	    longStackTraces: function() {
	        return config.longStackTraces;
	    },
	    warnings: function() {
	        return config.warnings;
	    },
	    cancellation: function() {
	        return config.cancellation;
	    },
	    monitoring: function() {
	        return config.monitoring;
	    },
	    propagateFromFunction: function() {
	        return propagateFromFunction;
	    },
	    boundValueFunction: function() {
	        return boundValueFunction;
	    },
	    checkForgottenReturns: checkForgottenReturns,
	    setBounds: setBounds,
	    warn: warn,
	    deprecated: deprecated,
	    CapturedTrace: CapturedTrace,
	    fireDomEvent: fireDomEvent,
	    fireGlobalEvent: fireGlobalEvent
	};
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(140)))

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function returner() {
	    return this.value;
	}
	function thrower() {
	    throw this.reason;
	}
	
	Promise.prototype["return"] =
	Promise.prototype.thenReturn = function (value) {
	    if (value instanceof Promise) value.suppressUnhandledRejections();
	    return this._then(
	        returner, undefined, undefined, {value: value}, undefined);
	};
	
	Promise.prototype["throw"] =
	Promise.prototype.thenThrow = function (reason) {
	    return this._then(
	        thrower, undefined, undefined, {reason: reason}, undefined);
	};
	
	Promise.prototype.catchThrow = function (reason) {
	    if (arguments.length <= 1) {
	        return this._then(
	            undefined, thrower, undefined, {reason: reason}, undefined);
	    } else {
	        var _reason = arguments[1];
	        var handler = function() {throw _reason;};
	        return this.caught(reason, handler);
	    }
	};
	
	Promise.prototype.catchReturn = function (value) {
	    if (arguments.length <= 1) {
	        if (value instanceof Promise) value.suppressUnhandledRejections();
	        return this._then(
	            undefined, returner, undefined, {value: value}, undefined);
	    } else {
	        var _value = arguments[1];
	        if (_value instanceof Promise) _value.suppressUnhandledRejections();
	        var handler = function() {return _value;};
	        return this.caught(value, handler);
	    }
	};
	};


/***/ }),
/* 1013 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseReduce = Promise.reduce;
	var PromiseAll = Promise.all;
	
	function promiseAllThis() {
	    return PromiseAll(this);
	}
	
	function PromiseMapSeries(promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
	}
	
	Promise.prototype.each = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, this, undefined);
	};
	
	Promise.prototype.mapSeries = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
	};
	
	Promise.each = function (promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, promises, undefined);
	};
	
	Promise.mapSeries = PromiseMapSeries;
	};
	


/***/ }),
/* 1014 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseMap = Promise.map;
	
	Promise.prototype.filter = function (fn, options) {
	    return PromiseMap(this, fn, options, INTERNAL);
	};
	
	Promise.filter = function (promises, fn, options) {
	    return PromiseMap(promises, fn, options, INTERNAL);
	};
	};


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
	var util = __webpack_require__(73);
	var CancellationError = Promise.CancellationError;
	var errorObj = util.errorObj;
	var catchFilter = __webpack_require__(594)(NEXT_FILTER);
	
	function PassThroughHandlerContext(promise, type, handler) {
	    this.promise = promise;
	    this.type = type;
	    this.handler = handler;
	    this.called = false;
	    this.cancelPromise = null;
	}
	
	PassThroughHandlerContext.prototype.isFinallyHandler = function() {
	    return this.type === 0;
	};
	
	function FinallyHandlerCancelReaction(finallyHandler) {
	    this.finallyHandler = finallyHandler;
	}
	
	FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
	    checkCancel(this.finallyHandler);
	};
	
	function checkCancel(ctx, reason) {
	    if (ctx.cancelPromise != null) {
	        if (arguments.length > 1) {
	            ctx.cancelPromise._reject(reason);
	        } else {
	            ctx.cancelPromise._cancel();
	        }
	        ctx.cancelPromise = null;
	        return true;
	    }
	    return false;
	}
	
	function succeed() {
	    return finallyHandler.call(this, this.promise._target()._settledValue());
	}
	function fail(reason) {
	    if (checkCancel(this, reason)) return;
	    errorObj.e = reason;
	    return errorObj;
	}
	function finallyHandler(reasonOrValue) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    if (!this.called) {
	        this.called = true;
	        var ret = this.isFinallyHandler()
	            ? handler.call(promise._boundValue())
	            : handler.call(promise._boundValue(), reasonOrValue);
	        if (ret === NEXT_FILTER) {
	            return ret;
	        } else if (ret !== undefined) {
	            promise._setReturnedNonUndefined();
	            var maybePromise = tryConvertToPromise(ret, promise);
	            if (maybePromise instanceof Promise) {
	                if (this.cancelPromise != null) {
	                    if (maybePromise._isCancelled()) {
	                        var reason =
	                            new CancellationError("late cancellation observer");
	                        promise._attachExtraTrace(reason);
	                        errorObj.e = reason;
	                        return errorObj;
	                    } else if (maybePromise.isPending()) {
	                        maybePromise._attachCancellationCallback(
	                            new FinallyHandlerCancelReaction(this));
	                    }
	                }
	                return maybePromise._then(
	                    succeed, fail, undefined, this, undefined);
	            }
	        }
	    }
	
	    if (promise.isRejected()) {
	        checkCancel(this);
	        errorObj.e = reasonOrValue;
	        return errorObj;
	    } else {
	        checkCancel(this);
	        return reasonOrValue;
	    }
	}
	
	Promise.prototype._passThrough = function(handler, type, success, fail) {
	    if (typeof handler !== "function") return this.then();
	    return this._then(success,
	                      fail,
	                      undefined,
	                      new PassThroughHandlerContext(this, type, handler),
	                      undefined);
	};
	
	Promise.prototype.lastly =
	Promise.prototype["finally"] = function (handler) {
	    return this._passThrough(handler,
	                             0,
	                             finallyHandler,
	                             finallyHandler);
	};
	
	
	Promise.prototype.tap = function (handler) {
	    return this._passThrough(handler, 1, finallyHandler);
	};
	
	Promise.prototype.tapCatch = function (handlerOrPredicate) {
	    var len = arguments.length;
	    if(len === 1) {
	        return this._passThrough(handlerOrPredicate,
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    } else {
	         var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return Promise.reject(new TypeError(
	                    "tapCatch statement predicate: "
	                    + "expecting an object but got " + util.classString(item)
	                ));
	            }
	        }
	        catchInstances.length = j;
	        var handler = arguments[i];
	        return this._passThrough(catchFilter(catchInstances, handler, this),
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    }
	
	};
	
	return PassThroughHandlerContext;
	};


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          apiRejection,
	                          INTERNAL,
	                          tryConvertToPromise,
	                          Proxyable,
	                          debug) {
	var errors = __webpack_require__(178);
	var TypeError = errors.TypeError;
	var util = __webpack_require__(73);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	var yieldHandlers = [];
	
	function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
	    for (var i = 0; i < yieldHandlers.length; ++i) {
	        traceParent._pushContext();
	        var result = tryCatch(yieldHandlers[i])(value);
	        traceParent._popContext();
	        if (result === errorObj) {
	            traceParent._pushContext();
	            var ret = Promise.reject(errorObj.e);
	            traceParent._popContext();
	            return ret;
	        }
	        var maybePromise = tryConvertToPromise(result, traceParent);
	        if (maybePromise instanceof Promise) return maybePromise;
	    }
	    return null;
	}
	
	function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
	    if (debug.cancellation()) {
	        var internal = new Promise(INTERNAL);
	        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
	        this._promise = internal.lastly(function() {
	            return _finallyPromise;
	        });
	        internal._captureStackTrace();
	        internal._setOnCancel(this);
	    } else {
	        var promise = this._promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	    }
	    this._stack = stack;
	    this._generatorFunction = generatorFunction;
	    this._receiver = receiver;
	    this._generator = undefined;
	    this._yieldHandlers = typeof yieldHandler === "function"
	        ? [yieldHandler].concat(yieldHandlers)
	        : yieldHandlers;
	    this._yieldedPromise = null;
	    this._cancellationPhase = false;
	}
	util.inherits(PromiseSpawn, Proxyable);
	
	PromiseSpawn.prototype._isResolved = function() {
	    return this._promise === null;
	};
	
	PromiseSpawn.prototype._cleanup = function() {
	    this._promise = this._generator = null;
	    if (debug.cancellation() && this._finallyPromise !== null) {
	        this._finallyPromise._fulfill();
	        this._finallyPromise = null;
	    }
	};
	
	PromiseSpawn.prototype._promiseCancelled = function() {
	    if (this._isResolved()) return;
	    var implementsReturn = typeof this._generator["return"] !== "undefined";
	
	    var result;
	    if (!implementsReturn) {
	        var reason = new Promise.CancellationError(
	            "generator .return() sentinel");
	        Promise.coroutine.returnSentinel = reason;
	        this._promise._attachExtraTrace(reason);
	        this._promise._pushContext();
	        result = tryCatch(this._generator["throw"]).call(this._generator,
	                                                         reason);
	        this._promise._popContext();
	    } else {
	        this._promise._pushContext();
	        result = tryCatch(this._generator["return"]).call(this._generator,
	                                                          undefined);
	        this._promise._popContext();
	    }
	    this._cancellationPhase = true;
	    this._yieldedPromise = null;
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseFulfilled = function(value) {
	    this._yieldedPromise = null;
	    this._promise._pushContext();
	    var result = tryCatch(this._generator.next).call(this._generator, value);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseRejected = function(reason) {
	    this._yieldedPromise = null;
	    this._promise._attachExtraTrace(reason);
	    this._promise._pushContext();
	    var result = tryCatch(this._generator["throw"])
	        .call(this._generator, reason);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._resultCancelled = function() {
	    if (this._yieldedPromise instanceof Promise) {
	        var promise = this._yieldedPromise;
	        this._yieldedPromise = null;
	        promise.cancel();
	    }
	};
	
	PromiseSpawn.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseSpawn.prototype._run = function () {
	    this._generator = this._generatorFunction.call(this._receiver);
	    this._receiver =
	        this._generatorFunction = undefined;
	    this._promiseFulfilled(undefined);
	};
	
	PromiseSpawn.prototype._continue = function (result) {
	    var promise = this._promise;
	    if (result === errorObj) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._rejectCallback(result.e, false);
	        }
	    }
	
	    var value = result.value;
	    if (result.done === true) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._resolveCallback(value);
	        }
	    } else {
	        var maybePromise = tryConvertToPromise(value, this._promise);
	        if (!(maybePromise instanceof Promise)) {
	            maybePromise =
	                promiseFromYieldHandler(maybePromise,
	                                        this._yieldHandlers,
	                                        this._promise);
	            if (maybePromise === null) {
	                this._promiseRejected(
	                    new TypeError(
	                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
	                        "From coroutine:\u000a" +
	                        this._stack.split("\n").slice(1, -7).join("\n")
	                    )
	                );
	                return;
	            }
	        }
	        maybePromise = maybePromise._target();
	        var bitField = maybePromise._bitField;
	        ;
	        if (((bitField & 50397184) === 0)) {
	            this._yieldedPromise = maybePromise;
	            maybePromise._proxy(this, null);
	        } else if (((bitField & 33554432) !== 0)) {
	            Promise._async.invoke(
	                this._promiseFulfilled, this, maybePromise._value()
	            );
	        } else if (((bitField & 16777216) !== 0)) {
	            Promise._async.invoke(
	                this._promiseRejected, this, maybePromise._reason()
	            );
	        } else {
	            this._promiseCancelled();
	        }
	    }
	};
	
	Promise.coroutine = function (generatorFunction, options) {
	    if (typeof generatorFunction !== "function") {
	        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var yieldHandler = Object(options).yieldHandler;
	    var PromiseSpawn$ = PromiseSpawn;
	    var stack = new Error().stack;
	    return function () {
	        var generator = generatorFunction.apply(this, arguments);
	        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
	                                      stack);
	        var ret = spawn.promise();
	        spawn._generator = generator;
	        spawn._promiseFulfilled(undefined);
	        return ret;
	    };
	};
	
	Promise.coroutine.addYieldHandler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    yieldHandlers.push(fn);
	};
	
	Promise.spawn = function (generatorFunction) {
	    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
	    if (typeof generatorFunction !== "function") {
	        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var spawn = new PromiseSpawn(generatorFunction, this);
	    var ret = spawn.promise();
	    spawn._run(Promise.spawn);
	    return ret;
	};
	};


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async,
	         getDomain) {
	var util = __webpack_require__(73);
	var canEvaluate = util.canEvaluate;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var reject;
	
	if (true) {
	if (canEvaluate) {
	    var thenCallback = function(i) {
	        return new Function("value", "holder", "                             \n\
	            'use strict';                                                    \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
	    };
	
	    var promiseSetter = function(i) {
	        return new Function("promise", "holder", "                           \n\
	            'use strict';                                                    \n\
	            holder.pIndex = promise;                                         \n\
	            ".replace(/Index/g, i));
	    };
	
	    var generateHolderClass = function(total) {
	        var props = new Array(total);
	        for (var i = 0; i < props.length; ++i) {
	            props[i] = "this.p" + (i+1);
	        }
	        var assignment = props.join(" = ") + " = null;";
	        var cancellationCode= "var promise;\n" + props.map(function(prop) {
	            return "                                                         \n\
	                promise = " + prop + ";                                      \n\
	                if (promise instanceof Promise) {                            \n\
	                    promise.cancel();                                        \n\
	                }                                                            \n\
	            ";
	        }).join("\n");
	        var passedArguments = props.join(", ");
	        var name = "Holder$" + total;
	
	
	        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
	            'use strict';                                                    \n\
	            function [TheName](fn) {                                         \n\
	                [TheProperties]                                              \n\
	                this.fn = fn;                                                \n\
	                this.asyncNeeded = true;                                     \n\
	                this.now = 0;                                                \n\
	            }                                                                \n\
	                                                                             \n\
	            [TheName].prototype._callFunction = function(promise) {          \n\
	                promise._pushContext();                                      \n\
	                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
	                promise._popContext();                                       \n\
	                if (ret === errorObj) {                                      \n\
	                    promise._rejectCallback(ret.e, false);                   \n\
	                } else {                                                     \n\
	                    promise._resolveCallback(ret);                           \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype.checkFulfillment = function(promise) {       \n\
	                var now = ++this.now;                                        \n\
	                if (now === [TheTotal]) {                                    \n\
	                    if (this.asyncNeeded) {                                  \n\
	                        async.invoke(this._callFunction, this, promise);     \n\
	                    } else {                                                 \n\
	                        this._callFunction(promise);                         \n\
	                    }                                                        \n\
	                                                                             \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype._resultCancelled = function() {              \n\
	                [CancellationCode]                                           \n\
	            };                                                               \n\
	                                                                             \n\
	            return [TheName];                                                \n\
	        }(tryCatch, errorObj, Promise, async);                               \n\
	        ";
	
	        code = code.replace(/\[TheName\]/g, name)
	            .replace(/\[TheTotal\]/g, total)
	            .replace(/\[ThePassedArguments\]/g, passedArguments)
	            .replace(/\[TheProperties\]/g, assignment)
	            .replace(/\[CancellationCode\]/g, cancellationCode);
	
	        return new Function("tryCatch", "errorObj", "Promise", "async", code)
	                           (tryCatch, errorObj, Promise, async);
	    };
	
	    var holderClasses = [];
	    var thenCallbacks = [];
	    var promiseSetters = [];
	
	    for (var i = 0; i < 8; ++i) {
	        holderClasses.push(generateHolderClass(i + 1));
	        thenCallbacks.push(thenCallback(i + 1));
	        promiseSetters.push(promiseSetter(i + 1));
	    }
	
	    reject = function (reason) {
	        this._reject(reason);
	    };
	}}
	
	Promise.join = function () {
	    var last = arguments.length - 1;
	    var fn;
	    if (last > 0 && typeof arguments[last] === "function") {
	        fn = arguments[last];
	        if (true) {
	            if (last <= 8 && canEvaluate) {
	                var ret = new Promise(INTERNAL);
	                ret._captureStackTrace();
	                var HolderClass = holderClasses[last - 1];
	                var holder = new HolderClass(fn);
	                var callbacks = thenCallbacks;
	
	                for (var i = 0; i < last; ++i) {
	                    var maybePromise = tryConvertToPromise(arguments[i], ret);
	                    if (maybePromise instanceof Promise) {
	                        maybePromise = maybePromise._target();
	                        var bitField = maybePromise._bitField;
	                        ;
	                        if (((bitField & 50397184) === 0)) {
	                            maybePromise._then(callbacks[i], reject,
	                                               undefined, ret, holder);
	                            promiseSetters[i](maybePromise, holder);
	                            holder.asyncNeeded = false;
	                        } else if (((bitField & 33554432) !== 0)) {
	                            callbacks[i].call(ret,
	                                              maybePromise._value(), holder);
	                        } else if (((bitField & 16777216) !== 0)) {
	                            ret._reject(maybePromise._reason());
	                        } else {
	                            ret._cancel();
	                        }
	                    } else {
	                        callbacks[i].call(ret, maybePromise, holder);
	                    }
	                }
	
	                if (!ret._isFateSealed()) {
	                    if (holder.asyncNeeded) {
	                        var domain = getDomain();
	                        if (domain !== null) {
	                            holder.fn = util.domainBind(domain, holder.fn);
	                        }
	                    }
	                    ret._setAsyncGuaranteed();
	                    ret._setOnCancel(holder);
	                }
	                return ret;
	            }
	        }
	    }
	    var $_len = arguments.length;var args = new Array($_len); for(var $_i = 0; $_i < $_len; ++$_i) {args[$_i] = arguments[$_i];};
	    if (fn) args.pop();
	    var ret = new PromiseArray(args).promise();
	    return fn !== undefined ? ret.spread(fn) : ret;
	};
	
	};


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(73);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	function MappingPromiseArray(promises, fn, limit, _filter) {
	    this.constructor$(promises);
	    this._promise._captureStackTrace();
	    var domain = getDomain();
	    this._callback = domain === null ? fn : util.domainBind(domain, fn);
	    this._preservedValues = _filter === INTERNAL
	        ? new Array(this.length())
	        : null;
	    this._limit = limit;
	    this._inFlight = 0;
	    this._queue = [];
	    async.invoke(this._asyncInit, this, undefined);
	}
	util.inherits(MappingPromiseArray, PromiseArray);
	
	MappingPromiseArray.prototype._asyncInit = function() {
	    this._init$(undefined, -2);
	};
	
	MappingPromiseArray.prototype._init = function () {};
	
	MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var values = this._values;
	    var length = this.length();
	    var preservedValues = this._preservedValues;
	    var limit = this._limit;
	
	    if (index < 0) {
	        index = (index * -1) - 1;
	        values[index] = value;
	        if (limit >= 1) {
	            this._inFlight--;
	            this._drainQueue();
	            if (this._isResolved()) return true;
	        }
	    } else {
	        if (limit >= 1 && this._inFlight >= limit) {
	            values[index] = value;
	            this._queue.push(index);
	            return false;
	        }
	        if (preservedValues !== null) preservedValues[index] = value;
	
	        var promise = this._promise;
	        var callback = this._callback;
	        var receiver = promise._boundValue();
	        promise._pushContext();
	        var ret = tryCatch(callback).call(receiver, value, index, length);
	        var promiseCreated = promise._popContext();
	        debug.checkForgottenReturns(
	            ret,
	            promiseCreated,
	            preservedValues !== null ? "Promise.filter" : "Promise.map",
	            promise
	        );
	        if (ret === errorObj) {
	            this._reject(ret.e);
	            return true;
	        }
	
	        var maybePromise = tryConvertToPromise(ret, this._promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            var bitField = maybePromise._bitField;
	            ;
	            if (((bitField & 50397184) === 0)) {
	                if (limit >= 1) this._inFlight++;
	                values[index] = maybePromise;
	                maybePromise._proxy(this, (index + 1) * -1);
	                return false;
	            } else if (((bitField & 33554432) !== 0)) {
	                ret = maybePromise._value();
	            } else if (((bitField & 16777216) !== 0)) {
	                this._reject(maybePromise._reason());
	                return true;
	            } else {
	                this._cancel();
	                return true;
	            }
	        }
	        values[index] = ret;
	    }
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= length) {
	        if (preservedValues !== null) {
	            this._filter(values, preservedValues);
	        } else {
	            this._resolve(values);
	        }
	        return true;
	    }
	    return false;
	};
	
	MappingPromiseArray.prototype._drainQueue = function () {
	    var queue = this._queue;
	    var limit = this._limit;
	    var values = this._values;
	    while (queue.length > 0 && this._inFlight < limit) {
	        if (this._isResolved()) return;
	        var index = queue.pop();
	        this._promiseFulfilled(values[index], index);
	    }
	};
	
	MappingPromiseArray.prototype._filter = function (booleans, values) {
	    var len = values.length;
	    var ret = new Array(len);
	    var j = 0;
	    for (var i = 0; i < len; ++i) {
	        if (booleans[i]) ret[j++] = values[i];
	    }
	    ret.length = j;
	    this._resolve(ret);
	};
	
	MappingPromiseArray.prototype.preservedValues = function () {
	    return this._preservedValues;
	};
	
	function map(promises, fn, options, _filter) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	
	    var limit = 0;
	    if (options !== undefined) {
	        if (typeof options === "object" && options !== null) {
	            if (typeof options.concurrency !== "number") {
	                return Promise.reject(
	                    new TypeError("'concurrency' must be a number but it is " +
	                                    util.classString(options.concurrency)));
	            }
	            limit = options.concurrency;
	        } else {
	            return Promise.reject(new TypeError(
	                            "options argument must be an object but it is " +
	                             util.classString(options)));
	        }
	    }
	    limit = typeof limit === "number" &&
	        isFinite(limit) && limit >= 1 ? limit : 0;
	    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
	}
	
	Promise.prototype.map = function (fn, options) {
	    return map(this, fn, options, null);
	};
	
	Promise.map = function (promises, fn, options, _filter) {
	    return map(promises, fn, options, _filter);
	};
	
	
	};


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
	var util = __webpack_require__(73);
	var tryCatch = util.tryCatch;
	
	Promise.method = function (fn) {
	    if (typeof fn !== "function") {
	        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return function () {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._pushContext();
	        var value = tryCatch(fn).apply(this, arguments);
	        var promiseCreated = ret._popContext();
	        debug.checkForgottenReturns(
	            value, promiseCreated, "Promise.method", ret);
	        ret._resolveFromSyncValue(value);
	        return ret;
	    };
	};
	
	Promise.attempt = Promise["try"] = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._pushContext();
	    var value;
	    if (arguments.length > 1) {
	        debug.deprecated("calling Promise.try with more than 1 argument");
	        var arg = arguments[1];
	        var ctx = arguments[2];
	        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
	                                  : tryCatch(fn).call(ctx, arg);
	    } else {
	        value = tryCatch(fn)();
	    }
	    var promiseCreated = ret._popContext();
	    debug.checkForgottenReturns(
	        value, promiseCreated, "Promise.try", ret);
	    ret._resolveFromSyncValue(value);
	    return ret;
	};
	
	Promise.prototype._resolveFromSyncValue = function (value) {
	    if (value === util.errorObj) {
	        this._rejectCallback(value.e, false);
	    } else {
	        this._resolveCallback(value, true);
	    }
	};
	};


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise) {
	var util = __webpack_require__(73);
	var async = Promise._async;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function spreadAdapter(val, nodeback) {
	    var promise = this;
	    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
	    var ret =
	        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	function successAdapter(val, nodeback) {
	    var promise = this;
	    var receiver = promise._boundValue();
	    var ret = val === undefined
	        ? tryCatch(nodeback).call(receiver, null)
	        : tryCatch(nodeback).call(receiver, null, val);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	function errorAdapter(reason, nodeback) {
	    var promise = this;
	    if (!reason) {
	        var newReason = new Error(reason + "");
	        newReason.cause = reason;
	        reason = newReason;
	    }
	    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
	                                                                     options) {
	    if (typeof nodeback == "function") {
	        var adapter = successAdapter;
	        if (options !== undefined && Object(options).spread) {
	            adapter = spreadAdapter;
	        }
	        this._then(
	            adapter,
	            errorAdapter,
	            undefined,
	            this,
	            nodeback
	        );
	    }
	    return this;
	};
	};


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function() {
	var makeSelfResolutionError = function () {
	    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var reflectHandler = function() {
	    return new Promise.PromiseInspection(this._target());
	};
	var apiRejection = function(msg) {
	    return Promise.reject(new TypeError(msg));
	};
	function Proxyable() {}
	var UNDEFINED_BINDING = {};
	var util = __webpack_require__(73);
	
	var getDomain;
	if (util.isNode) {
	    getDomain = function() {
	        var ret = process.domain;
	        if (ret === undefined) ret = null;
	        return ret;
	    };
	} else {
	    getDomain = function() {
	        return null;
	    };
	}
	util.notEnumerableProp(Promise, "_getDomain", getDomain);
	
	var es5 = __webpack_require__(196);
	var Async = __webpack_require__(1005);
	var async = new Async();
	es5.defineProperty(Promise, "_async", {value: async});
	var errors = __webpack_require__(178);
	var TypeError = Promise.TypeError = errors.TypeError;
	Promise.RangeError = errors.RangeError;
	var CancellationError = Promise.CancellationError = errors.CancellationError;
	Promise.TimeoutError = errors.TimeoutError;
	Promise.OperationalError = errors.OperationalError;
	Promise.RejectionError = errors.OperationalError;
	Promise.AggregateError = errors.AggregateError;
	var INTERNAL = function(){};
	var APPLY = {};
	var NEXT_FILTER = {};
	var tryConvertToPromise = __webpack_require__(1032)(Promise, INTERNAL);
	var PromiseArray =
	    __webpack_require__(1022)(Promise, INTERNAL,
	                               tryConvertToPromise, apiRejection, Proxyable);
	var Context = __webpack_require__(1010)(Promise);
	 /*jshint unused:false*/
	var createContext = Context.create;
	var debug = __webpack_require__(1011)(Promise, Context);
	var CapturedTrace = debug.CapturedTrace;
	var PassThroughHandlerContext =
	    __webpack_require__(1015)(Promise, tryConvertToPromise, NEXT_FILTER);
	var catchFilter = __webpack_require__(594)(NEXT_FILTER);
	var nodebackForPromise = __webpack_require__(595);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	function check(self, executor) {
	    if (self == null || self.constructor !== Promise) {
	        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (typeof executor !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(executor));
	    }
	
	}
	
	function Promise(executor) {
	    if (executor !== INTERNAL) {
	        check(this, executor);
	    }
	    this._bitField = 0;
	    this._fulfillmentHandler0 = undefined;
	    this._rejectionHandler0 = undefined;
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._resolveFromExecutor(executor);
	    this._promiseCreated();
	    this._fireEvent("promiseCreated", this);
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
	    var len = arguments.length;
	    if (len > 1) {
	        var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return apiRejection("Catch statement predicate: " +
	                    "expecting an object but got " + util.classString(item));
	            }
	        }
	        catchInstances.length = j;
	        fn = arguments[i];
	
	        if (typeof fn !== "function") {
	            throw new TypeError("The last argument to .catch() " +
	                "must be a function, got " + util.toString(fn));
	        }
	        return this.then(undefined, catchFilter(catchInstances, fn, this));
	    }
	    return this.then(undefined, fn);
	};
	
	Promise.prototype.reflect = function () {
	    return this._then(reflectHandler,
	        reflectHandler, undefined, this, undefined);
	};
	
	Promise.prototype.then = function (didFulfill, didReject) {
	    if (debug.warnings() && arguments.length > 0 &&
	        typeof didFulfill !== "function" &&
	        typeof didReject !== "function") {
	        var msg = ".then() only accepts functions but was passed: " +
	                util.classString(didFulfill);
	        if (arguments.length > 1) {
	            msg += ", " + util.classString(didReject);
	        }
	        this._warn(msg);
	    }
	    return this._then(didFulfill, didReject, undefined, undefined, undefined);
	};
	
	Promise.prototype.done = function (didFulfill, didReject) {
	    var promise =
	        this._then(didFulfill, didReject, undefined, undefined, undefined);
	    promise._setIsFinal();
	};
	
	Promise.prototype.spread = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
	};
	
	Promise.prototype.toJSON = function () {
	    var ret = {
	        isFulfilled: false,
	        isRejected: false,
	        fulfillmentValue: undefined,
	        rejectionReason: undefined
	    };
	    if (this.isFulfilled()) {
	        ret.fulfillmentValue = this.value();
	        ret.isFulfilled = true;
	    } else if (this.isRejected()) {
	        ret.rejectionReason = this.reason();
	        ret.isRejected = true;
	    }
	    return ret;
	};
	
	Promise.prototype.all = function () {
	    if (arguments.length > 0) {
	        this._warn(".all() was passed arguments but it does not take any");
	    }
	    return new PromiseArray(this).promise();
	};
	
	Promise.prototype.error = function (fn) {
	    return this.caught(util.originatesFromRejection, fn);
	};
	
	Promise.getNewLibraryCopy = module.exports;
	
	Promise.is = function (val) {
	    return val instanceof Promise;
	};
	
	Promise.fromNode = Promise.fromCallback = function(fn) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
	                                         : false;
	    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
	    if (result === errorObj) {
	        ret._rejectCallback(result.e, true);
	    }
	    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.all = function (promises) {
	    return new PromiseArray(promises).promise();
	};
	
	Promise.cast = function (obj) {
	    var ret = tryConvertToPromise(obj);
	    if (!(ret instanceof Promise)) {
	        ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._setFulfilled();
	        ret._rejectionHandler0 = obj;
	    }
	    return ret;
	};
	
	Promise.resolve = Promise.fulfilled = Promise.cast;
	
	Promise.reject = Promise.rejected = function (reason) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._rejectCallback(reason, true);
	    return ret;
	};
	
	Promise.setScheduler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return async.setScheduler(fn);
	};
	
	Promise.prototype._then = function (
	    didFulfill,
	    didReject,
	    _,    receiver,
	    internalData
	) {
	    var haveInternalData = internalData !== undefined;
	    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
	    var target = this._target();
	    var bitField = target._bitField;
	
	    if (!haveInternalData) {
	        promise._propagateFrom(this, 3);
	        promise._captureStackTrace();
	        if (receiver === undefined &&
	            ((this._bitField & 2097152) !== 0)) {
	            if (!((bitField & 50397184) === 0)) {
	                receiver = this._boundValue();
	            } else {
	                receiver = target === this ? undefined : this._boundTo;
	            }
	        }
	        this._fireEvent("promiseChained", this, promise);
	    }
	
	    var domain = getDomain();
	    if (!((bitField & 50397184) === 0)) {
	        var handler, value, settler = target._settlePromiseCtx;
	        if (((bitField & 33554432) !== 0)) {
	            value = target._rejectionHandler0;
	            handler = didFulfill;
	        } else if (((bitField & 16777216) !== 0)) {
	            value = target._fulfillmentHandler0;
	            handler = didReject;
	            target._unsetRejectionIsUnhandled();
	        } else {
	            settler = target._settlePromiseLateCancellationObserver;
	            value = new CancellationError("late cancellation observer");
	            target._attachExtraTrace(value);
	            handler = didReject;
	        }
	
	        async.invoke(settler, target, {
	            handler: domain === null ? handler
	                : (typeof handler === "function" &&
	                    util.domainBind(domain, handler)),
	            promise: promise,
	            receiver: receiver,
	            value: value
	        });
	    } else {
	        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
	    }
	
	    return promise;
	};
	
	Promise.prototype._length = function () {
	    return this._bitField & 65535;
	};
	
	Promise.prototype._isFateSealed = function () {
	    return (this._bitField & 117506048) !== 0;
	};
	
	Promise.prototype._isFollowing = function () {
	    return (this._bitField & 67108864) === 67108864;
	};
	
	Promise.prototype._setLength = function (len) {
	    this._bitField = (this._bitField & -65536) |
	        (len & 65535);
	};
	
	Promise.prototype._setFulfilled = function () {
	    this._bitField = this._bitField | 33554432;
	    this._fireEvent("promiseFulfilled", this);
	};
	
	Promise.prototype._setRejected = function () {
	    this._bitField = this._bitField | 16777216;
	    this._fireEvent("promiseRejected", this);
	};
	
	Promise.prototype._setFollowing = function () {
	    this._bitField = this._bitField | 67108864;
	    this._fireEvent("promiseResolved", this);
	};
	
	Promise.prototype._setIsFinal = function () {
	    this._bitField = this._bitField | 4194304;
	};
	
	Promise.prototype._isFinal = function () {
	    return (this._bitField & 4194304) > 0;
	};
	
	Promise.prototype._unsetCancelled = function() {
	    this._bitField = this._bitField & (~65536);
	};
	
	Promise.prototype._setCancelled = function() {
	    this._bitField = this._bitField | 65536;
	    this._fireEvent("promiseCancelled", this);
	};
	
	Promise.prototype._setWillBeCancelled = function() {
	    this._bitField = this._bitField | 8388608;
	};
	
	Promise.prototype._setAsyncGuaranteed = function() {
	    if (async.hasCustomScheduler()) return;
	    this._bitField = this._bitField | 134217728;
	};
	
	Promise.prototype._receiverAt = function (index) {
	    var ret = index === 0 ? this._receiver0 : this[
	            index * 4 - 4 + 3];
	    if (ret === UNDEFINED_BINDING) {
	        return undefined;
	    } else if (ret === undefined && this._isBound()) {
	        return this._boundValue();
	    }
	    return ret;
	};
	
	Promise.prototype._promiseAt = function (index) {
	    return this[
	            index * 4 - 4 + 2];
	};
	
	Promise.prototype._fulfillmentHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 0];
	};
	
	Promise.prototype._rejectionHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 1];
	};
	
	Promise.prototype._boundValue = function() {};
	
	Promise.prototype._migrateCallback0 = function (follower) {
	    var bitField = follower._bitField;
	    var fulfill = follower._fulfillmentHandler0;
	    var reject = follower._rejectionHandler0;
	    var promise = follower._promise0;
	    var receiver = follower._receiverAt(0);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._migrateCallbackAt = function (follower, index) {
	    var fulfill = follower._fulfillmentHandlerAt(index);
	    var reject = follower._rejectionHandlerAt(index);
	    var promise = follower._promiseAt(index);
	    var receiver = follower._receiverAt(index);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._addCallbacks = function (
	    fulfill,
	    reject,
	    promise,
	    receiver,
	    domain
	) {
	    var index = this._length();
	
	    if (index >= 65535 - 4) {
	        index = 0;
	        this._setLength(0);
	    }
	
	    if (index === 0) {
	        this._promise0 = promise;
	        this._receiver0 = receiver;
	        if (typeof fulfill === "function") {
	            this._fulfillmentHandler0 =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this._rejectionHandler0 =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    } else {
	        var base = index * 4 - 4;
	        this[base + 2] = promise;
	        this[base + 3] = receiver;
	        if (typeof fulfill === "function") {
	            this[base + 0] =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this[base + 1] =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    }
	    this._setLength(index + 1);
	    return index;
	};
	
	Promise.prototype._proxy = function (proxyable, arg) {
	    this._addCallbacks(undefined, undefined, arg, proxyable, null);
	};
	
	Promise.prototype._resolveCallback = function(value, shouldBind) {
	    if (((this._bitField & 117506048) !== 0)) return;
	    if (value === this)
	        return this._rejectCallback(makeSelfResolutionError(), false);
	    var maybePromise = tryConvertToPromise(value, this);
	    if (!(maybePromise instanceof Promise)) return this._fulfill(value);
	
	    if (shouldBind) this._propagateFrom(maybePromise, 2);
	
	    var promise = maybePromise._target();
	
	    if (promise === this) {
	        this._reject(makeSelfResolutionError());
	        return;
	    }
	
	    var bitField = promise._bitField;
	    if (((bitField & 50397184) === 0)) {
	        var len = this._length();
	        if (len > 0) promise._migrateCallback0(this);
	        for (var i = 1; i < len; ++i) {
	            promise._migrateCallbackAt(this, i);
	        }
	        this._setFollowing();
	        this._setLength(0);
	        this._setFollowee(promise);
	    } else if (((bitField & 33554432) !== 0)) {
	        this._fulfill(promise._value());
	    } else if (((bitField & 16777216) !== 0)) {
	        this._reject(promise._reason());
	    } else {
	        var reason = new CancellationError("late cancellation observer");
	        promise._attachExtraTrace(reason);
	        this._reject(reason);
	    }
	};
	
	Promise.prototype._rejectCallback =
	function(reason, synchronous, ignoreNonErrorWarnings) {
	    var trace = util.ensureErrorObject(reason);
	    var hasStack = trace === reason;
	    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
	        var message = "a promise was rejected with a non-error: " +
	            util.classString(reason);
	        this._warn(message, true);
	    }
	    this._attachExtraTrace(trace, synchronous ? hasStack : false);
	    this._reject(reason);
	};
	
	Promise.prototype._resolveFromExecutor = function (executor) {
	    if (executor === INTERNAL) return;
	    var promise = this;
	    this._captureStackTrace();
	    this._pushContext();
	    var synchronous = true;
	    var r = this._execute(executor, function(value) {
	        promise._resolveCallback(value);
	    }, function (reason) {
	        promise._rejectCallback(reason, synchronous);
	    });
	    synchronous = false;
	    this._popContext();
	
	    if (r !== undefined) {
	        promise._rejectCallback(r, true);
	    }
	};
	
	Promise.prototype._settlePromiseFromHandler = function (
	    handler, receiver, value, promise
	) {
	    var bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	    promise._pushContext();
	    var x;
	    if (receiver === APPLY) {
	        if (!value || typeof value.length !== "number") {
	            x = errorObj;
	            x.e = new TypeError("cannot .spread() a non-array: " +
	                                    util.classString(value));
	        } else {
	            x = tryCatch(handler).apply(this._boundValue(), value);
	        }
	    } else {
	        x = tryCatch(handler).call(receiver, value);
	    }
	    var promiseCreated = promise._popContext();
	    bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	
	    if (x === NEXT_FILTER) {
	        promise._reject(value);
	    } else if (x === errorObj) {
	        promise._rejectCallback(x.e, false);
	    } else {
	        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
	        promise._resolveCallback(x);
	    }
	};
	
	Promise.prototype._target = function() {
	    var ret = this;
	    while (ret._isFollowing()) ret = ret._followee();
	    return ret;
	};
	
	Promise.prototype._followee = function() {
	    return this._rejectionHandler0;
	};
	
	Promise.prototype._setFollowee = function(promise) {
	    this._rejectionHandler0 = promise;
	};
	
	Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
	    var isPromise = promise instanceof Promise;
	    var bitField = this._bitField;
	    var asyncGuaranteed = ((bitField & 134217728) !== 0);
	    if (((bitField & 65536) !== 0)) {
	        if (isPromise) promise._invokeInternalOnCancel();
	
	        if (receiver instanceof PassThroughHandlerContext &&
	            receiver.isFinallyHandler()) {
	            receiver.cancelPromise = promise;
	            if (tryCatch(handler).call(receiver, value) === errorObj) {
	                promise._reject(errorObj.e);
	            }
	        } else if (handler === reflectHandler) {
	            promise._fulfill(reflectHandler.call(receiver));
	        } else if (receiver instanceof Proxyable) {
	            receiver._promiseCancelled(promise);
	        } else if (isPromise || promise instanceof PromiseArray) {
	            promise._cancel();
	        } else {
	            receiver.cancel();
	        }
	    } else if (typeof handler === "function") {
	        if (!isPromise) {
	            handler.call(receiver, value, promise);
	        } else {
	            if (asyncGuaranteed) promise._setAsyncGuaranteed();
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (receiver instanceof Proxyable) {
	        if (!receiver._isResolved()) {
	            if (((bitField & 33554432) !== 0)) {
	                receiver._promiseFulfilled(value, promise);
	            } else {
	                receiver._promiseRejected(value, promise);
	            }
	        }
	    } else if (isPromise) {
	        if (asyncGuaranteed) promise._setAsyncGuaranteed();
	        if (((bitField & 33554432) !== 0)) {
	            promise._fulfill(value);
	        } else {
	            promise._reject(value);
	        }
	    }
	};
	
	Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
	    var handler = ctx.handler;
	    var promise = ctx.promise;
	    var receiver = ctx.receiver;
	    var value = ctx.value;
	    if (typeof handler === "function") {
	        if (!(promise instanceof Promise)) {
	            handler.call(receiver, value, promise);
	        } else {
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (promise instanceof Promise) {
	        promise._reject(value);
	    }
	};
	
	Promise.prototype._settlePromiseCtx = function(ctx) {
	    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
	};
	
	Promise.prototype._settlePromise0 = function(handler, value, bitField) {
	    var promise = this._promise0;
	    var receiver = this._receiverAt(0);
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._settlePromise(promise, handler, receiver, value);
	};
	
	Promise.prototype._clearCallbackDataAtIndex = function(index) {
	    var base = index * 4 - 4;
	    this[base + 2] =
	    this[base + 3] =
	    this[base + 0] =
	    this[base + 1] = undefined;
	};
	
	Promise.prototype._fulfill = function (value) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    if (value === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._reject(err);
	    }
	    this._setFulfilled();
	    this._rejectionHandler0 = value;
	
	    if ((bitField & 65535) > 0) {
	        if (((bitField & 134217728) !== 0)) {
	            this._settlePromises();
	        } else {
	            async.settlePromises(this);
	        }
	        this._dereferenceTrace();
	    }
	};
	
	Promise.prototype._reject = function (reason) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    this._setRejected();
	    this._fulfillmentHandler0 = reason;
	
	    if (this._isFinal()) {
	        return async.fatalError(reason, util.isNode);
	    }
	
	    if ((bitField & 65535) > 0) {
	        async.settlePromises(this);
	    } else {
	        this._ensurePossibleRejectionHandled();
	    }
	};
	
	Promise.prototype._fulfillPromises = function (len, value) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._fulfillmentHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, value);
	    }
	};
	
	Promise.prototype._rejectPromises = function (len, reason) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._rejectionHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, reason);
	    }
	};
	
	Promise.prototype._settlePromises = function () {
	    var bitField = this._bitField;
	    var len = (bitField & 65535);
	
	    if (len > 0) {
	        if (((bitField & 16842752) !== 0)) {
	            var reason = this._fulfillmentHandler0;
	            this._settlePromise0(this._rejectionHandler0, reason, bitField);
	            this._rejectPromises(len, reason);
	        } else {
	            var value = this._rejectionHandler0;
	            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
	            this._fulfillPromises(len, value);
	        }
	        this._setLength(0);
	    }
	    this._clearCancellationData();
	};
	
	Promise.prototype._settledValue = function() {
	    var bitField = this._bitField;
	    if (((bitField & 33554432) !== 0)) {
	        return this._rejectionHandler0;
	    } else if (((bitField & 16777216) !== 0)) {
	        return this._fulfillmentHandler0;
	    }
	};
	
	if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
	    es5.defineProperty(Promise.prototype, Symbol.toStringTag, {
	        get: function () {
	            return "Object";
	        }
	    });
	}
	
	function deferResolve(v) {this.promise._resolveCallback(v);}
	function deferReject(v) {this.promise._rejectCallback(v, false);}
	
	Promise.defer = Promise.pending = function() {
	    debug.deprecated("Promise.defer", "new Promise");
	    var promise = new Promise(INTERNAL);
	    return {
	        promise: promise,
	        resolve: deferResolve,
	        reject: deferReject
	    };
	};
	
	util.notEnumerableProp(Promise,
	                       "_makeSelfResolutionError",
	                       makeSelfResolutionError);
	
	__webpack_require__(1019)(Promise, INTERNAL, tryConvertToPromise, apiRejection,
	    debug);
	__webpack_require__(1006)(Promise, INTERNAL, tryConvertToPromise, debug);
	__webpack_require__(1009)(Promise, PromiseArray, apiRejection, debug);
	__webpack_require__(1012)(Promise);
	__webpack_require__(1031)(Promise);
	__webpack_require__(1017)(
	    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
	Promise.Promise = Promise;
	Promise.version = "3.5.5";
	__webpack_require__(1008)(Promise);
	__webpack_require__(1016)(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
	__webpack_require__(1018)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(1020)(Promise);
	__webpack_require__(1023)(Promise, INTERNAL);
	__webpack_require__(1024)(Promise, PromiseArray, tryConvertToPromise, apiRejection);
	__webpack_require__(1026)(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	__webpack_require__(1027)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(1029)(Promise, PromiseArray, debug);
	__webpack_require__(1030)(Promise, PromiseArray, apiRejection);
	__webpack_require__(1033)(Promise, INTERNAL, debug);
	__webpack_require__(1034)(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
	__webpack_require__(1004)(Promise);
	__webpack_require__(1013)(Promise, INTERNAL);
	__webpack_require__(1014)(Promise, INTERNAL);
	                                                         
	    util.toFastProperties(Promise);                                          
	    util.toFastProperties(Promise.prototype);                                
	    function fillTypes(value) {                                              
	        var p = new Promise(INTERNAL);                                       
	        p._fulfillmentHandler0 = value;                                      
	        p._rejectionHandler0 = value;                                        
	        p._promise0 = value;                                                 
	        p._receiver0 = value;                                                
	    }                                                                        
	    // Complete slack tracking, opt out of field-type tracking and           
	    // stabilize map                                                         
	    fillTypes({a: 1});                                                       
	    fillTypes({b: 2});                                                       
	    fillTypes({c: 3});                                                       
	    fillTypes(1);                                                            
	    fillTypes(function(){});                                                 
	    fillTypes(undefined);                                                    
	    fillTypes(false);                                                        
	    fillTypes(new Promise(INTERNAL));                                        
	    debug.setBounds(Async.firstLineError, util.lastLineError);               
	    return Promise;                                                          
	
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(140)))

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise,
	    apiRejection, Proxyable) {
	var util = __webpack_require__(73);
	var isArray = util.isArray;
	
	function toResolutionValue(val) {
	    switch(val) {
	    case -2: return [];
	    case -3: return {};
	    case -6: return new Map();
	    }
	}
	
	function PromiseArray(values) {
	    var promise = this._promise = new Promise(INTERNAL);
	    if (values instanceof Promise) {
	        promise._propagateFrom(values, 3);
	    }
	    promise._setOnCancel(this);
	    this._values = values;
	    this._length = 0;
	    this._totalResolved = 0;
	    this._init(undefined, -2);
	}
	util.inherits(PromiseArray, Proxyable);
	
	PromiseArray.prototype.length = function () {
	    return this._length;
	};
	
	PromiseArray.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
	    var values = tryConvertToPromise(this._values, this._promise);
	    if (values instanceof Promise) {
	        values = values._target();
	        var bitField = values._bitField;
	        ;
	        this._values = values;
	
	        if (((bitField & 50397184) === 0)) {
	            this._promise._setAsyncGuaranteed();
	            return values._then(
	                init,
	                this._reject,
	                undefined,
	                this,
	                resolveValueIfEmpty
	           );
	        } else if (((bitField & 33554432) !== 0)) {
	            values = values._value();
	        } else if (((bitField & 16777216) !== 0)) {
	            return this._reject(values._reason());
	        } else {
	            return this._cancel();
	        }
	    }
	    values = util.asArray(values);
	    if (values === null) {
	        var err = apiRejection(
	            "expecting an array or an iterable object but got " + util.classString(values)).reason();
	        this._promise._rejectCallback(err, false);
	        return;
	    }
	
	    if (values.length === 0) {
	        if (resolveValueIfEmpty === -5) {
	            this._resolveEmptyArray();
	        }
	        else {
	            this._resolve(toResolutionValue(resolveValueIfEmpty));
	        }
	        return;
	    }
	    this._iterate(values);
	};
	
	PromiseArray.prototype._iterate = function(values) {
	    var len = this.getActualLength(values.length);
	    this._length = len;
	    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
	    var result = this._promise;
	    var isResolved = false;
	    var bitField = null;
	    for (var i = 0; i < len; ++i) {
	        var maybePromise = tryConvertToPromise(values[i], result);
	
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            bitField = maybePromise._bitField;
	        } else {
	            bitField = null;
	        }
	
	        if (isResolved) {
	            if (bitField !== null) {
	                maybePromise.suppressUnhandledRejections();
	            }
	        } else if (bitField !== null) {
	            if (((bitField & 50397184) === 0)) {
	                maybePromise._proxy(this, i);
	                this._values[i] = maybePromise;
	            } else if (((bitField & 33554432) !== 0)) {
	                isResolved = this._promiseFulfilled(maybePromise._value(), i);
	            } else if (((bitField & 16777216) !== 0)) {
	                isResolved = this._promiseRejected(maybePromise._reason(), i);
	            } else {
	                isResolved = this._promiseCancelled(i);
	            }
	        } else {
	            isResolved = this._promiseFulfilled(maybePromise, i);
	        }
	    }
	    if (!isResolved) result._setAsyncGuaranteed();
	};
	
	PromiseArray.prototype._isResolved = function () {
	    return this._values === null;
	};
	
	PromiseArray.prototype._resolve = function (value) {
	    this._values = null;
	    this._promise._fulfill(value);
	};
	
	PromiseArray.prototype._cancel = function() {
	    if (this._isResolved() || !this._promise._isCancellable()) return;
	    this._values = null;
	    this._promise._cancel();
	};
	
	PromiseArray.prototype._reject = function (reason) {
	    this._values = null;
	    this._promise._rejectCallback(reason, false);
	};
	
	PromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	PromiseArray.prototype._promiseCancelled = function() {
	    this._cancel();
	    return true;
	};
	
	PromiseArray.prototype._promiseRejected = function (reason) {
	    this._totalResolved++;
	    this._reject(reason);
	    return true;
	};
	
	PromiseArray.prototype._resultCancelled = function() {
	    if (this._isResolved()) return;
	    var values = this._values;
	    this._cancel();
	    if (values instanceof Promise) {
	        values.cancel();
	    } else {
	        for (var i = 0; i < values.length; ++i) {
	            if (values[i] instanceof Promise) {
	                values[i].cancel();
	            }
	        }
	    }
	};
	
	PromiseArray.prototype.shouldCopyValues = function () {
	    return true;
	};
	
	PromiseArray.prototype.getActualLength = function (len) {
	    return len;
	};
	
	return PromiseArray;
	};


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var THIS = {};
	var util = __webpack_require__(73);
	var nodebackForPromise = __webpack_require__(595);
	var withAppended = util.withAppended;
	var maybeWrapAsError = util.maybeWrapAsError;
	var canEvaluate = util.canEvaluate;
	var TypeError = __webpack_require__(178).TypeError;
	var defaultSuffix = "Async";
	var defaultPromisified = {__isPromisified__: true};
	var noCopyProps = [
	    "arity",    "length",
	    "name",
	    "arguments",
	    "caller",
	    "callee",
	    "prototype",
	    "__isPromisified__"
	];
	var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
	
	var defaultFilter = function(name) {
	    return util.isIdentifier(name) &&
	        name.charAt(0) !== "_" &&
	        name !== "constructor";
	};
	
	function propsFilter(key) {
	    return !noCopyPropsPattern.test(key);
	}
	
	function isPromisified(fn) {
	    try {
	        return fn.__isPromisified__ === true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	
	function hasPromisified(obj, key, suffix) {
	    var val = util.getDataPropertyOrDefault(obj, key + suffix,
	                                            defaultPromisified);
	    return val ? isPromisified(val) : false;
	}
	function checkValid(ret, suffix, suffixRegexp) {
	    for (var i = 0; i < ret.length; i += 2) {
	        var key = ret[i];
	        if (suffixRegexp.test(key)) {
	            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
	            for (var j = 0; j < ret.length; j += 2) {
	                if (ret[j] === keyWithoutAsyncSuffix) {
	                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
	                        .replace("%s", suffix));
	                }
	            }
	        }
	    }
	}
	
	function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
	    var keys = util.inheritedDataKeys(obj);
	    var ret = [];
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var value = obj[key];
	        var passesDefaultFilter = filter === defaultFilter
	            ? true : defaultFilter(key, value, obj);
	        if (typeof value === "function" &&
	            !isPromisified(value) &&
	            !hasPromisified(obj, key, suffix) &&
	            filter(key, value, obj, passesDefaultFilter)) {
	            ret.push(key, value);
	        }
	    }
	    checkValid(ret, suffix, suffixRegexp);
	    return ret;
	}
	
	var escapeIdentRegex = function(str) {
	    return str.replace(/([$])/, "\\$");
	};
	
	var makeNodePromisifiedEval;
	if (true) {
	var switchCaseArgumentOrder = function(likelyArgumentCount) {
	    var ret = [likelyArgumentCount];
	    var min = Math.max(0, likelyArgumentCount - 1 - 3);
	    for(var i = likelyArgumentCount - 1; i >= min; --i) {
	        ret.push(i);
	    }
	    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
	        ret.push(i);
	    }
	    return ret;
	};
	
	var argumentSequence = function(argumentCount) {
	    return util.filledRange(argumentCount, "_arg", "");
	};
	
	var parameterDeclaration = function(parameterCount) {
	    return util.filledRange(
	        Math.max(parameterCount, 3), "_arg", "");
	};
	
	var parameterCount = function(fn) {
	    if (typeof fn.length === "number") {
	        return Math.max(Math.min(fn.length, 1023 + 1), 0);
	    }
	    return 0;
	};
	
	makeNodePromisifiedEval =
	function(callback, receiver, originalName, fn, _, multiArgs) {
	    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
	    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
	    var shouldProxyThis = typeof callback === "string" || receiver === THIS;
	
	    function generateCallForArgumentCount(count) {
	        var args = argumentSequence(count).join(", ");
	        var comma = count > 0 ? ", " : "";
	        var ret;
	        if (shouldProxyThis) {
	            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
	        } else {
	            ret = receiver === undefined
	                ? "ret = callback({{args}}, nodeback); break;\n"
	                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
	        }
	        return ret.replace("{{args}}", args).replace(", ", comma);
	    }
	
	    function generateArgumentSwitchCase() {
	        var ret = "";
	        for (var i = 0; i < argumentOrder.length; ++i) {
	            ret += "case " + argumentOrder[i] +":" +
	                generateCallForArgumentCount(argumentOrder[i]);
	        }
	
	        ret += "                                                             \n\
	        default:                                                             \n\
	            var args = new Array(len + 1);                                   \n\
	            var i = 0;                                                       \n\
	            for (var i = 0; i < len; ++i) {                                  \n\
	               args[i] = arguments[i];                                       \n\
	            }                                                                \n\
	            args[i] = nodeback;                                              \n\
	            [CodeForCall]                                                    \n\
	            break;                                                           \n\
	        ".replace("[CodeForCall]", (shouldProxyThis
	                                ? "ret = callback.apply(this, args);\n"
	                                : "ret = callback.apply(receiver, args);\n"));
	        return ret;
	    }
	
	    var getFunctionCode = typeof callback === "string"
	                                ? ("this != null ? this['"+callback+"'] : fn")
	                                : "fn";
	    var body = "'use strict';                                                \n\
	        var ret = function (Parameters) {                                    \n\
	            'use strict';                                                    \n\
	            var len = arguments.length;                                      \n\
	            var promise = new Promise(INTERNAL);                             \n\
	            promise._captureStackTrace();                                    \n\
	            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
	            var ret;                                                         \n\
	            var callback = tryCatch([GetFunctionCode]);                      \n\
	            switch(len) {                                                    \n\
	                [CodeForSwitchCase]                                          \n\
	            }                                                                \n\
	            if (ret === errorObj) {                                          \n\
	                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
	            }                                                                \n\
	            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
	            return promise;                                                  \n\
	        };                                                                   \n\
	        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
	        return ret;                                                          \n\
	    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
	        .replace("[GetFunctionCode]", getFunctionCode);
	    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
	    return new Function("Promise",
	                        "fn",
	                        "receiver",
	                        "withAppended",
	                        "maybeWrapAsError",
	                        "nodebackForPromise",
	                        "tryCatch",
	                        "errorObj",
	                        "notEnumerableProp",
	                        "INTERNAL",
	                        body)(
	                    Promise,
	                    fn,
	                    receiver,
	                    withAppended,
	                    maybeWrapAsError,
	                    nodebackForPromise,
	                    util.tryCatch,
	                    util.errorObj,
	                    util.notEnumerableProp,
	                    INTERNAL);
	};
	}
	
	function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
	    var defaultThis = (function() {return this;})();
	    var method = callback;
	    if (typeof method === "string") {
	        callback = fn;
	    }
	    function promisified() {
	        var _receiver = receiver;
	        if (receiver === THIS) _receiver = this;
	        var promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	        var cb = typeof method === "string" && this !== defaultThis
	            ? this[method] : callback;
	        var fn = nodebackForPromise(promise, multiArgs);
	        try {
	            cb.apply(_receiver, withAppended(arguments, fn));
	        } catch(e) {
	            promise._rejectCallback(maybeWrapAsError(e), true, true);
	        }
	        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
	        return promise;
	    }
	    util.notEnumerableProp(promisified, "__isPromisified__", true);
	    return promisified;
	}
	
	var makeNodePromisified = canEvaluate
	    ? makeNodePromisifiedEval
	    : makeNodePromisifiedClosure;
	
	function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
	    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
	    var methods =
	        promisifiableMethods(obj, suffix, suffixRegexp, filter);
	
	    for (var i = 0, len = methods.length; i < len; i+= 2) {
	        var key = methods[i];
	        var fn = methods[i+1];
	        var promisifiedKey = key + suffix;
	        if (promisifier === makeNodePromisified) {
	            obj[promisifiedKey] =
	                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
	        } else {
	            var promisified = promisifier(fn, function() {
	                return makeNodePromisified(key, THIS, key,
	                                           fn, suffix, multiArgs);
	            });
	            util.notEnumerableProp(promisified, "__isPromisified__", true);
	            obj[promisifiedKey] = promisified;
	        }
	    }
	    util.toFastProperties(obj);
	    return obj;
	}
	
	function promisify(callback, receiver, multiArgs) {
	    return makeNodePromisified(callback, receiver, undefined,
	                                callback, null, multiArgs);
	}
	
	Promise.promisify = function (fn, options) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    if (isPromisified(fn)) {
	        return fn;
	    }
	    options = Object(options);
	    var receiver = options.context === undefined ? THIS : options.context;
	    var multiArgs = !!options.multiArgs;
	    var ret = promisify(fn, receiver, multiArgs);
	    util.copyDescriptors(fn, ret, propsFilter);
	    return ret;
	};
	
	Promise.promisifyAll = function (target, options) {
	    if (typeof target !== "function" && typeof target !== "object") {
	        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    options = Object(options);
	    var multiArgs = !!options.multiArgs;
	    var suffix = options.suffix;
	    if (typeof suffix !== "string") suffix = defaultSuffix;
	    var filter = options.filter;
	    if (typeof filter !== "function") filter = defaultFilter;
	    var promisifier = options.promisifier;
	    if (typeof promisifier !== "function") promisifier = makeNodePromisified;
	
	    if (!util.isIdentifier(suffix)) {
	        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	
	    var keys = util.inheritedDataKeys(target);
	    for (var i = 0; i < keys.length; ++i) {
	        var value = target[keys[i]];
	        if (keys[i] !== "constructor" &&
	            util.isClass(value)) {
	            promisifyAll(value.prototype, suffix, filter, promisifier,
	                multiArgs);
	            promisifyAll(value, suffix, filter, promisifier, multiArgs);
	        }
	    }
	
	    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
	};
	};
	


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(73);
	var isObject = util.isObject;
	var es5 = __webpack_require__(196);
	var Es6Map;
	if (typeof Map === "function") Es6Map = Map;
	
	var mapToEntries = (function() {
	    var index = 0;
	    var size = 0;
	
	    function extractEntry(value, key) {
	        this[index] = value;
	        this[index + size] = key;
	        index++;
	    }
	
	    return function mapToEntries(map) {
	        size = map.size;
	        index = 0;
	        var ret = new Array(map.size * 2);
	        map.forEach(extractEntry, ret);
	        return ret;
	    };
	})();
	
	var entriesToMap = function(entries) {
	    var ret = new Es6Map();
	    var length = entries.length / 2 | 0;
	    for (var i = 0; i < length; ++i) {
	        var key = entries[length + i];
	        var value = entries[i];
	        ret.set(key, value);
	    }
	    return ret;
	};
	
	function PropertiesPromiseArray(obj) {
	    var isMap = false;
	    var entries;
	    if (Es6Map !== undefined && obj instanceof Es6Map) {
	        entries = mapToEntries(obj);
	        isMap = true;
	    } else {
	        var keys = es5.keys(obj);
	        var len = keys.length;
	        entries = new Array(len * 2);
	        for (var i = 0; i < len; ++i) {
	            var key = keys[i];
	            entries[i] = obj[key];
	            entries[i + len] = key;
	        }
	    }
	    this.constructor$(entries);
	    this._isMap = isMap;
	    this._init$(undefined, isMap ? -6 : -3);
	}
	util.inherits(PropertiesPromiseArray, PromiseArray);
	
	PropertiesPromiseArray.prototype._init = function () {};
	
	PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        var val;
	        if (this._isMap) {
	            val = entriesToMap(this._values);
	        } else {
	            val = {};
	            var keyOffset = this.length();
	            for (var i = 0, len = this.length(); i < len; ++i) {
	                val[this._values[i + keyOffset]] = this._values[i];
	            }
	        }
	        this._resolve(val);
	        return true;
	    }
	    return false;
	};
	
	PropertiesPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	PropertiesPromiseArray.prototype.getActualLength = function (len) {
	    return len >> 1;
	};
	
	function props(promises) {
	    var ret;
	    var castValue = tryConvertToPromise(promises);
	
	    if (!isObject(castValue)) {
	        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    } else if (castValue instanceof Promise) {
	        ret = castValue._then(
	            Promise.props, undefined, undefined, undefined, undefined);
	    } else {
	        ret = new PropertiesPromiseArray(castValue).promise();
	    }
	
	    if (castValue instanceof Promise) {
	        ret._propagateFrom(castValue, 2);
	    }
	    return ret;
	}
	
	Promise.prototype.props = function () {
	    return props(this);
	};
	
	Promise.props = function (promises) {
	    return props(promises);
	};
	};


/***/ }),
/* 1025 */
/***/ (function(module, exports) {

	"use strict";
	function arrayMove(src, srcIndex, dst, dstIndex, len) {
	    for (var j = 0; j < len; ++j) {
	        dst[j + dstIndex] = src[j + srcIndex];
	        src[j + srcIndex] = void 0;
	    }
	}
	
	function Queue(capacity) {
	    this._capacity = capacity;
	    this._length = 0;
	    this._front = 0;
	}
	
	Queue.prototype._willBeOverCapacity = function (size) {
	    return this._capacity < size;
	};
	
	Queue.prototype._pushOne = function (arg) {
	    var length = this.length();
	    this._checkCapacity(length + 1);
	    var i = (this._front + length) & (this._capacity - 1);
	    this[i] = arg;
	    this._length = length + 1;
	};
	
	Queue.prototype.push = function (fn, receiver, arg) {
	    var length = this.length() + 3;
	    if (this._willBeOverCapacity(length)) {
	        this._pushOne(fn);
	        this._pushOne(receiver);
	        this._pushOne(arg);
	        return;
	    }
	    var j = this._front + length - 3;
	    this._checkCapacity(length);
	    var wrapMask = this._capacity - 1;
	    this[(j + 0) & wrapMask] = fn;
	    this[(j + 1) & wrapMask] = receiver;
	    this[(j + 2) & wrapMask] = arg;
	    this._length = length;
	};
	
	Queue.prototype.shift = function () {
	    var front = this._front,
	        ret = this[front];
	
	    this[front] = undefined;
	    this._front = (front + 1) & (this._capacity - 1);
	    this._length--;
	    return ret;
	};
	
	Queue.prototype.length = function () {
	    return this._length;
	};
	
	Queue.prototype._checkCapacity = function (size) {
	    if (this._capacity < size) {
	        this._resizeTo(this._capacity << 1);
	    }
	};
	
	Queue.prototype._resizeTo = function (capacity) {
	    var oldCapacity = this._capacity;
	    this._capacity = capacity;
	    var front = this._front;
	    var length = this._length;
	    var moveItemsCount = (front + length) & (oldCapacity - 1);
	    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
	};
	
	module.exports = Queue;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(73);
	
	var raceLater = function (promise) {
	    return promise.then(function(array) {
	        return race(array, promise);
	    });
	};
	
	function race(promises, parent) {
	    var maybePromise = tryConvertToPromise(promises);
	
	    if (maybePromise instanceof Promise) {
	        return raceLater(maybePromise);
	    } else {
	        promises = util.asArray(promises);
	        if (promises === null)
	            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
	    }
	
	    var ret = new Promise(INTERNAL);
	    if (parent !== undefined) {
	        ret._propagateFrom(parent, 3);
	    }
	    var fulfill = ret._fulfill;
	    var reject = ret._reject;
	    for (var i = 0, len = promises.length; i < len; ++i) {
	        var val = promises[i];
	
	        if (val === undefined && !(i in promises)) {
	            continue;
	        }
	
	        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
	    }
	    return ret;
	}
	
	Promise.race = function (promises) {
	    return race(promises, undefined);
	};
	
	Promise.prototype.race = function () {
	    return race(this, undefined);
	};
	
	};


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(73);
	var tryCatch = util.tryCatch;
	
	function ReductionPromiseArray(promises, fn, initialValue, _each) {
	    this.constructor$(promises);
	    var domain = getDomain();
	    this._fn = domain === null ? fn : util.domainBind(domain, fn);
	    if (initialValue !== undefined) {
	        initialValue = Promise.resolve(initialValue);
	        initialValue._attachCancellationCallback(this);
	    }
	    this._initialValue = initialValue;
	    this._currentCancellable = null;
	    if(_each === INTERNAL) {
	        this._eachValues = Array(this._length);
	    } else if (_each === 0) {
	        this._eachValues = null;
	    } else {
	        this._eachValues = undefined;
	    }
	    this._promise._captureStackTrace();
	    this._init$(undefined, -5);
	}
	util.inherits(ReductionPromiseArray, PromiseArray);
	
	ReductionPromiseArray.prototype._gotAccum = function(accum) {
	    if (this._eachValues !== undefined && 
	        this._eachValues !== null && 
	        accum !== INTERNAL) {
	        this._eachValues.push(accum);
	    }
	};
	
	ReductionPromiseArray.prototype._eachComplete = function(value) {
	    if (this._eachValues !== null) {
	        this._eachValues.push(value);
	    }
	    return this._eachValues;
	};
	
	ReductionPromiseArray.prototype._init = function() {};
	
	ReductionPromiseArray.prototype._resolveEmptyArray = function() {
	    this._resolve(this._eachValues !== undefined ? this._eachValues
	                                                 : this._initialValue);
	};
	
	ReductionPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	ReductionPromiseArray.prototype._resolve = function(value) {
	    this._promise._resolveCallback(value);
	    this._values = null;
	};
	
	ReductionPromiseArray.prototype._resultCancelled = function(sender) {
	    if (sender === this._initialValue) return this._cancel();
	    if (this._isResolved()) return;
	    this._resultCancelled$();
	    if (this._currentCancellable instanceof Promise) {
	        this._currentCancellable.cancel();
	    }
	    if (this._initialValue instanceof Promise) {
	        this._initialValue.cancel();
	    }
	};
	
	ReductionPromiseArray.prototype._iterate = function (values) {
	    this._values = values;
	    var value;
	    var i;
	    var length = values.length;
	    if (this._initialValue !== undefined) {
	        value = this._initialValue;
	        i = 0;
	    } else {
	        value = Promise.resolve(values[0]);
	        i = 1;
	    }
	
	    this._currentCancellable = value;
	
	    if (!value.isRejected()) {
	        for (; i < length; ++i) {
	            var ctx = {
	                accum: null,
	                value: values[i],
	                index: i,
	                length: length,
	                array: this
	            };
	            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
	        }
	    }
	
	    if (this._eachValues !== undefined) {
	        value = value
	            ._then(this._eachComplete, undefined, undefined, this, undefined);
	    }
	    value._then(completed, completed, undefined, value, this);
	};
	
	Promise.prototype.reduce = function (fn, initialValue) {
	    return reduce(this, fn, initialValue, null);
	};
	
	Promise.reduce = function (promises, fn, initialValue, _each) {
	    return reduce(promises, fn, initialValue, _each);
	};
	
	function completed(valueOrReason, array) {
	    if (this.isFulfilled()) {
	        array._resolve(valueOrReason);
	    } else {
	        array._reject(valueOrReason);
	    }
	}
	
	function reduce(promises, fn, initialValue, _each) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
	    return array.promise();
	}
	
	function gotAccum(accum) {
	    this.accum = accum;
	    this.array._gotAccum(accum);
	    var value = tryConvertToPromise(this.value, this.array._promise);
	    if (value instanceof Promise) {
	        this.array._currentCancellable = value;
	        return value._then(gotValue, undefined, undefined, this, undefined);
	    } else {
	        return gotValue.call(this, value);
	    }
	}
	
	function gotValue(value) {
	    var array = this.array;
	    var promise = array._promise;
	    var fn = tryCatch(array._fn);
	    promise._pushContext();
	    var ret;
	    if (array._eachValues !== undefined) {
	        ret = fn.call(promise._boundValue(), value, this.index, this.length);
	    } else {
	        ret = fn.call(promise._boundValue(),
	                              this.accum, value, this.index, this.length);
	    }
	    if (ret instanceof Promise) {
	        array._currentCancellable = ret;
	    }
	    var promiseCreated = promise._popContext();
	    debug.checkForgottenReturns(
	        ret,
	        promiseCreated,
	        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
	        promise
	    );
	    return ret;
	}
	};


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, setImmediate) {"use strict";
	var util = __webpack_require__(73);
	var schedule;
	var noAsyncScheduler = function() {
	    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var NativePromise = util.getNativePromise();
	if (util.isNode && typeof MutationObserver === "undefined") {
	    var GlobalSetImmediate = global.setImmediate;
	    var ProcessNextTick = process.nextTick;
	    schedule = util.isRecentNode
	                ? function(fn) { GlobalSetImmediate.call(global, fn); }
	                : function(fn) { ProcessNextTick.call(process, fn); };
	} else if (typeof NativePromise === "function" &&
	           typeof NativePromise.resolve === "function") {
	    var nativePromise = NativePromise.resolve();
	    schedule = function(fn) {
	        nativePromise.then(fn);
	    };
	} else if ((typeof MutationObserver !== "undefined") &&
	          !(typeof window !== "undefined" &&
	            window.navigator &&
	            (window.navigator.standalone || window.cordova)) &&
	          ("classList" in document.documentElement)) {
	    schedule = (function() {
	        var div = document.createElement("div");
	        var opts = {attributes: true};
	        var toggleScheduled = false;
	        var div2 = document.createElement("div");
	        var o2 = new MutationObserver(function() {
	            div.classList.toggle("foo");
	            toggleScheduled = false;
	        });
	        o2.observe(div2, opts);
	
	        var scheduleToggle = function() {
	            if (toggleScheduled) return;
	            toggleScheduled = true;
	            div2.classList.toggle("foo");
	        };
	
	        return function schedule(fn) {
	            var o = new MutationObserver(function() {
	                o.disconnect();
	                fn();
	            });
	            o.observe(div, opts);
	            scheduleToggle();
	        };
	    })();
	} else if (typeof setImmediate !== "undefined") {
	    schedule = function (fn) {
	        setImmediate(fn);
	    };
	} else if (typeof setTimeout !== "undefined") {
	    schedule = function (fn) {
	        setTimeout(fn, 0);
	    };
	} else {
	    schedule = noAsyncScheduler;
	}
	module.exports = schedule;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(140), __webpack_require__(2325).setImmediate))

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	    function(Promise, PromiseArray, debug) {
	var PromiseInspection = Promise.PromiseInspection;
	var util = __webpack_require__(73);
	
	function SettledPromiseArray(values) {
	    this.constructor$(values);
	}
	util.inherits(SettledPromiseArray, PromiseArray);
	
	SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
	    this._values[index] = inspection;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 33554432;
	    ret._settledValueField = value;
	    return this._promiseResolved(index, ret);
	};
	SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 16777216;
	    ret._settledValueField = reason;
	    return this._promiseResolved(index, ret);
	};
	
	Promise.settle = function (promises) {
	    debug.deprecated(".settle()", ".reflect()");
	    return new SettledPromiseArray(promises).promise();
	};
	
	Promise.prototype.settle = function () {
	    return Promise.settle(this);
	};
	};


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, apiRejection) {
	var util = __webpack_require__(73);
	var RangeError = __webpack_require__(178).RangeError;
	var AggregateError = __webpack_require__(178).AggregateError;
	var isArray = util.isArray;
	var CANCELLATION = {};
	
	
	function SomePromiseArray(values) {
	    this.constructor$(values);
	    this._howMany = 0;
	    this._unwrap = false;
	    this._initialized = false;
	}
	util.inherits(SomePromiseArray, PromiseArray);
	
	SomePromiseArray.prototype._init = function () {
	    if (!this._initialized) {
	        return;
	    }
	    if (this._howMany === 0) {
	        this._resolve([]);
	        return;
	    }
	    this._init$(undefined, -5);
	    var isArrayResolved = isArray(this._values);
	    if (!this._isResolved() &&
	        isArrayResolved &&
	        this._howMany > this._canPossiblyFulfill()) {
	        this._reject(this._getRangeError(this.length()));
	    }
	};
	
	SomePromiseArray.prototype.init = function () {
	    this._initialized = true;
	    this._init();
	};
	
	SomePromiseArray.prototype.setUnwrap = function () {
	    this._unwrap = true;
	};
	
	SomePromiseArray.prototype.howMany = function () {
	    return this._howMany;
	};
	
	SomePromiseArray.prototype.setHowMany = function (count) {
	    this._howMany = count;
	};
	
	SomePromiseArray.prototype._promiseFulfilled = function (value) {
	    this._addFulfilled(value);
	    if (this._fulfilled() === this.howMany()) {
	        this._values.length = this.howMany();
	        if (this.howMany() === 1 && this._unwrap) {
	            this._resolve(this._values[0]);
	        } else {
	            this._resolve(this._values);
	        }
	        return true;
	    }
	    return false;
	
	};
	SomePromiseArray.prototype._promiseRejected = function (reason) {
	    this._addRejected(reason);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._promiseCancelled = function () {
	    if (this._values instanceof Promise || this._values == null) {
	        return this._cancel();
	    }
	    this._addRejected(CANCELLATION);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._checkOutcome = function() {
	    if (this.howMany() > this._canPossiblyFulfill()) {
	        var e = new AggregateError();
	        for (var i = this.length(); i < this._values.length; ++i) {
	            if (this._values[i] !== CANCELLATION) {
	                e.push(this._values[i]);
	            }
	        }
	        if (e.length > 0) {
	            this._reject(e);
	        } else {
	            this._cancel();
	        }
	        return true;
	    }
	    return false;
	};
	
	SomePromiseArray.prototype._fulfilled = function () {
	    return this._totalResolved;
	};
	
	SomePromiseArray.prototype._rejected = function () {
	    return this._values.length - this.length();
	};
	
	SomePromiseArray.prototype._addRejected = function (reason) {
	    this._values.push(reason);
	};
	
	SomePromiseArray.prototype._addFulfilled = function (value) {
	    this._values[this._totalResolved++] = value;
	};
	
	SomePromiseArray.prototype._canPossiblyFulfill = function () {
	    return this.length() - this._rejected();
	};
	
	SomePromiseArray.prototype._getRangeError = function (count) {
	    var message = "Input array must contain at least " +
	            this._howMany + " items but contains only " + count + " items";
	    return new RangeError(message);
	};
	
	SomePromiseArray.prototype._resolveEmptyArray = function () {
	    this._reject(this._getRangeError(0));
	};
	
	function some(promises, howMany) {
	    if ((howMany | 0) !== howMany || howMany < 0) {
	        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(howMany);
	    ret.init();
	    return promise;
	}
	
	Promise.some = function (promises, howMany) {
	    return some(promises, howMany);
	};
	
	Promise.prototype.some = function (howMany) {
	    return some(this, howMany);
	};
	
	Promise._SomePromiseArray = SomePromiseArray;
	};


/***/ }),
/* 1031 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function PromiseInspection(promise) {
	    if (promise !== undefined) {
	        promise = promise._target();
	        this._bitField = promise._bitField;
	        this._settledValueField = promise._isFateSealed()
	            ? promise._settledValue() : undefined;
	    }
	    else {
	        this._bitField = 0;
	        this._settledValueField = undefined;
	    }
	}
	
	PromiseInspection.prototype._settledValue = function() {
	    return this._settledValueField;
	};
	
	var value = PromiseInspection.prototype.value = function () {
	    if (!this.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var reason = PromiseInspection.prototype.error =
	PromiseInspection.prototype.reason = function () {
	    if (!this.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
	    return (this._bitField & 33554432) !== 0;
	};
	
	var isRejected = PromiseInspection.prototype.isRejected = function () {
	    return (this._bitField & 16777216) !== 0;
	};
	
	var isPending = PromiseInspection.prototype.isPending = function () {
	    return (this._bitField & 50397184) === 0;
	};
	
	var isResolved = PromiseInspection.prototype.isResolved = function () {
	    return (this._bitField & 50331648) !== 0;
	};
	
	PromiseInspection.prototype.isCancelled = function() {
	    return (this._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.__isCancelled = function() {
	    return (this._bitField & 65536) === 65536;
	};
	
	Promise.prototype._isCancelled = function() {
	    return this._target().__isCancelled();
	};
	
	Promise.prototype.isCancelled = function() {
	    return (this._target()._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.isPending = function() {
	    return isPending.call(this._target());
	};
	
	Promise.prototype.isRejected = function() {
	    return isRejected.call(this._target());
	};
	
	Promise.prototype.isFulfilled = function() {
	    return isFulfilled.call(this._target());
	};
	
	Promise.prototype.isResolved = function() {
	    return isResolved.call(this._target());
	};
	
	Promise.prototype.value = function() {
	    return value.call(this._target());
	};
	
	Promise.prototype.reason = function() {
	    var target = this._target();
	    target._unsetRejectionIsUnhandled();
	    return reason.call(target);
	};
	
	Promise.prototype._value = function() {
	    return this._settledValue();
	};
	
	Promise.prototype._reason = function() {
	    this._unsetRejectionIsUnhandled();
	    return this._settledValue();
	};
	
	Promise.PromiseInspection = PromiseInspection;
	};


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = __webpack_require__(73);
	var errorObj = util.errorObj;
	var isObject = util.isObject;
	
	function tryConvertToPromise(obj, context) {
	    if (isObject(obj)) {
	        if (obj instanceof Promise) return obj;
	        var then = getThen(obj);
	        if (then === errorObj) {
	            if (context) context._pushContext();
	            var ret = Promise.reject(then.e);
	            if (context) context._popContext();
	            return ret;
	        } else if (typeof then === "function") {
	            if (isAnyBluebirdPromise(obj)) {
	                var ret = new Promise(INTERNAL);
	                obj._then(
	                    ret._fulfill,
	                    ret._reject,
	                    undefined,
	                    ret,
	                    null
	                );
	                return ret;
	            }
	            return doThenable(obj, then, context);
	        }
	    }
	    return obj;
	}
	
	function doGetThen(obj) {
	    return obj.then;
	}
	
	function getThen(obj) {
	    try {
	        return doGetThen(obj);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	
	var hasProp = {}.hasOwnProperty;
	function isAnyBluebirdPromise(obj) {
	    try {
	        return hasProp.call(obj, "_promise0");
	    } catch (e) {
	        return false;
	    }
	}
	
	function doThenable(x, then, context) {
	    var promise = new Promise(INTERNAL);
	    var ret = promise;
	    if (context) context._pushContext();
	    promise._captureStackTrace();
	    if (context) context._popContext();
	    var synchronous = true;
	    var result = util.tryCatch(then).call(x, resolve, reject);
	    synchronous = false;
	
	    if (promise && result === errorObj) {
	        promise._rejectCallback(result.e, true, true);
	        promise = null;
	    }
	
	    function resolve(value) {
	        if (!promise) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }
	
	    function reject(reason) {
	        if (!promise) return;
	        promise._rejectCallback(reason, synchronous, true);
	        promise = null;
	    }
	    return ret;
	}
	
	return tryConvertToPromise;
	};


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, debug) {
	var util = __webpack_require__(73);
	var TimeoutError = Promise.TimeoutError;
	
	function HandleWrapper(handle)  {
	    this.handle = handle;
	}
	
	HandleWrapper.prototype._resultCancelled = function() {
	    clearTimeout(this.handle);
	};
	
	var afterValue = function(value) { return delay(+this).thenReturn(value); };
	var delay = Promise.delay = function (ms, value) {
	    var ret;
	    var handle;
	    if (value !== undefined) {
	        ret = Promise.resolve(value)
	                ._then(afterValue, null, null, ms, undefined);
	        if (debug.cancellation() && value instanceof Promise) {
	            ret._setOnCancel(value);
	        }
	    } else {
	        ret = new Promise(INTERNAL);
	        handle = setTimeout(function() { ret._fulfill(); }, +ms);
	        if (debug.cancellation()) {
	            ret._setOnCancel(new HandleWrapper(handle));
	        }
	        ret._captureStackTrace();
	    }
	    ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.prototype.delay = function (ms) {
	    return delay(ms, this);
	};
	
	var afterTimeout = function (promise, message, parent) {
	    var err;
	    if (typeof message !== "string") {
	        if (message instanceof Error) {
	            err = message;
	        } else {
	            err = new TimeoutError("operation timed out");
	        }
	    } else {
	        err = new TimeoutError(message);
	    }
	    util.markAsOriginatingFromRejection(err);
	    promise._attachExtraTrace(err);
	    promise._reject(err);
	
	    if (parent != null) {
	        parent.cancel();
	    }
	};
	
	function successClear(value) {
	    clearTimeout(this.handle);
	    return value;
	}
	
	function failureClear(reason) {
	    clearTimeout(this.handle);
	    throw reason;
	}
	
	Promise.prototype.timeout = function (ms, message) {
	    ms = +ms;
	    var ret, parent;
	
	    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
	        if (ret.isPending()) {
	            afterTimeout(ret, message, parent);
	        }
	    }, ms));
	
	    if (debug.cancellation()) {
	        parent = this.then();
	        ret = parent._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	        ret._setOnCancel(handleWrapper);
	    } else {
	        ret = this._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	    }
	
	    return ret;
	};
	
	};


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function (Promise, apiRejection, tryConvertToPromise,
	    createContext, INTERNAL, debug) {
	    var util = __webpack_require__(73);
	    var TypeError = __webpack_require__(178).TypeError;
	    var inherits = __webpack_require__(73).inherits;
	    var errorObj = util.errorObj;
	    var tryCatch = util.tryCatch;
	    var NULL = {};
	
	    function thrower(e) {
	        setTimeout(function(){throw e;}, 0);
	    }
	
	    function castPreservingDisposable(thenable) {
	        var maybePromise = tryConvertToPromise(thenable);
	        if (maybePromise !== thenable &&
	            typeof thenable._isDisposable === "function" &&
	            typeof thenable._getDisposer === "function" &&
	            thenable._isDisposable()) {
	            maybePromise._setDisposable(thenable._getDisposer());
	        }
	        return maybePromise;
	    }
	    function dispose(resources, inspection) {
	        var i = 0;
	        var len = resources.length;
	        var ret = new Promise(INTERNAL);
	        function iterator() {
	            if (i >= len) return ret._fulfill();
	            var maybePromise = castPreservingDisposable(resources[i++]);
	            if (maybePromise instanceof Promise &&
	                maybePromise._isDisposable()) {
	                try {
	                    maybePromise = tryConvertToPromise(
	                        maybePromise._getDisposer().tryDispose(inspection),
	                        resources.promise);
	                } catch (e) {
	                    return thrower(e);
	                }
	                if (maybePromise instanceof Promise) {
	                    return maybePromise._then(iterator, thrower,
	                                              null, null, null);
	                }
	            }
	            iterator();
	        }
	        iterator();
	        return ret;
	    }
	
	    function Disposer(data, promise, context) {
	        this._data = data;
	        this._promise = promise;
	        this._context = context;
	    }
	
	    Disposer.prototype.data = function () {
	        return this._data;
	    };
	
	    Disposer.prototype.promise = function () {
	        return this._promise;
	    };
	
	    Disposer.prototype.resource = function () {
	        if (this.promise().isFulfilled()) {
	            return this.promise().value();
	        }
	        return NULL;
	    };
	
	    Disposer.prototype.tryDispose = function(inspection) {
	        var resource = this.resource();
	        var context = this._context;
	        if (context !== undefined) context._pushContext();
	        var ret = resource !== NULL
	            ? this.doDispose(resource, inspection) : null;
	        if (context !== undefined) context._popContext();
	        this._promise._unsetDisposable();
	        this._data = null;
	        return ret;
	    };
	
	    Disposer.isDisposer = function (d) {
	        return (d != null &&
	                typeof d.resource === "function" &&
	                typeof d.tryDispose === "function");
	    };
	
	    function FunctionDisposer(fn, promise, context) {
	        this.constructor$(fn, promise, context);
	    }
	    inherits(FunctionDisposer, Disposer);
	
	    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
	        var fn = this.data();
	        return fn.call(resource, resource, inspection);
	    };
	
	    function maybeUnwrapDisposer(value) {
	        if (Disposer.isDisposer(value)) {
	            this.resources[this.index]._setDisposable(value);
	            return value.promise();
	        }
	        return value;
	    }
	
	    function ResourceList(length) {
	        this.length = length;
	        this.promise = null;
	        this[length-1] = null;
	    }
	
	    ResourceList.prototype._resultCancelled = function() {
	        var len = this.length;
	        for (var i = 0; i < len; ++i) {
	            var item = this[i];
	            if (item instanceof Promise) {
	                item.cancel();
	            }
	        }
	    };
	
	    Promise.using = function () {
	        var len = arguments.length;
	        if (len < 2) return apiRejection(
	                        "you must pass at least 2 arguments to Promise.using");
	        var fn = arguments[len - 1];
	        if (typeof fn !== "function") {
	            return apiRejection("expecting a function but got " + util.classString(fn));
	        }
	        var input;
	        var spreadArgs = true;
	        if (len === 2 && Array.isArray(arguments[0])) {
	            input = arguments[0];
	            len = input.length;
	            spreadArgs = false;
	        } else {
	            input = arguments;
	            len--;
	        }
	        var resources = new ResourceList(len);
	        for (var i = 0; i < len; ++i) {
	            var resource = input[i];
	            if (Disposer.isDisposer(resource)) {
	                var disposer = resource;
	                resource = resource.promise();
	                resource._setDisposable(disposer);
	            } else {
	                var maybePromise = tryConvertToPromise(resource);
	                if (maybePromise instanceof Promise) {
	                    resource =
	                        maybePromise._then(maybeUnwrapDisposer, null, null, {
	                            resources: resources,
	                            index: i
	                    }, undefined);
	                }
	            }
	            resources[i] = resource;
	        }
	
	        var reflectedResources = new Array(resources.length);
	        for (var i = 0; i < reflectedResources.length; ++i) {
	            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
	        }
	
	        var resultPromise = Promise.all(reflectedResources)
	            .then(function(inspections) {
	                for (var i = 0; i < inspections.length; ++i) {
	                    var inspection = inspections[i];
	                    if (inspection.isRejected()) {
	                        errorObj.e = inspection.error();
	                        return errorObj;
	                    } else if (!inspection.isFulfilled()) {
	                        resultPromise.cancel();
	                        return;
	                    }
	                    inspections[i] = inspection.value();
	                }
	                promise._pushContext();
	
	                fn = tryCatch(fn);
	                var ret = spreadArgs
	                    ? fn.apply(undefined, inspections) : fn(inspections);
	                var promiseCreated = promise._popContext();
	                debug.checkForgottenReturns(
	                    ret, promiseCreated, "Promise.using", promise);
	                return ret;
	            });
	
	        var promise = resultPromise.lastly(function() {
	            var inspection = new Promise.PromiseInspection(resultPromise);
	            return dispose(resources, inspection);
	        });
	        resources.promise = promise;
	        promise._setOnCancel(resources);
	        return promise;
	    };
	
	    Promise.prototype._setDisposable = function (disposer) {
	        this._bitField = this._bitField | 131072;
	        this._disposer = disposer;
	    };
	
	    Promise.prototype._isDisposable = function () {
	        return (this._bitField & 131072) > 0;
	    };
	
	    Promise.prototype._getDisposer = function () {
	        return this._disposer;
	    };
	
	    Promise.prototype._unsetDisposable = function () {
	        this._bitField = this._bitField & (~131072);
	        this._disposer = undefined;
	    };
	
	    Promise.prototype.disposer = function (fn) {
	        if (typeof fn === "function") {
	            return new FunctionDisposer(fn, this, createContext());
	        }
	        throw new TypeError();
	    };
	
	};


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Bowser - a browser detector
	 * https://github.com/ded/bowser
	 * MIT License | (c) Dustin Diaz 2015
	 */
	
	!function (root, name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) __webpack_require__(581)(name, definition)
	  else root[name] = definition()
	}(this, 'bowser', function () {
	  /**
	    * See useragents.js for examples of navigator.userAgent
	    */
	
	  var t = true
	
	  function detect(ua) {
	
	    function getFirstMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[1]) || '';
	    }
	
	    function getSecondMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[2]) || '';
	    }
	
	    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
	      , likeAndroid = /like android/i.test(ua)
	      , android = !likeAndroid && /android/i.test(ua)
	      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
	      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
	      , chromeos = /CrOS/.test(ua)
	      , silk = /silk/i.test(ua)
	      , sailfish = /sailfish/i.test(ua)
	      , tizen = /tizen/i.test(ua)
	      , webos = /(web|hpw)(o|0)s/i.test(ua)
	      , windowsphone = /windows phone/i.test(ua)
	      , samsungBrowser = /SamsungBrowser/i.test(ua)
	      , windows = !windowsphone && /windows/i.test(ua)
	      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
	      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
	      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
	      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
	      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
	      , mobile = !tablet && /[^-]mobi/i.test(ua)
	      , xbox = /xbox/i.test(ua)
	      , result
	
	    if (/opera/i.test(ua)) {
	      //  an old Opera
	      result = {
	        name: 'Opera'
	      , opera: t
	      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
	      }
	    } else if (/opr\/|opios/i.test(ua)) {
	      // a new Opera
	      result = {
	        name: 'Opera'
	        , opera: t
	        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/SamsungBrowser/i.test(ua)) {
	      result = {
	        name: 'Samsung Internet for Android'
	        , samsungBrowser: t
	        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/Whale/i.test(ua)) {
	      result = {
	        name: 'NAVER Whale browser'
	        , whale: t
	        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/MZBrowser/i.test(ua)) {
	      result = {
	        name: 'MZ Browser'
	        , mzbrowser: t
	        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/coast/i.test(ua)) {
	      result = {
	        name: 'Opera Coast'
	        , coast: t
	        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/focus/i.test(ua)) {
	      result = {
	        name: 'Focus'
	        , focus: t
	        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/yabrowser/i.test(ua)) {
	      result = {
	        name: 'Yandex Browser'
	      , yandexbrowser: t
	      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/ucbrowser/i.test(ua)) {
	      result = {
	          name: 'UC Browser'
	        , ucbrowser: t
	        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/mxios/i.test(ua)) {
	      result = {
	        name: 'Maxthon'
	        , maxthon: t
	        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/epiphany/i.test(ua)) {
	      result = {
	        name: 'Epiphany'
	        , epiphany: t
	        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/puffin/i.test(ua)) {
	      result = {
	        name: 'Puffin'
	        , puffin: t
	        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
	      }
	    }
	    else if (/sleipnir/i.test(ua)) {
	      result = {
	        name: 'Sleipnir'
	        , sleipnir: t
	        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/k-meleon/i.test(ua)) {
	      result = {
	        name: 'K-Meleon'
	        , kMeleon: t
	        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (windowsphone) {
	      result = {
	        name: 'Windows Phone'
	      , osname: 'Windows Phone'
	      , windowsphone: t
	      }
	      if (edgeVersion) {
	        result.msedge = t
	        result.version = edgeVersion
	      }
	      else {
	        result.msie = t
	        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/msie|trident/i.test(ua)) {
	      result = {
	        name: 'Internet Explorer'
	      , msie: t
	      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
	      }
	    } else if (chromeos) {
	      result = {
	        name: 'Chrome'
	      , osname: 'Chrome OS'
	      , chromeos: t
	      , chromeBook: t
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    } else if (/edg([ea]|ios)/i.test(ua)) {
	      result = {
	        name: 'Microsoft Edge'
	      , msedge: t
	      , version: edgeVersion
	      }
	    }
	    else if (/vivaldi/i.test(ua)) {
	      result = {
	        name: 'Vivaldi'
	        , vivaldi: t
	        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (sailfish) {
	      result = {
	        name: 'Sailfish'
	      , osname: 'Sailfish OS'
	      , sailfish: t
	      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/seamonkey\//i.test(ua)) {
	      result = {
	        name: 'SeaMonkey'
	      , seamonkey: t
	      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/firefox|iceweasel|fxios/i.test(ua)) {
	      result = {
	        name: 'Firefox'
	      , firefox: t
	      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
	      }
	      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
	        result.firefoxos = t
	        result.osname = 'Firefox OS'
	      }
	    }
	    else if (silk) {
	      result =  {
	        name: 'Amazon Silk'
	      , silk: t
	      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/phantom/i.test(ua)) {
	      result = {
	        name: 'PhantomJS'
	      , phantom: t
	      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/slimerjs/i.test(ua)) {
	      result = {
	        name: 'SlimerJS'
	        , slimer: t
	        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
	      result = {
	        name: 'BlackBerry'
	      , osname: 'BlackBerry OS'
	      , blackberry: t
	      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (webos) {
	      result = {
	        name: 'WebOS'
	      , osname: 'WebOS'
	      , webos: t
	      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
	      };
	      /touchpad\//i.test(ua) && (result.touchpad = t)
	    }
	    else if (/bada/i.test(ua)) {
	      result = {
	        name: 'Bada'
	      , osname: 'Bada'
	      , bada: t
	      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (tizen) {
	      result = {
	        name: 'Tizen'
	      , osname: 'Tizen'
	      , tizen: t
	      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/qupzilla/i.test(ua)) {
	      result = {
	        name: 'QupZilla'
	        , qupzilla: t
	        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
	      }
	    }
	    else if (/chromium/i.test(ua)) {
	      result = {
	        name: 'Chromium'
	        , chromium: t
	        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/chrome|crios|crmo/i.test(ua)) {
	      result = {
	        name: 'Chrome'
	        , chrome: t
	        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (android) {
	      result = {
	        name: 'Android'
	        , version: versionIdentifier
	      }
	    }
	    else if (/safari|applewebkit/i.test(ua)) {
	      result = {
	        name: 'Safari'
	      , safari: t
	      }
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if (iosdevice) {
	      result = {
	        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
	      }
	      // WTF: version is not part of user agent in web apps
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if(/googlebot/i.test(ua)) {
	      result = {
	        name: 'Googlebot'
	      , googlebot: t
	      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
	      }
	    }
	    else {
	      result = {
	        name: getFirstMatch(/^(.*)\/(.*) /),
	        version: getSecondMatch(/^(.*)\/(.*) /)
	     };
	   }
	
	    // set webkit or gecko flag for browsers based on these engines
	    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
	      if (/(apple)?webkit\/537\.36/i.test(ua)) {
	        result.name = result.name || "Blink"
	        result.blink = t
	      } else {
	        result.name = result.name || "Webkit"
	        result.webkit = t
	      }
	      if (!result.version && versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    } else if (!result.opera && /gecko\//i.test(ua)) {
	      result.name = result.name || "Gecko"
	      result.gecko = t
	      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
	    }
	
	    // set OS flags for platforms that have multiple browsers
	    if (!result.windowsphone && (android || result.silk)) {
	      result.android = t
	      result.osname = 'Android'
	    } else if (!result.windowsphone && iosdevice) {
	      result[iosdevice] = t
	      result.ios = t
	      result.osname = 'iOS'
	    } else if (mac) {
	      result.mac = t
	      result.osname = 'macOS'
	    } else if (xbox) {
	      result.xbox = t
	      result.osname = 'Xbox'
	    } else if (windows) {
	      result.windows = t
	      result.osname = 'Windows'
	    } else if (linux) {
	      result.linux = t
	      result.osname = 'Linux'
	    }
	
	    function getWindowsVersion (s) {
	      switch (s) {
	        case 'NT': return 'NT'
	        case 'XP': return 'XP'
	        case 'NT 5.0': return '2000'
	        case 'NT 5.1': return 'XP'
	        case 'NT 5.2': return '2003'
	        case 'NT 6.0': return 'Vista'
	        case 'NT 6.1': return '7'
	        case 'NT 6.2': return '8'
	        case 'NT 6.3': return '8.1'
	        case 'NT 10.0': return '10'
	        default: return undefined
	      }
	    }
	
	    // OS version extraction
	    var osVersion = '';
	    if (result.windows) {
	      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
	    } else if (result.windowsphone) {
	      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
	    } else if (result.mac) {
	      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (iosdevice) {
	      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (android) {
	      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
	    } else if (result.webos) {
	      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
	    } else if (result.blackberry) {
	      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
	    } else if (result.bada) {
	      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
	    } else if (result.tizen) {
	      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
	    }
	    if (osVersion) {
	      result.osversion = osVersion;
	    }
	
	    // device type extraction
	    var osMajorVersion = !result.windows && osVersion.split('.')[0];
	    if (
	         tablet
	      || nexusTablet
	      || iosdevice == 'ipad'
	      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
	      || result.silk
	    ) {
	      result.tablet = t
	    } else if (
	         mobile
	      || iosdevice == 'iphone'
	      || iosdevice == 'ipod'
	      || android
	      || nexusMobile
	      || result.blackberry
	      || result.webos
	      || result.bada
	    ) {
	      result.mobile = t
	    }
	
	    // Graded Browser Support
	    // http://developer.yahoo.com/yui/articles/gbs
	    if (result.msedge ||
	        (result.msie && result.version >= 10) ||
	        (result.yandexbrowser && result.version >= 15) ||
			    (result.vivaldi && result.version >= 1.0) ||
	        (result.chrome && result.version >= 20) ||
	        (result.samsungBrowser && result.version >= 4) ||
	        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
	        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
	        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
	        (result.firefox && result.version >= 20.0) ||
	        (result.safari && result.version >= 6) ||
	        (result.opera && result.version >= 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
	        (result.blackberry && result.version >= 10.1)
	        || (result.chromium && result.version >= 20)
	        ) {
	      result.a = t;
	    }
	    else if ((result.msie && result.version < 10) ||
	        (result.chrome && result.version < 20) ||
	        (result.firefox && result.version < 20.0) ||
	        (result.safari && result.version < 6) ||
	        (result.opera && result.version < 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
	        || (result.chromium && result.version < 20)
	        ) {
	      result.c = t
	    } else result.x = t
	
	    return result
	  }
	
	  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')
	
	  bowser.test = function (browserList) {
	    for (var i = 0; i < browserList.length; ++i) {
	      var browserItem = browserList[i];
	      if (typeof browserItem=== 'string') {
	        if (browserItem in bowser) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Get version precisions count
	   *
	   * @example
	   *   getVersionPrecision("1.10.3") // 3
	   *
	   * @param  {string} version
	   * @return {number}
	   */
	  function getVersionPrecision(version) {
	    return version.split(".").length;
	  }
	
	  /**
	   * Array::map polyfill
	   *
	   * @param  {Array} arr
	   * @param  {Function} iterator
	   * @return {Array}
	   */
	  function map(arr, iterator) {
	    var result = [], i;
	    if (Array.prototype.map) {
	      return Array.prototype.map.call(arr, iterator);
	    }
	    for (i = 0; i < arr.length; i++) {
	      result.push(iterator(arr[i]));
	    }
	    return result;
	  }
	
	  /**
	   * Calculate browser version weight
	   *
	   * @example
	   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
	   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
	   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
	   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
	   *
	   * @param  {Array<String>} versions versions to compare
	   * @return {Number} comparison result
	   */
	  function compareVersions(versions) {
	    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
	    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
	    var chunks = map(versions, function (version) {
	      var delta = precision - getVersionPrecision(version);
	
	      // 2) "9" -> "9.0" (for precision = 2)
	      version = version + new Array(delta + 1).join(".0");
	
	      // 3) "9.0" -> ["000000000"", "000000009"]
	      return map(version.split("."), function (chunk) {
	        return new Array(20 - chunk.length).join("0") + chunk;
	      }).reverse();
	    });
	
	    // iterate in reverse order by reversed chunks array
	    while (--precision >= 0) {
	      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
	      if (chunks[0][precision] > chunks[1][precision]) {
	        return 1;
	      }
	      else if (chunks[0][precision] === chunks[1][precision]) {
	        if (precision === 0) {
	          // all version chunks are same
	          return 0;
	        }
	      }
	      else {
	        return -1;
	      }
	    }
	  }
	
	  /**
	   * Check if browser is unsupported
	   *
	   * @example
	   *   bowser.isUnsupportedBrowser({
	   *     msie: "10",
	   *     firefox: "23",
	   *     chrome: "29",
	   *     safari: "5.1",
	   *     opera: "16",
	   *     phantom: "534"
	   *   });
	   *
	   * @param  {Object}  minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function isUnsupportedBrowser(minVersions, strictMode, ua) {
	    var _bowser = bowser;
	
	    // make strictMode param optional with ua param usage
	    if (typeof strictMode === 'string') {
	      ua = strictMode;
	      strictMode = void(0);
	    }
	
	    if (strictMode === void(0)) {
	      strictMode = false;
	    }
	    if (ua) {
	      _bowser = detect(ua);
	    }
	
	    var version = "" + _bowser.version;
	    for (var browser in minVersions) {
	      if (minVersions.hasOwnProperty(browser)) {
	        if (_bowser[browser]) {
	          if (typeof minVersions[browser] !== 'string') {
	            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
	          }
	
	          // browser version and min supported version.
	          return compareVersions([version, minVersions[browser]]) < 0;
	        }
	      }
	    }
	
	    return strictMode; // not found
	  }
	
	  /**
	   * Check if browser is supported
	   *
	   * @param  {Object} minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function check(minVersions, strictMode, ua) {
	    return !isUnsupportedBrowser(minVersions, strictMode, ua);
	  }
	
	  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
	  bowser.compareVersions = compareVersions;
	  bowser.check = check;
	
	  /*
	   * Set our detect method to the main bowser object so we can
	   * reuse it to test other user agents.
	   * This is needed to implement future tests.
	   */
	  bowser._detect = detect;
	
	  /*
	   * Set our detect public method to the main bowser object
	   * This is needed to implement bowser in server side
	   */
	  bowser.detect = detect;
	  return bowser
	});


/***/ }),
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),
/* 1041 */
/***/ (function(module, exports) {

	function toVal(mix) {
		var k, y, str='';
	
		if (typeof mix === 'string' || typeof mix === 'number') {
			str += mix;
		} else if (typeof mix === 'object') {
			if (Array.isArray(mix)) {
				for (k=0; k < mix.length; k++) {
					if (mix[k]) {
						if (y = toVal(mix[k])) {
							str && (str += ' ');
							str += y;
						}
					}
				}
			} else {
				for (k in mix) {
					if (mix[k]) {
						str && (str += ' ');
						str += k;
					}
				}
			}
		}
	
		return str;
	}
	
	module.exports = function () {
		var i=0, tmp, x, str='';
		while (i < arguments.length) {
			if (tmp = arguments[i++]) {
				if (x = toVal(tmp)) {
					str && (str += ' ');
					str += x
				}
			}
		}
		return str;
	}


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1116);
	__webpack_require__(1117);
	__webpack_require__(1118);
	__webpack_require__(1119);
	__webpack_require__(1120);
	__webpack_require__(1121);
	__webpack_require__(1122);
	__webpack_require__(1123);
	__webpack_require__(1124);
	__webpack_require__(1125);
	__webpack_require__(1126);
	__webpack_require__(1127);
	__webpack_require__(1128);
	__webpack_require__(1129);
	__webpack_require__(1130);
	__webpack_require__(1131);
	__webpack_require__(1132);
	module.exports = __webpack_require__(231).Math;


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1133);
	__webpack_require__(1143);
	__webpack_require__(1144);
	__webpack_require__(1134);
	__webpack_require__(1135);
	__webpack_require__(1136);
	__webpack_require__(1137);
	__webpack_require__(1138);
	__webpack_require__(1139);
	__webpack_require__(1140);
	__webpack_require__(1141);
	__webpack_require__(1142);
	module.exports = __webpack_require__(231).Number;


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(320);
	__webpack_require__(1078);
	module.exports = __webpack_require__(95).Array.from;


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(426);
	__webpack_require__(320);
	module.exports = __webpack_require__(1076);


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(426);
	__webpack_require__(320);
	module.exports = __webpack_require__(1077);


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1080);
	module.exports = __webpack_require__(95).Object.assign;


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1081);
	var $Object = __webpack_require__(95).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1082);
	var $Object = __webpack_require__(95).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1088);
	module.exports = __webpack_require__(95).Object.entries;


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1083);
	module.exports = __webpack_require__(95).Object.getPrototypeOf;


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1084);
	module.exports = __webpack_require__(95).Object.keys;


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1085);
	module.exports = __webpack_require__(95).Object.setPrototypeOf;


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1089);
	module.exports = __webpack_require__(95).Object.values;


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1087);
	__webpack_require__(1086);
	__webpack_require__(1090);
	__webpack_require__(1091);
	module.exports = __webpack_require__(95).Symbol;


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(320);
	__webpack_require__(426);
	module.exports = __webpack_require__(425).f('iterator');


/***/ }),
/* 1057 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 1058 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 1059 */
[2328, 199, 609, 1075],
/* 1060 */
[2330, 180, 268],
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(229);
	var gOPS = __webpack_require__(418);
	var pIE = __webpack_require__(267);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 1062 */
[2335, 179],
/* 1063 */
[2338, 228, 134],
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(413);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 1065 */
[2339, 197],
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(417);
	var descriptor = __webpack_require__(268);
	var setToStringTag = __webpack_require__(419);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(226)(IteratorPrototype, __webpack_require__(134)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 1067 */
[2340, 134],
/* 1068 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(319)('meta');
	var isObject = __webpack_require__(227);
	var has = __webpack_require__(198);
	var setDesc = __webpack_require__(180).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(225)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(160);
	var getKeys = __webpack_require__(229);
	var gOPS = __webpack_require__(418);
	var pIE = __webpack_require__(267);
	var toObject = __webpack_require__(230);
	var IObject = __webpack_require__(600);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(225)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 1071 */
[2343, 180, 197, 229, 160],
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(199);
	var gOPN = __webpack_require__(603).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 1073 */
[2349, 227, 197, 414, 602],
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(422);
	var defined = __webpack_require__(415);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 1075 */
[2352, 422],
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(197);
	var get = __webpack_require__(610);
	module.exports = __webpack_require__(95).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(597);
	var ITERATOR = __webpack_require__(134)('iterator');
	var Iterators = __webpack_require__(228);
	module.exports = __webpack_require__(95).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 1078 */
[2359, 414, 148, 230, 1065, 1063, 609, 1060, 610, 1067],
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(1058);
	var step = __webpack_require__(1068);
	var Iterators = __webpack_require__(228);
	var toIObject = __webpack_require__(199);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(601)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(148);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1070) });


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(148);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(417) });


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(148);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(160), 'Object', { defineProperty: __webpack_require__(180).f });


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(230);
	var $getPrototypeOf = __webpack_require__(604);
	
	__webpack_require__(606)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(230);
	var $keys = __webpack_require__(229);
	
	__webpack_require__(606)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(148);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1073).set });


/***/ }),
/* 1086 */
/***/ (function(module, exports) {



/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(179);
	var has = __webpack_require__(198);
	var DESCRIPTORS = __webpack_require__(160);
	var $export = __webpack_require__(148);
	var redefine = __webpack_require__(608);
	var META = __webpack_require__(1069).KEY;
	var $fails = __webpack_require__(225);
	var shared = __webpack_require__(421);
	var setToStringTag = __webpack_require__(419);
	var uid = __webpack_require__(319);
	var wks = __webpack_require__(134);
	var wksExt = __webpack_require__(425);
	var wksDefine = __webpack_require__(424);
	var enumKeys = __webpack_require__(1061);
	var isArray = __webpack_require__(1064);
	var anObject = __webpack_require__(197);
	var isObject = __webpack_require__(227);
	var toObject = __webpack_require__(230);
	var toIObject = __webpack_require__(199);
	var toPrimitive = __webpack_require__(423);
	var createDesc = __webpack_require__(268);
	var _create = __webpack_require__(417);
	var gOPNExt = __webpack_require__(1072);
	var $GOPD = __webpack_require__(602);
	var $GOPS = __webpack_require__(418);
	var $DP = __webpack_require__(180);
	var $keys = __webpack_require__(229);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(603).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(267).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(318)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(226)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1088 */
[2360, 148, 607],
/* 1089 */
[2361, 148, 607],
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(424)('asyncIterator');


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(424)('observable');


/***/ }),
/* 1092 */
1057,
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(270)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(429)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 1094 */
[2329, 321, 270],
/* 1095 */
[2330, 324, 432],
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(433)('native-function-to-string', Function.toString);


/***/ }),
/* 1097 */
[2335, 149],
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(232);
	var setPrototypeOf = __webpack_require__(1110).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 1099 */
[2337, 321],
/* 1100 */
[2338, 616, 270],
/* 1101 */
[2339, 269],
/* 1102 */
[2340, 270],
/* 1103 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(431);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 1105 */
[2341, 269, 1106, 428, 624, 613, 1097],
/* 1106 */
[2343, 324, 269, 620, 200],
/* 1107 */
[2345, 619, 428],
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(149).parseFloat;
	var $trim = __webpack_require__(434).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(435) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(149).parseInt;
	var $trim = __webpack_require__(434).trim;
	var ws = __webpack_require__(435);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 1110 */
[2349, 232, 269, 427, 618],
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(325);
	var defined = __webpack_require__(322);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 1112 */
[2352, 325],
/* 1113 */
[2355, 322],
/* 1114 */
[2358, 1094, 270, 616, 231],
/* 1115 */
[2359, 427, 53, 1113, 1101, 1100, 625, 1095, 1114, 1102],
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(53);
	var log1p = __webpack_require__(617);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(53);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(53);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(53);
	var sign = __webpack_require__(431);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(53);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(53);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(53);
	var $expm1 = __webpack_require__(430);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(53);
	
	$export($export.S, 'Math', { fround: __webpack_require__(1104) });


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(53);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(53);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(181)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(53);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(53);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(617) });


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(53);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(53);
	
	$export($export.S, 'Math', { sign: __webpack_require__(431) });


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(53);
	var expm1 = __webpack_require__(430);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(181)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(53);
	var expm1 = __webpack_require__(430);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(53);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(149);
	var has = __webpack_require__(323);
	var cof = __webpack_require__(321);
	var inheritIfRequired = __webpack_require__(1098);
	var toPrimitive = __webpack_require__(436);
	var fails = __webpack_require__(181);
	var gOPN = __webpack_require__(1107).f;
	var gOPD = __webpack_require__(618).f;
	var dP = __webpack_require__(324).f;
	var $trim = __webpack_require__(434).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(1105)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(200) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(623)(global, NUMBER, $Number);
	}


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(53);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(53);
	var _isFinite = __webpack_require__(149).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(53);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(615) });


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(53);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(53);
	var isInteger = __webpack_require__(615);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(53);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(53);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(53);
	var $parseFloat = __webpack_require__(1108);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(53);
	var $parseInt = __webpack_require__(1109);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(53);
	var toInteger = __webpack_require__(325);
	var aNumberValue = __webpack_require__(611);
	var repeat = __webpack_require__(1111);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(181)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(53);
	var $fails = __webpack_require__(181);
	var aNumberValue = __webpack_require__(611);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(53);
	var $includes = __webpack_require__(612)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(1093)('includes');


/***/ }),
/* 1146 */
[2360, 53, 622],
/* 1147 */
[2361, 53, 622],
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ v1.2.4 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	function bisector(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	}
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	function pairs(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	}
	
	function pair(a, b) {
	  return [a, b];
	}
	
	function cross(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function number(x) {
	  return x === null ? NaN : +x;
	}
	
	function variance(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	}
	
	function deviation(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	}
	
	function extent(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	}
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function identity(x) {
	  return x;
	}
	
	function range(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	}
	
	var e10 = Math.sqrt(50),
	    e5 = Math.sqrt(10),
	    e2 = Math.sqrt(2);
	
	function ticks(start, stop, count) {
	  var reverse,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  stop = +stop, start = +start, count = +count;
	  if (start === stop && count > 0) return [start];
	  if (reverse = stop < start) n = start, start = stop, stop = n;
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	}
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	function sturges(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	}
	
	function histogram() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	}
	
	function quantile(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	}
	
	function freedmanDiaconis(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	}
	
	function scott(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	}
	
	function max(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	}
	
	function mean(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	}
	
	function median(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	}
	
	function merge(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	}
	
	function min(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	}
	
	function permute(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	}
	
	function scan(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	}
	
	function shuffle(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	}
	
	function sum(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	}
	
	function transpose(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	}
	
	function length(d) {
	  return d.length;
	}
	
	function zip() {
	  return transpose(arguments);
	}
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ v1.0.7 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	function nest() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	}
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	function keys(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	}
	
	function values(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	}
	
	function entries(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	}
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ v1.4.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	function define(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	}
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*",
	    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
	    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
	    reHex = /^#([0-9a-f]{3,8})$/,
	    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
	    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
	    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
	    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
	    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
	    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  copy: function(channels) {
	    return Object.assign(new this.constructor, this, channels);
	  },
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  hex: color_formatHex, // Deprecated! Use color.formatHex.
	  formatHex: color_formatHex,
	  formatHsl: color_formatHsl,
	  formatRgb: color_formatRgb,
	  toString: color_formatRgb
	});
	
	function color_formatHex() {
	  return this.rgb().formatHex();
	}
	
	function color_formatHsl() {
	  return hslConvert(this).formatHsl();
	}
	
	function color_formatRgb() {
	  return this.rgb().formatRgb();
	}
	
	function color(format) {
	  var m, l;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
	      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
	      : l === 8 ? new Rgb(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
	      : l === 4 ? new Rgb((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
	      : null) // invalid hex
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (-0.5 <= this.r && this.r < 255.5)
	        && (-0.5 <= this.g && this.g < 255.5)
	        && (-0.5 <= this.b && this.b < 255.5)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
	  formatHex: rgb_formatHex,
	  formatRgb: rgb_formatRgb,
	  toString: rgb_formatRgb
	}));
	
	function rgb_formatHex() {
	  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
	}
	
	function rgb_formatRgb() {
	  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	  return (a === 1 ? "rgb(" : "rgba(")
	      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	      + (a === 1 ? ")" : ", " + a + ")");
	}
	
	function hex(value) {
	  value = Math.max(0, Math.min(255, Math.round(value) || 0));
	  return (value < 16 ? "0" : "") + value.toString(16);
	}
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  formatHsl: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "hsl(" : "hsla(")
	        + (this.h || 0) + ", "
	        + (this.s || 0) * 100 + "%, "
	        + (this.l || 0) * 100 + "%"
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	// https://observablehq.com/@mbostock/lab-and-rgb
	var K = 18,
	    Xn = 0.96422,
	    Yn = 1,
	    Zn = 0.82521,
	    t0 = 4 / 29,
	    t1 = 6 / 29,
	    t2 = 3 * t1 * t1,
	    t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) return hcl2lab(o);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = rgb2lrgb(o.r),
	      g = rgb2lrgb(o.g),
	      b = rgb2lrgb(o.b),
	      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
	  if (r === g && g === b) x = z = y; else {
	    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
	    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
	  }
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function gray(l, opacity) {
	  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    x = Xn * lab2xyz(x);
	    y = Yn * lab2xyz(y);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
	      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
	      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function lrgb2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2lrgb(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function lch(l, c, h, opacity) {
	  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	function hcl2lab(o) {
	  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
	  var h = o.h * deg2rad;
	  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return hcl2lab(this).rgb();
	  }
	}));
	
	var A = -0.14861,
	    B = +1.78277,
	    C = -0.29227,
	    D = -0.90649,
	    E = +1.97294,
	    ED = E * D,
	    EB = E * B,
	    BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.cubehelix = cubehelix;
	exports.gray = gray;
	exports.hcl = hcl;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.lch = lch;
	exports.rgb = rgb;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ v1.4.2 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	function formatDecimal(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	}
	
	function exponent(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	}
	
	function formatGroup(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	}
	
	function formatNumerals(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	}
	
	// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
	var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	  var match;
	  return new FormatSpecifier({
	    fill: match[1],
	    align: match[2],
	    sign: match[3],
	    symbol: match[4],
	    zero: match[5],
	    width: match[6],
	    comma: match[7],
	    precision: match[8] && match[8].slice(1),
	    trim: match[9],
	    type: match[10]
	  });
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
	  this.align = specifier.align === undefined ? ">" : specifier.align + "";
	  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
	  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
	  this.zero = !!specifier.zero;
	  this.width = specifier.width === undefined ? undefined : +specifier.width;
	  this.comma = !!specifier.comma;
	  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
	  this.trim = !!specifier.trim;
	  this.type = specifier.type === undefined ? "" : specifier.type + "";
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
	      + (this.trim ? "~" : "")
	      + this.type;
	};
	
	// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
	function formatTrim(s) {
	  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (s[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      default: if (i0 > 0) { if (!+s[i]) break out; i0 = 0; } break;
	    }
	  }
	  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
	}
	
	var prefixExponent;
	
	function formatPrefixAuto(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	}
	
	function formatRounded(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	}
	
	var formatTypes = {
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	function identity(x) {
	  return x;
	}
	
	var map = Array.prototype.map,
	    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	function formatLocale(locale) {
	  var group = locale.grouping === undefined || locale.thousands === undefined ? identity : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
	      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
	      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
	      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
	      numerals = locale.numerals === undefined ? identity : formatNumerals(map.call(locale.numerals, String)),
	      percent = locale.percent === undefined ? "%" : locale.percent + "",
	      minus = locale.minus === undefined ? "-" : locale.minus + "",
	      nan = locale.nan === undefined ? "NaN" : locale.nan + "";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        trim = specifier.trim,
	        type = specifier.type;
	
	    // The "n" type is an alias for ",g".
	    if (type === "n") comma = true, type = "g";
	
	    // The "" type, and any invalid type, is an alias for ".12~g".
	    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";
	
	    // If zero fill is specified, padding goes after sign and before digits.
	    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision === undefined ? 6
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
	
	        // Trim insignificant zeros.
	        if (trim) value = formatTrim(value);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	
	        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	}
	
	var locale;
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""],
	  minus: "-"
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	function precisionFixed(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	}
	
	function precisionPrefix(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	}
	
	function precisionRound(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	}
	
	exports.FormatSpecifier = FormatSpecifier;
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ v1.4.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(1150)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	function basis$1(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function basisClosed(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb = (function rgbGamma(y) {
	  var color = gamma(y);
	
	  function rgb(start, end) {
	    var r = color((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color(start.g, end.g),
	        b = color(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb.gamma = rgbGamma;
	
	  return rgb;
	})(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color;
	    for (i = 0; i < n; ++i) {
	      color = d3Color.rgb(colors[i]);
	      r[i] = color.r || 0;
	      g[i] = color.g || 0;
	      b[i] = color.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color.opacity = 1;
	    return function(t) {
	      color.r = r(t);
	      color.g = g(t);
	      color.b = b(t);
	      return color + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	function numberArray(a, b) {
	  if (!b) b = [];
	  var n = a ? Math.min(b.length, a.length) : 0,
	      c = b.slice(),
	      i;
	  return function(t) {
	    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
	    return c;
	  };
	}
	
	function isNumberArray(x) {
	  return ArrayBuffer.isView(x) && !(x instanceof DataView);
	}
	
	function array(a, b) {
	  return (isNumberArray(b) ? numberArray : genericArray)(a, b);
	}
	
	function genericArray(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	}
	
	function date(a, b) {
	  var d = new Date;
	  return a = +a, b = +b, function(t) {
	    return d.setTime(a * (1 - t) + b * t), d;
	  };
	}
	
	function number(a, b) {
	  return a = +a, b = +b, function(t) {
	    return a * (1 - t) + b * t;
	  };
	}
	
	function object(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	}
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
	    reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	function string(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	}
	
	function value(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb) : string)
	      : b instanceof d3Color.color ? rgb
	      : b instanceof Date ? date
	      : isNumberArray(b) ? numberArray
	      : Array.isArray(b) ? genericArray
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	}
	
	function discrete(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	function hue$1(a, b) {
	  var i = hue(+a, +b);
	  return function(t) {
	    var x = i(t);
	    return x - 360 * Math.floor(x / 360);
	  };
	}
	
	function round(a, b) {
	  return a = +a, b = +b, function(t) {
	    return Math.round(a * (1 - t) + b * t);
	  };
	}
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	function decompose(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	}
	
	var cssNode,
	    cssRoot,
	    cssView,
	    svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2,
	    rho2 = 2,
	    rho4 = 4,
	    epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	function zoom(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	}
	
	function hsl(hue) {
	  return function(start, end) {
	    var h = hue((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$1 = hsl(hue);
	var hslLong = hsl(nogamma);
	
	function lab(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl(hue) {
	  return function(start, end) {
	    var h = hue((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$1 = hcl(hue);
	var hclLong = hcl(nogamma);
	
	function cubehelix(hue) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix(start, end) {
	      var h = hue((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix.gamma = cubehelixGamma;
	
	    return cubehelix;
	  })(1);
	}
	
	var cubehelix$1 = cubehelix(hue);
	var cubehelixLong = cubehelix(nogamma);
	
	function piecewise(interpolate, values) {
	  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
	  while (i < n) I[i] = interpolate(v, v = values[++i]);
	  return function(t) {
	    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
	    return I[i](t - i);
	  };
	}
	
	function quantize(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	}
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateCubehelix = cubehelix$1;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.interpolateDate = date;
	exports.interpolateDiscrete = discrete;
	exports.interpolateHcl = hcl$1;
	exports.interpolateHclLong = hclLong;
	exports.interpolateHsl = hsl$1;
	exports.interpolateHslLong = hslLong;
	exports.interpolateHue = hue$1;
	exports.interpolateLab = lab;
	exports.interpolateNumber = number;
	exports.interpolateNumberArray = numberArray;
	exports.interpolateObject = object;
	exports.interpolateRgb = rgb;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.piecewise = piecewise;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ v1.0.9 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	var pi = Math.PI,
	    tau = 2 * pi,
	    epsilon = 1e-6,
	    tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon));
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r, ccw = !!ccw;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ v2.2.2 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(628)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newDate(y, m, d) {
	  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "f": formatMicroseconds,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "q": formatQuarter,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatSeconds,
	    "u": formatWeekdayNumberMonday,
	    "U": formatWeekNumberSunday,
	    "V": formatWeekNumberISO,
	    "w": formatWeekdayNumberSunday,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "f": formatUTCMicroseconds,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "q": formatUTCQuarter,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatUTCSeconds,
	    "u": formatUTCWeekdayNumberMonday,
	    "U": formatUTCWeekNumberSunday,
	    "V": formatUTCWeekNumberISO,
	    "w": formatUTCWeekdayNumberSunday,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "f": parseMicroseconds,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "q": parseQuarter,
	    "Q": parseUnixTimestamp,
	    "s": parseUnixTimestampSeconds,
	    "S": parseSeconds,
	    "u": parseWeekdayNumberMonday,
	    "U": parseWeekNumberSunday,
	    "V": parseWeekNumberISO,
	    "w": parseWeekdayNumberSunday,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, Z) {
	    return function(string) {
	      var d = newDate(1900, undefined, 1),
	          i = parseSpecifier(d, specifier, string += "", 0),
	          week, day;
	      if (i != string.length) return null;
	
	      // If a UNIX timestamp is specified, return it.
	      if ("Q" in d) return new Date(d.Q);
	      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
	
	      // If this is utcParse, never use the local timezone.
	      if (Z && !("Z" in d)) d.Z = 0;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // If the month was not specified, inherit from the quarter.
	      if (d.m === undefined) d.m = "q" in d ? d.q : 0;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("V" in d) {
	        if (d.V < 1 || d.V > 53) return null;
	        if (!("w" in d)) d.w = 1;
	        if ("Z" in d) {
	          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
	          week = day > 4 || day === 0 ? d3Time.utcMonday.ceil(week) : d3Time.utcMonday(week);
	          week = d3Time.utcDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getUTCFullYear();
	          d.m = week.getUTCMonth();
	          d.d = week.getUTCDate() + (d.w + 6) % 7;
	        } else {
	          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
	          week = day > 4 || day === 0 ? d3Time.timeMonday.ceil(week) : d3Time.timeMonday(week);
	          week = d3Time.timeDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getFullYear();
	          d.m = week.getMonth();
	          d.d = week.getDate() + (d.w + 6) % 7;
	        }
	      } else if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return localDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatQuarter(d) {
	    return 1 + ~~(d.getMonth() / 3);
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  function formatUTCQuarter(d) {
	    return 1 + ~~(d.getUTCMonth() / 3);
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", false);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier += "", true);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"},
	    numberRe = /^\s*\d+/, // note: ignores next directive
	    percentRe = /^%/,
	    requoteRe = /[\\^$*+?|[\]().{}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekdayNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.u = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberISO(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.V = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseQuarter(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseMicroseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 6));
	  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function parseUnixTimestamp(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0], i + n[0].length) : -1;
	}
	
	function parseUnixTimestampSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.s = +n[0], i + n[0].length) : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMicroseconds(d, p) {
	  return formatMilliseconds(d, p) + "000";
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekdayNumberMonday(d) {
	  var day = d.getDay();
	  return day === 0 ? 7 : day;
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d) - 1, d), p, 2);
	}
	
	function formatWeekNumberISO(d, p) {
	  var day = d.getDay();
	  d = (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	  return pad(d3Time.timeThursday.count(d3Time.timeYear(d), d) + (d3Time.timeYear(d).getDay() === 4), p, 2);
	}
	
	function formatWeekdayNumberSunday(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d) - 1, d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMicroseconds(d, p) {
	  return formatUTCMilliseconds(d, p) + "000";
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekdayNumberMonday(d) {
	  var dow = d.getUTCDay();
	  return dow === 0 ? 7 : dow;
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d) - 1, d), p, 2);
	}
	
	function formatUTCWeekNumberISO(d, p) {
	  var day = d.getUTCDay();
	  d = (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	  return pad(d3Time.utcThursday.count(d3Time.utcYear(d), d) + (d3Time.utcYear(d).getUTCDay() === 4), p, 2);
	}
	
	function formatUTCWeekdayNumberSunday(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d) - 1, d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	function formatUnixTimestamp(d) {
	  return +d;
	}
	
	function formatUnixTimestampSeconds(d) {
	  return Math.floor(+d / 1000);
	}
	
	var locale;
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.timeFormat = locale.format;
	  exports.timeParse = locale.parse;
	  exports.utcFormat = locale.utcFormat;
	  exports.utcParse = locale.utcParse;
	  return locale;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ }),
/* 1155 */
/***/ (function(module, exports) {

	var MILI    = 'milliseconds'
	  , SECONDS = 'seconds'
	  , MINUTES = 'minutes'
	  , HOURS   = 'hours'
	  , DAY     = 'day'
	  , WEEK    = 'week'
	  , MONTH   = 'month'
	  , YEAR    = 'year'
	  , DECADE  = 'decade'
	  , CENTURY = 'century';
	
	var dates = module.exports = {
	
	  add: function(date, num, unit) {
	    date = new Date(date)
	
	    switch (unit){
	      case MILI:
	      case SECONDS:
	      case MINUTES:
	      case HOURS:
	      case YEAR:
	        return dates[unit](date, dates[unit](date) + num)
	      case DAY:
	        return dates.date(date, dates.date(date) + num)
	      case WEEK:
	        return dates.date(date, dates.date(date) + (7 * num)) 
	      case MONTH:
	        return monthMath(date, num)
	      case DECADE:
	        return dates.year(date, dates.year(date) + (num * 10))
	      case CENTURY:
	        return dates.year(date, dates.year(date) + (num * 100))
	    }
	
	    throw new TypeError('Invalid units: "' + unit + '"')
	  },
	
	  subtract: function(date, num, unit) {
	    return dates.add(date, -num, unit)
	  },
	
	  startOf: function(date, unit, firstOfWeek) {
	    date = new Date(date)
	
	    switch (unit) {
	      case 'century':
	      case 'decade':
	      case 'year':
	          date = dates.month(date, 0);
	      case 'month':
	          date = dates.date(date, 1);
	      case 'week':
	      case 'day':
	          date = dates.hours(date, 0);
	      case 'hours':
	          date = dates.minutes(date, 0);
	      case 'minutes':
	          date = dates.seconds(date, 0);
	      case 'seconds':
	          date = dates.milliseconds(date, 0);
	    }
	
	    if (unit === DECADE) 
	      date = dates.subtract(date, dates.year(date) % 10, 'year')
	    
	    if (unit === CENTURY) 
	      date = dates.subtract(date, dates.year(date) % 100, 'year')
	
	    if (unit === WEEK) 
	      date = dates.weekday(date, 0, firstOfWeek);
	
	    return date
	  },
	
	
	  endOf: function(date, unit, firstOfWeek){
	    date = new Date(date)
	    date = dates.startOf(date, unit, firstOfWeek)
	    date = dates.add(date, 1, unit)
	    date = dates.subtract(date, 1, MILI)
	    return date
	  },
	
	  eq:  createComparer(function(a, b){ return a === b }),
	  neq: createComparer(function(a, b){ return a !== b }),
	  gt:  createComparer(function(a, b){ return a > b }),
	  gte: createComparer(function(a, b){ return a >= b }),
	  lt:  createComparer(function(a, b){ return a < b }),
	  lte: createComparer(function(a, b){ return a <= b }),
	
	  min: function(){
	    return new Date(Math.min.apply(Math, arguments))
	  },
	
	  max: function(){
	    return new Date(Math.max.apply(Math, arguments))
	  },
	  
	  inRange: function(day, min, max, unit){
	    unit = unit || 'day'
	
	    return (!min || dates.gte(day, min, unit))
	        && (!max || dates.lte(day, max, unit))
	  },
	
	  milliseconds:   createAccessor('Milliseconds'),
	  seconds:        createAccessor('Seconds'),
	  minutes:        createAccessor('Minutes'),
	  hours:          createAccessor('Hours'),
	  day:            createAccessor('Day'),
	  date:           createAccessor('Date'),
	  month:          createAccessor('Month'),
	  year:           createAccessor('FullYear'),
	
	  decade: function (date, val) {
	    return val === undefined 
	      ? dates.year(dates.startOf(date, DECADE))
	      : dates.add(date, val + 10, YEAR);
	  },
	
	  century: function (date, val) {
	    return val === undefined 
	      ? dates.year(dates.startOf(date, CENTURY))
	      : dates.add(date, val + 100, YEAR);
	  },
	
	  weekday: function (date, val, firstDay) {
	      var weekday = (dates.day(date) + 7 - (firstDay || 0) ) % 7;
	
	      return val === undefined 
	        ? weekday 
	        : dates.add(date, val - weekday, DAY);
	  },
	
	  diff: function (date1, date2, unit, asFloat) {
	    var dividend, divisor, result;
	
	    switch (unit) {
	      case MILI:
	      case SECONDS:
	      case MINUTES:
	      case HOURS:
	      case DAY:
	      case WEEK:
	        dividend = date2.getTime() - date1.getTime(); break;
	      case MONTH:
	      case YEAR:
	      case DECADE:
	      case CENTURY:
	        dividend = (dates.year(date2) - dates.year(date1)) * 12 + dates.month(date2) - dates.month(date1); break;
	      default:
	        throw new TypeError('Invalid units: "' + unit + '"');
	    }
	
	    switch (unit) {
	      case MILI:
	          divisor = 1; break;
	      case SECONDS:
	          divisor = 1000; break;
	      case MINUTES:
	          divisor = 1000 * 60; break;
	      case HOURS:
	          divisor = 1000 * 60 * 60; break;
	      case DAY:
	          divisor = 1000 * 60 * 60 * 24; break;
	      case WEEK:
	          divisor = 1000 * 60 * 60 * 24 * 7; break;
	      case MONTH:
	          divisor = 1; break;
	      case YEAR:
	          divisor = 12; break;
	      case DECADE:
	          divisor = 120; break;
	      case CENTURY:
	          divisor = 1200; break;
	      default:
	        throw new TypeError('Invalid units: "' + unit + '"');
	    }
	
	    result = dividend / divisor;
	
	    return asFloat ? result : absoluteFloor(result);
	  }
	};
	
	function absoluteFloor(number) {
	  return number < 0 ? Math.ceil(number) : Math.floor(number);
	}
	
	function monthMath(date, val){
	  var current = dates.month(date)
	    , newMonth  = (current + val);
	
	    date = dates.month(date, newMonth)
	
	    while (newMonth < 0 ) newMonth = 12 + newMonth
	      
	    //month rollover
	    if ( dates.month(date) !== ( newMonth % 12))
	      date = dates.date(date, 0) //move to last of month
	
	    return date
	}
	
	function createAccessor(method){
	  return function(date, val){
	    if (val === undefined)
	      return date['get' + method]()
	
	    date = new Date(date)
	    date['set' + method](val)
	    return date
	  }
	}
	
	function createComparer(operator) {
	  return function (a, b, unit) {
	    return operator(+dates.startOf(a, unit), +dates.startOf(b, unit))
	  };
	}


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _isDisposable = __webpack_require__(440);
	
	var _isDisposable2 = _interopRequireDefault(_isDisposable);
	
	/**
	 * Represents a group of disposable resources that are disposed together.
	 */
	
	var CompositeDisposable = (function () {
	  function CompositeDisposable() {
	    for (var _len = arguments.length, disposables = Array(_len), _key = 0; _key < _len; _key++) {
	      disposables[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, CompositeDisposable);
	
	    if (Array.isArray(disposables[0]) && disposables.length === 1) {
	      disposables = disposables[0];
	    }
	
	    for (var i = 0; i < disposables.length; i++) {
	      if (!_isDisposable2['default'](disposables[i])) {
	        throw new Error('Expected a disposable');
	      }
	    }
	
	    this.disposables = disposables;
	    this.isDisposed = false;
	  }
	
	  /**
	   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
	   * @param {Disposable} item Disposable to add.
	   */
	
	  CompositeDisposable.prototype.add = function add(item) {
	    if (this.isDisposed) {
	      item.dispose();
	    } else {
	      this.disposables.push(item);
	    }
	  };
	
	  /**
	   * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
	   * @param {Disposable} item Disposable to remove.
	   * @returns {Boolean} true if found; false otherwise.
	   */
	
	  CompositeDisposable.prototype.remove = function remove(item) {
	    if (this.isDisposed) {
	      return false;
	    }
	
	    var index = this.disposables.indexOf(item);
	    if (index === -1) {
	      return false;
	    }
	
	    this.disposables.splice(index, 1);
	    item.dispose();
	    return true;
	  };
	
	  /**
	   * Disposes all disposables in the group and removes them from the group.
	   */
	
	  CompositeDisposable.prototype.dispose = function dispose() {
	    if (this.isDisposed) {
	      return;
	    }
	
	    var len = this.disposables.length;
	    var currentDisposables = new Array(len);
	    for (var i = 0; i < len; i++) {
	      currentDisposables[i] = this.disposables[i];
	    }
	
	    this.isDisposed = true;
	    this.disposables = [];
	    this.length = 0;
	
	    for (var i = 0; i < len; i++) {
	      currentDisposables[i].dispose();
	    }
	  };
	
	  return CompositeDisposable;
	})();
	
	exports['default'] = CompositeDisposable;
	module.exports = exports['default'];

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var noop = function noop() {};
	
	/**
	 * The basic disposable.
	 */
	
	var Disposable = (function () {
	  _createClass(Disposable, null, [{
	    key: "empty",
	    value: { dispose: noop },
	    enumerable: true
	  }]);
	
	  function Disposable(action) {
	    _classCallCheck(this, Disposable);
	
	    this.isDisposed = false;
	    this.action = action || noop;
	  }
	
	  Disposable.prototype.dispose = function dispose() {
	    if (!this.isDisposed) {
	      this.action.call(null);
	      this.isDisposed = true;
	    }
	  };
	
	  return Disposable;
	})();
	
	exports["default"] = Disposable;
	module.exports = exports["default"];

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _isDisposable = __webpack_require__(440);
	
	var _isDisposable2 = _interopRequireDefault(_isDisposable);
	
	var SerialDisposable = (function () {
	  function SerialDisposable() {
	    _classCallCheck(this, SerialDisposable);
	
	    this.isDisposed = false;
	    this.current = null;
	  }
	
	  /**
	   * Gets the underlying disposable.
	   * @return The underlying disposable.
	   */
	
	  SerialDisposable.prototype.getDisposable = function getDisposable() {
	    return this.current;
	  };
	
	  /**
	   * Sets the underlying disposable.
	   * @param {Disposable} value The new underlying disposable.
	   */
	
	  SerialDisposable.prototype.setDisposable = function setDisposable() {
	    var value = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	
	    if (value != null && !_isDisposable2['default'](value)) {
	      throw new Error('Expected either an empty value or a valid disposable');
	    }
	
	    var isDisposed = this.isDisposed;
	    var previous = undefined;
	
	    if (!isDisposed) {
	      previous = this.current;
	      this.current = value;
	    }
	
	    if (previous) {
	      previous.dispose();
	    }
	
	    if (isDisposed && value) {
	      value.dispose();
	    }
	  };
	
	  /**
	   * Disposes the underlying disposable as well as all future replacements.
	   */
	
	  SerialDisposable.prototype.dispose = function dispose() {
	    if (this.isDisposed) {
	      return;
	    }
	
	    this.isDisposed = true;
	    var previous = this.current;
	    this.current = null;
	
	    if (previous) {
	      previous.dispose();
	    }
	  };
	
	  return SerialDisposable;
	})();
	
	exports['default'] = SerialDisposable;
	module.exports = exports['default'];

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _isDisposable2 = __webpack_require__(440);
	
	var _isDisposable3 = _interopRequireDefault(_isDisposable2);
	
	exports.isDisposable = _isDisposable3['default'];
	
	var _Disposable2 = __webpack_require__(1157);
	
	var _Disposable3 = _interopRequireDefault(_Disposable2);
	
	exports.Disposable = _Disposable3['default'];
	
	var _CompositeDisposable2 = __webpack_require__(1156);
	
	var _CompositeDisposable3 = _interopRequireDefault(_CompositeDisposable2);
	
	exports.CompositeDisposable = _CompositeDisposable3['default'];
	
	var _SerialDisposable2 = __webpack_require__(1158);
	
	var _SerialDisposable3 = _interopRequireDefault(_SerialDisposable2);
	
	exports.SerialDisposable = _SerialDisposable3['default'];

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _createStore = __webpack_require__(1974);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _reducers = __webpack_require__(1168);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _dragDrop = __webpack_require__(327);
	
	var dragDropActions = _interopRequireWildcard(_dragDrop);
	
	var _DragDropMonitor = __webpack_require__(1161);
	
	var _DragDropMonitor2 = _interopRequireDefault(_DragDropMonitor);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DragDropManager = function () {
		function DragDropManager(createBackend) {
			var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			_classCallCheck(this, DragDropManager);
	
			var store = (0, _createStore2.default)(_reducers2.default);
			this.context = context;
			this.store = store;
			this.monitor = new _DragDropMonitor2.default(store);
			this.registry = this.monitor.registry;
			this.backend = createBackend(this);
	
			store.subscribe(this.handleRefCountChange.bind(this));
		}
	
		_createClass(DragDropManager, [{
			key: 'handleRefCountChange',
			value: function handleRefCountChange() {
				var shouldSetUp = this.store.getState().refCount > 0;
				if (shouldSetUp && !this.isSetUp) {
					this.backend.setup();
					this.isSetUp = true;
				} else if (!shouldSetUp && this.isSetUp) {
					this.backend.teardown();
					this.isSetUp = false;
				}
			}
		}, {
			key: 'getContext',
			value: function getContext() {
				return this.context;
			}
		}, {
			key: 'getMonitor',
			value: function getMonitor() {
				return this.monitor;
			}
		}, {
			key: 'getBackend',
			value: function getBackend() {
				return this.backend;
			}
		}, {
			key: 'getRegistry',
			value: function getRegistry() {
				return this.registry;
			}
		}, {
			key: 'getActions',
			value: function getActions() {
				var manager = this;
				var dispatch = this.store.dispatch;
	
	
				function bindActionCreator(actionCreator) {
					return function () {
						for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
							args[_key] = arguments[_key];
						}
	
						var action = actionCreator.apply(manager, args);
						if (typeof action !== 'undefined') {
							dispatch(action);
						}
					};
				}
	
				return Object.keys(dragDropActions).filter(function (key) {
					return typeof dragDropActions[key] === 'function';
				}).reduce(function (boundActions, key) {
					var action = dragDropActions[key];
					boundActions[key] = bindActionCreator(action); // eslint-disable-line no-param-reassign
					return boundActions;
				}, {});
			}
		}]);
	
		return DragDropManager;
	}();
	
	exports.default = DragDropManager;

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isArray = __webpack_require__(62);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _matchesType = __webpack_require__(632);
	
	var _matchesType2 = _interopRequireDefault(_matchesType);
	
	var _HandlerRegistry = __webpack_require__(1164);
	
	var _HandlerRegistry2 = _interopRequireDefault(_HandlerRegistry);
	
	var _dragOffset = __webpack_require__(631);
	
	var _dirtyHandlerIds = __webpack_require__(630);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DragDropMonitor = function () {
		function DragDropMonitor(store) {
			_classCallCheck(this, DragDropMonitor);
	
			this.store = store;
			this.registry = new _HandlerRegistry2.default(store);
		}
	
		_createClass(DragDropMonitor, [{
			key: 'subscribeToStateChange',
			value: function subscribeToStateChange(listener) {
				var _this = this;
	
				var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
				var handlerIds = options.handlerIds;
	
				(0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
				(0, _invariant2.default)(typeof handlerIds === 'undefined' || (0, _isArray2.default)(handlerIds), 'handlerIds, when specified, must be an array of strings.');
	
				var prevStateId = this.store.getState().stateId;
				var handleChange = function handleChange() {
					var state = _this.store.getState();
					var currentStateId = state.stateId;
					try {
						var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, _dirtyHandlerIds.areDirty)(state.dirtyHandlerIds, handlerIds);
	
						if (!canSkipListener) {
							listener();
						}
					} finally {
						prevStateId = currentStateId;
					}
				};
	
				return this.store.subscribe(handleChange);
			}
		}, {
			key: 'subscribeToOffsetChange',
			value: function subscribeToOffsetChange(listener) {
				var _this2 = this;
	
				(0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
	
				var previousState = this.store.getState().dragOffset;
				var handleChange = function handleChange() {
					var nextState = _this2.store.getState().dragOffset;
					if (nextState === previousState) {
						return;
					}
	
					previousState = nextState;
					listener();
				};
	
				return this.store.subscribe(handleChange);
			}
		}, {
			key: 'canDragSource',
			value: function canDragSource(sourceId) {
				var source = this.registry.getSource(sourceId);
				(0, _invariant2.default)(source, 'Expected to find a valid source.');
	
				if (this.isDragging()) {
					return false;
				}
	
				return source.canDrag(this, sourceId);
			}
		}, {
			key: 'canDropOnTarget',
			value: function canDropOnTarget(targetId) {
				var target = this.registry.getTarget(targetId);
				(0, _invariant2.default)(target, 'Expected to find a valid target.');
	
				if (!this.isDragging() || this.didDrop()) {
					return false;
				}
	
				var targetType = this.registry.getTargetType(targetId);
				var draggedItemType = this.getItemType();
				return (0, _matchesType2.default)(targetType, draggedItemType) && target.canDrop(this, targetId);
			}
		}, {
			key: 'isDragging',
			value: function isDragging() {
				return Boolean(this.getItemType());
			}
		}, {
			key: 'isDraggingSource',
			value: function isDraggingSource(sourceId) {
				var source = this.registry.getSource(sourceId, true);
				(0, _invariant2.default)(source, 'Expected to find a valid source.');
	
				if (!this.isDragging() || !this.isSourcePublic()) {
					return false;
				}
	
				var sourceType = this.registry.getSourceType(sourceId);
				var draggedItemType = this.getItemType();
				if (sourceType !== draggedItemType) {
					return false;
				}
	
				return source.isDragging(this, sourceId);
			}
		}, {
			key: 'isOverTarget',
			value: function isOverTarget(targetId) {
				var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { shallow: false };
				var shallow = options.shallow;
	
				if (!this.isDragging()) {
					return false;
				}
	
				var targetType = this.registry.getTargetType(targetId);
				var draggedItemType = this.getItemType();
				if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
					return false;
				}
	
				var targetIds = this.getTargetIds();
				if (!targetIds.length) {
					return false;
				}
	
				var index = targetIds.indexOf(targetId);
				if (shallow) {
					return index === targetIds.length - 1;
				} else {
					return index > -1;
				}
			}
		}, {
			key: 'getItemType',
			value: function getItemType() {
				return this.store.getState().dragOperation.itemType;
			}
		}, {
			key: 'getItem',
			value: function getItem() {
				return this.store.getState().dragOperation.item;
			}
		}, {
			key: 'getSourceId',
			value: function getSourceId() {
				return this.store.getState().dragOperation.sourceId;
			}
		}, {
			key: 'getTargetIds',
			value: function getTargetIds() {
				return this.store.getState().dragOperation.targetIds;
			}
		}, {
			key: 'getDropResult',
			value: function getDropResult() {
				return this.store.getState().dragOperation.dropResult;
			}
		}, {
			key: 'didDrop',
			value: function didDrop() {
				return this.store.getState().dragOperation.didDrop;
			}
		}, {
			key: 'isSourcePublic',
			value: function isSourcePublic() {
				return this.store.getState().dragOperation.isSourcePublic;
			}
		}, {
			key: 'getInitialClientOffset',
			value: function getInitialClientOffset() {
				return this.store.getState().dragOffset.initialClientOffset;
			}
		}, {
			key: 'getInitialSourceClientOffset',
			value: function getInitialSourceClientOffset() {
				return this.store.getState().dragOffset.initialSourceClientOffset;
			}
		}, {
			key: 'getClientOffset',
			value: function getClientOffset() {
				return this.store.getState().dragOffset.clientOffset;
			}
		}, {
			key: 'getSourceClientOffset',
			value: function getSourceClientOffset() {
				return (0, _dragOffset.getSourceClientOffset)(this.store.getState().dragOffset);
			}
		}, {
			key: 'getDifferenceFromInitialOffset',
			value: function getDifferenceFromInitialOffset() {
				return (0, _dragOffset.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
			}
		}]);
	
		return DragDropMonitor;
	}();
	
	exports.default = DragDropMonitor;

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DragSource = function () {
		function DragSource() {
			_classCallCheck(this, DragSource);
		}
	
		_createClass(DragSource, [{
			key: "canDrag",
			value: function canDrag() {
				return true;
			}
		}, {
			key: "isDragging",
			value: function isDragging(monitor, handle) {
				return handle === monitor.getSourceId();
			}
		}, {
			key: "endDrag",
			value: function endDrag() {}
		}]);
	
		return DragSource;
	}();
	
	exports.default = DragSource;

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DropTarget = function () {
		function DropTarget() {
			_classCallCheck(this, DropTarget);
		}
	
		_createClass(DropTarget, [{
			key: "canDrop",
			value: function canDrop() {
				return true;
			}
		}, {
			key: "hover",
			value: function hover() {}
		}, {
			key: "drop",
			value: function drop() {}
		}]);
	
		return DropTarget;
	}();
	
	exports.default = DropTarget;

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isArray = __webpack_require__(62);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _asap = __webpack_require__(978);
	
	var _asap2 = _interopRequireDefault(_asap);
	
	var _registry = __webpack_require__(328);
	
	var _getNextUniqueId = __webpack_require__(1171);
	
	var _getNextUniqueId2 = _interopRequireDefault(_getNextUniqueId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HandlerRoles = {
		SOURCE: 'SOURCE',
		TARGET: 'TARGET'
	};
	
	function validateSourceContract(source) {
		(0, _invariant2.default)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
		(0, _invariant2.default)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
		(0, _invariant2.default)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
	}
	
	function validateTargetContract(target) {
		(0, _invariant2.default)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
		(0, _invariant2.default)(typeof target.hover === 'function', 'Expected hover to be a function.');
		(0, _invariant2.default)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
	}
	
	function validateType(type, allowArray) {
		if (allowArray && (0, _isArray2.default)(type)) {
			type.forEach(function (t) {
				return validateType(t, false);
			});
			return;
		}
	
		(0, _invariant2.default)(typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
	}
	
	function getNextHandlerId(role) {
		var id = (0, _getNextUniqueId2.default)().toString();
		switch (role) {
			case HandlerRoles.SOURCE:
				return 'S' + id;
			case HandlerRoles.TARGET:
				return 'T' + id;
			default:
				(0, _invariant2.default)(false, 'Unknown role: ' + role);
		}
	}
	
	function parseRoleFromHandlerId(handlerId) {
		switch (handlerId[0]) {
			case 'S':
				return HandlerRoles.SOURCE;
			case 'T':
				return HandlerRoles.TARGET;
			default:
				(0, _invariant2.default)(false, 'Cannot parse handler ID: ' + handlerId);
		}
	}
	
	var HandlerRegistry = function () {
		function HandlerRegistry(store) {
			_classCallCheck(this, HandlerRegistry);
	
			this.store = store;
	
			this.types = {};
			this.handlers = {};
	
			this.pinnedSourceId = null;
			this.pinnedSource = null;
		}
	
		_createClass(HandlerRegistry, [{
			key: 'addSource',
			value: function addSource(type, source) {
				validateType(type);
				validateSourceContract(source);
	
				var sourceId = this.addHandler(HandlerRoles.SOURCE, type, source);
				this.store.dispatch((0, _registry.addSource)(sourceId));
				return sourceId;
			}
		}, {
			key: 'addTarget',
			value: function addTarget(type, target) {
				validateType(type, true);
				validateTargetContract(target);
	
				var targetId = this.addHandler(HandlerRoles.TARGET, type, target);
				this.store.dispatch((0, _registry.addTarget)(targetId));
				return targetId;
			}
		}, {
			key: 'addHandler',
			value: function addHandler(role, type, handler) {
				var id = getNextHandlerId(role);
				this.types[id] = type;
				this.handlers[id] = handler;
	
				return id;
			}
		}, {
			key: 'containsHandler',
			value: function containsHandler(handler) {
				var _this = this;
	
				return Object.keys(this.handlers).some(function (key) {
					return _this.handlers[key] === handler;
				});
			}
		}, {
			key: 'getSource',
			value: function getSource(sourceId, includePinned) {
				(0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
	
				var isPinned = includePinned && sourceId === this.pinnedSourceId;
				var source = isPinned ? this.pinnedSource : this.handlers[sourceId];
	
				return source;
			}
		}, {
			key: 'getTarget',
			value: function getTarget(targetId) {
				(0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
				return this.handlers[targetId];
			}
		}, {
			key: 'getSourceType',
			value: function getSourceType(sourceId) {
				(0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
				return this.types[sourceId];
			}
		}, {
			key: 'getTargetType',
			value: function getTargetType(targetId) {
				(0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
				return this.types[targetId];
			}
		}, {
			key: 'isSourceId',
			value: function isSourceId(handlerId) {
				var role = parseRoleFromHandlerId(handlerId);
				return role === HandlerRoles.SOURCE;
			}
		}, {
			key: 'isTargetId',
			value: function isTargetId(handlerId) {
				var role = parseRoleFromHandlerId(handlerId);
				return role === HandlerRoles.TARGET;
			}
		}, {
			key: 'removeSource',
			value: function removeSource(sourceId) {
				var _this2 = this;
	
				(0, _invariant2.default)(this.getSource(sourceId), 'Expected an existing source.');
				this.store.dispatch((0, _registry.removeSource)(sourceId));
	
				(0, _asap2.default)(function () {
					delete _this2.handlers[sourceId];
					delete _this2.types[sourceId];
				});
			}
		}, {
			key: 'removeTarget',
			value: function removeTarget(targetId) {
				var _this3 = this;
	
				(0, _invariant2.default)(this.getTarget(targetId), 'Expected an existing target.');
				this.store.dispatch((0, _registry.removeTarget)(targetId));
	
				(0, _asap2.default)(function () {
					delete _this3.handlers[targetId];
					delete _this3.types[targetId];
				});
			}
		}, {
			key: 'pinSource',
			value: function pinSource(sourceId) {
				var source = this.getSource(sourceId);
				(0, _invariant2.default)(source, 'Expected an existing source.');
	
				this.pinnedSourceId = sourceId;
				this.pinnedSource = source;
			}
		}, {
			key: 'unpinSource',
			value: function unpinSource() {
				(0, _invariant2.default)(this.pinnedSource, 'No source is pinned at the time.');
	
				this.pinnedSourceId = null;
				this.pinnedSource = null;
			}
		}]);
	
		return HandlerRegistry;
	}();
	
	exports.default = HandlerRegistry;

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createBackend;
	
	var _noop = __webpack_require__(729);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TestBackend = function () {
		function TestBackend(manager) {
			_classCallCheck(this, TestBackend);
	
			this.actions = manager.getActions();
		}
	
		_createClass(TestBackend, [{
			key: 'setup',
			value: function setup() {
				this.didCallSetup = true;
			}
		}, {
			key: 'teardown',
			value: function teardown() {
				this.didCallTeardown = true;
			}
		}, {
			key: 'connectDragSource',
			value: function connectDragSource() {
				return _noop2.default;
			}
		}, {
			key: 'connectDragPreview',
			value: function connectDragPreview() {
				return _noop2.default;
			}
		}, {
			key: 'connectDropTarget',
			value: function connectDropTarget() {
				return _noop2.default;
			}
		}, {
			key: 'simulateBeginDrag',
			value: function simulateBeginDrag(sourceIds, options) {
				this.actions.beginDrag(sourceIds, options);
			}
		}, {
			key: 'simulatePublishDragSource',
			value: function simulatePublishDragSource() {
				this.actions.publishDragSource();
			}
		}, {
			key: 'simulateHover',
			value: function simulateHover(targetIds, options) {
				this.actions.hover(targetIds, options);
			}
		}, {
			key: 'simulateDrop',
			value: function simulateDrop() {
				this.actions.drop();
			}
		}, {
			key: 'simulateEndDrag',
			value: function simulateEndDrag() {
				this.actions.endDrag();
			}
		}]);
	
		return TestBackend;
	}();
	
	function createBackend(manager) {
		return new TestBackend(manager);
	}

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DragDropManager = __webpack_require__(1160);
	
	Object.defineProperty(exports, 'DragDropManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragDropManager).default;
	  }
	});
	
	var _DragSource = __webpack_require__(1162);
	
	Object.defineProperty(exports, 'DragSource', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragSource).default;
	  }
	});
	
	var _DropTarget = __webpack_require__(1163);
	
	Object.defineProperty(exports, 'DropTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropTarget).default;
	  }
	});
	
	var _createTestBackend = __webpack_require__(1165);
	
	Object.defineProperty(exports, 'createTestBackend', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_createTestBackend).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = dragOperation;
	
	var _without = __webpack_require__(738);
	
	var _without2 = _interopRequireDefault(_without);
	
	var _dragDrop = __webpack_require__(327);
	
	var _registry = __webpack_require__(328);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
		itemType: null,
		item: null,
		sourceId: null,
		targetIds: [],
		dropResult: null,
		didDrop: false,
		isSourcePublic: null
	};
	
	function dragOperation() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		var action = arguments[1];
	
		switch (action.type) {
			case _dragDrop.BEGIN_DRAG:
				return _extends({}, state, {
					itemType: action.itemType,
					item: action.item,
					sourceId: action.sourceId,
					isSourcePublic: action.isSourcePublic,
					dropResult: null,
					didDrop: false
				});
			case _dragDrop.PUBLISH_DRAG_SOURCE:
				return _extends({}, state, {
					isSourcePublic: true
				});
			case _dragDrop.HOVER:
				return _extends({}, state, {
					targetIds: action.targetIds
				});
			case _registry.REMOVE_TARGET:
				if (state.targetIds.indexOf(action.targetId) === -1) {
					return state;
				}
				return _extends({}, state, {
					targetIds: (0, _without2.default)(state.targetIds, action.targetId)
				});
			case _dragDrop.DROP:
				return _extends({}, state, {
					dropResult: action.dropResult,
					didDrop: true,
					targetIds: []
				});
			case _dragDrop.END_DRAG:
				return _extends({}, state, {
					itemType: null,
					item: null,
					sourceId: null,
					dropResult: null,
					didDrop: false,
					isSourcePublic: null,
					targetIds: []
				});
			default:
				return state;
		}
	}

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = reduce;
	
	var _dragOffset = __webpack_require__(631);
	
	var _dragOffset2 = _interopRequireDefault(_dragOffset);
	
	var _dragOperation = __webpack_require__(1167);
	
	var _dragOperation2 = _interopRequireDefault(_dragOperation);
	
	var _refCount = __webpack_require__(1169);
	
	var _refCount2 = _interopRequireDefault(_refCount);
	
	var _dirtyHandlerIds = __webpack_require__(630);
	
	var _dirtyHandlerIds2 = _interopRequireDefault(_dirtyHandlerIds);
	
	var _stateId = __webpack_require__(1170);
	
	var _stateId2 = _interopRequireDefault(_stateId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function reduce() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		return {
			dirtyHandlerIds: (0, _dirtyHandlerIds2.default)(state.dirtyHandlerIds, action, state.dragOperation),
			dragOffset: (0, _dragOffset2.default)(state.dragOffset, action),
			refCount: (0, _refCount2.default)(state.refCount, action),
			dragOperation: (0, _dragOperation2.default)(state.dragOperation, action),
			stateId: (0, _stateId2.default)(state.stateId)
		};
	}

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = refCount;
	
	var _registry = __webpack_require__(328);
	
	function refCount() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
		var action = arguments[1];
	
		switch (action.type) {
			case _registry.ADD_SOURCE:
			case _registry.ADD_TARGET:
				return state + 1;
			case _registry.REMOVE_SOURCE:
			case _registry.REMOVE_TARGET:
				return state - 1;
			default:
				return state;
		}
	}

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = stateId;
	function stateId() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
		return state + 1;
	}

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = getNextUniqueId;
	var nextUniqueId = 0;
	
	function getNextUniqueId() {
		return nextUniqueId++;
	}

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addClass = _interopRequireDefault(__webpack_require__(634));
	
	exports.addClass = _addClass.default;
	
	var _removeClass = _interopRequireDefault(__webpack_require__(636));
	
	exports.removeClass = _removeClass.default;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(635));
	
	exports.hasClass = _hasClass.default;
	var _default = {
	  addClass: _addClass.default,
	  removeClass: _removeClass.default,
	  hasClass: _hasClass.default
	};
	exports.default = _default;

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = filterEvents;
	
	var _contains = _interopRequireDefault(__webpack_require__(234));
	
	var _querySelectorAll = _interopRequireDefault(__webpack_require__(1178));
	
	function filterEvents(selector, handler) {
	  return function filterHandler(e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = (0, _querySelectorAll.default)(top, selector);
	    if (matches.some(function (match) {
	      return (0, _contains.default)(match, target);
	    })) handler.call(this, e);
	  };
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _on = _interopRequireDefault(__webpack_require__(329));
	
	exports.on = _on.default;
	
	var _off = _interopRequireDefault(__webpack_require__(441));
	
	exports.off = _off.default;
	
	var _filter = _interopRequireDefault(__webpack_require__(1173));
	
	exports.filter = _filter.default;
	
	var _listen = _interopRequireDefault(__webpack_require__(1175));
	
	exports.listen = _listen.default;
	var _default = {
	  on: _on.default,
	  off: _off.default,
	  filter: _filter.default,
	  listen: _listen.default
	};
	exports.default = _default;

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(182));
	
	var _on = _interopRequireDefault(__webpack_require__(329));
	
	var _off = _interopRequireDefault(__webpack_require__(441));
	
	var listen = function listen() {};
	
	if (_inDOM.default) {
	  listen = function listen(node, eventName, handler, capture) {
	    (0, _on.default)(node, eventName, handler, capture);
	    return function () {
	      (0, _off.default)(node, eventName, handler, capture);
	    };
	  };
	}
	
	var _default = listen;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = offsetParent;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(233));
	
	var _style = _interopRequireDefault(__webpack_require__(331));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = position;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(977));
	
	var _offset = _interopRequireDefault(__webpack_require__(637));
	
	var _offsetParent = _interopRequireDefault(__webpack_require__(1176));
	
	var _scrollTop = _interopRequireDefault(__webpack_require__(638));
	
	var _scrollLeft = _interopRequireDefault(__webpack_require__(1179));
	
	var _style = _interopRequireDefault(__webpack_require__(331));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = {
	    top: 0,
	    left: 0
	  },
	      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	
	  if ((0, _style.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent.default)(node);
	    offset = (0, _offset.default)(node);
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
	    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
	  } // Subtract parent offsets and node margins
	
	
	  return (0, _extends2.default)({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = qsa;
	// Zepto.js
	// (c) 2010-2015 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/;
	var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(330));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(640));
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	      prop = (0, _camelizeStyle.default)(prop);
	      if (prop == 'float') prop = 'styleFloat';
	      var current = node.currentStyle[prop] || null;
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
	
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px'; // Revert the changed values
	
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeStyle;
	
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(89);
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__(1184));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function combineOrderedStyles(customMap, defaults) {
	  if (customMap == null) {
	    return defaults;
	  }
	
	  var _defaults = _slicedToArray(defaults, 2),
	      defaultStyleMap = _defaults[0],
	      defaultStyleOrder = _defaults[1];
	
	  var styleMap = _objectSpread({}, defaultStyleMap);
	
	  var styleOrder = _toConsumableArray(defaultStyleOrder);
	
	  for (var _i2 = 0, _Object$keys = Object.keys(customMap); _i2 < _Object$keys.length; _i2++) {
	    var _styleName = _Object$keys[_i2];
	
	    if (defaultStyleMap.hasOwnProperty(_styleName)) {
	      var defaultStyles = defaultStyleMap[_styleName];
	      styleMap[_styleName] = _objectSpread({}, defaultStyles, {}, customMap[_styleName]);
	    } else {
	      styleMap[_styleName] = customMap[_styleName];
	      styleOrder.push(_styleName);
	    }
	  }
	
	  return [styleMap, styleOrder];
	}
	
	var _default = combineOrderedStyles;
	exports["default"] = _default;

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	// Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
	var ATTR_NAME_MAP = {
	  acceptCharset: 'accept-charset',
	  className: 'class',
	  htmlFor: 'for',
	  httpEquiv: 'http-equiv'
	};
	
	function normalizeAttributes(attributes) {
	  if (attributes == null) {
	    return attributes;
	  }
	
	  var normalized = {};
	  var didNormalize = false;
	
	  for (var _i = 0, _Object$keys = Object.keys(attributes); _i < _Object$keys.length; _i++) {
	    var name = _Object$keys[_i];
	    var newName = name;
	
	    if (ATTR_NAME_MAP.hasOwnProperty(name)) {
	      newName = ATTR_NAME_MAP[name];
	      didNormalize = true;
	    }
	
	    normalized[newName] = attributes[name];
	  }
	
	  return didNormalize ? normalized : attributes;
	}
	
	var _default = normalizeAttributes;
	exports["default"] = _default;

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var VENDOR_PREFIX = /^(moz|ms|o|webkit)-/;
	var NUMERIC_STRING = /^\d+$/;
	var UPPERCASE_PATTERN = /([A-Z])/g; // Lifted from:
	// https://github.com/facebook/react/blob/ab4ddf64939aebbbc8d31be1022efd56e834c95c/src/renderers/dom/shared/CSSProperty.js
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	}; // Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/CSSPropertyOperations.js
	
	function processStyleName(name) {
	  return name.replace(UPPERCASE_PATTERN, '-$1').toLowerCase().replace(VENDOR_PREFIX, '-$1-');
	} // Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/dangerousStyleValue.js
	
	
	function processStyleValue(name, value) {
	  var isNumeric;
	
	  if (typeof value === 'string') {
	    isNumeric = NUMERIC_STRING.test(value);
	  } else {
	    isNumeric = true;
	    value = String(value);
	  }
	
	  if (!isNumeric || value === '0' || isUnitlessNumber[name] === true) {
	    return value;
	  } else {
	    return value + 'px';
	  }
	}
	
	function styleToCSS(styleDescr) {
	  return Object.keys(styleDescr).map(function (name) {
	    var styleValue = processStyleValue(name, styleDescr[name]);
	    var styleName = processStyleName(name);
	    return "".concat(styleName, ": ").concat(styleValue);
	  }).join('; ');
	}
	
	var _default = styleToCSS;
	exports["default"] = _default;

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = stateToHTML;
	
	var _combineOrderedStyles3 = _interopRequireDefault(__webpack_require__(1186));
	
	var _normalizeAttributes = _interopRequireDefault(__webpack_require__(1187));
	
	var _styleToCSS = _interopRequireDefault(__webpack_require__(1188));
	
	var _draftJsUtils = __webpack_require__(1193);
	
	var _DEFAULT_STYLE_MAP, _ENTITY_ATTR_MAP, _DATA_TO_ATTR;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var BOLD = _draftJsUtils.INLINE_STYLE.BOLD,
	    CODE = _draftJsUtils.INLINE_STYLE.CODE,
	    ITALIC = _draftJsUtils.INLINE_STYLE.ITALIC,
	    STRIKETHROUGH = _draftJsUtils.INLINE_STYLE.STRIKETHROUGH,
	    UNDERLINE = _draftJsUtils.INLINE_STYLE.UNDERLINE;
	var INDENT = '  ';
	var BREAK = '<br>';
	var DATA_ATTRIBUTE = /^data-([a-z0-9-]+)$/;
	var DEFAULT_STYLE_MAP = (_DEFAULT_STYLE_MAP = {}, _defineProperty(_DEFAULT_STYLE_MAP, BOLD, {
	  element: 'strong'
	}), _defineProperty(_DEFAULT_STYLE_MAP, CODE, {
	  element: 'code'
	}), _defineProperty(_DEFAULT_STYLE_MAP, ITALIC, {
	  element: 'em'
	}), _defineProperty(_DEFAULT_STYLE_MAP, STRIKETHROUGH, {
	  element: 'del'
	}), _defineProperty(_DEFAULT_STYLE_MAP, UNDERLINE, {
	  element: 'u'
	}), _DEFAULT_STYLE_MAP); // Order: inner-most style to outer-most.
	// Examle: <em><strong>foo</strong></em>
	
	var DEFAULT_STYLE_ORDER = [BOLD, ITALIC, UNDERLINE, STRIKETHROUGH, CODE]; // Map entity data to element attributes.
	
	var ENTITY_ATTR_MAP = (_ENTITY_ATTR_MAP = {}, _defineProperty(_ENTITY_ATTR_MAP, _draftJsUtils.ENTITY_TYPE.LINK, {
	  url: 'href',
	  href: 'href',
	  rel: 'rel',
	  target: 'target',
	  title: 'title',
	  className: 'class'
	}), _defineProperty(_ENTITY_ATTR_MAP, _draftJsUtils.ENTITY_TYPE.IMAGE, {
	  src: 'src',
	  height: 'height',
	  width: 'width',
	  alt: 'alt',
	  className: 'class'
	}), _ENTITY_ATTR_MAP); // Map entity data to element attributes.
	
	var DATA_TO_ATTR = (_DATA_TO_ATTR = {}, _defineProperty(_DATA_TO_ATTR, _draftJsUtils.ENTITY_TYPE.LINK, function (entityType, entity) {
	  var attrMap = ENTITY_ATTR_MAP.hasOwnProperty(entityType) ? ENTITY_ATTR_MAP[entityType] : {};
	  var data = entity.getData();
	  var attrs = {};
	
	  for (var _i = 0, _Object$keys = Object.keys(data); _i < _Object$keys.length; _i++) {
	    var dataKey = _Object$keys[_i];
	    var dataValue = data[dataKey];
	
	    if (attrMap.hasOwnProperty(dataKey)) {
	      var attrKey = attrMap[dataKey];
	      attrs[attrKey] = dataValue;
	    } else if (DATA_ATTRIBUTE.test(dataKey)) {
	      attrs[dataKey] = dataValue;
	    }
	  }
	
	  return attrs;
	}), _defineProperty(_DATA_TO_ATTR, _draftJsUtils.ENTITY_TYPE.IMAGE, function (entityType, entity) {
	  var attrMap = ENTITY_ATTR_MAP.hasOwnProperty(entityType) ? ENTITY_ATTR_MAP[entityType] : {};
	  var data = entity.getData();
	  var attrs = {};
	
	  for (var _i2 = 0, _Object$keys2 = Object.keys(data); _i2 < _Object$keys2.length; _i2++) {
	    var dataKey = _Object$keys2[_i2];
	    var dataValue = data[dataKey];
	
	    if (attrMap.hasOwnProperty(dataKey)) {
	      var attrKey = attrMap[dataKey];
	      attrs[attrKey] = dataValue;
	    } else if (DATA_ATTRIBUTE.test(dataKey)) {
	      attrs[dataKey] = dataValue;
	    }
	  }
	
	  return attrs;
	}), _DATA_TO_ATTR); // The reason this returns an array is because a single block might get wrapped
	// in two tags.
	
	function getTags(blockType, defaultBlockTag) {
	  switch (blockType) {
	    case _draftJsUtils.BLOCK_TYPE.HEADER_ONE:
	      return ['h1'];
	
	    case _draftJsUtils.BLOCK_TYPE.HEADER_TWO:
	      return ['h2'];
	
	    case _draftJsUtils.BLOCK_TYPE.HEADER_THREE:
	      return ['h3'];
	
	    case _draftJsUtils.BLOCK_TYPE.HEADER_FOUR:
	      return ['h4'];
	
	    case _draftJsUtils.BLOCK_TYPE.HEADER_FIVE:
	      return ['h5'];
	
	    case _draftJsUtils.BLOCK_TYPE.HEADER_SIX:
	      return ['h6'];
	
	    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
	    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
	      return ['li'];
	
	    case _draftJsUtils.BLOCK_TYPE.BLOCKQUOTE:
	      return ['blockquote'];
	
	    case _draftJsUtils.BLOCK_TYPE.CODE:
	      return ['pre', 'code'];
	
	    case _draftJsUtils.BLOCK_TYPE.ATOMIC:
	      return ['figure'];
	
	    default:
	      if (defaultBlockTag === null) {
	        return [];
	      }
	
	      return [defaultBlockTag || 'p'];
	  }
	}
	
	function getWrapperTag(blockType) {
	  switch (blockType) {
	    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
	      return 'ul';
	
	    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
	      return 'ol';
	
	    default:
	      return null;
	  }
	}
	
	var MarkupGenerator =
	/*#__PURE__*/
	function () {
	  // These are related to state.
	  // These are related to user-defined options.
	  function MarkupGenerator(contentState, options) {
	    _classCallCheck(this, MarkupGenerator);
	
	    _defineProperty(this, "blocks", void 0);
	
	    _defineProperty(this, "contentState", void 0);
	
	    _defineProperty(this, "currentBlock", void 0);
	
	    _defineProperty(this, "indentLevel", void 0);
	
	    _defineProperty(this, "output", void 0);
	
	    _defineProperty(this, "totalBlocks", void 0);
	
	    _defineProperty(this, "wrapperTag", void 0);
	
	    _defineProperty(this, "options", void 0);
	
	    _defineProperty(this, "inlineStyles", void 0);
	
	    _defineProperty(this, "inlineStyleFn", void 0);
	
	    _defineProperty(this, "styleOrder", void 0);
	
	    if (options == null) {
	      options = {};
	    }
	
	    this.contentState = contentState;
	    this.options = options;
	
	    var _combineOrderedStyles = (0, _combineOrderedStyles3["default"])(options.inlineStyles, [DEFAULT_STYLE_MAP, DEFAULT_STYLE_ORDER]),
	        _combineOrderedStyles2 = _slicedToArray(_combineOrderedStyles, 2),
	        inlineStyles = _combineOrderedStyles2[0],
	        styleOrder = _combineOrderedStyles2[1];
	
	    this.inlineStyles = inlineStyles;
	    this.inlineStyleFn = options.inlineStyleFn;
	    this.styleOrder = styleOrder;
	  }
	
	  _createClass(MarkupGenerator, [{
	    key: "generate",
	    value: function generate() {
	      this.output = [];
	      this.blocks = this.contentState.getBlocksAsArray();
	      this.totalBlocks = this.blocks.length;
	      this.currentBlock = 0;
	      this.indentLevel = 0;
	      this.wrapperTag = null;
	
	      while (this.currentBlock < this.totalBlocks) {
	        this.processBlock();
	      }
	
	      this.closeWrapperTag();
	      return this.output.join('').trim();
	    }
	  }, {
	    key: "processBlock",
	    value: function processBlock() {
	      var _this$options = this.options,
	          blockRenderers = _this$options.blockRenderers,
	          defaultBlockTag = _this$options.defaultBlockTag;
	      var block = this.blocks[this.currentBlock];
	      var blockType = block.getType();
	      var newWrapperTag = getWrapperTag(blockType);
	
	      if (this.wrapperTag !== newWrapperTag) {
	        if (this.wrapperTag) {
	          this.closeWrapperTag();
	        }
	
	        if (newWrapperTag) {
	          this.openWrapperTag(newWrapperTag);
	        }
	      }
	
	      this.indent(); // Allow blocks to be rendered using a custom renderer.
	
	      var customRenderer = blockRenderers != null && blockRenderers.hasOwnProperty(blockType) ? blockRenderers[blockType] : null;
	      var customRendererOutput = customRenderer ? customRenderer(block) : null; // Renderer can return null, which will cause processing to continue as normal.
	
	      if (customRendererOutput != null) {
	        this.output.push(customRendererOutput);
	        this.output.push('\n');
	        this.currentBlock += 1;
	        return;
	      }
	
	      this.writeStartTag(block, defaultBlockTag);
	      this.output.push(this.renderBlockContent(block)); // Look ahead and see if we will nest list.
	
	      var nextBlock = this.getNextBlock();
	
	      if (canHaveDepth(blockType) && nextBlock && nextBlock.getDepth() === block.getDepth() + 1) {
	        this.output.push('\n'); // This is a litle hacky: temporarily stash our current wrapperTag and
	        // render child list(s).
	
	        var thisWrapperTag = this.wrapperTag;
	        this.wrapperTag = null;
	        this.indentLevel += 1;
	        this.currentBlock += 1;
	        this.processBlocksAtDepth(nextBlock.getDepth());
	        this.wrapperTag = thisWrapperTag;
	        this.indentLevel -= 1;
	        this.indent();
	      } else {
	        this.currentBlock += 1;
	      }
	
	      this.writeEndTag(block, defaultBlockTag);
	    }
	  }, {
	    key: "processBlocksAtDepth",
	    value: function processBlocksAtDepth(depth) {
	      var block = this.blocks[this.currentBlock];
	
	      while (block && block.getDepth() === depth) {
	        this.processBlock();
	        block = this.blocks[this.currentBlock];
	      }
	
	      this.closeWrapperTag();
	    }
	  }, {
	    key: "getNextBlock",
	    value: function getNextBlock() {
	      return this.blocks[this.currentBlock + 1];
	    }
	  }, {
	    key: "writeStartTag",
	    value: function writeStartTag(block, defaultBlockTag) {
	      var tags = getTags(block.getType(), defaultBlockTag);
	      var attrString;
	
	      if (this.options.blockStyleFn) {
	        var _ref = this.options.blockStyleFn(block) || {},
	            attributes = _ref.attributes,
	            _style = _ref.style; // Normalize `className` -> `class`, etc.
	
	
	        attributes = (0, _normalizeAttributes["default"])(attributes);
	
	        if (_style != null) {
	          var styleAttr = (0, _styleToCSS["default"])(_style);
	          attributes = attributes == null ? {
	            style: styleAttr
	          } : _objectSpread({}, attributes, {
	            style: styleAttr
	          });
	        }
	
	        attrString = stringifyAttrs(attributes);
	      } else {
	        attrString = '';
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var tag = _step.value;
	          this.output.push("<".concat(tag).concat(attrString, ">"));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
	            _iterator["return"]();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: "writeEndTag",
	    value: function writeEndTag(block, defaultBlockTag) {
	      var tags = getTags(block.getType(), defaultBlockTag);
	
	      if (tags.length === 1) {
	        this.output.push("</".concat(tags[0], ">\n"));
	      } else {
	        var output = [];
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = tags[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var tag = _step2.value;
	            output.unshift("</".concat(tag, ">"));
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
	              _iterator2["return"]();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	
	        this.output.push(output.join('') + '\n');
	      }
	    }
	  }, {
	    key: "openWrapperTag",
	    value: function openWrapperTag(wrapperTag) {
	      this.wrapperTag = wrapperTag;
	      this.indent();
	      this.output.push("<".concat(wrapperTag, ">\n"));
	      this.indentLevel += 1;
	    }
	  }, {
	    key: "closeWrapperTag",
	    value: function closeWrapperTag() {
	      var wrapperTag = this.wrapperTag;
	
	      if (wrapperTag) {
	        this.indentLevel -= 1;
	        this.indent();
	        this.output.push("</".concat(wrapperTag, ">\n"));
	        this.wrapperTag = null;
	      }
	    }
	  }, {
	    key: "indent",
	    value: function indent() {
	      this.output.push(INDENT.repeat(this.indentLevel));
	    }
	  }, {
	    key: "withCustomInlineStyles",
	    value: function withCustomInlineStyles(content, styleSet) {
	      if (!this.inlineStyleFn) {
	        return content;
	      }
	
	      var renderConfig = this.inlineStyleFn(styleSet);
	
	      if (!renderConfig) {
	        return content;
	      }
	
	      var _renderConfig$element = renderConfig.element,
	          element = _renderConfig$element === void 0 ? 'span' : _renderConfig$element,
	          attributes = renderConfig.attributes,
	          style = renderConfig.style;
	      var attrString = stringifyAttrs(_objectSpread({}, attributes, {
	        style: style && (0, _styleToCSS["default"])(style)
	      }));
	      return "<".concat(element).concat(attrString, ">").concat(content, "</").concat(element, ">");
	    }
	  }, {
	    key: "renderBlockContent",
	    value: function renderBlockContent(block) {
	      var _this = this;
	
	      var blockType = block.getType();
	      var text = block.getText();
	
	      if (text === '') {
	        // Prevent element collapse if completely empty.
	        return BREAK;
	      }
	
	      text = this.preserveWhitespace(text);
	      var charMetaList = block.getCharacterList();
	      var entityPieces = (0, _draftJsUtils.getEntityRanges)(text, charMetaList);
	      return entityPieces.map(function (_ref2) {
	        var _ref3 = _slicedToArray(_ref2, 2),
	            entityKey = _ref3[0],
	            stylePieces = _ref3[1];
	
	        var content = stylePieces.map(function (_ref4) {
	          var _ref5 = _slicedToArray(_ref4, 2),
	              text = _ref5[0],
	              styleSet = _ref5[1];
	
	          var content = encodeContent(text);
	          var _iteratorNormalCompletion3 = true;
	          var _didIteratorError3 = false;
	          var _iteratorError3 = undefined;
	
	          try {
	            for (var _iterator3 = _this.styleOrder[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	              var _styleName = _step3.value;
	
	              // If our block type is CODE then don't wrap inline code elements.
	              if (_styleName === CODE && blockType === _draftJsUtils.BLOCK_TYPE.CODE) {
	                continue;
	              }
	
	              if (styleSet.has(_styleName)) {
	                var _this$inlineStyles$_s = _this.inlineStyles[_styleName],
	                    element = _this$inlineStyles$_s.element,
	                    attributes = _this$inlineStyles$_s.attributes,
	                    _style2 = _this$inlineStyles$_s.style;
	
	                if (element == null) {
	                  element = 'span';
	                } // Normalize `className` -> `class`, etc.
	
	
	                attributes = (0, _normalizeAttributes["default"])(attributes);
	
	                if (_style2 != null) {
	                  var styleAttr = (0, _styleToCSS["default"])(_style2);
	                  attributes = attributes == null ? {
	                    style: styleAttr
	                  } : _objectSpread({}, attributes, {
	                    style: styleAttr
	                  });
	                }
	
	                var attrString = stringifyAttrs(attributes);
	                content = "<".concat(element).concat(attrString, ">").concat(content, "</").concat(element, ">");
	              }
	            }
	          } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
	                _iterator3["return"]();
	              }
	            } finally {
	              if (_didIteratorError3) {
	                throw _iteratorError3;
	              }
	            }
	          }
	
	          return _this.withCustomInlineStyles(content, styleSet);
	        }).join('');
	        var entity = entityKey ? _this.contentState.getEntity(entityKey) : null; // Note: The `toUpperCase` below is for compatability with some libraries that use lower-case for image blocks.
	
	        var entityType = entity == null ? null : entity.getType().toUpperCase();
	        var entityStyle;
	
	        if (entity != null && _this.options.entityStyleFn && (entityStyle = _this.options.entityStyleFn(entity))) {
	          var _entityStyle = entityStyle,
	              element = _entityStyle.element,
	              attributes = _entityStyle.attributes,
	              _style3 = _entityStyle.style;
	
	          if (element == null) {
	            element = 'span';
	          } // Normalize `className` -> `class`, etc.
	
	
	          attributes = (0, _normalizeAttributes["default"])(attributes);
	
	          if (_style3 != null) {
	            var styleAttr = (0, _styleToCSS["default"])(_style3);
	            attributes = attributes == null ? {
	              style: styleAttr
	            } : _objectSpread({}, attributes, {
	              style: styleAttr
	            });
	          }
	
	          var attrString = stringifyAttrs(attributes);
	          return "<".concat(element).concat(attrString, ">").concat(content, "</").concat(element, ">");
	        } else if (entityType != null && entityType === _draftJsUtils.ENTITY_TYPE.LINK) {
	          var attrs = DATA_TO_ATTR.hasOwnProperty(entityType) ? DATA_TO_ATTR[entityType](entityType, entity) : null;
	
	          var _attrString = stringifyAttrs(attrs);
	
	          return "<a".concat(_attrString, ">").concat(content, "</a>");
	        } else if (entityType != null && entityType === _draftJsUtils.ENTITY_TYPE.IMAGE) {
	          var _attrs = DATA_TO_ATTR.hasOwnProperty(entityType) ? DATA_TO_ATTR[entityType](entityType, entity) : null;
	
	          var _attrString2 = stringifyAttrs(_attrs);
	
	          return "<img".concat(_attrString2, "/>");
	        } else {
	          return content;
	        }
	      }).join('');
	    }
	  }, {
	    key: "preserveWhitespace",
	    value: function preserveWhitespace(text) {
	      var length = text.length; // Prevent leading/trailing/consecutive whitespace collapse.
	
	      var newText = new Array(length);
	
	      for (var i = 0; i < length; i++) {
	        if (text[i] === ' ' && (i === 0 || i === length - 1 || text[i - 1] === ' ')) {
	          newText[i] = '\xA0';
	        } else {
	          newText[i] = text[i];
	        }
	      }
	
	      return newText.join('');
	    }
	  }]);
	
	  return MarkupGenerator;
	}();
	
	function stringifyAttrs(attrs) {
	  if (attrs == null) {
	    return '';
	  }
	
	  var parts = [];
	
	  for (var _i3 = 0, _Object$keys3 = Object.keys(attrs); _i3 < _Object$keys3.length; _i3++) {
	    var name = _Object$keys3[_i3];
	    var value = attrs[name];
	
	    if (value != null) {
	      parts.push(" ".concat(name, "=\"").concat(encodeAttr(value + ''), "\""));
	    }
	  }
	
	  return parts.join('');
	}
	
	function canHaveDepth(blockType) {
	  switch (blockType) {
	    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
	    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
	      return true;
	
	    default:
	      return false;
	  }
	}
	
	function encodeContent(text) {
	  return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('\xA0').join('&nbsp;').split('\n').join(BREAK + '\n');
	}
	
	function encodeAttr(text) {
	  return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('"').join('&quot;');
	}
	
	function stateToHTML(content, options) {
	  return new MarkupGenerator(content, options).generate();
	}

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.INLINE_STYLE = exports.ENTITY_TYPE = exports.BLOCK_TYPE = void 0;
	var BLOCK_TYPE = {
	  // This is used to represent a normal text block (paragraph).
	  UNSTYLED: 'unstyled',
	  HEADER_ONE: 'header-one',
	  HEADER_TWO: 'header-two',
	  HEADER_THREE: 'header-three',
	  HEADER_FOUR: 'header-four',
	  HEADER_FIVE: 'header-five',
	  HEADER_SIX: 'header-six',
	  UNORDERED_LIST_ITEM: 'unordered-list-item',
	  ORDERED_LIST_ITEM: 'ordered-list-item',
	  BLOCKQUOTE: 'blockquote',
	  PULLQUOTE: 'pullquote',
	  CODE: 'code-block',
	  ATOMIC: 'atomic'
	};
	exports.BLOCK_TYPE = BLOCK_TYPE;
	var ENTITY_TYPE = {
	  LINK: 'LINK',
	  IMAGE: 'IMAGE',
	  EMBED: 'embed'
	};
	exports.ENTITY_TYPE = ENTITY_TYPE;
	var INLINE_STYLE = {
	  BOLD: 'BOLD',
	  CODE: 'CODE',
	  ITALIC: 'ITALIC',
	  STRIKETHROUGH: 'STRIKETHROUGH',
	  UNDERLINE: 'UNDERLINE'
	};
	exports.INLINE_STYLE = INLINE_STYLE;
	var _default = {
	  BLOCK_TYPE: BLOCK_TYPE,
	  ENTITY_TYPE: ENTITY_TYPE,
	  INLINE_STYLE: INLINE_STYLE
	};
	exports["default"] = _default;

/***/ }),
/* 1191 */
[2362, 443],
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getEntityRanges;
	exports.EMPTY_SET = void 0;
	
	var _immutable = __webpack_require__(461);
	
	var EMPTY_SET = new _immutable.OrderedSet();
	exports.EMPTY_SET = EMPTY_SET;
	
	function getEntityRanges(text, charMetaList) {
	  var charEntity = null;
	  var prevCharEntity = null;
	  var ranges = [];
	  var rangeStart = 0;
	
	  for (var i = 0, len = text.length; i < len; i++) {
	    prevCharEntity = charEntity;
	    var meta = charMetaList.get(i);
	    charEntity = meta ? meta.getEntity() : null;
	
	    if (i > 0 && charEntity !== prevCharEntity) {
	      ranges.push([prevCharEntity, getStyleRanges(text.slice(rangeStart, i), charMetaList.slice(rangeStart, i))]);
	      rangeStart = i;
	    }
	  }
	
	  ranges.push([charEntity, getStyleRanges(text.slice(rangeStart), charMetaList.slice(rangeStart))]);
	  return ranges;
	}
	
	function getStyleRanges(text, charMetaList) {
	  var charStyle = EMPTY_SET;
	  var prevCharStyle = EMPTY_SET;
	  var ranges = [];
	  var rangeStart = 0;
	
	  for (var i = 0, len = text.length; i < len; i++) {
	    prevCharStyle = charStyle;
	    var meta = charMetaList.get(i);
	    charStyle = meta ? meta.getStyle() : EMPTY_SET;
	
	    if (i > 0 && !(0, _immutable.is)(charStyle, prevCharStyle)) {
	      ranges.push([text.slice(rangeStart, i), prevCharStyle]);
	      rangeStart = i;
	    }
	  }
	
	  ranges.push([text.slice(rangeStart), charStyle]);
	  return ranges;
	}

/***/ }),
/* 1193 */
[2363, 1190, 1192, 443, 1194, 1191],
/* 1194 */
[2364, 443],
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "stateFromHTML", {
	  enumerable: true,
	  get: function get() {
	    return _stateFromHTML["default"];
	  }
	});
	
	var _stateFromHTML = _interopRequireDefault(__webpack_require__(1197));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parseHTML;
	
	function parseHTML(html) {
	  var doc;
	
	  if (typeof DOMParser !== 'undefined') {
	    var parser = new DOMParser();
	    doc = parser.parseFromString(html, 'text/html');
	  } else {
	    doc = document.implementation.createHTMLDocument('');
	
	    if (doc.documentElement) {
	      doc.documentElement.innerHTML = html;
	    }
	  } // This makes Flow happy
	
	
	  return doc.body || doc.createElement('body');
	}

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = stateFromHTML;
	
	var _draftJsImportElement = __webpack_require__(1200);
	
	var _parseHTML = _interopRequireDefault(__webpack_require__(1196));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var defaultOptions = {};
	
	function stateFromHTML(html, options) {
	  var _ref = options || defaultOptions,
	      parser = _ref.parser,
	      otherOptions = _objectWithoutProperties(_ref, ["parser"]);
	
	  if (parser == null) {
	    parser = _parseHTML["default"];
	  }
	
	  var element = parser(html);
	  return (0, _draftJsImportElement.stateFromElement)(element, otherOptions);
	}

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SELF_CLOSING_ELEMENTS = exports.SPECIAL_ELEMENTS = exports.INLINE_ELEMENTS = void 0;
	var INLINE_ELEMENTS = {
	  a: 1,
	  abbr: 1,
	  area: 1,
	  audio: 1,
	  b: 1,
	  bdi: 1,
	  bdo: 1,
	  br: 1,
	  button: 1,
	  canvas: 1,
	  cite: 1,
	  code: 1,
	  command: 1,
	  datalist: 1,
	  del: 1,
	  dfn: 1,
	  em: 1,
	  embed: 1,
	  i: 1,
	  iframe: 1,
	  img: 1,
	  input: 1,
	  ins: 1,
	  kbd: 1,
	  keygen: 1,
	  label: 1,
	  map: 1,
	  mark: 1,
	  meter: 1,
	  noscript: 1,
	  object: 1,
	  output: 1,
	  progress: 1,
	  q: 1,
	  ruby: 1,
	  s: 1,
	  samp: 1,
	  script: 1,
	  select: 1,
	  small: 1,
	  span: 1,
	  strong: 1,
	  sub: 1,
	  sup: 1,
	  textarea: 1,
	  time: 1,
	  u: 1,
	  "var": 1,
	  video: 1,
	  wbr: 1,
	  acronym: 1,
	  applet: 1,
	  basefont: 1,
	  big: 1,
	  font: 1,
	  isindex: 1,
	  strike: 1,
	  style: 1,
	  tt: 1
	}; // These elements are special because they cannot contain text as a direct
	// child (some cannot contain childNodes at all).
	
	exports.INLINE_ELEMENTS = INLINE_ELEMENTS;
	var SPECIAL_ELEMENTS = {
	  area: 1,
	  base: 1,
	  br: 1,
	  col: 1,
	  colgroup: 1,
	  command: 1,
	  dl: 1,
	  embed: 1,
	  head: 1,
	  hgroup: 1,
	  hr: 1,
	  iframe: 1,
	  img: 1,
	  input: 1,
	  keygen: 1,
	  link: 1,
	  meta: 1,
	  ol: 1,
	  optgroup: 1,
	  option: 1,
	  param: 1,
	  script: 1,
	  select: 1,
	  source: 1,
	  style: 1,
	  table: 1,
	  tbody: 1,
	  textarea: 1,
	  tfoot: 1,
	  thead: 1,
	  title: 1,
	  tr: 1,
	  track: 1,
	  ul: 1,
	  wbr: 1,
	  basefont: 1,
	  dialog: 1,
	  dir: 1,
	  isindex: 1
	}; // These elements are special because they cannot contain childNodes.
	// TODO: This is not an exhaustive list.
	
	exports.SPECIAL_ELEMENTS = SPECIAL_ELEMENTS;
	var SELF_CLOSING_ELEMENTS = {
	  img: 1
	};
	exports.SELF_CLOSING_ELEMENTS = SELF_CLOSING_ELEMENTS;

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = replaceTextWithMeta;
	
	function replaceTextWithMeta(subject, searchText, replaceText) {
	  var text = subject.text,
	      characterMeta = subject.characterMeta;
	  var searchTextLength = searchText.length;
	  var replaceTextLength = replaceText.length;
	  var resultTextParts = []; // Get empty set of same kind as characterMeta.
	
	  var resultCharMeta = characterMeta.slice(0, 0);
	  var lastEndIndex = 0;
	  var index = text.indexOf(searchText);
	
	  while (index !== -1) {
	    resultTextParts.push(text.slice(lastEndIndex, index) + replaceText);
	    resultCharMeta = resultCharMeta.concat(characterMeta.slice(lastEndIndex, index), // Use the metadata of the first char we are replacing.
	    repeatSeq(characterMeta.slice(index, index + 1), replaceTextLength));
	    lastEndIndex = index + searchTextLength;
	    index = text.indexOf(searchText, lastEndIndex);
	  }
	
	  resultTextParts.push(text.slice(lastEndIndex));
	  resultCharMeta = resultCharMeta.concat(characterMeta.slice(lastEndIndex));
	  return {
	    text: resultTextParts.join(''),
	    characterMeta: resultCharMeta
	  };
	}
	
	function repeatSeq(seq, count) {
	  var result = seq.slice(0, 0);
	
	  while (count-- > 0) {
	    result = result.concat(seq);
	  }
	
	  return result;
	}

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stateFromElement = __webpack_require__(1201);
	
	Object.keys(_stateFromElement).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _stateFromElement[key];
	    }
	  });
	});

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stateFromElement = stateFromElement;
	exports["default"] = void 0;
	
	var _replaceTextWithMeta3 = _interopRequireDefault(__webpack_require__(1199));
	
	var _draftJs = __webpack_require__(202);
	
	var _immutable = __webpack_require__(461);
	
	var _draftJsUtils = __webpack_require__(1205);
	
	var _syntheticDom = __webpack_require__(2037);
	
	var _Constants = __webpack_require__(1198);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var DATA_URL = /^data:/i;
	var NO_STYLE = (0, _immutable.OrderedSet)();
	var NO_ENTITY = null;
	var EMPTY_BLOCK = new _draftJs.ContentBlock({
	  key: (0, _draftJs.genKey)(),
	  text: '',
	  type: _draftJsUtils.BLOCK_TYPE.UNSTYLED,
	  characterList: (0, _immutable.List)(),
	  depth: 0
	});
	var LINE_BREAKS = /(\r\n|\r|\n)/g; // We use `\r` because that character is always stripped from source (normalized
	// to `\n`), so it's safe to assume it will only appear in the text content when
	// we put it there as a placeholder.
	
	var SOFT_BREAK_PLACEHOLDER = '\r';
	var ZERO_WIDTH_SPACE = "\u200B";
	var DATA_ATTRIBUTE = /^data-([a-z0-9-]+)$/; // Map element attributes to entity data.
	
	var ELEM_ATTR_MAP = {
	  a: {
	    href: 'url',
	    rel: 'rel',
	    target: 'target',
	    title: 'title'
	  },
	  img: {
	    src: 'src',
	    alt: 'alt',
	    width: 'width',
	    height: 'height'
	  }
	};
	
	var getEntityData = function getEntityData(tagName, element) {
	  var data = {};
	
	  if (ELEM_ATTR_MAP.hasOwnProperty(tagName)) {
	    var attrMap = ELEM_ATTR_MAP[tagName];
	
	    for (var i = 0; i < element.attributes.length; i++) {
	      var _element$attributes$i = element.attributes[i],
	          name = _element$attributes$i.name,
	          value = _element$attributes$i.value;
	
	      if (typeof value === 'string') {
	        var strVal = value;
	
	        if (attrMap.hasOwnProperty(name)) {
	          var newName = attrMap[name];
	          data[newName] = strVal;
	        } else if (DATA_ATTRIBUTE.test(name)) {
	          data[name] = strVal;
	        }
	      }
	    }
	  }
	
	  return data;
	}; // Functions to create entities from elements.
	
	
	var ElementToEntity = {
	  a: function a(generator, tagName, element) {
	    var data = getEntityData(tagName, element); // Don't add `<a>` elements with invalid href.
	
	    if (isAllowedHref(data.url)) {
	      return generator.createEntity(_draftJsUtils.ENTITY_TYPE.LINK, data);
	    }
	  },
	  img: function img(generator, tagName, element) {
	    var data = getEntityData(tagName, element); // Don't add `<img>` elements with no src.
	
	    if (data.src != null) {
	      return generator.createEntity(_draftJsUtils.ENTITY_TYPE.IMAGE, data);
	    }
	  }
	};
	
	var ContentGenerator =
	/*#__PURE__*/
	function () {
	  // This will be passed to the customInlineFn to allow it
	  // to return a Style() or Entity().
	  function ContentGenerator() {
	    var _this = this;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, ContentGenerator);
	
	    _defineProperty(this, "contentStateForEntities", void 0);
	
	    _defineProperty(this, "blockStack", void 0);
	
	    _defineProperty(this, "blockList", void 0);
	
	    _defineProperty(this, "depth", void 0);
	
	    _defineProperty(this, "options", void 0);
	
	    _defineProperty(this, "inlineCreators", {
	      Style: function (_Style) {
	        function Style(_x) {
	          return _Style.apply(this, arguments);
	        }
	
	        Style.toString = function () {
	          return _Style.toString();
	        };
	
	        return Style;
	      }(function (style) {
	        return {
	          type: 'STYLE',
	          style: style
	        };
	      }),
	      Entity: function Entity(type, data) {
	        var mutability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'MUTABLE';
	        return {
	          type: 'ENTITY',
	          entityKey: _this.createEntity(type, toStringMap(data), mutability)
	        };
	      }
	    });
	
	    this.options = options;
	    this.contentStateForEntities = _draftJs.ContentState.createFromBlockArray([]); // This represents the hierarchy as we traverse nested elements; for
	    // example [body, ul, li] where we must know li's parent type (ul or ol).
	
	    this.blockStack = []; // This is a linear list of blocks that will form the output; for example
	    // [p, li, li, blockquote].
	
	    this.blockList = [];
	    this.depth = 0;
	  }
	
	  _createClass(ContentGenerator, [{
	    key: "process",
	    value: function process(element) {
	      this.processBlockElement(element);
	      var contentBlocks = [];
	      this.blockList.forEach(function (block) {
	        var _concatFragments = concatFragments(block.textFragments),
	            text = _concatFragments.text,
	            characterMeta = _concatFragments.characterMeta;
	
	        var includeEmptyBlock = false; // If the block contains only a soft break then don't discard the block,
	        // but discard the soft break.
	
	        if (text === SOFT_BREAK_PLACEHOLDER) {
	          includeEmptyBlock = true;
	          text = '';
	        }
	
	        if (block.tagName === 'pre') {
	          var _trimLeadingNewline = trimLeadingNewline(text, characterMeta);
	
	          text = _trimLeadingNewline.text;
	          characterMeta = _trimLeadingNewline.characterMeta;
	        } else {
	          var _collapseWhiteSpace = collapseWhiteSpace(text, characterMeta);
	
	          text = _collapseWhiteSpace.text;
	          characterMeta = _collapseWhiteSpace.characterMeta;
	        } // Previously we were using a placeholder for soft breaks. Now that we
	        // have collapsed whitespace we can change it back to normal line breaks.
	
	
	        text = text.split(SOFT_BREAK_PLACEHOLDER).join('\n'); // Discard empty blocks (unless otherwise specified).
	
	        if (text.length || includeEmptyBlock) {
	          contentBlocks.push(new _draftJs.ContentBlock({
	            key: (0, _draftJs.genKey)(),
	            text: text,
	            type: block.type,
	            characterList: characterMeta.toList(),
	            depth: block.depth,
	            data: block.data ? (0, _immutable.Map)(block.data) : (0, _immutable.Map)()
	          }));
	        }
	      });
	
	      if (!contentBlocks.length) {
	        contentBlocks = [EMPTY_BLOCK];
	      }
	
	      return _draftJs.ContentState.createFromBlockArray(contentBlocks, this.contentStateForEntities.getEntityMap());
	    }
	  }, {
	    key: "getBlockTypeFromTagName",
	    value: function getBlockTypeFromTagName(tagName) {
	      var blockTypes = this.options.blockTypes;
	
	      if (blockTypes && blockTypes[tagName]) {
	        return blockTypes[tagName];
	      }
	
	      switch (tagName) {
	        case 'li':
	          {
	            var parent = this.blockStack.slice(-1)[0];
	            return parent.tagName === 'ol' ? _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM : _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM;
	          }
	
	        case 'blockquote':
	          {
	            return _draftJsUtils.BLOCK_TYPE.BLOCKQUOTE;
	          }
	
	        case 'h1':
	          {
	            return _draftJsUtils.BLOCK_TYPE.HEADER_ONE;
	          }
	
	        case 'h2':
	          {
	            return _draftJsUtils.BLOCK_TYPE.HEADER_TWO;
	          }
	
	        case 'h3':
	          {
	            return _draftJsUtils.BLOCK_TYPE.HEADER_THREE;
	          }
	
	        case 'h4':
	          {
	            return _draftJsUtils.BLOCK_TYPE.HEADER_FOUR;
	          }
	
	        case 'h5':
	          {
	            return _draftJsUtils.BLOCK_TYPE.HEADER_FIVE;
	          }
	
	        case 'h6':
	          {
	            return _draftJsUtils.BLOCK_TYPE.HEADER_SIX;
	          }
	
	        case 'pre':
	          {
	            return _draftJsUtils.BLOCK_TYPE.CODE;
	          }
	
	        case 'figure':
	          {
	            return _draftJsUtils.BLOCK_TYPE.ATOMIC;
	          }
	
	        default:
	          {
	            return _draftJsUtils.BLOCK_TYPE.UNSTYLED;
	          }
	      }
	    }
	  }, {
	    key: "processBlockElement",
	    value: function processBlockElement(element) {
	      if (!element) {
	        return;
	      }
	
	      var customBlockFn = this.options.customBlockFn;
	      var tagName = element.nodeName.toLowerCase();
	      var type;
	      var data;
	
	      if (customBlockFn) {
	        var customBlock = customBlockFn(element);
	
	        if (customBlock != null) {
	          type = customBlock.type;
	          data = customBlock.data;
	        }
	      }
	
	      var isCustomType = true;
	
	      if (type == null) {
	        isCustomType = false;
	        type = this.getBlockTypeFromTagName(tagName);
	      }
	
	      if (type === _draftJsUtils.BLOCK_TYPE.CODE) {
	        var language = element.getAttribute('data-language');
	
	        if (language) {
	          data = _objectSpread({}, data, {
	            language: language
	          });
	        }
	      }
	
	      var hasDepth = canHaveDepth(type);
	      var allowRender = !_Constants.SPECIAL_ELEMENTS.hasOwnProperty(tagName);
	
	      if (!isCustomType && !hasSemanticMeaning(type)) {
	        var parent = this.blockStack.slice(-1)[0];
	
	        if (parent) {
	          type = parent.type;
	        }
	      }
	
	      var block = {
	        tagName: tagName,
	        textFragments: [],
	        type: type,
	        styleStack: [NO_STYLE],
	        entityStack: [NO_ENTITY],
	        depth: hasDepth ? this.depth : 0,
	        data: data
	      };
	
	      if (allowRender) {
	        this.blockList.push(block);
	
	        if (hasDepth) {
	          this.depth += 1;
	        }
	      }
	
	      this.blockStack.push(block);
	
	      if (element.childNodes != null) {
	        Array.from(element.childNodes).forEach(this.processNode, this);
	      }
	
	      this.blockStack.pop();
	
	      if (allowRender && hasDepth) {
	        this.depth -= 1;
	      }
	    }
	  }, {
	    key: "processInlineElement",
	    value: function processInlineElement(element) {
	      var tagName = element.nodeName.toLowerCase();
	
	      if (tagName === 'br') {
	        this.processText(SOFT_BREAK_PLACEHOLDER);
	        return;
	      }
	
	      var block = this.blockStack.slice(-1)[0];
	      var style = block.styleStack.slice(-1)[0];
	      var entityKey = block.entityStack.slice(-1)[0];
	      var customInlineFn = this.options.customInlineFn;
	      var customInline = customInlineFn ? customInlineFn(element, this.inlineCreators) : null;
	
	      if (customInline != null) {
	        switch (customInline.type) {
	          case 'STYLE':
	            {
	              style = style.add(customInline.style);
	              break;
	            }
	
	          case 'ENTITY':
	            {
	              entityKey = customInline.entityKey;
	              break;
	            }
	        }
	      } else {
	        style = addStyleFromTagName(style, tagName, this.options.elementStyles);
	
	        if (ElementToEntity.hasOwnProperty(tagName)) {
	          // If the to-entity function returns nothing, use the existing entity.
	          entityKey = ElementToEntity[tagName](this, tagName, element) || entityKey;
	        }
	      }
	
	      block.styleStack.push(style);
	      block.entityStack.push(entityKey);
	
	      if (element.childNodes != null) {
	        Array.from(element.childNodes).forEach(this.processNode, this);
	      }
	
	      if (_Constants.SELF_CLOSING_ELEMENTS.hasOwnProperty(tagName)) {
	        this.processText("\xA0");
	      }
	
	      block.entityStack.pop();
	      block.styleStack.pop();
	    }
	  }, {
	    key: "processTextNode",
	    value: function processTextNode(node) {
	      var text = node.nodeValue; // This is important because we will use \r as a placeholder for a soft break.
	
	      text = text.replace(LINE_BREAKS, '\n'); // Replace zero-width space (we use it as a placeholder in markdown) with a
	      // soft break.
	      // TODO: The import-markdown package should correctly turn breaks into <br>
	      // elements so we don't need to include this hack.
	
	      text = text.split(ZERO_WIDTH_SPACE).join(SOFT_BREAK_PLACEHOLDER);
	      this.processText(text);
	    }
	  }, {
	    key: "processText",
	    value: function processText(text) {
	      var block = this.blockStack.slice(-1)[0];
	      var style = block.styleStack.slice(-1)[0];
	      var entity = block.entityStack.slice(-1)[0];
	
	      var charMetadata = _draftJs.CharacterMetadata.create({
	        style: style,
	        entity: entity
	      });
	
	      var seq = (0, _immutable.Repeat)(charMetadata, text.length);
	      block.textFragments.push({
	        text: text,
	        characterMeta: seq
	      });
	    }
	  }, {
	    key: "processNode",
	    value: function processNode(node) {
	      if (node.nodeType === _syntheticDom.NODE_TYPE_ELEMENT) {
	        // $FlowIssue
	        var _element = node;
	
	        var _tagName = _element.nodeName.toLowerCase();
	
	        if (_Constants.INLINE_ELEMENTS.hasOwnProperty(_tagName)) {
	          this.processInlineElement(_element);
	        } else {
	          this.processBlockElement(_element);
	        }
	      } else if (node.nodeType === _syntheticDom.NODE_TYPE_TEXT) {
	        this.processTextNode(node);
	      }
	    }
	  }, {
	    key: "createEntity",
	    value: function createEntity(type, data) {
	      var mutability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'MUTABLE';
	      this.contentStateForEntities = this.contentStateForEntities.createEntity(type, mutability, data);
	      return this.contentStateForEntities.getLastCreatedEntityKey();
	    }
	  }]);
	
	  return ContentGenerator;
	}();
	
	function trimLeadingNewline(text, characterMeta) {
	  if (text.charAt(0) === '\n') {
	    text = text.slice(1);
	    characterMeta = characterMeta.slice(1);
	  }
	
	  return {
	    text: text,
	    characterMeta: characterMeta
	  };
	}
	
	function trimLeadingSpace(text, characterMeta) {
	  while (text.charAt(0) === ' ') {
	    text = text.slice(1);
	    characterMeta = characterMeta.slice(1);
	  }
	
	  return {
	    text: text,
	    characterMeta: characterMeta
	  };
	}
	
	function trimTrailingSpace(text, characterMeta) {
	  while (text.slice(-1) === ' ') {
	    text = text.slice(0, -1);
	    characterMeta = characterMeta.slice(0, -1);
	  }
	
	  return {
	    text: text,
	    characterMeta: characterMeta
	  };
	}
	
	function collapseWhiteSpace(text, characterMeta) {
	  text = text.replace(/[ \t\n]/g, ' ');
	
	  var _trimLeadingSpace = trimLeadingSpace(text, characterMeta);
	
	  text = _trimLeadingSpace.text;
	  characterMeta = _trimLeadingSpace.characterMeta;
	
	  var _trimTrailingSpace = trimTrailingSpace(text, characterMeta);
	
	  text = _trimTrailingSpace.text;
	  characterMeta = _trimTrailingSpace.characterMeta;
	  var i = text.length;
	
	  while (i--) {
	    if (text.charAt(i) === ' ' && text.charAt(i - 1) === ' ') {
	      text = text.slice(0, i) + text.slice(i + 1);
	      characterMeta = characterMeta.slice(0, i).concat(characterMeta.slice(i + 1));
	    }
	  } // There could still be one space on either side of a softbreak.
	
	
	  var _replaceTextWithMeta = (0, _replaceTextWithMeta3["default"])({
	    text: text,
	    characterMeta: characterMeta
	  }, SOFT_BREAK_PLACEHOLDER + ' ', SOFT_BREAK_PLACEHOLDER);
	
	  text = _replaceTextWithMeta.text;
	  characterMeta = _replaceTextWithMeta.characterMeta;
	
	  var _replaceTextWithMeta2 = (0, _replaceTextWithMeta3["default"])({
	    text: text,
	    characterMeta: characterMeta
	  }, ' ' + SOFT_BREAK_PLACEHOLDER, SOFT_BREAK_PLACEHOLDER);
	
	  text = _replaceTextWithMeta2.text;
	  characterMeta = _replaceTextWithMeta2.characterMeta;
	  return {
	    text: text,
	    characterMeta: characterMeta
	  };
	}
	
	function canHaveDepth(blockType) {
	  switch (blockType) {
	    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
	    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
	      {
	        return true;
	      }
	
	    default:
	      {
	        return false;
	      }
	  }
	}
	
	function concatFragments(fragments) {
	  var text = '';
	  var characterMeta = (0, _immutable.Seq)();
	  fragments.forEach(function (textFragment) {
	    text = text + textFragment.text;
	    characterMeta = characterMeta.concat(textFragment.characterMeta);
	  });
	  return {
	    text: text,
	    characterMeta: characterMeta
	  };
	}
	
	function addStyleFromTagName(styleSet, tagName, elementStyles) {
	  switch (tagName) {
	    case 'b':
	    case 'strong':
	      {
	        return styleSet.add(_draftJsUtils.INLINE_STYLE.BOLD);
	      }
	
	    case 'i':
	    case 'em':
	      {
	        return styleSet.add(_draftJsUtils.INLINE_STYLE.ITALIC);
	      }
	
	    case 'u':
	    case 'ins':
	      {
	        return styleSet.add(_draftJsUtils.INLINE_STYLE.UNDERLINE);
	      }
	
	    case 'code':
	      {
	        return styleSet.add(_draftJsUtils.INLINE_STYLE.CODE);
	      }
	
	    case 's':
	    case 'del':
	      {
	        return styleSet.add(_draftJsUtils.INLINE_STYLE.STRIKETHROUGH);
	      }
	
	    default:
	      {
	        // Allow custom styles to be provided.
	        if (elementStyles && elementStyles[tagName]) {
	          return styleSet.add(elementStyles[tagName]);
	        }
	
	        return styleSet;
	      }
	  }
	}
	
	function hasSemanticMeaning(blockType) {
	  return blockType !== _draftJsUtils.BLOCK_TYPE.UNSTYLED;
	}
	
	function toStringMap(input) {
	  var result = {};
	
	  if (input !== null && _typeof(input) === 'object' && !Array.isArray(input)) {
	    var obj = input;
	
	    for (var _i = 0, _Object$keys = Object.keys(obj); _i < _Object$keys.length; _i++) {
	      var _key = _Object$keys[_i];
	      var value = obj[_key];
	
	      if (typeof value === 'string') {
	        result[_key] = value;
	      }
	    }
	  }
	
	  return result;
	}
	
	function isAllowedHref(input) {
	  if (input == null || input.match(DATA_URL)) {
	    return false;
	  } else {
	    return true;
	  }
	}
	
	function stateFromElement(element, options) {
	  return new ContentGenerator(options).process(element);
	}
	
	var _default = stateFromElement;
	exports["default"] = _default;

/***/ }),
/* 1202 */
1190,
/* 1203 */
[2362, 444],
/* 1204 */
1192,
/* 1205 */
[2363, 1202, 1204, 444, 1206, 1203],
/* 1206 */
[2364, 444],
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AtomicBlockUtils
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var BlockMapBuilder = __webpack_require__(271);
	var CharacterMetadata = __webpack_require__(112);
	var ContentBlock = __webpack_require__(201);
	var ContentBlockNode = __webpack_require__(123);
	var DraftFeatureFlags = __webpack_require__(183);
	var DraftModifier = __webpack_require__(104);
	var EditorState = __webpack_require__(71);
	var Immutable = __webpack_require__(60);
	var SelectionState = __webpack_require__(235);
	
	var generateRandomKey = __webpack_require__(161);
	var moveBlockInContentState = __webpack_require__(1267);
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
	
	var List = Immutable.List,
	    Repeat = Immutable.Repeat;
	
	
	var AtomicBlockUtils = {
	  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
	    var contentState = editorState.getCurrentContent();
	    var selectionState = editorState.getSelection();
	
	    var afterRemoval = DraftModifier.removeRange(contentState, selectionState, 'backward');
	
	    var targetSelection = afterRemoval.getSelectionAfter();
	    var afterSplit = DraftModifier.splitBlock(afterRemoval, targetSelection);
	    var insertionTarget = afterSplit.getSelectionAfter();
	
	    var asAtomicBlock = DraftModifier.setBlockType(afterSplit, insertionTarget, 'atomic');
	
	    var charData = CharacterMetadata.create({ entity: entityKey });
	
	    var atomicBlockConfig = {
	      key: generateRandomKey(),
	      type: 'atomic',
	      text: character,
	      characterList: List(Repeat(charData, character.length))
	    };
	
	    var atomicDividerBlockConfig = {
	      key: generateRandomKey(),
	      type: 'unstyled'
	    };
	
	    if (experimentalTreeDataSupport) {
	      atomicBlockConfig = _extends({}, atomicBlockConfig, {
	        nextSibling: atomicDividerBlockConfig.key
	      });
	      atomicDividerBlockConfig = _extends({}, atomicDividerBlockConfig, {
	        prevSibling: atomicBlockConfig.key
	      });
	    }
	
	    var fragmentArray = [new ContentBlockRecord(atomicBlockConfig), new ContentBlockRecord(atomicDividerBlockConfig)];
	
	    var fragment = BlockMapBuilder.createFromArray(fragmentArray);
	
	    var withAtomicBlock = DraftModifier.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);
	
	    var newContent = withAtomicBlock.merge({
	      selectionBefore: selectionState,
	      selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
	    });
	
	    return EditorState.push(editorState, newContent, 'insert-fragment');
	  },
	
	  moveAtomicBlock: function moveAtomicBlock(editorState, atomicBlock, targetRange, insertionMode) {
	    var contentState = editorState.getCurrentContent();
	    var selectionState = editorState.getSelection();
	
	    var withMovedAtomicBlock = void 0;
	
	    if (insertionMode === 'before' || insertionMode === 'after') {
	      var targetBlock = contentState.getBlockForKey(insertionMode === 'before' ? targetRange.getStartKey() : targetRange.getEndKey());
	
	      withMovedAtomicBlock = moveBlockInContentState(contentState, atomicBlock, targetBlock, insertionMode);
	    } else {
	      var afterRemoval = DraftModifier.removeRange(contentState, targetRange, 'backward');
	
	      var selectionAfterRemoval = afterRemoval.getSelectionAfter();
	      var _targetBlock = afterRemoval.getBlockForKey(selectionAfterRemoval.getFocusKey());
	
	      if (selectionAfterRemoval.getStartOffset() === 0) {
	        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'before');
	      } else if (selectionAfterRemoval.getEndOffset() === _targetBlock.getLength()) {
	        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'after');
	      } else {
	        var afterSplit = DraftModifier.splitBlock(afterRemoval, selectionAfterRemoval);
	
	        var selectionAfterSplit = afterSplit.getSelectionAfter();
	        var _targetBlock2 = afterSplit.getBlockForKey(selectionAfterSplit.getFocusKey());
	
	        withMovedAtomicBlock = moveBlockInContentState(afterSplit, atomicBlock, _targetBlock2, 'before');
	      }
	    }
	
	    var newContent = withMovedAtomicBlock.merge({
	      selectionBefore: selectionState,
	      selectionAfter: withMovedAtomicBlock.getSelectionAfter().set('hasFocus', true)
	    });
	
	    return EditorState.push(editorState, newContent, 'move-block');
	  }
	};
	
	module.exports = AtomicBlockUtils;

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CompositeDraftDecorator
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Immutable = __webpack_require__(60);
	
	var List = Immutable.List;
	
	
	var DELIMITER = '.';
	
	/**
	 * A CompositeDraftDecorator traverses through a list of DraftDecorator
	 * instances to identify sections of a ContentBlock that should be rendered
	 * in a "decorated" manner. For example, hashtags, mentions, and links may
	 * be intended to stand out visually, be rendered as anchors, etc.
	 *
	 * The list of decorators supplied to the constructor will be used in the
	 * order they are provided. This allows the caller to specify a priority for
	 * string matching, in case of match collisions among decorators.
	 *
	 * For instance, I may have a link with a `#` in its text. Though this section
	 * of text may match our hashtag decorator, it should not be treated as a
	 * hashtag. I should therefore list my link DraftDecorator
	 * before my hashtag DraftDecorator when constructing this composite
	 * decorator instance.
	 *
	 * Thus, when a collision like this is encountered, the earlier match is
	 * preserved and the new match is discarded.
	 */
	
	var CompositeDraftDecorator = function () {
	  function CompositeDraftDecorator(decorators) {
	    _classCallCheck(this, CompositeDraftDecorator);
	
	    // Copy the decorator array, since we use this array order to determine
	    // precedence of decoration matching. If the array is mutated externally,
	    // we don't want to be affected here.
	    this._decorators = decorators.slice();
	  }
	
	  CompositeDraftDecorator.prototype.getDecorations = function getDecorations(block, contentState) {
	    var decorations = Array(block.getText().length).fill(null);
	
	    this._decorators.forEach(function ( /*object*/decorator, /*number*/ii) {
	      var counter = 0;
	      var strategy = decorator.strategy;
	      var callback = function callback( /*number*/start, /*number*/end) {
	        // Find out if any of our matching range is already occupied
	        // by another decorator. If so, discard the match. Otherwise, store
	        // the component key for rendering.
	        if (canOccupySlice(decorations, start, end)) {
	          occupySlice(decorations, start, end, ii + DELIMITER + counter);
	          counter++;
	        }
	      };
	      strategy(block, callback, contentState);
	    });
	
	    return List(decorations);
	  };
	
	  CompositeDraftDecorator.prototype.getComponentForKey = function getComponentForKey(key) {
	    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
	    return this._decorators[componentKey].component;
	  };
	
	  CompositeDraftDecorator.prototype.getPropsForKey = function getPropsForKey(key) {
	    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
	    return this._decorators[componentKey].props;
	  };
	
	  return CompositeDraftDecorator;
	}();
	
	/**
	 * Determine whether we can occupy the specified slice of the decorations
	 * array.
	 */
	
	
	function canOccupySlice(decorations, start, end) {
	  for (var ii = start; ii < end; ii++) {
	    if (decorations[ii] != null) {
	      return false;
	    }
	  }
	  return true;
	}
	
	/**
	 * Splice the specified component into our decoration array at the desired
	 * range.
	 */
	function occupySlice(targetArr, start, end, componentKey) {
	  for (var ii = start; ii < end; ii++) {
	    targetArr[ii] = componentKey;
	  }
	}
	
	module.exports = CompositeDraftDecorator;

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentStateInlineStyle
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(112);
	
	var _require = __webpack_require__(60),
	    Map = _require.Map;
	
	var ContentStateInlineStyle = {
	  add: function add(contentState, selectionState, inlineStyle) {
	    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
	  },
	
	  remove: function remove(contentState, selectionState, inlineStyle) {
	    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
	  }
	};
	
	function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var newBlocks = blockMap.skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
	    var sliceStart;
	    var sliceEnd;
	
	    if (startKey === endKey) {
	      sliceStart = startOffset;
	      sliceEnd = endOffset;
	    } else {
	      sliceStart = blockKey === startKey ? startOffset : 0;
	      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
	    }
	
	    var chars = block.getCharacterList();
	    var current;
	    while (sliceStart < sliceEnd) {
	      current = chars.get(sliceStart);
	      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata.applyStyle(current, inlineStyle) : CharacterMetadata.removeStyle(current, inlineStyle));
	      sliceStart++;
	    }
	
	    return block.set('characterList', chars);
	  });
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = ContentStateInlineStyle;

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditor.react
	 * @format
	 * 
	 * @preventMunge
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultDraftBlockRenderMap = __webpack_require__(446);
	var DefaultDraftInlineStyle = __webpack_require__(643);
	var DraftEditorCompositionHandler = __webpack_require__(1211);
	var DraftEditorContents = __webpack_require__(1213);
	var DraftEditorDragHandler = __webpack_require__(1214);
	var DraftEditorEditHandler = __webpack_require__(1215);
	var DraftEditorPlaceholder = __webpack_require__(1217);
	var EditorState = __webpack_require__(71);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(31);
	var Scroll = __webpack_require__(671);
	var Style = __webpack_require__(455);
	var UserAgent = __webpack_require__(150);
	
	var cx = __webpack_require__(236);
	var emptyFunction = __webpack_require__(113);
	var generateRandomKey = __webpack_require__(161);
	var getDefaultKeyBinding = __webpack_require__(650);
	var getScrollPosition = __webpack_require__(457);
	var invariant = __webpack_require__(28);
	var nullthrows = __webpack_require__(136);
	
	var isIE = UserAgent.isBrowser('IE');
	
	// IE does not support the `input` event on contentEditable, so we can't
	// observe spellcheck behavior.
	var allowSpellCheck = !isIE;
	
	// Define a set of handler objects to correspond to each possible `mode`
	// of editor behavior.
	var handlerMap = {
	  edit: DraftEditorEditHandler,
	  composite: DraftEditorCompositionHandler,
	  drag: DraftEditorDragHandler,
	  cut: null,
	  render: null
	};
	
	/**
	 * `DraftEditor` is the root editor component. It composes a `contentEditable`
	 * div, and provides a wide variety of useful function props for managing the
	 * state of the editor. See `DraftEditorProps` for details.
	 */
	var DraftEditor = function (_React$Component) {
	  _inherits(DraftEditor, _React$Component);
	
	  function DraftEditor(props) {
	    _classCallCheck(this, DraftEditor);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.focus = function (scrollPosition) {
	      var editorState = _this.props.editorState;
	
	      var alreadyHasFocus = editorState.getSelection().getHasFocus();
	      var editorNode = ReactDOM.findDOMNode(_this.editor);
	
	      if (!editorNode) {
	        // once in a while people call 'focus' in a setTimeout, and the node has
	        // been deleted, so it can be null in that case.
	        return;
	      }
	
	      var scrollParent = Style.getScrollParent(editorNode);
	
	      var _ref = scrollPosition || getScrollPosition(scrollParent),
	          x = _ref.x,
	          y = _ref.y;
	
	      !(editorNode instanceof HTMLElement) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
	      editorNode.focus();
	
	      // Restore scroll position
	      if (scrollParent === window) {
	        window.scrollTo(x, y);
	      } else {
	        Scroll.setTop(scrollParent, y);
	      }
	
	      // On Chrome and Safari, calling focus on contenteditable focuses the
	      // cursor at the first character. This is something you don't expect when
	      // you're clicking on an input element but not directly on a character.
	      // Put the cursor back where it was before the blur.
	      if (!alreadyHasFocus) {
	        _this.update(EditorState.forceSelection(editorState, editorState.getSelection()));
	      }
	    };
	
	    _this.blur = function () {
	      var editorNode = ReactDOM.findDOMNode(_this.editor);
	      !(editorNode instanceof HTMLElement) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
	      editorNode.blur();
	    };
	
	    _this.setMode = function (mode) {
	      _this._handler = handlerMap[mode];
	    };
	
	    _this.exitCurrentMode = function () {
	      _this.setMode('edit');
	    };
	
	    _this.restoreEditorDOM = function (scrollPosition) {
	      _this.setState({ contentsKey: _this.state.contentsKey + 1 }, function () {
	        _this.focus(scrollPosition);
	      });
	    };
	
	    _this.setClipboard = function (clipboard) {
	      _this._clipboard = clipboard;
	    };
	
	    _this.getClipboard = function () {
	      return _this._clipboard;
	    };
	
	    _this.update = function (editorState) {
	      _this._latestEditorState = editorState;
	      _this.props.onChange(editorState);
	    };
	
	    _this.onDragEnter = function () {
	      _this._dragCount++;
	    };
	
	    _this.onDragLeave = function () {
	      _this._dragCount--;
	      if (_this._dragCount === 0) {
	        _this.exitCurrentMode();
	      }
	    };
	
	    _this._blockSelectEvents = false;
	    _this._clipboard = null;
	    _this._handler = null;
	    _this._dragCount = 0;
	    _this._editorKey = props.editorKey || generateRandomKey();
	    _this._placeholderAccessibilityID = 'placeholder-' + _this._editorKey;
	    _this._latestEditorState = props.editorState;
	    _this._latestCommittedEditorState = props.editorState;
	
	    _this._onBeforeInput = _this._buildHandler('onBeforeInput');
	    _this._onBlur = _this._buildHandler('onBlur');
	    _this._onCharacterData = _this._buildHandler('onCharacterData');
	    _this._onCompositionEnd = _this._buildHandler('onCompositionEnd');
	    _this._onCompositionStart = _this._buildHandler('onCompositionStart');
	    _this._onCopy = _this._buildHandler('onCopy');
	    _this._onCut = _this._buildHandler('onCut');
	    _this._onDragEnd = _this._buildHandler('onDragEnd');
	    _this._onDragOver = _this._buildHandler('onDragOver');
	    _this._onDragStart = _this._buildHandler('onDragStart');
	    _this._onDrop = _this._buildHandler('onDrop');
	    _this._onInput = _this._buildHandler('onInput');
	    _this._onFocus = _this._buildHandler('onFocus');
	    _this._onKeyDown = _this._buildHandler('onKeyDown');
	    _this._onKeyPress = _this._buildHandler('onKeyPress');
	    _this._onKeyUp = _this._buildHandler('onKeyUp');
	    _this._onMouseDown = _this._buildHandler('onMouseDown');
	    _this._onMouseUp = _this._buildHandler('onMouseUp');
	    _this._onPaste = _this._buildHandler('onPaste');
	    _this._onSelect = _this._buildHandler('onSelect');
	
	    _this.getEditorKey = function () {
	      return _this._editorKey;
	    };
	
	    // See `restoreEditorDOM()`.
	    _this.state = { contentsKey: 0 };
	    return _this;
	  }
	
	  /**
	   * Build a method that will pass the event to the specified handler method.
	   * This allows us to look up the correct handler function for the current
	   * editor mode, if any has been specified.
	   */
	
	
	  /**
	   * Define proxies that can route events to the current handler.
	   */
	
	
	  DraftEditor.prototype._buildHandler = function _buildHandler(eventName) {
	    var _this2 = this;
	
	    return function (e) {
	      if (!_this2.props.readOnly) {
	        var method = _this2._handler && _this2._handler[eventName];
	        method && method(_this2, e);
	      }
	    };
	  };
	
	  DraftEditor.prototype._showPlaceholder = function _showPlaceholder() {
	    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
	  };
	
	  DraftEditor.prototype._renderPlaceholder = function _renderPlaceholder() {
	    if (this._showPlaceholder()) {
	      var placeHolderProps = {
	        text: nullthrows(this.props.placeholder),
	        editorState: this.props.editorState,
	        textAlignment: this.props.textAlignment,
	        accessibilityID: this._placeholderAccessibilityID
	      };
	
	      return React.createElement(DraftEditorPlaceholder, placeHolderProps);
	    }
	    return null;
	  };
	
	  DraftEditor.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        blockRenderMap = _props.blockRenderMap,
	        blockRendererFn = _props.blockRendererFn,
	        blockStyleFn = _props.blockStyleFn,
	        customStyleFn = _props.customStyleFn,
	        customStyleMap = _props.customStyleMap,
	        editorState = _props.editorState,
	        readOnly = _props.readOnly,
	        textAlignment = _props.textAlignment,
	        textDirectionality = _props.textDirectionality;
	
	
	    var rootClass = cx({
	      'DraftEditor/root': true,
	      'DraftEditor/alignLeft': textAlignment === 'left',
	      'DraftEditor/alignRight': textAlignment === 'right',
	      'DraftEditor/alignCenter': textAlignment === 'center'
	    });
	
	    var contentStyle = {
	      outline: 'none',
	      // fix parent-draggable Safari bug. #1326
	      userSelect: 'text',
	      WebkitUserSelect: 'text',
	      whiteSpace: 'pre-wrap',
	      wordWrap: 'break-word'
	    };
	
	    // The aria-expanded and aria-haspopup properties should only be rendered
	    // for a combobox.
	    var ariaRole = this.props.role || 'textbox';
	    var ariaExpanded = ariaRole === 'combobox' ? !!this.props.ariaExpanded : null;
	
	    var editorContentsProps = {
	      blockRenderMap: blockRenderMap,
	      blockRendererFn: blockRendererFn,
	      blockStyleFn: blockStyleFn,
	      customStyleMap: _extends({}, DefaultDraftInlineStyle, customStyleMap),
	      customStyleFn: customStyleFn,
	      editorKey: this._editorKey,
	      editorState: editorState,
	      key: 'contents' + this.state.contentsKey,
	      textDirectionality: textDirectionality
	    };
	
	    return React.createElement(
	      'div',
	      { className: rootClass },
	      this._renderPlaceholder(),
	      React.createElement(
	        'div',
	        {
	          className: cx('DraftEditor/editorContainer'),
	          ref: function ref(_ref3) {
	            return _this3.editorContainer = _ref3;
	          } },
	        React.createElement(
	          'div',
	          {
	            'aria-activedescendant': readOnly ? null : this.props.ariaActiveDescendantID,
	            'aria-autocomplete': readOnly ? null : this.props.ariaAutoComplete,
	            'aria-controls': readOnly ? null : this.props.ariaControls,
	            'aria-describedby': this.props.ariaDescribedBy || this._placeholderAccessibilityID,
	            'aria-expanded': readOnly ? null : ariaExpanded,
	            'aria-label': this.props.ariaLabel,
	            'aria-labelledby': this.props.ariaLabelledBy,
	            'aria-multiline': this.props.ariaMultiline,
	            autoCapitalize: this.props.autoCapitalize,
	            autoComplete: this.props.autoComplete,
	            autoCorrect: this.props.autoCorrect,
	            className: cx({
	              // Chrome's built-in translation feature mutates the DOM in ways
	              // that Draft doesn't expect (ex: adding <font> tags inside
	              // DraftEditorLeaf spans) and causes problems. We add notranslate
	              // here which makes its autotranslation skip over this subtree.
	              notranslate: !readOnly,
	              'public/DraftEditor/content': true
	            }),
	            contentEditable: !readOnly,
	            'data-testid': this.props.webDriverTestID,
	            onBeforeInput: this._onBeforeInput,
	            onBlur: this._onBlur,
	            onCompositionEnd: this._onCompositionEnd,
	            onCompositionStart: this._onCompositionStart,
	            onCopy: this._onCopy,
	            onCut: this._onCut,
	            onDragEnd: this._onDragEnd,
	            onDragEnter: this.onDragEnter,
	            onDragLeave: this.onDragLeave,
	            onDragOver: this._onDragOver,
	            onDragStart: this._onDragStart,
	            onDrop: this._onDrop,
	            onFocus: this._onFocus,
	            onInput: this._onInput,
	            onKeyDown: this._onKeyDown,
	            onKeyPress: this._onKeyPress,
	            onKeyUp: this._onKeyUp,
	            onMouseUp: this._onMouseUp,
	            onPaste: this._onPaste,
	            onSelect: this._onSelect,
	            ref: function ref(_ref2) {
	              return _this3.editor = _ref2;
	            },
	            role: readOnly ? null : ariaRole,
	            spellCheck: allowSpellCheck && this.props.spellCheck,
	            style: contentStyle,
	            suppressContentEditableWarning: true,
	            tabIndex: this.props.tabIndex },
	          React.createElement(DraftEditorContents, editorContentsProps)
	        )
	      )
	    );
	  };
	
	  DraftEditor.prototype.componentDidMount = function componentDidMount() {
	    this.setMode('edit');
	
	    /**
	     * IE has a hardcoded "feature" that attempts to convert link text into
	     * anchors in contentEditable DOM. This breaks the editor's expectations of
	     * the DOM, and control is lost. Disable it to make IE behave.
	     * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
	     * ie9-beta-minor-change-list.aspx
	     */
	    if (isIE) {
	      document.execCommand('AutoUrlDetect', false, false);
	    }
	  };
	
	  /**
	   * Prevent selection events from affecting the current editor state. This
	   * is mostly intended to defend against IE, which fires off `selectionchange`
	   * events regardless of whether the selection is set via the browser or
	   * programmatically. We only care about selection events that occur because
	   * of browser interaction, not re-renders and forced selections.
	   */
	
	
	  DraftEditor.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    this._blockSelectEvents = true;
	    this._latestEditorState = nextProps.editorState;
	  };
	
	  DraftEditor.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._blockSelectEvents = false;
	    this._latestCommittedEditorState = this.props.editorState;
	  };
	
	  /**
	   * Used via `this.focus()`.
	   *
	   * Force focus back onto the editor node.
	   *
	   * We attempt to preserve scroll position when focusing. You can also pass
	   * a specified scroll position (for cases like `cut` behavior where it should
	   * be restored to a known position).
	   */
	
	
	  /**
	   * Used via `this.setMode(...)`.
	   *
	   * Set the behavior mode for the editor component. This switches the current
	   * handler module to ensure that DOM events are managed appropriately for
	   * the active mode.
	   */
	
	
	  /**
	   * Used via `this.restoreEditorDOM()`.
	   *
	   * Force a complete re-render of the DraftEditorContents based on the current
	   * EditorState. This is useful when we know we are going to lose control of
	   * the DOM state (cut command, IME) and we want to make sure that
	   * reconciliation occurs on a version of the DOM that is synchronized with
	   * our EditorState.
	   */
	
	
	  /**
	   * Used via `this.setClipboard(...)`.
	   *
	   * Set the clipboard state for a cut/copy event.
	   */
	
	
	  /**
	   * Used via `this.getClipboard()`.
	   *
	   * Retrieve the clipboard state for a cut/copy event.
	   */
	
	
	  /**
	   * Used via `this.update(...)`.
	   *
	   * Propagate a new `EditorState` object to higher-level components. This is
	   * the method by which event handlers inform the `DraftEditor` component of
	   * state changes. A component that composes a `DraftEditor` **must** provide
	   * an `onChange` prop to receive state updates passed along from this
	   * function.
	   */
	
	
	  /**
	   * Used in conjunction with `onDragLeave()`, by counting the number of times
	   * a dragged element enters and leaves the editor (or any of its children),
	   * to determine when the dragged element absolutely leaves the editor.
	   */
	
	
	  /**
	   * See `onDragEnter()`.
	   */
	
	
	  return DraftEditor;
	}(React.Component);
	
	DraftEditor.defaultProps = {
	  blockRenderMap: DefaultDraftBlockRenderMap,
	  blockRendererFn: emptyFunction.thatReturnsNull,
	  blockStyleFn: emptyFunction.thatReturns(''),
	  keyBindingFn: getDefaultKeyBinding,
	  readOnly: false,
	  spellCheck: false,
	  stripPastedStyles: false
	};
	
	
	module.exports = DraftEditor;

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorCompositionHandler
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftFeatureFlags = __webpack_require__(183);
	var DraftModifier = __webpack_require__(104);
	var EditorState = __webpack_require__(71);
	var Keys = __webpack_require__(454);
	
	var getEntityKeyForSelection = __webpack_require__(449);
	var isEventHandled = __webpack_require__(273);
	var isSelectionAtLeafStart = __webpack_require__(660);
	
	/**
	 * Millisecond delay to allow `compositionstart` to fire again upon
	 * `compositionend`.
	 *
	 * This is used for Korean input to ensure that typing can continue without
	 * the editor trying to render too quickly. More specifically, Safari 7.1+
	 * triggers `compositionstart` a little slower than Chrome/FF, which
	 * leads to composed characters being resolved and re-render occurring
	 * sooner than we want.
	 */
	var RESOLVE_DELAY = 20;
	
	/**
	 * A handful of variables used to track the current composition and its
	 * resolution status. These exist at the module level because it is not
	 * possible to have compositions occurring in multiple editors simultaneously,
	 * and it simplifies state management with respect to the DraftEditor component.
	 */
	var resolved = false;
	var stillComposing = false;
	var textInputData = '';
	
	var DraftEditorCompositionHandler = {
	  onBeforeInput: function onBeforeInput(editor, e) {
	    textInputData = (textInputData || '') + e.data;
	  },
	
	  /**
	   * A `compositionstart` event has fired while we're still in composition
	   * mode. Continue the current composition session to prevent a re-render.
	   */
	  onCompositionStart: function onCompositionStart(editor) {
	    stillComposing = true;
	  },
	
	  /**
	   * Attempt to end the current composition session.
	   *
	   * Defer handling because browser will still insert the chars into active
	   * element after `compositionend`. If a `compositionstart` event fires
	   * before `resolveComposition` executes, our composition session will
	   * continue.
	   *
	   * The `resolved` flag is useful because certain IME interfaces fire the
	   * `compositionend` event multiple times, thus queueing up multiple attempts
	   * at handling the composition. Since handling the same composition event
	   * twice could break the DOM, we only use the first event. Example: Arabic
	   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
	   */
	  onCompositionEnd: function onCompositionEnd(editor) {
	    resolved = false;
	    stillComposing = false;
	    setTimeout(function () {
	      if (!resolved) {
	        DraftEditorCompositionHandler.resolveComposition(editor);
	      }
	    }, RESOLVE_DELAY);
	  },
	
	  /**
	   * In Safari, keydown events may fire when committing compositions. If
	   * the arrow keys are used to commit, prevent default so that the cursor
	   * doesn't move, otherwise it will jump back noticeably on re-render.
	   */
	  onKeyDown: function onKeyDown(editor, e) {
	    if (!stillComposing) {
	      // If a keydown event is received after compositionend but before the
	      // 20ms timer expires (ex: type option-E then backspace, or type A then
	      // backspace in 2-Set Korean), we should immediately resolve the
	      // composition and reinterpret the key press in edit mode.
	      DraftEditorCompositionHandler.resolveComposition(editor);
	      editor._onKeyDown(e);
	      return;
	    }
	    if (e.which === Keys.RIGHT || e.which === Keys.LEFT) {
	      e.preventDefault();
	    }
	  },
	
	  /**
	   * Keypress events may fire when committing compositions. In Firefox,
	   * pressing RETURN commits the composition and inserts extra newline
	   * characters that we do not want. `preventDefault` allows the composition
	   * to be committed while preventing the extra characters.
	   */
	  onKeyPress: function onKeyPress(editor, e) {
	    if (e.which === Keys.RETURN) {
	      e.preventDefault();
	    }
	  },
	
	  /**
	   * Attempt to insert composed characters into the document.
	   *
	   * If we are still in a composition session, do nothing. Otherwise, insert
	   * the characters into the document and terminate the composition session.
	   *
	   * If no characters were composed -- for instance, the user
	   * deleted all composed characters and committed nothing new --
	   * force a re-render. We also re-render when the composition occurs
	   * at the beginning of a leaf, to ensure that if the browser has
	   * created a new text node for the composition, we will discard it.
	   *
	   * Resetting innerHTML will move focus to the beginning of the editor,
	   * so we update to force it back to the correct place.
	   */
	  resolveComposition: function resolveComposition(editor) {
	    if (stillComposing) {
	      return;
	    }
	
	    resolved = true;
	    var composedChars = textInputData;
	    textInputData = '';
	
	    var editorState = EditorState.set(editor._latestEditorState, {
	      inCompositionMode: false
	    });
	
	    var currentStyle = editorState.getCurrentInlineStyle();
	    var entityKey = getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection());
	
	    var mustReset = !composedChars || isSelectionAtLeafStart(editorState) || currentStyle.size > 0 || entityKey !== null;
	
	    if (mustReset) {
	      editor.restoreEditorDOM();
	    }
	
	    editor.exitCurrentMode();
	
	    if (composedChars) {
	      if (DraftFeatureFlags.draft_handlebeforeinput_composed_text && editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(composedChars, editorState))) {
	        return;
	      }
	      // If characters have been composed, re-rendering with the update
	      // is sufficient to reset the editor.
	      var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), composedChars, currentStyle, entityKey);
	      editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
	      return;
	    }
	
	    if (mustReset) {
	      editor.update(EditorState.set(editorState, {
	        nativelyRenderedContent: null,
	        forceSelection: true
	      }));
	    }
	  }
	};
	
	module.exports = DraftEditorCompositionHandler;

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorContents-core.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DraftEditorBlock = __webpack_require__(644);
	var DraftOffsetKey = __webpack_require__(333);
	var EditorState = __webpack_require__(71);
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(236);
	var joinClasses = __webpack_require__(1308);
	var nullthrows = __webpack_require__(136);
	
	/**
	 * Provide default styling for list items. This way, lists will be styled with
	 * proper counters and indentation even if the caller does not specify
	 * their own styling at all. If more than five levels of nesting are needed,
	 * the necessary CSS classes can be provided via `blockStyleFn` configuration.
	 */
	var getListItemClasses = function getListItemClasses(type, depth, shouldResetCount, direction) {
	  return cx({
	    'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
	    'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
	    'public/DraftStyleDefault/reset': shouldResetCount,
	    'public/DraftStyleDefault/depth0': depth === 0,
	    'public/DraftStyleDefault/depth1': depth === 1,
	    'public/DraftStyleDefault/depth2': depth === 2,
	    'public/DraftStyleDefault/depth3': depth === 3,
	    'public/DraftStyleDefault/depth4': depth === 4,
	    'public/DraftStyleDefault/listLTR': direction === 'LTR',
	    'public/DraftStyleDefault/listRTL': direction === 'RTL'
	  });
	};
	
	/**
	 * `DraftEditorContents` is the container component for all block components
	 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
	 * re-rendering blocks whenever possible.
	 *
	 * This component is separate from `DraftEditor` because certain props
	 * (for instance, ARIA props) must be allowed to update without affecting
	 * the contents of the editor.
	 */
	
	var DraftEditorContents = function (_React$Component) {
	  _inherits(DraftEditorContents, _React$Component);
	
	  function DraftEditorContents() {
	    _classCallCheck(this, DraftEditorContents);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorContents.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var prevEditorState = this.props.editorState;
	    var nextEditorState = nextProps.editorState;
	
	    var prevDirectionMap = prevEditorState.getDirectionMap();
	    var nextDirectionMap = nextEditorState.getDirectionMap();
	
	    // Text direction has changed for one or more blocks. We must re-render.
	    if (prevDirectionMap !== nextDirectionMap) {
	      return true;
	    }
	
	    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
	    var nowHasFocus = nextEditorState.getSelection().getHasFocus();
	
	    if (didHaveFocus !== nowHasFocus) {
	      return true;
	    }
	
	    var nextNativeContent = nextEditorState.getNativelyRenderedContent();
	
	    var wasComposing = prevEditorState.isInCompositionMode();
	    var nowComposing = nextEditorState.isInCompositionMode();
	
	    // If the state is unchanged or we're currently rendering a natively
	    // rendered state, there's nothing new to be done.
	    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
	      return false;
	    }
	
	    var prevContent = prevEditorState.getCurrentContent();
	    var nextContent = nextEditorState.getCurrentContent();
	    var prevDecorator = prevEditorState.getDecorator();
	    var nextDecorator = nextEditorState.getDecorator();
	    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
	  };
	
	  DraftEditorContents.prototype.render = function render() {
	    var _props = this.props,
	        blockRenderMap = _props.blockRenderMap,
	        blockRendererFn = _props.blockRendererFn,
	        blockStyleFn = _props.blockStyleFn,
	        customStyleMap = _props.customStyleMap,
	        customStyleFn = _props.customStyleFn,
	        editorState = _props.editorState,
	        editorKey = _props.editorKey,
	        textDirectionality = _props.textDirectionality;
	
	
	    var content = editorState.getCurrentContent();
	    var selection = editorState.getSelection();
	    var forceSelection = editorState.mustForceSelection();
	    var decorator = editorState.getDecorator();
	    var directionMap = nullthrows(editorState.getDirectionMap());
	
	    var blocksAsArray = content.getBlocksAsArray();
	    var processedBlocks = [];
	
	    var currentDepth = null;
	    var lastWrapperTemplate = null;
	
	    for (var ii = 0; ii < blocksAsArray.length; ii++) {
	      var _block = blocksAsArray[ii];
	      var key = _block.getKey();
	      var blockType = _block.getType();
	
	      var customRenderer = blockRendererFn(_block);
	      var CustomComponent = void 0,
	          customProps = void 0,
	          customEditable = void 0;
	      if (customRenderer) {
	        CustomComponent = customRenderer.component;
	        customProps = customRenderer.props;
	        customEditable = customRenderer.editable;
	      }
	
	      var direction = textDirectionality ? textDirectionality : directionMap.get(key);
	      var offsetKey = DraftOffsetKey.encode(key, 0, 0);
	      var componentProps = {
	        contentState: content,
	        block: _block,
	        blockProps: customProps,
	        blockStyleFn: blockStyleFn,
	        customStyleMap: customStyleMap,
	        customStyleFn: customStyleFn,
	        decorator: decorator,
	        direction: direction,
	        forceSelection: forceSelection,
	        key: key,
	        offsetKey: offsetKey,
	        selection: selection,
	        tree: editorState.getBlockTree(key)
	      };
	
	      var configForType = blockRenderMap.get(blockType) || blockRenderMap.get('unstyled');
	      var wrapperTemplate = configForType.wrapper;
	
	      var Element = configForType.element || blockRenderMap.get('unstyled').element;
	
	      var depth = _block.getDepth();
	      var className = '';
	      if (blockStyleFn) {
	        className = blockStyleFn(_block);
	      }
	
	      // List items are special snowflakes, since we handle nesting and
	      // counters manually.
	      if (Element === 'li') {
	        var shouldResetCount = lastWrapperTemplate !== wrapperTemplate || currentDepth === null || depth > currentDepth;
	        className = joinClasses(className, getListItemClasses(blockType, depth, shouldResetCount, direction));
	      }
	
	      var Component = CustomComponent || DraftEditorBlock;
	      var childProps = {
	        className: className,
	        'data-block': true,
	        'data-editor': editorKey,
	        'data-offset-key': offsetKey,
	        key: key
	      };
	      if (customEditable !== undefined) {
	        childProps = _extends({}, childProps, {
	          contentEditable: customEditable,
	          suppressContentEditableWarning: true
	        });
	      }
	
	      var child = React.createElement(Element, childProps, React.createElement(Component, componentProps));
	
	      processedBlocks.push({
	        block: child,
	        wrapperTemplate: wrapperTemplate,
	        key: key,
	        offsetKey: offsetKey
	      });
	
	      if (wrapperTemplate) {
	        currentDepth = _block.getDepth();
	      } else {
	        currentDepth = null;
	      }
	      lastWrapperTemplate = wrapperTemplate;
	    }
	
	    // Group contiguous runs of blocks that have the same wrapperTemplate
	    var outputBlocks = [];
	    for (var _ii = 0; _ii < processedBlocks.length;) {
	      var info = processedBlocks[_ii];
	      if (info.wrapperTemplate) {
	        var blocks = [];
	        do {
	          blocks.push(processedBlocks[_ii].block);
	          _ii++;
	        } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);
	        var wrapperElement = React.cloneElement(info.wrapperTemplate, {
	          key: info.key + '-wrap',
	          'data-offset-key': info.offsetKey
	        }, blocks);
	        outputBlocks.push(wrapperElement);
	      } else {
	        outputBlocks.push(info.block);
	        _ii++;
	      }
	    }
	
	    return React.createElement(
	      'div',
	      { 'data-contents': 'true' },
	      outputBlocks
	    );
	  };
	
	  return DraftEditorContents;
	}(React.Component);
	
	module.exports = DraftEditorContents;

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorContents.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftEditorContents = __webpack_require__(1212);
	
	module.exports = DraftEditorContents;

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorDragHandler
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DataTransfer = __webpack_require__(669);
	var DraftModifier = __webpack_require__(104);
	var EditorState = __webpack_require__(71);
	
	var findAncestorOffsetKey = __webpack_require__(448);
	var getTextContentFromFiles = __webpack_require__(657);
	var getUpdatedSelectionState = __webpack_require__(658);
	var isEventHandled = __webpack_require__(273);
	var nullthrows = __webpack_require__(136);
	
	/**
	 * Get a SelectionState for the supplied mouse event.
	 */
	function getSelectionForEvent(event, editorState) {
	  var node = null;
	  var offset = null;
	
	  if (typeof document.caretRangeFromPoint === 'function') {
	    var dropRange = document.caretRangeFromPoint(event.x, event.y);
	    node = dropRange.startContainer;
	    offset = dropRange.startOffset;
	  } else if (event.rangeParent) {
	    node = event.rangeParent;
	    offset = event.rangeOffset;
	  } else {
	    return null;
	  }
	
	  node = nullthrows(node);
	  offset = nullthrows(offset);
	  var offsetKey = nullthrows(findAncestorOffsetKey(node));
	
	  return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
	}
	
	var DraftEditorDragHandler = {
	  /**
	   * Drag originating from input terminated.
	   */
	  onDragEnd: function onDragEnd(editor) {
	    editor.exitCurrentMode();
	  },
	
	  /**
	   * Handle data being dropped.
	   */
	  onDrop: function onDrop(editor, e) {
	    var data = new DataTransfer(e.nativeEvent.dataTransfer);
	
	    var editorState = editor._latestEditorState;
	    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);
	
	    e.preventDefault();
	    editor.exitCurrentMode();
	
	    if (dropSelection == null) {
	      return;
	    }
	
	    var files = data.getFiles();
	    if (files.length > 0) {
	      if (editor.props.handleDroppedFiles && isEventHandled(editor.props.handleDroppedFiles(dropSelection, files))) {
	        return;
	      }
	
	      getTextContentFromFiles(files, function (fileText) {
	        fileText && editor.update(insertTextAtSelection(editorState, dropSelection, fileText));
	      });
	      return;
	    }
	
	    var dragType = editor._internalDrag ? 'internal' : 'external';
	    if (editor.props.handleDrop && isEventHandled(editor.props.handleDrop(dropSelection, data, dragType))) {
	      return;
	    }
	
	    if (editor._internalDrag) {
	      editor.update(moveText(editorState, dropSelection));
	      return;
	    }
	
	    editor.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
	  }
	};
	
	function moveText(editorState, targetSelection) {
	  var newContentState = DraftModifier.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
	  return EditorState.push(editorState, newContentState, 'insert-fragment');
	}
	
	/**
	 * Insert text at a specified selection.
	 */
	function insertTextAtSelection(editorState, selection, text) {
	  var newContentState = DraftModifier.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
	  return EditorState.push(editorState, newContentState, 'insert-fragment');
	}
	
	module.exports = DraftEditorDragHandler;

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorEditHandler
	 * @format
	 * 
	 */
	
	'use strict';
	
	var onBeforeInput = __webpack_require__(1234);
	var onBlur = __webpack_require__(1235);
	var onCompositionStart = __webpack_require__(1236);
	var onCopy = __webpack_require__(1237);
	var onCut = __webpack_require__(1238);
	var onDragOver = __webpack_require__(1239);
	var onDragStart = __webpack_require__(1240);
	var onFocus = __webpack_require__(1241);
	var onInput = __webpack_require__(1242);
	var onKeyDown = __webpack_require__(1243);
	var onPaste = __webpack_require__(1244);
	var onSelect = __webpack_require__(1245);
	
	var DraftEditorEditHandler = {
	  onBeforeInput: onBeforeInput,
	  onBlur: onBlur,
	  onCompositionStart: onCompositionStart,
	  onCopy: onCopy,
	  onCut: onCut,
	  onDragOver: onDragOver,
	  onDragStart: onDragStart,
	  onFocus: onFocus,
	  onInput: onInput,
	  onKeyDown: onKeyDown,
	  onPaste: onPaste,
	  onSelect: onSelect
	};
	
	module.exports = DraftEditorEditHandler;

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorLeaf.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DraftEditorTextNode = __webpack_require__(1218);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(31);
	
	var invariant = __webpack_require__(28);
	var setDraftEditorSelection = __webpack_require__(1269);
	
	/**
	 * All leaf nodes in the editor are spans with single text nodes. Leaf
	 * elements are styled based on the merging of an optional custom style map
	 * and a default style map.
	 *
	 * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
	 * DOM Selection API. In this way, top-level components can declaratively
	 * maintain the selection state.
	 */
	var DraftEditorLeaf = function (_React$Component) {
	  _inherits(DraftEditorLeaf, _React$Component);
	
	  function DraftEditorLeaf() {
	    _classCallCheck(this, DraftEditorLeaf);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorLeaf.prototype._setSelection = function _setSelection() {
	    var selection = this.props.selection;
	
	    // If selection state is irrelevant to the parent block, no-op.
	
	    if (selection == null || !selection.getHasFocus()) {
	      return;
	    }
	
	    var _props = this.props,
	        block = _props.block,
	        start = _props.start,
	        text = _props.text;
	
	    var blockKey = block.getKey();
	    var end = start + text.length;
	    if (!selection.hasEdgeWithin(blockKey, start, end)) {
	      return;
	    }
	
	    // Determine the appropriate target node for selection. If the child
	    // is not a text node, it is a <br /> spacer. In this case, use the
	    // <span> itself as the selection target.
	    var node = ReactDOM.findDOMNode(this);
	    !node ?  false ? invariant(false, 'Missing node') : invariant(false) : void 0;
	    var child = node.firstChild;
	    !child ?  false ? invariant(false, 'Missing child') : invariant(false) : void 0;
	    var targetNode = void 0;
	
	    if (child.nodeType === Node.TEXT_NODE) {
	      targetNode = child;
	    } else if (child.tagName === 'BR') {
	      targetNode = node;
	    } else {
	      targetNode = child.firstChild;
	      !targetNode ?  false ? invariant(false, 'Missing targetNode') : invariant(false) : void 0;
	    }
	
	    setDraftEditorSelection(selection, targetNode, blockKey, start, end);
	  };
	  /**
	   * By making individual leaf instances aware of their context within
	   * the text of the editor, we can set our selection range more
	   * easily than we could in the non-React world.
	   *
	   * Note that this depends on our maintaining tight control over the
	   * DOM structure of the DraftEditor component. If leaves had multiple
	   * text nodes, this would be harder.
	   */
	
	  DraftEditorLeaf.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var leafNode = ReactDOM.findDOMNode(this.leaf);
	    !leafNode ?  false ? invariant(false, 'Missing leafNode') : invariant(false) : void 0;
	    return leafNode.textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
	  };
	
	  DraftEditorLeaf.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._setSelection();
	  };
	
	  DraftEditorLeaf.prototype.componentDidMount = function componentDidMount() {
	    this._setSelection();
	  };
	
	  DraftEditorLeaf.prototype.render = function render() {
	    var _this2 = this;
	
	    var block = this.props.block;
	    var text = this.props.text;
	
	    // If the leaf is at the end of its block and ends in a soft newline, append
	    // an extra line feed character. Browsers collapse trailing newline
	    // characters, which leaves the cursor in the wrong place after a
	    // shift+enter. The extra character repairs this.
	
	    if (text.endsWith('\n') && this.props.isLast) {
	      text += '\n';
	    }
	
	    var _props2 = this.props,
	        customStyleMap = _props2.customStyleMap,
	        customStyleFn = _props2.customStyleFn,
	        offsetKey = _props2.offsetKey,
	        styleSet = _props2.styleSet;
	
	    var styleObj = styleSet.reduce(function (map, styleName) {
	      var mergedStyles = {};
	      var style = customStyleMap[styleName];
	
	      if (style !== undefined && map.textDecoration !== style.textDecoration) {
	        // .trim() is necessary for IE9/10/11 and Edge
	        mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
	      }
	
	      return _assign(map, style, mergedStyles);
	    }, {});
	
	    if (customStyleFn) {
	      var newStyles = customStyleFn(styleSet, block);
	      styleObj = _assign(styleObj, newStyles);
	    }
	
	    return React.createElement(
	      'span',
	      {
	        'data-offset-key': offsetKey,
	        ref: function ref(_ref) {
	          return _this2.leaf = _ref;
	        },
	        style: styleObj },
	      React.createElement(
	        DraftEditorTextNode,
	        null,
	        text
	      )
	    );
	  };
	
	  return DraftEditorLeaf;
	}(React.Component);
	
	module.exports = DraftEditorLeaf;

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorPlaceholder.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(236);
	
	/**
	 * This component is responsible for rendering placeholder text for the
	 * `DraftEditor` component.
	 *
	 * Override placeholder style via CSS.
	 */
	var DraftEditorPlaceholder = function (_React$Component) {
	  _inherits(DraftEditorPlaceholder, _React$Component);
	
	  function DraftEditorPlaceholder() {
	    _classCallCheck(this, DraftEditorPlaceholder);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorPlaceholder.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
	  };
	
	  DraftEditorPlaceholder.prototype.render = function render() {
	    var hasFocus = this.props.editorState.getSelection().getHasFocus();
	
	    var className = cx({
	      'public/DraftEditorPlaceholder/root': true,
	      'public/DraftEditorPlaceholder/hasFocus': hasFocus
	    });
	
	    var contentStyle = {
	      whiteSpace: 'pre-wrap'
	    };
	
	    return React.createElement(
	      'div',
	      { className: className },
	      React.createElement(
	        'div',
	        {
	          className: cx('public/DraftEditorPlaceholder/inner'),
	          id: this.props.accessibilityID,
	          style: contentStyle },
	        this.props.text
	      )
	    );
	  };
	
	  return DraftEditorPlaceholder;
	}(React.Component);
	
	module.exports = DraftEditorPlaceholder;

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorTextNode.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(31);
	var UserAgent = __webpack_require__(150);
	
	var invariant = __webpack_require__(28);
	
	// In IE, spans with <br> tags render as two newlines. By rendering a span
	// with only a newline character, we can be sure to render a single line.
	var useNewlineChar = UserAgent.isBrowser('IE <= 11');
	
	/**
	 * Check whether the node should be considered a newline.
	 */
	function isNewline(node) {
	  return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
	}
	
	/**
	 * Placeholder elements for empty text content.
	 *
	 * What is this `data-text` attribute, anyway? It turns out that we need to
	 * put an attribute on the lowest-level text node in order to preserve correct
	 * spellcheck handling. If the <span> is naked, Chrome and Safari may do
	 * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
	 * If the <span> has an attribute, this appears not to happen.
	 * See http://jsfiddle.net/9khdavod/ for the failure case, and
	 * http://jsfiddle.net/7pg143f7/ for the fixed case.
	 */
	var NEWLINE_A = useNewlineChar ? React.createElement(
	  'span',
	  { key: 'A', 'data-text': 'true' },
	  '\n'
	) : React.createElement('br', { key: 'A', 'data-text': 'true' });
	
	var NEWLINE_B = useNewlineChar ? React.createElement(
	  'span',
	  { key: 'B', 'data-text': 'true' },
	  '\n'
	) : React.createElement('br', { key: 'B', 'data-text': 'true' });
	
	/**
	 * The lowest-level component in a `DraftEditor`, the text node component
	 * replaces the default React text node implementation. This allows us to
	 * perform custom handling of newline behavior and avoid re-rendering text
	 * nodes with DOM state that already matches the expectations of our immutable
	 * editor state.
	 */
	var DraftEditorTextNode = function (_React$Component) {
	  _inherits(DraftEditorTextNode, _React$Component);
	
	  function DraftEditorTextNode(props) {
	    _classCallCheck(this, DraftEditorTextNode);
	
	    // By flipping this flag, we also keep flipping keys which forces
	    // React to remount this node every time it rerenders.
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._forceFlag = false;
	    return _this;
	  }
	
	  DraftEditorTextNode.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var node = ReactDOM.findDOMNode(this);
	    var shouldBeNewline = nextProps.children === '';
	    !(node instanceof Element) ?  false ? invariant(false, 'node is not an Element') : invariant(false) : void 0;
	    if (shouldBeNewline) {
	      return !isNewline(node);
	    }
	    return node.textContent !== nextProps.children;
	  };
	
	  DraftEditorTextNode.prototype.componentDidMount = function componentDidMount() {
	    this._forceFlag = !this._forceFlag;
	  };
	
	  DraftEditorTextNode.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._forceFlag = !this._forceFlag;
	  };
	
	  DraftEditorTextNode.prototype.render = function render() {
	    if (this.props.children === '') {
	      return this._forceFlag ? NEWLINE_A : NEWLINE_B;
	    }
	    return React.createElement(
	      'span',
	      { key: this._forceFlag ? 'A' : 'B', 'data-text': 'true' },
	      this.props.children
	    );
	  };
	
	  return DraftEditorTextNode;
	}(React.Component);
	
	module.exports = DraftEditorTextNode;

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntitySegments
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Identify the range to delete from a segmented entity.
	 *
	 * Rules:
	 *
	 *  Example: 'John F. Kennedy'
	 *
	 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
	 *     will return the range of that text.
	 *
	 *       'John F. Kennedy' -> 'John F.'
	 *                  ^
	 *
	 *   - Forward deletion of whitespace will remove the following section:
	 *
	 *       'John F. Kennedy' -> 'John Kennedy'
	 *            ^
	 *
	 *   - Backward deletion of whitespace will remove the previous section:
	 *
	 *       'John F. Kennedy' -> 'F. Kennedy'
	 *            ^
	 */
	var DraftEntitySegments = {
	  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
	    var segments = text.split(' ');
	    segments = segments.map(function ( /*string*/segment, /*number*/ii) {
	      if (direction === 'forward') {
	        if (ii > 0) {
	          return ' ' + segment;
	        }
	      } else if (ii < segments.length - 1) {
	        return segment + ' ';
	      }
	      return segment;
	    });
	
	    var segmentStart = entityStart;
	    var segmentEnd;
	    var segment;
	    var removalStart = null;
	    var removalEnd = null;
	
	    for (var jj = 0; jj < segments.length; jj++) {
	      segment = segments[jj];
	      segmentEnd = segmentStart + segment.length;
	
	      // Our selection overlaps this segment.
	      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
	        if (removalStart !== null) {
	          removalEnd = segmentEnd;
	        } else {
	          removalStart = segmentStart;
	          removalEnd = segmentEnd;
	        }
	      } else if (removalStart !== null) {
	        break;
	      }
	
	      segmentStart = segmentEnd;
	    }
	
	    var entityEnd = entityStart + text.length;
	    var atStart = removalStart === entityStart;
	    var atEnd = removalEnd === entityEnd;
	
	    if (!atStart && atEnd || atStart && !atEnd) {
	      if (direction === 'forward') {
	        if (removalEnd !== entityEnd) {
	          removalEnd++;
	        }
	      } else if (removalStart !== entityStart) {
	        removalStart--;
	      }
	    }
	
	    return {
	      start: removalStart,
	      end: removalEnd
	    };
	  }
	};
	
	module.exports = DraftEntitySegments;

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftFeatureFlags-core
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftFeatureFlags = {
	  draft_killswitch_allow_nontextnodes: false,
	  draft_segmented_entities_behavior: false,
	  draft_handlebeforeinput_composed_text: false,
	  draft_tree_data_support: false
	};
	
	module.exports = DraftFeatureFlags;

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftJsDebugLogging
	 */
	
	'use strict';
	
	module.exports = {
	  logSelectionStateFailure: function logSelectionStateFailure() {
	    return null;
	  }
	};

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftPasteProcessor
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var CharacterMetadata = __webpack_require__(112);
	var ContentBlock = __webpack_require__(201);
	var ContentBlockNode = __webpack_require__(123);
	var DraftFeatureFlags = __webpack_require__(183);
	var Immutable = __webpack_require__(60);
	
	var convertFromHTMLtoContentBlocks = __webpack_require__(649);
	var generateRandomKey = __webpack_require__(161);
	var getSafeBodyFromHTML = __webpack_require__(655);
	var sanitizeDraftText = __webpack_require__(451);
	
	var List = Immutable.List,
	    Repeat = Immutable.Repeat;
	
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
	
	var DraftPasteProcessor = {
	  processHTML: function processHTML(html, blockRenderMap) {
	    return convertFromHTMLtoContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
	  },
	  processText: function processText(textBlocks, character, type) {
	    return textBlocks.reduce(function (acc, textLine, index) {
	      textLine = sanitizeDraftText(textLine);
	      var key = generateRandomKey();
	
	      var blockNodeConfig = {
	        key: key,
	        type: type,
	        text: textLine,
	        characterList: List(Repeat(character, textLine.length))
	      };
	
	      // next block updates previous block
	      if (experimentalTreeDataSupport && index !== 0) {
	        var prevSiblingIndex = index - 1;
	        // update previous block
	        var previousBlock = acc[prevSiblingIndex] = acc[prevSiblingIndex].merge({
	          nextSibling: key
	        });
	        blockNodeConfig = _extends({}, blockNodeConfig, {
	          prevSibling: previousBlock.getKey()
	        });
	      }
	
	      acc.push(new ContentBlockRecord(blockNodeConfig));
	
	      return acc;
	    }, []);
	  }
	};
	
	module.exports = DraftPasteProcessor;

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftTreeAdapter
	 * @format
	 * 
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	
	var invariant = __webpack_require__(28);
	
	var traverseInDepthOrder = function traverseInDepthOrder(blocks, fn) {
	  var stack = [].concat(blocks).reverse();
	  while (stack.length) {
	    var _block = stack.pop();
	
	    fn(_block);
	
	    var children = _block.children;
	
	    !Array.isArray(children) ?  false ? invariant(false, 'Invalid tree raw block') : invariant(false) : void 0;
	
	    stack = stack.concat([].concat(children.reverse()));
	  }
	};
	
	var isListBlock = function isListBlock(block) {
	  if (!(block && block.type)) {
	    return false;
	  }
	  var type = block.type;
	
	  return type === 'unordered-list-item' || type === 'ordered-list-item';
	};
	
	var addDepthToChildren = function addDepthToChildren(block) {
	  if (Array.isArray(block.children)) {
	    block.children = block.children.map(function (child) {
	      return child.type === block.type ? _extends({}, child, { depth: (block.depth || 0) + 1 }) : child;
	    });
	  }
	};
	
	/**
	 * This adapter is intended to be be used as an adapter to draft tree data
	 *
	 * draft state <=====> draft tree state
	 */
	var DraftTreeAdapter = {
	  /**
	   * Converts from a tree raw state back to  draft raw state
	   */
	  fromRawTreeStateToRawState: function fromRawTreeStateToRawState(draftTreeState) {
	    var blocks = draftTreeState.blocks;
	
	    var transformedBlocks = [];
	
	    !Array.isArray(blocks) ?  false ? invariant(false, 'Invalid raw state') : invariant(false) : void 0;
	
	    if (!Array.isArray(blocks) || !blocks.length) {
	      return draftTreeState;
	    }
	
	    traverseInDepthOrder(blocks, function (block) {
	      var newBlock = _extends({}, block);
	
	      if (isListBlock(block)) {
	        newBlock.depth = newBlock.depth || 0;
	        addDepthToChildren(block);
	      }
	
	      delete newBlock.children;
	
	      transformedBlocks.push(newBlock);
	    });
	
	    draftTreeState.blocks = transformedBlocks;
	
	    return _extends({}, draftTreeState, {
	      blocks: transformedBlocks
	    });
	  },
	
	
	  /**
	   * Converts from draft raw state to tree draft state
	   */
	  fromRawStateToRawTreeState: function fromRawStateToRawTreeState(draftState) {
	    var lastListDepthCacheRef = {};
	    var transformedBlocks = [];
	
	    draftState.blocks.forEach(function (block) {
	      var isList = isListBlock(block);
	      var depth = block.depth || 0;
	      var treeBlock = _extends({}, block, {
	        children: []
	      });
	
	      if (!isList) {
	        // reset the cache path
	        lastListDepthCacheRef = {};
	        transformedBlocks.push(treeBlock);
	        return;
	      }
	
	      // update our depth cache reference path
	      lastListDepthCacheRef[depth] = treeBlock;
	
	      // if we are greater than zero we must have seen a parent already
	      if (depth > 0) {
	        var parent = lastListDepthCacheRef[depth - 1];
	
	        !parent ?  false ? invariant(false, 'Invalid depth for RawDraftContentBlock') : invariant(false) : void 0;
	
	        // push nested list blocks
	        parent.children.push(treeBlock);
	        return;
	      }
	
	      // push root list blocks
	      transformedBlocks.push(treeBlock);
	    });
	
	    return _extends({}, draftState, {
	      blocks: transformedBlocks
	    });
	  }
	};
	
	module.exports = DraftTreeAdapter;

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EditorBidiService
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(60);
	var UnicodeBidiService = __webpack_require__(1296);
	
	var nullthrows = __webpack_require__(136);
	
	var OrderedMap = Immutable.OrderedMap;
	
	
	var bidiService;
	
	var EditorBidiService = {
	  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
	    if (!bidiService) {
	      bidiService = new UnicodeBidiService();
	    } else {
	      bidiService.reset();
	    }
	
	    var blockMap = content.getBlockMap();
	    var nextBidi = blockMap.valueSeq().map(function (block) {
	      return nullthrows(bidiService).getDirection(block.getText());
	    });
	    var bidiMap = OrderedMap(blockMap.keySeq().zip(nextBidi));
	
	    if (prevBidiMap != null && Immutable.is(prevBidiMap, bidiMap)) {
	      return prevBidiMap;
	    }
	
	    return bidiMap;
	  }
	};
	
	module.exports = EditorBidiService;

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SecondaryClipboard
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(104);
	var EditorState = __webpack_require__(71);
	
	var getContentStateFragment = __webpack_require__(334);
	var nullthrows = __webpack_require__(136);
	
	var clipboard = null;
	
	/**
	 * Some systems offer a "secondary" clipboard to allow quick internal cut
	 * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
	 */
	var SecondaryClipboard = {
	  cut: function cut(editorState) {
	    var content = editorState.getCurrentContent();
	    var selection = editorState.getSelection();
	    var targetRange = null;
	
	    if (selection.isCollapsed()) {
	      var anchorKey = selection.getAnchorKey();
	      var blockEnd = content.getBlockForKey(anchorKey).getLength();
	
	      if (blockEnd === selection.getAnchorOffset()) {
	        return editorState;
	      }
	
	      targetRange = selection.set('focusOffset', blockEnd);
	    } else {
	      targetRange = selection;
	    }
	
	    targetRange = nullthrows(targetRange);
	    clipboard = getContentStateFragment(content, targetRange);
	
	    var afterRemoval = DraftModifier.removeRange(content, targetRange, 'forward');
	
	    if (afterRemoval === content) {
	      return editorState;
	    }
	
	    return EditorState.push(editorState, afterRemoval, 'remove-range');
	  },
	
	  paste: function paste(editorState) {
	    if (!clipboard) {
	      return editorState;
	    }
	
	    var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);
	
	    return EditorState.push(editorState, newContent, 'insert-fragment');
	  }
	};
	
	module.exports = SecondaryClipboard;

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adjustBlockDepthForContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
	  var startKey = selectionState.getStartKey();
	  var endKey = selectionState.getEndKey();
	  var blockMap = contentState.getBlockMap();
	  var blocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
	    var depth = block.getDepth() + adjustment;
	    depth = Math.max(0, Math.min(depth, maxDepth));
	    return block.set('depth', depth);
	  });
	
	  blockMap = blockMap.merge(blocks);
	
	  return contentState.merge({
	    blockMap: blockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = adjustBlockDepthForContentState;

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule applyEntityToContentBlock
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(112);
	
	function applyEntityToContentBlock(contentBlock, start, end, entityKey) {
	  var characterList = contentBlock.getCharacterList();
	  while (start < end) {
	    characterList = characterList.set(start, CharacterMetadata.applyEntity(characterList.get(start), entityKey));
	    start++;
	  }
	  return contentBlock.set('characterList', characterList);
	}
	
	module.exports = applyEntityToContentBlock;

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule applyEntityToContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(60);
	
	var applyEntityToContentBlock = __webpack_require__(1227);
	
	function applyEntityToContentState(contentState, selectionState, entityKey) {
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var newBlocks = blockMap.skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).toOrderedMap().merge(Immutable.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
	    var sliceStart = blockKey === startKey ? startOffset : 0;
	    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
	    return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
	  });
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = applyEntityToContentState;

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromDraftStateToRaw
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ContentBlock = __webpack_require__(201);
	var ContentBlockNode = __webpack_require__(123);
	var DraftStringKey = __webpack_require__(647);
	
	var encodeEntityRanges = __webpack_require__(1246);
	var encodeInlineStyleRanges = __webpack_require__(1247);
	var invariant = __webpack_require__(28);
	
	var createRawBlock = function createRawBlock(block, entityStorageMap) {
	  return {
	    key: block.getKey(),
	    text: block.getText(),
	    type: block.getType(),
	    depth: block.getDepth(),
	    inlineStyleRanges: encodeInlineStyleRanges(block),
	    entityRanges: encodeEntityRanges(block, entityStorageMap),
	    data: block.getData().toObject()
	  };
	};
	
	var insertRawBlock = function insertRawBlock(block, entityMap, rawBlocks, blockCacheRef) {
	  if (block instanceof ContentBlock) {
	    rawBlocks.push(createRawBlock(block, entityMap));
	    return;
	  }
	
	  !(block instanceof ContentBlockNode) ?  false ? invariant(false, 'block is not a BlockNode') : invariant(false) : void 0;
	
	  var parentKey = block.getParentKey();
	  var rawBlock = blockCacheRef[block.getKey()] = _extends({}, createRawBlock(block, entityMap), {
	    children: []
	  });
	
	  if (parentKey) {
	    blockCacheRef[parentKey].children.push(rawBlock);
	    return;
	  }
	
	  rawBlocks.push(rawBlock);
	};
	
	var encodeRawBlocks = function encodeRawBlocks(contentState, rawState) {
	  var entityMap = rawState.entityMap;
	
	
	  var rawBlocks = [];
	
	  var blockCacheRef = {};
	  var entityCacheRef = {};
	  var entityStorageKey = 0;
	
	  contentState.getBlockMap().forEach(function (block) {
	    block.findEntityRanges(function (character) {
	      return character.getEntity() !== null;
	    }, function (start) {
	      var entityKey = block.getEntityAt(start);
	      // Stringify to maintain order of otherwise numeric keys.
	      var stringifiedEntityKey = DraftStringKey.stringify(entityKey);
	      // This makes this function resilient to two entities
	      // erroneously having the same key
	      if (entityCacheRef[stringifiedEntityKey]) {
	        return;
	      }
	      entityCacheRef[stringifiedEntityKey] = entityKey;
	      // we need the `any` casting here since this is a temporary state
	      // where we will later on flip the entity map and populate it with
	      // real entity, at this stage we just need to map back the entity
	      // key used by the BlockNode
	      entityMap[stringifiedEntityKey] = '' + entityStorageKey;
	      entityStorageKey++;
	    });
	
	    insertRawBlock(block, entityMap, rawBlocks, blockCacheRef);
	  });
	
	  return {
	    blocks: rawBlocks,
	    entityMap: entityMap
	  };
	};
	
	// Flip storage map so that our storage keys map to global
	// DraftEntity keys.
	var encodeRawEntityMap = function encodeRawEntityMap(contentState, rawState) {
	  var blocks = rawState.blocks,
	      entityMap = rawState.entityMap;
	
	
	  var rawEntityMap = {};
	
	  Object.keys(entityMap).forEach(function (key, index) {
	    var entity = contentState.getEntity(DraftStringKey.unstringify(key));
	    rawEntityMap[index] = {
	      type: entity.getType(),
	      mutability: entity.getMutability(),
	      data: entity.getData()
	    };
	  });
	
	  return {
	    blocks: blocks,
	    entityMap: rawEntityMap
	  };
	};
	
	var convertFromDraftStateToRaw = function convertFromDraftStateToRaw(contentState) {
	  var rawDraftContentState = {
	    entityMap: {},
	    blocks: []
	  };
	
	  // add blocks
	  rawDraftContentState = encodeRawBlocks(contentState, rawDraftContentState);
	
	  // add entities
	  rawDraftContentState = encodeRawEntityMap(contentState, rawDraftContentState);
	
	  return rawDraftContentState;
	};
	
	module.exports = convertFromDraftStateToRaw;

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromRawToDraftState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ContentBlock = __webpack_require__(201);
	var ContentBlockNode = __webpack_require__(123);
	var ContentState = __webpack_require__(445);
	var DraftEntity = __webpack_require__(332);
	var DraftFeatureFlags = __webpack_require__(183);
	var DraftTreeAdapter = __webpack_require__(1223);
	var Immutable = __webpack_require__(60);
	var SelectionState = __webpack_require__(235);
	
	var createCharacterList = __webpack_require__(1231);
	var decodeEntityRanges = __webpack_require__(1232);
	var decodeInlineStyleRanges = __webpack_require__(1233);
	var generateRandomKey = __webpack_require__(161);
	var invariant = __webpack_require__(28);
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	
	var List = Immutable.List,
	    Map = Immutable.Map,
	    OrderedMap = Immutable.OrderedMap;
	
	
	var decodeBlockNodeConfig = function decodeBlockNodeConfig(block, entityMap) {
	  var key = block.key,
	      type = block.type,
	      data = block.data,
	      text = block.text,
	      depth = block.depth;
	
	
	  var blockNodeConfig = {
	    text: text,
	    depth: depth || 0,
	    type: type || 'unstyled',
	    key: key || generateRandomKey(),
	    data: Map(data),
	    characterList: decodeCharacterList(block, entityMap)
	  };
	
	  return blockNodeConfig;
	};
	
	var decodeCharacterList = function decodeCharacterList(block, entityMap) {
	  var text = block.text,
	      rawEntityRanges = block.entityRanges,
	      rawInlineStyleRanges = block.inlineStyleRanges;
	
	
	  var entityRanges = rawEntityRanges || [];
	  var inlineStyleRanges = rawInlineStyleRanges || [];
	
	  // Translate entity range keys to the DraftEntity map.
	  return createCharacterList(decodeInlineStyleRanges(text, inlineStyleRanges), decodeEntityRanges(text, entityRanges.filter(function (range) {
	    return entityMap.hasOwnProperty(range.key);
	  }).map(function (range) {
	    return _extends({}, range, { key: entityMap[range.key] });
	  })));
	};
	
	var addKeyIfMissing = function addKeyIfMissing(block) {
	  return _extends({}, block, {
	    key: block.key || generateRandomKey()
	  });
	};
	
	/**
	 * Node stack is responsible to ensure we traverse the tree only once
	 * in depth order, while also providing parent refs to inner nodes to
	 * construct their links.
	 */
	var updateNodeStack = function updateNodeStack(stack, nodes, parentRef) {
	  var nodesWithParentRef = nodes.map(function (block) {
	    return _extends({}, block, {
	      parentRef: parentRef
	    });
	  });
	
	  // since we pop nodes from the stack we need to insert them in reverse
	  return stack.concat(nodesWithParentRef.reverse());
	};
	
	/**
	 * This will build a tree draft content state by creating the node
	 * reference links into a single tree walk. Each node has a link
	 * reference to "parent", "children", "nextSibling" and "prevSibling"
	 * blockMap will be created using depth ordering.
	 */
	var decodeContentBlockNodes = function decodeContentBlockNodes(blocks, entityMap) {
	  return blocks
	  // ensure children have valid keys to enable sibling links
	  .map(addKeyIfMissing).reduce(function (blockMap, block, index) {
	    !Array.isArray(block.children) ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;
	
	    // ensure children have valid keys to enable sibling links
	    var children = block.children.map(addKeyIfMissing);
	
	    // root level nodes
	    var contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(block, entityMap), {
	      prevSibling: index === 0 ? null : blocks[index - 1].key,
	      nextSibling: index === blocks.length - 1 ? null : blocks[index + 1].key,
	      children: List(children.map(function (child) {
	        return child.key;
	      }))
	    }));
	
	    // push root node to blockMap
	    blockMap = blockMap.set(contentBlockNode.getKey(), contentBlockNode);
	
	    // this stack is used to ensure we visit all nodes respecting depth ordering
	    var stack = updateNodeStack([], children, contentBlockNode);
	
	    // start computing children nodes
	    while (stack.length > 0) {
	      // we pop from the stack and start processing this node
	      var node = stack.pop();
	
	      // parentRef already points to a converted ContentBlockNode
	      var parentRef = node.parentRef;
	      var siblings = parentRef.getChildKeys();
	      var _index = siblings.indexOf(node.key);
	      var isValidBlock = Array.isArray(node.children);
	
	      if (!isValidBlock) {
	        !isValidBlock ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;
	        break;
	      }
	
	      // ensure children have valid keys to enable sibling links
	      var _children = node.children.map(addKeyIfMissing);
	
	      var _contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(node, entityMap), {
	        parent: parentRef.getKey(),
	        children: List(_children.map(function (child) {
	          return child.key;
	        })),
	        prevSibling: _index === 0 ? null : siblings.get(_index - 1),
	        nextSibling: _index === siblings.size - 1 ? null : siblings.get(_index + 1)
	      }));
	
	      // push node to blockMap
	      blockMap = blockMap.set(_contentBlockNode.getKey(), _contentBlockNode);
	
	      // this stack is used to ensure we visit all nodes respecting depth ordering
	      stack = updateNodeStack(stack, _children, _contentBlockNode);
	    }
	
	    return blockMap;
	  }, OrderedMap());
	};
	
	var decodeContentBlocks = function decodeContentBlocks(blocks, entityMap) {
	  return OrderedMap(blocks.map(function (block) {
	    var contentBlock = new ContentBlock(decodeBlockNodeConfig(block, entityMap));
	    return [contentBlock.getKey(), contentBlock];
	  }));
	};
	
	var decodeRawBlocks = function decodeRawBlocks(rawState, entityMap) {
	  var isTreeRawBlock = Array.isArray(rawState.blocks[0].children);
	  var rawBlocks = experimentalTreeDataSupport && !isTreeRawBlock ? DraftTreeAdapter.fromRawStateToRawTreeState(rawState).blocks : rawState.blocks;
	
	  if (!experimentalTreeDataSupport) {
	    return decodeContentBlocks(isTreeRawBlock ? DraftTreeAdapter.fromRawTreeStateToRawState(rawState).blocks : rawBlocks, entityMap);
	  }
	
	  return decodeContentBlockNodes(rawBlocks, entityMap);
	};
	
	var decodeRawEntityMap = function decodeRawEntityMap(rawState) {
	  var rawEntityMap = rawState.entityMap;
	
	  var entityMap = {};
	
	  // TODO: Update this once we completely remove DraftEntity
	  Object.keys(rawEntityMap).forEach(function (rawEntityKey) {
	    var _rawEntityMap$rawEnti = rawEntityMap[rawEntityKey],
	        type = _rawEntityMap$rawEnti.type,
	        mutability = _rawEntityMap$rawEnti.mutability,
	        data = _rawEntityMap$rawEnti.data;
	
	    // get the key reference to created entity
	
	    entityMap[rawEntityKey] = DraftEntity.__create(type, mutability, data || {});
	  });
	
	  return entityMap;
	};
	
	var convertFromRawToDraftState = function convertFromRawToDraftState(rawState) {
	  !Array.isArray(rawState.blocks) ?  false ? invariant(false, 'invalid RawDraftContentState') : invariant(false) : void 0;
	
	  // decode entities
	  var entityMap = decodeRawEntityMap(rawState);
	
	  // decode blockMap
	  var blockMap = decodeRawBlocks(rawState, entityMap);
	
	  // create initial selection
	  var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
	
	  return new ContentState({
	    blockMap: blockMap,
	    entityMap: entityMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	};
	
	module.exports = convertFromRawToDraftState;

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createCharacterList
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(112);
	var Immutable = __webpack_require__(60);
	
	var List = Immutable.List;
	
	
	function createCharacterList(inlineStyles, entities) {
	  var characterArray = inlineStyles.map(function (style, ii) {
	    var entity = entities[ii];
	    return CharacterMetadata.create({ style: style, entity: entity });
	  });
	  return List(characterArray);
	}
	
	module.exports = createCharacterList;

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule decodeEntityRanges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UnicodeUtils = __webpack_require__(204);
	
	var substr = UnicodeUtils.substr;
	
	/**
	 * Convert to native JavaScript string lengths to determine ranges.
	 */
	
	function decodeEntityRanges(text, ranges) {
	  var entities = Array(text.length).fill(null);
	  if (ranges) {
	    ranges.forEach(function (range) {
	      // Using Unicode-enabled substrings converted to JavaScript lengths,
	      // fill the output array with entity keys.
	      var start = substr(text, 0, range.offset).length;
	      var end = start + substr(text, range.offset, range.length).length;
	      for (var ii = start; ii < end; ii++) {
	        entities[ii] = range.key;
	      }
	    });
	  }
	  return entities;
	}
	
	module.exports = decodeEntityRanges;

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule decodeInlineStyleRanges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _require = __webpack_require__(60),
	    OrderedSet = _require.OrderedSet;
	
	var UnicodeUtils = __webpack_require__(204);
	
	var substr = UnicodeUtils.substr;
	
	
	var EMPTY_SET = OrderedSet();
	
	/**
	 * Convert to native JavaScript string lengths to determine ranges.
	 */
	function decodeInlineStyleRanges(text, ranges) {
	  var styles = Array(text.length).fill(EMPTY_SET);
	  if (ranges) {
	    ranges.forEach(function ( /*object*/range) {
	      var cursor = substr(text, 0, range.offset).length;
	      var end = cursor + substr(text, range.offset, range.length).length;
	      while (cursor < end) {
	        styles[cursor] = styles[cursor].add(range.style);
	        cursor++;
	      }
	    });
	  }
	  return styles;
	}
	
	module.exports = decodeInlineStyleRanges;

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnBeforeInput
	 * @format
	 * 
	 */
	
	'use strict';
	
	var BlockTree = __webpack_require__(642);
	var DraftModifier = __webpack_require__(104);
	var EditorState = __webpack_require__(71);
	var UserAgent = __webpack_require__(150);
	
	var getEntityKeyForSelection = __webpack_require__(449);
	var isEventHandled = __webpack_require__(273);
	var isSelectionAtLeafStart = __webpack_require__(660);
	var nullthrows = __webpack_require__(136);
	var setImmediate = __webpack_require__(1310);
	
	// When nothing is focused, Firefox regards two characters, `'` and `/`, as
	// commands that should open and focus the "quickfind" search bar. This should
	// *never* happen while a contenteditable is focused, but as of v28, it
	// sometimes does, even when the keypress event target is the contenteditable.
	// This breaks the input. Special case these characters to ensure that when
	// they are typed, we prevent default on the event to make sure not to
	// trigger quickfind.
	var FF_QUICKFIND_CHAR = "'";
	var FF_QUICKFIND_LINK_CHAR = '/';
	var isFirefox = UserAgent.isBrowser('Firefox');
	
	function mustPreventDefaultForCharacter(character) {
	  return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
	}
	
	/**
	 * Replace the current selection with the specified text string, with the
	 * inline style and entity key applied to the newly inserted text.
	 */
	function replaceText(editorState, text, inlineStyle, entityKey) {
	  var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
	  return EditorState.push(editorState, contentState, 'insert-characters');
	}
	
	/**
	 * When `onBeforeInput` executes, the browser is attempting to insert a
	 * character into the editor. Apply this character data to the document,
	 * allowing native insertion if possible.
	 *
	 * Native insertion is encouraged in order to limit re-rendering and to
	 * preserve spellcheck highlighting, which disappears or flashes if re-render
	 * occurs on the relevant text nodes.
	 */
	function editOnBeforeInput(editor, e) {
	  if (editor._pendingStateFromBeforeInput !== undefined) {
	    editor.update(editor._pendingStateFromBeforeInput);
	    editor._pendingStateFromBeforeInput = undefined;
	  }
	
	  var editorState = editor._latestEditorState;
	
	  var chars = e.data;
	
	  // In some cases (ex: IE ideographic space insertion) no character data
	  // is provided. There's nothing to do when this happens.
	  if (!chars) {
	    return;
	  }
	
	  // Allow the top-level component to handle the insertion manually. This is
	  // useful when triggering interesting behaviors for a character insertion,
	  // Simple examples: replacing a raw text ':)' with a smile emoji or image
	  // decorator, or setting a block to be a list item after typing '- ' at the
	  // start of the block.
	  if (editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(chars, editorState))) {
	    e.preventDefault();
	    return;
	  }
	
	  // If selection is collapsed, conditionally allow native behavior. This
	  // reduces re-renders and preserves spellcheck highlighting. If the selection
	  // is not collapsed, we will re-render.
	  var selection = editorState.getSelection();
	  var selectionStart = selection.getStartOffset();
	  var selectionEnd = selection.getEndOffset();
	  var anchorKey = selection.getAnchorKey();
	
	  if (!selection.isCollapsed()) {
	    e.preventDefault();
	
	    // If the currently selected text matches what the user is trying to
	    // replace it with, let's just update the `SelectionState`. If not, update
	    // the `ContentState` with the new text.
	    var currentlySelectedChars = editorState.getCurrentContent().getPlainText().slice(selectionStart, selectionEnd);
	    if (chars === currentlySelectedChars) {
	      editor.update(EditorState.forceSelection(editorState, selection.merge({
	        focusOffset: selectionEnd
	      })));
	    } else {
	      editor.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())));
	    }
	    return;
	  }
	
	  var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()));
	
	  // Bunch of different cases follow where we need to prevent native insertion.
	  var mustPreventNative = false;
	  if (!mustPreventNative) {
	    // Browsers tend to insert text in weird places in the DOM when typing at
	    // the start of a leaf, so we'll handle it ourselves.
	    mustPreventNative = isSelectionAtLeafStart(editor._latestCommittedEditorState);
	  }
	  if (!mustPreventNative) {
	    // Chrome will also split up a node into two pieces if it contains a Tab
	    // char, for no explicable reason. Seemingly caused by this commit:
	    // https://chromium.googlesource.com/chromium/src/+/013ac5eaf3%5E%21/
	    var nativeSelection = global.getSelection();
	    // Selection is necessarily collapsed at this point due to earlier check.
	    if (nativeSelection.anchorNode && nativeSelection.anchorNode.nodeType === Node.TEXT_NODE) {
	      // See isTabHTMLSpanElement in chromium EditingUtilities.cpp.
	      var parentNode = nativeSelection.anchorNode.parentNode;
	      mustPreventNative = parentNode.nodeName === 'SPAN' && parentNode.firstChild.nodeType === Node.TEXT_NODE && parentNode.firstChild.nodeValue.indexOf('\t') !== -1;
	    }
	  }
	  if (!mustPreventNative) {
	    // Check the old and new "fingerprints" of the current block to determine
	    // whether this insertion requires any addition or removal of text nodes,
	    // in which case we would prevent the native character insertion.
	    var originalFingerprint = BlockTree.getFingerprint(editorState.getBlockTree(anchorKey));
	    var newFingerprint = BlockTree.getFingerprint(newEditorState.getBlockTree(anchorKey));
	    mustPreventNative = originalFingerprint !== newFingerprint;
	  }
	  if (!mustPreventNative) {
	    mustPreventNative = mustPreventDefaultForCharacter(chars);
	  }
	  if (!mustPreventNative) {
	    mustPreventNative = nullthrows(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows(editorState.getDirectionMap()).get(anchorKey);
	  }
	
	  if (mustPreventNative) {
	    e.preventDefault();
	    editor.update(newEditorState);
	    return;
	  }
	
	  // We made it all the way! Let the browser do its thing and insert the char.
	  newEditorState = EditorState.set(newEditorState, {
	    nativelyRenderedContent: newEditorState.getCurrentContent()
	  });
	  // The native event is allowed to occur. To allow user onChange handlers to
	  // change the inserted text, we wait until the text is actually inserted
	  // before we actually update our state. That way when we rerender, the text
	  // we see in the DOM will already have been inserted properly.
	  editor._pendingStateFromBeforeInput = newEditorState;
	  setImmediate(function () {
	    if (editor._pendingStateFromBeforeInput !== undefined) {
	      editor.update(editor._pendingStateFromBeforeInput);
	      editor._pendingStateFromBeforeInput = undefined;
	    }
	  });
	}
	
	module.exports = editOnBeforeInput;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnBlur
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(71);
	
	var containsNode = __webpack_require__(335);
	var getActiveElement = __webpack_require__(337);
	
	function editOnBlur(editor, e) {
	  // In a contentEditable element, when you select a range and then click
	  // another active element, this does trigger a `blur` event but will not
	  // remove the DOM selection from the contenteditable.
	  // This is consistent across all browsers, but we prefer that the editor
	  // behave like a textarea, where a `blur` event clears the DOM selection.
	  // We therefore force the issue to be certain, checking whether the active
	  // element is `body` to force it when blurring occurs within the window (as
	  // opposed to clicking to another tab or window).
	  if (getActiveElement() === document.body) {
	    var _selection = global.getSelection();
	    var editorNode = editor.editor;
	    if (_selection.rangeCount === 1 && containsNode(editorNode, _selection.anchorNode) && containsNode(editorNode, _selection.focusNode)) {
	      _selection.removeAllRanges();
	    }
	  }
	
	  var editorState = editor._latestEditorState;
	  var currentSelection = editorState.getSelection();
	  if (!currentSelection.getHasFocus()) {
	    return;
	  }
	
	  var selection = currentSelection.set('hasFocus', false);
	  editor.props.onBlur && editor.props.onBlur(e);
	  editor.update(EditorState.acceptSelection(editorState, selection));
	}
	
	module.exports = editOnBlur;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCompositionStart
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(71);
	
	/**
	 * The user has begun using an IME input system. Switching to `composite` mode
	 * allows handling composition input and disables other edit behavior.
	 */
	function editOnCompositionStart(editor, e) {
	  editor.setMode('composite');
	  editor.update(EditorState.set(editor._latestEditorState, { inCompositionMode: true }));
	  // Allow composition handler to interpret the compositionstart event
	  editor._onCompositionStart(e);
	}
	
	module.exports = editOnCompositionStart;

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCopy
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getFragmentFromSelection = __webpack_require__(652);
	
	/**
	 * If we have a selection, create a ContentState fragment and store
	 * it in our internal clipboard. Subsequent paste events will use this
	 * fragment if no external clipboard data is supplied.
	 */
	function editOnCopy(editor, e) {
	  var editorState = editor._latestEditorState;
	  var selection = editorState.getSelection();
	
	  // No selection, so there's nothing to copy.
	  if (selection.isCollapsed()) {
	    e.preventDefault();
	    return;
	  }
	
	  editor.setClipboard(getFragmentFromSelection(editor._latestEditorState));
	}
	
	module.exports = editOnCopy;

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCut
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(104);
	var EditorState = __webpack_require__(71);
	var Style = __webpack_require__(455);
	
	var getFragmentFromSelection = __webpack_require__(652);
	var getScrollPosition = __webpack_require__(457);
	
	/**
	 * On `cut` events, native behavior is allowed to occur so that the system
	 * clipboard is set properly. This means that we need to take steps to recover
	 * the editor DOM state after the `cut` has occurred in order to maintain
	 * control of the component.
	 *
	 * In addition, we can keep a copy of the removed fragment, including all
	 * styles and entities, for use as an internal paste.
	 */
	function editOnCut(editor, e) {
	  var editorState = editor._latestEditorState;
	  var selection = editorState.getSelection();
	  var element = e.target;
	  var scrollPosition = void 0;
	
	  // No selection, so there's nothing to cut.
	  if (selection.isCollapsed()) {
	    e.preventDefault();
	    return;
	  }
	
	  // Track the current scroll position so that it can be forced back in place
	  // after the editor regains control of the DOM.
	  if (element instanceof Node) {
	    scrollPosition = getScrollPosition(Style.getScrollParent(element));
	  }
	
	  var fragment = getFragmentFromSelection(editorState);
	  editor.setClipboard(fragment);
	
	  // Set `cut` mode to disable all event handling temporarily.
	  editor.setMode('cut');
	
	  // Let native `cut` behavior occur, then recover control.
	  setTimeout(function () {
	    editor.restoreEditorDOM(scrollPosition);
	    editor.exitCurrentMode();
	    editor.update(removeFragment(editorState));
	  }, 0);
	}
	
	function removeFragment(editorState) {
	  var newContent = DraftModifier.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
	  return EditorState.push(editorState, newContent, 'remove-range');
	}
	
	module.exports = editOnCut;

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnDragOver
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Drag behavior has begun from outside the editor element.
	 */
	function editOnDragOver(editor, e) {
	  editor._internalDrag = false;
	  editor.setMode('drag');
	  e.preventDefault();
	}
	
	module.exports = editOnDragOver;

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnDragStart
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * A `dragstart` event has begun within the text editor component.
	 */
	function editOnDragStart(editor) {
	  editor._internalDrag = true;
	  editor.setMode('drag');
	}
	
	module.exports = editOnDragStart;

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnFocus
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(71);
	var UserAgent = __webpack_require__(150);
	
	function editOnFocus(editor, e) {
	  var editorState = editor._latestEditorState;
	  var currentSelection = editorState.getSelection();
	  if (currentSelection.getHasFocus()) {
	    return;
	  }
	
	  var selection = currentSelection.set('hasFocus', true);
	  editor.props.onFocus && editor.props.onFocus(e);
	
	  // When the tab containing this text editor is hidden and the user does a
	  // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
	  // selection was right after sending this focus event and (if you let it)
	  // moves the cursor back to the beginning of the editor, so we force the
	  // selection here instead of simply accepting it in order to preserve the
	  // old cursor position. See https://crbug.com/540004.
	  // But it looks like this is fixed in Chrome 60.0.3081.0.
	  // Other browsers also don't have this bug, so we prefer to acceptSelection
	  // when possible, to ensure that unfocusing and refocusing a Draft editor
	  // doesn't preserve the selection, matching how textareas work.
	  if (UserAgent.isBrowser('Chrome < 60.0.3081.0')) {
	    editor.update(EditorState.forceSelection(editorState, selection));
	  } else {
	    editor.update(EditorState.acceptSelection(editorState, selection));
	  }
	}
	
	module.exports = editOnFocus;

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnInput
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftFeatureFlags = __webpack_require__(183);
	var DraftModifier = __webpack_require__(104);
	var DraftOffsetKey = __webpack_require__(333);
	var EditorState = __webpack_require__(71);
	var UserAgent = __webpack_require__(150);
	
	var findAncestorOffsetKey = __webpack_require__(448);
	var nullthrows = __webpack_require__(136);
	
	var isGecko = UserAgent.isEngine('Gecko');
	
	var DOUBLE_NEWLINE = '\n\n';
	
	/**
	 * This function is intended to handle spellcheck and autocorrect changes,
	 * which occur in the DOM natively without any opportunity to observe or
	 * interpret the changes before they occur.
	 *
	 * The `input` event fires in contentEditable elements reliably for non-IE
	 * browsers, immediately after changes occur to the editor DOM. Since our other
	 * handlers override or otherwise handle cover other varieties of text input,
	 * the DOM state should match the model in all controlled input cases. Thus,
	 * when an `input` change leads to a DOM/model mismatch, the change should be
	 * due to a spellcheck change, and we can incorporate it into our model.
	 */
	function editOnInput(editor) {
	  if (editor._pendingStateFromBeforeInput !== undefined) {
	    editor.update(editor._pendingStateFromBeforeInput);
	    editor._pendingStateFromBeforeInput = undefined;
	  }
	
	  var domSelection = global.getSelection();
	
	  var anchorNode = domSelection.anchorNode,
	      isCollapsed = domSelection.isCollapsed;
	
	  var isNotTextNode = anchorNode.nodeType !== Node.TEXT_NODE;
	  var isNotTextOrElementNode = anchorNode.nodeType !== Node.TEXT_NODE && anchorNode.nodeType !== Node.ELEMENT_NODE;
	
	  if (DraftFeatureFlags.draft_killswitch_allow_nontextnodes) {
	    if (isNotTextNode) {
	      return;
	    }
	  } else {
	    if (isNotTextOrElementNode) {
	      // TODO: (t16149272) figure out context for this change
	      return;
	    }
	  }
	
	  if (anchorNode.nodeType === Node.TEXT_NODE && (anchorNode.previousSibling !== null || anchorNode.nextSibling !== null)) {
	    // When typing at the beginning of a visual line, Chrome splits the text
	    // nodes into two. Why? No one knows. This commit is suspicious:
	    // https://chromium.googlesource.com/chromium/src/+/a3b600981286b135632371477f902214c55a1724
	    // To work around, we'll merge the sibling text nodes back into this one.
	    var span = anchorNode.parentNode;
	    anchorNode.nodeValue = span.textContent;
	    for (var child = span.firstChild; child !== null; child = child.nextSibling) {
	      if (child !== anchorNode) {
	        span.removeChild(child);
	      }
	    }
	  }
	
	  var domText = anchorNode.textContent;
	  var editorState = editor._latestEditorState;
	  var offsetKey = nullthrows(findAncestorOffsetKey(anchorNode));
	
	  var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey),
	      blockKey = _DraftOffsetKey$decod.blockKey,
	      decoratorKey = _DraftOffsetKey$decod.decoratorKey,
	      leafKey = _DraftOffsetKey$decod.leafKey;
	
	  var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
	      start = _editorState$getBlock.start,
	      end = _editorState$getBlock.end;
	
	  var content = editorState.getCurrentContent();
	  var block = content.getBlockForKey(blockKey);
	  var modelText = block.getText().slice(start, end);
	
	  // Special-case soft newlines here. If the DOM text ends in a soft newline,
	  // we will have manually inserted an extra soft newline in DraftEditorLeaf.
	  // We want to remove this extra newline for the purpose of our comparison
	  // of DOM and model text.
	  if (domText.endsWith(DOUBLE_NEWLINE)) {
	    domText = domText.slice(0, -1);
	  }
	
	  // No change -- the DOM is up to date. Nothing to do here.
	  if (domText === modelText) {
	    // This can be buggy for some Android keyboards because they don't fire
	    // standard onkeydown/pressed events and only fired editOnInput
	    // so domText is already changed by the browser and ends up being equal
	    // to modelText unexpectedly
	    return;
	  }
	
	  var selection = editorState.getSelection();
	
	  // We'll replace the entire leaf with the text content of the target.
	  var targetRange = selection.merge({
	    anchorOffset: start,
	    focusOffset: end,
	    isBackward: false
	  });
	
	  var entityKey = block.getEntityAt(start);
	  var entity = entityKey && content.getEntity(entityKey);
	  var entityType = entity && entity.getMutability();
	  var preserveEntity = entityType === 'MUTABLE';
	
	  // Immutable or segmented entities cannot properly be handled by the
	  // default browser undo, so we have to use a different change type to
	  // force using our internal undo method instead of falling through to the
	  // native browser undo.
	  var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';
	
	  var newContent = DraftModifier.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);
	
	  var anchorOffset, focusOffset, startOffset, endOffset;
	
	  if (isGecko) {
	    // Firefox selection does not change while the context menu is open, so
	    // we preserve the anchor and focus values of the DOM selection.
	    anchorOffset = domSelection.anchorOffset;
	    focusOffset = domSelection.focusOffset;
	    startOffset = start + Math.min(anchorOffset, focusOffset);
	    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
	    anchorOffset = startOffset;
	    focusOffset = endOffset;
	  } else {
	    // Browsers other than Firefox may adjust DOM selection while the context
	    // menu is open, and Safari autocorrect is prone to providing an inaccurate
	    // DOM selection. Don't trust it. Instead, use our existing SelectionState
	    // and adjust it based on the number of characters changed during the
	    // mutation.
	    var charDelta = domText.length - modelText.length;
	    startOffset = selection.getStartOffset();
	    endOffset = selection.getEndOffset();
	
	    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
	    focusOffset = endOffset + charDelta;
	  }
	
	  // Segmented entities are completely or partially removed when their
	  // text content changes. For this case we do not want any text to be selected
	  // after the change, so we are not merging the selection.
	  var contentWithAdjustedDOMSelection = newContent.merge({
	    selectionBefore: content.getSelectionAfter(),
	    selectionAfter: selection.merge({ anchorOffset: anchorOffset, focusOffset: focusOffset })
	  });
	
	  editor.update(EditorState.push(editorState, contentWithAdjustedDOMSelection, changeType));
	}
	
	module.exports = editOnInput;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnKeyDown
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(104);
	var EditorState = __webpack_require__(71);
	var KeyBindingUtil = __webpack_require__(447);
	var Keys = __webpack_require__(454);
	var SecondaryClipboard = __webpack_require__(1225);
	var UserAgent = __webpack_require__(150);
	
	var isEventHandled = __webpack_require__(273);
	var keyCommandBackspaceToStartOfLine = __webpack_require__(1256);
	var keyCommandBackspaceWord = __webpack_require__(1257);
	var keyCommandDeleteWord = __webpack_require__(1258);
	var keyCommandInsertNewline = __webpack_require__(1259);
	var keyCommandMoveSelectionToEndOfBlock = __webpack_require__(1260);
	var keyCommandMoveSelectionToStartOfBlock = __webpack_require__(1261);
	var keyCommandPlainBackspace = __webpack_require__(1262);
	var keyCommandPlainDelete = __webpack_require__(1263);
	var keyCommandTransposeCharacters = __webpack_require__(1264);
	var keyCommandUndo = __webpack_require__(1265);
	
	var isOptionKeyCommand = KeyBindingUtil.isOptionKeyCommand;
	
	var isChrome = UserAgent.isBrowser('Chrome');
	
	/**
	 * Map a `DraftEditorCommand` command value to a corresponding function.
	 */
	function onKeyCommand(command, editorState) {
	  switch (command) {
	    case 'redo':
	      return EditorState.redo(editorState);
	    case 'delete':
	      return keyCommandPlainDelete(editorState);
	    case 'delete-word':
	      return keyCommandDeleteWord(editorState);
	    case 'backspace':
	      return keyCommandPlainBackspace(editorState);
	    case 'backspace-word':
	      return keyCommandBackspaceWord(editorState);
	    case 'backspace-to-start-of-line':
	      return keyCommandBackspaceToStartOfLine(editorState);
	    case 'split-block':
	      return keyCommandInsertNewline(editorState);
	    case 'transpose-characters':
	      return keyCommandTransposeCharacters(editorState);
	    case 'move-selection-to-start-of-block':
	      return keyCommandMoveSelectionToStartOfBlock(editorState);
	    case 'move-selection-to-end-of-block':
	      return keyCommandMoveSelectionToEndOfBlock(editorState);
	    case 'secondary-cut':
	      return SecondaryClipboard.cut(editorState);
	    case 'secondary-paste':
	      return SecondaryClipboard.paste(editorState);
	    default:
	      return editorState;
	  }
	}
	
	/**
	 * Intercept keydown behavior to handle keys and commands manually, if desired.
	 *
	 * Keydown combinations may be mapped to `DraftCommand` values, which may
	 * correspond to command functions that modify the editor or its contents.
	 *
	 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
	 * component may provide a custom mapping via the `keyBindingFn` prop.
	 */
	function editOnKeyDown(editor, e) {
	  var keyCode = e.which;
	  var editorState = editor._latestEditorState;
	
	  switch (keyCode) {
	    case Keys.RETURN:
	      e.preventDefault();
	      // The top-level component may manually handle newline insertion. If
	      // no special handling is performed, fall through to command handling.
	      if (editor.props.handleReturn && isEventHandled(editor.props.handleReturn(e, editorState))) {
	        return;
	      }
	      break;
	    case Keys.ESC:
	      e.preventDefault();
	      editor.props.onEscape && editor.props.onEscape(e);
	      return;
	    case Keys.TAB:
	      editor.props.onTab && editor.props.onTab(e);
	      return;
	    case Keys.UP:
	      editor.props.onUpArrow && editor.props.onUpArrow(e);
	      return;
	    case Keys.RIGHT:
	      editor.props.onRightArrow && editor.props.onRightArrow(e);
	      return;
	    case Keys.DOWN:
	      editor.props.onDownArrow && editor.props.onDownArrow(e);
	      return;
	    case Keys.LEFT:
	      editor.props.onLeftArrow && editor.props.onLeftArrow(e);
	      return;
	    case Keys.SPACE:
	      // Handling for OSX where option + space scrolls.
	      if (isChrome && isOptionKeyCommand(e)) {
	        e.preventDefault();
	        // Insert a nbsp into the editor.
	        var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), '\xA0');
	        editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
	        return;
	      }
	  }
	
	  var command = editor.props.keyBindingFn(e);
	
	  // If no command is specified, allow keydown event to continue.
	  if (!command) {
	    return;
	  }
	
	  if (command === 'undo') {
	    // Since undo requires some special updating behavior to keep the editor
	    // in sync, handle it separately.
	    keyCommandUndo(e, editorState, editor.update);
	    return;
	  }
	
	  // At this point, we know that we're handling a command of some kind, so
	  // we don't want to insert a character following the keydown.
	  e.preventDefault();
	
	  // Allow components higher up the tree to handle the command first.
	  if (editor.props.handleKeyCommand && isEventHandled(editor.props.handleKeyCommand(command, editorState))) {
	    return;
	  }
	
	  var newState = onKeyCommand(command, editorState);
	  if (newState !== editorState) {
	    editor.update(newState);
	  }
	}
	
	module.exports = editOnKeyDown;

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnPaste
	 * @format
	 * 
	 */
	
	'use strict';
	
	var BlockMapBuilder = __webpack_require__(271);
	var CharacterMetadata = __webpack_require__(112);
	var DataTransfer = __webpack_require__(669);
	var DraftModifier = __webpack_require__(104);
	var DraftPasteProcessor = __webpack_require__(1222);
	var EditorState = __webpack_require__(71);
	var RichTextEditorUtil = __webpack_require__(648);
	
	var getEntityKeyForSelection = __webpack_require__(449);
	var getTextContentFromFiles = __webpack_require__(657);
	var isEventHandled = __webpack_require__(273);
	var splitTextIntoTextBlocks = __webpack_require__(1271);
	
	/**
	 * Paste content.
	 */
	function editOnPaste(editor, e) {
	  e.preventDefault();
	  var data = new DataTransfer(e.clipboardData);
	
	  // Get files, unless this is likely to be a string the user wants inline.
	  if (!data.isRichText()) {
	    var files = data.getFiles();
	    var defaultFileText = data.getText();
	    if (files.length > 0) {
	      // Allow customized paste handling for images, etc. Otherwise, fall
	      // through to insert text contents into the editor.
	      if (editor.props.handlePastedFiles && isEventHandled(editor.props.handlePastedFiles(files))) {
	        return;
	      }
	
	      getTextContentFromFiles(files, function ( /*string*/fileText) {
	        fileText = fileText || defaultFileText;
	        if (!fileText) {
	          return;
	        }
	
	        var editorState = editor._latestEditorState;
	        var blocks = splitTextIntoTextBlocks(fileText);
	        var character = CharacterMetadata.create({
	          style: editorState.getCurrentInlineStyle(),
	          entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
	        });
	        var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);
	
	        var text = DraftPasteProcessor.processText(blocks, character, currentBlockType);
	        var fragment = BlockMapBuilder.createFromArray(text);
	
	        var withInsertedText = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
	
	        editor.update(EditorState.push(editorState, withInsertedText, 'insert-fragment'));
	      });
	
	      return;
	    }
	  }
	
	  var textBlocks = [];
	  var text = data.getText();
	  var html = data.getHTML();
	  var editorState = editor._latestEditorState;
	
	  if (editor.props.handlePastedText && isEventHandled(editor.props.handlePastedText(text, html, editorState))) {
	    return;
	  }
	
	  if (text) {
	    textBlocks = splitTextIntoTextBlocks(text);
	  }
	
	  if (!editor.props.stripPastedStyles) {
	    // If the text from the paste event is rich content that matches what we
	    // already have on the internal clipboard, assume that we should just use
	    // the clipboard fragment for the paste. This will allow us to preserve
	    // styling and entities, if any are present. Note that newlines are
	    // stripped during comparison -- this is because copy/paste within the
	    // editor in Firefox and IE will not include empty lines. The resulting
	    // paste will preserve the newlines correctly.
	    var internalClipboard = editor.getClipboard();
	    if (data.isRichText() && internalClipboard) {
	      if (
	      // If the editorKey is present in the pasted HTML, it should be safe to
	      // assume this is an internal paste.
	      html.indexOf(editor.getEditorKey()) !== -1 ||
	      // The copy may have been made within a single block, in which case the
	      // editor key won't be part of the paste. In this case, just check
	      // whether the pasted text matches the internal clipboard.
	      textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
	        editor.update(insertFragment(editor._latestEditorState, internalClipboard));
	        return;
	      }
	    } else if (internalClipboard && data.types.includes('com.apple.webarchive') && !data.types.includes('text/html') && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
	      // Safari does not properly store text/html in some cases.
	      // Use the internalClipboard if present and equal to what is on
	      // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
	      editor.update(insertFragment(editor._latestEditorState, internalClipboard));
	      return;
	    }
	
	    // If there is html paste data, try to parse that.
	    if (html) {
	      var htmlFragment = DraftPasteProcessor.processHTML(html, editor.props.blockRenderMap);
	      if (htmlFragment) {
	        var contentBlocks = htmlFragment.contentBlocks,
	            entityMap = htmlFragment.entityMap;
	
	        if (contentBlocks) {
	          var htmlMap = BlockMapBuilder.createFromArray(contentBlocks);
	          editor.update(insertFragment(editor._latestEditorState, htmlMap, entityMap));
	          return;
	        }
	      }
	    }
	
	    // Otherwise, create a new fragment from our pasted text. Also
	    // empty the internal clipboard, since it's no longer valid.
	    editor.setClipboard(null);
	  }
	
	  if (textBlocks.length) {
	    var character = CharacterMetadata.create({
	      style: editorState.getCurrentInlineStyle(),
	      entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
	    });
	
	    var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);
	
	    var textFragment = DraftPasteProcessor.processText(textBlocks, character, currentBlockType);
	
	    var textMap = BlockMapBuilder.createFromArray(textFragment);
	    editor.update(insertFragment(editor._latestEditorState, textMap));
	  }
	}
	
	function insertFragment(editorState, fragment, entityMap) {
	  var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
	  // TODO: merge the entity map once we stop using DraftEntity
	  // like this:
	  // const mergedEntityMap = newContent.getEntityMap().merge(entityMap);
	
	  return EditorState.push(editorState, newContent.set('entityMap', entityMap), 'insert-fragment');
	}
	
	function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
	  return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function (block, ii) {
	    return block.getText() === textBlocks[ii];
	  });
	}
	
	module.exports = editOnPaste;

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnSelect
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(71);
	var ReactDOM = __webpack_require__(31);
	
	var getDraftEditorSelection = __webpack_require__(1250);
	var invariant = __webpack_require__(28);
	
	function editOnSelect(editor) {
	  if (editor._blockSelectEvents || editor._latestEditorState !== editor.props.editorState) {
	    return;
	  }
	
	  var editorState = editor.props.editorState;
	  var editorNode = ReactDOM.findDOMNode(editor.editorContainer);
	  !editorNode ?  false ? invariant(false, 'Missing editorNode') : invariant(false) : void 0;
	  !(editorNode.firstChild instanceof HTMLElement) ?  false ? invariant(false, 'editorNode.firstChild is not an HTMLElement') : invariant(false) : void 0;
	  var documentSelection = getDraftEditorSelection(editorState, editorNode.firstChild);
	  var updatedSelectionState = documentSelection.selectionState;
	
	  if (updatedSelectionState !== editorState.getSelection()) {
	    if (documentSelection.needsRecovery) {
	      editorState = EditorState.forceSelection(editorState, updatedSelectionState);
	    } else {
	      editorState = EditorState.acceptSelection(editorState, updatedSelectionState);
	    }
	    editor.update(editorState);
	  }
	}
	
	module.exports = editOnSelect;

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule encodeEntityRanges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftStringKey = __webpack_require__(647);
	var UnicodeUtils = __webpack_require__(204);
	
	var strlen = UnicodeUtils.strlen;
	
	/**
	 * Convert to UTF-8 character counts for storage.
	 */
	
	function encodeEntityRanges(block, storageMap) {
	  var encoded = [];
	  block.findEntityRanges(function (character) {
	    return !!character.getEntity();
	  }, function ( /*number*/start, /*number*/end) {
	    var text = block.getText();
	    var key = block.getEntityAt(start);
	    encoded.push({
	      offset: strlen(text.slice(0, start)),
	      length: strlen(text.slice(start, end)),
	      // Encode the key as a number for range storage.
	      key: Number(storageMap[DraftStringKey.stringify(key)])
	    });
	  });
	  return encoded;
	}
	
	module.exports = encodeEntityRanges;

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule encodeInlineStyleRanges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UnicodeUtils = __webpack_require__(204);
	
	var findRangesImmutable = __webpack_require__(272);
	
	var areEqual = function areEqual(a, b) {
	  return a === b;
	};
	var isTruthy = function isTruthy(a) {
	  return !!a;
	};
	var EMPTY_ARRAY = [];
	
	/**
	 * Helper function for getting encoded styles for each inline style. Convert
	 * to UTF-8 character counts for storage.
	 */
	function getEncodedInlinesForType(block, styleList, styleToEncode) {
	  var ranges = [];
	
	  // Obtain an array with ranges for only the specified style.
	  var filteredInlines = styleList.map(function (style) {
	    return style.has(styleToEncode);
	  }).toList();
	
	  findRangesImmutable(filteredInlines, areEqual,
	  // We only want to keep ranges with nonzero style values.
	  isTruthy, function (start, end) {
	    var text = block.getText();
	    ranges.push({
	      offset: UnicodeUtils.strlen(text.slice(0, start)),
	      length: UnicodeUtils.strlen(text.slice(start, end)),
	      style: styleToEncode
	    });
	  });
	
	  return ranges;
	}
	
	/*
	 * Retrieve the encoded arrays of inline styles, with each individual style
	 * treated separately.
	 */
	function encodeInlineStyleRanges(block) {
	  var styleList = block.getCharacterList().map(function (c) {
	    return c.getStyle();
	  }).toList();
	  var ranges = styleList.flatten().toSet().map(function (style) {
	    return getEncodedInlinesForType(block, styleList, style);
	  });
	
	  return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
	}
	
	module.exports = encodeInlineStyleRanges;

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule expandRangeToStartOfLine
	 * @format
	 * 
	 */
	
	var UnicodeUtils = __webpack_require__(204);
	
	var getRangeClientRects = __webpack_require__(654);
	var invariant = __webpack_require__(28);
	
	/**
	 * Return the computed line height, in pixels, for the provided element.
	 */
	function getLineHeightPx(element) {
	  var computed = getComputedStyle(element);
	  var div = document.createElement('div');
	  div.style.fontFamily = computed.fontFamily;
	  div.style.fontSize = computed.fontSize;
	  div.style.fontStyle = computed.fontStyle;
	  div.style.fontWeight = computed.fontWeight;
	  div.style.lineHeight = computed.lineHeight;
	  div.style.position = 'absolute';
	  div.textContent = 'M';
	
	  var documentBody = document.body;
	  !documentBody ?  false ? invariant(false, 'Missing document.body') : invariant(false) : void 0;
	
	  // forced layout here
	  documentBody.appendChild(div);
	  var rect = div.getBoundingClientRect();
	  documentBody.removeChild(div);
	
	  return rect.height;
	}
	
	/**
	 * Return whether every ClientRect in the provided list lies on the same line.
	 *
	 * We assume that the rects on the same line all contain the baseline, so the
	 * lowest top line needs to be above the highest bottom line (i.e., if you were
	 * to project the rects onto the y-axis, their intersection would be nonempty).
	 *
	 * In addition, we require that no two boxes are lineHeight (or more) apart at
	 * either top or bottom, which helps protect against false positives for fonts
	 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
	 * produces rects of height 58px!).
	 */
	function areRectsOnOneLine(rects, lineHeight) {
	  var minTop = Infinity;
	  var minBottom = Infinity;
	  var maxTop = -Infinity;
	  var maxBottom = -Infinity;
	
	  for (var ii = 0; ii < rects.length; ii++) {
	    var rect = rects[ii];
	    if (rect.width === 0 || rect.width === 1) {
	      // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
	      // Safari) include an empty rect on the previous or next line. When the
	      // text lies in a container whose position is not integral (e.g., from
	      // margin: auto), Safari makes these empty rects have width 1 (instead of
	      // 0). Having one-pixel-wide characters seems unlikely (and most browsers
	      // report widths in subpixel precision anyway) so it's relatively safe to
	      // skip over them.
	      continue;
	    }
	    minTop = Math.min(minTop, rect.top);
	    minBottom = Math.min(minBottom, rect.bottom);
	    maxTop = Math.max(maxTop, rect.top);
	    maxBottom = Math.max(maxBottom, rect.bottom);
	  }
	
	  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
	}
	
	/**
	 * Return the length of a node, as used by Range offsets.
	 */
	function getNodeLength(node) {
	  // http://www.w3.org/TR/dom/#concept-node-length
	  switch (node.nodeType) {
	    case Node.DOCUMENT_TYPE_NODE:
	      return 0;
	    case Node.TEXT_NODE:
	    case Node.PROCESSING_INSTRUCTION_NODE:
	    case Node.COMMENT_NODE:
	      return node.length;
	    default:
	      return node.childNodes.length;
	  }
	}
	
	/**
	 * Given a collapsed range, move the start position backwards as far as
	 * possible while the range still spans only a single line.
	 */
	function expandRangeToStartOfLine(range) {
	  !range.collapsed ?  false ? invariant(false, 'expandRangeToStartOfLine: Provided range is not collapsed.') : invariant(false) : void 0;
	  range = range.cloneRange();
	
	  var containingElement = range.startContainer;
	  if (containingElement.nodeType !== 1) {
	    containingElement = containingElement.parentNode;
	  }
	  var lineHeight = getLineHeightPx(containingElement);
	
	  // Imagine our text looks like:
	  //   <div><span>once upon a time, there was a <em>boy
	  //   who lived</em> </span><q><strong>under^ the
	  //   stairs</strong> in a small closet.</q></div>
	  // where the caret represents the cursor. First, we crawl up the tree until
	  // the range spans multiple lines (setting the start point to before
	  // "<strong>", then before "<div>"), then at each level we do a search to
	  // find the latest point which is still on a previous line. We'll find that
	  // the break point is inside the span, then inside the <em>, then in its text
	  // node child, the actual break point before "who".
	
	  var bestContainer = range.endContainer;
	  var bestOffset = range.endOffset;
	  range.setStart(range.startContainer, 0);
	
	  while (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
	    bestContainer = range.startContainer;
	    bestOffset = range.startOffset;
	    !bestContainer.parentNode ?  false ? invariant(false, 'Found unexpected detached subtree when traversing.') : invariant(false) : void 0;
	    range.setStartBefore(bestContainer);
	    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
	      // The start of the line is never in a different block-level container.
	      break;
	    }
	  }
	
	  // In the above example, range now spans from "<div>" to "under",
	  // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
	  // Picking out which child to recurse into here is a special case since we
	  // don't want to check past <q> -- once we find that the final range starts
	  // in <span>, we can look at all of its children (and all of their children)
	  // to find the break point.
	
	  // At all times, (bestContainer, bestOffset) is the latest single-line start
	  // point that we know of.
	  var currentContainer = bestContainer;
	  var maxIndexToConsider = bestOffset - 1;
	
	  do {
	    var nodeValue = currentContainer.nodeValue;
	
	    for (var ii = maxIndexToConsider; ii >= 0; ii--) {
	      if (nodeValue != null && ii > 0 && UnicodeUtils.isSurrogatePair(nodeValue, ii - 1)) {
	        // We're in the middle of a surrogate pair -- skip over so we never
	        // return a range with an endpoint in the middle of a code point.
	        continue;
	      }
	
	      range.setStart(currentContainer, ii);
	      if (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
	        bestContainer = currentContainer;
	        bestOffset = ii;
	      } else {
	        break;
	      }
	    }
	
	    if (ii === -1 || currentContainer.childNodes.length === 0) {
	      // If ii === -1, then (bestContainer, bestOffset), which is equal to
	      // (currentContainer, 0), was a single-line start point but a start
	      // point before currentContainer wasn't, so the line break seems to
	      // have occurred immediately after currentContainer's start tag
	      //
	      // If currentContainer.childNodes.length === 0, we're already at a
	      // terminal node (e.g., text node) and should return our current best.
	      break;
	    }
	
	    currentContainer = currentContainer.childNodes[ii];
	    maxIndexToConsider = getNodeLength(currentContainer);
	  } while (true);
	
	  range.setStart(bestContainer, bestOffset);
	  return range;
	}
	
	module.exports = expandRangeToStartOfLine;

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getCharacterRemovalRange
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftEntitySegments = __webpack_require__(1219);
	
	var getRangesForDraftEntity = __webpack_require__(1252);
	var invariant = __webpack_require__(28);
	
	/**
	 * Given a SelectionState and a removal direction, determine the entire range
	 * that should be removed from a ContentState. This is based on any entities
	 * within the target, with their `mutability` values taken into account.
	 *
	 * For instance, if we are attempting to remove part of an "immutable" entity
	 * range, the entire entity must be removed. The returned `SelectionState`
	 * will be adjusted accordingly.
	 */
	function getCharacterRemovalRange(entityMap, startBlock, endBlock, selectionState, direction) {
	  var start = selectionState.getStartOffset();
	  var end = selectionState.getEndOffset();
	  var startEntityKey = startBlock.getEntityAt(start);
	  var endEntityKey = endBlock.getEntityAt(end - 1);
	  if (!startEntityKey && !endEntityKey) {
	    return selectionState;
	  }
	  var newSelectionState = selectionState;
	  if (startEntityKey && startEntityKey === endEntityKey) {
	    newSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, true, true);
	  } else if (startEntityKey && endEntityKey) {
	    var startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
	    var endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
	    newSelectionState = newSelectionState.merge({
	      anchorOffset: startSelectionState.getAnchorOffset(),
	      focusOffset: endSelectionState.getFocusOffset(),
	      isBackward: false
	    });
	  } else if (startEntityKey) {
	    var _startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
	    newSelectionState = newSelectionState.merge({
	      anchorOffset: _startSelectionState.getStartOffset(),
	      isBackward: false
	    });
	  } else if (endEntityKey) {
	    var _endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
	    newSelectionState = newSelectionState.merge({
	      focusOffset: _endSelectionState.getEndOffset(),
	      isBackward: false
	    });
	  }
	  return newSelectionState;
	}
	
	function getEntityRemovalRange(entityMap, block, selectionState, direction, entityKey, isEntireSelectionWithinEntity, isEntityAtStart) {
	  var start = selectionState.getStartOffset();
	  var end = selectionState.getEndOffset();
	  var entity = entityMap.__get(entityKey);
	  var mutability = entity.getMutability();
	  var sideToConsider = isEntityAtStart ? start : end;
	
	  // `MUTABLE` entities can just have the specified range of text removed
	  // directly. No adjustments are needed.
	  if (mutability === 'MUTABLE') {
	    return selectionState;
	  }
	
	  // Find the entity range that overlaps with our removal range.
	  var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function (range) {
	    return sideToConsider <= range.end && sideToConsider >= range.start;
	  });
	
	  !(entityRanges.length == 1) ?  false ? invariant(false, 'There should only be one entity range within this removal range.') : invariant(false) : void 0;
	
	  var entityRange = entityRanges[0];
	
	  // For `IMMUTABLE` entity types, we will remove the entire entity range.
	  if (mutability === 'IMMUTABLE') {
	    return selectionState.merge({
	      anchorOffset: entityRange.start,
	      focusOffset: entityRange.end,
	      isBackward: false
	    });
	  }
	
	  // For `SEGMENTED` entity types, determine the appropriate segment to
	  // remove.
	  if (!isEntireSelectionWithinEntity) {
	    if (isEntityAtStart) {
	      end = entityRange.end;
	    } else {
	      start = entityRange.start;
	    }
	  }
	
	  var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);
	
	  return selectionState.merge({
	    anchorOffset: removalRange.start,
	    focusOffset: removalRange.end,
	    isBackward: false
	  });
	}
	
	module.exports = getCharacterRemovalRange;

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDraftEditorSelection
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getDraftEditorSelectionWithNodes = __webpack_require__(651);
	
	/**
	 * Convert the current selection range to an anchor/focus pair of offset keys
	 * and values that can be interpreted by components.
	 */
	function getDraftEditorSelection(editorState, root) {
	  var selection = global.getSelection();
	
	  // No active selection.
	  if (selection.rangeCount === 0) {
	    return {
	      selectionState: editorState.getSelection().set('hasFocus', false),
	      needsRecovery: false
	    };
	  }
	
	  return getDraftEditorSelectionWithNodes(editorState, root, selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	}
	
	module.exports = getDraftEditorSelection;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangeBoundingClientRect
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getRangeClientRects = __webpack_require__(654);
	
	/**
	 * Like range.getBoundingClientRect() but normalizes for browser bugs.
	 */
	function getRangeBoundingClientRect(range) {
	  // "Return a DOMRect object describing the smallest rectangle that includes
	  // the first rectangle in list and all of the remaining rectangles of which
	  // the height or width is not zero."
	  // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
	  var rects = getRangeClientRects(range);
	  var top = 0;
	  var right = 0;
	  var bottom = 0;
	  var left = 0;
	
	  if (rects.length) {
	    // If the first rectangle has 0 width, we use the second, this is needed
	    // because Chrome renders a 0 width rectangle when the selection contains
	    // a line break.
	    if (rects.length > 1 && rects[0].width === 0) {
	      var _rects$ = rects[1];
	      top = _rects$.top;
	      right = _rects$.right;
	      bottom = _rects$.bottom;
	      left = _rects$.left;
	    } else {
	      var _rects$2 = rects[0];
	      top = _rects$2.top;
	      right = _rects$2.right;
	      bottom = _rects$2.bottom;
	      left = _rects$2.left;
	    }
	
	    for (var ii = 1; ii < rects.length; ii++) {
	      var rect = rects[ii];
	      if (rect.height !== 0 && rect.width !== 0) {
	        top = Math.min(top, rect.top);
	        right = Math.max(right, rect.right);
	        bottom = Math.max(bottom, rect.bottom);
	        left = Math.min(left, rect.left);
	      }
	    }
	  }
	
	  return {
	    top: top,
	    right: right,
	    bottom: bottom,
	    left: left,
	    width: right - left,
	    height: bottom - top
	  };
	}
	
	module.exports = getRangeBoundingClientRect;

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangesForDraftEntity
	 * @format
	 * 
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(28);
	
	/**
	 * Obtain the start and end positions of the range that has the
	 * specified entity applied to it.
	 *
	 * Entity keys are applied only to contiguous stretches of text, so this
	 * method searches for the first instance of the entity key and returns
	 * the subsequent range.
	 */
	function getRangesForDraftEntity(block, key) {
	  var ranges = [];
	  block.findEntityRanges(function (c) {
	    return c.getEntity() === key;
	  }, function (start, end) {
	    ranges.push({ start: start, end: end });
	  });
	
	  !!!ranges.length ?  false ? invariant(false, 'Entity key not found in this range.') : invariant(false) : void 0;
	
	  return ranges;
	}
	
	module.exports = getRangesForDraftEntity;

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVisibleSelectionRect
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getRangeBoundingClientRect = __webpack_require__(1251);
	
	/**
	 * Return the bounding ClientRect for the visible DOM selection, if any.
	 * In cases where there are no selected ranges or the bounding rect is
	 * temporarily invalid, return null.
	 */
	function getVisibleSelectionRect(global) {
	  var selection = global.getSelection();
	  if (!selection.rangeCount) {
	    return null;
	  }
	
	  var range = selection.getRangeAt(0);
	  var boundingRect = getRangeBoundingClientRect(range);
	  var top = boundingRect.top,
	      right = boundingRect.right,
	      bottom = boundingRect.bottom,
	      left = boundingRect.left;
	
	  // When a re-render leads to a node being removed, the DOM selection will
	  // temporarily be placed on an ancestor node, which leads to an invalid
	  // bounding rect. Discard this state.
	
	  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
	    return null;
	  }
	
	  return boundingRect;
	}
	
	module.exports = getVisibleSelectionRect;

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertFragmentIntoContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var BlockMapBuilder = __webpack_require__(271);
	var ContentBlockNode = __webpack_require__(123);
	var Immutable = __webpack_require__(60);
	
	var insertIntoList = __webpack_require__(659);
	var invariant = __webpack_require__(28);
	var randomizeBlockMapKeys = __webpack_require__(662);
	
	var List = Immutable.List;
	
	
	var updateExistingBlock = function updateExistingBlock(contentState, selectionState, blockMap, fragmentBlock, targetKey, targetOffset) {
	  var targetBlock = blockMap.get(targetKey);
	  var text = targetBlock.getText();
	  var chars = targetBlock.getCharacterList();
	  var finalKey = targetKey;
	  var finalOffset = targetOffset + fragmentBlock.getText().length;
	
	  var newBlock = targetBlock.merge({
	    text: text.slice(0, targetOffset) + fragmentBlock.getText() + text.slice(targetOffset),
	    characterList: insertIntoList(chars, fragmentBlock.getCharacterList(), targetOffset),
	    data: fragmentBlock.getData()
	  });
	
	  return contentState.merge({
	    blockMap: blockMap.set(targetKey, newBlock),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: finalKey,
	      anchorOffset: finalOffset,
	      focusKey: finalKey,
	      focusOffset: finalOffset,
	      isBackward: false
	    })
	  });
	};
	
	/**
	 * Appends text/characterList from the fragment first block to
	 * target block.
	 */
	var updateHead = function updateHead(block, targetOffset, fragment) {
	  var text = block.getText();
	  var chars = block.getCharacterList();
	
	  // Modify head portion of block.
	  var headText = text.slice(0, targetOffset);
	  var headCharacters = chars.slice(0, targetOffset);
	  var appendToHead = fragment.first();
	
	  return block.merge({
	    text: headText + appendToHead.getText(),
	    characterList: headCharacters.concat(appendToHead.getCharacterList()),
	    type: headText ? block.getType() : appendToHead.getType(),
	    data: appendToHead.getData()
	  });
	};
	
	/**
	 * Appends offset text/characterList from the target block to the last
	 * fragment block.
	 */
	var updateTail = function updateTail(block, targetOffset, fragment) {
	  // Modify tail portion of block.
	  var text = block.getText();
	  var chars = block.getCharacterList();
	
	  // Modify head portion of block.
	  var blockSize = text.length;
	  var tailText = text.slice(targetOffset, blockSize);
	  var tailCharacters = chars.slice(targetOffset, blockSize);
	  var prependToTail = fragment.last();
	
	  return prependToTail.merge({
	    text: prependToTail.getText() + tailText,
	    characterList: prependToTail.getCharacterList().concat(tailCharacters),
	    data: prependToTail.getData()
	  });
	};
	
	var getRootBlocks = function getRootBlocks(block, blockMap) {
	  var headKey = block.getKey();
	  var rootBlock = block;
	  var rootBlocks = [];
	
	  // sometimes the fragment head block will not be part of the blockMap itself this can happen when
	  // the fragment head is used to update the target block, however when this does not happen we need
	  // to make sure that we include it on the rootBlocks since the first block of a fragment is always a
	  // fragment root block
	  if (blockMap.get(headKey)) {
	    rootBlocks.push(headKey);
	  }
	
	  while (rootBlock && rootBlock.getNextSiblingKey()) {
	    var lastSiblingKey = rootBlock.getNextSiblingKey();
	
	    if (!lastSiblingKey) {
	      break;
	    }
	
	    rootBlocks.push(lastSiblingKey);
	    rootBlock = blockMap.get(lastSiblingKey);
	  }
	
	  return rootBlocks;
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockMap, targetBlock, fragmentHeadBlock) {
	  return blockMap.withMutations(function (blockMapState) {
	    var targetKey = targetBlock.getKey();
	    var headKey = fragmentHeadBlock.getKey();
	    var targetNextKey = targetBlock.getNextSiblingKey();
	    var targetParentKey = targetBlock.getParentKey();
	    var fragmentRootBlocks = getRootBlocks(fragmentHeadBlock, blockMap);
	    var lastRootFragmentBlockKey = fragmentRootBlocks[fragmentRootBlocks.length - 1];
	
	    if (blockMapState.get(headKey)) {
	      // update the fragment head when it is part of the blockMap otherwise
	      blockMapState.setIn([targetKey, 'nextSibling'], headKey);
	      blockMapState.setIn([headKey, 'prevSibling'], targetKey);
	    } else {
	      // update the target block that had the fragment head contents merged into it
	      blockMapState.setIn([targetKey, 'nextSibling'], fragmentHeadBlock.getNextSiblingKey());
	      blockMapState.setIn([fragmentHeadBlock.getNextSiblingKey(), 'prevSibling'], targetKey);
	    }
	
	    // update the last root block fragment
	    blockMapState.setIn([lastRootFragmentBlockKey, 'nextSibling'], targetNextKey);
	
	    // update the original target next block
	    if (targetNextKey) {
	      blockMapState.setIn([targetNextKey, 'prevSibling'], lastRootFragmentBlockKey);
	    }
	
	    // update fragment parent links
	    fragmentRootBlocks.forEach(function (blockKey) {
	      return blockMapState.setIn([blockKey, 'parent'], targetParentKey);
	    });
	
	    // update targetBlock parent child links
	    if (targetParentKey) {
	      var targetParent = blockMap.get(targetParentKey);
	      var originalTargetParentChildKeys = targetParent.getChildKeys();
	
	      var targetBlockIndex = originalTargetParentChildKeys.indexOf(targetKey);
	      var insertionIndex = targetBlockIndex + 1;
	
	      var newChildrenKeysArray = originalTargetParentChildKeys.toArray();
	
	      // insert fragment children
	      newChildrenKeysArray.splice.apply(newChildrenKeysArray, [insertionIndex, 0].concat(fragmentRootBlocks));
	
	      blockMapState.setIn([targetParentKey, 'children'], List(newChildrenKeysArray));
	    }
	  });
	};
	
	var insertFragment = function insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset) {
	  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;
	  var newBlockArr = [];
	  var fragmentSize = fragment.size;
	  var target = blockMap.get(targetKey);
	  var head = fragment.first();
	  var tail = fragment.last();
	  var finalOffset = tail.getLength();
	  var finalKey = tail.getKey();
	  var shouldNotUpdateFromFragmentBlock = isTreeBasedBlockMap && (!target.getChildKeys().isEmpty() || !head.getChildKeys().isEmpty());
	
	  blockMap.forEach(function (block, blockKey) {
	    if (blockKey !== targetKey) {
	      newBlockArr.push(block);
	      return;
	    }
	
	    if (shouldNotUpdateFromFragmentBlock) {
	      newBlockArr.push(block);
	    } else {
	      newBlockArr.push(updateHead(block, targetOffset, fragment));
	    }
	
	    // Insert fragment blocks after the head and before the tail.
	    fragment
	    // when we are updating the target block with the head fragment block we skip the first fragment
	    // head since its contents have already been merged with the target block otherwise we include
	    // the whole fragment
	    .slice(shouldNotUpdateFromFragmentBlock ? 0 : 1, fragmentSize - 1).forEach(function (fragmentBlock) {
	      return newBlockArr.push(fragmentBlock);
	    });
	
	    // update tail
	    newBlockArr.push(updateTail(block, targetOffset, fragment));
	  });
	
	  var updatedBlockMap = BlockMapBuilder.createFromArray(newBlockArr);
	
	  if (isTreeBasedBlockMap) {
	    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, blockMap, target, head);
	  }
	
	  return contentState.merge({
	    blockMap: updatedBlockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: finalKey,
	      anchorOffset: finalOffset,
	      focusKey: finalKey,
	      focusOffset: finalOffset,
	      isBackward: false
	    })
	  });
	};
	
	var insertFragmentIntoContentState = function insertFragmentIntoContentState(contentState, selectionState, fragmentBlockMap) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertFragment` should only be called with a collapsed selection state.') : invariant(false) : void 0;
	
	  var blockMap = contentState.getBlockMap();
	  var fragment = randomizeBlockMapKeys(fragmentBlockMap);
	  var targetKey = selectionState.getStartKey();
	  var targetOffset = selectionState.getStartOffset();
	
	  var targetBlock = blockMap.get(targetKey);
	
	  if (targetBlock instanceof ContentBlockNode) {
	    !targetBlock.getChildKeys().isEmpty() ?  false ? invariant(false, '`insertFragment` should not be called when a container node is selected.') : invariant(false) : void 0;
	  }
	
	  // When we insert a fragment with a single block we simply update the target block
	  // with the contents of the inserted fragment block
	  if (fragment.size === 1) {
	    return updateExistingBlock(contentState, selectionState, blockMap, fragment.first(), targetKey, targetOffset);
	  }
	
	  return insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset);
	};
	
	module.exports = insertFragmentIntoContentState;

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertTextIntoContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(60);
	
	var insertIntoList = __webpack_require__(659);
	var invariant = __webpack_require__(28);
	
	var Repeat = Immutable.Repeat;
	
	
	function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertText` should only be called with a collapsed range.') : invariant(false) : void 0;
	
	  var len = text.length;
	  if (!len) {
	    return contentState;
	  }
	
	  var blockMap = contentState.getBlockMap();
	  var key = selectionState.getStartKey();
	  var offset = selectionState.getStartOffset();
	  var block = blockMap.get(key);
	  var blockText = block.getText();
	
	  var newBlock = block.merge({
	    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
	    characterList: insertIntoList(block.getCharacterList(), Repeat(characterMetadata, len).toList(), offset)
	  });
	
	  var newOffset = offset + len;
	
	  return contentState.merge({
	    blockMap: blockMap.set(key, newBlock),
	    selectionAfter: selectionState.merge({
	      anchorOffset: newOffset,
	      focusOffset: newOffset
	    })
	  });
	}
	
	module.exports = insertTextIntoContentState;

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandBackspaceToStartOfLine
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(71);
	
	var expandRangeToStartOfLine = __webpack_require__(1248);
	var getDraftEditorSelectionWithNodes = __webpack_require__(651);
	var moveSelectionBackward = __webpack_require__(450);
	var removeTextWithStrategy = __webpack_require__(274);
	
	function keyCommandBackspaceToStartOfLine(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
	      return moveSelectionBackward(strategyState, 1);
	    }
	
	    var domSelection = global.getSelection();
	    var range = domSelection.getRangeAt(0);
	    range = expandRangeToStartOfLine(range);
	
	    return getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandBackspaceToStartOfLine;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandBackspaceWord
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftRemovableWord = __webpack_require__(646);
	var EditorState = __webpack_require__(71);
	
	var moveSelectionBackward = __webpack_require__(450);
	var removeTextWithStrategy = __webpack_require__(274);
	
	/**
	 * Delete the word that is left of the cursor, as well as any spaces or
	 * punctuation after the word.
	 */
	function keyCommandBackspaceWord(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var offset = selection.getStartOffset();
	    // If there are no words before the cursor, remove the preceding newline.
	    if (offset === 0) {
	      return moveSelectionBackward(strategyState, 1);
	    }
	    var key = selection.getStartKey();
	    var content = strategyState.getCurrentContent();
	    var text = content.getBlockForKey(key).getText().slice(0, offset);
	    var toRemove = DraftRemovableWord.getBackward(text);
	    return moveSelectionBackward(strategyState, toRemove.length || 1);
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandBackspaceWord;

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandDeleteWord
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftRemovableWord = __webpack_require__(646);
	var EditorState = __webpack_require__(71);
	
	var moveSelectionForward = __webpack_require__(661);
	var removeTextWithStrategy = __webpack_require__(274);
	
	/**
	 * Delete the word that is right of the cursor, as well as any spaces or
	 * punctuation before the word.
	 */
	function keyCommandDeleteWord(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var offset = selection.getStartOffset();
	    var key = selection.getStartKey();
	    var content = strategyState.getCurrentContent();
	    var text = content.getBlockForKey(key).getText().slice(offset);
	    var toRemove = DraftRemovableWord.getForward(text);
	
	    // If there are no words in front of the cursor, remove the newline.
	    return moveSelectionForward(strategyState, toRemove.length || 1);
	  }, 'forward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandDeleteWord;

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandInsertNewline
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(104);
	var EditorState = __webpack_require__(71);
	
	function keyCommandInsertNewline(editorState) {
	  var contentState = DraftModifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
	  return EditorState.push(editorState, contentState, 'split-block');
	}
	
	module.exports = keyCommandInsertNewline;

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandMoveSelectionToEndOfBlock
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(71);
	
	/**
	 * See comment for `moveSelectionToStartOfBlock`.
	 */
	function keyCommandMoveSelectionToEndOfBlock(editorState) {
	  var selection = editorState.getSelection();
	  var endKey = selection.getEndKey();
	  var content = editorState.getCurrentContent();
	  var textLength = content.getBlockForKey(endKey).getLength();
	  return EditorState.set(editorState, {
	    selection: selection.merge({
	      anchorKey: endKey,
	      anchorOffset: textLength,
	      focusKey: endKey,
	      focusOffset: textLength,
	      isBackward: false
	    }),
	    forceSelection: true
	  });
	}
	
	module.exports = keyCommandMoveSelectionToEndOfBlock;

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandMoveSelectionToStartOfBlock
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(71);
	
	/**
	 * Collapse selection at the start of the first selected block. This is used
	 * for Firefox versions that attempt to navigate forward/backward instead of
	 * moving the cursor. Other browsers are able to move the cursor natively.
	 */
	function keyCommandMoveSelectionToStartOfBlock(editorState) {
	  var selection = editorState.getSelection();
	  var startKey = selection.getStartKey();
	  return EditorState.set(editorState, {
	    selection: selection.merge({
	      anchorKey: startKey,
	      anchorOffset: 0,
	      focusKey: startKey,
	      focusOffset: 0,
	      isBackward: false
	    }),
	    forceSelection: true
	  });
	}
	
	module.exports = keyCommandMoveSelectionToStartOfBlock;

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandPlainBackspace
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(71);
	var UnicodeUtils = __webpack_require__(204);
	
	var moveSelectionBackward = __webpack_require__(450);
	var removeTextWithStrategy = __webpack_require__(274);
	
	/**
	 * Remove the selected range. If the cursor is collapsed, remove the preceding
	 * character. This operation is Unicode-aware, so removing a single character
	 * will remove a surrogate pair properly as well.
	 */
	function keyCommandPlainBackspace(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var content = strategyState.getCurrentContent();
	    var key = selection.getAnchorKey();
	    var offset = selection.getAnchorOffset();
	    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
	    return moveSelectionBackward(strategyState, charBehind ? UnicodeUtils.getUTF16Length(charBehind, 0) : 1);
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  var selection = editorState.getSelection();
	  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
	}
	
	module.exports = keyCommandPlainBackspace;

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandPlainDelete
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(71);
	var UnicodeUtils = __webpack_require__(204);
	
	var moveSelectionForward = __webpack_require__(661);
	var removeTextWithStrategy = __webpack_require__(274);
	
	/**
	 * Remove the selected range. If the cursor is collapsed, remove the following
	 * character. This operation is Unicode-aware, so removing a single character
	 * will remove a surrogate pair properly as well.
	 */
	function keyCommandPlainDelete(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var content = strategyState.getCurrentContent();
	    var key = selection.getAnchorKey();
	    var offset = selection.getAnchorOffset();
	    var charAhead = content.getBlockForKey(key).getText()[offset];
	    return moveSelectionForward(strategyState, charAhead ? UnicodeUtils.getUTF16Length(charAhead, 0) : 1);
	  }, 'forward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  var selection = editorState.getSelection();
	
	  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
	}
	
	module.exports = keyCommandPlainDelete;

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandTransposeCharacters
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(104);
	var EditorState = __webpack_require__(71);
	
	var getContentStateFragment = __webpack_require__(334);
	
	/**
	 * Transpose the characters on either side of a collapsed cursor, or
	 * if the cursor is at the end of the block, transpose the last two
	 * characters.
	 */
	function keyCommandTransposeCharacters(editorState) {
	  var selection = editorState.getSelection();
	  if (!selection.isCollapsed()) {
	    return editorState;
	  }
	
	  var offset = selection.getAnchorOffset();
	  if (offset === 0) {
	    return editorState;
	  }
	
	  var blockKey = selection.getAnchorKey();
	  var content = editorState.getCurrentContent();
	  var block = content.getBlockForKey(blockKey);
	  var length = block.getLength();
	
	  // Nothing to transpose if there aren't two characters.
	  if (length <= 1) {
	    return editorState;
	  }
	
	  var removalRange;
	  var finalSelection;
	
	  if (offset === length) {
	    // The cursor is at the end of the block. Swap the last two characters.
	    removalRange = selection.set('anchorOffset', offset - 1);
	    finalSelection = selection;
	  } else {
	    removalRange = selection.set('focusOffset', offset + 1);
	    finalSelection = removalRange.set('anchorOffset', offset + 1);
	  }
	
	  // Extract the character to move as a fragment. This preserves its
	  // styling and entity, if any.
	  var movedFragment = getContentStateFragment(content, removalRange);
	  var afterRemoval = DraftModifier.removeRange(content, removalRange, 'backward');
	
	  // After the removal, the insertion target is one character back.
	  var selectionAfter = afterRemoval.getSelectionAfter();
	  var targetOffset = selectionAfter.getAnchorOffset() - 1;
	  var targetRange = selectionAfter.merge({
	    anchorOffset: targetOffset,
	    focusOffset: targetOffset
	  });
	
	  var afterInsert = DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
	
	  var newEditorState = EditorState.push(editorState, afterInsert, 'insert-fragment');
	
	  return EditorState.acceptSelection(newEditorState, finalSelection);
	}
	
	module.exports = keyCommandTransposeCharacters;

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandUndo
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(71);
	
	function keyCommandUndo(e, editorState, updateFn) {
	  var undoneState = EditorState.undo(editorState);
	
	  // If the last change to occur was a spellcheck change, allow the undo
	  // event to fall through to the browser. This allows the browser to record
	  // the unwanted change, which should soon lead it to learn not to suggest
	  // the correction again.
	  if (editorState.getLastChangeType() === 'spellcheck-change') {
	    var nativelyRenderedContent = undoneState.getCurrentContent();
	    updateFn(EditorState.set(undoneState, { nativelyRenderedContent: nativelyRenderedContent }));
	    return;
	  }
	
	  // Otheriwse, manage the undo behavior manually.
	  e.preventDefault();
	  if (!editorState.getNativelyRenderedContent()) {
	    updateFn(undoneState);
	    return;
	  }
	
	  // Trigger a re-render with the current content state to ensure that the
	  // component tree has up-to-date props for comparison.
	  updateFn(EditorState.set(editorState, { nativelyRenderedContent: null }));
	
	  // Wait to ensure that the re-render has occurred before performing
	  // the undo action.
	  setTimeout(function () {
	    updateFn(undoneState);
	  }, 0);
	}
	
	module.exports = keyCommandUndo;

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule modifyBlockForContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(60);
	
	var Map = Immutable.Map;
	
	
	function modifyBlockForContentState(contentState, selectionState, operation) {
	  var startKey = selectionState.getStartKey();
	  var endKey = selectionState.getEndKey();
	  var blockMap = contentState.getBlockMap();
	  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(operation);
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = modifyBlockForContentState;

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule moveBlockInContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var ContentBlockNode = __webpack_require__(123);
	var Immutable = __webpack_require__(60);
	
	var getNextDelimiterBlockKey = __webpack_require__(653);
	var invariant = __webpack_require__(28);
	
	var OrderedMap = Immutable.OrderedMap,
	    List = Immutable.List;
	
	
	var transformBlock = function transformBlock(key, blockMap, func) {
	  if (!key) {
	    return;
	  }
	
	  var block = blockMap.get(key);
	
	  if (!block) {
	    return;
	  }
	
	  blockMap.set(key, func(block));
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockToBeMoved, originalTargetBlock, insertionMode, isExperimentalTreeBlock) {
	  if (!isExperimentalTreeBlock) {
	    return blockMap;
	  }
	  // possible values of 'insertionMode' are: 'after', 'before'
	  var isInsertedAfterTarget = insertionMode === 'after';
	
	  var originalBlockKey = originalBlockToBeMoved.getKey();
	  var originalTargetKey = originalTargetBlock.getKey();
	  var originalParentKey = originalBlockToBeMoved.getParentKey();
	  var originalNextSiblingKey = originalBlockToBeMoved.getNextSiblingKey();
	  var originalPrevSiblingKey = originalBlockToBeMoved.getPrevSiblingKey();
	  var newParentKey = originalTargetBlock.getParentKey();
	  var newNextSiblingKey = isInsertedAfterTarget ? originalTargetBlock.getNextSiblingKey() : originalTargetKey;
	  var newPrevSiblingKey = isInsertedAfterTarget ? originalTargetKey : originalTargetBlock.getPrevSiblingKey();
	
	  return blockMap.withMutations(function (blocks) {
	    // update old parent
	    transformBlock(originalParentKey, blocks, function (block) {
	      var parentChildrenList = block.getChildKeys();
	      return block.merge({
	        children: parentChildrenList['delete'](parentChildrenList.indexOf(originalBlockKey))
	      });
	    });
	
	    // update old prev
	    transformBlock(originalPrevSiblingKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: originalNextSiblingKey
	      });
	    });
	
	    // update old next
	    transformBlock(originalNextSiblingKey, blocks, function (block) {
	      return block.merge({
	        prevSibling: originalPrevSiblingKey
	      });
	    });
	
	    // update new next
	    transformBlock(newNextSiblingKey, blocks, function (block) {
	      return block.merge({
	        prevSibling: originalBlockKey
	      });
	    });
	
	    // update new prev
	    transformBlock(newPrevSiblingKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: originalBlockKey
	      });
	    });
	
	    // update new parent
	    transformBlock(newParentKey, blocks, function (block) {
	      var newParentChildrenList = block.getChildKeys();
	      var targetBlockIndex = newParentChildrenList.indexOf(originalTargetKey);
	
	      var insertionIndex = isInsertedAfterTarget ? targetBlockIndex + 1 : targetBlockIndex !== 0 ? targetBlockIndex - 1 : 0;
	
	      var newChildrenArray = newParentChildrenList.toArray();
	      newChildrenArray.splice(insertionIndex, 0, originalBlockKey);
	
	      return block.merge({
	        children: List(newChildrenArray)
	      });
	    });
	
	    // update block
	    transformBlock(originalBlockKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: newNextSiblingKey,
	        prevSibling: newPrevSiblingKey,
	        parent: newParentKey
	      });
	    });
	  });
	};
	
	var moveBlockInContentState = function moveBlockInContentState(contentState, blockToBeMoved, targetBlock, insertionMode) {
	  !(insertionMode !== 'replace') ?  false ? invariant(false, 'Replacing blocks is not supported.') : invariant(false) : void 0;
	
	  var targetKey = targetBlock.getKey();
	  var blockKey = blockToBeMoved.getKey();
	
	  !(blockKey !== targetKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
	
	  var blockMap = contentState.getBlockMap();
	  var isExperimentalTreeBlock = blockToBeMoved instanceof ContentBlockNode;
	
	  var blocksToBeMoved = [blockToBeMoved];
	  var blockMapWithoutBlocksToBeMoved = blockMap['delete'](blockKey);
	
	  if (isExperimentalTreeBlock) {
	    blocksToBeMoved = [];
	    blockMapWithoutBlocksToBeMoved = blockMap.withMutations(function (blocks) {
	      var nextSiblingKey = blockToBeMoved.getNextSiblingKey();
	      var nextDelimiterBlockKey = getNextDelimiterBlockKey(blockToBeMoved, blocks);
	
	      blocks.toSeq().skipUntil(function (block) {
	        return block.getKey() === blockKey;
	      }).takeWhile(function (block) {
	        var key = block.getKey();
	        var isBlockToBeMoved = key === blockKey;
	        var hasNextSiblingAndIsNotNextSibling = nextSiblingKey && key !== nextSiblingKey;
	        var doesNotHaveNextSiblingAndIsNotDelimiter = !nextSiblingKey && block.getParentKey() && (!nextDelimiterBlockKey || key !== nextDelimiterBlockKey);
	
	        return !!(isBlockToBeMoved || hasNextSiblingAndIsNotNextSibling || doesNotHaveNextSiblingAndIsNotDelimiter);
	      }).forEach(function (block) {
	        blocksToBeMoved.push(block);
	        blocks['delete'](block.getKey());
	      });
	    });
	  }
	
	  var blocksBefore = blockMapWithoutBlocksToBeMoved.toSeq().takeUntil(function (v) {
	    return v === targetBlock;
	  });
	
	  var blocksAfter = blockMapWithoutBlocksToBeMoved.toSeq().skipUntil(function (v) {
	    return v === targetBlock;
	  }).skip(1);
	
	  var slicedBlocks = blocksToBeMoved.map(function (block) {
	    return [block.getKey(), block];
	  });
	
	  var newBlocks = OrderedMap();
	
	  if (insertionMode === 'before') {
	    var blockBefore = contentState.getBlockBefore(targetKey);
	
	    !(!blockBefore || blockBefore.getKey() !== blockToBeMoved.getKey()) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
	
	    newBlocks = blocksBefore.concat([].concat(slicedBlocks, [[targetKey, targetBlock]]), blocksAfter).toOrderedMap();
	  } else if (insertionMode === 'after') {
	    var blockAfter = contentState.getBlockAfter(targetKey);
	
	    !(!blockAfter || blockAfter.getKey() !== blockKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
	
	    newBlocks = blocksBefore.concat([[targetKey, targetBlock]].concat(slicedBlocks), blocksAfter).toOrderedMap();
	  }
	
	  return contentState.merge({
	    blockMap: updateBlockMapLinks(newBlocks, blockToBeMoved, targetBlock, insertionMode, isExperimentalTreeBlock),
	    selectionBefore: contentState.getSelectionAfter(),
	    selectionAfter: contentState.getSelectionAfter().merge({
	      anchorKey: blockKey,
	      focusKey: blockKey
	    })
	  });
	};
	
	module.exports = moveBlockInContentState;

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeRangeFromContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var ContentBlockNode = __webpack_require__(123);
	var Immutable = __webpack_require__(60);
	
	var getNextDelimiterBlockKey = __webpack_require__(653);
	
	var List = Immutable.List,
	    Map = Immutable.Map;
	
	
	var transformBlock = function transformBlock(key, blockMap, func) {
	  if (!key) {
	    return;
	  }
	
	  var block = blockMap.get(key);
	
	  if (!block) {
	    return;
	  }
	
	  blockMap.set(key, func(block));
	};
	
	/**
	 * Ancestors needs to be preserved when there are non selected
	 * children to make sure we do not leave any orphans behind
	 */
	var getAncestorsKeys = function getAncestorsKeys(blockKey, blockMap) {
	  var parents = [];
	
	  if (!blockKey) {
	    return parents;
	  }
	
	  var blockNode = blockMap.get(blockKey);
	  while (blockNode && blockNode.getParentKey()) {
	    var parentKey = blockNode.getParentKey();
	    if (parentKey) {
	      parents.push(parentKey);
	    }
	    blockNode = parentKey ? blockMap.get(parentKey) : null;
	  }
	
	  return parents;
	};
	
	/**
	 * Get all next delimiter keys until we hit a root delimiter and return
	 * an array of key references
	 */
	var getNextDelimitersBlockKeys = function getNextDelimitersBlockKeys(block, blockMap) {
	  var nextDelimiters = [];
	
	  if (!block) {
	    return nextDelimiters;
	  }
	
	  var nextDelimiter = getNextDelimiterBlockKey(block, blockMap);
	  while (nextDelimiter && blockMap.get(nextDelimiter)) {
	    var _block = blockMap.get(nextDelimiter);
	    nextDelimiters.push(nextDelimiter);
	
	    // we do not need to keep checking all root node siblings, just the first occurance
	    nextDelimiter = _block.getParentKey() ? getNextDelimiterBlockKey(_block, blockMap) : null;
	  }
	
	  return nextDelimiters;
	};
	
	var getNextValidSibling = function getNextValidSibling(block, blockMap, originalBlockMap) {
	  if (!block) {
	    return null;
	  }
	
	  // note that we need to make sure we refer to the original block since this
	  // function is called within a withMutations
	  var nextValidSiblingKey = originalBlockMap.get(block.getKey()).getNextSiblingKey();
	
	  while (nextValidSiblingKey && !blockMap.get(nextValidSiblingKey)) {
	    nextValidSiblingKey = originalBlockMap.get(nextValidSiblingKey).getNextSiblingKey() || null;
	  }
	
	  return nextValidSiblingKey;
	};
	
	var getPrevValidSibling = function getPrevValidSibling(block, blockMap, originalBlockMap) {
	  if (!block) {
	    return null;
	  }
	
	  // note that we need to make sure we refer to the original block since this
	  // function is called within a withMutations
	  var prevValidSiblingKey = originalBlockMap.get(block.getKey()).getPrevSiblingKey();
	
	  while (prevValidSiblingKey && !blockMap.get(prevValidSiblingKey)) {
	    prevValidSiblingKey = originalBlockMap.get(prevValidSiblingKey).getPrevSiblingKey() || null;
	  }
	
	  return prevValidSiblingKey;
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, startBlock, endBlock, originalBlockMap) {
	  return blockMap.withMutations(function (blocks) {
	    // update start block if its retained
	    transformBlock(startBlock.getKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap),
	        prevSibling: getPrevValidSibling(startBlock, blocks, originalBlockMap)
	      });
	    });
	
	    // update endblock if its retained
	    transformBlock(endBlock.getKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: getNextValidSibling(endBlock, blocks, originalBlockMap),
	        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
	      });
	    });
	
	    // update start block parent ancestors
	    getAncestorsKeys(startBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
	      return transformBlock(parentKey, blocks, function (block) {
	        return block.merge({
	          children: block.getChildKeys().filter(function (key) {
	            return blocks.get(key);
	          }),
	          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
	          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
	        });
	      });
	    });
	
	    // update start block next - can only happen if startBlock == endBlock
	    transformBlock(startBlock.getNextSiblingKey(), blocks, function (block) {
	      return block.merge({
	        prevSibling: startBlock.getPrevSiblingKey()
	      });
	    });
	
	    // update start block prev
	    transformBlock(startBlock.getPrevSiblingKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap)
	      });
	    });
	
	    // update end block next
	    transformBlock(endBlock.getNextSiblingKey(), blocks, function (block) {
	      return block.merge({
	        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
	      });
	    });
	
	    // update end block prev
	    transformBlock(endBlock.getPrevSiblingKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: endBlock.getNextSiblingKey()
	      });
	    });
	
	    // update end block parent ancestors
	    getAncestorsKeys(endBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
	      transformBlock(parentKey, blocks, function (block) {
	        return block.merge({
	          children: block.getChildKeys().filter(function (key) {
	            return blocks.get(key);
	          }),
	          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
	          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
	        });
	      });
	    });
	
	    // update next delimiters all the way to a root delimiter
	    getNextDelimitersBlockKeys(endBlock, originalBlockMap).forEach(function (delimiterKey) {
	      return transformBlock(delimiterKey, blocks, function (block) {
	        return block.merge({
	          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
	          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
	        });
	      });
	    });
	  });
	};
	
	var removeRangeFromContentState = function removeRangeFromContentState(contentState, selectionState) {
	  if (selectionState.isCollapsed()) {
	    return contentState;
	  }
	
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var startBlock = blockMap.get(startKey);
	  var endBlock = blockMap.get(endKey);
	
	  // we assume that ContentBlockNode and ContentBlocks are not mixed together
	  var isExperimentalTreeBlock = startBlock instanceof ContentBlockNode;
	
	  // used to retain blocks that should not be deleted to avoid orphan children
	  var parentAncestors = [];
	
	  if (isExperimentalTreeBlock) {
	    var endBlockchildrenKeys = endBlock.getChildKeys();
	    var endBlockAncestors = getAncestorsKeys(endKey, blockMap);
	
	    // endBlock has unselected sibblings so we can not remove its ancestors parents
	    if (endBlock.getNextSiblingKey()) {
	      parentAncestors = parentAncestors.concat(endBlockAncestors);
	    }
	
	    // endBlock has children so can not remove this block or any of its ancestors
	    if (!endBlockchildrenKeys.isEmpty()) {
	      parentAncestors = parentAncestors.concat(endBlockAncestors.concat([endKey]));
	    }
	
	    // we need to retain all ancestors of the next delimiter block
	    parentAncestors = parentAncestors.concat(getAncestorsKeys(getNextDelimiterBlockKey(endBlock, blockMap), blockMap));
	  }
	
	  var characterList = void 0;
	
	  if (startBlock === endBlock) {
	    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
	  } else {
	    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
	  }
	
	  var modifiedStart = startBlock.merge({
	    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
	    characterList: characterList
	  });
	
	  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).filter(function (_, k) {
	    return parentAncestors.indexOf(k) === -1;
	  }).concat(Map([[endKey, null]])).map(function (_, k) {
	    return k === startKey ? modifiedStart : null;
	  });
	
	  var updatedBlockMap = blockMap.merge(newBlocks).filter(function (block) {
	    return !!block;
	  });
	
	  if (isExperimentalTreeBlock) {
	    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, startBlock, endBlock, blockMap);
	  }
	
	  return contentState.merge({
	    blockMap: updatedBlockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: startKey,
	      anchorOffset: startOffset,
	      focusKey: startKey,
	      focusOffset: startOffset,
	      isBackward: false
	    })
	  });
	};
	
	/**
	 * Maintain persistence for target list when removing characters on the
	 * head and tail of the character list.
	 */
	var removeFromList = function removeFromList(targetList, startOffset, endOffset) {
	  if (startOffset === 0) {
	    while (startOffset < endOffset) {
	      targetList = targetList.shift();
	      startOffset++;
	    }
	  } else if (endOffset === targetList.count()) {
	    while (endOffset > startOffset) {
	      targetList = targetList.pop();
	      endOffset--;
	    }
	  } else {
	    var head = targetList.slice(0, startOffset);
	    var tail = targetList.slice(endOffset);
	    targetList = head.concat(tail).toList();
	  }
	  return targetList;
	};
	
	module.exports = removeRangeFromContentState;

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setDraftEditorSelection
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftJsDebugLogging = __webpack_require__(1221);
	
	var containsNode = __webpack_require__(335);
	var getActiveElement = __webpack_require__(337);
	var invariant = __webpack_require__(28);
	
	function getAnonymizedDOM(node, getNodeLabels) {
	  if (!node) {
	    return '[empty]';
	  }
	
	  var anonymized = anonymizeTextWithin(node, getNodeLabels);
	  if (anonymized.nodeType === Node.TEXT_NODE) {
	    return anonymized.textContent;
	  }
	
	  !(anonymized instanceof Element) ?  false ? invariant(false, 'Node must be an Element if it is not a text node.') : invariant(false) : void 0;
	  return anonymized.outerHTML;
	}
	
	function anonymizeTextWithin(node, getNodeLabels) {
	  var labels = getNodeLabels !== undefined ? getNodeLabels(node) : [];
	
	  if (node.nodeType === Node.TEXT_NODE) {
	    var length = node.textContent.length;
	    return document.createTextNode('[text ' + length + (labels.length ? ' | ' + labels.join(', ') : '') + ']');
	  }
	
	  var clone = node.cloneNode();
	  if (clone.nodeType === 1 && labels.length) {
	    clone.setAttribute('data-labels', labels.join(', '));
	  }
	  var childNodes = node.childNodes;
	  for (var ii = 0; ii < childNodes.length; ii++) {
	    clone.appendChild(anonymizeTextWithin(childNodes[ii], getNodeLabels));
	  }
	
	  return clone;
	}
	
	function getAnonymizedEditorDOM(node, getNodeLabels) {
	  // grabbing the DOM content of the Draft editor
	  var currentNode = node;
	  while (currentNode) {
	    if (currentNode instanceof Element && currentNode.hasAttribute('contenteditable')) {
	      // found the Draft editor container
	      return getAnonymizedDOM(currentNode, getNodeLabels);
	    } else {
	      currentNode = currentNode.parentNode;
	    }
	  }
	  return 'Could not find contentEditable parent of node';
	}
	
	function getNodeLength(node) {
	  return node.nodeValue === null ? node.childNodes.length : node.nodeValue.length;
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 */
	function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
	  // It's possible that the editor has been removed from the DOM but
	  // our selection code doesn't know it yet. Forcing selection in
	  // this case may lead to errors, so just bail now.
	  if (!containsNode(document.documentElement, node)) {
	    return;
	  }
	
	  var selection = global.getSelection();
	  var anchorKey = selectionState.getAnchorKey();
	  var anchorOffset = selectionState.getAnchorOffset();
	  var focusKey = selectionState.getFocusKey();
	  var focusOffset = selectionState.getFocusOffset();
	  var isBackward = selectionState.getIsBackward();
	
	  // IE doesn't support backward selection. Swap key/offset pairs.
	  if (!selection.extend && isBackward) {
	    var tempKey = anchorKey;
	    var tempOffset = anchorOffset;
	    anchorKey = focusKey;
	    anchorOffset = focusOffset;
	    focusKey = tempKey;
	    focusOffset = tempOffset;
	    isBackward = false;
	  }
	
	  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;
	
	  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset;
	
	  // If the selection is entirely bound within this node, set the selection
	  // and be done.
	  if (hasAnchor && hasFocus) {
	    selection.removeAllRanges();
	    addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
	    addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
	    return;
	  }
	
	  if (!isBackward) {
	    // If the anchor is within this node, set the range start.
	    if (hasAnchor) {
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
	    }
	
	    // If the focus is within this node, we can assume that we have
	    // already set the appropriate start range on the selection, and
	    // can simply extend the selection.
	    if (hasFocus) {
	      addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
	    }
	  } else {
	    // If this node has the focus, set the selection range to be a
	    // collapsed range beginning here. Later, when we encounter the anchor,
	    // we'll use this information to extend the selection.
	    if (hasFocus) {
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, focusOffset - nodeStart, selectionState);
	    }
	
	    // If this node has the anchor, we may assume that the correct
	    // focus information is already stored on the selection object.
	    // We keep track of it, reset the selection range, and extend it
	    // back to the focus point.
	    if (hasAnchor) {
	      var storedFocusNode = selection.focusNode;
	      var storedFocusOffset = selection.focusOffset;
	
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
	      addFocusToSelection(selection, storedFocusNode, storedFocusOffset, selectionState);
	    }
	  }
	}
	
	/**
	 * Extend selection towards focus point.
	 */
	function addFocusToSelection(selection, node, offset, selectionState) {
	  var activeElement = getActiveElement();
	  if (selection.extend && containsNode(activeElement, node)) {
	    // If `extend` is called while another element has focus, an error is
	    // thrown. We therefore disable `extend` if the active element is somewhere
	    // other than the node we are selecting. This should only occur in Firefox,
	    // since it is the only browser to support multiple selections.
	    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.
	
	    // logging to catch bug that is being reported in t16250795
	    if (offset > getNodeLength(node)) {
	      // the call to 'selection.extend' is about to throw
	      DraftJsDebugLogging.logSelectionStateFailure({
	        anonymizedDom: getAnonymizedEditorDOM(node),
	        extraParams: JSON.stringify({ offset: offset }),
	        selectionState: JSON.stringify(selectionState.toJS())
	      });
	    }
	
	    // logging to catch bug that is being reported in t18110632
	    var nodeWasFocus = node === selection.focusNode;
	    try {
	      selection.extend(node, offset);
	    } catch (e) {
	      DraftJsDebugLogging.logSelectionStateFailure({
	        anonymizedDom: getAnonymizedEditorDOM(node, function (n) {
	          var labels = [];
	          if (n === activeElement) {
	            labels.push('active element');
	          }
	          if (n === selection.anchorNode) {
	            labels.push('selection anchor node');
	          }
	          if (n === selection.focusNode) {
	            labels.push('selection focus node');
	          }
	          return labels;
	        }),
	        extraParams: JSON.stringify({
	          activeElementName: activeElement ? activeElement.nodeName : null,
	          nodeIsFocus: node === selection.focusNode,
	          nodeWasFocus: nodeWasFocus,
	          selectionRangeCount: selection.rangeCount,
	          selectionAnchorNodeName: selection.anchorNode ? selection.anchorNode.nodeName : null,
	          selectionAnchorOffset: selection.anchorOffset,
	          selectionFocusNodeName: selection.focusNode ? selection.focusNode.nodeName : null,
	          selectionFocusOffset: selection.focusOffset,
	          message: e ? '' + e : null,
	          offset: offset
	        }, null, 2),
	        selectionState: JSON.stringify(selectionState.toJS(), null, 2)
	      });
	      // allow the error to be thrown -
	      // better than continuing in a broken state
	      throw e;
	    }
	  } else {
	    // IE doesn't support extend. This will mean no backward selection.
	    // Extract the existing selection range and add focus to it.
	    // Additionally, clone the selection range. IE11 throws an
	    // InvalidStateError when attempting to access selection properties
	    // after the range is detached.
	    var range = selection.getRangeAt(0);
	    range.setEnd(node, offset);
	    selection.addRange(range.cloneRange());
	  }
	}
	
	function addPointToSelection(selection, node, offset, selectionState) {
	  var range = document.createRange();
	  // logging to catch bug that is being reported in t16250795
	  if (offset > getNodeLength(node)) {
	    // in this case we know that the call to 'range.setStart' is about to throw
	    DraftJsDebugLogging.logSelectionStateFailure({
	      anonymizedDom: getAnonymizedEditorDOM(node),
	      extraParams: JSON.stringify({ offset: offset }),
	      selectionState: JSON.stringify(selectionState.toJS())
	    });
	  }
	  range.setStart(node, offset);
	  selection.addRange(range);
	}
	
	module.exports = setDraftEditorSelection;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule splitBlockInContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var ContentBlockNode = __webpack_require__(123);
	var Immutable = __webpack_require__(60);
	
	var generateRandomKey = __webpack_require__(161);
	var invariant = __webpack_require__(28);
	
	var List = Immutable.List,
	    Map = Immutable.Map;
	
	
	var transformBlock = function transformBlock(key, blockMap, func) {
	  if (!key) {
	    return;
	  }
	
	  var block = blockMap.get(key);
	
	  if (!block) {
	    return;
	  }
	
	  blockMap.set(key, func(block));
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlock, belowBlock) {
	  return blockMap.withMutations(function (blocks) {
	    var originalBlockKey = originalBlock.getKey();
	    var belowBlockKey = belowBlock.getKey();
	
	    // update block parent
	    transformBlock(originalBlock.getParentKey(), blocks, function (block) {
	      var parentChildrenList = block.getChildKeys();
	      var insertionIndex = parentChildrenList.indexOf(originalBlockKey) + 1;
	      var newChildrenArray = parentChildrenList.toArray();
	
	      newChildrenArray.splice(insertionIndex, 0, belowBlockKey);
	
	      return block.merge({
	        children: List(newChildrenArray)
	      });
	    });
	
	    // update original next block
	    transformBlock(originalBlock.getNextSiblingKey(), blocks, function (block) {
	      return block.merge({
	        prevSibling: belowBlockKey
	      });
	    });
	
	    // update original block
	    transformBlock(originalBlockKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: belowBlockKey
	      });
	    });
	
	    // update below block
	    transformBlock(belowBlockKey, blocks, function (block) {
	      return block.merge({
	        prevSibling: originalBlockKey
	      });
	    });
	  });
	};
	
	var splitBlockInContentState = function splitBlockInContentState(contentState, selectionState) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, 'Selection range must be collapsed.') : invariant(false) : void 0;
	
	  var key = selectionState.getAnchorKey();
	  var offset = selectionState.getAnchorOffset();
	  var blockMap = contentState.getBlockMap();
	  var blockToSplit = blockMap.get(key);
	  var text = blockToSplit.getText();
	  var chars = blockToSplit.getCharacterList();
	  var keyBelow = generateRandomKey();
	  var isExperimentalTreeBlock = blockToSplit instanceof ContentBlockNode;
	
	  var blockAbove = blockToSplit.merge({
	    text: text.slice(0, offset),
	    characterList: chars.slice(0, offset)
	  });
	  var blockBelow = blockAbove.merge({
	    key: keyBelow,
	    text: text.slice(offset),
	    characterList: chars.slice(offset),
	    data: Map()
	  });
	
	  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
	    return v === blockToSplit;
	  });
	  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
	    return v === blockToSplit;
	  }).rest();
	  var newBlocks = blocksBefore.concat([[key, blockAbove], [keyBelow, blockBelow]], blocksAfter).toOrderedMap();
	
	  if (isExperimentalTreeBlock) {
	    !blockToSplit.getChildKeys().isEmpty() ?  false ? invariant(false, 'ContentBlockNode must not have children') : invariant(false) : void 0;
	
	    newBlocks = updateBlockMapLinks(newBlocks, blockAbove, blockBelow);
	  }
	
	  return contentState.merge({
	    blockMap: newBlocks,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: keyBelow,
	      anchorOffset: 0,
	      focusKey: keyBelow,
	      focusOffset: 0,
	      isBackward: false
	    })
	  });
	};
	
	module.exports = splitBlockInContentState;

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule splitTextIntoTextBlocks
	 * @format
	 * 
	 */
	
	'use strict';
	
	var NEWLINE_REGEX = /\r\n?|\n/g;
	
	function splitTextIntoTextBlocks(text) {
	  return text.split(NEWLINE_REGEX);
	}
	
	module.exports = splitTextIntoTextBlocks;

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

	/*!
	 * escape-html
	 * Copyright(c) 2012-2013 TJ Holowaychuk
	 * Copyright(c) 2015 Andreas Lubbe
	 * Copyright(c) 2015 Tiancheng "Timothy" Gu
	 * MIT Licensed
	 */
	
	'use strict';
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Module exports.
	 * @public
	 */
	
	module.exports = escapeHtml;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34: // "
	        escape = '&quot;';
	        break;
	      case 38: // &
	        escape = '&amp;';
	        break;
	      case 39: // '
	        escape = '&#39;';
	        break;
	      case 60: // <
	        escape = '&lt;';
	        break;
	      case 62: // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index
	    ? html + str.substring(lastIndex, index)
	    : html;
	}


/***/ }),
/* 1273 */
203,
/* 1274 */
203,
/* 1275 */
203,
/* 1276 */
203,
/* 1277 */
203,
/* 1278 */
203,
/* 1279 */
203,
/* 1280 */
203,
/* 1281 */
203,
/* 1282 */
203,
/* 1283 */
203,
/* 1284 */
203,
/* 1285 */
203,
/* 1286 */
203,
/* 1287 */
203,
/* 1288 */
203,
/* 1289 */
203,
/* 1290 */
203,
/* 1291 */
203,
/* 1292 */
203,
/* 1293 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	var PhotosMimeType = {
	  isImage: function isImage(mimeString) {
	    return getParts(mimeString)[0] === 'image';
	  },
	  isJpeg: function isJpeg(mimeString) {
	    var parts = getParts(mimeString);
	    return PhotosMimeType.isImage(mimeString) && (
	    // see http://fburl.com/10972194
	    parts[1] === 'jpeg' || parts[1] === 'pjpeg');
	  }
	};
	
	function getParts(mimeString) {
	  return mimeString.split('/');
	}
	
	module.exports = PhotosMimeType;

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * @stub
	 * 
	 */
	
	'use strict';
	
	// \u00a1-\u00b1\u00b4-\u00b8\u00ba\u00bb\u00bf
	//             is latin supplement punctuation except fractions and superscript
	//             numbers
	// \u2010-\u2027\u2030-\u205e
	//             is punctuation from the general punctuation block:
	//             weird quotes, commas, bullets, dashes, etc.
	// \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
	//             is CJK punctuation
	// \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
	//             is some full-width/half-width punctuation
	// \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
	//             is some Arabic punctuation marks
	// \u1801\u0964\u104a\u104b
	//             is misc. other language punctuation marks
	
	var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + '\u30FB\u3001\u3002\u3008-\u3011\u3014-\u301F\uFF1A-\uFF1F\uFF01-\uFF0F' + '\uFF3B-\uFF40\uFF5B-\uFF65\u2E2E\u061F\u066A-\u066C\u061B\u060C\u060D' + '\uFD3E\uFD3F\u1801\u0964\u104A\u104B\u2010-\u2027\u2030-\u205E' + '\xA1-\xB1\xB4-\xB8\xBA\xBB\xBF]';
	
	module.exports = {
	  getPunctuation: function getPunctuation() {
	    return PUNCTUATION;
	  }
	};

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var URI = function () {
	  function URI(uri) {
	    _classCallCheck(this, URI);
	
	    this._uri = uri;
	  }
	
	  URI.prototype.toString = function toString() {
	    return this._uri;
	  };
	
	  return URI;
	}();
	
	module.exports = URI;

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Stateful API for text direction detection
	 *
	 * This class can be used in applications where you need to detect the
	 * direction of a sequence of text blocks, where each direction shall be used
	 * as the fallback direction for the next one.
	 *
	 * NOTE: A default direction, if not provided, is set based on the global
	 *       direction, as defined by `UnicodeBidiDirection`.
	 *
	 * == Example ==
	 * ```
	 * var UnicodeBidiService = require('UnicodeBidiService');
	 *
	 * var bidiService = new UnicodeBidiService();
	 *
	 * ...
	 *
	 * bidiService.reset();
	 * for (var para in paragraphs) {
	 *   var dir = bidiService.getDirection(para);
	 *   ...
	 * }
	 * ```
	 *
	 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UnicodeBidi = __webpack_require__(672);
	var UnicodeBidiDirection = __webpack_require__(456);
	
	var invariant = __webpack_require__(28);
	
	var UnicodeBidiService = function () {
	
	  /**
	   * Stateful class for paragraph direction detection
	   *
	   * @param defaultDir  Default direction of the service
	   */
	  function UnicodeBidiService(defaultDir) {
	    _classCallCheck(this, UnicodeBidiService);
	
	    if (!defaultDir) {
	      defaultDir = UnicodeBidiDirection.getGlobalDir();
	    } else {
	      !UnicodeBidiDirection.isStrong(defaultDir) ?  false ? invariant(false, 'Default direction must be a strong direction (LTR or RTL)') : invariant(false) : void 0;
	    }
	    this._defaultDir = defaultDir;
	    this.reset();
	  }
	
	  /**
	   * Reset the internal state
	   *
	   * Instead of creating a new instance, you can just reset() your instance
	   * everytime you start a new loop.
	   */
	
	
	  UnicodeBidiService.prototype.reset = function reset() {
	    this._lastDir = this._defaultDir;
	  };
	
	  /**
	   * Returns the direction of a block of text, and remembers it as the
	   * fall-back direction for the next paragraph.
	   *
	   * @param str  A text block, e.g. paragraph, table cell, tag
	   * @return     The resolved direction
	   */
	
	
	  UnicodeBidiService.prototype.getDirection = function getDirection(str) {
	    this._lastDir = UnicodeBidi.getDirection(str, this._lastDir);
	    return this._lastDir;
	  };
	
	  return UnicodeBidiService;
	}();
	
	module.exports = UnicodeBidiService;

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * Usage note:
	 * This module makes a best effort to export the same data we would internally.
	 * At Facebook we use a server-generated module that does the parsing and
	 * exports the data for the client to use. We can't rely on a server-side
	 * implementation in open source so instead we make use of an open source
	 * library to do the heavy lifting and then make some adjustments as necessary.
	 * It's likely there will be some differences. Some we can smooth over.
	 * Others are going to be harder.
	 */
	
	'use strict';
	
	var UAParser = __webpack_require__(967);
	
	var UNKNOWN = 'Unknown';
	
	var PLATFORM_MAP = {
	  'Mac OS': 'Mac OS X'
	};
	
	/**
	 * Convert from UAParser platform name to what we expect.
	 */
	function convertPlatformName(name) {
	  return PLATFORM_MAP[name] || name;
	}
	
	/**
	 * Get the version number in parts. This is very naive. We actually get major
	 * version as a part of UAParser already, which is generally good enough, but
	 * let's get the minor just in case.
	 */
	function getBrowserVersion(version) {
	  if (!version) {
	    return {
	      major: '',
	      minor: ''
	    };
	  }
	  var parts = version.split('.');
	  return {
	    major: parts[0],
	    minor: parts[1]
	  };
	}
	
	/**
	 * Get the UA data fom UAParser and then convert it to the format we're
	 * expecting for our APIS.
	 */
	var parser = new UAParser();
	var results = parser.getResult();
	
	// Do some conversion first.
	var browserVersionData = getBrowserVersion(results.browser.version);
	var uaData = {
	  browserArchitecture: results.cpu.architecture || UNKNOWN,
	  browserFullVersion: results.browser.version || UNKNOWN,
	  browserMinorVersion: browserVersionData.minor || UNKNOWN,
	  browserName: results.browser.name || UNKNOWN,
	  browserVersion: results.browser.major || UNKNOWN,
	  deviceName: results.device.model || UNKNOWN,
	  engineName: results.engine.name || UNKNOWN,
	  engineVersion: results.engine.version || UNKNOWN,
	  platformArchitecture: results.cpu.architecture || UNKNOWN,
	  platformName: convertPlatformName(results.os.name) || UNKNOWN,
	  platformVersion: results.os.version || UNKNOWN,
	  platformFullVersion: results.os.version || UNKNOWN
	};
	
	module.exports = uaData;

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(28);
	
	var componentRegex = /\./;
	var orRegex = /\|\|/;
	var rangeRegex = /\s+\-\s+/;
	var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
	var numericRegex = /^(\d*)(.*)/;
	
	/**
	 * Splits input `range` on "||" and returns true if any subrange matches
	 * `version`.
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkOrExpression(range, version) {
	  var expressions = range.split(orRegex);
	
	  if (expressions.length > 1) {
	    return expressions.some(function (range) {
	      return VersionRange.contains(range, version);
	    });
	  } else {
	    range = expressions[0].trim();
	    return checkRangeExpression(range, version);
	  }
	}
	
	/**
	 * Splits input `range` on " - " (the surrounding whitespace is required) and
	 * returns true if version falls between the two operands.
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkRangeExpression(range, version) {
	  var expressions = range.split(rangeRegex);
	
	  !(expressions.length > 0 && expressions.length <= 2) ?  false ? invariant(false, 'the "-" operator expects exactly 2 operands') : invariant(false) : void 0;
	
	  if (expressions.length === 1) {
	    return checkSimpleExpression(expressions[0], version);
	  } else {
	    var startVersion = expressions[0],
	        endVersion = expressions[1];
	
	    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ?  false ? invariant(false, 'operands to the "-" operator must be simple (no modifiers)') : invariant(false) : void 0;
	
	    return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
	  }
	}
	
	/**
	 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
	 * not a compound range using the " - " or "||" operators).
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkSimpleExpression(range, version) {
	  range = range.trim();
	  if (range === '') {
	    return true;
	  }
	
	  var versionComponents = version.split(componentRegex);
	
	  var _getModifierAndCompon = getModifierAndComponents(range),
	      modifier = _getModifierAndCompon.modifier,
	      rangeComponents = _getModifierAndCompon.rangeComponents;
	
	  switch (modifier) {
	    case '<':
	      return checkLessThan(versionComponents, rangeComponents);
	    case '<=':
	      return checkLessThanOrEqual(versionComponents, rangeComponents);
	    case '>=':
	      return checkGreaterThanOrEqual(versionComponents, rangeComponents);
	    case '>':
	      return checkGreaterThan(versionComponents, rangeComponents);
	    case '~':
	    case '~>':
	      return checkApproximateVersion(versionComponents, rangeComponents);
	    default:
	      return checkEqual(versionComponents, rangeComponents);
	  }
	}
	
	/**
	 * Checks whether `a` is less than `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkLessThan(a, b) {
	  return compareComponents(a, b) === -1;
	}
	
	/**
	 * Checks whether `a` is less than or equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkLessThanOrEqual(a, b) {
	  var result = compareComponents(a, b);
	  return result === -1 || result === 0;
	}
	
	/**
	 * Checks whether `a` is equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkEqual(a, b) {
	  return compareComponents(a, b) === 0;
	}
	
	/**
	 * Checks whether `a` is greater than or equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkGreaterThanOrEqual(a, b) {
	  var result = compareComponents(a, b);
	  return result === 1 || result === 0;
	}
	
	/**
	 * Checks whether `a` is greater than `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkGreaterThan(a, b) {
	  return compareComponents(a, b) === 1;
	}
	
	/**
	 * Checks whether `a` is "reasonably close" to `b` (as described in
	 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
	 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkApproximateVersion(a, b) {
	  var lowerBound = b.slice();
	  var upperBound = b.slice();
	
	  if (upperBound.length > 1) {
	    upperBound.pop();
	  }
	  var lastIndex = upperBound.length - 1;
	  var numeric = parseInt(upperBound[lastIndex], 10);
	  if (isNumber(numeric)) {
	    upperBound[lastIndex] = numeric + 1 + '';
	  }
	
	  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
	}
	
	/**
	 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
	 * components from `range`.
	 *
	 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
	 * `">="` and `components` of `[1, 2, 3]`.
	 *
	 * @param {string} range
	 * @returns {object}
	 */
	function getModifierAndComponents(range) {
	  var rangeComponents = range.split(componentRegex);
	  var matches = rangeComponents[0].match(modifierRegex);
	  !matches ?  false ? invariant(false, 'expected regex to match but it did not') : invariant(false) : void 0;
	
	  return {
	    modifier: matches[1],
	    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
	  };
	}
	
	/**
	 * Determines if `number` is a number.
	 *
	 * @param {mixed} number
	 * @returns {boolean}
	 */
	function isNumber(number) {
	  return !isNaN(number) && isFinite(number);
	}
	
	/**
	 * Tests whether `range` is a "simple" version number without any modifiers
	 * (">", "~" etc).
	 *
	 * @param {string} range
	 * @returns {boolean}
	 */
	function isSimpleVersion(range) {
	  return !getModifierAndComponents(range).modifier;
	}
	
	/**
	 * Zero-pads array `array` until it is at least `length` long.
	 *
	 * @param {array} array
	 * @param {number} length
	 */
	function zeroPad(array, length) {
	  for (var i = array.length; i < length; i++) {
	    array[i] = '0';
	  }
	}
	
	/**
	 * Normalizes `a` and `b` in preparation for comparison by doing the following:
	 *
	 * - zero-pads `a` and `b`
	 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
	 *   in both `a` and `b`
	 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
	 *   and all of its successors in `a`
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {array<array<string>>}
	 */
	function normalizeVersions(a, b) {
	  a = a.slice();
	  b = b.slice();
	
	  zeroPad(a, b.length);
	
	  // mark "x" and "*" components as equal
	  for (var i = 0; i < b.length; i++) {
	    var matches = b[i].match(/^[x*]$/i);
	    if (matches) {
	      b[i] = a[i] = '0';
	
	      // final "*" greedily zeros all remaining components
	      if (matches[0] === '*' && i === b.length - 1) {
	        for (var j = i; j < a.length; j++) {
	          a[j] = '0';
	        }
	      }
	    }
	  }
	
	  zeroPad(b, a.length);
	
	  return [a, b];
	}
	
	/**
	 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
	 *
	 * For example, `10-alpha` is greater than `2-beta`.
	 *
	 * @param {string} a
	 * @param {string} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compareNumeric(a, b) {
	  var aPrefix = a.match(numericRegex)[1];
	  var bPrefix = b.match(numericRegex)[1];
	  var aNumeric = parseInt(aPrefix, 10);
	  var bNumeric = parseInt(bPrefix, 10);
	
	  if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
	    return compare(aNumeric, bNumeric);
	  } else {
	    return compare(a, b);
	  }
	}
	
	/**
	 * Returns the ordering of `a` and `b`.
	 *
	 * @param {string|number} a
	 * @param {string|number} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compare(a, b) {
	  !(typeof a === typeof b) ?  false ? invariant(false, '"a" and "b" must be of the same type') : invariant(false) : void 0;
	
	  if (a > b) {
	    return 1;
	  } else if (a < b) {
	    return -1;
	  } else {
	    return 0;
	  }
	}
	
	/**
	 * Compares arrays of version components.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compareComponents(a, b) {
	  var _normalizeVersions = normalizeVersions(a, b),
	      aNormalized = _normalizeVersions[0],
	      bNormalized = _normalizeVersions[1];
	
	  for (var i = 0; i < bNormalized.length; i++) {
	    var result = compareNumeric(aNormalized[i], bNormalized[i]);
	    if (result) {
	      return result;
	    }
	  }
	
	  return 0;
	}
	
	var VersionRange = {
	  /**
	   * Checks whether `version` satisfies the `range` specification.
	   *
	   * We support a subset of the expressions defined in
	   * https://www.npmjs.org/doc/misc/semver.html:
	   *
	   *    version   Must match version exactly
	   *    =version  Same as just version
	   *    >version  Must be greater than version
	   *    >=version Must be greater than or equal to version
	   *    <version  Must be less than version
	   *    <=version Must be less than or equal to version
	   *    ~version  Must be at least version, but less than the next significant
	   *              revision above version:
	   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
	   *    ~>version Equivalent to ~version
	   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
	   *              anything
	   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
	   *              "greedy" wildcard, so will match any number of additional
	   *              components:
	   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
	   *    *         Any version
	   *    ""        (Empty string) Same as *
	   *    v1 - v2   Equivalent to ">= v1 and <= v2"
	   *    r1 || r2  Passes if either r1 or r2 are satisfied
	   *
	   * @param {string} range
	   * @param {string} version
	   * @returns {boolean}
	   */
	  contains: function contains(range, version) {
	    return checkOrExpression(range.trim(), version.trim());
	  }
	};
	
	module.exports = VersionRange;

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(105);
	
	var createArrayFromMixed = __webpack_require__(675);
	var getMarkupWrap = __webpack_require__(1303);
	var invariant = __webpack_require__(28);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;
	
	/**
	 * Gets the element with the document scroll properties such as `scrollLeft` and
	 * `scrollHeight`. This may differ across different browsers.
	 *
	 * NOTE: The return value can be null if the DOM is not yet ready.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getDocumentScrollElement(doc) {
	  doc = doc || document;
	  if (doc.scrollingElement) {
	    return doc.scrollingElement;
	  }
	  return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
	}
	
	module.exports = getDocumentScrollElement;

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var getElementRect = __webpack_require__(1302);
	
	/**
	 * Gets an element's position in pixels relative to the viewport. The returned
	 * object represents the position of the element's top left corner.
	 *
	 * @param {DOMElement} element
	 * @return {object}
	 */
	function getElementPosition(element) {
	  var rect = getElementRect(element);
	  return {
	    x: rect.left,
	    y: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	}
	
	module.exports = getElementPosition;

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var containsNode = __webpack_require__(335);
	
	/**
	 * Gets an element's bounding rect in pixels relative to the viewport.
	 *
	 * @param {DOMElement} elem
	 * @return {object}
	 */
	function getElementRect(elem) {
	  var docElem = elem.ownerDocument.documentElement;
	
	  // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
	  // IE9- will throw if the element is not in the document.
	  if (!('getBoundingClientRect' in elem) || !containsNode(docElem, elem)) {
	    return {
	      left: 0,
	      right: 0,
	      top: 0,
	      bottom: 0
	    };
	  }
	
	  // Subtracts clientTop/Left because IE8- added a 2px border to the
	  // <html> element (see http://fburl.com/1493213). IE 7 in
	  // Quicksmode does not report clientLeft/clientTop so there
	  // will be an unaccounted offset of 2px when in quirksmode
	  var rect = elem.getBoundingClientRect();
	
	  return {
	    left: Math.round(rect.left) - docElem.clientLeft,
	    right: Math.round(rect.right) - docElem.clientLeft,
	    top: Math.round(rect.top) - docElem.clientTop,
	    bottom: Math.round(rect.bottom) - docElem.clientTop
	  };
	}
	
	module.exports = getElementRect;

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(105);
	
	var invariant = __webpack_require__(28);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var camelize = __webpack_require__(673);
	var hyphenate = __webpack_require__(678);
	
	function asString(value) /*?string*/{
	  return value == null ? value : String(value);
	}
	
	function getStyleProperty( /*DOMNode*/node, /*string*/name) /*?string*/{
	  var computedStyle = void 0;
	
	  // W3C Standard
	  if (window.getComputedStyle) {
	    // In certain cases such as within an iframe in FF3, this returns null.
	    computedStyle = window.getComputedStyle(node, null);
	    if (computedStyle) {
	      return asString(computedStyle.getPropertyValue(hyphenate(name)));
	    }
	  }
	  // Safari
	  if (document.defaultView && document.defaultView.getComputedStyle) {
	    computedStyle = document.defaultView.getComputedStyle(node, null);
	    // A Safari bug causes this to return null for `display: none` elements.
	    if (computedStyle) {
	      return asString(computedStyle.getPropertyValue(hyphenate(name)));
	    }
	    if (name === 'display') {
	      return 'none';
	    }
	  }
	  // Internet Explorer
	  if (node.currentStyle) {
	    if (name === 'float') {
	      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
	    }
	    return asString(node.currentStyle[camelize(name)]);
	  }
	  return asString(node.style && node.style[camelize(name)]);
	}
	
	module.exports = getStyleProperty;

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

	"use strict";
	
	function getViewportWidth() {
	  var width = void 0;
	  if (document.documentElement) {
	    width = document.documentElement.clientWidth;
	  }
	
	  if (!width && document.body) {
	    width = document.body.clientWidth;
	  }
	
	  return width || 0;
	} /**
	   * Copyright (c) 2013-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   * @typechecks
	   */
	
	function getViewportHeight() {
	  var height = void 0;
	  if (document.documentElement) {
	    height = document.documentElement.clientHeight;
	  }
	
	  if (!height && document.body) {
	    height = document.body.clientHeight;
	  }
	
	  return height || 0;
	}
	
	/**
	 * Gets the viewport dimensions including any scrollbars.
	 */
	function getViewportDimensions() {
	  return {
	    width: window.innerWidth || getViewportWidth(),
	    height: window.innerHeight || getViewportHeight()
	  };
	}
	
	/**
	 * Gets the viewport dimensions excluding any scrollbars.
	 */
	getViewportDimensions.withoutScrollbars = function () {
	  return {
	    width: getViewportWidth(),
	    height: getViewportHeight()
	  };
	};
	
	module.exports = getViewportDimensions;

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(1306);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Combines multiple className strings into one.
	 * http://jsperf.com/joinclasses-args-vs-array
	 *
	 * @param {...?string} className
	 * @return {string}
	 */
	
	function joinClasses(className /*, ... */) {
	  if (!className) {
	    className = '';
	  }
	  var nextClass = void 0;
	  var argLength = arguments.length;
	  if (argLength > 1) {
	    for (var ii = 1; ii < argLength; ii++) {
	      nextClass = arguments[ii];
	      if (nextClass) {
	        className = (className ? className + ' ' : '') + nextClass;
	      }
	    }
	  }
	  return className;
	}
	
	module.exports = joinClasses;

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	// setimmediate adds setImmediate to the global. We want to make sure we export
	// the actual function.
	
	__webpack_require__(921);
	module.exports = global.setImmediate;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f51b337e81a28b331543f8f04c7df6aa.png";

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowStart: true,
	  gridRowEnd: true,
	  gridColumn: true,
	  gridColumnStart: true,
	  gridColumnEnd: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	
	  /**
	   * @param {string} prefix vendor-specific prefix, eg: Webkit
	   * @param {string} key style name, eg: transitionDuration
	   * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	   * WebkitTransitionDuration
	   */
	};function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	exports.default = CSSProperty;

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CSSProperty = __webpack_require__(1312);
	
	var _CSSProperty2 = _interopRequireDefault(_CSSProperty);
	
	var _warning = __webpack_require__(61);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 */
	
	var isUnitlessNumber = _CSSProperty2.default.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	exports.default = dangerousStyleValue;

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = clean;
	// Returns true for null, false, undefined and {}
	function isFalsy(value) {
	  return value === null || value === undefined || value === false || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && Object.keys(value).length === 0;
	}
	
	function cleanObject(object) {
	  if (isFalsy(object)) return null;
	  if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') return object;
	
	  var acc = {},
	      keys = Object.keys(object),
	      hasFalsy = false;
	  for (var i = 0; i < keys.length; i++) {
	    var value = object[keys[i]];
	    var filteredValue = clean(value);
	    if (filteredValue === null || filteredValue !== value) {
	      hasFalsy = true;
	    }
	    if (filteredValue !== null) {
	      acc[keys[i]] = filteredValue;
	    }
	  }
	  return Object.keys(acc).length === 0 ? null : hasFalsy ? acc : object;
	}
	
	function cleanArray(rules) {
	  var hasFalsy = false;
	  var filtered = [];
	  rules.forEach(function (rule) {
	    var filteredRule = clean(rule);
	    if (filteredRule === null || filteredRule !== rule) {
	      hasFalsy = true;
	    }
	    if (filteredRule !== null) {
	      filtered.push(filteredRule);
	    }
	  });
	  return filtered.length == 0 ? null : hasFalsy ? filtered : rules;
	}
	
	// Takes style array or object provided by user and clears all the falsy data 
	// If there is no styles left after filtration returns null
	function clean(input) {
	  return Array.isArray(input) ? cleanArray(input) : cleanObject(input);
	}

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = doHash;
	// murmurhash2 via https://gist.github.com/raycmorgan/588423
	
	function doHash(str, seed) {
	  var m = 0x5bd1e995;
	  var r = 24;
	  var h = seed ^ str.length;
	  var length = str.length;
	  var currentIndex = 0;
	
	  while (length >= 4) {
	    var k = UInt32(str, currentIndex);
	
	    k = Umul32(k, m);
	    k ^= k >>> r;
	    k = Umul32(k, m);
	
	    h = Umul32(h, m);
	    h ^= k;
	
	    currentIndex += 4;
	    length -= 4;
	  }
	
	  switch (length) {
	    case 3:
	      h ^= UInt16(str, currentIndex);
	      h ^= str.charCodeAt(currentIndex + 2) << 16;
	      h = Umul32(h, m);
	      break;
	
	    case 2:
	      h ^= UInt16(str, currentIndex);
	      h = Umul32(h, m);
	      break;
	
	    case 1:
	      h ^= str.charCodeAt(currentIndex);
	      h = Umul32(h, m);
	      break;
	  }
	
	  h ^= h >>> 13;
	  h = Umul32(h, m);
	  h ^= h >>> 15;
	
	  return h >>> 0;
	}
	
	function UInt32(str, pos) {
	  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
	}
	
	function UInt16(str, pos) {
	  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
	}
	
	function Umul32(n, m) {
	  n = n | 0;
	  m = m | 0;
	  var nlo = n & 0xffff;
	  var nhi = n >>> 16;
	  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
	  return res;
	}

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.compose = exports.merge = exports.$ = exports.style = exports.presets = exports.keyframes = exports.fontFace = exports.insertGlobal = exports.insertRule = exports.plugins = exports.styleSheet = undefined;
	exports.speedy = speedy;
	exports.simulations = simulations;
	exports.simulate = simulate;
	exports.cssLabels = cssLabels;
	exports.isLikeRule = isLikeRule;
	exports.idFor = idFor;
	exports.css = css;
	exports.rehydrate = rehydrate;
	exports.flush = flush;
	exports.select = select;
	exports.parent = parent;
	exports.media = media;
	exports.pseudo = pseudo;
	exports.active = active;
	exports.any = any;
	exports.checked = checked;
	exports.disabled = disabled;
	exports.empty = empty;
	exports.enabled = enabled;
	exports._default = _default;
	exports.first = first;
	exports.firstChild = firstChild;
	exports.firstOfType = firstOfType;
	exports.fullscreen = fullscreen;
	exports.focus = focus;
	exports.hover = hover;
	exports.indeterminate = indeterminate;
	exports.inRange = inRange;
	exports.invalid = invalid;
	exports.lastChild = lastChild;
	exports.lastOfType = lastOfType;
	exports.left = left;
	exports.link = link;
	exports.onlyChild = onlyChild;
	exports.onlyOfType = onlyOfType;
	exports.optional = optional;
	exports.outOfRange = outOfRange;
	exports.readOnly = readOnly;
	exports.readWrite = readWrite;
	exports.required = required;
	exports.right = right;
	exports.root = root;
	exports.scope = scope;
	exports.target = target;
	exports.valid = valid;
	exports.visited = visited;
	exports.dir = dir;
	exports.lang = lang;
	exports.not = not;
	exports.nthChild = nthChild;
	exports.nthLastChild = nthLastChild;
	exports.nthLastOfType = nthLastOfType;
	exports.nthOfType = nthOfType;
	exports.after = after;
	exports.before = before;
	exports.firstLetter = firstLetter;
	exports.firstLine = firstLine;
	exports.selection = selection;
	exports.backdrop = backdrop;
	exports.placeholder = placeholder;
	exports.cssFor = cssFor;
	exports.attribsFor = attribsFor;
	
	var _objectAssign = __webpack_require__(40);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _sheet = __webpack_require__(1319);
	
	var _CSSPropertyOperations = __webpack_require__(679);
	
	var _clean = __webpack_require__(1314);
	
	var _clean2 = _interopRequireDefault(_clean);
	
	var _plugins = __webpack_require__(1317);
	
	var _hash = __webpack_require__(1315);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	/* stylesheet */
	
	
	var styleSheet = exports.styleSheet = new _sheet.StyleSheet();
	// an isomorphic StyleSheet shim. hides all the nitty gritty.
	
	// /**************** LIFTOFF IN 3... 2... 1... ****************/
	styleSheet.inject(); //eslint-disable-line indent
	// /****************      TO THE MOOOOOOON     ****************/
	
	// convenience function to toggle speedy
	function speedy(bool) {
	  return styleSheet.speedy(bool);
	}
	
	// plugins
	// we include these by default
	var plugins = exports.plugins = styleSheet.plugins = new _plugins.PluginSet([_plugins.prefixes, _plugins.contentWrap, _plugins.fallbacks]);
	plugins.media = new _plugins.PluginSet(); // neat! media, font-face, keyframes
	plugins.fontFace = new _plugins.PluginSet();
	plugins.keyframes = new _plugins.PluginSet([_plugins.prefixes, _plugins.fallbacks]);
	
	// define some constants
	
	var isDev = ("production") === 'development' || !("production");
	var isTest = ("production") === 'test';
	var isBrowser = typeof window !== 'undefined';
	
	/**** simulations  ****/
	
	// a flag to enable simulation meta tags on dom nodes
	// defaults to true in dev mode. recommend *not* to
	// toggle often.
	var canSimulate = isDev;
	
	// we use these flags for issuing warnings when simulate is called
	// in prod / in incorrect order
	var warned1 = false,
	    warned2 = false;
	
	// toggles simulation activity. shouldn't be needed in most cases
	function simulations() {
	  var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	  canSimulate = !!bool;
	}
	
	// use this on dom nodes to 'simulate' pseudoclasses
	// <div {...hover({ color: 'red' })} {...simulate('hover', 'visited')}>...</div>
	// you can even send in some weird ones, as long as it's in simple format
	// and matches an existing rule on the element
	// eg simulate('nthChild2', ':hover:active') etc
	function simulate() {
	  for (var _len = arguments.length, pseudos = Array(_len), _key = 0; _key < _len; _key++) {
	    pseudos[_key] = arguments[_key];
	  }
	
	  pseudos = (0, _clean2.default)(pseudos);
	  if (!pseudos) return {};
	  if (!canSimulate) {
	    if (!warned1) {
	      console.warn('can\'t simulate without once calling simulations(true)'); //eslint-disable-line no-console
	      warned1 = true;
	    }
	    if (!isDev && !isTest && !warned2) {
	      console.warn('don\'t use simulation outside dev'); //eslint-disable-line no-console
	      warned2 = true;
	    }
	    return {};
	  }
	  return pseudos.reduce(function (o, p) {
	    return o['data-simulate-' + simple(p)] = '', o;
	  }, {});
	}
	
	/**** labels ****/
	// toggle for debug labels.
	// *shouldn't* have to mess with this manually
	var hasLabels = isDev;
	
	function cssLabels(bool) {
	  hasLabels = !!bool;
	}
	
	// takes a string, converts to lowercase, strips out nonalphanumeric.
	function simple(str) {
	  var char = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  return str.toLowerCase().replace(/[^a-z0-9]/g, char);
	}
	
	// hashes a string to something 'unique'
	// we use this to generate ids for styles
	
	
	function hashify(obj) {
	  var str = JSON.stringify(obj);
	  var toRet = (0, _hash2.default)(str).toString(36);
	  if (obj.label && obj.label.length > 0 && isDev) {
	    return simple(obj.label.join('.'), '-') + '-' + toRet;
	  }
	  return toRet;
	}
	
	// of shape { 'data-css-<id>': '' }
	function isLikeRule(rule) {
	  var keys = Object.keys(rule).filter(function (x) {
	    return x !== 'toString';
	  });
	  if (keys.length !== 1) {
	    return false;
	  }
	  return !!/data\-css\-([a-zA-Z0-9\-_]+)/.exec(keys[0]);
	}
	
	// extracts id from a { 'data-css-<id>': ''} like object
	function idFor(rule) {
	  var keys = Object.keys(rule).filter(function (x) {
	    return x !== 'toString';
	  });
	  if (keys.length !== 1) throw new Error('not a rule');
	  var regex = /data\-css\-([a-zA-Z0-9\-_]+)/;
	  var match = regex.exec(keys[0]);
	  if (!match) throw new Error('not a rule');
	  return match[1];
	}
	
	// from https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61
	
	// "Tokenizes" the selectors into parts relevant for the next function.
	// Strings and comments are matched, but ignored afterwards.
	// This is not a full tokenizers. It only recognizes comas, parentheses,
	// strings and comments.
	// regexp generated by scripts/regexps.js then trimmed by hand
	var selectorTokenizer = /[(),]|"(?:\\.|[^"\n])*"|'(?:\\.|[^'\n])*'|\/\*[\s\S]*?\*\//g;
	
	/**
	 * This will split a coma-separated selector list into individual selectors,
	 * ignoring comas in strings, comments and in :pseudo-selectors(parameter, lists).
	 *
	 * @param {string} selector
	 * @return {string[]}
	 */
	
	function splitSelector(selector) {
	  if (selector.indexOf(',') === -1) {
	    return [selector];
	  }
	
	  var indices = [],
	      res = [],
	      inParen = 0,
	      o;
	  /*eslint-disable no-cond-assign*/
	  while (o = selectorTokenizer.exec(selector)) {
	    /*eslint-enable no-cond-assign*/
	    switch (o[0]) {
	      case '(':
	        inParen++;break;
	      case ')':
	        inParen--;break;
	      case ',':
	        if (inParen) break;indices.push(o.index);
	    }
	  }
	  for (o = indices.length; o--;) {
	    res.unshift(selector.slice(indices[o] + 1));
	    selector = selector.slice(0, indices[o]);
	  }
	  res.unshift(selector);
	  return res;
	}
	
	function selector(id, path) {
	  if (!id) {
	    return path.replace(/\&/g, '');
	  }
	  if (!path) return '.css-' + id + ',[data-css-' + id + ']';
	
	  var x = splitSelector(path).map(function (x) {
	    return x.indexOf('&') >= 0 ? [x.replace(/\&/mg, '.css-' + id), x.replace(/\&/mg, '[data-css-' + id + ']')].join(',') // todo - make sure each sub selector has an &
	    : '.css-' + id + x + ',[data-css-' + id + ']' + x;
	  }).join(',');
	
	  if (canSimulate && /^\&\:/.exec(path) && !/\s/.exec(path)) {
	    x += ',.css-' + id + '[data-simulate-' + simple(path) + '],[data-css-' + id + '][data-simulate-' + simple(path) + ']';
	  }
	  return x;
	}
	
	// end https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61
	
	
	function toCSS(_ref) {
	  var selector = _ref.selector,
	      style = _ref.style;
	
	  var result = plugins.transform({ selector: selector, style: style });
	  return result.selector + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
	}
	
	function deconstruct(style) {
	  // we can be sure it's not infinitely nested here
	  var plain = void 0,
	      selects = void 0,
	      medias = void 0,
	      supports = void 0;
	  Object.keys(style).forEach(function (key) {
	    if (key.indexOf('&') >= 0) {
	      selects = selects || {};
	      selects[key] = style[key];
	    } else if (key.indexOf('@media') === 0) {
	      medias = medias || {};
	      medias[key] = deconstruct(style[key]);
	    } else if (key.indexOf('@supports') === 0) {
	      supports = supports || {};
	      supports[key] = deconstruct(style[key]);
	    } else if (key === 'label') {
	      if (style.label.length > 0) {
	        plain = plain || {};
	        plain.label = hasLabels ? style.label.join('.') : '';
	      }
	    } else {
	      plain = plain || {};
	      plain[key] = style[key];
	    }
	  });
	  return { plain: plain, selects: selects, medias: medias, supports: supports };
	}
	
	function deconstructedStyleToCSS(id, style) {
	  var css = [];
	
	  // plugins here
	  var plain = style.plain,
	      selects = style.selects,
	      medias = style.medias,
	      supports = style.supports;
	
	  if (plain) {
	    css.push(toCSS({ style: plain, selector: selector(id) }));
	  }
	  if (selects) {
	    Object.keys(selects).forEach(function (key) {
	      return css.push(toCSS({ style: selects[key], selector: selector(id, key) }));
	    });
	  }
	  if (medias) {
	    Object.keys(medias).forEach(function (key) {
	      return css.push(key + '{' + deconstructedStyleToCSS(id, medias[key]).join('') + '}');
	    });
	  }
	  if (supports) {
	    Object.keys(supports).forEach(function (key) {
	      return css.push(key + '{' + deconstructedStyleToCSS(id, supports[key]).join('') + '}');
	    });
	  }
	  return css;
	}
	
	// this cache to track which rules have
	// been inserted into the stylesheet
	var inserted = styleSheet.inserted = {};
	
	// and helpers to insert rules into said styleSheet
	function insert(spec) {
	  if (!inserted[spec.id]) {
	    inserted[spec.id] = true;
	    var deconstructed = deconstruct(spec.style);
	    var rules = deconstructedStyleToCSS(spec.id, deconstructed);
	    inserted[spec.id] = isBrowser ? true : rules;
	    rules.forEach(function (cssRule) {
	      return styleSheet.insert(cssRule);
	    });
	  }
	}
	
	// a simple cache to store generated rules
	var registered = styleSheet.registered = {};
	function register(spec) {
	  if (!registered[spec.id]) {
	    registered[spec.id] = spec;
	  }
	}
	
	function _getRegistered(rule) {
	  if (isLikeRule(rule)) {
	    var ret = registered[idFor(rule)];
	    if (ret == null) {
	      throw new Error('[glamor] an unexpected rule cache miss occurred. This is probably a sign of multiple glamor instances in your app. See https://github.com/threepointone/glamor/issues/79');
	    }
	    return ret;
	  }
	  return rule;
	}
	
	// todo - perf
	var ruleCache = {};
	function toRule(spec) {
	  register(spec);
	  insert(spec);
	
	  if (ruleCache[spec.id]) {
	    return ruleCache[spec.id];
	  }
	
	  var ret = _defineProperty({}, 'data-css-' + spec.id, hasLabels ? spec.label || '' : '');
	  Object.defineProperty(ret, 'toString', {
	    enumerable: false, value: function value() {
	      return 'css-' + spec.id;
	    }
	  });
	  ruleCache[spec.id] = ret;
	  return ret;
	}
	
	function log() {
	  //eslint-disable-line no-unused-vars
	  console.log(this); //eslint-disable-line no-console
	  return this;
	}
	
	function isSelector(key) {
	  var possibles = [':', '.', '[', '>', ' '],
	      found = false,
	      ch = key.charAt(0);
	  for (var i = 0; i < possibles.length; i++) {
	    if (ch === possibles[i]) {
	      found = true;
	      break;
	    }
	  }
	  return found || key.indexOf('&') >= 0;
	}
	
	function joinSelectors(a, b) {
	  var as = splitSelector(a).map(function (a) {
	    return !(a.indexOf('&') >= 0) ? '&' + a : a;
	  });
	  var bs = splitSelector(b).map(function (b) {
	    return !(b.indexOf('&') >= 0) ? '&' + b : b;
	  });
	
	  return bs.reduce(function (arr, b) {
	    return arr.concat(as.map(function (a) {
	      return b.replace(/\&/g, a);
	    }));
	  }, []).join(',');
	}
	
	function joinMediaQueries(a, b) {
	  return a ? '@media ' + a.substring(6) + ' and ' + b.substring(6) : b;
	}
	
	function isMediaQuery(key) {
	  return key.indexOf('@media') === 0;
	}
	
	function isSupports(key) {
	  return key.indexOf('@supports') === 0;
	}
	
	function joinSupports(a, b) {
	  return a ? '@supports ' + a.substring(9) + ' and ' + b.substring(9) : b;
	}
	
	// flatten a nested array
	function flatten(inArr) {
	  var arr = [];
	  for (var i = 0; i < inArr.length; i++) {
	    if (Array.isArray(inArr[i])) arr = arr.concat(flatten(inArr[i]));else arr = arr.concat(inArr[i]);
	  }
	  return arr;
	}
	
	var prefixedPseudoSelectors = {
	  '::placeholder': ['::-webkit-input-placeholder', '::-moz-placeholder', '::-ms-input-placeholder'],
	  ':fullscreen': [':-webkit-full-screen', ':-moz-full-screen', ':-ms-fullscreen']
	
	  // mutable! modifies dest.
	};function build(dest, _ref2) {
	  var _ref2$selector = _ref2.selector,
	      selector = _ref2$selector === undefined ? '' : _ref2$selector,
	      _ref2$mq = _ref2.mq,
	      mq = _ref2$mq === undefined ? '' : _ref2$mq,
	      _ref2$supp = _ref2.supp,
	      supp = _ref2$supp === undefined ? '' : _ref2$supp,
	      _ref2$src = _ref2.src,
	      src = _ref2$src === undefined ? {} : _ref2$src;
	
	
	  if (!Array.isArray(src)) {
	    src = [src];
	  }
	  src = flatten(src);
	
	  src.forEach(function (_src) {
	    if (isLikeRule(_src)) {
	      var reg = _getRegistered(_src);
	      if (reg.type !== 'css') {
	        throw new Error('cannot merge this rule');
	      }
	      _src = reg.style;
	    }
	    _src = (0, _clean2.default)(_src);
	    if (_src && _src.composes) {
	      build(dest, { selector: selector, mq: mq, supp: supp, src: _src.composes });
	    }
	    Object.keys(_src || {}).forEach(function (key) {
	      if (isSelector(key)) {
	
	        if (prefixedPseudoSelectors[key]) {
	          prefixedPseudoSelectors[key].forEach(function (p) {
	            return build(dest, { selector: joinSelectors(selector, p), mq: mq, supp: supp, src: _src[key] });
	          });
	        }
	
	        build(dest, { selector: joinSelectors(selector, key), mq: mq, supp: supp, src: _src[key] });
	      } else if (isMediaQuery(key)) {
	        build(dest, { selector: selector, mq: joinMediaQueries(mq, key), supp: supp, src: _src[key] });
	      } else if (isSupports(key)) {
	        build(dest, { selector: selector, mq: mq, supp: joinSupports(supp, key), src: _src[key] });
	      } else if (key === 'composes') {
	        // ignore, we already dealth with it
	      } else {
	        var _dest = dest;
	        if (supp) {
	          _dest[supp] = _dest[supp] || {};
	          _dest = _dest[supp];
	        }
	        if (mq) {
	          _dest[mq] = _dest[mq] || {};
	          _dest = _dest[mq];
	        }
	        if (selector) {
	          _dest[selector] = _dest[selector] || {};
	          _dest = _dest[selector];
	        }
	
	        if (key === 'label') {
	          if (hasLabels) {
	            dest.label = dest.label.concat(_src.label);
	          }
	        } else {
	          _dest[key] = _src[key];
	        }
	      }
	    });
	  });
	}
	
	function _css(rules) {
	  var style = { label: [] };
	  build(style, { src: rules }); // mutative! but worth it.
	
	  var spec = {
	    id: hashify(style),
	    style: style, label: hasLabels ? style.label.join('.') : '',
	    type: 'css'
	  };
	  return toRule(spec);
	}
	
	var nullrule = {
	  // 'data-css-nil': ''
	};
	Object.defineProperty(nullrule, 'toString', {
	  enumerable: false, value: function value() {
	    return 'css-nil';
	  }
	});
	
	var inputCaches = typeof WeakMap !== 'undefined' ? [nullrule, new WeakMap(), new WeakMap(), new WeakMap()] : [nullrule];
	
	var warnedWeakMapError = false;
	function multiIndexCache(fn) {
	  return function (args) {
	    if (inputCaches[args.length]) {
	      var coi = inputCaches[args.length];
	      var ctr = 0;
	      while (ctr < args.length - 1) {
	        if (!coi.has(args[ctr])) {
	          coi.set(args[ctr], new WeakMap());
	        }
	        coi = coi.get(args[ctr]);
	        ctr++;
	      }
	      if (coi.has(args[args.length - 1])) {
	        var ret = coi.get(args[ctr]);
	
	        if (registered[ret.toString().substring(4)]) {
	          // make sure it hasn't been flushed
	          return ret;
	        }
	      }
	    }
	    var value = fn(args);
	    if (inputCaches[args.length]) {
	      var _ctr = 0,
	          _coi = inputCaches[args.length];
	      while (_ctr < args.length - 1) {
	        _coi = _coi.get(args[_ctr]);
	        _ctr++;
	      }
	      try {
	        _coi.set(args[_ctr], value);
	      } catch (err) {
	        if (isDev && !warnedWeakMapError) {
	          var _console;
	
	          warnedWeakMapError = true;
	          (_console = console).warn.apply(_console, ['failed setting the WeakMap cache for args:'].concat(_toConsumableArray(args))); // eslint-disable-line no-console
	          console.warn('this should NOT happen, please file a bug on the github repo.'); // eslint-disable-line no-console
	        }
	      }
	    }
	    return value;
	  };
	}
	
	var cachedCss = typeof WeakMap !== 'undefined' ? multiIndexCache(_css) : _css;
	
	function css() {
	  for (var _len2 = arguments.length, rules = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    rules[_key2] = arguments[_key2];
	  }
	
	  if (rules[0] && rules[0].length && rules[0].raw) {
	    throw new Error('you forgot to include glamor/babel in your babel plugins.');
	  }
	
	  rules = (0, _clean2.default)(rules);
	  if (!rules) {
	    return nullrule;
	  }
	
	  return cachedCss(rules);
	}
	
	css.insert = function (css) {
	  var spec = {
	    id: hashify(css),
	    css: css,
	    type: 'raw'
	  };
	  register(spec);
	  if (!inserted[spec.id]) {
	    styleSheet.insert(spec.css);
	    inserted[spec.id] = isBrowser ? true : [spec.css];
	  }
	};
	
	var insertRule = exports.insertRule = css.insert;
	
	css.global = function (selector, style) {
	  style = (0, _clean2.default)(style);
	  if (style) {
	    return css.insert(toCSS({ selector: selector, style: style }));
	  }
	};
	
	var insertGlobal = exports.insertGlobal = css.global;
	
	function insertKeyframe(spec) {
	  if (!inserted[spec.id]) {
	    var inner = Object.keys(spec.keyframes).map(function (kf) {
	      var result = plugins.keyframes.transform({ id: spec.id, name: kf, style: spec.keyframes[kf] });
	      return result.name + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
	    }).join('');
	
	    var rules = ['-webkit-', '-moz-', '-o-', ''].map(function (prefix) {
	      return '@' + prefix + 'keyframes ' + (spec.name + '_' + spec.id) + '{' + inner + '}';
	    });
	    rules.forEach(function (rule) {
	      return styleSheet.insert(rule);
	    });
	
	    inserted[spec.id] = isBrowser ? true : rules;
	  }
	}
	css.keyframes = function (name, kfs) {
	  if (!kfs) {
	    kfs = name, name = 'animation';
	  }
	
	  // do not ignore empty keyframe definitions for now.
	  kfs = (0, _clean2.default)(kfs) || {};
	  var spec = {
	    id: hashify({ name: name, kfs: kfs }),
	    type: 'keyframes',
	    name: name,
	    keyframes: kfs
	  };
	  register(spec);
	  insertKeyframe(spec);
	  return name + '_' + spec.id;
	};
	
	// we don't go all out for fonts as much, giving a simple font loading strategy
	// use a fancier lib if you need moar power
	css.fontFace = function (font) {
	  font = (0, _clean2.default)(font);
	  var spec = {
	    id: hashify(font),
	    type: 'font-face',
	    font: font
	  };
	  register(spec);
	  insertFontFace(spec);
	
	  return font.fontFamily;
	};
	
	var fontFace = exports.fontFace = css.fontFace;
	var keyframes = exports.keyframes = css.keyframes;
	
	function insertFontFace(spec) {
	  if (!inserted[spec.id]) {
	    var rule = '@font-face{' + (0, _CSSPropertyOperations.createMarkupForStyles)(spec.font) + '}';
	    styleSheet.insert(rule);
	    inserted[spec.id] = isBrowser ? true : [rule];
	  }
	}
	
	// rehydrate the insertion cache with ids sent from
	// renderStatic / renderStaticOptimized
	function rehydrate(ids) {
	  // load up ids
	  (0, _objectAssign2.default)(inserted, ids.reduce(function (o, i) {
	    return o[i] = true, o;
	  }, {}));
	  // assume css loaded separately
	}
	
	// clears out the cache and empties the stylesheet
	// best for tests, though there might be some value for SSR.
	
	function flush() {
	  inserted = styleSheet.inserted = {};
	  registered = styleSheet.registered = {};
	  ruleCache = {};
	  styleSheet.flush();
	  styleSheet.inject();
	}
	
	var presets = exports.presets = {
	  mobile: '(min-width: 400px)',
	  Mobile: '@media (min-width: 400px)',
	  phablet: '(min-width: 550px)',
	  Phablet: '@media (min-width: 550px)',
	  tablet: '(min-width: 750px)',
	  Tablet: '@media (min-width: 750px)',
	  desktop: '(min-width: 1000px)',
	  Desktop: '@media (min-width: 1000px)',
	  hd: '(min-width: 1200px)',
	  Hd: '@media (min-width: 1200px)'
	};
	
	var style = exports.style = css;
	
	function select(selector) {
	  for (var _len3 = arguments.length, styles = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    styles[_key3 - 1] = arguments[_key3];
	  }
	
	  if (!selector) {
	    return style(styles);
	  }
	  return css(_defineProperty({}, selector, styles));
	}
	var $ = exports.$ = select;
	
	function parent(selector) {
	  for (var _len4 = arguments.length, styles = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    styles[_key4 - 1] = arguments[_key4];
	  }
	
	  return css(_defineProperty({}, selector + ' &', styles));
	}
	
	var merge = exports.merge = css;
	var compose = exports.compose = css;
	
	function media(query) {
	  for (var _len5 = arguments.length, rules = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    rules[_key5 - 1] = arguments[_key5];
	  }
	
	  return css(_defineProperty({}, '@media ' + query, rules));
	}
	
	function pseudo(selector) {
	  for (var _len6 = arguments.length, styles = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	    styles[_key6 - 1] = arguments[_key6];
	  }
	
	  return css(_defineProperty({}, selector, styles));
	}
	
	// allllll the pseudoclasses
	
	function active(x) {
	  return pseudo(':active', x);
	}
	
	function any(x) {
	  return pseudo(':any', x);
	}
	
	function checked(x) {
	  return pseudo(':checked', x);
	}
	
	function disabled(x) {
	  return pseudo(':disabled', x);
	}
	
	function empty(x) {
	  return pseudo(':empty', x);
	}
	
	function enabled(x) {
	  return pseudo(':enabled', x);
	}
	
	function _default(x) {
	  return pseudo(':default', x); // note '_default' name
	}
	
	function first(x) {
	  return pseudo(':first', x);
	}
	
	function firstChild(x) {
	  return pseudo(':first-child', x);
	}
	
	function firstOfType(x) {
	  return pseudo(':first-of-type', x);
	}
	
	function fullscreen(x) {
	  return pseudo(':fullscreen', x);
	}
	
	function focus(x) {
	  return pseudo(':focus', x);
	}
	
	function hover(x) {
	  return pseudo(':hover', x);
	}
	
	function indeterminate(x) {
	  return pseudo(':indeterminate', x);
	}
	
	function inRange(x) {
	  return pseudo(':in-range', x);
	}
	
	function invalid(x) {
	  return pseudo(':invalid', x);
	}
	
	function lastChild(x) {
	  return pseudo(':last-child', x);
	}
	
	function lastOfType(x) {
	  return pseudo(':last-of-type', x);
	}
	
	function left(x) {
	  return pseudo(':left', x);
	}
	
	function link(x) {
	  return pseudo(':link', x);
	}
	
	function onlyChild(x) {
	  return pseudo(':only-child', x);
	}
	
	function onlyOfType(x) {
	  return pseudo(':only-of-type', x);
	}
	
	function optional(x) {
	  return pseudo(':optional', x);
	}
	
	function outOfRange(x) {
	  return pseudo(':out-of-range', x);
	}
	
	function readOnly(x) {
	  return pseudo(':read-only', x);
	}
	
	function readWrite(x) {
	  return pseudo(':read-write', x);
	}
	
	function required(x) {
	  return pseudo(':required', x);
	}
	
	function right(x) {
	  return pseudo(':right', x);
	}
	
	function root(x) {
	  return pseudo(':root', x);
	}
	
	function scope(x) {
	  return pseudo(':scope', x);
	}
	
	function target(x) {
	  return pseudo(':target', x);
	}
	
	function valid(x) {
	  return pseudo(':valid', x);
	}
	
	function visited(x) {
	  return pseudo(':visited', x);
	}
	
	// parameterized pseudoclasses
	function dir(p, x) {
	  return pseudo(':dir(' + p + ')', x);
	}
	function lang(p, x) {
	  return pseudo(':lang(' + p + ')', x);
	}
	function not(p, x) {
	  // should this be a plugin?
	  var selector = p.split(',').map(function (x) {
	    return x.trim();
	  }).map(function (x) {
	    return ':not(' + x + ')';
	  });
	  if (selector.length === 1) {
	    return pseudo(':not(' + p + ')', x);
	  }
	  return select(selector.join(''), x);
	}
	function nthChild(p, x) {
	  return pseudo(':nth-child(' + p + ')', x);
	}
	function nthLastChild(p, x) {
	  return pseudo(':nth-last-child(' + p + ')', x);
	}
	function nthLastOfType(p, x) {
	  return pseudo(':nth-last-of-type(' + p + ')', x);
	}
	function nthOfType(p, x) {
	  return pseudo(':nth-of-type(' + p + ')', x);
	}
	
	// pseudoelements
	function after(x) {
	  return pseudo('::after', x);
	}
	function before(x) {
	  return pseudo('::before', x);
	}
	function firstLetter(x) {
	  return pseudo('::first-letter', x);
	}
	function firstLine(x) {
	  return pseudo('::first-line', x);
	}
	function selection(x) {
	  return pseudo('::selection', x);
	}
	function backdrop(x) {
	  return pseudo('::backdrop', x);
	}
	function placeholder(x) {
	  // https://github.com/threepointone/glamor/issues/14
	  return css({ '::placeholder': x });
	}
	
	/*** helpers for web components ***/
	// https://github.com/threepointone/glamor/issues/16
	
	function cssFor() {
	  for (var _len7 = arguments.length, rules = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	    rules[_key7] = arguments[_key7];
	  }
	
	  rules = (0, _clean2.default)(rules);
	  return rules ? rules.map(function (r) {
	    var style = { label: [] };
	    build(style, { src: r }); // mutative! but worth it.
	    return deconstructedStyleToCSS(hashify(style), deconstruct(style)).join('');
	  }).join('') : '';
	}
	
	function attribsFor() {
	  for (var _len8 = arguments.length, rules = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	    rules[_key8] = arguments[_key8];
	  }
	
	  rules = (0, _clean2.default)(rules);
	  var htmlAttributes = rules ? rules.map(function (rule) {
	    idFor(rule); // throwaway check for rule
	    var key = Object.keys(rule)[0],
	        value = rule[key];
	    return key + '="' + (value || '') + '"';
	  }).join(' ') : '';
	
	  return htmlAttributes;
	}

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.PluginSet = PluginSet;
	exports.fallbacks = fallbacks;
	exports.contentWrap = contentWrap;
	exports.prefixes = prefixes;
	
	var _objectAssign = __webpack_require__(40);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _CSSPropertyOperations = __webpack_require__(679);
	
	var _prefixer = __webpack_require__(1318);
	
	var _prefixer2 = _interopRequireDefault(_prefixer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isDev = function (x) {
	  return x === 'development' || !x;
	}(("production"));
	
	function PluginSet(initial) {
	  this.fns = initial || [];
	}
	
	(0, _objectAssign2.default)(PluginSet.prototype, {
	  add: function add() {
	    var _this = this;
	
	    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
	      fns[_key] = arguments[_key];
	    }
	
	    fns.forEach(function (fn) {
	      if (_this.fns.indexOf(fn) >= 0) {
	        if (isDev) {
	          console.warn('adding the same plugin again, ignoring'); //eslint-disable-line no-console
	        }
	      } else {
	        _this.fns = [fn].concat(_this.fns);
	      }
	    });
	  },
	  remove: function remove(fn) {
	    this.fns = this.fns.filter(function (x) {
	      return x !== fn;
	    });
	  },
	  clear: function clear() {
	    this.fns = [];
	  },
	  transform: function transform(o) {
	    return this.fns.reduce(function (o, fn) {
	      return fn(o);
	    }, o);
	  }
	});
	
	function fallbacks(node) {
	  var hasArray = Object.keys(node.style).map(function (x) {
	    return Array.isArray(node.style[x]);
	  }).indexOf(true) >= 0;
	  if (hasArray) {
	    var style = node.style;
	
	    var flattened = Object.keys(style).reduce(function (o, key) {
	      o[key] = Array.isArray(style[key]) ? style[key].join('; ' + (0, _CSSPropertyOperations.processStyleName)(key) + ': ') : style[key];
	      return o;
	    }, {});
	    // todo - 
	    // flatten arrays which haven't been flattened yet 
	    return (0, _objectAssign2.default)({}, node, { style: flattened });
	  }
	  return node;
	}
	
	var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit'];
	
	function contentWrap(node) {
	  if (node.style.content) {
	    var cont = node.style.content;
	    if (contentValues.indexOf(cont) >= 0) {
	      return node;
	    }
	    if (/^(attr|calc|counters?|url)\(/.test(cont)) {
	      return node;
	    }
	    if (cont.charAt(0) === cont.charAt(cont.length - 1) && (cont.charAt(0) === '"' || cont.charAt(0) === "'")) {
	      return node;
	    }
	    return _extends({}, node, { style: _extends({}, node.style, { content: '"' + cont + '"' }) });
	  }
	  return node;
	}
	
	function prefixes(node) {
	  return (0, _objectAssign2.default)({}, node, { style: (0, _prefixer2.default)(_extends({}, node.style)) });
	}

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixer;
	
	var _staticData = __webpack_require__(1338);
	
	var _staticData2 = _interopRequireDefault(_staticData);
	
	var _prefixProperty = __webpack_require__(687);
	
	var _prefixProperty2 = _interopRequireDefault(_prefixProperty);
	
	var _prefixValue = __webpack_require__(463);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	var _cursor = __webpack_require__(1333);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _crossFade = __webpack_require__(1332);
	
	var _crossFade2 = _interopRequireDefault(_crossFade);
	
	var _filter = __webpack_require__(1334);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _flex = __webpack_require__(680);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxOld = __webpack_require__(681);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(682);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _imageSet = __webpack_require__(1336);
	
	var _imageSet2 = _interopRequireDefault(_imageSet);
	
	var _position = __webpack_require__(1337);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _sizing = __webpack_require__(683);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(684);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var plugins = [_crossFade2.default, _cursor2.default, _filter2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default, _flex2.default]; // custom facade for inline-style-prefixer
	
	var prefixMap = _staticData2.default.prefixMap;
	
	function prefixer(style) {
	  for (var property in style) {
	    var value = style[property];
	
	    var processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);
	
	    // only modify the value if it was touched
	    // by any plugin to prevent unnecessary mutations
	    if (processedValue) {
	      style[property] = processedValue;
	    }
	
	    (0, _prefixProperty2.default)(prefixMap, property, style);
	  }
	  return style;
	}

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StyleSheet = StyleSheet;
	
	var _objectAssign = __webpack_require__(40);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/* 
	
	high performance StyleSheet for css-in-js systems 
	
	- uses multiple style tags behind the scenes for millions of rules 
	- uses `insertRule` for appending in production for *much* faster performance
	- 'polyfills' on server side 
	
	
	// usage
	
	import StyleSheet from 'glamor/lib/sheet'
	let styleSheet = new StyleSheet()
	
	styleSheet.inject() 
	- 'injects' the stylesheet into the page (or into memory if on server)
	
	styleSheet.insert('#box { border: 1px solid red; }') 
	- appends a css rule into the stylesheet 
	
	styleSheet.flush() 
	- empties the stylesheet of all its contents
	
	
	*/
	
	function last(arr) {
	  return arr[arr.length - 1];
	}
	
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    return tag.sheet;
	  }
	
	  // this weirdness brought to you by firefox 
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      return document.styleSheets[i];
	    }
	  }
	}
	
	var isBrowser = typeof window !== 'undefined';
	var isDev = ("production") === 'development' || !("production"); //(x => (x === 'development') || !x)(process.env.NODE_ENV)
	var isTest = ("production") === 'test';
	
	var oldIE = function () {
	  if (isBrowser) {
	    var div = document.createElement('div');
	    div.innerHTML = '<!--[if lt IE 10]><i></i><![endif]-->';
	    return div.getElementsByTagName('i').length === 1;
	  }
	}();
	
	function makeStyleTag() {
	  var tag = document.createElement('style');
	  tag.type = 'text/css';
	  tag.setAttribute('data-glamor', '');
	  tag.appendChild(document.createTextNode(''));
	  (document.head || document.getElementsByTagName('head')[0]).appendChild(tag);
	  return tag;
	}
	
	function StyleSheet() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$speedy = _ref.speedy,
	      speedy = _ref$speedy === undefined ? !isDev && !isTest : _ref$speedy,
	      _ref$maxLength = _ref.maxLength,
	      maxLength = _ref$maxLength === undefined ? isBrowser && oldIE ? 4000 : 65000 : _ref$maxLength;
	
	  this.isSpeedy = speedy; // the big drawback here is that the css won't be editable in devtools
	  this.sheet = undefined;
	  this.tags = [];
	  this.maxLength = maxLength;
	  this.ctr = 0;
	}
	
	(0, _objectAssign2.default)(StyleSheet.prototype, {
	  getSheet: function getSheet() {
	    return sheetForTag(last(this.tags));
	  },
	  inject: function inject() {
	    var _this = this;
	
	    if (this.injected) {
	      throw new Error('already injected stylesheet!');
	    }
	    if (isBrowser) {
	      this.tags[0] = makeStyleTag();
	    } else {
	      // server side 'polyfill'. just enough behavior to be useful.
	      this.sheet = {
	        cssRules: [],
	        insertRule: function insertRule(rule) {
	          // enough 'spec compliance' to be able to extract the rules later  
	          // in other words, just the cssText field 
	          _this.sheet.cssRules.push({ cssText: rule });
	        }
	      };
	    }
	    this.injected = true;
	  },
	  speedy: function speedy(bool) {
	    if (this.ctr !== 0) {
	      throw new Error('cannot change speedy mode after inserting any rule to sheet. Either call speedy(' + bool + ') earlier in your app, or call flush() before speedy(' + bool + ')');
	    }
	    this.isSpeedy = !!bool;
	  },
	  _insert: function _insert(rule) {
	    // this weirdness for perf, and chrome's weird bug 
	    // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
	    try {
	      var sheet = this.getSheet();
	      sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : sheet.cssRules.length);
	    } catch (e) {
	      if (isDev) {
	        // might need beter dx for this 
	        console.warn('whoops, illegal rule inserted', rule); //eslint-disable-line no-console
	      }
	    }
	  },
	  insert: function insert(rule) {
	
	    if (isBrowser) {
	      // this is the ultrafast version, works across browsers 
	      if (this.isSpeedy && this.getSheet().insertRule) {
	        this._insert(rule);
	      }
	      // more browser weirdness. I don't even know    
	      // else if(this.tags.length > 0 && this.tags::last().styleSheet) {      
	      //   this.tags::last().styleSheet.cssText+= rule
	      // }
	      else {
	          if (rule.indexOf('@import') !== -1) {
	            var tag = last(this.tags);
	            tag.insertBefore(document.createTextNode(rule), tag.firstChild);
	          } else {
	            last(this.tags).appendChild(document.createTextNode(rule));
	          }
	        }
	    } else {
	      // server side is pretty simple         
	      this.sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : this.sheet.cssRules.length);
	    }
	
	    this.ctr++;
	    if (isBrowser && this.ctr % this.maxLength === 0) {
	      this.tags.push(makeStyleTag());
	    }
	    return this.ctr - 1;
	  },
	
	  // commenting this out till we decide on v3's decision 
	  // _replace(index, rule) {
	  //   // this weirdness for perf, and chrome's weird bug 
	  //   // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
	  //   try {  
	  //     let sheet = this.getSheet()        
	  //     sheet.deleteRule(index) // todo - correct index here     
	  //     sheet.insertRule(rule, index)
	  //   }
	  //   catch(e) {
	  //     if(isDev) {
	  //       // might need beter dx for this 
	  //       console.warn('whoops, problem replacing rule', rule) //eslint-disable-line no-console
	  //     }          
	  //   }          
	
	  // }
	  // replace(index, rule) {
	  //   if(isBrowser) {
	  //     if(this.isSpeedy && this.getSheet().insertRule) {
	  //       this._replace(index, rule)
	  //     }
	  //     else {
	  //       let _slot = Math.floor((index  + this.maxLength) / this.maxLength) - 1        
	  //       let _index = (index % this.maxLength) + 1
	  //       let tag = this.tags[_slot]
	  //       tag.replaceChild(document.createTextNode(rule), tag.childNodes[_index])
	  //     }
	  //   }
	  //   else {
	  //     let rules = this.sheet.cssRules
	  //     this.sheet.cssRules = [ ...rules.slice(0, index), { cssText: rule }, ...rules.slice(index + 1) ]
	  //   }
	  // }
	  delete: function _delete(index) {
	    // we insert a blank rule when 'deleting' so previously returned indexes remain stable
	    return this.replace(index, '');
	  },
	  flush: function flush() {
	    if (isBrowser) {
	      this.tags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	      });
	      this.tags = [];
	      this.sheet = null;
	      this.ctr = 0;
	      // todo - look for remnants in document.styleSheets
	    } else {
	      // simpler on server 
	      this.sheet.cssRules = [];
	    }
	    this.injected = false;
	  },
	  rules: function rules() {
	    if (!isBrowser) {
	      return this.sheet.cssRules;
	    }
	    var arr = [];
	    this.tags.forEach(function (tag) {
	      return arr.splice.apply(arr, [arr.length, 0].concat(_toConsumableArray(Array.from(sheetForTag(tag).cssRules))));
	    });
	    return arr;
	  }
	});

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(1));
	var glamor = __webpack_require__(1316);
	
	var htmlTagNames = [
	  "a",
	  "abbr",
	  "acronym",
	  "address",
	  "applet",
	  "area",
	  "article",
	  "aside",
	  "audio",
	  "b",
	  "base",
	  "basefont",
	  "bdi",
	  "bdo",
	  "bgsound",
	  "big",
	  "blink",
	  "blockquote",
	  "body",
	  "br",
	  "button",
	  "canvas",
	  "caption",
	  "center",
	  "cite",
	  "code",
	  "col",
	  "colgroup",
	  "command",
	  "content",
	  "data",
	  "datalist",
	  "dd",
	  "del",
	  "details",
	  "dfn",
	  "dialog",
	  "dir",
	  "div",
	  "dl",
	  "dt",
	  "element",
	  "em",
	  "embed",
	  "fieldset",
	  "figcaption",
	  "figure",
	  "font",
	  "footer",
	  "form",
	  "frame",
	  "frameset",
	  "h1",
	  "h2",
	  "h3",
	  "h4",
	  "h5",
	  "h6",
	  "head",
	  "header",
	  "hgroup",
	  "hr",
	  "html",
	  "i",
	  "iframe",
	  "image",
	  "img",
	  "input",
	  "ins",
	  "isindex",
	  "kbd",
	  "keygen",
	  "label",
	  "legend",
	  "li",
	  "link",
	  "listing",
	  "main",
	  "map",
	  "mark",
	  "marquee",
	  "math",
	  "menu",
	  "menuitem",
	  "meta",
	  "meter",
	  "multicol",
	  "nav",
	  "nextid",
	  "nobr",
	  "noembed",
	  "noframes",
	  "noscript",
	  "object",
	  "ol",
	  "optgroup",
	  "option",
	  "output",
	  "p",
	  "param",
	  "picture",
	  "plaintext",
	  "pre",
	  "progress",
	  "q",
	  "rb",
	  "rbc",
	  "rp",
	  "rt",
	  "rtc",
	  "ruby",
	  "s",
	  "samp",
	  "script",
	  "section",
	  "select",
	  "shadow",
	  "slot",
	  "small",
	  "source",
	  "spacer",
	  "span",
	  "strike",
	  "strong",
	  "style",
	  "sub",
	  "summary",
	  "sup",
	  "svg",
	  "table",
	  "tbody",
	  "td",
	  "template",
	  "textarea",
	  "tfoot",
	  "th",
	  "thead",
	  "time",
	  "title",
	  "tr",
	  "track",
	  "tt",
	  "u",
	  "ul",
	  "var",
	  "video",
	  "wbr",
	  "xmp"
	]
	;
	
	var svgTagNames = [
	  "a",
	  "altGlyph",
	  "altGlyphDef",
	  "altGlyphItem",
	  "animate",
	  "animateColor",
	  "animateMotion",
	  "animateTransform",
	  "animation",
	  "audio",
	  "canvas",
	  "circle",
	  "clipPath",
	  "color-profile",
	  "cursor",
	  "defs",
	  "desc",
	  "discard",
	  "ellipse",
	  "feBlend",
	  "feColorMatrix",
	  "feComponentTransfer",
	  "feComposite",
	  "feConvolveMatrix",
	  "feDiffuseLighting",
	  "feDisplacementMap",
	  "feDistantLight",
	  "feDropShadow",
	  "feFlood",
	  "feFuncA",
	  "feFuncB",
	  "feFuncG",
	  "feFuncR",
	  "feGaussianBlur",
	  "feImage",
	  "feMerge",
	  "feMergeNode",
	  "feMorphology",
	  "feOffset",
	  "fePointLight",
	  "feSpecularLighting",
	  "feSpotLight",
	  "feTile",
	  "feTurbulence",
	  "filter",
	  "font",
	  "font-face",
	  "font-face-format",
	  "font-face-name",
	  "font-face-src",
	  "font-face-uri",
	  "foreignObject",
	  "g",
	  "glyph",
	  "glyphRef",
	  "handler",
	  "hatch",
	  "hatchpath",
	  "hkern",
	  "iframe",
	  "image",
	  "line",
	  "linearGradient",
	  "listener",
	  "marker",
	  "mask",
	  "mesh",
	  "meshgradient",
	  "meshpatch",
	  "meshrow",
	  "metadata",
	  "missing-glyph",
	  "mpath",
	  "path",
	  "pattern",
	  "polygon",
	  "polyline",
	  "prefetch",
	  "radialGradient",
	  "rect",
	  "script",
	  "set",
	  "solidColor",
	  "solidcolor",
	  "stop",
	  "style",
	  "svg",
	  "switch",
	  "symbol",
	  "tbreak",
	  "text",
	  "textArea",
	  "textPath",
	  "title",
	  "tref",
	  "tspan",
	  "unknown",
	  "use",
	  "video",
	  "view",
	  "vkern"
	]
	;
	
	var domElements = htmlTagNames.concat(svgTagNames).filter(function (tag, index, array) {
	  return array.indexOf(tag) === index;
	});
	
	var CHANNEL = '__glamorous__'; /* istanbul ignore next */
	
	var isPreact = false;
	
	var _PropTypes = void 0;
	
	/* istanbul ignore next */
	if (isPreact) {
	  if (!React.PropTypes) {
	    _PropTypes = function PropTypes() {
	      return _PropTypes;
	    };
	
	    ['array', 'bool', 'func', 'number', 'object', 'string', 'symbol', 'any', 'arrayOf', 'element', 'instanceOf', 'node', 'objectOf', 'oneOf', 'oneOfType', 'shape', 'exact'].forEach(function (type) {
	      _PropTypes[type] = _PropTypes;
	    });
	  }
	  // copied from preact-compat
	  /* eslint-disable no-eq-null, eqeqeq, consistent-return */
	  if (!React.Children) {
	    var Children = {
	      map: function map(children, fn, ctx) {
	        if (children == null) {
	          return null;
	        }
	        children = Children.toArray(children);
	        if (ctx && ctx !== children) {
	          fn = fn.bind(ctx);
	        }
	        return children.map(fn);
	      },
	      forEach: function forEach(children, fn, ctx) {
	        if (children == null) {
	          return null;
	        }
	        children = Children.toArray(children);
	        if (ctx && ctx !== children) {
	          fn = fn.bind(ctx);
	        }
	        children.forEach(fn);
	      },
	      count: function count(children) {
	        return children && children.length || 0;
	      },
	      only: function only(children) {
	        children = Children.toArray(children);
	        if (children.length !== 1) {
	          throw new Error('Children.only() expects only one child.');
	        }
	        return children[0];
	      },
	      toArray: function toArray(children) {
	        if (children == null) {
	          return [];
	        }
	        return [].concat(children);
	      }
	    };
	    React.Children = Children;
	  }
	  /* eslint-enable no-eq-null, eqeqeq, consistent-return */
	} else if (parseFloat(React.version.slice(0, 4)) >= 15.5) {
	  /* istanbul ignore next */
	  try {
	    _PropTypes = __webpack_require__(2);
	    /* istanbul ignore next */
	  } catch (error) {
	    // ignore
	  }
	}
	/* istanbul ignore next */
	_PropTypes = _PropTypes || React.PropTypes;
	
	/*
	eslint
	  import/no-mutable-exports:0,
	  import/prefer-default-export:0,
	  react/no-deprecated:0
	 */
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	function generateWarningMessage(Comp) {
	  var componentName = Comp.displayName || Comp.name || 'FunctionComponent';
	  // eslint-disable-next-line max-len
	  return 'glamorous warning: Expected component called "' + componentName + '" which uses withTheme to be within a ThemeProvider but none was found.';
	}
	
	function withTheme(ComponentToTheme) {
	  var _defaultContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$noWarn = _ref.noWarn,
	      noWarn = _ref$noWarn === undefined ? false : _ref$noWarn,
	      _ref$createElement = _ref.createElement,
	      createElement = _ref$createElement === undefined ? true : _ref$createElement;
	
	  var ThemedComponent = function (_React$Component) {
	    inherits(ThemedComponent, _React$Component);
	
	    function ThemedComponent() {
	      var _temp, _this, _ret;
	
	      classCallCheck(this, ThemedComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.warned = noWarn, _this.state = { theme: {} }, _this.setTheme = function (theme) {
	        return _this.setState({ theme: theme });
	      }, _temp), possibleConstructorReturn(_this, _ret);
	    }
	
	    // eslint-disable-next-line complexity
	    ThemedComponent.prototype.componentWillMount = function componentWillMount() {
	      if (!this.context[CHANNEL]) {
	        if (false) {
	          this.warned = true;
	          // eslint-disable-next-line no-console
	          console.warn(generateWarningMessage(ComponentToTheme));
	        }
	      }
	      var theme = this.props.theme;
	
	      if (this.context[CHANNEL]) {
	        // if a theme is provided via props,
	        // it takes precedence over context
	        this.setTheme(theme ? theme : this.context[CHANNEL].getState());
	      } else {
	        this.setTheme(theme || {});
	      }
	    };
	
	    ThemedComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.theme !== nextProps.theme) {
	        this.setTheme(nextProps.theme);
	      }
	    };
	
	    ThemedComponent.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[CHANNEL] && !this.props.theme) {
	        // subscribe to future theme changes
	        this.subscriptionId = this.context[CHANNEL].subscribe(this.setTheme);
	      }
	    };
	
	    ThemedComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	      // cleanup subscription
	      this.subscriptionId && this.context[CHANNEL].unsubscribe(this.subscriptionId);
	    };
	
	    ThemedComponent.prototype.render = function render() {
	      if (createElement) {
	        return React.createElement(ComponentToTheme, _extends({}, this.props, this.state));
	      } else {
	        // this allows us to effectively use the GlamorousComponent
	        // as our `render` method without going through lifecycle hooks.
	        // Also allows us to forward the context in the scenario where
	        // a user wants to add more context.
	        // eslint-disable-next-line babel/new-cap
	        return ComponentToTheme.call(this, _extends({}, this.props, this.state), this.context);
	      }
	    };
	
	    return ThemedComponent;
	  }(React.Component);
	
	   false ? ThemedComponent.propTypes = {
	    theme: _PropTypes.object
	  } : void 0;
	
	
	  var defaultContextTypes = (_defaultContextTypes = {}, _defaultContextTypes[CHANNEL] = _PropTypes.object, _defaultContextTypes);
	
	  var userDefinedContextTypes = null;
	
	  // configure the contextTypes to be settable by the user,
	  // however also retaining the glamorous channel.
	  Object.defineProperty(ThemedComponent, 'contextTypes', {
	    enumerable: true,
	    configurable: true,
	    set: function set$$1(value) {
	      userDefinedContextTypes = value;
	    },
	    get: function get$$1() {
	      // if the user has provided a contextTypes definition,
	      // merge the default context types with the provided ones.
	      if (userDefinedContextTypes) {
	        return _extends({}, defaultContextTypes, userDefinedContextTypes);
	      }
	      return defaultContextTypes;
	    }
	  });
	
	  return ThemedComponent;
	}
	
	var isFunction_1 = isFunction;
	
	var toString = Object.prototype.toString;
	
	function isFunction (fn) {
	  var string = toString.call(fn);
	  return string === '[object Function]' ||
	    (typeof fn === 'function' && string !== '[object RegExp]') ||
	    (typeof window !== 'undefined' &&
	     // IE8 and below
	     (fn === window.setTimeout ||
	      fn === window.alert ||
	      fn === window.confirm ||
	      fn === window.prompt))
	}
	
	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	var isobject = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};
	
	function isObjectObject(o) {
	  return isobject(o) === true
	    && Object.prototype.toString.call(o) === '[object Object]';
	}
	
	var isPlainObject = function isPlainObject(o) {
	  var ctor,prot;
	
	  if (isObjectObject(o) === false) return false;
	
	  // If has modified constructor
	  ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;
	
	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;
	
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	
	  // Most likely a plain Object
	  return true;
	};
	
	function createBroadcast (initialState) {
	  var listeners = {};
	  var id = 1;
	  var _state = initialState;
	
	  function getState () {
	    return _state
	  }
	
	  function setState (state) {
	    _state = state;
	    var keys = Object.keys(listeners);
	    var i = 0;
	    var len = keys.length;
	    for (; i < len; i++) {
	      // if a listener gets unsubscribed during setState we just skip it
	      if (listeners[keys[i]]) { listeners[keys[i]](state); }
	    }
	  }
	
	  // subscribe to changes and return the subscriptionId
	  function subscribe (listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('listener must be a function.')
	    }
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    return currentId
	  }
	
	  // remove subscription by removing the listener function
	  function unsubscribe (id) {
	    listeners[id] = undefined;
	  }
	
	  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
	}
	
	var _ThemeProvider$childC, _ThemeProvider$contex;
	
	/**
	 * This is a component which will provide a theme to the entire tree
	 * via context and event listener
	 * (because pure components block context updates)
	 * inspired by the styled-components implementation
	 * https://github.com/styled-components/styled-components
	 * @param {Object} theme the theme object..
	 */
	
	var ThemeProvider = function (_React$Component) {
	  inherits(ThemeProvider, _React$Component);
	
	  function ThemeProvider() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, ThemeProvider);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setOuterTheme = function (theme) {
	      _this.outerTheme = theme;
	      if (_this.broadcast !== undefined) {
	        _this.publishTheme();
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  // create theme, by merging with outer theme, if present
	  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
	    var theme = passedTheme || this.props.theme;
	    if (isFunction_1(theme)) {
	      var mergedTheme = theme(this.outerTheme);
	      if (!isPlainObject(mergedTheme)) {
	        throw new Error('[ThemeProvider] Please return an object from your theme function, ' + 'i.e. theme={() => ({})}!');
	      }
	      return mergedTheme;
	    }
	    return _extends({}, this.outerTheme, theme);
	  };
	
	  ThemeProvider.prototype.getChildContext = function getChildContext() {
	    var _ref;
	
	    return _ref = {}, _ref[CHANNEL] = this.broadcast, _ref;
	  };
	
	  ThemeProvider.prototype.publishTheme = function publishTheme(theme) {
	    this.broadcast.setState(this.getTheme(theme));
	  };
	
	  ThemeProvider.prototype.componentDidMount = function componentDidMount() {
	    // create a new subscription for keeping track of outer theme, if present
	    if (this.context[CHANNEL]) {
	      this.subscriptionId = this.context[CHANNEL].subscribe(this.setOuterTheme);
	    }
	  };
	
	  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
	    // set broadcast state by merging outer theme with own
	    if (this.context[CHANNEL]) {
	      this.setOuterTheme(this.context[CHANNEL].getState());
	    }
	    this.broadcast = createBroadcast(this.getTheme(this.props.theme));
	  };
	
	  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.theme !== nextProps.theme) {
	      this.publishTheme(nextProps.theme);
	    }
	  };
	
	  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.subscriptionId && this.context[CHANNEL].unsubscribe(this.subscriptionId);
	  };
	
	  ThemeProvider.prototype.render = function render() {
	    return this.props.children ? React.Children.only(this.props.children) : null;
	  };
	
	  return ThemeProvider;
	}(React.Component);
	
	ThemeProvider.childContextTypes = (_ThemeProvider$childC = {}, _ThemeProvider$childC[CHANNEL] = _PropTypes.object.isRequired, _ThemeProvider$childC);
	
	ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL] = _PropTypes.object, _ThemeProvider$contex);
	
	 false ? ThemeProvider.propTypes = {
	  theme: _PropTypes.oneOfType([_PropTypes.object, _PropTypes.func]).isRequired,
	  children: _PropTypes.node
	} : void 0;
	
	/**
	 * This function takes a className string and gets all the
	 * associated glamor styles. It's used to merge glamor styles
	 * from a className to make sure that specificity is not
	 * a problem when passing a className to a component.
	 * @param {String} [className=''] the className string
	 * @return {Object} { glamorStyles, glamorlessClassName }
	 *   - glamorStyles is an array of all the glamor styles objects
	 *   - glamorlessClassName is the rest of the className string
	 *     without the glamor classNames
	 */
	function extractGlamorStyles(className) {
	  var glamorlessClassName = [];
	  var glamorStyles = [];
	  className.toString().split(' ').forEach(function (name) {
	    if (glamor.styleSheet.registered[name.substring(4)] === undefined) {
	      glamorlessClassName.push(name);
	    } else {
	      var style = buildGlamorSrcFromClassName(name);
	      glamorStyles.push(style);
	    }
	  });
	
	  return { glamorlessClassName: glamorlessClassName, glamorStyles: glamorStyles };
	}
	
	/** Glamor's css function returns an object with the shape
	 *
	 * {
	 *   [`data-css-${hash}`]: '',
	 *   toString() { return `css-${hash}` }
	 * }
	 *
	 * Whenever glamor's build function encounters an object with
	 * this shape it just pulls the resulting styles from the cache.
	 *
	 * note: the toString method is not needed to qualify the shape
	 **/
	function buildGlamorSrcFromClassName(className) {
	  var _ref;
	
	  return _ref = {}, _ref['data-' + className] = '', _ref;
	}
	
	function getGlamorClassName(_ref2) {
	  var styles = _ref2.styles,
	      props = _ref2.props,
	      cssOverrides = _ref2.cssOverrides,
	      cssProp = _ref2.cssProp,
	      context = _ref2.context,
	      displayName = _ref2.displayName;
	
	  var _handleStyles = handleStyles([].concat(styles, [props.className, cssOverrides, cssProp]), props, context),
	      mappedArgs = _handleStyles.mappedArgs,
	      nonGlamorClassNames = _handleStyles.nonGlamorClassNames;
	  // eslint-disable-next-line max-len
	
	
	  var isDev = ("production") === 'development' || !("production");
	  var devRules = isDev ? { label: displayName } : null;
	  var glamorClassName = glamor.css.apply(undefined, [devRules].concat(mappedArgs)).toString();
	  var extras = nonGlamorClassNames.join(' ').trim();
	  return (glamorClassName + ' ' + extras).trim();
	}
	
	// this next function is on a "hot" code-path
	// so it's pretty complex to make sure it's fast.
	// eslint-disable-next-line complexity
	function handleStyles(styles, props, context) {
	  var current = void 0;
	  var mappedArgs = [];
	  var nonGlamorClassNames = [];
	  for (var i = 0; i < styles.length; i++) {
	    current = styles[i];
	    while (typeof current === 'function') {
	      current = current(props, context);
	    }
	    if (typeof current === 'string') {
	      var _extractGlamorStyles = extractGlamorStyles(current),
	          glamorStyles = _extractGlamorStyles.glamorStyles,
	          glamorlessClassName = _extractGlamorStyles.glamorlessClassName;
	
	      mappedArgs.push.apply(mappedArgs, glamorStyles);
	      nonGlamorClassNames.push.apply(nonGlamorClassNames, glamorlessClassName);
	    } else if (Array.isArray(current)) {
	      var recursed = handleStyles(current, props, context);
	      mappedArgs.push.apply(mappedArgs, recursed.mappedArgs);
	      nonGlamorClassNames.push.apply(nonGlamorClassNames, recursed.nonGlamorClassNames);
	    } else {
	      mappedArgs.push(current);
	    }
	  }
	  return { mappedArgs: mappedArgs, nonGlamorClassNames: nonGlamorClassNames };
	}
	
	/*
	 * This is a relatively small abstraction that's ripe for open sourcing.
	 * Documentation is in the README.md
	 */
	
	function createGlamorous(splitProps) {
	  return glamorous;
	
	  /**
	   * This is the main export and the function that people
	   * interact with most directly.
	   *
	   * It accepts a component which can be a string or
	   * a React Component and returns
	   * a "glamorousComponentFactory"
	   * @param {String|ReactComponent} comp the component to render
	   * @param {Object} options helpful info for the GlamorousComponents
	   * @return {Function} the glamorousComponentFactory
	   */
	  function glamorous(comp) {
	    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var rootEl = config.rootEl,
	        displayName = config.displayName,
	        shouldClassNameUpdate = config.shouldClassNameUpdate,
	        _config$filterProps = config.filterProps,
	        filterProps = _config$filterProps === undefined ? [] : _config$filterProps,
	        _config$forwardProps = config.forwardProps,
	        forwardProps = _config$forwardProps === undefined ? [] : _config$forwardProps,
	        _config$propsAreCssOv = config.propsAreCssOverrides,
	        propsAreCssOverrides = _config$propsAreCssOv === undefined ? comp.propsAreCssOverrides : _config$propsAreCssOv,
	        basePropsToApply = config.withProps;
	
	    Object.assign(glamorousComponentFactory, { withConfig: withConfig });
	    return glamorousComponentFactory;
	
	    function withConfig(newConfig) {
	      return glamorous(comp, _extends({}, config, newConfig));
	    }
	
	    /**
	     * This returns a React Component that renders the comp (closure)
	     * with a className based on the given glamor styles object(s)
	     * @param {...Object|Function} styles the styles to create with glamor.
	     *   If any of these are functions, they are invoked with the component
	     *   props and the return value is used.
	     * @return {ReactComponent} the ReactComponent function
	     */
	    function glamorousComponentFactory() {
	      for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
	        styles[_key] = arguments[_key];
	      }
	
	      /**
	       * This is a component which will render the comp (closure)
	       * with the glamorous styles (closure). Forwards any valid
	       * props to the underlying component.
	       */
	      var GlamorousComponent = withTheme(function (props, context) {
	        props = getPropsToApply(GlamorousComponent.propsToApply, {}, props, context);
	        var updateClassName = shouldUpdate(props, context, this.previous);
	
	        if (shouldClassNameUpdate) {
	          this.previous = { props: props, context: context };
	        }
	
	        var _splitProps = splitProps(props, GlamorousComponent),
	            toForward = _splitProps.toForward,
	            cssOverrides = _splitProps.cssOverrides,
	            cssProp = _splitProps.cssProp;
	
	        // create className to apply
	
	
	        this.className = updateClassName ? getGlamorClassName({
	          styles: GlamorousComponent.styles,
	          props: props,
	          cssOverrides: cssOverrides,
	          cssProp: cssProp,
	          context: context,
	          displayName: GlamorousComponent.displayName
	        }) : this.className;
	
	        return React.createElement(GlamorousComponent.comp, _extends({
	          // if innerRef is forwarded we don't want to apply it here
	          ref: 'innerRef' in toForward ? undefined : props.innerRef
	        }, toForward, {
	          className: this.className
	        }));
	      }, { noWarn: true, createElement: false });
	
	       false ? GlamorousComponent.propTypes = {
	        // className accepts an object due to glamor's css function
	        // returning an object with a toString method that gives the className
	        className: _PropTypes.oneOfType([_PropTypes.string, _PropTypes.object]),
	        cssOverrides: _PropTypes.object,
	        innerRef: _PropTypes.oneOfType([_PropTypes.func, _PropTypes.object]),
	        glam: _PropTypes.object
	      } : void 0;
	
	      function shouldUpdate(props, context, previous) {
	        // exiting early so components which do not use this
	        // optimization are not penalized by hanging onto
	        // references to previous props and context
	        if (!shouldClassNameUpdate) {
	          return true;
	        }
	        var update = true;
	        if (previous) {
	          if (!shouldClassNameUpdate(previous.props, props, previous.context, context)) {
	            update = false;
	          }
	        }
	
	        return update;
	      }
	
	      Object.assign(GlamorousComponent, getGlamorousComponentMetadata({
	        comp: comp,
	        styles: styles,
	        rootEl: rootEl,
	        filterProps: filterProps,
	        forwardProps: forwardProps,
	        displayName: displayName,
	        propsToApply: basePropsToApply
	      }), {
	        isGlamorousComponent: true,
	        propsAreCssOverrides: propsAreCssOverrides,
	        withComponent: function (newComp) {
	          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	          var fwp = GlamorousComponent.forwardProps,
	              flp = GlamorousComponent.filterProps,
	              componentProperties = objectWithoutProperties(GlamorousComponent, ['forwardProps', 'filterProps']);
	
	          return glamorous(_extends({}, componentProperties, {
	            comp: newComp,
	            rootEl: getRootEl(newComp)
	          }), _extends({
	            // allows the forwardProps and filterProps to be overridden
	            forwardProps: fwp,
	            filterProps: flp
	          }, options))();
	        },
	        withProps: function () {
	          for (var _len2 = arguments.length, propsToApply = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            propsToApply[_key2] = arguments[_key2];
	          }
	
	          return glamorous(GlamorousComponent, { withProps: propsToApply })();
	        },
	        withConfig: withConfig
	      });
	      return GlamorousComponent;
	    }
	  }
	
	  function getGlamorousComponentMetadata(_ref) {
	    var comp = _ref.comp,
	        styles = _ref.styles,
	        rootEl = _ref.rootEl,
	        filterProps = _ref.filterProps,
	        forwardProps = _ref.forwardProps,
	        displayName = _ref.displayName,
	        basePropsToApply = _ref.propsToApply;
	
	    var componentsComp = comp.comp ? comp.comp : comp;
	    var propsToApply = comp.propsToApply ? [].concat(comp.propsToApply, arrayify(basePropsToApply)) : arrayify(basePropsToApply);
	    return {
	      // join styles together (for anyone doing: glamorous(glamorous.a({}), {}))
	      styles: when(comp.styles, styles),
	      // keep track of the ultimate rootEl to render (we never
	      // actually render anything but
	      // the base component, even when people wrap a glamorous
	      // component in glamorous
	      comp: componentsComp,
	      rootEl: rootEl || getRootEl(comp),
	      // join forwardProps and filterProps
	      // (for anyone doing: glamorous(glamorous.a({}), {}))
	      forwardProps: when(comp.forwardProps, forwardProps),
	      filterProps: when(comp.filterProps, filterProps),
	      // set the displayName to something that's slightly more
	      // helpful than `GlamorousComponent` :)
	      displayName: displayName || 'glamorous(' + getDisplayName(comp) + ')',
	      // these are props that should be applied to the component at render time
	      propsToApply: propsToApply
	    };
	  }
	}
	
	/**
	 * reduces the propsToApply given to a single props object
	 * @param {Array} propsToApply an array of propsToApply objects:
	 *   - object
	 *   - array of propsToApply items
	 *   - function that accepts the accumulated props and the context
	 * @param {Object} accumulator an object to apply props onto
	 * @param {Object} props the props that should ultimately take precedence
	 * @param {*} context the context object
	 * @return {Object} the reduced props
	 */
	function getPropsToApply(propsToApply, accumulator, props, context) {
	  // using forEach rather than reduce here because the reduce solution
	  // effectively did the same thing because we manipulate the `accumulator`
	  propsToApply.forEach(function (propsToApplyItem) {
	    if (typeof propsToApplyItem === 'function') {
	      return Object.assign(accumulator, propsToApplyItem(Object.assign({}, accumulator, props), context));
	    } else if (Array.isArray(propsToApplyItem)) {
	      return Object.assign(accumulator, getPropsToApply(propsToApplyItem, accumulator, props, context));
	    }
	    return Object.assign(accumulator, propsToApplyItem);
	  });
	  // props wins
	  return Object.assign(accumulator, props);
	}
	
	function arrayify() {
	  var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return Array.isArray(x) ? x : [x];
	}
	
	function when(comp, prop) {
	  return comp ? comp.concat(prop) : prop;
	}
	
	function getRootEl(comp) {
	  return comp.rootEl ? comp.rootEl : comp.comp || comp;
	}
	
	function getDisplayName(comp) {
	  return typeof comp === 'string' ? comp : comp.displayName || comp.name || 'unknown';
	}
	
	//
	// Main
	//
	
	function memoize (fn, options) {
	  var cache = options && options.cache
	    ? options.cache
	    : cacheDefault;
	
	  var serializer = options && options.serializer
	    ? options.serializer
	    : serializerDefault;
	
	  var strategy = options && options.strategy
	    ? options.strategy
	    : strategyDefault;
	
	  return strategy(fn, {
	    cache: cache,
	    serializer: serializer
	  })
	}
	
	//
	// Strategy
	//
	
	function isPrimitive (value) {
	  return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
	}
	
	function monadic (fn, cache, serializer, arg) {
	  var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
	
	  var computedValue = cache.get(cacheKey);
	  if (typeof computedValue === 'undefined') {
	    computedValue = fn.call(this, arg);
	    cache.set(cacheKey, computedValue);
	  }
	
	  return computedValue
	}
	
	function variadic (fn, cache, serializer) {
	  var args = Array.prototype.slice.call(arguments, 3);
	  var cacheKey = serializer(args);
	
	  var computedValue = cache.get(cacheKey);
	  if (typeof computedValue === 'undefined') {
	    computedValue = fn.apply(this, args);
	    cache.set(cacheKey, computedValue);
	  }
	
	  return computedValue
	}
	
	function assemble (fn, context, strategy, cache, serialize) {
	  return strategy.bind(
	    context,
	    fn,
	    cache,
	    serialize
	  )
	}
	
	function strategyDefault (fn, options) {
	  var strategy = fn.length === 1 ? monadic : variadic;
	
	  return assemble(
	    fn,
	    this,
	    strategy,
	    options.cache.create(),
	    options.serializer
	  )
	}
	
	function strategyVariadic (fn, options) {
	  var strategy = variadic;
	
	  return assemble(
	    fn,
	    this,
	    strategy,
	    options.cache.create(),
	    options.serializer
	  )
	}
	
	function strategyMonadic (fn, options) {
	  var strategy = monadic;
	
	  return assemble(
	    fn,
	    this,
	    strategy,
	    options.cache.create(),
	    options.serializer
	  )
	}
	
	//
	// Serializer
	//
	
	function serializerDefault () {
	  return JSON.stringify(arguments)
	}
	
	//
	// Cache
	//
	
	function ObjectWithoutPrototypeCache () {
	  this.cache = Object.create(null);
	}
	
	ObjectWithoutPrototypeCache.prototype.has = function (key) {
	  return (key in this.cache)
	};
	
	ObjectWithoutPrototypeCache.prototype.get = function (key) {
	  return this.cache[key]
	};
	
	ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
	  this.cache[key] = value;
	};
	
	var cacheDefault = {
	  create: function create () {
	    return new ObjectWithoutPrototypeCache()
	  }
	};
	
	//
	// API
	//
	
	var src = memoize;
	var strategies = {
	  variadic: strategyVariadic,
	  monadic: strategyMonadic
	};
	src.strategies = strategies;
	
	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var a = ["coords","download","href","name","rel","shape","target","type"];
	var abbr = ["title"];
	var applet = ["alt","height","name","width"];
	var area = ["alt","coords","download","href","rel","shape","target","type"];
	var audio = ["controls","loop","muted","preload","src"];
	var base = ["href","target"];
	var basefont = ["size"];
	var bdo = ["dir"];
	var blockquote = ["cite"];
	var button = ["disabled","form","name","type","value"];
	var canvas = ["height","width"];
	var col = ["span","width"];
	var colgroup = ["span","width"];
	var data = ["value"];
	var del = ["cite"];
	var details = ["open"];
	var dfn = ["title"];
	var dialog = ["open"];
	var embed = ["height","src","type","width"];
	var fieldset = ["disabled","form","name"];
	var font = ["size"];
	var form = ["accept","action","method","name","target"];
	var frame = ["name","scrolling","src"];
	var frameset = ["cols","rows"];
	var head = ["profile"];
	var hr = ["size","width"];
	var html = ["manifest"];
	var iframe = ["height","name","sandbox","scrolling","src","width"];
	var img = ["alt","height","name","sizes","src","width"];
	var input = ["accept","alt","autoCapitalize","autoCorrect","autoSave","checked","defaultChecked","defaultValue","disabled","form","height","list","max","min","multiple","name","onChange","pattern","placeholder","required","results","size","src","step","title","type","value","width"];
	var ins = ["cite"];
	var keygen = ["challenge","disabled","form","name"];
	var label = ["form"];
	var li = ["type","value"];
	var link = ["color","href","integrity","media","nonce","rel","scope","sizes","target","title","type"];
	var map = ["name"];
	var meta = ["content","name"];
	var meter = ["high","low","max","min","optimum","value"];
	var object = ["data","form","height","name","type","width"];
	var ol = ["reversed","start","type"];
	var optgroup = ["disabled","label"];
	var option = ["disabled","label","selected","value"];
	var output = ["form","name"];
	var param = ["name","type","value"];
	var pre = ["width"];
	var progress = ["max","value"];
	var q = ["cite"];
	var script = ["async","defer","integrity","nonce","src","type"];
	var select = ["defaultValue","disabled","form","multiple","name","onChange","required","size","value"];
	var slot = ["name"];
	var source = ["media","sizes","src","type"];
	var style = ["media","nonce","title","type"];
	var table = ["summary","width"];
	var td = ["headers","height","scope","width"];
	var textarea = ["autoCapitalize","autoCorrect","cols","defaultValue","disabled","form","name","onChange","placeholder","required","rows","value","wrap"];
	var th = ["headers","height","scope","width"];
	var track = ["default","kind","label","src"];
	var ul = ["type"];
	var video = ["controls","height","loop","muted","playsInline","poster","preload","src","width"];
	var svg = ["accentHeight","accumulate","additive","alignmentBaseline","allowReorder","alphabetic","amplitude","arabicForm","ascent","attributeName","attributeType","autoReverse","azimuth","baseFrequency","baseProfile","baselineShift","bbox","begin","bias","by","calcMode","capHeight","clip","clipPath","clipPathUnits","clipRule","color","colorInterpolation","colorInterpolationFilters","colorProfile","colorRendering","contentScriptType","contentStyleType","cursor","cx","cy","d","decelerate","descent","diffuseConstant","direction","display","divisor","dominantBaseline","dur","dx","dy","edgeMode","elevation","enableBackground","end","exponent","externalResourcesRequired","fill","fillOpacity","fillRule","filter","filterRes","filterUnits","floodColor","floodOpacity","focusable","fontFamily","fontSize","fontSizeAdjust","fontStretch","fontStyle","fontVariant","fontWeight","format","from","fx","fy","g1","g2","glyphName","glyphOrientationHorizontal","glyphOrientationVertical","glyphRef","gradientTransform","gradientUnits","hanging","height","horizAdvX","horizOriginX","ideographic","imageRendering","in","in2","intercept","k","k1","k2","k3","k4","kernelMatrix","kernelUnitLength","kerning","keyPoints","keySplines","keyTimes","lengthAdjust","letterSpacing","lightingColor","limitingConeAngle","local","markerEnd","markerHeight","markerMid","markerStart","markerUnits","markerWidth","mask","maskContentUnits","maskUnits","mathematical","mode","numOctaves","offset","opacity","operator","order","orient","orientation","origin","overflow","overlinePosition","overlineThickness","paintOrder","panose1","pathLength","patternContentUnits","patternTransform","patternUnits","pointerEvents","points","pointsAtX","pointsAtY","pointsAtZ","preserveAlpha","preserveAspectRatio","primitiveUnits","r","radius","refX","refY","renderingIntent","repeatCount","repeatDur","requiredExtensions","requiredFeatures","restart","result","rotate","rx","ry","scale","seed","shapeRendering","slope","spacing","specularConstant","specularExponent","speed","spreadMethod","startOffset","stdDeviation","stemh","stemv","stitchTiles","stopColor","stopOpacity","strikethroughPosition","strikethroughThickness","string","stroke","strokeDasharray","strokeDashoffset","strokeLinecap","strokeLinejoin","strokeMiterlimit","strokeOpacity","strokeWidth","surfaceScale","systemLanguage","tableValues","targetX","targetY","textAnchor","textDecoration","textLength","textRendering","to","transform","u1","u2","underlinePosition","underlineThickness","unicode","unicodeBidi","unicodeRange","unitsPerEm","vAlphabetic","vHanging","vIdeographic","vMathematical","values","vectorEffect","version","vertAdvY","vertOriginX","vertOriginY","viewBox","viewTarget","visibility","width","widths","wordSpacing","writingMode","x","x1","x2","xChannelSelector","xHeight","xlinkActuate","xlinkArcrole","xlinkHref","xlinkRole","xlinkShow","xlinkTitle","xlinkType","xmlBase","xmlLang","xmlSpace","xmlns","xmlnsXlink","y","y1","y2","yChannelSelector","z","zoomAndPan"];
	var elements = {"html":["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","math","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rb","rp","rt","rtc","ruby","s","samp","script","section","select","slot","small","source","span","strong","style","sub","summary","sup","svg","table","tbody","td","template","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr"],"svg":["a","altGlyph","altGlyphDef","altGlyphItem","animate","animateColor","animateMotion","animateTransform","circle","clipPath","color-profile","cursor","defs","desc","ellipse","feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feDistantLight","feFlood","feFuncA","feFuncB","feFuncG","feFuncR","feGaussianBlur","feImage","feMerge","feMergeNode","feMorphology","feOffset","fePointLight","feSpecularLighting","feSpotLight","feTile","feTurbulence","filter","font","font-face","font-face-format","font-face-name","font-face-src","font-face-uri","foreignObject","g","glyph","glyphRef","hkern","image","line","linearGradient","marker","mask","metadata","missing-glyph","mpath","path","pattern","polygon","polyline","radialGradient","rect","script","set","stop","style","svg","switch","symbol","text","textPath","title","tref","tspan","use","view","vkern"]};
	var reactHtmlAttributes = {
		a: a,
		abbr: abbr,
		applet: applet,
		area: area,
		audio: audio,
		base: base,
		basefont: basefont,
		bdo: bdo,
		blockquote: blockquote,
		button: button,
		canvas: canvas,
		col: col,
		colgroup: colgroup,
		data: data,
		del: del,
		details: details,
		dfn: dfn,
		dialog: dialog,
		embed: embed,
		fieldset: fieldset,
		font: font,
		form: form,
		frame: frame,
		frameset: frameset,
		head: head,
		hr: hr,
		html: html,
		iframe: iframe,
		img: img,
		input: input,
		ins: ins,
		keygen: keygen,
		label: label,
		li: li,
		link: link,
		map: map,
		meta: meta,
		meter: meter,
		object: object,
		ol: ol,
		optgroup: optgroup,
		option: option,
		output: output,
		param: param,
		pre: pre,
		progress: progress,
		q: q,
		script: script,
		select: select,
		slot: slot,
		source: source,
		style: style,
		table: table,
		td: td,
		textarea: textarea,
		th: th,
		track: track,
		ul: ul,
		video: video,
		svg: svg,
		elements: elements,
		"*": ["about","acceptCharset","accessKey","allowFullScreen","allowTransparency","autoComplete","autoFocus","autoPlay","capture","cellPadding","cellSpacing","charSet","classID","className","colSpan","contentEditable","contextMenu","crossOrigin","dangerouslySetInnerHTML","datatype","dateTime","dir","draggable","encType","formAction","formEncType","formMethod","formNoValidate","formTarget","frameBorder","hidden","hrefLang","htmlFor","httpEquiv","icon","id","inlist","inputMode","is","itemID","itemProp","itemRef","itemScope","itemType","keyParams","keyType","lang","marginHeight","marginWidth","maxLength","mediaGroup","minLength","noValidate","prefix","property","radioGroup","readOnly","resource","role","rowSpan","scoped","seamless","security","spellCheck","srcDoc","srcLang","srcSet","style","suppressContentEditableWarning","tabIndex","title","typeof","unselectable","useMap","vocab","wmode"]
	};
	
	var reactHtmlAttributes$1 = Object.freeze({
		a: a,
		abbr: abbr,
		applet: applet,
		area: area,
		audio: audio,
		base: base,
		basefont: basefont,
		bdo: bdo,
		blockquote: blockquote,
		button: button,
		canvas: canvas,
		col: col,
		colgroup: colgroup,
		data: data,
		del: del,
		details: details,
		dfn: dfn,
		dialog: dialog,
		embed: embed,
		fieldset: fieldset,
		font: font,
		form: form,
		frame: frame,
		frameset: frameset,
		head: head,
		hr: hr,
		html: html,
		iframe: iframe,
		img: img,
		input: input,
		ins: ins,
		keygen: keygen,
		label: label,
		li: li,
		link: link,
		map: map,
		meta: meta,
		meter: meter,
		object: object,
		ol: ol,
		optgroup: optgroup,
		option: option,
		output: output,
		param: param,
		pre: pre,
		progress: progress,
		q: q,
		script: script,
		select: select,
		slot: slot,
		source: source,
		style: style,
		table: table,
		td: td,
		textarea: textarea,
		th: th,
		track: track,
		ul: ul,
		video: video,
		svg: svg,
		elements: elements,
		default: reactHtmlAttributes
	});
	
	var reactHtmlAttributes$2 = ( reactHtmlAttributes$1 && reactHtmlAttributes ) || reactHtmlAttributes$1;
	
	var dist = createCommonjsModule(function (module, exports) {
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	exports.default = reactHtmlAttributes$2;
	
	module.exports = reactHtmlAttributes$2; // for CommonJS compatibility
	});
	
	var reactHTMLAttributes = unwrapExports(dist);
	
	/*
	 * This is used to check if a property name is one of the React-specific
	 * properties and determine if that property should be forwarded
	 * to the React component
	 */
	
	/* Logic copied from ReactDOMUnknownPropertyHook */
	var reactProps = ['children', 'dangerouslySetInnerHTML', 'key', 'ref', 'autoFocus', 'defaultValue', 'valueLink', 'defaultChecked', 'checkedLink', 'innerHTML', 'suppressContentEditableWarning', 'onFocusIn', 'onFocusOut', 'className',
	
	/* List copied from https://facebook.github.io/react/docs/events.html */
	'onCopy', 'onCut', 'onPaste', 'onCompositionEnd', 'onCompositionStart', 'onCompositionUpdate', 'onKeyDown', 'onKeyPress', 'onKeyUp', 'onFocus', 'onBlur', 'onChange', 'onInput', 'onInvalid', 'onSubmit', 'onClick', 'onContextMenu', 'onDoubleClick', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'onSelect', 'onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart', 'onScroll', 'onWheel', 'onAbort', 'onCanPlay', 'onCanPlayThrough', 'onDurationChange', 'onEmptied', 'onEncrypted', 'onEnded', 'onError', 'onLoadedData', 'onLoadedMetadata', 'onLoadStart', 'onPause', 'onPlay', 'onPlaying', 'onProgress', 'onRateChange', 'onSeeked', 'onSeeking', 'onStalled', 'onSuspend', 'onTimeUpdate', 'onVolumeChange', 'onWaiting', 'onLoad', 'onAnimationStart', 'onAnimationEnd', 'onAnimationIteration', 'onTransitionEnd', 'onCopyCapture', 'onCutCapture', 'onPasteCapture', 'onCompositionEndCapture', 'onCompositionStartCapture', 'onCompositionUpdateCapture', 'onKeyDownCapture', 'onKeyPressCapture', 'onKeyUpCapture', 'onFocusCapture', 'onBlurCapture', 'onChangeCapture', 'onInputCapture', 'onSubmitCapture', 'onClickCapture', 'onContextMenuCapture', 'onDoubleClickCapture', 'onDragCapture', 'onDragEndCapture', 'onDragEnterCapture', 'onDragExitCapture', 'onDragLeaveCapture', 'onDragOverCapture', 'onDragStartCapture', 'onDropCapture', 'onMouseDownCapture', 'onMouseEnterCapture', 'onMouseLeaveCapture', 'onMouseMoveCapture', 'onMouseOutCapture', 'onMouseOverCapture', 'onMouseUpCapture', 'onSelectCapture', 'onTouchCancelCapture', 'onTouchEndCapture', 'onTouchMoveCapture', 'onTouchStartCapture', 'onScrollCapture', 'onWheelCapture', 'onAbortCapture', 'onCanPlayCapture', 'onCanPlayThroughCapture', 'onDurationChangeCapture', 'onEmptiedCapture', 'onEncryptedCapture', 'onEndedCapture', 'onErrorCapture', 'onLoadedDataCapture', 'onLoadedMetadataCapture', 'onLoadStartCapture', 'onPauseCapture', 'onPlayCapture', 'onPlayingCapture', 'onProgressCapture', 'onRateChangeCapture', 'onSeekedCapture', 'onSeekingCapture', 'onStalledCapture', 'onSuspendCapture', 'onTimeUpdateCapture', 'onVolumeChangeCapture', 'onWaitingCapture', 'onLoadCapture', 'onAnimationStartCapture', 'onAnimationEndCapture', 'onAnimationIterationCapture', 'onTransitionEndCapture'];
	
	if (isPreact) {
	  reactProps.push('autocomplete', 'autofocus', 'class', 'for', 'onDblClick', 'onSearch', 'slot', 'srcset');
	}
	
	/* eslint max-lines:0, func-style:0 */
	
	var globalReactHtmlProps = reactHTMLAttributes['*'];
	var supportedSVGTagNames = reactHTMLAttributes.elements.svg;
	var supportedHtmlTagNames = reactHTMLAttributes.elements.html;
	
	// these are valid attributes that have the
	// same name as CSS properties, and is used
	// for css overrides API
	var cssProps = ['color', 'height', 'width'];
	
	/* From DOMProperty */
	var ATTRIBUTE_NAME_START_CHAR =
	// eslint-disable-next-line max-len
	':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	// eslint-disable-next-line max-len
	var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
	var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
	
	var isSvgTag = function (tagName) {
	  return (
	    // in our context, we only say that SVG tags are SVG
	    // if they are not also HTML.
	    // See https://github.com/paypal/glamorous/issues/245
	    // the svg tag will always be treated as svg for
	    // er... obvious reasons
	    tagName === 'svg' || supportedHtmlTagNames.indexOf(tagName) === -1 && supportedSVGTagNames.indexOf(tagName) !== -1
	  );
	};
	var isHtmlProp = function (name, tagName) {
	  var elementAttributes = void 0;
	
	  if (isSvgTag(tagName)) {
	    // all SVG attributes supported by React are grouped under 'svg'
	    elementAttributes = reactHTMLAttributes.svg;
	  } else {
	    elementAttributes = reactHTMLAttributes[tagName] || [];
	  }
	
	  return globalReactHtmlProps.indexOf(name) !== -1 || elementAttributes.indexOf(name) !== -1;
	};
	var isCssProp = function (name) {
	  return cssProps.indexOf(name) !== -1;
	};
	var isReactProp = function (name) {
	  return reactProps.indexOf(name) !== -1;
	};
	
	// eslint-disable-next-line complexity
	var shouldForwardProperty = function (tagName, name) {
	  return typeof tagName !== 'string' || (isHtmlProp(name, tagName) || isReactProp(name) || isCustomAttribute(name.toLowerCase())) && (!isCssProp(name) || isSvgTag(tagName));
	};
	
	var shouldForwardProperty$1 = src(shouldForwardProperty);
	
	// eslint-disable-next-line complexity
	function splitProps(_ref, _ref2) {
	  var propsAreCssOverrides = _ref2.propsAreCssOverrides,
	      rootEl = _ref2.rootEl,
	      filterProps = _ref2.filterProps,
	      forwardProps = _ref2.forwardProps;
	  var cssProp = _ref.css,
	      innerRef = _ref.innerRef,
	      theme = _ref.theme,
	      className = _ref.className,
	      glam = _ref.glam,
	      rest = objectWithoutProperties(_ref, ['css', 'innerRef', 'theme', 'className', 'glam']);
	
	  // forward innerRef if user wishes to do so
	  if (innerRef !== undefined && forwardProps.indexOf('innerRef') !== -1) {
	    rest.innerRef = innerRef;
	  }
	  var returnValue = { toForward: {}, cssProp: cssProp, cssOverrides: {} };
	  if (!propsAreCssOverrides) {
	    if (typeof rootEl !== 'string' && filterProps.length === 0) {
	      // if it's not a string and filterProps is empty,
	      // then we can forward everything (because it's a component)
	      returnValue.toForward = rest;
	      return returnValue;
	    }
	  }
	  return Object.keys(rest).reduce(function (split, propName) {
	    if (filterProps.indexOf(propName) !== -1) {
	      return split;
	    } else if (forwardProps.indexOf(propName) !== -1 || shouldForwardProperty$1(rootEl, propName)) {
	      split.toForward[propName] = rest[propName];
	    } else if (propsAreCssOverrides) {
	      split.cssOverrides[propName] = rest[propName];
	    }
	    return split;
	  }, returnValue);
	}
	
	var glamorous = createGlamorous(splitProps);
	
	/*
	 * This creates a glamorousComponentFactory for every DOM element so you can
	 * simply do:
	 * const GreenButton = glamorous.button({
	 *   backgroundColor: 'green',
	 *   padding: 20,
	 * })
	 * <GreenButton>Click Me!</GreenButton>
	 */
	Object.assign(glamorous, domElements.reduce(function (getters, tag) {
	  // TODO: next breaking change, let's make
	  // the `displayName` be: `glamorous.${tag}`
	  getters[tag] = glamorous(tag);
	  return getters;
	}, {}));
	
	/*
	 * This creates a glamorous component for each DOM element so you can
	 * simply do:
	 * <glamorous.Div
	 *   color="green"
	 *   marginLeft={20}
	 * >
	 *   I'm green!
	 * </glamorous.Div>
	 */
	Object.assign(glamorous, domElements.reduce(function (comps, tag) {
	  var capitalTag = capitalize(tag);
	  comps[capitalTag] = glamorous[tag]();
	  comps[capitalTag].displayName = 'glamorous.' + capitalTag;
	  comps[capitalTag].propsAreCssOverrides = true;
	  return comps;
	}, {}));
	
	function capitalize(s) {
	  return s.slice(0, 1).toUpperCase() + s.slice(1);
	}
	
	/*
	 * Fix importing in typescript after rollup compilation
	 * https://github.com/rollup/rollup/issues/1156
	 * https://github.com/Microsoft/TypeScript/issues/13017#issuecomment-268657860
	 */
	glamorous.default = glamorous;
	
	
	var glamorousStar = Object.freeze({
		default: glamorous,
		ThemeProvider: ThemeProvider,
		withTheme: withTheme
	});
	
	/* istanbul ignore next */
	
	var glamorous$1 = glamorous;
	
	Object.assign(glamorous$1, Object.keys(glamorousStar).reduce(function (e, prop) {
	  if (prop !== 'default') {
	    // eslint-disable-next-line import/namespace
	    e[prop] = glamorousStar[prop];
	  }
	  return e;
	}, {}));
	
	module.exports = glamorous$1;


/***/ }),
/* 1321 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable no-var, prefer-template */
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function toHyphenLower(match) {
	  return '-' + match.toLowerCase()
	}
	
	function hyphenateStyleName(name) {
	  if (cache.hasOwnProperty(name)) {
	    return cache[name]
	  }
	
	  var hName = name.replace(uppercasePattern, toHyphenLower);
	  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
	}
	
	module.exports = hyphenateStyleName;


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createPrefixer;
	
	var _getBrowserInformation = __webpack_require__(1339);
	
	var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);
	
	var _getPrefixedKeyframes = __webpack_require__(1340);
	
	var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);
	
	var _capitalizeString = __webpack_require__(462);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _addNewValuesOnly = __webpack_require__(685);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(686);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _prefixValue = __webpack_require__(463);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (style) {
	    return style;
	  };
	
	  return function () {
	    /**
	    * Instantiante a new prefixer
	    * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
	    * @param {string} keepUnprefixed - keeps unprefixed properties and values
	    */
	    function Prefixer() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      _classCallCheck(this, Prefixer);
	
	      var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
	      this._userAgent = options.userAgent || defaultUserAgent;
	      this._keepUnprefixed = options.keepUnprefixed || false;
	
	      if (this._userAgent) {
	        this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
	      }
	
	      // Checks if the userAgent was resolved correctly
	      if (this._browserInfo && this._browserInfo.cssPrefix) {
	        this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo.browserName, this._browserInfo.browserVersion, this._browserInfo.cssPrefix);
	      } else {
	        this._useFallback = true;
	        return false;
	      }
	
	      var prefixData = this._browserInfo.browserName && prefixMap[this._browserInfo.browserName];
	      if (prefixData) {
	        this._requiresPrefix = {};
	
	        for (var property in prefixData) {
	          if (prefixData[property] >= this._browserInfo.browserVersion) {
	            this._requiresPrefix[property] = true;
	          }
	        }
	
	        this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
	      } else {
	        this._useFallback = true;
	      }
	
	      this._metaData = {
	        browserVersion: this._browserInfo.browserVersion,
	        browserName: this._browserInfo.browserName,
	        cssPrefix: this._browserInfo.cssPrefix,
	        jsPrefix: this._browserInfo.jsPrefix,
	        keepUnprefixed: this._keepUnprefixed,
	        requiresPrefix: this._requiresPrefix
	      };
	    }
	
	    _createClass(Prefixer, [{
	      key: 'prefix',
	      value: function prefix(style) {
	        // use static prefixer as fallback if userAgent can not be resolved
	        if (this._useFallback) {
	          return fallback(style);
	        }
	
	        // only add prefixes if needed
	        if (!this._hasPropsRequiringPrefix) {
	          return style;
	        }
	
	        return this._prefixStyle(style);
	      }
	    }, {
	      key: '_prefixStyle',
	      value: function _prefixStyle(style) {
	        for (var property in style) {
	          var value = style[property];
	
	          // handle nested objects
	          if ((0, _isObject2.default)(value)) {
	            style[property] = this.prefix(value);
	            // handle array values
	          } else if (Array.isArray(value)) {
	            var combinedValue = [];
	
	            for (var i = 0, len = value.length; i < len; ++i) {
	              var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, this._metaData);
	              (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	            }
	
	            // only modify the value if it was touched
	            // by any plugin to prevent unnecessary mutations
	            if (combinedValue.length > 0) {
	              style[property] = combinedValue;
	            }
	          } else {
	            var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, this._metaData);
	
	            // only modify the value if it was touched
	            // by any plugin to prevent unnecessary mutations
	            if (_processedValue) {
	              style[property] = _processedValue;
	            }
	
	            // add prefixes to properties
	            if (this._requiresPrefix.hasOwnProperty(property)) {
	              style[this._browserInfo.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
	              if (!this._keepUnprefixed) {
	                delete style[property];
	              }
	            }
	          }
	        }
	
	        return style;
	      }
	
	      /**
	      * Returns a prefixed version of the style object using all vendor prefixes
	      * @param {Object} styles - Style object that gets prefixed properties added
	      * @returns {Object} - Style object with prefixed properties and values
	      */
	
	    }], [{
	      key: 'prefixAll',
	      value: function prefixAll(styles) {
	        return fallback(styles);
	      }
	    }]);
	
	    return Prefixer;
	  }();
	}
	module.exports = exports['default'];

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _getPrefixedValue = __webpack_require__(237);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calc(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browserName === 'firefox' && browserVersion < 15 || browserName === 'chrome' && browserVersion < 25 || browserName === 'safari' && browserVersion < 6.1 || browserName === 'ios_saf' && browserVersion < 7)) {
	    return (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, cssPrefix + 'calc('), value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	
	var _getPrefixedValue = __webpack_require__(237);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  flex: true,
	  'inline-flex': true
	};
	function flex(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'display' && values[value] && (browserName === 'chrome' && browserVersion < 29 && browserVersion > 20 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 && browserVersion > 6 || browserName === 'opera' && (browserVersion === 15 || browserVersion === 16))) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	var _getPrefixedValue = __webpack_require__(237);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  flex: 'flexbox',
	  'inline-flex': 'inline-flexbox'
	};
	
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msFlexPreferredSize'
	};
	
	function flexboxIE(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if ((alternativeProps.hasOwnProperty(property) || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'ie_mob' || browserName === 'ie') && browserVersion === 10) {
	    delete requiresPrefix[property];
	
	    if (!keepUnprefixed && !Array.isArray(style[property])) {
	      delete style[property];
	    }
	    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
	      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
	    }
	    if (alternativeProps.hasOwnProperty(property)) {
	      style[alternativeProps[property]] = alternativeValues[value] || value;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	var _getPrefixedValue = __webpack_require__(237);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
	var properties = Object.keys(alternativeProps).concat(otherProps);
	
	function flexboxOld(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'firefox' && browserVersion < 22 || browserName === 'chrome' && browserVersion < 21 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion <= 6.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
	    delete requiresPrefix[property];
	
	    if (!keepUnprefixed && !Array.isArray(style[property])) {
	      delete style[property];
	    }
	    if (property === 'flexDirection' && typeof value === 'string') {
	      if (value.indexOf('column') > -1) {
	        style.WebkitBoxOrient = 'vertical';
	      } else {
	        style.WebkitBoxOrient = 'horizontal';
	      }
	      if (value.indexOf('reverse') > -1) {
	        style.WebkitBoxDirection = 'reverse';
	      } else {
	        style.WebkitBoxDirection = 'normal';
	      }
	    }
	    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
	      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
	    }
	    if (alternativeProps.hasOwnProperty(property)) {
	      style[alternativeProps[property]] = alternativeValues[value] || value;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _getPrefixedValue = __webpack_require__(237);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	function gradient(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && values.test(value) && (browserName === 'firefox' && browserVersion < 16 || browserName === 'chrome' && browserVersion < 26 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 7 || (browserName === 'opera' || browserName === 'op_mini') && browserVersion < 12.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _getPrefixedValue = __webpack_require__(237);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	
	  // TODO: chrome & opera support it
	};function sizing(property, value, style, _ref) {
	  var cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  // This might change in the future
	  // Keep an eye on it
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(438);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var requiresPrefixDashCased = void 0;
	
	function transition(property, value, style, _ref) {
	  var cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    // memoize the prefix array for later use
	    if (!requiresPrefixDashCased) {
	      requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
	        return (0, _hyphenateProperty2.default)(prop);
	      });
	    }
	
	    // only split multi values, not cubic beziers
	    var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	    requiresPrefixDashCased.forEach(function (prop) {
	      multipleValues.forEach(function (val, index) {
	        if (val.indexOf(prop) > -1 && prop !== 'order') {
	          multipleValues[index] = val.replace(prop, cssPrefix + prop) + (keepUnprefixed ? ',' + val : '');
	        }
	      });
	    });
	
	    return multipleValues.join(',');
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPrefixer;
	
	var _prefixProperty = __webpack_require__(687);
	
	var _prefixProperty2 = _interopRequireDefault(_prefixProperty);
	
	var _prefixValue = __webpack_require__(463);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	var _addNewValuesOnly = __webpack_require__(685);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(686);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	
	  function prefixAll(style) {
	    for (var property in style) {
	      var value = style[property];
	
	      // handle nested objects
	      if ((0, _isObject2.default)(value)) {
	        style[property] = prefixAll(value);
	        // handle array values
	      } else if (Array.isArray(value)) {
	        var combinedValue = [];
	
	        for (var i = 0, len = value.length; i < len; ++i) {
	          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
	          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	        }
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (combinedValue.length > 0) {
	          style[property] = combinedValue;
	        }
	      } else {
	        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (_processedValue) {
	          style[property] = _processedValue;
	        }
	
	        (0, _prefixProperty2.default)(prefixMap, property, style);
	      }
	    }
	
	    return style;
	  }
	
	  return prefixAll;
	}
	module.exports = exports['default'];

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _isPrefixedValue = __webpack_require__(135);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = crossFade;
	
	var _isPrefixedValue = __webpack_require__(135);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#search=cross-fade
	var prefixes = ['-webkit-', ''];
	function crossFade(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filter;
	
	var _isPrefixedValue = __webpack_require__(135);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-filter-function
	var prefixes = ['-webkit-', ''];
	function filter(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/filter\(/g, prefix + 'filter(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msFlexPreferredSize'
	};
	
	function flexboxIE(property, value, style) {
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = imageSet;
	
	var _isPrefixedValue = __webpack_require__(135);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-image-set
	var prefixes = ['-webkit-', ''];
	function imageSet(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/image-set\(/g, prefix + 'image-set(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return ['-webkit-sticky', 'sticky'];
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var w = ["Webkit"];
	var m = ["Moz"];
	var ms = ["ms"];
	var wm = ["Webkit", "Moz"];
	var wms = ["Webkit", "ms"];
	var wmms = ["Webkit", "Moz", "ms"];
	
	exports.default = {
	  plugins: [],
	  prefixMap: { "appearance": wm, "userSelect": wmms, "textEmphasisPosition": w, "textEmphasis": w, "textEmphasisStyle": w, "textEmphasisColor": w, "boxDecorationBreak": w, "clipPath": w, "maskImage": w, "maskMode": w, "maskRepeat": w, "maskPosition": w, "maskClip": w, "maskOrigin": w, "maskSize": w, "maskComposite": w, "mask": w, "maskBorderSource": w, "maskBorderMode": w, "maskBorderSlice": w, "maskBorderWidth": w, "maskBorderOutset": w, "maskBorderRepeat": w, "maskBorder": w, "maskType": w, "textDecorationStyle": w, "textDecorationSkip": w, "textDecorationLine": w, "textDecorationColor": w, "filter": w, "fontFeatureSettings": w, "breakAfter": wmms, "breakBefore": wmms, "breakInside": wmms, "columnCount": wm, "columnFill": wm, "columnGap": wm, "columnRule": wm, "columnRuleColor": wm, "columnRuleStyle": wm, "columnRuleWidth": wm, "columns": wm, "columnSpan": wm, "columnWidth": wm, "writingMode": wms, "flex": w, "flexBasis": w, "flexDirection": w, "flexGrow": w, "flexFlow": w, "flexShrink": w, "flexWrap": w, "alignContent": w, "alignItems": w, "alignSelf": w, "justifyContent": w, "order": w, "transform": w, "transformOrigin": w, "transformOriginX": w, "transformOriginY": w, "backfaceVisibility": w, "perspective": w, "perspectiveOrigin": w, "transformStyle": w, "transformOriginZ": w, "animation": w, "animationDelay": w, "animationDirection": w, "animationFillMode": w, "animationDuration": w, "animationIterationCount": w, "animationName": w, "animationPlayState": w, "animationTimingFunction": w, "backdropFilter": w, "fontKerning": w, "scrollSnapType": wms, "scrollSnapPointsX": wms, "scrollSnapPointsY": wms, "scrollSnapDestination": wms, "scrollSnapCoordinate": wms, "shapeImageThreshold": w, "shapeImageMargin": w, "shapeImageOutside": w, "hyphens": wmms, "flowInto": wms, "flowFrom": wms, "regionFragment": wms, "textAlignLast": m, "tabSize": m, "wrapFlow": ms, "wrapThrough": ms, "wrapMargin": ms, "gridTemplateColumns": ms, "gridTemplateRows": ms, "gridTemplateAreas": ms, "gridTemplate": ms, "gridAutoColumns": ms, "gridAutoRows": ms, "gridAutoFlow": ms, "grid": ms, "gridRowStart": ms, "gridColumnStart": ms, "gridRowEnd": ms, "gridRow": ms, "gridColumn": ms, "gridColumnEnd": ms, "gridColumnGap": ms, "gridRowGap": ms, "gridArea": ms, "gridGap": ms, "textSizeAdjust": wms, "borderImage": w, "borderImageOutset": w, "borderImageRepeat": w, "borderImageSlice": w, "borderImageSource": w, "borderImageWidth": w, "transitionDelay": w, "transitionDuration": w, "transitionProperty": w, "transitionTimingFunction": w }
	};
	module.exports = exports["default"];

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getBrowserInformation;
	
	var _bowser = __webpack_require__(1035);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixByBrowser = {
	  chrome: 'Webkit',
	  safari: 'Webkit',
	  ios: 'Webkit',
	  android: 'Webkit',
	  phantom: 'Webkit',
	  opera: 'Webkit',
	  webos: 'Webkit',
	  blackberry: 'Webkit',
	  bada: 'Webkit',
	  tizen: 'Webkit',
	  chromium: 'Webkit',
	  vivaldi: 'Webkit',
	  firefox: 'Moz',
	  seamoney: 'Moz',
	  sailfish: 'Moz',
	  msie: 'ms',
	  msedge: 'ms'
	};
	
	
	var browserByCanIuseAlias = {
	  chrome: 'chrome',
	  chromium: 'chrome',
	  safari: 'safari',
	  firfox: 'firefox',
	  msedge: 'edge',
	  opera: 'opera',
	  vivaldi: 'opera',
	  msie: 'ie'
	};
	
	function getBrowserName(browserInfo) {
	  if (browserInfo.firefox) {
	    return 'firefox';
	  }
	
	  if (browserInfo.mobile || browserInfo.tablet) {
	    if (browserInfo.ios) {
	      return 'ios_saf';
	    } else if (browserInfo.android) {
	      return 'android';
	    } else if (browserInfo.opera) {
	      return 'op_mini';
	    }
	  }
	
	  for (var browser in browserByCanIuseAlias) {
	    if (browserInfo.hasOwnProperty(browser)) {
	      return browserByCanIuseAlias[browser];
	    }
	  }
	}
	
	/**
	 * Uses bowser to get default browser browserInformation such as version and name
	 * Evaluates bowser browserInfo and adds vendorPrefix browserInformation
	 * @param {string} userAgent - userAgent that gets evaluated
	 */
	function getBrowserInformation(userAgent) {
	  var browserInfo = _bowser2.default._detect(userAgent);
	
	  if (browserInfo.yandexbrowser) {
	    browserInfo = _bowser2.default._detect(userAgent.replace(/YaBrowser\/[0-9.]*/, ''));
	  }
	
	  for (var browser in prefixByBrowser) {
	    if (browserInfo.hasOwnProperty(browser)) {
	      var prefix = prefixByBrowser[browser];
	
	      browserInfo.jsPrefix = prefix;
	      browserInfo.cssPrefix = '-' + prefix.toLowerCase() + '-';
	      break;
	    }
	  }
	
	  browserInfo.browserName = getBrowserName(browserInfo);
	
	  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
	  if (browserInfo.version) {
	    browserInfo.browserVersion = parseFloat(browserInfo.version);
	  } else {
	    browserInfo.browserVersion = parseInt(parseFloat(browserInfo.osversion), 10);
	  }
	
	  browserInfo.osVersion = parseFloat(browserInfo.osversion);
	
	  // iOS forces all browsers to use Safari under the hood
	  // as the Safari version seems to match the iOS version
	  // we just explicitely use the osversion instead
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
	  if (browserInfo.browserName === 'ios_saf' && browserInfo.browserVersion > browserInfo.osVersion) {
	    browserInfo.browserVersion = browserInfo.osVersion;
	  }
	
	  // seperate native android chrome
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
	  if (browserInfo.browserName === 'android' && browserInfo.chrome && browserInfo.browserVersion > 37) {
	    browserInfo.browserName = 'and_chr';
	  }
	
	  // For android < 4.4 we want to check the osversion
	  // not the chrome version, see issue #26
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
	  if (browserInfo.browserName === 'android' && browserInfo.osVersion < 5) {
	    browserInfo.browserVersion = browserInfo.osVersion;
	  }
	
	  // Samsung browser are basically build on Chrome > 44
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/102
	  if (browserInfo.browserName === 'android' && browserInfo.samsungBrowser) {
	    browserInfo.browserName = 'and_chr';
	    browserInfo.browserVersion = 44;
	  }
	
	  return browserInfo;
	}
	module.exports = exports['default'];

/***/ }),
/* 1340 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPrefixedKeyframes;
	function getPrefixedKeyframes(browserName, browserVersion, cssPrefix) {
	  var prefixedKeyframes = 'keyframes';
	
	  if (browserName === 'chrome' && browserVersion < 43 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 || browserName === 'opera' && browserVersion < 30 || browserName === 'android' && browserVersion <= 4.4 || browserName === 'and_uc') {
	    return cssPrefix + prefixedKeyframes;
	  }
	  return prefixedKeyframes;
	}
	module.exports = exports['default'];

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(1342)['default'];
	exports['default'] = exports;


/***/ }),
/* 1342 */
/***/ (function(module, exports) {

	"use strict";
	
	exports["default"] = (function() {
	  "use strict";
	
	  /*
	   * Generated by PEG.js 0.9.0.
	   *
	   * http://pegjs.org/
	   */
	
	  function peg$subclass(child, parent) {
	    function ctor() { this.constructor = child; }
	    ctor.prototype = parent.prototype;
	    child.prototype = new ctor();
	  }
	
	  function peg$SyntaxError(message, expected, found, location) {
	    this.message  = message;
	    this.expected = expected;
	    this.found    = found;
	    this.location = location;
	    this.name     = "SyntaxError";
	
	    if (typeof Error.captureStackTrace === "function") {
	      Error.captureStackTrace(this, peg$SyntaxError);
	    }
	  }
	
	  peg$subclass(peg$SyntaxError, Error);
	
	  function peg$parse(input) {
	    var options = arguments.length > 1 ? arguments[1] : {},
	        parser  = this,
	
	        peg$FAILED = {},
	
	        peg$startRuleFunctions = { start: peg$parsestart },
	        peg$startRuleFunction  = peg$parsestart,
	
	        peg$c0 = function(elements) {
	                return {
	                    type    : 'messageFormatPattern',
	                    elements: elements,
	                    location: location()
	                };
	            },
	        peg$c1 = function(text) {
	                var string = '',
	                    i, j, outerLen, inner, innerLen;
	
	                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
	                    inner = text[i];
	
	                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
	                        string += inner[j];
	                    }
	                }
	
	                return string;
	            },
	        peg$c2 = function(messageText) {
	                return {
	                    type : 'messageTextElement',
	                    value: messageText,
	                    location: location()
	                };
	            },
	        peg$c3 = /^[^ \t\n\r,.+={}#]/,
	        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
	        peg$c5 = "{",
	        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
	        peg$c7 = ",",
	        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
	        peg$c9 = "}",
	        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
	        peg$c11 = function(id, format) {
	                return {
	                    type  : 'argumentElement',
	                    id    : id,
	                    format: format && format[2],
	                    location: location()
	                };
	            },
	        peg$c12 = "number",
	        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
	        peg$c14 = "date",
	        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
	        peg$c16 = "time",
	        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
	        peg$c18 = function(type, style) {
	                return {
	                    type : type + 'Format',
	                    style: style && style[2],
	                    location: location()
	                };
	            },
	        peg$c19 = "plural",
	        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
	        peg$c21 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: false,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options,
	                    location: location()
	                };
	            },
	        peg$c22 = "selectordinal",
	        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
	        peg$c24 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: true,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options,
	                    location: location()
	                }
	            },
	        peg$c25 = "select",
	        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
	        peg$c27 = function(options) {
	                return {
	                    type   : 'selectFormat',
	                    options: options,
	                    location: location()
	                };
	            },
	        peg$c28 = "=",
	        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
	        peg$c30 = function(selector, pattern) {
	                return {
	                    type    : 'optionalFormatPattern',
	                    selector: selector,
	                    value   : pattern,
	                    location: location()
	                };
	            },
	        peg$c31 = "offset:",
	        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
	        peg$c33 = function(number) {
	                return number;
	            },
	        peg$c34 = function(offset, options) {
	                return {
	                    type   : 'pluralFormat',
	                    offset : offset,
	                    options: options,
	                    location: location()
	                };
	            },
	        peg$c35 = { type: "other", description: "whitespace" },
	        peg$c36 = /^[ \t\n\r]/,
	        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
	        peg$c38 = { type: "other", description: "optionalWhitespace" },
	        peg$c39 = /^[0-9]/,
	        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
	        peg$c41 = /^[0-9a-f]/i,
	        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
	        peg$c43 = "0",
	        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
	        peg$c45 = /^[1-9]/,
	        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
	        peg$c47 = function(digits) {
	            return parseInt(digits, 10);
	        },
	        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
	        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
	        peg$c50 = "\\\\",
	        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
	        peg$c52 = function() { return '\\'; },
	        peg$c53 = "\\#",
	        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
	        peg$c55 = function() { return '\\#'; },
	        peg$c56 = "\\{",
	        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
	        peg$c58 = function() { return '\u007B'; },
	        peg$c59 = "\\}",
	        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
	        peg$c61 = function() { return '\u007D'; },
	        peg$c62 = "\\u",
	        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
	        peg$c64 = function(digits) {
	                return String.fromCharCode(parseInt(digits, 16));
	            },
	        peg$c65 = function(chars) { return chars.join(''); },
	
	        peg$currPos          = 0,
	        peg$savedPos         = 0,
	        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
	        peg$maxFailPos       = 0,
	        peg$maxFailExpected  = [],
	        peg$silentFails      = 0,
	
	        peg$result;
	
	    if ("startRule" in options) {
	      if (!(options.startRule in peg$startRuleFunctions)) {
	        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	      }
	
	      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	
	    function text() {
	      return input.substring(peg$savedPos, peg$currPos);
	    }
	
	    function location() {
	      return peg$computeLocation(peg$savedPos, peg$currPos);
	    }
	
	    function expected(description) {
	      throw peg$buildException(
	        null,
	        [{ type: "other", description: description }],
	        input.substring(peg$savedPos, peg$currPos),
	        peg$computeLocation(peg$savedPos, peg$currPos)
	      );
	    }
	
	    function error(message) {
	      throw peg$buildException(
	        message,
	        null,
	        input.substring(peg$savedPos, peg$currPos),
	        peg$computeLocation(peg$savedPos, peg$currPos)
	      );
	    }
	
	    function peg$computePosDetails(pos) {
	      var details = peg$posDetailsCache[pos],
	          p, ch;
	
	      if (details) {
	        return details;
	      } else {
	        p = pos - 1;
	        while (!peg$posDetailsCache[p]) {
	          p--;
	        }
	
	        details = peg$posDetailsCache[p];
	        details = {
	          line:   details.line,
	          column: details.column,
	          seenCR: details.seenCR
	        };
	
	        while (p < pos) {
	          ch = input.charAt(p);
	          if (ch === "\n") {
	            if (!details.seenCR) { details.line++; }
	            details.column = 1;
	            details.seenCR = false;
	          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
	            details.line++;
	            details.column = 1;
	            details.seenCR = true;
	          } else {
	            details.column++;
	            details.seenCR = false;
	          }
	
	          p++;
	        }
	
	        peg$posDetailsCache[pos] = details;
	        return details;
	      }
	    }
	
	    function peg$computeLocation(startPos, endPos) {
	      var startPosDetails = peg$computePosDetails(startPos),
	          endPosDetails   = peg$computePosDetails(endPos);
	
	      return {
	        start: {
	          offset: startPos,
	          line:   startPosDetails.line,
	          column: startPosDetails.column
	        },
	        end: {
	          offset: endPos,
	          line:   endPosDetails.line,
	          column: endPosDetails.column
	        }
	      };
	    }
	
	    function peg$fail(expected) {
	      if (peg$currPos < peg$maxFailPos) { return; }
	
	      if (peg$currPos > peg$maxFailPos) {
	        peg$maxFailPos = peg$currPos;
	        peg$maxFailExpected = [];
	      }
	
	      peg$maxFailExpected.push(expected);
	    }
	
	    function peg$buildException(message, expected, found, location) {
	      function cleanupExpected(expected) {
	        var i = 1;
	
	        expected.sort(function(a, b) {
	          if (a.description < b.description) {
	            return -1;
	          } else if (a.description > b.description) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	
	        while (i < expected.length) {
	          if (expected[i - 1] === expected[i]) {
	            expected.splice(i, 1);
	          } else {
	            i++;
	          }
	        }
	      }
	
	      function buildMessage(expected, found) {
	        function stringEscape(s) {
	          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }
	
	          return s
	            .replace(/\\/g,   '\\\\')
	            .replace(/"/g,    '\\"')
	            .replace(/\x08/g, '\\b')
	            .replace(/\t/g,   '\\t')
	            .replace(/\n/g,   '\\n')
	            .replace(/\f/g,   '\\f')
	            .replace(/\r/g,   '\\r')
	            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
	            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
	            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
	            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
	        }
	
	        var expectedDescs = new Array(expected.length),
	            expectedDesc, foundDesc, i;
	
	        for (i = 0; i < expected.length; i++) {
	          expectedDescs[i] = expected[i].description;
	        }
	
	        expectedDesc = expected.length > 1
	          ? expectedDescs.slice(0, -1).join(", ")
	              + " or "
	              + expectedDescs[expected.length - 1]
	          : expectedDescs[0];
	
	        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
	
	        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
	      }
	
	      if (expected !== null) {
	        cleanupExpected(expected);
	      }
	
	      return new peg$SyntaxError(
	        message !== null ? message : buildMessage(expected, found),
	        expected,
	        found,
	        location
	      );
	    }
	
	    function peg$parsestart() {
	      var s0;
	
	      s0 = peg$parsemessageFormatPattern();
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatPattern() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsemessageFormatElement();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsemessageFormatElement();
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c0(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatElement() {
	      var s0;
	
	      s0 = peg$parsemessageTextElement();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseargumentElement();
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageText() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parsechars();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parse_();
	          if (s5 !== peg$FAILED) {
	            s3 = [s3, s4, s5];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$FAILED;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsechars();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s3 = [s3, s4, s5];
	                s2 = s3;
	              } else {
	                peg$currPos = s2;
	                s2 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s2;
	              s2 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c1(s1);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = peg$parsews();
	        if (s1 !== peg$FAILED) {
	          s0 = input.substring(s0, peg$currPos);
	        } else {
	          s0 = s1;
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageTextElement() {
	      var s0, s1;
	
	      s0 = peg$currPos;
	      s1 = peg$parsemessageText();
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c2(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseargument() {
	      var s0, s1, s2;
	
	      s0 = peg$parsenumber();
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = [];
	        if (peg$c3.test(input.charAt(peg$currPos))) {
	          s2 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c4); }
	        }
	        if (s2 !== peg$FAILED) {
	          while (s2 !== peg$FAILED) {
	            s1.push(s2);
	            if (peg$c3.test(input.charAt(peg$currPos))) {
	              s2 = input.charAt(peg$currPos);
	              peg$currPos++;
	            } else {
	              s2 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c4); }
	            }
	          }
	        } else {
	          s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	          s0 = input.substring(s0, peg$currPos);
	        } else {
	          s0 = s1;
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parseargumentElement() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 123) {
	        s1 = peg$c5;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c6); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parseargument();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$currPos;
	              if (input.charCodeAt(peg$currPos) === 44) {
	                s6 = peg$c7;
	                peg$currPos++;
	              } else {
	                s6 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c8); }
	              }
	              if (s6 !== peg$FAILED) {
	                s7 = peg$parse_();
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parseelementFormat();
	                  if (s8 !== peg$FAILED) {
	                    s6 = [s6, s7, s8];
	                    s5 = s6;
	                  } else {
	                    peg$currPos = s5;
	                    s5 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s5;
	                  s5 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s5;
	                s5 = peg$FAILED;
	              }
	              if (s5 === peg$FAILED) {
	                s5 = null;
	              }
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parse_();
	                if (s6 !== peg$FAILED) {
	                  if (input.charCodeAt(peg$currPos) === 125) {
	                    s7 = peg$c9;
	                    peg$currPos++;
	                  } else {
	                    s7 = peg$FAILED;
	                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
	                  }
	                  if (s7 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c11(s3, s5);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseelementFormat() {
	      var s0;
	
	      s0 = peg$parsesimpleFormat();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsepluralFormat();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parseselectOrdinalFormat();
	          if (s0 === peg$FAILED) {
	            s0 = peg$parseselectFormat();
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsesimpleFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c12) {
	        s1 = peg$c12;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c13); }
	      }
	      if (s1 === peg$FAILED) {
	        if (input.substr(peg$currPos, 4) === peg$c14) {
	          s1 = peg$c14;
	          peg$currPos += 4;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c15); }
	        }
	        if (s1 === peg$FAILED) {
	          if (input.substr(peg$currPos, 4) === peg$c16) {
	            s1 = peg$c16;
	            peg$currPos += 4;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c17); }
	          }
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$currPos;
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s4 = peg$c7;
	            peg$currPos++;
	          } else {
	            s4 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s4 !== peg$FAILED) {
	            s5 = peg$parse_();
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parsechars();
	              if (s6 !== peg$FAILED) {
	                s4 = [s4, s5, s6];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s3;
	            s3 = peg$FAILED;
	          }
	          if (s3 === peg$FAILED) {
	            s3 = null;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c18(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c19) {
	        s1 = peg$c19;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c20); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c21(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectOrdinalFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 13) === peg$c22) {
	        s1 = peg$c22;
	        peg$currPos += 13;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c23); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c24(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c25) {
	        s1 = peg$c25;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c26); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = [];
	              s6 = peg$parseoptionalFormatPattern();
	              if (s6 !== peg$FAILED) {
	                while (s6 !== peg$FAILED) {
	                  s5.push(s6);
	                  s6 = peg$parseoptionalFormatPattern();
	                }
	              } else {
	                s5 = peg$FAILED;
	              }
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c27(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselector() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 61) {
	        s2 = peg$c28;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c29); }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parsenumber();
	        if (s3 !== peg$FAILED) {
	          s2 = [s2, s3];
	          s1 = s2;
	        } else {
	          peg$currPos = s1;
	          s1 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s1;
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        s0 = input.substring(s0, peg$currPos);
	      } else {
	        s0 = s1;
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsechars();
	      }
	
	      return s0;
	    }
	
	    function peg$parseoptionalFormatPattern() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseselector();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 123) {
	              s4 = peg$c5;
	              peg$currPos++;
	            } else {
	              s4 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c6); }
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parsemessageFormatPattern();
	                if (s6 !== peg$FAILED) {
	                  s7 = peg$parse_();
	                  if (s7 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 125) {
	                      s8 = peg$c9;
	                      peg$currPos++;
	                    } else {
	                      s8 = peg$FAILED;
	                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
	                    }
	                    if (s8 !== peg$FAILED) {
	                      peg$savedPos = s0;
	                      s1 = peg$c30(s2, s6);
	                      s0 = s1;
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseoffset() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 7) === peg$c31) {
	        s1 = peg$c31;
	        peg$currPos += 7;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c32); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parsenumber();
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c33(s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralStyle() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$parseoffset();
	      if (s1 === peg$FAILED) {
	        s1 = null;
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = [];
	          s4 = peg$parseoptionalFormatPattern();
	          if (s4 !== peg$FAILED) {
	            while (s4 !== peg$FAILED) {
	              s3.push(s4);
	              s4 = peg$parseoptionalFormatPattern();
	            }
	          } else {
	            s3 = peg$FAILED;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c34(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsews() {
	      var s0, s1;
	
	      peg$silentFails++;
	      s0 = [];
	      if (peg$c36.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c37); }
	      }
	      if (s1 !== peg$FAILED) {
	        while (s1 !== peg$FAILED) {
	          s0.push(s1);
	          if (peg$c36.test(input.charAt(peg$currPos))) {
	            s1 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c37); }
	          }
	        }
	      } else {
	        s0 = peg$FAILED;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c35); }
	      }
	
	      return s0;
	    }
	
	    function peg$parse_() {
	      var s0, s1, s2;
	
	      peg$silentFails++;
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsews();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsews();
	      }
	      if (s1 !== peg$FAILED) {
	        s0 = input.substring(s0, peg$currPos);
	      } else {
	        s0 = s1;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c38); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsedigit() {
	      var s0;
	
	      if (peg$c39.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c40); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsehexDigit() {
	      var s0;
	
	      if (peg$c41.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c42); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsenumber() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 48) {
	        s1 = peg$c43;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c44); }
	      }
	      if (s1 === peg$FAILED) {
	        s1 = peg$currPos;
	        s2 = peg$currPos;
	        if (peg$c45.test(input.charAt(peg$currPos))) {
	          s3 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s3 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c46); }
	        }
	        if (s3 !== peg$FAILED) {
	          s4 = [];
	          s5 = peg$parsedigit();
	          while (s5 !== peg$FAILED) {
	            s4.push(s5);
	            s5 = peg$parsedigit();
	          }
	          if (s4 !== peg$FAILED) {
	            s3 = [s3, s4];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	          s1 = input.substring(s1, peg$currPos);
	        } else {
	          s1 = s2;
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c47(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsechar() {
	      var s0, s1, s2, s3, s4, s5, s6, s7;
	
	      if (peg$c48.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c49); }
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c50) {
	          s1 = peg$c50;
	          peg$currPos += 2;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c51); }
	        }
	        if (s1 !== peg$FAILED) {
	          peg$savedPos = s0;
	          s1 = peg$c52();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	          s0 = peg$currPos;
	          if (input.substr(peg$currPos, 2) === peg$c53) {
	            s1 = peg$c53;
	            peg$currPos += 2;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c54); }
	          }
	          if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c55();
	          }
	          s0 = s1;
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            if (input.substr(peg$currPos, 2) === peg$c56) {
	              s1 = peg$c56;
	              peg$currPos += 2;
	            } else {
	              s1 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c57); }
	            }
	            if (s1 !== peg$FAILED) {
	              peg$savedPos = s0;
	              s1 = peg$c58();
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$currPos;
	              if (input.substr(peg$currPos, 2) === peg$c59) {
	                s1 = peg$c59;
	                peg$currPos += 2;
	              } else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c60); }
	              }
	              if (s1 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c61();
	              }
	              s0 = s1;
	              if (s0 === peg$FAILED) {
	                s0 = peg$currPos;
	                if (input.substr(peg$currPos, 2) === peg$c62) {
	                  s1 = peg$c62;
	                  peg$currPos += 2;
	                } else {
	                  s1 = peg$FAILED;
	                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
	                }
	                if (s1 !== peg$FAILED) {
	                  s2 = peg$currPos;
	                  s3 = peg$currPos;
	                  s4 = peg$parsehexDigit();
	                  if (s4 !== peg$FAILED) {
	                    s5 = peg$parsehexDigit();
	                    if (s5 !== peg$FAILED) {
	                      s6 = peg$parsehexDigit();
	                      if (s6 !== peg$FAILED) {
	                        s7 = peg$parsehexDigit();
	                        if (s7 !== peg$FAILED) {
	                          s4 = [s4, s5, s6, s7];
	                          s3 = s4;
	                        } else {
	                          peg$currPos = s3;
	                          s3 = peg$FAILED;
	                        }
	                      } else {
	                        peg$currPos = s3;
	                        s3 = peg$FAILED;
	                      }
	                    } else {
	                      peg$currPos = s3;
	                      s3 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s3;
	                    s3 = peg$FAILED;
	                  }
	                  if (s3 !== peg$FAILED) {
	                    s2 = input.substring(s2, peg$currPos);
	                  } else {
	                    s2 = s3;
	                  }
	                  if (s2 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c64(s2);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              }
	            }
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsechars() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsechar();
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$parsechar();
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c65(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    peg$result = peg$startRuleFunction();
	
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	      return peg$result;
	    } else {
	      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	        peg$fail({ type: "end", description: "end of input" });
	      }
	
	      throw peg$buildException(
	        null,
	        peg$maxFailExpected,
	        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
	        peg$maxFailPos < input.length
	          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
	          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
	      );
	    }
	  }
	
	  return {
	    SyntaxError: peg$SyntaxError,
	    parse:       peg$parse
	  };
	})();
	
	//# sourceMappingURL=parser.js.map

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlMessageFormat = __webpack_require__(1348)['default'];
	
	// Add all locale data to `IntlMessageFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(2326);
	
	// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlMessageFormat;
	exports['default'] = exports;


/***/ }),
/* 1344 */
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports["default"] = Compiler;
	
	function Compiler(locales, formats, pluralFn) {
	    this.locales  = locales;
	    this.formats  = formats;
	    this.pluralFn = pluralFn;
	}
	
	Compiler.prototype.compile = function (ast) {
	    this.pluralStack        = [];
	    this.currentPlural      = null;
	    this.pluralNumberFormat = null;
	
	    return this.compileMessage(ast);
	};
	
	Compiler.prototype.compileMessage = function (ast) {
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new Error('Message AST is not of type: "messageFormatPattern"');
	    }
	
	    var elements = ast.elements,
	        pattern  = [];
	
	    var i, len, element;
	
	    for (i = 0, len = elements.length; i < len; i += 1) {
	        element = elements[i];
	
	        switch (element.type) {
	            case 'messageTextElement':
	                pattern.push(this.compileMessageText(element));
	                break;
	
	            case 'argumentElement':
	                pattern.push(this.compileArgument(element));
	                break;
	
	            default:
	                throw new Error('Message element does not have a valid type');
	        }
	    }
	
	    return pattern;
	};
	
	Compiler.prototype.compileMessageText = function (element) {
	    // When this `element` is part of plural sub-pattern and its value contains
	    // an unescaped '#', use a `PluralOffsetString` helper to properly output
	    // the number with the correct offset in the string.
	    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
	        // Create a cache a NumberFormat instance that can be reused for any
	        // PluralOffsetString instance in this message.
	        if (!this.pluralNumberFormat) {
	            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
	        }
	
	        return new PluralOffsetString(
	                this.currentPlural.id,
	                this.currentPlural.format.offset,
	                this.pluralNumberFormat,
	                element.value);
	    }
	
	    // Unescape the escaped '#'s in the message text.
	    return element.value.replace(/\\#/g, '#');
	};
	
	Compiler.prototype.compileArgument = function (element) {
	    var format = element.format;
	
	    if (!format) {
	        return new StringFormat(element.id);
	    }
	
	    var formats  = this.formats,
	        locales  = this.locales,
	        pluralFn = this.pluralFn,
	        options;
	
	    switch (format.type) {
	        case 'numberFormat':
	            options = formats.number[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.NumberFormat(locales, options).format
	            };
	
	        case 'dateFormat':
	            options = formats.date[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'timeFormat':
	            options = formats.time[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'pluralFormat':
	            options = this.compileOptions(element);
	            return new PluralFormat(
	                element.id, format.ordinal, format.offset, options, pluralFn
	            );
	
	        case 'selectFormat':
	            options = this.compileOptions(element);
	            return new SelectFormat(element.id, options);
	
	        default:
	            throw new Error('Message element does not have a valid format type');
	    }
	};
	
	Compiler.prototype.compileOptions = function (element) {
	    var format      = element.format,
	        options     = format.options,
	        optionsHash = {};
	
	    // Save the current plural element, if any, then set it to a new value when
	    // compiling the options sub-patterns. This conforms the spec's algorithm
	    // for handling `"#"` syntax in message text.
	    this.pluralStack.push(this.currentPlural);
	    this.currentPlural = format.type === 'pluralFormat' ? element : null;
	
	    var i, len, option;
	
	    for (i = 0, len = options.length; i < len; i += 1) {
	        option = options[i];
	
	        // Compile the sub-pattern and save it under the options's selector.
	        optionsHash[option.selector] = this.compileMessage(option.value);
	    }
	
	    // Pop the plural stack to put back the original current plural value.
	    this.currentPlural = this.pluralStack.pop();
	
	    return optionsHash;
	};
	
	// -- Compiler Helper Classes --------------------------------------------------
	
	function StringFormat(id) {
	    this.id = id;
	}
	
	StringFormat.prototype.format = function (value) {
	    if (!value && typeof value !== 'number') {
	        return '';
	    }
	
	    return typeof value === 'string' ? value : String(value);
	};
	
	function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
	    this.id         = id;
	    this.useOrdinal = useOrdinal;
	    this.offset     = offset;
	    this.options    = options;
	    this.pluralFn   = pluralFn;
	}
	
	PluralFormat.prototype.getOption = function (value) {
	    var options = this.options;
	
	    var option = options['=' + value] ||
	            options[this.pluralFn(value - this.offset, this.useOrdinal)];
	
	    return option || options.other;
	};
	
	function PluralOffsetString(id, offset, numberFormat, string) {
	    this.id           = id;
	    this.offset       = offset;
	    this.numberFormat = numberFormat;
	    this.string       = string;
	}
	
	PluralOffsetString.prototype.format = function (value) {
	    var number = this.numberFormat.format(value - this.offset);
	
	    return this.string
	            .replace(/(^|[^\\])#/g, '$1' + number)
	            .replace(/\\#/g, '#');
	};
	
	function SelectFormat(id, options) {
	    this.id      = id;
	    this.options = options;
	}
	
	SelectFormat.prototype.getOption = function (value) {
	    var options = this.options;
	    return options[value] || options.other;
	};
	
	//# sourceMappingURL=compiler.js.map

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(688), src$es5$$ = __webpack_require__(1347), src$compiler$$ = __webpack_require__(1344), intl$messageformat$parser$$ = __webpack_require__(1341);
	exports["default"] = MessageFormat;
	
	// -- MessageFormat --------------------------------------------------------
	
	function MessageFormat(message, locales, formats) {
	    // Parse string messages into an AST.
	    var ast = typeof message === 'string' ?
	            MessageFormat.__parse(message) : message;
	
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new TypeError('A message must be provided as a String or AST.');
	    }
	
	    // Creates a new object with the specified `formats` merged with the default
	    // formats.
	    formats = this._mergeFormats(MessageFormat.formats, formats);
	
	    // Defined first because it's used to build the format pattern.
	    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});
	
	    // Compile the `ast` to a pattern that is highly optimized for repeated
	    // `format()` invocations. **Note:** This passes the `locales` set provided
	    // to the constructor instead of just the resolved locale.
	    var pluralFn = this._findPluralRuleFunction(this._locale);
	    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var messageFormat = this;
	    this.format = function (values) {
	      try {
	        return messageFormat._format(pattern, values);
	      } catch (e) {
	        if (e.variableId) {
	          throw new Error(
	            'The intl string context variable \'' + e.variableId + '\'' +
	            ' was not provided to the string \'' + message + '\''
	          );
	        } else {
	          throw e;
	        }
	      }
	    };
	}
	
	// Default format options used as the prototype of the `formats` provided to the
	// constructor. These are used when constructing the internal Intl.NumberFormat
	// and Intl.DateTimeFormat instances.
	src$es5$$.defineProperty(MessageFormat, 'formats', {
	    enumerable: true,
	
	    value: {
	        number: {
	            'currency': {
	                style: 'currency'
	            },
	
	            'percent': {
	                style: 'percent'
	            }
	        },
	
	        date: {
	            'short': {
	                month: 'numeric',
	                day  : 'numeric',
	                year : '2-digit'
	            },
	
	            'medium': {
	                month: 'short',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'long': {
	                month: 'long',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'full': {
	                weekday: 'long',
	                month  : 'long',
	                day    : 'numeric',
	                year   : 'numeric'
	            }
	        },
	
	        time: {
	            'short': {
	                hour  : 'numeric',
	                minute: 'numeric'
	            },
	
	            'medium':  {
	                hour  : 'numeric',
	                minute: 'numeric',
	                second: 'numeric'
	            },
	
	            'long': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            },
	
	            'full': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            }
	        }
	    }
	});
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlMessageFormat is missing a ' +
	            '`locale` property'
	        );
	    }
	
	    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
	}});
	
	// Defines `__parse()` static method as an exposed private.
	src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});
	
	// Define public `defaultLocale` property which defaults to English, but can be
	// set by the developer.
	src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	MessageFormat.prototype.resolvedOptions = function () {
	    // TODO: Provide anything else?
	    return {
	        locale: this._locale
	    };
	};
	
	MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
	    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
	    return compiler.compile(ast);
	};
	
	MessageFormat.prototype._findPluralRuleFunction = function (locale) {
	    var localeData = MessageFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find a `pluralRuleFunction` to return.
	    while (data) {
	        if (data.pluralRuleFunction) {
	            return data.pluralRuleFunction;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlMessageFormat is missing a ' +
	        '`pluralRuleFunction` for :' + locale
	    );
	};
	
	MessageFormat.prototype._format = function (pattern, values) {
	    var result = '',
	        i, len, part, id, value, err;
	
	    for (i = 0, len = pattern.length; i < len; i += 1) {
	        part = pattern[i];
	
	        // Exist early for string parts.
	        if (typeof part === 'string') {
	            result += part;
	            continue;
	        }
	
	        id = part.id;
	
	        // Enforce that all required values are provided by the caller.
	        if (!(values && src$utils$$.hop.call(values, id))) {
	          err = new Error('A value must be provided for: ' + id);
	          err.variableId = id;
	          throw err;
	        }
	
	        value = values[id];
	
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if (part.options) {
	            result += this._format(part.getOption(value), values);
	        } else {
	            result += part.format(value);
	        }
	    }
	
	    return result;
	};
	
	MessageFormat.prototype._mergeFormats = function (defaults, formats) {
	    var mergedFormats = {},
	        type, mergedType;
	
	    for (type in defaults) {
	        if (!src$utils$$.hop.call(defaults, type)) { continue; }
	
	        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);
	
	        if (formats && src$utils$$.hop.call(formats, type)) {
	            src$utils$$.extend(mergedType, formats[type]);
	        }
	    }
	
	    return mergedFormats;
	};
	
	MessageFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(MessageFormat.defaultLocale);
	
	    var localeData = MessageFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlMessageFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	//# sourceMappingURL=core.js.map

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};
	
	//# sourceMappingURL=en.js.map

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(688);
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (src$utils$$.hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(1345), src$en$$ = __webpack_require__(1346);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};


/***/ }),
/* 1350 */
/***/ (function(module, exports) {

	module.exports = {"core.grid.no-data":"Nenalezena žádná data","Save":"Uložit","New":"Nový","Copy":"Zkopírovat","Delete":"Smazat","Search":"Hledat","search.hintText":"Začněte psát (* pro všechny možnosti)","Assets":"Majetek","Party":"Osoby","Vehicles":"Vozidla","Contact persons":"Kontaktní osoby","Customers":"Zákaznící","Customer":"Zákazník","All Parties":"Všechny osoby","Sales Representative":"Obchodní zástupci","Shipment":"Přeprava","Outgoing Shipments":"Přeprava - Expedice","Incoming Shipments":"Přeprava - Příjem","Repackagings":"Přebal","Repackaging":"Přebal","New Out Shipment":"Nová Expedice","New In Shipment":"Nový Příjem","New Repackaging":"Nový přebal","No, return back":"Ne, zůstat","Yes, continue":"Ano, pokračovat","Set Daily Status":"Nastavit aktuální stav","You have unsaved information, are you sure you want to leave this page?":"Neuložili jste vaše změny, opravdu chcete odejít bez uložení?","Field":"Pole","Old value":"Stará hodnota","New value":"Nová hodnota","UPDATED":"AKTUALIZOVÁNO","ADDED":"PŘIDÁNO","DELETED":"SMAZÁNO","Close":"Zavřít","Test":"Otestovat","Manage Grid":"Úprava sestavy","Grid Management":"Správa sestavy","Choose Grid":"Vyberte sestavu","Save grid":"Uložit sestavu","Create new grid":"Vytvořit sestavu","Copy grid":"Kopírovat sestavu","Delete grid":"Smazat sestavu","At least one column must be selected.":"Alespoň jeden sloupec musí být vybrán.","For User Grid, user must be selected.":"Pro přehled uživatele musí být vybrán nejprve uživatel.","For Tenant Grid, Tenant must be selected.":"Pro přehled společnosti musí být vybrána nejprve společnost.","For Tenant Group Grid, Tenant Group must be selected.":"Pro přehled skupin společnosti musí být vybrána nejprve skupina.","Name of grid is required.":"Název sestavy je povinný.","Grid scroll size is required positive number.":"Velikost posuvníku sestavy musí být kladné číslo.","Grid page size is required positive number.":"Velikost stránky sestavy musí být kladné číslo.","Max column width is required positive number.":"Maximální šířka sloupce musí být kladné číslo.","Ascending":"Vzestupně","Descending":"Sestupně","Edit Grid":"Editace sestavy","New Grid":"Tvorba sestavy","1. Setup grid name":"1. Nastavení názvu sestavy","Grid Name":"Název sestavy","2. Choose Grid Columns":"2. Výběr sloupců sestavy","3. Setup Filters":"3. Nastavení filtrů","Column Name":"Název sloupce","Operator":"Podmínka","Value":"Hodnota","5. Setup Grid Ordering":"5. Nastavení řazení sestavy","ASC / DESC":"VZE / SES","Lock Ordering":"Uzamknutí řazení","Add Filter":"Přidat filtr","Add Ordering":"Přidat řazení","Available Columns":"Dostupné sloupce","Grid Columns":"Sloupce sestavy","Sum":"Suma","Manage":"Spravovat","Create Grid":"Vytvořit sestavu","Update rows":"Upravit záznamy","Delete rows":"Vymazat záznamy","Cancel":"Zrušit"," rows":" řádků","Fill Value":"Vložte hodnotu","Fill Value: From":"Vložte hodnotu: Od","Fill Value: To":"Vložte hodnotu: Pro","Yes":"Ano","No":"Ne","Advance {0} repackagings":"Dokonči {0} přebalů","Advance Repackagings":"Dokonči přebaly","Shipment visits":"Návštěvy","Shipment visit":"Návštěva","New Shipment visit":"Nová návštěva","Please enter a valid mobile phone number":"Vložte prosím platné mobilní telefonní číslo","Coming":"Příchod","Leaving":"Odchod","Driver SMS text":"SMS text řidiči","Direction Incoming":"Reception / Příjem","Direction Outgoing":"Expedition + packaging / Expedice + vykládka obalů","Loading":"Nakládka","Supplier":"Dodavatel","Unloading":"Vykládka","Car":"Auto","Create new Shipment Visit":"Vytvořit novou návštěvu","Suppliers":"Dodavatelé","Invoice":"Faktury","Products":"Produkty","Reports":"Reporty","Contracts":"Kontrakty","Issued Invoices":"Vystavené Faktury","Invoice Templates":"Šablony Faktur","Prices":"Ceník","Activities":"Aktivita","Events":"Události","Tasks":"Úkoly","Administration":"Administrace","Users":"Uživatelé","Security Roles":"Zabezpečení","Jobs":"Úlohy","Entities":"Entity","Grids":"Gridy","Document Types":"Dokumenty","Event Types":"Události","Activity Config":"Aktivita","Reference Tables":"Tabulky Odkazů","Certificates":"Certifikáty","New Customer":"Přidat Zákazníka","Issue Invoices":"Vystav Faktury","New Invoice":"Nová Faktura","New Template":"Nová Šablona","Generate Invoice":"Vytvoř Fakturu","Generate Invoices":"Vytvoř Faktury","New Contact":"Nová Kontakt Osoba","New Contract":"Nový Kontrakt","New Vehicle":"Nové Vozidlo","New Product":"Nový Produkt","New Price":"Přidat Cenu","Unloading place":"Místo vykládky","Do you really want to delete this item?":"Opravdu chcete tuto položku smazat?","Send SMS to driver":"Odeslat SMS řidiči","Update visit":"Uložit změny","Create prepared visit":"Připravit návštevu","Back to visits":"Seznam návštěv","Merge Visit":"Sloučit návštěvy","Find shipments":"Najít zásilky","Add shipments manually":"Přidat ručně","Update Registration number":"Sjednotit SPZ","Synchronize data on linked shipments":"Synchronizace dat","shipment.packagingSender":"Odesílatel","chart.rowExceed":"Záznamů musí být 500 a méně","chart.selectTop":"Potvrdit výběr","chart.goTo":"Přejít na graf","chart.fetchingIds":"Dokončujeme výběr...","chart.save":"Uložit graf","chart.selectAll":"Vybrat všechny","chart.showOthers":"Zobrazit ostatní","chart.sureAnotherGraphSelect":"Neuložili jste vaše změny, opravdu chcete přejít na jiný graf bez uložení?","chart.config.gridColumns":"Sloupce gridu","chart.config.inactiveGridColumns":"Ostatní","chart.config.chartType":"Typ grafu","chart.config.xAxis":"Osa X","chart.config.noXFieldSelected":"Žádná data","chart.pleaseFilter500":"Vyfiltrujte prosím data, aby grid obsahoval maximálně 500 řádků","chart.config.searchColumns":"Hledat ve sloupcích","chart.config.new":"nový","chart.config.save":"uložit","chart.config.delete":"smazat","chart.label.bar":"Barový graf","chart.label.line":"Liniový graf","chart.label.area":"Graf s oblastí","invoice.billed-to":"Odběratel","number.gen.group.new":"Nová skupina","Criteria menu":"Kritéria","Criteria":"Kritéria","Sub-criteria":"Dílčí kritéria","Criterion":"Kritérium","Sub-criterion":"Dílčí kritérium","Projects":"Projekty","Project":"Projekt","Total score":"Celkové skóre","Materials menu":"TM01 Enviromentální vlastnosti materiálů","Materials":"TM01_Materiály","Lifespan menu":"TM02_Životnosti konstrukcí","Lifespan":"Životnosti","Energy carriers menu":"TM03 Energonositele","Energy carriers":"TM03_Energonositelé","Energy carrier":"Energonositel","Custom material":"Vlastní materiál","Wood based material":"Výrobek na bázi dřeva","New material":"Nový materiál","New energy carrier":"Nový energonositel","Parameter is empty":"Parametr je prázdný","Parameter should be number":"Parametr by měl být číslo","Parameter should be 100 or less":"Parametr by měl být 100 nebo méně","Set default":"Jako výchozí","Cellar Compartment Checkbox Title":"Minimální sklepní kóje","Garage Checkbox Title":"Minimální individuální garáž","ZPKM Checkbox Title":"ZPKM","Room types":"Typy prostorů","Room types menu":"TP03 Místnosti","New room":"Nová místnost","Rooms":"TP03_Mistnosti","Usage groups menu":"TP02 Konstrukce a výrobky","Usage groups":"Konstrukce","Area":"TP04_Plochy","Area menu":"TP04 Plochy","New area":"Nová plocha","Doors":"TP06_Dveře","Frame material":"Materiál zárubně","Leaf materials":"Materiály křídla","New door":"Nové dveře","LOPs":"TP07_LOP","New LOP":"Nový LOP","LOP frame material":"Materiály rámu","LOP glazing material":"Materiál zasklení","Windows":"TP05_Okna","New Window":"nové okno","Trees":"TP10_Stromy","New tree":"Nový strom","Lop Fillings":"TP07_LOP_výplně","Lop Profiles":"TP08_LOP_profily","Parking":"TP09_Parkování","New Parking":"Nové Parkováni","TP Materials":"TP02_Materiály","TM Runoff coefficients":"TM_04 Odtokové součinitele","TP Capacity":"TP_01 Kapacity","Save Criterion":"uložit hodnoty kritérií","Save Version":"Uložit Verze","Copy Version":"Zkopírovat Verze","Delete Version":"Smazat Verze","New Project":"nový projekt","New project version":"Nová verze projektu","Methodological Tables":"metodické tabulky","Project Data":"Projektová data","Image Size Error":"Velikost souboru je příliš velká. Maximální velikost 1Mb(.jpeg, .jpg)","Current time":"Aktuální čas"}

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

	module.exports = {"Save":"Speichern","chart.rowExceed":"Records count must be 500 and less","chart.selectTop":"Select top","chart.fetchingIds":"Selection finish...","search.hintText":"Tippen zum Suchen (* für alle)","shipment.packagingSender":"Sender","Supplier":"Anbieter"}

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

	module.exports = {"core.grid.no-data":"No data found","en":"English","cs":"Czech","de":"German","hu":"Hungarian","pl":"Polish","ro":"Romanian","sk":"Slovak","uk":"Ukrainian","chart.rowExceed":"Records count must be 500 and less","chart.selectTop":"Select top","chart.goTo":"Go to chart","chart.fetchingIds":"Selection finish...","chart.save":"Save graph","chart.selectAll":"Select all","chart.showOthers":"Show inactive","chart.sureAnotherGraphSelect":"Changes are not saved, do you wish to continue to another chart?","chart.config.gridColumns":"Grid Columns","chart.config.inactiveGridColumns":"Others","chart.config.chartType":"Chart type","chart.config.xAxis":"X Axis","chart.config.noXFieldSelected":"No data","chart.pleaseFilter500":"Please filter data, so grid has 500 or less records","chart.config.searchColumns":"Search in columns","chart.config.new":"new","chart.config.save":"save","chart.config.delete":"delete","chart.label.bar":"Bar chart","chart.label.line":"Line chart","chart.label.area":"Area chart","invoice.billed-to":"Billed to","number.gen.group.new":"New group","Criteria menu":"Criterions","Criteria":"Criterions","Materials menu":"TM01 Material environmental properties","Materials":"Materials","Lifespan menu":"TM02 Lifespan","Lifespan":"Lifespan","Energy carriers menu":"T0M3 Energy carriers","Energy carriers":"Energy carriers","Custom material":"Custom material","Wood based material":"Wood based material","Cellar Compartment Checkbox Title":"Minimal cellar compartment","Garage Checkbox Title":"Minimal individual garage","ZPKM Checkbox Title":"ZPKM","Room types":"Room types","Room types menu":"TP03 Rooms","New room":"New room","Rooms":"Rooms","Usage groups menu":"TP02 Constructions and products","Usage groups":"Constructions","Area":"Areas","Area menu":"TP04 Areas","New area":"New area","Doors":"Doors","Frame material":"Frame material","Leaf materials":"Leaf materials","New door":"New door","LOPs":"LOPs","New LOP":"New LOP","LOP frame material":"Frame materials","LOP glazing material":"Glazing material","Windows":"Windows","Trees":"Trees","New tree":"New tree","Image Size Error":"File size is to big. Max. size 1Mb(.jpeg, .jpg)","search.hintText":"Type to search (* for all)","shipment.packagingSender":"Sender"}

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

	module.exports = {"Save":"a Mentés","chart.rowExceed":"Records count must be 500 and less","chart.selectTop":"Select top","chart.fetchingIds":"Selection finish...","Linked Credit Note/Proforma/Down payment":"Linked Credit Note/Proforma/Request to pay","Link Proforma / Down payment Invoice":"Link Proforma Invoice / Request to pay","Link Proforma/Down payment":"Link Proforma/Request to pay","Issue Down payment":"Issue Request to pay","search.hintText":"Írjon a kereséshez (* az összeshez)","shipment.packagingSender":"Feladó","Supplier":"Beszállító"}

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

	module.exports = {"Save":"Zapisz","chart.rowExceed":"Records count must be 500 and less","chart.selectTop":"Select top","chart.fetchingIds":"Selection finish...","search.hintText":"Wpisz, aby wyszukać (* dla wszystkich)","shipment.packagingSender":"Nadawca","Supplier":"Dostawca"}

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

	module.exports = {"Save":"Salvați","chart.rowExceed":"Records count must be 500 and less","chart.selectTop":"Select top","chart.fetchingIds":"Selection finish...","search.hintText":"Tastează pentru a căuta (* pentru toate)","shipment.packagingSender":"Expeditor","Supplier":"Furnizor"}

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

	module.exports = {"Save":"Uložiť","chart.rowExceed":"Records count must be 500 and less","chart.selectTop":"Select top","chart.fetchingIds":"Selection finish...","search.hintText":"Píšte pre hľadanie (* pre všetko)","shipment.packagingSender":"Odosielateľ","Supplier":"Dodávateľ"}

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

	module.exports = {"Save":"Зберегти","chart.rowExceed":"Records count must be 500 and less","chart.selectTop":"Select top","chart.fetchingIds":"Selection finish...","search.hintText":"Введіть для пошуку (* для всіх)","shipment.packagingSender":"Відправник","Supplier":"Постачальник"}

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

	/* This program is free software. It comes without any warranty, to
	     * the extent permitted by applicable law. You can redistribute it
	     * and/or modify it under the terms of the Do What The Fuck You Want
	     * To Public License, Version 2, as published by Sam Hocevar. See
	     * http://www.wtfpl.net/ for more details. */
	'use strict';
	module.exports = leftPad;
	
	var cache = [
	  '',
	  ' ',
	  '  ',
	  '   ',
	  '    ',
	  '     ',
	  '      ',
	  '       ',
	  '        ',
	  '         '
	];
	
	function leftPad (str, len, ch) {
	  // convert `str` to a `string`
	  str = str + '';
	  // `len` is the `pad`'s length now
	  len = len - str.length;
	  // doesn't need to pad
	  if (len <= 0) return str;
	  // `ch` defaults to `' '`
	  if (!ch && ch !== 0) ch = ' ';
	  // convert `ch` to a `string` cuz it could be a number
	  ch = ch + '';
	  // cache common use cases
	  if (ch === ' ' && len < 10) return cache[len] + str;
	  // `pad` starts with an empty string
	  var pad = '';
	  // loop
	  while (true) {
	    // add `ch` to `pad` if `len` is odd
	    if (len & 1) pad += ch;
	    // divide `len` by 2, ditch the remainder
	    len >>= 1;
	    // "double" the `ch` so this operation count grows logarithmically on `len`
	    // each time `ch` is "doubled", the `len` would need to be "doubled" too
	    // similar to finding a value in binary search tree, hence O(log(n))
	    if (len) ch += ch;
	    // `len` is 0, exit the loop
	    else break;
	  }
	  // pad `str`!
	  return pad + str;
	}


/***/ }),
/* 1359 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeMax = Math.max,
	    nativeNow = Date.now;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = merge;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(177)(module)))

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(206),
	    root = __webpack_require__(124);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1428),
	    hashDelete = __webpack_require__(1429),
	    hashGet = __webpack_require__(1430),
	    hashHas = __webpack_require__(1431),
	    hashSet = __webpack_require__(1432);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(206),
	    root = __webpack_require__(124);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(206),
	    root = __webpack_require__(124);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 1365 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 1366 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 1367 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(279),
	    keys = __webpack_require__(209);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(279),
	    keysIn = __webpack_require__(483);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(100);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(342);
	
	/**
	 * The base implementation of `_.every` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}
	
	module.exports = baseEvery;


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(342);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1415);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 1374 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 1375 */
/***/ (function(module, exports) {

	/**
	 * This function is like `baseIndexOf` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOfWith(array, value, fromIndex, comparator) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (comparator(array[index], value)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOfWith;


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(340),
	    arrayIncludes = __webpack_require__(468),
	    arrayIncludesWith = __webpack_require__(469),
	    arrayMap = __webpack_require__(162),
	    baseUnary = __webpack_require__(184),
	    cacheHas = __webpack_require__(345);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(151),
	    isObjectLike = __webpack_require__(116);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(151),
	    isObjectLike = __webpack_require__(116);
	
	/** `Object#toString` result references. */
	var dateTag = '[object Date]';
	
	/**
	 * The base implementation of `_.isDate` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	 */
	function baseIsDate(value) {
	  return isObjectLike(value) && baseGetTag(value) == dateTag;
	}
	
	module.exports = baseIsDate;


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(466),
	    equalArrays = __webpack_require__(710),
	    equalByTag = __webpack_require__(1421),
	    equalObjects = __webpack_require__(1422),
	    getTag = __webpack_require__(280),
	    isArray = __webpack_require__(62),
	    isBuffer = __webpack_require__(354),
	    isTypedArray = __webpack_require__(482);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(280),
	    isObjectLike = __webpack_require__(116);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(466),
	    baseIsEqual = __webpack_require__(473);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 1382 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(55),
	    isMasked = __webpack_require__(1438),
	    isObject = __webpack_require__(100),
	    toSource = __webpack_require__(720);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(280),
	    isObjectLike = __webpack_require__(116);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(151),
	    isLength = __webpack_require__(481),
	    isObjectLike = __webpack_require__(116);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(100),
	    isPrototype = __webpack_require__(349),
	    nativeKeysIn = __webpack_require__(1452);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1381),
	    getMatchData = __webpack_require__(1424),
	    matchesStrictComparable = __webpack_require__(716);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(473),
	    get = __webpack_require__(207),
	    hasIn = __webpack_require__(1472),
	    isKey = __webpack_require__(477),
	    isStrictComparable = __webpack_require__(715),
	    matchesStrictComparable = __webpack_require__(716),
	    toKey = __webpack_require__(282);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(162),
	    baseIteratee = __webpack_require__(114),
	    baseMap = __webpack_require__(705),
	    baseSortBy = __webpack_require__(1398),
	    baseUnary = __webpack_require__(184),
	    compareMultiple = __webpack_require__(1410),
	    identity = __webpack_require__(208);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ }),
/* 1390 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(472);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(162),
	    baseIndexOf = __webpack_require__(702),
	    baseIndexOfWith = __webpack_require__(1375),
	    baseUnary = __webpack_require__(184),
	    copyArray = __webpack_require__(708);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * The base implementation of `_.pullAllBy` without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to remove.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns `array`.
	 */
	function basePullAll(array, values, iteratee, comparator) {
	  var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	      index = -1,
	      length = values.length,
	      seen = array;
	
	  if (array === values) {
	    values = copyArray(values);
	  }
	  if (iteratee) {
	    seen = arrayMap(array, baseUnary(iteratee));
	  }
	  while (++index < length) {
	    var fromIndex = 0,
	        value = values[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	      if (seen !== array) {
	        splice.call(seen, fromIndex, 1);
	      }
	      splice.call(array, fromIndex, 1);
	    }
	  }
	  return array;
	}
	
	module.exports = basePullAll;


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	var baseUnset = __webpack_require__(707),
	    isIndex = __webpack_require__(348);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * The base implementation of `_.pullAt` without support for individual
	 * indexes or capturing the removed elements.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {number[]} indexes The indexes of elements to remove.
	 * @returns {Array} Returns `array`.
	 */
	function basePullAt(array, indexes) {
	  var length = array ? indexes.length : 0,
	      lastIndex = length - 1;
	
	  while (length--) {
	    var index = indexes[length];
	    if (length == lastIndex || index !== previous) {
	      var previous = index;
	      if (isIndex(index)) {
	        splice.call(array, index, 1);
	      } else {
	        baseUnset(array, index);
	      }
	    }
	  }
	  return array;
	}
	
	module.exports = basePullAt;


/***/ }),
/* 1394 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	module.exports = baseRange;


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1466),
	    defineProperty = __webpack_require__(709),
	    identity = __webpack_require__(208);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 1396 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(342);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ }),
/* 1398 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ }),
/* 1399 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(238),
	    arrayMap = __webpack_require__(162),
	    isArray = __webpack_require__(62),
	    isSymbol = __webpack_require__(240);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(162);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(697),
	    baseFlatten = __webpack_require__(278),
	    baseUniq = __webpack_require__(344);
	
	/**
	 * The base implementation of methods like `_.xor`, without support for
	 * iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of values.
	 */
	function baseXor(arrays, iteratee, comparator) {
	  var length = arrays.length;
	  if (length < 2) {
	    return length ? baseUniq(arrays[0]) : [];
	  }
	  var index = -1,
	      result = Array(length);
	
	  while (++index < length) {
	    var array = arrays[index],
	        othIndex = -1;
	
	    while (++othIndex < length) {
	      if (othIndex != index) {
	        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	      }
	    }
	  }
	  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	}
	
	module.exports = baseXor;


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(353);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(124);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(177)(module)))

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(474);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 1406 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(238);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(474);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(240);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(1409);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(279),
	    getSymbols = __webpack_require__(476);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(279),
	    getSymbolsIn = __webpack_require__(714);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(124);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(185);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 1415 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(114),
	    isArrayLike = __webpack_require__(185),
	    keys = __webpack_require__(209);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRange = __webpack_require__(1394),
	    isIterateeCall = __webpack_require__(281),
	    toFinite = __webpack_require__(735);
	
	/**
	 * Creates a `_.range` or `_.rangeRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new range function.
	 */
	function createRange(fromRight) {
	  return function(start, end, step) {
	    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	      end = step = undefined;
	    }
	    // Ensure the sign of `-0` is preserved.
	    start = toFinite(start);
	    if (end === undefined) {
	      end = start;
	      start = 0;
	    } else {
	      end = toFinite(end);
	    }
	    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	    return baseRange(start, end, step, fromRight);
	  };
	}
	
	module.exports = createRange;


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(124),
	    toInteger = __webpack_require__(736),
	    toNumber = __webpack_require__(487),
	    toString = __webpack_require__(737);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsFinite = root.isFinite,
	    nativeMin = Math.min;
	
	/**
	 * Creates a function like `_.round`.
	 *
	 * @private
	 * @param {string} methodName The name of the `Math` method to use when rounding.
	 * @returns {Function} Returns the new round function.
	 */
	function createRound(methodName) {
	  var func = Math[methodName];
	  return function(number, precision) {
	    number = toNumber(number);
	    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	    if (precision && nativeIsFinite(number)) {
	      // Shift with exponential notation to avoid floating-point issues.
	      // See [MDN](https://mdn.io/round#Examples) for more details.
	      var pair = (toString(number) + 'e').split('e'),
	          value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	      pair = (toString(value) + 'e').split('e');
	      return +(pair[0] + 'e' + (+pair[1] - precision));
	    }
	    return func(number);
	  };
	}
	
	module.exports = createRound;


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(691),
	    noop = __webpack_require__(729),
	    setToArray = __webpack_require__(478);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(137);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(238),
	    Uint8Array = __webpack_require__(692),
	    eq = __webpack_require__(283),
	    equalArrays = __webpack_require__(710),
	    mapToArray = __webpack_require__(1449),
	    setToArray = __webpack_require__(478);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(712);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(480),
	    overRest = __webpack_require__(718),
	    setToString = __webpack_require__(719);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(715),
	    keys = __webpack_require__(209);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(238);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 1426 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(346),
	    isArguments = __webpack_require__(352),
	    isArray = __webpack_require__(62),
	    isIndex = __webpack_require__(348),
	    isLength = __webpack_require__(481),
	    toKey = __webpack_require__(282);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(350);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 1429 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(350);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(350);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(350);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 1433 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(474),
	    cloneDataView = __webpack_require__(1405),
	    cloneRegExp = __webpack_require__(1406),
	    cloneSymbol = __webpack_require__(1407),
	    cloneTypedArray = __webpack_require__(1408);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(1370),
	    getPrototype = __webpack_require__(475),
	    isPrototype = __webpack_require__(349);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(238),
	    isArguments = __webpack_require__(352),
	    isArray = __webpack_require__(62);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 1437 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1413);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 1439 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(341);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(341);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(341);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(341);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1362),
	    ListCache = __webpack_require__(339),
	    Map = __webpack_require__(464);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(347);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(347);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(347);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(347);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 1449 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(726);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(717);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 1452 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 1453 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(472),
	    baseSlice = __webpack_require__(1396);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ }),
/* 1455 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 1456 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 1457 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(339);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 1459 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 1460 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 1461 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(339),
	    Map = __webpack_require__(464),
	    MapCache = __webpack_require__(465);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 1463 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1450);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(696);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.cloneWith` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.cloneWith
	 * @example
	 *
	 * function customizer(value) {
	 *   if (_.isElement(value)) {
	 *     return value.cloneNode(true);
	 *   }
	 * }
	 *
	 * var el = _.cloneDeepWith(document.body, customizer);
	 *
	 * console.log(el === document.body);
	 * // => false
	 * console.log(el.nodeName);
	 * // => 'BODY'
	 * console.log(el.childNodes.length);
	 * // => 20
	 */
	function cloneDeepWith(value, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	}
	
	module.exports = cloneDeepWith;


/***/ }),
/* 1466 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(205),
	    eq = __webpack_require__(283),
	    isIterateeCall = __webpack_require__(281),
	    keysIn = __webpack_require__(483);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own and inherited enumerable string keyed properties of source
	 * objects to the destination object for all destination properties that
	 * resolve to `undefined`. Source objects are applied from left to right.
	 * Once a property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaultsDeep
	 * @example
	 *
	 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var defaults = baseRest(function(object, sources) {
	  object = Object(object);
	
	  var index = -1;
	  var length = sources.length;
	  var guard = length > 2 ? sources[2] : undefined;
	
	  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	    length = 1;
	  }
	
	  while (++index < length) {
	    var source = sources[index];
	    var props = keysIn(source);
	    var propsIndex = -1;
	    var propsLength = props.length;
	
	    while (++propsIndex < propsLength) {
	      var key = props[propsIndex];
	      var value = object[key];
	
	      if (value === undefined ||
	          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        object[key] = source[key];
	      }
	    }
	  }
	
	  return object;
	});
	
	module.exports = defaults;


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(467),
	    baseFilter = __webpack_require__(1372),
	    baseIteratee = __webpack_require__(114),
	    isArray = __webpack_require__(62);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(1416),
	    findIndex = __webpack_require__(722);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1473);


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(278),
	    map = __webpack_require__(1478);
	
	/**
	 * Creates a flattened array of values by running each element in `collection`
	 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	 * with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * function duplicate(n) {
	 *   return [n, n];
	 * }
	 *
	 * _.flatMap([1, 2], duplicate);
	 * // => [1, 1, 2, 2]
	 */
	function flatMap(collection, iteratee) {
	  return baseFlatten(map(collection, iteratee), 1);
	}
	
	module.exports = flatMap;


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1374),
	    hasPath = __webpack_require__(1427);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 1473 */
/***/ (function(module, exports) {

	/**
	 * Gets the first element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias first
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the first element of `array`.
	 * @example
	 *
	 * _.head([1, 2, 3]);
	 * // => 1
	 *
	 * _.head([]);
	 * // => undefined
	 */
	function head(array) {
	  return (array && array.length) ? array[0] : undefined;
	}
	
	module.exports = head;


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(151),
	    isObjectLike = __webpack_require__(116);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]';
	
	/**
	 * Checks if `value` is classified as a boolean primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	 * @example
	 *
	 * _.isBoolean(false);
	 * // => true
	 *
	 * _.isBoolean(null);
	 * // => false
	 */
	function isBoolean(value) {
	  return value === true || value === false ||
	    (isObjectLike(value) && baseGetTag(value) == boolTag);
	}
	
	module.exports = isBoolean;


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsDate = __webpack_require__(1378),
	    baseUnary = __webpack_require__(184),
	    nodeUtil = __webpack_require__(351);
	
	/* Node.js helper references. */
	var nodeIsDate = nodeUtil && nodeUtil.isDate;
	
	/**
	 * Checks if `value` is classified as a `Date` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	 * @example
	 *
	 * _.isDate(new Date);
	 * // => true
	 *
	 * _.isDate('Mon April 23 2012');
	 * // => false
	 */
	var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	module.exports = isDate;


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(1380),
	    baseUnary = __webpack_require__(184),
	    nodeUtil = __webpack_require__(351);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(1384),
	    baseUnary = __webpack_require__(184),
	    nodeUtil = __webpack_require__(351);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(162),
	    baseIteratee = __webpack_require__(114),
	    baseMap = __webpack_require__(705),
	    isArray = __webpack_require__(62);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(471),
	    baseForOwn = __webpack_require__(699),
	    baseIteratee = __webpack_require__(114);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(124);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1390),
	    basePropertyDeep = __webpack_require__(1391),
	    isKey = __webpack_require__(477),
	    toKey = __webpack_require__(282);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(694),
	    baseIteratee = __webpack_require__(114),
	    baseSome = __webpack_require__(1397),
	    isArray = __webpack_require__(62),
	    isIterateeCall = __webpack_require__(281);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ }),
/* 1483 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSum = __webpack_require__(706),
	    identity = __webpack_require__(208);
	
	/**
	 * Computes the sum of the values in `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.4.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * _.sum([4, 2, 8, 6]);
	 * // => 20
	 */
	function sum(array) {
	  return (array && array.length)
	    ? baseSum(array, identity)
	    : 0;
	}
	
	module.exports = sum;


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(114),
	    baseSum = __webpack_require__(706);
	
	/**
	 * This method is like `_.sum` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the value to be summed.
	 * The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	 *
	 * _.sumBy(objects, function(o) { return o.n; });
	 * // => 20
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.sumBy(objects, 'n');
	 * // => 20
	 */
	function sumBy(array, iteratee) {
	  return (array && array.length)
	    ? baseSum(array, baseIteratee(iteratee, 2))
	    : 0;
	}
	
	module.exports = sumBy;


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(278),
	    baseRest = __webpack_require__(205),
	    baseUniq = __webpack_require__(344),
	    isArrayLikeObject = __webpack_require__(353);
	
	/**
	 * Creates an array of unique values, in order, from all given arrays using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([2], [1, 2]);
	 * // => [2, 1]
	 */
	var union = baseRest(function(arrays) {
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	});
	
	module.exports = union;


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	var baseUniq = __webpack_require__(344);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurrence of each element
	 * is kept. The order of result values is determined by the order they occur
	 * in the array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 */
	function uniq(array) {
	  return (array && array.length) ? baseUniq(array) : [];
	}
	
	module.exports = uniq;


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(1401),
	    keys = __webpack_require__(209);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(467),
	    baseRest = __webpack_require__(205),
	    baseXor = __webpack_require__(1402),
	    isArrayLikeObject = __webpack_require__(353);
	
	/**
	 * Creates an array of unique values that is the
	 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	 * of the given arrays. The order of result values is determined by the order
	 * they occur in the arrays.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.without
	 * @example
	 *
	 * _.xor([2, 1], [2, 3]);
	 * // => [1, 3]
	 */
	var xor = baseRest(function(arrays) {
	  return baseXor(arrayFilter(arrays, isArrayLikeObject));
	});
	
	module.exports = xor;


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(590);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.getStyles = getStyles;
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _IconButton = __webpack_require__(126);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _menu = __webpack_require__(1610);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _Paper = __webpack_require__(106);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _propTypes3 = __webpack_require__(118);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      appBar = _context$muiTheme.appBar,
	      iconButtonSize = _context$muiTheme.button.iconButtonSize,
	      zIndex = _context$muiTheme.zIndex;
	
	
	  var flatButtonSize = 36;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      zIndex: zIndex.appBar,
	      width: '100%',
	      display: 'flex',
	      backgroundColor: appBar.color,
	      paddingLeft: appBar.padding,
	      paddingRight: appBar.padding
	    },
	    title: {
	      whiteSpace: 'nowrap',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      margin: 0,
	      paddingTop: 0,
	      letterSpacing: 0,
	      fontSize: 24,
	      fontWeight: appBar.titleFontWeight,
	      color: appBar.textColor,
	      height: appBar.height,
	      lineHeight: appBar.height + 'px'
	    },
	    mainElement: {
	      boxFlex: 1,
	      flex: '1'
	    },
	    iconButtonStyle: {
	      marginTop: (appBar.height - iconButtonSize) / 2,
	      marginRight: 8,
	      marginLeft: -16
	    },
	    iconButtonIconStyle: {
	      fill: appBar.textColor,
	      color: appBar.textColor
	    },
	    flatButton: {
	      color: appBar.textColor,
	      marginTop: (iconButtonSize - flatButtonSize) / 2 + 1
	    }
	  };
	
	  return styles;
	}
	
	var AppBar = function (_Component) {
	  (0, _inherits3.default)(AppBar, _Component);
	
	  function AppBar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AppBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AppBar.__proto__ || (0, _getPrototypeOf2.default)(AppBar)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapLeftIconButton = function (event) {
	      if (_this.props.onLeftIconButtonTouchTap) {
	        _this.props.onLeftIconButtonTouchTap(event);
	      }
	    }, _this.handleTouchTapRightIconButton = function (event) {
	      if (_this.props.onRightIconButtonTouchTap) {
	        _this.props.onRightIconButtonTouchTap(event);
	      }
	    }, _this.handleTitleTouchTap = function (event) {
	      if (_this.props.onTitleTouchTap) {
	        _this.props.onTitleTouchTap(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AppBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	       false ? (0, _warning2.default)(!this.props.iconElementLeft || !this.props.iconClassNameLeft, 'Material-UI: Properties iconElementLeft\n      and iconClassNameLeft cannot be simultaneously defined. Please use one or the other.') : void 0;
	
	       false ? (0, _warning2.default)(!this.props.iconElementRight || !this.props.iconClassNameRight, 'Material-UI: Properties iconElementRight\n      and iconClassNameRight cannot be simultaneously defined. Please use one or the other.') : void 0;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          titleStyle = _props.titleStyle,
	          iconStyleLeft = _props.iconStyleLeft,
	          iconStyleRight = _props.iconStyleRight,
	          onTitleTouchTap = _props.onTitleTouchTap,
	          showMenuIconButton = _props.showMenuIconButton,
	          iconElementLeft = _props.iconElementLeft,
	          iconElementRight = _props.iconElementRight,
	          iconClassNameLeft = _props.iconClassNameLeft,
	          iconClassNameRight = _props.iconClassNameRight,
	          onLeftIconButtonTouchTap = _props.onLeftIconButtonTouchTap,
	          onRightIconButtonTouchTap = _props.onRightIconButtonTouchTap,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth,
	          children = _props.children,
	          other = (0, _objectWithoutProperties3.default)(_props, ['title', 'titleStyle', 'iconStyleLeft', 'iconStyleRight', 'onTitleTouchTap', 'showMenuIconButton', 'iconElementLeft', 'iconElementRight', 'iconClassNameLeft', 'iconClassNameRight', 'onLeftIconButtonTouchTap', 'onRightIconButtonTouchTap', 'className', 'style', 'zDepth', 'children']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var menuElementLeft = void 0;
	      var menuElementRight = void 0;
	
	      // If the title is a string, wrap in an h1 tag.
	      // If not, wrap in a div tag.
	      var titleComponent = typeof title === 'string' || title instanceof String ? 'h1' : 'div';
	
	      var titleElement = _react2.default.createElement(titleComponent, {
	        onClick: this.handleTitleTouchTap,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.title, styles.mainElement, titleStyle))
	      }, title);
	
	      var iconLeftStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, iconStyleLeft);
	
	      if (showMenuIconButton) {
	        if (iconElementLeft) {
	          var iconElementLeftProps = {};
	
	          if (iconElementLeft.type.muiName === 'IconButton') {
	            var iconElemLeftChildren = iconElementLeft.props.children;
	            var iconButtonIconStyle = !(iconElemLeftChildren && iconElemLeftChildren.props && iconElemLeftChildren.props.color) ? styles.iconButtonIconStyle : null;
	
	            iconElementLeftProps.iconStyle = (0, _simpleAssign2.default)({}, iconButtonIconStyle, iconElementLeft.props.iconStyle);
	          }
	
	          if (!iconElementLeft.props.onClick && this.props.onLeftIconButtonTouchTap) {
	            iconElementLeftProps.onClick = this.handleTouchTapLeftIconButton;
	          }
	
	          menuElementLeft = _react2.default.createElement(
	            'div',
	            { style: prepareStyles(iconLeftStyle) },
	            (0, _keys2.default)(iconElementLeftProps).length > 0 ? (0, _react.cloneElement)(iconElementLeft, iconElementLeftProps) : iconElementLeft
	          );
	        } else {
	          menuElementLeft = _react2.default.createElement(
	            _IconButton2.default,
	            {
	              style: iconLeftStyle,
	              iconStyle: styles.iconButtonIconStyle,
	              iconClassName: iconClassNameLeft,
	              onClick: this.handleTouchTapLeftIconButton
	            },
	            iconClassNameLeft ? '' : _react2.default.createElement(_menu2.default, { style: (0, _simpleAssign2.default)({}, styles.iconButtonIconStyle) })
	          );
	        }
	      }
	
	      var iconRightStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, {
	        marginRight: -16,
	        marginLeft: 'auto'
	      }, iconStyleRight);
	
	      if (iconElementRight) {
	        var iconElementRightProps = {};
	
	        switch (iconElementRight.type.muiName) {
	          case 'IconMenu':
	          case 'IconButton':
	            var iconElemRightChildren = iconElementRight.props.children;
	            var _iconButtonIconStyle = !(iconElemRightChildren && iconElemRightChildren.props && iconElemRightChildren.props.color) ? styles.iconButtonIconStyle : null;
	
	            iconElementRightProps.iconStyle = (0, _simpleAssign2.default)({}, _iconButtonIconStyle, iconElementRight.props.iconStyle);
	            break;
	
	          case 'FlatButton':
	            iconElementRightProps.style = (0, _simpleAssign2.default)({}, styles.flatButton, iconElementRight.props.style);
	            break;
	
	          default:
	        }
	
	        if (!iconElementRight.props.onClick && this.props.onRightIconButtonTouchTap) {
	          iconElementRightProps.onClick = this.handleTouchTapRightIconButton;
	        }
	
	        menuElementRight = _react2.default.createElement(
	          'div',
	          { style: prepareStyles(iconRightStyle) },
	          (0, _keys2.default)(iconElementRightProps).length > 0 ? (0, _react.cloneElement)(iconElementRight, iconElementRightProps) : iconElementRight
	        );
	      } else if (iconClassNameRight) {
	        menuElementRight = _react2.default.createElement(_IconButton2.default, {
	          style: iconRightStyle,
	          iconStyle: styles.iconButtonIconStyle,
	          iconClassName: iconClassNameRight,
	          onClick: this.handleTouchTapRightIconButton
	        });
	      }
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({}, other, {
	          rounded: false,
	          className: className,
	          style: (0, _simpleAssign2.default)({}, styles.root, style),
	          zDepth: zDepth
	        }),
	        menuElementLeft,
	        titleElement,
	        menuElementRight,
	        children
	      );
	    }
	  }]);
	  return AppBar;
	}(_react.Component);
	
	AppBar.muiName = 'AppBar';
	AppBar.defaultProps = {
	  showMenuIconButton: true,
	  title: '',
	  zDepth: 1
	};
	AppBar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	AppBar.propTypes =  false ? {
	  /**
	   * Can be used to render a tab inside an app bar for instance.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Applied to the app bar's root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The classname of the icon on the left of the app bar.
	   * If you are using a stylesheet for your icons, enter the class name for the icon to be used here.
	   */
	  iconClassNameLeft: _propTypes2.default.string,
	  /**
	   * Similiar to the iconClassNameLeft prop except that
	   * it applies to the icon displayed on the right of the app bar.
	   */
	  iconClassNameRight: _propTypes2.default.string,
	  /**
	   * The custom element to be displayed on the left side of the
	   * app bar such as an SvgIcon.
	   */
	  iconElementLeft: _propTypes2.default.element,
	  /**
	   * Similiar to the iconElementLeft prop except that this element is displayed on the right of the app bar.
	   */
	  iconElementRight: _propTypes2.default.element,
	  /**
	   * Override the inline-styles of the element displayed on the left side of the app bar.
	   */
	  iconStyleLeft: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the element displayed on the right side of the app bar.
	   */
	  iconStyleRight: _propTypes2.default.object,
	  /**
	   * Callback function for when the left icon is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the left `IconButton`.
	   */
	  onLeftIconButtonTouchTap: _propTypes2.default.func,
	  /**
	   * Callback function for when the right icon is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the right `IconButton`.
	   */
	  onRightIconButtonTouchTap: _propTypes2.default.func,
	  /**
	   * Callback function for when the title text is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the `title` node.
	   */
	  onTitleTouchTap: _propTypes2.default.func,
	  /**
	   * Determines whether or not to display the Menu icon next to the title.
	   * Setting this prop to false will hide the icon.
	   */
	  showMenuIconButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The title to display on the app bar.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the app bar's title element.
	   */
	  titleStyle: _propTypes2.default.object,
	  /**
	   * The zDepth of the component.
	   * The shadow of the app bar is also dependent on this property.
	   */
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = AppBar;

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _AppBar = __webpack_require__(1490);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AppBar2.default;

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(224);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _keycode = __webpack_require__(99);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _TextField = __webpack_require__(186);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Menu = __webpack_require__(750);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(101);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _Divider = __webpack_require__(241);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Popover = __webpack_require__(242);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _propTypes3 = __webpack_require__(118);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var anchorEl = state.anchorEl;
	  var fullWidth = props.fullWidth;
	
	
	  var styles = {
	    root: {
	      display: 'inline-block',
	      position: 'relative',
	      width: fullWidth ? '100%' : 256
	    },
	    menu: {
	      width: '100%'
	    },
	    list: {
	      display: 'block',
	      width: fullWidth ? '100%' : 256
	    },
	    innerDiv: {
	      overflow: 'hidden'
	    }
	  };
	
	  if (anchorEl && fullWidth) {
	    styles.popover = {
	      width: anchorEl.clientWidth
	    };
	  }
	
	  return styles;
	}
	
	var AutoComplete = function (_Component) {
	  (0, _inherits3.default)(AutoComplete, _Component);
	
	  function AutoComplete() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AutoComplete);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoComplete.__proto__ || (0, _getPrototypeOf2.default)(AutoComplete)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      anchorEl: null,
	      focusTextField: true,
	      open: false,
	      searchText: undefined
	    }, _this.handleRequestClose = function () {
	      // Only take into account the Popover clickAway when we are
	      // not focusing the TextField.
	      if (!_this.state.focusTextField) {
	        _this.close();
	      }
	    }, _this.handleMouseDown = function (event) {
	      // Keep the TextField focused
	      event.preventDefault();
	    }, _this.handleItemTouchTap = function (event, child) {
	      var dataSource = _this.props.dataSource;
	      var index = parseInt(child.key, 10);
	      var chosenRequest = dataSource[index];
	      var searchText = _this.chosenRequestText(chosenRequest);
	
	      var updateInput = function updateInput() {
	        return _this.props.onUpdateInput(searchText, _this.props.dataSource, {
	          source: 'click'
	        });
	      };
	      _this.timerTouchTapCloseId = function () {
	        return setTimeout(function () {
	          _this.timerTouchTapCloseId = null;
	          _this.close();
	          _this.props.onNewRequest(chosenRequest, index);
	        }, _this.props.menuCloseDelay);
	      };
	
	      if (typeof _this.props.searchText !== 'undefined') {
	        updateInput();
	        _this.timerTouchTapCloseId();
	      } else {
	        _this.setState({
	          searchText: searchText
	        }, function () {
	          updateInput();
	          _this.timerTouchTapCloseId();
	        });
	      }
	    }, _this.chosenRequestText = function (chosenRequest) {
	      if (typeof chosenRequest === 'string') {
	        return chosenRequest;
	      } else {
	        return chosenRequest[_this.props.dataSourceConfig.text];
	      }
	    }, _this.handleEscKeyDown = function () {
	      _this.close();
	    }, _this.handleKeyDown = function (event) {
	      if (_this.props.onKeyDown) _this.props.onKeyDown(event);
	
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.close();
	          var searchText = _this.state.searchText;
	          if (searchText !== '') {
	            _this.props.onNewRequest(searchText, -1);
	          }
	          break;
	
	        case 'esc':
	          _this.close();
	          break;
	
	        case 'down':
	          event.preventDefault();
	          _this.setState({
	            open: true,
	            focusTextField: false,
	            anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	          });
	          break;
	
	        default:
	          break;
	      }
	    }, _this.handleChange = function (event) {
	      var searchText = event.target.value;
	
	      // Make sure that we have a new searchText.
	      // Fix an issue with a Cordova Webview
	      if (searchText === _this.state.searchText) {
	        return;
	      }
	
	      var state = {
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	      };
	
	      if (_this.props.searchText === undefined) {
	        state.searchText = searchText;
	      }
	
	      _this.setState(state);
	
	      _this.props.onUpdateInput(searchText, _this.props.dataSource, {
	        source: 'change'
	      });
	    }, _this.handleBlur = function (event) {
	      if (_this.state.focusTextField && _this.timerTouchTapCloseId === null) {
	        _this.timerBlurClose = setTimeout(function () {
	          _this.close();
	        }, 0);
	      }
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      if (!_this.state.open && _this.props.openOnFocus) {
	        _this.setState({
	          open: true,
	          anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	        });
	      }
	
	      _this.setState({
	        focusTextField: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AutoComplete, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.requestsList = [];
	      this.setState({
	        open: this.props.open,
	        searchText: this.props.searchText || ''
	      });
	      this.timerTouchTapCloseId = null;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.searchText !== nextProps.searchText) {
	        this.setState({
	          searchText: nextProps.searchText
	        });
	      }
	      if (this.props.open !== nextProps.open) {
	        this.setState({
	          open: nextProps.open,
	          anchorEl: _reactDom2.default.findDOMNode(this.refs.searchTextField)
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerTouchTapCloseId);
	      clearTimeout(this.timerBlurClose);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.setState({
	        open: false,
	        anchorEl: null
	      });
	
	      if (this.props.onClose) {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.refs.searchTextField.blur();
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.refs.searchTextField.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          anchorOrigin = _props.anchorOrigin,
	          animated = _props.animated,
	          animation = _props.animation,
	          dataSource = _props.dataSource,
	          dataSourceConfig = _props.dataSourceConfig,
	          disableFocusRipple = _props.disableFocusRipple,
	          errorStyle = _props.errorStyle,
	          floatingLabelText = _props.floatingLabelText,
	          filter = _props.filter,
	          fullWidth = _props.fullWidth,
	          style = _props.style,
	          hintText = _props.hintText,
	          maxSearchResults = _props.maxSearchResults,
	          menuCloseDelay = _props.menuCloseDelay,
	          textFieldStyle = _props.textFieldStyle,
	          menuStyle = _props.menuStyle,
	          menuProps = _props.menuProps,
	          listStyle = _props.listStyle,
	          targetOrigin = _props.targetOrigin,
	          onBlur = _props.onBlur,
	          onClose = _props.onClose,
	          onFocus = _props.onFocus,
	          onKeyDown = _props.onKeyDown,
	          onNewRequest = _props.onNewRequest,
	          onUpdateInput = _props.onUpdateInput,
	          openOnFocus = _props.openOnFocus,
	          popoverProps = _props.popoverProps,
	          searchTextProp = _props.searchText,
	          other = (0, _objectWithoutProperties3.default)(_props, ['anchorOrigin', 'animated', 'animation', 'dataSource', 'dataSourceConfig', 'disableFocusRipple', 'errorStyle', 'floatingLabelText', 'filter', 'fullWidth', 'style', 'hintText', 'maxSearchResults', 'menuCloseDelay', 'textFieldStyle', 'menuStyle', 'menuProps', 'listStyle', 'targetOrigin', 'onBlur', 'onClose', 'onFocus', 'onKeyDown', 'onNewRequest', 'onUpdateInput', 'openOnFocus', 'popoverProps', 'searchText']);
	
	      var _ref2 = popoverProps || {},
	          popoverStyle = _ref2.style,
	          popoverOther = (0, _objectWithoutProperties3.default)(_ref2, ['style']);
	
	      var _state = this.state,
	          open = _state.open,
	          anchorEl = _state.anchorEl,
	          searchText = _state.searchText,
	          focusTextField = _state.focusTextField;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var requestsList = [];
	
	      dataSource.every(function (item, index) {
	        switch (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) {
	          case 'string':
	            if (filter(searchText, item, item)) {
	              requestsList.push({
	                text: item,
	                value: _react2.default.createElement(_MenuItem2.default, {
	                  innerDivStyle: styles.innerDiv,
	                  value: item,
	                  primaryText: item,
	                  disableFocusRipple: disableFocusRipple,
	                  key: index
	                })
	              });
	            }
	            break;
	
	          case 'object':
	            if (item && typeof item[_this2.props.dataSourceConfig.text] === 'string') {
	              var itemText = item[_this2.props.dataSourceConfig.text];
	              if (!_this2.props.filter(searchText, itemText, item)) break;
	
	              var itemValue = item[_this2.props.dataSourceConfig.value];
	              if (itemValue.type && (itemValue.type.muiName === _MenuItem2.default.muiName || itemValue.type.muiName === _Divider2.default.muiName)) {
	                requestsList.push({
	                  text: itemText,
	                  value: _react2.default.cloneElement(itemValue, {
	                    key: index,
	                    disableFocusRipple: disableFocusRipple
	                  })
	                });
	              } else {
	                requestsList.push({
	                  text: itemText,
	                  value: _react2.default.createElement(_MenuItem2.default, {
	                    innerDivStyle: styles.innerDiv,
	                    primaryText: itemText,
	                    disableFocusRipple: disableFocusRipple,
	                    key: index
	                  })
	                });
	              }
	            }
	            break;
	
	          default:
	          // Do nothing
	        }
	
	        return !(maxSearchResults && maxSearchResults > 0 && requestsList.length === maxSearchResults);
	      });
	
	      this.requestsList = requestsList;
	
	      var menu = open && requestsList.length > 0 && _react2.default.createElement(
	        _Menu2.default,
	        (0, _extends3.default)({
	          ref: 'menu',
	          autoWidth: false,
	          disableAutoFocus: focusTextField,
	          onEscKeyDown: this.handleEscKeyDown,
	          initiallyKeyboardFocused: true,
	          onItemTouchTap: this.handleItemTouchTap,
	          onMouseDown: this.handleMouseDown,
	          style: (0, _simpleAssign2.default)(styles.menu, menuStyle),
	          listStyle: (0, _simpleAssign2.default)(styles.list, listStyle)
	        }, menuProps),
	        requestsList.map(function (i) {
	          return i.value;
	        })
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({
	          ref: 'searchTextField',
	          autoComplete: 'off',
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onKeyDown: this.handleKeyDown,
	          floatingLabelText: floatingLabelText,
	          hintText: hintText,
	          fullWidth: fullWidth,
	          multiLine: false,
	          errorStyle: errorStyle,
	          style: textFieldStyle
	        }, other, {
	          // value and onChange are idiomatic properties often leaked.
	          // We prevent their overrides in order to reduce potential bugs.
	          value: searchText,
	          onChange: this.handleChange
	        })),
	        _react2.default.createElement(
	          _Popover2.default,
	          (0, _extends3.default)({
	            style: (0, _simpleAssign2.default)({}, styles.popover, popoverStyle),
	            canAutoPosition: false,
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            open: open,
	            anchorEl: anchorEl,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose,
	            animated: animated,
	            animation: animation
	          }, popoverOther),
	          menu
	        )
	      );
	    }
	  }]);
	  return AutoComplete;
	}(_react.Component);
	
	AutoComplete.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'left'
	  },
	  animated: true,
	  dataSourceConfig: {
	    text: 'text',
	    value: 'value'
	  },
	  disableFocusRipple: true,
	  filter: function filter(searchText, key) {
	    return searchText !== '' && key.indexOf(searchText) !== -1;
	  },
	  fullWidth: false,
	  open: false,
	  openOnFocus: false,
	  onUpdateInput: function onUpdateInput() {},
	  onNewRequest: function onNewRequest() {},
	  menuCloseDelay: 300,
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  }
	};
	AutoComplete.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	AutoComplete.propTypes =  false ? {
	  /**
	   * Location of the anchor for the auto complete.
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the auto complete is animated as it is toggled.
	   */
	  animated: _propTypes2.default.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * Array of strings or nodes used to populate the list.
	   */
	  dataSource: _propTypes2.default.array.isRequired,
	  /**
	   * Config for objects list dataSource.
	   *
	   * @typedef {Object} dataSourceConfig
	   *
	   * @property {string} text `dataSource` element key used to find a string to be matched for search
	   * and shown as a `TextField` input value after choosing the result.
	   * @property {string} value `dataSource` element key used to find a string to be shown in search results.
	   */
	  dataSourceConfig: _propTypes2.default.object,
	  /**
	   * Disables focus ripple when true.
	   */
	  disableFocusRipple: _propTypes2.default.bool,
	  /**
	   * Override style prop for error.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _propTypes2.default.node,
	  /**
	   * Callback function used to filter the auto complete.
	   *
	   * @param {string} searchText The text to search for within `dataSource`.
	   * @param {string} key `dataSource` element, or `text` property on that element if it's not a string.
	   * @returns {boolean} `true` indicates the auto complete list will include `key` when the input is `searchText`.
	   */
	  filter: _propTypes2.default.func,
	  /**
	   * The content to use for adding floating label element.
	   */
	  floatingLabelText: _propTypes2.default.node,
	  /**
	   * If true, the field receives the property `width: 100%`.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * The hint content to display.
	   */
	  hintText: _propTypes2.default.node,
	  /**
	   * Override style for list.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * The max number of search results to be shown.
	   * By default it shows all the items which matches filter.
	   */
	  maxSearchResults: _propTypes2.default.number,
	  /**
	   * Delay for closing time of the menu.
	   */
	  menuCloseDelay: _propTypes2.default.number,
	  /**
	   * Props to be passed to menu.
	   */
	  menuProps: _propTypes2.default.object,
	  /**
	   * Override style for menu.
	   */
	  menuStyle: _propTypes2.default.object,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function fired when the menu is closed.
	   */
	  onClose: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /** @ignore */
	  onKeyDown: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when a list item is selected, or enter is pressed in the `TextField`.
	   *
	   * @param {string} chosenRequest Either the `TextField` input value, if enter is pressed in the `TextField`,
	   * or the dataSource object corresponding to the list item that was selected.
	   * @param {number} index The index in `dataSource` of the list item selected, or `-1` if enter is pressed in the
	   * `TextField`.
	   */
	  onNewRequest: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the user updates the `TextField`.
	   *
	   * @param {string} searchText The auto-complete's `searchText` value.
	   * @param {array} dataSource The auto-complete's `dataSource` array.
	   * @param {object} params Additional information linked the update.
	   */
	  onUpdateInput: _propTypes2.default.func,
	  /**
	   * Auto complete menu is open if true.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * If true, the list item is showed when a focus event triggers.
	   */
	  openOnFocus: _propTypes2.default.bool,
	  /**
	   * Props to be passed to popover.
	   */
	  popoverProps: _propTypes2.default.object,
	  /**
	   * Text being input to auto complete.
	   */
	  searchText: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Origin for location of target.
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * Override the inline-styles of AutoComplete's TextField element.
	   */
	  textFieldStyle: _propTypes2.default.object
	} : {};
	
	
	AutoComplete.levenshteinDistance = function (searchText, key) {
	  var current = [];
	  var prev = void 0;
	  var value = void 0;
	
	  for (var i = 0; i <= key.length; i++) {
	    for (var j = 0; j <= searchText.length; j++) {
	      if (i && j) {
	        if (searchText.charAt(j - 1) === key.charAt(i - 1)) value = prev;else value = Math.min(current[j], current[j - 1], prev) + 1;
	      } else {
	        value = i + j;
	      }
	      prev = current[j];
	      current[j] = value;
	    }
	  }
	  return current.pop();
	};
	
	AutoComplete.noFilter = function () {
	  return true;
	};
	
	AutoComplete.defaultFilter = AutoComplete.caseSensitiveFilter = function (searchText, key) {
	  return searchText !== '' && key.indexOf(searchText) !== -1;
	};
	
	AutoComplete.caseInsensitiveFilter = function (searchText, key) {
	  return key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
	};
	
	AutoComplete.levenshteinDistanceFilter = function (distanceLessThan) {
	  if (distanceLessThan === undefined) {
	    return AutoComplete.levenshteinDistance;
	  } else if (typeof distanceLessThan !== 'number') {
	    throw 'Error: AutoComplete.levenshteinDistanceFilter is a filter generator, not a filter!';
	  }
	
	  return function (s, k) {
	    return AutoComplete.levenshteinDistance(s, k) < distanceLessThan;
	  };
	};
	
	AutoComplete.fuzzyFilter = function (searchText, key) {
	  var compareString = key.toLowerCase();
	  searchText = searchText.toLowerCase();
	
	  var searchTextIndex = 0;
	  for (var index = 0; index < key.length; index++) {
	    if (compareString[index] === searchText[searchTextIndex]) {
	      searchTextIndex += 1;
	    }
	  }
	
	  return searchTextIndex === searchText.length;
	};
	
	AutoComplete.Item = _MenuItem2.default;
	AutoComplete.Divider = _Divider2.default;
	
	exports.default = AutoComplete;

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _AutoComplete = __webpack_require__(1492);
	
	var _AutoComplete2 = _interopRequireDefault(_AutoComplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AutoComplete2.default;

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var backgroundColor = props.backgroundColor,
	      color = props.color,
	      size = props.size;
	  var avatar = context.muiTheme.avatar;
	
	
	  var styles = {
	    root: {
	      color: color || avatar.color,
	      backgroundColor: backgroundColor || avatar.backgroundColor,
	      userSelect: 'none',
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      fontSize: size / 2,
	      borderRadius: '50%',
	      height: size,
	      width: size
	    },
	    icon: {
	      color: color || avatar.color,
	      width: size * 0.6,
	      height: size * 0.6,
	      fontSize: size * 0.6,
	      margin: size * 0.2
	    }
	  };
	
	  return styles;
	}
	
	var Avatar = function (_Component) {
	  (0, _inherits3.default)(Avatar, _Component);
	
	  function Avatar() {
	    (0, _classCallCheck3.default)(this, Avatar);
	    return (0, _possibleConstructorReturn3.default)(this, (Avatar.__proto__ || (0, _getPrototypeOf2.default)(Avatar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Avatar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          icon = _props.icon,
	          src = _props.src,
	          style = _props.style,
	          className = _props.className,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'icon', 'src', 'style', 'className']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      if (src) {
	        return _react2.default.createElement('img', (0, _extends3.default)({
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, other, {
	          src: src,
	          className: className
	        }));
	      } else {
	        return _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({}, other, {
	            style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)),
	            className: className
	          }),
	          icon && _react2.default.cloneElement(icon, {
	            color: styles.icon.color,
	            style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
	          }),
	          this.props.children
	        );
	      }
	    }
	  }]);
	  return Avatar;
	}(_react.Component);
	
	Avatar.muiName = 'Avatar';
	Avatar.defaultProps = {
	  size: 40
	};
	Avatar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Avatar.propTypes =  false ? {
	  /**
	   * The backgroundColor of the avatar. Does not apply to image avatars.
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * Can be used, for instance, to render a letter inside the avatar.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root `div` or `img` element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The icon or letter's color.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * This is the SvgIcon or FontIcon to be used inside the avatar.
	   */
	  icon: _propTypes2.default.element,
	  /**
	   * This is the size of the avatar in pixels.
	   */
	  size: _propTypes2.default.number,
	  /**
	   * If passed in, this component will render an img element. Otherwise, a div will be rendered.
	   */
	  src: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Avatar;

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var primary = props.primary,
	      secondary = props.secondary;
	  var badge = context.muiTheme.badge;
	
	
	  var badgeBackgroundColor = void 0;
	  var badgeTextColor = void 0;
	
	  if (primary) {
	    badgeBackgroundColor = badge.primaryColor;
	    badgeTextColor = badge.primaryTextColor;
	  } else if (secondary) {
	    badgeBackgroundColor = badge.secondaryColor;
	    badgeTextColor = badge.secondaryTextColor;
	  } else {
	    badgeBackgroundColor = badge.color;
	    badgeTextColor = badge.textColor;
	  }
	
	  var radius = 12;
	  var radius2x = Math.floor(2 * radius);
	
	  return {
	    root: {
	      position: 'relative',
	      display: 'inline-block',
	      padding: radius2x + 'px ' + radius2x + 'px ' + radius + 'px ' + radius + 'px'
	    },
	    badge: {
	      display: 'flex',
	      flexDirection: 'row',
	      flexWrap: 'wrap',
	      justifyContent: 'center',
	      alignContent: 'center',
	      alignItems: 'center',
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      fontWeight: badge.fontWeight,
	      fontSize: radius,
	      width: radius2x,
	      height: radius2x,
	      borderRadius: '50%',
	      backgroundColor: badgeBackgroundColor,
	      color: badgeTextColor
	    }
	  };
	}
	
	var Badge = function (_Component) {
	  (0, _inherits3.default)(Badge, _Component);
	
	  function Badge() {
	    (0, _classCallCheck3.default)(this, Badge);
	    return (0, _possibleConstructorReturn3.default)(this, (Badge.__proto__ || (0, _getPrototypeOf2.default)(Badge)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Badge, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          badgeContent = _props.badgeContent,
	          badgeStyle = _props.badgeStyle,
	          children = _props.children,
	          primary = _props.primary,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['badgeContent', 'badgeStyle', 'children', 'primary', 'secondary', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        children,
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles((0, _simpleAssign2.default)({}, styles.badge, badgeStyle)) },
	          badgeContent
	        )
	      );
	    }
	  }]);
	  return Badge;
	}(_react.Component);
	
	Badge.defaultProps = {
	  primary: false,
	  secondary: false
	};
	Badge.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Badge.propTypes =  false ? {
	  /**
	   * This is the content rendered within the badge.
	   */
	  badgeContent: _propTypes2.default.node.isRequired,
	  /**
	   * Override the inline-styles of the badge element.
	   */
	  badgeStyle: _propTypes2.default.object,
	  /**
	   * The badge will be added relativelty to this node.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If true, the badge will use the primary badge colors.
	   */
	  primary: _propTypes2.default.bool,
	  /**
	   * If true, the badge will use the secondary badge colors.
	   */
	  secondary: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Badge;

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var bottomNavigation = context.muiTheme.bottomNavigation;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      width: '100%',
	      display: 'flex',
	      justifyContent: 'center',
	      backgroundColor: bottomNavigation.backgroundColor,
	      height: bottomNavigation.height
	    },
	    item: {
	      flex: '1'
	    }
	  };
	
	  return styles;
	}
	
	var BottomNavigation = function BottomNavigation(props, context) {
	  var children = props.children,
	      style = props.style,
	      selectedIndex = props.selectedIndex,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'style', 'selectedIndex']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var preparedChildren = _react.Children.map(children, function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      style: (0, _simpleAssign2.default)({}, styles.item, child.props.style),
	      selected: index === selectedIndex
	    });
	  });
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	    preparedChildren
	  );
	};
	
	BottomNavigation.propTypes =  false ? {
	  /**
	   * The `BottomNavigationItem`s to populate the element with.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The index of the currently selected navigation item.
	   */
	  selectedIndex: _propTypes2.default.number,
	  /**
	   * @ignore
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	BottomNavigation.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = BottomNavigation;

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BottomNavigationItem = exports.BottomNavigation = undefined;
	
	var _BottomNavigation2 = __webpack_require__(1496);
	
	var _BottomNavigation3 = _interopRequireDefault(_BottomNavigation2);
	
	var _BottomNavigationItem2 = __webpack_require__(739);
	
	var _BottomNavigationItem3 = _interopRequireDefault(_BottomNavigationItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BottomNavigation = _BottomNavigation3.default;
	exports.BottomNavigationItem = _BottomNavigationItem3.default;
	exports.default = _BottomNavigation3.default;

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(106);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _CardExpandable = __webpack_require__(741);
	
	var _CardExpandable2 = _interopRequireDefault(_CardExpandable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card = function (_Component) {
	  (0, _inherits3.default)(Card, _Component);
	
	  function Card() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Card);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Card.__proto__ || (0, _getPrototypeOf2.default)(Card)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      expanded: null
	    }, _this.handleExpanding = function (event) {
	      event.preventDefault();
	      var newExpandedState = !_this.state.expanded;
	      // no automatic state update when the component is controlled
	      if (_this.props.expanded === null) {
	        _this.setState({ expanded: newExpandedState });
	      }
	      if (_this.props.onExpandChange) {
	        _this.props.onExpandChange(newExpandedState);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Card, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        expanded: this.props.expanded === null ? this.props.initiallyExpanded === true : this.props.expanded
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // update the state when the component is controlled.
	      if (nextProps.expanded !== null) this.setState({ expanded: nextProps.expanded });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          style = _props.style,
	          containerStyle = _props.containerStyle,
	          children = _props.children,
	          expandable = _props.expandable,
	          expandedProp = _props.expanded,
	          initiallyExpanded = _props.initiallyExpanded,
	          onExpandChange = _props.onExpandChange,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'containerStyle', 'children', 'expandable', 'expanded', 'initiallyExpanded', 'onExpandChange']);
	
	
	      var lastElement = void 0;
	      var expanded = this.state.expanded;
	      var newChildren = _react2.default.Children.map(children, function (currentChild) {
	        var doClone = false;
	        var newChild = undefined;
	        var newProps = {};
	        var element = currentChild;
	        if (!currentChild || !currentChild.props) {
	          return null;
	        }
	        if (expanded === false && currentChild.props.expandable === true) return;
	        if (currentChild.props.actAsExpander === true) {
	          doClone = true;
	          newProps.onClick = _this2.handleExpanding;
	          newProps.style = (0, _simpleAssign2.default)({ cursor: 'pointer' }, currentChild.props.style);
	        }
	        if (currentChild.props.showExpandableButton === true) {
	          doClone = true;
	          newChild = _react2.default.createElement(_CardExpandable2.default, {
	            closeIcon: currentChild.props.closeIcon,
	            expanded: expanded,
	            onExpanding: _this2.handleExpanding,
	            openIcon: currentChild.props.openIcon,
	            iconStyle: currentChild.props.iconStyle
	          });
	        }
	        if (doClone) {
	          element = _react2.default.cloneElement(currentChild, newProps, currentChild.props.children, newChild);
	        }
	        lastElement = element;
	        return element;
	      }, this);
	
	      // If the last element is text or a title we should add
	      // 8px padding to the bottom of the card
	      var addBottomPadding = lastElement && (lastElement.type.muiName === 'CardText' || lastElement.type.muiName === 'CardTitle');
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        zIndex: 1
	      }, style);
	      var containerMergedStyles = (0, _simpleAssign2.default)({
	        paddingBottom: addBottomPadding ? 8 : 0
	      }, containerStyle);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({}, other, { style: mergedStyles }),
	        _react2.default.createElement(
	          'div',
	          { style: containerMergedStyles },
	          newChildren
	        )
	      );
	    }
	  }]);
	  return Card;
	}(_react.Component);
	
	Card.defaultProps = {
	  expandable: false,
	  expanded: null,
	  initiallyExpanded: false
	};
	Card.propTypes =  false ? {
	  /**
	   * Can be used to render elements inside the Card.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the container element.
	   */
	  containerStyle: _propTypes2.default.object,
	  /**
	   * If true, this card component is expandable. Can be set on any child of the `Card` component.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * Whether this card is expanded.
	   * If `true` or `false` the component is controlled.
	   * if `null` the component is uncontrolled.
	   */
	  expanded: _propTypes2.default.bool,
	  /**
	   * Whether this card is initially expanded.
	   */
	  initiallyExpanded: _propTypes2.default.bool,
	  /**
	   * Callback function fired when the `expandable` state of the card has changed.
	   *
	   * @param {boolean} newExpandedState Represents the new `expanded` state of the card.
	   */
	  onExpandChange: _propTypes2.default.func,
	  /**
	   * If true, this card component will include a button to expand the card. `CardTitle`,
	   * `CardHeader` and `CardActions` implement `showExpandableButton`. Any child component
	   * of `Card` can implements `showExpandableButton` or forwards the property to a child
	   * component supporting it.
	   */
	  showExpandableButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Card;

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CardExpandable = exports.CardActions = exports.CardText = exports.CardMedia = exports.CardTitle = exports.CardHeader = exports.Card = undefined;
	
	var _Card2 = __webpack_require__(1498);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardHeader2 = __webpack_require__(742);
	
	var _CardHeader3 = _interopRequireDefault(_CardHeader2);
	
	var _CardTitle2 = __webpack_require__(745);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardMedia2 = __webpack_require__(743);
	
	var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	var _CardText2 = __webpack_require__(744);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _CardActions2 = __webpack_require__(740);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardExpandable2 = __webpack_require__(741);
	
	var _CardExpandable3 = _interopRequireDefault(_CardExpandable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Card = _Card3.default;
	exports.CardHeader = _CardHeader3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardMedia = _CardMedia3.default;
	exports.CardText = _CardText3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardExpandable = _CardExpandable3.default;
	exports.default = _Card3.default;

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedSwitch = __webpack_require__(497);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _checkBoxOutlineBlank = __webpack_require__(1613);
	
	var _checkBoxOutlineBlank2 = _interopRequireDefault(_checkBoxOutlineBlank);
	
	var _checkBox = __webpack_require__(1614);
	
	var _checkBox2 = _interopRequireDefault(_checkBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var checkbox = context.muiTheme.checkbox;
	
	  var checkboxSize = 24;
	
	  return {
	    icon: {
	      height: checkboxSize,
	      width: checkboxSize
	    },
	    check: {
	      position: 'absolute',
	      opacity: 0,
	      transform: 'scale(0)',
	      transitionOrigin: '50% 50%',
	      transition: _transitions2.default.easeOut('450ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('0ms', 'transform', '450ms'),
	      fill: checkbox.checkedColor
	    },
	    checkWhenSwitched: {
	      opacity: 1,
	      transform: 'scale(1)',
	      transition: _transitions2.default.easeOut('0ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('800ms', 'transform', '0ms')
	    },
	    checkWhenDisabled: {
	      fill: checkbox.disabledColor
	    },
	    box: {
	      position: 'absolute',
	      opacity: 1,
	      fill: checkbox.boxColor,
	      transition: _transitions2.default.easeOut('1000ms', 'opacity', '200ms')
	    },
	    boxWhenSwitched: {
	      opacity: 0,
	      transition: _transitions2.default.easeOut('650ms', 'opacity', '150ms'),
	      fill: checkbox.checkedColor
	    },
	    boxWhenDisabled: {
	      fill: props.checked ? 'transparent' : checkbox.disabledColor
	    },
	    label: {
	      color: props.disabled ? checkbox.labelDisabledColor : checkbox.labelColor
	    }
	  };
	}
	
	var Checkbox = function (_Component) {
	  (0, _inherits3.default)(Checkbox, _Component);
	
	  function Checkbox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Checkbox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      switched: false
	    }, _this.handleStateChange = function (newSwitched) {
	      _this.setState({
	        switched: newSwitched
	      });
	    }, _this.handleCheck = function (event, isInputChecked) {
	      if (_this.props.onCheck) {
	        _this.props.onCheck(event, isInputChecked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Checkbox, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          checked = _props.checked,
	          defaultChecked = _props.defaultChecked,
	          valueLink = _props.valueLink;
	
	
	      if (checked || defaultChecked || valueLink && valueLink.value) {
	        this.setState({
	          switched: true
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.checked !== nextProps.checked) {
	        this.setState({
	          switched: nextProps.checked
	        });
	      }
	    }
	  }, {
	    key: 'isChecked',
	    value: function isChecked() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	  }, {
	    key: 'setChecked',
	    value: function setChecked(newCheckedValue) {
	      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          iconStyle = _props2.iconStyle,
	          onCheck = _props2.onCheck,
	          checkedIcon = _props2.checkedIcon,
	          uncheckedIcon = _props2.uncheckedIcon,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['iconStyle', 'onCheck', 'checkedIcon', 'uncheckedIcon']);
	
	      var styles = getStyles(this.props, this.context);
	      var boxStyles = (0, _simpleAssign2.default)(styles.box, this.state.switched && styles.boxWhenSwitched, iconStyle, this.props.disabled && styles.boxWhenDisabled);
	      var checkStyles = (0, _simpleAssign2.default)(styles.check, this.state.switched && styles.checkWhenSwitched, iconStyle, this.props.disabled && styles.checkWhenDisabled);
	
	      var checkedElement = checkedIcon ? _react2.default.cloneElement(checkedIcon, {
	        style: (0, _simpleAssign2.default)(checkStyles, checkedIcon.props.style)
	      }) : _react2.default.createElement(_checkBox2.default, {
	        style: checkStyles
	      });
	
	      var unCheckedElement = uncheckedIcon ? _react2.default.cloneElement(uncheckedIcon, {
	        style: (0, _simpleAssign2.default)(boxStyles, uncheckedIcon.props.style)
	      }) : _react2.default.createElement(_checkBoxOutlineBlank2.default, {
	        style: boxStyles
	      });
	
	      var checkboxElement = _react2.default.createElement(
	        'div',
	        null,
	        unCheckedElement,
	        checkedElement
	      );
	
	      var rippleColor = this.state.switched ? checkStyles.fill : boxStyles.fill;
	      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
	
	      var labelStyle = (0, _simpleAssign2.default)(styles.label, this.props.labelStyle);
	
	      var enhancedSwitchProps = {
	        ref: 'enhancedSwitch',
	        inputType: 'checkbox',
	        switched: this.state.switched,
	        switchElement: checkboxElement,
	        rippleColor: rippleColor,
	        iconStyle: mergedIconStyle,
	        onSwitch: this.handleCheck,
	        labelStyle: labelStyle,
	        onParentShouldUpdate: this.handleStateChange,
	        labelPosition: this.props.labelPosition
	      };
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
	    }
	  }]);
	  return Checkbox;
	}(_react.Component);
	
	Checkbox.defaultProps = {
	  labelPosition: 'right',
	  disabled: false
	};
	Checkbox.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Checkbox.propTypes =  false ? {
	  /**
	   * Checkbox is checked if true.
	   */
	  checked: _propTypes2.default.bool,
	  /**
	   * The SvgIcon to use for the checked state.
	   * This is useful to create icon toggles.
	   */
	  checkedIcon: _propTypes2.default.element,
	  /**
	   * The default state of our checkbox component.
	   * **Warning:** This cannot be used in conjunction with `checked`.
	   * Decide between using a controlled or uncontrolled input element and remove one of these props.
	   * More info: https://fb.me/react-controlled-components
	   */
	  defaultChecked: _propTypes2.default.bool,
	  /**
	   * Disabled if true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Overrides the inline-styles of the icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Overrides the inline-styles of the input element.
	   */
	  inputStyle: _propTypes2.default.object,
	  /**
	   * Where the label will be placed next to the checkbox.
	   */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Overrides the inline-styles of the Checkbox element label.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Callback function that is fired when the checkbox is checked.
	   *
	   * @param {object} event `change` event targeting the underlying checkbox `input`.
	   * @param {boolean} isInputChecked The `checked` value of the underlying checkbox `input`.
	   */
	  onCheck: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The SvgIcon to use for the unchecked state.
	   * This is useful to create icon toggles.
	   */
	  uncheckedIcon: _propTypes2.default.element,
	  /**
	   * ValueLink for when using controlled checkbox.
	   */
	  valueLink: _propTypes2.default.object
	} : {};
	exports.default = Checkbox;

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _keycode = __webpack_require__(99);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _colorManipulator = __webpack_require__(187);
	
	var _EnhancedButton = __webpack_require__(139);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _cancel = __webpack_require__(1607);
	
	var _cancel2 = _interopRequireDefault(_cancel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var chip = context.muiTheme.chip;
	
	
	  var backgroundColor = props.backgroundColor || chip.backgroundColor;
	  var focusColor = (0, _colorManipulator.emphasize)(backgroundColor, 0.08);
	  var pressedColor = (0, _colorManipulator.emphasize)(backgroundColor, 0.12);
	
	  return {
	    avatar: {
	      marginRight: -4
	    },
	    deleteIcon: {
	      color: state.deleteHovered ? (0, _colorManipulator.fade)(chip.deleteIconColor, 0.4) : chip.deleteIconColor,
	      cursor: 'pointer',
	      margin: '4px 4px 0px -8px'
	    },
	    label: {
	      color: props.labelColor || chip.textColor,
	      fontSize: chip.fontSize,
	      fontWeight: chip.fontWeight,
	      lineHeight: '32px',
	      paddingLeft: 12,
	      paddingRight: 12,
	      userSelect: 'none',
	      whiteSpace: 'nowrap'
	    },
	    root: {
	      backgroundColor: state.clicked ? pressedColor : state.focused || state.hovered ? focusColor : backgroundColor,
	      borderRadius: 16,
	      boxShadow: state.clicked ? chip.shadow : null,
	      cursor: props.onClick ? 'pointer' : 'default',
	      display: 'flex',
	      whiteSpace: 'nowrap',
	      width: 'fit-content'
	    }
	  };
	}
	
	var Chip = function (_Component) {
	  (0, _inherits3.default)(Chip, _Component);
	
	  function Chip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Chip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Chip.__proto__ || (0, _getPrototypeOf2.default)(Chip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      clicked: false,
	      deleteHovered: false,
	      focused: false,
	      hovered: false
	    }, _this.handleBlur = function (event) {
	      _this.setState({ clicked: false, focused: false });
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (_this.props.onClick || _this.props.onRequestDelete) {
	        _this.setState({ focused: true });
	      }
	      _this.props.onFocus(event);
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (keyboardFocused) {
	        _this.handleFocus();
	        _this.props.onFocus(event);
	      } else {
	        _this.handleBlur();
	      }
	
	      _this.props.onKeyboardFocus(event, keyboardFocused);
	    }, _this.handleKeyDown = function (event) {
	      if ((0, _keycode2.default)(event) === 'backspace') {
	        event.preventDefault();
	        if (_this.props.onRequestDelete) {
	          _this.props.onRequestDelete(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleMouseDown = function (event) {
	      // Only listen to left clicks
	      if (event.button === 0) {
	        event.stopPropagation();
	        if (_this.props.onClick) {
	          _this.setState({ clicked: true });
	        }
	      }
	      _this.props.onMouseDown(event);
	    }, _this.handleMouseEnter = function (event) {
	      if (_this.props.onClick) {
	        _this.setState({ hovered: true });
	      }
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseEnterDeleteIcon = function () {
	      _this.setState({ deleteHovered: true });
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({
	        clicked: false,
	        hovered: false
	      });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseLeaveDeleteIcon = function () {
	      _this.setState({ deleteHovered: false });
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({ clicked: false });
	      _this.props.onMouseUp(event);
	    }, _this.handleTouchTapDeleteIcon = function (event) {
	      // Stop the event from bubbling up to the `Chip`
	      event.stopPropagation();
	      _this.props.onRequestDelete(event);
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({ clicked: false });
	      _this.props.onTouchEnd(event);
	    }, _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      if (_this.props.onClick) {
	        _this.setState({ clicked: true });
	      }
	      _this.props.onTouchStart(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Chip, [{
	    key: 'render',
	    value: function render() {
	      var buttonEventHandlers = {
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        onMouseDown: this.handleMouseDown,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseUp: this.handleMouseUp,
	        onTouchEnd: this.handleTouchEnd,
	        onTouchStart: this.handleTouchStart,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var _props = this.props,
	          childrenProp = _props.children,
	          containerElement = _props.containerElement,
	          style = _props.style,
	          className = _props.className,
	          deleteIconStyle = _props.deleteIconStyle,
	          labelStyle = _props.labelStyle,
	          labelColor = _props.labelColor,
	          backgroundColor = _props.backgroundColor,
	          onRequestDelete = _props.onRequestDelete,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'containerElement', 'style', 'className', 'deleteIconStyle', 'labelStyle', 'labelColor', 'backgroundColor', 'onRequestDelete']);
	
	
	      var deletable = this.props.onRequestDelete;
	      var avatar = null;
	
	      var deleteIcon = deletable ? _react2.default.createElement(_cancel2.default, {
	        color: styles.deleteIcon.color,
	        style: (0, _simpleAssign2.default)(styles.deleteIcon, deleteIconStyle),
	        onClick: this.handleTouchTapDeleteIcon,
	        onMouseEnter: this.handleMouseEnterDeleteIcon,
	        onMouseLeave: this.handleMouseLeaveDeleteIcon
	      }) : null;
	
	      var children = childrenProp;
	      var childCount = _react2.default.Children.count(children);
	
	      // If the first child is an avatar, extract it and style it
	      if (childCount > 1) {
	        children = _react2.default.Children.toArray(children);
	
	        if (_react2.default.isValidElement(children[0]) && children[0].type.muiName === 'Avatar') {
	          avatar = children.shift();
	
	          avatar = _react2.default.cloneElement(avatar, {
	            style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style),
	            size: 32
	          });
	        }
	      }
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, buttonEventHandlers, {
	          className: className,
	          containerElement: containerElement,
	          disableTouchRipple: true,
	          disableFocusRipple: true,
	          style: (0, _simpleAssign2.default)(styles.root, style)
	        }),
	        avatar,
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	          children
	        ),
	        deleteIcon
	      );
	    }
	  }]);
	  return Chip;
	}(_react.Component);
	
	Chip.defaultProps = {
	  containerElement: 'div', // Firefox doesn't support nested buttons
	  onBlur: function onBlur() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseDown: function onMouseDown() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onMouseUp: function onMouseUp() {},
	  onTouchEnd: function onTouchEnd() {},
	  onTouchStart: function onTouchStart() {}
	};
	Chip.contextTypes = { muiTheme: _propTypes2.default.object.isRequired };
	Chip.propTypes =  false ? {
	  /**
	   * Override the background color of the chip.
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * Used to render elements inside the Chip.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * CSS `className` of the root element.
	   */
	  className: _propTypes2.default.node,
	  /**
	   * The element to use as the container for the Chip. Either a string to
	   * use a DOM element or a ReactElement.
	   */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * Override the inline-styles of the delete icon.
	   */
	  deleteIconStyle: _propTypes2.default.object,
	  /**
	   * Override the label color.
	   */
	  labelColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the label.
	   */
	  labelStyle: _propTypes2.default.object,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `Chip` element is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the element.
	   */
	  onClick: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /** @ignore */
	  onKeyDown: _propTypes2.default.func,
	  /** @ignore */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseDown: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseUp: _propTypes2.default.func,
	  /**
	   * Callback function fired when the delete icon is clicked. If set, the delete icon will be shown.
	   * @param {object} event `click` event targeting the element.
	   */
	  onRequestDelete: _propTypes2.default.func,
	  /** @ignore */
	  onTouchEnd: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Chip;

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autoPrefix = __webpack_require__(213);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  return clampedValue / (max - min);
	}
	
	function getArcLength(fraction, props) {
	  return fraction * Math.PI * (props.size - props.thickness);
	}
	
	function getStyles(props, context) {
	  var max = props.max,
	      min = props.min,
	      size = props.size,
	      value = props.value;
	  var palette = context.muiTheme.baseTheme.palette;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      display: 'inline-block',
	      width: size,
	      height: size
	    },
	    wrapper: {
	      width: size,
	      height: size,
	      display: 'inline-block',
	      transition: _transitions2.default.create('transform', '20s', null, 'linear'),
	      transitionTimingFunction: 'linear'
	    },
	    svg: {
	      width: size,
	      height: size,
	      position: 'relative'
	    },
	    path: {
	      stroke: props.color || palette.primary1Color,
	      strokeLinecap: 'round',
	      transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	    }
	  };
	
	  if (props.mode === 'determinate') {
	    var relVal = getRelativeValue(value, min, max);
	    styles.path.transition = _transitions2.default.create('all', '0.3s', null, 'linear');
	    styles.path.strokeDasharray = getArcLength(relVal, props) + ', ' + getArcLength(1, props);
	  }
	
	  return styles;
	}
	
	var CircularProgress = function (_Component) {
	  (0, _inherits3.default)(CircularProgress, _Component);
	
	  function CircularProgress() {
	    (0, _classCallCheck3.default)(this, CircularProgress);
	    return (0, _possibleConstructorReturn3.default)(this, (CircularProgress.__proto__ || (0, _getPrototypeOf2.default)(CircularProgress)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CircularProgress, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scalePath(this.refs.path);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	    }
	  }, {
	    key: 'scalePath',
	    value: function scalePath(path) {
	      var _this2 = this;
	
	      var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      step %= 3;
	
	      if (step === 0) {
	        path.style.strokeDasharray = getArcLength(0, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = 0;
	        path.style.transitionDuration = '0ms';
	      } else if (step === 1) {
	        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = getArcLength(-0.3, this.props);
	        path.style.transitionDuration = '750ms';
	      } else {
	        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = getArcLength(-1, this.props);
	        path.style.transitionDuration = '850ms';
	      }
	
	      this.scalePathTimer = setTimeout(function () {
	        return _this2.scalePath(path, step + 1);
	      }, step ? 750 : 250);
	    }
	  }, {
	    key: 'rotateWrapper',
	    value: function rotateWrapper(wrapper) {
	      var _this3 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');
	
	      setTimeout(function () {
	        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
	        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
	        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
	      }, 50);
	
	      this.rotateWrapperTimer = setTimeout(function () {
	        return _this3.rotateWrapper(wrapper);
	      }, 10050);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          innerStyle = _props.innerStyle,
	          size = _props.size,
	          thickness = _props.thickness,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'innerStyle', 'size', 'thickness']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper', style: prepareStyles((0, _simpleAssign2.default)(styles.wrapper, innerStyle)) },
	          _react2.default.createElement(
	            'svg',
	            {
	              viewBox: '0 0 ' + size + ' ' + size,
	              style: prepareStyles(styles.svg)
	            },
	            _react2.default.createElement('circle', {
	              ref: 'path',
	              style: prepareStyles(styles.path),
	              cx: size / 2,
	              cy: size / 2,
	              r: (size - thickness) / 2,
	              fill: 'none',
	              strokeWidth: thickness,
	              strokeMiterlimit: '20'
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return CircularProgress;
	}(_react.Component);
	
	CircularProgress.defaultProps = {
	  mode: 'indeterminate',
	  value: 0,
	  min: 0,
	  max: 100,
	  size: 40,
	  thickness: 3.5
	};
	CircularProgress.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CircularProgress.propTypes =  false ? {
	  /**
	   * Override the progress's color.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * Style for inner wrapper div.
	   */
	  innerStyle: _propTypes2.default.object,
	  /**
	   * The max value of progress, only works in determinate mode.
	   */
	  max: _propTypes2.default.number,
	  /**
	   * The min value of progress, only works in determinate mode.
	   */
	  min: _propTypes2.default.number,
	  /**
	   * The mode of show your progress, indeterminate
	   * for when there is no value for progress.
	   */
	  mode: _propTypes2.default.oneOf(['determinate', 'indeterminate']),
	  /**
	   * The diameter of the progress in pixels.
	   */
	  size: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Stroke width in pixels.
	   */
	  thickness: _propTypes2.default.number,
	  /**
	   * The value of progress, only works in determinate mode.
	   */
	  value: _propTypes2.default.number
	} : {};
	exports.default = CircularProgress;

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _CircularProgress = __webpack_require__(1502);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CircularProgress2.default;

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _toConsumableArray2 = __webpack_require__(266);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(165);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(99);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _CalendarActionButtons = __webpack_require__(1505);
	
	var _CalendarActionButtons2 = _interopRequireDefault(_CalendarActionButtons);
	
	var _CalendarMonth = __webpack_require__(1506);
	
	var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
	var _CalendarYear = __webpack_require__(1508);
	
	var _CalendarYear2 = _interopRequireDefault(_CalendarYear);
	
	var _CalendarToolbar = __webpack_require__(1507);
	
	var _CalendarToolbar2 = _interopRequireDefault(_CalendarToolbar);
	
	var _DateDisplay = __webpack_require__(1509);
	
	var _DateDisplay2 = _interopRequireDefault(_DateDisplay);
	
	var _SlideIn = __webpack_require__(499);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	var _dateUtils = __webpack_require__(285);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var daysArray = [].concat((0, _toConsumableArray3.default)(Array(7)));
	
	var Calendar = function (_Component) {
	  (0, _inherits3.default)(Calendar, _Component);
	
	  function Calendar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Calendar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Calendar.__proto__ || (0, _getPrototypeOf2.default)(Calendar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      displayDate: undefined,
	      displayMonthDay: undefined,
	      selectedDate: undefined,
	      transitionDirection: 'left',
	      transitionEnter: true
	    }, _this.calendarRefs = {}, _this.handleTouchTapDay = function (event, date) {
	      _this.setSelectedDate(date);
	      if (_this.props.onTouchTapDay) _this.props.onTouchTapDay(event, date);
	    }, _this.handleMonthChange = function (months) {
	      var nextDirection = _this.context.muiTheme.isRtl ? 'right' : 'left';
	      var prevDirection = _this.context.muiTheme.isRtl ? 'left' : 'right';
	      var direction = months >= 0 ? nextDirection : prevDirection;
	      _this.setState({
	        transitionDirection: direction,
	        displayDate: _this.props.utils.addMonths(_this.state.displayDate, months)
	      });
	    }, _this.handleTouchTapYear = function (event, year) {
	      _this.setSelectedDate(_this.props.utils.setYear(_this.state.selectedDate, year), event);
	      _this.handleTouchTapDateDisplayMonthDay();
	    }, _this.handleTouchTapDateDisplayMonthDay = function () {
	      _this.setState({
	        displayMonthDay: true
	      });
	    }, _this.handleTouchTapDateDisplayYear = function () {
	      _this.setState({
	        displayMonthDay: false
	      });
	    }, _this.handleWindowKeyDown = function (event) {
	      if (_this.props.open) {
	        var nextArrow = _this.context.muiTheme.isRtl ? 'left' : 'right';
	        var prevArrow = _this.context.muiTheme.isRtl ? 'right' : 'left';
	        switch ((0, _keycode2.default)(event)) {
	          case 'up':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(-1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(-1);
	            } else {
	              _this.addSelectedDays(-7);
	            }
	            break;
	
	          case 'down':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(1);
	            } else {
	              _this.addSelectedDays(7);
	            }
	            break;
	
	          case nextArrow:
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(1);
	            } else {
	              _this.addSelectedDays(1);
	            }
	            break;
	
	          case prevArrow:
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(-1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(-1);
	            } else {
	              _this.addSelectedDays(-1);
	            }
	            break;
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Calendar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        displayDate: this.props.utils.getFirstDayOfMonth(this.props.initialDate),
	        selectedDate: this.props.initialDate,
	        displayMonthDay: !this.props.openToYearSelection
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.initialDate !== this.props.initialDate) {
	        var date = nextProps.initialDate || new Date();
	        this.setState({
	          displayDate: this.props.utils.getFirstDayOfMonth(date),
	          selectedDate: date
	        });
	      }
	    }
	  }, {
	    key: 'getMinDate',
	    value: function getMinDate() {
	      return this.props.minDate || this.props.utils.addYears(new Date(), -100);
	    }
	  }, {
	    key: 'getMaxDate',
	    value: function getMaxDate() {
	      return this.props.maxDate || this.props.utils.addYears(new Date(), 100);
	    }
	  }, {
	    key: 'getSelectedDate',
	    value: function getSelectedDate() {
	      return this.state.selectedDate;
	    }
	  }, {
	    key: 'isSelectedDateDisabled',
	    value: function isSelectedDateDisabled() {
	      if (!this.state.displayMonthDay) {
	        return false;
	      }
	
	      if (this.calendarRefs.calendar) {
	        return this.calendarRefs.calendar.isSelectedDateDisabled();
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'addSelectedDays',
	    value: function addSelectedDays(days) {
	      this.setSelectedDate(this.props.utils.addDays(this.state.selectedDate, days));
	    }
	  }, {
	    key: 'addSelectedMonths',
	    value: function addSelectedMonths(months) {
	      this.setSelectedDate(this.props.utils.addMonths(this.state.selectedDate, months));
	    }
	  }, {
	    key: 'addSelectedYears',
	    value: function addSelectedYears(years) {
	      this.setSelectedDate(this.props.utils.addYears(this.state.selectedDate, years));
	    }
	  }, {
	    key: 'setDisplayDate',
	    value: function setDisplayDate(date, newSelectedDate) {
	      var newDisplayDate = this.props.utils.getFirstDayOfMonth(date);
	
	      if (newDisplayDate !== this.state.displayDate) {
	        var nextDirection = this.context.muiTheme.isRtl ? 'right' : 'left';
	        var prevDirection = this.context.muiTheme.isRtl ? 'left' : 'right';
	        var direction = newDisplayDate > this.state.displayDate ? nextDirection : prevDirection;
	        this.setState({
	          displayDate: newDisplayDate,
	          transitionDirection: direction,
	          selectedDate: newSelectedDate || this.state.selectedDate
	        });
	      }
	    }
	  }, {
	    key: 'setSelectedDate',
	    value: function setSelectedDate(date) {
	      var adjustedDate = date;
	      var minDate = this.getMinDate();
	      var maxDate = this.getMaxDate();
	      if ((0, _dateUtils.isBeforeDate)(date, minDate)) {
	        adjustedDate = minDate;
	      } else if ((0, _dateUtils.isAfterDate)(date, maxDate)) {
	        adjustedDate = maxDate;
	      }
	
	      var newDisplayDate = this.props.utils.getFirstDayOfMonth(adjustedDate);
	      if (newDisplayDate !== this.state.displayDate) {
	        this.setDisplayDate(newDisplayDate, adjustedDate);
	      } else {
	        this.setState({
	          selectedDate: adjustedDate
	        });
	      }
	    }
	  }, {
	    key: 'getToolbarInteractions',
	    value: function getToolbarInteractions() {
	      return {
	        prevMonth: this.props.utils.monthDiff(this.state.displayDate, this.getMinDate()) > 0,
	        nextMonth: this.props.utils.monthDiff(this.state.displayDate, this.getMaxDate()) < 0
	      };
	    }
	  }, {
	    key: 'yearSelector',
	    value: function yearSelector() {
	      if (!this.props.disableYearSelection) {
	        return _react2.default.createElement(_CalendarYear2.default, {
	          key: 'years',
	          DateTimeFormat: this.props.DateTimeFormat,
	          locale: this.props.locale,
	          onTouchTapYear: this.handleTouchTapYear,
	          selectedDate: this.state.selectedDate,
	          minDate: this.getMinDate(),
	          maxDate: this.getMaxDate(),
	          utils: this.props.utils
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var hideCalendarDate = this.props.hideCalendarDate;
	
	      var toolbarInteractions = this.getToolbarInteractions();
	      var isLandscape = this.props.mode === 'landscape';
	      var calendarTextColor = this.context.muiTheme.datePicker.calendarTextColor;
	
	
	      var styles = {
	        root: {
	          color: calendarTextColor,
	          userSelect: 'none',
	          width: !hideCalendarDate && isLandscape ? 479 : 310
	        },
	        calendar: {
	          display: 'flex',
	          flexDirection: 'column'
	        },
	        calendarContainer: {
	          display: 'flex',
	          alignContent: 'space-between',
	          justifyContent: 'space-between',
	          flexDirection: 'column',
	          fontSize: 12,
	          fontWeight: 400,
	          padding: '0px 8px',
	          transition: _transitions2.default.easeOut()
	        },
	        yearContainer: {
	          display: 'flex',
	          justifyContent: 'space-between',
	          flexDirection: 'column',
	          height: 272,
	          marginTop: 10,
	          overflow: 'hidden',
	          width: 310
	        },
	        weekTitle: {
	          display: 'flex',
	          flexDirection: 'row',
	          justifyContent: 'space-between',
	          fontWeight: '500',
	          height: 20,
	          lineHeight: '15px',
	          opacity: '0.5',
	          textAlign: 'center'
	        },
	        weekTitleDay: {
	          width: 42
	        },
	        transitionSlide: {
	          height: 214
	        }
	      };
	
	      var weekTitleDayStyle = prepareStyles(styles.weekTitleDay);
	
	      var _props = this.props,
	          cancelLabel = _props.cancelLabel,
	          DateTimeFormat = _props.DateTimeFormat,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          locale = _props.locale,
	          okLabel = _props.okLabel,
	          onTouchTapCancel = _props.onTouchTapCancel,
	          onTouchTapOk = _props.onTouchTapOk,
	          utils = _props.utils;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyDown: this.handleWindowKeyDown
	        }),
	        !hideCalendarDate && _react2.default.createElement(_DateDisplay2.default, {
	          DateTimeFormat: DateTimeFormat,
	          disableYearSelection: this.props.disableYearSelection,
	          onTouchTapMonthDay: this.handleTouchTapDateDisplayMonthDay,
	          onTouchTapYear: this.handleTouchTapDateDisplayYear,
	          locale: locale,
	          monthDaySelected: this.state.displayMonthDay,
	          mode: this.props.mode,
	          selectedDate: this.state.selectedDate
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.calendar) },
	          this.state.displayMonthDay && _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.calendarContainer) },
	            _react2.default.createElement(_CalendarToolbar2.default, {
	              DateTimeFormat: DateTimeFormat,
	              locale: locale,
	              displayDate: this.state.displayDate,
	              onMonthChange: this.handleMonthChange,
	              prevMonth: toolbarInteractions.prevMonth,
	              nextMonth: toolbarInteractions.nextMonth
	            }),
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles(styles.weekTitle) },
	              daysArray.map(function (event, i) {
	                return _react2.default.createElement(
	                  'span',
	                  { key: i, style: weekTitleDayStyle },
	                  (0, _dateUtils.localizedWeekday)(DateTimeFormat, locale, i, firstDayOfWeek)
	                );
	              })
	            ),
	            _react2.default.createElement(
	              _SlideIn2.default,
	              { direction: this.state.transitionDirection, style: styles.transitionSlide },
	              _react2.default.createElement(_CalendarMonth2.default, {
	                DateTimeFormat: DateTimeFormat,
	                locale: locale,
	                displayDate: this.state.displayDate,
	                firstDayOfWeek: this.props.firstDayOfWeek,
	                key: this.state.displayDate.toDateString(),
	                minDate: this.getMinDate(),
	                maxDate: this.getMaxDate(),
	                onTouchTapDay: this.handleTouchTapDay,
	                ref: function ref(_ref2) {
	                  return _this2.calendarRefs.calendar = _ref2;
	                },
	                selectedDate: this.state.selectedDate,
	                shouldDisableDate: this.props.shouldDisableDate,
	                utils: utils
	              })
	            )
	          ),
	          !this.state.displayMonthDay && _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.yearContainer) },
	            this.yearSelector()
	          ),
	          okLabel && _react2.default.createElement(_CalendarActionButtons2.default, {
	            autoOk: this.props.autoOk,
	            cancelLabel: cancelLabel,
	            okLabel: okLabel,
	            onTouchTapCancel: onTouchTapCancel,
	            onTouchTapOk: onTouchTapOk
	          })
	        )
	      );
	    }
	  }]);
	  return Calendar;
	}(_react.Component);
	
	Calendar.defaultProps = {
	  DateTimeFormat: _dateUtils.dateTimeFormat,
	  disableYearSelection: false,
	  initialDate: new Date(),
	  locale: 'en-US',
	  utils: _dateUtils.defaultUtils
	};
	Calendar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Calendar.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  autoOk: _propTypes2.default.bool,
	  cancelLabel: _propTypes2.default.node,
	  disableYearSelection: _propTypes2.default.bool,
	  firstDayOfWeek: _propTypes2.default.number,
	  hideCalendarDate: _propTypes2.default.bool,
	  initialDate: _propTypes2.default.object,
	  locale: _propTypes2.default.string.isRequired,
	  maxDate: _propTypes2.default.object,
	  minDate: _propTypes2.default.object,
	  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
	  okLabel: _propTypes2.default.node,
	  onTouchTapCancel: _propTypes2.default.func,
	  onTouchTapDay: _propTypes2.default.func,
	  onTouchTapOk: _propTypes2.default.func,
	  open: _propTypes2.default.bool,
	  openToYearSelection: _propTypes2.default.bool,
	  shouldDisableDate: _propTypes2.default.func,
	  utils: _propTypes2.default.object
	} : {};
	exports.default = Calendar;

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FlatButton = __webpack_require__(36);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarActionButton = function (_Component) {
	  (0, _inherits3.default)(CalendarActionButton, _Component);
	
	  function CalendarActionButton() {
	    (0, _classCallCheck3.default)(this, CalendarActionButton);
	    return (0, _possibleConstructorReturn3.default)(this, (CalendarActionButton.__proto__ || (0, _getPrototypeOf2.default)(CalendarActionButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CalendarActionButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cancelLabel = _props.cancelLabel,
	          okLabel = _props.okLabel;
	
	
	      var styles = {
	        root: {
	          display: 'flex',
	          flexDirection: 'row',
	          justifyContent: 'flex-end',
	          margin: 0,
	          maxHeight: 48,
	          padding: 0
	        },
	        flatButtons: {
	          fontsize: 14,
	          margin: '4px 8px 8px 0px',
	          maxHeight: 36,
	          minWidth: 64,
	          padding: 0
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(_FlatButton2.default, {
	          label: cancelLabel,
	          onClick: this.props.onTouchTapCancel,
	          primary: true,
	          style: styles.flatButtons
	        }),
	        !this.props.autoOk && _react2.default.createElement(_FlatButton2.default, {
	          disabled: this.refs.calendar !== undefined && this.refs.calendar.isSelectedDateDisabled(),
	          label: okLabel,
	          onClick: this.props.onTouchTapOk,
	          primary: true,
	          style: styles.flatButtons
	        })
	      );
	    }
	  }]);
	  return CalendarActionButton;
	}(_react.Component);
	
	CalendarActionButton.propTypes =  false ? {
	  autoOk: _propTypes2.default.bool,
	  cancelLabel: _propTypes2.default.node,
	  okLabel: _propTypes2.default.node,
	  onTouchTapCancel: _propTypes2.default.func,
	  onTouchTapOk: _propTypes2.default.func
	} : {};
	exports.default = CalendarActionButton;

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dateUtils = __webpack_require__(285);
	
	var _DayButton = __webpack_require__(1512);
	
	var _DayButton2 = _interopRequireDefault(_DayButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'flex',
	    flexDirection: 'column',
	    justifyContent: 'flex-start',
	    fontWeight: 400,
	    height: 228,
	    lineHeight: 2,
	    position: 'relative',
	    textAlign: 'center',
	    MozPaddingStart: 0
	  },
	  week: {
	    display: 'flex',
	    flexDirection: 'row',
	    justifyContent: 'space-around',
	    height: 34,
	    marginBottom: 2
	  }
	};
	
	var CalendarMonth = function (_Component) {
	  (0, _inherits3.default)(CalendarMonth, _Component);
	
	  function CalendarMonth() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarMonth);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarMonth.__proto__ || (0, _getPrototypeOf2.default)(CalendarMonth)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapDay = function (event, date) {
	      if (_this.props.onTouchTapDay) {
	        _this.props.onTouchTapDay(event, date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarMonth, [{
	    key: 'isSelectedDateDisabled',
	    value: function isSelectedDateDisabled() {
	      return this.selectedDateDisabled;
	    }
	  }, {
	    key: 'shouldDisableDate',
	    value: function shouldDisableDate(day) {
	      if (day === null) return false;
	      var disabled = !(0, _dateUtils.isBetweenDates)(day, this.props.minDate, this.props.maxDate);
	      if (!disabled && this.props.shouldDisableDate) disabled = this.props.shouldDisableDate(day);
	
	      return disabled;
	    }
	  }, {
	    key: 'getWeekElements',
	    value: function getWeekElements() {
	      var _this2 = this;
	
	      var weekArray = this.props.utils.getWeekArray(this.props.displayDate, this.props.firstDayOfWeek);
	
	      return weekArray.map(function (week, i) {
	        return _react2.default.createElement(
	          'div',
	          { key: i, style: styles.week },
	          _this2.getDayElements(week, i)
	        );
	      }, this);
	    }
	  }, {
	    key: 'getDayElements',
	    value: function getDayElements(week, i) {
	      var _this3 = this;
	
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          selectedDate = _props.selectedDate;
	
	
	      return week.map(function (day, j) {
	        var isSameDate = (0, _dateUtils.isEqualDate)(selectedDate, day);
	        var disabled = _this3.shouldDisableDate(day);
	        var selected = !disabled && isSameDate;
	
	        if (isSameDate) {
	          _this3.selectedDateDisabled = disabled;
	        }
	
	        return _react2.default.createElement(_DayButton2.default, {
	          DateTimeFormat: DateTimeFormat,
	          locale: locale,
	          date: day,
	          disabled: disabled,
	          key: 'db' + (i + j),
	          onClick: _this3.handleTouchTapDay,
	          selected: selected
	        });
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        this.getWeekElements()
	      );
	    }
	  }]);
	  return CalendarMonth;
	}(_react.Component);
	
	CalendarMonth.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  autoOk: _propTypes2.default.bool,
	  displayDate: _propTypes2.default.object.isRequired,
	  firstDayOfWeek: _propTypes2.default.number,
	  locale: _propTypes2.default.string.isRequired,
	  maxDate: _propTypes2.default.object,
	  minDate: _propTypes2.default.object,
	  onTouchTapDay: _propTypes2.default.func,
	  selectedDate: _propTypes2.default.object.isRequired,
	  shouldDisableDate: _propTypes2.default.func,
	  utils: _propTypes2.default.object.isRequired
	} : {};
	exports.default = CalendarMonth;

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _IconButton = __webpack_require__(126);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _chevronLeft = __webpack_require__(779);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _chevronRight = __webpack_require__(780);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _SlideIn = __webpack_require__(499);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'flex',
	    justifyContent: 'space-between',
	    backgroundColor: 'inherit',
	    height: 48
	  },
	  titleDiv: {
	    fontSize: 14,
	    fontWeight: '500',
	    textAlign: 'center',
	    width: '100%'
	  },
	  titleText: {
	    height: 'inherit',
	    paddingTop: 12
	  }
	};
	
	var CalendarToolbar = function (_Component) {
	  (0, _inherits3.default)(CalendarToolbar, _Component);
	
	  function CalendarToolbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarToolbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarToolbar.__proto__ || (0, _getPrototypeOf2.default)(CalendarToolbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      transitionDirection: 'up'
	    }, _this.handleTouchTapPrevMonth = function () {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(-1);
	      }
	    }, _this.handleTouchTapNextMonth = function () {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(1);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarToolbar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.displayDate !== this.props.displayDate) {
	        var nextDirection = this.context.muiTheme.isRtl ? 'right' : 'left';
	        var prevDirection = this.context.muiTheme.isRtl ? 'left' : 'right';
	        var direction = nextProps.displayDate > this.props.displayDate ? nextDirection : prevDirection;
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          displayDate = _props.displayDate;
	
	
	      var dateTimeFormatted = new DateTimeFormat(locale, {
	        month: 'long',
	        year: 'numeric'
	      }).format(displayDate);
	
	      var nextButtonIcon = this.context.muiTheme.isRtl ? _react2.default.createElement(_chevronLeft2.default, null) : _react2.default.createElement(_chevronRight2.default, null);
	      var prevButtonIcon = this.context.muiTheme.isRtl ? _react2.default.createElement(_chevronRight2.default, null) : _react2.default.createElement(_chevronLeft2.default, null);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            disabled: !this.props.prevMonth,
	            onClick: this.handleTouchTapPrevMonth
	          },
	          prevButtonIcon
	        ),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          {
	            direction: this.state.transitionDirection,
	            style: styles.titleDiv
	          },
	          _react2.default.createElement(
	            'div',
	            { key: dateTimeFormatted, style: styles.titleText },
	            dateTimeFormatted
	          )
	        ),
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            disabled: !this.props.nextMonth,
	            onClick: this.handleTouchTapNextMonth
	          },
	          nextButtonIcon
	        )
	      );
	    }
	  }]);
	  return CalendarToolbar;
	}(_react.Component);
	
	CalendarToolbar.defaultProps = {
	  nextMonth: true,
	  prevMonth: true
	};
	CalendarToolbar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CalendarToolbar.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  displayDate: _propTypes2.default.object.isRequired,
	  locale: _propTypes2.default.string.isRequired,
	  nextMonth: _propTypes2.default.bool,
	  onMonthChange: _propTypes2.default.func,
	  prevMonth: _propTypes2.default.bool
	} : {};
	exports.default = CalendarToolbar;

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _YearButton = __webpack_require__(1513);
	
	var _YearButton2 = _interopRequireDefault(_YearButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarYear = function (_Component) {
	  (0, _inherits3.default)(CalendarYear, _Component);
	
	  function CalendarYear() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarYear);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarYear.__proto__ || (0, _getPrototypeOf2.default)(CalendarYear)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapYear = function (event, year) {
	      if (_this.props.onTouchTapYear) {
	        _this.props.onTouchTapYear(event, year);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarYear, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scrollToSelectedYear();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.scrollToSelectedYear();
	    }
	  }, {
	    key: 'getYears',
	    value: function getYears() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate,
	          selectedDate = _props.selectedDate,
	          utils = _props.utils;
	
	
	      var minYear = utils.getYear(minDate);
	      var maxYear = utils.getYear(maxDate);
	      var years = [];
	
	      for (var year = minYear; year <= maxYear; year++) {
	        var selected = utils.getYear(selectedDate) === year;
	        var selectedProps = {};
	        if (selected) {
	          selectedProps.ref = 'selectedYearButton';
	        }
	
	        var yearFormated = new DateTimeFormat(locale, {
	          year: 'numeric'
	        }).format(utils.setYear(selectedDate, year));
	
	        var yearButton = _react2.default.createElement(
	          _YearButton2.default,
	          (0, _extends3.default)({
	            key: 'yb' + year,
	            onClick: this.handleTouchTapYear,
	            selected: selected,
	            year: year,
	            utils: utils
	          }, selectedProps),
	          yearFormated
	        );
	
	        years.push(yearButton);
	      }
	
	      return years;
	    }
	  }, {
	    key: 'scrollToSelectedYear',
	    value: function scrollToSelectedYear() {
	      if (this.refs.selectedYearButton === undefined) {
	        return;
	      }
	
	      var container = _reactDom2.default.findDOMNode(this);
	      var yearButtonNode = _reactDom2.default.findDOMNode(this.refs.selectedYearButton);
	
	      var containerHeight = container.clientHeight;
	      var yearButtonNodeHeight = yearButtonNode.clientHeight || 32;
	
	      var scrollYOffset = yearButtonNode.offsetTop + yearButtonNodeHeight / 2 - containerHeight / 2;
	      container.scrollTop = scrollYOffset;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          calendarYearBackgroundColor = _context$muiTheme.datePicker.calendarYearBackgroundColor;
	
	
	      var styles = {
	        root: {
	          backgroundColor: calendarYearBackgroundColor,
	          height: 'inherit',
	          lineHeight: '35px',
	          overflowX: 'hidden',
	          overflowY: 'scroll',
	          position: 'relative'
	        },
	        child: {
	          display: 'flex',
	          flexDirection: 'column',
	          justifyContent: 'center',
	          minHeight: '100%'
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.child) },
	          this.getYears()
	        )
	      );
	    }
	  }]);
	  return CalendarYear;
	}(_react.Component);
	
	CalendarYear.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CalendarYear.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locale: _propTypes2.default.string.isRequired,
	  maxDate: _propTypes2.default.object.isRequired,
	  minDate: _propTypes2.default.object.isRequired,
	  onTouchTapYear: _propTypes2.default.func,
	  selectedDate: _propTypes2.default.object.isRequired,
	  utils: _propTypes2.default.object.isRequired,
	  wordings: _propTypes2.default.object
	} : {};
	exports.default = CalendarYear;

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _SlideIn = __webpack_require__(499);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var datePicker = context.muiTheme.datePicker;
	  var selectedYear = state.selectedYear;
	
	  var isLandscape = props.mode === 'landscape';
	
	  var styles = {
	    root: {
	      width: isLandscape ? 165 : '100%',
	      height: isLandscape ? 330 : 'auto',
	      float: isLandscape ? 'left' : 'none',
	      fontWeight: 700,
	      display: 'inline-block',
	      backgroundColor: datePicker.headerColor,
	      borderTopLeftRadius: 2,
	      borderTopRightRadius: isLandscape ? 0 : 2,
	      borderBottomLeftRadius: isLandscape ? 2 : 0,
	      color: datePicker.textColor,
	      padding: 20,
	      boxSizing: 'border-box'
	    },
	    monthDay: {
	      display: 'block',
	      fontSize: 36,
	      lineHeight: '36px',
	      height: props.mode === 'landscape' ? '100%' : 38,
	      opacity: selectedYear ? 0.7 : 1,
	      transition: _transitions2.default.easeOut(),
	      width: '100%',
	      fontWeight: '500'
	    },
	    monthDayTitle: {
	      cursor: !selectedYear ? 'default' : 'pointer',
	      width: '100%',
	      display: 'block'
	    },
	    year: {
	      margin: 0,
	      fontSize: 16,
	      fontWeight: '500',
	      lineHeight: '16px',
	      height: 16,
	      opacity: selectedYear ? 1 : 0.7,
	      transition: _transitions2.default.easeOut(),
	      marginBottom: 10
	    },
	    yearTitle: {
	      cursor: props.disableYearSelection || selectedYear ? 'default' : 'pointer'
	    }
	  };
	
	  return styles;
	}
	
	var DateDisplay = function (_Component) {
	  (0, _inherits3.default)(DateDisplay, _Component);
	
	  function DateDisplay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DateDisplay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DateDisplay.__proto__ || (0, _getPrototypeOf2.default)(DateDisplay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedYear: false,
	      transitionDirection: 'up'
	    }, _this.handleTouchTapMonthDay = function () {
	      if (_this.props.onTouchTapMonthDay && _this.state.selectedYear) {
	        _this.props.onTouchTapMonthDay();
	      }
	
	      _this.setState({ selectedYear: false });
	    }, _this.handleTouchTapYear = function () {
	      if (_this.props.onTouchTapYear && !_this.props.disableYearSelection && !_this.state.selectedYear) {
	        _this.props.onTouchTapYear();
	      }
	
	      if (!_this.props.disableYearSelection) {
	        _this.setState({ selectedYear: true });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DateDisplay, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.monthDaySelected) {
	        this.setState({ selectedYear: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedDate !== this.props.selectedDate) {
	        var direction = nextProps.selectedDate > this.props.selectedDate ? 'up' : 'down';
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	
	      if (nextProps.monthDaySelected !== undefined) {
	        this.setState({
	          selectedYear: !nextProps.monthDaySelected
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          disableYearSelection = _props.disableYearSelection,
	          locale = _props.locale,
	          mode = _props.mode,
	          monthDaySelected = _props.monthDaySelected,
	          onTouchTapMonthDay = _props.onTouchTapMonthDay,
	          onTouchTapYear = _props.onTouchTapYear,
	          selectedDate = _props.selectedDate,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'disableYearSelection', 'locale', 'mode', 'monthDaySelected', 'onTouchTapMonthDay', 'onTouchTapYear', 'selectedDate', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var year = new DateTimeFormat(locale, {
	        year: 'numeric'
	      }).format(selectedDate);
	
	      var dateTime = new DateTimeFormat(locale, {
	        month: 'short',
	        weekday: 'short',
	        day: '2-digit'
	      }).format(selectedDate);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(styles.root, style) }),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          { style: styles.year, direction: this.state.transitionDirection },
	          _react2.default.createElement(
	            'div',
	            { key: year, style: styles.yearTitle, onClick: this.handleTouchTapYear },
	            year
	          )
	        ),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          { style: styles.monthDay, direction: this.state.transitionDirection },
	          _react2.default.createElement(
	            'div',
	            {
	              key: dateTime,
	              onClick: this.handleTouchTapMonthDay,
	              style: styles.monthDayTitle
	            },
	            dateTime
	          )
	        )
	      );
	    }
	  }]);
	  return DateDisplay;
	}(_react.Component);
	
	DateDisplay.defaultProps = {
	  disableYearSelection: false,
	  monthDaySelected: true
	};
	DateDisplay.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	DateDisplay.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  disableYearSelection: _propTypes2.default.bool,
	  locale: _propTypes2.default.string.isRequired,
	  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
	  monthDaySelected: _propTypes2.default.bool,
	  onTouchTapMonthDay: _propTypes2.default.func,
	  onTouchTapYear: _propTypes2.default.func,
	  selectedDate: _propTypes2.default.object.isRequired,
	  style: _propTypes2.default.object
	} : {};
	exports.default = DateDisplay;

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dateUtils = __webpack_require__(285);
	
	var _DatePickerDialog = __webpack_require__(1511);
	
	var _DatePickerDialog2 = _interopRequireDefault(_DatePickerDialog);
	
	var _TextField = __webpack_require__(186);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePicker = function (_Component) {
	  (0, _inherits3.default)(DatePicker, _Component);
	
	  function DatePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DatePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatePicker.__proto__ || (0, _getPrototypeOf2.default)(DatePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      date: undefined
	    }, _this.handleAccept = function (date) {
	      if (!_this.isControlled()) {
	        _this.setState({
	          date: date
	        });
	      }
	      if (_this.props.onChange) {
	        _this.props.onChange(null, date);
	      }
	    }, _this.handleFocus = function (event) {
	      event.target.blur();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleTouchTap = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	
	      if (!_this.props.disabled) {
	        setTimeout(function () {
	          _this.openDialog();
	        }, 0);
	      }
	    }, _this.formatDate = function (date) {
	      if (_this.props.locale) {
	        var DateTimeFormat = _this.props.DateTimeFormat || _dateUtils.dateTimeFormat;
	        return new DateTimeFormat(_this.props.locale, {
	          day: 'numeric',
	          month: 'numeric',
	          year: 'numeric'
	        }).format(date);
	      } else {
	        return (0, _dateUtils.formatIso)(date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DatePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        date: this.isControlled() ? this.getControlledDate() : this.props.defaultDate
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.isControlled()) {
	        var newDate = this.getControlledDate(nextProps);
	        if (!(0, _dateUtils.isEqualDate)(this.state.date, newDate)) {
	          this.setState({
	            date: newDate
	          });
	        }
	      }
	    }
	  }, {
	    key: 'getDate',
	    value: function getDate() {
	      return this.state.date;
	    }
	
	    /**
	     * Open the date-picker dialog programmatically from a parent.
	     */
	
	  }, {
	    key: 'openDialog',
	    value: function openDialog() {
	      /**
	       * if the date is not selected then set it to new date
	       * (get the current system date while doing so)
	       * else set it to the currently selected date
	       */
	      if (this.state.date !== undefined) {
	        this.setState({
	          dialogDate: this.getDate()
	        }, this.refs.dialogWindow.show);
	      } else {
	        this.setState({
	          dialogDate: new Date()
	        }, this.refs.dialogWindow.show);
	      }
	    }
	
	    /**
	     * Alias for `openDialog()` for an api consistent with TextField.
	     */
	
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.openDialog();
	    }
	  }, {
	    key: 'isControlled',
	    value: function isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'getControlledDate',
	    value: function getControlledDate() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      if (props.value instanceof Date) {
	        return props.value;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          className = _props.className,
	          container = _props.container,
	          defaultDate = _props.defaultDate,
	          dialogContainerStyle = _props.dialogContainerStyle,
	          disableYearSelection = _props.disableYearSelection,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          formatDateProp = _props.formatDate,
	          locale = _props.locale,
	          maxDate = _props.maxDate,
	          minDate = _props.minDate,
	          mode = _props.mode,
	          okLabel = _props.okLabel,
	          onDismiss = _props.onDismiss,
	          onFocus = _props.onFocus,
	          onShow = _props.onShow,
	          onClick = _props.onClick,
	          openToYearSelection = _props.openToYearSelection,
	          shouldDisableDate = _props.shouldDisableDate,
	          hideCalendarDate = _props.hideCalendarDate,
	          style = _props.style,
	          textFieldStyle = _props.textFieldStyle,
	          utils = _props.utils,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'className', 'container', 'defaultDate', 'dialogContainerStyle', 'disableYearSelection', 'firstDayOfWeek', 'formatDate', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onDismiss', 'onFocus', 'onShow', 'onClick', 'openToYearSelection', 'shouldDisableDate', 'hideCalendarDate', 'style', 'textFieldStyle', 'utils']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var formatDate = formatDateProp || this.formatDate;
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
	          onFocus: this.handleFocus,
	          onClick: this.handleTouchTap,
	          ref: 'input',
	          style: textFieldStyle,
	          value: this.state.date ? formatDate(this.state.date) : ''
	        })),
	        _react2.default.createElement(_DatePickerDialog2.default, {
	          DateTimeFormat: DateTimeFormat,
	          autoOk: autoOk,
	          cancelLabel: cancelLabel,
	          container: container,
	          containerStyle: dialogContainerStyle,
	          disableYearSelection: disableYearSelection,
	          firstDayOfWeek: firstDayOfWeek,
	          initialDate: this.state.dialogDate,
	          locale: locale,
	          maxDate: maxDate,
	          minDate: minDate,
	          mode: mode,
	          okLabel: okLabel,
	          onAccept: this.handleAccept,
	          onShow: onShow,
	          onDismiss: onDismiss,
	          ref: 'dialogWindow',
	          shouldDisableDate: shouldDisableDate,
	          hideCalendarDate: hideCalendarDate,
	          openToYearSelection: openToYearSelection,
	          utils: utils
	        })
	      );
	    }
	  }]);
	  return DatePicker;
	}(_react.Component);
	
	DatePicker.defaultProps = {
	  autoOk: false,
	  container: 'dialog',
	  disabled: false,
	  disableYearSelection: false,
	  firstDayOfWeek: 1,
	  hideCalendarDate: false,
	  style: {},
	  openToYearSelection: false
	};
	DatePicker.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	DatePicker.propTypes =  false ? {
	  /**
	   * Constructor for date formatting for the specified `locale`.
	   * The constructor must follow this specification: ECMAScript Internationalization API 1.0 (ECMA-402).
	   * `Intl.DateTimeFormat` is supported by most modern browsers, see http://caniuse.com/#search=intl,
	   * otherwise https://github.com/andyearnshaw/Intl.js is a good polyfill.
	   *
	   * By default, a built-in `DateTimeFormat` is used which supports the 'en-US' `locale`.
	   */
	  DateTimeFormat: _propTypes2.default.func,
	  /**
	   * If true, automatically accept and close the picker on select a date.
	   */
	  autoOk: _propTypes2.default.bool,
	  /**
	   * Override the default text of the 'Cancel' button.
	   */
	  cancelLabel: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Used to control how the Date Picker will be displayed when the input field is focused.
	   * `dialog` (default) displays the DatePicker as a dialog with a modal.
	   * `inline` displays the DatePicker below the input field (similar to auto complete).
	   */
	  container: _propTypes2.default.oneOf(['dialog', 'inline']),
	  /**
	   * This is the initial date value of the component.
	   * If either `value` or `valueLink` is provided they will override this
	   * prop with `value` taking precedence.
	   */
	  defaultDate: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of DatePickerDialog's Container element.
	   */
	  dialogContainerStyle: _propTypes2.default.object,
	  /**
	   * Disables the year selection in the date picker.
	   */
	  disableYearSelection: _propTypes2.default.bool,
	  /**
	   * Disables the DatePicker.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Used to change the first day of week. It varies from
	   * Saturday to Monday between different locales.
	   * The allowed range is 0 (Sunday) to 6 (Saturday).
	   * The default is `1`, Monday, as per ISO 8601.
	   */
	  firstDayOfWeek: _propTypes2.default.number,
	  /**
	   * This function is called to format the date displayed in the input field, and should return a string.
	   * By default if no `locale` and `DateTimeFormat` is provided date objects are formatted to ISO 8601 YYYY-MM-DD.
	   *
	   * @param {object} date Date object to be formatted.
	   * @returns {any} The formatted date.
	   */
	  formatDate: _propTypes2.default.func,
	  /**
	   * Hide date display
	   */
	  hideCalendarDate: _propTypes2.default.bool,
	  /**
	   * Locale used for formatting the `DatePicker` date strings. Other than for 'en-US', you
	   * must provide a `DateTimeFormat` that supports the chosen `locale`.
	   */
	  locale: _propTypes2.default.string,
	  /**
	   * The ending of a range of valid dates. The range includes the endDate.
	   * The default value is current date + 100 years.
	   */
	  maxDate: _propTypes2.default.object,
	  /**
	   * The beginning of a range of valid dates. The range includes the startDate.
	   * The default value is current date - 100 years.
	   */
	  minDate: _propTypes2.default.object,
	  /**
	   * Tells the component to display the picker in portrait or landscape mode.
	   */
	  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
	  /**
	   * Override the default text of the 'OK' button.
	   */
	  okLabel: _propTypes2.default.node,
	  /**
	   * Callback function that is fired when the date value changes.
	   *
	   * @param {null} null Since there is no particular event associated with the change,
	   * the first argument will always be null.
	   * @param {object} date The new date.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when a touch tap event occurs on the Date Picker's `TextField`.
	   *
	   * @param {object} event TouchTap event targeting the `TextField`.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the Date Picker's dialog is dismissed.
	   */
	  onDismiss: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the Date Picker's `TextField` gains focus.
	   */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the Date Picker's dialog is shown.
	   */
	  onShow: _propTypes2.default.func,
	  /**
	   * If true sets the datepicker to open to year selection first.
	   */
	  openToYearSelection: _propTypes2.default.bool,
	  /**
	   * Callback function used to determine if a day's entry should be disabled on the calendar.
	   *
	   * @param {object} day Date object of a day.
	   * @returns {boolean} Indicates whether the day should be disabled.
	   */
	  shouldDisableDate: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of DatePicker's TextField element.
	   */
	  textFieldStyle: _propTypes2.default.object,
	  /**
	   * This object should contain methods needed to build the calendar system.
	   *
	   * Useful for building a custom calendar system. Refer to the
	   * [source code](https://github.com/callemall/material-ui/blob/master/src/DatePicker/dateUtils.js)
	   * and an [example implementation](https://github.com/alitaheri/material-ui-persian-date-picker-utils)
	   * for more information.
	   */
	  utils: _propTypes2.default.object,
	  /**
	   * Sets the date for the Date Picker programmatically.
	   */
	  value: _propTypes2.default.object
	} : {};
	exports.default = DatePicker;

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(165);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(99);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _Calendar = __webpack_require__(1504);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _Dialog = __webpack_require__(76);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Popover = __webpack_require__(242);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _PopoverAnimationVertical = __webpack_require__(492);
	
	var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);
	
	var _dateUtils = __webpack_require__(285);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePickerDialog = function (_Component) {
	  (0, _inherits3.default)(DatePickerDialog, _Component);
	
	  function DatePickerDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DatePickerDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatePickerDialog.__proto__ || (0, _getPrototypeOf2.default)(DatePickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.show = function () {
	      if (_this.props.onShow && !_this.state.open) {
	        _this.props.onShow();
	      }
	
	      _this.setState({
	        open: true
	      });
	    }, _this.dismiss = function () {
	      if (_this.props.onDismiss && _this.state.open) {
	        _this.props.onDismiss();
	      }
	
	      _this.setState({
	        open: false
	      });
	    }, _this.handleTouchTapDay = function () {
	      if (_this.props.autoOk) {
	        setTimeout(_this.handleTouchTapOk, 300);
	      }
	    }, _this.handleTouchTapCancel = function () {
	      _this.dismiss();
	    }, _this.handleRequestClose = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapOk = function () {
	      if (_this.props.onAccept && !_this.refs.calendar.isSelectedDateDisabled()) {
	        _this.props.onAccept(_this.refs.calendar.getSelectedDate());
	      }
	
	      _this.setState({
	        open: false
	      });
	    }, _this.handleWindowKeyUp = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.handleTouchTapOk();
	          break;
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DatePickerDialog, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          container = _props.container,
	          containerStyle = _props.containerStyle,
	          disableYearSelection = _props.disableYearSelection,
	          initialDate = _props.initialDate,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          locale = _props.locale,
	          maxDate = _props.maxDate,
	          minDate = _props.minDate,
	          mode = _props.mode,
	          okLabel = _props.okLabel,
	          onAccept = _props.onAccept,
	          onDismiss = _props.onDismiss,
	          onShow = _props.onShow,
	          openToYearSelection = _props.openToYearSelection,
	          shouldDisableDate = _props.shouldDisableDate,
	          hideCalendarDate = _props.hideCalendarDate,
	          style = _props.style,
	          animation = _props.animation,
	          utils = _props.utils,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'container', 'containerStyle', 'disableYearSelection', 'initialDate', 'firstDayOfWeek', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onAccept', 'onDismiss', 'onShow', 'openToYearSelection', 'shouldDisableDate', 'hideCalendarDate', 'style', 'animation', 'utils']);
	      var open = this.state.open;
	
	
	      var styles = {
	        dialogContent: {
	          width: !hideCalendarDate && mode === 'landscape' ? 479 : 310
	        },
	        dialogBodyContent: {
	          padding: 0,
	          minHeight: hideCalendarDate || mode === 'landscape' ? 330 : 434,
	          minWidth: hideCalendarDate || mode !== 'landscape' ? 310 : 479
	        }
	      };
	
	      var Container = container === 'inline' ? _Popover2.default : _Dialog2.default;
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { ref: 'root' }),
	        _react2.default.createElement(
	          Container,
	          {
	            anchorEl: this.refs.root // For Popover
	            , animation: animation || _PopoverAnimationVertical2.default // For Popover
	            , bodyStyle: styles.dialogBodyContent,
	            contentStyle: styles.dialogContent,
	            ref: 'dialog',
	            repositionOnUpdate: true,
	            open: open,
	            onRequestClose: this.handleRequestClose,
	            style: (0, _simpleAssign2.default)(styles.dialogBodyContent, containerStyle)
	          },
	          _react2.default.createElement(_reactEventListener2.default, {
	            target: 'window',
	            onKeyUp: this.handleWindowKeyUp
	          }),
	          _react2.default.createElement(_Calendar2.default, {
	            autoOk: autoOk,
	            DateTimeFormat: DateTimeFormat,
	            cancelLabel: cancelLabel,
	            disableYearSelection: disableYearSelection,
	            firstDayOfWeek: firstDayOfWeek,
	            initialDate: initialDate,
	            locale: locale,
	            onTouchTapDay: this.handleTouchTapDay,
	            maxDate: maxDate,
	            minDate: minDate,
	            mode: mode,
	            open: open,
	            ref: 'calendar',
	            onTouchTapCancel: this.handleTouchTapCancel,
	            onTouchTapOk: this.handleTouchTapOk,
	            okLabel: okLabel,
	            openToYearSelection: openToYearSelection,
	            shouldDisableDate: shouldDisableDate,
	            hideCalendarDate: hideCalendarDate,
	            utils: utils
	          })
	        )
	      );
	    }
	  }]);
	  return DatePickerDialog;
	}(_react.Component);
	
	DatePickerDialog.defaultProps = {
	  DateTimeFormat: _dateUtils.dateTimeFormat,
	  cancelLabel: 'Cancel',
	  container: 'dialog',
	  locale: 'en-US',
	  okLabel: 'OK',
	  openToYearSelection: false
	};
	DatePickerDialog.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	DatePickerDialog.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func,
	  animation: _propTypes2.default.func,
	  autoOk: _propTypes2.default.bool,
	  cancelLabel: _propTypes2.default.node,
	  container: _propTypes2.default.oneOf(['dialog', 'inline']),
	  containerStyle: _propTypes2.default.object,
	  disableYearSelection: _propTypes2.default.bool,
	  firstDayOfWeek: _propTypes2.default.number,
	  hideCalendarDate: _propTypes2.default.bool,
	  initialDate: _propTypes2.default.object,
	  locale: _propTypes2.default.string,
	  maxDate: _propTypes2.default.object,
	  minDate: _propTypes2.default.object,
	  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
	  okLabel: _propTypes2.default.node,
	  onAccept: _propTypes2.default.func,
	  onDismiss: _propTypes2.default.func,
	  onShow: _propTypes2.default.func,
	  open: _propTypes2.default.bool,
	  openToYearSelection: _propTypes2.default.bool,
	  shouldDisableDate: _propTypes2.default.func,
	  style: _propTypes2.default.object,
	  utils: _propTypes2.default.object
	} : {};
	exports.default = DatePickerDialog;

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _dateUtils = __webpack_require__(285);
	
	var _EnhancedButton = __webpack_require__(139);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var date = props.date,
	      disabled = props.disabled,
	      selected = props.selected;
	  var hover = state.hover;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      datePicker = _context$muiTheme.datePicker;
	
	
	  var labelColor = baseTheme.palette.textColor;
	  var buttonStateOpacity = 0;
	  var buttonStateTransform = 'scale(0)';
	
	  if (hover || selected) {
	    labelColor = datePicker.selectTextColor;
	    buttonStateOpacity = selected ? 1 : 0.6;
	    buttonStateTransform = 'scale(1)';
	  } else if ((0, _dateUtils.isEqualDate)(date, new Date())) {
	    labelColor = datePicker.color;
	  }
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      fontWeight: '400',
	      opacity: disabled && '0.4',
	      padding: '4px 0px',
	      position: 'relative',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      width: 42
	    },
	    label: {
	      color: labelColor,
	      fontWeight: '400',
	      position: 'relative'
	    },
	    buttonState: {
	      backgroundColor: datePicker.selectColor,
	      borderRadius: '50%',
	      height: 34,
	      left: 4,
	      opacity: buttonStateOpacity,
	      position: 'absolute',
	      top: 0,
	      transform: buttonStateTransform,
	      transition: _transitions2.default.easeOut(),
	      width: 34
	    }
	  };
	}
	
	var DayButton = function (_Component) {
	  (0, _inherits3.default)(DayButton, _Component);
	
	  function DayButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DayButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DayButton.__proto__ || (0, _getPrototypeOf2.default)(DayButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hover: false
	    }, _this.handleMouseEnter = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ hover: true });
	      }
	    }, _this.handleMouseLeave = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ hover: false });
	      }
	    }, _this.handleTouchTap = function (event) {
	      if (!_this.props.disabled && _this.props.onClick) {
	        _this.props.onClick(event, _this.props.date);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (!_this.props.disabled && _this.props.onKeyboardFocus) {
	        _this.props.onKeyboardFocus(event, keyboardFocused, _this.props.date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DayButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          date = _props.date,
	          disabled = _props.disabled,
	          locale = _props.locale,
	          onClick = _props.onClick,
	          selected = _props.selected,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'date', 'disabled', 'locale', 'onClick', 'selected']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return date ? _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          disableFocusRipple: true,
	          disableTouchRipple: true,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onClick: this.handleTouchTap,
	          style: styles.root
	        }),
	        _react2.default.createElement('div', { style: prepareStyles(styles.buttonState) }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          new DateTimeFormat(locale, {
	            day: 'numeric'
	          }).format(date)
	        )
	      ) : _react2.default.createElement('span', { style: prepareStyles(styles.root) });
	    }
	  }]);
	  return DayButton;
	}(_react.Component);
	
	DayButton.defaultProps = {
	  selected: false,
	  disabled: false
	};
	DayButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	DayButton.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  date: _propTypes2.default.object,
	  disabled: _propTypes2.default.bool,
	  locale: _propTypes2.default.string.isRequired,
	  onClick: _propTypes2.default.func,
	  onKeyboardFocus: _propTypes2.default.func,
	  selected: _propTypes2.default.bool
	} : {};
	exports.default = DayButton;

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedButton = __webpack_require__(139);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var selected = props.selected,
	      year = props.year,
	      utils = props.utils;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      datePicker = _context$muiTheme.datePicker;
	  var hover = state.hover;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      color: year === utils.getYear(new Date()) && datePicker.color,
	      display: 'block',
	      fontSize: 14,
	      margin: '0 auto',
	      position: 'relative',
	      textAlign: 'center',
	      lineHeight: 'inherit',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)' // Remove mobile color flashing (deprecated)
	    },
	    label: {
	      alignSelf: 'center',
	      color: hover || selected ? datePicker.color : baseTheme.palette.textColor,
	      fontSize: selected ? 26 : 17,
	      fontWeight: hover ? 450 : selected ? 500 : 400,
	      position: 'relative',
	      top: -1
	    }
	  };
	}
	
	var YearButton = function (_Component) {
	  (0, _inherits3.default)(YearButton, _Component);
	
	  function YearButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, YearButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = YearButton.__proto__ || (0, _getPrototypeOf2.default)(YearButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hover: false
	    }, _this.handleMouseEnter = function () {
	      _this.setState({ hover: true });
	    }, _this.handleMouseLeave = function () {
	      _this.setState({ hover: false });
	    }, _this.handleTouchTap = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event, _this.props.year);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(YearButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          onClick = _props.onClick,
	          selected = _props.selected,
	          year = _props.year,
	          utils = _props.utils,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'onClick', 'selected', 'year', 'utils']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disableFocusRipple: true,
	          disableTouchRipple: true,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onClick: this.handleTouchTap,
	          style: styles.root
	        }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          children
	        )
	      );
	    }
	  }]);
	  return YearButton;
	}(_react.Component);
	
	YearButton.defaultProps = {
	  selected: false
	};
	YearButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	YearButton.propTypes =  false ? {
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  selected: _propTypes2.default.bool,
	  utils: _propTypes2.default.object.isRequired,
	  year: _propTypes2.default.number.isRequired
	} : {};
	exports.default = YearButton;

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(165);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(99);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Overlay = __webpack_require__(768);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _RenderToLayer = __webpack_require__(769);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _Paper = __webpack_require__(106);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _TransitionGroup = __webpack_require__(290);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransitionItem = function (_Component) {
	  (0, _inherits3.default)(TransitionItem, _Component);
	
	  function TransitionItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TransitionItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TransitionItem.__proto__ || (0, _getPrototypeOf2.default)(TransitionItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      style: {}
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TransitionItem, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimeout);
	      clearTimeout(this.leaveTimeout);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.componentWillAppear(callback);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      var spacing = this.context.muiTheme.baseTheme.spacing;
	
	      this.setState({
	        style: {
	          opacity: 1,
	          transform: 'translate(0, ' + spacing.desktopKeylineIncrement + 'px)'
	        }
	      });
	
	      this.enterTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      this.setState({
	        style: {
	          opacity: 0,
	          transform: 'translate(0, 0)'
	        }
	      });
	
	      this.leaveTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          children = _props.children,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'children']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, this.state.style, style)) }),
	        children
	      );
	    }
	  }]);
	  return TransitionItem;
	}(_react.Component);
	
	TransitionItem.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TransitionItem.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  style: _propTypes2.default.object
	} : {};
	
	
	function getStyles(props, context) {
	  var autoScrollBodyContent = props.autoScrollBodyContent,
	      open = props.open;
	  var _context$muiTheme = context.muiTheme,
	      _context$muiTheme$bas = _context$muiTheme.baseTheme,
	      spacing = _context$muiTheme$bas.spacing,
	      palette = _context$muiTheme$bas.palette,
	      dialog = _context$muiTheme.dialog,
	      zIndex = _context$muiTheme.zIndex;
	
	
	  var gutter = spacing.desktopGutter;
	  var borderScroll = '1px solid ' + palette.borderColor;
	
	  return {
	    root: {
	      position: 'fixed',
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      zIndex: zIndex.dialog,
	      top: 0,
	      left: open ? 0 : -10000,
	      width: '100%',
	      height: '100%',
	      transition: open ? _transitions2.default.easeOut('0ms', 'left', '0ms') : _transitions2.default.easeOut('0ms', 'left', '450ms')
	    },
	    content: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      transition: _transitions2.default.easeOut(),
	      position: 'relative',
	      width: '75%',
	      maxWidth: spacing.desktopKeylineIncrement * 12,
	      margin: '0 auto',
	      zIndex: zIndex.dialog
	    },
	    actionsContainer: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      padding: 8,
	      width: '100%',
	      textAlign: 'right',
	      marginTop: autoScrollBodyContent ? -1 : 0
	    },
	    overlay: {
	      zIndex: zIndex.dialogOverlay
	    },
	    title: {
	      margin: 0,
	      padding: gutter + 'px ' + gutter + 'px 20px ' + gutter + 'px',
	      color: palette.textColor,
	      fontSize: dialog.titleFontSize,
	      lineHeight: '32px',
	      fontWeight: 400,
	      marginBottom: autoScrollBodyContent ? -1 : 0
	    },
	    body: {
	      fontSize: dialog.bodyFontSize,
	      color: dialog.bodyColor,
	      padding: (props.title ? 0 : gutter) + 'px ' + gutter + 'px ' + gutter + 'px',
	      boxSizing: 'border-box',
	      overflowY: autoScrollBodyContent ? 'auto' : 'hidden',
	      borderTop: autoScrollBodyContent ? borderScroll : 'none',
	      borderBottom: autoScrollBodyContent ? borderScroll : 'none'
	    }
	  };
	}
	
	var DialogInline = function (_Component2) {
	  (0, _inherits3.default)(DialogInline, _Component2);
	
	  function DialogInline() {
	    var _ref2;
	
	    var _temp2, _this2, _ret2;
	
	    (0, _classCallCheck3.default)(this, DialogInline);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = DialogInline.__proto__ || (0, _getPrototypeOf2.default)(DialogInline)).call.apply(_ref2, [this].concat(args))), _this2), _this2.handleTouchTapOverlay = function () {
	      _this2.requestClose(false);
	    }, _this2.handleKeyUp = function (event) {
	      if ((0, _keycode2.default)(event) === 'esc') {
	        _this2.requestClose(false);
	      }
	    }, _this2.handleResize = function () {
	      _this2.positionDialog();
	    }, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
	  }
	
	  (0, _createClass3.default)(DialogInline, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'positionDialog',
	    value: function positionDialog() {
	      var _props2 = this.props,
	          actions = _props2.actions,
	          autoDetectWindowHeight = _props2.autoDetectWindowHeight,
	          autoScrollBodyContent = _props2.autoScrollBodyContent,
	          bodyStyle = _props2.bodyStyle,
	          open = _props2.open,
	          repositionOnUpdate = _props2.repositionOnUpdate,
	          title = _props2.title;
	
	
	      if (!open) {
	        return;
	      }
	
	      var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	      var container = _reactDom2.default.findDOMNode(this);
	      var dialogWindow = _reactDom2.default.findDOMNode(this.refs.dialogWindow);
	      var dialogContent = _reactDom2.default.findDOMNode(this.refs.dialogContent);
	      var minPaddingTop = 16;
	
	      // Reset the height in case the window was resized.
	      dialogWindow.style.height = '';
	      dialogContent.style.height = '';
	
	      var dialogWindowHeight = dialogWindow.offsetHeight;
	      var paddingTop = (clientHeight - dialogWindowHeight) / 2 - 64;
	      if (paddingTop < minPaddingTop) paddingTop = minPaddingTop;
	
	      // Vertically center the dialog window, but make sure it doesn't
	      // transition to that position.
	      if (repositionOnUpdate || !container.style.paddingTop) {
	        container.style.paddingTop = paddingTop + 'px';
	      }
	
	      // Force a height if the dialog is taller than clientHeight
	      if (autoDetectWindowHeight || autoScrollBodyContent) {
	        var styles = getStyles(this.props, this.context);
	        styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	        var maxDialogContentHeight = clientHeight - 2 * 64;
	
	        if (title) maxDialogContentHeight -= dialogContent.previousSibling.offsetHeight;
	
	        if (_react2.default.Children.count(actions)) {
	          maxDialogContentHeight -= dialogContent.nextSibling.offsetHeight;
	        }
	
	        dialogContent.style.maxHeight = maxDialogContentHeight + 'px';
	        if (maxDialogContentHeight > dialogWindowHeight) {
	          dialogContent.style.borderBottom = 'none';
	          dialogContent.style.borderTop = 'none';
	        }
	      }
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(buttonClicked) {
	      if (!buttonClicked && this.props.modal) {
	        return;
	      }
	
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(!!buttonClicked);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          actions = _props3.actions,
	          actionsContainerClassName = _props3.actionsContainerClassName,
	          actionsContainerStyle = _props3.actionsContainerStyle,
	          bodyClassName = _props3.bodyClassName,
	          bodyStyle = _props3.bodyStyle,
	          children = _props3.children,
	          className = _props3.className,
	          contentClassName = _props3.contentClassName,
	          contentStyle = _props3.contentStyle,
	          overlayClassName = _props3.overlayClassName,
	          overlayStyle = _props3.overlayStyle,
	          open = _props3.open,
	          paperClassName = _props3.paperClassName,
	          paperProps = _props3.paperProps,
	          style = _props3.style,
	          titleClassName = _props3.titleClassName,
	          titleStyle = _props3.titleStyle,
	          title = _props3.title;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      styles.root = (0, _simpleAssign2.default)(styles.root, style);
	      styles.content = (0, _simpleAssign2.default)(styles.content, contentStyle);
	      styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	      styles.actionsContainer = (0, _simpleAssign2.default)(styles.actionsContainer, actionsContainerStyle);
	      styles.overlay = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
	      styles.title = (0, _simpleAssign2.default)(styles.title, titleStyle);
	
	      var actionsContainer = _react2.default.Children.count(actions) > 0 && _react2.default.createElement(
	        'div',
	        { className: actionsContainerClassName, style: prepareStyles(styles.actionsContainer) },
	        _react2.default.Children.toArray(actions)
	      );
	
	      var titleElement = title;
	      if (_react2.default.isValidElement(title)) {
	        titleElement = _react2.default.cloneElement(title, {
	          className: title.props.className || titleClassName,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.title, title.props.style))
	        });
	      } else if (typeof title === 'string') {
	        titleElement = _react2.default.createElement(
	          'h3',
	          { className: titleClassName, style: prepareStyles(styles.title) },
	          title
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: prepareStyles(styles.root) },
	        open && _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyUp: this.handleKeyUp,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(
	          _TransitionGroup2.default,
	          {
	            component: 'div',
	            ref: 'dialogWindow',
	            transitionAppear: true,
	            transitionAppearTimeout: 450,
	            transitionEnter: true,
	            transitionEnterTimeout: 450
	          },
	          open && _react2.default.createElement(
	            TransitionItem,
	            {
	              className: contentClassName,
	              style: styles.content
	            },
	            _react2.default.createElement(
	              _Paper2.default,
	              (0, _extends3.default)({ className: paperClassName, zDepth: 4 }, paperProps),
	              titleElement,
	              _react2.default.createElement(
	                'div',
	                {
	                  ref: 'dialogContent',
	                  className: bodyClassName,
	                  style: prepareStyles(styles.body)
	                },
	                children
	              ),
	              actionsContainer
	            )
	          )
	        ),
	        _react2.default.createElement(_Overlay2.default, {
	          show: open,
	          className: overlayClassName,
	          style: styles.overlay,
	          onClick: this.handleTouchTapOverlay
	        })
	      );
	    }
	  }]);
	  return DialogInline;
	}(_react.Component);
	
	DialogInline.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	DialogInline.propTypes =  false ? {
	  actions: _propTypes2.default.node,
	  actionsContainerClassName: _propTypes2.default.string,
	  actionsContainerStyle: _propTypes2.default.object,
	  autoDetectWindowHeight: _propTypes2.default.bool,
	  autoScrollBodyContent: _propTypes2.default.bool,
	  bodyClassName: _propTypes2.default.string,
	  bodyStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  contentClassName: _propTypes2.default.string,
	  contentStyle: _propTypes2.default.object,
	  modal: _propTypes2.default.bool,
	  onRequestClose: _propTypes2.default.func,
	  open: _propTypes2.default.bool.isRequired,
	  overlayClassName: _propTypes2.default.string,
	  overlayStyle: _propTypes2.default.object,
	  paperClassName: _propTypes2.default.string,
	  paperProps: _propTypes2.default.object,
	  repositionOnUpdate: _propTypes2.default.bool,
	  style: _propTypes2.default.object,
	  title: _propTypes2.default.node,
	  titleClassName: _propTypes2.default.string,
	  titleStyle: _propTypes2.default.object
	} : {};
	
	var Dialog = function (_Component3) {
	  (0, _inherits3.default)(Dialog, _Component3);
	
	  function Dialog() {
	    var _ref3;
	
	    var _temp3, _this3, _ret3;
	
	    (0, _classCallCheck3.default)(this, Dialog);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Dialog.__proto__ || (0, _getPrototypeOf2.default)(Dialog)).call.apply(_ref3, [this].concat(args))), _this3), _this3.renderLayer = function () {
	      return _react2.default.createElement(DialogInline, _this3.props);
	    }, _temp3), (0, _possibleConstructorReturn3.default)(_this3, _ret3);
	  }
	
	  (0, _createClass3.default)(Dialog, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_RenderToLayer2.default, { render: this.renderLayer, open: true, useLayerForClickAway: false });
	    }
	  }]);
	  return Dialog;
	}(_react.Component);
	
	Dialog.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Dialog.defaultProps = {
	  autoDetectWindowHeight: true,
	  autoScrollBodyContent: false,
	  modal: false,
	  repositionOnUpdate: true
	};
	Dialog.propTypes =  false ? {
	  /**
	   * Action buttons to display below the Dialog content (`children`).
	   * This property accepts either a React element, or an array of React elements.
	   */
	  actions: _propTypes2.default.node,
	  /**
	   * The `className` to add to the actions container's root element.
	   */
	  actionsContainerClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the actions container's root element.
	   */
	  actionsContainerStyle: _propTypes2.default.object,
	  /**
	   * If set to true, the height of the `Dialog` will be auto detected. A max height
	   * will be enforced so that the content does not extend beyond the viewport.
	   */
	  autoDetectWindowHeight: _propTypes2.default.bool,
	  /**
	   * If set to true, the body content of the `Dialog` will be scrollable.
	   */
	  autoScrollBodyContent: _propTypes2.default.bool,
	  /**
	   * The `className` to add to the content's root element under the title.
	   */
	  bodyClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the content's root element under the title.
	   */
	  bodyStyle: _propTypes2.default.object,
	  /**
	   * The contents of the `Dialog`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The `className` to add to the content container.
	   */
	  contentClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the content container.
	   */
	  contentStyle: _propTypes2.default.object,
	  /**
	   * Force the user to use one of the actions in the `Dialog`.
	   * Clicking outside the `Dialog` will not trigger the `onRequestClose`.
	   */
	  modal: _propTypes2.default.bool,
	  /**
	   * Fired when the `Dialog` is requested to be closed by a click outside the `Dialog` or on the buttons.
	   *
	   * @param {bool} buttonClicked Determines whether a button click triggered this request.
	   */
	  onRequestClose: _propTypes2.default.func,
	  /**
	   * Controls whether the Dialog is opened or not.
	   */
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * The `className` to add to the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayStyle: _propTypes2.default.object,
	  /**
	   * The CSS class name of the `Paper` element.
	   */
	  paperClassName: _propTypes2.default.string,
	  /**
	   * Properties applied to the `Paper` element.
	   */
	  paperProps: _propTypes2.default.object,
	  /**
	   * Determines whether the `Dialog` should be repositioned when it's contents are updated.
	   */
	  repositionOnUpdate: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The title to display on the `Dialog`. Could be number, string, element or an array containing these types.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * The `className` to add to the title's root container element.
	   */
	  titleClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the title's root container element.
	   */
	  titleStyle: _propTypes2.default.object
	} : {};
	exports.default = Dialog;

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Divider = function Divider(props, context) {
	  var inset = props.inset,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['inset', 'style']);
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      prepareStyles = _context$muiTheme.prepareStyles;
	
	
	  var styles = {
	    root: {
	      margin: 0,
	      marginTop: -1,
	      marginLeft: inset ? 72 : 0,
	      height: 1,
	      border: 'none',
	      backgroundColor: baseTheme.palette.borderColor
	    }
	  };
	
	  return _react2.default.createElement('hr', (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }));
	};
	
	Divider.muiName = 'Divider';
	
	Divider.propTypes =  false ? {
	  /**
	   * If true, the `Divider` will be indented.
	   */
	  inset: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	Divider.defaultProps = {
	  inset: false
	};
	
	Divider.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Divider;

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(165);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(99);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _autoPrefix = __webpack_require__(213);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Overlay = __webpack_require__(768);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _Paper = __webpack_require__(106);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _propTypes3 = __webpack_require__(118);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var openNavEventHandler = null;
	
	var Drawer = function (_Component) {
	  (0, _inherits3.default)(Drawer, _Component);
	
	  function Drawer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Drawer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Drawer.__proto__ || (0, _getPrototypeOf2.default)(Drawer)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapOverlay = function (event) {
	      event.preventDefault();
	      _this.close('clickaway');
	    }, _this.handleKeyUp = function (event) {
	      if (_this.state.open && !_this.props.docked && (0, _keycode2.default)(event) === 'esc') {
	        _this.close('escape');
	      }
	    }, _this.onBodyTouchStart = function (event) {
	      var swipeAreaWidth = _this.props.swipeAreaWidth;
	
	      var touchStartX = _this.context.muiTheme.isRtl ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
	      var touchStartY = event.touches[0].pageY;
	
	      // Open only if swiping from far left (or right) while closed
	      if (swipeAreaWidth !== null && !_this.state.open) {
	        if (_this.props.openSecondary) {
	          // If openSecondary is true calculate from the far right
	          if (touchStartX < document.body.offsetWidth - swipeAreaWidth) return;
	        } else {
	          // If openSecondary is false calculate from the far left
	          if (touchStartX > swipeAreaWidth) return;
	        }
	      }
	
	      if (!_this.state.open && (openNavEventHandler !== _this.onBodyTouchStart || _this.props.disableSwipeToOpen)) {
	        return;
	      }
	
	      _this.maybeSwiping = true;
	      _this.touchStartX = touchStartX;
	      _this.touchStartY = touchStartY;
	
	      document.body.addEventListener('touchmove', _this.onBodyTouchMove);
	      document.body.addEventListener('touchend', _this.onBodyTouchEnd);
	      document.body.addEventListener('touchcancel', _this.onBodyTouchEnd);
	    }, _this.onBodyTouchMove = function (event) {
	      var currentX = _this.context.muiTheme.isRtl ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
	      var currentY = event.touches[0].pageY;
	
	      if (_this.state.swiping) {
	        event.preventDefault();
	        _this.setPosition(_this.getTranslateX(currentX));
	      } else if (_this.maybeSwiping) {
	        var dXAbs = Math.abs(currentX - _this.touchStartX);
	        var dYAbs = Math.abs(currentY - _this.touchStartY);
	        // If the user has moved his thumb ten pixels in either direction,
	        // we can safely make an assumption about whether he was intending
	        // to swipe or scroll.
	        var threshold = 10;
	
	        if (dXAbs > threshold && dYAbs <= threshold) {
	          _this.swipeStartX = currentX;
	          _this.setState({
	            swiping: _this.state.open ? 'closing' : 'opening'
	          });
	          _this.setPosition(_this.getTranslateX(currentX));
	        } else if (dXAbs <= threshold && dYAbs > threshold) {
	          _this.onBodyTouchEnd();
	        }
	      }
	    }, _this.onBodyTouchEnd = function (event) {
	      if (_this.state.swiping) {
	        var currentX = _this.context.muiTheme.isRtl ? document.body.offsetWidth - event.changedTouches[0].pageX : event.changedTouches[0].pageX;
	        var translateRatio = _this.getTranslateX(currentX) / _this.getMaxTranslateX();
	
	        _this.maybeSwiping = false;
	        var swiping = _this.state.swiping;
	        _this.setState({
	          swiping: null
	        });
	
	        // We have to open or close after setting swiping to null,
	        // because only then CSS transition is enabled.
	        if (translateRatio > 0.5) {
	          if (swiping === 'opening') {
	            _this.setPosition(_this.getMaxTranslateX());
	          } else {
	            _this.close('swipe');
	          }
	        } else {
	          if (swiping === 'opening') {
	            _this.open('swipe');
	          } else {
	            _this.setPosition(0);
	          }
	        }
	      } else {
	        _this.maybeSwiping = false;
	      }
	
	      _this.removeBodyTouchListeners();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Drawer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.maybeSwiping = false;
	      this.touchStartX = null;
	      this.touchStartY = null;
	      this.swipeStartX = null;
	
	      this.setState({
	        open: this.props.open !== null ? this.props.open : this.props.docked,
	        swiping: null
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.enableSwipeHandling();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // If controlled then the open prop takes precedence.
	      if (nextProps.open !== null) {
	        this.setState({
	          open: nextProps.open
	        });
	        // Otherwise, if docked is changed, change the open state for when uncontrolled.
	      } else if (this.props.docked !== nextProps.docked) {
	        this.setState({
	          open: nextProps.docked
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.enableSwipeHandling();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.disableSwipeHandling();
	      this.removeBodyTouchListeners();
	    }
	  }, {
	    key: 'getStyles',
	    value: function getStyles() {
	      var muiTheme = this.context.muiTheme;
	      var theme = muiTheme.drawer;
	
	      var x = this.getTranslateMultiplier() * (this.state.open ? 0 : this.getMaxTranslateX());
	
	      var styles = {
	        root: {
	          height: '100%',
	          width: this.getTranslatedWidth() || theme.width,
	          position: 'fixed',
	          zIndex: muiTheme.zIndex.drawer,
	          left: 0,
	          top: 0,
	          transform: 'translate(' + x + 'px, 0)',
	          transition: !this.state.swiping && _transitions2.default.easeOut(null, 'transform', null),
	          backgroundColor: theme.color,
	          overflow: 'auto',
	          WebkitOverflowScrolling: 'touch' // iOS momentum scrolling
	        },
	        overlay: {
	          zIndex: muiTheme.zIndex.drawerOverlay,
	          pointerEvents: this.state.open ? 'auto' : 'none' // Bypass mouse events when left nav is closing.
	        },
	        rootWhenOpenRight: {
	          left: 'auto',
	          right: 0
	        }
	      };
	
	      return styles;
	    }
	  }, {
	    key: 'shouldShow',
	    value: function shouldShow() {
	      return this.state.open || !!this.state.swiping; // component is swiping
	    }
	  }, {
	    key: 'close',
	    value: function close(reason) {
	      if (this.props.open === null) this.setState({ open: false });
	      if (this.props.onRequestChange) this.props.onRequestChange(false, reason);
	      return this;
	    }
	  }, {
	    key: 'open',
	    value: function open(reason) {
	      if (this.props.open === null) this.setState({ open: true });
	      if (this.props.onRequestChange) this.props.onRequestChange(true, reason);
	      return this;
	    }
	  }, {
	    key: 'getTranslatedWidth',
	    value: function getTranslatedWidth() {
	      if (typeof this.props.width === 'string') {
	        if (!/^\d+(\.\d+)?%$/.test(this.props.width)) {
	          throw new Error('Not a valid percentage format.');
	        }
	        var width = parseFloat(this.props.width) / 100.0;
	        // We are doing our best on the Server to render a consistent UI, hence the
	        // default value of 10000
	        return typeof window !== 'undefined' ? width * window.innerWidth : 10000;
	      } else {
	        return this.props.width;
	      }
	    }
	  }, {
	    key: 'getMaxTranslateX',
	    value: function getMaxTranslateX() {
	      var width = this.getTranslatedWidth() || this.context.muiTheme.drawer.width;
	      return width + 10;
	    }
	  }, {
	    key: 'getTranslateMultiplier',
	    value: function getTranslateMultiplier() {
	      return this.props.openSecondary ? 1 : -1;
	    }
	  }, {
	    key: 'enableSwipeHandling',
	    value: function enableSwipeHandling() {
	      if (!this.props.docked) {
	        document.body.addEventListener('touchstart', this.onBodyTouchStart);
	        if (!openNavEventHandler) {
	          openNavEventHandler = this.onBodyTouchStart;
	        }
	      } else {
	        this.disableSwipeHandling();
	      }
	    }
	  }, {
	    key: 'disableSwipeHandling',
	    value: function disableSwipeHandling() {
	      document.body.removeEventListener('touchstart', this.onBodyTouchStart);
	      if (openNavEventHandler === this.onBodyTouchStart) {
	        openNavEventHandler = null;
	      }
	    }
	  }, {
	    key: 'removeBodyTouchListeners',
	    value: function removeBodyTouchListeners() {
	      document.body.removeEventListener('touchmove', this.onBodyTouchMove);
	      document.body.removeEventListener('touchend', this.onBodyTouchEnd);
	      document.body.removeEventListener('touchcancel', this.onBodyTouchEnd);
	    }
	  }, {
	    key: 'setPosition',
	    value: function setPosition(translateX) {
	      var rtlTranslateMultiplier = this.context.muiTheme.isRtl ? -1 : 1;
	      var drawer = _reactDom2.default.findDOMNode(this.refs.clickAwayableElement);
	      var transformCSS = 'translate(' + this.getTranslateMultiplier() * rtlTranslateMultiplier * translateX + 'px, 0)';
	      this.refs.overlay.setOpacity(1 - translateX / this.getMaxTranslateX());
	      _autoPrefix2.default.set(drawer.style, 'transform', transformCSS);
	    }
	  }, {
	    key: 'getTranslateX',
	    value: function getTranslateX(currentX) {
	      return Math.min(Math.max(this.state.swiping === 'closing' ? this.getTranslateMultiplier() * (currentX - this.swipeStartX) : this.getMaxTranslateX() - this.getTranslateMultiplier() * (this.swipeStartX - currentX), 0), this.getMaxTranslateX());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          containerClassName = _props.containerClassName,
	          containerStyle = _props.containerStyle,
	          docked = _props.docked,
	          openSecondary = _props.openSecondary,
	          overlayClassName = _props.overlayClassName,
	          overlayStyle = _props.overlayStyle,
	          style = _props.style,
	          zDepth = _props.zDepth;
	
	
	      var styles = this.getStyles();
	
	      var overlay = void 0;
	      if (!docked) {
	        overlay = _react2.default.createElement(_Overlay2.default, {
	          ref: 'overlay',
	          show: this.shouldShow(),
	          className: overlayClassName,
	          style: (0, _simpleAssign2.default)(styles.overlay, overlayStyle),
	          transitionEnabled: !this.state.swiping,
	          onClick: this.handleTouchTapOverlay
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: className,
	          style: style
	        },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
	        overlay,
	        _react2.default.createElement(
	          _Paper2.default,
	          {
	            ref: 'clickAwayableElement',
	            zDepth: zDepth,
	            rounded: false,
	            transitionEnabled: !this.state.swiping,
	            className: containerClassName,
	            style: (0, _simpleAssign2.default)(styles.root, openSecondary && styles.rootWhenOpenRight, containerStyle)
	          },
	          children
	        )
	      );
	    }
	  }]);
	  return Drawer;
	}(_react.Component);
	
	Drawer.defaultProps = {
	  disableSwipeToOpen: false,
	  docked: true,
	  open: null,
	  openSecondary: false,
	  swipeAreaWidth: 30,
	  width: null,
	  zDepth: 2
	};
	Drawer.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Drawer.propTypes =  false ? {
	  /**
	   * The contents of the `Drawer`
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The CSS class name of the container element.
	   */
	  containerClassName: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the container element.
	   */
	  containerStyle: _propTypes2.default.object,
	  /**
	   * If true, swiping sideways when the `Drawer` is closed will not open it.
	   */
	  disableSwipeToOpen: _propTypes2.default.bool,
	  /**
	   * If true, the `Drawer` will be docked. In this state, the overlay won't show and
	   * clicking on a menu item will not close the `Drawer`.
	   */
	  docked: _propTypes2.default.bool,
	  /**
	   * Callback function fired when the `open` state of the `Drawer` is requested to be changed.
	   *
	   * @param {boolean} open If true, the `Drawer` was requested to be opened.
	   * @param {string} reason The reason for the open or close request. Possible values are
	   * 'swipe' for open requests; 'clickaway' (on overlay clicks),
	   * 'escape' (on escape key press), and 'swipe' for close requests.
	   */
	  onRequestChange: _propTypes2.default.func,
	  /**
	   * If true, the `Drawer` is opened.  Providing a value will turn the `Drawer`
	   * into a controlled component.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * If true, the `Drawer` is positioned to open from the opposite side.
	   */
	  openSecondary: _propTypes2.default.bool,
	  /**
	   * The CSS class name to add to the `Overlay` component that is rendered behind the `Drawer`.
	   */
	  overlayClassName: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the `Overlay` component that is rendered behind the `Drawer`.
	   */
	  overlayStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The width of the left most (or right most) area in pixels where the `Drawer` can be
	   * swiped open from. Setting this to `null` spans that area to the entire page
	   * (**CAUTION!** Setting this property to `null` might cause issues with sliders and
	   * swipeable `Tabs`: use at your own risk).
	   */
	  swipeAreaWidth: _propTypes2.default.number,
	  /**
	   * The width of the `Drawer` in pixels or percentage in string format ex. `50%` to fill
	   * half of the window or `100%` and so on. Defaults to using the values from theme.
	   */
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * The zDepth of the `Drawer`.
	   */
	  zDepth: _propTypes4.default.zDepth
	
	} : {};
	exports.default = Drawer;

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _arrowDropDown = __webpack_require__(1606);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _Menu = __webpack_require__(360);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _ClearFix = __webpack_require__(1567);
	
	var _ClearFix2 = _interopRequireDefault(_ClearFix);
	
	var _Popover = __webpack_require__(242);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _PopoverAnimationVertical = __webpack_require__(492);
	
	var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);
	
	var _keycode = __webpack_require__(99);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _events = __webpack_require__(363);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _IconButton = __webpack_require__(126);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _propTypes3 = __webpack_require__(118);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var disabled = props.disabled;
	
	  var spacing = context.muiTheme.baseTheme.spacing;
	  var palette = context.muiTheme.baseTheme.palette;
	  var accentColor = context.muiTheme.dropDownMenu.accentColor;
	  return {
	    control: {
	      cursor: disabled ? 'not-allowed' : 'pointer',
	      height: '100%',
	      position: 'relative',
	      width: '100%'
	    },
	    icon: {
	      fill: accentColor,
	      position: 'absolute',
	      right: spacing.desktopGutterLess,
	      top: (spacing.iconSize - 24) / 2 + spacing.desktopGutterMini / 2
	    },
	    iconChildren: {
	      fill: 'inherit'
	    },
	    label: {
	      color: disabled ? palette.disabledColor : palette.textColor,
	      height: spacing.desktopToolbarHeight + 'px',
	      lineHeight: spacing.desktopToolbarHeight + 'px',
	      overflow: 'hidden',
	      opacity: 1,
	      position: 'relative',
	      paddingLeft: spacing.desktopGutter,
	      paddingRight: spacing.iconSize * 2 + spacing.desktopGutterMini,
	      textOverflow: 'ellipsis',
	      top: 0,
	      whiteSpace: 'nowrap'
	    },
	    labelWhenOpen: {
	      opacity: 0,
	      top: spacing.desktopToolbarHeight / 8
	    },
	    root: {
	      display: 'inline-block',
	      fontSize: spacing.desktopDropDownMenuFontSize,
	      height: spacing.desktopSubheaderHeight,
	      fontFamily: context.muiTheme.baseTheme.fontFamily,
	      outline: 'none',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	    rootWhenOpen: {
	      opacity: 1
	    },
	    underline: {
	      borderTop: 'solid 1px ' + accentColor,
	      bottom: 1,
	      left: 0,
	      margin: '-1px ' + spacing.desktopGutter + 'px',
	      right: 0,
	      position: 'absolute'
	    }
	  };
	}
	
	var DropDownMenu = function (_Component) {
	  (0, _inherits3.default)(DropDownMenu, _Component);
	
	  function DropDownMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DropDownMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropDownMenu.__proto__ || (0, _getPrototypeOf2.default)(DropDownMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.rootNode = undefined, _this.arrowNode = undefined, _this.handleTouchTapControl = function (event) {
	      event.preventDefault();
	      if (!_this.props.disabled) {
	        _this.setState({
	          open: !_this.state.open,
	          anchorEl: _this.rootNode
	        });
	      }
	    }, _this.handleRequestCloseMenu = function () {
	      _this.close(false);
	    }, _this.handleEscKeyDownMenu = function () {
	      _this.close(true);
	    }, _this.handleKeyDown = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'up':
	        case 'down':
	        case 'space':
	        case 'enter':
	          event.preventDefault();
	          _this.setState({
	            open: true,
	            anchorEl: _this.rootNode
	          });
	          break;
	      }
	    }, _this.handleItemTouchTap = function (event, child, index) {
	      if (_this.props.multiple) {
	        if (!_this.state.open) {
	          _this.setState({ open: true });
	        }
	      } else {
	        event.persist();
	        _this.setState({
	          open: false
	        }, function () {
	          if (_this.props.onChange) {
	            _this.props.onChange(event, index, child.props.value);
	          }
	
	          _this.close(_events2.default.isKeyboard(event));
	        });
	      }
	    }, _this.handleChange = function (event, value) {
	      if (_this.props.multiple && _this.props.onChange) {
	        _this.props.onChange(event, undefined, value);
	      }
	    }, _this.close = function (isKeyboard) {
	      _this.setState({
	        open: false
	      }, function () {
	        if (_this.props.onClose) {
	          _this.props.onClose();
	        }
	
	        if (isKeyboard) {
	          var dropArrow = _this.arrowNode;
	          var dropNode = _reactDom2.default.findDOMNode(dropArrow);
	          dropNode.focus();
	          dropArrow.setKeyboardFocus(true);
	        }
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  // The nested styles for drop-down-menu are modified by toolbar and possibly
	  // other user components, so it will give full access to its js styles rather
	  // than just the parent.
	
	
	  (0, _createClass3.default)(DropDownMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      if (this.props.openImmediately) {
	        // TODO: Temporary fix to make openImmediately work with popover.
	        /* eslint-disable react/no-did-mount-set-state */
	        setTimeout(function () {
	          return _this2.setState({
	            open: true,
	            anchorEl: _this2.rootNode
	          });
	        }, 0);
	        /* eslint-enable react/no-did-mount-set-state */
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	    }
	  }, {
	    key: 'getInputNode',
	
	
	    /**
	     * This method is deprecated but still here because the TextField
	     * need it in order to work. TODO: That will be addressed later.
	     */
	    value: function getInputNode() {
	      var _this3 = this;
	
	      var rootNode = this.rootNode;
	
	      rootNode.focus = function () {
	        if (!_this3.props.disabled) {
	          _this3.setState({
	            open: !_this3.state.open,
	            anchorEl: _this3.rootNode
	          });
	        }
	      };
	
	      return rootNode;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = this.rootNode;
	      if (!this.props.style || !this.props.style.hasOwnProperty('width')) {
	        el.style.width = 'auto';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          animated = _props.animated,
	          animation = _props.animation,
	          autoWidth = _props.autoWidth,
	          multiple = _props.multiple,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          iconStyle = _props.iconStyle,
	          labelStyle = _props.labelStyle,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          menuStyleProp = _props.menuStyle,
	          selectionRenderer = _props.selectionRenderer,
	          onClose = _props.onClose,
	          openImmediately = _props.openImmediately,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          style = _props.style,
	          underlineStyle = _props.underlineStyle,
	          value = _props.value,
	          iconButton = _props.iconButton,
	          anchorOrigin = _props.anchorOrigin,
	          targetOrigin = _props.targetOrigin,
	          other = (0, _objectWithoutProperties3.default)(_props, ['animated', 'animation', 'autoWidth', 'multiple', 'children', 'className', 'disabled', 'iconStyle', 'labelStyle', 'listStyle', 'maxHeight', 'menuStyle', 'selectionRenderer', 'onClose', 'openImmediately', 'menuItemStyle', 'selectedMenuItemStyle', 'style', 'underlineStyle', 'value', 'iconButton', 'anchorOrigin', 'targetOrigin']);
	      var _state = this.state,
	          anchorEl = _state.anchorEl,
	          open = _state.open;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var displayValue = '';
	      if (!multiple) {
	        _react2.default.Children.forEach(children, function (child) {
	          if (child && value === child.props.value) {
	            if (selectionRenderer) {
	              displayValue = selectionRenderer(value, child);
	            } else {
	              // This will need to be improved (in case primaryText is a node)
	              displayValue = child.props.label || child.props.primaryText;
	            }
	          }
	        });
	      } else {
	        var values = [];
	        var selectionRendererChildren = [];
	        _react2.default.Children.forEach(children, function (child) {
	          if (child && value && value.indexOf(child.props.value) > -1) {
	            if (selectionRenderer) {
	              values.push(child.props.value);
	              selectionRendererChildren.push(child);
	            } else {
	              values.push(child.props.label || child.props.primaryText);
	            }
	          }
	        });
	
	        displayValue = [];
	        if (selectionRenderer) {
	          displayValue = selectionRenderer(values, selectionRendererChildren);
	        } else {
	          displayValue = values.join(', ');
	        }
	      }
	
	      var menuStyle = void 0;
	      if (anchorEl && !autoWidth) {
	        menuStyle = (0, _simpleAssign2.default)({
	          width: anchorEl.clientWidth
	        }, menuStyleProp);
	      } else {
	        menuStyle = menuStyleProp;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, {
	          ref: function ref(node) {
	            _this4.rootNode = node;
	          },
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, open && styles.rootWhenOpen, style))
	        }),
	        _react2.default.createElement(
	          _ClearFix2.default,
	          { style: styles.control, onClick: this.handleTouchTapControl },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.label, open && styles.labelWhenOpen, labelStyle)) },
	            displayValue
	          ),
	          _react2.default.createElement(
	            _IconButton2.default,
	            {
	              disabled: disabled,
	              onKeyDown: this.handleKeyDown,
	              ref: function ref(node) {
	                _this4.arrowNode = node;
	              },
	              style: (0, _simpleAssign2.default)({}, styles.icon, iconStyle),
	              iconStyle: styles.iconChildren
	            },
	            iconButton
	          ),
	          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.underline, underlineStyle)) })
	        ),
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            anchorEl: anchorEl,
	            animation: animation || _PopoverAnimationVertical2.default,
	            open: open,
	            animated: animated,
	            onRequestClose: this.handleRequestCloseMenu
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            {
	              multiple: multiple,
	              maxHeight: maxHeight,
	              desktop: true,
	              value: value,
	              onEscKeyDown: this.handleEscKeyDownMenu,
	              style: menuStyle,
	              listStyle: listStyle,
	              onItemTouchTap: this.handleItemTouchTap,
	              onChange: this.handleChange,
	              menuItemStyle: menuItemStyle,
	              selectedMenuItemStyle: selectedMenuItemStyle,
	              autoWidth: autoWidth,
	              width: !autoWidth && menuStyle ? menuStyle.width : null
	            },
	            children
	          )
	        )
	      );
	    }
	  }]);
	  return DropDownMenu;
	}(_react.Component);
	
	DropDownMenu.muiName = 'DropDownMenu';
	DropDownMenu.defaultProps = {
	  animated: true,
	  autoWidth: true,
	  disabled: false,
	  iconButton: _react2.default.createElement(_arrowDropDown2.default, null),
	  openImmediately: false,
	  maxHeight: 500,
	  multiple: false,
	  anchorOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  }
	};
	DropDownMenu.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	DropDownMenu.propTypes =  false ? {
	  /**
	   * This is the point on the anchor that the popover's
	   * `targetOrigin` will attach to.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it gets added to the DOM.
	   */
	  animated: _propTypes2.default.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * The width will automatically be set according to the items inside the menu.
	   * To control this width in css instead, set this prop to `false`.
	   */
	  autoWidth: _propTypes2.default.bool,
	  /**
	   * The `MenuItem`s to populate the `Menu` with. If the `MenuItems` have the
	   * prop `label` that value will be used to render the representation of that
	   * item within the field.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Disables the menu.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Overrides default `SvgIcon` dropdown arrow component.
	   */
	  iconButton: _propTypes2.default.node,
	  /**
	   * Overrides the styles of icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Overrides the styles of label when the `DropDownMenu` is inactive.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * The style object to use to override underlying list style.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * The maximum height of the `Menu` when it is displayed.
	   */
	  maxHeight: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _propTypes2.default.object,
	  /**
	   * Overrides the styles of `Menu` when the `DropDownMenu` is displayed.
	   */
	  menuStyle: _propTypes2.default.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _propTypes2.default.bool,
	  /**
	   * Callback function fired when a menu item is clicked, other than the one currently selected.
	   *
	   * @param {object} event TouchTap event targeting the menu item that was clicked.
	   * @param {number} key The index of the clicked menu item in the `children` collection.
	   * @param {any} value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function fired when the menu is closed.
	   */
	  onClose: _propTypes2.default.func,
	  /**
	   * Set to true to have the `DropDownMenu` automatically open on mount.
	   */
	  openImmediately: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _propTypes2.default.object,
	  /**
	   * Callback function fired when a menu item is clicked, other than the one currently selected.
	   *
	   * @param {any} value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   * @param {any} menuItem The selected `MenuItem`.
	   * If `multiple` is true, this will be an array with the `MenuItem`s matching the `value`s parameter.
	   */
	  selectionRenderer: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * This is the point on the popover which will attach to
	   * the anchor's origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * Overrides the inline-styles of the underline.
	   */
	  underlineStyle: _propTypes2.default.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = DropDownMenu;

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(187);
	
	var _EnhancedButton = __webpack_require__(139);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FlatButtonLabel = __webpack_require__(1519);
	
	var _FlatButtonLabel2 = _interopRequireDefault(_FlatButtonLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	var FlatButton = function (_Component) {
	  (0, _inherits3.default)(FlatButton, _Component);
	
	  function FlatButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FlatButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FlatButton.__proto__ || (0, _getPrototypeOf2.default)(FlatButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FlatButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled) {
	        this.setState({
	          hovered: false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          children = _props.children,
	          disabled = _props.disabled,
	          fullWidth = _props.fullWidth,
	          hoverColor = _props.hoverColor,
	          icon = _props.icon,
	          label = _props.label,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          primary = _props.primary,
	          rippleColor = _props.rippleColor,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'children', 'disabled', 'fullWidth', 'hoverColor', 'icon', 'label', 'labelStyle', 'labelPosition', 'primary', 'rippleColor', 'secondary', 'style']);
	      var _context$muiTheme = this.context.muiTheme,
	          borderRadius = _context$muiTheme.borderRadius,
	          _context$muiTheme$but = _context$muiTheme.button,
	          buttonHeight = _context$muiTheme$but.height,
	          buttonMinWidth = _context$muiTheme$but.minWidth,
	          buttonTextTransform = _context$muiTheme$but.textTransform,
	          _context$muiTheme$fla = _context$muiTheme.flatButton,
	          buttonFilterColor = _context$muiTheme$fla.buttonFilterColor,
	          buttonColor = _context$muiTheme$fla.color,
	          disabledTextColor = _context$muiTheme$fla.disabledTextColor,
	          fontSize = _context$muiTheme$fla.fontSize,
	          fontWeight = _context$muiTheme$fla.fontWeight,
	          primaryTextColor = _context$muiTheme$fla.primaryTextColor,
	          secondaryTextColor = _context$muiTheme$fla.secondaryTextColor,
	          textColor = _context$muiTheme$fla.textColor,
	          _context$muiTheme$fla2 = _context$muiTheme$fla.textTransform,
	          textTransform = _context$muiTheme$fla2 === undefined ? buttonTextTransform || 'uppercase' : _context$muiTheme$fla2;
	
	      var defaultTextColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;
	
	      var defaultHoverColor = (0, _colorManipulator.fade)(buttonFilterColor, 0.2);
	      var defaultRippleColor = buttonFilterColor;
	      var buttonHoverColor = hoverColor || defaultHoverColor;
	      var buttonRippleColor = rippleColor || defaultRippleColor;
	      var buttonBackgroundColor = backgroundColor || buttonColor;
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        height: buttonHeight,
	        lineHeight: buttonHeight + 'px',
	        minWidth: fullWidth ? '100%' : buttonMinWidth,
	        color: defaultTextColor,
	        transition: _transitions2.default.easeOut(),
	        borderRadius: borderRadius,
	        userSelect: 'none',
	        overflow: 'hidden',
	        backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
	        padding: 0,
	        margin: 0,
	        textAlign: 'center'
	      }, style);
	
	      var iconCloned = void 0;
	      var labelStyleIcon = {};
	
	      if (icon) {
	        var iconStyles = (0, _simpleAssign2.default)({
	          verticalAlign: 'middle',
	          marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	          marginRight: label && labelPosition === 'before' ? 12 : 0
	        }, icon.props.style);
	        iconCloned = _react2.default.cloneElement(icon, {
	          color: icon.props.color || mergedRootStyles.color,
	          style: iconStyles,
	          key: 'iconCloned'
	        });
	
	        if (labelPosition === 'before') {
	          labelStyleIcon.paddingRight = 8;
	        } else {
	          labelStyleIcon.paddingLeft = 8;
	        }
	      }
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({
	        letterSpacing: 0,
	        textTransform: textTransform,
	        fontWeight: fontWeight,
	        fontSize: fontSize
	      }, labelStyleIcon, labelStyle);
	
	      var labelElement = label ? _react2.default.createElement(_FlatButtonLabel2.default, { key: 'labelElement', label: label, style: mergedLabelStyles }) : undefined;
	
	      // Place label before or after children.
	      var enhancedButtonChildren = labelPosition === 'before' ? [labelElement, iconCloned, children] : [children, iconCloned, labelElement];
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          focusRippleColor: buttonRippleColor,
	          focusRippleOpacity: 0.3,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          touchRippleColor: buttonRippleColor,
	          touchRippleOpacity: 0.3
	        }),
	        enhancedButtonChildren
	      );
	    }
	  }]);
	  return FlatButton;
	}(_react.Component);
	
	FlatButton.muiName = 'FlatButton';
	FlatButton.defaultProps = {
	  disabled: false,
	  fullWidth: false,
	  labelStyle: {},
	  labelPosition: 'after',
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onTouchStart: function onTouchStart() {},
	  primary: false,
	  secondary: false
	};
	FlatButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	FlatButton.propTypes =  false ? {
	  /**
	   * Color of button when mouse is not hovering over it.
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * This is what will be displayed inside the button.
	   * If a label is specified, the text within the label prop will
	   * be displayed. Otherwise, the component will expect children
	   * which will then be displayed. (In our example,
	   * we are nesting an `<input type="file" />` and a `span`
	   * that acts as our label to be displayed.) This only
	   * applies to flat and raised buttons.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The element to use as the container for the FlatButton. Either a string to
	   * use a DOM element or a ReactElement. This is useful for wrapping the
	   * FlatButton in a custom Link component. If a ReactElement is given, ensure
	   * that it passes all of its given props through to the underlying DOM
	   * element and renders its children prop for proper integration.
	   */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes2.default.bool,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If true, the button will take up the full width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Color of button when mouse hovers over.
	   */
	  hoverColor: _propTypes2.default.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * Use this property to display an icon.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * Label for the button.
	   */
	  label: validateLabel,
	  /**
	   * Place label before or after the passed children.
	   */
	  labelPosition: _propTypes2.default.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Callback function fired when the button is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the button.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} isKeyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * If true, colors button according to
	   * primaryTextColor from the Theme.
	   */
	  primary: _propTypes2.default.bool,
	  /**
	   * Color for the ripple after button is clicked.
	   */
	  rippleColor: _propTypes2.default.string,
	  /**
	   * If true, colors button according to secondaryTextColor from the theme.
	   * The primary prop has precendent if set to true.
	   */
	  secondary: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = FlatButton;

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      position: 'relative',
	      paddingLeft: baseTheme.spacing.desktopGutterLess,
	      paddingRight: baseTheme.spacing.desktopGutterLess,
	      verticalAlign: 'middle'
	    }
	  };
	}
	
	var FlatButtonLabel = function (_Component) {
	  (0, _inherits3.default)(FlatButtonLabel, _Component);
	
	  function FlatButtonLabel() {
	    (0, _classCallCheck3.default)(this, FlatButtonLabel);
	    return (0, _possibleConstructorReturn3.default)(this, (FlatButtonLabel.__proto__ || (0, _getPrototypeOf2.default)(FlatButtonLabel)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FlatButtonLabel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        label
	      );
	    }
	  }]);
	  return FlatButtonLabel;
	}(_react.Component);
	
	FlatButtonLabel.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	FlatButtonLabel.propTypes =  false ? {
	  label: _propTypes2.default.node,
	  style: _propTypes2.default.object
	} : {};
	exports.default = FlatButtonLabel;

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(187);
	
	var _EnhancedButton = __webpack_require__(139);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(164);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Paper = __webpack_require__(106);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _childUtils = __webpack_require__(783);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes3 = __webpack_require__(118);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var floatingActionButton = context.muiTheme.floatingActionButton;
	
	
	  var backgroundColor = props.backgroundColor || floatingActionButton.color;
	  var iconColor = floatingActionButton.iconColor;
	
	  if (props.disabled) {
	    backgroundColor = props.disabledColor || floatingActionButton.disabledColor;
	    iconColor = floatingActionButton.disabledTextColor;
	  } else if (props.secondary) {
	    backgroundColor = floatingActionButton.secondaryColor;
	    iconColor = floatingActionButton.secondaryIconColor;
	  }
	
	  return {
	    root: {
	      transition: _transitions2.default.easeOut(),
	      display: 'inline-block',
	      backgroundColor: 'transparent'
	    },
	    container: {
	      backgroundColor: backgroundColor,
	      transition: _transitions2.default.easeOut(),
	      height: floatingActionButton.buttonSize,
	      width: floatingActionButton.buttonSize,
	      padding: 0,
	      overflow: 'hidden',
	      borderRadius: '50%',
	      textAlign: 'center',
	      verticalAlign: 'bottom'
	    },
	    containerWhenMini: {
	      height: floatingActionButton.miniSize,
	      width: floatingActionButton.miniSize
	    },
	    overlay: {
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    overlayWhenHovered: {
	      backgroundColor: (0, _colorManipulator.fade)(iconColor, 0.4)
	    },
	    icon: {
	      height: floatingActionButton.buttonSize,
	      lineHeight: floatingActionButton.buttonSize + 'px',
	      fill: iconColor,
	      color: iconColor
	    },
	    iconWhenMini: {
	      height: floatingActionButton.miniSize,
	      lineHeight: floatingActionButton.miniSize + 'px'
	    }
	  };
	}
	
	var FloatingActionButton = function (_Component) {
	  (0, _inherits3.default)(FloatingActionButton, _Component);
	
	  function FloatingActionButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FloatingActionButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FloatingActionButton.__proto__ || (0, _getPrototypeOf2.default)(FloatingActionButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touch: false,
	      zDepth: undefined
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({ zDepth: _this.props.zDepth + 1 });
	      }
	      if (_this.props.onMouseDown) _this.props.onMouseDown(event);
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({ zDepth: _this.props.zDepth });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.refs.container.isKeyboardFocused()) {
	        _this.setState({ zDepth: _this.props.zDepth, hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.refs.container.isKeyboardFocused() && !_this.state.touch) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touch: true,
	        zDepth: _this.props.zDepth + 1
	      });
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({
	        touch: true,
	        zDepth: _this.props.zDepth
	      });
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (keyboardFocused && !_this.props.disabled) {
	        _this.setState({ zDepth: _this.props.zDepth + 1 });
	        _this.refs.overlay.style.backgroundColor = (0, _colorManipulator.fade)(getStyles(_this.props, _this.context).icon.color, 0.4);
	      } else if (!_this.state.hovered) {
	        _this.setState({ zDepth: _this.props.zDepth });
	        _this.refs.overlay.style.backgroundColor = 'transparent';
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FloatingActionButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        zDepth: this.props.disabled ? 0 : this.props.zDepth
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	       false ? (0, _warning2.default)(!this.props.iconClassName || !this.props.children, 'Material-UI: You have set both an iconClassName and a child icon. ' + 'It is recommended you use only one method when adding ' + 'icons to FloatingActionButtons.') : void 0;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var nextState = {};
	
	      if (nextProps.disabled !== this.props.disabled) {
	        nextState.zDepth = nextProps.disabled ? 0 : this.props.zDepth;
	      }
	      if (nextProps.disabled) {
	        nextState.hovered = false;
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          className = _props.className,
	          childrenProp = _props.children,
	          disabled = _props.disabled,
	          disabledColor = _props.disabledColor,
	          mini = _props.mini,
	          secondary = _props.secondary,
	          iconStyle = _props.iconStyle,
	          iconClassName = _props.iconClassName,
	          zDepth = _props.zDepth,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'className', 'children', 'disabled', 'disabledColor', 'mini', 'secondary', 'iconStyle', 'iconClassName', 'zDepth']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var iconElement = void 0;
	      if (iconClassName) {
	        iconElement = _react2.default.createElement(_FontIcon2.default, {
	          className: iconClassName,
	          style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle)
	        });
	      }
	
	      var children = void 0;
	
	      if (childrenProp) {
	        children = (0, _childUtils.extendChildren)(childrenProp, function (child) {
	          return {
	            style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle, child.props.style)
	          };
	        });
	      }
	
	      var buttonEventHandlers = disabled ? null : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          zDepth: this.state.zDepth,
	          circle: true
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.container, this.props.mini && styles.containerWhenMini, iconStyle),
	            focusRippleColor: styles.icon.color,
	            touchRippleColor: styles.icon.color
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, this.state.hovered && !this.props.disabled && styles.overlayWhenHovered))
	            },
	            iconElement,
	            children
	          )
	        )
	      );
	    }
	  }]);
	  return FloatingActionButton;
	}(_react.Component);
	
	FloatingActionButton.defaultProps = {
	  disabled: false,
	  mini: false,
	  secondary: false,
	  zDepth: 2
	};
	FloatingActionButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	FloatingActionButton.propTypes =  false ? {
	  /**
	   * This value will override the default background color for the button.
	   * However it will not override the default disabled background color.
	   * This has to be set separately using the disabledColor attribute.
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * This is what displayed inside the floating action button; for example, a SVG Icon.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * This value will override the default background color for the button when it is disabled.
	   */
	  disabledColor: _propTypes2.default.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * The icon within the FloatingActionButton is a FontIcon component.
	   * This property is the classname of the icon to be displayed inside the button.
	   * An alternative to adding an iconClassName would be to manually insert a
	   * FontIcon component or custom SvgIcon component or as a child of FloatingActionButton.
	   */
	  iconClassName: _propTypes2.default.string,
	  /**
	   * This is the equivalent to iconClassName except that it is used for
	   * overriding the inline-styles of the FontIcon component.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * If true, the button will be a small floating action button.
	   */
	  mini: _propTypes2.default.bool,
	  /**
	   * Callback function fired when the button is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the button.
	   */
	  onClick: _propTypes2.default.func,
	  /** @ignore */
	  onMouseDown: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseUp: _propTypes2.default.func,
	  /** @ignore */
	  onTouchEnd: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * If true, the button will use the secondary button colors.
	   */
	  secondary: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The zDepth of the underlying `Paper` component.
	   */
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = FloatingActionButton;

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FloatingActionButton = __webpack_require__(1520);
	
	var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FloatingActionButton2.default;

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var color = props.color,
	      hoverColor = props.hoverColor;
	  var baseTheme = context.muiTheme.baseTheme;
	
	  var offColor = color || baseTheme.palette.textColor;
	  var onColor = hoverColor || offColor;
	
	  return {
	    root: {
	      color: state.hovered ? onColor : offColor,
	      position: 'relative',
	      fontSize: baseTheme.spacing.iconSize,
	      display: 'inline-block',
	      userSelect: 'none',
	      transition: _transitions2.default.easeOut()
	    }
	  };
	}
	
	var FontIcon = function (_Component) {
	  (0, _inherits3.default)(FontIcon, _Component);
	
	  function FontIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FontIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FontIcon.__proto__ || (0, _getPrototypeOf2.default)(FontIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FontIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          hoverColor = _props.hoverColor,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['hoverColor', 'onMouseLeave', 'onMouseEnter', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement('span', (0, _extends3.default)({}, other, {
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	      }));
	    }
	  }]);
	  return FontIcon;
	}(_react.Component);
	
	FontIcon.muiName = 'FontIcon';
	FontIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {}
	};
	FontIcon.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	FontIcon.propTypes =  false ? {
	  /**
	   * This is the font color of the font icon. If not specified,
	   * this component will default to muiTheme.palette.textColor.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _propTypes2.default.string,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = FontIcon;

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  return {
	    root: {
	      display: 'flex',
	      flexWrap: 'wrap',
	      margin: -props.padding / 2
	    },
	    item: {
	      boxSizing: 'border-box',
	      padding: props.padding / 2
	    }
	  };
	}
	
	var GridList = function (_Component) {
	  (0, _inherits3.default)(GridList, _Component);
	
	  function GridList() {
	    (0, _classCallCheck3.default)(this, GridList);
	    return (0, _possibleConstructorReturn3.default)(this, (GridList.__proto__ || (0, _getPrototypeOf2.default)(GridList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GridList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cols = _props.cols,
	          padding = _props.padding,
	          cellHeight = _props.cellHeight,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['cols', 'padding', 'cellHeight', 'children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	
	      var wrappedChildren = _react2.default.Children.map(children, function (currentChild) {
	        if (_react2.default.isValidElement(currentChild) && currentChild.type.muiName === 'Subheader') {
	          return currentChild;
	        }
	        var childCols = currentChild.props.cols || 1;
	        var childRows = currentChild.props.rows || 1;
	        var itemStyle = (0, _simpleAssign2.default)({}, styles.item, {
	          width: 100 / cols * childCols + '%',
	          height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + padding
	        });
	
	        return _react2.default.createElement(
	          'div',
	          { style: prepareStyles(itemStyle) },
	          currentChild
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles(mergedRootStyles) }, other),
	        wrappedChildren
	      );
	    }
	  }]);
	  return GridList;
	}(_react.Component);
	
	GridList.defaultProps = {
	  cols: 2,
	  padding: 4,
	  cellHeight: 180
	};
	GridList.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	GridList.propTypes =  false ? {
	  /**
	   * Number of px for one cell height.
	   * You can set `'auto'` if you want to let the children determine the height.
	   */
	  cellHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['auto'])]),
	  /**
	   * Grid Tiles that will be in Grid List.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Number of columns.
	   */
	  cols: _propTypes2.default.number,
	  /**
	   * Number of px for the padding/spacing between items.
	   */
	  padding: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = GridList;

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.GridTile = exports.GridList = undefined;
	
	var _GridList2 = __webpack_require__(1523);
	
	var _GridList3 = _interopRequireDefault(_GridList2);
	
	var _GridTile2 = __webpack_require__(748);
	
	var _GridTile3 = _interopRequireDefault(_GridTile2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.GridList = _GridList3.default;
	exports.GridTile = _GridTile3.default;
	exports.default = _GridList3.default;

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes3 = __webpack_require__(118);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _EnhancedButton = __webpack_require__(139);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(164);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Tooltip = __webpack_require__(770);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _childUtils = __webpack_require__(783);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      overflow: 'visible',
	      transition: _transitions2.default.easeOut(),
	      padding: baseTheme.spacing.iconSize / 2,
	      width: baseTheme.spacing.iconSize * 2,
	      height: baseTheme.spacing.iconSize * 2,
	      fontSize: 0
	    },
	    tooltip: {
	      boxSizing: 'border-box'
	    },
	    disabled: {
	      color: baseTheme.palette.disabledColor,
	      fill: baseTheme.palette.disabledColor,
	      cursor: 'default'
	    }
	  };
	}
	
	var IconButton = function (_Component) {
	  (0, _inherits3.default)(IconButton, _Component);
	
	  function IconButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, IconButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconButton.__proto__ || (0, _getPrototypeOf2.default)(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      // Not to be confonded with the touch property.
	      // This state is to determined if it's a mobile device.
	      touch: false,
	      tooltipShown: false
	    }, _this.handleBlur = function (event) {
	      _this.hideTooltip();
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      _this.showTooltip();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.button.isKeyboardFocused()) {
	        _this.hideTooltip();
	      }
	      _this.setState({ hovered: false });
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseOut = function (event) {
	      if (_this.props.disabled) _this.hideTooltip();
	      if (_this.props.onMouseOut) _this.props.onMouseOut(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.showTooltip();
	
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onFocus = _this$props.onFocus,
	          onBlur = _this$props.onBlur,
	          onKeyboardFocus = _this$props.onKeyboardFocus;
	
	      if (isKeyboardFocused && !disabled) {
	        _this.showTooltip();
	        if (onFocus) {
	          onFocus(event);
	        }
	      } else {
	        _this.hideTooltip();
	        if (onBlur) {
	          onBlur(event);
	        }
	      }
	
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      if (onKeyboardFocus) {
	        onKeyboardFocus(event, isKeyboardFocused);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(IconButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled) {
	        this.setState({ hovered: false });
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus() {
	      this.button.setKeyboardFocus();
	    }
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip() {
	      if (this.props.tooltip) {
	        this.setState({ tooltipShown: true });
	      }
	    }
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip() {
	      if (this.props.tooltip) this.setState({ tooltipShown: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          disabled = _props.disabled,
	          hoveredStyle = _props.hoveredStyle,
	          disableTouchRipple = _props.disableTouchRipple,
	          children = _props.children,
	          iconClassName = _props.iconClassName,
	          style = _props.style,
	          tooltip = _props.tooltip,
	          tooltipPositionProp = _props.tooltipPosition,
	          tooltipStyles = _props.tooltipStyles,
	          touch = _props.touch,
	          iconStyle = _props.iconStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['disabled', 'hoveredStyle', 'disableTouchRipple', 'children', 'iconClassName', 'style', 'tooltip', 'tooltipPosition', 'tooltipStyles', 'touch', 'iconStyle']);
	
	      var fonticon = void 0;
	
	      var styles = getStyles(this.props, this.context);
	      var tooltipPosition = tooltipPositionProp.split('-');
	
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style, hovered ? hoveredStyle : {});
	
	      var tooltipElement = tooltip ? _react2.default.createElement(_Tooltip2.default, {
	        label: tooltip,
	        show: this.state.tooltipShown,
	        touch: touch,
	        style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyles),
	        verticalPosition: tooltipPosition[0],
	        horizontalPosition: tooltipPosition[1]
	      }) : null;
	
	      if (iconClassName) {
	        var iconHoverColor = iconStyle.iconHoverColor,
	            iconStyleFontIcon = (0, _objectWithoutProperties3.default)(iconStyle, ['iconHoverColor']);
	
	
	        fonticon = _react2.default.createElement(
	          _FontIcon2.default,
	          {
	            className: iconClassName,
	            hoverColor: disabled ? null : iconHoverColor,
	            style: (0, _simpleAssign2.default)({}, disabled && styles.disabled, iconStyleFontIcon),
	            color: this.context.muiTheme.baseTheme.palette.textColor
	          },
	          children
	        );
	      }
	
	      var childrenStyle = disabled ? (0, _simpleAssign2.default)({}, iconStyle, styles.disabled) : iconStyle;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({
	          ref: function ref(_ref2) {
	            return _this2.button = _ref2;
	          }
	        }, other, {
	          centerRipple: true,
	          disabled: disabled,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          disableTouchRipple: disableTouchRipple,
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseOut: this.handleMouseOut,
	          onKeyboardFocus: this.handleKeyboardFocus
	        }),
	        tooltipElement,
	        fonticon,
	        (0, _childUtils.extendChildren)(children, {
	          style: childrenStyle
	        })
	      );
	    }
	  }]);
	  return IconButton;
	}(_react.Component);
	
	IconButton.muiName = 'IconButton';
	IconButton.defaultProps = {
	  disabled: false,
	  disableTouchRipple: false,
	  iconStyle: {},
	  tooltipPosition: 'bottom-center',
	  touch: false
	};
	IconButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	IconButton.propTypes =  false ? {
	  /**
	   * Can be used to pass a `FontIcon` element as the icon for the button.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes2.default.bool,
	  /**
	   * If true, the element will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element when the component is hovered.
	   */
	  hoveredStyle: _propTypes2.default.object,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * The CSS class name of the icon. Used for setting the icon with a stylesheet.
	   */
	  iconClassName: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the icon element.
	   * Note: you can specify iconHoverColor as a String inside this object.
	   */
	  iconStyle: _propTypes2.default.object,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function fired when the button is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the button.
	   */
	  onClick: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} keyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseOut: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The text to supply to the element's tooltip.
	   */
	  tooltip: _propTypes2.default.node,
	  /**
	   * The vertical and horizontal positions, respectively, of the element's tooltip.
	   * Possible values are: "bottom-center", "top-center", "bottom-right", "top-right",
	   * "bottom-left", and "top-left".
	   */
	  tooltipPosition: _propTypes4.default.cornersAndCenter,
	  /**
	   * Override the inline-styles of the tooltip element.
	   */
	  tooltipStyles: _propTypes2.default.object,
	  /**
	   * If true, increase the tooltip element's size. Useful for increasing tooltip
	   * readability on mobile devices.
	   */
	  touch: _propTypes2.default.bool
	} : {};
	exports.default = IconButton;

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(363);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _propTypes3 = __webpack_require__(118);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _Menu = __webpack_require__(360);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Popover = __webpack_require__(242);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconMenu = function (_Component) {
	  (0, _inherits3.default)(IconMenu, _Component);
	
	  function IconMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, IconMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconMenu.__proto__ || (0, _getPrototypeOf2.default)(IconMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      menuInitiallyKeyboardFocused: false,
	      open: false
	    }, _this.handleItemTouchTap = function (event, child) {
	      if (_this.props.touchTapCloseDelay !== 0 && !child.props.hasOwnProperty('menuItems')) {
	        var isKeyboard = _events2.default.isKeyboard(event);
	        _this.timerCloseId = setTimeout(function () {
	          _this.close(isKeyboard ? 'enter' : 'itemTap', isKeyboard);
	        }, _this.props.touchTapCloseDelay);
	      }
	
	      _this.props.onItemTouchTap(event, child);
	    }, _this.handleRequestClose = function (reason) {
	      _this.close(reason);
	    }, _this.handleEscKeyDownMenu = function (event) {
	      _this.close('escape', event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(IconMenu, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.open != null) {
	        this.setState({
	          open: nextProps.open,
	          anchorEl: this.refs.iconMenuContainer
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerCloseId);
	    }
	  }, {
	    key: 'isOpen',
	    value: function isOpen() {
	      return this.state.open;
	    }
	  }, {
	    key: 'close',
	    value: function close(reason, isKeyboard) {
	      var _this2 = this;
	
	      if (!this.state.open) {
	        return;
	      }
	
	      if (this.props.open !== null) {
	        this.props.onRequestChange(false, reason);
	      } else {
	        this.setState({ open: false }, function () {
	          // Set focus on the icon button when the menu close
	          if (isKeyboard) {
	            var iconButton = _this2.refs.iconButton;
	            _reactDom2.default.findDOMNode(iconButton).focus();
	            iconButton.setKeyboardFocus();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open(reason, event) {
	      if (this.props.open !== null) {
	        this.props.onRequestChange(true, reason);
	
	        return this.setState({
	          menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	          anchorEl: event.currentTarget
	        });
	      }
	
	      this.setState({
	        open: true,
	        menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	        anchorEl: event.currentTarget
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          anchorOrigin = _props.anchorOrigin,
	          className = _props.className,
	          animated = _props.animated,
	          animation = _props.animation,
	          iconButtonElement = _props.iconButtonElement,
	          iconStyle = _props.iconStyle,
	          onItemTouchTap = _props.onItemTouchTap,
	          onKeyboardFocus = _props.onKeyboardFocus,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseUp = _props.onMouseUp,
	          onRequestChange = _props.onRequestChange,
	          onClick = _props.onClick,
	          listStyle = _props.listStyle,
	          menuStyle = _props.menuStyle,
	          style = _props.style,
	          targetOrigin = _props.targetOrigin,
	          touchTapCloseDelay = _props.touchTapCloseDelay,
	          useLayerForClickAway = _props.useLayerForClickAway,
	          other = (0, _objectWithoutProperties3.default)(_props, ['anchorOrigin', 'className', 'animated', 'animation', 'iconButtonElement', 'iconStyle', 'onItemTouchTap', 'onKeyboardFocus', 'onMouseDown', 'onMouseLeave', 'onMouseEnter', 'onMouseUp', 'onRequestChange', 'onClick', 'listStyle', 'menuStyle', 'style', 'targetOrigin', 'touchTapCloseDelay', 'useLayerForClickAway']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var _state = this.state,
	          open = _state.open,
	          anchorEl = _state.anchorEl;
	
	
	      var styles = {
	        root: {
	          display: 'inline-block',
	          position: 'relative'
	        },
	        menu: {
	          position: 'relative'
	        }
	      };
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedMenuStyles = (0, _simpleAssign2.default)(styles.menu, menuStyle);
	
	       false ? (0, _warning2.default)(iconButtonElement.type.muiName !== 'SvgIcon', 'Material-UI: You shoud not provide an <SvgIcon /> to the \'iconButtonElement\' property of <IconMenu />.\nYou should wrapped it with an <IconButton />.') : void 0;
	
	      var iconButtonProps = {
	        onKeyboardFocus: onKeyboardFocus,
	        onClick: function onClick(event) {
	          _this3.open(_events2.default.isKeyboard(event) ? 'keyboard' : 'iconTap', event);
	          if (iconButtonElement.props.onClick) {
	            iconButtonElement.props.onClick(event);
	          }
	        },
	        ref: 'iconButton'
	      };
	      if (iconStyle || iconButtonElement.props.iconStyle) {
	        iconButtonProps.iconStyle = iconStyle ? (0, _simpleAssign2.default)({}, iconStyle, iconButtonElement.props.iconStyle) : iconButtonElement.props.iconStyle;
	      }
	      var iconButton = _react2.default.cloneElement(iconButtonElement, iconButtonProps);
	
	      var menu = _react2.default.createElement(
	        _Menu2.default,
	        (0, _extends3.default)({}, other, {
	          initiallyKeyboardFocused: this.state.menuInitiallyKeyboardFocused,
	          onEscKeyDown: this.handleEscKeyDownMenu,
	          onItemTouchTap: this.handleItemTouchTap,
	          style: mergedMenuStyles,
	          listStyle: listStyle
	        }),
	        this.props.children
	      );
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: 'iconMenuContainer',
	          className: className,
	          onMouseDown: onMouseDown,
	          onMouseLeave: onMouseLeave,
	          onMouseEnter: onMouseEnter,
	          onMouseUp: onMouseUp,
	          onClick: onClick,
	          style: prepareStyles(mergedRootStyles)
	        },
	        iconButton,
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            open: open,
	            anchorEl: anchorEl,
	            childContextTypes: this.constructor.childContextTypes,
	            useLayerForClickAway: useLayerForClickAway,
	            onRequestClose: this.handleRequestClose,
	            animated: animated,
	            animation: animation,
	            context: this.context
	          },
	          menu
	        )
	      );
	    }
	  }]);
	  return IconMenu;
	}(_react.Component);
	
	IconMenu.muiName = 'IconMenu';
	IconMenu.defaultProps = {
	  anchorOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  animated: true,
	  multiple: false,
	  open: null,
	  onItemTouchTap: function onItemTouchTap() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseDown: function onMouseDown() {},
	  onMouseLeave: function onMouseLeave() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseUp: function onMouseUp() {},
	  onRequestChange: function onRequestChange() {},
	  onClick: function onClick() {},
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  touchTapCloseDelay: 200,
	  useLayerForClickAway: false
	};
	IconMenu.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	IconMenu.propTypes =  false ? {
	  /**
	   * This is the point on the icon where the menu
	   * `targetOrigin` will attach.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it gets added to the DOM.
	   */
	  animated: _propTypes2.default.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * Should be used to pass `MenuItem` components.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * This is the `IconButton` to render. This button will open the menu.
	   */
	  iconButtonElement: _propTypes2.default.element.isRequired,
	  /**
	   * Override the inline-styles of the underlying icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the menu element.
	   */
	  menuStyle: _propTypes2.default.object,
	  /**
	   * If true, the value can an be array and allow the menu to be a multi-select.
	   */
	  multiple: _propTypes2.default.bool,
	  /**
	   * Callback function fired when the `IconButton` element is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the `IconButton` element.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Callback function fired when a menu item is selected with a touch-tap.
	   *
	   * @param {object} event TouchTap event targeting the selected menu item element.
	   * @param {object} child The selected element.
	   */
	  onItemTouchTap: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `IconButton` element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `IconButton` element.
	   * @param {boolean} keyboardFocused If true, the `IconButton` element is focused.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseDown: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseUp: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `open` state of the menu is requested to be changed.
	   *
	   * @param {boolean} open If true, the menu was requested to be opened.
	   * @param {string} reason The reason for the open or close request. Possible values are
	   * 'keyboard' and 'iconTap' for open requests; 'enter', 'escape', 'itemTap', and 'clickAway'
	   * for close requests.
	   */
	  onRequestChange: _propTypes2.default.func,
	  /**
	   * If true, the `IconMenu` is opened.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * This is the point on the menu which will stick to the menu
	   * origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * Sets the delay in milliseconds before closing the
	   * menu when an item is clicked.
	   * If set to 0 then the auto close functionality
	   * will be disabled.
	   */
	  touchTapCloseDelay: _propTypes2.default.number,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying elements.
	   */
	  useLayerForClickAway: _propTypes2.default.bool
	} : {};
	exports.default = IconMenu;

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  var rangeValue = max - min;
	  var relValue = Math.round((clampedValue - min) / rangeValue * 10000) / 10000;
	  return relValue * 100;
	}
	
	function getStyles(props, context) {
	  var max = props.max,
	      min = props.min,
	      value = props.value;
	  var _context$muiTheme = context.muiTheme,
	      palette = _context$muiTheme.baseTheme.palette,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      height: 4,
	      display: 'block',
	      width: '100%',
	      backgroundColor: palette.primary3Color,
	      borderRadius: borderRadius,
	      margin: 0,
	      overflow: 'hidden'
	    },
	    bar: {
	      height: '100%'
	    },
	    barFragment1: {},
	    barFragment2: {}
	  };
	
	  if (props.mode === 'indeterminate') {
	    styles.barFragment1 = {
	      position: 'absolute',
	      backgroundColor: props.color || palette.primary1Color,
	      top: 0,
	      left: 0,
	      bottom: 0,
	      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.650, 0.815, 0.735, 0.395)')
	    };
	
	    styles.barFragment2 = {
	      position: 'absolute',
	      backgroundColor: props.color || palette.primary1Color,
	      top: 0,
	      left: 0,
	      bottom: 0,
	      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.165, 0.840, 0.440, 1.000)')
	    };
	  } else {
	    styles.bar.backgroundColor = props.color || palette.primary1Color;
	    styles.bar.transition = _transitions2.default.create('width', '.3s', null, 'linear');
	    styles.bar.width = getRelativeValue(value, min, max) + '%';
	  }
	
	  return styles;
	}
	
	var LinearProgress = function (_Component) {
	  (0, _inherits3.default)(LinearProgress, _Component);
	
	  function LinearProgress() {
	    (0, _classCallCheck3.default)(this, LinearProgress);
	    return (0, _possibleConstructorReturn3.default)(this, (LinearProgress.__proto__ || (0, _getPrototypeOf2.default)(LinearProgress)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LinearProgress, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.timers = {};
	
	      this.timers.bar1 = this.barUpdate('bar1', 0, this.refs.bar1, [[-35, 100], [100, -90]], 0);
	
	      this.timers.bar2 = setTimeout(function () {
	        _this2.barUpdate('bar2', 0, _this2.refs.bar2, [[-200, 100], [107, -8]], 0);
	      }, 850);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timers.bar1);
	      clearTimeout(this.timers.bar2);
	    }
	  }, {
	    key: 'barUpdate',
	    value: function barUpdate(id, step, barElement, stepValues, timeToNextStep) {
	      var _this3 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      timeToNextStep = timeToNextStep || 420;
	      step = step || 0;
	      step %= 4;
	
	      var right = this.context.muiTheme.isRtl ? 'left' : 'right';
	      var left = this.context.muiTheme.isRtl ? 'right' : 'left';
	
	      if (step === 0) {
	        barElement.style[left] = stepValues[0][0] + '%';
	        barElement.style[right] = stepValues[0][1] + '%';
	      } else if (step === 1) {
	        barElement.style.transitionDuration = '840ms';
	      } else if (step === 2) {
	        barElement.style[left] = stepValues[1][0] + '%';
	        barElement.style[right] = stepValues[1][1] + '%';
	      } else if (step === 3) {
	        barElement.style.transitionDuration = '0ms';
	      }
	      this.timers[id] = setTimeout(function () {
	        return _this3.barUpdate(id, step + 1, barElement, stepValues);
	      }, timeToNextStep);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.bar) },
	          _react2.default.createElement('div', { ref: 'bar1', style: prepareStyles(styles.barFragment1) }),
	          _react2.default.createElement('div', { ref: 'bar2', style: prepareStyles(styles.barFragment2) })
	        )
	      );
	    }
	  }]);
	  return LinearProgress;
	}(_react.Component);
	
	LinearProgress.defaultProps = {
	  mode: 'indeterminate',
	  value: 0,
	  min: 0,
	  max: 100
	};
	LinearProgress.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	LinearProgress.propTypes =  false ? {
	  /**
	   * The color of the progress bar, defaults to
	   * primary color of theme.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * The max value of progress, only works in determinate mode.
	   */
	  max: _propTypes2.default.number,
	  /**
	   * The min value of progress, only works in determinate mode.
	   */
	  min: _propTypes2.default.number,
	  /**
	   * The mode of show your progress, indeterminate for when
	   * there is no value for progress.
	   */
	  mode: _propTypes2.default.oneOf(['determinate', 'indeterminate']),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The value of progress, only works in determinate mode.
	   */
	  value: _propTypes2.default.number
	} : {};
	exports.default = LinearProgress;

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _List = __webpack_require__(358);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NestedList = function NestedList(props) {
	  var children = props.children,
	      open = props.open,
	      nestedLevel = props.nestedLevel,
	      style = props.style;
	
	
	  if (!open) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    _List2.default,
	    { style: style },
	    _react.Children.map(children, function (child) {
	      return (0, _react.isValidElement)(child) ? (0, _react.cloneElement)(child, {
	        nestedLevel: nestedLevel + 1
	      }) : child;
	    })
	  );
	};
	
	NestedList.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  nestedLevel: _propTypes2.default.number.isRequired,
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	exports.default = NestedList;

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.makeSelectable = exports.ListItem = exports.List = undefined;
	
	var _List2 = __webpack_require__(358);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(359);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _makeSelectable2 = __webpack_require__(749);
	
	var _makeSelectable3 = _interopRequireDefault(_makeSelectable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.makeSelectable = _makeSelectable3.default;
	exports.default = _List3.default;

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HotKeyHolder = undefined;
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HotKeyHolder = exports.HotKeyHolder = function () {
	  function HotKeyHolder() {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, HotKeyHolder);
	
	    this.clear = function () {
	      _this.timerId = null;
	      _this.lastKeys = null;
	    };
	  }
	
	  (0, _createClass3.default)(HotKeyHolder, [{
	    key: 'append',
	    value: function append(key) {
	      clearTimeout(this.timerId);
	      this.timerId = setTimeout(this.clear, 500);
	      return this.lastKeys = (this.lastKeys || '') + key;
	    }
	  }]);
	  return HotKeyHolder;
	}();

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(118);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var rounded = props.rounded,
	      circle = props.circle,
	      transitionEnabled = props.transitionEnabled,
	      zDepth = props.zDepth;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      paper = _context$muiTheme.paper,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  return {
	    root: {
	      color: paper.color,
	      backgroundColor: paper.backgroundColor,
	      transition: transitionEnabled && _transitions2.default.easeOut(),
	      boxSizing: 'border-box',
	      fontFamily: baseTheme.fontFamily,
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      boxShadow: paper.zDepthShadows[zDepth - 1], // No shadow for 0 depth papers
	      borderRadius: circle ? '50%' : rounded ? borderRadius : '0px'
	    }
	  };
	}
	
	var Paper = function (_Component) {
	  (0, _inherits3.default)(Paper, _Component);
	
	  function Paper() {
	    (0, _classCallCheck3.default)(this, Paper);
	    return (0, _possibleConstructorReturn3.default)(this, (Paper.__proto__ || (0, _getPrototypeOf2.default)(Paper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Paper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          circle = _props.circle,
	          rounded = _props.rounded,
	          style = _props.style,
	          transitionEnabled = _props.transitionEnabled,
	          zDepth = _props.zDepth,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return Paper;
	}(_react.Component);
	
	Paper.defaultProps = {
	  circle: false,
	  rounded: true,
	  transitionEnabled: true,
	  zDepth: 1
	};
	Paper.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Paper.propTypes =  false ? {
	  /**
	   * Children passed into the paper element.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Set to true to generate a circular paper container.
	   */
	  circle: _propTypes2.default.bool,
	  /**
	   * By default, the paper container will have a border radius.
	   * Set this to false to generate a container with sharp corners.
	   */
	  rounded: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Set to false to disable CSS transitions for the paper element.
	   */
	  transitionEnabled: _propTypes2.default.bool,
	  /**
	   * This number represents the zDepth of the paper shadow.
	   */
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = Paper;

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(118);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _Paper = __webpack_require__(106);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	  return {
	    root: {
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      opacity: open ? 1 : 0,
	      transform: open ? 'scale(1, 1)' : 'scale(0, 0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    },
	    horizontal: {
	      maxHeight: '100%',
	      overflowY: 'auto',
	      transform: open ? 'scaleX(1)' : 'scaleX(0)',
	      opacity: open ? 1 : 0,
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity'])
	    },
	    vertical: {
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('500ms', ['transform', 'opacity'])
	    }
	  };
	}
	
	var PopoverAnimationDefault = function (_Component) {
	  (0, _inherits3.default)(PopoverAnimationDefault, _Component);
	
	  function PopoverAnimationDefault() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverAnimationDefault);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationDefault.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationDefault)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverAnimationDefault, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.horizontal) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.vertical) },
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	  return PopoverAnimationDefault;
	}(_react.Component);
	
	PopoverAnimationDefault.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationDefault.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	PopoverAnimationDefault.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  targetOrigin: _propTypes4.default.origin.isRequired,
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = PopoverAnimationDefault;

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.PopoverAnimationVertical = exports.Popover = undefined;
	
	var _Popover2 = __webpack_require__(242);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _PopoverAnimationVertical2 = __webpack_require__(492);
	
	var _PopoverAnimationVertical3 = _interopRequireDefault(_PopoverAnimationVertical2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Popover = _Popover3.default;
	exports.PopoverAnimationVertical = _PopoverAnimationVertical3.default;
	exports.default = _Popover3.default;

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(187);
	
	var _EnhancedButton = __webpack_require__(139);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _Paper = __webpack_require__(106);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      button = _context$muiTheme.button,
	      raisedButton = _context$muiTheme.raisedButton,
	      borderRadius = _context$muiTheme.borderRadius;
	  var disabled = props.disabled,
	      disabledBackgroundColor = props.disabledBackgroundColor,
	      disabledLabelColor = props.disabledLabelColor,
	      fullWidth = props.fullWidth,
	      icon = props.icon,
	      label = props.label,
	      labelPosition = props.labelPosition,
	      primary = props.primary,
	      secondary = props.secondary,
	      style = props.style;
	
	
	  var amount = primary || secondary ? 0.4 : 0.08;
	
	  var backgroundColor = raisedButton.color;
	  var labelColor = raisedButton.textColor;
	
	  if (disabled) {
	    backgroundColor = disabledBackgroundColor || raisedButton.disabledColor;
	    labelColor = disabledLabelColor || raisedButton.disabledTextColor;
	  } else if (primary) {
	    backgroundColor = raisedButton.primaryColor;
	    labelColor = raisedButton.primaryTextColor;
	  } else if (secondary) {
	    backgroundColor = raisedButton.secondaryColor;
	    labelColor = raisedButton.secondaryTextColor;
	  } else {
	    if (props.backgroundColor) {
	      backgroundColor = props.backgroundColor;
	    }
	    if (props.labelColor) {
	      labelColor = props.labelColor;
	    }
	  }
	
	  var buttonHeight = style && style.height || button.height;
	
	  return {
	    root: {
	      display: 'inline-block',
	      transition: _transitions2.default.easeOut(),
	      minWidth: fullWidth ? '100%' : button.minWidth
	    },
	    button: {
	      height: buttonHeight,
	      lineHeight: buttonHeight + 'px',
	      width: '100%',
	      padding: 0,
	      borderRadius: borderRadius,
	      transition: _transitions2.default.easeOut(),
	      backgroundColor: backgroundColor,
	      // That's the default value for a button but not a link
	      textAlign: 'center'
	    },
	    label: {
	      position: 'relative',
	      opacity: 1,
	      fontSize: raisedButton.fontSize,
	      letterSpacing: 0,
	      textTransform: raisedButton.textTransform || button.textTransform || 'uppercase',
	      fontWeight: raisedButton.fontWeight,
	      margin: 0,
	      userSelect: 'none',
	      paddingLeft: icon && labelPosition !== 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      paddingRight: icon && labelPosition === 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      color: labelColor
	    },
	    icon: {
	      verticalAlign: 'middle',
	      marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	      marginRight: label && labelPosition === 'before' ? 12 : 0
	    },
	    overlay: {
	      height: buttonHeight,
	      borderRadius: borderRadius,
	      backgroundColor: (state.keyboardFocused || state.hovered) && !disabled && (0, _colorManipulator.fade)(labelColor, amount),
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    ripple: {
	      color: labelColor,
	      opacity: !(primary || secondary) ? 0.1 : 0.16
	    }
	  };
	}
	
	var RaisedButton = function (_Component) {
	  (0, _inherits3.default)(RaisedButton, _Component);
	
	  function RaisedButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RaisedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RaisedButton.__proto__ || (0, _getPrototypeOf2.default)(RaisedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      keyboardFocused: false,
	      touched: false,
	      initialZDepth: 0,
	      zDepth: 0
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth + 1
	        });
	      }
	      if (_this.props.onMouseDown) {
	        _this.props.onMouseDown(event);
	      }
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({
	        zDepth: _this.state.initialZDepth
	      });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.state.keyboardFocused) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth,
	          hovered: false
	        });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.keyboardFocused && !_this.state.touched) {
	        _this.setState({
	          hovered: true
	        });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth + 1
	      });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth
	      });
	
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      var zDepth = keyboardFocused && !_this.props.disabled ? _this.state.initialZDepth + 1 : _this.state.initialZDepth;
	
	      _this.setState({
	        zDepth: zDepth,
	        keyboardFocused: keyboardFocused
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RaisedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var zDepth = this.props.disabled ? 0 : 1;
	      this.setState({
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var zDepth = nextProps.disabled ? 0 : 1;
	      var nextState = {
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      };
	
	      if (nextProps.disabled) {
	        nextState.hovered = false;
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          buttonStyle = _props.buttonStyle,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          disabledBackgroundColor = _props.disabledBackgroundColor,
	          disabledLabelColor = _props.disabledLabelColor,
	          fullWidth = _props.fullWidth,
	          icon = _props.icon,
	          label = _props.label,
	          labelColor = _props.labelColor,
	          labelPosition = _props.labelPosition,
	          labelStyle = _props.labelStyle,
	          overlayStyle = _props.overlayStyle,
	          primary = _props.primary,
	          rippleStyle = _props.rippleStyle,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'buttonStyle', 'children', 'className', 'disabled', 'disabledBackgroundColor', 'disabledLabelColor', 'fullWidth', 'icon', 'label', 'labelColor', 'labelPosition', 'labelStyle', 'overlayStyle', 'primary', 'rippleStyle', 'secondary', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var mergedRippleStyles = (0, _simpleAssign2.default)({}, styles.ripple, rippleStyle);
	
	      var buttonEventHandlers = disabled ? {} : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      var labelElement = label && _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)), key: 'labelElement' },
	        label
	      );
	
	      var iconCloned = icon && (0, _react.cloneElement)(icon, {
	        color: icon.props.color || styles.label.color,
	        style: (0, _simpleAssign2.default)(styles.icon, icon.props.style),
	        key: 'iconCloned'
	      });
	
	      // Place label before or after children.
	      var enhancedButtonChildren = labelPosition === 'before' ? [labelElement, iconCloned, children] : [children, iconCloned, labelElement];
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: this.state.zDepth
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.button, buttonStyle),
	            focusRippleColor: mergedRippleStyles.color,
	            touchRippleColor: mergedRippleStyles.color,
	            focusRippleOpacity: mergedRippleStyles.opacity,
	            touchRippleOpacity: mergedRippleStyles.opacity
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, overlayStyle))
	            },
	            enhancedButtonChildren
	          )
	        )
	      );
	    }
	  }]);
	  return RaisedButton;
	}(_react.Component);
	
	RaisedButton.muiName = 'RaisedButton';
	RaisedButton.defaultProps = {
	  disabled: false,
	  labelPosition: 'after',
	  fullWidth: false,
	  primary: false,
	  secondary: false
	};
	RaisedButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	RaisedButton.propTypes =  false ? {
	  /**
	   * Override the default background color for the button,
	   * but not the default disabled background color
	   * (use `disabledBackgroundColor` for this).
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the button element.
	   */
	  buttonStyle: _propTypes2.default.object,
	  /**
	   * The content of the button.
	   * If a label is provided via the `label` prop, the text within the label
	   * will be displayed in addition to the content provided here.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	    * The element to use as the container for the RaisedButton. Either a string to
	    * use a DOM element or a ReactElement. This is useful for wrapping the
	    * RaisedButton in a custom Link component. If a ReactElement is given, ensure
	    * that it passes all of its given props through to the underlying DOM
	    * element and renders its children prop for proper integration.
	    */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes2.default.bool,
	  /**
	   * If true, the button will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the default background color for the button
	   * when it is disabled.
	   */
	  disabledBackgroundColor: _propTypes2.default.string,
	  /**
	   * The color of the button's label when the button is disabled.
	   */
	  disabledLabelColor: _propTypes2.default.string,
	  /**
	   * If true, the button will take up the full width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * An icon to be displayed within the button.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * The label to be displayed within the button.
	   * If content is provided via the `children` prop, that content will be
	   * displayed in addition to the label provided here.
	   */
	  label: validateLabel,
	  /**
	   * The color of the button's label.
	   */
	  labelColor: _propTypes2.default.string,
	  /**
	   * The position of the button's label relative to the button's `children`.
	   */
	  labelPosition: _propTypes2.default.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Callback function fired when the button is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the button.
	   */
	  onClick: _propTypes2.default.func,
	  /** @ignore */
	  onMouseDown: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseUp: _propTypes2.default.func,
	  /** @ignore */
	  onTouchEnd: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Override the inline style of the button overlay.
	   */
	  overlayStyle: _propTypes2.default.object,
	  /**
	   * If true, the button will use the theme's primary color.
	   */
	  primary: _propTypes2.default.bool,
	  /**
	   * Override the inline style of the ripple element.
	   */
	  rippleStyle: _propTypes2.default.object,
	  /**
	   * If true, the button will use the theme's secondary color.
	   * If both `secondary` and `primary` are true, the button will use
	   * the theme's primary color.
	   */
	  secondary: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = RaisedButton;

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _slicedToArray2 = __webpack_require__(412);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autoPrefix = __webpack_require__(213);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Paper = __webpack_require__(106);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VIEWBOX_SIZE = 32;
	
	function getStyles(props) {
	  var padding = props.size * 0.1; // same implementation of `this.getPaddingSize()`
	  return {
	    root: {
	      position: 'absolute',
	      zIndex: 2,
	      width: props.size,
	      height: props.size,
	      padding: padding,
	      top: -10000,
	      left: -10000,
	      transform: 'translate(' + (10000 + props.left) + 'px, ' + (10000 + props.top) + 'px)',
	      opacity: props.status === 'hide' ? 0 : 1,
	      transition: props.status === 'hide' ? _transitions2.default.create('all', '.3s', 'ease-out') : 'none'
	    }
	  };
	}
	
	var RefreshIndicator = function (_Component) {
	  (0, _inherits3.default)(RefreshIndicator, _Component);
	
	  function RefreshIndicator() {
	    (0, _classCallCheck3.default)(this, RefreshIndicator);
	    return (0, _possibleConstructorReturn3.default)(this, (RefreshIndicator.__proto__ || (0, _getPrototypeOf2.default)(RefreshIndicator)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RefreshIndicator, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scalePath(this.refs.path, 0);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	      clearTimeout(this.rotateWrapperSecondTimer);
	
	      this.scalePath(this.refs.path, 0);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	      clearTimeout(this.rotateWrapperSecondTimer);
	    }
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var paperSize = this.getPaperSize();
	
	      var childrenCmp = null;
	      if (this.props.status !== 'ready') {
	        var circleStyle = this.getCircleStyle(paperSize);
	        childrenCmp = _react2.default.createElement(
	          'div',
	          {
	            ref: 'wrapper',
	            style: prepareStyles({
	              transition: _transitions2.default.create('transform', '20s', null, 'linear'),
	              width: '100%',
	              height: '100%'
	            })
	          },
	          _react2.default.createElement(
	            'svg',
	            {
	              style: {
	                width: paperSize,
	                height: paperSize
	              },
	              viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	            },
	            _react2.default.createElement('circle', (0, _extends3.default)({
	              ref: 'path',
	              style: prepareStyles((0, _simpleAssign2.default)(circleStyle.style, {
	                transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	              }))
	            }, circleStyle.attr))
	          )
	        );
	      } else {
	        var _circleStyle = this.getCircleStyle(paperSize);
	        var polygonStyle = this.getPolygonStyle(paperSize);
	        childrenCmp = _react2.default.createElement(
	          'svg',
	          {
	            style: {
	              width: paperSize,
	              height: paperSize
	            },
	            viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	          },
	          _react2.default.createElement('circle', (0, _extends3.default)({
	            style: prepareStyles(_circleStyle.style)
	          }, _circleStyle.attr)),
	          _react2.default.createElement('polygon', (0, _extends3.default)({
	            style: prepareStyles(polygonStyle.style)
	          }, polygonStyle.attr))
	        );
	      }
	
	      return childrenCmp;
	    }
	  }, {
	    key: 'getTheme',
	    value: function getTheme() {
	      return this.context.muiTheme.refreshIndicator;
	    }
	  }, {
	    key: 'getPaddingSize',
	    value: function getPaddingSize() {
	      var padding = this.props.size * 0.1;
	      return padding;
	    }
	  }, {
	    key: 'getPaperSize',
	    value: function getPaperSize() {
	      return this.props.size - this.getPaddingSize() * 2;
	    }
	  }, {
	    key: 'getCircleAttr',
	    value: function getCircleAttr() {
	      return {
	        radiu: VIEWBOX_SIZE / 2 - 5,
	        originX: VIEWBOX_SIZE / 2,
	        originY: VIEWBOX_SIZE / 2,
	        strokeWidth: 3
	      };
	    }
	  }, {
	    key: 'getArcDeg',
	    value: function getArcDeg() {
	      var p = this.props.percentage / 100;
	
	      var beginDeg = p * 120;
	      var endDeg = p * 410;
	      return [beginDeg, endDeg];
	    }
	  }, {
	    key: 'getFactor',
	    value: function getFactor() {
	      var p = this.props.percentage / 100;
	      var p1 = Math.min(1, p / 0.4);
	
	      return p1;
	    }
	  }, {
	    key: 'getCircleStyle',
	    value: function getCircleStyle() {
	      var isLoading = this.props.status === 'loading';
	      var p1 = isLoading ? 1 : this.getFactor();
	      var circle = this.getCircleAttr();
	      var perimeter = Math.PI * 2 * circle.radiu;
	
	      var _getArcDeg = this.getArcDeg(),
	          _getArcDeg2 = (0, _slicedToArray3.default)(_getArcDeg, 2),
	          beginDeg = _getArcDeg2[0],
	          endDeg = _getArcDeg2[1];
	
	      var arcLen = (endDeg - beginDeg) * perimeter / 360;
	      var dashOffset = -beginDeg * perimeter / 360;
	
	      var theme = this.getTheme();
	      return {
	        style: {
	          strokeDasharray: arcLen + ', ' + (perimeter - arcLen),
	          strokeDashoffset: dashOffset,
	          stroke: isLoading || this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
	          strokeLinecap: 'round',
	          opacity: p1,
	          strokeWidth: circle.strokeWidth * p1,
	          fill: 'none'
	        },
	        attr: {
	          cx: circle.originX,
	          cy: circle.originY,
	          r: circle.radiu
	        }
	      };
	    }
	  }, {
	    key: 'getPolygonStyle',
	    value: function getPolygonStyle() {
	      var p1 = this.getFactor();
	      var circle = this.getCircleAttr();
	
	      var triangleCx = circle.originX + circle.radiu;
	      var triangleCy = circle.originY;
	      var dx = circle.strokeWidth * 7 / 4 * p1;
	      var trianglePath = triangleCx - dx + ',' + triangleCy + ' ' + (triangleCx + dx) + ',' + triangleCy + ' ' + triangleCx + ',' + (triangleCy + dx);
	
	      var _getArcDeg3 = this.getArcDeg(),
	          _getArcDeg4 = (0, _slicedToArray3.default)(_getArcDeg3, 2),
	          endDeg = _getArcDeg4[1];
	
	      var theme = this.getTheme();
	      return {
	        style: {
	          fill: this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
	          transform: 'rotate(' + endDeg + 'deg)',
	          transformOrigin: circle.originX + 'px ' + circle.originY + 'px',
	          opacity: p1
	        },
	        attr: {
	          points: trianglePath
	        }
	      };
	    }
	  }, {
	    key: 'scalePath',
	    value: function scalePath(path, step) {
	      var _this2 = this;
	
	      if (this.props.status !== 'loading') return;
	
	      var currStep = (step || 0) % 3;
	
	      var circle = this.getCircleAttr();
	      var perimeter = Math.PI * 2 * circle.radiu;
	      var arcLen = perimeter * 0.64;
	
	      var strokeDasharray = void 0;
	      var strokeDashoffset = void 0;
	      var transitionDuration = void 0;
	
	      if (currStep === 0) {
	        strokeDasharray = '1, 200';
	        strokeDashoffset = 0;
	        transitionDuration = '0ms';
	      } else if (currStep === 1) {
	        strokeDasharray = arcLen + ', 200';
	        strokeDashoffset = -15;
	        transitionDuration = '750ms';
	      } else {
	        strokeDasharray = arcLen + ', 200';
	        strokeDashoffset = -(perimeter - 1);
	        transitionDuration = '850ms';
	      }
	
	      _autoPrefix2.default.set(path.style, 'strokeDasharray', strokeDasharray);
	      _autoPrefix2.default.set(path.style, 'strokeDashoffset', strokeDashoffset);
	      _autoPrefix2.default.set(path.style, 'transitionDuration', transitionDuration);
	
	      this.scalePathTimer = setTimeout(function () {
	        return _this2.scalePath(path, currStep + 1);
	      }, currStep ? 750 : 250);
	    }
	  }, {
	    key: 'rotateWrapper',
	    value: function rotateWrapper(wrapper) {
	      var _this3 = this;
	
	      if (this.props.status !== 'loading') return;
	
	      _autoPrefix2.default.set(wrapper.style, 'transform', null);
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');
	
	      this.rotateWrapperSecondTimer = setTimeout(function () {
	        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
	        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
	        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
	      }, 50);
	
	      this.rotateWrapperTimer = setTimeout(function () {
	        return _this3.rotateWrapper(wrapper);
	      }, 10050);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          top = _props.top,
	          left = _props.left,
	          percentage = _props.percentage,
	          status = _props.status,
	          loadingColor = _props.loadingColor,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'top', 'left', 'percentage', 'status', 'loadingColor']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({
	          circle: true,
	          style: (0, _simpleAssign2.default)(styles.root, style)
	        }, other),
	        this.renderChildren()
	      );
	    }
	  }]);
	  return RefreshIndicator;
	}(_react.Component);
	
	RefreshIndicator.defaultProps = {
	  percentage: 0,
	  size: 40,
	  status: 'hide'
	};
	RefreshIndicator.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	RefreshIndicator.propTypes =  false ? {
	  /**
	   * Override the theme's color of the indicator while it's status is
	   * "ready" and it's percentage is less than 100.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * The absolute left position of the indicator in pixels.
	   */
	  left: _propTypes2.default.number.isRequired,
	  /**
	   * Override the theme's color of the indicator while
	   * it's status is "loading" or when it's percentage is 100.
	   */
	  loadingColor: _propTypes2.default.string,
	  /**
	   * The confirmation progress to fetch data. Max value is 100.
	   */
	  percentage: _propTypes2.default.number,
	  /**
	   * Size in pixels.
	   */
	  size: _propTypes2.default.number,
	  /**
	   * The display status of the indicator. If the status is
	   * "ready", the indicator will display the ready state
	   * arrow. If the status is "loading", it will display
	   * the loading progress indicator. If the status is "hide",
	   * the indicator will be hidden.
	   */
	  status: _propTypes2.default.oneOf(['ready', 'loading', 'hide']),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The absolute top position of the indicator in pixels.
	   */
	  top: _propTypes2.default.number.isRequired
	} : {};
	exports.default = RefreshIndicator;

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RefreshIndicator = __webpack_require__(1535);
	
	var _RefreshIndicator2 = _interopRequireDefault(_RefreshIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RefreshIndicator2.default;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextField = __webpack_require__(186);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _DropDownMenu = __webpack_require__(747);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  return {
	    label: {
	      paddingLeft: 0,
	      top: props.floatingLabelText ? 6 : -4
	    },
	    icon: {
	      right: 0,
	      top: props.floatingLabelText ? 8 : 0
	    },
	    hideDropDownUnderline: {
	      borderTop: 'none'
	    },
	    dropDownMenu: {
	      display: 'block'
	    }
	  };
	}
	
	var SelectField = function (_Component) {
	  (0, _inherits3.default)(SelectField, _Component);
	
	  function SelectField() {
	    (0, _classCallCheck3.default)(this, SelectField);
	    return (0, _possibleConstructorReturn3.default)(this, (SelectField.__proto__ || (0, _getPrototypeOf2.default)(SelectField)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SelectField, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoWidth = _props.autoWidth,
	          multiple = _props.multiple,
	          children = _props.children,
	          style = _props.style,
	          labelStyle = _props.labelStyle,
	          iconStyle = _props.iconStyle,
	          id = _props.id,
	          underlineDisabledStyle = _props.underlineDisabledStyle,
	          underlineFocusStyle = _props.underlineFocusStyle,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          underlineStyle = _props.underlineStyle,
	          dropDownMenuProps = _props.dropDownMenuProps,
	          errorStyle = _props.errorStyle,
	          disabled = _props.disabled,
	          floatingLabelFixed = _props.floatingLabelFixed,
	          floatingLabelText = _props.floatingLabelText,
	          floatingLabelStyle = _props.floatingLabelStyle,
	          hintStyle = _props.hintStyle,
	          hintText = _props.hintText,
	          fullWidth = _props.fullWidth,
	          errorText = _props.errorText,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          menuStyle = _props.menuStyle,
	          onFocus = _props.onFocus,
	          onBlur = _props.onBlur,
	          onChange = _props.onChange,
	          selectionRenderer = _props.selectionRenderer,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'multiple', 'children', 'style', 'labelStyle', 'iconStyle', 'id', 'underlineDisabledStyle', 'underlineFocusStyle', 'menuItemStyle', 'selectedMenuItemStyle', 'underlineStyle', 'dropDownMenuProps', 'errorStyle', 'disabled', 'floatingLabelFixed', 'floatingLabelText', 'floatingLabelStyle', 'hintStyle', 'hintText', 'fullWidth', 'errorText', 'listStyle', 'maxHeight', 'menuStyle', 'onFocus', 'onBlur', 'onChange', 'selectionRenderer', 'value']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _TextField2.default,
	        (0, _extends3.default)({}, other, {
	          style: style,
	          disabled: disabled,
	          floatingLabelFixed: floatingLabelFixed,
	          floatingLabelText: floatingLabelText,
	          floatingLabelStyle: floatingLabelStyle,
	          hintStyle: hintStyle,
	          hintText: !hintText && !floatingLabelText ? ' ' : hintText,
	          fullWidth: fullWidth,
	          errorText: errorText,
	          underlineStyle: underlineStyle,
	          errorStyle: errorStyle,
	          onFocus: onFocus,
	          onBlur: onBlur,
	          id: id,
	          underlineDisabledStyle: underlineDisabledStyle,
	          underlineFocusStyle: underlineFocusStyle
	        }),
	        _react2.default.createElement(
	          _DropDownMenu2.default,
	          (0, _extends3.default)({
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.dropDownMenu, menuStyle),
	            labelStyle: (0, _simpleAssign2.default)(styles.label, labelStyle),
	            iconStyle: (0, _simpleAssign2.default)(styles.icon, iconStyle),
	            menuItemStyle: menuItemStyle,
	            selectedMenuItemStyle: selectedMenuItemStyle,
	            underlineStyle: styles.hideDropDownUnderline,
	            listStyle: listStyle,
	            autoWidth: autoWidth,
	            value: value,
	            onChange: onChange,
	            maxHeight: maxHeight,
	            multiple: multiple,
	            selectionRenderer: selectionRenderer
	          }, dropDownMenuProps),
	          children
	        )
	      );
	    }
	  }]);
	  return SelectField;
	}(_react.Component);
	
	SelectField.defaultProps = {
	  autoWidth: false,
	  disabled: false,
	  fullWidth: false,
	  multiple: false
	};
	SelectField.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	SelectField.propTypes =  false ? {
	  /**
	   * If true, the width will automatically be set according to the
	   * items inside the menu.
	   * To control the width in CSS instead, leave this prop set to `false`.
	   */
	  autoWidth: _propTypes2.default.bool,
	  /**
	   * The `MenuItem` elements to populate the select field with.
	   * If the menu items have a `label` prop, that value will
	   * represent the selected menu item in the rendered select field.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, the select field will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Object that can handle and override any property of component DropDownMenu.
	   */
	  dropDownMenuProps: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the error element.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _propTypes2.default.node,
	  /**
	   * If true, the floating label will float even when no value is selected.
	   */
	  floatingLabelFixed: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the floating label.
	   */
	  floatingLabelStyle: _propTypes2.default.object,
	  /**
	   * The content of the floating label.
	   */
	  floatingLabelText: _propTypes2.default.node,
	  /**
	   * If true, the select field will take up the full width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the hint element.
	   */
	  hintStyle: _propTypes2.default.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * The id prop for the text field.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * Override the label style when the select field is inactive.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * Override the default max-height of the underlying `DropDownMenu` element.
	   */
	  maxHeight: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underlying `DropDownMenu` element.
	   */
	  menuStyle: _propTypes2.default.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _propTypes2.default.bool,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event TouchTap event targeting the menu item
	   * that was selected.
	   * @param {number} key The index of the selected menu item, or undefined
	   * if `multiple` is true.
	   * @param {any} payload If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _propTypes2.default.object,
	  /**
	   * Customize the rendering of the selected item.
	   *
	   * @param {any} value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   * @param {any} menuItem The selected `MenuItem`.
	   * If `multiple` is true, this will be an array with the `MenuItem`s matching the `value`s parameter.
	   */
	  selectionRenderer: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underline element when the select
	   * field is disabled.
	   */
	  underlineDisabledStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underline element when the select field
	   * is focused.
	   */
	  underlineFocusStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underline element.
	   */
	  underlineStyle: _propTypes2.default.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = SelectField;

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(591);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _keycode = __webpack_require__(99);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(498);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Verifies min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if min >= max otherwise null.
	 */
	var minMaxPropType = function minMaxPropType(props, propName, componentName) {
	  for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    rest[_key - 3] = arguments[_key];
	  }
	
	  var error = _propTypes2.default.number.apply(_propTypes2.default, [props, propName, componentName].concat(rest));
	  if (error !== null) {
	    return error;
	  }
	
	  if (props.min >= props.max) {
	    var errorMsg = propName === 'min' ? 'min should be less than max' : 'max should be greater than min';
	    return new Error(errorMsg);
	  }
	};
	
	/**
	 * Verifies value is within the min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if the value is not within the range otherwise null.
	 */
	var valueInRangePropType = function valueInRangePropType(props, propName, componentName) {
	  for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	    rest[_key2 - 3] = arguments[_key2];
	  }
	
	  var error = _propTypes2.default.number.apply(_propTypes2.default, [props, propName, componentName].concat(rest));
	  if (error !== null) {
	    return error;
	  }
	
	  var value = props[propName];
	  if (value < props.min || props.max < value) {
	    return new Error(propName + ' should be within the range specified by min and max');
	  }
	};
	
	var crossAxisProperty = {
	  x: 'height',
	  'x-reverse': 'height',
	  y: 'width',
	  'y-reverse': 'width'
	};
	
	var crossAxisOffsetProperty = {
	  x: 'top',
	  'x-reverse': 'top',
	  y: 'left',
	  'y-reverse': 'left'
	};
	
	var mainAxisProperty = {
	  x: 'width',
	  'x-reverse': 'width',
	  y: 'height',
	  'y-reverse': 'height'
	};
	
	var mainAxisMarginFromEnd = {
	  x: 'marginRight',
	  'x-reverse': 'marginLeft',
	  y: 'marginTop',
	  'y-reverse': 'marginBottom'
	};
	
	var mainAxisMarginFromStart = {
	  x: 'marginLeft',
	  'x-reverse': 'marginRight',
	  y: 'marginBottom',
	  'y-reverse': 'marginTop'
	};
	
	var mainAxisOffsetProperty = {
	  x: 'left',
	  'x-reverse': 'right',
	  y: 'bottom',
	  'y-reverse': 'top'
	};
	
	var mainAxisClientProperty = {
	  x: 'clientWidth',
	  'x-reverse': 'clientWidth',
	  y: 'clientHeight',
	  'y-reverse': 'clientHeight'
	};
	
	var mainAxisClientOffsetProperty = {
	  x: 'clientX',
	  'x-reverse': 'clientX',
	  y: 'clientY',
	  'y-reverse': 'clientY'
	};
	
	var reverseMainAxisOffsetProperty = {
	  x: 'right',
	  'x-reverse': 'left',
	  y: 'top',
	  'y-reverse': 'bottom'
	};
	
	var isMouseControlInverted = function isMouseControlInverted(axis) {
	  return axis === 'x-reverse' || axis === 'y';
	};
	
	var calculateAxis = function calculateAxis(axis, isRtl) {
	  if (isRtl) {
	    switch (axis) {
	      case 'x':
	        return 'x-reverse';
	      case 'x-reverse':
	        return 'x';
	    }
	  }
	  return axis;
	};
	
	function getPercent(value, min, max) {
	  var percent = (value - min) / (max - min);
	  if (isNaN(percent)) {
	    percent = 0;
	  }
	
	  return percent;
	}
	
	var getStyles = function getStyles(props, context, state) {
	  var _slider, _track, _filledAndRemaining, _handle, _objectAssign2, _objectAssign3;
	
	  var axis = props.axis,
	      disabled = props.disabled,
	      max = props.max,
	      min = props.min;
	  var _context$muiTheme = context.muiTheme,
	      isRtl = _context$muiTheme.isRtl,
	      _context$muiTheme$sli = _context$muiTheme.slider,
	      handleColorZero = _context$muiTheme$sli.handleColorZero,
	      handleFillColor = _context$muiTheme$sli.handleFillColor,
	      handleSize = _context$muiTheme$sli.handleSize,
	      handleSizeDisabled = _context$muiTheme$sli.handleSizeDisabled,
	      handleSizeActive = _context$muiTheme$sli.handleSizeActive,
	      trackSize = _context$muiTheme$sli.trackSize,
	      trackColor = _context$muiTheme$sli.trackColor,
	      trackColorSelected = _context$muiTheme$sli.trackColorSelected,
	      rippleColor = _context$muiTheme$sli.rippleColor,
	      selectionColor = _context$muiTheme$sli.selectionColor;
	
	
	  var fillGutter = handleSize / 2;
	  var disabledGutter = trackSize + handleSizeDisabled / 2;
	  var calcDisabledSpacing = disabled ? ' - ' + disabledGutter + 'px' : '';
	  var percent = getPercent(state.value, min, max);
	  var calculatedAxis = calculateAxis(axis, isRtl);
	
	  var styles = {
	    slider: (_slider = {
	      touchCallout: 'none',
	      userSelect: 'none',
	      cursor: 'default'
	    }, (0, _defineProperty3.default)(_slider, crossAxisProperty[calculatedAxis], handleSizeActive), (0, _defineProperty3.default)(_slider, mainAxisProperty[calculatedAxis], '100%'), (0, _defineProperty3.default)(_slider, 'position', 'relative'), (0, _defineProperty3.default)(_slider, 'marginTop', 24), (0, _defineProperty3.default)(_slider, 'marginBottom', 48), _slider),
	    track: (_track = {
	      position: 'absolute'
	    }, (0, _defineProperty3.default)(_track, crossAxisOffsetProperty[calculatedAxis], (handleSizeActive - trackSize) / 2), (0, _defineProperty3.default)(_track, mainAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_track, mainAxisProperty[calculatedAxis], '100%'), (0, _defineProperty3.default)(_track, crossAxisProperty[calculatedAxis], trackSize), _track),
	    filledAndRemaining: (_filledAndRemaining = {
	      directionInvariant: true,
	      position: 'absolute'
	    }, (0, _defineProperty3.default)(_filledAndRemaining, crossAxisOffsetProperty, 0), (0, _defineProperty3.default)(_filledAndRemaining, crossAxisProperty[calculatedAxis], '100%'), (0, _defineProperty3.default)(_filledAndRemaining, 'transition', _transitions2.default.easeOut(null, 'margin')), _filledAndRemaining),
	    handle: (_handle = {
	      directionInvariant: true,
	      boxSizing: 'border-box',
	      position: 'absolute',
	      cursor: 'pointer',
	      pointerEvents: 'inherit'
	    }, (0, _defineProperty3.default)(_handle, crossAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_handle, mainAxisOffsetProperty[calculatedAxis], percent === 0 ? '0%' : percent * 100 + '%'), (0, _defineProperty3.default)(_handle, 'zIndex', 1), (0, _defineProperty3.default)(_handle, 'margin', {
	      x: trackSize / 2 + 'px 0 0 0',
	      'x-reverse': trackSize / 2 + 'px 0 0 0',
	      y: '0 0 0 ' + trackSize / 2 + 'px',
	      'y-reverse': '0 0 0 ' + trackSize / 2 + 'px'
	    }[calculatedAxis]), (0, _defineProperty3.default)(_handle, 'width', handleSize), (0, _defineProperty3.default)(_handle, 'height', handleSize), (0, _defineProperty3.default)(_handle, 'backgroundColor', selectionColor), (0, _defineProperty3.default)(_handle, 'backgroundClip', 'padding-box'), (0, _defineProperty3.default)(_handle, 'border', '0px solid transparent'), (0, _defineProperty3.default)(_handle, 'borderRadius', '50%'), (0, _defineProperty3.default)(_handle, 'transform', {
	      x: 'translate(-50%, -50%)',
	      'x-reverse': 'translate(50%, -50%)',
	      y: 'translate(-50%, 50%)',
	      'y-reverse': 'translate(-50%, -50%)'
	    }[calculatedAxis]), (0, _defineProperty3.default)(_handle, 'transition', _transitions2.default.easeOut('450ms', 'background') + ', ' + _transitions2.default.easeOut('450ms', 'border-color') + ', ' + _transitions2.default.easeOut('450ms', 'width') + ', ' + _transitions2.default.easeOut('450ms', 'height')), (0, _defineProperty3.default)(_handle, 'overflow', 'visible'), (0, _defineProperty3.default)(_handle, 'outline', 'none'), _handle),
	    handleWhenDisabled: {
	      boxSizing: 'content-box',
	      cursor: 'not-allowed',
	      backgroundColor: trackColor,
	      width: handleSizeDisabled,
	      height: handleSizeDisabled,
	      border: 'none'
	    },
	    handleWhenPercentZero: {
	      border: trackSize + 'px solid ' + handleColorZero,
	      backgroundColor: handleFillColor,
	      boxShadow: 'none'
	    },
	    handleWhenPercentZeroAndDisabled: {
	      cursor: 'not-allowed',
	      width: handleSizeDisabled,
	      height: handleSizeDisabled
	    },
	    handleWhenPercentZeroAndFocused: {
	      border: trackSize + 'px solid ' + trackColorSelected
	    },
	    handleWhenActive: {
	      width: handleSizeActive,
	      height: handleSizeActive
	    },
	    ripple: {
	      height: handleSize,
	      width: handleSize,
	      overflow: 'visible'
	    },
	    rippleWhenPercentZero: {
	      top: -trackSize,
	      left: -trackSize
	    },
	    rippleInner: {
	      height: '300%',
	      width: '300%',
	      top: -handleSize,
	      left: -handleSize
	    },
	    rippleColor: {
	      fill: percent === 0 ? handleColorZero : rippleColor
	    }
	  };
	  styles.filled = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign2 = {}, (0, _defineProperty3.default)(_objectAssign2, mainAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_objectAssign2, 'backgroundColor', disabled ? trackColor : selectionColor), (0, _defineProperty3.default)(_objectAssign2, mainAxisMarginFromEnd[calculatedAxis], fillGutter), (0, _defineProperty3.default)(_objectAssign2, mainAxisProperty[calculatedAxis], 'calc(' + percent * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign2));
	  styles.remaining = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign3 = {}, (0, _defineProperty3.default)(_objectAssign3, reverseMainAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_objectAssign3, 'backgroundColor', (state.hovered || state.focused) && !disabled ? trackColorSelected : trackColor), (0, _defineProperty3.default)(_objectAssign3, mainAxisMarginFromStart[calculatedAxis], fillGutter), (0, _defineProperty3.default)(_objectAssign3, mainAxisProperty[calculatedAxis], 'calc(' + (1 - percent) * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign3));
	
	  return styles;
	};
	
	var Slider = function (_Component) {
	  (0, _inherits3.default)(Slider, _Component);
	
	  function Slider() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Slider);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Slider.__proto__ || (0, _getPrototypeOf2.default)(Slider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      active: false,
	      dragging: false,
	      focused: false,
	      hovered: false,
	      value: 0
	    }, _this.track = null, _this.handle = null, _this.resolveValue = function (value) {
	      var _this$props = _this.props,
	          max = _this$props.max,
	          min = _this$props.min;
	
	
	      if (value > max) {
	        return max;
	      }
	
	      if (value < min) {
	        return min;
	      }
	
	      return value;
	    }, _this.handleKeyDown = function (event) {
	      var _this$props2 = _this.props,
	          axis = _this$props2.axis,
	          min = _this$props2.min,
	          max = _this$props2.max,
	          step = _this$props2.step;
	      var isRtl = _this.context.muiTheme.isRtl;
	
	
	      var calculatedAxis = calculateAxis(axis, isRtl);
	
	      var action = void 0;
	
	      switch ((0, _keycode2.default)(event)) {
	        case 'page down':
	        case 'down':
	          if (calculatedAxis === 'y-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'left':
	          if (calculatedAxis === 'x-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'page up':
	        case 'up':
	          if (calculatedAxis === 'y-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'right':
	          if (calculatedAxis === 'x-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'home':
	          action = 'min';
	          break;
	        case 'end':
	          action = 'max';
	          break;
	      }
	
	      if (action) {
	        var newValue = void 0;
	
	        // Cancel scroll
	        event.preventDefault();
	
	        switch (action) {
	          case 'decrease':
	            newValue = _this.state.value - step;
	            break;
	          case 'increase':
	            newValue = _this.state.value + step;
	            break;
	          case 'min':
	            newValue = min;
	            break;
	          case 'max':
	            newValue = max;
	            break;
	        }
	
	        // We need to use toFixed() because of float point errors.
	        // For example, 0.01 + 0.06 = 0.06999999999999999
	        newValue = _this.resolveValue(parseFloat(newValue.toFixed(5)));
	
	        if (_this.state.value !== newValue) {
	          _this.setState({
	            value: newValue
	          });
	
	          if (_this.props.onChange) {
	            _this.props.onChange(event, newValue);
	          }
	        }
	      }
	    }, _this.handleDragMouseMove = function (event) {
	      _this.onDragUpdate(event, 'mouse');
	    }, _this.handleTouchMove = function (event) {
	      _this.onDragUpdate(event, 'touch');
	    }, _this.handleMouseEnd = function (event) {
	      document.removeEventListener('mousemove', _this.handleDragMouseMove);
	      document.removeEventListener('mouseup', _this.handleMouseEnd);
	
	      _this.onDragStop(event);
	    }, _this.handleTouchEnd = function (event) {
	      document.removeEventListener('touchmove', _this.handleTouchMove);
	      document.removeEventListener('touchup', _this.handleTouchEnd);
	      document.removeEventListener('touchend', _this.handleTouchEnd);
	      document.removeEventListener('touchcancel', _this.handleTouchEnd);
	
	      _this.onDragStop(event);
	    }, _this.handleTouchStart = function (event) {
	      var _this$props3 = _this.props,
	          axis = _this$props3.axis,
	          disabled = _this$props3.disabled;
	      var isRtl = _this.context.muiTheme.isRtl;
	
	
	      if (disabled) {
	        return;
	      }
	
	      var calculatedAxis = calculateAxis(axis, isRtl);
	
	      var position = void 0;
	      if (isMouseControlInverted(calculatedAxis)) {
	        position = _this.getTrackOffset() - event.touches[0][mainAxisClientOffsetProperty[calculatedAxis]];
	      } else {
	        position = event.touches[0][mainAxisClientOffsetProperty[calculatedAxis]] - _this.getTrackOffset();
	      }
	      _this.setValueFromPosition(event, position);
	
	      document.addEventListener('touchmove', _this.handleTouchMove);
	      document.addEventListener('touchup', _this.handleTouchEnd);
	      document.addEventListener('touchend', _this.handleTouchEnd);
	      document.addEventListener('touchcancel', _this.handleTouchEnd);
	
	      _this.onDragStart(event);
	
	      // Cancel scroll and context menu
	      event.preventDefault();
	    }, _this.handleFocus = function (event) {
	      _this.setState({
	        focused: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        focused: false,
	        active: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      var _this$props4 = _this.props,
	          axis = _this$props4.axis,
	          disabled = _this$props4.disabled;
	      var isRtl = _this.context.muiTheme.isRtl;
	
	
	      if (disabled) {
	        return;
	      }
	
	      var calculatedAxis = calculateAxis(axis, isRtl);
	
	      var position = void 0;
	      if (isMouseControlInverted(calculatedAxis)) {
	        position = _this.getTrackOffset() - event[mainAxisClientOffsetProperty[calculatedAxis]];
	      } else {
	        position = event[mainAxisClientOffsetProperty[calculatedAxis]] - _this.getTrackOffset();
	      }
	      _this.setValueFromPosition(event, position);
	
	      document.addEventListener('mousemove', _this.handleDragMouseMove);
	      document.addEventListener('mouseup', _this.handleMouseEnd);
	
	      // Cancel text selection
	      event.preventDefault();
	
	      // Set focus manually since we called preventDefault()
	      _this.handle.focus();
	
	      _this.onDragStart(event);
	    }, _this.handleMouseUp = function () {
	      if (!_this.props.disabled) {
	        _this.setState({
	          active: false
	        });
	      }
	    }, _this.handleMouseEnter = function () {
	      _this.setState({
	        hovered: true
	      });
	    }, _this.handleMouseLeave = function () {
	      _this.setState({
	        hovered: false
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Slider, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          valueProp = _props.value,
	          defaultValue = _props.defaultValue,
	          min = _props.min;
	
	
	      var value = valueProp;
	      if (value === undefined) {
	        value = defaultValue !== undefined ? defaultValue : min;
	      }
	
	      this.setState({
	        value: this.resolveValue(value)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== undefined && !this.state.dragging) {
	        this.setState({
	          value: this.resolveValue(nextProps.value)
	        });
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	       false ? (0, _warning2.default)(false, 'Material-UI Slider: getValue() method is deprecated.\n      Use the onChange callbacks instead.\n      It will be removed with v0.17.0.') : void 0;
	
	      return this.state.value;
	    }
	  }, {
	    key: 'clearValue',
	    value: function clearValue() {
	       false ? (0, _warning2.default)(false, 'Material-UI Slider: clearValue() method is deprecated.\n      Use the value property to control the component instead.\n      It will be removed with v0.17.0.') : void 0;
	
	      this.setState({
	        value: this.props.min
	      });
	    }
	  }, {
	    key: 'getTrackOffset',
	    value: function getTrackOffset() {
	      var axis = this.props.axis;
	      var isRtl = this.context.muiTheme.isRtl;
	
	
	      var calculatedAxis = calculateAxis(axis, isRtl);
	
	      return this.track.getBoundingClientRect()[mainAxisOffsetProperty[calculatedAxis]];
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(event) {
	      this.setState({
	        dragging: true,
	        active: true
	      });
	
	      if (this.props.onDragStart) {
	        this.props.onDragStart(event);
	      }
	    }
	  }, {
	    key: 'onDragUpdate',
	    value: function onDragUpdate(event, type) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          axis = _props2.axis,
	          disabled = _props2.disabled;
	      var isRtl = this.context.muiTheme.isRtl;
	
	
	      if (this.dragRunning) {
	        return;
	      }
	      this.dragRunning = true;
	
	      requestAnimationFrame(function () {
	        _this2.dragRunning = false;
	
	        var calculatedAxis = calculateAxis(axis, isRtl);
	        var source = type === 'touch' ? event.touches[0] : event;
	
	        var position = void 0;
	        if (isMouseControlInverted(calculatedAxis)) {
	          position = _this2.getTrackOffset() - source[mainAxisClientOffsetProperty[calculatedAxis]];
	        } else {
	          position = source[mainAxisClientOffsetProperty[calculatedAxis]] - _this2.getTrackOffset();
	        }
	
	        if (!disabled) {
	          _this2.setValueFromPosition(event, position);
	        }
	      });
	    }
	  }, {
	    key: 'onDragStop',
	    value: function onDragStop(event) {
	      this.setState({
	        dragging: false,
	        active: false
	      });
	
	      if (this.props.onDragStop) {
	        this.props.onDragStop(event);
	      }
	    }
	  }, {
	    key: 'setValueFromPosition',
	    value: function setValueFromPosition(event, position) {
	      var _props3 = this.props,
	          axis = _props3.axis,
	          step = _props3.step,
	          min = _props3.min,
	          max = _props3.max;
	      var isRtl = this.context.muiTheme.isRtl;
	
	
	      var calculatedAxis = calculateAxis(axis, isRtl);
	      var positionMax = this.track[mainAxisClientProperty[calculatedAxis]];
	
	      var value = void 0;
	
	      if (position <= 0) {
	        value = min;
	      } else if (position >= positionMax) {
	        value = max;
	      } else {
	        value = position / positionMax * (max - min);
	        value = Math.round(value / step) * step + min;
	        value = parseFloat(value.toFixed(5));
	      }
	
	      value = this.resolveValue(value);
	
	      if (this.state.value !== value) {
	        this.setState({
	          value: value
	        });
	
	        if (this.props.onChange) {
	          this.props.onChange(event, value);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props4 = this.props,
	          axis = _props4.axis,
	          disabled = _props4.disabled,
	          disableFocusRipple = _props4.disableFocusRipple,
	          max = _props4.max,
	          min = _props4.min,
	          name = _props4.name,
	          onBlur = _props4.onBlur,
	          onChange = _props4.onChange,
	          onDragStart = _props4.onDragStart,
	          onDragStop = _props4.onDragStop,
	          onFocus = _props4.onFocus,
	          required = _props4.required,
	          sliderStyle = _props4.sliderStyle,
	          step = _props4.step,
	          style = _props4.style,
	          propValue = _props4.value,
	          other = (0, _objectWithoutProperties3.default)(_props4, ['axis', 'disabled', 'disableFocusRipple', 'max', 'min', 'name', 'onBlur', 'onChange', 'onDragStart', 'onDragStop', 'onFocus', 'required', 'sliderStyle', 'step', 'style', 'value']);
	      var _state = this.state,
	          active = _state.active,
	          focused = _state.focused,
	          hovered = _state.hovered,
	          value = _state.value;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var percent = getPercent(value, min, max);
	
	      var handleStyles = {};
	      if (percent === 0) {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, styles.handleWhenPercentZero, active && styles.handleWhenActive, (hovered || focused) && !disabled && styles.handleWhenPercentZeroAndFocused, disabled && styles.handleWhenPercentZeroAndDisabled);
	      } else {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, active && styles.handleWhenActive, disabled && styles.handleWhenDisabled);
	      }
	
	      var rippleStyle = (0, _simpleAssign2.default)({}, styles.ripple, percent === 0 && styles.rippleWhenPercentZero);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, style)) }),
	        _react2.default.createElement(
	          'div',
	          {
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.slider, sliderStyle)),
	            onFocus: this.handleFocus,
	            onBlur: this.handleBlur,
	            onMouseDown: this.handleMouseDown,
	            onMouseEnter: this.handleMouseEnter,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseUp: this.handleMouseUp,
	            onTouchStart: this.handleTouchStart,
	            onKeyDown: !disabled && this.handleKeyDown
	          },
	          _react2.default.createElement(
	            'div',
	            { ref: function ref(node) {
	                return _this3.track = node;
	              }, style: prepareStyles(styles.track) },
	            _react2.default.createElement('div', { style: prepareStyles(styles.filled) }),
	            _react2.default.createElement('div', { style: prepareStyles(styles.remaining) }),
	            _react2.default.createElement(
	              'div',
	              {
	                ref: function ref(node) {
	                  return _this3.handle = node;
	                },
	                style: prepareStyles(handleStyles),
	                tabIndex: 0
	              },
	              !disabled && !disableFocusRipple && _react2.default.createElement(_FocusRipple2.default, {
	                style: rippleStyle,
	                innerStyle: styles.rippleInner,
	                show: (hovered || focused) && !active,
	                color: styles.rippleColor.fill
	              })
	            )
	          )
	        ),
	        _react2.default.createElement('input', {
	          type: 'hidden',
	          name: name,
	          value: value,
	          required: required,
	          min: min,
	          max: max,
	          step: step
	        })
	      );
	    }
	  }]);
	  return Slider;
	}(_react.Component);
	
	Slider.defaultProps = {
	  axis: 'x',
	  disabled: false,
	  disableFocusRipple: false,
	  max: 1,
	  min: 0,
	  required: true,
	  step: 0.01,
	  style: {}
	};
	Slider.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Slider.propTypes =  false ? {
	  /**
	   * The axis on which the slider will slide.
	   */
	  axis: _propTypes2.default.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
	  /**
	   * The default value of the slider.
	   */
	  defaultValue: valueInRangePropType,
	  /**
	   * Disables focus ripple if set to true.
	   */
	  disableFocusRipple: _propTypes2.default.bool,
	  /**
	   * If true, the slider will not be interactable.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The maximum value the slider can slide to on
	   * a scale from 0 to 1 inclusive. Cannot be equal to min.
	   */
	  max: minMaxPropType,
	  /**
	   * The minimum value the slider can slide to on a scale
	   * from 0 to 1 inclusive. Cannot be equal to max.
	   */
	  min: minMaxPropType,
	  /**
	   * The name of the slider. Behaves like the name attribute
	   * of an input element.
	   */
	  name: _propTypes2.default.string,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the slider's value changed.
	   *
	   * @param {object} event KeyDown event targeting the slider.
	   * @param {number} newValue The new value of the slider.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the slider has begun to move.
	   *
	   * @param {object} event MouseDown or TouchStart event targeting the slider.
	   */
	  onDragStart: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the slide has stopped moving.
	   *
	   * @param {object} event MouseEnd or TouchEnd event targeting the slider.
	   */
	  onDragStop: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Whether or not the slider is required in a form.
	   */
	  required: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the inner slider element.
	   */
	  sliderStyle: _propTypes2.default.object,
	  /**
	   * The granularity the slider can step through values.
	   */
	  step: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The value of the slider.
	   */
	  value: valueInRangePropType
	} : {};
	exports.default = Slider;

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Slider = __webpack_require__(1538);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Slider2.default;

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ClickAwayListener = __webpack_require__(496);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _SnackbarBody = __webpack_require__(1541);
	
	var _SnackbarBody2 = _interopRequireDefault(_SnackbarBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      desktopSubheaderHeight = _context$muiTheme.baseTheme.spacing.desktopSubheaderHeight,
	      zIndex = _context$muiTheme.zIndex;
	  var open = state.open;
	
	
	  var styles = {
	    root: {
	      position: 'fixed',
	      left: '50%',
	      display: 'flex',
	      bottom: 0,
	      zIndex: zIndex.snackbar,
	      visibility: open ? 'visible' : 'hidden',
	      transform: open ? 'translate(-50%, 0)' : 'translate(-50%, ' + desktopSubheaderHeight + 'px)',
	      transition: _transitions2.default.easeOut('400ms', 'transform') + ', ' + _transitions2.default.easeOut('400ms', 'visibility')
	    }
	  };
	
	  return styles;
	}
	
	var Snackbar = function (_Component) {
	  (0, _inherits3.default)(Snackbar, _Component);
	
	  function Snackbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Snackbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Snackbar.__proto__ || (0, _getPrototypeOf2.default)(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.componentClickAway = function () {
	      if (_this.timerTransitionId) {
	        // If transitioning, don't close the snackbar.
	        return;
	      }
	
	      if (_this.props.open !== null && _this.props.onRequestClose) {
	        _this.props.onRequestClose('clickaway');
	      } else {
	        _this.setState({ open: false });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Snackbar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        open: this.props.open,
	        message: this.props.message,
	        action: this.props.action
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.open) {
	        this.setAutoHideTimer();
	        this.setTransitionTimer();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.props.open && nextProps.open && (nextProps.message !== this.props.message || nextProps.action !== this.props.action)) {
	        this.setState({
	          open: false
	        });
	
	        clearTimeout(this.timerOneAtTheTimeId);
	        this.timerOneAtTheTimeId = setTimeout(function () {
	          _this2.setState({
	            message: nextProps.message,
	            action: nextProps.action,
	            open: true
	          });
	        }, 400);
	      } else {
	        var open = nextProps.open;
	
	        this.setState({
	          open: open !== null ? open : this.state.open,
	          message: nextProps.message,
	          action: nextProps.action
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.open !== this.state.open) {
	        if (this.state.open) {
	          this.setAutoHideTimer();
	          this.setTransitionTimer();
	        } else {
	          clearTimeout(this.timerAutoHideId);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerAutoHideId);
	      clearTimeout(this.timerTransitionId);
	      clearTimeout(this.timerOneAtTheTimeId);
	    }
	  }, {
	    key: 'setAutoHideTimer',
	
	
	    // Timer that controls delay before snackbar auto hides
	    value: function setAutoHideTimer() {
	      var _this3 = this;
	
	      var autoHideDuration = this.props.autoHideDuration;
	
	      if (autoHideDuration > 0) {
	        clearTimeout(this.timerAutoHideId);
	        this.timerAutoHideId = setTimeout(function () {
	          if (_this3.props.open !== null && _this3.props.onRequestClose) {
	            _this3.props.onRequestClose('timeout');
	          } else {
	            _this3.setState({ open: false });
	          }
	        }, autoHideDuration);
	      }
	    }
	
	    // Timer that controls delay before click-away events are captured (based on when animation completes)
	
	  }, {
	    key: 'setTransitionTimer',
	    value: function setTransitionTimer() {
	      var _this4 = this;
	
	      this.timerTransitionId = setTimeout(function () {
	        _this4.timerTransitionId = undefined;
	      }, 400);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoHideDuration = _props.autoHideDuration,
	          contentStyle = _props.contentStyle,
	          bodyStyle = _props.bodyStyle,
	          messageProp = _props.message,
	          onRequestClose = _props.onRequestClose,
	          onActionTouchTap = _props.onActionTouchTap,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoHideDuration', 'contentStyle', 'bodyStyle', 'message', 'onRequestClose', 'onActionTouchTap', 'style']);
	      var _state = this.state,
	          action = _state.action,
	          message = _state.message,
	          open = _state.open;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: open ? this.componentClickAway : null },
	        _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	          _react2.default.createElement(_SnackbarBody2.default, {
	            action: action,
	            contentStyle: contentStyle,
	            message: message,
	            open: open,
	            onActionTouchTap: onActionTouchTap,
	            style: bodyStyle
	          })
	        )
	      );
	    }
	  }]);
	  return Snackbar;
	}(_react.Component);
	
	Snackbar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Snackbar.propTypes =  false ? {
	  /**
	   * The label for the action on the snackbar.
	   */
	  action: _propTypes2.default.node,
	  /**
	   * The number of milliseconds to wait before automatically dismissing.
	   * If no value is specified the snackbar will dismiss normally.
	   * If a value is provided the snackbar can still be dismissed normally.
	   * If a snackbar is dismissed before the timer expires, the timer will be cleared.
	   */
	  autoHideDuration: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the body element.
	   */
	  bodyStyle: _propTypes2.default.object,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the content element.
	   */
	  contentStyle: _propTypes2.default.object,
	  /**
	   * The message to be displayed.
	   *
	   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
	   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
	   * showing again)
	   */
	  message: _propTypes2.default.node.isRequired,
	  /**
	   * Fired when the action button is touchtapped.
	   *
	   * @param {object} event Action button event.
	   */
	  onActionTouchTap: _propTypes2.default.func,
	  /**
	   * Fired when the `Snackbar` is requested to be closed by a click outside the `Snackbar`, or after the
	   * `autoHideDuration` timer expires.
	   *
	   * Typically `onRequestClose` is used to set state in the parent component, which is used to control the `Snackbar`
	   * `open` prop.
	   *
	   * The `reason` parameter can optionally be used to control the response to `onRequestClose`,
	   * for example ignoring `clickaway`.
	   *
	   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
	   */
	  onRequestClose: _propTypes2.default.func,
	  /**
	   * Controls whether the `Snackbar` is opened or not.
	   */
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Snackbar;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SnackbarBody = undefined;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _withWidth = __webpack_require__(1622);
	
	var _withWidth2 = _interopRequireDefault(_withWidth);
	
	var _FlatButton = __webpack_require__(36);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var open = props.open,
	      width = props.width;
	  var _context$muiTheme = context.muiTheme,
	      _context$muiTheme$bas = _context$muiTheme.baseTheme,
	      _context$muiTheme$bas2 = _context$muiTheme$bas.spacing,
	      desktopGutter = _context$muiTheme$bas2.desktopGutter,
	      desktopSubheaderHeight = _context$muiTheme$bas2.desktopSubheaderHeight,
	      fontFamily = _context$muiTheme$bas.fontFamily,
	      _context$muiTheme$sna = _context$muiTheme.snackbar,
	      backgroundColor = _context$muiTheme$sna.backgroundColor,
	      textColor = _context$muiTheme$sna.textColor,
	      actionColor = _context$muiTheme$sna.actionColor,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  var isSmall = width === _withWidth.SMALL;
	
	  var styles = {
	    root: {
	      fontFamily: fontFamily,
	      backgroundColor: backgroundColor,
	      padding: '0 ' + desktopGutter + 'px',
	      height: desktopSubheaderHeight,
	      lineHeight: desktopSubheaderHeight + 'px',
	      borderRadius: isSmall ? 0 : borderRadius,
	      maxWidth: isSmall ? 'inherit' : 568,
	      minWidth: isSmall ? 'inherit' : 288,
	      width: isSmall ? 'calc(100vw - ' + desktopGutter * 2 + 'px)' : 'auto',
	      flexGrow: isSmall ? 1 : 0
	    },
	    content: {
	      fontSize: 14,
	      color: textColor,
	      opacity: open ? 1 : 0,
	      transition: open ? _transitions2.default.easeOut('500ms', 'opacity', '100ms') : _transitions2.default.easeOut('400ms', 'opacity')
	    },
	    action: {
	      color: actionColor,
	      float: 'right',
	      marginTop: 6,
	      marginRight: -16,
	      marginLeft: desktopGutter,
	      backgroundColor: 'transparent'
	    }
	  };
	
	  return styles;
	}
	
	var SnackbarBody = function SnackbarBody(props, context) {
	  var action = props.action,
	      contentStyle = props.contentStyle,
	      message = props.message,
	      open = props.open,
	      onActionTouchTap = props.onActionTouchTap,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['action', 'contentStyle', 'message', 'open', 'onActionTouchTap', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var actionButton = action && _react2.default.createElement(_FlatButton2.default, {
	    style: styles.action,
	    label: action,
	    onClick: onActionTouchTap
	  });
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	    _react2.default.createElement(
	      'div',
	      { style: prepareStyles((0, _simpleAssign2.default)(styles.content, contentStyle)) },
	      _react2.default.createElement(
	        'span',
	        null,
	        message
	      ),
	      actionButton
	    )
	  );
	};
	
	exports.SnackbarBody = SnackbarBody;
	SnackbarBody.propTypes =  false ? {
	  /**
	   * The label for the action on the snackbar.
	   */
	  action: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the content element.
	   */
	  contentStyle: _propTypes2.default.object,
	  /**
	   * The message to be displayed.
	   *
	   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
	   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
	   * showing again)
	   */
	  message: _propTypes2.default.node.isRequired,
	  /**
	   * Fired when the action button is touchtapped.
	   *
	   * @param {object} event Action button event.
	   */
	  onActionTouchTap: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Controls whether the `Snackbar` is opened or not.
	   */
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * @ignore
	   * Width of the screen.
	   */
	  width: _propTypes2.default.number.isRequired
	} : {};
	
	SnackbarBody.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _withWidth2.default)()(SnackbarBody);

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Snackbar = __webpack_require__(1540);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Snackbar2.default;

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PlainStepConnector = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	};
	
	var contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	
	var StepConnector = function StepConnector(props, context) {
	  var muiTheme = context.muiTheme,
	      stepper = context.stepper;
	
	
	  var styles = {
	    wrapper: {
	      flex: '1 1 auto'
	    },
	    line: {
	      display: 'block',
	      borderColor: muiTheme.stepper.connectorLineColor
	    }
	  };
	
	  /**
	   * Clean up once we can use CSS pseudo elements
	   */
	  if (stepper.orientation === 'horizontal') {
	    styles.line.marginLeft = -6;
	    styles.line.borderTopStyle = 'solid';
	    styles.line.borderTopWidth = 1;
	  } else if (stepper.orientation === 'vertical') {
	    styles.wrapper.marginLeft = 14 + 11; // padding + 1/2 icon
	    styles.line.borderLeftStyle = 'solid';
	    styles.line.borderLeftWidth = 1;
	    styles.line.minHeight = 28;
	  }
	
	  var prepareStyles = muiTheme.prepareStyles;
	
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles(styles.wrapper) },
	    _react2.default.createElement('span', { style: prepareStyles(styles.line) })
	  );
	};
	
	StepConnector.propTypes =  false ? propTypes : {};
	StepConnector.contextTypes = contextTypes;
	
	exports.PlainStepConnector = StepConnector;
	exports.default = (0, _pure2.default)(StepConnector);

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Subheader = function Subheader(props, context) {
	  var children = props.children,
	      inset = props.inset,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'inset', 'style']);
	  var _context$muiTheme = context.muiTheme,
	      prepareStyles = _context$muiTheme.prepareStyles,
	      subheader = _context$muiTheme.subheader;
	
	
	  var styles = {
	    root: {
	      boxSizing: 'border-box',
	      color: subheader.color,
	      fontSize: 14,
	      fontWeight: subheader.fontWeight,
	      lineHeight: '48px',
	      paddingLeft: inset ? 72 : 16,
	      width: '100%'
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	    children
	  );
	};
	
	Subheader.muiName = 'Subheader';
	
	Subheader.propTypes =  false ? {
	  /**
	   * Node that will be placed inside the `Subheader`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, the `Subheader` will be indented.
	   */
	  inset: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	Subheader.defaultProps = {
	  inset: false
	};
	
	Subheader.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Subheader;

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SvgIcon = function (_Component) {
	  (0, _inherits3.default)(SvgIcon, _Component);
	
	  function SvgIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SvgIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SvgIcon.__proto__ || (0, _getPrototypeOf2.default)(SvgIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SvgIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          color = _props.color,
	          hoverColor = _props.hoverColor,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          style = _props.style,
	          viewBox = _props.viewBox,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);
	      var _context$muiTheme = this.context.muiTheme,
	          svgIcon = _context$muiTheme.svgIcon,
	          prepareStyles = _context$muiTheme.prepareStyles;
	
	
	      var offColor = color ? color : 'currentColor';
	      var onColor = hoverColor ? hoverColor : offColor;
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        display: 'inline-block',
	        color: svgIcon.color,
	        fill: this.state.hovered ? onColor : offColor,
	        height: 24,
	        width: 24,
	        userSelect: 'none',
	        transition: _transitions2.default.easeOut()
	      }, style);
	
	      return _react2.default.createElement(
	        'svg',
	        (0, _extends3.default)({}, other, {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          style: prepareStyles(mergedStyles),
	          viewBox: viewBox
	        }),
	        children
	      );
	    }
	  }]);
	  return SvgIcon;
	}(_react.Component);
	
	SvgIcon.muiName = 'SvgIcon';
	SvgIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  viewBox: '0 0 24 24'
	};
	SvgIcon.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	SvgIcon.propTypes =  false ? {
	  /**
	   * Elements passed into the SVG Icon.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * This is the fill color of the svg icon.
	   * If not specified, this component will default
	   * to muiTheme.palette.textColor.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _propTypes2.default.string,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Allows you to redefine what the coordinates
	   * without units mean inside an svg element. For example,
	   * if the SVG element is 500 (width) by 200 (height), and you
	   * pass viewBox="0 0 50 20", this means that the coordinates inside
	   * the svg will go from the top left corner (0,0) to bottom right (50,20)
	   * and each unit will be worth 10px.
	   */
	  viewBox: _propTypes2.default.string
	} : {};
	exports.default = SvgIcon;

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      table = _context$muiTheme.table;
	
	
	  return {
	    root: {
	      backgroundColor: table.backgroundColor,
	      width: '100%',
	      borderCollapse: 'collapse',
	      borderSpacing: 0,
	      tableLayout: 'fixed',
	      fontFamily: baseTheme.fontFamily
	    },
	    bodyTable: {
	      height: props.fixedHeader || props.fixedFooter ? props.height : 'auto',
	      overflowX: 'hidden',
	      overflowY: 'auto'
	    },
	    tableWrapper: {
	      height: props.fixedHeader || props.fixedFooter ? 'auto' : props.height,
	      overflow: 'auto'
	    }
	  };
	}
	
	var Table = function (_Component) {
	  (0, _inherits3.default)(Table, _Component);
	
	  function Table() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Table);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      allRowsSelected: false
	    }, _this.onCellClick = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellClick) _this.props.onCellClick(rowNumber, columnNumber, event);
	    }, _this.onCellHover = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellHover) _this.props.onCellHover(rowNumber, columnNumber, event);
	    }, _this.onCellHoverExit = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(rowNumber, columnNumber, event);
	    }, _this.onRowHover = function (rowNumber) {
	      if (_this.props.onRowHover) _this.props.onRowHover(rowNumber);
	    }, _this.onRowHoverExit = function (rowNumber) {
	      if (_this.props.onRowHoverExit) _this.props.onRowHoverExit(rowNumber);
	    }, _this.onRowSelection = function (selectedRows) {
	      if (_this.state.allRowsSelected) {
	        _this.setState({ allRowsSelected: false });
	      }
	
	      if (_this.props.onRowSelection) {
	        _this.props.onRowSelection(selectedRows);
	      }
	    }, _this.onSelectAll = function () {
	      if (_this.props.onRowSelection) {
	        if (!_this.state.allRowsSelected) {
	          _this.props.onRowSelection('all');
	        } else {
	          _this.props.onRowSelection('none');
	        }
	      }
	
	      _this.setState({ allRowsSelected: !_this.state.allRowsSelected });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Table, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.allRowsSelected) {
	        this.setState({ allRowsSelected: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.allRowsSelected !== nextProps.allRowsSelected) {
	        this.setState({ allRowsSelected: nextProps.allRowsSelected });
	      }
	    }
	  }, {
	    key: 'isScrollbarVisible',
	    value: function isScrollbarVisible() {
	      var tableDivHeight = this.refs.tableDiv.clientHeight;
	      var tableBodyHeight = this.refs.tableBody.clientHeight;
	
	      return tableBodyHeight > tableDivHeight;
	    }
	  }, {
	    key: 'createTableHeader',
	    value: function createTableHeader(base) {
	      return _react2.default.cloneElement(base, {
	        enableSelectAll: base.props.enableSelectAll && this.props.selectable && this.props.multiSelectable,
	        onSelectAll: this.onSelectAll,
	        selectAllSelected: this.state.allRowsSelected
	      });
	    }
	  }, {
	    key: 'createTableBody',
	    value: function createTableBody(base) {
	      return _react2.default.cloneElement(base, {
	        allRowsSelected: this.state.allRowsSelected,
	        multiSelectable: this.props.multiSelectable,
	        onCellClick: this.onCellClick,
	        onCellHover: this.onCellHover,
	        onCellHoverExit: this.onCellHoverExit,
	        onRowHover: this.onRowHover,
	        onRowHoverExit: this.onRowHoverExit,
	        onRowSelection: this.onRowSelection,
	        selectable: this.props.selectable
	      });
	    }
	  }, {
	    key: 'createTableFooter',
	    value: function createTableFooter(base) {
	      return base;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          fixedFooter = _props.fixedFooter,
	          fixedHeader = _props.fixedHeader,
	          style = _props.style,
	          wrapperStyle = _props.wrapperStyle,
	          headerStyle = _props.headerStyle,
	          bodyStyle = _props.bodyStyle,
	          footerStyle = _props.footerStyle;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var tHead = void 0;
	      var tFoot = void 0;
	      var tBody = void 0;
	
	      _react2.default.Children.forEach(children, function (child) {
	        if (!_react2.default.isValidElement(child)) return;
	
	        var muiName = child.type.muiName;
	
	        if (muiName === 'TableBody') {
	          tBody = _this2.createTableBody(child);
	        } else if (muiName === 'TableHeader') {
	          tHead = _this2.createTableHeader(child);
	        } else if (muiName === 'TableFooter') {
	          tFoot = _this2.createTableFooter(child);
	        } else {
	           false ? (0, _warning2.default)(false, 'Material-UI: Children of the Table component must be TableBody or TableHeader or TableFooter.\n           Nothing is rendered.') : void 0;
	        }
	      });
	
	      // If we could not find a table-header and a table-body, do not attempt to display anything.
	      if (!tBody && !tHead) return null;
	
	      var mergedTableStyle = (0, _simpleAssign2.default)(styles.root, style);
	      var headerTable = void 0;
	      var footerTable = void 0;
	      var inlineHeader = void 0;
	      var inlineFooter = void 0;
	
	      if (fixedHeader) {
	        headerTable = _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)({}, headerStyle)) },
	          _react2.default.createElement(
	            'table',
	            { className: className, style: mergedTableStyle },
	            tHead
	          )
	        );
	      } else {
	        inlineHeader = tHead;
	      }
	
	      if (tFoot !== undefined) {
	        if (fixedFooter) {
	          footerTable = _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, footerStyle)) },
	            _react2.default.createElement(
	              'table',
	              { className: className, style: prepareStyles(mergedTableStyle) },
	              tFoot
	            )
	          );
	        } else {
	          inlineFooter = tFoot;
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.tableWrapper, wrapperStyle)) },
	        headerTable,
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.bodyTable, bodyStyle)), ref: 'tableDiv' },
	          _react2.default.createElement(
	            'table',
	            { className: className, style: mergedTableStyle, ref: 'tableBody' },
	            inlineHeader,
	            inlineFooter,
	            tBody
	          )
	        ),
	        footerTable
	      );
	    }
	  }]);
	  return Table;
	}(_react.Component);
	
	Table.defaultProps = {
	  allRowsSelected: false,
	  fixedFooter: true,
	  fixedHeader: true,
	  height: 'inherit',
	  multiSelectable: false,
	  selectable: true
	};
	Table.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Table.propTypes =  false ? {
	  /**
	   * Set to true to indicate that all rows should be selected.
	   */
	  allRowsSelected: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the body's table element.
	   */
	  bodyStyle: _propTypes2.default.object,
	  /**
	   * Children passed to table.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If true, the footer will appear fixed below the table.
	   * The default value is true.
	   */
	  fixedFooter: _propTypes2.default.bool,
	  /**
	   * If true, the header will appear fixed above the table.
	   * The default value is true.
	   */
	  fixedHeader: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the footer's table element.
	   */
	  footerStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the header's table element.
	   */
	  headerStyle: _propTypes2.default.object,
	  /**
	   * The height of the table.
	   */
	  height: _propTypes2.default.string,
	  /**
	   * If true, multiple table rows can be selected.
	   * CTRL/CMD+Click and SHIFT+Click are valid actions.
	   * The default value is false.
	   */
	  multiSelectable: _propTypes2.default.bool,
	  /**
	   * Called when a row cell is clicked.
	   * rowNumber is the row number and columnId is
	   * the column number or the column key.
	   */
	  onCellClick: _propTypes2.default.func,
	  /**
	   * Called when a table cell is hovered.
	   * rowNumber is the row number of the hovered row
	   * and columnId is the column number or the column key of the cell.
	   */
	  onCellHover: _propTypes2.default.func,
	  /**
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _propTypes2.default.func,
	  /**
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _propTypes2.default.func,
	  /**
	   * Called when a table row is no longer hovered.
	   * rowNumber is the row number of the row that is no longer hovered.
	   */
	  onRowHoverExit: _propTypes2.default.func,
	  /**
	   * Called when a row is selected.
	   * selectedRows is an array of all row selections.
	   * IF all rows have been selected, the string "all"
	   * will be returned instead to indicate that all rows have been selected.
	   */
	  onRowSelection: _propTypes2.default.func,
	  /**
	   * If true, table rows can be selected.
	   * If multiple row selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the table's wrapper element.
	   */
	  wrapperStyle: _propTypes2.default.object
	} : {};
	exports.default = Table;

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      inkBar = _context$muiTheme.inkBar,
	      isRtl = _context$muiTheme.isRtl;
	
	
	  return {
	    root: {
	      left: props.left,
	      width: props.width,
	      bottom: 0,
	      display: 'block',
	      backgroundColor: props.color || inkBar.backgroundColor,
	      height: 2,
	      marginTop: -2,
	      position: 'relative',
	      transition: _transitions2.default.easeOut('1s', isRtl ? 'right' : 'left')
	    }
	  };
	}
	
	var InkBar = function (_Component) {
	  (0, _inherits3.default)(InkBar, _Component);
	
	  function InkBar() {
	    (0, _classCallCheck3.default)(this, InkBar);
	    return (0, _possibleConstructorReturn3.default)(this, (InkBar.__proto__ || (0, _getPrototypeOf2.default)(InkBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InkBar, [{
	    key: 'render',
	    value: function render() {
	      var style = this.props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) });
	    }
	  }]);
	  return InkBar;
	}(_react.Component);
	
	InkBar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	InkBar.propTypes =  false ? {
	  color: _propTypes2.default.string,
	  left: _propTypes2.default.string.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  width: _propTypes2.default.string.isRequired
	} : {};
	exports.default = InkBar;

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  width: '100%',
	  position: 'relative',
	  textAlign: 'initial'
	};
	
	var TabTemplate = function TabTemplate(_ref) {
	  var children = _ref.children,
	      selected = _ref.selected,
	      style = _ref.style;
	
	  var templateStyle = (0, _simpleAssign2.default)({}, styles, style);
	  if (!selected) {
	    templateStyle.height = 0;
	    templateStyle.overflow = 'hidden';
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: templateStyle },
	    children
	  );
	};
	
	TabTemplate.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  selected: _propTypes2.default.bool,
	  style: _propTypes2.default.object
	} : {};
	
	exports.default = TabTemplate;

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Tabs = exports.Tab = undefined;
	
	var _Tab2 = __webpack_require__(102);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _Tabs2 = __webpack_require__(107);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Tab = _Tab3.default;
	exports.Tabs = _Tabs3.default;
	exports.default = _Tabs3.default;

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(165);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rowsHeight = 24;
	
	function getStyles(props, context, state) {
	  return {
	    root: {
	      position: 'relative' // because the shadow has position: 'absolute'
	    },
	    textarea: {
	      height: state.height,
	      width: '100%',
	      resize: 'none',
	      font: 'inherit',
	      padding: 0,
	      cursor: 'inherit'
	    },
	    shadow: {
	      resize: 'none',
	      // Overflow also needed to here to remove the extra row
	      // added to textareas in Firefox.
	      overflow: 'hidden',
	      // Visibility needed to hide the extra text area on ipads
	      visibility: 'hidden',
	      position: 'absolute',
	      height: 'auto'
	    }
	  };
	}
	
	var EnhancedTextarea = function (_Component) {
	  (0, _inherits3.default)(EnhancedTextarea, _Component);
	
	  function EnhancedTextarea() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedTextarea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedTextarea.__proto__ || (0, _getPrototypeOf2.default)(EnhancedTextarea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      height: null
	    }, _this.handleResize = function (event) {
	      _this.syncHeightWithShadow(_this.props.value, event);
	    }, _this.handleChange = function (event) {
	      if (!_this.props.hasOwnProperty('value')) {
	        _this.syncHeightWithShadow(event.target.value);
	      }
	
	      if (_this.props.hasOwnProperty('valueLink')) {
	        _this.props.valueLink.requestChange(event.target.value);
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedTextarea, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        height: this.props.rows * rowsHeight
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.syncHeightWithShadow(this.props.value);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value || nextProps.rowsMax !== this.props.rowsMax) {
	        this.syncHeightWithShadow(nextProps.value, null, nextProps);
	      }
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.refs.input;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.getInputNode().value = value;
	      this.syncHeightWithShadow(value);
	    }
	  }, {
	    key: 'syncHeightWithShadow',
	    value: function syncHeightWithShadow(newValue, event, props) {
	      var shadow = this.refs.shadow;
	      var displayText = this.props.hintText && (newValue === '' || newValue === undefined || newValue === null) ? this.props.hintText : newValue;
	
	      if (displayText !== undefined) {
	        shadow.value = displayText;
	      }
	
	      var newHeight = shadow.scrollHeight;
	
	      // Guarding for jsdom, where scrollHeight isn't present.
	      // See https://github.com/tmpvar/jsdom/issues/1013
	      if (newHeight === undefined) return;
	
	      props = props || this.props;
	
	      if (props.rowsMax >= props.rows) {
	        newHeight = Math.min(props.rowsMax * rowsHeight, newHeight);
	      }
	
	      newHeight = Math.max(newHeight, rowsHeight);
	
	      if (this.state.height !== newHeight) {
	        var input = this.refs.input;
	        var cursorPosition = input.selectionStart;
	        this.setState({
	          height: newHeight
	        }, function () {
	          input.setSelectionRange(cursorPosition, cursorPosition);
	        });
	
	        if (props.onHeightChange) {
	          props.onHeightChange(event, newHeight);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onChange = _props.onChange,
	          onHeightChange = _props.onHeightChange,
	          rows = _props.rows,
	          rowsMax = _props.rowsMax,
	          shadowStyle = _props.shadowStyle,
	          style = _props.style,
	          hintText = _props.hintText,
	          textareaStyle = _props.textareaStyle,
	          valueLink = _props.valueLink,
	          other = (0, _objectWithoutProperties3.default)(_props, ['onChange', 'onHeightChange', 'rows', 'rowsMax', 'shadowStyle', 'style', 'hintText', 'textareaStyle', 'valueLink']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var rootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var textareaStyles = (0, _simpleAssign2.default)(styles.textarea, textareaStyle);
	      var shadowStyles = (0, _simpleAssign2.default)({}, textareaStyles, styles.shadow, shadowStyle);
	      var props = {};
	
	      if (this.props.hasOwnProperty('valueLink')) {
	        other.value = valueLink.value;
	        props.valueLink = valueLink;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(rootStyles) },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
	        _react2.default.createElement('textarea', (0, _extends3.default)({
	          ref: 'shadow',
	          style: prepareStyles(shadowStyles),
	          tabIndex: '-1',
	          rows: this.props.rows,
	          defaultValue: this.props.defaultValue,
	          readOnly: true,
	          value: this.props.value
	        }, props)),
	        _react2.default.createElement('textarea', (0, _extends3.default)({}, other, {
	          ref: 'input',
	          rows: this.props.rows,
	          style: prepareStyles(textareaStyles),
	          onChange: this.handleChange
	        }))
	      );
	    }
	  }]);
	  return EnhancedTextarea;
	}(_react.Component);
	
	EnhancedTextarea.defaultProps = {
	  rows: 1
	};
	EnhancedTextarea.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	EnhancedTextarea.propTypes =  false ? {
	  defaultValue: _propTypes2.default.any,
	  disabled: _propTypes2.default.bool,
	  hintText: _propTypes2.default.node,
	  onChange: _propTypes2.default.func,
	  onHeightChange: _propTypes2.default.func,
	  rows: _propTypes2.default.number,
	  rowsMax: _propTypes2.default.number,
	  shadowStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  textareaStyle: _propTypes2.default.object,
	  value: _propTypes2.default.string,
	  valueLink: _propTypes2.default.object
	} : {};
	exports.default = EnhancedTextarea;

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(212);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedTextarea = __webpack_require__(1550);
	
	var _EnhancedTextarea2 = _interopRequireDefault(_EnhancedTextarea);
	
	var _TextFieldHint = __webpack_require__(1552);
	
	var _TextFieldHint2 = _interopRequireDefault(_TextFieldHint);
	
	var _TextFieldLabel = __webpack_require__(1553);
	
	var _TextFieldLabel2 = _interopRequireDefault(_TextFieldLabel);
	
	var _TextFieldUnderline = __webpack_require__(1554);
	
	var _TextFieldUnderline2 = _interopRequireDefault(_TextFieldUnderline);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      _context$muiTheme$tex = _context$muiTheme.textField,
	      floatingLabelColor = _context$muiTheme$tex.floatingLabelColor,
	      focusColor = _context$muiTheme$tex.focusColor,
	      textColor = _context$muiTheme$tex.textColor,
	      disabledTextColor = _context$muiTheme$tex.disabledTextColor,
	      backgroundColor = _context$muiTheme$tex.backgroundColor,
	      errorColor = _context$muiTheme$tex.errorColor;
	
	
	  var styles = {
	    root: {
	      fontSize: 16,
	      lineHeight: '24px',
	      width: props.fullWidth ? '100%' : 256,
	      height: (props.rows - 1) * 24 + (props.floatingLabelText ? 72 : 48),
	      display: 'inline-block',
	      position: 'relative',
	      backgroundColor: backgroundColor,
	      fontFamily: baseTheme.fontFamily,
	      transition: _transitions2.default.easeOut('200ms', 'height'),
	      cursor: props.disabled ? 'not-allowed' : 'auto'
	    },
	    error: {
	      position: 'relative',
	      bottom: 2,
	      fontSize: 12,
	      lineHeight: '12px',
	      color: errorColor,
	      transition: _transitions2.default.easeOut()
	    },
	    floatingLabel: {
	      color: props.disabled ? disabledTextColor : floatingLabelColor,
	      pointerEvents: 'none'
	    },
	    input: {
	      padding: 0,
	      position: 'relative',
	      width: '100%',
	      border: 'none',
	      outline: 'none',
	      backgroundColor: 'rgba(0,0,0,0)',
	      color: props.disabled ? disabledTextColor : textColor,
	      cursor: 'inherit',
	      font: 'inherit',
	      WebkitOpacity: 1,
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)' // Remove mobile color flashing (deprecated style).
	    },
	    inputNative: {
	      appearance: 'textfield' // Improve type search style.
	    }
	  };
	
	  styles.textarea = (0, _simpleAssign2.default)({}, styles.input, {
	    marginTop: props.floatingLabelText ? 36 : 12,
	    marginBottom: props.floatingLabelText ? -36 : -12,
	    boxSizing: 'border-box',
	    font: 'inherit'
	  });
	
	  // Do not assign a height to the textarea as he handles it on his own.
	  styles.input.height = '100%';
	
	  if (state.isFocused) {
	    styles.floatingLabel.color = focusColor;
	  }
	
	  if (props.floatingLabelText) {
	    styles.input.boxSizing = 'border-box';
	
	    if (!props.multiLine) {
	      styles.input.marginTop = 14;
	    }
	
	    if (state.errorText) {
	      styles.error.bottom = !props.multiLine ? styles.error.fontSize + 3 : 3;
	    }
	  }
	
	  if (state.errorText) {
	    if (state.isFocused) {
	      styles.floatingLabel.color = styles.error.color;
	    }
	  }
	
	  return styles;
	};
	
	/**
	 * Check if a value is valid to be displayed inside an input.
	 *
	 * @param The value to check.
	 * @returns True if the string provided is valid, false otherwise.
	 */
	function isValid(value) {
	  return value !== '' && value !== undefined && value !== null && !(Array.isArray(value) && value.length === 0);
	}
	
	var TextField = function (_Component) {
	  (0, _inherits3.default)(TextField, _Component);
	
	  function TextField() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TextField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextField.__proto__ || (0, _getPrototypeOf2.default)(TextField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isFocused: false,
	      errorText: undefined,
	      hasValue: false
	    }, _this.handleInputBlur = function (event) {
	      _this.setState({ isFocused: false });
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleInputChange = function (event) {
	      if (!_this.props.hasOwnProperty('value')) {
	        _this.setState({ hasValue: isValid(event.target.value) });
	      }
	      if (_this.props.onChange) {
	        _this.props.onChange(event, event.target.value);
	      }
	    }, _this.handleInputFocus = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	      _this.setState({ isFocused: true });
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleHeightChange = function (event, height) {
	      var newHeight = height + 24;
	      if (_this.props.floatingLabelText) {
	        newHeight += 24;
	      }
	      _reactDom2.default.findDOMNode(_this).style.height = newHeight + 'px';
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TextField, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          children = _props.children,
	          name = _props.name,
	          hintText = _props.hintText,
	          floatingLabelText = _props.floatingLabelText,
	          id = _props.id;
	
	
	      var propsLeaf = children ? children.props : this.props;
	
	      this.setState({
	        errorText: this.props.errorText,
	        hasValue: isValid(propsLeaf.value) || isValid(propsLeaf.defaultValue)
	      });
	
	       false ? (0, _warning2.default)(name || hintText || floatingLabelText || id, 'Material-UI: We don\'t have enough information\n      to build a robust unique id for the TextField component. Please provide an id or a name.') : void 0;
	
	      var uniqueId = name + '-' + hintText + '-' + floatingLabelText + '-' + Math.floor(Math.random() * 0xFFFF);
	      this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled && !this.props.disabled) {
	        this.setState({
	          isFocused: false
	        });
	      }
	
	      if (nextProps.errorText !== this.props.errorText) {
	        this.setState({
	          errorText: nextProps.errorText
	        });
	      }
	
	      if (nextProps.children && nextProps.children.props) {
	        nextProps = nextProps.children.props;
	      }
	
	      if (nextProps.hasOwnProperty('value')) {
	        var hasValue = isValid(nextProps.value);
	
	        this.setState({
	          hasValue: hasValue
	        });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      if (this.input) {
	        this.getInputNode().blur();
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.input) {
	        this.getInputNode().focus();
	      }
	    }
	  }, {
	    key: 'select',
	    value: function select() {
	      if (this.input) {
	        this.getInputNode().select();
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input ? this.getInputNode().value : undefined;
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.props.children || this.props.multiLine ? this.input.getInputNode() : _reactDom2.default.findDOMNode(this.input);
	    }
	  }, {
	    key: '_isControlled',
	    value: function _isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          errorStyle = _props2.errorStyle,
	          errorText = _props2.errorText,
	          floatingLabelFixed = _props2.floatingLabelFixed,
	          floatingLabelFocusStyle = _props2.floatingLabelFocusStyle,
	          floatingLabelShrinkStyle = _props2.floatingLabelShrinkStyle,
	          floatingLabelStyle = _props2.floatingLabelStyle,
	          floatingLabelText = _props2.floatingLabelText,
	          fullWidth = _props2.fullWidth,
	          hintText = _props2.hintText,
	          hintStyle = _props2.hintStyle,
	          id = _props2.id,
	          inputStyle = _props2.inputStyle,
	          multiLine = _props2.multiLine,
	          onBlur = _props2.onBlur,
	          onChange = _props2.onChange,
	          onFocus = _props2.onFocus,
	          style = _props2.style,
	          type = _props2.type,
	          underlineDisabledStyle = _props2.underlineDisabledStyle,
	          underlineFocusStyle = _props2.underlineFocusStyle,
	          underlineShow = _props2.underlineShow,
	          underlineStyle = _props2.underlineStyle,
	          rows = _props2.rows,
	          rowsMax = _props2.rowsMax,
	          textareaStyle = _props2.textareaStyle,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'className', 'disabled', 'errorStyle', 'errorText', 'floatingLabelFixed', 'floatingLabelFocusStyle', 'floatingLabelShrinkStyle', 'floatingLabelStyle', 'floatingLabelText', 'fullWidth', 'hintText', 'hintStyle', 'id', 'inputStyle', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'style', 'type', 'underlineDisabledStyle', 'underlineFocusStyle', 'underlineShow', 'underlineStyle', 'rows', 'rowsMax', 'textareaStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var inputId = id || this.uniqueId;
	
	      var errorTextElement = this.state.errorText && _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.error, errorStyle)) },
	        this.state.errorText
	      );
	
	      var floatingLabelTextElement = floatingLabelText && _react2.default.createElement(
	        _TextFieldLabel2.default,
	        {
	          muiTheme: this.context.muiTheme,
	          style: (0, _simpleAssign2.default)(styles.floatingLabel, floatingLabelStyle, this.state.isFocused ? floatingLabelFocusStyle : null),
	          shrinkStyle: floatingLabelShrinkStyle,
	          htmlFor: inputId,
	          shrink: this.state.hasValue || this.state.isFocused || floatingLabelFixed,
	          disabled: disabled
	        },
	        floatingLabelText
	      );
	
	      var inputProps = {
	        id: inputId,
	        ref: function ref(elem) {
	          return _this2.input = elem;
	        },
	        disabled: this.props.disabled,
	        onBlur: this.handleInputBlur,
	        onChange: this.handleInputChange,
	        onFocus: this.handleInputFocus
	      };
	
	      var childStyleMerged = (0, _simpleAssign2.default)(styles.input, inputStyle);
	
	      var inputElement = void 0;
	      if (children) {
	        inputElement = _react2.default.cloneElement(children, (0, _extends3.default)({}, inputProps, children.props, {
	          style: (0, _simpleAssign2.default)(childStyleMerged, children.props.style)
	        }));
	      } else {
	        inputElement = multiLine ? _react2.default.createElement(_EnhancedTextarea2.default, (0, _extends3.default)({
	          style: childStyleMerged,
	          textareaStyle: (0, _simpleAssign2.default)(styles.textarea, styles.inputNative, textareaStyle),
	          rows: rows,
	          rowsMax: rowsMax,
	          hintText: hintText
	        }, other, inputProps, {
	          onHeightChange: this.handleHeightChange
	        })) : _react2.default.createElement('input', (0, _extends3.default)({
	          type: type,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.inputNative, childStyleMerged))
	        }, other, inputProps));
	      }
	
	      var rootProps = {};
	
	      if (children) {
	        rootProps = other;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, rootProps, {
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }),
	        floatingLabelTextElement,
	        hintText ? _react2.default.createElement(_TextFieldHint2.default, {
	          muiTheme: this.context.muiTheme,
	          show: !(this.state.hasValue || floatingLabelText && !this.state.isFocused) || !this.state.hasValue && floatingLabelText && floatingLabelFixed && !this.state.isFocused,
	          style: hintStyle,
	          text: hintText
	        }) : null,
	        inputElement,
	        underlineShow ? _react2.default.createElement(_TextFieldUnderline2.default, {
	          disabled: disabled,
	          disabledStyle: underlineDisabledStyle,
	          error: !!this.state.errorText,
	          errorStyle: errorStyle,
	          focus: this.state.isFocused,
	          focusStyle: underlineFocusStyle,
	          muiTheme: this.context.muiTheme,
	          style: underlineStyle
	        }) : null,
	        errorTextElement
	      );
	    }
	  }]);
	  return TextField;
	}(_react.Component);
	
	TextField.defaultProps = {
	  disabled: false,
	  floatingLabelFixed: false,
	  multiLine: false,
	  fullWidth: false,
	  type: 'text',
	  underlineShow: true,
	  rows: 1
	};
	TextField.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TextField.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The text string to use for the default value.
	   */
	  defaultValue: _propTypes2.default.any,
	  /**
	   * Disables the text field if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The style object to use to override error styles.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _propTypes2.default.node,
	  /**
	   * If true, the floating label will float even when there is no value.
	   */
	  floatingLabelFixed: _propTypes2.default.bool,
	  /**
	   * The style object to use to override floating label styles when focused.
	   */
	  floatingLabelFocusStyle: _propTypes2.default.object,
	  /**
	   * The style object to use to override floating label styles when shrunk.
	   */
	  floatingLabelShrinkStyle: _propTypes2.default.object,
	  /**
	   * The style object to use to override floating label styles.
	   */
	  floatingLabelStyle: _propTypes2.default.object,
	  /**
	   * The content to use for the floating label element.
	   */
	  floatingLabelText: _propTypes2.default.node,
	  /**
	   * If true, the field receives the property width 100%.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the TextField's hint text element.
	   */
	  hintStyle: _propTypes2.default.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _propTypes2.default.node,
	  /**
	   * The id prop for the text field.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the TextField's input element.
	   * When multiLine is false: define the style of the input element.
	   * When multiLine is true: define the style of the container of the textarea.
	   */
	  inputStyle: _propTypes2.default.object,
	  /**
	   * If true, a textarea element will be rendered.
	   * The textarea also grows and shrinks according to the number of lines.
	   */
	  multiLine: _propTypes2.default.bool,
	  /**
	   * Name applied to the input.
	   */
	  name: _propTypes2.default.string,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the textfield's value changes.
	   *
	   * @param {object} event Change event targeting the text field.
	   * @param {string} newValue The new value of the text field.
	   */
	  onChange: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Number of rows to display when multiLine option is set to true.
	   */
	  rows: _propTypes2.default.number,
	  /**
	   * Maximum number of rows to display when
	   * multiLine option is set to true.
	   */
	  rowsMax: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the TextField's textarea element.
	   * The TextField use either a textarea or an input,
	   * this property has effects only when multiLine is true.
	   */
	  textareaStyle: _propTypes2.default.object,
	  /**
	   * Specifies the type of input to display
	   * such as "password" or "text".
	   */
	  type: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the
	   * TextField's underline element when disabled.
	   */
	  underlineDisabledStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the TextField's
	   * underline element when focussed.
	   */
	  underlineFocusStyle: _propTypes2.default.object,
	  /**
	   * If true, shows the underline for the text field.
	   */
	  underlineShow: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the TextField's underline element.
	   */
	  underlineStyle: _propTypes2.default.object,
	  /**
	   * The value of the text field.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = TextField;

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var hintColor = props.muiTheme.textField.hintColor,
	      show = props.show;
	
	
	  return {
	    root: {
	      position: 'absolute',
	      opacity: show ? 1 : 0,
	      color: hintColor,
	      transition: _transitions2.default.easeOut(),
	      bottom: 12
	    }
	  };
	}
	
	var TextFieldHint = function TextFieldHint(props) {
	  var prepareStyles = props.muiTheme.prepareStyles,
	      style = props.style,
	      text = props.text;
	
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	    text
	  );
	};
	
	TextFieldHint.propTypes =  false ? {
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _propTypes2.default.object.isRequired,
	  /**
	   * True if the hint text should be visible.
	   */
	  show: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The hint text displayed.
	   */
	  text: _propTypes2.default.node
	} : {};
	
	TextFieldHint.defaultProps = {
	  show: true
	};
	
	exports.default = TextFieldHint;

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var defaultStyles = {
	    position: 'absolute',
	    lineHeight: '22px',
	    top: 38,
	    transition: _transitions2.default.easeOut(),
	    zIndex: 1, // Needed to display label above Chrome's autocomplete field background
	    transform: 'scale(1) translate(0, 0)',
	    transformOrigin: 'left top',
	    pointerEvents: 'auto',
	    userSelect: 'none'
	  };
	
	  var shrinkStyles = props.shrink ? (0, _simpleAssign2.default)({
	    transform: 'scale(0.75) translate(0, -28px)',
	    pointerEvents: 'none'
	  }, props.shrinkStyle) : null;
	
	  return {
	    root: (0, _simpleAssign2.default)(defaultStyles, props.style, shrinkStyles)
	  };
	}
	
	var TextFieldLabel = function TextFieldLabel(props) {
	  var muiTheme = props.muiTheme,
	      className = props.className,
	      children = props.children,
	      htmlFor = props.htmlFor,
	      onClick = props.onClick;
	  var prepareStyles = muiTheme.prepareStyles;
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'label',
	    {
	      className: className,
	      style: prepareStyles(styles.root),
	      htmlFor: htmlFor,
	      onClick: onClick
	    },
	    children
	  );
	};
	
	TextFieldLabel.propTypes =  false ? {
	  /**
	   * The label contents.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Disables the label if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The id of the target element that this label should refer to.
	   */
	  htmlFor: _propTypes2.default.string,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _propTypes2.default.object.isRequired,
	  /**
	   * Callback function for when the label is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the text field label.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * True if the floating label should shrink.
	   */
	  shrink: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element when shrunk.
	   */
	  shrinkStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	TextFieldLabel.defaultProps = {
	  disabled: false,
	  shrink: false
	};
	
	exports.default = TextFieldLabel;

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * True if the parent `TextField` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is disabled.
	   */
	  disabledStyle: _propTypes2.default.object,
	  /**
	   * True if the parent `TextField` has an error.
	   */
	  error: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` has an error.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * True if the parent `TextField` is focused.
	   */
	  focus: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is focused.
	   */
	  focusStyle: _propTypes2.default.object,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _propTypes2.default.object.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	};
	
	var defaultProps = {
	  disabled: false,
	  disabledStyle: {},
	  error: false,
	  errorStyle: {},
	  focus: false,
	  focusStyle: {},
	  style: {}
	};
	
	var TextFieldUnderline = function TextFieldUnderline(props) {
	  var disabled = props.disabled,
	      disabledStyle = props.disabledStyle,
	      error = props.error,
	      errorStyle = props.errorStyle,
	      focus = props.focus,
	      focusStyle = props.focusStyle,
	      muiTheme = props.muiTheme,
	      style = props.style;
	  var errorStyleColor = errorStyle.color;
	  var prepareStyles = muiTheme.prepareStyles,
	      _muiTheme$textField = muiTheme.textField,
	      borderColor = _muiTheme$textField.borderColor,
	      disabledTextColor = _muiTheme$textField.disabledTextColor,
	      errorColor = _muiTheme$textField.errorColor,
	      focusColor = _muiTheme$textField.focusColor;
	
	
	  var styles = {
	    root: {
	      borderTop: 'none',
	      borderLeft: 'none',
	      borderRight: 'none',
	      borderBottomStyle: 'solid',
	      borderBottomWidth: 1,
	      borderColor: borderColor,
	      bottom: 8,
	      boxSizing: 'content-box',
	      margin: 0,
	      position: 'absolute',
	      width: '100%'
	    },
	    disabled: {
	      borderBottomStyle: 'dotted',
	      borderBottomWidth: 2,
	      borderColor: disabledTextColor
	    },
	    focus: {
	      borderBottomStyle: 'solid',
	      borderBottomWidth: 2,
	      borderColor: focusColor,
	      transform: 'scaleX(0)',
	      transition: _transitions2.default.easeOut()
	    },
	    error: {
	      borderColor: errorStyleColor ? errorStyleColor : errorColor,
	      transform: 'scaleX(1)'
	    }
	  };
	
	  var underline = (0, _simpleAssign2.default)({}, styles.root, style);
	  var focusedUnderline = (0, _simpleAssign2.default)({}, underline, styles.focus, focusStyle);
	
	  if (disabled) underline = (0, _simpleAssign2.default)({}, underline, styles.disabled, disabledStyle);
	  if (focus) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, { transform: 'scaleX(1)' });
	  if (error) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, styles.error);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('hr', { 'aria-hidden': 'true', style: prepareStyles(underline) }),
	    _react2.default.createElement('hr', { 'aria-hidden': 'true', style: prepareStyles(focusedUnderline) })
	  );
	};
	
	TextFieldUnderline.propTypes =  false ? propTypes : {};
	TextFieldUnderline.defaultProps = defaultProps;
	
	exports.default = TextFieldUnderline;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TimeDisplay = __webpack_require__(1558);
	
	var _TimeDisplay2 = _interopRequireDefault(_TimeDisplay);
	
	var _ClockHours = __webpack_require__(1556);
	
	var _ClockHours2 = _interopRequireDefault(_ClockHours);
	
	var _ClockMinutes = __webpack_require__(1557);
	
	var _ClockMinutes2 = _interopRequireDefault(_ClockMinutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Clock = function (_Component) {
	  (0, _inherits3.default)(Clock, _Component);
	
	  function Clock() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Clock);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Clock.__proto__ || (0, _getPrototypeOf2.default)(Clock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedTime: null,
	      mode: 'hour'
	    }, _this.setMode = function (mode) {
	      setTimeout(function () {
	        _this.setState({
	          mode: mode
	        });
	      }, 100);
	    }, _this.handleSelectAffix = function (affix) {
	      if (affix === _this.getAffix()) return;
	
	      var hours = _this.state.selectedTime.getHours();
	
	      if (affix === 'am') {
	        _this.handleChangeHours(hours - 12, affix);
	        return;
	      }
	
	      _this.handleChangeHours(hours + 12, affix);
	    }, _this.handleChangeHours = function (hours, finished) {
	      var time = new Date(_this.state.selectedTime);
	      var affix = void 0;
	
	      if (typeof finished === 'string') {
	        affix = finished;
	        finished = undefined;
	      }
	      if (!affix) {
	        affix = _this.getAffix();
	      }
	      if (affix === 'pm' && hours < 12) {
	        hours += 12;
	      }
	
	      time.setHours(hours);
	      _this.setState({
	        selectedTime: time
	      });
	
	      if (finished) {
	        setTimeout(function () {
	          _this.setState({
	            mode: 'minute'
	          });
	
	          var onChangeHours = _this.props.onChangeHours;
	
	          if (onChangeHours) {
	            onChangeHours(time);
	          }
	        }, 100);
	      }
	    }, _this.handleChangeMinutes = function (minutes, finished) {
	      var time = new Date(_this.state.selectedTime);
	      time.setMinutes(minutes);
	      _this.setState({
	        selectedTime: time
	      });
	
	      var onChangeMinutes = _this.props.onChangeMinutes;
	
	      if (onChangeMinutes && finished) {
	        setTimeout(function () {
	          onChangeMinutes(time);
	        }, 0);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Clock, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var selectedTime = this.props.initialTime || new Date();
	      var minutes = selectedTime.getMinutes();
	      selectedTime.setMinutes(minutes - minutes % this.props.minutesStep);
	
	      this.setState({
	        selectedTime: selectedTime
	      });
	    }
	  }, {
	    key: 'getAffix',
	    value: function getAffix() {
	      if (this.props.format !== 'ampm') return '';
	
	      var hours = this.state.selectedTime.getHours();
	      if (hours < 12) {
	        return 'am';
	      }
	
	      return 'pm';
	    }
	  }, {
	    key: 'getSelectedTime',
	    value: function getSelectedTime() {
	      return this.state.selectedTime;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var clock = null;
	
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          timePicker = _context$muiTheme.timePicker;
	
	
	      var styles = {
	        root: {
	          userSelect: 'none'
	        },
	        container: {
	          height: 280,
	          padding: 10,
	          position: 'relative',
	          boxSizing: 'content-box'
	        },
	        circle: {
	          position: 'absolute',
	          top: 20,
	          width: 260,
	          height: 260,
	          borderRadius: '100%',
	          backgroundColor: timePicker.clockCircleColor
	        }
	      };
	
	      if (this.state.mode === 'hour') {
	        clock = _react2.default.createElement(_ClockHours2.default, {
	          key: 'hours',
	          format: this.props.format,
	          onChange: this.handleChangeHours,
	          initialHours: this.state.selectedTime.getHours()
	        });
	      } else {
	        clock = _react2.default.createElement(_ClockMinutes2.default, {
	          key: 'minutes',
	          onChange: this.handleChangeMinutes,
	          initialMinutes: this.state.selectedTime.getMinutes(),
	          step: this.props.minutesStep
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(_TimeDisplay2.default, {
	          selectedTime: this.state.selectedTime,
	          mode: this.state.mode,
	          format: this.props.format,
	          affix: this.getAffix(),
	          onSelectAffix: this.handleSelectAffix,
	          onSelectHour: this.setMode.bind(this, 'hour'),
	          onSelectMin: this.setMode.bind(this, 'minute')
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.container) },
	          _react2.default.createElement('div', { style: prepareStyles(styles.circle) }),
	          clock
	        )
	      );
	    }
	  }]);
	  return Clock;
	}(_react.Component);
	
	Clock.defaultProps = {
	  initialTime: new Date()
	};
	Clock.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Clock.propTypes =  false ? {
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  initialTime: _propTypes2.default.object,
	  minutesStep: _propTypes2.default.number,
	  onChangeHours: _propTypes2.default.func,
	  onChangeMinutes: _propTypes2.default.func
	} : {};
	exports.default = Clock;

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ClockNumber = __webpack_require__(762);
	
	var _ClockNumber2 = _interopRequireDefault(_ClockNumber);
	
	var _ClockPointer = __webpack_require__(763);
	
	var _ClockPointer2 = _interopRequireDefault(_ClockPointer);
	
	var _timeUtils = __webpack_require__(289);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClockHours = function (_Component) {
	  (0, _inherits3.default)(ClockHours, _Component);
	
	  function ClockHours() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockHours);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockHours.__proto__ || (0, _getPrototypeOf2.default)(ClockHours)).call.apply(_ref, [this].concat(args))), _this), _this.handleUp = function (event) {
	      event.preventDefault();
	      _this.setClock(event.nativeEvent, true);
	    }, _this.handleMove = function (event) {
	      event.preventDefault();
	      if (_this.isMousePressed(event) !== 1) return;
	      _this.setClock(event.nativeEvent, false);
	    }, _this.handleTouchMove = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], false);
	    }, _this.handleTouchEnd = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], true);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockHours, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var clockElement = _reactDom2.default.findDOMNode(this.refs.mask);
	
	      this.center = {
	        x: clockElement.offsetWidth / 2,
	        y: clockElement.offsetHeight / 2
	      };
	
	      this.basePoint = {
	        x: this.center.x,
	        y: 0
	      };
	    }
	  }, {
	    key: 'isMousePressed',
	    value: function isMousePressed(event) {
	      if (typeof event.buttons === 'undefined') {
	        return event.nativeEvent.which;
	      }
	
	      return event.buttons;
	    }
	  }, {
	    key: 'setClock',
	    value: function setClock(event, finish) {
	      if (typeof event.offsetX === 'undefined') {
	        var offset = (0, _timeUtils.getTouchEventOffsetValues)(event);
	
	        event.offsetX = offset.offsetX;
	        event.offsetY = offset.offsetY;
	      }
	
	      var hours = this.getHours(event.offsetX, event.offsetY);
	
	      this.props.onChange(hours, finish);
	    }
	  }, {
	    key: 'getHours',
	    value: function getHours(offsetX, offsetY) {
	      var step = 30;
	      var x = offsetX - this.center.x;
	      var y = offsetY - this.center.y;
	      var cx = this.basePoint.x - this.center.x;
	      var cy = this.basePoint.y - this.center.y;
	
	      var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	      var deg = (0, _timeUtils.rad2deg)(atan);
	      deg = Math.round(deg / step) * step;
	      deg %= 360;
	
	      var value = Math.floor(deg / step) || 0;
	
	      var delta = Math.pow(x, 2) + Math.pow(y, 2);
	      var distance = Math.sqrt(delta);
	
	      value = value || 12;
	      if (this.props.format === '24hr') {
	        if (distance < 90) {
	          value += 12;
	          value %= 24;
	        }
	      } else {
	        value %= 12;
	      }
	
	      return value;
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected() {
	      var hour = this.props.initialHours;
	
	      if (this.props.format === 'ampm') {
	        hour %= 12;
	        hour = hour || 12;
	      }
	
	      return hour;
	    }
	  }, {
	    key: 'getHourNumbers',
	    value: function getHourNumbers() {
	      var _this2 = this;
	
	      var style = {
	        pointerEvents: 'none'
	      };
	      var hourSize = this.props.format === 'ampm' ? 12 : 24;
	
	      var hours = [];
	      for (var i = 1; i <= hourSize; i++) {
	        hours.push(i % 24);
	      }
	
	      return hours.map(function (hour) {
	        var isSelected = _this2.getSelected() === hour;
	        return _react2.default.createElement(_ClockNumber2.default, {
	          key: hour,
	          style: style,
	          isSelected: isSelected,
	          type: 'hour',
	          value: hour
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = {
	        root: {
	          height: '100%',
	          width: '100%',
	          borderRadius: '100%',
	          position: 'relative',
	          pointerEvents: 'none',
	          boxSizing: 'border-box'
	        },
	
	        hitMask: {
	          height: '100%',
	          width: '100%',
	          pointerEvents: 'auto'
	        }
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var hours = this.getSelected();
	      var numbers = this.getHourNumbers();
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'clock', style: prepareStyles(styles.root) },
	        _react2.default.createElement(_ClockPointer2.default, { hasSelected: true, value: hours, type: 'hour' }),
	        numbers,
	        _react2.default.createElement('div', {
	          ref: 'mask', style: prepareStyles(styles.hitMask), onTouchMove: this.handleTouchMove,
	          onTouchEnd: this.handleTouchEnd, onMouseUp: this.handleUp, onMouseMove: this.handleMove
	        })
	      );
	    }
	  }]);
	  return ClockHours;
	}(_react.Component);
	
	ClockHours.defaultProps = {
	  initialHours: new Date().getHours(),
	  onChange: function onChange() {},
	  format: 'ampm'
	};
	ClockHours.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ClockHours.propTypes =  false ? {
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  initialHours: _propTypes2.default.number,
	  onChange: _propTypes2.default.func
	} : {};
	exports.default = ClockHours;

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClockNumber = __webpack_require__(762);
	
	var _ClockNumber2 = _interopRequireDefault(_ClockNumber);
	
	var _ClockPointer = __webpack_require__(763);
	
	var _ClockPointer2 = _interopRequireDefault(_ClockPointer);
	
	var _timeUtils = __webpack_require__(289);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClockMinutes = function (_Component) {
	  (0, _inherits3.default)(ClockMinutes, _Component);
	
	  function ClockMinutes() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockMinutes);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockMinutes.__proto__ || (0, _getPrototypeOf2.default)(ClockMinutes)).call.apply(_ref, [this].concat(args))), _this), _this.handleUp = function (event) {
	      event.preventDefault();
	      _this.setClock(event.nativeEvent, true);
	    }, _this.handleMove = function (event) {
	      event.preventDefault();
	      if (_this.isMousePressed(event) !== 1) {
	        return;
	      }
	      _this.setClock(event.nativeEvent, false);
	    }, _this.handleTouch = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], event.type === 'touchend');
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockMinutes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var clockElement = this.refs.mask;
	
	      this.center = {
	        x: clockElement.offsetWidth / 2,
	        y: clockElement.offsetHeight / 2
	      };
	
	      this.basePoint = {
	        x: this.center.x,
	        y: 0
	      };
	    }
	  }, {
	    key: 'isMousePressed',
	    value: function isMousePressed(event) {
	      if (typeof event.buttons === 'undefined') {
	        return event.nativeEvent.which;
	      }
	      return event.buttons;
	    }
	  }, {
	    key: 'setClock',
	    value: function setClock(event, finish) {
	      if (typeof event.offsetX === 'undefined') {
	        var offset = (0, _timeUtils.getTouchEventOffsetValues)(event);
	
	        event.offsetX = offset.offsetX;
	        event.offsetY = offset.offsetY;
	      }
	
	      var minutes = this.getMinutes(event.offsetX, event.offsetY);
	
	      this.props.onChange(minutes, finish);
	    }
	  }, {
	    key: 'getMinutes',
	    value: function getMinutes(offsetX, offsetY) {
	      var step = 6 * this.props.step;
	      var x = offsetX - this.center.x;
	      var y = offsetY - this.center.y;
	      var cx = this.basePoint.x - this.center.x;
	      var cy = this.basePoint.y - this.center.y;
	
	      var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	      var deg = (0, _timeUtils.rad2deg)(atan);
	      deg = Math.round(deg / step) * step;
	      deg %= 360;
	
	      var value = Math.floor(deg / step) || 0;
	
	      return value * this.props.step;
	    }
	  }, {
	    key: 'getMinuteNumbers',
	    value: function getMinuteNumbers() {
	      var minutes = [];
	      for (var i = 0; i < 12; i++) {
	        minutes.push(i * 5);
	      }
	      var selectedMinutes = this.props.initialMinutes;
	      var hasSelected = false;
	
	      var numbers = minutes.map(function (minute) {
	        var isSelected = selectedMinutes === minute;
	        if (isSelected) {
	          hasSelected = true;
	        }
	        return _react2.default.createElement(_ClockNumber2.default, {
	          key: minute,
	          isSelected: isSelected,
	          type: 'minute',
	          value: minute
	        });
	      });
	
	      return {
	        numbers: numbers,
	        hasSelected: hasSelected,
	        selected: selectedMinutes
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = {
	        root: {
	          height: '100%',
	          width: '100%',
	          borderRadius: '100%',
	          position: 'relative',
	          pointerEvents: 'none',
	          boxSizing: 'border-box'
	        },
	
	        hitMask: {
	          height: '100%',
	          width: '100%',
	          pointerEvents: 'auto'
	        }
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var minutes = this.getMinuteNumbers();
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'clock', style: prepareStyles(styles.root) },
	        _react2.default.createElement(_ClockPointer2.default, { value: minutes.selected, type: 'minute', hasSelected: minutes.hasSelected }),
	        minutes.numbers,
	        _react2.default.createElement('div', {
	          ref: 'mask',
	          style: prepareStyles(styles.hitMask),
	          onTouchMove: this.handleTouch,
	          onTouchEnd: this.handleTouch,
	          onMouseUp: this.handleUp,
	          onMouseMove: this.handleMove
	        })
	      );
	    }
	  }]);
	  return ClockMinutes;
	}(_react.Component);
	
	ClockMinutes.defaultProps = {
	  initialMinutes: new Date().getMinutes(),
	  onChange: function onChange() {},
	  step: 1
	};
	ClockMinutes.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ClockMinutes.propTypes =  false ? {
	  initialMinutes: _propTypes2.default.number,
	  onChange: _propTypes2.default.func,
	  step: _propTypes2.default.number
	} : {};
	exports.default = ClockMinutes;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(412);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeDisplay = function (_Component) {
	  (0, _inherits3.default)(TimeDisplay, _Component);
	
	  function TimeDisplay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimeDisplay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimeDisplay.__proto__ || (0, _getPrototypeOf2.default)(TimeDisplay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      transitionDirection: 'up'
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimeDisplay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedTime !== this.props.selectedTime) {
	        var direction = nextProps.selectedTime > this.props.selectedTime ? 'up' : 'down';
	
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	    }
	  }, {
	    key: 'sanitizeTime',
	    value: function sanitizeTime() {
	      var hour = this.props.selectedTime.getHours();
	      var min = this.props.selectedTime.getMinutes().toString();
	
	      if (this.props.format === 'ampm') {
	        hour %= 12;
	        hour = hour || 12;
	      }
	
	      hour = hour.toString();
	      if (hour.length < 2) hour = '0' + hour;
	      if (min.length < 2) min = '0' + min;
	
	      return [hour, min];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          affix = _props.affix,
	          format = _props.format,
	          mode = _props.mode,
	          onSelectAffix = _props.onSelectAffix,
	          onSelectHour = _props.onSelectHour,
	          onSelectMin = _props.onSelectMin,
	          selectedTime = _props.selectedTime,
	          other = (0, _objectWithoutProperties3.default)(_props, ['affix', 'format', 'mode', 'onSelectAffix', 'onSelectHour', 'onSelectMin', 'selectedTime']);
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          timePicker = _context$muiTheme.timePicker;
	
	
	      var styles = {
	        root: {
	          padding: '14px 0',
	          borderTopLeftRadius: 2,
	          borderTopRightRadius: 2,
	          backgroundColor: timePicker.headerColor,
	          color: timePicker.textColor
	        },
	        text: {
	          margin: '6px 0',
	          lineHeight: '58px',
	          height: 58,
	          fontSize: 58,
	          display: 'flex',
	          justifyContent: 'center',
	          alignItems: 'baseline'
	        },
	        time: {
	          margin: '0 10px'
	        },
	        affix: {
	          flex: 1,
	          position: 'relative',
	          lineHeight: '17px',
	          height: 17,
	          fontSize: 17
	        },
	        affixTop: {
	          position: 'absolute',
	          top: -20,
	          left: 0
	        },
	        clickable: {
	          cursor: 'pointer'
	        },
	        inactive: {
	          opacity: 0.7
	        }
	      };
	
	      var _sanitizeTime = this.sanitizeTime(),
	          _sanitizeTime2 = (0, _slicedToArray3.default)(_sanitizeTime, 2),
	          hour = _sanitizeTime2[0],
	          min = _sanitizeTime2[1];
	
	      var buttons = [];
	      if (format === 'ampm') {
	        buttons = [_react2.default.createElement(
	          'div',
	          {
	            key: 'pm',
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, affix === 'pm' ? {} : styles.inactive)),
	            onClick: function onClick() {
	              return onSelectAffix('pm');
	            }
	          },
	          'PM'
	        ), _react2.default.createElement(
	          'div',
	          {
	            key: 'am',
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.affixTop, styles.clickable, affix === 'am' ? {} : styles.inactive)),
	            onClick: function onClick() {
	              return onSelectAffix('am');
	            }
	          },
	          'AM'
	        )];
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(styles.root) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.text) },
	          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.affix)) }),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.time) },
	            _react2.default.createElement(
	              'span',
	              {
	                style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, mode === 'hour' ? {} : styles.inactive)),
	                onClick: onSelectHour
	              },
	              hour
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, mode === 'minute' ? {} : styles.inactive)),
	                onClick: onSelectMin
	              },
	              min
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.affix)) },
	            buttons
	          )
	        )
	      );
	    }
	  }]);
	  return TimeDisplay;
	}(_react.Component);
	
	TimeDisplay.defaultProps = {
	  affix: '',
	  mode: 'hour'
	};
	TimeDisplay.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TimeDisplay.propTypes =  false ? {
	  affix: _propTypes2.default.oneOf(['', 'pm', 'am']),
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  mode: _propTypes2.default.oneOf(['hour', 'minute']),
	  onSelectAffix: _propTypes2.default.func,
	  onSelectHour: _propTypes2.default.func,
	  onSelectMin: _propTypes2.default.func,
	  selectedTime: _propTypes2.default.object.isRequired
	} : {};
	exports.default = TimeDisplay;

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TimePickerDialog = __webpack_require__(1560);
	
	var _TimePickerDialog2 = _interopRequireDefault(_TimePickerDialog);
	
	var _TextField = __webpack_require__(186);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _timeUtils = __webpack_require__(289);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyTime = new Date();
	emptyTime.setHours(0);
	emptyTime.setMinutes(0);
	emptyTime.setSeconds(0);
	emptyTime.setMilliseconds(0);
	
	var TimePicker = function (_Component) {
	  (0, _inherits3.default)(TimePicker, _Component);
	
	  function TimePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimePicker.__proto__ || (0, _getPrototypeOf2.default)(TimePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      time: null,
	      dialogTime: new Date()
	    }, _this.handleAcceptDialog = function (time) {
	      _this.setState({
	        time: time
	      });
	      if (_this.props.onChange) _this.props.onChange(null, time);
	    }, _this.handleFocusInput = function (event) {
	      event.target.blur();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleTouchTapInput = function (event) {
	      event.preventDefault();
	
	      if (!_this.props.disabled) {
	        _this.openDialog();
	      }
	
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        time: this.isControlled() ? this.getControlledTime() : this.props.defaultTime
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value) {
	        this.setState({
	          time: this.getControlledTime(nextProps)
	        });
	      }
	    }
	
	    /**
	     * Alias for `openDialog()` for an api consistent with TextField.
	     */
	
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.openDialog();
	    }
	  }, {
	    key: 'openDialog',
	    value: function openDialog() {
	      this.setState({
	        dialogTime: this.state.time
	      });
	      this.refs.dialogWindow.show();
	    }
	  }, {
	    key: 'isControlled',
	    value: function isControlled() {
	      return this.props.value !== null;
	    }
	  }, {
	    key: 'getControlledTime',
	    value: function getControlledTime() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      var result = null;
	      if (props.value instanceof Date) {
	        result = props.value;
	      }
	      return result;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          defaultTime = _props.defaultTime,
	          dialogBodyStyle = _props.dialogBodyStyle,
	          dialogStyle = _props.dialogStyle,
	          format = _props.format,
	          okLabel = _props.okLabel,
	          onFocus = _props.onFocus,
	          onClick = _props.onClick,
	          onShow = _props.onShow,
	          onDismiss = _props.onDismiss,
	          pedantic = _props.pedantic,
	          style = _props.style,
	          textFieldStyle = _props.textFieldStyle,
	          minutesStep = _props.minutesStep,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoOk', 'cancelLabel', 'defaultTime', 'dialogBodyStyle', 'dialogStyle', 'format', 'okLabel', 'onFocus', 'onClick', 'onShow', 'onDismiss', 'pedantic', 'style', 'textFieldStyle', 'minutesStep']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var time = this.state.time;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
	          style: textFieldStyle,
	          ref: 'input',
	          value: time === emptyTime ? null : (0, _timeUtils.formatTime)(time, format, pedantic),
	          onFocus: this.handleFocusInput,
	          onClick: this.handleTouchTapInput
	        })),
	        _react2.default.createElement(_TimePickerDialog2.default, {
	          ref: 'dialogWindow',
	          bodyStyle: dialogBodyStyle,
	          initialTime: this.state.dialogTime,
	          onAccept: this.handleAcceptDialog,
	          onShow: onShow,
	          onDismiss: onDismiss,
	          format: format,
	          okLabel: okLabel,
	          cancelLabel: cancelLabel,
	          autoOk: autoOk,
	          style: dialogStyle,
	          minutesStep: minutesStep
	        })
	      );
	    }
	  }]);
	  return TimePicker;
	}(_react.Component);
	
	TimePicker.defaultProps = {
	  autoOk: false,
	  cancelLabel: 'Cancel',
	  defaultTime: null,
	  disabled: false,
	  format: 'ampm',
	  okLabel: 'OK',
	  pedantic: false,
	  style: {},
	  value: null,
	  minutesStep: 1
	};
	TimePicker.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TimePicker.propTypes =  false ? {
	  /**
	   * If true, automatically accept and close the picker on set minutes.
	   */
	  autoOk: _propTypes2.default.bool,
	  /**
	   * Override the label of the 'Cancel' button.
	   */
	  cancelLabel: _propTypes2.default.node,
	  /**
	   * The initial time value of the TimePicker.
	   */
	  defaultTime: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of TimePickerDialog's body element.
	   */
	  dialogBodyStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of TimePickerDialog's root element.
	   */
	  dialogStyle: _propTypes2.default.object,
	  /**
	   * If true, the TimePicker is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Tells the component to display the picker in `ampm` (12hr) format or `24hr` format.
	   */
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  /**
	   * How many minutes should be added/subtracted when moving the clock pointer.
	   */
	  minutesStep: _propTypes2.default.number,
	  /**
	   * Override the label of the 'OK' button.
	   */
	  okLabel: _propTypes2.default.node,
	  /**
	   * Callback function that is fired when the time value changes. The time value is passed in a Date Object.
	   * Since there is no particular event associated with the change the first argument will always be null
	   * and the second argument will be the new Date instance.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function fired when the TimePicker is tapped or clicked.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Callback function fired when the TimePicker dialog is dismissed.
	   */
	  onDismiss: _propTypes2.default.func,
	  /**
	   * Callback function fired when the TimePicker `TextField` gains focus.
	   */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Callback function fired when the TimePicker dialog is shown.
	   */
	  onShow: _propTypes2.default.func,
	  /**
	   * If true, uses ("noon" / "midnight") instead of ("12 a.m." / "12 p.m.").
	   *
	   * It's technically more correct to refer to "12 noon" and "12 midnight" rather than "12 a.m." and "12 p.m."
	   * and it avoids confusion between different locales. By default (for compatibility reasons) TimePicker uses
	   * ("12 a.m." / "12 p.m.").
	   */
	  pedantic: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of TimePicker's TextField element.
	   */
	  textFieldStyle: _propTypes2.default.object,
	  /**
	   * Sets the time for the Time Picker programmatically.
	   */
	  value: _propTypes2.default.object
	} : {};
	exports.default = TimePicker;

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(165);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(99);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _Clock = __webpack_require__(1555);
	
	var _Clock2 = _interopRequireDefault(_Clock);
	
	var _Dialog = __webpack_require__(76);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(36);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimePickerDialog = function (_Component) {
	  (0, _inherits3.default)(TimePickerDialog, _Component);
	
	  function TimePickerDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimePickerDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimePickerDialog.__proto__ || (0, _getPrototypeOf2.default)(TimePickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.handleRequestClose = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapCancel = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapOK = function () {
	      if (_this.props.onAccept) {
	        _this.props.onAccept(_this.refs.clock.getSelectedTime());
	      }
	      _this.setState({
	        open: false
	      });
	    }, _this.handleKeyUp = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.handleTouchTapOK();
	          break;
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimePickerDialog, [{
	    key: 'show',
	    value: function show() {
	      if (this.props.onShow && !this.state.open) this.props.onShow();
	      this.setState({
	        open: true
	      });
	    }
	  }, {
	    key: 'dismiss',
	    value: function dismiss() {
	      if (this.props.onDismiss && this.state.open) this.props.onDismiss();
	      this.setState({
	        open: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bodyStyle = _props.bodyStyle,
	          initialTime = _props.initialTime,
	          onAccept = _props.onAccept,
	          format = _props.format,
	          autoOk = _props.autoOk,
	          okLabel = _props.okLabel,
	          cancelLabel = _props.cancelLabel,
	          style = _props.style,
	          minutesStep = _props.minutesStep,
	          other = (0, _objectWithoutProperties3.default)(_props, ['bodyStyle', 'initialTime', 'onAccept', 'format', 'autoOk', 'okLabel', 'cancelLabel', 'style', 'minutesStep']);
	
	
	      var styles = {
	        root: {
	          fontSize: 14,
	          color: this.context.muiTheme.timePicker.clockColor
	        },
	        dialogContent: {
	          width: 280
	        },
	        body: {
	          padding: 0
	        }
	      };
	
	      var actions = [_react2.default.createElement(_FlatButton2.default, {
	        key: 0,
	        label: cancelLabel,
	        primary: true,
	        onClick: this.handleTouchTapCancel
	      }), _react2.default.createElement(_FlatButton2.default, {
	        key: 1,
	        label: okLabel,
	        primary: true,
	        onClick: this.handleTouchTapOK
	      })];
	
	      var onClockChangeMinutes = autoOk === true ? this.handleTouchTapOK : undefined;
	      var open = this.state.open;
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        (0, _extends3.default)({}, other, {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          bodyStyle: (0, _simpleAssign2.default)(styles.body, bodyStyle),
	          actions: actions,
	          contentStyle: styles.dialogContent,
	          repositionOnUpdate: false,
	          open: open,
	          onRequestClose: this.handleRequestClose
	        }),
	        open && _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
	        open && _react2.default.createElement(_Clock2.default, {
	          ref: 'clock',
	          format: format,
	          initialTime: initialTime,
	          onChangeMinutes: onClockChangeMinutes,
	          minutesStep: minutesStep
	        })
	      );
	    }
	  }]);
	  return TimePickerDialog;
	}(_react.Component);
	
	TimePickerDialog.defaultProps = {
	  okLabel: 'OK',
	  cancelLabel: 'Cancel'
	};
	TimePickerDialog.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TimePickerDialog.propTypes =  false ? {
	  autoOk: _propTypes2.default.bool,
	  bodyStyle: _propTypes2.default.object,
	  cancelLabel: _propTypes2.default.node,
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  initialTime: _propTypes2.default.object,
	  minutesStep: _propTypes2.default.number,
	  okLabel: _propTypes2.default.node,
	  onAccept: _propTypes2.default.func,
	  onDismiss: _propTypes2.default.func,
	  onShow: _propTypes2.default.func,
	  style: _propTypes2.default.object
	} : {};
	exports.default = TimePickerDialog;

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TimePicker = __webpack_require__(1559);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TimePicker2.default;

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Paper = __webpack_require__(106);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _EnhancedSwitch = __webpack_require__(497);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var disabled = props.disabled,
	      elementStyle = props.elementStyle,
	      trackSwitchedStyle = props.trackSwitchedStyle,
	      thumbSwitchedStyle = props.thumbSwitchedStyle,
	      trackStyle = props.trackStyle,
	      thumbStyle = props.thumbStyle,
	      iconStyle = props.iconStyle,
	      rippleStyle = props.rippleStyle,
	      labelStyle = props.labelStyle;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toggle = _context$muiTheme.toggle;
	
	
	  var toggleSize = 20;
	  var toggleTrackWidth = 36;
	  var styles = {
	    icon: {
	      width: 36,
	      padding: '4px 0px 6px 2px'
	    },
	    ripple: {
	      top: -10,
	      left: -10,
	      color: state.switched ? toggle.thumbOnColor : baseTheme.palette.textColor
	    },
	    toggleElement: {
	      width: toggleTrackWidth
	    },
	    track: {
	      transition: _transitions2.default.easeOut(),
	      width: '100%',
	      height: 14,
	      borderRadius: 30,
	      backgroundColor: toggle.trackOffColor
	    },
	    thumb: {
	      transition: _transitions2.default.easeOut(),
	      position: 'absolute',
	      top: 1,
	      left: 0,
	      width: toggleSize,
	      height: toggleSize,
	      lineHeight: '24px',
	      borderRadius: '50%',
	      backgroundColor: toggle.thumbOffColor
	    },
	    trackWhenSwitched: {
	      backgroundColor: toggle.trackOnColor
	    },
	    thumbWhenSwitched: {
	      backgroundColor: toggle.thumbOnColor,
	      left: '100%'
	    },
	    trackWhenDisabled: {
	      backgroundColor: toggle.trackDisabledColor
	    },
	    thumbWhenDisabled: {
	      backgroundColor: toggle.thumbDisabledColor
	    },
	    label: {
	      color: disabled ? toggle.labelDisabledColor : toggle.labelColor,
	      width: 'calc(100% - ' + (toggleTrackWidth + 10) + 'px)'
	    }
	  };
	
	  (0, _simpleAssign2.default)(styles.track, trackStyle, state.switched && styles.trackWhenSwitched, state.switched && trackSwitchedStyle, disabled && styles.trackWhenDisabled);
	
	  (0, _simpleAssign2.default)(styles.thumb, thumbStyle, state.switched && styles.thumbWhenSwitched, state.switched && thumbSwitchedStyle, disabled && styles.thumbWhenDisabled);
	
	  if (state.switched) {
	    styles.thumb.marginLeft = 0 - styles.thumb.width;
	  }
	
	  (0, _simpleAssign2.default)(styles.icon, iconStyle);
	
	  (0, _simpleAssign2.default)(styles.ripple, rippleStyle);
	
	  (0, _simpleAssign2.default)(styles.label, labelStyle);
	
	  (0, _simpleAssign2.default)(styles.toggleElement, elementStyle);
	
	  return styles;
	}
	
	var Toggle = function (_Component) {
	  (0, _inherits3.default)(Toggle, _Component);
	
	  function Toggle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Toggle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Toggle.__proto__ || (0, _getPrototypeOf2.default)(Toggle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      switched: false
	    }, _this.handleStateChange = function (newSwitched) {
	      _this.setState({
	        switched: newSwitched
	      });
	    }, _this.handleToggle = function (event, isInputChecked) {
	      if (_this.props.onToggle) {
	        _this.props.onToggle(event, isInputChecked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Toggle, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          toggled = _props.toggled,
	          defaultToggled = _props.defaultToggled,
	          valueLink = _props.valueLink;
	
	
	      if (toggled || defaultToggled || valueLink && valueLink.value) {
	        this.setState({
	          switched: true
	        });
	      }
	    }
	  }, {
	    key: 'isToggled',
	    value: function isToggled() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	  }, {
	    key: 'setToggled',
	    value: function setToggled(newToggledValue) {
	      this.refs.enhancedSwitch.setSwitched(newToggledValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          defaultToggled = _props2.defaultToggled,
	          elementStyle = _props2.elementStyle,
	          onToggle = _props2.onToggle,
	          trackSwitchedStyle = _props2.trackSwitchedStyle,
	          thumbSwitchedStyle = _props2.thumbSwitchedStyle,
	          toggled = _props2.toggled,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['defaultToggled', 'elementStyle', 'onToggle', 'trackSwitchedStyle', 'thumbSwitchedStyle', 'toggled']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var toggleElement = _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)({}, styles.toggleElement)) },
	        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.track)) }),
	        _react2.default.createElement(_Paper2.default, { style: styles.thumb, circle: true, zDepth: 1 })
	      );
	
	      var enhancedSwitchProps = {
	        ref: 'enhancedSwitch',
	        inputType: 'checkbox',
	        switchElement: toggleElement,
	        rippleStyle: styles.ripple,
	        rippleColor: styles.ripple.color,
	        iconStyle: styles.icon,
	        trackStyle: styles.track,
	        thumbStyle: styles.thumb,
	        labelStyle: styles.label,
	        switched: this.state.switched,
	        onSwitch: this.handleToggle,
	        onParentShouldUpdate: this.handleStateChange,
	        labelPosition: this.props.labelPosition
	      };
	
	      if (this.props.hasOwnProperty('toggled')) {
	        enhancedSwitchProps.checked = toggled;
	      } else if (this.props.hasOwnProperty('defaultToggled')) {
	        enhancedSwitchProps.defaultChecked = defaultToggled;
	      }
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
	    }
	  }]);
	  return Toggle;
	}(_react.Component);
	
	Toggle.defaultProps = {
	  defaultToggled: false,
	  disabled: false,
	  labelPosition: 'left'
	};
	Toggle.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Toggle.propTypes =  false ? {
	  /**
	   * Determines whether the Toggle is initially turned on.
	   * **Warning:** This cannot be used in conjunction with `toggled`.
	   * Decide between using a controlled or uncontrolled input element and remove one of these props.
	   * More info: https://fb.me/react-controlled-components
	   */
	  defaultToggled: _propTypes2.default.bool,
	  /**
	   * Will disable the toggle if true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Overrides the inline-styles of the Toggle element.
	   */
	  elementStyle: _propTypes2.default.object,
	  /**
	   * Overrides the inline-styles of the Icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Overrides the inline-styles of the input element.
	   */
	  inputStyle: _propTypes2.default.object,
	  /**
	   * Label for toggle.
	   */
	  label: _propTypes2.default.node,
	  /**
	   * Where the label will be placed next to the toggle.
	   */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Overrides the inline-styles of the Toggle element label.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Callback function that is fired when the toggle switch is toggled.
	   *
	   * @param {object} event Change event targeting the toggle.
	   * @param {bool} isInputChecked The new value of the toggle.
	   */
	  onToggle: _propTypes2.default.func,
	  /**
	   * Override style of ripple.
	   */
	  rippleStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override style for thumb.
	   */
	  thumbStyle: _propTypes2.default.object,
	  /**
	  * Override the inline styles for thumb when the toggle switch is toggled on.
	  */
	  thumbSwitchedStyle: _propTypes2.default.object,
	  /**
	   * Toggled if set to true.
	   */
	  toggled: _propTypes2.default.bool,
	  /**
	   * Override style for track.
	   */
	  trackStyle: _propTypes2.default.object,
	  /**
	  * Override the inline styles for track when the toggle switch is toggled on.
	  */
	  trackSwitchedStyle: _propTypes2.default.object,
	  /**
	   * ValueLink prop for when using controlled toggle.
	   */
	  valueLink: _propTypes2.default.object
	} : {};
	exports.default = Toggle;

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var noGutter = props.noGutter;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      backgroundColor: toolbar.backgroundColor,
	      height: toolbar.height,
	      padding: noGutter ? 0 : '0px ' + baseTheme.spacing.desktopGutter + 'px',
	      display: 'flex',
	      justifyContent: 'space-between'
	    }
	  };
	}
	
	var Toolbar = function (_Component) {
	  (0, _inherits3.default)(Toolbar, _Component);
	
	  function Toolbar() {
	    (0, _classCallCheck3.default)(this, Toolbar);
	    return (0, _possibleConstructorReturn3.default)(this, (Toolbar.__proto__ || (0, _getPrototypeOf2.default)(Toolbar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Toolbar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          noGutter = _props.noGutter,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'noGutter', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return Toolbar;
	}(_react.Component);
	
	Toolbar.defaultProps = {
	  noGutter: false
	};
	Toolbar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Toolbar.propTypes =  false ? {
	  /**
	   * Can be a `ToolbarGroup` to render a group of related items.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Do not apply `desktopGutter` to the `Toolbar`.
	   */
	  noGutter: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Toolbar;

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var originalBodyOverflow = null;
	var lockingCounter = 0;
	
	var AutoLockScrolling = function (_Component) {
	  (0, _inherits3.default)(AutoLockScrolling, _Component);
	
	  function AutoLockScrolling() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AutoLockScrolling);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoLockScrolling.__proto__ || (0, _getPrototypeOf2.default)(AutoLockScrolling)).call.apply(_ref, [this].concat(args))), _this), _this.locked = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AutoLockScrolling, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.lock === true) {
	        this.preventScrolling();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.lock !== nextProps.lock) {
	        if (nextProps.lock) {
	          this.preventScrolling();
	        } else {
	          this.allowScrolling();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.allowScrolling();
	    }
	
	    // force to only lock/unlock once
	
	  }, {
	    key: 'preventScrolling',
	    value: function preventScrolling() {
	      if (this.locked === true) {
	        return;
	      }
	
	      lockingCounter = lockingCounter + 1;
	      this.locked = true;
	
	      // only lock the first time the component is mounted.
	      if (lockingCounter === 1) {
	        var body = document.getElementsByTagName('body')[0];
	        originalBodyOverflow = body.style.overflow;
	        body.style.overflow = 'hidden';
	      }
	    }
	  }, {
	    key: 'allowScrolling',
	    value: function allowScrolling() {
	      if (this.locked === true) {
	        lockingCounter = lockingCounter - 1;
	        this.locked = false;
	      }
	
	      if (lockingCounter === 0 && originalBodyOverflow !== null) {
	        var body = document.getElementsByTagName('body')[0];
	        body.style.overflow = originalBodyOverflow || '';
	        originalBodyOverflow = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return AutoLockScrolling;
	}(_react.Component);
	
	AutoLockScrolling.propTypes =  false ? {
	  lock: _propTypes2.default.bool.isRequired
	} : {};
	exports.default = AutoLockScrolling;

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  BeforeAfterWrapper
	 *    An alternative for the ::before and ::after css pseudo-elements for
	 *    components whose styles are defined in javascript instead of css.
	 *
	 *  Usage: For the element that we want to apply before and after elements to,
	 *    wrap its children with BeforeAfterWrapper. For example:
	 *
	 *                                            <Paper>
	 *  <Paper>                                     <div> // See notice
	 *    <BeforeAfterWrapper>        renders         <div/> // before element
	 *      [children of paper]       ------>         [children of paper]
	 *    </BeforeAfterWrapper>                       <div/> // after element
	 *  </Paper>                                    </div>
	 *                                            </Paper>
	 *
	 *  Notice: Notice that this div bundles together our elements. If the element
	 *    that we want to apply before and after elements is a HTML tag (i.e. a
	 *    div, p, or button tag), we can avoid this extra nesting by passing using
	 *    the BeforeAfterWrapper in place of said tag like so:
	 *
	 *  <p>
	 *    <BeforeAfterWrapper>   do this instead   <BeforeAfterWrapper elementType='p'>
	 *      [children of p]          ------>         [children of p]
	 *    </BeforeAfterWrapper>                    </BeforeAfterWrapper>
	 *  </p>
	 *
	 *  BeforeAfterWrapper features spread functionality. This means that we can
	 *  pass HTML tag properties directly into the BeforeAfterWrapper tag.
	 *
	 *  When using BeforeAfterWrapper, ensure that the parent of the beforeElement
	 *  and afterElement have a defined style position.
	 */
	
	var styles = {
	  box: {
	    boxSizing: 'border-box'
	  }
	};
	
	var BeforeAfterWrapper = function (_Component) {
	  (0, _inherits3.default)(BeforeAfterWrapper, _Component);
	
	  function BeforeAfterWrapper() {
	    (0, _classCallCheck3.default)(this, BeforeAfterWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (BeforeAfterWrapper.__proto__ || (0, _getPrototypeOf2.default)(BeforeAfterWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BeforeAfterWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          beforeStyle = _props.beforeStyle,
	          afterStyle = _props.afterStyle,
	          beforeElementType = _props.beforeElementType,
	          afterElementType = _props.afterElementType,
	          elementType = _props.elementType,
	          other = (0, _objectWithoutProperties3.default)(_props, ['beforeStyle', 'afterStyle', 'beforeElementType', 'afterElementType', 'elementType']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var beforeElement = void 0;
	      var afterElement = void 0;
	
	      if (beforeStyle) {
	        beforeElement = _react2.default.createElement(this.props.beforeElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, beforeStyle)),
	          key: '::before'
	        });
	      }
	
	      if (afterStyle) {
	        afterElement = _react2.default.createElement(this.props.afterElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, afterStyle)),
	          key: '::after'
	        });
	      }
	
	      var children = [beforeElement, this.props.children, afterElement];
	
	      var props = other;
	      props.style = prepareStyles((0, _simpleAssign2.default)({}, this.props.style));
	
	      return _react2.default.createElement(this.props.elementType, props, children);
	    }
	  }]);
	  return BeforeAfterWrapper;
	}(_react.Component);
	
	BeforeAfterWrapper.defaultProps = {
	  beforeElementType: 'div',
	  afterElementType: 'div',
	  elementType: 'div'
	};
	BeforeAfterWrapper.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	BeforeAfterWrapper.propTypes =  false ? {
	  afterElementType: _propTypes2.default.string,
	  afterStyle: _propTypes2.default.object,
	  beforeElementType: _propTypes2.default.string,
	  beforeStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  elementType: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = BeforeAfterWrapper;

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(212);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(213);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CircleRipple = function (_Component) {
	  (0, _inherits3.default)(CircleRipple, _Component);
	
	  function CircleRipple() {
	    (0, _classCallCheck3.default)(this, CircleRipple);
	    return (0, _possibleConstructorReturn3.default)(this, (CircleRipple.__proto__ || (0, _getPrototypeOf2.default)(CircleRipple)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CircleRipple, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = 0;
	      // If the animation is aborted, remove from the DOM immediately
	      var removeAfter = this.props.aborted ? 0 : 2000;
	      this.enterTimer = setTimeout(callback, removeAfter);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ', ' + _transitions2.default.easeOut('1s', 'transform');
	      _autoPrefix2.default.set(style, 'transition', transitionValue);
	      _autoPrefix2.default.set(style, 'transform', 'scale(1)');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = this.props.opacity;
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	      this.leaveTimer = setTimeout(callback, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          aborted = _props.aborted,
	          color = _props.color,
	          opacity = _props.opacity,
	          style = _props.style,
	          touchGenerated = _props.touchGenerated,
	          other = (0, _objectWithoutProperties3.default)(_props, ['aborted', 'color', 'opacity', 'style', 'touchGenerated']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        top: 0,
	        left: 0,
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        backgroundColor: color
	      }, style);
	
	      return _react2.default.createElement('div', (0, _extends3.default)({}, other, { style: prepareStyles(mergedStyles) }));
	    }
	  }]);
	  return CircleRipple;
	}(_react.Component);
	
	CircleRipple.defaultProps = {
	  opacity: 0.1,
	  aborted: false
	};
	CircleRipple.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CircleRipple.propTypes =  false ? {
	  aborted: _propTypes2.default.bool,
	  color: _propTypes2.default.string,
	  opacity: _propTypes2.default.number,
	  style: _propTypes2.default.object,
	  touchGenerated: _propTypes2.default.bool
	} : {};
	exports.default = CircleRipple;

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BeforeAfterWrapper = __webpack_require__(1565);
	
	var _BeforeAfterWrapper2 = _interopRequireDefault(_BeforeAfterWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  before: {
	    content: "' '",
	    display: 'table'
	  },
	  after: {
	    content: "' '",
	    clear: 'both',
	    display: 'table'
	  }
	};
	
	var ClearFix = function ClearFix(_ref) {
	  var style = _ref.style,
	      children = _ref.children,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['style', 'children']);
	  return _react2.default.createElement(
	    _BeforeAfterWrapper2.default,
	    (0, _extends3.default)({}, other, {
	      beforeStyle: styles.before,
	      afterStyle: styles.after,
	      style: style
	    }),
	    children
	  );
	};
	
	ClearFix.muiName = 'ClearFix';
	
	ClearFix.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	exports.default = ClearFix;

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(290);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _ExpandTransitionChild = __webpack_require__(1569);
	
	var _ExpandTransitionChild2 = _interopRequireDefault(_ExpandTransitionChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpandTransition = function (_Component) {
	  (0, _inherits3.default)(ExpandTransition, _Component);
	
	  function ExpandTransition() {
	    (0, _classCallCheck3.default)(this, ExpandTransition);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransition.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransition)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpandTransition, [{
	    key: 'renderChildren',
	    value: function renderChildren(children) {
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          transitionDelay = _props.transitionDelay,
	          transitionDuration = _props.transitionDuration,
	          expandTransitionChildStyle = _props.expandTransitionChildStyle;
	
	      return _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ExpandTransitionChild2.default,
	          {
	            enterDelay: enterDelay,
	            transitionDelay: transitionDelay,
	            transitionDuration: transitionDuration,
	            key: child.key,
	            style: expandTransitionChildStyle
	          },
	          child
	        );
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          enterDelay = _props2.enterDelay,
	          loading = _props2.loading,
	          open = _props2.open,
	          style = _props2.style,
	          transitionDelay = _props2.transitionDelay,
	          transitionDuration = _props2.transitionDuration,
	          expandTransitionChildStyle = _props2.expandTransitionChildStyle,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'enterDelay', 'loading', 'open', 'style', 'transitionDelay', 'transitionDuration', 'expandTransitionChildStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: 'auto'
	      }, style);
	
	      var newChildren = loading ? [] : this.renderChildren(children);
	
	      return _react2.default.createElement(
	        _TransitionGroup2.default,
	        (0, _extends3.default)({
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }, other),
	        open && newChildren
	      );
	    }
	  }]);
	  return ExpandTransition;
	}(_react.Component);
	
	ExpandTransition.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450,
	  loading: false,
	  open: false
	};
	ExpandTransition.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ExpandTransition.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  expandTransitionChildStyle: _propTypes2.default.object,
	  loading: _propTypes2.default.bool,
	  open: _propTypes2.default.bool,
	  style: _propTypes2.default.object,
	  transitionDelay: _propTypes2.default.number,
	  transitionDuration: _propTypes2.default.number
	} : {};
	exports.default = ExpandTransition;

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reflow = function reflow(elem) {
	  return elem.offsetHeight;
	};
	
	var ExpandTransitionChild = function (_Component) {
	  (0, _inherits3.default)(ExpandTransitionChild, _Component);
	
	  function ExpandTransitionChild() {
	    (0, _classCallCheck3.default)(this, ExpandTransitionChild);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransitionChild.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransitionChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpandTransitionChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.enteredTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.open();
	      callback();
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var _this2 = this;
	
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          transitionDelay = _props.transitionDelay,
	          transitionDuration = _props.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = 0;
	      this.enterTimer = setTimeout(function () {
	        return _this2.open();
	      }, enterDelay);
	      this.enteredTimer = setTimeout(function () {
	        return callback();
	      }, enterDelay + transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var _props2 = this.props,
	          transitionDelay = _props2.transitionDelay,
	          transitionDuration = _props2.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      // Set fixed height first for animated property value
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	      reflow(element);
	      element.style.transitionDuration = transitionDuration + 'ms';
	      element.style.height = 0;
	      this.leaveTimer = setTimeout(function () {
	        return callback();
	      }, transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'setAutoHeight',
	    value: function setAutoHeight() {
	      var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this),
	          style = _ReactDOM$findDOMNode.style;
	
	      style.transitionDuration = 0;
	      style.height = 'auto';
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          children = _props3.children,
	          enterDelay = _props3.enterDelay,
	          style = _props3.style,
	          transitionDelay = _props3.transitionDelay,
	          transitionDuration = _props3.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['children', 'enterDelay', 'style', 'transitionDelay', 'transitionDuration']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        position: 'relative',
	        height: 0,
	        width: '100%',
	        top: 0,
	        left: 0,
	        overflow: 'hidden',
	        transition: _transitions2.default.easeOut(transitionDuration + 'ms', ['height'], transitionDelay + 'ms')
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper' },
	          children
	        )
	      );
	    }
	  }]);
	  return ExpandTransitionChild;
	}(_react.Component);
	
	ExpandTransitionChild.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450
	};
	ExpandTransitionChild.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ExpandTransitionChild.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  style: _propTypes2.default.object,
	  transitionDelay: _propTypes2.default.number,
	  transitionDuration: _propTypes2.default.number
	} : {};
	exports.default = ExpandTransitionChild;

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(290);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _ScaleInChild = __webpack_require__(1571);
	
	var _ScaleInChild2 = _interopRequireDefault(_ScaleInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleIn = function (_Component) {
	  (0, _inherits3.default)(ScaleIn, _Component);
	
	  function ScaleIn() {
	    (0, _classCallCheck3.default)(this, ScaleIn);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleIn.__proto__ || (0, _getPrototypeOf2.default)(ScaleIn)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleIn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          childStyle = _props.childStyle,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ScaleInChild2.default,
	          {
	            key: child.key,
	            enterDelay: enterDelay,
	            maxScale: maxScale,
	            minScale: minScale,
	            style: childStyle
	          },
	          child
	        );
	      });
	
	      return _react2.default.createElement(
	        _TransitionGroup2.default,
	        (0, _extends3.default)({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	  return ScaleIn;
	}(_react.Component);
	
	ScaleIn.defaultProps = {
	  enterDelay: 0
	};
	ScaleIn.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ScaleIn.propTypes =  false ? {
	  childStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  maxScale: _propTypes2.default.number,
	  minScale: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = ScaleIn;

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(213);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleInChild = function (_Component) {
	  (0, _inherits3.default)(ScaleInChild, _Component);
	
	  function ScaleInChild() {
	    (0, _classCallCheck3.default)(this, ScaleInChild);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleInChild.__proto__ || (0, _getPrototypeOf2.default)(ScaleInChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	  return ScaleInChild;
	}(_react.Component);
	
	ScaleInChild.defaultProps = {
	  enterDelay: 0,
	  maxScale: 1,
	  minScale: 0
	};
	ScaleInChild.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ScaleInChild.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  maxScale: _propTypes2.default.number,
	  minScale: _propTypes2.default.number,
	  style: _propTypes2.default.object
	} : {};
	exports.default = ScaleInChild;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(19);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(213);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideInChild = function (_Component) {
	  (0, _inherits3.default)(SlideInChild, _Component);
	
	  function SlideInChild() {
	    (0, _classCallCheck3.default)(this, SlideInChild);
	    return (0, _possibleConstructorReturn3.default)(this, (SlideInChild.__proto__ || (0, _getPrototypeOf2.default)(SlideInChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SlideInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var x = this.props.direction === 'left' ? '100%' : this.props.direction === 'right' ? '-100%' : '0';
	      var y = this.props.direction === 'up' ? '100%' : this.props.direction === 'down' ? '-100%' : '0';
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'translate(0,0)');
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var direction = this.props.getLeaveDirection();
	      var x = direction === 'left' ? '-100%' : direction === 'right' ? '100%' : '0';
	      var y = direction === 'up' ? '-100%' : direction === 'down' ? '100%' : '0';
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          enterDelay = _props.enterDelay,
	          getLeaveDirection = _props.getLeaveDirection,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'getLeaveDirection', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	  return SlideInChild;
	}(_react.Component);
	
	SlideInChild.defaultProps = {
	  enterDelay: 0
	};
	SlideInChild.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	SlideInChild.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  direction: _propTypes2.default.string,
	  enterDelay: _propTypes2.default.number,
	  // This callback is needed bacause the direction could change when leaving the DOM
	  getLeaveDirection: _propTypes2.default.func.isRequired,
	  style: _propTypes2.default.object
	} : {};
	exports.default = SlideInChild;

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	module.exports = _classCallCheck;

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	module.exports = _createClass;

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	module.exports = _inherits;

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(1576);
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = Object.keys(source);
	
	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	module.exports = _objectSpread;

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutProperties;

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(772);
	
	var assertThisInitialized = __webpack_require__(1573);
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return assertThisInitialized(self);
	}
	
	module.exports = _possibleConstructorReturn;

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),
/* 1582 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = compose;
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ }),
/* 1584 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	    return BaseComponent;
	  };
	};
	
	exports.default = setStatic;

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _setDisplayName = __webpack_require__(773);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(774);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _react.createFactory)(BaseComponent);
	
	    var ShouldUpdate = function (_Component) {
	      _inherits(ShouldUpdate, _Component);
	
	      function ShouldUpdate() {
	        _classCallCheck(this, ShouldUpdate);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      ShouldUpdate.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return ShouldUpdate;
	    }(_react.Component);
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
	    }
	    return ShouldUpdate;
	  };
	};
	
	exports.default = shouldUpdate;

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _getMuiTheme = __webpack_require__(775);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MuiThemeProvider = function (_Component) {
	  (0, _inherits3.default)(MuiThemeProvider, _Component);
	
	  function MuiThemeProvider() {
	    (0, _classCallCheck3.default)(this, MuiThemeProvider);
	    return (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MuiThemeProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return MuiThemeProvider;
	}(_react.Component);
	
	MuiThemeProvider.childContextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	MuiThemeProvider.propTypes =  false ? {
	  children: _propTypes2.default.element,
	  muiTheme: _propTypes2.default.object
	} : {};
	exports.default = MuiThemeProvider;

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(29);
	
	var _colorManipulator = __webpack_require__(187);
	
	var _spacing = __webpack_require__(1588);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  Light Theme is the default theme used in material-ui. It is guaranteed to
	 *  have all theme variables needed for every component. Variables not defined
	 *  in a custom theme will default to these values.
	 */
	exports.default = {
	  spacing: _spacing2.default,
	  fontFamily: 'Roboto, sans-serif',
	  borderRadius: 2,
	  palette: {
	    primary1Color: _colors.cyan500,
	    primary2Color: _colors.cyan700,
	    primary3Color: _colors.grey400,
	    accent1Color: _colors.pinkA200,
	    accent2Color: _colors.grey100,
	    accent3Color: _colors.grey500,
	    textColor: _colors.darkBlack,
	    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54),
	    alternateTextColor: _colors.white,
	    canvasColor: _colors.white,
	    borderColor: _colors.grey300,
	    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
	    pickerHeaderColor: _colors.cyan500,
	    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
	    shadowColor: _colors.fullBlack
	  }
	}; /**
	    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
	    */

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  iconSize: 24,
	
	  desktopGutter: 24,
	  desktopGutterMore: 32,
	  desktopGutterLess: 16,
	  desktopGutterMini: 8,
	  desktopKeylineIncrement: 64,
	  desktopDropDownMenuItemHeight: 32,
	  desktopDropDownMenuFontSize: 15,
	  desktopDrawerMenuItemHeight: 48,
	  desktopSubheaderHeight: 48,
	  desktopToolbarHeight: 56
	};

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  menu: 1000,
	  appBar: 1100,
	  drawerOverlay: 1200,
	  drawer: 1300,
	  dialogOverlay: 1400,
	  dialog: 1500,
	  layer: 2000,
	  popover: 2100,
	  snackbar: 2900,
	  tooltip: 3000
	};

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCheckCircle = function ActionCheckCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ActionCheckCircle = (0, _pure2.default)(ActionCheckCircle);
	ActionCheckCircle.displayName = 'ActionCheckCircle';
	ActionCheckCircle.muiName = 'SvgIcon';
	
	exports.default = ActionCheckCircle;

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHome = function ActionHome(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z' })
	  );
	};
	ActionHome = (0, _pure2.default)(ActionHome);
	ActionHome.displayName = 'ActionHome';
	ActionHome.muiName = 'SvgIcon';
	
	exports.default = ActionHome;

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionOpenInNew = function ActionOpenInNew(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' })
	  );
	};
	ActionOpenInNew = (0, _pure2.default)(ActionOpenInNew);
	ActionOpenInNew.displayName = 'ActionOpenInNew';
	ActionOpenInNew.muiName = 'SvgIcon';
	
	exports.default = ActionOpenInNew;

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPrint = function ActionPrint(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z' })
	  );
	};
	ActionPrint = (0, _pure2.default)(ActionPrint);
	ActionPrint.displayName = 'ActionPrint';
	ActionPrint.muiName = 'SvgIcon';
	
	exports.default = ActionPrint;

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationEmail = function CommunicationEmail(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
	  );
	};
	CommunicationEmail = (0, _pure2.default)(CommunicationEmail);
	CommunicationEmail.displayName = 'CommunicationEmail';
	CommunicationEmail.muiName = 'SvgIcon';
	
	exports.default = CommunicationEmail;

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationImportContacts = function CommunicationImportContacts(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z' })
	  );
	};
	CommunicationImportContacts = (0, _pure2.default)(CommunicationImportContacts);
	CommunicationImportContacts.displayName = 'CommunicationImportContacts';
	CommunicationImportContacts.muiName = 'SvgIcon';
	
	exports.default = CommunicationImportContacts;

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationMessage = function CommunicationMessage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
	  );
	};
	CommunicationMessage = (0, _pure2.default)(CommunicationMessage);
	CommunicationMessage.displayName = 'CommunicationMessage';
	CommunicationMessage.muiName = 'SvgIcon';
	
	exports.default = CommunicationMessage;

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentLink = function ContentLink(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' })
	  );
	};
	ContentLink = (0, _pure2.default)(ContentLink);
	ContentLink.displayName = 'ContentLink';
	ContentLink.muiName = 'SvgIcon';
	
	exports.default = ContentLink;

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentRemoveCircleOutline = function ContentRemoveCircleOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ContentRemoveCircleOutline = (0, _pure2.default)(ContentRemoveCircleOutline);
	ContentRemoveCircleOutline.displayName = 'ContentRemoveCircleOutline';
	ContentRemoveCircleOutline.muiName = 'SvgIcon';
	
	exports.default = ContentRemoveCircleOutline;

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentSend = function ContentSend(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2.01 21L23 12 2.01 3 2 10l15 2-15 2z' })
	  );
	};
	ContentSend = (0, _pure2.default)(ContentSend);
	ContentSend.displayName = 'ContentSend';
	ContentSend.muiName = 'SvgIcon';
	
	exports.default = ContentSend;

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorAttachFile = function EditorAttachFile(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z' })
	  );
	};
	EditorAttachFile = (0, _pure2.default)(EditorAttachFile);
	EditorAttachFile.displayName = 'EditorAttachFile';
	EditorAttachFile.muiName = 'SvgIcon';
	
	exports.default = EditorAttachFile;

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorModeEdit = function EditorModeEdit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
	  );
	};
	EditorModeEdit = (0, _pure2.default)(EditorModeEdit);
	EditorModeEdit.displayName = 'EditorModeEdit';
	EditorModeEdit.muiName = 'SvgIcon';
	
	exports.default = EditorModeEdit;

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowDown = function HardwareKeyboardArrowDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' })
	  );
	};
	HardwareKeyboardArrowDown = (0, _pure2.default)(HardwareKeyboardArrowDown);
	HardwareKeyboardArrowDown.displayName = 'HardwareKeyboardArrowDown';
	HardwareKeyboardArrowDown.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowDown;

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowUp = function HardwareKeyboardArrowUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' })
	  );
	};
	HardwareKeyboardArrowUp = (0, _pure2.default)(HardwareKeyboardArrowUp);
	HardwareKeyboardArrowUp.displayName = 'HardwareKeyboardArrowUp';
	HardwareKeyboardArrowUp.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowUp;

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropRight = function NavigationArrowDropRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.5,7l5,5l-5,5V7z' })
	  );
	};
	
	NavigationArrowDropRight = (0, _pure2.default)(NavigationArrowDropRight);
	NavigationArrowDropRight.displayName = 'NavigationArrowDropRight';
	NavigationArrowDropRight.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropRight;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowBack = function NavigationArrowBack(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z' })
	  );
	};
	NavigationArrowBack = (0, _pure2.default)(NavigationArrowBack);
	NavigationArrowBack.displayName = 'NavigationArrowBack';
	NavigationArrowBack.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowBack;

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropDown = function NavigationArrowDropDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' })
	  );
	};
	NavigationArrowDropDown = (0, _pure2.default)(NavigationArrowDropDown);
	NavigationArrowDropDown.displayName = 'NavigationArrowDropDown';
	NavigationArrowDropDown.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropDown;

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCancel = function NavigationCancel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z' })
	  );
	};
	NavigationCancel = (0, _pure2.default)(NavigationCancel);
	NavigationCancel.displayName = 'NavigationCancel';
	NavigationCancel.muiName = 'SvgIcon';
	
	exports.default = NavigationCancel;

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCheck = function NavigationCheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
	  );
	};
	NavigationCheck = (0, _pure2.default)(NavigationCheck);
	NavigationCheck.displayName = 'NavigationCheck';
	NavigationCheck.muiName = 'SvgIcon';
	
	exports.default = NavigationCheck;

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationClose = function NavigationClose(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' })
	  );
	};
	NavigationClose = (0, _pure2.default)(NavigationClose);
	NavigationClose.displayName = 'NavigationClose';
	NavigationClose.muiName = 'SvgIcon';
	
	exports.default = NavigationClose;

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationMenu = function NavigationMenu(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z' })
	  );
	};
	NavigationMenu = (0, _pure2.default)(NavigationMenu);
	NavigationMenu.displayName = 'NavigationMenu';
	NavigationMenu.muiName = 'SvgIcon';
	
	exports.default = NavigationMenu;

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationEventNote = function NotificationEventNote(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z' })
	  );
	};
	NotificationEventNote = (0, _pure2.default)(NotificationEventNote);
	NotificationEventNote.displayName = 'NotificationEventNote';
	NotificationEventNote.muiName = 'SvgIcon';
	
	exports.default = NotificationEventNote;

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSms = function NotificationSms(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z' })
	  );
	};
	NotificationSms = (0, _pure2.default)(NotificationSms);
	NotificationSms.displayName = 'NotificationSms';
	NotificationSms.muiName = 'SvgIcon';
	
	exports.default = NotificationSms;

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBoxOutlineBlank = function ToggleCheckBoxOutlineBlank(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ToggleCheckBoxOutlineBlank = (0, _pure2.default)(ToggleCheckBoxOutlineBlank);
	ToggleCheckBoxOutlineBlank.displayName = 'ToggleCheckBoxOutlineBlank';
	ToggleCheckBoxOutlineBlank.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBoxOutlineBlank;

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBox = function ToggleCheckBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ToggleCheckBox = (0, _pure2.default)(ToggleCheckBox);
	ToggleCheckBox.displayName = 'ToggleCheckBox';
	ToggleCheckBox.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBox;

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleRadioButtonChecked = function ToggleRadioButtonChecked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	ToggleRadioButtonChecked = (0, _pure2.default)(ToggleRadioButtonChecked);
	ToggleRadioButtonChecked.displayName = 'ToggleRadioButtonChecked';
	ToggleRadioButtonChecked.muiName = 'SvgIcon';
	
	exports.default = ToggleRadioButtonChecked;

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(46);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleRadioButtonUnchecked = function ToggleRadioButtonUnchecked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	ToggleRadioButtonUnchecked = (0, _pure2.default)(ToggleRadioButtonUnchecked);
	ToggleRadioButtonUnchecked.displayName = 'ToggleRadioButtonUnchecked';
	ToggleRadioButtonUnchecked.muiName = 'SvgIcon';
	
	exports.default = ToggleRadioButtonUnchecked;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (muiTheme) {
	  var isClient = typeof navigator !== 'undefined';
	  var userAgent = muiTheme.userAgent;
	
	  if (userAgent === undefined && isClient) {
	    userAgent = navigator.userAgent;
	  }
	
	  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
	     false ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;
	
	    hasWarnedAboutUserAgent = true;
	  }
	
	  var prefixAll = (0, _createPrefixer2.default)(_autoprefixerStatic2.default);
	
	  if (userAgent === false) {
	    // Disabled autoprefixer
	    return null;
	  } else if (userAgent === 'all' || userAgent === undefined) {
	    // Prefix for all user agent
	    return function (style) {
	      var isFlex = ['flex', 'inline-flex'].indexOf(style.display) !== -1;
	      var stylePrefixed = prefixAll(style);
	
	      if (isFlex) {
	        var display = stylePrefixed.display;
	        if (isClient) {
	          // We can't apply this join with react-dom:
	          // #https://github.com/facebook/react/issues/6467
	          stylePrefixed.display = display[display.length - 1];
	        } else {
	          stylePrefixed.display = display.join('; display: ');
	        }
	      }
	
	      return stylePrefixed;
	    };
	  } else {
	    var Prefixer = (0, _createPrefixer4.default)(_autoprefixerDynamic2.default, prefixAll);
	    var prefixer = new Prefixer({
	      userAgent: userAgent
	    });
	
	    return function (style) {
	      return prefixer.prefix(style);
	    };
	  }
	};
	
	var _createPrefixer = __webpack_require__(1330);
	
	var _createPrefixer2 = _interopRequireDefault(_createPrefixer);
	
	var _createPrefixer3 = __webpack_require__(1322);
	
	var _createPrefixer4 = _interopRequireDefault(_createPrefixer3);
	
	var _autoprefixerDynamic = __webpack_require__(1618);
	
	var _autoprefixerDynamic2 = _interopRequireDefault(_autoprefixerDynamic);
	
	var _autoprefixerStatic = __webpack_require__(1619);
	
	var _autoprefixerStatic2 = _interopRequireDefault(_autoprefixerStatic);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasWarnedAboutUserAgent = false;

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calc = __webpack_require__(1323);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _flex = __webpack_require__(1324);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxIE = __webpack_require__(1325);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(1326);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(1327);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _sizing = __webpack_require__(1328);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(1329);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
	  prefixMap: { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 60, "userSelect": 53, "fontKerning": 32, "textEmphasisPosition": 60, "textEmphasis": 60, "textEmphasisStyle": 60, "textEmphasisColor": 60, "boxDecorationBreak": 60, "clipPath": 54, "maskImage": 60, "maskMode": 60, "maskRepeat": 60, "maskPosition": 60, "maskClip": 60, "maskOrigin": 60, "maskSize": 60, "maskComposite": 60, "mask": 60, "maskBorderSource": 60, "maskBorderMode": 60, "maskBorderSlice": 60, "maskBorderWidth": 60, "maskBorderOutset": 60, "maskBorderRepeat": 60, "maskBorder": 60, "maskType": 60, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10.1, "userSelect": 10.1, "backdropFilter": 10.1, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10.1, "clipPath": 10.1, "maskImage": 10.1, "maskMode": 10.1, "maskRepeat": 10.1, "maskPosition": 10.1, "maskClip": 10.1, "maskOrigin": 10.1, "maskSize": 10.1, "maskComposite": 10.1, "mask": 10.1, "maskBorderSource": 10.1, "maskBorderMode": 10.1, "maskBorderSlice": 10.1, "maskBorderWidth": 10.1, "maskBorderOutset": 10.1, "maskBorderRepeat": 10.1, "maskBorder": 10.1, "maskType": 10.1, "textDecorationStyle": 10.1, "textDecorationSkip": 10.1, "textDecorationLine": 10.1, "textDecorationColor": 10.1, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10.1, "flowInto": 10.1, "flowFrom": 10.1, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10.1, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 55, "userSelect": 55, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 55, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 45, "userSelect": 40, "fontKerning": 19, "textEmphasisPosition": 45, "textEmphasis": 45, "textEmphasisStyle": 45, "textEmphasisColor": 45, "boxDecorationBreak": 45, "clipPath": 41, "maskImage": 45, "maskMode": 45, "maskRepeat": 45, "maskPosition": 45, "maskClip": 45, "maskOrigin": 45, "maskSize": 45, "maskComposite": 45, "mask": 45, "maskBorderSource": 45, "maskBorderMode": 45, "maskBorderSlice": 45, "maskBorderWidth": 45, "maskBorderOutset": 45, "maskBorderRepeat": 45, "maskBorder": 45, "maskType": 45, "textDecorationStyle": 43, "textDecorationSkip": 43, "textDecorationLine": 43, "textDecorationColor": 43, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 15, "wrapFlow": 15, "wrapThrough": 15, "wrapMargin": 15, "scrollSnapType": 15, "scrollSnapPointsX": 15, "scrollSnapPointsY": 15, "scrollSnapDestination": 15, "scrollSnapCoordinate": 15, "hyphens": 15, "flowInto": 15, "flowFrom": 15, "breakBefore": 15, "breakAfter": 15, "breakInside": 15, "regionFragment": 15, "gridTemplateColumns": 15, "gridTemplateRows": 15, "gridTemplateAreas": 15, "gridTemplate": 15, "gridAutoColumns": 15, "gridAutoRows": 15, "gridAutoFlow": 15, "grid": 15, "gridRowStart": 15, "gridColumnStart": 15, "gridRowEnd": 15, "gridRow": 15, "gridColumn": 15, "gridColumnEnd": 15, "gridColumnGap": 15, "gridRowGap": 15, "gridArea": 15, "gridGap": 15 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 10, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textSizeAdjust": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 10, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "borderImage": 4.2, "borderImageOutset": 4.2, "borderImageRepeat": 4.2, "borderImageSlice": 4.2, "borderImageSource": 4.2, "borderImageWidth": 4.2, "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 53, "userSelect": 53, "fontKerning": 4.4, "textEmphasisPosition": 53, "textEmphasis": 53, "textEmphasisStyle": 53, "textEmphasisColor": 53, "boxDecorationBreak": 53, "clipPath": 53, "maskImage": 53, "maskMode": 53, "maskRepeat": 53, "maskPosition": 53, "maskClip": 53, "maskOrigin": 53, "maskSize": 53, "maskComposite": 53, "mask": 53, "maskBorderSource": 53, "maskBorderMode": 53, "maskBorderSlice": 53, "maskBorderWidth": 53, "maskBorderOutset": 53, "maskBorderRepeat": 53, "maskBorder": 53, "maskType": 53, "filter": 4.4, "fontFeatureSettings": 4.4, "breakAfter": 53, "breakBefore": 53, "breakInside": 53, "columnCount": 53, "columnFill": 53, "columnGap": 53, "columnRule": 53, "columnRuleColor": 53, "columnRuleStyle": 53, "columnRuleWidth": 53, "columns": 53, "columnSpan": 53, "columnWidth": 53 }, "and_chr": { "appearance": 56, "textEmphasisPosition": 56, "textEmphasis": 56, "textEmphasisStyle": 56, "textEmphasisColor": 56, "boxDecorationBreak": 56, "maskImage": 56, "maskMode": 56, "maskRepeat": 56, "maskPosition": 56, "maskClip": 56, "maskOrigin": 56, "maskSize": 56, "maskComposite": 56, "mask": 56, "maskBorderSource": 56, "maskBorderMode": 56, "maskBorderSlice": 56, "maskBorderWidth": 56, "maskBorderOutset": 56, "maskBorderRepeat": 56, "maskBorder": 56, "maskType": 56, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56 }, "and_uc": { "flex": 11, "flexBasis": 11, "flexDirection": 11, "flexGrow": 11, "flexFlow": 11, "flexShrink": 11, "flexWrap": 11, "alignContent": 11, "alignItems": 11, "alignSelf": 11, "justifyContent": 11, "order": 11, "transition": 11, "transitionDelay": 11, "transitionDuration": 11, "transitionProperty": 11, "transitionTimingFunction": 11, "transform": 11, "transformOrigin": 11, "transformOriginX": 11, "transformOriginY": 11, "backfaceVisibility": 11, "perspective": 11, "perspectiveOrigin": 11, "transformStyle": 11, "transformOriginZ": 11, "animation": 11, "animationDelay": 11, "animationDirection": 11, "animationFillMode": 11, "animationDuration": 11, "animationIterationCount": 11, "animationName": 11, "animationPlayState": 11, "animationTimingFunction": 11, "appearance": 11, "userSelect": 11, "fontKerning": 11, "textEmphasisPosition": 11, "textEmphasis": 11, "textEmphasisStyle": 11, "textEmphasisColor": 11, "maskImage": 11, "maskMode": 11, "maskRepeat": 11, "maskPosition": 11, "maskClip": 11, "maskOrigin": 11, "maskSize": 11, "maskComposite": 11, "mask": 11, "maskBorderSource": 11, "maskBorderMode": 11, "maskBorderSlice": 11, "maskBorderWidth": 11, "maskBorderOutset": 11, "maskBorderRepeat": 11, "maskBorder": 11, "maskType": 11, "textSizeAdjust": 11, "filter": 11, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "fontFeatureSettings": 11, "columnCount": 11, "columnFill": 11, "columnGap": 11, "columnRule": 11, "columnRuleColor": 11, "columnRuleStyle": 11, "columnRuleWidth": 11, "columns": 11, "columnSpan": 11, "columnWidth": 11 }, "op_mini": {} }
	}; /* eslint-disable */

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calc = __webpack_require__(1331);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _flex = __webpack_require__(680);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxIE = __webpack_require__(1335);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(681);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(682);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _sizing = __webpack_require__(683);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(684);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
	  prefixMap: { "transform": ["Webkit", "ms"], "transformOrigin": ["Webkit", "ms"], "transformOriginX": ["Webkit", "ms"], "transformOriginY": ["Webkit", "ms"], "backfaceVisibility": ["Webkit"], "perspective": ["Webkit"], "perspectiveOrigin": ["Webkit"], "transformStyle": ["Webkit"], "transformOriginZ": ["Webkit"], "animation": ["Webkit"], "animationDelay": ["Webkit"], "animationDirection": ["Webkit"], "animationFillMode": ["Webkit"], "animationDuration": ["Webkit"], "animationIterationCount": ["Webkit"], "animationName": ["Webkit"], "animationPlayState": ["Webkit"], "animationTimingFunction": ["Webkit"], "appearance": ["Webkit", "Moz"], "userSelect": ["Webkit", "Moz", "ms"], "fontKerning": ["Webkit"], "textEmphasisPosition": ["Webkit"], "textEmphasis": ["Webkit"], "textEmphasisStyle": ["Webkit"], "textEmphasisColor": ["Webkit"], "boxDecorationBreak": ["Webkit"], "clipPath": ["Webkit"], "maskImage": ["Webkit"], "maskMode": ["Webkit"], "maskRepeat": ["Webkit"], "maskPosition": ["Webkit"], "maskClip": ["Webkit"], "maskOrigin": ["Webkit"], "maskSize": ["Webkit"], "maskComposite": ["Webkit"], "mask": ["Webkit"], "maskBorderSource": ["Webkit"], "maskBorderMode": ["Webkit"], "maskBorderSlice": ["Webkit"], "maskBorderWidth": ["Webkit"], "maskBorderOutset": ["Webkit"], "maskBorderRepeat": ["Webkit"], "maskBorder": ["Webkit"], "maskType": ["Webkit"], "textDecorationStyle": ["Webkit", "Moz"], "textDecorationSkip": ["Webkit", "Moz"], "textDecorationLine": ["Webkit", "Moz"], "textDecorationColor": ["Webkit", "Moz"], "filter": ["Webkit"], "fontFeatureSettings": ["Webkit", "Moz"], "breakAfter": ["Webkit", "Moz", "ms"], "breakBefore": ["Webkit", "Moz", "ms"], "breakInside": ["Webkit", "Moz", "ms"], "columnCount": ["Webkit", "Moz"], "columnFill": ["Webkit", "Moz"], "columnGap": ["Webkit", "Moz"], "columnRule": ["Webkit", "Moz"], "columnRuleColor": ["Webkit", "Moz"], "columnRuleStyle": ["Webkit", "Moz"], "columnRuleWidth": ["Webkit", "Moz"], "columns": ["Webkit", "Moz"], "columnSpan": ["Webkit", "Moz"], "columnWidth": ["Webkit", "Moz"], "flex": ["Webkit", "ms"], "flexBasis": ["Webkit"], "flexDirection": ["Webkit", "ms"], "flexGrow": ["Webkit"], "flexFlow": ["Webkit", "ms"], "flexShrink": ["Webkit"], "flexWrap": ["Webkit", "ms"], "alignContent": ["Webkit"], "alignItems": ["Webkit"], "alignSelf": ["Webkit"], "justifyContent": ["Webkit"], "order": ["Webkit"], "transitionDelay": ["Webkit"], "transitionDuration": ["Webkit"], "transitionProperty": ["Webkit"], "transitionTimingFunction": ["Webkit"], "backdropFilter": ["Webkit"], "scrollSnapType": ["Webkit", "ms"], "scrollSnapPointsX": ["Webkit", "ms"], "scrollSnapPointsY": ["Webkit", "ms"], "scrollSnapDestination": ["Webkit", "ms"], "scrollSnapCoordinate": ["Webkit", "ms"], "shapeImageThreshold": ["Webkit"], "shapeImageMargin": ["Webkit"], "shapeImageOutside": ["Webkit"], "hyphens": ["Webkit", "Moz", "ms"], "flowInto": ["Webkit", "ms"], "flowFrom": ["Webkit", "ms"], "regionFragment": ["Webkit", "ms"], "boxSizing": ["Moz"], "textAlignLast": ["Moz"], "tabSize": ["Moz"], "wrapFlow": ["ms"], "wrapThrough": ["ms"], "wrapMargin": ["ms"], "touchAction": ["ms"], "gridTemplateColumns": ["ms"], "gridTemplateRows": ["ms"], "gridTemplateAreas": ["ms"], "gridTemplate": ["ms"], "gridAutoColumns": ["ms"], "gridAutoRows": ["ms"], "gridAutoFlow": ["ms"], "grid": ["ms"], "gridRowStart": ["ms"], "gridColumnStart": ["ms"], "gridRowEnd": ["ms"], "gridRow": ["ms"], "gridColumn": ["ms"], "gridColumnEnd": ["ms"], "gridColumnGap": ["ms"], "gridRowGap": ["ms"], "gridArea": ["ms"], "gridGap": ["ms"], "textSizeAdjust": ["Webkit", "ms"], "borderImage": ["Webkit"], "borderImageOutset": ["Webkit"], "borderImageRepeat": ["Webkit"], "borderImageSlice": ["Webkit"], "borderImageSource": ["Webkit"], "borderImageWidth": ["Webkit"] }
	}; /* eslint-disable */

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = callOnce;
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CALLED_ONCE = 'muiPrepared';
	
	function callOnce() {
	  if (false) {
	    return function (style) {
	      if (style[CALLED_ONCE]) {
	        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: You cannot call prepareStyles() on the same style object more than once.') : void 0;
	      }
	      style[CALLED_ONCE] = true;
	      return style;
	    };
	  }
	}

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(590);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = rtl;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
	var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;
	
	/**
	 * This function ensures that `style` supports both ltr and rtl directions by
	 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
	 * necessary.
	 */
	function rtl(muiTheme) {
	  if (muiTheme.isRtl) {
	    return function (style) {
	      if (style.directionInvariant === true) {
	        return style;
	      }
	
	      var flippedAttributes = {
	        // Keys and their replacements.
	        right: 'left',
	        left: 'right',
	        marginRight: 'marginLeft',
	        marginLeft: 'marginRight',
	        paddingRight: 'paddingLeft',
	        paddingLeft: 'paddingRight',
	        borderRight: 'borderLeft',
	        borderLeft: 'borderRight'
	      };
	
	      var newStyle = {};
	
	      (0, _keys2.default)(style).forEach(function (attribute) {
	        var value = style[attribute];
	        var key = attribute;
	
	        if (flippedAttributes.hasOwnProperty(attribute)) {
	          key = flippedAttributes[attribute];
	        }
	
	        switch (attribute) {
	          case 'float':
	          case 'textAlign':
	            if (value === 'right') {
	              value = 'left';
	            } else if (value === 'left') {
	              value = 'right';
	            }
	            break;
	
	          case 'direction':
	            if (value === 'ltr') {
	              value = 'rtl';
	            } else if (value === 'rtl') {
	              value = 'ltr';
	            }
	            break;
	
	          case 'transform':
	            if (!value) break;
	            var matches = void 0;
	            if (matches = value.match(reTranslate)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
	            }
	            if (matches = value.match(reSkew)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
	            }
	            break;
	
	          case 'transformOrigin':
	            if (!value) break;
	            if (value.indexOf('right') > -1) {
	              value = value.replace('right', 'left');
	            } else if (value.indexOf('left') > -1) {
	              value = value.replace('left', 'right');
	            }
	            break;
	        }
	
	        newStyle[key] = value;
	      });
	
	      return newStyle;
	    };
	  }
	}

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LARGE = exports.MEDIUM = exports.SMALL = undefined;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(17);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.default = withWidth;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(165);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SMALL = exports.SMALL = 1;
	var MEDIUM = exports.MEDIUM = 2;
	var LARGE = exports.LARGE = 3;
	
	function withWidth() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$largeWidth = options.largeWidth,
	      largeWidth = _options$largeWidth === undefined ? 992 : _options$largeWidth,
	      _options$mediumWidth = options.mediumWidth,
	      mediumWidth = _options$mediumWidth === undefined ? 768 : _options$mediumWidth,
	      _options$resizeInterv = options.resizeInterval,
	      resizeInterval = _options$resizeInterv === undefined ? 166 : _options$resizeInterv;
	
	
	  return function (MyComponent) {
	    return function (_Component) {
	      (0, _inherits3.default)(WithWidth, _Component);
	
	      function WithWidth() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, WithWidth);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WithWidth.__proto__ || (0, _getPrototypeOf2.default)(WithWidth)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          width: null
	        }, _this.handleResize = function () {
	          clearTimeout(_this.deferTimer);
	          _this.deferTimer = setTimeout(function () {
	            _this.updateWidth();
	          }, resizeInterval);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	      }
	
	      (0, _createClass3.default)(WithWidth, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.updateWidth();
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          clearTimeout(this.deferTimer);
	        }
	      }, {
	        key: 'updateWidth',
	        value: function updateWidth() {
	          var innerWidth = window.innerWidth;
	          var width = void 0;
	
	          if (innerWidth >= largeWidth) {
	            width = LARGE;
	          } else if (innerWidth >= mediumWidth) {
	            width = MEDIUM;
	          } else {
	            // innerWidth < 768
	            width = SMALL;
	          }
	
	          if (width !== this.state.width) {
	            this.setState({
	              width: width
	            });
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var width = this.state.width;
	
	          /**
	           * When rendering the component on the server,
	           * we have no idea about the screen width.
	           * In order to prevent blinks and help the reconciliation
	           * we are not rendering the component.
	           *
	           * A better alternative would be to send client hints.
	           * But the browser support of this API is low:
	           * http://caniuse.com/#search=client%20hint
	           */
	          if (width === null) {
	            return null;
	          }
	
	          return _react2.default.createElement(
	            _reactEventListener2.default,
	            { target: 'window', onResize: this.handleResize },
	            _react2.default.createElement(MyComponent, (0, _extends3.default)({
	              width: width
	            }, this.props))
	          );
	        }
	      }]);
	      return WithWidth;
	    }(_react.Component);
	  };
	}

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(1627);
	Mexp.prototype.formulaEval = function () {
		"use strict";
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1||arr[i].type===3){
				disp.push({value:arr[i].type===3?arr[i].show:arr[i].value,type:1});
			}
			else if(arr[i].type===13){
				disp.push({value:arr[i].show,type:1});
			}
			else if(arr[i].type===0){
				disp[disp.length-1]={value:arr[i].show+(arr[i].show!="-"?"(":"")+disp[disp.length-1].value+(arr[i].show!="-"?")":""),type:0};
			}
			else if(arr[i].type===7){
				disp[disp.length-1]={value:(disp[disp.length-1].type!=1?"(":"")+disp[disp.length-1].value+(disp[disp.length-1].type!=1?")":"")+arr[i].show,type:7};
			}
			else if(arr[i].type===10){
				pop1=disp.pop();
				pop2=disp.pop();
				if(arr[i].show==='P'||arr[i].show==='C')disp.push({value:"<sup>"+pop2.value+"</sup>"+arr[i].show+"<sub>"+pop1.value+"</sub>",type:10});
				else disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+"<sup>"+pop1.value+"</sup>",type:1});
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=disp.pop();
				pop2=disp.pop();
				disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+arr[i].show+(pop1.type!=1?"(":"")+pop1.value+(pop1.type!=1?")":""),type:arr[i].type});
			}
			else if(arr[i].type===12){
				pop1=disp.pop();
				pop2=disp.pop();
				pop3=disp.pop();
				disp.push({value:arr[i].show+"("+pop3.value+","+pop2.value+","+pop1.value+")",type:12});
			}
		}
		return disp[0].value;
	};
	module.exports=Mexp;

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(1625);
		function inc(arr,val){
			for(var i=0;i<arr.length;i++)
				arr[i]+=val;
			return arr;
		}
		var token=['sin','cos','tan','pi','(',')','P','C',
			  'asin','acos','atan','7','8','9','int',
			  'cosh','acosh','ln','^','root','4','5','6','/','!',
			  'tanh','atanh','Mod','1','2','3','*',
			  'sinh','asinh','e','log','0','.','+','-',',','Sigma','n','Pi','pow'];
		var show=['sin','cos','tan','&pi;','(',')','P','C',
			'asin','acos','atan','7','8','9','Int',
			'cosh','acosh',' ln','^','root','4','5','6','&divide;','!',
			'tanh','atanh',' Mod ','1','2','3','&times;',
			'sinh','asinh','e',' log','0','.','+','-',',','&Sigma;','n','&Pi;','pow'];
		var eva=[Mexp.math.sin,Mexp.math.cos,Mexp.math.tan,'PI','(',')',Mexp.math.P,Mexp.math.C,
			Mexp.math.asin,Mexp.math.acos,Mexp.math.atan,'7','8','9',Math.floor,
			Mexp.math.cosh,Mexp.math.acosh,Math.log,Math.pow,Math.sqrt,'4','5','6',Mexp.math.div,Mexp.math.fact,
			Mexp.math.tanh,Mexp.math.atanh,Mexp.math.mod,'1','2','3',Mexp.math.mul,
			Mexp.math.sinh,Mexp.math.asinh,'E',Mexp.math.log,'0','.',Mexp.math.add,Mexp.math.sub,',',Mexp.math.sigma,'n',Mexp.math.Pi,Math.pow];
		var preced={0:11,1:0,2:3,3:0,4:0,5:0,6:0,7:11,8:11,9:1,10:10,11:0,12:11,13:0};
		var type=[0,0,0,3,4,5,10,10,
			0,0,0,1,1,1,0,
			0,0,0,10,0,1,1,1,2,7,
			0,0,2,1,1,1,2,
			0,0,3,0,1,6,9,9,11,12,13,12,8];
		 /*
		0 : function with syntax function_name(Maths_exp)
		1 : numbers
		2 : binary operators like * / Mod left associate and same precedence
		3 : Math constant values like e,pi,Cruncher ans
		4 : opening bracket
		5 : closing bracket
		6 : decimal
		7 : function with syntax (Math_exp)function_name
		8: function with syntax function_name(Math_exp1,Math_exp2)
		9 : binary operator like +,-
		10: binary operator like P C or ^
		11: ,
		12: function with , seperated three parameters
		13: variable of Sigma function
		 */
		var type0={0:true,1:true,3:true,4:true,6:true,8:true,9:true,12:true,13:true},//type2:true,type4:true,type9:true,type11:true,type21:true,type22
		type1={0:true,1:true,2:true,3:true,4:true,5:true,6:true,7:true,8:true,9:true,10:true,11:true,12:true,13:true},//type3:true,type5:true,type7:true,type23
		type_1={0:true,3:true,4:true,8:true,12:true,13:true},
		empty={},
		type_3={0:true,1:true,3:true,4:true,6:true,8:true,12:true,13:true},//type_5:true,type_7:true,type_23
		type6={1:true},
		newAr=[[],
				["1","2","3","7","8","9","4","5","6","+","-","*","/","(",")","^","!","P","C","e","0",".",",","n"],
				["pi","ln","Pi"],
				["sin","cos","tan","Del","int","Mod","log","pow"],
				["asin","acos","atan","cosh","root","tanh","sinh"],
				["acosh","atanh","asinh","Sigma"]];
		function match(str1,str2,i,x){
			for(var f=0;f<x;f++){
				if (str1[i+f]!==str2[f])
					return false;
			}
			return true;
		}
		Mexp.addToken=function(tokens){
			for(i=0;i<tokens.length;i++){
				x=tokens[i].token.length;
				var temp=-1;
	
				//newAr is a specially designed data structure in which 1D array at location one of 2d array has all string with length 1 2 with 2 and so on
	
				if (x<newAr.length)	//match to check if token is really huge and not existing
									//if not checked it will break in next line as undefined index
					for(y=0;y<newAr[x].length;y++){
						if (tokens[i].token===newAr[x][y]){
							temp=token.indexOf(newAr[x][y]);
							break;
						}
					}
				if (temp===-1) {
					token.push(tokens[i].token);
					type.push(tokens[i].type);
					if(newAr.length<=tokens[i].token.length)
						newAr[tokens[i].token.length]=[];
					newAr[tokens[i].token.length].push(tokens[i].token);
					eva.push(tokens[i].value);
					show.push(tokens[i].show);
				}
				else {
					token[temp]=tokens[i].token;
					type[temp]=tokens[i].type;
					eva[temp]=tokens[i].value;
					show[temp]=tokens[i].show;
				}
			}
		};
		Mexp.lex=function(inp,tokens){
			'use strict';
			var str=[{type:4,value:"(",show:"(",pre:0}];
			var ptc=[];	//Parenthesis to close at the beginning is after one token
			var inpStr=inp;
			var key;
	        var pcounter=0;
			var allowed=type0;
			var bracToClose=0;
			var asterick=empty;
			var prevKey='';
			var i,x,y;
			if(typeof tokens!=="undefined")
				Mexp.addToken(tokens);
			var obj={};
			for(i=0;i<inpStr.length;i++){
				if (inpStr[i]==' ') {
					continue;
				}
				key='';
				sec:for(x=(inpStr.length-i>(newAr.length-2)?newAr.length-1:inpStr.length-i);x>0;x--){
					for(y=0;y<newAr[x].length;y++){
						if (match(inpStr,newAr[x][y],i,x)){
							key=newAr[x][y];
							break sec;
						}
					}
				}
				i+=key.length-1;
				if(key===''){
					throw(new Mexp.exception("Can't understand after "+inpStr.slice(i)));
				}
				var index=token.indexOf(key);
				var cToken=key;
				var cType=type[index];
				var cEv=eva[index];
				var cPre=preced[cType];
				var	cShow=show[index];
				var pre=str[str.length-1];
				for(j=ptc.length;j--;){	//loop over ptc
					if(ptc[j]===0){
						if([0,2,3,5,9,11,12,13].indexOf(cType)!==-1){
							if(allowed[cType]!==true){
								throw(new Mexp.exception(key+" is not allowed after "+prevKey));
							}
							str.push({value:")",type:5,pre:0,show:")"});
							allowed=type1;
							asterick=type_3;
							inc(ptc,-1).pop();
						}
					}
				}
				if(allowed[cType]!==true){
					throw(new Mexp.exception(key+" is not allowed after "+prevKey));
				}
				if(asterick[cType]===true){
					cType=2;
					cEv=Mexp.math.mul;
					cShow="&times;";
					cPre=3;
					i=i-key.length;
			 	}
				obj={value:cEv,type:cType,pre:cPre,show:cShow};
				if(cType===0){
					allowed=type0;
					asterick=empty;
					inc(ptc,2).push(2);
					str.push(obj);
					str.push({value:"(",type:4,pre:0,show:"("});
				}
				else if(cType===1){
					if(pre.type===1){
						pre.value+=cEv;
						inc(ptc,1);
					}
					else {
						str.push(obj);
					}
					allowed=type1;
					asterick=type_1;
				}
				else if(cType===2){
					allowed=type0;
					asterick=empty;
					inc(ptc,2);
					str.push(obj);
				}
				else if(cType===3){//constant
					str.push(obj);
					allowed=type1;
					asterick=type_3;
				}
				else if(cType===4){
	                pcounter+=ptc.length;
	                ptc=[];
					bracToClose++;
					allowed=type0;
					asterick=empty;
					str.push(obj);
				}
				else if(cType===5){
					if(!bracToClose){
						throw(new Mexp.exception("Closing parenthesis are more than opening one, wait What!!!"));
					}
	                while(pcounter--){	//loop over ptc
	    						str.push({value:")",type:5,pre:0,show:")"});
	    			}
	                pcounter=0;
					bracToClose--;
					allowed=type1;
					asterick=type_3;
					str.push(obj);
				}
				else if(cType===6){
					if(pre.hasDec){
						throw(new Mexp.exception("Two decimals are not allowed in one number"));
					}
					if(pre.type!==1){
						pre={value:0,type:1,pre:0};	//pre needs to be changed as it will the last value now to be safe in later code
						str.push(pre);
						inc(ptc,-1);
					}
					allowed=type6;
					inc(ptc,1);
					asterick=empty;
					pre.value+=cEv;
					pre.hasDec=true;
				}
				else if(cType===7){
					allowed=type1;
					asterick=type_3;
					inc(ptc,1);
					str.push(obj);
				}
				if(cType===8){
					allowed=type0;
					asterick=empty;
					inc(ptc,4).push(4);
					str.push(obj);
					str.push({value:"(",type:4,pre:0,show:"("});
				}
				else if(cType===9){
					if(pre.type===9){
						if(pre.value===Mexp.math.add){
							pre.value=cEv;
							pre.show=cShow;
							inc(ptc,1);
						}
						else if(pre.value===Mexp.math.sub&&cShow==='-'){
							pre.value=Mexp.math.add;
							pre.show='+';
							inc(ptc,1);
						}
					}
					else if(pre.type!==5&&pre.type!==7&&pre.type!==1&&pre.type!==3&&pre.type!==13){//changesign only when negative is found
						if(cToken==='-'){//do nothing for + token
										//don't add with the above if statement as that will run the else statement of parent if on Ctoken +
							allowed=type0;
							asterick=empty;
							inc(ptc,2).push(2);
							str.push({value:Mexp.math.changeSign,type:0,pre:21,show:"-"});
							str.push({value:"(",type:4,pre:0,show:"("});
						}
					}
					else{
						str.push(obj);
						inc(ptc,2);
					}
					allowed=type0;
					asterick=empty;
				}
				else if(cType===10){
					allowed=type0;
					asterick=empty;
					inc(ptc,2);
					str.push(obj);
				}
				else if(cType===11){
					allowed=type0;
					asterick=empty;
					str.push(obj);
				}
				else if(cType===12){
					allowed=type0;
					asterick=empty;
					inc(ptc,6).push(6);
					str.push(obj);
					str.push({value:"(",type:4,pre:0});
				}
				else if(cType===13){
					allowed=type1;
					asterick=type_3;
					str.push(obj);
				}
				inc(ptc,-1);
				prevKey=key;
			}
			for(var j=ptc.length;j--;){	//loop over ptc
				if(ptc[j]===0){
	
					str.push({value:")",show:")",type:5,pre:3});
					inc(ptc,-1).pop();
				}
			}
			if (allowed[5]!==true) {
				throw(new Mexp.exception("complete the expression"));
			}
			while(bracToClose--)
				str.push({value:")",show:")",type:5,pre:3});
	
			str.push({type:5,value:")",show:")",pre:0});
	//        console.log(str);
			return new Mexp(str);
		};
	    module.exports=Mexp;


/***/ }),
/* 1625 */
/***/ (function(module, exports) {

		var Mexp=function(parsed){
			this.value=parsed;
	
		};
	
		Mexp.math={
			isDegree:true, //mode of calculator
			acos:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.acos(x):Math.acos(x));
			},
			add:function(a,b){
				return a+b;
			},
			asin:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.asin(x):Math.asin(x));
			},
			atan:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.atan(x):Math.atan(x));
			},
			acosh:function(x){
				return Math.log(x+Math.sqrt(x*x-1));
			},
			asinh:function(x){
				return Math.log(x+Math.sqrt(x*x+1));
			},
			atanh:function(x){
				return Math.log((1+x)/(1-x));
			},
			C:function(n,r){
				var pro=1,other=n-r,choice=r;
				if(choice<other){
				choice=other;
				other=r;
				}
				for(var i=choice+1;i<=n;i++)
					pro*=i;
				return pro/Mexp.math.fact(other);
			},
			changeSign:function(x){
				return -x;
			},
			cos:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.cos(x);
			},
			cosh:function(x){
				return (Math.pow(Math.E,x)+Math.pow(Math.E,-1*x))/2;
			},
			div:function(a,b){
			return a/b;
			},
			fact:function(n) {
			if(n%1!==0)return "NAN";
				var pro=1;
				for(var i=2;i<=n;i++)
					pro*=i;
				return pro;
			},
			inverse:function(x){
				return 1/x;
			},
			log:function(i){
				return Math.log(i)/Math.log(10);
			},
			mod:function(a,b){
			return a%b;
			},
			mul:function(a,b){
			return a*b;
			},
			P:function(n,r){var pro=1;
				 for(var i=Math.floor(n)-Math.floor(r)+1;i<=Math.floor(n);i++)
						pro*=i;
						return pro;
	
			},
			Pi:function(low,high,ex){
				var pro=1;
				for(var i=low;i<=high;i++){
					pro*=Number(ex.postfixEval({n:i}));
				}
				return pro;
			},
			pow10x:function(e){
				var x=1;
				while(e--){x*=10;}
				return x;
			},
			sigma:function(low,high,ex){
				var sum=0;
				for(var i=low;i<=high;i++){
					sum+=Number(ex.postfixEval({n:i}));
				}
				return sum;
			},
			sin:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.sin(x);
			},
			sinh:function(x){
				return (Math.pow(Math.E,x)-Math.pow(Math.E,-1*x))/2;
			},
			sub:function(a,b){
			return a-b;
			},
			tan:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.tan(x);
			},
			tanh:function(x){
				return Mexp.sinha(x)/Mexp.cosha(x);
			},
			toRadian:function(x){
				return x*Math.PI/180;
			}
		};
		Mexp.exception=function(message){
			this.message=message;
		};
	    module.exports=Mexp;

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	
	    var Mexp=__webpack_require__(1624);
	
		Mexp.prototype.toPostfix = function () {
			'use strict';
			var post=[],elem,popped,prep,pre,ele;
	    	var stack=[{value:"(",type:4,pre:0}];
			var arr=this.value;
			for (var i=1; i < arr.length; i++) {
				if(arr[i].type===1||arr[i].type===3||arr[i].type===13){	//if token is number,constant,or n(which is also a special constant in our case)
					if(arr[i].type===1)
						arr[i].value=Number(arr[i].value);
					post.push(arr[i]);
				}
				else if(arr[i].type===4){
					stack.push(arr[i]);
				}
				else if(arr[i].type===5){
					while((popped=stack.pop()).type!==4){
						post.push(popped);
					}
				}
				else if(arr[i].type===11){
					while((popped=stack.pop()).type!==4){
						post.push(popped);
					}
					stack.push(popped);
				}
				else {
					elem=arr[i];
					pre=elem.pre;
					ele=stack[stack.length-1];
					prep=ele.pre;
					var flag=ele.value=='Math.pow'&&elem.value=='Math.pow';
					if(pre>prep)stack.push(elem);
					else {
						while(prep>=pre&&!flag||flag&&pre<prep){
							popped=stack.pop();
							ele=stack[stack.length-1];
							post.push(popped);
							prep=ele.pre;
							flag=elem.value=='Math.pow'&&ele.value=='Math.pow';
						}
						stack.push(elem);
					}
				}
			}
			return new Mexp(post);
		};
	    module.exports=Mexp;

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(1626);
	Mexp.prototype.postfixEval = function (UserDefined) {
		'use strict';
		UserDefined=UserDefined||{};
		UserDefined.PI=Math.PI;
		UserDefined.E=Math.E;
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		var bool=(typeof UserDefined.n!=="undefined");
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1){
				stack.push({value:arr[i].value,type:1});
			}
			else if(arr[i].type===3){
				stack.push({value:UserDefined[arr[i].value],type:1});
			}
			else if(arr[i].type===0){
				if(typeof stack[stack.length-1].type==="undefined"){
					stack[stack.length-1].value.push(arr[i]);
				}
				else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
			}
			else if(arr[i].type===7){
				if(typeof stack[stack.length-1].type==="undefined"){
					stack[stack.length-1].value.push(arr[i]);
				}
				else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
			}
			else if(arr[i].type===8){
				pop1=stack.pop();
				pop2=stack.pop();
				stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
			}
			else if(arr[i].type===10){
				pop1=stack.pop();
				pop2=stack.pop();
				if(typeof pop2.type==="undefined"){
					pop2.value=pop2.concat(pop1);
					pop2.value.push(arr[i]);
					stack.push(pop2);
				}
				else if (typeof pop1.type==="undefined") {
					pop1.unshift(pop2);
					pop1.push(arr[i]);
					stack.push(pop1);
				}
				else{
					stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
	            }
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=stack.pop();
				pop2=stack.pop();
				if(typeof pop2.type==="undefined"){
	                console.log(pop2);
					pop2=pop2.concat(pop1);
					pop2.push(arr[i]);
					stack.push(pop2);
				}
				else if (typeof pop1.type==="undefined") {
					pop1.unshift(pop2);
					pop1.push(arr[i]);
					stack.push(pop1);
				}
				else{
					stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
				}
			}
			else if(arr[i].type===12){
				pop1=stack.pop();
				if (typeof pop1.type!=="undefined") {
					pop1=[pop1];
				}
				pop2=stack.pop();
				pop3=stack.pop();
				stack.push({type:1,value:arr[i].value(pop3.value,pop2.value,new Mexp(pop1))});
			}
			else if(arr[i].type===13){
				if(bool){
					stack.push({value:UserDefined[arr[i].value],type:3});
				}
				else stack.push([arr[i]]);
			}
		}
		if (stack.length>1) {
			throw(new Mexp.exception("Uncaught Syntax error"));
		}
		return stack[0].value>1000000000000000?"Infinity":parseFloat(stack[0].value.toFixed(15));
	};
	Mexp.eval=function(str,tokens,obj){
		if (typeof tokens==="undefined") {
			return this.lex(str).toPostfix().postfixEval();
		}
		else if (typeof obj==="undefined") {
			if (typeof tokens.length!=="undefined") 
				return this.lex(str,tokens).toPostfix().postfixEval();
			else
				return this.lex(str).toPostfix().postfixEval(tokens);
		}
		else
			return this.lex(str,tokens).toPostfix().postfixEval(obj);
	};
	module.exports=Mexp;

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(39)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	
	    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
	    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(39)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(39)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(39)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(39)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(39)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(39)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (m === true) {
	            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
	 * numeral.js
	 * version : 1.5.6
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function() {
	
	    /************************************
	        Variables
	    ************************************/
	
	    var numeral,
	        VERSION = '1.5.6',
	        // internal storage for language config files
	        languages = {},
	        defaults = {
	            currentLanguage: 'en',
	            zeroFormat: null,
	            nullFormat: null,
	            defaultFormat: '0,0'
	        },
	        options = {
	            currentLanguage: defaults.currentLanguage,
	            zeroFormat: defaults.zeroFormat,
	            nullFormat: defaults.nullFormat,
	            defaultFormat: defaults.defaultFormat
	        },
	        byteSuffixes = {
	            bytes: ['B','KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
	            iec: ['B','KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	        };
	
	
	    /************************************
	        Constructors
	    ************************************/
	
	
	    // Numeral prototype object
	    function Numeral(number) {
	        this._value = number;
	    }
	
	    /**
	     * Implementation of toFixed() that treats floats more like decimals
	     *
	     * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	     * problems for accounting- and finance-related software.
	     */
	    function toFixed (value, maxDecimals, roundingFunction, optionals) {
	        var splitValue = value.toString().split('.'),
	            minDecimals = maxDecimals - (optionals || 0),
	            boundedPrecision,
	            optionalsRegExp,
	            power,
	            output;
	
	        // Use the smallest precision value possible to avoid errors from floating point representation
	        if (splitValue.length === 2) {
	          boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
	        } else {
	          boundedPrecision = minDecimals;
	        }
	
	        power = Math.pow(10, boundedPrecision);
	
	        //roundingFunction = (roundingFunction !== undefined ? roundingFunction : Math.round);
	        // Multiply up by precision, round accurately, then divide and use native toFixed():
	        output = (roundingFunction(value * power) / power).toFixed(boundedPrecision);
	
	        if (optionals > maxDecimals - boundedPrecision) {
	            optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
	            output = output.replace(optionalsRegExp, '');
	        }
	
	        return output;
	    }
	
	    /************************************
	        Formatting
	    ************************************/
	
	    // determine what type of formatting we need to do
	    function formatNumeral(n, format, roundingFunction) {
	        var output;
	
	        if (n._value === 0 && options.zeroFormat !== null) {
	            output = options.zeroFormat;
	        } else if (n._value === null && options.nullFormat !== null) {
	            output = options.nullFormat;
	        } else {
	            // figure out what kind of format we are dealing with
	            if (format.indexOf('$') > -1) {
	                output = formatCurrency(n, format, roundingFunction);
	            } else if (format.indexOf('%') > -1) {
	                output = formatPercentage(n, format, roundingFunction);
	            } else if (format.indexOf(':') > -1) {
	                output = formatTime(n, format);
	            } else if (format.indexOf('b') > -1 || format.indexOf('ib') > -1) {
	                output = formatBytes(n, format, roundingFunction);
	            } else if (format.indexOf('o') > -1) {
	                output = formatOrdinal(n, format, roundingFunction);
	            } else {
	                output = formatNumber(n._value, format, roundingFunction);
	            }
	        }
	
	        return output;
	    }
	
	    function formatCurrency(n, format, roundingFunction) {
	        var symbolIndex = format.indexOf('$'),
	            openParenIndex = format.indexOf('('),
	            minusSignIndex = format.indexOf('-'),
	            space = '',
	            spliceIndex,
	            output;
	
	        // check for space before or after currency
	        if (format.indexOf(' $') > -1) {
	            space = ' ';
	            format = format.replace(' $', '');
	        } else if (format.indexOf('$ ') > -1) {
	            space = ' ';
	            format = format.replace('$ ', '');
	        } else {
	            format = format.replace('$', '');
	        }
	
	        // format the number
	        output = formatNumber(n._value, format, roundingFunction, false);
	
	        // position the symbol
	        if (symbolIndex <= 1) {
	            if (output.indexOf('(') > -1 || output.indexOf('-') > -1) {
	                output = output.split('');
	                spliceIndex = 1;
	                if (symbolIndex < openParenIndex || symbolIndex < minusSignIndex) {
	                    // the symbol appears before the "(" or "-"
	                    spliceIndex = 0;
	                }
	                output.splice(spliceIndex, 0, languages[options.currentLanguage].currency.symbol + space);
	                output = output.join('');
	            } else {
	                output = languages[options.currentLanguage].currency.symbol + space + output;
	            }
	        } else {
	            if (output.indexOf(')') > -1) {
	                output = output.split('');
	                output.splice(-1, 0, space + languages[options.currentLanguage].currency.symbol);
	                output = output.join('');
	            } else {
	                output = output + space + languages[options.currentLanguage].currency.symbol;
	            }
	        }
	
	        return output;
	    }
	
	    function formatPercentage(n, format, roundingFunction) {
	        var space = '',
	            output,
	            value = n._value * 100;
	
	        // check for space before %
	        if (format.indexOf(' %') > -1) {
	            space = ' ';
	            format = format.replace(' %', '');
	        } else {
	            format = format.replace('%', '');
	        }
	
	        output = formatNumber(value, format, roundingFunction);
	
	        if (output.indexOf(')') > -1) {
	            output = output.split('');
	            output.splice(-1, 0, space + '%');
	            output = output.join('');
	        } else {
	            output = output + space + '%';
	        }
	
	        return output;
	    }
	
	    function formatBytes(n, format, roundingFunction) {
	        var output,
	            suffixes = format.indexOf('ib') > -1 ? byteSuffixes.iec : byteSuffixes.bytes,
	            value = n._value,
	            suffix = '',
	            power,
	            min,
	            max;
	
	        // check for space before
	        if (format.indexOf(' b') > -1 || format.indexOf(' ib') > -1) {
	            suffix = ' ';
	            format = format.replace(' ib', '').replace(' b', '');
	        } else {
	            format = format.replace('ib', '').replace('b', '');
	        }
	
	        for (power = 0; power <= suffixes.length; power++) {
	            min = Math.pow(1024, power);
	            max = Math.pow(1024, power + 1);
	
	            if (value === null || value === 0 || value >= min && value < max) {
	                suffix += suffixes[power];
	
	                if (min > 0) {
	                    value = value / min;
	                }
	
	                break;
	            }
	        }
	
	        output = formatNumber(value, format, roundingFunction);
	
	        return output + suffix;
	    }
	
	    function formatOrdinal(n, format, roundingFunction) {
	        var output,
	            ordinal = '';
	
	        // check for space before
	        if (format.indexOf(' o') > -1) {
	            ordinal = ' ';
	            format = format.replace(' o', '');
	        } else {
	            format = format.replace('o', '');
	        }
	
	        ordinal += languages[options.currentLanguage].ordinal(n._value);
	
	        output = formatNumber(n._value, format, roundingFunction);
	
	        return output + ordinal;
	    }
	
	    function formatTime(n) {
	        var hours = Math.floor(n._value / 60 / 60),
	            minutes = Math.floor((n._value - (hours * 60 * 60)) / 60),
	            seconds = Math.round(n._value - (hours * 60 * 60) - (minutes * 60));
	
	        return hours + ':' + ((minutes < 10) ? '0' + minutes : minutes) + ':' + ((seconds < 10) ? '0' + seconds : seconds);
	    }
	
	    function formatNumber(value, format, roundingFunction) {
	        var negP = false,
	            signed = false,
	            optDec = false,
	            abbr = '',
	            abbrK = false, // force abbreviation to thousands
	            abbrM = false, // force abbreviation to millions
	            abbrB = false, // force abbreviation to billions
	            abbrT = false, // force abbreviation to trillions
	            abbrForce = false, // force abbreviation
	            abs,
	            min,
	            max,
	            power,
	            w,
	            precision,
	            thousands,
	            d = '',
	            neg = false;
	
	        if (value === null) {
	            value = 0;
	        }
	
	        abs = Math.abs(value);
	
	        // see if we should use parentheses for negative number or if we should prefix with a sign
	        // if both are present we default to parentheses
	        if (format.indexOf('(') > -1) {
	            negP = true;
	            format = format.slice(1, -1);
	        } else if (format.indexOf('+') > -1) {
	            signed = true;
	            format = format.replace(/\+/g, '');
	        }
	
	        // see if abbreviation is wanted
	        if (format.indexOf('a') > -1) {
	            // check if abbreviation is specified
	            abbrK = format.indexOf('aK') >= 0;
	            abbrM = format.indexOf('aM') >= 0;
	            abbrB = format.indexOf('aB') >= 0;
	            abbrT = format.indexOf('aT') >= 0;
	            abbrForce = abbrK || abbrM || abbrB || abbrT;
	
	            // check for space before abbreviation
	            if (format.indexOf(' a') > -1) {
	                abbr = ' ';
	            }
	
	            format = format.replace(new RegExp(abbr + 'a[KMBT]?'), '');
	
	            if (abs >= Math.pow(10, 12) && !abbrForce || abbrT) {
	                // trillion
	                abbr = abbr + languages[options.currentLanguage].abbreviations.trillion;
	                value = value / Math.pow(10, 12);
	            } else if (abs < Math.pow(10, 12) && abs >= Math.pow(10, 9) && !abbrForce || abbrB) {
	                // billion
	                abbr = abbr + languages[options.currentLanguage].abbreviations.billion;
	                value = value / Math.pow(10, 9);
	            } else if (abs < Math.pow(10, 9) && abs >= Math.pow(10, 6) && !abbrForce || abbrM) {
	                // million
	                abbr = abbr + languages[options.currentLanguage].abbreviations.million;
	                value = value / Math.pow(10, 6);
	            } else if (abs < Math.pow(10, 6) && abs >= Math.pow(10, 3) && !abbrForce || abbrK) {
	                // thousand
	                abbr = abbr + languages[options.currentLanguage].abbreviations.thousand;
	                value = value / Math.pow(10, 3);
	            }
	        }
	
	
	        if (format.indexOf('[.]') > -1) {
	            optDec = true;
	            format = format.replace('[.]', '.');
	        }
	
	        w = value.toString().split('.')[0];
	        precision = format.split('.')[1];
	        thousands = format.indexOf(',');
	
	        if (precision) {
	            if (precision.indexOf('[') > -1) {
	                precision = precision.replace(']', '');
	                precision = precision.split('[');
	                d = toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
	            } else {
	                d = toFixed(value, precision.length, roundingFunction);
	            }
	
	            w = d.split('.')[0];
	
	            if (d.indexOf('.') > -1) {
	                d = languages[options.currentLanguage].delimiters.decimal + d.split('.')[1];
	            } else {
	                d = '';
	            }
	
	            if (optDec && Number(d.slice(1)) === 0) {
	                d = '';
	            }
	        } else {
	            w = toFixed(value, null, roundingFunction);
	        }
	
	        // format number
	        if (w.indexOf('-') > -1) {
	            w = w.slice(1);
	            neg = true;
	        }
	
	        if (thousands > -1) {
	            w = w.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + languages[options.currentLanguage].delimiters.thousands);
	        }
	
	        if (format.indexOf('.') === 0) {
	            w = '';
	        }
	
	        return ((negP && neg) ? '(' : '') + ((!negP && neg) ? '-' : '') + ((!neg && signed) ? '+' : '') + w + d + ((abbr) ? abbr : '') + ((negP && neg) ? ')' : '');
	    }
	
	
	    /************************************
	        Unformatting
	    ************************************/
	
	    // revert to number
	    function unformatNumeral(n, string) {
	        var stringOriginal = string,
	            thousandRegExp,
	            millionRegExp,
	            billionRegExp,
	            trillionRegExp,
	            bytesMultiplier = false,
	            power,
	            value;
	
	        if (string.indexOf(':') > -1) {
	            value = unformatTime(string);
	        } else {
	            if (string === options.zeroFormat || string === options.nullFormat) {
	                value = 0;
	            } else {
	                if (languages[options.currentLanguage].delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(languages[options.currentLanguage].delimiters.decimal, '.');
	                }
	
	                // see if abbreviations are there so that we can multiply to the correct number
	                thousandRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.thousand + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                millionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.million + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                billionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.billion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                trillionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.trillion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	
	                // see if bytes are there so that we can multiply to the correct number
	                for (power = 1; power <= byteSuffixes.bytes.length; power++) {
	                    bytesMultiplier = ((string.indexOf(byteSuffixes.bytes[power]) > -1) || (string.indexOf(byteSuffixes.iec[power]) > -1))? Math.pow(1024, power) : false;
	
	                    if (bytesMultiplier) {
	                        break;
	                    }
	                }
	
	                // do some math to create our number
	                value = bytesMultiplier ? bytesMultiplier : 1;
	                value *= stringOriginal.match(thousandRegExp) ? Math.pow(10, 3) : 1;
	                value *= stringOriginal.match(millionRegExp) ? Math.pow(10, 6) : 1;
	                value *= stringOriginal.match(billionRegExp) ? Math.pow(10, 9) : 1;
	                value *= stringOriginal.match(trillionRegExp) ? Math.pow(10, 12) : 1;
	                // check for percentage
	                value *= string.indexOf('%') > -1 ? 0.01 : 1;
	                // check for negative number
	                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
	                // remove non numbers
	                value *= Number(string.replace(/[^0-9\.]+/g, ''));
	                // round if we are talking about bytes
	                value = bytesMultiplier ? Math.ceil(value) : value;
	            }
	        }
	
	        n._value = value;
	
	        return n._value;
	    }
	    function unformatTime(string) {
	        var timeArray = string.split(':'),
	            seconds = 0;
	        // turn hours and minutes into seconds and add them all up
	        if (timeArray.length === 3) {
	            // hours
	            seconds = seconds + (Number(timeArray[0]) * 60 * 60);
	            // minutes
	            seconds = seconds + (Number(timeArray[1]) * 60);
	            // seconds
	            seconds = seconds + Number(timeArray[2]);
	        } else if (timeArray.length === 2) {
	            // minutes
	            seconds = seconds + (Number(timeArray[0]) * 60);
	            // seconds
	            seconds = seconds + Number(timeArray[1]);
	        }
	        return Number(seconds);
	    }
	
	
	    /************************************
	        Top Level Functions
	    ************************************/
	
	    numeral = function(input) {
	        if (numeral.isNumeral(input)) {
	            input = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            input = 0;
	        } else if (input === null) {
	            input = null;
	        } else if (!Number(input)) {
	            input = numeral.fn.unformat(input);
	        } else {
	            input = Number(input);
	        }
	
	        return new Numeral(input);
	    };
	
	    // version number
	    numeral.version = VERSION;
	
	    // compare numeral object
	    numeral.isNumeral = function(obj) {
	        return obj instanceof Numeral;
	    };
	
	
	    // This function will load languages and then set the global language.  If
	    // no arguments are passed in, it will simply return the current global
	    // language key.
	    numeral.language = function(key, values) {
	        if (!key) {
	            return options.currentLanguage;
	        }
	
	        key = key.toLowerCase();
	
	        if (key && !values) {
	            if (!languages[key]) {
	                throw new Error('Unknown language : ' + key);
	            }
	
	            options.currentLanguage = key;
	        }
	
	        if (values || !languages[key]) {
	            loadLanguage(key, values);
	        }
	
	        return numeral;
	    };
	
	    numeral.reset = function() {
	        for (var property in defaults) {
	            options[property] = defaults[property];
	        }
	    };
	
	    // This function provides access to the loaded language data.  If
	    // no arguments are passed in, it will simply return the current
	    // global language object.
	    numeral.languageData = function(key) {
	        if (!key) {
	            return languages[options.currentLanguage];
	        }
	
	        if (!languages[key]) {
	            throw new Error('Unknown language : ' + key);
	        }
	
	        return languages[key];
	    };
	
	    numeral.language('en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function(number) {
	            var b = number % 10;
	            return (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    numeral.zeroFormat = function(format) {
	        options.zeroFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.nullFormat = function (format) {
	        options.nullFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.defaultFormat = function(format) {
	        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
	    };
	
	    numeral.validate = function(val, culture) {
	        var _decimalSep,
	            _thousandSep,
	            _currSymbol,
	            _valArray,
	            _abbrObj,
	            _thousandRegEx,
	            languageData,
	            temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	            if (console.warn) {
	                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //if val is just digits return true
	        if ( !! val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numeral.languageData
	        try {
	            //check if the culture is understood by numeral. if not, default it to current language
	            languageData = numeral.languageData(culture);
	        } catch (e) {
	            languageData = numeral.languageData(numeral.language());
	        }
	
	        //setup the delimiters and currency symbol based on culture/language
	        _currSymbol = languageData.currency.symbol;
	        _abbrObj = languageData.abbreviations;
	        _decimalSep = languageData.delimiters.decimal;
	        if (languageData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = languageData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
	                } else {
	                    if (_valArray[0].length === 1) {
	                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    } else {
	                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	    /************************************
	        Helpers
	    ************************************/
	
	    function loadLanguage(key, values) {
	        languages[key] = values;
	    }
	
	    /************************************
	        Floating-point helpers
	    ************************************/
	
	    // The floating-point helper functions and implementation
	    // borrows heavily from sinful.js: http://guipn.github.io/sinful.js/
	
	    // Production steps of ECMA-262, Edition 5, 15.4.4.21
	    // Reference: http://es5.github.io/#x15.4.4.21
	    if (!Array.prototype.reduce) {
	        Array.prototype.reduce = function(callback /*, initialValue*/) {
	            'use strict';
	            if (this === null) {
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var t = Object(this), len = t.length >>> 0, k = 0, value;
	
	            if (arguments.length === 2) {
	                value = arguments[1];
	            } else {
	                while (k < len && !(k in t)) {
	                    k++;
	                }
	
	                if (k >= len) {
	                    throw new TypeError('Reduce of empty array with no initial value');
	                }
	
	                value = t[k++];
	            }
	            for (; k < len; k++) {
	                if (k in t) {
	                    value = callback(value, t[k], k, t);
	                }
	            }
	            return value;
	        };
	    }
	
	    /**
	     * Computes the multiplier necessary to make x >= 1,
	     * effectively eliminating miscalculations caused by
	     * finite precision.
	     */
	    function multiplier(x) {
	        var parts = x.toString().split('.');
	        if (parts.length < 2) {
	            return 1;
	        }
	        return Math.pow(10, parts[1].length);
	    }
	
	    /**
	     * Given a variable number of arguments, returns the maximum
	     * multiplier that must be used to normalize an operation involving
	     * all of them.
	     */
	    function correctionFactor() {
	        var args = Array.prototype.slice.call(arguments);
	        return args.reduce(function(prev, next) {
	            var mp = multiplier(prev),
	                mn = multiplier(next);
	            return mp > mn ? mp : mn;
	        }, -Infinity);
	    }
	
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	
	    numeral.fn = Numeral.prototype = {
	
	        clone: function() {
	            return numeral(this);
	        },
	
	        format: function (inputString, roundingFunction) {
	            return formatNumeral(this,
	                inputString ? inputString : options.defaultFormat,
	                roundingFunction !== undefined ? roundingFunction : Math.round
	            );
	        },
	
	        unformat: function (inputString) {
	            if (Object.prototype.toString.call(inputString) === '[object Number]') {
	                return inputString;
	            }
	
	            return unformatNumeral(this, inputString ? inputString : options.defaultFormat);
	        },
	
	        value: function() {
	            return this._value;
	        },
	
	        valueOf: function() {
	            return this._value;
	        },
	
	        set: function(value) {
	            this._value = Number(value);
	            return this;
	        },
	
	        add: function(value) {
	            var corrFactor = correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum + corrFactor * curr;
	            }
	            this._value = [this._value, value].reduce(cback, 0) / corrFactor;
	            return this;
	        },
	
	        subtract: function(value) {
	            var corrFactor = correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum - corrFactor * curr;
	            }
	            this._value = [value].reduce(cback, this._value * corrFactor) / corrFactor;
	            return this;
	        },
	
	        multiply: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = correctionFactor(accum, curr);
	                return (accum * corrFactor) * (curr * corrFactor) /
	                    (corrFactor * corrFactor);
	            }
	            this._value = [this._value, value].reduce(cback, 1);
	            return this;
	        },
	
	        divide: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = correctionFactor(accum, curr);
	                return (accum * corrFactor) / (curr * corrFactor);
	            }
	            this._value = [this._value, value].reduce(cback);
	            return this;
	        },
	
	        difference: function(value) {
	            return Math.abs(numeral(this._value).subtract(value).value());
	        }
	
	    };
	
	    /************************************
	        Exposing Numeral
	    ************************************/
	
	    // CommonJS module is defined
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = numeral;
	    }
	
	    /*global ender:false */
	    if (typeof ender === 'undefined') {
	        // here, `this` means `window` in the browser, or `global` on the server
	        // add `numeral` as a global object via a string identifier,
	        // for Closure Compiler 'advanced' mode
	        this['numeral'] = numeral;
	    }
	
	    /*global define:false */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return numeral;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}).call(this);


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(140)))

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(786);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(850);
	var assign = __webpack_require__(40);
	
	var ReactPropTypesSecret = __webpack_require__(786);
	var checkPropTypes = __webpack_require__(1637);
	
	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

	var mode = __webpack_require__(790);
	
	function QR8bitByte(data) {
		this.mode = mode.MODE_8BIT_BYTE;
		this.data = data;
	}
	
	QR8bitByte.prototype = {
	
		getLength : function(buffer) {
			return this.data.length;
		},
		
		write : function(buffer) {
			for (var i = 0; i < this.data.length; i++) {
				// not JIS ...
				buffer.put(this.data.charCodeAt(i), 8);
			}
		}
	};
	
	module.exports = QR8bitByte;
	


/***/ }),
/* 1641 */
/***/ (function(module, exports) {

	function QRBitBuffer() {
		this.buffer = new Array();
		this.length = 0;
	}
	
	QRBitBuffer.prototype = {
	
		get : function(index) {
			var bufIndex = Math.floor(index / 8);
			return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
		},
		
		put : function(num, length) {
			for (var i = 0; i < length; i++) {
				this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
			}
		},
		
		getLengthInBits : function() {
			return this.length;
		},
		
		putBit : function(bit) {
		
			var bufIndex = Math.floor(this.length / 8);
			if (this.buffer.length <= bufIndex) {
				this.buffer.push(0);
			}
		
			if (bit) {
				this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
			}
		
			this.length++;
		}
	};
	
	module.exports = QRBitBuffer;


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	var BitByte = __webpack_require__(1640);
	var RSBlock = __webpack_require__(1643);
	var BitBuffer = __webpack_require__(1641);
	var util = __webpack_require__(1644);
	var Polynomial = __webpack_require__(788);
	
	function QRCode(typeNumber, errorCorrectLevel) {
		this.typeNumber = typeNumber;
		this.errorCorrectLevel = errorCorrectLevel;
		this.modules = null;
		this.moduleCount = 0;
		this.dataCache = null;
		this.dataList = [];
	}
	
	// for client side minification
	var proto = QRCode.prototype;
	
	proto.addData = function(data) {
		var newData = new BitByte(data);
		this.dataList.push(newData);
		this.dataCache = null;
	};
	
	proto.isDark = function(row, col) {
		if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
			throw new Error(row + "," + col);
		}
		return this.modules[row][col];
	};
	
	proto.getModuleCount = function() {
		return this.moduleCount;
	};
	
	proto.make = function() {
		// Calculate automatically typeNumber if provided is < 1
		if (this.typeNumber < 1 ){
			var typeNumber = 1;
			for (typeNumber = 1; typeNumber < 40; typeNumber++) {
				var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);
	
				var buffer = new BitBuffer();
				var totalDataCount = 0;
				for (var i = 0; i < rsBlocks.length; i++) {
					totalDataCount += rsBlocks[i].dataCount;
				}
	
				for (var i = 0; i < this.dataList.length; i++) {
					var data = this.dataList[i];
					buffer.put(data.mode, 4);
					buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
					data.write(buffer);
				}
				if (buffer.getLengthInBits() <= totalDataCount * 8)
					break;
			}
			this.typeNumber = typeNumber;
		}
		this.makeImpl(false, this.getBestMaskPattern() );
	};
	
	proto.makeImpl = function(test, maskPattern) {
		
		this.moduleCount = this.typeNumber * 4 + 17;
		this.modules = new Array(this.moduleCount);
		
		for (var row = 0; row < this.moduleCount; row++) {
			
			this.modules[row] = new Array(this.moduleCount);
			
			for (var col = 0; col < this.moduleCount; col++) {
				this.modules[row][col] = null;//(col + row) % 3;
			}
		}
	
		this.setupPositionProbePattern(0, 0);
		this.setupPositionProbePattern(this.moduleCount - 7, 0);
		this.setupPositionProbePattern(0, this.moduleCount - 7);
		this.setupPositionAdjustPattern();
		this.setupTimingPattern();
		this.setupTypeInfo(test, maskPattern);
		
		if (this.typeNumber >= 7) {
			this.setupTypeNumber(test);
		}
	
		if (this.dataCache == null) {
			this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
		}
	
		this.mapData(this.dataCache, maskPattern);
	};
	
	proto.setupPositionProbePattern = function(row, col)  {
		
		for (var r = -1; r <= 7; r++) {
			
			if (row + r <= -1 || this.moduleCount <= row + r) continue;
			
			for (var c = -1; c <= 7; c++) {
				
				if (col + c <= -1 || this.moduleCount <= col + c) continue;
				
				if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
						|| (0 <= c && c <= 6 && (r == 0 || r == 6) )
						|| (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
					this.modules[row + r][col + c] = true;
				} else {
					this.modules[row + r][col + c] = false;
				}
			}		
		}		
	};
	
	proto.getBestMaskPattern = function() {
	
		var minLostPoint = 0;
		var pattern = 0;
	
		for (var i = 0; i < 8; i++) {
			
			this.makeImpl(true, i);
	
			var lostPoint = util.getLostPoint(this);
	
			if (i == 0 || minLostPoint >  lostPoint) {
				minLostPoint = lostPoint;
				pattern = i;
			}
		}
	
		return pattern;
	};
	
	proto.createMovieClip = function(target_mc, instance_name, depth) {
	
		var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
		var cs = 1;
	
		this.make();
	
		for (var row = 0; row < this.modules.length; row++) {
			
			var y = row * cs;
			
			for (var col = 0; col < this.modules[row].length; col++) {
	
				var x = col * cs;
				var dark = this.modules[row][col];
			
				if (dark) {
					qr_mc.beginFill(0, 100);
					qr_mc.moveTo(x, y);
					qr_mc.lineTo(x + cs, y);
					qr_mc.lineTo(x + cs, y + cs);
					qr_mc.lineTo(x, y + cs);
					qr_mc.endFill();
				}
			}
		}
		
		return qr_mc;
	};
	
	proto.setupTimingPattern = function() {
		
		for (var r = 8; r < this.moduleCount - 8; r++) {
			if (this.modules[r][6] != null) {
				continue;
			}
			this.modules[r][6] = (r % 2 == 0);
		}
	
		for (var c = 8; c < this.moduleCount - 8; c++) {
			if (this.modules[6][c] != null) {
				continue;
			}
			this.modules[6][c] = (c % 2 == 0);
		}
	};
	
	proto.setupPositionAdjustPattern = function() {
	
		var pos = util.getPatternPosition(this.typeNumber);
		
		for (var i = 0; i < pos.length; i++) {
		
			for (var j = 0; j < pos.length; j++) {
			
				var row = pos[i];
				var col = pos[j];
				
				if (this.modules[row][col] != null) {
					continue;
				}
				
				for (var r = -2; r <= 2; r++) {
				
					for (var c = -2; c <= 2; c++) {
					
						if (r == -2 || r == 2 || c == -2 || c == 2
								|| (r == 0 && c == 0) ) {
							this.modules[row + r][col + c] = true;
						} else {
							this.modules[row + r][col + c] = false;
						}
					}
				}
			}
		}
	};
	
	proto.setupTypeNumber = function(test) {
	
		var bits = util.getBCHTypeNumber(this.typeNumber);
	
		for (var i = 0; i < 18; i++) {
			var mod = (!test && ( (bits >> i) & 1) == 1);
			this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
		}
	
		for (var i = 0; i < 18; i++) {
			var mod = (!test && ( (bits >> i) & 1) == 1);
			this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
		}
	};
	
	proto.setupTypeInfo = function(test, maskPattern) {
	
		var data = (this.errorCorrectLevel << 3) | maskPattern;
		var bits = util.getBCHTypeInfo(data);
	
		// vertical		
		for (var i = 0; i < 15; i++) {
	
			var mod = (!test && ( (bits >> i) & 1) == 1);
	
			if (i < 6) {
				this.modules[i][8] = mod;
			} else if (i < 8) {
				this.modules[i + 1][8] = mod;
			} else {
				this.modules[this.moduleCount - 15 + i][8] = mod;
			}
		}
	
		// horizontal
		for (var i = 0; i < 15; i++) {
	
			var mod = (!test && ( (bits >> i) & 1) == 1);
			
			if (i < 8) {
				this.modules[8][this.moduleCount - i - 1] = mod;
			} else if (i < 9) {
				this.modules[8][15 - i - 1 + 1] = mod;
			} else {
				this.modules[8][15 - i - 1] = mod;
			}
		}
	
		// fixed module
		this.modules[this.moduleCount - 8][8] = (!test);
	};
	
	proto.mapData = function(data, maskPattern) {
		
		var inc = -1;
		var row = this.moduleCount - 1;
		var bitIndex = 7;
		var byteIndex = 0;
		
		for (var col = this.moduleCount - 1; col > 0; col -= 2) {
	
			if (col == 6) col--;
	
			while (true) {
	
				for (var c = 0; c < 2; c++) {
					
					if (this.modules[row][col - c] == null) {
						
						var dark = false;
	
						if (byteIndex < data.length) {
							dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
						}
	
						var mask = util.getMask(maskPattern, row, col - c);
	
						if (mask) {
							dark = !dark;
						}
						
						this.modules[row][col - c] = dark;
						bitIndex--;
	
						if (bitIndex == -1) {
							byteIndex++;
							bitIndex = 7;
						}
					}
				}
								
				row += inc;
	
				if (row < 0 || this.moduleCount <= row) {
					row -= inc;
					inc = -inc;
					break;
				}
			}
		}
	};
	
	QRCode.PAD0 = 0xEC;
	QRCode.PAD1 = 0x11;
	
	QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
		
		var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
		
		var buffer = new BitBuffer();
		
		for (var i = 0; i < dataList.length; i++) {
			var data = dataList[i];
			buffer.put(data.mode, 4);
			buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
			data.write(buffer);
		}
	
		// calc num max data.
		var totalDataCount = 0;
		for (var i = 0; i < rsBlocks.length; i++) {
			totalDataCount += rsBlocks[i].dataCount;
		}
	
		if (buffer.getLengthInBits() > totalDataCount * 8) {
			throw new Error("code length overflow. ("
				+ buffer.getLengthInBits()
				+ ">"
				+  totalDataCount * 8
				+ ")");
		}
	
		// end code
		if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
			buffer.put(0, 4);
		}
	
		// padding
		while (buffer.getLengthInBits() % 8 != 0) {
			buffer.putBit(false);
		}
	
		// padding
		while (true) {
			
			if (buffer.getLengthInBits() >= totalDataCount * 8) {
				break;
			}
			buffer.put(QRCode.PAD0, 8);
			
			if (buffer.getLengthInBits() >= totalDataCount * 8) {
				break;
			}
			buffer.put(QRCode.PAD1, 8);
		}
	
		return QRCode.createBytes(buffer, rsBlocks);
	};
	
	QRCode.createBytes = function(buffer, rsBlocks) {
	
		var offset = 0;
		
		var maxDcCount = 0;
		var maxEcCount = 0;
		
		var dcdata = new Array(rsBlocks.length);
		var ecdata = new Array(rsBlocks.length);
		
		for (var r = 0; r < rsBlocks.length; r++) {
	
			var dcCount = rsBlocks[r].dataCount;
			var ecCount = rsBlocks[r].totalCount - dcCount;
	
			maxDcCount = Math.max(maxDcCount, dcCount);
			maxEcCount = Math.max(maxEcCount, ecCount);
			
			dcdata[r] = new Array(dcCount);
			
			for (var i = 0; i < dcdata[r].length; i++) {
				dcdata[r][i] = 0xff & buffer.buffer[i + offset];
			}
			offset += dcCount;
			
			var rsPoly = util.getErrorCorrectPolynomial(ecCount);
			var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);
	
			var modPoly = rawPoly.mod(rsPoly);
			ecdata[r] = new Array(rsPoly.getLength() - 1);
			for (var i = 0; i < ecdata[r].length; i++) {
	            var modIndex = i + modPoly.getLength() - ecdata[r].length;
				ecdata[r][i] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
			}
	
		}
		
		var totalCodeCount = 0;
		for (var i = 0; i < rsBlocks.length; i++) {
			totalCodeCount += rsBlocks[i].totalCount;
		}
	
		var data = new Array(totalCodeCount);
		var index = 0;
	
		for (var i = 0; i < maxDcCount; i++) {
			for (var r = 0; r < rsBlocks.length; r++) {
				if (i < dcdata[r].length) {
					data[index++] = dcdata[r][i];
				}
			}
		}
	
		for (var i = 0; i < maxEcCount; i++) {
			for (var r = 0; r < rsBlocks.length; r++) {
				if (i < ecdata[r].length) {
					data[index++] = ecdata[r][i];
				}
			}
		}
	
		return data;
	};
	
	module.exports = QRCode;
	


/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	// ErrorCorrectLevel
	var ECL = __webpack_require__(787);
	
	function QRRSBlock(totalCount, dataCount) {
		this.totalCount = totalCount;
		this.dataCount  = dataCount;
	}
	
	QRRSBlock.RS_BLOCK_TABLE = [
	
		// L
		// M
		// Q
		// H
	
		// 1
		[1, 26, 19],
		[1, 26, 16],
		[1, 26, 13],
		[1, 26, 9],
		
		// 2
		[1, 44, 34],
		[1, 44, 28],
		[1, 44, 22],
		[1, 44, 16],
	
		// 3
		[1, 70, 55],
		[1, 70, 44],
		[2, 35, 17],
		[2, 35, 13],
	
		// 4		
		[1, 100, 80],
		[2, 50, 32],
		[2, 50, 24],
		[4, 25, 9],
		
		// 5
		[1, 134, 108],
		[2, 67, 43],
		[2, 33, 15, 2, 34, 16],
		[2, 33, 11, 2, 34, 12],
		
		// 6
		[2, 86, 68],
		[4, 43, 27],
		[4, 43, 19],
		[4, 43, 15],
		
		// 7		
		[2, 98, 78],
		[4, 49, 31],
		[2, 32, 14, 4, 33, 15],
		[4, 39, 13, 1, 40, 14],
		
		// 8
		[2, 121, 97],
		[2, 60, 38, 2, 61, 39],
		[4, 40, 18, 2, 41, 19],
		[4, 40, 14, 2, 41, 15],
		
		// 9
		[2, 146, 116],
		[3, 58, 36, 2, 59, 37],
		[4, 36, 16, 4, 37, 17],
		[4, 36, 12, 4, 37, 13],
		
		// 10		
		[2, 86, 68, 2, 87, 69],
		[4, 69, 43, 1, 70, 44],
		[6, 43, 19, 2, 44, 20],
		[6, 43, 15, 2, 44, 16],
	
		// 11
		[4, 101, 81],
		[1, 80, 50, 4, 81, 51],
		[4, 50, 22, 4, 51, 23],
		[3, 36, 12, 8, 37, 13],
	
		// 12
		[2, 116, 92, 2, 117, 93],
		[6, 58, 36, 2, 59, 37],
		[4, 46, 20, 6, 47, 21],
		[7, 42, 14, 4, 43, 15],
	
		// 13
		[4, 133, 107],
		[8, 59, 37, 1, 60, 38],
		[8, 44, 20, 4, 45, 21],
		[12, 33, 11, 4, 34, 12],
	
		// 14
		[3, 145, 115, 1, 146, 116],
		[4, 64, 40, 5, 65, 41],
		[11, 36, 16, 5, 37, 17],
		[11, 36, 12, 5, 37, 13],
	
		// 15
		[5, 109, 87, 1, 110, 88],
		[5, 65, 41, 5, 66, 42],
		[5, 54, 24, 7, 55, 25],
		[11, 36, 12],
	
		// 16
		[5, 122, 98, 1, 123, 99],
		[7, 73, 45, 3, 74, 46],
		[15, 43, 19, 2, 44, 20],
		[3, 45, 15, 13, 46, 16],
	
		// 17
		[1, 135, 107, 5, 136, 108],
		[10, 74, 46, 1, 75, 47],
		[1, 50, 22, 15, 51, 23],
		[2, 42, 14, 17, 43, 15],
	
		// 18
		[5, 150, 120, 1, 151, 121],
		[9, 69, 43, 4, 70, 44],
		[17, 50, 22, 1, 51, 23],
		[2, 42, 14, 19, 43, 15],
	
		// 19
		[3, 141, 113, 4, 142, 114],
		[3, 70, 44, 11, 71, 45],
		[17, 47, 21, 4, 48, 22],
		[9, 39, 13, 16, 40, 14],
	
		// 20
		[3, 135, 107, 5, 136, 108],
		[3, 67, 41, 13, 68, 42],
		[15, 54, 24, 5, 55, 25],
		[15, 43, 15, 10, 44, 16],
	
		// 21
		[4, 144, 116, 4, 145, 117],
		[17, 68, 42],
		[17, 50, 22, 6, 51, 23],
		[19, 46, 16, 6, 47, 17],
	
		// 22
		[2, 139, 111, 7, 140, 112],
		[17, 74, 46],
		[7, 54, 24, 16, 55, 25],
		[34, 37, 13],
	
		// 23
		[4, 151, 121, 5, 152, 122],
		[4, 75, 47, 14, 76, 48],
		[11, 54, 24, 14, 55, 25],
		[16, 45, 15, 14, 46, 16],
	
		// 24
		[6, 147, 117, 4, 148, 118],
		[6, 73, 45, 14, 74, 46],
		[11, 54, 24, 16, 55, 25],
		[30, 46, 16, 2, 47, 17],
	
		// 25
		[8, 132, 106, 4, 133, 107],
		[8, 75, 47, 13, 76, 48],
		[7, 54, 24, 22, 55, 25],
		[22, 45, 15, 13, 46, 16],
	
		// 26
		[10, 142, 114, 2, 143, 115],
		[19, 74, 46, 4, 75, 47],
		[28, 50, 22, 6, 51, 23],
		[33, 46, 16, 4, 47, 17],
	
		// 27
		[8, 152, 122, 4, 153, 123],
		[22, 73, 45, 3, 74, 46],
		[8, 53, 23, 26, 54, 24],
		[12, 45, 15, 28, 46, 16],
	
		// 28
		[3, 147, 117, 10, 148, 118],
		[3, 73, 45, 23, 74, 46],
		[4, 54, 24, 31, 55, 25],
		[11, 45, 15, 31, 46, 16],
	
		// 29
		[7, 146, 116, 7, 147, 117],
		[21, 73, 45, 7, 74, 46],
		[1, 53, 23, 37, 54, 24],
		[19, 45, 15, 26, 46, 16],
	
		// 30
		[5, 145, 115, 10, 146, 116],
		[19, 75, 47, 10, 76, 48],
		[15, 54, 24, 25, 55, 25],
		[23, 45, 15, 25, 46, 16],
	
		// 31
		[13, 145, 115, 3, 146, 116],
		[2, 74, 46, 29, 75, 47],
		[42, 54, 24, 1, 55, 25],
		[23, 45, 15, 28, 46, 16],
	
		// 32
		[17, 145, 115],
		[10, 74, 46, 23, 75, 47],
		[10, 54, 24, 35, 55, 25],
		[19, 45, 15, 35, 46, 16],
	
		// 33
		[17, 145, 115, 1, 146, 116],
		[14, 74, 46, 21, 75, 47],
		[29, 54, 24, 19, 55, 25],
		[11, 45, 15, 46, 46, 16],
	
		// 34
		[13, 145, 115, 6, 146, 116],
		[14, 74, 46, 23, 75, 47],
		[44, 54, 24, 7, 55, 25],
		[59, 46, 16, 1, 47, 17],
	
		// 35
		[12, 151, 121, 7, 152, 122],
		[12, 75, 47, 26, 76, 48],
		[39, 54, 24, 14, 55, 25],
		[22, 45, 15, 41, 46, 16],
	
		// 36
		[6, 151, 121, 14, 152, 122],
		[6, 75, 47, 34, 76, 48],
		[46, 54, 24, 10, 55, 25],
		[2, 45, 15, 64, 46, 16],
	
		// 37
		[17, 152, 122, 4, 153, 123],
		[29, 74, 46, 14, 75, 47],
		[49, 54, 24, 10, 55, 25],
		[24, 45, 15, 46, 46, 16],
	
		// 38
		[4, 152, 122, 18, 153, 123],
		[13, 74, 46, 32, 75, 47],
		[48, 54, 24, 14, 55, 25],
		[42, 45, 15, 32, 46, 16],
	
		// 39
		[20, 147, 117, 4, 148, 118],
		[40, 75, 47, 7, 76, 48],
		[43, 54, 24, 22, 55, 25],
		[10, 45, 15, 67, 46, 16],
	
		// 40
		[19, 148, 118, 6, 149, 119],
		[18, 75, 47, 31, 76, 48],
		[34, 54, 24, 34, 55, 25],
		[20, 45, 15, 61, 46, 16]
	];
	
	QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
		
		var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
		
		if (rsBlock == undefined) {
			throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
		}
	
		var length = rsBlock.length / 3;
		
		var list = new Array();
		
		for (var i = 0; i < length; i++) {
	
			var count = rsBlock[i * 3 + 0];
			var totalCount = rsBlock[i * 3 + 1];
			var dataCount  = rsBlock[i * 3 + 2];
	
			for (var j = 0; j < count; j++) {
				list.push(new QRRSBlock(totalCount, dataCount) );	
			}
		}
		
		return list;
	}
	
	QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {
	
		switch(errorCorrectLevel) {
		case ECL.L :
			return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
		case ECL.M :
			return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
		case ECL.Q :
			return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
		case ECL.H :
			return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
		default :
			return undefined;
		}
	}
	
	module.exports = QRRSBlock;


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

	var Mode = __webpack_require__(790);
	var Polynomial = __webpack_require__(788);
	var math = __webpack_require__(789);
	
	var QRMaskPattern = {
		PATTERN000 : 0,
		PATTERN001 : 1,
		PATTERN010 : 2,
		PATTERN011 : 3,
		PATTERN100 : 4,
		PATTERN101 : 5,
		PATTERN110 : 6,
		PATTERN111 : 7
	};
	
	var QRUtil = {
	
	    PATTERN_POSITION_TABLE : [
		    [],
		    [6, 18],
		    [6, 22],
		    [6, 26],
		    [6, 30],
		    [6, 34],
		    [6, 22, 38],
		    [6, 24, 42],
		    [6, 26, 46],
		    [6, 28, 50],
		    [6, 30, 54],		
		    [6, 32, 58],
		    [6, 34, 62],
		    [6, 26, 46, 66],
		    [6, 26, 48, 70],
		    [6, 26, 50, 74],
		    [6, 30, 54, 78],
		    [6, 30, 56, 82],
		    [6, 30, 58, 86],
		    [6, 34, 62, 90],
		    [6, 28, 50, 72, 94],
		    [6, 26, 50, 74, 98],
		    [6, 30, 54, 78, 102],
		    [6, 28, 54, 80, 106],
		    [6, 32, 58, 84, 110],
		    [6, 30, 58, 86, 114],
		    [6, 34, 62, 90, 118],
		    [6, 26, 50, 74, 98, 122],
		    [6, 30, 54, 78, 102, 126],
		    [6, 26, 52, 78, 104, 130],
		    [6, 30, 56, 82, 108, 134],
		    [6, 34, 60, 86, 112, 138],
		    [6, 30, 58, 86, 114, 142],
		    [6, 34, 62, 90, 118, 146],
		    [6, 30, 54, 78, 102, 126, 150],
		    [6, 24, 50, 76, 102, 128, 154],
		    [6, 28, 54, 80, 106, 132, 158],
		    [6, 32, 58, 84, 110, 136, 162],
		    [6, 26, 54, 82, 110, 138, 166],
		    [6, 30, 58, 86, 114, 142, 170]
	    ],
	
	    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
	    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
	    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)	| (1 << 4) | (1 << 1),
	
	    getBCHTypeInfo : function(data) {
		    var d = data << 10;
		    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
			    d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) ); 	
		    }
		    return ( (data << 10) | d) ^ QRUtil.G15_MASK;
	    },
	
	    getBCHTypeNumber : function(data) {
		    var d = data << 12;
		    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
			    d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) ); 	
		    }
		    return (data << 12) | d;
	    },
	
	    getBCHDigit : function(data) {
	
		    var digit = 0;
	
		    while (data != 0) {
			    digit++;
			    data >>>= 1;
		    }
	
		    return digit;
	    },
	
	    getPatternPosition : function(typeNumber) {
		    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
	    },
	
	    getMask : function(maskPattern, i, j) {
		    
		    switch (maskPattern) {
			    
		    case QRMaskPattern.PATTERN000 : return (i + j) % 2 == 0;
		    case QRMaskPattern.PATTERN001 : return i % 2 == 0;
		    case QRMaskPattern.PATTERN010 : return j % 3 == 0;
		    case QRMaskPattern.PATTERN011 : return (i + j) % 3 == 0;
		    case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0;
		    case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 == 0;
		    case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 == 0;
		    case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 == 0;
	
		    default :
			    throw new Error("bad maskPattern:" + maskPattern);
		    }
	    },
	
	    getErrorCorrectPolynomial : function(errorCorrectLength) {
	
		    var a = new Polynomial([1], 0);
	
		    for (var i = 0; i < errorCorrectLength; i++) {
			    a = a.multiply(new Polynomial([1, math.gexp(i)], 0) );
		    }
	
		    return a;
	    },
	
	    getLengthInBits : function(mode, type) {
	
		    if (1 <= type && type < 10) {
	
			    // 1 - 9
	
			    switch(mode) {
			    case Mode.MODE_NUMBER 	: return 10;
			    case Mode.MODE_ALPHA_NUM 	: return 9;
			    case Mode.MODE_8BIT_BYTE	: return 8;
			    case Mode.MODE_KANJI  	: return 8;
			    default :
				    throw new Error("mode:" + mode);
			    }
	
		    } else if (type < 27) {
	
			    // 10 - 26
	
			    switch(mode) {
			    case Mode.MODE_NUMBER 	: return 12;
			    case Mode.MODE_ALPHA_NUM 	: return 11;
			    case Mode.MODE_8BIT_BYTE	: return 16;
			    case Mode.MODE_KANJI  	: return 10;
			    default :
				    throw new Error("mode:" + mode);
			    }
	
		    } else if (type < 41) {
	
			    // 27 - 40
	
			    switch(mode) {
			    case Mode.MODE_NUMBER 	: return 14;
			    case Mode.MODE_ALPHA_NUM	: return 13;
			    case Mode.MODE_8BIT_BYTE	: return 16;
			    case Mode.MODE_KANJI  	: return 12;
			    default :
				    throw new Error("mode:" + mode);
			    }
	
		    } else {
			    throw new Error("type:" + type);
		    }
	    },
	
	    getLostPoint : function(qrCode) {
		    
		    var moduleCount = qrCode.getModuleCount();
		    
		    var lostPoint = 0;
		    
		    // LEVEL1
		    
		    for (var row = 0; row < moduleCount; row++) {
	
			    for (var col = 0; col < moduleCount; col++) {
	
				    var sameCount = 0;
				    var dark = qrCode.isDark(row, col);
	
					for (var r = -1; r <= 1; r++) {
	
					    if (row + r < 0 || moduleCount <= row + r) {
						    continue;
					    }
	
					    for (var c = -1; c <= 1; c++) {
	
						    if (col + c < 0 || moduleCount <= col + c) {
							    continue;
						    }
	
						    if (r == 0 && c == 0) {
							    continue;
						    }
	
						    if (dark == qrCode.isDark(row + r, col + c) ) {
							    sameCount++;
						    }
					    }
				    }
	
				    if (sameCount > 5) {
					    lostPoint += (3 + sameCount - 5);
				    }
			    }
		    }
	
		    // LEVEL2
	
		    for (var row = 0; row < moduleCount - 1; row++) {
			    for (var col = 0; col < moduleCount - 1; col++) {
				    var count = 0;
				    if (qrCode.isDark(row,     col    ) ) count++;
				    if (qrCode.isDark(row + 1, col    ) ) count++;
				    if (qrCode.isDark(row,     col + 1) ) count++;
				    if (qrCode.isDark(row + 1, col + 1) ) count++;
				    if (count == 0 || count == 4) {
					    lostPoint += 3;
				    }
			    }
		    }
	
		    // LEVEL3
	
		    for (var row = 0; row < moduleCount; row++) {
			    for (var col = 0; col < moduleCount - 6; col++) {
				    if (qrCode.isDark(row, col)
						    && !qrCode.isDark(row, col + 1)
						    &&  qrCode.isDark(row, col + 2)
						    &&  qrCode.isDark(row, col + 3)
						    &&  qrCode.isDark(row, col + 4)
						    && !qrCode.isDark(row, col + 5)
						    &&  qrCode.isDark(row, col + 6) ) {
					    lostPoint += 40;
				    }
			    }
		    }
	
		    for (var col = 0; col < moduleCount; col++) {
			    for (var row = 0; row < moduleCount - 6; row++) {
				    if (qrCode.isDark(row, col)
						    && !qrCode.isDark(row + 1, col)
						    &&  qrCode.isDark(row + 2, col)
						    &&  qrCode.isDark(row + 3, col)
						    &&  qrCode.isDark(row + 4, col)
						    && !qrCode.isDark(row + 5, col)
						    &&  qrCode.isDark(row + 6, col) ) {
					    lostPoint += 40;
				    }
			    }
		    }
	
		    // LEVEL4
		    
		    var darkCount = 0;
	
		    for (var col = 0; col < moduleCount; col++) {
			    for (var row = 0; row < moduleCount; row++) {
				    if (qrCode.isDark(row, col) ) {
					    darkCount++;
				    }
			    }
		    }
		    
		    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
		    lostPoint += ratio * 10;
	
		    return lostPoint;		
	    }
	};
	
	module.exports = QRUtil;


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1646);


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

	// Load modules
	
	var Stringify = __webpack_require__(1648);
	var Parse = __webpack_require__(1647);
	
	
	// Declare internals
	
	var internals = {};
	
	
	module.exports = {
	    stringify: Stringify,
	    parse: Parse
	};


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(791);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    depth: 5,
	    arrayLimit: 20,
	    parameterLimit: 1000
	};
	
	
	internals.parseValues = function (str, options) {
	
	    var obj = {};
	    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);
	
	    for (var i = 0, il = parts.length; i < il; ++i) {
	        var part = parts[i];
	        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;
	
	        if (pos === -1) {
	            obj[Utils.decode(part)] = '';
	        }
	        else {
	            var key = Utils.decode(part.slice(0, pos));
	            var val = Utils.decode(part.slice(pos + 1));
	
	            if (Object.prototype.hasOwnProperty(key)) {
	                continue;
	            }
	
	            if (!obj.hasOwnProperty(key)) {
	                obj[key] = val;
	            }
	            else {
	                obj[key] = [].concat(obj[key]).concat(val);
	            }
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseObject = function (chain, val, options) {
	
	    if (!chain.length) {
	        return val;
	    }
	
	    var root = chain.shift();
	
	    var obj = {};
	    if (root === '[]') {
	        obj = [];
	        obj = obj.concat(internals.parseObject(chain, val, options));
	    }
	    else {
	        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
	        var index = parseInt(cleanRoot, 10);
	        var indexString = '' + index;
	        if (!isNaN(index) &&
	            root !== cleanRoot &&
	            indexString === cleanRoot &&
	            index >= 0 &&
	            index <= options.arrayLimit) {
	
	            obj = [];
	            obj[index] = internals.parseObject(chain, val, options);
	        }
	        else {
	            obj[cleanRoot] = internals.parseObject(chain, val, options);
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseKeys = function (key, val, options) {
	
	    if (!key) {
	        return;
	    }
	
	    // The regex chunks
	
	    var parent = /^([^\[\]]*)/;
	    var child = /(\[[^\[\]]*\])/g;
	
	    // Get the parent
	
	    var segment = parent.exec(key);
	
	    // Don't allow them to overwrite object prototype properties
	
	    if (Object.prototype.hasOwnProperty(segment[1])) {
	        return;
	    }
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (segment[1]) {
	        keys.push(segment[1]);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	
	        ++i;
	        if (!Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {
	            keys.push(segment[1]);
	        }
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return internals.parseObject(keys, val, options);
	};
	
	
	module.exports = function (str, options) {
	
	    if (str === '' ||
	        str === null ||
	        typeof str === 'undefined') {
	
	        return {};
	    }
	
	    options = options || {};
	    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
	
	    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
	    var obj = {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        var newObj = internals.parseKeys(key, tempObj[key], options);
	        obj = Utils.merge(obj, newObj);
	    }
	
	    return Utils.compact(obj);
	};


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(791);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    arrayPrefixGenerators: {
	        brackets: function (prefix, key) {
	            return prefix + '[]';
	        },
	        indices: function (prefix, key) {
	            return prefix + '[' + key + ']';
	        },
	        repeat: function (prefix, key) {
	            return prefix;
	        }
	    }
	};
	
	
	internals.stringify = function (obj, prefix, generateArrayPrefix) {
	
	    if (Utils.isBuffer(obj)) {
	        obj = obj.toString();
	    }
	    else if (obj instanceof Date) {
	        obj = obj.toISOString();
	    }
	    else if (obj === null) {
	        obj = '';
	    }
	
	    if (typeof obj === 'string' ||
	        typeof obj === 'number' ||
	        typeof obj === 'boolean') {
	
	        return [encodeURIComponent(prefix) + '=' + encodeURIComponent(obj)];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys = Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	        if (Array.isArray(obj)) {
	            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix));
	        }
	        else {
	            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix));
	        }
	    }
	
	    return values;
	};
	
	
	module.exports = function (obj, options) {
	
	    options = options || {};
	    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
	
	    var keys = [];
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in internals.arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    }
	    else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    }
	    else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];
	
	    var objKeys = Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix));
	    }
	
	    return keys.join(delimiter);
	};


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelGroup = __webpack_require__(808);
	
	var _PanelGroup2 = _interopRequireDefault(_PanelGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Accordion = function (_React$Component) {
	  (0, _inherits3.default)(Accordion, _React$Component);
	
	  function Accordion() {
	    (0, _classCallCheck3.default)(this, Accordion);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Accordion.prototype.render = function render() {
	    return _react2.default.createElement(
	      _PanelGroup2.default,
	      (0, _extends3.default)({}, this.props, { accordion: true }),
	      this.props.children
	    );
	  };
	
	  return Accordion;
	}(_react2.default.Component);
	
	exports.default = Accordion;
	module.exports = exports['default'];

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(223);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _StyleConfig = __webpack_require__(98);
	
	var _CloseButton = __webpack_require__(502);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  onDismiss: _propTypes2.default.func,
	  closeLabel: _propTypes2.default.string
	};
	
	var defaultProps = {
	  closeLabel: 'Close alert'
	};
	
	var Alert = function (_React$Component) {
	  (0, _inherits3.default)(Alert, _React$Component);
	
	  function Alert() {
	    (0, _classCallCheck3.default)(this, Alert);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Alert.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        onDismiss = _props.onDismiss,
	        closeLabel = _props.closeLabel,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['onDismiss', 'closeLabel', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var dismissable = !!onDismiss;
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dismissable')] = dismissable, _extends2));
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        role: 'alert',
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      dismissable && _react2.default.createElement(_CloseButton2.default, {
	        onClick: onDismiss,
	        label: closeLabel
	      }),
	      children
	    );
	  };
	
	  return Alert;
	}(_react2.default.Component);
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsStyles)((0, _values2.default)(_StyleConfig.State), _StyleConfig.State.INFO, (0, _bootstrapUtils.bsClass)('alert', Alert));
	module.exports = exports['default'];

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: `pullRight` doesn't belong here. There's no special handling here.
	
	var propTypes = {
	  pullRight: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  pullRight: false
	};
	
	var Badge = function (_React$Component) {
	  (0, _inherits3.default)(Badge, _React$Component);
	
	  function Badge() {
	    (0, _classCallCheck3.default)(this, Badge);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Badge.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2.default.Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Badge.prototype.render = function render() {
	    var _props = this.props,
	        pullRight = _props.pullRight,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['pullRight', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'pull-right': pullRight,
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2.default.createElement(
	      'span',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Badge;
	}(_react2.default.Component);
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('badge', Badge);
	module.exports = exports['default'];

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BreadcrumbItem = __webpack_require__(793);
	
	var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Breadcrumb = function (_React$Component) {
	  (0, _inherits3.default)(Breadcrumb, _React$Component);
	
	  function Breadcrumb() {
	    (0, _classCallCheck3.default)(this, Breadcrumb);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Breadcrumb.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('ol', (0, _extends3.default)({}, elementProps, {
	      role: 'navigation',
	      'aria-label': 'breadcrumbs',
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Breadcrumb;
	}(_react2.default.Component);
	
	Breadcrumb.Item = _BreadcrumbItem2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('breadcrumb', Breadcrumb);
	module.exports = exports['default'];

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonToolbar = function (_React$Component) {
	  (0, _inherits3.default)(ButtonToolbar, _React$Component);
	
	  function ButtonToolbar() {
	    (0, _classCallCheck3.default)(this, ButtonToolbar);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonToolbar.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      role: 'toolbar',
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ButtonToolbar;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('btn-toolbar', ButtonToolbar);
	module.exports = exports['default'];

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CarouselCaption = __webpack_require__(1655);
	
	var _CarouselCaption2 = _interopRequireDefault(_CarouselCaption);
	
	var _CarouselItem = __webpack_require__(794);
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	var _Glyphicon = __webpack_require__(504);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _SafeAnchor = __webpack_require__(154);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _ValidComponentChildren = __webpack_require__(108);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: `slide` should be `animate`.
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  slide: _propTypes2.default.bool,
	  indicators: _propTypes2.default.bool,
	  /**
	   * The amount of time to delay between automatically cycling an item.
	   * If `null`, carousel will not automatically cycle.
	   */
	  interval: _propTypes2.default.number,
	  controls: _propTypes2.default.bool,
	  pauseOnHover: _propTypes2.default.bool,
	  wrap: _propTypes2.default.bool,
	  /**
	   * Callback fired when the active item changes.
	   *
	   * ```js
	   * (eventKey: any) => any | (eventKey: any, event: Object) => any
	   * ```
	   *
	   * If this callback takes two or more arguments, the second argument will
	   * be a persisted event object with `direction` set to the direction of the
	   * transition.
	   */
	  onSelect: _propTypes2.default.func,
	  onSlideEnd: _propTypes2.default.func,
	  activeIndex: _propTypes2.default.number,
	  defaultActiveIndex: _propTypes2.default.number,
	  direction: _propTypes2.default.oneOf(['prev', 'next']),
	  prevIcon: _propTypes2.default.node,
	  /**
	   * Label shown to screen readers only, can be used to show the previous element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  prevLabel: _propTypes2.default.string,
	  nextIcon: _propTypes2.default.node,
	  /**
	   * Label shown to screen readers only, can be used to show the next element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  nextLabel: _propTypes2.default.string
	};
	
	var defaultProps = {
	  slide: true,
	  interval: 5000,
	  pauseOnHover: true,
	  wrap: true,
	  indicators: true,
	  controls: true,
	  prevIcon: _react2.default.createElement(_Glyphicon2.default, { glyph: 'chevron-left' }),
	  prevLabel: 'Previous',
	  nextIcon: _react2.default.createElement(_Glyphicon2.default, { glyph: 'chevron-right' }),
	  nextLabel: 'Next'
	};
	
	var Carousel = function (_React$Component) {
	  (0, _inherits3.default)(Carousel, _React$Component);
	
	  function Carousel(props, context) {
	    (0, _classCallCheck3.default)(this, Carousel);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handlePrev = _this.handlePrev.bind(_this);
	    _this.handleNext = _this.handleNext.bind(_this);
	    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);
	
	    var defaultActiveIndex = props.defaultActiveIndex;
	
	
	    _this.state = {
	      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
	      previousActiveIndex: null,
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  Carousel.prototype.componentDidMount = function componentDidMount() {
	    this.waitForNext();
	  };
	
	  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	
	    if (nextProps.activeIndex == null && this.state.activeIndex >= nextProps.children.length) {
	      this.setState({
	        activeIndex: 0,
	        previousActiveIndex: null,
	        direction: null
	      });
	    }
	  };
	
	  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	    this.isUnmounted = true;
	  };
	
	  Carousel.prototype.getActiveIndex = function getActiveIndex() {
	    var activeIndexProp = this.props.activeIndex;
	    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
	  };
	
	  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  };
	
	  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
	    var _this2 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this2.waitForNext();
	
	      if (_this2.props.onSlideEnd) {
	        _this2.props.onSlideEnd();
	      }
	    });
	  };
	
	  Carousel.prototype.handleMouseOut = function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  };
	
	  Carousel.prototype.handleMouseOver = function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  };
	
	  Carousel.prototype.handleNext = function handleNext(e) {
	    var index = this.getActiveIndex() + 1;
	    var count = _ValidComponentChildren2.default.count(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = 0;
	    }
	
	    this.select(index, e, 'next');
	  };
	
	  Carousel.prototype.handlePrev = function handlePrev(e) {
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = _ValidComponentChildren2.default.count(this.props.children) - 1;
	    }
	
	    this.select(index, e, 'prev');
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.pause = function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.play = function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  };
	
	  Carousel.prototype.select = function select(index, e, direction) {
	    clearTimeout(this.timeout);
	
	    // TODO: Is this necessary? Seems like the only risk is if the component
	    // unmounts while handleItemAnimateOutEnd fires.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
	    direction = direction || this.getDirection(previousActiveIndex, index);
	
	    var onSelect = this.props.onSelect;
	
	
	    if (onSelect) {
	      if (onSelect.length > 1) {
	        // React SyntheticEvents are pooled, so we need to remove this event
	        // from the pool to add a custom property. To avoid unnecessarily
	        // removing objects from the pool, only do this when the listener
	        // actually wants the event.
	        if (e) {
	          e.persist();
	          e.direction = direction;
	        } else {
	          e = { direction: direction };
	        }
	
	        onSelect(index, e);
	      } else {
	        onSelect(index);
	      }
	    }
	
	    if (this.props.activeIndex == null && index !== previousActiveIndex) {
	      if (this.state.previousActiveIndex != null) {
	        // If currently animating don't activate the new index.
	        // TODO: look into queueing this canceled call and
	        // animating after the current animation has ended.
	        return;
	      }
	
	      this.setState({
	        activeIndex: index,
	        previousActiveIndex: previousActiveIndex,
	        direction: direction
	      });
	    }
	  };
	
	  Carousel.prototype.waitForNext = function waitForNext() {
	    var _props = this.props,
	        slide = _props.slide,
	        interval = _props.interval,
	        activeIndexProp = _props.activeIndex;
	
	
	    if (!this.isPaused && slide && interval && activeIndexProp == null) {
	      this.timeout = setTimeout(this.handleNext, interval);
	    }
	  };
	
	  Carousel.prototype.renderControls = function renderControls(properties) {
	    var wrap = properties.wrap,
	        children = properties.children,
	        activeIndex = properties.activeIndex,
	        prevIcon = properties.prevIcon,
	        nextIcon = properties.nextIcon,
	        bsProps = properties.bsProps,
	        prevLabel = properties.prevLabel,
	        nextLabel = properties.nextLabel;
	
	    var controlClassName = (0, _bootstrapUtils.prefix)(bsProps, 'control');
	    var count = _ValidComponentChildren2.default.count(children);
	
	    return [(wrap || activeIndex !== 0) && _react2.default.createElement(
	      _SafeAnchor2.default,
	      {
	        key: 'prev',
	        className: (0, _classnames2.default)(controlClassName, 'left'),
	        onClick: this.handlePrev
	      },
	      prevIcon,
	      prevLabel && _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        prevLabel
	      )
	    ), (wrap || activeIndex !== count - 1) && _react2.default.createElement(
	      _SafeAnchor2.default,
	      {
	        key: 'next',
	        className: (0, _classnames2.default)(controlClassName, 'right'),
	        onClick: this.handleNext
	      },
	      nextIcon,
	      nextLabel && _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        nextLabel
	      )
	    )];
	  };
	
	  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
	    var _this3 = this;
	
	    var indicators = [];
	
	    _ValidComponentChildren2.default.forEach(children, function (child, index) {
	      indicators.push(_react2.default.createElement('li', {
	        key: index,
	        className: index === activeIndex ? 'active' : null,
	        onClick: function onClick(e) {
	          return _this3.select(index, e);
	        }
	      }),
	
	      // Force whitespace between indicator elements. Bootstrap requires
	      // this for correct spacing of elements.
	      ' ');
	    });
	
	    return _react2.default.createElement(
	      'ol',
	      { className: (0, _bootstrapUtils.prefix)(bsProps, 'indicators') },
	      indicators
	    );
	  };
	
	  Carousel.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props2 = this.props,
	        slide = _props2.slide,
	        indicators = _props2.indicators,
	        controls = _props2.controls,
	        wrap = _props2.wrap,
	        prevIcon = _props2.prevIcon,
	        prevLabel = _props2.prevLabel,
	        nextIcon = _props2.nextIcon,
	        nextLabel = _props2.nextLabel,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);
	    var _state = this.state,
	        previousActiveIndex = _state.previousActiveIndex,
	        direction = _state.direction;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
	    'defaultActiveIndex', 'direction']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeIndex = this.getActiveIndex();
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      slide: slide
	    });
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes),
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut
	      }),
	      indicators && this.renderIndicators(children, activeIndex, bsProps),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        _ValidComponentChildren2.default.map(children, function (child, index) {
	          var active = index === activeIndex;
	          var previousActive = slide && index === previousActiveIndex;
	
	          return (0, _react.cloneElement)(child, {
	            active: active,
	            index: index,
	            animateOut: previousActive,
	            animateIn: active && previousActiveIndex != null && slide,
	            direction: direction,
	            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
	          });
	        })
	      ),
	      controls && this.renderControls({
	        wrap: wrap,
	        children: children,
	        activeIndex: activeIndex,
	        prevIcon: prevIcon,
	        prevLabel: prevLabel,
	        nextIcon: nextIcon,
	        nextLabel: nextLabel,
	        bsProps: bsProps
	      })
	    );
	  };
	
	  return Carousel;
	}(_react2.default.Component);
	
	Carousel.propTypes = propTypes;
	Carousel.defaultProps = defaultProps;
	
	Carousel.Caption = _CarouselCaption2.default;
	Carousel.Item = _CarouselItem2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('carousel', Carousel);
	module.exports = exports['default'];

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var CarouselCaption = function (_React$Component) {
	  (0, _inherits3.default)(CarouselCaption, _React$Component);
	
	  function CarouselCaption() {
	    (0, _classCallCheck3.default)(this, CarouselCaption);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  CarouselCaption.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return CarouselCaption;
	}(_react2.default.Component);
	
	CarouselCaption.propTypes = propTypes;
	CarouselCaption.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('carousel-caption', CarouselCaption);
	module.exports = exports['default'];

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  inline: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2.default.oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Checkbox inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2.default.func
	}; /* eslint-disable jsx-a11y/label-has-for */
	
	var defaultProps = {
	  inline: false,
	  disabled: false,
	  title: ''
	};
	
	var Checkbox = function (_React$Component) {
	  (0, _inherits3.default)(Checkbox, _React$Component);
	
	  function Checkbox() {
	    (0, _classCallCheck3.default)(this, Checkbox);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Checkbox.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2.default.createElement('input', (0, _extends3.default)({}, elementProps, {
	      ref: inputRef,
	      type: 'checkbox',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2.default)(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2.default.createElement(
	        'label',
	        { className: (0, _classnames2.default)(className, _classes), style: style, title: title },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(className, classes), style: style },
	      _react2.default.createElement(
	        'label',
	        { title: title },
	        input,
	        children
	      )
	    );
	  };
	
	  return Checkbox;
	}(_react2.default.Component);
	
	Checkbox.propTypes = propTypes;
	Checkbox.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('checkbox', Checkbox);
	module.exports = exports['default'];

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _capitalize = __webpack_require__(811);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _StyleConfig = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default,
	
	  /**
	   * Apply clearfix
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `visible-xs-block`
	   */
	  visibleXsBlock: _propTypes2.default.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Small devices Tablets
	   *
	   * adds class `visible-sm-block`
	   */
	  visibleSmBlock: _propTypes2.default.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `visible-md-block`
	   */
	  visibleMdBlock: _propTypes2.default.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Large devices Desktops
	   *
	   * adds class `visible-lg-block`
	   */
	  visibleLgBlock: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Clearfix = function (_React$Component) {
	  (0, _inherits3.default)(Clearfix, _React$Component);
	
	  function Clearfix() {
	    (0, _classCallCheck3.default)(this, Clearfix);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Clearfix.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      var propName = 'visible' + (0, _capitalize2.default)(size) + 'Block';
	      if (elementProps[propName]) {
	        classes['visible-' + size + '-block'] = true;
	      }
	
	      delete elementProps[propName];
	    });
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Clearfix;
	}(_react2.default.Component);
	
	Clearfix.propTypes = propTypes;
	Clearfix.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('clearfix', Clearfix);
	module.exports = exports['default'];

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _StyleConfig = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default,
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Extra small devices Phones (<768px)
	   *
	   * class-prefix `col-xs-`
	   */
	  xs: _propTypes2.default.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Small devices Tablets (≥768px)
	   *
	   * class-prefix `col-sm-`
	   */
	  sm: _propTypes2.default.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Medium devices Desktops (≥992px)
	   *
	   * class-prefix `col-md-`
	   */
	  md: _propTypes2.default.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Large devices Desktops (≥1200px)
	   *
	   * class-prefix `col-lg-`
	   */
	  lg: _propTypes2.default.number,
	  /**
	   * Hide column
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `hidden-xs`
	   */
	  xsHidden: _propTypes2.default.bool,
	  /**
	   * Hide column
	   *
	   * on Small devices Tablets
	   *
	   * adds class `hidden-sm`
	   */
	  smHidden: _propTypes2.default.bool,
	  /**
	   * Hide column
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `hidden-md`
	   */
	  mdHidden: _propTypes2.default.bool,
	  /**
	   * Hide column
	   *
	   * on Large devices Desktops
	   *
	   * adds class `hidden-lg`
	   */
	  lgHidden: _propTypes2.default.bool,
	  /**
	   * Move columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-offset-`
	   */
	  xsOffset: _propTypes2.default.number,
	  /**
	   * Move columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-offset-`
	   */
	  smOffset: _propTypes2.default.number,
	  /**
	   * Move columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-offset-`
	   */
	  mdOffset: _propTypes2.default.number,
	  /**
	   * Move columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-offset-`
	   */
	  lgOffset: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-push-`
	   */
	  xsPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-push-`
	   */
	  smPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-push-`
	   */
	  mdPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-push-`
	   */
	  lgPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-pull-`
	   */
	  xsPull: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-pull-`
	   */
	  smPull: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-pull-`
	   */
	  mdPull: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-pull-`
	   */
	  lgPull: _propTypes2.default.number
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Col = function (_React$Component) {
	  (0, _inherits3.default)(Col, _React$Component);
	
	  function Col() {
	    (0, _classCallCheck3.default)(this, Col);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Col.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      function popProp(propSuffix, modifier) {
	        var propName = '' + size + propSuffix;
	        var propValue = elementProps[propName];
	
	        if (propValue != null) {
	          classes.push((0, _bootstrapUtils.prefix)(bsProps, '' + size + modifier + '-' + propValue));
	        }
	
	        delete elementProps[propName];
	      }
	
	      popProp('', '');
	      popProp('Offset', '-offset');
	      popProp('Push', '-push');
	      popProp('Pull', '-pull');
	
	      var hiddenPropName = size + 'Hidden';
	      if (elementProps[hiddenPropName]) {
	        classes.push('hidden-' + size);
	      }
	      delete elementProps[hiddenPropName];
	    });
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Col;
	}(_react2.default.Component);
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('col', Col);
	module.exports = exports['default'];

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  htmlFor: _propTypes2.default.string,
	  srOnly: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  srOnly: false
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2.default.object
	};
	
	var ControlLabel = function (_React$Component) {
	  (0, _inherits3.default)(ControlLabel, _React$Component);
	
	  function ControlLabel() {
	    (0, _classCallCheck3.default)(this, ControlLabel);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ControlLabel.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        _props$htmlFor = _props.htmlFor,
	        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
	        srOnly = _props.srOnly,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['htmlFor', 'srOnly', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2.default)(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'sr-only': srOnly
	    });
	
	    return _react2.default.createElement('label', (0, _extends3.default)({}, elementProps, {
	      htmlFor: htmlFor,
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ControlLabel;
	}(_react2.default.Component);
	
	ControlLabel.propTypes = propTypes;
	ControlLabel.defaultProps = defaultProps;
	ControlLabel.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('control-label', ControlLabel);
	module.exports = exports['default'];

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(364);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(367);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Dropdown2.default.propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2.default.string,
	  bsSize: _propTypes2.default.string,
	  title: _propTypes2.default.node.isRequired,
	  noCaret: _propTypes2.default.bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2.default.node
	});
	
	var DropdownButton = function (_React$Component) {
	  (0, _inherits3.default)(DropdownButton, _React$Component);
	
	  function DropdownButton() {
	    (0, _classCallCheck3.default)(this, DropdownButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['bsSize', 'bsStyle', 'title', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3.default)(props, _Dropdown2.default.ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    return _react2.default.createElement(
	      _Dropdown2.default,
	      (0, _extends3.default)({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2.default.createElement(
	        _Dropdown2.default.Toggle,
	        (0, _extends3.default)({}, toggleProps, {
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2.default.createElement(
	        _Dropdown2.default.Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return DropdownButton;
	}(_react2.default.Component);
	
	DropdownButton.propTypes = propTypes;
	
	exports.default = DropdownButton;
	module.exports = exports['default'];

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _from = __webpack_require__(411);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(99);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _RootCloseWrapper = __webpack_require__(813);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _createChainedFunction = __webpack_require__(90);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(108);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  open: _propTypes2.default.bool,
	  pullRight: _propTypes2.default.bool,
	  onClose: _propTypes2.default.func,
	  labelledBy: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  onSelect: _propTypes2.default.func,
	  rootCloseEvent: _propTypes2.default.oneOf(['click', 'mousedown'])
	};
	
	var defaultProps = {
	  bsRole: 'menu',
	  pullRight: false
	};
	
	var DropdownMenu = function (_React$Component) {
	  (0, _inherits3.default)(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    (0, _classCallCheck3.default)(this, DropdownMenu);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    _this.handleRootClose = _this.handleRootClose.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
	    var node = _reactDom2.default.findDOMNode(this);
	    if (!node) {
	      return [];
	    }
	
	    return (0, _from2.default)(node.querySelectorAll('[tabIndex="-1"]'));
	  };
	
	  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
	    var items = this.getFocusableMenuItems();
	    var activeIndex = items.indexOf(document.activeElement);
	
	    return { items: items, activeIndex: activeIndex };
	  };
	
	  DropdownMenu.prototype.focusNext = function focusNext() {
	    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd.items,
	        activeIndex = _getItemsAndActiveInd.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
	    items[nextIndex].focus();
	  };
	
	  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
	    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd2.items,
	        activeIndex = _getItemsAndActiveInd2.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
	    items[prevIndex].focus();
	  };
	
	  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
	    switch (event.keyCode) {
	      case _keycode2.default.codes.down:
	        this.focusNext();
	        event.preventDefault();
	        break;
	      case _keycode2.default.codes.up:
	        this.focusPrevious();
	        event.preventDefault();
	        break;
	      case _keycode2.default.codes.esc:
	      case _keycode2.default.codes.tab:
	        this.props.onClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
	    this.props.onClose(event, { source: 'rootClose' });
	  };
	
	  DropdownMenu.prototype.render = function render() {
	    var _extends2,
	        _this2 = this;
	
	    var _props = this.props,
	        open = _props.open,
	        pullRight = _props.pullRight,
	        labelledBy = _props.labelledBy,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onClose']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'right')] = pullRight, _extends2));
	
	    return _react2.default.createElement(
	      _RootCloseWrapper2.default,
	      {
	        disabled: !open,
	        onRootClose: this.handleRootClose,
	        event: rootCloseEvent
	      },
	      _react2.default.createElement(
	        'ul',
	        (0, _extends4.default)({}, elementProps, {
	          role: 'menu',
	          className: (0, _classnames2.default)(className, classes),
	          'aria-labelledby': labelledBy
	        }),
	        _ValidComponentChildren2.default.map(children, function (child) {
	          return _react2.default.cloneElement(child, {
	            onKeyDown: (0, _createChainedFunction2.default)(child.props.onKeyDown, _this2.handleKeyDown),
	            onSelect: (0, _createChainedFunction2.default)(child.props.onSelect, onSelect)
	          });
	        })
	      )
	    );
	  };
	
	  return DropdownMenu;
	}(_react2.default.Component);
	
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('dropdown-menu', DropdownMenu);
	module.exports = exports['default'];

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  horizontal: _propTypes2.default.bool,
	  inline: _propTypes2.default.bool,
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  horizontal: false,
	  inline: false,
	  componentClass: 'form'
	};
	
	var Form = function (_React$Component) {
	  (0, _inherits3.default)(Form, _React$Component);
	
	  function Form() {
	    (0, _classCallCheck3.default)(this, Form);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Form.prototype.render = function render() {
	    var _props = this.props,
	        horizontal = _props.horizontal,
	        inline = _props.inline,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['horizontal', 'inline', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	    if (horizontal) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'horizontal'));
	    }
	    if (inline) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'inline'));
	    }
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Form;
	}(_react2.default.Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form', Form);
	module.exports = exports['default'];

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _FormControlFeedback = __webpack_require__(1664);
	
	var _FormControlFeedback2 = _interopRequireDefault(_FormControlFeedback);
	
	var _FormControlStatic = __webpack_require__(1665);
	
	var _FormControlStatic2 = _interopRequireDefault(_FormControlStatic);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _StyleConfig = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default,
	  /**
	   * Only relevant if `componentClass` is `'input'`.
	   */
	  type: _propTypes2.default.string,
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <FormControl inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2.default.func
	};
	
	var defaultProps = {
	  componentClass: 'input'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2.default.object
	};
	
	var FormControl = function (_React$Component) {
	  (0, _inherits3.default)(FormControl, _React$Component);
	
	  function FormControl() {
	    (0, _classCallCheck3.default)(this, FormControl);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControl.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        type = _props.type,
	        _props$id = _props.id,
	        id = _props$id === undefined ? controlId : _props$id,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        bsSize = _props.bsSize,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2.default)(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
	
	    // input[type="file"] should not have .form-control.
	    var classes = void 0;
	    if (type !== 'file') {
	      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    }
	
	    // If user provides a size, make sure to append it to classes as input-
	    // e.g. if bsSize is small, it will append input-sm
	    if (bsSize) {
	      var size = _StyleConfig.SIZE_MAP[bsSize] || bsSize;
	      classes[(0, _bootstrapUtils.prefix)({ bsClass: 'input' }, size)] = true;
	    }
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      type: type,
	      id: id,
	      ref: inputRef,
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return FormControl;
	}(_react2.default.Component);
	
	FormControl.propTypes = propTypes;
	FormControl.defaultProps = defaultProps;
	FormControl.contextTypes = contextTypes;
	
	FormControl.Feedback = _FormControlFeedback2.default;
	FormControl.Static = _FormControlStatic2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-control', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.SMALL, _StyleConfig.Size.LARGE], FormControl));
	module.exports = exports['default'];

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Glyphicon = __webpack_require__(504);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	  bsRole: 'feedback'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2.default.object
	};
	
	var FormControlFeedback = function (_React$Component) {
	  (0, _inherits3.default)(FormControlFeedback, _React$Component);
	
	  function FormControlFeedback() {
	    (0, _classCallCheck3.default)(this, FormControlFeedback);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
	    switch (validationState) {
	      case 'success':
	        return 'ok';
	      case 'warning':
	        return 'warning-sign';
	      case 'error':
	        return 'remove';
	      default:
	        return null;
	    }
	  };
	
	  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
	    var glyph = this.getGlyph(formGroup && formGroup.validationState);
	    if (!glyph) {
	      return null;
	    }
	
	    return _react2.default.createElement(_Glyphicon2.default, (0, _extends3.default)({}, elementProps, {
	      glyph: glyph,
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  FormControlFeedback.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (!children) {
	      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(child.props.className, className, classes)
	    }));
	  };
	
	  return FormControlFeedback;
	}(_react2.default.Component);
	
	FormControlFeedback.defaultProps = defaultProps;
	FormControlFeedback.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);
	module.exports = exports['default'];

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'p'
	};
	
	var FormControlStatic = function (_React$Component) {
	  (0, _inherits3.default)(FormControlStatic, _React$Component);
	
	  function FormControlStatic() {
	    (0, _classCallCheck3.default)(this, FormControlStatic);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlStatic.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return FormControlStatic;
	}(_react2.default.Component);
	
	FormControlStatic.propTypes = propTypes;
	FormControlStatic.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);
	module.exports = exports['default'];

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _StyleConfig = __webpack_require__(98);
	
	var _ValidComponentChildren = __webpack_require__(108);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
	   */
	  controlId: _propTypes2.default.string,
	  validationState: _propTypes2.default.oneOf(['success', 'warning', 'error', null])
	};
	
	var childContextTypes = {
	  $bs_formGroup: _propTypes2.default.object.isRequired
	};
	
	var FormGroup = function (_React$Component) {
	  (0, _inherits3.default)(FormGroup, _React$Component);
	
	  function FormGroup() {
	    (0, _classCallCheck3.default)(this, FormGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormGroup.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        controlId = _props.controlId,
	        validationState = _props.validationState;
	
	
	    return {
	      $bs_formGroup: {
	        controlId: controlId,
	        validationState: validationState
	      }
	    };
	  };
	
	  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
	    var _this2 = this;
	
	    return _ValidComponentChildren2.default.some(children, function (child) {
	      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
	    });
	  };
	
	  FormGroup.prototype.render = function render() {
	    var _props2 = this.props,
	        validationState = _props2.validationState,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['validationState', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['controlId']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'has-feedback': this.hasFeedback(children)
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      children
	    );
	  };
	
	  return FormGroup;
	}(_react2.default.Component);
	
	FormGroup.propTypes = propTypes;
	FormGroup.childContextTypes = childContextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], FormGroup));
	module.exports = exports['default'];

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HelpBlock = function (_React$Component) {
	  (0, _inherits3.default)(HelpBlock, _React$Component);
	
	  function HelpBlock() {
	    (0, _classCallCheck3.default)(this, HelpBlock);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  HelpBlock.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return HelpBlock;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('help-block', HelpBlock);
	module.exports = exports['default'];

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Sets image as responsive image
	   */
	  responsive: _propTypes2.default.bool,
	
	  /**
	   * Sets image shape as rounded
	   */
	  rounded: _propTypes2.default.bool,
	
	  /**
	   * Sets image shape as circle
	   */
	  circle: _propTypes2.default.bool,
	
	  /**
	   * Sets image shape as thumbnail
	   */
	  thumbnail: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  responsive: false,
	  rounded: false,
	  circle: false,
	  thumbnail: false
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image() {
	    (0, _classCallCheck3.default)(this, Image);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Image.prototype.render = function render() {
	    var _classes;
	
	    var _props = this.props,
	        responsive = _props.responsive,
	        rounded = _props.rounded,
	        circle = _props.circle,
	        thumbnail = _props.thumbnail,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (_classes = {}, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'responsive')] = responsive, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'rounded')] = rounded, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'circle')] = circle, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'thumbnail')] = thumbnail, _classes);
	
	    return _react2.default.createElement('img', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.propTypes = propTypes;
	Image.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('img', Image);
	module.exports = exports['default'];

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputGroupAddon = __webpack_require__(1670);
	
	var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);
	
	var _InputGroupButton = __webpack_require__(1671);
	
	var _InputGroupButton2 = _interopRequireDefault(_InputGroupButton);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _StyleConfig = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputGroup = function (_React$Component) {
	  (0, _inherits3.default)(InputGroup, _React$Component);
	
	  function InputGroup() {
	    (0, _classCallCheck3.default)(this, InputGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroup.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return InputGroup;
	}(_react2.default.Component);
	
	InputGroup.Addon = _InputGroupAddon2.default;
	InputGroup.Button = _InputGroupButton2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('input-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], InputGroup));
	module.exports = exports['default'];

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputGroupAddon = function (_React$Component) {
	  (0, _inherits3.default)(InputGroupAddon, _React$Component);
	
	  function InputGroupAddon() {
	    (0, _classCallCheck3.default)(this, InputGroupAddon);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupAddon.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return InputGroupAddon;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('input-group-addon', InputGroupAddon);
	module.exports = exports['default'];

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputGroupButton = function (_React$Component) {
	  (0, _inherits3.default)(InputGroupButton, _React$Component);
	
	  function InputGroupButton() {
	    (0, _classCallCheck3.default)(this, InputGroupButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupButton.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return InputGroupButton;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('input-group-btn', InputGroupButton);
	module.exports = exports['default'];

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Jumbotron = function (_React$Component) {
	  (0, _inherits3.default)(Jumbotron, _React$Component);
	
	  function Jumbotron() {
	    (0, _classCallCheck3.default)(this, Jumbotron);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Jumbotron.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Jumbotron;
	}(_react2.default.Component);
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('jumbotron', Jumbotron);
	module.exports = exports['default'];

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(223);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _StyleConfig = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Label = function (_React$Component) {
	  (0, _inherits3.default)(Label, _React$Component);
	
	  function Label() {
	    (0, _classCallCheck3.default)(this, Label);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Label.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2.default.Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Label.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2.default.createElement(
	      'span',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Label;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('label', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2.default)(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Label));
	module.exports = exports['default'];

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _ListGroupItem = __webpack_require__(797);
	
	var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _ValidComponentChildren = __webpack_require__(108);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * You can use a custom element type for this component.
	   *
	   * If not specified, it will be treated as `'li'` if every child is a
	   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
	   */
	  componentClass: _elementType2.default
	};
	
	function getDefaultComponent(children) {
	  if (!children) {
	    // FIXME: This is the old behavior. Is this right?
	    return 'div';
	  }
	
	  if (_ValidComponentChildren2.default.some(children, function (child) {
	    return child.type !== _ListGroupItem2.default || child.props.href || child.props.onClick;
	  })) {
	    return 'div';
	  }
	
	  return 'ul';
	}
	
	var ListGroup = function (_React$Component) {
	  (0, _inherits3.default)(ListGroup, _React$Component);
	
	  function ListGroup() {
	    (0, _classCallCheck3.default)(this, ListGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroup.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        _props$componentClass = _props.componentClass,
	        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['children', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var useListItem = Component === 'ul' && _ValidComponentChildren2.default.every(children, function (child) {
	      return child.type === _ListGroupItem2.default;
	    });
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      useListItem ? _ValidComponentChildren2.default.map(children, function (child) {
	        return (0, _react.cloneElement)(child, { listItem: true });
	      }) : children
	    );
	  };
	
	  return ListGroup;
	}(_react2.default.Component);
	
	ListGroup.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('list-group', ListGroup);
	module.exports = exports['default'];

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Media = __webpack_require__(366);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom']),
	
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var MediaBody = function (_React$Component) {
	  (0, _inherits3.default)(MediaBody, _React$Component);
	
	  function MediaBody() {
	    (0, _classCallCheck3.default)(this, MediaBody);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2.default.defaultProps, align)] = true;
	    }
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaBody;
	}(_react2.default.Component);
	
	MediaBody.propTypes = propTypes;
	MediaBody.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-body', MediaBody);
	module.exports = exports['default'];

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var MediaHeading = function (_React$Component) {
	  (0, _inherits3.default)(MediaHeading, _React$Component);
	
	  function MediaHeading() {
	    (0, _classCallCheck3.default)(this, MediaHeading);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaHeading.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaHeading;
	}(_react2.default.Component);
	
	MediaHeading.propTypes = propTypes;
	MediaHeading.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-heading', MediaHeading);
	module.exports = exports['default'];

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(366);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaLeft = function (_React$Component) {
	  (0, _inherits3.default)(MediaLeft, _React$Component);
	
	  function MediaLeft() {
	    (0, _classCallCheck3.default)(this, MediaLeft);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaLeft.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2.default.defaultProps, align)] = true;
	    }
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaLeft;
	}(_react2.default.Component);
	
	MediaLeft.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-left', MediaLeft);
	module.exports = exports['default'];

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaList = function (_React$Component) {
	  (0, _inherits3.default)(MediaList, _React$Component);
	
	  function MediaList() {
	    (0, _classCallCheck3.default)(this, MediaList);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaList.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('ul', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaList;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-list', MediaList);
	module.exports = exports['default'];

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaListItem = function (_React$Component) {
	  (0, _inherits3.default)(MediaListItem, _React$Component);
	
	  function MediaListItem() {
	    (0, _classCallCheck3.default)(this, MediaListItem);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaListItem.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('li', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaListItem;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('media', MediaListItem);
	module.exports = exports['default'];

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(366);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaRight = function (_React$Component) {
	  (0, _inherits3.default)(MediaRight, _React$Component);
	
	  function MediaRight() {
	    (0, _classCallCheck3.default)(this, MediaRight);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaRight.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-right-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2.default.defaultProps, align)] = true;
	    }
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaRight;
	}(_react2.default.Component);
	
	MediaRight.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-right', MediaRight);
	module.exports = exports['default'];

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(368);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _SafeAnchor = __webpack_require__(154);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _createChainedFunction = __webpack_require__(90);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Highlight the menu item as active.
	   */
	  active: _propTypes2.default.bool,
	
	  /**
	   * Disable the menu item, making it unselectable.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Styles the menu item as a horizontal rule, providing visual separation between
	   * groups of menu items.
	   */
	  divider: (0, _all2.default)(_propTypes2.default.bool, function (_ref) {
	    var divider = _ref.divider,
	        children = _ref.children;
	    return divider && children ? new Error('Children will not be rendered for dividers') : null;
	  }),
	
	  /**
	   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
	   */
	  eventKey: _propTypes2.default.any,
	
	  /**
	   * Styles the menu item as a header label, useful for describing a group of menu items.
	   */
	  header: _propTypes2.default.bool,
	
	  /**
	   * HTML `href` attribute corresponding to `a.href`.
	   */
	  href: _propTypes2.default.string,
	
	  /**
	   * Callback fired when the menu item is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * Callback fired when the menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2.default.func
	};
	
	var defaultProps = {
	  divider: false,
	  disabled: false,
	  header: false
	};
	
	var MenuItem = function (_React$Component) {
	  (0, _inherits3.default)(MenuItem, _React$Component);
	
	  function MenuItem(props, context) {
	    (0, _classCallCheck3.default)(this, MenuItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  MenuItem.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        href = _props.href,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (!href || disabled) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  MenuItem.prototype.render = function render() {
	    var _props2 = this.props,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        divider = _props2.divider,
	        header = _props2.header,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    if (divider) {
	      // Forcibly blank out the children; separators shouldn't render any.
	      elementProps.children = undefined;
	
	      return _react2.default.createElement('li', (0, _extends3.default)({}, elementProps, {
	        role: 'separator',
	        className: (0, _classnames2.default)(className, 'divider'),
	        style: style
	      }));
	    }
	
	    if (header) {
	      return _react2.default.createElement('li', (0, _extends3.default)({}, elementProps, {
	        role: 'heading',
	        className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'header')),
	        style: style
	      }));
	    }
	
	    return _react2.default.createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2.default)(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2.default.createElement(_SafeAnchor2.default, (0, _extends3.default)({}, elementProps, {
	        role: 'menuitem',
	        tabIndex: '-1',
	        onClick: (0, _createChainedFunction2.default)(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return MenuItem;
	}(_react2.default.Component);
	
	MenuItem.propTypes = propTypes;
	MenuItem.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);
	module.exports = exports['default'];

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _events = __webpack_require__(1174);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _ownerDocument = __webpack_require__(233);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _inDOM = __webpack_require__(182);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _scrollbarSize = __webpack_require__(641);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Modal = __webpack_require__(1715);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _isOverflowing = __webpack_require__(816);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(365);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ModalBody = __webpack_require__(798);
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalDialog = __webpack_require__(1683);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _ModalFooter = __webpack_require__(799);
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	var _ModalHeader = __webpack_require__(800);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalTitle = __webpack_require__(801);
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _createChainedFunction = __webpack_require__(90);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _splitComponentProps2 = __webpack_require__(367);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _StyleConfig = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Modal2.default.propTypes, _ModalDialog2.default.propTypes, {
	
	  /**
	   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
	   * trigger an "onHide" when clicked.
	   */
	  backdrop: _propTypes2.default.oneOf(['static', true, false]),
	
	  /**
	   * Add an optional extra class name to .modal-backdrop
	   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
	   */
	  backdropClassName: _propTypes2.default.string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2.default.bool,
	
	  /**
	   * Open and close the Modal with a slide and fade animation.
	   */
	  animation: _propTypes2.default.bool,
	
	  /**
	   * A Component type that provides the modal content Markup. This is a useful
	   * prop when you want to use your own styles and markup to create a custom
	   * modal component.
	   */
	  dialogComponentClass: _elementType2.default,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it
	   * opens, and replace it to the last focused element when it closes.
	   * Generally this should never be set to false as it makes the Modal less
	   * accessible to assistive technologies, like screen-readers.
	   */
	  autoFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while
	   * open. Consider leaving the default value here, as it is necessary to make
	   * the Modal work well with assistive technologies, such as screen readers.
	   */
	  enforceFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will show itself.
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * A callback fired when the header closeButton or non-static backdrop is
	   * clicked. Required if either are specified.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * @private
	   */
	  container: _Modal2.default.propTypes.container
	});
	
	var defaultProps = (0, _extends3.default)({}, _Modal2.default.defaultProps, {
	  animation: true,
	  dialogComponentClass: _ModalDialog2.default
	});
	
	var childContextTypes = {
	  $bs_modal: _propTypes2.default.shape({
	    onHide: _propTypes2.default.func
	  })
	};
	
	var Modal = function (_React$Component) {
	  (0, _inherits3.default)(Modal, _React$Component);
	
	  function Modal(props, context) {
	    (0, _classCallCheck3.default)(this, Modal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
	    _this.setModalRef = _this.setModalRef.bind(_this);
	
	    _this.state = {
	      style: {}
	    };
	    return _this;
	  }
	
	  Modal.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_modal: {
	        onHide: this.props.onHide
	      }
	    };
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Clean up the listener if we need to.
	    this.handleExited();
	  };
	
	  Modal.prototype.setModalRef = function setModalRef(ref) {
	    this._modal = ref;
	  };
	
	  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  };
	
	  Modal.prototype.handleEntering = function handleEntering() {
	    // FIXME: This should work even when animation is disabled.
	    _events2.default.on(window, 'resize', this.handleWindowResize);
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleExited = function handleExited() {
	    // FIXME: This should work even when animation is disabled.
	    _events2.default.off(window, 'resize', this.handleWindowResize);
	  };
	
	  Modal.prototype.handleWindowResize = function handleWindowResize() {
	    this.updateStyle();
	  };
	
	  Modal.prototype.updateStyle = function updateStyle() {
	    if (!_inDOM2.default) {
	      return;
	    }
	
	    var dialogNode = this._modal.getDialogElement();
	    var dialogHeight = dialogNode.scrollHeight;
	
	    var document = (0, _ownerDocument2.default)(dialogNode);
	    var bodyIsOverflowing = (0, _isOverflowing2.default)(_reactDom2.default.findDOMNode(this.props.container || document.body));
	    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
	
	    this.setState({
	      style: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize2.default)() : undefined,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize2.default)() : undefined
	      }
	    });
	  };
	
	  Modal.prototype.render = function render() {
	    var _props = this.props,
	        backdrop = _props.backdrop,
	        backdropClassName = _props.backdropClassName,
	        animation = _props.animation,
	        show = _props.show,
	        Dialog = _props.dialogComponentClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        onEntering = _props.onEntering,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3.default)(_props, ['backdrop', 'backdropClassName', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);
	
	    var _splitComponentProps = (0, _splitComponentProps3.default)(props, _Modal2.default),
	        baseModalProps = _splitComponentProps[0],
	        dialogProps = _splitComponentProps[1];
	
	    var inClassName = show && !animation && 'in';
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      (0, _extends3.default)({}, baseModalProps, {
	        ref: this.setModalRef,
	        show: show,
	        onEntering: (0, _createChainedFunction2.default)(onEntering, this.handleEntering),
	        onExited: (0, _createChainedFunction2.default)(onExited, this.handleExited),
	        backdrop: backdrop,
	        backdropClassName: (0, _classnames2.default)((0, _bootstrapUtils.prefix)(props, 'backdrop'), backdropClassName, inClassName),
	        containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
	        transition: animation ? _Fade2.default : undefined,
	        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
	        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
	      }),
	      _react2.default.createElement(
	        Dialog,
	        (0, _extends3.default)({}, dialogProps, {
	          style: (0, _extends3.default)({}, this.state.style, style),
	          className: (0, _classnames2.default)(className, inClassName),
	          onClick: backdrop === true ? this.handleDialogClick : null
	        }),
	        children
	      )
	    );
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.childContextTypes = childContextTypes;
	
	Modal.Body = _ModalBody2.default;
	Modal.Header = _ModalHeader2.default;
	Modal.Title = _ModalTitle2.default;
	Modal.Footer = _ModalFooter2.default;
	
	Modal.Dialog = _ModalDialog2.default;
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Modal));
	module.exports = exports['default'];

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _StyleConfig = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * A css class to apply to the Modal dialog DOM node.
	   */
	  dialogClassName: _propTypes2.default.string
	};
	
	var ModalDialog = function (_React$Component) {
	  (0, _inherits3.default)(ModalDialog, _React$Component);
	
	  function ModalDialog() {
	    (0, _classCallCheck3.default)(this, ModalDialog);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalDialog.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        dialogClassName = _props.dialogClassName,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['dialogClassName', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(bsProps);
	
	    var modalStyle = (0, _extends4.default)({ display: 'block' }, style);
	
	    var dialogClasses = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dialog')] = true, _extends2));
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        tabIndex: '-1',
	        role: 'dialog',
	        style: modalStyle,
	        className: (0, _classnames2.default)(className, bsClassName)
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(dialogClassName, dialogClasses) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'content'), role: 'document' },
	          children
	        )
	      )
	    );
	  };
	
	  return ModalDialog;
	}(_react2.default.Component);
	
	ModalDialog.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], ModalDialog));
	module.exports = exports['default'];

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(364);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(367);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _ValidComponentChildren = __webpack_require__(108);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Dropdown2.default.propTypes, {
	
	  // Toggle props.
	  title: _propTypes2.default.node.isRequired,
	  noCaret: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2.default.node
	});
	
	var NavDropdown = function (_React$Component) {
	  (0, _inherits3.default)(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    (0, _classCallCheck3.default)(this, NavDropdown);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
	    var props = _ref.props;
	
	    var _this2 = this;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    if (_ValidComponentChildren2.default.some(props.children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    })) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  NavDropdown.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        title = _props.title,
	        activeKey = _props.activeKey,
	        activeHref = _props.activeHref,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);
	
	
	    var active = this.isActive(this, activeKey, activeHref);
	    delete props.active; // Accessed via this.isActive().
	    delete props.eventKey; // Accessed via this.isActive().
	
	    var _splitComponentProps = (0, _splitComponentProps3.default)(props, _Dropdown2.default.ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
	    // rather than the `<Dropdown.Toggle>`.
	
	    return _react2.default.createElement(
	      _Dropdown2.default,
	      (0, _extends3.default)({}, dropdownProps, {
	        componentClass: 'li',
	        className: (0, _classnames2.default)(className, { active: active }),
	        style: style
	      }),
	      _react2.default.createElement(
	        _Dropdown2.default.Toggle,
	        (0, _extends3.default)({}, toggleProps, { useAnchor: true }),
	        title
	      ),
	      _react2.default.createElement(
	        _Dropdown2.default.Menu,
	        null,
	        _ValidComponentChildren2.default.map(children, function (child) {
	          return _react2.default.cloneElement(child, {
	            active: _this3.isActive(child, activeKey, activeHref)
	          });
	        })
	      )
	    );
	  };
	
	  return NavDropdown;
	}(_react2.default.Component);
	
	NavDropdown.propTypes = propTypes;
	
	exports.default = NavDropdown;
	module.exports = exports['default'];

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _uncontrollable = __webpack_require__(221);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Grid = __webpack_require__(796);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _NavbarBrand = __webpack_require__(804);
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	var _NavbarCollapse = __webpack_require__(1686);
	
	var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);
	
	var _NavbarHeader = __webpack_require__(1687);
	
	var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);
	
	var _NavbarToggle = __webpack_require__(1688);
	
	var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _StyleConfig = __webpack_require__(98);
	
	var _createChainedFunction = __webpack_require__(90);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Create a fixed navbar along the top of the screen, that scrolls with the
	   * page
	   */
	  fixedTop: _propTypes2.default.bool,
	  /**
	   * Create a fixed navbar along the bottom of the screen, that scrolls with
	   * the page
	   */
	  fixedBottom: _propTypes2.default.bool,
	  /**
	   * Create a full-width navbar that scrolls away with the page
	   */
	  staticTop: _propTypes2.default.bool,
	  /**
	   * An alternative dark visual style for the Navbar
	   */
	  inverse: _propTypes2.default.bool,
	  /**
	   * Allow the Navbar to fluidly adjust to the page or container width, instead
	   * of at the predefined screen breakpoints
	   */
	  fluid: _propTypes2.default.bool,
	
	  /**
	   * Set a custom element for this component.
	   */
	  componentClass: _elementType2.default,
	  /**
	   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
	   * a `<Navbar.Toggle>` is clicked and called with the new `expanded`
	   * boolean value.
	   *
	   * @controllable expanded
	   */
	  onToggle: _propTypes2.default.func,
	  /**
	   * A callback fired when a descendant of a child `<Nav>` is selected. Should
	   * be used to execute complex closing or other miscellaneous actions desired
	   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
	   * descendants exist. The callback is called with an eventKey, which is a
	   * prop from the selected `<Nav>` descendant, and an event.
	   *
	   * ```js
	   * function (
	   *  Any eventKey,
	   *  SyntheticEvent event?
	   * )
	   * ```
	   *
	   * For basic closing behavior after all `<Nav>` descendant onSelect events in
	   * mobile viewports, try using collapseOnSelect.
	   *
	   * Note: If you are manually closing the navbar using this `OnSelect` prop,
	   * ensure that you are setting `expanded` to false and not *toggling* between
	   * true and false.
	   */
	  onSelect: _propTypes2.default.func,
	  /**
	   * Sets `expanded` to `false` after the onSelect event of a descendant of a
	   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
	   *
	   * The onSelect callback should be used instead for more complex operations
	   * that need to be executed after the `select` event of `<Nav>` descendants.
	   */
	  collapseOnSelect: _propTypes2.default.bool,
	  /**
	   * Explicitly set the visiblity of the navbar body
	   *
	   * @controllable onToggle
	   */
	  expanded: _propTypes2.default.bool,
	
	  role: _propTypes2.default.string
	}; // TODO: Remove this pragma once we upgrade eslint-config-airbnb.
	/* eslint-disable react/no-multi-comp */
	
	var defaultProps = {
	  componentClass: 'nav',
	  fixedTop: false,
	  fixedBottom: false,
	  staticTop: false,
	  inverse: false,
	  fluid: false,
	  collapseOnSelect: false
	};
	
	var childContextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    expanded: _propTypes2.default.bool,
	    onToggle: _propTypes2.default.func.isRequired,
	    onSelect: _propTypes2.default.func
	  })
	};
	
	var Navbar = function (_React$Component) {
	  (0, _inherits3.default)(Navbar, _React$Component);
	
	  function Navbar(props, context) {
	    (0, _classCallCheck3.default)(this, Navbar);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleCollapse = _this.handleCollapse.bind(_this);
	    return _this;
	  }
	
	  Navbar.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        expanded = _props.expanded,
	        onSelect = _props.onSelect,
	        collapseOnSelect = _props.collapseOnSelect;
	
	
	    return {
	      $bs_navbar: {
	        bsClass: bsClass,
	        expanded: expanded,
	        onToggle: this.handleToggle,
	        onSelect: (0, _createChainedFunction2.default)(onSelect, collapseOnSelect ? this.handleCollapse : null)
	      }
	    };
	  };
	
	  Navbar.prototype.handleCollapse = function handleCollapse() {
	    var _props2 = this.props,
	        onToggle = _props2.onToggle,
	        expanded = _props2.expanded;
	
	
	    if (expanded) {
	      onToggle(false);
	    }
	  };
	
	  Navbar.prototype.handleToggle = function handleToggle() {
	    var _props3 = this.props,
	        onToggle = _props3.onToggle,
	        expanded = _props3.expanded;
	
	
	    onToggle(!expanded);
	  };
	
	  Navbar.prototype.render = function render() {
	    var _extends2;
	
	    var _props4 = this.props,
	        Component = _props4.componentClass,
	        fixedTop = _props4.fixedTop,
	        fixedBottom = _props4.fixedBottom,
	        staticTop = _props4.staticTop,
	        inverse = _props4.inverse,
	        fluid = _props4.fluid,
	        className = _props4.className,
	        children = _props4.children,
	        props = (0, _objectWithoutProperties3.default)(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	
	
	    if (elementProps.role === undefined && Component !== 'nav') {
	      elementProps.role = 'navigation';
	    }
	
	    if (inverse) {
	      bsProps.bsStyle = _StyleConfig.Style.INVERSE;
	    }
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-top')] = fixedTop, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'static-top')] = staticTop, _extends2));
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends4.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _react2.default.createElement(
	        _Grid2.default,
	        { fluid: fluid },
	        children
	      )
	    );
	  };
	
	  return Navbar;
	}(_react2.default.Component);
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	Navbar.childContextTypes = childContextTypes;
	
	(0, _bootstrapUtils.bsClass)('navbar', Navbar);
	
	var UncontrollableNavbar = (0, _uncontrollable2.default)(Navbar, { expanded: 'onToggle' });
	
	function createSimpleWrapper(tag, suffix, displayName) {
	  var Wrapper = function Wrapper(_ref, _ref2) {
	    var _ref2$$bs_navbar = _ref2.$bs_navbar,
	        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;
	    var Component = _ref.componentClass,
	        className = _ref.className,
	        pullRight = _ref.pullRight,
	        pullLeft = _ref.pullLeft,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);
	    return _react2.default.createElement(Component, (0, _extends4.default)({}, props, {
	      className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(navbarProps, suffix), pullRight && (0, _bootstrapUtils.prefix)(navbarProps, 'right'), pullLeft && (0, _bootstrapUtils.prefix)(navbarProps, 'left'))
	    }));
	  };
	
	  Wrapper.displayName = displayName;
	
	  Wrapper.propTypes = {
	    componentClass: _elementType2.default,
	    pullRight: _propTypes2.default.bool,
	    pullLeft: _propTypes2.default.bool
	  };
	
	  Wrapper.defaultProps = {
	    componentClass: tag,
	    pullRight: false,
	    pullLeft: false
	  };
	
	  Wrapper.contextTypes = {
	    $bs_navbar: _propTypes2.default.shape({
	      bsClass: _propTypes2.default.string
	    })
	  };
	
	  return Wrapper;
	}
	
	UncontrollableNavbar.Brand = _NavbarBrand2.default;
	UncontrollableNavbar.Header = _NavbarHeader2.default;
	UncontrollableNavbar.Toggle = _NavbarToggle2.default;
	UncontrollableNavbar.Collapse = _NavbarCollapse2.default;
	
	UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
	UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
	UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');
	
	// Set bsStyles here so they can be overridden.
	exports.default = (0, _bootstrapUtils.bsStyles)([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.INVERSE], _StyleConfig.Style.DEFAULT, UncontrollableNavbar);
	module.exports = exports['default'];

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(503);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    expanded: _propTypes2.default.bool
	  })
	};
	
	var NavbarCollapse = function (_React$Component) {
	  (0, _inherits3.default)(NavbarCollapse, _React$Component);
	
	  function NavbarCollapse() {
	    (0, _classCallCheck3.default)(this, NavbarCollapse);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarCollapse.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'collapse');
	
	    return _react2.default.createElement(
	      _Collapse2.default,
	      (0, _extends3.default)({ 'in': navbarProps.expanded }, props),
	      _react2.default.createElement(
	        'div',
	        { className: bsClassName },
	        children
	      )
	    );
	  };
	
	  return NavbarCollapse;
	}(_react2.default.Component);
	
	NavbarCollapse.contextTypes = contextTypes;
	
	exports.default = NavbarCollapse;
	module.exports = exports['default'];

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string
	  })
	};
	
	var NavbarHeader = function (_React$Component) {
	  (0, _inherits3.default)(NavbarHeader, _React$Component);
	
	  function NavbarHeader() {
	    (0, _classCallCheck3.default)(this, NavbarHeader);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'header');
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: (0, _classnames2.default)(className, bsClassName) }));
	  };
	
	  return NavbarHeader;
	}(_react2.default.Component);
	
	NavbarHeader.contextTypes = contextTypes;
	
	exports.default = NavbarHeader;
	module.exports = exports['default'];

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _createChainedFunction = __webpack_require__(90);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  onClick: _propTypes2.default.func,
	  /**
	   * The toggle content, if left empty it will render the default toggle (seen above).
	   */
	  children: _propTypes2.default.node
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    expanded: _propTypes2.default.bool,
	    onToggle: _propTypes2.default.func.isRequired
	  })
	};
	
	var NavbarToggle = function (_React$Component) {
	  (0, _inherits3.default)(NavbarToggle, _React$Component);
	
	  function NavbarToggle() {
	    (0, _classCallCheck3.default)(this, NavbarToggle);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarToggle.prototype.render = function render() {
	    var _props = this.props,
	        onClick = _props.onClick,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['onClick', 'className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var buttonProps = (0, _extends3.default)({
	      type: 'button'
	    }, props, {
	      onClick: (0, _createChainedFunction2.default)(onClick, navbarProps.onToggle),
	      className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
	    });
	
	    if (children) {
	      return _react2.default.createElement(
	        'button',
	        buttonProps,
	        children
	      );
	    }
	
	    return _react2.default.createElement(
	      'button',
	      buttonProps,
	      _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        'Toggle navigation'
	      ),
	      _react2.default.createElement('span', { className: 'icon-bar' }),
	      _react2.default.createElement('span', { className: 'icon-bar' }),
	      _react2.default.createElement('span', { className: 'icon-bar' })
	    );
	  };
	
	  return NavbarToggle;
	}(_react2.default.Component);
	
	NavbarToggle.propTypes = propTypes;
	NavbarToggle.contextTypes = contextTypes;
	
	exports.default = NavbarToggle;
	module.exports = exports['default'];

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _contains = __webpack_require__(234);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Overlay = __webpack_require__(805);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _createChainedFunction = __webpack_require__(90);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if (Array.isArray(of)) {
	    return of.indexOf(one) >= 0;
	  }
	  return one === of;
	}
	
	var triggerType = _propTypes2.default.oneOf(['click', 'hover', 'focus']);
	
	var propTypes = (0, _extends3.default)({}, _Overlay2.default.propTypes, {
	
	  /**
	   * Specify which action or actions trigger Overlay visibility
	   */
	  trigger: _propTypes2.default.oneOfType([triggerType, _propTypes2.default.arrayOf(triggerType)]),
	
	  /**
	   * A millisecond delay amount to show and hide the Overlay once triggered
	   */
	  delay: _propTypes2.default.number,
	  /**
	   * A millisecond delay amount before showing the Overlay once triggered.
	   */
	  delayShow: _propTypes2.default.number,
	  /**
	   * A millisecond delay amount before hiding the Overlay once triggered.
	   */
	  delayHide: _propTypes2.default.number,
	
	  // FIXME: This should be `defaultShow`.
	  /**
	   * The initial visibility state of the Overlay. For more nuanced visibility
	   * control, consider using the Overlay component directly.
	   */
	  defaultOverlayShown: _propTypes2.default.bool,
	
	  /**
	   * An element or text to overlay next to the target.
	   */
	  overlay: _propTypes2.default.node.isRequired,
	
	  /**
	   * @private
	   */
	  onBlur: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onFocus: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onMouseOut: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  // Overridden props from `<Overlay>`.
	  /**
	   * @private
	   */
	  target: _propTypes2.default.oneOf([null]),
	  /**
	   * @private
	   */
	  onHide: _propTypes2.default.oneOf([null]),
	  /**
	   * @private
	   */
	  show: _propTypes2.default.oneOf([null])
	});
	
	var defaultProps = {
	  defaultOverlayShown: false,
	  trigger: ['hover', 'focus']
	};
	
	var OverlayTrigger = function (_React$Component) {
	  (0, _inherits3.default)(OverlayTrigger, _React$Component);
	
	  function OverlayTrigger(props, context) {
	    (0, _classCallCheck3.default)(this, OverlayTrigger);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
	    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
	    _this.handleHide = _this.handleHide.bind(_this);
	
	    _this.handleMouseOver = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
	    };
	    _this.handleMouseOut = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
	    };
	
	    _this._mountNode = null;
	
	    _this.state = {
	      show: props.defaultOverlayShown
	    };
	    return _this;
	  }
	
	  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    _reactDom2.default.unmountComponentAtNode(this._mountNode);
	    this._mountNode = null;
	
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  };
	
	  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
	    var _this2 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.show || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this2._hoverHideDelay = null;
	      _this2.hide();
	    }, delay);
	  };
	
	  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
	    var _this3 = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.show || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this3._hoverShowDelay = null;
	      _this3.show();
	    }, delay);
	  };
	
	  OverlayTrigger.prototype.handleHide = function handleHide() {
	    this.hide();
	  };
	
	  // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
	  // moving from one child element to another.
	
	
	  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent.toElement;
	
	    if ((!related || related !== target) && !(0, _contains2.default)(target, related)) {
	      handler(e);
	    }
	  };
	
	  OverlayTrigger.prototype.handleToggle = function handleToggle() {
	    if (this.state.show) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  OverlayTrigger.prototype.hide = function hide() {
	    this.setState({ show: false });
	  };
	
	  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
	    return _react2.default.createElement(
	      _Overlay2.default,
	      (0, _extends3.default)({}, props, {
	        show: this.state.show,
	        onHide: this.handleHide,
	        target: this
	      }),
	      overlay
	    );
	  };
	
	  OverlayTrigger.prototype.show = function show() {
	    this.setState({ show: true });
	  };
	
	  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
	    _reactDom2.default.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  };
	
	  OverlayTrigger.prototype.render = function render() {
	    var _props = this.props,
	        trigger = _props.trigger,
	        overlay = _props.overlay,
	        children = _props.children,
	        onBlur = _props.onBlur,
	        onClick = _props.onClick,
	        onFocus = _props.onFocus,
	        onMouseOut = _props.onMouseOut,
	        onMouseOver = _props.onMouseOver,
	        props = (0, _objectWithoutProperties3.default)(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);
	
	
	    delete props.delay;
	    delete props.delayShow;
	    delete props.delayHide;
	    delete props.defaultOverlayShown;
	
	    var child = _react2.default.Children.only(children);
	    var childProps = child.props;
	    var triggerProps = {};
	
	    if (this.state.show) {
	      triggerProps['aria-describedby'] = overlay.props.id;
	    }
	
	    // FIXME: The logic here for passing through handlers on this component is
	    // inconsistent. We shouldn't be passing any of these props through.
	
	    triggerProps.onClick = (0, _createChainedFunction2.default)(childProps.onClick, onClick);
	
	    if (isOneOf('click', trigger)) {
	      triggerProps.onClick = (0, _createChainedFunction2.default)(triggerProps.onClick, this.handleToggle);
	    }
	
	    if (isOneOf('hover', trigger)) {
	       false ? (0, _warning2.default)(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
	
	      triggerProps.onMouseOver = (0, _createChainedFunction2.default)(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
	      triggerProps.onMouseOut = (0, _createChainedFunction2.default)(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
	    }
	
	    if (isOneOf('focus', trigger)) {
	      triggerProps.onFocus = (0, _createChainedFunction2.default)(childProps.onFocus, onFocus, this.handleDelayedShow);
	      triggerProps.onBlur = (0, _createChainedFunction2.default)(childProps.onBlur, onBlur, this.handleDelayedHide);
	    }
	
	    this._overlay = this.makeOverlay(overlay, props);
	
	    return (0, _react.cloneElement)(child, triggerProps);
	  };
	
	  return OverlayTrigger;
	}(_react2.default.Component);
	
	OverlayTrigger.propTypes = propTypes;
	OverlayTrigger.defaultProps = defaultProps;
	
	exports.default = OverlayTrigger;
	module.exports = exports['default'];

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageHeader = function (_React$Component) {
	  (0, _inherits3.default)(PageHeader, _React$Component);
	
	  function PageHeader() {
	    (0, _classCallCheck3.default)(this, PageHeader);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  PageHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _react2.default.createElement(
	        'h1',
	        null,
	        children
	      )
	    );
	  };
	
	  return PageHeader;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('page-header', PageHeader);
	module.exports = exports['default'];

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PagerItem = __webpack_require__(806);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _deprecationWarning = __webpack_require__(1711);
	
	var _deprecationWarning2 = _interopRequireDefault(_deprecationWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _deprecationWarning2.default.wrapper(_PagerItem2.default, '`<PageItem>`', '`<Pager.Item>`');
	module.exports = exports['default'];

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PagerItem = __webpack_require__(806);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _createChainedFunction = __webpack_require__(90);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(108);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  onSelect: _propTypes2.default.func
	};
	
	var Pager = function (_React$Component) {
	  (0, _inherits3.default)(Pager, _React$Component);
	
	  function Pager() {
	    (0, _classCallCheck3.default)(this, Pager);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Pager.prototype.render = function render() {
	    var _props = this.props,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['onSelect', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'ul',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        return (0, _react.cloneElement)(child, {
	          onSelect: (0, _createChainedFunction2.default)(child.props.onSelect, onSelect)
	        });
	      })
	    );
	  };
	
	  return Pager;
	}(_react2.default.Component);
	
	Pager.propTypes = propTypes;
	
	Pager.Item = _PagerItem2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('pager', Pager);
	module.exports = exports['default'];

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _PaginationButton = __webpack_require__(807);
	
	var _PaginationButton2 = _interopRequireDefault(_PaginationButton);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  activePage: _propTypes2.default.number,
	  items: _propTypes2.default.number,
	  maxButtons: _propTypes2.default.number,
	
	  /**
	   * When `true`, will display the first and the last button page when
	   * displaying ellipsis.
	   */
	  boundaryLinks: _propTypes2.default.bool,
	
	  /**
	   * When `true`, will display the default node value ('&hellip;').
	   * Otherwise, will display provided node (when specified).
	   */
	  ellipsis: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  /**
	   * When `true`, will display the default node value ('&laquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  first: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  /**
	   * When `true`, will display the default node value ('&raquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  last: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  /**
	   * When `true`, will display the default node value ('&lsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  prev: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  /**
	   * When `true`, will display the default node value ('&rsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  next: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * You can use a custom element for the buttons
	   */
	  buttonComponentClass: _elementType2.default
	};
	
	var defaultProps = {
	  activePage: 1,
	  items: 1,
	  maxButtons: 0,
	  first: false,
	  last: false,
	  prev: false,
	  next: false,
	  ellipsis: true,
	  boundaryLinks: false
	};
	
	var Pagination = function (_React$Component) {
	  (0, _inherits3.default)(Pagination, _React$Component);
	
	  function Pagination() {
	    (0, _classCallCheck3.default)(this, Pagination);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Pagination.prototype.renderPageButtons = function renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps) {
	    var pageButtons = [];
	
	    var startPage = void 0;
	    var endPage = void 0;
	
	    if (maxButtons && maxButtons < items) {
	      startPage = Math.max(Math.min(activePage - Math.floor(maxButtons / 2, 10), items - maxButtons + 1), 1);
	      endPage = startPage + maxButtons - 1;
	    } else {
	      startPage = 1;
	      endPage = items;
	    }
	
	    for (var page = startPage; page <= endPage; ++page) {
	      pageButtons.push(_react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          key: page,
	          eventKey: page,
	          active: page === activePage
	        }),
	        page
	      ));
	    }
	
	    if (ellipsis && boundaryLinks && startPage > 1) {
	      if (startPage > 2) {
	        pageButtons.unshift(_react2.default.createElement(
	          _PaginationButton2.default,
	          {
	            key: 'ellipsisFirst',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2.default.createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      pageButtons.unshift(_react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          key: 1,
	          eventKey: 1,
	          active: false
	        }),
	        '1'
	      ));
	    }
	
	    if (ellipsis && endPage < items) {
	      if (!boundaryLinks || endPage < items - 1) {
	        pageButtons.push(_react2.default.createElement(
	          _PaginationButton2.default,
	          {
	            key: 'ellipsis',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2.default.createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      if (boundaryLinks) {
	        pageButtons.push(_react2.default.createElement(
	          _PaginationButton2.default,
	          (0, _extends3.default)({}, buttonProps, {
	            key: items,
	            eventKey: items,
	            active: false
	          }),
	          items
	        ));
	      }
	    }
	
	    return pageButtons;
	  };
	
	  Pagination.prototype.render = function render() {
	    var _props = this.props,
	        activePage = _props.activePage,
	        items = _props.items,
	        maxButtons = _props.maxButtons,
	        boundaryLinks = _props.boundaryLinks,
	        ellipsis = _props.ellipsis,
	        first = _props.first,
	        last = _props.last,
	        prev = _props.prev,
	        next = _props.next,
	        onSelect = _props.onSelect,
	        buttonComponentClass = _props.buttonComponentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['activePage', 'items', 'maxButtons', 'boundaryLinks', 'ellipsis', 'first', 'last', 'prev', 'next', 'onSelect', 'buttonComponentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var buttonProps = {
	      onSelect: onSelect,
	      componentClass: buttonComponentClass
	    };
	
	    return _react2.default.createElement(
	      'ul',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      first && _react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          eventKey: 1,
	          disabled: activePage === 1
	        }),
	        _react2.default.createElement(
	          'span',
	          { 'aria-label': 'First' },
	          first === true ? '\xAB' : first
	        )
	      ),
	      prev && _react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          eventKey: activePage - 1,
	          disabled: activePage === 1
	        }),
	        _react2.default.createElement(
	          'span',
	          { 'aria-label': 'Previous' },
	          prev === true ? '\u2039' : prev
	        )
	      ),
	      this.renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps),
	      next && _react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          eventKey: activePage + 1,
	          disabled: activePage >= items
	        }),
	        _react2.default.createElement(
	          'span',
	          { 'aria-label': 'Next' },
	          next === true ? '\u203A' : next
	        )
	      ),
	      last && _react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          eventKey: items,
	          disabled: activePage >= items
	        }),
	        _react2.default.createElement(
	          'span',
	          { 'aria-label': 'Last' },
	          last === true ? '\xBB' : last
	        )
	      )
	    );
	  };
	
	  return Pagination;
	}(_react2.default.Component);
	
	Pagination.propTypes = propTypes;
	Pagination.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('pagination', Pagination);
	module.exports = exports['default'];

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(223);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(503);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _StyleConfig = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  collapsible: _propTypes2.default.bool,
	  onSelect: _propTypes2.default.func,
	  header: _propTypes2.default.node,
	  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  footer: _propTypes2.default.node,
	  defaultExpanded: _propTypes2.default.bool,
	  expanded: _propTypes2.default.bool,
	  eventKey: _propTypes2.default.any,
	  headerRole: _propTypes2.default.string,
	  panelRole: _propTypes2.default.string,
	
	  // From Collapse.
	  onEnter: _propTypes2.default.func,
	  onEntering: _propTypes2.default.func,
	  onEntered: _propTypes2.default.func,
	  onExit: _propTypes2.default.func,
	  onExiting: _propTypes2.default.func,
	  onExited: _propTypes2.default.func
	};
	
	var defaultProps = {
	  defaultExpanded: false
	};
	
	var Panel = function (_React$Component) {
	  (0, _inherits3.default)(Panel, _React$Component);
	
	  function Panel(props, context) {
	    (0, _classCallCheck3.default)(this, Panel);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClickTitle = _this.handleClickTitle.bind(_this);
	
	    _this.state = {
	      expanded: _this.props.defaultExpanded
	    };
	    return _this;
	  }
	
	  Panel.prototype.handleClickTitle = function handleClickTitle(e) {
	    // FIXME: What the heck? This API is horrible. This needs to go away!
	    e.persist();
	    e.selected = true;
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, e);
	    } else {
	      e.preventDefault();
	    }
	
	    if (e.selected) {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  };
	
	  Panel.prototype.renderAnchor = function renderAnchor(header, id, role, expanded) {
	    return _react2.default.createElement(
	      'a',
	      {
	        role: role,
	        href: id && '#' + id,
	        onClick: this.handleClickTitle,
	        'aria-controls': id,
	        'aria-expanded': expanded,
	        'aria-selected': expanded,
	        className: expanded ? null : 'collapsed'
	      },
	      header
	    );
	  };
	
	  Panel.prototype.renderBody = function renderBody(rawChildren, bsProps) {
	    var children = [];
	    var bodyChildren = [];
	
	    var bodyClassName = (0, _bootstrapUtils.prefix)(bsProps, 'body');
	
	    function maybeAddBody() {
	      if (!bodyChildren.length) {
	        return;
	      }
	
	      // Derive the key from the index here, since we need to make one up.
	      children.push(_react2.default.createElement(
	        'div',
	        { key: children.length, className: bodyClassName },
	        bodyChildren
	      ));
	
	      bodyChildren = [];
	    }
	
	    // Convert to array so we can re-use keys.
	    _react2.default.Children.toArray(rawChildren).forEach(function (child) {
	      if (_react2.default.isValidElement(child) && child.props.fill) {
	        maybeAddBody();
	
	        // Remove the child's unknown `fill` prop.
	        children.push((0, _react.cloneElement)(child, { fill: undefined }));
	
	        return;
	      }
	
	      bodyChildren.push(child);
	    });
	
	    maybeAddBody();
	
	    return children;
	  };
	
	  Panel.prototype.renderCollapsibleBody = function renderCollapsibleBody(id, expanded, role, children, bsProps, animationHooks) {
	    return _react2.default.createElement(
	      _Collapse2.default,
	      (0, _extends3.default)({ 'in': expanded }, animationHooks),
	      _react2.default.createElement(
	        'div',
	        {
	          id: id,
	          role: role,
	          className: (0, _bootstrapUtils.prefix)(bsProps, 'collapse'),
	          'aria-hidden': !expanded
	        },
	        this.renderBody(children, bsProps)
	      )
	    );
	  };
	
	  Panel.prototype.renderHeader = function renderHeader(collapsible, header, id, role, expanded, bsProps) {
	    var titleClassName = (0, _bootstrapUtils.prefix)(bsProps, 'title');
	
	    if (!collapsible) {
	      if (!_react2.default.isValidElement(header)) {
	        return header;
	      }
	
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2.default)(header.props.className, titleClassName)
	      });
	    }
	
	    if (!_react2.default.isValidElement(header)) {
	      return _react2.default.createElement(
	        'h4',
	        { role: 'presentation', className: titleClassName },
	        this.renderAnchor(header, id, role, expanded)
	      );
	    }
	
	    return (0, _react.cloneElement)(header, {
	      className: (0, _classnames2.default)(header.props.className, titleClassName),
	      children: this.renderAnchor(header.props.children, id, role, expanded)
	    });
	  };
	
	  Panel.prototype.render = function render() {
	    var _props = this.props,
	        collapsible = _props.collapsible,
	        header = _props.header,
	        id = _props.id,
	        footer = _props.footer,
	        propsExpanded = _props.expanded,
	        headerRole = _props.headerRole,
	        panelRole = _props.panelRole,
	        className = _props.className,
	        children = _props.children,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3.default)(_props, ['collapsible', 'header', 'id', 'footer', 'expanded', 'headerRole', 'panelRole', 'className', 'children', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultExpanded', 'eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes),
	        id: collapsible ? null : id
	      }),
	      header && _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'heading') },
	        this.renderHeader(collapsible, header, id, headerRole, expanded, bsProps)
	      ),
	      collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, bsProps, { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }) : this.renderBody(children, bsProps),
	      footer && _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'footer') },
	        footer
	      )
	    );
	  };
	
	  return Panel;
	}(_react2.default.Component);
	
	Panel.propTypes = propTypes;
	Panel.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('panel', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2.default)(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Panel));
	module.exports = exports['default'];

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(370);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * Sets the direction the Popover is positioned towards.
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Popover.
	   */
	  positionTop: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The "left" position value for the Popover.
	   */
	  positionLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * The "top" position value for the Popover arrow.
	   */
	  arrowOffsetTop: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The "left" position value for the Popover arrow.
	   */
	  arrowOffsetLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Title content
	   */
	  title: _propTypes2.default.node
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Popover = function (_React$Component) {
	  (0, _inherits3.default)(Popover, _React$Component);
	
	  function Popover() {
	    (0, _classCallCheck3.default)(this, Popover);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Popover.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        title = _props.title,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4.default)({
	      display: 'block',
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2.default)(className, classes),
	        style: outerStyle
	      }),
	      _react2.default.createElement('div', { className: 'arrow', style: arrowStyle }),
	      title && _react2.default.createElement(
	        'h3',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'title') },
	        title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'content') },
	        children
	      )
	    );
	  };
	
	  return Popover;
	}(_react2.default.Component);
	
	Popover.propTypes = propTypes;
	Popover.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('popover', Popover);
	module.exports = exports['default'];

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(223);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _StyleConfig = __webpack_require__(98);
	
	var _ValidComponentChildren = __webpack_require__(108);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROUND_PRECISION = 1000;
	
	/**
	 * Validate that children, if any, are instances of `<ProgressBar>`.
	 */
	function onlyProgressBar(props, propName, componentName) {
	  var children = props[propName];
	  if (!children) {
	    return null;
	  }
	
	  var error = null;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (error) {
	      return;
	    }
	
	    if (child.type === ProgressBar) {
	      // eslint-disable-line no-use-before-define
	      return;
	    }
	
	    var childIdentifier = _react2.default.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
	    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
	  });
	
	  return error;
	}
	
	var propTypes = {
	  min: _propTypes2.default.number,
	  now: _propTypes2.default.number,
	  max: _propTypes2.default.number,
	  label: _propTypes2.default.node,
	  srOnly: _propTypes2.default.bool,
	  striped: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  children: onlyProgressBar,
	
	  /**
	   * @private
	   */
	  isChild: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	};
	
	function getPercentage(now, min, max) {
	  var percentage = (now - min) / (max - min) * 100;
	  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
	}
	
	var ProgressBar = function (_React$Component) {
	  (0, _inherits3.default)(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    (0, _classCallCheck3.default)(this, ProgressBar);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
	    var _extends2;
	
	    var min = _ref.min,
	        now = _ref.now,
	        max = _ref.max,
	        label = _ref.label,
	        srOnly = _ref.srOnly,
	        striped = _ref.striped,
	        active = _ref.active,
	        className = _ref.className,
	        style = _ref.style,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = active || striped, _extends2));
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        role: 'progressbar',
	        className: (0, _classnames2.default)(className, classes),
	        style: (0, _extends4.default)({ width: getPercentage(now, min, max) + '%' }, style),
	        'aria-valuenow': now,
	        'aria-valuemin': min,
	        'aria-valuemax': max
	      }),
	      srOnly ? _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      ) : label
	    );
	  };
	
	  ProgressBar.prototype.render = function render() {
	    var _props = this.props,
	        isChild = _props.isChild,
	        props = (0, _objectWithoutProperties3.default)(_props, ['isChild']);
	
	
	    if (isChild) {
	      return this.renderProgressBar(props);
	    }
	
	    var min = props.min,
	        now = props.now,
	        max = props.max,
	        label = props.label,
	        srOnly = props.srOnly,
	        striped = props.striped,
	        active = props.active,
	        bsClass = props.bsClass,
	        bsStyle = props.bsStyle,
	        className = props.className,
	        children = props.children,
	        wrapperProps = (0, _objectWithoutProperties3.default)(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);
	
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, wrapperProps, {
	        className: (0, _classnames2.default)(className, 'progress')
	      }),
	      children ? _ValidComponentChildren2.default.map(children, function (child) {
	        return (0, _react.cloneElement)(child, { isChild: true });
	      }) : this.renderProgressBar({
	        min: min, now: now, max: max, label: label, srOnly: srOnly, striped: striped, active: active, bsClass: bsClass, bsStyle: bsStyle
	      })
	    );
	  };
	
	  return ProgressBar;
	}(_react2.default.Component);
	
	ProgressBar.propTypes = propTypes;
	ProgressBar.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('progress-bar', (0, _bootstrapUtils.bsStyles)((0, _values2.default)(_StyleConfig.State), ProgressBar));
	module.exports = exports['default'];

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  inline: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2.default.oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Radio inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2.default.func
	}; /* eslint-disable jsx-a11y/label-has-for */
	
	var defaultProps = {
	  inline: false,
	  disabled: false,
	  title: ''
	};
	
	var Radio = function (_React$Component) {
	  (0, _inherits3.default)(Radio, _React$Component);
	
	  function Radio() {
	    (0, _classCallCheck3.default)(this, Radio);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Radio.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2.default.createElement('input', (0, _extends3.default)({}, elementProps, {
	      ref: inputRef,
	      type: 'radio',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2.default)(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2.default.createElement(
	        'label',
	        { className: (0, _classnames2.default)(className, _classes), style: style, title: title },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(className, classes), style: style },
	      _react2.default.createElement(
	        'label',
	        { title: title },
	        input,
	        children
	      )
	    );
	  };
	
	  return Radio;
	}(_react2.default.Component);
	
	Radio.propTypes = propTypes;
	Radio.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('radio', Radio);
	module.exports = exports['default'];

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: This should probably take a single `aspectRatio` prop.
	
	var propTypes = {
	  /**
	   * This component requires a single child element
	   */
	  children: _propTypes2.default.element.isRequired,
	  /**
	   * 16by9 aspect ratio
	   */
	  a16by9: _propTypes2.default.bool,
	  /**
	   * 4by3 aspect ratio
	   */
	  a4by3: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  a16by9: false,
	  a4by3: false
	};
	
	var ResponsiveEmbed = function (_React$Component) {
	  (0, _inherits3.default)(ResponsiveEmbed, _React$Component);
	
	  function ResponsiveEmbed() {
	    (0, _classCallCheck3.default)(this, ResponsiveEmbed);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ResponsiveEmbed.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        a16by9 = _props.a16by9,
	        a4by3 = _props.a4by3,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['a16by9', 'a4by3', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2.default)(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
	     false ? (0, _warning2.default)(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '16by9')] = a16by9, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '4by3')] = a4by3, _extends2));
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(classes) },
	      (0, _react.cloneElement)(children, (0, _extends4.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'item'))
	      }))
	    );
	  };
	
	  return ResponsiveEmbed;
	}(_react2.default.Component);
	
	ResponsiveEmbed.propTypes = propTypes;
	ResponsiveEmbed.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('embed-responsive', ResponsiveEmbed);
	module.exports = exports['default'];

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Row = function (_React$Component) {
	  (0, _inherits3.default)(Row, _React$Component);
	
	  function Row() {
	    (0, _classCallCheck3.default)(this, Row);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Row.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Row;
	}(_react2.default.Component);
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('row', Row);
	module.exports = exports['default'];

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(292);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dropdown = __webpack_require__(364);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SplitToggle = __webpack_require__(1701);
	
	var _SplitToggle2 = _interopRequireDefault(_SplitToggle);
	
	var _splitComponentProps2 = __webpack_require__(367);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Dropdown2.default.propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2.default.string,
	  bsSize: _propTypes2.default.string,
	  href: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  /**
	   * The content of the split button.
	   */
	  title: _propTypes2.default.node.isRequired,
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _propTypes2.default.string,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2.default.node
	});
	
	var SplitButton = function (_React$Component) {
	  (0, _inherits3.default)(SplitButton, _React$Component);
	
	  function SplitButton() {
	    (0, _classCallCheck3.default)(this, SplitButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        toggleLabel = _props.toggleLabel,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3.default)(props, _Dropdown2.default.ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        buttonProps = _splitComponentProps[1];
	
	    return _react2.default.createElement(
	      _Dropdown2.default,
	      (0, _extends3.default)({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2.default.createElement(
	        _Button2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          disabled: props.disabled,
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2.default.createElement(_SplitToggle2.default, {
	        'aria-label': toggleLabel || title,
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2.default.createElement(
	        _Dropdown2.default.Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return SplitButton;
	}(_react2.default.Component);
	
	SplitButton.propTypes = propTypes;
	
	SplitButton.Toggle = _SplitToggle2.default;
	
	exports.default = SplitButton;
	module.exports = exports['default'];

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownToggle = __webpack_require__(795);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SplitToggle = function (_React$Component) {
	  (0, _inherits3.default)(SplitToggle, _React$Component);
	
	  function SplitToggle() {
	    (0, _classCallCheck3.default)(this, SplitToggle);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitToggle.prototype.render = function render() {
	    return _react2.default.createElement(_DropdownToggle2.default, (0, _extends3.default)({}, this.props, {
	      useAnchor: false,
	      noCaret: false
	    }));
	  };
	
	  return SplitToggle;
	}(_react2.default.Component);
	
	SplitToggle.defaultProps = _DropdownToggle2.default.defaultProps;
	
	exports.default = SplitToggle;
	module.exports = exports['default'];

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TabContainer = __webpack_require__(505);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(506);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _TabPane = __webpack_require__(809);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _TabPane2.default.propTypes, {
	
	  disabled: _propTypes2.default.bool,
	
	  title: _propTypes2.default.node,
	
	  /**
	   * tabClassName is used as className for the associated NavItem
	   */
	  tabClassName: _propTypes2.default.string
	});
	
	var Tab = function (_React$Component) {
	  (0, _inherits3.default)(Tab, _React$Component);
	
	  function Tab() {
	    (0, _classCallCheck3.default)(this, Tab);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Tab.prototype.render = function render() {
	    var props = (0, _extends3.default)({}, this.props);
	
	    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
	    delete props.title;
	    delete props.disabled;
	    delete props.tabClassName;
	
	    return _react2.default.createElement(_TabPane2.default, props);
	  };
	
	  return Tab;
	}(_react2.default.Component);
	
	Tab.propTypes = propTypes;
	
	Tab.Container = _TabContainer2.default;
	Tab.Content = _TabContent2.default;
	Tab.Pane = _TabPane2.default;
	
	exports.default = Tab;
	module.exports = exports['default'];

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  striped: _propTypes2.default.bool,
	  bordered: _propTypes2.default.bool,
	  condensed: _propTypes2.default.bool,
	  hover: _propTypes2.default.bool,
	  responsive: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  bordered: false,
	  condensed: false,
	  hover: false,
	  responsive: false,
	  striped: false
	};
	
	var Table = function (_React$Component) {
	  (0, _inherits3.default)(Table, _React$Component);
	
	  function Table() {
	    (0, _classCallCheck3.default)(this, Table);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Table.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        striped = _props.striped,
	        bordered = _props.bordered,
	        condensed = _props.condensed,
	        hover = _props.hover,
	        responsive = _props.responsive,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = striped, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'bordered')] = bordered, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'condensed')] = condensed, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'hover')] = hover, _extends2));
	
	    var table = _react2.default.createElement('table', (0, _extends4.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	
	    if (responsive) {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'responsive') },
	        table
	      );
	    }
	
	    return table;
	  };
	
	  return Table;
	}(_react2.default.Component);
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('table', Table);
	module.exports = exports['default'];

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(370);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(221);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Nav = __webpack_require__(802);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__(803);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _TabContainer = __webpack_require__(505);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(506);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _ValidComponentChildren = __webpack_require__(108);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabContainer = _TabContainer2.default.ControlledComponent;
	
	var propTypes = {
	  /**
	   * Mark the Tab with a matching `eventKey` as active.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2.default.any,
	
	  /**
	   * Navigation style
	   */
	  bsStyle: _propTypes2.default.oneOf(['tabs', 'pills']),
	
	  animation: _propTypes2.default.bool,
	
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * Callback fired when a Tab is selected.
	   *
	   * ```js
	   * function (
	   *   Any eventKey,
	   *   SyntheticEvent event?
	   * )
	   * ```
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  bsStyle: 'tabs',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	function getDefaultActiveKey(children) {
	  var defaultActiveKey = void 0;
	  _ValidComponentChildren2.default.forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3.default)(Tabs, _React$Component);
	
	  function Tabs() {
	    (0, _classCallCheck3.default)(this, Tabs);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Tabs.prototype.renderTab = function renderTab(child) {
	    var _child$props = child.props,
	        title = _child$props.title,
	        eventKey = _child$props.eventKey,
	        disabled = _child$props.disabled,
	        tabClassName = _child$props.tabClassName;
	
	    if (title == null) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      _NavItem2.default,
	      {
	        eventKey: eventKey,
	        disabled: disabled,
	        className: tabClassName
	      },
	      title
	    );
	  };
	
	  Tabs.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        onSelect = _props.onSelect,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        _props$activeKey = _props.activeKey,
	        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
	        props = (0, _objectWithoutProperties3.default)(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);
	
	
	    return _react2.default.createElement(
	      TabContainer,
	      {
	        id: id,
	        activeKey: activeKey,
	        onSelect: onSelect,
	        className: className,
	        style: style
	      },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Nav2.default,
	          (0, _extends3.default)({}, props, {
	            role: 'tablist'
	          }),
	          _ValidComponentChildren2.default.map(children, this.renderTab)
	        ),
	        _react2.default.createElement(
	          _TabContent2.default,
	          {
	            bsClass: bsClass,
	            animation: animation,
	            mountOnEnter: mountOnEnter,
	            unmountOnExit: unmountOnExit
	          },
	          children
	        )
	      )
	    );
	  };
	
	  return Tabs;
	}(_react2.default.Component);
	
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('tab', Tabs);
	
	exports.default = (0, _uncontrollable2.default)(Tabs, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(154);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * src property that is passed down to the image inside this component
	   */
	  src: _propTypes2.default.string,
	  /**
	   * alt property that is passed down to the image inside this component
	   */
	  alt: _propTypes2.default.string,
	  /**
	   * href property that is passed down to the image inside this component
	   */
	  href: _propTypes2.default.string,
	  /**
	   * onError callback that is passed down to the image inside this component
	   */
	  onError: _propTypes2.default.func,
	  /**
	   * onLoad callback that is passed down to the image inside this component
	   */
	  onLoad: _propTypes2.default.func
	}; /* eslint-disable jsx-a11y/alt-text */
	
	var Thumbnail = function (_React$Component) {
	  (0, _inherits3.default)(Thumbnail, _React$Component);
	
	  function Thumbnail() {
	    (0, _classCallCheck3.default)(this, Thumbnail);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Thumbnail.prototype.render = function render() {
	    var _props = this.props,
	        src = _props.src,
	        alt = _props.alt,
	        onError = _props.onError,
	        onLoad = _props.onLoad,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['src', 'alt', 'onError', 'onLoad', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var Component = elementProps.href ? _SafeAnchor2.default : 'div';
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _react2.default.createElement('img', { src: src, alt: alt, onError: onError, onLoad: onLoad }),
	      children && _react2.default.createElement(
	        'div',
	        { className: 'caption' },
	        children
	      )
	    );
	  };
	
	  return Thumbnail;
	}(_react2.default.Component);
	
	Thumbnail.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('thumbnail', Thumbnail);
	module.exports = exports['default'];

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _uncontrollable = __webpack_require__(221);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _createChainedFunction = __webpack_require__(90);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(108);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	var _ButtonGroup = __webpack_require__(501);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _ToggleButton = __webpack_require__(810);
	
	var _ToggleButton2 = _interopRequireDefault(_ToggleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * An HTML `<input>` name for each child button.
	   *
	   * __Required if `type` is set to `'radio'`__
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * The value, or array of values, of the active (pressed) buttons
	   *
	   * @controllable onChange
	   */
	  value: _propTypes2.default.any,
	
	  /**
	   * Callback fired when a button is pressed, depending on whether the `type`
	   * is `'radio'` or `'checkbox'`, `onChange` will be called with the value or
	   * array of active values
	   *
	   * @controllable values
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * The input `type` of the rendered buttons, determines the toggle behavior
	   * of the buttons
	   */
	  type: _propTypes2.default.oneOf(['checkbox', 'radio']).isRequired
	};
	
	var defaultProps = {
	  type: 'radio'
	};
	
	var ToggleButtonGroup = function (_React$Component) {
	  (0, _inherits3.default)(ToggleButtonGroup, _React$Component);
	
	  function ToggleButtonGroup() {
	    (0, _classCallCheck3.default)(this, ToggleButtonGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ToggleButtonGroup.prototype.getValues = function getValues() {
	    var value = this.props.value;
	
	    return value == null ? [] : [].concat(value);
	  };
	
	  ToggleButtonGroup.prototype.handleToggle = function handleToggle(value) {
	    var _props = this.props,
	        type = _props.type,
	        onChange = _props.onChange;
	
	    var values = this.getValues();
	    var isActive = values.indexOf(value) !== -1;
	
	    if (type === 'radio') {
	      if (!isActive) {
	        onChange(value);
	      }
	      return;
	    }
	
	    if (isActive) {
	      onChange(values.filter(function (n) {
	        return n !== value;
	      }));
	    } else {
	      onChange([].concat(values, [value]));
	    }
	  };
	
	  ToggleButtonGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props2 = this.props,
	        children = _props2.children,
	        type = _props2.type,
	        name = _props2.name,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['children', 'type', 'name']);
	
	
	    var values = this.getValues();
	
	    !(type !== 'radio' || !!name) ?  false ? (0, _invariant2.default)(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : (0, _invariant2.default)(false) : void 0;
	
	    delete props.onChange;
	    delete props.value;
	
	    // the data attribute is required b/c twbs css uses it in the selector
	    return _react2.default.createElement(
	      _ButtonGroup2.default,
	      (0, _extends3.default)({}, props, { 'data-toggle': 'buttons' }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        var _child$props = child.props,
	            value = _child$props.value,
	            onChange = _child$props.onChange;
	
	        var handler = function handler() {
	          return _this2.handleToggle(value);
	        };
	
	        return _react2.default.cloneElement(child, {
	          type: type,
	          name: child.name || name,
	          checked: values.indexOf(value) !== -1,
	          onChange: (0, _createChainedFunction2.default)(onChange, handler)
	        });
	      })
	    );
	  };
	
	  return ToggleButtonGroup;
	}(_react2.default.Component);
	
	ToggleButtonGroup.propTypes = propTypes;
	ToggleButtonGroup.defaultProps = defaultProps;
	
	var UncontrolledToggleButtonGroup = (0, _uncontrollable2.default)(ToggleButtonGroup, {
	  value: 'onChange'
	});
	
	UncontrolledToggleButtonGroup.Button = _ToggleButton2.default;
	
	exports.default = UncontrolledToggleButtonGroup;
	module.exports = exports['default'];

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(370);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * Sets the direction the Tooltip is positioned towards.
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Tooltip.
	   */
	  positionTop: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The "left" position value for the Tooltip.
	   */
	  positionLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * The "top" position value for the Tooltip arrow.
	   */
	  arrowOffsetTop: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The "left" position value for the Tooltip arrow.
	   */
	  arrowOffsetLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Tooltip = function (_React$Component) {
	  (0, _inherits3.default)(Tooltip, _React$Component);
	
	  function Tooltip() {
	    (0, _classCallCheck3.default)(this, Tooltip);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Tooltip.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4.default)({
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2.default)(className, classes),
	        style: outerStyle
	      }),
	      _react2.default.createElement('div', { className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'), style: arrowStyle }),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        children
	      )
	    );
	  };
	
	  return Tooltip;
	}(_react2.default.Component);
	
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);
	module.exports = exports['default'];

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(25);
	
	var _StyleConfig = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Well = function (_React$Component) {
	  (0, _inherits3.default)(Well, _React$Component);
	
	  function Well() {
	    (0, _classCallCheck3.default)(this, Well);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Well.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Well;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('well', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Well));
	module.exports = exports['default'];

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.requiredRoles = requiredRoles;
	exports.exclusiveRoles = exclusiveRoles;
	
	var _createChainableTypeChecker = __webpack_require__(371);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	var _ValidComponentChildren = __webpack_require__(108);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function requiredRoles() {
	  for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
	    roles[_key] = arguments[_key];
	  }
	
	  return (0, _createChainableTypeChecker2.default)(function (props, propName, component) {
	    var missing = void 0;
	
	    roles.every(function (role) {
	      if (!_ValidComponentChildren2.default.some(props.children, function (child) {
	        return child.props.bsRole === role;
	      })) {
	        missing = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (missing) {
	      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}
	
	function exclusiveRoles() {
	  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    roles[_key2] = arguments[_key2];
	  }
	
	  return (0, _createChainableTypeChecker2.default)(function (props, propName, component) {
	    var duplicate = void 0;
	
	    roles.every(function (role) {
	      var childrenWithRole = _ValidComponentChildren2.default.filter(props.children, function (child) {
	        return child.props.bsRole === role;
	      });
	
	      if (childrenWithRole.length > 1) {
	        duplicate = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (duplicate) {
	      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}

/***/ }),
/* 1710 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This file contains a modified version of:
	 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
	 *
	 * This source code is licensed under the BSD-style license found here:
	 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
	 * An additional grant of patent rights can be found here:
	 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
	 */
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    // eslint-disable-line guard-for-in
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      // eslint-disable-line guard-for-in
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports.default = ReactTransitionEvents;
	module.exports = exports['default'];

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(224);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function deprecationWarning(oldname, newname, link) {
	  var message = void 0;
	
	  if ((typeof oldname === 'undefined' ? 'undefined' : (0, _typeof3.default)(oldname)) === 'object') {
	    message = oldname.message;
	  } else {
	    message = oldname + ' is deprecated. Use ' + newname + ' instead.';
	
	    if (link) {
	      message += '\nYou can read more about it at ' + link;
	    }
	  }
	
	  if (warned[message]) {
	    return;
	  }
	
	   false ? (0, _warning2.default)(false, message) : void 0;
	  warned[message] = true;
	}
	
	deprecationWarning.wrapper = function (Component) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return function (_Component) {
	    (0, _inherits3.default)(DeprecatedComponent, _Component);
	
	    function DeprecatedComponent() {
	      (0, _classCallCheck3.default)(this, DeprecatedComponent);
	      return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
	    }
	
	    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
	      deprecationWarning.apply(undefined, args);
	
	      if (_Component.prototype.componentWillMount) {
	        var _Component$prototype$;
	
	        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          methodArgs[_key2] = arguments[_key2];
	        }
	
	        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
	      }
	    };
	
	    return DeprecatedComponent;
	  }(Component);
	};
	
	exports.default = deprecationWarning;
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ValidComponentChildren = exports.createChainedFunction = exports.bootstrapUtils = undefined;
	
	var _bootstrapUtils2 = __webpack_require__(25);
	
	var _bootstrapUtils = _interopRequireWildcard(_bootstrapUtils2);
	
	var _createChainedFunction2 = __webpack_require__(90);
	
	var _createChainedFunction3 = _interopRequireDefault(_createChainedFunction2);
	
	var _ValidComponentChildren2 = __webpack_require__(108);
	
	var _ValidComponentChildren3 = _interopRequireDefault(_ValidComponentChildren2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.bootstrapUtils = _bootstrapUtils;
	exports.createChainedFunction = _createChainedFunction3.default;
	exports.ValidComponentChildren = _ValidComponentChildren3.default;

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecated;
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	
	/* eslint-disable no-underscore-dangle */
	function _resetWarned() {
	  warned = {};
	}
	
	deprecated._resetWarned = _resetWarned;
	/* eslint-enable no-underscore-dangle */
	
	module.exports = exports['default'];

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(369);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(372);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(244);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
	      if (!_this._overlayTarget) {
	        _this._overlayTarget = document.createElement('div');
	        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
	        _this._portalContainerNode.appendChild(_this._overlayTarget);
	      }
	    }, _this._unmountOverlayTarget = function () {
	      if (_this._overlayTarget) {
	        _this._portalContainerNode.removeChild(_this._overlayTarget);
	        _this._overlayTarget = null;
	      }
	      _this._portalContainerNode = null;
	    }, _this._renderOverlay = function () {
	      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);
	
	      // Save reference for future access.
	      if (overlay !== null) {
	        _this._mountOverlayTarget();
	
	        var initialRender = !_this._overlayInstance;
	
	        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
	          if (initialRender && _this.props.onRendered) {
	            _this.props.onRendered();
	          }
	        });
	      } else {
	        // Unrender if the component is null for transitions to null
	        _this._unrenderOverlay();
	        _this._unmountOverlayTarget();
	      }
	    }, _this._unrenderOverlay = function () {
	      if (_this._overlayTarget) {
	        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
	        _this._overlayInstance = null;
	      }
	    }, _this.getMountNode = function () {
	      return _this._overlayTarget;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  };
	
	  Portal.prototype.render = function render() {
	    return null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = Portal;
	module.exports = exports['default'];

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _activeElement = __webpack_require__(633);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(234);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _inDOM = __webpack_require__(182);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(369);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _deprecated = __webpack_require__(1713);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(70);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ModalManager = __webpack_require__(1716);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _Portal = __webpack_require__(812);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _RefHolder = __webpack_require__(1719);
	
	var _RefHolder2 = _interopRequireDefault(_RefHolder);
	
	var _addEventListener = __webpack_require__(815);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(1720);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _getContainer = __webpack_require__(372);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(244);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	
	var Modal = function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  function Modal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Modal.prototype.omitProps = function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  };
	
	  Modal.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        dialogTransitionTimeout = _props.dialogTransitionTimeout,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container,
	        onRendered: this.onPortalRendered
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: this.setModalNodeRef,
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        _react2.default.createElement(
	          _RefHolder2.default,
	          { ref: this.setDialogRef },
	          dialog
	        )
	      )
	    );
	  };
	
	  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  };
	
	  Modal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    if (this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _props2 = this.props,
	        show = _props2.show,
	        transition = _props2.transition;
	
	
	    this._isMounted = false;
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  };
	
	  Modal.prototype.autoFocus = function autoFocus() {
	    if (!this.props.autoFocus) {
	      return;
	    }
	
	    var dialogElement = this.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      this.lastFocus = currentActiveElement;
	
	      if (!dialogElement.hasAttribute('tabIndex')) {
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');
	
	        dialogElement.setAttribute('tabIndex', -1);
	      }
	
	      dialogElement.focus();
	    }
	  };
	
	  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  };
	
	  Modal.prototype.getDialogElement = function getDialogElement() {
	    return _reactDom2.default.findDOMNode(this.dialog);
	  };
	
	  Modal.prototype.isTopModal = function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = _extends({}, _Portal2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Modal
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	   *
	   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	   * page content can be placed behind a virtual backdrop as well as a visual one.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * A callback fired when the Modal is opening.
	   */
	  onShow: _propTypes2.default.func,
	
	  /**
	   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	   *
	   * The `onHide` callback only signals intent from the Modal,
	   * you must actually set the `show` prop to `false` for the Modal to close.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Include a backdrop component.
	   */
	  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),
	
	  /**
	   * A function that returns a backdrop component. Useful for custom
	   * backdrop rendering.
	   *
	   * ```js
	   *  renderBackdrop={props => <MyBackdrop {...props} />}
	   * ```
	   */
	  renderBackdrop: _propTypes2.default.func,
	
	  /**
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   */
	  onEscapeKeyDown: _propTypes2.default.func,
	
	  /**
	   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   * @deprecated
	   */
	  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),
	
	  /**
	   * A callback fired when the backdrop, if specified, is clicked.
	   */
	  onBackdropClick: _propTypes2.default.func,
	
	  /**
	   * A style object for the backdrop component.
	   */
	  backdropStyle: _propTypes2.default.object,
	
	  /**
	   * A css class or classes for the backdrop component.
	   */
	  backdropClassName: _propTypes2.default.string,
	
	  /**
	   * A css class or set of classes applied to the modal container when the modal is open,
	   * and removed when it is closed.
	   */
	  containerClassName: _propTypes2.default.string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2.default.bool,
	
	  /**
	   * A `<Transition/>` component to use for the dialog and backdrop components.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * The `timeout` of the dialog transition if specified. This number is used to ensure that
	   * transition callbacks are always fired, even if browser transition events are canceled.
	   *
	   * See the Transition `timeout` prop for more infomation.
	   */
	  dialogTransitionTimeout: _propTypes2.default.number,
	
	  /**
	   * The `timeout` of the backdrop transition if specified. This number is used to
	   * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	   *
	   * See the Transition `timeout` prop for more infomation.
	   */
	  backdropTransitionTimeout: _propTypes2.default.number,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes. This also
	   * works correctly with any Modal children that have the `autoFocus` prop.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  autoFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while open.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  enforceFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2.default.bool,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * A ModalManager instance used to track and manage the state of open
	   * Modals. Useful when customizing how modals interact within a container
	   */
	  manager: _propTypes2.default.object.isRequired
	});
	Modal.defaultProps = {
	  show: false,
	  backdrop: true,
	  keyboard: true,
	  autoFocus: true,
	  enforceFocus: true,
	  restoreFocus: true,
	  onHide: function onHide() {},
	  manager: modalManager,
	  renderBackdrop: function renderBackdrop(props) {
	    return _react2.default.createElement('div', props);
	  }
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.state = { exited: !this.props.show };
	
	  this.renderBackdrop = function () {
	    var _props3 = _this2.props,
	        backdropStyle = _props3.backdropStyle,
	        backdropClassName = _props3.backdropClassName,
	        renderBackdrop = _props3.renderBackdrop,
	        Transition = _props3.transition,
	        backdropTransitionTimeout = _props3.backdropTransitionTimeout;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this2.backdrop = ref;
	    };
	
	    var backdrop = renderBackdrop({
	      ref: backdropRef,
	      style: backdropStyle,
	      className: backdropClassName,
	      onClick: _this2.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': _this2.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        backdrop
	      );
	    }
	
	    return backdrop;
	  };
	
	  this.onPortalRendered = function () {
	    _this2.autoFocus();
	
	    if (_this2.props.onShow) {
	      _this2.props.onShow();
	    }
	  };
	
	  this.onShow = function () {
	    var doc = (0, _ownerDocument2.default)(_this2);
	    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);
	
	    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);
	
	    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);
	
	    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);
	
	    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
	  };
	
	  this.onHide = function () {
	    _this2.props.manager.remove(_this2);
	
	    _this2._onDocumentKeydownListener.remove();
	
	    _this2._onDocumentKeyupListener.remove();
	
	    _this2._onFocusinListener.remove();
	
	    if (_this2.props.restoreFocus) {
	      _this2.restoreLastFocus();
	    }
	  };
	
	  this.setMountNode = function (ref) {
	    _this2.mountNode = ref ? ref.getMountNode() : ref;
	  };
	
	  this.setModalNodeRef = function (ref) {
	    _this2.modalNode = ref;
	  };
	
	  this.setDialogRef = function (ref) {
	    _this2.dialog = ref;
	  };
	
	  this.handleHidden = function () {
	    _this2.setState({ exited: true });
	    _this2.onHide();
	
	    if (_this2.props.onExited) {
	      var _props4;
	
	      (_props4 = _this2.props).onExited.apply(_props4, arguments);
	    }
	  };
	
	  this.handleBackdropClick = function (e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (_this2.props.onBackdropClick) {
	      _this2.props.onBackdropClick(e);
	    }
	
	    if (_this2.props.backdrop === true) {
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyDown = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyDown) {
	        _this2.props.onEscapeKeyDown(e);
	      }
	
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyUp = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyUp) {
	        _this2.props.onEscapeKeyUp(e);
	      }
	    }
	  };
	
	  this.checkForFocus = function () {
	    if (_inDOM2.default) {
	      _this2.lastFocus = (0, _activeElement2.default)();
	    }
	  };
	
	  this.enforceFocus = function () {
	    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
	      return;
	    }
	
	    var dialogElement = _this2.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      dialogElement.focus();
	    }
	  };
	};
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class = __webpack_require__(1172);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _style = __webpack_require__(331);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _scrollbarSize = __webpack_require__(641);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(816);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(1722);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function ModalManager() {
	  var _this = this;
	
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	      _ref2$handleContainer = _ref2.handleContainerOverflow,
	      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	  _classCallCheck(this, ModalManager);
	
	  this.add = function (modal, container, className) {
	    var modalIdx = _this.modals.indexOf(modal);
	    var containerIdx = _this.containers.indexOf(container);
	
	    if (modalIdx !== -1) {
	      return modalIdx;
	    }
	
	    modalIdx = _this.modals.length;
	    _this.modals.push(modal);
	
	    if (_this.hideSiblingNodes) {
	      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	    }
	
	    if (containerIdx !== -1) {
	      _this.data[containerIdx].modals.push(modal);
	      return modalIdx;
	    }
	
	    var data = {
	      modals: [modal],
	      //right now only the first modal of a container will have its classes applied
	      classes: className ? className.split(/\s+/) : [],
	
	      overflowing: (0, _isOverflowing2.default)(container)
	    };
	
	    if (_this.handleContainerOverflow) {
	      setContainerStyle(data, container);
	    }
	
	    data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	    _this.containers.push(container);
	    _this.data.push(data);
	
	    return modalIdx;
	  };
	
	  this.remove = function (modal) {
	    var modalIdx = _this.modals.indexOf(modal);
	
	    if (modalIdx === -1) {
	      return;
	    }
	
	    var containerIdx = findContainer(_this.data, modal);
	    var data = _this.data[containerIdx];
	    var container = _this.containers[containerIdx];
	
	    data.modals.splice(data.modals.indexOf(modal), 1);
	
	    _this.modals.splice(modalIdx, 1);
	
	    // if that was the last modal in a container,
	    // clean up the container
	    if (data.modals.length === 0) {
	      data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	      if (_this.handleContainerOverflow) {
	        removeContainerStyle(data, container);
	      }
	
	      if (_this.hideSiblingNodes) {
	        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	      }
	      _this.containers.splice(containerIdx, 1);
	      _this.data.splice(containerIdx, 1);
	    } else if (_this.hideSiblingNodes) {
	      //otherwise make sure the next top modal is visible to a SR
	      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	    }
	  };
	
	  this.isTopModal = function (modal) {
	    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
	  };
	
	  this.hideSiblingNodes = hideSiblingNodes;
	  this.handleContainerOverflow = handleContainerOverflow;
	  this.modals = [];
	  this.containers = [];
	  this.data = [];
	};
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(69);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(812);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(1718);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(813);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleHidden = function () {
	      _this.setState({ exited: true });
	
	      if (_this.props.onExited) {
	        var _this$props;
	
	        (_this$props = _this.props).onExited.apply(_this$props, arguments);
	      }
	    };
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        container = _props.container,
	        containerPadding = _props.containerPadding,
	        target = _props.target,
	        placement = _props.placement,
	        shouldUpdatePosition = _props.shouldUpdatePosition,
	        rootClose = _props.rootClose,
	        children = _props.children,
	        Transition = _props.transition,
	        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	    // Don't un-render the overlay while it's transitioning out.
	
	
	    var mountOverlay = props.show || Transition && !this.state.exited;
	    if (!mountOverlay) {
	      // Don't bother showing anything if we don't have to.
	      return null;
	    }
	
	    var child = children;
	
	    // Position is be inner-most because it adds inline styles into the child,
	    // which the other wrappers don't forward correctly.
	    child = _react2.default.createElement(
	      _Position2.default,
	      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	      child
	    );
	
	    if (Transition) {
	      var onExit = props.onExit,
	          onExiting = props.onExiting,
	          onEnter = props.onEnter,
	          onEntering = props.onEntering,
	          onEntered = props.onEntered;
	
	      // This animates the child node by injecting props, so it must precede
	      // anything that adds a wrapping div.
	
	      child = _react2.default.createElement(
	        Transition,
	        {
	          'in': props.show,
	          transitionAppear: true,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.onHiddenListener,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        child
	      );
	    }
	
	    // This goes after everything else because it adds a wrapping div.
	    if (rootClose) {
	      child = _react2.default.createElement(
	        _RootCloseWrapper2.default,
	        { onRootClose: props.onHide },
	        child
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      { container: container },
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2.default.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _propTypes2.default.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `<Transition/>` component used to animate the overlay changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2.default.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(369);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _calculatePosition = __webpack_require__(1721);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(372);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(244);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.getTarget = function () {
	      var target = _this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    };
	
	    _this.maybeUpdatePosition = function (placementChanged) {
	      var target = _this.getTarget();
	
	      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      _this.updatePosition(target);
	    };
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  Position.prototype.componentDidMount = function componentDidMount() {
	    this.updatePosition(this.getTarget());
	  };
	
	  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	    this._needsFlush = true;
	  };
	
	  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this._needsFlush) {
	      this._needsFlush = false;
	      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	    }
	  };
	
	  Position.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        props = _objectWithoutProperties(_props, ['children', 'className']);
	
	    var _state = this.state,
	        positionLeft = _state.positionLeft,
	        positionTop = _state.positionTop,
	        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	    // These should not be forwarded to the child.
	
	
	    delete props.target;
	    delete props.container;
	    delete props.containerPadding;
	    delete props.shouldUpdatePosition;
	
	    var child = _react2.default.Children.only(children);
	    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	      // and `props.style`.
	      positionLeft: positionLeft,
	      positionTop: positionTop,
	      className: (0, _classnames2.default)(className, child.props.className),
	      style: _extends({}, child.props.style, {
	        left: positionLeft,
	        top: positionTop
	      })
	    }));
	  };
	
	  Position.prototype.updatePosition = function updatePosition(target) {
	    this._lastTarget = target;
	
	    if (!target) {
	      this.setState({
	        positionLeft: 0,
	        positionTop: 0,
	        arrowOffsetLeft: null,
	        arrowOffsetTop: null
	      });
	
	      return;
	    }
	
	    var overlay = _reactDom2.default.findDOMNode(this);
	    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	  };
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _propTypes2.default.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _propTypes2.default.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  children: _propTypes2.default.node
	};
	
	/**
	 * Internal helper component to allow attaching a non-conflicting ref to a
	 * child element that may not accept refs.
	 */
	
	var RefHolder = function (_React$Component) {
	  _inherits(RefHolder, _React$Component);
	
	  function RefHolder() {
	    _classCallCheck(this, RefHolder);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  RefHolder.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RefHolder;
	}(_react2.default.Component);
	
	RefHolder.propTypes = propTypes;
	
	exports.default = RefHolder;
	module.exports = exports['default'];

/***/ }),
/* 1720 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(637);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(1177);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(638);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(244);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ }),
/* 1722 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _union = __webpack_require__(1486);
	
	var _union2 = _interopRequireDefault(_union);
	
	var _without = __webpack_require__(738);
	
	var _without2 = _interopRequireDefault(_without);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EnterLeaveCounter = function () {
		function EnterLeaveCounter() {
			_classCallCheck(this, EnterLeaveCounter);
	
			this.entered = [];
		}
	
		_createClass(EnterLeaveCounter, [{
			key: 'enter',
			value: function enter(enteringNode) {
				var previousLength = this.entered.length;
	
				var isNodeEntered = function isNodeEntered(node) {
					return document.documentElement.contains(node) && (!node.contains || node.contains(enteringNode));
				};
	
				this.entered = (0, _union2.default)(this.entered.filter(isNodeEntered), [enteringNode]);
	
				return previousLength === 0 && this.entered.length > 0;
			}
		}, {
			key: 'leave',
			value: function leave(leavingNode) {
				var previousLength = this.entered.length;
	
				this.entered = (0, _without2.default)(this.entered.filter(function (node) {
					return document.documentElement.contains(node);
				}), leavingNode);
	
				return previousLength > 0 && this.entered.length === 0;
			}
		}, {
			key: 'reset',
			value: function reset() {
				this.entered = [];
			}
		}]);
	
		return EnterLeaveCounter;
	}();
	
	exports.default = EnterLeaveCounter;

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable no-underscore-dangle */
	
	
	var _defaults = __webpack_require__(1467);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	var _shallowEqual = __webpack_require__(1730);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _EnterLeaveCounter = __webpack_require__(1723);
	
	var _EnterLeaveCounter2 = _interopRequireDefault(_EnterLeaveCounter);
	
	var _BrowserDetector = __webpack_require__(817);
	
	var _OffsetUtils = __webpack_require__(1727);
	
	var _NativeDragSources = __webpack_require__(1726);
	
	var _NativeTypes = __webpack_require__(507);
	
	var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HTML5Backend = function () {
		function HTML5Backend(manager) {
			_classCallCheck(this, HTML5Backend);
	
			this.actions = manager.getActions();
			this.monitor = manager.getMonitor();
			this.registry = manager.getRegistry();
			this.context = manager.getContext();
	
			this.sourcePreviewNodes = {};
			this.sourcePreviewNodeOptions = {};
			this.sourceNodes = {};
			this.sourceNodeOptions = {};
			this.enterLeaveCounter = new _EnterLeaveCounter2.default();
	
			this.dragStartSourceIds = [];
			this.dropTargetIds = [];
			this.dragEnterTargetIds = [];
			this.currentNativeSource = null;
			this.currentNativeHandle = null;
			this.currentDragSourceNode = null;
			this.currentDragSourceNodeOffset = null;
			this.currentDragSourceNodeOffsetChanged = false;
			this.altKeyPressed = false;
			this.mouseMoveTimeoutTimer = null;
	
			this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
			this.handleTopDragStart = this.handleTopDragStart.bind(this);
			this.handleTopDragStartCapture = this.handleTopDragStartCapture.bind(this);
			this.handleTopDragEndCapture = this.handleTopDragEndCapture.bind(this);
			this.handleTopDragEnter = this.handleTopDragEnter.bind(this);
			this.handleTopDragEnterCapture = this.handleTopDragEnterCapture.bind(this);
			this.handleTopDragLeaveCapture = this.handleTopDragLeaveCapture.bind(this);
			this.handleTopDragOver = this.handleTopDragOver.bind(this);
			this.handleTopDragOverCapture = this.handleTopDragOverCapture.bind(this);
			this.handleTopDrop = this.handleTopDrop.bind(this);
			this.handleTopDropCapture = this.handleTopDropCapture.bind(this);
			this.handleSelectStart = this.handleSelectStart.bind(this);
			this.endDragIfSourceWasRemovedFromDOM = this.endDragIfSourceWasRemovedFromDOM.bind(this);
			this.endDragNativeItem = this.endDragNativeItem.bind(this);
			this.asyncEndDragNativeItem = this.asyncEndDragNativeItem.bind(this);
			this.isNodeInDocument = this.isNodeInDocument.bind(this);
		}
	
		_createClass(HTML5Backend, [{
			key: 'setup',
			value: function setup() {
				if (this.window === undefined) {
					return;
				}
	
				if (this.window.__isReactDndBackendSetUp) {
					throw new Error('Cannot have two HTML5 backends at the same time.');
				}
				this.window.__isReactDndBackendSetUp = true;
				this.addEventListeners(this.window);
			}
		}, {
			key: 'teardown',
			value: function teardown() {
				if (this.window === undefined) {
					return;
				}
	
				this.window.__isReactDndBackendSetUp = false;
				this.removeEventListeners(this.window);
				this.clearCurrentDragSourceNode();
				if (this.asyncEndDragFrameId) {
					this.window.cancelAnimationFrame(this.asyncEndDragFrameId);
				}
			}
		}, {
			key: 'addEventListeners',
			value: function addEventListeners(target) {
				// SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
				if (!target.addEventListener) {
					return;
				}
				target.addEventListener('dragstart', this.handleTopDragStart);
				target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
				target.addEventListener('dragend', this.handleTopDragEndCapture, true);
				target.addEventListener('dragenter', this.handleTopDragEnter);
				target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
				target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
				target.addEventListener('dragover', this.handleTopDragOver);
				target.addEventListener('dragover', this.handleTopDragOverCapture, true);
				target.addEventListener('drop', this.handleTopDrop);
				target.addEventListener('drop', this.handleTopDropCapture, true);
			}
		}, {
			key: 'removeEventListeners',
			value: function removeEventListeners(target) {
				// SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
				if (!target.removeEventListener) {
					return;
				}
				target.removeEventListener('dragstart', this.handleTopDragStart);
				target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
				target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
				target.removeEventListener('dragenter', this.handleTopDragEnter);
				target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
				target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
				target.removeEventListener('dragover', this.handleTopDragOver);
				target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
				target.removeEventListener('drop', this.handleTopDrop);
				target.removeEventListener('drop', this.handleTopDropCapture, true);
			}
		}, {
			key: 'connectDragPreview',
			value: function connectDragPreview(sourceId, node, options) {
				var _this = this;
	
				this.sourcePreviewNodeOptions[sourceId] = options;
				this.sourcePreviewNodes[sourceId] = node;
	
				return function () {
					delete _this.sourcePreviewNodes[sourceId];
					delete _this.sourcePreviewNodeOptions[sourceId];
				};
			}
		}, {
			key: 'connectDragSource',
			value: function connectDragSource(sourceId, node, options) {
				var _this2 = this;
	
				this.sourceNodes[sourceId] = node;
				this.sourceNodeOptions[sourceId] = options;
	
				var handleDragStart = function handleDragStart(e) {
					return _this2.handleDragStart(e, sourceId);
				};
				var handleSelectStart = function handleSelectStart(e) {
					return _this2.handleSelectStart(e, sourceId);
				};
	
				node.setAttribute('draggable', true);
				node.addEventListener('dragstart', handleDragStart);
				node.addEventListener('selectstart', handleSelectStart);
	
				return function () {
					delete _this2.sourceNodes[sourceId];
					delete _this2.sourceNodeOptions[sourceId];
	
					node.removeEventListener('dragstart', handleDragStart);
					node.removeEventListener('selectstart', handleSelectStart);
					node.setAttribute('draggable', false);
				};
			}
		}, {
			key: 'connectDropTarget',
			value: function connectDropTarget(targetId, node) {
				var _this3 = this;
	
				var handleDragEnter = function handleDragEnter(e) {
					return _this3.handleDragEnter(e, targetId);
				};
				var handleDragOver = function handleDragOver(e) {
					return _this3.handleDragOver(e, targetId);
				};
				var handleDrop = function handleDrop(e) {
					return _this3.handleDrop(e, targetId);
				};
	
				node.addEventListener('dragenter', handleDragEnter);
				node.addEventListener('dragover', handleDragOver);
				node.addEventListener('drop', handleDrop);
	
				return function () {
					node.removeEventListener('dragenter', handleDragEnter);
					node.removeEventListener('dragover', handleDragOver);
					node.removeEventListener('drop', handleDrop);
				};
			}
		}, {
			key: 'getCurrentSourceNodeOptions',
			value: function getCurrentSourceNodeOptions() {
				var sourceId = this.monitor.getSourceId();
				var sourceNodeOptions = this.sourceNodeOptions[sourceId];
	
				return (0, _defaults2.default)(sourceNodeOptions || {}, {
					dropEffect: this.altKeyPressed ? 'copy' : 'move'
				});
			}
		}, {
			key: 'getCurrentDropEffect',
			value: function getCurrentDropEffect() {
				if (this.isDraggingNativeItem()) {
					// It makes more sense to default to 'copy' for native resources
					return 'copy';
				}
	
				return this.getCurrentSourceNodeOptions().dropEffect;
			}
		}, {
			key: 'getCurrentSourcePreviewNodeOptions',
			value: function getCurrentSourcePreviewNodeOptions() {
				var sourceId = this.monitor.getSourceId();
				var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions[sourceId];
	
				return (0, _defaults2.default)(sourcePreviewNodeOptions || {}, {
					anchorX: 0.5,
					anchorY: 0.5,
					captureDraggingState: false
				});
			}
		}, {
			key: 'getSourceClientOffset',
			value: function getSourceClientOffset(sourceId) {
				return (0, _OffsetUtils.getNodeClientOffset)(this.sourceNodes[sourceId]);
			}
		}, {
			key: 'isDraggingNativeItem',
			value: function isDraggingNativeItem() {
				var itemType = this.monitor.getItemType();
				return Object.keys(NativeTypes).some(function (key) {
					return NativeTypes[key] === itemType;
				});
			}
		}, {
			key: 'beginDragNativeItem',
			value: function beginDragNativeItem(type) {
				this.clearCurrentDragSourceNode();
	
				var SourceType = (0, _NativeDragSources.createNativeDragSource)(type);
				this.currentNativeSource = new SourceType();
				this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
				this.actions.beginDrag([this.currentNativeHandle]);
			}
		}, {
			key: 'asyncEndDragNativeItem',
			value: function asyncEndDragNativeItem() {
				this.asyncEndDragFrameId = this.window.requestAnimationFrame(this.endDragNativeItem);
			}
		}, {
			key: 'endDragNativeItem',
			value: function endDragNativeItem() {
				if (!this.isDraggingNativeItem()) {
					return;
				}
	
				this.actions.endDrag();
				this.registry.removeSource(this.currentNativeHandle);
				this.currentNativeHandle = null;
				this.currentNativeSource = null;
			}
		}, {
			key: 'isNodeInDocument',
			value: function isNodeInDocument(node) {
				// Check the node either in the main document or in the current context
				return document.body.contains(node) || this.window ? this.window.document.body.contains(node) : false;
			}
		}, {
			key: 'endDragIfSourceWasRemovedFromDOM',
			value: function endDragIfSourceWasRemovedFromDOM() {
				var node = this.currentDragSourceNode;
				if (this.isNodeInDocument(node)) {
					return;
				}
	
				if (this.clearCurrentDragSourceNode()) {
					this.actions.endDrag();
				}
			}
		}, {
			key: 'setCurrentDragSourceNode',
			value: function setCurrentDragSourceNode(node) {
				var _this4 = this;
	
				this.clearCurrentDragSourceNode();
				this.currentDragSourceNode = node;
				this.currentDragSourceNodeOffset = (0, _OffsetUtils.getNodeClientOffset)(node);
				this.currentDragSourceNodeOffsetChanged = false;
	
				// A timeout of > 0 is necessary to resolve Firefox issue referenced
				// See:
				//   * https://github.com/react-dnd/react-dnd/pull/928
				//   * https://github.com/react-dnd/react-dnd/issues/869
				var MOUSE_MOVE_TIMEOUT = 1000;
	
				// Receiving a mouse event in the middle of a dragging operation
				// means it has ended and the drag source node disappeared from DOM,
				// so the browser didn't dispatch the dragend event.
				//
				// We need to wait before we start listening for mousemove events.
				// This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
				// immediately in some browsers.
				//
				// See:
				//   * https://github.com/react-dnd/react-dnd/pull/928
				//   * https://github.com/react-dnd/react-dnd/issues/869
				//
				this.mouseMoveTimeoutTimer = setTimeout(function () {
					_this4.mouseMoveTimeoutId = null;
					return _this4.window.addEventListener('mousemove', _this4.endDragIfSourceWasRemovedFromDOM, true);
				}, MOUSE_MOVE_TIMEOUT);
			}
		}, {
			key: 'clearCurrentDragSourceNode',
			value: function clearCurrentDragSourceNode() {
				if (this.currentDragSourceNode) {
					this.currentDragSourceNode = null;
					this.currentDragSourceNodeOffset = null;
					this.currentDragSourceNodeOffsetChanged = false;
					this.window.clearTimeout(this.mouseMoveTimeoutTimer);
					this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
					this.mouseMoveTimeoutTimer = null;
					return true;
				}
	
				return false;
			}
		}, {
			key: 'checkIfCurrentDragSourceRectChanged',
			value: function checkIfCurrentDragSourceRectChanged() {
				var node = this.currentDragSourceNode;
				if (!node) {
					return false;
				}
	
				if (this.currentDragSourceNodeOffsetChanged) {
					return true;
				}
	
				this.currentDragSourceNodeOffsetChanged = !(0, _shallowEqual2.default)((0, _OffsetUtils.getNodeClientOffset)(node), this.currentDragSourceNodeOffset);
	
				return this.currentDragSourceNodeOffsetChanged;
			}
		}, {
			key: 'handleTopDragStartCapture',
			value: function handleTopDragStartCapture() {
				this.clearCurrentDragSourceNode();
				this.dragStartSourceIds = [];
			}
		}, {
			key: 'handleDragStart',
			value: function handleDragStart(e, sourceId) {
				this.dragStartSourceIds.unshift(sourceId);
			}
		}, {
			key: 'handleTopDragStart',
			value: function handleTopDragStart(e) {
				var _this5 = this;
	
				var dragStartSourceIds = this.dragStartSourceIds;
	
				this.dragStartSourceIds = null;
	
				var clientOffset = (0, _OffsetUtils.getEventClientOffset)(e);
	
				// Avoid crashing if we missed a drop event or our previous drag died
				if (this.monitor.isDragging()) {
					this.actions.endDrag();
				}
	
				// Don't publish the source just yet (see why below)
				this.actions.beginDrag(dragStartSourceIds, {
					publishSource: false,
					getSourceClientOffset: this.getSourceClientOffset,
					clientOffset: clientOffset
				});
	
				var dataTransfer = e.dataTransfer;
	
				var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
	
				if (this.monitor.isDragging()) {
					if (typeof dataTransfer.setDragImage === 'function') {
						// Use custom drag image if user specifies it.
						// If child drag source refuses drag but parent agrees,
						// use parent's node as drag image. Neither works in IE though.
						var sourceId = this.monitor.getSourceId();
						var sourceNode = this.sourceNodes[sourceId];
						var dragPreview = this.sourcePreviewNodes[sourceId] || sourceNode;
	
						var _getCurrentSourcePrev = this.getCurrentSourcePreviewNodeOptions(),
						    anchorX = _getCurrentSourcePrev.anchorX,
						    anchorY = _getCurrentSourcePrev.anchorY,
						    offsetX = _getCurrentSourcePrev.offsetX,
						    offsetY = _getCurrentSourcePrev.offsetY;
	
						var anchorPoint = { anchorX: anchorX, anchorY: anchorY };
						var offsetPoint = { offsetX: offsetX, offsetY: offsetY };
						var dragPreviewOffset = (0, _OffsetUtils.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
	
						dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
					}
	
					try {
						// Firefox won't drag without setting data
						dataTransfer.setData('application/json', {});
					} catch (err) {}
					// IE doesn't support MIME types in setData
	
	
					// Store drag source node so we can check whether
					// it is removed from DOM and trigger endDrag manually.
					this.setCurrentDragSourceNode(e.target);
	
					// Now we are ready to publish the drag source.. or are we not?
	
					var _getCurrentSourcePrev2 = this.getCurrentSourcePreviewNodeOptions(),
					    captureDraggingState = _getCurrentSourcePrev2.captureDraggingState;
	
					if (!captureDraggingState) {
						// Usually we want to publish it in the next tick so that browser
						// is able to screenshot the current (not yet dragging) state.
						//
						// It also neatly avoids a situation where render() returns null
						// in the same tick for the source element, and browser freaks out.
						setTimeout(function () {
							return _this5.actions.publishDragSource();
						});
					} else {
						// In some cases the user may want to override this behavior, e.g.
						// to work around IE not supporting custom drag previews.
						//
						// When using a custom drag layer, the only way to prevent
						// the default drag preview from drawing in IE is to screenshot
						// the dragging state in which the node itself has zero opacity
						// and height. In this case, though, returning null from render()
						// will abruptly end the dragging, which is not obvious.
						//
						// This is the reason such behavior is strictly opt-in.
						this.actions.publishDragSource();
					}
				} else if (nativeType) {
					// A native item (such as URL) dragged from inside the document
					this.beginDragNativeItem(nativeType);
				} else if (!dataTransfer.types && (!e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
					// Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
					// Just let it drag. It's a native type (URL or text) and will be picked up in
					// dragenter handler.
					return; // eslint-disable-line no-useless-return
				} else {
					// If by this time no drag source reacted, tell browser not to drag.
					e.preventDefault();
				}
			}
		}, {
			key: 'handleTopDragEndCapture',
			value: function handleTopDragEndCapture() {
				if (this.clearCurrentDragSourceNode()) {
					// Firefox can dispatch this event in an infinite loop
					// if dragend handler does something like showing an alert.
					// Only proceed if we have not handled it already.
					this.actions.endDrag();
				}
			}
		}, {
			key: 'handleTopDragEnterCapture',
			value: function handleTopDragEnterCapture(e) {
				this.dragEnterTargetIds = [];
	
				var isFirstEnter = this.enterLeaveCounter.enter(e.target);
				if (!isFirstEnter || this.monitor.isDragging()) {
					return;
				}
	
				var dataTransfer = e.dataTransfer;
	
				var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
	
				if (nativeType) {
					// A native item (such as file or URL) dragged from outside the document
					this.beginDragNativeItem(nativeType);
				}
			}
		}, {
			key: 'handleDragEnter',
			value: function handleDragEnter(e, targetId) {
				this.dragEnterTargetIds.unshift(targetId);
			}
		}, {
			key: 'handleTopDragEnter',
			value: function handleTopDragEnter(e) {
				var _this6 = this;
	
				var dragEnterTargetIds = this.dragEnterTargetIds;
	
				this.dragEnterTargetIds = [];
	
				if (!this.monitor.isDragging()) {
					// This is probably a native item type we don't understand.
					return;
				}
	
				this.altKeyPressed = e.altKey;
	
				if (!(0, _BrowserDetector.isFirefox)()) {
					// Don't emit hover in `dragenter` on Firefox due to an edge case.
					// If the target changes position as the result of `dragenter`, Firefox
					// will still happily dispatch `dragover` despite target being no longer
					// there. The easy solution is to only fire `hover` in `dragover` on FF.
					this.actions.hover(dragEnterTargetIds, {
						clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
					});
				}
	
				var canDrop = dragEnterTargetIds.some(function (targetId) {
					return _this6.monitor.canDropOnTarget(targetId);
				});
	
				if (canDrop) {
					// IE requires this to fire dragover events
					e.preventDefault();
					e.dataTransfer.dropEffect = this.getCurrentDropEffect();
				}
			}
		}, {
			key: 'handleTopDragOverCapture',
			value: function handleTopDragOverCapture() {
				this.dragOverTargetIds = [];
			}
		}, {
			key: 'handleDragOver',
			value: function handleDragOver(e, targetId) {
				this.dragOverTargetIds.unshift(targetId);
			}
		}, {
			key: 'handleTopDragOver',
			value: function handleTopDragOver(e) {
				var _this7 = this;
	
				var dragOverTargetIds = this.dragOverTargetIds;
	
				this.dragOverTargetIds = [];
	
				if (!this.monitor.isDragging()) {
					// This is probably a native item type we don't understand.
					// Prevent default "drop and blow away the whole document" action.
					e.preventDefault();
					e.dataTransfer.dropEffect = 'none';
					return;
				}
	
				this.altKeyPressed = e.altKey;
	
				this.actions.hover(dragOverTargetIds, {
					clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
				});
	
				var canDrop = dragOverTargetIds.some(function (targetId) {
					return _this7.monitor.canDropOnTarget(targetId);
				});
	
				if (canDrop) {
					// Show user-specified drop effect.
					e.preventDefault();
					e.dataTransfer.dropEffect = this.getCurrentDropEffect();
				} else if (this.isDraggingNativeItem()) {
					// Don't show a nice cursor but still prevent default
					// "drop and blow away the whole document" action.
					e.preventDefault();
					e.dataTransfer.dropEffect = 'none';
				} else if (this.checkIfCurrentDragSourceRectChanged()) {
					// Prevent animating to incorrect position.
					// Drop effect must be other than 'none' to prevent animation.
					e.preventDefault();
					e.dataTransfer.dropEffect = 'move';
				}
			}
		}, {
			key: 'handleTopDragLeaveCapture',
			value: function handleTopDragLeaveCapture(e) {
				if (this.isDraggingNativeItem()) {
					e.preventDefault();
				}
	
				var isLastLeave = this.enterLeaveCounter.leave(e.target);
				if (!isLastLeave) {
					return;
				}
	
				if (this.isDraggingNativeItem()) {
					this.endDragNativeItem();
				}
			}
		}, {
			key: 'handleTopDropCapture',
			value: function handleTopDropCapture(e) {
				this.dropTargetIds = [];
				e.preventDefault();
	
				if (this.isDraggingNativeItem()) {
					this.currentNativeSource.mutateItemByReadingDataTransfer(e.dataTransfer);
				}
	
				this.enterLeaveCounter.reset();
			}
		}, {
			key: 'handleDrop',
			value: function handleDrop(e, targetId) {
				this.dropTargetIds.unshift(targetId);
			}
		}, {
			key: 'handleTopDrop',
			value: function handleTopDrop(e) {
				var dropTargetIds = this.dropTargetIds;
	
				this.dropTargetIds = [];
	
				this.actions.hover(dropTargetIds, {
					clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
				});
				this.actions.drop({ dropEffect: this.getCurrentDropEffect() });
	
				if (this.isDraggingNativeItem()) {
					this.endDragNativeItem();
				} else {
					this.endDragIfSourceWasRemovedFromDOM();
				}
			}
		}, {
			key: 'handleSelectStart',
			value: function handleSelectStart(e) {
				var target = e.target;
	
				// Only IE requires us to explicitly say
				// we want drag drop operation to start
	
				if (typeof target.dragDrop !== 'function') {
					return;
				}
	
				// Inputs and textareas should be selectable
				if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
					return;
				}
	
				// For other targets, ask IE
				// to enable drag and drop
				e.preventDefault();
				target.dragDrop();
			}
		}, {
			key: 'window',
			get: function get() {
				if (this.context && this.context.window) {
					return this.context.window;
				} else if (typeof window !== 'undefined') {
					return window;
				}
				return undefined;
			}
		}]);
	
		return HTML5Backend;
	}();
	
	exports.default = HTML5Backend;

/***/ }),
/* 1725 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint
	   no-plusplus: off,
	   no-mixed-operators: off
	*/
	var MonotonicInterpolant = function () {
		function MonotonicInterpolant(xs, ys) {
			_classCallCheck(this, MonotonicInterpolant);
	
			var length = xs.length;
	
			// Rearrange xs and ys so that xs is sorted
			var indexes = [];
			for (var i = 0; i < length; i++) {
				indexes.push(i);
			}
			indexes.sort(function (a, b) {
				return xs[a] < xs[b] ? -1 : 1;
			});
	
			// Get consecutive differences and slopes
			var dys = [];
			var dxs = [];
			var ms = [];
			var dx = void 0;
			var dy = void 0;
			for (var _i = 0; _i < length - 1; _i++) {
				dx = xs[_i + 1] - xs[_i];
				dy = ys[_i + 1] - ys[_i];
				dxs.push(dx);
				dys.push(dy);
				ms.push(dy / dx);
			}
	
			// Get degree-1 coefficients
			var c1s = [ms[0]];
			for (var _i2 = 0; _i2 < dxs.length - 1; _i2++) {
				var _m = ms[_i2];
				var mNext = ms[_i2 + 1];
				if (_m * mNext <= 0) {
					c1s.push(0);
				} else {
					dx = dxs[_i2];
					var dxNext = dxs[_i2 + 1];
					var common = dx + dxNext;
					c1s.push(3 * common / ((common + dxNext) / _m + (common + dx) / mNext));
				}
			}
			c1s.push(ms[ms.length - 1]);
	
			// Get degree-2 and degree-3 coefficients
			var c2s = [];
			var c3s = [];
			var m = void 0;
			for (var _i3 = 0; _i3 < c1s.length - 1; _i3++) {
				m = ms[_i3];
				var c1 = c1s[_i3];
				var invDx = 1 / dxs[_i3];
				var _common = c1 + c1s[_i3 + 1] - m - m;
				c2s.push((m - c1 - _common) * invDx);
				c3s.push(_common * invDx * invDx);
			}
	
			this.xs = xs;
			this.ys = ys;
			this.c1s = c1s;
			this.c2s = c2s;
			this.c3s = c3s;
		}
	
		_createClass(MonotonicInterpolant, [{
			key: "interpolate",
			value: function interpolate(x) {
				var xs = this.xs,
				    ys = this.ys,
				    c1s = this.c1s,
				    c2s = this.c2s,
				    c3s = this.c3s;
	
				// The rightmost point in the dataset should give an exact result
	
				var i = xs.length - 1;
				if (x === xs[i]) {
					return ys[i];
				}
	
				// Search for the interval x is in, returning the corresponding y if x is one of the original xs
				var low = 0;
				var high = c3s.length - 1;
				var mid = void 0;
				while (low <= high) {
					mid = Math.floor(0.5 * (low + high));
					var xHere = xs[mid];
					if (xHere < x) {
						low = mid + 1;
					} else if (xHere > x) {
						high = mid - 1;
					} else {
						return ys[mid];
					}
				}
				i = Math.max(0, high);
	
				// Interpolate
				var diff = x - xs[i];
				var diffSq = diff * diff;
				return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
			}
		}]);
	
		return MonotonicInterpolant;
	}();
	
	exports.default = MonotonicInterpolant;

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _nativeTypesConfig;
	
	exports.createNativeDragSource = createNativeDragSource;
	exports.matchNativeItemType = matchNativeItemType;
	
	var _NativeTypes = __webpack_require__(507);
	
	var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
		var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
			return resultSoFar || dataTransfer.getData(typeToTry);
		}, null);
	
		return result != null // eslint-disable-line eqeqeq
		? result : defaultValue;
	}
	
	var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty(_nativeTypesConfig, NativeTypes.FILE, {
		exposeProperty: 'files',
		matchesTypes: ['Files'],
		getData: function getData(dataTransfer) {
			return Array.prototype.slice.call(dataTransfer.files);
		}
	}), _defineProperty(_nativeTypesConfig, NativeTypes.URL, {
		exposeProperty: 'urls',
		matchesTypes: ['Url', 'text/uri-list'],
		getData: function getData(dataTransfer, matchesTypes) {
			return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
		}
	}), _defineProperty(_nativeTypesConfig, NativeTypes.TEXT, {
		exposeProperty: 'text',
		matchesTypes: ['Text', 'text/plain'],
		getData: function getData(dataTransfer, matchesTypes) {
			return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
		}
	}), _nativeTypesConfig);
	
	function createNativeDragSource(type) {
		var _nativeTypesConfig$ty = nativeTypesConfig[type],
		    exposeProperty = _nativeTypesConfig$ty.exposeProperty,
		    matchesTypes = _nativeTypesConfig$ty.matchesTypes,
		    getData = _nativeTypesConfig$ty.getData;
	
	
		return function () {
			function NativeDragSource() {
				var _item, _mutatorMap;
	
				_classCallCheck(this, NativeDragSource);
	
				this.item = (_item = {}, _mutatorMap = {}, _mutatorMap[exposeProperty] = _mutatorMap[exposeProperty] || {}, _mutatorMap[exposeProperty].get = function () {
					// eslint-disable-next-line no-console
					console.warn('Browser doesn\'t allow reading "' + exposeProperty + '" until the drop event.');
					return null;
				}, _defineEnumerableProperties(_item, _mutatorMap), _item);
			}
	
			_createClass(NativeDragSource, [{
				key: 'mutateItemByReadingDataTransfer',
				value: function mutateItemByReadingDataTransfer(dataTransfer) {
					delete this.item[exposeProperty];
					this.item[exposeProperty] = getData(dataTransfer, matchesTypes);
				}
			}, {
				key: 'canDrag',
				value: function canDrag() {
					return true;
				}
			}, {
				key: 'beginDrag',
				value: function beginDrag() {
					return this.item;
				}
			}, {
				key: 'isDragging',
				value: function isDragging(monitor, handle) {
					return handle === monitor.getSourceId();
				}
			}, {
				key: 'endDrag',
				value: function endDrag() {}
			}]);
	
			return NativeDragSource;
		}();
	}
	
	function matchNativeItemType(dataTransfer) {
		var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
	
		return Object.keys(nativeTypesConfig).filter(function (nativeItemType) {
			var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;
	
			return matchesTypes.some(function (t) {
				return dataTransferTypes.indexOf(t) > -1;
			});
		})[0] || null;
	}

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getNodeClientOffset = getNodeClientOffset;
	exports.getEventClientOffset = getEventClientOffset;
	exports.getDragPreviewOffset = getDragPreviewOffset;
	
	var _BrowserDetector = __webpack_require__(817);
	
	var _MonotonicInterpolant = __webpack_require__(1725);
	
	var _MonotonicInterpolant2 = _interopRequireDefault(_MonotonicInterpolant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint
	   no-mixed-operators: off
	*/
	var ELEMENT_NODE = 1;
	
	function getNodeClientOffset(node) {
		var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
	
		if (!el) {
			return null;
		}
	
		var _el$getBoundingClient = el.getBoundingClientRect(),
		    top = _el$getBoundingClient.top,
		    left = _el$getBoundingClient.left;
	
		return { x: left, y: top };
	}
	
	function getEventClientOffset(e) {
		return {
			x: e.clientX,
			y: e.clientY
		};
	}
	
	function isImageNode(node) {
		return node.nodeName === 'IMG' && ((0, _BrowserDetector.isFirefox)() || !document.documentElement.contains(node));
	}
	
	function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
		var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
		var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
	
		// Work around @2x coordinate discrepancies in browsers
		if ((0, _BrowserDetector.isSafari)() && isImage) {
			dragPreviewHeight /= window.devicePixelRatio;
			dragPreviewWidth /= window.devicePixelRatio;
		}
		return { dragPreviewWidth: dragPreviewWidth, dragPreviewHeight: dragPreviewHeight };
	}
	
	function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
		// The browsers will use the image intrinsic size under different conditions.
		// Firefox only cares if it's an image, but WebKit also wants it to be detached.
		var isImage = isImageNode(dragPreview);
		var dragPreviewNode = isImage ? sourceNode : dragPreview;
		var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
		var offsetFromDragPreview = {
			x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
			y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
		};
		var sourceWidth = sourceNode.offsetWidth,
		    sourceHeight = sourceNode.offsetHeight;
		var anchorX = anchorPoint.anchorX,
		    anchorY = anchorPoint.anchorY;
	
		var _getDragPreviewSize = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight),
		    dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth,
		    dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;
	
		var calculateYOffset = function calculateYOffset() {
			var interpolantY = new _MonotonicInterpolant2.default([0, 0.5, 1], [
			// Dock to the top
			offsetFromDragPreview.y,
			// Align at the center
			offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
			// Dock to the bottom
			offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
			var y = interpolantY.interpolate(anchorY);
			// Work around Safari 8 positioning bug
			if ((0, _BrowserDetector.isSafari)() && isImage) {
				// We'll have to wait for @3x to see if this is entirely correct
				y += (window.devicePixelRatio - 1) * dragPreviewHeight;
			}
			return y;
		};
	
		var calculateXOffset = function calculateXOffset() {
			// Interpolate coordinates depending on anchor point
			// If you know a simpler way to do this, let me know
			var interpolantX = new _MonotonicInterpolant2.default([0, 0.5, 1], [
			// Dock to the left
			offsetFromDragPreview.x,
			// Align at the center
			offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
			// Dock to the right
			offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
			return interpolantX.interpolate(anchorX);
		};
	
		// Force offsets if specified in the options.
		var offsetX = offsetPoint.offsetX,
		    offsetY = offsetPoint.offsetY;
	
		var isManualOffsetX = offsetX === 0 || offsetX;
		var isManualOffsetY = offsetY === 0 || offsetY;
		return {
			x: isManualOffsetX ? offsetX : calculateXOffset(),
			y: isManualOffsetY ? offsetY : calculateYOffset()
		};
	}

/***/ }),
/* 1728 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = getEmptyImage;
	var emptyImage = void 0;
	function getEmptyImage() {
		if (!emptyImage) {
			emptyImage = new Image();
			emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
		}
	
		return emptyImage;
	}

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getEmptyImage = exports.NativeTypes = undefined;
	exports.default = createHTML5Backend;
	
	var _HTML5Backend = __webpack_require__(1724);
	
	var _HTML5Backend2 = _interopRequireDefault(_HTML5Backend);
	
	var _getEmptyImage = __webpack_require__(1728);
	
	var _getEmptyImage2 = _interopRequireDefault(_getEmptyImage);
	
	var _NativeTypes = __webpack_require__(507);
	
	var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.NativeTypes = NativeTypes;
	exports.getEmptyImage = _getEmptyImage2.default;
	function createHTML5Backend(manager) {
		return new _HTML5Backend2.default(manager);
	}

/***/ }),
/* 1730 */
509,
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DragDropContext = __webpack_require__(818);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This class is a React-Component based version of the DragDropContext.
	 * This is an alternative to decorating an application component with an ES7 decorator.
	 */
	var DragDropContextProvider = (_temp = _class = function (_Component) {
		_inherits(DragDropContextProvider, _Component);
	
		function DragDropContextProvider(props, context) {
			_classCallCheck(this, DragDropContextProvider);
	
			/**
	   * This property determines which window global to use for creating the DragDropManager.
	   * If a window has been injected explicitly via props, that is used first. If it is available
	   * as a context value, then use that, otherwise use the browser global.
	   */
			var _this = _possibleConstructorReturn(this, (DragDropContextProvider.__proto__ || Object.getPrototypeOf(DragDropContextProvider)).call(this, props, context));
	
			var getWindow = function getWindow() {
				if (props && props.window) {
					return props.window;
				} else if (context && context.window) {
					return context.window;
				} else if (typeof window !== 'undefined') {
					return window;
				}
				return undefined;
			};
	
			_this.backend = (0, _DragDropContext.unpackBackendForEs5Users)(props.backend);
			_this.childContext = (0, _DragDropContext.createChildContext)(_this.backend, {
				window: getWindow()
			});
			return _this;
		}
	
		_createClass(DragDropContextProvider, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.backend !== this.props.backend || nextProps.window !== this.props.window) {
					throw new Error('DragDropContextProvider backend and window props must not change.');
				}
			}
		}, {
			key: 'getChildContext',
			value: function getChildContext() {
				return this.childContext;
			}
		}, {
			key: 'render',
			value: function render() {
				return _react.Children.only(this.props.children);
			}
		}]);
	
		return DragDropContextProvider;
	}(_react.Component), _class.propTypes = {
		backend: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]).isRequired,
		children: _propTypes2.default.element.isRequired,
		window: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
	}, _class.defaultProps = {
		window: undefined
	}, _class.childContextTypes = _DragDropContext.CHILD_CONTEXT_TYPES, _class.displayName = 'DragDropContextProvider', _class.contextTypes = {
		window: _propTypes2.default.object
	}, _temp);
	exports.default = DragDropContextProvider;

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = DragLayer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(460);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _isPlainObject = __webpack_require__(137);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _shallowEqual = __webpack_require__(509);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _shallowEqualScalar = __webpack_require__(822);
	
	var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);
	
	var _checkDecoratorArguments = __webpack_require__(373);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function DragLayer(collect) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		_checkDecoratorArguments2.default.apply(undefined, ['DragLayer', 'collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
		(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer to be a function that collects props to inject into the component. ', 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', collect);
		(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the second argument to DragLayer to be a plain object when specified. ' + 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', options);
	
		return function decorateLayer(DecoratedComponent) {
			var _class, _temp;
	
			var _options$arePropsEqua = options.arePropsEqual,
			    arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;
	
			var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
			var DragLayerContainer = (_temp = _class = function (_Component) {
				_inherits(DragLayerContainer, _Component);
	
				_createClass(DragLayerContainer, [{
					key: 'getDecoratedComponentInstance',
					value: function getDecoratedComponentInstance() {
						(0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
						return this.child;
					}
				}, {
					key: 'shouldComponentUpdate',
					value: function shouldComponentUpdate(nextProps, nextState) {
						return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
					}
				}]);
	
				function DragLayerContainer(props, context) {
					_classCallCheck(this, DragLayerContainer);
	
					var _this = _possibleConstructorReturn(this, (DragLayerContainer.__proto__ || Object.getPrototypeOf(DragLayerContainer)).call(this, props));
	
					_this.handleChange = _this.handleChange.bind(_this);
	
					_this.manager = context.dragDropManager;
					(0, _invariant2.default)(_typeof(_this.manager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	
					_this.state = _this.getCurrentState();
					return _this;
				}
	
				_createClass(DragLayerContainer, [{
					key: 'componentDidMount',
					value: function componentDidMount() {
						this.isCurrentlyMounted = true;
	
						var monitor = this.manager.getMonitor();
						this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
						this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);
	
						this.handleChange();
					}
				}, {
					key: 'componentWillUnmount',
					value: function componentWillUnmount() {
						this.isCurrentlyMounted = false;
	
						this.unsubscribeFromOffsetChange();
						this.unsubscribeFromStateChange();
					}
				}, {
					key: 'handleChange',
					value: function handleChange() {
						if (!this.isCurrentlyMounted) {
							return;
						}
	
						var nextState = this.getCurrentState();
						if (!(0, _shallowEqual2.default)(nextState, this.state)) {
							this.setState(nextState);
						}
					}
				}, {
					key: 'getCurrentState',
					value: function getCurrentState() {
						var monitor = this.manager.getMonitor();
						return collect(monitor, this.props);
					}
				}, {
					key: 'render',
					value: function render() {
						var _this2 = this;
	
						return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
							ref: function ref(child) {
								_this2.child = child;
							}
						}));
					}
				}]);
	
				return DragLayerContainer;
			}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragLayer(' + displayName + ')', _class.contextTypes = {
				dragDropManager: _propTypes2.default.object.isRequired
			}, _temp);
	
	
			return (0, _hoistNonReactStatics2.default)(DragLayerContainer, DecoratedComponent);
		};
	}

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = DragSource;
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(137);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _checkDecoratorArguments = __webpack_require__(373);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	var _decorateHandler = __webpack_require__(820);
	
	var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
	
	var _registerSource = __webpack_require__(1741);
	
	var _registerSource2 = _interopRequireDefault(_registerSource);
	
	var _createSourceFactory = __webpack_require__(1736);
	
	var _createSourceFactory2 = _interopRequireDefault(_createSourceFactory);
	
	var _createSourceMonitor = __webpack_require__(1737);
	
	var _createSourceMonitor2 = _interopRequireDefault(_createSourceMonitor);
	
	var _createSourceConnector = __webpack_require__(1735);
	
	var _createSourceConnector2 = _interopRequireDefault(_createSourceConnector);
	
	var _isValidType = __webpack_require__(821);
	
	var _isValidType2 = _interopRequireDefault(_isValidType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DragSource(type, spec, collect) {
		var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
		_checkDecoratorArguments2.default.apply(undefined, ['DragSource', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments)));
		var getType = type;
		if (typeof type !== 'function') {
			(0, _invariant2.default)((0, _isValidType2.default)(type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', type);
			getType = function getType() {
				return type;
			};
		}
		(0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', spec);
		var createSource = (0, _createSourceFactory2.default)(spec);
		(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
		(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
	
		return function decorateSource(DecoratedComponent) {
			return (0, _decorateHandler2.default)({
				connectBackend: function connectBackend(backend, sourceId) {
					return backend.connectDragSource(sourceId);
				},
				containerDisplayName: 'DragSource',
				createHandler: createSource,
				registerHandler: _registerSource2.default,
				createMonitor: _createSourceMonitor2.default,
				createConnector: _createSourceConnector2.default,
				DecoratedComponent: DecoratedComponent,
				getType: getType,
				collect: collect,
				options: options
			});
		};
	}

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = DropTarget;
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(137);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _checkDecoratorArguments = __webpack_require__(373);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	var _decorateHandler = __webpack_require__(820);
	
	var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
	
	var _registerTarget = __webpack_require__(1742);
	
	var _registerTarget2 = _interopRequireDefault(_registerTarget);
	
	var _createTargetFactory = __webpack_require__(1739);
	
	var _createTargetFactory2 = _interopRequireDefault(_createTargetFactory);
	
	var _createTargetMonitor = __webpack_require__(1740);
	
	var _createTargetMonitor2 = _interopRequireDefault(_createTargetMonitor);
	
	var _createTargetConnector = __webpack_require__(1738);
	
	var _createTargetConnector2 = _interopRequireDefault(_createTargetConnector);
	
	var _isValidType = __webpack_require__(821);
	
	var _isValidType2 = _interopRequireDefault(_isValidType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DropTarget(type, spec, collect) {
		var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
		_checkDecoratorArguments2.default.apply(undefined, ['DropTarget', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments)));
		var getType = type;
		if (typeof type !== 'function') {
			(0, _invariant2.default)((0, _isValidType2.default)(type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', type);
			getType = function getType() {
				return type;
			};
		}
		(0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', spec);
		var createTarget = (0, _createTargetFactory2.default)(spec);
		(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
		(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
	
		return function decorateTarget(DecoratedComponent) {
			return (0, _decorateHandler2.default)({
				connectBackend: function connectBackend(backend, targetId) {
					return backend.connectDropTarget(targetId);
				},
				containerDisplayName: 'DropTarget',
				createHandler: createTarget,
				registerHandler: _registerTarget2.default,
				createMonitor: _createTargetMonitor2.default,
				createConnector: _createTargetConnector2.default,
				DecoratedComponent: DecoratedComponent,
				getType: getType,
				collect: collect,
				options: options
			});
		};
	}

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = createSourceConnector;
	
	var _wrapConnectorHooks = __webpack_require__(823);
	
	var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);
	
	var _areOptionsEqual = __webpack_require__(819);
	
	var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createSourceConnector(backend) {
		var currentHandlerId = void 0;
	
		var currentDragSourceNode = void 0;
		var currentDragSourceOptions = void 0;
		var disconnectCurrentDragSource = void 0;
	
		var currentDragPreviewNode = void 0;
		var currentDragPreviewOptions = void 0;
		var disconnectCurrentDragPreview = void 0;
	
		function reconnectDragSource() {
			if (disconnectCurrentDragSource) {
				disconnectCurrentDragSource();
				disconnectCurrentDragSource = null;
			}
	
			if (currentHandlerId && currentDragSourceNode) {
				disconnectCurrentDragSource = backend.connectDragSource(currentHandlerId, currentDragSourceNode, currentDragSourceOptions);
			}
		}
	
		function reconnectDragPreview() {
			if (disconnectCurrentDragPreview) {
				disconnectCurrentDragPreview();
				disconnectCurrentDragPreview = null;
			}
	
			if (currentHandlerId && currentDragPreviewNode) {
				disconnectCurrentDragPreview = backend.connectDragPreview(currentHandlerId, currentDragPreviewNode, currentDragPreviewOptions);
			}
		}
	
		function receiveHandlerId(handlerId) {
			if (handlerId === currentHandlerId) {
				return;
			}
	
			currentHandlerId = handlerId;
			reconnectDragSource();
			reconnectDragPreview();
		}
	
		var hooks = (0, _wrapConnectorHooks2.default)({
			dragSource: function connectDragSource(node, options) {
				if (node === currentDragSourceNode && (0, _areOptionsEqual2.default)(options, currentDragSourceOptions)) {
					return;
				}
	
				currentDragSourceNode = node;
				currentDragSourceOptions = options;
	
				reconnectDragSource();
			},
	
			dragPreview: function connectDragPreview(node, options) {
				if (node === currentDragPreviewNode && (0, _areOptionsEqual2.default)(options, currentDragPreviewOptions)) {
					return;
				}
	
				currentDragPreviewNode = node;
				currentDragPreviewOptions = options;
	
				reconnectDragPreview();
			}
		});
	
		return {
			receiveHandlerId: receiveHandlerId,
			hooks: hooks
		};
	}

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createSourceFactory;
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(137);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'isDragging', 'endDrag'];
	var REQUIRED_SPEC_METHODS = ['beginDrag'];
	
	function createSourceFactory(spec) {
		Object.keys(spec).forEach(function (key) {
			(0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', ALLOWED_SPEC_METHODS.join(', '), key);
			(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
		});
		REQUIRED_SPEC_METHODS.forEach(function (key) {
			(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
		});
	
		var Source = function () {
			function Source(monitor) {
				_classCallCheck(this, Source);
	
				this.monitor = monitor;
				this.props = null;
				this.component = null;
			}
	
			_createClass(Source, [{
				key: 'receiveProps',
				value: function receiveProps(props) {
					this.props = props;
				}
			}, {
				key: 'receiveComponent',
				value: function receiveComponent(component) {
					this.component = component;
				}
			}, {
				key: 'canDrag',
				value: function canDrag() {
					if (!spec.canDrag) {
						return true;
					}
	
					return spec.canDrag(this.props, this.monitor);
				}
			}, {
				key: 'isDragging',
				value: function isDragging(globalMonitor, sourceId) {
					if (!spec.isDragging) {
						return sourceId === globalMonitor.getSourceId();
					}
	
					return spec.isDragging(this.props, this.monitor);
				}
			}, {
				key: 'beginDrag',
				value: function beginDrag() {
					var item = spec.beginDrag(this.props, this.monitor, this.component);
					if (false) {
						(0, _invariant2.default)((0, _isPlainObject2.default)(item), 'beginDrag() must return a plain object that represents the dragged item. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', item);
					}
					return item;
				}
			}, {
				key: 'endDrag',
				value: function endDrag() {
					if (!spec.endDrag) {
						return;
					}
	
					spec.endDrag(this.props, this.monitor, this.component);
				}
			}]);
	
			return Source;
		}();
	
		return function createSource(monitor) {
			return new Source(monitor);
		};
	}

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createSourceMonitor;
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var isCallingCanDrag = false;
	var isCallingIsDragging = false;
	
	var SourceMonitor = function () {
		function SourceMonitor(manager) {
			_classCallCheck(this, SourceMonitor);
	
			this.internalMonitor = manager.getMonitor();
		}
	
		_createClass(SourceMonitor, [{
			key: 'receiveHandlerId',
			value: function receiveHandlerId(sourceId) {
				this.sourceId = sourceId;
			}
		}, {
			key: 'canDrag',
			value: function canDrag() {
				(0, _invariant2.default)(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');
	
				try {
					isCallingCanDrag = true;
					return this.internalMonitor.canDragSource(this.sourceId);
				} finally {
					isCallingCanDrag = false;
				}
			}
		}, {
			key: 'isDragging',
			value: function isDragging() {
				(0, _invariant2.default)(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');
	
				try {
					isCallingIsDragging = true;
					return this.internalMonitor.isDraggingSource(this.sourceId);
				} finally {
					isCallingIsDragging = false;
				}
			}
		}, {
			key: 'getItemType',
			value: function getItemType() {
				return this.internalMonitor.getItemType();
			}
		}, {
			key: 'getItem',
			value: function getItem() {
				return this.internalMonitor.getItem();
			}
		}, {
			key: 'getDropResult',
			value: function getDropResult() {
				return this.internalMonitor.getDropResult();
			}
		}, {
			key: 'didDrop',
			value: function didDrop() {
				return this.internalMonitor.didDrop();
			}
		}, {
			key: 'getInitialClientOffset',
			value: function getInitialClientOffset() {
				return this.internalMonitor.getInitialClientOffset();
			}
		}, {
			key: 'getInitialSourceClientOffset',
			value: function getInitialSourceClientOffset() {
				return this.internalMonitor.getInitialSourceClientOffset();
			}
		}, {
			key: 'getSourceClientOffset',
			value: function getSourceClientOffset() {
				return this.internalMonitor.getSourceClientOffset();
			}
		}, {
			key: 'getClientOffset',
			value: function getClientOffset() {
				return this.internalMonitor.getClientOffset();
			}
		}, {
			key: 'getDifferenceFromInitialOffset',
			value: function getDifferenceFromInitialOffset() {
				return this.internalMonitor.getDifferenceFromInitialOffset();
			}
		}]);
	
		return SourceMonitor;
	}();
	
	function createSourceMonitor(manager) {
		return new SourceMonitor(manager);
	}

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = createTargetConnector;
	
	var _wrapConnectorHooks = __webpack_require__(823);
	
	var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);
	
	var _areOptionsEqual = __webpack_require__(819);
	
	var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTargetConnector(backend) {
		var currentHandlerId = void 0;
	
		var currentDropTargetNode = void 0;
		var currentDropTargetOptions = void 0;
		var disconnectCurrentDropTarget = void 0;
	
		function reconnectDropTarget() {
			if (disconnectCurrentDropTarget) {
				disconnectCurrentDropTarget();
				disconnectCurrentDropTarget = null;
			}
	
			if (currentHandlerId && currentDropTargetNode) {
				disconnectCurrentDropTarget = backend.connectDropTarget(currentHandlerId, currentDropTargetNode, currentDropTargetOptions);
			}
		}
	
		function receiveHandlerId(handlerId) {
			if (handlerId === currentHandlerId) {
				return;
			}
	
			currentHandlerId = handlerId;
			reconnectDropTarget();
		}
	
		var hooks = (0, _wrapConnectorHooks2.default)({
			dropTarget: function connectDropTarget(node, options) {
				if (node === currentDropTargetNode && (0, _areOptionsEqual2.default)(options, currentDropTargetOptions)) {
					return;
				}
	
				currentDropTargetNode = node;
				currentDropTargetOptions = options;
	
				reconnectDropTarget();
			}
		});
	
		return {
			receiveHandlerId: receiveHandlerId,
			hooks: hooks
		};
	}

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createTargetFactory;
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(137);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];
	
	function createTargetFactory(spec) {
		Object.keys(spec).forEach(function (key) {
			(0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', ALLOWED_SPEC_METHODS.join(', '), key);
			(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', key, key, spec[key]);
		});
	
		var Target = function () {
			function Target(monitor) {
				_classCallCheck(this, Target);
	
				this.monitor = monitor;
				this.props = null;
				this.component = null;
			}
	
			_createClass(Target, [{
				key: 'receiveProps',
				value: function receiveProps(props) {
					this.props = props;
				}
			}, {
				key: 'receiveMonitor',
				value: function receiveMonitor(monitor) {
					this.monitor = monitor;
				}
			}, {
				key: 'receiveComponent',
				value: function receiveComponent(component) {
					this.component = component;
				}
			}, {
				key: 'canDrop',
				value: function canDrop() {
					if (!spec.canDrop) {
						return true;
					}
	
					return spec.canDrop(this.props, this.monitor);
				}
			}, {
				key: 'hover',
				value: function hover() {
					if (!spec.hover) {
						return;
					}
	
					spec.hover(this.props, this.monitor, this.component);
				}
			}, {
				key: 'drop',
				value: function drop() {
					if (!spec.drop) {
						return undefined;
					}
	
					var dropResult = spec.drop(this.props, this.monitor, this.component);
					if (false) {
						(0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isPlainObject2.default)(dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', dropResult);
					}
					return dropResult;
				}
			}]);
	
			return Target;
		}();
	
		return function createTarget(monitor) {
			return new Target(monitor);
		};
	}

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createTargetMonitor;
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var isCallingCanDrop = false;
	
	var TargetMonitor = function () {
		function TargetMonitor(manager) {
			_classCallCheck(this, TargetMonitor);
	
			this.internalMonitor = manager.getMonitor();
		}
	
		_createClass(TargetMonitor, [{
			key: 'receiveHandlerId',
			value: function receiveHandlerId(targetId) {
				this.targetId = targetId;
			}
		}, {
			key: 'canDrop',
			value: function canDrop() {
				(0, _invariant2.default)(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target-monitor.html');
	
				try {
					isCallingCanDrop = true;
					return this.internalMonitor.canDropOnTarget(this.targetId);
				} finally {
					isCallingCanDrop = false;
				}
			}
		}, {
			key: 'isOver',
			value: function isOver(options) {
				return this.internalMonitor.isOverTarget(this.targetId, options);
			}
		}, {
			key: 'getItemType',
			value: function getItemType() {
				return this.internalMonitor.getItemType();
			}
		}, {
			key: 'getItem',
			value: function getItem() {
				return this.internalMonitor.getItem();
			}
		}, {
			key: 'getDropResult',
			value: function getDropResult() {
				return this.internalMonitor.getDropResult();
			}
		}, {
			key: 'didDrop',
			value: function didDrop() {
				return this.internalMonitor.didDrop();
			}
		}, {
			key: 'getInitialClientOffset',
			value: function getInitialClientOffset() {
				return this.internalMonitor.getInitialClientOffset();
			}
		}, {
			key: 'getInitialSourceClientOffset',
			value: function getInitialSourceClientOffset() {
				return this.internalMonitor.getInitialSourceClientOffset();
			}
		}, {
			key: 'getSourceClientOffset',
			value: function getSourceClientOffset() {
				return this.internalMonitor.getSourceClientOffset();
			}
		}, {
			key: 'getClientOffset',
			value: function getClientOffset() {
				return this.internalMonitor.getClientOffset();
			}
		}, {
			key: 'getDifferenceFromInitialOffset',
			value: function getDifferenceFromInitialOffset() {
				return this.internalMonitor.getDifferenceFromInitialOffset();
			}
		}]);
	
		return TargetMonitor;
	}();
	
	function createTargetMonitor(manager) {
		return new TargetMonitor(manager);
	}

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = registerSource;
	function registerSource(type, source, manager) {
		var registry = manager.getRegistry();
		var sourceId = registry.addSource(type, source);
	
		function unregisterSource() {
			registry.removeSource(sourceId);
		}
	
		return {
			handlerId: sourceId,
			unregister: unregisterSource
		};
	}

/***/ }),
/* 1742 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = registerTarget;
	function registerTarget(type, target, manager) {
		var registry = manager.getRegistry();
		var targetId = registry.addTarget(type, target);
	
		function unregisterTarget() {
			registry.removeTarget(targetId);
		}
	
		return {
			handlerId: targetId,
			unregister: unregisterTarget
		};
	}

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = cloneWithRef;
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cloneWithRef(element, newRef) {
		var previousRef = element.ref;
		(0, _invariant2.default)(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');
	
		if (!previousRef) {
			// When there is no ref on the element, use the new ref directly
			return (0, _react.cloneElement)(element, {
				ref: newRef
			});
		}
	
		return (0, _react.cloneElement)(element, {
			ref: function ref(node) {
				newRef(node);
	
				if (previousRef) {
					previousRef(node);
				}
			}
		});
	}

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(85);
	
	var focusNode = __webpack_require__(676);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(294);
	var ExecutionEnvironment = __webpack_require__(105);
	var FallbackCompositionState = __webpack_require__(1752);
	var SyntheticCompositionEvent = __webpack_require__(1789);
	var SyntheticInputEvent = __webpack_require__(1792);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(824);
	var ExecutionEnvironment = __webpack_require__(105);
	var ReactInstrumentation = __webpack_require__(141);
	
	var camelizeStyleName = __webpack_require__(674);
	var dangerousStyleValue = __webpack_require__(1798);
	var hyphenateStyleName = __webpack_require__(458);
	var memoizeStringOnly = __webpack_require__(459);
	var warning = __webpack_require__(61);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(293);
	var EventPropagators = __webpack_require__(294);
	var ExecutionEnvironment = __webpack_require__(105);
	var ReactDOMComponentTree = __webpack_require__(85);
	var ReactUpdates = __webpack_require__(155);
	var SyntheticEvent = __webpack_require__(166);
	
	var inputValueTracking = __webpack_require__(840);
	var getEventTarget = __webpack_require__(522);
	var isEventSupported = __webpack_require__(523);
	var isTextInputElement = __webpack_require__(842);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var DOMLazyTree = __webpack_require__(245);
	var ExecutionEnvironment = __webpack_require__(105);
	
	var createNodesFromMarkup = __webpack_require__(1299);
	var emptyFunction = __webpack_require__(113);
	var invariant = __webpack_require__(28);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ }),
/* 1750 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(294);
	var ReactDOMComponentTree = __webpack_require__(85);
	var SyntheticMouseEvent = __webpack_require__(375);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var PooledClass = __webpack_require__(214);
	
	var getTextContentAccessor = __webpack_require__(839);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(246);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(247);
	
	var instantiateReactComponent = __webpack_require__(841);
	var KeyEscapeUtils = __webpack_require__(514);
	var shouldUpdateReactComponent = __webpack_require__(524);
	var traverseAllChildren = __webpack_require__(844);
	var warning = __webpack_require__(61);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(886);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(140)))

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(510);
	var ReactDOMIDOperations = __webpack_require__(1762);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64),
	    _assign = __webpack_require__(40);
	
	var React = __webpack_require__(252);
	var ReactComponentEnvironment = __webpack_require__(516);
	var ReactCurrentOwner = __webpack_require__(169);
	var ReactErrorUtils = __webpack_require__(517);
	var ReactInstanceMap = __webpack_require__(295);
	var ReactInstrumentation = __webpack_require__(141);
	var ReactNodeTypes = __webpack_require__(834);
	var ReactReconciler = __webpack_require__(247);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(336);
	var invariant = __webpack_require__(28);
	var shallowEqual = __webpack_require__(276);
	var shouldUpdateReactComponent = __webpack_require__(524);
	var warning = __webpack_require__(61);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(85);
	var ReactDefaultInjection = __webpack_require__(1770);
	var ReactMount = __webpack_require__(833);
	var ReactReconciler = __webpack_require__(247);
	var ReactUpdates = __webpack_require__(155);
	var ReactVersion = __webpack_require__(1783);
	
	var findDOMNode = __webpack_require__(1799);
	var getHostComponentFromComposite = __webpack_require__(838);
	var renderSubtreeIntoContainer = __webpack_require__(1806);
	var warning = __webpack_require__(61);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64),
	    _assign = __webpack_require__(40);
	
	var AutoFocusUtils = __webpack_require__(1745);
	var CSSPropertyOperations = __webpack_require__(1747);
	var DOMLazyTree = __webpack_require__(245);
	var DOMNamespaces = __webpack_require__(511);
	var DOMProperty = __webpack_require__(246);
	var DOMPropertyOperations = __webpack_require__(826);
	var EventPluginHub = __webpack_require__(293);
	var EventPluginRegistry = __webpack_require__(512);
	var ReactBrowserEventEmitter = __webpack_require__(374);
	var ReactDOMComponentFlags = __webpack_require__(827);
	var ReactDOMComponentTree = __webpack_require__(85);
	var ReactDOMInput = __webpack_require__(1763);
	var ReactDOMOption = __webpack_require__(1764);
	var ReactDOMSelect = __webpack_require__(828);
	var ReactDOMTextarea = __webpack_require__(1767);
	var ReactInstrumentation = __webpack_require__(141);
	var ReactMultiChild = __webpack_require__(1776);
	var ReactServerRenderingTransaction = __webpack_require__(1781);
	
	var emptyFunction = __webpack_require__(113);
	var escapeTextContentForBrowser = __webpack_require__(377);
	var invariant = __webpack_require__(28);
	var isEventSupported = __webpack_require__(523);
	var shallowEqual = __webpack_require__(276);
	var inputValueTracking = __webpack_require__(840);
	var validateDOMNesting = __webpack_require__(525);
	var warning = __webpack_require__(61);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(525);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var DOMLazyTree = __webpack_require__(245);
	var ReactDOMComponentTree = __webpack_require__(85);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 1761 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(510);
	var ReactDOMComponentTree = __webpack_require__(85);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64),
	    _assign = __webpack_require__(40);
	
	var DOMPropertyOperations = __webpack_require__(826);
	var LinkedValueUtils = __webpack_require__(515);
	var ReactDOMComponentTree = __webpack_require__(85);
	var ReactUpdates = __webpack_require__(155);
	
	var invariant = __webpack_require__(28);
	var warning = __webpack_require__(61);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var React = __webpack_require__(252);
	var ReactDOMComponentTree = __webpack_require__(85);
	var ReactDOMSelect = __webpack_require__(828);
	
	var warning = __webpack_require__(61);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(105);
	
	var getNodeForCharacterOffset = __webpack_require__(1803);
	var getTextContentAccessor = __webpack_require__(839);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64),
	    _assign = __webpack_require__(40);
	
	var DOMChildrenOperations = __webpack_require__(510);
	var DOMLazyTree = __webpack_require__(245);
	var ReactDOMComponentTree = __webpack_require__(85);
	
	var escapeTextContentForBrowser = __webpack_require__(377);
	var invariant = __webpack_require__(28);
	var validateDOMNesting = __webpack_require__(525);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64),
	    _assign = __webpack_require__(40);
	
	var LinkedValueUtils = __webpack_require__(515);
	var ReactDOMComponentTree = __webpack_require__(85);
	var ReactUpdates = __webpack_require__(155);
	
	var invariant = __webpack_require__(28);
	var warning = __webpack_require__(61);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var invariant = __webpack_require__(28);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var ReactUpdates = __webpack_require__(155);
	var Transaction = __webpack_require__(376);
	
	var emptyFunction = __webpack_require__(113);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1744);
	var BeforeInputEventPlugin = __webpack_require__(1746);
	var ChangeEventPlugin = __webpack_require__(1748);
	var DefaultEventPluginOrder = __webpack_require__(1750);
	var EnterLeaveEventPlugin = __webpack_require__(1751);
	var HTMLDOMPropertyConfig = __webpack_require__(1753);
	var ReactComponentBrowserEnvironment = __webpack_require__(1755);
	var ReactDOMComponent = __webpack_require__(1758);
	var ReactDOMComponentTree = __webpack_require__(85);
	var ReactDOMEmptyComponent = __webpack_require__(1760);
	var ReactDOMTreeTraversal = __webpack_require__(1768);
	var ReactDOMTextComponent = __webpack_require__(1766);
	var ReactDefaultBatchingStrategy = __webpack_require__(1769);
	var ReactEventListener = __webpack_require__(1773);
	var ReactInjection = __webpack_require__(1774);
	var ReactReconcileTransaction = __webpack_require__(1779);
	var SVGDOMPropertyConfig = __webpack_require__(1784);
	var SelectEventPlugin = __webpack_require__(1785);
	var SimpleEventPlugin = __webpack_require__(1786);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 1771 */
887,
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(293);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var EventListener = __webpack_require__(670);
	var ExecutionEnvironment = __webpack_require__(105);
	var PooledClass = __webpack_require__(214);
	var ReactDOMComponentTree = __webpack_require__(85);
	var ReactUpdates = __webpack_require__(155);
	
	var getEventTarget = __webpack_require__(522);
	var getUnboundedScrollPosition = __webpack_require__(677);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(246);
	var EventPluginHub = __webpack_require__(293);
	var EventPluginUtils = __webpack_require__(513);
	var ReactComponentEnvironment = __webpack_require__(516);
	var ReactEmptyComponent = __webpack_require__(829);
	var ReactBrowserEventEmitter = __webpack_require__(374);
	var ReactHostComponent = __webpack_require__(831);
	var ReactUpdates = __webpack_require__(155);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1797);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var ReactComponentEnvironment = __webpack_require__(516);
	var ReactInstanceMap = __webpack_require__(295);
	var ReactInstrumentation = __webpack_require__(141);
	
	var ReactCurrentOwner = __webpack_require__(169);
	var ReactReconciler = __webpack_require__(247);
	var ReactChildReconciler = __webpack_require__(1754);
	
	var emptyFunction = __webpack_require__(113);
	var flattenChildren = __webpack_require__(1800);
	var invariant = __webpack_require__(28);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var invariant = __webpack_require__(28);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 1778 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var CallbackQueue = __webpack_require__(825);
	var PooledClass = __webpack_require__(214);
	var ReactBrowserEventEmitter = __webpack_require__(374);
	var ReactInputSelection = __webpack_require__(832);
	var ReactInstrumentation = __webpack_require__(141);
	var Transaction = __webpack_require__(376);
	var ReactUpdateQueue = __webpack_require__(518);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1777);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var PooledClass = __webpack_require__(214);
	var Transaction = __webpack_require__(376);
	var ReactInstrumentation = __webpack_require__(141);
	var ReactServerUpdateQueue = __webpack_require__(1782);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(518);
	
	var warning = __webpack_require__(61);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 1783 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 1784 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(294);
	var ExecutionEnvironment = __webpack_require__(105);
	var ReactDOMComponentTree = __webpack_require__(85);
	var ReactInputSelection = __webpack_require__(832);
	var SyntheticEvent = __webpack_require__(166);
	
	var getActiveElement = __webpack_require__(337);
	var isTextInputElement = __webpack_require__(842);
	var shallowEqual = __webpack_require__(276);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var EventListener = __webpack_require__(670);
	var EventPropagators = __webpack_require__(294);
	var ReactDOMComponentTree = __webpack_require__(85);
	var SyntheticAnimationEvent = __webpack_require__(1787);
	var SyntheticClipboardEvent = __webpack_require__(1788);
	var SyntheticEvent = __webpack_require__(166);
	var SyntheticFocusEvent = __webpack_require__(1791);
	var SyntheticKeyboardEvent = __webpack_require__(1793);
	var SyntheticMouseEvent = __webpack_require__(375);
	var SyntheticDragEvent = __webpack_require__(1790);
	var SyntheticTouchEvent = __webpack_require__(1794);
	var SyntheticTransitionEvent = __webpack_require__(1795);
	var SyntheticUIEvent = __webpack_require__(296);
	var SyntheticWheelEvent = __webpack_require__(1796);
	
	var emptyFunction = __webpack_require__(113);
	var getEventCharCode = __webpack_require__(520);
	var invariant = __webpack_require__(28);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(166);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(166);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(166);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(375);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(296);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(166);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(296);
	
	var getEventCharCode = __webpack_require__(520);
	var getEventKey = __webpack_require__(1801);
	var getEventModifierState = __webpack_require__(521);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(296);
	
	var getEventModifierState = __webpack_require__(521);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(166);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(375);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 1797 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(824);
	var warning = __webpack_require__(61);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var ReactCurrentOwner = __webpack_require__(169);
	var ReactDOMComponentTree = __webpack_require__(85);
	var ReactInstanceMap = __webpack_require__(295);
	
	var getHostComponentFromComposite = __webpack_require__(838);
	var invariant = __webpack_require__(28);
	var warning = __webpack_require__(61);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(514);
	var traverseAllChildren = __webpack_require__(844);
	var warning = __webpack_require__(61);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(886);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(140)))

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(520);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 1802 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 1803 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(105);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(377);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(833);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? module.exports = factory(__webpack_require__(31), __webpack_require__(1)) :
		typeof define === 'function' && define.amd ? define(['react-dom', 'react'], factory) :
		(global.ReactDraggable = factory(global.ReactDOM,global.React));
	}(this, (function (ReactDOM,React) { 'use strict';
	
		ReactDOM = ReactDOM && ReactDOM.hasOwnProperty('default') ? ReactDOM['default'] : ReactDOM;
		React = React && React.hasOwnProperty('default') ? React['default'] : React;
	
		function createCommonjsModule(fn, module) {
			return module = { exports: {} }, fn(module, module.exports), module.exports;
		}
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 * 
		 */
	
		function makeEmptyFunction(arg) {
		  return function () {
		    return arg;
		  };
		}
	
		/**
		 * This function accepts and discards inputs; it has no side effects. This is
		 * primarily useful idiomatically for overridable function endpoints which
		 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
		 */
		var emptyFunction = function emptyFunction() {};
	
		emptyFunction.thatReturns = makeEmptyFunction;
		emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
		emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
		emptyFunction.thatReturnsNull = makeEmptyFunction(null);
		emptyFunction.thatReturnsThis = function () {
		  return this;
		};
		emptyFunction.thatReturnsArgument = function (arg) {
		  return arg;
		};
	
		var emptyFunction_1 = emptyFunction;
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 */
	
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
	
		var validateFormat = function validateFormat(format) {};
	
		{
		  validateFormat = function validateFormat(format) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  };
		}
	
		function invariant(condition, format, a, b, c, d, e, f) {
		  validateFormat(format);
	
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
	
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
	
		var invariant_1 = invariant;
	
		/**
		 * Similar to invariant but only logs a warning if the condition is not met.
		 * This can be used to log issues in development environments in critical
		 * paths. Removing the logging code for production environments will keep the
		 * same logic and follow the same code paths.
		 */
	
		var warning = emptyFunction_1;
	
		{
		  var printWarning = function printWarning(format) {
		    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		      args[_key - 1] = arguments[_key];
		    }
	
		    var argIndex = 0;
		    var message = 'Warning: ' + format.replace(/%s/g, function () {
		      return args[argIndex++];
		    });
		    if (typeof console !== 'undefined') {
		      console.error(message);
		    }
		    try {
		      // --- Welcome to debugging React ---
		      // This error was thrown as a convenience so that you can use this stack
		      // to find the callsite that caused this warning to fire.
		      throw new Error(message);
		    } catch (x) {}
		  };
	
		  warning = function warning(condition, format) {
		    if (format === undefined) {
		      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
		    }
	
		    if (format.indexOf('Failed Composite propType: ') === 0) {
		      return; // Ignore CompositeComponent proptype check.
		    }
	
		    if (!condition) {
		      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		        args[_key2 - 2] = arguments[_key2];
		      }
	
		      printWarning.apply(undefined, [format].concat(args));
		    }
		  };
		}
	
		var warning_1 = warning;
	
		/*
		object-assign
		(c) Sindre Sorhus
		@license MIT
		*/
		/* eslint-disable no-unused-vars */
		var getOwnPropertySymbols = Object.getOwnPropertySymbols;
		var hasOwnProperty = Object.prototype.hasOwnProperty;
		var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
		function toObject(val) {
			if (val === null || val === undefined) {
				throw new TypeError('Object.assign cannot be called with null or undefined');
			}
	
			return Object(val);
		}
	
		function shouldUseNative() {
			try {
				if (!Object.assign) {
					return false;
				}
	
				// Detect buggy property enumeration order in older V8 versions.
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=4118
				var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
				test1[5] = 'de';
				if (Object.getOwnPropertyNames(test1)[0] === '5') {
					return false;
				}
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test2 = {};
				for (var i = 0; i < 10; i++) {
					test2['_' + String.fromCharCode(i)] = i;
				}
				var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
					return test2[n];
				});
				if (order2.join('') !== '0123456789') {
					return false;
				}
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test3 = {};
				'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
					test3[letter] = letter;
				});
				if (Object.keys(Object.assign({}, test3)).join('') !==
						'abcdefghijklmnopqrst') {
					return false;
				}
	
				return true;
			} catch (err) {
				// We don't expect any of the above to throw, but better to be safe.
				return false;
			}
		}
	
		var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
			var from;
			var to = toObject(target);
			var symbols;
	
			for (var s = 1; s < arguments.length; s++) {
				from = Object(arguments[s]);
	
				for (var key in from) {
					if (hasOwnProperty.call(from, key)) {
						to[key] = from[key];
					}
				}
	
				if (getOwnPropertySymbols) {
					symbols = getOwnPropertySymbols(from);
					for (var i = 0; i < symbols.length; i++) {
						if (propIsEnumerable.call(from, symbols[i])) {
							to[symbols[i]] = from[symbols[i]];
						}
					}
				}
			}
	
			return to;
		};
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
	
		var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
		var ReactPropTypesSecret_1 = ReactPropTypesSecret;
	
		{
		  var invariant$1 = invariant_1;
		  var warning$1 = warning_1;
		  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
		  var loggedTypeFailures = {};
		}
	
		/**
		 * Assert that the values match with the type specs.
		 * Error messages are memorized and will only be shown once.
		 *
		 * @param {object} typeSpecs Map of name to a ReactPropType
		 * @param {object} values Runtime values that need to be type-checked
		 * @param {string} location e.g. "prop", "context", "child context"
		 * @param {string} componentName Name of the component for error messages.
		 * @param {?Function} getStack Returns the component stack.
		 * @private
		 */
		function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
		  {
		    for (var typeSpecName in typeSpecs) {
		      if (typeSpecs.hasOwnProperty(typeSpecName)) {
		        var error;
		        // Prop type validation may throw. In case they do, we don't want to
		        // fail the render phase where it didn't fail before. So we log it.
		        // After these have been cleaned up, we'll let them throw.
		        try {
		          // This is intentionally an invariant that gets caught. It's the same
		          // behavior as without this statement except with a better message.
		          invariant$1(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
		          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
		        } catch (ex) {
		          error = ex;
		        }
		        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
		        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
		          // Only monitor this failure once because there tends to be a lot of the
		          // same error.
		          loggedTypeFailures[error.message] = true;
	
		          var stack = getStack ? getStack() : '';
	
		          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
		        }
		      }
		    }
		  }
		}
	
		var checkPropTypes_1 = checkPropTypes;
	
		var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
		  /* global Symbol */
		  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
		  /**
		   * Returns the iterator method function contained on the iterable object.
		   *
		   * Be sure to invoke the function with the iterable as context:
		   *
		   *     var iteratorFn = getIteratorFn(myIterable);
		   *     if (iteratorFn) {
		   *       var iterator = iteratorFn.call(myIterable);
		   *       ...
		   *     }
		   *
		   * @param {?object} maybeIterable
		   * @return {?function}
		   */
		  function getIteratorFn(maybeIterable) {
		    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
		    if (typeof iteratorFn === 'function') {
		      return iteratorFn;
		    }
		  }
	
		  /**
		   * Collection of methods that allow declaration and validation of props that are
		   * supplied to React components. Example usage:
		   *
		   *   var Props = require('ReactPropTypes');
		   *   var MyArticle = React.createClass({
		   *     propTypes: {
		   *       // An optional string prop named "description".
		   *       description: Props.string,
		   *
		   *       // A required enum prop named "category".
		   *       category: Props.oneOf(['News','Photos']).isRequired,
		   *
		   *       // A prop named "dialog" that requires an instance of Dialog.
		   *       dialog: Props.instanceOf(Dialog).isRequired
		   *     },
		   *     render: function() { ... }
		   *   });
		   *
		   * A more formal specification of how these methods are used:
		   *
		   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
		   *   decl := ReactPropTypes.{type}(.isRequired)?
		   *
		   * Each and every declaration produces a function with the same signature. This
		   * allows the creation of custom validation functions. For example:
		   *
		   *  var MyLink = React.createClass({
		   *    propTypes: {
		   *      // An optional string or URI prop named "href".
		   *      href: function(props, propName, componentName) {
		   *        var propValue = props[propName];
		   *        if (propValue != null && typeof propValue !== 'string' &&
		   *            !(propValue instanceof URI)) {
		   *          return new Error(
		   *            'Expected a string or an URI for ' + propName + ' in ' +
		   *            componentName
		   *          );
		   *        }
		   *      }
		   *    },
		   *    render: function() {...}
		   *  });
		   *
		   * @internal
		   */
	
		  var ANONYMOUS = '<<anonymous>>';
	
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
		  var ReactPropTypes = {
		    array: createPrimitiveTypeChecker('array'),
		    bool: createPrimitiveTypeChecker('boolean'),
		    func: createPrimitiveTypeChecker('function'),
		    number: createPrimitiveTypeChecker('number'),
		    object: createPrimitiveTypeChecker('object'),
		    string: createPrimitiveTypeChecker('string'),
		    symbol: createPrimitiveTypeChecker('symbol'),
	
		    any: createAnyTypeChecker(),
		    arrayOf: createArrayOfTypeChecker,
		    element: createElementTypeChecker(),
		    instanceOf: createInstanceTypeChecker,
		    node: createNodeChecker(),
		    objectOf: createObjectOfTypeChecker,
		    oneOf: createEnumTypeChecker,
		    oneOfType: createUnionTypeChecker,
		    shape: createShapeTypeChecker,
		    exact: createStrictShapeTypeChecker,
		  };
	
		  /**
		   * inlined Object.is polyfill to avoid requiring consumers ship their own
		   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
		   */
		  /*eslint-disable no-self-compare*/
		  function is(x, y) {
		    // SameValue algorithm
		    if (x === y) {
		      // Steps 1-5, 7-10
		      // Steps 6.b-6.e: +0 != -0
		      return x !== 0 || 1 / x === 1 / y;
		    } else {
		      // Step 6.a: NaN == NaN
		      return x !== x && y !== y;
		    }
		  }
		  /*eslint-enable no-self-compare*/
	
		  /**
		   * We use an Error-like object for backward compatibility as people may call
		   * PropTypes directly and inspect their output. However, we don't use real
		   * Errors anymore. We don't inspect their stack anyway, and creating them
		   * is prohibitively expensive if they are created too often, such as what
		   * happens in oneOfType() for any type before the one that matched.
		   */
		  function PropTypeError(message) {
		    this.message = message;
		    this.stack = '';
		  }
		  // Make `instanceof Error` still work for returned errors.
		  PropTypeError.prototype = Error.prototype;
	
		  function createChainableTypeChecker(validate) {
		    {
		      var manualPropTypeCallCache = {};
		      var manualPropTypeWarningCount = 0;
		    }
		    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
		      componentName = componentName || ANONYMOUS;
		      propFullName = propFullName || propName;
	
		      if (secret !== ReactPropTypesSecret_1) {
		        if (throwOnDirectAccess) {
		          // New behavior only for users of `prop-types` package
		          invariant_1(
		            false,
		            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		            'Use `PropTypes.checkPropTypes()` to call them. ' +
		            'Read more at http://fb.me/use-check-prop-types'
		          );
		        } else if ("development" !== 'production' && typeof console !== 'undefined') {
		          // Old behavior for people using React.PropTypes
		          var cacheKey = componentName + ':' + propName;
		          if (
		            !manualPropTypeCallCache[cacheKey] &&
		            // Avoid spamming the console because they are often not actionable except for lib authors
		            manualPropTypeWarningCount < 3
		          ) {
		            warning_1(
		              false,
		              'You are manually calling a React.PropTypes validation ' +
		              'function for the `%s` prop on `%s`. This is deprecated ' +
		              'and will throw in the standalone `prop-types` package. ' +
		              'You may be seeing this warning due to a third-party PropTypes ' +
		              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
		              propFullName,
		              componentName
		            );
		            manualPropTypeCallCache[cacheKey] = true;
		            manualPropTypeWarningCount++;
		          }
		        }
		      }
		      if (props[propName] == null) {
		        if (isRequired) {
		          if (props[propName] === null) {
		            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
		          }
		          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
		        }
		        return null;
		      } else {
		        return validate(props, propName, componentName, location, propFullName);
		      }
		    }
	
		    var chainedCheckType = checkType.bind(null, false);
		    chainedCheckType.isRequired = checkType.bind(null, true);
	
		    return chainedCheckType;
		  }
	
		  function createPrimitiveTypeChecker(expectedType) {
		    function validate(props, propName, componentName, location, propFullName, secret) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== expectedType) {
		        // `propValue` being instance of, say, date/regexp, pass the 'object'
		        // check, but we can offer a more precise error message here rather than
		        // 'of type `object`'.
		        var preciseType = getPreciseType(propValue);
	
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createAnyTypeChecker() {
		    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
		  }
	
		  function createArrayOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
		      }
		      var propValue = props[propName];
		      if (!Array.isArray(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
		      }
		      for (var i = 0; i < propValue.length; i++) {
		        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
		        if (error instanceof Error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createElementTypeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      if (!isValidElement(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createInstanceTypeChecker(expectedClass) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!(props[propName] instanceof expectedClass)) {
		        var expectedClassName = expectedClass.name || ANONYMOUS;
		        var actualClassName = getClassName(props[propName]);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createEnumTypeChecker(expectedValues) {
		    if (!Array.isArray(expectedValues)) {
		      warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.');
		      return emptyFunction_1.thatReturnsNull;
		    }
	
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      for (var i = 0; i < expectedValues.length; i++) {
		        if (is(propValue, expectedValues[i])) {
		          return null;
		        }
		      }
	
		      var valuesString = JSON.stringify(expectedValues);
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createObjectOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
		      }
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
		      }
		      for (var key in propValue) {
		        if (propValue.hasOwnProperty(key)) {
		          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
		          if (error instanceof Error) {
		            return error;
		          }
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createUnionTypeChecker(arrayOfTypeCheckers) {
		    if (!Array.isArray(arrayOfTypeCheckers)) {
		      warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.');
		      return emptyFunction_1.thatReturnsNull;
		    }
	
		    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		      var checker = arrayOfTypeCheckers[i];
		      if (typeof checker !== 'function') {
		        warning_1(
		          false,
		          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
		          'received %s at index %s.',
		          getPostfixForTypeWarning(checker),
		          i
		        );
		        return emptyFunction_1.thatReturnsNull;
		      }
		    }
	
		    function validate(props, propName, componentName, location, propFullName) {
		      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		        var checker = arrayOfTypeCheckers[i];
		        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
		          return null;
		        }
		      }
	
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createNodeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!isNode(props[propName])) {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      for (var key in shapeTypes) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          continue;
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createStrictShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      // We need to check all keys in case some are required but missing from
		      // props.
		      var allKeys = objectAssign({}, props[propName], shapeTypes);
		      for (var key in allKeys) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          return new PropTypeError(
		            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
		            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
		            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
		          );
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
	
		    return createChainableTypeChecker(validate);
		  }
	
		  function isNode(propValue) {
		    switch (typeof propValue) {
		      case 'number':
		      case 'string':
		      case 'undefined':
		        return true;
		      case 'boolean':
		        return !propValue;
		      case 'object':
		        if (Array.isArray(propValue)) {
		          return propValue.every(isNode);
		        }
		        if (propValue === null || isValidElement(propValue)) {
		          return true;
		        }
	
		        var iteratorFn = getIteratorFn(propValue);
		        if (iteratorFn) {
		          var iterator = iteratorFn.call(propValue);
		          var step;
		          if (iteratorFn !== propValue.entries) {
		            while (!(step = iterator.next()).done) {
		              if (!isNode(step.value)) {
		                return false;
		              }
		            }
		          } else {
		            // Iterator will provide entry [k,v] tuples rather than values.
		            while (!(step = iterator.next()).done) {
		              var entry = step.value;
		              if (entry) {
		                if (!isNode(entry[1])) {
		                  return false;
		                }
		              }
		            }
		          }
		        } else {
		          return false;
		        }
	
		        return true;
		      default:
		        return false;
		    }
		  }
	
		  function isSymbol(propType, propValue) {
		    // Native Symbol.
		    if (propType === 'symbol') {
		      return true;
		    }
	
		    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
		    if (propValue['@@toStringTag'] === 'Symbol') {
		      return true;
		    }
	
		    // Fallback for non-spec compliant Symbols which are polyfilled.
		    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
		      return true;
		    }
	
		    return false;
		  }
	
		  // Equivalent of `typeof` but with special handling for array and regexp.
		  function getPropType(propValue) {
		    var propType = typeof propValue;
		    if (Array.isArray(propValue)) {
		      return 'array';
		    }
		    if (propValue instanceof RegExp) {
		      // Old webkits (at least until Android 4.0) return 'function' rather than
		      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
		      // passes PropTypes.object.
		      return 'object';
		    }
		    if (isSymbol(propType, propValue)) {
		      return 'symbol';
		    }
		    return propType;
		  }
	
		  // This handles more types than `getPropType`. Only used for error messages.
		  // See `createPrimitiveTypeChecker`.
		  function getPreciseType(propValue) {
		    if (typeof propValue === 'undefined' || propValue === null) {
		      return '' + propValue;
		    }
		    var propType = getPropType(propValue);
		    if (propType === 'object') {
		      if (propValue instanceof Date) {
		        return 'date';
		      } else if (propValue instanceof RegExp) {
		        return 'regexp';
		      }
		    }
		    return propType;
		  }
	
		  // Returns a string that is postfixed to a warning about an invalid type.
		  // For example, "undefined" or "of type array"
		  function getPostfixForTypeWarning(value) {
		    var type = getPreciseType(value);
		    switch (type) {
		      case 'array':
		      case 'object':
		        return 'an ' + type;
		      case 'boolean':
		      case 'date':
		      case 'regexp':
		        return 'a ' + type;
		      default:
		        return type;
		    }
		  }
	
		  // Returns class name of the object, if any.
		  function getClassName(propValue) {
		    if (!propValue.constructor || !propValue.constructor.name) {
		      return ANONYMOUS;
		    }
		    return propValue.constructor.name;
		  }
	
		  ReactPropTypes.checkPropTypes = checkPropTypes_1;
		  ReactPropTypes.PropTypes = ReactPropTypes;
	
		  return ReactPropTypes;
		};
	
		var propTypes = createCommonjsModule(function (module) {
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
	
		{
		  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
		    Symbol.for &&
		    Symbol.for('react.element')) ||
		    0xeac7;
	
		  var isValidElement = function(object) {
		    return typeof object === 'object' &&
		      object !== null &&
		      object.$$typeof === REACT_ELEMENT_TYPE;
		  };
	
		  // By explicitly using `prop-types` you are opting into new development behavior.
		  // http://fb.me/prop-types-in-prod
		  var throwOnDirectAccess = true;
		  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
		}
		});
	
		var classnames = createCommonjsModule(function (module) {
		/*!
		  Copyright (c) 2016 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/classnames
		*/
		/* global define */
	
		(function () {
	
			var hasOwn = {}.hasOwnProperty;
	
			function classNames () {
				var classes = [];
	
				for (var i = 0; i < arguments.length; i++) {
					var arg = arguments[i];
					if (!arg) continue;
	
					var argType = typeof arg;
	
					if (argType === 'string' || argType === 'number') {
						classes.push(arg);
					} else if (Array.isArray(arg)) {
						classes.push(classNames.apply(null, arg));
					} else if (argType === 'object') {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					}
				}
	
				return classes.join(' ');
			}
	
			if ('object' !== 'undefined' && module.exports) {
				module.exports = classNames;
			} else if (false) {
				// register as 'classnames', consistent with npm package name
				undefined('classnames', [], function () {
					return classNames;
				});
			} else {
				window.classNames = classNames;
			}
		}());
		});
	
		// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
		function findInArray(array /*: Array<any> | TouchList*/, callback /*: Function*/) /*: any*/ {
		  for (var i = 0, length = array.length; i < length; i++) {
		    if (callback.apply(callback, [array[i], i, array])) return array[i];
		  }
		}
	
		function isFunction(func /*: any*/) /*: boolean*/ {
		  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
		}
	
		function isNum(num /*: any*/) /*: boolean*/ {
		  return typeof num === 'number' && !isNaN(num);
		}
	
		function int(a /*: string*/) /*: number*/ {
		  return parseInt(a, 10);
		}
	
		function dontSetMe(props /*: Object*/, propName /*: string*/, componentName /*: string*/) {
		  if (props[propName]) {
		    return new Error('Invalid prop ' + propName + ' passed to ' + componentName + ' - do not set this, set it on the child.');
		  }
		}
	
		var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
		function getPrefix() /*: string*/ {
		  var prop /*: string*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
	
		  // Checking specifically for 'window.document' is for pseudo-browser server-side
		  // environments that define 'window' as the global context.
		  // E.g. React-rails (see https://github.com/reactjs/react-rails/pull/84)
		  if (typeof window === 'undefined' || typeof window.document === 'undefined') return '';
	
		  var style = window.document.documentElement.style;
	
		  if (prop in style) return '';
	
		  for (var i = 0; i < prefixes.length; i++) {
		    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
		  }
	
		  return '';
		}
	
		function browserPrefixToKey(prop /*: string*/, prefix /*: string*/) /*: string*/ {
		  return prefix ? '' + prefix + kebabToTitleCase(prop) : prop;
		}
	
		function kebabToTitleCase(str /*: string*/) /*: string*/ {
		  var out = '';
		  var shouldCapitalize = true;
		  for (var i = 0; i < str.length; i++) {
		    if (shouldCapitalize) {
		      out += str[i].toUpperCase();
		      shouldCapitalize = false;
		    } else if (str[i] === '-') {
		      shouldCapitalize = true;
		    } else {
		      out += str[i];
		    }
		  }
		  return out;
		}
	
		// Default export is the prefix itself, like 'Moz', 'Webkit', etc
		// Note that you may have to re-test for certain things; for instance, Chrome 50
		// can handle unprefixed `transform`, but not unprefixed `user-select`
		var browserPrefix = getPrefix();
	
		var classCallCheck = function (instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		};
	
		var createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];
		      descriptor.enumerable = descriptor.enumerable || false;
		      descriptor.configurable = true;
		      if ("value" in descriptor) descriptor.writable = true;
		      Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }
	
		  return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);
		    if (staticProps) defineProperties(Constructor, staticProps);
		    return Constructor;
		  };
		}();
	
		var defineProperty = function (obj, key, value) {
		  if (key in obj) {
		    Object.defineProperty(obj, key, {
		      value: value,
		      enumerable: true,
		      configurable: true,
		      writable: true
		    });
		  } else {
		    obj[key] = value;
		  }
	
		  return obj;
		};
	
		var _extends = Object.assign || function (target) {
		  for (var i = 1; i < arguments.length; i++) {
		    var source = arguments[i];
	
		    for (var key in source) {
		      if (Object.prototype.hasOwnProperty.call(source, key)) {
		        target[key] = source[key];
		      }
		    }
		  }
	
		  return target;
		};
	
		var inherits = function (subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		  }
	
		  subClass.prototype = Object.create(superClass && superClass.prototype, {
		    constructor: {
		      value: subClass,
		      enumerable: false,
		      writable: true,
		      configurable: true
		    }
		  });
		  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		};
	
		var possibleConstructorReturn = function (self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }
	
		  return call && (typeof call === "object" || typeof call === "function") ? call : self;
		};
	
		var slicedToArray = function () {
		  function sliceIterator(arr, i) {
		    var _arr = [];
		    var _n = true;
		    var _d = false;
		    var _e = undefined;
	
		    try {
		      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
		        _arr.push(_s.value);
	
		        if (i && _arr.length === i) break;
		      }
		    } catch (err) {
		      _d = true;
		      _e = err;
		    } finally {
		      try {
		        if (!_n && _i["return"]) _i["return"]();
		      } finally {
		        if (_d) throw _e;
		      }
		    }
	
		    return _arr;
		  }
	
		  return function (arr, i) {
		    if (Array.isArray(arr)) {
		      return arr;
		    } else if (Symbol.iterator in Object(arr)) {
		      return sliceIterator(arr, i);
		    } else {
		      throw new TypeError("Invalid attempt to destructure non-iterable instance");
		    }
		  };
		}();
	
		/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/
	
	
		var matchesSelectorFunc = '';
		function matchesSelector(el /*: Node*/, selector /*: string*/) /*: boolean*/ {
		  if (!matchesSelectorFunc) {
		    matchesSelectorFunc = findInArray(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
		      // $FlowIgnore: Doesn't think elements are indexable
		      return isFunction(el[method]);
		    });
		  }
	
		  // Might not be found entirely (not an Element?) - in that case, bail
		  // $FlowIgnore: Doesn't think elements are indexable
		  if (!isFunction(el[matchesSelectorFunc])) return false;
	
		  // $FlowIgnore: Doesn't think elements are indexable
		  return el[matchesSelectorFunc](selector);
		}
	
		// Works up the tree to the draggable itself attempting to match selector.
		function matchesSelectorAndParentsTo(el /*: Node*/, selector /*: string*/, baseNode /*: Node*/) /*: boolean*/ {
		  var node = el;
		  do {
		    if (matchesSelector(node, selector)) return true;
		    if (node === baseNode) return false;
		    node = node.parentNode;
		  } while (node);
	
		  return false;
		}
	
		function addEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
		  if (!el) {
		    return;
		  }
		  if (el.attachEvent) {
		    el.attachEvent('on' + event, handler);
		  } else if (el.addEventListener) {
		    el.addEventListener(event, handler, true);
		  } else {
		    // $FlowIgnore: Doesn't think elements are indexable
		    el['on' + event] = handler;
		  }
		}
	
		function removeEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
		  if (!el) {
		    return;
		  }
		  if (el.detachEvent) {
		    el.detachEvent('on' + event, handler);
		  } else if (el.removeEventListener) {
		    el.removeEventListener(event, handler, true);
		  } else {
		    // $FlowIgnore: Doesn't think elements are indexable
		    el['on' + event] = null;
		  }
		}
	
		function outerHeight(node /*: HTMLElement*/) /*: number*/ {
		  // This is deliberately excluding margin for our calculations, since we are using
		  // offsetTop which is including margin. See getBoundPosition
		  var height = node.clientHeight;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  height += int(computedStyle.borderTopWidth);
		  height += int(computedStyle.borderBottomWidth);
		  return height;
		}
	
		function outerWidth(node /*: HTMLElement*/) /*: number*/ {
		  // This is deliberately excluding margin for our calculations, since we are using
		  // offsetLeft which is including margin. See getBoundPosition
		  var width = node.clientWidth;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  width += int(computedStyle.borderLeftWidth);
		  width += int(computedStyle.borderRightWidth);
		  return width;
		}
		function innerHeight(node /*: HTMLElement*/) /*: number*/ {
		  var height = node.clientHeight;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  height -= int(computedStyle.paddingTop);
		  height -= int(computedStyle.paddingBottom);
		  return height;
		}
	
		function innerWidth(node /*: HTMLElement*/) /*: number*/ {
		  var width = node.clientWidth;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  width -= int(computedStyle.paddingLeft);
		  width -= int(computedStyle.paddingRight);
		  return width;
		}
	
		// Get from offsetParent
		function offsetXYFromParent(evt /*: {clientX: number, clientY: number}*/, offsetParent /*: HTMLElement*/) /*: ControlPosition*/ {
		  var isBody = offsetParent === offsetParent.ownerDocument.body;
		  var offsetParentRect = isBody ? { left: 0, top: 0 } : offsetParent.getBoundingClientRect();
	
		  var x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left;
		  var y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top;
	
		  return { x: x, y: y };
		}
	
		function createCSSTransform(controlPos /*: ControlPosition*/, positionOffset /*: PositionOffsetControlPosition*/) /*: Object*/ {
		  var translation = getTranslation(controlPos, positionOffset, 'px');
		  return defineProperty({}, browserPrefixToKey('transform', browserPrefix), translation);
		}
	
		function createSVGTransform(controlPos /*: ControlPosition*/, positionOffset /*: PositionOffsetControlPosition*/) /*: string*/ {
		  var translation = getTranslation(controlPos, positionOffset, '');
		  return translation;
		}
		function getTranslation(_ref2, positionOffset /*: PositionOffsetControlPosition*/, unitSuffix /*: string*/) /*: string*/ {
		  var x = _ref2.x,
		      y = _ref2.y;
	
		  var translation = 'translate(' + x + unitSuffix + ',' + y + unitSuffix + ')';
		  if (positionOffset) {
		    var defaultX = '' + (typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
		    var defaultY = '' + (typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
		    translation = 'translate(' + defaultX + ', ' + defaultY + ')' + translation;
		  }
		  return translation;
		}
	
		function getTouch(e /*: MouseTouchEvent*/, identifier /*: number*/) /*: ?{clientX: number, clientY: number}*/ {
		  return e.targetTouches && findInArray(e.targetTouches, function (t) {
		    return identifier === t.identifier;
		  }) || e.changedTouches && findInArray(e.changedTouches, function (t) {
		    return identifier === t.identifier;
		  });
		}
	
		function getTouchIdentifier(e /*: MouseTouchEvent*/) /*: ?number*/ {
		  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
		  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
		}
	
		// User-select Hacks:
		//
		// Useful for preventing blue highlights all over everything when dragging.
	
		// Note we're passing `document` b/c we could be iframed
		function addUserSelectStyles(doc /*: ?Document*/) {
		  if (!doc) return;
		  var styleEl = doc.getElementById('react-draggable-style-el');
		  if (!styleEl) {
		    styleEl = doc.createElement('style');
		    styleEl.type = 'text/css';
		    styleEl.id = 'react-draggable-style-el';
		    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
		    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
		    doc.getElementsByTagName('head')[0].appendChild(styleEl);
		  }
		  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
		}
	
		function removeUserSelectStyles(doc /*: ?Document*/) {
		  try {
		    if (doc && doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection');
		    // $FlowIgnore: IE
		    if (doc.selection) {
		      // $FlowIgnore: IE
		      doc.selection.empty();
		    } else {
		      window.getSelection().removeAllRanges(); // remove selection caused by scroll
		    }
		  } catch (e) {
		    // probably IE
		  }
		}
	
		function styleHacks() /*: Object*/ {
		  var childStyle /*: Object*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
		  // Workaround IE pointer events; see #51
		  // https://github.com/mzabriskie/react-draggable/issues/51#issuecomment-103488278
		  return _extends({
		    touchAction: 'none'
		  }, childStyle);
		}
	
		function addClassName(el /*: HTMLElement*/, className /*: string*/) {
		  if (el.classList) {
		    el.classList.add(className);
		  } else {
		    if (!el.className.match(new RegExp('(?:^|\\s)' + className + '(?!\\S)'))) {
		      el.className += ' ' + className;
		    }
		  }
		}
	
		function removeClassName(el /*: HTMLElement*/, className /*: string*/) {
		  if (el.classList) {
		    el.classList.remove(className);
		  } else {
		    el.className = el.className.replace(new RegExp('(?:^|\\s)' + className + '(?!\\S)', 'g'), '');
		  }
		}
	
		/*:: import type Draggable from '../Draggable';*/
		/*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/
		/*:: import type DraggableCore from '../DraggableCore';*/
	
	
		function getBoundPosition(draggable /*: Draggable*/, x /*: number*/, y /*: number*/) /*: [number, number]*/ {
		  // If no bounds, short-circuit and move on
		  if (!draggable.props.bounds) return [x, y];
	
		  // Clone new bounds
		  var bounds = draggable.props.bounds;
	
		  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
		  var node = findDOMNode(draggable);
	
		  if (typeof bounds === 'string') {
		    var ownerDocument = node.ownerDocument;
	
		    var ownerWindow = ownerDocument.defaultView;
		    var boundNode = void 0;
		    if (bounds === 'parent') {
		      boundNode = node.parentNode;
		    } else {
		      boundNode = ownerDocument.querySelector(bounds);
		    }
		    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
		      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
		    }
		    var nodeStyle = ownerWindow.getComputedStyle(node);
		    var boundNodeStyle = ownerWindow.getComputedStyle(boundNode);
		    // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
		    bounds = {
		      left: -node.offsetLeft + int(boundNodeStyle.paddingLeft) + int(nodeStyle.marginLeft),
		      top: -node.offsetTop + int(boundNodeStyle.paddingTop) + int(nodeStyle.marginTop),
		      right: innerWidth(boundNode) - outerWidth(node) - node.offsetLeft + int(boundNodeStyle.paddingRight) - int(nodeStyle.marginRight),
		      bottom: innerHeight(boundNode) - outerHeight(node) - node.offsetTop + int(boundNodeStyle.paddingBottom) - int(nodeStyle.marginBottom)
		    };
		  }
	
		  // Keep x and y below right and bottom limits...
		  if (isNum(bounds.right)) x = Math.min(x, bounds.right);
		  if (isNum(bounds.bottom)) y = Math.min(y, bounds.bottom);
	
		  // But above left and top limits.
		  if (isNum(bounds.left)) x = Math.max(x, bounds.left);
		  if (isNum(bounds.top)) y = Math.max(y, bounds.top);
	
		  return [x, y];
		}
	
		function snapToGrid(grid /*: [number, number]*/, pendingX /*: number*/, pendingY /*: number*/) /*: [number, number]*/ {
		  var x = Math.round(pendingX / grid[0]) * grid[0];
		  var y = Math.round(pendingY / grid[1]) * grid[1];
		  return [x, y];
		}
	
		function canDragX(draggable /*: Draggable*/) /*: boolean*/ {
		  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
		}
	
		function canDragY(draggable /*: Draggable*/) /*: boolean*/ {
		  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
		}
	
		// Get {x, y} positions from event.
		function getControlPosition(e /*: MouseTouchEvent*/, touchIdentifier /*: ?number*/, draggableCore /*: DraggableCore*/) /*: ?ControlPosition*/ {
		  var touchObj = typeof touchIdentifier === 'number' ? getTouch(e, touchIdentifier) : null;
		  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
		  var node = findDOMNode(draggableCore);
		  // User can provide an offsetParent if desired.
		  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
		  return offsetXYFromParent(touchObj || e, offsetParent);
		}
	
		// Create an data object exposed by <DraggableCore>'s events
		function createCoreData(draggable /*: DraggableCore*/, x /*: number*/, y /*: number*/) /*: DraggableData*/ {
		  var state = draggable.state;
		  var isStart = !isNum(state.lastX);
		  var node = findDOMNode(draggable);
	
		  if (isStart) {
		    // If this is our first move, use the x and y as last coords.
		    return {
		      node: node,
		      deltaX: 0, deltaY: 0,
		      lastX: x, lastY: y,
		      x: x, y: y
		    };
		  } else {
		    // Otherwise calculate proper values.
		    return {
		      node: node,
		      deltaX: x - state.lastX, deltaY: y - state.lastY,
		      lastX: state.lastX, lastY: state.lastY,
		      x: x, y: y
		    };
		  }
		}
	
		// Create an data exposed by <Draggable>'s events
		function createDraggableData(draggable /*: Draggable*/, coreData /*: DraggableData*/) /*: DraggableData*/ {
		  var scale = draggable.props.scale;
		  return {
		    node: coreData.node,
		    x: draggable.state.x + coreData.deltaX / scale,
		    y: draggable.state.y + coreData.deltaY / scale,
		    deltaX: coreData.deltaX / scale,
		    deltaY: coreData.deltaY / scale,
		    lastX: draggable.state.x,
		    lastY: draggable.state.y
		  };
		}
	
		// A lot faster than stringify/parse
		function cloneBounds(bounds /*: Bounds*/) /*: Bounds*/ {
		  return {
		    left: bounds.left,
		    top: bounds.top,
		    right: bounds.right,
		    bottom: bounds.bottom
		  };
		}
	
		function findDOMNode(draggable /*: Draggable | DraggableCore*/) /*: HTMLElement*/ {
		  var node = ReactDOM.findDOMNode(draggable);
		  if (!node) {
		    throw new Error('<DraggableCore>: Unmounted during event!');
		  }
		  // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
		  return node;
		}
	
		/*eslint no-console:0*/
		function log() {
		}
	
		/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/
	
	
		// Simple abstraction for dragging events names.
		/*:: import type {Element as ReactElement} from 'react';*/
		var eventsFor = {
		  touch: {
		    start: 'touchstart',
		    move: 'touchmove',
		    stop: 'touchend'
		  },
		  mouse: {
		    start: 'mousedown',
		    move: 'mousemove',
		    stop: 'mouseup'
		  }
		};
	
		// Default to mouse events.
		var dragEventFor = eventsFor.mouse;
	
		/*:: type DraggableCoreState = {
		  dragging: boolean,
		  lastX: number,
		  lastY: number,
		  touchIdentifier: ?number
		};*/
		/*:: export type DraggableBounds = {
		  left: number,
		  right: number,
		  top: number,
		  bottom: number,
		};*/
		/*:: export type DraggableData = {
		  node: HTMLElement,
		  x: number, y: number,
		  deltaX: number, deltaY: number,
		  lastX: number, lastY: number,
		};*/
		/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void;*/
		/*:: export type ControlPosition = {x: number, y: number};*/
		/*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/
	
	
		//
		// Define <DraggableCore>.
		//
		// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
		// work well with libraries that require more control over the element.
		//
	
		/*:: export type DraggableCoreProps = {
		  allowAnyClick: boolean,
		  cancel: string,
		  children: ReactElement<any>,
		  disabled: boolean,
		  enableUserSelectHack: boolean,
		  offsetParent: HTMLElement,
		  grid: [number, number],
		  handle: string,
		  onStart: DraggableEventHandler,
		  onDrag: DraggableEventHandler,
		  onStop: DraggableEventHandler,
		  onMouseDown: (e: MouseEvent) => void,
		};*/
	
		var DraggableCore = function (_React$Component) {
		  inherits(DraggableCore, _React$Component);
	
		  function DraggableCore() {
		    var _ref;
	
		    var _temp, _this, _ret;
	
		    classCallCheck(this, DraggableCore);
	
		    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		      args[_key] = arguments[_key];
		    }
	
		    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = DraggableCore.__proto__ || Object.getPrototypeOf(DraggableCore)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
		      dragging: false,
		      // Used while dragging to determine deltas.
		      lastX: NaN, lastY: NaN,
		      touchIdentifier: null
		    }, _this.handleDragStart = function (e) {
		      // Make it possible to attach event handlers on top of this one.
		      _this.props.onMouseDown(e);
	
		      // Only accept left-clicks.
		      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;
	
		      // Get nodes. Be sure to grab relative document (could be iframed)
		      var thisNode = ReactDOM.findDOMNode(_this);
		      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
		        throw new Error('<DraggableCore> not mounted on DragStart!');
		      }
		      var ownerDocument = thisNode.ownerDocument;
	
		      // Short circuit if handle or cancel prop was provided and selector doesn't match.
	
		      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !matchesSelectorAndParentsTo(e.target, _this.props.handle, thisNode) || _this.props.cancel && matchesSelectorAndParentsTo(e.target, _this.props.cancel, thisNode)) {
		        return;
		      }
	
		      // Set touch identifier in component state if this is a touch event. This allows us to
		      // distinguish between individual touches on multitouch screens by identifying which
		      // touchpoint was set to this element.
		      var touchIdentifier = getTouchIdentifier(e);
		      _this.setState({ touchIdentifier: touchIdentifier });
	
		      // Get the current drag point from the event. This is used as the offset.
		      var position = getControlPosition(e, touchIdentifier, _this);
		      if (position == null) return; // not possible but satisfies flow
		      var x = position.x,
		          y = position.y;
	
		      // Create an event object with all the data parents need to make a decision here.
	
		      var coreEvent = createCoreData(_this, x, y);
	
		      // Call event handler. If it returns explicit false, cancel.
		      log('calling', _this.props.onStart);
		      var shouldUpdate = _this.props.onStart(e, coreEvent);
		      if (shouldUpdate === false) return;
	
		      // Add a style to the body to disable user-select. This prevents text from
		      // being selected all over the page.
		      if (_this.props.enableUserSelectHack) addUserSelectStyles(ownerDocument);
	
		      // Initiate dragging. Set the current x and y as offsets
		      // so we know how much we've moved during the drag. This allows us
		      // to drag elements around even if they have been moved, without issue.
		      _this.setState({
		        dragging: true,
	
		        lastX: x,
		        lastY: y
		      });
	
		      // Add events to the document directly so we catch when the user's mouse/touch moves outside of
		      // this element. We use different events depending on whether or not we have detected that this
		      // is a touch-capable device.
		      addEvent(ownerDocument, dragEventFor.move, _this.handleDrag);
		      addEvent(ownerDocument, dragEventFor.stop, _this.handleDragStop);
		    }, _this.handleDrag = function (e) {
	
		      // Prevent scrolling on mobile devices, like ipad/iphone.
		      if (e.type === 'touchmove') e.preventDefault();
	
		      // Get the current drag point from the event. This is used as the offset.
		      var position = getControlPosition(e, _this.state.touchIdentifier, _this);
		      if (position == null) return;
		      var x = position.x,
		          y = position.y;
	
		      // Snap to grid if prop has been provided
	
		      if (Array.isArray(_this.props.grid)) {
		        var _deltaX = x - _this.state.lastX,
		            _deltaY = y - _this.state.lastY;
	
		        var _snapToGrid = snapToGrid(_this.props.grid, _deltaX, _deltaY);
	
		        var _snapToGrid2 = slicedToArray(_snapToGrid, 2);
	
		        _deltaX = _snapToGrid2[0];
		        _deltaY = _snapToGrid2[1];
	
		        if (!_deltaX && !_deltaY) return; // skip useless drag
		        x = _this.state.lastX + _deltaX, y = _this.state.lastY + _deltaY;
		      }
	
		      var coreEvent = createCoreData(_this, x, y);
	
		      // Call event handler. If it returns explicit false, trigger end.
		      var shouldUpdate = _this.props.onDrag(e, coreEvent);
		      if (shouldUpdate === false) {
		        try {
		          // $FlowIgnore
		          _this.handleDragStop(new MouseEvent('mouseup'));
		        } catch (err) {
		          // Old browsers
		          var event = ((document.createEvent('MouseEvents') /*: any*/) /*: MouseTouchEvent*/);
		          // I see why this insanity was deprecated
		          // $FlowIgnore
		          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		          _this.handleDragStop(event);
		        }
		        return;
		      }
	
		      _this.setState({
		        lastX: x,
		        lastY: y
		      });
		    }, _this.handleDragStop = function (e) {
		      if (!_this.state.dragging) return;
	
		      var position = getControlPosition(e, _this.state.touchIdentifier, _this);
		      if (position == null) return;
		      var x = position.x,
		          y = position.y;
	
		      var coreEvent = createCoreData(_this, x, y);
	
		      var thisNode = ReactDOM.findDOMNode(_this);
		      if (thisNode) {
		        // Remove user-select hack
		        if (_this.props.enableUserSelectHack) removeUserSelectStyles(thisNode.ownerDocument);
		      }
	
		      // Reset the el.
		      _this.setState({
		        dragging: false,
		        lastX: NaN,
		        lastY: NaN
		      });
	
		      // Call event handler
		      _this.props.onStop(e, coreEvent);
	
		      if (thisNode) {
		        removeEvent(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
		        removeEvent(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
		      }
		    }, _this.onMouseDown = function (e) {
		      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
	
		      return _this.handleDragStart(e);
		    }, _this.onMouseUp = function (e) {
		      dragEventFor = eventsFor.mouse;
	
		      return _this.handleDragStop(e);
		    }, _this.onTouchStart = function (e) {
		      // We're on a touch device now, so change the event handlers
		      dragEventFor = eventsFor.touch;
	
		      return _this.handleDragStart(e);
		    }, _this.onTouchEnd = function (e) {
		      // We're on a touch device now, so change the event handlers
		      dragEventFor = eventsFor.touch;
	
		      return _this.handleDragStop(e);
		    }, _temp), possibleConstructorReturn(_this, _ret);
		  }
	
		  createClass(DraggableCore, [{
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      // Remove any leftover event handlers. Remove both touch and mouse handlers in case
		      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
		      var thisNode = ReactDOM.findDOMNode(this);
		      if (thisNode) {
		        var ownerDocument = thisNode.ownerDocument;
	
		        removeEvent(ownerDocument, eventsFor.mouse.move, this.handleDrag);
		        removeEvent(ownerDocument, eventsFor.touch.move, this.handleDrag);
		        removeEvent(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
		        removeEvent(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
		        if (this.props.enableUserSelectHack) removeUserSelectStyles(ownerDocument);
		      }
		    }
	
		    // Same as onMouseDown (start drag), but now consider this a touch device.
	
		  }, {
		    key: 'render',
		    value: function render() {
		      // Reuse the child provided
		      // This makes it flexible to use whatever element is wanted (div, ul, etc)
		      return React.cloneElement(React.Children.only(this.props.children), {
		        style: styleHacks(this.props.children.props.style),
	
		        // Note: mouseMove handler is attached to document so it will still function
		        // when the user drags quickly and leaves the bounds of the element.
		        onMouseDown: this.onMouseDown,
		        onTouchStart: this.onTouchStart,
		        onMouseUp: this.onMouseUp,
		        onTouchEnd: this.onTouchEnd
		      });
		    }
		  }]);
		  return DraggableCore;
		}(React.Component);
	
		DraggableCore.displayName = 'DraggableCore';
		DraggableCore.propTypes = {
		  /**
		   * `allowAnyClick` allows dragging using any mouse button.
		   * By default, we only accept the left button.
		   *
		   * Defaults to `false`.
		   */
		  allowAnyClick: propTypes.bool,
	
		  /**
		   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
		   * with the exception of `onMouseDown`, will not fire.
		   */
		  disabled: propTypes.bool,
	
		  /**
		   * By default, we add 'user-select:none' attributes to the document body
		   * to prevent ugly text selection during drag. If this is causing problems
		   * for your app, set this to `false`.
		   */
		  enableUserSelectHack: propTypes.bool,
	
		  /**
		   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
		   * instead of using the parent node.
		   */
		  offsetParent: function offsetParent(props /*: DraggableCoreProps*/, propName /*: $Keys<DraggableCoreProps>*/) {
		    if (props[propName] && props[propName].nodeType !== 1) {
		      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
		    }
		  },
	
		  /**
		   * `grid` specifies the x and y that dragging should snap to.
		   */
		  grid: propTypes.arrayOf(propTypes.number),
	
		  /**
		   * `scale` specifies the scale of the area you are dragging inside of. It allows
		   * the drag deltas to scale correctly with how far zoomed in/out you are.
		   */
		  scale: propTypes.number,
	
		  /**
		   * `handle` specifies a selector to be used as the handle that initiates drag.
		   *
		   * Example:
		   *
		   * ```jsx
		   *   let App = React.createClass({
		   *       render: function () {
		   *         return (
		   *            <Draggable handle=".handle">
		   *              <div>
		   *                  <div className="handle">Click me to drag</div>
		   *                  <div>This is some other content</div>
		   *              </div>
		   *           </Draggable>
		   *         );
		   *       }
		   *   });
		   * ```
		   */
		  handle: propTypes.string,
	
		  /**
		   * `cancel` specifies a selector to be used to prevent drag initialization.
		   *
		   * Example:
		   *
		   * ```jsx
		   *   let App = React.createClass({
		   *       render: function () {
		   *           return(
		   *               <Draggable cancel=".cancel">
		   *                   <div>
		   *                     <div className="cancel">You can't drag from here</div>
		   *                     <div>Dragging here works fine</div>
		   *                   </div>
		   *               </Draggable>
		   *           );
		   *       }
		   *   });
		   * ```
		   */
		  cancel: propTypes.string,
	
		  /**
		   * Called when dragging starts.
		   * If this function returns the boolean false, dragging will be canceled.
		   */
		  onStart: propTypes.func,
	
		  /**
		   * Called while dragging.
		   * If this function returns the boolean false, dragging will be canceled.
		   */
		  onDrag: propTypes.func,
	
		  /**
		   * Called when dragging stops.
		   * If this function returns the boolean false, the drag will remain active.
		   */
		  onStop: propTypes.func,
	
		  /**
		   * A workaround option which can be passed if onMouseDown needs to be accessed,
		   * since it'll always be blocked (as there is internal use of onMouseDown)
		   */
		  onMouseDown: propTypes.func,
	
		  /**
		   * These properties should be defined on the child, not here.
		   */
		  className: dontSetMe,
		  style: dontSetMe,
		  transform: dontSetMe
		};
		DraggableCore.defaultProps = {
		  allowAnyClick: false, // by default only accept left click
		  cancel: null,
		  disabled: false,
		  enableUserSelectHack: true,
		  offsetParent: null,
		  handle: null,
		  grid: null,
		  transform: null,
		  onStart: function onStart() {},
		  onDrag: function onDrag() {},
		  onStop: function onStop() {},
		  onMouseDown: function onMouseDown() {}
		};
	
		/*:: import type {DraggableEventHandler} from './utils/types';*/
		/*:: import type {Element as ReactElement} from 'react';*/
		/*:: type DraggableState = {
		  dragging: boolean,
		  dragged: boolean,
		  x: number, y: number,
		  slackX: number, slackY: number,
		  isElementSVG: boolean
		};*/
	
	
		//
		// Define <Draggable>
		//
	
		/*:: export type DraggableProps = {
		  ...$Exact<DraggableCoreProps>,
		  axis: 'both' | 'x' | 'y' | 'none',
		  bounds: DraggableBounds | string | false,
		  defaultClassName: string,
		  defaultClassNameDragging: string,
		  defaultClassNameDragged: string,
		  defaultPosition: ControlPosition,
		  positionOffset: PositionOffsetControlPosition,
		  position: ControlPosition,
		  scale: number
		};*/
	
		var Draggable = function (_React$Component) {
		  inherits(Draggable, _React$Component);
	
		  function Draggable(props /*: DraggableProps*/) {
		    classCallCheck(this, Draggable);
	
		    var _this = possibleConstructorReturn(this, (Draggable.__proto__ || Object.getPrototypeOf(Draggable)).call(this, props));
	
		    _this.onDragStart = function (e, coreData) {
	
		      // Short-circuit if user's callback killed it.
		      var shouldStart = _this.props.onStart(e, createDraggableData(_this, coreData));
		      // Kills start event on core as well, so move handlers are never bound.
		      if (shouldStart === false) return false;
	
		      _this.setState({ dragging: true, dragged: true });
		    };
	
		    _this.onDrag = function (e, coreData) {
		      if (!_this.state.dragging) return false;
	
		      var uiData = createDraggableData(_this, coreData);
	
		      var newState /*: $Shape<DraggableState>*/ = {
		        x: uiData.x,
		        y: uiData.y
		      };
	
		      // Keep within bounds.
		      if (_this.props.bounds) {
		        // Save original x and y.
		        var _x = newState.x,
		            _y = newState.y;
	
		        // Add slack to the values used to calculate bound position. This will ensure that if
		        // we start removing slack, the element won't react to it right away until it's been
		        // completely removed.
	
		        newState.x += _this.state.slackX;
		        newState.y += _this.state.slackY;
	
		        // Get bound position. This will ceil/floor the x and y within the boundaries.
	
		        var _getBoundPosition = getBoundPosition(_this, newState.x, newState.y),
		            _getBoundPosition2 = slicedToArray(_getBoundPosition, 2),
		            newStateX = _getBoundPosition2[0],
		            newStateY = _getBoundPosition2[1];
	
		        newState.x = newStateX;
		        newState.y = newStateY;
	
		        // Recalculate slack by noting how much was shaved by the boundPosition handler.
		        newState.slackX = _this.state.slackX + (_x - newState.x);
		        newState.slackY = _this.state.slackY + (_y - newState.y);
	
		        // Update the event we fire to reflect what really happened after bounds took effect.
		        uiData.x = newState.x;
		        uiData.y = newState.y;
		        uiData.deltaX = newState.x - _this.state.x;
		        uiData.deltaY = newState.y - _this.state.y;
		      }
	
		      // Short-circuit if user's callback killed it.
		      var shouldUpdate = _this.props.onDrag(e, uiData);
		      if (shouldUpdate === false) return false;
	
		      _this.setState(newState);
		    };
	
		    _this.onDragStop = function (e, coreData) {
		      if (!_this.state.dragging) return false;
	
		      // Short-circuit if user's callback killed it.
		      var shouldStop = _this.props.onStop(e, createDraggableData(_this, coreData));
		      if (shouldStop === false) return false;
	
		      var newState /*: $Shape<DraggableState>*/ = {
		        dragging: false,
		        slackX: 0,
		        slackY: 0
		      };
	
		      // If this is a controlled component, the result of this operation will be to
		      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
		      var controlled = Boolean(_this.props.position);
		      if (controlled) {
		        var _this$props$position = _this.props.position,
		            _x2 = _this$props$position.x,
		            _y2 = _this$props$position.y;
	
		        newState.x = _x2;
		        newState.y = _y2;
		      }
	
		      _this.setState(newState);
		    };
	
		    _this.state = {
		      // Whether or not we are currently dragging.
		      dragging: false,
	
		      // Whether or not we have been dragged before.
		      dragged: false,
	
		      // Current transform x and y.
		      x: props.position ? props.position.x : props.defaultPosition.x,
		      y: props.position ? props.position.y : props.defaultPosition.y,
	
		      // Used for compensating for out-of-bounds drags
		      slackX: 0, slackY: 0,
	
		      // Can only determine if SVG after mounting
		      isElementSVG: false
		    };
	
		    if (props.position && !(props.onDrag || props.onStop)) {
		      // eslint-disable-next-line no-console
		      console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
		    }
		    return _this;
		  }
	
		  createClass(Draggable, [{
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      // Check to see if the element passed is an instanceof SVGElement
		      if (typeof window.SVGElement !== 'undefined' && ReactDOM.findDOMNode(this) instanceof window.SVGElement) {
		        this.setState({ isElementSVG: true });
		      }
		    }
		  }, {
		    key: 'componentWillReceiveProps',
		    value: function componentWillReceiveProps(nextProps /*: Object*/) {
		      // Set x/y if position has changed
		      if (nextProps.position && (!this.props.position || nextProps.position.x !== this.props.position.x || nextProps.position.y !== this.props.position.y)) {
		        this.setState({ x: nextProps.position.x, y: nextProps.position.y });
		      }
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      this.setState({ dragging: false }); // prevents invariant if unmounted while dragging
		    }
		  }, {
		    key: 'render',
		    value: function render() /*: ReactElement<any>*/ {
		      var _classNames;
	
		      var style = {},
		          svgTransform = null;
	
		      // If this is controlled, we don't want to move it - unless it's dragging.
		      var controlled = Boolean(this.props.position);
		      var draggable = !controlled || this.state.dragging;
	
		      var position = this.props.position || this.props.defaultPosition;
		      var transformOpts = {
		        // Set left if horizontal drag is enabled
		        x: canDragX(this) && draggable ? this.state.x : position.x,
	
		        // Set top if vertical drag is enabled
		        y: canDragY(this) && draggable ? this.state.y : position.y
		      };
	
		      // If this element was SVG, we use the `transform` attribute.
		      if (this.state.isElementSVG) {
		        svgTransform = createSVGTransform(transformOpts, this.props.positionOffset);
		      } else {
		        // Add a CSS transform to move the element around. This allows us to move the element around
		        // without worrying about whether or not it is relatively or absolutely positioned.
		        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
		        // has a clean slate.
		        style = createCSSTransform(transformOpts, this.props.positionOffset);
		      }
	
		      var _props = this.props,
		          defaultClassName = _props.defaultClassName,
		          defaultClassNameDragging = _props.defaultClassNameDragging,
		          defaultClassNameDragged = _props.defaultClassNameDragged;
	
	
		      var children = React.Children.only(this.props.children);
	
		      // Mark with class while dragging
		      var className = classnames(children.props.className || '', defaultClassName, (_classNames = {}, defineProperty(_classNames, defaultClassNameDragging, this.state.dragging), defineProperty(_classNames, defaultClassNameDragged, this.state.dragged), _classNames));
	
		      // Reuse the child provided
		      // This makes it flexible to use whatever element is wanted (div, ul, etc)
		      return React.createElement(
		        DraggableCore,
		        _extends({}, this.props, { onStart: this.onDragStart, onDrag: this.onDrag, onStop: this.onDragStop }),
		        React.cloneElement(children, {
		          className: className,
		          style: _extends({}, children.props.style, style),
		          transform: svgTransform
		        })
		      );
		    }
		  }]);
		  return Draggable;
		}(React.Component);
	
		Draggable.displayName = 'Draggable';
		Draggable.propTypes = _extends({}, DraggableCore.propTypes, {
	
		  /**
		   * `axis` determines which axis the draggable can move.
		   *
		   *  Note that all callbacks will still return data as normal. This only
		   *  controls flushing to the DOM.
		   *
		   * 'both' allows movement horizontally and vertically.
		   * 'x' limits movement to horizontal axis.
		   * 'y' limits movement to vertical axis.
		   * 'none' limits all movement.
		   *
		   * Defaults to 'both'.
		   */
		  axis: propTypes.oneOf(['both', 'x', 'y', 'none']),
	
		  /**
		   * `bounds` determines the range of movement available to the element.
		   * Available values are:
		   *
		   * 'parent' restricts movement within the Draggable's parent node.
		   *
		   * Alternatively, pass an object with the following properties, all of which are optional:
		   *
		   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
		   *
		   * All values are in px.
		   *
		   * Example:
		   *
		   * ```jsx
		   *   let App = React.createClass({
		   *       render: function () {
		   *         return (
		   *            <Draggable bounds={{right: 300, bottom: 300}}>
		   *              <div>Content</div>
		   *           </Draggable>
		   *         );
		   *       }
		   *   });
		   * ```
		   */
		  bounds: propTypes.oneOfType([propTypes.shape({
		    left: propTypes.number,
		    right: propTypes.number,
		    top: propTypes.number,
		    bottom: propTypes.number
		  }), propTypes.string, propTypes.oneOf([false])]),
	
		  defaultClassName: propTypes.string,
		  defaultClassNameDragging: propTypes.string,
		  defaultClassNameDragged: propTypes.string,
	
		  /**
		   * `defaultPosition` specifies the x and y that the dragged item should start at
		   *
		   * Example:
		   *
		   * ```jsx
		   *      let App = React.createClass({
		   *          render: function () {
		   *              return (
		   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
		   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
		   *                  </Draggable>
		   *              );
		   *          }
		   *      });
		   * ```
		   */
		  defaultPosition: propTypes.shape({
		    x: propTypes.number,
		    y: propTypes.number
		  }),
		  positionOffset: propTypes.shape({
		    x: propTypes.oneOfType([propTypes.number, propTypes.string]),
		    y: propTypes.oneOfType([propTypes.number, propTypes.string])
		  }),
	
		  /**
		   * `position`, if present, defines the current position of the element.
		   *
		   *  This is similar to how form elements in React work - if no `position` is supplied, the component
		   *  is uncontrolled.
		   *
		   * Example:
		   *
		   * ```jsx
		   *      let App = React.createClass({
		   *          render: function () {
		   *              return (
		   *                  <Draggable position={{x: 25, y: 25}}>
		   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
		   *                  </Draggable>
		   *              );
		   *          }
		   *      });
		   * ```
		   */
		  position: propTypes.shape({
		    x: propTypes.number,
		    y: propTypes.number
		  }),
	
		  /**
		   * These properties should be defined on the child, not here.
		   */
		  className: dontSetMe,
		  style: dontSetMe,
		  transform: dontSetMe
		});
		Draggable.defaultProps = _extends({}, DraggableCore.defaultProps, {
		  axis: 'both',
		  bounds: false,
		  defaultClassName: 'react-draggable',
		  defaultClassNameDragging: 'react-draggable-dragging',
		  defaultClassNameDragged: 'react-draggable-dragged',
		  defaultPosition: { x: 0, y: 0 },
		  position: null,
		  scale: 1
		});
	
		// Previous versions of this lib exported <Draggable> as the root export. As to not break
		// them, or TypeScript, we export *both* as the root and as 'default'.
		// See https://github.com/mzabriskie/react-draggable/pull/254
		// and https://github.com/mzabriskie/react-draggable/issues/266
		Draggable.default = Draggable;
		Draggable.DraggableCore = DraggableCore;
	
		return Draggable;
	
	})));
	//# sourceMappingURL=react-draggable.js.map


/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDraggable = __webpack_require__(1807);
	
	var _reactResizable = __webpack_require__(1847);
	
	var _utils = __webpack_require__(297);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * An individual item within a ReactGridLayout.
	 */
	var GridItem = function (_React$Component) {
	  _inherits(GridItem, _React$Component);
	
	  function GridItem() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GridItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      resizing: null,
	      dragging: null,
	      className: ""
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // Helper for generating column width
	  GridItem.prototype.calcColWidth = function calcColWidth() {
	    var _props = this.props,
	        margin = _props.margin,
	        containerPadding = _props.containerPadding,
	        containerWidth = _props.containerWidth,
	        cols = _props.cols;
	
	    return (containerWidth - margin[0] * (cols - 1) - containerPadding[0] * 2) / cols;
	  };
	
	  /**
	   * Return position on the page given an x, y, w, h.
	   * left, top, width, height are all in pixels.
	   * @param  {Number}  x             X coordinate in grid units.
	   * @param  {Number}  y             Y coordinate in grid units.
	   * @param  {Number}  w             W coordinate in grid units.
	   * @param  {Number}  h             H coordinate in grid units.
	   * @return {Object}                Object containing coords.
	   */
	
	
	  GridItem.prototype.calcPosition = function calcPosition(x, y, w, h, state) {
	    var _props2 = this.props,
	        margin = _props2.margin,
	        containerPadding = _props2.containerPadding,
	        rowHeight = _props2.rowHeight;
	
	    var colWidth = this.calcColWidth();
	
	    var out = {
	      left: Math.round((colWidth + margin[0]) * x + containerPadding[0]),
	      top: Math.round((rowHeight + margin[1]) * y + containerPadding[1]),
	      // 0 * Infinity === NaN, which causes problems with resize constraints;
	      // Fix this if it occurs.
	      // Note we do it here rather than later because Math.round(Infinity) causes deopt
	      width: w === Infinity ? w : Math.round(colWidth * w + Math.max(0, w - 1) * margin[0]),
	      height: h === Infinity ? h : Math.round(rowHeight * h + Math.max(0, h - 1) * margin[1])
	    };
	
	    if (state && state.resizing) {
	      out.width = Math.round(state.resizing.width);
	      out.height = Math.round(state.resizing.height);
	    }
	
	    if (state && state.dragging) {
	      out.top = Math.round(state.dragging.top);
	      out.left = Math.round(state.dragging.left);
	    }
	
	    return out;
	  };
	
	  /**
	   * Translate x and y coordinates from pixels to grid units.
	   * @param  {Number} top  Top position (relative to parent) in pixels.
	   * @param  {Number} left Left position (relative to parent) in pixels.
	   * @return {Object} x and y in grid units.
	   */
	
	
	  GridItem.prototype.calcXY = function calcXY(top, left) {
	    var _props3 = this.props,
	        margin = _props3.margin,
	        cols = _props3.cols,
	        rowHeight = _props3.rowHeight,
	        w = _props3.w,
	        h = _props3.h,
	        maxRows = _props3.maxRows;
	
	    var colWidth = this.calcColWidth();
	
	    // left = colWidth * x + margin * (x + 1)
	    // l = cx + m(x+1)
	    // l = cx + mx + m
	    // l - m = cx + mx
	    // l - m = x(c + m)
	    // (l - m) / (c + m) = x
	    // x = (left - margin) / (coldWidth + margin)
	    var x = Math.round((left - margin[0]) / (colWidth + margin[0]));
	    var y = Math.round((top - margin[1]) / (rowHeight + margin[1]));
	
	    // Capping
	    x = Math.max(Math.min(x, cols - w), 0);
	    y = Math.max(Math.min(y, maxRows - h), 0);
	
	    return { x: x, y: y };
	  };
	
	  /**
	   * Given a height and width in pixel values, calculate grid units.
	   * @param  {Number} height Height in pixels.
	   * @param  {Number} width  Width in pixels.
	   * @return {Object} w, h as grid units.
	   */
	
	
	  GridItem.prototype.calcWH = function calcWH(_ref) {
	    var height = _ref.height,
	        width = _ref.width;
	    var _props4 = this.props,
	        margin = _props4.margin,
	        maxRows = _props4.maxRows,
	        cols = _props4.cols,
	        rowHeight = _props4.rowHeight,
	        x = _props4.x,
	        y = _props4.y;
	
	    var colWidth = this.calcColWidth();
	
	    // width = colWidth * w - (margin * (w - 1))
	    // ...
	    // w = (width + margin) / (colWidth + margin)
	    var w = Math.round((width + margin[0]) / (colWidth + margin[0]));
	    var h = Math.round((height + margin[1]) / (rowHeight + margin[1]));
	
	    // Capping
	    w = Math.max(Math.min(w, cols - x), 0);
	    h = Math.max(Math.min(h, maxRows - y), 0);
	    return { w: w, h: h };
	  };
	
	  /**
	   * This is where we set the grid item's absolute placement. It gets a little tricky because we want to do it
	   * well when server rendering, and the only way to do that properly is to use percentage width/left because
	   * we don't know exactly what the browser viewport is.
	   * Unfortunately, CSS Transforms, which are great for performance, break in this instance because a percentage
	   * left is relative to the item itself, not its container! So we cannot use them on the server rendering pass.
	   *
	   * @param  {Object} pos Position object with width, height, left, top.
	   * @return {Object}     Style object.
	   */
	
	
	  GridItem.prototype.createStyle = function createStyle(pos) {
	    var _props5 = this.props,
	        usePercentages = _props5.usePercentages,
	        containerWidth = _props5.containerWidth,
	        useCSSTransforms = _props5.useCSSTransforms;
	
	
	    var style = void 0;
	    // CSS Transforms support (default)
	    if (useCSSTransforms) {
	      style = (0, _utils.setTransform)(pos);
	    } else {
	      // top,left (slow)
	      style = (0, _utils.setTopLeft)(pos);
	
	      // This is used for server rendering.
	      if (usePercentages) {
	        style.left = (0, _utils.perc)(pos.left / containerWidth);
	        style.width = (0, _utils.perc)(pos.width / containerWidth);
	      }
	    }
	
	    return style;
	  };
	
	  /**
	   * Mix a Draggable instance into a child.
	   * @param  {Element} child    Child element.
	   * @return {Element}          Child wrapped in Draggable.
	   */
	
	
	  GridItem.prototype.mixinDraggable = function mixinDraggable(child) {
	    return _react2.default.createElement(
	      _reactDraggable.DraggableCore,
	      {
	        onStart: this.onDragHandler("onDragStart"),
	        onDrag: this.onDragHandler("onDrag"),
	        onStop: this.onDragHandler("onDragStop"),
	        handle: this.props.handle,
	        cancel: ".react-resizable-handle" + (this.props.cancel ? "," + this.props.cancel : "")
	      },
	      child
	    );
	  };
	
	  /**
	   * Mix a Resizable instance into a child.
	   * @param  {Element} child    Child element.
	   * @param  {Object} position  Position object (pixel values)
	   * @return {Element}          Child wrapped in Resizable.
	   */
	
	
	  GridItem.prototype.mixinResizable = function mixinResizable(child, position) {
	    var _props6 = this.props,
	        cols = _props6.cols,
	        x = _props6.x,
	        minW = _props6.minW,
	        minH = _props6.minH,
	        maxW = _props6.maxW,
	        maxH = _props6.maxH;
	
	    // This is the max possible width - doesn't go to infinity because of the width of the window
	
	    var maxWidth = this.calcPosition(0, 0, cols - x, 0).width;
	
	    // Calculate min/max constraints using our min & maxes
	    var mins = this.calcPosition(0, 0, minW, minH);
	    var maxes = this.calcPosition(0, 0, maxW, maxH);
	    var minConstraints = [mins.width, mins.height];
	    var maxConstraints = [Math.min(maxes.width, maxWidth), Math.min(maxes.height, Infinity)];
	    return _react2.default.createElement(
	      _reactResizable.Resizable,
	      {
	        width: position.width,
	        height: position.height,
	        minConstraints: minConstraints,
	        maxConstraints: maxConstraints,
	        onResizeStop: this.onResizeHandler("onResizeStop"),
	        onResizeStart: this.onResizeHandler("onResizeStart"),
	        onResize: this.onResizeHandler("onResize")
	      },
	      child
	    );
	  };
	
	  /**
	   * Wrapper around drag events to provide more useful data.
	   * All drag events call the function with the given handler name,
	   * with the signature (index, x, y).
	   *
	   * @param  {String} handlerName Handler name to wrap.
	   * @return {Function}           Handler function.
	   */
	
	
	  GridItem.prototype.onDragHandler = function onDragHandler(handlerName) {
	    var _this2 = this;
	
	    return function (e, _ref2) {
	      var node = _ref2.node,
	          deltaX = _ref2.deltaX,
	          deltaY = _ref2.deltaY;
	
	      var handler = _this2.props[handlerName];
	      if (!handler) return;
	
	      var newPosition = { top: 0, left: 0 };
	
	      // Get new XY
	      switch (handlerName) {
	        case "onDragStart":
	          {
	            // TODO: this wont work on nested parents
	            var offsetParent = node.offsetParent;
	
	            if (!offsetParent) return;
	            var parentRect = offsetParent.getBoundingClientRect();
	            var clientRect = node.getBoundingClientRect();
	            newPosition.left = clientRect.left - parentRect.left + offsetParent.scrollLeft;
	            newPosition.top = clientRect.top - parentRect.top + offsetParent.scrollTop;
	            _this2.setState({ dragging: newPosition });
	            break;
	          }
	        case "onDrag":
	          if (!_this2.state.dragging) throw new Error("onDrag called before onDragStart.");
	          newPosition.left = _this2.state.dragging.left + deltaX;
	          newPosition.top = _this2.state.dragging.top + deltaY;
	          _this2.setState({ dragging: newPosition });
	          break;
	        case "onDragStop":
	          if (!_this2.state.dragging) throw new Error("onDragEnd called before onDragStart.");
	          newPosition.left = _this2.state.dragging.left;
	          newPosition.top = _this2.state.dragging.top;
	          _this2.setState({ dragging: null });
	          break;
	        default:
	          throw new Error("onDragHandler called with unrecognized handlerName: " + handlerName);
	      }
	
	      var _calcXY = _this2.calcXY(newPosition.top, newPosition.left),
	          x = _calcXY.x,
	          y = _calcXY.y;
	
	      return handler.call(_this2, _this2.props.i, x, y, { e: e, node: node, newPosition: newPosition });
	    };
	  };
	
	  /**
	   * Wrapper around drag events to provide more useful data.
	   * All drag events call the function with the given handler name,
	   * with the signature (index, x, y).
	   *
	   * @param  {String} handlerName Handler name to wrap.
	   * @return {Function}           Handler function.
	   */
	
	
	  GridItem.prototype.onResizeHandler = function onResizeHandler(handlerName) {
	    var _this3 = this;
	
	    return function (e, _ref3) {
	      var node = _ref3.node,
	          size = _ref3.size;
	
	      var handler = _this3.props[handlerName];
	      if (!handler) return;
	      var _props7 = _this3.props,
	          cols = _props7.cols,
	          x = _props7.x,
	          i = _props7.i,
	          maxW = _props7.maxW,
	          minW = _props7.minW,
	          maxH = _props7.maxH,
	          minH = _props7.minH;
	
	      // Get new XY
	
	      var _calcWH = _this3.calcWH(size),
	          w = _calcWH.w,
	          h = _calcWH.h;
	
	      // Cap w at numCols
	
	
	      w = Math.min(w, cols - x);
	      // Ensure w is at least 1
	      w = Math.max(w, 1);
	
	      // Min/max capping
	      w = Math.max(Math.min(w, maxW), minW);
	      h = Math.max(Math.min(h, maxH), minH);
	
	      _this3.setState({ resizing: handlerName === "onResizeStop" ? null : size });
	
	      handler.call(_this3, i, w, h, { e: e, node: node, size: size });
	    };
	  };
	
	  GridItem.prototype.render = function render() {
	    var _props8 = this.props,
	        x = _props8.x,
	        y = _props8.y,
	        w = _props8.w,
	        h = _props8.h,
	        isDraggable = _props8.isDraggable,
	        isResizable = _props8.isResizable,
	        useCSSTransforms = _props8.useCSSTransforms;
	
	
	    var pos = this.calcPosition(x, y, w, h, this.state);
	    var child = _react2.default.Children.only(this.props.children);
	
	    // Create the child element. We clone the existing element but modify its className and style.
	    var newChild = _react2.default.cloneElement(child, {
	      className: (0, _classnames2.default)("react-grid-item", child.props.className, this.props.className, {
	        static: this.props.static,
	        resizing: Boolean(this.state.resizing),
	        "react-draggable": isDraggable,
	        "react-draggable-dragging": Boolean(this.state.dragging),
	        cssTransforms: useCSSTransforms
	      }),
	      // We can set the width and height on the child, but unfortunately we can't set the position.
	      style: _extends({}, this.props.style, child.props.style, this.createStyle(pos))
	    });
	
	    // Resizable support. This is usually on but the user can toggle it off.
	    if (isResizable) newChild = this.mixinResizable(newChild, pos);
	
	    // Draggable support. This is always on, except for with placeholders.
	    if (isDraggable) newChild = this.mixinDraggable(newChild);
	
	    return newChild;
	  };
	
	  return GridItem;
	}(_react2.default.Component);
	
	GridItem.propTypes = {
	  // Children must be only a single element
	  children: _propTypes2.default.element,
	
	  // General grid attributes
	  cols: _propTypes2.default.number.isRequired,
	  containerWidth: _propTypes2.default.number.isRequired,
	  rowHeight: _propTypes2.default.number.isRequired,
	  margin: _propTypes2.default.array.isRequired,
	  maxRows: _propTypes2.default.number.isRequired,
	  containerPadding: _propTypes2.default.array.isRequired,
	
	  // These are all in grid units
	  x: _propTypes2.default.number.isRequired,
	  y: _propTypes2.default.number.isRequired,
	  w: _propTypes2.default.number.isRequired,
	  h: _propTypes2.default.number.isRequired,
	
	  // All optional
	  minW: function minW(props, propName) {
	    var value = props[propName];
	    if (typeof value !== "number") return new Error("minWidth not Number");
	    if (value > props.w || value > props.maxW) return new Error("minWidth larger than item width/maxWidth");
	  },
	
	  maxW: function maxW(props, propName) {
	    var value = props[propName];
	    if (typeof value !== "number") return new Error("maxWidth not Number");
	    if (value < props.w || value < props.minW) return new Error("maxWidth smaller than item width/minWidth");
	  },
	
	  minH: function minH(props, propName) {
	    var value = props[propName];
	    if (typeof value !== "number") return new Error("minHeight not Number");
	    if (value > props.h || value > props.maxH) return new Error("minHeight larger than item height/maxHeight");
	  },
	
	  maxH: function maxH(props, propName) {
	    var value = props[propName];
	    if (typeof value !== "number") return new Error("maxHeight not Number");
	    if (value < props.h || value < props.minH) return new Error("maxHeight smaller than item height/minHeight");
	  },
	
	  // ID is nice to have for callbacks
	  i: _propTypes2.default.string.isRequired,
	
	  // Functions
	  onDragStop: _propTypes2.default.func,
	  onDragStart: _propTypes2.default.func,
	  onDrag: _propTypes2.default.func,
	  onResizeStop: _propTypes2.default.func,
	  onResizeStart: _propTypes2.default.func,
	  onResize: _propTypes2.default.func,
	
	  // Flags
	  isDraggable: _propTypes2.default.bool.isRequired,
	  isResizable: _propTypes2.default.bool.isRequired,
	  static: _propTypes2.default.bool,
	
	  // Use CSS transforms instead of top/left
	  useCSSTransforms: _propTypes2.default.bool.isRequired,
	
	  // Others
	  className: _propTypes2.default.string,
	  // Selector for draggable handle
	  handle: _propTypes2.default.string,
	  // Selector for draggable cancel (see react-draggable)
	  cancel: _propTypes2.default.string
	};
	GridItem.defaultProps = {
	  className: "",
	  cancel: "",
	  handle: "",
	  minH: 1,
	  minW: 1,
	  maxH: Infinity,
	  maxW: Infinity
	};
	exports.default = GridItem;

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(338);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utils = __webpack_require__(297);
	
	var _responsiveUtils = __webpack_require__(848);
	
	var _ReactGridLayout = __webpack_require__(847);
	
	var _ReactGridLayout2 = _interopRequireDefault(_ReactGridLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var type = function type(obj) {
	  return Object.prototype.toString.call(obj);
	};
	
	var ResponsiveReactGridLayout = function (_React$Component) {
	  _inherits(ResponsiveReactGridLayout, _React$Component);
	
	  function ResponsiveReactGridLayout() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ResponsiveReactGridLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = _this.generateInitialState(), _this.onLayoutChange = function (layout) {
	      var _extends2;
	
	      _this.props.onLayoutChange(layout, _extends({}, _this.props.layouts, (_extends2 = {}, _extends2[_this.state.breakpoint] = layout, _extends2)));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	  // This should only include propTypes needed in this code; RGL itself
	  // will do validation of the rest props passed to it.
	
	
	  ResponsiveReactGridLayout.prototype.generateInitialState = function generateInitialState() {
	    var _props = this.props,
	        width = _props.width,
	        breakpoints = _props.breakpoints,
	        layouts = _props.layouts,
	        cols = _props.cols;
	
	    var breakpoint = (0, _responsiveUtils.getBreakpointFromWidth)(breakpoints, width);
	    var colNo = (0, _responsiveUtils.getColsFromBreakpoint)(breakpoint, cols);
	    // verticalCompact compatibility, now deprecated
	    var compactType = this.props.verticalCompact === false ? null : this.props.compactType;
	    // Get the initial layout. This can tricky; we try to generate one however possible if one doesn't exist
	    // for this layout.
	    var initialLayout = (0, _responsiveUtils.findOrGenerateResponsiveLayout)(layouts, breakpoints, breakpoint, breakpoint, colNo, compactType);
	
	    return {
	      layout: initialLayout,
	      breakpoint: breakpoint,
	      cols: colNo
	    };
	  };
	
	  ResponsiveReactGridLayout.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    // Allow parent to set width or breakpoint directly.
	    if (nextProps.width != this.props.width || nextProps.breakpoint !== this.props.breakpoint || !(0, _lodash2.default)(nextProps.breakpoints, this.props.breakpoints) || !(0, _lodash2.default)(nextProps.cols, this.props.cols)) {
	      this.onWidthChange(nextProps);
	    } else if (!(0, _lodash2.default)(nextProps.layouts, this.props.layouts)) {
	      // Allow parent to set layouts directly.
	      var _state = this.state,
	          _breakpoint = _state.breakpoint,
	          _cols = _state.cols;
	
	      // Since we're setting an entirely new layout object, we must generate a new responsive layout
	      // if one does not exist.
	
	      var newLayout = (0, _responsiveUtils.findOrGenerateResponsiveLayout)(nextProps.layouts, nextProps.breakpoints, _breakpoint, _breakpoint, _cols, nextProps.compactType);
	      this.setState({ layout: newLayout });
	    }
	  };
	
	  // wrap layouts so we do not need to pass layouts to child
	
	
	  /**
	   * When the width changes work through breakpoints and reset state with the new width & breakpoint.
	   * Width changes are necessary to figure out the widget widths.
	   */
	  ResponsiveReactGridLayout.prototype.onWidthChange = function onWidthChange(nextProps) {
	    var breakpoints = nextProps.breakpoints,
	        cols = nextProps.cols,
	        layouts = nextProps.layouts,
	        compactType = nextProps.compactType;
	
	    var newBreakpoint = nextProps.breakpoint || (0, _responsiveUtils.getBreakpointFromWidth)(nextProps.breakpoints, nextProps.width);
	
	    var lastBreakpoint = this.state.breakpoint;
	
	    // Breakpoint change
	    if (lastBreakpoint !== newBreakpoint || this.props.breakpoints !== breakpoints || this.props.cols !== cols) {
	      // Preserve the current layout if the current breakpoint is not present in the next layouts.
	      if (!(lastBreakpoint in layouts)) layouts[lastBreakpoint] = (0, _utils.cloneLayout)(this.state.layout);
	
	      // Find or generate a new layout.
	      var newCols = (0, _responsiveUtils.getColsFromBreakpoint)(newBreakpoint, cols);
	      var _layout = (0, _responsiveUtils.findOrGenerateResponsiveLayout)(layouts, breakpoints, newBreakpoint, lastBreakpoint, newCols, compactType);
	
	      // This adds missing items.
	      _layout = (0, _utils.synchronizeLayoutWithChildren)(_layout, nextProps.children, newCols, compactType);
	
	      // Store the new layout.
	      layouts[newBreakpoint] = _layout;
	
	      // callbacks
	      this.props.onLayoutChange(_layout, layouts);
	      this.props.onBreakpointChange(newBreakpoint, newCols);
	      this.props.onWidthChange(nextProps.width, nextProps.margin, newCols, nextProps.containerPadding);
	
	      this.setState({
	        breakpoint: newBreakpoint,
	        layout: _layout,
	        cols: newCols
	      });
	    }
	  };
	
	  ResponsiveReactGridLayout.prototype.render = function render() {
	    /* eslint-disable no-unused-vars */
	    var _props2 = this.props,
	        breakpoint = _props2.breakpoint,
	        breakpoints = _props2.breakpoints,
	        cols = _props2.cols,
	        layouts = _props2.layouts,
	        onBreakpointChange = _props2.onBreakpointChange,
	        onLayoutChange = _props2.onLayoutChange,
	        onWidthChange = _props2.onWidthChange,
	        other = _objectWithoutProperties(_props2, ["breakpoint", "breakpoints", "cols", "layouts", "onBreakpointChange", "onLayoutChange", "onWidthChange"]);
	    /* eslint-enable no-unused-vars */
	
	    return _react2.default.createElement(_ReactGridLayout2.default, _extends({}, other, {
	      onLayoutChange: this.onLayoutChange,
	      layout: this.state.layout,
	      cols: this.state.cols
	    }));
	  };
	
	  return ResponsiveReactGridLayout;
	}(_react2.default.Component);
	
	ResponsiveReactGridLayout.propTypes = {
	  //
	  // Basic props
	  //
	
	  // Optional, but if you are managing width yourself you may want to set the breakpoint
	  // yourself as well.
	  breakpoint: _propTypes2.default.string,
	
	  // {name: pxVal}, e.g. {lg: 1200, md: 996, sm: 768, xs: 480}
	  breakpoints: _propTypes2.default.object,
	
	  // # of cols. This is a breakpoint -> cols map
	  cols: _propTypes2.default.object,
	
	  // layouts is an object mapping breakpoints to layouts.
	  // e.g. {lg: Layout, md: Layout, ...}
	  layouts: function layouts(props, propName) {
	    if (type(props[propName]) !== "[object Object]") {
	      throw new Error("Layout property must be an object. Received: " + type(props[propName]));
	    }
	    Object.keys(props[propName]).forEach(function (key) {
	      if (!(key in props.breakpoints)) {
	        throw new Error("Each key in layouts must align with a key in breakpoints.");
	      }
	      (0, _utils.validateLayout)(props.layouts[key], "layouts." + key);
	    });
	  },
	
	
	  // The width of this component.
	  // Required in this propTypes stanza because generateInitialState() will fail without it.
	  width: _propTypes2.default.number.isRequired,
	
	  //
	  // Callbacks
	  //
	
	  // Calls back with breakpoint and new # cols
	  onBreakpointChange: _propTypes2.default.func,
	
	  // Callback so you can save the layout.
	  // Calls back with (currentLayout, allLayouts). allLayouts are keyed by breakpoint.
	  onLayoutChange: _propTypes2.default.func,
	
	  // Calls back with (containerWidth, margin, cols, containerPadding)
	  onWidthChange: _propTypes2.default.func
	};
	ResponsiveReactGridLayout.defaultProps = {
	  breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
	  cols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
	  layouts: {},
	  onBreakpointChange: _utils.noop,
	  onLayoutChange: _utils.noop,
	  onWidthChange: _utils.noop
	};
	exports.default = ResponsiveReactGridLayout;

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = WidthProvider;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * A simple HOC that provides facility for listening to container resizes.
	 */
	function WidthProvider(ComposedComponent) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_React$Component) {
	    _inherits(WidthProvider, _React$Component);
	
	    function WidthProvider() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, WidthProvider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	        width: 1280
	      }, _this.mounted = false, _this.onWindowResize = function () {
	        if (!_this.mounted) return;
	        // eslint-disable-next-line
	        var node = _reactDom2.default.findDOMNode(_this); // Flow casts this to Text | Element
	        if (node instanceof HTMLElement) _this.setState({ width: node.offsetWidth });
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    WidthProvider.prototype.componentDidMount = function componentDidMount() {
	      this.mounted = true;
	
	      window.addEventListener("resize", this.onWindowResize);
	      // Call to properly set the breakpoint and resize the elements.
	      // Note that if you're doing a full-width element, this can get a little wonky if a scrollbar
	      // appears because of the grid. In that case, fire your own resize event, or set `overflow: scroll` on your body.
	      this.onWindowResize();
	    };
	
	    WidthProvider.prototype.componentWillUnmount = function componentWillUnmount() {
	      this.mounted = false;
	      window.removeEventListener("resize", this.onWindowResize);
	    };
	
	    WidthProvider.prototype.render = function render() {
	      var _props = this.props,
	          measureBeforeMount = _props.measureBeforeMount,
	          rest = _objectWithoutProperties(_props, ["measureBeforeMount"]);
	
	      if (measureBeforeMount && !this.mounted) {
	        return _react2.default.createElement("div", { className: this.props.className, style: this.props.style });
	      }
	
	      return _react2.default.createElement(ComposedComponent, _extends({}, rest, this.state));
	    };
	
	    return WidthProvider;
	  }(_react2.default.Component), _class.defaultProps = {
	    measureBeforeMount: false
	  }, _class.propTypes = {
	    // If true, will not render children until mounted. Useful for getting the exact width before
	    // rendering, to prevent any unsightly resizing.
	    measureBeforeMount: _propTypes2.default.bool
	  }, _temp2;
	}

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(847).default;
	module.exports.utils = __webpack_require__(297);
	module.exports.Responsive = __webpack_require__(1809).default;
	module.exports.Responsive.utils = __webpack_require__(848);
	module.exports.WidthProvider = __webpack_require__(1810).default;


/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBookmarkO = function FaBookmarkO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.2 5.7h-22.8v27.7l11.4-10.9 2 1.9 9.4 9v-27.7z m0.3-2.8q0.5 0 1 0.2 0.7 0.2 1.1 0.9t0.5 1.4v28.7q0 0.8-0.5 1.4t-1.1 0.9q-0.5 0.2-1 0.2-1.1 0-1.9-0.7l-9.8-9.5-9.9 9.5q-0.8 0.7-1.8 0.7-0.5 0-1-0.2-0.7-0.3-1.2-0.9t-0.4-1.4v-28.7q0-0.8 0.4-1.4t1.2-0.9q0.5-0.2 1-0.2h23.4z' })
	        )
	    );
	};
	
	exports.default = FaBookmarkO;
	module.exports = exports['default'];

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBookmark = function FaBookmark(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.5 2.9q0.5 0 1 0.2 0.7 0.2 1.1 0.9t0.5 1.4v28.7q0 0.8-0.5 1.4t-1.1 0.9q-0.5 0.2-1 0.2-1.1 0-1.9-0.7l-9.8-9.5-9.9 9.5q-0.8 0.7-1.8 0.7-0.5 0-1-0.2-0.7-0.3-1.2-0.9t-0.4-1.4v-28.7q0-0.8 0.4-1.4t1.2-0.9q0.5-0.2 1-0.2h23.4z' })
	        )
	    );
	};
	
	exports.default = FaBookmark;
	module.exports = exports['default'];

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCalendarO = function FaCalendarO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm4.4 37.1h31.4v-22.8h-31.4v22.8z m8.5-27.1v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m17.2 0v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.5q0.3 0 0.5-0.2t0.2-0.5z m8.5-1.4v28.5q0 1.2-0.8 2.1t-2 0.8h-31.4q-1.2 0-2.1-0.9t-0.8-2v-28.5q0-1.2 0.8-2t2.1-0.9h2.8v-2.1q0-1.5 1.1-2.6t2.5-1h1.4q1.5 0 2.5 1.1t1.1 2.5v2.1h8.6v-2.1q0-1.5 1-2.6t2.5-1h1.5q1.4 0 2.5 1.1t1 2.5v2.1h2.9q1.1 0 2 0.9t0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaCalendarO;
	module.exports = exports['default'];

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCaretDown = function FaCaretDown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.4 15.7q0 0.6-0.5 1l-10 10q-0.4 0.4-1 0.4t-1-0.4l-10-10q-0.4-0.4-0.4-1t0.4-1 1-0.4h20q0.6 0 1 0.4t0.5 1z' })
	        )
	    );
	};
	
	exports.default = FaCaretDown;
	module.exports = exports['default'];

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCaretUp = function FaCaretUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.4 27.1q0 0.6-0.5 1t-1 0.5h-20q-0.6 0-1-0.5t-0.4-1 0.4-1l10-10q0.4-0.4 1-0.4t1 0.4l10 10q0.5 0.5 0.5 1z' })
	        )
	    );
	};
	
	exports.default = FaCaretUp;
	module.exports = exports['default'];

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCheck = function FaCheck(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.3 12.6q0 0.9-0.6 1.6l-19.2 19.1q-0.6 0.7-1.5 0.7t-1.6-0.7l-11.1-11.1q-0.6-0.6-0.6-1.5t0.6-1.5l3.1-3q0.6-0.7 1.5-0.7t1.5 0.7l6.6 6.5 14.6-14.6q0.6-0.6 1.5-0.6t1.5 0.6l3.1 3q0.6 0.6 0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaCheck;
	module.exports = exports['default'];

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCopy = function FaCopy(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.9 8.6q0.9 0 1.5 0.6t0.6 1.5v27.2q0 0.9-0.6 1.5t-1.5 0.6h-21.5q-0.9 0-1.5-0.6t-0.6-1.5v-6.5h-12.2q-0.9 0-1.5-0.6t-0.6-1.5v-15q0-0.9 0.4-2t1.1-1.7l9.1-9.1q0.6-0.6 1.7-1.1t2-0.4h9.3q0.9 0 1.5 0.6t0.6 1.5v7.4q1.5-0.9 2.9-0.9h9.3z m-12.2 4.7l-6.7 6.7h6.7v-6.7z m-14.3-8.5l-6.6 6.6h6.6v-6.6z m4.4 14.4l7.1-7.1v-9.2h-8.6v9.2q0 0.9-0.6 1.6t-1.6 0.6h-9.2v14.3h11.4v-5.7q0-0.9 0.4-2t1.1-1.7z m21.3 17.9v-25.7h-8.5v9.3q0 0.9-0.7 1.5t-1.5 0.7h-9.3v14.2h20z' })
	        )
	    );
	};
	
	exports.default = FaCopy;
	module.exports = exports['default'];

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaEraser = function FaEraser(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm18.6 30.6l7-7.9h-16l-6.9 7.9h15.9z m21-22.3q0.4 0.7 0.2 1.5t-0.6 1.3l-18.6 21.3q-0.8 0.9-2 0.9h-15.9q-0.8 0-1.5-0.4t-1-1.2q-0.3-0.7-0.2-1.5t0.7-1.3l18.6-21.3q0.8-0.9 2-0.9h15.9q0.8 0 1.5 0.4t0.9 1.2z' })
	        )
	    );
	};
	
	exports.default = FaEraser;
	module.exports = exports['default'];

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFilter = function FaFilter(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.8 6.6q0.4 0.9-0.3 1.5l-11 11.1v16.5q0 1-0.9 1.3-0.3 0.1-0.5 0.1-0.6 0-1-0.4l-5.7-5.7q-0.5-0.4-0.5-1v-10.8l-11-11q-0.7-0.7-0.3-1.6 0.4-0.9 1.3-0.9h28.6q0.9 0 1.3 0.9z' })
	        )
	    );
	};
	
	exports.default = FaFilter;
	module.exports = exports['default'];

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLevelUp = function FaLevelUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.2 13.5q-0.4 0.8-1.3 0.8h-4.3v19.3q0 0.3-0.2 0.5t-0.5 0.2h-15.7q-0.5 0-0.6-0.4-0.2-0.5 0.1-0.8l3.5-4.3q0.2-0.2 0.6-0.2h7.1v-14.3h-4.3q-0.9 0-1.3-0.8-0.3-0.9 0.2-1.6l7.2-8.5q0.4-0.5 1.1-0.5t1.1 0.5l7.1 8.5q0.6 0.8 0.2 1.6z' })
	        )
	    );
	};
	
	exports.default = FaLevelUp;
	module.exports = exports['default'];

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLongArrowLeft = function FaLongArrowLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39 17.9v4.2q0 0.3-0.2 0.5t-0.5 0.2h-27.1v4.9q0 0.4-0.5 0.6t-0.7-0.1l-8.4-7.6q-0.2-0.3-0.2-0.5 0-0.3 0.2-0.6l8.4-7.7q0.3-0.3 0.7-0.1 0.4 0.2 0.4 0.6v4.9h27.2q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaLongArrowLeft;
	module.exports = exports['default'];

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLongArrowRight = function FaLongArrowRight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.1 19.9q0 0.3-0.3 0.6l-8.5 7.9q-0.4 0.3-0.8 0.1-0.4-0.2-0.4-0.6v-5h-27.9q-0.3 0-0.5-0.2t-0.2-0.6v-4.2q0-0.4 0.2-0.6t0.5-0.2h27.9v-5q0-0.4 0.4-0.6t0.8 0.1l8.5 7.8q0.3 0.2 0.3 0.5z' })
	        )
	    );
	};
	
	exports.default = FaLongArrowRight;
	module.exports = exports['default'];

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdArrowDropDown = function MdArrowDropDown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.6 16.6h16.8l-8.4 8.4z' })
	        )
	    );
	};
	
	exports.default = MdArrowDropDown;
	module.exports = exports['default'];

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdArrowDropUp = function MdArrowDropUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.6 23.4l8.4-8.4 8.4 8.4h-16.8z' })
	        )
	    );
	};
	
	exports.default = MdArrowDropUp;
	module.exports = exports['default'];

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdCheckBoxOutlineBlank = function MdCheckBoxOutlineBlank(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 5q1.4 0 2.4 1t1 2.4v23.2q0 1.4-1 2.4t-2.4 1h-23.2q-1.4 0-2.4-1t-1-2.4v-23.2q0-1.4 1-2.4t2.4-1h23.2z m0 3.4h-23.2v23.2h23.2v-23.2z' })
	        )
	    );
	};
	
	exports.default = MdCheckBoxOutlineBlank;
	module.exports = exports['default'];

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdCheckBox = function MdCheckBox(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm16.6 28.4l15-15-2.3-2.5-12.7 12.7-5.9-5.9-2.3 2.3z m15-23.4c1.9 0 3.4 1.6 3.4 3.4v23.2c0 1.8-1.5 3.4-3.4 3.4h-23.2c-1.9 0-3.4-1.6-3.4-3.4v-23.2c0-1.8 1.5-3.4 3.4-3.4h23.2z' })
	        )
	    );
	};
	
	exports.default = MdCheckBox;
	module.exports = exports['default'];

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdCloudDownload = function MdCloudDownload(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.4 21.6h-5v-6.6h-6.8v6.6h-5l8.4 8.4z m3.9-4.9c4.3 0.3 7.7 3.9 7.7 8.3 0 4.6-3.7 8.4-8.4 8.4h-21.6c-5.5 0-10-4.5-10-10 0-5.2 3.9-9.4 8.9-10 2.1-3.9 6.3-6.8 11.1-6.8 6.1 0 11.1 4.3 12.3 10.1z' })
	        )
	    );
	};
	
	exports.default = MdCloudDownload;
	module.exports = exports['default'];

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdMenu = function MdMenu(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm5 10h30v3.4h-30v-3.4z m0 11.6v-3.2h30v3.2h-30z m0 8.4v-3.4h30v3.4h-30z' })
	        )
	    );
	};
	
	exports.default = MdMenu;
	module.exports = exports['default'];

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdModeEdit = function MdModeEdit(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm34.5 11.7l-3 3.1-6.3-6.3 3.1-3c0.6-0.7 1.7-0.7 2.3 0l3.9 3.9c0.7 0.6 0.7 1.7 0 2.3z m-29.5 17.1l18.4-18.5 6.3 6.3-18.4 18.4h-6.3v-6.2z' })
	        )
	    );
	};
	
	exports.default = MdModeEdit;
	module.exports = exports['default'];

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdPieChartOutlined = function MdPieChartOutlined(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm21.6 33.2c6.1-0.8 10.8-5.5 11.6-11.6h-11.6v11.6z m-15-13.2c0 6.8 5.2 12.3 11.8 13.2v-26.4c-6.6 0.8-11.8 6.4-11.8 13.2z m15-13.2v11.6h11.6c-0.8-6.1-5.5-10.8-11.6-11.6z m-1.6-3.4c9.1 0 16.6 7.5 16.6 16.6s-7.5 16.6-16.6 16.6-16.6-7.5-16.6-16.6 7.5-16.6 16.6-16.6z' })
	        )
	    );
	};
	
	exports.default = MdPieChartOutlined;
	module.exports = exports['default'];

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdPieChart = function MdPieChart(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm21.7 21.7h14.9c-0.7 7.9-7 14.2-14.9 14.9v-14.9z m0-18.3c7.9 0.7 14.2 7 14.9 14.9h-14.9v-14.9z m-3.3 0v33.2c-8.5-0.8-15-7.9-15-16.6s6.5-15.8 15-16.6z' })
	        )
	    );
	};
	
	exports.default = MdPieChart;
	module.exports = exports['default'];

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdRefresh = function MdRefresh(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29.5 10.5l3.9-3.9v11.8h-11.8l5.4-5.4c-1.8-1.8-4.3-3-7-3-5.5 0-10 4.5-10 10s4.5 10 10 10c4.4 0 8.1-2.7 9.5-6.6h3.4c-1.5 5.7-6.6 10-12.9 10-7.3 0-13.3-6.1-13.3-13.4s6-13.4 13.3-13.4c3.7 0 7 1.5 9.5 3.9z' })
	        )
	    );
	};
	
	exports.default = MdRefresh;
	module.exports = exports['default'];

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdSyncDisabled = function MdSyncDisabled(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm33.4 6.6l-4 4c2.4 2.4 4 5.7 4 9.4 0 2.6-0.8 5-2.1 7l-2.5-2.4c0.7-1.4 1.2-3 1.2-4.6 0-2.7-1.2-5.2-3-7l-3.6 3.6v-10h10z m-28.6 2.4l2.1-2.1 26.1 26.2-2.1 2.1-3.9-3.9c-1.1 0.7-2.4 1.3-3.7 1.6v-3.4c0.4-0.2 0.9-0.4 1.3-0.7l-13.4-13.4c-0.7 1.4-1.2 3-1.2 4.6 0 2.7 1.2 5.2 3 7l3.6-3.6v10h-10l4-4c-2.4-2.4-4-5.7-4-9.4 0-2.6 0.8-5 2.1-7z m11.8 1.5c-0.4 0.2-0.8 0.4-1.2 0.7l-2.4-2.5c1.1-0.7 2.3-1.3 3.6-1.6v3.4z' })
	        )
	    );
	};
	
	exports.default = MdSyncDisabled;
	module.exports = exports['default'];

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdSync = function MdSync(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20 30v-5l6.6 6.6-6.6 6.8v-5c-7.3 0-13.4-6.1-13.4-13.4 0-2.6 0.8-5.1 2.2-7.1l2.4 2.4c-0.8 1.4-1.2 3-1.2 4.7 0 5.5 4.5 10 10 10z m0-23.4c7.3 0 13.4 6.1 13.4 13.4 0 2.6-0.8 5.1-2.1 7.1l-2.5-2.4c0.8-1.4 1.2-3 1.2-4.7 0-5.5-4.5-10-10-10v5l-6.6-6.6 6.6-6.8v5z' })
	        )
	    );
	};
	
	exports.default = MdSync;
	module.exports = exports['default'];

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdVpnKey = function MdVpnKey(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.6 23.4c1.8 0 3.4-1.6 3.4-3.4s-1.6-3.4-3.4-3.4-3.2 1.6-3.2 3.4 1.4 3.4 3.2 3.4z m9.5-6.8h17.3v6.8h-3.4v6.6h-6.6v-6.6h-7.3c-1.3 3.9-5.1 6.6-9.5 6.6-5.5 0-10-4.5-10-10s4.5-10 10-10c4.4 0 8.2 2.7 9.5 6.6z' })
	        )
	    );
	};
	
	exports.default = MdVpnKey;
	module.exports = exports['default'];

/***/ }),
/* 1837 */
/***/ (function(module, exports) {

	/** @license React v16.12.0
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
	60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function z(a){return y(a)===m}
	exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
	exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var createReactClass = __webpack_require__(92);
	var PropTypes = __webpack_require__(2);
	var NotificationItem = __webpack_require__(1839);
	var Constants = __webpack_require__(528);
	
	var NotificationContainer = createReactClass({
	
	  propTypes: {
	    position: PropTypes.string.isRequired,
	    notifications: PropTypes.array.isRequired,
	    getStyles: PropTypes.object
	  },
	
	  _style: {},
	
	  componentWillMount: function() {
	    // Fix position if width is overrided
	    this._style = this.props.getStyles.container(this.props.position);
	
	    if (this.props.getStyles.overrideWidth && (this.props.position === Constants.positions.tc || this.props.position === Constants.positions.bc)) {
	      this._style.marginLeft = -(this.props.getStyles.overrideWidth / 2);
	    }
	  },
	
	  render: function() {
	    var self = this;
	    var notifications;
	
	    if ([Constants.positions.bl, Constants.positions.br, Constants.positions.bc].indexOf(this.props.position) > -1) {
	      this.props.notifications.reverse();
	    }
	
	    notifications = this.props.notifications.map(function(notification) {
	      return (
	        React.createElement(NotificationItem, {
	          ref:  'notification-' + notification.uid, 
	          key:  notification.uid, 
	          notification:  notification, 
	          getStyles:  self.props.getStyles, 
	          onRemove:  self.props.onRemove, 
	          noAnimation:  self.props.noAnimation, 
	          allowHTML:  self.props.allowHTML, 
	          children:  self.props.children}
	        )
	      );
	    });
	
	    return (
	      React.createElement("div", {className:  'notifications-' + this.props.position, style:  this._style}, 
	         notifications 
	      )
	    );
	  }
	});
	
	
	module.exports = NotificationContainer;


/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var createReactClass = __webpack_require__(92);
	var PropTypes = __webpack_require__(2);
	var ReactDOM = __webpack_require__(31);
	var Constants = __webpack_require__(528);
	var Helpers = __webpack_require__(1841);
	var merge = __webpack_require__(40);
	
	/* From Modernizr */
	var whichTransitionEvent = function() {
	  var el = document.createElement('fakeelement');
	  var transition;
	  var transitions = {
	    transition: 'transitionend',
	    OTransition: 'oTransitionEnd',
	    MozTransition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd'
	  };
	
	  Object.keys(transitions).forEach(function(transitionKey) {
	    if (el.style[transitionKey] !== undefined) {
	      transition = transitions[transitionKey];
	    }
	  });
	
	  return transition;
	};
	
	var NotificationItem = createReactClass({
	  propTypes: {
	    notification: PropTypes.object,
	    getStyles: PropTypes.object,
	    onRemove: PropTypes.func,
	    allowHTML: PropTypes.bool,
	    noAnimation: PropTypes.bool,
	    children: PropTypes.oneOfType([
	      PropTypes.string,
	      PropTypes.element
	    ])
	  },
	
	  getDefaultProps: function() {
	    return {
	      noAnimation: false,
	      onRemove: function() {},
	      allowHTML: false
	    };
	  },
	
	  getInitialState: function() {
	    return {
	      visible: undefined,
	      removed: false
	    };
	  },
	
	  componentWillMount: function() {
	    var getStyles = this.props.getStyles;
	    var level = this.props.notification.level;
	    var dismissible = this.props.notification.dismissible;
	
	    this._noAnimation = this.props.noAnimation;
	
	    this._styles = {
	      notification: getStyles.byElement('notification')(level),
	      title: getStyles.byElement('title')(level),
	      dismiss: getStyles.byElement('dismiss')(level),
	      messageWrapper: getStyles.byElement('messageWrapper')(level),
	      actionWrapper: getStyles.byElement('actionWrapper')(level),
	      action: getStyles.byElement('action')(level)
	    };
	
	    if (!dismissible || dismissible === 'none' || dismissible === 'button') {
	      this._styles.notification.cursor = 'default';
	    }
	  },
	
	  _styles: {},
	
	  _notificationTimer: null,
	
	  _height: 0,
	
	  _noAnimation: null,
	
	  _isMounted: false,
	
	  _removeCount: 0,
	
	  _getCssPropertyByPosition: function() {
	    var position = this.props.notification.position;
	    var css = {};
	
	    switch (position) {
	    case Constants.positions.tl:
	    case Constants.positions.bl:
	      css = {
	        property: 'left',
	        value: -200
	      };
	      break;
	
	    case Constants.positions.tr:
	    case Constants.positions.br:
	      css = {
	        property: 'right',
	        value: -200
	      };
	      break;
	
	    case Constants.positions.tc:
	      css = {
	        property: 'top',
	        value: -100
	      };
	      break;
	
	    case Constants.positions.bc:
	      css = {
	        property: 'bottom',
	        value: -100
	      };
	      break;
	
	    default:
	    }
	
	    return css;
	  },
	
	  _defaultAction: function(event) {
	    var notification = this.props.notification;
	
	    event.preventDefault();
	    this._hideNotification();
	    if (typeof notification.action.callback === 'function') {
	      notification.action.callback();
	    }
	  },
	
	  _hideNotification: function() {
	    if (this._notificationTimer) {
	      this._notificationTimer.clear();
	    }
	
	    if (this._isMounted) {
	      this.setState({
	        visible: false,
	        removed: true
	      });
	    }
	
	    if (this._noAnimation) {
	      this._removeNotification();
	    }
	  },
	
	  _removeNotification: function() {
	    this.props.onRemove(this.props.notification.uid);
	  },
	
	  _dismiss: function() {
	    if (!this.props.notification.dismissible) {
	      return;
	    }
	
	    this._hideNotification();
	  },
	
	  _showNotification: function() {
	    var self = this;
	    setTimeout(function() {
	      if (self._isMounted) {
	        self.setState({
	          visible: true
	        });
	      }
	    }, 50);
	  },
	
	  _onTransitionEnd: function() {
	    if (this._removeCount > 0) return;
	    if (this.state.removed) {
	      this._removeCount += 1;
	      this._removeNotification();
	    }
	  },
	
	  componentDidMount: function() {
	    var self = this;
	    var transitionEvent = whichTransitionEvent();
	    var notification = this.props.notification;
	    var element = ReactDOM.findDOMNode(this);
	
	    this._height = element.offsetHeight;
	
	    this._isMounted = true;
	
	    // Watch for transition end
	    if (!this._noAnimation) {
	      if (transitionEvent) {
	        element.addEventListener(transitionEvent, this._onTransitionEnd);
	      } else {
	        this._noAnimation = true;
	      }
	    }
	
	
	    if (notification.autoDismiss) {
	      this._notificationTimer = new Helpers.Timer(function() {
	        self._hideNotification();
	      }, notification.autoDismiss * 1000);
	    }
	
	    this._showNotification();
	  },
	
	  _handleMouseEnter: function() {
	    var notification = this.props.notification;
	    if (notification.autoDismiss) {
	      this._notificationTimer.pause();
	    }
	  },
	
	  _handleMouseLeave: function() {
	    var notification = this.props.notification;
	    if (notification.autoDismiss) {
	      this._notificationTimer.resume();
	    }
	  },
	
	  _handleNotificationClick: function() {
	    var dismissible = this.props.notification.dismissible;
	    if (dismissible === 'both' || dismissible === 'click' || dismissible === true) {
	      this._dismiss();
	    }
	  },
	
	  componentWillUnmount: function() {
	    var element = ReactDOM.findDOMNode(this);
	    var transitionEvent = whichTransitionEvent();
	    element.removeEventListener(transitionEvent, this._onTransitionEnd);
	    this._isMounted = false;
	  },
	
	  _allowHTML: function(string) {
	    return { __html: string };
	  },
	
	  render: function() {
	    var notification = this.props.notification;
	    var className = 'notification notification-' + notification.level;
	    var notificationStyle = merge({}, this._styles.notification);
	    var cssByPos = this._getCssPropertyByPosition();
	    var dismiss = null;
	    var actionButton = null;
	    var title = null;
	    var message = null;
	
	    if (this.state.visible) {
	      className += ' notification-visible';
	    } else if (this.state.visible === false) {
	      className += ' notification-hidden';
	    }
	
	    if (notification.dismissible === 'none') {
	      className += ' notification-not-dismissible';
	    }
	
	    if (this.props.getStyles.overrideStyle) {
	      if (!this.state.visible && !this.state.removed) {
	        notificationStyle[cssByPos.property] = cssByPos.value;
	      }
	
	      if (this.state.visible && !this.state.removed) {
	        notificationStyle.height = this._height;
	        notificationStyle[cssByPos.property] = 0;
	      }
	
	      if (this.state.removed) {
	        notificationStyle.overlay = 'hidden';
	        notificationStyle.height = 0;
	        notificationStyle.marginTop = 0;
	        notificationStyle.paddingTop = 0;
	        notificationStyle.paddingBottom = 0;
	      }
	      notificationStyle.opacity = this.state.visible ? this._styles.notification.isVisible.opacity : this._styles.notification.isHidden.opacity;
	    }
	
	    if (notification.title) {
	      title = React.createElement("h4", {className: "notification-title", style:  this._styles.title},  notification.title);
	    }
	
	    if (notification.message) {
	      if (this.props.allowHTML) {
	        message = (
	          React.createElement("div", {className: "notification-message", style:  this._styles.messageWrapper, dangerouslySetInnerHTML:  this._allowHTML(notification.message) })
	        );
	      } else {
	        message = (
	          React.createElement("div", {className: "notification-message", style:  this._styles.messageWrapper},  notification.message)
	        );
	      }
	    }
	    if (notification.dismissible === 'both' || notification.dismissible === 'button' || notification.dismissible === true) {
	      dismiss = React.createElement("span", {className: "notification-dismiss", onClick:  this._dismiss, style:  this._styles.dismiss}, "×");
	    }
	
	    if (notification.action) {
	      actionButton = (
	        React.createElement("div", {className: "notification-action-wrapper", style:  this._styles.actionWrapper}, 
	          React.createElement("button", {className: "notification-action-button", 
	            onClick:  this._defaultAction, 
	            style:  this._styles.action}, 
	             notification.action.label
	          )
	        )
	      );
	    }
	
	    if (notification.children) {
	      actionButton = notification.children;
	    }
	
	    return (
	      React.createElement("div", {className:  className, onClick:  this._handleNotificationClick, onMouseEnter:  this._handleMouseEnter, onMouseLeave:  this._handleMouseLeave, style:  notificationStyle }, 
	         title, 
	         message, 
	         dismiss, 
	         actionButton 
	      )
	    );
	  }
	
	});
	
	module.exports = NotificationItem;


/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var createReactClass = __webpack_require__(92);
	var PropTypes = __webpack_require__(2);
	var merge = __webpack_require__(40);
	var NotificationContainer = __webpack_require__(1838);
	var Constants = __webpack_require__(528);
	var Styles = __webpack_require__(1842);
	
	var NotificationSystem = createReactClass({
	
	  uid: 3400,
	
	  _isMounted: false,
	
	  _getStyles: {
	    overrideStyle: {},
	
	    overrideWidth: null,
	
	    setOverrideStyle: function(style) {
	      this.overrideStyle = style;
	    },
	
	    wrapper: function() {
	      if (!this.overrideStyle) return {};
	      return merge({}, Styles.Wrapper, this.overrideStyle.Wrapper);
	    },
	
	    container: function(position) {
	      var override = this.overrideStyle.Containers || {};
	      if (!this.overrideStyle) return {};
	
	      this.overrideWidth = Styles.Containers.DefaultStyle.width;
	
	      if (override.DefaultStyle && override.DefaultStyle.width) {
	        this.overrideWidth = override.DefaultStyle.width;
	      }
	
	      if (override[position] && override[position].width) {
	        this.overrideWidth = override[position].width;
	      }
	
	      return merge({}, Styles.Containers.DefaultStyle, Styles.Containers[position], override.DefaultStyle, override[position]);
	    },
	
	    elements: {
	      notification: 'NotificationItem',
	      title: 'Title',
	      messageWrapper: 'MessageWrapper',
	      dismiss: 'Dismiss',
	      action: 'Action',
	      actionWrapper: 'ActionWrapper'
	    },
	
	    byElement: function(element) {
	      var self = this;
	      return function(level) {
	        var _element = self.elements[element];
	        var override = self.overrideStyle[_element] || {};
	        if (!self.overrideStyle) return {};
	        return merge({}, Styles[_element].DefaultStyle, Styles[_element][level], override.DefaultStyle, override[level]);
	      };
	    }
	  },
	
	  _didNotificationRemoved: function(uid) {
	    var notification;
	    var notifications = this.state.notifications.filter(function(toCheck) {
	      if (toCheck.uid === uid) {
	        notification = toCheck;
	        return false;
	      }
	      return true;
	    });
	
	    if (this._isMounted) {
	      this.setState({ notifications: notifications });
	    }
	
	    if (notification && notification.onRemove) {
	      notification.onRemove(notification);
	    }
	  },
	
	  getInitialState: function() {
	    return {
	      notifications: []
	    };
	  },
	
	  propTypes: {
	    style: PropTypes.oneOfType([
	      PropTypes.bool,
	      PropTypes.object
	    ]),
	    noAnimation: PropTypes.bool,
	    allowHTML: PropTypes.bool
	  },
	
	  getDefaultProps: function() {
	    return {
	      style: {},
	      noAnimation: false,
	      allowHTML: false
	    };
	  },
	
	  addNotification: function(notification) {
	    var _notification = merge({}, Constants.notification, notification);
	    var notifications = this.state.notifications;
	    var i;
	
	    if (!_notification.level) {
	      throw new Error('notification level is required.');
	    }
	
	    if (Object.keys(Constants.levels).indexOf(_notification.level) === -1) {
	      throw new Error('\'' + _notification.level + '\' is not a valid level.');
	    }
	
	    // eslint-disable-next-line
	    if (isNaN(_notification.autoDismiss)) {
	      throw new Error('\'autoDismiss\' must be a number.');
	    }
	
	    if (Object.keys(Constants.positions).indexOf(_notification.position) === -1) {
	      throw new Error('\'' + _notification.position + '\' is not a valid position.');
	    }
	
	    // Some preparations
	    _notification.position = _notification.position.toLowerCase();
	    _notification.level = _notification.level.toLowerCase();
	    _notification.autoDismiss = parseInt(_notification.autoDismiss, 10);
	
	    _notification.uid = _notification.uid || this.uid;
	    _notification.ref = 'notification-' + _notification.uid;
	    this.uid += 1;
	
	    // do not add if the notification already exists based on supplied uid
	    for (i = 0; i < notifications.length; i += 1) {
	      if (notifications[i].uid === _notification.uid) {
	        return false;
	      }
	    }
	
	    notifications.push(_notification);
	
	    if (typeof _notification.onAdd === 'function') {
	      notification.onAdd(_notification);
	    }
	
	    this.setState({
	      notifications: notifications
	    });
	
	    return _notification;
	  },
	
	  getNotificationRef: function(notification) {
	    var self = this;
	    var foundNotification = null;
	
	    Object.keys(this.refs).forEach(function(container) {
	      if (container.indexOf('container') > -1) {
	        Object.keys(self.refs[container].refs).forEach(function(_notification) {
	          var uid = notification.uid ? notification.uid : notification;
	          if (_notification === 'notification-' + uid) {
	            // NOTE: Stop iterating further and return the found notification.
	            // Since UIDs are uniques and there won't be another notification found.
	            foundNotification = self.refs[container].refs[_notification];
	          }
	        });
	      }
	    });
	
	    return foundNotification;
	  },
	
	  removeNotification: function(notification) {
	    var foundNotification = this.getNotificationRef(notification);
	    return foundNotification && foundNotification._hideNotification();
	  },
	
	  editNotification: function(notification, newNotification) {
	    var foundNotification = null;
	    // NOTE: Find state notification to update by using
	    // `setState` and forcing React to re-render the component.
	    var uid = notification.uid ? notification.uid : notification;
	
	    var newNotifications = this.state.notifications.filter(function(stateNotification) {
	      if (uid === stateNotification.uid) {
	        foundNotification = stateNotification;
	        return false;
	      }
	
	      return true;
	    });
	
	
	    if (!foundNotification) {
	      return;
	    }
	
	    newNotifications.push(merge(
	      {},
	      foundNotification,
	      newNotification
	    ));
	
	    this.setState({
	      notifications: newNotifications
	    });
	  },
	
	  clearNotifications: function() {
	    var self = this;
	    Object.keys(this.refs).forEach(function(container) {
	      if (container.indexOf('container') > -1) {
	        Object.keys(self.refs[container].refs).forEach(function(_notification) {
	          self.refs[container].refs[_notification]._hideNotification();
	        });
	      }
	    });
	  },
	
	  componentDidMount: function() {
	    this._getStyles.setOverrideStyle(this.props.style);
	    this._isMounted = true;
	  },
	
	  componentWillUnmount: function() {
	    this._isMounted = false;
	  },
	
	  render: function() {
	    var self = this;
	    var containers = null;
	    var notifications = this.state.notifications;
	
	    if (notifications.length) {
	      containers = Object.keys(Constants.positions).map(function(position) {
	        var _notifications = notifications.filter(function(notification) {
	          return position === notification.position;
	        });
	
	        if (!_notifications.length) {
	          return null;
	        }
	
	        return (
	          React.createElement(NotificationContainer, {
	            ref:  'container-' + position, 
	            key:  position, 
	            position:  position, 
	            notifications:  _notifications, 
	            getStyles:  self._getStyles, 
	            onRemove:  self._didNotificationRemoved, 
	            noAnimation:  self.props.noAnimation, 
	            allowHTML:  self.props.allowHTML}
	          )
	        );
	      });
	    }
	
	
	    return (
	      React.createElement("div", {className: "notifications-wrapper", style:  this._getStyles.wrapper() }, 
	         containers 
	      )
	    );
	  }
	});
	
	module.exports = NotificationSystem;


/***/ }),
/* 1841 */
/***/ (function(module, exports) {

	var Helpers = {
	  Timer: function(callback, delay) {
	    var timerId;
	    var start;
	    var remaining = delay;
	
	    this.pause = function() {
	      clearTimeout(timerId);
	      remaining -= new Date() - start;
	    };
	
	    this.resume = function() {
	      start = new Date();
	      clearTimeout(timerId);
	      timerId = setTimeout(callback, remaining);
	    };
	
	    this.clear = function() {
	      clearTimeout(timerId);
	    };
	
	    this.resume();
	  }
	};
	
	module.exports = Helpers;


/***/ }),
/* 1842 */
/***/ (function(module, exports) {

	// Used for calculations
	var defaultWidth = 320;
	var defaultColors = {
	  success: {
	    rgb: '94, 164, 0',
	    hex: '#5ea400'
	  },
	  error: {
	    rgb: '236, 61, 61',
	    hex: '#ec3d3d'
	  },
	  warning: {
	    rgb: '235, 173, 23',
	    hex: '#ebad1a'
	  },
	  info: {
	    rgb: '54, 156, 199',
	    hex: '#369cc7'
	  }
	};
	var defaultShadowOpacity = '0.9';
	
	var STYLES = {
	
	  Wrapper: {},
	  Containers: {
	    DefaultStyle: {
	      fontFamily: 'inherit',
	      position: 'fixed',
	      width: defaultWidth,
	      padding: '0 10px 10px 10px',
	      zIndex: 9998,
	      WebkitBoxSizing: 'border-box',
	      MozBoxSizing: 'border-box',
	      boxSizing: 'border-box',
	      height: 'auto'
	    },
	
	    tl: {
	      top: '0px',
	      bottom: 'auto',
	      left: '0px',
	      right: 'auto'
	    },
	
	    tr: {
	      top: '0px',
	      bottom: 'auto',
	      left: 'auto',
	      right: '0px'
	    },
	
	    tc: {
	      top: '0px',
	      bottom: 'auto',
	      margin: '0 auto',
	      left: '50%',
	      marginLeft: -(defaultWidth / 2)
	    },
	
	    bl: {
	      top: 'auto',
	      bottom: '0px',
	      left: '0px',
	      right: 'auto'
	    },
	
	    br: {
	      top: 'auto',
	      bottom: '0px',
	      left: 'auto',
	      right: '0px'
	    },
	
	    bc: {
	      top: 'auto',
	      bottom: '0px',
	      margin: '0 auto',
	      left: '50%',
	      marginLeft: -(defaultWidth / 2)
	    }
	
	  },
	
	  NotificationItem: {
	    DefaultStyle: {
	      position: 'relative',
	      width: '100%',
	      cursor: 'pointer',
	      borderRadius: '2px',
	      fontSize: '13px',
	      margin: '10px 0 0',
	      padding: '10px',
	      display: 'block',
	      WebkitBoxSizing: 'border-box',
	      MozBoxSizing: 'border-box',
	      boxSizing: 'border-box',
	      opacity: 0,
	      transition: '0.3s ease-in-out',
	      WebkitTransform: 'translate3d(0, 0, 0)',
	      transform: 'translate3d(0, 0, 0)',
	      willChange: 'transform, opacity',
	
	      isHidden: {
	        opacity: 0
	      },
	
	      isVisible: {
	        opacity: 1
	      }
	    },
	
	    success: {
	      borderTop: '2px solid ' + defaultColors.success.hex,
	      backgroundColor: '#f0f5ea',
	      color: '#4b583a',
	      WebkitBoxShadow: '0 0 1px rgba(' + defaultColors.success.rgb + ',' + defaultShadowOpacity + ')',
	      MozBoxShadow: '0 0 1px rgba(' + defaultColors.success.rgb + ',' + defaultShadowOpacity + ')',
	      boxShadow: '0 0 1px rgba(' + defaultColors.success.rgb + ',' + defaultShadowOpacity + ')'
	    },
	
	    error: {
	      borderTop: '2px solid ' + defaultColors.error.hex,
	      backgroundColor: '#f4e9e9',
	      color: '#412f2f',
	      WebkitBoxShadow: '0 0 1px rgba(' + defaultColors.error.rgb + ',' + defaultShadowOpacity + ')',
	      MozBoxShadow: '0 0 1px rgba(' + defaultColors.error.rgb + ',' + defaultShadowOpacity + ')',
	      boxShadow: '0 0 1px rgba(' + defaultColors.error.rgb + ',' + defaultShadowOpacity + ')'
	    },
	
	    warning: {
	      borderTop: '2px solid ' + defaultColors.warning.hex,
	      backgroundColor: '#f9f6f0',
	      color: '#5a5343',
	      WebkitBoxShadow: '0 0 1px rgba(' + defaultColors.warning.rgb + ',' + defaultShadowOpacity + ')',
	      MozBoxShadow: '0 0 1px rgba(' + defaultColors.warning.rgb + ',' + defaultShadowOpacity + ')',
	      boxShadow: '0 0 1px rgba(' + defaultColors.warning.rgb + ',' + defaultShadowOpacity + ')'
	    },
	
	    info: {
	      borderTop: '2px solid ' + defaultColors.info.hex,
	      backgroundColor: '#e8f0f4',
	      color: '#41555d',
	      WebkitBoxShadow: '0 0 1px rgba(' + defaultColors.info.rgb + ',' + defaultShadowOpacity + ')',
	      MozBoxShadow: '0 0 1px rgba(' + defaultColors.info.rgb + ',' + defaultShadowOpacity + ')',
	      boxShadow: '0 0 1px rgba(' + defaultColors.info.rgb + ',' + defaultShadowOpacity + ')'
	    }
	  },
	
	  Title: {
	    DefaultStyle: {
	      fontSize: '14px',
	      margin: '0 0 5px 0',
	      padding: 0,
	      fontWeight: 'bold'
	    },
	
	    success: {
	      color: defaultColors.success.hex
	    },
	
	    error: {
	      color: defaultColors.error.hex
	    },
	
	    warning: {
	      color: defaultColors.warning.hex
	    },
	
	    info: {
	      color: defaultColors.info.hex
	    }
	
	  },
	
	  MessageWrapper: {
	    DefaultStyle: {
	      margin: 0,
	      padding: 0
	    }
	  },
	
	  Dismiss: {
	    DefaultStyle: {
	      cursor: 'pointer',
	      fontFamily: 'Arial',
	      fontSize: '17px',
	      position: 'absolute',
	      top: '4px',
	      right: '5px',
	      lineHeight: '15px',
	      backgroundColor: '#dededf',
	      color: '#ffffff',
	      borderRadius: '50%',
	      width: '14px',
	      height: '14px',
	      fontWeight: 'bold',
	      textAlign: 'center'
	    },
	
	    success: {
	      color: '#f0f5ea',
	      backgroundColor: '#b0ca92'
	    },
	
	    error: {
	      color: '#f4e9e9',
	      backgroundColor: '#e4bebe'
	    },
	
	    warning: {
	      color: '#f9f6f0',
	      backgroundColor: '#e1cfac'
	    },
	
	    info: {
	      color: '#e8f0f4',
	      backgroundColor: '#a4becb'
	    }
	  },
	
	  Action: {
	    DefaultStyle: {
	      background: '#ffffff',
	      borderRadius: '2px',
	      padding: '6px 20px',
	      fontWeight: 'bold',
	      margin: '10px 0 0 0',
	      border: 0
	    },
	
	    success: {
	      backgroundColor: defaultColors.success.hex,
	      color: '#ffffff'
	    },
	
	    error: {
	      backgroundColor: defaultColors.error.hex,
	      color: '#ffffff'
	    },
	
	    warning: {
	      backgroundColor: defaultColors.warning.hex,
	      color: '#ffffff'
	    },
	
	    info: {
	      backgroundColor: defaultColors.info.hex,
	      color: '#ffffff'
	    }
	  },
	
	  ActionWrapper: {
	    DefaultStyle: {
	      margin: 0,
	      padding: 0
	    }
	  }
	};
	
	module.exports = STYLES;


/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.QRCode = QRCode;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var QRCodeImpl = __webpack_require__(1642);
	var ErrorCorrectLevel = __webpack_require__(787);
	
	function QRCode() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var _ref$value = _ref.value,
	        value = _ref$value === undefined ? "" : _ref$value,
	        _ref$level = _ref.level,
	        level = _ref$level === undefined ? "L" : _ref$level,
	        _ref$bgColor = _ref.bgColor,
	        bgColor = _ref$bgColor === undefined ? "#FFFFFF" : _ref$bgColor,
	        _ref$fgColor = _ref.fgColor,
	        fgColor = _ref$fgColor === undefined ? "#000000" : _ref$fgColor,
	        _ref$cellClassPrefix = _ref.cellClassPrefix,
	        cellClassPrefix = _ref$cellClassPrefix === undefined ? "" : _ref$cellClassPrefix,
	        otherProps = _objectWithoutProperties(_ref, ["value", "level", "bgColor", "fgColor", "cellClassPrefix"]);
	
	    // adapted from https://github.com/zpao/qrcode.react/blob/master/src/index.js
	    var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
	    qrcode.addData(value);
	    qrcode.make();
	
	    var cells = qrcode.modules;
	
	    var cellClassName = cellClassPrefix && cellClassPrefix + "-cell";
	    var emptyCellClassName = cellClassPrefix && cellClassName + " " + cellClassPrefix + "-cell-empty";
	    var filledCellClassName = cellClassPrefix && cellClassName + " " + cellClassPrefix + "-cell-filled";
	
	    var cellIndex = 0; // we use simple order as a key just to avoid the key warning here
	
	    return _react2.default.createElement(
	        "svg",
	        _extends({
	            shapeRendering: "crispEdges",
	            viewBox: [0, 0, cells.length, cells.length].join(" ")
	        }, otherProps),
	        cells.map(function (row, rowIndex) {
	            return row.map(function (cell, colIndex) {
	                var className = cell ? filledCellClassName : emptyCellClassName;
	                var classNameProp = className ? { className: className } : null;
	
	                // Only use the fill if no cellClassPrefix was set. See https://github.com/no23reason/react-qr-svg/issues/136 for reasoning.
	                var fill = !classNameProp && (cell ? fgColor : bgColor);
	                var styleProp = fill ? { style: { fill: fill } } : null;
	                return _react2.default.createElement("rect", _extends({
	                    height: 1,
	                    key: cellIndex++ // string was too slow here
	                }, styleProp, classNameProp, {
	                    width: 1,
	                    x: colIndex,
	                    y: rowIndex
	                }));
	            });
	        })
	    );
	}
	
	QRCode.propTypes = {
	    value: _propTypes2.default.string.isRequired,
	    size: _propTypes2.default.number,
	    level: _propTypes2.default.oneOf(["L", "M", "Q", "H"]),
	    bgColor: _propTypes2.default.string,
	    fgColor: _propTypes2.default.string,
	    cellClassPrefix: _propTypes2.default.string
	};

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _qrSvg = __webpack_require__(1843);
	
	module.exports = { QRCode: _qrSvg.QRCode };

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Resizable = _interopRequireDefault(__webpack_require__(852));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// An example use of Resizable.
	var ResizableBox =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ResizableBox, _React$Component);
	
	  function ResizableBox() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      width: _this.props.width,
	      height: _this.props.height,
	      propsWidth: _this.props.width,
	      propsHeight: _this.props.height
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onResize", function (e, data) {
	      var size = data.size;
	      var width = size.width,
	          height = size.height;
	
	      if (_this.props.onResize) {
	        e.persist && e.persist();
	
	        _this.setState(size, function () {
	          return _this.props.onResize && _this.props.onResize(e, data);
	        });
	      } else {
	        _this.setState(size);
	      }
	    });
	
	    return _this;
	  }
	
	  ResizableBox.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    // If parent changes height/width, set that in our state.
	    if (state.propsWidth !== props.width || state.propsHeight !== props.height) {
	      return {
	        width: props.width,
	        height: props.height,
	        propsWidth: props.width,
	        propsHeight: props.height
	      };
	    }
	
	    return null;
	  };
	
	  var _proto = ResizableBox.prototype;
	
	  _proto.render = function render() {
	    // Basic wrapper around a Resizable instance.
	    // If you use Resizable directly, you are responsible for updating the child component
	    // with a new width and height.
	    var _this$props = this.props,
	        handle = _this$props.handle,
	        handleSize = _this$props.handleSize,
	        onResize = _this$props.onResize,
	        onResizeStart = _this$props.onResizeStart,
	        onResizeStop = _this$props.onResizeStop,
	        draggableOpts = _this$props.draggableOpts,
	        minConstraints = _this$props.minConstraints,
	        maxConstraints = _this$props.maxConstraints,
	        lockAspectRatio = _this$props.lockAspectRatio,
	        axis = _this$props.axis,
	        width = _this$props.width,
	        height = _this$props.height,
	        resizeHandles = _this$props.resizeHandles,
	        props = _objectWithoutPropertiesLoose(_this$props, ["handle", "handleSize", "onResize", "onResizeStart", "onResizeStop", "draggableOpts", "minConstraints", "maxConstraints", "lockAspectRatio", "axis", "width", "height", "resizeHandles"]);
	
	    return _react.default.createElement(_Resizable.default, {
	      handle: handle,
	      handleSize: handleSize,
	      width: this.state.width,
	      height: this.state.height,
	      onResizeStart: onResizeStart,
	      onResize: this.onResize,
	      onResizeStop: onResizeStop,
	      draggableOpts: draggableOpts,
	      minConstraints: minConstraints,
	      maxConstraints: maxConstraints,
	      lockAspectRatio: lockAspectRatio,
	      axis: axis,
	      resizeHandles: resizeHandles
	    }, _react.default.createElement("div", _extends({
	      style: {
	        width: this.state.width + 'px',
	        height: this.state.height + 'px'
	      }
	    }, props)));
	  };
	
	  return ResizableBox;
	}(_react.default.Component);
	
	exports.default = ResizableBox;
	
	_defineProperty(ResizableBox, "propTypes", {
	  height: _propTypes.default.number,
	  width: _propTypes.default.number
	});
	
	_defineProperty(ResizableBox, "defaultProps", {
	  handleSize: [20, 20]
	});

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.cloneElement = cloneElement;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// React.addons.cloneWithProps look-alike that merges style & className.
	function cloneElement(element, props) {
	  if (props.style && element.props.style) {
	    props.style = _objectSpread({}, element.props.style, {}, props.style);
	  }
	
	  if (props.className && element.props.className) {
	    props.className = element.props.className + " " + props.className;
	  }
	
	  return _react.default.cloneElement(element, props);
	}

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = function() {
	  throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
	};
	
	module.exports.Resizable = __webpack_require__(852).default;
	module.exports.ResizableBox = __webpack_require__(1845).default;


/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "DraggableCore", {
	  enumerable: true,
	  get: function get() {
	    return _DraggableCore.default;
	  }
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _clsx2 = _interopRequireDefault(__webpack_require__(1041));
	
	var _domFns = __webpack_require__(529);
	
	var _positionFns = __webpack_require__(854);
	
	var _shims = __webpack_require__(380);
	
	var _DraggableCore = _interopRequireDefault(__webpack_require__(1849));
	
	var _log = _interopRequireDefault(__webpack_require__(853));
	
	var _excluded = ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"];
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	//
	// Define <Draggable>
	//
	var Draggable = /*#__PURE__*/function (_React$Component) {
	  _inherits(Draggable, _React$Component);
	
	  var _super = _createSuper(Draggable);
	
	  function Draggable(props
	  /*: DraggableProps*/
	  ) {
	    var _this;
	
	    _classCallCheck(this, Draggable);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "onDragStart", function (e, coreData) {
	      (0, _log.default)('Draggable: onDragStart: %j', coreData); // Short-circuit if user's callback killed it.
	
	      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData)); // Kills start event on core as well, so move handlers are never bound.
	
	
	      if (shouldStart === false) return false;
	
	      _this.setState({
	        dragging: true,
	        dragged: true
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDrag", function (e, coreData) {
	      if (!_this.state.dragging) return false;
	      (0, _log.default)('Draggable: onDrag: %j', coreData);
	      var uiData = (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData);
	      var newState
	      /*: $Shape<DraggableState>*/
	      = {
	        x: uiData.x,
	        y: uiData.y
	      }; // Keep within bounds.
	
	      if (_this.props.bounds) {
	        // Save original x and y.
	        var x = newState.x,
	            y = newState.y; // Add slack to the values used to calculate bound position. This will ensure that if
	        // we start removing slack, the element won't react to it right away until it's been
	        // completely removed.
	
	        newState.x += _this.state.slackX;
	        newState.y += _this.state.slackY; // Get bound position. This will ceil/floor the x and y within the boundaries.
	
	        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_assertThisInitialized(_this), newState.x, newState.y),
	            _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2),
	            newStateX = _getBoundPosition2[0],
	            newStateY = _getBoundPosition2[1];
	
	        newState.x = newStateX;
	        newState.y = newStateY; // Recalculate slack by noting how much was shaved by the boundPosition handler.
	
	        newState.slackX = _this.state.slackX + (x - newState.x);
	        newState.slackY = _this.state.slackY + (y - newState.y); // Update the event we fire to reflect what really happened after bounds took effect.
	
	        uiData.x = newState.x;
	        uiData.y = newState.y;
	        uiData.deltaX = newState.x - _this.state.x;
	        uiData.deltaY = newState.y - _this.state.y;
	      } // Short-circuit if user's callback killed it.
	
	
	      var shouldUpdate = _this.props.onDrag(e, uiData);
	
	      if (shouldUpdate === false) return false;
	
	      _this.setState(newState);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDragStop", function (e, coreData) {
	      if (!_this.state.dragging) return false; // Short-circuit if user's callback killed it.
	
	      var shouldContinue = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData));
	
	      if (shouldContinue === false) return false;
	      (0, _log.default)('Draggable: onDragStop: %j', coreData);
	      var newState
	      /*: $Shape<DraggableState>*/
	      = {
	        dragging: false,
	        slackX: 0,
	        slackY: 0
	      }; // If this is a controlled component, the result of this operation will be to
	      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
	
	      var controlled = Boolean(_this.props.position);
	
	      if (controlled) {
	        var _this$props$position = _this.props.position,
	            x = _this$props$position.x,
	            y = _this$props$position.y;
	        newState.x = x;
	        newState.y = y;
	      }
	
	      _this.setState(newState);
	    });
	
	    _this.state = {
	      // Whether or not we are currently dragging.
	      dragging: false,
	      // Whether or not we have been dragged before.
	      dragged: false,
	      // Current transform x and y.
	      x: props.position ? props.position.x : props.defaultPosition.x,
	      y: props.position ? props.position.y : props.defaultPosition.y,
	      prevPropsPosition: _objectSpread({}, props.position),
	      // Used for compensating for out-of-bounds drags
	      slackX: 0,
	      slackY: 0,
	      // Can only determine if SVG after mounting
	      isElementSVG: false
	    };
	
	    if (props.position && !(props.onDrag || props.onStop)) {
	      // eslint-disable-next-line no-console
	      console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
	    }
	
	    return _this;
	  }
	
	  _createClass(Draggable, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Check to see if the element passed is an instanceof SVGElement
	      if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) {
	        this.setState({
	          isElementSVG: true
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.setState({
	        dragging: false
	      }); // prevents invariant if unmounted while dragging
	    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
	    // the underlying DOM node ourselves. See the README for more information.
	
	  }, {
	    key: "findDOMNode",
	    value: function findDOMNode()
	    /*: ?HTMLElement*/
	    {
	      var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;
	
	      return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom.default.findDOMNode(this);
	    }
	  }, {
	    key: "render",
	    value: function render()
	    /*: ReactElement<any>*/
	    {
	      var _clsx;
	
	      var _this$props2 = this.props,
	          axis = _this$props2.axis,
	          bounds = _this$props2.bounds,
	          children = _this$props2.children,
	          defaultPosition = _this$props2.defaultPosition,
	          defaultClassName = _this$props2.defaultClassName,
	          defaultClassNameDragging = _this$props2.defaultClassNameDragging,
	          defaultClassNameDragged = _this$props2.defaultClassNameDragged,
	          position = _this$props2.position,
	          positionOffset = _this$props2.positionOffset,
	          scale = _this$props2.scale,
	          draggableCoreProps = _objectWithoutProperties(_this$props2, _excluded);
	
	      var style = {};
	      var svgTransform = null; // If this is controlled, we don't want to move it - unless it's dragging.
	
	      var controlled = Boolean(position);
	      var draggable = !controlled || this.state.dragging;
	      var validPosition = position || defaultPosition;
	      var transformOpts = {
	        // Set left if horizontal drag is enabled
	        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : validPosition.x,
	        // Set top if vertical drag is enabled
	        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : validPosition.y
	      }; // If this element was SVG, we use the `transform` attribute.
	
	      if (this.state.isElementSVG) {
	        svgTransform = (0, _domFns.createSVGTransform)(transformOpts, positionOffset);
	      } else {
	        // Add a CSS transform to move the element around. This allows us to move the element around
	        // without worrying about whether or not it is relatively or absolutely positioned.
	        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
	        // has a clean slate.
	        style = (0, _domFns.createCSSTransform)(transformOpts, positionOffset);
	      } // Mark with class while dragging
	
	
	      var className = (0, _clsx2.default)(children.props.className || '', defaultClassName, (_clsx = {}, _defineProperty(_clsx, defaultClassNameDragging, this.state.dragging), _defineProperty(_clsx, defaultClassNameDragged, this.state.dragged), _clsx)); // Reuse the child provided
	      // This makes it flexible to use whatever element is wanted (div, ul, etc)
	
	      return /*#__PURE__*/React.createElement(_DraggableCore.default, _extends({}, draggableCoreProps, {
	        onStart: this.onDragStart,
	        onDrag: this.onDrag,
	        onStop: this.onDragStop
	      }), /*#__PURE__*/React.cloneElement(React.Children.only(children), {
	        className: className,
	        style: _objectSpread(_objectSpread({}, children.props.style), style),
	        transform: svgTransform
	      }));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: // React 16.3+
	    // Arity (props, state)
	    function getDerivedStateFromProps(_ref, _ref2)
	    /*: ?$Shape<DraggableState>*/
	    {
	      var position = _ref.position;
	      var prevPropsPosition = _ref2.prevPropsPosition;
	
	      // Set x/y if a new position is provided in props that is different than the previous.
	      if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
	        (0, _log.default)('Draggable: getDerivedStateFromProps %j', {
	          position: position,
	          prevPropsPosition: prevPropsPosition
	        });
	        return {
	          x: position.x,
	          y: position.y,
	          prevPropsPosition: _objectSpread({}, position)
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Draggable;
	}(React.Component);
	
	exports.default = Draggable;
	
	_defineProperty(Draggable, "displayName", 'Draggable');
	
	_defineProperty(Draggable, "propTypes", _objectSpread(_objectSpread({}, _DraggableCore.default.propTypes), {}, {
	  /**
	   * `axis` determines which axis the draggable can move.
	   *
	   *  Note that all callbacks will still return data as normal. This only
	   *  controls flushing to the DOM.
	   *
	   * 'both' allows movement horizontally and vertically.
	   * 'x' limits movement to horizontal axis.
	   * 'y' limits movement to vertical axis.
	   * 'none' limits all movement.
	   *
	   * Defaults to 'both'.
	   */
	  axis: _propTypes.default.oneOf(['both', 'x', 'y', 'none']),
	
	  /**
	   * `bounds` determines the range of movement available to the element.
	   * Available values are:
	   *
	   * 'parent' restricts movement within the Draggable's parent node.
	   *
	   * Alternatively, pass an object with the following properties, all of which are optional:
	   *
	   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
	   *
	   * All values are in px.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable bounds={{right: 300, bottom: 300}}>
	   *              <div>Content</div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  bounds: _propTypes.default.oneOfType([_propTypes.default.shape({
	    left: _propTypes.default.number,
	    right: _propTypes.default.number,
	    top: _propTypes.default.number,
	    bottom: _propTypes.default.number
	  }), _propTypes.default.string, _propTypes.default.oneOf([false])]),
	  defaultClassName: _propTypes.default.string,
	  defaultClassNameDragging: _propTypes.default.string,
	  defaultClassNameDragged: _propTypes.default.string,
	
	  /**
	   * `defaultPosition` specifies the x and y that the dragged item should start at
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  defaultPosition: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }),
	  positionOffset: _propTypes.default.shape({
	    x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  }),
	
	  /**
	   * `position`, if present, defines the current position of the element.
	   *
	   *  This is similar to how form elements in React work - if no `position` is supplied, the component
	   *  is uncontrolled.
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable position={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  position: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }),
	
	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: _shims.dontSetMe,
	  style: _shims.dontSetMe,
	  transform: _shims.dontSetMe
	}));
	
	_defineProperty(Draggable, "defaultProps", _objectSpread(_objectSpread({}, _DraggableCore.default.defaultProps), {}, {
	  axis: 'both',
	  bounds: false,
	  defaultClassName: 'react-draggable',
	  defaultClassNameDragging: 'react-draggable-dragging',
	  defaultClassNameDragged: 'react-draggable-dragged',
	  defaultPosition: {
	    x: 0,
	    y: 0
	  },
	  scale: 1
	}));

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _domFns = __webpack_require__(529);
	
	var _positionFns = __webpack_require__(854);
	
	var _shims = __webpack_require__(380);
	
	var _log = _interopRequireDefault(__webpack_require__(853));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Simple abstraction for dragging events names.
	var eventsFor = {
	  touch: {
	    start: 'touchstart',
	    move: 'touchmove',
	    stop: 'touchend'
	  },
	  mouse: {
	    start: 'mousedown',
	    move: 'mousemove',
	    stop: 'mouseup'
	  }
	}; // Default to mouse events.
	
	var dragEventFor = eventsFor.mouse;
	/*:: type DraggableCoreState = {
	  dragging: boolean,
	  lastX: number,
	  lastY: number,
	  touchIdentifier: ?number
	};*/
	
	/*:: export type DraggableData = {
	  node: HTMLElement,
	  x: number, y: number,
	  deltaX: number, deltaY: number,
	  lastX: number, lastY: number,
	};*/
	
	/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/
	
	/*:: export type ControlPosition = {x: number, y: number};*/
	
	/*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/
	
	/*:: export type DraggableCoreDefaultProps = {
	  allowAnyClick: boolean,
	  disabled: boolean,
	  enableUserSelectHack: boolean,
	  onStart: DraggableEventHandler,
	  onDrag: DraggableEventHandler,
	  onStop: DraggableEventHandler,
	  onMouseDown: (e: MouseEvent) => void,
	  scale: number,
	};*/
	
	/*:: export type DraggableCoreProps = {
	  ...DraggableCoreDefaultProps,
	  cancel: string,
	  children: ReactElement<any>,
	  offsetParent: HTMLElement,
	  grid: [number, number],
	  handle: string,
	  nodeRef?: ?React.ElementRef<any>,
	};*/
	
	//
	// Define <DraggableCore>.
	//
	// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
	// work well with libraries that require more control over the element.
	//
	var DraggableCore = /*#__PURE__*/function (_React$Component) {
	  _inherits(DraggableCore, _React$Component);
	
	  var _super = _createSuper(DraggableCore);
	
	  function DraggableCore() {
	    var _this;
	
	    _classCallCheck(this, DraggableCore);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      dragging: false,
	      // Used while dragging to determine deltas.
	      lastX: NaN,
	      lastY: NaN,
	      touchIdentifier: null
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "mounted", false);
	
	    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (e) {
	      // Make it possible to attach event handlers on top of this one.
	      _this.props.onMouseDown(e); // Only accept left-clicks.
	
	
	      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false; // Get nodes. Be sure to grab relative document (could be iframed)
	
	      var thisNode = _this.findDOMNode();
	
	      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
	        throw new Error('<DraggableCore> not mounted on DragStart!');
	      }
	
	      var ownerDocument = thisNode.ownerDocument; // Short circuit if handle or cancel prop was provided and selector doesn't match.
	
	      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
	        return;
	      } // Prevent scrolling on mobile devices, like ipad/iphone.
	      // Important that this is after handle/cancel.
	
	
	      if (e.type === 'touchstart') e.preventDefault(); // Set touch identifier in component state if this is a touch event. This allows us to
	      // distinguish between individual touches on multitouch screens by identifying which
	      // touchpoint was set to this element.
	
	      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
	
	      _this.setState({
	        touchIdentifier: touchIdentifier
	      }); // Get the current drag point from the event. This is used as the offset.
	
	
	      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _assertThisInitialized(_this));
	      if (position == null) return; // not possible but satisfies flow
	
	      var x = position.x,
	          y = position.y; // Create an event object with all the data parents need to make a decision here.
	
	      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
	      (0, _log.default)('DraggableCore: handleDragStart: %j', coreEvent); // Call event handler. If it returns explicit false, cancel.
	
	      (0, _log.default)('calling', _this.props.onStart);
	
	      var shouldUpdate = _this.props.onStart(e, coreEvent);
	
	      if (shouldUpdate === false || _this.mounted === false) return; // Add a style to the body to disable user-select. This prevents text from
	      // being selected all over the page.
	
	      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument); // Initiate dragging. Set the current x and y as offsets
	      // so we know how much we've moved during the drag. This allows us
	      // to drag elements around even if they have been moved, without issue.
	
	      _this.setState({
	        dragging: true,
	        lastX: x,
	        lastY: y
	      }); // Add events to the document directly so we catch when the user's mouse/touch moves outside of
	      // this element. We use different events depending on whether or not we have detected that this
	      // is a touch-capable device.
	
	
	      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
	      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleDrag", function (e) {
	      // Get the current drag point from the event. This is used as the offset.
	      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
	      if (position == null) return;
	      var x = position.x,
	          y = position.y; // Snap to grid if prop has been provided
	
	      if (Array.isArray(_this.props.grid)) {
	        var deltaX = x - _this.state.lastX,
	            deltaY = y - _this.state.lastY;
	
	        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
	
	        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);
	
	        deltaX = _snapToGrid2[0];
	        deltaY = _snapToGrid2[1];
	        if (!deltaX && !deltaY) return; // skip useless drag
	
	        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
	      }
	
	      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
	      (0, _log.default)('DraggableCore: handleDrag: %j', coreEvent); // Call event handler. If it returns explicit false, trigger end.
	
	      var shouldUpdate = _this.props.onDrag(e, coreEvent);
	
	      if (shouldUpdate === false || _this.mounted === false) {
	        try {
	          // $FlowIgnore
	          _this.handleDragStop(new MouseEvent('mouseup'));
	        } catch (err) {
	          // Old browsers
	          var event = ((document.createEvent('MouseEvents')
	          /*: any*/
	          )
	          /*: MouseTouchEvent*/
	          ); // I see why this insanity was deprecated
	          // $FlowIgnore
	
	          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	
	          _this.handleDragStop(event);
	        }
	
	        return;
	      }
	
	      _this.setState({
	        lastX: x,
	        lastY: y
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleDragStop", function (e) {
	      if (!_this.state.dragging) return;
	      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
	      if (position == null) return;
	      var x = position.x,
	          y = position.y;
	      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y); // Call event handler
	
	      var shouldContinue = _this.props.onStop(e, coreEvent);
	
	      if (shouldContinue === false || _this.mounted === false) return false;
	
	      var thisNode = _this.findDOMNode();
	
	      if (thisNode) {
	        // Remove user-select hack
	        if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
	      }
	
	      (0, _log.default)('DraggableCore: handleDragStop: %j', coreEvent); // Reset the el.
	
	      _this.setState({
	        dragging: false,
	        lastX: NaN,
	        lastY: NaN
	      });
	
	      if (thisNode) {
	        // Remove event handlers
	        (0, _log.default)('DraggableCore: Removing handlers');
	        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
	        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e) {
	      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
	
	      return _this.handleDragStart(e);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function (e) {
	      dragEventFor = eventsFor.mouse;
	      return _this.handleDragStop(e);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTouchStart", function (e) {
	      // We're on a touch device now, so change the event handlers
	      dragEventFor = eventsFor.touch;
	      return _this.handleDragStart(e);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTouchEnd", function (e) {
	      // We're on a touch device now, so change the event handlers
	      dragEventFor = eventsFor.touch;
	      return _this.handleDragStop(e);
	    });
	
	    return _this;
	  }
	
	  _createClass(DraggableCore, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true; // Touch handlers must be added with {passive: false} to be cancelable.
	      // https://developers.google.com/web/updates/2017/01/scrolling-intervention
	
	      var thisNode = this.findDOMNode();
	
	      if (thisNode) {
	        (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
	          passive: false
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false; // Remove any leftover event handlers. Remove both touch and mouse handlers in case
	      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
	
	      var thisNode = this.findDOMNode();
	
	      if (thisNode) {
	        var ownerDocument = thisNode.ownerDocument;
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
	        (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
	          passive: false
	        });
	        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
	      }
	    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
	    // the underlying DOM node ourselves. See the README for more information.
	
	  }, {
	    key: "findDOMNode",
	    value: function findDOMNode()
	    /*: ?HTMLElement*/
	    {
	      var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;
	
	      return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom.default.findDOMNode(this);
	    }
	  }, {
	    key: "render",
	    value: function render()
	    /*: React.Element<any>*/
	    {
	      // Reuse the child provided
	      // This makes it flexible to use whatever element is wanted (div, ul, etc)
	      return /*#__PURE__*/React.cloneElement(React.Children.only(this.props.children), {
	        // Note: mouseMove handler is attached to document so it will still function
	        // when the user drags quickly and leaves the bounds of the element.
	        onMouseDown: this.onMouseDown,
	        onMouseUp: this.onMouseUp,
	        // onTouchStart is added on `componentDidMount` so they can be added with
	        // {passive: false}, which allows it to cancel. See
	        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
	        onTouchEnd: this.onTouchEnd
	      });
	    }
	  }]);
	
	  return DraggableCore;
	}(React.Component);
	
	exports.default = DraggableCore;
	
	_defineProperty(DraggableCore, "displayName", 'DraggableCore');
	
	_defineProperty(DraggableCore, "propTypes", {
	  /**
	   * `allowAnyClick` allows dragging using any mouse button.
	   * By default, we only accept the left button.
	   *
	   * Defaults to `false`.
	   */
	  allowAnyClick: _propTypes.default.bool,
	
	  /**
	   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
	   * with the exception of `onMouseDown`, will not fire.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * By default, we add 'user-select:none' attributes to the document body
	   * to prevent ugly text selection during drag. If this is causing problems
	   * for your app, set this to `false`.
	   */
	  enableUserSelectHack: _propTypes.default.bool,
	
	  /**
	   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
	   * instead of using the parent node.
	   */
	  offsetParent: function offsetParent(props
	  /*: DraggableCoreProps*/
	  , propName
	  /*: $Keys<DraggableCoreProps>*/
	  ) {
	    if (props[propName] && props[propName].nodeType !== 1) {
	      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
	    }
	  },
	
	  /**
	   * `grid` specifies the x and y that dragging should snap to.
	   */
	  grid: _propTypes.default.arrayOf(_propTypes.default.number),
	
	  /**
	   * `handle` specifies a selector to be used as the handle that initiates drag.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable handle=".handle">
	   *              <div>
	   *                  <div className="handle">Click me to drag</div>
	   *                  <div>This is some other content</div>
	   *              </div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  handle: _propTypes.default.string,
	
	  /**
	   * `cancel` specifies a selector to be used to prevent drag initialization.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *           return(
	   *               <Draggable cancel=".cancel">
	   *                   <div>
	   *                     <div className="cancel">You can't drag from here</div>
	   *                     <div>Dragging here works fine</div>
	   *                   </div>
	   *               </Draggable>
	   *           );
	   *       }
	   *   });
	   * ```
	   */
	  cancel: _propTypes.default.string,
	
	  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
	   * Unfortunately, in order for <Draggable> to work properly, we need raw access
	   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
	   * as in this example:
	   *
	   * function MyComponent() {
	   *   const nodeRef = React.useRef(null);
	   *   return (
	   *     <Draggable nodeRef={nodeRef}>
	   *       <div ref={nodeRef}>Example Target</div>
	   *     </Draggable>
	   *   );
	   * }
	   *
	   * This can be used for arbitrarily nested components, so long as the ref ends up
	   * pointing to the actual child DOM node and not a custom component.
	   */
	  nodeRef: _propTypes.default.object,
	
	  /**
	   * Called when dragging starts.
	   * If this function returns the boolean false, dragging will be canceled.
	   */
	  onStart: _propTypes.default.func,
	
	  /**
	   * Called while dragging.
	   * If this function returns the boolean false, dragging will be canceled.
	   */
	  onDrag: _propTypes.default.func,
	
	  /**
	   * Called when dragging stops.
	   * If this function returns the boolean false, the drag will remain active.
	   */
	  onStop: _propTypes.default.func,
	
	  /**
	   * A workaround option which can be passed if onMouseDown needs to be accessed,
	   * since it'll always be blocked (as there is internal use of onMouseDown)
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * `scale`, if set, applies scaling while dragging an element
	   */
	  scale: _propTypes.default.number,
	
	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: _shims.dontSetMe,
	  style: _shims.dontSetMe,
	  transform: _shims.dontSetMe
	});
	
	_defineProperty(DraggableCore, "defaultProps", {
	  allowAnyClick: false,
	  // by default only accept left click
	  disabled: false,
	  enableUserSelectHack: true,
	  onStart: function onStart() {},
	  onDrag: function onDrag() {},
	  onStop: function onStop() {},
	  onMouseDown: function onMouseDown() {},
	  scale: 1
	});

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _require = __webpack_require__(1848),
	    Draggable = _require.default,
	    DraggableCore = _require.DraggableCore; // Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
	// See https://github.com/mzabriskie/react-draggable/pull/254
	// and https://github.com/mzabriskie/react-draggable/issues/266
	
	
	module.exports = Draggable;
	module.exports.default = Draggable;
	module.exports.DraggableCore = DraggableCore;

/***/ }),
/* 1851 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPrefix = getPrefix;
	exports.browserPrefixToKey = browserPrefixToKey;
	exports.browserPrefixToStyle = browserPrefixToStyle;
	exports.default = void 0;
	var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
	
	function getPrefix()
	/*: string*/
	{
	  var _window$document, _window$document$docu;
	
	  var prop
	  /*: string*/
	  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
	  // Ensure we're running in an environment where there is actually a global
	  // `window` obj
	  if (typeof window === 'undefined') return ''; // If we're in a pseudo-browser server-side environment, this access
	  // path may not exist, so bail out if it doesn't.
	
	  var style = (_window$document = window.document) === null || _window$document === void 0 ? void 0 : (_window$document$docu = _window$document.documentElement) === null || _window$document$docu === void 0 ? void 0 : _window$document$docu.style;
	  if (!style) return '';
	  if (prop in style) return '';
	
	  for (var i = 0; i < prefixes.length; i++) {
	    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
	  }
	
	  return '';
	}
	
	function browserPrefixToKey(prop
	/*: string*/
	, prefix
	/*: string*/
	)
	/*: string*/
	{
	  return prefix ? "".concat(prefix).concat(kebabToTitleCase(prop)) : prop;
	}
	
	function browserPrefixToStyle(prop
	/*: string*/
	, prefix
	/*: string*/
	)
	/*: string*/
	{
	  return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
	}
	
	function kebabToTitleCase(str
	/*: string*/
	)
	/*: string*/
	{
	  var out = '';
	  var shouldCapitalize = true;
	
	  for (var i = 0; i < str.length; i++) {
	    if (shouldCapitalize) {
	      out += str[i].toUpperCase();
	      shouldCapitalize = false;
	    } else if (str[i] === '-') {
	      shouldCapitalize = true;
	    } else {
	      out += str[i];
	    }
	  }
	
	  return out;
	} // Default export is the prefix itself, like 'Moz', 'Webkit', etc
	// Note that you may have to re-test for certain things; for instance, Chrome 50
	// can handle unprefixed `transform`, but not unprefixed `user-select`
	
	
	var _default = (getPrefix()
	/*: string*/
	);
	
	exports.default = _default;

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint -W084 */
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var PathUtils = __webpack_require__(530);
	
	function deepSearch(route, pathname, query) {
	  // Check the subtree first to find the most deeply-nested match.
	  var childRoutes = route.childRoutes;
	  if (childRoutes) {
	    var match, childRoute;
	    for (var i = 0, len = childRoutes.length; i < len; ++i) {
	      childRoute = childRoutes[i];
	
	      if (childRoute.isDefault || childRoute.isNotFound) continue; // Check these in order later.
	
	      if (match = deepSearch(childRoute, pathname, query)) {
	        // A route in the subtree matched! Add this route and we're done.
	        match.routes.unshift(route);
	        return match;
	      }
	    }
	  }
	
	  // No child routes matched; try the default route.
	  var defaultRoute = route.defaultRoute;
	  if (defaultRoute && (params = PathUtils.extractParams(defaultRoute.path, pathname))) return new Match(pathname, params, query, [route, defaultRoute]);
	
	  // Does the "not found" route match?
	  var notFoundRoute = route.notFoundRoute;
	  if (notFoundRoute && (params = PathUtils.extractParams(notFoundRoute.path, pathname))) return new Match(pathname, params, query, [route, notFoundRoute]);
	
	  // Last attempt: check this route.
	  var params = PathUtils.extractParams(route.path, pathname);
	  if (params) return new Match(pathname, params, query, [route]);
	
	  return null;
	}
	
	var Match = (function () {
	  _createClass(Match, null, [{
	    key: 'findMatch',
	
	    /**
	     * Attempts to match depth-first a route in the given route's
	     * subtree against the given path and returns the match if it
	     * succeeds, null if no match can be made.
	     */
	    value: function findMatch(routes, path) {
	      var pathname = PathUtils.withoutQuery(path);
	      var query = PathUtils.extractQuery(path);
	      var match = null;
	
	      for (var i = 0, len = routes.length; match == null && i < len; ++i) match = deepSearch(routes[i], pathname, query);
	
	      return match;
	    }
	  }]);
	
	  function Match(pathname, params, query, routes) {
	    _classCallCheck(this, Match);
	
	    this.pathname = pathname;
	    this.params = params;
	    this.query = query;
	    this.routes = routes;
	  }
	
	  return Match;
	})();
	
	module.exports = Match;

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var PropTypes = __webpack_require__(167);
	
	/**
	 * A mixin for components that modify the URL.
	 *
	 * Example:
	 *
	 *   var MyLink = React.createClass({
	 *     mixins: [ Router.Navigation ],
	 *     handleClick(event) {
	 *       event.preventDefault();
	 *       this.transitionTo('aRoute', { the: 'params' }, { the: 'query' });
	 *     },
	 *     render() {
	 *       return (
	 *         <a onClick={this.handleClick}>Click me!</a>
	 *       );
	 *     }
	 *   });
	 */
	var Navigation = {
	
	  contextTypes: {
	    router: PropTypes.router.isRequired
	  },
	
	  /**
	   * Returns an absolute URL path created from the given route
	   * name, URL parameters, and query values.
	   */
	  makePath: function makePath(to, params, query) {
	    return this.context.router.makePath(to, params, query);
	  },
	
	  /**
	   * Returns a string that may safely be used as the href of a
	   * link to the route with the given name.
	   */
	  makeHref: function makeHref(to, params, query) {
	    return this.context.router.makeHref(to, params, query);
	  },
	
	  /**
	   * Transitions to the URL specified in the arguments by pushing
	   * a new URL onto the history stack.
	   */
	  transitionTo: function transitionTo(to, params, query) {
	    this.context.router.transitionTo(to, params, query);
	  },
	
	  /**
	   * Transitions to the URL specified in the arguments by replacing
	   * the current URL in the history stack.
	   */
	  replaceWith: function replaceWith(to, params, query) {
	    this.context.router.replaceWith(to, params, query);
	  },
	
	  /**
	   * Transitions to the previous URL.
	   */
	  goBack: function goBack() {
	    return this.context.router.goBack();
	  }
	
	};
	
	module.exports = Navigation;

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(68);
	var canUseDOM = __webpack_require__(317);
	var getWindowScrollPosition = __webpack_require__(1860);
	
	function shouldUpdateScroll(state, prevState) {
	  if (!prevState) return true;
	
	  // Don't update scroll position when only the query has changed.
	  if (state.pathname === prevState.pathname) return false;
	
	  var routes = state.routes;
	  var prevRoutes = prevState.routes;
	
	  var sharedAncestorRoutes = routes.filter(function (route) {
	    return prevRoutes.indexOf(route) !== -1;
	  });
	
	  return !sharedAncestorRoutes.some(function (route) {
	    return route.ignoreScrollBehavior;
	  });
	}
	
	/**
	 * Provides the router with the ability to manage window scroll position
	 * according to its scroll behavior.
	 */
	var ScrollHistory = {
	
	  statics: {
	
	    /**
	     * Records curent scroll position as the last known position for the given URL path.
	     */
	    recordScrollPosition: function recordScrollPosition(path) {
	      if (!this.scrollHistory) this.scrollHistory = {};
	
	      this.scrollHistory[path] = getWindowScrollPosition();
	    },
	
	    /**
	     * Returns the last known scroll position for the given URL path.
	     */
	    getScrollPosition: function getScrollPosition(path) {
	      if (!this.scrollHistory) this.scrollHistory = {};
	
	      return this.scrollHistory[path] || null;
	    }
	
	  },
	
	  componentWillMount: function componentWillMount() {
	    invariant(this.constructor.getScrollBehavior() == null || canUseDOM, 'Cannot use scroll behavior without a DOM');
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._updateScroll();
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    this._updateScroll(prevState);
	  },
	
	  _updateScroll: function _updateScroll(prevState) {
	    if (!shouldUpdateScroll(this.state, prevState)) return;
	
	    var scrollBehavior = this.constructor.getScrollBehavior();
	
	    if (scrollBehavior) scrollBehavior.updateScrollPosition(this.constructor.getScrollPosition(this.state.path), this.state.action);
	  }
	
	};
	
	module.exports = ScrollHistory;

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var PropTypes = __webpack_require__(167);
	
	/**
	 * A mixin for components that need to know the path, routes, URL
	 * params and query that are currently active.
	 *
	 * Example:
	 *
	 *   var AboutLink = React.createClass({
	 *     mixins: [ Router.State ],
	 *     render() {
	 *       var className = this.props.className;
	 *
	 *       if (this.isActive('about'))
	 *         className += ' is-active';
	 *
	 *       return React.DOM.a({ className: className }, this.props.children);
	 *     }
	 *   });
	 */
	var State = {
	
	  contextTypes: {
	    router: PropTypes.router.isRequired
	  },
	
	  /**
	   * Returns the current URL path.
	   */
	  getPath: function getPath() {
	    return this.context.router.getCurrentPath();
	  },
	
	  /**
	   * Returns the current URL path without the query string.
	   */
	  getPathname: function getPathname() {
	    return this.context.router.getCurrentPathname();
	  },
	
	  /**
	   * Returns an object of the URL params that are currently active.
	   */
	  getParams: function getParams() {
	    return this.context.router.getCurrentParams();
	  },
	
	  /**
	   * Returns an object of the query params that are currently active.
	   */
	  getQuery: function getQuery() {
	    return this.context.router.getCurrentQuery();
	  },
	
	  /**
	   * Returns an array of the routes that are currently active.
	   */
	  getRoutes: function getRoutes() {
	    return this.context.router.getCurrentRoutes();
	  },
	
	  /**
	   * A helper method to determine if a given route, params, and query
	   * are active.
	   */
	  isActive: function isActive(to, params, query) {
	    return this.context.router.isActive(to, params, query);
	  }
	
	};
	
	module.exports = State;

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint -W058 */
	
	'use strict';
	
	var Cancellation = __webpack_require__(855);
	var Redirect = __webpack_require__(856);
	
	/**
	 * Encapsulates a transition to a given path.
	 *
	 * The willTransitionTo and willTransitionFrom handlers receive
	 * an instance of this class as their first argument.
	 */
	function Transition(path, retry) {
	  this.path = path;
	  this.abortReason = null;
	  // TODO: Change this to router.retryTransition(transition)
	  this.retry = retry.bind(this);
	}
	
	Transition.prototype.abort = function (reason) {
	  if (this.abortReason == null) this.abortReason = reason || 'ABORT';
	};
	
	Transition.prototype.redirect = function (to, params, query) {
	  this.abort(new Redirect(to, params, query));
	};
	
	Transition.prototype.cancel = function () {
	  this.abort(new Cancellation());
	};
	
	Transition.from = function (transition, routes, components, callback) {
	  routes.reduce(function (callback, route, index) {
	    return function (error) {
	      if (error || transition.abortReason) {
	        callback(error);
	      } else if (route.onLeave) {
	        try {
	          route.onLeave(transition, components[index], callback);
	
	          // If there is no callback in the argument list, call it automatically.
	          if (route.onLeave.length < 3) callback();
	        } catch (e) {
	          callback(e);
	        }
	      } else {
	        callback();
	      }
	    };
	  }, callback)();
	};
	
	Transition.to = function (transition, routes, params, query, callback) {
	  routes.reduceRight(function (callback, route) {
	    return function (error) {
	      if (error || transition.abortReason) {
	        callback(error);
	      } else if (route.onEnter) {
	        try {
	          route.onEnter(transition, params, query, callback);
	
	          // If there is no callback in the argument list, call it automatically.
	          if (route.onEnter.length < 4) callback();
	        } catch (e) {
	          callback(e);
	        }
	      } else {
	        callback();
	      }
	    };
	  }, callback)();
	};
	
	module.exports = Transition;

/***/ }),
/* 1857 */
/***/ (function(module, exports) {

	/**
	 * A scroll behavior that always scrolls to the top of the page
	 * after a transition.
	 */
	"use strict";
	
	var ScrollToTopBehavior = {
	
	  updateScrollPosition: function updateScrollPosition() {
	    window.scrollTo(0, 0);
	  }
	
	};
	
	module.exports = ScrollToTopBehavior;

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * This component is necessary to get around a context warning
	 * present in React 0.13.0. It sovles this by providing a separation
	 * between the "owner" and "parent" contexts.
	 */
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	
	var ContextWrapper = (function (_React$Component) {
	  _inherits(ContextWrapper, _React$Component);
	
	  function ContextWrapper() {
	    _classCallCheck(this, ContextWrapper);
	
	    _get(Object.getPrototypeOf(ContextWrapper.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ContextWrapper, [{
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return ContextWrapper;
	})(React.Component);
	
	module.exports = ContextWrapper;

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var assign = __webpack_require__(251);
	var PropTypes = __webpack_require__(167);
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * <Link> components are used to create an <a> element that links to a route.
	 * When that route is active, the link gets an "active" class name (or the
	 * value of its `activeClassName` prop).
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route name="showPost" path="/posts/:postID" handler={Post}/>
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to="showPost" params={{ postID: "123" }} />
	 *
	 * In addition to params, links may pass along query string parameters
	 * using the `query` prop.
	 *
	 *   <Link to="showPost" params={{ postID: "123" }} query={{ show:true }}/>
	 */
	
	var Link = (function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    _get(Object.getPrototypeOf(Link.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  _createClass(Link, [{
	    key: 'handleClick',
	    value: function handleClick(event) {
	      var allowTransition = true;
	      var clickResult;
	
	      if (this.props.onClick) clickResult = this.props.onClick(event);
	
	      if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	      if (clickResult === false || event.defaultPrevented === true) allowTransition = false;
	
	      event.preventDefault();
	
	      if (allowTransition) this.context.router.transitionTo(this.props.to, this.props.params, this.props.query);
	    }
	
	    /**
	     * Returns the value of the "href" attribute to use on the DOM element.
	     */
	  }, {
	    key: 'getHref',
	    value: function getHref() {
	      return this.context.router.makeHref(this.props.to, this.props.params, this.props.query);
	    }
	
	    /**
	     * Returns the value of the "class" attribute to use on the DOM element, which contains
	     * the value of the activeClassName property when this <Link> is active.
	     */
	  }, {
	    key: 'getClassName',
	    value: function getClassName() {
	      var className = this.props.className;
	
	      if (this.getActiveState()) className += ' ' + this.props.activeClassName;
	
	      return className;
	    }
	  }, {
	    key: 'getActiveState',
	    value: function getActiveState() {
	      return this.context.router.isActive(this.props.to, this.props.params, this.props.query);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = assign({}, this.props, {
	        href: this.getHref(),
	        className: this.getClassName(),
	        onClick: this.handleClick.bind(this)
	      });
	
	      if (props.activeStyle && this.getActiveState()) props.style = props.activeStyle;
	
	      delete props.to;
	      delete props.params;
	      delete props.query;
	      delete props.activeClassName;
	      delete props.activeStyle;
	
	      return React.DOM.a(props, this.props.children);
	    }
	  }]);
	
	  return Link;
	})(React.Component);
	
	Link.contextTypes = {
	  router: PropTypes.router.isRequired
	};
	
	Link.propTypes = {
	  activeClassName: PropTypes.string.isRequired,
	  to: PropTypes.oneOfType([PropTypes.string, PropTypes.route]).isRequired,
	  params: PropTypes.object,
	  query: PropTypes.object,
	  activeStyle: PropTypes.object,
	  onClick: PropTypes.func
	};
	
	Link.defaultProps = {
	  activeClassName: 'active',
	  className: ''
	};
	
	module.exports = Link;

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(68);
	var canUseDOM = __webpack_require__(317);
	
	/**
	 * Returns the current scroll position of the window as { x, y }.
	 */
	function getWindowScrollPosition() {
	  invariant(canUseDOM, 'Cannot get current scroll position without a DOM');
	
	  return {
	    x: window.pageXOffset || document.documentElement.scrollLeft,
	    y: window.pageYOffset || document.documentElement.scrollTop
	  };
	}
	
	module.exports = getWindowScrollPosition;

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	
	function isValidChild(object) {
	  return object == null || React.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	module.exports = isReactChildren;

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(68);
	var LocationActions = __webpack_require__(299);
	var History = __webpack_require__(250);
	
	/**
	 * A location that is convenient for testing and does not require a DOM.
	 */
	
	var TestLocation = (function () {
	  function TestLocation(history) {
	    _classCallCheck(this, TestLocation);
	
	    this.history = history || [];
	    this.listeners = [];
	    this.needsDOM = false;
	    this._updateHistoryLength();
	  }
	
	  _createClass(TestLocation, [{
	    key: '_updateHistoryLength',
	    value: function _updateHistoryLength() {
	      History.length = this.history.length;
	    }
	  }, {
	    key: '_notifyChange',
	    value: function _notifyChange(type) {
	      var change = {
	        path: this.getCurrentPath(),
	        type: type
	      };
	
	      for (var i = 0, len = this.listeners.length; i < len; ++i) this.listeners[i].call(this, change);
	    }
	  }, {
	    key: 'addChangeListener',
	    value: function addChangeListener(listener) {
	      this.listeners.push(listener);
	    }
	  }, {
	    key: 'removeChangeListener',
	    value: function removeChangeListener(listener) {
	      this.listeners = this.listeners.filter(function (l) {
	        return l !== listener;
	      });
	    }
	  }, {
	    key: 'push',
	    value: function push(path) {
	      this.history.push(path);
	      this._updateHistoryLength();
	      this._notifyChange(LocationActions.PUSH);
	    }
	  }, {
	    key: 'replace',
	    value: function replace(path) {
	      invariant(this.history.length, 'You cannot replace the current path with no history');
	
	      this.history[this.history.length - 1] = path;
	
	      this._notifyChange(LocationActions.REPLACE);
	    }
	  }, {
	    key: 'pop',
	    value: function pop() {
	      this.history.pop();
	      this._updateHistoryLength();
	      this._notifyChange(LocationActions.POP);
	    }
	  }, {
	    key: 'getCurrentPath',
	    value: function getCurrentPath() {
	      return this.history[this.history.length - 1];
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return '<TestLocation>';
	    }
	  }]);
	
	  return TestLocation;
	})();
	
	module.exports = TestLocation;

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createRouter = __webpack_require__(861);
	
	/**
	 * A high-level convenience method that creates, configures, and
	 * runs a router in one shot. The method signature is:
	 *
	 *   Router.run(routes[, location ], callback);
	 *
	 * Using `window.location.hash` to manage the URL, you could do:
	 *
	 *   Router.run(routes, function (Handler) {
	 *     React.render(<Handler/>, document.body);
	 *   });
	 * 
	 * Using HTML5 history and a custom "cursor" prop:
	 * 
	 *   Router.run(routes, Router.HistoryLocation, function (Handler) {
	 *     React.render(<Handler cursor={cursor}/>, document.body);
	 *   });
	 *
	 * Returns the newly created router.
	 *
	 * Note: If you need to specify further options for your router such
	 * as error/abort handling or custom scroll behavior, use Router.create
	 * instead.
	 *
	 *   var router = Router.create(options);
	 *   router.run(function (Handler) {
	 *     // ...
	 *   });
	 */
	function runRouter(routes, location, callback) {
	  if (typeof location === 'function') {
	    callback = location;
	    location = null;
	  }
	
	  var router = createRouter({
	    routes: routes,
	    location: location
	  });
	
	  router.run(callback);
	
	  return router;
	}
	
	module.exports = runRouter;

/***/ }),
/* 1864 */
/***/ (function(module, exports) {

	'use strict';
	
	function supportsHistory() {
	  /*! taken from modernizr
	   * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	   * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	   * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	   */
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	module.exports = supportsHistory;

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Async = __webpack_require__(866);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(867);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Select = __webpack_require__(383);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (_ref) {
						var ref = _ref.ref,
						    asyncProps = _objectWithoutProperties(_ref, ['ref']);
	
						var asyncRef = ref;
						return _react2.default.createElement(
							_Creatable2.default,
							asyncProps,
							function (_ref2) {
								var ref = _ref2.ref,
								    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
	
								var creatableRef = ref;
								return _this2.props.children(_extends({}, creatableProps, {
									ref: function ref(select) {
										creatableRef(select);
										asyncRef(select);
										_this2.select = select;
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	AsyncCreatableSelect.propTypes = {
		children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	};
	
	AsyncCreatableSelect.defaultProps = {
		children: defaultChildren
	};
	
	exports.default = AsyncCreatableSelect;

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(383);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(866);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(1865);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(867);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(869);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Option = __webpack_require__(868);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _defaultMenuRenderer = __webpack_require__(534);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultArrowRenderer = __webpack_require__(870);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(871);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(533);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	_Select2.default.Option = _Option2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;
	exports.Option = _Option2.default;
	exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
	exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
	exports.defaultClearRenderer = _defaultClearRenderer2.default;
	exports.defaultFilterOptions = _defaultFilterOptions2.default;

/***/ }),
/* 1867 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	};

/***/ }),
/* 1868 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var trim = function trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	exports.default = trim;

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'UNSAFE_componentWillReceiveProps',
			value: function UNSAFE_componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

	var SplitPane = __webpack_require__(874);
	
	module.exports = SplitPane;

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #000;\n  opacity: 0.2;\n  z-index: 1;\n  box-sizing: border-box;\n  background-clip: padding-box;\n\n  :hover {\n    transition: all 2s ease;\n  }\n'], ['\n  background: #000;\n  opacity: 0.2;\n  z-index: 1;\n  box-sizing: border-box;\n  background-clip: padding-box;\n\n  :hover {\n    transition: all 2s ease;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  height: 11px;\n  margin: -5px 0;\n  border-top: 5px solid rgba(255, 255, 255, 0);\n  border-bottom: 5px solid rgba(255, 255, 255, 0);\n  cursor: row-resize;\n  width: 100%;\n\n  :hover {\n    border-top: 5px solid rgba(0, 0, 0, 0.5);\n    border-bottom: 5px solid rgba(0, 0, 0, 0.5);\n  }\n\n  .disabled {\n    cursor: not-allowed;\n  }\n  .disabled:hover {\n    border-color: transparent;\n  }\n'], ['\n  height: 11px;\n  margin: -5px 0;\n  border-top: 5px solid rgba(255, 255, 255, 0);\n  border-bottom: 5px solid rgba(255, 255, 255, 0);\n  cursor: row-resize;\n  width: 100%;\n\n  :hover {\n    border-top: 5px solid rgba(0, 0, 0, 0.5);\n    border-bottom: 5px solid rgba(0, 0, 0, 0.5);\n  }\n\n  .disabled {\n    cursor: not-allowed;\n  }\n  .disabled:hover {\n    border-color: transparent;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  width: 11px;\n  margin: 0 -5px;\n  border-left: 5px solid rgba(255, 255, 255, 0);\n  border-right: 5px solid rgba(255, 255, 255, 0);\n  cursor: col-resize;\n\n  :hover {\n    border-left: 5px solid rgba(0, 0, 0, 0.5);\n    border-right: 5px solid rgba(0, 0, 0, 0.5);\n  }\n  .disabled {\n    cursor: not-allowed;\n  }\n  .disabled:hover {\n    border-color: transparent;\n  }\n'], ['\n  width: 11px;\n  margin: 0 -5px;\n  border-left: 5px solid rgba(255, 255, 255, 0);\n  border-right: 5px solid rgba(255, 255, 255, 0);\n  cursor: col-resize;\n\n  :hover {\n    border-left: 5px solid rgba(0, 0, 0, 0.5);\n    border-right: 5px solid rgba(0, 0, 0, 0.5);\n  }\n  .disabled {\n    cursor: not-allowed;\n  }\n  .disabled:hover {\n    border-color: transparent;\n  }\n']);
	
	var _react = __webpack_require__(535);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(67);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var HorizontalWrapper = (0, _styledComponents2.default)(Wrapper)(_templateObject2);
	
	var VerticalWrapper = (0, _styledComponents2.default)(Wrapper)(_templateObject3);
	
	var Resizer = function (_Component) {
	  _inherits(Resizer, _Component);
	
	  function Resizer() {
	    _classCallCheck(this, Resizer);
	
	    return _possibleConstructorReturn(this, (Resizer.__proto__ || Object.getPrototypeOf(Resizer)).apply(this, arguments));
	  }
	
	  _createClass(Resizer, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          index = _props.index,
	          _props$split = _props.split,
	          split = _props$split === undefined ? 'vertical' : _props$split,
	          _props$onClick = _props.onClick,
	          _onClick = _props$onClick === undefined ? function () {} : _props$onClick,
	          _props$onDoubleClick = _props.onDoubleClick,
	          _onDoubleClick = _props$onDoubleClick === undefined ? function () {} : _props$onDoubleClick,
	          _props$onMouseDown = _props.onMouseDown,
	          _onMouseDown = _props$onMouseDown === undefined ? function () {} : _props$onMouseDown,
	          _props$onTouchEnd = _props.onTouchEnd,
	          _onTouchEnd = _props$onTouchEnd === undefined ? function () {} : _props$onTouchEnd,
	          _props$onTouchStart = _props.onTouchStart,
	          _onTouchStart = _props$onTouchStart === undefined ? function () {} : _props$onTouchStart;
	
	      var props = {
	        ref: function ref(_) {
	          return _this2.resizer = _;
	        },
	        'data-attribute': split,
	        'data-type': 'Resizer',
	        onMouseDown: function onMouseDown(event) {
	          return _onMouseDown(event, index);
	        },
	        onTouchStart: function onTouchStart(event) {
	          event.preventDefault();
	          _onTouchStart(event, index);
	        },
	        onTouchEnd: function onTouchEnd(event) {
	          event.preventDefault();
	          _onTouchEnd(event, index);
	        },
	        onClick: function onClick(event) {
	          if (_onClick) {
	            event.preventDefault();
	            _onClick(event, index);
	          }
	        },
	        onDoubleClick: function onDoubleClick(event) {
	          if (_onDoubleClick) {
	            event.preventDefault();
	            _onDoubleClick(event, index);
	          }
	        }
	      };
	
	      return split === 'vertical' ? _react2.default.createElement(VerticalWrapper, props) : _react2.default.createElement(HorizontalWrapper, props);
	    }
	  }]);
	
	  return Resizer;
	}(_react.Component);
	
	exports.default = Resizer;
	module.exports = exports['default'];

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPrefixer;
	
	var _prefixProperty = __webpack_require__(1887);
	
	var _prefixProperty2 = _interopRequireDefault(_prefixProperty);
	
	var _prefixValue = __webpack_require__(1888);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	var _addNewValuesOnly = __webpack_require__(1885);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(1886);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	
	  function prefixAll(style) {
	    for (var property in style) {
	      var value = style[property];
	
	      // handle nested objects
	      if ((0, _isObject2.default)(value)) {
	        style[property] = prefixAll(value);
	        // handle array values
	      } else if (Array.isArray(value)) {
	        var combinedValue = [];
	
	        for (var i = 0, len = value.length; i < len; ++i) {
	          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
	          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	        }
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (combinedValue.length > 0) {
	          style[property] = combinedValue;
	        }
	      } else {
	        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (_processedValue) {
	          style[property] = _processedValue;
	        }
	
	        style = (0, _prefixProperty2.default)(prefixMap, property, style);
	      }
	    }
	
	    return style;
	  }
	
	  return prefixAll;
	}
	module.exports = exports['default'];

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createPrefixer = __webpack_require__(1872);
	
	var _createPrefixer2 = _interopRequireDefault(_createPrefixer);
	
	var _staticData = __webpack_require__(1884);
	
	var _staticData2 = _interopRequireDefault(_staticData);
	
	var _cursor = __webpack_require__(1875);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _crossFade = __webpack_require__(1874);
	
	var _crossFade2 = _interopRequireDefault(_crossFade);
	
	var _filter = __webpack_require__(1876);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _flex = __webpack_require__(1877);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxOld = __webpack_require__(1878);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(1879);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _imageSet = __webpack_require__(1880);
	
	var _imageSet2 = _interopRequireDefault(_imageSet);
	
	var _position = __webpack_require__(1881);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _sizing = __webpack_require__(1882);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(1883);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var plugins = [_crossFade2.default, _cursor2.default, _filter2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default, _flex2.default];
	
	exports.default = (0, _createPrefixer2.default)({
	  prefixMap: _staticData2.default.prefixMap,
	  plugins: plugins
	});
	module.exports = exports['default'];

/***/ }),
/* 1874 */
1332,
/* 1875 */
1333,
/* 1876 */
1334,
/* 1877 */
680,
/* 1878 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines',
	  flexGrow: 'WebkitBoxFlex'
	};
	
	function flexboxOld(property, value, style) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    if (value.indexOf('column') > -1) {
	      style.WebkitBoxOrient = 'vertical';
	    } else {
	      style.WebkitBoxOrient = 'horizontal';
	    }
	    if (value.indexOf('reverse') > -1) {
	      style.WebkitBoxDirection = 'reverse';
	    } else {
	      style.WebkitBoxDirection = 'normal';
	    }
	  }
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _isPrefixedValue = __webpack_require__(135);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
	    return prefixes.map(function (prefix) {
	      return value.replace(values, function (grad) {
	        return prefix + grad;
	      });
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1880 */
1336,
/* 1881 */
1337,
/* 1882 */
683,
/* 1883 */
[2365, 875],
/* 1884 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var w = ["Webkit"];
	var m = ["Moz"];
	var ms = ["ms"];
	var wm = ["Webkit", "Moz"];
	var wms = ["Webkit", "ms"];
	var wmms = ["Webkit", "Moz", "ms"];
	
	exports.default = {
	  plugins: [],
	  prefixMap: { "appearance": wm, "textEmphasisPosition": w, "textEmphasis": w, "textEmphasisStyle": w, "textEmphasisColor": w, "boxDecorationBreak": w, "maskImage": w, "maskMode": w, "maskRepeat": w, "maskPosition": w, "maskClip": w, "maskOrigin": w, "maskSize": w, "maskComposite": w, "mask": w, "maskBorderSource": w, "maskBorderMode": w, "maskBorderSlice": w, "maskBorderWidth": w, "maskBorderOutset": w, "maskBorderRepeat": w, "maskBorder": w, "maskType": w, "textDecorationStyle": w, "textDecorationSkip": w, "textDecorationLine": w, "textDecorationColor": w, "userSelect": wmms, "backdropFilter": w, "fontKerning": w, "scrollSnapType": wms, "scrollSnapPointsX": wms, "scrollSnapPointsY": wms, "scrollSnapDestination": wms, "scrollSnapCoordinate": wms, "clipPath": w, "shapeImageThreshold": w, "shapeImageMargin": w, "shapeImageOutside": w, "filter": w, "hyphens": wms, "flowInto": wms, "flowFrom": wms, "breakBefore": wms, "breakAfter": wms, "breakInside": wms, "regionFragment": wms, "writingMode": wms, "textOrientation": w, "tabSize": m, "fontFeatureSettings": w, "columnCount": w, "columnFill": w, "columnGap": w, "columnRule": w, "columnRuleColor": w, "columnRuleStyle": w, "columnRuleWidth": w, "columns": w, "columnSpan": w, "columnWidth": w, "wrapFlow": ms, "wrapThrough": ms, "wrapMargin": ms, "gridTemplateColumns": ms, "gridTemplateRows": ms, "gridTemplateAreas": ms, "gridTemplate": ms, "gridAutoColumns": ms, "gridAutoRows": ms, "gridAutoFlow": ms, "grid": ms, "gridRowStart": ms, "gridColumnStart": ms, "gridRowEnd": ms, "gridRow": ms, "gridColumn": ms, "gridColumnEnd": ms, "gridColumnGap": ms, "gridRowGap": ms, "gridArea": ms, "gridGap": ms, "textSizeAdjust": wms }
	};
	module.exports = exports["default"];

/***/ }),
/* 1885 */
685,
/* 1886 */
686,
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixProperty;
	
	var _capitalizeString = __webpack_require__(875);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function prefixProperty(prefixProperties, property, style) {
	  if (prefixProperties.hasOwnProperty(property)) {
	    var newStyle = {};
	    var requiredPrefixes = prefixProperties[property];
	    var capitalizedProperty = (0, _capitalizeString2.default)(property);
	    var keys = Object.keys(style);
	    for (var i = 0; i < keys.length; i++) {
	      var styleProperty = keys[i];
	      if (styleProperty === property) {
	        for (var j = 0; j < requiredPrefixes.length; j++) {
	          newStyle[requiredPrefixes[j] + capitalizedProperty] = style[property];
	        }
	      }
	      newStyle[styleProperty] = style[styleProperty];
	    }
	    return newStyle;
	  }
	  return style;
	}
	module.exports = exports['default'];

/***/ }),
/* 1888 */
463,
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(40),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _CalendarView = __webpack_require__(384);
	
	var _CalendarView2 = _interopRequireDefault(_CalendarView);
	
	var _dates = __webpack_require__(188);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _localizers = __webpack_require__(128);
	
	var _2 = __webpack_require__(93);
	
	var _3 = _interopRequireDefault(_2);
	
	var _propTypes3 = __webpack_require__(156);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _widgetHelpers = __webpack_require__(189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var format = function format(props) {
	  return _localizers.date.getFormat('decade', props.decadeFormat);
	};
	
	var optionId = function optionId(id, date) {
	  return id + '__century_' + _dates2.default.year(date);
	};
	
	var propTypes = {
	  culture: _propTypes2.default.string,
	  today: _propTypes2.default.instanceOf(Date),
	  value: _propTypes2.default.instanceOf(Date),
	  focused: _propTypes2.default.instanceOf(Date),
	  min: _propTypes2.default.instanceOf(Date),
	  max: _propTypes2.default.instanceOf(Date),
	  onChange: _propTypes2.default.func.isRequired,
	  decadeFormat: _propTypes4.default.dateFormat
	};
	
	exports.default = (0, _createReactClass2.default)({
	
	  displayName: 'CenturyView',
	
	  mixins: [__webpack_require__(300), __webpack_require__(301), __webpack_require__(216)()],
	
	  propTypes: propTypes,
	
	  componentDidUpdate: function componentDidUpdate() {
	    var activeId = optionId((0, _widgetHelpers.instanceId)(this), this.props.focused);
	    this.ariaActiveDescendant(activeId);
	  },
	  render: function render() {
	    var focused = this.props.focused;
	
	
	    return _react2.default.createElement(
	      _CalendarView2.default,
	      _3.default.omitOwnProps(this),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _3.default.chunk(getCenturyDecades(focused), 4).map(this.renderRow)
	      )
	    );
	  },
	  renderRow: function renderRow(row, rowIdx) {
	    var _this = this;
	
	    var _props = this.props,
	        focused = _props.focused,
	        disabled = _props.disabled,
	        onChange = _props.onChange,
	        value = _props.value,
	        today = _props.today,
	        culture = _props.culture,
	        min = _props.min,
	        max = _props.max;
	
	
	    var id = (0, _widgetHelpers.instanceId)(this, '_century');
	
	    return _react2.default.createElement(
	      _CalendarView2.default.Row,
	      { key: rowIdx },
	      row.map(function (date, colIdx) {
	        var label = _localizers.date.format(_dates2.default.startOf(date, 'decade'), format(_this.props), culture);
	
	        return _react2.default.createElement(
	          _CalendarView2.default.Cell,
	          {
	            key: colIdx,
	            unit: 'decade',
	            id: optionId(id, date),
	            label: label,
	            date: date,
	            now: today,
	            min: min,
	            max: max,
	            onChange: onChange,
	            focused: focused,
	            selected: value,
	            disabled: disabled
	          },
	          label
	        );
	      })
	    );
	  }
	});
	
	
	function getCenturyDecades(_date) {
	  var days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
	      date = _dates2.default.add(_dates2.default.startOf(_date, 'century'), -20, 'year');
	
	  return days.map(function () {
	    return date = _dates2.default.add(date, 10, 'year');
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _desc, _value, _obj;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //pick, omit, has
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _activeElement = __webpack_require__(1911);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _compat = __webpack_require__(168);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _2 = __webpack_require__(93);
	
	var _3 = _interopRequireDefault(_2);
	
	var _dates = __webpack_require__(188);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _localizers = __webpack_require__(128);
	
	var _constants = __webpack_require__(539);
	
	var _Widget = __webpack_require__(877);
	
	var _Widget2 = _interopRequireDefault(_Widget);
	
	var _Popup = __webpack_require__(1900);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Calendar = __webpack_require__(876);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _TimeList = __webpack_require__(1903);
	
	var _TimeList2 = _interopRequireDefault(_TimeList);
	
	var _DateTimePickerInput = __webpack_require__(1892);
	
	var _DateTimePickerInput2 = _interopRequireDefault(_DateTimePickerInput);
	
	var _Button = __webpack_require__(536);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _propTypes3 = __webpack_require__(156);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _uncontrollable = __webpack_require__(221);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _interaction = __webpack_require__(302);
	
	var _widgetHelpers = __webpack_require__(189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var Calendar = _Calendar2.default.ControlledComponent;
	
	var viewEnum = Object.keys(_constants.calendarViews).map(function (k) {
	  return _constants.calendarViews[k];
	});
	
	var propTypes = _extends({}, Calendar.propTypes, {
	
	  //-- controlled props -----------
	  value: _propTypes2.default.instanceOf(Date),
	  onChange: _propTypes2.default.func,
	  open: _propTypes2.default.oneOf([false, _constants.datePopups.TIME, _constants.datePopups.CALENDAR]),
	  onToggle: _propTypes2.default.func,
	  currentDate: _propTypes2.default.instanceOf(Date),
	  onCurrentDateChange: _propTypes2.default.func,
	  //------------------------------------
	
	  onSelect: _propTypes2.default.func,
	
	  min: _propTypes2.default.instanceOf(Date),
	  max: _propTypes2.default.instanceOf(Date),
	
	  culture: _propTypes2.default.string,
	
	  format: _propTypes4.default.dateFormat,
	  timeFormat: _propTypes4.default.dateFormat,
	  editFormat: _propTypes4.default.dateFormat,
	
	  calendar: _propTypes2.default.bool,
	  time: _propTypes2.default.bool,
	
	  timeComponent: _propTypes4.default.elementType,
	
	  //popup
	  dropUp: _propTypes2.default.bool,
	  duration: _propTypes2.default.number,
	
	  placeholder: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	
	  initialView: _propTypes2.default.oneOf(viewEnum),
	  finalView: _propTypes2.default.oneOf(viewEnum),
	
	  autoFocus: _propTypes2.default.bool,
	  disabled: _propTypes4.default.disabled,
	  readOnly: _propTypes4.default.readOnly,
	
	  parse: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string, _propTypes2.default.func]),
	
	  'aria-labelledby': _propTypes2.default.string,
	  'aria-describedby': _propTypes2.default.string,
	
	  messages: _propTypes2.default.shape({
	    calendarButton: _propTypes2.default.string,
	    timeButton: _propTypes2.default.string
	  })
	});
	
	var DateTimePicker = (0, _createReactClass2.default)((_obj = {
	
	  displayName: 'DateTimePicker',
	
	  mixins: [__webpack_require__(537), __webpack_require__(300), __webpack_require__(1909), __webpack_require__(879), __webpack_require__(878)({
	    didHandle: function didHandle(focused) {
	      if (!focused) this.close();
	    }
	  }), __webpack_require__(216)('valueInput', function (key, id) {
	    var open = this.props.open,
	        current = this.ariaActiveDescendant(),
	        calIsActive = open === _constants.datePopups.CALENDAR && key === 'calendar',
	        timeIsActive = open === _constants.datePopups.TIME && key === 'timelist';
	
	
	    if (!current || timeIsActive || calIsActive) return id;
	  })],
	
	  propTypes: propTypes,
	
	  getInitialState: function getInitialState() {
	    return {
	      focused: false
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	
	    return {
	      value: null,
	      currentDate: new Date(),
	      min: new Date(1900, 0, 1),
	      max: new Date(2099, 11, 31),
	      calendar: true,
	      time: true,
	      open: false,
	
	      //calendar override
	      footer: true,
	
	      messages: {
	        calendarButton: 'Select Date',
	        timeButton: 'Select Time'
	      },
	
	      ariaActiveDescendantKey: 'dropdownlist'
	    };
	  },
	  renderInput: function renderInput(id, owns) {
	    var _props = this.props,
	        open = _props.open,
	        value = _props.value,
	        editFormat = _props.editFormat,
	        culture = _props.culture,
	        busy = _props.busy,
	        placeholder = _props.placeholder,
	        disabled = _props.disabled,
	        readOnly = _props.readOnly,
	        name = _props.name,
	        tabIndex = _props.tabIndex,
	        autoFocus = _props.autoFocus,
	        ariaLabelledby = _props['aria-labelledby'],
	        ariaDescribedby = _props['aria-describedby'];
	    var focused = this.state.focused;
	
	
	    return _react2.default.createElement(_DateTimePickerInput2.default, {
	      id: id,
	      ref: 'valueInput',
	      role: 'combobox',
	      name: name,
	      tabIndex: tabIndex,
	      autoFocus: autoFocus,
	      placeholder: placeholder,
	      disabled: disabled,
	      readOnly: readOnly,
	      value: value,
	      format: getFormat(this.props),
	      editFormat: editFormat,
	      editing: focused,
	      culture: culture,
	      parse: this._parse,
	      onChange: this.handleChange,
	      'aria-haspopup': true,
	      'aria-labelledby': ariaLabelledby,
	      'aria-describedby': ariaDescribedby,
	      'aria-expanded': !!open,
	      'aria-busy': !!busy,
	      'aria-owns': owns
	    });
	  },
	  renderButtons: function renderButtons(messages) {
	    var _props2 = this.props,
	        calendar = _props2.calendar,
	        time = _props2.time,
	        disabled = _props2.disabled,
	        readOnly = _props2.readOnly;
	
	
	    if (!calendar && !time) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'span',
	      { className: 'rw-select' },
	      calendar && _react2.default.createElement(_Button2.default, {
	        icon: 'calendar',
	        className: 'rw-btn-calendar',
	        label: messages.calendarButton,
	        disabled: !!(disabled || readOnly),
	        onClick: this._click.bind(null, _constants.datePopups.CALENDAR)
	      }),
	      time && _react2.default.createElement(_Button2.default, {
	        icon: 'clock-o',
	        className: 'rw-btn-time',
	        label: messages.timeButton,
	        disabled: !!(disabled || readOnly),
	        onClick: this._click.bind(null, _constants.datePopups.TIME)
	      })
	    );
	  },
	  renderCalendar: function renderCalendar(id, inputID) {
	    var _this = this;
	
	    var _props3 = this.props,
	        open = _props3.open,
	        value = _props3.value,
	        duration = _props3.duration,
	        dropUp = _props3.dropUp;
	
	
	    var calendarProps = _3.default.pickProps(this.props, Calendar);
	
	    return _react2.default.createElement(
	      _Popup2.default,
	      {
	        dropUp: dropUp,
	        duration: duration,
	        open: open === _constants.datePopups.CALENDAR,
	        className: 'rw-calendar-popup'
	      },
	      _react2.default.createElement(Calendar, _extends({}, calendarProps, {
	        ref: 'calPopup',
	        id: id,
	        tabIndex: '-1',
	        value: value,
	        autoFocus: false,
	        onChange: this.handleDateSelect
	        // #75: need to aggressively reclaim focus from the calendar otherwise
	        // disabled header/footer buttons will drop focus completely from the widget
	        , onNavigate: function onNavigate() {
	          return _this.focus();
	        },
	        currentDate: this.props.currentDate,
	        onCurrentDateChange: this.props.onCurrentDateChange,
	        'aria-hidden': !open,
	        'aria-live': 'polite',
	        'aria-labelledby': inputID,
	        ariaActiveDescendantKey: 'calendar'
	      }))
	    );
	  },
	  renderTimeList: function renderTimeList(id, inputID) {
	    var _this2 = this;
	
	    var _props4 = this.props,
	        open = _props4.open,
	        value = _props4.value,
	        duration = _props4.duration,
	        dropUp = _props4.dropUp,
	        calendar = _props4.calendar,
	        timeFormat = _props4.timeFormat,
	        timeComponent = _props4.timeComponent;
	
	
	    var timeListProps = _3.default.pickProps(this.props, _TimeList2.default);
	
	    return _react2.default.createElement(
	      _Popup2.default,
	      {
	        dropUp: dropUp,
	        duration: duration,
	        open: open === _constants.datePopups.TIME,
	        onOpening: function onOpening() {
	          return _this2.refs.timePopup.forceUpdate();
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_TimeList2.default, _extends({}, timeListProps, {
	          ref: 'timePopup',
	          id: id,
	          format: timeFormat,
	          value: dateOrNull(value),
	          onMove: this._scrollTo,
	          onSelect: this.handleTimeSelect,
	          preserveDate: !!calendar,
	          itemComponent: timeComponent,
	          'aria-labelledby': inputID,
	          'aria-live': open && 'polite',
	          'aria-hidden': !open,
	          ariaActiveDescendantKey: 'timelist'
	        }))
	      )
	    );
	  },
	  render: function render() {
	    var _props5 = this.props,
	        className = _props5.className,
	        calendar = _props5.calendar,
	        time = _props5.time,
	        open = _props5.open,
	        messages = _props5.messages,
	        disabled = _props5.disabled,
	        readOnly = _props5.readOnly,
	        dropUp = _props5.dropUp;
	    var focused = this.state.focused;
	
	
	    var inputID = (0, _widgetHelpers.instanceId)(this, '_input'),
	        timeListID = (0, _widgetHelpers.instanceId)(this, '_time_listbox'),
	        dateListID = (0, _widgetHelpers.instanceId)(this, '_cal'),
	        owns = '';
	
	    var elementProps = _3.default.omitOwnProps(this, Calendar, _TimeList2.default);
	
	    var shouldRenderList = open || (0, _widgetHelpers.isFirstFocusedRender)(this);
	
	    if (calendar) owns += dateListID;
	    if (time) owns += ' ' + timeListID;
	
	    return _react2.default.createElement(
	      _Widget2.default,
	      _extends({}, elementProps, {
	        open: !!open,
	        dropUp: dropUp,
	        focused: focused,
	        disabled: disabled,
	        readOnly: readOnly,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        onKeyPress: this.handleKeyPress,
	        className: (0, _classnames2.default)(className, 'rw-datetimepicker', calendar && time && 'rw-has-both', !calendar && !time && 'rw-has-neither')
	      }),
	      this.renderInput(inputID, owns.trim()),
	      this.renderButtons(messages),
	      shouldRenderList && this.renderTimeList(timeListID, inputID),
	      shouldRenderList && this.renderCalendar(dateListID, inputID)
	    );
	  },
	  handleChange: function handleChange(date, str, constrain) {
	    var _props6 = this.props,
	        onChange = _props6.onChange,
	        value = _props6.value;
	
	
	    if (constrain) date = this.inRangeValue(date);
	
	    if (onChange) {
	      if (date == null || value == null) {
	        if (date != value) //eslint-disable-line eqeqeq
	          onChange(date, str);
	      } else if (!_dates2.default.eq(date, value)) {
	        onChange(date, str);
	      }
	    }
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    var _props7 = this.props,
	        open = _props7.open,
	        calendar = _props7.calendar,
	        time = _props7.time;
	
	
	    (0, _widgetHelpers.notify)(this.props.onKeyDown, [e]);
	
	    if (e.defaultPrevented) return;
	
	    if (e.key === 'Escape' && open) this.close();else if (e.altKey) {
	      e.preventDefault();
	
	      if (e.key === 'ArrowDown') {
	        if (calendar && time) this.open(open === _constants.datePopups.CALENDAR ? _constants.datePopups.TIME : _constants.datePopups.CALENDAR);else if (time) this.open(_constants.datePopups.TIME);else if (calendar) this.open(_constants.datePopups.CALENDAR);
	      } else if (e.key === 'ArrowUp') this.close();
	    } else if (open) {
	      if (open === _constants.datePopups.CALENDAR) this.refs.calPopup.handleKeyDown(e);
	      if (open === _constants.datePopups.TIME) this.refs.timePopup.handleKeyDown(e);
	    }
	  },
	  handleKeyPress: function handleKeyPress(e) {
	    (0, _widgetHelpers.notify)(this.props.onKeyPress, [e]);
	
	    if (e.defaultPrevented) return;
	
	    if (this.props.open === _constants.datePopups.TIME) this.refs.timePopup.handleKeyPress(e);
	  },
	  focus: function focus() {
	    var valueInput = this.refs.valueInput;
	
	
	    if (valueInput && (0, _activeElement2.default)() !== _compat2.default.findDOMNode(valueInput)) valueInput.focus();
	  },
	  handleDateSelect: function handleDateSelect(date) {
	    var format = getFormat(this.props),
	        dateTime = _dates2.default.merge(date, this.props.value, this.props.currentDate),
	        dateStr = formatDate(date, format, this.props.culture);
	
	    this.close();
	    (0, _widgetHelpers.notify)(this.props.onSelect, [dateTime, dateStr]);
	    this.handleChange(dateTime, dateStr, true);
	    this.focus();
	  },
	  handleTimeSelect: function handleTimeSelect(datum) {
	    var format = getFormat(this.props),
	        dateTime = _dates2.default.merge(this.props.value, datum.date, this.props.currentDate),
	        dateStr = formatDate(datum.date, format, this.props.culture);
	
	    this.close();
	    (0, _widgetHelpers.notify)(this.props.onSelect, [dateTime, dateStr]);
	    this.handleChange(dateTime, dateStr, true);
	    this.focus();
	  },
	  _click: function _click(view, e) {
	    this.focus();
	    this.toggle(view, e);
	  },
	  _parse: function _parse(string) {
	    var format = getFormat(this.props, true),
	        editFormat = this.props.editFormat,
	        parse = this.props.parse,
	        formats = [];
	
	    if (typeof parse === 'function') return parse(string, this.props.culture);
	
	    if (typeof format === 'string') formats.push(format);
	
	    if (typeof editFormat === 'string') formats.push(editFormat);
	
	    if (parse) formats = formats.concat(this.props.parse);
	
	    (0, _invariant2.default)(formats.length, 'React Widgets: there are no specified `parse` formats provided and the `format` prop is a function. ' + 'the DateTimePicker is unable to parse `%s` into a dateTime, ' + 'please provide either a parse function or Globalize.js compatible string for `format`', string);
	
	    return formatsParser(formats, this.props.culture, string);
	  },
	  toggle: function toggle(view) {
	    this.props.open ? this.props.open !== view ? this.open(view) : this.close(view) : this.open(view);
	  },
	  open: function open(view) {
	    if (this.props.open !== view && this.props[view] === true) (0, _widgetHelpers.notify)(this.props.onToggle, view);
	  },
	  close: function close() {
	    if (this.props.open) (0, _widgetHelpers.notify)(this.props.onToggle, false);
	  },
	  inRangeValue: function inRangeValue(value) {
	    if (value == null) return value;
	
	    return _dates2.default.max(_dates2.default.min(value, this.props.max), this.props.min);
	  }
	}, (_applyDecoratedDescriptor(_obj, 'handleChange', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleChange'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyDown', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyDown'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyPress', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyPress'), _obj), _applyDecoratedDescriptor(_obj, 'handleDateSelect', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleDateSelect'), _obj), _applyDecoratedDescriptor(_obj, 'handleTimeSelect', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleTimeSelect'), _obj), _applyDecoratedDescriptor(_obj, '_click', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, '_click'), _obj)), _obj));
	
	exports.default = (0, _uncontrollable2.default)(DateTimePicker, {
	  open: 'onToggle',
	  value: 'onChange',
	  currentDate: 'onCurrentDateChange'
	}, ['focus']);
	
	
	function getFormat(props) {
	  var cal = props[_constants.datePopups.CALENDAR] != null ? props.calendar : true,
	      time = props[_constants.datePopups.TIME] != null ? props.time : true;
	
	  return props.format ? props.format : cal && time || !cal && !time ? _localizers.date.getFormat('default') : _localizers.date.getFormat(cal ? 'date' : 'time');
	}
	
	function formatDate(date, format, culture) {
	  var val = '';
	
	  if (date instanceof Date && !isNaN(date.getTime())) val = _localizers.date.format(date, format, culture);
	
	  return val;
	}
	
	function formatsParser(formats, culture, str) {
	  var date;
	
	  for (var i = 0; i < formats.length; i++) {
	    date = _localizers.date.parse(str, formats[i], culture);
	    if (date) return date;
	  }
	  return null;
	}
	
	function dateOrNull(dt) {
	  if (dt && !isNaN(dt.getTime())) return dt;
	  return null;
	}
	module.exports = exports['default'];

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _2 = __webpack_require__(93);
	
	var _3 = _interopRequireDefault(_2);
	
	var _Input = __webpack_require__(1896);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _compat = __webpack_require__(168);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _localizers = __webpack_require__(128);
	
	var _propTypes3 = __webpack_require__(156);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createReactClass2.default)({
	
	  displayName: 'DateTimePickerInput',
	
	  propTypes: {
	    format: _propTypes4.default.dateFormat.isRequired,
	    editing: _propTypes2.default.bool,
	    editFormat: _propTypes4.default.dateFormat,
	    parse: _propTypes2.default.func.isRequired,
	
	    value: _propTypes2.default.instanceOf(Date),
	    onChange: _propTypes2.default.func.isRequired,
	    culture: _propTypes2.default.string
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var value = nextProps.value,
	        editing = nextProps.editing,
	        editFormat = nextProps.editFormat,
	        format = nextProps.format,
	        culture = nextProps.culture;
	
	
	    this.setState({
	      textValue: formatDate(value, editing && editFormat ? editFormat : format, culture)
	    });
	  },
	  getInitialState: function getInitialState() {
	    var _props = this.props,
	        value = _props.value,
	        editing = _props.editing,
	        editFormat = _props.editFormat,
	        format = _props.format,
	        culture = _props.culture;
	
	
	    return {
	      textValue: formatDate(value, editing && editFormat ? editFormat : format, culture)
	    };
	  },
	  render: function render() {
	    var _props2 = this.props,
	        disabled = _props2.disabled,
	        readOnly = _props2.readOnly;
	    var textValue = this.state.textValue;
	
	
	    var props = _3.default.omitOwnProps(this);
	
	    return _react2.default.createElement(_Input2.default, _extends({}, props, {
	      type: 'text',
	      value: textValue,
	      disabled: disabled,
	      readOnly: readOnly,
	      onChange: this.handleChange,
	      onBlur: this.handleBlur
	    }));
	  },
	  handleChange: function handleChange(_ref) {
	    var value = _ref.target.value;
	
	    this._needsFlush = true;
	    this.setState({ textValue: value });
	  },
	  handleBlur: function handleBlur(event) {
	    var _props3 = this.props,
	        format = _props3.format,
	        culture = _props3.culture,
	        parse = _props3.parse,
	        onChange = _props3.onChange,
	        onBlur = _props3.onBlur;
	
	
	    onBlur && onBlur(event);
	
	    if (this._needsFlush) {
	      var date = parse(event.target.value);
	
	      this._needsFlush = false;
	      onChange(date, formatDate(date, format, culture));
	    }
	  },
	  focus: function focus() {
	    _compat2.default.findDOMNode(this).focus();
	  }
	});
	
	
	function isValid(d) {
	  return !isNaN(d.getTime());
	}
	
	function formatDate(date, format, culture) {
	  var val = '';
	
	  if (date instanceof Date && isValid(date)) val = _localizers.date.format(date, format, culture);
	
	  return val;
	}
	module.exports = exports['default'];

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _CalendarView = __webpack_require__(384);
	
	var _CalendarView2 = _interopRequireDefault(_CalendarView);
	
	var _dates = __webpack_require__(188);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _localizers = __webpack_require__(128);
	
	var _2 = __webpack_require__(93);
	
	var _3 = _interopRequireDefault(_2);
	
	var _propTypes3 = __webpack_require__(156);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _widgetHelpers = __webpack_require__(189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  culture: _propTypes2.default.string,
	  today: _propTypes2.default.instanceOf(Date),
	  value: _propTypes2.default.instanceOf(Date),
	  focused: _propTypes2.default.instanceOf(Date),
	  min: _propTypes2.default.instanceOf(Date),
	  max: _propTypes2.default.instanceOf(Date),
	  onChange: _propTypes2.default.func.isRequired,
	
	  yearFormat: _propTypes4.default.dateFormat
	};
	
	var optionId = function optionId(id, date) {
	  return id + '__decade_' + _dates2.default.year(date);
	};
	
	exports.default = (0, _createReactClass2.default)({
	
	  displayName: 'DecadeView',
	
	  mixins: [__webpack_require__(300), __webpack_require__(301), __webpack_require__(216)()],
	
	  propTypes: propTypes,
	
	  componentDidUpdate: function componentDidUpdate() {
	    var activeId = optionId((0, _widgetHelpers.instanceId)(this), this.props.focused);
	    this.ariaActiveDescendant(activeId);
	  },
	  render: function render() {
	    var focused = this.props.focused;
	
	
	    return _react2.default.createElement(
	      _CalendarView2.default,
	      _3.default.omitOwnProps(this),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _3.default.chunk(getDecadeYears(focused), 4).map(this.renderRow)
	      )
	    );
	  },
	  renderRow: function renderRow(row, rowIdx) {
	    var _props = this.props,
	        focused = _props.focused,
	        disabled = _props.disabled,
	        onChange = _props.onChange,
	        yearFormat = _props.yearFormat,
	        value = _props.value,
	        today = _props.today,
	        culture = _props.culture,
	        min = _props.min,
	        max = _props.max;
	
	
	    var id = (0, _widgetHelpers.instanceId)(this);
	
	    return _react2.default.createElement(
	      _CalendarView2.default.Row,
	      { key: rowIdx },
	      row.map(function (date, colIdx) {
	        var label = _localizers.date.format(date, _localizers.date.getFormat('year', yearFormat), culture);
	
	        return _react2.default.createElement(
	          _CalendarView2.default.Cell,
	          {
	            key: colIdx,
	            unit: 'year',
	            id: optionId(id, date),
	            label: label,
	            date: date,
	            now: today,
	            min: min,
	            max: max,
	            onChange: onChange,
	            focused: focused,
	            selected: value,
	            disabled: disabled
	          },
	          label
	        );
	      })
	    );
	  }
	});
	
	
	function getDecadeYears(_date) {
	  var days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
	      date = _dates2.default.add(_dates2.default.startOf(_date, 'decade'), -2, 'year');
	
	  return days.map(function () {
	    return date = _dates2.default.add(date, 1, 'year');
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Button = __webpack_require__(536);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _localizers = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var format = function format(props) {
	  return _localizers.date.getFormat('footer', props.format);
	};
	
	module.exports = (0, _createReactClass2.default)({
	
	  displayName: 'Footer',
	
	  render: function render() {
	    var _props = this.props,
	        disabled = _props.disabled,
	        readOnly = _props.readOnly,
	        value = _props.value;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'rw-footer' },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          disabled: !!(disabled || readOnly),
	          onClick: this.props.onClick.bind(null, value)
	        },
	        _localizers.date.format(value, format(this.props), this.props.culture)
	      )
	    );
	  }
	});

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Button = __webpack_require__(536);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createReactClass2.default)({
	  displayName: 'Header',
	  propTypes: {
	    label: _propTypes2.default.string.isRequired,
	    labelId: _propTypes2.default.string,
	
	    upDisabled: _propTypes2.default.bool.isRequired,
	    prevDisabled: _propTypes2.default.bool.isRequired,
	    nextDisabled: _propTypes2.default.bool.isRequired,
	    onViewChange: _propTypes2.default.func.isRequired,
	    onMoveLeft: _propTypes2.default.func.isRequired,
	    onMoveRight: _propTypes2.default.func.isRequired,
	
	    messages: _propTypes2.default.shape({
	      moveBack: _propTypes2.default.string,
	      moveForward: _propTypes2.default.string
	    })
	  },
	
	  mixins: [__webpack_require__(300), __webpack_require__(301)],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      messages: {
	        moveBack: 'navigate back',
	        moveForward: 'navigate forward'
	      }
	    };
	  },
	  render: function render() {
	    var _props = this.props,
	        messages = _props.messages,
	        label = _props.label,
	        labelId = _props.labelId,
	        onMoveRight = _props.onMoveRight,
	        onMoveLeft = _props.onMoveLeft,
	        onViewChange = _props.onViewChange,
	        prevDisabled = _props.prevDisabled,
	        upDisabled = _props.upDisabled,
	        nextDisabled = _props.nextDisabled;
	
	
	    var rtl = this.isRtl();
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'rw-header' },
	      _react2.default.createElement(_Button2.default, {
	        className: 'rw-btn-left',
	        onClick: onMoveLeft,
	        disabled: prevDisabled,
	        label: messages.moveBack,
	        icon: 'caret-' + (rtl ? 'right' : 'left')
	      }),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          id: labelId,
	          onClick: onViewChange,
	          className: 'rw-btn-view',
	          disabled: upDisabled,
	          'aria-live': 'polite',
	          'aria-atomic': 'true'
	        },
	        label
	      ),
	      _react2.default.createElement(_Button2.default, {
	        className: 'rw-btn-right',
	        onClick: onMoveRight,
	        disabled: nextDisabled,
	        label: messages.moveForward,
	        icon: 'caret-' + (rtl ? 'left' : 'right')
	      })
	    );
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Input = function (_React$Component) {
	  _inherits(Input, _React$Component);
	
	  function Input() {
	    _classCallCheck(this, Input);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Input.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        disabled = _props.disabled,
	        readOnly = _props.readOnly,
	        value = _props.value,
	        tabIndex = _props.tabIndex,
	        _props$component = _props.component,
	        Component = _props$component === undefined ? 'input' : _props$component,
	        props = _objectWithoutProperties(_props, ['className', 'disabled', 'readOnly', 'value', 'tabIndex', 'component']);
	
	    return _react2.default.createElement(Component, _extends({}, props, {
	      type: 'text',
	      tabIndex: tabIndex || 0,
	      autoComplete: 'off',
	      disabled: disabled,
	      readOnly: readOnly,
	      'aria-disabled': disabled,
	      'aria-readonly': readOnly,
	      value: value == null ? '' : value,
	      className: (0, _classnames2.default)(className, 'rw-input')
	    }));
	  };
	
	  return Input;
	}(_react2.default.Component);
	
	exports.default = Input;
	module.exports = exports['default'];

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _ListOption = __webpack_require__(1898);
	
	var _ListOption2 = _interopRequireDefault(_ListOption);
	
	var _propTypes3 = __webpack_require__(156);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _compat = __webpack_require__(168);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _2 = __webpack_require__(93);
	
	var _3 = _interopRequireDefault(_2);
	
	var _dataHelpers = __webpack_require__(540);
	
	var _widgetHelpers = __webpack_require__(189);
	
	var _interaction = __webpack_require__(302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var optionId = function optionId(id, idx) {
	  return id + '__option__' + idx;
	};
	
	exports.default = (0, _createReactClass2.default)({
	
	  displayName: 'List',
	
	  mixins: [__webpack_require__(1908), __webpack_require__(216)()],
	
	  propTypes: {
	    data: _propTypes2.default.array,
	    onSelect: _propTypes2.default.func,
	    onMove: _propTypes2.default.func,
	
	    optionComponent: _propTypes4.default.elementType,
	    itemComponent: _propTypes4.default.elementType,
	
	    selected: _propTypes2.default.any,
	    focused: _propTypes2.default.any,
	    valueField: _propTypes4.default.accessor,
	    textField: _propTypes4.default.accessor,
	
	    disabled: _propTypes4.default.disabled.acceptsArray,
	    readOnly: _propTypes4.default.readOnly.acceptsArray,
	
	    messages: _propTypes2.default.shape({
	      emptyList: _propTypes4.default.message
	    })
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onSelect: function onSelect() {},
	      optionComponent: _ListOption2.default,
	      ariaActiveDescendantKey: 'list',
	      data: [],
	      messages: {
	        emptyList: 'There are no items in this list'
	      }
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.move();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    var _props = this.props,
	        data = _props.data,
	        focused = _props.focused,
	        idx = data.indexOf(focused),
	        activeId = optionId((0, _widgetHelpers.instanceId)(this), idx);
	
	
	    this.ariaActiveDescendant(idx !== -1 ? activeId : null);
	
	    this.move();
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props,
	        className = _props2.className,
	        role = _props2.role,
	        data = _props2.data,
	        textField = _props2.textField,
	        valueField = _props2.valueField,
	        focused = _props2.focused,
	        selected = _props2.selected,
	        messages = _props2.messages,
	        onSelect = _props2.onSelect,
	        ItemComponent = _props2.itemComponent,
	        Option = _props2.optionComponent;
	
	
	    var id = (0, _widgetHelpers.instanceId)(this),
	        items = void 0;
	
	    var elementProps = _3.default.omitOwnProps(this);
	
	    items = !data.length ? _react2.default.createElement(
	      'li',
	      { className: 'rw-list-empty' },
	      _3.default.result(messages.emptyList, this.props)
	    ) : data.map(function (item, idx) {
	      var currentId = optionId(id, idx),
	          isDisabled = (0, _interaction.isDisabledItem)(item, _this.props),
	          isReadOnly = (0, _interaction.isReadOnlyItem)(item, _this.props);
	
	      return _react2.default.createElement(
	        Option,
	        {
	          key: 'item_' + idx,
	          id: currentId,
	          dataItem: item,
	          disabled: isDisabled,
	          readOnly: isReadOnly,
	          focused: focused === item,
	          selected: selected === item,
	          onClick: isDisabled || isReadOnly ? undefined : onSelect.bind(null, item)
	        },
	        ItemComponent ? _react2.default.createElement(ItemComponent, {
	          item: item,
	          value: (0, _dataHelpers.dataValue)(item, valueField),
	          text: (0, _dataHelpers.dataText)(item, textField),
	          disabled: isDisabled,
	          readOnly: isReadOnly
	        }) : (0, _dataHelpers.dataText)(item, textField)
	      );
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      _extends({
	        id: id,
	        tabIndex: '-1',
	        className: (0, _classnames2.default)(className, 'rw-list'),
	        role: role === undefined ? 'listbox' : role
	      }, elementProps),
	      items
	    );
	  },
	  _data: function _data() {
	    return this.props.data;
	  },
	  move: function move() {
	    var list = _compat2.default.findDOMNode(this),
	        idx = this._data().indexOf(this.props.focused),
	        selected = list.children[idx];
	
	    if (!selected) return;
	
	    (0, _widgetHelpers.notify)(this.props.onMove, [selected, list, this.props.focused]);
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _2 = __webpack_require__(93);
	
	var _3 = _interopRequireDefault(_2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListOption = (0, _createReactClass2.default)({
	  displayName: 'ListOption',
	
	  propTypes: {
	    dataItem: _propTypes2.default.any,
	    focused: _propTypes2.default.bool,
	    selected: _propTypes2.default.bool,
	    disabled: _propTypes2.default.bool,
	    readOnly: _propTypes2.default.bool
	  },
	
	  render: function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        focused = _props.focused,
	        selected = _props.selected,
	        disabled = _props.disabled,
	        readOnly = _props.readOnly;
	
	
	    var props = _3.default.omitOwnProps(this);
	
	    var classes = {
	      'rw-state-focus': focused,
	      'rw-state-selected': selected,
	      'rw-state-disabled': disabled,
	      'rw-state-readonly': readOnly
	    };
	
	    return _react2.default.createElement(
	      'li',
	      _extends({
	        role: 'option',
	        tabIndex: !(disabled || readOnly) ? '-1' : undefined,
	        'aria-selected': !!selected,
	        className: (0, _classnames2.default)('rw-list-option', className, classes)
	      }, props),
	      children
	    );
	  }
	});
	
	exports.default = ListOption;
	module.exports = exports['default'];

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _CalendarView = __webpack_require__(384);
	
	var _CalendarView2 = _interopRequireDefault(_CalendarView);
	
	var _dates = __webpack_require__(188);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _localizers = __webpack_require__(128);
	
	var _propTypes3 = __webpack_require__(156);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _2 = __webpack_require__(93);
	
	var _3 = _interopRequireDefault(_2);
	
	var _widgetHelpers = __webpack_require__(189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dayFormat = function dayFormat(props) {
	  return _localizers.date.getFormat('weekday', props.dayFormat);
	},
	    dateFormat = function dateFormat(props) {
	  return _localizers.date.getFormat('dayOfMonth', props.dateFormat);
	};
	
	var optionId = function optionId(id, date) {
	  return id + '__month_' + _dates2.default.month(date) + '-' + _dates2.default.date(date);
	};
	
	var propTypes = {
	  culture: _propTypes2.default.string,
	  today: _propTypes2.default.instanceOf(Date),
	  value: _propTypes2.default.instanceOf(Date),
	  focused: _propTypes2.default.instanceOf(Date),
	  min: _propTypes2.default.instanceOf(Date),
	  max: _propTypes2.default.instanceOf(Date),
	  onChange: _propTypes2.default.func.isRequired,
	
	  dayComponent: _propTypes4.default.elementType,
	  dayFormat: _propTypes4.default.dateFormat,
	  dateFormat: _propTypes4.default.dateFormat
	};
	
	var isEqual = function isEqual(dateA, dateB) {
	  return _dates2.default.eq(dateA, dateB, 'day');
	};
	
	var MonthView = (0, _createReactClass2.default)({
	
	  displayName: 'MonthView',
	
	  statics: {
	    isEqual: isEqual
	  },
	
	  mixins: [__webpack_require__(301), __webpack_require__(216)()],
	
	  propTypes: propTypes,
	
	  componentDidUpdate: function componentDidUpdate() {
	    var activeId = optionId((0, _widgetHelpers.instanceId)(this), this.props.focused);
	    this.ariaActiveDescendant(activeId, null);
	  },
	  render: function render() {
	    var _props = this.props,
	        focused = _props.focused,
	        culture = _props.culture,
	        month = _dates2.default.visibleDays(focused, culture),
	        rows = _3.default.chunk(month, 7);
	
	    return _react2.default.createElement(
	      _CalendarView2.default,
	      _3.default.omitOwnProps(this),
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          this.renderHeaders(rows[0], dayFormat(this.props), culture)
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        rows.map(this.renderRow)
	      )
	    );
	  },
	  renderRow: function renderRow(row, rowIdx) {
	    var _this = this;
	
	    var _props2 = this.props,
	        focused = _props2.focused,
	        today = _props2.today,
	        disabled = _props2.disabled,
	        onChange = _props2.onChange,
	        value = _props2.value,
	        culture = _props2.culture,
	        min = _props2.min,
	        max = _props2.max,
	        Day = _props2.dayComponent,
	        id = (0, _widgetHelpers.instanceId)(this),
	        labelFormat = _localizers.date.getFormat('footer');
	
	    return _react2.default.createElement(
	      _CalendarView2.default.Row,
	      { key: rowIdx },
	      row.map(function (date, colIdx) {
	        var formattedDate = _localizers.date.format(date, dateFormat(_this.props), culture),
	            label = _localizers.date.format(date, labelFormat, culture);
	
	        return _react2.default.createElement(
	          _CalendarView2.default.Cell,
	          {
	            key: colIdx,
	            id: optionId(id, date),
	            label: label,
	            date: date,
	            now: today,
	            min: min,
	            max: max,
	            unit: 'day',
	            viewUnit: 'month',
	            onChange: onChange,
	            focused: focused,
	            selected: value,
	            disabled: disabled
	          },
	          Day ? _react2.default.createElement(Day, { date: date, label: formattedDate }) : formattedDate
	        );
	      })
	    );
	  },
	  renderHeaders: function renderHeaders(week, format, culture) {
	    return week.map(function (date) {
	      return _react2.default.createElement(
	        'th',
	        { key: 'header_' + _dates2.default.weekday(date, undefined, _localizers.date.startOfWeek(culture)) },
	        _localizers.date.format(date, format, culture)
	      );
	    });
	  }
	});
	
	exports.default = MonthView;
	module.exports = exports['default'];

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _OVERFLOW;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _2 = __webpack_require__(93);
	
	var _3 = _interopRequireDefault(_2);
	
	var _style = __webpack_require__(304);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _height = __webpack_require__(385);
	
	var _height2 = _interopRequireDefault(_height);
	
	var _camelizeStyle = __webpack_require__(542);
	
	var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);
	
	var _configuration = __webpack_require__(538);
	
	var _configuration2 = _interopRequireDefault(_configuration);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _compat = __webpack_require__(168);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transform = (0, _camelizeStyle2.default)(_configuration2.default.animate.transform);
	
	var CLOSING = 0,
	    CLOSED = 1,
	    OPENING = 2,
	    OPEN = 3;
	
	function properties(prop, value) {
	  var _ref, _ref2;
	
	  var TRANSLATION_MAP = _configuration2.default.animate.TRANSLATION_MAP;
	
	  if (TRANSLATION_MAP && TRANSLATION_MAP[prop]) return _ref = {}, _ref[transform] = TRANSLATION_MAP[prop] + '(' + value + ')', _ref;
	
	  return _ref2 = {}, _ref2[prop] = value, _ref2;
	}
	
	var OVERFLOW = (_OVERFLOW = {}, _OVERFLOW[CLOSED] = 'hidden', _OVERFLOW[CLOSING] = 'hidden', _OVERFLOW[OPENING] = 'hidden', _OVERFLOW);
	
	var propTypes = {
	  open: _propTypes2.default.bool,
	  dropUp: _propTypes2.default.bool,
	  duration: _propTypes2.default.number,
	
	  onClosing: _propTypes2.default.func,
	  onOpening: _propTypes2.default.func,
	  onClose: _propTypes2.default.func,
	  onOpen: _propTypes2.default.func
	};
	
	exports.default = (0, _createReactClass2.default)({
	
	  displayName: 'Popup',
	
	  propTypes: propTypes,
	
	  getInitialState: function getInitialState() {
	    return {
	      initialRender: true,
	      status: this.props.open ? OPENING : CLOSED
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      duration: 200,
	      open: false,
	      onClosing: function onClosing() {},
	      onOpening: function onOpening() {},
	      onClose: function onClose() {},
	      onOpen: function onOpen() {}
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setState({
	      contentChanged: childKey(nextProps.children) !== childKey(this.props.children)
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var isOpen = this.state.status === OPENING;
	
	    _compat2.default.batchedUpdates(function () {
	      _this.setState({ initialRender: false });
	      if (isOpen) {
	        _this.open();
	      }
	    });
	  },
	  componentDidUpdate: function componentDidUpdate(pvProps) {
	    var closing = pvProps.open && !this.props.open,
	        opening = !pvProps.open && this.props.open,
	        open = this.props.open,
	        status = this.state.status;
	
	    if (!!pvProps.dropUp !== !!this.props.dropUp) {
	      this.cancelNextCallback();
	      if (status === OPENING) this.open();
	      if (status === CLOSING) this.close();
	      return;
	    }
	
	    if (opening) this.open();else if (closing) this.close();else if (open) {
	      // this.height() returns a floating point number with the desired height
	      // for this popup. Because of potential rounding errors in floating point
	      // aritmetic we must allow an error margin when comparing to the current
	      // state, otherwise we can end up in an infinite loop where the height
	      // is never exactly equal to our target value.
	      var height = this.height(),
	          diff = Math.abs(height - this.state.height);
	      if (isNaN(diff) || diff > 0.1) this.setState({ height: height });
	    }
	  },
	  render: function render() {
	    var _props = this.props,
	        className = _props.className,
	        dropUp = _props.dropUp,
	        style = _props.style,
	        _state = this.state,
	        status = _state.status,
	        height = _state.height;
	
	
	    var overflow = OVERFLOW[status] || 'visible',
	        display = status === CLOSED ? 'none' : 'block';
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: _extends({
	          display: display,
	          overflow: overflow,
	          height: height
	        }, style),
	        className: (0, _classnames2.default)(className, 'rw-popup-container', dropUp && 'rw-dropup', this.isTransitioning() && 'rw-popup-animating')
	      },
	      this.renderChildren()
	    );
	  },
	  renderChildren: function renderChildren() {
	    if (!this.props.children) return _react2.default.createElement('span', { className: 'rw-popup rw-widget' });
	
	    var offset = this.getOffsetForStatus(this.state.status),
	        child = _react2.default.Children.only(this.props.children);
	
	    return (0, _react.cloneElement)(child, {
	      style: _extends({}, child.props.style, offset, {
	        position: this.isTransitioning() ? 'absolute' : undefined
	      }),
	      className: (0, _classnames2.default)(child.props.className, 'rw-popup rw-widget')
	    });
	  },
	  open: function open() {
	    var _this2 = this;
	
	    this.cancelNextCallback();
	    var el = _compat2.default.findDOMNode(this).firstChild,
	        height = this.height();
	
	    this.props.onOpening();
	
	    this.safeSetState({ status: OPENING, height: height }, function () {
	      var offset = _this2.getOffsetForStatus(OPEN),
	          duration = _this2.props.duration;
	
	      _this2.animate(el, offset, duration, 'ease', function () {
	        _this2.safeSetState({ status: OPEN }, function () {
	          _this2.props.onOpen();
	        });
	      });
	    });
	  },
	  close: function close() {
	    var _this3 = this;
	
	    this.cancelNextCallback();
	    var el = _compat2.default.findDOMNode(this).firstChild,
	        height = this.height();
	
	    this.props.onClosing();
	
	    this.safeSetState({ status: CLOSING, height: height }, function () {
	      var offset = _this3.getOffsetForStatus(CLOSED),
	          duration = _this3.props.duration;
	
	      _this3.animate(el, offset, duration, 'ease', function () {
	        return _this3.safeSetState({ status: CLOSED }, function () {
	          _this3.props.onClose();
	        });
	      });
	    });
	  },
	  getOffsetForStatus: function getOffsetForStatus(status) {
	    var _CLOSED$CLOSING$OPENI;
	
	    if (this.state.initialRender) return {};
	
	    var _in = properties('top', this.props.dropUp ? '100%' : '-100%'),
	        out = properties('top', 0);
	    return (_CLOSED$CLOSING$OPENI = {}, _CLOSED$CLOSING$OPENI[CLOSED] = _in, _CLOSED$CLOSING$OPENI[CLOSING] = out, _CLOSED$CLOSING$OPENI[OPENING] = _in, _CLOSED$CLOSING$OPENI[OPEN] = out, _CLOSED$CLOSING$OPENI)[status] || {};
	  },
	  height: function height() {
	    var container = _compat2.default.findDOMNode(this),
	        content = container.firstChild,
	        margin = parseInt((0, _style2.default)(content, 'margin-top'), 10) + parseInt((0, _style2.default)(content, 'margin-bottom'), 10);
	
	    var old = container.style.display,
	        height = void 0;
	
	    container.style.display = 'block';
	    height = ((0, _height2.default)(content) || 0) + (isNaN(margin) ? 0 : margin);
	    container.style.display = old;
	    return height;
	  },
	  isTransitioning: function isTransitioning() {
	    return this.state.status === OPENING || this.state.status === CLOSED;
	  },
	  animate: function animate(el, props, dur, easing, cb) {
	    this._transition = _configuration2.default.animate(el, props, dur, easing, this.setNextCallback(cb));
	  },
	  cancelNextCallback: function cancelNextCallback() {
	    if (this._transition && this._transition.cancel) {
	      this._transition.cancel();
	      this._transition = null;
	    }
	    if (this.nextCallback) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  },
	  safeSetState: function safeSetState(nextState, callback) {
	    this.setState(nextState, this.setNextCallback(callback));
	  },
	  setNextCallback: function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      return active = false;
	    };
	    return this.nextCallback;
	  }
	});
	
	
	function childKey(children) {
	  var nextChildMapping = _react2.default.Children.map(children, function (c) {
	    return c;
	  });
	  for (var key in nextChildMapping) {
	    return key;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _style = __webpack_require__(304);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _height = __webpack_require__(385);
	
	var _height2 = _interopRequireDefault(_height);
	
	var _width = __webpack_require__(882);
	
	var _width2 = _interopRequireDefault(_width);
	
	var _compat = __webpack_require__(168);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _2 = __webpack_require__(93);
	
	var _3 = _interopRequireDefault(_2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A streamlined version of TransitionGroup built for managing at most two active children
	 * also provides additional hooks for animation start/end
	 * https://github.com/facebook/react/blob/master/src/addons/transitions/ReactTransitionGroup.js
	 * relevent code is licensed accordingly
	 */
	function getChild(children) {
	  return _react2.default.Children.only(children);
	}
	
	function key(child) {
	  return child && child.key;
	}
	
	exports.default = (0, _createReactClass2.default)({
	
	  displayName: 'ReplaceTransitionGroup',
	
	  propTypes: {
	    component: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),
	    childFactory: _propTypes2.default.func,
	    onAnimating: _propTypes2.default.func,
	    onAnimate: _propTypes2.default.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      component: 'span',
	      childFactory: function childFactory(a) {
	        return a;
	      },
	      onAnimating: _3.default.noop,
	      onAnimate: _3.default.noop
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      children: _3.default.splat(this.props.children)
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var nextChild = getChild(nextProps.children),
	        stack = this.state.children.slice(),
	        next = stack[1],
	        last = stack[0];
	
	    var isLastChild = last && key(last) === key(nextChild),
	        isNextChild = next && key(next) === key(nextChild);
	
	    //no children
	    if (!last) {
	      stack.push(nextChild);
	      this.entering = nextChild;
	    } else if (last && !next && !isLastChild) {
	      //new child
	      stack.push(nextChild);
	      this.leaving = last;
	      this.entering = nextChild;
	    } else if (last && next && !isLastChild && !isNextChild) {
	      // the child is not the current one, exit the current one, add the new one
	      //  - shift the stack down
	      stack.shift();
	      stack.push(nextChild);
	      this.leaving = next;
	      this.entering = nextChild;
	    }
	    //new child that just needs to be re-rendered
	    else if (isLastChild) stack.splice(0, 1, nextChild);else if (isNextChild) stack.splice(1, 1, nextChild);
	
	    if (this.state.children[0] !== stack[0] || this.state.children[1] !== stack[1]) this.setState({ children: stack });
	  },
	  componentWillMount: function componentWillMount() {
	    this.animatingKeys = {};
	    this.leaving = null;
	    this.entering = null;
	  },
	  componentDidMount: function componentDidMount() {
	    this._mounted = true;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._mounted = false;
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    var entering = this.entering,
	        leaving = this.leaving,
	        first = this.refs[key(entering) || key(leaving)],
	        node = _compat2.default.findDOMNode(this),
	        el = first && _compat2.default.findDOMNode(first);
	
	    if (el) (0, _style2.default)(node, {
	      overflow: 'hidden',
	      height: (0, _height2.default)(el) + 'px',
	      width: (0, _width2.default)(el) + 'px'
	    });
	
	    this.props.onAnimating();
	
	    this.entering = null;
	    this.leaving = null;
	
	    if (entering) this.performEnter(key(entering));
	    if (leaving) this.performLeave(key(leaving));
	  },
	  performEnter: function performEnter(key) {
	    var component = this.refs[key];
	
	    if (!component) return;
	
	    this.animatingKeys[key] = true;
	
	    if (component.componentWillEnter) component.componentWillEnter(this._handleDoneEntering.bind(this, key));else this._handleDoneEntering(key);
	  },
	  _tryFinish: function _tryFinish() {
	
	    if (this.isTransitioning()) return;
	
	    if (this._mounted) (0, _style2.default)(_compat2.default.findDOMNode(this), { overflow: 'visible', height: '', width: '' });
	
	    this.props.onAnimate();
	  },
	  _handleDoneEntering: function _handleDoneEntering(enterkey) {
	    var component = this.refs[enterkey];
	
	    if (component && component.componentDidEnter) component.componentDidEnter();
	
	    delete this.animatingKeys[enterkey];
	
	    if (key(this.props.children) !== enterkey) this.performLeave(enterkey); // This was removed before it had fully entered. Remove it.
	
	    this._tryFinish();
	  },
	  performLeave: function performLeave(key) {
	    var component = this.refs[key];
	
	    if (!component) return;
	
	    this.animatingKeys[key] = true;
	
	    if (component.componentWillLeave) component.componentWillLeave(this._handleDoneLeaving.bind(this, key));else this._handleDoneLeaving(key);
	  },
	  _handleDoneLeaving: function _handleDoneLeaving(leavekey) {
	    var component = this.refs[leavekey];
	
	    if (component && component.componentDidLeave) component.componentDidLeave();
	
	    delete this.animatingKeys[leavekey];
	
	    if (key(this.props.children) === leavekey) this.performEnter(leavekey); // This entered again before it fully left. Add it again.
	
	    else if (this._mounted) this.setState({
	        children: this.state.children.filter(function (c) {
	          return key(c) !== leavekey;
	        })
	      });
	
	    this._tryFinish();
	  },
	  isTransitioning: function isTransitioning() {
	    return !!Object.keys(this.animatingKeys).length;
	  },
	  render: function render() {
	    var _this = this;
	
	    var Component = this.props.component;
	
	    return _react2.default.createElement(
	      Component,
	      _3.default.omitOwnProps(this),
	      this.state.children.map(function (c) {
	        return _this.props.childFactory(c, key(c));
	      })
	    );
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _ReplaceTransitionGroup = __webpack_require__(1901);
	
	var _ReplaceTransitionGroup2 = _interopRequireDefault(_ReplaceTransitionGroup);
	
	var _compat = __webpack_require__(168);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _style = __webpack_require__(304);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _width = __webpack_require__(882);
	
	var _width2 = _interopRequireDefault(_width);
	
	var _configuration = __webpack_require__(538);
	
	var _configuration2 = _interopRequireDefault(_configuration);
	
	var _2 = __webpack_require__(93);
	
	var _3 = _interopRequireDefault(_2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideChildGroup = (0, _createReactClass2.default)({
	  displayName: 'SlideChildGroup',
	
	
	  propTypes: {
	    direction: _propTypes2.default.oneOf(['left', 'right']),
	    duration: _propTypes2.default.number
	  },
	
	  componentWillEnter: function componentWillEnter(done) {
	    var _this = this;
	
	    var node = _compat2.default.findDOMNode(this),
	        width = (0, _width2.default)(node),
	        direction = this.props.direction;
	
	    width = direction === 'left' ? width : -width;
	
	    this.ORGINAL_POSITION = node.style.position;
	
	    (0, _style2.default)(node, { position: 'absolute', left: width + 'px', top: 0 });
	
	    _configuration2.default.animate(node, { left: 0 }, this.props.duration, function () {
	
	      (0, _style2.default)(node, {
	        position: _this.ORGINAL_POSITION,
	        overflow: 'hidden'
	      });
	
	      _this.ORGINAL_POSITION = null;
	      done && done();
	    });
	  },
	  componentWillLeave: function componentWillLeave(done) {
	    var _this2 = this;
	
	    var node = _compat2.default.findDOMNode(this),
	        width = (0, _width2.default)(node),
	        direction = this.props.direction;
	
	    width = direction === 'left' ? -width : width;
	
	    this.ORGINAL_POSITION = node.style.position;
	
	    (0, _style2.default)(node, { position: 'absolute', top: 0, left: 0 });
	
	    _configuration2.default.animate(node, { left: width + 'px' }, this.props.duration, function () {
	      (0, _style2.default)(node, {
	        position: _this2.ORGINAL_POSITION,
	        overflow: 'hidden'
	      });
	
	      _this2.ORGINAL_POSITION = null;
	      done && done();
	    });
	  },
	  render: function render() {
	    return _react2.default.Children.only(this.props.children);
	  }
	});
	
	module.exports = (0, _createReactClass2.default)({
	  displayName: 'exports',
	
	
	  propTypes: {
	    direction: _propTypes2.default.oneOf(['left', 'right']),
	    duration: _propTypes2.default.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      direction: 'left',
	      duration: 250
	    };
	  },
	  _wrapChild: function _wrapChild(child, ref) {
	    return _react2.default.createElement(
	      SlideChildGroup,
	      { key: child.key, ref: ref,
	        direction: this.props.direction,
	        duration: this.props.duration },
	      child
	    );
	  },
	  render: function render() {
	    var _props = this.props,
	        style = _props.style,
	        children = _props.children;
	
	
	    style = _extends({}, style, {
	      position: 'relative',
	      overflow: 'hidden'
	    });
	
	    return _react2.default.createElement(
	      _ReplaceTransitionGroup2.default,
	      _extends({}, _3.default.omitOwnProps(this), {
	        ref: 'container',
	        component: 'div',
	        childFactory: this._wrapChild,
	        style: style
	      }),
	      children
	    );
	  }
	});

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _dates2 = __webpack_require__(188);
	
	var _dates3 = _interopRequireDefault(_dates2);
	
	var _List = __webpack_require__(1897);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _localizers = __webpack_require__(128);
	
	var _propTypes3 = __webpack_require__(156);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _2 = __webpack_require__(93);
	
	var _3 = _interopRequireDefault(_2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var format = function format(props) {
	  return _localizers.date.getFormat('time', props.format);
	};
	
	exports.default = (0, _createReactClass2.default)({
	
	  displayName: 'TimeList',
	
	  propTypes: {
	    value: _propTypes2.default.instanceOf(Date),
	    step: _propTypes2.default.number,
	    min: _propTypes2.default.instanceOf(Date),
	    max: _propTypes2.default.instanceOf(Date),
	    currentDate: _propTypes2.default.instanceOf(Date),
	
	    itemComponent: _propTypes4.default.elementType,
	    format: _propTypes4.default.dateFormat,
	    onSelect: _propTypes2.default.func,
	    preserveDate: _propTypes2.default.bool,
	    culture: _propTypes2.default.string,
	    delay: _propTypes2.default.number
	  },
	
	  mixins: [__webpack_require__(537)],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      step: 30,
	      onSelect: function onSelect() {},
	      min: new Date(1900, 0, 1),
	      max: new Date(2099, 11, 31),
	      preserveDate: true,
	      delay: 300,
	      ariaActiveDescendantKey: 'timelist'
	    };
	  },
	  getInitialState: function getInitialState() {
	    var data = this._dates(this.props),
	        focusedItem = this._closestDate(data, this.props.value || this.props.currentDate);
	
	    return {
	      focusedItem: focusedItem || data[0],
	      dates: data
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this._mounted = true;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._mounted = false;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var data = this._dates(nextProps),
	        focusedItem = this._closestDate(data, nextProps.value || this.props.currentDate),
	        valChanged = !_dates3.default.eq(nextProps.value, this.props.value, 'minutes'),
	        minChanged = !_dates3.default.eq(nextProps.min, this.props.min, 'minutes'),
	        maxChanged = !_dates3.default.eq(nextProps.max, this.props.max, 'minutes'),
	        localeChanged = this.props.format !== nextProps.format || this.props.culture !== nextProps.culture;
	
	    if (valChanged || minChanged || maxChanged || localeChanged) {
	      this.setState({
	        focusedItem: focusedItem || data[0],
	        dates: data
	      });
	    }
	  },
	  render: function render() {
	    var _props = this.props,
	        value = _props.value,
	        onSelect = _props.onSelect,
	        itemComponent = _props.itemComponent;
	
	
	    var times = this.state.dates,
	        date = this._closestDate(times, value);
	
	    return _react2.default.createElement(_List2.default, _extends({}, _3.default.omitOwnProps(this), {
	      ref: 'list',
	      data: times,
	      textField: 'label',
	      valueField: 'date',
	      selected: date,
	      onSelect: onSelect,
	      focused: this.state.focusedItem,
	      itemComponent: itemComponent
	    }));
	  },
	  _closestDate: function _closestDate(times, date) {
	    var roundTo = 1000 * 60 * this.props.step,
	        inst = null,
	        label;
	
	    if (!date) return null;
	
	    date = new Date(Math.floor(date.getTime() / roundTo) * roundTo);
	    label = _localizers.date.format(date, format(this.props), this.props.culture);
	
	    times.some(function (time) {
	      if (time.label === label) return inst = time;
	    });
	
	    return inst;
	  },
	  _data: function _data() {
	    return this.state.dates;
	  },
	  _dates: function _dates(props) {
	    var times = [],
	        i = 0,
	        values = this._dateValues(props),
	        start = values.min,
	        startDay = _dates3.default.date(start);
	
	    while (_dates3.default.date(start) === startDay && _dates3.default.lte(start, values.max)) {
	      i++;
	      times.push({ date: start, label: _localizers.date.format(start, format(props), props.culture) });
	      start = _dates3.default.add(start, props.step || 30, 'minutes');
	    }
	    return times;
	  },
	  _dateValues: function _dateValues(props) {
	    var value = props.value || props.currentDate || _dates3.default.today(),
	        useDate = props.preserveDate,
	        min = props.min,
	        max = props.max,
	        start,
	        end;
	
	    //compare just the time regradless of whether they fall on the same day
	    if (!useDate) {
	      start = _dates3.default.startOf(_dates3.default.merge(new Date(), min, props.currentDate), 'minutes');
	      end = _dates3.default.startOf(_dates3.default.merge(new Date(), max, props.currentDate), 'minutes');
	
	      if (_dates3.default.lte(end, start) && _dates3.default.gt(max, min, 'day')) end = _dates3.default.tomorrow();
	
	      return {
	        min: start,
	        max: end
	      };
	    }
	
	    start = _dates3.default.today();
	    end = _dates3.default.tomorrow();
	    //date parts are equal
	    return {
	      min: _dates3.default.eq(value, min, 'day') ? _dates3.default.merge(start, min, props.currentDate) : start,
	      max: _dates3.default.eq(value, max, 'day') ? _dates3.default.merge(start, max, props.currentDate) : end
	    };
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    var key = e.key,
	        focusedItem = this.state.focusedItem,
	        list = this.refs.list;
	
	    if (key === 'End') {
	      e.preventDefault();
	      this.setState({ focusedItem: list.last() });
	    } else if (key === 'Home') {
	      e.preventDefault();
	      this.setState({ focusedItem: list.first() });
	    } else if (key === 'Enter') this.props.onSelect(focusedItem);else if (key === 'ArrowDown') {
	      e.preventDefault();
	      this.setState({ focusedItem: list.next(focusedItem) });
	    } else if (key === 'ArrowUp') {
	      e.preventDefault();
	      this.setState({ focusedItem: list.prev(focusedItem) });
	    }
	  },
	  handleKeyPress: function handleKeyPress(e) {
	    var _this = this;
	
	    e.preventDefault();
	
	    this.search(String.fromCharCode(e.which), function (item) {
	      _this._mounted && _this.setState({ focusedItem: item });
	    });
	  },
	  scrollTo: function scrollTo() {
	    this.refs.list.move && this.refs.list.move();
	  },
	  search: function search(character, cb) {
	    var _this2 = this;
	
	    var word = ((this._searchTerm || '') + character).toLowerCase();
	
	    this._searchTerm = word;
	
	    this.setTimeout('search', function () {
	      var list = _this2.refs.list,
	          item = list.next(_this2.state.focusedItem, word);
	
	      _this2._searchTerm = '';
	      if (item) cb(item);
	    }, this.props.delay);
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _CalendarView = __webpack_require__(384);
	
	var _CalendarView2 = _interopRequireDefault(_CalendarView);
	
	var _dates = __webpack_require__(188);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _localizers = __webpack_require__(128);
	
	var _2 = __webpack_require__(93);
	
	var _3 = _interopRequireDefault(_2);
	
	var _propTypes3 = __webpack_require__(156);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _widgetHelpers = __webpack_require__(189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var format = function format(props) {
	  return _localizers.date.getFormat('month', props.monthFormat);
	};
	
	var propTypes = {
	  culture: _propTypes2.default.string,
	  today: _propTypes2.default.instanceOf(Date),
	  value: _propTypes2.default.instanceOf(Date),
	  focused: _propTypes2.default.instanceOf(Date),
	  min: _propTypes2.default.instanceOf(Date),
	  max: _propTypes2.default.instanceOf(Date),
	  onChange: _propTypes2.default.func.isRequired,
	
	  monthFormat: _propTypes4.default.dateFormat
	};
	
	var optionId = function optionId(id, date) {
	  return id + '__year_' + _dates2.default.year(date) + '-' + _dates2.default.month(date);
	};
	
	var YearView = (0, _createReactClass2.default)({
	
	  displayName: 'YearView',
	
	  mixins: [__webpack_require__(301), __webpack_require__(216)()],
	
	  propTypes: propTypes,
	
	  componentDidUpdate: function componentDidUpdate() {
	    var activeId = optionId((0, _widgetHelpers.instanceId)(this), this.props.focused);
	    this.ariaActiveDescendant(activeId);
	  },
	  render: function render() {
	    var focused = this.props.focused,
	        months = _dates2.default.monthsInYear(_dates2.default.year(focused));
	
	
	    return _react2.default.createElement(
	      _CalendarView2.default,
	      _3.default.omitOwnProps(this),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _3.default.chunk(months, 4).map(this.renderRow)
	      )
	    );
	  },
	  renderRow: function renderRow(row, rowIdx) {
	    var _this = this;
	
	    var _props = this.props,
	        focused = _props.focused,
	        disabled = _props.disabled,
	        onChange = _props.onChange,
	        value = _props.value,
	        today = _props.today,
	        culture = _props.culture,
	        min = _props.min,
	        max = _props.max;
	
	
	    var id = (0, _widgetHelpers.instanceId)(this),
	        labelFormat = _localizers.date.getFormat('header');
	
	    return _react2.default.createElement(
	      _CalendarView2.default.Row,
	      { key: rowIdx },
	      row.map(function (date, colIdx) {
	        var label = _localizers.date.format(date, labelFormat, culture);
	
	        return _react2.default.createElement(
	          _CalendarView2.default.Cell,
	          {
	            key: colIdx,
	            id: optionId(id, date),
	            label: label,
	            date: date,
	            now: today,
	            min: min,
	            max: max,
	            unit: 'month',
	            onChange: onChange,
	            focused: focused,
	            selected: value,
	            disabled: disabled
	          },
	          _localizers.date.format(date, format(_this.props), culture)
	        );
	      })
	    );
	  }
	});
	
	exports.default = YearView;
	module.exports = exports['default'];

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _configuration = __webpack_require__(538);
	
	var _configuration2 = _interopRequireDefault(_configuration);
	
	var _localizers = __webpack_require__(128);
	
	var localizers = _interopRequireWildcard(_localizers);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  setAnimate: function setAnimate(animatefn) {
	    _configuration2.default.animate = animatefn;
	  },
	  setLocalizers: function setLocalizers(_ref) {
	    var date = _ref.date,
	        number = _ref.number;
	
	    date && this.setDateLocalizer(date);
	    number && this.setNumberLocalizer(number);
	  },
	
	
	  setDateLocalizer: localizers.setDate,
	
	  setNumberLocalizer: localizers.setNumber
	};
	module.exports = exports['default'];

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (moment) {
	  if (typeof moment !== 'function') throw new TypeError('You must provide a valid moment object');
	
	  var localField = typeof moment().locale === 'function' ? 'locale' : 'lang',
	      hasLocaleData = !!moment.localeData;
	
	  if (!hasLocaleData) throw new TypeError('The Moment localizer depends on the `localeData` api, please provide a moment object v2.2.0 or higher');
	
	  function getMoment(culture, value, format) {
	    return culture ? moment(value, format)[localField](culture) : moment(value, format);
	  }
	
	  function endOfDecade(date) {
	    return moment(date).add(10, 'year').add(-1, 'millisecond').toDate();
	  }
	
	  function endOfCentury(date) {
	    return moment(date).add(100, 'year').add(-1, 'millisecond').toDate();
	  }
	
	  var localizer = {
	    formats: {
	      date: 'L',
	      time: 'LT',
	      default: 'lll',
	      header: 'MMMM YYYY',
	      footer: 'LL',
	      weekday: 'dd',
	      dayOfMonth: 'DD',
	      month: 'MMM',
	      year: 'YYYY',
	
	      decade: function decade(date, culture, localizer) {
	        return localizer.format(date, 'YYYY', culture) + ' - ' + localizer.format(endOfDecade(date), 'YYYY', culture);
	      },
	      century: function century(date, culture, localizer) {
	        return localizer.format(date, 'YYYY', culture) + ' - ' + localizer.format(endOfCentury(date), 'YYYY', culture);
	      }
	    },
	
	    firstOfWeek: function firstOfWeek(culture) {
	      return moment.localeData(culture).firstDayOfWeek();
	    },
	    parse: function parse(value, format, culture) {
	      if (!value) return null;
	      var m = getMoment(culture, value, format);
	      if (m.isValid()) return m.toDate();
	      return null;
	    },
	    format: function format(value, _format, culture) {
	      return getMoment(culture, value).format(_format);
	    }
	  };
	
	  _configure2.default.setDateLocalizer(localizer);
	
	  return localizer;
	};
	
	var _configure = __webpack_require__(1905);
	
	var _configure2 = _interopRequireDefault(_configure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  propTypes: {
	    autoFocus: _propTypes2.default.bool
	  },
	
	  componentDidMount: function componentDidMount() {
	    var autoFocus = this.props.autoFocus;
	
	
	    if (autoFocus) this.focus ? this.focus() : (0, _reactDom.findDOMNode)(this).focus();
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _filter = __webpack_require__(880);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _dataHelpers = __webpack_require__(540);
	
	var _propTypes = __webpack_require__(156);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _interaction = __webpack_require__(302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EMPTY_VALUE = {};
	
	var isDisabledOrReadonly = function isDisabledOrReadonly(item, props) {
	  return (0, _interaction.isDisabledItem)(item, props) || (0, _interaction.isReadOnlyItem)(item, props);
	};
	
	exports.default = {
	
	  propTypes: {
	    textField: _propTypes2.default.accessor,
	    valueField: _propTypes2.default.accessor,
	    disabled: _propTypes2.default.disabled.acceptsArray,
	    readOnly: _propTypes2.default.readOnly.acceptsArray
	  },
	
	  first: function first() {
	    return this.next(EMPTY_VALUE);
	  },
	  last: function last() {
	    var data = this._data(),
	        item = data[data.length - 1];
	
	    return isDisabledOrReadonly(item, this.props) ? this.prev(item) : item;
	  },
	  prev: function prev(item, word) {
	    var data = this._data(),
	        nextIdx = data.indexOf(item),
	        matches = matcher(word, item, this.props.textField);
	
	    if (nextIdx < 0 || nextIdx == null) nextIdx = 0;
	
	    nextIdx--;
	
	    while (nextIdx > -1 && (isDisabledOrReadonly(data[nextIdx], this.props) || !matches(data[nextIdx]))) {
	      nextIdx--;
	    }return nextIdx >= 0 ? data[nextIdx] : item;
	  },
	  next: function next(item, word) {
	    var data = this._data(),
	        nextIdx = data.indexOf(item) + 1,
	        len = data.length,
	        matches = matcher(word, item, this.props.textField);
	
	    while (nextIdx < len && (isDisabledOrReadonly(data[nextIdx], this.props) || !matches(data[nextIdx]))) {
	      nextIdx++;
	    }return nextIdx < len ? data[nextIdx] : item;
	  }
	};
	
	
	function matcher(word, item, textField) {
	  if (!word) return function () {
	    return true;
	  };
	
	  word = word.toLowerCase();
	  return function (item) {
	    return _filter2.default.startsWith((0, _dataHelpers.dataText)(item, textField).toLowerCase(), word);
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _scrollTo2 = __webpack_require__(1923);
	
	var _scrollTo3 = _interopRequireDefault(_scrollTo2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  _scrollTo: function _scrollTo(selected, list, focused) {
	    var state = this._scrollState || (this._scrollState = {}),
	        handler = this.props.onMove,
	        lastVisible = state.visible,
	        lastItem = state.focused,
	        shown,
	        changed;
	
	    state.visible = !(!list.offsetWidth || !list.offsetHeight);
	    state.focused = focused;
	
	    changed = lastItem !== focused;
	    shown = state.visible && !lastVisible;
	
	    if (shown || state.visible && changed) {
	      if (handler) handler(selected, list, focused);else {
	        state.scrollCancel && state.scrollCancel();
	        state.scrollCancel = (0, _scrollTo3.default)(selected, list);
	      }
	    }
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = animate;
	
	var _hyphenate = __webpack_require__(884);
	
	var _hyphenate2 = _interopRequireDefault(_hyphenate);
	
	var _style = __webpack_require__(304);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _on = __webpack_require__(1913);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(1912);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _properties = __webpack_require__(1919);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var has = Object.prototype.hasOwnProperty,
	    reset = {},
	    TRANSLATION_MAP = {
	  left: 'translateX',
	  right: 'translateX',
	  top: 'translateY',
	  bottom: 'translateY'
	};
	
	reset[_properties2.default.property] = reset[_properties2.default.duration] = reset[_properties2.default.delay] = reset[_properties2.default.timing] = '';
	
	animate.endEvent = _properties2.default.end;
	animate.transform = _properties2.default.transform;
	animate.TRANSLATION_MAP = TRANSLATION_MAP;
	
	// super lean animate function for transitions
	// doesn't support all translations to keep it matching the jquery API
	/**
	 * code in part from: Zepto 1.1.4 | zeptojs.com/license
	 */
	function animate(node, properties, duration, easing, callback) {
	  var cssProperties = [],
	      fakeEvent = { target: node, currentTarget: node },
	      cssValues = {},
	      transforms = '',
	      fired;
	
	  if (typeof easing === 'function') callback = easing, easing = null;
	
	  if (!_properties2.default.end) duration = 0;
	  if (duration === undefined) duration = 200;
	
	  for (var key in properties) {
	    if (has.call(properties, key)) {
	      if (/(top|bottom)/.test(key)) transforms += TRANSLATION_MAP[key] + '(' + properties[key] + ') ';else {
	        cssValues[key] = properties[key];
	        cssProperties.push((0, _hyphenate2.default)(key));
	      }
	    }
	  }if (transforms) {
	    cssValues[_properties2.default.transform] = transforms;
	    cssProperties.push(_properties2.default.transform);
	  }
	
	  if (duration > 0) {
	    cssValues[_properties2.default.property] = cssProperties.join(', ');
	    cssValues[_properties2.default.duration] = duration / 1000 + 's';
	    cssValues[_properties2.default.delay] = 0 + 's';
	    cssValues[_properties2.default.timing] = easing || 'linear';
	
	    (0, _on2.default)(node, _properties2.default.end, done);
	
	    setTimeout(function () {
	      if (!fired) done(fakeEvent);
	    }, duration + 500);
	  }
	
	  node.clientLeft; // trigger page reflow
	  (0, _style2.default)(node, cssValues);
	
	  if (duration <= 0) setTimeout(done.bind(null, fakeEvent), 0);
	
	  return {
	    cancel: function cancel() {
	      if (fired) return;
	      fired = true;
	      (0, _off2.default)(node, _properties2.default.end, done);
	      (0, _style2.default)(node, reset);
	    }
	  };
	
	  function done(event) {
	    if (event.target !== event.currentTarget) return;
	
	    fired = true;
	    (0, _off2.default)(event.target, _properties2.default.end, done);
	    (0, _style2.default)(node, reset);
	    callback && callback.call(this);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__(883);
	
	exports.__esModule = true;
	
	/**
	 * document.activeElement
	 */
	exports['default'] = activeElement;
	
	var _ownerDocument = __webpack_require__(881);
	
	var _ownerDocument2 = babelHelpers.interopRequireDefault(_ownerDocument);
	
	function activeElement() {
	  var doc = arguments[0] === undefined ? document : arguments[0];
	
	  try {
	    return doc.activeElement;
	  } catch (e) {}
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(305);
	var off = function off() {};
	
	if (canUseDOM) {
	
	  off = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = off;

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(305);
	var on = function on() {};
	
	if (canUseDOM) {
	  on = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = on;

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(305);
	
	var contains = (function () {
	  var root = canUseDOM && document.documentElement;
	
	  return root && root.contains ? function (context, node) {
	    return context.contains(node);
	  } : root && root.compareDocumentPosition ? function (context, node) {
	    return context === node || !!(context.compareDocumentPosition(node) & 16);
	  } : function (context, node) {
	    if (node) do {
	      if (node === context) return true;
	    } while (node = node.parentNode);
	
	    return false;
	  };
	})();
	
	module.exports = contains;

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var css = __webpack_require__(304),
	    height = __webpack_require__(385);
	
	module.exports = function scrollPrarent(node) {
	  var position = css(node, 'position'),
	      excludeStatic = position === 'absolute',
	      ownerDoc = node.ownerDocument;
	
	  if (position === 'fixed') return ownerDoc || document;
	
	  while ((node = node.parentNode) && node.nodeType !== 9) {
	
	    var isStatic = excludeStatic && css(node, 'position') === 'static',
	        style = css(node, 'overflow') + css(node, 'overflow-y') + css(node, 'overflow-x');
	
	    if (isStatic) continue;
	
	    if (/(auto|scroll)/.test(style) && height(node) < node.scrollHeight) return node;
	  }
	
	  return document;
	};

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getWindow = __webpack_require__(303);
	
	module.exports = function scrollTop(node, val) {
	  var win = getWindow(node);
	
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	};

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__(883);
	
	var _utilCamelizeStyle = __webpack_require__(542);
	
	var _utilCamelizeStyle2 = babelHelpers.interopRequireDefault(_utilCamelizeStyle);
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	module.exports = function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : { //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	
	      prop = (0, _utilCamelizeStyle2['default'])(prop);
	
	      if (prop == 'float') prop = 'styleFloat';
	
	      var current = node.currentStyle[prop] || null;
	
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left;
	
	        // Put in the new values to get a computed value out
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px';
	
	        // Revert the changed values
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	};

/***/ }),
/* 1918 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	};

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(305);
	
	var has = Object.prototype.hasOwnProperty,
	    transform = 'transform',
	    transition = {},
	    transitionTiming,
	    transitionDuration,
	    transitionProperty,
	    transitionDelay;
	
	if (canUseDOM) {
	  transition = getTransitionProperties();
	
	  transform = transition.prefix + transform;
	
	  transitionProperty = transition.prefix + 'transition-property';
	  transitionDuration = transition.prefix + 'transition-duration';
	  transitionDelay = transition.prefix + 'transition-delay';
	  transitionTiming = transition.prefix + 'transition-timing-function';
	}
	
	module.exports = {
	  transform: transform,
	  end: transition.end,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	
	function getTransitionProperties() {
	  var endEvent,
	      prefix = '',
	      transitions = {
	    O: 'otransitionend',
	    Moz: 'transitionend',
	    Webkit: 'webkitTransitionEnd',
	    ms: 'MSTransitionEnd'
	  };
	
	  var element = document.createElement('div');
	
	  for (var vendor in transitions) if (has.call(transitions, vendor)) {
	    if (element.style[vendor + 'TransitionProperty'] !== undefined) {
	      prefix = '-' + vendor.toLowerCase() + '-';
	      endEvent = transitions[vendor];
	      break;
	    }
	  }
	
	  if (!endEvent && element.style.transitionProperty !== undefined) endEvent = 'transitionend';
	
	  return { end: endEvent, prefix: prefix };
	}

/***/ }),
/* 1920 */
/***/ (function(module, exports) {

	"use strict";
	
	var rHyphen = /-(.)/g;
	
	module.exports = function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	};

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	
	"use strict";
	
	var hyphenate = __webpack_require__(884);
	var msPattern = /^ms-/;
	
	module.exports = function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, "-ms-");
	};

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var canUseDOM = __webpack_require__(305);
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'],
	    cancel = 'clearTimeout',
	    raf = fallback,
	    compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (canUseDOM) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function (cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	
	/* https://github.com/component/raf */
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	
	  prev = curr;
	  return req;
	}
	
	compatRaf = function (cb) {
	  return raf(cb);
	};
	compatRaf.cancel = function (id) {
	  return window[cancel](id);
	};
	
	module.exports = compatRaf;

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getOffset = __webpack_require__(541),
	    height = __webpack_require__(385),
	    getScrollParent = __webpack_require__(1915),
	    scrollTop = __webpack_require__(1916),
	    raf = __webpack_require__(1922),
	    getWindow = __webpack_require__(303);
	
	module.exports = function scrollTo(selected, scrollParent) {
	    var offset = getOffset(selected),
	        poff = { top: 0, left: 0 },
	        list,
	        listScrollTop,
	        selectedTop,
	        isWin,
	        selectedHeight,
	        listHeight,
	        bottom;
	
	    if (!selected) return;
	
	    list = scrollParent || getScrollParent(selected);
	    isWin = getWindow(list);
	    listScrollTop = scrollTop(list);
	
	    listHeight = height(list, true);
	    isWin = getWindow(list);
	
	    if (!isWin) poff = getOffset(list);
	
	    offset = {
	        top: offset.top - poff.top,
	        left: offset.left - poff.left,
	        height: offset.height,
	        width: offset.width
	    };
	
	    selectedHeight = offset.height;
	    selectedTop = offset.top + (isWin ? 0 : listScrollTop);
	    bottom = selectedTop + selectedHeight;
	
	    listScrollTop = listScrollTop > selectedTop ? selectedTop : bottom > listScrollTop + listHeight ? bottom - listHeight : listScrollTop;
	
	    var id = raf(function () {
	        return scrollTop(list, listScrollTop);
	    });
	
	    return function () {
	        return raf.cancel(id);
	    };
	};

/***/ }),
/* 1924 */
514,
/* 1925 */
[2457, 306],
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1925);
	var ReactElement = __webpack_require__(253);
	
	var emptyFunction = __webpack_require__(113);
	var traverseAllChildren = __webpack_require__(1935);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(253);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(253),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(785);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 1929 */
1783,
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(885),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(253),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(888);
	var factory = __webpack_require__(626);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 1931 */
1802,
/* 1932 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(306);
	
	var ReactElement = __webpack_require__(253);
	
	var invariant = __webpack_require__(28);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(306);
	
	var ReactCurrentOwner = __webpack_require__(169);
	var REACT_ELEMENT_TYPE = __webpack_require__(887);
	
	var getIteratorFn = __webpack_require__(1931);
	var invariant = __webpack_require__(28);
	var KeyEscapeUtils = __webpack_require__(1924);
	var warning = __webpack_require__(61);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTickValuesFixedDomain = exports.getTickValues = exports.getNiceTickValues = void 0;
	
	var _decimal = _interopRequireDefault(__webpack_require__(629));
	
	var _utils = __webpack_require__(890);
	
	var _arithmetic = _interopRequireDefault(__webpack_require__(1938));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	/**
	 * Calculate a interval of a minimum value and a maximum value
	 *
	 * @param  {Number} min       The minimum value
	 * @param  {Number} max       The maximum value
	 * @return {Array} An interval
	 */
	function getValidInterval(_ref) {
	  var _ref2 = _slicedToArray(_ref, 2),
	      min = _ref2[0],
	      max = _ref2[1];
	
	  var validMin = min,
	      validMax = max; // exchange
	
	  if (min > max) {
	    validMin = max;
	    validMax = min;
	  }
	
	  return [validMin, validMax];
	}
	/**
	 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
	 *
	 * @param  {Decimal} roughStep        The rough step calculated by deviding the
	 * difference by the tickCount
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Integer} correctionFactor A correction factor
	 * @return {Decimal} The step which is easy to understand between two ticks
	 */
	
	
	function getFormatStep(roughStep, allowDecimals, correctionFactor) {
	  if (roughStep.lte(0)) {
	    return new _decimal.default(0);
	  }
	
	  var digitCount = _arithmetic.default.getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
	  // order of magnitudes than the rough step
	
	
	  var digitCountValue = new _decimal.default(10).pow(digitCount);
	  var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
	
	  var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
	  var amendStepRatio = new _decimal.default(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
	  var formatStep = amendStepRatio.mul(digitCountValue);
	  return allowDecimals ? formatStep : new _decimal.default(Math.ceil(formatStep));
	}
	/**
	 * calculate the ticks when the minimum value equals to the maximum value
	 *
	 * @param  {Number}  value         The minimum valuue which is also the maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}                 ticks
	 */
	
	
	function getTickOfSingleValue(value, tickCount, allowDecimals) {
	  var step = 1; // calculate the middle value of ticks
	
	  var middle = new _decimal.default(value);
	
	  if (!middle.isint() && allowDecimals) {
	    var absVal = Math.abs(value);
	
	    if (absVal < 1) {
	      // The step should be a float number when the difference is smaller than 1
	      step = new _decimal.default(10).pow(_arithmetic.default.getDigitCount(value) - 1);
	      middle = new _decimal.default(Math.floor(middle.div(step).toNumber())).mul(step);
	    } else if (absVal > 1) {
	      // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
	      middle = new _decimal.default(Math.floor(value));
	    }
	  } else if (value === 0) {
	    middle = new _decimal.default(Math.floor((tickCount - 1) / 2));
	  } else if (!allowDecimals) {
	    middle = new _decimal.default(Math.floor(value));
	  }
	
	  var middleIndex = Math.floor((tickCount - 1) / 2);
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return middle.add(new _decimal.default(n - middleIndex).mul(step)).toNumber();
	  }), _utils.range);
	  return fn(0, tickCount);
	}
	/**
	 * Calculate the step
	 *
	 * @param  {Number}  min              The minimum value of an interval
	 * @param  {Number}  max              The maximum value of an interval
	 * @param  {Integer} tickCount        The count of ticks
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Number}  correctionFactor A correction factor
	 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
	 */
	
	
	function calculateStep(min, max, tickCount, allowDecimals) {
	  var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	
	  // dirty hack (for recharts' test)
	  if (!Number.isFinite((max - min) / (tickCount - 1))) {
	    return {
	      step: new _decimal.default(0),
	      tickMin: new _decimal.default(0),
	      tickMax: new _decimal.default(0)
	    };
	  } // The step which is easy to understand between two ticks
	
	
	  var step = getFormatStep(new _decimal.default(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
	
	  var middle; // When 0 is inside the interval, 0 should be a tick
	
	  if (min <= 0 && max >= 0) {
	    middle = new _decimal.default(0);
	  } else {
	    // calculate the middle value
	    middle = new _decimal.default(min).add(max).div(2); // minus modulo value
	
	    middle = middle.sub(new _decimal.default(middle).mod(step));
	  }
	
	  var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
	  var upCount = Math.ceil(new _decimal.default(max).sub(middle).div(step).toNumber());
	  var scaleCount = belowCount + upCount + 1;
	
	  if (scaleCount > tickCount) {
	    // When more ticks need to cover the interval, step should be bigger.
	    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
	  }
	
	  if (scaleCount < tickCount) {
	    // When less ticks can cover the interval, we should add some additional ticks
	    upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
	    belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
	  }
	
	  return {
	    step: step,
	    tickMin: middle.sub(new _decimal.default(belowCount).mul(step)),
	    tickMax: middle.add(new _decimal.default(upCount).mul(step))
	  };
	}
	/**
	 * Calculate the ticks of an interval, the count of ticks will be guraranteed
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	
	
	function getNiceTickValuesFn(_ref3) {
	  var _ref4 = _slicedToArray(_ref3, 2),
	      min = _ref4[0],
	      max = _ref4[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval = getValidInterval([min, max]),
	      _getValidInterval2 = _slicedToArray(_getValidInterval, 2),
	      cormin = _getValidInterval2[0],
	      cormax = _getValidInterval2[1];
	
	  if (cormin === -Infinity || cormax === Infinity) {
	    var _values = cormax === Infinity ? [cormin].concat(_toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function () {
	      return Infinity;
	    }))) : _toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function () {
	      return -Infinity;
	    })).concat([cormax]);
	
	    return min > max ? (0, _utils.reverse)(_values) : _values;
	  }
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  } // Get the step between two ticks
	
	
	  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals),
	      step = _calculateStep.step,
	      tickMin = _calculateStep.tickMin,
	      tickMax = _calculateStep.tickMax;
	
	  var values = _arithmetic.default.rangeStep(tickMin, tickMax.add(new _decimal.default(0.1).mul(step)), step);
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	/**
	 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	
	
	function getTickValuesFn(_ref5) {
	  var _ref6 = _slicedToArray(_ref5, 2),
	      min = _ref6[0],
	      max = _ref6[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval3 = getValidInterval([min, max]),
	      _getValidInterval4 = _slicedToArray(_getValidInterval3, 2),
	      cormin = _getValidInterval4[0],
	      cormax = _getValidInterval4[1];
	
	  if (cormin === -Infinity || cormax === Infinity) {
	    return [min, max];
	  }
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  }
	
	  var step = getFormatStep(new _decimal.default(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return new _decimal.default(cormin).add(new _decimal.default(n).mul(step)).toNumber();
	  }), _utils.range);
	  var values = fn(0, count).filter(function (entry) {
	    return entry >= cormin && entry <= cormax;
	  });
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	/**
	 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
	 * but the domain will be guaranteed
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	
	
	function getTickValuesFixedDomainFn(_ref7, tickCount) {
	  var _ref8 = _slicedToArray(_ref7, 2),
	      min = _ref8[0],
	      max = _ref8[1];
	
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var _getValidInterval5 = getValidInterval([min, max]),
	      _getValidInterval6 = _slicedToArray(_getValidInterval5, 2),
	      cormin = _getValidInterval6[0],
	      cormax = _getValidInterval6[1];
	
	  if (cormin === -Infinity || cormax === Infinity) {
	    return [min, max];
	  }
	
	  if (cormin === cormax) {
	    return [cormin];
	  }
	
	  var count = Math.max(tickCount, 2);
	  var step = getFormatStep(new _decimal.default(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
	
	  var values = _toConsumableArray(_arithmetic.default.rangeStep(new _decimal.default(cormin), new _decimal.default(cormax).sub(new _decimal.default(0.99).mul(step)), step)).concat([cormax]);
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	var getNiceTickValues = (0, _utils.memoize)(getNiceTickValuesFn);
	exports.getNiceTickValues = getNiceTickValues;
	var getTickValues = (0, _utils.memoize)(getTickValuesFn);
	exports.getTickValues = getTickValues;
	var getTickValuesFixedDomain = (0, _utils.memoize)(getTickValuesFixedDomainFn);
	exports.getTickValuesFixedDomain = getTickValuesFixedDomain;

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "getTickValues", {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValues;
	  }
	});
	Object.defineProperty(exports, "getNiceTickValues", {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getNiceTickValues;
	  }
	});
	Object.defineProperty(exports, "getTickValuesFixedDomain", {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValuesFixedDomain;
	  }
	});
	
	var _getNiceTickValues = __webpack_require__(1936);

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _decimal = _interopRequireDefault(__webpack_require__(629));
	
	var _utils = __webpack_require__(890);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview 一些公用的运算方法
	 * @author xile611
	 * @date 2015-09-17
	 */
	
	/**
	 * 获取数值的位数
	 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
	 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
	 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
	 *
	 * @param  {Number} value 数值
	 * @return {Integer} 位数
	 */
	function getDigitCount(value) {
	  var result;
	
	  if (value === 0) {
	    result = 1;
	  } else {
	    result = Math.floor(new _decimal.default(value).abs().log(10).toNumber()) + 1;
	  }
	
	  return result;
	}
	/**
	 * 按照固定的步长获取[start, end)这个区间的数据
	 * 并且需要处理js计算精度的问题
	 *
	 * @param  {Decimal} start 起点
	 * @param  {Decimal} end   终点，不包含该值
	 * @param  {Decimal} step  步长
	 * @return {Array}         若干数值
	 */
	
	
	function rangeStep(start, end, step) {
	  var num = new _decimal.default(start);
	  var i = 0;
	  var result = []; // magic number to prevent infinite loop
	
	  while (num.lt(end) && i < 100000) {
	    result.push(num.toNumber());
	    num = num.add(step);
	    i++;
	  }
	
	  return result;
	}
	/**
	 * 对数值进行线性插值
	 *
	 * @param  {Number} a  定义域的极点
	 * @param  {Number} b  定义域的极点
	 * @param  {Number} t  [0, 1]内的某个值
	 * @return {Number}    定义域内的某个值
	 */
	
	
	var interpolateNumber = (0, _utils.curry)(function (a, b, t) {
	  var newA = +a;
	  var newB = +b;
	  return newA + t * (newB - newA);
	});
	/**
	 * 线性插值的逆运算
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
	 */
	
	var uninterpolateNumber = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	  diff = diff || Infinity;
	  return (x - a) / diff;
	});
	/**
	 * 线性插值的逆运算，并且有截断的操作
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
	 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
	 */
	
	var uninterpolateTruncation = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	  diff = diff || Infinity;
	  return Math.max(0, Math.min(1, (x - a) / diff));
	});
	var _default = {
	  rangeStep: rangeStep,
	  getDigitCount: getDigitCount,
	  interpolateNumber: interpolateNumber,
	  uninterpolateNumber: uninterpolateNumber,
	  uninterpolateTruncation: uninterpolateTruncation
	};
	exports.default = _default;

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _ReactUtils = __webpack_require__(43);
	
	var _DataUtils = __webpack_require__(66);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CartesianGrid =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(CartesianGrid, _PureComponent);
	
	  function CartesianGrid() {
	    _classCallCheck(this, CartesianGrid);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(CartesianGrid).apply(this, arguments));
	  }
	
	  _createClass(CartesianGrid, [{
	    key: "renderHorizontal",
	
	    /**
	     * Draw the horizontal grid lines
	     * @param {Array} horizontalPoints either passed in as props or generated from function
	     * @return {Group} Horizontal lines
	     */
	    value: function renderHorizontal(horizontalPoints) {
	      var _this = this;
	
	      var _this$props = this.props,
	          x = _this$props.x,
	          width = _this$props.width,
	          horizontal = _this$props.horizontal;
	
	      if (!horizontalPoints || !horizontalPoints.length) {
	        return null;
	      }
	
	      var items = horizontalPoints.map(function (entry, i) {
	        var props = _objectSpread({}, _this.props, {
	          x1: x,
	          y1: entry,
	          x2: x + width,
	          y2: entry,
	          key: "line-".concat(i),
	          index: i
	        });
	
	        return _this.constructor.renderLineItem(horizontal, props);
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-grid-horizontal"
	      }, items);
	    }
	    /**
	     * Draw vertical grid lines
	     * @param {Array} verticalPoints either passed in as props or generated from function
	     * @return {Group} Vertical lines
	     */
	
	  }, {
	    key: "renderVertical",
	    value: function renderVertical(verticalPoints) {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          y = _this$props2.y,
	          height = _this$props2.height,
	          vertical = _this$props2.vertical;
	
	      if (!verticalPoints || !verticalPoints.length) {
	        return null;
	      }
	
	      var items = verticalPoints.map(function (entry, i) {
	        var props = _objectSpread({}, _this2.props, {
	          x1: entry,
	          y1: y,
	          x2: entry,
	          y2: y + height,
	          key: "line-".concat(i),
	          index: i
	        });
	
	        return _this2.constructor.renderLineItem(vertical, props);
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-grid-vertical"
	      }, items);
	    }
	    /**
	     * Draw vertical grid stripes filled by colors
	     * @param {Array} verticalPoints either passed in as props or generated from function
	     * @return {Group} Vertical stripes
	     */
	
	  }, {
	    key: "renderVerticalStripes",
	    value: function renderVerticalStripes(verticalPoints) {
	      var verticalFill = this.props.verticalFill;
	
	      if (!verticalFill || !verticalFill.length) {
	        return null;
	      }
	
	      var _this$props3 = this.props,
	          fillOpacity = _this$props3.fillOpacity,
	          x = _this$props3.x,
	          y = _this$props3.y,
	          width = _this$props3.width,
	          height = _this$props3.height;
	      var verticalPointsUpdated = verticalPoints.slice().sort(function (a, b) {
	        return a - b;
	      });
	
	      if (x !== verticalPointsUpdated[0]) {
	        verticalPointsUpdated.unshift(0);
	      }
	
	      var items = verticalPointsUpdated.map(function (entry, i) {
	        var lineWidth = verticalPointsUpdated[i + 1] ? verticalPointsUpdated[i + 1] - entry : x + width - entry;
	
	        if (lineWidth <= 0) {
	          return null;
	        }
	
	        var colorIndex = i % verticalFill.length;
	        return _react["default"].createElement("rect", {
	          key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
	          ,
	          x: Math.round(entry + x - x),
	          y: y,
	          width: lineWidth,
	          height: height,
	          stroke: "none",
	          fill: verticalFill[colorIndex],
	          fillOpacity: fillOpacity,
	          className: "recharts-cartesian-grid-bg"
	        });
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-gridstripes-vertical"
	      }, items);
	    }
	    /**
	     * Draw horizontal grid stripes filled by colors
	     * @param {Array} horizontalPoints either passed in as props or generated from function
	     * @return {Group} Horizontal stripes
	     */
	
	  }, {
	    key: "renderHorizontalStripes",
	    value: function renderHorizontalStripes(horizontalPoints) {
	      var horizontalFill = this.props.horizontalFill;
	
	      if (!horizontalFill || !horizontalFill.length) {
	        return null;
	      }
	
	      var _this$props4 = this.props,
	          fillOpacity = _this$props4.fillOpacity,
	          x = _this$props4.x,
	          y = _this$props4.y,
	          width = _this$props4.width,
	          height = _this$props4.height;
	      var horizontalPointsUpdated = horizontalPoints.slice().sort(function (a, b) {
	        return a - b;
	      });
	
	      if (y !== horizontalPointsUpdated[0]) {
	        horizontalPointsUpdated.unshift(0);
	      }
	
	      var items = horizontalPointsUpdated.map(function (entry, i) {
	        var lineHeight = horizontalPointsUpdated[i + 1] ? horizontalPointsUpdated[i + 1] - entry : y + height - entry;
	
	        if (lineHeight <= 0) {
	          return null;
	        }
	
	        var colorIndex = i % horizontalFill.length;
	        return _react["default"].createElement("rect", {
	          key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
	          ,
	          y: Math.round(entry + y - y),
	          x: x,
	          height: lineHeight,
	          width: width,
	          stroke: "none",
	          fill: horizontalFill[colorIndex],
	          fillOpacity: fillOpacity,
	          className: "recharts-cartesian-grid-bg"
	        });
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-gridstripes-horizontal"
	      }, items);
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground() {
	      var fill = this.props.fill;
	
	      if (!fill || fill === 'none') {
	        return null;
	      }
	
	      var _this$props5 = this.props,
	          fillOpacity = _this$props5.fillOpacity,
	          x = _this$props5.x,
	          y = _this$props5.y,
	          width = _this$props5.width,
	          height = _this$props5.height;
	      return _react["default"].createElement("rect", {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        stroke: "none",
	        fill: fill,
	        fillOpacity: fillOpacity,
	        className: "recharts-cartesian-grid-bg"
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          x = _this$props6.x,
	          y = _this$props6.y,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          horizontal = _this$props6.horizontal,
	          vertical = _this$props6.vertical,
	          horizontalCoordinatesGenerator = _this$props6.horizontalCoordinatesGenerator,
	          verticalCoordinatesGenerator = _this$props6.verticalCoordinatesGenerator,
	          xAxis = _this$props6.xAxis,
	          yAxis = _this$props6.yAxis,
	          offset = _this$props6.offset,
	          chartWidth = _this$props6.chartWidth,
	          chartHeight = _this$props6.chartHeight;
	
	      if (!(0, _DataUtils.isNumber)(width) || width <= 0 || !(0, _DataUtils.isNumber)(height) || height <= 0 || !(0, _DataUtils.isNumber)(x) || x !== +x || !(0, _DataUtils.isNumber)(y) || y !== +y) {
	        return null;
	      }
	
	      var _this$props7 = this.props,
	          horizontalPoints = _this$props7.horizontalPoints,
	          verticalPoints = _this$props7.verticalPoints; // No horizontal points are specified
	
	      if ((!horizontalPoints || !horizontalPoints.length) && (0, _isFunction2["default"])(horizontalCoordinatesGenerator)) {
	        horizontalPoints = horizontalCoordinatesGenerator({
	          yAxis: yAxis,
	          width: chartWidth,
	          height: chartHeight,
	          offset: offset
	        });
	      } // No vertical points are specified
	
	
	      if ((!verticalPoints || !verticalPoints.length) && (0, _isFunction2["default"])(verticalCoordinatesGenerator)) {
	        verticalPoints = verticalCoordinatesGenerator({
	          xAxis: xAxis,
	          width: chartWidth,
	          height: chartHeight,
	          offset: offset
	        });
	      }
	
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-grid"
	      }, this.renderBackground(), horizontal && this.renderHorizontal(horizontalPoints), vertical && this.renderVertical(verticalPoints), horizontal && this.renderHorizontalStripes(horizontalPoints), vertical && this.renderVerticalStripes(verticalPoints));
	    }
	  }], [{
	    key: "renderLineItem",
	    value: function renderLineItem(option, props) {
	      var lineItem;
	
	      if (_react["default"].isValidElement(option)) {
	        lineItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        lineItem = option(props);
	      } else {
	        var x1 = props.x1,
	            y1 = props.y1,
	            x2 = props.x2,
	            y2 = props.y2,
	            key = props.key,
	            others = _objectWithoutProperties(props, ["x1", "y1", "x2", "y2", "key"]);
	
	        lineItem = _react["default"].createElement("line", _extends({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	          x1: x1,
	          y1: y1,
	          x2: x2,
	          y2: y2,
	          fill: "none",
	          key: key
	        }));
	      }
	
	      return lineItem;
	    }
	  }]);
	
	  return CartesianGrid;
	}(_react.PureComponent);
	
	CartesianGrid.displayName = 'CartesianGrid';
	CartesianGrid.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  horizontal: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  vertical: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  horizontalPoints: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  verticalPoints: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  horizontalCoordinatesGenerator: _propTypes["default"].func,
	  verticalCoordinatesGenerator: _propTypes["default"].func,
	  xAxis: _propTypes["default"].object,
	  yAxis: _propTypes["default"].object,
	  offset: _propTypes["default"].object,
	  chartWidth: _propTypes["default"].number,
	  chartHeight: _propTypes["default"].number,
	  verticalFill: _propTypes["default"].arrayOf(_propTypes["default"].string),
	  horizontalFill: _propTypes["default"].arrayOf(_propTypes["default"].string)
	});
	CartesianGrid.defaultProps = {
	  horizontal: true,
	  vertical: true,
	  // The ordinates of horizontal grid lines
	  horizontalPoints: [],
	  // The abscissas of vertical grid lines
	  verticalPoints: [],
	  stroke: '#ccc',
	  fill: 'none',
	  // The fill of colors of grid lines
	  verticalFill: [],
	  horizontalFill: []
	};
	var _default = CartesianGrid;
	exports["default"] = _default;

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(170));
	
	var _Area = _interopRequireDefault(__webpack_require__(543));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(254));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(255));
	
	var _CartesianUtils = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Area Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'AreaChart',
	  GraphicalChild: _Area["default"],
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(170));
	
	var _Bar = _interopRequireDefault(__webpack_require__(544));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(254));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(255));
	
	var _CartesianUtils = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Bar Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'BarChart',
	  GraphicalChild: _Bar["default"],
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(170));
	
	var _Area = _interopRequireDefault(__webpack_require__(543));
	
	var _Bar = _interopRequireDefault(__webpack_require__(544));
	
	var _Line = _interopRequireDefault(__webpack_require__(545));
	
	var _Scatter = _interopRequireDefault(__webpack_require__(546));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(254));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(255));
	
	var _ZAxis = _interopRequireDefault(__webpack_require__(386));
	
	var _CartesianUtils = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Composed Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'ComposedChart',
	  GraphicalChild: [_Line["default"], _Area["default"], _Bar["default"], _Scatter["default"]],
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }, {
	    axisType: 'zAxis',
	    AxisComp: _ZAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(170));
	
	var _Funnel = _interopRequireDefault(__webpack_require__(896));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Funnel Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'FunnelChart',
	  GraphicalChild: _Funnel["default"],
	  eventType: 'item',
	  axisComponents: [],
	  defaultProps: {
	    layout: 'centric'
	  },
	  propTypes: {
	    layout: _propTypes["default"].oneOf(['centric'])
	  }
	});
	
	exports["default"] = _default;

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(170));
	
	var _Line = _interopRequireDefault(__webpack_require__(545));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(254));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(255));
	
	var _CartesianUtils = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Line Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'LineChart',
	  GraphicalChild: _Line["default"],
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(170));
	
	var _PolarAngleAxis = _interopRequireDefault(__webpack_require__(388));
	
	var _PolarRadiusAxis = _interopRequireDefault(__webpack_require__(389));
	
	var _PolarUtils = __webpack_require__(142);
	
	var _Pie = _interopRequireDefault(__webpack_require__(897));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Pie Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'PieChart',
	  GraphicalChild: _Pie["default"],
	  eventType: 'item',
	  legendContent: 'children',
	  axisComponents: [{
	    axisType: 'angleAxis',
	    AxisComp: _PolarAngleAxis["default"]
	  }, {
	    axisType: 'radiusAxis',
	    AxisComp: _PolarRadiusAxis["default"]
	  }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'centric',
	    startAngle: 0,
	    endAngle: 360,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes["default"].oneOf(['centric']),
	    startAngle: _propTypes["default"].number,
	    endAngle: _propTypes["default"].number,
	    cx: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    cy: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    innerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    outerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	  }
	});
	
	exports["default"] = _default;

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(170));
	
	var _Radar = _interopRequireDefault(__webpack_require__(898));
	
	var _PolarAngleAxis = _interopRequireDefault(__webpack_require__(388));
	
	var _PolarRadiusAxis = _interopRequireDefault(__webpack_require__(389));
	
	var _PolarUtils = __webpack_require__(142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Radar Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'RadarChart',
	  GraphicalChild: _Radar["default"],
	  axisComponents: [{
	    axisType: 'angleAxis',
	    AxisComp: _PolarAngleAxis["default"]
	  }, {
	    axisType: 'radiusAxis',
	    AxisComp: _PolarRadiusAxis["default"]
	  }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'centric',
	    startAngle: 90,
	    endAngle: -270,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes["default"].oneOf(['centric']),
	    startAngle: _propTypes["default"].number,
	    endAngle: _propTypes["default"].number,
	    cx: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    cy: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    innerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    outerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	  }
	});
	
	exports["default"] = _default;

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(170));
	
	var _PolarAngleAxis = _interopRequireDefault(__webpack_require__(388));
	
	var _PolarRadiusAxis = _interopRequireDefault(__webpack_require__(389));
	
	var _PolarUtils = __webpack_require__(142);
	
	var _RadialBar = _interopRequireDefault(__webpack_require__(899));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Radar Bar Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'RadialBarChart',
	  GraphicalChild: _RadialBar["default"],
	  legendContent: 'children',
	  axisComponents: [{
	    axisType: 'angleAxis',
	    AxisComp: _PolarAngleAxis["default"]
	  }, {
	    axisType: 'radiusAxis',
	    AxisComp: _PolarRadiusAxis["default"]
	  }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'radial',
	    startAngle: 0,
	    endAngle: 360,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes["default"].oneOf(['radial']),
	    startAngle: _propTypes["default"].number,
	    endAngle: _propTypes["default"].number,
	    cx: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    cy: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    innerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    outerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	  }
	});
	
	exports["default"] = _default;

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _sumBy2 = _interopRequireDefault(__webpack_require__(1485));
	
	var _min2 = _interopRequireDefault(__webpack_require__(727));
	
	var _maxBy2 = _interopRequireDefault(__webpack_require__(725));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _Surface = _interopRequireDefault(__webpack_require__(308));
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(387));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(258));
	
	var _ShallowEqual = __webpack_require__(394);
	
	var _ReactUtils = __webpack_require__(43);
	
	var _ChartUtils = __webpack_require__(103);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultCoordinateOfTooltip = {
	  x: 0,
	  y: 0
	};
	
	var interpolationGenerator = function interpolationGenerator(a, b) {
	  var ka = +a;
	  var kb = b - ka;
	  return function (t) {
	    return ka + kb * t;
	  };
	};
	
	var centerY = function centerY(node) {
	  return node.y + node.dy / 2;
	};
	
	var getValue = function getValue(entry) {
	  return entry && entry.value || 0;
	};
	
	var getSumOfIds = function getSumOfIds(links, ids) {
	  return ids.reduce(function (result, id) {
	    return result + getValue(links[id]);
	  }, 0);
	};
	
	var getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var sourceNode = tree[link.source];
	    return result + centerY(sourceNode) * getValue(links[id]);
	  }, 0);
	};
	
	var getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var targetNode = tree[link.target];
	    return result + centerY(targetNode) * getValue(links[id]);
	  }, 0);
	};
	
	var ascendingY = function ascendingY(a, b) {
	  return a.y - b.y;
	};
	
	var searchTargetsAndSources = function searchTargetsAndSources(links, id) {
	  var sourceNodes = [];
	  var sourceLinks = [];
	  var targetNodes = [];
	  var targetLinks = [];
	
	  for (var i = 0, len = links.length; i < len; i++) {
	    var link = links[i];
	
	    if (link.source === id) {
	      targetNodes.push(link.target);
	      targetLinks.push(i);
	    }
	
	    if (link.target === id) {
	      sourceNodes.push(link.source);
	      sourceLinks.push(i);
	    }
	  }
	
	  return {
	    sourceNodes: sourceNodes,
	    sourceLinks: sourceLinks,
	    targetLinks: targetLinks,
	    targetNodes: targetNodes
	  };
	};
	
	var updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
	  var targetNodes = curNode.targetNodes;
	
	  for (var i = 0, len = targetNodes.length; i < len; i++) {
	    var target = tree[targetNodes[i]];
	
	    if (target) {
	      target.depth = Math.max(curNode.depth + 1, target.depth);
	      updateDepthOfTargets(tree, target);
	    }
	  }
	};
	
	var getNodesTree = function getNodesTree(_ref, width, nodeWidth) {
	  var nodes = _ref.nodes,
	      links = _ref.links;
	  var tree = nodes.map(function (entry, index) {
	    var result = searchTargetsAndSources(links, index);
	    return _objectSpread({}, entry, {}, result, {
	      value: Math.max(getSumOfIds(links, result.sourceLinks), getSumOfIds(links, result.targetLinks)),
	      depth: 0
	    });
	  });
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!node.sourceNodes.length) {
	      updateDepthOfTargets(tree, node);
	    }
	  }
	
	  var maxDepth = (0, _maxBy2["default"])(tree, function (entry) {
	    return entry.depth;
	  }).depth;
	
	  if (maxDepth >= 1) {
	    var childWidth = (width - nodeWidth) / maxDepth;
	
	    for (var _i = 0, _len = tree.length; _i < _len; _i++) {
	      var _node = tree[_i];
	
	      if (!_node.targetNodes.length) {
	        _node.depth = maxDepth;
	      }
	
	      _node.x = _node.depth * childWidth;
	      _node.dx = nodeWidth;
	    }
	  }
	
	  return {
	    tree: tree,
	    maxDepth: maxDepth
	  };
	};
	
	var getDepthTree = function getDepthTree(tree) {
	  var result = [];
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!result[node.depth]) {
	      result[node.depth] = [];
	    }
	
	    result[node.depth].push(node);
	  }
	
	  return result;
	};
	
	var updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
	  var yRatio = (0, _min2["default"])(depthTree.map(function (nodes) {
	    return (height - (nodes.length - 1) * nodePadding) / (0, _sumBy2["default"])(nodes, getValue);
	  }));
	
	  for (var d = 0, maxDepth = depthTree.length; d < maxDepth; d++) {
	    for (var i = 0, len = depthTree[d].length; i < len; i++) {
	      var node = depthTree[d][i];
	      node.y = i;
	      node.dy = node.value * yRatio;
	    }
	  }
	
	  return links.map(function (link) {
	    return _objectSpread({}, link, {
	      dy: getValue(link) * yRatio
	    });
	  });
	};
	
	var resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
	  for (var i = 0, len = depthTree.length; i < len; i++) {
	    var nodes = depthTree[i];
	    var n = nodes.length; // Sort by the value of y
	
	    nodes.sort(ascendingY);
	    var y0 = 0;
	
	    for (var j = 0; j < n; j++) {
	      var node = nodes[j];
	      var dy = y0 - node.y;
	
	      if (dy > 0) {
	        node.y += dy;
	      }
	
	      y0 = node.y + node.dy + nodePadding;
	    }
	
	    y0 = height + nodePadding;
	
	    for (var _j = n - 1; _j >= 0; _j--) {
	      var _node2 = nodes[_j];
	
	      var _dy = _node2.y + _node2.dy + nodePadding - y0;
	
	      if (_dy > 0) {
	        _node2.y -= _dy;
	        y0 = _node2.y;
	      } else {
	        break;
	      }
	    }
	  }
	};
	
	var relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
	  for (var i = 0, maxDepth = depthTree.length; i < maxDepth; i++) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.sourceLinks.length) {
	        var sourceSum = getSumOfIds(links, node.sourceLinks);
	        var weightedSum = getSumWithWeightedSource(tree, links, node.sourceLinks);
	        var y = weightedSum / sourceSum;
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	
	var relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
	  for (var i = depthTree.length - 1; i >= 0; i--) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.targetLinks.length) {
	        var targetSum = getSumOfIds(links, node.targetLinks);
	        var weightedSum = getSumWithWeightedTarget(tree, links, node.targetLinks);
	        var y = weightedSum / targetSum;
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	
	var updateYOfLinks = function updateYOfLinks(tree, links) {
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	    var sy = 0;
	    var ty = 0;
	    node.targetLinks.sort(function (a, b) {
	      return tree[links[a].target].y - tree[links[b].target].y;
	    });
	    node.sourceLinks.sort(function (a, b) {
	      return tree[links[a].source].y - tree[links[b].source].y;
	    });
	
	    for (var j = 0, tLen = node.targetLinks.length; j < tLen; j++) {
	      var link = links[node.targetLinks[j]];
	
	      if (link) {
	        link.sy = sy;
	        sy += link.dy;
	      }
	    }
	
	    for (var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++) {
	      var _link = links[node.sourceLinks[_j2]];
	
	      if (_link) {
	        _link.ty = ty;
	        ty += _link.dy;
	      }
	    }
	  }
	};
	
	var computeData = function computeData(_ref2) {
	  var data = _ref2.data,
	      width = _ref2.width,
	      height = _ref2.height,
	      iterations = _ref2.iterations,
	      nodeWidth = _ref2.nodeWidth,
	      nodePadding = _ref2.nodePadding;
	  var links = data.links;
	
	  var _getNodesTree = getNodesTree(data, width, nodeWidth),
	      tree = _getNodesTree.tree;
	
	  var depthTree = getDepthTree(tree);
	  var newLinks = updateYOfTree(depthTree, height, nodePadding, links);
	  resolveCollisions(depthTree, height, nodePadding);
	  var alpha = 1;
	
	  for (var i = 1; i <= iterations; i++) {
	    relaxRightToLeft(tree, depthTree, newLinks, alpha *= 0.99);
	    resolveCollisions(depthTree, height, nodePadding);
	    relaxLeftToRight(tree, depthTree, newLinks, alpha);
	    resolveCollisions(depthTree, height, nodePadding);
	  }
	
	  updateYOfLinks(tree, newLinks);
	  return {
	    nodes: tree,
	    links: newLinks
	  };
	};
	
	var getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
	  if (type === 'node') {
	    return {
	      x: el.x + el.width / 2,
	      y: el.y + el.height / 2
	    };
	  }
	
	  return {
	    x: (el.sourceX + el.targetX) / 2,
	    y: (el.sourceY + el.targetY) / 2
	  };
	};
	
	var getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
	  var payload = el.payload;
	
	  if (type === 'node') {
	    return [{
	      payload: el,
	      name: (0, _ChartUtils.getValueByDataKey)(payload, nameKey, ''),
	      value: (0, _ChartUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	
	  if (payload.source && payload.target) {
	    var sourceName = (0, _ChartUtils.getValueByDataKey)(payload.source, nameKey, '');
	    var targetName = (0, _ChartUtils.getValueByDataKey)(payload.target, nameKey, '');
	    return [{
	      payload: el,
	      name: "".concat(sourceName, " - ").concat(targetName),
	      value: (0, _ChartUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	
	  return [];
	};
	
	var Sankey =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Sankey, _PureComponent);
	
	  function Sankey(props) {
	    var _this;
	
	    _classCallCheck(this, Sankey);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sankey).call(this, props));
	    _this.state = _this.constructor.createDefaultState(props);
	    return _this;
	  } // eslint-disable-next-line camelcase
	
	
	  _createClass(Sankey, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          data = _this$props.data,
	          width = _this$props.width,
	          height = _this$props.height,
	          margin = _this$props.margin,
	          iterations = _this$props.iterations,
	          nodeWidth = _this$props.nodeWidth,
	          nodePadding = _this$props.nodePadding,
	          nameKey = _this$props.nameKey;
	
	      if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || !(0, _ShallowEqual.shallowEqual)(nextProps.margin, margin) || nextProps.iterations !== iterations || nextProps.nodeWidth !== nodeWidth || nextProps.nodePadding !== nodePadding || nextProps.nameKey !== nameKey) {
	        this.setState(this.constructor.createDefaultState(nextProps));
	      }
	    }
	    /**
	     * Returns default, reset state for the sankey chart.
	     * @param  {Object} props The latest props
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: "handleMouseEnter",
	    value: function handleMouseEnter(el, type, e) {
	      var _this$props2 = this.props,
	          onMouseEnter = _this$props2.onMouseEnter,
	          children = _this$props2.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (tooltipItem) {
	        this.setState({
	          activeElement: el,
	          activeElementType: type,
	          isTooltipActive: true
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(el, type, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(el, type, e);
	      }
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave(el, type, e) {
	      var _this$props3 = this.props,
	          onMouseLeave = _this$props3.onMouseLeave,
	          children = _this$props3.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(el, type, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(el, type, e);
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(el, type, e) {
	      var onClick = this.props.onClick;
	      if (onClick) onClick(el, type, e);
	    }
	  }, {
	    key: "renderLinks",
	    value: function renderLinks(links, nodes) {
	      var _this2 = this;
	
	      var _this$props4 = this.props,
	          linkCurvature = _this$props4.linkCurvature,
	          linkContent = _this$props4.link,
	          margin = _this$props4.margin;
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-sankey-links",
	        key: "recharts-sankey-links"
	      }, links.map(function (link, i) {
	        var sourceRelativeY = link.sy,
	            targetRelativeY = link.ty,
	            linkWidth = link.dy;
	        var source = nodes[link.source];
	        var target = nodes[link.target];
	        var sourceX = source.x + source.dx + left;
	        var targetX = target.x + left;
	        var interpolationFunc = interpolationGenerator(sourceX, targetX);
	        var sourceControlX = interpolationFunc(linkCurvature);
	        var targetControlX = interpolationFunc(1 - linkCurvature);
	        var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
	        var targetY = target.y + targetRelativeY + linkWidth / 2 + top;
	
	        var linkProps = _objectSpread({
	          sourceX: sourceX,
	          targetX: targetX,
	          sourceY: sourceY,
	          targetY: targetY,
	          sourceControlX: sourceControlX,
	          targetControlX: targetControlX,
	          sourceRelativeY: sourceRelativeY,
	          targetRelativeY: targetRelativeY,
	          linkWidth: linkWidth,
	          index: i,
	          payload: _objectSpread({}, link, {
	            source: source,
	            target: target
	          })
	        }, (0, _ReactUtils.getPresentationAttributes)(linkContent));
	
	        var events = {
	          onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
	          onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link'),
	          onClick: _this2.handleClick.bind(_this2, linkProps, 'link')
	        };
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement(_Layer["default"], _extends({
	            key: "link".concat(i)
	          }, events), _this2.constructor.renderLinkItem(linkContent, linkProps))
	        );
	      }));
	    }
	  }, {
	    key: "renderNodes",
	    value: function renderNodes(nodes) {
	      var _this3 = this;
	
	      var _this$props5 = this.props,
	          nodeContent = _this$props5.node,
	          margin = _this$props5.margin;
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-sankey-nodes",
	        key: "recharts-sankey-nodes"
	      }, nodes.map(function (node, i) {
	        var x = node.x,
	            y = node.y,
	            dx = node.dx,
	            dy = node.dy;
	
	        var nodeProps = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(nodeContent), {
	          x: x + left,
	          y: y + top,
	          width: dx,
	          height: dy,
	          index: i,
	          payload: node
	        });
	
	        var events = {
	          onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
	          onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node'),
	          onClick: _this3.handleClick.bind(_this3, nodeProps, 'node')
	        };
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement(_Layer["default"], _extends({
	            key: "node".concat(i)
	          }, events), _this3.constructor.renderNodeItem(nodeContent, nodeProps))
	        );
	      }));
	    }
	  }, {
	    key: "renderTooltip",
	    value: function renderTooltip() {
	      var _this$props6 = this.props,
	          children = _this$props6.children,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          nameKey = _this$props6.nameKey;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _this$state = this.state,
	          isTooltipActive = _this$state.isTooltipActive,
	          activeElement = _this$state.activeElement,
	          activeElementType = _this$state.activeElementType;
	      var viewBox = {
	        x: 0,
	        y: 0,
	        width: width,
	        height: height
	      };
	      var coordinate = activeElement ? getCoordinateOfTooltip(activeElement, activeElementType) : defaultCoordinateOfTooltip;
	      var payload = activeElement ? getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];
	      return _react["default"].cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _this$props7 = this.props,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          className = _this$props7.className,
	          style = _this$props7.style,
	          children = _this$props7.children,
	          others = _objectWithoutProperties(_this$props7, ["width", "height", "className", "style", "children"]);
	
	      var _this$state2 = this.state,
	          links = _this$state2.links,
	          nodes = _this$state2.nodes;
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])('recharts-wrapper', className),
	        style: _objectSpread({}, style, {
	          position: 'relative',
	          cursor: 'default',
	          width: width,
	          height: height
	        })
	      }, _react["default"].createElement(_Surface["default"], _extends({}, attrs, {
	        width: width,
	        height: height
	      }), (0, _ReactUtils.filterSvgElements)(children), this.renderLinks(links, nodes), this.renderNodes(nodes)), this.renderTooltip());
	    }
	  }], [{
	    key: "createDefaultState",
	    value: function createDefaultState(props) {
	      var data = props.data,
	          width = props.width,
	          height = props.height,
	          margin = props.margin,
	          iterations = props.iterations,
	          nodeWidth = props.nodeWidth,
	          nodePadding = props.nodePadding;
	      var contentWidth = width - (margin && margin.left || 0) - (margin && margin.right || 0);
	      var contentHeight = height - (margin && margin.top || 0) - (margin && margin.bottom || 0);
	
	      var _computeData = computeData({
	        data: data,
	        width: contentWidth,
	        height: contentHeight,
	        iterations: iterations,
	        nodeWidth: nodeWidth,
	        nodePadding: nodePadding
	      }),
	          links = _computeData.links,
	          nodes = _computeData.nodes;
	
	      return {
	        activeElement: null,
	        activeElementType: null,
	        isTooltipActive: false,
	        nodes: nodes,
	        links: links
	      };
	    }
	  }, {
	    key: "renderLinkItem",
	    value: function renderLinkItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      var sourceX = props.sourceX,
	          sourceY = props.sourceY,
	          sourceControlX = props.sourceControlX,
	          targetX = props.targetX,
	          targetY = props.targetY,
	          targetControlX = props.targetControlX,
	          linkWidth = props.linkWidth,
	          others = _objectWithoutProperties(props, ["sourceX", "sourceY", "sourceControlX", "targetX", "targetY", "targetControlX", "linkWidth"]);
	
	      return _react["default"].createElement("path", _extends({
	        className: "recharts-sankey-link",
	        d: "\n          M".concat(sourceX, ",").concat(sourceY, "\n          C").concat(sourceControlX, ",").concat(sourceY, " ").concat(targetControlX, ",").concat(targetY, " ").concat(targetX, ",").concat(targetY, "\n        "),
	        fill: "none",
	        stroke: "#333",
	        strokeWidth: linkWidth,
	        strokeOpacity: "0.2"
	      }, (0, _ReactUtils.getPresentationAttributes)(others)));
	    }
	  }, {
	    key: "renderNodeItem",
	    value: function renderNodeItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      return _react["default"].createElement(_Rectangle["default"], _extends({
	        className: "recharts-sankey-node",
	        fill: "#0088fe",
	        fillOpacity: "0.8"
	      }, props));
	    }
	  }]);
	
	  return Sankey;
	}(_react.PureComponent);
	
	Sankey.displayName = 'Sankey';
	Sankey.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  nameKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  data: _propTypes["default"].shape({
	    nodes: _propTypes["default"].array,
	    links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	      target: _propTypes["default"].number,
	      source: _propTypes["default"].number,
	      value: _propTypes["default"].number
	    }))
	  }),
	  nodePadding: _propTypes["default"].number,
	  nodeWidth: _propTypes["default"].number,
	  linkCurvature: _propTypes["default"].number,
	  iterations: _propTypes["default"].number,
	  node: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func]),
	  link: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func]),
	  style: _propTypes["default"].object,
	  className: _propTypes["default"].string,
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
	  margin: _propTypes["default"].shape({
	    top: _propTypes["default"].number,
	    right: _propTypes["default"].number,
	    bottom: _propTypes["default"].number,
	    left: _propTypes["default"].number
	  })
	});
	Sankey.defaultProps = {
	  nodePadding: 10,
	  nodeWidth: 10,
	  nameKey: 'name',
	  dataKey: 'value',
	  linkCurvature: 0.5,
	  iterations: 32,
	  margin: {
	    top: 5,
	    right: 5,
	    bottom: 5,
	    left: 5
	  }
	};
	var _default = Sankey;
	exports["default"] = _default;

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(170));
	
	var _Scatter = _interopRequireDefault(__webpack_require__(546));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(254));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(255));
	
	var _ZAxis = _interopRequireDefault(__webpack_require__(386));
	
	var _CartesianUtils = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Scatter Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'ScatterChart',
	  GraphicalChild: _Scatter["default"],
	  eventType: 'single',
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }, {
	    axisType: 'zAxis',
	    AxisComp: _ZAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _get2 = _interopRequireDefault(__webpack_require__(207));
	
	var _omit2 = _interopRequireDefault(__webpack_require__(730));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(355));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(129));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _Surface = _interopRequireDefault(__webpack_require__(308));
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(258));
	
	var _ReactUtils = __webpack_require__(43);
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(387));
	
	var _Polygon = _interopRequireDefault(__webpack_require__(390));
	
	var _ChartUtils = __webpack_require__(103);
	
	var _Constants = __webpack_require__(1957);
	
	var _DOMUtils = __webpack_require__(392);
	
	var _DataUtils = __webpack_require__(66);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var computeNode = function computeNode(_ref) {
	  var depth = _ref.depth,
	      node = _ref.node,
	      index = _ref.index,
	      valueKey = _ref.valueKey;
	  var children = node.children;
	  var childDepth = depth + 1;
	  var computedChildren = children && children.length ? children.map(function (child, i) {
	    return computeNode({
	      depth: childDepth,
	      node: child,
	      index: i,
	      valueKey: valueKey
	    });
	  }) : null;
	  var value;
	
	  if (children && children.length) {
	    value = computedChildren.reduce(function (result, child) {
	      return result + child.value;
	    }, 0);
	  } else {
	    value = (0, _isNaN2["default"])(node[valueKey]) || node[valueKey] <= 0 ? 0 : node[valueKey];
	  }
	
	  return _objectSpread({}, node, {
	    children: computedChildren,
	    value: value,
	    depth: depth,
	    index: index
	  });
	};
	
	var filterRect = function filterRect(node) {
	  return {
	    x: node.x,
	    y: node.y,
	    width: node.width,
	    height: node.height
	  };
	}; // Compute the area for each child based on value & scale.
	
	
	var getAreaOfChildren = function getAreaOfChildren(children, areaValueRatio) {
	  var ratio = areaValueRatio < 0 ? 0 : areaValueRatio;
	  return children.map(function (child) {
	    var area = child.value * ratio;
	    return _objectSpread({}, child, {
	      area: (0, _isNaN2["default"])(area) || area <= 0 ? 0 : area
	    });
	  });
	}; // Computes the score for the specified row, as the worst aspect ratio.
	
	
	var getWorstScore = function getWorstScore(row, parentSize, aspectRatio) {
	  var parentArea = parentSize * parentSize;
	  var rowArea = row.area * row.area;
	
	  var _row$reduce = row.reduce(function (result, child) {
	    return {
	      min: Math.min(result.min, child.area),
	      max: Math.max(result.max, child.area)
	    };
	  }, {
	    min: Infinity,
	    max: 0
	  }),
	      min = _row$reduce.min,
	      max = _row$reduce.max;
	
	  return rowArea ? Math.max(parentArea * max * aspectRatio / rowArea, rowArea / (parentArea * min * aspectRatio)) : Infinity;
	};
	
	var horizontalPosition = function horizontalPosition(row, parentSize, parentRect, isFlush) {
	  var rowHeight = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowHeight > parentRect.height) {
	    rowHeight = parentRect.height;
	  }
	
	  var curX = parentRect.x;
	  var child;
	
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = curX;
	    child.y = parentRect.y;
	    child.height = rowHeight;
	    child.width = Math.min(rowHeight ? Math.round(child.area / rowHeight) : 0, parentRect.x + parentRect.width - curX);
	    curX += child.width;
	  } // what's z
	
	
	  child.z = true; // add the remain x to the last one of row
	
	  child.width += parentRect.x + parentRect.width - curX;
	  return _objectSpread({}, parentRect, {
	    y: parentRect.y + rowHeight,
	    height: parentRect.height - rowHeight
	  });
	};
	
	var verticalPosition = function verticalPosition(row, parentSize, parentRect, isFlush) {
	  var rowWidth = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowWidth > parentRect.width) {
	    rowWidth = parentRect.width;
	  }
	
	  var curY = parentRect.y;
	  var child;
	
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = parentRect.x;
	    child.y = curY;
	    child.width = rowWidth;
	    child.height = Math.min(rowWidth ? Math.round(child.area / rowWidth) : 0, parentRect.y + parentRect.height - curY);
	    curY += child.height;
	  }
	
	  child.z = false;
	  child.height += parentRect.y + parentRect.height - curY;
	  return _objectSpread({}, parentRect, {
	    x: parentRect.x + rowWidth,
	    width: parentRect.width - rowWidth
	  });
	};
	
	var position = function position(row, parentSize, parentRect, isFlush) {
	  if (parentSize === parentRect.width) {
	    return horizontalPosition(row, parentSize, parentRect, isFlush);
	  }
	
	  return verticalPosition(row, parentSize, parentRect, isFlush);
	}; // Recursively arranges the specified node's children into squarified rows.
	
	
	var squarify = function squarify(node, aspectRatio) {
	  var children = node.children;
	
	  if (children && children.length) {
	    var rect = filterRect(node);
	    var row = [];
	    var best = Infinity; // the best row score so far
	
	    var child, score; // the current row score
	
	    var size = Math.min(rect.width, rect.height); // initial orientation
	
	    var scaleChildren = getAreaOfChildren(children, rect.width * rect.height / node.value);
	    var tempChildren = scaleChildren.slice();
	    row.area = 0;
	
	    while (tempChildren.length > 0) {
	      // row first
	      // eslint-disable-next-line prefer-destructuring
	      row.push(child = tempChildren[0]);
	      row.area += child.area;
	      score = getWorstScore(row, size, aspectRatio);
	
	      if (score <= best) {
	        // continue with this orientation
	        tempChildren.shift();
	        best = score;
	      } else {
	        // abort, and try a different orientation
	        row.area -= row.pop().area;
	        rect = position(row, size, rect, false);
	        size = Math.min(rect.width, rect.height);
	        row.length = row.area = 0;
	        best = Infinity;
	      }
	    }
	
	    if (row.length) {
	      rect = position(row, size, rect, true);
	      row.length = row.area = 0;
	    }
	
	    return _objectSpread({}, node, {
	      children: scaleChildren.map(function (c) {
	        return squarify(c, aspectRatio);
	      })
	    });
	  }
	
	  return node;
	};
	
	var Treemap =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Treemap, _PureComponent);
	
	  function Treemap() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Treemap);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Treemap)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = _this.constructor.createDefaultState();
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Treemap, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props = this.props,
	          type = _this$props.type,
	          width = _this$props.width,
	          height = _this$props.height,
	          data = _this$props.data,
	          dataKey = _this$props.dataKey,
	          aspectRatio = _this$props.aspectRatio;
	
	      var _this$computeRoot = this.computeRoot({
	        type: type,
	        width: width,
	        height: height,
	        data: data,
	        dataKey: dataKey,
	        aspectRatio: aspectRatio
	      }),
	          formatRoot = _this$computeRoot.formatRoot,
	          currentRoot = _this$computeRoot.currentRoot,
	          nestIndex = _this$computeRoot.nestIndex;
	
	      this.setState({
	        formatRoot: formatRoot,
	        currentRoot: currentRoot,
	        nestIndex: nestIndex
	      });
	    }
	  }, {
	    key: "computeRoot",
	    value: function computeRoot(_ref2) {
	      var type = _ref2.type,
	          width = _ref2.width,
	          height = _ref2.height,
	          data = _ref2.data,
	          dataKey = _ref2.dataKey,
	          aspectRatio = _ref2.aspectRatio;
	      var root = computeNode({
	        depth: 0,
	        node: {
	          children: data,
	          x: 0,
	          y: 0,
	          width: width,
	          height: height
	        },
	        index: 0,
	        valueKey: dataKey
	      });
	      var formatRoot = squarify(root, aspectRatio);
	      var nestIndex = this.state.nestIndex;
	
	      if (type === 'nest') {
	        nestIndex.push(root);
	      }
	
	      return {
	        formatRoot: formatRoot,
	        currentRoot: root,
	        nestIndex: nestIndex
	      };
	    } // eslint-disable-next-line camelcase
	
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var type = nextProps.type,
	          width = nextProps.width,
	          height = nextProps.height,
	          data = nextProps.data,
	          dataKey = nextProps.dataKey,
	          aspectRatio = nextProps.aspectRatio;
	
	      if (data !== this.props.data || type !== this.props.type || width !== this.props.width || height !== this.props.height || dataKey !== this.props.dataKey || aspectRatio !== this.props.aspectRatio) {
	        var nextRoot = this.computeRoot({
	          type: type,
	          width: width,
	          height: height,
	          data: data,
	          dataKey: dataKey,
	          aspectRatio: aspectRatio
	        });
	        this.setState(_objectSpread({}, this.constructor.createDefaultState(), {}, nextRoot, {
	          nestIndex: [nextRoot.currentRoot]
	        }));
	      }
	    }
	    /**
	     * Returns default, reset state for the treemap chart.
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: "handleMouseEnter",
	    value: function handleMouseEnter(node, e) {
	      var _this$props2 = this.props,
	          onMouseEnter = _this$props2.onMouseEnter,
	          children = _this$props2.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: true,
	          activeNode: node
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(node, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(node, e);
	      }
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave(node, e) {
	      var _this$props3 = this.props,
	          onMouseLeave = _this$props3.onMouseLeave,
	          children = _this$props3.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false,
	          activeNode: null
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(node, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(node, e);
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(node) {
	      var _this$props4 = this.props,
	          onClick = _this$props4.onClick,
	          type = _this$props4.type;
	
	      if (type === 'nest' && node.children) {
	        var _this$props5 = this.props,
	            width = _this$props5.width,
	            height = _this$props5.height,
	            dataKey = _this$props5.dataKey,
	            aspectRatio = _this$props5.aspectRatio;
	        var root = computeNode({
	          depth: 0,
	          node: _objectSpread({}, node, {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          }),
	          index: 0,
	          valueKey: dataKey
	        });
	        var formatRoot = squarify(root, aspectRatio);
	        var nestIndex = this.state.nestIndex;
	        nestIndex.push(node);
	        this.setState({
	          formatRoot: formatRoot,
	          currentRoot: root,
	          nestIndex: nestIndex
	        });
	      }
	
	      if (onClick) {
	        onClick(node);
	      }
	    }
	  }, {
	    key: "handleNestIndex",
	    value: function handleNestIndex(node, i) {
	      var nestIndex = this.state.nestIndex;
	      var _this$props6 = this.props,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          dataKey = _this$props6.dataKey,
	          aspectRatio = _this$props6.aspectRatio;
	      var root = computeNode({
	        depth: 0,
	        node: _objectSpread({}, node, {
	          x: 0,
	          y: 0,
	          width: width,
	          height: height
	        }),
	        index: 0,
	        valueKey: dataKey
	      });
	      var formatRoot = squarify(root, aspectRatio);
	      nestIndex = nestIndex.slice(0, i + 1);
	      this.setState({
	        formatRoot: formatRoot,
	        currentRoot: node,
	        nestIndex: nestIndex
	      });
	    }
	  }, {
	    key: "renderItem",
	    value: function renderItem(content, nodeProps, isLeaf) {
	      var _this2 = this;
	
	      var _this$props7 = this.props,
	          isAnimationActive = _this$props7.isAnimationActive,
	          animationBegin = _this$props7.animationBegin,
	          animationDuration = _this$props7.animationDuration,
	          animationEasing = _this$props7.animationEasing,
	          isUpdateAnimationActive = _this$props7.isUpdateAnimationActive,
	          type = _this$props7.type,
	          animationId = _this$props7.animationId,
	          colorPanel = _this$props7.colorPanel;
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var width = nodeProps.width,
	          height = nodeProps.height,
	          x = nodeProps.x,
	          y = nodeProps.y,
	          depth = nodeProps.depth;
	      var translateX = parseInt((Math.random() * 2 - 1) * width, 10);
	      var event = {};
	
	      if (isLeaf || type === 'nest') {
	        event = {
	          onMouseEnter: this.handleMouseEnter.bind(this, nodeProps),
	          onMouseLeave: this.handleMouseLeave.bind(this, nodeProps),
	          onClick: this.handleClick.bind(this, nodeProps)
	        };
	      }
	
	      if (!isAnimationActive) {
	        return _react["default"].createElement(_Layer["default"], event, this.constructor.renderContentItem(content, _objectSpread({}, nodeProps, {
	          isAnimationActive: false,
	          isUpdateAnimationActive: false,
	          width: width,
	          height: height,
	          x: x,
	          y: y
	        }), type, colorPanel));
	      }
	
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        key: "treemap-".concat(animationId),
	        from: {
	          x: x,
	          y: y,
	          width: width,
	          height: height
	        },
	        to: {
	          x: x,
	          y: y,
	          width: width,
	          height: height
	        },
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref3) {
	        var currX = _ref3.x,
	            currY = _ref3.y,
	            currWidth = _ref3.width,
	            currHeight = _ref3.height;
	        return _react["default"].createElement(_reactSmooth["default"], {
	          from: "translate(".concat(translateX, "px, ").concat(translateX, "px)"),
	          to: "translate(0, 0)",
	          attributeName: "transform",
	          begin: animationBegin,
	          easing: animationEasing,
	          isActive: isAnimationActive,
	          duration: animationDuration
	        }, _react["default"].createElement(_Layer["default"], event, function () {
	          // when animation Duration , only render depth=1 nodes
	          if (depth > 2 && !isAnimationFinished) {
	            return null;
	          }
	
	          return _this2.constructor.renderContentItem(content, _objectSpread({}, nodeProps, {
	            isAnimationActive: isAnimationActive,
	            isUpdateAnimationActive: !isUpdateAnimationActive,
	            width: currWidth,
	            height: currHeight,
	            x: currX,
	            y: currY
	          }), type, colorPanel);
	        }()));
	      });
	    }
	  }, {
	    key: "renderNode",
	    value: function renderNode(root, node, i) {
	      var _this3 = this;
	
	      var _this$props8 = this.props,
	          content = _this$props8.content,
	          type = _this$props8.type;
	
	      var nodeProps = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {}, node, {
	        root: root
	      });
	
	      var isLeaf = !node.children || !node.children.length;
	      var currentRoot = this.state.currentRoot;
	      var isCurrentRootChild = (currentRoot.children || []).filter(function (item) {
	        return item.depth === node.depth && item.name === node.name;
	      });
	
	      if (!isCurrentRootChild.length && root.depth && type === 'nest') {
	        return null;
	      }
	
	      return (// eslint-disable-next-line react/no-array-index-key
	        _react["default"].createElement(_Layer["default"], {
	          key: "recharts-treemap-node-".concat(i),
	          className: "recharts-treemap-depth-".concat(node.depth)
	        }, this.renderItem(content, nodeProps, isLeaf), node.children && node.children.length ? node.children.map(function (child, index) {
	          return _this3.renderNode(node, child, index);
	        }) : null)
	      );
	    }
	  }, {
	    key: "renderAllNodes",
	    value: function renderAllNodes() {
	      var formatRoot = this.state.formatRoot;
	
	      if (!formatRoot) {
	        return null;
	      }
	
	      return this.renderNode(formatRoot, formatRoot, 0);
	    }
	  }, {
	    key: "renderTooltip",
	    value: function renderTooltip() {
	      var _this$props9 = this.props,
	          children = _this$props9.children,
	          nameKey = _this$props9.nameKey;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _this$props10 = this.props,
	          width = _this$props10.width,
	          height = _this$props10.height,
	          dataKey = _this$props10.dataKey;
	      var _this$state = this.state,
	          isTooltipActive = _this$state.isTooltipActive,
	          activeNode = _this$state.activeNode;
	      var viewBox = {
	        x: 0,
	        y: 0,
	        width: width,
	        height: height
	      };
	      var coordinate = activeNode ? {
	        x: activeNode.x + activeNode.width / 2,
	        y: activeNode.y + activeNode.height / 2
	      } : null;
	      var payload = isTooltipActive && activeNode ? [{
	        payload: activeNode,
	        name: (0, _ChartUtils.getValueByDataKey)(activeNode, nameKey, ''),
	        value: (0, _ChartUtils.getValueByDataKey)(activeNode, dataKey)
	      }] : [];
	      return _react["default"].cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    } // render nest treemap
	
	  }, {
	    key: "renderNestIndex",
	    value: function renderNestIndex() {
	      var _this4 = this;
	
	      var _this$props11 = this.props,
	          nameKey = _this$props11.nameKey,
	          nestIndexContent = _this$props11.nestIndexContent;
	      var nestIndex = this.state.nestIndex;
	      return _react["default"].createElement("div", {
	        className: "recharts-treemap-nest-index-wrapper",
	        style: {
	          marginTop: '8px',
	          textAlign: 'center'
	        }
	      }, nestIndex.map(function (item, i) {
	        var name = (0, _get2["default"])(item, nameKey, 'root');
	        var content = null;
	
	        if (_react["default"].isValidElement(nestIndexContent)) {
	          content = _react["default"].cloneElement(nestIndexContent, item, i);
	        }
	
	        if ((0, _isFunction2["default"])(nestIndexContent)) {
	          content = nestIndexContent(item, i);
	        } else {
	          content = name;
	        }
	
	        return (// eslint-disable-next-line jsx-a11y/click-events-have-key-events
	          _react["default"].createElement("div", {
	            onClick: _this4.handleNestIndex.bind(_this4, item, i),
	            key: "nest-index-".concat((0, _DataUtils.uniqueId)()),
	            className: "recharts-treemap-nest-index-box",
	            style: {
	              cursor: 'pointer',
	              display: 'inline-block',
	              padding: '0 7px',
	              background: '#000',
	              color: '#fff',
	              marginRight: '3px'
	            }
	          }, content)
	        );
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _this$props12 = this.props,
	          width = _this$props12.width,
	          height = _this$props12.height,
	          className = _this$props12.className,
	          style = _this$props12.style,
	          children = _this$props12.children,
	          type = _this$props12.type,
	          others = _objectWithoutProperties(_this$props12, ["width", "height", "className", "style", "children", "type"]);
	
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])('recharts-wrapper', className),
	        style: _objectSpread({}, style, {
	          position: 'relative',
	          cursor: 'default',
	          width: width,
	          height: height
	        })
	      }, _react["default"].createElement(_Surface["default"], _extends({}, attrs, {
	        width: width,
	        height: type === 'nest' ? height - 30 : height
	      }), this.renderAllNodes(), (0, _ReactUtils.filterSvgElements)(children)), this.renderTooltip(), type === 'nest' && this.renderNestIndex());
	    }
	  }], [{
	    key: "createDefaultState",
	    value: function createDefaultState() {
	      return {
	        isTooltipActive: false,
	        isAnimationFinished: false,
	        activeNode: null,
	        currentRoot: null,
	        formatRoot: null,
	        nestIndex: []
	      };
	    }
	  }, {
	    key: "renderContentItem",
	    value: function renderContentItem(content, nodeProps, type, colorPanel) {
	      if (_react["default"].isValidElement(content)) {
	        return _react["default"].cloneElement(content, nodeProps);
	      }
	
	      if ((0, _isFunction2["default"])(content)) {
	        return content(nodeProps);
	      } // optimize default shape
	
	
	      var x = nodeProps.x,
	          y = nodeProps.y,
	          width = nodeProps.width,
	          height = nodeProps.height,
	          index = nodeProps.index;
	      var arrow = null;
	
	      if (width > 10 && height > 10 && nodeProps.children && type === 'nest') {
	        arrow = _react["default"].createElement(_Polygon["default"], {
	          points: [{
	            x: x + 2,
	            y: y + height / 2
	          }, {
	            x: x + 6,
	            y: y + height / 2 + 3
	          }, {
	            x: x + 2,
	            y: y + height / 2 + 6
	          }]
	        });
	      }
	
	      var text = null;
	      var nameSize = (0, _DOMUtils.getStringSize)(nodeProps.name);
	
	      if (width > 20 && height > 20 && nameSize.width < width && nameSize.height < height) {
	        text = _react["default"].createElement("text", {
	          x: x + 8,
	          y: y + height / 2 + 7,
	          fontSize: 14
	        }, nodeProps.name);
	      }
	
	      var colors = colorPanel || _Constants.COLOR_PANEL;
	      return _react["default"].createElement("g", null, _react["default"].createElement(_Rectangle["default"], _extends({
	        fill: nodeProps.depth < 2 ? colors[index % colors.length] : 'rgba(255,255,255,0)',
	        stroke: "#fff"
	      }, (0, _omit2["default"])(nodeProps, 'children'))), arrow, text);
	    }
	  }]);
	
	  return Treemap;
	}(_react.PureComponent);
	
	Treemap.displayName = 'Treemap';
	Treemap.propTypes = {
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  data: _propTypes["default"].array,
	  animationId: _propTypes["default"].number,
	  style: _propTypes["default"].object,
	  aspectRatio: _propTypes["default"].number,
	  content: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  fill: _propTypes["default"].string,
	  stroke: _propTypes["default"].string,
	  className: _propTypes["default"].string,
	  nameKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
	  // optional values flat/nest, flat show whole treemap, nest only show depth=1 node
	  type: _propTypes["default"].oneOf(['flat', 'nest']),
	  colorPanel: _propTypes["default"].array,
	  // customize nest index content
	  nestIndexContent: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  isUpdateAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	};
	Treemap.defaultProps = {
	  dataKey: 'value',
	  aspectRatio: 0.5 * (1 + Math.sqrt(5)),
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  isUpdateAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'linear',
	  type: 'flat'
	};
	var _default = Treemap;
	exports["default"] = _default;

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Customized;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(55));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Layer = _interopRequireDefault(__webpack_require__(81));
	
	var _LogUtils = __webpack_require__(259);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	/**
	 * custom svg elements by rechart instance props and state.
	 * @returns {Object}   svg elements
	 */
	function Customized(_ref) {
	  var component = _ref.component,
	      props = _objectWithoutProperties(_ref, ["component"]);
	
	  var child;
	
	  if ((0, _react.isValidElement)(component)) {
	    child = (0, _react.cloneElement)(component, props);
	  } else if ((0, _isFunction2["default"])(component)) {
	    child = component(props);
	  } else {
	    (0, _LogUtils.warn)(false, 'Customized\'s props `component` must be React.element or Function, but got %s.', _typeof(component));
	  }
	
	  return _react["default"].createElement(_Layer["default"], {
	    className: "recharts-customized-wrapper"
	  }, child);
	}
	
	Customized.displayName = 'Customized';
	Customized.propTypes = {
	  component: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]).isRequired
	};

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _Surface = _interopRequireDefault(__webpack_require__(308));
	
	var _Symbols = _interopRequireDefault(__webpack_require__(549));
	
	var _ReactUtils = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var SIZE = 32;
	
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var DefaultLegendContent =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(DefaultLegendContent, _PureComponent);
	
	  function DefaultLegendContent() {
	    _classCallCheck(this, DefaultLegendContent);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultLegendContent).apply(this, arguments));
	  }
	
	  _createClass(DefaultLegendContent, [{
	    key: "renderIcon",
	
	    /**
	     * Render the path of icon
	     * @param {Object} data Data of each legend item
	     * @return {String} Path element
	     */
	    value: function renderIcon(data) {
	      var inactiveColor = this.props.inactiveColor;
	      var halfSize = SIZE / 2;
	      var sixthSize = SIZE / 6;
	      var thirdSize = SIZE / 3;
	      var color = data.inactive ? inactiveColor : data.color;
	
	      if (data.type === 'plainline') {
	        return _react["default"].createElement("line", {
	          strokeWidth: 4,
	          fill: "none",
	          stroke: color,
	          strokeDasharray: data.payload.strokeDasharray,
	          x1: 0,
	          y1: halfSize,
	          x2: SIZE,
	          y2: halfSize,
	          className: "recharts-legend-icon"
	        });
	      }
	
	      if (data.type === 'line') {
	        return _react["default"].createElement("path", {
	          strokeWidth: 4,
	          fill: "none",
	          stroke: color,
	          d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat(SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
	          className: "recharts-legend-icon"
	        });
	      }
	
	      if (data.type === 'rect') {
	        return _react["default"].createElement("path", {
	          stroke: "none",
	          fill: color,
	          d: "M0,".concat(SIZE / 8, "h").concat(SIZE, "v").concat(SIZE * 3 / 4, "h").concat(-SIZE, "z"),
	          className: "recharts-legend-icon"
	        });
	      }
	
	      return _react["default"].createElement(_Symbols["default"], {
	        fill: color,
	        cx: halfSize,
	        cy: halfSize,
	        size: SIZE,
	        sizeType: "diameter",
	        type: data.type
	      });
	    }
	    /**
	     * Draw items of legend
	     * @return {ReactElement} Items
	     */
	
	  }, {
	    key: "renderItems",
	    value: function renderItems() {
	      var _this = this;
	
	      var _this$props = this.props,
	          payload = _this$props.payload,
	          iconSize = _this$props.iconSize,
	          layout = _this$props.layout,
	          formatter = _this$props.formatter;
	      var viewBox = {
	        x: 0,
	        y: 0,
	        width: SIZE,
	        height: SIZE
	      };
	      var itemStyle = {
	        display: layout === 'horizontal' ? 'inline-block' : 'block',
	        marginRight: 10
	      };
	      var svgStyle = {
	        display: 'inline-block',
	        verticalAlign: 'middle',
	        marginRight: 4
	      };
	      return payload.map(function (entry, i) {
	        var _classNames;
	
	        var finalFormatter = entry.formatter || formatter;
	        var className = (0, _classnames["default"])((_classNames = {
	          'recharts-legend-item': true
	        }, _defineProperty(_classNames, "legend-item-".concat(i), true), _defineProperty(_classNames, "inactive", entry.inactive), _classNames));
	
	        if (entry.type === 'none') {
	          return null;
	        }
	
	        return _react["default"].createElement("li", _extends({
	          className: className,
	          style: itemStyle,
	          key: "legend-item-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), _react["default"].createElement(_Surface["default"], {
	          width: iconSize,
	          height: iconSize,
	          viewBox: viewBox,
	          style: svgStyle
	        }, _this.renderIcon(entry)), _react["default"].createElement("span", {
	          className: "recharts-legend-item-text"
	        }, finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value));
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          payload = _this$props2.payload,
	          layout = _this$props2.layout,
	          align = _this$props2.align;
	
	      if (!payload || !payload.length) {
	        return null;
	      }
	
	      var finalStyle = {
	        padding: 0,
	        margin: 0,
	        textAlign: layout === 'horizontal' ? align : 'left'
	      };
	      return _react["default"].createElement("ul", {
	        className: "recharts-default-legend",
	        style: finalStyle
	      }, this.renderItems());
	    }
	  }]);
	
	  return DefaultLegendContent;
	}(_react.PureComponent);
	
	DefaultLegendContent.displayName = 'Legend';
	DefaultLegendContent.propTypes = {
	  content: _propTypes["default"].element,
	  iconSize: _propTypes["default"].number,
	  iconType: _propTypes["default"].oneOf(ICON_TYPES),
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  align: _propTypes["default"].oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes["default"].oneOf(['top', 'bottom', 'middle']),
	  payload: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    value: _propTypes["default"].any,
	    id: _propTypes["default"].any,
	    type: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  inactiveColor: _propTypes["default"].string,
	  formatter: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func
	};
	DefaultLegendContent.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'middle',
	  inactiveColor: '#ccc'
	};
	var _default = DefaultLegendContent;
	exports["default"] = _default;

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _sortBy2 = _interopRequireDefault(__webpack_require__(486));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(62));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _DataUtils = __webpack_require__(66);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var defaultFormatter = function defaultFormatter(value) {
	  return (0, _isArray2["default"])(value) && (0, _DataUtils.isNumOrStr)(value[0]) && (0, _DataUtils.isNumOrStr)(value[1]) ? value.join(' ~ ') : value;
	};
	
	var DefaultTooltipContent =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(DefaultTooltipContent, _PureComponent);
	
	  function DefaultTooltipContent() {
	    _classCallCheck(this, DefaultTooltipContent);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultTooltipContent).apply(this, arguments));
	  }
	
	  _createClass(DefaultTooltipContent, [{
	    key: "renderContent",
	    value: function renderContent() {
	      var _this$props = this.props,
	          payload = _this$props.payload,
	          separator = _this$props.separator,
	          formatter = _this$props.formatter,
	          itemStyle = _this$props.itemStyle,
	          itemSorter = _this$props.itemSorter;
	
	      if (payload && payload.length) {
	        var listStyle = {
	          padding: 0,
	          margin: 0
	        };
	        var items = (itemSorter ? (0, _sortBy2["default"])(payload, itemSorter) : payload).map(function (entry, i) {
	          if (entry.type === 'none') {
	            return null;
	          }
	
	          var finalItemStyle = _objectSpread({
	            display: 'block',
	            paddingTop: 4,
	            paddingBottom: 4,
	            color: entry.color || '#000'
	          }, itemStyle);
	
	          var finalFormatter = entry.formatter || formatter || defaultFormatter;
	          var name = entry.name,
	              value = entry.value;
	
	          if (finalFormatter) {
	            var formatted = finalFormatter(value, name, entry, i);
	
	            if (Array.isArray(formatted)) {
	              var _formatted = _slicedToArray(formatted, 2);
	
	              value = _formatted[0];
	              name = _formatted[1];
	            } else {
	              value = formatted;
	            }
	          }
	
	          return (// eslint-disable-next-line react/no-array-index-key
	            _react["default"].createElement("li", {
	              className: "recharts-tooltip-item",
	              key: "tooltip-item-".concat(i),
	              style: finalItemStyle
	            }, (0, _DataUtils.isNumOrStr)(name) ? _react["default"].createElement("span", {
	              className: "recharts-tooltip-item-name"
	            }, name) : null, (0, _DataUtils.isNumOrStr)(name) ? _react["default"].createElement("span", {
	              className: "recharts-tooltip-item-separator"
	            }, separator) : null, _react["default"].createElement("span", {
	              className: "recharts-tooltip-item-value"
	            }, value), _react["default"].createElement("span", {
	              className: "recharts-tooltip-item-unit"
	            }, entry.unit || ''))
	          );
	        });
	        return _react["default"].createElement("ul", {
	          className: "recharts-tooltip-item-list",
	          style: listStyle
	        }, items);
	      }
	
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          wrapperClassName = _this$props2.wrapperClassName,
	          contentStyle = _this$props2.contentStyle,
	          labelClassName = _this$props2.labelClassName,
	          labelStyle = _this$props2.labelStyle,
	          label = _this$props2.label,
	          labelFormatter = _this$props2.labelFormatter;
	
	      var finalStyle = _objectSpread({
	        margin: 0,
	        padding: 10,
	        backgroundColor: '#fff',
	        border: '1px solid #ccc',
	        whiteSpace: 'nowrap'
	      }, contentStyle);
	
	      var finalLabelStyle = _objectSpread({
	        margin: 0
	      }, labelStyle);
	
	      var hasLabel = (0, _DataUtils.isNumOrStr)(label);
	      var finalLabel = hasLabel ? label : '';
	      var wrapperCN = (0, _classnames["default"])('recharts-default-tooltip', wrapperClassName);
	      var labelCN = (0, _classnames["default"])('recharts-tooltip-label', labelClassName);
	
	      if (hasLabel && labelFormatter) {
	        finalLabel = labelFormatter(label);
	      }
	
	      return _react["default"].createElement("div", {
	        className: wrapperCN,
	        style: finalStyle
	      }, _react["default"].createElement("p", {
	        className: labelCN,
	        style: finalLabelStyle
	      }, finalLabel), this.renderContent());
	    }
	  }]);
	
	  return DefaultTooltipContent;
	}(_react.PureComponent);
	
	DefaultTooltipContent.displayName = 'DefaultTooltipContent';
	DefaultTooltipContent.propTypes = {
	  separator: _propTypes["default"].string,
	  wrapperClassName: _propTypes["default"].string,
	  labelClassName: _propTypes["default"].string,
	  formatter: _propTypes["default"].func,
	  contentStyle: _propTypes["default"].object,
	  itemStyle: _propTypes["default"].object,
	  labelStyle: _propTypes["default"].object,
	  labelFormatter: _propTypes["default"].func,
	  label: _propTypes["default"].any,
	  payload: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    name: _propTypes["default"].any,
	    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].array]),
	    unit: _propTypes["default"].any
	  })),
	  itemSorter: _propTypes["default"].func
	};
	DefaultTooltipContent.defaultProps = {
	  separator: ' : ',
	  contentStyle: {},
	  itemStyle: {},
	  labelStyle: {}
	};
	var _default = DefaultTooltipContent;
	exports["default"] = _default;

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _debounce2 = _interopRequireDefault(__webpack_require__(479));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _reactResizeDetector = _interopRequireDefault(__webpack_require__(1962));
	
	var _DataUtils = __webpack_require__(66);
	
	var _LogUtils = __webpack_require__(259);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ResponsiveContainer =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ResponsiveContainer, _Component);
	
	  function ResponsiveContainer(props) {
	    var _this;
	
	    _classCallCheck(this, ResponsiveContainer);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResponsiveContainer).call(this, props));
	
	    _this.updateDimensionsImmediate = function () {
	      if (!_this.mounted) {
	        return;
	      }
	
	      var newSize = _this.getContainerSize();
	
	      if (newSize) {
	        var _this$state = _this.state,
	            oldWidth = _this$state.containerWidth,
	            oldHeight = _this$state.containerHeight;
	        var containerWidth = newSize.containerWidth,
	            containerHeight = newSize.containerHeight;
	
	        if (containerWidth !== oldWidth || containerHeight !== oldHeight) {
	          _this.setState({
	            containerWidth: containerWidth,
	            containerHeight: containerHeight
	          });
	        }
	      }
	    };
	
	    _this.state = {
	      containerWidth: -1,
	      containerHeight: -1
	    };
	    _this.handleResize = props.debounce > 0 ? (0, _debounce2["default"])(_this.updateDimensionsImmediate, props.debounce) : _this.updateDimensionsImmediate;
	    return _this;
	  }
	  /* eslint-disable  react/no-did-mount-set-state */
	
	
	  _createClass(ResponsiveContainer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	      var size = this.getContainerSize();
	
	      if (size) {
	        this.setState(size);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: "getContainerSize",
	    value: function getContainerSize() {
	      if (!this.container) {
	        return null;
	      }
	
	      return {
	        containerWidth: this.container.clientWidth,
	        containerHeight: this.container.clientHeight
	      };
	    }
	  }, {
	    key: "renderChart",
	    value: function renderChart() {
	      var _this$state2 = this.state,
	          containerWidth = _this$state2.containerWidth,
	          containerHeight = _this$state2.containerHeight;
	
	      if (containerWidth < 0 || containerHeight < 0) {
	        return null;
	      }
	
	      var _this$props = this.props,
	          aspect = _this$props.aspect,
	          width = _this$props.width,
	          height = _this$props.height,
	          minWidth = _this$props.minWidth,
	          minHeight = _this$props.minHeight,
	          maxHeight = _this$props.maxHeight,
	          children = _this$props.children;
	      (0, _LogUtils.warn)((0, _DataUtils.isPercent)(width) || (0, _DataUtils.isPercent)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
	      (0, _LogUtils.warn)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
	      var calculatedWidth = (0, _DataUtils.isPercent)(width) ? containerWidth : width;
	      var calculatedHeight = (0, _DataUtils.isPercent)(height) ? containerHeight : height;
	
	      if (aspect && aspect > 0) {
	        // Preserve the desired aspect ratio
	        if (calculatedWidth) {
	          // Will default to using width for aspect ratio
	          calculatedHeight = calculatedWidth / aspect;
	        } else if (calculatedHeight) {
	          // But we should also take height into consideration
	          calculatedWidth = calculatedHeight * aspect;
	        } // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
	
	
	        if (maxHeight && calculatedHeight > maxHeight) {
	          calculatedHeight = maxHeight;
	        }
	      }
	
	      (0, _LogUtils.warn)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
	      return _react["default"].cloneElement(children, {
	        width: calculatedWidth,
	        height: calculatedHeight
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          minWidth = _this$props2.minWidth,
	          minHeight = _this$props2.minHeight,
	          width = _this$props2.width,
	          height = _this$props2.height,
	          maxHeight = _this$props2.maxHeight,
	          id = _this$props2.id,
	          className = _this$props2.className;
	      var style = {
	        width: width,
	        height: height,
	        minWidth: minWidth,
	        minHeight: minHeight,
	        maxHeight: maxHeight
	      };
	      return _react["default"].createElement("div", {
	        id: id,
	        className: (0, _classnames["default"])('recharts-responsive-container', className),
	        style: style,
	        ref: function ref(node) {
	          _this2.container = node;
	        }
	      }, this.renderChart(), _react["default"].createElement(_reactResizeDetector["default"], {
	        handleWidth: true,
	        handleHeight: true,
	        onResize: this.handleResize
	      }));
	    }
	  }]);
	
	  return ResponsiveContainer;
	}(_react.Component);
	
	ResponsiveContainer.displayName = 'ResponsiveContainer';
	ResponsiveContainer.propTypes = {
	  aspect: _propTypes["default"].number,
	  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  minHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  maxHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  children: _propTypes["default"].node.isRequired,
	  debounce: _propTypes["default"].number,
	  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
	};
	ResponsiveContainer.defaultProps = {
	  width: '100%',
	  height: '100%',
	  debounce: 0
	};
	var _default = ResponsiveContainer;
	exports["default"] = _default;

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _PolarUtils = __webpack_require__(142);
	
	var _ReactUtils = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var PolarGrid =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(PolarGrid, _PureComponent);
	
	  function PolarGrid() {
	    _classCallCheck(this, PolarGrid);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PolarGrid).apply(this, arguments));
	  }
	
	  _createClass(PolarGrid, [{
	    key: "getPolygonPath",
	    value: function getPolygonPath(radius) {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          polarAngles = _this$props.polarAngles;
	      var path = '';
	      polarAngles.forEach(function (angle, i) {
	        var point = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle);
	
	        if (i) {
	          path += "L ".concat(point.x, ",").concat(point.y);
	        } else {
	          path += "M ".concat(point.x, ",").concat(point.y);
	        }
	      });
	      path += 'Z';
	      return path;
	    }
	    /**
	     * Draw axis of radial line
	     * @return {[type]} The lines
	     */
	
	  }, {
	    key: "renderPolarAngles",
	    value: function renderPolarAngles() {
	      var _this$props2 = this.props,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          innerRadius = _this$props2.innerRadius,
	          outerRadius = _this$props2.outerRadius,
	          polarAngles = _this$props2.polarAngles;
	
	      if (!polarAngles || !polarAngles.length) {
	        return null;
	      }
	
	      var props = _objectSpread({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props));
	
	      return _react["default"].createElement("g", {
	        className: "recharts-polar-grid-angle"
	      }, polarAngles.map(function (entry, i) {
	        var start = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, entry);
	        var end = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, entry);
	        return _react["default"].createElement("line", _extends({}, props, {
	          key: "line-".concat(i) // eslint-disable-line react/no-array-index-key
	          ,
	          x1: start.x,
	          y1: start.y,
	          x2: end.x,
	          y2: end.y
	        }));
	      }));
	    }
	    /**
	     * Draw concentric circles
	     * @param {Number} radius The radius of circle
	     * @param {Number} index  The index of circle
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} circle
	     */
	
	  }, {
	    key: "renderConcentricCircle",
	    value: function renderConcentricCircle(radius, index, extraProps) {
	      var _this$props3 = this.props,
	          cx = _this$props3.cx,
	          cy = _this$props3.cy;
	
	      var props = _objectSpread({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react["default"].createElement("circle", _extends({}, props, {
	        className: "recharts-polar-grid-concentric-circle",
	        key: "circle-".concat(index),
	        cx: cx,
	        cy: cy,
	        r: radius
	      }));
	    }
	    /**
	     * Draw concentric polygons
	     * @param {Number} radius     The radius of polygon
	     * @param {Number} index      The index of polygon
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} polygon
	     */
	
	  }, {
	    key: "renderConcentricPolygon",
	    value: function renderConcentricPolygon(radius, index, extraProps) {
	      var props = _objectSpread({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react["default"].createElement("path", _extends({}, props, {
	        className: "recharts-polar-grid-concentric-polygon",
	        key: "path-".concat(index),
	        d: this.getPolygonPath(radius)
	      }));
	    }
	    /**
	     * Draw concentric axis
	     * @return {ReactElement} Concentric axis
	     * @todo Optimize the name
	     */
	
	  }, {
	    key: "renderConcentricPath",
	    value: function renderConcentricPath() {
	      var _this = this;
	
	      var _this$props4 = this.props,
	          polarRadius = _this$props4.polarRadius,
	          gridType = _this$props4.gridType;
	
	      if (!polarRadius || !polarRadius.length) {
	        return null;
	      }
	
	      return _react["default"].createElement("g", {
	        className: "recharts-polar-grid-concentric"
	      }, polarRadius.map(function (entry, i) {
	        return gridType === 'circle' ? _this.renderConcentricCircle(entry, i) : _this.renderConcentricPolygon(entry, i);
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var outerRadius = this.props.outerRadius;
	
	      if (outerRadius <= 0) {
	        return null;
	      }
	
	      return _react["default"].createElement("g", {
	        className: "recharts-polar-grid"
	      }, this.renderPolarAngles(), this.renderConcentricPath());
	    }
	  }]);
	
	  return PolarGrid;
	}(_react.PureComponent);
	
	PolarGrid.displayName = 'PolarGrid';
	PolarGrid.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  innerRadius: _propTypes["default"].number,
	  outerRadius: _propTypes["default"].number,
	  polarAngles: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  polarRadius: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  gridType: _propTypes["default"].oneOf(['polygon', 'circle'])
	});
	PolarGrid.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  gridType: 'polygon'
	};
	var _default = PolarGrid;
	exports["default"] = _default;

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(1042);
	
	__webpack_require__(1043);
	
	/* eslint no-proto: 0 */
	var testObject = {};
	
	if (!(Object.setPrototypeOf || testObject.__proto__)) {
	  var nativeGetPrototypeOf = Object.getPrototypeOf;
	
	  Object.getPrototypeOf = function (object) {
	    if (object.__proto__) {
	      return object.__proto__;
	    }
	
	    return nativeGetPrototypeOf.call(Object, object);
	  };
	}

/***/ }),
/* 1957 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.COLOR_PANEL = void 0;
	var COLOR_PANEL = ['#1890FF', '#66B5FF', '#41D9C7', '#2FC25B', '#6EDB8F', '#9AE65C', '#FACC14', '#E6965C', '#57AD71', '#223273', '#738AE6', '#7564CC', '#8543E0', '#A877ED', '#5C8EE6', '#13C2C2', '#70E0E0', '#5CA3E6', '#3436C7', '#8082FF', '#DD81E6', '#F04864', '#FA7D92', '#D598D9'];
	exports.COLOR_PANEL = COLOR_PANEL;

/***/ }),
/* 1958 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generatePrefixStyle = void 0;
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
	
	var generatePrefixStyle = function generatePrefixStyle(name, value) {
	  if (!name) {
	    return null;
	  }
	
	  var camelName = name.replace(/(\w)/, function (v) {
	    return v.toUpperCase();
	  });
	  var result = PREFIX_LIST.reduce(function (res, entry) {
	    return _objectSpread({}, res, _defineProperty({}, entry + camelName, value));
	  }, {});
	  result[name] = value;
	  return result;
	};
	
	exports.generatePrefixStyle = generatePrefixStyle;

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.detectReferenceElementsDomain = void 0;
	
	var _ReferenceDot = _interopRequireDefault(__webpack_require__(894));
	
	var _ReferenceLine = _interopRequireDefault(__webpack_require__(895));
	
	var _ReferenceArea = _interopRequireDefault(__webpack_require__(893));
	
	var _IfOverflowMatches = __webpack_require__(393);
	
	var _ReactUtils = __webpack_require__(43);
	
	var _DataUtils = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
	  var lines = (0, _ReactUtils.findAllByType)(children, _ReferenceLine["default"]);
	  var dots = (0, _ReactUtils.findAllByType)(children, _ReferenceDot["default"]);
	  var elements = lines.concat(dots);
	  var areas = (0, _ReactUtils.findAllByType)(children, _ReferenceArea["default"]);
	  var idKey = "".concat(axisType, "Id");
	  var valueKey = axisType[0];
	  var finalDomain = domain;
	
	  if (elements.length) {
	    finalDomain = elements.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && (0, _IfOverflowMatches.ifOverflowMatches)(el.props, 'extendDomain') && (0, _DataUtils.isNumber)(el.props[valueKey])) {
	        var value = el.props[valueKey];
	        return [Math.min(result[0], value), Math.max(result[1], value)];
	      }
	
	      return result;
	    }, finalDomain);
	  }
	
	  if (areas.length) {
	    var key1 = "".concat(valueKey, "1");
	    var key2 = "".concat(valueKey, "2");
	    finalDomain = areas.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && (0, _IfOverflowMatches.ifOverflowMatches)(el.props, 'extendDomain') && (0, _DataUtils.isNumber)(el.props[key1]) && (0, _DataUtils.isNumber)(el.props[key2])) {
	        var value1 = el.props[key1];
	        var value2 = el.props[key2];
	        return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
	      }
	
	      return result;
	    }, finalDomain);
	  }
	
	  if (specifiedTicks && specifiedTicks.length) {
	    finalDomain = specifiedTicks.reduce(function (result, tick) {
	      if ((0, _DataUtils.isNumber)(tick)) {
	        return [Math.min(result[0], tick), Math.max(result[1], tick)];
	      }
	
	      return result;
	    }, finalDomain);
	  }
	
	  return finalDomain;
	};
	
	exports.detectReferenceElementsDomain = detectReferenceElementsDomain;

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SYNC_EVENT = exports.eventCenter = void 0;
	
	var _events = _interopRequireDefault(__webpack_require__(664));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var eventCenter = new _events["default"]();
	exports.eventCenter = eventCenter;
	
	if (eventCenter.setMaxListeners) {
	  eventCenter.setMaxListeners(10);
	}
	
	var SYNC_EVENT = 'recharts.syncMouseEvents';
	exports.SYNC_EVENT = SYNC_EVENT;

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resizeObserverPolyfill = __webpack_require__(1975);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	var _lodash = __webpack_require__(1359);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(690);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var listMode = { debounce: _lodash2.default, throttle: _lodash4.default };
	
	var styles = {
	  position: 'absolute',
	  width: 0,
	  height: 0,
	  visibility: 'hidden',
	  display: 'none'
	};
	
	var ResizeDetector = function (_PureComponent) {
	  _inherits(ResizeDetector, _PureComponent);
	
	  function ResizeDetector(props) {
	    _classCallCheck(this, ResizeDetector);
	
	    var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this, props));
	
	    _this.createResizeObserver = function (entries) {
	      var _this$props = _this.props,
	          handleWidth = _this$props.handleWidth,
	          handleHeight = _this$props.handleHeight,
	          onResize = _this$props.onResize;
	
	      entries.forEach(function (entry) {
	        var _entry$contentRect = entry.contentRect,
	            width = _entry$contentRect.width,
	            height = _entry$contentRect.height;
	
	        var notifyWidth = handleWidth && _this.width !== width;
	        var notifyHeight = handleHeight && _this.height !== height;
	        if (!_this.skipOnMount && (notifyWidth || notifyHeight)) {
	          onResize(width, height);
	        }
	        _this.width = width;
	        _this.height = height;
	        _this.skipOnMount = false;
	      });
	    };
	
	    var skipOnMount = props.skipOnMount,
	        refreshMode = props.refreshMode,
	        refreshRate = props.refreshRate;
	
	
	    _this.width = undefined;
	    _this.height = undefined;
	    _this.skipOnMount = skipOnMount;
	
	    var resizeObserver = listMode[refreshMode] && listMode[refreshMode](_this.createResizeObserver, refreshRate) || _this.createResizeObserver;
	
	    _this.ro = new _resizeObserverPolyfill2.default(resizeObserver);
	    return _this;
	  }
	
	  _createClass(ResizeDetector, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var resizableElementId = this.props.resizableElementId;
	
	      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
	      this.ro.observe(resizableElement);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var resizableElementId = this.props.resizableElementId;
	
	      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
	      this.ro.unobserve(resizableElement);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement('div', {
	        style: styles,
	        ref: function ref(el) {
	          _this2.el = el;
	        }
	      });
	    }
	  }]);
	
	  return ResizeDetector;
	}(_react.PureComponent);
	
	exports.default = ResizeDetector;
	
	
	ResizeDetector.propTypes = {
	  handleWidth: _propTypes2.default.bool,
	  handleHeight: _propTypes2.default.bool,
	  skipOnMount: _propTypes2.default.bool,
	  refreshRate: _propTypes2.default.number,
	  refreshMode: _propTypes2.default.string,
	  resizableElementId: _propTypes2.default.string,
	  onResize: _propTypes2.default.func
	};
	
	ResizeDetector.defaultProps = {
	  handleWidth: false,
	  handleHeight: false,
	  skipOnMount: false,
	  refreshRate: 1000,
	  refreshMode: undefined,
	  resizableElementId: '',
	  onResize: function onResize(e) {
	    return e;
	  }
	};

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ResizeDetector = __webpack_require__(1961);
	
	var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ResizeDetector2.default;

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(906);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _AnimateGroupChild = _interopRequireDefault(__webpack_require__(1964));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function AnimateGroup(props) {
	  var component = props.component,
	      children = props.children,
	      appear = props.appear,
	      enter = props.enter,
	      leave = props.leave;
	  return _react.default.createElement(_reactTransitionGroup.TransitionGroup, {
	    component: component
	  }, _react.Children.map(children, function (child, index) {
	    return _react.default.createElement(_AnimateGroupChild.default, {
	      appearOptions: appear,
	      enterOptions: enter,
	      leaveOptions: leave,
	      key: "child-".concat(index)
	    }, child);
	  }));
	}
	
	AnimateGroup.propTypes = {
	  appear: _propTypes.default.object,
	  enter: _propTypes.default.object,
	  leave: _propTypes.default.object,
	  children: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.element]),
	  component: _propTypes.default.any
	};
	AnimateGroup.defaultProps = {
	  component: 'span'
	};
	var _default = AnimateGroup;
	exports.default = _default;

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isNumber2 = _interopRequireDefault(__webpack_require__(239));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(906);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Animate = _interopRequireDefault(__webpack_require__(902));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var steps = options.steps,
	      duration = options.duration;
	
	  if (steps && steps.length) {
	    return steps.reduce(function (result, entry) {
	      return result + ((0, _isNumber2.default)(entry.duration) && entry.duration > 0 ? entry.duration : 0);
	    }, 0);
	  }
	
	  if ((0, _isNumber2.default)(duration)) {
	    return duration;
	  }
	
	  return 0;
	};
	
	var AnimateGroupChild =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(AnimateGroupChild, _Component);
	
	  function AnimateGroupChild() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, AnimateGroupChild);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AnimateGroupChild)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isActive: false
	    };
	
	    _this.handleEnter = function (node, isAppearing) {
	      var _this$props = _this.props,
	          appearOptions = _this$props.appearOptions,
	          enterOptions = _this$props.enterOptions;
	
	      _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
	    };
	
	    _this.handleExit = function () {
	      _this.handleStyleActive(_this.props.leaveOptions);
	    };
	
	    return _this;
	  }
	
	  _createClass(AnimateGroupChild, [{
	    key: "handleStyleActive",
	    value: function handleStyleActive(style) {
	      if (style) {
	        var onAnimationEnd = style.onAnimationEnd ? function () {
	          style.onAnimationEnd();
	        } : null;
	        this.setState(_objectSpread({}, style, {
	          onAnimationEnd: onAnimationEnd,
	          isActive: true
	        }));
	      }
	    }
	  }, {
	    key: "parseTimeout",
	    value: function parseTimeout() {
	      var _this$props2 = this.props,
	          appearOptions = _this$props2.appearOptions,
	          enterOptions = _this$props2.enterOptions,
	          leaveOptions = _this$props2.leaveOptions;
	      return parseDurationOfSingleTransition(appearOptions) + parseDurationOfSingleTransition(enterOptions) + parseDurationOfSingleTransition(leaveOptions);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props3 = this.props,
	          children = _this$props3.children,
	          appearOptions = _this$props3.appearOptions,
	          enterOptions = _this$props3.enterOptions,
	          leaveOptions = _this$props3.leaveOptions,
	          props = _objectWithoutProperties(_this$props3, ["children", "appearOptions", "enterOptions", "leaveOptions"]);
	
	      return _react.default.createElement(_reactTransitionGroup.Transition, _extends({}, props, {
	        onEnter: this.handleEnter,
	        onExit: this.handleExit,
	        timeout: this.parseTimeout()
	      }), function () {
	        return _react.default.createElement(_Animate.default, _this2.state, _react.Children.only(children));
	      });
	    }
	  }]);
	
	  return AnimateGroupChild;
	}(_react.Component);
	
	AnimateGroupChild.propTypes = {
	  appearOptions: _propTypes.default.object,
	  enterOptions: _propTypes.default.object,
	  leaveOptions: _propTypes.default.object,
	  children: _propTypes.default.element
	};
	var _default = AnimateGroupChild;
	exports.default = _default;

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createAnimateManager;
	
	var _setRafTimeout = _interopRequireDefault(__webpack_require__(1967));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function createAnimateManager() {
	  var currStyle = {};
	
	  var handleChange = function handleChange() {
	    return null;
	  };
	
	  var shouldStop = false;
	
	  var setStyle = function setStyle(_style) {
	    if (shouldStop) {
	      return;
	    }
	
	    if (Array.isArray(_style)) {
	      if (!_style.length) {
	        return;
	      }
	
	      var styles = _style;
	
	      var _styles = _toArray(styles),
	          curr = _styles[0],
	          restStyles = _styles.slice(1);
	
	      if (typeof curr === 'number') {
	        (0, _setRafTimeout.default)(setStyle.bind(null, restStyles), curr);
	        return;
	      }
	
	      setStyle(curr);
	      (0, _setRafTimeout.default)(setStyle.bind(null, restStyles));
	      return;
	    }
	
	    if (_typeof(_style) === 'object') {
	      currStyle = _style;
	      handleChange(currStyle);
	    }
	
	    if (typeof _style === 'function') {
	      _style();
	    }
	  };
	
	  return {
	    stop: function stop() {
	      shouldStop = true;
	    },
	    start: function start(style) {
	      shouldStop = false;
	      setStyle(style);
	    },
	    subscribe: function subscribe(_handleChange) {
	      handleChange = _handleChange;
	      return function () {
	        handleChange = function handleChange() {
	          return null;
	        };
	      };
	    }
	  };
	}

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _filter2 = _interopRequireDefault(__webpack_require__(1468));
	
	var _raf = _interopRequireWildcard(__webpack_require__(792));
	
	var _util = __webpack_require__(395);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var alpha = function alpha(begin, end, k) {
	  return begin + (end - begin) * k;
	};
	
	var needContinue = function needContinue(_ref) {
	  var from = _ref.from,
	      to = _ref.to;
	  return from !== to;
	};
	/*
	 * @description: cal new from value and velocity in each stepper
	 * @return: { [styleProperty]: { from, to, velocity } }
	 */
	
	
	var calStepperVals = function calStepperVals(easing, preVals, steps) {
	  var nextStepVals = (0, _util.mapObject)(function (key, val) {
	    if (needContinue(val)) {
	      var _easing = easing(val.from, val.to, val.velocity),
	          _easing2 = _slicedToArray(_easing, 2),
	          newX = _easing2[0],
	          newV = _easing2[1];
	
	      return _objectSpread({}, val, {
	        from: newX,
	        velocity: newV
	      });
	    }
	
	    return val;
	  }, preVals);
	
	  if (steps < 1) {
	    return (0, _util.mapObject)(function (key, val) {
	      if (needContinue(val)) {
	        return _objectSpread({}, val, {
	          velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
	          from: alpha(val.from, nextStepVals[key].from, steps)
	        });
	      }
	
	      return val;
	    }, preVals);
	  }
	
	  return calStepperVals(easing, nextStepVals, steps - 1);
	}; // configure update function
	
	
	var _default = function _default(from, to, easing, duration, render) {
	  var interKeys = (0, _util.getIntersectionKeys)(from, to);
	  var timingStyle = interKeys.reduce(function (res, key) {
	    return _objectSpread({}, res, _defineProperty({}, key, [from[key], to[key]]));
	  }, {});
	  var stepperStyle = interKeys.reduce(function (res, key) {
	    return _objectSpread({}, res, _defineProperty({}, key, {
	      from: from[key],
	      velocity: 0,
	      to: to[key]
	    }));
	  }, {});
	  var cafId = -1;
	  var preTime;
	  var beginTime;
	
	  var update = function update() {
	    return null;
	  };
	
	  var getCurrStyle = function getCurrStyle() {
	    return (0, _util.mapObject)(function (key, val) {
	      return val.from;
	    }, stepperStyle);
	  };
	
	  var shouldStopAnimation = function shouldStopAnimation() {
	    return !(0, _filter2.default)(stepperStyle, needContinue).length;
	  }; // stepper timing function like spring
	
	
	  var stepperUpdate = function stepperUpdate(now) {
	    if (!preTime) {
	      preTime = now;
	    }
	
	    var deltaTime = now - preTime;
	    var steps = deltaTime / easing.dt;
	    stepperStyle = calStepperVals(easing, stepperStyle, steps); // get union set and add compatible prefix
	
	    render(_objectSpread({}, from, to, getCurrStyle(stepperStyle)));
	    preTime = now;
	
	    if (!shouldStopAnimation()) {
	      cafId = (0, _raf.default)(update);
	    }
	  }; // t => val timing function like cubic-bezier
	
	
	  var timingUpdate = function timingUpdate(now) {
	    if (!beginTime) {
	      beginTime = now;
	    }
	
	    var t = (now - beginTime) / duration;
	    var currStyle = (0, _util.mapObject)(function (key, val) {
	      return alpha.apply(void 0, _toConsumableArray(val).concat([easing(t)]));
	    }, timingStyle); // get union set and add compatible prefix
	
	    render(_objectSpread({}, from, to, currStyle));
	
	    if (t < 1) {
	      cafId = (0, _raf.default)(update);
	    } else {
	      var finalStyle = (0, _util.mapObject)(function (key, val) {
	        return alpha.apply(void 0, _toConsumableArray(val).concat([easing(1)]));
	      }, timingStyle);
	      render(_objectSpread({}, from, to, finalStyle));
	    }
	  };
	
	  update = easing.isStepper ? stepperUpdate : timingUpdate; // return start animation method
	
	  return function () {
	    (0, _raf.default)(update); // return stop animation method
	
	    return function () {
	      (0, _raf.cancel)(cafId);
	    };
	  };
	};
	
	exports.default = _default;

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setRafTimeout;
	
	var _raf = _interopRequireDefault(__webpack_require__(792));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setRafTimeout(callback) {
	  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var currTime = -1;
	
	  var shouldUpdate = function shouldUpdate(now) {
	    if (currTime < 0) {
	      currTime = now;
	    }
	
	    if (now - currTime > timeout) {
	      callback(now);
	      currTime = -1;
	    } else {
	      (0, _raf.default)(shouldUpdate);
	    }
	  };
	
	  (0, _raf.default)(shouldUpdate);
	}

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _addClass = _interopRequireDefault(__webpack_require__(634));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(636));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(904));
	
	var _PropTypes = __webpack_require__(907);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity: 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var appearClassName = _this.getClassNames('appear').doneClassName;
	
	      var enterClassName = _this.getClassNames('enter').doneClassName;
	
	      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames5.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
	      var className = isStringClassNames ? prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
	      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames6 = this.getClassNames(type),
	        className = _this$getClassNames6.className,
	        activeClassName = _this$getClassNames6.activeClassName,
	        doneClassName = _this$getClassNames6.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	
	      addClass(node, className);
	    }
	  };
	
	  _proto.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or
	   * has finished the transition. A single name can be provided and it will be
	   * suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
	   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(31);
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(905));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	var balanced = __webpack_require__(1972)
	var reduceFunctionCall = __webpack_require__(1973)
	var mexp = __webpack_require__(1623)
	
	/**
	 * Constantes
	 */
	var MAX_STACK = 100 // should be enough for a single calc()...
	var NESTED_CALC_RE = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g
	
	/**
	 * Global variables
	 */
	var stack
	
	/**
	 * Expose reduceCSSCalc plugin
	 *
	 * @type {Function}
	 */
	module.exports = reduceCSSCalc
	
	/**
	 * Reduce CSS calc() in a string, whenever it's possible
	 *
	 * @param {String} value css input
	 */
	function reduceCSSCalc(value, decimalPrecision) {
	  stack = 0
	  decimalPrecision = Math.pow(10, decimalPrecision === undefined ? 5 : decimalPrecision)
	
	  // Allow calc() on multiple lines
	  value = value.replace(/\n+/g, " ")
	
	  /**
	   * Evaluates an expression
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateExpression (expression, functionIdentifier, call) {
	    if (stack++ > MAX_STACK) {
	      stack = 0
	      throw new Error("Call stack overflow for " + call)
	    }
	
	    if (expression === "") {
	      throw new Error(functionIdentifier + "(): '" + call + "' must contain a non-whitespace string")
	    }
	
	    expression = evaluateNestedExpression(expression, call)
	
	    var units = getUnitsInExpression(expression)
	
	    // If the expression contains multiple units or CSS variables,
	    // then let the expression be (i.e. browser calc())
	    if (units.length > 1 || expression.indexOf("var(") > -1) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    var unit = units[0] || ""
	
	    if (unit === "%") {
	      // Convert percentages to numbers, to handle expressions like: 50% * 50% (will become: 25%):
	      // console.log(expression)
	      expression = expression.replace(/\b[0-9\.]+%/g, function(percent) {
	        return parseFloat(percent.slice(0, -1)) * 0.01
	      })
	    }
	
	    // Remove units in expression:
	    var toEvaluate = expression.replace(new RegExp(unit, "gi"), "")
	    var result
	
	    try {
	      result = mexp.eval(toEvaluate)
	    }
	    catch (e) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    // Transform back to a percentage result:
	    if (unit === "%") {
	      result *= 100
	    }
	
	    // adjust rounding shit
	    // (0.1 * 0.2 === 0.020000000000000004)
	    if (functionIdentifier.length || unit === "%") {
	      result = Math.round(result * decimalPrecision) / decimalPrecision
	    }
	
	    // Add unit
	    result += unit
	
	    return result
	  }
	
	  /**
	   * Evaluates nested expressions
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateNestedExpression(expression, call) {
	    // Remove the calc part from nested expressions to ensure
	    // better browser compatibility
	    expression = expression.replace(/((?:\-[a-z]+\-)?calc)/g, "")
	    var evaluatedPart = ""
	    var nonEvaluatedPart = expression
	    var matches
	    while ((matches = NESTED_CALC_RE.exec(nonEvaluatedPart))) {
	      if (matches[0].index > 0) {
	        evaluatedPart += nonEvaluatedPart.substring(0, matches[0].index)
	      }
	
	      var balancedExpr = balanced("(", ")", nonEvaluatedPart.substring([0].index))
	      if (balancedExpr.body === "") {
	        throw new Error("'" + expression + "' must contain a non-whitespace string")
	      }
	
	      var evaluated = evaluateExpression(balancedExpr.body, "", call)
	
	      evaluatedPart += balancedExpr.pre + evaluated
	      nonEvaluatedPart = balancedExpr.post
	    }
	
	    return evaluatedPart + nonEvaluatedPart
	  }
	
	  return reduceFunctionCall(value, /((?:\-[a-z]+\-)?calc)\(/, evaluateExpression)
	}
	
	/**
	 * Checks what units are used in an expression
	 *
	 * @param {String} expression
	 * @returns {Array}
	 */
	
	function getUnitsInExpression(expression) {
	  var uniqueUnits = []
	  var uniqueLowerCaseUnits = []
	  var unitRegEx = /[\.0-9]([%a-z]+)/gi
	  var matches = unitRegEx.exec(expression)
	
	  while (matches) {
	    if (!matches || !matches[1]) {
	      continue
	    }
	
	    if (uniqueLowerCaseUnits.indexOf(matches[1].toLowerCase()) === -1) {
	      uniqueUnits.push(matches[1])
	      uniqueLowerCaseUnits.push(matches[1].toLowerCase())
	    }
	
	    matches = unitRegEx.exec(expression)
	  }
	
	  return uniqueUnits
	}


/***/ }),
/* 1972 */
/***/ (function(module, exports) {

	module.exports = balanced;
	function balanced(a, b, str) {
	  if (a instanceof RegExp) a = maybeMatch(a, str);
	  if (b instanceof RegExp) b = maybeMatch(b, str);
	
	  var r = range(a, b, str);
	
	  return r && {
	    start: r[0],
	    end: r[1],
	    pre: str.slice(0, r[0]),
	    body: str.slice(r[0] + a.length, r[1]),
	    post: str.slice(r[1] + b.length)
	  };
	}
	
	function maybeMatch(reg, str) {
	  var m = str.match(reg);
	  return m ? m[0] : null;
	}
	
	balanced.range = range;
	function range(a, b, str) {
	  var begs, beg, left, right, result;
	  var ai = str.indexOf(a);
	  var bi = str.indexOf(b, ai + 1);
	  var i = ai;
	
	  if (ai >= 0 && bi > 0) {
	    begs = [];
	    left = str.length;
	
	    while (i >= 0 && !result) {
	      if (i == ai) {
	        begs.push(i);
	        ai = str.indexOf(a, i + 1);
	      } else if (begs.length == 1) {
	        result = [ begs.pop(), bi ];
	      } else {
	        beg = begs.pop();
	        if (beg < left) {
	          left = beg;
	          right = bi;
	        }
	
	        bi = str.indexOf(b, i + 1);
	      }
	
	      i = ai < bi && ai >= 0 ? ai : bi;
	    }
	
	    if (begs.length) {
	      result = [ left, right ];
	    }
	  }
	
	  return result;
	}


/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Module dependencies
	 */
	var balanced = __webpack_require__(1003)
	
	/**
	 * Expose `reduceFunctionCall`
	 *
	 * @type {Function}
	 */
	module.exports = reduceFunctionCall
	
	/**
	 * Walkthrough all expressions, evaluate them and insert them into the declaration
	 *
	 * @param {Array} expressions
	 * @param {Object} declaration
	 */
	
	function reduceFunctionCall(string, functionRE, callback) {
	  var call = string
	  return getFunctionCalls(string, functionRE).reduce(function(string, obj) {
	    return string.replace(obj.functionIdentifier + "(" + obj.matches.body + ")", evalFunctionCall(obj.matches.body, obj.functionIdentifier, callback, call, functionRE))
	  }, string)
	}
	
	/**
	 * Parses expressions in a value
	 *
	 * @param {String} value
	 * @returns {Array}
	 * @api private
	 */
	
	function getFunctionCalls(call, functionRE) {
	  var expressions = []
	
	  var fnRE = typeof functionRE === "string" ? new RegExp("\\b(" + functionRE + ")\\(") : functionRE
	  do {
	    var searchMatch = fnRE.exec(call)
	    if (!searchMatch) {
	      return expressions
	    }
	    if (searchMatch[1] === undefined) {
	      throw new Error("Missing the first couple of parenthesis to get the function identifier in " + functionRE)
	    }
	    var fn = searchMatch[1]
	    var startIndex = searchMatch.index
	    var matches = balanced("(", ")", call.substring(startIndex))
	
	    if (!matches || matches.start !== searchMatch[0].length - 1) {
	      throw new SyntaxError(fn + "(): missing closing ')' in the value '" + call + "'")
	    }
	
	    expressions.push({matches: matches, functionIdentifier: fn})
	    call = matches.post
	  }
	  while (fnRE.test(call))
	
	  return expressions
	}
	
	/**
	 * Evaluates an expression
	 *
	 * @param {String} expression
	 * @returns {String}
	 * @api private
	 */
	
	function evalFunctionCall (string, functionIdentifier, callback, call, functionRE) {
	  // allow recursivity
	  return callback(reduceFunctionCall(string, functionRE, callback), functionIdentifier, call)
	}


/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(137);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(2034);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(219);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var InnerSubscriber = (function (_super) {
	    __extends(InnerSubscriber, _super);
	    function InnerSubscriber(parent, outerValue, outerIndex) {
	        _super.call(this);
	        this.parent = parent;
	        this.outerValue = outerValue;
	        this.outerIndex = outerIndex;
	        this.index = 0;
	    }
	    InnerSubscriber.prototype._next = function (value) {
	        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
	    };
	    InnerSubscriber.prototype._error = function (error) {
	        this.parent.notifyError(error, this);
	        this.unsubscribe();
	    };
	    InnerSubscriber.prototype._complete = function () {
	        this.parent.notifyComplete(this);
	        this.unsubscribe();
	    };
	    return InnerSubscriber;
	}(Subscriber_1.Subscriber));
	exports.InnerSubscriber = InnerSubscriber;
	//# sourceMappingURL=InnerSubscriber.js.map

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(94);
	/**
	 * Represents a push-based event or value that an {@link Observable} can emit.
	 * This class is particularly useful for operators that manage notifications,
	 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
	 * others. Besides wrapping the actual delivered value, it also annotates it
	 * with metadata of, for instance, what type of push message it is (`next`,
	 * `error`, or `complete`).
	 *
	 * @see {@link materialize}
	 * @see {@link dematerialize}
	 * @see {@link observeOn}
	 *
	 * @class Notification<T>
	 */
	var Notification = (function () {
	    function Notification(kind, value, error) {
	        this.kind = kind;
	        this.value = value;
	        this.error = error;
	        this.hasValue = kind === 'N';
	    }
	    /**
	     * Delivers to the given `observer` the value wrapped by this Notification.
	     * @param {Observer} observer
	     * @return
	     */
	    Notification.prototype.observe = function (observer) {
	        switch (this.kind) {
	            case 'N':
	                return observer.next && observer.next(this.value);
	            case 'E':
	                return observer.error && observer.error(this.error);
	            case 'C':
	                return observer.complete && observer.complete();
	        }
	    };
	    /**
	     * Given some {@link Observer} callbacks, deliver the value represented by the
	     * current Notification to the correctly corresponding callback.
	     * @param {function(value: T): void} next An Observer `next` callback.
	     * @param {function(err: any): void} [error] An Observer `error` callback.
	     * @param {function(): void} [complete] An Observer `complete` callback.
	     * @return {any}
	     */
	    Notification.prototype.do = function (next, error, complete) {
	        var kind = this.kind;
	        switch (kind) {
	            case 'N':
	                return next && next(this.value);
	            case 'E':
	                return error && error(this.error);
	            case 'C':
	                return complete && complete();
	        }
	    };
	    /**
	     * Takes an Observer or its individual callback functions, and calls `observe`
	     * or `do` methods accordingly.
	     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
	     * the `next` callback.
	     * @param {function(err: any): void} [error] An Observer `error` callback.
	     * @param {function(): void} [complete] An Observer `complete` callback.
	     * @return {any}
	     */
	    Notification.prototype.accept = function (nextOrObserver, error, complete) {
	        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
	            return this.observe(nextOrObserver);
	        }
	        else {
	            return this.do(nextOrObserver, error, complete);
	        }
	    };
	    /**
	     * Returns a simple Observable that just delivers the notification represented
	     * by this Notification instance.
	     * @return {any}
	     */
	    Notification.prototype.toObservable = function () {
	        var kind = this.kind;
	        switch (kind) {
	            case 'N':
	                return Observable_1.Observable.of(this.value);
	            case 'E':
	                return Observable_1.Observable.throw(this.error);
	            case 'C':
	                return Observable_1.Observable.empty();
	        }
	        throw new Error('unexpected notification kind value');
	    };
	    /**
	     * A shortcut to create a Notification instance of the type `next` from a
	     * given value.
	     * @param {T} value The `next` value.
	     * @return {Notification<T>} The "next" Notification representing the
	     * argument.
	     */
	    Notification.createNext = function (value) {
	        if (typeof value !== 'undefined') {
	            return new Notification('N', value);
	        }
	        return Notification.undefinedValueNotification;
	    };
	    /**
	     * A shortcut to create a Notification instance of the type `error` from a
	     * given error.
	     * @param {any} [err] The `error` error.
	     * @return {Notification<T>} The "error" Notification representing the
	     * argument.
	     */
	    Notification.createError = function (err) {
	        return new Notification('E', undefined, err);
	    };
	    /**
	     * A shortcut to create a Notification instance of the type `complete`.
	     * @return {Notification<any>} The valueless "complete" Notification.
	     */
	    Notification.createComplete = function () {
	        return Notification.completeNotification;
	    };
	    Notification.completeNotification = new Notification('C');
	    Notification.undefinedValueNotification = new Notification('N', undefined);
	    return Notification;
	}());
	exports.Notification = Notification;
	//# sourceMappingURL=Notification.js.map

/***/ }),
/* 1978 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * An execution context and a data structure to order tasks and schedule their
	 * execution. Provides a notion of (potentially virtual) time, through the
	 * `now()` getter method.
	 *
	 * Each unit of work in a Scheduler is called an {@link Action}.
	 *
	 * ```ts
	 * class Scheduler {
	 *   now(): number;
	 *   schedule(work, delay?, state?): Subscription;
	 * }
	 * ```
	 *
	 * @class Scheduler
	 */
	var Scheduler = (function () {
	    function Scheduler(SchedulerAction, now) {
	        if (now === void 0) { now = Scheduler.now; }
	        this.SchedulerAction = SchedulerAction;
	        this.now = now;
	    }
	    /**
	     * Schedules a function, `work`, for execution. May happen at some point in
	     * the future, according to the `delay` parameter, if specified. May be passed
	     * some context object, `state`, which will be passed to the `work` function.
	     *
	     * The given arguments will be processed an stored as an Action object in a
	     * queue of actions.
	     *
	     * @param {function(state: ?T): ?Subscription} work A function representing a
	     * task, or some unit of work to be executed by the Scheduler.
	     * @param {number} [delay] Time to wait before executing the work, where the
	     * time unit is implicit and defined by the Scheduler itself.
	     * @param {T} [state] Some contextual data that the `work` function uses when
	     * called by the Scheduler.
	     * @return {Subscription} A subscription in order to be able to unsubscribe
	     * the scheduled work.
	     */
	    Scheduler.prototype.schedule = function (work, delay, state) {
	        if (delay === void 0) { delay = 0; }
	        return new this.SchedulerAction(this, work).schedule(state, delay);
	    };
	    Scheduler.now = Date.now ? Date.now : function () { return +new Date(); };
	    return Scheduler;
	}());
	exports.Scheduler = Scheduler;
	//# sourceMappingURL=Scheduler.js.map

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscription_1 = __webpack_require__(396);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SubjectSubscription = (function (_super) {
	    __extends(SubjectSubscription, _super);
	    function SubjectSubscription(subject, subscriber) {
	        _super.call(this);
	        this.subject = subject;
	        this.subscriber = subscriber;
	        this.closed = false;
	    }
	    SubjectSubscription.prototype.unsubscribe = function () {
	        if (this.closed) {
	            return;
	        }
	        this.closed = true;
	        var subject = this.subject;
	        var observers = subject.observers;
	        this.subject = null;
	        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
	            return;
	        }
	        var subscriberIndex = observers.indexOf(this.subscriber);
	        if (subscriberIndex !== -1) {
	            observers.splice(subscriberIndex, 1);
	        }
	    };
	    return SubjectSubscription;
	}(Subscription_1.Subscription));
	exports.SubjectSubscription = SubjectSubscription;
	//# sourceMappingURL=SubjectSubscription.js.map

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(94);
	var fromPromise_1 = __webpack_require__(1988);
	Observable_1.Observable.fromPromise = fromPromise_1.fromPromise;
	//# sourceMappingURL=fromPromise.js.map

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(94);
	var map_1 = __webpack_require__(1991);
	Observable_1.Observable.prototype.map = map_1.map;
	//# sourceMappingURL=map.js.map

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(94);
	var startWith_1 = __webpack_require__(1993);
	Observable_1.Observable.prototype.startWith = startWith_1.startWith;
	//# sourceMappingURL=startWith.js.map

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(94);
	var ScalarObservable_1 = __webpack_require__(552);
	var EmptyObservable_1 = __webpack_require__(551);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ArrayLikeObservable = (function (_super) {
	    __extends(ArrayLikeObservable, _super);
	    function ArrayLikeObservable(arrayLike, scheduler) {
	        _super.call(this);
	        this.arrayLike = arrayLike;
	        this.scheduler = scheduler;
	        if (!scheduler && arrayLike.length === 1) {
	            this._isScalar = true;
	            this.value = arrayLike[0];
	        }
	    }
	    ArrayLikeObservable.create = function (arrayLike, scheduler) {
	        var length = arrayLike.length;
	        if (length === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        else if (length === 1) {
	            return new ScalarObservable_1.ScalarObservable(arrayLike[0], scheduler);
	        }
	        else {
	            return new ArrayLikeObservable(arrayLike, scheduler);
	        }
	    };
	    ArrayLikeObservable.dispatch = function (state) {
	        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
	        if (subscriber.closed) {
	            return;
	        }
	        if (index >= length) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(arrayLike[index]);
	        state.index = index + 1;
	        this.schedule(state);
	    };
	    /** @deprecated internal use only */ ArrayLikeObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
	        var length = arrayLike.length;
	        if (scheduler) {
	            return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
	                arrayLike: arrayLike, index: index, length: length, subscriber: subscriber
	            });
	        }
	        else {
	            for (var i = 0; i < length && !subscriber.closed; i++) {
	                subscriber.next(arrayLike[i]);
	            }
	            subscriber.complete();
	        }
	    };
	    return ArrayLikeObservable;
	}(Observable_1.Observable));
	exports.ArrayLikeObservable = ArrayLikeObservable;
	//# sourceMappingURL=ArrayLikeObservable.js.map

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isArray_1 = __webpack_require__(916);
	var isArrayLike_1 = __webpack_require__(917);
	var isPromise_1 = __webpack_require__(556);
	var PromiseObservable_1 = __webpack_require__(912);
	var IteratorObservable_1 = __webpack_require__(1985);
	var ArrayObservable_1 = __webpack_require__(550);
	var ArrayLikeObservable_1 = __webpack_require__(1983);
	var iterator_1 = __webpack_require__(553);
	var Observable_1 = __webpack_require__(94);
	var observeOn_1 = __webpack_require__(1999);
	var observable_1 = __webpack_require__(554);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var FromObservable = (function (_super) {
	    __extends(FromObservable, _super);
	    function FromObservable(ish, scheduler) {
	        _super.call(this, null);
	        this.ish = ish;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable from an Array, an array-like object, a Promise, an
	     * iterable object, or an Observable-like object.
	     *
	     * <span class="informal">Converts almost anything to an Observable.</span>
	     *
	     * <img src="./img/from.png" width="100%">
	     *
	     * Convert various other objects and data types into Observables. `from`
	     * converts a Promise or an array-like or an
	     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
	     * object into an Observable that emits the items in that promise or array or
	     * iterable. A String, in this context, is treated as an array of characters.
	     * Observable-like objects (contains a function named with the ES2015 Symbol
	     * for Observable) can also be converted through this operator.
	     *
	     * @example <caption>Converts an array to an Observable</caption>
	     * var array = [10, 20, 30];
	     * var result = Rx.Observable.from(array);
	     * result.subscribe(x => console.log(x));
	     *
	     * // Results in the following:
	     * // 10 20 30
	     *
	     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
	     * function* generateDoubles(seed) {
	     *   var i = seed;
	     *   while (true) {
	     *     yield i;
	     *     i = 2 * i; // double it
	     *   }
	     * }
	     *
	     * var iterator = generateDoubles(3);
	     * var result = Rx.Observable.from(iterator).take(10);
	     * result.subscribe(x => console.log(x));
	     *
	     * // Results in the following:
	     * // 3 6 12 24 48 96 192 384 768 1536
	     *
	     * @see {@link create}
	     * @see {@link fromEvent}
	     * @see {@link fromEventPattern}
	     * @see {@link fromPromise}
	     *
	     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
	     * Observable-like, an Array, an iterable or an array-like object to be
	     * converted.
	     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
	     * emissions of values.
	     * @return {Observable<T>} The Observable whose values are originally from the
	     * input object that was converted.
	     * @static true
	     * @name from
	     * @owner Observable
	     */
	    FromObservable.create = function (ish, scheduler) {
	        if (ish != null) {
	            if (typeof ish[observable_1.observable] === 'function') {
	                if (ish instanceof Observable_1.Observable && !scheduler) {
	                    return ish;
	                }
	                return new FromObservable(ish, scheduler);
	            }
	            else if (isArray_1.isArray(ish)) {
	                return new ArrayObservable_1.ArrayObservable(ish, scheduler);
	            }
	            else if (isPromise_1.isPromise(ish)) {
	                return new PromiseObservable_1.PromiseObservable(ish, scheduler);
	            }
	            else if (typeof ish[iterator_1.iterator] === 'function' || typeof ish === 'string') {
	                return new IteratorObservable_1.IteratorObservable(ish, scheduler);
	            }
	            else if (isArrayLike_1.isArrayLike(ish)) {
	                return new ArrayLikeObservable_1.ArrayLikeObservable(ish, scheduler);
	            }
	        }
	        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
	    };
	    /** @deprecated internal use only */ FromObservable.prototype._subscribe = function (subscriber) {
	        var ish = this.ish;
	        var scheduler = this.scheduler;
	        if (scheduler == null) {
	            return ish[observable_1.observable]().subscribe(subscriber);
	        }
	        else {
	            return ish[observable_1.observable]().subscribe(new observeOn_1.ObserveOnSubscriber(subscriber, scheduler, 0));
	        }
	    };
	    return FromObservable;
	}(Observable_1.Observable));
	exports.FromObservable = FromObservable;
	//# sourceMappingURL=FromObservable.js.map

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var root_1 = __webpack_require__(192);
	var Observable_1 = __webpack_require__(94);
	var iterator_1 = __webpack_require__(553);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var IteratorObservable = (function (_super) {
	    __extends(IteratorObservable, _super);
	    function IteratorObservable(iterator, scheduler) {
	        _super.call(this);
	        this.scheduler = scheduler;
	        if (iterator == null) {
	            throw new Error('iterator cannot be null.');
	        }
	        this.iterator = getIterator(iterator);
	    }
	    IteratorObservable.create = function (iterator, scheduler) {
	        return new IteratorObservable(iterator, scheduler);
	    };
	    IteratorObservable.dispatch = function (state) {
	        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
	        if (hasError) {
	            subscriber.error(state.error);
	            return;
	        }
	        var result = iterator.next();
	        if (result.done) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(result.value);
	        state.index = index + 1;
	        if (subscriber.closed) {
	            if (typeof iterator.return === 'function') {
	                iterator.return();
	            }
	            return;
	        }
	        this.schedule(state);
	    };
	    /** @deprecated internal use only */ IteratorObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(IteratorObservable.dispatch, 0, {
	                index: index, iterator: iterator, subscriber: subscriber
	            });
	        }
	        else {
	            do {
	                var result = iterator.next();
	                if (result.done) {
	                    subscriber.complete();
	                    break;
	                }
	                else {
	                    subscriber.next(result.value);
	                }
	                if (subscriber.closed) {
	                    if (typeof iterator.return === 'function') {
	                        iterator.return();
	                    }
	                    break;
	                }
	            } while (true);
	        }
	    };
	    return IteratorObservable;
	}(Observable_1.Observable));
	exports.IteratorObservable = IteratorObservable;
	var StringIterator = (function () {
	    function StringIterator(str, idx, len) {
	        if (idx === void 0) { idx = 0; }
	        if (len === void 0) { len = str.length; }
	        this.str = str;
	        this.idx = idx;
	        this.len = len;
	    }
	    StringIterator.prototype[iterator_1.iterator] = function () { return (this); };
	    StringIterator.prototype.next = function () {
	        return this.idx < this.len ? {
	            done: false,
	            value: this.str.charAt(this.idx++)
	        } : {
	            done: true,
	            value: undefined
	        };
	    };
	    return StringIterator;
	}());
	var ArrayIterator = (function () {
	    function ArrayIterator(arr, idx, len) {
	        if (idx === void 0) { idx = 0; }
	        if (len === void 0) { len = toLength(arr); }
	        this.arr = arr;
	        this.idx = idx;
	        this.len = len;
	    }
	    ArrayIterator.prototype[iterator_1.iterator] = function () { return this; };
	    ArrayIterator.prototype.next = function () {
	        return this.idx < this.len ? {
	            done: false,
	            value: this.arr[this.idx++]
	        } : {
	            done: true,
	            value: undefined
	        };
	    };
	    return ArrayIterator;
	}());
	function getIterator(obj) {
	    var i = obj[iterator_1.iterator];
	    if (!i && typeof obj === 'string') {
	        return new StringIterator(obj);
	    }
	    if (!i && obj.length !== undefined) {
	        return new ArrayIterator(obj);
	    }
	    if (!i) {
	        throw new TypeError('object is not iterable');
	    }
	    return obj[iterator_1.iterator]();
	}
	var maxSafeInteger = Math.pow(2, 53) - 1;
	function toLength(o) {
	    var len = +o.length;
	    if (isNaN(len)) {
	        return 0;
	    }
	    if (len === 0 || !numberIsFinite(len)) {
	        return len;
	    }
	    len = sign(len) * Math.floor(Math.abs(len));
	    if (len <= 0) {
	        return 0;
	    }
	    if (len > maxSafeInteger) {
	        return maxSafeInteger;
	    }
	    return len;
	}
	function numberIsFinite(value) {
	    return typeof value === 'number' && root_1.root.isFinite(value);
	}
	function sign(value) {
	    var valueAsNumber = +value;
	    if (valueAsNumber === 0) {
	        return valueAsNumber;
	    }
	    if (isNaN(valueAsNumber)) {
	        return valueAsNumber;
	    }
	    return valueAsNumber < 0 ? -1 : 1;
	}
	//# sourceMappingURL=IteratorObservable.js.map

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isScheduler_1 = __webpack_require__(557);
	var of_1 = __webpack_require__(1989);
	var from_1 = __webpack_require__(1987);
	var concatAll_1 = __webpack_require__(1995);
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which sequentially emits all values from given
	 * Observable and then moves on to the next.
	 *
	 * <span class="informal">Concatenates multiple Observables together by
	 * sequentially emitting their values, one Observable after the other.</span>
	 *
	 * <img src="./img/concat.png" width="100%">
	 *
	 * `concat` joins multiple Observables together, by subscribing to them one at a time and
	 * merging their results into the output Observable. You can pass either an array of
	 * Observables, or put them directly as arguments. Passing an empty array will result
	 * in Observable that completes immediately.
	 *
	 * `concat` will subscribe to first input Observable and emit all its values, without
	 * changing or affecting them in any way. When that Observable completes, it will
	 * subscribe to then next Observable passed and, again, emit its values. This will be
	 * repeated, until the operator runs out of Observables. When last input Observable completes,
	 * `concat` will complete as well. At any given moment only one Observable passed to operator
	 * emits values. If you would like to emit values from passed Observables concurrently, check out
	 * {@link merge} instead, especially with optional `concurrent` parameter. As a matter of fact,
	 * `concat` is an equivalent of `merge` operator with `concurrent` parameter set to `1`.
	 *
	 * Note that if some input Observable never completes, `concat` will also never complete
	 * and Observables following the one that did not complete will never be subscribed. On the other
	 * hand, if some Observable simply completes immediately after it is subscribed, it will be
	 * invisible for `concat`, which will just move on to the next Observable.
	 *
	 * If any Observable in chain errors, instead of passing control to the next Observable,
	 * `concat` will error immediately as well. Observables that would be subscribed after
	 * the one that emitted error, never will.
	 *
	 * If you pass to `concat` the same Observable many times, its stream of values
	 * will be "replayed" on every subscription, which means you can repeat given Observable
	 * as many times as you like. If passing the same Observable to `concat` 1000 times becomes tedious,
	 * you can always use {@link repeat}.
	 *
	 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
	 * var timer = Rx.Observable.interval(1000).take(4);
	 * var sequence = Rx.Observable.range(1, 10);
	 * var result = Rx.Observable.concat(timer, sequence);
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in:
	 * // 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
	 *
	 *
	 * @example <caption>Concatenate an array of 3 Observables</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var result = Rx.Observable.concat([timer1, timer2, timer3]); // note that array is passed
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in the following:
	 * // (Prints to console sequentially)
	 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
	 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
	 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
	 *
	 *
	 * @example <caption>Concatenate the same Observable to repeat it</caption>
	 * const timer = Rx.Observable.interval(1000).take(2);
	 *
	 * Rx.Observable.concat(timer, timer) // concating the same Observable!
	 * .subscribe(
	 *   value => console.log(value),
	 *   err => {},
	 *   () => console.log('...and it is done!')
	 * );
	 *
	 * // Logs:
	 * // 0 after 1s
	 * // 1 after 2s
	 * // 0 after 3s
	 * // 1 after 4s
	 * // "...and it is done!" also after 4s
	 *
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 *
	 * @param {ObservableInput} input1 An input Observable to concatenate with others.
	 * @param {ObservableInput} input2 An input Observable to concatenate with others.
	 * More than one input Observables may be given as argument.
	 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
	 * Observable subscription on.
	 * @return {Observable} All values of each passed Observable merged into a
	 * single Observable, in order, in serial fashion.
	 * @static true
	 * @name concat
	 * @owner Observable
	 */
	function concat() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    if (observables.length === 1 || (observables.length === 2 && isScheduler_1.isScheduler(observables[1]))) {
	        return from_1.from(observables[0]);
	    }
	    return concatAll_1.concatAll()(of_1.of.apply(void 0, observables));
	}
	exports.concat = concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var FromObservable_1 = __webpack_require__(1984);
	exports.from = FromObservable_1.FromObservable.create;
	//# sourceMappingURL=from.js.map

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var PromiseObservable_1 = __webpack_require__(912);
	exports.fromPromise = PromiseObservable_1.PromiseObservable.create;
	//# sourceMappingURL=fromPromise.js.map

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ArrayObservable_1 = __webpack_require__(550);
	exports.of = ArrayObservable_1.ArrayObservable.of;
	//# sourceMappingURL=of.js.map

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(914);
	var debounceTime_1 = __webpack_require__(1996);
	/**
	 * Emits a value from the source Observable only after a particular time span
	 * has passed without another source emission.
	 *
	 * <span class="informal">It's like {@link delay}, but passes only the most
	 * recent value from each burst of emissions.</span>
	 *
	 * <img src="./img/debounceTime.png" width="100%">
	 *
	 * `debounceTime` delays values emitted by the source Observable, but drops
	 * previous pending delayed emissions if a new value arrives on the source
	 * Observable. This operator keeps track of the most recent value from the
	 * source Observable, and emits that only when `dueTime` enough time has passed
	 * without any other value appearing on the source Observable. If a new value
	 * appears before `dueTime` silence occurs, the previous value will be dropped
	 * and will not be emitted on the output Observable.
	 *
	 * This is a rate-limiting operator, because it is impossible for more than one
	 * value to be emitted in any time window of duration `dueTime`, but it is also
	 * a delay-like operator since output emissions do not occur at the same time as
	 * they did on the source Observable. Optionally takes a {@link IScheduler} for
	 * managing timers.
	 *
	 * @example <caption>Emit the most recent click after a burst of clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.debounceTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounce}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttleTime}
	 *
	 * @param {number} dueTime The timeout duration in milliseconds (or the time
	 * unit determined internally by the optional `scheduler`) for the window of
	 * time required to wait for emission silence before emitting the most recent
	 * source value.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the timeout for each value.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified `dueTime`, and may drop some values if they occur
	 * too frequently.
	 * @method debounceTime
	 * @owner Observable
	 */
	function debounceTime(dueTime, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return debounceTime_1.debounceTime(dueTime, scheduler)(this);
	}
	exports.debounceTime = debounceTime;
	//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var map_1 = __webpack_require__(1997);
	/**
	 * Applies a given `project` function to each value emitted by the source
	 * Observable, and emits the resulting values as an Observable.
	 *
	 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
	 * it passes each source value through a transformation function to get
	 * corresponding output values.</span>
	 *
	 * <img src="./img/map.png" width="100%">
	 *
	 * Similar to the well known `Array.prototype.map` function, this operator
	 * applies a projection to each value and emits that projection in the output
	 * Observable.
	 *
	 * @example <caption>Map every click to the clientX position of that click</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var positions = clicks.map(ev => ev.clientX);
	 * positions.subscribe(x => console.log(x));
	 *
	 * @see {@link mapTo}
	 * @see {@link pluck}
	 *
	 * @param {function(value: T, index: number): R} project The function to apply
	 * to each `value` emitted by the source Observable. The `index` parameter is
	 * the number `i` for the i-th emission that has happened since the
	 * subscription, starting from the number `0`.
	 * @param {any} [thisArg] An optional argument to define what `this` is in the
	 * `project` function.
	 * @return {Observable<R>} An Observable that emits the values from the source
	 * Observable transformed by the given `project` function.
	 * @method map
	 * @owner Observable
	 */
	function map(project, thisArg) {
	    return map_1.map(project, thisArg)(this);
	}
	exports.map = map;
	//# sourceMappingURL=map.js.map

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeMap_1 = __webpack_require__(913);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link mergeAll}.</span>
	 *
	 * <img src="./img/mergeMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an Observable, and then merging those resulting Observables and
	 * emitting the results of this merger.
	 *
	 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
	 * var letters = Rx.Observable.of('a', 'b', 'c');
	 * var result = letters.mergeMap(x =>
	 *   Rx.Observable.interval(1000).map(i => x+i)
	 * );
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // a0
	 * // b0
	 * // c0
	 * // a1
	 * // b1
	 * // c1
	 * // continues to list a,b,c with respective ascending integers
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaustMap}
	 * @see {@link merge}
	 * @see {@link mergeAll}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and merging the results of the Observables obtained
	 * from this transformation.
	 * @method mergeMap
	 * @owner Observable
	 */
	function mergeMap(project, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return mergeMap_1.mergeMap(project, resultSelector, concurrent)(this);
	}
	exports.mergeMap = mergeMap;
	//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var startWith_1 = __webpack_require__(2000);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits the items you specify as arguments before it begins to emit
	 * items emitted by the source Observable.
	 *
	 * <img src="./img/startWith.png" width="100%">
	 *
	 * @param {...T} values - Items you want the modified Observable to emit first.
	 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
	 * the emissions of the `next` notifications.
	 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
	 * emitted by the source Observable.
	 * @method startWith
	 * @owner Observable
	 */
	function startWith() {
	    var array = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        array[_i - 0] = arguments[_i];
	    }
	    return startWith_1.startWith.apply(void 0, array)(this);
	}
	exports.startWith = startWith;
	//# sourceMappingURL=startWith.js.map

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var switchMap_1 = __webpack_require__(2001);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable, emitting values only from the most recently projected Observable.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link switch}.</span>
	 *
	 * <img src="./img/switchMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. Each time it observes one of these
	 * inner Observables, the output Observable begins emitting the items emitted by
	 * that inner Observable. When a new inner Observable is emitted, `switchMap`
	 * stops emitting items from the earlier-emitted inner Observable and begins
	 * emitting items from the new one. It continues to behave like this for
	 * subsequent inner Observables.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaustMap}
	 * @see {@link mergeMap}
	 * @see {@link switch}
	 * @see {@link switchMapTo}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and taking only the values from the most recently
	 * projected inner Observable.
	 * @method switchMap
	 * @owner Observable
	 */
	function switchMap(project, resultSelector) {
	    return switchMap_1.switchMap(project, resultSelector)(this);
	}
	exports.switchMap = switchMap;
	//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeAll_1 = __webpack_require__(1998);
	/**
	 * Converts a higher-order Observable into a first-order Observable by
	 * concatenating the inner Observables in order.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by putting one
	 * inner Observable after the other.</span>
	 *
	 * <img src="./img/concatAll.png" width="100%">
	 *
	 * Joins every Observable emitted by the source (a higher-order Observable), in
	 * a serial fashion. It subscribes to each inner Observable only after the
	 * previous inner Observable has completed, and merges all of their values into
	 * the returned observable.
	 *
	 * __Warning:__ If the source Observable emits Observables quickly and
	 * endlessly, and the inner Observables it emits generally complete slower than
	 * the source emits, you can run into memory issues as the incoming Observables
	 * collect in an unbounded buffer.
	 *
	 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
	 * to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
	 * var firstOrder = higherOrder.concatAll();
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link combineAll}
	 * @see {@link concat}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 * @see {@link exhaust}
	 * @see {@link mergeAll}
	 * @see {@link switch}
	 * @see {@link zipAll}
	 *
	 * @return {Observable} An Observable emitting values from all the inner
	 * Observables concatenated.
	 * @method concatAll
	 * @owner Observable
	 */
	function concatAll() {
	    return mergeAll_1.mergeAll(1);
	}
	exports.concatAll = concatAll;
	//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(219);
	var async_1 = __webpack_require__(914);
	/**
	 * Emits a value from the source Observable only after a particular time span
	 * has passed without another source emission.
	 *
	 * <span class="informal">It's like {@link delay}, but passes only the most
	 * recent value from each burst of emissions.</span>
	 *
	 * <img src="./img/debounceTime.png" width="100%">
	 *
	 * `debounceTime` delays values emitted by the source Observable, but drops
	 * previous pending delayed emissions if a new value arrives on the source
	 * Observable. This operator keeps track of the most recent value from the
	 * source Observable, and emits that only when `dueTime` enough time has passed
	 * without any other value appearing on the source Observable. If a new value
	 * appears before `dueTime` silence occurs, the previous value will be dropped
	 * and will not be emitted on the output Observable.
	 *
	 * This is a rate-limiting operator, because it is impossible for more than one
	 * value to be emitted in any time window of duration `dueTime`, but it is also
	 * a delay-like operator since output emissions do not occur at the same time as
	 * they did on the source Observable. Optionally takes a {@link IScheduler} for
	 * managing timers.
	 *
	 * @example <caption>Emit the most recent click after a burst of clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.debounceTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounce}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttleTime}
	 *
	 * @param {number} dueTime The timeout duration in milliseconds (or the time
	 * unit determined internally by the optional `scheduler`) for the window of
	 * time required to wait for emission silence before emitting the most recent
	 * source value.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the timeout for each value.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified `dueTime`, and may drop some values if they occur
	 * too frequently.
	 * @method debounceTime
	 * @owner Observable
	 */
	function debounceTime(dueTime, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return function (source) { return source.lift(new DebounceTimeOperator(dueTime, scheduler)); };
	}
	exports.debounceTime = debounceTime;
	var DebounceTimeOperator = (function () {
	    function DebounceTimeOperator(dueTime, scheduler) {
	        this.dueTime = dueTime;
	        this.scheduler = scheduler;
	    }
	    DebounceTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
	    };
	    return DebounceTimeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DebounceTimeSubscriber = (function (_super) {
	    __extends(DebounceTimeSubscriber, _super);
	    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
	        _super.call(this, destination);
	        this.dueTime = dueTime;
	        this.scheduler = scheduler;
	        this.debouncedSubscription = null;
	        this.lastValue = null;
	        this.hasValue = false;
	    }
	    DebounceTimeSubscriber.prototype._next = function (value) {
	        this.clearDebounce();
	        this.lastValue = value;
	        this.hasValue = true;
	        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
	    };
	    DebounceTimeSubscriber.prototype._complete = function () {
	        this.debouncedNext();
	        this.destination.complete();
	    };
	    DebounceTimeSubscriber.prototype.debouncedNext = function () {
	        this.clearDebounce();
	        if (this.hasValue) {
	            this.destination.next(this.lastValue);
	            this.lastValue = null;
	            this.hasValue = false;
	        }
	    };
	    DebounceTimeSubscriber.prototype.clearDebounce = function () {
	        var debouncedSubscription = this.debouncedSubscription;
	        if (debouncedSubscription !== null) {
	            this.remove(debouncedSubscription);
	            debouncedSubscription.unsubscribe();
	            this.debouncedSubscription = null;
	        }
	    };
	    return DebounceTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchNext(subscriber) {
	    subscriber.debouncedNext();
	}
	//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(219);
	/**
	 * Applies a given `project` function to each value emitted by the source
	 * Observable, and emits the resulting values as an Observable.
	 *
	 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
	 * it passes each source value through a transformation function to get
	 * corresponding output values.</span>
	 *
	 * <img src="./img/map.png" width="100%">
	 *
	 * Similar to the well known `Array.prototype.map` function, this operator
	 * applies a projection to each value and emits that projection in the output
	 * Observable.
	 *
	 * @example <caption>Map every click to the clientX position of that click</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var positions = clicks.map(ev => ev.clientX);
	 * positions.subscribe(x => console.log(x));
	 *
	 * @see {@link mapTo}
	 * @see {@link pluck}
	 *
	 * @param {function(value: T, index: number): R} project The function to apply
	 * to each `value` emitted by the source Observable. The `index` parameter is
	 * the number `i` for the i-th emission that has happened since the
	 * subscription, starting from the number `0`.
	 * @param {any} [thisArg] An optional argument to define what `this` is in the
	 * `project` function.
	 * @return {Observable<R>} An Observable that emits the values from the source
	 * Observable transformed by the given `project` function.
	 * @method map
	 * @owner Observable
	 */
	function map(project, thisArg) {
	    return function mapOperation(source) {
	        if (typeof project !== 'function') {
	            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
	        }
	        return source.lift(new MapOperator(project, thisArg));
	    };
	}
	exports.map = map;
	var MapOperator = (function () {
	    function MapOperator(project, thisArg) {
	        this.project = project;
	        this.thisArg = thisArg;
	    }
	    MapOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
	    };
	    return MapOperator;
	}());
	exports.MapOperator = MapOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MapSubscriber = (function (_super) {
	    __extends(MapSubscriber, _super);
	    function MapSubscriber(destination, project, thisArg) {
	        _super.call(this, destination);
	        this.project = project;
	        this.count = 0;
	        this.thisArg = thisArg || this;
	    }
	    // NOTE: This looks unoptimized, but it's actually purposefully NOT
	    // using try/catch optimizations.
	    MapSubscriber.prototype._next = function (value) {
	        var result;
	        try {
	            result = this.project.call(this.thisArg, value, this.count++);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return MapSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=map.js.map

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeMap_1 = __webpack_require__(913);
	var identity_1 = __webpack_require__(2007);
	/**
	 * Converts a higher-order Observable into a first-order Observable which
	 * concurrently delivers all values that are emitted on the inner Observables.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables.</span>
	 *
	 * <img src="./img/mergeAll.png" width="100%">
	 *
	 * `mergeAll` subscribes to an Observable that emits Observables, also known as
	 * a higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, it subscribes to that and delivers all the values from the
	 * inner Observable on the output Observable. The output Observable only
	 * completes once all inner Observables have completed. Any error delivered by
	 * a inner Observable will be immediately emitted on the output Observable.
	 *
	 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
	 * var firstOrder = higherOrder.mergeAll();
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
	 * var firstOrder = higherOrder.mergeAll(2);
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link exhaust}
	 * @see {@link merge}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 * @see {@link switch}
	 * @see {@link zipAll}
	 *
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits values coming from all the
	 * inner Observables emitted by the source Observable.
	 * @method mergeAll
	 * @owner Observable
	 */
	function mergeAll(concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return mergeMap_1.mergeMap(identity_1.identity, null, concurrent);
	}
	exports.mergeAll = mergeAll;
	//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(219);
	var Notification_1 = __webpack_require__(1977);
	/**
	 *
	 * Re-emits all notifications from source Observable with specified scheduler.
	 *
	 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
	 *
	 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
	 * notifications emitted by the source Observable. It might be useful, if you do not have control over
	 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
	 *
	 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
	 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
	 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
	 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
	 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
	 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
	 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
	 * little bit more, to ensure that they are emitted at expected moments.
	 *
	 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
	 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
	 * will delay all notifications - including error notifications - while `delay` will pass through error
	 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
	 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
	 * for notification emissions in general.
	 *
	 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
	 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
	 *                                               // with async scheduler by default...
	 *
	 * intervals
	 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
	 * .subscribe(val => {                           // scheduler to ensure smooth animation.
	 *   someDiv.style.height = val + 'px';
	 * });
	 *
	 * @see {@link delay}
	 *
	 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
	 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
	 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
	 * but with provided scheduler.
	 *
	 * @method observeOn
	 * @owner Observable
	 */
	function observeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return function observeOnOperatorFunction(source) {
	        return source.lift(new ObserveOnOperator(scheduler, delay));
	    };
	}
	exports.observeOn = observeOn;
	var ObserveOnOperator = (function () {
	    function ObserveOnOperator(scheduler, delay) {
	        if (delay === void 0) { delay = 0; }
	        this.scheduler = scheduler;
	        this.delay = delay;
	    }
	    ObserveOnOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
	    };
	    return ObserveOnOperator;
	}());
	exports.ObserveOnOperator = ObserveOnOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ObserveOnSubscriber = (function (_super) {
	    __extends(ObserveOnSubscriber, _super);
	    function ObserveOnSubscriber(destination, scheduler, delay) {
	        if (delay === void 0) { delay = 0; }
	        _super.call(this, destination);
	        this.scheduler = scheduler;
	        this.delay = delay;
	    }
	    ObserveOnSubscriber.dispatch = function (arg) {
	        var notification = arg.notification, destination = arg.destination;
	        notification.observe(destination);
	        this.unsubscribe();
	    };
	    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
	        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
	    };
	    ObserveOnSubscriber.prototype._next = function (value) {
	        this.scheduleMessage(Notification_1.Notification.createNext(value));
	    };
	    ObserveOnSubscriber.prototype._error = function (err) {
	        this.scheduleMessage(Notification_1.Notification.createError(err));
	    };
	    ObserveOnSubscriber.prototype._complete = function () {
	        this.scheduleMessage(Notification_1.Notification.createComplete());
	    };
	    return ObserveOnSubscriber;
	}(Subscriber_1.Subscriber));
	exports.ObserveOnSubscriber = ObserveOnSubscriber;
	var ObserveOnMessage = (function () {
	    function ObserveOnMessage(notification, destination) {
	        this.notification = notification;
	        this.destination = destination;
	    }
	    return ObserveOnMessage;
	}());
	exports.ObserveOnMessage = ObserveOnMessage;
	//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ArrayObservable_1 = __webpack_require__(550);
	var ScalarObservable_1 = __webpack_require__(552);
	var EmptyObservable_1 = __webpack_require__(551);
	var concat_1 = __webpack_require__(1986);
	var isScheduler_1 = __webpack_require__(557);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits the items you specify as arguments before it begins to emit
	 * items emitted by the source Observable.
	 *
	 * <img src="./img/startWith.png" width="100%">
	 *
	 * @param {...T} values - Items you want the modified Observable to emit first.
	 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
	 * the emissions of the `next` notifications.
	 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
	 * emitted by the source Observable.
	 * @method startWith
	 * @owner Observable
	 */
	function startWith() {
	    var array = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        array[_i - 0] = arguments[_i];
	    }
	    return function (source) {
	        var scheduler = array[array.length - 1];
	        if (isScheduler_1.isScheduler(scheduler)) {
	            array.pop();
	        }
	        else {
	            scheduler = null;
	        }
	        var len = array.length;
	        if (len === 1) {
	            return concat_1.concat(new ScalarObservable_1.ScalarObservable(array[0], scheduler), source);
	        }
	        else if (len > 1) {
	            return concat_1.concat(new ArrayObservable_1.ArrayObservable(array, scheduler), source);
	        }
	        else {
	            return concat_1.concat(new EmptyObservable_1.EmptyObservable(scheduler), source);
	        }
	    };
	}
	exports.startWith = startWith;
	//# sourceMappingURL=startWith.js.map

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(909);
	var subscribeToResult_1 = __webpack_require__(920);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable, emitting values only from the most recently projected Observable.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link switch}.</span>
	 *
	 * <img src="./img/switchMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. Each time it observes one of these
	 * inner Observables, the output Observable begins emitting the items emitted by
	 * that inner Observable. When a new inner Observable is emitted, `switchMap`
	 * stops emitting items from the earlier-emitted inner Observable and begins
	 * emitting items from the new one. It continues to behave like this for
	 * subsequent inner Observables.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaustMap}
	 * @see {@link mergeMap}
	 * @see {@link switch}
	 * @see {@link switchMapTo}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and taking only the values from the most recently
	 * projected inner Observable.
	 * @method switchMap
	 * @owner Observable
	 */
	function switchMap(project, resultSelector) {
	    return function switchMapOperatorFunction(source) {
	        return source.lift(new SwitchMapOperator(project, resultSelector));
	    };
	}
	exports.switchMap = switchMap;
	var SwitchMapOperator = (function () {
	    function SwitchMapOperator(project, resultSelector) {
	        this.project = project;
	        this.resultSelector = resultSelector;
	    }
	    SwitchMapOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
	    };
	    return SwitchMapOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SwitchMapSubscriber = (function (_super) {
	    __extends(SwitchMapSubscriber, _super);
	    function SwitchMapSubscriber(destination, project, resultSelector) {
	        _super.call(this, destination);
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.index = 0;
	    }
	    SwitchMapSubscriber.prototype._next = function (value) {
	        var result;
	        var index = this.index++;
	        try {
	            result = this.project(value, index);
	        }
	        catch (error) {
	            this.destination.error(error);
	            return;
	        }
	        this._innerSub(result, value, index);
	    };
	    SwitchMapSubscriber.prototype._innerSub = function (result, value, index) {
	        var innerSubscription = this.innerSubscription;
	        if (innerSubscription) {
	            innerSubscription.unsubscribe();
	        }
	        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, result, value, index));
	    };
	    SwitchMapSubscriber.prototype._complete = function () {
	        var innerSubscription = this.innerSubscription;
	        if (!innerSubscription || innerSubscription.closed) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function () {
	        this.innerSubscription = null;
	    };
	    SwitchMapSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.remove(innerSub);
	        this.innerSubscription = null;
	        if (this.isStopped) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    SwitchMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (this.resultSelector) {
	            this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            this.destination.next(innerValue);
	        }
	    };
	    SwitchMapSubscriber.prototype._tryNotifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var result;
	        try {
	            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return SwitchMapSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscription_1 = __webpack_require__(396);
	/**
	 * A unit of work to be executed in a {@link Scheduler}. An action is typically
	 * created from within a Scheduler and an RxJS user does not need to concern
	 * themselves about creating and manipulating an Action.
	 *
	 * ```ts
	 * class Action<T> extends Subscription {
	 *   new (scheduler: Scheduler, work: (state?: T) => void);
	 *   schedule(state?: T, delay: number = 0): Subscription;
	 * }
	 * ```
	 *
	 * @class Action<T>
	 */
	var Action = (function (_super) {
	    __extends(Action, _super);
	    function Action(scheduler, work) {
	        _super.call(this);
	    }
	    /**
	     * Schedules this action on its parent Scheduler for execution. May be passed
	     * some context object, `state`. May happen at some point in the future,
	     * according to the `delay` parameter, if specified.
	     * @param {T} [state] Some contextual data that the `work` function uses when
	     * called by the Scheduler.
	     * @param {number} [delay] Time to wait before executing the work, where the
	     * time unit is implicit and defined by the Scheduler.
	     * @return {void}
	     */
	    Action.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        return this;
	    };
	    return Action;
	}(Subscription_1.Subscription));
	exports.Action = Action;
	//# sourceMappingURL=Action.js.map

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var root_1 = __webpack_require__(192);
	var Action_1 = __webpack_require__(2002);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AsyncAction = (function (_super) {
	    __extends(AsyncAction, _super);
	    function AsyncAction(scheduler, work) {
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.pending = false;
	        this.work = work;
	    }
	    AsyncAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (this.closed) {
	            return this;
	        }
	        // Always replace the current state with the new state.
	        this.state = state;
	        // Set the pending flag indicating that this action has been scheduled, or
	        // has recursively rescheduled itself.
	        this.pending = true;
	        var id = this.id;
	        var scheduler = this.scheduler;
	        //
	        // Important implementation note:
	        //
	        // Actions only execute once by default, unless rescheduled from within the
	        // scheduled callback. This allows us to implement single and repeat
	        // actions via the same code path, without adding API surface area, as well
	        // as mimic traditional recursion but across asynchronous boundaries.
	        //
	        // However, JS runtimes and timers distinguish between intervals achieved by
	        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
	        // serial `setTimeout` calls can be individually delayed, which delays
	        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
	        // guarantee the interval callback will be invoked more precisely to the
	        // interval period, regardless of load.
	        //
	        // Therefore, we use `setInterval` to schedule single and repeat actions.
	        // If the action reschedules itself with the same delay, the interval is not
	        // canceled. If the action doesn't reschedule, or reschedules with a
	        // different delay, the interval will be canceled after scheduled callback
	        // execution.
	        //
	        if (id != null) {
	            this.id = this.recycleAsyncId(scheduler, id, delay);
	        }
	        this.delay = delay;
	        // If this action has already an async Id, don't request a new one.
	        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
	        return this;
	    };
	    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        return root_1.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
	    };
	    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If this action is rescheduled with the same delay time, don't clear the interval id.
	        if (delay !== null && this.delay === delay && this.pending === false) {
	            return id;
	        }
	        // Otherwise, if the action's delay time is different from the current delay,
	        // or the action has been rescheduled before it's executed, clear the interval id
	        return root_1.root.clearInterval(id) && undefined || undefined;
	    };
	    /**
	     * Immediately executes this action and the `work` it contains.
	     * @return {any}
	     */
	    AsyncAction.prototype.execute = function (state, delay) {
	        if (this.closed) {
	            return new Error('executing a cancelled action');
	        }
	        this.pending = false;
	        var error = this._execute(state, delay);
	        if (error) {
	            return error;
	        }
	        else if (this.pending === false && this.id != null) {
	            // Dequeue if the action didn't reschedule itself. Don't call
	            // unsubscribe(), because the action could reschedule later.
	            // For example:
	            // ```
	            // scheduler.schedule(function doWork(counter) {
	            //   /* ... I'm a busy worker bee ... */
	            //   var originalAction = this;
	            //   /* wait 100ms before rescheduling the action */
	            //   setTimeout(function () {
	            //     originalAction.schedule(counter + 1);
	            //   }, 100);
	            // }, 1000);
	            // ```
	            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
	        }
	    };
	    AsyncAction.prototype._execute = function (state, delay) {
	        var errored = false;
	        var errorValue = undefined;
	        try {
	            this.work(state);
	        }
	        catch (e) {
	            errored = true;
	            errorValue = !!e && e || new Error(e);
	        }
	        if (errored) {
	            this.unsubscribe();
	            return errorValue;
	        }
	    };
	    /** @deprecated internal use only */ AsyncAction.prototype._unsubscribe = function () {
	        var id = this.id;
	        var scheduler = this.scheduler;
	        var actions = scheduler.actions;
	        var index = actions.indexOf(this);
	        this.work = null;
	        this.state = null;
	        this.pending = false;
	        this.scheduler = null;
	        if (index !== -1) {
	            actions.splice(index, 1);
	        }
	        if (id != null) {
	            this.id = this.recycleAsyncId(scheduler, id, null);
	        }
	        this.delay = null;
	    };
	    return AsyncAction;
	}(Action_1.Action));
	exports.AsyncAction = AsyncAction;
	//# sourceMappingURL=AsyncAction.js.map

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Scheduler_1 = __webpack_require__(1978);
	var AsyncScheduler = (function (_super) {
	    __extends(AsyncScheduler, _super);
	    function AsyncScheduler() {
	        _super.apply(this, arguments);
	        this.actions = [];
	        /**
	         * A flag to indicate whether the Scheduler is currently executing a batch of
	         * queued actions.
	         * @type {boolean}
	         */
	        this.active = false;
	        /**
	         * An internal ID used to track the latest asynchronous task such as those
	         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
	         * others.
	         * @type {any}
	         */
	        this.scheduled = undefined;
	    }
	    AsyncScheduler.prototype.flush = function (action) {
	        var actions = this.actions;
	        if (this.active) {
	            actions.push(action);
	            return;
	        }
	        var error;
	        this.active = true;
	        do {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        } while (action = actions.shift()); // exhaust the scheduler queue
	        this.active = false;
	        if (error) {
	            while (action = actions.shift()) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AsyncScheduler;
	}(Scheduler_1.Scheduler));
	exports.AsyncScheduler = AsyncScheduler;
	//# sourceMappingURL=AsyncScheduler.js.map

/***/ }),
/* 2005 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when an action is invalid because the object has been
	 * unsubscribed.
	 *
	 * @see {@link Subject}
	 * @see {@link BehaviorSubject}
	 *
	 * @class ObjectUnsubscribedError
	 */
	var ObjectUnsubscribedError = (function (_super) {
	    __extends(ObjectUnsubscribedError, _super);
	    function ObjectUnsubscribedError() {
	        var err = _super.call(this, 'object unsubscribed');
	        this.name = err.name = 'ObjectUnsubscribedError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return ObjectUnsubscribedError;
	}(Error));
	exports.ObjectUnsubscribedError = ObjectUnsubscribedError;
	//# sourceMappingURL=ObjectUnsubscribedError.js.map

/***/ }),
/* 2006 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when one or more errors have occurred during the
	 * `unsubscribe` of a {@link Subscription}.
	 */
	var UnsubscriptionError = (function (_super) {
	    __extends(UnsubscriptionError, _super);
	    function UnsubscriptionError(errors) {
	        _super.call(this);
	        this.errors = errors;
	        var err = Error.call(this, errors ?
	            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return ((i + 1) + ") " + err.toString()); }).join('\n  ') : '');
	        this.name = err.name = 'UnsubscriptionError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return UnsubscriptionError;
	}(Error));
	exports.UnsubscriptionError = UnsubscriptionError;
	//# sourceMappingURL=UnsubscriptionError.js.map

/***/ }),
/* 2007 */
/***/ (function(module, exports) {

	"use strict";
	function identity(x) {
	    return x;
	}
	exports.identity = identity;
	//# sourceMappingURL=identity.js.map

/***/ }),
/* 2008 */
/***/ (function(module, exports) {

	"use strict";
	/* tslint:disable:no-empty */
	function noop() { }
	exports.noop = noop;
	//# sourceMappingURL=noop.js.map

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var noop_1 = __webpack_require__(2008);
	/* tslint:enable:max-line-length */
	function pipe() {
	    var fns = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        fns[_i - 0] = arguments[_i];
	    }
	    return pipeFromArray(fns);
	}
	exports.pipe = pipe;
	/* @internal */
	function pipeFromArray(fns) {
	    if (!fns) {
	        return noop_1.noop;
	    }
	    if (fns.length === 1) {
	        return fns[0];
	    }
	    return function piped(input) {
	        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
	    };
	}
	exports.pipeFromArray = pipeFromArray;
	//# sourceMappingURL=pipe.js.map

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Subscriber_1 = __webpack_require__(219);
	var rxSubscriber_1 = __webpack_require__(555);
	var Observer_1 = __webpack_require__(908);
	function toSubscriber(nextOrObserver, error, complete) {
	    if (nextOrObserver) {
	        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
	            return nextOrObserver;
	        }
	        if (nextOrObserver[rxSubscriber_1.rxSubscriber]) {
	            return nextOrObserver[rxSubscriber_1.rxSubscriber]();
	        }
	    }
	    if (!nextOrObserver && !error && !complete) {
	        return new Subscriber_1.Subscriber(Observer_1.empty);
	    }
	    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
	}
	exports.toSubscriber = toSubscriber;
	//# sourceMappingURL=toSubscriber.js.map

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var errorObject_1 = __webpack_require__(915);
	var tryCatchTarget;
	function tryCatcher() {
	    try {
	        return tryCatchTarget.apply(this, arguments);
	    }
	    catch (e) {
	        errorObject_1.errorObject.e = e;
	        return errorObject_1.errorObject;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	exports.tryCatch = tryCatch;
	;
	//# sourceMappingURL=tryCatch.js.map

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var babelPluginFlowReactPropTypes_proptype_Target = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_Target || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(2).any;
	
	exports.default = function (css) {
	  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    if (false) {
	      // $FlowInvalidInputTest
	      throw new Error('Cannot create styled-component for component: ' + tag);
	    }
	
	    /* This is callable directly as a template function */
	    var templateFunction = function templateFunction(strings) {
	      for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        interpolations[_key - 1] = arguments[_key];
	      }
	
	      return componentConstructor(tag, options, css.apply(undefined, [strings].concat(interpolations)));
	    };
	
	    /* If config methods are called, wrap up a new template function and merge options */
	    templateFunction.withConfig = function (config) {
	      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
	    };
	    templateFunction.attrs = function (attrs) {
	      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
	        attrs: _extends({}, options.attrs || {}, attrs)
	      }));
	    };
	
	    return templateFunction;
	  };
	
	  return constructWithOptions;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _interleave = __webpack_require__(2027);
	
	var _interleave2 = _interopRequireDefault(_interleave);
	
	var _flatten = __webpack_require__(925);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_RuleSet = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_RuleSet || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(2).any;
	
	exports.default = function (strings) {
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  return (0, _flatten2.default)((0, _interleave2.default)(strings, interpolations));
	};
	
	module.exports = exports['default'];

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _hash = __webpack_require__(559);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _StyleSheet = __webpack_require__(172);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Stringifier = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_Stringifier || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(2).any;
	
	exports.default = function (stringifyRules, css) {
	  var injectGlobal = function injectGlobal(strings) {
	    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    var rules = css.apply(undefined, [strings].concat(interpolations));
	    var hash = (0, _hash2.default)(JSON.stringify(rules));
	
	    var componentId = 'sc-global-' + hash;
	    if (_StyleSheet2.default.instance.hasInjectedComponent(componentId)) return;
	
	    _StyleSheet2.default.instance.inject(componentId, false, stringifyRules(rules));
	  };
	
	  return injectGlobal;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _hash = __webpack_require__(559);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _StyleSheet = __webpack_require__(172);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Stringifier = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_Stringifier || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_NameGenerator = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_NameGenerator || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(2).any;
	
	var replaceWhitespace = function replaceWhitespace(str) {
	  return str.replace(/\s|\\n/g, '');
	};
	
	exports.default = function (nameGenerator, stringifyRules, css) {
	  return function (strings) {
	    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    var rules = css.apply(undefined, [strings].concat(interpolations));
	    var hash = (0, _hash2.default)(replaceWhitespace(JSON.stringify(rules)));
	
	    var existingName = _StyleSheet2.default.instance.getName(hash);
	    if (existingName) return existingName;
	
	    var name = nameGenerator(hash);
	    if (_StyleSheet2.default.instance.alreadyInjected(hash, name)) return name;
	
	    var generatedCSS = stringifyRules(rules, name, '@keyframes');
	    _StyleSheet2.default.instance.inject('sc-keyframes-' + name, true, generatedCSS, hash, name);
	    return name;
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _domElements = __webpack_require__(2022);
	
	var _domElements2 = _interopRequireDefault(_domElements);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Target = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_Target || __webpack_require__(2).any;
	
	exports.default = function (styledComponent, constructWithOptions) {
	  var styled = function styled(tag) {
	    return constructWithOptions(styledComponent, tag);
	  };
	
	  // Shorthands for all valid HTML Elements
	  _domElements2.default.forEach(function (domElement) {
	    styled[domElement] = styled(domElement);
	  });
	
	  return styled;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(2032);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ThemeProvider = __webpack_require__(398);
	
	var _isStyledComponent2 = __webpack_require__(558);
	
	var _isStyledComponent3 = _interopRequireDefault(_isStyledComponent2);
	
	var _determineTheme = __webpack_require__(924);
	
	var _determineTheme2 = _interopRequireDefault(_determineTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* globals ReactClass */
	
	var wrapWithTheme = function wrapWithTheme(Component) {
	  var _WithTheme$contextTyp;
	
	  var componentName = Component.displayName || Component.name || 'Component';
	
	  var shouldSetInnerRef = (0, _isStyledComponent3.default)(Component) ||
	  // NOTE: We can't pass a ref to a stateless functional component
	  typeof Component === 'function' && !(Component.prototype && 'isReactComponent' in Component.prototype);
	
	  var WithTheme = function (_React$Component) {
	    _inherits(WithTheme, _React$Component);
	
	    function WithTheme() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, WithTheme);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {}, _this.unsubscribeId = -1, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping
	
	
	    WithTheme.prototype.componentWillMount = function componentWillMount() {
	      var _this2 = this;
	
	      var defaultProps = this.constructor.defaultProps;
	
	      var styledContext = this.context[_ThemeProvider.CHANNEL_NEXT];
	      var themeProp = (0, _determineTheme2.default)(this.props, undefined, defaultProps);
	      if (styledContext === undefined && themeProp === undefined && ("production") !== 'production') {
	        // eslint-disable-next-line no-console
	        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
	      } else if (styledContext === undefined && themeProp !== undefined) {
	        this.setState({ theme: themeProp });
	      } else {
	        var subscribe = styledContext.subscribe;
	
	        this.unsubscribeId = subscribe(function (nextTheme) {
	          var theme = (0, _determineTheme2.default)(_this2.props, nextTheme, defaultProps);
	          _this2.setState({ theme: theme });
	        });
	      }
	    };
	
	    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var defaultProps = this.constructor.defaultProps;
	
	      this.setState(function (oldState) {
	        var theme = (0, _determineTheme2.default)(nextProps, oldState.theme, defaultProps);
	
	        return { theme: theme };
	      });
	    };
	
	    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.unsubscribeId !== -1) {
	        this.context[_ThemeProvider.CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
	      }
	    };
	
	    WithTheme.prototype.render = function render() {
	      // eslint-disable-next-line react/prop-types
	      var innerRef = this.props.innerRef;
	      var theme = this.state.theme;
	
	
	      return _react2.default.createElement(Component, _extends({
	        theme: theme
	      }, this.props, {
	        innerRef: shouldSetInnerRef ? innerRef : undefined,
	        ref: shouldSetInnerRef ? undefined : innerRef
	      }));
	    };
	
	    return WithTheme;
	  }(_react2.default.Component);
	
	  WithTheme.displayName = 'WithTheme(' + componentName + ')';
	  WithTheme.styledComponentId = 'withTheme';
	  WithTheme.contextTypes = (_WithTheme$contextTyp = {}, _WithTheme$contextTyp[_ThemeProvider.CHANNEL] = _propTypes2.default.func, _WithTheme$contextTyp[_ThemeProvider.CHANNEL_NEXT] = _ThemeProvider.CONTEXT_CHANNEL_SHAPE, _WithTheme$contextTyp);
	
	
	  return (0, _hoistNonReactStatics2.default)(WithTheme, Component);
	};
	
	exports.default = wrapWithTheme;
	module.exports = exports['default'];

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.COMPONENTS_PER_TAG = undefined;
	
	var _extractCompsFromCSS = __webpack_require__(2024);
	
	var _extractCompsFromCSS2 = _interopRequireDefault(_extractCompsFromCSS);
	
	var _nonce = __webpack_require__(926);
	
	var _nonce2 = _interopRequireDefault(_nonce);
	
	var _StyleSheet = __webpack_require__(172);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	/* eslint-disable no-underscore-dangle */
	/*
	 * Browser Style Sheet with Rehydration
	 *
	 * <style data-styled-components="x y z"
	 *        data-styled-components-is-local="true">
	 *   /· sc-component-id: a ·/
	 *   .sc-a { ... }
	 *   .x { ... }
	 *   /· sc-component-id: b ·/
	 *   .sc-b { ... }
	 *   .y { ... }
	 *   .z { ... }
	 * </style>
	 *
	 * Note: replace · with * in the above snippet.
	 * */
	
	
	var babelPluginFlowReactPropTypes_proptype_Tag = __webpack_require__(172).babelPluginFlowReactPropTypes_proptype_Tag || __webpack_require__(2).any;
	
	var COMPONENTS_PER_TAG = exports.COMPONENTS_PER_TAG = 40;
	
	var BrowserTag = function () {
	  function BrowserTag(el, isLocal) {
	    var existingSource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	    _classCallCheck(this, BrowserTag);
	
	    this.el = el;
	    this.isLocal = isLocal;
	    this.ready = false;
	
	    var extractedComps = (0, _extractCompsFromCSS2.default)(existingSource);
	
	    this.size = extractedComps.length;
	    this.components = extractedComps.reduce(function (acc, obj) {
	      acc[obj.componentId] = obj; // eslint-disable-line no-param-reassign
	      return acc;
	    }, {});
	  }
	
	  BrowserTag.prototype.isFull = function isFull() {
	    return this.size >= COMPONENTS_PER_TAG;
	  };
	
	  BrowserTag.prototype.addComponent = function addComponent(componentId) {
	    if (!this.ready) this.replaceElement();
	    if (false) {
	      throw new Error('Trying to add Component \'' + componentId + '\' twice!');
	    }
	
	    var comp = { componentId: componentId, textNode: document.createTextNode('') };
	    this.el.appendChild(comp.textNode);
	
	    this.size += 1;
	    this.components[componentId] = comp;
	  };
	
	  BrowserTag.prototype.inject = function inject(componentId, css, name) {
	    if (!this.ready) this.replaceElement();
	    var comp = this.components[componentId];
	
	    if (false) {
	      throw new Error('Must add a new component before you can inject css into it');
	    }
	    if (comp.textNode.data === '') {
	      comp.textNode.appendData('\n/* sc-component-id: ' + componentId + ' */\n');
	    }
	
	    comp.textNode.appendData(css);
	    if (name) {
	      var existingNames = this.el.getAttribute(_StyleSheet.SC_ATTR);
	      this.el.setAttribute(_StyleSheet.SC_ATTR, existingNames ? existingNames + ' ' + name : name);
	    }
	
	    var nonce = (0, _nonce2.default)();
	
	    if (nonce) {
	      this.el.setAttribute('nonce', nonce);
	    }
	  };
	
	  BrowserTag.prototype.toHTML = function toHTML() {
	    return this.el.outerHTML;
	  };
	
	  BrowserTag.prototype.toReactElement = function toReactElement() {
	    throw new Error("BrowserTag doesn't implement toReactElement!");
	  };
	
	  BrowserTag.prototype.clone = function clone() {
	    throw new Error('BrowserTag cannot be cloned!');
	  };
	
	  /* Because we care about source order, before we can inject anything we need to
	   * create a text node for each component and replace the existing CSS. */
	
	
	  BrowserTag.prototype.replaceElement = function replaceElement() {
	    var _this = this;
	
	    this.ready = true;
	    // We have nothing to inject. Use the current el.
	    if (this.size === 0) return;
	
	    // Build up our replacement style tag
	    var newEl = this.el.cloneNode();
	    newEl.appendChild(document.createTextNode('\n'));
	
	    Object.keys(this.components).forEach(function (key) {
	      var comp = _this.components[key];
	
	      // eslint-disable-next-line no-param-reassign
	      comp.textNode = document.createTextNode(comp.cssFromDOM);
	      newEl.appendChild(comp.textNode);
	    });
	
	    if (!this.el.parentNode) {
	      throw new Error("Trying to replace an element that wasn't mounted!");
	    }
	
	    // The ol' switcheroo
	    this.el.parentNode.replaceChild(newEl, this.el);
	    this.el = newEl;
	  };
	
	  return BrowserTag;
	}();
	
	/* Factory function to separate DOM operations from logical ones*/
	
	
	exports.default = {
	  create: function create() {
	    var tags = [];
	    var names = {};
	
	    /* Construct existing state from DOM */
	    var nodes = document.querySelectorAll('[' + _StyleSheet.SC_ATTR + ']');
	    var nodesLength = nodes.length;
	
	    for (var i = 0; i < nodesLength; i += 1) {
	      var el = nodes[i];
	
	      tags.push(new BrowserTag(el, el.getAttribute(_StyleSheet.LOCAL_ATTR) === 'true', el.innerHTML));
	
	      var attr = el.getAttribute(_StyleSheet.SC_ATTR);
	      if (attr) {
	        attr.trim().split(/\s+/).forEach(function (name) {
	          names[name] = true;
	        });
	      }
	    }
	
	    /* Factory for making more tags */
	    var tagConstructor = function tagConstructor(isLocal) {
	      var el = document.createElement('style');
	      el.type = 'text/css';
	      el.setAttribute(_StyleSheet.SC_ATTR, '');
	      el.setAttribute(_StyleSheet.LOCAL_ATTR, isLocal ? 'true' : 'false');
	      if (!document.head) throw new Error('Missing document <head>');
	      document.head.appendChild(el);
	      return new BrowserTag(el, isLocal);
	    };
	
	    return new _StyleSheet2.default(tagConstructor, tags, names);
	  }
	};

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	exports.__esModule = true;
	
	var _hash = __webpack_require__(559);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _StyleSheet = __webpack_require__(172);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _isStyledComponent = __webpack_require__(558);
	
	var _isStyledComponent2 = _interopRequireDefault(_isStyledComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var babelPluginFlowReactPropTypes_proptype_Stringifier = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_Stringifier || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_Flattener = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_Flattener || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_NameGenerator = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_NameGenerator || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_RuleSet = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_RuleSet || __webpack_require__(2).any;
	
	var isStaticRules = function isStaticRules(rules, attrs) {
	  for (var i = 0; i < rules.length; i += 1) {
	    var rule = rules[i];
	
	    // recursive case
	    if (Array.isArray(rule) && !isStaticRules(rule)) {
	      return false;
	    } else if (typeof rule === 'function' && !(0, _isStyledComponent2.default)(rule)) {
	      // functions are allowed to be static if they're just being
	      // used to get the classname of a nested styled copmonent
	      return false;
	    }
	  }
	
	  if (attrs !== undefined) {
	    // eslint-disable-next-line guard-for-in, no-restricted-syntax
	    for (var key in attrs) {
	      var value = attrs[key];
	      if (typeof value === 'function') {
	        return false;
	      }
	    }
	  }
	
	  return true;
	};
	
	var isHRMEnabled = typeof module !== 'undefined' && module.hot && ("production") !== 'production';
	
	/*
	 ComponentStyle is all the CSS-specific stuff, not
	 the React-specific stuff.
	 */
	
	exports.default = function (nameGenerator, flatten, stringifyRules) {
	  var ComponentStyle = function () {
	    function ComponentStyle(rules, attrs, componentId) {
	      _classCallCheck(this, ComponentStyle);
	
	      this.rules = rules;
	      this.isStatic = !isHRMEnabled && isStaticRules(rules, attrs);
	      this.componentId = componentId;
	      if (!_StyleSheet2.default.instance.hasInjectedComponent(this.componentId)) {
	        var placeholder =  false ? '.' + componentId + ' {}' : '';
	        _StyleSheet2.default.instance.deferredInject(componentId, true, placeholder);
	      }
	    }
	
	    /*
	     * Flattens a rule set into valid CSS
	     * Hashes it, wraps the whole chunk in a .hash1234 {}
	     * Returns the hash to be injected on render()
	     * */
	
	
	    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
	      var isStatic = this.isStatic,
	          lastClassName = this.lastClassName;
	
	      if (isStatic && lastClassName !== undefined) {
	        return lastClassName;
	      }
	
	      var flatCSS = flatten(this.rules, executionContext);
	      var hash = (0, _hash2.default)(this.componentId + flatCSS.join(''));
	
	      var existingName = styleSheet.getName(hash);
	      if (existingName !== undefined) {
	        if (styleSheet.stylesCacheable) {
	          this.lastClassName = existingName;
	        }
	        return existingName;
	      }
	
	      var name = nameGenerator(hash);
	      if (styleSheet.stylesCacheable) {
	        this.lastClassName = existingName;
	      }
	      if (styleSheet.alreadyInjected(hash, name)) {
	        return name;
	      }
	
	      var css = '\n' + stringifyRules(flatCSS, '.' + name);
	      // NOTE: this can only be set when we inject the class-name.
	      // For some reason, presumably due to how css is stringifyRules behaves in
	      // differently between client and server, styles break.
	      styleSheet.inject(this.componentId, true, css, hash, name);
	      return name;
	    };
	
	    ComponentStyle.generateName = function generateName(str) {
	      return nameGenerator((0, _hash2.default)(str));
	    };
	
	    return ComponentStyle;
	  }();
	
	  return ComponentStyle;
	};
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(177)(module)))

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createWarnTooManyClasses = __webpack_require__(2021);
	
	var _createWarnTooManyClasses2 = _interopRequireDefault(_createWarnTooManyClasses);
	
	var _validAttr = __webpack_require__(2031);
	
	var _validAttr2 = _interopRequireDefault(_validAttr);
	
	var _isTag = __webpack_require__(2028);
	
	var _isTag2 = _interopRequireDefault(_isTag);
	
	var _isStyledComponent = __webpack_require__(558);
	
	var _isStyledComponent2 = _interopRequireDefault(_isStyledComponent);
	
	var _getComponentName = __webpack_require__(2026);
	
	var _getComponentName2 = _interopRequireDefault(_getComponentName);
	
	var _determineTheme = __webpack_require__(924);
	
	var _determineTheme2 = _interopRequireDefault(_determineTheme);
	
	var _escape = __webpack_require__(2023);
	
	var _escape2 = _interopRequireDefault(_escape);
	
	var _ThemeProvider = __webpack_require__(398);
	
	var _StyleSheet = __webpack_require__(172);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _ServerStyleSheet = __webpack_require__(397);
	
	var _ServerStyleSheet2 = _interopRequireDefault(_ServerStyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var babelPluginFlowReactPropTypes_proptype_Theme = __webpack_require__(398).babelPluginFlowReactPropTypes_proptype_Theme || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_Target = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_Target || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_RuleSet = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_RuleSet || __webpack_require__(2).any;
	
	// HACK for generating all static styles without needing to allocate
	// an empty execution context every single time...
	var STATIC_EXECUTION_CONTEXT = {};
	
	exports.default = function (ComponentStyle, constructWithOptions) {
	  var identifiers = {};
	
	  /* We depend on components having unique IDs */
	  var generateId = function generateId(_displayName, parentComponentId) {
	    var displayName = typeof _displayName !== 'string' ? 'sc' : (0, _escape2.default)(_displayName);
	
	    var componentId = void 0;
	
	    /**
	     * only fall back to hashing the component injection order if
	     * a proper displayName isn't provided by the babel plugin
	     */
	    if (!_displayName) {
	      var nr = (identifiers[displayName] || 0) + 1;
	      identifiers[displayName] = nr;
	
	      componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
	    } else {
	      componentId = displayName + '-' + ComponentStyle.generateName(displayName);
	    }
	
	    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
	  };
	
	  var BaseStyledComponent = function (_Component) {
	    _inherits(BaseStyledComponent, _Component);
	
	    function BaseStyledComponent() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, BaseStyledComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
	        theme: null,
	        generatedClassName: ''
	      }, _this.unsubscribeId = -1, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
	      if (this.unsubscribeId !== -1) {
	        this.context[_ThemeProvider.CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
	      }
	    };
	
	    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
	      var attrs = this.constructor.attrs;
	
	      var context = _extends({}, props, { theme: theme });
	      if (attrs === undefined) {
	        return context;
	      }
	
	      this.attrs = Object.keys(attrs).reduce(function (acc, key) {
	        var attr = attrs[key];
	        // eslint-disable-next-line no-param-reassign
	        acc[key] = typeof attr === 'function' ? attr(context) : attr;
	        return acc;
	      }, {});
	
	      return _extends({}, context, this.attrs);
	    };
	
	    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
	      var _constructor = this.constructor,
	          attrs = _constructor.attrs,
	          componentStyle = _constructor.componentStyle,
	          warnTooManyClasses = _constructor.warnTooManyClasses;
	
	      var styleSheet = this.context[_StyleSheet.CONTEXT_KEY] || _StyleSheet2.default.instance;
	
	      // staticaly styled-components don't need to build an execution context object,
	      // and shouldn't be increasing the number of class names
	      if (componentStyle.isStatic && attrs === undefined) {
	        return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
	      } else {
	        var executionContext = this.buildExecutionContext(theme, props);
	        var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);
	
	        if (false) {
	          warnTooManyClasses(className);
	        }
	
	        return className;
	      }
	    };
	
	    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
	      var _this2 = this;
	
	      var componentStyle = this.constructor.componentStyle;
	
	      var styledContext = this.context[_ThemeProvider.CHANNEL_NEXT];
	
	      // If this is a staticaly-styled component, we don't need to the theme
	      // to generate or build styles.
	      if (componentStyle.isStatic) {
	        var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
	        this.setState({ generatedClassName: generatedClassName });
	        // If there is a theme in the context, subscribe to the event emitter. This
	        // is necessary due to pure components blocking context updates, this circumvents
	        // that by updating when an event is emitted
	      } else if (styledContext !== undefined) {
	        var subscribe = styledContext.subscribe;
	
	        this.unsubscribeId = subscribe(function (nextTheme) {
	          // This will be called once immediately
	          var theme = (0, _determineTheme2.default)(_this2.props, nextTheme, _this2.constructor.defaultProps);
	          var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
	
	          _this2.setState({ theme: theme, generatedClassName: generatedClassName });
	        });
	      } else {
	        // eslint-disable-next-line react/prop-types
	        var _theme = this.props.theme || {};
	        var _generatedClassName = this.generateAndInjectStyles(_theme, this.props);
	        this.setState({ theme: _theme, generatedClassName: _generatedClassName });
	      }
	    };
	
	    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      // If this is a staticaly-styled component, we don't need to listen to
	      // props changes to update styles
	      var componentStyle = this.constructor.componentStyle;
	
	      if (componentStyle.isStatic) {
	        return;
	      }
	
	      this.setState(function (oldState) {
	        var theme = (0, _determineTheme2.default)(nextProps, oldState.theme, _this3.constructor.defaultProps);
	        var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);
	
	        return { theme: theme, generatedClassName: generatedClassName };
	      });
	    };
	
	    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	      this.unsubscribeFromContext();
	    };
	
	    BaseStyledComponent.prototype.render = function render() {
	      var _this4 = this;
	
	      // eslint-disable-next-line react/prop-types
	      var innerRef = this.props.innerRef;
	      var generatedClassName = this.state.generatedClassName;
	      var _constructor2 = this.constructor,
	          styledComponentId = _constructor2.styledComponentId,
	          target = _constructor2.target;
	
	
	      var isTargetTag = (0, _isTag2.default)(target);
	
	      var className = [
	      // eslint-disable-next-line react/prop-types
	      this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');
	
	      var baseProps = _extends({}, this.attrs, {
	        className: className
	      });
	
	      if ((0, _isStyledComponent2.default)(target)) {
	        baseProps.innerRef = innerRef;
	      } else {
	        baseProps.ref = innerRef;
	      }
	
	      var propsForElement = Object.keys(this.props).reduce(function (acc, propName) {
	        // Don't pass through non HTML tags through to HTML elements
	        // always omit innerRef
	        if (propName !== 'innerRef' && propName !== 'className' && (!isTargetTag || (0, _validAttr2.default)(propName))) {
	          // eslint-disable-next-line no-param-reassign
	          acc[propName] = _this4.props[propName];
	        }
	
	        return acc;
	      }, baseProps);
	
	      return (0, _react.createElement)(target, propsForElement);
	    };
	
	    return BaseStyledComponent;
	  }(_react.Component);
	
	  var createStyledComponent = function createStyledComponent(target, options, rules) {
	    var _StyledComponent$cont;
	
	    var _options$displayName = options.displayName,
	        displayName = _options$displayName === undefined ? (0, _isTag2.default)(target) ? 'styled.' + target : 'Styled(' + (0, _getComponentName2.default)(target) + ')' : _options$displayName,
	        _options$componentId = options.componentId,
	        componentId = _options$componentId === undefined ? generateId(options.displayName, options.parentComponentId) : _options$componentId,
	        _options$ParentCompon = options.ParentComponent,
	        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
	        extendingRules = options.rules,
	        attrs = options.attrs;
	
	
	    var styledComponentId = options.displayName && options.componentId ? (0, _escape2.default)(options.displayName) + '-' + options.componentId : componentId;
	
	    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);
	
	    var StyledComponent = function (_ParentComponent) {
	      _inherits(StyledComponent, _ParentComponent);
	
	      function StyledComponent() {
	        _classCallCheck(this, StyledComponent);
	
	        return _possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
	      }
	
	      StyledComponent.withComponent = function withComponent(tag) {
	        var previousComponentId = options.componentId,
	            optionsToCopy = _objectWithoutProperties(options, ['componentId']);
	
	        var newComponentId = previousComponentId && previousComponentId + '-' + ((0, _isTag2.default)(tag) ? tag : (0, _escape2.default)((0, _getComponentName2.default)(tag)));
	
	        var newOptions = _extends({}, optionsToCopy, {
	          componentId: newComponentId,
	          ParentComponent: StyledComponent
	        });
	
	        return createStyledComponent(tag, newOptions, rules);
	      };
	
	      _createClass(StyledComponent, null, [{
	        key: 'extend',
	        get: function get() {
	          var rulesFromOptions = options.rules,
	              parentComponentId = options.componentId,
	              optionsToCopy = _objectWithoutProperties(options, ['rules', 'componentId']);
	
	          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);
	
	          var newOptions = _extends({}, optionsToCopy, {
	            rules: newRules,
	            parentComponentId: parentComponentId,
	            ParentComponent: StyledComponent
	          });
	
	          return constructWithOptions(createStyledComponent, target, newOptions);
	        }
	      }]);
	
	      return StyledComponent;
	    }(ParentComponent);
	
	    StyledComponent.contextTypes = (_StyledComponent$cont = {}, _StyledComponent$cont[_ThemeProvider.CHANNEL] = _propTypes2.default.func, _StyledComponent$cont[_ThemeProvider.CHANNEL_NEXT] = _ThemeProvider.CONTEXT_CHANNEL_SHAPE, _StyledComponent$cont[_StyleSheet.CONTEXT_KEY] = _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_StyleSheet2.default), _propTypes2.default.instanceOf(_ServerStyleSheet2.default)]), _StyledComponent$cont);
	    StyledComponent.displayName = displayName;
	    StyledComponent.styledComponentId = styledComponentId;
	    StyledComponent.attrs = attrs;
	    StyledComponent.componentStyle = componentStyle;
	    StyledComponent.target = target;
	
	
	    if (false) {
	      StyledComponent.warnTooManyClasses = (0, _createWarnTooManyClasses2.default)(displayName);
	    }
	
	    return StyledComponent;
	  };
	
	  return createStyledComponent;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 2021 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var LIMIT = 200;
	
	exports.default = function (displayName) {
	  var generatedClasses = {};
	  var warningSeen = false;
	
	  return function (className) {
	    if (!warningSeen) {
	      generatedClasses[className] = true;
	      if (Object.keys(generatedClasses).length >= LIMIT) {
	        // Unable to find latestRule in test environment.
	        /* eslint-disable no-console, prefer-template */
	        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
	        warningSeen = true;
	        generatedClasses = {};
	      }
	    }
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 2022 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	// Thanks to ReactDOMFactories for this handy list!
	
	exports.default = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
	
	// SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	module.exports = exports['default'];

/***/ }),
/* 2023 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = escape;
	var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
	var dashesAtEnds = /(^-|-$)/g;
	
	/**
	 * TODO: Explore using CSS.escape when it becomes more available
	 * in evergreen browsers.
	 */
	function escape(str) {
	  return str
	  // Replace all possible CSS selectors
	  .replace(escapeRegex, '-')
	
	  // Remove extraneous hyphens at the start and end
	  .replace(dashesAtEnds, '');
	}
	module.exports = exports['default'];

/***/ }),
/* 2024 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s+(\S+)\s+\*\//gm;
	
	exports.default = function (maybeCSS) {
	  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
	  var existingComponents = [];
	  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
	    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
	    return match;
	  });
	  return existingComponents.map(function (_ref, i) {
	    var componentId = _ref.componentId,
	        matchIndex = _ref.matchIndex;
	
	    var nextComp = existingComponents[i + 1];
	    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
	    return { componentId: componentId, cssFromDOM: cssFromDOM };
	  });
	};
	
	module.exports = exports['default'];

/***/ }),
/* 2025 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
	var charsLength = chars.length;
	
	/* Some high number, usually 9-digit base-10. Map it to base-😎 */
	var generateAlphabeticName = function generateAlphabeticName(code) {
	  var name = '';
	  var x = void 0;
	
	  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
	    name = chars[x % charsLength] + name;
	  }
	
	  return chars[x % charsLength] + name;
	};
	
	exports.default = generateAlphabeticName;
	module.exports = exports['default'];

/***/ }),
/* 2026 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getComponentName;
	
	
	/* eslint-disable no-undef */
	function getComponentName(target) {
	  return target.displayName || target.name || 'Component';
	}
	module.exports = exports['default'];

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(2).any;
	
	exports.default = function (strings, interpolations) {
	  return interpolations.reduce(function (array, interp, i) {
	    return array.concat(interp, strings[i + 1]);
	  }, [strings[0]]);
	};
	
	module.exports = exports['default'];

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isTag;
	
	var babelPluginFlowReactPropTypes_proptype_Target = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_Target || __webpack_require__(2).any;
	
	function isTag(target) /* : %checks */{
	  return typeof target === 'string';
	}
	module.exports = exports['default'];

/***/ }),
/* 2029 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	// Helper to call a given function, only once
	exports.default = function (cb) {
	  var called = false;
	
	  return function () {
	    if (!called) {
	      called = true;
	      cb();
	    }
	  };
	};
	
	module.exports = exports["default"];

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _stylis = __webpack_require__(2033);
	
	var _stylis2 = _interopRequireDefault(_stylis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(86).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(2).any;
	
	var stylis = new _stylis2.default({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: true,
	  compress: false,
	  semicolon: true
	});
	
	var stringifyRules = function stringifyRules(rules, selector, prefix) {
	  var flatCSS = rules.join('').replace(/^\s*\/\/.*$/gm, ''); // replace JS comments
	
	  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
	
	  return stylis(prefix || !selector ? '' : selector, cssStr);
	};
	
	exports.default = stringifyRules;
	module.exports = exports['default'];

/***/ }),
/* 2031 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	/* eslint-disable max-len */
	/**
	 * Trying to avoid the unknown-prop errors on styled components by filtering by
	 * React's attribute whitelist.
	 *
	 * To regenerate this regex:
	 *
	 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
	 * 2. Run `regexgen` with the list of space-separated words below as input
	 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
	 *    and no false positives from partials
	 **/
	/*
	children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan
	*/
	/* eslint-enable max-len */
	
	var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|(?:attribute|glyph)Nam|playsInlin|(?:formE|e)ncTyp|(?:writing|input|edge)Mod|(?:xlinkTy|itemSco|keyTy|slo)p|(?:amplitu|mo)d|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ntrol|ord)s|o(?:lor(?:Interpolation)?|ntent)|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|o(?:ntextMenu|ls)|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|(?:rossOrigi|olSpa)n|apHeight|lip(?:Path)?|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|autoFocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|formActio|zoomAndPa|onFocusI|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveA(?:spectRatio|lpha)|ointsAt[X-Z]|anose1)|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:gradientT|patternT|t)ransform|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:strokeMiterlimi|(?:specularConsta|repeatCou|fontVaria)n|(?:(?:specularE|e)xpon|renderingInt|asc)en|d(?:iffuseConsta|esce)n|(?:fontSizeAdju|lengthAdju|manife)s|baselineShif|vectorEffec|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|a(?:utoCorrec|bou)|markerStar|onFocusOu|in(?:tercep|lis)|restar|forma|heigh|lis)t|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|m(?:arkerMi|etho)|preloa|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:allowFullScre|hidd)en|strokeDasharray|systemLanguage|(?:strokeLineca|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|(?:pointerEve|keyPoi)nts|unicodeRange|(?:(?:allowReord|placehold|frameBord|paintOrd|post|ord)e|repeatDu|d(?:efe|u))r|mathematical|(?:vI|i)deographic|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|vAlphabetic|mediaGroup|spellCheck|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|(?:xmlnsXl|valueL)ink|a(?:rabicForm|l(?:phabetic|t)|sync)|pathLength|(?:text|m(?:in|ax))Length|innerHTML|xlinkShow|(?:xlinkHr|glyphR)ef|r(?:e(?:quired|sult|f))?|o(?:verflow|pen)|(?:tabInde|(?:sand|b)bo|viewBo)x|(?:(?:href|xml|src)La|kerni)ng|f(?:o(?:ntSize|rm)|il(?:ter|l))|autoPlay|unicode|p(?:attern|oints)|t(?:arget[XY]|o)|i(?:temRef|n2|s)|divisor|d(?:efault|ata|ir)?|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|(?:width|size)s|(?:stri|la)ng|prefix|itemID|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|s)|t(?:arget|ype)|typeof|width|value|x(?:mlns)?|label|m(?:edia|a(?:sk|x)|in)|size|href|k(?:ey)?|end|low|x[12]|i[dn]|y[12]|g[12]|by|f[xy]|[yz])$/;
	
	/* From DOMProperty */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
	var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
	
	exports.default = function (name) {
	  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
	};
	
	module.exports = exports['default'];

/***/ }),
/* 2032 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*
	 *          __        ___
	 *    _____/ /___  __/ (_)____
	 *   / ___/ __/ / / / / / ___/
	 *  (__  ) /_/ /_/ / / (__  )
	 * /____/\__/\__, /_/_/____/
	 *          /____/
	 *
	 * light - weight css preprocessor @licence MIT
	 */
	(function (factory) {/* eslint-disable */
		 true ? (module['exports'] = factory(null)) :
			typeof define === 'function' && define['amd'] ? define(factory(null)) :
				(window['stylis'] = factory(null))
	}(/** @param {*=} options */function factory (options) {/* eslint-disable */
	
		'use strict'
	
		/**
		 * Notes
		 *
		 * The ['<method name>'] pattern is used to support closure compiler
		 * the jsdoc signatures are also used to the same effect
		 *
		 * ----
		 *
		 * int + int + int === n4 [faster]
		 *
		 * vs
		 *
		 * int === n1 && int === n2 && int === n3
		 *
		 * ----
		 *
		 * switch (int) { case ints...} [faster]
		 *
		 * vs
		 *
		 * if (int == 1 && int === 2 ...)
		 *
		 * ----
		 *
		 * The (first*n1 + second*n2 + third*n3) format used in the property parser
		 * is a simple way to hash the sequence of characters
		 * taking into account the index they occur in
		 * since any number of 3 character sequences could produce duplicates.
		 *
		 * On the other hand sequences that are directly tied to the index of the character
		 * resolve a far more accurate measure, it's also faster
		 * to evaluate one condition in a switch statement
		 * than three in an if statement regardless of the added math.
		 *
		 * This allows the vendor prefixer to be both small and fast.
		 */
	
		var nullptn = /^\0+/g /* matches leading null characters */
		var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
		var colonptn = /: */g /* splits animation rules */
		var cursorptn = /zoo|gra/ /* assert cursor varient */
		var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
		var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
		var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
		var elementptn = / *[\0] */g /* selector elements */
		var selectorptn = /,\r+?/g /* splits selectors */
		var andptn = /([\t\r\n ])*\f?&/g /* match & */
		var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
		var invalidptn = /\W+/g /* removes invalid characters from keyframes */
		var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
		var plcholdrptn = /::(place)/g /* match ::placeholder varient */
		var readonlyptn = /:(read-only)/g /* match :read-only varient */
		var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
		var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
		var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
		var whiteptn = /\s{2,}/g /* matches repeating whitespace */
		var pseudoptn = /([^\(])(:+) */g /* pseudo element */
		var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
		var gradientptn = /([\w-]+t\()/g /* match *gradient property */
		var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
		var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
		var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
		var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
		var trimptn = /[ \t]+$/ /* match tail whitspace */
		var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
		var imgsrcptn = /([^-])(image-set\()/
	
		/* vendors */
		var webkit = '-webkit-'
		var moz = '-moz-'
		var ms = '-ms-'
	
		/* character codes */
		var SEMICOLON = 59 /* ; */
		var CLOSEBRACES = 125 /* } */
		var OPENBRACES = 123 /* { */
		var OPENPARENTHESES = 40 /* ( */
		var CLOSEPARENTHESES = 41 /* ) */
		var OPENBRACKET = 91 /* [ */
		var CLOSEBRACKET = 93 /* ] */
		var NEWLINE = 10 /* \n */
		var CARRIAGE = 13 /* \r */
		var TAB = 9 /* \t */
		var AT = 64 /* @ */
		var SPACE = 32 /*   */
		var AND = 38 /* & */
		var DASH = 45 /* - */
		var UNDERSCORE = 95 /* _ */
		var STAR = 42 /* * */
		var COMMA = 44 /* , */
		var COLON = 58 /* : */
		var SINGLEQUOTE = 39 /* ' */
		var DOUBLEQUOTE = 34 /* " */
		var FOWARDSLASH = 47 /* / */
		var GREATERTHAN = 62 /* > */
		var PLUS = 43 /* + */
		var TILDE = 126 /* ~ */
		var NULL = 0 /* \0 */
		var FORMFEED = 12 /* \f */
		var VERTICALTAB = 11 /* \v */
	
		/* special identifiers */
		var KEYFRAME = 107 /* k */
		var MEDIA = 109 /* m */
		var SUPPORTS = 115 /* s */
		var PLACEHOLDER = 112 /* p */
		var READONLY = 111 /* o */
		var IMPORT = 105 /* <at>i */
		var CHARSET = 99 /* <at>c */
		var DOCUMENT = 100 /* <at>d */
		var PAGE = 112 /* <at>p */
	
		var column = 1 /* current column */
		var line = 1 /* current line numebr */
		var pattern = 0 /* :pattern */
	
		var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
		var prefix = 1 /* vendor prefix */
		var escape = 1 /* escape :global() pattern */
		var compress = 0 /* compress output */
		var semicolon = 0 /* no/semicolon option */
		var preserve = 0 /* preserve empty selectors */
	
		/* empty reference */
		var array = []
	
		/* plugins */
		var plugins = []
		var plugged = 0
		var should = null
	
		/* plugin context */
		var POSTS = -2
		var PREPS = -1
		var UNKWN = 0
		var PROPS = 1
		var BLCKS = 2
		var ATRUL = 3
	
		/* plugin newline context */
		var unkwn = 0
	
		/* keyframe animation */
		var keyed = 1
		var key = ''
	
		/* selector namespace */
		var nscopealt = ''
		var nscope = ''
	
		/**
		 * Compile
		 *
		 * @param {Array<string>} parent
		 * @param {Array<string>} current
		 * @param {string} body
		 * @param {number} id
		 * @param {number} depth
		 * @return {string}
		 */
		function compile (parent, current, body, id, depth) {
			var bracket = 0 /* brackets [] */
			var comment = 0 /* comments /* // or /* */
			var parentheses = 0 /* functions () */
			var quote = 0 /* quotes '', "" */
	
			var first = 0 /* first character code */
			var second = 0 /* second character code */
			var code = 0 /* current character code */
			var tail = 0 /* previous character code */
			var trail = 0 /* character before previous code */
			var peak = 0 /* previous non-whitespace code */
	
			var counter = 0 /* count sequence termination */
			var context = 0 /* track current context */
			var atrule = 0 /* track @at-rule context */
			var pseudo = 0 /* track pseudo token index */
			var caret = 0 /* current character index */
			var format = 0 /* control character formating context */
			var insert = 0 /* auto semicolon insertion */
			var invert = 0 /* inverted selector pattern */
			var length = 0 /* generic length address */
			var eof = body.length /* end of file(length) */
			var eol = eof - 1 /* end of file(characters) */
	
			var char = '' /* current character */
			var chars = '' /* current buffer of characters */
			var child = '' /* next buffer of characters */
			var out = '' /* compiled body */
			var children = '' /* compiled children */
			var flat = '' /* compiled leafs */
			var selector /* generic selector address */
			var result /* generic address */
	
			// ...build body
			while (caret < eof) {
				code = body.charCodeAt(caret)
	
				// eof varient
				if (caret === eol) {
					// last character + noop context, add synthetic padding for noop context to terminate
					if (comment + quote + parentheses + bracket !== 0) {
						if (comment !== 0) {
							code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
						}
	
						quote = parentheses = bracket = 0
						eof++
						eol++
					}
				}
	
				if (comment + quote + parentheses + bracket === 0) {
					// eof varient
					if (caret === eol) {
						if (format > 0) {
							chars = chars.replace(formatptn, '')
						}
	
						if (chars.trim().length > 0) {
							switch (code) {
								case SPACE:
								case TAB:
								case SEMICOLON:
								case CARRIAGE:
								case NEWLINE: {
									break
								}
								default: {
									chars += body.charAt(caret)
								}
							}
	
							code = SEMICOLON
						}
					}
	
					// auto semicolon insertion
					if (insert === 1) {
						switch (code) {
							// false flags
							case OPENBRACES:
							case CLOSEBRACES:
							case SEMICOLON:
							case DOUBLEQUOTE:
							case SINGLEQUOTE:
							case OPENPARENTHESES:
							case CLOSEPARENTHESES:
							case COMMA: {
								insert = 0
							}
							// ignore
							case TAB:
							case CARRIAGE:
							case NEWLINE:
							case SPACE: {
								break
							}
							// valid
							default: {
								insert = 0
								length = caret
								first = code
								caret--
								code = SEMICOLON
	
								while (length < eof) {
									switch (body.charCodeAt(length++)) {
										case NEWLINE:
										case CARRIAGE:
										case SEMICOLON: {
											++caret
											code = first
											length = eof
											break
										}
										case COLON: {
											if (format > 0) {
												++caret
												code = first
											}
										}
										case OPENBRACES: {
											length = eof
										}
									}
								}
							}
						}
					}
	
					// token varient
					switch (code) {
						case OPENBRACES: {
							chars = chars.trim()
							first = chars.charCodeAt(0)
							counter = 1
							length = ++caret
	
							while (caret < eof) {
								switch (code = body.charCodeAt(caret)) {
									case OPENBRACES: {
										counter++
										break
									}
									case CLOSEBRACES: {
										counter--
										break
									}
									case FOWARDSLASH: {
										switch (second = body.charCodeAt(caret + 1)) {
											// /*, //
											case STAR:
											case FOWARDSLASH: {
												caret = delimited(second, caret, eol, body)
											}
										}
										break
									}
									// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
									case OPENBRACKET: {
										code++
									}
									// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
									case OPENPARENTHESES: {
										code++
									}
									// quote tail delimiter is identical to the head delimiter hence noop,
									// fallthrough clauses have been shifted to the correct tail delimiter
									case DOUBLEQUOTE:
									case SINGLEQUOTE: {
										while (caret++ < eol) {
											if (body.charCodeAt(caret) === code) {
												break
											}
										}
									}
								}
	
								if (counter === 0) {
									break
								}
	
								caret++
							}
	
							child = body.substring(length, caret)
	
							if (first === NULL) {
								first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
							}
	
							switch (first) {
								// @at-rule
								case AT: {
									if (format > 0) {
										chars = chars.replace(formatptn, '')
									}
	
									second = chars.charCodeAt(1)
	
									switch (second) {
										case DOCUMENT:
										case MEDIA:
										case SUPPORTS:
										case DASH: {
											selector = current
											break
										}
										default: {
											selector = array
										}
									}
	
									child = compile(current, selector, child, second, depth+1)
									length = child.length
	
									// preserve empty @at-rule
									if (preserve > 0 && length === 0) {
										length = chars.length
									}
	
									// execute plugins, @at-rule context
									if (plugged > 0) {
										selector = select(array, chars, invert)
										result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
										chars = selector.join('')
	
										if (result !== void 0) {
											if ((length = (child = result.trim()).length) === 0) {
												second = 0
												child = ''
											}
										}
									}
	
									if (length > 0) {
										switch (second) {
											case SUPPORTS: {
												chars = chars.replace(supportsptn, supports)
											}
											case DOCUMENT:
											case MEDIA:
											case DASH: {
												child = chars + '{' + child + '}'
												break
											}
											case KEYFRAME: {
												chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
												child = chars + '{' + child + '}'
	
												if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
													child = '@' + webkit + child + '@' + child
												} else {
													child = '@' + child
												}
												break
											}
											default: {
												child = chars + child
	
												if (id === PAGE) {
													child = (out += child, '')
												}
											}
										}
									} else {
										child = ''
									}
	
									break
								}
								// selector
								default: {
									child = compile(current, select(current, chars, invert), child, id, depth+1)
								}
							}
	
							children += child
	
							// reset
							context = 0
							insert = 0
							pseudo = 0
							format = 0
							invert = 0
							atrule = 0
							chars = ''
							child = ''
							code = body.charCodeAt(++caret)
							break
						}
						case CLOSEBRACES:
						case SEMICOLON: {
							chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()
	
							if ((length = chars.length) > 1) {
								// monkey-patch missing colon
								if (pseudo === 0) {
									first = chars.charCodeAt(0)
	
									// first character is a letter or dash, buffer has a space character
									if ((first === DASH || first > 96 && first < 123)) {
										length = (chars = chars.replace(' ', ':')).length
									}
								}
	
								// execute plugins, property context
								if (plugged > 0) {
									if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
										if ((length = (chars = result.trim()).length) === 0) {
											chars = '\0\0'
										}
									}
								}
	
								first = chars.charCodeAt(0)
								second = chars.charCodeAt(1)
	
								switch (first) {
									case NULL: {
										break
									}
									case AT: {
										if (second === IMPORT || second === CHARSET) {
											flat += chars + body.charAt(caret)
											break
										}
									}
									default: {
										if (chars.charCodeAt(length-1) === COLON) {
											break
										}
	
										out += property(chars, first, second, chars.charCodeAt(2))
									}
								}
							}
	
							// reset
							context = 0
							insert = 0
							pseudo = 0
							format = 0
							invert = 0
							chars = ''
							code = body.charCodeAt(++caret)
							break
						}
					}
				}
	
				// parse characters
				switch (code) {
					case CARRIAGE:
					case NEWLINE: {
						// auto insert semicolon
						if (comment + quote + parentheses + bracket + semicolon === 0) {
							// valid non-whitespace characters that
							// may precede a newline
							switch (peak) {
								case CLOSEPARENTHESES:
								case SINGLEQUOTE:
								case DOUBLEQUOTE:
								case AT:
								case TILDE:
								case GREATERTHAN:
								case STAR:
								case PLUS:
								case FOWARDSLASH:
								case DASH:
								case COLON:
								case COMMA:
								case SEMICOLON:
								case OPENBRACES:
								case CLOSEBRACES: {
									break
								}
								default: {
									// current buffer has a colon
									if (pseudo > 0) {
										insert = 1
									}
								}
							}
						}
	
						// terminate line comment
						if (comment === FOWARDSLASH) {
							comment = 0
						} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
							format = 1
							chars += '\0'
						}
	
						// execute plugins, newline context
						if (plugged * unkwn > 0) {
							proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
						}
	
						// next line, reset column position
						column = 1
						line++
						break
					}
					case SEMICOLON:
					case CLOSEBRACES: {
						if (comment + quote + parentheses + bracket === 0) {
							column++
							break
						}
					}
					default: {
						// increment column position
						column++
	
						// current character
						char = body.charAt(caret)
	
						// remove comments, escape functions, strings, attributes and prepare selectors
						switch (code) {
							case TAB:
							case SPACE: {
								if (quote + bracket + comment === 0) {
									switch (tail) {
										case COMMA:
										case COLON:
										case TAB:
										case SPACE: {
											char = ''
											break
										}
										default: {
											if (code !== SPACE) {
												char = ' '
											}
										}
									}
								}
								break
							}
							// escape breaking control characters
							case NULL: {
								char = '\\0'
								break
							}
							case FORMFEED: {
								char = '\\f'
								break
							}
							case VERTICALTAB: {
								char = '\\v'
								break
							}
							// &
							case AND: {
								// inverted selector pattern i.e html &
								if (quote + comment + bracket === 0 && cascade > 0) {
									invert = 1
									format = 1
									char = '\f' + char
								}
								break
							}
							// ::p<l>aceholder, l
							// :read-on<l>y, l
							case 108: {
								if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
									switch (caret - pseudo) {
										// ::placeholder
										case 2: {
											if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
												pattern = tail
											}
										}
										// :read-only
										case 8: {
											if (trail === READONLY) {
												pattern = trail
											}
										}
									}
								}
								break
							}
							// :<pattern>
							case COLON: {
								if (quote + comment + bracket === 0) {
									pseudo = caret
								}
								break
							}
							// selectors
							case COMMA: {
								if (comment + parentheses + quote + bracket === 0) {
									format = 1
									char += '\r'
								}
								break
							}
							// quotes
							case DOUBLEQUOTE:
							case SINGLEQUOTE: {
								if (comment === 0) {
									quote = quote === code ? 0 : (quote === 0 ? code : quote)
								}
								break
							}
							// attributes
							case OPENBRACKET: {
								if (quote + comment + parentheses === 0) {
									bracket++
								}
								break
							}
							case CLOSEBRACKET: {
								if (quote + comment + parentheses === 0) {
									bracket--
								}
								break
							}
							// functions
							case CLOSEPARENTHESES: {
								if (quote + comment + bracket === 0) {
									parentheses--
								}
								break
							}
							case OPENPARENTHESES: {
								if (quote + comment + bracket === 0) {
									if (context === 0) {
										switch (tail*2 + trail*3) {
											// :matches
											case 533: {
												break
											}
											// :global, :not, :nth-child etc...
											default: {
												counter = 0
												context = 1
											}
										}
									}
	
									parentheses++
								}
								break
							}
							case AT: {
								if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
									atrule = 1
								}
								break
							}
							// block/line comments
							case STAR:
							case FOWARDSLASH: {
								if (quote + bracket + parentheses > 0) {
									break
								}
	
								switch (comment) {
									// initialize line/block comment context
									case 0: {
										switch (code*2 + body.charCodeAt(caret+1)*3) {
											// //
											case 235: {
												comment = FOWARDSLASH
												break
											}
											// /*
											case 220: {
												length = caret
												comment = STAR
												break
											}
										}
										break
									}
									// end block comment context
									case STAR: {
										if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
											// /*<!> ... */, !
											if (body.charCodeAt(length+2) === 33) {
												out += body.substring(length, caret+1)
											}
											char = ''
											comment = 0
										}
									}
								}
							}
						}
	
						// ignore comment blocks
						if (comment === 0) {
							// aggressive isolation mode, divide each individual selector
							// including selectors in :not function but excluding selectors in :global function
							if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
								switch (code) {
									case COMMA:
									case TILDE:
									case GREATERTHAN:
									case PLUS:
									case CLOSEPARENTHESES:
									case OPENPARENTHESES: {
										if (context === 0) {
											// outside of an isolated context i.e nth-child(<...>)
											switch (tail) {
												case TAB:
												case SPACE:
												case NEWLINE:
												case CARRIAGE: {
													char = char + '\0'
													break
												}
												default: {
													char = '\0' + char + (code === COMMA ? '' : '\0')
												}
											}
											format = 1
										} else {
											// within an isolated context, sleep untill it's terminated
											switch (code) {
												case OPENPARENTHESES: {
													// :globa<l>(
													if (pseudo + 7 === caret && tail === 108) {
														pseudo = 0
													}
													context = ++counter
													break
												}
												case CLOSEPARENTHESES: {
													if ((context = --counter) === 0) {
														format = 1
														char += '\0'
													}
													break
												}
											}
										}
										break
									}
									case TAB:
									case SPACE: {
										switch (tail) {
											case NULL:
											case OPENBRACES:
											case CLOSEBRACES:
											case SEMICOLON:
											case COMMA:
											case FORMFEED:
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												break
											}
											default: {
												// ignore in isolated contexts
												if (context === 0) {
													format = 1
													char += '\0'
												}
											}
										}
									}
								}
							}
	
							// concat buffer of characters
							chars += char
	
							// previous non-whitespace character code
							if (code !== SPACE && code !== TAB) {
								peak = code
							}
						}
					}
				}
	
				// tail character codes
				trail = tail
				tail = code
	
				// visit every character
				caret++
			}
	
			length = out.length
	
			// preserve empty selector
	 		if (preserve > 0) {
	 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
	 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
						length = current.join(',').length + 2
	 				}
	 			}
			}
	
			if (length > 0) {
				// cascade isolation mode?
				selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current
	
				// execute plugins, block context
				if (plugged > 0) {
					result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)
	
					if (result !== void 0 && (out = result).length === 0) {
						return flat + out + children
					}
				}
	
				out = selector.join(',') + '{' + out + '}'
	
				if (prefix*pattern !== 0) {
					if (prefix === 2 && !vendor(out, 2))
						pattern = 0
	
					switch (pattern) {
						// ::read-only
						case READONLY: {
							out = out.replace(readonlyptn, ':'+moz+'$1')+out
							break
						}
						// ::placeholder
						case PLACEHOLDER: {
							out = (
								out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
								out.replace(plcholdrptn, '::' + moz + '$1') +
								out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
							)
							break
						}
					}
	
					pattern = 0
				}
			}
	
			return flat + out + children
		}
	
		/**
		 * Select
		 *
		 * @param {Array<string>} parent
		 * @param {string} current
		 * @param {number} invert
		 * @return {Array<string>}
		 */
		function select (parent, current, invert) {
			var selectors = current.trim().split(selectorptn)
			var out = selectors
	
			var length = selectors.length
			var l = parent.length
	
			switch (l) {
				// 0-1 parent selectors
				case 0:
				case 1: {
					for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
						out[i] = scope(selector, out[i], invert, l).trim()
					}
					break
				}
				// >2 parent selectors, nested
				default: {
					for (var i = 0, j = 0, out = []; i < length; ++i) {
						for (var k = 0; k < l; ++k) {
							out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
						}
					}
				}
			}
	
			return out
		}
	
		/**
		 * Scope
		 *
		 * @param {string} parent
		 * @param {string} current
		 * @param {number} invert
		 * @param {number} level
		 * @return {string}
		 */
		function scope (parent, current, invert, level) {
			var selector = current
			var code = selector.charCodeAt(0)
	
			// trim leading whitespace
			if (code < 33) {
				code = (selector = selector.trim()).charCodeAt(0)
			}
	
			switch (code) {
				// &
				case AND: {
					switch (cascade + level) {
						case 0:
						case 1: {
							if (parent.trim().length === 0) {
								break
							}
						}
						default: {
							return selector.replace(andptn, '$1'+parent.trim())
						}
					}
					break
				}
				// :
				case COLON: {
					switch (selector.charCodeAt(1)) {
						// g in :global
						case 103: {
							if (escape > 0 && cascade > 0) {
								return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
							}
							break
						}
						default: {
							// :hover
							return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
						}
					}
				}
				default: {
					// html &
					if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
						return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
					}
				}
			}
	
			return parent + selector
		}
	
		/**
		 * Property
		 *
		 * @param {string} input
		 * @param {number} first
		 * @param {number} second
		 * @param {number} third
		 * @return {string}
		 */
		function property (input, first, second, third) {
			var index = 0
			var out = input + ';'
			var hash = (first*2) + (second*3) + (third*4)
			var cache
	
			// animation: a, n, i characters
			if (hash === 944) {
				return animation(out)
			} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
				return out
			}
	
			// vendor prefix
			switch (hash) {
				// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
				case 1015: {
					// text-shadow/text-align/text-transform, a
					return out.charCodeAt(10) === 97 ? webkit + out + out : out
				}
				// filter/fill f, i, l
				case 951: {
					// filter, t
					return out.charCodeAt(3) === 116 ? webkit + out + out : out
				}
				// color/column, c, o, l
				case 963: {
					// column, n
					return out.charCodeAt(5) === 110 ? webkit + out + out : out
				}
				// box-decoration-break, b, o, x
				case 1009: {
					if (out.charCodeAt(4) !== 100) {
						break
					}
				}
				// mask, m, a, s
				// clip-path, c, l, i
				case 969:
				case 942: {
					return webkit + out + out
				}
				// appearance: a, p, p
				case 978: {
					return webkit + out + moz + out + out
				}
				// hyphens: h, y, p
				// user-select: u, s, e
				case 1019:
				case 983: {
					return webkit + out + moz + out + ms + out + out
				}
				// background/backface-visibility, b, a, c
				case 883: {
					// backface-visibility, -
					if (out.charCodeAt(8) === DASH) {
						return webkit + out + out
					}
	
					// image-set(...)
					if (out.indexOf('image-set(', 11) > 0) {
						return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
					}
	
					return out
				}
				// flex: f, l, e
				case 932: {
					if (out.charCodeAt(4) === DASH) {
						switch (out.charCodeAt(5)) {
							// flex-grow, g
							case 103: {
								return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
							}
							// flex-shrink, s
							case 115: {
								return webkit + out + ms + out.replace('shrink', 'negative') + out
							}
							// flex-basis, b
							case 98: {
								return webkit + out + ms + out.replace('basis', 'preferred-size') + out
							}
						}
					}
	
					return webkit + out + ms + out + out
				}
				// order: o, r, d
				case 964: {
					return webkit + out + ms + 'flex' + '-' + out + out
				}
				// justify-items/justify-content, j, u, s
				case 1023: {
					// justify-content, c
					if (out.charCodeAt(8) !== 99) {
						break
					}
	
					cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
					return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
				}
				// cursor, c, u, r
				case 1005: {
					return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
				}
				// writing-mode, w, r, i
				case 1000: {
					cache = out.substring(13).trim()
					index = cache.indexOf('-') + 1
	
					switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
						// vertical-lr
						case 226: {
							cache = out.replace(writingptn, 'tb')
							break
						}
						// vertical-rl
						case 232: {
							cache = out.replace(writingptn, 'tb-rl')
							break
						}
						// horizontal-tb
						case 220: {
							cache = out.replace(writingptn, 'lr')
							break
						}
						default: {
							return out
						}
					}
	
					return webkit + out + ms + cache + out
				}
				// position: sticky
				case 1017: {
					if (out.indexOf('sticky', 9) === -1) {
						return out
					}
				}
				// display(flex/inline-flex/inline-box): d, i, s
				case 975: {
					index = (out = input).length - 10
					cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()
	
					switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
						// inline-
						case 203: {
							// inline-box
							if (cache.charCodeAt(8) < 111) {
								break
							}
						}
						// inline-box/sticky
						case 115: {
							out = out.replace(cache, webkit+cache)+';'+out
							break
						}
						// inline-flex
						// flex
						case 207:
						case 102: {
							out = (
								out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
								out.replace(cache, webkit+cache)+';'+
								out.replace(cache, ms+cache+'box')+';'+
								out
							)
						}
					}
	
					return out + ';'
				}
				// align-items, align-center, align-self: a, l, i, -
				case 938: {
					if (out.charCodeAt(5) === DASH) {
						switch (out.charCodeAt(6)) {
							// align-items, i
							case 105: {
								cache = out.replace('-items', '')
								return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
							}
							// align-self, s
							case 115: {
								return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
							}
							// align-content
							default: {
								return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
							}
						}
					}
					break
				}
				// min/max
				case 973:
				case 989: {
					// min-/max- height/width/block-size/inline-size
					if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
						break
					}
				}
				// height/width: min-content / width: max-content
				case 931:
				case 953: {
					if (dimensionptn.test(input) === true) {
						// stretch
						if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
							return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
						else
							return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
					}
					break
				}
				// transform, transition: t, r, a
				case 962: {
					out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out
	
					// transitions
					if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
						return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
					}
	
					break
				}
			}
	
			return out
		}
	
		/**
		 * Vendor
		 *
		 * @param {string} content
		 * @param {number} context
		 * @return {boolean}
		 */
		function vendor (content, context) {
			var index = content.indexOf(context === 1 ? ':' : '{')
			var key = content.substring(0, context !== 3 ? index : 10)
			var value = content.substring(index + 1, content.length - 1)
	
			return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
		}
	
		/**
		 * Supports
		 *
		 * @param {string} match
		 * @param {string} group
		 * @return {string}
		 */
		function supports (match, group) {
			var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))
	
			return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
		}
	
		/**
		 * Animation
		 *
		 * @param {string} input
		 * @return {string}
		 */
		function animation (input) {
			var length = input.length
			var index = input.indexOf(':', 9) + 1
			var declare = input.substring(0, index).trim()
			var out = input.substring(index, length-1).trim()
	
			switch (input.charCodeAt(9)*keyed) {
				case 0: {
					break
				}
				// animation-*, -
				case DASH: {
					// animation-name, n
					if (input.charCodeAt(10) !== 110) {
						break
					}
				}
				// animation/animation-name
				default: {
					// split in case of multiple animations
					var list = out.split((out = '', animationptn))
	
					for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
						var value = list[i]
						var items = value.split(propertiesptn)
	
						while (value = items[index]) {
							var peak = value.charCodeAt(0)
	
							if (keyed === 1 && (
								// letters
								(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
								// dash but not in sequence i.e --
								(peak === DASH && value.charCodeAt(1) !== DASH)
							)) {
								// not a number/function
								switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
									case 1: {
										switch (value) {
											// not a valid reserved keyword
											case 'infinite': case 'alternate': case 'backwards': case 'running':
											case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
											case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
											case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
											case 'initial': case 'unset': case 'step-start': case 'step-end': {
												break
											}
											default: {
												value += key
											}
										}
									}
								}
							}
	
							items[index++] = value
						}
	
						out += (i === 0 ? '' : ',') + items.join(' ')
					}
				}
			}
	
			out = declare + out + ';'
	
			if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
				return webkit + out + out
	
			return out
		}
	
		/**
		 * Isolate
		 *
		 * @param {Array<string>} current
		 */
		function isolate (current) {
			for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
				// split individual elements in a selector i.e h1 h2 === [h1, h2]
				var elements = current[i].split(elementptn)
				var out = ''
	
				for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
					// empty element
					if ((size = (element = elements[j]).length) === 0 && l > 1) {
						continue
					}
	
					tail = out.charCodeAt(out.length-1)
					code = element.charCodeAt(0)
					padding = ''
	
					if (j !== 0) {
						// determine if we need padding
						switch (tail) {
							case STAR:
							case TILDE:
							case GREATERTHAN:
							case PLUS:
							case SPACE:
							case OPENPARENTHESES:  {
								break
							}
							default: {
								padding = ' '
							}
						}
					}
	
					switch (code) {
						case AND: {
							element = padding + nscopealt
						}
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case CLOSEPARENTHESES:
						case OPENPARENTHESES: {
							break
						}
						case OPENBRACKET: {
							element = padding + element + nscopealt
							break
						}
						case COLON: {
							switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
								// :global
								case 530: {
									if (escape > 0) {
										element = padding + element.substring(8, size - 1)
										break
									}
								}
								// :hover, :nth-child(), ...
								default: {
									if (j < 1 || elements[j-1].length < 1) {
										element = padding + nscopealt + element
									}
								}
							}
							break
						}
						case COMMA: {
							padding = ''
						}
						default: {
							if (size > 1 && element.indexOf(':') > 0) {
								element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
							} else {
								element = padding + element + nscopealt
							}
						}
					}
	
					out += element
				}
	
				selector[i] = out.replace(formatptn, '').trim()
			}
	
			return selector
		}
	
		/**
		 * Proxy
		 *
		 * @param {number} context
		 * @param {string} content
		 * @param {Array<string>} selectors
		 * @param {Array<string>} parents
		 * @param {number} line
		 * @param {number} column
		 * @param {number} length
		 * @param {number} id
		 * @param {number} depth
		 * @param {number} at
		 * @return {(string|void|*)}
		 */
		function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
			for (var i = 0, out = content, next; i < plugged; ++i) {
				switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
					case void 0:
					case false:
					case true:
					case null: {
						break
					}
					default: {
						out = next
					}
				}
			}
			if (out !== content) {
			  return out
			}
		}
	
		/**
		 * @param {number} code
		 * @param {number} index
		 * @param {number} length
		 * @param {string} body
		 * @return {number}
		 */
		function delimited (code, index, length, body) {
			for (var i = index + 1; i < length; ++i) {
				switch (body.charCodeAt(i)) {
					// /*
					case FOWARDSLASH: {
						if (code === STAR) {
							if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
								return i + 1
							}
						}
						break
					}
					// //
					case NEWLINE: {
						if (code === FOWARDSLASH) {
							return i + 1
						}
					}
				}
			}
	
			return i
		}
	
		/**
		 * @param {number} type
		 * @param {number} index
		 * @param {number} length
		 * @param {number} find
		 * @param {string} body
		 * @return {number}
		 */
		function match (type, index, length, body) {
			for (var i = index + 1; i < length; ++i) {
				switch (body.charCodeAt(i)) {
					case type: {
						return i
					}
				}
			}
	
			return i
		}
	
		/**
		 * Minify
		 *
		 * @param {(string|*)} output
		 * @return {string}
		 */
		function minify (output) {
			return output
				.replace(formatptn, '')
				.replace(beforeptn, '')
				.replace(afterptn, '$1')
				.replace(tailptn, '$1')
				.replace(whiteptn, ' ')
		}
	
		/**
		 * Use
		 *
		 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
		 */
		function use (plugin) {
			switch (plugin) {
				case void 0:
				case null: {
					plugged = plugins.length = 0
					break
				}
				default: {
					if (typeof plugin === 'function') {
						plugins[plugged++] = plugin
					}	else if (typeof plugin === 'object') {
						for (var i = 0, length = plugin.length; i < length; ++i) {
							use(plugin[i])
						}
					} else {
						unkwn = !!plugin|0
					}
				}
	 		}
	
	 		return use
		}
	
		/**
		 * Set
		 *
		 * @param {*} options
		 */
		function set (options) {
			for (var name in options) {
				var value = options[name]
				switch (name) {
					case 'keyframe': keyed = value|0; break
					case 'global': escape = value|0; break
					case 'cascade': cascade = value|0; break
					case 'compress': compress = value|0; break
					case 'semicolon': semicolon = value|0; break
					case 'preserve': preserve = value|0; break
					case 'prefix':
						should = null
	
						if (!value) {
							prefix = 0
						} else if (typeof value !== 'function') {
							prefix = 1
						} else {
							prefix = 2
							should = value
						}
				}
			}
	
			return set
		}
	
		/**
		 * Stylis
		 *
		 * @param {string} selector
		 * @param {string} input
		 * @return {*}
		 */
		function stylis (selector, input) {
			if (this !== void 0 && this.constructor === stylis) {
				return factory(selector)
			}
	
			// setup
			var ns = selector
			var code = ns.charCodeAt(0)
	
			// trim leading whitespace
			if (code < 33) {
				code = (ns = ns.trim()).charCodeAt(0)
			}
	
			// keyframe/animation namespace
			if (keyed > 0) {
				key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
			}
	
			// reset, used to assert if a plugin is moneky-patching the return value
			code = 1
	
			// cascade/isolate
			if (cascade === 1) {
				nscope = ns
			} else {
				nscopealt = ns
			}
	
			var selectors = [nscope]
			var result
	
			// execute plugins, pre-process context
			if (plugged > 0) {
				result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)
	
				if (result !== void 0 && typeof result === 'string') {
					input = result
				}
			}
	
			// build
			var output = compile(array, selectors, input, 0, 0)
	
			// execute plugins, post-process context
			if (plugged > 0) {
				result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)
	
				// bypass minification
				if (result !== void 0 && typeof(output = result) !== 'string') {
					code = 0
				}
			}
	
			// reset
			key = ''
			nscope = ''
			nscopealt = ''
			pattern = 0
			line = 1
			column = 1
	
			return compress*code === 0 ? output : minify(output)
		}
	
		stylis['use'] = use
		stylis['set'] = set
	
		if (options !== void 0) {
			set(options)
		}
	
		return stylis
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(177)(module)))

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(2035);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(177)(module)))

/***/ }),
/* 2035 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 2036 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FragmentNode = exports.ElementNode = exports.TextNode = exports.Node = exports.SELF_CLOSING = exports.NODE_TYPE_FRAGMENT = exports.NODE_TYPE_TEXT = exports.NODE_TYPE_ELEMENT = void 0;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var EMPTY_ATTR_LIST = [];
	var NODE_TYPE_ELEMENT = 1;
	exports.NODE_TYPE_ELEMENT = NODE_TYPE_ELEMENT;
	var NODE_TYPE_TEXT = 3;
	exports.NODE_TYPE_TEXT = NODE_TYPE_TEXT;
	var NODE_TYPE_FRAGMENT = 11;
	exports.NODE_TYPE_FRAGMENT = NODE_TYPE_FRAGMENT;
	var SELF_CLOSING = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	};
	exports.SELF_CLOSING = SELF_CLOSING;
	
	var Node =
	/*#__PURE__*/
	function () {
	  function Node() {
	    _classCallCheck(this, Node);
	
	    _defineProperty(this, "nodeType", void 0);
	
	    _defineProperty(this, "nodeName", void 0);
	
	    _defineProperty(this, "nodeValue", void 0);
	
	    _defineProperty(this, "childNodes", void 0);
	  }
	
	  _createClass(Node, [{
	    key: "toString",
	    value: function toString(isXHTML) {
	      return isXHTML ? '' : '';
	    }
	  }]);
	
	  return Node;
	}();
	
	exports.Node = Node;
	
	var TextNode =
	/*#__PURE__*/
	function (_Node) {
	  _inherits(TextNode, _Node);
	
	  function TextNode(value) {
	    var _this;
	
	    _classCallCheck(this, TextNode);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextNode).apply(this, arguments));
	    _this.nodeType = NODE_TYPE_TEXT;
	    _this.nodeName = '#text';
	    _this.nodeValue = value;
	    return _this;
	  } // eslint-disable-next-line no-unused-vars
	
	
	  _createClass(TextNode, [{
	    key: "toString",
	    value: function toString(isXHTML) {
	      return escape(this.nodeValue);
	    }
	  }]);
	
	  return TextNode;
	}(Node);
	
	exports.TextNode = TextNode;
	
	var ElementNode =
	/*#__PURE__*/
	function (_Node2) {
	  _inherits(ElementNode, _Node2);
	
	  function ElementNode(name, attributes, childNodes) {
	    var _this2;
	
	    _classCallCheck(this, ElementNode);
	
	    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ElementNode).apply(this, arguments));
	
	    _defineProperty(_assertThisInitialized(_this2), "_name", void 0);
	
	    _defineProperty(_assertThisInitialized(_this2), "_attrMap", void 0);
	
	    _defineProperty(_assertThisInitialized(_this2), "_isSelfClosing", void 0);
	
	    _defineProperty(_assertThisInitialized(_this2), "childNodes", void 0);
	
	    _defineProperty(_assertThisInitialized(_this2), "attributes", void 0);
	
	    if (attributes == null) {
	      attributes = EMPTY_ATTR_LIST;
	    }
	
	    var isSelfClosing = SELF_CLOSING[name] === true;
	    _this2.nodeType = NODE_TYPE_ELEMENT;
	    _this2._name = name.toLowerCase();
	    _this2.attributes = attributes;
	    _this2._attrMap = new Map(attributes.map(function (attr) {
	      return [attr.name, attr];
	    }));
	    _this2.nodeName = name.toUpperCase();
	    _this2.childNodes = [];
	    _this2._isSelfClosing = isSelfClosing;
	
	    if (!isSelfClosing && childNodes) {
	      childNodes.forEach(_this2.appendChild, _assertThisInitialized(_this2));
	    }
	
	    return _this2;
	  }
	
	  _createClass(ElementNode, [{
	    key: "appendChild",
	    value: function appendChild(node) {
	      if (node.nodeType === NODE_TYPE_FRAGMENT && node.childNodes) {
	        var _this$childNodes;
	
	        this.childNodes && (_this$childNodes = this.childNodes).push.apply(_this$childNodes, _toConsumableArray(node.childNodes));
	      } else {
	        this.childNodes && this.childNodes.push(node);
	      }
	    }
	  }, {
	    key: "getAttribute",
	    value: function getAttribute(name) {
	      var attr = this._attrMap.get(name);
	
	      if (attr) {
	        return attr.value;
	      }
	    }
	  }, {
	    key: "toString",
	    value: function toString(isXHTML) {
	      var attributes = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.attributes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = _step.value,
	              name = _step$value.name,
	              value = _step$value.value;
	          attributes.push(name + (value ? '="' + escapeAttr(value) + '"' : ''));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
	            _iterator["return"]();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var attrString = attributes.length ? ' ' + attributes.join(' ') : '';
	
	      if (this._isSelfClosing) {
	        return '<' + this._name + attrString + (isXHTML ? '/>' : '>');
	      }
	
	      var childNodes = this.childNodes ? this.childNodes.map(function (node) {
	        return node.toString(isXHTML);
	      }).join('') : '';
	      return '<' + this._name + attrString + '>' + childNodes + '</' + this._name + '>';
	    }
	  }, {
	    key: "tagName",
	    get: function get() {
	      return this.nodeName;
	    }
	  }, {
	    key: "className",
	    get: function get() {
	      return this.getAttribute('class') || '';
	    }
	  }]);
	
	  return ElementNode;
	}(Node);
	
	exports.ElementNode = ElementNode;
	
	var FragmentNode =
	/*#__PURE__*/
	function (_Node3) {
	  _inherits(FragmentNode, _Node3);
	
	  function FragmentNode(childNodes) {
	    var _this3;
	
	    _classCallCheck(this, FragmentNode);
	
	    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(FragmentNode).apply(this, arguments));
	
	    _defineProperty(_assertThisInitialized(_this3), "childNodes", void 0);
	
	    _this3.nodeType = NODE_TYPE_FRAGMENT;
	    _this3.childNodes = [];
	
	    if (childNodes) {
	      childNodes.forEach(_this3.appendChild, _assertThisInitialized(_this3));
	    }
	
	    return _this3;
	  }
	
	  _createClass(FragmentNode, [{
	    key: "appendChild",
	    value: function appendChild(node) {
	      if (node.nodeType === NODE_TYPE_FRAGMENT && node.childNodes) {
	        var _this$childNodes2;
	
	        this.childNodes && (_this$childNodes2 = this.childNodes).push.apply(_this$childNodes2, _toConsumableArray(node.childNodes));
	      } else {
	        this.childNodes && this.childNodes.push(node);
	      }
	    }
	  }, {
	    key: "toString",
	    value: function toString(isXHTML) {
	      var childNodes = this.childNodes;
	      return childNodes ? childNodes.map(function (node) {
	        return node.toString(isXHTML);
	      }).join('') : '';
	    }
	  }]);
	
	  return FragmentNode;
	}(Node);
	
	exports.FragmentNode = FragmentNode;
	
	function escape(html) {
	  return html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}
	
	function escapeAttr(html) {
	  return html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SyntheticDOM = __webpack_require__(2036);
	
	Object.keys(_SyntheticDOM).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SyntheticDOM[key];
	    }
	  });
	});

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var gridLocation = 'accountTransactionList';
	var grid;
	var BankTransactionList = /** @class */ (function (_super) {
	    tslib_1.__extends(BankTransactionList, _super);
	    function BankTransactionList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    BankTransactionList.fetchData = function (routerParams) {
	        console.log("BankTransactionList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            grid = new grid_1.default(gridLocationMap.get(gridLocation), routerParams.id);
	        });
	    };
	    BankTransactionList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: grid, entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query }));
	    };
	    BankTransactionList.module = metaConstant_1.MODULE.accounting;
	    BankTransactionList.title = 'Account Transactions';
	    BankTransactionList.icon = 'money';
	    BankTransactionList.protectedPage = true;
	    BankTransactionList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], BankTransactionList);
	    return BankTransactionList;
	}(pageAncestor_1.default));
	exports.default = BankTransactionList;


/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var accountingDomain_1 = __webpack_require__(560);
	var AccountingService = /** @class */ (function () {
	    function AccountingService() {
	    }
	    AccountingService.prototype.readBankTransaction = function (bankTransactionId) {
	        return axios_config_1.default.get('/bank-transaction/' + bankTransactionId)
	            .then(function (response) { return new accountingDomain_1.BankTransaction(response.data); });
	    };
	    return AccountingService;
	}());
	exports.default = new AccountingService();


/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var buttons_1 = __webpack_require__(27);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var errorComp_1 = __webpack_require__(34);
	var formUtils_1 = __webpack_require__(14);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var certificateService_1 = tslib_1.__importDefault(__webpack_require__(927));
	var certificateDomain_1 = __webpack_require__(561);
	var Paper_1 = tslib_1.__importDefault(__webpack_require__(106));
	var List_1 = tslib_1.__importDefault(__webpack_require__(358));
	var ListItem_1 = tslib_1.__importDefault(__webpack_require__(359));
	var dateUtils_1 = __webpack_require__(49);
	var dialogAncestor_1 = __webpack_require__(87);
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var createForm_1 = __webpack_require__(18);
	var fields_1 = __webpack_require__(20);
	var radioButtonField_1 = tslib_1.__importDefault(__webpack_require__(144));
	var locales_1 = __webpack_require__(15);
	var CertificateDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(CertificateDetail, _super);
	    function CertificateDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            certificateService_1.default.deleteCertificate(certificateService_1.default.certificateObject.certificateId)
	                .then(function (response) {
	                _this.context.router.transitionTo('certificateList');
	            });
	        };
	        _this.onExport = function (evt) {
	            console.log('onExport');
	            var dto = {
	                certificate: certificateService_1.default.certificateObject,
	                certFormat: mdEntityService_1.default.getEntity("CERTFORMAT").getLovItem(certificateDomain_1.CERTFORMAT.X509_BASE64),
	                password: ""
	            };
	            new Promise(function (resolve, reject) {
	                _this.exportCertificateDialog.open(resolve, reject, (0, mobx_1.observable)(dto));
	            }).then(function (dto) {
	            }).catch(function (e) {
	            });
	        };
	        _this.exportCertificateDialogfHandler = function (comp) { return _this.exportCertificateDialog = comp; };
	        return _this;
	    }
	    CertificateDetail.fetchData = function (routerParams, query) {
	        console.log("CertificateDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['MdCertificate'], [{ entity: "CERTFORMAT", lov: true }]);
	        var certificatePromise = certificateService_1.default.readCertificate(routerParams.id);
	        return Promise.all([metadataPromise, certificatePromise])
	            .then(function (_a) {
	            var entityMap = _a[0], certificateObject = _a[1];
	            certificateService_1.default.certificateObject = certificateObject.initAfterRead(false);
	        });
	    };
	    CertificateDetail.prototype.componentWillUnmount = function () {
	        certificateService_1.default.certificateObject = null;
	    };
	    CertificateDetail.prototype.findRootObject = function () {
	        return certificateService_1.default.certificateObject;
	    };
	    CertificateDetail.prototype.render = function () {
	        var query = this.props.query;
	        var certificate = certificateService_1.default.certificateObject;
	        var errors = (!certificate.valid) ? [{ message: certificate.validError }] : [];
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	            react_1.default.createElement(toolmenu_1.default, { backAction: this.onBack, backDisabled: History.length <= 1 },
	                react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "MdCertificate", pageAncestor: this, onClick: this.onDelete, label: "Delete", permission: metaConstant_1.PERMISSION.Delete }),
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onExport, label: "Export", permission: metaConstant_1.PERMISSION.Export })),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	            react_1.default.createElement(ExportCertificateDialog, { ref: this.exportCertificateDialogfHandler }),
	            react_1.default.createElement(Paper_1.default, { style: { marginTop: 15, padding: 8 }, zDepth: 1 },
	                react_1.default.createElement("h4", { style: { marginLeft: 15 } }, "Certificate Detail"),
	                react_1.default.createElement(List_1.default, null,
	                    react_1.default.createElement(ListItem_1.default, null,
	                        react_1.default.createElement("span", null, "Valid"),
	                        react_1.default.createElement("p", null,
	                            react_1.default.createElement("span", { className: (certificate.valid) ? "fa fa-certificate color-green-500" : "fa fa-certificate color-red-500" }))),
	                    react_1.default.createElement(ListItem_1.default, null,
	                        react_1.default.createElement("span", null, "Subject"),
	                        react_1.default.createElement("p", null,
	                            react_1.default.createElement("b", null, certificate.subjectCn))),
	                    react_1.default.createElement(ListItem_1.default, null,
	                        react_1.default.createElement("span", null, "Issuer"),
	                        react_1.default.createElement("p", null,
	                            react_1.default.createElement("b", null, certificate.issuerCn))),
	                    react_1.default.createElement(ListItem_1.default, null,
	                        react_1.default.createElement("span", null, "Serial Number"),
	                        react_1.default.createElement("p", null,
	                            react_1.default.createElement("b", null, certificate.serialNumber))),
	                    react_1.default.createElement(ListItem_1.default, null,
	                        react_1.default.createElement("span", null, " Validity "),
	                        react_1.default.createElement("p", null,
	                            react_1.default.createElement("b", null,
	                                " ",
	                                (0, dateUtils_1.formatDateTime)(certificate.fromDate),
	                                " - ",
	                                (0, dateUtils_1.formatDateTime)(certificate.toDate),
	                                " "))),
	                    react_1.default.createElement(ListItem_1.default, null,
	                        react_1.default.createElement("span", null, "Changed at"),
	                        react_1.default.createElement("p", null,
	                            react_1.default.createElement("b", null, (0, dateUtils_1.formatDateTime)(certificate.dateUpdated)))),
	                    react_1.default.createElement(ListItem_1.default, null,
	                        react_1.default.createElement("span", null, "Changed by"),
	                        react_1.default.createElement("p", null,
	                            react_1.default.createElement("b", null, certificate.userCreated))))),
	            react_1.default.createElement(Paper_1.default, { zDepth: 1, style: { marginTop: 15, padding: 8 } },
	                react_1.default.createElement("h4", { style: { marginLeft: 15 } }, "X509"),
	                react_1.default.createElement("pre", null, certificate.x509String))));
	    };
	    CertificateDetail.module = metaConstant_1.MODULE.core;
	    CertificateDetail.title = 'Certificate';
	    CertificateDetail.icon = 'certificate';
	    CertificateDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], CertificateDetail.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], CertificateDetail.prototype, "onExport", void 0);
	    CertificateDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], CertificateDetail);
	    return CertificateDetail;
	}(pageAncestor_1.default));
	exports.default = CertificateDetail;
	var ExportCertificateDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(ExportCertificateDialog, _super);
	    function ExportCertificateDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.export = function (evt) {
	            console.log('ExportCertificateDialog#ok evt = %O', evt);
	            _this.dialogOpen = false;
	            _this.$errors = [];
	            _this.resolve(_this.dto);
	        };
	        _this.cancel = function (evt) {
	            console.log('ExportCertificateDialog#cancel evt = %O', evt);
	            _this.dialogOpen = false;
	            _this.$errors = [];
	            _this.reject("cancel");
	        };
	        _this.onChangeCertFormat = function (lovItem) {
	            console.log('onChangeCertFormat lovItem = %O', lovItem);
	            _this.dto.certFormat = lovItem;
	            _this.dto.password = "";
	        };
	        _this.onChangePassword = function (evt) {
	            _this.dto.password = evt.target.value;
	        };
	        return _this;
	    }
	    ExportCertificateDialog.prototype.open = function (resolve, reject, dto) {
	        this.resolve = resolve;
	        this.reject = reject;
	        this.dialogOpen = true;
	        this.dto = dto;
	    };
	    ExportCertificateDialog.prototype.render = function () {
	        if (!(this.dialogOpen))
	            return null;
	        return (react_1.default.createElement(Dialog_1.default, { title: "Export Certificate", actions: [react_1.default.createElement(FlatButton_1.default, { label: "Export", href: certificateService_1.default.exportCertificateUrl((0, formUtils_1.lovValue)(this.dto.certFormat), this.dto.certificate.certificateId, this.dto.password), secondary: true, onClick: this.export, disabled: ((0, formUtils_1.lovValue)(this.dto.certFormat) === certificateDomain_1.CERTFORMAT.PKCS_12) && !this.dto.password }), react_1.default.createElement(FlatButton_1.default, { label: "Cancel", primary: true, onClick: this.cancel })], modal: true, open: this.dialogOpen, bodyStyle: { minHeight: 180 }, contentStyle: { position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', filter: 'blur(0)' } },
	            react_1.default.createElement("form", null,
	                react_1.default.createElement(radioButtonField_1.default, tslib_1.__assign({ onChange: this.onChangeCertFormat, name: "certFormat" }, createForm_1.fieldStyles.small.radioButton, { value: this.dto.certFormat, options: mdEntityService_1.default.getEntity("CERTFORMAT").lovItems, disabled: disabledPKCS.bind(this, this.dto.certificate) })),
	                ((0, formUtils_1.lovValue)(this.dto.certFormat) === certificateDomain_1.CERTFORMAT.PKCS_12) ? (react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, createForm_1.fieldStyles.small.textField, { value: this.dto.password, type: "password", errorText: (this.dto.password) ? undefined : "Password is required", onChange: this.onChangePassword, fullWidth: true, hintText: "Password" }))) : null)));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ExportCertificateDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ExportCertificateDialog.prototype, "export", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ExportCertificateDialog.prototype, "cancel", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ExportCertificateDialog.prototype, "onChangeCertFormat", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ExportCertificateDialog.prototype, "onChangePassword", void 0);
	    ExportCertificateDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ExportCertificateDialog);
	    return ExportCertificateDialog;
	}(dialogAncestor_1.DialogAncestor));
	function disabledPKCS(certificate, lov) {
	    return ((0, formUtils_1.lovValue)(certificate.certType) !== certificateDomain_1.CERTTYPE.PRIVATE && (0, formUtils_1.lovValue)(lov) === certificateDomain_1.CERTFORMAT.PKCS_12);
	}
	var templateObject_1, templateObject_2;


/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var gridUtils_1 = __webpack_require__(83);
	var certificateService_1 = tslib_1.__importDefault(__webpack_require__(927));
	var variables_1 = __webpack_require__(96);
	var mui_theme_1 = __webpack_require__(119);
	var gridComp_1 = tslib_1.__importDefault(__webpack_require__(44));
	var Tabs_1 = tslib_1.__importDefault(__webpack_require__(107));
	var Tab_1 = tslib_1.__importDefault(__webpack_require__(102));
	var mobx_1 = __webpack_require__(5);
	var buttons_1 = __webpack_require__(27);
	var routes_1 = __webpack_require__(75);
	var axios_config_1 = __webpack_require__(59);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var createForm_1 = __webpack_require__(18);
	var fields_1 = __webpack_require__(20);
	var errorComp_1 = __webpack_require__(34);
	var certificateDomain_1 = __webpack_require__(561);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var commonDataService_1 = __webpack_require__(41);
	var RaisedButton_1 = tslib_1.__importDefault(__webpack_require__(152));
	var locales_1 = __webpack_require__(15);
	var certificateListCAROOT = 'certificateListCAROOT';
	var certificateListCAINTERMEDIATE = 'certificateListCAINTERMEDIATE';
	var certificateListPUBLIC = 'certificateListPUBLIC';
	var certificateListPRIVATE = 'certificateListPRIVATE';
	var CertificateList = /** @class */ (function (_super) {
	    tslib_1.__extends(CertificateList, _super);
	    function CertificateList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onTabChange = function (tabName) {
	            _this.tabChange(tabName, function (tab) {
	                certificateService_1.default.certificateListsMV.activeBlockTab = tab;
	            });
	        };
	        _this.postSuccessFn = function () {
	            _this.passwordText = null;
	            certificateService_1.default.certificateListsMV.blockArray.forEach(function (grid) { return grid.data = null; });
	            return certificateService_1.default.certificateListsMV.searchExposedGrids(null, true);
	        };
	        _this.handleFileUpload = function (files) {
	            var data = new FormData();
	            var isPrivateCert = false;
	            for (var i = 0; i < files.length; i++) {
	                var file = files.item(i);
	                data.append('certificate[' + i + ']', file, file.name);
	                if ((/\.(pfx|p12)$/i).test(file.name))
	                    isPrivateCert = true;
	            }
	            if (isPrivateCert) {
	                return new Promise(function (resolve, reject) {
	                    _this.passwordDialogRef.open(resolve, reject);
	                }).then(function () {
	                    return axios_config_1.uploadAxios.post('/core/security/certificate/import', data, { params: { password: _this.passwordText }, showPrettyError: true })
	                        .then(_this.postSuccessFn, function (error) {
	                        _this.$errors = error.getMessages();
	                    });
	                }).catch(function (e) {
	                    _this.passwordText = null;
	                });
	            }
	            else {
	                return axios_config_1.uploadAxios.post('/core/security/certificate/import', data, { showPrettyError: true })
	                    .then(_this.postSuccessFn, function (error) {
	                    _this.$errors = error.getMessages();
	                });
	            }
	        };
	        _this.onChangePassword = function (evt) {
	            _this.passwordText = evt.target.value;
	        };
	        _this.activatePrivateCertTab = function (evt) {
	            console.log('activatePrivateCertTab');
	            return Promise.all([certificateService_1.default.readCertificateBeanConfigs(), (0, commonDataService_1.optionsSearch)("MdCertificate", { certType: [certificateDomain_1.CERTTYPE.PRIVATE] })])
	                .then(function (_a) {
	                var configs = _a[0], options = _a[1];
	                certificateService_1.default.certificateConfigs = configs;
	                _this.certificateOptions = options.options;
	                _this.certificateOptions.unshift({ value: null, label: '---' });
	            });
	        };
	        _this.passwordDialogRefHandler = function (comp) { return _this.passwordDialogRef = comp; };
	        return _this;
	    }
	    CertificateList.fetchData = function (routerParams, query) {
	        console.log("CertificateList#fetchData");
	        return gridService_1.default.fetchGrids(certificateListCAROOT, certificateListCAINTERMEDIATE, certificateListPUBLIC, certificateListPRIVATE)
	            .then(function (gridLocationMap) {
	            certificateService_1.default.certificateListsMV = new gridUtils_1.MovingBlocks(null, true, query.tab, new grid_1.default(gridLocationMap.get(certificateListPRIVATE)), new grid_1.default(gridLocationMap.get(certificateListPUBLIC)), new grid_1.default(gridLocationMap.get(certificateListCAINTERMEDIATE)), new grid_1.default(gridLocationMap.get(certificateListCAROOT)));
	        });
	    };
	    CertificateList.prototype.componentDidMount = function () {
	        console.debug("%c componentDidMount", "background-color: magenta");
	        certificateService_1.default.certificateListsMV.searchExposedGrids(null);
	    };
	    CertificateList.prototype.componentWillUnmount = function () {
	        certificateService_1.default.certificateListsMV = null;
	    };
	    CertificateList.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, params = _a.params, query = _a.query;
	        var gridCompArray = [
	            react_1.default.createElement(gridComp_1.default, { grid: certificateService_1.default.certificateListsMV.getBlock(certificateListPRIVATE), uiLocation: certificateService_1.default.certificateListsMV.getUiLocation(certificateListPRIVATE), entities: mdEntityService_1.default.entityMap }),
	            react_1.default.createElement(gridComp_1.default, { grid: certificateService_1.default.certificateListsMV.getBlock(certificateListPUBLIC), uiLocation: certificateService_1.default.certificateListsMV.getUiLocation(certificateListPUBLIC), entities: mdEntityService_1.default.entityMap }),
	            react_1.default.createElement(gridComp_1.default, { grid: certificateService_1.default.certificateListsMV.getBlock(certificateListCAINTERMEDIATE), uiLocation: certificateService_1.default.certificateListsMV.getUiLocation(certificateListCAINTERMEDIATE), entities: mdEntityService_1.default.entityMap }),
	            react_1.default.createElement(gridComp_1.default, { grid: certificateService_1.default.certificateListsMV.getBlock(certificateListCAROOT), uiLocation: certificateService_1.default.certificateListsMV.getUiLocation(certificateListCAROOT), entities: mdEntityService_1.default.entityMap }),
	        ];
	        var tabArray = gridCompArray.map(function (gridComp, index) { return (react_1.default.createElement(Tab_1.default, { label: gridComp.props.grid.label, style: variables_1.tabStyle, onActive: _this.activateTab.bind(_this, gridComp.props.grid), key: gridComp.props.grid.getBlockName(), value: gridComp.props.grid.getBlockName() }, gridComp)); });
	        var passwordField = react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, createForm_1.fieldStyles.small.textField, { value: this.passwordText, onChange: this.onChangePassword, fullWidth: true, hintText: "Password" }));
	        return (react_1.default.createElement("main", { className: "main-content" },
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: this.$errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.passwordDialogRefHandler, cancelButtonText: "Cancel", okButtonText: "Ok", contentComponent: passwordField, title: "Certificate Password" }),
	            react_1.default.createElement("div", { style: { diplay: 'flex' } },
	                react_1.default.createElement(buttons_1.SecuredZzUploadFlatButton, { label: "Import Certificate", permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.certificateDetail, handleFileUpload: this.handleFileUpload, accept: ".cer,.der,.crt,.pfx,.p12,.p7b" })),
	            react_1.default.createElement(Tabs_1.default, { value: certificateService_1.default.certificateListsMV.activeBlockTab, className: "detail-grid", tabTemplate: mui_theme_1.TabTemplate, inkBarStyle: { transition: 'inherit' }, contentContainerStyle: { width: '100%', flexGrow: 1, display: 'flex', minHeight: 0 }, onChange: this.onTabChange },
	                tabArray,
	                react_1.default.createElement(Tab_1.default, { label: "Private Certificate Usage", style: variables_1.tabStyle, onActive: this.activatePrivateCertTab, value: "privateCertUsage" }, (certificateService_1.default.certificateConfigs) ? (react_1.default.createElement("div", { style: { width: "100%" } },
	                    react_1.default.createElement("table", { className: "zz-simple-table", style: { minWidth: '100%' } },
	                        react_1.default.createElement("thead", null,
	                            react_1.default.createElement("tr", null,
	                                react_1.default.createElement("th", null, "Private Certificate Usage"),
	                                react_1.default.createElement("th", null, "Private Certificate"))),
	                        react_1.default.createElement("tbody", null, certificateService_1.default.certificateConfigs.map(function (config, index) { return (react_1.default.createElement("tr", { key: index },
	                            react_1.default.createElement("td", null, config.beanName),
	                            react_1.default.createElement("td", { style: { width: '70%' } },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({ name: 'select_' + config.beanName, value: config.certificate, options: _this.certificateOptions, onChange: _this.onChangeCertificate.bind(_this, config) }, createForm_1.fieldStyles.small.styledSelect, { fullWidth: true, clearable: false }))))); }))),
	                    react_1.default.createElement(RaisedButton_1.default, { label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Save"], ["Save"]))), onClick: this.onClickSave, primary: true }))) : null))));
	    };
	    CertificateList.prototype.onChangeCertificate = function (config, newCertificate) {
	        console.log('onChangeCertificate: ', newCertificate, config);
	        config.certificate = newCertificate;
	    };
	    ;
	    CertificateList.prototype.onClickSave = function () {
	        console.log('onClickSave: ');
	        return certificateService_1.default.saveCertificateBeanConfigs(certificateService_1.default.certificateConfigs);
	    };
	    ;
	    CertificateList.module = metaConstant_1.MODULE.core;
	    CertificateList.title = locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Certificates"], ["Certificates"])));
	    CertificateList.icon = 'certificate';
	    CertificateList.rootPage = true;
	    CertificateList.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], CertificateList.prototype, "passwordText", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], CertificateList.prototype, "$errors", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], CertificateList.prototype, "certificateOptions", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], CertificateList.prototype, "onTabChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], CertificateList.prototype, "handleFileUpload", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], CertificateList.prototype, "onChangePassword", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], CertificateList.prototype, "activatePrivateCertTab", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], CertificateList.prototype, "onChangeCertificate", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], CertificateList.prototype, "onClickSave", null);
	    CertificateList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], CertificateList);
	    return CertificateList;
	}(pageAncestor_1.default));
	exports.default = CertificateList;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var gridLocationMap = {
	    Country: "countryList"
	};
	var ReferenceDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(ReferenceDetail, _super);
	    function ReferenceDetail() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ReferenceDetail.fetchData = function (routerParams) {
	        var gridLocation = gridLocationMap[routerParams.id];
	        document.title = 'Reference Table - ' + routerParams.id;
	        console.log("ReferenceDetail#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gl) { return gridService_1.default.getOrCreateGrid(gridLocation); });
	    };
	    ReferenceDetail.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        var gridLocation = gridLocationMap[params.id];
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query }));
	    };
	    ReferenceDetail.module = metaConstant_1.MODULE.core;
	    ReferenceDetail.icon = 'server';
	    ReferenceDetail.protectedPage = true;
	    ReferenceDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ReferenceDetail);
	    return ReferenceDetail;
	}(pageAncestor_1.default));
	exports.default = ReferenceDetail;


/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var react_router_1 = __webpack_require__(65);
	var utils_1 = __webpack_require__(37);
	var locales_1 = __webpack_require__(15);
	var ReferenceList = /** @class */ (function (_super) {
	    tslib_1.__extends(ReferenceList, _super);
	    function ReferenceList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ReferenceList.fetchData = function (routerParams) {
	        console.log("ReferenceList#fetchData %O", routerParams);
	        // return Promise.all([gridService.fetchGrids(gridLocation), jobService.readAvailableJobs()])
	        //   .then(([gridLocationMap, availableJobs]: [ObservableMap<GridLocation>, {[key: string]: string[]}]) => {
	        //     jobService.availableJobs = availableJobs;
	        //     return gridService.getOrCreateGrid(gridLocation);
	        //})
	    };
	    ReferenceList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement("main", { className: "main-content" },
	            react_1.default.createElement("table", { className: "zz-simple-table", style: { margin: 20 } },
	                react_1.default.createElement("tbody", null,
	                    react_1.default.createElement("tr", null,
	                        react_1.default.createElement("td", null,
	                            react_1.default.createElement(react_router_1.Link, { to: "referenceDetail", params: { id: "Country" }, query: (0, utils_1.addTenantToQuery)() }, "Countries")))))));
	    };
	    ReferenceList.module = metaConstant_1.MODULE.core;
	    ReferenceList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Reference Tables"], ["Reference Tables"])));
	    ReferenceList.icon = 'server';
	    ReferenceList.rootPage = true;
	    ReferenceList.protectedPage = true;
	    ReferenceList.contextTypes = {
	        router: prop_types_1.default.func.isRequired
	    };
	    ReferenceList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ReferenceList);
	    return ReferenceList;
	}(pageAncestor_1.default));
	exports.default = ReferenceList;
	var templateObject_1;


/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var variables_1 = __webpack_require__(96);
	var ResponsiveTest = /** @class */ (function (_super) {
	    tslib_1.__extends(ResponsiveTest, _super);
	    function ResponsiveTest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = _this._createSizeObject();
	        _this.onResize = function (evt) {
	            _this.setState(_this._createSizeObject());
	        };
	        _this.onChecked = function (e) {
	            console.log('onChecked ', e.target.value, e.target.checked);
	            _this.setState({ checkboxValue: e.target.checked });
	        };
	        _this.onDateTest = function (e) {
	            var invoiceDate = '2016-07-25';
	            var startInvoicePeriod = (0, moment_1.default)(invoiceDate).startOf('month').toISOString();
	            var endInvoicePeriod = (0, moment_1.default)(invoiceDate).endOf('month').startOf('day').toISOString();
	            console.log('startInvoicePeriod ', startInvoicePeriod);
	            console.log('endInvoicePeriod ', endInvoicePeriod);
	            var struct = {
	                localDate1: startInvoicePeriod,
	                localDate2: endInvoicePeriod,
	                localDateTime1: startInvoicePeriod,
	                localDateTime2: endInvoicePeriod,
	                instant1: startInvoicePeriod,
	                instant2: endInvoicePeriod,
	                zonedDateTime1: startInvoicePeriod,
	                zonedDateTime2: endInvoicePeriod
	            };
	            axios_config_1.default.post('/public/test/dates', struct)
	                .then(function (response) {
	                console.log(response);
	            });
	        };
	        _this.onDateTest2 = function (e) {
	            var invoiceDate = '2016-07-25';
	            var startInvoicePeriod = (0, moment_1.default)(invoiceDate).startOf('month').format("YYYY-MM-DD");
	            var endInvoicePeriod = (0, moment_1.default)(invoiceDate).endOf('month').startOf('day').format("YYYY-MM-DD");
	            console.log('startInvoicePeriod ', startInvoicePeriod);
	            console.log('endInvoicePeriod ', endInvoicePeriod);
	            var struct = {
	                localDate1: startInvoicePeriod,
	                localDate2: endInvoicePeriod,
	            };
	            axios_config_1.default.post('/public/test/dates', struct)
	                .then(function (response) {
	                console.log(response);
	            });
	        };
	        return _this;
	    }
	    ResponsiveTest.prototype._createSizeObject = function () {
	        var widths = {
	            screenWidth: window.screen.width,
	            viewportWidth: window.innerWidth,
	            bodyClientWidth: document.body.clientWidth,
	            documentClientWidth: document.documentElement.clientWidth,
	            checkboxValue: true
	        };
	        console.log('widths: ', widths);
	        return widths;
	    };
	    ResponsiveTest.prototype.componentWillMount = function () {
	        this.mq = window.matchMedia('only screen and (min-width: ' + variables_1.screenLg + 'px)');
	        if (this.mq.matches) {
	            console.log('the width of browser is more then ' + variables_1.screenLg);
	        }
	        else {
	            console.log('the width of browser is less then ' + variables_1.screenLg);
	        }
	        this.mq.addListener(function (changed) {
	            if (changed.matches) {
	                console.log('the width of browser is more then ' + variables_1.screenLg);
	            }
	            else {
	                console.log('the width of browser is less then ' + variables_1.screenLg);
	            }
	        });
	    };
	    ResponsiveTest.prototype.componentDidMount = function () {
	        window.addEventListener('resize', this.onResize);
	    };
	    ResponsiveTest.prototype.componentWillUnmount = function () {
	        window.removeEventListener('resize', this.onResize);
	        this.mq.removeListener(this.onResize);
	    };
	    ResponsiveTest.prototype.render = function () {
	        var _a = this.state, screenWidth = _a.screenWidth, viewportWidth = _a.viewportWidth, bodyClientWidth = _a.bodyClientWidth, documentClientWidth = _a.documentClientWidth;
	        return (react_1.default.createElement("main", { className: "main-content" },
	            react_1.default.createElement(toolmenu_1.default, null,
	                react_1.default.createElement("div", null,
	                    "window.screen.width: ",
	                    screenWidth),
	                react_1.default.createElement("div", null,
	                    "window.innerWidth: ",
	                    viewportWidth),
	                react_1.default.createElement("div", null,
	                    "document.body.clientWidth: ",
	                    bodyClientWidth),
	                react_1.default.createElement("div", null,
	                    "document.documentElement.clientWidth: ",
	                    documentClientWidth)),
	            react_1.default.createElement("form", null,
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12" },
	                        react_1.default.createElement("div", { className: "box", style: { backgroundColor: 'blue', color: 'white', marginTop: 10 } }, "col-xs  < 768px"))),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12" },
	                        react_1.default.createElement("div", { className: "box", style: { backgroundColor: 'blue', color: 'white' } }, "768px <= col-sm  < 992px"))),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12" },
	                        react_1.default.createElement("div", { className: "box", style: { backgroundColor: 'blue', color: 'white' } }, "992px <= col-md  < 1200px"))),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12" },
	                        react_1.default.createElement("div", { className: "box", style: { backgroundColor: 'blue', color: 'white' } }, "1200px <= col-lg"))),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12" },
	                        react_1.default.createElement("div", { className: "box", style: { backgroundColor: 'lightGrey', marginTop: 10, marginBottom: 10 } }, "col-xs-12"))),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12 col-sm-8" },
	                        react_1.default.createElement("div", { className: "box", style: { backgroundColor: 'lightGrey', marginTop: 10, marginBottom: 10 } }, "col-xs-12 col-sm-8"))),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12 col-sm-8 col-md-6" },
	                        react_1.default.createElement("div", { className: "box", style: { backgroundColor: 'lightGrey', marginTop: 10, marginBottom: 10 } }, "col-xs-12 col-sm-8 col-md-6"))),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12 col-sm-8 col-md-6 col-lg-4" },
	                        react_1.default.createElement("div", { className: "box", style: { backgroundColor: 'lightGrey', marginTop: 10, marginBottom: 10 } }, "col-xs-12 col-sm-8 col-md-6 col-lg-4"))),
	                react_1.default.createElement("hr", null),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12 col-md-6 col-lg-4" },
	                        react_1.default.createElement("div", { className: "box", style: { backgroundColor: 'yellow', marginTop: 10, marginBottom: 10 } }, "col-xs-12 col-sm-8 col-md-6 col-lg-4")),
	                    react_1.default.createElement("div", { className: "col-xs-12  col-md-6 col-lg-4" },
	                        react_1.default.createElement("div", { className: "box", style: { backgroundColor: 'yellow', marginTop: 10, marginBottom: 10 } }, "col-xs-12 col-sm-8 col-md-6 col-lg-4")),
	                    react_1.default.createElement("div", { className: "col-xs-12 col-md-6 col-lg-4" },
	                        react_1.default.createElement("div", { className: "box", style: { backgroundColor: 'yellow', marginTop: 10, marginBottom: 10 } }, "col-xs-12 col-sm-8 col-md-6 col-lg-4"))),
	                react_1.default.createElement(styledDatePicker_1.default, { defaultValue: new Date(), style: { marginRight: '20px' }, placeholder: "Datum narozeni" }),
	                react_1.default.createElement(styledDatePicker_1.default, { defaultValue: new Date(), style: { marginRight: '20px' }, floatingLabelText: "Datum narozeni" }),
	                react_1.default.createElement(fields_1.MdTextField, { defaultValue: '1000' }),
	                react_1.default.createElement(fields_1.MdCheckbox, { name: "checkboxName", checked: this.state.checkboxValue, label: "went for a run today", onCheck: this.onChecked }),
	                react_1.default.createElement(FlatButton_1.default, { label: "onDateTest", onClick: this.onDateTest }),
	                react_1.default.createElement(FlatButton_1.default, { label: "onDateTest2", onClick: this.onDateTest2 }))));
	    };
	    ResponsiveTest.title = 'Responsive Test';
	    ResponsiveTest.icon = 'home';
	    return ResponsiveTest;
	}(react_1.default.Component));
	exports.default = ResponsiveTest;


/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var Tabs_1 = tslib_1.__importDefault(__webpack_require__(107));
	var Tab_1 = tslib_1.__importDefault(__webpack_require__(102));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var last = __webpack_require__(138);
	var mobx_1 = __webpack_require__(5);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var numberUtils_1 = __webpack_require__(143);
	var buttons_1 = __webpack_require__(27);
	var dateUtils_1 = __webpack_require__(49);
	var MValue = function (_a) {
	    var label = _a.label, value = _a.value, numFormat = _a.numFormat, suffix = _a.suffix;
	    var valueStyle = { display: 'table-cell' };
	    if (numFormat) {
	        value = (0, numberUtils_1.formatNumber)(value, numFormat);
	        valueStyle['textAlign'] = 'right';
	    }
	    return (react_1.default.createElement("div", { style: { display: 'table-row' } },
	        react_1.default.createElement("div", { style: { display: 'table-cell', paddingRight: 10 } }, label),
	        react_1.default.createElement("div", { style: valueStyle },
	            value,
	            suffix)));
	};
	// {"memory":{"Max memory":"3,5 GiB","Free memory":"535,7 MiB","Total memory":"905,5 MiB"},"jvmProps":[{"java.vendor":"Oracle Corporation"},{"sun.java.launcher":"SUN_STANDARD"},
	var Metrics = function (_a) {
	    var zzInfo = _a.zzInfo, info = _a.info;
	    return (react_1.default.createElement("div", null,
	        react_1.default.createElement("div", { className: "row" },
	            react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                react_1.default.createElement("h3", null, "Build info"),
	                react_1.default.createElement(MValue, { label: "Version", value: info.build ? info.build.version : "" }),
	                react_1.default.createElement(MValue, { label: "Timestamp", value: (0, dateUtils_1.formatDateTime)(info.build ? info.build.time : "") })),
	            react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                react_1.default.createElement("h3", null, "Memory"),
	                Object.entries(zzInfo["memory"]).map(function (entry) { return react_1.default.createElement(MValue, { label: entry[0], value: entry[1] }); }))),
	        react_1.default.createElement("div", { className: "row" },
	            react_1.default.createElement("div", { className: "col-sm-12" },
	                react_1.default.createElement("h3", null, "JVM Properties"),
	                zzInfo["jvmProps"].map(function (prop) {
	                    var key = Object.keys(prop)[0];
	                    return react_1.default.createElement(MValue, { label: key, value: prop[key] });
	                })))));
	};
	var Logs = function (_a) {
	    var data = _a.data;
	    return (react_1.default.createElement("table", { className: "zz-simple-table", style: { margin: 20 } },
	        react_1.default.createElement("tbody", null, data.map(function (logName) { return (react_1.default.createElement("tr", { key: logName },
	            react_1.default.createElement("td", null,
	                react_1.default.createElement("a", { href: '/api/core/logging/' + logName, target: "_blank" }, logName)))); }))));
	};
	var CacheStats = /** @class */ (function (_super) {
	    tslib_1.__extends(CacheStats, _super);
	    function CacheStats() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onClearAll = function () {
	            return axios_config_1.default.delete("/core/caches").then(function (response) {
	                return _this.readData();
	            });
	        };
	        _this.onClear = function (cacheName) {
	            return axios_config_1.default.delete("/core/cache/" + cacheName).then(function (response) {
	                return _this.readData();
	            });
	        };
	        _this.onRefresh = function () {
	            return _this.readData();
	        };
	        return _this;
	    }
	    CacheStats.prototype.componentDidMount = function () {
	        return this.readData();
	    };
	    CacheStats.prototype.readData = function () {
	        var _this = this;
	        return axios_config_1.default.get("/core/caches")
	            .then(function (response) {
	            _this.cacheStats = response.data;
	        });
	    };
	    CacheStats.prototype.render = function () {
	        var _this = this;
	        if (!this.cacheStats)
	            return react_1.default.createElement("noscript", null);
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { style: { display: 'flex' } },
	                react_1.default.createElement(buttons_1.SecuredZzFlatButton, { onClick: this.onClearAll, label: "Clear all caches", primary: true, style: { margin: '20px 0 0 20px' }, permission: metaConstant_1.PERMISSION.Update }),
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onRefresh, label: "Refresh", primary: true, style: { margin: '20px 0 0 20px' } })),
	            react_1.default.createElement("table", { className: "zz-simple-table", style: { margin: 20 } },
	                react_1.default.createElement("thead", null,
	                    react_1.default.createElement("tr", null,
	                        react_1.default.createElement("th", null, "Cache Name"),
	                        react_1.default.createElement("th", null, "Clear"),
	                        react_1.default.createElement("th", null, "Current size"),
	                        react_1.default.createElement("th", null, "Total size"),
	                        react_1.default.createElement("th", null, "Puts #"),
	                        react_1.default.createElement("th", null, "Gets #"),
	                        react_1.default.createElement("th", null, "Hits #"),
	                        react_1.default.createElement("th", null, "Misses #"),
	                        react_1.default.createElement("th", null, "Remove hits #"),
	                        react_1.default.createElement("th", null, "Remove misses #"),
	                        react_1.default.createElement("th", null, "Evictions #"),
	                        react_1.default.createElement("th", null, "Read time"),
	                        react_1.default.createElement("th", null, "Write time"),
	                        react_1.default.createElement("th", null, "Remove time"))),
	                react_1.default.createElement("tbody", null, this.cacheStats.map(function (cacheDto) { return (react_1.default.createElement("tr", { key: cacheDto.name },
	                    react_1.default.createElement("td", null, cacheDto.name),
	                    react_1.default.createElement("td", null,
	                        react_1.default.createElement(buttons_1.SecuredZzFlatButton, { onClick: _this.onClear.bind(_this, cacheDto.name), label: "Clear", primary: true, permission: metaConstant_1.PERMISSION.Update })),
	                    react_1.default.createElement("td", null, cacheDto.currentNumberOfEntries),
	                    react_1.default.createElement("td", null, cacheDto.totalNumberOfEntries),
	                    react_1.default.createElement("td", null, cacheDto.stores),
	                    react_1.default.createElement("td", null, cacheDto.retrievals),
	                    react_1.default.createElement("td", null, cacheDto.hits),
	                    react_1.default.createElement("td", null, cacheDto.misses),
	                    react_1.default.createElement("td", null, cacheDto.removeHits),
	                    react_1.default.createElement("td", null, cacheDto.removeMisses),
	                    react_1.default.createElement("td", null, cacheDto.evictions),
	                    react_1.default.createElement("td", null, cacheDto.averageReadTime),
	                    react_1.default.createElement("td", null, cacheDto.averageWriteTime),
	                    react_1.default.createElement("td", null, cacheDto.averageRemoveTime))); })))));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], CacheStats.prototype, "cacheStats", void 0);
	    CacheStats = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], CacheStats);
	    return CacheStats;
	}(react_1.default.Component));
	var ServerOverview = /** @class */ (function (_super) {
	    tslib_1.__extends(ServerOverview, _super);
	    function ServerOverview() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleChange = function (value) {
	            console.log("handleChange " + value);
	            _this.activeTab = value;
	            _this[_this.activeTab]();
	            var routeName = last(_this.context.router.getCurrentRoutes()).name, params = _this.context.router.getCurrentParams();
	            params.tab = value;
	            _this.context.router.replaceWith(routeName, params, undefined);
	        };
	        return _this;
	    }
	    ServerOverview.fetchData = function (routerParams) {
	        console.log("ServerOverview#fetchData %O", routerParams);
	        // return Promise.all([gridService.fetchGrids(gridLocation), jobService.readAvailableJobs()])
	        //   .then(([gridLocationMap, availableJobs]: [ObservableMap<GridLocation>, {[key: string]: string[]}]) => {
	        //     jobService.availableJobs = availableJobs;
	        //     return gridService.getOrCreateGrid(gridLocation);
	        //})
	    };
	    ServerOverview.prototype.componentWillMount = function () {
	        var params = this.context.router.getCurrentParams();
	        this.activeTab = (params.tab) ? params.tab : 'info';
	    };
	    ServerOverview.prototype.componentDidMount = function () {
	        this[this.activeTab]();
	    };
	    ServerOverview.prototype.info = function () {
	        var _this = this;
	        if (!this.infoMetrics) {
	            Promise.all([axios_config_1.default.get("/core/info"), axios_config_1.default.get("/manage/info")])
	                .then(function (_a) {
	                var responseZzInfo = _a[0], responseInfo = _a[1];
	                _this.infoMetrics = { zzInfo: responseZzInfo.data, info: responseInfo.data };
	            });
	        }
	    };
	    ServerOverview.prototype.logs = function () {
	        var _this = this;
	        if (!this.logNames) {
	            axios_config_1.default.get("/core/logging")
	                .then(function (response) {
	                _this.logNames = response.data;
	            });
	        }
	    };
	    ServerOverview.prototype.caches = function () {
	        // cache manages its own data
	    };
	    ServerOverview.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        console.debug("ServerPage render");
	        return (react_1.default.createElement("main", { className: "main-content" },
	            react_1.default.createElement(Tabs_1.default, { value: this.activeTab, onChange: this.handleChange },
	                react_1.default.createElement(Tab_1.default, { label: "Info", value: "info" },
	                    react_1.default.createElement("div", null, (this.infoMetrics) ? (react_1.default.createElement(Metrics, tslib_1.__assign({}, this.infoMetrics))) : null)),
	                react_1.default.createElement(Tab_1.default, { label: "Logs", value: "logs" },
	                    react_1.default.createElement("div", null, (this.logNames) ? (react_1.default.createElement(Logs, { data: this.logNames })) : null)),
	                react_1.default.createElement(Tab_1.default, { label: "Caches", value: "caches" },
	                    react_1.default.createElement("div", null,
	                        react_1.default.createElement(CacheStats, null))),
	                react_1.default.createElement(Tab_1.default, { label: "Threads", value: "threads" },
	                    react_1.default.createElement("div", null,
	                        react_1.default.createElement("h2", null, "Controllable Tab B"),
	                        react_1.default.createElement("p", null, "This is another example of a controllable tab. Remember, if you use controllable Tabs, you need to give all of your tabs values or else you wont be able to select them."))),
	                react_1.default.createElement(Tab_1.default, { label: "Connections", value: "connections" },
	                    react_1.default.createElement("div", null,
	                        react_1.default.createElement("h2", null, "Controllable Tab B"),
	                        react_1.default.createElement("p", null, "This is another example of a controllable tab. Remember, if you use controllable Tabs, you need to give all of your tabs values or else you wont be able to select them."))),
	                react_1.default.createElement(Tab_1.default, { label: "Beans", value: "beans" },
	                    react_1.default.createElement("div", null,
	                        react_1.default.createElement("h2", null, "Controllable Tab B"),
	                        react_1.default.createElement("p", null, "This is another example of a controllable tab. Remember, if you use controllable Tabs, you need to give all of your tabs values or else you wont be able to select them."))))));
	    };
	    ServerOverview.module = metaConstant_1.MODULE.core;
	    ServerOverview.title = 'Server';
	    ServerOverview.icon = 'server';
	    ServerOverview.rootPage = true;
	    ServerOverview.protectedPage = true;
	    ServerOverview.contextTypes = {
	        router: prop_types_1.default.func.isRequired
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ServerOverview.prototype, "activeTab", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ServerOverview.prototype, "infoMetrics", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ServerOverview.prototype, "logNames", void 0);
	    ServerOverview = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ServerOverview);
	    return ServerOverview;
	}(pageAncestor_1.default));
	exports.default = ServerOverview;


/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EditableTenantAncestor = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var tenantService_1 = tslib_1.__importDefault(__webpack_require__(402));
	var utils_1 = __webpack_require__(37);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var constants_1 = __webpack_require__(570);
	/**
	 * For entities that using the only tenantId but tenant edit is wanted from GUI
	 */
	var EditableTenantAncestor = /** @class */ (function (_super) {
	    tslib_1.__extends(EditableTenantAncestor, _super);
	    function EditableTenantAncestor(json) {
	        return _super.call(this, json) || this;
	    }
	    EditableTenantAncestor.prototype.resolveTenantOrTenantGroup = function (formName) {
	        var _this = this;
	        if (this.tenantId || this.tenantId === 0) {
	            tenantService_1.default.getTenantLovItem(this.tenantId)
	                .then(function (res) {
	                if (res) {
	                    if ((0, utils_1.isTenantNumber)(res.value))
	                        _this.tenant = res;
	                    else
	                        _this.tenantGroup = res;
	                    if (formName) {
	                        var form = _this.getForm(formName);
	                        form.getField("tenant").props.value = _this.tenant;
	                        form.getField("tenantGroup").props.value = _this.tenantGroup;
	                    }
	                }
	            });
	        }
	    };
	    EditableTenantAncestor.prototype.loadTenantOptions = function (formName) {
	        var _this = this;
	        mdEntityService_1.default.fetchMissingEntityLovs([constants_1.TENANT_ENTITY, constants_1.TENANT_GROUP_ENTITY])
	            .then(function (res) { return _this.parseTenantOptionsToProvidedForm(formName, res); });
	    };
	    EditableTenantAncestor.prototype.parseTenantOptionsToProvidedForm = function (formName, tenantOptions) {
	        var form = this.getForm(formName);
	        form.getField("tenant").props.options = tenantOptions[constants_1.TENANT_ENTITY];
	        form.getField("tenantGroup").props.options = tenantOptions[constants_1.TENANT_GROUP_ENTITY];
	    };
	    EditableTenantAncestor.prototype.createEditTenantDto = function () {
	        return {
	            dataObject: this,
	            tenantGroup: this.tenantGroup,
	            tenant: this.tenant
	        };
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EditableTenantAncestor.prototype, "tenantGroup", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EditableTenantAncestor.prototype, "tenant", void 0);
	    return EditableTenantAncestor;
	}(DomainAncestor_1.DomainAncestor));
	exports.EditableTenantAncestor = EditableTenantAncestor;


/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.errorToTeams = errorToTeams;
	var tslib_1 = __webpack_require__(3);
	var axios_1 = tslib_1.__importDefault(__webpack_require__(314));
	var customAxios = axios_1.default.create({
	    headers: {
	        'Content-Type': 'text/plain'
	    }
	});
	function errorToTeams(reason, userAgent, username) {
	    var teamsUrl = "https://zauzoocom.webhook.office.com/webhookb2/fa44a333-ddea-4c1b-acfd-693ac89da5a9@60b62049-2eac-4c01-acad-4e62d8ca8fef/IncomingWebhook/55b45351339f41fb975fccfa2f8d383b/f4ae6f61-d8b9-4d89-8b3d-99928cffc0fc";
	    var title = "\uD83D\uDCA3 " + reason.substring(0, 100);
	    var message = {
	        "@type": "MessageCard",
	        "@context": "https://schema.org/extensions",
	        "summary": title,
	        "themeColor": "ff4444",
	        "title": title,
	        "sections": [
	            {
	                "facts": [
	                    {
	                        name: "browser",
	                        value: userAgent.browser.name + ' ' + userAgent.browser.version,
	                    },
	                    {
	                        name: "engine",
	                        value: userAgent.engine.name + ' ' + userAgent.engine.version,
	                    },
	                    {
	                        name: "os",
	                        value: userAgent.os.name + ' ' + userAgent.os.version,
	                    },
	                    {
	                        name: "device",
	                        value: userAgent.device.type + ' ' + userAgent.device.model + ' ' + userAgent.device.vendor,
	                    },
	                    {
	                        name: "user",
	                        value: username,
	                    }
	                ]
	            },
	            {
	                "text": "<pre>" + reason + "</pre>"
	            }
	        ]
	    };
	    return customAxios.post(teamsUrl, message).catch(function (error) {
	        console.log(error);
	    });
	}


/***/ }),
/* 2048 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.encode = encode;
	exports.decode = decode;
	function utf8ToBytes(str, units) {
	    units = units || Infinity;
	    var codePoint;
	    var length = str.length;
	    var leadSurrogate = null;
	    var bytes = [];
	    var i = 0;
	    for (; i < length; i++) {
	        codePoint = str.charCodeAt(i);
	        // is surrogate component
	        if (codePoint > 0xD7FF && codePoint < 0xE000) {
	            // last char was a lead
	            if (leadSurrogate) {
	                // 2 leads in a row
	                if (codePoint < 0xDC00) {
	                    if ((units -= 3) > -1)
	                        bytes.push(0xEF, 0xBF, 0xBD);
	                    leadSurrogate = codePoint;
	                    continue;
	                }
	                else {
	                    // valid surrogate pair
	                    codePoint = leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00 | 0x10000;
	                    leadSurrogate = null;
	                }
	            }
	            else {
	                // no lead yet
	                if (codePoint > 0xDBFF) {
	                    // unexpected trail
	                    if ((units -= 3) > -1)
	                        bytes.push(0xEF, 0xBF, 0xBD);
	                    continue;
	                }
	                else if (i + 1 === length) {
	                    // unpaired lead
	                    if ((units -= 3) > -1)
	                        bytes.push(0xEF, 0xBF, 0xBD);
	                    continue;
	                }
	                else {
	                    // valid lead
	                    leadSurrogate = codePoint;
	                    continue;
	                }
	            }
	        }
	        else if (leadSurrogate) {
	            // valid bmp char, but last char was a lead
	            if ((units -= 3) > -1)
	                bytes.push(0xEF, 0xBF, 0xBD);
	            leadSurrogate = null;
	        }
	        // encode utf8
	        if (codePoint < 0x80) {
	            if ((units -= 1) < 0)
	                break;
	            bytes.push(codePoint);
	        }
	        else if (codePoint < 0x800) {
	            if ((units -= 2) < 0)
	                break;
	            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
	        }
	        else if (codePoint < 0x10000) {
	            if ((units -= 3) < 0)
	                break;
	            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
	        }
	        else if (codePoint < 0x200000) {
	            if ((units -= 4) < 0)
	                break;
	            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
	        }
	        else {
	            throw new Error('Invalid code point');
	        }
	    }
	    return bytes;
	}
	function utf8Slice(buf, start, end) {
	    var res = '';
	    var tmp = '';
	    end = Math.min(buf.length, end || Infinity);
	    start = start || 0;
	    for (var i = start; i < end; i++) {
	        if (buf[i] <= 0x7F) {
	            res += decodeUtf8Char(tmp) + String.fromCharCode(buf[i]);
	            tmp = '';
	        }
	        else {
	            tmp += '%' + buf[i].toString(16);
	        }
	    }
	    return res + decodeUtf8Char(tmp);
	}
	function decodeUtf8Char(str) {
	    try {
	        return decodeURIComponent(str);
	    }
	    catch (err) {
	        return String.fromCharCode(0xFFFD); // UTF 8 invalid char
	    }
	}
	/**
	 * konvertuje string do byte array using UTF-8 encoding
	 * @param str
	 * @returns {*}
	 */
	function encode(str) {
	    return new Uint8Array(utf8ToBytes(str));
	}
	/**
	 * konvertuje byte array do stringu using UTF-8 encoding
	 * @param bytes
	 */
	function decode(bytes) {
	    return utf8Slice(bytes, 0, bytes.length);
	}


/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var react_router_1 = __webpack_require__(65);
	var react_notification_system_1 = tslib_1.__importDefault(__webpack_require__(1840));
	var mui_theme_1 = __webpack_require__(119);
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var mainMenu_1 = tslib_1.__importDefault(__webpack_require__(2059));
	var logging_1 = __webpack_require__(2047);
	var getMuiTheme_1 = tslib_1.__importDefault(__webpack_require__(775));
	var mobx_react_1 = __webpack_require__(4);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var ua_parser_js_1 = tslib_1.__importDefault(__webpack_require__(967));
	__webpack_require__(1276);
	// detekce react modu
	try {
	    react_1.default.createClass({});
	}
	catch (e) {
	    console.log('REACT IS RUNNING IN ' + ((e.message.indexOf('render') >= 0) ? 'DEV' : 'PROD') + ' MODE');
	}
	var Application = /** @class */ (function (_super) {
	    tslib_1.__extends(Application, _super);
	    function Application() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            loading: false
	        };
	        _this.notificationSystemRefHandler = function (comp) { return _this._notificationSystemRef = comp; };
	        return _this;
	    }
	    Application.prototype.getChildContext = function () {
	        return { muiTheme: (0, getMuiTheme_1.default)(mui_theme_1.muiTheme) };
	    };
	    Application.prototype.componentWillMount = function () {
	        var parser = new ua_parser_js_1.default();
	        var userAgent = parser.getResult();
	        var username = (securityService_1.default.currentUser) ? securityService_1.default.currentUser.username : null;
	        window.onerror = function (message, source, lineno, colno, error) {
	            var reason = (error && error.stack) ? error.stack.toString() : (message + "");
	            commonService_1.default.notifyError(reason, 'Client Error');
	            if (false) {
	                return (0, logging_1.errorToTeams)(reason, userAgent, username);
	            }
	            //console.log('%c onerror: reason = %s, message = %s, source = %s, lineno = %s, colno = %s, error = %O', 'background-color: red', reason, message, source, lineno, colno, error);
	        };
	        window.addEventListener("unhandledrejection", function (event) {
	            var anyEvent = event;
	            var reason = (anyEvent.detail && anyEvent.detail.reason) ? anyEvent.detail.reason : ((anyEvent.reason) ? anyEvent.reason : event.toString());
	            if (reason) {
	                if (reason.status === 400)
	                    return;
	                var _r = (reason.stack) ? reason.stack : reason;
	                commonService_1.default.notifyError(reason, 'Client Error');
	                if (false) {
	                    return (0, logging_1.errorToTeams)(_r, userAgent, username);
	                }
	            }
	        });
	    };
	    Application.prototype.componentDidMount = function () {
	        var _this = this;
	        commonService_1.default.notificationSystem = this._notificationSystemRef;
	        commonService_1.default.router = this.context.router;
	        commonService_1.default.emitter.on('LOADING', function (isOn) {
	            var loading = isOn[0];
	            console.log('LOADING listener: ', loading);
	            if (_this.state.loading ? !loading : loading) {
	                _this.setState({ loading: loading });
	            }
	        });
	    };
	    ;
	    Application.prototype.componentWillUnmount = function () {
	        commonService_1.default.emitter.removeAllListeners('LOADING');
	        commonService_1.default.notificationSystem = null;
	    };
	    Application.prototype.render = function () {
	        var devtools = null;
	        if (false) {
	            var DevTools = require('mobx-react-devtools').default;
	            devtools = react_1.default.createElement(DevTools, null);
	        }
	        console.log('render application');
	        return (react_1.default.createElement("div", { id: "content" },
	            (this.state.loading) ? (react_1.default.createElement("div", { className: "loading loading--overlay" },
	                react_1.default.createElement("div", { className: "loading__content loading__content--overlay" },
	                    react_1.default.createElement("p", { className: "sr-only" }, "Loading the view..."),
	                    react_1.default.createElement("i", { className: "fa fa-4x fa-spinner fa-spin" })))) : '',
	            react_1.default.createElement(mainMenu_1.default, { currentUser: securityService_1.default.currentUser, currentTenant: securityService_1.default.currentTenant, availableTenants: securityService_1.default.availableTenants, restrictionData: securityService_1.default.restrictionData }),
	            react_1.default.createElement(react_router_1.RouteHandler, null),
	            react_1.default.createElement(react_notification_system_1.default, { ref: this.notificationSystemRefHandler }),
	            devtools));
	    };
	    Application.contextTypes = {
	        router: prop_types_1.default.func.isRequired
	    };
	    Application.childContextTypes = {
	        muiTheme: prop_types_1.default.object.isRequired
	    };
	    Application = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], Application);
	    return Application;
	}(react_1.default.Component));
	exports.default = Application;


/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ChartGridWrapperComp = exports.ChartComp = void 0;
	var tslib_1 = __webpack_require__(3);
	__webpack_require__(1278);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var mobx_react_1 = __webpack_require__(4);
	var recharts_1 = __webpack_require__(548);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var mobx_1 = __webpack_require__(5);
	var chartDomain_1 = __webpack_require__(928);
	var splitPane_1 = __webpack_require__(2060);
	var axios_1 = tslib_1.__importDefault(__webpack_require__(314));
	var configPane_1 = __webpack_require__(2051);
	var mdField_1 = __webpack_require__(57);
	var dateUtils_1 = __webpack_require__(49);
	var metaConstant_1 = __webpack_require__(13);
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var ChartComp = /** @class */ (function (_super) {
	    tslib_1.__extends(ChartComp, _super);
	    function ChartComp() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.initialDataSeries = [];
	        _this.currentDataSeries = [];
	        _this.allProperitiesSelected = false;
	        _this.currentChartConfigs = new Map();
	        _this.initChartConfigs = new Map();
	        _this.chartConfigsLoaded = false;
	        _this.dataSeriesExtracted = false;
	        _this.shouldUpdateDataSeriesFromConfig = true;
	        _this.newChartId = -1;
	        _this.customDataFetchedIds = new Set();
	        _this.extractDataSeries = function (data, columns) {
	            var colorIndex = 0;
	            if (data == null) {
	                return;
	            }
	            if (data.length > 0) {
	                _this.initialDataSeries = [];
	                _this.currentDataSeries = [];
	                _this.formatDataValues(data, columns);
	                columns.forEach(function (column) {
	                    _this.initialDataSeries.push({
	                        id: column.id,
	                        name: column.effectiveHeaderLabel,
	                        enable: false,
	                        type: chartDomain_1.ChartType.BAR,
	                        color: chartDomain_1.COLORS[colorIndex],
	                        isUsedOnGrid: column.isUsedOnGrid,
	                    });
	                    _this.currentDataSeries.push({
	                        id: column.id,
	                        name: column.effectiveHeaderLabel,
	                        enable: false,
	                        type: chartDomain_1.ChartType.BAR,
	                        color: chartDomain_1.COLORS[colorIndex],
	                        isUsedOnGrid: column.isUsedOnGrid,
	                    });
	                    colorIndex++;
	                    if (colorIndex >= chartDomain_1.COLORS.length) {
	                        colorIndex = 0;
	                    }
	                });
	            }
	            _this.dataSeriesExtracted = true;
	        };
	        _this.renderDataSeries = function () {
	            var elements = [];
	            var index = 0;
	            for (var _i = 0, _a = _this.currentDataSeries; _i < _a.length; _i++) {
	                var ds = _a[_i];
	                if (ds.enable == false) {
	                    continue;
	                }
	                if (ds.type == chartDomain_1.ChartType.BAR) {
	                    var comp = (react_1.default.createElement(recharts_1.Bar, { key: "".concat(ds.name, "-").concat(index), dataKey: ds.name, fill: ds.color, yAxisId: "left" }));
	                    elements.push(comp);
	                }
	                else if (ds.type == chartDomain_1.ChartType.AREA) {
	                    var comp = (react_1.default.createElement(recharts_1.Area, { type: "monotone", key: "".concat(ds.name, "-").concat(index), dataKey: ds.name, fill: ds.color, yAxisId: "right" }));
	                    elements.push(comp);
	                }
	                else if (ds.type == chartDomain_1.ChartType.LINE) {
	                    var comp = (react_1.default.createElement(recharts_1.Line, { type: "monotone", key: "".concat(ds.name, "-").concat(index), dataKey: ds.name, fill: ds.color, yAxisId: "right" }));
	                    elements.push(comp);
	                }
	                index++;
	            }
	            var chartXField = _this.currentChartConfigs.get(_this.activeChartConfigId).chartXField;
	            if (chartXField) {
	                var ds = _this.currentDataSeries.find(function (ds) { return ds.id === chartXField; });
	                if (ds) {
	                    var comp = react_1.default.createElement(recharts_1.XAxis, { key: "".concat(ds.name, "-X-").concat(index), dataKey: ds.name });
	                    elements.push(comp);
	                }
	            }
	            return elements;
	        };
	        return _this;
	    }
	    ChartComp.prototype.getNewChart = function () {
	        return {
	            chartId: this.newChartId,
	            chartName: "New chart",
	            chartType: chartDomain_1.ChartType.BAR,
	            isNew: true,
	            chartColumnsIds: [],
	            configLevel: metaConstant_1.CONFIGLEVEL.USER,
	            chartSorted: false,
	        };
	    };
	    ChartComp.prototype.componentWillMount = function () {
	        var _this = this;
	        var _a = this.props, chart = _a.chart, grid = _a.grid;
	        this.extractDataSeries(chart.data, chart.columnsInfo);
	        axios_1.default.get("/api/core/grid/".concat(grid.activeGridConfig.gridId, "/chart/config")).then(function (response) {
	            var chartConfigDtos = response.data;
	            if (chartConfigDtos.length !== 0) {
	                chartConfigDtos.sort(function (a, b) {
	                    return ("" + a.chartName).localeCompare(b.chartName);
	                });
	                //fill chart configs
	                _this.activeChartConfigId = chartConfigDtos[0].chartId;
	                chartConfigDtos.forEach(function (cC) {
	                    _this.currentChartConfigs.set(cC.chartId, cC);
	                    _this.initChartConfigs.set(cC.chartId, cC);
	                });
	            }
	            else {
	                _this.onNewChart(true); //handle no config, create new chart
	            }
	            var activeConfig = _this.initChartConfigs.get(_this.activeChartConfigId);
	            _this.xAxisDataSort(activeConfig.chartSorted);
	            _this.chartConfigsLoaded = true;
	        });
	    };
	    ChartComp.prototype.onNewChart = function (isInitial) {
	        if (isInitial === void 0) { isInitial = false; }
	        //isInitial = no configs saved in past
	        this.currentChartConfigs.set(this.newChartId, this.getNewChart());
	        this.initChartConfigs.set(this.newChartId, this.getNewChart());
	        this.activeChartConfigId = this.newChartId;
	        if (!isInitial) {
	            this.initialDataSeries.forEach(function (dS) { return (dS.enable = false); });
	            this.currentDataSeries.forEach(function (dS) { return (dS.enable = false); });
	        }
	    };
	    ChartComp.prototype.onDeleteChart = function () {
	        var _this = this;
	        var deletedChartId = this.activeChartConfigId;
	        if (this.initChartConfigs.size === 1) {
	            this.onNewChart();
	        }
	        else {
	            this.initChartConfigs.forEach(function (cC) {
	                if (cC.chartId !== deletedChartId) {
	                    _this.activeChartConfigId = cC.chartId;
	                    return;
	                }
	            });
	        }
	        this.initChartConfigs.delete(deletedChartId);
	        this.currentChartConfigs.delete(deletedChartId);
	        this.updateSeriesFromConfig();
	    };
	    ChartComp.prototype.updateSeriesFromConfig = function (forceUpdate) {
	        var _this = this;
	        if (forceUpdate === void 0) { forceUpdate = false; }
	        if (forceUpdate ||
	            (this.shouldUpdateDataSeriesFromConfig &&
	                this.chartConfigsLoaded &&
	                this.dataSeriesExtracted)) {
	            var enabledMap_1 = new Map();
	            var activeConfig_1 = this.currentChartConfigs.get(this.activeChartConfigId);
	            var enabledColumnIds_1 = activeConfig_1.chartColumnsIds;
	            this.props.chart.columnsInfo.forEach(function (column) {
	                //fill enabled map
	                enabledMap_1.set(column.id, enabledColumnIds_1.find(function (c) { return c === column.id; }) !== undefined);
	            });
	            this.initialDataSeries.forEach(function (dS) {
	                dS.enable = enabledMap_1.get(dS.id);
	                dS.type = activeConfig_1.chartType;
	            });
	            var columnIdsToFetch_1 = [];
	            this.currentDataSeries.forEach(function (dS) {
	                dS.enable = enabledMap_1.get(dS.id);
	                dS.type = activeConfig_1.chartType;
	                if (dS.enable &&
	                    !dS.isUsedOnGrid &&
	                    !_this.customDataAlreadyFetched(dS.id)) {
	                    //add others columns ids to fetch
	                    columnIdsToFetch_1.push(dS.id);
	                    _this.customDataFetchedIds.add(dS.id);
	                }
	                if (activeConfig_1.chartXField === dS.id &&
	                    !_this.customDataAlreadyFetched(dS.id)) {
	                    //x axis id to fetch
	                    columnIdsToFetch_1.push(dS.id);
	                    _this.customDataFetchedIds.add(dS.id);
	                }
	            });
	            if (columnIdsToFetch_1.length > 0) {
	                this.props.onCustomDataFetch(columnIdsToFetch_1);
	            }
	            if (!forceUpdate)
	                this.shouldUpdateDataSeriesFromConfig = false;
	        }
	    };
	    ChartComp.prototype.componentWillUpdate = function () {
	        this.updateSeriesFromConfig();
	    };
	    ChartComp.prototype.componentDidUpdate = function (prevProps, _, __) {
	        if (prevProps.chart != this.props.chart) {
	            var chart = this.props.chart;
	            this.extractDataSeries(chart.data, chart.columnsInfo);
	            this.updateSeriesFromConfig(true);
	        }
	    };
	    ChartComp.prototype.formatDataValues = function (data, columns) {
	        var dateLabelSet = new Set();
	        var durationLabelSet = new Set();
	        columns.forEach(function (column) {
	            if (column.dataType === mdField_1.DATATYPE.DATE) {
	                dateLabelSet.add(column.effectiveHeaderLabel);
	            }
	            else if (column.dataType === mdField_1.DATATYPE.DURATION) {
	                durationLabelSet.add(column.effectiveHeaderLabel);
	            }
	        });
	        data.forEach(function (piece) {
	            dateLabelSet.forEach(function (label) {
	                if (piece[label]) {
	                    piece[label] = (0, dateUtils_1.formatDate)(piece[label]);
	                }
	            });
	            durationLabelSet.forEach(function (label) {
	                if (piece[label]) {
	                    piece[label] = (0, dateUtils_1.formatPeriod)(piece[label] * 1000, true);
	                }
	            });
	        });
	    };
	    ChartComp.prototype.customDataAlreadyFetched = function (columnId) {
	        return this.customDataFetchedIds.has(columnId);
	    };
	    ChartComp.prototype.xAxisDataSort = function (sort) {
	        var chart = this.props.chart;
	        var activeConfig = this.currentChartConfigs.get(this.activeChartConfigId);
	        if (!activeConfig.chartXField)
	            return;
	        if (sort) {
	            var effectiveHeaderLabel_1 = this.props.chart.columnsInfo.find(function (column) { return column.id === activeConfig.chartXField; }).effectiveHeaderLabel;
	            var value = chart.data[0][effectiveHeaderLabel_1];
	            if (value !== undefined) {
	                var isDate = (0, moment_1.default)(value, moment_1.default.ISO_8601, true).isValid();
	                var isNumber = typeof value == "string" && !isNaN(value) && !isNaN(parseFloat(value));
	                if (isDate) {
	                    this.sortedData = tslib_1.__spreadArray([], chart.data, true).sort(function (a, b) {
	                        return (0, moment_1.default)(a[effectiveHeaderLabel_1], moment_1.default.ISO_8601).diff((0, moment_1.default)(b[effectiveHeaderLabel_1], moment_1.default.ISO_8601));
	                    });
	                }
	                else if (isNumber) {
	                    this.sortedData = tslib_1.__spreadArray([], chart.data, true).sort(function (a, b) {
	                        return parseFloat(a[effectiveHeaderLabel_1]) < parseFloat(b[effectiveHeaderLabel_1]) ? -1 : 1;
	                    });
	                }
	                else {
	                    this.sortedData = tslib_1.__spreadArray([], chart.data, true).sort(function (a, b) {
	                        return a[effectiveHeaderLabel_1] < b[effectiveHeaderLabel_1] ? -1 : 1;
	                    });
	                }
	            }
	        }
	        else {
	            this.sortedData = undefined;
	        }
	    };
	    ChartComp.prototype.renderConfigPane = function () {
	        var _this = this;
	        return (react_1.default.createElement(configPane_1.ConfigPane, { initChartConfigs: this.initChartConfigs, currentChartConfigs: this.currentChartConfigs, activeChartConfigId: this.activeChartConfigId, onChartConfigChange: function (chartConfig, changeType) {
	                _this.currentDataSeries.forEach(function (dS) {
	                    dS.type = chartConfig.chartType;
	                });
	                _this.currentChartConfigs.set(chartConfig.chartId, chartConfig);
	                switch (changeType) {
	                    case configPane_1.ConfigChangeTypeEnum.X_AXIS:
	                        _this.xAxisDataSort(chartConfig.chartSorted);
	                        _this.updateSeriesFromConfig(true);
	                        break;
	                    case configPane_1.ConfigChangeTypeEnum.SORTED:
	                        _this.xAxisDataSort(chartConfig.chartSorted);
	                        break;
	                }
	            }, onOtherColumnSelected: function (columnName, columnId) {
	                if (!_this.customDataAlreadyFetched(columnId)) {
	                    //data not fetched
	                    console.log("Fetching custom data for chart. columnName: ".concat(columnName, ", columnId: ").concat(columnId));
	                    _this.customDataFetchedIds.add(columnId);
	                    _this.props.onCustomDataFetch([columnId]);
	                }
	            }, onActiveChartConfigChange: function (newActiveChartConfigId, reinitCurrent) {
	                if (reinitCurrent) {
	                    _this.currentChartConfigs.set(_this.activeChartConfigId, _this.initChartConfigs.get(_this.activeChartConfigId));
	                }
	                _this.activeChartConfigId = newActiveChartConfigId;
	                _this.updateSeriesFromConfig(true);
	            }, onChartConfigSave: function (chartConfig) {
	                _this.initChartConfigs.set(chartConfig.chartId, chartConfig);
	                _this.currentChartConfigs.set(chartConfig.chartId, chartConfig);
	                if (_this.activeChartConfigId === _this.newChartId) {
	                    //use id for new chart
	                    _this.activeChartConfigId = chartConfig.chartId;
	                    _this.initChartConfigs.delete(_this.newChartId);
	                    _this.currentChartConfigs.delete(_this.newChartId);
	                }
	                _this.updateSeriesFromConfig(true);
	            }, onNewChart: function () { return _this.onNewChart(); }, onDeleteChart: function () { return _this.onDeleteChart(); }, currentDataSeries: this.currentDataSeries, initDataSeries: this.initialDataSeries, allSelected: this.allProperitiesSelected, onSelectAll: function (allSelected) {
	                _this.allProperitiesSelected = allSelected;
	                _this.currentDataSeries.forEach(function (ds) {
	                    ds.enable = _this.allProperitiesSelected;
	                });
	            }, entityName: this.props.chart.entityName, grid: this.props.grid }));
	    };
	    ChartComp.prototype.render = function () {
	        var chart = this.props.chart;
	        if (!this.chartConfigsLoaded)
	            return null;
	        var columnsData = this.renderDataSeries();
	        return (react_1.default.createElement(splitPane_1.SplitPane, null,
	            react_1.default.createElement(ChartView, { data: this.sortedData ? this.sortedData.slice() : chart.data, columnsData: columnsData, ref: "chart-view" }),
	            this.chartConfigsLoaded && this.dataSeriesExtracted ? (this.renderConfigPane()) : (react_1.default.createElement("div", null, "Loading"))));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ChartComp.prototype, "currentDataSeries", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ChartComp.prototype, "allProperitiesSelected", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ChartComp.prototype, "currentChartConfigs", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ChartComp.prototype, "initChartConfigs", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ChartComp.prototype, "activeChartConfigId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ChartComp.prototype, "chartConfigsLoaded", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ChartComp.prototype, "dataSeriesExtracted", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable.shallow
	    ], ChartComp.prototype, "sortedData", void 0);
	    ChartComp = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ChartComp);
	    return ChartComp;
	}(react_1.default.Component));
	exports.ChartComp = ChartComp;
	var ChartView = /** @class */ (function (_super) {
	    tslib_1.__extends(ChartView, _super);
	    function ChartView() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ChartView.prototype.render = function () {
	        return (react_1.default.createElement("div", { className: "chart-container", style: { width: "100%", height: "100%" } },
	            react_1.default.createElement(recharts_1.ResponsiveContainer, null,
	                react_1.default.createElement(recharts_1.ComposedChart, { data: this.props.data.slice() },
	                    this.props.columnsData,
	                    react_1.default.createElement(recharts_1.Legend, null),
	                    react_1.default.createElement(recharts_1.Brush, { height: 30, stroke: "#8884d8" }),
	                    react_1.default.createElement(recharts_1.CartesianGrid, { stroke: "#ccc", strokeDasharray: "5 5" }),
	                    react_1.default.createElement(recharts_1.YAxis, { yAxisId: "left", orientation: "left" }),
	                    react_1.default.createElement(recharts_1.YAxis, { yAxisId: "right", orientation: "right" }),
	                    react_1.default.createElement(recharts_1.Tooltip, null)))));
	    };
	    return ChartView;
	}(react_1.default.Component));
	var ChartGridWrapperComp = /** @class */ (function (_super) {
	    tslib_1.__extends(ChartGridWrapperComp, _super);
	    function ChartGridWrapperComp() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ChartGridWrapperComp.prototype.fetchCustomData = function (columnNames) {
	        var _this = this;
	        gridService_1.default.chart(this.props.grid, columnNames).then(function (chart) {
	            for (var i = 0; i < _this.chart.data.length; i++) {
	                _this.chart.data[i] = Object.assign(_this.chart.data[i], chart.data[i]);
	            }
	            _this.chart = Object.assign({}, _this.chart);
	            console.log("Custom data fetched", columnNames);
	            //TODO: use deep observing of data
	        });
	    };
	    ChartGridWrapperComp.prototype.componentDidMount = function () {
	        var _this = this;
	        gridService_1.default.chart(this.props.grid).then(function (chart) {
	            _this.chart = chart;
	        });
	    };
	    ChartGridWrapperComp.prototype.render = function () {
	        var _this = this;
	        return this.chart && this.chart.data ? (react_1.default.createElement(ChartComp, { chart: this.chart, grid: this.props.grid, onCustomDataFetch: function (columnNames) {
	                _this.fetchCustomData(columnNames);
	            } })) : null;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ChartGridWrapperComp.prototype, "chart", void 0);
	    ChartGridWrapperComp = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ChartGridWrapperComp);
	    return ChartGridWrapperComp;
	}(react_1.default.Component));
	exports.ChartGridWrapperComp = ChartGridWrapperComp;


/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ConfigChangeTypeEnum = exports.ConfigPane = void 0;
	var tslib_1 = __webpack_require__(3);
	__webpack_require__(1279);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_bootstrap_1 = __webpack_require__(72);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var EditIcon = __webpack_require__(1830);
	var CheckIcon = __webpack_require__(1817);
	var DropdownArrowIcon = __webpack_require__(1824);
	var DropupArrowIcon = __webpack_require__(1825);
	var icons_1 = __webpack_require__(63);
	var buttons_1 = __webpack_require__(27);
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var chartDomain_1 = __webpack_require__(928);
	var material_ui_1 = __webpack_require__(127);
	var axios_1 = tslib_1.__importDefault(__webpack_require__(314));
	var locales_1 = __webpack_require__(15);
	var metaConstant_1 = __webpack_require__(13);
	var ConfigPane = /** @class */ (function (_super) {
	    tslib_1.__extends(ConfigPane, _super);
	    function ConfigPane() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.anyChange = false;
	        _this.editChartName = false;
	        //used to show unsaved changes dialog, number is used to change active config and cleared
	        _this.switchConfigId = undefined;
	        _this.showOthersColumns = false;
	        _this.columnSearch = "";
	        _this.legendItemIsChecked = function (name) {
	            var ds = _this.props.currentDataSeries.find(function (s) { return s.name == name; });
	            if (ds != null) {
	                return ds.enable;
	            }
	            return false;
	        };
	        ////////// ENABLE AND DISABLE DATA SERIES //////////
	        _this.legendItemClicked = function (e) {
	            var ds = _this.props.currentDataSeries.find(
	            //TODO: put outside component
	            function (s) { return s.name == e.target.value; });
	            if (ds != null) {
	                ds.enable = !ds.enable;
	                if (ds.enable && !ds.isUsedOnGrid) {
	                    _this.props.onOtherColumnSelected(ds.name, ds.id);
	                }
	                var activeConfig = _this.props.currentChartConfigs.get(_this.props.activeChartConfigId);
	                var changedConfig = Object.assign({}, activeConfig);
	                if (ds.enable) {
	                    changedConfig.chartColumnsIds.push(ds.id);
	                }
	                else {
	                    var foundIndex = changedConfig.chartColumnsIds.findIndex(function (columnId) { return columnId == ds.id; });
	                    if (foundIndex != -1) {
	                        changedConfig.chartColumnsIds.splice(foundIndex);
	                    }
	                }
	                _this.props.onChartConfigChange(changedConfig);
	            }
	            _this.checkChanges();
	        };
	        _this.renderControlElements = function () {
	            var legendList = []; //active columns on grid
	            var activeLegendList = [];
	            var othersLegendList = []; //inactive columns on grid
	            var activeOthersLegendList = [];
	            _this.props.currentDataSeries.forEach(function (ds) {
	                if (_this.columnSearch) {
	                    if (ds.name.toLowerCase().indexOf(_this.columnSearch) === -1)
	                        return;
	                }
	                var legendItem = (react_1.default.createElement("div", { id: ds.name, className: "legend-list-item", key: "item-" + ds.name },
	                    react_1.default.createElement("input", { value: ds.name, type: "checkbox", checked: _this.legendItemIsChecked(ds.name), onChange: _this.legendItemClicked }),
	                    react_1.default.createElement("label", { style: { marginRight: 5 } }, ds.name)));
	                if (ds.isUsedOnGrid) {
	                    ds.enable
	                        ? activeLegendList.push(legendItem)
	                        : legendList.push(legendItem);
	                }
	                else {
	                    ds.enable
	                        ? activeOthersLegendList.push(legendItem)
	                        : othersLegendList.push(legendItem);
	                }
	            });
	            var showOthersList = activeOthersLegendList.length > 0 || othersLegendList.length > 0;
	            return (react_1.default.createElement("div", { className: "legend" },
	                react_1.default.createElement("div", { className: "legend-column" },
	                    react_1.default.createElement("h4", null, locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["chart.config.gridColumns"], ["chart.config.gridColumns"])))),
	                    react_1.default.createElement("div", null, activeLegendList),
	                    activeLegendList.length > 0 && react_1.default.createElement("div", { className: "separator" }),
	                    react_1.default.createElement("div", { className: "legend-list" }, legendList)),
	                showOthersList && (react_1.default.createElement("div", { className: "legend-column" },
	                    react_1.default.createElement("div", { className: "others-header", onClick: function () { return (_this.showOthersColumns = !_this.showOthersColumns); } },
	                        react_1.default.createElement("h4", null, locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["chart.config.inactiveGridColumns"], ["chart.config.inactiveGridColumns"])))),
	                        _this.showOthersColumns ? (react_1.default.createElement(DropupArrowIcon, { size: 30 })) : (react_1.default.createElement(DropdownArrowIcon, { size: 30 }))),
	                    react_1.default.createElement("div", null, activeOthersLegendList),
	                    activeOthersLegendList.length > 0 && _this.showOthersColumns && (react_1.default.createElement("div", { className: "separator" })),
	                    _this.showOthersColumns && (react_1.default.createElement("div", { className: "legend-list" }, othersLegendList))))));
	        };
	        return _this;
	    }
	    ConfigPane.prototype.renderChartConfigSelectItems = function () {
	        var result = [];
	        var values = this.props.currentChartConfigs.values();
	        while (true) {
	            var iteratorResult = values.next();
	            if (iteratorResult.done)
	                break;
	            var value = iteratorResult.value;
	            result.push(react_1.default.createElement(material_ui_1.MenuItem, { value: value.chartId, key: "select-chart-config-".concat(value.chartId), primaryText: value.chartName }));
	        }
	        return result;
	    };
	    ConfigPane.prototype.checkChanges = function () {
	        var p = this.props;
	        var initConfig = p.initChartConfigs.get(p.activeChartConfigId);
	        var currentConfig = p.currentChartConfigs.get(p.activeChartConfigId);
	        var dataSeriesChanged = false;
	        p.initDataSeries.forEach(function (initDataSeries, i) {
	            if (initDataSeries.enable !== p.currentDataSeries[i].enable) {
	                dataSeriesChanged = true;
	                return;
	            }
	        });
	        if (dataSeriesChanged)
	            console.log("CHECK_CHANGES: Data series changed");
	        this.anyChange =
	            dataSeriesChanged ||
	                initConfig.chartName !== currentConfig.chartName ||
	                initConfig.chartType !== currentConfig.chartType ||
	                initConfig.chartXField !== currentConfig.chartXField ||
	                initConfig.configLevel !== currentConfig.configLevel ||
	                initConfig.chartSorted !== currentConfig.chartSorted;
	    };
	    ConfigPane.prototype.changeActiveConfig = function (configId, reinitCurrent) {
	        this.anyChange = false;
	        this.props.onActiveChartConfigChange(configId, reinitCurrent);
	    };
	    ConfigPane.prototype.render = function () {
	        var _this = this;
	        var p = this.props;
	        var activeConfig = this.props.currentChartConfigs.get(this.props.activeChartConfigId);
	        return p.currentChartConfigs ? (react_1.default.createElement("div", { className: "config-pane" },
	            react_1.default.createElement(material_ui_1.Dialog, { actions: [
	                    react_1.default.createElement(FlatButton_1.default, { label: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["No, return back"], ["No, return back"]))), primary: true, onClick: function () { return (_this.switchConfigId = undefined); } }),
	                    react_1.default.createElement(FlatButton_1.default, { label: locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["Yes, continue"], ["Yes, continue"]))), secondary: true, onClick: function () {
	                            _this.changeActiveConfig(_this.switchConfigId, true);
	                            _this.switchConfigId = undefined;
	                        } }),
	                ], open: !!this.switchConfigId, title: locales_1.loc.i18n(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["chart.sureAnotherGraphSelect"], ["chart.sureAnotherGraphSelect"]))) }),
	            react_1.default.createElement(react_bootstrap_1.Navbar, { className: "graph-nav-bar", fluid: true },
	                react_1.default.createElement("div", { className: "nav-items-container" },
	                    this.editChartName ? (react_1.default.createElement(material_ui_1.TextField, { id: "tf-chart-name", value: activeConfig.chartName, autoFocus: true, onFocus: function (e) {
	                            e.target.select();
	                        }, onChange: function (e) {
	                            var changedConfig = Object.assign({}, activeConfig);
	                            changedConfig.chartName = e.target.value;
	                            p.onChartConfigChange(changedConfig);
	                        } })) : (react_1.default.createElement(material_ui_1.SelectField, { value: this.props.activeChartConfigId, onChange: function (e, i, value) {
	                            if (value === _this.props.activeChartConfigId)
	                                return;
	                            if (_this.anyChange) {
	                                _this.switchConfigId = value;
	                            }
	                            else {
	                                _this.changeActiveConfig(value, false);
	                            }
	                        } }, this.renderChartConfigSelectItems())),
	                    react_1.default.createElement(icons_1.MdIconButton, { style: { alignSelf: "center", color: "pink" }, onClick: function () {
	                            _this.editChartName = !_this.editChartName;
	                            if (!_this.editChartName)
	                                _this.checkChanges();
	                        } }, this.editChartName ? (react_1.default.createElement(CheckIcon, { size: 24 })) : (react_1.default.createElement(EditIcon, { size: 24 })))),
	                react_1.default.createElement("div", { className: "nav-items-container" },
	                    react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: function () { return p.onNewChart(); }, label: locales_1.loc.i18n(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["chart.config.new"], ["chart.config.new"]))), disabled: activeConfig.isNew }),
	                    react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: function () {
	                            var p = _this.props;
	                            var chartColumnsIds = [];
	                            p.currentDataSeries.forEach(function (dS, i) {
	                                if (dS.enable)
	                                    chartColumnsIds.push(dS.id);
	                            });
	                            axios_1.default.post("/api/core/grid/".concat(p.grid.activeGridConfig.gridId, "/chart/config"), {
	                                chartId: activeConfig.isNew
	                                    ? undefined
	                                    : activeConfig.chartId,
	                                chartName: activeConfig.chartName,
	                                chartType: activeConfig.chartType,
	                                chartColumnsIds: chartColumnsIds.join(";"),
	                                chartXField: activeConfig.chartXField,
	                                configLevel: activeConfig.configLevel,
	                                entityName: p.entityName,
	                                chartSorted: activeConfig.chartSorted,
	                            }).then(function (response) {
	                                _this.props.onChartConfigSave(response.data);
	                                _this.checkChanges();
	                            });
	                        }, label: locales_1.loc.i18n(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["chart.config.save"], ["chart.config.save"]))), disabled: this.editChartName || (!activeConfig.isNew && !this.anyChange) }),
	                    react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: function () {
	                            axios_1.default.delete("/api/core/grid/chart/".concat(activeConfig.chartId)).then(function () {
	                                _this.props.onDeleteChart();
	                            });
	                        }, label: locales_1.loc.i18n(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["chart.config.delete"], ["chart.config.delete"]))), disabled: activeConfig.isNew }))),
	            react_1.default.createElement(material_ui_1.RadioButtonGroup, { name: "Config level radio group", valueSelected: activeConfig.configLevel, onChange: function (_, value) {
	                    var changedConfig = Object.assign({}, activeConfig);
	                    changedConfig.configLevel = value;
	                    p.onChartConfigChange(changedConfig);
	                    _this.checkChanges();
	                } }, [metaConstant_1.CONFIGLEVEL.USER, metaConstant_1.CONFIGLEVEL.TENANT].map(function (value) { return (react_1.default.createElement(material_ui_1.RadioButton, { style: { width: "auto" }, key: value, value: value, label: value })); })),
	            react_1.default.createElement("div", null, locales_1.loc.i18n(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["chart.config.chartType"], ["chart.config.chartType"])))),
	            react_1.default.createElement(material_ui_1.SelectField, { value: activeConfig.chartType, onChange: function (_, __, value) {
	                    var changedConfig = Object.assign({}, activeConfig);
	                    changedConfig.chartType = value;
	                    p.onChartConfigChange(changedConfig);
	                    _this.checkChanges();
	                } }, chartTypes.map(function (chartType) { return (react_1.default.createElement(material_ui_1.MenuItem, { value: chartType.value, key: chartType.value, primaryText: locales_1.loc.get(chartType.label) })); })),
	            react_1.default.createElement("div", null, locales_1.loc.i18n(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["chart.config.xAxis"], ["chart.config.xAxis"])))),
	            react_1.default.createElement("div", { style: { display: "flex", alignItems: "center" } },
	                react_1.default.createElement(material_ui_1.SelectField, { value: activeConfig.chartXField || "", onChange: function (_, __, value) {
	                        var changedConfig = Object.assign({}, activeConfig);
	                        changedConfig.chartXField = value;
	                        p.onChartConfigChange(changedConfig, ConfigChangeTypeEnum.X_AXIS);
	                        _this.checkChanges();
	                    } },
	                    react_1.default.createElement(material_ui_1.MenuItem, { value: "", key: "None", primaryText: locales_1.loc.i18n(templateObject_11 || (templateObject_11 = tslib_1.__makeTemplateObject(["chart.config.noXFieldSelected"], ["chart.config.noXFieldSelected"]))) }),
	                    p.initDataSeries.map(function (dS) { return (react_1.default.createElement(material_ui_1.MenuItem, { value: dS.id, key: dS.id, primaryText: dS.name })); })),
	                react_1.default.createElement(material_ui_1.Checkbox, { style: { marginLeft: 10 }, label: "Sorted", checked: activeConfig.chartSorted, disabled: !activeConfig.chartXField, onCheck: function () {
	                        var changedConfig = Object.assign({}, activeConfig);
	                        changedConfig.chartSorted = !changedConfig.chartSorted;
	                        p.onChartConfigChange(changedConfig, ConfigChangeTypeEnum.SORTED);
	                        _this.checkChanges();
	                    } })),
	            react_1.default.createElement("div", null, locales_1.loc.i18n(templateObject_12 || (templateObject_12 = tslib_1.__makeTemplateObject(["chart.config.searchColumns"], ["chart.config.searchColumns"])))),
	            react_1.default.createElement(material_ui_1.TextField, { id: "tf-search", value: this.columnSearch, onChange: function (_, value) {
	                    _this.columnSearch = value;
	                } }),
	            this.renderControlElements())) : (react_1.default.createElement("div", null, "loading"));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ConfigPane.prototype, "anyChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ConfigPane.prototype, "editChartName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ConfigPane.prototype, "switchConfigId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ConfigPane.prototype, "showOthersColumns", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ConfigPane.prototype, "columnSearch", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ConfigPane.prototype, "legendItemClicked", void 0);
	    ConfigPane = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ConfigPane);
	    return ConfigPane;
	}(react_1.default.Component));
	exports.ConfigPane = ConfigPane;
	var chartTypes = [
	    { value: chartDomain_1.ChartType.BAR, label: "chart.label.bar" },
	    { value: chartDomain_1.ChartType.LINE, label: "chart.label.line" },
	    { value: chartDomain_1.ChartType.AREA, label: "chart.label.area" },
	];
	var ConfigChangeTypeEnum;
	(function (ConfigChangeTypeEnum) {
	    ConfigChangeTypeEnum[ConfigChangeTypeEnum["X_AXIS"] = 0] = "X_AXIS";
	    ConfigChangeTypeEnum[ConfigChangeTypeEnum["SORTED"] = 1] = "SORTED";
	})(ConfigChangeTypeEnum || (exports.ConfigChangeTypeEnum = ConfigChangeTypeEnum = {}));
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;


/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var errorComp_1 = __webpack_require__(34);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var dialogAncestor_1 = __webpack_require__(87);
	var emailBodyEditor_1 = tslib_1.__importDefault(__webpack_require__(564));
	var draft_js_1 = __webpack_require__(202);
	var draft_js_export_html_1 = __webpack_require__(442);
	var NoteDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(NoteDialog, _super);
	    function NoteDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.ok = function () {
	            console.log('NoteDialog OK');
	            _this.dialogOpen = false;
	            _this.resolve((0, draft_js_export_html_1.stateToHTML)(_this.editorState.getCurrentContent()));
	        };
	        _this.cancel = function (evt) {
	            console.log('NoteDialog#cancel evt = %O', evt);
	            _this.dialogOpen = false;
	            _this.reject(null);
	        };
	        _this.onChangeNote = function (editorState) {
	            _this.editorState = editorState;
	        };
	        return _this;
	    }
	    NoteDialog.prototype.open = function (resolve, reject) {
	        console.log('NoteDialog: Opening dialog');
	        this.resolve = resolve;
	        this.reject = reject;
	        this.$errors = null;
	        this.editorState = draft_js_1.EditorState.createEmpty();
	        this.dialogOpen = true;
	    };
	    NoteDialog.prototype.render = function () {
	        if (!this.dialogOpen)
	            return null;
	        return (react_1.default.createElement(Dialog_1.default, { actions: [react_1.default.createElement(FlatButton_1.default, { label: "Cancel", tabIndex: 0, primary: true, onClick: this.cancel }), react_1.default.createElement(FlatButton_1.default, { label: "Ok", disabled: !this.editorState.getCurrentContent().hasText(), secondary: true, onClick: this.ok })
	            ], modal: true, title: this.props.title, open: this.dialogOpen, contentStyle: { width: '80%', maxWidth: 800 }, bodyStyle: { overflowY: 'auto' } },
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: this.$errors }),
	            react_1.default.createElement(emailBodyEditor_1.default, { editorState: this.editorState, onChange: this.onChangeNote, style: { height: 400 } })));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], NoteDialog.prototype, "editorState", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], NoteDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], NoteDialog.prototype, "ok", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], NoteDialog.prototype, "cancel", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], NoteDialog.prototype, "onChangeNote", void 0);
	    NoteDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], NoteDialog);
	    return NoteDialog;
	}(dialogAncestor_1.DialogAncestor));
	exports.default = NoteDialog;


/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var errorComp_1 = __webpack_require__(34);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var dialogAncestor_1 = __webpack_require__(87);
	var sqlSelectEditor_1 = tslib_1.__importDefault(__webpack_require__(2054));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var SqlSelectDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(SqlSelectDialog, _super);
	    function SqlSelectDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.ok = function () {
	            console.log('SqlSelectDialog OK');
	            gridService_1.default.getColumnsFromSql(_this.sqlCommand, _this.gridLocation)
	                .then(function (gridConfig) {
	                _this.dialogOpen = false;
	                _this.resolve(gridConfig);
	            }, function (error) {
	                _this.$errors = error.getMessages();
	            });
	        };
	        _this.cancel = function (evt) {
	            console.log('SqlSelectDialog#cancel evt = %O', evt);
	            _this.dialogOpen = false;
	            _this.reject(null);
	        };
	        _this.onChange = function (sqlCommand) {
	            _this.sqlCommand = sqlCommand;
	        };
	        return _this;
	    }
	    SqlSelectDialog.prototype.open = function (resolve, reject, sqlCommand, gridLocation) {
	        console.log('NoteDialog: Opening dialog');
	        this.resolve = resolve;
	        this.reject = reject;
	        this.$errors = null;
	        this.sqlCommand = (sqlCommand == null) ? '' : sqlCommand;
	        this.dialogOpen = true;
	        this.gridLocation = gridLocation;
	    };
	    SqlSelectDialog.prototype.render = function () {
	        if (!this.dialogOpen)
	            return null;
	        return (react_1.default.createElement(Dialog_1.default, { actions: [react_1.default.createElement(FlatButton_1.default, { label: "Cancel", tabIndex: 0, primary: true, onClick: this.cancel }), react_1.default.createElement(FlatButton_1.default, { label: "Ok", disabled: !this.sqlCommand, secondary: true, onClick: this.ok })
	            ], modal: true, title: this.props.title, open: this.dialogOpen, contentStyle: { position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', filter: 'blur(0)' }, bodyStyle: { overflowY: 'auto' } },
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: this.$errors }),
	            react_1.default.createElement(sqlSelectEditor_1.default, { sqlCommand: this.sqlCommand, onChange: this.onChange, style: { height: 400 } })));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SqlSelectDialog.prototype, "sqlCommand", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SqlSelectDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SqlSelectDialog.prototype, "ok", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SqlSelectDialog.prototype, "cancel", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SqlSelectDialog.prototype, "onChange", void 0);
	    SqlSelectDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SqlSelectDialog);
	    return SqlSelectDialog;
	}(dialogAncestor_1.DialogAncestor));
	exports.default = SqlSelectDialog;


/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var mobx_react_1 = __webpack_require__(4);
	var utils_1 = __webpack_require__(37);
	var domUtils_1 = __webpack_require__(91);
	var AceEditor;
	var SqlSelectEditor = /** @class */ (function (_super) {
	    tslib_1.__extends(SqlSelectEditor, _super);
	    function SqlSelectEditor() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            aceHeightBody: 400
	        };
	        _this.onResize = function (evt) {
	            var bodyRect = document.body.getBoundingClientRect();
	            var aceHeightBody = (0, domUtils_1.computeHeight)(bodyRect, _this._aceEditorBody);
	            console.debug("onResize: " + aceHeightBody);
	            if (aceHeightBody) {
	                _this.setState({ aceHeightBody: aceHeightBody });
	            }
	        };
	        return _this;
	    }
	    SqlSelectEditor.prototype.componentWillMount = function () {
	        var _this = this;
	        __webpack_require__.e/* nsure */(0, function (require) {
	            if (AceEditor) {
	                return;
	            }
	            AceEditor = __webpack_require__(153).default;
	            var brace = __webpack_require__(133);
	            __webpack_require__(316);
	            __webpack_require__(147);
	            __webpack_require__(146);
	            _this.forceUpdate();
	            _this.onResize();
	        });
	    };
	    SqlSelectEditor.prototype.componentDidMount = function () {
	        console.debug("%c componentDidMount", "background-color: magenta");
	        this.onResizeDebounced = (0, utils_1.debounce)(this.onResize, 15, false);
	        window.addEventListener('resize', this.onResizeDebounced);
	        this.onResize();
	    };
	    SqlSelectEditor.prototype.componentWillUnmount = function () {
	        window.removeEventListener('resize', this.onResizeDebounced);
	    };
	    SqlSelectEditor.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, onChange = _a.onChange, sqlCommand = _a.sqlCommand;
	        return ((AceEditor) ?
	            react_1.default.createElement(AceEditor, { mode: "sql", theme: "github", value: sqlCommand, onChange: onChange, name: "SQL", enableBasicAutocompletion: true, enableLiveAutocompletion: true, editorProps: { $blockScrolling: true }, width: "100%", height: this.state.aceHeightBody + 'px', style: { padding: '5px 0 0 0' }, ref: function (c) { return _this._aceEditorBody = c; } })
	            : react_1.default.createElement("div", null, "Loading...."));
	    };
	    SqlSelectEditor = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SqlSelectEditor);
	    return SqlSelectEditor;
	}(react_1.default.Component));
	exports.default = SqlSelectEditor;


/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EmailSentComp = exports.AlertComp = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_bootstrap_1 = __webpack_require__(72);
	var isEmpty = __webpack_require__(284);
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var StyledAlert = (0, styled_components_1.default)(react_bootstrap_1.Alert)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      margin-top: 10px;\n      box-sizing: content-box;\n      button {\n        float: right;\n        border: 0;\n        background-color: rgba(0,0,0,0);\n      }\n"], ["\n      margin-top: 10px;\n      box-sizing: content-box;\n      button {\n        float: right;\n        border: 0;\n        background-color: rgba(0,0,0,0);\n      }\n"])));
	var AlertComp = function (_a) {
	    var level = _a.level, children = _a.children, onDismiss = _a.onDismiss, header = _a.header;
	    return ((children) ? react_1.default.createElement(StyledAlert, { bsStyle: level, onDismiss: onDismiss },
	        (header) ? react_1.default.createElement("h4", null, header) : null,
	        children) : react_1.default.createElement("noscript", null));
	};
	exports.AlertComp = AlertComp;
	var EmailSentComp = /** @class */ (function (_super) {
	    tslib_1.__extends(EmailSentComp, _super);
	    function EmailSentComp() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDismiss = function () {
	            var objekt = _this.props.objekt;
	            if (objekt.tupleMap) {
	                objekt.tupleMap.emailedPersons = undefined;
	                objekt.tupleMap.excludedPersons = undefined;
	            }
	        };
	        return _this;
	    }
	    EmailSentComp.prototype.render = function () {
	        var _a = this.props, objekt = _a.objekt, header = _a.header, level = _a.level;
	        return ((objekt.tupleMap && !isEmpty(objekt.tupleMap.emailedPersons)) ? react_1.default.createElement(StyledAlert, { bsStyle: level, onDismiss: this.onDismiss },
	            (header) ? react_1.default.createElement("h4", null, header) : null,
	            react_1.default.createElement("div", null,
	                "Email sent to",
	                react_1.default.createElement("ul", null, Object.entries(objekt.tupleMap.emailedPersons).map(function (_a, index) {
	                    var k = _a[0], v = _a[1];
	                    return react_1.default.createElement("li", { key: index },
	                        "  ",
	                        k + " (" + v.join(", ") + ")");
	                }))),
	            (!isEmpty(objekt.tupleMap.excludedPersons)) ? (react_1.default.createElement("div", null,
	                "Excluded",
	                react_1.default.createElement("ul", null, Object.entries(objekt.tupleMap.excludedPersons).map(function (_a, index) {
	                    var k = _a[0], v = _a[1];
	                    return react_1.default.createElement("li", { key: index },
	                        "  ",
	                        k + " (" + v.join(", ") + ")");
	                })))) : null) : react_1.default.createElement("noscript", null));
	    };
	    ;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EmailSentComp.prototype, "onDismiss", void 0);
	    EmailSentComp = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EmailSentComp);
	    return EmailSentComp;
	}(react_1.default.Component));
	exports.EmailSentComp = EmailSentComp;
	var templateObject_1;


/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.CHECKBOXGROUPSTYLE = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var formUtils_1 = __webpack_require__(14);
	var colors_1 = __webpack_require__(29);
	var isFunction = __webpack_require__(55);
	var Checkbox_1 = tslib_1.__importDefault(__webpack_require__(210));
	var CHECKBOXGROUPSTYLE;
	(function (CHECKBOXGROUPSTYLE) {
	    CHECKBOXGROUPSTYLE[CHECKBOXGROUPSTYLE["VERTICAL"] = 0] = "VERTICAL";
	    CHECKBOXGROUPSTYLE[CHECKBOXGROUPSTYLE["HORIZONTAL"] = 1] = "HORIZONTAL";
	})(CHECKBOXGROUPSTYLE || (exports.CHECKBOXGROUPSTYLE = CHECKBOXGROUPSTYLE = {}));
	var CheckBoxGroupField = /** @class */ (function (_super) {
	    tslib_1.__extends(CheckBoxGroupField, _super);
	    function CheckBoxGroupField() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onChangeInner = function (lov, evt) {
	            console.log("lov = %o, checked = %s", lov, evt.target.checked);
	            var newValues;
	            if (evt.target.checked) {
	                newValues = _this.props.value.slice();
	                newValues.push({ value: lov.value, label: lov.label });
	            }
	            else {
	                newValues = _this.props.value.filter(function (v) { return (0, formUtils_1.lovValue)(v) !== lov.value; });
	            }
	            _this.props.onChange(newValues);
	        };
	        return _this;
	    }
	    CheckBoxGroupField.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, name = _a.name, value = _a.value, labelStyle = _a.labelStyle, inputStyle = _a.inputStyle, options = _a.options, onChange = _a.onChange, optionStyle = _a.optionStyle, iconStyle = _a.iconStyle, iconStyleFn = _a.iconStyleFn, style = _a.style, errorText = _a.errorText, disabled = _a.disabled, groupStyle = _a.groupStyle, other = tslib_1.__rest(_a, ["name", "value", "labelStyle", "inputStyle", "options", "onChange", "optionStyle", "iconStyle", "iconStyleFn", "style", "errorText", "disabled", "groupStyle"]);
	        if (groupStyle === CHECKBOXGROUPSTYLE.HORIZONTAL) {
	            style = tslib_1.__assign(tslib_1.__assign({}, style), { display: 'flex', alignItems: 'center' });
	            labelStyle = tslib_1.__assign(tslib_1.__assign({}, labelStyle), { whiteSpace: 'nowrap' });
	            iconStyle = tslib_1.__assign(tslib_1.__assign({}, iconStyle), { marginRight: 4, color: colors_1.grey700 });
	            optionStyle = tslib_1.__assign(tslib_1.__assign({}, optionStyle), { marginRight: 10 });
	        }
	        console.log('CheckBoxGroupFieldProps value: %o, labelStyle: %o, iconStyle: %o, inputStyle: %o, style %o', value, labelStyle, iconStyle, inputStyle, style);
	        var valueIds = value.map(function (v) { return (0, formUtils_1.lovValue)(v); });
	        var extendedOptions = options.map(function (op) { return (tslib_1.__assign(tslib_1.__assign({}, op), { checked: valueIds.includes((0, formUtils_1.lovValue)(op)) })); });
	        return (react_1.default.createElement("div", { style: style },
	            extendedOptions.map(function (lov, index) { return react_1.default.createElement(Checkbox_1.default, { key: index, value: lov.checked, label: lov.label, defaultChecked: lov.checked, onCheck: _this.onChangeInner.bind(_this, lov), labelStyle: labelStyle, iconStyle: (iconStyleFn) ? iconStyleFn(lov.value) : iconStyle, inputStyle: inputStyle, style: optionStyle, disabled: (isFunction(disabled)) ? disabled(lov) : disabled }); }),
	            react_1.default.createElement("div", { style: { fontSize: 12, color: colors_1.red500 } }, errorText)));
	    };
	    return CheckBoxGroupField;
	}(react_1.default.PureComponent));
	exports.default = CheckBoxGroupField;


/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var mobx_react_1 = __webpack_require__(4);
	__webpack_require__(1283);
	var LocalizeField = /** @class */ (function (_super) {
	    tslib_1.__extends(LocalizeField, _super);
	    function LocalizeField() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    LocalizeField.prototype.render = function () {
	        // let {
	        //   children,
	        //   style,
	        //   ...other,
	        //   } = this.props;
	        return (react_1.default.createElement("span", { className: "lozalize-field fa fa-globe" }));
	    };
	    LocalizeField = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], LocalizeField);
	    return LocalizeField;
	}(react_1.default.Component));
	exports.default = LocalizeField;


/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var mobx_react_1 = __webpack_require__(4);
	var react_grid_layout_1 = __webpack_require__(1811);
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var mobx_1 = __webpack_require__(5);
	var variables_1 = __webpack_require__(96);
	var utils_1 = __webpack_require__(37);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridComp_1 = tslib_1.__importStar(__webpack_require__(44));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var ResponsiveReactGridLayout = (0, react_grid_layout_1.WidthProvider)(react_grid_layout_1.Responsive);
	var Main = styled_components_1.default.main(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding: 10px;\n  height: 100%;\n"], ["\n  padding: 10px;\n  height: 100%;\n"])));
	var _addButtonStyle = {
	    float: 'right',
	    margin: 20
	};
	var Home = /** @class */ (function (_super) {
	    tslib_1.__extends(Home, _super);
	    function Home() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.addGrid = function (gridLocation, gridConfig) {
	            return gridService_1.default.fetchGrids(gridLocation)
	                .then((0, mobx_1.action)("addGrid-cb", function (gridMap) {
	                _this.layouts.lg.push({ i: (0, utils_1.formatId)(gridLocation, gridConfig), x: 0, y: 0, w: 6, h: 2 });
	            }));
	        };
	        return _this;
	    }
	    Home.prototype.componentWillMount = function () {
	        this.layouts = securityService_1.default.currentUser.layoutConfig;
	        if (!this.layouts) {
	            this.layouts = { lg: [] };
	        }
	    };
	    Home.prototype.componentDidMount = function () {
	        var gridLocations = this.layouts.lg.map(function (l) { return (0, utils_1.parseId)(l.i)[0]; });
	        return gridService_1.default.fetchGrids.apply(gridService_1.default, gridLocations);
	    };
	    Home.prototype.render = function () {
	        console.log("render Home", this.layouts);
	        var layouts = { lg: [
	                { i: 'a', x: 0, y: 0, w: 1, h: 2, static: true },
	                { i: 'b', x: 0, y: 0, w: 3, h: 2, minW: 2, maxW: 4 },
	                { i: 'c', x: 0, y: 0, w: 1, h: 2 }
	            ] };
	        return (react_1.default.createElement(Main, null,
	            react_1.default.createElement(ResponsiveReactGridLayout, { className: "layout", layouts: (0, mobx_1.toJS)(this.layouts), breakpoints: { lg: variables_1.screenLg, md: variables_1.screenMd, sm: variables_1.screenSm, xs: variables_1.screenXs, xxs: 0 }, cols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 } }, this.layouts.lg.map(function (layout) {
	                var strings = (0, utils_1.parseId)(layout.i);
	                var gridLocation = strings[0];
	                var gridConfig = parseInt(strings[1]);
	                var grid = gridService_1.default.getOrCreateGrid(gridLocation);
	                grid.assignActiveGridConfig(grid.getActiveGridConfig(gridConfig));
	                return (react_1.default.createElement(gridComp_1.default, { key: layout.i, grid: grid, uiLocation: gridComp_1.UILOCATION.dashboard, entities: mdEntityService_1.default.entityMap }));
	            }))));
	    };
	    Home.title = 'Zauzoo Home';
	    Home.icon = 'home';
	    Home.rootPage = true;
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], Home.prototype, "layouts", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], Home.prototype, "addGrid", void 0);
	    Home = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], Home);
	    return Home;
	}(pageAncestor_1.default));
	exports.default = Home;
	var templateObject_1;


/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var react_bootstrap_1 = __webpack_require__(72);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var utils_1 = __webpack_require__(37);
	var home_1 = tslib_1.__importDefault(__webpack_require__(1591));
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var metaConstant_1 = __webpack_require__(13);
	__webpack_require__(1286);
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var formUtils_1 = __webpack_require__(14);
	var colors_1 = __webpack_require__(29);
	var locales_1 = __webpack_require__(15);
	var employeeService_1 = tslib_1.__importDefault(__webpack_require__(2134));
	var humanResourceDomain_1 = __webpack_require__(2135);
	var dateUtils_1 = __webpack_require__(49);
	var sbtool_logo_smaller_png_1 = tslib_1.__importDefault(__webpack_require__(1311));
	var envColors = {
	    prod: colors_1.indigo500,
	    test: colors_1.teal500,
	    test2: colors_1.blueGrey500,
	    dev: colors_1.brown500
	};
	var environmentStyles = { backgroundColor: envColors[("test")] };
	var HelpSpan = styled_components_1.default.span(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    color: ", ";\n    font-size: 15px;\n    margin-top:12px;\n    margin-right: 12px;\n"], ["\n    color: ", ";\n    font-size: 15px;\n    margin-top:12px;\n    margin-right: 12px;\n"])), colors_1.blueGrey200);
	var MainMenu = /** @class */ (function (_super) {
	    tslib_1.__extends(MainMenu, _super);
	    function MainMenu() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /* *******   EVENT HENDLERS ************ */
	        _this.logout = function (eventKey, event) {
	            console.log('logout');
	            event.preventDefault();
	            securityService_1.default.logout()
	                .then((0, mobx_1.action)("logout-action", function (response) {
	                securityService_1.default.setUserContextDto({});
	                window.location.assign(_this.context.router.makePath('loginPage'));
	            }), function (err) {
	                console.log('logout error');
	            });
	        };
	        _this.attendanceHandler = function (eventKey, event) {
	            console.log('attendanceHandler');
	            event.preventDefault();
	            var _a = _this.props, currentUser = _a.currentUser, restrictionData = _a.restrictionData;
	            employeeService_1.default.employeeAttendanceSave({ partyId: currentUser.partyId, coming: restrictionData.showComing() })
	                .then((0, mobx_1.action)("employeeAttendanceSave-action", function (data) {
	                var employeeAttendance = new humanResourceDomain_1.EmployeeAttendance(data);
	                restrictionData.lastComingTime = employeeAttendance.comingTime;
	                restrictionData.lastLeavingTime = employeeAttendance.leavingTime;
	            }), function (err) {
	                console.log('employeeAttendanceSave error');
	            });
	        };
	        _this.onSelectWithTransition = function (eventKey, event) {
	            console.log('onSelect2: event = %o, eventKey = %o', event, eventKey);
	            event.preventDefault();
	            _this.context.router.transitionTo(eventKey);
	        };
	        _this.onSelectLanguage = function (eventKey, event) {
	            (0, locales_1.changeLanguage)(eventKey, event);
	        };
	        _this.onHome = function (event) {
	            event.preventDefault();
	            var currentUser = _this.props.currentUser;
	            if (currentUser && currentUser.username === 'autoneum_gate') {
	                _this.context.router.transitionTo("shipmentVisitDetail", { id: 'new' });
	            }
	            else {
	                _this.context.router.transitionTo("home");
	            }
	        };
	        _this.changeTenant = function (tenantId, eventKey, event) {
	            event.preventDefault();
	            console.log('changeTenant ' + tenantId, event);
	            if (tenantId != null) {
	                securityService_1.default.changeLastTenant(tenantId)
	                    .then(function () {
	                    window.sessionStorage.setItem('tenantId', tenantId.toString());
	                    window.TENANT_ID = tenantId.toString();
	                    window.localStorage.clear();
	                    window.location.reload(true);
	                });
	            }
	        };
	        _this.clearCache = function (eventKey, event) {
	            console.log('clearCache');
	            event.preventDefault();
	            console.log('clearCache');
	            window.localStorage.clear();
	            window.location.reload(true);
	        };
	        _this.getCompanyLogo = function () {
	            var currentTenant = _this.props.currentTenant;
	            // TODO : Nico predelej to
	            if (currentTenant && currentTenant.tenantId === 17) {
	                return react_1.default.createElement("img", { src: sbtool_logo_smaller_png_1.default, alt: "SbTool" });
	            }
	            return react_1.default.createElement(home_1.default, { color: colors_1.grey300, hoverColor: colors_1.grey400 });
	        };
	        return _this;
	    }
	    /* *******   REACT METHODS ************ */
	    MainMenu.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, currentUser = _a.currentUser, currentTenant = _a.currentTenant, availableTenants = _a.availableTenants, restrictionData = _a.restrictionData;
	        console.log('MAIN MENU CURRENT USER = %O, tenant = %O, tenants = %O', currentUser, currentTenant, availableTenants);
	        var tenantsForChange = (availableTenants) ? availableTenants.filter(function (lov) { return (0, formUtils_1.lovValue)(lov) !== currentTenant.tenantId; }) : [];
	        var languagesFrag = (react_1.default.createElement(react_bootstrap_1.NavDropdown, { id: "languages_menu_dropdown", eventKey: 3, title: react_1.default.createElement("span", { style: { textTransform: 'uppercase' } }, locales_1.loc.lang) }, locales_1.loc.available.filter(function (x) { return x !== locales_1.loc.lang; }).map(function (locale) {
	            return (react_1.default.createElement(react_bootstrap_1.MenuItem, { eventKey: locale, key: locale, onSelect: _this.onSelectLanguage, style: { textTransform: 'uppercase' } }, locale));
	        })));
	        var mainMenuFrag = (react_1.default.createElement(react_bootstrap_1.Nav, { navbar: true },
	            react_1.default.createElement(PrunedNavDropdown, { id: "party_menu_dropdown", title: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Party"], ["Party"]))), onSelect: this.onSelectWithTransition },
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.party, route: "partyCustomers" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.party, route: "partyContacts" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.party, route: "partySalesReps" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.party, route: "partySuppliers" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.party, route: "partyHaulers" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.party, route: "partyDrivers" }),
	                react_1.default.createElement(react_bootstrap_1.MenuItem, { divider: true }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.party, route: "partyAll" }),
	                react_1.default.createElement(react_bootstrap_1.MenuItem, { divider: true }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.core, route: "contractList" })),
	            react_1.default.createElement(PrunedNavDropdown, { id: "invoice_menu_dropdown", title: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Invoice"], ["Invoice"]))), onSelect: this.onSelectWithTransition },
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.invoicing, route: "issuedInvoiceList" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.invoicing, route: "invoiceTemplateList" }),
	                react_1.default.createElement(react_bootstrap_1.MenuItem, { divider: true }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.invoicing, route: "invoiceReport" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.invoicing, route: "entityNumberGenGroupList" })),
	            react_1.default.createElement(PrunedNavDropdown, { id: "assets_menu_dropdown", title: locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["Assets"], ["Assets"]))), onSelect: this.onSelectWithTransition },
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.product, route: "vehicleList" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.shipment, route: "shipmentOutgoingList" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.shipment, route: "shipmentIncomingList" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.shipment, route: "shipmentRepackagingList" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.shipment, route: "shipmentVisitList" }),
	                react_1.default.createElement(react_bootstrap_1.MenuItem, { divider: true }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.product, route: 'brimMessageList' }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.shipment, route: "shipmentReport" })),
	            react_1.default.createElement(PrunedNavDropdown, { id: "product_menu_dropdown", title: locales_1.loc.i18n(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["Products"], ["Products"]))), onSelect: this.onSelectWithTransition },
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.product, route: "productList" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.product, route: "priceComponentList" })),
	            react_1.default.createElement(PrunedNavDropdown, { id: "crm_menu_dropdown", title: 'CRM', onSelect: this.onSelectWithTransition },
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.core, route: "taskList" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.core, route: "activityList" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.core, route: "eventList" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.humanresource, route: "timeSheetReport" })),
	            react_1.default.createElement(PrunedNavDropdown, { id: "sbtool_menu_dropdown", title: 'SBTool', onSelect: this.onSelectWithTransition },
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.sbtool, route: "sbToolProjectsList" })),
	            react_1.default.createElement(PrunedNavDropdown, { id: "administration_dropdown", title: locales_1.loc.i18n(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["Administration"], ["Administration"]))), onSelect: this.onSelectWithTransition },
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.core, route: "userList" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.core, route: "securityRoleList" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.core, route: "jobList" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.core, route: "entityList" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.core, route: "gridLocationList" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.core, route: "documentTypeList" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.core, route: "eventTypeList" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.core, route: "activityConfigList" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.core, route: "serverOverview", params: { tab: 'info' } }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.core, route: "referenceList" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.core, route: "certificateList" }),
	                react_1.default.createElement(PageLinkMenuItem, { module: metaConstant_1.MODULE.core, route: "paramKeyList" }))));
	        return (react_1.default.createElement(react_bootstrap_1.Navbar, { inverse: true, fixedTop: true, fluid: true, style: environmentStyles, collapseOnSelect: true },
	            react_1.default.createElement(react_bootstrap_1.Navbar.Header, null,
	                react_1.default.createElement(react_bootstrap_1.Navbar.Brand, null,
	                    react_1.default.createElement("a", { href: this.context.router.makeHref('home', null, (0, utils_1.addTenantToQuery)()), onClick: this.onHome }, this.getCompanyLogo())),
	                react_1.default.createElement(react_bootstrap_1.Navbar.Toggle, null)),
	            react_1.default.createElement(react_bootstrap_1.Navbar.Collapse, null,
	                currentUser ? mainMenuFrag : '',
	                react_1.default.createElement(react_bootstrap_1.Nav, { navbar: true, pullRight: true },
	                    currentUser ? (react_1.default.createElement(react_bootstrap_1.NavDropdown, { eventKey: 3, id: "user_menu_dropdown", title: currentUser ? (currentUser.displayName + ((restrictionData.employer) ? (' - ' + (0, formUtils_1.lovLabel)(restrictionData.employer)) : '') + ' (' + currentTenant.label + ')') : '' },
	                        this._menuItem("userProfile", undefined, undefined, function (eventKey, event) { event.preventDefault(); _this.context.router.transitionTo("userProfile", { tab: "info" }); }),
	                        (currentUser.hasRight("employeeAttendance", metaConstant_1.PERMISSION.Update)) ? (react_1.default.createElement(react_bootstrap_1.MenuItem, { eventKey: 'attendance', onSelect: this.attendanceHandler }, restrictionData.showComing() ? locales_1.loc.i18n(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["Coming"], ["Coming"]))) : (locales_1.loc.i18n(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["Leaving"], ["Leaving"]))) + ' (' + (0, dateUtils_1.formatTime)(restrictionData.lastComingTime) + ' - ?)'))) : null,
	                        react_1.default.createElement(react_bootstrap_1.MenuItem, { eventKey: 'clearCache', onSelect: this.clearCache }, "Clear cache"),
	                        react_1.default.createElement(react_bootstrap_1.MenuItem, { eventKey: 'logout', onSelect: this.logout }, "Logout"),
	                        (tenantsForChange.length) ? react_1.default.createElement(react_bootstrap_1.MenuItem, { divider: true }) : null,
	                        tenantsForChange.map(function (li, i) { return react_1.default.createElement(react_bootstrap_1.MenuItem, { eventKey: li.value, key: li.value, onSelect: _this.changeTenant.bind(_this, li.value) },
	                            " ",
	                            li.label,
	                            " "); }))) : null,
	                    languagesFrag,
	                    react_1.default.createElement("a", { href: "/doc/index.html", target: "_blank" },
	                        react_1.default.createElement(HelpSpan, { className: "fa fa-question" }))))));
	    };
	    MainMenu.prototype._menuItem = function (route, title, icon, onSelect) {
	        var routeObj = this.context.router.namedRoutes[route];
	        var routeHandler = (routeObj) ? routeObj.handler : null;
	        var resolvedTitle = (title) ? title : ((routeHandler) ? routeHandler.title : null);
	        var menuItemProps = {
	            href: this.context.router.makeHref(route, null, (0, utils_1.addTenantToQuery)()),
	            eventKey: route
	        };
	        if (onSelect) {
	            menuItemProps.onSelect = onSelect;
	        }
	        return react_1.default.createElement(react_bootstrap_1.MenuItem, tslib_1.__assign({}, menuItemProps),
	            " ",
	            resolvedTitle,
	            " ");
	    };
	    MainMenu.contextTypes = {
	        router: prop_types_1.default.func.isRequired
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], MainMenu.prototype, "logout", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], MainMenu.prototype, "attendanceHandler", void 0);
	    MainMenu = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], MainMenu);
	    return MainMenu;
	}(react_1.default.Component));
	exports.default = MainMenu;
	var PageLinkMenuItem = function (_a, context) {
	    var module = _a.module, route = _a.route, title = _a.title, icon = _a.icon, onSelect = _a.onSelect, params = _a.params, query = _a.query;
	    var routeObj = context.router.namedRoutes[route];
	    var routeHandler = (routeObj) ? routeObj.handler : null;
	    var resolvedTitle = (title) ? title : ((routeHandler) ? routeHandler.title : null);
	    var menuItemProps = {
	        href: context.router.makeHref(route, params, (0, utils_1.addTenantToQuery)(query)),
	        eventKey: route
	    };
	    if (onSelect) {
	        menuItemProps.onSelect = onSelect;
	    }
	    return react_1.default.createElement(react_bootstrap_1.MenuItem, tslib_1.__assign({}, menuItemProps),
	        " ",
	        resolvedTitle,
	        " ");
	};
	PageLinkMenuItem.contextTypes = { router: prop_types_1.default.func.isRequired };
	var PrunedNavDropdown = function (_a) {
	    var id = _a.id, title = _a.title, onSelect = _a.onSelect, children = _a.children;
	    var filteredChildren = react_1.default.Children.toArray(children).filter(function (child) { return !child.props.module || securityService_1.default.hasRight(child.props.route, metaConstant_1.PERMISSION.Read); });
	    // vyhodim 2 dividery za sebou, pokud je prvni nebo posledni element divider, tak taky
	    if (filteredChildren.length) {
	        var prevChild = filteredChildren[0];
	        var newChildren = (prevChild.props.module) ? [prevChild] : [];
	        for (var i = 1; i < filteredChildren.length; i++) {
	            if (prevChild.props.module || filteredChildren[i].props.module) {
	                newChildren.push(filteredChildren[i]);
	            }
	            prevChild = filteredChildren[i];
	        }
	        if (newChildren.length && !newChildren[newChildren.length - 1].props.module)
	            newChildren.pop();
	        filteredChildren = newChildren;
	    }
	    return (filteredChildren.length && filteredChildren.find(function (ch) { return ch.props.module; })) ? (react_1.default.createElement(react_bootstrap_1.NavDropdown, { id: id, title: title, onSelect: onSelect }, filteredChildren)) : react_1.default.createElement("noscript", null);
	};
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;


/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SplitPane = void 0;
	var tslib_1 = __webpack_require__(3);
	__webpack_require__(1287);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_split_pane_1 = tslib_1.__importDefault(__webpack_require__(1870));
	var Pane_1 = tslib_1.__importDefault(__webpack_require__(873));
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var SplitPane = /** @class */ (function (_super) {
	    tslib_1.__extends(SplitPane, _super);
	    function SplitPane() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.sizes = ["", ""];
	        return _this;
	    }
	    SplitPane.prototype.render = function () {
	        var _this = this;
	        return (react_1.default.createElement(react_split_pane_1.default, { className: "SplitPane", split: "vertical", onChange: function (sizes) {
	                _this.sizes = sizes;
	            } },
	            react_1.default.createElement(Pane_1.default, { className: "pane", size: this.sizes[0] }, this.props.children[0]),
	            react_1.default.createElement(Pane_1.default, { size: this.sizes[1], className: "pane", minSize: "360px", maxSize: "650px", initialSize: "650px" }, this.props.children[1])));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SplitPane.prototype, "sizes", void 0);
	    SplitPane = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SplitPane);
	    return SplitPane;
	}(react_1.default.Component));
	exports.SplitPane = SplitPane;


/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BrimMessageBlock = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var react_bootstrap_1 = __webpack_require__(72);
	var formUtils_1 = __webpack_require__(14);
	var dateUtils_1 = __webpack_require__(49);
	__webpack_require__(666);
	var eventDomain_1 = __webpack_require__(74);
	var icons = tslib_1.__importStar(__webpack_require__(563));
	var locales_1 = __webpack_require__(15);
	var react_router_1 = __webpack_require__(65);
	var utils_1 = __webpack_require__(37);
	/* **************************************************************************************
	 *******     BrimMessageFielTable     *******************************************************
	 ****************************************************************************************/
	function getProdutMatch(produtVehicle, product) {
	    return produtVehicle.filter(function (producVehicle) { return producVehicle.product.value === product.value; });
	}
	;
	function sortedProductsVehicles(productVehicles, product) {
	    return productVehicles.sort(function (productVehicle) {
	        if (productVehicle.product.value === product.value)
	            return -1;
	        if (productVehicle.product.value === product.value)
	            return 1;
	        return 0;
	    });
	}
	;
	var FutureProductVehicleTable = function (_a) {
	    var brimMessage = _a.brimMessage, productMatch = _a.productMatch, futureProductVehicle = _a.futureProductVehicle;
	    var boldProduct = (productMatch.length) ? "bold-product" : "";
	    var price = (futureProductVehicle.validPrice.price != null) ? futureProductVehicle.validPrice.price : "";
	    var currency = (futureProductVehicle.validPrice.currency != null) ? futureProductVehicle.validPrice.currency : "";
	    return (react_1.default.createElement("tbody", null,
	        react_1.default.createElement("tr", null,
	            react_1.default.createElement("th", null, locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Future product"], ["Future product"])))),
	            react_1.default.createElement("th", null, locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Valid price"], ["Valid price"])))),
	            react_1.default.createElement("th", null, locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Start Date"], ["Start Date"])))),
	            react_1.default.createElement("th", null, locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["End Date"], ["End Date"])))),
	            react_1.default.createElement("th", null, locales_1.loc.i18n(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["Status"], ["Status"])))),
	            react_1.default.createElement("th", null, locales_1.loc.i18n(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["Subscription"], ["Subscription"]))))),
	        react_1.default.createElement("tr", { key: 1 },
	            react_1.default.createElement("td", { className: boldProduct }, futureProductVehicle.product.label),
	            react_1.default.createElement("td", null,
	                price,
	                " ",
	                currency),
	            react_1.default.createElement("td", null, futureProductVehicle.validFrom),
	            react_1.default.createElement("td", null, futureProductVehicle.validTo),
	            react_1.default.createElement("td", null, brimMessage.status.label),
	            react_1.default.createElement("td", null, brimMessage.subscriptionType))));
	};
	var BrimMessageProductVehicleTable = function (_a) {
	    var vehicle = _a.vehicle, productMatch = _a.productMatch, product = _a.product;
	    return (react_1.default.createElement("tbody", null,
	        react_1.default.createElement("tr", { key: 2 },
	            react_1.default.createElement("th", null, locales_1.loc.i18n(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["Active products"], ["Active products"])))),
	            react_1.default.createElement("th", null),
	            react_1.default.createElement("th", null),
	            react_1.default.createElement("th", null),
	            react_1.default.createElement("th", null),
	            react_1.default.createElement("th", null)),
	        sortedProductsVehicles(vehicle.productVehicles, product).map(function (productVehicle, index) {
	            var boldProduct = (productMatch.length && productMatch.includes(productVehicle)) ? "bold-product" : "";
	            return (react_1.default.createElement("tr", { key: index + 3 },
	                react_1.default.createElement("td", { className: boldProduct }, productVehicle.product.label),
	                react_1.default.createElement("td", null,
	                    (productVehicle.validPrice) ? productVehicle.validPrice.price : "",
	                    " ",
	                    (productVehicle.validPrice) ? productVehicle.validPrice.currency : ""),
	                react_1.default.createElement("td", null, productVehicle.validFrom),
	                react_1.default.createElement("td", null, productVehicle.validTo),
	                react_1.default.createElement("td", null),
	                react_1.default.createElement("td", null)));
	        })));
	};
	var BrimMessageValues = function (brimMessage) {
	    return new Map([
	        ["Product", brimMessage.productNumber + " " + brimMessage.productName],
	        ["Product status", brimMessage.productStatus],
	        ["Subscription status", brimMessage.subscriptionType],
	        ["Customer CDB", brimMessage.customerPartyId],
	        ["Vin", brimMessage.vin],
	        ["Registration number", brimMessage.registrationNumber],
	        ["Subscription id", brimMessage.subscriptionId],
	        ["Subscription number", brimMessage.subscriptionNumber],
	        ["Start Date", (0, dateUtils_1.formatDateTime)(brimMessage.startDate)],
	        ["End Date", (0, dateUtils_1.formatDateTime)(brimMessage.endDate)],
	    ]);
	};
	var BrimMessageTable = function (_a) {
	    var brimMessage = _a.brimMessage;
	    return (react_1.default.createElement("tbody", null,
	        react_1.default.createElement("tr", null,
	            react_1.default.createElement("th", null, locales_1.loc.i18n(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["Original product"], ["Original product"])))),
	            react_1.default.createElement("th", null, locales_1.loc.i18n(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["Value"], ["Value"])))),
	            react_1.default.createElement("th", null),
	            react_1.default.createElement("th", null),
	            react_1.default.createElement("th", null),
	            react_1.default.createElement("th", null)),
	        Array.from(BrimMessageValues(brimMessage)).filter(function (_a) {
	            var key = _a[0], value = _a[1];
	            return value != null;
	        }).map(function (_a) {
	            var key = _a[0], value = _a[1];
	            return (react_1.default.createElement("tr", { key: key },
	                react_1.default.createElement("td", null, key),
	                react_1.default.createElement("td", null, value),
	                react_1.default.createElement("td", null),
	                react_1.default.createElement("td", null),
	                react_1.default.createElement("td", null),
	                react_1.default.createElement("td", null)));
	        })));
	};
	var PartyBlock = function (_a) {
	    var party = _a.party;
	    return (react_1.default.createElement("div", { className: "link-text" },
	        react_1.default.createElement(react_router_1.Link, { activeClassName: "link-text", to: "partyDetail", params: { id: (0, formUtils_1.lovValue)(party) }, query: (0, utils_1.addTenantToQuery)() }, party.label)));
	};
	var VehicleBlock = function (_a) {
	    var vehicle = _a.vehicle;
	    return (react_1.default.createElement("div", { className: "link-text" },
	        react_1.default.createElement(react_router_1.Link, { activeClassName: "link-text", to: "vehicleDetail", params: { id: vehicle.vehicleId }, query: (0, utils_1.addTenantToQuery)() },
	            vehicle.registrationNumber,
	            " - ",
	            vehicle.vin)));
	};
	var BrimMessageBlock = function (_a) {
	    var importEntryBrimMessage = _a.importEntryBrimMessage;
	    var EventCatIcon = icons[eventDomain_1.EVENTCATEGORY_MAP["DATA_EVENT"].icon];
	    var brimMessage = importEntryBrimMessage.brimMessage;
	    var futureProductVehicle = importEntryBrimMessage.futureProductVehicle;
	    var productMatch = (brimMessage.vehicle && brimMessage.vehicle.productVehicles.length && brimMessage.product) ? getProdutMatch(brimMessage.vehicle.productVehicles, brimMessage.product) : [];
	    return (react_1.default.createElement("div", { className: "event-history" },
	        react_1.default.createElement("div", { className: "eh-header" },
	            react_1.default.createElement("div", { className: "eh-header-left" },
	                react_1.default.createElement(EventCatIcon, null),
	                react_1.default.createElement("div", { className: "text" },
	                    (0, formUtils_1.lovLabel)(brimMessage.status),
	                    " - ",
	                    (0, dateUtils_1.formatDateTime)(brimMessage.statusChangeDate))),
	            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "bottom", delayShow: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: brimMessage.messageId + "_dateTooltip" }, (0, dateUtils_1.formatDateTime)(brimMessage.dateCreated)) },
	                react_1.default.createElement("span", null,
	                    brimMessage.userCreated,
	                    ", ",
	                    (0, moment_1.default)(brimMessage.dateCreated).fromNow()))),
	        react_1.default.createElement("div", { className: "eh-objects" },
	            (brimMessage.party) ? react_1.default.createElement(PartyBlock, { party: brimMessage.party }) : null,
	            (brimMessage.vehicle) ? react_1.default.createElement(VehicleBlock, { vehicle: brimMessage.vehicle }) : null,
	            react_1.default.createElement("div", { className: "description-text" }, brimMessage.statusDescription),
	            react_1.default.createElement("table", { className: "zz-simple-table" },
	                (futureProductVehicle) ? react_1.default.createElement(FutureProductVehicleTable, { brimMessage: brimMessage, productMatch: productMatch, futureProductVehicle: futureProductVehicle }) : null,
	                (futureProductVehicle && brimMessage.vehicle && brimMessage.vehicle.productVehicles.length && brimMessage.product) ?
	                    react_1.default.createElement(BrimMessageProductVehicleTable, { vehicle: brimMessage.vehicle, productMatch: productMatch, product: brimMessage.product })
	                    : null,
	                react_1.default.createElement(BrimMessageTable, { brimMessage: brimMessage })))));
	};
	exports.BrimMessageBlock = BrimMessageBlock;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;


/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var Subject_1 = __webpack_require__(260);
	__webpack_require__(309);
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var brimMessageExpandBlock_1 = __webpack_require__(2061);
	var dataImportService_1 = tslib_1.__importDefault(__webpack_require__(931));
	var itemStream = new Subject_1.Subject();
	itemStream
	    .mergeMap(function (item) { return Promise.all([item, dataImportService_1.default.getBrimMessageDetail(item.rowId, true)]); }, null, 5)
	    .mergeMap(function (_a) {
	    var item = _a[0], importEntryBrimMessage = _a[1];
	    return Promise.all([item, importEntryBrimMessage]);
	})
	    .subscribe((0, mobx_1.action)("subscribe-actionCb", function (_a) {
	    var item = _a[0], importEntryBrimMessage = _a[1];
	    item.rowObject = importEntryBrimMessage;
	    item.expanded = 2;
	    console.log("BrimMessage resolved event %s", importEntryBrimMessage.brimMessage.messageId);
	}));
	var MDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-left: 24px;\n"], ["\n  margin-left: 24px;\n"])));
	var BrimMessageExpando = /** @class */ (function (_super) {
	    tslib_1.__extends(BrimMessageExpando, _super);
	    function BrimMessageExpando() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    BrimMessageExpando.prototype.componentDidMount = function () {
	        var item = this.props.item;
	        var importEntryBrimMessage = item.rowObject;
	        if (!importEntryBrimMessage) {
	            itemStream.next(item);
	        }
	    };
	    BrimMessageExpando.prototype.componentDidUpdate = function (prevProps, prevState) {
	        var item = this.props.item;
	        var importEntryBrimMessage = item.rowObject;
	        if (!importEntryBrimMessage && prevProps.item.rowId !== item.rowId) {
	            itemStream.next(item);
	        }
	    };
	    BrimMessageExpando.prototype.render = function () {
	        var item = this.props.item;
	        var importEntryBrimMessage = item.rowObject;
	        console.log("EventExpando render vehicle %s, expanded = %s", (importEntryBrimMessage) ? importEntryBrimMessage.brimMessage.messageId : null, item.expanded);
	        if (item.expanded === 1) {
	            return (react_1.default.createElement(MDiv, null,
	                react_1.default.createElement("i", { className: "fa fa-refresh fa-2x fa-spin color-blue-grey-200" })));
	        }
	        return react_1.default.createElement(brimMessageExpandBlock_1.BrimMessageBlock, { importEntryBrimMessage: importEntryBrimMessage });
	    };
	    BrimMessageExpando = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], BrimMessageExpando);
	    return BrimMessageExpando;
	}(react_1.default.Component));
	exports.default = BrimMessageExpando;
	var templateObject_1;


/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ImportEntryBrimMessage = exports.BrimMessage = exports.SUBSTYPE = void 0;
	var tslib_1 = __webpack_require__(3);
	var productDomain_1 = __webpack_require__(158);
	var mobx_1 = __webpack_require__(5);
	var DomainAncestor_1 = __webpack_require__(33);
	var SUBSTYPE;
	(function (SUBSTYPE) {
	    SUBSTYPE["MONTHLYPAYMENT"] = "MONTHLYPAYMENT";
	    SUBSTYPE["UPFRONTPAYMENT"] = "UPFRONTPAYMENT";
	    SUBSTYPE["PREPAID"] = "PREPAID";
	    SUBSTYPE["RECURRING"] = "RECURRING";
	})(SUBSTYPE || (exports.SUBSTYPE = SUBSTYPE = {}));
	var BrimMessage = /** @class */ (function (_super) {
	    tslib_1.__extends(BrimMessage, _super);
	    function BrimMessage(json) {
	        return _super.call(this, json) || this;
	    }
	    BrimMessage.prototype.getId = function () {
	        return this.messageId;
	    };
	    BrimMessage.prototype.setId = function (id) {
	        this.messageId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "messageId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "status", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "statusDescription", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "businessArea", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "countryCode", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "startDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "endDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "statusChangeDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "customerPartyId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "vin", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "duration", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "productName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "productNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "productStatus", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "subscriptionType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "salesType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "registrationNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "externalOrderNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "subscriptionNumber", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "subscriptionId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "transactionType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "notificationDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "party", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(productDomain_1.Vehicle)
	    ], BrimMessage.prototype, "vehicle", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], BrimMessage.prototype, "product", void 0);
	    BrimMessage = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], BrimMessage);
	    return BrimMessage;
	}(DomainAncestor_1.DomainAncestor));
	exports.BrimMessage = BrimMessage;
	var ImportEntryBrimMessage = /** @class */ (function (_super) {
	    tslib_1.__extends(ImportEntryBrimMessage, _super);
	    function ImportEntryBrimMessage(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(BrimMessage)
	    ], ImportEntryBrimMessage.prototype, "brimMessage", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable,
	        (0, DomainAncestor_1.fieldInfo)(productDomain_1.ProductVehicle)
	    ], ImportEntryBrimMessage.prototype, "futureProductVehicle", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ImportEntryBrimMessage.prototype, "substype", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ImportEntryBrimMessage.prototype, "productStatus", void 0);
	    ImportEntryBrimMessage = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ImportEntryBrimMessage);
	    return ImportEntryBrimMessage;
	}(DomainAncestor_1.DomainAncestor));
	exports.ImportEntryBrimMessage = ImportEntryBrimMessage;


/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var gridComp_1 = __webpack_require__(44);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var mobx_1 = __webpack_require__(5);
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var brimMessageExpando_1 = tslib_1.__importDefault(__webpack_require__(2062));
	var dataImportService_1 = tslib_1.__importDefault(__webpack_require__(931));
	var gridLocation = 'brimMessageList';
	var ParamKeyList = /** @class */ (function (_super) {
	    tslib_1.__extends(ParamKeyList, _super);
	    function ParamKeyList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.accept = function (grid) {
	            _this._confirmation.open(function (success) {
	                commonService_1.default.loading(true);
	                dataImportService_1.default.acceptBrimMessage(grid.createFullParams())
	                    .then((0, mobx_1.action)("accepting-brimMessage", function (domainObject) {
	                    commonService_1.default.loading(false);
	                    grid.search(domainObject);
	                }));
	            }, function (cancel) {
	            }, 'Do you want to Accept all ' + grid.getSelectedCount() + ' changes?');
	        };
	        _this.reject = function (grid) {
	            _this._confirmation.open(function (success) {
	                commonService_1.default.loading(true);
	                dataImportService_1.default.rejectBrimMessgage(grid.createFullParams())
	                    .then((0, mobx_1.action)("rejecting-brimMessage", function (domainObject) {
	                    commonService_1.default.loading(false);
	                    grid.search(domainObject);
	                }));
	            }, function (cancel) {
	            }, 'Do you want to Reject all ' + grid.getSelectedCount() + ' changes?');
	        };
	        _this.validate = function (grid) {
	            _this._confirmation.open(function (success) {
	                commonService_1.default.loading(true);
	                dataImportService_1.default.validateBrimMessage(grid.createFullParams())
	                    .then((0, mobx_1.action)("validating-brimMessage", function (domainObject) {
	                    commonService_1.default.loading(false);
	                    grid.search(domainObject);
	                }));
	            }, function (cancel) {
	            }, 'Do you want to Validate all ' + grid.getSelectedCount() + ' changes?');
	        };
	        _this.ConfirmationDialogRef = function (comp) { _this._confirmation = comp; };
	        return _this;
	    }
	    ParamKeyList.fetchData = function (routerParams) {
	        console.log("BrimMessage#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    ParamKeyList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        var bulkActions = [
	            { type: gridComp_1.BULKACTIONTYPE.ACTION, label: 'Accept', fn: this.accept, that: this, securable: metaConstant_1.SECURABLE.brimMessageAction },
	            { type: gridComp_1.BULKACTIONTYPE.ACTION, label: 'Reject', fn: this.reject, that: this, securable: metaConstant_1.SECURABLE.brimMessageAction },
	            { type: gridComp_1.BULKACTIONTYPE.ACTION, label: 'Validate', fn: this.validate, that: this, securable: metaConstant_1.SECURABLE.brimMessageAction },
	        ];
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query, bulkActions: bulkActions, showExpand: true, ExpandComponent: brimMessageExpando_1.default },
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.ConfirmationDialogRef })));
	    };
	    ParamKeyList.module = metaConstant_1.MODULE.product;
	    ParamKeyList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Brim Message"], ["Brim Message"])));
	    ParamKeyList.icon = 'key';
	    ParamKeyList.rootPage = true;
	    ParamKeyList.protectedPage = true;
	    ParamKeyList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ParamKeyList);
	    return ParamKeyList;
	}(pageAncestor_1.default));
	exports.default = ParamKeyList;
	var templateObject_1;


/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ContractDetailComp = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var formUtils_1 = __webpack_require__(14);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var mobx_react_1 = __webpack_require__(4);
	var createForm_1 = __webpack_require__(18);
	var colors_1 = __webpack_require__(29);
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var documentDomain_1 = __webpack_require__(109);
	var form_1 = __webpack_require__(52);
	var radioButtonField_1 = tslib_1.__importDefault(__webpack_require__(144));
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var Avatar_1 = tslib_1.__importDefault(__webpack_require__(356));
	var stringUtils_1 = __webpack_require__(174);
	var partyDomain_1 = __webpack_require__(48);
	var commonDataService_1 = __webpack_require__(41);
	var FlexRowDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));
	var FlexDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
	var HeaderWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  margin-top: 12px;\n  margin-bottom: 5px;\n  align-items: center;\n"], ["\n  display: flex;\n  margin-top: 12px;\n  margin-bottom: 5px;\n  align-items: center;\n"])));
	var Header = styled_components_1.default.div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject([" \n  color: ", ";\n  margin-right: 10px;\n  font-size: 20px;\n"], [" \n  color: ", ";\n  margin-right: 10px;\n  font-size: 20px;\n"])), colors_1.grey400);
	var AvatarStyle = {
	    margin: "0 15px 0 0"
	};
	var ContractDetailComp = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled, standAlone = _a.standAlone;
	    return (react_1.default.createElement(FlexRowDiv, null,
	        react_1.default.createElement(Avatar_1.default, { backgroundColor: documentDomain_1.CONTRACTTYPE_MAP[(0, formUtils_1.lovValue)(dataObject.contractType)].backgroundColor, style: AvatarStyle }, (0, stringUtils_1.acronym)((0, formUtils_1.lovLabel)(dataObject.contractType), 1)),
	        react_1.default.createElement(FlexDiv, null,
	            react_1.default.createElement(HeaderWrapper, null,
	                react_1.default.createElement(Header, null,
	                    react_1.default.createElement("span", { className: "zz-mr-5" }, dataObject.contractNumber),
	                    " - ",
	                    " " + (0, formUtils_1.lovLabel)(dataObject.contractStatus)),
	                (!standAlone && dataObject.customer) ? (react_1.default.createElement(formUtils_1.FieldText, { value: dataObject.customer.label, linkProps: { to: 'partyDetail', params: { id: dataObject.customer.value } } })) : null),
	            react_1.default.createElement("div", { className: "form-text-row" },
	                react_1.default.createElement(formUtils_1.FieldText, { label: fields.sendForSigningDate.textLabel, value: dataObject.sendForSigningDate, mdField: fields.sendForSigningDate.mdField }),
	                react_1.default.createElement(formUtils_1.FieldText, { label: fields.signingDate.textLabel, value: dataObject.signingDate, mdField: fields.signingDate.mdField })),
	            react_1.default.createElement("div", { className: "form-text-row" },
	                react_1.default.createElement(formUtils_1.FieldText, { value: dataObject.comment })))));
	};
	exports.ContractDetailComp = ContractDetailComp;
	var ContractForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ContractForm, _super);
	    function ContractForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ContractForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity, formName = _a.formName;
	        var fields = dataObject.getFormFields(formName);
	        var contractNumber = fields.contractNumber, contractStatus = fields.contractStatus, contractType = fields.contractType, sendForSigningDate = fields.sendForSigningDate, signingDate = fields.signingDate, comment = fields.comment, customer = fields.customer;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12" },
	                    react_1.default.createElement("div", { style: { color: colors_1.grey400, marginBottom: 5 } }, contractType.mdField.formLabelActive),
	                    react_1.default.createElement(radioButtonField_1.default, tslib_1.__assign({}, contractType.props, { groupStyle: { display: 'flex' }, optionStyle: { width: 'initial', marginRight: 15 }, labelStyle: { whiteSpace: 'nowrap', marginLeft: -10 } })),
	                    react_1.default.createElement(validate_1.Validate, { field: contractType, value: contractType.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, customer.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.CUSTOMER_ROLE, partyDomain_1.PARTYROLE.OWNER_ROLE] }), clearable: true })),
	                    react_1.default.createElement(validate_1.Validate, { field: customer, value: customer.props.value })),
	                react_1.default.createElement("div", { className: "xs col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, contractNumber.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: contractNumber, value: contractNumber.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, contractStatus.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: contractStatus, value: contractStatus.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-3" },
	                    react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, sendForSigningDate.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-3" },
	                    react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, signingDate.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "xs col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props, { multiLine: true, rows: 3 }))))));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(exports.ContractDetailComp, { dataObject: dataObject, entity: entity, entities: entities, fields: fields, standAlone: false }) }, this.props, { validate: this.props.validate })));
	    };
	    ContractForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'ContractForm',
	            fields: [{
	                    name: 'contractNumber'
	                }, {
	                    name: 'contractStatus',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'contractType',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.radioButton,
	                    validators: ['IsRequired']
	                }, {
	                    name: "sendForSigningDate"
	                }, {
	                    name: "signingDate"
	                }, {
	                    name: "customer"
	                }, {
	                    name: "comment",
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	                }]
	        }, exports.ContractDetailComp),
	        mobx_react_1.observer
	    ], ContractForm);
	    return ContractForm;
	}(react_1.default.Component));
	exports.default = ContractForm;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var styledDateInterval_1 = tslib_1.__importDefault(__webpack_require__(130));
	var dateUtils_1 = __webpack_require__(49);
	var blockComp_1 = __webpack_require__(30);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var mobx_react_1 = __webpack_require__(4);
	var form_1 = __webpack_require__(52);
	var mdField_1 = tslib_1.__importStar(__webpack_require__(57));
	var closedForm_1 = __webpack_require__(82);
	var validate_1 = __webpack_require__(24);
	var DocumentTemplateForm = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentTemplateForm, _super);
	    function DocumentTemplateForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DocumentTemplateForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity, formName = _a.formName;
	        var fields = dataObject.getFormFields(formName);
	        var comment = fields.comment, validFrom = fields.validFrom, validTo = fields.validTo, profitCenter = fields.profitCenter, language = fields.language, useSaxonForXslt = fields.useSaxonForXslt, computations = fields.computations, documentNameExpression = fields.documentNameExpression, invoiceTypeIds = fields.invoiceTypeIds;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, profitCenter.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, language.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, invoiceTypeIds.props, { multi: true, floatingLabelStyle: { top: 15 } })),
	                    react_1.default.createElement(validate_1.Validate, { field: invoiceTypeIds, value: invoiceTypeIds.props.value })),
	                react_1.default.createElement("div", { className: "col-xs-8 col-sm-6" },
	                    react_1.default.createElement(styledDateInterval_1.default, tslib_1.__assign({}, validFrom.props, { valueFrom: validFrom.props.value, valueTo: validTo.props.value, onChangeFrom: validFrom.props.onChange, onChangeTo: validTo.props.onChange })))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, documentNameExpression.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-10" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, computations.props, { multi: true, floatingLabelStyle: { top: 15 } }))),
	                react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-2" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, useSaxonForXslt.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props, { multiLine: true, rows: 2 }))))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true },
	            react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate }, this.props))));
	    };
	    DocumentTemplateForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], DocumentTemplateForm);
	    return DocumentTemplateForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", null,
	        react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields, singleColumn: true },
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.templateIndex.textLabel, value: dataObject.templateIndex }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.language.textLabel, value: dataObject.language }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.profitCenter.textLabel, value: dataObject.profitCenter }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.invoiceTypeIds.textLabel, value: dataObject.invoiceTypeIds }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.useSaxonForXslt.textLabel, value: dataObject.useSaxonForXslt }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.validFrom.textLabel, value: (0, dateUtils_1.formatInterval)(dataObject.validFrom, dataObject.validTo), mdField: fields.validFrom.mdField }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.documentNameExpression.textLabel, value: dataObject.documentNameExpression }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.computations.textLabel, value: dataObject.computations }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.comment.textLabel, value: dataObject.comment }))));
	};
	var definition = {
	    formName: 'DocumentTemplateForm',
	    fields: [{
	            name: 'comment',
	            displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	        }, {
	            name: 'validFrom'
	        }, {
	            name: 'validTo'
	        }, {
	            name: 'profitCenter'
	        }, {
	            name: 'invoiceTypeIds',
	            omitNullOption: true,
	        }, {
	            name: 'language'
	        }, {
	            name: 'computations',
	            mdField: new mdField_1.default({ label: 'Computed properties', valueSource: 'DOCUMENTCOMPUTATION', valueSourceType: mdField_1.VALUESOURCETYPE.LOCAL })
	        }, {
	            name: 'documentNameExpression'
	        }, {
	            name: 'templateIndex'
	        }, {
	            name: 'useSaxonForXslt',
	            displayType: form_1.FIELDDEFDISPLAYTYPE.checkbox
	        }]
	};
	exports.default = (0, createForm_1.createForm)(definition, ClosedContent)(DocumentTemplateForm);


/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var formUtils_1 = __webpack_require__(14);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var blockComp_1 = __webpack_require__(30);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var rules_1 = __webpack_require__(56);
	var mobx_react_1 = __webpack_require__(4);
	var form_1 = __webpack_require__(52);
	var definition = {
	    formName: 'DocumentTypeForm',
	    fields: [{
	            name: 'documentTypeId',
	            validators: ['IsRequired']
	        }, {
	            name: 'documentName',
	            validators: ['IsRequired']
	        }, {
	            name: 'comment',
	            displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	        }, {
	            name: 'type',
	            validators: ['IsRequired']
	        }, {
	            name: 'format'
	        }, {
	            name: 'templateType'
	        }, {
	            name: 'location'
	        }, {
	            name: 'cardinality'
	        }, {
	            name: 'langSource'
	        }, {
	            name: 'dataPrepareBean'
	        }]
	};
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
	        react_1.default.createElement("h5", { style: { marginTop: 0, fontSize: '18px', fontWeight: 'bold' } },
	            " ",
	            react_1.default.createElement("span", { className: "zz-grey-text" }, (0, formUtils_1.lovLabel)(dataObject.type)),
	            " ",
	            dataObject.documentName),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.location.textLabel, value: dataObject.location }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.templateType.textLabel, value: dataObject.templateType }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.format.textLabel, value: dataObject.format }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.cardinality.textLabel, value: dataObject.cardinality }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.langSource.textLabel, value: dataObject.langSource }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.documentTypeId.textLabel, value: dataObject.documentTypeId })),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.comment.textLabel, value: dataObject.comment }))));
	};
	var DocumentTypeForm = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentTypeForm, _super);
	    function DocumentTypeForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DocumentTypeForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity, formName = _a.formName;
	        var fields = dataObject.getFormFields(formName);
	        var documentTypeId = fields.documentTypeId, documentName = fields.documentName, comment = fields.comment, type = fields.type, format = fields.format, templateType = fields.templateType, cardinality = fields.cardinality, langSource = fields.langSource, location = fields.location;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, documentTypeId.props, { disabled: !dataObject.$new })),
	                    react_1.default.createElement(validate_1.Validate, { field: documentTypeId, value: documentTypeId.props.value },
	                        react_1.default.createElement(rules_1.PrimaryKeyString, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, documentName.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: documentName, value: documentName.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, type.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: type, value: type.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, templateType.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, format.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, cardinality.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, langSource.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, location.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props, { multiLine: true, rows: 2 }))))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true },
	            react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate }, this.props))));
	    };
	    DocumentTypeForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)(definition, ClosedContent),
	        mobx_react_1.observer
	    ], DocumentTypeForm);
	    return DocumentTypeForm;
	}(react_1.default.Component));
	exports.default = DocumentTypeForm;


/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var RadioButtonGroup_1 = tslib_1.__importDefault(__webpack_require__(243));
	var RadioButton_1 = tslib_1.__importDefault(__webpack_require__(287));
	var RaisedButton_1 = tslib_1.__importDefault(__webpack_require__(152));
	var file_download_1 = tslib_1.__importDefault(__webpack_require__(778));
	var open_in_new_1 = tslib_1.__importDefault(__webpack_require__(1592));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var documentService_1 = tslib_1.__importDefault(__webpack_require__(110));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var fields_1 = __webpack_require__(20);
	var formUtils_1 = __webpack_require__(14);
	var mobx_1 = __webpack_require__(5);
	var dialogAncestor_1 = __webpack_require__(87);
	var mobx_react_1 = __webpack_require__(4);
	var DownloadDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(DownloadDialog, _super);
	    function DownloadDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.cancel = function (evt) {
	            console.log('DownloadDialog#cancel evt = %O', evt);
	            documentService_1.default.documentCountObject = null;
	            _this.dialogOpen = false;
	            _this.reject(null);
	        };
	        _this.onChangeSelectedFormat = function (evt, selectedFormat) {
	            console.log('onChangeSelectedFormat ', selectedFormat);
	            documentService_1.default.documentCountObject.selectedFormat = selectedFormat;
	        };
	        _this.onCheckDuplexPrinting = function (evt, checked) {
	            console.log('onCheckDuplexPrinting ', checked);
	            documentService_1.default.documentCountObject.duplexPrinting = checked;
	        };
	        return _this;
	    }
	    DownloadDialog.prototype.open = function (resolve, reject, params) {
	        var _this = this;
	        var _a = this.props, entities = _a.entities, grid = _a.grid, entityName = _a.entityName, documentLocation = _a.documentLocation;
	        var gridParams = grid.createFullParams(params);
	        console.log('DownloadDialog: Opening dialog params = %O ', gridParams);
	        this.resolve = resolve;
	        this.reject = reject;
	        commonService_1.default.loading(true);
	        Promise.all([mdEntityService_1.default.fetchEntities([{ entity: 'DocumentType', lov: true }]), documentService_1.default.documentCount(entityName, documentLocation, gridParams)])
	            .then(function (_a) {
	            var entities = _a[0], documentCountObjectDto = _a[1];
	            documentCountObjectDto.selectedFormat = documentCountObjectDto.formats[0].value;
	            documentCountObjectDto.duplexPrinting = false;
	            documentCountObjectDto.gridParams = gridParams;
	            documentService_1.default.documentCountObject = documentCountObjectDto;
	            commonService_1.default.loading(false);
	            _this.dialogOpen = true;
	        })
	            .catch(function (error) {
	            _this.reject(error);
	        });
	    };
	    DownloadDialog.prototype.render = function () {
	        var _a = this.props, entities = _a.entities, grid = _a.grid, entityName = _a.entityName, documentLocation = _a.documentLocation, bodyStyle = _a.bodyStyle, children = _a.children;
	        if (!this.dialogOpen)
	            return null;
	        var actions = [
	            react_1.default.createElement(FlatButton_1.default, { label: "Close", secondary: true, onClick: this.cancel })
	        ];
	        return (react_1.default.createElement(Dialog_1.default, { title: this.titleWithProgress("Found ".concat(documentService_1.default.documentCountObject.documentCount, " documents for requested ").concat(documentService_1.default.documentCountObject.originalCount, " entities")), actions: actions, modal: true, open: this.dialogOpen, contentStyle: DownloadDialog_contentStyle, bodyStyle: (bodyStyle) ? Object.assign({}, DownloadDialog_bodyStyle, bodyStyle) : DownloadDialog_bodyStyle },
	            children,
	            react_1.default.createElement("div", null,
	                react_1.default.createElement("div", { style: { marginTop: 10, marginLeft: 20, height: 100 } },
	                    react_1.default.createElement("h6", { style: { fontSize: 16 } }, "Download format"),
	                    react_1.default.createElement(RadioButtonGroup_1.default, { name: "selectedFormatRadio", valueSelected: documentService_1.default.documentCountObject.selectedFormat, onChange: this.onChangeSelectedFormat }, documentService_1.default.documentCountObject.formats.map(function (format, index) { return (react_1.default.createElement(RadioButton_1.default, { key: index, value: format.value, label: format.label, style: { display: 'inline-block', width: '25%' } })); })),
	                    (0, formUtils_1.lovParam)((0, formUtils_1.getLovItem)(documentService_1.default.documentCountObject.formats, documentService_1.default.documentCountObject.selectedFormat), 'concatable') ?
	                        react_1.default.createElement(fields_1.MdCheckbox, { name: "duplexPrinting", checked: documentService_1.default.documentCountObject.duplexPrinting, label: "Duplex Printing", onCheck: this.onCheckDuplexPrinting })
	                        : null),
	                react_1.default.createElement("div", { style: { marginTop: 20, marginLeft: 20, display: 'flex' } },
	                    react_1.default.createElement(RaisedButton_1.default, { href: gridService_1.default.documentDownloadUrl(grid, documentLocation, documentService_1.default.documentCountObject, false), label: "Download", icon: react_1.default.createElement(file_download_1.default, null), primary: true, style: { marginRight: 20 } }),
	                    react_1.default.createElement(RaisedButton_1.default, { href: gridService_1.default.documentDownloadUrl(grid, documentLocation, documentService_1.default.documentCountObject, true), target: "_blank", label: "Open", icon: react_1.default.createElement(open_in_new_1.default, null), primary: true })))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], DownloadDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], DownloadDialog.prototype, "cancel", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], DownloadDialog.prototype, "onChangeSelectedFormat", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], DownloadDialog.prototype, "onCheckDuplexPrinting", void 0);
	    DownloadDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], DownloadDialog);
	    return DownloadDialog;
	}(dialogAncestor_1.DialogAncestor));
	exports.default = DownloadDialog;
	var DownloadDialog_bodyStyle = { overflow: 'visible', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' };
	var DownloadDialog_contentStyle = { width: '80%', maxWidth: 800 };


/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var errorComp_1 = __webpack_require__(34);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var react_router_1 = __webpack_require__(65);
	var formUtils_1 = __webpack_require__(14);
	var mobx_1 = __webpack_require__(5);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var buttons_1 = __webpack_require__(27);
	__webpack_require__(452);
	var documentDomain_1 = __webpack_require__(109);
	var documentService_1 = tslib_1.__importDefault(__webpack_require__(110));
	var contractForm_1 = tslib_1.__importDefault(__webpack_require__(2065));
	var gridDocumentComp_1 = tslib_1.__importDefault(__webpack_require__(312));
	var gridDocument_1 = __webpack_require__(313);
	var locales_1 = __webpack_require__(15);
	var ContractDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(ContractDetail, _super);
	    function ContractDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.customValidate = function (contractObject) {
	            var errors = [];
	            // if (contractObject.contractType === CONTRACTTYPE.CUSTOMER_CONTRACT && !contractObject.contractNumber) {
	            //   errors.push({message: `${mdEntityService.getEntity("CONTRACTTYPE").getLovItemLabel(CONTRACTTYPE.CUSTOMER_CONTRACT)} requires Contract Number`});
	            // }
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave ');
	            uiService_1.default.showToolbarActionFlag();
	            var result = (0, formUtils_1.preSave)(documentService_1.default.contractObject, _this.customValidate);
	            if (!result) {
	                return;
	            }
	            var wasNew;
	            return documentService_1.default.saveContract(documentService_1.default.contractObject)
	                .then((0, mobx_1.action)("contractSave-callback", function (contractJson) {
	                wasNew = documentService_1.default.contractObject.cleanAfterSave(contractJson);
	                return _this.docSavingPromise(documentService_1.default.contractObject.$gridDocument, { contractId: documentService_1.default.contractObject.contractId });
	            })).then(function (x) {
	                if (wasNew) {
	                    _this.context.router.replaceWith('contractDetail', { id: documentService_1.default.contractObject.contractId });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            }).catch(function (error) {
	                documentService_1.default.contractObject.$errors = error.getMessages();
	            });
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            documentService_1.default.deleteContract(documentService_1.default.contractObject.contractId)
	                .then(function (response) {
	                _this.goBackOrHome();
	            }, function (error) {
	                documentService_1.default.contractObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            var query = { contractStatus: documentDomain_1.CONTRACTSTATUS.DRAFT, contractType: documentDomain_1.CONTRACTTYPE.CUSTOMER_CONTRACT };
	            _this.context.router.transitionTo("contractDetail", { id: 'new' }, query);
	        };
	        return _this;
	    }
	    ContractDetail.fetchData = function (routerParams, query) {
	        console.log("ContractDetail#fetchData(%O)", query);
	        var promiseArray = [mdEntityService_1.default.fetchEntityMetadata(['Contract'], ["Document"])];
	        if (routerParams.id === 'new') {
	            var customerLabel = query.customerLabel, customerValue = query.customerValue, other = tslib_1.__rest(query, ["customerLabel", "customerValue"]);
	            promiseArray.push(Promise.resolve(new documentDomain_1.Contract(tslib_1.__assign(tslib_1.__assign({ $new: true, active: true }, other), { customer: { value: customerValue, label: customerLabel } }))));
	            promiseArray.push(Promise.resolve([]));
	        }
	        else {
	            promiseArray.push(documentService_1.default.readContract(routerParams.id));
	            promiseArray.push(documentService_1.default.readDocuments({ contractId: routerParams.id }));
	        }
	        return Promise.all(promiseArray)
	            .then(function (_a) {
	            var entityMap = _a[0], contractObject = _a[1], documents = _a[2];
	            contractObject.$gridDocument = new gridDocument_1.GridDocument("contractGridDocument", "Docs", { contractId: contractObject.contractId }, false, null, documents);
	            documentService_1.default.contractObject = contractObject.initAfterRead(routerParams.id === 'new');
	        });
	    };
	    ContractDetail.prototype.componentWillUnmount = function () {
	        documentService_1.default.contractObject = null;
	    };
	    ContractDetail.prototype.findRootObject = function () {
	        return documentService_1.default.contractObject;
	    };
	    ContractDetail.prototype.render = function () {
	        var query = this.props.query;
	        console.debug('%c taskDetail render query %O', 'background-color: yellow', this.props.query);
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	            this._createToolMenu(documentService_1.default.contractObject, query.gridLocation),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: documentService_1.default.contractObject.$errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	            react_1.default.createElement("form", { style: { marginTop: 10 } },
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12" },
	                        react_1.default.createElement(contractForm_1.default, { dataObject: documentService_1.default.contractObject, rootObject: documentService_1.default.contractObject, entity: mdEntityService_1.default.getEntity("Contract"), entities: mdEntityService_1.default.entityMap })))),
	            react_1.default.createElement(gridDocumentComp_1.default, { grid: documentService_1.default.contractObject.$gridDocument, entities: mdEntityService_1.default.entityMap, rootObject: documentService_1.default.contractObject })));
	    };
	    ContractDetail.prototype._createToolMenu = function (contractObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: react_router_1.History.length <= 1, entityName: "Task", entityId: contractObject.contractId },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !contractObject.$dirty, label: "Save", permission: contractObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, disabled: contractObject.$new, label: "New", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "Contract", pageAncestor: this, onClick: this.onDelete, disabled: contractObject.$new, label: "Delete", permission: metaConstant_1.PERMISSION.Delete })));
	    };
	    ContractDetail.module = metaConstant_1.MODULE.core;
	    ContractDetail.title = 'Contract';
	    ContractDetail.icon = 'handshake-o';
	    ContractDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ContractDetail.prototype, "componentWillUnmount", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ContractDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ContractDetail.prototype, "onDelete", void 0);
	    ContractDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ContractDetail);
	    return ContractDetail;
	}(pageAncestor_1.default));
	exports.default = ContractDetail;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var routes_1 = __webpack_require__(75);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var documentDomain_1 = __webpack_require__(109);
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'contractList';
	var ContractList = /** @class */ (function (_super) {
	    tslib_1.__extends(ContractList, _super);
	    function ContractList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ContractList.fetchData = function (routerParams) {
	        console.log("ContractList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gl) { return gridService_1.default.getOrCreateGrid(gridLocation); });
	    };
	    ContractList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "contractDetail", params: { id: 'new' }, query: { contractStatus: documentDomain_1.CONTRACTSTATUS.DRAFT, contractType: documentDomain_1.CONTRACTTYPE.CUSTOMER_CONTRACT }, label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["New Contract"], ["New Contract"]))), permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.contractDetail })));
	    };
	    ContractList.module = metaConstant_1.MODULE.core;
	    ContractList.title = locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Contracts"], ["Contracts"])));
	    ContractList.icon = 'handshake-o';
	    ContractList.rootPage = true;
	    ContractList.protectedPage = true;
	    ContractList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ContractList);
	    return ContractList;
	}(pageAncestor_1.default));
	exports.default = ContractList;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var Tabs_1 = tslib_1.__importDefault(__webpack_require__(107));
	var Tab_1 = tslib_1.__importDefault(__webpack_require__(102));
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mui_theme_1 = __webpack_require__(119);
	var errorComp_1 = __webpack_require__(34);
	var formUtils_1 = __webpack_require__(14);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var documentService_1 = tslib_1.__importDefault(__webpack_require__(110));
	var documentTemplateForm_1 = tslib_1.__importDefault(__webpack_require__(2066));
	var documentTemplateResourceList_1 = tslib_1.__importDefault(__webpack_require__(565));
	var variables_1 = __webpack_require__(96);
	var stringUtils_1 = __webpack_require__(174);
	var domUtils_1 = __webpack_require__(91);
	var utils_1 = __webpack_require__(37);
	var metaConstant_1 = __webpack_require__(13);
	var documentDomain_1 = __webpack_require__(109);
	var mobx_1 = __webpack_require__(5);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var buttons_1 = __webpack_require__(27);
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var RadioButtonGroup_1 = tslib_1.__importDefault(__webpack_require__(243));
	var RadioButton_1 = tslib_1.__importDefault(__webpack_require__(287));
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var commonDataService_1 = __webpack_require__(41);
	var createForm_1 = __webpack_require__(18);
	var AceEditor;
	var testDataTypes = [{ value: 'xml', label: 'XML' }, { value: 'id', label: 'Select entity' }];
	var DocumentTemplateDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentTemplateDetail, _super);
	    function DocumentTemplateDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            selectedTab: 'header',
	            testDataType: (0, formUtils_1.lovValue)(testDataTypes[0])
	        };
	        _this.aceEditorTSRefHandler = function (c) { return _this._aceEditorTS = c; };
	        _this.aceEditorRRefHandler = function (c) { return _this._aceEditorR = c; };
	        _this.aceEditorDRefHandler = function (c) { return _this._aceEditorD = c; };
	        _this.customValidate = function (documentTemplateObject) {
	            var errors = [];
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave ');
	            uiService_1.default.showToolbarActionFlag();
	            if (!(0, formUtils_1.preSave)(documentService_1.default.documentTemplateObject, _this.customValidate)) {
	                return;
	            }
	            documentService_1.default.saveDocumentTemplate(documentService_1.default.documentTemplateObject.prepareForServer())
	                .then((0, mobx_1.action)("documentTemplateSave-callback", function (documentTemplateJson) {
	                var wasNew = documentService_1.default.documentTemplateObject.cleanAfterSave(documentTemplateJson);
	                if (wasNew) {
	                    _this.context.router.replaceWith('documentTemplateDetail', { id: documentService_1.default.documentTemplateObject.id });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            }), function (error) {
	                documentService_1.default.documentTemplateObject.$errors = error.getMessages();
	            });
	        };
	        _this.onDelete = function (evt) {
	            documentService_1.default.deleteDocumentTemplate(documentService_1.default.documentTemplateObject.documentType.value, documentService_1.default.documentTemplateObject.templateIndex)
	                .then(function (response) {
	                _this.context.router.transitionTo('documentTypeDetail', { id: documentService_1.default.documentTemplateObject.documentType.value });
	            }, function (error) {
	                documentService_1.default.documentTemplateObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            var query = (documentService_1.default.documentTemplateObject.documentType) ? {
	                documentTypeId: documentService_1.default.documentTemplateObject.documentType.value,
	                documentTypeLabel: documentService_1.default.documentTemplateObject.documentType.label,
	                templateTypeId: documentService_1.default.documentTemplateObject.templateTypeId
	            } : null;
	            _this.context.router.transitionTo("documentTemplateDetail", { id: 'new' }, query);
	        };
	        _this.handleChange = function (value) {
	            console.log('handleChange newValue ', value);
	            // tohle je hack, kdy zrejme pritomnost ACE editoru vyvola tento event pri psani do TextFieldu....
	            if (value && value.target) {
	                value.stopPropagation();
	                return;
	            }
	            _this.setState({
	                selectedTab: value
	            }, function () {
	                _this.onResize();
	            });
	        };
	        _this.onChangeTemplateSource = function (newValue) {
	            console.log('onChangeTemplateSource');
	            documentService_1.default.documentTemplateObject.templateStr = newValue;
	            documentService_1.default.documentTemplateObject.$dirty = true;
	        };
	        _this.onChangeTestDataType = function (evt, testDataType) {
	            console.log('onChangeTestDataType ', testDataType);
	            _this.setState({ testDataType: testDataType, dataStr: "", testEntity: null, testObject: null });
	        };
	        _this.onChangeData = function (newValue) {
	            console.log('onChangeData');
	            _this.setState({ dataStr: newValue });
	        };
	        _this.onChangeTestEntity = function (testEntity) {
	            console.log('onChangeTestEntity');
	            _this.setState({ testEntity: testEntity, testObject: null });
	        };
	        _this.onChangeTestObject = function (testObject) {
	            console.log('onChangeTestObject');
	            _this.setState({ testObject: testObject });
	        };
	        _this.onResize = function (evt) {
	            var bodyRect = document.body.getBoundingClientRect();
	            var aceHeightTS = (0, domUtils_1.computeHeight)(bodyRect, _this._aceEditorTS);
	            var aceHeightD = (0, domUtils_1.computeHeight)(bodyRect, _this._aceEditorD);
	            var aceHeightR = (0, domUtils_1.computeHeight)(bodyRect, _this._aceEditorR);
	            if (aceHeightTS || aceHeightD || aceHeightR) {
	                _this.setState({ aceHeightTS: aceHeightTS, aceHeightD: aceHeightD, aceHeightR: aceHeightR });
	            }
	        };
	        _this.onTestEnabled = function () {
	            return documentService_1.default.documentTemplateObject.templateStr && ((_this.state.testDataType === 'xml' && _this.state.dataStr) || (_this.state.testDataType === 'id' && _this.state.testEntity && _this.state.testObject));
	        };
	        _this.onTest = function () {
	            var _a = _this.state, dataStr = _a.dataStr, testEntity = _a.testEntity, testObject = _a.testObject;
	            commonService_1.default.loading(true);
	            var data = (0, stringUtils_1.encodeString)(dataStr);
	            documentService_1.default.test({ documentTemplate: documentService_1.default.documentTemplateObject.prepareForServer(), data: data, testEntity: testEntity, testEntityId: (0, formUtils_1.lovValue)(testObject) })
	                .then(function (resultData) {
	                var resultStr = (documentService_1.default.documentTemplateObject.templateTypeId === 'XSL') ? (0, stringUtils_1.decodeString)(resultData)
	                    : (((documentService_1.default.documentTemplateObject.templateTypeId === 'XSL_FO')) ? ("data:application/pdf;base64, " + resultData) : resultData);
	                _this.setState({ resultStr: resultStr, selectedTab: 'result' }, function () {
	                    _this.onResize();
	                    commonService_1.default.loading(false);
	                });
	            });
	        };
	        return _this;
	    }
	    DocumentTemplateDetail.fetchData = function (routerParams, query) {
	        console.log("DocumentTemplateDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['DocumentTemplate', "DocumentTemplateResource"], [{ entity: "DOCUMENTCOMPUTATION", lov: true }, { entity: "MdEntity", lov: true }]);
	        var documentPromise;
	        if (routerParams.id === 'new') {
	            var documentType = (query.documentTypeId) ? { value: query.documentTypeId, label: query.documentTypeLabel } : null;
	            documentPromise = Promise.resolve(new documentDomain_1.DocumentTemplate({
	                $new: true,
	                documentType: documentType,
	                templateTypeId: query.templateTypeId,
	                useSaxonForXslt: (query.templateTypeId === 'XSL' || query.templateTypeId === 'XSL_FO')
	            }));
	        }
	        else {
	            documentPromise = documentService_1.default.readDocumentTemplate(routerParams.id);
	        }
	        // webpack to takhle promisifikovane nezvladne, musi to byt normalne, je to v willMount
	        // const requireEnsure = (dependencies, filename) => new Promise((resolve, reject) => {
	        //     require.ensure(dependencies, resolve, filename);
	        //   });
	        //
	        // let requirePromise = requireEnsure(['brace', 'react-ace', 'brace/mode/xml', 'brace/theme/github'], 'reactAce');
	        return Promise.all([metadataPromise, documentPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], documentTemplateObject = _a[1];
	            documentService_1.default.documentTemplateObject = documentTemplateObject.initAfterRead(false);
	        });
	    };
	    DocumentTemplateDetail.prototype.componentWillMount = function () {
	        var _this = this;
	        __webpack_require__.e/* nsure */(0, function (require) {
	            if (AceEditor) {
	                return;
	            }
	            AceEditor = __webpack_require__(153).default;
	            var brace = __webpack_require__(133);
	            __webpack_require__(596);
	            __webpack_require__(147);
	            __webpack_require__(146);
	            _this.forceUpdate();
	        });
	    };
	    // componentWillReceiveProps(nextProps) {
	    //   //console.debug('DocumentTemplateDetail#componentWillReceiveProps, nextProps: %O', nextProps);
	    //   setTimeout(() => {
	    //     this.onResize();
	    //   })
	    // }
	    DocumentTemplateDetail.prototype.componentDidMount = function () {
	        console.debug("%c componentDidMount", "background-color: magenta");
	        this.onResizeDebounced = (0, utils_1.debounce)(this.onResize, 15, false);
	        window.addEventListener('resize', this.onResizeDebounced);
	        this.onResize();
	    };
	    DocumentTemplateDetail.prototype.componentWillUnmount = function () {
	        window.removeEventListener('resize', this.onResizeDebounced);
	        documentService_1.default.documentTemplateObject = null;
	    };
	    DocumentTemplateDetail.prototype.findRootObject = function () {
	        return documentService_1.default.documentTemplateObject;
	    };
	    DocumentTemplateDetail.prototype.render = function () {
	        var query = this.props.query;
	        var _a = this.state, aceHeightTS = _a.aceHeightTS, aceHeightD = _a.aceHeightD, aceHeightR = _a.aceHeightR, dataStr = _a.dataStr, resultStr = _a.resultStr;
	        var propsForCreateForm = {
	            dataObject: documentService_1.default.documentTemplateObject,
	            rootObject: documentService_1.default.documentTemplateObject,
	            entity: mdEntityService_1.default.getEntity('DocumentTemplate'),
	            entities: mdEntityService_1.default.entityMap
	        };
	        console.debug('%c documentTemplateDetail render template %s', 'background-color: yellow', this.state.selectedTab);
	        var resultElement = null;
	        if (resultStr) {
	            if (documentService_1.default.documentTemplateObject.templateTypeId === 'XSL') {
	                if (AceEditor) {
	                    resultElement = react_1.default.createElement(AceEditor, { mode: "xml", theme: "github", value: resultStr, readOnly: true, name: "RESULT_DIV_ID", editorProps: { $blockScrolling: true }, width: "100%", height: aceHeightR + "px", ref: this.aceEditorRRefHandler, style: { padding: '5px 0 0 0' } });
	                }
	                else {
	                    resultElement = "Loading....";
	                }
	            }
	            else if (documentService_1.default.documentTemplateObject.templateTypeId === 'XSL_FO') {
	                resultElement = react_1.default.createElement("iframe", { src: resultStr, ref: this.aceEditorRRefHandler, height: aceHeightR + "px", width: "100%" });
	            }
	        }
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	            this._createToolMenu(documentService_1.default.documentTemplateObject, query.gridLocation),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: documentService_1.default.documentTemplateObject.$errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	            react_1.default.createElement("form", { style: { marginTop: 10 } },
	                react_1.default.createElement(Tabs_1.default, { value: this.state.selectedTab, onChange: this.handleChange, className: "detail-grid", tabTemplate: mui_theme_1.TabTemplate, inkBarStyle: { transition: 'inherit' }, contentContainerStyle: { width: '100%', flexGrow: 1, display: 'flex', minHeight: 0 } },
	                    react_1.default.createElement(Tab_1.default, { label: "Header", style: variables_1.tabStyle, value: 'header' },
	                        react_1.default.createElement("div", { className: "row", style: { padding: '5px 0 0 0', width: '100%' } },
	                            react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                                react_1.default.createElement(documentTemplateForm_1.default, tslib_1.__assign({}, propsForCreateForm))),
	                            react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                                react_1.default.createElement(documentTemplateResourceList_1.default, { documentTemplateObject: documentService_1.default.documentTemplateObject, entities: mdEntityService_1.default.entityMap, showType: false })))),
	                    react_1.default.createElement(Tab_1.default, { label: "Template source", style: variables_1.tabStyle, value: 'templateSource' }, (AceEditor) ?
	                        react_1.default.createElement(AceEditor, { mode: "xml", theme: "github", value: documentService_1.default.documentTemplateObject.templateStr, onChange: this.onChangeTemplateSource, name: "TEMPLATE_SOURCE_DIV_ID", enableBasicAutocompletion: true, enableLiveAutocompletion: true, editorProps: { $blockScrolling: true }, width: "100%", height: aceHeightTS + "px", ref: this.aceEditorTSRefHandler, style: { padding: '5px 0 0 0' } })
	                        : "Loading...."),
	                    react_1.default.createElement(Tab_1.default, { label: "Test Data", style: variables_1.tabStyle, value: 'data' },
	                        react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column", width: "100%" } },
	                            react_1.default.createElement(RadioButtonGroup_1.default, { name: "testDataType", valueSelected: this.state.testDataType, onChange: this.onChangeTestDataType, style: { margin: "20px 0 10px 0" } }, testDataTypes.map(function (format, index) { return (react_1.default.createElement(RadioButton_1.default, { key: index, value: format.value, label: format.label, style: { display: 'inline-block', width: '25%' } })); })),
	                            ((0, formUtils_1.lovValue)(this.state.testDataType) === 'xml') &&
	                                ((AceEditor) ?
	                                    react_1.default.createElement(AceEditor, { mode: "xml", theme: "github", value: dataStr, onChange: this.onChangeData, name: "DATA_DIV_ID", editorProps: { $blockScrolling: true }, width: "100%", height: aceHeightD + "px", ref: this.aceEditorDRefHandler, style: { padding: '5px 0 0 0' } })
	                                    : "Loading...."),
	                            ((0, formUtils_1.lovValue)(this.state.testDataType) === 'id') && react_1.default.createElement("div", null,
	                                react_1.default.createElement("div", { style: { margin: 20 } },
	                                    react_1.default.createElement("div", { className: "row" },
	                                        react_1.default.createElement("div", { className: "fx col-xs-12" },
	                                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { name: "testEntity", value: this.state.testEntity, floatingLabelText: "Select Entity Type", options: mdEntityService_1.default.getEntity("MdEntity").lovItems, fullWidth: true, onChange: this.onChangeTestEntity, clearable: false })))),
	                                    (this.state.testEntity) ? (react_1.default.createElement("div", { className: "row" },
	                                        react_1.default.createElement("div", { className: "fx col-xs-12" },
	                                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { name: "testObject", floatingLabelText: "Search entity", value: this.state.testObject, async: true, asterixForAll: true, fullWidth: true, onChange: this.onChangeTestObject, clearable: false, loadOptions: commonDataService_1.optionsSearch.bind(this, (0, formUtils_1.lovValue)(this.state.testEntity), {}) }))))) : null)))),
	                    react_1.default.createElement(Tab_1.default, { label: "Result", style: variables_1.tabStyle, value: 'result' }, resultElement)))));
	    };
	    DocumentTemplateDetail.prototype._createToolMenu = function (documentTemplateObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: History.length <= 1 },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !documentTemplateObject.$dirty, label: "Save", permission: documentTemplateObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, disabled: documentTemplateObject.$new, label: "New", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "DocumentTemplate", pageAncestor: this, onClick: this.onDelete, disabled: documentTemplateObject.$new, label: "Delete", permission: metaConstant_1.PERMISSION.Delete }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onTest, disabled: !this.onTestEnabled(), label: "Test" })));
	    };
	    DocumentTemplateDetail.module = metaConstant_1.MODULE.core;
	    DocumentTemplateDetail.title = 'Document Template';
	    DocumentTemplateDetail.icon = 'file-code-o';
	    DocumentTemplateDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], DocumentTemplateDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], DocumentTemplateDetail.prototype, "onDelete", void 0);
	    DocumentTemplateDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], DocumentTemplateDetail);
	    return DocumentTemplateDetail;
	}(pageAncestor_1.default));
	exports.default = DocumentTemplateDetail;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var Tabs_1 = tslib_1.__importDefault(__webpack_require__(107));
	var Tab_1 = tslib_1.__importDefault(__webpack_require__(102));
	var buttons_1 = __webpack_require__(27);
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var icons_1 = __webpack_require__(63);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var mui_theme_1 = __webpack_require__(119);
	var errorComp_1 = __webpack_require__(34);
	var formUtils_1 = __webpack_require__(14);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridComp_1 = tslib_1.__importDefault(__webpack_require__(44));
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var documentService_1 = tslib_1.__importDefault(__webpack_require__(110));
	var documentTypeForm_1 = tslib_1.__importDefault(__webpack_require__(2067));
	var variables_1 = __webpack_require__(96);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var documentDomain_1 = __webpack_require__(109);
	var gridUtils_1 = __webpack_require__(83);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var mobx_1 = __webpack_require__(5);
	var gridComp_2 = __webpack_require__(44);
	var gridSelectionSupport_1 = __webpack_require__(938);
	var tenantSelectionSupport_1 = __webpack_require__(403);
	var locales_1 = __webpack_require__(15);
	var documentTemplateGridLocation = 'documentTemplateList';
	var tenantGridComposite = 'tenantGridComposite';
	var tenantGridLocation = 'tenantList';
	var tenantGroupListLocation = 'tenantGroupList';
	var gridLocationListLocation = 'gridLocationSelectionList';
	var DocumentTypeDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentTypeDetail, _super);
	    function DocumentTypeDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.customValidate = function (documentTypeObject) {
	            var errors = [];
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave ');
	            uiService_1.default.showToolbarActionFlag();
	            var result = (0, formUtils_1.preSave)(documentService_1.default.documentTypeObject, _this.customValidate);
	            if (!result) {
	                return;
	            }
	            documentService_1.default.saveDocumentType(documentService_1.default.documentTypeObject)
	                .then((0, mobx_1.action)("documentTypeSave-callback", function (documentTypeJson) {
	                var wasNew = documentService_1.default.documentTypeObject.cleanAfterSave(documentTypeJson);
	                if (wasNew) {
	                    _this.context.router.replaceWith('documentTypeDetail', { id: documentService_1.default.documentTypeObject.documentTypeId });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            }), function (error) {
	                documentService_1.default.documentTypeObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            _this.context.router.transitionTo("documentTypeDetail", { id: 'new' });
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            documentService_1.default.deleteDocumentType(documentService_1.default.documentTypeObject.documentTypeId)
	                .then(function (response) {
	                _this.context.router.transitionTo('documentTypeList');
	            }, function (error) {
	                documentService_1.default.documentTypeObject.$errors = error.getMessages();
	            });
	        };
	        return _this;
	    }
	    DocumentTypeDetail.fetchData = function (routerParams, query) {
	        console.log("DocumentTypeDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['DocumentType']);
	        var documentPromise;
	        if (routerParams.id === 'new') {
	            documentPromise = Promise.resolve(new documentDomain_1.DocumentType({ $new: true }));
	        }
	        else {
	            documentPromise = documentService_1.default.readDocumentType(routerParams.id);
	        }
	        var gridPromise = gridService_1.default.fetchGrids(documentTemplateGridLocation, tenantGridLocation, tenantGroupListLocation, gridLocationListLocation);
	        return Promise.all([metadataPromise, documentPromise, gridPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], documentTypeObject = _a[1], gridLocationMap = _a[2];
	            documentTypeObject.$movingBlocks = new gridUtils_1.MovingBlocks(tenantGridComposite, true, query.tab, new grid_1.default(gridLocationMap.get(documentTemplateGridLocation), documentTypeObject.documentTypeId), new gridUtils_1.GridComposite(tenantGridComposite, 'Tenant selection', new grid_1.default(gridLocationMap.get(tenantGridLocation)), new grid_1.default(gridLocationMap.get(tenantGroupListLocation))), new grid_1.default(gridLocationMap.get(gridLocationListLocation)));
	            documentService_1.default.documentTypeObject = documentTypeObject.initAfterRead(false);
	        });
	    };
	    DocumentTypeDetail.prototype.componentWillMount = function () {
	        uiService_1.default.addMediaQueryListener(this.mediaQueryListener);
	    };
	    /**
	     * tohle je tady kvuli prechodu na jiny detail invoice (chained details)
	     * @param prevProps
	     */
	    DocumentTypeDetail.prototype.componentDidUpdate = function (prevProps) {
	        if (this.idChanged(prevProps.params.id, this.props.params.id)) {
	            documentService_1.default.documentTypeObject.$movingBlocks.searchExposedGrids(documentService_1.default.documentTypeObject);
	        }
	    };
	    DocumentTypeDetail.prototype.componentDidMount = function () {
	        console.debug("%c componentDidMount", "background-color: magenta");
	        documentService_1.default.documentTypeObject.$movingBlocks.searchExposedGrids(documentService_1.default.documentTypeObject);
	    };
	    DocumentTypeDetail.prototype.componentWillUnmount = function () {
	        uiService_1.default.removeMediaQueryListener(this.mediaQueryListener);
	        documentService_1.default.documentTypeObject = null;
	    };
	    DocumentTypeDetail.prototype.findRootObject = function () {
	        return documentService_1.default.documentTypeObject;
	    };
	    DocumentTypeDetail.prototype.render = function () {
	        var _this = this;
	        var query = this.props.query;
	        var propsForCreateForm = {
	            dataObject: documentService_1.default.documentTypeObject,
	            rootObject: documentService_1.default.documentTypeObject,
	            entity: mdEntityService_1.default.getEntity('DocumentType'),
	            entities: mdEntityService_1.default.entityMap
	        };
	        console.debug('%c documentTypeDetail render query %O', 'background-color: yellow', this.props.query);
	        var documentTypeQuery = {
	            documentTypeId: documentService_1.default.documentTypeObject.documentTypeId,
	            documentTypeLabel: documentService_1.default.documentTypeObject.documentName,
	            templateTypeId: (0, formUtils_1.lovValue)(documentService_1.default.documentTypeObject.templateType)
	        };
	        var mainForm = (react_1.default.createElement("form", { style: { marginTop: 10 } },
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12" },
	                    react_1.default.createElement(documentTypeForm_1.default, tslib_1.__assign({}, propsForCreateForm))))));
	        var movingBlocks = documentService_1.default.documentTypeObject.$movingBlocks;
	        var gridCompArray = [
	            react_1.default.createElement(gridComp_1.default, { ref: documentTemplateGridLocation, grid: movingBlocks.getBlock(documentTemplateGridLocation), uiLocation: movingBlocks.getUiLocation(documentTemplateGridLocation), entities: mdEntityService_1.default.entityMap },
	                react_1.default.createElement(icons_1.ZzIconButtonRoute, { big: true, routeName: "documentTemplateDetail", params: { id: 'new' }, query: documentTypeQuery, securable: "documentTemplateDetail", permission: metaConstant_1.PERMISSION.New },
	                    react_1.default.createElement(add_1.default, null))),
	            react_1.default.createElement(gridComp_2.GridCompositeComp, { grid: movingBlocks.getBlock(tenantGridComposite), uiLocation: movingBlocks.getUiLocation(tenantGridComposite) },
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6", style: { padding: 10 } },
	                    react_1.default.createElement("h4", null, "Select Tenants"),
	                    react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(tenantGridComposite).groupMembers[0], multiSelect: false, hideToolbar: true, gridClassName: "detail-grid", uiLocation: movingBlocks.getUiLocation(tenantGridComposite), functionMap: { getSelectTenant: tenantSelectionSupport_1.getSelectTenant.bind(this, documentService_1.default.documentTypeObject), setSelectTenant: tenantSelectionSupport_1.setSelectTenant.bind(this, documentService_1.default.documentTypeObject) }, entities: mdEntityService_1.default.entityMap })),
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6", style: { padding: 10 } },
	                    react_1.default.createElement("h4", null, "or select Tenant Groups"),
	                    react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(tenantGridComposite).groupMembers[1], multiSelect: false, hideToolbar: true, gridClassName: "detail-grid", uiLocation: movingBlocks.getUiLocation(tenantGridComposite), functionMap: { getSelectTenantGroup: tenantSelectionSupport_1.getSelectTenantGroup.bind(this, documentService_1.default.documentTypeObject), setSelectTenantGroup: tenantSelectionSupport_1.setSelectTenantGroup.bind(this, documentService_1.default.documentTypeObject) }, entities: mdEntityService_1.default.entityMap }))),
	            react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(gridLocationListLocation), multiSelect: false, uiLocation: movingBlocks.getUiLocation(gridLocationListLocation), functionMap: { getSelectGridLocation: gridSelectionSupport_1.getSelectGridLocation.bind(this, documentService_1.default.documentTypeObject), setSelectGridLocation: gridSelectionSupport_1.setSelectGridLocation.bind(this, documentService_1.default.documentTypeObject) }, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideRefresh: true })
	        ];
	        var standAloneGridComp = movingBlocks.pluckStandAloneBlock(gridCompArray);
	        var tabArray = gridCompArray.map(function (gridComp) { return (react_1.default.createElement(Tab_1.default, { label: gridComp.props.grid.label, style: variables_1.tabStyle, onActive: _this.activateTab.bind(_this, gridComp.props.grid), key: gridComp.props.grid.getBlockName(), value: gridComp.props.grid.getBlockName() }, gridComp)); });
	        var tabs = (tabArray.length) ? (react_1.default.createElement(Tabs_1.default, { value: movingBlocks.activeBlockTab, className: "detail-grid", tabTemplate: mui_theme_1.TabTemplate, inkBarStyle: { transition: 'inherit' }, contentContainerStyle: { width: '100%', flexGrow: 1, display: 'flex', minHeight: 0 }, onChange: this.onTabChange }, tabArray)) : '';
	        if (uiService_1.default.globalMediaQuery.matches) {
	            return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'row' } },
	                react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', height: '100%', width: '50%' } },
	                    this._createToolMenu(documentService_1.default.documentTypeObject, query.gridLocation),
	                    react_1.default.createElement(errorComp_1.ErrorComp, { messages: documentService_1.default.documentTypeObject.$errors }),
	                    react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	                    react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	                    mainForm,
	                    tabs),
	                standAloneGridComp));
	        }
	        else {
	            return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	                this._createToolMenu(documentService_1.default.documentTypeObject, query.gridLocation),
	                react_1.default.createElement(errorComp_1.ErrorComp, { messages: documentService_1.default.documentTypeObject.$errors }),
	                react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	                react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	                mainForm,
	                tabs));
	        }
	    };
	    DocumentTypeDetail.prototype._createToolMenu = function (documentTypeObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: History.length <= 1, activeTab: documentTypeObject.$movingBlocks.activeBlockTab },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave.bind(this, false), disabled: !documentTypeObject.$dirty, label: "Save", permission: documentTypeObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, disabled: documentTypeObject.$new, label: "New", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "DocumentType", pageAncestor: this, onClick: this.onDelete, disabled: documentTypeObject.$new, label: "Delete", permission: metaConstant_1.PERMISSION.Delete })));
	    };
	    DocumentTypeDetail.module = metaConstant_1.MODULE.core;
	    DocumentTypeDetail.title = 'Document Type';
	    DocumentTypeDetail.icon = 'file-text';
	    DocumentTypeDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], DocumentTypeDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], DocumentTypeDetail.prototype, "onDelete", void 0);
	    DocumentTypeDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], DocumentTypeDetail);
	    return DocumentTypeDetail;
	}(pageAncestor_1.default));
	exports.default = DocumentTypeDetail;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var routes_1 = __webpack_require__(75);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'documentTypeList';
	var DocumentTypeList = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentTypeList, _super);
	    function DocumentTypeList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DocumentTypeList.fetchData = function (routerParams) {
	        console.log("DocumentTypeList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    DocumentTypeList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "documentTypeDetail", params: { id: 'new' }, label: "New Document Type", permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.documentTypeDetail })));
	    };
	    DocumentTypeList.module = metaConstant_1.MODULE.core;
	    DocumentTypeList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Document Types"], ["Document Types"])));
	    DocumentTypeList.icon = 'file-text';
	    DocumentTypeList.rootPage = true;
	    DocumentTypeList.protectedPage = true;
	    DocumentTypeList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], DocumentTypeList);
	    return DocumentTypeList;
	}(pageAncestor_1.default));
	exports.default = DocumentTypeList;
	var templateObject_1;


/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var Tabs_1 = tslib_1.__importDefault(__webpack_require__(107));
	var Tab_1 = tslib_1.__importDefault(__webpack_require__(102));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var icons_1 = __webpack_require__(63);
	var buttons_1 = __webpack_require__(27);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var mui_theme_1 = __webpack_require__(119);
	var errorComp_1 = __webpack_require__(34);
	var formUtils_1 = __webpack_require__(14);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridComp_1 = tslib_1.__importDefault(__webpack_require__(44));
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var eventService_1 = tslib_1.__importDefault(__webpack_require__(120));
	var activityConfigForm_1 = tslib_1.__importDefault(__webpack_require__(2078));
	var variables_1 = __webpack_require__(96);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var metaConstant_1 = __webpack_require__(13);
	var eventDomain_1 = __webpack_require__(74);
	var gridUtils_1 = __webpack_require__(83);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var gridComp_2 = __webpack_require__(44);
	var gridSelectionSupport_1 = __webpack_require__(938);
	var tenantSelectionSupport_1 = __webpack_require__(403);
	var locales_1 = __webpack_require__(15);
	var activityTemplateGridLocation = 'activityTemplateList';
	var tenantGridComposite = 'tenantGridComposite';
	var tenantGridLocation = 'tenantList';
	var tenantGroupListLocation = 'tenantGroupList';
	var gridLocationListLocation = 'gridLocationSelectionList';
	var ActivityConfigDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(ActivityConfigDetail, _super);
	    function ActivityConfigDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.customValidate = function (activityConfigObject) {
	            var errors = [];
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave ');
	            uiService_1.default.showToolbarActionFlag();
	            var result = (0, formUtils_1.preSave)(eventService_1.default.activityConfigObject, _this.customValidate);
	            if (!result) {
	                return;
	            }
	            eventService_1.default.saveActivityConfig(eventService_1.default.activityConfigObject)
	                .then((0, mobx_1.action)("activitySave-callback", function (activityConfigJson) {
	                var wasNew = eventService_1.default.activityConfigObject.cleanAfterSave(activityConfigJson);
	                if (wasNew) {
	                    _this.context.router.replaceWith('activityConfigDetail', { id: eventService_1.default.activityConfigObject.activityConfigId });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            }), function (error) {
	                eventService_1.default.activityConfigObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            _this.context.router.transitionTo("activityConfigDetail", { id: 'new' });
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            eventService_1.default.deleteActivityConfig(eventService_1.default.activityConfigObject.activityConfigId)
	                .then(function (response) {
	                _this.context.router.transitionTo('activityConfigList');
	            }, function (error) {
	                eventService_1.default.activityConfigObject.$errors = error.getMessages();
	            });
	        };
	        _this.onRootEntitySuccess = function () {
	            console.log("onRootEntitySuccess");
	            var grid = eventService_1.default.activityConfigObject.$movingBlocks.getBlock(gridLocationListLocation);
	            grid.masterId = (0, formUtils_1.lovValue)(eventService_1.default.activityConfigObject.rootEntity);
	            return grid.search(eventService_1.default.activityConfigObject);
	        };
	        return _this;
	    }
	    ActivityConfigDetail.fetchData = function (routerParams, query) {
	        console.log("ActivityConfigDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['ActivityConfig']);
	        var activityPromise;
	        if (routerParams.id === 'new') {
	            activityPromise = Promise.resolve(new eventDomain_1.ActivityConfig({ $new: true }));
	        }
	        else {
	            activityPromise = eventService_1.default.readActivityConfig(routerParams.id);
	        }
	        var gridPromise = gridService_1.default.fetchGrids(activityTemplateGridLocation, tenantGridLocation, tenantGroupListLocation, gridLocationListLocation);
	        return Promise.all([metadataPromise, activityPromise, gridPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], activityConfigObject = _a[1], gridLocationMap = _a[2];
	            activityConfigObject.$movingBlocks = new gridUtils_1.MovingBlocks(tenantGridComposite, true, query.tab, new grid_1.default(gridLocationMap.get(activityTemplateGridLocation), activityConfigObject.activityConfigId), new gridUtils_1.GridComposite(tenantGridComposite, 'Tenant selection', new grid_1.default(gridLocationMap.get(tenantGridLocation)), new grid_1.default(gridLocationMap.get(tenantGroupListLocation))), new grid_1.default(gridLocationMap.get(gridLocationListLocation), (0, formUtils_1.lovValue)(activityConfigObject.rootEntity)));
	            eventService_1.default.activityConfigObject = activityConfigObject.initAfterRead(false);
	        });
	    };
	    ActivityConfigDetail.prototype.componentWillMount = function () {
	        uiService_1.default.addMediaQueryListener(this.mediaQueryListener);
	    };
	    /**
	     * tohle je tady kvuli prechodu na jiny detail invoice (chained details)
	     * @param prevProps
	     */
	    ActivityConfigDetail.prototype.componentDidUpdate = function (prevProps) {
	        if (this.idChanged(prevProps.params.id, this.props.params.id)) {
	            eventService_1.default.activityConfigObject.$movingBlocks.searchExposedGrids(eventService_1.default.activityConfigObject);
	        }
	    };
	    ActivityConfigDetail.prototype.componentDidMount = function () {
	        console.debug("%c componentDidMount", "background-color: magenta");
	        eventService_1.default.activityConfigObject.$movingBlocks.searchExposedGrids(eventService_1.default.activityConfigObject);
	    };
	    ActivityConfigDetail.prototype.componentWillUnmount = function () {
	        uiService_1.default.removeMediaQueryListener(this.mediaQueryListener);
	        eventService_1.default.activityConfigObject = null;
	    };
	    ActivityConfigDetail.prototype.findRootObject = function () {
	        return eventService_1.default.activityConfigObject;
	    };
	    ActivityConfigDetail.prototype.render = function () {
	        var _this = this;
	        var query = this.props.query;
	        var propsForCreateForm = {
	            dataObject: eventService_1.default.activityConfigObject,
	            rootObject: eventService_1.default.activityConfigObject,
	            entity: mdEntityService_1.default.getEntity('ActivityConfig'),
	            entities: mdEntityService_1.default.entityMap
	        };
	        console.debug('%c activityConfigDetail render query %O', 'background-color: yellow', this.props.query);
	        var mainForm = (react_1.default.createElement("form", { style: { marginTop: 10 } },
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12" },
	                    react_1.default.createElement(activityConfigForm_1.default, tslib_1.__assign({}, propsForCreateForm, { onRootEntitySuccess: this.onRootEntitySuccess }))))));
	        var movingBlocks = eventService_1.default.activityConfigObject.$movingBlocks;
	        var gridCompArray = [
	            react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(activityTemplateGridLocation), uiLocation: movingBlocks.getUiLocation(activityTemplateGridLocation), entities: mdEntityService_1.default.entityMap },
	                react_1.default.createElement(icons_1.ZzIconButtonRoute, { big: true, routeName: "activityTemplateDetail", params: { id: 'new' }, query: eventService_1.default.activityConfigObject.createLov(), securable: "activityTemplateDetail", permission: metaConstant_1.PERMISSION.New },
	                    react_1.default.createElement(add_1.default, null))),
	            react_1.default.createElement(gridComp_2.GridCompositeComp, { grid: movingBlocks.getBlock(tenantGridComposite), uiLocation: movingBlocks.getUiLocation(tenantGridComposite) },
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6", style: { padding: 10 } },
	                    react_1.default.createElement("h4", null, "Select Tenants"),
	                    react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(tenantGridComposite).groupMembers[0], multiSelect: false, hideToolbar: true, gridClassName: "detail-grid", uiLocation: movingBlocks.getUiLocation(tenantGridComposite), functionMap: { getSelectTenant: tenantSelectionSupport_1.getSelectTenant.bind(this, eventService_1.default.activityConfigObject), setSelectTenant: tenantSelectionSupport_1.setSelectTenant.bind(this, eventService_1.default.activityConfigObject) }, entities: mdEntityService_1.default.entityMap })),
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6", style: { padding: 10 } },
	                    react_1.default.createElement("h4", null, "or select Tenant Groups"),
	                    react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(tenantGridComposite).groupMembers[1], multiSelect: false, hideToolbar: true, gridClassName: "detail-grid", uiLocation: movingBlocks.getUiLocation(tenantGridComposite), functionMap: { getSelectTenantGroup: tenantSelectionSupport_1.getSelectTenantGroup.bind(this, eventService_1.default.activityConfigObject), setSelectTenantGroup: tenantSelectionSupport_1.setSelectTenantGroup.bind(this, eventService_1.default.activityConfigObject) }, entities: mdEntityService_1.default.entityMap }))),
	            react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(gridLocationListLocation), multiSelect: false, uiLocation: movingBlocks.getUiLocation(gridLocationListLocation), functionMap: { getSelectGridLocation: gridSelectionSupport_1.getSelectGridLocation.bind(this, eventService_1.default.activityConfigObject), setSelectGridLocation: gridSelectionSupport_1.setSelectGridLocation.bind(this, eventService_1.default.activityConfigObject) }, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideRefresh: true })
	        ];
	        var standAloneGridComp = movingBlocks.pluckStandAloneBlock(gridCompArray);
	        var tabArray = gridCompArray.map(function (gridComp) { return (react_1.default.createElement(Tab_1.default, { label: gridComp.props.grid.label, style: variables_1.tabStyle, onActive: _this.activateTab.bind(_this, gridComp.props.grid), key: gridComp.props.grid.getBlockName(), value: gridComp.props.grid.getBlockName() }, gridComp)); });
	        var tabs = (tabArray.length) ? (react_1.default.createElement(Tabs_1.default, { value: movingBlocks.activeBlockTab, className: "detail-grid", tabTemplate: mui_theme_1.TabTemplate, inkBarStyle: { transition: 'inherit' }, contentContainerStyle: { width: '100%', flexGrow: 1, display: 'flex', minHeight: 0 }, onChange: this.onTabChange }, tabArray)) : '';
	        if (uiService_1.default.globalMediaQuery.matches) {
	            return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'row' } },
	                react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', height: '100%', width: '50%' } },
	                    this._createToolMenu(eventService_1.default.activityConfigObject, query.gridLocation),
	                    react_1.default.createElement(errorComp_1.ErrorComp, { messages: eventService_1.default.activityConfigObject.$errors }),
	                    react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	                    react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	                    mainForm,
	                    tabs),
	                standAloneGridComp));
	        }
	        else {
	            return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	                this._createToolMenu(eventService_1.default.activityConfigObject, query.gridLocation),
	                react_1.default.createElement(errorComp_1.ErrorComp, { messages: eventService_1.default.activityConfigObject.$errors }),
	                react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	                react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	                mainForm,
	                tabs));
	        }
	    };
	    ActivityConfigDetail.prototype._createToolMenu = function (activityConfigObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: History.length <= 1, activeTab: activityConfigObject.$movingBlocks.activeBlockTab },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !activityConfigObject.$dirty, label: "Save", permission: activityConfigObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, disabled: activityConfigObject.$new, label: "New", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "ActivityConfig", pageAncestor: this, onClick: this.onDelete, disabled: activityConfigObject.$new, label: "Delete", permission: metaConstant_1.PERMISSION.Delete })));
	    };
	    ActivityConfigDetail.module = metaConstant_1.MODULE.core;
	    ActivityConfigDetail.title = 'Activity Config';
	    ActivityConfigDetail.icon = 'send';
	    ActivityConfigDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ActivityConfigDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ActivityConfigDetail.prototype, "onDelete", void 0);
	    ActivityConfigDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ActivityConfigDetail);
	    return ActivityConfigDetail;
	}(pageAncestor_1.default));
	exports.default = ActivityConfigDetail;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var routes_1 = __webpack_require__(75);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'activityConfigList';
	var ActivityConfigList = /** @class */ (function (_super) {
	    tslib_1.__extends(ActivityConfigList, _super);
	    function ActivityConfigList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ActivityConfigList.fetchData = function (routerParams) {
	        console.log("ActivityConfigList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    ActivityConfigList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "activityConfigDetail", params: { id: 'new' }, label: "New Activity Config", permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.activityConfigDetail })));
	    };
	    ActivityConfigList.module = metaConstant_1.MODULE.core;
	    ActivityConfigList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Activity Config"], ["Activity Config"])));
	    ActivityConfigList.icon = 'send';
	    ActivityConfigList.rootPage = true;
	    ActivityConfigList.protectedPage = true;
	    ActivityConfigList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ActivityConfigList);
	    return ActivityConfigList;
	}(pageAncestor_1.default));
	exports.default = ActivityConfigList;
	var templateObject_1;


/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var activityExpando_1 = tslib_1.__importDefault(__webpack_require__(566));
	var mobx_1 = __webpack_require__(5);
	var eventService_1 = tslib_1.__importDefault(__webpack_require__(120));
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'activityList';
	var ActivityList = /** @class */ (function (_super) {
	    tslib_1.__extends(ActivityList, _super);
	    function ActivityList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.bulkDelete = function (gridParams) {
	            return eventService_1.default.deletePartyActivity(gridParams);
	        };
	        return _this;
	    }
	    ActivityList.fetchData = function (routerParams) {
	        console.log("ActivityList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gl) { return gridService_1.default.getOrCreateGrid(gridLocation); });
	    };
	    ActivityList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query, showExpand: true, ExpandComponent: activityExpando_1.default, multiDeleteSecurable: metaConstant_1.SECURABLE.activityList, multiDeleteSaveFn: this.bulkDelete }));
	    };
	    ActivityList.module = metaConstant_1.MODULE.core;
	    ActivityList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Activities"], ["Activities"])));
	    ActivityList.icon = 'volume-control-phone';
	    ActivityList.rootPage = true;
	    ActivityList.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ActivityList.prototype, "bulkDelete", void 0);
	    ActivityList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ActivityList);
	    return ActivityList;
	}(pageAncestor_1.default));
	exports.default = ActivityList;
	var templateObject_1;


/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var errorComp_1 = __webpack_require__(34);
	var formUtils_1 = __webpack_require__(14);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var eventService_1 = tslib_1.__importDefault(__webpack_require__(120));
	var activityTemplateForm_1 = tslib_1.__importDefault(__webpack_require__(2079));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var eventDomain_1 = __webpack_require__(74);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var mobx_1 = __webpack_require__(5);
	var buttons_1 = __webpack_require__(27);
	var documentTemplateResourceList_1 = tslib_1.__importDefault(__webpack_require__(565));
	var Tabs_1 = tslib_1.__importDefault(__webpack_require__(107));
	var Tab_1 = tslib_1.__importDefault(__webpack_require__(102));
	var utils_1 = __webpack_require__(37);
	var domUtils_1 = __webpack_require__(91);
	var RadioButtonGroup_1 = tslib_1.__importDefault(__webpack_require__(243));
	var RadioButton_1 = tslib_1.__importDefault(__webpack_require__(287));
	var locales_1 = __webpack_require__(15);
	var AceEditor, EmailEditor;
	var editorTypes = [{ value: 'simple', label: 'Simple' }, { value: 'advanced', label: 'Advanced' }];
	var ActivityTemplateDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(ActivityTemplateDetail, _super);
	    function ActivityTemplateDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.editorType = (eventService_1.default.activityTemplateObject.defaultEmailDesign) ? (0, formUtils_1.lovValue)(editorTypes[1]) : (0, formUtils_1.lovValue)(editorTypes[0]);
	        _this.editorHeight = 500;
	        _this.aceEditorBodyRefHandler = function (c) { return _this._aceEditorBody = c; };
	        _this.customValidate = function (activityTemplateObject) {
	            var errors = [];
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave ');
	            uiService_1.default.showToolbarActionFlag();
	            if (!(0, formUtils_1.preSave)(eventService_1.default.activityTemplateObject, _this.customValidate)) {
	                return;
	            }
	            if (_this.editorType == 'advanced') {
	                _this.editorRef.exportHtml(function (data) {
	                    eventService_1.default.activityTemplateObject.defaultEmailBody = data.html;
	                    eventService_1.default.activityTemplateObject.defaultEmailDesign = JSON.stringify(data.design);
	                    _this.onSaveInner();
	                });
	            }
	            else {
	                eventService_1.default.activityTemplateObject.defaultEmailDesign = null;
	                _this.onSaveInner();
	            }
	        };
	        _this.onSaveInner = function () {
	            eventService_1.default.saveActivityTemplate(eventService_1.default.activityTemplateObject.prepareForServer())
	                .then((0, mobx_1.action)("activityTemplateSave-callback", function (activityTemplateJson) {
	                var wasNew = eventService_1.default.activityTemplateObject.cleanAfterSave(activityTemplateJson);
	                if (wasNew) {
	                    _this.context.router.replaceWith('activityTemplateDetail', { id: eventService_1.default.activityTemplateObject.id });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            }), function (error) {
	                eventService_1.default.activityTemplateObject.$errors = error.getMessages();
	            });
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            eventService_1.default.deleteActivityTemplate(eventService_1.default.activityTemplateObject.activityConfig.value, eventService_1.default.activityTemplateObject.templateIndex)
	                .then(function (response) {
	                _this.context.router.transitionTo('activityConfigDetail', { id: eventService_1.default.activityTemplateObject.activityConfig.value });
	            }, function (error) {
	                eventService_1.default.activityTemplateObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            _this.context.router.transitionTo("activityTemplateDetail", { id: 'new' }, eventService_1.default.activityTemplateObject.activityConfig);
	        };
	        _this.onCopy = function (evt) {
	            console.log('onCopy');
	            _this.context.router.transitionTo("activityTemplateDetail", { id: 'copy' }, { copyId: eventService_1.default.activityTemplateObject.id });
	        };
	        _this.onChangeDefaultEmailBody = function (newValue) {
	            console.log('onChangeDefaultEmailBody');
	            eventService_1.default.activityTemplateObject.defaultEmailBody = newValue;
	            eventService_1.default.activityTemplateObject.$dirty = true;
	        };
	        _this.handleChange = function (value) {
	            console.log("handleChange " + value);
	            _this.activeTab = value;
	            _this[_this.activeTab]();
	        };
	        _this.onResize = function (evt) {
	            var bodyRect = document.body.getBoundingClientRect();
	            var _editorHeight = (0, domUtils_1.computeHeight)(bodyRect, _this.editorRef);
	            console.log('onResize ', _editorHeight);
	            if (_editorHeight > 0)
	                _this.editorHeight = _editorHeight;
	        };
	        _this.onEditorLoad = function (evt) {
	            console.log('onEditorLoad');
	            setTimeout(function () {
	                _this.onResize();
	                _this.editorRef.addEventListener('design:updated', function (data) {
	                    eventService_1.default.activityTemplateObject.$dirty = true;
	                });
	                if (eventService_1.default.activityTemplateObject.defaultEmailDesign)
	                    _this.editorRef.loadDesign(JSON.parse(eventService_1.default.activityTemplateObject.defaultEmailDesign));
	            }, 0);
	        };
	        _this.onChangeEditorType = function (evt, editorType) {
	            console.log('onChangeEditorType ', editorType);
	            _this.editorType = editorType;
	        };
	        return _this;
	    }
	    ActivityTemplateDetail.fetchData = function (routerParams, query) {
	        console.log("ActivityTemplateDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['ActivityTemplate', "DocumentTemplateResource"]);
	        var activityTemplatePromise;
	        if (routerParams.id === 'new') {
	            activityTemplatePromise = Promise.resolve(new eventDomain_1.ActivityTemplate({ $new: true, activityConfig: (0, formUtils_1.pickLov)(query) }));
	        }
	        else if (routerParams.id === 'copy') {
	            activityTemplatePromise = eventService_1.default.readActivityTemplate(query.copyId)
	                .then(function (activityTemplateObject) {
	                activityTemplateObject.cleanOnCopy();
	                activityTemplateObject.templateIndex = undefined;
	                return activityTemplateObject;
	            });
	        }
	        else {
	            activityTemplatePromise = eventService_1.default.readActivityTemplate(routerParams.id);
	        }
	        return Promise.all([metadataPromise, activityTemplatePromise])
	            .then(function (_a) {
	            var entityMap = _a[0], activityTemplateObject = _a[1];
	            eventService_1.default.activityTemplateObject = activityTemplateObject.initAfterRead(false);
	            if (eventService_1.default.activityTemplateObject.defaultEmailBody == null)
	                eventService_1.default.activityTemplateObject.defaultEmailBody = '';
	        });
	    };
	    ActivityTemplateDetail.prototype.componentWillMount = function () {
	        var _this = this;
	        __webpack_require__.e/* nsure */(0, function (require) {
	            if (AceEditor) {
	                return;
	            }
	            AceEditor = __webpack_require__(153).default;
	            var brace = __webpack_require__(133);
	            __webpack_require__(315);
	            __webpack_require__(147);
	            __webpack_require__(146);
	            _this.forceUpdate();
	        });
	        __webpack_require__.e/* nsure */(2, function (require) {
	            if (EmailEditor) {
	                return;
	            }
	            __webpack_require__(527);
	            EmailEditor = __webpack_require__(846);
	            _this.forceUpdate();
	        });
	    };
	    ActivityTemplateDetail.prototype.componentDidMount = function () {
	        console.debug("%c componentDidMount", "background-color: magenta");
	        this.onResizeDebounced = (0, utils_1.debounce)(this.onResize, 15, false);
	        window.addEventListener('resize', this.onResizeDebounced);
	    };
	    ActivityTemplateDetail.prototype.componentWillUnmount = function () {
	        window.removeEventListener('resize', this.onResizeDebounced);
	        eventService_1.default.activityTemplateObject = null;
	    };
	    ActivityTemplateDetail.prototype.findRootObject = function () {
	        return eventService_1.default.activityTemplateObject;
	    };
	    ActivityTemplateDetail.prototype.render = function () {
	        var _this = this;
	        var query = this.props.query;
	        var propsForCreateForm = {
	            dataObject: eventService_1.default.activityTemplateObject,
	            rootObject: eventService_1.default.activityTemplateObject,
	            entity: mdEntityService_1.default.getEntity('ActivityTemplate'),
	            entities: mdEntityService_1.default.entityMap
	        };
	        console.log('editorType', this.editorType);
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column', width: "100%" } },
	            this._createToolMenu(eventService_1.default.activityTemplateObject, query.gridLocation),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: eventService_1.default.activityTemplateObject.$errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	            react_1.default.createElement("form", { style: { marginTop: 10 } },
	                react_1.default.createElement(Tabs_1.default, { value: this.activeTab, onChange: this.handleChange },
	                    react_1.default.createElement(Tab_1.default, { label: "Configuration", value: "configuration" },
	                        react_1.default.createElement("div", { className: "row", style: { marginTop: 10 } },
	                            react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                                react_1.default.createElement(RadioButtonGroup_1.default, { name: "editorType", valueSelected: this.editorType, onChange: this.onChangeEditorType }, editorTypes.map(function (format, index) { return (react_1.default.createElement(RadioButton_1.default, { key: index, value: format.value, label: format.label, style: { display: 'inline-block', width: '25%' } })); })),
	                                react_1.default.createElement(activityTemplateForm_1.default, tslib_1.__assign({}, propsForCreateForm))),
	                            react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                                react_1.default.createElement(documentTemplateResourceList_1.default, { documentTemplateObject: eventService_1.default.activityTemplateObject, entities: mdEntityService_1.default.entityMap, showType: true })))),
	                    react_1.default.createElement(Tab_1.default, { label: "Simple Editor", value: "editorSimple", disabled: this.editorType !== 'simple' },
	                        react_1.default.createElement("div", { style: { marginTop: 10 } }, (AceEditor) ?
	                            react_1.default.createElement(AceEditor, { mode: "html", theme: "github", value: eventService_1.default.activityTemplateObject.defaultEmailBody, onChange: this.onChangeDefaultEmailBody, name: "DEFAULT_EMAIL_BODY", enableBasicAutocompletion: true, enableLiveAutocompletion: true, editorProps: { $blockScrolling: true }, width: "100%", maxLines: "Infinity", minLines: 10, style: { padding: '5px 0 0 0' }, height: this.editorHeight + "px", ref: this.aceEditorBodyRefHandler })
	                            : "Loading....")),
	                    react_1.default.createElement(Tab_1.default, { label: "Advanced Editor", value: "editorAdvanced", disabled: this.editorType !== 'advanced' },
	                        react_1.default.createElement("div", { style: { marginTop: 10 } }, (EmailEditor) ?
	                            react_1.default.createElement(EmailEditor, { ref: function (editor) { return _this.editorRef = editor; }, style: { height: this.editorHeight + "px" }, onLoad: this.onEditorLoad })
	                            : "Loading...."))))));
	    };
	    ActivityTemplateDetail.prototype.editorSimple = function () {
	    };
	    ActivityTemplateDetail.prototype.editorAdvanced = function () {
	    };
	    ActivityTemplateDetail.prototype.configuration = function () {
	    };
	    ActivityTemplateDetail.prototype._createToolMenu = function (activityTemplateObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: History.length <= 1 },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !activityTemplateObject.$dirty, label: "Save", permission: activityTemplateObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, disabled: activityTemplateObject.$new, label: "New", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onCopy, disabled: activityTemplateObject.$new, label: "Copy", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "ActivityTemplate", pageAncestor: this, onClick: this.onDelete, disabled: activityTemplateObject.$new, label: "Delete", permission: metaConstant_1.PERMISSION.Delete })));
	    };
	    ActivityTemplateDetail.module = metaConstant_1.MODULE.core;
	    ActivityTemplateDetail.title = 'Activity Template';
	    ActivityTemplateDetail.icon = 'file-code-o';
	    ActivityTemplateDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplateDetail.prototype, "editorType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplateDetail.prototype, "editorHeight", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ActivityTemplateDetail.prototype, "activeTab", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ActivityTemplateDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ActivityTemplateDetail.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ActivityTemplateDetail.prototype, "onChangeDefaultEmailBody", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ActivityTemplateDetail.prototype, "handleChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ActivityTemplateDetail.prototype, "onResize", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ActivityTemplateDetail.prototype, "onEditorLoad", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ActivityTemplateDetail.prototype, "onChangeEditorType", void 0);
	    ActivityTemplateDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ActivityTemplateDetail);
	    return ActivityTemplateDetail;
	}(pageAncestor_1.default));
	exports.default = ActivityTemplateDetail;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var formUtils_1 = __webpack_require__(14);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var blockComp_1 = __webpack_require__(30);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var rules_1 = __webpack_require__(56);
	var mobx_react_1 = __webpack_require__(4);
	var form_1 = __webpack_require__(52);
	var ActivityConfigForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ActivityConfigForm, _super);
	    function ActivityConfigForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ActivityConfigForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity;
	        var fields = dataObject.getFormFields(definition.formName);
	        var activityConfigId = fields.activityConfigId, activityName = fields.activityName, comment = fields.comment, activityType = fields.activityType, rootEntity = fields.rootEntity, location = fields.location, activityCategory = fields.activityCategory;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-5" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, activityConfigId.props, { disabled: !dataObject.$new })),
	                    react_1.default.createElement(validate_1.Validate, { field: activityConfigId, value: activityConfigId.props.value },
	                        react_1.default.createElement(rules_1.PrimaryKeyString, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-7" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, activityName.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: activityName, value: activityName.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, activityType.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: activityType, value: activityType.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, activityCategory.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: activityCategory, value: activityCategory.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, rootEntity.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: rootEntity, value: rootEntity.props.value, onSuccess: this.props.onRootEntitySuccess })),
	                react_1.default.createElement("div", { className: "fx col-xs-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, location.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props, { multiLine: true, rows: 2 }))))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true },
	            react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate }, this.props))));
	    };
	    ActivityConfigForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ActivityConfigForm);
	    return ActivityConfigForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
	        react_1.default.createElement("h5", { style: { marginTop: 0, fontSize: '18px', fontWeight: 'bold' } },
	            " ",
	            react_1.default.createElement("span", { className: "zz-grey-text" }, (0, formUtils_1.lovLabel)(dataObject.activityType)),
	            " ",
	            dataObject.activityName),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.activityCategory.textLabel, value: dataObject.activityCategory })),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.activityConfigId.textLabel, value: dataObject.activityConfigId }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.rootEntity.textLabel, value: dataObject.rootEntity }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.location.textLabel, value: dataObject.location })),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.comment.textLabel, value: dataObject.comment }))));
	};
	var definition = {
	    formName: 'ActivityConfigForm',
	    fields: [{
	            name: 'activityConfigId',
	            validators: ['IsRequired']
	        }, {
	            name: 'activityName',
	            validators: ['IsRequired']
	        }, {
	            name: 'comment',
	            displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	        }, {
	            name: 'activityType',
	            validators: ['IsRequired']
	        }, {
	            name: 'rootEntity',
	            validators: ['IsRequired']
	        }, {
	            name: 'location'
	        }, {
	            name: 'activityCategory',
	            validators: ['IsRequired']
	        }]
	};
	exports.default = (0, createForm_1.createForm)(definition, ClosedContent)(ActivityConfigForm);


/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var styledDateInterval_1 = tslib_1.__importDefault(__webpack_require__(130));
	var dateUtils_1 = __webpack_require__(49);
	var blockComp_1 = __webpack_require__(30);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var mobx_react_1 = __webpack_require__(4);
	var form_1 = __webpack_require__(52);
	var closedForm_1 = __webpack_require__(82);
	var ActivityTemplateForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ActivityTemplateForm, _super);
	    function ActivityTemplateForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ActivityTemplateForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entity = _a.entity, entities = _a.entities;
	        var fields = dataObject.getFormFields(definition.formName);
	        var comment = fields.comment, validFrom = fields.validFrom, validTo = fields.validTo, language = fields.language, defaultEmailSubject = fields.defaultEmailSubject, templateIndex = fields.templateIndex, profitCenter = fields.profitCenter, emailFrom = fields.emailFrom, replyTo = fields.replyTo, cc = fields.cc, bcc = fields.bcc, toAddress = fields.toAddress, activityPaths = fields.activityPaths, backOfficeEmail = fields.backOfficeEmail;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, profitCenter.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, language.props))),
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-4" },
	                    react_1.default.createElement(styledDateInterval_1.default, tslib_1.__assign({}, validFrom.props, { valueFrom: validFrom.props.value, valueTo: validTo.props.value, onChangeFrom: validFrom.props.onChange, onChangeTo: validTo.props.onChange })))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, emailFrom.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, replyTo.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, toAddress.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, cc.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, bcc.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, backOfficeEmail.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, activityPaths.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, defaultEmailSubject.props, { multiLine: true, rows: 2 })))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props, { multiLine: true, rows: 2 }))))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true },
	            react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, openClassName: "active-item", closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate }, this.props))));
	    };
	    ActivityTemplateForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ActivityTemplateForm);
	    return ActivityTemplateForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields },
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.templateIndex.textLabel, value: dataObject.templateIndex }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.language.textLabel, value: dataObject.language }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.profitCenter.textLabel, value: dataObject.profitCenter }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.validFrom.textLabel, value: (0, dateUtils_1.formatInterval)(dataObject.validFrom, dataObject.validTo) }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.emailFrom.textLabel, value: dataObject.emailFrom }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.replyTo.textLabel, value: dataObject.replyTo }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.toAddress.textLabel, value: dataObject.toAddress }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.cc.textLabel, value: dataObject.cc }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.bcc.textLabel, value: dataObject.bcc }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.backOfficeEmail.textLabel, value: dataObject.backOfficeEmail }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.activityPaths.textLabel, value: dataObject.activityPaths }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.defaultEmailSubject.textLabel, value: dataObject.defaultEmailSubject }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.comment.textLabel, value: dataObject.comment })));
	};
	var definition = {
	    formName: 'ActivityTemplateForm',
	    fields: [{
	            name: 'comment',
	            displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	        }, {
	            name: 'validFrom'
	        }, {
	            name: 'validTo'
	        }, {
	            name: 'profitCenter'
	        }, {
	            name: 'language'
	        }, {
	            name: 'emailFrom'
	        }, {
	            name: 'replyTo'
	        }, {
	            name: 'toAddress'
	        }, {
	            name: 'cc'
	        }, {
	            name: 'bcc'
	        }, {
	            name: 'backOfficeEmail'
	        }, {
	            name: 'activityPaths'
	        }, {
	            name: 'templateIndex'
	        }, {
	            name: 'defaultEmailSubject',
	            displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	        }]
	};
	exports.default = (0, createForm_1.createForm)(definition, ClosedContent)(ActivityTemplateForm);


/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_dom_1 = tslib_1.__importDefault(__webpack_require__(31));
	var react_bootstrap_1 = __webpack_require__(72);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var createForm_1 = __webpack_require__(18);
	var mobx_react_1 = __webpack_require__(4);
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var colors_1 = __webpack_require__(29);
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var formUtils_1 = __webpack_require__(14);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var mobx_1 = __webpack_require__(5);
	var commonDataService_1 = __webpack_require__(41);
	var PopoverStyled = (0, styled_components_1.default)(react_bootstrap_1.Popover)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    min-width: 200px;\n    z-index: 1600px;\n"], ["\n    min-width: 200px;\n    z-index: 1600px;\n"])));
	var TitleP = styled_components_1.default.p(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n    color: ", ";\n    font-size: 18px;\n"], ["\n    color: ", ";\n    font-size: 18px;\n"])), colors_1.grey400);
	var ButtonDiv = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-around;\n  margin-top: 10px;\n"], ["\n  display: flex;\n  justify-content: space-around;\n  margin-top: 10px;\n"])));
	var AssignDiv = styled_components_1.default.div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n"], ["\n    display: flex;\n    flex-direction: column;\n"])));
	var IconSpan = styled_components_1.default.span(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n    float: right;\n    cursor: pointer;\n    margin: 6px;\n"], ["\n    float: right;\n    cursor: pointer;\n    margin: 6px;\n"])));
	var AssignTaskComponent = /** @class */ (function (_super) {
	    tslib_1.__extends(AssignTaskComponent, _super);
	    function AssignTaskComponent() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            showPopover: false,
	            owner: null,
	            ownerError: null
	        };
	        _this.cancelPopover = function (evt) {
	            _this.setState({
	                showPopover: false,
	                owner: null,
	                ownerError: null
	            });
	        };
	        _this.onChangeOwner = function (ownerLov) {
	            _this.setState({ owner: ownerLov });
	        };
	        _this.onOpen = function (evt) {
	            _this.setState({
	                showPopover: true,
	                owner: null,
	                ownerError: null
	            });
	        };
	        _this.assignToMe = function (evt) {
	            console.log("assign to me");
	            return _this.props.onAssign(securityService_1.default.currentUser.username)
	                .then(function () {
	                _this.cancelPopover(null);
	            });
	        };
	        _this.assignToOther = function (evt) {
	            console.log("assign to other");
	            if (!_this.state.owner) {
	                _this.setState({ ownerError: 'Select User' });
	            }
	            else {
	                return _this.props.onAssign(_this.state.owner.value)
	                    .then(function () {
	                    _this.cancelPopover(null);
	                });
	            }
	        };
	        _this.buttonRefHandler = function (comp) { return _this.buttonRef = comp; };
	        _this.onHideHandler = function () { return _this.setState({ showPopover: false }); };
	        _this.targetHandler = function () { return react_dom_1.default.findDOMNode(_this.buttonRef); };
	        return _this;
	    }
	    AssignTaskComponent.prototype.render = function () {
	        var taskObject = this.props.taskObject;
	        return (react_1.default.createElement("div", { ref: this.buttonRefHandler },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onOpen, label: "Assign", permission: taskObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(react_bootstrap_1.Overlay, { show: this.state.showPopover, onHide: this.onHideHandler, rootClose: true, target: this.targetHandler, placement: "bottom" },
	                react_1.default.createElement(PopoverStyled, { id: "taskAssignPopover" },
	                    react_1.default.createElement(TitleP, null,
	                        react_1.default.createElement("span", null,
	                            react_1.default.createElement("span", null, "Assign Task"),
	                            " ",
	                            react_1.default.createElement(IconSpan, { className: "fa fa-close", onClick: this.cancelPopover }))),
	                    react_1.default.createElement(ButtonDiv, null,
	                        ((0, formUtils_1.lovValue)(taskObject.owner) !== securityService_1.default.currentUser.username || 1 === 1) ? react_1.default.createElement(buttons_1.ZzFlatButton, { label: "Assign to me", secondary: true, onClick: this.assignToMe }) : null,
	                        react_1.default.createElement(AssignDiv, null,
	                            react_1.default.createElement(buttons_1.ZzFlatButton, { label: "Assign to ...", secondary: true, onClick: this.assignToOther }),
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { style: tslib_1.__assign({ width: 200 }, createForm_1.fieldStyles.small.styledSelect.style), onChange: this.onChangeOwner, value: this.state.owner, async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'User', { currentTenantOnly: true }), clearable: true, asterixForAll: true, errorText: this.state.ownerError }))))))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], AssignTaskComponent.prototype, "onOpen", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], AssignTaskComponent.prototype, "assignToMe", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], AssignTaskComponent.prototype, "assignToOther", void 0);
	    AssignTaskComponent = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], AssignTaskComponent);
	    return AssignTaskComponent;
	}(react_1.default.Component));
	exports.default = AssignTaskComponent;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var Subject_1 = __webpack_require__(260);
	__webpack_require__(309);
	var eventService_1 = tslib_1.__importDefault(__webpack_require__(120));
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var historyBlocks_1 = __webpack_require__(263);
	var itemStream = new Subject_1.Subject();
	itemStream
	    .mergeMap(function (item) { return Promise.all([item, eventService_1.default.readEventHistory(item.rowId), mdEntityService_1.default.fetchEntityMetadata(['EventHistory', 'HistoryObject', 'HistoryObjectField'])]); }, null, 5)
	    .mergeMap(function (_a) {
	    var item = _a[0], eventHistory = _a[1], entityMap = _a[2];
	    return Promise.all([item, eventHistory, mdEntityService_1.default.fetchEntityMetadata(tslib_1.__spreadArray([eventHistory.entityName], eventHistory.historyObjects.map(function (ho) { return ho.entityName; }), true))]);
	})
	    .subscribe((0, mobx_1.action)("subscribe-actionCb", function (_a) {
	    var item = _a[0], eventHistory = _a[1], entityMap = _a[2];
	    item.rowObject = eventHistory;
	    item.expanded = 2;
	    console.log("EventExpando resolved event %s", eventHistory.eventHistoryId);
	}));
	var MDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-left: 24px;\n"], ["\n  margin-left: 24px;\n"])));
	var EventExpando = /** @class */ (function (_super) {
	    tslib_1.__extends(EventExpando, _super);
	    function EventExpando() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    EventExpando.prototype.componentDidMount = function () {
	        var item = this.props.item;
	        var eventHistory = item.rowObject;
	        if (!eventHistory) {
	            itemStream.next(item);
	        }
	    };
	    EventExpando.prototype.componentDidUpdate = function (prevProps, prevState) {
	        var item = this.props.item;
	        var eventHistory = item.rowObject;
	        if (!eventHistory && prevProps.item.rowId !== item.rowId) {
	            itemStream.next(item);
	        }
	    };
	    EventExpando.prototype.render = function () {
	        var item = this.props.item;
	        var eventHistory = item.rowObject;
	        console.log("EventExpando render vehicle %s, expanded = %s", (eventHistory) ? eventHistory.eventHistoryId : null, item.expanded);
	        if (item.expanded === 1) {
	            return (react_1.default.createElement(MDiv, null,
	                react_1.default.createElement("i", { className: "fa fa-refresh fa-2x fa-spin color-blue-grey-200" })));
	        }
	        return react_1.default.createElement(historyBlocks_1.EventHistoryBlock, { eventHistory: eventHistory, entities: mdEntityService_1.default.entityMap });
	    };
	    EventExpando = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EventExpando);
	    return EventExpando;
	}(react_1.default.Component));
	exports.default = EventExpando;
	var templateObject_1;


/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var styledDateInterval_1 = tslib_1.__importDefault(__webpack_require__(130));
	var dateUtils_1 = __webpack_require__(49);
	var blockComp_1 = __webpack_require__(30);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var mobx_react_1 = __webpack_require__(4);
	var form_1 = __webpack_require__(52);
	var closedForm_1 = __webpack_require__(82);
	var validate_1 = __webpack_require__(24);
	var EventTemplateForm = /** @class */ (function (_super) {
	    tslib_1.__extends(EventTemplateForm, _super);
	    function EventTemplateForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    EventTemplateForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entity = _a.entity, entities = _a.entities;
	        var fields = dataObject.getFormFields(definition.formName);
	        var comment = fields.comment, validFrom = fields.validFrom, validTo = fields.validTo, profitCenter = fields.profitCenter, language = fields.language, defaultEmailSubject = fields.defaultEmailSubject, templateIndex = fields.templateIndex, emailFrom = fields.emailFrom, replyTo = fields.replyTo, cc = fields.cc, bcc = fields.bcc, toAddress = fields.toAddress, toAddressCode = fields.toAddressCode, invoiceTypeIds = fields.invoiceTypeIds;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, profitCenter.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, language.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, invoiceTypeIds.props, { multi: true, floatingLabelStyle: { top: 15 } })),
	                    react_1.default.createElement(validate_1.Validate, { field: invoiceTypeIds, value: invoiceTypeIds.props.value })),
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                    react_1.default.createElement(styledDateInterval_1.default, tslib_1.__assign({}, validFrom.props, { valueFrom: validFrom.props.value, valueTo: validTo.props.value, onChangeFrom: validFrom.props.onChange, onChangeTo: validTo.props.onChange })))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, defaultEmailSubject.props, { multiLine: true, rows: 2 })))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, emailFrom.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, replyTo.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, toAddressCode.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, toAddress.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, cc.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, bcc.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props, { multiLine: true, rows: 2 }))))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true },
	            react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate }, this.props))));
	    };
	    EventTemplateForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EventTemplateForm);
	    return EventTemplateForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields },
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.templateIndex.textLabel, value: dataObject.templateIndex }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.language.textLabel, value: dataObject.language }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.invoiceTypeIds.textLabel, value: dataObject.invoiceTypeIds }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.profitCenter.textLabel, value: dataObject.profitCenter }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.validFrom.textLabel, value: (0, dateUtils_1.formatInterval)(dataObject.validFrom, dataObject.validTo) }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.emailFrom.textLabel, value: dataObject.emailFrom }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.replyTo.textLabel, value: dataObject.replyTo }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.toAddressCode.textLabel, value: dataObject.toAddressCode }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.toAddress.textLabel, value: dataObject.toAddress }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.cc.textLabel, value: dataObject.cc }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.bcc.textLabel, value: dataObject.bcc }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.defaultEmailSubject.textLabel, value: dataObject.defaultEmailSubject }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.comment.textLabel, value: dataObject.comment })));
	};
	var definition = {
	    formName: 'EventTemplateForm',
	    fields: [{
	            name: 'comment',
	            displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	        }, {
	            name: 'validFrom'
	        }, {
	            name: 'validTo'
	        }, {
	            name: 'profitCenter'
	        }, {
	            name: 'language'
	        }, {
	            name: 'emailFrom'
	        }, {
	            name: 'replyTo'
	        }, {
	            name: 'cc'
	        }, {
	            name: 'toAddress'
	        }, {
	            name: 'toAddressCode'
	        }, {
	            name: 'bcc'
	        }, {
	            name: 'templateIndex'
	        }, {
	            name: 'defaultEmailSubject',
	            displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	        }, {
	            name: 'invoiceTypeIds',
	            omitNullOption: true,
	        }]
	};
	exports.default = (0, createForm_1.createForm)(definition, ClosedContent)(EventTemplateForm);


/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var formUtils_1 = __webpack_require__(14);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var blockComp_1 = __webpack_require__(30);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var rules_1 = __webpack_require__(56);
	var eventDomain_1 = __webpack_require__(74);
	var mobx_react_1 = __webpack_require__(4);
	var form_1 = __webpack_require__(52);
	var mobx_1 = __webpack_require__(5);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var EventTypeForm = /** @class */ (function (_super) {
	    tslib_1.__extends(EventTypeForm, _super);
	    function EventTypeForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.eventTypeOnSuccess = function () {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            if (!dataObject.eventCategory && dataObject.eventType) {
	                dataObject.eventCategory = mdEntityService_1.default.getEntity("EVENTCATEGORY").getLovItem((0, formUtils_1.lovParam)(dataObject.eventType, "defaultEventCategory"));
	                form.updateFieldsPropValue(dataObject, "eventCategory");
	            }
	        };
	        return _this;
	    }
	    EventTypeForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity;
	        var fields = dataObject.getFormFields(definition.formName);
	        var eventTypeId = fields.eventTypeId, eventName = fields.eventName, comment = fields.comment, eventType = fields.eventType, eventCategory = fields.eventCategory, smsDeliveryReceipt = fields.smsDeliveryReceipt, smsDeliveryFailureAlert = fields.smsDeliveryFailureAlert;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, eventTypeId.props, { disabled: !dataObject.$new, autoFocus: true })),
	                    react_1.default.createElement(validate_1.Validate, { field: eventTypeId, value: eventTypeId.props.value },
	                        react_1.default.createElement(rules_1.PrimaryKeyString, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, eventName.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: eventName, value: eventName.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, eventType.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: eventType, value: eventType.props.value, onSuccess: this.eventTypeOnSuccess })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, eventCategory.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: eventCategory, value: eventCategory.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, smsDeliveryReceipt.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, smsDeliveryFailureAlert.props, { options: smsDeliveryFailureAlert.props.options.filter(function (lov) { return ((lov["eventCategory"] === eventDomain_1.EVENTCATEGORY.EMAIL_EVENT || lov["eventCategory"] === eventDomain_1.EVENTCATEGORY.SMS_EVENT)) || !lov.value; }) })))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props, { multiLine: true, rows: 2 }))))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true },
	            react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate }, this.props))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EventTypeForm.prototype, "eventTypeOnSuccess", void 0);
	    EventTypeForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EventTypeForm);
	    return EventTypeForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
	        react_1.default.createElement("h5", { style: { marginTop: 0, fontSize: '18px', fontWeight: 'bold' } },
	            " ",
	            react_1.default.createElement("span", { className: "zz-grey-text" }, (0, formUtils_1.lovLabel)(dataObject.eventType)),
	            " ",
	            dataObject.eventName),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.eventCategory.textLabel, value: dataObject.eventCategory }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.eventTypeId.textLabel, value: dataObject.eventTypeId })),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.smsDeliveryFailureAlert.textLabel, value: dataObject.smsDeliveryFailureAlert })),
	        react_1.default.createElement("div", { className: "form-text-row" }, (dataObject.smsDeliveryReceipt) ? fields.smsDeliveryReceipt.textLabel : ''),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.comment.textLabel, value: dataObject.comment }))));
	};
	var definition = {
	    formName: 'EventTypeForm',
	    fields: [{
	            name: 'eventTypeId',
	            validators: ['IsRequired']
	        }, {
	            name: 'eventName',
	            validators: ['IsRequired']
	        }, {
	            name: 'comment',
	            displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	        }, {
	            name: 'smsDeliveryReceipt',
	            displayType: form_1.FIELDDEFDISPLAYTYPE.checkbox
	        }, {
	            name: 'eventType',
	            validators: ['IsRequired']
	        }, {
	            name: 'eventCategory',
	            validators: ['IsRequired']
	        }, {
	            name: 'smsDeliveryFailureAlert'
	        }]
	};
	exports.default = (0, createForm_1.createForm)(definition, ClosedContent)(EventTypeForm);


/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var fields_1 = __webpack_require__(20);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var errorComp_1 = __webpack_require__(34);
	var formUtils_1 = __webpack_require__(14);
	var Stepper_1 = __webpack_require__(288);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var dialogAncestor_1 = __webpack_require__(87);
	var eventDomain_1 = __webpack_require__(74);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var historyBlocks_1 = __webpack_require__(263);
	var emailBodyEditor_1 = tslib_1.__importDefault(__webpack_require__(564));
	var draft_js_1 = __webpack_require__(202);
	var draft_js_export_html_1 = __webpack_require__(442);
	var eventService_1 = tslib_1.__importDefault(__webpack_require__(120));
	var draft_js_import_html_1 = __webpack_require__(1195);
	var htmlThumbnail_1 = __webpack_require__(2085);
	var GenerateActivityDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(GenerateActivityDialog, _super);
	    function GenerateActivityDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.prepare = function () {
	            console.log('Preparing generate activity');
	            commonService_1.default.loading(true);
	            var activityTemplate = _this.activityTemplates[_this.selectedTemplateIndex];
	            if (!activityTemplate.defaultEmailDesign)
	                _this.gridActivityDto.bodyTemplate = (0, draft_js_export_html_1.stateToHTML)(_this.editorState.getCurrentContent());
	            gridService_1.default.generateActivity(_this.grid, _this.gridActivityDto, 1)
	                .then((0, mobx_1.action)("prepare-action", function (newGridActivityDto) {
	                commonService_1.default.loading(false);
	                _this.gridActivityDto.part = 2;
	                _this.gridActivityDto.showErrors = true;
	                _this.gridActivityDto.statuses = newGridActivityDto.statuses;
	            }), function (error) {
	                _this.$errors = error.getMessages();
	            });
	        };
	        _this.ok = function () {
	            console.log('Issuing invoices');
	            commonService_1.default.loading(true);
	            var activityTemplate = _this.activityTemplates[_this.selectedTemplateIndex];
	            if (!activityTemplate.defaultEmailDesign)
	                _this.gridActivityDto.bodyTemplate = (0, draft_js_export_html_1.stateToHTML)(_this.editorState.getCurrentContent());
	            gridService_1.default.generateActivity(_this.grid, _this.gridActivityDto, 2)
	                .then((0, mobx_1.action)("generate-action", function (newGridActivityDto) {
	                commonService_1.default.loading(false);
	                newGridActivityDto.part = 3;
	                newGridActivityDto.showErrors = false;
	                _this.gridActivityDto = newGridActivityDto;
	            }), function (error) {
	                _this.$errors = error.getMessages();
	            });
	        };
	        _this.close = function () {
	            _this.gridActivityDto = null;
	            _this.resolve(null);
	        };
	        _this.cancel = function (evt) {
	            console.log('GenerateActivityDialog#cancel evt = %O', evt);
	            _this.gridActivityDto = null;
	            _this.reject(null);
	        };
	        _this.onShowErrors = function (evt) {
	            _this.gridActivityDto.showErrors = evt.target.checked;
	        };
	        _this.onChangeSubject = function (evt) {
	            _this.gridActivityDto.subjectTemplate = evt.target.value;
	        };
	        _this.onChangeBody = function (editorState) {
	            _this.editorState = editorState;
	        };
	        _this.handleThumbnail = function (index) {
	            _this.selectedTemplateIndex = index;
	            var activityTemplate = _this.activityTemplates[index];
	            _this.gridActivityDto.subjectTemplate = activityTemplate.defaultEmailSubject;
	            _this.gridActivityDto.bodyTemplate = activityTemplate.defaultEmailBody;
	            if (!activityTemplate.defaultEmailDesign) {
	                _this.editorState = (activityTemplate.defaultEmailBody) ? draft_js_1.EditorState.createWithContent((0, draft_js_import_html_1.stateFromHTML)(activityTemplate.defaultEmailBody)) : draft_js_1.EditorState.createEmpty();
	            }
	        };
	        return _this;
	    }
	    GenerateActivityDialog.prototype.open = function (resolve, reject, grid, activityConfigLov) {
	        var _this = this;
	        var entities = this.props.entities;
	        uiService_1.default.showToolbarActionFlag();
	        this.selectedTemplateIndex = undefined;
	        var gridParams = grid.createFullParams();
	        console.log('GenerateActivityDialog: Opening dialog for ', gridParams);
	        this.resolve = resolve;
	        this.reject = reject;
	        this.grid = grid;
	        Promise.all([mdEntityService_1.default.fetchEntities([{ entity: "ACTIVITYTYPE", lov: true }]), eventService_1.default.readActivityTemplates((0, formUtils_1.lovValue)(activityConfigLov))])
	            .then(function (_a) {
	            var entities = _a[0], activityTemplates = _a[1];
	            _this.activityTemplates = activityTemplates;
	            _this.gridActivityDto = new eventDomain_1.GridActivityDto({
	                activityConfigId: (0, formUtils_1.lovValue)(activityConfigLov),
	                gridId: grid.getActiveGridConfig().gridId,
	                type: mdEntityService_1.default.getEntity("ACTIVITYTYPE").getLovItem(eventDomain_1.ACTIVITYTYPE.EMAIL),
	                part: 1,
	                gridParams: gridParams,
	            });
	            if (activityTemplates.length === 1) {
	                _this.selectedTemplateIndex = 0;
	                _this.handleThumbnail(0);
	            }
	            _this.dialogOpen = true;
	            uiService_1.default.hideToolbarActionFlag();
	        })
	            .catch(function (error) {
	            _this.reject(error);
	        });
	    };
	    GenerateActivityDialog.prototype.componentWillUnmount = function () {
	        this.gridActivityDto = null;
	    };
	    GenerateActivityDialog.prototype.render = function () {
	        var _this = this;
	        var entities = this.props.entities;
	        if (!(this.gridActivityDto && this.dialogOpen))
	            return null;
	        var cancelButton = react_1.default.createElement(FlatButton_1.default, { label: "Cancel", key: 0, tabIndex: 0, primary: true, onClick: this.cancel });
	        var showErrorCheckbox = react_1.default.createElement(fields_1.MdCheckbox, { key: 1, label: "Show Errors", checked: this.gridActivityDto.showErrors, labelStyle: { whiteSpace: 'nowrap' }, style: { display: 'inline-block', width: 140, verticalAlign: 'middle' }, onCheck: this.onShowErrors });
	        var actions;
	        if (this.gridActivityDto.part === 1) {
	            actions = [cancelButton, react_1.default.createElement(FlatButton_1.default, { key: 2, label: "Prepare ".concat((0, formUtils_1.lovLabel)(this.gridActivityDto.type)), secondary: true, onClick: this.prepare })];
	        }
	        else if (this.gridActivityDto.part === 2) {
	            actions = [showErrorCheckbox, cancelButton, react_1.default.createElement(FlatButton_1.default, { key: 2, label: "Recheck", secondary: true, onClick: this.prepare }), react_1.default.createElement(FlatButton_1.default, { key: 3, label: "Send ".concat((0, formUtils_1.lovLabel)(this.gridActivityDto.type), " !"), secondary: true, onClick: this.ok })];
	        }
	        else if (this.gridActivityDto.part === 3) {
	            actions = [showErrorCheckbox, react_1.default.createElement(FlatButton_1.default, { key: 2, label: "Close", primary: true, onClick: this.close })];
	        }
	        console.debug("rendering GenerateActivityDialog ", this.gridActivityDto);
	        return (react_1.default.createElement(Dialog_1.default, { actions: actions, modal: true, open: this.dialogOpen, contentStyle: { width: '80%', maxWidth: 800 }, bodyStyle: { overflow: 'auto' } },
	            react_1.default.createElement(Stepper_1.Stepper, { activeStep: this.gridActivityDto.part - 1 },
	                react_1.default.createElement(Stepper_1.Step, null,
	                    react_1.default.createElement(Stepper_1.StepLabel, { className: "mui-stepper-icon-hack" }, " Check ")),
	                react_1.default.createElement(Stepper_1.Step, null,
	                    react_1.default.createElement(Stepper_1.StepLabel, { className: "mui-stepper-icon-hack" }, " Generate ")),
	                react_1.default.createElement(Stepper_1.Step, null,
	                    react_1.default.createElement(Stepper_1.StepLabel, { className: "mui-stepper-icon-hack" }, " Done "))),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: this.$errors }),
	            (this.gridActivityDto.part === 1) ?
	                (this.selectedTemplateIndex == null) ? (react_1.default.createElement("div", { style: { marginLeft: 10 } }, this.activityTemplates.map(function (at, i) { return (react_1.default.createElement(htmlThumbnail_1.HtmlThumbnail, { html: at.defaultEmailBody, onClick: _this.handleThumbnail.bind(_this, i), key: i })); }))) : (react_1.default.createElement("div", { style: { marginLeft: 10 } },
	                    react_1.default.createElement(fields_1.MdTextField, { value: this.gridActivityDto.subjectTemplate, onChange: this.onChangeSubject, fullWidth: true, hintText: "Subject" }),
	                    (this.activityTemplates[this.selectedTemplateIndex].defaultEmailDesign) ? (react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.activityTemplates[this.selectedTemplateIndex].defaultEmailBody } })) : (react_1.default.createElement(emailBodyEditor_1.default, { editorState: this.editorState, onChange: this.onChangeBody, style: { height: 500 } }))))
	                : (react_1.default.createElement("div", { style: { overflowY: 'auto', maxHeight: 500, fontSize: 13 } },
	                    react_1.default.createElement(historyBlocks_1.PartyActivityTable, { statuses: this.gridActivityDto.statuses, showErrors: this.gridActivityDto.showErrors })))));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GenerateActivityDialog.prototype, "gridActivityDto", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GenerateActivityDialog.prototype, "grid", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GenerateActivityDialog.prototype, "editorState", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GenerateActivityDialog.prototype, "selectedTemplateIndex", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GenerateActivityDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GenerateActivityDialog.prototype, "prepare", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GenerateActivityDialog.prototype, "ok", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GenerateActivityDialog.prototype, "close", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GenerateActivityDialog.prototype, "cancel", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GenerateActivityDialog.prototype, "onShowErrors", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GenerateActivityDialog.prototype, "onChangeSubject", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GenerateActivityDialog.prototype, "onChangeBody", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GenerateActivityDialog.prototype, "handleThumbnail", void 0);
	    GenerateActivityDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], GenerateActivityDialog);
	    return GenerateActivityDialog;
	}(dialogAncestor_1.SteppingDialogAncestor));
	exports.default = GenerateActivityDialog;


/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.HtmlThumbnail = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	__webpack_require__(1289);
	var HtmlThumbnail = function (_a) {
	    var html = _a.html, onClick = _a.onClick;
	    if (!html)
	        html = "<div>EMPTY BODY</div>";
	    return (react_1.default.createElement("div", { className: "thumbnail-container", onClick: onClick },
	        react_1.default.createElement("div", { className: "thumbnail" },
	            react_1.default.createElement("iframe", { srcDoc: html, frameBorder: "0" }))));
	};
	exports.HtmlThumbnail = HtmlThumbnail;


/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var formUtils_1 = __webpack_require__(14);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var mobx_react_1 = __webpack_require__(4);
	var createForm_1 = __webpack_require__(18);
	var colors_1 = __webpack_require__(29);
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var CCDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
	var TaskTypeSpan = styled_components_1.default.span(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject([" \n    color: ", "\n"], [" \n    color: ", "\n"])), colors_1.grey400);
	var TaskName = styled_components_1.default.h5(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n    margin-top: 0;\n    font-size: 22px;\n    font-weight: bold;\n"], ["\n    margin-top: 0;\n    font-size: 22px;\n    font-weight: bold;\n"])));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    var taskType = (0, formUtils_1.lovLabel)(dataObject.taskType);
	    return (react_1.default.createElement(CCDiv, null,
	        react_1.default.createElement(TaskName, null,
	            dataObject.name,
	            " ",
	            (taskType !== dataObject.name) ? react_1.default.createElement(TaskTypeSpan, null,
	                " (",
	                taskType,
	                ")") : null,
	            " ")));
	};
	var TaskForm = /** @class */ (function (_super) {
	    tslib_1.__extends(TaskForm, _super);
	    function TaskForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TaskForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity, formName = _a.formName;
	        var fields = dataObject.getFormFields(formName);
	        var name = fields.name;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "xs col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value })))));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }) }, this.props, { validate: this.props.validate })));
	    };
	    TaskForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'TaskForm',
	            fields: [{
	                    name: 'name',
	                    validators: ['IsRequired']
	                }
	            ]
	        }, ClosedContent),
	        mobx_react_1.observer
	    ], TaskForm);
	    return TaskForm;
	}(react_1.default.Component));
	exports.default = TaskForm;
	var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var eventExpando_1 = tslib_1.__importDefault(__webpack_require__(2081));
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'eventHistoryList';
	var EventList = /** @class */ (function (_super) {
	    tslib_1.__extends(EventList, _super);
	    function EventList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    EventList.fetchData = function (routerParams) {
	        console.log("EventList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gl) { return gridService_1.default.getOrCreateGrid(gridLocation); });
	    };
	    EventList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query, showExpand: true, ExpandComponent: eventExpando_1.default }));
	    };
	    EventList.module = metaConstant_1.MODULE.core;
	    EventList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Events"], ["Events"])));
	    EventList.icon = 'commenting';
	    EventList.rootPage = true;
	    EventList.protectedPage = true;
	    EventList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EventList);
	    return EventList;
	}(pageAncestor_1.default));
	exports.default = EventList;
	var templateObject_1;


/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var MenuItem_1 = tslib_1.__importDefault(__webpack_require__(101));
	var Drawer_1 = tslib_1.__importDefault(__webpack_require__(286));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var errorComp_1 = __webpack_require__(34);
	var formUtils_1 = __webpack_require__(14);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var eventService_1 = tslib_1.__importDefault(__webpack_require__(120));
	var eventTemplateForm_1 = tslib_1.__importDefault(__webpack_require__(2082));
	var documentTemplateResourceList_1 = tslib_1.__importDefault(__webpack_require__(565));
	var more_vert_1 = tslib_1.__importDefault(__webpack_require__(291));
	var icons_1 = __webpack_require__(63);
	var variables_1 = __webpack_require__(96);
	var validate_1 = __webpack_require__(24);
	var mdField_1 = tslib_1.__importDefault(__webpack_require__(57));
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var commonDataService_1 = __webpack_require__(41);
	var historyBlocks_1 = __webpack_require__(263);
	var fields_1 = __webpack_require__(20);
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var eventDomain_1 = __webpack_require__(74);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var mobx_1 = __webpack_require__(5);
	var buttons_1 = __webpack_require__(27);
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var mdField_2 = __webpack_require__(57);
	var mdField_3 = __webpack_require__(57);
	var form_1 = __webpack_require__(52);
	var locales_1 = __webpack_require__(15);
	var AceEditor;
	var EventTemplateDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(EventTemplateDetail, _super);
	    function EventTemplateDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            openTestDrawer: false
	        };
	        _this.aceEditorBodyRefHandler = function (c) { return _this._aceEditorBody = c; };
	        _this.customValidate = function (eventTemplateObject) {
	            var errors = [];
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave ');
	            uiService_1.default.showToolbarActionFlag();
	            if (!(0, formUtils_1.preSave)(eventService_1.default.eventTemplateObject, _this.customValidate)) {
	                return;
	            }
	            eventService_1.default.saveEventTemplate(eventService_1.default.eventTemplateObject.prepareForServer())
	                .then((0, mobx_1.action)("eventTemplateSave-callback", function (eventTemplateJson) {
	                var wasNew = eventService_1.default.eventTemplateObject.cleanAfterSave(eventTemplateJson);
	                if (wasNew) {
	                    _this.context.router.replaceWith('eventTemplateDetail', { id: eventService_1.default.eventTemplateObject.id });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            }), function (error) {
	                eventService_1.default.eventTemplateObject.$errors = error.getMessages();
	            });
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            eventService_1.default.deleteEventTemplate(eventService_1.default.eventTemplateObject.eventType.value, eventService_1.default.eventTemplateObject.templateIndex)
	                .then(function (response) {
	                _this.context.router.transitionTo('eventTypeDetail', { id: eventService_1.default.eventTemplateObject.eventType.value });
	            }, function (error) {
	                eventService_1.default.eventTemplateObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            _this.context.router.transitionTo("eventTemplateDetail", { id: 'new' }, eventService_1.default.eventTemplateObject.eventType);
	        };
	        _this.onChangeDefaultEmailBody = function (newValue) {
	            console.log('onChangeDefaultEmailBody');
	            eventService_1.default.eventTemplateObject.defaultEmailBody = newValue;
	            eventService_1.default.eventTemplateObject.$dirty = true;
	        };
	        _this.handleTest = function (evt) {
	            eventService_1.default.eventTemplateObject.$testObject = new eventDomain_1.EventTest();
	            _this.setState({ openTestDrawer: true });
	        };
	        _this.handleTestRequestChange = function (evt) {
	            _this.setState({ openTestDrawer: false });
	        };
	        return _this;
	    }
	    EventTemplateDetail.fetchData = function (routerParams, query) {
	        console.log("EventTemplateDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['EventTemplate', "DocumentTemplateResource"], [{ entity: 'MdEntity', lov: true }]);
	        var eventPromise;
	        if (routerParams.id === 'new') {
	            eventPromise = Promise.resolve(new eventDomain_1.EventTemplate({ $new: true, eventType: (0, formUtils_1.pickLov)(query) }));
	        }
	        else {
	            eventPromise = eventService_1.default.readEventTemplate(routerParams.id);
	        }
	        // webpack to takhle promisifikovane nezvladne, musi to byt normalne, je to v willMount
	        // const requireEnsure = (dependencies, filename) => new Promise((resolve, reject) => {
	        //     require.ensure(dependencies, resolve, filename);
	        //   });
	        //
	        // let requirePromise = requireEnsure(['brace', 'react-ace', 'brace/mode/xml', 'brace/theme/github'], 'reactAce');
	        return Promise.all([metadataPromise, eventPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], eventTemplateObject = _a[1];
	            eventService_1.default.eventTemplateObject = eventTemplateObject.initAfterRead(false);
	            if (eventService_1.default.eventTemplateObject.defaultEmailBody == null) {
	                eventService_1.default.eventTemplateObject.defaultEmailBody = '';
	            }
	        });
	    };
	    EventTemplateDetail.prototype.componentWillMount = function () {
	        var _this = this;
	        __webpack_require__.e/* nsure */(0, function (require) {
	            if (AceEditor) {
	                return;
	            }
	            AceEditor = __webpack_require__(153).default;
	            var brace = __webpack_require__(133);
	            __webpack_require__(315);
	            __webpack_require__(147);
	            __webpack_require__(146);
	            _this.forceUpdate();
	        });
	    };
	    EventTemplateDetail.prototype.componentWillUnmount = function () {
	        eventService_1.default.eventTemplateObject = null;
	    };
	    EventTemplateDetail.prototype.findRootObject = function () {
	        return eventService_1.default.eventTemplateObject;
	    };
	    EventTemplateDetail.prototype.render = function () {
	        var query = this.props.query;
	        var propsForCreateForm = {
	            dataObject: eventService_1.default.eventTemplateObject,
	            rootObject: eventService_1.default.eventTemplateObject,
	            entity: mdEntityService_1.default.getEntity('EventTemplate'),
	            entities: mdEntityService_1.default.entityMap
	        };
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	            this._createToolMenu(eventService_1.default.eventTemplateObject, query.gridLocation),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: eventService_1.default.eventTemplateObject.$errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	            (this.state.openTestDrawer) ?
	                react_1.default.createElement(EventTestDrawer, { entities: mdEntityService_1.default.entityMap, open: this.state.openTestDrawer, dataObject: eventService_1.default.eventTemplateObject.$testObject, rootObject: eventService_1.default.eventTemplateObject, onRequestChange: this.handleTestRequestChange }) : null,
	            react_1.default.createElement("form", { style: { marginTop: 10 } },
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                        react_1.default.createElement(eventTemplateForm_1.default, tslib_1.__assign({}, propsForCreateForm))),
	                    react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                        react_1.default.createElement(documentTemplateResourceList_1.default, { documentTemplateObject: eventService_1.default.eventTemplateObject, entities: mdEntityService_1.default.entityMap, showType: true }))),
	                react_1.default.createElement("div", null, "Email body template"),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12" }, (AceEditor) ?
	                        react_1.default.createElement(AceEditor, { mode: "html", theme: "github", value: eventService_1.default.eventTemplateObject.defaultEmailBody, onChange: this.onChangeDefaultEmailBody, name: "DEFAULT_EMAIL_BODY", enableBasicAutocompletion: true, enableLiveAutocompletion: true, editorProps: { $blockScrolling: true }, width: "100%", maxLines: "Infinity", minLines: 10, style: { padding: '5px 0 0 0' }, ref: this.aceEditorBodyRefHandler })
	                        : "Loading....")))));
	    };
	    EventTemplateDetail.prototype._createToolMenu = function (eventTemplateObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: History.length <= 1 },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !eventTemplateObject.$dirty, label: "Save", permission: eventTemplateObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, disabled: eventTemplateObject.$new, label: "New", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "EventTemplate", pageAncestor: this, onClick: this.onDelete, disabled: eventTemplateObject.$new, label: "Delete", permission: metaConstant_1.PERMISSION.Delete }),
	            react_1.default.createElement(icons_1.ZzIconButtonMenu, { buttonIcon: react_1.default.createElement(more_vert_1.default, null) },
	                react_1.default.createElement(MenuItem_1.default, { primaryText: "Test", key: 1, onClick: this.handleTest }))));
	    };
	    EventTemplateDetail.module = metaConstant_1.MODULE.core;
	    EventTemplateDetail.title = 'Event Template';
	    EventTemplateDetail.icon = 'file-code-o';
	    EventTemplateDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EventTemplateDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EventTemplateDetail.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EventTemplateDetail.prototype, "onChangeDefaultEmailBody", void 0);
	    EventTemplateDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EventTemplateDetail);
	    return EventTemplateDetail;
	}(pageAncestor_1.default));
	exports.default = EventTemplateDetail;
	var EventTestDrawer = /** @class */ (function (_super) {
	    tslib_1.__extends(EventTestDrawer, _super);
	    function EventTestDrawer() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleTest = function () {
	            var _a = _this.props, entities = _a.entities, dataObject = _a.dataObject, rootObject = _a.rootObject;
	            eventService_1.default.test(rootObject, dataObject.$mdEntity, (0, formUtils_1.lovValue)(dataObject.$testObject), !dataObject.$sendEmail)
	                .then(function (eventHistory) {
	                dataObject.$eventHistory = eventHistory;
	            });
	        };
	        return _this;
	    }
	    EventTestDrawer.prototype.render = function () {
	        var _a = this.props, entities = _a.entities, open = _a.open, onRequestChange = _a.onRequestChange, dataObject = _a.dataObject, rootObject = _a.rootObject, formName = _a.formName;
	        var _b = dataObject.getFormFields(formName), $mdEntity = _b.$mdEntity, $testObject = _b.$testObject, $sendEmail = _b.$sendEmail;
	        var screenWidth = document.body.getBoundingClientRect().width;
	        return (react_1.default.createElement(Drawer_1.default, { openSecondary: true, open: open, width: ((screenWidth < variables_1.screenSm) ? 0.9 : 0.6) * screenWidth, docked: true, onRequestChange: onRequestChange, containerStyle: { paddingTop: 40, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' } },
	            react_1.default.createElement("div", { style: { margin: 20 } },
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-12" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, $mdEntity.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: $mdEntity, value: $mdEntity.props.value }))),
	                (dataObject.$mdEntity) ? (react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-12" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, $testObject.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, (0, formUtils_1.lovValue)(dataObject.$mdEntity), {}), clearable: true })),
	                        react_1.default.createElement(validate_1.Validate, { field: $testObject, value: $testObject.props.value })))) : null,
	                (dataObject.$mdEntity) ? (react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, $sendEmail.props))))) : null,
	                (dataObject.$eventHistory) ? (react_1.default.createElement(historyBlocks_1.EmailEventHistory, { eventHistory: dataObject.$eventHistory })) : null),
	            react_1.default.createElement("div", { style: { margin: 20 } },
	                react_1.default.createElement(FlatButton_1.default, { label: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Close"], ["Close"]))), primary: true, onClick: onRequestChange }),
	                react_1.default.createElement(FlatButton_1.default, { label: locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["Test"], ["Test"]))), secondary: true, onClick: this.handleTest }))));
	    };
	    EventTestDrawer = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'EventTemplateTestForm',
	            fields: [{
	                    name: '$mdEntity',
	                    validators: ['IsRequired'],
	                    mdField: new mdField_1.default({ label: 'Type of object to test', valueSource: 'MdEntity', valueSourceType: mdField_2.VALUESOURCETYPE.LOCAL })
	                }, {
	                    name: '$testObject',
	                    validators: ['IsRequired'],
	                    mdField: new mdField_1.default({ label: 'Test Object', valueSourceType: mdField_2.VALUESOURCETYPE.ASYNC })
	                }, {
	                    name: '$sendEmail',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.checkbox,
	                    mdField: new mdField_1.default({ label: 'Send email', dataType: mdField_3.DATATYPE.BOOLEAN })
	                }]
	        }, function () { return react_1.default.createElement("noscript", null); }),
	        mobx_react_1.observer
	    ], EventTestDrawer);
	    return EventTestDrawer;
	}(react_1.default.Component));
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var Tabs_1 = tslib_1.__importDefault(__webpack_require__(107));
	var Tab_1 = tslib_1.__importDefault(__webpack_require__(102));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var icons_1 = __webpack_require__(63);
	var buttons_1 = __webpack_require__(27);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var mui_theme_1 = __webpack_require__(119);
	var errorComp_1 = __webpack_require__(34);
	var formUtils_1 = __webpack_require__(14);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridComp_1 = tslib_1.__importDefault(__webpack_require__(44));
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var eventService_1 = tslib_1.__importDefault(__webpack_require__(120));
	var eventTypeForm_1 = tslib_1.__importDefault(__webpack_require__(2083));
	var variables_1 = __webpack_require__(96);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var metaConstant_1 = __webpack_require__(13);
	var eventDomain_1 = __webpack_require__(74);
	var gridUtils_1 = __webpack_require__(83);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var gridComp_2 = __webpack_require__(44);
	var tenantSelectionSupport_1 = __webpack_require__(403);
	var locales_1 = __webpack_require__(15);
	var eventTemplateGridLocation = 'eventTemplateList';
	var tenantGridComposite = 'tenantGridComposite';
	var tenantGridLocation = 'tenantList';
	var tenantGroupListLocation = 'tenantGroupList';
	var EventTypeDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(EventTypeDetail, _super);
	    function EventTypeDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.customValidate = function (eventTypeObject) {
	            var errors = [];
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave ');
	            uiService_1.default.showToolbarActionFlag();
	            var result = (0, formUtils_1.preSave)(eventService_1.default.eventTypeObject, _this.customValidate);
	            if (!result) {
	                return;
	            }
	            eventService_1.default.saveEventType(eventService_1.default.eventTypeObject)
	                .then((0, mobx_1.action)("eventSave-callback", function (eventTypeJson) {
	                var wasNew = eventService_1.default.eventTypeObject.cleanAfterSave(eventTypeJson);
	                if (wasNew) {
	                    _this.context.router.replaceWith('eventTypeDetail', { id: eventService_1.default.eventTypeObject.eventTypeId });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            }), function (error) {
	                eventService_1.default.eventTypeObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            _this.context.router.transitionTo("eventTypeDetail", { id: 'new' });
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            eventService_1.default.deleteEventType(eventService_1.default.eventTypeObject.eventTypeId)
	                .then(function (response) {
	                _this.context.router.transitionTo('eventTypeList');
	            }, function (error) {
	                eventService_1.default.eventTypeObject.$errors = error.getMessages();
	            });
	        };
	        return _this;
	    }
	    EventTypeDetail.fetchData = function (routerParams, query) {
	        console.log("EventTypeDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['EventType']);
	        var eventPromise;
	        if (routerParams.id === 'new') {
	            eventPromise = Promise.resolve(new eventDomain_1.EventType({ $new: true }));
	        }
	        else {
	            eventPromise = eventService_1.default.readEventType(routerParams.id);
	        }
	        var gridPromise = gridService_1.default.fetchGrids(eventTemplateGridLocation, tenantGridLocation, tenantGroupListLocation);
	        return Promise.all([metadataPromise, eventPromise, gridPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], eventTypeObject = _a[1], gridLocationMap = _a[2];
	            eventTypeObject.$movingBlocks = new gridUtils_1.MovingBlocks(tenantGridComposite, true, query.tab, new grid_1.default(gridLocationMap.get(eventTemplateGridLocation), eventTypeObject.eventTypeId), new gridUtils_1.GridComposite(tenantGridComposite, 'Tenant selection', new grid_1.default(gridLocationMap.get(tenantGridLocation)), new grid_1.default(gridLocationMap.get(tenantGroupListLocation))));
	            eventService_1.default.eventTypeObject = eventTypeObject.initAfterRead(false);
	        });
	    };
	    EventTypeDetail.prototype.componentWillMount = function () {
	        uiService_1.default.addMediaQueryListener(this.mediaQueryListener);
	    };
	    /**
	     * tohle je tady kvuli prechodu na jiny detail invoice (chained details)
	     * @param prevProps
	     */
	    EventTypeDetail.prototype.componentDidUpdate = function (prevProps) {
	        if (this.idChanged(prevProps.params.id, this.props.params.id)) {
	            eventService_1.default.eventTypeObject.$movingBlocks.searchExposedGrids(eventService_1.default.eventTypeObject);
	        }
	    };
	    EventTypeDetail.prototype.componentDidMount = function () {
	        console.debug("%c componentDidMount", "background-color: magenta");
	        eventService_1.default.eventTypeObject.$movingBlocks.searchExposedGrids(eventService_1.default.eventTypeObject);
	    };
	    EventTypeDetail.prototype.componentWillUnmount = function () {
	        uiService_1.default.removeMediaQueryListener(this.mediaQueryListener);
	        eventService_1.default.eventTypeObject = null;
	    };
	    EventTypeDetail.prototype.findRootObject = function () {
	        return eventService_1.default.eventTypeObject;
	    };
	    EventTypeDetail.prototype.render = function () {
	        var _this = this;
	        var query = this.props.query;
	        var propsForCreateForm = {
	            dataObject: eventService_1.default.eventTypeObject,
	            rootObject: eventService_1.default.eventTypeObject,
	            entity: mdEntityService_1.default.getEntity('EventType'),
	            entities: mdEntityService_1.default.entityMap
	        };
	        console.debug('%c eventTypeDetail render query %O', 'background-color: yellow', this.props.query);
	        var mainForm = (react_1.default.createElement("form", { style: { marginTop: 10 } },
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12" },
	                    react_1.default.createElement(eventTypeForm_1.default, tslib_1.__assign({}, propsForCreateForm))))));
	        var movingBlocks = eventService_1.default.eventTypeObject.$movingBlocks;
	        var gridCompArray = [
	            react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(eventTemplateGridLocation), uiLocation: movingBlocks.getUiLocation(eventTemplateGridLocation), entities: mdEntityService_1.default.entityMap },
	                react_1.default.createElement(icons_1.ZzIconButtonRoute, { big: true, routeName: "eventTemplateDetail", params: { id: 'new' }, query: eventService_1.default.eventTypeObject.createLov(), securable: "eventTemplateDetail", permission: metaConstant_1.PERMISSION.New },
	                    react_1.default.createElement(add_1.default, null))),
	            react_1.default.createElement(gridComp_2.GridCompositeComp, { grid: movingBlocks.getBlock(tenantGridComposite), uiLocation: movingBlocks.getUiLocation(tenantGridComposite) },
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6", style: { padding: 10 } },
	                    react_1.default.createElement("h4", null, "Select Tenants"),
	                    react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(tenantGridComposite).groupMembers[0], multiSelect: false, hideToolbar: true, gridClassName: "detail-grid", uiLocation: movingBlocks.getUiLocation(tenantGridComposite), functionMap: { getSelectTenant: tenantSelectionSupport_1.getSelectTenant.bind(this, eventService_1.default.eventTypeObject), setSelectTenant: tenantSelectionSupport_1.setSelectTenant.bind(this, eventService_1.default.eventTypeObject) }, entities: mdEntityService_1.default.entityMap })),
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6", style: { padding: 10 } },
	                    react_1.default.createElement("h4", null, "or select Tenant Groups"),
	                    react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(tenantGridComposite).groupMembers[1], multiSelect: false, hideToolbar: true, gridClassName: "detail-grid", uiLocation: movingBlocks.getUiLocation(tenantGridComposite), functionMap: { getSelectTenantGroup: tenantSelectionSupport_1.getSelectTenantGroup.bind(this, eventService_1.default.eventTypeObject), setSelectTenantGroup: tenantSelectionSupport_1.setSelectTenantGroup.bind(this, eventService_1.default.eventTypeObject) }, entities: mdEntityService_1.default.entityMap })))
	        ];
	        var standAloneGridComp = movingBlocks.pluckStandAloneBlock(gridCompArray);
	        var tabArray = gridCompArray.map(function (gridComp) { return (react_1.default.createElement(Tab_1.default, { label: gridComp.props.grid.label, style: variables_1.tabStyle, onActive: _this.activateTab.bind(_this, gridComp.props.grid), key: gridComp.props.grid.getBlockName(), value: gridComp.props.grid.getBlockName() }, gridComp)); });
	        var tabs = (tabArray.length) ? (react_1.default.createElement(Tabs_1.default, { value: movingBlocks.activeBlockTab, className: "detail-grid", tabTemplate: mui_theme_1.TabTemplate, inkBarStyle: { transition: 'inherit' }, contentContainerStyle: { width: '100%', flexGrow: 1, display: 'flex', minHeight: 0 }, onChange: this.onTabChange }, tabArray)) : '';
	        if (uiService_1.default.globalMediaQuery.matches) {
	            return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'row' } },
	                react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', height: '100%', width: '50%' } },
	                    this._createToolMenu(eventService_1.default.eventTypeObject, query.gridLocation),
	                    react_1.default.createElement(errorComp_1.ErrorComp, { messages: eventService_1.default.eventTypeObject.$errors }),
	                    react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	                    react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	                    mainForm,
	                    tabs),
	                standAloneGridComp));
	        }
	        else {
	            return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	                this._createToolMenu(eventService_1.default.eventTypeObject, query.gridLocation),
	                react_1.default.createElement(errorComp_1.ErrorComp, { messages: eventService_1.default.eventTypeObject.$errors }),
	                react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	                react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	                mainForm,
	                tabs));
	        }
	    };
	    EventTypeDetail.prototype._createToolMenu = function (eventTypeObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: History.length <= 1, activeTab: eventTypeObject.$movingBlocks.activeBlockTab },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !eventTypeObject.$dirty, label: "Save", permission: eventTypeObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, disabled: eventTypeObject.$new, label: "New", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "EventType", pageAncestor: this, onClick: this.onDelete, disabled: eventTypeObject.$new, label: "Delete", permission: metaConstant_1.PERMISSION.Delete })));
	    };
	    EventTypeDetail.module = metaConstant_1.MODULE.core;
	    EventTypeDetail.title = 'Event Type';
	    EventTypeDetail.icon = 'send';
	    EventTypeDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EventTypeDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EventTypeDetail.prototype, "onDelete", void 0);
	    EventTypeDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EventTypeDetail);
	    return EventTypeDetail;
	}(pageAncestor_1.default));
	exports.default = EventTypeDetail;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var routes_1 = __webpack_require__(75);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'eventTypeList';
	var EventTypeList = /** @class */ (function (_super) {
	    tslib_1.__extends(EventTypeList, _super);
	    function EventTypeList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    EventTypeList.fetchData = function (routerParams) {
	        console.log("EventTypeList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    EventTypeList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "eventTypeDetail", params: { id: 'new' }, label: "New Event Type", permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.eventTypeDetail })));
	    };
	    EventTypeList.module = metaConstant_1.MODULE.core;
	    EventTypeList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Event Types"], ["Event Types"])));
	    EventTypeList.icon = 'send';
	    EventTypeList.rootPage = true;
	    EventTypeList.protectedPage = true;
	    EventTypeList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EventTypeList);
	    return EventTypeList;
	}(pageAncestor_1.default));
	exports.default = EventTypeList;
	var templateObject_1;


/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var errorComp_1 = __webpack_require__(34);
	var alertComp_1 = __webpack_require__(2055);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var react_router_1 = __webpack_require__(65);
	var eventDomain_1 = __webpack_require__(74);
	var eventService_1 = tslib_1.__importDefault(__webpack_require__(120));
	var taskForm_1 = tslib_1.__importDefault(__webpack_require__(2086));
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var formUtils_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(37);
	var react_router_2 = __webpack_require__(65);
	var taskActivityBlocks_1 = __webpack_require__(933);
	var blockComp_1 = __webpack_require__(30);
	var arrayUtils_1 = __webpack_require__(78);
	var mobx_1 = __webpack_require__(5);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var historyBlocks_1 = __webpack_require__(263);
	var buttons_1 = __webpack_require__(27);
	var loading_1 = __webpack_require__(262);
	__webpack_require__(452);
	var noteDialog_1 = tslib_1.__importDefault(__webpack_require__(2052));
	var assignTaskComponent_1 = tslib_1.__importDefault(__webpack_require__(2080));
	var colors_1 = __webpack_require__(29);
	var locales_1 = __webpack_require__(15);
	var TForm = styled_components_1.default.form(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-top: 10px;\n"], ["\n  margin-top: 10px;\n"])));
	var SectionDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  margin-left: 20px;\n  margin-bottom: 10px;\n"], ["\n  margin-left: 20px;\n  margin-bottom: 10px;\n"])));
	var ConnectedPersonsH5 = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n    margin-left: 20px;\n    font-size: 18px;\n    color: ", "\n"], ["\n    margin-left: 20px;\n    font-size: 18px;\n    color: ", "\n"])), colors_1.grey400);
	var TaskHistoryDiv = styled_components_1.default.div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n    margin-left: 20px;\n    font-size: 24px;\n    color: ", "\n"], ["\n    margin-left: 20px;\n    font-size: 24px;\n    color: ", "\n"])), colors_1.grey300);
	var TaskDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(TaskDetail, _super);
	    function TaskDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.histories = [];
	        _this.customValidate = function (taskObject) {
	            var errors = [];
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave ');
	            uiService_1.default.showToolbarActionFlag();
	            var result = (0, formUtils_1.preSave)(eventService_1.default.taskObject, _this.customValidate);
	            if (!result) {
	                return;
	            }
	            return eventService_1.default.updateTask(eventService_1.default.taskObject)
	                .then((0, mobx_1.action)("taskSave-callback", function (taskJson) {
	                taskJson.objects = eventService_1.default.taskObject.objects;
	                taskJson.partyActivities = eventService_1.default.taskObject.partyActivities;
	                var wasNew = eventService_1.default.taskObject.cleanAfterSave(taskJson);
	                if (wasNew) {
	                    _this.context.router.replaceWith('taskDetail', { id: eventService_1.default.taskObject.taskId });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	                return _this.createHistories(eventService_1.default.taskObject.taskId, true);
	            }), function (error) {
	                eventService_1.default.taskObject.$errors = error.getMessages();
	            });
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            eventService_1.default.deleteTask(eventService_1.default.taskObject.taskId)
	                .then(function (response) {
	                _this.goBackOrHome();
	            }, function (error) {
	                eventService_1.default.taskObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAddNote = function (evt) {
	            console.log('onAddNote');
	            return Promise.resolve((eventService_1.default.taskObject.$new) ? _this.onSave(null) : null)
	                .then(function () {
	                return new Promise(function (resolve, reject) {
	                    _this.noteDialogRef.open(resolve, reject);
	                }).then(function (note) {
	                    console.log('Add note ' + note);
	                    uiService_1.default.showToolbarActionFlag();
	                    var taskNote = new eventDomain_1.TaskNote({ task: eventService_1.default.taskObject.createLov(), content: note }).initAfterRead(true);
	                    return eventService_1.default.createTaskNote(taskNote)
	                        .then(function (taskJson) {
	                        eventService_1.default.taskObject.cleanAfterSave(taskJson);
	                        uiService_1.default.hideToolbarActionFlag();
	                        return _this.createHistories(eventService_1.default.taskObject.taskId, false);
	                    });
	                }).catch(function (e) {
	                });
	            });
	        };
	        _this.onReopen = function (evt) {
	            console.log('onReopen');
	            uiService_1.default.showToolbarActionFlag();
	            return eventService_1.default.reopenTask(eventService_1.default.taskObject.taskId)
	                .then((0, mobx_1.action)("taskReopen-callback", function (taskJson) {
	                eventService_1.default.taskObject.cleanAfterSave(taskJson);
	                uiService_1.default.hideToolbarActionFlag();
	                return _this.createHistories(eventService_1.default.taskObject.taskId, true);
	            }), function (error) {
	                eventService_1.default.taskObject.$errors = error.getMessages();
	            });
	        };
	        _this.onClose = function (evt) {
	            console.log('onClose');
	            new Promise(function (resolve, reject) {
	                _this.closeDialogRef.open(resolve, reject);
	            }).then(function (note) {
	                console.log('Close ' + note);
	                uiService_1.default.showToolbarActionFlag();
	                var taskNote = new eventDomain_1.TaskNote({ task: eventService_1.default.taskObject.createLov(), content: note }).initAfterRead(true);
	                return eventService_1.default.closeTask(taskNote)
	                    .then(function (taskJson) {
	                    eventService_1.default.taskObject.cleanAfterSave(taskJson);
	                    uiService_1.default.hideToolbarActionFlag();
	                    return _this.createHistories(eventService_1.default.taskObject.taskId, false);
	                });
	            }).catch(function (e) {
	            });
	        };
	        _this.onAssign = function (username) {
	            console.log('onAssign ' + username);
	            uiService_1.default.showToolbarActionFlag();
	            return eventService_1.default.assignTask(eventService_1.default.taskObject.taskId, username)
	                .then((0, mobx_1.action)("taskAssign-callback", function (taskJson) {
	                eventService_1.default.taskObject.cleanAfterSave(taskJson);
	                uiService_1.default.hideToolbarActionFlag();
	                //commonService.notifySuccess(null, "Task reassigned", content);
	                return _this.createHistories(eventService_1.default.taskObject.taskId, true);
	            }), function (error) {
	                eventService_1.default.taskObject.$errors = error.getMessages();
	            });
	        };
	        _this.noteDialogRefHandler = function (comp) { return _this.noteDialogRef = comp; };
	        _this.closeDialogRefHandler = function (comp) { return _this.closeDialogRef = comp; };
	        return _this;
	    }
	    TaskDetail.fetchData = function (routerParams, query) {
	        console.log("TaskDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['Task', 'TaskNote', 'EventHistory', 'HistoryObject', 'HistoryObjectField']);
	        var taskPromise;
	        if (routerParams.id === 'new') {
	            taskPromise = Promise.resolve(new eventDomain_1.Task({ $new: true, active: true }));
	        }
	        else {
	            taskPromise = eventService_1.default.readTask(routerParams.id);
	        }
	        return Promise.all([metadataPromise, taskPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], taskObject = _a[1];
	            eventService_1.default.taskObject = taskObject.initAfterRead(routerParams.id === 'new');
	        });
	    };
	    TaskDetail.prototype.createHistories = function (id, reloadEventHistory) {
	        var _this = this;
	        return Promise.resolve((this.eventHistories && !reloadEventHistory) ? this.eventHistories : eventService_1.default.readHistory("Task", id))
	            .then(function (eventHistories) {
	            _this.eventHistories = eventHistories;
	            var histories = eventHistories.concat(eventService_1.default.taskObject.notes.map(function (note) { return ({
	                icon: (note.closingNote) ? "Close" : "EventNote",
	                name: (note.closingNote) ? "TASK CLOSED" : "NOTE",
	                userCreated: note.userCreated,
	                dateCreated: note.dateCreated,
	                objectElement: react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: note.content } })
	            }); }));
	            _this.histories = histories.sort(function (a, b) { return (new Date(a.dateCreated).getTime() - new Date(b.dateCreated).getTime()); });
	            _this.loadingHistories = false;
	        });
	    };
	    TaskDetail.prototype.componentWillMount = function () {
	        this.loadingHistories = true;
	    };
	    TaskDetail.prototype.componentDidUpdate = function (prevProps) {
	        if (this.idChanged(prevProps.params.id, this.props.params.id)) {
	            this.loadingHistories = true;
	            return this.createHistories(this.props.params.id, true);
	        }
	    };
	    TaskDetail.prototype.componentDidMount = function () {
	        console.debug("%c componentDidMount", "background-color: magenta");
	        if (this.properId(this.props.params.id)) {
	            return this.createHistories(this.props.params.id, true);
	        }
	    };
	    TaskDetail.prototype.componentWillUnmount = function () {
	        eventService_1.default.taskObject = null;
	        this.eventHistories = null;
	        this.histories = null;
	    };
	    TaskDetail.prototype.findRootObject = function () {
	        return eventService_1.default.taskObject;
	    };
	    TaskDetail.prototype.render = function () {
	        var query = this.props.query;
	        var propsForCreateForm = {
	            dataObject: eventService_1.default.taskObject,
	            rootObject: eventService_1.default.taskObject,
	            entity: mdEntityService_1.default.getEntity('Task'),
	            entities: mdEntityService_1.default.entityMap
	        };
	        console.debug('%c taskDetail render query %O', 'background-color: yellow', this.props.query);
	        return (react_1.default.createElement("main", { className: "main-content" },
	            this._createToolMenu(eventService_1.default.taskObject, query.gridLocation),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: eventService_1.default.taskObject.$errors }),
	            react_1.default.createElement(alertComp_1.EmailSentComp, { level: "info", objekt: eventService_1.default.taskObject }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	            react_1.default.createElement(noteDialog_1.default, { ref: this.noteDialogRefHandler, title: "Add Note" }),
	            react_1.default.createElement(noteDialog_1.default, { ref: this.closeDialogRefHandler, title: "Close Task" }),
	            react_1.default.createElement("div", { className: "row zz-mt-10" },
	                react_1.default.createElement("div", { className: "col-xs-12 col-md-6 block-comp-right-border" },
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "col-xs-12" },
	                            react_1.default.createElement(TForm, null,
	                                react_1.default.createElement(taskForm_1.default, tslib_1.__assign({}, propsForCreateForm))))),
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                            react_1.default.createElement(ConnectedPersonsH5, null, "Customer"),
	                            react_1.default.createElement(SectionDiv, null,
	                                react_1.default.createElement(react_router_2.Link, { to: "partyDetail", params: { id: (0, formUtils_1.lovValue)(eventService_1.default.taskObject.customer) }, query: (0, utils_1.addTenantToQuery)() }, (0, formUtils_1.lovLabel)(eventService_1.default.taskObject.customer)))),
	                        react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                            react_1.default.createElement(ConnectedPersonsH5, null, "Owner"),
	                            react_1.default.createElement(SectionDiv, null, (0, formUtils_1.lovLabel)(eventService_1.default.taskObject.owner)))),
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                            react_1.default.createElement(ConnectedPersonsH5, null, "Connected Persons"),
	                            react_1.default.createElement(SectionDiv, null, eventService_1.default.taskObject.persons.map(function (p) { return (react_1.default.createElement("div", { key: p.value },
	                                react_1.default.createElement(react_router_2.Link, { to: "partyDetail", params: { id: (0, formUtils_1.lovValue)(p) }, query: (0, utils_1.addTenantToQuery)() }, (0, formUtils_1.lovLabel)(p)))); }))),
	                        (eventService_1.default.taskObject.objects.length) ? (react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                            react_1.default.createElement(ConnectedPersonsH5, null, "Connected Objects"),
	                            react_1.default.createElement(SectionDiv, null, eventService_1.default.taskObject.objects.map(function (to) { return (react_1.default.createElement("div", { key: to.taskObjectId },
	                                react_1.default.createElement(react_router_2.Link, { to: mdEntityService_1.default.getEntityDetailRoute(to.entityName), params: { id: (0, formUtils_1.lovValue)(to.fullObject) }, query: (0, utils_1.addTenantToQuery)() }, (0, formUtils_1.lovLabel)(to.fullObject)))); })))) : null),
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "col-xs-12" },
	                            react_1.default.createElement(ConnectedPersonsH5, null, "Activities"),
	                            react_1.default.createElement(SectionDiv, null, (0, arrayUtils_1.addSeparator)(eventService_1.default.taskObject.partyActivities.map(function (pa) { return (react_1.default.createElement("div", { key: pa.partyActivityId },
	                                react_1.default.createElement(taskActivityBlocks_1.ActivityBlock, { activity: pa }))); }), react_1.default.createElement(blockComp_1.MdDivider, { inset: true })))))),
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                    react_1.default.createElement(TaskHistoryDiv, null, "TASK HISTORY"),
	                    (this.loadingHistories) ? react_1.default.createElement(loading_1.LoadingElement, null) :
	                        ((this.histories && this.histories.length) ?
	                            (0, arrayUtils_1.addSeparator)(this.histories.map(function (taskHistory, index) { return ((taskHistory instanceof eventDomain_1.EventHistory) ? react_1.default.createElement(historyBlocks_1.EventHistoryBlock, { eventHistory: taskHistory, entities: mdEntityService_1.default.entityMap, key: index }) : react_1.default.createElement(historyBlocks_1.CustomHistoryBlock, tslib_1.__assign({}, taskHistory, { key: index }))); }), react_1.default.createElement(blockComp_1.MdDivider, { inset: true })) : null)))));
	    };
	    TaskDetail.prototype._createToolMenu = function (taskObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: react_router_1.History.length <= 1, entityName: "Task", entityId: taskObject.taskId },
	            ((0, formUtils_1.lovValue)(taskObject.taskStatus) !== eventDomain_1.TASKSTATUS.CLOSED) ?
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !taskObject.$dirty, label: "Save", permission: taskObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }) : null,
	            ((0, formUtils_1.lovValue)(taskObject.taskStatus) !== eventDomain_1.TASKSTATUS.CLOSED) ?
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAddNote, label: "Add Note", permission: taskObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }) : null,
	            ((0, formUtils_1.lovValue)(taskObject.taskStatus) !== eventDomain_1.TASKSTATUS.CLOSED) ? react_1.default.createElement(assignTaskComponent_1.default, { taskObject: taskObject, onAssign: this.onAssign }) : null,
	            (!taskObject.$new && (0, formUtils_1.lovValue)(taskObject.taskStatus) === eventDomain_1.TASKSTATUS.OPEN) ?
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onClose, label: "Close", permission: metaConstant_1.PERMISSION.Update }) : null,
	            (!taskObject.$new && (0, formUtils_1.lovValue)(taskObject.taskStatus) === eventDomain_1.TASKSTATUS.CLOSED) ?
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onReopen, label: "Reopen", permission: metaConstant_1.PERMISSION.Update }) : null,
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "Task", pageAncestor: this, onClick: this.onDelete, disabled: taskObject.$new, label: "Delete", permission: metaConstant_1.PERMISSION.Delete })));
	    };
	    TaskDetail.module = metaConstant_1.MODULE.core;
	    TaskDetail.title = 'Task';
	    TaskDetail.icon = 'tasks';
	    TaskDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskDetail.prototype, "loadingHistories", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskDetail.prototype, "eventHistories", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], TaskDetail.prototype, "histories", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], TaskDetail.prototype, "componentWillUnmount", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], TaskDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], TaskDetail.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], TaskDetail.prototype, "onAddNote", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], TaskDetail.prototype, "onReopen", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], TaskDetail.prototype, "onClose", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], TaskDetail.prototype, "onAssign", void 0);
	    TaskDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], TaskDetail);
	    return TaskDetail;
	}(pageAncestor_1.default));
	exports.default = TaskDetail;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;


/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'taskList';
	var TaskList = /** @class */ (function (_super) {
	    tslib_1.__extends(TaskList, _super);
	    function TaskList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TaskList.fetchData = function (routerParams) {
	        console.log("TaskList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gl) { return gridService_1.default.getOrCreateGrid(gridLocation); });
	    };
	    TaskList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query }));
	    };
	    TaskList.module = metaConstant_1.MODULE.core;
	    TaskList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Tasks"], ["Tasks"])));
	    TaskList.icon = 'tasks';
	    TaskList.rootPage = true;
	    TaskList.protectedPage = true;
	    TaskList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], TaskList);
	    return TaskList;
	}(pageAncestor_1.default));
	exports.default = TaskList;
	var templateObject_1;


/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var RaisedButton_1 = tslib_1.__importDefault(__webpack_require__(152));
	var fields_1 = __webpack_require__(20);
	var remove = __webpack_require__(485);
	var arrayUtils_1 = __webpack_require__(78);
	var gridConfigColumn_1 = tslib_1.__importDefault(__webpack_require__(935));
	var createForm_1 = __webpack_require__(18);
	var chevron_left_1 = tslib_1.__importDefault(__webpack_require__(779));
	var chevron_right_1 = tslib_1.__importDefault(__webpack_require__(780));
	var expand_less_1 = tslib_1.__importDefault(__webpack_require__(781));
	var expand_more_1 = tslib_1.__importDefault(__webpack_require__(782));
	var mobx_1 = __webpack_require__(5);
	var FaSearch = __webpack_require__(526);
	var react_bootstrap_1 = __webpack_require__(72);
	var colors_1 = __webpack_require__(29);
	__webpack_require__(1291);
	var mobx_react_1 = __webpack_require__(4);
	var mdField_1 = __webpack_require__(57);
	var domUtils_1 = __webpack_require__(91);
	var locales_1 = __webpack_require__(15);
	var __buttonStyle = { width: 40, minWidth: 40, marginTop: 5, marginBottom: 5 };
	var ColumnSelector = /** @class */ (function (_super) {
	    tslib_1.__extends(ColumnSelector, _super);
	    function ColumnSelector() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            lastClickedIndex: null,
	            availableColumnsSearchTerm: ""
	        };
	        /* ****************   EVENT HENDLERS ************************************************************ */
	        _this.onClickPridat = function () {
	            var _a = _this.props, gridConfig = _a.gridConfig, entity = _a.entity;
	            var selectedFields = entity.getFields().filter(function (field) { return field.$selected; });
	            console.log('onClickPridat selectedFields: %O', selectedFields);
	            selectedFields.forEach(function (field) {
	                field.$selected = undefined;
	                gridConfig.columns.push(new gridConfigColumn_1.default(gridConfig, { field: field }));
	            });
	        };
	        _this.onClickOdstranit = function () {
	            var _a = _this.props, gridConfig = _a.gridConfig, entity = _a.entity;
	            var selectedFields = gridConfig.columns.filter(function (field) { return field.$selected; });
	            console.log('onClickOdstranit selectedFields: %O', selectedFields);
	            selectedFields.forEach(function (gcc) {
	                gcc.$selected = undefined;
	                remove(gridConfig.columns, function (c) { return c.field.fieldKey === gcc.field.fieldKey; });
	            });
	        };
	        _this.onClickUp = function () {
	            var _a = _this.props, gridConfig = _a.gridConfig, entity = _a.entity;
	            var copy = gridConfig.columns.slice(0);
	            for (var i = 0; i < copy.length; i++) {
	                if (copy[i].$selected) {
	                    if (i < 1)
	                        return;
	                    (0, arrayUtils_1.moveItem)(gridConfig.columns, i, i - 1);
	                }
	            }
	        };
	        _this.onClickDown = function () {
	            var _a = _this.props, gridConfig = _a.gridConfig, entity = _a.entity;
	            var copy = gridConfig.columns.slice(0);
	            for (var i = copy.length - 1; i >= 0; i--) {
	                if (copy[i].$selected) {
	                    if (i >= copy.length - 1)
	                        return;
	                    (0, arrayUtils_1.moveItem)(gridConfig.columns, i, i + 1);
	                }
	            }
	        };
	        _this.handleSelectedItemClick = function (obj, index, objArray, evt) {
	            console.log('handleSelectedItemClick ', evt.ctrlKey);
	            var lastIndex = _this.state.lastClickedIndex;
	            if (evt.ctrlKey) {
	                obj.$selected = !obj.$selected;
	            }
	            else if (evt.shiftKey && lastIndex != null) {
	                for (var i = 0; i < objArray.length; i++) {
	                    objArray[i].$selected = (i >= Math.min(lastIndex, index) && i <= Math.max(lastIndex, index));
	                }
	            }
	            else {
	                objArray.forEach(function (o) { return o.$selected = undefined; });
	                obj.$selected = true;
	            }
	            _this.setState({ lastClickedIndex: index });
	        };
	        _this.handleSelectedItemMouseEnter = function (obj, index, objArray, evt) {
	            if (evt.button === 1 || evt.buttons === 1) {
	                obj.$selected = true;
	                _this.forceUpdate();
	            }
	        };
	        _this.onSearchAvailableColumns = function (evt) {
	            console.log("onSearchAvailableColumns: evt = %s", evt.target.value);
	            _this.setState({ availableColumnsSearchTerm: evt.target.value });
	        };
	        _this.onCheckSum = function (obj, evt, checked) {
	            console.log('onCheckSum obj = ', obj, checked);
	            obj.sum = checked;
	        };
	        _this.onCheckAvg = function (obj, evt, checked) {
	            console.log('onCheckAvg obj = ', obj, checked);
	            obj.avg = checked;
	        };
	        return _this;
	    }
	    ColumnSelector.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, gridConfig = _a.gridConfig, entity = _a.entity, disabled = _a.disabled;
	        var availableColumnsSearchTerm = this.state.availableColumnsSearchTerm;
	        var selectedObjects = gridConfig.columns;
	        var selectedObjectsNames = selectedObjects.map(function (v) { return v.field.fieldName; });
	        var allObjects = entity.getFields().filter(function (field) { return field.visible && !selectedObjectsNames.includes(field.fieldName)
	            && (!availableColumnsSearchTerm || field.label.toLowerCase().includes(availableColumnsSearchTerm.toLowerCase())); });
	        return (react_1.default.createElement("div", { className: "columnSelector" },
	            react_1.default.createElement("div", { className: "selectbox-wrapper" },
	                react_1.default.createElement("div", { className: "selectbox-search-wrapper" },
	                    react_1.default.createElement("span", null, locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Available Columns"], ["Available Columns"])))),
	                    react_1.default.createElement("div", { className: "selectbox-search" },
	                        react_1.default.createElement(react_bootstrap_1.FormControl, { type: "text", onChange: this.onSearchAvailableColumns, value: availableColumnsSearchTerm }),
	                        react_1.default.createElement(FaSearch, { style: { position: 'absolute', top: 2, right: 2, color: colors_1.grey400 } }))),
	                react_1.default.createElement("ul", { className: "selectbox" }, allObjects.map(function (obj, index) {
	                    return (react_1.default.createElement("li", { key: index, value: obj.fieldName, className: (0, domUtils_1.classNames)('selectbox-item', { 'selectbox-item--selected': obj.$selected }), onClick: _this.handleSelectedItemClick.bind(_this, obj, index, allObjects), onMouseEnter: _this.handleSelectedItemMouseEnter.bind(_this, obj, index, allObjects), onMouseLeave: _this.handleSelectedItemMouseEnter.bind(_this, obj, index, allObjects) },
	                        react_1.default.createElement("span", null, obj.label)));
	                }))),
	            react_1.default.createElement("div", { className: "addbuttons" },
	                react_1.default.createElement(RaisedButton_1.default, { style: __buttonStyle, primary: true, onClick: this.onClickPridat, icon: react_1.default.createElement(chevron_right_1.default, null), disabled: disabled }),
	                react_1.default.createElement(RaisedButton_1.default, { style: __buttonStyle, primary: true, onClick: this.onClickOdstranit, icon: react_1.default.createElement(chevron_left_1.default, null), disabled: disabled })),
	            react_1.default.createElement("div", { className: "selectbox-wrapper" },
	                react_1.default.createElement("div", { className: "selectbox-header" },
	                    react_1.default.createElement("div", { style: { flexGrow: 1 } }, locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Grid Columns"], ["Grid Columns"])))),
	                    react_1.default.createElement("div", { style: { width: 40 } }, locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Sum"], ["Sum"])))),
	                    react_1.default.createElement("div", { style: { width: 62 } }, locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["Avg"], ["Avg"]))))),
	                react_1.default.createElement("ul", { className: "selectbox" }, selectedObjects.map(function (obj, index) {
	                    return (react_1.default.createElement("li", { key: index, value: obj.field.fieldName, className: (0, domUtils_1.classNames)('selectbox-item', { 'selectbox-item--selected': obj.$selected }), onClick: _this.handleSelectedItemClick.bind(_this, obj, index, selectedObjects), onMouseEnter: _this.handleSelectedItemMouseEnter.bind(_this, obj, index, allObjects), onMouseLeave: _this.handleSelectedItemMouseEnter.bind(_this, obj, index, allObjects) },
	                        react_1.default.createElement("span", { style: { flexGrow: 1 } }, obj.label),
	                        (obj.field.fieldKey && (obj.field.dataType === mdField_1.DATATYPE.NUMBER || obj.field.dataType === mdField_1.DATATYPE.NUMBERCURRENCY || obj.field.dataType === mdField_1.DATATYPE.DURATION || obj.field.dataType === mdField_1.DATATYPE.BOOLEAN)) ?
	                            react_1.default.createElement(fields_1.MdCheckbox, { style: Object.assign(createForm_1.fieldStyles.small.default.style, { width: 'inherit', height: 25 }), name: "sum", checked: obj.sum, onCheck: _this.onCheckSum.bind(_this, obj) })
	                            : null,
	                        (obj.field.fieldKey && (obj.field.dataType === mdField_1.DATATYPE.NUMBER || obj.field.dataType === mdField_1.DATATYPE.NUMBERCURRENCY || obj.field.dataType === mdField_1.DATATYPE.DURATION || obj.field.dataType === mdField_1.DATATYPE.BOOLEAN)) ?
	                            react_1.default.createElement(fields_1.MdCheckbox, { style: Object.assign(createForm_1.fieldStyles.small.default.style, { width: 'inherit', height: 25 }), name: "Avg", checked: obj.avg, onCheck: _this.onCheckAvg.bind(_this, obj) })
	                            : null));
	                }))),
	            react_1.default.createElement("div", { className: "sortbuttons" },
	                react_1.default.createElement(RaisedButton_1.default, { style: __buttonStyle, primary: true, onClick: this.onClickUp, icon: react_1.default.createElement(expand_less_1.default, null), disabled: disabled }),
	                react_1.default.createElement(RaisedButton_1.default, { style: __buttonStyle, primary: true, onClick: this.onClickDown, icon: react_1.default.createElement(expand_more_1.default, null), disabled: disabled }))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ColumnSelector.prototype, "onClickPridat", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ColumnSelector.prototype, "onClickOdstranit", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ColumnSelector.prototype, "onClickUp", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ColumnSelector.prototype, "onClickDown", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ColumnSelector.prototype, "handleSelectedItemClick", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ColumnSelector.prototype, "handleSelectedItemMouseEnter", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ColumnSelector.prototype, "onSearchAvailableColumns", void 0);
	    ColumnSelector = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ColumnSelector);
	    return ColumnSelector;
	}(react_1.default.Component));
	exports.default = ColumnSelector;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var SelectField_1 = tslib_1.__importDefault(__webpack_require__(493));
	var MenuItem_1 = tslib_1.__importDefault(__webpack_require__(101));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var gridConfig_1 = tslib_1.__importDefault(__webpack_require__(264));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridAdminComp_1 = tslib_1.__importDefault(__webpack_require__(934));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var mobx_react_1 = __webpack_require__(4);
	var metaConstant_1 = __webpack_require__(13);
	var mobx_1 = __webpack_require__(5);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var storage_1 = __webpack_require__(173);
	var locales_1 = __webpack_require__(15);
	var GridAdminView = /** @class */ (function (_super) {
	    tslib_1.__extends(GridAdminView, _super);
	    function GridAdminView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /* ****************   EVENT HENDLERS ************************************************************ */
	        _this.onChangeGridConfig = function (evt, key, gridId) {
	            console.log('onChangeGridConfig gridId = %s', gridId);
	            var gridConfig = _this.gridObject.getGridConfig(gridId);
	            gridService_1.default.fetchConditionLovs(gridConfig.conditions)
	                .then(function (entityMap) {
	                gridService_1.default.gridConfig = gridConfig;
	                _this.context.router.replaceWith("gridAdmin", { gridLocation: _this.gridObject.gridLocation, gridId: gridConfig.gridId });
	            });
	        };
	        _this.onClickSave = function (evt) {
	            console.log('onClickSave %O', gridService_1.default.gridConfig);
	            uiService_1.default.showToolbarActionFlag();
	            _this.gridAdminCompRef.save()
	                .then(function (newGridConfig) {
	                if (newGridConfig) {
	                    _this.context.router.replaceWith("gridAdmin", { gridLocation: _this.gridObject.gridLocation, gridId: newGridConfig.gridId });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            });
	        };
	        _this.onClickAdd = function (evt) {
	            console.log('onClickAdd');
	            _this.context.router.transitionTo("gridAdmin", { gridLocation: _this.gridObject.gridLocation, gridId: 'new' });
	        };
	        _this.onClickCopy = function (evt) {
	            console.log('onClickCopy');
	            _this.context.router.transitionTo("gridAdmin", { gridLocation: _this.gridObject.gridLocation, gridId: 'copy' }, { copyId: gridService_1.default.gridConfig.gridId });
	        };
	        _this.onClickDelete = function (evt) {
	            console.log('onClickDelete ' + gridService_1.default.gridConfig.gridId);
	            axios_config_1.default.delete('/core/grid-config/' + gridService_1.default.gridConfig.gridId)
	                .then(function (response) {
	                _this.gridObject.deleteGridConfig(gridService_1.default.gridConfig.gridId);
	                (0, storage_1.removeItemFromLocalStorage)("GridLocation", locales_1.loc.lang, gridService_1.default.gridConfig.gridLocation);
	                _this.context.router.transitionTo("gridAdmin", { gridLocation: _this.gridObject.gridLocation });
	                gridService_1.default.gridConfig = null;
	            });
	        };
	        _this.onClickBack = function () {
	            console.log('onClickBack');
	            var ok = _this.context.router.goBack();
	            if (!ok) {
	                _this.context.router.transitionTo(_this.props.params.gridLocation);
	            }
	        };
	        _this.gridAdminCompRefHandler = function (comp) { return _this.gridAdminCompRef = comp; };
	        return _this;
	    }
	    GridAdminView.prototype.prepareGridConfig = function (grid, gridId, copiedGridId) {
	        if (gridId === 'new') {
	            return gridConfig_1.default.newInstance(grid.$gridLocationRef);
	        }
	        else if (gridId === 'copy') {
	            var copiedGridConfig = grid.getGridConfig(copiedGridId).clone();
	            copiedGridConfig.cleanOnCopy();
	            copiedGridConfig.configLevel = mdEntityService_1.default.getEntity("CONFIGLEVEL").getLovItem(metaConstant_1.CONFIGLEVEL.USER);
	            copiedGridConfig.tenant = null;
	            copiedGridConfig.tenantGroup = null;
	            copiedGridConfig.defaultGrid = undefined;
	            return copiedGridConfig;
	        }
	        else {
	            return grid.getGridConfig(gridId);
	        }
	    };
	    GridAdminView.prototype.componentDidMount = function () {
	        var _this = this;
	        var gridConfig;
	        var _a = this.props, params = _a.params, query = _a.query;
	        var mdEntityPromise = mdEntityService_1.default.fetchEntities([{ entity: "CONFIGLEVEL", lov: true }, { entity: "Tenant", lov: true }, { entity: "TenantGroup", lov: true }, { entity: "GRIDROWCSS", lov: true }]);
	        var gridLocationPromise = gridService_1.default.fetchGrids(params.gridLocation);
	        Promise.all([mdEntityPromise, gridLocationPromise])
	            .then(function (_a) {
	            var entities = _a[0], gridLocationMap = _a[1];
	            _this.gridObject = gridService_1.default.getGrid(params.gridLocation);
	            if (!_this.gridObject)
	                _this.gridObject = new grid_1.default(gridLocationMap.get(params.gridLocation));
	            if (params.gridId) {
	                gridConfig = _this.prepareGridConfig(_this.gridObject, params.gridId, query.copyId);
	                gridService_1.default.gridConfig = gridConfig;
	                return (gridConfig) ? gridService_1.default.fetchConditionLovs(gridConfig.conditions) : Promise.resolve(null);
	            }
	            else {
	                return Promise.resolve(null);
	            }
	        })
	            .then(function (entityMap) { return (gridConfig && gridConfig.conditions) ? gridConfig.conditions.forEach(function (cond) { return _this.gridAdminCompRef.setupConditionField(cond, true); }) : null; });
	    };
	    GridAdminView.prototype.componentWillReceiveProps = function (nextProps) {
	        console.debug("GridAdminView componentWillReceiveProps");
	        if (this.props.params.gridId !== nextProps.params.gridId) {
	            gridService_1.default.gridConfig = this.prepareGridConfig(this.gridObject, nextProps.params.gridId, nextProps.query.copyId);
	            ;
	        }
	    };
	    GridAdminView.prototype.componentWillUnmount = function () {
	        gridService_1.default.gridConfig = null;
	        this.gridObject = null;
	    };
	    /* ****************   REACT METHODS ************************************************************ */
	    GridAdminView.prototype.render = function () {
	        if (!this.gridObject)
	            return react_1.default.createElement("noscript", null);
	        var toolMenu = this._createToolMenu(gridService_1.default.gridConfig);
	        var gridConfigItems = this.gridObject.gridConfigs.map(function (gc, i) { return react_1.default.createElement(MenuItem_1.default, { value: gc.gridId, key: i, primaryText: gc.label }); });
	        console.debug('gridAdminView render gridConfig : %O', gridService_1.default.gridConfig);
	        return (react_1.default.createElement("main", { className: "main-content container" },
	            toolMenu,
	            react_1.default.createElement("h4", { className: "zauzoo", style: { marginTop: 20 } }, locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Grid Management"], ["Grid Management"])))),
	            react_1.default.createElement(SelectField_1.default, { value: (gridService_1.default.gridConfig) ? gridService_1.default.gridConfig.gridId : null, style: { fontSize: 14, marginLeft: 10 }, menuItemStyle: { fontSize: 14 }, onChange: this.onChangeGridConfig, disabled: gridService_1.default.gridConfig && gridService_1.default.gridConfig.$new, hintText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Choose Grid"], ["Choose Grid"]))), autoComplete: "off" }, gridConfigItems),
	            (gridService_1.default.gridConfig) ? react_1.default.createElement(gridAdminComp_1.default, { ref: this.gridAdminCompRefHandler, gridLocation: this.gridObject.$gridLocationRef, grid: this.gridObject, gridConfig: gridService_1.default.gridConfig, entities: mdEntityService_1.default.entityMap }) : null));
	    };
	    /* ****************   NORMAL METHODS ************************************************************ */
	    GridAdminView.prototype._createToolMenu = function (gridConfig) {
	        var disabled = gridService_1.default.computeConfigLevels(this.gridObject.$gridLocationRef, gridConfig).disabled;
	        return (react_1.default.createElement(toolmenu_1.default, { backAction: this.onClickBack, backDisabled: false },
	            (gridConfig && !disabled) ? (react_1.default.createElement(FlatButton_1.default, { onClick: this.onClickSave, label: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Save grid"], ["Save grid"]))) })) : react_1.default.createElement("noscript", null),
	            react_1.default.createElement(FlatButton_1.default, { onClick: this.onClickAdd, label: locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["Create new grid"], ["Create new grid"]))) }),
	            (gridConfig) ? (react_1.default.createElement(FlatButton_1.default, { onClick: this.onClickCopy, label: locales_1.loc.i18n(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["Copy grid"], ["Copy grid"]))) })) : react_1.default.createElement("noscript", null),
	            (gridConfig && !disabled) ? (react_1.default.createElement(FlatButton_1.default, { onClick: this.onClickDelete, label: locales_1.loc.i18n(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["Delete grid"], ["Delete grid"]))) })) : react_1.default.createElement("noscript", null)));
	    };
	    GridAdminView.title = locales_1.loc.i18n(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["Manage Grid"], ["Manage Grid"])));
	    GridAdminView.icon = 'wrench';
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridAdminView.prototype, "gridObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminView.prototype, "onChangeGridConfig", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminView.prototype, "onClickSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridAdminView.prototype, "onClickDelete", void 0);
	    GridAdminView = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], GridAdminView);
	    return GridAdminView;
	}(pageAncestor_1.default));
	exports.default = GridAdminView;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;


/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_dom_1 = tslib_1.__importDefault(__webpack_require__(31));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var react_bootstrap_1 = __webpack_require__(72);
	var gridConfigCondition_1 = tslib_1.__importDefault(__webpack_require__(194));
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var conditionValueForm_1 = tslib_1.__importStar(__webpack_require__(401));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var formUtils_1 = __webpack_require__(14);
	var createForm_1 = __webpack_require__(18);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var colors_1 = __webpack_require__(29);
	var domUtils_1 = __webpack_require__(91);
	var TitleP = styled_components_1.default.p(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    color: ", ";\n    font-size: 18px;\n"], ["\n    color: ", ";\n    font-size: 18px;\n"])), colors_1.grey400);
	var GridHeader = /** @class */ (function (_super) {
	    tslib_1.__extends(GridHeader, _super);
	    function GridHeader() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            showFilterIcon: !!_this.props.conditionObject,
	            showFilterPopover: false,
	            conditionObject: _this.props.conditionObject
	        };
	        _this.filterIconRefHandler = function (comp) {
	            _this.filterIconRef = comp;
	        };
	        _this._onClickLink = function (evt) {
	            var _a = _this.props, field = _a.field, sortObject = _a.sortObject;
	            console.log('_onClickLink %s - %o', field.fieldName, sortObject);
	            var newSortObject = {
	                field: field,
	                desc: (sortObject) ? !sortObject.desc : false
	            };
	            _this.props.onClickLink(newSortObject);
	        };
	        _this.onClickFilter = function (evt) {
	            var field = _this.props.field;
	            console.log('onClickFilter: %o', field);
	            var conditionObject = _this.state.conditionObject;
	            if (!conditionObject) {
	                conditionObject = new gridConfigCondition_1.default(_this.props.gridConfig, null);
	                conditionObject.field = field;
	                if (field.defaultOperator) {
	                    _this.onChangeConditionOperator(conditionObject, field.defaultOperator);
	                }
	            }
	            var entitiesToFetch = [];
	            if (field.hasLocalValueSource())
	                entitiesToFetch.push({ entity: field.valueSource, lov: true });
	            mdEntityService_1.default.fetchEntities(entitiesToFetch)
	                .then(function (entityMap) {
	                conditionObject.convertToLov();
	                _this.setState({ showFilterPopover: true, conditionObject: conditionObject });
	            });
	        };
	        _this.onChangeConditionValues = function (conditionObject) {
	            console.log('onChangeConditionValues: condition %O', conditionObject);
	            _this.setState({ conditionObject: conditionObject });
	        };
	        _this.onMouseOver = function (evt) {
	            if (!_this.props.conditionObject)
	                _this.setState({ showFilterIcon: true });
	        };
	        _this.onMouseOut = function (evt) {
	            if (!_this.props.conditionObject)
	                _this.setState({ showFilterIcon: false });
	        };
	        _this.cancelPopover = function (evt) {
	            _this.setState({ showFilterPopover: false });
	        };
	        _this.submitCondition = function (evt) {
	            evt.preventDefault();
	            var allOperators = _this.props.entities.get('FILTEROPERATOR').lovItems;
	            var conditionObject = _this.state.conditionObject;
	            var form = conditionObject.getForm("ConditionValueForm");
	            if (form.validateForm(conditionObject) && gridService_1.default.validateCondition(conditionObject, [], 0, allOperators)) {
	                _this.props.grid.updateGridConditions(conditionObject, _this.props.field);
	                _this.props.refreshGrid();
	                _this.setState({ showFilterPopover: false });
	            }
	            else {
	                _this.setState({ conditionObject: conditionObject });
	            }
	        };
	        _this.clearCondition = function (evt) {
	            _this.props.grid.updateGridConditions(null, _this.props.field);
	            _this.props.refreshGrid();
	            _this.setState({ showFilterPopover: false });
	        };
	        _this.onHideHandler = function () {
	            _this.setState({ showFilterPopover: false });
	        };
	        _this.overlayTargetHandler = function () { return react_dom_1.default.findDOMNode(_this.filterIconRef); };
	        _this.extractFieldFnHandler = function (dataObject, fieldDef) { return dataObject.field; };
	        return _this;
	    }
	    GridHeader.prototype.componentWillReceiveProps = function (nextProps) {
	        if (!!nextProps.conditionObject !== !!this.props.conditionObject || nextProps.conditionObject !== this.props.conditionObject) {
	            this.setState({
	                showFilterIcon: !!nextProps.conditionObject,
	                conditionObject: nextProps.conditionObject
	            });
	        }
	    };
	    GridHeader.prototype.onChangeConditionOperator = function (conditionObject, newOperator) {
	        newOperator = (0, formUtils_1.lovValue)(newOperator);
	        console.log('onChangeConditionOperator: ', newOperator, conditionObject);
	        conditionObject.operator = newOperator;
	        if (newOperator) {
	            var allOperators = this.props.entities.get('FILTEROPERATOR').lovItems;
	            var operatorLov = allOperators.find(function (v) { return v.value === newOperator; });
	            conditionObject.values = (operatorLov.inputCount === 'N') ? [] : new Array(parseInt(operatorLov.inputCount));
	        }
	        else {
	            conditionObject.values = [];
	        }
	        conditionObject.getForm("ConditionValueForm").updateFieldsPropValue(conditionObject, "field0", "field1", "fieldMulti");
	        this.setState({ conditionObject: conditionObject });
	    };
	    ;
	    GridHeader.prototype.render = function () {
	        var _a = this.props, gridConfigField = _a.gridConfigField, field = _a.field, sortObject = _a.sortObject, entities = _a.entities, gridConfig = _a.gridConfig;
	        var conditionObject = this.state.conditionObject;
	        var allOperators = entities.get('FILTEROPERATOR').lovItems;
	        var operatorOptions = (conditionObject) ? allOperators.filter(function (li) { return conditionObject.field.availableOperators.includes(li.value); }) : [];
	        var tooltipText = field.gridHeaderTooltipActive;
	        var desc = (sortObject && sortObject.desc) ? true : false;
	        var tooltip = react_1.default.createElement(react_bootstrap_1.Tooltip, { placement: "top", id: field.fieldName }, tooltipText);
	        var filterPopover = (react_1.default.createElement(react_bootstrap_1.Overlay, { show: this.state.showFilterPopover, onHide: this.onHideHandler, rootClose: true, target: this.overlayTargetHandler, placement: "bottom" },
	            react_1.default.createElement(react_bootstrap_1.Popover, { style: { minWidth: 300, zIndex: 1600 }, id: field.fieldName + '_filter' },
	                react_1.default.createElement(TitleP, null,
	                    react_1.default.createElement("span", null,
	                        react_1.default.createElement("span", null, "Column Filter"),
	                        " ",
	                        react_1.default.createElement("span", { className: "fa fa-close", style: { float: 'right', cursor: 'pointer', margin: 6 }, onClick: this.cancelPopover }))),
	                (conditionObject) ? (react_1.default.createElement("form", { onSubmit: this.submitCondition },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({ name: "conditionOperator", value: conditionObject.operator, options: operatorOptions, onChange: this.onChangeConditionOperator.bind(this, conditionObject) }, createForm_1.fieldStyles.small.styledSelect, { clearable: false })),
	                    react_1.default.createElement("div", { style: { minHeight: 50 } },
	                        react_1.default.createElement(conditionValueForm_1.default, { dataObject: conditionObject, rootObject: gridConfig, entities: entities, context: conditionValueForm_1.CONDITIONVALUEFORMCONTEXT.GRIDFILTER, entity: conditionObject.getEntityRef(), extractFieldFn: this.extractFieldFnHandler })),
	                    react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'space-around', marginTop: 10 } },
	                        react_1.default.createElement(FlatButton_1.default, { type: "submit", label: "OK", primary: true, disabled: !conditionObject.operator }),
	                        react_1.default.createElement(FlatButton_1.default, { onClick: this.clearCondition, label: "Clear", secondary: true, disabled: !this.props.conditionObject })))) : '')));
	        var filter = (react_1.default.createElement("a", { ref: this.filterIconRefHandler, onClick: this.onClickFilter, onMouseOver: this.onMouseOver, onMouseOut: this.onMouseOut },
	            react_1.default.createElement("span", { style: { marginLeft: 1 }, className: (0, domUtils_1.classNames)('fa', 'fa-filter', { 'invisible': !this.state.showFilterIcon }) })));
	        var anchor = (field.filterable) ? (react_1.default.createElement("a", { onClick: this._onClickLink, onMouseOver: this.onMouseOver, onMouseOut: this.onMouseOut },
	            (sortObject) ? (react_1.default.createElement("span", { className: (0, domUtils_1.classNames)('fa', { 'fa-long-arrow-up': !desc, 'fa-long-arrow-down': desc }) })) : '',
	            gridConfigField.gridHeaderLabelActive)) : (react_1.default.createElement("span", { style: { color: colors_1.indigo500 } }, gridConfigField.gridHeaderLabelActive));
	        var anchorWithTooltip = (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { overlay: tooltip, delayShow: 300, delayHide: 150 }, anchor));
	        var showFilter = field.filterable && !(conditionObject != null && conditionObject.superFilter);
	        return (react_1.default.createElement("span", null,
	            (tooltipText) ? anchorWithTooltip : anchor,
	            (showFilter) ? filter : '',
	            (showFilter) ? filterPopover : ''));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridHeader.prototype, "_onClickLink", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridHeader.prototype, "onClickFilter", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridHeader.prototype, "onChangeConditionOperator", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridHeader.prototype, "onChangeConditionValues", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridHeader.prototype, "submitCondition", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridHeader.prototype, "clearCondition", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridHeader.prototype, "onHideHandler", void 0);
	    GridHeader = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], GridHeader);
	    return GridHeader;
	}(react_1.default.Component));
	exports.default = GridHeader;
	var templateObject_1;


/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.GridImportDialog = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var errorComp_1 = __webpack_require__(34);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var dialogAncestor_1 = __webpack_require__(87);
	var buttons_1 = __webpack_require__(27);
	var axios_config_1 = __webpack_require__(59);
	var eventDomain_1 = __webpack_require__(74);
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var Toggle_1 = tslib_1.__importDefault(__webpack_require__(362));
	var fields_1 = __webpack_require__(20);
	/* ************************************************************************************************
	 * ***********   DIALOG  *************************************************************
	 * ********************************************************************************************** */
	var GridImportDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(GridImportDialog, _super);
	    function GridImportDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.showOverride = false;
	        _this.ignoreUpdate = false;
	        _this.ignoreEmptyValueOnUpdate = false;
	        _this.close = function () {
	            _this.dialogOpen = false;
	            _this.resolve("OK");
	        };
	        _this.onChange = function (value) {
	            console.log(value);
	            _this.importConfig = value;
	        };
	        _this.showOverrideHandler = function (evt, bulik) {
	            _this.showOverride = bulik;
	        };
	        _this.handleFileUpload = function (files) {
	            var data = new FormData();
	            for (var i = 0; i < files.length; i++) {
	                var file = files.item(i);
	                data.append('file[' + i + ']', file, file.name);
	            }
	            commonService_1.default.loading(true);
	            var params = { importConfigId: _this.importConfig.value };
	            if (_this.showOverride) {
	                params.ignoreUpdate = _this.ignoreUpdate;
	                params.ignoreEmptyValueOnUpdate = _this.ignoreEmptyValueOnUpdate;
	            }
	            return axios_config_1.uploadAxios.post('/core/dataimport/grid', data, { params: params, showPrettyError: true })
	                .then(function (response) {
	                console.log(response);
	                var statuses = response.data;
	                var inserted = statuses.filter(function (s) { return s.operation === eventDomain_1.DMLOPERATION.INSERT; }).length;
	                var updated = statuses.filter(function (s) { return s.operation === eventDomain_1.DMLOPERATION.UPDATE; }).length;
	                _this.resultMessage = "Inserted ".concat(inserted, " new ").concat(_this.grid.$entityRef.label, "s, Updated ").concat(updated, " existing ").concat(_this.grid.$entityRef.label, "s");
	                commonService_1.default.loading(false);
	            }, function (error) {
	                _this.$errors = error.getMessages();
	            });
	        };
	        return _this;
	    }
	    GridImportDialog.prototype.open = function (resolve, reject, grid) {
	        console.log('GridImportDialog: Opening dialog');
	        this.resolve = resolve;
	        this.reject = reject;
	        this.dialogOpen = true;
	        this.grid = grid;
	    };
	    GridImportDialog.prototype.render = function () {
	        var _this = this;
	        console.log('MultiUpdateDialog: rendering dialog');
	        if (!this.grid)
	            return null;
	        var actions = [
	            react_1.default.createElement(FlatButton_1.default, { label: "Close", secondary: true, onClick: this.close }),
	        ];
	        return (react_1.default.createElement(Dialog_1.default, { title: "Select file to import ".concat(this.grid.$gridLocationRef.$entityRef.label, "s"), actions: actions, modal: true, open: this.dialogOpen, contentStyle: { width: '60%', maxWidth: 'none' }, bodyStyle: { overflow: 'visible' } },
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: this.$errors }),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12" },
	                    react_1.default.createElement("span", null, "Select Import config"),
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({ name: "selectImportConfig", value: this.importConfig, options: this.grid.$gridLocationRef.importConfigs, onChange: this.onChange }, createForm_1.fieldStyles.small.styledSelect, { fullWidth: true, clearable: false })))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement(Toggle_1.default, { label: "Override import settings", toggled: this.showOverride, onToggle: this.showOverrideHandler, style: { width: "unset", marginTop: 20 }, labelStyle: { marginRight: 10, whiteSpace: 'nowrap' } })),
	            this.showOverride && (react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement(fields_1.MdCheckbox, { name: "ignoreUpdate", checked: this.ignoreUpdate, label: "Do not update existing ".concat(this.grid.$gridLocationRef.$entityRef.label, "s"), onCheck: function (e) { return _this.ignoreUpdate = e.target.checked; } }))),
	            this.showOverride && (react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement(fields_1.MdCheckbox, { name: "ignoreEmptyValueOnUpdate", checked: this.ignoreEmptyValueOnUpdate, label: "Do not set empty values when updating existing ".concat(this.grid.$gridLocationRef.$entityRef.label, "s"), onCheck: function (e) { return _this.ignoreEmptyValueOnUpdate = e.target.checked; } }))),
	            this.importConfig && (react_1.default.createElement("div", { className: "row", style: { marginTop: 20 } },
	                react_1.default.createElement("div", { className: "col-xs-12" },
	                    react_1.default.createElement(buttons_1.ZzUploadFlatButton, { label: "Import File", handleFileUpload: this.handleFileUpload })))),
	            this.resultMessage && (react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12" },
	                    react_1.default.createElement("h5", { style: { color: "red" } }, this.resultMessage))))));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridImportDialog.prototype, "importConfig", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridImportDialog.prototype, "resultMessage", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridImportDialog.prototype, "showOverride", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridImportDialog.prototype, "ignoreUpdate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], GridImportDialog.prototype, "ignoreEmptyValueOnUpdate", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridImportDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridImportDialog.prototype, "close", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridImportDialog.prototype, "onChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridImportDialog.prototype, "showOverrideHandler", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridImportDialog.prototype, "handleFileUpload", void 0);
	    GridImportDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], GridImportDialog);
	    return GridImportDialog;
	}(dialogAncestor_1.DialogAncestor));
	exports.GridImportDialog = GridImportDialog;


/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_dom_1 = tslib_1.__importDefault(__webpack_require__(31));
	var react_bootstrap_1 = __webpack_require__(72);
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var createForm_1 = __webpack_require__(18);
	var FaFilter = __webpack_require__(1820);
	var icons_1 = __webpack_require__(63);
	var Badge_1 = tslib_1.__importDefault(__webpack_require__(489));
	var mobx_react_1 = __webpack_require__(4);
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var colors_1 = __webpack_require__(29);
	var GridComp__iconStyle = { height: 18, width: 18 };
	var iconButonStyle = { width: 32, height: 40, padding: "8px 4px" };
	var badgeIcon__badgeStyle = { fontSize: 8, width: 12, height: 12 };
	var badgeIcon__style = { padding: 0 };
	var PopoverStyled = (0, styled_components_1.default)(react_bootstrap_1.Popover)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    min-width: 300px;\n    z-index: 1600px;\n"], ["\n    min-width: 300px;\n    z-index: 1600px;\n"])));
	var TitleP = styled_components_1.default.p(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n    color: ", ";\n    font-size: 18px;\n"], ["\n    color: ", ";\n    font-size: 18px;\n"])), colors_1.grey400);
	var ButtonDiv = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-around;\n  margin-top: 10px;\n"], ["\n  display: flex;\n  justify-content: space-around;\n  margin-top: 10px;\n"])));
	var MainIconDiv = styled_components_1.default.div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n    position: relative;\n    vertical-align: top;\n    display: inline-block;\n"], ["\n    position: relative;\n    vertical-align: top;\n    display: inline-block;\n"])));
	var SpecialConditionFilter = /** @class */ (function (_super) {
	    tslib_1.__extends(SpecialConditionFilter, _super);
	    function SpecialConditionFilter() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            showPopover: false,
	            specialConditions: []
	        };
	        _this.cancelPopover = function (evt) {
	            var grid = _this.props.grid;
	            _this.setState({
	                showPopover: false
	            });
	        };
	        _this.handleSpecialCondition = function () {
	            _this.setState({
	                showPopover: true,
	                specialConditions: _this.props.grid.specialConditions
	            });
	        };
	        _this.onChangeSpecialCondition = function (valueArray) {
	            _this.setState({ specialConditions: valueArray });
	        };
	        _this.submitCondition = function (evt) {
	            evt.preventDefault();
	            var _a = _this.props, grid = _a.grid, search = _a.search, onGridChange = _a.onGridChange;
	            grid.specialConditions = _this.state.specialConditions;
	            _this.setState({ showPopover: false });
	            if (onGridChange) {
	                onGridChange(grid);
	            }
	            search(true);
	        };
	        _this.filterIconRefHandler = function (comp) { return _this.filterIconRef = comp; };
	        _this.onHideHandler = function () { return _this.setState({ showPopover: false }); };
	        _this.targetHandler = function () { return react_dom_1.default.findDOMNode(_this.filterIconRef); };
	        return _this;
	    }
	    SpecialConditionFilter.prototype.render = function () {
	        var grid = this.props.grid;
	        var popover = (react_1.default.createElement(react_bootstrap_1.Overlay, { show: this.state.showPopover, onHide: this.onHideHandler, rootClose: true, target: this.targetHandler, placement: "bottom" },
	            react_1.default.createElement(PopoverStyled, { id: "specialConditionFilter" },
	                react_1.default.createElement("form", { onSubmit: this.submitCondition },
	                    react_1.default.createElement(TitleP, null, "Special Conditions"),
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { onChange: this.onChangeSpecialCondition, value: this.state.specialConditions, options: grid.$gridLocationRef.specialConditions, multi: true, fullWidth: true, searchable: false, clearable: false })),
	                    react_1.default.createElement(ButtonDiv, null,
	                        react_1.default.createElement(FlatButton_1.default, { type: "submit", label: "OK", primary: true }),
	                        react_1.default.createElement(FlatButton_1.default, { onClick: this.cancelPopover, label: "Cancel", secondary: true }))))));
	        if (grid.$gridLocationRef.specialConditions && grid.$gridLocationRef.specialConditions.length > 0) {
	            var icon = (react_1.default.createElement(icons_1.MdIconButton, { onClick: this.handleSpecialCondition, style: iconButonStyle, iconStyle: GridComp__iconStyle, disabled: this.props.disabled },
	                react_1.default.createElement(FaFilter, { size: 18 })));
	            var badgeIcon = ((grid.specialConditions && grid.specialConditions.length) ?
	                react_1.default.createElement(Badge_1.default, { badgeContent: grid.specialConditions.length, primary: true, badgeStyle: badgeIcon__badgeStyle, style: badgeIcon__style }, icon)
	                : icon);
	            return (react_1.default.createElement(MainIconDiv, { ref: this.filterIconRefHandler },
	                badgeIcon,
	                popover));
	        }
	        else {
	            return react_1.default.createElement("noscript", null);
	        }
	    };
	    SpecialConditionFilter = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SpecialConditionFilter);
	    return SpecialConditionFilter;
	}(react_1.default.Component));
	exports.default = SpecialConditionFilter;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var conditionValueForm_1 = tslib_1.__importStar(__webpack_require__(401));
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var SuperFilterBar = /** @class */ (function (_super) {
	    tslib_1.__extends(SuperFilterBar, _super);
	    function SuperFilterBar() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.submitCondition = function (evt) {
	            console.log("submitCondition");
	            if (evt)
	                evt.preventDefault();
	            var grid = _this.props.grid;
	            var allOk = true;
	            grid.getSuperFilters().forEach(function (gcc) {
	                var form = gcc.getForm("ConditionValueForm");
	                if (!form.validateForm(gcc)) {
	                    allOk = false;
	                }
	            });
	            if (allOk) {
	                _this.props.refreshGrid();
	            }
	        };
	        return _this;
	    }
	    SuperFilterBar.prototype.componentDidMount = function () {
	        var _a = this.props, grid = _a.grid, gridConfig = _a.gridConfig;
	        var entitiesToFetch = gridConfig.getSuperFilters().filter(function (gcc) { return gcc.field.hasLocalValueSource(); })
	            .map(function (gcc) { return ({ entity: gcc.field.valueSource, lov: true }); });
	        mdEntityService_1.default.fetchEntities(entitiesToFetch)
	            .then((0, mobx_1.action)("action-cb", function (entityMap) {
	            grid.initSuperFilter();
	        }));
	    };
	    SuperFilterBar.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, grid = _a.grid, gridConfig = _a.gridConfig;
	        console.debug("render SuperFilterBar conditionArray = ", grid.getSuperFilters());
	        return (react_1.default.createElement("form", { onSubmit: this.submitCondition, className: "md-grid-super-filter" }, grid.getSuperFilters().map(function (gcc, i) { return (react_1.default.createElement(SuperFilter, { key: i, grid: grid, gridConfig: gridConfig, conditionObject: gcc, onSuccess: _this.submitCondition })); })));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SuperFilterBar.prototype, "submitCondition", void 0);
	    SuperFilterBar = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SuperFilterBar);
	    return SuperFilterBar;
	}(react_1.default.Component));
	exports.default = SuperFilterBar;
	var SuperFilter = /** @class */ (function (_super) {
	    tslib_1.__extends(SuperFilter, _super);
	    function SuperFilter() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.extractFieldFnHandler = function (dataObject, fieldDef) { return dataObject.field; };
	        return _this;
	    }
	    SuperFilter.prototype.render = function () {
	        var _a = this.props, conditionObject = _a.conditionObject, gridConfig = _a.gridConfig, onSuccess = _a.onSuccess;
	        console.debug("render superfilter, entity %O, entities %O, condition $O", conditionObject.getEntityRef(), mdEntityService_1.default.entityMap, conditionObject);
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement(conditionValueForm_1.default, { dataObject: conditionObject, rootObject: gridConfig, entities: mdEntityService_1.default.entityMap, context: conditionValueForm_1.CONDITIONVALUEFORMCONTEXT.SUPERFILTER, onSuccess: onSuccess, entity: conditionObject.getEntityRef(), extractFieldFn: this.extractFieldFnHandler })));
	    };
	    SuperFilter = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SuperFilter);
	    return SuperFilter;
	}(react_1.default.Component));


/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var arrayUtils_1 = __webpack_require__(78);
	var domUtils_1 = __webpack_require__(91);
	var mobx_react_1 = __webpack_require__(4);
	var grid_1 = __webpack_require__(50);
	var throtlle = __webpack_require__(734);
	var VirtualList = /** @class */ (function (_super) {
	    tslib_1.__extends(VirtualList, _super);
	    function VirtualList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onScroll = function () {
	            var state = _this.getVirtualState(_this.props);
	            _this.setState(state);
	            // v pripade ze je header, posuneme ho do spravne pozice
	            if (_this.props.header) {
	                _this.props.header.style.left = -_this.props.container.scrollLeft + 'px';
	            }
	        };
	        _this.onResize = function () {
	            window.requestAnimationFrame(function () {
	                var state = _this.getVirtualState(_this.props);
	                _this.setState(state);
	            });
	        };
	        _this.mainRefHandler = function (comp) { return _this.mainRef = comp; };
	        return _this;
	    }
	    VirtualList.prototype.shouldComponentUpdate = function (nextProps, nextState) {
	        if (this.state.bufferStart !== nextState.bufferStart) {
	            //console.log('state.bufferStart se lisi, returning TRUE');
	            return true;
	        }
	        if (this.state.height !== nextState.height) {
	            //console.log('state.height se lisi, returning TRUE');
	            return true;
	        }
	        var equal = (0, arrayUtils_1.areArraysEqual)(this.state.items, nextState.items);
	        //console.log('state.items array returning ' + !equal);
	        return !equal;
	    };
	    VirtualList.prototype.componentWillReceiveProps = function (nextProps) {
	        console.log('virtualList#componentWillReceiveProps %O', nextProps);
	        var state = this.getVirtualState(nextProps);
	        this.setState(state);
	    };
	    VirtualList.prototype.componentWillMount = function () {
	        //console.log('virtualList#componentWillMount %O', this.props);
	        this.onScrollThrottled = throtlle(this.onScroll, 60);
	        var state = this.getVirtualState(this.props);
	        this.setState(state);
	    };
	    VirtualList.prototype.componentDidMount = function () {
	        this._isMounted = true;
	        var state = this.getVirtualState(this.props);
	        console.log('virtualList#componentDidMount state = %O', state);
	        this.setState(state);
	        this.props.container.addEventListener('scroll', this.onScrollThrottled, { passive: true });
	        window.addEventListener('resize', this.onResize);
	    };
	    VirtualList.prototype.remountScroll = function (container) {
	        console.log('remountScroll %O', container);
	        container.addEventListener('scroll', this.onScrollThrottled, { passive: true });
	    };
	    VirtualList.prototype.componentWillUnmount = function () {
	        //console.log('virtualList#componentWillUnmount %O', this.props);
	        this._isMounted = undefined;
	        this.props.container.removeEventListener('scroll', this.onScrollThrottled);
	        window.removeEventListener('resize', this.onResize);
	    };
	    // in case you need to get the currently visible items
	    VirtualList.prototype.visibleItems = function () {
	        return this.state.items;
	    };
	    VirtualList.prototype.scrollTop = function () {
	        this.props.container.scrollTop = 0;
	    };
	    VirtualList.prototype.render = function () {
	        //console.log("%cVirtualList#render: items.length = " + this.state.items.length, "background-color: red");
	        try {
	            return (react_1.default.createElement("div", { ref: this.mainRefHandler, style: { boxSizing: 'border-box', height: this.state.height, paddingTop: this.state.bufferStart } }, this.state.items.map(this.props.renderItem)));
	        }
	        catch (err) {
	            console.error('Error in render item: ', err);
	        }
	    };
	    VirtualList.prototype.getVirtualState = function (props) {
	        var gridData = props.gridData, container = props.container, search = props.search;
	        // default values
	        var state = {
	            items: [],
	            bufferStart: 0,
	            height: 0
	        };
	        // early return if nothing to render
	        if (typeof container === 'undefined' || gridData.isEmpty() || !this._isMounted)
	            return state;
	        //let items = props.items;
	        state.height = this.virtualHeight(gridData);
	        var viewHeight = typeof container.innerHeight !== 'undefined' ? container.innerHeight : container.clientHeight;
	        // no space to render
	        if (viewHeight <= 0)
	            return state;
	        var offsetTop = (0, domUtils_1.topDifference)(this.mainRef, container);
	        var viewTop = typeof container.scrollY !== 'undefined' ? container.scrollY : container.scrollTop;
	        var renderStats = this.getItems(viewTop, viewHeight, offsetTop, gridData, state.height, search);
	        if (renderStats) {
	            console.log("firstLocalIndex = %s, lastLocalIndex = %s, firstPlaneIndex = %s, lastPlaneIndex = %s", renderStats.firstIndex.local, renderStats.lastIndex.local, renderStats.firstIndex.plane, renderStats.lastIndex.plane);
	        }
	        // no items to render
	        if (!renderStats)
	            return state;
	        state.items = gridData.sliceSparse(renderStats.firstIndex, renderStats.lastIndex);
	        state.bufferStart = this.virtualHeightTo(gridData, renderStats.firstIndex);
	        //console.debug("getVirtualState: state.height = " + state.height + " on " + props.items.length + " total items.  State.items = " + state.items.length + ", state.bufferStart = " + state.bufferStart);
	        return state;
	    };
	    VirtualList.prototype.getItems = function (viewTop, viewHeight, listTop, gridData, listHeight, search) {
	        if (listHeight === 0)
	            return null;
	        var listBox = {
	            top: listTop,
	            height: listHeight,
	            bottom: listTop + listHeight
	        };
	        var viewBox = {
	            top: viewTop,
	            bottom: viewTop + viewHeight
	        };
	        // list is below viewport
	        if (viewBox.bottom < listBox.top)
	            return null;
	        // list is above viewport
	        if (viewBox.top > listBox.bottom)
	            return null;
	        var listViewBox = this.getBox(viewBox, listBox);
	        var firstLocalIndex = 0, lastLocalIndex = 0, firstPlaneIndex = 1, lastPlaneIndex = 1, runningHeight = 0;
	        var remainingCount = gridData.totalCount;
	        var page = 1;
	        var pageSize = gridData.pageSize;
	        while (remainingCount > 0) {
	            firstLocalIndex = 0;
	            lastLocalIndex = 0;
	            if (runningHeight <= listViewBox.top)
	                firstPlaneIndex = page;
	            if (runningHeight <= listViewBox.bottom)
	                lastPlaneIndex = page;
	            var plane = gridData.pageMap.get(page.toString());
	            if (plane) {
	                for (var i = 0; i < plane.length; i++) {
	                    if (runningHeight <= listViewBox.top)
	                        firstLocalIndex = i;
	                    if (runningHeight <= listViewBox.bottom)
	                        lastLocalIndex = i;
	                    runningHeight += plane[i].rowHeight;
	                    if (runningHeight > listViewBox.bottom)
	                        return { firstIndex: { plane: firstPlaneIndex, local: firstLocalIndex }, lastIndex: { plane: lastPlaneIndex, local: lastLocalIndex } };
	                }
	            }
	            else {
	                // SEARCH NEEDED
	                console.log("SEARCH NEEDED");
	                search(page);
	                for (var i = 0; i < pageSize; i++) {
	                    if (runningHeight <= listViewBox.top)
	                        firstLocalIndex = i;
	                    if (runningHeight <= listViewBox.bottom)
	                        lastLocalIndex = i;
	                    runningHeight += grid_1.ROW_HEIGHT;
	                    if (runningHeight > listViewBox.bottom)
	                        return { firstIndex: { plane: firstPlaneIndex, local: firstLocalIndex }, lastIndex: { plane: lastPlaneIndex, local: lastLocalIndex } };
	                }
	            }
	            remainingCount -= pageSize;
	            page++;
	            pageSize *= 2;
	        }
	        return { firstIndex: { plane: firstPlaneIndex, local: firstLocalIndex }, lastIndex: { plane: lastPlaneIndex, local: lastLocalIndex } };
	    };
	    VirtualList.prototype.virtualHeight = function (gridData) {
	        var height = 0, realCount = 0;
	        for (var _i = 0, _a = gridData.pageMap.values(); _i < _a.length; _i++) {
	            var plane = _a[_i];
	            height = plane.reduce(function (acc, row) { return acc + row.rowHeight; }, height);
	            realCount += plane.length;
	        }
	        return (height + (gridData.totalCount - realCount) * grid_1.ROW_HEIGHT);
	    };
	    VirtualList.prototype.virtualHeightTo = function (gridData, firstIndex) {
	        var height = 0;
	        var pageSize = gridData.pageSize;
	        for (var page = 1; page <= firstIndex.plane; page++) {
	            var plane = gridData.pageMap.get(page.toString());
	            var _last = (page === firstIndex.plane) ? (firstIndex.local) : pageSize;
	            if (plane) {
	                for (var i = 0; i < _last; i++)
	                    height += plane[i].rowHeight;
	            }
	            else {
	                height += _last * grid_1.ROW_HEIGHT;
	            }
	            pageSize *= 2;
	        }
	        return height;
	    };
	    VirtualList.prototype.getBox = function (view, list) {
	        list.height = list.height || list.bottom - list.top;
	        return {
	            top: Math.max(0, Math.min(view.top - list.top)),
	            bottom: Math.max(0, Math.min(list.height, view.bottom - list.top))
	        };
	    };
	    VirtualList.defaultProps = {
	        container: typeof window !== 'undefined' ? window : undefined,
	    };
	    VirtualList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], VirtualList);
	    return VirtualList;
	}(react_1.default.Component));
	exports.default = VirtualList;
	;


/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var Chart = /** @class */ (function (_super) {
	    tslib_1.__extends(Chart, _super);
	    function Chart(json) {
	        var _this = _super.call(this, json) || this;
	        if (!_this.data)
	            _this.data = [];
	        return _this;
	    }
	    return Chart;
	}(DomainAncestor_1.DomainAncestor));
	exports.default = Chart;


/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_router_1 = __webpack_require__(65);
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var gridConfig_1 = tslib_1.__importDefault(__webpack_require__(264));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var gridAdminComp_1 = tslib_1.__importDefault(__webpack_require__(934));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var buttons_1 = __webpack_require__(27);
	var storage_1 = __webpack_require__(173);
	var locales_1 = __webpack_require__(15);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	// function mapStateToProps(state, ownProps) {
	//   return {
	//     entities: state.getIn(['metamodel', 'entities']),
	//     gridConfig: state.getIn(['grid', 'gridConfig'])
	//   };
	// }
	//
	//
	// @connect(mapStateToProps, {updateGridAction, updateGridConfigAction})
	var GridConfigDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(GridConfigDetail, _super);
	    function GridConfigDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /* ****************   EVENT HENDLERS ************************************************************ */
	        _this.onClickSave = function (evt) {
	            console.log('onClickSave');
	            _this.gridAdminCompRef.save()
	                .then(function (newGridConfig) {
	                if (newGridConfig) {
	                    _this.context.router.replaceWith("gridConfigDetail", {
	                        gridLocation: newGridConfig.gridLocation,
	                        id: newGridConfig.gridId
	                    });
	                }
	            });
	        };
	        _this.onClickAdd = function (evt) {
	            console.log('onClickAdd');
	            _this.context.router.transitionTo("gridConfigDetail", { id: 'new' }, { gridLocation: gridService_1.default.gridConfig.gridLocation });
	        };
	        _this.onClickCopy = function (evt) {
	            console.log('onClickCopy');
	            _this.context.router.transitionTo("gridConfigDetail", { id: 'copy' }, { gridLocation: gridService_1.default.gridConfig.gridLocation, copyId: gridService_1.default.gridConfig.gridId });
	        };
	        _this.onClickDelete = function (evt) {
	            console.log('onClickDelete ' + gridService_1.default.gridConfig.gridId);
	            _this.openDeleteDialog().then(function () {
	                commonService_1.default.loading(true);
	                axios_config_1.default.delete('/core/grid-config/' + gridService_1.default.gridConfig.gridId)
	                    .then(function (response) {
	                    var grid = gridService_1.default.getGrid(gridService_1.default.gridConfig.gridLocation);
	                    if (grid)
	                        grid.deleteGridConfig(gridService_1.default.gridConfig.gridId);
	                    (0, storage_1.removeItemFromLocalStorage)("GridLocation", locales_1.loc.lang, gridService_1.default.gridConfig.gridLocation);
	                    _this.context.router.transitionTo("gridLocationDetail", { id: gridService_1.default.gridConfig.gridLocation });
	                    commonService_1.default.loading(false);
	                });
	            }).catch(function (e) { });
	        };
	        _this.onClickBack = function () {
	            console.log('onClickBack');
	            _this.context.router.transitionTo("gridLocationDetail", { id: gridService_1.default.gridConfig.gridLocation });
	        };
	        _this.gridAdminCompRefHandler = function (comp) { return _this.gridAdminCompRef = comp; };
	        return _this;
	    }
	    GridConfigDetail.fetchData = function (routerParams, query) {
	        console.log("GridConfigDetail#fetchData(%o)", routerParams);
	        var gridConfigPromise;
	        var mdEntityPromise = mdEntityService_1.default.fetchEntities([{ entity: "CONFIGLEVEL", lov: true }, { entity: "GRIDROWCSS", lov: true }, { entity: "Tenant", lov: true }, { entity: "TenantGroup", lov: true }]);
	        if (routerParams.id === 'new') {
	            gridConfigPromise = gridService_1.default.fetchGrids(query.gridLocation)
	                .then(function (gridLocationMap) {
	                return gridConfig_1.default.newInstance(gridLocationMap.get(query.gridLocation));
	            });
	        }
	        else if (routerParams.id === 'copy') {
	            gridConfigPromise = gridService_1.default.readGridConfig(query.copyId)
	                .then(function (gridConfig) {
	                gridConfig.cleanOnCopy();
	                gridConfig.defaultGrid = undefined;
	                return gridConfig;
	            });
	        }
	        else {
	            gridConfigPromise = gridService_1.default.readGridConfig(routerParams.id);
	        }
	        return Promise.all([gridConfigPromise, mdEntityPromise]).then(function (_a) {
	            var gridConfig = _a[0], entities = _a[1];
	            gridService_1.default.gridConfig = gridConfig;
	            return gridService_1.default.fetchConditionLovs(gridConfig.conditions);
	        });
	    };
	    GridConfigDetail.prototype.componentWillUnmount = function () {
	        gridService_1.default.gridConfig = undefined;
	    };
	    /* ****************   REACT METHODS ************************************************************ */
	    GridConfigDetail.prototype.render = function () {
	        var toolMenu = this._createToolMenu(gridService_1.default.gridConfig, this.props.query.gridLocation);
	        console.debug('gridConfigDetail render gridConfig');
	        return (react_1.default.createElement("main", { className: "main-content container" },
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	            toolMenu,
	            react_1.default.createElement(gridAdminComp_1.default, { ref: this.gridAdminCompRefHandler, gridLocation: gridService_1.default.gridConfig.$gridLocationRef, grid: gridService_1.default.getGrid(gridService_1.default.gridConfig.gridLocation), gridConfig: gridService_1.default.gridConfig, entities: mdEntityService_1.default.entityMap, adminMode: true })));
	    };
	    /* ****************   NORMAL METHODS ************************************************************ */
	    GridConfigDetail.prototype._createToolMenu = function (gridConfig, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onClickBack, backDisabled: react_router_1.History.length <= 1 },
	            (gridConfig) ? (react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onClickSave, label: "Save grid", permission: gridConfig.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update })) : react_1.default.createElement("noscript", null),
	            (gridConfig && gridConfig.gridId > 0) ? (react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onClickAdd, label: "Create new grid", permission: metaConstant_1.PERMISSION.New })) : react_1.default.createElement("noscript", null),
	            (gridConfig && gridConfig.gridId > 0) ? (react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onClickCopy, label: "Copy grid", permission: metaConstant_1.PERMISSION.New })) : react_1.default.createElement("noscript", null),
	            (gridConfig && gridConfig.gridId > 0) ? (react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onClickDelete, label: "Delete grid", permission: metaConstant_1.PERMISSION.Delete })) : react_1.default.createElement("noscript", null)));
	    };
	    GridConfigDetail.module = metaConstant_1.MODULE.core;
	    GridConfigDetail.title = 'Manage Grid';
	    GridConfigDetail.icon = 'wrench';
	    GridConfigDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridConfigDetail.prototype, "onClickSave", void 0);
	    GridConfigDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], GridConfigDetail);
	    return GridConfigDetail;
	}(pageAncestor_1.default));
	exports.default = GridConfigDetail;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var Tabs_1 = tslib_1.__importDefault(__webpack_require__(107));
	var Tab_1 = tslib_1.__importDefault(__webpack_require__(102));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var blockComp_1 = __webpack_require__(30);
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridComp_1 = tslib_1.__importDefault(__webpack_require__(44));
	var metaConstant_1 = __webpack_require__(13);
	var variables_1 = __webpack_require__(96);
	var errorComp_1 = __webpack_require__(34);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var mui_theme_1 = __webpack_require__(119);
	var buttons_1 = __webpack_require__(27);
	var buttons_2 = __webpack_require__(27);
	var mobx_react_1 = __webpack_require__(4);
	var gridUtils_1 = __webpack_require__(83);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var formUtils_1 = __webpack_require__(14);
	var gridConfigGridLocation = 'gridConfigList';
	var specialConditionGridLocation = 'gridSpecialConditionList';
	var fieldGridLocation = "gridLocationFieldList";
	var GridLocationDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(GridLocationDetail, _super);
	    function GridLocationDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onSave = function (evt) {
	            console.log('onSave');
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	        };
	        _this.onBack = function (evt) {
	            console.log('onBack %O', _this.context.router);
	            _this.context.router.transitionTo('gridLocationList');
	        };
	        return _this;
	    }
	    GridLocationDetail.fetchData = function (routerParams, query) {
	        console.log("GridLocationDetail#fetchData()");
	        var gridObjectPromise = gridService_1.default.readGridLocation(routerParams.id);
	        var gridPromise = gridService_1.default.fetchGrids(gridConfigGridLocation, specialConditionGridLocation, fieldGridLocation);
	        return Promise.all([gridObjectPromise, gridPromise]).then(function (_a) {
	            var gridLocationObject = _a[0], gridLocationMap = _a[1];
	            gridLocationObject.$movingBlocks = new gridUtils_1.MovingBlocks(gridConfigGridLocation, true, query.tab, new grid_1.default(gridLocationMap.get(gridConfigGridLocation), gridLocationObject.gridLocation), new grid_1.default(gridLocationMap.get(specialConditionGridLocation), gridLocationObject.gridLocation), new grid_1.default(gridLocationMap.get(fieldGridLocation), gridLocationObject.gridLocation));
	            gridService_1.default.gridLocationObject = gridLocationObject;
	        });
	    };
	    /**
	     *
	     */
	    GridLocationDetail.prototype.componentWillMount = function () {
	        uiService_1.default.addMediaQueryListener(this.mediaQueryListener);
	    };
	    /**
	     * tohle je tady kvuli chained detailu
	     * @param prevProps
	     */
	    GridLocationDetail.prototype.componentDidUpdate = function (prevProps) {
	        if (this.idChanged(prevProps.params.id, this.props.params.id)) {
	            gridService_1.default.gridLocationObject.$movingBlocks.searchExposedGrids(gridService_1.default.gridLocationObject);
	        }
	    };
	    GridLocationDetail.prototype.componentDidMount = function () {
	        gridService_1.default.gridLocationObject.$movingBlocks.searchExposedGrids(gridService_1.default.gridLocationObject);
	    };
	    GridLocationDetail.prototype.componentWillUnmount = function () {
	        uiService_1.default.removeMediaQueryListener(this.mediaQueryListener);
	        gridService_1.default.gridLocationObject = null;
	    };
	    GridLocationDetail.prototype.findRootObject = function () {
	        return gridService_1.default.gridLocationObject;
	    };
	    GridLocationDetail.prototype.render = function () {
	        var _this = this;
	        var query = this.props.query;
	        console.debug('%c GridLocationDetail render query %O', 'background-color: yellow', query);
	        var movingBlocks = gridService_1.default.gridLocationObject.$movingBlocks;
	        var mainForm = (react_1.default.createElement(blockComp_1.BlockComp, { style: { marginTop: 10 }, header: "Grid" },
	            react_1.default.createElement("form", null,
	                gridService_1.default.gridLocationObject.label,
	                " (",
	                gridService_1.default.gridLocationObject.gridLocation,
	                ") for entity ",
	                gridService_1.default.gridLocationObject.entityName,
	                react_1.default.createElement("br", null),
	                "Security:  ",
	                (gridService_1.default.gridLocationObject.securable) ? (0, formUtils_1.lovLabel)(gridService_1.default.gridLocationObject.securable) : " Unsecured")));
	        // this.context.router.transitionTo("gridConfigDetail", {id: 'new'}, {gridLocation: this.props.gridObject.gridLocation});
	        //<FlatButton onClick={this.onClickAdd} label="Vytvořit novou sestavu" securable="gridConfigDetail" permission={PERMISSION.New}/>
	        var gridCompArray = [
	            react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(gridConfigGridLocation), uiLocation: movingBlocks.getUiLocation(gridConfigGridLocation), entities: mdEntityService_1.default.entityMap },
	                react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "gridConfigDetail", params: { id: 'new' }, query: { gridLocation: gridService_1.default.gridLocationObject.gridLocation }, label: "New Grid Config", securable: "gridConfigDetail", permission: metaConstant_1.PERMISSION.New })),
	            react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(specialConditionGridLocation), uiLocation: movingBlocks.getUiLocation(specialConditionGridLocation), entities: mdEntityService_1.default.entityMap },
	                react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "gridSpecialConditionDetail", params: { id: 'new' }, query: { gridLocation: gridService_1.default.gridLocationObject.gridLocation }, label: "New Special Condition", securable: "gridSpecialConditionDetail", permission: metaConstant_1.PERMISSION.New })),
	            react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(fieldGridLocation), uiLocation: movingBlocks.getUiLocation(fieldGridLocation), entities: mdEntityService_1.default.entityMap })
	        ];
	        var standAloneGridComp = movingBlocks.pluckStandAloneBlock(gridCompArray);
	        var tabArray = gridCompArray.map(function (gridComp) { return (react_1.default.createElement(Tab_1.default, { label: gridComp.props.grid.label, style: variables_1.tabStyle, onActive: _this.activateTab.bind(_this, gridComp.props.grid), key: gridComp.props.grid.gridLocation, value: gridComp.props.grid.gridLocation }, gridComp)); });
	        var tabs = (tabArray.length) ? (react_1.default.createElement(Tabs_1.default, { value: gridService_1.default.gridLocationObject.$movingBlocks.activeBlockTab, className: "detail-grid", tabTemplate: mui_theme_1.TabTemplate, inkBarStyle: { transition: 'inherit' }, contentContainerStyle: { width: '100%', flexGrow: 1, display: 'flex', minHeight: 0 }, onChange: this.onTabChange }, tabArray)) : '';
	        if (uiService_1.default.globalMediaQuery.matches) {
	            return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'row' } },
	                react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', height: '100%', width: '50%' } },
	                    this._createToolMenu(gridService_1.default.gridLocationObject, query.gridLocation),
	                    react_1.default.createElement(errorComp_1.ErrorComp, { messages: gridService_1.default.gridLocationObject.$errors }),
	                    react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	                    mainForm,
	                    tabs),
	                standAloneGridComp));
	        }
	        else {
	            return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	                this._createToolMenu(gridService_1.default.gridLocationObject, query.gridLocation),
	                react_1.default.createElement(errorComp_1.ErrorComp, { messages: gridService_1.default.gridLocationObject.$errors }),
	                react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	                mainForm,
	                tabs));
	        }
	    };
	    GridLocationDetail.prototype._createToolMenu = function (gridObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: false, activeTab: gridObject.$movingBlocks.activeBlockTab },
	            react_1.default.createElement(buttons_2.ZzFlatButton, { onClick: this.onSave, label: "Save Grid", permission: metaConstant_1.PERMISSION.Update })));
	    };
	    GridLocationDetail.module = metaConstant_1.MODULE.core;
	    GridLocationDetail.title = 'Grid';
	    GridLocationDetail.icon = 'table';
	    GridLocationDetail.protectedPage = true;
	    GridLocationDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], GridLocationDetail);
	    return GridLocationDetail;
	}(pageAncestor_1.default));
	exports.default = GridLocationDetail;


/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var utils_1 = __webpack_require__(37);
	var formUtils_1 = __webpack_require__(14);
	var errorComp_1 = __webpack_require__(34);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var buttons_1 = __webpack_require__(27);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var mobx_1 = __webpack_require__(5);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var localizeFields_1 = tslib_1.__importDefault(__webpack_require__(930));
	var GridLocationFieldDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(GridLocationFieldDetail, _super);
	    function GridLocationFieldDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onSave = function (evt) {
	            console.log('onSave ');
	            uiService_1.default.showToolbarActionFlag();
	            if (!(0, formUtils_1.preSave)(gridService_1.default.gridLocationFieldObject)) {
	                return;
	            }
	            gridService_1.default.saveGridLocationFieldDto(gridService_1.default.gridLocationFieldObject)
	                .then((0, mobx_1.action)("fieldDtoSave-action", function (foJson) {
	                var wasNew = gridService_1.default.gridLocationFieldObject.cleanAfterSave(foJson);
	                uiService_1.default.hideToolbarActionFlag();
	            }), function (error) {
	                gridService_1.default.gridLocationFieldObject.$errors = error.getMessages();
	            });
	        };
	        _this.onBack = function (evt) {
	            _this.context.router.transitionTo('gridLocationDetail', { id: (0, utils_1.parseId)(gridService_1.default.gridLocationFieldObject.gridLocationField) });
	        };
	        return _this;
	    }
	    GridLocationFieldDetail.fetchData = function (routerParams, query) {
	        console.log("GridLocationFieldDetail#fetchData(%O)", routerParams.id);
	        var _a = (0, utils_1.parseId)(routerParams.id), gridLocationName = _a[0], fieldName = _a[1];
	        var fieldDtoPromise = gridService_1.default.readGridLocationField(routerParams.id);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata([], ['GridLocationField']);
	        return Promise.all([fieldDtoPromise, metadataPromise])
	            .then(function (_a) {
	            var fieldDto = _a[0], entityMap = _a[1];
	            gridService_1.default.gridLocationFieldObject = fieldDto;
	        });
	    };
	    GridLocationFieldDetail.prototype.componentWillUnmount = function () {
	        gridService_1.default.gridLocationFieldObject = null;
	    };
	    GridLocationFieldDetail.prototype.findRootObject = function () {
	        return gridService_1.default.gridLocationFieldObject;
	    };
	    GridLocationFieldDetail.prototype.render = function () {
	        var query = this.props.query;
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	            this._createToolMenu(query.gridLocation),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: gridService_1.default.gridLocationFieldObject.$errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement("form", { style: { marginTop: 10 } },
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12" },
	                        react_1.default.createElement(localizeFields_1.default, { fields: gridService_1.default.gridLocationFieldObject.locales.entries().map(function (_a) {
	                                var fieldName = _a[0], locArray = _a[1];
	                                return ({ fieldName: fieldName, locArray: locArray });
	                            }) }))))));
	    };
	    GridLocationFieldDetail.prototype._createToolMenu = function (gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: false },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, label: "Save Field", permission: metaConstant_1.PERMISSION.Update })));
	    };
	    GridLocationFieldDetail.module = metaConstant_1.MODULE.core;
	    GridLocationFieldDetail.title = 'Grid location field';
	    GridLocationFieldDetail.icon = 'book';
	    GridLocationFieldDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridLocationFieldDetail.prototype, "onSave", void 0);
	    GridLocationFieldDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], GridLocationFieldDetail);
	    return GridLocationFieldDetail;
	}(pageAncestor_1.default));
	exports.default = GridLocationFieldDetail;


/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'gridLocationList';
	var GridLocationList = /** @class */ (function (_super) {
	    tslib_1.__extends(GridLocationList, _super);
	    function GridLocationList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    GridLocationList.fetchData = function (routerParams) {
	        console.log("GridLocationList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    GridLocationList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query }));
	    };
	    GridLocationList.module = metaConstant_1.MODULE.core;
	    GridLocationList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Grids"], ["Grids"])));
	    GridLocationList.icon = 'table';
	    GridLocationList.rootPage = true;
	    GridLocationList.protectedPage = true;
	    GridLocationList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], GridLocationList);
	    return GridLocationList;
	}(pageAncestor_1.default));
	exports.default = GridLocationList;
	var templateObject_1;


/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var formUtils_1 = __webpack_require__(14);
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var blockComp_1 = __webpack_require__(30);
	var domUtils_1 = __webpack_require__(91);
	var utils_1 = __webpack_require__(37);
	var gridSpecialCondition_1 = __webpack_require__(937);
	var mobx_1 = __webpack_require__(5);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var buttons_1 = __webpack_require__(27);
	var mobx_react_1 = __webpack_require__(4);
	var storage_1 = __webpack_require__(173);
	var form_1 = __webpack_require__(52);
	var locales_1 = __webpack_require__(15);
	var AceEditor;
	var GridSpecialConditionDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(GridSpecialConditionDetail, _super);
	    function GridSpecialConditionDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            aceHeightBody: 400
	        };
	        _this.onResize = function (evt) {
	            var bodyRect = document.body.getBoundingClientRect();
	            var aceHeightBody = (0, domUtils_1.computeHeight)(bodyRect, _this._aceEditorBody);
	            console.debug("onResize: " + aceHeightBody);
	            if (aceHeightBody) {
	                _this.setState({ aceHeightBody: aceHeightBody });
	            }
	        };
	        /* ****************   EVENT HENDLERS ************************************************************ */
	        _this.customValidate = function (specialCondition) {
	            var errors = [];
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave ');
	            uiService_1.default.showToolbarActionFlag();
	            var result = (0, formUtils_1.preSave)(gridService_1.default.specialConditionObject, _this.customValidate);
	            if (!result) {
	                return;
	            }
	            gridService_1.default.saveSpecialCondition(gridService_1.default.specialConditionObject)
	                .then((0, mobx_1.action)("saveSpecialCondition-action", function (specialConditionJson) {
	                var wasNew = gridService_1.default.specialConditionObject.cleanAfterSave(specialConditionJson);
	                if (wasNew) {
	                    _this.context.router.replaceWith('gridSpecialConditionDetail', { id: gridService_1.default.specialConditionObject.id });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	                gridService_1.default.removeGrid(gridService_1.default.specialConditionObject.gridLocation);
	                (0, storage_1.removeItemFromLocalStorage)("GridLocation", locales_1.loc.lang, gridService_1.default.specialConditionObject.gridLocation);
	            }));
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            gridService_1.default.deleteSpecialCondition(gridService_1.default.specialConditionObject.specialConditionId)
	                .then(function (response) {
	                gridService_1.default.removeGrid(gridService_1.default.specialConditionObject.gridLocation);
	                (0, storage_1.removeItemFromLocalStorage)("GridLocation", locales_1.loc.lang, gridService_1.default.specialConditionObject.gridLocation);
	                _this.onBack();
	            }, function (error) {
	                gridService_1.default.specialConditionObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            var query = {};
	            _this.context.router.transitionTo("gridSpecialConditionDetail", { id: 'new' }, query);
	        };
	        _this.onCopy = function (evt) {
	            console.log('onCopy');
	            _this.context.router.transitionTo("gridSpecialConditionDetail", { id: 'copy' }, { copyId: gridService_1.default.specialConditionObject.specialConditionId });
	        };
	        _this.onBack = function () {
	            console.log('onClickBack');
	            var query = {};
	            _this.context.router.transitionTo("gridLocationDetail", { id: gridService_1.default.specialConditionObject.gridLocation }, query);
	        };
	        _this.onChangeSql = function (newValue) {
	            console.log('onChangeSql');
	            gridService_1.default.specialConditionObject.sql = newValue;
	            gridService_1.default.specialConditionObject.$dirty = true;
	        };
	        return _this;
	    }
	    GridSpecialConditionDetail.fetchData = function (routerParams, query) {
	        console.log("GridSpecialConditionDetail#fetchData(%o)", routerParams);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['GridSpecialCondition']);
	        var specialConditionPromise;
	        if (routerParams.id === 'new') {
	            specialConditionPromise = Promise.resolve(new gridSpecialCondition_1.GridSpecialCondition(Object.assign({ $new: true }, query)));
	        }
	        else if (routerParams.id === 'copy') {
	            specialConditionPromise = gridService_1.default.readSpecialCondition(query.copyId)
	                .then(function (specialCondition) {
	                specialCondition.cleanOnCopy();
	                return specialCondition;
	            });
	        }
	        else {
	            specialConditionPromise = gridService_1.default.readSpecialCondition(routerParams.id);
	        }
	        return Promise.all([metadataPromise, specialConditionPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], specialCondition = _a[1];
	            gridService_1.default.specialConditionObject = specialCondition.initAfterRead(routerParams.id === 'new');
	            if (gridService_1.default.specialConditionObject.sql == null)
	                gridService_1.default.specialConditionObject.sql = '';
	        });
	    };
	    GridSpecialConditionDetail.prototype.componentWillMount = function () {
	        var _this = this;
	        __webpack_require__.e/* nsure */(0, function (require) {
	            if (AceEditor) {
	                return;
	            }
	            AceEditor = __webpack_require__(153).default;
	            var brace = __webpack_require__(133);
	            __webpack_require__(316);
	            __webpack_require__(147);
	            __webpack_require__(146);
	            _this.forceUpdate();
	            _this.onResize();
	        });
	    };
	    GridSpecialConditionDetail.prototype.componentDidMount = function () {
	        console.debug("%c componentDidMount", "background-color: magenta");
	        this.onResizeDebounced = (0, utils_1.debounce)(this.onResize, 15, false);
	        window.addEventListener('resize', this.onResizeDebounced);
	        this.onResize();
	    };
	    GridSpecialConditionDetail.prototype.componentWillUnmount = function () {
	        window.removeEventListener('resize', this.onResizeDebounced);
	        gridService_1.default.specialConditionObject = null;
	    };
	    /* ****************   REACT METHODS ************************************************************ */
	    GridSpecialConditionDetail.prototype.render = function () {
	        var _this = this;
	        var query = this.props.query;
	        return (react_1.default.createElement("main", { className: "main-content container" },
	            this._createToolMenu(gridService_1.default.specialConditionObject, query.gridLocation),
	            react_1.default.createElement("form", { style: { marginTop: 10 } },
	                react_1.default.createElement(GridSpecialConditionForm, { dataObject: gridService_1.default.specialConditionObject, rootObject: gridService_1.default.specialConditionObject, entity: mdEntityService_1.default.getEntity('GridSpecialCondition'), entities: mdEntityService_1.default.entityMap }),
	                react_1.default.createElement("h5", null, "Where condition SQL"),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12" }, (AceEditor) ?
	                        react_1.default.createElement(AceEditor, { mode: "sql", theme: "github", value: gridService_1.default.specialConditionObject.sql, onChange: this.onChangeSql, name: "SQL", enableBasicAutocompletion: true, enableLiveAutocompletion: true, editorProps: { $blockScrolling: true }, width: "100%", height: this.state.aceHeightBody + 'px', style: { padding: '5px 0 0 0' }, ref: function (c) { return _this._aceEditorBody = c; } })
	                        : "Loading....")))));
	    };
	    /* ****************   NORMAL METHODS ************************************************************ */
	    GridSpecialConditionDetail.prototype._createToolMenu = function (specialCondition, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !specialCondition.$dirty, label: "Save", permission: specialCondition.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, disabled: specialCondition.$new, label: "New", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onCopy, disabled: specialCondition.$new, label: "Copy", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onDelete, disabled: specialCondition.$new, label: "Delete", permission: metaConstant_1.PERMISSION.Delete })));
	    };
	    GridSpecialConditionDetail.module = metaConstant_1.MODULE.core;
	    GridSpecialConditionDetail.title = 'Special Condidition';
	    GridSpecialConditionDetail.icon = 'wrench';
	    GridSpecialConditionDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridSpecialConditionDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], GridSpecialConditionDetail.prototype, "onDelete", void 0);
	    GridSpecialConditionDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], GridSpecialConditionDetail);
	    return GridSpecialConditionDetail;
	}(pageAncestor_1.default));
	exports.default = GridSpecialConditionDetail;
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
	        react_1.default.createElement("h5", { style: { marginTop: 0, fontSize: '18px', fontWeight: 'bold' } },
	            " ",
	            dataObject.name),
	        react_1.default.createElement("div", null, dataObject.description)));
	};
	var GridSpecialConditionForm = /** @class */ (function (_super) {
	    tslib_1.__extends(GridSpecialConditionForm, _super);
	    function GridSpecialConditionForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    GridSpecialConditionForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, formName = _a.formName, entity = _a.entity;
	        var fields = dataObject.getFormFields(formName);
	        var name = fields.name, description = fields.description, sql = fields.sql;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, description.props, { multiLine: true, rows: 2 }))))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true },
	            react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate }, this.props))));
	    };
	    GridSpecialConditionForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'GridSpecialConditionForm',
	            fields: [{
	                    name: 'name',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'description',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	                }]
	        }, ClosedContent),
	        mobx_react_1.observer
	    ], GridSpecialConditionForm);
	    return GridSpecialConditionForm;
	}(react_1.default.Component));


/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.triggerGridLocation = exports.jobHistoryGridLocation = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var jobService_1 = tslib_1.__importDefault(__webpack_require__(569));
	var errorComp_1 = __webpack_require__(34);
	var formUtils_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(37);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridComp_1 = tslib_1.__importStar(__webpack_require__(44));
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var triggerForm_1 = tslib_1.__importDefault(__webpack_require__(2109));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var jobDomain_1 = __webpack_require__(939);
	var gridUtils_1 = __webpack_require__(83);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var mobx_1 = __webpack_require__(5);
	var buttons_1 = __webpack_require__(27);
	var JobDetailForms = tslib_1.__importStar(__webpack_require__(2107));
	var locales_1 = __webpack_require__(15);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	exports.jobHistoryGridLocation = 'jobHistoryList';
	exports.triggerGridLocation = 'triggerList';
	var JobDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(JobDetail, _super);
	    function JobDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.customValidate = function (jobObject) {
	            var errors = [];
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave ', jobService_1.default.jobObject);
	            uiService_1.default.showToolbarActionFlag();
	            var result = (0, formUtils_1.preSave)(jobService_1.default.jobObject, _this.customValidate);
	            if (!result) {
	                return;
	            }
	            jobService_1.default.jobSave(jobService_1.default.jobObject.createDataObjectDto())
	                .then((0, mobx_1.action)("jobSave-callback", function (jobJson) {
	                var wasNew = jobService_1.default.jobObject.cleanAfterSave(jobJson);
	                if (wasNew) {
	                    _this.context.router.replaceWith('jobDetail', { id: jobService_1.default.jobObject.id }); // {id: formatId(jobObject.group, jobObject.name)}
	                    window.location.reload(true);
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            }), function (error) {
	                jobService_1.default.jobObject.$errors = error.getMessages();
	            });
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            jobService_1.default.deleteJob(jobService_1.default.jobObject)
	                .then(function (response) {
	                _this.context.router.transitionTo('jobList');
	            }, function (error) {
	                jobService_1.default.jobObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAddTrigger = function (evt) {
	            console.log('onAddTrigger');
	            var grid = jobService_1.default.jobObject.$movingBlocks.getBlock(exports.triggerGridLocation);
	            var rowObject = new jobDomain_1.TriggerInfo({
	                misfirePolicy: { value: 'DO_NOTHING', label: 'DO_NOTHING' },
	                $new: true,
	                $dirty: true,
	                $added: true
	            }).initDefaultValues();
	            grid.addRow(rowObject);
	            var form = rowObject.getForm('TriggerForm');
	            form.$open = true;
	            jobService_1.default.jobObject.$dirty = true;
	        };
	        _this.onRunNow = function (evt) {
	            console.log('onRunNow');
	            jobService_1.default.oneOff(jobService_1.default.jobObject)
	                .then(function (res) {
	                jobService_1.default.jobObject.$movingBlocks.searchExposedGrids(jobService_1.default.jobObject, true);
	            });
	        };
	        _this.refresh = function (evt) {
	            console.log('refresh');
	            jobService_1.default.jobObject.$movingBlocks.searchExposedGrids(jobService_1.default.jobObject, true);
	        };
	        _this.switchState = function (rowId) {
	            console.log('switchState %s', rowId);
	            var jobObject = jobService_1.default.jobObject;
	            if (!jobObject.$new && !securityService_1.default.hasRight(metaConstant_1.SECURABLE.jobDetail.name, metaConstant_1.PERMISSION.Update, jobObject.id)) {
	                commonService_1.default.notifyError("You do not have permission to enable or disable schedule of this job", "Error");
	                return;
	            }
	            var strings = (0, utils_1.parseId)(rowId);
	            jobService_1.default.switchState(new jobDomain_1.TriggerInfo({ group: strings[0], name: strings[1] }))
	                .then(function (res) {
	                jobObject.$movingBlocks.getBlock(exports.triggerGridLocation).search(jobObject, true);
	            });
	        };
	        return _this;
	    }
	    JobDetail.fetchData = function (routerParams, query) {
	        console.log("JobDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['JobInfo', 'JobLog', 'TriggerInfo']);
	        var jobPromise = jobService_1.default.readJob(routerParams.id);
	        var gridPromise = gridService_1.default.fetchGrids(exports.jobHistoryGridLocation, exports.triggerGridLocation);
	        return Promise.all([metadataPromise, jobPromise, gridPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], jobObject = _a[1], gridLocationMap = _a[2];
	            jobObject.$new = query.new;
	            if (jobObject.$new)
	                jobObject.$dirty = true;
	            jobObject.$movingBlocks = new gridUtils_1.MovingBlocks(null, false, null, new grid_1.default(gridLocationMap.get(exports.triggerGridLocation), jobObject.id), new grid_1.default(gridLocationMap.get(exports.jobHistoryGridLocation), jobObject.id));
	            jobService_1.default.jobObject = jobObject.initAfterRead(jobObject.$new);
	        });
	    };
	    /**
	     * tohle je tady kvuli prechodu na jiny detail invoice (chained details)
	     * @param prevProps
	     */
	    JobDetail.prototype.componentDidUpdate = function (prevProps) {
	        if ((prevProps.query.new && !this.props.query.new) // protoze id neni generovane
	            || this.idChanged(prevProps.params.id, this.props.params.id)) {
	            jobService_1.default.jobObject.$movingBlocks.searchExposedGrids(jobService_1.default.jobObject);
	        }
	    };
	    JobDetail.prototype.componentDidMount = function () {
	        jobService_1.default.jobObject.$movingBlocks.searchExposedGrids(jobService_1.default.jobObject);
	    };
	    JobDetail.prototype.componentWillUnmount = function () {
	        jobService_1.default.jobObject = null;
	    };
	    JobDetail.prototype.findRootObject = function () {
	        return jobService_1.default.jobObject;
	    };
	    JobDetail.prototype.render = function () {
	        var query = this.props.query;
	        // const propsForCreateForm = {
	        //   dataObject: jobService.jobObject,
	        //   rootObject: jobService.jobObject,
	        //   entity: mdEntityService.getEntity("JobInfo"),
	        //   entities: mdEntityService.entityMap
	        // };
	        console.debug('%c jobDetail render query %O', 'background-color: yellow', this.props.query);
	        var jobObject = jobService_1.default.jobObject;
	        var movingBlocks = jobObject.$movingBlocks;
	        // let triggerGrid = Grid.safeGet(jobObject, triggerGridLocation);
	        // let jobHistoryGrid = Grid.safeGet(jobObject, jobHistoryGridLocation);
	        var rowTriggerForm = (react_1.default.createElement(triggerForm_1.default, { rootObject: jobObject, entity: mdEntityService_1.default.getEntity('TriggerInfo'), entities: mdEntityService_1.default.entityMap, dataObject: null }));
	        var detailComponent;
	        if (jobObject.detailComponent) {
	            var enabled = (!jobObject.$new && securityService_1.default.hasRight(metaConstant_1.SECURABLE.jobDetail.name, metaConstant_1.PERMISSION.Update, jobObject.id.toString())) || (jobObject.$new && securityService_1.default.hasRight(metaConstant_1.SECURABLE.jobDetail.name, metaConstant_1.PERMISSION.New));
	            var DetailComponentForm = JobDetailForms[jobObject.detailComponent + 'Form'];
	            detailComponent = react_1.default.createElement(DetailComponentForm, { dataObject: jobObject, rootObject: jobObject, entities: mdEntityService_1.default.entityMap, entity: mdEntityService_1.default.getEntity('JobInfo'), disabled: !enabled });
	        }
	        else {
	            detailComponent = (react_1.default.createElement("h3", null, jobObject.group + ' - ' + jobObject.name));
	        }
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	            this._createToolMenu(jobObject, query.gridLocation),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: jobObject.$errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	            react_1.default.createElement("form", { style: { marginTop: 10 } }, detailComponent),
	            react_1.default.createElement("h5", null, "Triggers"),
	            react_1.default.createElement(gridComp_1.default, { ref: exports.triggerGridLocation, grid: movingBlocks.getBlock(exports.triggerGridLocation), hideToolbar: true, uiLocation: gridComp_1.UILOCATION.main, showEdit: securityService_1.default.hasRight(metaConstant_1.SECURABLE.jobDetail.name, metaConstant_1.PERMISSION.Update, jobObject.$new ? undefined : jobObject.id), showDelete: securityService_1.default.hasRight(metaConstant_1.SECURABLE.jobDetail.name, metaConstant_1.PERMISSION.Update, jobObject.$new ? undefined : jobObject.id), deleteRowIcon: "fa fa-trash", rootObject: jobObject, editForm: rowTriggerForm, editFormName: "TriggerForm", entities: mdEntityService_1.default.entityMap, functionMap: { switchState: this.switchState.bind(this) } }),
	            react_1.default.createElement("h5", null, "Run History"),
	            react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(exports.jobHistoryGridLocation), uiLocation: gridComp_1.UILOCATION.main, entities: mdEntityService_1.default.entityMap, hideToolbar: true }),
	            react_1.default.createElement("h6", null, "Possible Trigger state explained:"),
	            react_1.default.createElement("table", { className: "table table-condensed fullwrap" },
	                react_1.default.createElement("tbody", null,
	                    react_1.default.createElement("tr", null,
	                        react_1.default.createElement("td", { className: "color-green-500", style: { width: 80 } }, "NORMAL"),
	                        react_1.default.createElement("td", null, "Indicates that the Trigger is in the \"normal\" state.")),
	                    react_1.default.createElement("tr", null,
	                        react_1.default.createElement("td", { className: "color-green-500" }, "BLOCKED"),
	                        react_1.default.createElement("td", null, "Indicates that the Trigger is in the \"blocked\" state. A Trigger arrives at the blocked state when the job that it is associated with is a StatefulJob and it is currently executing.")),
	                    react_1.default.createElement("tr", null,
	                        react_1.default.createElement("td", { className: "color-grey-500" }, "PAUSED"),
	                        react_1.default.createElement("td", null, "Indicates that the Trigger is in the \"paused\" state.")),
	                    react_1.default.createElement("tr", null,
	                        react_1.default.createElement("td", { className: "color-grey-500" }, "COMPLETE"),
	                        react_1.default.createElement("td", null, "Indicates that the Trigger is in the \"complete\" state. \"Complete\" indicates that the trigger has not remaining fire-times in its schedule.")),
	                    react_1.default.createElement("tr", null,
	                        react_1.default.createElement("td", { className: "color-red-500" }, "ERROR"),
	                        react_1.default.createElement("td", null, "Indicates that the Trigger is in the \"error\" state. A Trigger arrives at the error state when the scheduler attempts to fire it, but cannot due to an error creating and executing its related job. Often this is due to the Job's class not existing in the classpath. When the trigger is in the error state, the scheduler will make no attempts to fire it."))))));
	    };
	    JobDetail.prototype._createToolMenu = function (jobObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: History.length <= 1 },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !jobObject.$dirty, label: "Save", permission: jobObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update, detailId: jobObject.$new ? undefined : jobObject.id }),
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "JobInfo", pageAncestor: this, onClick: this.onDelete, disabled: jobObject.$new, label: "Delete", permission: metaConstant_1.PERMISSION.Delete, detailId: jobObject.id }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAddTrigger, label: "Add Trigger", permission: jobObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update, detailId: jobObject.$new ? undefined : jobObject.id }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onRunNow, disabled: jobObject.$new, label: "Run Now!", permission: metaConstant_1.PERMISSION.Execute, detailId: jobObject.id }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.refresh, disabled: jobObject.$new, label: "Refresh" })));
	    };
	    JobDetail.module = metaConstant_1.MODULE.core;
	    JobDetail.title = 'JobInfo';
	    JobDetail.icon = 'cogs';
	    JobDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], JobDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], JobDetail.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], JobDetail.prototype, "onAddTrigger", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], JobDetail.prototype, "onRunNow", void 0);
	    JobDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], JobDetail);
	    return JobDetail;
	}(pageAncestor_1.default));
	exports.default = JobDetail;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DataImportForm = exports.QueueForm = exports.InvoiceToArchiveForm = exports.ProcessBrimMessageForm = exports.DownloadBankTxForm = exports.InvoiceToAccForm = exports.EODForm = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var formUtils_1 = __webpack_require__(14);
	var createForm_1 = __webpack_require__(18);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var mdField_1 = __webpack_require__(57);
	var mdField_2 = tslib_1.__importDefault(__webpack_require__(57));
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var dateUtils_1 = __webpack_require__(49);
	var eventDomain_1 = __webpack_require__(74);
	var closedForm_1 = __webpack_require__(82);
	var colors_1 = __webpack_require__(29);
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var rules_1 = __webpack_require__(56);
	var tenantService_1 = tslib_1.__importDefault(__webpack_require__(402));
	var transformedTextThStyle = {
	    height: "200px",
	    lineHeight: "14px",
	    paddingBottom: "20px",
	    textAlign: "left"
	};
	var transformedTextDivStyle = {
	    marginLeft: "-75px",
	    position: "absolute",
	    width: "195px",
	    transform: "rotate(-90deg)",
	    lineHeight: "14px",
	    textAlign: "left"
	};
	var checkboxTdStyle = {
	    textAlign: "center"
	};
	var HeadingDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  font-size: 18px;\n  color: ", "\n"], ["\n  font-size: 18px;\n  color: ", "\n"])), colors_1.grey400);
	var EodTable = /** @class */ (function (_super) {
	    tslib_1.__extends(EodTable, _super);
	    function EodTable() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onChangeEodMap = function (tenantId, step, evt) {
	            var _a = _this.props, eodMap = _a.eodMap, onChange = _a.onChange;
	            var checked = evt.target.checked;
	            eodMap[tenantId][step] = checked;
	            console.log("onChangeEodMap ", tenantId, step, checked, eodMap);
	            if (onChange) {
	                onChange(tenantId, step, checked);
	            }
	        };
	        return _this;
	    }
	    EodTable.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, eodMap = _a.eodMap, disabled = _a.disabled, dataObject = _a.dataObject;
	        if (!eodMap)
	            return react_1.default.createElement("noscript", null);
	        var eodPhaseEntity = mdEntityService_1.default.getEntity("EODPHASE");
	        var tenantEntity = mdEntityService_1.default.getEntity("Tenant");
	        var phasesBodLV = eodPhaseEntity.lovItems.filter(function (lv) { return lv["BoD"]; });
	        var phasesEodLV = eodPhaseEntity.lovItems.filter(function (lv) { return !lv["BoD"]; });
	        return (react_1.default.createElement("div", { style: { display: 'flex' } },
	            react_1.default.createElement("div", null,
	                react_1.default.createElement(HeadingDiv, null,
	                    react_1.default.createElement("span", null, "End of date"),
	                    " ",
	                    react_1.default.createElement("span", null,
	                        " (",
	                        (0, dateUtils_1.formatDate)(dataObject.oldBusinessDate),
	                        ")")),
	                react_1.default.createElement("table", null,
	                    react_1.default.createElement("thead", null,
	                        react_1.default.createElement("tr", null,
	                            react_1.default.createElement("th", null),
	                            phasesEodLV.map(function (li) { return react_1.default.createElement("th", { key: li.value, style: transformedTextThStyle },
	                                react_1.default.createElement("div", { style: transformedTextDivStyle }, (0, formUtils_1.lovLabel)(li))); }))),
	                    react_1.default.createElement("tbody", null, tenantEntity.lovItems.map(function (tenant) { return (react_1.default.createElement("tr", { key: tenant.value },
	                        react_1.default.createElement("td", null, (0, formUtils_1.lovLabel)(tenant)),
	                        phasesEodLV.map(function (step) { return (react_1.default.createElement("td", { key: step.value, style: checkboxTdStyle },
	                            react_1.default.createElement(fields_1.MdCheckbox, { checked: eodMap[tenant.value][step.value], disabled: disabled, onCheck: _this.onChangeEodMap.bind(_this, tenant.value, step.value) }))); }))); })))),
	            react_1.default.createElement("div", { style: { width: 40 }, className: "block-comp-right-border" }),
	            react_1.default.createElement("div", { style: { width: 40 } }),
	            react_1.default.createElement("div", null,
	                react_1.default.createElement(HeadingDiv, null,
	                    react_1.default.createElement("span", null, "Begining of date"),
	                    " ",
	                    react_1.default.createElement("span", null,
	                        "  (",
	                        (0, dateUtils_1.formatDate)(dataObject.newBusinessDate),
	                        ")")),
	                react_1.default.createElement("table", null,
	                    react_1.default.createElement("thead", null,
	                        react_1.default.createElement("tr", null,
	                            react_1.default.createElement("th", null),
	                            phasesBodLV.map(function (li) { return react_1.default.createElement("th", { key: li.value, style: transformedTextThStyle },
	                                react_1.default.createElement("div", { style: transformedTextDivStyle }, (0, formUtils_1.lovLabel)(li))); }))),
	                    react_1.default.createElement("tbody", null, tenantEntity.lovItems.map(function (tenant) { return (react_1.default.createElement("tr", { key: tenant.value },
	                        react_1.default.createElement("td", null, (0, formUtils_1.lovLabel)(tenant)),
	                        phasesBodLV.map(function (step) { return (react_1.default.createElement("td", { key: step.value, style: checkboxTdStyle },
	                            react_1.default.createElement(fields_1.MdCheckbox, { checked: eodMap[tenant.value][step.value], disabled: disabled, onCheck: _this.onChangeEodMap.bind(_this, tenant.value, step.value) }))); }))); }))))));
	    };
	    EodTable = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EodTable);
	    return EodTable;
	}(react_1.default.Component));
	var EODClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
	        react_1.default.createElement("h3", null, dataObject.group + ' - ' + dataObject.name),
	        react_1.default.createElement(EodTable, { eodMap: dataObject.eodMap, disabled: true, dataObject: dataObject })));
	};
	var EODForm = /** @class */ (function (_super) {
	    tslib_1.__extends(EODForm, _super);
	    function EODForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onChange = function (tenantId, step, checked) {
	            _this.props.rootObject.$dirty = true;
	        };
	        return _this;
	    }
	    EODForm.prototype.componentWillReceiveProps = function (nextProps) {
	        console.debug('EODForm componentWillReceiveProps ', nextProps);
	    };
	    EODForm.prototype.componentDidMount = function () {
	        console.debug('EODForm componentDidMount');
	        var dataObject = this.props.dataObject;
	        mdEntityService_1.default.fetchEntities([{ entity: 'EODPHASE', lov: true }, {
	                entity: 'Tenant',
	                lov: true
	            }]).then((0, mobx_1.action)("action-cb", function (entityMap) {
	            var eodPhaseEntity = entityMap.get("EODPHASE");
	            var tenantEntity = entityMap.get("Tenant");
	            var eodDef = (dataObject.arguments && dataObject.arguments.length) ? dataObject.arguments[0] : null;
	            // Vytvorim prazdnou mapu TEodMap a zaskrtam policka podle TEodDef
	            dataObject.eodMap = tenantEntity.lovItems.reduce(function (acc, tenant) {
	                acc[tenant.value] = eodPhaseEntity.lovItems.reduce(function (phases, eodPhase) {
	                    phases[eodPhase.value] = !!(eodDef && eodDef[eodPhase.value] && eodDef[eodPhase.value].includes(tenant.value));
	                    return phases;
	                }, {});
	                return acc;
	            }, {});
	        }));
	    };
	    EODForm.prototype.render = function () {
	        console.log("render EODForm ", this.props.dataObject.eodMap);
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, index = _a.index, entities = _a.entities, entity = _a.entity, formName = _a.formName, disabled = _a.disabled;
	        var fields = dataObject.getFormFields(formName);
	        var name = fields.name, eodMap = fields.eodMap;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props, { disabled: !dataObject.$new })),
	                    react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12" },
	                    react_1.default.createElement(EodTable, { eodMap: dataObject.eodMap, onChange: this.onChange, dataObject: dataObject })))));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(EODClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate, disableEditing: disabled }, this.props)));
	    };
	    EODForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'EODForm',
	            fields: [{
	                    name: 'name',
	                    validators: ['IsRequired']
	                }],
	            onCommit: function (dataObject) {
	                // konvertuju z TEodMap do TEodDef
	                dataObject.arguments = [Object.entries(dataObject.eodMap).reduce(function (acc, _a) {
	                        var tenantId = _a[0], stepMap = _a[1];
	                        Object.entries(stepMap).filter(function (_a) {
	                            var step = _a[0], checked = _a[1];
	                            return checked;
	                        }).forEach(function (_a) {
	                            var step = _a[0], checked = _a[1];
	                            var tenants = acc[step];
	                            if (!tenants) {
	                                tenants = [];
	                                acc[step] = tenants;
	                            }
	                            tenants.push(parseInt(tenantId));
	                        });
	                        return acc;
	                    }, {})];
	            }
	        }, EODClosedContent),
	        mobx_react_1.observer
	    ], EODForm);
	    return EODForm;
	}(react_1.default.Component));
	exports.EODForm = EODForm;
	/* ************************************************************************************************
	 * ***********   InvoiceToAccForm *************************************************************
	 * ********************************************************************************************** */
	var InvoiceToAccFormCC = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", null,
	        react_1.default.createElement("h3", null, dataObject.group + ' - ' + dataObject.name),
	        react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields, singleColumn: true },
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.documentTypes.textLabel, value: dataObject.documentTypes }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.eventType.textLabel, value: dataObject.eventType }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.invoiceTypes.textLabel, value: dataObject.invoiceTypes }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.limitByProfitCenter.textLabel, value: dataObject.limitByProfitCenter, mdField: fields.limitByProfitCenter.mdField }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.profitCenters.textLabel, value: dataObject.profitCenters }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.onlyForDomesticCustomers.textLabel, value: dataObject.onlyForDomesticCustomers, mdField: fields.onlyForDomesticCustomers.mdField }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.waitForTaxConfirmation.textLabel, value: dataObject.waitForTaxConfirmation, mdField: fields.waitForTaxConfirmation.mdField }))));
	};
	var InvoiceToAccForm = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceToAccForm, _super);
	    function InvoiceToAccForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleLimitByProfitCenter = function (evt) {
	            var _a = _this.props, entities = _a.entities, dataObject = _a.dataObject, form = _a.form, rootObject = _a.rootObject;
	            console.debug('handleLimitByProfitCenter ', evt, dataObject.limitByProfitCenter);
	            form.getField("limitByProfitCenter").props.onCheck(evt);
	            dataObject.profitCenters = [];
	            form.updateFieldsPropValue(dataObject, "profitCenters");
	        };
	        _this.onSuccessEventType = function () {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            tenantService_1.default.getBindedTenants(["DocumentType", "EventType"], {
	                "DocumentTypeIds": dataObject.documentTypes.map(function (x) { return (0, formUtils_1.lovValue)(x); }),
	                "EventTypeIds": [(0, formUtils_1.lovValue)(dataObject.eventType)]
	            })
	                .then(function (tenantLovs) {
	                return (tenantLovs.length) ? mdEntityService_1.default.fetchMissingEntityLovs(["ProfitCenter"], tenantLovs.map(function (lov) { return (0, formUtils_1.lovValue)(lov); })) : Promise.resolve({ "ProfitCenter": [] });
	            })
	                .then(function (lovsMap) {
	                var profitCenterLovs = lovsMap["ProfitCenter"];
	                form.getField("profitCenters").props.options = profitCenterLovs;
	                dataObject.profitCenters = (dataObject.profitCenters && dataObject.profitCenters.length) ? dataObject.profitCenters.map(function (lov) { return profitCenterLovs.find(function (x) { return (0, formUtils_1.lovValue)(x) === (0, formUtils_1.lovValue)(lov); }); }).filter(function (x) { return !!x; }) : [];
	                form.updateFieldsPropValue(dataObject, "profitCenters");
	            });
	        };
	        _this.onChangeDocumentTypes = function (evt) {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            var field = form.getField("documentTypes");
	            field.props.onChange(evt);
	            form.updateFieldPropValue(field, dataObject);
	            _this.onSuccessEventType();
	        };
	        return _this;
	    }
	    InvoiceToAccForm.prototype.componentWillReceiveProps = function (nextProps) {
	        console.debug('InvoiceToAccForm componentWillReceiveProps ', nextProps);
	    };
	    InvoiceToAccForm.prototype.componentDidMount = function () {
	        console.debug('InvoiceToAccForm componentDidMount');
	        var _a = this.props, dataObject = _a.dataObject, form = _a.form;
	        var docTypesIds = (dataObject.arguments && dataObject.arguments.length) ? dataObject.arguments[0].slice() : [];
	        var eventTypeIds = (dataObject.arguments && dataObject.arguments.length > 1) ? [dataObject.arguments[1]] : [];
	        Promise.all([mdEntityService_1.default.fetchEntities([{ entity: 'DocumentType', lov: true }, {
	                    entity: 'EventType',
	                    lov: true
	                }, { entity: 'ProfitCenter' }, { entity: "InvoiceType", lov: true }]),
	            tenantService_1.default.getBindedTenants(["DocumentType", "EventType"], {
	                "DocumentTypeIds": docTypesIds,
	                "EventTypeIds": eventTypeIds
	            })])
	            .then(function (_a) {
	            var entityMap = _a[0], tenantLovs = _a[1];
	            form.initForm(entityMap.get("JobInfo"), entityMap, dataObject, dataObject, null);
	            if (dataObject.arguments && dataObject.arguments.length) {
	                var dtMdEntity_1 = entityMap.get("DocumentType");
	                dataObject.documentTypes = (docTypesIds && docTypesIds.length) ? docTypesIds.map(function (dtId) { return dtMdEntity_1.getLovItem(dtId); }) : [];
	            }
	            var eventTypeEntity = entityMap.get("EventType");
	            if (dataObject.arguments && dataObject.arguments.length > 1) {
	                dataObject.eventType = eventTypeEntity.getLovItem(dataObject.arguments[1]);
	            }
	            if (dataObject.arguments && dataObject.arguments.length > 2) {
	                dataObject.limitByProfitCenter = dataObject.arguments[2];
	            }
	            var invoiceTypeEntity = entityMap.get("InvoiceType");
	            if (dataObject.arguments && dataObject.arguments.length > 4) {
	                var invoiceTypeIds = dataObject.arguments[4];
	                dataObject.invoiceTypes = (invoiceTypeIds && invoiceTypeIds.length) ? invoiceTypeIds.map(function (dtId) { return invoiceTypeEntity.lovItems.find(function (x) { return x.value === dtId; }); }).filter(function (x) { return !!x; }) : [];
	            }
	            if (dataObject.arguments && dataObject.arguments.length > 5) {
	                dataObject.onlyForDomesticCustomers = dataObject.arguments[5];
	            }
	            if (dataObject.arguments && dataObject.arguments.length > 6) {
	                dataObject.waitForTaxConfirmation = dataObject.arguments[6];
	            }
	            form.getField("eventType").props.options = eventTypeEntity.lovItems.filter(function (li) { return li["eventType"] === ((dataObject.group === 'InvoiceToAcc') ? eventDomain_1.EVENTTYPE.INVOICE_SENT_ACCOUNTING : eventDomain_1.EVENTTYPE.INVOICE_SENT_TAX_OFFICE); });
	            return (tenantLovs.length) ? mdEntityService_1.default.fetchMissingEntityLovs(["ProfitCenter"], tenantLovs.map(function (lov) { return (0, formUtils_1.lovValue)(lov); })) : Promise.resolve({ "ProfitCenter": [] });
	        })
	            .then(function (lovsMap) {
	            var profitCenterLovs = lovsMap["ProfitCenter"];
	            form.getField("profitCenters").props.options = profitCenterLovs;
	            if (dataObject.arguments && dataObject.arguments.length > 3) {
	                var profitCenterIds = dataObject.arguments[3];
	                dataObject.profitCenters = (profitCenterIds && profitCenterIds.length) ? profitCenterIds.map(function (dtId) { return profitCenterLovs.find(function (x) { return x.value === dtId; }); }).filter(function (x) { return !!x; }) : [];
	            }
	            form.updateAllFieldsPropValue(dataObject);
	        });
	    };
	    InvoiceToAccForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, index = _a.index, entities = _a.entities, entity = _a.entity, formName = _a.formName, disabled = _a.disabled;
	        var fields = dataObject.getFormFields(formName);
	        var name = fields.name, documentTypes = fields.documentTypes, eventType = fields.eventType, profitCenters = fields.profitCenters, limitByProfitCenter = fields.limitByProfitCenter, invoiceTypes = fields.invoiceTypes, onlyForDomesticCustomers = fields.onlyForDomesticCustomers, waitForTaxConfirmation = fields.waitForTaxConfirmation;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props, { disabled: !dataObject.$new })),
	                    react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, documentTypes.props, { multi: true, onChange: this.onChangeDocumentTypes })),
	                    react_1.default.createElement(validate_1.Validate, { field: documentTypes, value: documentTypes.props.value, dataObject: dataObject })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, eventType.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: eventType, value: eventType.props.value, dataObject: dataObject, onSuccess: this.onSuccessEventType }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, invoiceTypes.props, { multi: true })),
	                    react_1.default.createElement(validate_1.Validate, { field: invoiceTypes, value: invoiceTypes.props.value, dataObject: dataObject })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, limitByProfitCenter.props, { onCheck: this.handleLimitByProfitCenter }))),
	                (dataObject.limitByProfitCenter) ? (react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, profitCenters.props, { multi: true })),
	                    react_1.default.createElement(validate_1.Validate, { field: profitCenters, value: profitCenters.props.value, dataObject: dataObject }))) : null),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, onlyForDomesticCustomers.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, waitForTaxConfirmation.props))))));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(InvoiceToAccFormCC, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate, disableEditing: disabled }, this.props)));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceToAccForm.prototype, "handleLimitByProfitCenter", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceToAccForm.prototype, "onSuccessEventType", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceToAccForm.prototype, "onChangeDocumentTypes", void 0);
	    InvoiceToAccForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'InvoiceToAccForm',
	            fields: [{
	                    name: 'name',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'documentTypes',
	                    validators: ['IsRequired'],
	                    omitNullOption: true,
	                    mdField: new mdField_2.default({ label: 'Document Types', valueSource: 'DocumentType', valueSourceType: mdField_1.VALUESOURCETYPE.LOCAL })
	                }, {
	                    name: 'eventType',
	                    validators: ['IsRequired'],
	                    mdField: new mdField_2.default({ label: 'Event Type', valueSource: 'EventType', valueSourceType: mdField_1.VALUESOURCETYPE.LOCAL })
	                }, {
	                    name: 'invoiceTypes',
	                    validators: ['IsRequired'],
	                    omitNullOption: true,
	                    mdField: new mdField_2.default({ label: 'Invoice Types', valueSource: 'InvoiceType', valueSourceType: mdField_1.VALUESOURCETYPE.LOCAL })
	                }, {
	                    name: 'limitByProfitCenter',
	                    mdField: new mdField_2.default({ label: 'Limit by Profit Centers', dataType: mdField_1.DATATYPE.BOOLEAN })
	                }, {
	                    name: 'onlyForDomesticCustomers',
	                    mdField: new mdField_2.default({ label: 'Only for Domestic Customers', dataType: mdField_1.DATATYPE.BOOLEAN })
	                }, {
	                    name: 'waitForTaxConfirmation',
	                    mdField: new mdField_2.default({ label: 'Wait for Tax Confirmation', dataType: mdField_1.DATATYPE.BOOLEAN })
	                }, {
	                    name: 'profitCenters',
	                    validators: ['IsRequired'],
	                    mdField: new mdField_2.default({ label: 'Profit centers', valueSource: 'ProfitCenter', valueSourceType: mdField_1.VALUESOURCETYPE.LOCAL })
	                }],
	            onCommit: function (dataObject) {
	                dataObject.arguments = [(dataObject.documentTypes) ? dataObject.documentTypes.map(function (dtLov) { return (0, formUtils_1.lovValue)(dtLov); }) : [], // 1
	                    (0, formUtils_1.lovValue)(dataObject.eventType), // 2
	                    dataObject.limitByProfitCenter, // 3
	                    (dataObject.profitCenters) ? dataObject.profitCenters.map(function (dtLov) { return (0, formUtils_1.lovValue)(dtLov); }) : [], // 4
	                    (dataObject.invoiceTypes) ? dataObject.invoiceTypes.map(function (lov) { return (0, formUtils_1.lovValue)(lov); }) : [], // 5
	                    dataObject.onlyForDomesticCustomers, // 6
	                    dataObject.waitForTaxConfirmation // 7
	                ];
	            }
	        }, InvoiceToAccFormCC),
	        mobx_react_1.observer
	    ], InvoiceToAccForm);
	    return InvoiceToAccForm;
	}(react_1.default.Component));
	exports.InvoiceToAccForm = InvoiceToAccForm;
	/* ************************************************************************************************
	 * ***********   DownloadBankTx *************************************************************
	 * ********************************************************************************************** */
	var DownloadBankTxCC = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
	        react_1.default.createElement("h3", null, dataObject.group + ' - ' + dataObject.name),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.tenants.textLabel, value: (dataObject.tenants && dataObject.tenants.length) ? dataObject.tenants.map(function (dt, index) { return (0, formUtils_1.lovLabel)(dt); }).join(", ") : null })),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.bankApiTypes.textLabel, value: (dataObject.bankApiTypes && dataObject.bankApiTypes.length) ? dataObject.bankApiTypes.map(function (dt, index) { return (0, formUtils_1.lovLabel)(dt); }).join(", ") : null }))));
	};
	var DownloadBankTxForm = /** @class */ (function (_super) {
	    tslib_1.__extends(DownloadBankTxForm, _super);
	    function DownloadBankTxForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DownloadBankTxForm.prototype.componentWillReceiveProps = function (nextProps) {
	        console.debug('DownloadBankTxForm componentWillReceiveProps ', nextProps);
	    };
	    DownloadBankTxForm.prototype.componentDidMount = function () {
	        console.debug('DownloadBankTxForm componentDidMount');
	        var _a = this.props, dataObject = _a.dataObject, form = _a.form;
	        mdEntityService_1.default.fetchEntities([{ entity: 'Tenant', lov: true }, {
	                entity: 'BANKAPITYPE',
	                lov: true
	            }]).then((0, mobx_1.action)("action-cb", function (entityMap) {
	            form.initForm(entityMap.get("JobInfo"), entityMap, dataObject, dataObject, null);
	            if (dataObject.arguments && dataObject.arguments.length) {
	                var tenantIds = dataObject.arguments[0];
	                var tnMdEntity_1 = entityMap.get("Tenant");
	                dataObject.tenants = (tenantIds && tenantIds.length) ? tenantIds.map(function (dtId) { return tnMdEntity_1.getLovItem(dtId); }) : [];
	            }
	            if (dataObject.arguments && dataObject.arguments.length > 1) {
	                var bankApiIds = dataObject.arguments[1];
	                var apiTypeEntity_1 = entityMap.get("BANKAPITYPE");
	                dataObject.bankApiTypes = (bankApiIds && bankApiIds.length) ? bankApiIds.map(function (dtId) { return apiTypeEntity_1.getLovItem(dtId); }) : [];
	            }
	            form.updateAllFieldsPropValue(dataObject);
	        }));
	    };
	    DownloadBankTxForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, index = _a.index, entities = _a.entities, entity = _a.entity, formName = _a.formName, disabled = _a.disabled;
	        var fields = dataObject.getFormFields(formName);
	        var name = fields.name, tenants = fields.tenants, bankApiTypes = fields.bankApiTypes;
	        var openContent = (react_1.default.createElement("div", { className: "row" },
	            react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props, { disabled: !dataObject.$new })),
	                react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value })),
	            react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, tenants.props, { multi: true })),
	                react_1.default.createElement(validate_1.Validate, { field: tenants, value: tenants.props.value, dataObject: dataObject })),
	            react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, bankApiTypes.props, { multi: true })),
	                react_1.default.createElement(validate_1.Validate, { field: bankApiTypes, value: bankApiTypes.props.value, dataObject: dataObject }))));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(DownloadBankTxCC, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate, disableEditing: disabled }, this.props)));
	    };
	    DownloadBankTxForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'DownloadBankTxForm',
	            fields: [{
	                    name: 'name',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'tenants',
	                    validators: ['IsRequired'],
	                    mdField: new mdField_2.default({ label: 'Tenants', valueSource: 'Tenant', valueSourceType: mdField_1.VALUESOURCETYPE.LOCAL })
	                }, {
	                    name: 'bankApiTypes',
	                    validators: ['IsRequired'],
	                    mdField: new mdField_2.default({ label: 'Bank API types', valueSource: 'BANKAPITYPE', valueSourceType: mdField_1.VALUESOURCETYPE.LOCAL })
	                }],
	            onCommit: function (dataObject) {
	                dataObject.arguments = [dataObject.tenants.map(function (dtLov) { return (0, formUtils_1.lovValue)(dtLov); }), dataObject.bankApiTypes.map(function (dtLov) { return (0, formUtils_1.lovValue)(dtLov); })];
	            }
	        }, DownloadBankTxCC),
	        mobx_react_1.observer
	    ], DownloadBankTxForm);
	    return DownloadBankTxForm;
	}(react_1.default.Component));
	exports.DownloadBankTxForm = DownloadBankTxForm;
	/* ************************************************************************************************
	 * ***********   ProcessBrimMessage   *************************************************************
	 * ********************************************************************************************** */
	var ProcessBrimMessage = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
	        react_1.default.createElement("h3", null, dataObject.group + ' - ' + dataObject.name),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.tenants.textLabel, value: (dataObject.tenants && dataObject.tenants.length) ? dataObject.tenants.map(function (dt, index) { return (0, formUtils_1.lovLabel)(dt); }).join(", ") : null })),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.invalidate.textLabel, value: dataObject.invalidate }))));
	};
	var ProcessBrimMessageForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProcessBrimMessageForm, _super);
	    function ProcessBrimMessageForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ProcessBrimMessageForm.prototype.componentWillReceiveProps = function (nextProps) {
	        console.debug('ProcessBrimMessage componentWillReceiveProps ', nextProps);
	    };
	    ProcessBrimMessageForm.prototype.componentDidMount = function () {
	        console.debug('ProcessBrimMessage componentDidMount');
	        var _a = this.props, dataObject = _a.dataObject, form = _a.form;
	        mdEntityService_1.default.fetchEntities([{ entity: 'Tenant', lov: true }]).then((0, mobx_1.action)("action-cb", function (entityMap) {
	            form.initForm(entityMap.get("JobInfo"), entityMap, dataObject, dataObject, null);
	            if (dataObject.arguments && dataObject.arguments.length) {
	                var tenantIds = dataObject.arguments[0];
	                var tnMdEntity_2 = entityMap.get("Tenant");
	                dataObject.tenants = (tenantIds && tenantIds.length) ? tenantIds.map(function (dtId) { return tnMdEntity_2.getLovItem(dtId); }) : [];
	            }
	            // limit
	            if (dataObject.arguments && dataObject.arguments.length > 1) {
	                dataObject.invalidate = dataObject.arguments[1];
	            }
	            form.updateAllFieldsPropValue(dataObject);
	        }));
	    };
	    ProcessBrimMessageForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, index = _a.index, entities = _a.entities, entity = _a.entity, formName = _a.formName, disabled = _a.disabled;
	        var fields = dataObject.getFormFields(formName);
	        var name = fields.name, tenants = fields.tenants, invalidate = fields.invalidate;
	        var openContent = (react_1.default.createElement("div", { className: "row" },
	            react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props, { disabled: !dataObject.$new })),
	                react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value })),
	            react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, tenants.props, { multi: true })),
	                react_1.default.createElement(validate_1.Validate, { field: tenants, value: tenants.props.value, dataObject: dataObject })),
	            react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, invalidate.props)),
	                react_1.default.createElement(validate_1.Validate, { field: invalidate, value: invalidate.props.value },
	                    react_1.default.createElement(rules_1.NumberFormat, { precision: 10, scale: 0, value: undefined }),
	                    react_1.default.createElement(rules_1.Min, { min: 0, value: undefined })))));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ProcessBrimMessage, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate, disableEditing: disabled }, this.props)));
	    };
	    ProcessBrimMessageForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'ProcessBrimMessageForm',
	            fields: [{
	                    name: 'name',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'tenants',
	                    mdField: new mdField_2.default({ label: 'Tenants', valueSource: 'Tenant', valueSourceType: mdField_1.VALUESOURCETYPE.LOCAL })
	                }, {
	                    name: 'invalidate',
	                    mdField: new mdField_2.default({ label: 'Invalidate  message after (days)', dataType: mdField_1.DATATYPE.NUMBER })
	                }],
	            onCommit: function (dataObject) {
	                dataObject.arguments = [(dataObject.tenants) ? dataObject.tenants.map(function (dtLov) { return (0, formUtils_1.lovValue)(dtLov); }) : [], dataObject.invalidate];
	            }
	        }, ProcessBrimMessage),
	        mobx_react_1.observer
	    ], ProcessBrimMessageForm);
	    return ProcessBrimMessageForm;
	}(react_1.default.Component));
	exports.ProcessBrimMessageForm = ProcessBrimMessageForm;
	/* ************************************************************************************************
	 * ***********   InvoiceToArchiveForm *************************************************************
	 * ********************************************************************************************** */
	var InvoiceToArchiveFormCC = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", null,
	        react_1.default.createElement("h3", null, dataObject.group + ' - ' + dataObject.name),
	        react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields, singleColumn: true },
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.documentTypes.textLabel, value: dataObject.documentTypes }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.eventType.textLabel, value: dataObject.eventType }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.invoiceTypes.textLabel, value: dataObject.invoiceTypes }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.mainDocument.textLabel, value: dataObject.mainDocument }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.mainDocumentNameExpression.textLabel, value: dataObject.mainDocumentNameExpression }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.attachedDocuments.textLabel, value: dataObject.attachedDocuments, mdField: fields.attachedDocuments.mdField }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.archivingFormat.textLabel, value: dataObject.archivingFormat }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.archiveFilenameExpression.textLabel, value: dataObject.archiveFilenameExpression }))));
	};
	var InvoiceToArchiveForm = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceToArchiveForm, _super);
	    function InvoiceToArchiveForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    InvoiceToArchiveForm.prototype.componentWillReceiveProps = function (nextProps) {
	        console.debug('InvoiceToArchiveForm componentWillReceiveProps ', nextProps);
	    };
	    InvoiceToArchiveForm.prototype.componentDidMount = function () {
	        console.debug('InvoiceToArchiveForm componentDidMount');
	        var _a = this.props, dataObject = _a.dataObject, form = _a.form;
	        mdEntityService_1.default.fetchEntities([{ entity: 'DocumentType', lov: true }, { entity: 'EventType', lov: true },
	            { entity: "DOCUMENTLOCATION", lov: true }, {
	                entity: "DOCUMENTFORMAT",
	                lov: true
	            }, { entity: "InvoiceType", lov: true }]).then((0, mobx_1.action)("action-cb", function (entityMap) {
	            form.initForm(entityMap.get("JobInfo"), entityMap, dataObject, dataObject, null);
	            // documentTypes
	            if (dataObject.arguments && dataObject.arguments.length) {
	                var docTypesIds = dataObject.arguments[0];
	                var dtMdEntity_2 = entityMap.get("DocumentType");
	                dataObject.documentTypes = (docTypesIds && docTypesIds.length) ? docTypesIds.map(function (dtId) { return dtMdEntity_2.getLovItem(dtId); }) : [];
	            }
	            // eventType
	            var eventTypeEntity = entityMap.get("EventType");
	            if (dataObject.arguments && dataObject.arguments.length > 1) {
	                dataObject.eventType = eventTypeEntity.getLovItem(dataObject.arguments[1]);
	            }
	            // mainDocument
	            if (dataObject.arguments && dataObject.arguments.length > 2) {
	                var documentLocationEntity = entityMap.get("DOCUMENTLOCATION");
	                dataObject.mainDocument = documentLocationEntity.getLovItem(dataObject.arguments[2]);
	            }
	            // mainDocumentNameExpression
	            if (dataObject.arguments && dataObject.arguments.length > 3) {
	                dataObject.mainDocumentNameExpression = dataObject.arguments[3];
	            }
	            // attachedDocuments
	            if (dataObject.arguments && dataObject.arguments.length > 4) {
	                dataObject.attachedDocuments = dataObject.arguments[4];
	            }
	            // archivingFormat
	            var documentFormatEntity = entityMap.get("DOCUMENTFORMAT");
	            if (dataObject.arguments && dataObject.arguments.length > 5) {
	                dataObject.archivingFormat = documentFormatEntity.getLovItem(dataObject.arguments[5]);
	            }
	            // archiveFilenameExpression
	            if (dataObject.arguments && dataObject.arguments.length > 6) {
	                dataObject.archiveFilenameExpression = dataObject.arguments[6];
	            }
	            var invoiceTypeEntity = entityMap.get("InvoiceType");
	            if (dataObject.arguments && dataObject.arguments.length > 7) {
	                var invoiceTypeIds = dataObject.arguments[7];
	                dataObject.invoiceTypes = (invoiceTypeIds && invoiceTypeIds.length) ? invoiceTypeIds.map(function (dtId) { return invoiceTypeEntity.lovItems.find(function (x) { return x.value === dtId; }); }).filter(function (x) { return !!x; }) : [];
	            }
	            form.updateAllFieldsPropValue(dataObject);
	            form.getField("eventType").props.options = eventTypeEntity.lovItems.filter(function (li) { return li["eventType"] === eventDomain_1.EVENTTYPE.INVOICE_SENT_ARCHIVE; });
	            form.getField("archivingFormat").props.options = documentFormatEntity.lovItems.filter(function (li) { return li["archive"]; });
	        }));
	    };
	    InvoiceToArchiveForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, index = _a.index, entities = _a.entities, entity = _a.entity, formName = _a.formName, disabled = _a.disabled;
	        var fields = dataObject.getFormFields(formName);
	        var name = fields.name, documentTypes = fields.documentTypes, eventType = fields.eventType, mainDocument = fields.mainDocument, mainDocumentNameExpression = fields.mainDocumentNameExpression, attachedDocuments = fields.attachedDocuments, archivingFormat = fields.archivingFormat, archiveFilenameExpression = fields.archiveFilenameExpression, invoiceTypes = fields.invoiceTypes;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props, { disabled: !dataObject.$new })),
	                    react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, documentTypes.props, { multi: true })),
	                    react_1.default.createElement(validate_1.Validate, { field: documentTypes, value: documentTypes.props.value, dataObject: dataObject })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, eventType.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: eventType, value: eventType.props.value, dataObject: dataObject }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, mainDocument.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: mainDocument, value: mainDocument.props.value, dataObject: dataObject })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-8" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, mainDocumentNameExpression.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: mainDocumentNameExpression, value: mainDocumentNameExpression.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, archivingFormat.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: archivingFormat, value: archivingFormat.props.value, dataObject: dataObject })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-8" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, archiveFilenameExpression.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: archiveFilenameExpression, value: archiveFilenameExpression.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, invoiceTypes.props, { multi: true })),
	                    react_1.default.createElement(validate_1.Validate, { field: invoiceTypes, value: invoiceTypes.props.value, dataObject: dataObject })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, attachedDocuments.props))))));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(InvoiceToArchiveFormCC, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate, disableEditing: disabled }, this.props)));
	    };
	    InvoiceToArchiveForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'InvoiceToArchiveForm',
	            fields: [{
	                    name: 'name',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'documentTypes',
	                    validators: ['IsRequired'],
	                    mdField: new mdField_2.default({
	                        label: 'Document Types for accompanying documents',
	                        valueSource: 'DocumentType',
	                        valueSourceType: mdField_1.VALUESOURCETYPE.LOCAL
	                    })
	                }, {
	                    name: 'eventType',
	                    validators: ['IsRequired'],
	                    mdField: new mdField_2.default({ label: 'Event Type', valueSource: 'EventType', valueSourceType: mdField_1.VALUESOURCETYPE.LOCAL })
	                }, {
	                    name: 'invoiceTypes',
	                    validators: ['IsRequired'],
	                    omitNullOption: true,
	                    mdField: new mdField_2.default({ label: 'Invoice Types', valueSource: 'InvoiceType', valueSourceType: mdField_1.VALUESOURCETYPE.LOCAL })
	                }, {
	                    name: 'mainDocument',
	                    mdField: new mdField_2.default({
	                        label: 'Main document location',
	                        valueSource: 'DOCUMENTLOCATION',
	                        valueSourceType: mdField_1.VALUESOURCETYPE.LOCAL
	                    })
	                }, {
	                    name: 'mainDocumentNameExpression',
	                    mdField: new mdField_2.default({ label: 'Main document name expression', dataType: mdField_1.DATATYPE.STRING })
	                }, {
	                    name: 'attachedDocuments',
	                    mdField: new mdField_2.default({ label: 'Add Attached documents', dataType: mdField_1.DATATYPE.BOOLEAN })
	                }, {
	                    name: 'archivingFormat',
	                    mdField: new mdField_2.default({
	                        label: 'ArchivingFormat',
	                        valueSource: 'DOCUMENTFORMAT',
	                        valueSourceType: mdField_1.VALUESOURCETYPE.LOCAL
	                    })
	                }, {
	                    name: 'archiveFilenameExpression',
	                    mdField: new mdField_2.default({ label: 'Archive file name expression', dataType: mdField_1.DATATYPE.STRING })
	                }],
	            onCommit: function (dataObject) {
	                dataObject.arguments = [(dataObject.documentTypes) ? dataObject.documentTypes.map(function (dtLov) { return (0, formUtils_1.lovValue)(dtLov); }) : [], // 1
	                    (0, formUtils_1.lovValue)(dataObject.eventType), // 2
	                    (0, formUtils_1.lovValue)(dataObject.mainDocument), // 3
	                    dataObject.mainDocumentNameExpression, // 4
	                    dataObject.attachedDocuments, // 5
	                    (0, formUtils_1.lovValue)(dataObject.archivingFormat), // 6
	                    dataObject.archiveFilenameExpression, // 7
	                    (dataObject.invoiceTypes) ? dataObject.invoiceTypes.map(function (lov) { return (0, formUtils_1.lovValue)(lov); }) : [] // 8
	                ];
	            }
	        }, InvoiceToArchiveFormCC),
	        mobx_react_1.observer
	    ], InvoiceToArchiveForm);
	    return InvoiceToArchiveForm;
	}(react_1.default.Component));
	exports.InvoiceToArchiveForm = InvoiceToArchiveForm;
	/* ************************************************************************************************
	 * ***********   QueueForm *************************************************************
	 * ********************************************************************************************** */
	var QueueFormCC = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", null,
	        react_1.default.createElement("h3", null, dataObject.group + ' - ' + dataObject.name),
	        react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields, singleColumn: true },
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.queueTypes.textLabel, value: (dataObject.queueTypes && dataObject.queueTypes.length) ? dataObject.queueTypes.map(function (dt) { return (0, formUtils_1.lovLabel)(dt); }).join(", ") : null }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.limit.textLabel, value: dataObject.limit }))));
	};
	var QueueForm = /** @class */ (function (_super) {
	    tslib_1.__extends(QueueForm, _super);
	    function QueueForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    QueueForm.prototype.componentWillReceiveProps = function (nextProps) {
	        console.debug('QueueForm componentWillReceiveProps ', nextProps);
	    };
	    QueueForm.prototype.componentDidMount = function () {
	        console.debug('QueueForm componentDidMount');
	        var _a = this.props, dataObject = _a.dataObject, form = _a.form;
	        mdEntityService_1.default.fetchEntities([{
	                entity: 'QUEUETYPE',
	                lov: true
	            }]).then((0, mobx_1.action)("action-cb", function (entityMap) {
	            form.initForm(entityMap.get("JobInfo"), entityMap, dataObject, dataObject, null);
	            // QUEUETYPE
	            if (dataObject.arguments && dataObject.arguments.length) {
	                var QUEUETYPES = dataObject.arguments[0];
	                var QUEUETYPEMdEntity_1 = entityMap.get("QUEUETYPE");
	                dataObject.queueTypes = (QUEUETYPES && QUEUETYPES.length) ? QUEUETYPES.map(function (qt) { return QUEUETYPEMdEntity_1.getLovItem(qt); }) : [];
	            }
	            // limit
	            if (dataObject.arguments && dataObject.arguments.length > 1) {
	                dataObject.limit = dataObject.arguments[1];
	            }
	            form.updateAllFieldsPropValue(dataObject);
	        }));
	    };
	    QueueForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, index = _a.index, entities = _a.entities, entity = _a.entity, formName = _a.formName, disabled = _a.disabled;
	        var fields = dataObject.getFormFields(formName);
	        var name = fields.name, queueTypes = fields.queueTypes, limit = fields.limit;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props, { disabled: !dataObject.$new })),
	                    react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value },
	                        react_1.default.createElement(rules_1.PrimaryKeyString, { value: undefined }))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-8" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, queueTypes.props, { multi: true })),
	                    react_1.default.createElement(validate_1.Validate, { field: queueTypes, value: queueTypes.props.value, dataObject: dataObject })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, limit.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: limit, value: limit.props.value },
	                        react_1.default.createElement(rules_1.NumberFormat, { precision: 10, scale: 0, value: undefined }),
	                        react_1.default.createElement(rules_1.Min, { min: 0, value: undefined }))))));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(QueueFormCC, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate, disableEditing: disabled }, this.props)));
	    };
	    QueueForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'QueueForm',
	            fields: [{
	                    name: 'name',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'queueTypes',
	                    validators: ['IsRequired'],
	                    mdField: new mdField_2.default({ label: 'Queue Types', valueSource: 'QUEUETYPE', valueSourceType: mdField_1.VALUESOURCETYPE.LOCAL })
	                }, {
	                    name: 'limit',
	                    validators: ['IsRequired'],
	                    mdField: new mdField_2.default({ label: 'Max number of queue items processed in one job', dataType: mdField_1.DATATYPE.NUMBER })
	                }],
	            onCommit: function (dataObject) {
	                dataObject.arguments = [(dataObject.queueTypes) ? dataObject.queueTypes.map(function (dtLov) { return (0, formUtils_1.lovValue)(dtLov); }) : [], dataObject.limit];
	            }
	        }, QueueFormCC),
	        mobx_react_1.observer
	    ], QueueForm);
	    return QueueForm;
	}(react_1.default.Component));
	exports.QueueForm = QueueForm;
	/* ************************************************************************************************
	 * ***********   DataImport *************************************************************
	 * ********************************************************************************************** */
	var DataImportFormCC = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", null,
	        react_1.default.createElement("h3", null, dataObject.group + ' - ' + dataObject.name),
	        react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields, singleColumn: true },
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.importType.textLabel, value: dataObject.importType }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.directory.textLabel, value: dataObject.directory }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.filenamePattern.textLabel, value: dataObject.filenamePattern }))));
	};
	var DataImportForm = /** @class */ (function (_super) {
	    tslib_1.__extends(DataImportForm, _super);
	    function DataImportForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DataImportForm.prototype.componentWillReceiveProps = function (nextProps) {
	        console.debug('DataImportForm componentWillReceiveProps ', nextProps);
	    };
	    DataImportForm.prototype.componentDidMount = function () {
	        console.debug('DataImportForm componentDidMount');
	        var _a = this.props, dataObject = _a.dataObject, form = _a.form;
	        mdEntityService_1.default.fetchEntities([{
	                entity: 'IMPORTTYPE',
	                lov: true
	            }]).then((0, mobx_1.action)("action-cb", function (entityMap) {
	            form.initForm(entityMap.get("JobInfo"), entityMap, dataObject, dataObject, null);
	            // IMPORTTYPE
	            if (dataObject.arguments && dataObject.arguments.length) {
	                var IMPORTTYPE = dataObject.arguments[0];
	                var IMPORTTYPEMdEntity = entityMap.get("IMPORTTYPE");
	                dataObject.importType = IMPORTTYPEMdEntity.getLovItem(IMPORTTYPE);
	            }
	            // directory
	            if (dataObject.arguments && dataObject.arguments.length > 1) {
	                dataObject.directory = dataObject.arguments[1];
	            }
	            // filenamePattern
	            if (dataObject.arguments && dataObject.arguments.length > 2) {
	                dataObject.filenamePattern = dataObject.arguments[2];
	            }
	            form.updateAllFieldsPropValue(dataObject);
	        }));
	    };
	    DataImportForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, index = _a.index, entities = _a.entities, entity = _a.entity, formName = _a.formName, disabled = _a.disabled;
	        var fields = dataObject.getFormFields(formName);
	        var name = fields.name, importType = fields.importType, directory = fields.directory, filenamePattern = fields.filenamePattern;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props, { disabled: !dataObject.$new })),
	                    react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, importType.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: importType, value: importType.props.value, dataObject: dataObject })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, directory.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: directory, value: directory.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, filenamePattern.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: filenamePattern, value: filenamePattern.props.value })))));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(DataImportFormCC, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate, disableEditing: disabled }, this.props)));
	    };
	    DataImportForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'DataImportForm',
	            fields: [{
	                    name: 'name',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'importType',
	                    validators: ['IsRequired'],
	                    mdField: new mdField_2.default({ label: 'Import Type', valueSource: 'IMPORTTYPE', valueSourceType: mdField_1.VALUESOURCETYPE.LOCAL })
	                }, {
	                    name: 'directory',
	                    validators: ['IsRequired'],
	                    mdField: new mdField_2.default({ label: 'Import files directory', dataType: mdField_1.DATATYPE.STRING })
	                }, {
	                    name: 'filenamePattern',
	                    validators: ['IsRequired'],
	                    mdField: new mdField_2.default({ label: 'Filename pattern', dataType: mdField_1.DATATYPE.STRING })
	                }],
	            onCommit: function (dataObject) {
	                dataObject.arguments = [(0, formUtils_1.lovValue)(dataObject.importType), dataObject.directory, dataObject.filenamePattern];
	            }
	        }, DataImportFormCC),
	        mobx_react_1.observer
	    ], DataImportForm);
	    return DataImportForm;
	}(react_1.default.Component));
	exports.DataImportForm = DataImportForm;
	var templateObject_1;


/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var icons_1 = __webpack_require__(63);
	var jobService_1 = tslib_1.__importDefault(__webpack_require__(569));
	var MenuItem_1 = tslib_1.__importDefault(__webpack_require__(101));
	var Divider_1 = tslib_1.__importDefault(__webpack_require__(241));
	var utils_1 = __webpack_require__(37);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'jobList';
	var JobList = /** @class */ (function (_super) {
	    tslib_1.__extends(JobList, _super);
	    function JobList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.addJob = function (groupName, jobName) {
	            console.log('addJob ' + jobName);
	            _this.context.router.transitionTo("jobDetail", { id: (0, utils_1.formatId)(groupName, jobName) }, { new: true });
	        };
	        return _this;
	    }
	    JobList.fetchData = function (routerParams) {
	        console.log("JobList#fetchData(%s)", gridLocation);
	        return Promise.all([gridService_1.default.fetchGrids(gridLocation), jobService_1.default.readAvailableJobs()])
	            .then(function (_a) {
	            var gridLocationMap = _a[0], availableJobs = _a[1];
	            jobService_1.default.availableJobs = availableJobs;
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    JobList.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, params = _a.params, query = _a.query;
	        console.debug("jobList render");
	        var menuItems = [];
	        if (jobService_1.default.availableJobs) {
	            Object.entries(jobService_1.default.availableJobs).forEach(function (pair, index) {
	                var groupName = pair[0];
	                var jobsInGroup = pair[1];
	                if (index > 0)
	                    menuItems.push(react_1.default.createElement(Divider_1.default, { key: groupName }));
	                jobsInGroup.forEach(function (job) {
	                    menuItems.push(react_1.default.createElement(MenuItem_1.default, { primaryText: groupName + ' - ' + job, key: groupName + job, onClick: _this.addJob.bind(_this, groupName, job) }));
	                });
	            });
	        }
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query },
	            react_1.default.createElement(icons_1.ZzIconButtonMenu, { buttonIcon: react_1.default.createElement(add_1.default, null) }, menuItems)));
	    };
	    JobList.module = metaConstant_1.MODULE.core;
	    JobList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Jobs"], ["Jobs"])));
	    JobList.icon = 'cogs';
	    JobList.rootPage = true;
	    JobList.protectedPage = true;
	    JobList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], JobList);
	    return JobList;
	}(pageAncestor_1.default));
	exports.default = JobList;
	var templateObject_1;


/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var validate_1 = __webpack_require__(24);
	var jobService_1 = tslib_1.__importDefault(__webpack_require__(569));
	var rules_1 = __webpack_require__(56);
	var mobx_react_1 = __webpack_require__(4);
	var form_1 = __webpack_require__(52);
	function TriggerExists(_a) {
	    var value = _a.value, name = _a.name;
	    if (!value)
	        return (0, rules_1.valid)();
	    if (name == value)
	        return (0, rules_1.valid)();
	    return jobService_1.default.triggerExist(value)
	        .then(function (exists) { return (exists) ? (0, rules_1.invalid)("Trigger ".concat(value, " already exists")) : (0, rules_1.valid)(); });
	}
	function CronCheck(_a) {
	    var value = _a.value;
	    if (!value)
	        return (0, rules_1.valid)();
	    return jobService_1.default.cronCheck(value)
	        .then(function (errorText) { return (errorText) ? (0, rules_1.invalid)(errorText) : (0, rules_1.valid)(); });
	}
	var TriggerForm = /** @class */ (function (_super) {
	    tslib_1.__extends(TriggerForm, _super);
	    function TriggerForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TriggerForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, formName = _a.formName;
	        var fields = dataObject.getFormFields(formName);
	        var name = fields.name, cronExpression = fields.cronExpression, misfirePolicy = fields.misfirePolicy, addHolidayCalendar = fields.addHolidayCalendar;
	        console.debug("TriggerForm#render() %O", dataObject);
	        return (react_1.default.createElement("div", { className: "row" },
	            react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props, { disabled: !dataObject.$new })),
	                react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value },
	                    react_1.default.createElement(rules_1.PrimaryKeyString, null),
	                    react_1.default.createElement(TriggerExists, { name: dataObject.name }))),
	            react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, cronExpression.props)),
	                react_1.default.createElement(validate_1.Validate, { field: cronExpression, value: cronExpression.props.value },
	                    react_1.default.createElement(CronCheck, null))),
	            react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, misfirePolicy.props)),
	                react_1.default.createElement(validate_1.Validate, { field: misfirePolicy, value: misfirePolicy.props.value })),
	            react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, addHolidayCalendar.props))),
	            react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6", style: { paddingTop: 12, fontSize: 14 } },
	                react_1.default.createElement("a", { href: "http://www.quartz-scheduler.org/documentation/quartz-2.3.0/tutorials/crontrigger.html", target: "_blank" },
	                    "Cron Expression Documentation",
	                    react_1.default.createElement("span", { className: "fa fa-external-link zz-ml-5" })))));
	    };
	    TriggerForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], TriggerForm);
	    return TriggerForm;
	}(react_1.default.Component));
	var definition = {
	    formName: 'TriggerForm',
	    fields: [{
	            name: 'name',
	            validators: ['IsRequired']
	        }, {
	            name: 'cronExpression',
	            validators: ['IsRequired']
	        }, {
	            name: 'misfirePolicy',
	            validators: ['IsRequired']
	        }, {
	            name: 'addHolidayCalendar',
	            displayType: form_1.FIELDDEFDISPLAYTYPE.checkbox
	        }]
	};
	exports.default = (0, createForm_1.createForm)(definition, function () { return react_1.default.createElement("noscript", null); })(TriggerForm);


/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pull = __webpack_require__(117);
	var formUtils_1 = __webpack_require__(14);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var blockComp_1 = __webpack_require__(30);
	var icons_1 = __webpack_require__(63);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var arrayUtils_1 = __webpack_require__(78);
	var blockComp_2 = __webpack_require__(30);
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var metaDomain_1 = __webpack_require__(220);
	var commonDataService_1 = __webpack_require__(41);
	var EntityValidationList = /** @class */ (function (_super) {
	    tslib_1.__extends(EntityValidationList, _super);
	    function EntityValidationList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.addValidation = function () {
	            console.debug('addValidation');
	            var _a = _this.props, entityObject = _a.entityObject, rootObject = _a.rootObject;
	            var newValidation = new metaDomain_1.EntityValidationTable({
	                $new: true,
	                $added: true,
	                entityName: entityObject.mdEntity,
	                configLevel: metaConstant_1.CONFIGLEVEL.GLOBAL
	            });
	            entityObject.validations.push(newValidation);
	            rootObject.$dirty = true;
	        };
	        return _this;
	    }
	    EntityValidationList.prototype.render = function () {
	        var _a = this.props, entityObject = _a.entityObject, entities = _a.entities, entity = _a.entity, rootObject = _a.rootObject;
	        var header = (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
	            react_1.default.createElement("div", null, "Entity Validations"),
	            react_1.default.createElement(icons_1.MdIconButton, { onClick: this.addValidation },
	                react_1.default.createElement(add_1.default, null))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { header: header, noPadding: true, style: { display: 'flex', flexDirection: 'column' } }, (0, arrayUtils_1.addSeparator)(entityObject.validations.map(function (ev, index) { return react_1.default.createElement(EntityValidationTableForm, { dataObject: ev, rootObject: rootObject, key: index, entities: entities, entity: entity, index: index }); }), react_1.default.createElement(blockComp_2.MdDivider, { inset: true }))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EntityValidationList.prototype, "addValidation", void 0);
	    EntityValidationList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EntityValidationList);
	    return EntityValidationList;
	}(react_1.default.Component));
	exports.default = EntityValidationList;
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { display: 'flex', fontSize: 16, lineHeight: '14px' } },
	        react_1.default.createElement("div", { className: "zz-grey-text zz-mr-5" }, (0, formUtils_1.lovLabel)(dataObject.configLevel)),
	        ((0, formUtils_1.lovValue)(dataObject.configLevel) === metaConstant_1.CONFIGLEVEL.TENANTGROUP) ? react_1.default.createElement("div", { className: "zz-grey-text" }, (0, formUtils_1.lovLabel)(dataObject.tenantGroup)) : null,
	        ((0, formUtils_1.lovValue)(dataObject.configLevel) === metaConstant_1.CONFIGLEVEL.TENANT) ? react_1.default.createElement("div", { className: "zz-grey-text" }, (0, formUtils_1.lovLabel)(dataObject.tenant)) : null,
	        ((0, formUtils_1.lovValue)(dataObject.configLevel) === metaConstant_1.CONFIGLEVEL.USER) ? react_1.default.createElement("div", { className: "zz-grey-text" }, (0, formUtils_1.lovLabel)(dataObject.user)) : null,
	        (dataObject.language) ? react_1.default.createElement("div", { className: "zz-grey-text zz-ml-5" },
	            "(",
	            (0, formUtils_1.lovLabel)(dataObject.language),
	            ")") : null,
	        react_1.default.createElement("div", { className: "zz-ml-10" }, (0, formUtils_1.lovLabel)(dataObject.validation))));
	};
	var EntityValidationTableForm = /** @class */ (function (_super) {
	    tslib_1.__extends(EntityValidationTableForm, _super);
	    function EntityValidationTableForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDelete = function (evt) {
	            evt.stopPropagation();
	            console.log('onDelete %o', _this.props.dataObject);
	            pull(_this.props.rootObject.validations, _this.props.dataObject);
	        };
	        _this.handleConfigLevelChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, formName = _a.formName;
	            console.log('handleConfigLevelChange ', dataObject.configLevel);
	            dataObject.tenant = null;
	            dataObject.tenantGroup = null;
	            dataObject.user = null;
	            dataObject.getForm(formName).updateAllFieldsPropValue(dataObject);
	        };
	        return _this;
	    }
	    EntityValidationTableForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, index = _a.index, entities = _a.entities, formName = _a.formName, entity = _a.entity;
	        var fields = dataObject.getFormFields(formName);
	        var validation = fields.validation, configLevel = fields.configLevel, tenantGroup = fields.tenantGroup, tenant = fields.tenant, user = fields.user, language = fields.language;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, configLevel.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: configLevel, value: configLevel.props.value, onSuccess: this.handleConfigLevelChange })),
	                ((0, formUtils_1.lovValue)(dataObject.configLevel) === metaConstant_1.CONFIGLEVEL.TENANTGROUP) ?
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, tenantGroup.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: tenantGroup, value: tenantGroup.props.value }))
	                    : null,
	                ((0, formUtils_1.lovValue)(dataObject.configLevel) === metaConstant_1.CONFIGLEVEL.TENANT) ?
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, tenant.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: tenant, value: tenant.props.value }))
	                    : null,
	                ((0, formUtils_1.lovValue)(dataObject.configLevel) === metaConstant_1.CONFIGLEVEL.USER) ?
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, user.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'User', {}), clearable: true, asterixForAll: true })),
	                        react_1.default.createElement(validate_1.Validate, { field: user, value: user.props.value }))
	                    : null,
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, language.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-sm-12" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, validation.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: validation, value: validation.props.value })))));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), key: index, onDelete: this.onDelete, validate: this.props.validate }, this.props)));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EntityValidationTableForm.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EntityValidationTableForm.prototype, "handleConfigLevelChange", void 0);
	    EntityValidationTableForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'EntityValidationTableForm',
	            fields: [{
	                    name: 'validation'
	                }, {
	                    name: 'tenantGroup',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'tenant',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'user',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'configLevel',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'language'
	                }]
	        }, ClosedContent),
	        mobx_react_1.observer
	    ], EntityValidationTableForm);
	    return EntityValidationTableForm;
	}(react_1.default.Component));


/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pull = __webpack_require__(117);
	var fields_1 = __webpack_require__(20);
	var formUtils_1 = __webpack_require__(14);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var blockComp_1 = __webpack_require__(30);
	var icons_1 = __webpack_require__(63);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var arrayUtils_1 = __webpack_require__(78);
	var blockComp_2 = __webpack_require__(30);
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var metaDomain_1 = __webpack_require__(220);
	var commonDataService_1 = __webpack_require__(41);
	var FieldDefaultList = /** @class */ (function (_super) {
	    tslib_1.__extends(FieldDefaultList, _super);
	    function FieldDefaultList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.addDefault = function () {
	            console.debug('addDefault');
	            var _a = _this.props, fieldObject = _a.fieldObject, rootObject = _a.rootObject;
	            var newDefault = new metaDomain_1.FieldDefaultTable({
	                $new: true,
	                $added: true,
	                entityName: fieldObject.entityName,
	                fieldName: fieldObject.fieldName,
	                configLevel: metaConstant_1.CONFIGLEVEL.GLOBAL
	            });
	            fieldObject.defaults.push(newDefault);
	            rootObject.$dirty = true;
	        };
	        return _this;
	    }
	    FieldDefaultList.prototype.render = function () {
	        var _a = this.props, fieldObject = _a.fieldObject, entities = _a.entities, entity = _a.entity, rootObject = _a.rootObject;
	        var header = (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
	            react_1.default.createElement("div", null, "Field Defaults"),
	            react_1.default.createElement(icons_1.MdIconButton, { onClick: this.addDefault },
	                react_1.default.createElement(add_1.default, null))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { header: header, noPadding: true, style: { display: 'flex', flexDirection: 'column' } }, (0, arrayUtils_1.addSeparator)(fieldObject.defaults.map(function (fd, index) { return react_1.default.createElement(FieldDefaultTableForm, { dataObject: fd, rootObject: rootObject, key: index, entities: entities, entity: entity, index: index }); }), react_1.default.createElement(blockComp_2.MdDivider, { inset: true }))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], FieldDefaultList.prototype, "addDefault", void 0);
	    FieldDefaultList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], FieldDefaultList);
	    return FieldDefaultList;
	}(react_1.default.Component));
	exports.default = FieldDefaultList;
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { display: 'flex', fontSize: 16, lineHeight: '14px' } },
	        react_1.default.createElement("div", { className: "zz-grey-text zz-mr-5" }, (0, formUtils_1.lovLabel)(dataObject.configLevel)),
	        ((0, formUtils_1.lovValue)(dataObject.configLevel) === metaConstant_1.CONFIGLEVEL.TENANTGROUP) ? react_1.default.createElement("div", { className: "zz-grey-text" }, (0, formUtils_1.lovLabel)(dataObject.tenantGroup)) : null,
	        ((0, formUtils_1.lovValue)(dataObject.configLevel) === metaConstant_1.CONFIGLEVEL.TENANT) ? react_1.default.createElement("div", { className: "zz-grey-text" }, (0, formUtils_1.lovLabel)(dataObject.tenant)) : null,
	        ((0, formUtils_1.lovValue)(dataObject.configLevel) === metaConstant_1.CONFIGLEVEL.USER) ? react_1.default.createElement("div", { className: "zz-grey-text" }, (0, formUtils_1.lovLabel)(dataObject.user)) : null,
	        (dataObject.language) ? react_1.default.createElement("div", { className: "zz-grey-text zz-ml-5" },
	            "(",
	            (0, formUtils_1.lovLabel)(dataObject.language),
	            ")") : null,
	        react_1.default.createElement("div", { className: "zz-ml-10" }, dataObject.value)));
	};
	var FieldDefaultTableForm = /** @class */ (function (_super) {
	    tslib_1.__extends(FieldDefaultTableForm, _super);
	    function FieldDefaultTableForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDelete = function (evt) {
	            evt.stopPropagation();
	            console.log('onDelete %o', _this.props.dataObject);
	            pull(_this.props.rootObject.defaults, _this.props.dataObject);
	        };
	        _this.handleConfigLevelChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, formName = _a.formName;
	            console.log('handleConfigLevelChange ', dataObject.configLevel);
	            dataObject.tenant = null;
	            dataObject.tenantGroup = null;
	            dataObject.user = null;
	            dataObject.getForm(formName).updateAllFieldsPropValue(dataObject);
	        };
	        return _this;
	    }
	    FieldDefaultTableForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, index = _a.index, entities = _a.entities, formName = _a.formName, entity = _a.entity;
	        var fields = dataObject.getFormFields(formName);
	        var value = fields.value, configLevel = fields.configLevel, tenantGroup = fields.tenantGroup, tenant = fields.tenant, user = fields.user, language = fields.language;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, configLevel.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: configLevel, value: configLevel.props.value, onSuccess: this.handleConfigLevelChange })),
	                ((0, formUtils_1.lovValue)(dataObject.configLevel) === metaConstant_1.CONFIGLEVEL.TENANTGROUP) ?
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, tenantGroup.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: tenantGroup, value: tenantGroup.props.value }))
	                    : null,
	                ((0, formUtils_1.lovValue)(dataObject.configLevel) === metaConstant_1.CONFIGLEVEL.TENANT) ?
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, tenant.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: tenant, value: tenant.props.value }))
	                    : null,
	                ((0, formUtils_1.lovValue)(dataObject.configLevel) === metaConstant_1.CONFIGLEVEL.USER) ?
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, user.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'User', {}), clearable: true, asterixForAll: true })),
	                        react_1.default.createElement(validate_1.Validate, { field: user, value: user.props.value }))
	                    : null,
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, language.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, value.props))))));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), key: index, onDelete: this.onDelete, validate: this.props.validate }, this.props)));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], FieldDefaultTableForm.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], FieldDefaultTableForm.prototype, "handleConfigLevelChange", void 0);
	    FieldDefaultTableForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'FieldDefaultTableForm',
	            fields: [{
	                    name: 'value'
	                }, {
	                    name: 'tenantGroup',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'tenant',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'user',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'configLevel',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'language'
	                }]
	        }, ClosedContent),
	        mobx_react_1.observer
	    ], FieldDefaultTableForm);
	    return FieldDefaultTableForm;
	}(react_1.default.Component));


/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pull = __webpack_require__(117);
	var fields_1 = __webpack_require__(20);
	var formUtils_1 = __webpack_require__(14);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var blockComp_1 = __webpack_require__(30);
	var icons_1 = __webpack_require__(63);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var arrayUtils_1 = __webpack_require__(78);
	var blockComp_2 = __webpack_require__(30);
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var metaDomain_1 = __webpack_require__(220);
	var definedRules = tslib_1.__importStar(__webpack_require__(56));
	var mdField_1 = __webpack_require__(57);
	var commonDataService_1 = __webpack_require__(41);
	var FieldValidationList = /** @class */ (function (_super) {
	    tslib_1.__extends(FieldValidationList, _super);
	    function FieldValidationList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.addValidation = function () {
	            console.debug('addValidation');
	            var _a = _this.props, fieldObject = _a.fieldObject, rootObject = _a.rootObject;
	            var newValidation = new metaDomain_1.FieldValidationTable({
	                $new: true,
	                $added: true,
	                entityName: fieldObject.entityName,
	                fieldName: fieldObject.fieldName,
	                configLevel: metaConstant_1.CONFIGLEVEL.GLOBAL
	            });
	            fieldObject.validations.push(newValidation);
	            rootObject.$dirty = true;
	        };
	        return _this;
	    }
	    FieldValidationList.prototype.render = function () {
	        var _a = this.props, fieldObject = _a.fieldObject, entities = _a.entities, entity = _a.entity, rootObject = _a.rootObject;
	        var header = (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
	            react_1.default.createElement("div", null, "Field Validations"),
	            react_1.default.createElement(icons_1.MdIconButton, { onClick: this.addValidation },
	                react_1.default.createElement(add_1.default, null))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { header: header, noPadding: true, style: { display: 'flex', flexDirection: 'column' } }, (0, arrayUtils_1.addSeparator)(fieldObject.validations.map(function (fv, index) { return react_1.default.createElement(FieldValidationTableForm, { dataObject: fv, rootObject: rootObject, key: index, entities: entities, entity: entity, index: index }); }), react_1.default.createElement(blockComp_2.MdDivider, { inset: true }))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], FieldValidationList.prototype, "addValidation", void 0);
	    FieldValidationList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], FieldValidationList);
	    return FieldValidationList;
	}(react_1.default.Component));
	exports.default = FieldValidationList;
	var ParameterFieldComp = function (_a) {
	    var dataType = _a.dataType, other = tslib_1.__rest(_a, ["dataType"]);
	    switch (dataType) {
	        case mdField_1.DATATYPE.NUMBER:
	        case mdField_1.DATATYPE.NUMBERCURRENCY:
	            return (react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, other)));
	        case mdField_1.DATATYPE.STRING:
	            return (react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, other, { maxLength: 255 })));
	        default:
	            return null;
	    }
	};
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { display: 'flex', fontSize: 16, lineHeight: '14px' } },
	        react_1.default.createElement("div", { className: "zz-grey-text zz-mr-5" }, (0, formUtils_1.lovLabel)(dataObject.configLevel)),
	        ((0, formUtils_1.lovValue)(dataObject.configLevel) === metaConstant_1.CONFIGLEVEL.TENANTGROUP) ? react_1.default.createElement("div", { className: "zz-grey-text" }, (0, formUtils_1.lovLabel)(dataObject.tenantGroup)) : null,
	        ((0, formUtils_1.lovValue)(dataObject.configLevel) === metaConstant_1.CONFIGLEVEL.TENANT) ? react_1.default.createElement("div", { className: "zz-grey-text" }, (0, formUtils_1.lovLabel)(dataObject.tenant)) : null,
	        ((0, formUtils_1.lovValue)(dataObject.configLevel) === metaConstant_1.CONFIGLEVEL.USER) ? react_1.default.createElement("div", { className: "zz-grey-text" }, (0, formUtils_1.lovLabel)(dataObject.user)) : null,
	        (dataObject.language) ? react_1.default.createElement("div", { className: "zz-grey-text zz-ml-5" },
	            "(",
	            (0, formUtils_1.lovLabel)(dataObject.language),
	            ")") : null,
	        (dataObject.serverSide) ? react_1.default.createElement("div", { className: "zz-grey-text zz-ml-5" }, "server-side") : null,
	        react_1.default.createElement("div", { className: "zz-ml-10" },
	            (0, formUtils_1.lovLabel)(dataObject.validation),
	            (dataObject.parameters) ? (react_1.default.createElement("span", { className: "zz-ml-5" },
	                "(",
	                dataObject.parameters.entries().map(function (_a) {
	                    var key = _a[0], value = _a[1];
	                    return react_1.default.createElement("span", { key: key, className: "zz-ml-2" },
	                        key,
	                        " : ",
	                        value);
	                }),
	                ")")) : null),
	        (dataObject.qualifyExpr) ? (react_1.default.createElement("div", { className: "zz-ml-10" }, dataObject.qualifyExpr)) : null));
	};
	var FieldValidationTableForm = /** @class */ (function (_super) {
	    tslib_1.__extends(FieldValidationTableForm, _super);
	    function FieldValidationTableForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDelete = function (evt) {
	            evt.stopPropagation();
	            console.log('onDelete %o', _this.props.dataObject);
	            pull(_this.props.rootObject.validations, _this.props.dataObject);
	        };
	        _this.handleConfigLevelChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, formName = _a.formName;
	            console.log('handleConfigLevelChange ', dataObject.configLevel);
	            dataObject.tenant = null;
	            dataObject.tenantGroup = null;
	            dataObject.user = null;
	            dataObject.getForm(formName).updateAllFieldsPropValue(dataObject);
	        };
	        _this.onChangeParameter = function (parameterName, value) {
	            if (value != null && value != '') {
	                _this.props.dataObject.parameters.set(parameterName, value);
	            }
	            else {
	                _this.props.dataObject.parameters.delete(parameterName);
	            }
	        };
	        return _this;
	    }
	    FieldValidationTableForm.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, index = _a.index, entities = _a.entities, formName = _a.formName, entity = _a.entity;
	        var fields = dataObject.getFormFields(formName);
	        var validation = fields.validation, configLevel = fields.configLevel, tenantGroup = fields.tenantGroup, tenant = fields.tenant, user = fields.user, language = fields.language, qualifyExpr = fields.qualifyExpr, serverSide = fields.serverSide;
	        var parametersDef = null;
	        if (dataObject.validation) {
	            var validationFunction = definedRules[(0, formUtils_1.lovValue)(dataObject.validation)];
	            if (validationFunction && validationFunction.parameters) {
	                parametersDef = validationFunction.parameters;
	            }
	        }
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, configLevel.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: configLevel, value: configLevel.props.value, onSuccess: this.handleConfigLevelChange })),
	                ((0, formUtils_1.lovValue)(dataObject.configLevel) === metaConstant_1.CONFIGLEVEL.TENANTGROUP) ?
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, tenantGroup.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: tenantGroup, value: tenantGroup.props.value }))
	                    : null,
	                ((0, formUtils_1.lovValue)(dataObject.configLevel) === metaConstant_1.CONFIGLEVEL.TENANT) ?
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, tenant.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: tenant, value: tenant.props.value }))
	                    : null,
	                ((0, formUtils_1.lovValue)(dataObject.configLevel) === metaConstant_1.CONFIGLEVEL.USER) ?
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, user.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'User', {}), clearable: true, asterixForAll: true })),
	                        react_1.default.createElement(validate_1.Validate, { field: user, value: user.props.value }))
	                    : null,
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, language.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, validation.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: validation, value: validation.props.value })),
	                (parametersDef) ? (Object.entries(parametersDef).map(function (_a) {
	                    var key = _a[0], value = _a[1];
	                    return (react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4", key: key },
	                        react_1.default.createElement(ParameterFieldComp, { dataType: value, value: dataObject.parameters.get(key), name: key, floatingLabelText: key, onChange: _this.onChangeParameter.bind(_this, key) })));
	                })) : null),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-8" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, qualifyExpr.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, serverSide.props))))));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), key: index, onDelete: this.onDelete, validate: this.props.validate }, this.props)));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], FieldValidationTableForm.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], FieldValidationTableForm.prototype, "handleConfigLevelChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], FieldValidationTableForm.prototype, "onChangeParameter", void 0);
	    FieldValidationTableForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'FieldValidationTableForm',
	            fields: [{
	                    name: 'validation'
	                }, {
	                    name: 'tenantGroup',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'tenant',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'user',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'configLevel',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'language'
	                }, {
	                    name: 'serverSide'
	                }, {
	                    name: 'qualifyExpr'
	                }]
	        }, ClosedContent),
	        mobx_react_1.observer
	    ], FieldValidationTableForm);
	    return FieldValidationTableForm;
	}(react_1.default.Component));


/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mdConfigService_1 = tslib_1.__importDefault(__webpack_require__(941));
	var blockComp_1 = __webpack_require__(30);
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var gridComp_1 = tslib_1.__importDefault(__webpack_require__(44));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var errorComp_1 = __webpack_require__(34);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var gridUtils_1 = __webpack_require__(83);
	var mobx_1 = __webpack_require__(5);
	var buttons_1 = __webpack_require__(27);
	var gridComp_2 = __webpack_require__(44);
	var entityValidationList_1 = tslib_1.__importDefault(__webpack_require__(2110));
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var formUtils_1 = __webpack_require__(14);
	var locales_1 = __webpack_require__(15);
	var utils_1 = __webpack_require__(37);
	var mdFieldGridLocation = 'mdFieldList';
	var EntityDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(EntityDetail, _super);
	    function EntityDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onSave = function (evt) {
	            console.log('onSave ');
	            uiService_1.default.showToolbarActionFlag();
	            if (!(0, formUtils_1.preSave)(mdConfigService_1.default.entityObject)) {
	                return;
	            }
	            mdConfigService_1.default.saveEntityDto(mdConfigService_1.default.entityObject)
	                .then((0, mobx_1.action)("entityDtoSave-action", function (foJson) {
	                var wasNew = mdConfigService_1.default.entityObject.cleanAfterSave(foJson);
	                uiService_1.default.hideToolbarActionFlag();
	            }), function (error) {
	                mdConfigService_1.default.entityObject.$errors = error.getMessages();
	            });
	        };
	        return _this;
	    }
	    EntityDetail.fetchData = function (routerParams, query) {
	        var entityName = routerParams.id;
	        console.log("EntityDetail#fetchData(%O)", entityName);
	        // $freshLoadFlag = true;
	        // $fetchDataDoneFlag = false;
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['EntityValidationTable'], [entityName, 'MdField', 'MdEntity']);
	        var gridPromise = gridService_1.default.fetchGrids(mdFieldGridLocation);
	        var entityDtoPromise = mdConfigService_1.default.readEntityDto(entityName);
	        return Promise.all([metadataPromise, gridPromise, entityDtoPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], gridLocationMap = _a[1], entityObject = _a[2];
	            entityObject.$entityRef = entityMap.get(entityName);
	            entityObject.$movingBlocks = new gridUtils_1.MovingBlocks(null, false, null, new grid_1.default(gridLocationMap.get(mdFieldGridLocation), entityName));
	            mdConfigService_1.default.entityObject = entityObject;
	        });
	    };
	    /**
	     * tohle je tady kvuli prechodu na jiny detail entity (chained details)
	     * @param prevProps
	     */
	    EntityDetail.prototype.componentDidUpdate = function (prevProps) {
	        if (this.idChanged(prevProps.params.id, this.props.params.id)) {
	            mdConfigService_1.default.entityObject.$movingBlocks.searchExposedGrids(mdConfigService_1.default.entityObject);
	        }
	    };
	    EntityDetail.prototype.componentDidMount = function () {
	        mdConfigService_1.default.entityObject.$movingBlocks.searchExposedGrids(mdConfigService_1.default.entityObject);
	    };
	    EntityDetail.prototype.componentWillUnmount = function () {
	        mdConfigService_1.default.entityObject = null;
	    };
	    EntityDetail.prototype.findRootObject = function () {
	        return mdConfigService_1.default.entityObject;
	    };
	    EntityDetail.prototype.render = function () {
	        var query = this.props.query;
	        var movingBlocks = mdConfigService_1.default.entityObject.$movingBlocks;
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	            this._createToolMenu(query.gridLocation, mdConfigService_1.default.entityObject),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: mdConfigService_1.default.entityObject.$errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement(blockComp_1.BlockComp, { style: { marginTop: 10 }, header: "Entity ".concat(mdConfigService_1.default.entityObject.mdEntity) },
	                react_1.default.createElement("form", null,
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "col-xs-12 col-sm-6 block-comp-right-border" },
	                            react_1.default.createElement(blockComp_1.BlockComp, { style: { marginTop: 10 }, header: "Entity" },
	                                mdConfigService_1.default.entityObject.mdEntity,
	                                react_1.default.createElement("br", null),
	                                "TODO: label edit")),
	                        react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                            react_1.default.createElement(entityValidationList_1.default, { entityObject: mdConfigService_1.default.entityObject, rootObject: mdConfigService_1.default.entityObject, entities: mdEntityService_1.default.entityMap, entity: mdEntityService_1.default.getEntity('EntityValidationTable') }))))),
	            react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(mdFieldGridLocation), uiLocation: gridComp_2.UILOCATION.main, gridClassName: "detail-grid", entities: mdEntityService_1.default.entityMap })));
	    };
	    EntityDetail.prototype._createToolMenu = function (gridLocation, entityObject) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: false },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, label: "Save Entity", permission: metaConstant_1.PERMISSION.Update }),
	            entityObject.$entityRef.supportDynamicFields && react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "entityFieldDetail", params: { id: (0, utils_1.formatId)(entityObject.mdEntity, 'new') }, label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["New Dynamic Field"], ["New Dynamic Field"]))), permission: metaConstant_1.PERMISSION.New, securable: metaConstant_1.SECURABLE.entityFieldDetail })));
	    };
	    EntityDetail.module = metaConstant_1.MODULE.core;
	    EntityDetail.title = 'Entity';
	    EntityDetail.icon = 'book';
	    EntityDetail.protectedPage = true;
	    EntityDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EntityDetail);
	    return EntityDetail;
	}(pageAncestor_1.default));
	exports.default = EntityDetail;
	var templateObject_1;


/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mdConfigService_1 = tslib_1.__importDefault(__webpack_require__(941));
	var utils_1 = __webpack_require__(37);
	var formUtils_1 = __webpack_require__(14);
	var errorComp_1 = __webpack_require__(34);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var fieldDefaultList_1 = tslib_1.__importDefault(__webpack_require__(2111));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var buttons_1 = __webpack_require__(27);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var mobx_1 = __webpack_require__(5);
	var fieldValidationList_1 = tslib_1.__importDefault(__webpack_require__(2112));
	var metaDomain_1 = __webpack_require__(220);
	var localizeFields_1 = tslib_1.__importDefault(__webpack_require__(930));
	var mdField_1 = __webpack_require__(57);
	var createForm_1 = __webpack_require__(18);
	var blockComp_1 = __webpack_require__(30);
	var validate_1 = __webpack_require__(24);
	var fields_1 = __webpack_require__(20);
	var rules_1 = __webpack_require__(56);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridUtils_1 = __webpack_require__(83);
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var gridComp_1 = tslib_1.__importStar(__webpack_require__(44));
	var tenantSelectionSupport_1 = __webpack_require__(403);
	var tenantGridLocation = 'tenantList';
	var tenantGroupListLocation = 'tenantGroupList';
	var tenantGridComposite = 'tenantGridComposite';
	var EntityFieldDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(EntityFieldDetail, _super);
	    function EntityFieldDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.customValidate = function (fieldObject) {
	            var errors = [];
	            if (fieldObject.$new) {
	                var entity = mdEntityService_1.default.getEntity(fieldObject.entityName);
	                if (entity.getField(fieldObject.dynamicFieldConfig.fieldName)) {
	                    errors.push({ message: "Field " + fieldObject.dynamicFieldConfig.fieldName + " already exists on the entity" });
	                }
	            }
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave ');
	            uiService_1.default.showToolbarActionFlag();
	            var fieldObject = mdConfigService_1.default.fieldObject;
	            if (!(0, formUtils_1.preSave)(fieldObject, _this.customValidate)) {
	                return;
	            }
	            mdConfigService_1.default.saveFieldDto(fieldObject)
	                .then((0, mobx_1.action)("fieldDtoSave-action", function (foJson) {
	                var wasNew = fieldObject.cleanAfterSave(foJson);
	                if (wasNew) {
	                    _this.context.router.replaceWith('entityFieldDetail', { id: fieldObject.getId() });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            }), function (error) {
	                fieldObject.$errors = error.getMessages();
	            });
	        };
	        _this.onBack = function (evt) {
	            _this.context.router.transitionTo('entityDetail', { id: mdConfigService_1.default.fieldObject.entityName });
	        };
	        return _this;
	    }
	    EntityFieldDetail.fetchData = function (routerParams, query) {
	        console.log("EntityFieldDetail#fetchData(%O)", routerParams.id);
	        var _a = (0, utils_1.parseId)(routerParams.id), entityName = _a[0], fieldName = _a[1];
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['DynamicFieldConfig', 'FieldDefaultTable', 'FieldValidationTable'], [entityName, 'MdField']);
	        var gridPromise = gridService_1.default.fetchGrids(tenantGridLocation, tenantGroupListLocation);
	        var fieldDtoPromise;
	        if (fieldName === 'new') {
	            fieldDtoPromise = Promise.resolve(new metaDomain_1.MdFieldDto({
	                entityName: entityName,
	                fieldType: mdField_1.FIELDTYPE.DYNAMIC,
	                dynamicFieldConfig: {
	                    entityName: entityName,
	                    active: true,
	                    $new: true
	                },
	                $new: true,
	                active: true
	            }));
	        }
	        else {
	            fieldDtoPromise = mdConfigService_1.default.readFieldDto(routerParams.id);
	        }
	        return Promise.all([fieldDtoPromise, metadataPromise, gridPromise])
	            .then(function (_a) {
	            var mdFieldDto = _a[0], entityMap = _a[1], gridLocationMap = _a[2];
	            mdFieldDto.$movingBlocks = new gridUtils_1.MovingBlocks(tenantGridComposite, false, null, new gridUtils_1.GridComposite(tenantGridComposite, 'Tenant selection', new grid_1.default(gridLocationMap.get(tenantGridLocation)), new grid_1.default(gridLocationMap.get(tenantGroupListLocation))));
	            mdConfigService_1.default.fieldObject = mdFieldDto.initAfterRead(routerParams.id === 'new');
	            console.log("fieldObject = %o", mdConfigService_1.default.fieldObject);
	        });
	    };
	    /**
	     * tohle je tady kvuli prechodu na jiny detail invoice (chained details)
	     * @param prevProps
	     */
	    EntityFieldDetail.prototype.componentDidUpdate = function (prevProps) {
	        if (this.idChanged(prevProps.params.id, this.props.params.id)) {
	            mdConfigService_1.default.fieldObject.$movingBlocks.searchExposedGrids(mdConfigService_1.default.fieldObject);
	        }
	    };
	    EntityFieldDetail.prototype.componentDidMount = function () {
	        console.debug("%c componentDidMount", "background-color: magenta");
	        mdConfigService_1.default.fieldObject.$movingBlocks.searchExposedGrids(mdConfigService_1.default.fieldObject);
	    };
	    EntityFieldDetail.prototype.componentWillUnmount = function () {
	        mdConfigService_1.default.fieldObject = null;
	    };
	    EntityFieldDetail.prototype.findRootObject = function () {
	        return mdConfigService_1.default.fieldObject;
	    };
	    EntityFieldDetail.prototype.render = function () {
	        var query = this.props.query;
	        var dynFieldConfigEntity = mdEntityService_1.default.getEntity("DynamicFieldConfig");
	        var movingBlocks = mdConfigService_1.default.fieldObject.$movingBlocks;
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	            this._createToolMenu(query.gridLocation),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: mdConfigService_1.default.fieldObject.$errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            mdConfigService_1.default.fieldObject.fieldType === mdField_1.FIELDTYPE.DYNAMIC && (react_1.default.createElement("div", null,
	                react_1.default.createElement(DynamicFieldConfigForm, { dataObject: mdConfigService_1.default.fieldObject.dynamicFieldConfig, entities: mdEntityService_1.default.entityMap, rootObject: mdConfigService_1.default.fieldObject, entity: dynFieldConfigEntity }),
	                react_1.default.createElement(gridComp_1.GridCompositeComp, { grid: movingBlocks.getBlock(tenantGridComposite), uiLocation: movingBlocks.getUiLocation(tenantGridComposite) },
	                    react_1.default.createElement("div", { className: "col-xs-12 col-sm-6", style: { padding: 10 } },
	                        react_1.default.createElement("h4", null, "Select Tenants"),
	                        react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(tenantGridComposite).groupMembers[0], multiSelect: false, hideToolbar: true, gridClassName: "detail-grid", uiLocation: movingBlocks.getUiLocation(tenantGridComposite), functionMap: { getSelectTenant: tenantSelectionSupport_1.getSelectTenant.bind(this, mdConfigService_1.default.fieldObject.dynamicFieldConfig), setSelectTenant: tenantSelectionSupport_1.setSelectTenant.bind(this, mdConfigService_1.default.fieldObject.dynamicFieldConfig) }, entities: mdEntityService_1.default.entityMap })),
	                    react_1.default.createElement("div", { className: "col-xs-12 col-sm-6", style: { padding: 10 } },
	                        react_1.default.createElement("h4", null, "or select Tenant Groups"),
	                        react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(tenantGridComposite).groupMembers[1], multiSelect: false, hideToolbar: true, gridClassName: "detail-grid", uiLocation: movingBlocks.getUiLocation(tenantGridComposite), functionMap: { getSelectTenantGroup: tenantSelectionSupport_1.getSelectTenantGroup.bind(this, mdConfigService_1.default.fieldObject.dynamicFieldConfig), setSelectTenantGroup: tenantSelectionSupport_1.setSelectTenantGroup.bind(this, mdConfigService_1.default.fieldObject.dynamicFieldConfig) }, entities: mdEntityService_1.default.entityMap }))))),
	            mdConfigService_1.default.fieldObject.fieldType !== mdField_1.FIELDTYPE.DYNAMIC && (react_1.default.createElement("h1", null,
	                mdConfigService_1.default.fieldObject.entityName,
	                " / ",
	                mdConfigService_1.default.fieldObject.fieldName)),
	            react_1.default.createElement("form", { style: { marginTop: 10 } },
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12 col-sm-6 block-comp-right-border" },
	                        react_1.default.createElement(localizeFields_1.default, { fields: mdConfigService_1.default.fieldObject.locales.entries().map(function (_a) {
	                                var fieldName = _a[0], locArray = _a[1];
	                                return ({ fieldName: fieldName, locArray: locArray });
	                            }) })),
	                    react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                        react_1.default.createElement(fieldDefaultList_1.default, { fieldObject: mdConfigService_1.default.fieldObject, rootObject: mdConfigService_1.default.fieldObject, entities: mdEntityService_1.default.entityMap, entity: mdEntityService_1.default.getEntity('FieldDefaultTable') }),
	                        react_1.default.createElement(fieldValidationList_1.default, { fieldObject: mdConfigService_1.default.fieldObject, rootObject: mdConfigService_1.default.fieldObject, entities: mdEntityService_1.default.entityMap, entity: mdEntityService_1.default.getEntity('FieldValidationTable') }))))));
	    };
	    EntityFieldDetail.prototype._createToolMenu = function (gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: false },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, label: "Save Field", permission: metaConstant_1.PERMISSION.Update })));
	    };
	    EntityFieldDetail.module = metaConstant_1.MODULE.core;
	    EntityFieldDetail.title = 'Field';
	    EntityFieldDetail.icon = 'book';
	    EntityFieldDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EntityFieldDetail.prototype, "onSave", void 0);
	    EntityFieldDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EntityFieldDetail);
	    return EntityFieldDetail;
	}(pageAncestor_1.default));
	exports.default = EntityFieldDetail;
	var DynamicFieldConfigForm = /** @class */ (function (_super) {
	    tslib_1.__extends(DynamicFieldConfigForm, _super);
	    function DynamicFieldConfigForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DynamicFieldConfigForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entity = _a.entity, entities = _a.entities, form = _a.form, formName = _a.formName;
	        var fields = form.fields;
	        var _b = dataObject.getFormFields(formName), fieldName = _b.fieldName, dataType = _b.dataType, defaultLabel = _b.defaultLabel, active = _b.active;
	        return (react_1.default.createElement("form", { style: { marginTop: 10 } },
	            react_1.default.createElement(blockComp_1.BlockComp, null,
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                        react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, fieldName.props, { disabled: !dataObject.$new })),
	                        react_1.default.createElement(validate_1.Validate, { field: fieldName, value: fieldName.props.value },
	                            react_1.default.createElement(rules_1.PrimaryKeyString, null))),
	                    react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, dataType.props, { clearable: false, disabled: !dataObject.$new })),
	                        react_1.default.createElement(validate_1.Validate, { field: dataType, value: dataType.props.value })),
	                    react_1.default.createElement("div", { className: "fx col-xs-10 col-sm-5" },
	                        react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, defaultLabel.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: defaultLabel, value: defaultLabel.props.value })),
	                    react_1.default.createElement("div", { className: "fx col-xs-2 col-sm-1" },
	                        react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, active.props)))))));
	    };
	    DynamicFieldConfigForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'DynamicFieldConfigForm',
	            fields: [{
	                    name: 'fieldName',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'dataType',
	                    validators: ['IsRequired'],
	                }, {
	                    name: 'defaultLabel',
	                    validators: ['IsRequired']
	                }, {
	                    name: "active"
	                }]
	        }, function () { return react_1.default.createElement("noscript", null); }),
	        mobx_react_1.observer
	    ], DynamicFieldConfigForm);
	    return DynamicFieldConfigForm;
	}(react_1.default.Component));


/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'entityList';
	var EntityList = /** @class */ (function (_super) {
	    tslib_1.__extends(EntityList, _super);
	    function EntityList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    EntityList.fetchData = function (routerParams) {
	        console.log("EntityList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    EntityList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query }));
	    };
	    EntityList.module = metaConstant_1.MODULE.core;
	    EntityList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Entities"], ["Entities"])));
	    EntityList.icon = 'book';
	    EntityList.rootPage = true;
	    EntityList.protectedPage = true;
	    EntityList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EntityList);
	    return EntityList;
	}(pageAncestor_1.default));
	exports.default = EntityList;
	var templateObject_1;


/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mdField_1 = tslib_1.__importStar(__webpack_require__(57));
	var mobx_1 = __webpack_require__(5);
	var utils_1 = __webpack_require__(37);
	var isPlainObject = __webpack_require__(137);
	var MdEntity = /** @class */ (function () {
	    function MdEntity(json) {
	        this.fromJson(json);
	    }
	    MdEntity.prototype.fromJson = function (json) {
	        for (var key in json) {
	            if (json.hasOwnProperty(key)) {
	                this[key] = json[key];
	            }
	        }
	        var mapa = mobx_1.observable.shallowMap();
	        if (isPlainObject(this.fields)) {
	            for (var key in this.fields) {
	                mapa.set(key, new mdField_1.default(this.fields[key], this));
	            }
	        }
	        this.fields = mapa;
	    };
	    /**
	     * vrati LovItem dle zadaneho id (value)
	     */
	    MdEntity.prototype.getLovItem = function (id, strictEquality) {
	        if (strictEquality === void 0) { strictEquality = true; }
	        return (strictEquality) ? this.lovItems.find(function (lov) { return lov.value === id; }) : this.lovItems.find(function (lov) { return lov.value == id; });
	    };
	    MdEntity.prototype.getLovItemLabel = function (id) {
	        var lov = this.getLovItem(id);
	        return (lov) ? lov.label : undefined;
	    };
	    MdEntity.prototype.getLovItemParam = function (id, paramName) {
	        var lov = this.getLovItem(id);
	        return (lov) ? lov[paramName] : undefined;
	    };
	    MdEntity.prototype.getField = function (fieldName) {
	        return this.fields.get(fieldName);
	    };
	    MdEntity.prototype.getFieldByKey = function (fieldKey) {
	        var fieldName = (fieldKey) ? (0, utils_1.parseId)(fieldKey).slice(-1).pop() : undefined;
	        return (fieldName) ? this.fields.get(fieldName) : undefined;
	    };
	    MdEntity.prototype.getFields = function () {
	        return this.fields.values();
	    };
	    MdEntity.prototype.getDynamicFields = function () {
	        return this.fields.values().filter(function (md) { return md.fieldType === mdField_1.FIELDTYPE.DYNAMIC; });
	    };
	    MdEntity.prototype.newObject = function (dataObject) {
	        if (!dataObject['@class'])
	            dataObject['@class'] = this.clazzName;
	        return dataObject;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], MdEntity.prototype, "fields", void 0);
	    return MdEntity;
	}());
	exports.default = MdEntity;


/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SecurableDetailDrawer = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_1 = __webpack_require__(5);
	var securityDomain_1 = __webpack_require__(97);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var Drawer_1 = tslib_1.__importDefault(__webpack_require__(286));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var formUtils_1 = __webpack_require__(14);
	var metaConstant_1 = __webpack_require__(13);
	var colors_1 = __webpack_require__(29);
	var fields_1 = __webpack_require__(20);
	var errorComp_1 = __webpack_require__(34);
	var TH_STYLE = { position: "sticky", top: 0, zIndex: 100, backgroundColor: colors_1.white };
	var TD_STYLE = { paddingTop: 5, paddingBottom: 5 };
	var TD_STYLE_GREY = { paddingTop: 5, paddingBottom: 5, backgroundColor: colors_1.grey200 };
	var TD_STYLE_GREEN = { paddingTop: 5, paddingBottom: 5, backgroundColor: colors_1.green100 };
	var TD_STYLE_RED = { paddingTop: 5, paddingBottom: 5, backgroundColor: colors_1.red100 };
	var SecurableDetailDrawer = /** @class */ (function (_super) {
	    tslib_1.__extends(SecurableDetailDrawer, _super);
	    function SecurableDetailDrawer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SecurableDetailDrawer.prototype.componentWillMount = function () {
	        var _a = this.props, securableDefinition = _a.securableDefinition, securablePermission = _a.securablePermission;
	        console.log("Open SecurableDetailDrawer ", securablePermission.securable.value);
	        this.expandedSPDs = securableDefinition.detailPermissions.map(function (detailLov) {
	            var permissionDetail = securablePermission.detailPermissions.get((0, formUtils_1.lovValue)(detailLov));
	            if (!permissionDetail) {
	                permissionDetail = new securityDomain_1.SecurablePermissionDetail({ id: detailLov.value, detailId: detailLov.value, label: detailLov.label });
	            }
	            return permissionDetail;
	        });
	    };
	    SecurableDetailDrawer.prototype.render = function () {
	        var _a = this.props, open = _a.open, securableDefinition = _a.securableDefinition, securityRole = _a.securityRole, securablePermission = _a.securablePermission;
	        var screenWidth = document.body.getBoundingClientRect().width;
	        var availablePermissions = securableDefinition.availablePermissions;
	        var permissionKeys = Object.keys(metaConstant_1.PERMISSION).filter(function (p) { return ![metaConstant_1.PERMISSION.PublicGrid, metaConstant_1.PERMISSION.TenantGrid, metaConstant_1.PERMISSION.TenantGroupGrid].includes(p); });
	        return (react_1.default.createElement(Drawer_1.default, { open: open, width: 0.9 * screenWidth, docked: true, onRequestChange: this.onClose, containerStyle: { paddingTop: 40 } },
	            react_1.default.createElement("div", { style: { margin: 20 } },
	                react_1.default.createElement(FlatButton_1.default, { label: "Close", primary: true, onClick: this.onClose.bind(this) })),
	            react_1.default.createElement(errorComp_1.ErrorComp, { style: { margin: 20 }, bsStyle: "info", messages: [
	                    { message: "When master securable (" + (0, formUtils_1.lovLabel)(securablePermission.securable) + ") is checked, then all detailed not checked securables are positive" },
	                    { message: "When master securable is not checked, then only detailed checked securables are positive" },
	                    { message: "In short: green ~ positive, red ~ negative" }
	                ] }),
	            react_1.default.createElement("table", { className: "zz-simple-table", style: { position: "relative", margin: 10 } },
	                react_1.default.createElement("thead", null,
	                    react_1.default.createElement("tr", null,
	                        react_1.default.createElement("th", { style: TH_STYLE }),
	                        permissionKeys.map(function (p, i) { return (react_1.default.createElement("th", { key: i, style: TH_STYLE }, p)); }))),
	                react_1.default.createElement("tbody", null,
	                    react_1.default.createElement("tr", null,
	                        react_1.default.createElement("td", { style: TD_STYLE },
	                            react_1.default.createElement("b", null, (0, formUtils_1.lovLabel)(securablePermission.securable))),
	                        react_1.default.createElement(SecurableAssignedCell, { expandedSPDs: this.expandedSPDs, securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.Read, index: -1, availablePermissions: availablePermissions, securityRole: securityRole }),
	                        react_1.default.createElement(SecurableAssignedCell, { expandedSPDs: this.expandedSPDs, securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.New, index: -1, availablePermissions: availablePermissions, securityRole: securityRole }),
	                        react_1.default.createElement(SecurableAssignedCell, { expandedSPDs: this.expandedSPDs, securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.Update, index: -1, availablePermissions: availablePermissions, securityRole: securityRole }),
	                        react_1.default.createElement(SecurableAssignedCell, { expandedSPDs: this.expandedSPDs, securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.Delete, index: -1, availablePermissions: availablePermissions, securityRole: securityRole }),
	                        react_1.default.createElement(SecurableAssignedCell, { expandedSPDs: this.expandedSPDs, securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.Execute, index: -1, availablePermissions: availablePermissions, securityRole: securityRole }),
	                        react_1.default.createElement(SecurableAssignedCell, { expandedSPDs: this.expandedSPDs, securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.Export, index: -1, availablePermissions: availablePermissions, securityRole: securityRole }),
	                        react_1.default.createElement(SecurableAssignedCell, { expandedSPDs: this.expandedSPDs, securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.Import, index: -1, availablePermissions: availablePermissions, securityRole: securityRole })),
	                    this.expandedSPDs.map(function (spd, index) {
	                        return (react_1.default.createElement("tr", { key: index },
	                            react_1.default.createElement("td", { style: TD_STYLE }, (0, formUtils_1.lovLabel)(spd)),
	                            react_1.default.createElement(SecurableDetailCell, { spd: spd, securityRole: securityRole, permission: metaConstant_1.PERMISSION.Read, index: index, availablePermissions: availablePermissions, securablePermission: securablePermission }),
	                            react_1.default.createElement(SecurableDetailCell, { spd: spd, securityRole: securityRole, permission: metaConstant_1.PERMISSION.New, index: index, availablePermissions: availablePermissions, securablePermission: securablePermission }),
	                            react_1.default.createElement(SecurableDetailCell, { spd: spd, securityRole: securityRole, permission: metaConstant_1.PERMISSION.Update, index: index, availablePermissions: availablePermissions, securablePermission: securablePermission }),
	                            react_1.default.createElement(SecurableDetailCell, { spd: spd, securityRole: securityRole, permission: metaConstant_1.PERMISSION.Delete, index: index, availablePermissions: availablePermissions, securablePermission: securablePermission }),
	                            react_1.default.createElement(SecurableDetailCell, { spd: spd, securityRole: securityRole, permission: metaConstant_1.PERMISSION.Execute, index: index, availablePermissions: availablePermissions, securablePermission: securablePermission }),
	                            react_1.default.createElement(SecurableDetailCell, { spd: spd, securityRole: securityRole, permission: metaConstant_1.PERMISSION.Export, index: index, availablePermissions: availablePermissions, securablePermission: securablePermission }),
	                            react_1.default.createElement(SecurableDetailCell, { spd: spd, securityRole: securityRole, permission: metaConstant_1.PERMISSION.Import, index: index, availablePermissions: availablePermissions, securablePermission: securablePermission })));
	                    })))));
	    };
	    SecurableDetailDrawer.prototype.onClose = function (event) {
	        var _a = this.props, onRequestChange = _a.onRequestChange, securablePermission = _a.securablePermission;
	        securablePermission.detailPermissions.clear();
	        this.expandedSPDs.forEach(function (spd) {
	            if (spd.getPermissionList().length > 0) {
	                securablePermission.detailPermissions.set(spd.detailId, spd);
	            }
	        });
	        onRequestChange();
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SecurableDetailDrawer.prototype, "expandedSPDs", void 0);
	    SecurableDetailDrawer = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SecurableDetailDrawer);
	    return SecurableDetailDrawer;
	}(react_1.default.Component));
	exports.SecurableDetailDrawer = SecurableDetailDrawer;
	var SecurableDetailCell = /** @class */ (function (_super) {
	    tslib_1.__extends(SecurableDetailCell, _super);
	    function SecurableDetailCell() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onCheck = function (evt, checked) {
	            var _a = _this.props, spd = _a.spd, permission = _a.permission, securityRole = _a.securityRole;
	            console.log('onCheck checked: ' + checked);
	            spd.setPermission(permission, checked);
	            securityRole.$dirty = true;
	        };
	        return _this;
	    }
	    SecurableDetailCell.prototype.render = function () {
	        var _a = this.props, permission = _a.permission, index = _a.index, availablePermissions = _a.availablePermissions, spd = _a.spd, securablePermission = _a.securablePermission;
	        var active = availablePermissions.includes(permission);
	        var tdStyle = active ? ((!!securablePermission.isPermission(permission) != !!spd.isPermission(permission)) ? TD_STYLE_GREEN : TD_STYLE_RED) : TD_STYLE_GREY;
	        return (react_1.default.createElement("td", { style: tdStyle }, active &&
	            react_1.default.createElement(fields_1.MdCheckbox, { name: permission + index, checked: spd.isPermission(permission), onCheck: this.onCheck })));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SecurableDetailCell.prototype, "onCheck", void 0);
	    SecurableDetailCell = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SecurableDetailCell);
	    return SecurableDetailCell;
	}(react_1.default.Component));
	var SecurableAssignedCell = /** @class */ (function (_super) {
	    tslib_1.__extends(SecurableAssignedCell, _super);
	    function SecurableAssignedCell() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onCheck = function (evt, checked) {
	            var _a = _this.props, securablePermission = _a.securablePermission, permission = _a.permission, securityRole = _a.securityRole, expandedSPDs = _a.expandedSPDs;
	            console.log('onCheck checked: ' + checked);
	            securablePermission.setPermission(permission, checked);
	            expandedSPDs.forEach(function (spd) { return spd.setPermission(permission, false); });
	            securityRole.$dirty = true;
	            securablePermission.$dirty = true;
	        };
	        return _this;
	    }
	    SecurableAssignedCell.prototype.render = function () {
	        var _a = this.props, securablePermission = _a.securablePermission, permission = _a.permission, index = _a.index, availablePermissions = _a.availablePermissions;
	        var active = availablePermissions.includes(permission);
	        var tdStyle = active ? TD_STYLE : TD_STYLE_GREY;
	        return (react_1.default.createElement("td", { style: tdStyle }, active &&
	            react_1.default.createElement(fields_1.MdCheckbox, { name: permission + index, checked: securablePermission.isPermission(permission), onCheck: this.onCheck })));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SecurableAssignedCell.prototype, "onCheck", void 0);
	    SecurableAssignedCell = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SecurableAssignedCell);
	    return SecurableAssignedCell;
	}(react_1.default.Component));


/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SecurableDrawer = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_dnd_1 = __webpack_require__(508);
	var Drawer_1 = tslib_1.__importDefault(__webpack_require__(286));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var arrayUtils_1 = __webpack_require__(78);
	var blockComp_1 = __webpack_require__(30);
	var formUtils_1 = __webpack_require__(14);
	var Chip_1 = tslib_1.__importDefault(__webpack_require__(211));
	var jsonUtils_1 = __webpack_require__(193);
	var SecurableDrawer = /** @class */ (function (_super) {
	    tslib_1.__extends(SecurableDrawer, _super);
	    function SecurableDrawer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SecurableDrawer.prototype.render = function () {
	        var _a = this.props, entities = _a.entities, open = _a.open, onRequestChange = _a.onRequestChange, securables = _a.securables, securityRoleObject = _a.securityRoleObject;
	        var screenWidth = document.body.getBoundingClientRect().width;
	        return (react_1.default.createElement(Drawer_1.default, { open: open, width: 0.5 * screenWidth, docked: true, onRequestChange: onRequestChange, containerStyle: { paddingTop: 40 } },
	            react_1.default.createElement("div", { style: { margin: 20 } },
	                react_1.default.createElement(FlatButton_1.default, { label: "Close", primary: true, onClick: onRequestChange })),
	            securables &&
	                (0, arrayUtils_1.addSeparator)(Object.entries(pruneSecurables(securables, securityRoleObject.permissions)).map(function (pair, index) { return (react_1.default.createElement(ModuleSecurablesBlock, { module: pair[0], moduleSecurables: pair[1], entities: entities, key: index })); }), react_1.default.createElement(blockComp_1.MdDivider, { inset: true }))));
	    };
	    SecurableDrawer = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SecurableDrawer);
	    return SecurableDrawer;
	}(react_1.default.Component));
	exports.SecurableDrawer = SecurableDrawer;
	var ModuleSecurablesBlock = (0, mobx_react_1.observer)(function (_a) {
	    var moduleSecurables = _a.moduleSecurables, module = _a.module, entities = _a.entities;
	    var moduleLov = (0, formUtils_1.getLovItem)(entities.get('MODULE').lovItems, module);
	    return (react_1.default.createElement("div", { className: "secu-module" },
	        react_1.default.createElement("div", { className: "secu-module-header" },
	            react_1.default.createElement("span", { className: (0, formUtils_1.lovParam)(moduleLov, 'icon') }),
	            react_1.default.createElement("div", { className: "text" }, (0, formUtils_1.lovLabel)(moduleLov))),
	        react_1.default.createElement("div", { className: "secu-module-body" }, (0, arrayUtils_1.addSeparator)(Object.entries(moduleSecurables)
	            .map(function (pair, index) { return react_1.default.createElement(TypeSecurablesBlock, { module: module, entities: entities, type: pair[0], typeSecurables: pair[1], key: index }); }), react_1.default.createElement(blockComp_1.MdDivider, null)))));
	});
	var TypeSecurablesBlock = (0, mobx_react_1.observer)(function (_a) {
	    var typeSecurables = _a.typeSecurables, type = _a.type, entities = _a.entities, module = _a.module;
	    var typeLov = (0, formUtils_1.getLovItem)(entities.get('SECURABLETYPE').lovItems, type);
	    return (react_1.default.createElement("div", { className: "secu-type" },
	        react_1.default.createElement("div", { className: "secu-type-header" }, (0, formUtils_1.lovLabel)(typeLov)),
	        react_1.default.createElement("div", { className: "secu-type-body" }, Object.entries(typeSecurables)
	            .map(function (pair, index) { return react_1.default.createElement(DraggableSecurableBlock, { module: module, entities: entities, securable: pair[0], key: index }); }))));
	});
	var _secu_securable_styles = { margin: 3 };
	var _label_style = { fontSize: 13 };
	var SecurableBlock = /** @class */ (function (_super) {
	    tslib_1.__extends(SecurableBlock, _super);
	    function SecurableBlock() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SecurableBlock.prototype.render = function () {
	        // Your component receives its own props as usual
	        var _a = this.props, entities = _a.entities, securable = _a.securable, isDragging = _a.isDragging, connectDragSource = _a.connectDragSource;
	        var opacity = isDragging ? 0.4 : 1;
	        var bodyEl = (react_1.default.createElement("div", { style: tslib_1.__assign(tslib_1.__assign({}, _secu_securable_styles), { opacity: opacity }) },
	            react_1.default.createElement(Chip_1.default, { style: { cursor: 'move' } }, (0, formUtils_1.lovLabel)((0, formUtils_1.getLovItem)(entities.get('SECURABLE').lovItems, securable)))));
	        return connectDragSource(bodyEl);
	    };
	    SecurableBlock = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SecurableBlock);
	    return SecurableBlock;
	}(react_1.default.Component));
	/**
	 * Specifies the drag source contract.
	 * Only `beginDrag` function is required.
	 */
	var securableSource = {
	    beginDrag: function (props) {
	        console.log('begin drag');
	        // Return the data describing the dragged item
	        var item = { module: props.module, type: props.type, securable: props.securable };
	        return item;
	    },
	    endDrag: function (props, monitor, component) {
	        if (!monitor.didDrop()) {
	            return;
	        }
	        // When dropped on a compatible target, do something
	        var item = monitor.getItem();
	        var dropResult = monitor.getDropResult();
	        console.log('endDrag: item = %O, dropResult = %O, props = %O, component = %O', item, dropResult, props, component);
	        //CardActions.moveCardToList(item.id, dropResult.listId);
	    }
	};
	var DraggableSecurableBlock = (0, react_dnd_1.DragSource)("SECURABLE", securableSource, function (connect, monitor) { return ({
	    // Call this function inside render()
	    // to let React DnD handle the drag events:
	    connectDragSource: connect.dragSource(),
	    // You can ask the monitor about the current drag state:
	    isDragging: monitor.isDragging()
	}); })(SecurableBlock);
	function pruneSecurables(securableDefinitionModuleMap, permissions) {
	    var mapa = {};
	    var securableStrings = permissions.map(function (pObj) { return (0, formUtils_1.lovValue)(pObj.securable); });
	    Object.values(securableDefinitionModuleMap).forEach(function (securableDefinitionSecurableMap) {
	        Object.values(securableDefinitionSecurableMap).forEach(function (securableDefinition) {
	            if (!securableStrings.includes((0, formUtils_1.lovValue)(securableDefinition.securable))) {
	                getOrCreateSecurable(mapa, (0, formUtils_1.lovValue)(securableDefinition.module), (0, formUtils_1.lovValue)(securableDefinition.type), (0, formUtils_1.lovValue)(securableDefinition.securable), function (sec) { return securableDefinition.availablePermissions; });
	            }
	        });
	    });
	    return mapa;
	}
	function getOrCreateSecurable(permissionMap, module, type, securable, fn) {
	    var mapOfModule = (0, jsonUtils_1.createIfAbsent)(permissionMap, module, function (x) { return ({}); });
	    var mapOfType = (0, jsonUtils_1.createIfAbsent)(mapOfModule, type, function (x) { return ({}); });
	    return (0, jsonUtils_1.createIfAbsent)(mapOfType, securable, fn);
	}


/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.disabledHoc = disabledHoc;
	exports.withDeleteDialogHoc = withDeleteDialogHoc;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	function disabledHoc(Component) {
	    var _a;
	    return _a = /** @class */ (function (_super) {
	            tslib_1.__extends(class_1, _super);
	            function class_1() {
	                var _this = _super !== null && _super.apply(this, arguments) || this;
	                _this.state = { enabled: true };
	                return _this;
	            }
	            class_1.prototype.componentWillMount = function () {
	                var _b = this.props, module = _b.module, securableType = _b.securableType, securable = _b.securable, permission = _b.permission, detailId = _b.detailId;
	                this.setState({
	                    enabled: securityService_1.default.hasRouterRight(this.context.router, module, securableType, securable, permission, detailId)
	                });
	            };
	            class_1.prototype.render = function () {
	                var _b = this.props, module = _b.module, securableType = _b.securableType, securable = _b.securable, permission = _b.permission, disabled = _b.disabled, other = tslib_1.__rest(_b, ["module", "securableType", "securable", "permission", "disabled"]);
	                return react_1.default.createElement(Component, tslib_1.__assign({}, other, { disabled: !this.state.enabled || disabled }));
	            };
	            return class_1;
	        }(react_1.default.Component)),
	        _a.contextTypes = {
	            router: prop_types_1.default.func.isRequired
	        },
	        _a;
	}
	function withDeleteDialogHoc(Component) {
	    return /** @class */ (function (_super) {
	        tslib_1.__extends(class_2, _super);
	        function class_2() {
	            var _this = _super !== null && _super.apply(this, arguments) || this;
	            _this.handleClick = function (e) {
	                var _a = _this.props, entityName = _a.entityName, pageAncestor = _a.pageAncestor, onClick = _a.onClick;
	                console.debug("onClick for withDeleteDialogHoc button on entity " + entityName);
	                if (securityService_1.default.currentUser.confirmDelete(entityName)) {
	                    pageAncestor.openDeleteDialog().then(function () {
	                        onClick();
	                    }).catch(function (e) { });
	                }
	                else {
	                    onClick();
	                }
	            };
	            return _this;
	        }
	        class_2.prototype.render = function () {
	            var _a = this.props, entityName = _a.entityName, pageAncestor = _a.pageAncestor, onClick = _a.onClick, other = tslib_1.__rest(_a, ["entityName", "pageAncestor", "onClick"]);
	            return react_1.default.createElement(Component, tslib_1.__assign({ onClick: this.handleClick }, other));
	        };
	        return class_2;
	    }(react_1.default.Component));
	}


/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SecurablesAssigned = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var formUtils_1 = __webpack_require__(14);
	var react_dnd_1 = __webpack_require__(508);
	var colors_1 = __webpack_require__(29);
	__webpack_require__(453);
	var mobx_1 = __webpack_require__(5);
	var metaConstant_1 = __webpack_require__(13);
	var securityDomain_1 = __webpack_require__(97);
	var mobx_react_1 = __webpack_require__(4);
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var jsonUtils_1 = __webpack_require__(193);
	var SecurableDetailDrawer_1 = __webpack_require__(2117);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var securableTarget = {
	    drop: function (props, monitor, component) {
	        console.log('dropped, props = %O, item = %O', props, monitor.getItem());
	        var securables = props.securables, securityRoleObject = props.securityRoleObject, entities = props.entities;
	        var _a = monitor.getItem(), module = _a.module, type = _a.type, securable = _a.securable;
	        var securableDefinition = securables[module][securable];
	        var newSp = new securityDomain_1.SecurablePermission({
	            securityRole: securityRoleObject.createLov(),
	            securable: { value: securable, label: (0, formUtils_1.lovLabel)(entities.get("SECURABLE").getLovItem(securable)) },
	            module: module,
	            type: type
	        }).modifyPermissions(securableDefinition.availablePermissions);
	        console.log('NEW SecurityPermission ', newSp);
	        securityRoleObject.permissions.push(newSp);
	        console.log('AFTER ', securityRoleObject);
	        securityRoleObject.$dirty = true;
	        return { target: 'SecurablesAssigned' };
	    }
	};
	var _wrapperStyle = { margin: 20 };
	var TH_STYLE = { position: "sticky", top: 82, zIndex: 100, backgroundColor: colors_1.white };
	var TD_STYLE = { paddingTop: 5, paddingBottom: 5 };
	var TD_STYLE_GREY = { paddingTop: 5, paddingBottom: 5, backgroundColor: colors_1.grey200 };
	var SecurablesAssigned = /** @class */ (function (_super) {
	    tslib_1.__extends(SecurablesAssigned, _super);
	    function SecurablesAssigned() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SecurablesAssigned.prototype.render = function () {
	        var _a = this.props, entities = _a.entities, securityRoleObject = _a.securityRoleObject, securables = _a.securables, canDrop = _a.canDrop, isOver = _a.isOver, connectDropTarget = _a.connectDropTarget;
	        var style = { minHeight: 400 };
	        var isActive = canDrop && isOver;
	        if (isActive) {
	            style.backgroundColor = colors_1.yellow300;
	        }
	        else if (canDrop) {
	            style.backgroundColor = colors_1.yellow100;
	        }
	        var permissionKeys = Object.keys(metaConstant_1.PERMISSION);
	        var permissionMap = securityRoleObject.permissions.reduce(function (acc, sp) {
	            (0, jsonUtils_1.createIfAbsent)(acc, sp.module, function (k) { return []; }).push(sp);
	            return acc;
	        }, {});
	        return connectDropTarget(react_1.default.createElement("div", { style: _wrapperStyle },
	            react_1.default.createElement("table", { className: "zz-simple-table", style: { position: "relative" } },
	                react_1.default.createElement("thead", null,
	                    react_1.default.createElement("tr", null,
	                        react_1.default.createElement("th", { style: TH_STYLE }),
	                        permissionKeys.map(function (p, i) { return (react_1.default.createElement("th", { key: i, style: TH_STYLE }, p)); }),
	                        react_1.default.createElement("th", { style: TH_STYLE }))),
	                Object.entries(permissionMap).map(function (_a) {
	                    var module = _a[0], sps = _a[1];
	                    var moduleLov = (0, formUtils_1.getLovItem)(entities.get('MODULE').lovItems, module);
	                    var securableDefinitionSecurableMap = securables[module];
	                    return (react_1.default.createElement("tbody", { key: module },
	                        react_1.default.createElement("tr", null,
	                            react_1.default.createElement("td", { colSpan: permissionKeys.length + 2, style: { paddingTop: 10, paddingBottom: 10 } },
	                                react_1.default.createElement("div", { className: "secu-module-header", style: { justifyContent: "center" } },
	                                    react_1.default.createElement("span", { className: (0, formUtils_1.lovParam)(moduleLov, 'icon') }),
	                                    react_1.default.createElement("div", { className: "text" }, (0, formUtils_1.lovLabel)(moduleLov))))),
	                        sps.map(function (sp, index) { return react_1.default.createElement(SecurableAssignedRow, { key: sp.securable.value, index: index, securablePermission: sp, securableDefinitionSecurableMap: securableDefinitionSecurableMap, securityRole: securityRoleObject }); })));
	                }))));
	    };
	    SecurablesAssigned = tslib_1.__decorate([
	        (0, react_dnd_1.DropTarget)("SECURABLE", securableTarget, function (connect, monitor) { return ({
	            connectDropTarget: connect.dropTarget(),
	            isOver: monitor.isOver(),
	            canDrop: monitor.canDrop()
	        }); }),
	        mobx_react_1.observer
	    ], SecurablesAssigned);
	    return SecurablesAssigned;
	}(react_1.default.Component));
	exports.SecurablesAssigned = SecurablesAssigned;
	var SecurableAssignedRow = /** @class */ (function (_super) {
	    tslib_1.__extends(SecurableAssignedRow, _super);
	    function SecurableAssignedRow() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            openDetailDrawer: false,
	        };
	        _this.handleDrawerRequestChange = function (evt) {
	            _this.setState({ openDetailDrawer: false });
	        };
	        return _this;
	    }
	    SecurableAssignedRow.prototype.render = function () {
	        var _a = this.props, securableDefinitionSecurableMap = _a.securableDefinitionSecurableMap, securablePermission = _a.securablePermission, index = _a.index, securityRole = _a.securityRole;
	        var securableDefinition = securableDefinitionSecurableMap[(0, formUtils_1.lovValue)(securablePermission.securable)];
	        var availablePermissions = securableDefinition.availablePermissions;
	        var securableConfig = metaConstant_1.SECURABLE[(0, formUtils_1.lovValue)(securablePermission.securable)];
	        return ((securableConfig && securableConfig.detailHeader) ? (react_1.default.createElement("tr", null,
	            react_1.default.createElement("td", { style: TD_STYLE },
	                react_1.default.createElement(FlatButton_1.default, { onClick: this.openDrawer.bind(this, securablePermission), label: (0, formUtils_1.lovLabel)(securablePermission.securable) }),
	                this.state.openDetailDrawer &&
	                    react_1.default.createElement(SecurableDetailDrawer_1.SecurableDetailDrawer, { entities: mdEntityService_1.default.entityMap, open: this.state.openDetailDrawer, securablePermission: securablePermission, securableDefinition: securableDefinition, securityRole: securityService_1.default.securityRoleObject, onRequestChange: this.handleDrawerRequestChange })),
	            react_1.default.createElement(SecurableAssignedCellWithDetail, { permission: metaConstant_1.PERMISSION.Read, securablePermission: securablePermission, securableDefinition: securableDefinition }),
	            react_1.default.createElement(SecurableAssignedCellWithDetail, { permission: metaConstant_1.PERMISSION.New, securablePermission: securablePermission, securableDefinition: securableDefinition }),
	            react_1.default.createElement(SecurableAssignedCellWithDetail, { permission: metaConstant_1.PERMISSION.Update, securablePermission: securablePermission, securableDefinition: securableDefinition }),
	            react_1.default.createElement(SecurableAssignedCellWithDetail, { permission: metaConstant_1.PERMISSION.Delete, securablePermission: securablePermission, securableDefinition: securableDefinition }),
	            react_1.default.createElement(SecurableAssignedCellWithDetail, { permission: metaConstant_1.PERMISSION.Execute, securablePermission: securablePermission, securableDefinition: securableDefinition }),
	            react_1.default.createElement(SecurableAssignedCellWithDetail, { permission: metaConstant_1.PERMISSION.Export, securablePermission: securablePermission, securableDefinition: securableDefinition }),
	            react_1.default.createElement(SecurableAssignedCellWithDetail, { permission: metaConstant_1.PERMISSION.Import, securablePermission: securablePermission, securableDefinition: securableDefinition }),
	            react_1.default.createElement(SecurableAssignedCell, { securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.PublicGrid, index: index, availablePermissions: availablePermissions, securityRole: securityRole }),
	            react_1.default.createElement(SecurableAssignedCell, { securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.TenantGrid, index: index, availablePermissions: availablePermissions, securityRole: securityRole }),
	            react_1.default.createElement(SecurableAssignedCell, { securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.TenantGroupGrid, index: index, availablePermissions: availablePermissions, securityRole: securityRole }),
	            react_1.default.createElement("td", { style: TD_STYLE },
	                react_1.default.createElement("a", { className: "font-button-link", onClick: this.onDeletePermission.bind(this, (0, formUtils_1.lovValue)(securablePermission.securable)) },
	                    react_1.default.createElement("span", { className: "fa fa-trash" }))))) : (react_1.default.createElement("tr", null,
	            react_1.default.createElement("td", { style: TD_STYLE }, (0, formUtils_1.lovLabel)(securablePermission.securable)),
	            react_1.default.createElement(SecurableAssignedCell, { securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.Read, index: index, availablePermissions: availablePermissions, securityRole: securityRole }),
	            react_1.default.createElement(SecurableAssignedCell, { securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.New, index: index, availablePermissions: availablePermissions, securityRole: securityRole }),
	            react_1.default.createElement(SecurableAssignedCell, { securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.Update, index: index, availablePermissions: availablePermissions, securityRole: securityRole }),
	            react_1.default.createElement(SecurableAssignedCell, { securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.Delete, index: index, availablePermissions: availablePermissions, securityRole: securityRole }),
	            react_1.default.createElement(SecurableAssignedCell, { securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.Execute, index: index, availablePermissions: availablePermissions, securityRole: securityRole }),
	            react_1.default.createElement(SecurableAssignedCell, { securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.Export, index: index, availablePermissions: availablePermissions, securityRole: securityRole }),
	            react_1.default.createElement(SecurableAssignedCell, { securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.Import, index: index, availablePermissions: availablePermissions, securityRole: securityRole }),
	            react_1.default.createElement(SecurableAssignedCell, { securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.PublicGrid, index: index, availablePermissions: availablePermissions, securityRole: securityRole }),
	            react_1.default.createElement(SecurableAssignedCell, { securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.TenantGrid, index: index, availablePermissions: availablePermissions, securityRole: securityRole }),
	            react_1.default.createElement(SecurableAssignedCell, { securablePermission: securablePermission, permission: metaConstant_1.PERMISSION.TenantGroupGrid, index: index, availablePermissions: availablePermissions, securityRole: securityRole }),
	            react_1.default.createElement("td", { style: TD_STYLE },
	                react_1.default.createElement("a", { className: "font-button-link", onClick: this.onDeletePermission.bind(this, (0, formUtils_1.lovValue)(securablePermission.securable)) },
	                    react_1.default.createElement("span", { className: "fa fa-trash" }))))));
	    };
	    SecurableAssignedRow.prototype.onDeletePermission = function (event) {
	        console.log('onDeletePermission: ');
	        var _a = this.props, securityRole = _a.securityRole, securablePermission = _a.securablePermission;
	        var index = securityRole.permissions.findIndex(function (sp) { return (0, formUtils_1.lovValue)(sp.securable) === (0, formUtils_1.lovValue)(securablePermission.securable); });
	        securityRole.permissions.splice(index, 1);
	        securityRole.$dirty = true;
	    };
	    SecurableAssignedRow.prototype.openDrawer = function (sp) {
	        console.log('openDrawer: ', sp);
	        this.setState({ openDetailDrawer: true });
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SecurableAssignedRow.prototype, "onDeletePermission", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SecurableAssignedRow.prototype, "openDrawer", null);
	    SecurableAssignedRow = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SecurableAssignedRow);
	    return SecurableAssignedRow;
	}(react_1.default.Component));
	var SecurableAssignedCell = /** @class */ (function (_super) {
	    tslib_1.__extends(SecurableAssignedCell, _super);
	    function SecurableAssignedCell() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onCheck = function (evt, checked) {
	            var _a = _this.props, securablePermission = _a.securablePermission, permission = _a.permission, securityRole = _a.securityRole;
	            console.log('onCheck checked: ' + checked);
	            securablePermission.setPermission(permission, checked);
	            securityRole.$dirty = true;
	        };
	        return _this;
	    }
	    SecurableAssignedCell.prototype.render = function () {
	        var _a = this.props, permission = _a.permission, index = _a.index, securablePermission = _a.securablePermission, availablePermissions = _a.availablePermissions;
	        var active = availablePermissions.includes(permission);
	        var tdStyle = active ? TD_STYLE : TD_STYLE_GREY;
	        return (react_1.default.createElement("td", { style: tdStyle }, active &&
	            react_1.default.createElement(fields_1.MdCheckbox, { name: permission + index, checked: securablePermission.isPermission(permission), onCheck: this.onCheck })));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SecurableAssignedCell.prototype, "onCheck", void 0);
	    SecurableAssignedCell = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SecurableAssignedCell);
	    return SecurableAssignedCell;
	}(react_1.default.Component));
	var SecurableAssignedCellWithDetail = (0, mobx_react_1.observer)(function (_a) {
	    var permission = _a.permission, securablePermission = _a.securablePermission, securableDefinition = _a.securableDefinition;
	    var active = securableDefinition.availablePermissions.includes(permission);
	    var total = securableDefinition.detailPermissions.length;
	    var checked = securablePermission.detailPermissions.values().filter(function (spd) { return spd.isPermission(permission); }).length;
	    var effectiveChecked = (securablePermission.isPermission(permission)) ? (total - checked) : checked;
	    var tdStyle = active ? TD_STYLE : TD_STYLE_GREY;
	    return (react_1.default.createElement("td", { style: tdStyle }, (active) && (effectiveChecked + "/" + total)));
	});


/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.InvoicePreferenceForm = void 0;
	var tslib_1 = __webpack_require__(3);
	var createForm_1 = __webpack_require__(18);
	var formUtils_1 = __webpack_require__(14);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_1 = __webpack_require__(5);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var closedForm_1 = __webpack_require__(82);
	var mdField_1 = tslib_1.__importStar(__webpack_require__(57));
	/* ************************************************************************************************
	 * ***********   Invoice  *************************************************************
	 * ********************************************************************************************** */
	var InvoicePreferenceFormCC = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    var invoicewarningEntity = entities.get("INVOICEWARNING");
	    return (react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields, singleColumn: true },
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.enabledInvoiceWarnings.textLabel }, dataObject.enabledInvoiceWarnings.map(function (eiw) { return react_1.default.createElement("div", { key: (0, formUtils_1.lovValue)(eiw) }, (0, formUtils_1.lovLabel)(invoicewarningEntity.getLovItem((0, formUtils_1.lovValue)(eiw)))); }))));
	};
	var InvoicePreferenceForm = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoicePreferenceForm, _super);
	    function InvoicePreferenceForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    InvoicePreferenceForm.prototype.componentDidMount = function () {
	        console.debug('InvoicePreferenceForm componentDidMount');
	        var _a = this.props, dataObject = _a.dataObject, form = _a.form;
	        mdEntityService_1.default.fetchEntities([{
	                entity: 'INVOICEWARNING',
	                lov: true
	            }]).then((0, mobx_1.action)("action-cb", function (entityMap) {
	            form.initForm(entityMap.get("JobInfo"), entityMap, dataObject, dataObject, null);
	            form.updateAllFieldsPropValue(dataObject);
	        }));
	    };
	    InvoicePreferenceForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, index = _a.index, entities = _a.entities, entity = _a.entity, formName = _a.formName, disabled = _a.disabled;
	        var fields = dataObject.getFormFields(formName);
	        var enabledInvoiceWarnings = fields.enabledInvoiceWarnings;
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, enabledInvoiceWarnings.props, { multi: true, fullWidth: true, clearable: false, floatingLabelStyle: { top: 15 } }))))));
	    };
	    InvoicePreferenceForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'InvoicePreferenceForm',
	            fields: [{
	                    name: 'enabledInvoiceWarnings',
	                    mdField: new mdField_1.default({ label: 'Enabled Invoice issue warnings', valueSource: 'INVOICEWARNING', valueSourceType: mdField_1.VALUESOURCETYPE.LOCAL }),
	                    omitNullOption: true
	                }],
	            onCommit: function (dataObject) {
	                dataObject.arguments = [(0, formUtils_1.lovValue)(dataObject.importType), dataObject.directory, dataObject.filenamePattern];
	            }
	        }, InvoicePreferenceFormCC),
	        mobx_react_1.observer
	    ], InvoicePreferenceForm);
	    return InvoicePreferenceForm;
	}(react_1.default.Component));
	exports.InvoicePreferenceForm = InvoicePreferenceForm;


/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.LoginObjectForm = exports.LoginObject = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_dom_1 = tslib_1.__importDefault(__webpack_require__(31));
	var RaisedButton_1 = tslib_1.__importDefault(__webpack_require__(152));
	var react_bootstrap_1 = __webpack_require__(72);
	var DomainAncestor_1 = __webpack_require__(33);
	var createForm_1 = __webpack_require__(18);
	var mobx_react_1 = __webpack_require__(4);
	var mdField_1 = tslib_1.__importStar(__webpack_require__(57));
	var fields_1 = __webpack_require__(20);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var mobx_1 = __webpack_require__(5);
	var validate_1 = __webpack_require__(24);
	var securityDomain_1 = __webpack_require__(97);
	var form_1 = __webpack_require__(52);
	var LoginObject = /** @class */ (function (_super) {
	    tslib_1.__extends(LoginObject, _super);
	    function LoginObject(json) {
	        return _super.call(this, json) || this;
	    }
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], LoginObject.prototype, "username", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], LoginObject.prototype, "password", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], LoginObject.prototype, "loginText", void 0);
	    return LoginObject;
	}(DomainAncestor_1.DomainAncestor));
	exports.LoginObject = LoginObject;
	var LoginObjectForm = /** @class */ (function (_super) {
	    tslib_1.__extends(LoginObjectForm, _super);
	    function LoginObjectForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onSubmit = function (e) {
	            console.log('form submited');
	            e.preventDefault();
	            var _a = _this.props, dataObject = _a.dataObject, formName = _a.formName;
	            var form = dataObject.getForm(formName);
	            if (!form.validateForm(dataObject, [])) {
	                return;
	            }
	            _this.props.onSubmit(dataObject)
	                .catch(function (err) {
	                console.log('login error: %0', err);
	                dataObject.$errors = [{ message: "Bad username or password" }];
	                dataObject.username = null;
	                dataObject.password = null;
	                dataObject.tenantId = null;
	                dataObject.getForm(formName).updateFieldsPropValue(dataObject, "username", "password");
	                var usernameFieldNode = react_dom_1.default.findDOMNode(_this.usernameFieldRef);
	                if (usernameFieldNode) {
	                    usernameFieldNode.getElementsByTagName("input")[0].focus();
	                }
	            });
	        };
	        _this.onChangeUsername = function (e) {
	            var _a = _this.props, dataObject = _a.dataObject, formName = _a.formName;
	            var form = dataObject.getForm(formName);
	            form.getField("username").props.onChange(e);
	            securityService_1.default.getLastTenantId(dataObject.username)
	                .then(function (tenantId) {
	                return (tenantId) ? securityService_1.default.getTenantParamFromServer(tenantId, securityDomain_1.PARAMKEY.GDPR_LOGIN_TEXT) : Promise.resolve(null);
	            })
	                .then((0, mobx_1.action)("tenantText-action", function (text) {
	                dataObject.loginText = text;
	            }));
	        };
	        _this.usernameFieldRefHandler = function (comp) { return _this.usernameFieldRef = comp; };
	        return _this;
	    }
	    LoginObjectForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, index = _a.index, entities = _a.entities, formName = _a.formName;
	        var _b = dataObject.getFormFields(formName), username = _b.username, password = _b.password;
	        return (react_1.default.createElement("form", { onSubmit: this.onSubmit, autoComplete: "off" },
	            react_1.default.createElement("div", { className: "container-fluid", style: { marginTop: 40 } },
	                (dataObject.$errors && dataObject.$errors.length) ? (react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-offset-1 col-xs-10" },
	                        react_1.default.createElement(react_bootstrap_1.Alert, { bsStyle: 'danger' }, dataObject.$errors.map(function (e) { return e.message; }))))) : null,
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-offset-1 col-xs-10" },
	                        react_1.default.createElement("h4", null, "Please login"))),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-offset-1 col-xs-10", style: { display: 'flex' } },
	                        react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, username.props, { ref: this.usernameFieldRefHandler, onChange: this.onChangeUsername, autoFocus: true, autoComplete: "new-password", tabIndex: "1", style: { maxWidth: 200 }, autocomplete: "off" })),
	                        react_1.default.createElement(validate_1.Validate, { field: username, value: username.props.value }))),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-offset-1 col-xs-10" },
	                        react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, password.props, { type: "password", autoComplete: "new-password", tabIndex: "3", style: { maxWidth: 200 }, autocomplete: "off" })),
	                        react_1.default.createElement(validate_1.Validate, { field: password, value: password.props.value }))),
	                react_1.default.createElement("div", { className: "row", style: { marginTop: 20 } },
	                    react_1.default.createElement("div", { className: "col-xs-offset-1 col-xs-10" },
	                        react_1.default.createElement(RaisedButton_1.default, { type: "submit", label: "Login", disabled: !dataObject.password || !dataObject.username, secondary: true, tabIndex: 4 }))),
	                react_1.default.createElement("div", { className: "row", style: { marginTop: 40 } },
	                    react_1.default.createElement("div", { className: "col-xs-offset-1 col-xs-10" },
	                        react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: dataObject.loginText } }))))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], LoginObjectForm.prototype, "onSubmit", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], LoginObjectForm.prototype, "onChangeUsername", void 0);
	    LoginObjectForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'LoginObjecForm',
	            fields: [{
	                    name: 'username',
	                    usePlaceholder: true, size: form_1.FIELDDEFSIZE.big,
	                    mdField: new mdField_1.default({ label: 'Username', dataType: mdField_1.DATATYPE.STRING })
	                }, {
	                    name: 'password',
	                    usePlaceholder: true, size: form_1.FIELDDEFSIZE.big,
	                    mdField: new mdField_1.default({ label: 'Password', dataType: mdField_1.DATATYPE.STRING })
	                }]
	        }, function () { return react_1.default.createElement("noscript", null); }),
	        mobx_react_1.observer
	    ], LoginObjectForm);
	    return LoginObjectForm;
	}(react_1.default.Component));
	exports.LoginObjectForm = LoginObjectForm;


/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var loginForm_1 = __webpack_require__(2122);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_1 = __webpack_require__(5);
	var favicon_1 = __webpack_require__(562);
	var LoginPage = /** @class */ (function (_super) {
	    tslib_1.__extends(LoginPage, _super);
	    function LoginPage() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onSubmit = function (e) {
	            return securityService_1.default.login(securityService_1.default.loginObject.username, securityService_1.default.loginObject.password)
	                .then((0, mobx_1.action)("login-action", function (userContextDto) {
	                var redirectAfterLogin = commonService_1.default.redirectAfterLogin;
	                _this.context.router.transitionTo((redirectAfterLogin && redirectAfterLogin !== '/' && redirectAfterLogin !== '/login') ? redirectAfterLogin : 'home');
	            }));
	        };
	        return _this;
	    }
	    LoginPage_1 = LoginPage;
	    LoginPage.prototype.componentWillMount = function () {
	        securityService_1.default.loginObject = new loginForm_1.LoginObject({});
	    };
	    LoginPage.prototype.componentWillUnmount = function () {
	        securityService_1.default.loginObject = null;
	    };
	    LoginPage.prototype.componentDidMount = function () {
	        (0, favicon_1.handleFavicon)(LoginPage_1);
	    };
	    LoginPage.prototype.render = function () {
	        return (react_1.default.createElement("main", { className: "main-content" },
	            react_1.default.createElement(loginForm_1.LoginObjectForm, { dataObject: securityService_1.default.loginObject, rootObject: securityService_1.default.loginObject, entities: mdEntityService_1.default.entityMap, onSubmit: this.onSubmit })));
	    };
	    var LoginPage_1;
	    LoginPage.title = 'Zauzoo Login';
	    LoginPage.icon = 'lock';
	    LoginPage.rootPage = true;
	    LoginPage.contextTypes = {
	        router: prop_types_1.default.func.isRequired
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], LoginPage.prototype, "onSubmit", void 0);
	    LoginPage = LoginPage_1 = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], LoginPage);
	    return LoginPage;
	}(react_1.default.Component));
	exports.default = LoginPage;


/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_router_1 = __webpack_require__(65);
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var blockComp_1 = __webpack_require__(30);
	var formUtils_1 = __webpack_require__(14);
	var errorComp_1 = __webpack_require__(34);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var rules_1 = __webpack_require__(56);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var RaisedButton_1 = tslib_1.__importDefault(__webpack_require__(152));
	var react_dnd_html5_backend_1 = tslib_1.__importDefault(__webpack_require__(1729));
	var react_dnd_1 = __webpack_require__(508);
	var securableAssigned_1 = __webpack_require__(2120);
	var metaConstant_1 = __webpack_require__(13);
	var securityDomain_1 = __webpack_require__(97);
	var mobx_1 = __webpack_require__(5);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var buttons_1 = __webpack_require__(27);
	var mobx_react_1 = __webpack_require__(4);
	__webpack_require__(453);
	var storage_1 = __webpack_require__(173);
	var form_1 = __webpack_require__(52);
	var locales_1 = __webpack_require__(15);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var Chip_1 = tslib_1.__importDefault(__webpack_require__(211));
	var colors_1 = __webpack_require__(29);
	var SecurableDrawer_1 = __webpack_require__(2118);
	var KNOWN_STATICS = ["fetchData", "handler", "willTransitionTo", "willTransitionFrom", "module", "title", "icon", "protectedPage", "rootPage"];
	function recoverLostStatics(componentWrappedByDnd) {
	    for (var _i = 0, KNOWN_STATICS_1 = KNOWN_STATICS; _i < KNOWN_STATICS_1.length; _i++) {
	        var key = KNOWN_STATICS_1[_i];
	        componentWrappedByDnd[key] = componentWrappedByDnd.DecoratedComponent[key];
	    }
	}
	var SecurityRoleDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(SecurityRoleDetail, _super);
	    function SecurityRoleDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            openDrawer: false,
	            loadingDrawer: false
	        };
	        _this.customValidate = function (securityRoleObject) {
	            var errors = [];
	            if (securityRoleObject.permissions.length === 0 && (!securityRoleObject.restrictions || !securityRoleObject.restrictions.length)) {
	                errors.push({ message: "At least one securable or restriction must be selected" });
	            }
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave');
	            uiService_1.default.showToolbarActionFlag();
	            securityService_1.default.securityRoleObject.permissions = securityService_1.default.securityRoleObject.permissions.filter(function (sp) { return sp.getPermissionList().length > 0 || sp.detailPermissions.size > 0; });
	            var result = (0, formUtils_1.preSave)(securityService_1.default.securityRoleObject, _this.customValidate);
	            if (!result) {
	                return;
	            }
	            var promise = securityService_1.default.saveSecurityRole(securityService_1.default.securityRoleObject);
	            promise.then((0, mobx_1.action)("saveSecurityRole-actopm", function (secRoleJson) {
	                var wasNew = securityService_1.default.securityRoleObject.cleanAfterSave(secRoleJson);
	                if (wasNew) {
	                    _this.context.router.replaceWith('securityRoleDetail', { id: securityService_1.default.securityRoleObject.roleId });
	                }
	                (0, storage_1.removeItemFromLocalStorage)("MdEntity", locales_1.loc.lang, "SecurityRole");
	                uiService_1.default.hideToolbarActionFlag();
	            }));
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            securityService_1.default.deleteSecurityRole(securityService_1.default.securityRoleObject.roleId)
	                .then(function (response) {
	                (0, storage_1.removeItemFromLocalStorage)("MdEntity", locales_1.loc.lang, "SecurityRole");
	                _this.goBackOrHome();
	            }, function (error) {
	                securityService_1.default.securityRoleObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            _this.context.router.transitionTo("securityRoleDetail", { id: 'new' });
	        };
	        _this.onCopy = function (evt) {
	            console.log('onCopy');
	            _this.context.router.transitionTo("securityRoleDetail", { id: 'copy' }, { copyId: securityService_1.default.securityRoleObject.roleId });
	        };
	        _this.openDrawer = function () {
	            _this.setState({ openDrawer: !_this.state.openDrawer });
	        };
	        _this.handleDrawerRequestChange = function (evt) {
	            _this.setState({ openDrawer: false });
	        };
	        _this.truish = function () { return true; };
	        _this.handleRestriction = function (valueArray) {
	            console.log('handleRestriction %O', valueArray);
	            securityService_1.default.securityRoleObject.restrictions = valueArray;
	            securityService_1.default.securityRoleObject.$dirty = true;
	        };
	        return _this;
	    }
	    SecurityRoleDetail_1 = SecurityRoleDetail;
	    SecurityRoleDetail.fetchData = function (routerParams, query) {
	        console.log("SecurityRoleDetail#fetchData()", this, SecurityRoleDetail_1);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['SecurityRole'], [{
	                entity: 'MODULE',
	                lov: true
	            }, { entity: 'SECURABLETYPE', lov: true }, { entity: 'SECURABLE', lov: true }, { entity: 'RESTRICTION', lov: true }]);
	        var securablesPromise = securityService_1.default.getSecurables();
	        var securityRolePromise;
	        if (routerParams.id === 'new') {
	            securityRolePromise = Promise.resolve(new securityDomain_1.SecurityRole(Object.assign({
	                permissionMap: {},
	                users: [],
	                restrictions: [],
	                $new: true
	            }, query)));
	        }
	        else if (routerParams.id === 'copy') {
	            securityRolePromise = securityService_1.default.readSecurityRole(query.copyId)
	                .then(function (securityRoleObject) {
	                securityRoleObject.cleanOnCopy();
	                securityRoleObject.users = [];
	                return securityRoleObject;
	            });
	        }
	        else {
	            securityRolePromise = securityService_1.default.readSecurityRole(routerParams.id);
	        }
	        return Promise.all([metadataPromise, securityRolePromise, securablesPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], securityRoleObject = _a[1], securables = _a[2];
	            securityService_1.default.securityRoleObject = securityRoleObject.initAfterRead(routerParams.id === 'new');
	            securityService_1.default.securables = securables;
	        });
	    };
	    SecurityRoleDetail.prototype.componentWillUnmount = function () {
	        securityService_1.default.securityRoleObject = null;
	    };
	    SecurityRoleDetail.prototype.findRootObject = function () {
	        return securityService_1.default.securityRoleObject;
	    };
	    SecurityRoleDetail.prototype.render = function () {
	        var query = this.props.query;
	        var propsForCreateForm = {
	            dataObject: securityService_1.default.securityRoleObject,
	            rootObject: securityService_1.default.securityRoleObject,
	            entity: mdEntityService_1.default.getEntity('SecurityRole'),
	            entities: mdEntityService_1.default.entityMap
	        };
	        console.debug('%c securityRoleDetail render', 'background-color: yellow');
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column', height: '100%' } },
	            this._createToolMenu(securityService_1.default.securityRoleObject, query.gridLocation),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: securityService_1.default.securityRoleObject.$errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	            this.state.openDrawer &&
	                react_1.default.createElement(SecurableDrawer_1.SecurableDrawer, { entities: mdEntityService_1.default.entityMap, open: this.state.openDrawer, securables: securityService_1.default.securables, securityRoleObject: securityService_1.default.securityRoleObject, onRequestChange: this.handleDrawerRequestChange }),
	            react_1.default.createElement("div", { style: { marginTop: 20, display: "flex" } },
	                react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true, className: "block-comp-right-border", style: { flexGrow: 1, minWidth: "30%" }, header: "Security Role" },
	                    react_1.default.createElement("form", null,
	                        react_1.default.createElement(SecurityRoleForm, tslib_1.__assign({}, propsForCreateForm)))),
	                react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true, header: "Restrictions", style: { flexGrow: 1 } },
	                    react_1.default.createElement(activeItem_1.default, { openContent: react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "col-xs-12" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { onChange: this.handleRestriction, value: securityService_1.default.securityRoleObject.restrictions.slice(), options: mdEntityService_1.default.getEntity('RESTRICTION').lovItems, hintText: "Choose values", multi: true, fullWidth: true, searchable: false, clearable: false })))), closedContent: react_1.default.createElement("div", { style: { fontSize: 14, lineHeight: '14px', minHeight: 20, display: 'flex', flexWrap: 'wrap', margin: -4 } }, securityService_1.default.securityRoleObject.restrictions.map(function (rst, index) { return react_1.default.createElement(Chip_1.default, { key: index, style: { margin: 3, backgroundColor: colors_1.red300 } }, (0, formUtils_1.lovLabel)(rst)); })), validate: this.truish, dataObject: securityService_1.default.securityRoleObject, entities: mdEntityService_1.default.entityMap, formName: "securityRoleRestrictionsForm", rootObject: securityService_1.default.securityRoleObject }))),
	            react_1.default.createElement("div", { style: { marginLeft: 20, marginTop: 10 } },
	                react_1.default.createElement(RaisedButton_1.default, { primary: true, onClick: this.openDrawer, label: "Add Securable" })),
	            react_1.default.createElement(securableAssigned_1.SecurablesAssigned, { entities: mdEntityService_1.default.entityMap, securityRoleObject: securityService_1.default.securityRoleObject, securables: securityService_1.default.securables }),
	            react_1.default.createElement(blockComp_1.MdDivider, { inset: true, marginTop: 20 }),
	            react_1.default.createElement(blockComp_1.BlockComp, { header: react_1.default.createElement("span", null, "Users") },
	                react_1.default.createElement("table", { className: "zz-simple-table" },
	                    react_1.default.createElement("thead", null,
	                        react_1.default.createElement("tr", null,
	                            react_1.default.createElement("th", null, "Username"),
	                            react_1.default.createElement("th", null, "Full name"))),
	                    react_1.default.createElement("tbody", null, securityService_1.default.securityRoleObject.users.map(function (userLov, index) { return (react_1.default.createElement("tr", { key: index },
	                        react_1.default.createElement("td", null, userLov.value),
	                        react_1.default.createElement("td", null, userLov.label))); }))))));
	    };
	    SecurityRoleDetail.prototype._createToolMenu = function (securityRoleObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: react_router_1.History.length <= 1, historize: true, entityName: "SecurityRole", entityId: securityRoleObject.roleId },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !securityRoleObject.$dirty, label: "Save", permission: securityRoleObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, disabled: securityRoleObject.$new, label: "New", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onCopy, disabled: securityRoleObject.$new, label: "Copy", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "SecurityRole", pageAncestor: this, onClick: this.onDelete, disabled: securityRoleObject.$new, label: "Delete", permission: metaConstant_1.PERMISSION.Delete })));
	    };
	    var SecurityRoleDetail_1;
	    SecurityRoleDetail.module = metaConstant_1.MODULE.core;
	    SecurityRoleDetail.title = 'Security Role';
	    SecurityRoleDetail.icon = 'user-secret';
	    SecurityRoleDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SecurityRoleDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SecurityRoleDetail.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SecurityRoleDetail.prototype, "handleRestriction", void 0);
	    SecurityRoleDetail = SecurityRoleDetail_1 = tslib_1.__decorate([
	        recoverLostStatics,
	        (0, react_dnd_1.DragDropContext)(react_dnd_html5_backend_1.default),
	        mobx_react_1.observer
	    ], SecurityRoleDetail);
	    return SecurityRoleDetail;
	}(pageAncestor_1.default));
	exports.default = SecurityRoleDetail;
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
	        react_1.default.createElement("h5", { style: { marginTop: 0, fontSize: '18px', fontWeight: 'bold' } },
	            " ",
	            dataObject.roleName),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.roleId.textLabel, value: dataObject.roleId })),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.comment.textLabel, value: dataObject.comment }))));
	};
	var SecurityRoleForm = /** @class */ (function (_super) {
	    tslib_1.__extends(SecurityRoleForm, _super);
	    function SecurityRoleForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SecurityRoleForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, formName = _a.formName, entity = _a.entity;
	        var fields = dataObject.getFormFields(formName);
	        var roleId = fields.roleId, roleName = fields.roleName, comment = fields.comment;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, roleId.props, { disabled: !dataObject.$new })),
	                    react_1.default.createElement(validate_1.Validate, { field: roleId, value: roleId.props.value },
	                        react_1.default.createElement(rules_1.PrimaryKeyString, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, roleName.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: roleName, value: roleName.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props, { multiLine: true, rows: 2 }))))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true },
	            react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate }, this.props))));
	    };
	    SecurityRoleForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'SecurityRoleForm',
	            fields: [{
	                    name: 'roleId',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'roleName',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'comment',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	                }]
	        }, ClosedContent),
	        mobx_react_1.observer
	    ], SecurityRoleForm);
	    return SecurityRoleForm;
	}(react_1.default.Component));
	var templateObject_1, templateObject_2;


/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var routes_1 = __webpack_require__(75);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'securityRoleList';
	var SecurityRoleList = /** @class */ (function (_super) {
	    tslib_1.__extends(SecurityRoleList, _super);
	    function SecurityRoleList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SecurityRoleList.fetchData = function (routerParams) {
	        console.log("SecurityRoleList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    SecurityRoleList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "securityRoleDetail", params: { id: 'new' }, label: "New Role", permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.securityRoleDetail })));
	    };
	    SecurityRoleList.module = metaConstant_1.MODULE.core;
	    SecurityRoleList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Security Roles"], ["Security Roles"])));
	    SecurityRoleList.icon = 'user';
	    SecurityRoleList.rootPage = true;
	    SecurityRoleList.protectedPage = true;
	    SecurityRoleList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SecurityRoleList);
	    return SecurityRoleList;
	}(pageAncestor_1.default));
	exports.default = SecurityRoleList;
	var templateObject_1;


/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var RaisedButton_1 = tslib_1.__importDefault(__webpack_require__(152));
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var validate_1 = __webpack_require__(24);
	var rules_1 = __webpack_require__(56);
	var formUtils_1 = __webpack_require__(14);
	var errorComp_1 = __webpack_require__(34);
	var metaConstant_1 = __webpack_require__(13);
	var mobx_1 = __webpack_require__(5);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var mobx_react_1 = __webpack_require__(4);
	var form_1 = __webpack_require__(52);
	var SetPassword = /** @class */ (function (_super) {
	    tslib_1.__extends(SetPassword, _super);
	    function SetPassword() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onSubmit = function (evt) {
	            evt.preventDefault();
	            console.log('onSubmit ');
	            uiService_1.default.showToolbarActionFlag();
	            var result = (0, formUtils_1.preSave)(securityService_1.default.passwordObject, null, true);
	            if (!result) {
	                return;
	            }
	            securityService_1.default.resetPassword(securityService_1.default.passwordObject, _this.context.router.getCurrentParams().mode)
	                .then(function (response) {
	                uiService_1.default.hideToolbarActionFlag();
	                _this.goBackOrHome();
	            }, function (error) {
	                Object.assign(securityService_1.default.passwordObject, { oldPassword: undefined, password1: undefined, password2: undefined, $errors: error.response.data.messages });
	                securityService_1.default.passwordObject.getForm("SetPasswordForm").updateAllFieldsPropValue(securityService_1.default.passwordObject);
	            });
	        };
	        return _this;
	    }
	    SetPassword.fetchData = function (routerParams, query) {
	        console.log("SetPassword#fetchData()");
	        var metadataPromise = mdEntityService_1.default.fetchEntities(['User']);
	        var username = (routerParams.mode === 'ADMIN') ? routerParams.id : securityService_1.default.currentUser.username;
	        var userPromise = securityService_1.default.readUser(username);
	        return Promise.all([metadataPromise, userPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], userObject = _a[1];
	            securityService_1.default.passwordObject = userObject;
	        });
	    };
	    SetPassword.prototype.componentWillUnmount = function () {
	        securityService_1.default.passwordObject = null;
	    };
	    SetPassword.prototype.render = function () {
	        console.debug('%c setPassword render', 'background-color: yellow');
	        return (react_1.default.createElement("main", { className: "main-content container" },
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: securityService_1.default.passwordObject.$errors }),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-offset-1 col-xs-10" },
	                    react_1.default.createElement("h4", null, "Change Password"))),
	            react_1.default.createElement(SetPasswordForm, { dataObject: securityService_1.default.passwordObject, rootObject: securityService_1.default.passwordObject, entity: mdEntityService_1.default.getEntity('User'), entities: mdEntityService_1.default.entityMap, routeParams: this.context.router.getCurrentParams(), onCancel: this.goBackOrHome, onSubmit: this.onSubmit })));
	    };
	    SetPassword.module = metaConstant_1.MODULE.core;
	    SetPassword.title = 'set password';
	    SetPassword.icon = 'unlock-alt';
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SetPassword.prototype, "onSubmit", void 0);
	    SetPassword = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SetPassword);
	    return SetPassword;
	}(pageAncestor_1.default));
	exports.default = SetPassword;
	var SetPasswordForm = /** @class */ (function (_super) {
	    tslib_1.__extends(SetPasswordForm, _super);
	    function SetPasswordForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SetPasswordForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, routeParams = _a.routeParams, onSubmit = _a.onSubmit, onCancel = _a.onCancel, formName = _a.formName;
	        var fields = dataObject.getFormFields(formName);
	        var oldPassword = fields.oldPassword, password1 = fields.password1, password2 = fields.password2;
	        return (react_1.default.createElement("form", { onSubmit: onSubmit },
	            (routeParams.mode === 'USER') ? (react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-offset-1 col-xs-10" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({ type: "password" }, oldPassword.props, { style: { maxWidth: 300 } })),
	                    react_1.default.createElement(validate_1.Validate, { field: oldPassword, value: oldPassword.props.value })))) : null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-offset-1 col-xs-10", style: { display: 'flex', flexWrap: 'nowrap' } },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({ type: "password" }, password1.props, { style: { maxWidth: 300 } })),
	                    react_1.default.createElement(validate_1.Validate, { field: password1, value: password1.props.value },
	                        react_1.default.createElement(rules_1.HasLength, { min: 8 })),
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({ type: "password" }, password2.props, { style: { maxWidth: 300, marginLeft: 20 } })),
	                    react_1.default.createElement(validate_1.Validate, { field: password2, value: password2.props.value, needTouch: [['AreSame', 'value1'], ['AreSame', 'value2']] },
	                        react_1.default.createElement(rules_1.HasLength, { min: 8 }),
	                        react_1.default.createElement(rules_1.AreSame, { value1: password1.props.value, value2: password2.props.value })))),
	            react_1.default.createElement("div", { className: "row", style: { marginTop: 20 } },
	                react_1.default.createElement("div", { className: "col-xs-offset-1 col-xs-10" },
	                    react_1.default.createElement(RaisedButton_1.default, { type: "submit", label: "OK", secondary: true }),
	                    react_1.default.createElement(RaisedButton_1.default, { type: "button", onClick: onCancel, label: "Cancel", style: { marginLeft: 20 } })))));
	    };
	    SetPasswordForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'SetPasswordForm',
	            fields: [{
	                    name: 'oldPassword', size: form_1.FIELDDEFSIZE.big,
	                    validators: ['IsRequired']
	                }, {
	                    name: 'password1', size: form_1.FIELDDEFSIZE.big,
	                    validators: ['IsRequired']
	                }, {
	                    name: 'password2', size: form_1.FIELDDEFSIZE.big,
	                    validators: ['IsRequired']
	                }
	            ]
	        }, function () { return react_1.default.createElement("noscript", null); }),
	        mobx_react_1.observer
	    ], SetPasswordForm);
	    return SetPasswordForm;
	}(react_1.default.Component));


/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_router_1 = __webpack_require__(65);
	var Chip_1 = tslib_1.__importDefault(__webpack_require__(211));
	var colors_1 = __webpack_require__(29);
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var blockComp_1 = __webpack_require__(30);
	var formUtils_1 = __webpack_require__(14);
	var errorComp_1 = __webpack_require__(34);
	var userForm_1 = tslib_1.__importDefault(__webpack_require__(2128));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridComp_1 = tslib_1.__importDefault(__webpack_require__(44));
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var formUtils_2 = __webpack_require__(14);
	var createForm_1 = __webpack_require__(18);
	var metaConstant_1 = __webpack_require__(13);
	var buttons_1 = __webpack_require__(27);
	var securityDomain_1 = __webpack_require__(97);
	var gridUtils_1 = __webpack_require__(83);
	var mobx_1 = __webpack_require__(5);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var partyDomain_1 = __webpack_require__(48);
	var gridComp_2 = __webpack_require__(44);
	var mobx_react_1 = __webpack_require__(4);
	var partyService_1 = tslib_1.__importDefault(__webpack_require__(175));
	var more_vert_1 = tslib_1.__importDefault(__webpack_require__(291));
	var icons_1 = __webpack_require__(63);
	var userTokenList_1 = tslib_1.__importDefault(__webpack_require__(943));
	var locales_1 = __webpack_require__(15);
	var utils_1 = __webpack_require__(37);
	var react_router_2 = __webpack_require__(65);
	var securableResolved_1 = __webpack_require__(942);
	var tenantGridLocation = 'tenantListDefault';
	var UserDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(UserDetail, _super);
	    function UserDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.customValidate = function (userObject) {
	            var errors = [];
	            if (userObject.tenants.length === 0) {
	                errors.push({ message: "At least one tenant must be selected" });
	            }
	            if (!userObject.party) {
	                errors.push({ message: "Party must be selected" });
	            }
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave');
	            uiService_1.default.showToolbarActionFlag();
	            var result = (0, formUtils_1.preSave)(securityService_1.default.userObject, _this.customValidate);
	            if (!result) {
	                return;
	            }
	            var promise = (securityService_1.default.userObject.$new) ? securityService_1.default.userCreate(securityService_1.default.userObject) : securityService_1.default.userUpdate(securityService_1.default.userObject);
	            promise.then((0, mobx_1.action)("userSave-action", function (userJson) {
	                var wasNew = securityService_1.default.userObject.cleanAfterSave(userJson);
	                if (wasNew) {
	                    _this.context.router.replaceWith('userDetail', { id: securityService_1.default.userObject.username });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            })).catch(function (error) {
	                console.log("Error %O", error);
	                securityService_1.default.userObject.$errors = error.getMessages();
	            });
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            securityService_1.default.deleteUser(securityService_1.default.userObject.username)
	                .then(function (response) {
	                _this.goBackOrHome();
	            }, function (error) {
	                securityService_1.default.userObject.$errors = error.getMessages();
	            });
	        };
	        _this.onSetPassword = function (evt) {
	            console.log('onSetPassword');
	            _this.context.router.transitionTo('setPassword', { mode: 'ADMIN', id: securityService_1.default.userObject.username });
	        };
	        _this.onImpersonate = function (evt) {
	            console.log('onImpersonate');
	            return securityService_1.default.impersonate(securityService_1.default.userObject.username)
	                .then(function (userContext) {
	                _this.context.router.transitionTo('home');
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            _this.context.router.transitionTo("userDetail", { id: 'new' });
	        };
	        _this.onCopy = function (evt) {
	            console.log('onCopy');
	            _this.context.router.transitionTo("userDetail", { id: 'copy' }, { copyId: securityService_1.default.userObject.username });
	        };
	        _this.onPartyChange = function (partyObject) {
	            console.log('onPartyChange %O', partyObject);
	            securityService_1.default.userObject.party = partyObject;
	            securityService_1.default.userObject.$dirty = true;
	        };
	        _this.getSelectTenant = function (tenantId) {
	            //console.log('getSelectTenant %s .. %s', tenantId, index);
	            return securityService_1.default.userObject.tenants.includes(tenantId);
	        };
	        _this.setSelectTenant = function (tenantId, item, checked) {
	            console.log('setSelectTenant %s .. %s...%s', tenantId, item, checked);
	            var ti = securityService_1.default.userObject.tenants.indexOf(tenantId);
	            if (checked) {
	                if (ti === -1)
	                    securityService_1.default.userObject.tenants.push(tenantId);
	            }
	            else {
	                if (ti >= 0)
	                    securityService_1.default.userObject.tenants.splice(ti, 1);
	            }
	            securityService_1.default.userObject.$dirty = true;
	        };
	        _this.truish = function () { return true; };
	        _this.handleSecurityRole = function (valueArray) {
	            console.log('handleSecurityRole %O', valueArray);
	            securityService_1.default.userObject.securityRoles = valueArray;
	            securityService_1.default.userObject.$dirty = true;
	        };
	        _this.handleProfitCenter = function (valueArray) {
	            console.log('handleProfitCenter %O', valueArray);
	            securityService_1.default.userObject.profitCenters = valueArray;
	            securityService_1.default.userObject.$dirty = true;
	        };
	        _this.newParty = function () { return new partyDomain_1.Party({
	            partyCategory: partyDomain_1.PARTYCATEGORY.PE,
	            roles: [partyService_1.default.newRole(partyDomain_1.PARTYROLE.USER_ROLE)],
	            active: true
	        }).initAfterRead(true); };
	        return _this;
	    }
	    UserDetail.fetchData = function (routerParams, query) {
	        console.log("UserDetail#fetchData()");
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['User', 'UserToken'], ['Tenant', 'Party', 'PartyContact', 'PartyRole', 'Address', 'PartyNote',
	            { entity: 'PartyRoleType', lov: true }, { entity: 'SecurityRole', lov: true }, { entity: 'ProfitCenter', lov: true }, { entity: 'MODULE', lov: true }, { entity: 'SECURABLETYPE', lov: true }, { entity: 'SECURABLE', lov: true }]);
	        var userPromise;
	        if (routerParams.id === 'new') {
	            userPromise = Promise.resolve(new securityDomain_1.User(Object.assign({
	                gridConfigs: [],
	                tenants: [],
	                securityRoles: [],
	                restrictions: [],
	                defaultGridConfig: {},
	                permissionMap: {},
	                profitCenters: [],
	                tokens: [],
	                enabled: true,
	                expirationMinutes: 480,
	                rememberMe: false,
	                passwordPolicy: 2,
	                $new: true
	            }, query)));
	        }
	        else if (routerParams.id === 'copy') {
	            userPromise = securityService_1.default.readUser(query.copyId)
	                .then(function (userObject) {
	                userObject._copiedFromUsername = userObject.username;
	                userObject.cleanOnCopy();
	                userObject.gridConfigs = [];
	                userObject.defaultGridConfig = {};
	                userObject.permissionMap = {};
	                userObject.tokens = [];
	                return userObject;
	            });
	        }
	        else {
	            userPromise = securityService_1.default.readUser(routerParams.id);
	        }
	        var gridPromise = gridService_1.default.fetchGrids(tenantGridLocation);
	        var securablesPromise = securityService_1.default.getSecurables();
	        return Promise.all([metadataPromise, userPromise, gridPromise, securablesPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], userObject = _a[1], gridLocationMap = _a[2], securables = _a[3];
	            userObject.$movingBlocks = new gridUtils_1.MovingBlocks(null, false, null, new grid_1.default(gridLocationMap.get(tenantGridLocation)));
	            securityService_1.default.userObject = userObject.initAfterRead(routerParams.id === 'new');
	            securityService_1.default.securables = securables;
	            return securityService_1.default.userObject;
	        });
	    };
	    /**
	     * tohle je tady kvuli prechodu na jiny detail party (z relationship vazeb), kdy react-router neudela reload
	     * @param prevProps
	     */
	    UserDetail.prototype.componentDidUpdate = function (prevProps) {
	        console.log("componentDidUpdate prev.id = %s, id = %s", prevProps.params.id, this.props.params.id);
	        if (prevProps.params.id !== this.props.params.id) {
	            securityService_1.default.userObject.$movingBlocks.searchExposedGrids(securityService_1.default.userObject);
	        }
	    };
	    UserDetail.prototype.componentDidMount = function () {
	        console.log("ComponentDidMount");
	        securityService_1.default.userObject.$movingBlocks.searchExposedGrids(securityService_1.default.userObject);
	    };
	    UserDetail.prototype.componentWillUnmount = function () {
	        securityService_1.default.userObject = null;
	    };
	    UserDetail.prototype.findRootObject = function () {
	        return securityService_1.default.userObject;
	    };
	    UserDetail.prototype.render = function () {
	        var query = this.props.query;
	        var propsForCreateForm = {
	            dataObject: securityService_1.default.userObject,
	            rootObject: securityService_1.default.userObject,
	            entity: mdEntityService_1.default.getEntity('User'),
	            entities: mdEntityService_1.default.entityMap
	        };
	        var movingBlocks = securityService_1.default.userObject.$movingBlocks;
	        var partyEntity = mdEntityService_1.default.getEntity('Party');
	        console.debug('%c userDetail render', 'background-color: yellow');
	        return (react_1.default.createElement("main", { className: "main-content container" },
	            this._createToolMenu(securityService_1.default.userObject, query.gridLocation),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: securityService_1.default.userObject.$errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	            react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true, style: { marginTop: 20 }, header: "User" },
	                react_1.default.createElement("form", null,
	                    react_1.default.createElement(userForm_1.default, tslib_1.__assign({}, propsForCreateForm)))),
	            react_1.default.createElement(blockComp_1.MdDivider, { inset: true, marginTop: 20, marginBottom: 20 }),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6", style: { display: 'flex', flexDirection: 'column' } },
	                    react_1.default.createElement(blockComp_1.BlockComp, { header: "Security Roles", className: "block-comp-right-border" },
	                        react_1.default.createElement(activeItem_1.default, { openContent: react_1.default.createElement("div", { className: "row" },
	                                react_1.default.createElement("div", { className: "col-xs-12" },
	                                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { onChange: this.handleSecurityRole, value: securityService_1.default.userObject.securityRoles.slice(), options: mdEntityService_1.default.getEntity('SecurityRole').lovItems, hintText: "Choose values", multi: true, fullWidth: true, searchable: true, clearable: false })))), closedContent: react_1.default.createElement("div", { style: { fontSize: 14, lineHeight: '14px', minHeight: 20, display: 'flex', flexWrap: 'wrap', margin: -4 } }, securityService_1.default.userObject.securityRoles.map(function (role, index) { return (react_1.default.createElement(react_router_2.Link, { to: "securityRoleDetail", params: { id: (0, formUtils_1.lovValue)(role) }, query: (0, utils_1.addTenantToQuery)() },
	                                react_1.default.createElement(Chip_1.default, { key: index, style: { margin: 3, backgroundColor: colors_1.blueGrey50 } }, (0, formUtils_2.lovLabel)(role)))); })), validate: this.truish, dataObject: securityService_1.default.userObject, entities: mdEntityService_1.default.entityMap, formName: "userSecurityRolesForm", rootObject: securityService_1.default.userObject })),
	                    react_1.default.createElement(blockComp_1.BlockComp, { header: "Profit Centers", className: "block-comp-right-border", style: { flexGrow: 1 } },
	                        react_1.default.createElement(activeItem_1.default, { openContent: react_1.default.createElement("div", { className: "row" },
	                                react_1.default.createElement("div", { className: "col-xs-12" },
	                                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { onChange: this.handleProfitCenter, value: securityService_1.default.userObject.profitCenters.slice(), options: mdEntityService_1.default.getEntity('ProfitCenter').lovItems, hintText: "Choose values", multi: true, fullWidth: true, searchable: false, clearable: false })))), closedContent: react_1.default.createElement("div", { style: { fontSize: 14, lineHeight: '14px', minHeight: 20, display: 'flex', flexWrap: 'wrap', margin: -4 } }, securityService_1.default.userObject.profitCenters.map(function (pc, index) { return react_1.default.createElement(Chip_1.default, { key: index, style: { margin: 3, backgroundColor: colors_1.blueGrey50 } }, (0, formUtils_2.lovLabel)(pc)); })), validate: this.truish, dataObject: securityService_1.default.userObject, entities: mdEntityService_1.default.entityMap, formName: "userProfitCentersForm", rootObject: securityService_1.default.userObject }))),
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                    react_1.default.createElement(blockComp_1.BlockComp, { header: "Available Tenants" },
	                        react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(tenantGridLocation), multiSelect: false, hideToolbar: true, gridClassName: "detail-grid", bodyStyle: { paddingBottom: 7 }, uiLocation: gridComp_2.UILOCATION.main, functionMap: {
	                                getSelectTenant: this.getSelectTenant.bind(this),
	                                setSelectTenant: this.setSelectTenant.bind(this)
	                            }, entities: mdEntityService_1.default.entityMap })))),
	            react_1.default.createElement(blockComp_1.MdDivider, { inset: true, marginTop: 20, marginBottom: 20 }),
	            react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true, header: react_1.default.createElement("span", null, "Effective Rights"), style: { display: 'flex', flexDirection: 'column' } },
	                react_1.default.createElement(securableResolved_1.SecurablesResolved, { entities: mdEntityService_1.default.entityMap, permissionMap: securityService_1.default.userObject.permissionMap, securables: securityService_1.default.securables })),
	            react_1.default.createElement(blockComp_1.MdDivider, { inset: true, marginTop: 20, marginBottom: 20 }),
	            react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true, header: react_1.default.createElement("span", null, "Effective Restrictions") },
	                react_1.default.createElement("div", { style: { marginLeft: 20, marginTop: 15, display: 'flex', flexWrap: 'wrap' } }, securityService_1.default.userObject.restrictions.map(function (rst, index) { return react_1.default.createElement(Chip_1.default, { key: index, style: { margin: 3, backgroundColor: colors_1.red300 } }, (0, formUtils_2.lovLabel)(rst)); }))),
	            react_1.default.createElement(blockComp_1.MdDivider, { inset: true, marginTop: 20, marginBottom: 20 }),
	            react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true, style: { display: 'flex', flexDirection: 'column' } },
	                react_1.default.createElement(userTokenList_1.default, { userObject: securityService_1.default.userObject, entities: mdEntityService_1.default.entityMap }))));
	    };
	    UserDetail.prototype._createToolMenu = function (userObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: react_router_1.History.length <= 1, historize: true, entityName: "User", entityId: userObject.username },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !userObject.$dirty, label: "Save", permission: userObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, disabled: userObject.$new, label: "New", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onCopy, disabled: userObject.$new, label: "Copy", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "User", pageAncestor: this, onClick: this.onDelete, disabled: userObject.$new, label: "Delete", permission: metaConstant_1.PERMISSION.Delete }),
	            react_1.default.createElement(icons_1.ZzIconButtonMenu, { buttonIcon: react_1.default.createElement(more_vert_1.default, null), securableType: metaConstant_1.SECURABLE_TYPE.DETAILACTION },
	                react_1.default.createElement(icons_1.ZzMenuItem, { primaryText: "Set password", key: 1, disabled: userObject.$new, onClick: this.onSetPassword, securable: metaConstant_1.SECURABLE.setPassword }),
	                react_1.default.createElement(icons_1.ZzMenuItem, { primaryText: "Impersonate", key: 2, disabled: userObject.$new, onClick: this.onImpersonate, securable: metaConstant_1.SECURABLE.impersonate }))));
	    };
	    UserDetail.module = metaConstant_1.MODULE.core;
	    UserDetail.title = 'User';
	    UserDetail.icon = 'user';
	    UserDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], UserDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], UserDetail.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], UserDetail.prototype, "onSetPassword", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], UserDetail.prototype, "onImpersonate", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], UserDetail.prototype, "onPartyChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], UserDetail.prototype, "setSelectTenant", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], UserDetail.prototype, "handleSecurityRole", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], UserDetail.prototype, "handleProfitCenter", void 0);
	    UserDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], UserDetail);
	    return UserDetail;
	}(pageAncestor_1.default));
	exports.default = UserDetail;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var fields_1 = __webpack_require__(20);
	var rules_1 = __webpack_require__(56);
	var form_1 = __webpack_require__(52);
	var formUtils_1 = __webpack_require__(14);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var rules_2 = __webpack_require__(56);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var mobx_react_1 = __webpack_require__(4);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var commonDataService_1 = __webpack_require__(41);
	var newPartyDialog_1 = tslib_1.__importDefault(__webpack_require__(948));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var partyDomain_1 = __webpack_require__(48);
	var mobx_1 = __webpack_require__(5);
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var closedForm_1 = __webpack_require__(82);
	function UserExist(_a) {
	    var value = _a.value;
	    if (!value)
	        return (0, rules_2.valid)();
	    return securityService_1.default.userExist(value)
	        .then(function (exists) { return (exists) ? (0, rules_2.invalid)("User ".concat(value, " already exists")) : (0, rules_2.valid)(); });
	}
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
	        react_1.default.createElement("h5", { style: { marginTop: 0, fontSize: '18px', fontWeight: 'bold', display: 'flex' } },
	            react_1.default.createElement("span", { style: { marginRight: 10 } }, dataObject.username),
	            (dataObject.party) ? (react_1.default.createElement(closedForm_1.ClosedFormField, { label: 'Owner', value: dataObject.party.label, linkProps: { to: 'partyDetail', params: { id: dataObject.party.value } } })) : null),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { value: (dataObject.enabled) ? 'Enabled' : 'Disabled' }),
	            react_1.default.createElement(formUtils_1.FieldText, { value: (dataObject.locked) ? 'Locked' : '' }),
	            react_1.default.createElement(formUtils_1.FieldText, { value: (dataObject.expired) ? 'Expired' : '' }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: "Session expiration", value: moment_1.default.duration(dataObject.expirationMinutes, 'minutes').humanize(true) + ((dataObject.rememberMe) ? ' (persists when browser closed)' : '(closed on browser close)') }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.accountExpiration.textLabel, value: dataObject.accountExpiration ? (0, moment_1.default)(dataObject.accountExpiration).format("DD.MM.YYYY") : undefined }))));
	};
	var UserForm = /** @class */ (function (_super) {
	    tslib_1.__extends(UserForm, _super);
	    function UserForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.newPartyDialogRefHandler = function (comp) { return _this.newPartyDialogRef = comp; };
	        _this.newParty = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, formName = _a.formName;
	            var roleType = entities.get('PartyRoleType').getLovItem(partyDomain_1.PARTYROLE.USER_ROLE);
	            var newPartyObject = new partyDomain_1.Party({
	                active: true,
	                $new: true,
	                partyCategory: partyDomain_1.PARTYCATEGORY.PE,
	                roles: [new partyDomain_1.PartyRole({ roleType: roleType }).initDefaultValues()]
	            }).initAfterRead(true);
	            console.log("newParty roleType = %O", roleType);
	            new Promise(function (resolve, reject) {
	                _this.newPartyDialogRef.open(resolve, reject, newPartyObject);
	            }).then((0, mobx_1.action)("close-new-party-diaglog", function (newPartyLov) {
	                dataObject.party = newPartyLov;
	                dataObject.getForm(formName).updateFieldsPropValue(dataObject, "party");
	                rootObject.$dirty = true;
	                console.debug("update PartyRel %O", dataObject);
	            })).catch(function (e) { });
	        };
	        return _this;
	    }
	    UserForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity, formName = _a.formName;
	        var fields = dataObject.getFormFields(formName);
	        var username = fields.username, enabled = fields.enabled, locked = fields.locked, expired = fields.expired, password1 = fields.password1, password2 = fields.password2, rememberMe = fields.rememberMe, expirationMinutes = fields.expirationMinutes, accountExpiration = fields.accountExpiration, party = fields.party;
	        console.log("ON RENDER: User form fields", fields);
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "xs col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, username.props, { disabled: !dataObject.$new })),
	                    react_1.default.createElement(validate_1.Validate, { field: username, value: username.props.value },
	                        (dataObject.$new) ? react_1.default.createElement(UserExist, null) : null,
	                        react_1.default.createElement(rules_2.ForbiddenNames, { names: ["system"] }))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-8" },
	                    react_1.default.createElement(newPartyDialog_1.default, { ref: this.newPartyDialogRefHandler }),
	                    react_1.default.createElement("h5", { style: { marginLeft: 25, alignSelf: 'center' } }, "Party to link"),
	                    react_1.default.createElement("div", { style: { marginLeft: 15, flexGrow: 1 } },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, party.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { partyCategory: [partyDomain_1.PARTYCATEGORY.PE, partyDomain_1.PARTYCATEGORY.EN] }), advancedSearchGL: "partySearch", hintText: "type to start search..." })),
	                        react_1.default.createElement(validate_1.Validate, { field: party, value: party.props.value })),
	                    react_1.default.createElement(FlatButton_1.default, { labelStyle: { fontSize: 20 }, style: { alignSelf: 'center' }, label: " or create a new one", secondary: true, onClick: this.newParty }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, enabled.props))),
	                react_1.default.createElement("div", { className: "col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, locked.props))),
	                react_1.default.createElement("div", { className: "col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, expired.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "xs col-xs-6 col-sm-4" },
	                    react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, expirationMinutes.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: expirationMinutes, value: expirationMinutes.props.value },
	                        react_1.default.createElement(rules_1.NumberFormat, { precision: 10, scale: 0 }),
	                        react_1.default.createElement(rules_1.Min, { min: 1 }),
	                        react_1.default.createElement(rules_1.Max, { max: 1000000 }))),
	                react_1.default.createElement("div", { className: "col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, rememberMe.props))),
	                react_1.default.createElement("div", { className: "col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({ min: (0, moment_1.default)().add(1, "days").toDate() }, accountExpiration.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: accountExpiration, value: accountExpiration.props.value },
	                        react_1.default.createElement(rules_1.MinDateOrPrevious, { min: (0, moment_1.default)().add(1, "days"), previous: (0, moment_1.default)(accountExpiration.props.value) })))),
	            (dataObject.$new) ?
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-6 col-sm-4" },
	                        react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({ type: "password" }, password1.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: password1, value: password1.props.value },
	                            react_1.default.createElement(rules_2.HasLength, { min: 8 }))),
	                    react_1.default.createElement("div", { className: "col-xs-6 col-sm-4" },
	                        react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({ type: "password" }, password2.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: password2, value: password2.props.value, needTouch: [['AreSame', 'value1'], ['AreSame', 'value2']] },
	                            react_1.default.createElement(rules_2.HasLength, { min: 8 }),
	                            react_1.default.createElement(rules_2.AreSame, { value1: password1.props.value, value2: password2.props.value }))))
	                : null));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }) }, this.props, { validate: this.props.validate })));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], UserForm.prototype, "newParty", void 0);
	    UserForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'UserForm',
	            fields: [{
	                    name: 'username',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'party',
	                    validators: ['IsRequired'],
	                    usePlaceholder: true
	                }, {
	                    name: 'enabled',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.checkbox
	                }, {
	                    name: 'locked',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.checkbox
	                }, {
	                    name: 'expired',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.checkbox
	                }, {
	                    name: 'password1',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'password2',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'accountExpiration'
	                }, {
	                    name: 'rememberMe',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.checkbox
	                }, {
	                    name: 'expirationMinutes',
	                    validators: ['IsRequired', 'IsNumber']
	                }
	            ]
	        }, ClosedContent),
	        mobx_react_1.observer
	    ], UserForm);
	    return UserForm;
	}(react_1.default.Component));
	exports.default = UserForm;


/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var routes_1 = __webpack_require__(75);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'userList';
	var UserList = /** @class */ (function (_super) {
	    tslib_1.__extends(UserList, _super);
	    function UserList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    UserList.fetchData = function (routerParams) {
	        console.log("UserList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gl) { return gridService_1.default.getOrCreateGrid(gridLocation); });
	    };
	    UserList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "userDetail", params: { id: 'new' }, label: "New User", permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.userDetail })));
	    };
	    UserList.module = metaConstant_1.MODULE.core;
	    UserList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Users"], ["Users"])));
	    UserList.icon = 'user';
	    UserList.rootPage = true;
	    UserList.protectedPage = true;
	    UserList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], UserList);
	    return UserList;
	}(pageAncestor_1.default));
	exports.default = UserList;
	var templateObject_1;


/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_router_1 = __webpack_require__(65);
	var FontIcon_1 = tslib_1.__importDefault(__webpack_require__(164));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var blockComp_1 = __webpack_require__(30);
	var metaConstant_1 = __webpack_require__(13);
	var securityDomain_1 = __webpack_require__(97);
	var mobx_react_1 = __webpack_require__(4);
	var colors_1 = __webpack_require__(29);
	var userTokenList_1 = tslib_1.__importDefault(__webpack_require__(943));
	var Chip_1 = tslib_1.__importDefault(__webpack_require__(211));
	var formUtils_1 = __webpack_require__(14);
	var securableResolved_1 = __webpack_require__(942);
	var Tabs_1 = tslib_1.__importDefault(__webpack_require__(107));
	var Tab_1 = tslib_1.__importDefault(__webpack_require__(102));
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var mobx_1 = __webpack_require__(5);
	var last_1 = tslib_1.__importDefault(__webpack_require__(138));
	var SvgDone = __webpack_require__(298);
	var SvgEdit = __webpack_require__(379);
	var SvgClear = __webpack_require__(248);
	var fields_1 = __webpack_require__(20);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var errorComp_1 = __webpack_require__(34);
	var UserProfileForms = tslib_1.__importStar(__webpack_require__(2121));
	var UserProfile = /** @class */ (function (_super) {
	    tslib_1.__extends(UserProfile, _super);
	    function UserProfile() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onSetPassword = function (evt) {
	            console.log('onSetPassword');
	            _this.context.router.transitionTo('setPassword', { mode: 'USER' });
	        };
	        _this.onBack = function (evt) {
	            console.log('onBack %O', _this.context.router);
	            _this.context.router.goBack();
	        };
	        _this.handleChange = function (value) {
	            _this.activeTab = value;
	            _this[_this.activeTab]();
	            var routeName = (0, last_1.default)(_this.context.router.getCurrentRoutes()).name;
	            var params = _this.context.router.getCurrentParams();
	            params.tab = value;
	            console.log("handleChange %s , %o", value, params);
	            _this.context.router.replaceWith(routeName, params, undefined);
	        };
	        return _this;
	    }
	    UserProfile.fetchData = function (routerParams, query) {
	        console.log("UserProfile#fetchData()");
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['User', 'UserToken'], [{ entity: 'Tenant', lov: true }, 'Party', 'ExtendedPreferences',
	            { entity: 'SecurityRole', lov: true }, { entity: 'MODULE', lov: true }, { entity: 'SECURABLETYPE', lov: true }, { entity: 'SECURABLE', lov: true }, { entity: 'INVOICEWARNING', lov: true }]);
	        var userProfilePromise = securityService_1.default.readUserProfile(securityService_1.default.currentUser.username);
	        var securablesPromise = securityService_1.default.getSecurables();
	        return Promise.all([metadataPromise, userProfilePromise, securablesPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], userProfileObject = _a[1], securables = _a[2];
	            securityService_1.default.userProfileObject = userProfileObject;
	            securityService_1.default.securables = securables;
	        });
	    };
	    UserProfile.prototype.componentWillMount = function () {
	        var params = this.context.router.getCurrentParams();
	        this.activeTab = (params.tab) ? params.tab : 'info';
	    };
	    UserProfile.prototype.componentDidMount = function () {
	        this[this.activeTab]();
	    };
	    UserProfile.prototype.componentWillUnmount = function () {
	        securityService_1.default.userProfileObject = null;
	    };
	    UserProfile.prototype.info = function () {
	    };
	    UserProfile.prototype.rights = function () {
	    };
	    UserProfile.prototype.apiTokens = function () {
	    };
	    UserProfile.prototype.entityPreferences = function () {
	    };
	    UserProfile.prototype.render = function () {
	        console.debug('%c userProfile render', 'background-color: yellow');
	        return (react_1.default.createElement("main", { className: "main-content" },
	            this._createToolMenu(securityService_1.default.userProfileObject),
	            react_1.default.createElement(Tabs_1.default, { value: this.activeTab, onChange: this.handleChange },
	                react_1.default.createElement(Tab_1.default, { label: "Info", value: "info" },
	                    react_1.default.createElement(MainTab, null)),
	                react_1.default.createElement(Tab_1.default, { label: "My Rights", value: "rights" },
	                    react_1.default.createElement("div", null,
	                        react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true, style: { display: 'flex', flexDirection: 'column' } },
	                            react_1.default.createElement(securableResolved_1.SecurablesResolved, { entities: mdEntityService_1.default.entityMap, permissionMap: securityService_1.default.userProfileObject.user.permissionMap, securables: securityService_1.default.securables })),
	                        react_1.default.createElement(blockComp_1.MdDivider, { inset: true, marginTop: 20, marginBottom: 20 }),
	                        react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true, header: react_1.default.createElement("span", null, "My Restrictions") },
	                            react_1.default.createElement("div", { style: { marginLeft: 20, marginTop: 15, display: 'flex', flexWrap: 'wrap' } }, securityService_1.default.userProfileObject.user.restrictions.map(function (rst, index) { return react_1.default.createElement(Chip_1.default, { key: index, style: { margin: 3, backgroundColor: colors_1.red300 } }, (0, formUtils_1.lovLabel)(rst)); }))))),
	                react_1.default.createElement(Tab_1.default, { label: "API Tokens", value: "apiTokens" },
	                    react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true, style: { display: 'flex', flexDirection: 'column' } },
	                        react_1.default.createElement(userTokenList_1.default, { userObject: securityService_1.default.userProfileObject.user, entities: mdEntityService_1.default.entityMap }))),
	                react_1.default.createElement(Tab_1.default, { label: "Entity Preferences", value: "entityPreferences" },
	                    react_1.default.createElement(EntityPreferences, null)))));
	    };
	    UserProfile.prototype._createToolMenu = function (userProfileObject) {
	        return (react_1.default.createElement(toolmenu_1.default, { backAction: this.onBack, backDisabled: react_router_1.History.length <= 1 },
	            react_1.default.createElement(FlatButton_1.default, { onClick: this.onSetPassword, label: "Set password" })));
	    };
	    UserProfile.module = metaConstant_1.MODULE.core;
	    UserProfile.title = 'My Profile';
	    UserProfile.icon = 'user';
	    UserProfile.contextTypes = {
	        router: prop_types_1.default.func.isRequired
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], UserProfile.prototype, "activeTab", void 0);
	    UserProfile = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], UserProfile);
	    return UserProfile;
	}(pageAncestor_1.default));
	exports.default = UserProfile;
	var MainTab = /** @class */ (function (_super) {
	    tslib_1.__extends(MainTab, _super);
	    function MainTab() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDetail = function (evt) {
	            console.log('onDetail');
	            _this.context.router.transitionTo('partyDetail', { id: securityService_1.default.userProfileObject.user.party.value });
	        };
	        return _this;
	    }
	    MainTab.prototype.render = function () {
	        var tenantLovs = mdEntityService_1.default.getEntity('Tenant').lovItems.filter(function (li) { return securityService_1.default.userProfileObject.user.tenants.includes(li.value); });
	        return (react_1.default.createElement(blockComp_1.BlockComp, { style: { marginTop: 10 } },
	            react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'baseline' } },
	                react_1.default.createElement("div", { style: { fontSize: '18px', fontWeight: 'bold', marginRight: 8 } }, securityService_1.default.userProfileObject.user.username),
	                react_1.default.createElement(FlatButton_1.default, { onClick: this.onDetail, primary: true, label: "Edit", labelPosition: "after", labelStyle: { paddingLeft: 8 }, style: { paddingLeft: 5 } },
	                    react_1.default.createElement(FontIcon_1.default, { className: "fa fa-pencil", style: { fontSize: 14, color: colors_1.indigo500 } })),
	                react_1.default.createElement("div", null, "Available Tenants:"),
	                react_1.default.createElement("ul", null, tenantLovs.map(function (li) { return (react_1.default.createElement("li", { style: { listStyleType: 'none' }, key: li.value }, li.label)); })))));
	    };
	    MainTab.contextTypes = {
	        router: prop_types_1.default.func.isRequired
	    };
	    MainTab = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], MainTab);
	    return MainTab;
	}(react_1.default.Component));
	var GREEN_STYLE = { color: colors_1.green500, fontWeight: "bold" };
	var EntityPreferences = /** @class */ (function (_super) {
	    tslib_1.__extends(EntityPreferences, _super);
	    function EntityPreferences() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onCheck = function (ep) {
	            console.log('onCheck ', ep);
	            ep.confirmDelete = !ep.confirmDelete;
	            securityService_1.default.userProfileObject.$dirty = true;
	        };
	        _this.onEdit = function (evt) {
	            console.log('onEdit');
	            _this.editing = true;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave');
	            securityService_1.default.saveUserProfile(securityService_1.default.userProfileObject.user.username, new securityDomain_1.UserProfileDto({ entityPreferences: securityService_1.default.userProfileObject.entityPreferences }))
	                .then((0, mobx_1.action)("userProfileSave-action", function (userProfileJson) {
	                securityService_1.default.userProfileObject.cleanAfterSave(userProfileJson);
	                uiService_1.default.hideToolbarActionFlag();
	                _this.editing = false;
	                return securityService_1.default.readCurrentUserContext();
	            })).then(function (userContextDto) {
	                if (userContextDto) {
	                    securityService_1.default.setUserContextDto(userContextDto);
	                }
	            }).catch(function (error) {
	                console.log("Error %O", error);
	                securityService_1.default.userProfileObject.$errors = error.getMessages();
	            });
	        };
	        _this.onCancel = function (evt) {
	            console.log('onCancel');
	            securityService_1.default.readUserProfile(securityService_1.default.currentUser.username)
	                .then(function (userProfileDto) {
	                securityService_1.default.userProfileObject = userProfileDto;
	                _this.editing = false;
	            });
	        };
	        return _this;
	    }
	    EntityPreferences.prototype.render = function () {
	        var _this = this;
	        var userProfileObject = securityService_1.default.userProfileObject;
	        var tenantLovs = mdEntityService_1.default.getEntity('Tenant').lovItems.filter(function (li) { return userProfileObject.user.tenants.includes(li.value); });
	        return (react_1.default.createElement(blockComp_1.BlockComp, { style: { marginTop: 10, display: "flex" } },
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: userProfileObject.$errors }),
	            react_1.default.createElement("table", { className: "zz-simple-table" },
	                react_1.default.createElement("thead", null,
	                    react_1.default.createElement("tr", null,
	                        react_1.default.createElement("th", null, "Entity"),
	                        react_1.default.createElement("th", null, "Confirm delete"))),
	                userProfileObject.entityPreferences.map(function (ep) {
	                    var expEntity = mdEntityService_1.default.getEntity('ExtendedPreferences');
	                    var formName = ep.entityName + 'PreferenceForm';
	                    var DetailComponentForm = UserProfileForms[formName];
	                    var detailComponent = null;
	                    if (DetailComponentForm) {
	                        var ClosedContent = mdEntityService_1.default.getClosedContent(formName);
	                        var form = ep.extendedPreferences.getForm(formName);
	                        var fields = form.setupFields(ep.extendedPreferences, userProfileObject, expEntity, mdEntityService_1.default.entityMap, null);
	                        detailComponent = (_this.editing) ? react_1.default.createElement(DetailComponentForm, { dataObject: ep.extendedPreferences, rootObject: userProfileObject, entities: mdEntityService_1.default.entityMap, entity: expEntity })
	                            : react_1.default.createElement(ClosedContent, { dataObject: ep.extendedPreferences, entities: mdEntityService_1.default.entityMap, entity: expEntity, fields: fields });
	                    }
	                    return (react_1.default.createElement("tbody", { key: ep.entityName },
	                        react_1.default.createElement("tr", null,
	                            react_1.default.createElement("td", null, ep.entityName),
	                            react_1.default.createElement("td", null,
	                                !_this.editing && ep.confirmDelete && react_1.default.createElement(SvgDone, { style: GREEN_STYLE, size: 16 }),
	                                _this.editing && react_1.default.createElement(fields_1.MdCheckbox, { name: "confirmDelete_" + ep.entityName, checked: ep.confirmDelete, onCheck: _this.onCheck.bind(_this, ep) }))),
	                        !!detailComponent &&
	                            react_1.default.createElement("tr", null,
	                                react_1.default.createElement("td", { colSpan: 2, style: { borderTop: "0px" } }, detailComponent))));
	                })),
	            react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column", columnGap: 10, margin: "20px 10px", width: "100%", alignItems: "center" } },
	                !this.editing &&
	                    react_1.default.createElement(FlatButton_1.default, { onClick: this.onEdit, primary: true, label: "Edit", labelPosition: "after", labelStyle: { paddingLeft: 8 }, style: { paddingLeft: 5, minWidth: 100 } },
	                        react_1.default.createElement(SvgEdit, { style: { color: colors_1.indigo500 }, size: 16 })),
	                this.editing &&
	                    react_1.default.createElement(FlatButton_1.default, { onClick: this.onSave, primary: true, label: "Save", labelPosition: "after", labelStyle: { paddingLeft: 8 }, style: { paddingLeft: 5, minWidth: 100 } },
	                        react_1.default.createElement(SvgDone, { style: { color: colors_1.green500 }, size: 16 })),
	                this.editing &&
	                    react_1.default.createElement(FlatButton_1.default, { onClick: this.onCancel, primary: true, label: "Cancel", labelPosition: "after", labelStyle: { paddingLeft: 8 }, style: { paddingLeft: 5, minWidth: 100 } },
	                        react_1.default.createElement(SvgClear, { style: { color: colors_1.red500 }, size: 16 })))));
	    };
	    EntityPreferences.contextTypes = {
	        router: prop_types_1.default.func.isRequired
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntityPreferences.prototype, "editing", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EntityPreferences.prototype, "onCheck", void 0);
	    EntityPreferences = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EntityPreferences);
	    return EntityPreferences;
	}(react_1.default.Component));


/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var metaConstant_1 = __webpack_require__(13);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var buttons_1 = __webpack_require__(27);
	var tenantService_1 = tslib_1.__importDefault(__webpack_require__(402));
	var tenantDomain_1 = __webpack_require__(944);
	var constants_1 = __webpack_require__(570);
	var formUtils_1 = __webpack_require__(14);
	var errorComp_1 = __webpack_require__(34);
	var paramTableForm_1 = tslib_1.__importStar(__webpack_require__(2133));
	var ParamKeyDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(ParamKeyDetail, _super);
	    function ParamKeyDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.confirmationDeleteDialogRefHandler = function (comp) { return _this.confirmationDeleteDialogRef = comp; };
	        _this.customValidate = function (paramTableObject) {
	            var errors = [];
	            if (paramTableObject.tenant && paramTableObject.tenantGroup)
	                errors.push({ message: "Choose one of tenant or tenant group" });
	            else if (!paramTableObject.tenant && !paramTableObject.tenantGroup)
	                errors.push({ message: "Please choose tenant or tenant group" });
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave paramTableObjectId = %s, $new = %s', tenantService_1.default.paramTableObject.getFlattenId(), tenantService_1.default.paramTableObject.$new);
	            uiService_1.default.showToolbarActionFlag();
	            var result = (0, formUtils_1.preSave)(tenantService_1.default.paramTableObject, _this.customValidate, true);
	            if (!result) {
	                return;
	            }
	            tenantService_1.default.saveParamTable(tenantService_1.default.paramTableObject.createEditTenantDto(), tenantService_1.default.paramTableObject.$new)
	                .then((0, mobx_1.action)("paramTableSave", function (paramTableJson) {
	                var wasNew = tenantService_1.default.paramTableObject.cleanAfterSave(paramTableJson);
	                if (wasNew)
	                    _this.context.router.replaceWith('paramKeyDetail', { id: tenantService_1.default.paramTableObject.getFlattenId() });
	                uiService_1.default.hideToolbarActionFlag();
	            }), function (error) {
	                tenantService_1.default.paramTableObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            _this.context.router.transitionTo("paramKeyDetail", { id: 'new' });
	        };
	        _this.onCopy = function (evt) {
	            console.log('onCopy');
	            _this.context.router.transitionTo("paramKeyDetail", { id: 'copy' }, { copyId: tenantService_1.default.paramTableObject.getFlattenId() });
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            new Promise(function (resolve, reject) {
	                _this.confirmationDeleteDialogRef.open(resolve, reject, 'Do you really want to delete this param table row?');
	            }).then(function () {
	                uiService_1.default.showToolbarActionFlag();
	                tenantService_1.default.deleteTableParam(tenantService_1.default.paramTableObject.getFlattenId())
	                    .then(function (_) {
	                    _this.goBackOrHome();
	                    uiService_1.default.hideToolbarActionFlag();
	                }, function (error) {
	                    tenantService_1.default.paramTableObject.$errors = error.getMessages();
	                });
	            }).catch(function (e) {
	            });
	        };
	        return _this;
	    }
	    ParamKeyDetail.fetchData = function (routerParams, query) {
	        console.log("ParamKeyDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata([constants_1.PARAM_TABLE_ENTITY]);
	        var entityGenGroupObjectPromise;
	        if (routerParams.id === 'new') {
	            entityGenGroupObjectPromise = Promise.resolve(new tenantDomain_1.ParamTable({ $new: true }));
	        }
	        else if (routerParams.id === 'copy') {
	            entityGenGroupObjectPromise = tenantService_1.default.readParamTableRow(query.copyId)
	                .then(function (paramTableObject) {
	                paramTableObject.cleanOnCopy();
	                paramTableObject.tenantId = undefined;
	                return paramTableObject;
	            });
	        }
	        else {
	            entityGenGroupObjectPromise = tenantService_1.default.readParamTableRow(routerParams.id);
	        }
	        return Promise.all([metadataPromise, entityGenGroupObjectPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], paramTableObject = _a[1];
	            tenantService_1.default.paramTableObject = paramTableObject.initAfterRead(routerParams.id === 'new');
	            tenantService_1.default.paramTableObject.loadTenantOptions(paramTableForm_1.ParamTableFormDefinition.formName);
	            tenantService_1.default.paramTableObject.resolveTenantOrTenantGroup(paramTableForm_1.ParamTableFormDefinition.formName);
	        });
	    };
	    ParamKeyDetail.prototype.componentWillUnmount = function () {
	        tenantService_1.default.paramTableObject = null;
	    };
	    ParamKeyDetail.prototype.findRootObject = function () {
	        return tenantService_1.default.paramTableObject;
	    };
	    ParamKeyDetail.prototype._createToolMenu = function (paramTableObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: History.length <= 1 },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !paramTableObject.$dirty, label: "Save", permission: paramTableObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, label: "New", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onCopy, disabled: paramTableObject.$new, label: "Copy", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onDelete, disabled: paramTableObject.$new, label: "Delete", permission: metaConstant_1.PERMISSION.Delete })));
	    };
	    ParamKeyDetail.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        var paramTableObject = tenantService_1.default.paramTableObject;
	        var propsForForm = {
	            dataObject: paramTableObject,
	            rootObject: paramTableObject,
	            entity: mdEntityService_1.default.getEntity(constants_1.PARAM_TABLE_ENTITY),
	            entities: mdEntityService_1.default.entityMap
	        };
	        var _renderParamTableForm = (react_1.default.createElement(paramTableForm_1.default, tslib_1.__assign({}, propsForForm)));
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	            this._createToolMenu(paramTableObject, query.gridLocation),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: paramTableObject.$errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement(confirmationDialog_1.default, { okButtonText: "Yes", cancelButtonText: "No", ref: this.confirmationDeleteDialogRefHandler }),
	            _renderParamTableForm));
	    };
	    ParamKeyDetail.module = metaConstant_1.MODULE.core;
	    ParamKeyDetail.title = 'Param key Detail';
	    ParamKeyDetail.icon = 'key';
	    ParamKeyDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ParamKeyDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ParamKeyDetail.prototype, "onAdd", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ParamKeyDetail.prototype, "onCopy", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ParamKeyDetail.prototype, "onDelete", void 0);
	    ParamKeyDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ParamKeyDetail);
	    return ParamKeyDetail;
	}(pageAncestor_1.default));
	exports.default = ParamKeyDetail;


/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var buttons_1 = __webpack_require__(27);
	var routes_1 = __webpack_require__(75);
	var constants_1 = __webpack_require__(570);
	var ParamKeyList = /** @class */ (function (_super) {
	    tslib_1.__extends(ParamKeyList, _super);
	    function ParamKeyList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ParamKeyList.fetchData = function (routerParams) {
	        console.log("ParamKeyList#fetchData(%s)", constants_1.PARAM_TABLE_LIST);
	        return gridService_1.default.fetchGrids(constants_1.PARAM_TABLE_LIST)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(constants_1.PARAM_TABLE_LIST);
	        });
	    };
	    ParamKeyList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(constants_1.PARAM_TABLE_LIST), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "paramKeyDetail", params: { id: 'new' }, label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["New param"], ["New param"]))), permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.entityNumberGenGroupDetail })));
	    };
	    ParamKeyList.module = metaConstant_1.MODULE.core;
	    ParamKeyList.title = locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Param key List"], ["Param key List"])));
	    ParamKeyList.icon = 'key';
	    ParamKeyList.rootPage = true;
	    ParamKeyList.protectedPage = true;
	    ParamKeyList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ParamKeyList);
	    return ParamKeyList;
	}(pageAncestor_1.default));
	exports.default = ParamKeyList;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ParamTableFormDefinition = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var mobx_react_1 = __webpack_require__(4);
	var form_1 = __webpack_require__(52);
	var createForm_1 = __webpack_require__(18);
	var closedForm_1 = __webpack_require__(82);
	var blockComp_1 = __webpack_require__(30);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var fields_1 = __webpack_require__(20);
	var rules_1 = __webpack_require__(56);
	var validate_1 = __webpack_require__(24);
	var tenantService_1 = tslib_1.__importDefault(__webpack_require__(402));
	var mobx_1 = __webpack_require__(5);
	var mdField_1 = tslib_1.__importStar(__webpack_require__(57));
	var ParamTableForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ParamTableForm, _super);
	    function ParamTableForm(props, context) {
	        var _this = _super.call(this, props, context) || this;
	        _this.onTenantChange = function (_a) {
	            var lovItem = _a.lovItem, changedField = _a.changedField, touchField = _a.touchField;
	            var _b = _this.props, dataObject = _b.dataObject, form = _b.form;
	            form.getField(changedField).props.onChange(lovItem);
	            dataObject[touchField] = null;
	            form.updateFieldsPropValue(dataObject, touchField);
	        };
	        _this.isValueAssignableToParamKey = function (dataObject, form) {
	            var paramKey = dataObject.paramKey, value = dataObject.value;
	            if (!paramKey || !value)
	                return;
	            var valueField = form.getField("value");
	            tenantService_1.default.checkIfValueIsAssignableToParamKey(paramKey, value)
	                .then(function () {
	                valueField.valid = true;
	                valueField.showValidation = false;
	                valueField.props.errorText = null;
	                valueField.errorText = null;
	            })
	                .catch(function (err) {
	                var messArray = err.getMessages();
	                var mess = messArray ? messArray[0].message : "Error";
	                valueField.valid = false;
	                valueField.showValidation = true;
	                valueField.props.errorText = mess;
	                valueField.errorText = mess;
	            });
	        };
	        (0, mobx_1.reaction)(function () { return tenantService_1.default.paramTableObject.paramKey; }, function (paramKey) {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            _this.isValueAssignableToParamKey(dataObject, form);
	        });
	        (0, mobx_1.reaction)(function () { return tenantService_1.default.paramTableObject.value; }, function (value) {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            _this.isValueAssignableToParamKey(dataObject, form);
	        });
	        return _this;
	    }
	    ParamTableForm.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity, form = _a.form;
	        var fields = dataObject.getFormFields(exports.ParamTableFormDefinition.formName);
	        var paramKey = fields.paramKey, value = fields.value, tenantGroup = fields.tenantGroup, tenant = fields.tenant;
	        var openContent = (react_1.default.createElement("form", { style: { marginTop: 10 } },
	            react_1.default.createElement(blockComp_1.BlockComp, null,
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, paramKey.props, { disabled: !dataObject.$new })),
	                        react_1.default.createElement(validate_1.Validate, { field: paramKey, value: paramKey.props.value },
	                            react_1.default.createElement(rules_1.IsRequired, null))),
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, tenantGroup.props, { onChange: function (v) { return _this.onTenantChange({
	                                lovItem: v,
	                                changedField: "tenantGroup",
	                                touchField: "tenant"
	                            }); }, disabled: !dataObject.$new })),
	                        react_1.default.createElement(validate_1.Validate, { field: tenantGroup, value: tenantGroup.props.value })),
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, tenant.props, { onChange: function (v) { return _this.onTenantChange({
	                                lovItem: v,
	                                changedField: "tenant",
	                                touchField: "tenantGroup"
	                            }); }, disabled: !dataObject.$new })),
	                        react_1.default.createElement(validate_1.Validate, { field: tenant, value: tenant.props.value }))),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-12 zz-mb-5" },
	                        react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, value.props, { multiLine: true, maxLength: 4096 })),
	                        react_1.default.createElement(validate_1.Validate, { field: value, value: value.props.value },
	                            react_1.default.createElement(rules_1.IsRequired, null)))))));
	        return openContent;
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ParamTableForm.prototype, "onTenantChange", void 0);
	    ParamTableForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ParamTableForm);
	    return ParamTableForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { width: '100%' } },
	        react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields },
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.paramKey.textLabel, value: dataObject.paramKey }))));
	};
	exports.ParamTableFormDefinition = {
	    formName: 'ParamTableForm',
	    fields: [{
	            name: 'paramKey',
	            validators: ['IsRequired']
	        }, {
	            name: 'value',
	            displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	        }, {
	            name: 'tenantGroup',
	            mdField: new mdField_1.default({ label: "Tenant Group", valueSourceType: mdField_1.VALUESOURCETYPE.ASYNC })
	        }, {
	            name: 'tenant',
	            mdField: new mdField_1.default({ label: "Tenant", valueSourceType: mdField_1.VALUESOURCETYPE.ASYNC })
	        },]
	};
	exports.default = (0, createForm_1.createForm)(exports.ParamTableFormDefinition, ClosedContent)(ParamTableForm);


/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var EmployeeService = /** @class */ (function () {
	    function EmployeeService() {
	    }
	    EmployeeService.prototype.employeeAttendanceSave = function (empAttendanceDto) {
	        console.log('employeeAttendanceSave %O', empAttendanceDto);
	        return axios_config_1.default.post('/employee-attendance', empAttendanceDto)
	            .then(function (response) { return response.data; });
	    };
	    return EmployeeService;
	}());
	exports.default = new EmployeeService();


/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EmployeeAttendance = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var EmployeeAttendance = /** @class */ (function (_super) {
	    tslib_1.__extends(EmployeeAttendance, _super);
	    function EmployeeAttendance(json) {
	        return _super.call(this, json) || this;
	    }
	    EmployeeAttendance.prototype.getId = function () {
	        return this.employeeAttendanceId;
	    };
	    EmployeeAttendance.prototype.setId = function (id) {
	        this.employeeAttendanceId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EmployeeAttendance.prototype, "employeeAttendanceId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EmployeeAttendance.prototype, "employee", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EmployeeAttendance.prototype, "comingTime", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EmployeeAttendance.prototype, "leavingTime", void 0);
	    EmployeeAttendance = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], EmployeeAttendance);
	    return EmployeeAttendance;
	}(DomainAncestor_1.DomainAncestor));
	exports.EmployeeAttendance = EmployeeAttendance;


/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'timeSheetReport';
	var TimeSheetReport = /** @class */ (function (_super) {
	    tslib_1.__extends(TimeSheetReport, _super);
	    function TimeSheetReport() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TimeSheetReport.fetchData = function (routerParams) {
	        console.log("TimeSheetReport#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    TimeSheetReport.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query }));
	    };
	    TimeSheetReport.module = metaConstant_1.MODULE.humanresource;
	    TimeSheetReport.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Time sheets"], ["Time sheets"])));
	    TimeSheetReport.icon = 'user-circle-o';
	    TimeSheetReport.rootPage = true;
	    TimeSheetReport.protectedPage = true;
	    TimeSheetReport = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], TimeSheetReport);
	    return TimeSheetReport;
	}(pageAncestor_1.default));
	exports.default = TimeSheetReport;
	var templateObject_1;


/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EntityNumberGenFormDefinition = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var validate_1 = __webpack_require__(24);
	var fields_1 = __webpack_require__(20);
	var closedForm_1 = __webpack_require__(82);
	var createForm_1 = __webpack_require__(18);
	var rules_1 = __webpack_require__(56);
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var styledDateInterval_1 = tslib_1.__importDefault(__webpack_require__(130));
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var entityNumberGenService_1 = tslib_1.__importDefault(__webpack_require__(947));
	var colors_1 = __webpack_require__(29);
	function PrefixConstantExists(_a) {
	    var value = _a.value;
	    if (!value)
	        return (0, rules_1.invalid)("Prefix constant was not specified");
	    return entityNumberGenService_1.default.checkIfEntityNumberGenPrefixExist(value)
	        .then(function (exists) { return (exists) ? (0, rules_1.invalid)("Number gen with prefix ".concat(value, " already exists")) : (0, rules_1.valid)(); });
	}
	var EntityNumberGenForm = /** @class */ (function (_super) {
	    tslib_1.__extends(EntityNumberGenForm, _super);
	    function EntityNumberGenForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = { sameGenNumberPossibility: false };
	        _this.ValidateDateInterval = function (_a) {
	            var value = _a.value;
	            var _b = _this.props, dataObject = _b.dataObject, form = _b.form;
	            if (!dataObject.validFrom || !dataObject.validTo)
	                return (0, rules_1.valid)();
	            var validFrom = (0, moment_1.default)(dataObject.validFrom);
	            var validTo = (0, moment_1.default)(dataObject.validTo);
	            if (validFrom.isAfter(validTo))
	                return (0, rules_1.invalid)('Valid from has to be before valid to date');
	            if (validTo.diff(validFrom, 'days') < 1)
	                return (0, rules_1.invalid)('There has to be at least one day between valid from and valid to dates');
	            var validFromField = form.getField("validFrom");
	            validFromField.valid = true;
	            validFromField.errorText = null;
	            var validToField = form.getField("validTo");
	            validToField.valid = true;
	            validToField.errorText = null;
	            return (0, rules_1.valid)();
	        };
	        _this.checkSameGenNumberPossibility = function () {
	            var dataObject = _this.props.dataObject;
	            if (dataObject.prefixConstant && dataObject.padding)
	                entityNumberGenService_1.default.checkSameGenNumberPossibility(dataObject.prefixConstant, dataObject.padding)
	                    .then(function (exist) {
	                    _this.setState({
	                        sameGenNumberPossibility: exist,
	                    });
	                });
	        };
	        return _this;
	    }
	    EntityNumberGenForm.prototype.componentDidMount = function () {
	        var dataObject = this.props.dataObject;
	        if (!dataObject.entityNumberGenId && dataObject.prefixConstant && dataObject.padding)
	            this.checkSameGenNumberPossibility();
	    };
	    EntityNumberGenForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity;
	        var fields = dataObject.getFormFields(exports.EntityNumberGenFormDefinition.formName);
	        var padding = fields.padding, prefixConstant = fields.prefixConstant, validFrom = fields.validFrom, validTo = fields.validTo, active = fields.active;
	        var exist = !!dataObject.entityNumberGenId;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" }, (this.state.sameGenNumberPossibility) ? (react_1.default.createElement("div", { className: "fx col-xs-12" },
	                react_1.default.createElement("h5", { style: { color: colors_1.orange500 } }, "This configuration can generate same numbers as existing number generation"))) : null),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, prefixConstant.props, { disabled: exist })),
	                    react_1.default.createElement(validate_1.Validate, { field: prefixConstant, value: prefixConstant.props.value, onSuccess: this.checkSameGenNumberPossibility }, (exist) ? null : (react_1.default.createElement(PrefixConstantExists, null)))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-3" },
	                    react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, padding.props, { disabled: exist })),
	                    react_1.default.createElement(validate_1.Validate, { field: padding, value: padding.props.value, onSuccess: this.checkSameGenNumberPossibility },
	                        react_1.default.createElement(rules_1.NumberFormat, { precision: 1, scale: 0 }),
	                        react_1.default.createElement(rules_1.Min, { min: 1 }))),
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-3" },
	                    react_1.default.createElement(styledDateInterval_1.default, tslib_1.__assign({}, validFrom.props, { errorText: validFrom.errorText ? validFrom.errorText : validTo.errorText, valueFrom: validFrom.props.value, valueTo: validTo.props.value, onChangeFrom: validFrom.props.onChange, onChangeTo: validTo.props.onChange })),
	                    react_1.default.createElement(validate_1.Validate, { field: validFrom, value: validFrom.props.value },
	                        react_1.default.createElement(this.ValidateDateInterval, null)),
	                    react_1.default.createElement(validate_1.Validate, { field: validTo, value: validTo.props.value },
	                        react_1.default.createElement(this.ValidateDateInterval, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, active.props, { style: { alignSelf: 'center' } })),
	                    react_1.default.createElement(validate_1.Validate, { field: active, value: active.props.value })))));
	        return openContent;
	    };
	    EntityNumberGenForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EntityNumberGenForm);
	    return EntityNumberGenForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", null,
	        react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields },
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.prefixConstant.textLabel, value: dataObject.prefixConstant }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.padding.textLabel, value: dataObject.padding }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.validFrom.textLabel, value: dataObject.validFrom }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.validTo.textLabel, value: dataObject.validTo }))));
	};
	exports.EntityNumberGenFormDefinition = {
	    formName: 'EntityNumberGenForm',
	    fields: [{
	            name: 'prefixConstant',
	            validators: ['IsRequired', { validation: 'HasLength', parameters: { max: 10 } }]
	        }, {
	            name: 'padding',
	            validators: ['IsRequired']
	        }, {
	            name: 'validFrom',
	            validators: ['IsRequired']
	        }, {
	            name: 'validTo'
	        }, {
	            name: 'active'
	        }]
	};
	exports.default = (0, createForm_1.createForm)(exports.EntityNumberGenFormDefinition, ClosedContent)(EntityNumberGenForm);


/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.InvoiceCustomerBlock = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var FontIcon_1 = tslib_1.__importDefault(__webpack_require__(164));
	var fields_1 = __webpack_require__(20);
	var Colors = tslib_1.__importStar(__webpack_require__(29));
	var react_bootstrap_1 = __webpack_require__(72);
	var createForm_1 = __webpack_require__(18);
	var formUtils_1 = __webpack_require__(14);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var blockComp_1 = __webpack_require__(30);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var commonDataService_1 = __webpack_require__(41);
	var mobx_react_1 = __webpack_require__(4);
	var invoiceDomain_1 = __webpack_require__(157);
	var mobx_1 = __webpack_require__(5);
	var partyDomain_1 = __webpack_require__(48);
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var grid_1 = __webpack_require__(50);
	var rules_1 = __webpack_require__(56);
	var selectSearchDialog_1 = tslib_1.__importDefault(__webpack_require__(311));
	var dateUtils_1 = __webpack_require__(49);
	var numberUtils_1 = __webpack_require__(143);
	var arrayUtils_1 = __webpack_require__(78);
	var gridConfigCondition_1 = tslib_1.__importDefault(__webpack_require__(194));
	var utils_1 = __webpack_require__(37);
	var react_router_1 = __webpack_require__(65);
	var locales_1 = __webpack_require__(15);
	var icons_1 = __webpack_require__(63);
	var link_1 = tslib_1.__importDefault(__webpack_require__(1597));
	var MenuItem_1 = tslib_1.__importDefault(__webpack_require__(101));
	var invoiceService_1 = tslib_1.__importDefault(__webpack_require__(195));
	var SvgDelete = __webpack_require__(249);
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var InvoiceCustomerBlock = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, style = _a.style, fields = _a.fields, showLinkedInvoices = _a.showLinkedInvoices;
	    var ADDRESSTYPEEntity = entities.get('ADDRESSTYPE');
	    var permanentAddressText = partyDomain_1.Address.addressLineFromItems(dataObject.toPermanentStreet, dataObject.toPermanentCity, dataObject.toPermanentZip, dataObject.toPermanentCountry);
	    var correspondentAddressText = partyDomain_1.Address.addressLineFromItems(dataObject.toCorrespondentStreet, dataObject.toCorrespondentCity, dataObject.toCorrespondentZip, dataObject.toCorrespondentCountry);
	    //labels={{toIco: toIco.textLabel, toDic: toDic.textLabel, toIcoDph: toIcoDph.textLabel}}
	    return (react_1.default.createElement("div", { style: style },
	        react_1.default.createElement("div", { className: "form-text-row" },
	            (0, formUtils_1.hideForVatRateCountry)(react_1.default.createElement(formUtils_1.FieldText, { label: fields.toIco.textLabel, value: dataObject.toIco }), partyDomain_1.COUNTRY.RO),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.toDic.textLabel, value: dataObject.toDic }),
	            (0, formUtils_1.showForVatRateCountry)(react_1.default.createElement(formUtils_1.FieldText, { label: fields.toIcoDph.textLabel, value: dataObject.toIcoDph }), partyDomain_1.COUNTRY.SK, partyDomain_1.COUNTRY.HU),
	            dataObject.billedTo2 && react_1.default.createElement(formUtils_1.FieldText, { label: "Second customer", value: dataObject.billedTo2.label, linkProps: {
	                    to: 'partyDetail',
	                    params: { id: dataObject.billedTo2.value }
	                } })),
	        (permanentAddressText) ? (react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "top", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "permanentAddressTooltip", style: { fontSize: 13 } }, ADDRESSTYPEEntity.getLovItemLabel(partyDomain_1.ADDRESSTYPE.PERMANENT)) },
	                react_1.default.createElement(FontIcon_1.default, { className: "fa fa-envelope-o", color: Colors[ADDRESSTYPEEntity.getLovItemParam(partyDomain_1.ADDRESSTYPE.PERMANENT, 'color')], style: { fontSize: 16, marginRight: 5 } })),
	            react_1.default.createElement("span", null, permanentAddressText))) : null,
	        (correspondentAddressText) ? (react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "top", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "correspondentAddressTooltip", style: { fontSize: 13 } }, ADDRESSTYPEEntity.getLovItemLabel(partyDomain_1.ADDRESSTYPE.CORRESPONDENT)) },
	                react_1.default.createElement(FontIcon_1.default, { className: "fa fa-envelope-o", color: Colors[ADDRESSTYPEEntity.getLovItemParam(partyDomain_1.ADDRESSTYPE.CORRESPONDENT, 'color')], style: { fontSize: 16, marginRight: 5 } })),
	            react_1.default.createElement("span", null, correspondentAddressText))) : null,
	        (showLinkedInvoices && (dataObject.fromRels.length || dataObject.toRels.length)) ? (react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(LinkedInvoicesTable, { dataObject: dataObject }))) : null));
	};
	exports.InvoiceCustomerBlock = InvoiceCustomerBlock;
	var CustomerForm = /** @class */ (function (_super) {
	    tslib_1.__extends(CustomerForm, _super);
	    function CustomerForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onBilledToChange = function () {
	            var _a = _this.props, entities = _a.entities, dataObject = _a.dataObject, form = _a.form;
	            console.log('onBilledToChange ', dataObject.billedTo);
	            //let oldBilledToLov = form.getValue(dataObject, "billedTo");
	            var partyId = (0, formUtils_1.lovValue)(dataObject.billedTo);
	            var optionsPromise = (partyId != null) ? (0, commonDataService_1.optionsSearch)('Party', { contactsOf: partyId }, '*') : Promise.resolve({ options: [] });
	            return Promise.all([_this.props.recalculate(_this.props.dataObject, null, null, { billedToChange: true }), optionsPromise])
	                .then((0, mobx_1.action)('onBilledToChange-cb1', function (_a) {
	                var x = _a[0], options = _a[1];
	                console.log(x);
	                console.log(options);
	                form.getField('orderedBy').props.options = options.options;
	                dataObject.orderedBy = (options.options.length === 1) ? options.options[0].value : null;
	                form.updateAllFieldsPropValue(dataObject);
	                dataObject.getForm('InvoiceForm').updateAllFieldsPropValue(dataObject);
	                dataObject.getForm('InvoiceAdvancedForm').updateAllFieldsPropValue(dataObject);
	                //
	                if (dataObject.getTuple('vatRateChange')) {
	                    commonService_1.default.notifyInfo('Vat rates were changed');
	                }
	            }));
	        };
	        _this.onDeleteLink = function (invoiceRelation) {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onDelete %o', invoiceRelation);
	            (0, arrayUtils_1.removeItem)(dataObject.fromRels, invoiceRelation);
	            (0, arrayUtils_1.removeItem)(dataObject.toRels, invoiceRelation);
	            _this.props.recalculate(dataObject, null, null, {});
	            rootObject.$dirty = true;
	        };
	        _this.onInvoiceTypeSuccess = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form, entities = _a.entities;
	            var doRecalculate = dataObject.toRels.length + dataObject.fromRels.length;
	            dataObject.toRels = [];
	            dataObject.fromRels = [];
	            // zkusime najit regular pro creditNote
	            var promise;
	            if ((0, formUtils_1.lovValue)(dataObject.invoiceType) === invoiceDomain_1.INVOICE_TYPE.CN && dataObject.copiedFromInvoiceId != undefined) {
	                promise = invoiceService_1.default.readInvoice(dataObject.copiedFromInvoiceId)
	                    .then(function (invoice) {
	                    if ([invoiceDomain_1.INVOICE_TYPE.FI, invoiceDomain_1.INVOICE_TYPE.AD].includes((0, formUtils_1.lovValue)(invoice.invoiceType))) {
	                        dataObject.fromRels.push(new invoiceDomain_1.InvoiceRelation({
	                            toInvoice: invoice.createInvoiceInInvoiceRelation(),
	                            relationType: entities.get("INVOICERELATIONTYPE").getLovItem((0, invoiceDomain_1.relationArrayInverse)(invoiceDomain_1.INVOICE_TYPE.CN, (0, formUtils_1.lovValue)(invoice.invoiceType))),
	                            valueDate: (0, dateUtils_1.formatDateIso)(new Date())
	                        }));
	                        doRecalculate++;
	                    }
	                });
	            }
	            else {
	                promise = Promise.resolve(undefined);
	            }
	            promise.then(function () {
	                if (doRecalculate) {
	                    return _this.props.recalculate(dataObject, null, null, {});
	                }
	            });
	        };
	        _this.addLinkedInvoice = function (invoiceType) {
	            var _a = _this.props, dataObject = _a.dataObject, entity = _a.entity, rootObject = _a.rootObject, entities = _a.entities;
	            console.log('addLinkedInvoice');
	            new Promise(function (resolve, reject) {
	                return _this.selectSearchDialogRef.open(resolve, reject, function (grid) {
	                    var linkedInvoices = dataObject.getLinkedInvoices();
	                    if (linkedInvoices.length) {
	                        if (!grid.conditionArray)
	                            grid.conditionArray = [];
	                        // vyloucime jiz pridane
	                        grid.conditionArray.push(new gridConfigCondition_1.default(grid.$gridLocationRef, {
	                            field: entity.getField('invoiceId'),
	                            operator: grid_1.FILTEROPERATOR.NOTIN,
	                            values: linkedInvoices.map(function (lv) { return lv.value; })
	                        }));
	                    }
	                }, locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Link"], ["Link"]))) + ' ' + entities.get('InvoiceType').getLovItemLabel(invoiceType), (0, formUtils_1.lovValue)(dataObject.invoiceType) + "_" + (0, formUtils_1.lovValue)(dataObject.billedTo) + '_' + invoiceType);
	            }).then((0, mobx_1.action)('close-new-party-diaglog', function (linkedInvoice) {
	                console.log('adding %o', linkedInvoice);
	                if (invoiceType !== (0, formUtils_1.lovValue)(linkedInvoice.invoiceType))
	                    throw new Error("InvoiceType mismash");
	                if ((0, formUtils_1.lovValue)(linkedInvoice.invoiceType) === invoiceDomain_1.INVOICE_TYPE.PR) {
	                    dataObject.items = linkedInvoice.items.map(function (item) {
	                        var invoiceItemId = item.invoiceItemId, invoice = item.invoice, rest = tslib_1.__rest(item, ["invoiceItemId", "invoice"]);
	                        return new invoiceDomain_1.InvoiceItem(rest);
	                    });
	                }
	                var invoicerelationtype = (0, invoiceDomain_1.relationArrayInverse)(invoiceType, (0, formUtils_1.lovValue)(dataObject.invoiceType));
	                if (invoicerelationtype) {
	                    dataObject.toRels.push(new invoiceDomain_1.InvoiceRelation({
	                        fromInvoice: linkedInvoice.createInvoiceInInvoiceRelation(),
	                        relationType: entities.get("INVOICERELATIONTYPE").getLovItem(invoicerelationtype),
	                        contributedAmount: linkedInvoice.totalAdjustedPrice,
	                        valueDate: (0, dateUtils_1.formatDateIso)(new Date())
	                    }));
	                }
	                else {
	                    dataObject.fromRels.push(new invoiceDomain_1.InvoiceRelation({
	                        toInvoice: linkedInvoice.createInvoiceInInvoiceRelation(),
	                        relationType: entities.get("INVOICERELATIONTYPE").getLovItem((0, invoiceDomain_1.relationArrayInverse)((0, formUtils_1.lovValue)(dataObject.invoiceType), invoiceType)),
	                        contributedAmount: linkedInvoice.totalAdjustedPrice,
	                        valueDate: (0, dateUtils_1.formatDateIso)(new Date())
	                    }));
	                }
	                console.debug("fromRels = %o, toRels = %o", dataObject.fromRels, dataObject.toRels);
	                rootObject.$dirty = true;
	                return _this.props.recalculate(dataObject, null, null, {});
	            }), function (reason) {
	                console.log("dialog rejected with reason: ", reason);
	            });
	        };
	        //  this.onResizeDebounced = debounce(this.onResize, 15, false);
	        _this.onChangeContributedAmount = (0, utils_1.debounce)(function (invoiceRelation, newNum) {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject;
	            console.log("onChangeContributedAmount IR = %o, value = %s", invoiceRelation, newNum);
	            if (newNum != null && !Number.isNaN(newNum) && typeof newNum === 'number') {
	                invoiceRelation.contributedAmount = newNum;
	                rootObject.$dirty = true;
	                return _this.props.recalculate(dataObject, null, null, {});
	            }
	        }, 1500, false);
	        _this.selectSearchDialogRefHandler = function (comp) { return _this.selectSearchDialogRef = comp; };
	        return _this;
	    }
	    CustomerForm.prototype.componentWillMount = function () {
	        var _a = this.props, entities = _a.entities, dataObject = _a.dataObject, form = _a.form;
	        form.getField('orderedBy').props.options = dataObject.getTuple('orderedByOptions');
	    };
	    CustomerForm.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, formName = _a.formName, entity = _a.entity;
	        var fields = dataObject.getFormFields(formName);
	        var billedTo = fields.billedTo, billedTo2 = fields.billedTo2, toFullName = fields.toFullName, toIco = fields.toIco, toDic = fields.toDic, toIcoDph = fields.toIcoDph, orderedBy = fields.orderedBy, orderNumber = fields.orderNumber, invoiceType = fields.invoiceType, toPermanentStreet = fields.toPermanentStreet, toPermanentCity = fields.toPermanentCity, toPermanentZip = fields.toPermanentZip, toPermanentCountry = fields.toPermanentCountry, toCorrespondentStreet = fields.toCorrespondentStreet, toCorrespondentCity = fields.toCorrespondentCity, toCorrespondentZip = fields.toCorrespondentZip, toCorrespondentCountry = fields.toCorrespondentCountry;
	        var clearBilledTo2 = function () {
	            billedTo2.props.value = undefined;
	            dataObject.billedTo2 = undefined;
	        };
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-8" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, toFullName.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: toFullName, value: toFullName.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, toDic.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                (0, formUtils_1.hideForVatRateCountry)(react_1.default.createElement("div", { className: "fx col-xs-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, toIco.props))), partyDomain_1.COUNTRY.RO),
	                (0, formUtils_1.showForVatRateCountry)((react_1.default.createElement("div", { className: "fx col-xs-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, toIcoDph.props)))), partyDomain_1.COUNTRY.SK, partyDomain_1.COUNTRY.HU)),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" }, "Permanent Address")),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, toPermanentStreet.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, toPermanentCity.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, toPermanentZip.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, toPermanentCountry.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" }, "Correspondent Address")),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, toCorrespondentStreet.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, toCorrespondentCity.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, toCorrespondentZip.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, toCorrespondentCountry.props))))));
	        var _b = this.props, recalculate = _b.recalculate, activeItemProps = tslib_1.__rest(_b, ["recalculate"]);
	        var linkingPerInvoiceType = invoiceDomain_1.linkingPerInvoiceTypes[(0, formUtils_1.lovValue)(dataObject.invoiceType)];
	        var invoiceTypeEntity = entities.get('InvoiceType');
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true },
	            react_1.default.createElement(selectSearchDialog_1.default, { ref: this.selectSearchDialogRefHandler, gridLocation: "invoiceSearch", showGridConfig: false }),
	            react_1.default.createElement("div", null,
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-8", style: { paddingLeft: 25, paddingTop: 10 } },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, billedTo.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.CUSTOMER_ROLE] }), clearable: true, onValueEmpty: clearBilledTo2 })),
	                        react_1.default.createElement(validate_1.Validate, { field: billedTo, value: billedTo.props.value, onSuccess: this.onBilledToChange })),
	                    react_1.default.createElement("div", { className: "fx col-xs-4", style: { paddingRight: 20, paddingTop: 10 } },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, orderedBy.props, { clearable: false })))),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-8", style: { paddingLeft: 25 } },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, billedTo2.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.CUSTOMER_ROLE] }), clearable: true, disabled: !billedTo.props.value })),
	                        react_1.default.createElement(validate_1.Validate, { field: billedTo2, value: billedTo2.props.value })),
	                    react_1.default.createElement("div", { className: "fx col-xs-4", style: { paddingRight: 20 } },
	                        react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, orderNumber.props, { clearable: false })),
	                        react_1.default.createElement(validate_1.Validate, { field: orderNumber, value: orderNumber.props.value },
	                            react_1.default.createElement(rules_1.HasLength, { max: 30 })))),
	                react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(exports.InvoiceCustomerBlock, { dataObject: dataObject, entities: entities, entity: entity, style: { display: 'flex', flexDirection: 'column' }, fields: fields, showLinkedInvoices: false }), closedStyle: { paddingTop: 4, paddingBottom: 0 } }, activeItemProps)),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-md-5 col-xs-8", style: { paddingLeft: 25 } },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, invoiceType.props, { floatingLabelText: "", clearable: false })),
	                        react_1.default.createElement(validate_1.Validate, { field: invoiceType, value: invoiceType.props.value, onSuccess: this.onInvoiceTypeSuccess })),
	                    !!linkingPerInvoiceType && !!linkingPerInvoiceType.length && (react_1.default.createElement("div", { className: "fx col-xs-4", style: { paddingRight: 25, paddingTop: 10 } },
	                        react_1.default.createElement(icons_1.ZzIconButtonMenu, { buttonIcon: react_1.default.createElement(link_1.default, null) }, linkingPerInvoiceType.map(function (possibleInvType) { return (react_1.default.createElement(MenuItem_1.default, { primaryText: (0, formUtils_1.lovLabel)(invoiceTypeEntity.getLovItem(possibleInvType)), onClick: _this.addLinkedInvoice.bind(_this, possibleInvType), disabled: !dataObject.billedTo })); }))))),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-12", style: { paddingLeft: 25 } },
	                        react_1.default.createElement(LinkedInvoicesTable, { dataObject: dataObject, onDelete: this.onDeleteLink, onChangeContributedAmount: this.onChangeContributedAmount }))))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], CustomerForm.prototype, "onBilledToChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], CustomerForm.prototype, "onDeleteLink", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], CustomerForm.prototype, "onChangeContributedAmount", void 0);
	    CustomerForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'CustomerForm',
	            closedOnNew: true,
	            fields: [{
	                    name: 'billedTo',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'orderNumber'
	                }, {
	                    name: 'billedTo2'
	                }, {
	                    name: 'toFullName',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'toIco'
	                }, {
	                    name: 'toDic'
	                }, {
	                    name: 'toIcoDph'
	                }, {
	                    name: 'toPermanentStreet'
	                }, {
	                    name: 'toPermanentCity'
	                }, {
	                    name: 'toPermanentZip'
	                }, {
	                    name: 'toPermanentCountry'
	                }, {
	                    name: 'toCorrespondentStreet'
	                }, {
	                    name: 'toCorrespondentCity'
	                }, {
	                    name: 'toCorrespondentZip'
	                }, {
	                    name: 'toCorrespondentCountry'
	                }, {
	                    name: 'issuedBy'
	                }, {
	                    name: 'orderedBy'
	                }, {
	                    name: 'invoiceType',
	                    validators: ['IsRequired'],
	                    omitNullOption: true
	                }]
	        }, exports.InvoiceCustomerBlock),
	        mobx_react_1.observer
	    ], CustomerForm);
	    return CustomerForm;
	}(react_1.default.Component));
	exports.default = CustomerForm;
	var LinkedInvoicesTable = /** @class */ (function (_super) {
	    tslib_1.__extends(LinkedInvoicesTable, _super);
	    function LinkedInvoicesTable() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    LinkedInvoicesTable.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, dataObject = _a.dataObject, onDelete = _a.onDelete, onChangeContributedAmount = _a.onChangeContributedAmount;
	        return ((dataObject.fromRels.length || dataObject.toRels.length) ? (react_1.default.createElement("table", { className: "zz-simple-table" },
	            react_1.default.createElement("thead", null,
	                react_1.default.createElement("tr", null,
	                    react_1.default.createElement("th", { style: { paddingTop: 10, paddingLeft: 0 }, colSpan: 3 }, locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Linked Invoices"], ["Linked Invoices"])))),
	                    react_1.default.createElement("th", null, "Inv Amount"),
	                    react_1.default.createElement("th", null, "Contrib Amount"))),
	            react_1.default.createElement("tbody", null, dataObject.fromRels.concat(dataObject.toRels).map(function (invoiceRelation) {
	                var otherInvoice = invoiceRelation.getOtherInvoice(dataObject);
	                return (react_1.default.createElement("tr", { key: otherInvoice === null || otherInvoice === void 0 ? void 0 : otherInvoice.value },
	                    react_1.default.createElement("td", { style: { whiteSpace: "nowrap" } }, (0, formUtils_1.lovLabel)(otherInvoice === null || otherInvoice === void 0 ? void 0 : otherInvoice.invoiceType)),
	                    react_1.default.createElement("td", null, !!(otherInvoice === null || otherInvoice === void 0 ? void 0 : otherInvoice.value) && react_1.default.createElement(react_router_1.Link, { to: "invoiceDetail", params: { id: otherInvoice.value }, query: (0, utils_1.addTenantToQuery)() }, otherInvoice.label)),
	                    react_1.default.createElement("td", null, (0, dateUtils_1.formatDate)(otherInvoice === null || otherInvoice === void 0 ? void 0 : otherInvoice.invoiceDate)),
	                    react_1.default.createElement("td", null, (0, numberUtils_1.formatNumber)(otherInvoice === null || otherInvoice === void 0 ? void 0 : otherInvoice.totalAdjustedPrice, numberUtils_1.DEFAULT_CURRENCY_FORMAT)),
	                    react_1.default.createElement("td", null, (!!onChangeContributedAmount && [invoiceDomain_1.INVOICERELATIONTYPE.DP_TO_FI, invoiceDomain_1.INVOICERELATIONTYPE.AD_TO_FI, invoiceDomain_1.INVOICERELATIONTYPE.AD_TO_DP].includes((0, formUtils_1.lovValue)(invoiceRelation.relationType))) ?
	                        react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.radioButton, { name: "contributedAmount_" + (otherInvoice === null || otherInvoice === void 0 ? void 0 : otherInvoice.value), value: invoiceRelation.contributedAmount, onChange: onChangeContributedAmount.bind(_this, invoiceRelation), errorText: invoiceRelation.contributedAmount == null ? "Value is required" : (isNaN(invoiceRelation.contributedAmount) ? "Please enter a valid number" : undefined) }))
	                        : (0, numberUtils_1.formatNumber)(invoiceRelation.contributedAmount, numberUtils_1.DEFAULT_CURRENCY_FORMAT)),
	                    (!!onDelete) ?
	                        react_1.default.createElement("td", null,
	                            react_1.default.createElement(SvgDelete, { style: { cursor: 'pointer' }, onClick: onDelete.bind(_this, invoiceRelation) })) : null));
	            })))) : null);
	    };
	    LinkedInvoicesTable = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], LinkedInvoicesTable);
	    return LinkedInvoicesTable;
	}(react_1.default.Component));
	var templateObject_1, templateObject_2;


/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var fields_1 = __webpack_require__(20);
	var documentService_1 = tslib_1.__importDefault(__webpack_require__(110));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var errorComp_1 = __webpack_require__(34);
	var formUtils_1 = __webpack_require__(14);
	var Stepper_1 = __webpack_require__(288);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var dialogAncestor_1 = __webpack_require__(87);
	var react_router_1 = __webpack_require__(65);
	var utils_1 = __webpack_require__(37);
	var gridUtils_1 = __webpack_require__(83);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var EntitiesEmailDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(EntitiesEmailDialog, _super);
	    function EntitiesEmailDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.prepare = function () {
	            var entityName = _this.props.entityName;
	            console.log('Preparing email ' + entityName + "s");
	            commonService_1.default.loading(true);
	            gridService_1.default.doMultipleEmail(_this.emailEntitiesObject, entityName, 1)
	                .then((0, mobx_1.action)("prepare-action", function (newEmailEntitiesObject) {
	                commonService_1.default.loading(false);
	                _this.emailEntitiesObject.part = 2;
	                _this.emailEntitiesObject.showErrors = true;
	                _this.emailEntitiesObject.entityStatuses = newEmailEntitiesObject.entityStatuses;
	            }), function (error) {
	                _this.$errors = error.getMessages();
	            });
	        };
	        _this.ok = function () {
	            var entityName = _this.props.entityName;
	            console.log('Emailing entities ' + _this.props.entityName);
	            commonService_1.default.loading(true);
	            gridService_1.default.doMultipleEmail(_this.emailEntitiesObject, entityName, 2)
	                .then((0, mobx_1.action)("email-action", function (newEmailEntitiesObject) {
	                commonService_1.default.loading(false);
	                newEmailEntitiesObject.part = 3;
	                newEmailEntitiesObject.showErrors = false;
	                _this.emailEntitiesObject = newEmailEntitiesObject;
	            }), function (error) {
	                _this.$errors = error.getMessages();
	            });
	        };
	        _this.close = function () {
	            _this.emailEntitiesObject = null;
	            _this.resolve(null);
	        };
	        _this.cancel = function (evt) {
	            console.log('EntitiesEmailDialog#cancel evt = %O', evt);
	            _this.emailEntitiesObject = null;
	            _this.reject(null);
	        };
	        _this.onShowErrors = function (evt) {
	            _this.emailEntitiesObject.showErrors = evt.target.checked;
	        };
	        _this.onCheckIncludeSent = function (evt, checked) {
	            var _a = _this.props, entityName = _a.entityName, documentLocation = _a.documentLocation;
	            console.log('onCheckIncludeSent checked: ' + checked);
	            _this.emailEntitiesObject.gridParams._includeSent = checked;
	            uiService_1.default.showDialogActionFlag();
	            documentService_1.default.documentCount(entityName, documentLocation, _this.emailEntitiesObject.gridParams)
	                .then(function (documentCountObject) {
	                _this.emailEntitiesObject.count = documentCountObject.documentCount;
	                uiService_1.default.hideDialogActionFlag();
	            });
	        };
	        _this.onCheckIncludeAll = function (evt, checked) {
	            var _a = _this.props, entityName = _a.entityName, documentLocation = _a.documentLocation;
	            console.log('onCheckIncludeAll checked: ' + checked);
	            _this.emailEntitiesObject.gridParams._includeAll = checked;
	            uiService_1.default.showDialogActionFlag();
	            documentService_1.default.documentCount(entityName, documentLocation, _this.emailEntitiesObject.gridParams)
	                .then(function (documentCountObject) {
	                _this.emailEntitiesObject.count = documentCountObject.documentCount;
	                uiService_1.default.hideDialogActionFlag();
	            });
	        };
	        return _this;
	    }
	    EntitiesEmailDialog.prototype.open = function (resolve, reject, grid) {
	        var _this = this;
	        var _a = this.props, entities = _a.entities, entityName = _a.entityName, documentLocation = _a.documentLocation;
	        uiService_1.default.showToolbarActionFlag();
	        var gridParams = grid.createFullParams({
	            _includeSent: false,
	            _includeAll: false,
	            _includeByAll: true,
	            _byEmail: true
	        });
	        console.log('EntitiesEmailDialog: Opening dialog for grid params ', gridParams);
	        this.resolve = resolve;
	        this.reject = reject;
	        Promise.all([mdEntityService_1.default.fetchEntityMetadata([entityName]), documentService_1.default.documentCount(entityName, documentLocation, gridParams)])
	            .then(function (_a) {
	            var entities = _a[0], documentCountObject = _a[1];
	            _this.emailEntitiesObject = new gridUtils_1.GridBulkEntityDto({
	                entityStatuses: null,
	                showErrors: null,
	                part: 1,
	                gridParams: gridParams,
	                includeAll: false,
	                includeSent: false,
	                count: documentCountObject.documentCount
	            });
	            _this.dialogOpen = true;
	            uiService_1.default.hideToolbarActionFlag();
	        })
	            .catch(function (error) {
	            _this.reject(error);
	        });
	    };
	    EntitiesEmailDialog.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, entityDetailRoute = _a.entityDetailRoute, localizedEntitiesName = _a.localizedEntitiesName;
	        if (!(this.emailEntitiesObject && this.dialogOpen))
	            return null;
	        var issuableCount = this.emailEntitiesObject.issuableCount();
	        var cancelButton = react_1.default.createElement(FlatButton_1.default, { label: "Cancel", tabIndex: 0, primary: true, onClick: this.cancel });
	        var showErrorCheckbox = react_1.default.createElement(fields_1.MdCheckbox, { label: "Show Errors", checked: this.emailEntitiesObject.showErrors, labelStyle: { whiteSpace: 'nowrap' }, style: { display: 'inline-block', width: 140, verticalAlign: 'middle' }, onCheck: this.onShowErrors });
	        var actions;
	        if (this.emailEntitiesObject.part === 1) {
	            actions = [cancelButton, react_1.default.createElement(FlatButton_1.default, { label: "Prepare Emails", secondary: true, onClick: this.prepare })];
	        }
	        else if (this.emailEntitiesObject.part === 2) {
	            actions = [showErrorCheckbox, cancelButton, react_1.default.createElement(FlatButton_1.default, { label: "Recheck", secondary: true, onClick: this.prepare }), react_1.default.createElement(FlatButton_1.default, { label: "Send Emails !", secondary: true, onClick: this.ok, disabled: issuableCount === 0 })];
	        }
	        else if (this.emailEntitiesObject.part === 3) {
	            actions = [showErrorCheckbox, react_1.default.createElement(FlatButton_1.default, { label: "Close", primary: true, onClick: this.close })];
	        }
	        console.debug("rendering EntitiesEmailDialog ", this.emailEntitiesObject);
	        return (react_1.default.createElement(Dialog_1.default, { title: this.titleWithProgress(null), titleStyle: { height: 2, paddingBottom: 0 }, actions: actions, modal: true, open: this.dialogOpen, contentStyle: { width: '80%', maxWidth: 800 }, bodyStyle: { overflow: 'visible' } },
	            react_1.default.createElement(Stepper_1.Stepper, { activeStep: this.emailEntitiesObject.part - 1 },
	                react_1.default.createElement(Stepper_1.Step, null,
	                    react_1.default.createElement(Stepper_1.StepLabel, { className: "mui-stepper-icon-hack" },
	                        " ", "Check (".concat(this.emailEntitiesObject.count, ")"),
	                        " ")),
	                react_1.default.createElement(Stepper_1.Step, null,
	                    react_1.default.createElement(Stepper_1.StepLabel, { className: "mui-stepper-icon-hack" },
	                        " ", "Do send emails (".concat(issuableCount, ")"),
	                        " ")),
	                react_1.default.createElement(Stepper_1.Step, null,
	                    react_1.default.createElement(Stepper_1.StepLabel, { className: "mui-stepper-icon-hack" },
	                        " ", "Done (".concat((this.emailEntitiesObject.part === 3) ? issuableCount : 0, ")"),
	                        "  "))),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: this.$errors }),
	            (this.emailEntitiesObject.part === 1) ?
	                react_1.default.createElement("div", { style: { marginLeft: 10 } },
	                    react_1.default.createElement(fields_1.MdCheckbox, { name: "includeAll", checked: this.emailEntitiesObject.gridParams._includeAll, label: "Include all ".concat(localizedEntitiesName, " (canceled, reopened)"), onCheck: this.onCheckIncludeAll }),
	                    react_1.default.createElement(fields_1.MdCheckbox, { name: "includeSent", checked: this.emailEntitiesObject.gridParams._includeSent, label: "Include already sent ".concat(localizedEntitiesName), onCheck: this.onCheckIncludeSent }))
	                : (react_1.default.createElement("div", { style: { overflowY: 'auto', maxHeight: 500 } },
	                    react_1.default.createElement("table", { className: "table table-condensed fullwrap" },
	                        react_1.default.createElement("tbody", null, this.emailEntitiesObject.entityStatuses.filter(function (is) { return _this.emailEntitiesObject.showErrors || is.status !== 'ERROR'; }).map(function (is, index) {
	                            var _className = (0, dialogAncestor_1.entityStatusCss)(is);
	                            return (react_1.default.createElement("tr", { key: index },
	                                react_1.default.createElement("td", null,
	                                    react_1.default.createElement(react_router_1.Link, { to: entityDetailRoute, params: { id: (0, formUtils_1.lovValue)(is.entityObject) }, query: (0, utils_1.addTenantToQuery)() },
	                                        react_1.default.createElement("span", { className: _className }, (0, formUtils_1.lovLabel)(is.entityObject))),
	                                    (is.messages && is.messages.length) ? (react_1.default.createElement("table", { style: { marginLeft: 20 } },
	                                        react_1.default.createElement("tbody", null, is.messages.map(function (messageObj, index) { return (react_1.default.createElement("tr", { key: index },
	                                            react_1.default.createElement("td", { className: (0, dialogAncestor_1.validationMessageCss)(messageObj) }, messageObj.message))); })))) : null),
	                                react_1.default.createElement("td", { className: _className }, is.emails.join(', ')),
	                                react_1.default.createElement("td", { className: _className }, (0, dialogAncestor_1.entityStatusText)(is))));
	                        })))))));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], EntitiesEmailDialog.prototype, "emailEntitiesObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EntitiesEmailDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EntitiesEmailDialog.prototype, "prepare", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EntitiesEmailDialog.prototype, "ok", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EntitiesEmailDialog.prototype, "close", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EntitiesEmailDialog.prototype, "cancel", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EntitiesEmailDialog.prototype, "onShowErrors", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EntitiesEmailDialog.prototype, "onCheckIncludeSent", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EntitiesEmailDialog.prototype, "onCheckIncludeAll", void 0);
	    EntitiesEmailDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EntitiesEmailDialog);
	    return EntitiesEmailDialog;
	}(dialogAncestor_1.SteppingDialogAncestor));
	exports.default = EntitiesEmailDialog;


/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EntityNumberGenGroupFormDefinition = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var formUtils_1 = __webpack_require__(14);
	var validate_1 = __webpack_require__(24);
	var fields_1 = __webpack_require__(20);
	var closedForm_1 = __webpack_require__(82);
	var createForm_1 = __webpack_require__(18);
	var blockComp_1 = __webpack_require__(30);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var commonDataService_1 = __webpack_require__(41);
	var partyDomain_1 = __webpack_require__(48);
	var rules_1 = __webpack_require__(56);
	var EntityNumberGenGroupForm = /** @class */ (function (_super) {
	    tslib_1.__extends(EntityNumberGenGroupForm, _super);
	    function EntityNumberGenGroupForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onChangeEntity = function (entityLov) {
	            console.log('onChangeEntity');
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject;
	            dataObject.entityName = (0, formUtils_1.lovValue)(entityLov);
	            rootObject.$dirty = true;
	        };
	        return _this;
	    }
	    EntityNumberGenGroupForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity;
	        var fields = dataObject.getFormFields(exports.EntityNumberGenGroupFormDefinition.formName);
	        var name = fields.name, party = fields.party, profitCenterIds = fields.profitCenterIds, invoiceTypeIds = fields.invoiceTypeIds;
	        var openContent = (react_1.default.createElement("form", { style: { marginTop: 10 } },
	            react_1.default.createElement(blockComp_1.BlockComp, null,
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { name: "testEntity", value: { value: dataObject.entityName, label: (0, formUtils_1.lovLabel)(entities.get("MdEntity").getLovItem(dataObject.entityName)) }, floatingLabelText: "Select Entity Type", options: entities.get("MdEntity").lovItems, fullWidth: true, onChange: this.onChangeEntity, clearable: false }))),
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value },
	                            react_1.default.createElement(rules_1.HasLength, { max: 30 }))),
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, party.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.CUSTOMER_ROLE] }), clearable: true })),
	                        react_1.default.createElement(validate_1.Validate, { field: party, value: party.props.value })),
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, profitCenterIds.props, { multi: true, floatingLabelStyle: { top: 15 } })),
	                        react_1.default.createElement(validate_1.Validate, { field: profitCenterIds, value: profitCenterIds.props.value })),
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, invoiceTypeIds.props, { multi: true, floatingLabelStyle: { top: 15 } })),
	                        react_1.default.createElement(validate_1.Validate, { field: invoiceTypeIds, value: invoiceTypeIds.props.value }))))));
	        return openContent;
	    };
	    EntityNumberGenGroupForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EntityNumberGenGroupForm);
	    return EntityNumberGenGroupForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { width: '100%' } },
	        react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields },
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.entityName.textLabel, value: dataObject.entityName }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.name.textLabel, value: dataObject.name }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.party.textLabel, value: dataObject.party, linkProps: { to: 'partyDetail', params: { id: (0, formUtils_1.lovValue)(dataObject.party) } } }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.invoiceTypeIds.textLabel, value: dataObject.invoiceTypeIds }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.profitCenterIds.textLabel, value: dataObject.profitCenterIds }))));
	};
	exports.EntityNumberGenGroupFormDefinition = {
	    formName: 'EntityNumberGenGroupForm',
	    fields: [{
	            name: 'entityName',
	            validators: ['IsRequired']
	        }, {
	            name: 'name',
	            validators: ['IsRequired']
	        }, {
	            name: 'party'
	        }, {
	            name: 'profitCenterIds',
	            omitNullOption: true
	        }, {
	            name: 'invoiceTypeIds',
	            omitNullOption: true
	        },]
	};
	exports.default = (0, createForm_1.createForm)(exports.EntityNumberGenGroupFormDefinition, ClosedContent)(EntityNumberGenGroupForm);


/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var form_1 = __webpack_require__(52);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var blockComp_1 = __webpack_require__(30);
	var validate_1 = __webpack_require__(24);
	var rules_1 = __webpack_require__(56);
	var commonDataService_1 = __webpack_require__(41);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var constants_1 = __webpack_require__(404);
	var InvoiceAdvancedForm = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceAdvancedForm, _super);
	    function InvoiceAdvancedForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = { optionsForNumberGen: [] };
	        _this.recalculate = function (evt) {
	            return _this.props.recalculate(_this.props.dataObject, null, null);
	        };
	        return _this;
	    }
	    InvoiceAdvancedForm.prototype.componentWillMount = function () {
	        var _this = this;
	        var dataObject = this.props.dataObject;
	        (0, commonDataService_1.optionsSearch)(constants_1.ENTITY_NUMBER_GEN_ENTITY, dataObject.getInvoiceParamsForNumberGenSearch(), '*')
	            .then(function (res) {
	            _this.setState({
	                optionsForNumberGen: tslib_1.__spreadArray([{ value: null, label: '---' }], res.options, true),
	            });
	        });
	    };
	    InvoiceAdvancedForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, formName = _a.formName;
	        var _b = dataObject.getFormFields(formName), monetaryRounding = _b.monetaryRounding, internalComment = _b.internalComment, accountingMatchingId = _b.accountingMatchingId, entityNumberGen = _b.entityNumberGen, accountingNumber = _b.accountingNumber, internalOrder = _b.internalOrder, relatedInvoice = _b.relatedInvoice, accountingProfitCenter = _b.accountingProfitCenter, costCenter = _b.costCenter;
	        return (react_1.default.createElement(blockComp_1.BlockComp, null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, accountingProfitCenter.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, costCenter.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, accountingNumber.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, accountingMatchingId.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: accountingMatchingId, value: accountingMatchingId.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, internalOrder.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, relatedInvoice.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, monetaryRounding.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: monetaryRounding, value: monetaryRounding.props.value },
	                        react_1.default.createElement(rules_1.NumberFormat, { precision: 1, scale: 0 }),
	                        react_1.default.createElement(rules_1.Min, { min: 0 }),
	                        react_1.default.createElement(rules_1.Max, { max: 6 }))),
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, entityNumberGen.props, { options: this.state.optionsForNumberGen, clearable: false })))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, internalComment.props, { multiLine: true, rows: 1 }))))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceAdvancedForm.prototype, "recalculate", void 0);
	    InvoiceAdvancedForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'InvoiceAdvancedForm',
	            fields: [{
	                    name: 'monetaryRounding',
	                    validators: ['IsRequired', 'IsNumber']
	                }, {
	                    name: 'internalComment',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	                }, {
	                    name: 'accountingMatchingId'
	                }, {
	                    name: 'entityNumberGen'
	                }, {
	                    name: 'accountingNumber'
	                }, {
	                    name: 'internalOrder'
	                }, {
	                    name: 'relatedInvoice'
	                }, {
	                    name: 'accountingProfitCenter'
	                }, {
	                    name: 'costCenter'
	                }]
	        }, function () { return react_1.default.createElement("noscript", null); }),
	        mobx_react_1.observer
	    ], InvoiceAdvancedForm);
	    return InvoiceAdvancedForm;
	}(react_1.default.Component));
	exports.default = InvoiceAdvancedForm;


/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var form_1 = __webpack_require__(52);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var blockComp_1 = __webpack_require__(30);
	var validate_1 = __webpack_require__(24);
	var commonDataService_1 = __webpack_require__(41);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var partyDomain_1 = __webpack_require__(48);
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var securityDomain_1 = __webpack_require__(97);
	var InvoiceForm = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceForm, _super);
	    function InvoiceForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onInvoiceCurrencySuccess = function () {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            if (dataObject.invoiceCurrency && dataObject.localCurrency) {
	                return _this.props.recalculate(_this.props.dataObject, null, null, { invoiceCurrencyChange: true })
	                    .then(function () {
	                    form.updateFieldsPropValue(dataObject, "exchangeRate");
	                    if (dataObject.getTuple("invoiceCurrencyChange")) {
	                        commonService_1.default.notifyInfo("Exchange rate has changed");
	                    }
	                });
	            }
	            else {
	                dataObject.exchangeRate = null;
	                form.updateFieldsPropValue(dataObject, "exchangeRate");
	            }
	        };
	        _this.recalculate = function (evt) {
	            return _this.props.recalculate(_this.props.dataObject, null, null);
	        };
	        return _this;
	    }
	    InvoiceForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, formName = _a.formName;
	        var _b = dataObject.getFormFields(formName), profitCenter = _b.profitCenter, paymentCond = _b.paymentCond, paymentType = _b.paymentType, invoiceCurrency = _b.invoiceCurrency, language = _b.language, exchangeRate = _b.exchangeRate, comment = _b.comment, issuedBy = _b.issuedBy, sendType = _b.sendType, invoiceAdjustmentKoef = _b.invoiceAdjustmentKoef;
	        var profitCenterOptions = (securityService_1.default.currentUser.hasRestriction(securityDomain_1.RESTRICTION.LIMIT_INVOICE_BY_USER_PROFITCENTER)) ?
	            profitCenter.props.options.filter(function (lv) { return securityService_1.default.restrictionData.userProfitCenterIds.includes(lv.value); }) : profitCenter.props.options;
	        return (react_1.default.createElement(blockComp_1.BlockComp, null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, profitCenter.props, { options: profitCenterOptions })),
	                    react_1.default.createElement(validate_1.Validate, { field: profitCenter, value: profitCenter.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, invoiceCurrency.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: invoiceCurrency, value: invoiceCurrency.props.value, onSuccess: this.onInvoiceCurrencySuccess })),
	                (dataObject.invoiceIsCurrencyDifferent()) ? (react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, exchangeRate.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: exchangeRate, value: exchangeRate.props.value, onSuccess: this.recalculate }))) : null),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, paymentType.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: paymentType, value: paymentType.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, paymentCond.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, issuedBy.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.USER_ROLE] }), clearable: true, asterixForAll: true })))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, invoiceAdjustmentKoef.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: invoiceAdjustmentKoef, value: invoiceAdjustmentKoef.props.value, onSuccess: this.recalculate })),
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, language.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: language, value: language.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, sendType.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: sendType, value: sendType.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props, { multiLine: true, rows: 1 }))))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceForm.prototype, "onInvoiceCurrencySuccess", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceForm.prototype, "recalculate", void 0);
	    InvoiceForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'InvoiceForm',
	            fields: [{
	                    name: 'profitCenter',
	                }, {
	                    name: 'paymentCond'
	                }, {
	                    name: 'paymentType',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'invoiceCurrency',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'language',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'exchangeRate',
	                    validators: ['IsRequired', 'IsNumber']
	                }, {
	                    name: 'invoiceAdjustmentKoef',
	                    validators: ['IsRequired', 'IsNumber']
	                }, {
	                    name: 'issuedBy'
	                }, {
	                    name: 'comment',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	                }, {
	                    name: 'sendType',
	                    validators: ['IsRequired']
	                }]
	        }, function () { return react_1.default.createElement("noscript", null); }),
	        mobx_react_1.observer
	    ], InvoiceForm);
	    return InvoiceForm;
	}(react_1.default.Component));
	exports.default = InvoiceForm;


/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var Toggle_1 = tslib_1.__importDefault(__webpack_require__(362));
	var fields_1 = __webpack_require__(20);
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var mdField_1 = tslib_1.__importStar(__webpack_require__(57));
	var formUtils_1 = __webpack_require__(14);
	var form_1 = __webpack_require__(52);
	var createForm_1 = __webpack_require__(18);
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var styledDateInterval_1 = tslib_1.__importDefault(__webpack_require__(130));
	var validate_1 = __webpack_require__(24);
	var invoiceService_1 = tslib_1.__importStar(__webpack_require__(195));
	var errorComp_1 = __webpack_require__(34);
	var variables_1 = __webpack_require__(96);
	var rules_1 = __webpack_require__(56);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var react_bootstrap_1 = __webpack_require__(72);
	var buttons_1 = __webpack_require__(27);
	var documentComp_1 = tslib_1.__importDefault(__webpack_require__(400));
	var documentService_1 = tslib_1.__importDefault(__webpack_require__(110));
	var mobx_react_1 = __webpack_require__(4);
	var invoiceDomain_1 = __webpack_require__(157);
	var mobx_1 = __webpack_require__(5);
	var partyDomain_1 = __webpack_require__(48);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var eventDomain_1 = __webpack_require__(74);
	var documentDomain_1 = __webpack_require__(109);
	var commonDataService_1 = __webpack_require__(41);
	var dialogAncestor_1 = __webpack_require__(87);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var numberUtils_1 = __webpack_require__(143);
	var colors_1 = __webpack_require__(29);
	var constants_1 = __webpack_require__(404);
	var emailComponents_1 = __webpack_require__(932);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var invoiceSumTable_1 = tslib_1.__importDefault(__webpack_require__(945));
	var InvoiceIssueDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceIssueDialog, _super);
	    function InvoiceIssueDialog(props) {
	        var _this = _super.call(this, props) || this;
	        _this.emailInvoiceToggle = true;
	        _this.showSummary = false;
	        _this._runningOkAction = false;
	        _this.ok = function (send, thruDialog) {
	            console.log('Issuing invoice, send = ' + send);
	            if (_this._runningOkAction)
	                return;
	            var form = invoiceService_1.default.invoiceObject.getForm('InvoiceIssueForm');
	            var res = form.validateForm(invoiceService_1.default.invoiceObject);
	            if (!res) {
	                return;
	            }
	            _this._runningOkAction = true;
	            uiService_1.default.showToolbarActionFlag();
	            if (!invoiceService_1.default.invoiceObject.tupleMap)
	                invoiceService_1.default.invoiceObject.tupleMap = {};
	            invoiceService_1.default.invoiceObject.tupleMap.SEND = send;
	            var invoicePrintWindow;
	            // remove invoice period if it was disabled
	            if (!invoiceService_1.default.invoiceObject.periodicInvoice) {
	                invoiceService_1.default.invoiceObject.startInvoicePeriod = null;
	                invoiceService_1.default.invoiceObject.endInvoicePeriod = null;
	            }
	            invoiceService_1.default.doIssue(invoiceService_1.default.invoiceObject)
	                .then((0, mobx_1.action)("ok-doIssue-actionCb", function (issuedInvoiceJson) {
	                var wasNew = invoiceService_1.default.invoiceObject.cleanAfterSave(issuedInvoiceJson, false);
	                _this.dialogOpen = false;
	                _this.$pristineObject = undefined;
	                _this.resolve(wasNew);
	                _this._runningOkAction = false;
	                // otevru v novem okne
	                if (send === eventDomain_1.SENDTYPE.POST) {
	                    var maxDocumentById = invoiceService_1.default.invoiceObject.documents.filter(function (doc) { return doc.status === documentDomain_1.DOCUMENTSTATUS.VALID; })
	                        .reduce(function (prev, next) { return (prev.documentId > next.documentId) ? prev : next; });
	                    documentService_1.default.printDocument(maxDocumentById.documentUuid);
	                }
	            }), function (error) {
	                _this._runningOkAction = false;
	                _this.$errors = error.getMessages();
	            });
	        };
	        _this.cancel = function (evt) {
	            console.log('InvoiceIssueDialog#cancel evt = %O', evt);
	            _this.dialogOpen = false;
	            invoiceService_1.default.invoiceObject.copyStandardFields(_this.$pristineObject);
	            _this.$pristineObject = undefined;
	            _this.$errors = undefined;
	            //invoiceObject.invoiceNumber = undefined;
	            var grid = invoiceService_1.default.invoiceObject.$movingBlocks.getBlock(invoiceService_1.invoiceItemGridLocation);
	            grid.generateGridData(invoiceService_1.default.invoiceObject);
	            _this.reject("cancel");
	        };
	        _this.cancelKeepChanges = function () {
	            invoiceService_1.default.invoiceObject.$dirty = true;
	            _this.dialogOpen = false;
	            _this.$pristineObject = undefined;
	            _this.$errors = undefined;
	            //invoiceObject.invoiceNumber = undefined;
	            var grid = invoiceService_1.default.invoiceObject.$movingBlocks.getBlock(invoiceService_1.invoiceItemGridLocation);
	            grid.generateGridData(invoiceService_1.default.invoiceObject);
	            _this.reject("cancel");
	        };
	        _this.toNegative = function (doResolve) {
	            var promise = (doResolve) ? invoiceService_1.default.recalculateWithClean(invoiceService_1.default.invoiceObject, { toNegative: true }) : Promise.resolve(true);
	            promise.then(function () {
	                invoiceService_1.default.invoiceObject.$positiveItemResolved = true;
	                _this.showSummary = true;
	            });
	        };
	        _this.toPositive = function (doResolve) {
	            var promise = (doResolve) ? invoiceService_1.default.recalculateWithClean(invoiceService_1.default.invoiceObject, { toPositive: true }) : Promise.resolve(true);
	            promise.then(function () {
	                invoiceService_1.default.invoiceObject.$negativeItemResolved = true;
	                _this.showSummary = true;
	            });
	        };
	        _this.changeExchangeRate = function (doResolve) {
	            if (doResolve) {
	                invoiceService_1.default.invoiceObject.exchangeRate = invoiceService_1.default.invoiceObject.tupleMap.exchangeRate;
	            }
	            var promise = (doResolve) ? invoiceService_1.default.recalculateWithClean(invoiceService_1.default.invoiceObject, {}) : Promise.resolve(true);
	            promise.then(function () {
	                invoiceService_1.default.invoiceObject.$exchangeRateResolved = true;
	                _this.showSummary = true;
	            });
	        };
	        _this.changeVatRate = function (doResolve) {
	            var promise = (doResolve) ? invoiceService_1.default.recalculateWithClean(invoiceService_1.default.invoiceObject, { fixVatRate: true }) : Promise.resolve(true);
	            promise.then(function () {
	                invoiceService_1.default.invoiceObject.$vatRateResolved = true;
	                _this.showSummary = true;
	            });
	        };
	        _this.resolveDifferentValue = function (fieldName, newValue) {
	            invoiceService_1.default.invoiceObject[fieldName] = newValue;
	            invoiceService_1.default.invoiceObject.$differentFields.splice(invoiceService_1.default.invoiceObject.$differentFields.findIndex(function (hof) { return hof.fieldName === fieldName; }), 1);
	        };
	        _this.resolveDifferentInvoice = function () {
	            invoiceService_1.default.invoiceObject.$vehicleOwnersResolved = true;
	        };
	        _this.showSendToggleHandler = function (evt, bulik) {
	            _this.emailInvoiceToggle = bulik;
	        };
	        _this.changeBlockIssueBtn = function (block) {
	            _this.setState({
	                blockIssueBtn: block,
	            });
	        };
	        _this.state = { blockIssueBtn: false };
	        return _this;
	    }
	    InvoiceIssueDialog.prototype.open = function (resolve, reject, invoiceTypeId, fastIssue) {
	        var _this = this;
	        uiService_1.default.showToolbarActionFlag();
	        var entities = this.props.entities;
	        this.resolve = resolve;
	        this.reject = reject;
	        this.$errors = [];
	        this.showSummary = false;
	        this.$pristineObject = invoiceService_1.default.invoiceObject.cloneShallow();
	        invoiceService_1.default.invoiceObject.invoiceType = entities.get('InvoiceType').getLovItem(invoiceTypeId);
	        invoiceService_1.default.invoiceObject.$generateInvoiceNumber = !invoiceService_1.default.invoiceObject.invoiceNumber;
	        if (invoiceService_1.default.invoiceObject.tupleMap && invoiceService_1.default.invoiceObject.tupleMap.EMAILS)
	            invoiceService_1.default.invoiceObject.tupleMap.EMAILS = (0, mobx_1.observable)(invoiceService_1.default.invoiceObject.tupleMap.EMAILS);
	        return invoiceService_1.default.prepareIssue(invoiceService_1.default.invoiceObject)
	            .then((0, mobx_1.action)("open-prepare-assue-actionCb", function (invoiceJson) {
	            // dokumenty nechat puvodni
	            var documents = invoiceService_1.default.invoiceObject.documents;
	            invoiceService_1.default.invoiceObject.fromJson(invoiceJson);
	            invoiceService_1.default.invoiceObject.documents = documents;
	            if (!invoiceService_1.default.invoiceObject.startInvoicePeriod) {
	                invoiceService_1.default.invoiceObject.startInvoicePeriod = (0, moment_1.default)().startOf('month').format("YYYY-MM-DD");
	            }
	            if (!invoiceService_1.default.invoiceObject.endInvoicePeriod) {
	                invoiceService_1.default.invoiceObject.endInvoicePeriod = (0, moment_1.default)().endOf('month').startOf('day').format("YYYY-MM-DD");
	            }
	            if ((0, formUtils_1.isForVatRateCountry)(partyDomain_1.COUNTRY.HU))
	                invoiceService_1.default.invoiceObject.deliveryDate = invoiceService_1.default.invoiceObject.invoiceComputeHuDeliveryDate();
	            var extendedPreferences = securityService_1.default.currentUser.extendedPreferences("Invoice");
	            var enabledInvoiceWarnings = extendedPreferences ? extendedPreferences.enabledInvoiceWarnings : [];
	            Object.assign(invoiceService_1.default.invoiceObject, {
	                $negativeItemExists: enabledInvoiceWarnings.includes(invoiceDomain_1.INVOICEWARNING.negativeItemExists) && ([invoiceDomain_1.INVOICE_TYPE.FI, invoiceDomain_1.INVOICE_TYPE.PR, invoiceDomain_1.INVOICE_TYPE.DP, invoiceDomain_1.INVOICE_TYPE.AD].includes(invoiceTypeId) && invoiceService_1.default.invoiceObject.invoiceNegativeItemExists()),
	                $positiveItemExists: enabledInvoiceWarnings.includes(invoiceDomain_1.INVOICEWARNING.positiveItemExists) && (invoiceTypeId === invoiceDomain_1.INVOICE_TYPE.CN && invoiceService_1.default.invoiceObject.invoicePositiveItemExists()),
	                $negativeItemResolved: false,
	                $positiveItemResolved: false,
	                $exchangeRateResolved: (invoiceTypeId === invoiceDomain_1.INVOICE_TYPE.CN),
	                $exchangeRateDifferent: enabledInvoiceWarnings.includes(invoiceDomain_1.INVOICEWARNING.exchangeRateDifferent) && (invoiceService_1.default.invoiceObject.tupleMap.exchangeRate !== invoiceService_1.default.invoiceObject.exchangeRate),
	                $vatRateResolved: (invoiceTypeId === invoiceDomain_1.INVOICE_TYPE.CN),
	                $vatRateDifferent: enabledInvoiceWarnings.includes(invoiceDomain_1.INVOICEWARNING.differentVatRates) && (invoiceService_1.default.invoiceObject.tupleMap.differentVatRates && invoiceService_1.default.invoiceObject.tupleMap.differentVatRates.length),
	                $vehicleOwners: enabledInvoiceWarnings.includes(invoiceDomain_1.INVOICEWARNING.vehicleOwners) && ((invoiceService_1.default.invoiceObject.tupleMap.vehicleOwners) ? invoiceService_1.default.invoiceObject.tupleMap.vehicleOwners.filter(function (t) { return (0, formUtils_1.lovValue)(t.value1) != (0, formUtils_1.lovValue)(invoiceService_1.default.invoiceObject.billedTo); }) : []),
	                $differentFields: enabledInvoiceWarnings.includes(invoiceDomain_1.INVOICEWARNING.differentFields) && _this.filterDifferentFields(invoiceService_1.default.invoiceObject.tupleMap.differentFields)
	            });
	            uiService_1.default.hideToolbarActionFlag();
	            var thruDialog = !fastIssue || _this.disableIssue(invoiceService_1.default.invoiceObject);
	            if (thruDialog) {
	                _this.dialogOpen = true;
	            }
	            else {
	                var sendType = (0, formUtils_1.lovValue)(invoiceService_1.default.invoiceObject.sendType);
	                return _this.ok(sendType, thruDialog);
	            }
	        }));
	    };
	    /**
	     * If a customer does not have set its default profit centre we cannot take it as a new value
	     */
	    InvoiceIssueDialog.prototype.filterDifferentFields = function (differentFields) {
	        return differentFields.filter(function (hof) {
	            if (hof.fieldName === 'profitCenter')
	                return !!hof.newValue;
	            return true;
	        });
	    };
	    InvoiceIssueDialog.prototype.disableIssue = function (invoiceObject) {
	        return (!invoiceObject.$negativeItemResolved && invoiceObject.$negativeItemExists)
	            || (!invoiceObject.$positiveItemResolved && invoiceObject.$positiveItemExists)
	            || (!invoiceObject.$exchangeRateResolved && invoiceObject.$exchangeRateDifferent)
	            || (!invoiceObject.$vatRateResolved && invoiceObject.$vatRateDifferent)
	            || (invoiceObject.tupleMap.invalidVatRates && invoiceObject.tupleMap.invalidVatRates.length)
	            || (!invoiceObject.$vehicleOwnersResolved && invoiceObject.$vehicleOwners.length)
	            || invoiceObject.$differentFields.length
	            || (invoiceObject.$generateInvoiceNumber && !invoiceObject.entityNumberGen && !invoiceObject.tupleMap.hasEntityNumberGenDefault)
	            || this.state.blockIssueBtn;
	    };
	    InvoiceIssueDialog.prototype.render = function () {
	        var _this = this;
	        var _a;
	        var entities = this.props.entities;
	        if (!(invoiceService_1.default.invoiceObject && this.dialogOpen))
	            return null;
	        var invoiceObject = invoiceService_1.default.invoiceObject;
	        var invoiceEntity = mdEntityService_1.default.getEntity("Invoice");
	        var tupleMap = invoiceService_1.default.invoiceObject.tupleMap;
	        var sendType = (0, formUtils_1.lovValue)(invoiceObject.sendType);
	        var disableIssue = this.disableIssue(invoiceObject);
	        var finalInvoiceRels = invoiceObject.getFinalInvoiceRels();
	        console.debug('this.state %O, disableIssue = %s', this.state, disableIssue);
	        var actions = [
	            (sendType === eventDomain_1.SENDTYPE.POST) ?
	                react_1.default.createElement(buttons_1.ZzSplitButton, { key: 1, title: "Issue", onClick: this.ok.bind(this, null, true), secondary: true, disabled: disableIssue, id: "issue-button" },
	                    react_1.default.createElement(react_bootstrap_1.MenuItem, { eventKey: 0, onSelect: this.ok.bind(this, null, true) }, "Issue"),
	                    react_1.default.createElement(react_bootstrap_1.MenuItem, { eventKey: 1, onSelect: this.ok.bind(this, sendType, true) }, "Issue and print"))
	                :
	                    react_1.default.createElement(FlatButton_1.default, { key: 1, label: "Issue", primary: true, disabled: disableIssue, onClick: this.ok.bind(this, (this.emailInvoiceToggle) ? sendType : null, true) }),
	            react_1.default.createElement(FlatButton_1.default, { key: 2, label: "Cancel", primary: true, onClick: this.cancel }),
	            react_1.default.createElement(FlatButton_1.default, { key: 3, label: "Cancel & keep changes", primary: true, onClick: this.cancelKeepChanges })
	        ];
	        return (react_1.default.createElement(Dialog_1.default, { title: "Issue  ".concat((0, formUtils_1.lovLabel)(invoiceObject.invoiceType)), actions: actions, modal: true, open: this.dialogOpen, autoScrollBodyContent: true, contentStyle: { width: '80%', maxWidth: 800 } },
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: this.$errors }),
	            ((0, formUtils_1.lovValue)(invoiceObject.invoiceType) === invoiceDomain_1.INVOICE_TYPE.CN && !finalInvoiceRels.length) ? (react_1.default.createElement("div", { style: { display: 'flex' } },
	                react_1.default.createElement("h5", { style: { marginRight: 2, color: colors_1.orange500, marginTop: 12 } }, "This Credit Note is not linked to Final Invoice"))) : null,
	            (invoiceObject.$generateInvoiceNumber && !invoiceObject.entityNumberGen && !invoiceObject.tupleMap.hasEntityNumberGenDefault) ? (react_1.default.createElement("div", { style: { display: 'flex' } },
	                react_1.default.createElement("h5", { style: { marginRight: 2, color: colors_1.orange500, marginTop: 12 } }, "There is no default Invoice Number, choose it, please"))) : null,
	            (invoiceObject.$generateInvoiceNumber && invoiceObject.tupleMap.hasSeveralDefaultEntityNumberGen) ? (react_1.default.createElement("div", { style: { display: 'flex' } },
	                react_1.default.createElement("h5", { style: { marginRight: 2, color: colors_1.orange500, marginTop: 12 } }, "There is several default Invoice Numbers, choose one, please"))) : null,
	            (!invoiceObject.$negativeItemResolved && invoiceObject.$negativeItemExists) ? (react_1.default.createElement("div", { style: { display: 'flex' } },
	                react_1.default.createElement("h5", { style: { marginRight: 2, color: colors_1.pink500, marginTop: 12 } }, "There are items with negative quantity or price, "),
	                react_1.default.createElement(FlatButton_1.default, { labelStyle: { fontSize: 16 }, style: { height: 48 }, label: "revert them", primary: true, onClick: this.toPositive.bind(this, true) }),
	                react_1.default.createElement(FlatButton_1.default, { labelStyle: { fontSize: 16 }, style: { height: 48 }, label: "keep them", primary: true, onClick: this.toPositive.bind(this, false) }))) : null,
	            (!invoiceObject.$positiveItemResolved && invoiceObject.$positiveItemExists) ? (react_1.default.createElement("div", { style: { display: 'flex' } },
	                react_1.default.createElement("h5", { style: { marginRight: 2, color: colors_1.pink500, marginTop: 12 } }, "There are items with positive quantity or price, "),
	                react_1.default.createElement(FlatButton_1.default, { labelStyle: { fontSize: 16 }, style: { height: 48 }, label: "revert them", primary: true, onClick: this.toNegative.bind(this, true) }),
	                react_1.default.createElement(FlatButton_1.default, { labelStyle: { fontSize: 16 }, style: { height: 48 }, label: "keep them", primary: true, onClick: this.toNegative.bind(this, false) }))) : null,
	            (!invoiceObject.$exchangeRateResolved && invoiceObject.$exchangeRateDifferent) ? (react_1.default.createElement("div", { style: { display: 'flex', flexWrap: 'wrap' } },
	                react_1.default.createElement("h5", { style: {
	                        marginRight: 2,
	                        color: colors_1.pink500,
	                        marginTop: 12
	                    } }, "Copied exchange rate ".concat(invoiceObject.exchangeRate, " differs from current rate ").concat(invoiceObject.tupleMap.exchangeRate),
	                    " "),
	                react_1.default.createElement(FlatButton_1.default, { labelStyle: { fontSize: 16 }, style: { height: 48 }, label: "Use current", primary: true, onClick: this.changeExchangeRate.bind(this, true) }),
	                react_1.default.createElement(FlatButton_1.default, { labelStyle: { fontSize: 16 }, style: { height: 48 }, label: "Keep existing", primary: true, onClick: this.changeExchangeRate.bind(this, false) }))) : null,
	            (invoiceObject.tupleMap.invalidVatRates && invoiceObject.tupleMap.invalidVatRates.length) ? (react_1.default.createElement("div", { style: { display: 'flex', flexWrap: 'wrap' } },
	                react_1.default.createElement("h5", { style: {
	                        marginRight: 2,
	                        color: colors_1.pink500,
	                        marginTop: 12
	                    } }, "Following VAT Rates are not valid for selected Tax Date: ".concat(invoiceObject.tupleMap.invalidVatRates.join(', ')),
	                    " "))) : null,
	            (!invoiceObject.$vatRateResolved && invoiceObject.$vatRateDifferent) ? (react_1.default.createElement("div", { style: { display: 'flex', flexWrap: 'wrap' } },
	                react_1.default.createElement("h5", { style: {
	                        marginRight: 2,
	                        color: colors_1.pink500,
	                        marginTop: 12
	                    } },
	                    invoiceObject.tupleMap.differentVatRates.join(', '),
	                    " "),
	                react_1.default.createElement(FlatButton_1.default, { labelStyle: { fontSize: 16 }, style: { height: 48 }, label: "Use correct", primary: true, onClick: this.changeVatRate.bind(this, true) }),
	                react_1.default.createElement(FlatButton_1.default, { labelStyle: { fontSize: 16 }, style: { height: 48 }, label: "Keep existing", primary: true, onClick: this.changeVatRate.bind(this, false) }))) : null,
	            (!invoiceObject.$vehicleOwnersResolved && invoiceObject.$vehicleOwners.length) ? (react_1.default.createElement("div", null, invoiceObject.$vehicleOwners.map(function (tuple) { return (react_1.default.createElement("div", { style: { display: 'flex', flexWrap: 'wrap' } },
	                react_1.default.createElement("h5", { style: { marginRight: 2, color: colors_1.pink500, marginTop: 12 } },
	                    "Vehicles ",
	                    tuple.value2.map(function (lov) { return (0, formUtils_1.lovLabel)(lov); }).join(", "),
	                    " have owner ",
	                    (0, formUtils_1.lovLabel)(tuple.value1),
	                    " who differs from invoice customer"),
	                react_1.default.createElement(FlatButton_1.default, { labelStyle: { fontSize: 16 }, style: { height: 48 }, label: "Issue anyways", primary: true, onClick: _this.resolveDifferentInvoice }))); }))) : null,
	            (invoiceObject.$differentFields.length) ? (react_1.default.createElement("div", null, invoiceObject.$differentFields.map(function (hof, index) {
	                var mdField = invoiceEntity.getField(hof.fieldName);
	                return (react_1.default.createElement("div", { key: index, style: { display: 'flex', flexWrap: 'wrap' } },
	                    react_1.default.createElement("h5", { style: { marginRight: 2, color: colors_1.pink500, marginTop: 12 } },
	                        "Field ",
	                        mdField.formLabelActive,
	                        " has outdated value ",
	                        mdField.formatValue(hof.oldValue),
	                        ". New value is ",
	                        mdField.formatValue(hof.newValue)),
	                    react_1.default.createElement(FlatButton_1.default, { labelStyle: { fontSize: 16 }, style: { height: 48 }, label: "Use new", primary: true, onClick: _this.resolveDifferentValue.bind(_this, hof.fieldName, hof.newValue) }),
	                    react_1.default.createElement(FlatButton_1.default, { labelStyle: { fontSize: 16 }, style: { height: 48 }, label: "Keep old", primary: true, onClick: _this.resolveDifferentValue.bind(_this, hof.fieldName, hof.oldValue) })));
	            }))) : null,
	            (invoiceObject.cnOutstanding > 0 && (0, formUtils_1.lovValue)(invoiceObject.invoiceType) === invoiceDomain_1.INVOICE_TYPE.CN) ? (react_1.default.createElement("div", { style: { display: 'flex', flexWrap: 'wrap' } },
	                react_1.default.createElement("h5", { style: {
	                        marginRight: 2,
	                        color: colors_1.indigo500,
	                        marginTop: 12
	                    } }, "Credit Note Amount is higher than Invoice's unsettled amount. ".concat((0, numberUtils_1.formatNumber)(invoiceObject.cnOutstanding, numberUtils_1.DEFAULT_CURRENCY_FORMAT), " will be added to Customer's credit.")))) : null,
	            react_1.default.createElement(InvoiceIssueForm, { entities: entities, entity: entities.get('Invoice'), changeBlockIssueBtn: this.changeBlockIssueBtn, dataObject: invoiceObject, rootObject: invoiceObject }),
	            react_1.default.createElement("div", { style: { display: 'flex', flexWrap: 'wrap', gap: '10px 10px' } },
	                react_1.default.createElement(documentComp_1.default, { documents: invoiceObject.documents, entities: entities, style: { flex: '1 1 auto' }, showFilterFn: documentDomain_1.nonReplacedDocumentFp, enableUpload: invoiceObject.invoiceStatus === invoiceDomain_1.INVOICESTATUS.CONCEPT, rootObject: invoiceObject, documentEntity: entities.get('Document'), canDeleteFn: invoiceDomain_1.canDeleteInvoiceDocument, showIncludeCheckbox: true, defaultAttachmentType: (_a = invoiceObject.billedTo) === null || _a === void 0 ? void 0 : _a.defaultAttachmentType }),
	                this.showSummary && react_1.default.createElement(invoiceSumTable_1.default, { invoiceObject: invoiceObject, entities: mdEntityService_1.default.entityMap, invoiceEntity: invoiceEntity, minimal: true, style: { minWidth: '50%' } })),
	            (sendType === eventDomain_1.SENDTYPE.EMAIL) &&
	                react_1.default.createElement(Toggle_1.default, { label: "Email invoice to customer", toggled: this.emailInvoiceToggle, onToggle: this.showSendToggleHandler, style: { width: "unset", marginTop: 20 }, labelStyle: { marginRight: 10, whiteSpace: 'nowrap' } }),
	            (sendType === eventDomain_1.SENDTYPE.EMAIL) && (this.emailInvoiceToggle) && tupleMap && tupleMap.EMAILS && react_1.default.createElement(emailComponents_1.EmailAddressesEditor, { emails: tupleMap.EMAILS })));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceIssueDialog.prototype, "emailInvoiceToggle", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceIssueDialog.prototype, "showSummary", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceIssueDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceIssueDialog.prototype, "ok", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceIssueDialog.prototype, "cancel", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceIssueDialog.prototype, "cancelKeepChanges", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceIssueDialog.prototype, "toNegative", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceIssueDialog.prototype, "toPositive", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceIssueDialog.prototype, "changeExchangeRate", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceIssueDialog.prototype, "changeVatRate", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceIssueDialog.prototype, "resolveDifferentValue", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceIssueDialog.prototype, "resolveDifferentInvoice", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceIssueDialog.prototype, "showSendToggleHandler", void 0);
	    InvoiceIssueDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], InvoiceIssueDialog);
	    return InvoiceIssueDialog;
	}(dialogAncestor_1.DialogAncestor));
	exports.default = InvoiceIssueDialog;
	var InvoiceIssueForm = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceIssueForm, _super);
	    function InvoiceIssueForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = { servicePeriod: 'thisMonth', defaultEntityNumberGen: null, showNumberGenField: false, optionsForNumberGen: [] };
	        _this.onSuccessInvoiceDate = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, form = _a.form;
	            // dueDateDays
	            console.log('onChangeInvoiceDate ', dataObject.invoiceDate);
	            _this.changeBlockIssueBtn(true);
	            var prepareIssuePromise = Promise.resolve(null);
	            if (dataObject.invoiceDate) {
	                dataObject.taxDate = dataObject.invoiceDate;
	                if ((0, formUtils_1.isForVatRateCountry)(partyDomain_1.COUNTRY.HU))
	                    dataObject.deliveryDate = dataObject.invoiceComputeHuDeliveryDate();
	                if (_this.state.showNumberGenField)
	                    dataObject.entityNumberGen = null;
	                prepareIssuePromise = _this.prepareIssue()
	                    .then(function () {
	                    var showNumberGenField = _this.updateShowNumberGenFieldValue(dataObject);
	                    if (showNumberGenField) {
	                        (0, commonDataService_1.optionsSearch)(constants_1.ENTITY_NUMBER_GEN_ENTITY, _this.getNumberGenLoadOptionParams(), '*')
	                            .then(function (res) {
	                            var firstNumberGen = dataObject.tupleMap.hasEntityNumberGenDefault === false ? null : res.options[0];
	                            if (dataObject.$generateInvoiceNumber)
	                                dataObject.entityNumberGen = firstNumberGen;
	                            _this.setState({
	                                defaultEntityNumberGen: firstNumberGen,
	                                optionsForNumberGen: res.options
	                            });
	                            form.updateFieldsPropValue(dataObject, "entityNumberGen");
	                        });
	                    }
	                });
	            }
	            return prepareIssuePromise.then((0, mobx_1.action)("prepareIssuePromise-actionCb", function () {
	                rootObject.$dirty = true;
	                form.updateAllFieldsPropValue(dataObject);
	                _this.changeBlockIssueBtn(false);
	            }));
	        };
	        _this.onSuccessTaxDate = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, form = _a.form;
	            console.log('onChangeTaxDate ', dataObject.taxDate);
	            var prepareIssuePromise = Promise.resolve(null);
	            if (dataObject.taxDate) {
	                if ([invoiceDomain_1.INVOICE_TYPE.FI, invoiceDomain_1.INVOICE_TYPE.PR, invoiceDomain_1.INVOICE_TYPE.DP].includes((0, formUtils_1.lovValue)(dataObject.invoiceType))) {
	                    prepareIssuePromise = _this.prepareIssue();
	                }
	            }
	            return prepareIssuePromise.then((0, mobx_1.action)("prepareIssuePromise-actionCb", function () {
	                rootObject.$dirty = true;
	            }));
	        };
	        _this.onGenerateInvoiceNumberCheck = function (evt) {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            form.getField("$generateInvoiceNumber").props.onCheck(evt); //changing state of $generateInvoiceNumber
	            console.log("onGenerateInvoiceNumberCheck dataObject.$generateInvoiceNumber = " + dataObject.$generateInvoiceNumber);
	            if (dataObject.invoiceNumber)
	                _this.oldInvoiceNumber = dataObject.invoiceNumber;
	            dataObject.invoiceNumber = (dataObject.$generateInvoiceNumber) ? null : _this.oldInvoiceNumber;
	            form.getField("invoiceNumber").valid = true;
	            if (_this.state.showNumberGenField) {
	                dataObject.entityNumberGen = dataObject.$generateInvoiceNumber ? _this.state.defaultEntityNumberGen : null;
	                form.getField("entityNumberGen").valid = true;
	            }
	            form.updateFieldsPropValue(dataObject, "invoiceNumber", "entityNumberGen");
	        };
	        _this.getNumberGenLoadOptionParams = function () {
	            var dataObject = _this.props.dataObject;
	            return dataObject.tupleMap.hasEntityNumberGenDefault ? tslib_1.__assign(tslib_1.__assign({}, dataObject.getInvoiceParamsForNumberGenSearch()), { partyId: dataObject.billedTo.value, invoiceTypeId: dataObject.invoiceType.value, profitCenterId: dataObject.profitCenter.value }) :
	                dataObject.getInvoiceParamsForNumberGenSearch();
	        };
	        _this.changeBlockIssueBtn = function (block) {
	            _this.props.changeBlockIssueBtn(block);
	        };
	        return _this;
	    }
	    InvoiceIssueForm.prototype.componentWillMount = function () {
	        var _this = this;
	        var _a = this.props, dataObject = _a.dataObject, form = _a.form;
	        var showNumberGenField = this.updateShowNumberGenFieldValue(dataObject);
	        if (showNumberGenField) {
	            (0, commonDataService_1.optionsSearch)(constants_1.ENTITY_NUMBER_GEN_ENTITY, this.getNumberGenLoadOptionParams(), '*')
	                .then(function (res) {
	                var firstNumberGen = dataObject.tupleMap.hasEntityNumberGenDefault === false ? null : res.options[0];
	                dataObject.entityNumberGen = firstNumberGen;
	                _this.setState({
	                    defaultEntityNumberGen: firstNumberGen,
	                    optionsForNumberGen: res.options
	                });
	                form.updateFieldsPropValue(dataObject, "entityNumberGen");
	            });
	        }
	    };
	    InvoiceIssueForm.prototype.updateShowNumberGenFieldValue = function (dataObject) {
	        var showNumberGenField = !dataObject.entityNumberGen && (!dataObject.tupleMap.hasEntityNumberGenDefault || dataObject.tupleMap.hasSeveralDefaultEntityNumberGen);
	        this.setState({
	            showNumberGenField: showNumberGenField
	        });
	        return showNumberGenField;
	    };
	    InvoiceIssueForm.prototype.prepareIssue = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject;
	        return invoiceService_1.default.prepareIssue(dataObject)
	            .then((0, mobx_1.action)("prepareIssue-actionCb", function (newInvoiceJson) {
	            var newInvoice = new invoiceDomain_1.Invoice(newInvoiceJson);
	            dataObject.tupleMap.exchangeRate = newInvoice.tupleMap.exchangeRate;
	            dataObject.tupleMap.differentVatRates = newInvoice.tupleMap.differentVatRates;
	            dataObject.tupleMap.invalidVatRates = newInvoice.tupleMap.invalidVatRates;
	            dataObject.cnOutstanding = newInvoice.cnOutstanding;
	            dataObject.tupleMap.hasEntityNumberGenDefault = newInvoice.tupleMap.hasEntityNumberGenDefault;
	            dataObject.tupleMap.hasSeveralDefaultEntityNumberGen = newInvoice.tupleMap.hasSeveralDefaultEntityNumberGen;
	            dataObject.$exchangeRateDifferent = (dataObject.tupleMap.exchangeRate !== dataObject.exchangeRate);
	            dataObject.$exchangeRateResolved = ((0, formUtils_1.lovValue)(dataObject.invoiceType) === invoiceDomain_1.INVOICE_TYPE.CN);
	            dataObject.$vatRateDifferent = (dataObject.tupleMap.differentVatRates && dataObject.tupleMap.differentVatRates.length);
	            dataObject.dueDate = newInvoice.dueDate;
	        }));
	    };
	    InvoiceIssueForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, index = _a.index, formName = _a.formName;
	        var _b = dataObject.getFormFields(formName), invoiceNumber = _b.invoiceNumber, invoiceDate = _b.invoiceDate, taxDate = _b.taxDate, dueDate = _b.dueDate, deliveryDate = _b.deliveryDate, $generateInvoiceNumber = _b.$generateInvoiceNumber, startInvoicePeriod = _b.startInvoicePeriod, endInvoicePeriod = _b.endInvoicePeriod, periodicInvoice = _b.periodicInvoice, entityNumberGen = _b.entityNumberGen;
	        var invoiceNumberStyle = (dataObject.$generateInvoiceNumber) ? { visibility: 'hidden' } : {};
	        var finalInvoiceRels = dataObject.getFinalInvoiceRels();
	        return (react_1.default.createElement("form", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "col-xs-11" },
	                            react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, $generateInvoiceNumber.props, { onCheck: this.onGenerateInvoiceNumberCheck })))),
	                    react_1.default.createElement("div", { className: "row" },
	                        (dataObject.$generateInvoiceNumber) ? ((this.state.showNumberGenField) ? (react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, entityNumberGen.props, { 
	                                // loadOptions={optionsSearch.bind(this, ENTITY_NUMBER_GEN_ENTITY, this.getNumberGenLoadOptionParams())}
	                                options: this.state.optionsForNumberGen, clearable: false })),
	                            react_1.default.createElement(validate_1.Validate, { field: entityNumberGen, value: entityNumberGen.props.value },
	                                react_1.default.createElement(rules_1.IsRequired, null)))) : (react_1.default.createElement("div", { className: "col-xs-12 col-sm-6", style: { height: variables_1.FIELD_HEIGHT } }))) : (react_1.default.createElement("div", { className: "col-xs-12 col-sm-6", style: invoiceNumberStyle },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, invoiceNumber.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: invoiceNumber, value: invoiceNumber.props.value },
	                                react_1.default.createElement(rules_1.IsRequired, null)))),
	                        ((0, formUtils_1.lovValue)(dataObject.invoiceType) === invoiceDomain_1.INVOICE_TYPE.CN) ? (react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" }, finalInvoiceRels.map(function (ir) { return (react_1.default.createElement("div", null, (0, formUtils_1.lovLabel)(ir.toInvoice))); }))) : null),
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "col-xs-11" },
	                            react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, periodicInvoice.props, { style: { height: 30, marginTop: 10 } })))),
	                    dataObject.periodicInvoice &&
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "col-xs-10" },
	                                react_1.default.createElement(styledDateInterval_1.default, tslib_1.__assign({}, startInvoicePeriod.props, { valueFrom: startInvoicePeriod.props.value, valueTo: endInvoicePeriod.props.value, onChangeFrom: startInvoicePeriod.props.onChange, onChangeTo: endInvoicePeriod.props.onChange }))))),
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "col-xs-10 col-sm-5 col-sm-offset-1" },
	                            react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, invoiceDate.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: invoiceDate, value: invoiceDate.props.value, onSuccess: this.onSuccessInvoiceDate })),
	                        react_1.default.createElement("div", { className: "col-xs-10 col-sm-5 col-sm-offset-1" },
	                            react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, deliveryDate.props)))),
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "col-xs-10 col-sm-5 col-sm-offset-1" },
	                            react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, taxDate.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: taxDate, value: taxDate.props.value, onSuccess: this.onSuccessTaxDate })),
	                        react_1.default.createElement("div", { className: "col-xs-10 col-sm-5 col-sm-offset-1" },
	                            react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, dueDate.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: dueDate, value: dueDate.props.value })))))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceIssueForm.prototype, "onSuccessInvoiceDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceIssueForm.prototype, "onSuccessTaxDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceIssueForm.prototype, "prepareIssue", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceIssueForm.prototype, "onGenerateInvoiceNumberCheck", void 0);
	    InvoiceIssueForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'InvoiceIssueForm',
	            fields: [{
	                    name: 'invoiceDate',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'taxDate',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'dueDate',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'invoiceNumber'
	                }, {
	                    name: 'deliveryDate'
	                }, {
	                    name: 'startInvoicePeriod'
	                }, {
	                    name: 'endInvoicePeriod'
	                }, {
	                    name: 'entityNumberGen'
	                }, {
	                    name: 'periodicInvoice'
	                }, {
	                    name: '$generateInvoiceNumber',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.checkbox,
	                    mdField: new mdField_1.default({ label: 'Generate Invoice Number', dataType: mdField_1.DATATYPE.BOOLEAN })
	                }]
	        }, function () { return react_1.default.createElement("noscript", null); }),
	        mobx_react_1.observer
	    ], InvoiceIssueForm);
	    return InvoiceIssueForm;
	}(react_1.default.Component));


/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var round = __webpack_require__(732);
	var createForm_1 = __webpack_require__(18);
	var formUtils_1 = __webpack_require__(14);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var validate_1 = __webpack_require__(24);
	var rules_1 = __webpack_require__(56);
	var commonDataService_1 = __webpack_require__(41);
	var invoiceService_1 = tslib_1.__importDefault(__webpack_require__(195));
	var productService_1 = tslib_1.__importDefault(__webpack_require__(131));
	var productUtils_1 = __webpack_require__(405);
	var invoiceDomain_1 = __webpack_require__(157);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var FaUser = __webpack_require__(849);
	var partyDomain_1 = __webpack_require__(48);
	var InvoiceItemForm = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceItemForm, _super);
	    function InvoiceItemForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onBasePriceChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onBasePriceChange ', dataObject.basePrice);
	            dataObject.adjustmentAmount = round(dataObject.basePrice * dataObject.adjustmentKoef, rootObject.monetaryRounding);
	            _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	            rootObject.$dirty = true;
	            form.updateAllFieldsPropValue(dataObject);
	        };
	        _this.onAdjustmentKoefChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onAdjustmentKoefChange ', dataObject.adjustmentKoef);
	            dataObject.adjustmentAmount = round(dataObject.adjustmentKoef * dataObject.basePrice, rootObject.monetaryRounding);
	            _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	            rootObject.$dirty = true;
	            form.updateAllFieldsPropValue(dataObject);
	        };
	        _this.onAdjustmentAmountChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onAdjustmentAmountChange ', dataObject.adjustmentAmount);
	            dataObject.adjustmentKoef = round(dataObject.adjustmentAmount / dataObject.basePrice, rootObject.monetaryRounding);
	            _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	            rootObject.$dirty = true;
	            form.updateAllFieldsPropValue(dataObject);
	        };
	        _this.onPriceWithoutVatChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onPriceWithoutVatChange ', dataObject.priceWithoutVat);
	            dataObject.basePriceWithAdjustment = round(dataObject.priceWithoutVat / (1 + rootObject.invoiceAdjustmentKoef), rootObject.monetaryRounding);
	            dataObject.basePrice = round(dataObject.basePriceWithAdjustment / (1 + dataObject.adjustmentKoef), rootObject.monetaryRounding);
	            dataObject.adjustmentAmount = dataObject.basePriceWithAdjustment - dataObject.basePrice;
	            dataObject.invoiceAdjustmentAmount = dataObject.priceWithoutVat - dataObject.basePriceWithAdjustment;
	            dataObject.vatAmount = round(dataObject.priceWithoutVat * dataObject.vatRate, rootObject.monetaryRounding);
	            dataObject.itemPrice = dataObject.priceWithoutVat + dataObject.vatAmount;
	            rootObject.$dirty = true;
	            form.updateAllFieldsPropValue(dataObject);
	        };
	        _this.onItemPriceChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onItemPriceChange ', dataObject.itemPrice);
	            dataObject.priceWithoutVat = round(dataObject.itemPrice / (1 + dataObject.vatRate), rootObject.monetaryRounding);
	            dataObject.vatAmount = dataObject.itemPrice - dataObject.priceWithoutVat;
	            dataObject.basePriceWithAdjustment = round(dataObject.priceWithoutVat / (1 + rootObject.invoiceAdjustmentKoef), rootObject.monetaryRounding);
	            dataObject.basePrice = round(dataObject.basePriceWithAdjustment / (1 + dataObject.adjustmentKoef), rootObject.monetaryRounding);
	            dataObject.adjustmentAmount = dataObject.basePriceWithAdjustment - dataObject.basePrice;
	            dataObject.invoiceAdjustmentAmount = dataObject.priceWithoutVat - dataObject.basePriceWithAdjustment;
	            rootObject.$dirty = true;
	            form.updateAllFieldsPropValue(dataObject);
	        };
	        _this.onVatRateRefChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onVatRateRefChange ', dataObject.vatRateRef);
	            var vatRateId = (0, formUtils_1.lovValue)(dataObject.vatRateRef);
	            return ((vatRateId != null) ? invoiceService_1.default.vatRateValue(vatRateId) : Promise.resolve(null))
	                .then((0, mobx_1.action)("vatRateValue-actionCb", function (value) {
	                dataObject.vatRate = value;
	                _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	                rootObject.$dirty = true;
	                form.updateAllFieldsPropValue(dataObject);
	            }));
	        };
	        _this.onProductChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onProductChange ', dataObject.product);
	            var productId = (0, formUtils_1.lovValue)(dataObject.product);
	            if (productId == null) {
	                dataObject.vatRate = null;
	                _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	                rootObject.$dirty = true;
	                form.updateAllFieldsPropValue(dataObject);
	            }
	            else {
	                var capturedProduct_1;
	                var vatRateValuePromise = productService_1.default.readProduct(productId, (0, formUtils_1.lovValue)(rootObject.billedFrom), (0, formUtils_1.lovValue)(rootObject.billedTo))
	                    .then(function (product) {
	                    capturedProduct_1 = product;
	                    var vatRateId = (0, formUtils_1.lovValue)(product.vatRate);
	                    return ((vatRateId != null) ? invoiceService_1.default.vatRateValue(vatRateId) : Promise.resolve(null));
	                });
	                var vehicleId = (0, formUtils_1.lovValue)(dataObject.vehicle);
	                var pricePromise = (vehicleId == null) ? productService_1.default.readProductPrice(productId, (0, formUtils_1.lovValue)(rootObject.billedTo), (0, formUtils_1.lovValue)(rootObject.invoiceCurrency))
	                    : productService_1.default.readProductVehiclePrice(productId, vehicleId, (0, formUtils_1.lovValue)(rootObject.billedTo), (0, formUtils_1.lovValue)(rootObject.invoiceCurrency));
	                return Promise.all([vatRateValuePromise, pricePromise])
	                    .then((0, mobx_1.action)("productChange-actionCb", function (_a) {
	                    var vatRateValue = _a[0], price = _a[1];
	                    if (capturedProduct_1.unitOfMeasure)
	                        dataObject.unitOfMeasure = capturedProduct_1.unitOfMeasure;
	                    dataObject.vatRateRef = capturedProduct_1.vatRate;
	                    dataObject.vatRate = vatRateValue;
	                    dataObject.unitPrice = (0, productUtils_1.priceValue)(price);
	                    dataObject.description = capturedProduct_1.name;
	                    dataObject.productNumber = capturedProduct_1.productNumber;
	                    dataObject.taxType = capturedProduct_1.taxType;
	                    dataObject.basePrice = dataObject.unitPrice * dataObject.quantity;
	                    _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	                    rootObject.$dirty = true;
	                    form.updateAllFieldsPropValue(dataObject);
	                }));
	            }
	        };
	        _this.onVehicleChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onVehicleChange ', dataObject.vehicle);
	            var vehicleId = (0, formUtils_1.lovValue)(dataObject.vehicle);
	            var productId = (0, formUtils_1.lovValue)(dataObject.product);
	            if (vehicleId == null || productId == null) {
	                rootObject.$dirty = true;
	                form.updateAllFieldsPropValue(dataObject);
	            }
	            else {
	                return productService_1.default.readProductVehiclePrice(productId, vehicleId, (0, formUtils_1.lovValue)(rootObject.billedTo), (0, formUtils_1.lovValue)(rootObject.invoiceCurrency))
	                    .then((0, mobx_1.action)("vehicleChange-actionCb", function (price) {
	                    dataObject.unitPrice = (0, productUtils_1.priceValue)(price);
	                    dataObject.basePrice = dataObject.unitPrice * dataObject.quantity;
	                    _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	                    rootObject.$dirty = true;
	                    form.updateAllFieldsPropValue(dataObject);
	                }));
	            }
	        };
	        _this.onUnitPriceChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onUnitPriceChange ', dataObject.unitPrice);
	            dataObject.basePrice = dataObject.unitPrice * dataObject.quantity;
	            dataObject.adjustmentAmount = round(dataObject.basePrice * dataObject.adjustmentKoef, rootObject.monetaryRounding);
	            _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	            rootObject.$dirty = true;
	            form.updateAllFieldsPropValue(dataObject);
	        };
	        _this.onQuantityChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onQuantityChange ', dataObject.quantity);
	            dataObject.basePrice = dataObject.unitPrice * dataObject.quantity;
	            dataObject.adjustmentAmount = round(dataObject.basePrice * dataObject.adjustmentKoef, rootObject.monetaryRounding);
	            _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	            rootObject.$dirty = true;
	            form.updateAllFieldsPropValue(dataObject);
	        };
	        _this.onShowParty = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onShowParty ', dataObject.quantity);
	            _this.$showParty = true;
	        };
	        return _this;
	    }
	    InvoiceItemForm.prototype.computeDerived = function (dataObject, rootObject, precision) {
	        dataObject.basePriceWithAdjustment = dataObject.basePrice + dataObject.adjustmentAmount;
	        dataObject.invoiceAdjustmentAmount = round(dataObject.basePriceWithAdjustment * rootObject.invoiceAdjustmentKoef, precision);
	        dataObject.priceWithoutVat = dataObject.basePriceWithAdjustment + dataObject.invoiceAdjustmentAmount;
	        dataObject.vatAmount = round(dataObject.priceWithoutVat * dataObject.vatRate, precision);
	        dataObject.itemPrice = dataObject.priceWithoutVat + dataObject.vatAmount;
	    };
	    InvoiceItemForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, formName = _a.formName;
	        var fields = dataObject.getFormFields(formName);
	        var product = fields.product, vehicle = fields.vehicle, productNumber = fields.productNumber, description = fields.description, unitOfMeasure = fields.unitOfMeasure, quantity = fields.quantity, unitPrice = fields.unitPrice, basePrice = fields.basePrice, adjustmentKoef = fields.adjustmentKoef, adjustmentAmount = fields.adjustmentAmount, priceWithoutVat = fields.priceWithoutVat, vatAmount = fields.vatAmount, itemPrice = fields.itemPrice, vatRate = fields.vatRate, vatRateRef = fields.vatRateRef, invoiceAdjustmentAmount = fields.invoiceAdjustmentAmount, taxType = fields.taxType, comment = fields.comment, party = fields.party;
	        console.debug("InvoiceItemForm#render() %O", dataObject);
	        var formComp = null;
	        switch ((0, formUtils_1.lovValue)(dataObject.itemType)) {
	            case invoiceDomain_1.INVOICEITEMTYPE.FREEITEM:
	                formComp = (react_1.default.createElement("div", null,
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-8" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, description.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: description, value: description.props.value })),
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, vatRateRef.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: vatRateRef, value: vatRateRef.props.value, onSuccess: this.onVatRateRefChange }),
	                            react_1.default.createElement(formUtils_1.FieldText, { label: "", style: { alignSelf: 'flex-end', paddingBottom: 10 }, value: dataObject.vatRate, mdField: vatRate.mdField })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, basePrice.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: basePrice, value: basePrice.props.value, onSuccess: this.onBasePriceChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, adjustmentKoef.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: adjustmentKoef, value: adjustmentKoef.props.value, onSuccess: this.onAdjustmentKoefChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, adjustmentAmount.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: adjustmentAmount, value: adjustmentAmount.props.value, onSuccess: this.onAdjustmentAmountChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, priceWithoutVat.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: priceWithoutVat, value: priceWithoutVat.props.value, onSuccess: this.onPriceWithoutVatChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, vatAmount.props, { disabled: true }))),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, itemPrice.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: itemPrice, value: itemPrice.props.value, onSuccess: this.onItemPriceChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, taxType.props))),
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: comment, value: comment.props.value },
	                                react_1.default.createElement(rules_1.HasLength, { max: 150 }))))));
	                break;
	            case invoiceDomain_1.INVOICEITEMTYPE.PRODUCTITEM:
	                formComp = (react_1.default.createElement("div", null,
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "fx col-xs-8 col-sm-4" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, product.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Product', {}), clearable: true, asterixForAll: true })),
	                            react_1.default.createElement(validate_1.Validate, { field: product, value: product.props.value, onSuccess: this.onProductChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-2" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, productNumber.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: productNumber, value: productNumber.props.value })),
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, description.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: description, value: description.props.value })),
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, vatRateRef.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: vatRateRef, value: vatRateRef.props.value, onSuccess: this.onVatRateRefChange }),
	                            react_1.default.createElement(formUtils_1.FieldText, { label: "", style: { alignSelf: 'flex-end', paddingBottom: 10 }, value: dataObject.vatRate, mdField: vatRate.mdField })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, unitPrice.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: unitPrice, value: unitPrice.props.value, onSuccess: this.onUnitPriceChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, quantity.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: quantity, value: quantity.props.value, onSuccess: this.onQuantityChange },
	                                react_1.default.createElement(rules_1.NumberFormat, { precision: 10, scale: 3 }))),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, unitOfMeasure.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: unitOfMeasure, value: unitOfMeasure.props.value })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, basePrice.props, { disabled: true }))),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, adjustmentKoef.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: adjustmentKoef, value: adjustmentKoef.props.value, onSuccess: this.onAdjustmentKoefChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, adjustmentAmount.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: adjustmentAmount, value: adjustmentAmount.props.value, onSuccess: this.onAdjustmentAmountChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, taxType.props))),
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: comment, value: comment.props.value },
	                                react_1.default.createElement(rules_1.HasLength, { max: 150 })),
	                            react_1.default.createElement(FaUser, { className: "active-item--check zz-ml-15", style: { alignSelf: "center" }, size: 18, onClick: this.onShowParty })),
	                        (!!this.$showParty || party.props.value) &&
	                            react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, party.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.EMPLOYEE] }), clearable: true, asterixForAll: true })))),
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6", style: { display: 'flex', alignItems: 'center', flexWrap: 'wrap' } },
	                            (dataObject.invoiceAdjustmentAmount) ? react_1.default.createElement(formUtils_1.FieldText, { label: invoiceAdjustmentAmount.textLabel, value: dataObject.invoiceAdjustmentAmount, mdField: invoiceAdjustmentAmount.mdField }) : null,
	                            react_1.default.createElement(formUtils_1.FieldText, { label: priceWithoutVat.textLabel, value: dataObject.priceWithoutVat, mdField: priceWithoutVat.mdField }),
	                            react_1.default.createElement(formUtils_1.FieldText, { label: vatAmount.textLabel, value: dataObject.vatAmount, mdField: vatAmount.mdField }),
	                            react_1.default.createElement(formUtils_1.FieldText, { label: itemPrice.textLabel, value: dataObject.itemPrice, mdField: itemPrice.mdField })))));
	                break;
	            case invoiceDomain_1.INVOICEITEMTYPE.PRODUCTVEHICLEITEM:
	                var billedToId = (0, formUtils_1.lovValue)(rootObject.billedTo);
	                formComp = (react_1.default.createElement("div", null,
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "fx col-xs-8 col-sm-4" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, product.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Product', {}), clearable: true, asterixForAll: true })),
	                            react_1.default.createElement(validate_1.Validate, { field: product, value: product.props.value, onSuccess: this.onProductChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-4" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, productNumber.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: productNumber, value: productNumber.props.value })),
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, vehicle.props, { minimumInput: 0, asterixForAll: true, async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Vehicle', { partyId: billedToId }), advancedSearchGL: "invoiceItemVehicleSearch", advancedSearchMasterId: billedToId })),
	                            react_1.default.createElement(validate_1.Validate, { field: vehicle, value: vehicle.props.value, onSuccess: this.onVehicleChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, description.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: description, value: description.props.value })),
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, vatRateRef.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: vatRateRef, value: vatRateRef.props.value, onSuccess: this.onVatRateRefChange }),
	                            react_1.default.createElement(formUtils_1.FieldText, { label: "", style: { alignSelf: 'flex-end', paddingBottom: 10 }, value: dataObject.vatRate, mdField: vatRate.mdField })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, unitPrice.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: unitPrice, value: unitPrice.props.value, onSuccess: this.onUnitPriceChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, quantity.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: quantity, value: quantity.props.value, onSuccess: this.onQuantityChange },
	                                react_1.default.createElement(rules_1.NumberFormat, { precision: 10, scale: 0 }))),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, unitOfMeasure.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: unitOfMeasure, value: unitOfMeasure.props.value })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, basePrice.props, { disabled: true }))),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, adjustmentKoef.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: adjustmentKoef, value: adjustmentKoef.props.value, onSuccess: this.onAdjustmentKoefChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, adjustmentAmount.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: adjustmentAmount, value: adjustmentAmount.props.value, onSuccess: this.onAdjustmentAmountChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, taxType.props))),
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: comment, value: comment.props.value },
	                                react_1.default.createElement(rules_1.HasLength, { max: 150 })))),
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6", style: { display: 'flex', alignItems: 'center', flexWrap: 'wrap' } },
	                            (dataObject.invoiceAdjustmentAmount) ? react_1.default.createElement(formUtils_1.FieldText, { label: invoiceAdjustmentAmount.textLabel, value: dataObject.invoiceAdjustmentAmount, mdField: invoiceAdjustmentAmount.mdField }) : null,
	                            react_1.default.createElement(formUtils_1.FieldText, { label: priceWithoutVat.textLabel, value: dataObject.priceWithoutVat, mdField: priceWithoutVat.mdField }),
	                            react_1.default.createElement(formUtils_1.FieldText, { label: vatAmount.textLabel, value: dataObject.vatAmount, mdField: vatAmount.mdField }),
	                            react_1.default.createElement(formUtils_1.FieldText, { label: itemPrice.textLabel, value: dataObject.itemPrice, mdField: itemPrice.mdField })))));
	                break;
	        }
	        return formComp;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceItemForm.prototype, "$showParty", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceItemForm.prototype, "onBasePriceChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceItemForm.prototype, "onAdjustmentKoefChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceItemForm.prototype, "onAdjustmentAmountChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceItemForm.prototype, "onPriceWithoutVatChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceItemForm.prototype, "onItemPriceChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceItemForm.prototype, "onVatRateRefChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceItemForm.prototype, "onProductChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceItemForm.prototype, "onVehicleChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceItemForm.prototype, "onUnitPriceChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceItemForm.prototype, "onQuantityChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceItemForm.prototype, "onShowParty", void 0);
	    InvoiceItemForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], InvoiceItemForm);
	    return InvoiceItemForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, setDataAction = _a.setDataAction, fields = _a.fields;
	    return (react_1.default.createElement("div", null,
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.product.textLabel, value: dataObject.product }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.productNumber.textLabel, value: dataObject.productNumber }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.vehicle.textLabel, value: dataObject.vehicle }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.party.textLabel, value: dataObject.party })),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.description.textLabel, value: dataObject.description }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.comment.textLabel, value: dataObject.comment })),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.unitPrice.textLabel, value: dataObject.unitPrice, mdField: fields.unitPrice.mdField }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.quantity.textLabel, value: dataObject.quantity, mdField: fields.quantity.mdField }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.unitOfMeasure.textLabel, value: dataObject.unitOfMeasure }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.basePrice.textLabel, value: dataObject.basePrice, mdField: fields.basePrice.mdField }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.adjustmentKoef.textLabel, value: dataObject.adjustmentKoef, mdField: fields.adjustmentKoef.mdField }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.adjustmentAmount.textLabel, value: dataObject.adjustmentAmount, mdField: fields.adjustmentAmount.mdField })),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.vatRateRef.textLabel, value: dataObject.vatRateRef }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.vatRate.textLabel, value: dataObject.vatRate, mdField: fields.vatRate.mdField }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.priceWithoutVat.textLabel, value: dataObject.priceWithoutVat, mdField: fields.priceWithoutVat.mdField }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.vatAmount.textLabel, value: dataObject.vatAmount, mdField: fields.vatAmount.mdField }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.itemPrice.textLabel, value: dataObject.itemPrice, mdField: fields.itemPrice.mdField }))));
	};
	var definition = {
	    formName: 'InvoiceItemForm',
	    fields: [{
	            name: 'product',
	            validators: ['IsRequired']
	        }, {
	            name: 'vehicle',
	            validators: ['IsRequired']
	        }, {
	            name: 'productNumber',
	            validators: ['IsRequired']
	        }, {
	            name: 'description',
	            validators: ['IsRequired']
	        }, {
	            name: 'unitOfMeasure',
	            validators: ['IsRequired']
	        }, {
	            name: 'quantity',
	            validators: ['IsNumber', 'IsRequired']
	        }, {
	            name: 'unitPrice',
	            validators: ['IsNumber', 'IsRequired']
	        }, {
	            name: 'basePrice',
	            validators: ['IsRequired', 'IsNumber']
	        }, {
	            name: 'adjustmentKoef',
	            validators: ['IsRequired', 'IsNumber'],
	            numberFormat: '0[.][00000000]%'
	        }, {
	            name: 'adjustmentAmount',
	            validators: ['IsRequired', 'IsNumber']
	        }, {
	            name: 'vatRateRef',
	            validators: ['IsRequired']
	        }, {
	            name: 'priceWithoutVat',
	            validators: ['IsRequired']
	        }, {
	            name: 'vatAmount',
	            validators: ['IsRequired']
	        }, {
	            name: 'itemPrice',
	            validators: ['IsRequired']
	        }, {
	            name: 'vatRate'
	        }, {
	            name: 'invoiceAdjustmentAmount'
	        }, {
	            name: 'comment'
	        }, {
	            name: 'taxType'
	        }, {
	            name: 'party'
	        }]
	};
	exports.default = (0, createForm_1.createForm)(definition, ClosedContent)(InvoiceItemForm);


/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.NewInvoicePaymentDialog = exports.InvoicePaymentComp = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var mobx_react_1 = __webpack_require__(4);
	var invoiceDomain_1 = __webpack_require__(157);
	var dateUtils_1 = __webpack_require__(49);
	var formUtils_1 = __webpack_require__(14);
	var stringUtils_1 = __webpack_require__(174);
	var colors_1 = __webpack_require__(29);
	var dialogAncestor_1 = __webpack_require__(87);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_1 = __webpack_require__(5);
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var errorComp_1 = __webpack_require__(34);
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var invoiceService_1 = tslib_1.__importDefault(__webpack_require__(195));
	var createForm_1 = __webpack_require__(18);
	var form_1 = __webpack_require__(52);
	var metaConstant_1 = __webpack_require__(13);
	var buttons_1 = __webpack_require__(27);
	var radioButtonField_1 = tslib_1.__importDefault(__webpack_require__(144));
	var validate_1 = __webpack_require__(24);
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var commonDataService_1 = __webpack_require__(41);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var accountingDomain_1 = __webpack_require__(560);
	var fields_1 = __webpack_require__(20);
	var accountingService_1 = tslib_1.__importDefault(__webpack_require__(2039));
	var partyService_1 = tslib_1.__importDefault(__webpack_require__(175));
	var partyCreditEntry_1 = __webpack_require__(952);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var numberUtils_1 = __webpack_require__(143);
	var utils_1 = __webpack_require__(37);
	var react_router_1 = __webpack_require__(65);
	var Toggle_1 = tslib_1.__importDefault(__webpack_require__(362));
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var domUtils_1 = __webpack_require__(91);
	var InvoicePaymentComp = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoicePaymentComp, _super);
	    function InvoicePaymentComp() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.addInvoicePayment = function (evt) {
	            var invoiceObject = _this.props.invoiceObject;
	            Promise.all([mdEntityService_1.default.fetchEntityMetadata(["Payment", "PaymentRelation"], ["BankTransaction"]),
	                partyService_1.default.readCreditEntries((0, formUtils_1.lovValue)(invoiceObject.billedTo))])
	                .then(function (_a) {
	                var entityMap = _a[0], creditEntryDto = _a[1];
	                var newPaymentObject = new invoiceDomain_1.Payment({
	                    active: true,
	                    $new: true,
	                    //[(lovValue(invoiceObject.invoiceType) == INVOICE_TYPE.CREDIT_NOTE) ? 'creditNote' : 'invoice']: invoiceObject.invoiceLov(),
	                    paymentType: mdEntityService_1.default.getEntity("PaymentType").getLovItem(1),
	                    currency: invoiceObject.invoiceCurrency,
	                    matchType: invoiceDomain_1.INVOICEPAYMENTMATCHTYPE.MANUAL,
	                    valueDate: (0, moment_1.default)().startOf('day').toDate()
	                }).initAfterRead(true);
	                new Promise(function (resolve, reject) {
	                    _this.newInvoicePaymentDialogRef.open(resolve, reject, newPaymentObject, invoiceObject, creditEntryDto.sums);
	                }).then(function (result) {
	                    if ([invoiceDomain_1.INVOICE_TYPE.PR].includes((0, formUtils_1.lovValue)(invoiceObject.invoiceType)) && result.createInvoiceForProforma) {
	                        _this.context.router.transitionTo("invoiceDetail", { id: 'copy' }, (0, utils_1.addTenantToQuery)({
	                            copyId: invoiceObject.invoiceId,
	                            linkToFI: true,
	                        }));
	                    }
	                    else if ([invoiceDomain_1.INVOICE_TYPE.DP].includes((0, formUtils_1.lovValue)(invoiceObject.invoiceType)) && result.createDdoppForDownPayment) {
	                        _this.context.router.transitionTo("invoiceDetail", { id: 'copy' }, (0, utils_1.addTenantToQuery)({
	                            copyId: invoiceObject.invoiceId,
	                            linkToAD: true,
	                        }));
	                    }
	                    else {
	                        return invoiceService_1.default.readInvoiceGraph(invoiceObject.invoiceId)
	                            .then((0, mobx_1.action)("readInvoicePayments-handler", function (invoiceGraph) {
	                            invoiceObject.$invoiceGraph = invoiceGraph;
	                        }));
	                    }
	                }).catch(function (e) {
	                });
	            });
	        };
	        _this.newInvoicePaymentDialogRefHandler = function (comp) { return _this.newInvoicePaymentDialogRef = comp; };
	        return _this;
	    }
	    InvoicePaymentComp.prototype.render = function () {
	        var invoiceObject = this.props.invoiceObject;
	        return (react_1.default.createElement("div", { style: { marginBottom: 50, marginTop: 20 } },
	            react_1.default.createElement(NewInvoicePaymentDialog, { ref: this.newInvoicePaymentDialogRefHandler, entities: mdEntityService_1.default.entityMap }),
	            react_1.default.createElement(InvoicePaymentTable, { invoiceGraph: invoiceObject.$invoiceGraph, rootInvoice: invoiceObject }),
	            react_1.default.createElement(buttons_1.SecuredZzFlatButton, { label: "Add Settlement", permission: metaConstant_1.PERMISSION.New, securable: metaConstant_1.SECURABLE.invoiceSettlement, primary: true, disabled: invoiceObject.invoicePaid || invoiceObject.invoiceCredited, onClick: this.addInvoicePayment })));
	    };
	    InvoicePaymentComp.contextTypes = {
	        router: prop_types_1.default.func.isRequired
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoicePaymentComp.prototype, "addInvoicePayment", void 0);
	    InvoicePaymentComp = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], InvoicePaymentComp);
	    return InvoicePaymentComp;
	}(react_1.default.Component));
	exports.InvoicePaymentComp = InvoicePaymentComp;
	var InvoicePaymentTable = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoicePaymentTable, _super);
	    function InvoicePaymentTable() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.deleteInvoicePayment = function (payRelation) {
	            var rootInvoice = _this.props.rootInvoice;
	            new Promise(function (resolve, reject) {
	                _this.confirmationDialogRef.open(resolve, reject, 'Do you really want to delete this Settlement ?');
	            }).then(function () {
	                console.log('do cancel');
	                uiService_1.default.showToolbarActionFlag();
	                invoiceService_1.default.deleteInvoicePayment(payRelation.payment.paymentId, rootInvoice.invoiceId)
	                    .then(function (invoiceJson) {
	                    console.log('deleteInvoicePayment invoicePaid = ' + invoiceJson.invoicePaid);
	                    rootInvoice.cleanAfterSave(invoiceJson);
	                    rootInvoice.invoicePaid = invoiceJson.invoicePaid;
	                    rootInvoice.invoiceCredited = invoiceJson.invoiceCredited;
	                    console.log('cleanAfterSave invoicePaid = ' + rootInvoice.invoicePaid);
	                    uiService_1.default.hideToolbarActionFlag();
	                    return invoiceService_1.default.readInvoiceGraph(rootInvoice.invoiceId);
	                }).then((0, mobx_1.action)('readInvoicePayments-handler', function (invoiceGraph) {
	                    rootInvoice.$invoiceGraph = invoiceGraph;
	                })).catch(function (error) {
	                    rootInvoice.$errors = error.getMessages();
	                });
	            }).catch(function (e) {
	            });
	        };
	        _this.confirmationDialogRefHandler = function (comp) { return _this.confirmationDialogRef = comp; };
	        return _this;
	    }
	    InvoicePaymentTable_1 = InvoicePaymentTable;
	    InvoicePaymentTable.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, invoiceGraph = _a.invoiceGraph, invRelation = _a.invRelation, rootInvoice = _a.rootInvoice;
	        if (!invoiceGraph) {
	            return react_1.default.createElement("noscript", null);
	        }
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement(confirmationDialog_1.default, { okButtonText: "Yes", cancelButtonText: "No", ref: this.confirmationDialogRefHandler }),
	            react_1.default.createElement("table", { className: "zz-simple-table" },
	                react_1.default.createElement("tbody", null,
	                    react_1.default.createElement("tr", null,
	                        react_1.default.createElement("td", { colSpan: 6, style: (0, domUtils_1.clsx)(!rootInvoice && { borderTop: 0 }) },
	                            react_1.default.createElement(react_router_1.Link, { to: "invoiceDetail", params: { id: (0, formUtils_1.lovValue)(invoiceGraph.invoice) }, query: (0, utils_1.addTenantToQuery)(), style: (0, domUtils_1.clsx)({ display: 'flex', gap: 5 }, !!rootInvoice && { fontWeight: "bold" }) },
	                                react_1.default.createElement("span", null, (0, formUtils_1.lovLabel)(invoiceGraph.invoice.invoiceType)),
	                                react_1.default.createElement("span", null, invoiceGraph.invoice.invoiceNumber ? invoiceGraph.invoice.invoiceNumber : "Not issued"),
	                                react_1.default.createElement("span", null, (0, numberUtils_1.formatMonetaryAmount)(invoiceGraph.invoice.totalAdjustedPrice, invoiceGraph.invoice.invoiceCurrency)),
	                                react_1.default.createElement("span", null, "on"),
	                                react_1.default.createElement("span", null, (0, formUtils_1.formatValue)(invoiceGraph.invoice.invoiceDate, mdEntityService_1.default.getEntity("Invoice").getField('invoiceDate'))),
	                                !!invRelation && react_1.default.createElement("span", null, "contribution"),
	                                !!invRelation &&
	                                    react_1.default.createElement("span", null, (0, numberUtils_1.formatMonetaryAmount)(invRelation.contributedAmount, invRelation.currency))))),
	                    !!invoiceGraph.pays.length &&
	                        react_1.default.createElement("tr", null,
	                            react_1.default.createElement("td", { style: { color: colors_1.grey500, fontSize: 13 } }, "Value Date"),
	                            react_1.default.createElement("td", { style: { color: colors_1.grey500, fontSize: 13 } }, "Amount"),
	                            react_1.default.createElement("td", { style: { color: colors_1.grey500, fontSize: 13 } }, "PaymentType"),
	                            react_1.default.createElement("td", { style: { color: colors_1.grey500, fontSize: 13 } }, "Bank Transaction"),
	                            react_1.default.createElement("td", { style: { color: colors_1.grey500, fontSize: 13 } }, "Match Type"),
	                            react_1.default.createElement("td", null)),
	                    invoiceGraph.pays.map(function (payRelation, index) {
	                        //let mdField = entity.getField(field.fieldName);
	                        return (react_1.default.createElement("tr", { key: index },
	                            react_1.default.createElement("td", null, (0, dateUtils_1.formatDate)(payRelation.valueDate)),
	                            react_1.default.createElement("td", null, (0, numberUtils_1.formatMonetaryAmount)(payRelation.contributedAmount, payRelation.currency)),
	                            react_1.default.createElement("td", null, (0, formUtils_1.lovLabel)(payRelation.payment.paymentType)),
	                            react_1.default.createElement("td", null, (0, stringUtils_1.abbreviate)((0, formUtils_1.lovLabel)(payRelation.payment.bankTransaction), 60)),
	                            react_1.default.createElement("td", null, (0, formUtils_1.lovLabel)(payRelation.payment.matchType)),
	                            react_1.default.createElement("td", null, !!_this.props.rootInvoice &&
	                                react_1.default.createElement(buttons_1.SecuredZzFlatButton, { label: "Delete", permission: metaConstant_1.PERMISSION.Delete, secondary: true, securable: metaConstant_1.SECURABLE.invoiceSettlement, onClick: _this.deleteInvoicePayment.bind(_this, payRelation) }))));
	                    })),
	                react_1.default.createElement("tbody", null,
	                    invoiceGraph.froms.map(function (invRelation, index) {
	                        return (react_1.default.createElement("tr", { key: index },
	                            react_1.default.createElement("td", { colSpan: 6 },
	                                react_1.default.createElement(InvoicePaymentTable_1, { invoiceGraph: invRelation.node, invRelation: invRelation }))));
	                    }),
	                    invoiceGraph.tos.map(function (invRelation, index) {
	                        return (react_1.default.createElement("tr", { key: index },
	                            react_1.default.createElement("td", { colSpan: 6 },
	                                react_1.default.createElement(InvoicePaymentTable_1, { invoiceGraph: invRelation.node, invRelation: invRelation }))));
	                    })))));
	    };
	    var InvoicePaymentTable_1;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoicePaymentTable.prototype, "deleteInvoicePayment", void 0);
	    InvoicePaymentTable = InvoicePaymentTable_1 = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], InvoicePaymentTable);
	    return InvoicePaymentTable;
	}(react_1.default.Component));
	var NewInvoicePaymentDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(NewInvoicePaymentDialog, _super);
	    function NewInvoicePaymentDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.ok = function () {
	            var result = (0, formUtils_1.preSave)(_this.payment, null);
	            if (!result) {
	                return;
	            }
	            uiService_1.default.showDialogActionFlag();
	            invoiceService_1.default.saveInvoicePayment(_this.payment, _this.invoiceObject.invoiceId)
	                .then(function (struct) {
	                _this.invoiceObject.cleanAfterSave(struct.invoice);
	                _this.dialogOpen = false;
	                uiService_1.default.hideDialogActionFlag();
	                _this.resolve({
	                    payment: new invoiceDomain_1.Payment(struct.payment),
	                    paymentRelation: new invoiceDomain_1.PaymentRelation(struct.paymentRelation),
	                    createInvoiceForProforma: [invoiceDomain_1.INVOICE_TYPE.PR].includes((0, formUtils_1.lovValue)(_this.invoiceObject.invoiceType)) && _this.createRegularInvoiceToggle,
	                    createDdoppForDownPayment: [invoiceDomain_1.INVOICE_TYPE.DP].includes((0, formUtils_1.lovValue)(_this.invoiceObject.invoiceType)) && _this.createDdoppToggle
	                });
	            }, function (error) {
	                _this.$errors = error.getMessages();
	            });
	        };
	        _this.cancel = function (evt) {
	            console.log('NewInvoicePaymentDialog#cancel evt = %O', evt);
	            _this.dialogOpen = false;
	            _this.$errors = [];
	            _this.reject("cancel");
	        };
	        _this.createRegularInvoiceToggleHandler = function (evt, bulik) {
	            _this.createRegularInvoiceToggle = bulik;
	        };
	        _this.createDdoppToggleHandler = function (evt, bulik) {
	            _this.createDdoppToggle = bulik;
	        };
	        return _this;
	    }
	    NewInvoicePaymentDialog.prototype.open = function (resolve, reject, payment, invoiceObject, creditEntrySums) {
	        this.resolve = resolve;
	        this.reject = reject;
	        this.$errors = [];
	        this.dialogOpen = true;
	        this.payment = payment;
	        this.invoiceObject = invoiceObject;
	        this.creditEntrySums = creditEntrySums;
	        this.createRegularInvoiceToggle = ((0, formUtils_1.lovValue)(this.invoiceObject.invoiceType) === invoiceDomain_1.INVOICE_TYPE.PR);
	        this.createDdoppToggle = false;
	    };
	    NewInvoicePaymentDialog.prototype.render = function () {
	        console.log('invoicePayment = %O, dialogOpen = %s', this.payment, this.dialogOpen);
	        if (!(this.payment && this.dialogOpen))
	            return null;
	        var actions = [
	            react_1.default.createElement(FlatButton_1.default, { key: "1", label: "Cancel", primary: true, onClick: this.cancel }),
	            react_1.default.createElement(FlatButton_1.default, { key: "2", label: "Save", secondary: true, onClick: this.ok })
	        ];
	        var propsForCreateForm = {
	            dataObject: this.payment,
	            rootObject: this.invoiceObject,
	            entity: mdEntityService_1.default.getEntity('Payment'),
	            entities: mdEntityService_1.default.entityMap
	        };
	        return (react_1.default.createElement(Dialog_1.default, { title: "Create new Invoice Settlement for ".concat((0, formUtils_1.lovLabel)(this.invoiceObject.invoiceType), " #").concat(this.invoiceObject.invoiceNumber), actions: actions, modal: true, open: this.dialogOpen, autoScrollBodyContent: true, bodyStyle: { minHeight: 300 }, contentStyle: {
	                position: 'absolute',
	                left: '50%',
	                top: '50%',
	                transform: 'translate(-50%, -50%)',
	                filter: 'blur(0)'
	            } },
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: this.$errors }),
	            react_1.default.createElement(PaymentForm, tslib_1.__assign({}, propsForCreateForm, { open: true, creditEntrySums: this.creditEntrySums })),
	            [invoiceDomain_1.INVOICE_TYPE.PR].includes((0, formUtils_1.lovValue)(this.invoiceObject.invoiceType)) &&
	                react_1.default.createElement(Toggle_1.default, { label: "Create new regular Invoice", toggled: this.createRegularInvoiceToggle, onToggle: this.createRegularInvoiceToggleHandler, style: { width: "unset", marginTop: 20 }, labelStyle: { marginRight: 10, whiteSpace: 'nowrap' } }),
	            [invoiceDomain_1.INVOICE_TYPE.DP].includes((0, formUtils_1.lovValue)(this.invoiceObject.invoiceType)) &&
	                react_1.default.createElement(Toggle_1.default, { label: "Create DDOPP", toggled: this.createDdoppToggle, onToggle: this.createDdoppToggleHandler, style: { width: "unset", marginTop: 20 }, labelStyle: { marginRight: 10, whiteSpace: 'nowrap' } })));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], NewInvoicePaymentDialog.prototype, "payment", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], NewInvoicePaymentDialog.prototype, "invoiceObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], NewInvoicePaymentDialog.prototype, "createRegularInvoiceToggle", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], NewInvoicePaymentDialog.prototype, "createDdoppToggle", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable.ref
	    ], NewInvoicePaymentDialog.prototype, "creditEntrySums", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], NewInvoicePaymentDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], NewInvoicePaymentDialog.prototype, "ok", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], NewInvoicePaymentDialog.prototype, "cancel", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], NewInvoicePaymentDialog.prototype, "createRegularInvoiceToggleHandler", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], NewInvoicePaymentDialog.prototype, "createDdoppToggleHandler", void 0);
	    NewInvoicePaymentDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], NewInvoicePaymentDialog);
	    return NewInvoicePaymentDialog;
	}(dialogAncestor_1.DialogAncestor));
	exports.NewInvoicePaymentDialog = NewInvoicePaymentDialog;
	var PaymentForm = /** @class */ (function (_super) {
	    tslib_1.__extends(PaymentForm, _super);
	    function PaymentForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onPaymentTypeSuccess = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onPaymentTypeSuccess ', dataObject.paymentType);
	            var paymentTypeId = (0, formUtils_1.lovValue)(dataObject.paymentType);
	            if (paymentTypeId != invoiceDomain_1.PAYMENT_TYPE.ACCOUNT_TRANSFER) {
	                dataObject.bankTransaction = null;
	            }
	            if (paymentTypeId == invoiceDomain_1.PAYMENT_TYPE.CUSTOMER_CREDIT || paymentTypeId == invoiceDomain_1.PAYMENT_TYPE.CASH) {
	                dataObject.amount = rootObject.totalAdjustedPrice - rootObject.paidAmount;
	            }
	            else {
	                dataObject.amount = null;
	            }
	            form.updateAllFieldsPropValue(dataObject);
	        };
	        _this.onBankTransactionSuccess = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onBankTransactionSuccess ', dataObject.bankTransaction);
	            var bankTransactionId = (0, formUtils_1.lovValue)(dataObject.bankTransaction);
	            if (bankTransactionId) {
	                return accountingService_1.default.readBankTransaction(bankTransactionId)
	                    .then((0, mobx_1.action)("onBankTransactionSuccess-actionCb", function (bankTransaction) {
	                    dataObject.amount = Math.min(rootObject.totalAdjustedPrice - rootObject.paidAmount, bankTransaction.amount);
	                    form.updateFieldsPropValue(dataObject, "amount");
	                }));
	            }
	        };
	        return _this;
	    }
	    // @action onSuccessCounterInvoice = () => {
	    //   let {dataObject, rootObject, form} = this.props;
	    //   console.log('onSuccessCounterInvoice ', dataObject.counterInvoice);
	    //
	    //   let invoiceId = lovValue(dataObject.counterInvoice);
	    //
	    //   if (invoiceId) {
	    //     return invoiceService.readInvoice(invoiceId)
	    //       .then(action("onSuccessCounterInvoice-actionCb", (invoice: Invoice) => {
	    //         dataObject.amount = Math.min(rootObject.totalAdjustedPrice - rootObject.paidAmount, invoice.totalAdjustedPrice - invoice.paidAmount);
	    //         form.updateFieldsPropValue(dataObject, "amount");
	    //       }));
	    //   }
	    // };
	    PaymentForm.prototype.render = function () {
	        console.debug('PaymentForm render()');
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, index = _a.index, formName = _a.formName, creditEntrySums = _a.creditEntrySums;
	        var _b = dataObject.getFormFields(formName), paymentType = _b.paymentType, amount = _b.amount, bankTransaction = _b.bankTransaction, comment = _b.comment;
	        var invoiceTypeId = (0, formUtils_1.lovValue)(rootObject.invoiceType);
	        var paymentTypeId = (0, formUtils_1.lovValue)(dataObject.paymentType);
	        var paymentTypesWoCN = paymentType.props.options.filter(function (lov) { return ![invoiceDomain_1.PAYMENT_TYPE.CREDIT_NOTE, invoiceDomain_1.PAYMENT_TYPE.MUTUAL_CREDIT].includes((0, formUtils_1.lovValue)(lov)); });
	        return (react_1.default.createElement("form", null,
	            react_1.default.createElement("div", { className: "row", style: { marginTop: 5, marginBottom: 5 } },
	                react_1.default.createElement("div", { className: "col-xs-12" },
	                    react_1.default.createElement(radioButtonField_1.default, tslib_1.__assign({}, paymentType.props, { options: paymentTypesWoCN, groupStyle: { display: 'flex', flexWrap: 'wrap' }, optionStyle: { width: 'initial', marginRight: 15 }, labelStyle: { whiteSpace: 'nowrap', marginLeft: -10 } })),
	                    react_1.default.createElement(validate_1.Validate, { field: paymentType, value: paymentType.props.value, onSuccess: this.onPaymentTypeSuccess }))),
	            react_1.default.createElement("div", { className: "row" },
	                (paymentTypeId == invoiceDomain_1.PAYMENT_TYPE.ACCOUNT_TRANSFER) ? (react_1.default.createElement("div", { className: "col-xs-10" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, bankTransaction.props, { minimumInput: 0, async: true, clearable: true, asterixForAll: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'BankTransaction', {
	                            accountPartyId: (0, formUtils_1.lovValue)(rootObject.billedFrom),
	                            transactionType: accountingDomain_1.BANKTRANSACTIONTYPE.PAYMENT_IN,
	                            settled: false
	                        }), advancedSearchGL: "bankTransactionSearch", advancedSearchMasterId: (0, formUtils_1.lovValue)(rootObject.billedFrom), advancedSearchContentStyle: { width: '80%', maxWidth: 'none' }, advancedSearchShowGridConfig: true, advancedSearchTitle: "Search payment for ".concat((0, formUtils_1.lovLabel)(rootObject.invoiceType), " #").concat(rootObject.invoiceNumber, " - ").concat((0, formUtils_1.lovLabel)(rootObject.billedTo), ", amount ").concat((0, numberUtils_1.formatNumber)(rootObject.totalAdjustedPrice, numberUtils_1.DEFAULT_CURRENCY_FORMAT), " ").concat((0, formUtils_1.lovLabel)(rootObject.invoiceCurrency)) })),
	                    react_1.default.createElement(validate_1.Validate, { field: bankTransaction, value: bankTransaction.props.value, onSuccess: this.onBankTransactionSuccess }))) : null,
	                (paymentTypeId == invoiceDomain_1.PAYMENT_TYPE.CUSTOMER_CREDIT) ? (react_1.default.createElement("div", { className: "col-xs-12" },
	                    react_1.default.createElement(partyCreditEntry_1.PartyCreditSumTable, { sums: creditEntrySums }))) : null),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-6 col-sm-6" },
	                    react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, amount.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: amount, value: amount.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props, { multiLine: true, rows: 2 }))))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PaymentForm.prototype, "onPaymentTypeSuccess", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PaymentForm.prototype, "onBankTransactionSuccess", void 0);
	    PaymentForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'PaymentForm',
	            fields: [{
	                    name: 'paymentType',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.radioButton,
	                    validators: ['IsRequired']
	                }, {
	                    name: "amount",
	                    validators: ['IsRequired']
	                }, {
	                    name: "bankTransaction",
	                    validators: ['IsRequired']
	                }, {
	                    name: 'comment',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	                }
	            ]
	        }, function () { return react_1.default.createElement("noscript", null); }),
	        mobx_react_1.observer
	    ], PaymentForm);
	    return PaymentForm;
	}(react_1.default.Component));


/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var material_ui_1 = __webpack_require__(127);
	var mobx_1 = __webpack_require__(5);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var commonDataService_1 = __webpack_require__(41);
	var partyDomain_1 = __webpack_require__(48);
	var mobx_react_1 = __webpack_require__(4);
	var createForm_1 = __webpack_require__(18);
	var InvoiceTemplateBilledToDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceTemplateBilledToDialog, _super);
	    function InvoiceTemplateBilledToDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.confirm = function () {
	            _this.confirmed = true;
	            if (_this.billedTo != null) {
	                _this.props.onConfirm(_this.billedTo);
	            }
	        };
	        _this.close = function () {
	            _this.billedTo = null;
	            _this.confirmed = false;
	            _this.props.onClose();
	        };
	        _this.onBilledToChange = function (value) {
	            _this.billedTo = value;
	        };
	        return _this;
	    }
	    InvoiceTemplateBilledToDialog.prototype.render = function () {
	        return react_1.default.createElement(Dialog_1.default, { title: "Select billed to", actions: [
	                react_1.default.createElement(material_ui_1.FlatButton, { key: "close", label: "Close", primary: true, onClick: this.close }),
	                react_1.default.createElement(material_ui_1.FlatButton, { key: "confirm", label: "Confirm", primary: true, onClick: this.confirm })
	            ], modal: true, open: this.props.dialogOpen, contentStyle: { width: '80%', maxWidth: 800 }, bodyStyle: { overflow: 'visible' } },
	            react_1.default.createElement("div", { className: "fx col-xs-12" },
	                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({ async: true, floatingLabelText: "Billed To *", loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.CUSTOMER_ROLE] }), clearable: true, onChange: this.onBilledToChange, value: this.billedTo, errorText: this.confirmed && this.billedTo == null && "Billed To is required" }, createForm_1.fieldStyles.small.styledSelect))));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateBilledToDialog.prototype, "billedTo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateBilledToDialog.prototype, "confirmed", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateBilledToDialog.prototype, "confirm", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateBilledToDialog.prototype, "close", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateBilledToDialog.prototype, "onBilledToChange", void 0);
	    InvoiceTemplateBilledToDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], InvoiceTemplateBilledToDialog);
	    return InvoiceTemplateBilledToDialog;
	}(react_1.default.Component));
	exports.default = InvoiceTemplateBilledToDialog;


/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var form_1 = __webpack_require__(52);
	var createForm_1 = __webpack_require__(18);
	var formUtils_1 = __webpack_require__(14);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var blockComp_1 = __webpack_require__(30);
	var validate_1 = __webpack_require__(24);
	var rules_1 = __webpack_require__(56);
	var commonDataService_1 = __webpack_require__(41);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var partyDomain_1 = __webpack_require__(48);
	var statusActiveComp_1 = __webpack_require__(261);
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var Checkbox_1 = tslib_1.__importDefault(__webpack_require__(210));
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var dateUtils_1 = __webpack_require__(49);
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var eventDomain_1 = __webpack_require__(74);
	var colors_1 = __webpack_require__(29);
	var mdField_1 = tslib_1.__importStar(__webpack_require__(57));
	var locales_1 = __webpack_require__(15);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var dynamicFields_1 = __webpack_require__(940);
	var HeadingDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    font-size: 18px;\n    color: ", "\n"], ["\n    font-size: 18px;\n    color: ", "\n"])), colors_1.grey400);
	var ClosedContent = (0, mobx_react_1.observer)(function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { width: '100%' } },
	        react_1.default.createElement("div", { style: { display: 'flex' } },
	            disabled ? null :
	                react_1.default.createElement(statusActiveComp_1.StatusActiveComp, { activeObject: dataObject, entity: entity, id: dataObject.invoiceTemplateId }),
	            react_1.default.createElement("h5", { style: statusActiveComp_1.StatusActiveComp__h5_style },
	                " ",
	                (0, formUtils_1.lovLabel)(dataObject.name))),
	        (dataObject.description) ? (react_1.default.createElement("div", null,
	            react_1.default.createElement("i", null, dataObject.description))) : null,
	        react_1.default.createElement("div", { className: "row" },
	            react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                react_1.default.createElement(HeadingDiv, null, "Customer"),
	                (dataObject.billedTo) ? (react_1.default.createElement("div", { className: "form-text-row" },
	                    react_1.default.createElement("span", { className: "zz-mr-5" }, locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["invoice.billed-to"], ["invoice.billed-to"]))),
	                        " ",
	                        (dataObject.billedTo2) ? " 1" : ""),
	                    react_1.default.createElement(formUtils_1.FieldText, { value: dataObject.billedTo.label, linkProps: { to: 'partyDetail', params: { id: dataObject.billedTo.value } } }),
	                    (dataObject.orderedBy) ? (react_1.default.createElement(formUtils_1.FieldText, { label: 'Ordered By', value: dataObject.orderedBy.label, linkProps: { to: 'partyDetail', params: { id: dataObject.orderedBy.value } } })) : null,
	                    (dataObject.issuedBy) ? (react_1.default.createElement(formUtils_1.FieldText, { label: 'Issued By', value: dataObject.issuedBy.label, linkProps: { to: 'partyDetail', params: { id: dataObject.issuedBy.value } } })) : null)) : null,
	                (dataObject.billedTo2) ? (react_1.default.createElement("div", { className: "form-text-row" },
	                    react_1.default.createElement("span", { className: "zz-mr-5" }, locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["invoice.billed-to"], ["invoice.billed-to"]))),
	                        " 2"),
	                    react_1.default.createElement(formUtils_1.FieldText, { value: dataObject.billedTo2.label, linkProps: { to: 'partyDetail', params: { id: dataObject.billedTo2.value } } }))) : null),
	            react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                react_1.default.createElement(HeadingDiv, null, "Details"),
	                react_1.default.createElement("div", { className: "form-text-row" },
	                    react_1.default.createElement(formUtils_1.FieldText, { label: fields.invoiceType.textLabel, value: dataObject.invoiceType }),
	                    react_1.default.createElement(formUtils_1.FieldText, { label: fields.invoiceCurrency.textLabel, value: dataObject.invoiceCurrency }),
	                    react_1.default.createElement(formUtils_1.FieldText, { label: fields.invoiceAdjustmentKoef.textLabel, value: dataObject.invoiceAdjustmentKoef }),
	                    react_1.default.createElement("span", { className: "zz-ml-5 zz-mr-5" }, (dataObject.issueInvoice) ? 'Issue Invoice' : 'Leave is Concept'),
	                    react_1.default.createElement(formUtils_1.FieldText, { label: fields.eventType.textLabel, value: dataObject.eventType })),
	                react_1.default.createElement("div", { className: "form-text-row" },
	                    react_1.default.createElement(formUtils_1.FieldText, { label: fields.startInvoicePeriodExpression.textLabel, value: dataObject.startInvoicePeriodExpression }),
	                    react_1.default.createElement(formUtils_1.FieldText, { label: fields.endInvoicePeriodExpression.textLabel, value: dataObject.endInvoicePeriodExpression })),
	                react_1.default.createElement("div", { className: "form-text-row" },
	                    react_1.default.createElement(formUtils_1.FieldText, { label: fields.invoiceDateExpression.textLabel, value: dataObject.invoiceDateExpression }),
	                    react_1.default.createElement(formUtils_1.FieldText, { label: fields.taxDateExpression.textLabel, value: dataObject.taxDateExpression })))),
	        react_1.default.createElement("div", { className: "row" },
	            react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                react_1.default.createElement(HeadingDiv, null, "Scheduling"),
	                dataObject.disableScheduling ?
	                    react_1.default.createElement("span", { className: "zz-ml-5 zz-mr-5" }, "Disable Scheduling")
	                    :
	                        react_1.default.createElement("div", null,
	                            react_1.default.createElement("div", { className: "form-text-row" },
	                                react_1.default.createElement("span", { className: "zz-ml-2" }, "Repeat once every ".concat(dataObject.remittanceSkipCount, " ").concat((0, formUtils_1.lovLabel)(dataObject.remittanceType), " starting at ").concat((0, dateUtils_1.formatDate)(dataObject.validFrom), " ").concat((!dataObject.validTo) ? 'forever' : ('to ' + (0, dateUtils_1.formatDate)(dataObject.validTo))))),
	                            react_1.default.createElement("div", { className: "form-text-row" },
	                                react_1.default.createElement(formUtils_1.FieldText, { label: fields.lastGenerateDate.textLabel, value: dataObject.lastGenerateDate, mdField: fields.lastGenerateDate.mdField }),
	                                react_1.default.createElement(formUtils_1.FieldText, { label: fields.nextGenerateDate.textLabel, value: dataObject.nextGenerateDate, mdField: fields.nextGenerateDate.mdField })))),
	            react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                react_1.default.createElement(HeadingDiv, null, "Customer Overrides"),
	                react_1.default.createElement("div", { className: "form-text-row" },
	                    react_1.default.createElement(formUtils_1.FieldText, { label: fields.paymentCond.textLabel, value: dataObject.paymentCond }),
	                    react_1.default.createElement(formUtils_1.FieldText, { label: fields.profitCenter.textLabel, value: dataObject.profitCenter }),
	                    react_1.default.createElement(formUtils_1.FieldText, { label: fields.language.textLabel, value: dataObject.language }),
	                    react_1.default.createElement(formUtils_1.FieldText, { label: fields.monetaryRounding.textLabel, value: dataObject.monetaryRounding }),
	                    react_1.default.createElement(formUtils_1.FieldText, { label: fields.entityNumberGen.textLabel, value: dataObject.entityNumberGen ? dataObject.entityNumberGen.label : 'Default' })),
	                react_1.default.createElement("div", { className: "form-text-row" },
	                    react_1.default.createElement(formUtils_1.FieldText, { label: fields.accountingNumber.textLabel, value: dataObject.accountingNumber }),
	                    react_1.default.createElement(formUtils_1.FieldText, { label: fields.accountingProfitCenter.textLabel, value: dataObject.accountingProfitCenter }),
	                    react_1.default.createElement(formUtils_1.FieldText, { label: fields.costCenter.textLabel, value: dataObject.costCenter }),
	                    react_1.default.createElement(formUtils_1.FieldText, { label: fields.internalOrder.textLabel, value: dataObject.internalOrder })))),
	        react_1.default.createElement("div", { className: "row" },
	            react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                react_1.default.createElement(HeadingDiv, null, "Comments"),
	                react_1.default.createElement("div", { className: "form-text-row" },
	                    react_1.default.createElement(formUtils_1.FieldText, { value: dataObject.comment })),
	                react_1.default.createElement("div", { className: "form-text-row" },
	                    react_1.default.createElement(formUtils_1.FieldText, { label: fields.internalComment.textLabel, value: dataObject.internalComment }))),
	            react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                react_1.default.createElement(HeadingDiv, null, "Parameters"),
	                dataObject.fields.map(function (dynField) {
	                    var field = entity.getField(dynField.fieldName);
	                    if (!field)
	                        return null;
	                    return (react_1.default.createElement("div", { className: "form-text-row" },
	                        react_1.default.createElement(formUtils_1.FieldText, { mdField: field, label: field.formLabelActive, value: dynField.value })));
	                })))));
	});
	var InvoiceTemplateForm = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceTemplateForm, _super);
	    function InvoiceTemplateForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.recalculate = function (evt) {
	            return _this.props.recalculate(_this.props.dataObject, null, null);
	        };
	        _this.handleForever = function (evt) {
	            var _a = _this.props, entities = _a.entities, dataObject = _a.dataObject, form = _a.form, rootObject = _a.rootObject;
	            _this.forever = !_this.forever;
	            if (_this.forever) {
	                dataObject.validTo = null;
	                form.updateFieldsPropValue(dataObject, "validTo");
	                rootObject.$dirty = true;
	            }
	        };
	        _this.onBilledToChange = function () {
	            var _a = _this.props, entities = _a.entities, dataObject = _a.dataObject, form = _a.form;
	            console.log('onBilledToChange ', dataObject.billedTo);
	            var partyId = (0, formUtils_1.lovValue)(dataObject.billedTo);
	            var optionsPromise = (partyId != null) ? (0, commonDataService_1.optionsSearch)('Party', { contactsOf: partyId }, '*') : Promise.resolve({ options: [] });
	            return Promise.all([_this.props.recalculate(_this.props.dataObject, null, null, { billedToChange: true }), optionsPromise])
	                .then((0, mobx_1.action)("onBilledToChange-cb1", function (_a) {
	                var x = _a[0], options = _a[1];
	                form.getField("orderedBy").props.options = options.options;
	                dataObject.orderedBy = (options.options.length === 1) ? options.options[0].value : null;
	                if (dataObject.billedTo == null) {
	                    dataObject.disableScheduling = true;
	                }
	                form.updateAllFieldsPropValue(dataObject);
	                if (dataObject.getTuple("vatRateChange")) {
	                    commonService_1.default.notifyInfo("Vat rates were changed");
	                }
	            }));
	        };
	        return _this;
	    }
	    InvoiceTemplateForm.prototype.componentWillMount = function () {
	        var _a = this.props, entities = _a.entities, dataObject = _a.dataObject, form = _a.form;
	        if (dataObject.$new) {
	            dataObject.disableScheduling = true;
	            form.updateFieldsPropValue(dataObject, "disableScheduling");
	        }
	        form.getField("orderedBy").props.options = dataObject.getTuple("orderedByOptions");
	        this.forever = (!dataObject.validTo);
	    };
	    InvoiceTemplateForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entity = _a.entity, entities = _a.entities, form = _a.form, formName = _a.formName;
	        var fields = form.fields;
	        var _b = dataObject.getFormFields(formName), profitCenter = _b.profitCenter, paymentCond = _b.paymentCond, invoiceCurrency = _b.invoiceCurrency, language = _b.language, monetaryRounding = _b.monetaryRounding, comment = _b.comment, internalComment = _b.internalComment, issuedBy = _b.issuedBy, orderedBy = _b.orderedBy, invoiceAdjustmentKoef = _b.invoiceAdjustmentKoef, markAsSentByPost = _b.markAsSentByPost, billedTo = _b.billedTo, billedTo2 = _b.billedTo2, disableScheduling = _b.disableScheduling, remittanceType = _b.remittanceType, remittanceSkipCount = _b.remittanceSkipCount, validFrom = _b.validFrom, validTo = _b.validTo, name = _b.name, description = _b.description, issueInvoice = _b.issueInvoice, startInvoicePeriodExpression = _b.startInvoicePeriodExpression, endInvoicePeriodExpression = _b.endInvoicePeriodExpression, periodicInvoice = _b.periodicInvoice, invoiceDateExpression = _b.invoiceDateExpression, taxDateExpression = _b.taxDateExpression, eventType = _b.eventType, entityNumberGen = _b.entityNumberGen, accountingNumber = _b.accountingNumber, costCenter = _b.costCenter, accountingProfitCenter = _b.accountingProfitCenter, internalOrder = _b.internalOrder, invoiceType = _b.invoiceType;
	        var clearBilledTo2 = function () {
	            billedTo2.props.value = undefined;
	            dataObject.billedTo2 = undefined;
	        };
	        var eventTypeOptions = eventType.props.options.filter(function (li) { return li.label === '---' || li["eventType"] === eventDomain_1.EVENTTYPE.INVOICE_INTERNAL_EMAIL; });
	        var strings = securityService_1.default.currentUser.detailIdList(metaConstant_1.SECURABLE.invoiceTemplateDetail.name);
	        var invoiceTypeOptions = invoiceType.props.options.filter(function (li) { return strings.includes((0, formUtils_1.lovValue)(li).toString()); });
	        var openContent = (react_1.default.createElement("form", { style: { marginTop: 10 } },
	            react_1.default.createElement(blockComp_1.BlockComp, null,
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-4" },
	                        react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, name.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value })),
	                    react_1.default.createElement("div", { className: "fx col-xs-8" },
	                        react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, description.props, { multiLine: true, rows: 1 }))))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                    react_1.default.createElement(blockComp_1.BlockComp, { className: "block-comp-right-border", header: "Customer", style: { marginBottom: 0 } },
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-8" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, billedTo.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.CUSTOMER_ROLE] }), clearable: true, onValueEmpty: clearBilledTo2 })),
	                                react_1.default.createElement(validate_1.Validate, { field: billedTo, value: billedTo.props.value, onSuccess: this.onBilledToChange })),
	                            react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, orderedBy.props, { clearable: false }))),
	                            react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-8" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, billedTo2.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.CUSTOMER_ROLE] }), clearable: true, disabled: !billedTo.props.value })),
	                                react_1.default.createElement(validate_1.Validate, { field: billedTo2, value: billedTo2.props.value })),
	                            react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, issuedBy.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.USER_ROLE] }), clearable: true, asterixForAll: true })))))),
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                    react_1.default.createElement(blockComp_1.BlockComp, { header: "Scheduling", style: { marginBottom: 0 } },
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "col-xs-11" },
	                                react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, disableScheduling.props, { disabled: dataObject.billedTo == null || dataObject.items.length == 0 })))),
	                        !dataObject.disableScheduling &&
	                            react_1.default.createElement("div", null,
	                                react_1.default.createElement("div", { style: { display: 'flex', flexWrap: 'wrap' } },
	                                    react_1.default.createElement("span", { style: { marginRight: 5, position: 'relative', top: 26 } }, "Repeat once every "),
	                                    react_1.default.createElement("div", { className: "fx col-xs-1" },
	                                        react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, remittanceSkipCount.props)),
	                                        react_1.default.createElement(validate_1.Validate, { field: remittanceSkipCount, value: remittanceSkipCount.props.value },
	                                            react_1.default.createElement(rules_1.NumberFormat, { precision: 2, scale: 0 }),
	                                            react_1.default.createElement(rules_1.Min, { min: 1 }),
	                                            react_1.default.createElement(rules_1.Max, { max: 11 }))),
	                                    react_1.default.createElement("div", { className: "fx col-xs-3" },
	                                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, remittanceType.props, { clearable: false })),
	                                        react_1.default.createElement(validate_1.Validate, { field: remittanceType, value: remittanceType.props.value }))),
	                                react_1.default.createElement("div", { style: { display: 'flex', flexWrap: 'wrap' } },
	                                    react_1.default.createElement("span", { style: { marginRight: 5, position: 'relative', top: 26 } }, "from "),
	                                    react_1.default.createElement("div", { className: "fx col-xs-3" },
	                                        react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, validFrom.props)),
	                                        react_1.default.createElement(validate_1.Validate, { field: remittanceType, value: remittanceType.props.value })),
	                                    react_1.default.createElement("div", { className: "fx col-xs-2", style: { position: 'relative', top: 26 } },
	                                        react_1.default.createElement(Checkbox_1.default, { onCheck: this.handleForever, label: "forever", checked: this.forever, labelStyle: { marginLeft: -10 } })),
	                                    (!this.forever) ? (react_1.default.createElement("span", { style: { marginLeft: 5, marginRight: 5, position: 'relative', top: 26 } }, "to ")) : null,
	                                    (!this.forever) ? (react_1.default.createElement("div", { className: "fx col-xs-3" },
	                                        react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, validTo.props, { hintText: "" })))) : null))))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                    react_1.default.createElement(blockComp_1.BlockComp, { className: "block-comp-right-border", header: "Details", style: { marginBottom: 0 } },
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, invoiceCurrency.props)),
	                                react_1.default.createElement(validate_1.Validate, { field: invoiceCurrency, value: invoiceCurrency.props.value })),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, invoiceAdjustmentKoef.props)),
	                                react_1.default.createElement(validate_1.Validate, { field: invoiceAdjustmentKoef, value: invoiceAdjustmentKoef.props.value, onSuccess: this.recalculate }))),
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "col-xs-11" },
	                                react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, periodicInvoice.props, { style: { height: 30, marginTop: 10 } })))),
	                        dataObject.periodicInvoice &&
	                            react_1.default.createElement("div", { className: "row" },
	                                react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, startInvoicePeriodExpression.props))),
	                                react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, endInvoicePeriodExpression.props)))),
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, invoiceDateExpression.props))),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, taxDateExpression.props))),
	                            react_1.default.createElement("div", { className: "col-xs-6" },
	                                react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, issueInvoice.props, { style: { height: 30 } })),
	                                (dataObject.issueInvoice) ? react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, markAsSentByPost.props, { style: { height: 30 } })) : null),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, eventType.props, { options: eventTypeOptions }))))),
	                    react_1.default.createElement(blockComp_1.BlockComp, { className: "block-comp-right-border", header: "Customer Overrides", style: { marginBottom: 0 } },
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, paymentCond.props))),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, profitCenter.props))),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, language.props))),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, monetaryRounding.props)),
	                                react_1.default.createElement(validate_1.Validate, { field: monetaryRounding, value: monetaryRounding.props.value },
	                                    react_1.default.createElement(rules_1.NumberFormat, { precision: 1, scale: 0 }),
	                                    react_1.default.createElement(rules_1.Min, { min: 0 }),
	                                    react_1.default.createElement(rules_1.Max, { max: 6 })))))),
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                    react_1.default.createElement(blockComp_1.BlockComp, { header: "Comments", style: { marginBottom: 0 } },
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-12" },
	                                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props, { multiLine: true, rows: 2 })))),
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-12" },
	                                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, internalComment.props, { multiLine: true, rows: 2 })))),
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, entityNumberGen.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'EntityNumberGen', { entityName: "Invoice" }), clearable: true, asterixForAll: true }))),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, invoiceType.props, { options: invoiceTypeOptions })),
	                                react_1.default.createElement(validate_1.Validate, { field: invoiceType, value: invoiceType.props.value }))),
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, accountingNumber.props))),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, internalOrder.props)))),
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, accountingProfitCenter.props))),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, costCenter.props))))),
	                    react_1.default.createElement(dynamicFields_1.DynamicFieldsBlock, { header: "Parameters", dataObject: dataObject, rootObject: dataObject, entity: entity, entities: mdEntityService_1.default.entityMap })))));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate }, this.props)));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateForm.prototype, "forever", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateForm.prototype, "recalculate", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateForm.prototype, "handleForever", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateForm.prototype, "onBilledToChange", void 0);
	    InvoiceTemplateForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'InvoiceTemplateForm',
	            fields: [{
	                    name: 'name',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'description',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	                }, {
	                    name: 'profitCenter',
	                }, {
	                    name: 'paymentCond'
	                }, {
	                    name: 'paymentType'
	                }, {
	                    name: 'invoiceCurrency',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'language'
	                }, {
	                    name: 'monetaryRounding'
	                }, {
	                    name: 'invoiceAdjustmentKoef',
	                    validators: ['IsRequired', 'IsNumber']
	                }, {
	                    name: 'issuedBy'
	                }, {
	                    name: 'orderedBy'
	                }, {
	                    name: 'billedTo'
	                }, {
	                    name: 'billedTo2'
	                }, {
	                    name: 'comment',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	                }, {
	                    name: 'internalComment',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	                }, {
	                    name: 'disableScheduling',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.checkbox,
	                    mdField: new mdField_1.default({ label: 'Disable Scheduling', dataType: mdField_1.DATATYPE.BOOLEAN })
	                }, {
	                    name: "remittanceType",
	                    validators: ['IsRequired'],
	                    omitNullOption: true,
	                    usePlaceholder: true
	                }, {
	                    name: "remittanceSkipCount",
	                    validators: ['IsRequired'],
	                    usePlaceholder: true
	                }, {
	                    name: "validFrom",
	                    validators: ['IsRequired'],
	                    usePlaceholder: true
	                }, {
	                    name: "validTo",
	                    usePlaceholder: true
	                }, {
	                    name: "holidayHandling"
	                }, {
	                    name: "issueInvoice"
	                }, {
	                    name: "markAsSentByPost"
	                }, {
	                    name: "lastGenerateDate"
	                }, {
	                    name: "nextGenerateDate"
	                }, {
	                    name: "startInvoicePeriodExpression"
	                }, {
	                    name: "endInvoicePeriodExpression"
	                }, {
	                    name: "periodicInvoice"
	                }, {
	                    name: "invoiceDateExpression"
	                }, {
	                    name: "taxDateExpression"
	                }, {
	                    name: "eventType"
	                }, {
	                    name: "entityNumberGen"
	                }, {
	                    name: "accountingNumber"
	                }, {
	                    name: "internalOrder"
	                }, {
	                    name: "accountingProfitCenter"
	                }, {
	                    name: "costCenter"
	                }, {
	                    name: "invoiceType",
	                    validators: ['IsRequired'],
	                    omitNullOption: true
	                }]
	        }, ClosedContent),
	        mobx_react_1.observer
	    ], InvoiceTemplateForm);
	    return InvoiceTemplateForm;
	}(react_1.default.Component));
	exports.default = InvoiceTemplateForm;
	var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var round = __webpack_require__(732);
	var createForm_1 = __webpack_require__(18);
	var formUtils_1 = __webpack_require__(14);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var validate_1 = __webpack_require__(24);
	var rules_1 = __webpack_require__(56);
	var commonDataService_1 = __webpack_require__(41);
	var invoiceService_1 = tslib_1.__importDefault(__webpack_require__(195));
	var productService_1 = tslib_1.__importDefault(__webpack_require__(131));
	var productUtils_1 = __webpack_require__(405);
	var invoiceDomain_1 = __webpack_require__(157);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var Checkbox_1 = tslib_1.__importDefault(__webpack_require__(210));
	var FaUser = __webpack_require__(849);
	var partyDomain_1 = __webpack_require__(48);
	var _basePrice, _unitPrice;
	function ComputeBasePriceExpression(_a) {
	    var value = _a.value;
	    console.log('ComputeBasePriceExpression value = ', value);
	    if (!value)
	        return (0, rules_1.valid)();
	    return mdEntityService_1.default.spelExpression(value)
	        .then(function (value) {
	        _basePrice = value;
	        return (0, rules_1.valid)();
	    }).catch(function (error) {
	        return (0, rules_1.invalid)(error.response.data.messages[0].message);
	    });
	}
	function ComputeUnitPriceExpression(_a) {
	    var value = _a.value;
	    if (!value)
	        return (0, rules_1.valid)();
	    return mdEntityService_1.default.spelExpression(value)
	        .then(function (value) {
	        _unitPrice = value;
	        return (0, rules_1.valid)();
	    }).catch(function (error) {
	        return (0, rules_1.invalid)(error.response.data.messages[0].message);
	    });
	}
	var InvoiceTemplateItemForm = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceTemplateItemForm, _super);
	    function InvoiceTemplateItemForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleUseExpressionBase = function (evt) {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            dataObject.$useExpression = !dataObject.$useExpression;
	            dataObject.basePriceExpression = '';
	            form.updateFieldsPropValue(dataObject, "basePriceExpression");
	            rootObject.$dirty = true;
	            if (dataObject.$useExpression) {
	                form.getField("basePriceExpression").handleValidation({ validationResult: { valid: false, error: "Field is required" }, showValidation: false }, "MANUAL");
	            }
	            else {
	                form.getField("basePriceExpression").handleValidation({ validationResult: { valid: true }, showValidation: false }, "MANUAL");
	            }
	        };
	        _this.handleUseExpressionUnit = function (evt) {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            dataObject.$useExpression = !dataObject.$useExpression;
	            dataObject.unitPriceExpression = '';
	            form.updateFieldsPropValue(dataObject, "unitPriceExpression");
	            rootObject.$dirty = true;
	            if (dataObject.$useExpression) {
	                form.getField("unitPriceExpression").handleValidation({ validationResult: { valid: false, error: "Field is required" }, showValidation: false }, "MANUAL");
	            }
	            else {
	                form.getField("unitPriceExpression").handleValidation({ validationResult: { valid: true }, showValidation: false }, "MANUAL");
	            }
	        };
	        _this.onBasePriceChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onBasePriceChange ', dataObject.basePrice);
	            dataObject.adjustmentAmount = round(dataObject.basePrice * dataObject.adjustmentKoef, rootObject.monetaryRounding);
	            _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	            rootObject.$dirty = true;
	            form.updateAllFieldsPropValue(dataObject);
	        };
	        _this.onBasePriceExpressionSuccess = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onBasePriceExpressionSuccess _basePrice = ', _basePrice);
	            dataObject.basePrice = _basePrice;
	            dataObject.adjustmentAmount = round(dataObject.basePrice * dataObject.adjustmentKoef, rootObject.monetaryRounding);
	            _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	            rootObject.$dirty = true;
	            form.updateAllFieldsPropValue(dataObject);
	        };
	        _this.onUnitPriceChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onUnitPriceChange ', dataObject.unitPrice);
	            dataObject.basePrice = dataObject.unitPrice * dataObject.quantity;
	            dataObject.adjustmentAmount = round(dataObject.basePrice * dataObject.adjustmentKoef, rootObject.monetaryRounding);
	            _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	            rootObject.$dirty = true;
	            form.updateAllFieldsPropValue(dataObject);
	        };
	        _this.onUnitPriceExpressionSuccess = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onUnitPriceExpressionSuccess _unitPrice = ', _unitPrice);
	            dataObject.unitPrice = _unitPrice;
	            dataObject.basePrice = dataObject.unitPrice * dataObject.quantity;
	            dataObject.adjustmentAmount = round(dataObject.basePrice * dataObject.adjustmentKoef, rootObject.monetaryRounding);
	            _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	            rootObject.$dirty = true;
	            form.updateAllFieldsPropValue(dataObject);
	        };
	        _this.onAdjustmentKoefChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onAdjustmentKoefChange ', dataObject.adjustmentKoef);
	            dataObject.adjustmentAmount = round(dataObject.adjustmentKoef * dataObject.basePrice, rootObject.monetaryRounding);
	            _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	            rootObject.$dirty = true;
	            form.updateAllFieldsPropValue(dataObject);
	        };
	        _this.onAdjustmentAmountChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onAdjustmentAmountChange ', dataObject.adjustmentAmount);
	            dataObject.adjustmentKoef = round(dataObject.adjustmentAmount / dataObject.basePrice, rootObject.monetaryRounding);
	            _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	            rootObject.$dirty = true;
	            form.updateAllFieldsPropValue(dataObject);
	        };
	        _this.onPriceWithoutVatChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onPriceWithoutVatChange ', dataObject.priceWithoutVat);
	            dataObject.basePriceWithAdjustment = round(dataObject.priceWithoutVat / (1 + rootObject.invoiceAdjustmentKoef), rootObject.monetaryRounding);
	            dataObject.basePrice = round(dataObject.basePriceWithAdjustment / (1 + dataObject.adjustmentKoef), rootObject.monetaryRounding);
	            dataObject.adjustmentAmount = dataObject.basePriceWithAdjustment - dataObject.basePrice;
	            dataObject.invoiceAdjustmentAmount = dataObject.priceWithoutVat - dataObject.basePriceWithAdjustment;
	            dataObject.vatAmount = round(dataObject.priceWithoutVat * dataObject.vatRate, rootObject.monetaryRounding);
	            dataObject.itemPrice = dataObject.priceWithoutVat + dataObject.vatAmount;
	            rootObject.$dirty = true;
	            form.updateAllFieldsPropValue(dataObject);
	        };
	        _this.onItemPriceChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onItemPriceChange ', dataObject.itemPrice);
	            dataObject.priceWithoutVat = round(dataObject.itemPrice / (1 + dataObject.vatRate), rootObject.monetaryRounding);
	            dataObject.vatAmount = dataObject.itemPrice - dataObject.priceWithoutVat;
	            dataObject.basePriceWithAdjustment = round(dataObject.priceWithoutVat / (1 + rootObject.invoiceAdjustmentKoef), rootObject.monetaryRounding);
	            dataObject.basePrice = round(dataObject.basePriceWithAdjustment / (1 + dataObject.adjustmentKoef), rootObject.monetaryRounding);
	            dataObject.adjustmentAmount = dataObject.basePriceWithAdjustment - dataObject.basePrice;
	            dataObject.invoiceAdjustmentAmount = dataObject.priceWithoutVat - dataObject.basePriceWithAdjustment;
	            rootObject.$dirty = true;
	            form.updateAllFieldsPropValue(dataObject);
	        };
	        _this.onVatRateRefChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onVatRateRefChange ', dataObject.vatRateRef);
	            var vatRateId = (0, formUtils_1.lovValue)(dataObject.vatRateRef);
	            return ((vatRateId != null) ? invoiceService_1.default.vatRateValue(vatRateId) : Promise.resolve(null))
	                .then((0, mobx_1.action)("vatRateValue-actionCb", function (value) {
	                dataObject.vatRate = value;
	                _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	                rootObject.$dirty = true;
	                form.updateAllFieldsPropValue(dataObject);
	            }));
	        };
	        _this.onProductChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onProductChange ', dataObject.product);
	            var productId = (0, formUtils_1.lovValue)(dataObject.product);
	            if (productId == null) {
	                dataObject.vatRate = null;
	                _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	                rootObject.$dirty = true;
	                form.updateAllFieldsPropValue(dataObject);
	            }
	            else {
	                var capturedProduct_1;
	                var vatRateValuePromise = productService_1.default.readProduct(productId, (0, formUtils_1.lovValue)(securityService_1.default.currentTenant.party), (0, formUtils_1.lovValue)(rootObject.billedTo))
	                    .then(function (product) {
	                    capturedProduct_1 = product;
	                    var vatRateId = (0, formUtils_1.lovValue)(product.vatRate);
	                    return ((vatRateId != null) ? invoiceService_1.default.vatRateValue(vatRateId) : Promise.resolve(null));
	                });
	                var vehicleId = (0, formUtils_1.lovValue)(dataObject.vehicle);
	                var pricePromise = void 0;
	                if (rootObject.billedTo)
	                    pricePromise = (vehicleId == null) ? productService_1.default.readProductPrice(productId, (0, formUtils_1.lovValue)(rootObject.billedTo), (0, formUtils_1.lovValue)(rootObject.invoiceCurrency))
	                        : productService_1.default.readProductVehiclePrice(productId, vehicleId, (0, formUtils_1.lovValue)(rootObject.billedTo), (0, formUtils_1.lovValue)(rootObject.invoiceCurrency));
	                else
	                    pricePromise = null;
	                return Promise.all([vatRateValuePromise, pricePromise])
	                    .then((0, mobx_1.action)("productChange-actionCb", function (_a) {
	                    var vatRateValue = _a[0], price = _a[1];
	                    if (capturedProduct_1.unitOfMeasure)
	                        dataObject.unitOfMeasure = capturedProduct_1.unitOfMeasure;
	                    dataObject.vatRateRef = capturedProduct_1.vatRate;
	                    dataObject.vatRate = vatRateValue;
	                    dataObject.unitPrice = (0, productUtils_1.priceValue)(price);
	                    dataObject.description = capturedProduct_1.name;
	                    dataObject.productNumber = capturedProduct_1.productNumber;
	                    dataObject.taxType = capturedProduct_1.taxType;
	                    dataObject.basePrice = dataObject.unitPrice * dataObject.quantity;
	                    _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	                    rootObject.$dirty = true;
	                    form.updateAllFieldsPropValue(dataObject);
	                }));
	            }
	        };
	        _this.onVehicleChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onVehicleChange ', dataObject.vehicle);
	            var vehicleId = (0, formUtils_1.lovValue)(dataObject.vehicle);
	            var productId = (0, formUtils_1.lovValue)(dataObject.product);
	            if (vehicleId == null || productId == null || !rootObject.billedTo) {
	                rootObject.$dirty = true;
	                form.updateAllFieldsPropValue(dataObject);
	            }
	            else {
	                return productService_1.default.readProductVehiclePrice(productId, vehicleId, (0, formUtils_1.lovValue)(rootObject.billedTo), (0, formUtils_1.lovValue)(rootObject.invoiceCurrency))
	                    .then((0, mobx_1.action)("vehicleChange-actionCb", function (price) {
	                    dataObject.unitPrice = (0, productUtils_1.priceValue)(price);
	                    dataObject.basePrice = dataObject.unitPrice * dataObject.quantity;
	                    _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	                    rootObject.$dirty = true;
	                    form.updateAllFieldsPropValue(dataObject);
	                }));
	            }
	        };
	        _this.onQuantityChange = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onQuantityChange ', dataObject.quantity);
	            dataObject.basePrice = dataObject.unitPrice * dataObject.quantity;
	            dataObject.adjustmentAmount = round(dataObject.basePrice * dataObject.adjustmentKoef, rootObject.monetaryRounding);
	            _this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
	            rootObject.$dirty = true;
	            form.updateAllFieldsPropValue(dataObject);
	        };
	        _this.onShowParty = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            console.log('onShowParty ', dataObject.quantity);
	            _this.$showParty = true;
	        };
	        return _this;
	    }
	    InvoiceTemplateItemForm.prototype.componentWillMount = function () {
	        var _a = this.props, entities = _a.entities, dataObject = _a.dataObject, form = _a.form;
	        dataObject.$useExpression = (!!dataObject.basePriceExpression || !!dataObject.unitPriceExpression);
	    };
	    InvoiceTemplateItemForm.prototype.computeDerived = function (dataObject, rootObject, precision) {
	        dataObject.basePriceWithAdjustment = dataObject.basePrice + dataObject.adjustmentAmount;
	        dataObject.invoiceAdjustmentAmount = round(dataObject.basePriceWithAdjustment * rootObject.invoiceAdjustmentKoef, precision);
	        dataObject.priceWithoutVat = dataObject.basePriceWithAdjustment + dataObject.invoiceAdjustmentAmount;
	        dataObject.vatAmount = round(dataObject.priceWithoutVat * dataObject.vatRate, precision);
	        dataObject.itemPrice = dataObject.priceWithoutVat + dataObject.vatAmount;
	    };
	    InvoiceTemplateItemForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, formName = _a.formName;
	        var fields = dataObject.getFormFields(formName);
	        var product = fields.product, vehicle = fields.vehicle, productNumber = fields.productNumber, description = fields.description, unitOfMeasure = fields.unitOfMeasure, quantity = fields.quantity, unitPrice = fields.unitPrice, basePrice = fields.basePrice, basePriceExpression = fields.basePriceExpression, unitPriceExpression = fields.unitPriceExpression, adjustmentKoef = fields.adjustmentKoef, adjustmentAmount = fields.adjustmentAmount, priceWithoutVat = fields.priceWithoutVat, vatAmount = fields.vatAmount, itemPrice = fields.itemPrice, vatRate = fields.vatRate, vatRateRef = fields.vatRateRef, invoiceAdjustmentAmount = fields.invoiceAdjustmentAmount, taxType = fields.taxType, comment = fields.comment, party = fields.party;
	        console.debug("InvoiceTemplateItemForm#render() %O", dataObject);
	        var formComp = null;
	        var _showExpressionStyle = (dataObject.$useExpression) ? {} : { display: 'none' };
	        var _hideExpressionStyle = (dataObject.$useExpression) ? { display: 'none' } : {};
	        switch ((0, formUtils_1.lovValue)(dataObject.itemType)) {
	            case invoiceDomain_1.INVOICEITEMTYPE.FREEITEM:
	                formComp = (react_1.default.createElement("div", null,
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, description.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: description, value: description.props.value })),
	                        react_1.default.createElement("div", { className: "fx col-xs-8 col-sm-4" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, vatRateRef.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: vatRateRef, value: vatRateRef.props.value, onSuccess: this.onVatRateRefChange }),
	                            react_1.default.createElement(formUtils_1.FieldText, { label: "", style: { alignSelf: 'flex-end', paddingBottom: 10 }, value: dataObject.vatRate, mdField: vatRate.mdField })),
	                        react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-2", style: { alignSelf: 'center' } },
	                            react_1.default.createElement(Checkbox_1.default, { onCheck: this.handleUseExpressionBase, label: "Expression", checked: dataObject.$useExpression, labelStyle: { marginLeft: -10 } })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2", style: _showExpressionStyle },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, basePriceExpression.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: basePriceExpression, dataObject: dataObject, value: basePriceExpression.props.value, onSuccess: this.onBasePriceExpressionSuccess },
	                                react_1.default.createElement(ComputeBasePriceExpression, null))),
	                        react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-2", style: _hideExpressionStyle },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, basePrice.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: basePrice, value: basePrice.props.value, onSuccess: this.onBasePriceChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-1" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, adjustmentKoef.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: adjustmentKoef, value: adjustmentKoef.props.value, onSuccess: this.onAdjustmentKoefChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, adjustmentAmount.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: adjustmentAmount, value: adjustmentAmount.props.value, onSuccess: this.onAdjustmentAmountChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, priceWithoutVat.props, { disabled: dataObject.$useExpression })),
	                            react_1.default.createElement(validate_1.Validate, { field: priceWithoutVat, value: priceWithoutVat.props.value, onSuccess: this.onPriceWithoutVatChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, vatAmount.props, { disabled: true }))),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, itemPrice.props, { disabled: dataObject.$useExpression })),
	                            react_1.default.createElement(validate_1.Validate, { field: itemPrice, value: itemPrice.props.value, onSuccess: this.onItemPriceChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, taxType.props))),
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: comment, value: comment.props.value },
	                                react_1.default.createElement(rules_1.HasLength, { max: 150 }))))));
	                break;
	            case invoiceDomain_1.INVOICEITEMTYPE.PRODUCTITEM:
	                formComp = (react_1.default.createElement("div", null,
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "fx col-xs-8 col-sm-4" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, product.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Product', {}), clearable: true, asterixForAll: true })),
	                            react_1.default.createElement(validate_1.Validate, { field: product, value: product.props.value, onSuccess: this.onProductChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-2" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, productNumber.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: productNumber, value: productNumber.props.value })),
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, description.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: description, value: description.props.value })),
	                        react_1.default.createElement("div", { className: "fx col-xs-8 col-sm-4" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, vatRateRef.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: vatRateRef, value: vatRateRef.props.value, onSuccess: this.onVatRateRefChange }),
	                            react_1.default.createElement(formUtils_1.FieldText, { label: "", style: { alignSelf: 'flex-end', paddingBottom: 10 }, value: dataObject.vatRate, mdField: vatRate.mdField })),
	                        react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-2", style: { position: 'relative', top: 26 } },
	                            react_1.default.createElement(Checkbox_1.default, { onCheck: this.handleUseExpressionUnit, label: "Expression", checked: dataObject.$useExpression, labelStyle: { marginLeft: -10 } })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2", style: _showExpressionStyle },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, unitPriceExpression.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: unitPriceExpression, dataObject: dataObject, value: unitPriceExpression.props.value, onSuccess: this.onUnitPriceExpressionSuccess },
	                                react_1.default.createElement(ComputeUnitPriceExpression, null))),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2", style: _hideExpressionStyle },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, unitPrice.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: unitPrice, value: unitPrice.props.value, onSuccess: this.onUnitPriceChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, quantity.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: quantity, value: quantity.props.value, onSuccess: this.onQuantityChange },
	                                react_1.default.createElement(rules_1.NumberFormat, { precision: 10, scale: 2 }))),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, unitOfMeasure.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: unitOfMeasure, value: unitOfMeasure.props.value })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, basePrice.props, { disabled: true }))),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, adjustmentKoef.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: adjustmentKoef, value: adjustmentKoef.props.value, onSuccess: this.onAdjustmentKoefChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, adjustmentAmount.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: adjustmentAmount, value: adjustmentAmount.props.value, onSuccess: this.onAdjustmentAmountChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, taxType.props))),
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: comment, value: comment.props.value },
	                                react_1.default.createElement(rules_1.HasLength, { max: 150 })),
	                            react_1.default.createElement(FaUser, { className: "active-item--check zz-ml-15", style: { alignSelf: "center" }, size: 18, onClick: this.onShowParty })),
	                        (!!this.$showParty || party.props.value) &&
	                            react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, party.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.EMPLOYEE] }), clearable: true, asterixForAll: true })))),
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "fx col-xs-12", style: { display: 'flex', alignItems: 'center', flexWrap: 'wrap' } },
	                            (dataObject.invoiceAdjustmentAmount) ?
	                                react_1.default.createElement(formUtils_1.FieldText, { label: invoiceAdjustmentAmount.textLabel, value: dataObject.invoiceAdjustmentAmount, mdField: invoiceAdjustmentAmount.mdField }) : null,
	                            react_1.default.createElement(formUtils_1.FieldText, { label: priceWithoutVat.textLabel, value: dataObject.priceWithoutVat, mdField: priceWithoutVat.mdField }),
	                            react_1.default.createElement(formUtils_1.FieldText, { label: vatAmount.textLabel, value: dataObject.vatAmount, mdField: vatAmount.mdField }),
	                            react_1.default.createElement(formUtils_1.FieldText, { label: itemPrice.textLabel, value: dataObject.itemPrice, mdField: itemPrice.mdField })))));
	                break;
	            case invoiceDomain_1.INVOICEITEMTYPE.PRODUCTVEHICLEITEM:
	                var billedToId = (0, formUtils_1.lovValue)(rootObject.billedTo);
	                formComp = (react_1.default.createElement("div", null,
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "fx col-xs-8 col-sm-4" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, product.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Product', {}), clearable: true, asterixForAll: true })),
	                            react_1.default.createElement(validate_1.Validate, { field: product, value: product.props.value, onSuccess: this.onProductChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-4" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, productNumber.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: productNumber, value: productNumber.props.value })),
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, vehicle.props, { minimumInput: 0, asterixForAll: true, async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Vehicle', { partyId: billedToId }), advancedSearchGL: "invoiceItemVehicleSearch", advancedSearchMasterId: billedToId })),
	                            react_1.default.createElement(validate_1.Validate, { field: vehicle, value: vehicle.props.value, onSuccess: this.onVehicleChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, description.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: description, value: description.props.value })),
	                        react_1.default.createElement("div", { className: "fx col-xs-8 col-sm-4" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, vatRateRef.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: vatRateRef, value: vatRateRef.props.value, onSuccess: this.onVatRateRefChange }),
	                            react_1.default.createElement(formUtils_1.FieldText, { label: "", style: { alignSelf: 'flex-end', paddingBottom: 10 }, value: dataObject.vatRate, mdField: vatRate.mdField })),
	                        react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-1", style: { position: 'relative', top: 26 } },
	                            react_1.default.createElement(Checkbox_1.default, { onCheck: this.handleUseExpressionUnit, label: "Expression", checked: dataObject.$useExpression, labelStyle: { marginLeft: -10 } })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2", style: _showExpressionStyle },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, unitPriceExpression.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: unitPriceExpression, dataObject: dataObject, value: unitPriceExpression.props.value, onSuccess: this.onUnitPriceExpressionSuccess },
	                                react_1.default.createElement(ComputeUnitPriceExpression, null))),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2", style: _hideExpressionStyle },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, unitPrice.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: unitPrice, value: unitPrice.props.value, onSuccess: this.onUnitPriceChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, quantity.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: quantity, value: quantity.props.value, onSuccess: this.onQuantityChange },
	                                react_1.default.createElement(rules_1.NumberFormat, { precision: 8, scale: 0 }))),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, unitOfMeasure.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: unitOfMeasure, value: unitOfMeasure.props.value })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, basePrice.props, { disabled: true }))),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, adjustmentKoef.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: adjustmentKoef, value: adjustmentKoef.props.value, onSuccess: this.onAdjustmentKoefChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, adjustmentAmount.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: adjustmentAmount, value: adjustmentAmount.props.value, onSuccess: this.onAdjustmentAmountChange })),
	                        react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, taxType.props))),
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: comment, value: comment.props.value },
	                                react_1.default.createElement(rules_1.HasLength, { max: 150 })))),
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "fx col-xs-12", style: { display: 'flex', alignItems: 'center', flexWrap: 'wrap' } },
	                            (dataObject.invoiceAdjustmentAmount) ? react_1.default.createElement(formUtils_1.FieldText, { label: invoiceAdjustmentAmount.textLabel, value: dataObject.invoiceAdjustmentAmount, mdField: invoiceAdjustmentAmount.mdField }) : null,
	                            react_1.default.createElement(formUtils_1.FieldText, { label: priceWithoutVat.textLabel, value: dataObject.priceWithoutVat, mdField: priceWithoutVat.mdField }),
	                            react_1.default.createElement(formUtils_1.FieldText, { label: vatAmount.textLabel, value: dataObject.vatAmount, mdField: vatAmount.mdField }),
	                            react_1.default.createElement(formUtils_1.FieldText, { label: itemPrice.textLabel, value: dataObject.itemPrice, mdField: itemPrice.mdField })))));
	                break;
	        }
	        return formComp;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateItemForm.prototype, "$showParty", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateItemForm.prototype, "handleUseExpressionBase", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateItemForm.prototype, "handleUseExpressionUnit", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateItemForm.prototype, "onBasePriceChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateItemForm.prototype, "onBasePriceExpressionSuccess", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateItemForm.prototype, "onUnitPriceChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateItemForm.prototype, "onUnitPriceExpressionSuccess", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateItemForm.prototype, "onAdjustmentKoefChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateItemForm.prototype, "onAdjustmentAmountChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateItemForm.prototype, "onPriceWithoutVatChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateItemForm.prototype, "onItemPriceChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateItemForm.prototype, "onVatRateRefChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateItemForm.prototype, "onProductChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateItemForm.prototype, "onVehicleChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateItemForm.prototype, "onQuantityChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateItemForm.prototype, "onShowParty", void 0);
	    InvoiceTemplateItemForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], InvoiceTemplateItemForm);
	    return InvoiceTemplateItemForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, setDataAction = _a.setDataAction, fields = _a.fields;
	    return (react_1.default.createElement("div", null,
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.product.textLabel, value: dataObject.product }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.productNumber.textLabel, value: dataObject.productNumber }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.vehicle.textLabel, value: dataObject.vehicle })),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.description.textLabel, value: dataObject.description })),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.unitPrice.textLabel, value: dataObject.unitPrice, mdField: fields.unitPrice.mdField }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.quantity.textLabel, value: dataObject.quantity, mdField: fields.quantity.mdField }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.unitOfMeasure.textLabel, value: dataObject.unitOfMeasure }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.basePrice.textLabel, value: dataObject.basePrice, mdField: fields.basePrice.mdField }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.adjustmentKoef.textLabel, value: dataObject.adjustmentKoef, mdField: fields.adjustmentKoef.mdField }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.adjustmentAmount.textLabel, value: dataObject.adjustmentAmount, mdField: fields.adjustmentAmount.mdField })),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.vatRateRef.textLabel, value: dataObject.vatRateRef }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.vatRate.textLabel, value: dataObject.vatRate, mdField: fields.vatRate.mdField }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.priceWithoutVat.textLabel, value: dataObject.priceWithoutVat, mdField: fields.priceWithoutVat.mdField }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.vatAmount.textLabel, value: dataObject.vatAmount, mdField: fields.vatAmount.mdField }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.itemPrice.textLabel, value: dataObject.itemPrice, mdField: fields.itemPrice.mdField }))));
	};
	var definition = {
	    formName: 'InvoiceTemplateItemForm',
	    fields: [{
	            name: 'product',
	            validators: ['IsRequired']
	        }, {
	            name: 'vehicle',
	            validators: ['IsRequired']
	        }, {
	            name: 'productNumber',
	            validators: ['IsRequired']
	        }, {
	            name: 'description',
	            validators: ['IsRequired']
	        }, {
	            name: 'unitOfMeasure',
	            validators: ['IsRequired']
	        }, {
	            name: 'quantity',
	            validators: ['IsNumber', 'IsRequired']
	        }, {
	            name: 'unitPrice',
	            validators: ['IsNumber', 'IsRequired']
	        }, {
	            name: 'basePrice',
	            validators: ['IsRequired', 'IsNumber']
	        }, {
	            name: 'adjustmentKoef',
	            validators: ['IsRequired', 'IsNumber'],
	            numberFormat: '0[.][00000000]%'
	        }, {
	            name: 'adjustmentAmount',
	            validators: ['IsRequired', 'IsNumber']
	        }, {
	            name: 'vatRateRef',
	            validators: ['IsRequired']
	        }, {
	            name: 'priceWithoutVat',
	            validators: ['IsRequired']
	        }, {
	            name: 'vatAmount',
	            validators: ['IsRequired']
	        }, {
	            name: 'itemPrice',
	            validators: ['IsRequired']
	        }, {
	            name: 'vatRate'
	        }, {
	            name: 'invoiceAdjustmentAmount'
	        }, {
	            name: 'unitPriceExpression',
	            validators: [{ validation: 'IsRequired', qualifyExpr: 'that.$useExpression' }]
	        }, {
	            name: 'basePriceExpression',
	            validators: [{ validation: 'IsRequired', qualifyExpr: 'that.$useExpression' }]
	        }, {
	            name: 'comment'
	        }, {
	            name: 'taxType'
	        }, {
	            name: 'party'
	        }]
	};
	exports.default = (0, createForm_1.createForm)(definition, ClosedContent)(InvoiceTemplateItemForm);


/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var formUtils_1 = __webpack_require__(14);
	var arrayUtils_1 = __webpack_require__(78);
	var colors_1 = __webpack_require__(29);
	__webpack_require__(667);
	var mobx_react_1 = __webpack_require__(4);
	var InvoiceTemplateSumTable = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceTemplateSumTable, _super);
	    function InvoiceTemplateSumTable() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    InvoiceTemplateSumTable.prototype.render = function () {
	        var _a = this.props, invoiceTemplateObject = _a.invoiceTemplateObject, entities = _a.entities, invoiceTemplateEntity = _a.invoiceTemplateEntity, style = _a.style;
	        var basePrice = invoiceTemplateEntity.getField('basePrice'), itemAdjustmentAmount = invoiceTemplateEntity.getField('itemAdjustmentAmount'), // Sum (invoiceItem.adjustmentAmount)
	        itemAdjustmentKoef = invoiceTemplateEntity.getField('itemAdjustmentKoef'), // itemAdjustmentAmount / basePrice
	        basePriceWithAdjustment = invoiceTemplateEntity.getField('basePriceWithAdjustment'), // basePrice + itemAdjustmentAmount
	        invoiceAdjustmentKoef = invoiceTemplateEntity.getField('invoiceAdjustmentKoef'), // zadano
	        invoiceAdjustmentAmount = invoiceTemplateEntity.getField('invoiceAdjustmentAmount'), // (basePriceWithAdjustment * invoiceAdjustmentKoef)cr
	        priceWithoutVat = invoiceTemplateEntity.getField('priceWithoutVat'), vatAmount = invoiceTemplateEntity.getField('vatAmount'), totalPrice = invoiceTemplateEntity.getField('totalPrice'), // sum (invoiceItem.itemPrice)
	        pennyAdjustment = invoiceTemplateEntity.getField('pennyAdjustment'), totalAdjustedPrice = invoiceTemplateEntity.getField('totalAdjustedPrice'), invoiceCurrencyLabel = (0, formUtils_1.lovLabel)(invoiceTemplateObject.invoiceCurrency), invoiceCurrencyValue = (0, formUtils_1.lovValue)(invoiceTemplateObject.invoiceCurrency);
	        return (react_1.default.createElement("table", { className: "invoice-sum-table", style: style },
	            react_1.default.createElement("thead", null,
	                react_1.default.createElement("tr", null,
	                    react_1.default.createElement("th", { style: { backgroundColor: colors_1.grey300 } }),
	                    (invoiceTemplateObject.itemAdjustmentAmount || invoiceTemplateObject.invoiceAdjustmentAmount) ? react_1.default.createElement("th", null, basePrice.gridHeaderLabelActive) : null,
	                    (invoiceTemplateObject.itemAdjustmentAmount) ? react_1.default.createElement("th", null, itemAdjustmentAmount.gridHeaderLabelActive) : null,
	                    (invoiceTemplateObject.invoiceAdjustmentAmount) ? react_1.default.createElement("th", null, invoiceAdjustmentAmount.gridHeaderLabelActive) : null,
	                    react_1.default.createElement("th", null, priceWithoutVat.gridHeaderLabelActive),
	                    react_1.default.createElement("th", null, vatAmount.gridHeaderLabelActive),
	                    react_1.default.createElement("th", null, totalPrice.gridHeaderLabelActive),
	                    (invoiceTemplateObject.pennyAdjustment) ? react_1.default.createElement("th", null, pennyAdjustment.gridHeaderLabelActive) : null,
	                    (invoiceTemplateObject.pennyAdjustment) ? react_1.default.createElement("th", null, totalAdjustedPrice.gridHeaderLabelActive) : null)),
	            react_1.default.createElement("tbody", null,
	                react_1.default.createElement("tr", null,
	                    react_1.default.createElement("td", null, invoiceCurrencyLabel),
	                    (invoiceTemplateObject.itemAdjustmentAmount || invoiceTemplateObject.invoiceAdjustmentAmount) ? react_1.default.createElement("td", null, basePrice.formatValue(invoiceTemplateObject.basePrice)) : null,
	                    (invoiceTemplateObject.itemAdjustmentAmount) ? react_1.default.createElement("td", null,
	                        " ",
	                        react_1.default.createElement("div", null, itemAdjustmentAmount.formatValue(invoiceTemplateObject.itemAdjustmentAmount)),
	                        react_1.default.createElement("div", { style: { fontSize: 10 } }, itemAdjustmentKoef.formatValue(invoiceTemplateObject.itemAdjustmentKoef)),
	                        "  ") : null,
	                    (invoiceTemplateObject.invoiceAdjustmentAmount) ? react_1.default.createElement("td", null, invoiceAdjustmentAmount.formatValue(invoiceTemplateObject.invoiceAdjustmentAmount)) : null,
	                    react_1.default.createElement("td", null, priceWithoutVat.formatValue(invoiceTemplateObject.priceWithoutVat)),
	                    react_1.default.createElement("td", null, vatAmount.formatValue(invoiceTemplateObject.vatAmount)),
	                    react_1.default.createElement("td", { className: "invoice-sum-table--big" }, (0, arrayUtils_1.joinNonNull)([totalPrice.formatValue(invoiceTemplateObject.totalPrice), invoiceCurrencyLabel], ' ')),
	                    (invoiceTemplateObject.pennyAdjustment) ? react_1.default.createElement("td", null, pennyAdjustment.formatValue(invoiceTemplateObject.pennyAdjustment)) : null,
	                    (invoiceTemplateObject.pennyAdjustment) ? react_1.default.createElement("td", { className: "invoice-sum-table--big" }, totalAdjustedPrice.formatValue(invoiceTemplateObject.totalAdjustedPrice) + ' ' + invoiceCurrencyLabel) : null))));
	    };
	    InvoiceTemplateSumTable = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], InvoiceTemplateSumTable);
	    return InvoiceTemplateSumTable;
	}(react_1.default.Component));
	exports.default = InvoiceTemplateSumTable;


/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var fields_1 = __webpack_require__(20);
	var form_1 = __webpack_require__(52);
	var createForm_1 = __webpack_require__(18);
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var styledDateInterval_1 = tslib_1.__importDefault(__webpack_require__(130));
	var validate_1 = __webpack_require__(24);
	var invoiceService_1 = tslib_1.__importDefault(__webpack_require__(195));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var errorComp_1 = __webpack_require__(34);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var formUtils_1 = __webpack_require__(14);
	var commonDataService_1 = __webpack_require__(41);
	var Stepper_1 = __webpack_require__(288);
	var mobx_react_1 = __webpack_require__(4);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var mobx_1 = __webpack_require__(5);
	var partyDomain_1 = __webpack_require__(48);
	var dialogAncestor_1 = __webpack_require__(87);
	var mdField_1 = tslib_1.__importStar(__webpack_require__(57));
	var utils_1 = __webpack_require__(37);
	var react_router_1 = __webpack_require__(65);
	var dateUtils_1 = __webpack_require__(49);
	var securityDomain_1 = __webpack_require__(97);
	var colors_1 = __webpack_require__(29);
	var InvoicesIssueDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoicesIssueDialog, _super);
	    function InvoicesIssueDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.prepare = function () {
	            console.log('Preparing issue invoices');
	            var form = _this.issueInvoicesObject.getForm("InvoicesIssueForm");
	            var res = form.validateForm(_this.issueInvoicesObject)
	                && _this.issueInvoicesObject.rates.reduce(function (acc, rate) {
	                    return acc && rate.getForm("InvoicesIssueRateForm").validateForm(rate);
	                }, true);
	            if (!res) {
	                return;
	            }
	            commonService_1.default.loading(true);
	            invoiceService_1.default.doMultipleIssue(_this.issueInvoicesObject, 1)
	                .then((0, mobx_1.action)("prepare-actionCb", function (newIssueInvoicesObject) {
	                commonService_1.default.loading(false);
	                newIssueInvoicesObject.part = 2;
	                newIssueInvoicesObject.showErrors = true;
	                _this.issueInvoicesObject = newIssueInvoicesObject;
	                //this.resolve(count);
	            }), function (error) {
	                _this.$errors = error.getMessages();
	            });
	        };
	        _this.ok = function () {
	            console.log('Issuing invoices');
	            commonService_1.default.loading(true);
	            invoiceService_1.default.doMultipleIssue(_this.issueInvoicesObject, 2)
	                .then((0, mobx_1.action)("ok-actionCb", function (newIssueInvoicesObject) {
	                commonService_1.default.loading(false);
	                newIssueInvoicesObject.part = 3;
	                newIssueInvoicesObject.showErrors = false;
	                _this.issueInvoicesObject = newIssueInvoicesObject;
	            }), function (error) {
	                _this.$errors = error.getMessages();
	            });
	        };
	        _this.close = function () {
	            _this.issueInvoicesObject = null;
	            _this.resolve(null);
	        };
	        _this.cancel = function (evt) {
	            console.log('InvoiceIssueDialog#cancel evt = %O', evt);
	            _this.issueInvoicesObject = null;
	            _this.reject(null);
	        };
	        _this.onShowErrors = function (evt) {
	            _this.issueInvoicesObject.showErrors = evt.target.checked;
	        };
	        return _this;
	    }
	    InvoicesIssueDialog.prototype.open = function (resolve, reject, grid) {
	        var _this = this;
	        uiService_1.default.showToolbarActionFlag();
	        var gridParams = grid.createFullParams();
	        console.log('InvoicesIssueDialog: Opening dialog for ', gridParams);
	        this.resolve = resolve;
	        this.reject = reject;
	        Promise.all([mdEntityService_1.default.fetchEntityMetadata(['Invoice'], ["IssueInvoicesDto"]), invoiceService_1.default.prepareMultipleIssue(gridParams)])
	            .then((0, mobx_1.action)("open-invoiceIssue-actionCb", function (_a) {
	            var entities = _a[0], issueInvoicesObject = _a[1];
	            issueInvoicesObject.initAfterRead(true);
	            var invoiceDateWrapper = (0, moment_1.default)(issueInvoicesObject.invoiceDate);
	            issueInvoicesObject.startInvoicePeriod = invoiceDateWrapper.startOf('month').format("YYYY-MM-DD");
	            issueInvoicesObject.endInvoicePeriod = invoiceDateWrapper.endOf('month').startOf('day').format("YYYY-MM-DD");
	            issueInvoicesObject.part = 1;
	            _this.issueInvoicesObject = issueInvoicesObject;
	            _this.dialogOpen = true;
	            uiService_1.default.hideToolbarActionFlag();
	        }))
	            .catch(function (error) {
	            _this.reject(error);
	        });
	    };
	    InvoicesIssueDialog.prototype.render = function () {
	        var _this = this;
	        var entities = this.props.entities;
	        if (!(this.issueInvoicesObject && this.dialogOpen))
	            return null;
	        var issuableCount = this.issueInvoicesObject.customerNoErrorCount();
	        var cancelButton = react_1.default.createElement(FlatButton_1.default, { label: "Cancel", tabIndex: 0, primary: true, onClick: this.cancel });
	        var showErrorCheckbox = react_1.default.createElement(fields_1.MdCheckbox, { label: "Show Errors", checked: this.issueInvoicesObject.showErrors, labelStyle: { whiteSpace: 'nowrap' }, style: { display: 'inline-block', width: 140, verticalAlign: 'middle' }, onCheck: this.onShowErrors });
	        var actions;
	        if (this.issueInvoicesObject.part === 1) {
	            actions = [cancelButton, react_1.default.createElement(FlatButton_1.default, { label: "Prepare Issue", secondary: true, onClick: this.prepare, disabled: !this.issueInvoicesObject.tupleMap.hasTenantAnyEntityNumberGen })];
	        }
	        else if (this.issueInvoicesObject.part === 2) {
	            actions = [showErrorCheckbox, cancelButton, react_1.default.createElement(FlatButton_1.default, { label: "Recheck", secondary: true, onClick: this.prepare }), react_1.default.createElement(FlatButton_1.default, { label: "Issue !", secondary: true, onClick: this.ok, disabled: issuableCount === 0 })];
	        }
	        else if (this.issueInvoicesObject.part === 3) {
	            actions = [showErrorCheckbox, react_1.default.createElement(FlatButton_1.default, { label: "Close", primary: true, onClick: this.close })];
	        }
	        console.debug("rendering InvoicesIssueDialog ", this.issueInvoicesObject);
	        return (react_1.default.createElement(Dialog_1.default, { actions: actions, modal: true, open: this.dialogOpen, contentStyle: { width: '80%', maxWidth: 800 }, bodyStyle: { overflow: 'visible' } },
	            react_1.default.createElement(Stepper_1.Stepper, { activeStep: this.issueInvoicesObject.part - 1 },
	                react_1.default.createElement(Stepper_1.Step, null,
	                    react_1.default.createElement(Stepper_1.StepLabel, { className: "mui-stepper-icon-hack" },
	                        " ", "Prepare issue (".concat(this.issueInvoicesObject.customerIds.length, ")"),
	                        " ")),
	                react_1.default.createElement(Stepper_1.Step, null,
	                    react_1.default.createElement(Stepper_1.StepLabel, { className: "mui-stepper-icon-hack" },
	                        " ", "Do Issue (".concat(issuableCount, ")"),
	                        " ")),
	                react_1.default.createElement(Stepper_1.Step, null,
	                    react_1.default.createElement(Stepper_1.StepLabel, { className: "mui-stepper-icon-hack" },
	                        " ", "Done (".concat((this.issueInvoicesObject.part === 3) ? issuableCount : 0, ")"),
	                        "  "))),
	            (!this.issueInvoicesObject.tupleMap.hasTenantAnyEntityNumberGen) ?
	                (react_1.default.createElement("div", { style: { display: 'flex' } },
	                    react_1.default.createElement("h5", { style: { marginRight: 2, color: colors_1.pink500, marginTop: 12 } }, "There is no number generation configuration, please create one."))) : null,
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: this.$errors }),
	            (this.issueInvoicesObject.part === 1) ? react_1.default.createElement(InvoicesIssueForm, { entities: entities, entity: entities.get('IssueInvoicesDto'), dataObject: this.issueInvoicesObject, rootObject: this.issueInvoicesObject })
	                : (react_1.default.createElement("div", { style: { overflowY: 'auto', maxHeight: 500 } },
	                    react_1.default.createElement("table", { className: "table table-condensed fullwrap" },
	                        react_1.default.createElement("tbody", null, this.issueInvoicesObject.customerStatuses.filter(function (cs) { return _this.issueInvoicesObject.showErrors || cs.status !== 'ERROR'; }).map(function (cs, index) {
	                            var _className = (0, dialogAncestor_1.entityStatusCss)(cs);
	                            return (react_1.default.createElement("tr", { key: index },
	                                react_1.default.createElement("td", { className: _className },
	                                    react_1.default.createElement(react_router_1.Link, { to: "partyDetail", params: { id: (0, formUtils_1.lovValue)(cs.entityObject) }, query: (0, utils_1.addTenantToQuery)() },
	                                        react_1.default.createElement("span", { className: _className }, (0, formUtils_1.lovLabel)(cs.entityObject))),
	                                    (cs.messages && cs.messages.length) ? (react_1.default.createElement("table", { style: { marginLeft: 20 } },
	                                        react_1.default.createElement("tbody", null, cs.messages.map(function (messageObj, index) { return (react_1.default.createElement("tr", { key: index },
	                                            react_1.default.createElement("td", { className: (0, dialogAncestor_1.validationMessageCss)(messageObj) }, messageObj.message))); })))) : null),
	                                react_1.default.createElement("td", { className: _className }, (0, dialogAncestor_1.entityStatusText)(cs))));
	                        })))))));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoicesIssueDialog.prototype, "issueInvoicesObject", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoicesIssueDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoicesIssueDialog.prototype, "prepare", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoicesIssueDialog.prototype, "ok", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoicesIssueDialog.prototype, "close", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoicesIssueDialog.prototype, "cancel", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoicesIssueDialog.prototype, "onShowErrors", void 0);
	    InvoicesIssueDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], InvoicesIssueDialog);
	    return InvoicesIssueDialog;
	}(dialogAncestor_1.SteppingDialogAncestor));
	exports.default = InvoicesIssueDialog;
	var InvoicesIssueForm = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoicesIssueForm, _super);
	    function InvoicesIssueForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = { servicePeriod: 'thisMonth' };
	        _this.onChangeServicePeriod = function (evt, servicePeriod) {
	            console.log('onChangeServicePeriod ', servicePeriod);
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject;
	            if (servicePeriod === 'thisMonth') {
	                dataObject.startInvoicePeriod = (0, moment_1.default)(dataObject.invoiceDate).startOf('month').format("YYYY-MM-DD");
	                dataObject.endInvoicePeriod = (0, moment_1.default)(dataObject.invoiceDate).endOf('month').startOf('day').format("YYYY-MM-DD");
	            }
	            else if (servicePeriod === 'previousMonth') {
	                dataObject.startInvoicePeriod = (0, moment_1.default)(dataObject.invoiceDate).subtract(1, 'months').startOf('month').format("YYYY-MM-DD");
	                dataObject.endInvoicePeriod = (0, moment_1.default)(dataObject.invoiceDate).subtract(1, 'months').endOf('month').startOf('day').format("YYYY-MM-DD");
	            }
	            _this.setState({ servicePeriod: servicePeriod });
	        };
	        _this.onChangeInvoiceDate = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject;
	            console.log('onChangeInvoiceDate ', dataObject.invoiceDate);
	            if (dataObject.invoiceDate) {
	                dataObject.taxDate = dataObject.invoiceDate;
	            }
	            rootObject.$dirty = true;
	        };
	        _this.onChangeRate = function (rateObject, value) {
	            var rootObject = _this.props.rootObject;
	            console.log('onChangeRate: ', value);
	            rateObject.rate = (value == null) ? '' : value;
	            rootObject.$dirty = true;
	        };
	        _this.issuedByFO = function (option, filter) {
	            return option;
	        };
	        return _this;
	    }
	    InvoicesIssueForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity, index = _a.index, formName = _a.formName;
	        var _b = dataObject.getFormFields(formName), invoiceDate = _b.invoiceDate, taxDate = _b.taxDate, startInvoicePeriod = _b.startInvoicePeriod, endInvoicePeriod = _b.endInvoicePeriod, paymentType = _b.paymentType, profitCenter = _b.profitCenter, issuedBy = _b.issuedBy, internalComment = _b.internalComment, comment = _b.comment, invoiceAdjustmentKoef = _b.invoiceAdjustmentKoef;
	        var months;
	        if (dataObject.startInvoicePeriod && dataObject.endInvoicePeriod) {
	            var duration = moment_1.default.duration((0, moment_1.default)(dataObject.startInvoicePeriod).diff((0, moment_1.default)(dataObject.endInvoicePeriod), 'month', true));
	            months = duration.asMonths();
	            console.log(months);
	        }
	        return (react_1.default.createElement("form", null,
	            react_1.default.createElement("h5", { className: "color-amber-600" }, (dataObject.startInvoicePeriod && dataObject.endInvoicePeriod && !(0, dateUtils_1.isFullMonth)(dataObject.startInvoicePeriod, dataObject.endInvoicePeriod))
	                ? "Invoice Period is not one full month, Invoices with prepaid (longer than one month) periods will not be generated" : null),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                    (securityService_1.default.getTenantParam(securityDomain_1.PARAMKEY.BATCH_INVOICE_SPLIT_PROFIT_CENTER)) ?
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-10" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, profitCenter.props)),
	                                react_1.default.createElement(validate_1.Validate, { field: profitCenter, value: profitCenter.props.value })))
	                        : null,
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "fx col-xs-10" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, paymentType.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: paymentType, value: paymentType.props.value }))),
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "fx col-xs-10" },
	                            react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, invoiceDate.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: invoiceDate, value: invoiceDate.props.value, onSuccess: this.onChangeInvoiceDate }))),
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "fx col-xs-10" },
	                            react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, taxDate.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: taxDate, value: taxDate.props.value }))),
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "fx col-xs-10" },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, issuedBy.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.USER_ROLE] }), clearable: true, asterixForAll: true })))),
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "col-xs-10" },
	                            react_1.default.createElement(styledDateInterval_1.default, tslib_1.__assign({}, startInvoicePeriod.props, { valueFrom: startInvoicePeriod.props.value, valueTo: endInvoicePeriod.props.value, onChangeFrom: startInvoicePeriod.props.onChange, onChangeTo: endInvoicePeriod.props.onChange })),
	                            react_1.default.createElement(validate_1.Validate, { field: startInvoicePeriod, value: startInvoicePeriod.props.value }),
	                            react_1.default.createElement(validate_1.Validate, { field: endInvoicePeriod, value: endInvoicePeriod.props.value }))),
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "fx col-xs-10" },
	                            react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, invoiceAdjustmentKoef.props)),
	                            react_1.default.createElement(validate_1.Validate, { field: invoiceAdjustmentKoef, value: invoiceAdjustmentKoef.props.value })))),
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                    react_1.default.createElement("h6", null, "Rates for Invoice currency / Local curency:"),
	                    react_1.default.createElement("table", { className: "table table-condensed fullwrap" },
	                        react_1.default.createElement("tbody", null, (dataObject.rates) ?
	                            dataObject.rates.map(function (rateObject, index) { return (react_1.default.createElement(InvoicesIssueRateForm, { entities: entities, dataObject: rateObject, rootObject: dataObject })); })
	                            : null)),
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "fx col-xs-12" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props, { multiLine: true, rows: 2 })))),
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "fx col-xs-12" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, internalComment.props, { multiLine: true, rows: 2 }))))))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoicesIssueForm.prototype, "onChangeServicePeriod", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoicesIssueForm.prototype, "onChangeInvoiceDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoicesIssueForm.prototype, "onChangeRate", void 0);
	    InvoicesIssueForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'InvoicesIssueForm',
	            fields: [{
	                    name: 'invoiceDate',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'taxDate',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'startInvoicePeriod',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'invoiceAdjustmentKoef',
	                    validators: ['IsRequired', 'IsNumber']
	                }, {
	                    name: 'paymentType',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'endInvoicePeriod',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'issuedBy'
	                }, {
	                    name: 'comment',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	                }, {
	                    name: 'internalComment',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	                }, {
	                    name: 'profitCenter'
	                }]
	        }, function () { return react_1.default.createElement("noscript", null); }),
	        mobx_react_1.observer
	    ], InvoicesIssueForm);
	    return InvoicesIssueForm;
	}(react_1.default.Component));
	var InvoicesIssueRateForm = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoicesIssueRateForm, _super);
	    function InvoicesIssueRateForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    InvoicesIssueRateForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entity = _a.entity, index = _a.index, entities = _a.entities, formName = _a.formName;
	        var fields = dataObject.getFormFields(formName);
	        var rate = fields.rate;
	        return (react_1.default.createElement("tr", { key: index },
	            react_1.default.createElement("td", { style: { verticalAlign: 'bottom', lineHeight: 2.9 } }, dataObject.ccy1 + '/' + dataObject.ccy2),
	            react_1.default.createElement("td", null,
	                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, rate.props, createForm_1.fieldStyles.small.styledSelect)),
	                react_1.default.createElement(validate_1.Validate, { field: rate, value: rate.props.value })),
	            react_1.default.createElement("td", { style: { color: colors_1.grey500, fontSize: 12, verticalAlign: 'bottom' } }, dataObject.label)));
	    };
	    InvoicesIssueRateForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'InvoicesIssueRateForm',
	            fields: [{
	                    name: 'rate',
	                    mdField: new mdField_1.default({ label: 'Size', dataType: mdField_1.DATATYPE.NUMBER }),
	                    validators: ['IsRequired', 'IsNumber']
	                }]
	        }, function () { return react_1.default.createElement("noscript", null); }),
	        mobx_react_1.observer
	    ], InvoicesIssueRateForm);
	    return InvoicesIssueRateForm;
	}(react_1.default.Component));


/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.VatRateClosedContent = exports.VatRateFormDefinition = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var closedForm_1 = __webpack_require__(82);
	var createForm_1 = __webpack_require__(18);
	exports.VatRateFormDefinition = {
	    formName: "VatRateForm",
	    fields: [
	        {
	            name: "name",
	            validators: ['IsRequired']
	        },
	        {
	            name: "validFrom",
	            validators: ['IsRequired']
	        },
	        {
	            name: "validTo",
	            validators: ['IsRequired']
	        },
	        {
	            name: "vatRateCountry",
	            validators: ['IsRequired']
	        },
	        {
	            name: "noVat",
	            validators: ['IsRequired']
	        }
	    ]
	};
	var VatRateForm = /** @class */ (function (_super) {
	    tslib_1.__extends(VatRateForm, _super);
	    function VatRateForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    VatRateForm.prototype.render = function () {
	        return (react_1.default.createElement("noscript", null));
	    };
	    VatRateForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], VatRateForm);
	    return VatRateForm;
	}(react_1.default.Component));
	var VatRateClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields;
	    return (react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields },
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.name.textLabel, value: dataObject.name }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.validFrom.textLabel, value: dataObject.validFrom }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.validTo.textLabel, value: dataObject.validTo }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.vatRateCountry.textLabel, value: dataObject.vatRateCountry }),
	        react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.noVat.textLabel, value: dataObject.noVat ? "TRUE" : "FALSE" })));
	};
	exports.VatRateClosedContent = VatRateClosedContent;
	exports.default = (0, createForm_1.createForm)(exports.VatRateFormDefinition, exports.VatRateClosedContent)(VatRateForm);


/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var metaConstant_1 = __webpack_require__(13);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var entityNumberGenDomain_1 = __webpack_require__(946);
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var buttons_1 = __webpack_require__(27);
	var entityNumberGenService_1 = tslib_1.__importDefault(__webpack_require__(947));
	var mobx_1 = __webpack_require__(5);
	var errorComp_1 = __webpack_require__(34);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var entityNumberGenGroupForm_1 = tslib_1.__importDefault(__webpack_require__(2140));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var formUtils_1 = __webpack_require__(14);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var constants_1 = __webpack_require__(404);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var grid_1 = __webpack_require__(50);
	var gridUtils_1 = __webpack_require__(83);
	var gridComp_1 = tslib_1.__importStar(__webpack_require__(44));
	var EntityNumberGenForm_1 = tslib_1.__importStar(__webpack_require__(2137));
	var icons_1 = __webpack_require__(63);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var EntityNumberGenGroupDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(EntityNumberGenGroupDetail, _super);
	    function EntityNumberGenGroupDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.customValidate = function (genGroupObject) {
	            var errors = [];
	            var numberGenGrid = entityNumberGenService_1.default.entityGenGroupObject.$movingBlocks.getBlock(constants_1.ENTITY_NUMBER_GEN_LIST);
	            var editedRows = numberGenGrid.getEditedRows().filter(function (e) { return !e.getId(); });
	            if (editedRows.length > 1) {
	                var hasError = false;
	                for (var i = 0; i < editedRows.length; i++) {
	                    var noGen = editedRows[i];
	                    var firstGenNo = "".concat(noGen.prefixConstant).concat("0".repeat(noGen.padding));
	                    for (var j = (i + 1); j < editedRows.length; j++) {
	                        var nextNoGen = editedRows[j];
	                        if (noGen.prefixConstant === nextNoGen.prefixConstant) {
	                            errors.push({ message: "There are number generation configurations with same prefix constant" });
	                            hasError = true;
	                            break;
	                        }
	                        if (firstGenNo.startsWith(nextNoGen.prefixConstant) && noGen.getNumberLength() === (nextNoGen.getNumberLength())) {
	                            errors.push({ message: "There are number generation configurations that can generate same numbers" });
	                            hasError = true;
	                            break;
	                        }
	                    }
	                    if (hasError)
	                        break;
	                }
	            }
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave entityNumberGenGroupId = %s, $new = %s', entityNumberGenService_1.default.entityGenGroupObject.entityNumberGenGroupId, entityNumberGenService_1.default.entityGenGroupObject.$new);
	            uiService_1.default.showToolbarActionFlag();
	            var result = (0, formUtils_1.preSave)(entityNumberGenService_1.default.entityGenGroupObject, _this.customValidate, true);
	            if (!result) {
	                return;
	            }
	            entityNumberGenService_1.default.saveGenGroup(entityNumberGenService_1.default.entityGenGroupObject.createDataObjectDto())
	                .then((0, mobx_1.action)("entityGenGroupSave", function (entityGenGroupJson) {
	                var wasNew = entityNumberGenService_1.default.entityGenGroupObject.cleanAfterSave(entityGenGroupJson);
	                if (wasNew)
	                    _this.context.router.replaceWith('entityNumberGenGroupDetail', { id: entityNumberGenService_1.default.entityGenGroupObject.entityNumberGenGroupId });
	                uiService_1.default.hideToolbarActionFlag();
	            }), function (error) {
	                entityNumberGenService_1.default.entityGenGroupObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            _this.context.router.transitionTo("entityNumberGenGroupDetail", { id: 'new' });
	        };
	        _this.onCopy = function (evt) {
	            console.log('onCopy');
	            _this.context.router.transitionTo("entityNumberGenGroupDetail", { id: 'copy' }, { copyId: entityNumberGenService_1.default.entityGenGroupObject.entityNumberGenGroupId });
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            new Promise(function (resolve, reject) {
	                _this.confirmationDialogRef.open(resolve, reject, 'Do you really want to delete this group with its number gens?');
	            }).then(function () {
	                uiService_1.default.showToolbarActionFlag();
	                entityNumberGenService_1.default.deleteGenGroup(entityNumberGenService_1.default.entityGenGroupObject.entityNumberGenGroupId)
	                    .then(function (_) {
	                    _this.goBackOrHome();
	                    uiService_1.default.hideToolbarActionFlag();
	                }, function (error) {
	                    entityNumberGenService_1.default.entityGenGroupObject.$errors = error.getMessages();
	                });
	            }).catch(function (e) {
	            });
	        };
	        _this.copyEntityNumberGen = function (entityGenGroup) {
	            entityGenGroup.entityNumberGenId = undefined;
	            entityGenGroup.dateCreated = undefined;
	            entityGenGroup.dateUpdated = undefined;
	            entityGenGroup.userCreated = undefined;
	            entityGenGroup.tenantId = undefined;
	            return entityGenGroup;
	        };
	        _this.addEntityNumberGen = function () {
	            console.log('addEntityNumberGen');
	            var grid = entityNumberGenService_1.default.entityGenGroupObject.$movingBlocks.getBlock(constants_1.ENTITY_NUMBER_GEN_LIST);
	            var rowObject = new entityNumberGenDomain_1.EntityNumberGen(tslib_1.__assign(tslib_1.__assign({ group: entityNumberGenService_1.default.entityGenGroupObject.createLov(), active: true }, _this.prepareNewNumberGenDefaults()), { $new: true, $dirty: true, $added: true })).initDefaultValues();
	            grid.addRow(rowObject);
	            var form = rowObject.getForm(EntityNumberGenForm_1.EntityNumberGenFormDefinition.formName);
	            form.$open = true;
	            entityNumberGenService_1.default.entityGenGroupObject.$dirty = true;
	        };
	        _this.disableDelete = function (numberGen) {
	            return !!numberGen.entityNumberGenId;
	        };
	        _this.confirmationDialogRefHandler = function (comp) { return _this.confirmationDialogRef = comp; };
	        return _this;
	    }
	    EntityNumberGenGroupDetail.fetchData = function (routerParams, query) {
	        console.log("EntityNumberGenGroupDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata([constants_1.ENTITY_NUMBER_GEN_GROUP_ENTITY, constants_1.ENTITY_NUMBER_GEN_ENTITY], [{ entity: 'MdEntity', lov: true }]);
	        var gridPromise = gridService_1.default.fetchGrids(constants_1.ENTITY_NUMBER_GEN_LIST);
	        var entityGenGroupObjectPromise;
	        if (routerParams.id === 'new') {
	            entityGenGroupObjectPromise = Promise.resolve(new entityNumberGenDomain_1.EntityNumberGenGroup({ $new: true }));
	        }
	        else if (routerParams.id === 'copy') {
	            entityGenGroupObjectPromise = entityNumberGenService_1.default.readEntityNumberGenGroup(query.copyId)
	                .then(function (entityGenGroupObject) {
	                entityGenGroupObject.cleanOnCopy();
	                entityGenGroupObject.entityNumberGenGroupId = undefined;
	                entityGenGroupObject.numberGenList.forEach(function (e) {
	                    e.group = undefined;
	                    e.entityNumberGenId = undefined;
	                    e.$dirty = true;
	                    e.$new = true;
	                    e.$added = true;
	                });
	                return entityGenGroupObject;
	            });
	        }
	        else {
	            entityGenGroupObjectPromise = entityNumberGenService_1.default.readEntityNumberGenGroup(routerParams.id);
	        }
	        return Promise.all([metadataPromise, entityGenGroupObjectPromise, gridPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], entityGenGroupObject = _a[1], gridLocationMap = _a[2];
	            entityGenGroupObject.$new = !entityGenGroupObject.entityNumberGenGroupId;
	            entityGenGroupObject.$movingBlocks = new gridUtils_1.MovingBlocks(null, false, null, new grid_1.ClientGrid(gridLocationMap.get(constants_1.ENTITY_NUMBER_GEN_LIST), "numberGenList", entityGenGroupObject.entityNumberGenGroupId));
	            if (routerParams.id === 'copy')
	                entityGenGroupObject.$movingBlocks.getBlock(constants_1.ENTITY_NUMBER_GEN_LIST).$dirty = true;
	            entityNumberGenService_1.default.entityGenGroupObject = entityGenGroupObject.initAfterRead(routerParams.id === 'new');
	        });
	    };
	    EntityNumberGenGroupDetail.prototype.componentDidUpdate = function (prevProps) {
	        if (prevProps.params.id !== this.props.params.id)
	            entityNumberGenService_1.default.entityGenGroupObject.$movingBlocks.searchExposedGrids(entityNumberGenService_1.default.entityGenGroupObject);
	    };
	    EntityNumberGenGroupDetail.prototype.componentDidMount = function () {
	        entityNumberGenService_1.default.entityGenGroupObject.$movingBlocks.searchExposedGrids(entityNumberGenService_1.default.entityGenGroupObject);
	    };
	    EntityNumberGenGroupDetail.prototype.componentWillUnmount = function () {
	        entityNumberGenService_1.default.entityGenGroupObject = null;
	    };
	    EntityNumberGenGroupDetail.prototype.findRootObject = function () {
	        return entityNumberGenService_1.default.entityGenGroupObject;
	    };
	    EntityNumberGenGroupDetail.prototype.prepareNewNumberGenDefaults = function () {
	        if (!entityNumberGenService_1.default.entityGenGroupObject.numberGenList || entityNumberGenService_1.default.entityGenGroupObject.numberGenList.length === 0)
	            return {};
	        var lastGen = entityNumberGenService_1.default.entityGenGroupObject.numberGenList
	            .reduce(function (prev, current) { return (prev.entityNumberGenId > current.entityNumberGenId) ? prev : current; });
	        var nextYear = new Date().getFullYear() + 1;
	        var foundNos = lastGen.prefixConstant.match(/\d+/g);
	        var prefixConstant = lastGen.prefixConstant;
	        var validFrom = new Date(lastGen.validFrom);
	        if (validFrom)
	            validFrom.setFullYear(nextYear);
	        var validTo = lastGen.validTo ? new Date(lastGen.validTo) : null;
	        if (validTo)
	            validTo.setFullYear(nextYear);
	        if (foundNos) {
	            var noFromPrefix = foundNos[foundNos.length - 1];
	            prefixConstant = prefixConstant.replace(noFromPrefix, (parseInt(noFromPrefix) + 1).toString());
	        }
	        return {
	            padding: lastGen.padding,
	            prefixConstant: prefixConstant,
	            validFrom: validFrom,
	            validTo: validTo
	        };
	    };
	    EntityNumberGenGroupDetail.prototype._createToolMenu = function (entityGenGroupObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: History.length <= 1 },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !entityGenGroupObject.$dirty, label: "Save", permission: entityGenGroupObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, disabled: entityGenGroupObject.$new, label: "New", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onCopy, disabled: entityGenGroupObject.$new, label: "Copy", permission: metaConstant_1.PERMISSION.New }),
	            (!entityGenGroupObject.numberGenList || entityGenGroupObject.numberGenList.length === 0) ?
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onDelete, disabled: entityGenGroupObject.$new, label: "Delete", permission: metaConstant_1.PERMISSION.Delete }) : null));
	    };
	    EntityNumberGenGroupDetail.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        var entityGenGroupObject = entityNumberGenService_1.default.entityGenGroupObject;
	        var propsForForm = {
	            dataObject: entityGenGroupObject,
	            rootObject: entityGenGroupObject,
	            entity: mdEntityService_1.default.getEntity(constants_1.ENTITY_NUMBER_GEN_GROUP_ENTITY),
	            entities: mdEntityService_1.default.entityMap
	        };
	        var _renderEntityNumberGenGroupForm = (react_1.default.createElement(entityNumberGenGroupForm_1.default, tslib_1.__assign({}, propsForForm)));
	        var _rowEntityNumberGenForm = (react_1.default.createElement(EntityNumberGenForm_1.default, { rootObject: entityGenGroupObject, entity: mdEntityService_1.default.getEntity(constants_1.ENTITY_NUMBER_GEN_ENTITY), entities: mdEntityService_1.default.entityMap, dataObject: null }));
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	            this._createToolMenu(entityGenGroupObject, query.gridLocation),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: entityGenGroupObject.$errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement(confirmationDialog_1.default, { okButtonText: "Yes", cancelButtonText: "No", ref: this.confirmationDialogRefHandler }),
	            _renderEntityNumberGenGroupForm,
	            react_1.default.createElement(gridComp_1.default, { ref: constants_1.ENTITY_NUMBER_GEN_LIST, grid: entityGenGroupObject.$movingBlocks.getBlock(constants_1.ENTITY_NUMBER_GEN_LIST), uiLocation: gridComp_1.UILOCATION.main, entities: mdEntityService_1.default.entityMap, rootObject: entityGenGroupObject, editForm: _rowEntityNumberGenForm, editFormName: EntityNumberGenForm_1.EntityNumberGenFormDefinition.formName, showEdit: true, deleteRowIcon: "fa fa-trash", multiSelect: false, showDelete: true, disableDeleteFn: this.disableDelete, multiUpdateSaveFn: this.onSave, copyRowObjectFn: this.copyEntityNumberGen },
	                react_1.default.createElement(icons_1.MdIconButton, { onToolbar: true, onClick: this.addEntityNumberGen },
	                    react_1.default.createElement(add_1.default, null)))));
	    };
	    EntityNumberGenGroupDetail.module = metaConstant_1.MODULE.invoicing;
	    EntityNumberGenGroupDetail.title = 'Entity number gen group';
	    EntityNumberGenGroupDetail.icon = 'group';
	    EntityNumberGenGroupDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EntityNumberGenGroupDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EntityNumberGenGroupDetail.prototype, "onAdd", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EntityNumberGenGroupDetail.prototype, "onCopy", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EntityNumberGenGroupDetail.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EntityNumberGenGroupDetail.prototype, "copyEntityNumberGen", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], EntityNumberGenGroupDetail.prototype, "addEntityNumberGen", void 0);
	    EntityNumberGenGroupDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EntityNumberGenGroupDetail);
	    return EntityNumberGenGroupDetail;
	}(pageAncestor_1.default));
	exports.default = EntityNumberGenGroupDetail;


/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var constants_1 = __webpack_require__(404);
	var routes_1 = __webpack_require__(75);
	var buttons_1 = __webpack_require__(27);
	var EntityNumberGenGroupList = /** @class */ (function (_super) {
	    tslib_1.__extends(EntityNumberGenGroupList, _super);
	    function EntityNumberGenGroupList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    EntityNumberGenGroupList.fetchData = function (routerParams) {
	        console.log("EntityNumberGenGroupList#fetchData(%s)", constants_1.ENTITY_NUMBER_GEN_GROUP_LIST);
	        return gridService_1.default.fetchGrids(constants_1.ENTITY_NUMBER_GEN_GROUP_LIST)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(constants_1.ENTITY_NUMBER_GEN_GROUP_LIST);
	        });
	    };
	    EntityNumberGenGroupList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(constants_1.ENTITY_NUMBER_GEN_GROUP_LIST), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "entityNumberGenGroupDetail", params: { id: 'new' }, label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["number.gen.group.new"], ["number.gen.group.new"]))), permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.entityNumberGenGroupDetail })));
	    };
	    EntityNumberGenGroupList.module = metaConstant_1.MODULE.invoicing;
	    EntityNumberGenGroupList.title = locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Entity number gen"], ["Entity number gen"])));
	    EntityNumberGenGroupList.icon = 'line-chart';
	    EntityNumberGenGroupList.rootPage = true;
	    EntityNumberGenGroupList.protectedPage = true;
	    EntityNumberGenGroupList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EntityNumberGenGroupList);
	    return EntityNumberGenGroupList;
	}(pageAncestor_1.default));
	exports.default = EntityNumberGenGroupList;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_router_1 = __webpack_require__(65);
	var buttons_1 = __webpack_require__(27);
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var icons_1 = __webpack_require__(63);
	var MenuItem_1 = tslib_1.__importDefault(__webpack_require__(101));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var invoiceService_1 = tslib_1.__importStar(__webpack_require__(195));
	var errorComp_1 = __webpack_require__(34);
	var formUtils_1 = __webpack_require__(14);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridComp_1 = tslib_1.__importStar(__webpack_require__(44));
	var grid_1 = __webpack_require__(50);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var customerForm_1 = tslib_1.__importStar(__webpack_require__(2138));
	var invoiceForm_1 = tslib_1.__importDefault(__webpack_require__(2142));
	var invoiceItemForm_1 = tslib_1.__importDefault(__webpack_require__(2144));
	var productUtils_1 = __webpack_require__(405);
	var invoiceSumTable_1 = tslib_1.__importDefault(__webpack_require__(945));
	var invoiceIssueDialog_1 = tslib_1.__importDefault(__webpack_require__(2143));
	var blockComp_1 = __webpack_require__(30);
	var watermark_1 = __webpack_require__(929);
	var documentComp_1 = tslib_1.__importDefault(__webpack_require__(400));
	var utils_1 = __webpack_require__(37);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var more_vert_1 = tslib_1.__importDefault(__webpack_require__(291));
	var Divider_1 = tslib_1.__importDefault(__webpack_require__(241));
	var arrayUtils_1 = __webpack_require__(78);
	var documentService_1 = tslib_1.__importDefault(__webpack_require__(110));
	var metaConstant_1 = __webpack_require__(13);
	__webpack_require__(203);
	var mobx_react_1 = __webpack_require__(4);
	var invoiceDomain_1 = __webpack_require__(157);
	var mobx_1 = __webpack_require__(5);
	var gridUtils_1 = __webpack_require__(83);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var eventDomain_1 = __webpack_require__(74);
	var documentDomain_1 = __webpack_require__(109);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var invoicePayment_1 = __webpack_require__(2145);
	var Tabs_1 = tslib_1.__importDefault(__webpack_require__(107));
	var Tab_1 = tslib_1.__importDefault(__webpack_require__(102));
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var emailComponents_1 = __webpack_require__(932);
	var invoiceAdvancedForm_1 = tslib_1.__importDefault(__webpack_require__(2141));
	var locales_1 = __webpack_require__(15);
	var dynamicFields_1 = __webpack_require__(940);
	var dateUtils_1 = __webpack_require__(49);
	var pullAll = __webpack_require__(484);
	var history_1 = tslib_1.__importDefault(__webpack_require__(777));
	var react_bootstrap_1 = __webpack_require__(72);
	var InvoiceBlockTable = (0, mobx_react_1.observer)(function (_a) {
	    var fieldList = _a.fieldList, entity = _a.entity, dataObject = _a.dataObject;
	    var values = fieldList.filter(function (v) { return (typeof v === 'string') ? (dataObject[v] != null) : v.show(dataObject); })
	        .map(function (v) {
	        if (typeof v === 'string') {
	            var mdField = entity.getField(v);
	            return { value: (0, formUtils_1.formatValue)(dataObject[v], mdField), label: mdField.formLabelActive };
	        }
	        else {
	            return { value: v.value(dataObject), label: v.label(dataObject) };
	        }
	    });
	    return (react_1.default.createElement("table", { className: "invoice-block-table" },
	        react_1.default.createElement("tbody", null, values.map(function (lov, index) { return (react_1.default.createElement("tr", { key: index },
	            react_1.default.createElement("td", null, lov.label),
	            react_1.default.createElement("td", null, lov.value))); }))));
	});
	var CONCEPT_TABS = ["main", 'advanced', 'parameters'];
	var ISSUED_TABS = ["detail", 'settlement'];
	var InvoiceDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceDetail, _super);
	    function InvoiceDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.customValidate = function (invoiceObject) {
	            var errors = [];
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave invoiceId = %s, $new = %s', invoiceService_1.default.invoiceObject.invoiceId, invoiceService_1.default.invoiceObject.$new);
	            // pridame do invoiceObject.items z otevrenych formu na gridu
	            var grid = invoiceService_1.default.invoiceObject.$movingBlocks.getBlock(invoiceService_1.invoiceItemGridLocation);
	            _this.commitOpenItems(grid);
	            var result = (0, formUtils_1.preSave)(invoiceService_1.default.invoiceObject, _this.customValidate, true);
	            if (!result) {
	                return;
	            }
	            uiService_1.default.showToolbarActionFlag();
	            invoiceService_1.default.invoiceSave(invoiceService_1.default.invoiceObject)
	                .then((0, mobx_1.action)("invoiceSave-action", function (invoiceJson) {
	                var wasNew = invoiceService_1.default.invoiceObject.cleanAfterSave(invoiceJson);
	                if (wasNew) {
	                    _this.context.router.replaceWith('invoiceDetail', { id: invoiceService_1.default.invoiceObject.invoiceId });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            }), function (error) {
	                invoiceService_1.default.invoiceObject.$errors = error.getMessages();
	            });
	        };
	        _this.onIssue = function (invoiceTypeId, fastIssue, evt) {
	            console.log('onIssue invoiceType ' + invoiceTypeId + ", fastIssue = " + fastIssue);
	            var grid = invoiceService_1.default.invoiceObject.$movingBlocks.getBlock(invoiceService_1.invoiceItemGridLocation);
	            // pridame do invoiceObject.items z otevrenych formu na gridu
	            _this.commitOpenItems(grid);
	            var result = (0, formUtils_1.preSave)(invoiceService_1.default.invoiceObject, _this.customValidate, true);
	            if (!result) {
	                return;
	            }
	            new Promise(function (resolve, reject) {
	                _this.invoiceIssueDialogRef.open(resolve, reject, invoiceTypeId, fastIssue);
	            }).then(function (wasNew) {
	                grid.generateGridData(invoiceService_1.default.invoiceObject);
	                uiService_1.default.hideToolbarActionFlag();
	                if (wasNew) {
	                    _this.context.router.replaceWith('invoiceDetail', { id: invoiceService_1.default.invoiceObject.invoiceId });
	                }
	                commonService_1.default.notifySuccess((0, formUtils_1.lovLabel)(invoiceService_1.default.invoiceObject.invoiceType) + ' was issued with number ' + invoiceService_1.default.invoiceObject.invoiceNumber);
	            }).catch(function (e) {
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            var query = { paymentTypeId: 1 };
	            _this.context.router.transitionTo("invoiceDetail", { id: 'new' }, query);
	        };
	        _this.onCopy = function (evt) {
	            console.log('onCopy');
	            _this.context.router.transitionTo("invoiceDetail", { id: 'copy' }, { copyId: invoiceService_1.default.invoiceObject.invoiceId });
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            invoiceService_1.default.deleteInvoice(invoiceService_1.default.invoiceObject.invoiceId)
	                .then(function (response) {
	                _this.goBackOrHome();
	            }, function (error) {
	                invoiceService_1.default.invoiceObject.$errors = error.getMessages();
	            });
	        };
	        _this.onCancel = function (evt) {
	            console.log('onCancel');
	            new Promise(function (resolve, reject) {
	                _this.confirmationDialogRef.open(resolve, reject, 'Do you really want to cancel this ' + (0, formUtils_1.lovLabel)(invoiceService_1.default.invoiceObject.invoiceType) + ' ?');
	            }).then(function () {
	                console.log('do cancel');
	                uiService_1.default.showToolbarActionFlag();
	                invoiceService_1.default.cancelInvoice(invoiceService_1.default.invoiceObject)
	                    .then(function (invoiceJson) {
	                    invoiceService_1.default.invoiceObject.cleanAfterSave(invoiceJson);
	                    uiService_1.default.hideToolbarActionFlag();
	                }, function (error) {
	                    invoiceService_1.default.invoiceObject.$errors = error.getMessages();
	                });
	            }).catch(function (e) {
	            });
	        };
	        _this.onReopen = function (evt) {
	            console.log('onReopen');
	            new Promise(function (resolve, reject) {
	                _this.confirmationDialogRef.open(resolve, reject, 'Do you really want to reopen this ' + (0, formUtils_1.lovLabel)(invoiceService_1.default.invoiceObject.invoiceType) + ' ?');
	            }).then(function () {
	                console.log('do reopen');
	                uiService_1.default.showToolbarActionFlag();
	                invoiceService_1.default.reopenInvoice(invoiceService_1.default.invoiceObject)
	                    .then(function (invoiceJson) {
	                    invoiceService_1.default.invoiceObject.cleanAfterSave(invoiceJson);
	                    if (invoiceService_1.default.invoiceObject.tupleMap) {
	                        invoiceService_1.default.invoiceObject.tupleMap.hasEntityNumberGenDefault = null;
	                        invoiceService_1.default.invoiceObject.tupleMap.hasSeveralDefaultEntityNumberGen = null;
	                    }
	                    uiService_1.default.hideToolbarActionFlag();
	                }, function (error) {
	                    invoiceService_1.default.invoiceObject.$errors = error.getMessages();
	                });
	            }).catch(function (e) {
	            });
	        };
	        _this.handleSend = function (evt) {
	            console.log('handleSend - ' + (0, formUtils_1.lovValue)(invoiceService_1.default.invoiceObject.sendType));
	            var sendType = (0, formUtils_1.lovValue)(invoiceService_1.default.invoiceObject.sendType);
	            if (sendType === eventDomain_1.SENDTYPE.EMAIL) {
	                invoiceService_1.default.emailAddresses(invoiceService_1.default.invoiceObject)
	                    .then(function (emailAddresses) {
	                    return new Promise(function (resolve, reject) {
	                        _this.emailAddressesEditorDialogRef.open(resolve, reject, (0, mobx_1.observable)({ emails: emailAddresses }), invoiceService_1.default.invoiceObject.documents.some(function (d) { return (0, formUtils_1.lovValue)(d.attachmentType) === documentDomain_1.DOCUMENTATTACHMENTTYPE.SEPARATE_INCLUDE; }), "Email Invoice");
	                    });
	                })
	                    .then((0, mobx_1.action)("sendEmails", function (dto) {
	                    uiService_1.default.showToolbarActionFlag();
	                    var emails = dto.emails, insertSeparateDocsIntoMain = dto.insertSeparateDocsIntoMain;
	                    console.log("Sending to emails: %o", emails);
	                    return invoiceService_1.default.sendInvoice(invoiceService_1.default.invoiceObject, false, insertSeparateDocsIntoMain, invoiceService_1.default.invoiceObject.invoiceStatus == invoiceDomain_1.INVOICESTATUS.CONCEPT ? eventDomain_1.EVENTTYPE.INVOICE_CONCEPT_SENT_EMAIL : undefined, emails);
	                }))
	                    .then(function (res) {
	                    uiService_1.default.hideToolbarActionFlag();
	                })
	                    .catch(function (e) {
	                });
	            }
	            else if (sendType === eventDomain_1.SENDTYPE.POST) {
	                new Promise(function (resolve, reject) {
	                    _this.confirmationDialogRef.open(resolve, reject, 'Do you really want to post this ' + (0, formUtils_1.lovLabel)(invoiceService_1.default.invoiceObject.invoiceType) + ' ?');
	                }).then(function () {
	                    var invoicePrintWindow = window.open("about:blank", 'invoicePrint');
	                    return invoiceService_1.default.sendInvoice(invoiceService_1.default.invoiceObject, false, false, undefined, undefined)
	                        .then(function (invoiceJson) {
	                        invoiceService_1.default.invoiceObject.cleanAfterSave(invoiceJson);
	                        var maxDocumentById = invoiceService_1.default.invoiceObject.documents.filter(function (doc) { return doc.status === documentDomain_1.DOCUMENTSTATUS.VALID; })
	                            .reduce(function (prev, next) { return (prev.documentId > next.documentId) ? prev : next; });
	                        invoicePrintWindow.location.assign(documentService_1.default.documentUrl(maxDocumentById.documentUuid, { inline: true }));
	                    });
	                }).catch(function (e) {
	                });
	            }
	        };
	        _this.previewInvoice = function (evt) {
	            console.log('previewInvoice');
	            uiService_1.default.showToolbarActionFlag();
	            var invoicePreviewWindow = window.open("about:blank", 'invoicePreview');
	            invoiceService_1.default.previewInvoice(invoiceService_1.default.invoiceObject)
	                .then(function (documentPreviewDto) {
	                uiService_1.default.hideToolbarActionFlag();
	                invoicePreviewWindow.location.assign(documentService_1.default.documentTemporaryUrl(documentPreviewDto.id, { inline: true }));
	            }, function (error) {
	                invoiceService_1.default.invoiceObject.$errors = error.getMessages();
	            });
	        };
	        _this.handleMarkSent = function (evt) {
	            return invoiceService_1.default.sendInvoice(invoiceService_1.default.invoiceObject, true, false, undefined, undefined)
	                .then(function (res) {
	                invoiceService_1.default.invoiceObject.fromJson(res);
	                commonService_1.default.notifyInfo('Invoice was marked as sent');
	            });
	        };
	        _this.addInvoiceItem = function (itemType) {
	            console.log('addInvoiceItem %s', itemType);
	            var grid = invoiceService_1.default.invoiceObject.$movingBlocks.getBlock(invoiceService_1.invoiceItemGridLocation);
	            var rowObject = new invoiceDomain_1.InvoiceItem({
	                invoice: invoiceService_1.default.invoiceObject.invoiceLov(),
	                adjustmentKoef: 0,
	                adjustmentAmount: 0,
	                $new: true,
	                $dirty: true,
	                $added: true,
	                itemType: (0, formUtils_1.replaceIdWithLov)(itemType, mdEntityService_1.default.getEntity('INVOICEITEMTYPE'))
	            });
	            if (itemType !== invoiceDomain_1.INVOICEITEMTYPE.FREEITEM) {
	                rowObject.quantity = 1;
	                rowObject.unitOfMeasure = (0, formUtils_1.replaceIdWithLov)(productUtils_1.UNIT_OF_MEASURE.pcs, mdEntityService_1.default.getEntity('UnitOfMeasure'));
	            }
	            grid.addRow(rowObject);
	            var form = rowObject.getForm('InvoiceItemForm');
	            form.$open = true;
	            invoiceService_1.default.invoiceObject.$dirty = true;
	        };
	        _this.addAllVehicles = function () {
	            uiService_1.default.showToolbarActionFlag();
	            return invoiceService_1.default.addAllVehicles(invoiceService_1.default.invoiceObject)
	                .then(function (invoiceJson) {
	                invoiceService_1.default.invoiceObject.cleanAfterSave(invoiceJson);
	                invoiceService_1.default.invoiceObject.$dirty = true;
	                uiService_1.default.hideToolbarActionFlag();
	            }, function (error) {
	                invoiceService_1.default.invoiceObject.$errors = error.getMessages();
	            });
	        };
	        _this.recalculateInvoice = function (rootObject, modifiedRows, toDeleteRows, params) {
	            uiService_1.default.showToolbarActionFlag();
	            if (modifiedRows) {
	                for (var _i = 0, modifiedRows_1 = modifiedRows; _i < modifiedRows_1.length; _i++) {
	                    var row = modifiedRows_1[_i];
	                    if (row.rowObject.$added) {
	                        invoiceService_1.default.invoiceObject.items.push(row.rowObject);
	                    }
	                }
	            }
	            if (toDeleteRows) {
	                pullAll(invoiceService_1.default.invoiceObject.items, toDeleteRows.map(function (row) { return row.rowObject; }));
	            }
	            return invoiceService_1.default.recalculateWithClean(invoiceService_1.default.invoiceObject, params)
	                .then((0, mobx_1.action)("recalculateWithClean-actionCb", function () {
	                var grid = invoiceService_1.default.invoiceObject.$movingBlocks.getBlock(invoiceService_1.invoiceItemGridLocation);
	                grid.$dirty = true;
	                invoiceService_1.default.invoiceObject.$dirty = true;
	                uiService_1.default.hideToolbarActionFlag();
	            }));
	        };
	        _this.copyInvoiceItem = function (invoiceItem) {
	            invoiceItem.invoiceItemId = undefined;
	            invoiceItem.dateCreated = undefined;
	            invoiceItem.dateUpdated = undefined;
	            invoiceItem.userCreated = undefined;
	            invoiceItem.tenantId = undefined;
	            return invoiceItem;
	        };
	        _this.disableEditDelete = function (invoiceItem) {
	            return ((0, formUtils_1.lovValue)(invoiceItem.itemType) === invoiceDomain_1.INVOICEITEMTYPE.ROUNDINGDIFF);
	        };
	        _this.handleChange = function (tabName) {
	            _this.tabChange(tabName, function (tab) {
	                invoiceService_1.default.invoiceObject.$headerTab = tab;
	            });
	            _this[tabName]();
	        };
	        _this.invoiceIssueDialogRefHandler = function (comp) { return _this.invoiceIssueDialogRef = comp; };
	        _this.confirmationDialogRefHandler = function (comp) { return _this.confirmationDialogRef = comp; };
	        _this.emailAddressesEditorDialogRefHandler = function (comp) { return _this.emailAddressesEditorDialogRef = comp; };
	        return _this;
	    }
	    InvoiceDetail.fetchData = function (routerParams, query) {
	        console.log("InvoiceDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['Invoice', 'InvoiceItem', 'InvoiceRole', 'InvoiceField', 'InvoiceRelation'], ['Document', { entity: 'ADDRESSTYPE', lov: true }, { entity: 'DOCUMENTATTACHMENTTYPE', lov: true }]);
	        var invoicePromise;
	        var toFinalInvoice;
	        var toADInvoice;
	        if (routerParams.id === 'new') {
	            invoicePromise = invoiceService_1.default.issuedNew(query.paymentTypeId, query.partyId);
	        }
	        else if (routerParams.id === 'copy') {
	            invoicePromise = invoiceService_1.default.readInvoice(query.copyId, { mode: 'copy' })
	                .then(function (invoiceObject) {
	                toFinalInvoice = query.linkToFI ? invoiceObject.createInvoiceInInvoiceRelation() : undefined;
	                toADInvoice = query.linkToAD ? invoiceObject.createInvoiceInInvoiceRelation() : undefined;
	                // copiedFromInvoiceId musi byt pred cleanOnCopy() jinak se vynuluje invoiceId !
	                invoiceObject.copiedFromInvoiceId = invoiceObject.invoiceId;
	                invoiceObject.cleanOnCopy();
	                invoiceObject.invoiceId = undefined;
	                invoiceObject.invoiceNumber = undefined;
	                invoiceObject.invoiceType = undefined;
	                invoiceObject.endInvoicePeriod = undefined;
	                invoiceObject.startInvoicePeriod = undefined;
	                invoiceObject.dueDate = undefined;
	                invoiceObject.invoiceDate = undefined;
	                invoiceObject.deliveryDate = undefined;
	                invoiceObject.taxDate = undefined;
	                invoiceObject.dateSentByPostToCustomer = undefined;
	                invoiceObject.dateEmailedToCustomer = undefined;
	                invoiceObject.dateSentToAccounting = undefined;
	                invoiceObject.dateSentToTaxOffice = undefined;
	                invoiceObject.dateSentToArchive = undefined;
	                invoiceObject.taxOfficeConfirmationNumber = undefined;
	                invoiceObject.taxOfficeConfirmationTime = undefined;
	                invoiceObject.taxOfficeConfirmationError = undefined;
	                invoiceObject.issueDate = undefined;
	                invoiceObject.paidAmount = 0;
	                invoiceObject.invoicePaid = undefined;
	                invoiceObject.invoiceCredited = undefined;
	                invoiceObject.entityNumberGen = undefined;
	                invoiceObject.issuedBy = securityService_1.default.currentUser.getMePartyLov();
	                invoiceObject.invoiceStatus = invoiceDomain_1.INVOICESTATUS.CONCEPT;
	                invoiceObject.documents = [];
	                invoiceObject.fromRels = [];
	                invoiceObject.toRels = [];
	                invoiceObject.items.forEach(function (t) {
	                    t.invoice = undefined;
	                    t.invoiceItemId = undefined;
	                });
	                return invoiceObject;
	            });
	        }
	        else {
	            invoicePromise = invoiceService_1.default.readInvoice(routerParams.id);
	        }
	        var gridPromise = gridService_1.default.fetchGrids(invoiceService_1.invoiceItemGridLocation);
	        return Promise.all([metadataPromise, invoicePromise, gridPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], invoiceObject = _a[1], gridLocationMap = _a[2];
	            invoiceObject.$new = !invoiceObject.invoiceId;
	            if (!invoiceObject.invoiceType)
	                invoiceObject.invoiceType = entityMap.get("InvoiceType").getLovItem(invoiceDomain_1.INVOICE_TYPE.FI);
	            invoiceObject.$movingBlocks = new gridUtils_1.MovingBlocks(null, false, null, new grid_1.ClientGrid(gridLocationMap.get(invoiceService_1.invoiceItemGridLocation), "items", invoiceObject.invoiceId));
	            invoiceObject.$headerTab = query.tab;
	            invoiceService_1.default.invoiceObject = invoiceObject.initAfterRead(routerParams.id === 'new');
	            if (toFinalInvoice) {
	                invoiceObject.toRels.push(new invoiceDomain_1.InvoiceRelation({
	                    fromInvoice: toFinalInvoice,
	                    relationType: entityMap.get("INVOICERELATIONTYPE").getLovItem((0, invoiceDomain_1.relationArrayInverse)((0, formUtils_1.lovValue)(toFinalInvoice.invoiceType), invoiceDomain_1.INVOICE_TYPE.FI)),
	                    valueDate: (0, dateUtils_1.formatDateIso)(new Date()),
	                    contributedAmount: toFinalInvoice.totalAdjustedPrice,
	                    currency: invoiceObject.invoiceCurrency
	                }));
	            }
	            else if (toADInvoice) {
	                invoiceObject.fromRels.push(new invoiceDomain_1.InvoiceRelation({
	                    toInvoice: toADInvoice,
	                    relationType: entityMap.get("INVOICERELATIONTYPE").getLovItem((0, invoiceDomain_1.relationArrayInverse)(invoiceDomain_1.INVOICE_TYPE.AD, (0, formUtils_1.lovValue)(toADInvoice.invoiceType))),
	                    valueDate: (0, dateUtils_1.formatDateIso)(new Date()),
	                    contributedAmount: toADInvoice.totalAdjustedPrice,
	                    currency: invoiceObject.invoiceCurrency
	                }));
	                invoiceObject.invoiceType = entityMap.get("InvoiceType").getLovItem(invoiceDomain_1.INVOICE_TYPE.AD);
	            }
	            if (toFinalInvoice || toADInvoice) {
	                return invoiceService_1.default.recalculateWithClean(invoiceObject, {});
	            }
	        });
	    };
	    /**
	     * tohle je tady kvuli prechodu na jiny detail invoice (chained details)
	     * @param prevProps
	     */
	    InvoiceDetail.prototype.componentDidUpdate = function (prevProps) {
	        if (prevProps.params.id !== this.props.params.id) {
	            this.onLoad();
	        }
	    };
	    InvoiceDetail.prototype.componentDidMount = function () {
	        this.onLoad();
	    };
	    InvoiceDetail.prototype.onLoad = function () {
	        invoiceService_1.default.invoiceObject.$movingBlocks.searchExposedGrids(invoiceService_1.default.invoiceObject);
	        var tab = invoiceService_1.default.invoiceObject.$headerTab;
	        if (tab && this[tab])
	            this[tab]();
	    };
	    InvoiceDetail.prototype.componentWillUnmount = function () {
	        invoiceService_1.default.invoiceObject = null;
	    };
	    InvoiceDetail.prototype.findRootObject = function () {
	        return invoiceService_1.default.invoiceObject;
	    };
	    InvoiceDetail.prototype.commitOpenItems = function (grid) {
	        if (grid.data) {
	            for (var _i = 0, _a = grid.data.flatRows(); _i < _a.length; _i++) {
	                var row = _a[_i];
	                var rowObject = row.rowObject;
	                if (rowObject && rowObject.$added) {
	                    invoiceService_1.default.invoiceObject.items.push(rowObject);
	                }
	            }
	        }
	    };
	    InvoiceDetail.prototype.detail = function () {
	    };
	    InvoiceDetail.prototype.main = function () {
	    };
	    InvoiceDetail.prototype.advanced = function () {
	    };
	    InvoiceDetail.prototype.parameters = function () {
	    };
	    InvoiceDetail.prototype.settlement = function () {
	        return invoiceService_1.default.readInvoiceGraph(invoiceService_1.default.invoiceObject.invoiceId)
	            .then((0, mobx_1.action)("readInvoicePayments-handler", function (invoiceGraph) {
	            invoiceService_1.default.invoiceObject.$invoiceGraph = invoiceGraph;
	        }));
	    };
	    InvoiceDetail.prototype.saveFn = function (documents) {
	        var invoiceObject = invoiceService_1.default.invoiceObject;
	        if (invoiceObject.$new) {
	            return Promise.resolve(null);
	        }
	        else {
	            return Promise.all(documents.filter(function (doc) { return doc.$new; }).map(function (doc) { return documentService_1.default.saveDocument(doc, { invoiceId: (invoiceObject.invoiceId) }); }))
	                .then((0, mobx_1.action)("saveDocument-action", function (documentJson) {
	                console.log(documentJson.length);
	                var newDocs = documents.filter(function (doc) { return doc.$new; });
	                for (var i = 0; i < documentJson.length; i++) {
	                    newDocs[i].cleanAfterSave(documentJson[i]);
	                }
	            }));
	        }
	    };
	    InvoiceDetail.prototype.render = function () {
	        var _a;
	        var query = this.props.query;
	        var invoiceObject = invoiceService_1.default.invoiceObject;
	        var invoiceEntity = mdEntityService_1.default.getEntity('Invoice');
	        var propsForCreateForm = {
	            dataObject: invoiceObject,
	            rootObject: invoiceObject,
	            entity: invoiceEntity,
	            entities: mdEntityService_1.default.entityMap
	        };
	        var sendType = (0, formUtils_1.lovValue)(invoiceObject.sendType);
	        console.log('invoiceDetail render invoiceId = %s, $new = %s', invoiceObject.invoiceId, invoiceObject.$new);
	        // InvoiceCustomerBlock, ktery potrebuje fields, se zpracuje drive nez se vytvori fields na CustomerForm
	        var customerForm = invoiceObject.getForm("CustomerForm");
	        var customerFormFields = customerForm.fields;
	        if (!customerFormFields) {
	            customerFormFields = customerForm.setupFields(invoiceObject, invoiceObject, invoiceEntity, mdEntityService_1.default.entityMap, null);
	        }
	        var selectedTabArray = (invoiceObject.invoiceStatus === invoiceDomain_1.INVOICESTATUS.CONCEPT) ? CONCEPT_TABS : ISSUED_TABS;
	        var fixedTab = selectedTabArray.includes(invoiceObject.$headerTab) ? invoiceObject.$headerTab : selectedTabArray[0];
	        var headerContent = (invoiceObject.invoiceStatus === invoiceDomain_1.INVOICESTATUS.CONCEPT) ? (react_1.default.createElement("form", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6", style: { marginTop: 20 } },
	                    react_1.default.createElement(customerForm_1.default, tslib_1.__assign({}, propsForCreateForm, { recalculate: this.recalculateInvoice }))),
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                    react_1.default.createElement(Tabs_1.default, { value: fixedTab, onChange: this.handleChange },
	                        react_1.default.createElement(Tab_1.default, { label: "Main", value: "main" },
	                            react_1.default.createElement(invoiceForm_1.default, tslib_1.__assign({}, propsForCreateForm, { recalculate: this.recalculateInvoice }))),
	                        react_1.default.createElement(Tab_1.default, { label: "Advanced", value: "advanced" },
	                            react_1.default.createElement(invoiceAdvancedForm_1.default, tslib_1.__assign({}, propsForCreateForm, { recalculate: this.recalculateInvoice }))),
	                        react_1.default.createElement(Tab_1.default, { label: "Parameters", value: "parameters" },
	                            react_1.default.createElement(dynamicFields_1.DynamicFieldsBlock, { dataObject: invoiceObject, rootObject: invoiceObject, entity: invoiceEntity, entities: mdEntityService_1.default.entityMap }))))))) : (react_1.default.createElement("div", { style: { position: 'relative' } },
	            react_1.default.createElement("div", { style: {
	                    position: 'absolute',
	                    right: 5,
	                    top: 0
	                } }, (0, formUtils_1.lovValue)(invoiceObject.language).toUpperCase() + ' ' + (0, formUtils_1.lovLabel)(invoiceObject.sendType)),
	            react_1.default.createElement(Tabs_1.default, { value: fixedTab, onChange: this.handleChange },
	                react_1.default.createElement(Tab_1.default, { label: "Details", value: "detail" },
	                    react_1.default.createElement(blockComp_1.BlockComp, { style: { marginTop: 10 } },
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "cols-xs-12 col-sm-5" },
	                                react_1.default.createElement("div", { className: "invoice-block-header" }, "The Customer"),
	                                react_1.default.createElement("h5", { className: "form-header-text" },
	                                    react_1.default.createElement(react_router_1.Link, { to: "partyDetail", params: { id: (0, formUtils_1.lovValue)(invoiceObject.billedTo) }, query: (0, utils_1.addTenantToQuery)() }, invoiceObject.toFullName)),
	                                react_1.default.createElement(customerForm_1.InvoiceCustomerBlock, { dataObject: invoiceObject, entities: mdEntityService_1.default.entityMap, entity: invoiceEntity, style: { display: 'flex', flexDirection: 'column', marginLeft: 10 }, fields: customerFormFields, showLinkedInvoices: true })),
	                            react_1.default.createElement("div", { className: "cols-xs-12 col-sm-7", style: { marginBottom: 10 } },
	                                react_1.default.createElement("div", { className: "invoice-block-header" },
	                                    react_1.default.createElement("span", { className: invoiceObject.statusFontCss + ' zz-mr-5' }),
	                                    react_1.default.createElement("span", null, "".concat((0, formUtils_1.lovLabel)(invoiceObject.invoiceType), " # ").concat(invoiceObject.invoiceNumber, " on ").concat((0, formUtils_1.formatValue)(invoiceObject.invoiceDate, invoiceEntity.getField('invoiceDate'))))),
	                                react_1.default.createElement("div", { style: { display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start' } },
	                                    react_1.default.createElement(InvoiceBlockTable, { key: 1, fieldList: ['taxDate', 'dueDate', 'deliveryDate', 'deliveryNoteDate', 'paymentType', 'orderDate', 'orderedBy'], entity: invoiceEntity, dataObject: invoiceObject }),
	                                    react_1.default.createElement(InvoiceBlockTable, { key: 2, fieldList: ['invoiceAdjustmentKoef', 'exchangeRate', 'profitCenter', 'orderNumber', 'deliveryNoteNumber', {
	                                                show: function (o) { return o['startInvoicePeriod'] != null || o['endInvoicePeriod'] != null; },
	                                                value: function (o) { return (0, formUtils_1.formatValue)(o['startInvoicePeriod'], invoiceEntity.getField("startInvoicePeriod")) + " - " + (0, formUtils_1.formatValue)(o['endInvoicePeriod'], invoiceEntity.getField("endInvoicePeriod")); },
	                                                label: function (o) { return invoiceEntity.getField("startInvoicePeriod").formLabelActive; }
	                                            }, 'issuedBy'], entity: invoiceEntity, dataObject: invoiceObject }),
	                                    react_1.default.createElement(InvoiceBlockTable, { key: 3, fieldList: ['accountingProfitCenter', 'costCenter', 'internalOrder', 'relatedInvoice', 'accountingMatchingId', 'accountingNumber'], entity: invoiceEntity, dataObject: invoiceObject })),
	                                (invoiceObject.comment) ? (react_1.default.createElement("div", { style: { marginLeft: 10 } }, invoiceObject.comment)) : null,
	                                (invoiceObject.internalComment) ? (react_1.default.createElement("div", { style: { marginLeft: 10 } }, invoiceObject.internalComment)) : null)))),
	                react_1.default.createElement(Tab_1.default, { label: "Settlements", value: "settlement" },
	                    react_1.default.createElement(invoicePayment_1.InvoicePaymentComp, { invoiceObject: invoiceObject })))));
	        var rowInvoiceItemForm = (react_1.default.createElement(invoiceItemForm_1.default, { rootObject: invoiceObject, entity: mdEntityService_1.default.getEntity('InvoiceItem'), entities: mdEntityService_1.default.entityMap, dataObject: null }));
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	            this._createToolMenu(invoiceObject, query.gridLocation),
	            (invoiceObject.invoiceStatus === invoiceDomain_1.INVOICESTATUS.CANCELED) ? react_1.default.createElement(watermark_1.Watermark, { text: "Canceled" }) : null,
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: invoiceObject.$errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	            (invoiceObject.invoiceStatus === invoiceDomain_1.INVOICESTATUS.CONCEPT) ?
	                react_1.default.createElement(invoiceIssueDialog_1.default, { ref: this.invoiceIssueDialogRefHandler, entities: mdEntityService_1.default.entityMap }) : null,
	            react_1.default.createElement(confirmationDialog_1.default, { okButtonText: "Yes", cancelButtonText: "No", ref: this.confirmationDialogRefHandler }),
	            (sendType === eventDomain_1.SENDTYPE.EMAIL) ?
	                react_1.default.createElement(emailComponents_1.EmailAddressesEditorDialog, { ref: this.emailAddressesEditorDialogRefHandler }) : null,
	            headerContent,
	            react_1.default.createElement("div", { style: { display: 'flex', width: '100%', justifyContent: 'space-between', flexShrink: 0, flexWrap: 'wrap' } },
	                react_1.default.createElement(documentComp_1.default, { documents: invoiceObject.documents, showFilterFn: documentDomain_1.nonReplacedDocumentFp, entities: mdEntityService_1.default.entityMap, style: { flex: '1 1 auto', marginBottom: 10 }, enableUpload: invoiceObject.invoiceStatus === invoiceDomain_1.INVOICESTATUS.CONCEPT, rootObject: invoiceObject, saveFn: this.saveFn, documentEntity: mdEntityService_1.default.getEntity('Document'), canDeleteFn: invoiceDomain_1.canDeleteInvoiceDocument, showIncludeCheckbox: true, defaultAttachmentType: (_a = invoiceObject.billedTo) === null || _a === void 0 ? void 0 : _a.defaultAttachmentType }),
	                react_1.default.createElement(invoiceSumTable_1.default, { invoiceObject: invoiceObject, entities: mdEntityService_1.default.entityMap, invoiceEntity: invoiceEntity, style: { minWidth: '50%' } })),
	            react_1.default.createElement(gridComp_1.default, { ref: invoiceService_1.invoiceItemGridLocation, grid: invoiceObject.$movingBlocks.getBlock(invoiceService_1.invoiceItemGridLocation), uiLocation: gridComp_1.UILOCATION.main, showEdit: invoiceObject.invoiceStatus === invoiceDomain_1.INVOICESTATUS.CONCEPT, disableEditFn: this.disableEditDelete, showDelete: invoiceObject.invoiceStatus === invoiceDomain_1.INVOICESTATUS.CONCEPT, disableDeleteFn: this.disableEditDelete, deleteRowIcon: "fa fa-trash", rootObject: invoiceObject, editForm: rowInvoiceItemForm, editFormName: "InvoiceItemForm", entities: mdEntityService_1.default.entityMap, editOverrideFn: this.recalculateInvoice, copyRowObjectFn: this.copyInvoiceItem, multiUpdateSecurable: (invoiceObject.invoiceStatus === invoiceDomain_1.INVOICESTATUS.CONCEPT) ? metaConstant_1.SECURABLE.invoiceDetail : null, multiUpdateSaveFn: this.onSave },
	                react_1.default.createElement(icons_1.ZzIconButtonMenu, { buttonIcon: react_1.default.createElement(add_1.default, null), disabled: !invoiceObject.billedTo || !invoiceObject.invoiceCurrency || !invoiceObject.exchangeRate || invoiceObject.invoiceStatus !== invoiceDomain_1.INVOICESTATUS.CONCEPT },
	                    react_1.default.createElement(MenuItem_1.default, { primaryText: "Free Item", onClick: this.addInvoiceItem.bind(this, invoiceDomain_1.INVOICEITEMTYPE.FREEITEM) }),
	                    react_1.default.createElement(MenuItem_1.default, { primaryText: "Product", onClick: this.addInvoiceItem.bind(this, invoiceDomain_1.INVOICEITEMTYPE.PRODUCTITEM) }),
	                    react_1.default.createElement(MenuItem_1.default, { primaryText: "Product & Vehicle", onClick: this.addInvoiceItem.bind(this, invoiceDomain_1.INVOICEITEMTYPE.PRODUCTVEHICLEITEM) }),
	                    react_1.default.createElement(MenuItem_1.default, { primaryText: "All Vehicles", onClick: this.addAllVehicles })))));
	    };
	    InvoiceDetail.prototype._createToolMenu = function (invoiceObject, gridLocation) {
	        var _disableIssue = (invoiceObject.invoiceStatus !== invoiceDomain_1.INVOICESTATUS.CONCEPT || !invoiceObject.billedTo || !invoiceObject.items.length || !invoiceObject.invoiceType);
	        var sendType = (0, formUtils_1.lovValue)(invoiceObject.sendType);
	        var invoiceTypeId = (0, formUtils_1.lovValue)(invoiceObject.invoiceType);
	        var sendMenuItemLabel = (sendType === eventDomain_1.SENDTYPE.EMAIL) ? "Email Invoice" : "Print Invoice";
	        var menuArray = (0, arrayUtils_1.addSeparatorBetweenArrays)(react_1.default.createElement(Divider_1.default, null), (invoiceObject.invoiceStatus !== invoiceDomain_1.INVOICESTATUS.CONCEPT) ? null : [react_1.default.createElement(icons_1.ZzMenuItem, { primaryText: "Email Concept", key: 3, onClick: this.handleSend }), react_1.default.createElement(icons_1.ZzMenuItem, { primaryText: "Preview Invoice", key: 3, onClick: this.previewInvoice })], (invoiceObject.$new || invoiceObject.invoiceStatus !== invoiceDomain_1.INVOICESTATUS.ISSUED) ? null : [react_1.default.createElement(icons_1.ZzMenuItem, { primaryText: "Cancel", key: 3, securable: metaConstant_1.SECURABLE.cancelInvoice, onClick: this.onCancel }), react_1.default.createElement(icons_1.ZzMenuItem, { primaryText: "Reopen", key: 4, onClick: this.onReopen, securable: metaConstant_1.SECURABLE.reopenInvoice }), react_1.default.createElement(icons_1.ZzMenuItem, { primaryText: sendMenuItemLabel, key: 5, onClick: this.handleSend, securable: metaConstant_1.SECURABLE.sendInvoice }), (!invoiceObject.isSent()) ? react_1.default.createElement(icons_1.ZzMenuItem, { primaryText: "Mark as Sent", key: 4, onClick: this.handleMarkSent, securable: metaConstant_1.SECURABLE.sendInvoice }) : null,
	            (!!invoiceObject.invoiceId && securityService_1.default.hasRight(metaConstant_1.SECURABLE.documentTemplateDetail.name, metaConstant_1.PERMISSION.Read)) ?
	                react_1.default.createElement("a", { style: { paddingLeft: 20 }, href: "/api/core/document/xml/Invoice/" + invoiceObject.invoiceId + "?inline=true", className: "mui-menu-item-link-1", target: "_blank" }, " XML ") : null
	        ]);
	        console.log(menuArray);
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: history_1.default.length <= 1, historize: true, entityName: "Invoice", entityId: invoiceObject.invoiceId },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !invoiceObject.$dirty, label: "Save", permission: invoiceObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, disabled: invoiceObject.$new, label: "New", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onCopy, disabled: invoiceObject.$new, label: "Copy", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "Invoice", pageAncestor: this, onClick: this.onDelete, disabled: invoiceObject.$new || invoiceObject.invoiceStatus !== invoiceDomain_1.INVOICESTATUS.CONCEPT, label: "Delete", permission: metaConstant_1.PERMISSION.Delete }),
	            !_disableIssue && securityService_1.default.hasRight(metaConstant_1.SECURABLE.issueInvoice.name, metaConstant_1.PERMISSION.Execute, invoiceTypeId + "") && (react_1.default.createElement(buttons_1.ZzSplitButton, { bsStyle: "toolbar", title: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Issue"], ["Issue"]))) + ' ' + (0, formUtils_1.lovLabel)(invoiceObject.invoiceType), onClick: this.onIssue.bind(this, invoiceTypeId, false), id: "issue-button" },
	                react_1.default.createElement(react_bootstrap_1.MenuItem, { eventKey: 0, onSelect: this.onIssue.bind(this, invoiceTypeId, false) }, "Issue"),
	                react_1.default.createElement(react_bootstrap_1.MenuItem, { eventKey: 1, onSelect: this.onIssue.bind(this, invoiceTypeId, true) }, "Issue immediatelly"))),
	            react_1.default.createElement(icons_1.ZzIconButtonMenu, { buttonIcon: react_1.default.createElement(more_vert_1.default, null), disabled: !menuArray.length, securableType: metaConstant_1.SECURABLE_TYPE.DETAILACTION }, menuArray)));
	    };
	    InvoiceDetail.module = metaConstant_1.MODULE.invoicing;
	    InvoiceDetail.title = 'Invoice';
	    InvoiceDetail.icon = 'money';
	    InvoiceDetail.protectedPage = true;
	    InvoiceDetail.contextTypes = {
	        router: prop_types_1.default.func.isRequired
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceDetail.prototype, "onIssue", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceDetail.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceDetail.prototype, "onCancel", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceDetail.prototype, "onReopen", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceDetail.prototype, "handleSend", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceDetail.prototype, "previewInvoice", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceDetail.prototype, "handleMarkSent", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceDetail.prototype, "addInvoiceItem", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceDetail.prototype, "addAllVehicles", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceDetail.prototype, "recalculateInvoice", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceDetail.prototype, "copyInvoiceItem", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceDetail.prototype, "handleChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceDetail.prototype, "detail", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceDetail.prototype, "main", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceDetail.prototype, "advanced", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceDetail.prototype, "parameters", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceDetail.prototype, "settlement", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceDetail.prototype, "saveFn", null);
	    InvoiceDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], InvoiceDetail);
	    return InvoiceDetail;
	}(pageAncestor_1.default));
	exports.default = InvoiceDetail;
	var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'invoiceReport';
	var InvoiceReport = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceReport, _super);
	    function InvoiceReport() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    InvoiceReport.fetchData = function (routerParams) {
	        console.log("InvoiceReport#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    InvoiceReport.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query }));
	    };
	    InvoiceReport.module = metaConstant_1.MODULE.invoicing;
	    InvoiceReport.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Reports"], ["Reports"])));
	    InvoiceReport.icon = 'line-chart';
	    InvoiceReport.rootPage = true;
	    InvoiceReport.protectedPage = true;
	    InvoiceReport = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], InvoiceReport);
	    return InvoiceReport;
	}(pageAncestor_1.default));
	exports.default = InvoiceReport;
	var templateObject_1;


/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var pullAll = __webpack_require__(484);
	var buttons_1 = __webpack_require__(27);
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var icons_1 = __webpack_require__(63);
	var MenuItem_1 = tslib_1.__importDefault(__webpack_require__(101));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var invoiceService_1 = tslib_1.__importStar(__webpack_require__(195));
	var errorComp_1 = __webpack_require__(34);
	var formUtils_1 = __webpack_require__(14);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridComp_1 = tslib_1.__importDefault(__webpack_require__(44));
	var grid_1 = __webpack_require__(50);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var invoiceTemplateItemForm_1 = tslib_1.__importDefault(__webpack_require__(2148));
	var productUtils_1 = __webpack_require__(405);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var metaConstant_1 = __webpack_require__(13);
	__webpack_require__(203);
	var mobx_react_1 = __webpack_require__(4);
	var invoiceDomain_1 = __webpack_require__(157);
	var mobx_1 = __webpack_require__(5);
	var gridUtils_1 = __webpack_require__(83);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var gridComp_2 = __webpack_require__(44);
	var invoiceTemplateForm_1 = tslib_1.__importDefault(__webpack_require__(2147));
	var invoiceTemplateSumTable_1 = tslib_1.__importDefault(__webpack_require__(2149));
	var locales_1 = __webpack_require__(15);
	var invoiceTemplateBilledToDialog_1 = tslib_1.__importDefault(__webpack_require__(2146));
	var InvoiceTemplateDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceTemplateDetail, _super);
	    function InvoiceTemplateDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.billedToDialogOpen = false;
	        _this.customValidate = function (invoiceTemplateObject) {
	            var errors = [];
	            var today = (0, moment_1.default)().startOf('day');
	            if (!invoiceTemplateObject.disableScheduling && !invoiceTemplateObject.lastGenerateDate && (0, moment_1.default)(invoiceTemplateObject.validFrom).isBefore(today)) {
	                errors.push({ message: "Starting date cannot be in the past" });
	            }
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave invoiceTemplateId = %s, $new = %s', invoiceService_1.default.invoiceTemplateObject.invoiceTemplateId, invoiceService_1.default.invoiceTemplateObject.$new);
	            uiService_1.default.showToolbarActionFlag();
	            // remove invoice period if it was disabled
	            if (!invoiceService_1.default.invoiceTemplateObject.periodicInvoice) {
	                invoiceService_1.default.invoiceTemplateObject.startInvoicePeriodExpression = null;
	                invoiceService_1.default.invoiceTemplateObject.endInvoicePeriodExpression = null;
	            }
	            // pridame do invoiceObject.items z otevrenych formu na gridu
	            var grid = invoiceService_1.default.invoiceTemplateObject.$movingBlocks.getBlock(invoiceService_1.invoiceTemplateItemGridLocation);
	            _this.commitOpenItems(grid);
	            var result = (0, formUtils_1.preSave)(invoiceService_1.default.invoiceTemplateObject, _this.customValidate, true);
	            if (!result) {
	                return;
	            }
	            invoiceService_1.default.invoiceTemplateSave(invoiceService_1.default.invoiceTemplateObject)
	                .then((0, mobx_1.action)("invoiceTemplateSave-action", function (invoiceTemplateJson) {
	                var wasNew = invoiceService_1.default.invoiceTemplateObject.cleanAfterSave(invoiceTemplateJson);
	                console.log("invoiceService.invoiceTemplateObject.nextGenerateDate = ", invoiceService_1.default.invoiceTemplateObject.nextGenerateDate);
	                if (wasNew) {
	                    _this.context.router.replaceWith('invoiceTemplateDetail', { id: invoiceService_1.default.invoiceTemplateObject.invoiceTemplateId });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            }), function (error) {
	                invoiceService_1.default.invoiceTemplateObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            var query = {};
	            _this.context.router.transitionTo("invoiceTemplateDetail", { id: 'new' }, query);
	        };
	        _this.onCopy = function (evt) {
	            console.log('onCopy');
	            _this.context.router.transitionTo("invoiceTemplateDetail", { id: 'copy' }, { copyId: invoiceService_1.default.invoiceTemplateObject.invoiceTemplateId });
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            invoiceService_1.default.deleteInvoiceTemplate(invoiceService_1.default.invoiceTemplateObject.invoiceTemplateId)
	                .then(function (response) {
	                _this.goBackOrHome();
	            }, function (error) {
	                invoiceService_1.default.invoiceTemplateObject.$errors = error.getMessages();
	            });
	        };
	        _this.onGenerateInvoice = function (evt) {
	            if (invoiceService_1.default.invoiceTemplateObject.billedTo == null) {
	                _this.billedToDialogOpen = true;
	            }
	            else {
	                _this.generateInvoice();
	            }
	        };
	        _this.onBilledToDialogConfirm = function (billedTo) {
	            _this.billedToDialogOpen = false;
	            _this.generateInvoice(billedTo.value);
	        };
	        _this.onBilledToDialogClose = function () {
	            _this.billedToDialogOpen = false;
	        };
	        _this.generateInvoice = function (billedTo) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
	            var invoiceTemplate;
	            return tslib_1.__generator(this, function (_a) {
	                invoiceTemplate = invoiceService_1.default.invoiceTemplateObject;
	                uiService_1.default.showToolbarActionFlag();
	                invoiceService_1.default.generateInvoiceFromTemplate(invoiceTemplate.invoiceTemplateId, billedTo)
	                    .then((0, mobx_1.action)("generateInvoiceAction", function (invoice) {
	                    uiService_1.default.hideToolbarActionFlag();
	                    window.location.href = "/invoice/detail/".concat(invoice.invoiceId);
	                }), function (error) {
	                    console.error(error);
	                    invoiceService_1.default.invoiceObject.$errors = error.getMessages();
	                });
	                return [2 /*return*/];
	            });
	        }); };
	        _this.addInvoiceTemplateItem = function (itemType) {
	            console.log('addInvoiceItem %s', itemType);
	            var grid = invoiceService_1.default.invoiceTemplateObject.$movingBlocks.getBlock(invoiceService_1.invoiceTemplateItemGridLocation);
	            var rowObject = new invoiceDomain_1.InvoiceTemplateItem({
	                invoiceTemplate: invoiceService_1.default.invoiceTemplateObject.invoiceTemplateLov(),
	                adjustmentKoef: 0,
	                adjustmentAmount: 0,
	                $new: true,
	                $dirty: true,
	                $added: true,
	                itemType: (0, formUtils_1.replaceIdWithLov)(itemType, mdEntityService_1.default.getEntity('INVOICEITEMTYPE'))
	            });
	            if (itemType !== invoiceDomain_1.INVOICEITEMTYPE.FREEITEM) {
	                rowObject.quantity = 1;
	                rowObject.unitOfMeasure = (0, formUtils_1.replaceIdWithLov)(productUtils_1.UNIT_OF_MEASURE.pcs, mdEntityService_1.default.getEntity('UnitOfMeasure'));
	            }
	            grid.addRow(rowObject);
	            var form = rowObject.getForm('InvoiceTemplateItemForm');
	            form.$open = true;
	            invoiceService_1.default.invoiceTemplateObject.$dirty = true;
	        };
	        _this.recalculateInvoiceTemplate = function (rootObject, modifiedRows, toDeleteRows, params) {
	            uiService_1.default.showToolbarActionFlag();
	            if ((toDeleteRows != null && rootObject.items.length - toDeleteRows.length == 0)
	                || rootObject.items.length == 0) {
	                invoiceService_1.default.invoiceTemplateObject.disableScheduling = true;
	                var form = rootObject.getForm('InvoiceTemplateForm');
	                form.updateFieldsPropValue(rootObject, 'disableScheduling');
	            }
	            if (modifiedRows) {
	                for (var _i = 0, modifiedRows_1 = modifiedRows; _i < modifiedRows_1.length; _i++) {
	                    var row = modifiedRows_1[_i];
	                    if (row.rowObject.$added) {
	                        invoiceService_1.default.invoiceTemplateObject.items.push(row.rowObject);
	                    }
	                }
	            }
	            if (toDeleteRows) {
	                pullAll(invoiceService_1.default.invoiceTemplateObject.items, toDeleteRows.map(function (row) { return row.rowObject; }));
	            }
	            return invoiceService_1.default.recalculateTemplateWithClean(invoiceService_1.default.invoiceTemplateObject, params)
	                .then((0, mobx_1.action)("recalculateTemaplteWithClean-actionCb", function () {
	                var grid = invoiceService_1.default.invoiceTemplateObject.$movingBlocks.getBlock(invoiceService_1.invoiceTemplateItemGridLocation);
	                grid.$dirty = true;
	                invoiceService_1.default.invoiceTemplateObject.$dirty = true;
	                uiService_1.default.hideToolbarActionFlag();
	            }));
	        };
	        _this.copyInvoiceTemplateItem = function (invoiceTemplateItem) {
	            invoiceTemplateItem.invoiceTemplateItemId = undefined;
	            invoiceTemplateItem.dateCreated = undefined;
	            invoiceTemplateItem.dateUpdated = undefined;
	            invoiceTemplateItem.userCreated = undefined;
	            invoiceTemplateItem.tenantId = undefined;
	            return invoiceTemplateItem;
	        };
	        return _this;
	    }
	    InvoiceTemplateDetail.fetchData = function (routerParams, query) {
	        console.log("InvoiceTemplateDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['InvoiceTemplate', 'InvoiceTemplateItem'], ['Invoice', { entity: "EventType", lov: true }]);
	        var invoiceTemplatePromise;
	        if (routerParams.id === 'new') {
	            invoiceTemplatePromise = Promise.resolve(new invoiceDomain_1.InvoiceTemplate({
	                $new: true,
	                active: true,
	                invoiceAdjustmentKoef: 0
	            }));
	        }
	        else if (routerParams.id === 'copy') {
	            invoiceTemplatePromise = invoiceService_1.default.readInvoiceTemplate(query.copyId, { mode: 'copy' })
	                .then(function (invoiceTemplateObject) {
	                invoiceTemplateObject.cleanOnCopy();
	                invoiceTemplateObject.invoiceTemplateId = undefined;
	                invoiceTemplateObject.items.forEach(function (t) {
	                    t.invoiceTemplate = undefined;
	                    t.invoiceTemplateItemId = undefined;
	                });
	                return invoiceTemplateObject;
	            });
	        }
	        else {
	            invoiceTemplatePromise = invoiceService_1.default.readInvoiceTemplate(routerParams.id);
	        }
	        var gridPromise = gridService_1.default.fetchGrids(invoiceService_1.invoiceTemplateItemGridLocation);
	        return Promise.all([metadataPromise, invoiceTemplatePromise, gridPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], invoiceTemplateObject = _a[1], gridLocationMap = _a[2];
	            invoiceTemplateObject.$new = !invoiceTemplateObject.invoiceTemplateId;
	            if (!invoiceTemplateObject.holidayHandling)
	                invoiceTemplateObject.holidayHandling = entityMap.get("HOLIDAYHANDLING").getLovItem("ALWAYS");
	            if (!invoiceTemplateObject.paymentType)
	                invoiceTemplateObject.paymentType = entityMap.get("PaymentType").getLovItem(invoiceDomain_1.PAYMENT_TYPE.ACCOUNT_TRANSFER);
	            if (!invoiceTemplateObject.remittanceSkipCount)
	                invoiceTemplateObject.remittanceSkipCount = 1;
	            if (!invoiceTemplateObject.remittanceType)
	                invoiceTemplateObject.remittanceType = entityMap.get("REMITTANCETYPE").getLovItem("MONTH");
	            if (!invoiceTemplateObject.validFrom)
	                invoiceTemplateObject.validFrom = new Date(new Date().setHours(0, 0, 0, 0));
	            invoiceTemplateObject.$movingBlocks = new gridUtils_1.MovingBlocks(null, false, null, new grid_1.ClientGrid(gridLocationMap.get(invoiceService_1.invoiceTemplateItemGridLocation), "items", invoiceTemplateObject.invoiceTemplateId));
	            invoiceService_1.default.invoiceTemplateObject = invoiceTemplateObject.initAfterRead(routerParams.id === 'new');
	        });
	    };
	    /**
	     * tohle je tady kvuli prechodu na jiny detail invoice (chained details)
	     * @param prevProps
	     */
	    InvoiceTemplateDetail.prototype.componentDidUpdate = function (prevProps) {
	        if (prevProps.params.id !== this.props.params.id) {
	            invoiceService_1.default.invoiceTemplateObject.$movingBlocks.searchExposedGrids(invoiceService_1.default.invoiceTemplateObject);
	        }
	    };
	    InvoiceTemplateDetail.prototype.componentDidMount = function () {
	        invoiceService_1.default.invoiceTemplateObject.$movingBlocks.searchExposedGrids(invoiceService_1.default.invoiceTemplateObject);
	    };
	    InvoiceTemplateDetail.prototype.componentWillUnmount = function () {
	        invoiceService_1.default.invoiceTemplateObject = null;
	    };
	    InvoiceTemplateDetail.prototype.findRootObject = function () {
	        return invoiceService_1.default.invoiceTemplateObject;
	    };
	    InvoiceTemplateDetail.prototype.commitOpenItems = function (grid) {
	        if (grid.data) {
	            for (var _i = 0, _a = grid.data.flatRows(); _i < _a.length; _i++) {
	                var row = _a[_i];
	                var rowObject = row.rowObject;
	                if (rowObject && rowObject.$added) {
	                    invoiceService_1.default.invoiceTemplateObject.items.push(rowObject);
	                }
	            }
	        }
	    };
	    InvoiceTemplateDetail.prototype.render = function () {
	        var query = this.props.query;
	        var invoiceTemplateObject = invoiceService_1.default.invoiceTemplateObject;
	        var invoiceTemplateEntity = mdEntityService_1.default.getEntity('InvoiceTemplate');
	        var propsForCreateForm = {
	            dataObject: invoiceTemplateObject,
	            rootObject: invoiceTemplateObject,
	            entity: invoiceTemplateEntity,
	            entities: mdEntityService_1.default.entityMap
	        };
	        console.log('invoiceTemplateDetail render invoiceId = %s, $new = %s', invoiceTemplateObject.invoiceTemplateId, invoiceTemplateObject.$new);
	        var rowInvoiceTemplateItemForm = (react_1.default.createElement(invoiceTemplateItemForm_1.default, { rootObject: invoiceTemplateObject, entity: mdEntityService_1.default.getEntity('InvoiceTemplateItem'), entities: mdEntityService_1.default.entityMap, dataObject: null }));
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	            react_1.default.createElement(invoiceTemplateBilledToDialog_1.default, { dialogOpen: this.billedToDialogOpen, onConfirm: this.onBilledToDialogConfirm, onClose: this.onBilledToDialogClose }),
	            this._createToolMenu(invoiceTemplateObject, query.gridLocation),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: invoiceTemplateObject.$errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	            react_1.default.createElement(invoiceTemplateForm_1.default, tslib_1.__assign({}, propsForCreateForm, { recalculate: this.recalculateInvoiceTemplate })),
	            react_1.default.createElement(invoiceTemplateSumTable_1.default, { invoiceTemplateObject: invoiceTemplateObject, entities: mdEntityService_1.default.entityMap, invoiceTemplateEntity: invoiceTemplateEntity, style: { minWidth: '50%', margin: "10px 20px" } }),
	            react_1.default.createElement(gridComp_1.default, { ref: invoiceService_1.invoiceTemplateItemGridLocation, grid: invoiceTemplateObject.$movingBlocks.getBlock(invoiceService_1.invoiceTemplateItemGridLocation), uiLocation: gridComp_2.UILOCATION.main, showEdit: true, showDelete: true, deleteRowIcon: "fa fa-trash", rootObject: invoiceTemplateObject, editForm: rowInvoiceTemplateItemForm, editFormName: "InvoiceTemplateItemForm", entities: mdEntityService_1.default.entityMap, editOverrideFn: this.recalculateInvoiceTemplate, copyRowObjectFn: this.copyInvoiceTemplateItem, multiUpdateSaveFn: this.onSave },
	                react_1.default.createElement(icons_1.ZzIconButtonMenu, { buttonIcon: react_1.default.createElement(add_1.default, null), disabled: !invoiceTemplateObject.invoiceCurrency },
	                    react_1.default.createElement(MenuItem_1.default, { primaryText: "Free Item", onClick: this.addInvoiceTemplateItem.bind(this, invoiceDomain_1.INVOICEITEMTYPE.FREEITEM) }),
	                    react_1.default.createElement(MenuItem_1.default, { primaryText: "Product", onClick: this.addInvoiceTemplateItem.bind(this, invoiceDomain_1.INVOICEITEMTYPE.PRODUCTITEM) }),
	                    react_1.default.createElement(MenuItem_1.default, { primaryText: "Product & Vehicle", onClick: this.addInvoiceTemplateItem.bind(this, invoiceDomain_1.INVOICEITEMTYPE.PRODUCTVEHICLEITEM) })))));
	    };
	    InvoiceTemplateDetail.prototype._createToolMenu = function (invoiceTemplateObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: History.length <= 1, historize: true, entityName: "InvoiceTemplate", entityId: invoiceTemplateObject.invoiceTemplateId },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !invoiceTemplateObject.$dirty, label: "Save", permission: invoiceTemplateObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, disabled: invoiceTemplateObject.$new, label: "New", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onCopy, disabled: invoiceTemplateObject.$new, label: "Copy", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "InvoiceTemplate", pageAncestor: this, onClick: this.onDelete, disabled: invoiceTemplateObject.$new, label: "Delete", permission: metaConstant_1.PERMISSION.Delete }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onGenerateInvoice, disabled: invoiceTemplateObject.$new, label: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Generate Invoice"], ["Generate Invoice"]))) })));
	    };
	    InvoiceTemplateDetail.module = metaConstant_1.MODULE.invoicing;
	    InvoiceTemplateDetail.title = 'Invoice Template';
	    InvoiceTemplateDetail.icon = 'money';
	    InvoiceTemplateDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], InvoiceTemplateDetail.prototype, "billedToDialogOpen", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateDetail.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateDetail.prototype, "onGenerateInvoice", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateDetail.prototype, "onBilledToDialogConfirm", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateDetail.prototype, "onBilledToDialogClose", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateDetail.prototype, "generateInvoice", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateDetail.prototype, "addInvoiceTemplateItem", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateDetail.prototype, "recalculateInvoiceTemplate", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], InvoiceTemplateDetail.prototype, "copyInvoiceTemplateItem", void 0);
	    InvoiceTemplateDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], InvoiceTemplateDetail);
	    return InvoiceTemplateDetail;
	}(pageAncestor_1.default));
	exports.default = InvoiceTemplateDetail;
	var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var routes_1 = __webpack_require__(75);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'invoiceTemplateList';
	var InvoiceTemplateList = /** @class */ (function (_super) {
	    tslib_1.__extends(InvoiceTemplateList, _super);
	    function InvoiceTemplateList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    InvoiceTemplateList.fetchData = function (routerParams) {
	        console.log("InvoiceTemplateList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    InvoiceTemplateList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "invoiceTemplateDetail", params: { id: 'new' }, label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["New Template"], ["New Template"]))), permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.invoiceTemplateDetail })));
	    };
	    InvoiceTemplateList.module = metaConstant_1.MODULE.invoicing;
	    InvoiceTemplateList.title = locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Invoice Templates"], ["Invoice Templates"])));
	    InvoiceTemplateList.icon = 'money';
	    InvoiceTemplateList.rootPage = true;
	    InvoiceTemplateList.protectedPage = true;
	    InvoiceTemplateList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], InvoiceTemplateList);
	    return InvoiceTemplateList;
	}(pageAncestor_1.default));
	exports.default = InvoiceTemplateList;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var downloadDialog_1 = tslib_1.__importDefault(__webpack_require__(2068));
	var entitiesEmailDialog_1 = tslib_1.__importDefault(__webpack_require__(2139));
	var fields_1 = __webpack_require__(20);
	var documentService_1 = tslib_1.__importDefault(__webpack_require__(110));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var routes_1 = __webpack_require__(75);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var documentDomain_1 = __webpack_require__(109);
	var mobx_react_1 = __webpack_require__(4);
	var gridComp_1 = __webpack_require__(44);
	var mobx_1 = __webpack_require__(5);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var locales_1 = __webpack_require__(15);
	var invoiceDomain_1 = __webpack_require__(157);
	var gridLocation = 'issuedInvoiceList';
	var IssuedInvoiceList = /** @class */ (function (_super) {
	    tslib_1.__extends(IssuedInvoiceList, _super);
	    function IssuedInvoiceList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.downloadInvoices = function (grid) {
	            new Promise(function (resolve, reject) {
	                _this.downloadDialogRef.open(resolve, reject, { _includeSent: true, _includeByAll: true, _includeAll: false, _byEmail: false, _markSent: false });
	            }).catch(function (error) {
	                console.log('rejecting DownloadDialog with ', error);
	                if (error) {
	                    if (error.response && error.response.data && error.response.data.severity === 'ERROR') {
	                        grid.errors = error.response.data.messages;
	                    }
	                    else {
	                        throw error;
	                    }
	                }
	            });
	        };
	        _this.emailInvoices = function (grid) {
	            new Promise(function (resolve, reject) {
	                _this.emailDialogRef.open(resolve, reject, grid);
	            }).catch(function (error) {
	                console.log('rejecting EmailDialo with ', error);
	                if (error) {
	                    if (error.response && error.response.data && error.response.data.severity === 'ERROR') {
	                        grid.errors = error.response.data.messages;
	                    }
	                    else {
	                        throw error;
	                    }
	                }
	            });
	        };
	        _this.onCheckMarkSentByPost = function (evt, checked) {
	            console.log('onCheckMarkSentByPost checked: ' + checked);
	            documentService_1.default.documentCountObject.gridParams._markSent = checked;
	            documentService_1.default.documentCountObject.gridParams._includeByAll = !checked;
	            documentService_1.default.documentCountObject.gridParams._includeSent = !checked;
	            return _this.recount();
	        };
	        _this.onCheckIncludeSent = function (evt, checked) {
	            console.log('onCheckIncludeSent checked: ' + checked);
	            documentService_1.default.documentCountObject.gridParams._includeSent = checked;
	            return _this.recount();
	        };
	        _this.onCheckByAll = function (evt, checked) {
	            console.log('onCheckByAll checked: ' + checked);
	            documentService_1.default.documentCountObject.gridParams._includeByAll = checked;
	            return _this.recount();
	        };
	        _this.onCheckIncludeAll = function (evt, checked) {
	            console.log('onCheckIncludeAll checked: ' + checked);
	            documentService_1.default.documentCountObject.gridParams._includeAll = checked;
	            return _this.recount();
	        };
	        _this.downloadDialogRefHandler = function (comp) { return _this.downloadDialogRef = comp; };
	        _this.emailDialogRefHandler = function (comp) { return _this.emailDialogRef = comp; };
	        return _this;
	    }
	    IssuedInvoiceList.fetchData = function (routerParams) {
	        console.log("IssuedInvoiceList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    IssuedInvoiceList.prototype.recount = function () {
	        uiService_1.default.showDialogActionFlag();
	        return documentService_1.default.documentCount("Invoice", documentDomain_1.DOCUMENTLOCATION.Invoice, documentService_1.default.documentCountObject.gridParams)
	            .then(function (documentCountObjectDto) {
	            (0, mobx_1.extendObservable)(documentService_1.default.documentCountObject, documentCountObjectDto);
	            uiService_1.default.hideDialogActionFlag();
	        });
	    };
	    IssuedInvoiceList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        var bulkActions = [
	            { type: gridComp_1.BULKACTIONTYPE.ACTION, label: 'Download Invoices for printing', fn: this.downloadInvoices, that: this, securable: metaConstant_1.SECURABLE.downloadInvoices },
	            { type: gridComp_1.BULKACTIONTYPE.ACTION, label: 'Email Invoices', fn: this.emailInvoices, that: this, securable: metaConstant_1.SECURABLE.emailInvoices }
	        ];
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query, bulkActions: bulkActions, multiUpdateSecurable: metaConstant_1.SECURABLE.invoiceGridUpdate },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "invoiceDetail", params: { id: 'new' }, query: { paymentTypeId: invoiceDomain_1.PAYMENT_TYPE.ACCOUNT_TRANSFER }, label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["New Invoice"], ["New Invoice"]))), permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.invoiceDetail }),
	            react_1.default.createElement(downloadDialog_1.default, { ref: this.downloadDialogRefHandler, grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, entityName: "Invoice", documentLocation: documentDomain_1.DOCUMENTLOCATION.Invoice, bodyStyle: DownloadDialog_bodyStyle }, (documentService_1.default.documentCountObject && documentService_1.default.documentCountObject.gridParams) ?
	                react_1.default.createElement("div", { style: { marginTop: 5, marginLeft: 20 } },
	                    react_1.default.createElement(fields_1.MdCheckbox, { name: "includeAll", checked: documentService_1.default.documentCountObject.gridParams._includeAll, label: "Include all invoices (canceled, reopened)", onCheck: this.onCheckIncludeAll }),
	                    react_1.default.createElement(fields_1.MdCheckbox, { name: "markSent", checked: documentService_1.default.documentCountObject.gridParams._markSent, label: "Mark Invoices as Sent via post", onCheck: this.onCheckMarkSentByPost }),
	                    (documentService_1.default.documentCountObject.gridParams._markSent) ? (react_1.default.createElement(fields_1.MdCheckbox, { style: { marginLeft: 10 }, name: "includeSent", checked: documentService_1.default.documentCountObject.gridParams._includeSent, label: "Include already sent Invoices", onCheck: this.onCheckIncludeSent })) : null,
	                    (documentService_1.default.documentCountObject.gridParams._markSent) ? (react_1.default.createElement(fields_1.MdCheckbox, { style: { marginLeft: 10 }, name: "includeByAll", checked: documentService_1.default.documentCountObject.gridParams._includeByAll, label: "Include Invoices to be sent by email", disabled: true, onCheck: this.onCheckByAll })) : null)
	                : null),
	            react_1.default.createElement(entitiesEmailDialog_1.default, { ref: this.emailDialogRefHandler, entities: mdEntityService_1.default.entityMap, entityName: "Invoice", documentLocation: documentDomain_1.DOCUMENTLOCATION.Invoice, localizedEntitiesName: "invoices", entityDetailRoute: "invoiceDetail" })));
	    };
	    IssuedInvoiceList.module = metaConstant_1.MODULE.invoicing;
	    IssuedInvoiceList.title = locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Issued Invoices"], ["Issued Invoices"])));
	    IssuedInvoiceList.icon = 'money';
	    IssuedInvoiceList.rootPage = true;
	    IssuedInvoiceList.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], IssuedInvoiceList.prototype, "onCheckMarkSentByPost", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], IssuedInvoiceList.prototype, "onCheckIncludeSent", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], IssuedInvoiceList.prototype, "onCheckByAll", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], IssuedInvoiceList.prototype, "onCheckIncludeAll", void 0);
	    IssuedInvoiceList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], IssuedInvoiceList);
	    return IssuedInvoiceList;
	}(pageAncestor_1.default));
	exports.default = IssuedInvoiceList;
	var DownloadDialog_bodyStyle = { minHeight: 270 };
	var templateObject_1, templateObject_2;


/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	// Bootstrapping module
	__webpack_require__(1147);
	__webpack_require__(1146);
	__webpack_require__(1145);
	__webpack_require__(1115);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_dom_1 = tslib_1.__importDefault(__webpack_require__(31));
	var react_router_1 = tslib_1.__importDefault(__webpack_require__(65));
	var last = __webpack_require__(138);
	var values = __webpack_require__(1488);
	var routes_1 = __webpack_require__(75);
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	console.log('__ENVIRONMENT__ = ' + ("test"));
	// router
	react_router_1.default.run(routes_1.routes, react_router_1.default.HistoryLocation, function (Root, state) {
	    console.debug('router run');
	    commonService_1.default.emitter.emit('loadStart');
	    var routes = state.routes;
	    var lastRoute = routes[routes.length - 1];
	    if (lastRoute) {
	        var title = lastRoute.handler.title;
	        if (title) {
	            document.title = title;
	        }
	    }
	    var previousLastRoute = last(Root.getCurrentRoutes());
	    if (previousLastRoute && lastRoute) {
	        uiService_1.default.updateTransition({ params: Root.getCurrentParams(), query: Root.getCurrentQuery(), newQuery: state.query,
	            routeName: previousLastRoute.name, newRouteName: lastRoute.name, rootPage: previousLastRoute.handler.rootPage });
	    }
	    var promises = routes.filter(function (route) { return route.handler.fetchData; })
	        .reduce(function (promises, route) {
	        promises[route.name] = route.handler.fetchData(state.params, state.query);
	        return promises;
	    }, {});
	    Promise.all(values(promises))
	        .then(function (dataArray) {
	        react_dom_1.default.render(react_1.default.createElement(Root, tslib_1.__assign({}, state)), document.getElementById('root'));
	    });
	});


/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var prop_types_1 = tslib_1.__importDefault(__webpack_require__(2));
	var fields_1 = __webpack_require__(20);
	var formUtils_1 = __webpack_require__(14);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var blockComp_1 = __webpack_require__(30);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var arrayUtils_1 = __webpack_require__(78);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var styledDateInterval_1 = tslib_1.__importDefault(__webpack_require__(130));
	var dateUtils_1 = __webpack_require__(49);
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var pull = __webpack_require__(117);
	var SvgVpnKey = __webpack_require__(1836);
	var colors_1 = __webpack_require__(29);
	var stringUtils_1 = __webpack_require__(174);
	var utils_1 = __webpack_require__(37);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var metaConstant_1 = __webpack_require__(13);
	var routes_1 = __webpack_require__(75);
	var PartyBankAccountList = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyBankAccountList, _super);
	    function PartyBankAccountList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PartyBankAccountList.prototype.render = function () {
	        var _a = this.props, partyObject = _a.partyObject, entities = _a.entities, rootObject = _a.rootObject;
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true, style: { display: 'flex', flexDirection: 'column' } }, (0, arrayUtils_1.addSeparator)(partyObject.bankAccounts.map(function (bankAccount, index) { return react_1.default.createElement(PartyBankAccountForm, { dataObject: bankAccount, rootObject: partyObject, key: index, entities: entities, entity: entities.get('PartyBankAccount'), index: index }); }), react_1.default.createElement(blockComp_1.MdDivider, { inset: true }))));
	    };
	    PartyBankAccountList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], PartyBankAccountList);
	    return PartyBankAccountList;
	}(react_1.default.Component));
	exports.default = PartyBankAccountList;
	var PartyBankAccountFormClosedContent = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyBankAccountFormClosedContent, _super);
	    function PartyBankAccountFormClosedContent() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.transactions = function (event) {
	            console.log('transactions');
	            event.preventDefault();
	            _this.context.router.transitionTo("bankTransactionList", { id: _this.props.dataObject.partyBankAccountId }, (0, utils_1.addTenantToQuery)());
	        };
	        return _this;
	    }
	    PartyBankAccountFormClosedContent.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields;
	        var txUrl = (dataObject.partyBankAccountId) ? this.context.router.makeHref("bankTransactionList", { id: dataObject.partyBankAccountId }, (0, utils_1.addTenantToQuery)()) : null;
	        return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
	            react_1.default.createElement("div", { className: "form-text-row" },
	                react_1.default.createElement("span", { className: "zz-mr-5" }, (0, formUtils_1.lovValue)(dataObject.currency)),
	                (dataObject.accountNumber) ? react_1.default.createElement(formUtils_1.FieldText, { value: dataObject.getFullAccount() }) : null,
	                react_1.default.createElement(formUtils_1.FieldText, { label: fields.iban.textLabel, value: (0, stringUtils_1.chunkString)(dataObject.iban, 4, ' ') }),
	                react_1.default.createElement("span", { className: "zz-mr-10" }, (0, formUtils_1.lovLabel)(dataObject.bank)),
	                (dataObject.validFrom || dataObject.validTo) ? react_1.default.createElement(formUtils_1.FieldText, { label: fields.validFrom.textLabel, value: (0, dateUtils_1.formatInterval)(dataObject.validFrom, dataObject.validTo) }) : null,
	                react_1.default.createElement(formUtils_1.FieldText, { label: fields.comment.textLabel, value: dataObject.comment }),
	                (dataObject.hasApiToken) ? react_1.default.createElement("div", { style: { color: colors_1.indigo500 } },
	                    react_1.default.createElement(SvgVpnKey, { size: 20 })) : null,
	                (securityService_1.default.hasRight(routes_1.PAGE.bankTransactionList.name, metaConstant_1.PERMISSION.Read) && txUrl) ? react_1.default.createElement(FlatButton_1.default, { label: "Transactions", href: txUrl, primary: true, onClick: this.transactions }) : null)));
	    };
	    PartyBankAccountFormClosedContent.contextTypes = {
	        router: prop_types_1.default.func.isRequired,
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyBankAccountFormClosedContent.prototype, "transactions", void 0);
	    return PartyBankAccountFormClosedContent;
	}(react_1.default.Component));
	var PartyBankAccountForm = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyBankAccountForm, _super);
	    function PartyBankAccountForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDelete = function (evt) {
	            evt.stopPropagation();
	            console.log('onDelete %o', _this.props.dataObject);
	            pull(_this.props.rootObject.bankAccounts, _this.props.dataObject);
	        };
	        _this.setApiKey = function (evt) {
	            evt.stopPropagation();
	            return new Promise(function (resolve, reject) {
	                _this.apiDialogRef.open(resolve, reject);
	            }).then(function () {
	                _this.props.dataObject.apiToken = _this.apiTokenText;
	                _this.props.rootObject.$dirty = true;
	                if (_this.apiTokenText) {
	                    _this.props.dataObject.hasApiToken = true;
	                }
	                else {
	                    _this.props.dataObject.hasApiToken = false;
	                }
	                _this.apiTokenText = null;
	            }).catch(function (e) {
	                _this.apiTokenText = null;
	            });
	        };
	        _this.deleteApiKey = function (evt) {
	            _this.props.dataObject.apiToken = null;
	            _this.props.rootObject.$dirty = true;
	            _this.props.dataObject.hasApiToken = false;
	        };
	        _this.onChangeApiToken = function (evt) {
	            _this.apiTokenText = evt.target.value;
	        };
	        _this.apiDialogRefHandler = function (comp) { return _this.apiDialogRef = comp; };
	        return _this;
	    }
	    PartyBankAccountForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, entity = _a.entity, formName = _a.formName, rootObject = _a.rootObject, index = _a.index, entities = _a.entities;
	        var fields = dataObject.getFormFields(formName);
	        var accountPrefix = fields.accountPrefix, accountNumber = fields.accountNumber, iban = fields.iban, bank = fields.bank, currency = fields.currency, comment = fields.comment, validFrom = fields.validFrom, validTo = fields.validTo;
	        var apiTokenField = react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, createForm_1.fieldStyles.small.textArea, { value: this.apiTokenText, onChange: this.onChangeApiToken, fullWidth: true, hintText: "API Token", multiLine: true, rows: 5 }));
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.apiDialogRefHandler, cancelButtonText: "Cancel", okButtonText: "Ok", contentComponent: apiTokenField, title: "Paste API key here" }),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-md-2" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, accountPrefix.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-md-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, accountNumber.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: accountNumber, value: accountNumber.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-md-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, iban.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-md-10" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, bank.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: bank, value: bank.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-md-2" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, currency.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: currency, value: currency.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-md-8" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-md-4" },
	                    react_1.default.createElement(styledDateInterval_1.default, tslib_1.__assign({}, validFrom.props, { valueFrom: validFrom.props.value, valueTo: validTo.props.value, onChangeFrom: validFrom.props.onChange, onChangeTo: validTo.props.onChange }))))));
	        var openButtons = (react_1.default.createElement("div", null,
	            react_1.default.createElement(FlatButton_1.default, { label: "Set API Key", primary: true, onClick: this.setApiKey }),
	            (dataObject.hasApiToken) ? react_1.default.createElement(FlatButton_1.default, { label: "Delete API Key", primary: true, onClick: this.deleteApiKey }) : null));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(PartyBankAccountFormClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), key: index, onDelete: this.onDelete, validate: this.props.validate, openButtons: openButtons }, this.props)));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyBankAccountForm.prototype, "apiTokenText", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyBankAccountForm.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyBankAccountForm.prototype, "setApiKey", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyBankAccountForm.prototype, "deleteApiKey", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyBankAccountForm.prototype, "onChangeApiToken", void 0);
	    PartyBankAccountForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'PartyBankAccountForm',
	            fields: [{
	                    name: 'bank',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'accountPrefix'
	                }, {
	                    name: 'accountNumber'
	                }, {
	                    name: 'iban'
	                }, {
	                    name: 'currency',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'comment'
	                }, {
	                    name: 'validFrom'
	                }, {
	                    name: 'validTo'
	                }]
	        }, PartyBankAccountFormClosedContent),
	        mobx_react_1.observer
	    ], PartyBankAccountForm);
	    return PartyBankAccountForm;
	}(react_1.default.Component));


/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var blockComp_1 = __webpack_require__(30);
	var PartyFeatureForms = tslib_1.__importStar(__webpack_require__(2162));
	var arrayUtils_1 = __webpack_require__(78);
	var blockComp_2 = __webpack_require__(30);
	var mobx_react_1 = __webpack_require__(4);
	var PartyFeatureList = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyFeatureList, _super);
	    function PartyFeatureList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PartyFeatureList.prototype.render = function () {
	        var _a = this.props, partyObject = _a.partyObject, rootObject = _a.rootObject, entities = _a.entities;
	        return (partyObject.features && partyObject.features.length) ? (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true, style: { display: 'flex', flexDirection: 'column' } }, (0, arrayUtils_1.addSeparator)(partyObject.features.map(function (feature, index) {
	            var PartyFeatureForm = PartyFeatureForms[feature.featureType + 'Form'];
	            return react_1.default.createElement(PartyFeatureForm, { dataObject: feature, rootObject: partyObject, key: index, entities: entities, entity: entities.get('PartyFeature'), index: index });
	        }), react_1.default.createElement(blockComp_2.MdDivider, { inset: true })))) : null;
	    };
	    PartyFeatureList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], PartyFeatureList);
	    return PartyFeatureList;
	}(react_1.default.Component));
	exports.default = PartyFeatureList;


/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AUTONEUM_DATAForm = exports.VOLVO_LOGINSForm = exports.INVOICE_DATAForm = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var pull = __webpack_require__(117);
	var fields_1 = __webpack_require__(20);
	var formUtils_1 = __webpack_require__(14);
	var createForm_1 = __webpack_require__(18);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var partyDomain_1 = __webpack_require__(48);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var productDomain_1 = __webpack_require__(158);
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var commonDataService_1 = __webpack_require__(41);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var mdEntityService_2 = tslib_1.__importDefault(__webpack_require__(11));
	/* ************************************************************************************************
	 * ***********   INVOICE_DATAForm *************************************************************
	 * ********************************************************************************************** */
	var INVOICE_DATAFormName = 'INVOICE_DATAForm';
	var INVOICE_DATAClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.accountingMatchingId.textLabel, value: dataObject.value1 }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.invoiceDateDelay.textLabel, value: dataObject.value2, mdField: fields.invoiceDateDelay.mdField }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.customerMatchingId.textLabel, value: dataObject.value3 }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.customerMatchingId2.textLabel, value: dataObject.value6 }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.invoicingPeriod.textLabel, value: dataObject.value4, mdField: fields.invoicingPeriod.mdField }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.invoicingStartDate.textLabel, value: dataObject.value5, mdField: fields.invoicingStartDate.mdField }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.tradingPartner.textLabel, value: dataObject.value7 }))));
	};
	var INVOICE_DATAForm = /** @class */ (function (_super) {
	    tslib_1.__extends(INVOICE_DATAForm, _super);
	    function INVOICE_DATAForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDelete = function (evt) {
	            evt.stopPropagation();
	            console.log('onDelete %o', _this.props.dataObject);
	            pull(_this.props.rootObject.features, _this.props.dataObject);
	        };
	        return _this;
	    }
	    INVOICE_DATAForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, index = _a.index, entities = _a.entities, entity = _a.entity, formName = _a.formName;
	        var fields = dataObject.getFormFields(formName);
	        var accountingMatchingId = fields.accountingMatchingId, invoiceDateDelay = fields.invoiceDateDelay, customerMatchingId = fields.customerMatchingId, invoicingPeriod = fields.invoicingPeriod, invoicingStartDate = fields.invoicingStartDate, customerMatchingId2 = fields.customerMatchingId2, tradingPartner = fields.tradingPartner;
	        var iddValues = ["P1M", "P2M", "P3M", "P4M", "P5M", "P6M", "P7M", "P8M", "P9M", "P10M", "P11M", "P1Y"];
	        var iddOptions = tslib_1.__spreadArray([{ value: null, label: '---' }], iddValues.map(function (v) { return ({ value: v, label: moment_1.default.duration(v).humanize() }); }), true);
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, accountingMatchingId.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: accountingMatchingId, value: accountingMatchingId.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, invoiceDateDelay.props, { searchable: false, clearable: false, options: iddOptions })),
	                    react_1.default.createElement(validate_1.Validate, { field: invoiceDateDelay, value: invoiceDateDelay.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, customerMatchingId.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, invoicingPeriod.props, { searchable: false, clearable: false, options: iddOptions })),
	                    react_1.default.createElement(validate_1.Validate, { field: invoicingPeriod, value: invoicingPeriod.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, invoicingStartDate.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: invoicingStartDate, value: invoicingStartDate.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, customerMatchingId2.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, tradingPartner.props))))));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(INVOICE_DATAClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), key: index, onDelete: this.onDelete, validate: this.props.validate }, this.props)));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], INVOICE_DATAForm.prototype, "onDelete", void 0);
	    INVOICE_DATAForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: INVOICE_DATAFormName,
	            fields: [{
	                    name: 'accountingMatchingId',
	                    validators: ['IsRequired', 'IsNumber', { validation: 'HasLength', parameters: { max: 10 } }],
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value1 = (value === '') ? null : value; },
	                    getFieldValueFn: function (dataObject) { return dataObject.value1; }
	                }, {
	                    name: 'invoiceDateDelay',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value2 = (0, formUtils_1.lovValue)(value); },
	                    getFieldValueFn: function (dataObject) { return dataObject.value2; }
	                }, {
	                    name: 'customerMatchingId',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value3 = (value === '') ? null : value; },
	                    getFieldValueFn: function (dataObject) { return dataObject.value3; }
	                }, {
	                    name: 'invoicingPeriod',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value4 = (0, formUtils_1.lovValue)(value); },
	                    getFieldValueFn: function (dataObject) { return dataObject.value4; }
	                }, {
	                    name: 'invoicingStartDate',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value5 = (value === '') ? null : value; },
	                    getFieldValueFn: function (dataObject) { return dataObject.value5; }
	                }, {
	                    name: 'customerMatchingId2',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value6 = (value === '') ? null : value; },
	                    getFieldValueFn: function (dataObject) { return dataObject.value6; }
	                }, {
	                    name: 'tradingPartner',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value7 = (value === '') ? null : value; },
	                    getFieldValueFn: function (dataObject) { return dataObject.value7; }
	                }
	            ]
	        }, INVOICE_DATAClosedContent),
	        mobx_react_1.observer
	    ], INVOICE_DATAForm);
	    return INVOICE_DATAForm;
	}(react_1.default.Component));
	exports.INVOICE_DATAForm = INVOICE_DATAForm;
	/* ************************************************************************************************
	 * ***********   VOLVO_LOGINSForm *************************************************************
	 * ********************************************************************************************** */
	var VOLVO_LOGINSFormName = 'VOLVO_LOGINSForm';
	// * 1:  adminLoginDF
	// * 2:  adminPasswordDF
	// * 3:  adminLoginOF
	// * 4:  adminPasswordOF
	// * 5:  userLoginDF
	// * 6:  userPasswordDF
	// * 7:  userLoginOF
	// * 8:  userPasswordOF
	// * 9:  fuelCheckLogin
	// * 10: fuelCheckPassword
	// * 11: volvoLogin
	// * 12: renaultLogin
	var VOLVO_LOGINSClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.adminLoginDF.textLabel, value: dataObject.value1 }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.adminPasswordDF.textLabel, value: dataObject.value2 }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.adminLoginOF.textLabel, value: dataObject.value3 }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.adminPasswordOF.textLabel, value: dataObject.value4 })),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.userLoginDF.textLabel, value: dataObject.value5 }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.userPasswordDF.textLabel, value: dataObject.value6 }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.userLoginOF.textLabel, value: dataObject.value7 }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.userPasswordOF.textLabel, value: dataObject.value8 })),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.fuelCheckLogin.textLabel, value: dataObject.value9 }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.fuelCheckPassword.textLabel, value: dataObject.value10 }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.volvoLogin.textLabel, value: dataObject.value11 }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.renaultLogin.textLabel, value: dataObject.value12 }))));
	};
	var VOLVO_LOGINSForm = /** @class */ (function (_super) {
	    tslib_1.__extends(VOLVO_LOGINSForm, _super);
	    function VOLVO_LOGINSForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDelete = function (evt) {
	            evt.stopPropagation();
	            console.log('onDelete %o', _this.props.dataObject);
	            pull(_this.props.rootObject.features, _this.props.dataObject);
	        };
	        _this.onVolvoLoginEnable = function (value) {
	            return !value;
	        };
	        _this.onVolvoLogin = function (evt) {
	            evt.preventDefault();
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            mdEntityService_1.default.fetchNextEntityNumber("PartyFeature_VOLVO_LOGINS", null, productDomain_1.PROFITCENTER.DYNAFLEET, null)
	                .then((0, mobx_1.action)("fetchNextEntityNumber-actionCb", function (entityNumber) {
	                if (entityNumber) {
	                    dataObject.value11 = entityNumber;
	                    form.updateFieldsPropValue(dataObject, "volvoLogin");
	                    rootObject.$dirty = true;
	                }
	            }));
	        };
	        _this.onRenaultLogin = function (evt) {
	            evt.preventDefault();
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, form = _a.form;
	            mdEntityService_1.default.fetchNextEntityNumber("PartyFeature_VOLVO_LOGINS", null, productDomain_1.PROFITCENTER.OPTIFLEET, null)
	                .then((0, mobx_1.action)("fetchNextEntityNumber-actionCb", function (entityNumber) {
	                if (entityNumber) {
	                    dataObject.value12 = entityNumber;
	                    form.updateFieldsPropValue(dataObject, "renaultLogin");
	                    rootObject.$dirty = true;
	                }
	            }));
	        };
	        return _this;
	    }
	    VOLVO_LOGINSForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, index = _a.index, entities = _a.entities, entity = _a.entity, formName = _a.formName;
	        var fields = dataObject.getFormFields(formName);
	        var adminLoginDF = fields.adminLoginDF, adminPasswordDF = fields.adminPasswordDF, adminLoginOF = fields.adminLoginOF, adminPasswordOF = fields.adminPasswordOF, userLoginDF = fields.userLoginDF, userPasswordDF = fields.userPasswordDF, userLoginOF = fields.userLoginOF, userPasswordOF = fields.userPasswordOF, fuelCheckLogin = fields.fuelCheckLogin, fuelCheckPassword = fields.fuelCheckPassword, volvoLogin = fields.volvoLogin, renaultLogin = fields.renaultLogin;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, adminLoginDF.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, adminPasswordDF.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, adminLoginOF.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, adminPasswordOF.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, userLoginDF.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, userPasswordDF.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, userLoginOF.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, userPasswordOF.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, fuelCheckLogin.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, fuelCheckPassword.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, volvoLogin.props, { showValidationIcon: true, onAction: this.onVolvoLogin, onActionEnable: this.onVolvoLoginEnable }))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, renaultLogin.props, { showValidationIcon: true, onAction: this.onRenaultLogin, onActionEnable: this.onVolvoLoginEnable }))))));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(VOLVO_LOGINSClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), key: index, onDelete: this.onDelete, validate: this.props.validate }, this.props)));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], VOLVO_LOGINSForm.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], VOLVO_LOGINSForm.prototype, "onVolvoLoginEnable", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], VOLVO_LOGINSForm.prototype, "onVolvoLogin", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], VOLVO_LOGINSForm.prototype, "onRenaultLogin", void 0);
	    VOLVO_LOGINSForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: VOLVO_LOGINSFormName,
	            fields: [{
	                    name: 'adminLoginDF',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value1 = (value === '') ? null : value; },
	                    getFieldValueFn: function (dataObject) { return dataObject.value1; }
	                }, {
	                    name: 'adminPasswordDF',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value2 = (value === '') ? null : value; },
	                    getFieldValueFn: function (dataObject) { return dataObject.value2; }
	                }, {
	                    name: 'adminLoginOF',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value3 = (value === '') ? null : value; },
	                    getFieldValueFn: function (dataObject) { return dataObject.value3; }
	                }, {
	                    name: 'adminPasswordOF',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value4 = (value === '') ? null : value; },
	                    getFieldValueFn: function (dataObject) { return dataObject.value4; }
	                }, {
	                    name: 'userLoginDF',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value5 = (value === '') ? null : value; },
	                    getFieldValueFn: function (dataObject) { return dataObject.value5; }
	                }, {
	                    name: 'userPasswordDF',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value6 = (value === '') ? null : value; },
	                    getFieldValueFn: function (dataObject) { return dataObject.value6; }
	                }, {
	                    name: 'userLoginOF',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value7 = (value === '') ? null : value; },
	                    getFieldValueFn: function (dataObject) { return dataObject.value7; }
	                }, {
	                    name: 'userPasswordOF',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value8 = (value === '') ? null : value; },
	                    getFieldValueFn: function (dataObject) { return dataObject.value8; }
	                }, {
	                    name: 'fuelCheckLogin',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value9 = (value === '') ? null : value; },
	                    getFieldValueFn: function (dataObject) { return dataObject.value9; }
	                }, {
	                    name: 'fuelCheckPassword',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value10 = (value === '') ? null : value; },
	                    getFieldValueFn: function (dataObject) { return dataObject.value10; }
	                }, {
	                    name: 'volvoLogin',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value11 = (value === '') ? null : value; },
	                    getFieldValueFn: function (dataObject) { return dataObject.value11; }
	                }, {
	                    name: 'renaultLogin',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value12 = value; },
	                    getFieldValueFn: function (dataObject) { return dataObject.value12; }
	                }]
	        }, VOLVO_LOGINSClosedContent),
	        mobx_react_1.observer
	    ], VOLVO_LOGINSForm);
	    return VOLVO_LOGINSForm;
	}(react_1.default.Component));
	exports.VOLVO_LOGINSForm = VOLVO_LOGINSForm;
	/* ************************************************************************************************
	* ***********   AUTONEUM_DATAForm *************************************************************
	* ********************************************************************************************** */
	var AUTONEUM_DATAFormName = 'AUTONEUM_DATAForm';
	// * 1:  disponentNumber
	var AUTONEUM_DATAClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    var addressPlaceMdEntity = mdEntityService_2.default.getEntity("AddressPlace");
	    var defaultShippedFromPlace = (dataObject.value2) ? addressPlaceMdEntity.getLovItem(dataObject.value2, false) : null;
	    var defaultShippedToPlace = (dataObject.value3) ? addressPlaceMdEntity.getLovItem(dataObject.value3, false) : null;
	    return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.disponentNumber.textLabel, value: dataObject.value1 }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.defaultShippedFromPlace.textLabel, value: defaultShippedFromPlace }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.defaultShippedToPlace.textLabel, value: defaultShippedToPlace }))));
	};
	var AUTONEUM_DATAForm = /** @class */ (function (_super) {
	    tslib_1.__extends(AUTONEUM_DATAForm, _super);
	    function AUTONEUM_DATAForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDelete = function (evt) {
	            evt.stopPropagation();
	            console.log('onDelete %o', _this.props.dataObject);
	            pull(_this.props.rootObject.features, _this.props.dataObject);
	        };
	        return _this;
	    }
	    AUTONEUM_DATAForm.prototype.componentDidMount = function () {
	        return this.populateDropdowns(true);
	    };
	    AUTONEUM_DATAForm.prototype.componentDidUpdate = function () {
	        var _a = this.props, form = _a.form, dataObject = _a.dataObject;
	        var defaultShippedFromPlaceField = form.getField("defaultShippedFromPlace");
	        var defaultShippedToPlaceField = form.getField("defaultShippedToPlace");
	        if ((defaultShippedToPlaceField && (!defaultShippedToPlaceField.props.options || !defaultShippedToPlaceField.props.options.length))
	            || (defaultShippedFromPlaceField && (!defaultShippedFromPlaceField.props.options || !defaultShippedFromPlaceField.props.options.length))) {
	            console.debug("componentDidUpdate, no dropdown data filling");
	            return this.populateDropdowns(false);
	        }
	    };
	    AUTONEUM_DATAForm.prototype.populateDropdowns = function (initial) {
	        var _a = this.props, dataObject = _a.dataObject, form = _a.form;
	        return (Promise.all([
	            (0, commonDataService_1.optionsSearch)('AddressPlace', {
	                partyId: securityService_1.default.currentTenant.party.value,
	                placeType: partyDomain_1.ADDRESSPLACETYPE.EXPEDITION
	            }), (0, commonDataService_1.optionsSearch)('AddressPlace', {
	                partyId: securityService_1.default.currentTenant.party.value,
	                placeType: partyDomain_1.ADDRESSPLACETYPE.INCOMING
	            })
	        ]))
	            .then((0, mobx_1.action)("populateDropdowns-action", function (_a) {
	            var fromPlaceOptions = _a[0].options, toPlaceOptions = _a[1].options;
	            fromPlaceOptions.unshift({ value: null, label: '---' });
	            toPlaceOptions.unshift({ value: null, label: '---' });
	            form.getField("defaultShippedFromPlace").props.options = mobx_1.observable.shallowArray(fromPlaceOptions);
	            form.getField("defaultShippedToPlace").props.options = mobx_1.observable.shallowArray(toPlaceOptions);
	            form.updateFieldsPropValue(dataObject, "defaultShippedFromPlace", "defaultShippedToPlace");
	        }));
	    };
	    AUTONEUM_DATAForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, index = _a.index, entities = _a.entities, entity = _a.entity, formName = _a.formName;
	        var fields = dataObject.getFormFields(formName);
	        var disponentNumber = fields.disponentNumber, defaultShippedFromPlace = fields.defaultShippedFromPlace, defaultShippedToPlace = fields.defaultShippedToPlace;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, disponentNumber.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, defaultShippedFromPlace.props, { clearable: false }))),
	                react_1.default.createElement("div", { className: "fx col-xs-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, defaultShippedToPlace.props, { clearable: false }))))));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(AUTONEUM_DATAClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), key: index, onDelete: this.onDelete, validate: this.props.validate }, this.props)));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], AUTONEUM_DATAForm.prototype, "onDelete", void 0);
	    AUTONEUM_DATAForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: AUTONEUM_DATAFormName,
	            fields: [{
	                    name: 'disponentNumber',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value1 = (value === '') ? null : value; },
	                    getFieldValueFn: function (dataObject) { return dataObject.value1; }
	                },
	                {
	                    name: 'defaultShippedFromPlace',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value2 = (0, formUtils_1.lovValue)(value); },
	                    getFieldValueFn: function (dataObject) { return dataObject.value2; }
	                },
	                {
	                    name: 'defaultShippedToPlace',
	                    setFieldValueFn: function (dataObject, value) { return dataObject.value3 = (0, formUtils_1.lovValue)(value); },
	                    getFieldValueFn: function (dataObject) { return dataObject.value3; }
	                }]
	        }, AUTONEUM_DATAClosedContent),
	        mobx_react_1.observer
	    ], AUTONEUM_DATAForm);
	    return AUTONEUM_DATAForm;
	}(react_1.default.Component));
	exports.AUTONEUM_DATAForm = AUTONEUM_DATAForm;


/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pull = __webpack_require__(117);
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var blockComp_1 = __webpack_require__(30);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var arrayUtils_1 = __webpack_require__(78);
	var blockComp_2 = __webpack_require__(30);
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var formUtils_1 = __webpack_require__(14);
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var form_1 = __webpack_require__(52);
	var PNF_CC_DIC = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  font-size: 14px;\n  line-height: 14px;\n  min-height: 20px;\n"], ["\n  font-size: 14px;\n  line-height: 14px;\n  min-height: 20px;\n"])));
	var PartyNoteList = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyNoteList, _super);
	    function PartyNoteList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PartyNoteList.prototype.render = function () {
	        var _a = this.props, partyObject = _a.partyObject, rootObject = _a.rootObject, entities = _a.entities;
	        return (partyObject.notes && partyObject.notes.length) ? (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true, style: { display: 'flex', flexDirection: 'column' } }, (0, arrayUtils_1.addSeparator)(partyObject.notes.map(function (note, index) { return react_1.default.createElement(PartyNoteForm, { dataObject: note, rootObject: partyObject, key: index, entities: entities, entity: entities.get('PartyNote'), index: index }); }), react_1.default.createElement(blockComp_2.MdDivider, { inset: true })))) : null;
	    };
	    PartyNoteList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], PartyNoteList);
	    return PartyNoteList;
	}(react_1.default.Component));
	exports.default = PartyNoteList;
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement(PNF_CC_DIC, null,
	        react_1.default.createElement("div", { className: "zz-grey-text zz-mb-5" }, (0, formUtils_1.lovLabel)(dataObject.noteType)),
	        dataObject.content));
	};
	var PartyNoteForm = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyNoteForm, _super);
	    function PartyNoteForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDelete = function (evt) {
	            evt.stopPropagation();
	            console.log('onDelete %o', _this.props.dataObject);
	            pull(_this.props.rootObject.notes, _this.props.dataObject);
	        };
	        return _this;
	    }
	    PartyNoteForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entity = _a.entity, index = _a.index, entities = _a.entities, formName = _a.formName;
	        var fields = dataObject.getFormFields(formName);
	        var content = fields.content, noteType = fields.noteType;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4 col-md-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, noteType.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, content.props, { multiLine: true, rows: 2 })),
	                    react_1.default.createElement(validate_1.Validate, { field: content, value: content.props.value })))));
	        return (react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), key: index, onDelete: this.onDelete, validate: this.props.validate }, this.props)));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyNoteForm.prototype, "onDelete", void 0);
	    PartyNoteForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'PartyNoteForm',
	            fields: [{
	                    name: 'content',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.textArea,
	                    validators: ['IsRequired']
	                }, {
	                    name: 'noteType'
	                }]
	        }, ClosedContent),
	        mobx_react_1.observer
	    ], PartyNoteForm);
	    return PartyNoteForm;
	}(react_1.default.Component));
	var templateObject_1;


/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var commonDataService_1 = __webpack_require__(41);
	var newPartyDialog_1 = tslib_1.__importDefault(__webpack_require__(948));
	var formUtils_1 = __webpack_require__(14);
	var validate_1 = __webpack_require__(24);
	var mobx_react_1 = __webpack_require__(4);
	var partyDomain_1 = __webpack_require__(48);
	var mobx_1 = __webpack_require__(5);
	var fields_1 = __webpack_require__(20);
	var form_1 = __webpack_require__(52);
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, setDataAction = _a.setDataAction, fields = _a.fields;
	    return (react_1.default.createElement("div", { style: { fontSize: 16, lineHeight: '16px', minHeight: 20 } },
	        (0, formUtils_1.lovLabel)(dataObject.relType),
	        ' ',
	        (dataObject.relType.directionFrom) ? (0, formUtils_1.lovLabel)(dataObject.toParty) : (0, formUtils_1.lovLabel)(dataObject.fromParty)));
	};
	var PartyRelForm = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyRelForm, _super);
	    function PartyRelForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.newParty = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, formName = _a.formName;
	            var roleType = entities.get('PartyRoleType').getLovItem(dataObject.relType.roleId);
	            var newPartyObject = new partyDomain_1.Party({
	                active: true,
	                $new: true,
	                partyCategory: (0, formUtils_1.lovParam)(roleType, 'defaultPartyCategory'),
	                roles: [new partyDomain_1.PartyRole({ roleType: roleType }).initDefaultValues()]
	            }).initAfterRead(true);
	            console.log("newParty roleType = %O", roleType);
	            new Promise(function (resolve, reject) {
	                _this.newPartyDialogRef.open(resolve, reject, newPartyObject);
	            }).then((0, mobx_1.action)("close-new-party-diaglog", function (newPartyLov) {
	                var key = (dataObject.relType.directionFrom) ? "toParty" : "fromParty";
	                dataObject[key] = newPartyLov;
	                dataObject.getForm(formName).updateFieldsPropValue(dataObject, key);
	                console.debug("update PartyRel %O", dataObject);
	            })).catch(function (e) { });
	        };
	        _this.newPartyDialogRefHandler = function (comp) { return _this.newPartyDialogRef = comp; };
	        return _this;
	    }
	    PartyRelForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, formName = _a.formName;
	        var _b = dataObject.getFormFields(formName), fromParty = _b.fromParty, toParty = _b.toParty, comments = _b.comments, description = _b.description;
	        return (react_1.default.createElement("div", null,
	            (dataObject.$new) ? (react_1.default.createElement("div", { style: { display: 'flex' } },
	                react_1.default.createElement(newPartyDialog_1.default, { ref: this.newPartyDialogRefHandler }),
	                react_1.default.createElement("h5", null,
	                    "Search for ",
	                    dataObject.relType.roleLabel,
	                    " to link"),
	                (dataObject.relType.directionFrom) ?
	                    react_1.default.createElement("div", { style: { marginLeft: 15, flexGrow: 1 } },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, toParty.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [dataObject.relType.roleId] }), clearable: true, hintText: "type to start search..." })),
	                        react_1.default.createElement(validate_1.Validate, { field: toParty, value: toParty.props.value }))
	                    :
	                        react_1.default.createElement("div", { style: { marginLeft: 15, flexGrow: 1 } },
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, fromParty.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [dataObject.relType.roleId] }), clearable: true, hintText: "type to start search..." })),
	                            react_1.default.createElement(validate_1.Validate, { field: fromParty, value: fromParty.props.value })),
	                react_1.default.createElement(FlatButton_1.default, { labelStyle: { fontSize: 20 }, style: { alignSelf: 'center' }, label: " or create a new one", secondary: true, onClick: this.newParty }))) : null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, description.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comments.props, { multiLine: true, rows: 2 }))))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyRelForm.prototype, "newParty", void 0);
	    PartyRelForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'PartyRelForm',
	            fields: [{
	                    name: 'fromParty',
	                    validators: ['IsRequired'],
	                    usePlaceholder: true
	                }, {
	                    name: 'toParty',
	                    validators: ['IsRequired'],
	                    usePlaceholder: true
	                }, {
	                    name: 'description'
	                }, {
	                    name: 'comments',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	                }]
	        }, ClosedContent),
	        mobx_react_1.observer
	    ], PartyRelForm);
	    return PartyRelForm;
	}(react_1.default.Component));
	exports.default = PartyRelForm;


/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var AddressPlacesList = /** @class */ (function (_super) {
	    tslib_1.__extends(AddressPlacesList, _super);
	    function AddressPlacesList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    AddressPlacesList.fetchData = function (routerParams) {
	        console.log("AddressPlacesList#fetchData(%s)");
	        return Promise.resolve(null);
	    };
	    AddressPlacesList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement("div", null, "\"Address places list\""));
	    };
	    AddressPlacesList.module = metaConstant_1.MODULE.party;
	    AddressPlacesList.title = 'Addres places';
	    AddressPlacesList.icon = 'fa-envelope-o';
	    AddressPlacesList.rootPage = true;
	    AddressPlacesList.protectedPage = 'partyDetail';
	    AddressPlacesList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], AddressPlacesList);
	    return AddressPlacesList;
	}(pageAncestor_1.default));
	exports.default = AddressPlacesList;


/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var partyDomain_1 = __webpack_require__(48);
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'partyContacts';
	var ContactPersonList = /** @class */ (function (_super) {
	    tslib_1.__extends(ContactPersonList, _super);
	    function ContactPersonList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ContactPersonList.fetchData = function (params) {
	        console.log("ContactPersonList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    ContactPersonList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query, multiUpdateSecurable: metaConstant_1.SECURABLE.partyGridUpdate },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "partyDetail", params: { id: 'new' }, query: { partyCategory: partyDomain_1.PARTYCATEGORY.PE, roles: partyDomain_1.PARTYROLE.CONTACT_ROLE }, label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["New Contact"], ["New Contact"]))), permission: metaConstant_1.PERMISSION.New })));
	    };
	    ContactPersonList.module = metaConstant_1.MODULE.party;
	    ContactPersonList.title = locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Contact persons"], ["Contact persons"])));
	    ContactPersonList.icon = 'female';
	    ContactPersonList.rootPage = true;
	    ContactPersonList.protectedPage = true;
	    ContactPersonList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ContactPersonList);
	    return ContactPersonList;
	}(pageAncestor_1.default));
	exports.default = ContactPersonList;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var invoicesIssueDialog_1 = tslib_1.__importDefault(__webpack_require__(2150));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var partyDomain_1 = __webpack_require__(48);
	var gridComp_1 = __webpack_require__(44);
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'partyCustomers';
	var CustomerList = /** @class */ (function (_super) {
	    tslib_1.__extends(CustomerList, _super);
	    function CustomerList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.invoicesIssueDialogRefHandler = function (comp) { return _this.invoicesIssueDialogRef = comp; };
	        _this.issueInvoices = function (grid) {
	            new Promise(function (resolve, reject) {
	                _this.invoicesIssueDialogRef.open(resolve, reject, grid);
	            }).catch(function (error) {
	                console.log('rejecting InvoicesIssueDialog with ', error);
	                if (error) {
	                    if (error.response && error.response.data && error.response.data.severity === 'ERROR') {
	                        grid.errors = error.response.data.messages;
	                    }
	                    else {
	                        throw error;
	                    }
	                }
	            });
	        };
	        return _this;
	    }
	    CustomerList.fetchData = function (routerParams) {
	        console.log("CustomerList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    CustomerList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        var bulkActions = [{ type: gridComp_1.BULKACTIONTYPE.ACTION, label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Issue Invoices"], ["Issue Invoices"]))), fn: this.issueInvoices, that: this, securable: metaConstant_1.SECURABLE.issueInvoices }];
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query, bulkActions: bulkActions, multiUpdateSecurable: metaConstant_1.SECURABLE.partyGridUpdate },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "partyDetail", params: { id: 'new' }, query: { partyCategory: partyDomain_1.PARTYCATEGORY.CO, roles: partyDomain_1.PARTYROLE.CUSTOMER_ROLE }, label: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["New Customer"], ["New Customer"]))), permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(invoicesIssueDialog_1.default, { ref: this.invoicesIssueDialogRefHandler, entities: mdEntityService_1.default.entityMap })));
	    };
	    CustomerList.module = metaConstant_1.MODULE.party;
	    CustomerList.title = locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Customers"], ["Customers"])));
	    CustomerList.icon = 'male';
	    CustomerList.rootPage = true;
	    CustomerList.protectedPage = true;
	    CustomerList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], CustomerList);
	    return CustomerList;
	}(pageAncestor_1.default));
	exports.default = CustomerList;
	var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var partyDomain_1 = __webpack_require__(48);
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'partyDrivers';
	var DriverList = /** @class */ (function (_super) {
	    tslib_1.__extends(DriverList, _super);
	    function DriverList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DriverList.fetchData = function (routerParams) {
	        console.log("DriverList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    DriverList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query, multiUpdateSecurable: metaConstant_1.SECURABLE.partyGridUpdate },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "partyDetail", params: { id: 'new' }, query: { partyCategory: partyDomain_1.PARTYCATEGORY.PE, roles: partyDomain_1.PARTYROLE.DRIVER }, label: "New Driver", permission: metaConstant_1.PERMISSION.New })));
	    };
	    DriverList.module = metaConstant_1.MODULE.party;
	    DriverList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Drivers"], ["Drivers"])));
	    DriverList.icon = 'truck';
	    DriverList.rootPage = true;
	    DriverList.protectedPage = true;
	    DriverList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], DriverList);
	    return DriverList;
	}(pageAncestor_1.default));
	exports.default = DriverList;
	var templateObject_1;


/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var partyDomain_1 = __webpack_require__(48);
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'partyHaulers';
	var HaulerList = /** @class */ (function (_super) {
	    tslib_1.__extends(HaulerList, _super);
	    function HaulerList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    HaulerList.fetchData = function (routerParams) {
	        console.log("HaulerList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    HaulerList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query, multiUpdateSecurable: metaConstant_1.SECURABLE.partyGridUpdate },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "partyDetail", params: { id: 'new' }, query: { partyCategory: partyDomain_1.PARTYCATEGORY.CO, roles: partyDomain_1.PARTYROLE.HAULER }, label: "New Hauler", permission: metaConstant_1.PERMISSION.New })));
	    };
	    HaulerList.module = metaConstant_1.MODULE.party;
	    HaulerList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Haulers"], ["Haulers"])));
	    HaulerList.icon = 'truck';
	    HaulerList.rootPage = true;
	    HaulerList.protectedPage = true;
	    HaulerList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], HaulerList);
	    return HaulerList;
	}(pageAncestor_1.default));
	exports.default = HaulerList;
	var templateObject_1;


/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var react_router_1 = __webpack_require__(65);
	var Tabs_1 = tslib_1.__importDefault(__webpack_require__(107));
	var buttons_1 = __webpack_require__(27);
	var Tab_1 = tslib_1.__importDefault(__webpack_require__(102));
	var MenuItem_1 = tslib_1.__importDefault(__webpack_require__(101));
	var Divider_1 = tslib_1.__importDefault(__webpack_require__(241));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var icons_1 = __webpack_require__(63);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var partyService_1 = tslib_1.__importDefault(__webpack_require__(175));
	var mui_theme_1 = __webpack_require__(119);
	var variables_1 = __webpack_require__(96);
	var formUtils_1 = __webpack_require__(14);
	var partyFoForm_1 = tslib_1.__importDefault(__webpack_require__(953));
	var partyPoForm_1 = tslib_1.__importDefault(__webpack_require__(954));
	var partyRelForm_1 = tslib_1.__importDefault(__webpack_require__(2164));
	var partyContactList_1 = tslib_1.__importDefault(__webpack_require__(951));
	var partyRoleForm_1 = tslib_1.__importDefault(__webpack_require__(955));
	var partyNoteList_1 = tslib_1.__importDefault(__webpack_require__(2163));
	var partyFeatureList_1 = tslib_1.__importDefault(__webpack_require__(2161));
	var partyAddressList_1 = tslib_1.__importDefault(__webpack_require__(950));
	var errorComp_1 = __webpack_require__(34);
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridComp_1 = tslib_1.__importStar(__webpack_require__(44));
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var productVehicleAssignDialog_1 = tslib_1.__importDefault(__webpack_require__(571));
	var favicon_1 = __webpack_require__(562);
	var blockComp_1 = __webpack_require__(30);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var metaConstant_1 = __webpack_require__(13);
	var partyDomain_1 = __webpack_require__(48);
	var gridUtils_1 = __webpack_require__(83);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var arrayUtils_1 = __webpack_require__(78);
	var vehicleExpando_1 = tslib_1.__importDefault(__webpack_require__(956));
	var activityExpando_1 = tslib_1.__importDefault(__webpack_require__(566));
	var productDomain_1 = __webpack_require__(158);
	var more_vert_1 = tslib_1.__importDefault(__webpack_require__(291));
	var taskDialog_1 = tslib_1.__importDefault(__webpack_require__(567));
	var eventDomain_1 = __webpack_require__(74);
	var gridDocument_1 = __webpack_require__(313);
	var gridDocumentComp_1 = tslib_1.__importDefault(__webpack_require__(312));
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var validator_1 = tslib_1.__importDefault(__webpack_require__(576));
	var partyBankAccountList_1 = tslib_1.__importDefault(__webpack_require__(2160));
	var partyCreditEntry_1 = __webpack_require__(952);
	var colors_1 = __webpack_require__(29);
	var domUtils_1 = __webpack_require__(91);
	var IconButton_1 = tslib_1.__importDefault(__webpack_require__(126));
	var FontIcon_1 = tslib_1.__importDefault(__webpack_require__(164));
	var utils_1 = __webpack_require__(37);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var routes_1 = __webpack_require__(75);
	var shipmentDomain_1 = __webpack_require__(132);
	var locales_1 = __webpack_require__(15);
	var securityDomain_1 = __webpack_require__(97);
	var vehicleGridLocation = 'partyVehicleList';
	var invoiceGridLocation = 'partyInvoiceList';
	var invoiceItemGridLocation = 'partyInvoiceItemList';
	var partyRelGridLocation = 'partyRelList';
	var partyPriceComponentGridLocation = "partyPriceComponentList";
	var partyActivityGridLocation = "partyActivityPartyList";
	var taskGridLocation = "taskPartyList";
	var partyGridDocument = 'partyGridDocument';
	var shipmentGridLocation = 'partyShipmentList';
	function hasGridRight(module, gridLocation) {
	    return securityService_1.default.hasRight((0, formUtils_1.lovValue)(gridService_1.default.gridLocationMap.get(gridLocation).securable), metaConstant_1.PERMISSION.Read);
	}
	var PartyDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyDetail, _super);
	    function PartyDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = { relTypes: [] };
	        _this.customValidate = function (partyObject) {
	            var errors = [];
	            if (partyObject.roles.length === 0) {
	                errors.push({ message: "Party must have at least one role" });
	            }
	            var numberOfPermanentAddresses = partyObject.addresses.filter(function (a) { return (0, formUtils_1.lovValue)(a.addressType) === partyDomain_1.ADDRESSTYPE.PERMANENT; }).length;
	            if (numberOfPermanentAddresses > 1) {
	                errors.push({ message: "Party must have only one Permanent Address" });
	            }
	            if (partyObject.hasRole(partyDomain_1.PARTYROLE.CUSTOMER_ROLE) && numberOfPermanentAddresses === 0) {
	                errors.push({ message: "Party with role Customer must have Permanent Address" });
	            }
	            if (partyObject.hasRole(partyDomain_1.PARTYROLE.CUSTOMER_ROLE) && !partyObject.defaultCurrency) {
	                errors.push({ message: "Party with role Customer must have default currency" });
	            }
	            if (partyObject.hasRole(partyDomain_1.PARTYROLE.CUSTOMER_ROLE) && !partyObject.defaultSendType) {
	                errors.push({ message: "Party with role Customer must have default send type" });
	            }
	            if (partyObject.hasRole(partyDomain_1.PARTYROLE.CUSTOMER_ROLE) && !partyObject.defaultAttachmentType) {
	                errors.push({ message: "Party with role Customer must have default attachment type" });
	            }
	            if (partyObject.addresses.filter(function (a) { return (0, formUtils_1.lovValue)(a.addressType) === partyDomain_1.ADDRESSTYPE.CORRESPONDENT; }).length > 1) {
	                errors.push({ message: "Party must have only one Correspondent Address" });
	            }
	            if (partyObject.getInvoicingPeriod() && !partyObject.getInvoicingStartDate()) {
	                errors.push({ message: "If Invoicing Period is bigger than 1 month, Invoice start Date must be specified to fix start of this period" });
	            }
	            if (partyObject.partyCategory === partyDomain_1.PARTYCATEGORY.EN && (!partyObject.lastName || !partyObject.firstName)) {
	                errors.push({ message: "Party must have Last and First name filled in" });
	            }
	            if (partyObject.notes.filter(function (n) { return (0, formUtils_1.lovValue)(n.noteType) === partyDomain_1.PARTYNOTETYPE.INVOICE; }).length > 1) {
	                errors.push({ message: "There is allowed only 1 ".concat(partyDomain_1.PARTYNOTETYPE.INVOICE, " note for party") });
	            }
	            var badContacts = partyObject.contacts.filter(function (pc) { return pc.contactType.category === partyDomain_1.PARTYCONTACTCATEGORY.EMAIL && !validator_1.default.isEmail(pc.value); });
	            for (var _i = 0, badContacts_1 = badContacts; _i < badContacts_1.length; _i++) {
	                var pc = badContacts_1[_i];
	                errors.push({ message: (0, formUtils_1.lovLabel)(pc.contactType) + " Contact " + pc.value + " has invalid format" });
	            }
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave %O', partyService_1.default.partyObject);
	            uiService_1.default.showToolbarActionFlag();
	            var result = (0, formUtils_1.preSave)(partyService_1.default.partyObject, _this.customValidate);
	            if (!result) {
	                return;
	            }
	            var wasNew;
	            return partyService_1.default.partySave(partyService_1.default.partyObject.createDataObjectDto())
	                .then((0, mobx_1.action)("partySave-action", function (partyJson) {
	                wasNew = partyService_1.default.partyObject.cleanAfterSave(partyJson);
	                return _this.docSavingPromise(partyService_1.default.partyObject.$movingBlocks.getBlock(partyGridDocument), { partyId: partyService_1.default.partyObject.partyId });
	            })).then(function (x) {
	                if (wasNew) {
	                    _this.context.router.replaceWith('partyDetail', { id: partyService_1.default.partyObject.partyId });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            }).catch(function (error) {
	                partyService_1.default.partyObject.$errors = error.getMessages();
	            });
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            uiService_1.default.showToolbarActionFlag();
	            partyService_1.default.deleteParty(partyService_1.default.partyObject.partyId)
	                .then(function (response) {
	                uiService_1.default.hideToolbarActionFlag();
	                _this.goBackOrHome();
	            }, function (error) {
	                partyService_1.default.partyObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            var query = { partyCategory: partyService_1.default.partyObject.partyCategory };
	            query.roles = partyService_1.default.partyObject.roles.filter(function (ro) { return (0, formUtils_1.lovValue)(ro.roleType) <= 3; }).map(function (ro) { return ro.roleType.value; });
	            _this.context.router.transitionTo("partyDetail", { id: 'new' }, query);
	        };
	        _this.onCopy = function (evt) {
	            console.log('onCopy');
	            _this.context.router.transitionTo("partyDetail", { id: 'copy' }, { copyId: partyService_1.default.partyObject.partyId });
	        };
	        _this.addPartyRel = function (relType) {
	            var _a;
	            console.log('addPartyRel ', relType);
	            var grid = partyService_1.default.partyObject.$movingBlocks.getBlock(partyRelGridLocation);
	            var rowObject = new partyDomain_1.PartyRel((_a = {
	                    relType: relType,
	                    $new: true,
	                    $dirty: true,
	                    $added: true
	                },
	                _a[(relType.directionFrom) ? "fromParty" : "toParty"] = partyService_1.default.partyObject.partyLov(),
	                _a)).initDefaultValues();
	            grid.addRow(rowObject);
	            var form = rowObject.getForm('PartyRelForm');
	            form.$open = true;
	            partyService_1.default.partyObject.$dirty = true;
	        };
	        _this.openAddRel = function () {
	            console.log('Open add rel');
	            var roleTypes = partyService_1.default.partyObject.roles.map(function (r) { return r.roleType; });
	            var allRelTypes = mdEntityService_1.default.getEntity("PartyRelType").lovItems;
	            var roleTypeEntity = mdEntityService_1.default.getEntity("PartyRoleType");
	            var relTypes = [];
	            var _loop_1 = function (relType) {
	                var fromRoleId = (0, formUtils_1.lovParam)(relType, "from");
	                var toRoleId = (0, formUtils_1.lovParam)(relType, "to");
	                var fromRoleType = roleTypes.find((function (rt) { return (0, formUtils_1.lovValue)(rt) === fromRoleId; }));
	                var toRoleType = roleTypes.find((function (rt) { return (0, formUtils_1.lovValue)(rt) === toRoleId; }));
	                if (fromRoleType || toRoleType) {
	                    var o_1 = Object.assign({}, relType);
	                    if (fromRoleType) {
	                        o_1.directionFrom = true;
	                        o_1.roleLabel = roleTypeEntity.getLovItemLabel(toRoleId);
	                        o_1.roleId = toRoleId;
	                    }
	                    else {
	                        o_1.roleLabel = roleTypeEntity.getLovItemLabel(fromRoleId);
	                        o_1.roleId = fromRoleId;
	                    }
	                    // musime vyloucit protoze existuji CONTACT_PERSON -> CUSTOMER, CONTACT_PERSON -> OPERATOR, tak aby nebyly 2 nabidky pri vazbeni z customera, ktery je zaroven operator
	                    if (!relTypes.find(function (relType) { return relType.roleId === o_1.roleId; })) {
	                        relTypes.push(o_1);
	                    }
	                }
	            };
	            for (var _i = 0, allRelTypes_1 = allRelTypes; _i < allRelTypes_1.length; _i++) {
	                var relType = allRelTypes_1[_i];
	                _loop_1(relType);
	            }
	            _this.setState({ relTypes: relTypes });
	        };
	        _this.addNote = function (evt) {
	            console.debug('addNote');
	            var newNote = new partyDomain_1.PartyNote({ $new: true, $added: true }).initDefaultValues();
	            partyService_1.default.partyObject.notes.push(newNote);
	            partyService_1.default.partyObject.$dirty = true;
	        };
	        _this.addBankAccount = function () {
	            console.debug('add PartyBankAccount');
	            var newAccount = new partyDomain_1.PartyBankAccount({ $new: true, $added: true }).initDefaultValues();
	            partyService_1.default.partyObject.bankAccounts.push(newAccount);
	            partyService_1.default.partyObject.$dirty = true;
	        };
	        _this.addFeature = function (feature) {
	            console.log('addBankInfo %s', feature);
	            var newFeature = new partyDomain_1.PartyFeature({ $new: true, $added: true, featureType: feature }).initDefaultValues();
	            partyService_1.default.partyObject.features.push(newFeature);
	            partyService_1.default.partyObject.$dirty = true;
	        };
	        _this.assignProducts = function (grid) {
	            new Promise(function (resolve, reject) {
	                _this.productVehicleAssignDialogRef.open(resolve, reject, grid);
	            }).catch(function (e) { });
	        };
	        _this.createTasks = function (grid) {
	            console.log('createTasks');
	            return new Promise(function (resolve, reject) {
	                return _this.vehicleTaskDialogRef.open(resolve, reject, grid.createFullParams());
	            }).catch(function (e) { });
	        };
	        _this.onChangeRole = function () {
	            PartyDetail_1.reinitMovingBlocks(partyService_1.default.partyObject);
	            partyService_1.default.partyObject.$movingBlocks.searchExposedGrids(partyService_1.default.partyObject);
	        };
	        _this.onCustomerNotification = function (evt) {
	            console.log('onCustomerNotification');
	            new Promise(function (resolve, reject) {
	                _this.taskDialogRef.open(resolve, reject, { entity: partyService_1.default.partyObject.$mdEntityRef.id, rowid: [partyService_1.default.partyObject.partyId] });
	            }).then(function () {
	                uiService_1.default.hideToolbarActionFlag();
	                var movingBlocks = partyService_1.default.partyObject.$movingBlocks;
	                var taskGrid = movingBlocks.getBlock(taskGridLocation);
	                taskGrid.data = null;
	                if (movingBlocks.activeBlockTab === taskGridLocation) {
	                    _this.activateTab(taskGrid);
	                }
	            }).catch(function (e) {
	            });
	        };
	        _this.onCustomerRegistration = function (evt) {
	            console.log('onCustomerRegistration');
	            new Promise(function (resolve, reject) {
	                _this.confirmationDialogRef.open(resolve, reject, 'Do you really want to send registration emails for this customer ?');
	            }).then(function () {
	                uiService_1.default.showToolbarActionFlag();
	                return partyService_1.default.manualCustomerRegistration(partyService_1.default.partyObject.partyId)
	                    .then(function (activities) {
	                    if (activities.length) {
	                        commonService_1.default.notifyInfo("Registration emails were sent.", null, (react_1.default.createElement("ul", null, activities.map(function (activity) { return (react_1.default.createElement("li", null,
	                            activity.emailSubject,
	                            " - To: ",
	                            activity.getTo().join(", "),
	                            " , Cc: ",
	                            activity.getCc().join(", "))); }))), 0);
	                    }
	                    else {
	                        commonService_1.default.notifyWarning("No Registration email was sent, there is probably no contact person with Email Registration Role or no active vehicle with configured products.");
	                    }
	                    uiService_1.default.hideToolbarActionFlag();
	                });
	            }).catch(function (e) {
	            });
	        };
	        _this.expandCreditEntries = function () {
	            _this.creditEntriesExpanded = !_this.creditEntriesExpanded;
	        };
	        _this.productVehicleAssignDialogRefHandler = function (comp) { return _this.productVehicleAssignDialogRef = comp; };
	        _this.taskDialogRefHandler = function (comp) { return _this.taskDialogRef = comp; };
	        _this.vehicleTaskDialogRefHandler = function (comp) { return _this.vehicleTaskDialogRef = comp; };
	        _this.confirmationDialogRefHandler = function (comp) { return _this.confirmationDialogRef = comp; };
	        _this.onAddressPlaces = function (event) {
	            console.log('places');
	            event.preventDefault();
	            _this.context.router.transitionTo("addressPlacesList", { id: partyService_1.default.partyObject.partyId }, (0, utils_1.addTenantToQuery)());
	        };
	        return _this;
	    }
	    PartyDetail_1 = PartyDetail;
	    PartyDetail.reinitMovingBlocks = function (partyObject) {
	        var standaloneBlockName = taskGridLocation;
	        var blockNames = [taskGridLocation, partyActivityGridLocation, partyRelGridLocation, partyGridDocument];
	        if (securityService_1.default.currentUser.hasRestriction(securityDomain_1.RESTRICTION.YARD_MGMT_HAULER_DRIVER)) {
	            (0, arrayUtils_1.removeItem)(blockNames, partyRelGridLocation);
	        }
	        if (partyObject.hasRole(partyDomain_1.PARTYROLE.CUSTOMER_ROLE)) {
	            if (hasGridRight(metaConstant_1.MODULE.invoicing, invoiceItemGridLocation))
	                blockNames.unshift(invoiceItemGridLocation);
	            if (hasGridRight(metaConstant_1.MODULE.invoicing, invoiceGridLocation))
	                blockNames.unshift(invoiceGridLocation);
	            if (hasGridRight(metaConstant_1.MODULE.product, partyPriceComponentGridLocation))
	                blockNames.push(partyPriceComponentGridLocation);
	        }
	        if (partyObject.hasOneOfRoles(partyDomain_1.PARTYROLE.CUSTOMER_ROLE, partyDomain_1.PARTYROLE.OWNER_ROLE, partyDomain_1.PARTYROLE.OPERATOR, partyDomain_1.PARTYROLE.SUPPLIER_ROLE)) {
	            if (hasGridRight(metaConstant_1.MODULE.shipment, shipmentGridLocation))
	                blockNames.unshift(shipmentGridLocation);
	        }
	        if (partyObject.hasOneOfRoles(partyDomain_1.PARTYROLE.CUSTOMER_ROLE, partyDomain_1.PARTYROLE.OWNER_ROLE, partyDomain_1.PARTYROLE.OPERATOR)) {
	            if (hasGridRight(metaConstant_1.MODULE.product, vehicleGridLocation)) {
	                standaloneBlockName = vehicleGridLocation;
	                blockNames.unshift(vehicleGridLocation);
	            }
	        }
	        partyObject.$movingBlocks.reinit(standaloneBlockName, blockNames);
	    };
	    PartyDetail.fetchData = function (routerParams, query) {
	        console.log("PartyDetail#fetchData(%O)", query);
	        var entityMap;
	        return mdEntityService_1.default.fetchEntityMetadata(['Party', 'PartyContact', 'PartyRole', 'Address', 'PartyRel', 'PartyNote', 'PartyFeature', "Contract", "PartyBankAccount", "Bank"], [{ entity: 'PARTYCONTACTCATEGORY', lov: true }, { entity: 'PARTYFEATURETYPE', lov: true }, { entity: 'AddressPlace', lov: true }, { entity: 'PARTYCATEGORY', lov: true }, { entity: 'DOCUMENTATTACHMENTTYPE', lov: true }, 'Document'])
	            .then(function (_entityMap) {
	            entityMap = _entityMap;
	            var partyPromise;
	            if (routerParams.id === 'new') {
	                var roles = query.roles, q = tslib_1.__rest(query, ["roles"]);
	                var partyRoles = (0, arrayUtils_1.toArray)(roles).map(function (r) { return partyService_1.default.newRole(parseInt(r)); });
	                if (q.defaultSendType) {
	                    q.defaultSendType = entityMap.get('SENDTYPE').getLovItem(q.defaultSendType);
	                }
	                partyPromise = Promise.resolve(new partyDomain_1.Party(tslib_1.__assign(tslib_1.__assign({ active: true, $new: true }, q), { roles: partyRoles })));
	            }
	            else if (routerParams.id === 'copy') {
	                partyPromise = partyService_1.default.readParty(query.copyId)
	                    .then(function (partyObject) {
	                    partyObject.cleanOnCopy();
	                    partyObject.active = true;
	                    partyObject.contacts.forEach(function (c) {
	                        c.partyContactId = null;
	                        c.party = null;
	                    });
	                    partyObject.roles.forEach(function (r) {
	                        r.partyRoleId = null;
	                        r.party = null;
	                    });
	                    partyObject.notes.forEach(function (n) {
	                        n.partyNoteId = null;
	                        n.party = null;
	                    });
	                    partyObject.features.forEach(function (n) {
	                        n.partyFeatureId = null;
	                        n.party = null;
	                    });
	                    partyObject.addresses.forEach(function (a) {
	                        a.addressId = null;
	                        a.party = null;
	                    });
	                    return partyObject;
	                });
	            }
	            else {
	                partyPromise = partyService_1.default.readParty(routerParams.id);
	            }
	            var gridPromise = gridService_1.default.fetchGrids(vehicleGridLocation, invoiceGridLocation, invoiceItemGridLocation, partyRelGridLocation, partyPriceComponentGridLocation, taskGridLocation, partyActivityGridLocation, shipmentGridLocation);
	            return Promise.all([partyPromise, gridPromise]);
	        })
	            .then(function (_a) {
	            var partyObject = _a[0], gridLocationMap = _a[1];
	            partyObject.$movingBlocks = new gridUtils_1.MovingBlocks(null, true, query.tab, new grid_1.default(gridLocationMap.get(vehicleGridLocation), partyObject.partyId), new grid_1.default(gridLocationMap.get(shipmentGridLocation), partyObject.partyId), new grid_1.default(gridLocationMap.get(invoiceGridLocation), partyObject.partyId), new grid_1.default(gridLocationMap.get(invoiceItemGridLocation), partyObject.partyId), new grid_1.default(gridLocationMap.get(taskGridLocation), partyObject.partyId), new grid_1.default(gridLocationMap.get(partyActivityGridLocation), partyObject.partyId), new grid_1.default(gridLocationMap.get(partyRelGridLocation), partyObject.partyId), new grid_1.default(gridLocationMap.get(partyPriceComponentGridLocation), partyObject.partyId), new gridDocument_1.GridDocument(partyGridDocument, "Docs", { partyId: partyObject.partyId }, true, partyObject, (partyObject.$new) ? [] : null));
	            PartyDetail_1.reinitMovingBlocks(partyObject);
	            partyService_1.default.partyObject = partyObject.initAfterRead(routerParams.id === 'new');
	            // override podle customer x contact person x sales rep x user
	            document.title = partyObject.roleName();
	            (0, favicon_1.handleFavicon)(partyObject.partyIcon());
	        });
	    };
	    /**
	     *
	     */
	    PartyDetail.prototype.componentWillMount = function () {
	        uiService_1.default.addMediaQueryListener(this.mediaQueryListener);
	    };
	    PartyDetail.prototype.componentDidUpdate = function (prevProps) {
	        if (this.idChanged(prevProps.params.id, this.props.params.id)) {
	            partyService_1.default.partyObject.$movingBlocks.searchExposedGrids(partyService_1.default.partyObject);
	        }
	    };
	    PartyDetail.prototype.componentDidMount = function () {
	        partyService_1.default.partyObject.$movingBlocks.searchExposedGrids(partyService_1.default.partyObject);
	        if (partyService_1.default.partyObject.partyId) {
	            partyService_1.default.readCreditEntries(partyService_1.default.partyObject.partyId)
	                .then((0, mobx_1.action)("readCreditEntriesACB", function (data) {
	                partyService_1.default.partyObject.$creditEntries = data.entries;
	                partyService_1.default.partyObject.$creditSums = data.sums;
	            }));
	        }
	    };
	    PartyDetail.prototype.componentWillUnmount = function () {
	        uiService_1.default.removeMediaQueryListener(this.mediaQueryListener);
	        partyService_1.default.partyObject = null;
	    };
	    PartyDetail.prototype.findRootObject = function () {
	        return partyService_1.default.partyObject;
	    };
	    PartyDetail.prototype.render = function () {
	        var _this = this;
	        var query = this.props.query;
	        var propsForCreateForm = {
	            dataObject: partyService_1.default.partyObject,
	            rootObject: partyService_1.default.partyObject,
	            entity: mdEntityService_1.default.getEntity('Party'),
	            entities: mdEntityService_1.default.entityMap
	        };
	        var partyObject = partyService_1.default.partyObject;
	        var movingBlocks = partyService_1.default.partyObject.$movingBlocks;
	        console.debug('%c partyDetail render query %O', 'background-color: yellow', this.props.query);
	        var verticalArray = [(partyObject.partyCategory === partyDomain_1.PARTYCATEGORY.PE) ? react_1.default.createElement(partyFoForm_1.default, tslib_1.__assign({}, propsForCreateForm, { key: 1 })) : react_1.default.createElement(partyPoForm_1.default, tslib_1.__assign({}, propsForCreateForm, { key: 1 }))];
	        verticalArray.push(react_1.default.createElement(partyAddressList_1.default, { partyObject: partyObject, entities: mdEntityService_1.default.entityMap, key: 2 }));
	        if (partyObject.bankAccounts && partyObject.bankAccounts.length)
	            verticalArray.push(react_1.default.createElement(partyBankAccountList_1.default, { partyObject: partyObject, rootObject: partyObject, entities: mdEntityService_1.default.entityMap, key: 3 }));
	        if (partyObject.features && partyObject.features.length)
	            verticalArray.push(react_1.default.createElement(partyFeatureList_1.default, { partyObject: partyObject, rootObject: partyObject, entities: mdEntityService_1.default.entityMap, key: 4 }));
	        if (partyObject.notes && partyObject.notes.length)
	            verticalArray.push(react_1.default.createElement(partyNoteList_1.default, { partyObject: partyObject, rootObject: partyObject, entities: mdEntityService_1.default.entityMap, key: 5 }));
	        var mainForm = (react_1.default.createElement("form", { style: { marginTop: 10 } },
	            (partyObject.$creditSums && partyObject.$creditSums.length) ? (react_1.default.createElement("div", { style: { display: 'flex', paddingLeft: 20 } },
	                react_1.default.createElement(partyCreditEntry_1.PartyCreditSumTable, { sums: partyObject.$creditSums }),
	                react_1.default.createElement(IconButton_1.default, { style: { width: 40, height: 40, marginTop: 4 }, iconStyle: { fontSize: 20 }, onClick: this.expandCreditEntries },
	                    react_1.default.createElement(FontIcon_1.default, { color: colors_1.green500, className: (0, domUtils_1.classNames)('fa', { 'fa-angle-double-down': !this.creditEntriesExpanded, 'fa-angle-double-up': this.creditEntriesExpanded }) })))) : null,
	            (this.creditEntriesExpanded && partyObject.$creditEntries && partyObject.$creditEntries.length) ? (react_1.default.createElement(partyCreditEntry_1.PartyCreditEntryTable, { creditEntries: partyObject.$creditEntries })) : null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement(blockComp_1.MdBlockArray, { className: "col-xs-12 col-sm-8 block-comp-right-border", inset: true }, verticalArray),
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-4" },
	                    react_1.default.createElement(partyContactList_1.default, { partyObject: partyObject, rootObject: partyObject, entities: mdEntityService_1.default.entityMap }),
	                    react_1.default.createElement(partyRoleForm_1.default, { onChangeRole: this.onChangeRole, dataObject: partyObject, rootObject: partyObject, entity: mdEntityService_1.default.getEntity("PartyRole"), entities: mdEntityService_1.default.entityMap })))));
	        var rowPartyRelForm = (react_1.default.createElement(partyRelForm_1.default, { rootObject: partyObject, entity: mdEntityService_1.default.getEntity('PartyRel'), entities: mdEntityService_1.default.entityMap, dataObject: null }));
	        var gridCompArray = [react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(taskGridLocation), key: "taskGridLocation", uiLocation: movingBlocks.getUiLocation(taskGridLocation), entities: mdEntityService_1.default.entityMap })];
	        gridCompArray.push(react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(partyActivityGridLocation), key: "partyActivityGridLocation", uiLocation: movingBlocks.getUiLocation(partyActivityGridLocation), entities: mdEntityService_1.default.entityMap, showExpand: true, ExpandComponent: activityExpando_1.default }));
	        if (movingBlocks.getBlock(partyRelGridLocation)) {
	            gridCompArray.push(react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(partyRelGridLocation), key: "partyRelGridLocation", uiLocation: movingBlocks.getUiLocation(partyRelGridLocation), showDelete: true, deleteRowIcon: "fa fa-chain-broken", rootObject: partyObject, showEdit: true, editForm: rowPartyRelForm, editFormName: "PartyRelForm", entities: mdEntityService_1.default.entityMap, hideCopyRow: true, multiUpdateSecurable: metaConstant_1.SECURABLE.partyGridUpdate, multiUpdateSaveFn: this.onSave },
	                react_1.default.createElement(icons_1.ZzIconButtonMenu, { onClick: this.openAddRel, buttonIcon: react_1.default.createElement(add_1.default, null) }, this.state.relTypes.map(function (relType) { return react_1.default.createElement(MenuItem_1.default, { key: (0, formUtils_1.lovValue)(relType), primaryText: relType.roleLabel, onClick: _this.addPartyRel.bind(_this, relType) }); }))));
	        }
	        if (partyObject.hasRole(partyDomain_1.PARTYROLE.CUSTOMER_ROLE)) {
	            if (hasGridRight(metaConstant_1.MODULE.invoicing, invoiceItemGridLocation))
	                gridCompArray.unshift(react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(invoiceItemGridLocation), uiLocation: movingBlocks.getUiLocation(invoiceItemGridLocation), entities: mdEntityService_1.default.entityMap }));
	            if (hasGridRight(metaConstant_1.MODULE.invoicing, invoiceGridLocation))
	                gridCompArray.unshift(react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(invoiceGridLocation), uiLocation: movingBlocks.getUiLocation(invoiceGridLocation), entities: mdEntityService_1.default.entityMap },
	                    react_1.default.createElement(icons_1.ZzIconButtonRoute, { big: true, routeName: "invoiceDetail", params: { id: 'new' }, query: { partyId: partyObject.partyId, paymentTypeId: 1 }, disabled: partyObject.$new },
	                        react_1.default.createElement(add_1.default, null))));
	            if (hasGridRight(metaConstant_1.MODULE.product, partyPriceComponentGridLocation))
	                gridCompArray.push(react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(partyPriceComponentGridLocation), uiLocation: movingBlocks.getUiLocation(partyPriceComponentGridLocation), entities: mdEntityService_1.default.entityMap },
	                    react_1.default.createElement(icons_1.ZzIconButtonRoute, { big: true, routeName: "priceComponentDetail", params: { id: 'new' }, query: { partyId: partyObject.partyId, partyLabel: partyObject.partyLabel(), priceLevel: productDomain_1.PRICECOMPLEVEL.PRODUCTCUSTOMER, priceCurrency: (0, formUtils_1.lovValue)(partyObject.defaultCurrency) }, disabled: partyObject.$new },
	                        react_1.default.createElement(add_1.default, null))));
	        }
	        if (partyObject.hasOneOfRoles(partyDomain_1.PARTYROLE.CUSTOMER_ROLE, partyDomain_1.PARTYROLE.OWNER_ROLE, partyDomain_1.PARTYROLE.OPERATOR, partyDomain_1.PARTYROLE.SUPPLIER_ROLE)) {
	            if (hasGridRight(metaConstant_1.MODULE.shipment, shipmentGridLocation))
	                gridCompArray.unshift(react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(shipmentGridLocation), uiLocation: movingBlocks.getUiLocation(shipmentGridLocation), entities: mdEntityService_1.default.entityMap, multiUpdateSecurable: metaConstant_1.SECURABLE.shipmentGridUpdate },
	                    react_1.default.createElement(icons_1.ZzIconButtonRoute, { big: true, routeName: "shipmentDetail", params: { id: 'new' }, query: { partyId: partyObject.partyId, partyLabel: partyObject.partyLabel() }, disabled: partyObject.$new },
	                        react_1.default.createElement(add_1.default, null)),
	                    react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "shipmentDetail", params: { id: 'new' }, query: { shipmentDirection: shipmentDomain_1.SHIPMENTDIRECTION.OUTGOING, partyId: partyObject.partyId, partyLabel: partyObject.partyLabel() }, label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["New Out Shipment"], ["New Out Shipment"]))), disabled: partyObject.$new, permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.shipmentDetail }),
	                    react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "shipmentDetail", params: { id: 'new' }, query: { shipmentDirection: shipmentDomain_1.SHIPMENTDIRECTION.INCOMING, partyId: partyObject.partyId, partyLabel: partyObject.partyLabel() }, label: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["New In Shipment"], ["New In Shipment"]))), disabled: partyObject.$new, permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.shipmentDetail })));
	        }
	        if (partyObject.hasOneOfRoles(partyDomain_1.PARTYROLE.CUSTOMER_ROLE, partyDomain_1.PARTYROLE.OWNER_ROLE, partyDomain_1.PARTYROLE.OPERATOR)) {
	            if (hasGridRight(metaConstant_1.MODULE.product, vehicleGridLocation))
	                gridCompArray.unshift(react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(vehicleGridLocation), uiLocation: movingBlocks.getUiLocation(vehicleGridLocation), entities: mdEntityService_1.default.entityMap, showExpand: true, ExpandComponent: vehicleExpando_1.default, multiUpdateSecurable: metaConstant_1.SECURABLE.productGridUpdate, bulkActions: [
	                        { type: gridComp_1.BULKACTIONTYPE.ACTION, label: 'Assign Product', fn: this.assignProducts },
	                        { type: gridComp_1.BULKACTIONTYPE.ACTION, label: 'Create Tasks', fn: this.createTasks }
	                    ] },
	                    react_1.default.createElement(icons_1.ZzIconButtonRoute, { big: true, routeName: "vehicleDetail", params: { id: 'new' }, query: { partyId: partyObject.partyId, partyLabel: partyObject.partyLabel(), vehicleType: 1 }, disabled: partyObject.$new },
	                        react_1.default.createElement(add_1.default, null)),
	                    react_1.default.createElement(productVehicleAssignDialog_1.default, { ref: this.productVehicleAssignDialogRefHandler }),
	                    react_1.default.createElement(taskDialog_1.default, { ref: this.vehicleTaskDialogRefHandler, entities: mdEntityService_1.default.entityMap, location: eventDomain_1.ACTIVITYLOCATION.Vehicle, taskType: eventDomain_1.TASKTYPE.VEHICLE_NOTIFICATION })));
	        }
	        gridCompArray.push(react_1.default.createElement(gridDocumentComp_1.default, { uiLocation: movingBlocks.getUiLocation(partyGridDocument), grid: movingBlocks.getBlock(partyGridDocument), entities: mdEntityService_1.default.entityMap, rootObject: partyObject }));
	        var standAloneGridComp = movingBlocks.pluckStandAloneBlock(gridCompArray);
	        var tabArray = gridCompArray.map(function (gridComp) { return (react_1.default.createElement(Tab_1.default, { label: gridComp.props.grid.label, style: variables_1.tabStyle, onActive: _this.activateTab.bind(_this, gridComp.props.grid), key: gridComp.props.grid.getBlockName(), value: gridComp.props.grid.getBlockName() }, gridComp)); });
	        var tabs = (tabArray.length) ? (react_1.default.createElement(Tabs_1.default, { value: movingBlocks.activeBlockTab, className: "detail-grid", tabTemplate: mui_theme_1.TabTemplate, inkBarStyle: { transition: 'inherit' }, contentContainerStyle: { width: '100%', flexGrow: 1, display: 'flex', minHeight: 0 }, onChange: this.onTabChange }, tabArray)) : null;
	        if (uiService_1.default.globalMediaQuery.matches) {
	            return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'row' } },
	                react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', height: '100%', width: '50%' } },
	                    this._createToolMenu(partyObject, query.gridLocation, mdEntityService_1.default.getEntity('PARTYFEATURETYPE')),
	                    react_1.default.createElement(errorComp_1.ErrorComp, { messages: partyObject.$errors }),
	                    react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	                    react_1.default.createElement(confirmationDialog_1.default, { okButtonText: "Yes", cancelButtonText: "No", ref: this.confirmationDialogRefHandler }),
	                    react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	                    react_1.default.createElement(taskDialog_1.default, { ref: this.taskDialogRefHandler, entities: mdEntityService_1.default.entityMap, location: eventDomain_1.ACTIVITYLOCATION.Customer, taskType: eventDomain_1.TASKTYPE.PARTY_NOTIFICATION }),
	                    mainForm,
	                    tabs),
	                standAloneGridComp));
	        }
	        else {
	            return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	                this._createToolMenu(partyObject, query.gridLocation, mdEntityService_1.default.getEntity('PARTYFEATURETYPE')),
	                react_1.default.createElement(errorComp_1.ErrorComp, { messages: partyObject.$errors }),
	                react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	                react_1.default.createElement(confirmationDialog_1.default, { okButtonText: "Yes", cancelButtonText: "No", ref: this.confirmationDialogRefHandler }),
	                react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	                react_1.default.createElement(taskDialog_1.default, { ref: this.taskDialogRefHandler, entities: mdEntityService_1.default.entityMap, location: eventDomain_1.ACTIVITYLOCATION.Customer, taskType: eventDomain_1.TASKTYPE.PARTY_NOTIFICATION }),
	                mainForm,
	                tabs));
	        }
	    };
	    PartyDetail.prototype._createToolMenu = function (partyObject, gridLocation, PARTYFEATURETYPE) {
	        var _this = this;
	        var featureTypes = partyObject.features.map(function (f) { return f.featureType; });
	        var placesUrl = (partyObject.partyId) ? this.context.router.makeHref("addressPlacesList", { id: partyObject.partyId }, (0, utils_1.addTenantToQuery)()) : null;
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: react_router_1.History.length <= 1, historize: true, entityName: "Party", entityId: partyObject.partyId, activeTab: partyObject.$movingBlocks.activeBlockTab },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !partyObject.$dirty, label: "Save", permission: partyObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, disabled: partyObject.$new, label: "New", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onCopy, disabled: partyObject.$new, label: "Copy", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "Party", pageAncestor: this, onClick: this.onDelete, disabled: partyObject.$new, label: "Delete", permission: metaConstant_1.PERMISSION.Delete }),
	            react_1.default.createElement(icons_1.ZzIconButtonMenu, { buttonIcon: react_1.default.createElement(add_1.default, null) },
	                react_1.default.createElement(MenuItem_1.default, { primaryText: "Add Note", onClick: this.addNote }),
	                react_1.default.createElement(MenuItem_1.default, { primaryText: "Add Bank Info", onClick: this.addBankAccount }),
	                react_1.default.createElement(Divider_1.default, null),
	                PARTYFEATURETYPE.lovItems.filter(function (f) { return !featureTypes.includes(f.value) && f["visible"]; }).map(function (lovItem, index) { return react_1.default.createElement(MenuItem_1.default, { primaryText: lovItem.label, key: index, onClick: _this.addFeature.bind(_this, lovItem.value) }); })),
	            react_1.default.createElement(icons_1.ZzIconButtonMenu, { buttonIcon: react_1.default.createElement(more_vert_1.default, null), securableType: metaConstant_1.SECURABLE_TYPE.DETAILACTION },
	                (!partyObject.$new && partyObject.hasRole(partyDomain_1.PARTYROLE.CUSTOMER_ROLE)) ? (react_1.default.createElement(icons_1.ZzMenuItem, { primaryText: "Create Task", key: 4, onClick: this.onCustomerNotification, securable: metaConstant_1.SECURABLE.customerNotification })) : null,
	                (!partyObject.$new && partyObject.hasRole(partyDomain_1.PARTYROLE.CUSTOMER_ROLE)) ? (react_1.default.createElement(icons_1.ZzMenuItem, { primaryText: "Customer Registration", key: 5, onClick: this.onCustomerRegistration, securable: metaConstant_1.SECURABLE.customerRegistration })) : null,
	                (placesUrl) ? react_1.default.createElement(icons_1.ZzMenuItem, { primaryText: "Address Places", href: placesUrl, onClick: this.onAddressPlaces }) : null)));
	    };
	    var PartyDetail_1;
	    PartyDetail.module = metaConstant_1.MODULE.party;
	    PartyDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], PartyDetail.prototype, "creditEntriesExpanded", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyDetail.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyDetail.prototype, "addPartyRel", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyDetail.prototype, "openAddRel", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyDetail.prototype, "addNote", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyDetail.prototype, "addBankAccount", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyDetail.prototype, "addFeature", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyDetail.prototype, "assignProducts", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyDetail.prototype, "createTasks", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyDetail.prototype, "onChangeRole", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyDetail.prototype, "onCustomerNotification", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyDetail.prototype, "onCustomerRegistration", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyDetail.prototype, "expandCreditEntries", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PartyDetail.prototype, "onAddressPlaces", void 0);
	    PartyDetail = PartyDetail_1 = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], PartyDetail);
	    return PartyDetail;
	}(pageAncestor_1.default));
	exports.default = PartyDetail;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;


/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'partyAll';
	var PartyList = /** @class */ (function (_super) {
	    tslib_1.__extends(PartyList, _super);
	    function PartyList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PartyList.fetchData = function (routerParams) {
	        console.log("PartyList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    PartyList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query, multiUpdateSecurable: metaConstant_1.SECURABLE.partyGridUpdate }));
	    };
	    PartyList.module = metaConstant_1.MODULE.party;
	    PartyList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["All Parties"], ["All Parties"])));
	    PartyList.rootPage = true;
	    PartyList.protectedPage = true;
	    PartyList.icon = 'user';
	    PartyList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], PartyList);
	    return PartyList;
	}(pageAncestor_1.default));
	exports.default = PartyList;
	var templateObject_1;


/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var partyDomain_1 = __webpack_require__(48);
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'partySalesReps';
	var SalesRepList = /** @class */ (function (_super) {
	    tslib_1.__extends(SalesRepList, _super);
	    function SalesRepList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SalesRepList.fetchData = function (params) {
	        console.log("SalesRepList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    SalesRepList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query, multiUpdateSecurable: metaConstant_1.SECURABLE.partyGridUpdate },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "partyDetail", params: { id: 'new' }, query: { partyCategory: partyDomain_1.PARTYCATEGORY.PE, roles: partyDomain_1.PARTYROLE.SALESREP_ROLE }, label: "New Sales Rep", permission: metaConstant_1.PERMISSION.New })));
	    };
	    SalesRepList.module = metaConstant_1.MODULE.party;
	    SalesRepList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Sales Representative"], ["Sales Representative"])));
	    SalesRepList.icon = 'child';
	    SalesRepList.rootPage = true;
	    SalesRepList.protectedPage = true;
	    SalesRepList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SalesRepList);
	    return SalesRepList;
	}(pageAncestor_1.default));
	exports.default = SalesRepList;
	var templateObject_1;


/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var partyDomain_1 = __webpack_require__(48);
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'partySuppliers';
	var SupplierList = /** @class */ (function (_super) {
	    tslib_1.__extends(SupplierList, _super);
	    function SupplierList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SupplierList.fetchData = function (routerParams) {
	        console.log("SupplierList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    SupplierList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query, multiUpdateSecurable: metaConstant_1.SECURABLE.partyGridUpdate },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "partyDetail", params: { id: 'new' }, query: { partyCategory: partyDomain_1.PARTYCATEGORY.CO, roles: partyDomain_1.PARTYROLE.SUPPLIER_ROLE }, label: "New Supplier", permission: metaConstant_1.PERMISSION.New })));
	    };
	    SupplierList.module = metaConstant_1.MODULE.party;
	    SupplierList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Suppliers"], ["Suppliers"])));
	    SupplierList.icon = 'male';
	    SupplierList.rootPage = true;
	    SupplierList.protectedPage = true;
	    SupplierList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SupplierList);
	    return SupplierList;
	}(pageAncestor_1.default));
	exports.default = SupplierList;
	var templateObject_1;


/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var styledDateInterval_1 = tslib_1.__importDefault(__webpack_require__(130));
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var validate_1 = __webpack_require__(24);
	var SvgDelete = __webpack_require__(249);
	var icons_1 = __webpack_require__(63);
	var formUtils_1 = __webpack_require__(14);
	var dateUtils_1 = __webpack_require__(49);
	var productDomain_1 = __webpack_require__(158);
	var mobx_react_1 = __webpack_require__(4);
	var lens_1 = tslib_1.__importDefault(__webpack_require__(500));
	var PriceComponentAssignedForm = /** @class */ (function (_super) {
	    tslib_1.__extends(PriceComponentAssignedForm, _super);
	    function PriceComponentAssignedForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDelete = function (e) {
	            _this.props.onDelete(_this.props.index);
	        };
	        return _this;
	    }
	    PriceComponentAssignedForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity, formName = _a.formName, open = _a.open;
	        var fields = dataObject.getFormFields(formName);
	        var price = fields.price, priceCurrency = fields.priceCurrency, priceLcy = fields.priceLcy, validFrom = fields.validFrom, validTo = fields.validTo;
	        return (react_1.default.createElement("div", { className: "row" },
	            react_1.default.createElement("div", { style: { marginRight: 10, marginLeft: 5, alignSelf: 'center' } },
	                react_1.default.createElement(lens_1.default, { style: { color: (dataObject.priceLevel) ? productDomain_1.PRICECOMPLEVEL_COLORS[(0, formUtils_1.lovValue)(dataObject.priceLevel)] : productDomain_1.PRICECOMPLEVEL_COLORS.PRODUCTVEHICLE } })),
	            react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, price.props)),
	                react_1.default.createElement(validate_1.Validate, { field: price, value: price.props.value })),
	            react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, priceCurrency.props)),
	                react_1.default.createElement(validate_1.Validate, { field: priceCurrency, value: priceCurrency.props.value })),
	            react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, priceLcy.props)),
	                react_1.default.createElement(validate_1.Validate, { field: priceLcy, value: priceLcy.props.value })),
	            react_1.default.createElement("div", { className: "col-xs-6 col-sm-4" },
	                react_1.default.createElement(styledDateInterval_1.default, tslib_1.__assign({}, validFrom.props, { valueFrom: validFrom.props.value, valueTo: validTo.props.value, onChangeFrom: validFrom.props.onChange, onChangeTo: validTo.props.onChange }))),
	            react_1.default.createElement(icons_1.MdIconButton, { style: { alignSelf: 'center' }, onClick: this.onDelete },
	                react_1.default.createElement(SvgDelete, { size: 24 }))));
	    };
	    PriceComponentAssignedForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], PriceComponentAssignedForm);
	    return PriceComponentAssignedForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields;
	    return (react_1.default.createElement("div", null,
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement("span", { style: { marginRight: 5 } }, (0, formUtils_1.lovLabel)(dataObject.product)),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.price.textLabel, value: dataObject.price, mdField: fields.price.mdField }),
	            react_1.default.createElement(formUtils_1.FieldText, { value: dataObject.priceCurrency }),
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.priceLcy.textLabel, value: dataObject.priceLcy, mdField: fields.priceLcy.mdField })),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.validFrom.textLabel, value: (0, dateUtils_1.formatInterval)(dataObject.validFrom, dataObject.validTo) }))));
	};
	var definition = {
	    formName: 'PriceComponentAssignedForm',
	    nested: true,
	    fields: [{
	            name: 'price',
	            validators: ['IsRequired', 'IsNumber']
	        }, {
	            name: 'priceCurrency',
	            validators: ['IsRequired']
	        }, {
	            name: 'priceLcy',
	            validators: ['IsNumber']
	        }, {
	            name: 'validFrom'
	        }, {
	            name: 'validTo'
	        }]
	};
	exports.default = (0, createForm_1.createForm)(definition, ClosedContent)(PriceComponentAssignedForm);


/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var formUtils_1 = __webpack_require__(14);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var blockComp_1 = __webpack_require__(30);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var commonDataService_1 = __webpack_require__(41);
	var styledDateInterval_1 = tslib_1.__importDefault(__webpack_require__(130));
	var dateUtils_1 = __webpack_require__(49);
	var productDomain_1 = __webpack_require__(158);
	var mobx_react_1 = __webpack_require__(4);
	var partyDomain_1 = __webpack_require__(48);
	var form_1 = __webpack_require__(52);
	var lens_1 = tslib_1.__importDefault(__webpack_require__(500));
	var radioButtonField_1 = tslib_1.__importDefault(__webpack_require__(144));
	var colors_1 = __webpack_require__(29);
	var closedForm_1 = __webpack_require__(82);
	var PriceComponentForm = /** @class */ (function (_super) {
	    tslib_1.__extends(PriceComponentForm, _super);
	    function PriceComponentForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PriceComponentForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity, formName = _a.formName;
	        var fields = dataObject.getFormFields(formName);
	        var priceLevel = fields.priceLevel, price = fields.price, priceCurrency = fields.priceCurrency, priceLcy = fields.priceLcy, comment = fields.comment, validFrom = fields.validFrom, validTo = fields.validTo, product = fields.product, profitCenter = fields.profitCenter, vehicle = fields.vehicle, party = fields.party;
	        console.debug('PriceComponentForm render');
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12" },
	                    react_1.default.createElement("div", { style: { color: colors_1.grey400, marginBottom: 5 } }, priceLevel.mdField.formLabelActive),
	                    react_1.default.createElement(radioButtonField_1.default, tslib_1.__assign({}, priceLevel.props, { groupStyle: { display: 'flex' }, optionStyle: { width: 'initial', marginRight: 15 }, labelStyle: { whiteSpace: 'nowrap', marginLeft: -10 }, iconStyleFn: function (v) { return ({ fill: productDomain_1.PRICECOMPLEVEL_COLORS[v] }); } })),
	                    react_1.default.createElement(validate_1.Validate, { field: priceLevel, value: priceLevel.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, product.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Product', {}), clearable: true, asterixForAll: true })),
	                    react_1.default.createElement(validate_1.Validate, { field: product, value: product.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, vehicle.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Vehicle', {}), clearable: true }))),
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, party.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.CUSTOMER_ROLE] }), clearable: true })))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, price.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: price, value: price.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, priceCurrency.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: priceCurrency, value: priceCurrency.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, priceLcy.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: priceLcy, value: priceLcy.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, profitCenter.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: profitCenter, value: profitCenter.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-4" },
	                    react_1.default.createElement(styledDateInterval_1.default, tslib_1.__assign({}, validFrom.props, { valueFrom: validFrom.props.value, valueTo: validTo.props.value, onChangeFrom: validFrom.props.onChange, onChangeTo: validTo.props.onChange })))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props, { multiLine: true, rows: 3 }))))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true },
	            react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate }, this.props))));
	    };
	    PriceComponentForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], PriceComponentForm);
	    return PriceComponentForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { display: 'flex' } },
	        react_1.default.createElement("div", { style: { marginRight: 5 } },
	            react_1.default.createElement(lens_1.default, { style: { color: productDomain_1.PRICECOMPLEVEL_COLORS[(0, formUtils_1.lovValue)(dataObject.priceLevel)] } })),
	        react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields },
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.priceLevel.textLabel, value: dataObject.priceLevel }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.product.textLabel, value: dataObject.product, linkProps: { to: 'productDetail', params: { id: (0, formUtils_1.lovValue)(dataObject.product) } } }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.vehicle.textLabel, value: dataObject.vehicle, linkProps: { to: 'vehicleDetail', params: { id: (0, formUtils_1.lovValue)(dataObject.vehicle) } } }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.party.textLabel, value: dataObject.party, linkProps: { to: 'partyDetail', params: { id: (0, formUtils_1.lovValue)(dataObject.party) } } }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.price.textLabel },
	                react_1.default.createElement("span", null, (0, formUtils_1.formatValue)(dataObject.price, fields.price.mdField) + ' ' + (0, formUtils_1.lovLabel)(dataObject.priceCurrency))),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.priceLcy.textLabel, value: dataObject.priceLcy, mdField: fields.priceLcy.mdField }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.profitCenter.textLabel, value: dataObject.profitCenter }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.validFrom.textLabel, value: (0, dateUtils_1.formatInterval)(dataObject.validFrom, dataObject.validTo) }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.comment.textLabel, value: dataObject.comment }))));
	};
	var definition = {
	    formName: 'PriceComponentForm',
	    fields: [{
	            name: 'priceLevel',
	            displayType: form_1.FIELDDEFDISPLAYTYPE.radioButton,
	            validators: ['IsRequired']
	        }, {
	            name: 'price',
	            validators: ['IsRequired', 'IsNumber']
	        }, {
	            name: 'priceCurrency',
	            validators: ['IsRequired']
	        }, {
	            name: 'priceLcy',
	            validators: ['IsNumber']
	        }, {
	            name: 'comment',
	            displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	        }, {
	            name: 'validFrom'
	        }, {
	            name: 'validTo'
	        }, {
	            name: 'product',
	            validators: ['IsRequired']
	        }, {
	            name: 'profitCenter'
	        }, {
	            name: 'vehicle'
	        }, {
	            name: 'party'
	        }]
	};
	exports.default = (0, createForm_1.createForm)(definition, ClosedContent)(PriceComponentForm);


/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var styledDateInterval_1 = tslib_1.__importDefault(__webpack_require__(130));
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var validate_1 = __webpack_require__(24);
	var mobx_react_1 = __webpack_require__(4);
	var blockComp_1 = __webpack_require__(30);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var vehicleExpando_1 = __webpack_require__(956);
	var mobx_1 = __webpack_require__(5);
	var pull = __webpack_require__(117);
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields;
	    return (react_1.default.createElement(vehicleExpando_1.PriceBox, { pc: dataObject, disableLink: true, priceField: entity.getField("price"), style: { marginRight: 20, minWidth: 100, textAlign: 'center' } }));
	};
	var PriceComponentProductForm = /** @class */ (function (_super) {
	    tslib_1.__extends(PriceComponentProductForm, _super);
	    function PriceComponentProductForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onDelete = function (evt) {
	            evt.stopPropagation();
	            console.log('onDelete %o', _this.props.dataObject);
	            pull(_this.props.rootObject.prices, _this.props.dataObject);
	        };
	        return _this;
	    }
	    PriceComponentProductForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity, formName = _a.formName, open = _a.open;
	        var fields = dataObject.getFormFields(formName);
	        var price = fields.price, priceCurrency = fields.priceCurrency, priceLcy = fields.priceLcy, validFrom = fields.validFrom, validTo = fields.validTo;
	        var openContent = (react_1.default.createElement("div", { className: "row" },
	            react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, price.props)),
	                react_1.default.createElement(validate_1.Validate, { field: price, value: price.props.value })),
	            react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, priceCurrency.props)),
	                react_1.default.createElement(validate_1.Validate, { field: priceCurrency, value: priceCurrency.props.value })),
	            react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, priceLcy.props)),
	                react_1.default.createElement(validate_1.Validate, { field: priceLcy, value: priceLcy.props.value })),
	            react_1.default.createElement("div", { className: "col-xs-6 col-sm-4" },
	                react_1.default.createElement(styledDateInterval_1.default, tslib_1.__assign({}, validFrom.props, { valueFrom: validFrom.props.value, valueTo: validTo.props.value, onChangeFrom: validFrom.props.onChange, onChangeTo: validTo.props.onChange })))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true, style: { marginBottom: 0 } },
	            react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate, onDelete: this.onDelete }, this.props, { closedStyle: { justifyContent: 'initial', paddingTop: 5, paddingBottom: 5 } }))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PriceComponentProductForm.prototype, "onDelete", void 0);
	    PriceComponentProductForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'PriceComponentProductForm',
	            nested: true,
	            fields: [{
	                    name: 'price',
	                    validators: ['IsRequired', 'IsNumber']
	                }, {
	                    name: 'priceCurrency',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'priceLcy',
	                    validators: ['IsNumber']
	                }, {
	                    name: 'validFrom'
	                }, {
	                    name: 'validTo'
	                }]
	        }, ClosedContent),
	        mobx_react_1.observer
	    ], PriceComponentProductForm);
	    return PriceComponentProductForm;
	}(react_1.default.Component));
	exports.default = PriceComponentProductForm;


/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.definition = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var blockComp_1 = __webpack_require__(30);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var statusActiveComp_1 = __webpack_require__(261);
	var mobx_react_1 = __webpack_require__(4);
	var form_1 = __webpack_require__(52);
	var closedForm_1 = __webpack_require__(82);
	var productService_1 = tslib_1.__importDefault(__webpack_require__(131));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var securityDomain_1 = __webpack_require__(97);
	var ProductForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProductForm, _super);
	    function ProductForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = { originalProductNumber: _this.props.dataObject.productNumber };
	        _this.validateProductNumber = function (productNumber) {
	            var dataObject = _this.props.dataObject;
	            var originalProductNumber = _this.state.originalProductNumber;
	            if (!productNumber || productNumber.length == 0) {
	                return;
	            }
	            productNumber = productNumber.trim();
	            if (dataObject.getId() && originalProductNumber && productNumber === originalProductNumber.trim()) {
	                return;
	            }
	            productService_1.default.isProductNumberUnique(productNumber).then(function (isUniqueProductNumber) {
	                var form = dataObject.getForm(exports.definition.formName);
	                if (!isUniqueProductNumber) {
	                    form.getField("productNumber").valid = false;
	                    form.getField("productNumber").showValidation = true;
	                    form.getField("productNumber").props.errorText = "Product number " + productNumber + " already exists";
	                }
	            });
	        };
	        return _this;
	    }
	    ProductForm.prototype.componentDidUpdate = function (prevProps, prevState, prevContext) {
	        this.validateProductNumber(this.props.dataObject.productNumber);
	    };
	    ProductForm.prototype.componentDidMount = function () {
	        this.validateProductNumber(this.props.dataObject.productNumber);
	    };
	    ProductForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity;
	        var fields = dataObject.getFormFields(exports.definition.formName);
	        var productNumber = fields.productNumber, name = fields.name, productType = fields.productType, specification = fields.specification, comment = fields.comment, introductionDate = fields.introductionDate, salesDiscontinuationDate = fields.salesDiscontinuationDate, supportDiscontinuationDate = fields.supportDiscontinuationDate, unitOfMeasure = fields.unitOfMeasure, profitCenter = fields.profitCenter, vatRate = fields.vatRate, taxType = fields.taxType, revenueCategory = fields.revenueCategory;
	        var profitCenterOptions = (securityService_1.default.currentUser.hasRestriction(securityDomain_1.RESTRICTION.LIMIT_PRODUCT_BY_USER_PROFITCENTER)) ?
	            profitCenter.props.options.filter(function (lv) { return securityService_1.default.restrictionData.userProfitCenterIds.includes(lv.value); }) : profitCenter.props.options;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, productType.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: productType, value: productType.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, productNumber.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: productNumber, value: productNumber.props.value.trim() })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-7" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, specification.props, { multiLine: true, rows: 3 })))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props, { multiLine: true, rows: 3 })))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, introductionDate.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, salesDiscontinuationDate.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, supportDiscontinuationDate.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, unitOfMeasure.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, profitCenter.props, { options: profitCenterOptions }))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, vatRate.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: vatRate, value: vatRate.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, taxType.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, revenueCategory.props))))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true },
	            react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate }, this.props))));
	    };
	    ProductForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProductForm);
	    return ProductForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { width: '100%' } },
	        react_1.default.createElement("div", { style: { display: 'flex' } },
	            disabled ? null : react_1.default.createElement(statusActiveComp_1.StatusActiveComp, { activeObject: dataObject, entity: entity, id: dataObject.productId }),
	            react_1.default.createElement("h5", { style: statusActiveComp_1.StatusActiveComp__h5_style },
	                " ",
	                dataObject.productNumber,
	                " ",
	                dataObject.name,
	                " ")),
	        react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields },
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.specification.textLabel, value: dataObject.specification }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.comment.textLabel, value: dataObject.comment }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.introductionDate.textLabel, value: dataObject.introductionDate }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.salesDiscontinuationDate.textLabel, value: dataObject.salesDiscontinuationDate }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.supportDiscontinuationDate.textLabel, value: dataObject.supportDiscontinuationDate }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.productType.textLabel, value: dataObject.productType }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.unitOfMeasure.textLabel, value: dataObject.unitOfMeasure }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.profitCenter.textLabel, value: dataObject.profitCenter }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.revenueCategory.textLabel, value: dataObject.revenueCategory }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.vatRate.textLabel, value: dataObject.vatRate }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.taxType.textLabel, value: dataObject.taxType }))));
	};
	exports.definition = {
	    formName: 'ProductForm',
	    fields: [{
	            name: 'productNumber',
	            validators: ['IsRequired']
	        }, {
	            name: 'name',
	            validators: ['IsRequired']
	        }, {
	            name: 'productType',
	            validators: ['IsRequired']
	        }, {
	            name: 'vatRate',
	            validators: ['IsRequired']
	        }, {
	            name: 'specification',
	            displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	        }, {
	            name: 'comment',
	            displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	        }, {
	            name: 'introductionDate'
	        }, {
	            name: 'salesDiscontinuationDate'
	        }, {
	            name: 'supportDiscontinuationDate'
	        }, {
	            name: 'unitOfMeasure'
	        }, {
	            name: 'profitCenter'
	        }, {
	            name: 'revenueCategory'
	        }, {
	            name: 'taxType'
	        }]
	};
	exports.default = (0, createForm_1.createForm)(exports.definition, ClosedContent)(ProductForm);


/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var createForm_1 = __webpack_require__(18);
	var formUtils_1 = __webpack_require__(14);
	var productService_1 = tslib_1.__importDefault(__webpack_require__(131));
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var styledDateInterval_1 = tslib_1.__importDefault(__webpack_require__(130));
	var validate_1 = __webpack_require__(24);
	var priceComponentAssignedForm_1 = tslib_1.__importDefault(__webpack_require__(2174));
	var icons_1 = __webpack_require__(63);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var dateUtils_1 = __webpack_require__(49);
	var mobx_1 = __webpack_require__(5);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var commonDataService_1 = __webpack_require__(41);
	var ProductVehicleForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProductVehicleForm, _super);
	    function ProductVehicleForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.addPrice = function () {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities;
	            productService_1.default.initPriceComponent((0, formUtils_1.lovValue)(rootObject.party))
	                .then((0, mobx_1.action)("addPrice-handler", function (priceComponent) {
	                dataObject.prices.push(priceComponent.initAfterRead(true));
	                dataObject.$dirty = true;
	                console.debug("addPrice %O", dataObject);
	            }));
	        };
	        _this.deletePrice = function (index) {
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities;
	            console.log('delete price ' + index);
	            dataObject.prices.splice(index, 1);
	            dataObject.$dirty = true;
	        };
	        return _this;
	    }
	    ProductVehicleForm.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities;
	        var fields = dataObject.getFormFields(definition.formName);
	        var product = fields.product, validFrom = fields.validFrom, validTo = fields.validTo;
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, product.props, { disabled: !dataObject.$new, async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Product', {}), clearable: true, asterixForAll: true })),
	                    react_1.default.createElement(validate_1.Validate, { field: product, value: product.props.value })),
	                react_1.default.createElement("div", { className: "col-xs-6" },
	                    react_1.default.createElement(styledDateInterval_1.default, tslib_1.__assign({}, validFrom.props, { valueFrom: validFrom.props.value, valueTo: validTo.props.value, onChangeFrom: validFrom.props.onChange, onChangeTo: validTo.props.onChange })))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("h5", { style: { display: 'flex', alignItems: 'center', margin: '0 0 0 5px', fontSize: 18 } },
	                    react_1.default.createElement("span", null, "Prices"),
	                    react_1.default.createElement(icons_1.MdIconButton, { onClick: this.addPrice },
	                        react_1.default.createElement(add_1.default, null)))),
	            (dataObject.prices) ?
	                dataObject.prices.map(function (priceObject, index, array) { return react_1.default.createElement(priceComponentAssignedForm_1.default, { dataObject: priceObject, rootObject: dataObject, key: index, entities: mdEntityService_1.default.entityMap, entity: mdEntityService_1.default.getEntity('PriceComponent'), index: index, onDelete: _this.deletePrice }); })
	                : null));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProductVehicleForm.prototype, "addPrice", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProductVehicleForm.prototype, "deletePrice", void 0);
	    ProductVehicleForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProductVehicleForm);
	    return ProductVehicleForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields;
	    return (react_1.default.createElement("div", null,
	        react_1.default.createElement("div", { className: "form-text-row", style: { fontSize: 16, lineHeight: '16px', minHeight: 20 } }, (0, formUtils_1.lovLabel)(dataObject.product)),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { label: fields.validFrom.textLabel, value: (0, dateUtils_1.formatInterval)(dataObject.validFrom, dataObject.validTo) }))));
	};
	var definition = {
	    formName: 'ProductVehicleForm',
	    fields: [{
	            name: 'product',
	            validators: ['IsRequired']
	        }, {
	            name: 'validFrom'
	        }, {
	            name: 'validTo'
	        }],
	    nestedForms: [{ path: 'prices', formName: 'PriceComponentAssignedForm' }]
	};
	exports.default = (0, createForm_1.createForm)(definition, ClosedContent)(ProductVehicleForm);


/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var formUtils_1 = __webpack_require__(14);
	var productService_1 = tslib_1.__importDefault(__webpack_require__(131));
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var blockComp_1 = __webpack_require__(30);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var validate_1 = __webpack_require__(24);
	var rules_1 = __webpack_require__(56);
	var commonDataService_1 = __webpack_require__(41);
	var statusActiveComp_1 = __webpack_require__(261);
	var mobx_react_1 = __webpack_require__(4);
	var partyDomain_1 = __webpack_require__(48);
	var closedForm_1 = __webpack_require__(82);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var securityDomain_1 = __webpack_require__(97);
	function VehicleExistRegistrationNumber(_a) {
	    var value = _a.value, vehicleId = _a.vehicleId;
	    if (!value)
	        return (0, rules_1.valid)();
	    return productService_1.default.vehicleExist({ registrationNumber: value, vehicleId: vehicleId })
	        .then(function (exists) { return (exists) ? (0, rules_1.invalid)("Vehicle with registrationNumber ".concat(value, " already exists")) : (0, rules_1.valid)(); });
	}
	function VehicleExistVin(_a) {
	    var value = _a.value, vehicleId = _a.vehicleId;
	    if (!value)
	        return (0, rules_1.valid)();
	    return productService_1.default.vehicleExist({ vin: value, vehicleId: vehicleId })
	        .then(function (exists) { return (exists) ? (0, rules_1.invalid)("Vehicle with vin ".concat(value, " already exists")) : (0, rules_1.valid)(); });
	}
	var VehicleForm = /** @class */ (function (_super) {
	    tslib_1.__extends(VehicleForm, _super);
	    function VehicleForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    VehicleForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entity = _a.entity, entities = _a.entities, form = _a.form;
	        var fields = form.fields;
	        var registrationNumber = fields.registrationNumber, vin = fields.vin, model = fields.model, vehicleType = fields.vehicleType, vehicleBrand = fields.vehicleBrand, vehicleNumber = fields.vehicleNumber, activationDate = fields.activationDate, party = fields.party, note = fields.note, operatorParty = fields.operatorParty, lastNotificationCheck = fields.lastNotificationCheck, chassisSeries = fields.chassisSeries, chassis = fields.chassis, driverParty = fields.driverParty;
	        var hasHaulerVehicle = securityService_1.default.currentUser.hasRestriction(securityDomain_1.RESTRICTION.YARD_MGMT_HAULER_VEHICLE);
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, party.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.CUSTOMER_ROLE, partyDomain_1.PARTYROLE.OWNER_ROLE, partyDomain_1.PARTYROLE.HAULER] }), clearable: true, disabled: hasHaulerVehicle })),
	                    react_1.default.createElement(validate_1.Validate, { field: party, value: party.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, operatorParty.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.OPERATOR, partyDomain_1.PARTYROLE.OWNER_ROLE] }), clearable: true, disabled: hasHaulerVehicle })))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, registrationNumber.props, { showValidationIcon: true })),
	                    react_1.default.createElement(validate_1.Validate, { field: registrationNumber, value: registrationNumber.props.value },
	                        react_1.default.createElement(VehicleExistRegistrationNumber, { vehicleId: dataObject.vehicleId }))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, vin.props, { showValidationIcon: true })),
	                    react_1.default.createElement(validate_1.Validate, { field: vin, value: vin.props.value },
	                        react_1.default.createElement(VehicleExistVin, { vehicleId: dataObject.vehicleId }))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, vehicleNumber.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, activationDate.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, vehicleType.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: vehicleType, value: vehicleType.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, vehicleBrand.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: vehicleBrand, value: vehicleBrand.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, model.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, lastNotificationCheck.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, chassis.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, chassisSeries.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, driverParty.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.DRIVER] }), clearable: true, asterixForAll: true })))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, note.props))))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true },
	            react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate }, this.props))));
	    };
	    VehicleForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], VehicleForm);
	    return VehicleForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", null,
	        react_1.default.createElement("div", { style: { display: 'flex' } },
	            disabled ? null : react_1.default.createElement(statusActiveComp_1.StatusActiveComp, { activeObject: dataObject, entity: entity, id: dataObject.vehicleId }),
	            react_1.default.createElement("h5", { style: statusActiveComp_1.StatusActiveComp__h5_style },
	                " ",
	                (0, formUtils_1.lovLabel)(dataObject.vehicleBrand),
	                " ",
	                dataObject.registrationNumber)),
	        react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields },
	            (dataObject.party) ? (react_1.default.createElement(closedForm_1.ClosedFormField, { label: 'Owner', value: dataObject.party.label, linkProps: { to: 'partyDetail', params: { id: dataObject.party.value } } })) : null,
	            (dataObject.operatorParty) ? (react_1.default.createElement(closedForm_1.ClosedFormField, { label: 'Operator', value: dataObject.operatorParty.label, linkProps: { to: 'partyDetail', params: { id: dataObject.operatorParty.value } } })) : null,
	            (dataObject.driverParty) ? (react_1.default.createElement(closedForm_1.ClosedFormField, { label: 'Driver', value: dataObject.driverParty.label, linkProps: { to: 'partyDetail', params: { id: dataObject.driverParty.value } } })) : null,
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.vehicleNumber.textLabel, value: dataObject.vehicleNumber }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.activationDate.textLabel, value: dataObject.activationDate, mdField: fields.activationDate.mdField }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.lastNotificationCheck.textLabel, value: dataObject.lastNotificationCheck, mdField: fields.lastNotificationCheck.mdField }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.vehicleType.textLabel, value: dataObject.vehicleType }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.model.textLabel, value: dataObject.model }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.vin.textLabel, value: dataObject.vin }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.chassis.textLabel, value: dataObject.chassis }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.chassisSeries.textLabel, value: dataObject.chassisSeries })),
	        react_1.default.createElement("div", { className: "form-text-row" },
	            react_1.default.createElement(formUtils_1.FieldText, { value: dataObject.note }))));
	};
	var definition = {
	    formName: 'VehicleForm',
	    fields: [{
	            name: 'party'
	        }, {
	            name: 'operatorParty'
	        }, {
	            name: 'driverParty'
	        }, {
	            name: 'registrationNumber',
	            validators: ['IsRequired']
	        }, {
	            name: 'vin'
	        }, {
	            name: 'chassis'
	        }, {
	            name: 'chassisSeries'
	        }, {
	            name: 'vehicleType',
	            validators: ['IsRequired']
	        }, {
	            name: 'model'
	        }, {
	            name: 'vehicleBrand',
	            validators: ['IsRequired']
	        }, {
	            name: 'vehicleNumber'
	        }, {
	            name: 'activationDate'
	        }, {
	            name: 'note'
	        }, {
	            name: 'lastNotificationCheck'
	        }]
	};
	exports.default = (0, createForm_1.createForm)(definition, ClosedContent)(VehicleForm);


/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var formUtils_1 = __webpack_require__(14);
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var errorComp_1 = __webpack_require__(34);
	var priceComponentForm_1 = tslib_1.__importDefault(__webpack_require__(2175));
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var buttons_1 = __webpack_require__(27);
	var productService_1 = tslib_1.__importDefault(__webpack_require__(131));
	var productDomain_1 = __webpack_require__(158);
	var mobx_1 = __webpack_require__(5);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var react_router_1 = __webpack_require__(65);
	var locales_1 = __webpack_require__(15);
	var PriceComponentDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(PriceComponentDetail, _super);
	    function PriceComponentDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.customValidate = function (priceComponentObject) {
	            var errors = [];
	            switch ((0, formUtils_1.lovValue)(priceComponentObject.priceLevel)) {
	                case productDomain_1.PRICECOMPLEVEL.PRODUCT:
	                    if (priceComponentObject.vehicle || priceComponentObject.party) {
	                        errors.push({ message: "Price level PRODUCT must not have customer or vehicle filled in" });
	                    }
	                    break;
	                case productDomain_1.PRICECOMPLEVEL.PRODUCTCUSTOMER:
	                    if (priceComponentObject.vehicle || !priceComponentObject.party) {
	                        errors.push({ message: "Price level PRODUCTCUSTOMER must have customer but not vehicle filled in" });
	                    }
	                    break;
	                case productDomain_1.PRICECOMPLEVEL.PRODUCTVEHICLE:
	                    if (!priceComponentObject.vehicle || priceComponentObject.party) {
	                        errors.push({ message: "Price level PRODUCTVEHICLE must have vehicle but not customer filled in" });
	                    }
	                    break;
	            }
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave ');
	            uiService_1.default.showToolbarActionFlag();
	            var result = (0, formUtils_1.preSave)(productService_1.default.priceComponentObject, _this.customValidate);
	            if (!result) {
	                return;
	            }
	            productService_1.default.priceComponentSave(productService_1.default.priceComponentObject)
	                .then((0, mobx_1.action)("priceComponentSave-callback", function (priceComponentJson) {
	                var wasNew = productService_1.default.priceComponentObject.cleanAfterSave(priceComponentJson);
	                if (wasNew) {
	                    _this.context.router.replaceWith('priceComponentDetail', { id: productService_1.default.priceComponentObject.priceComponentId });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            }), function (error) {
	                productService_1.default.priceComponentObject.$errors = error.getMessages();
	                productService_1.default.priceComponentObject.getForm("PriceComponentForm").$open = true;
	            });
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            productService_1.default.deletePriceComponent(productService_1.default.priceComponentObject.priceComponentId)
	                .then(function (response) {
	                _this.goBackOrHome();
	            }, function (error) {
	                productService_1.default.priceComponentObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            var query = { priceCurrency: 'EUR' };
	            _this.context.router.transitionTo("priceComponentDetail", { id: 'new' }, query);
	        };
	        _this.onCopy = function (evt) {
	            console.log('onCopy');
	            _this.context.router.transitionTo("priceComponentDetail", { id: 'copy' }, { copyId: productService_1.default.priceComponentObject.priceComponentId });
	        };
	        return _this;
	    }
	    PriceComponentDetail.fetchData = function (routerParams, query) {
	        console.log("PriceComponentDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['PriceComponent']);
	        var priceComponentPromise;
	        if (routerParams.id === 'new') {
	            var partyId = query.partyId, partyLabel = query.partyLabel, queryOther = tslib_1.__rest(query, ["partyId", "partyLabel"]);
	            var party = (partyId) ? { value: partyId, label: partyLabel } : null;
	            priceComponentPromise = Promise.resolve(new productDomain_1.PriceComponent(tslib_1.__assign({ $new: true, party: party }, queryOther)));
	        }
	        else if (routerParams.id === 'copy') {
	            priceComponentPromise = productService_1.default.readPriceComponent(query.copyId)
	                .then(function (priceComponentObject) {
	                priceComponentObject.cleanOnCopy();
	                return priceComponentObject;
	            });
	        }
	        else {
	            priceComponentPromise = productService_1.default.readPriceComponent(routerParams.id);
	        }
	        return Promise.all([metadataPromise, priceComponentPromise])
	            .then((0, mobx_1.action)("PriceComponentDetail-fetchData-callback", function (_a) {
	            var entityMap = _a[0], priceComponentObject = _a[1];
	            productService_1.default.priceComponentObject = priceComponentObject.initAfterRead(routerParams.id === 'new');
	        }));
	    };
	    PriceComponentDetail.prototype.componentWillUnmount = function () {
	        productService_1.default.priceComponentObject = null;
	    };
	    PriceComponentDetail.prototype.findRootObject = function () {
	        return productService_1.default.priceComponentObject;
	    };
	    PriceComponentDetail.prototype.render = function () {
	        var query = this.props.query;
	        console.debug('%c PriceComponentDetail render query %O', 'background-color: yellow', this.props.query);
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	            this._createToolMenu(productService_1.default.priceComponentObject, query.gridLocation),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: productService_1.default.priceComponentObject.$errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	            react_1.default.createElement("form", { style: { marginTop: 10 } },
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12" },
	                        react_1.default.createElement(priceComponentForm_1.default, { dataObject: productService_1.default.priceComponentObject, rootObject: productService_1.default.priceComponentObject, entity: mdEntityService_1.default.getEntity("PriceComponent"), entities: mdEntityService_1.default.entityMap }))))));
	    };
	    PriceComponentDetail.prototype._createToolMenu = function (priceComponentObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: react_router_1.History.length <= 1, historize: true, entityName: "PriceComponent", entityId: priceComponentObject.priceComponentId },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !priceComponentObject.$dirty, label: "Save", permission: priceComponentObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, disabled: priceComponentObject.$new, label: "New", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onCopy, disabled: priceComponentObject.$new, label: "Copy", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "PriceComponent", pageAncestor: this, onClick: this.onDelete, disabled: priceComponentObject.$new, label: "Delete", permission: metaConstant_1.PERMISSION.Delete })));
	    };
	    PriceComponentDetail.module = metaConstant_1.MODULE.product;
	    PriceComponentDetail.title = 'Price';
	    PriceComponentDetail.icon = 'dollar';
	    PriceComponentDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PriceComponentDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], PriceComponentDetail.prototype, "onDelete", void 0);
	    PriceComponentDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], PriceComponentDetail);
	    return PriceComponentDetail;
	}(pageAncestor_1.default));
	exports.default = PriceComponentDetail;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var routes_1 = __webpack_require__(75);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var formUtils_1 = __webpack_require__(14);
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'priceComponentList';
	var PriceComponentList = /** @class */ (function (_super) {
	    tslib_1.__extends(PriceComponentList, _super);
	    function PriceComponentList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PriceComponentList.fetchData = function (routerParams) {
	        console.log("PriceComponentList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    PriceComponentList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        var curr = (0, formUtils_1.lovValue)(securityService_1.default.currentTenant.defaultCurrency);
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query, multiUpdateSecurable: metaConstant_1.SECURABLE.productGridUpdate },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "priceComponentDetail", params: { id: 'new' }, query: { priceCurrency: curr }, label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["New Price"], ["New Price"]))), permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.priceComponentDetail })));
	    };
	    PriceComponentList.module = metaConstant_1.MODULE.product;
	    PriceComponentList.title = locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Prices"], ["Prices"])));
	    PriceComponentList.icon = 'dollar';
	    PriceComponentList.rootPage = true;
	    PriceComponentList.protectedPage = true;
	    PriceComponentList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], PriceComponentList);
	    return PriceComponentList;
	}(pageAncestor_1.default));
	exports.default = PriceComponentList;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var Tabs_1 = tslib_1.__importDefault(__webpack_require__(107));
	var Tab_1 = tslib_1.__importDefault(__webpack_require__(102));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var productService_1 = tslib_1.__importDefault(__webpack_require__(131));
	var formUtils_1 = __webpack_require__(14);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridComp_1 = tslib_1.__importDefault(__webpack_require__(44));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var mui_theme_1 = __webpack_require__(119);
	var variables_1 = __webpack_require__(96);
	var errorComp_1 = __webpack_require__(34);
	var productForm_1 = tslib_1.__importStar(__webpack_require__(2177));
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var productDomain_1 = __webpack_require__(158);
	var gridUtils_1 = __webpack_require__(83);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var mobx_1 = __webpack_require__(5);
	var react_router_1 = __webpack_require__(65);
	var buttons_1 = __webpack_require__(27);
	var blockComp_1 = __webpack_require__(30);
	var icons_1 = __webpack_require__(63);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var priceComponentProductForm_1 = tslib_1.__importDefault(__webpack_require__(2176));
	var fields_1 = __webpack_require__(20);
	var dateUtils_1 = __webpack_require__(49);
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var gridDocument_1 = __webpack_require__(313);
	var gridDocumentComp_1 = tslib_1.__importDefault(__webpack_require__(312));
	var vatRateForm_1 = __webpack_require__(2151);
	var locales_1 = __webpack_require__(15);
	var vehicleGridLocation = 'productVehicleList';
	var invoiceGridLocation = 'productInvoiceList';
	var invoiceItemGridLocation = 'productInvoiceItemList';
	var productGridDocument = 'productGridDocument';
	var ProductDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(ProductDetail, _super);
	    function ProductDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.customValidate = function (productObject) {
	            var errors = [];
	            var productForm = productObject.getForm(productForm_1.definition.formName);
	            if (productForm.fields.productNumber.props.errorText) {
	                errors.push({ propertyPath: "productNumber", message: productForm.fields.productNumber.props.errorText });
	            }
	            var pricesPerCurrency = productObject.prices.reduce(function (acc, price) {
	                var currEntry = acc[(0, formUtils_1.lovValue)(price.priceCurrency)];
	                if (!currEntry) {
	                    currEntry = [];
	                    acc[(0, formUtils_1.lovValue)(price.priceCurrency)] = currEntry;
	                }
	                currEntry.push(price);
	                return acc;
	            }, {});
	            for (var currency in pricesPerCurrency) {
	                var currEntry = pricesPerCurrency[currency];
	                if (!(0, dateUtils_1.sortAndCheckInterval)(currEntry)) {
	                    errors.push({ propertyPath: "prices", message: "Price validity intervals for " + currency + " must not overlap" });
	                }
	            }
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave ');
	            uiService_1.default.showToolbarActionFlag();
	            var result = (0, formUtils_1.preSave)(productService_1.default.productObject, _this.customValidate);
	            if (!result) {
	                return;
	            }
	            var wasNew;
	            return productService_1.default.productSave(productService_1.default.productObject)
	                .then((0, mobx_1.action)("productSave-callback", function (productJson) {
	                if (!_this.savedProduct) {
	                    _this.savedProduct = Math.floor((Math.random() * 100) + 1);
	                }
	                else {
	                    _this.savedProduct = _this.savedProduct + 1;
	                }
	                wasNew = productService_1.default.productObject.cleanAfterSave(productJson);
	                return _this.docSavingPromise(productService_1.default.productObject.$movingBlocks.getBlock(productGridDocument), { productId: productService_1.default.productObject.productId });
	            })).then(function (x) {
	                if (wasNew) {
	                    _this.context.router.replaceWith('productDetail', { id: productService_1.default.productObject.productId });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            }).catch(function (error) {
	                productService_1.default.productObject.$errors = error.getMessages();
	            });
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            uiService_1.default.showToolbarActionFlag();
	            productService_1.default.deleteProduct(productService_1.default.productObject.productId)
	                .then(function (response) {
	                uiService_1.default.hideToolbarActionFlag();
	                _this.goBackOrHome();
	            }, function (error) {
	                productService_1.default.productObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            var query = {};
	            _this.context.router.transitionTo("productDetail", { id: 'new' }, query);
	        };
	        _this.onCopy = function (evt) {
	            console.log('onCopy');
	            _this.context.router.transitionTo("productDetail", { id: 'copy' }, { copyId: productService_1.default.productObject.productId });
	        };
	        return _this;
	    }
	    ProductDetail.fetchData = function (routerParams, query) {
	        console.log("ProductDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['Product', 'PriceComponent'], ["Document"]);
	        var productPromise;
	        if (routerParams.id === 'new') {
	            productPromise = Promise.resolve(new productDomain_1.Product(Object.assign({ $new: true, active: true }, query)));
	        }
	        else if (routerParams.id === 'copy') {
	            productPromise = productService_1.default.readProduct(query.copyId)
	                .then(function (productObject) {
	                productObject.cleanOnCopy();
	                productObject.active = true;
	                return productObject;
	            });
	        }
	        else {
	            productPromise = productService_1.default.readProduct(routerParams.id);
	            // Needed for show history
	            mdEntityService_1.default.setFormDefinition(vatRateForm_1.VatRateFormDefinition.formName, vatRateForm_1.VatRateFormDefinition);
	            mdEntityService_1.default.setClosedContent(vatRateForm_1.VatRateFormDefinition.formName, vatRateForm_1.VatRateClosedContent);
	        }
	        var gridPromise = gridService_1.default.fetchGrids(vehicleGridLocation, invoiceGridLocation, invoiceItemGridLocation);
	        return Promise.all([metadataPromise, productPromise, gridPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], productObject = _a[1], gridLocationMap = _a[2];
	            productObject.$movingBlocks = new gridUtils_1.MovingBlocks(vehicleGridLocation, true, query.tab, new grid_1.default(gridLocationMap.get(vehicleGridLocation), productObject.productId), new grid_1.default(gridLocationMap.get(invoiceGridLocation), productObject.productId), new grid_1.default(gridLocationMap.get(invoiceItemGridLocation), productObject.productId), new gridDocument_1.GridDocument(productGridDocument, "Docs", { productId: productObject.productId }, false, null, (productObject.$new) ? [] : null));
	            productService_1.default.productObject = productObject.initAfterRead(routerParams.id === 'new');
	        });
	    };
	    /**
	     *
	     */
	    ProductDetail.prototype.componentWillMount = function () {
	        uiService_1.default.addMediaQueryListener(this.mediaQueryListener);
	    };
	    /**
	     * tohle je tady kvuli prechodu na jiny detail productu (chained details)
	     * @param prevProps
	     */
	    ProductDetail.prototype.componentDidUpdate = function (prevProps) {
	        if (this.idChanged(prevProps.params.id, this.props.params.id)) {
	            productService_1.default.productObject.$movingBlocks.searchExposedGrids(productService_1.default.vehicleObject);
	        }
	    };
	    ProductDetail.prototype.componentDidMount = function () {
	        console.debug("%c componentDidMount", "background-color: magenta");
	        productService_1.default.productObject.$movingBlocks.searchExposedGrids(productService_1.default.productObject);
	    };
	    ProductDetail.prototype.componentWillUnmount = function () {
	        uiService_1.default.removeMediaQueryListener(this.mediaQueryListener);
	        productService_1.default.productObject = null;
	    };
	    ProductDetail.prototype.findRootObject = function () {
	        return productService_1.default.productObject;
	    };
	    ProductDetail.prototype.render = function () {
	        var _this = this;
	        var query = this.props.query;
	        var propsForCreateForm = {
	            dataObject: productService_1.default.productObject,
	            rootObject: productService_1.default.productObject,
	            entity: mdEntityService_1.default.getEntity('Product'),
	            entities: mdEntityService_1.default.entityMap
	        };
	        console.debug('%c productDetail render query %O', 'background-color: yellow', this.props.query);
	        var mainForm = (react_1.default.createElement("form", { style: { marginTop: 10 } },
	            react_1.default.createElement(blockComp_1.MdBlockArray, { inset: true }, [
	                react_1.default.createElement(productForm_1.default, tslib_1.__assign({}, propsForCreateForm, { key:  true ? this.savedProduct : 1 })),
	                react_1.default.createElement(ProductPriceList, { productObject: productService_1.default.productObject, entities: mdEntityService_1.default.entityMap, key: 2 })
	            ])));
	        var movingBlocks = productService_1.default.productObject.$movingBlocks;
	        var gridCompArray = [
	            react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(vehicleGridLocation), uiLocation: movingBlocks.getUiLocation(vehicleGridLocation), entities: mdEntityService_1.default.entityMap, multiUpdateSecurable: metaConstant_1.SECURABLE.productGridUpdate }),
	            react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(invoiceGridLocation), uiLocation: movingBlocks.getUiLocation(invoiceGridLocation), entities: mdEntityService_1.default.entityMap }),
	            react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(invoiceItemGridLocation), uiLocation: movingBlocks.getUiLocation(invoiceItemGridLocation), entities: mdEntityService_1.default.entityMap }),
	            react_1.default.createElement(gridDocumentComp_1.default, { uiLocation: movingBlocks.getUiLocation(productGridDocument), grid: movingBlocks.getBlock(productGridDocument), entities: mdEntityService_1.default.entityMap, rootObject: productService_1.default.productObject })
	        ];
	        var standAloneGridComp = movingBlocks.pluckStandAloneBlock(gridCompArray);
	        var tabArray = gridCompArray.map(function (gridComp) { return (react_1.default.createElement(Tab_1.default, { label: gridComp.props.grid.label, style: variables_1.tabStyle, onActive: _this.activateTab.bind(_this, gridComp.props.grid), key: gridComp.props.grid.getBlockName(), value: gridComp.props.grid.getBlockName() }, gridComp)); });
	        var tabs = (tabArray.length) ? (react_1.default.createElement(Tabs_1.default, { value: movingBlocks.activeBlockTab, className: "detail-grid", tabTemplate: mui_theme_1.TabTemplate, inkBarStyle: { transition: 'inherit' }, contentContainerStyle: { width: '100%', flexGrow: 1, display: 'flex', minHeight: 0 }, onChange: this.onTabChange }, tabArray)) : '';
	        if (uiService_1.default.globalMediaQuery.matches) {
	            return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'row' } },
	                react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', height: '100%', width: '50%' } },
	                    this._createToolMenu(productService_1.default.productObject, query.gridLocation),
	                    react_1.default.createElement(errorComp_1.ErrorComp, { messages: productService_1.default.productObject.$errors }),
	                    react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	                    react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	                    mainForm,
	                    tabs),
	                standAloneGridComp));
	        }
	        else {
	            return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	                this._createToolMenu(productService_1.default.productObject, query.gridLocation),
	                react_1.default.createElement(errorComp_1.ErrorComp, { messages: productService_1.default.productObject.$errors }),
	                react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	                react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	                mainForm,
	                tabs));
	        }
	    };
	    ProductDetail.prototype._createToolMenu = function (productObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: react_router_1.History.length <= 1, historize: true, entityName: "Product", entityId: productObject.productId, activeTab: productObject.$movingBlocks.activeBlockTab },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !productObject.$dirty, label: "Save", permission: productObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, disabled: productObject.$new, label: "New", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onCopy, disabled: productObject.$new, label: "Copy", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "Product", pageAncestor: this, onClick: this.onDelete, disabled: productObject.$new, label: "Delete", permission: metaConstant_1.PERMISSION.Delete })));
	    };
	    ProductDetail.module = metaConstant_1.MODULE.product;
	    ProductDetail.title = 'Product';
	    ProductDetail.icon = 'cube';
	    ProductDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProductDetail.prototype, "savedProduct", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProductDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProductDetail.prototype, "onDelete", void 0);
	    ProductDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProductDetail);
	    return ProductDetail;
	}(pageAncestor_1.default));
	exports.default = ProductDetail;
	var ProductPriceList = /** @class */ (function (_super) {
	    tslib_1.__extends(ProductPriceList, _super);
	    function ProductPriceList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.now = (0, moment_1.default)().startOf('day');
	        _this.addPrice = function () {
	            console.debug('addPrice');
	            var _a = _this.props, productObject = _a.productObject, entities = _a.entities;
	            var newPrice = new productDomain_1.PriceComponent({
	                $new: true,
	                $added: true,
	                priceLevel: entities.get("PRICECOMPLEVEL").getLovItem(productDomain_1.PRICECOMPLEVEL.PRODUCT),
	                product: productObject.createLov(),
	                priceCurrency: securityService_1.default.currentTenant.defaultCurrency
	            }).initDefaultValues();
	            productObject.prices.push(newPrice);
	            productObject.$dirty = true;
	        };
	        _this.onShowAll = function (evt) {
	            _this.showAll = evt.target.checked;
	        };
	        return _this;
	    }
	    ProductPriceList.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, productObject = _a.productObject, entities = _a.entities;
	        var header = (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
	            react_1.default.createElement("div", null, "Prices"),
	            react_1.default.createElement(icons_1.MdIconButton, { onClick: this.addPrice },
	                react_1.default.createElement(add_1.default, null))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { header: header, noPadding: true, style: { display: 'flex', flexDirection: 'column' } },
	            productObject.prices.filter(function (price) { return _this.showAll || (0, dateUtils_1.isValid)(price, _this.now); }).map(function (price, index) { return react_1.default.createElement(priceComponentProductForm_1.default, { dataObject: price, rootObject: productObject, key: index, entities: entities, entity: entities.get('PriceComponent'), index: index }); }),
	            react_1.default.createElement(fields_1.MdCheckbox, { label: "Show invalid prices", checked: this.showAll, labelStyle: { whiteSpace: 'nowrap', marginRight: 5, fontSize: 13 }, style: { width: 'initial', marginLeft: 10, marginTop: 10 }, iconStyle: { height: 18, paddingTop: 2 }, labelPosition: "left", onCheck: this.onShowAll })));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProductPriceList.prototype, "showAll", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProductPriceList.prototype, "addPrice", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProductPriceList.prototype, "onShowAll", void 0);
	    ProductPriceList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProductPriceList);
	    return ProductPriceList;
	}(react_1.default.Component));
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var routes_1 = __webpack_require__(75);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'productList';
	var ProductList = /** @class */ (function (_super) {
	    tslib_1.__extends(ProductList, _super);
	    function ProductList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ProductList.fetchData = function (routerParams) {
	        console.log("ProductList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    ProductList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query, multiUpdateSecurable: metaConstant_1.SECURABLE.productGridUpdate },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "productDetail", params: { id: 'new' }, label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["New Product"], ["New Product"]))), permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.productDetail })));
	    };
	    ProductList.module = metaConstant_1.MODULE.product;
	    ProductList.title = locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Products"], ["Products"])));
	    ProductList.icon = 'cube';
	    ProductList.rootPage = true;
	    ProductList.protectedPage = true;
	    ProductList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProductList);
	    return ProductList;
	}(pageAncestor_1.default));
	exports.default = ProductList;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var Tabs_1 = tslib_1.__importDefault(__webpack_require__(107));
	var Tab_1 = tslib_1.__importDefault(__webpack_require__(102));
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var productService_1 = tslib_1.__importDefault(__webpack_require__(131));
	var formUtils_1 = __webpack_require__(14);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridComp_1 = tslib_1.__importDefault(__webpack_require__(44));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var mui_theme_1 = __webpack_require__(119);
	var variables_1 = __webpack_require__(96);
	var errorComp_1 = __webpack_require__(34);
	var vehicleForm_1 = tslib_1.__importDefault(__webpack_require__(2179));
	var productVehicleForm_1 = tslib_1.__importDefault(__webpack_require__(2178));
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var icons_1 = __webpack_require__(63);
	var add_1 = tslib_1.__importDefault(__webpack_require__(77));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var productDomain_1 = __webpack_require__(158);
	var gridUtils_1 = __webpack_require__(83);
	var buttons_1 = __webpack_require__(27);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var mobx_1 = __webpack_require__(5);
	var react_router_1 = __webpack_require__(65);
	var more_vert_1 = tslib_1.__importDefault(__webpack_require__(291));
	var taskDialog_1 = tslib_1.__importDefault(__webpack_require__(567));
	var eventDomain_1 = __webpack_require__(74);
	var utils_1 = __webpack_require__(37);
	var activityExpando_1 = tslib_1.__importDefault(__webpack_require__(566));
	var dateUtils_1 = __webpack_require__(49);
	var gridDocument_1 = __webpack_require__(313);
	var gridDocumentComp_1 = tslib_1.__importDefault(__webpack_require__(312));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var securityDomain_1 = __webpack_require__(97);
	var locales_1 = __webpack_require__(15);
	var productGridLocation = 'vehicleProductList';
	var invoiceGridLocation = 'vehicleInvoiceList';
	var invoiceItemGridLocation = 'vehicleInvoiceItemList';
	var taskObjectGridLocation = 'taskObjectList';
	var activityGridLocation = "activityObjectList";
	var vehicleGridDocument = 'vehicleGridDocument';
	var VehicleDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(VehicleDetail, _super);
	    function VehicleDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.customValidate = function (vehicleObject) {
	            var errors = [];
	            var vehicleDto = vehicleObject.createDataObjectDto();
	            var editedData = vehicleDto.gridData[productGridLocation];
	            if (editedData) {
	                for (var _i = 0, _a = editedData.editedRows; _i < _a.length; _i++) {
	                    var rowObject = _a[_i];
	                    var productVehicle = rowObject;
	                    var pricesPerCurrency = productVehicle.prices.reduce(function (acc, price) {
	                        var currEntry = acc[(0, formUtils_1.lovValue)(price.priceCurrency)];
	                        if (!currEntry) {
	                            currEntry = [];
	                            acc[(0, formUtils_1.lovValue)(price.priceCurrency)] = currEntry;
	                        }
	                        currEntry.push(price);
	                        return acc;
	                    }, {});
	                    for (var currency in pricesPerCurrency) {
	                        var currEntry = pricesPerCurrency[currency];
	                        if (!(0, dateUtils_1.sortAndCheckInterval)(currEntry)) {
	                            errors.push({ message: "Price validity intervals for " + currency + " on " + (0, formUtils_1.lovLabel)(productVehicle.product) + " must not overlap" });
	                        }
	                    }
	                }
	            }
	            return errors;
	        };
	        /**
	         * musim dotahnout prices, jinak spadne customValidate, a nechci menit globalni
	         */
	        _this.onSaveMultiUpdate = function () {
	            uiService_1.default.showToolbarActionFlag();
	            var vehicleDto = productService_1.default.vehicleObject.createDataObjectDto();
	            var editedData = vehicleDto.gridData[productGridLocation];
	            if (editedData) {
	                var promises = editedData.editedRows.map(function (pv) { return _this.onProductVehicleFormLoad(pv); });
	                Promise.all(promises).then(function (x) {
	                    return _this.onSave(null);
	                });
	            }
	            else {
	                uiService_1.default.hideToolbarActionFlag();
	            }
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave ');
	            uiService_1.default.showToolbarActionFlag();
	            var result = (0, formUtils_1.preSave)(productService_1.default.vehicleObject, _this.customValidate);
	            if (!result) {
	                return;
	            }
	            var wasNew;
	            return productService_1.default.vehicleSave(productService_1.default.vehicleObject.createDataObjectDto())
	                .then((0, mobx_1.action)("vehicleSave-callback", function (vehicleJson) {
	                wasNew = productService_1.default.vehicleObject.cleanAfterSave(vehicleJson);
	                return _this.docSavingPromise(productService_1.default.vehicleObject.$movingBlocks.getBlock(vehicleGridDocument), { vehicleId: productService_1.default.vehicleObject.vehicleId });
	            })).then(function (x) {
	                if (wasNew) {
	                    _this.context.router.replaceWith('vehicleDetail', { id: productService_1.default.vehicleObject.vehicleId });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            }).catch(function (error) {
	                console.log("Error %O", error);
	                productService_1.default.vehicleObject.$errors = error.getMessages();
	            });
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            uiService_1.default.showToolbarActionFlag();
	            productService_1.default.deleteVehicle(productService_1.default.vehicleObject.vehicleId)
	                .then(function (response) {
	                uiService_1.default.hideToolbarActionFlag();
	                _this.goBackOrHome();
	            }, function (error) {
	                productService_1.default.vehicleObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            var party = (productService_1.default.vehicleObject.party) ? {
	                partyId: productService_1.default.vehicleObject.party.value,
	                partyLabel: productService_1.default.vehicleObject.party.label
	            } : null;
	            var query = tslib_1.__assign({ vehicleType: 1 }, party);
	            _this.context.router.transitionTo("vehicleDetail", { id: 'new' }, query);
	        };
	        _this.onCopy = function (evt) {
	            console.log('onCopy');
	            _this.context.router.transitionTo("vehicleDetail", { id: 'copy' }, { copyId: productService_1.default.vehicleObject.vehicleId });
	        };
	        _this.addProduct = function (evt) {
	            console.log('addProduct %O', evt);
	            var grid = productService_1.default.vehicleObject.$movingBlocks.getBlock(productGridLocation);
	            var rowObject = new productDomain_1.ProductVehicle({
	                vehicle: productService_1.default.vehicleObject.createLov(),
	                prices: [],
	                $new: true,
	                $dirty: true,
	                $added: true
	            }).initDefaultValues();
	            grid.addRow(rowObject);
	            var form = rowObject.getForm('ProductVehicleForm');
	            form.$open = true;
	            productService_1.default.vehicleObject.$dirty = true;
	        };
	        _this.onProductVehicleFormLoad = function (rowObject) {
	            console.log('onProductVehicleFormLoad %O', rowObject);
	            if (rowObject.prices) {
	                return Promise.resolve(rowObject);
	            }
	            else {
	                return productService_1.default.searchPriceComponents((0, formUtils_1.lovValue)(rowObject.product), (0, formUtils_1.lovValue)(rowObject.vehicle), null, productDomain_1.PRICECOMPLEVEL.PRODUCTVEHICLE)
	                    .then(function (prices) {
	                    rowObject.prices = mobx_1.observable.array(prices);
	                    return rowObject;
	                });
	            }
	        };
	        _this.onProductVehicleFormCommit = function (rootObject, rowObject) {
	            console.log('onProductVehicleFormCommit rootObject = %O, rowObject = %O', rootObject, rowObject);
	            return { partyId: (0, formUtils_1.lovValue)(rootObject.party) };
	        };
	        _this.onVehicleNotification = function (evt) {
	            console.log('onVehicleNotification');
	            new Promise(function (resolve, reject) {
	                _this.taskDialogRef.open(resolve, reject, { entity: productService_1.default.vehicleObject.$mdEntityRef.id, rowid: [productService_1.default.vehicleObject.vehicleId] });
	            }).then(function () {
	                uiService_1.default.hideToolbarActionFlag();
	                var movingBlocks = productService_1.default.vehicleObject.$movingBlocks;
	                var taskGrid = movingBlocks.getBlock(taskObjectGridLocation);
	                taskGrid.data = null;
	                if (movingBlocks.activeBlockTab === taskObjectGridLocation) {
	                    _this.activateTab(taskGrid);
	                }
	            }).catch(function (e) {
	            });
	        };
	        _this.taskDialogRefHandler = function (comp) { return _this.taskDialogRef = comp; };
	        return _this;
	    }
	    VehicleDetail.fetchData = function (routerParams, query) {
	        console.log("VehicleDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['Vehicle'], ['ProductVehicle', 'PriceComponent', {
	                entity: 'Product',
	                lov: true
	            }, { entity: 'Currency', lov: true }, 'Document']);
	        var vehiclePromise;
	        if (routerParams.id === 'new') {
	            var vehicleType = (query.vehicleType) ? parseInt(query.vehicleType) : null;
	            var party = (query.partyId) ? { value: query.partyId, label: query.partyLabel } : (securityService_1.default.currentUser.hasRestriction(securityDomain_1.RESTRICTION.YARD_MGMT_HAULER_VEHICLE) ? securityService_1.default.restrictionData.employer : null);
	            vehiclePromise = Promise.resolve(new productDomain_1.Vehicle({ $new: true, active: true, vehicleType: vehicleType, party: party }));
	        }
	        else if (routerParams.id === 'copy') {
	            vehiclePromise = productService_1.default.readVehicle(query.copyId)
	                .then(function (vehicleObject) {
	                vehicleObject.cleanOnCopy();
	                vehicleObject.active = true;
	                return vehicleObject;
	            });
	        }
	        else {
	            vehiclePromise = productService_1.default.readVehicle(routerParams.id);
	        }
	        var gridPromise = gridService_1.default.fetchGrids(productGridLocation, invoiceGridLocation, invoiceItemGridLocation, taskObjectGridLocation, activityGridLocation);
	        return Promise.all([metadataPromise, vehiclePromise, gridPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], vehicleObject = _a[1], gridLocationMap = _a[2];
	            vehicleObject.$movingBlocks = new gridUtils_1.MovingBlocks(productGridLocation, true, query.tab, new grid_1.default(gridLocationMap.get(productGridLocation), vehicleObject.vehicleId), new grid_1.default(gridLocationMap.get(invoiceGridLocation), vehicleObject.vehicleId), new grid_1.default(gridLocationMap.get(invoiceItemGridLocation), vehicleObject.vehicleId), new grid_1.default(gridLocationMap.get(taskObjectGridLocation), (0, utils_1.formatId)("Vehicle", vehicleObject.vehicleId)), new grid_1.default(gridLocationMap.get(activityGridLocation), (0, utils_1.formatId)("Vehicle", vehicleObject.vehicleId)), new gridDocument_1.GridDocument(vehicleGridDocument, "Docs", { vehicleId: vehicleObject.vehicleId }, false, null, (vehicleObject.$new) ? [] : null));
	            productService_1.default.vehicleObject = vehicleObject.initAfterRead(routerParams.id === 'new');
	        });
	    };
	    /**
	     *
	     */
	    VehicleDetail.prototype.componentWillMount = function () {
	        uiService_1.default.addMediaQueryListener(this.mediaQueryListener);
	    };
	    VehicleDetail.prototype.componentDidUpdate = function (prevProps) {
	        if (this.idChanged(prevProps.params.id, this.props.params.id)) {
	            productService_1.default.vehicleObject.$movingBlocks.searchExposedGrids(productService_1.default.vehicleObject);
	        }
	    };
	    VehicleDetail.prototype.componentDidMount = function () {
	        console.debug("%c componentDidMount", "background-color: magenta");
	        productService_1.default.vehicleObject.$movingBlocks.searchExposedGrids(productService_1.default.vehicleObject);
	    };
	    VehicleDetail.prototype.componentWillUnmount = function () {
	        uiService_1.default.removeMediaQueryListener(this.mediaQueryListener);
	        productService_1.default.vehicleObject = null;
	    };
	    VehicleDetail.prototype.findRootObject = function () {
	        return productService_1.default.vehicleObject;
	    };
	    VehicleDetail.prototype.render = function () {
	        var _this = this;
	        var query = this.props.query;
	        var propsForCreateForm = {
	            dataObject: productService_1.default.vehicleObject,
	            rootObject: productService_1.default.vehicleObject,
	            entity: mdEntityService_1.default.getEntity('Vehicle'),
	            entities: mdEntityService_1.default.entityMap
	        };
	        console.debug('%c vehicleDetail render query %O', 'background-color: yellow', this.props.query);
	        var mainForm = (react_1.default.createElement("form", { style: { marginTop: 10 } },
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12" },
	                    react_1.default.createElement(vehicleForm_1.default, tslib_1.__assign({}, propsForCreateForm))))));
	        var productVehicleEntity = mdEntityService_1.default.getEntity('ProductVehicle');
	        var rowProductForm = (react_1.default.createElement(productVehicleForm_1.default, { rootObject: productService_1.default.vehicleObject, entity: productVehicleEntity, entities: mdEntityService_1.default.entityMap, dataObject: null }));
	        var movingBlocks = productService_1.default.vehicleObject.$movingBlocks;
	        var gridCompArray = [
	            react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(productGridLocation), key: productGridLocation, uiLocation: movingBlocks.getUiLocation(productGridLocation), showEdit: true, showDelete: true, deleteRowIcon: "fa fa-trash", rootObject: productService_1.default.vehicleObject, editForm: rowProductForm, editFormName: "ProductVehicleForm", entities: mdEntityService_1.default.entityMap, onEditFormLoad: this.onProductVehicleFormLoad, prepareFormatRowParamsFn: this.onProductVehicleFormCommit, multiUpdateSecurable: metaConstant_1.SECURABLE.productGridUpdate, multiUpdateSaveFn: this.onSaveMultiUpdate },
	                react_1.default.createElement(icons_1.MdIconButton, { onToolbar: true, onClick: this.addProduct, disabled: !productService_1.default.vehicleObject.party },
	                    react_1.default.createElement(add_1.default, null))),
	            react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(invoiceGridLocation), key: productGridLocation, uiLocation: movingBlocks.getUiLocation(invoiceGridLocation), entities: mdEntityService_1.default.entityMap }),
	            react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(invoiceItemGridLocation), key: invoiceItemGridLocation, uiLocation: movingBlocks.getUiLocation(invoiceItemGridLocation), entities: mdEntityService_1.default.entityMap }),
	            react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(taskObjectGridLocation), key: taskObjectGridLocation, uiLocation: movingBlocks.getUiLocation(taskObjectGridLocation), entities: mdEntityService_1.default.entityMap }),
	            react_1.default.createElement(gridComp_1.default, { grid: movingBlocks.getBlock(activityGridLocation), key: activityGridLocation, uiLocation: movingBlocks.getUiLocation(activityGridLocation), entities: mdEntityService_1.default.entityMap, showExpand: true, ExpandComponent: activityExpando_1.default }),
	            react_1.default.createElement(gridDocumentComp_1.default, { uiLocation: movingBlocks.getUiLocation(vehicleGridDocument), grid: movingBlocks.getBlock(vehicleGridDocument), key: vehicleGridDocument, entities: mdEntityService_1.default.entityMap, rootObject: productService_1.default.vehicleObject })
	        ];
	        var standAloneGridComp = movingBlocks.pluckStandAloneBlock(gridCompArray);
	        var tabArray = gridCompArray.map(function (gridComp, index) { return (react_1.default.createElement(Tab_1.default, { label: gridComp.props.grid.label, style: variables_1.tabStyle, onActive: _this.activateTab.bind(_this, gridComp.props.grid), key: gridComp.props.grid.getBlockName(), value: gridComp.props.grid.getBlockName() }, gridComp)); });
	        var tabs = (tabArray.length) ? (react_1.default.createElement(Tabs_1.default, { value: movingBlocks.activeBlockTab, className: "detail-grid", tabTemplate: mui_theme_1.TabTemplate, inkBarStyle: { transition: 'inherit' }, contentContainerStyle: { width: '100%', flexGrow: 1, display: 'flex', minHeight: 0 }, onChange: this.onTabChange }, tabArray)) : '';
	        if (uiService_1.default.globalMediaQuery.matches) {
	            return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'row' } },
	                react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', height: '100%', width: '50%' } },
	                    this._createToolMenu(productService_1.default.vehicleObject, query.gridLocation),
	                    react_1.default.createElement(errorComp_1.ErrorComp, { messages: productService_1.default.vehicleObject.$errors }),
	                    react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	                    react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	                    react_1.default.createElement(taskDialog_1.default, { ref: this.taskDialogRefHandler, entities: mdEntityService_1.default.entityMap, location: eventDomain_1.ACTIVITYLOCATION.Vehicle, taskType: eventDomain_1.TASKTYPE.VEHICLE_NOTIFICATION }),
	                    mainForm,
	                    tabs),
	                standAloneGridComp));
	        }
	        else {
	            return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	                this._createToolMenu(productService_1.default.vehicleObject, query.gridLocation),
	                react_1.default.createElement(errorComp_1.ErrorComp, { messages: productService_1.default.vehicleObject.$errors }),
	                react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	                react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	                react_1.default.createElement(taskDialog_1.default, { ref: this.taskDialogRefHandler, entities: mdEntityService_1.default.entityMap, location: eventDomain_1.ACTIVITYLOCATION.Vehicle, taskType: eventDomain_1.TASKTYPE.VEHICLE_NOTIFICATION }),
	                mainForm,
	                tabs));
	        }
	    };
	    VehicleDetail.prototype._createToolMenu = function (vehicleObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: react_router_1.History.length <= 1, historize: true, entityName: "Vehicle", entityId: vehicleObject.vehicleId, activeTab: vehicleObject.$movingBlocks.activeBlockTab },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !vehicleObject.$dirty, label: "Save", permission: vehicleObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, disabled: vehicleObject.$new, label: "New", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onCopy, disabled: vehicleObject.$new, label: "Copy", permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "Vehicle", pageAncestor: this, onClick: this.onDelete, disabled: vehicleObject.$new, label: "Delete", permission: metaConstant_1.PERMISSION.Delete }),
	            react_1.default.createElement(icons_1.ZzIconButtonMenu, { buttonIcon: react_1.default.createElement(more_vert_1.default, null), securableType: metaConstant_1.SECURABLE_TYPE.DETAILACTION },
	                react_1.default.createElement(icons_1.ZzMenuItem, { primaryText: "Create Task", key: 4, onClick: this.onVehicleNotification, securable: metaConstant_1.SECURABLE.vehicleNotification }))));
	    };
	    VehicleDetail.module = metaConstant_1.MODULE.product;
	    VehicleDetail.title = 'Vehicle';
	    VehicleDetail.icon = 'truck';
	    VehicleDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], VehicleDetail.prototype, "onSaveMultiUpdate", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], VehicleDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], VehicleDetail.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], VehicleDetail.prototype, "addProduct", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], VehicleDetail.prototype, "onProductVehicleFormLoad", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], VehicleDetail.prototype, "onVehicleNotification", void 0);
	    VehicleDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], VehicleDetail);
	    return VehicleDetail;
	}(pageAncestor_1.default));
	exports.default = VehicleDetail;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var productVehicleAssignDialog_1 = tslib_1.__importDefault(__webpack_require__(571));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var routes_1 = __webpack_require__(75);
	var mobx_react_1 = __webpack_require__(4);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var gridComp_1 = __webpack_require__(44);
	var taskDialog_1 = tslib_1.__importDefault(__webpack_require__(567));
	var eventDomain_1 = __webpack_require__(74);
	var mobx_1 = __webpack_require__(5);
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'vehicleList';
	var VehicleList = /** @class */ (function (_super) {
	    tslib_1.__extends(VehicleList, _super);
	    function VehicleList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.assignProducts = function (grid) {
	            new Promise(function (resolve, reject) {
	                _this._productVehicleAssignDialog.open(resolve, reject, grid);
	            }).catch(function (e) { });
	        };
	        _this.createTasks = function (grid) {
	            console.log('createTasks');
	            return new Promise(function (resolve, reject) {
	                return _this.taskDialogRef.open(resolve, reject, grid.createFullParams());
	            }).catch(function (e) { });
	        };
	        _this.productVehicleAssignDialogRef = function (comp) { _this._productVehicleAssignDialog = comp; };
	        _this.taskDialogRefHandler = function (comp) { return _this.taskDialogRef = comp; };
	        return _this;
	    }
	    VehicleList.fetchData = function (routerParams) {
	        console.log("VehicleList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    VehicleList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        var bulkActions = [
	            { type: gridComp_1.BULKACTIONTYPE.ACTION, label: 'Assign Product', fn: this.assignProducts, that: this, securable: metaConstant_1.SECURABLE.assignProducts },
	            { type: gridComp_1.BULKACTIONTYPE.ACTION, label: 'Create Tasks', fn: this.createTasks, that: this, securable: metaConstant_1.SECURABLE.vehiclesNotification }
	        ];
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query, bulkActions: bulkActions, multiUpdateSecurable: metaConstant_1.SECURABLE.productGridUpdate },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "vehicleDetail", params: { id: 'new' }, query: { vehicleType: 1 }, label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["New Vehicle"], ["New Vehicle"]))), permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.vehicleDetail }),
	            react_1.default.createElement(productVehicleAssignDialog_1.default, { ref: this.productVehicleAssignDialogRef }),
	            react_1.default.createElement(taskDialog_1.default, { ref: this.taskDialogRefHandler, entities: mdEntityService_1.default.entityMap, location: eventDomain_1.ACTIVITYLOCATION.Vehicle, taskType: eventDomain_1.TASKTYPE.VEHICLE_NOTIFICATION })));
	    };
	    VehicleList.module = metaConstant_1.MODULE.product;
	    VehicleList.title = locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Vehicles"], ["Vehicles"])));
	    VehicleList.icon = 'truck';
	    VehicleList.rootPage = true;
	    VehicleList.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], VehicleList.prototype, "createTasks", void 0);
	    VehicleList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], VehicleList);
	    return VehicleList;
	}(pageAncestor_1.default));
	exports.default = VehicleList;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = EvaluationChartItem;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var recharts_1 = __webpack_require__(548);
	var Evaluation_styled_1 = __webpack_require__(572);
	function EvaluationChartItem(_a) {
	    var criteria = _a.criteria, color = _a.color, withCharts = _a.withCharts, total = _a.total;
	    function generateData(criteria) {
	        var data = [];
	        criteria.forEach(function (criterion) {
	            var value = criterion.groupScore ? criterion.groupScore : 0;
	            data.push({ name: criterion.criterionCode, value: Number(value.toFixed(1)) });
	        });
	        return data;
	    }
	    var totalResult = total > 0 ? total.toFixed(1) : '0.0';
	    return (react_1.default.createElement("div", null, withCharts ?
	        react_1.default.createElement(Evaluation_styled_1.CardBlock, null,
	            react_1.default.createElement("span", { className: "score" }, totalResult),
	            total && total > 0 ? react_1.default.createElement(recharts_1.PieChart, { width: 160, height: 120 },
	                react_1.default.createElement(recharts_1.Pie, { dataKey: "value", isAnimationActive: false, data: generateData(criteria), cx: "50%", cy: "50%", outerRadius: 30, fill: color, label: true, minAngle: 13 }),
	                react_1.default.createElement(recharts_1.Tooltip, null))
	                :
	                    react_1.default.createElement(Evaluation_styled_1.EmptyCircle, { color: color }))
	        :
	            react_1.default.createElement(Evaluation_styled_1.MiniCardBlock, null,
	                react_1.default.createElement("span", { className: "score" }, totalResult))));
	}


/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var Evaluation_styled_1 = __webpack_require__(572);
	var EvaluationChartItem_1 = tslib_1.__importDefault(__webpack_require__(2186));
	var projectVersionService_1 = tslib_1.__importDefault(__webpack_require__(111));
	var projectService_1 = tslib_1.__importDefault(__webpack_require__(406));
	var TotalEvaluationChart_1 = tslib_1.__importDefault(__webpack_require__(2188));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var paramsService_1 = tslib_1.__importDefault(__webpack_require__(159));
	var loading_1 = __webpack_require__(262);
	var EvaluationGrid = /** @class */ (function (_super) {
	    tslib_1.__extends(EvaluationGrid, _super);
	    function EvaluationGrid() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            projectVersions: [],
	            versionsData: [],
	            isLoading: true,
	        };
	        return _this;
	    }
	    EvaluationGrid.prototype.componentDidMount = function () {
	        this.fetchDataForCharts();
	    };
	    EvaluationGrid.prototype.openFullViewGrid = function () {
	        paramsService_1.default.selectedCriterion = undefined;
	    };
	    EvaluationGrid.prototype.fetchDataForCharts = function () {
	        var _this = this;
	        this.setState({ isLoading: true });
	        var projectID = projectVersionService_1.default.projectVersion.project.projectId;
	        projectService_1.default.getVersionsScore(projectID).then(function (resp) {
	            _this.setState({ projectVersions: resp.map(function (el) { return el.projectVersionId; }) });
	            var sortedVariants = resp.sort(function (a, b) {
	                var comparison = 0;
	                if (a.projectVersionId > b.projectVersionId) {
	                    comparison = 1;
	                }
	                else if (a.projectVersionId < b.projectVersionId) {
	                    comparison = -1;
	                }
	                return comparison;
	            });
	            _this.setState({ versionsData: sortedVariants });
	        }).then(function () { return _this.setState({ isLoading: false }); }).catch(function (error) { return console.error('err', error); });
	    };
	    EvaluationGrid.prototype.render = function () {
	        var _this = this;
	        var _a = this.state, projectVersions = _a.projectVersions, versionsData = _a.versionsData, isLoading = _a.isLoading;
	        var isCriterionSelected = paramsService_1.default.selectedCriterion;
	        var currentOpenedVersion = projectVersionService_1.default.projectVersion.versionId;
	        var criteriaColors = {
	            env: "#667B3B",
	            soc: "#36537B",
	            eco: "#B57031",
	            loc: "#555555"
	        };
	        return (react_1.default.createElement("div", { className: "EvaluationGrid", style: { backgroundColor: "#F9F9F9", borderRadius: 10, padding: 20, maxWidth: "100%" } },
	            react_1.default.createElement(Evaluation_styled_1.RowName, { style: { fontWeight: 700, color: "#000", height: "2rem", display: "block", marginBottom: "2rem" } }, "Pr\u016Fb\u011B\u017En\u00E1 anal\u00FDza v\u00FDsledk\u016F:"),
	            !isCriterionSelected ?
	                react_1.default.createElement("div", { style: { display: "flex" } },
	                    react_1.default.createElement("div", null,
	                        react_1.default.createElement(Evaluation_styled_1.Column, null,
	                            react_1.default.createElement(Evaluation_styled_1.RowName, null, "Hodnocen\u00ED lokality:"),
	                            react_1.default.createElement(Evaluation_styled_1.RowName, { style: { fontWeight: 700, color: "#000", height: "37px" } }, "Hodnocen\u00ED budovy:"),
	                            react_1.default.createElement(Evaluation_styled_1.RowName, null, "Environment\u00E1ln\u00ED krit\u00E9ria:"),
	                            react_1.default.createElement(Evaluation_styled_1.RowName, null, "Soci\u00E1ln\u00ED krit\u00E9ria:"),
	                            react_1.default.createElement(Evaluation_styled_1.RowName, null, "Ekonomick\u00E1 krit\u00E9ria:"),
	                            react_1.default.createElement(Evaluation_styled_1.RowName, null, "Celkov\u00E9 pr\u016Fb\u011B\u017En\u00E9 hodnocen\u00ED projektu:"))),
	                    react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "flex-start", overflowX: "auto", overflowY: "hidden" } },
	                        versionsData.length > 0 &&
	                            react_1.default.createElement(EvaluationChartItem_1.default, { criteria: versionsData[0].criterionListLocality, color: criteriaColors.loc, withCharts: !isCriterionSelected, total: versionsData[0].localityScore }),
	                        react_1.default.createElement(Evaluation_styled_1.GridContainer, { versions: projectVersions }, versionsData.map(function (versionData) {
	                            return react_1.default.createElement(Evaluation_styled_1.Column, { key: versionData.projectVersionId },
	                                currentOpenedVersion === versionData.projectVersionId ?
	                                    react_1.default.createElement("span", { style: { fontWeight: 700, fontSize: "2rem" } },
	                                        "V.",
	                                        versionData.version)
	                                    :
	                                        react_1.default.createElement("span", { style: { fontSize: "2rem" } },
	                                            "V.",
	                                            versionData.version),
	                                react_1.default.createElement(EvaluationChartItem_1.default, { criteria: versionData.criterionListEnvironmental, color: criteriaColors.env, withCharts: !isCriterionSelected, total: versionData.environmentalScore }),
	                                react_1.default.createElement(EvaluationChartItem_1.default, { criteria: versionData.criterionListSocial, color: criteriaColors.soc, withCharts: !isCriterionSelected, total: versionData.socialScore }),
	                                react_1.default.createElement(EvaluationChartItem_1.default, { criteria: versionData.criterionListEconomical, color: criteriaColors.eco, withCharts: !isCriterionSelected, total: versionData.economicalScore }),
	                                react_1.default.createElement(TotalEvaluationChart_1.default, { criteria: versionData.criterionList, withCharts: !isCriterionSelected, total: versionData.totalResult }));
	                        }))))
	                :
	                    // mini view of grid
	                    react_1.default.createElement("div", { style: { maxWidth: 300, overflowX: "auto" } },
	                        react_1.default.createElement("div", null,
	                            react_1.default.createElement(Evaluation_styled_1.MiniRowName, null, "Hodnocen\u00ED lokality:"),
	                            react_1.default.createElement(Evaluation_styled_1.MiniChartsRow, { versions: projectVersions }, versionsData.length > 0 &&
	                                react_1.default.createElement(EvaluationChartItem_1.default, { criteria: versionsData[0].criterionListLocality, color: criteriaColors.loc, withCharts: !isCriterionSelected, total: versionsData[0].localityScore }))),
	                        react_1.default.createElement("div", null,
	                            react_1.default.createElement(Evaluation_styled_1.MiniRowName, { style: { fontWeight: 700, color: "#000", display: "inline" } }, "Hodnocen\u00ED budovy:"),
	                            react_1.default.createElement(Evaluation_styled_1.MiniChartsRow, { versions: versionsData }, versionsData.map(function (version) {
	                                return currentOpenedVersion === version.projectVersionId ?
	                                    react_1.default.createElement("h5", { style: { fontWeight: 700, }, key: version.version },
	                                        "V.",
	                                        version.version)
	                                    :
	                                        react_1.default.createElement("h5", { key: version.version },
	                                            "V.",
	                                            version.version);
	                            }))),
	                        react_1.default.createElement("div", null,
	                            react_1.default.createElement(Evaluation_styled_1.MiniRowName, null, "Environment\u00E1ln\u00ED krit\u00E9ria:"),
	                            react_1.default.createElement(Evaluation_styled_1.MiniChartsRow, { versions: projectVersions }, versionsData &&
	                                versionsData.map(function (el, index) {
	                                    return react_1.default.createElement(EvaluationChartItem_1.default, { key: index, criteria: el.criterionListEnvironmental, color: criteriaColors.env, withCharts: !isCriterionSelected, total: el.environmentalScore });
	                                }))),
	                        react_1.default.createElement("div", null,
	                            react_1.default.createElement(Evaluation_styled_1.MiniRowName, null, "Soci\u00E1ln\u00ED krit\u00E9ria:"),
	                            react_1.default.createElement(Evaluation_styled_1.MiniChartsRow, { versions: projectVersions }, versionsData &&
	                                versionsData.map(function (el, index) {
	                                    return react_1.default.createElement(EvaluationChartItem_1.default, { key: index, criteria: el.criterionListSocial, color: criteriaColors.soc, withCharts: !isCriterionSelected, total: el.socialScore });
	                                }))),
	                        react_1.default.createElement("div", null,
	                            react_1.default.createElement(Evaluation_styled_1.MiniRowName, null, "Ekonomick\u00E1 krit\u00E9ria:"),
	                            react_1.default.createElement(Evaluation_styled_1.MiniChartsRow, { versions: projectVersions }, versionsData &&
	                                versionsData.map(function (el, index) {
	                                    return react_1.default.createElement(EvaluationChartItem_1.default, { key: index, criteria: el.criterionListEconomical, color: criteriaColors.eco, withCharts: !isCriterionSelected, total: el.economicalScore });
	                                }))),
	                        react_1.default.createElement("div", null,
	                            react_1.default.createElement(Evaluation_styled_1.MiniRowName, null, "Celkov\u00E9 pr\u016Fb\u011B\u017En\u00E9 hodnocen\u00ED projektu:"),
	                            react_1.default.createElement(Evaluation_styled_1.MiniChartsRow, { versions: projectVersions }, versionsData &&
	                                versionsData.map(function (el, index) {
	                                    return react_1.default.createElement(TotalEvaluationChart_1.default, { key: index, criteria: el.criterionList, withCharts: !isCriterionSelected, total: el.totalResult });
	                                })))),
	            react_1.default.createElement("div", { style: { display: "flex", justifyContent: "space-between", marginTop: 20 } },
	                isLoading ?
	                    react_1.default.createElement(loading_1.LoadingIcon, null)
	                    :
	                        react_1.default.createElement("div", { onClick: function () { return _this.fetchDataForCharts(); } },
	                            react_1.default.createElement(FlatButton_1.default, { label: "přepočítat", backgroundColor: "#98FB98" })),
	                isCriterionSelected &&
	                    react_1.default.createElement("div", { onClick: function () { return _this.openFullViewGrid(); } },
	                        react_1.default.createElement(FlatButton_1.default, { label: "plné zobrazení", backgroundColor: "#EDEDED" })))));
	    };
	    return EvaluationGrid;
	}(react_1.default.Component));
	exports.default = EvaluationGrid;


/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var recharts_1 = __webpack_require__(548);
	var Evaluation_styled_1 = __webpack_require__(572);
	// chart func from library to calculate angled line to criterion Value
	var renderActiveShape = function (items) {
	    var RADIAN = Math.PI / 180;
	    var cx = items.cx, cy = items.cy, midAngle = items.midAngle, innerRadius = items.innerRadius, outerRadius = items.outerRadius, startAngle = items.startAngle, endAngle = items.endAngle, fill = items.fill, payload = items.payload, value = items.value;
	    var sin = Math.sin(-RADIAN * midAngle);
	    var cos = Math.cos(-RADIAN * midAngle);
	    var sx = cx + (outerRadius + 10) * cos;
	    var sy = cy + (outerRadius + 10) * sin;
	    var mx = cx + (outerRadius + 10) * cos;
	    var my = cy + (outerRadius + 10) * sin;
	    var ex = mx + (cos >= 0 ? 1 : -1) * 10;
	    var ey = my;
	    var textAnchor = cos >= 0 ? 'start' : 'end';
	    return (react_1.default.createElement("g", null,
	        react_1.default.createElement("text", { x: cx, y: cy, dy: 8, textAnchor: "middle", fill: fill }, payload.name),
	        react_1.default.createElement(recharts_1.Sector, { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle, fill: fill }),
	        react_1.default.createElement(recharts_1.Sector, { cx: cx, cy: cy, startAngle: startAngle, endAngle: endAngle, innerRadius: outerRadius + 6, outerRadius: outerRadius + 10, fill: fill }),
	        react_1.default.createElement("path", { d: "M".concat(sx, ",").concat(sy, "L").concat(mx, ",").concat(my, "L").concat(ex, ",").concat(ey), stroke: fill, fill: "none" }),
	        react_1.default.createElement("circle", { cx: ex, cy: ey, r: 2, fill: fill, stroke: "none" }),
	        react_1.default.createElement("text", { x: ex + (cos >= 0 ? 1 : -1) * 12, y: ey, textAnchor: textAnchor, fill: "#333" }, value)));
	};
	var TotalEvaluationChart = /** @class */ (function (_super) {
	    tslib_1.__extends(TotalEvaluationChart, _super);
	    function TotalEvaluationChart(props) {
	        var _this = _super.call(this, props) || this;
	        _this.onPieEnter = function (_, index) {
	            _this.setState({
	                activeIndex: index,
	            });
	        };
	        _this.state = {
	            activeIndex: 0,
	        };
	        return _this;
	    }
	    TotalEvaluationChart.prototype.colorPicker = function (type) {
	        var criteriaColors = {
	            env: "#667B3B",
	            soc: "#36537B",
	            eco: "#B57031",
	            loc: "#555555"
	        };
	        switch (type) {
	            case "E": {
	                return criteriaColors.env;
	            }
	            case "S": {
	                return criteriaColors.soc;
	            }
	            case "C": {
	                return criteriaColors.eco;
	            }
	            case "L": {
	                return criteriaColors.loc;
	            }
	            default:
	                break;
	        }
	    };
	    TotalEvaluationChart.prototype.generateData = function (criteria) {
	        var data = [];
	        criteria.forEach(function (criterion) {
	            var value = criterion.totalScore ? criterion.totalScore : 0;
	            data.push({ name: criterion.criterionCode, value: Number(value.toFixed(1)) });
	        });
	        return data;
	    };
	    TotalEvaluationChart.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, criteria = _a.criteria, withCharts = _a.withCharts, total = _a.total;
	        var totalResult = total > 0 ? total.toFixed(1) : '0.0';
	        return (react_1.default.createElement("div", null, withCharts ?
	            react_1.default.createElement(Evaluation_styled_1.CardBlock, null,
	                react_1.default.createElement("span", { className: "score" }, totalResult),
	                total && total > 0 ? react_1.default.createElement(recharts_1.PieChart, { width: 160, height: 120 },
	                    react_1.default.createElement(recharts_1.Pie, { activeIndex: this.state.activeIndex, activeShape: renderActiveShape, data: this.generateData(criteria), cx: "50%", cy: "50%", innerRadius: 15, outerRadius: 30, fill: "#018A00", dataKey: "value", onMouseEnter: this.onPieEnter, minAngle: 5 }, criteria.map(function (entry, index) { return (react_1.default.createElement(recharts_1.Cell, { key: "cell-".concat(index), fill: _this.colorPicker(entry.type) })); })))
	                    :
	                        react_1.default.createElement(Evaluation_styled_1.EmptyCircle, { color: "linear-gradient(90deg, rgba(102,123,59,1) 0%, rgba(54,83,123,1) 35%, rgba(181,112,49,1) 69%, rgba(85,85,85,1) 100%)" }))
	            :
	                react_1.default.createElement(Evaluation_styled_1.MiniCardBlock, null,
	                    react_1.default.createElement("span", { className: "score" }, totalResult))));
	    };
	    return TotalEvaluationChart;
	}(react_1.default.Component));
	exports.default = TotalEvaluationChart;


/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var projectVersionService_1 = tslib_1.__importDefault(__webpack_require__(111));
	var mobx_react_1 = __webpack_require__(4);
	var FaCaretDown = __webpack_require__(1815);
	var FaCaretUp = __webpack_require__(1816);
	var SidebarCriteriaMenu_styled_1 = __webpack_require__(957);
	var SidebarMenuItem_1 = tslib_1.__importDefault(__webpack_require__(2190));
	var SidebarCriteriaMenu = /** @class */ (function (_super) {
	    tslib_1.__extends(SidebarCriteriaMenu, _super);
	    function SidebarCriteriaMenu() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            environmental: [],
	            social: [],
	            economic: [],
	            local: [],
	            openEnv: true,
	            openSoc: false,
	            openEco: false,
	            openLoc: false,
	        };
	        return _this;
	    }
	    SidebarCriteriaMenu.prototype.componentDidMount = function () {
	        var ENVIRONMENTALcriterias = projectVersionService_1.default.criteriaList.filter(function (el) { return el.type === "E"; });
	        var SOCIALcriterias = projectVersionService_1.default.criteriaList.filter(function (el) { return el.type === "S"; });
	        var ECONOMICcriterias = projectVersionService_1.default.criteriaList.filter(function (el) { return el.type === "C"; });
	        var LOCALcriterias = projectVersionService_1.default.criteriaList.filter(function (el) { return el.type === "L"; });
	        this.setState({
	            environmental: this.state.environmental.concat(ENVIRONMENTALcriterias),
	            social: this.state.environmental.concat(SOCIALcriterias),
	            economic: this.state.environmental.concat(ECONOMICcriterias),
	            local: this.state.environmental.concat(LOCALcriterias)
	        });
	    };
	    SidebarCriteriaMenu.prototype.toggleMenuOpen = function (menuOption) {
	        switch (menuOption) {
	            case "openEnv":
	                this.setState({ openEnv: !this.state.openEnv });
	                break;
	            case "openSoc":
	                this.setState({ openSoc: !this.state.openSoc });
	                break;
	            case "openEco":
	                this.setState({ openEco: !this.state.openEco });
	                break;
	            case "openLoc":
	                this.setState({ openLoc: !this.state.openLoc });
	                break;
	            default:
	                break;
	        }
	    };
	    SidebarCriteriaMenu.prototype.render = function () {
	        var _this = this;
	        var _a = this.state, openEnv = _a.openEnv, openLoc = _a.openLoc, openSoc = _a.openSoc, openEco = _a.openEco, environmental = _a.environmental, social = _a.social, local = _a.local, economic = _a.economic;
	        return (react_1.default.createElement(SidebarCriteriaMenu_styled_1.StyledMenu, null,
	            react_1.default.createElement(SidebarCriteriaMenu_styled_1.MenuHeader, { onClick: function () { return _this.toggleMenuOpen("openEnv"); }, isActive: openEnv },
	                openEnv ? react_1.default.createElement(FaCaretUp, null) : react_1.default.createElement(FaCaretDown, null),
	                react_1.default.createElement("h4", null, "Environment\u00E1ln\u00ED krit\u00E9ria")),
	            openEnv && environmental.map(function (criterion) {
	                return react_1.default.createElement(SidebarMenuItem_1.default, { key: criterion.criterionId, criterion: criterion, isValueChanged: _this.props.isValueChanged, handleChangeValue: _this.props.handleChangeValueState });
	            }),
	            react_1.default.createElement(SidebarCriteriaMenu_styled_1.MenuHeader, { onClick: function () { return _this.toggleMenuOpen("openSoc"); }, isActive: openSoc },
	                openSoc ? react_1.default.createElement(FaCaretUp, null) : react_1.default.createElement(FaCaretDown, null),
	                react_1.default.createElement("h4", null, "Soci\u00E1ln\u00ED krit\u00E9ria")),
	            openSoc && social.map(function (criterion) {
	                return react_1.default.createElement(SidebarMenuItem_1.default, { key: criterion.criterionId, criterion: criterion, isValueChanged: _this.props.isValueChanged, handleChangeValue: _this.props.handleChangeValueState });
	            }),
	            react_1.default.createElement(SidebarCriteriaMenu_styled_1.MenuHeader, { onClick: function () { return _this.toggleMenuOpen("openEco"); }, isActive: openEco },
	                openEco ? react_1.default.createElement(FaCaretUp, null) : react_1.default.createElement(FaCaretDown, null),
	                react_1.default.createElement("h4", null, "Ekonomika a management")),
	            openEco && economic.map(function (criterion) {
	                return react_1.default.createElement(SidebarMenuItem_1.default, { key: criterion.criterionId, criterion: criterion, isValueChanged: _this.props.isValueChanged, handleChangeValue: _this.props.handleChangeValueState });
	            }),
	            react_1.default.createElement(SidebarCriteriaMenu_styled_1.MenuHeader, { onClick: function () { return _this.toggleMenuOpen("openLoc"); }, isActive: openLoc },
	                openLoc ? react_1.default.createElement(FaCaretUp, null) : react_1.default.createElement(FaCaretDown, null),
	                react_1.default.createElement("h4", null, "Lokalita")),
	            openLoc && local.map(function (criterion) {
	                return react_1.default.createElement(SidebarMenuItem_1.default, { key: criterion.criterionId, criterion: criterion, isValueChanged: _this.props.isValueChanged, handleChangeValue: _this.props.handleChangeValueState });
	            })));
	    };
	    SidebarCriteriaMenu = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SidebarCriteriaMenu);
	    return SidebarCriteriaMenu;
	}(react_1.default.Component));
	exports.default = SidebarCriteriaMenu;


/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var paramsService_1 = tslib_1.__importDefault(__webpack_require__(159));
	var projectVersionService_1 = tslib_1.__importDefault(__webpack_require__(111));
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var SidebarCriteriaMenu_styled_1 = __webpack_require__(957);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var SidebarMenuItem = /** @class */ (function (_super) {
	    tslib_1.__extends(SidebarMenuItem, _super);
	    function SidebarMenuItem() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onSelectCriterion = function (e, passedCriterion) {
	            var criterion = projectVersionService_1.default.criteriaList.find(function (cr) { return cr.criterionId === passedCriterion.criterionId; });
	            paramsService_1.default.selectedCriterion = criterion;
	            if (criterion.subCriteria.length > 0) {
	                paramsService_1.default.selectedSubCriterion = criterion.subCriteria[0];
	            }
	            paramsService_1.default.selectCriterionVersion(undefined);
	            console.warn("Selected criterion : " + criterion.code);
	        };
	        _this.handlePickCriterion = function (e, passedCriterion) {
	            if (_this.props.isValueChanged) {
	                _this.changeCriterion.open(function (forward) {
	                    //if click 'yes, delete changed'
	                    _this.props.handleChangeValue(false);
	                    _this.onSelectCriterion(e, passedCriterion);
	                }, function (stay) {
	                    return;
	                });
	            }
	            else {
	                // if criterion value was not changed
	                _this.onSelectCriterion(e, passedCriterion);
	            }
	        };
	        _this.submitSaveDialogRefHandler = function (comp) { return _this.changeCriterion = comp; };
	        return _this;
	    }
	    SidebarMenuItem.prototype.render = function () {
	        var _this = this;
	        var criterion = this.props.criterion;
	        var selectedCriterion = paramsService_1.default.selectedCriterion;
	        var value = projectVersionService_1.default.criterionResults[criterion.code];
	        var valueStr = value >= 0 ? value : '';
	        var selected = selectedCriterion && criterion.criterionId === selectedCriterion.criterionId;
	        return (react_1.default.createElement(SidebarCriteriaMenu_styled_1.StyledMenuItem, { onClick: function (e) { return _this.handlePickCriterion(e, criterion); }, selected: selected },
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.submitSaveDialogRefHandler }),
	            react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
	                react_1.default.createElement(SidebarCriteriaMenu_styled_1.ColorCircle, { selected: selected, value: value }),
	                react_1.default.createElement("span", null, criterion.code + " " + criterion.name)),
	            react_1.default.createElement("span", { style: { fontWeight: 700 } }, valueStr)));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], SidebarMenuItem.prototype, "onSelectCriterion", void 0);
	    SidebarMenuItem = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SidebarMenuItem);
	    return SidebarMenuItem;
	}(react_1.default.Component));
	exports.default = SidebarMenuItem;


/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importStar(__webpack_require__(1));
	var mobx_react_1 = __webpack_require__(4);
	var TextField_1 = tslib_1.__importDefault(__webpack_require__(186));
	var subCriterionParameterDomain_1 = __webpack_require__(574);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var createForm_1 = __webpack_require__(18);
	var metaConstant_1 = __webpack_require__(13);
	var buttons_1 = __webpack_require__(27);
	var material_ui_1 = __webpack_require__(127);
	var paramsService_1 = tslib_1.__importDefault(__webpack_require__(159));
	var mobx_1 = __webpack_require__(5);
	var projectVersionParameterValueDomain_1 = __webpack_require__(265);
	var projectVersionService_1 = tslib_1.__importDefault(__webpack_require__(111));
	var locales_1 = __webpack_require__(15);
	var react_bootstrap_1 = __webpack_require__(72);
	var addDeleteColumnStyle = {
	    width: "80px"
	};
	var ParametersComplexCriterionForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ParametersComplexCriterionForm, _super);
	    function ParametersComplexCriterionForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.SHARED_PARAM_NUMBER = 1;
	        _this.newParameter = mobx_1.observable.map();
	        _this.parameterRows = (0, mobx_1.observable)([]);
	        _this.errors = mobx_1.observable.map();
	        _this.getParameters = function () {
	            var criterion = _this.props.criterion;
	            var subCriteria = criterion.subCriteria;
	            var parameters = [];
	            subCriteria.forEach(function (subCriterion) { return (subCriterion.parameters.forEach(function (param) { return (parameters.push(param)); })); });
	            var nonSharedParams = parameters.filter(function (param) { return (param.number !== _this.SHARED_PARAM_NUMBER); });
	            var sharedParam = subCriteria[0].parameters.filter(function (param) { return (param.number === _this.SHARED_PARAM_NUMBER); })[0];
	            var sharedParamId = sharedParam.paramId;
	            return { 'nonSharedParams': nonSharedParams, 'sharedParam': sharedParam, 'sharedParamId': sharedParamId };
	        };
	        _this.isValidRow = function () {
	            _this.errors.clear();
	            _this.newParameter.keys().forEach(function (key) {
	                var value = _this.newParameter.get(key).toString();
	                if (value.trim().length === 0) {
	                    _this.errors.set(key, locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Parameter is empty"], ["Parameter is empty"]))));
	                }
	            });
	            var sharedParamId = _this.getParameters().sharedParamId;
	            var sharedParamValue = _this.newParameter.get(sharedParamId.toString());
	            paramsService_1.default.paramsValues.filter(function (param) { return (param.paramNumber === _this.SHARED_PARAM_NUMBER); }).forEach(function (param) {
	                if (param.value.toString().trim() === sharedParamValue) {
	                    _this.errors.set(sharedParamId.toString(), locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Parameter must be entered only once"], ["Parameter must be entered only once"]))));
	                }
	            });
	            return _this.errors.size === 0;
	        };
	        _this.onChangeValue = function (paramId, value) {
	            var valueMap = _this.newParameter;
	            valueMap.set(paramId.toString(), value);
	            _this.newParameter.replace(valueMap);
	        };
	        _this.onDelete = function (paramNumber) {
	            var filteredParameterRows = _this.parameterRows.filter(function (element, index) { return (index + 1 !== paramNumber); });
	            var filteredParams = paramsService_1.default.paramsValues.filter(function (paramValue) { return (paramValue.paramNumber !== paramNumber); });
	            filteredParams.forEach(function (param) {
	                if (param.paramNumber > paramNumber) {
	                    param.paramNumber -= 1;
	                }
	            });
	            paramsService_1.default.paramsValues.replace(filteredParams);
	            _this.parameterRows.replace(filteredParameterRows);
	            _this.props.handleChangeValueState(true);
	        };
	        _this.onAddValue = function () {
	            if (!_this.isValidRow()) {
	                console.warn('ROW IS NOT VALID', _this.errors);
	                return;
	            }
	            var keys = _this.newParameter.keys(); //KEYS ARE PARAM ID
	            var criterion = _this.props.criterion;
	            var subCriteria = criterion.subCriteria;
	            subCriteria.forEach(function (subCriterion) {
	                subCriterion.parameters.forEach(function (parameter) {
	                    var param;
	                    if (parameter.number === _this.SHARED_PARAM_NUMBER) {
	                        var sharedParam = subCriterion.parameters;
	                        var sharedParamId = sharedParam[0].paramId;
	                        var sharedParamValue = _this.newParameter.get(sharedParamId.toString());
	                        param = new projectVersionParameterValueDomain_1.ProjectVersionParamValue({
	                            value: sharedParamValue,
	                            paramNumber: _this.parameterRows.length + 1,
	                            projectVersion: projectVersionService_1.default.projectVersion,
	                            parameter: parameter,
	                            count: 1,
	                            $new: true
	                        });
	                    }
	                    else {
	                        var paramValueKey = null;
	                        for (var i = 0; i < keys.length; i++) {
	                            if (parameter.paramId.toString().includes(keys[i])) {
	                                paramValueKey = keys[i];
	                            }
	                        }
	                        if (paramValueKey === null) {
	                            return;
	                        }
	                        var paramValue = _this.newParameter.get(paramValueKey);
	                        param = new projectVersionParameterValueDomain_1.ProjectVersionParamValue({
	                            value: paramValue,
	                            paramNumber: _this.parameterRows.length + 1,
	                            projectVersion: projectVersionService_1.default.projectVersion,
	                            parameter: parameter,
	                            count: 1,
	                            $new: true
	                        });
	                    }
	                    param.initAfterRead(true);
	                    paramsService_1.default.paramsValues.push(param);
	                });
	                _this.props.handleChangeValueState(true);
	            });
	            var paramValueMap = new Map();
	            _this.newParameter.keys().forEach(function (key) { return (paramValueMap.set(key, _this.newParameter.get(key))); });
	            _this.parameterRows.push(paramValueMap);
	            var cleanRow = mobx_1.observable.map();
	            _this.newParameter.keys().forEach(function (key) { return (cleanRow.set(key, '')); });
	            _this.newParameter = cleanRow;
	        };
	        _this.renderAddRow = function () {
	            var criterion = _this.props.criterion;
	            var subCriteria = criterion.subCriteria;
	            if (subCriteria.length === 0) {
	                return react_1.default.createElement("noscript", null);
	            }
	            var params = [];
	            for (var _i = 0, _a = criterion.subCriteria; _i < _a.length; _i++) {
	                var subcrioterion = _a[_i];
	                for (var _b = 0, _c = subcrioterion.parameters; _b < _c.length; _b++) {
	                    var param = _c[_b];
	                    params.push(param);
	                }
	            }
	            return (react_1.default.createElement("div", { style: { display: "flex", height: 60, width: '100%' } },
	                params.map(function (parameter) {
	                    if (parameter.valueType === subCriterionParameterDomain_1.VALUETYPE.NUMBER) {
	                        return (react_1.default.createElement(TextField_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.textField, { key: parameter.paramId, type: "string", style: { flexGrow: 1 }, value: _this.newParameter.get(parameter.paramId.toString()), onChange: function (e) {
	                                _this.onChangeValue(parameter.paramId, e.target.value);
	                            }, floatingLabelText: parameter.name, errorText: _this.errors.get(parameter.paramId.toString()) })));
	                    }
	                    else if (parameter.valueType === subCriterionParameterDomain_1.VALUETYPE.PARAM_ID) {
	                        var options = parameter.parameters
	                            .sort(function (p1, p2) { return p1.value - p2.value; })
	                            .map(function (p) {
	                            return { label: p.label + " (" + p.value + ")", value: p.valueId };
	                        });
	                        return (react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { label: parameter.name, value: _this.newParameter.get(parameter.paramId.toString()), onChange: function (e) {
	                                _this.onChangeValue(parameter.paramId, e.value);
	                            }, floatingLabelText: parameter.name, key: parameter.paramId, options: options, asterixForAll: false, style: { flexGrow: 1 }, async: false, searchable: true, clearable: false, errorText: _this.errors.get(parameter.paramId.toString()) })));
	                    }
	                }),
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: function () { return _this.onAddValue(); }, permission: metaConstant_1.PERMISSION.Update, style: addDeleteColumnStyle },
	                    react_1.default.createElement("i", { className: "fa fa-plus", "aria-hidden": "true" }))));
	        };
	        _this.renderTableBody = function () {
	            return (react_1.default.createElement(material_ui_1.TableBody, { displayRowCheckbox: false }, _this.renderRows()));
	        };
	        _this.fillParameterRows = function () {
	            if (!paramsService_1.default.parametersLoaded) {
	                setTimeout(_this.fillParameterRows, 1000);
	                return;
	            }
	            //all params that was saved
	            var params = paramsService_1.default.paramsValues;
	            if (params.length === 0) {
	                // console.warn("CRITERIA HAS NO FILLED PARAMS")
	                return;
	            }
	            // detecting how much subCriterion is for count columns
	            var rowLength = _this.props.criterion.subCriteria.length;
	            //will be fulfilled by {id:value} of param
	            var fullParam = new Map();
	            params.forEach(function (param, index) {
	                var paramId = param.parameter.paramId;
	                var value = param.value;
	                fullParam.set(paramId, value);
	                // divide params by subCriteria length for 1 row
	                if ((index + 1) % rowLength === 0) {
	                    _this.parameterRows.push(fullParam);
	                    fullParam.clear();
	                }
	            });
	        };
	        _this.renderRows = function () {
	            var criterion = _this.props.criterion;
	            var subCriteria = criterion.subCriteria;
	            var params = paramsService_1.default.paramsValues;
	            if (params.length === 0) {
	                return [];
	            }
	            var rows = [];
	            var _loop_1 = function (i) {
	                if (_this.parameterRows[i].size === 0) {
	                    return { value: void 0 };
	                }
	                var columns = [];
	                var valueMap = _this.parameterRows[i];
	                subCriteria.forEach(function (subCriterion) {
	                    subCriterion.parameters.forEach(function (parameter) {
	                        valueMap.keys().forEach(function (key) {
	                            if (key == parameter.paramId) {
	                                var value_1 = valueMap.get(key);
	                                if (parameter.valueType === subCriterionParameterDomain_1.VALUETYPE.PARAM_ID) {
	                                    var labelParameter = parameter.parameters.find(function (param) { return (param.valueId === Number(value_1)); });
	                                    value_1 = labelParameter.label;
	                                }
	                                columns.push(react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "left", key: i, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "valueTooltip", style: { fontSize: 13 }, className: "left-aligned-tooltip" }, value_1) },
	                                    react_1.default.createElement(material_ui_1.TableRowColumn, { key: i + '' + key }, value_1)));
	                            }
	                        });
	                    });
	                });
	                columns.push(_this.renderDeleteColumn(i + 1));
	                rows.push(react_1.default.createElement(material_ui_1.TableRow, { key: i }, columns));
	            };
	            for (var i = 0; i < _this.parameterRows.length; i++) {
	                var state_1 = _loop_1(i);
	                if (typeof state_1 === "object")
	                    return state_1.value;
	            }
	            return rows;
	        };
	        _this.renderDeleteColumn = function (paramNumber) {
	            return (react_1.default.createElement(material_ui_1.TableRowColumn, { key: paramNumber + ' delete', style: addDeleteColumnStyle },
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: function () { return _this.onDelete(paramNumber); }, permission: metaConstant_1.PERMISSION.Update },
	                    react_1.default.createElement("i", { className: "fa fa-minus", "aria-hidden": "true" }))));
	        };
	        return _this;
	    }
	    ParametersComplexCriterionForm.prototype.componentDidMount = function () {
	        var _this = this;
	        console.warn('componentDidMount');
	        this.parameterRows.clear();
	        this.fillParameterRows();
	        var _a = this.getParameters(), nonSharedParams = _a.nonSharedParams, sharedParamId = _a.sharedParamId;
	        this.newParameter.set(sharedParamId.toString(), '');
	        nonSharedParams.forEach(function (param) {
	            _this.newParameter.set(param.paramId.toString(), '');
	        });
	    };
	    ParametersComplexCriterionForm.prototype.componentDidUpdate = function (prevProps, prevState, prevContext) {
	        var _this = this;
	        if (prevProps.criterion !== this.props.criterion) {
	            console.warn('componentDidUpdate');
	            this.parameterRows.clear();
	            this.newParameter.clear();
	            var _a = this.getParameters(), nonSharedParams = _a.nonSharedParams, sharedParamId = _a.sharedParamId;
	            this.newParameter.set(sharedParamId.toString(), '');
	            nonSharedParams.forEach(function (param) {
	                _this.newParameter.set(param.paramId.toString(), '');
	            });
	            this.fillParameterRows();
	        }
	    };
	    ParametersComplexCriterionForm.prototype.componentWillUnmount = function () {
	        this.parameterRows.clear();
	        this.newParameter.clear();
	    };
	    ParametersComplexCriterionForm.prototype.render = function () {
	        return (react_1.default.createElement("div", { style: { marginTop: 20, width: "100%" } },
	            this.renderAddRow(),
	            react_1.default.createElement(material_ui_1.Table, { selectable: false }, this.renderTableBody())));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ParametersComplexCriterionForm.prototype, "fillParameterRows", void 0);
	    ParametersComplexCriterionForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ParametersComplexCriterionForm);
	    return ParametersComplexCriterionForm;
	}(react_1.Component));
	exports.default = ParametersComplexCriterionForm;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importStar(__webpack_require__(1));
	var subCriterionParameterDomain_1 = __webpack_require__(574);
	var material_ui_1 = __webpack_require__(127);
	var mobx_react_1 = __webpack_require__(4);
	var paramsService_1 = tslib_1.__importDefault(__webpack_require__(159));
	var projectVersionParameterValueDomain_1 = __webpack_require__(265);
	var projectVersionService_1 = tslib_1.__importDefault(__webpack_require__(111));
	var mobx_1 = __webpack_require__(5);
	var locales_1 = __webpack_require__(15);
	var PARAM_NUMBER = 1;
	var ParametersInputsForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ParametersInputsForm, _super);
	    function ParametersInputsForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.errors = mobx_1.observable.map();
	        _this.onInput = function (e, subCriterionParam) {
	            var value = e.target.value;
	            _this.validate(value, subCriterionParam);
	            var versionParam = paramsService_1.default.paramsValues.find(function (p) { return p.paramNumber === PARAM_NUMBER && p.parameter.paramId === subCriterionParam.paramId; });
	            if (versionParam) {
	                versionParam.value = value;
	            }
	            else {
	                var param = new projectVersionParameterValueDomain_1.ProjectVersionParamValue({
	                    value: value,
	                    paramNumber: PARAM_NUMBER,
	                    projectVersion: projectVersionService_1.default.projectVersion,
	                    parameter: subCriterionParam,
	                    count: 1,
	                    $new: true
	                });
	                param.initAfterRead(true);
	                paramsService_1.default.paramsValues.push(param);
	            }
	            _this.props.handleChangeValueState(true);
	        };
	        _this.validate = function (value, subCriterionParam) {
	            var paramId = String(subCriterionParam.paramId);
	            var valueType = subCriterionParam.valueType;
	            if (subCriterionParam.optional) {
	                return;
	            }
	            if (!value) {
	                _this.errors.set(paramId, locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Parameter is empty"], ["Parameter is empty"]))));
	                return;
	            }
	            if (valueType === subCriterionParameterDomain_1.VALUETYPE.NUMBER && isNaN(Number(value))) {
	                _this.errors.set(paramId, locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Parameter should be number"], ["Parameter should be number"]))));
	                return;
	            }
	            if (valueType === subCriterionParameterDomain_1.VALUETYPE.PERCENTS && isNaN(Number(value))) {
	                _this.errors.set(paramId, locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Parameter should be number"], ["Parameter should be number"]))));
	                return;
	            }
	            if (valueType === subCriterionParameterDomain_1.VALUETYPE.PERCENTS && Number(value) > 100) {
	                _this.errors.set(paramId, locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["Parameter should be 100 or less"], ["Parameter should be 100 or less"]))));
	                return;
	            }
	            if (valueType === subCriterionParameterDomain_1.VALUETYPE.PARAM_ID) {
	                _this.errors.set(paramId, locales_1.loc.i18n(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["Param id not supported here"], ["Param id not supported here"]))));
	                return;
	            }
	            _this.errors.delete(paramId);
	        };
	        _this.renderInput = function (subCriterionParam) {
	            var versionParam = paramsService_1.default.paramsValues.find(function (p) { return p.paramNumber === PARAM_NUMBER && p.parameter.paramId === subCriterionParam.paramId; });
	            var value = "";
	            if (versionParam) {
	                value = versionParam.value;
	            }
	            return (react_1.default.createElement(material_ui_1.TextField, { floatingLabelText: subCriterionParam.name, fullWidth: true, value: value, onChange: function (e) { return _this.onInput(e, subCriterionParam); }, errorText: _this.errors.get(String(subCriterionParam.paramId)) }));
	        };
	        return _this;
	    }
	    ParametersInputsForm.prototype.render = function () {
	        var _this = this;
	        return (react_1.default.createElement("div", { style: { marginTop: 20, width: "100%" } }, this.props.subCriterion.parameters
	            .sort(function (p1, p2) { return p1.number - p2.number; })
	            .map(function (p) { return _this.renderInput(p); })));
	    };
	    ParametersInputsForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ParametersInputsForm);
	    return ParametersInputsForm;
	}(react_1.Component));
	exports.default = ParametersInputsForm;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importStar(__webpack_require__(1));
	var subCriterionParameterDomain_1 = __webpack_require__(574);
	var material_ui_1 = __webpack_require__(127);
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var projectVersionParameterValueDomain_1 = __webpack_require__(265);
	var locales_1 = __webpack_require__(15);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var paramsService_1 = tslib_1.__importDefault(__webpack_require__(159));
	var projectVersionService_1 = tslib_1.__importDefault(__webpack_require__(111));
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var react_bootstrap_1 = __webpack_require__(72);
	var addDeleteColumnStyle = {
	    width: "80px"
	};
	var ParametersListForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ParametersListForm, _super);
	    function ParametersListForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.errors = mobx_1.observable.map();
	        _this.newValuesRow = (0, mobx_1.observable)([]);
	        _this.booleanOptions = [{ value: "true", label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))) }, { value: "false", label: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }];
	        _this.initNewValueArray = function (subCriterion) {
	            var newArray = new Array(subCriterion.parameters.length).fill("");
	            _this.newValuesRow.replace(newArray);
	        };
	        _this.onValueChangeArray = function (newValue, index) {
	            var newValueRow = _this.newValuesRow;
	            newValueRow[index] = newValue.map(function (v) { return String(v.value); });
	            _this.setState({ newValuesRow: newValueRow });
	        };
	        _this.onValueChange = function (newValue, index) {
	            var newValueRow = _this.newValuesRow;
	            newValueRow[index] = newValue;
	            _this.setState({ newValuesRow: newValueRow });
	        };
	        _this.onAdd = function () {
	            if (!_this.isValidRow()) {
	                return;
	            }
	            var rowValues = _this.newValuesRow;
	            var subCriterion = _this.props.subCriterion;
	            var paramNumber = paramsService_1.default.getNextParamNumber(subCriterion);
	            var criterionParams = subCriterion.parameters.sort(_this.sortByNumber);
	            rowValues.forEach(function (v, i) {
	                console.warn("added value", i, v);
	                if (v instanceof Array) {
	                    var params = v;
	                    params.forEach(function (vp) {
	                        var param = new projectVersionParameterValueDomain_1.ProjectVersionParamValue({
	                            value: vp,
	                            paramNumber: paramNumber,
	                            projectVersion: projectVersionService_1.default.projectVersion,
	                            parameter: criterionParams[i],
	                            count: 1,
	                            $new: true
	                        });
	                        param.initAfterRead(true);
	                        paramsService_1.default.paramsValues.push(param);
	                    });
	                }
	                else {
	                    var param = new projectVersionParameterValueDomain_1.ProjectVersionParamValue({
	                        value: v,
	                        paramNumber: paramNumber,
	                        projectVersion: projectVersionService_1.default.projectVersion,
	                        parameter: criterionParams[i],
	                        count: 1,
	                        $new: true
	                    });
	                    param.initAfterRead(true);
	                    paramsService_1.default.paramsValues.push(param);
	                }
	            });
	            console.warn("params after all push", paramsService_1.default.paramsValues);
	            _this.initNewValueArray(_this.props.subCriterion);
	            _this.props.handleChangeValueState(true);
	        };
	        _this.onDelete = function (paramNumber) {
	            var paramValuesCurrentSubCriterion = paramsService_1.default.paramsValues.filter(function (p) {
	                return p.paramNumber !== paramNumber && _this.props.subCriterion.parameters.find(function (par) { return par.paramId === p.parameter.paramId; }) !== undefined;
	            });
	            var paramValuesAnotherCriteria = paramsService_1.default.paramsValues.filter(function (p) {
	                return _this.props.subCriterion.parameters.find(function (par) { return par.paramId === p.parameter.paramId; }) === undefined;
	            });
	            paramValuesCurrentSubCriterion.push.apply(paramValuesCurrentSubCriterion, paramValuesAnotherCriteria);
	            paramsService_1.default.paramsValues.replace(paramValuesCurrentSubCriterion);
	            paramsService_1.default.recalculateParamsNumbers();
	            _this.props.handleChangeValueState(true);
	        };
	        _this.isValidRow = function () {
	            _this.errors.clear();
	            _this.newValuesRow.forEach(function (value, index) {
	                var param = _this.props.subCriterion.parameters[index];
	                var valueType = param.valueType;
	                var paramIndex = String(index);
	                //For optional parameter there is currently no validation
	                if (param.optional) {
	                    return;
	                }
	                if (!value || (typeof value === "string" && value.trim().length) === 0) {
	                    _this.errors.set(paramIndex, locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Parameter is empty"], ["Parameter is empty"]))));
	                }
	                else if (valueType === subCriterionParameterDomain_1.VALUETYPE.NUMBER && isNaN(Number(value))) {
	                    _this.errors.set(paramIndex, locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["Parameter should be number"], ["Parameter should be number"]))));
	                }
	                else if (valueType === subCriterionParameterDomain_1.VALUETYPE.PERCENTS && isNaN(Number(value))) {
	                    _this.errors.set(paramIndex, locales_1.loc.i18n(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["Parameter should be number"], ["Parameter should be number"]))));
	                }
	                else if (valueType === subCriterionParameterDomain_1.VALUETYPE.PERCENTS && Number(value) > 100) {
	                    _this.errors.set(paramIndex, locales_1.loc.i18n(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["Parameter should be 100 or less"], ["Parameter should be 100 or less"]))));
	                }
	            });
	            return _this.errors.size === 0;
	        };
	        _this.renderAddRow = function () {
	            var subCriterion = _this.props.subCriterion;
	            console.warn("subCriterion", subCriterion);
	            var params = subCriterion.parameters.sort(_this.sortByNumber);
	            var columns = params.map(function (p, index) {
	                var value = _this.newValuesRow[index];
	                if (p.valueType === subCriterionParameterDomain_1.VALUETYPE.NUMBER || p.valueType === subCriterionParameterDomain_1.VALUETYPE.STRING || p.valueType === subCriterionParameterDomain_1.VALUETYPE.PERCENTS) {
	                    return react_1.default.createElement(material_ui_1.TextField, tslib_1.__assign({}, createForm_1.fieldStyles.small.textField, { key: p.number + "1", type: "string", style: { width: "100%" }, value: value, floatingLabelText: p.name, onChange: function (e) { return _this.onValueChange(e.target.value, index); }, errorText: _this.errors.get(String(index)) }));
	                }
	                else if (p.valueType === subCriterionParameterDomain_1.VALUETYPE.PARAM_ID) {
	                    var options = p.parameters
	                        .sort(function (p1, p2) { return p1.value - p2.value; })
	                        .map(function (p) {
	                        return { label: p.label + " (" + p.value + ")", value: p.valueId };
	                    });
	                    return react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { label: p.name, value: value, floatingLabelText: p.name, key: p.number, options: options, asterixForAll: false, style: { width: "100%" }, async: false, searchable: true, clearable: false, onChange: function (e) { return _this.onValueChange(String(e.value), index); }, errorText: _this.errors.get(String(index)) }));
	                }
	                else if (p.valueType === subCriterionParameterDomain_1.VALUETYPE.BOOLEAN) {
	                    return react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { label: p.name, value: value, floatingLabelText: p.name, key: p.number, options: _this.booleanOptions, style: { width: "100%" }, async: false, clearable: false, onChange: function (e) { return _this.onValueChange(String(e.value), index); }, errorText: _this.errors.get(String(index)) }));
	                }
	                else if (p.valueType === subCriterionParameterDomain_1.VALUETYPE.MULTI) {
	                    var options = p.parameters
	                        .sort(function (p1, p2) { return p1.value - p2.value; })
	                        .map(function (p) {
	                        return { label: p.label + " (" + p.value + ")", value: p.valueId };
	                    });
	                    return react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.small.styledSelect, { label: p.name, value: value, floatingLabelText: p.name, key: p.number, options: options, asterixForAll: false, style: { width: "100%" }, async: false, multi: true, searchable: true, clearable: false, onChange: function (e) { return _this.onValueChangeArray(e, index); }, errorText: _this.errors.get(String(index)) }));
	                }
	                else {
	                    return react_1.default.createElement("noscript", null);
	                }
	            });
	            return (react_1.default.createElement("div", { style: { display: "flex", height: 60 } },
	                columns,
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: _this.onAdd, permission: metaConstant_1.PERMISSION.Update, style: addDeleteColumnStyle },
	                    react_1.default.createElement("i", { className: "fa fa-plus", "aria-hidden": "true" }))));
	        };
	        _this.sortByNumber = function (p1, p2) {
	            return p1.number - p2.number;
	        };
	        _this.renderTableBody = function () {
	            return (react_1.default.createElement(material_ui_1.TableBody, { displayRowCheckbox: false }, _this.renderRows()));
	        };
	        _this.renderRows = function () {
	            var params = paramsService_1.default.paramsValues
	                .filter(function (p) { return _this.props.subCriterion.parameters.find(function (p1) { return p1.paramId === p.parameter.paramId; }); })
	                .sort(function (p1, p2) { return _this.sortByNumber(p1.parameter, p2.parameter); });
	            if (params.length === 0) {
	                return [];
	            }
	            var rows = [];
	            var currentRowNumber = 1;
	            var rowParams = params.filter(function (p) { return p.paramNumber === currentRowNumber; });
	            while (rowParams.length != 0) {
	                var columns = rowParams.map(function (param, index) {
	                    var text = param.value;
	                    if (param.parameter.valueType === subCriterionParameterDomain_1.VALUETYPE.PARAM_ID) {
	                        var paramValue = param.parameter.parameters.find(function (p) { return p.valueId === Number(param.value); });
	                        text = paramValue ? paramValue.label : "-";
	                    }
	                    else if (param.parameter.valueType === subCriterionParameterDomain_1.VALUETYPE.BOOLEAN) {
	                        text = param.value == "true" ? "Ano" : "Ne";
	                    }
	                    else if (param.parameter.valueType === subCriterionParameterDomain_1.VALUETYPE.MULTI) {
	                        text = "";
	                        param.parameter.parameters
	                            .filter(function (p) { return p.valueId === Number(param.value); })
	                            .forEach(function (p) {
	                            text += p.label + ", ";
	                        });
	                    }
	                    return (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "left", key: index, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "valueTooltip", style: { fontSize: 13 }, className: "left-aligned-tooltip" }, text) },
	                        react_1.default.createElement(material_ui_1.TableRowColumn, { key: index + "" }, text)));
	                });
	                var row = react_1.default.createElement(material_ui_1.TableRow, { key: currentRowNumber },
	                    columns,
	                    _this.renderDeleteColumn(currentRowNumber));
	                rows.push(row);
	                currentRowNumber++;
	                rowParams = params.filter(function (p) { return p.paramNumber === currentRowNumber; });
	            }
	            return rows;
	        };
	        _this.renderDeleteColumn = function (paramNumber) {
	            return (react_1.default.createElement(material_ui_1.TableRowColumn, { style: addDeleteColumnStyle },
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: function () { return _this.onDelete(paramNumber); }, permission: metaConstant_1.PERMISSION.Update },
	                    react_1.default.createElement("i", { className: "fa fa-minus", "aria-hidden": "true" }))));
	        };
	        return _this;
	    }
	    ParametersListForm.prototype.componentDidMount = function () {
	        this.initNewValueArray(this.props.subCriterion);
	    };
	    ParametersListForm.prototype.componentDidUpdate = function (prevProps, prevState, prevContext) {
	        if (prevProps.subCriterion !== this.props.subCriterion) {
	            this.initNewValueArray(this.props.subCriterion);
	        }
	    };
	    ParametersListForm.prototype.render = function () {
	        return (react_1.default.createElement("div", { style: { marginTop: 20, width: "100%" } },
	            this.renderAddRow(),
	            react_1.default.createElement(material_ui_1.Table, { selectable: false }, this.renderTableBody())));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ParametersListForm.prototype, "onAdd", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ParametersListForm.prototype, "onDelete", void 0);
	    ParametersListForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ParametersListForm);
	    return ParametersListForm;
	}(react_1.Component));
	exports.default = ParametersListForm;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;


/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importStar(__webpack_require__(1));
	var material_ui_1 = __webpack_require__(127);
	var mobx_react_1 = __webpack_require__(4);
	var paramsService_1 = tslib_1.__importDefault(__webpack_require__(159));
	var projectVersionParameterValueDomain_1 = __webpack_require__(265);
	var projectVersionService_1 = tslib_1.__importDefault(__webpack_require__(111));
	var mobx_1 = __webpack_require__(5);
	var ParametersMultiSelectForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ParametersMultiSelectForm, _super);
	    function ParametersMultiSelectForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onSelect = function (checked, valueId, subCriterionParam) {
	            var paramValue = subCriterionParam.parameters.find(function (p) { return p.valueId === valueId; });
	            var toDisableIds = [];
	            if (!checked) {
	                subCriterionParam.parameters.forEach(function (param) {
	                    if (param.dependsOn.find(function (depend) { return depend.value == valueId; })) {
	                        toDisableIds.push(String(param.valueId));
	                    }
	                });
	            }
	            var versionParam = paramsService_1.default.paramsValues.find(function (p) { return p.value === String(paramValue.valueId) && p.parameter.paramId === subCriterionParam.paramId; });
	            if (versionParam) {
	                var newValues = paramsService_1.default.paramsValues.filter(function (e) { return e.value !== versionParam.value && !toDisableIds.includes(e.value); });
	                paramsService_1.default.paramsValues.replace(newValues);
	                paramsService_1.default.recalculateParamsNumbers();
	            }
	            else {
	                var param = new projectVersionParameterValueDomain_1.ProjectVersionParamValue({
	                    value: String(paramValue.valueId),
	                    projectVersion: projectVersionService_1.default.projectVersion,
	                    parameter: subCriterionParam,
	                    paramNumber: paramsService_1.default.getNextParamNumber(_this.props.subCriterion),
	                    count: 1,
	                    $new: true
	                });
	                param.initAfterRead(true);
	                paramsService_1.default.paramsValues.push(param);
	            }
	            _this.props.handleChangeValueState(true);
	        };
	        _this.onChangeCount = function (value, subCriterionParam, valueCount) {
	            var versionParam = paramsService_1.default.paramsValues.find(function (p) { return p.value === String(value.valueId) && p.parameter.paramId === subCriterionParam.paramId; });
	            var newCount = versionParam.count + valueCount;
	            if (newCount >= 1 && newCount <= value.countLimit) {
	                versionParam.count = newCount;
	            }
	        };
	        _this.isChecked = function (valueId) {
	            var param = paramsService_1.default.paramsValues.find(function (p) { return p.value === String(valueId); });
	            return param !== undefined; //&& value.selected === true;
	        };
	        _this.isDisabled = function (value) {
	            if (value.dependsOn.length == 0) {
	                return false;
	            }
	            return value.dependsOn.find(function (elem) { return !_this.isChecked(Number(elem.value)); }) != undefined;
	        };
	        _this.renderCheckboxes = function (subCriterionParam) {
	            var sorted = subCriterionParam.parameters.sort(function (a, b) {
	                return a.valueId - b.valueId;
	            });
	            return sorted.map(function (param) {
	                return (react_1.default.createElement("div", { key: param.valueId },
	                    react_1.default.createElement(material_ui_1.Checkbox, { name: subCriterionParam.name, checked: _this.isChecked(param.valueId), onCheck: function (e, checked) { return _this.onSelect(checked, param.valueId, subCriterionParam); }, key: param.valueId, value: param.valueId, disabled: _this.isDisabled(param), label: param.label + " (" + param.value + ")" }),
	                    _this.renderStepper(param, subCriterionParam)));
	            });
	        };
	        _this.renderStepper = function (value, subCriterionParam) {
	            var isDisabled = !_this.isChecked(value.valueId);
	            var versionParam = paramsService_1.default.paramsValues.find(function (p) { return p.value === String(value.valueId) && p.parameter.paramId === subCriterionParam.paramId; });
	            if (!value.countLimit || value.countLimit <= 1) {
	                return react_1.default.createElement("noscript", null);
	            }
	            if (isDisabled) {
	                return react_1.default.createElement("noscript", null);
	            }
	            return (react_1.default.createElement("div", { style: { display: "inline-block" } },
	                react_1.default.createElement(material_ui_1.FlatButton, { onClick: function (event) { return _this.onChangeCount(value, subCriterionParam, -1); } },
	                    react_1.default.createElement("i", { className: "fa fa-minus", "aria-hidden": "true" })),
	                react_1.default.createElement(material_ui_1.FlatButton, null, versionParam.count),
	                react_1.default.createElement(material_ui_1.FlatButton, { onClick: function (event) { return _this.onChangeCount(value, subCriterionParam, 1); } },
	                    react_1.default.createElement("i", { className: "fa fa-plus", "aria-hidden": "true" }))));
	        };
	        return _this;
	    }
	    ParametersMultiSelectForm.prototype.renderCheckboxGroups = function (subCriterionParams) {
	        var _this = this;
	        return subCriterionParams.map(function (param) {
	            return (react_1.default.createElement("div", { key: param.paramId },
	                param.name,
	                _this.renderCheckboxes(param)));
	        });
	    };
	    ParametersMultiSelectForm.prototype.render = function () {
	        return (react_1.default.createElement("div", { style: { marginTop: 20, width: "100%" } }, this.renderCheckboxGroups(this.props.subCriterion.parameters)));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ParametersMultiSelectForm.prototype, "onSelect", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ParametersMultiSelectForm.prototype, "onChangeCount", void 0);
	    ParametersMultiSelectForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ParametersMultiSelectForm);
	    return ParametersMultiSelectForm;
	}(react_1.Component));
	exports.default = ParametersMultiSelectForm;


/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importStar(__webpack_require__(1));
	var material_ui_1 = __webpack_require__(127);
	var mobx_react_1 = __webpack_require__(4);
	var paramsService_1 = tslib_1.__importDefault(__webpack_require__(159));
	var projectVersionParameterValueDomain_1 = __webpack_require__(265);
	var projectVersionService_1 = tslib_1.__importDefault(__webpack_require__(111));
	var PARAM_NUMBER = 1;
	var ParametersSelectForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ParametersSelectForm, _super);
	    function ParametersSelectForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onSelect = function (e, selected, subCriterionParam) {
	            var value = subCriterionParam.parameters.find(function (p) { return p.valueId === Number(selected); });
	            var versionParam = paramsService_1.default.paramsValues.find(function (p) { return p.paramNumber === PARAM_NUMBER && p.parameter.paramId === subCriterionParam.paramId; });
	            if (versionParam) {
	                versionParam.value = String(value.valueId);
	            }
	            else {
	                var param = new projectVersionParameterValueDomain_1.ProjectVersionParamValue({
	                    value: String(value.valueId),
	                    paramNumber: PARAM_NUMBER,
	                    projectVersion: projectVersionService_1.default.projectVersion,
	                    parameter: subCriterionParam,
	                    count: 1,
	                    $new: true
	                });
	                param.initAfterRead(true);
	                paramsService_1.default.paramsValues.push(param);
	            }
	            _this.props.handleChangeValueState(true);
	        };
	        _this.formatValue = function (value) {
	            var text = value.label.trim() + " (" + value.value + ")";
	            return (react_1.default.createElement("div", { style: { whiteSpace: "pre-line", width: "100%" } }, text));
	        };
	        _this.renderButtons = function (subCriterionParam) {
	            return subCriterionParam.parameters
	                .sort(function (p1, p2) { return p1.value - p2.value; })
	                .map(function (param, index) {
	                return react_1.default.createElement(material_ui_1.RadioButton, { key: index, value: param.valueId, label: _this.formatValue(param) });
	            });
	        };
	        _this.renderButtonGroup = function (subCriterionParam) {
	            var selectedValueId = undefined;
	            var param = paramsService_1.default.paramsValues.find(function (p) { return p.parameter.paramId === subCriterionParam.paramId; });
	            if (param) {
	                var selectedValue = subCriterionParam.parameters.find(function (p) { return p.valueId === Number(param.value); });
	                if (selectedValue) {
	                    selectedValueId = selectedValue.valueId;
	                }
	            }
	            return (react_1.default.createElement("div", null,
	                subCriterionParam.name,
	                react_1.default.createElement(material_ui_1.RadioButtonGroup, { name: subCriterionParam.name, valueSelected: selectedValueId, onChange: function (e, selected) { return _this.onSelect(e, selected, subCriterionParam); }, key: subCriterionParam.number }, _this.renderButtons(subCriterionParam))));
	        };
	        return _this;
	    }
	    ParametersSelectForm.prototype.render = function () {
	        var _this = this;
	        return (react_1.default.createElement("div", { style: { marginTop: 20, width: "100%" } }, this.props.subCriterion.parameters.map(function (p) { return _this.renderButtonGroup(p); })));
	    };
	    ParametersSelectForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ParametersSelectForm);
	    return ParametersSelectForm;
	}(react_1.Component));
	exports.default = ParametersSelectForm;


/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var material_ui_1 = __webpack_require__(127);
	var mui_theme_1 = __webpack_require__(119);
	var mobx_react_1 = __webpack_require__(4);
	var criterionDomain_1 = __webpack_require__(573);
	var projectVersionService_1 = tslib_1.__importDefault(__webpack_require__(111));
	var mobx_1 = __webpack_require__(5);
	var subCriterionDomain_1 = __webpack_require__(958);
	var parametersListForm_1 = tslib_1.__importDefault(__webpack_require__(2193));
	var parametersSelectForm_1 = tslib_1.__importDefault(__webpack_require__(2195));
	var paramsService_1 = tslib_1.__importDefault(__webpack_require__(159));
	var projectVersionParamsToolbar_1 = tslib_1.__importDefault(__webpack_require__(2197));
	var gridComp_1 = tslib_1.__importStar(__webpack_require__(44));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var gridsContants_1 = __webpack_require__(121);
	var parametersMultiSelectForm_1 = tslib_1.__importDefault(__webpack_require__(2194));
	var parametersInputsForm_1 = tslib_1.__importDefault(__webpack_require__(2192));
	var projectVersionMaterialExpandComp_1 = tslib_1.__importDefault(__webpack_require__(2211));
	var parametersComplexCriterionForm_1 = tslib_1.__importDefault(__webpack_require__(2191));
	var subCriterionAreaList_1 = tslib_1.__importDefault(__webpack_require__(2241));
	var SidebarCriteriaMenu_1 = tslib_1.__importDefault(__webpack_require__(2189));
	var EvaluationGrid_1 = tslib_1.__importDefault(__webpack_require__(2187));
	var styled_components_1 = tslib_1.__importDefault(__webpack_require__(67));
	var ProjectVersionParamsForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionParamsForm, _super);
	    function ProjectVersionParamsForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            isValueChanged: false
	        };
	        _this.onSelectSubCriterion = function (value, e, tab) {
	            var criterion = paramsService_1.default.selectedCriterion;
	            var subCriterion = criterion.subCriteria.find(function (sc) { return sc.subCriterionId === Number(value); });
	            paramsService_1.default.selectedSubCriterion = subCriterion;
	            console.warn("Selected sub criterion : " + subCriterion.name);
	        };
	        // Rendering second tabs line with sub criteria names
	        _this.renderSubCriteriaTabs = function () {
	            var criterion = paramsService_1.default.selectedCriterion;
	            if (!criterion) {
	                return "";
	            }
	            if (criterion.criterionType === criterionDomain_1.CRITERIONTYPE.COMPLEX) {
	                var tab = (react_1.default.createElement(material_ui_1.Tab, { label: criterion.name, style: {
	                        minHeight: 50,
	                        whiteSpace: "break-spaces",
	                        backgroundColor: '#F9F9F9',
	                        borderRadius: 5,
	                        padding: 10,
	                        boxShadow: " rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px",
	                    }, key: criterion.id, value: criterion.id }, _this.renderComplexSubCriterionForm(criterion)));
	                return (react_1.default.createElement("div", { style: { width: "100%", zIndex: 1 } },
	                    react_1.default.createElement(projectVersionParamsToolbar_1.default, { isValueChanged: _this.state.isValueChanged, handleChangeValueState: _this.handleChangeValueState }),
	                    react_1.default.createElement(material_ui_1.Tabs, { className: "detail-grid", tabTemplate: mui_theme_1.TabTemplate, inkBarStyle: { transition: 'inherit' }, contentContainerStyle: { width: '100%', flexGrow: 1, display: 'flex', minHeight: 50 }, style: { marginTop: 5, marginBottom: 5 }, tabItemContainerStyle: { height: 100 } }, tab)));
	            }
	            // Style for Tab for set height to fix text overrun form Tab element. Tab in HTML is button>div>div>#textNode
	            var StyledTab = (0, styled_components_1.default)(material_ui_1.Tab)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    & div > div {\n      height: fit-content !important;\n    }\n    "], ["\n    & div > div {\n      height: fit-content !important;\n    }\n    "])));
	            var subCriteriaTabArray = criterion.subCriteria.map(function (subCriterion, index) { return (react_1.default.createElement(StyledTab, { label: subCriterion.name, style: {
	                    minHeight: 50,
	                    whiteSpace: "break-spaces",
	                    backgroundColor: '#F9F9F9',
	                    borderRadius: 5,
	                    padding: 10,
	                    boxShadow: "rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px",
	                }, key: index, value: subCriterion.id }, _this.renderSubCriterionForm(subCriterion))); });
	            return (subCriteriaTabArray.length) ? (react_1.default.createElement("div", { style: { width: "75%", zIndex: 1 } },
	                react_1.default.createElement(projectVersionParamsToolbar_1.default, { isValueChanged: _this.state.isValueChanged, handleChangeValueState: _this.handleChangeValueState }),
	                react_1.default.createElement(material_ui_1.Tabs, { className: "detail-grid", tabTemplate: mui_theme_1.TabTemplate, inkBarStyle: { transition: 'inherit' }, contentContainerStyle: { width: '100%', flexGrow: 1, display: 'flex', minHeight: "fit-content" }, style: { marginTop: 5, marginBottom: 5 }, value: paramsService_1.default.selectedSubCriterion.id, onChange: _this.onSelectSubCriterion, tabItemContainerStyle: { height: "fit-content" } }, subCriteriaTabArray))) : '';
	        };
	        _this.handleChangeValueState = function (bool) { _this.setState({ isValueChanged: bool }); };
	        // Rendering form for filling sub criterion
	        _this.renderSubCriterionForm = function (subCriterion) {
	            if (subCriterion.type === subCriterionDomain_1.SUBCRITERIONVALUESTYPE.LIST) {
	                return (react_1.default.createElement(parametersListForm_1.default, { subCriterion: subCriterion, handleChangeValueState: _this.handleChangeValueState }));
	            }
	            if (subCriterion.type === subCriterionDomain_1.SUBCRITERIONVALUESTYPE.SELECT) {
	                return react_1.default.createElement(parametersSelectForm_1.default, { subCriterion: subCriterion, handleChangeValueState: _this.handleChangeValueState });
	            }
	            if (subCriterion.type === subCriterionDomain_1.SUBCRITERIONVALUESTYPE.MULTISELECT) {
	                return react_1.default.createElement(parametersMultiSelectForm_1.default, { subCriterion: subCriterion, handleChangeValueState: _this.handleChangeValueState });
	            }
	            if (subCriterion.type === subCriterionDomain_1.SUBCRITERIONVALUESTYPE.INPUTS) {
	                return react_1.default.createElement(parametersInputsForm_1.default, { subCriterion: subCriterion, handleChangeValueState: _this.handleChangeValueState });
	            }
	            if (subCriterion.type === subCriterionDomain_1.SUBCRITERIONVALUESTYPE.MATERIALS) {
	                var materialsGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_MATERIALS_GRID);
	                console.error(materialsGrid.label);
	                return react_1.default.createElement(gridComp_1.default, { grid: materialsGrid, uiLocation: gridComp_1.UILOCATION.tab, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true, showExpand: true, ExpandComponent: projectVersionMaterialExpandComp_1.default });
	            }
	            if (subCriterion.type === subCriterionDomain_1.SUBCRITERIONVALUESTYPE.ENERGY_CARRIERS) {
	                var grid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_ENERGY_CARRIERS_LIST);
	                console.error(grid.label);
	                return react_1.default.createElement(gridComp_1.default, { grid: grid, uiLocation: gridComp_1.UILOCATION.tab, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true });
	            }
	            if (subCriterion.type === subCriterionDomain_1.SUBCRITERIONVALUESTYPE.AREAS) {
	                var versionId = paramsService_1.default.selectedCriterionVersion.projectVersion.versionId;
	                return react_1.default.createElement(subCriterionAreaList_1.default, { projectVersionId: versionId, subCriterionCode: subCriterion.code });
	            }
	            if (subCriterion.type === subCriterionDomain_1.SUBCRITERIONVALUESTYPE.RECYCLABLE_MATERIALS_GRID) {
	                var materialsGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_RECYCLABLE_MATERIALS_LIST);
	                return react_1.default.createElement(gridComp_1.default, { grid: materialsGrid, uiLocation: gridComp_1.UILOCATION.tab, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true });
	            }
	            if (subCriterion.type === subCriterionDomain_1.SUBCRITERIONVALUESTYPE.EPD_CERTIFIED_MATERIALS_GRID) {
	                var materialsGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_EPD_CERTIFIED_MATERIALS_LIST);
	                return react_1.default.createElement(gridComp_1.default, { grid: materialsGrid, uiLocation: gridComp_1.UILOCATION.tab, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true });
	            }
	            if (subCriterion.type === subCriterionDomain_1.SUBCRITERIONVALUESTYPE.WOOD_BASED_MATERIALS_GRID) {
	                var materialsGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_WOOD_BASED_MATERIALS_GRID);
	                return react_1.default.createElement(gridComp_1.default, { grid: materialsGrid, uiLocation: gridComp_1.UILOCATION.tab, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true });
	            }
	            if (subCriterion.type === subCriterionDomain_1.SUBCRITERIONVALUESTYPE.AREAS_ZELPO_GRID) {
	                var materialsGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_AREA_ZELPO_GRID);
	                return react_1.default.createElement(gridComp_1.default, { grid: materialsGrid, uiLocation: gridComp_1.UILOCATION.tab, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true });
	            }
	            if (subCriterion.type === subCriterionDomain_1.SUBCRITERIONVALUESTYPE.AREAS_ZELZP_GRID) {
	                var materialsGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_AREA_ZELZP_GRID);
	                return react_1.default.createElement(gridComp_1.default, { grid: materialsGrid, uiLocation: gridComp_1.UILOCATION.tab, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true });
	            }
	            if (subCriterion.type === subCriterionDomain_1.SUBCRITERIONVALUESTYPE.AREAS_ZELZF_GRID) {
	                var materialsGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_AREA_ZELZF_GRID);
	                return react_1.default.createElement(gridComp_1.default, { grid: materialsGrid, uiLocation: gridComp_1.UILOCATION.tab, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true });
	            }
	            if (subCriterion.type === subCriterionDomain_1.SUBCRITERIONVALUESTYPE.AREAS_ZELZS_GRID) {
	                var materialsGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_AREA_ZELZS_GRID);
	                return react_1.default.createElement(gridComp_1.default, { grid: materialsGrid, uiLocation: gridComp_1.UILOCATION.tab, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true });
	            }
	            if (subCriterion.type === subCriterionDomain_1.SUBCRITERIONVALUESTYPE.AREAS_ZELST_GRID) {
	                var materialsGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_AREA_ZELST_GRID);
	                return react_1.default.createElement(gridComp_1.default, { grid: materialsGrid, uiLocation: gridComp_1.UILOCATION.tab, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true });
	            }
	            if (subCriterion.type === subCriterionDomain_1.SUBCRITERIONVALUESTYPE.AREAS_VPREP_GRID) {
	                var materialsGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_AREA_VPREP_GRID);
	                return react_1.default.createElement(gridComp_1.default, { grid: materialsGrid, uiLocation: gridComp_1.UILOCATION.tab, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true });
	            }
	            if (subCriterion.type === subCriterionDomain_1.SUBCRITERIONVALUESTYPE.AREAS_PEFKE_GRID) {
	                var materialsGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_AREA_PEFKE_GRID);
	                return react_1.default.createElement(gridComp_1.default, { grid: materialsGrid, uiLocation: gridComp_1.UILOCATION.tab, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true });
	            }
	            return react_1.default.createElement("noscript", null);
	        };
	        _this.renderComplexSubCriterionForm = function (criterion) {
	            return react_1.default.createElement(parametersComplexCriterionForm_1.default, { criterion: criterion, handleChangeValueState: _this.handleChangeValueState });
	        };
	        return _this;
	    }
	    ProjectVersionParamsForm.prototype.componentDidMount = function () {
	        paramsService_1.default.loadResults();
	        paramsService_1.default.loadCriterionVersions();
	    };
	    ProjectVersionParamsForm.prototype.render = function () {
	        return (react_1.default.createElement("div", { style: { width: "100%", minWidth: 768, borderTop: "1px solid #E7E7E7", marginTop: 5 } },
	            react_1.default.createElement("div", { style: { display: "flex", gap: 50, marginTop: 10 } },
	                react_1.default.createElement("div", { style: { backgroundColor: "#F0F0F0", minHeight: "100vh" } },
	                    react_1.default.createElement(SidebarCriteriaMenu_1.default, { isValueChanged: this.state.isValueChanged, handleChangeValueState: this.handleChangeValueState })),
	                react_1.default.createElement("div", { style: { display: "flex", width: "79%", justifyContent: "space-between", gap: 50, } },
	                    this.renderSubCriteriaTabs(),
	                    react_1.default.createElement(EvaluationGrid_1.default, null)))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionParamsForm.prototype, "onSelectSubCriterion", void 0);
	    ProjectVersionParamsForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionParamsForm);
	    return ProjectVersionParamsForm;
	}(react_1.default.Component));
	exports.default = ProjectVersionParamsForm;
	var templateObject_1;


/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var material_ui_1 = __webpack_require__(127);
	var buttons_1 = __webpack_require__(27);
	var locales_1 = __webpack_require__(15);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var mobx_1 = __webpack_require__(5);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var paramsService_1 = tslib_1.__importDefault(__webpack_require__(159));
	var projectVersionService_1 = tslib_1.__importDefault(__webpack_require__(111));
	var mobx_react_1 = __webpack_require__(4);
	var ProjectVersionParamsToolbar = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionParamsToolbar, _super);
	    function ProjectVersionParamsToolbar() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onSave = function () {
	            var newCriteriaVersionName = paramsService_1.default.criterionVersionName;
	            if (!newCriteriaVersionName || newCriteriaVersionName.trim().length === 0
	                || newCriteriaVersionName === paramsService_1.default.selectedCriterionVersion.name) {
	                newCriteriaVersionName = null;
	            }
	            uiService_1.default.showToolbarActionFlag();
	            var criterion = paramsService_1.default.selectedCriterion;
	            var projectVersion = projectVersionService_1.default.projectVersion;
	            var criterionVersion = paramsService_1.default.selectedCriterionVersion;
	            var params = paramsService_1.default.paramsValues.peek();
	            console.warn("Saving params for criterion : " + criterion.code);
	            projectVersionService_1.default.saveProjectVersionValues(projectVersion.versionId, criterion.criterionId, criterionVersion.versionId, newCriteriaVersionName, params).then(function () {
	                console.warn("Saving params success");
	                paramsService_1.default.loadResults();
	                paramsService_1.default.loadCriterionVersions();
	                uiService_1.default.hideToolbarActionFlag();
	                _this.props.handleChangeValueState(false);
	            }).catch(function (error) {
	                console.error(error);
	            });
	        };
	        return _this;
	    }
	    ProjectVersionParamsToolbar.prototype.linkEndGeneratingByBuildingType = function () {
	        var buildingType = projectVersionService_1.default.projectVersion.project.buildingType.value;
	        switch (buildingType) {
	            case 1: {
	                return "bd-vk-1/";
	            }
	            case 2: {
	                return "rd-vk-1/";
	            }
	            case 3: {
	                return "edu-vk-1/";
	            }
	            case 4: {
	                return "ab-vk-1/";
	            }
	            case 5: {
	                return "uni-vk-1/";
	            }
	            default: {
	                break;
	            }
	        }
	    };
	    ProjectVersionParamsToolbar.prototype.render = function () {
	        var criterion = paramsService_1.default.selectedCriterion;
	        var isValueChanged = this.props.isValueChanged;
	        return (react_1.default.createElement(material_ui_1.Toolbar, { style: { top: 40, zIndex: 1, left: 5, right: 5, marginTop: 3, minHeight: 40 } },
	            react_1.default.createElement(material_ui_1.ToolbarGroup, { firstChild: true },
	                react_1.default.createElement("div", { style: {
	                        paddingLeft: 10,
	                        textTransform: "uppercase",
	                    } },
	                    react_1.default.createElement("a", { href: criterion.link + this.linkEndGeneratingByBuildingType(), target: '_blank', style: {
	                            fontSize: "1.5rem",
	                            color: "#000",
	                            textDecoration: 'none'
	                        } },
	                        criterion.type,
	                        ".",
	                        criterion.code,
	                        " ",
	                        criterion.name))),
	            react_1.default.createElement(material_ui_1.ToolbarGroup, { lastChild: true },
	                react_1.default.createElement(buttons_1.ZzFlatButton, { label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Save Criterion"], ["Save Criterion"]))), onClick: this.onSave, disabled: !isValueChanged, style: { backgroundColor: 'PaleGreen' } }))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionParamsToolbar.prototype, "onSave", void 0);
	    ProjectVersionParamsToolbar = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionParamsToolbar);
	    return ProjectVersionParamsToolbar;
	}(react_1.default.Component));
	exports.default = ProjectVersionParamsToolbar;
	var templateObject_1;


/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectVersionCapacitiesFormDefinition = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var validate_1 = __webpack_require__(24);
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var ProjectVersionCapacitiesForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionCapacitiesForm, _super);
	    function ProjectVersionCapacitiesForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ProjectVersionCapacitiesForm.prototype.render = function () {
	        var dataObject = this.props.dataObject;
	        var fields = dataObject.getFormFields(exports.ProjectVersionCapacitiesFormDefinition.formName);
	        var area = fields.area, countOfHousingUnits = fields.countOfHousingUnits, countOfPeople = fields.countOfPeople;
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, area.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: area, value: area.props.value })),
	                react_1.default.createElement("div", { className: "col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, countOfHousingUnits.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: countOfHousingUnits, value: countOfHousingUnits.props.value })),
	                react_1.default.createElement("div", { className: "col-xs-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, countOfPeople.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: countOfPeople, value: countOfPeople.props.value })))));
	    };
	    ProjectVersionCapacitiesForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionCapacitiesForm);
	    return ProjectVersionCapacitiesForm;
	}(react_1.default.Component));
	exports.ProjectVersionCapacitiesFormDefinition = {
	    formName: 'ProjectVersionCapacitiesForm',
	    fields: [
	        { name: 'area', validators: ['IsNumber'] },
	        { name: 'countOfHousingUnits', validators: ['IsNumber'] },
	        { name: 'countOfPeople', validators: ['IsNumber'] },
	    ]
	};
	exports.default = (0, createForm_1.createForm)(exports.ProjectVersionCapacitiesFormDefinition, null)(ProjectVersionCapacitiesForm);


/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var validate_1 = __webpack_require__(24);
	var fields_1 = __webpack_require__(20);
	var blockComp_1 = __webpack_require__(30);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var closedForm_1 = __webpack_require__(82);
	var createForm_1 = __webpack_require__(18);
	var projectDomain_1 = __webpack_require__(575);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var ProjectForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectForm, _super);
	    function ProjectForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.isSchoolTypeValidationNeeded = function (props) {
	            return (props.value && props.value.value == projectDomain_1.BUILDINGTYPE.EDU);
	        };
	        _this.isSchoolTypeFieldDisabled = function (props) {
	            return !(props.value && props.value.value === projectDomain_1.BUILDINGTYPE.EDU);
	        };
	        _this.onChangeBuildingType = function (value) {
	            var dataObject = _this.props.dataObject;
	            var form = dataObject.getForm(definition.formName);
	            form.getField("buildingType").props.onChange(value);
	            if (value === null || value.value !== projectDomain_1.BUILDINGTYPE.EDU) {
	                dataObject.schoolLevel = null;
	                form.updateFieldsPropValue(dataObject, "schoolLevel");
	            }
	        };
	        return _this;
	    }
	    ProjectForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, entities = _a.entities, entity = _a.entity;
	        var fields = dataObject.getFormFields(definition.formName);
	        var name = fields.name, description = fields.description, address = fields.address, cadastralParcelNumber = fields.cadastralParcelNumber, cadastralParcelArea = fields.cadastralParcelArea, documentationCreator = fields.documentationCreator, documentationCreated = fields.documentationCreated, documentationLevel = fields.documentationLevel, evaluator = fields.evaluator, projectCreated = fields.projectCreated, area = fields.area, countOfHousingUnits = fields.countOfHousingUnits, countOfPeople = fields.countOfPeople, buildingType = fields.buildingType, schoolLevel = fields.schoolLevel, cellarCompartment = fields.cellarCompartment, garage = fields.garage, zpkm = fields.zpkm, documentationVersion = fields.documentationVersion, projectEvaluationFinished = fields.projectEvaluationFinished, estimatedCosts = fields.estimatedCosts, anticipatedCommissioning = fields.anticipatedCommissioning, evaluationPhase = fields.evaluationPhase, evaluationType = fields.evaluationType, certified_person = fields.certified_person;
	        var schoolTypeValidation = this.isSchoolTypeValidationNeeded(buildingType.props) ?
	            react_1.default.createElement(validate_1.Validate, { field: schoolLevel, value: schoolLevel.props.value }) : react_1.default.createElement("noscript", null);
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props)),
	                react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value })),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, description.props))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-5" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, address.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: address, value: address.props.value })),
	                react_1.default.createElement("div", { className: "col-xs-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, cadastralParcelArea.props))),
	                react_1.default.createElement("div", { className: "col-xs-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, cadastralParcelNumber.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-2" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, documentationCreator.props))),
	                react_1.default.createElement("div", { className: "col-xs-2" },
	                    react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, documentationCreated.props))),
	                react_1.default.createElement("div", { className: "col-xs-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, documentationLevel.props))),
	                react_1.default.createElement("div", { className: "col-xs-2" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, buildingType.props, { onChange: this.onChangeBuildingType })),
	                    react_1.default.createElement(validate_1.Validate, { field: buildingType, value: buildingType.props.value })),
	                react_1.default.createElement("div", { className: "col-xs-2" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, schoolLevel.props, { disabled: this.isSchoolTypeFieldDisabled(buildingType.props) })),
	                    schoolTypeValidation)),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, evaluator.props))),
	                react_1.default.createElement("div", { className: "col-xs-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, certified_person.props))),
	                react_1.default.createElement("div", { className: "col-xs-6" },
	                    react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, projectCreated.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-1" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, documentationVersion.props))),
	                react_1.default.createElement("div", { className: "col-xs-3" },
	                    react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, projectEvaluationFinished.props))),
	                react_1.default.createElement("div", { className: "col-xs-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, estimatedCosts.props))),
	                react_1.default.createElement("div", { className: "col-xs-4" },
	                    react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, anticipatedCommissioning.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, evaluationPhase.props))),
	                react_1.default.createElement("div", { className: "col-xs-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, evaluationType.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: evaluationType, value: evaluationType.props.value })))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true },
	            react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate }, this.props))));
	    };
	    ProjectForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectForm);
	    return ProjectForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { width: '100%' } },
	        react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields },
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.name.textLabel, value: dataObject.name }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.description.textLabel, value: dataObject.description }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.address.textLabel, value: dataObject.address }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.cadastralParcelNumber.textLabel, value: dataObject.cadastralParcelNumber }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.documentationCreator.textLabel, value: dataObject.documentationCreator }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.documentationLevel.textLabel, value: dataObject.documentationLevel }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.evaluator.textLabel, value: dataObject.evaluator }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.certified_person.textLabel, value: dataObject.certified_person }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.projectCreated.textLabel, value: dataObject.projectCreated }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.buildingType.textLabel, value: dataObject.buildingType }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.schoolLevel.textLabel, value: dataObject.schoolLevel }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.cadastralParcelArea.textLabel, value: dataObject.cadastralParcelArea }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.documentationVersion.textLabel, value: dataObject.documentationVersion }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.projectEvaluationFinished.textLabel, value: dataObject.projectEvaluationFinished }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.estimatedCosts.textLabel, value: dataObject.estimatedCosts }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.anticipatedCommissioning.textLabel, value: dataObject.anticipatedCommissioning }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.evaluationPhase.textLabel, value: dataObject.evaluationPhase }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.evaluationType.textLabel, value: dataObject.evaluationType }))));
	};
	var definition = {
	    formName: 'SbToolProjectForm',
	    fields: [
	        { name: 'name', validators: ['IsRequired'] },
	        { name: 'address', validators: ['IsRequired'] },
	        { name: 'description' },
	        { name: 'cadastralParcelNumber' },
	        { name: 'cadastralParcelArea' },
	        { name: 'documentationCreator' },
	        { name: 'documentationCreated' },
	        { name: 'documentationLevel' },
	        { name: 'evaluator' },
	        { name: 'certified_person' },
	        { name: 'projectCreated' },
	        // {name: 'area',validators: ['IsRequired', 'IsNumber']},
	        // {name: 'countOfHousingUnits',validators: ['IsRequired', 'IsNumber']},
	        // {name: 'countOfPeople',validators: ['IsRequired', 'IsNumber']},
	        { name: 'buildingType', validators: ['IsRequired'] },
	        { name: 'schoolLevel', validators: ['IsRequired'] },
	        // {name : 'cellarCompartment',validators: ['IsRequired']},
	        // {name : 'garage',validators: ['IsRequired']},
	        // {name : 'zpkm',validators: ['IsRequired']},
	        { name: 'documentationVersion' },
	        { name: 'projectEvaluationFinished' },
	        { name: 'estimatedCosts' },
	        { name: 'anticipatedCommissioning' },
	        { name: 'evaluationPhase' },
	        { name: 'evaluationType', validators: ['IsRequired'] }
	    ]
	};
	exports.default = (0, createForm_1.createForm)(definition, ClosedContent)(ProjectForm);


/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectMaterialsFormDefinition = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var validate_1 = __webpack_require__(24);
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var locales_1 = __webpack_require__(15);
	var ProjectMaterialsForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectMaterialsForm, _super);
	    function ProjectMaterialsForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ProjectMaterialsForm.prototype.render = function () {
	        var dataObject = this.props.dataObject;
	        var fields = dataObject.getFormFields(exports.ProjectMaterialsFormDefinition.formName);
	        var density = fields.density, primaryEnergy = fields.primaryEnergy, thermalCoefficient = fields.thermalCoefficient, co2Equivalent = fields.co2Equivalent, so2Equivalent = fields.so2Equivalent, po4Equivalent = fields.po4Equivalent, r11Equivalent = fields.r11Equivalent, c2h4Equivalent = fields.c2h4Equivalent, name = fields.name, code = fields.code, epdcertification = fields.epdcertification, woodBased = fields.woodBased, source = fields.source;
	        console.log('MATERIALS FIELDS', fields);
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-3 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, woodBased.props, { disabled: false, label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Wood based material"], ["Wood based material"]))) }))),
	                react_1.default.createElement("div", { className: "fx col-xs-3 col-sm-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, epdcertification.props, { disabled: woodBased.props.checked })),
	                    react_1.default.createElement(validate_1.Validate, { field: epdcertification, value: epdcertification.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-12" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-1 col-sm-1" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, code.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: code, value: code.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-3 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, density.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: density, value: density.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-3 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, primaryEnergy.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: primaryEnergy, value: primaryEnergy.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-3 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, thermalCoefficient.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: thermalCoefficient, value: thermalCoefficient.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-2 col-sm-2" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, co2Equivalent.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: co2Equivalent, value: co2Equivalent.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-2 col-sm-2" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, so2Equivalent.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: so2Equivalent, value: so2Equivalent.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-2 col-sm-2" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, po4Equivalent.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: po4Equivalent, value: po4Equivalent.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-3 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, r11Equivalent.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: r11Equivalent, value: r11Equivalent.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-3 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, c2h4Equivalent.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: c2h4Equivalent, value: c2h4Equivalent.props.value })))));
	    };
	    ProjectMaterialsForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectMaterialsForm);
	    return ProjectMaterialsForm;
	}(react_1.default.Component));
	exports.ProjectMaterialsFormDefinition = {
	    formName: 'ProjectMaterialsForm',
	    fields: [
	        { name: 'code', validators: ['IsRequired'] },
	        { name: 'name', validators: ['IsRequired'] },
	        { name: 'density', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'primaryEnergy', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'co2Equivalent', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'so2Equivalent', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'po4Equivalent', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'r11Equivalent', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'c2h4Equivalent', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'woodBased' },
	        { name: 'thermalCoefficient', validators: ['IsRequired', 'IsNumber', { validation: 'Min', parameters: { min: 0 } }] },
	        { name: 'epdcertification', validators: ['IsRequired'] },
	        { name: 'source' },
	    ]
	};
	exports.default = (0, createForm_1.createForm)(exports.ProjectMaterialsFormDefinition, null)(ProjectMaterialsForm);
	var templateObject_1;


/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectRunoffCoefficientFormDefinition = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var validate_1 = __webpack_require__(24);
	var createForm_1 = __webpack_require__(18);
	var ProjectVersionRunoffCoefficientForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionRunoffCoefficientForm, _super);
	    function ProjectVersionRunoffCoefficientForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ProjectVersionRunoffCoefficientForm.prototype.render = function () {
	        var dataObject = this.props.dataObject;
	        var fields = dataObject.getFormFields(exports.ProjectRunoffCoefficientFormDefinition.formName);
	        var name = fields.name, lower = fields.lower, between = fields.between, over = fields.over;
	        console.log("runoffCoefficient PROPS", this.props);
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: 'row' },
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, lower.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: lower, value: lower.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, between.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: between, value: between.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, over.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: over, value: over.props.value })))));
	    };
	    ProjectVersionRunoffCoefficientForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionRunoffCoefficientForm);
	    return ProjectVersionRunoffCoefficientForm;
	}(react_1.default.Component));
	exports.ProjectRunoffCoefficientFormDefinition = {
	    formName: 'ProjectVersionRunoffCoefficientForm',
	    fields: [
	        { name: 'name', validators: ['IsRequired'] },
	        { name: 'lower', validators: ['IsNumber', 'IsRequired', { validation: 'Max', parameters: { max: 1 } }] },
	        { name: 'between', validators: ['IsNumber', 'IsRequired', { validation: 'Max', parameters: { max: 1 } }] },
	        { name: 'over', validators: ['IsNumber', 'IsRequired', { validation: 'Max', parameters: { max: 1 } }] },
	    ]
	};
	exports.default = (0, createForm_1.createForm)(exports.ProjectRunoffCoefficientFormDefinition, null)(ProjectVersionRunoffCoefficientForm);


/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectVersionAreaFormDefinition = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var commonDataService_1 = __webpack_require__(41);
	var entityConstants_1 = __webpack_require__(145);
	var fields_1 = __webpack_require__(20);
	var validate_1 = __webpack_require__(24);
	var ProjectVersionAreaForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionAreaForm, _super);
	    function ProjectVersionAreaForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ProjectVersionAreaForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity;
	        var fields = dataObject.getFormFields(exports.ProjectVersionAreaFormDefinition.formName);
	        var area = fields.area, m2 = fields.m2, note = fields.note;
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, area.props, { async: true, clearable: true, asterixForAll: true, loadOptions: commonDataService_1.optionsSearch.bind(this, entityConstants_1.AREA_ENTITY, {}) })),
	                    react_1.default.createElement(validate_1.Validate, { field: area, value: area.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, m2.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: m2, value: m2.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, note.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: note, value: note.props.value })))));
	    };
	    ProjectVersionAreaForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionAreaForm);
	    return ProjectVersionAreaForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { width: '100%' } }));
	};
	exports.ProjectVersionAreaFormDefinition = {
	    formName: 'ProjectVersionAreaForm',
	    fields: [
	        { name: 'area', validators: ['IsRequired'] },
	        { name: 'm2', validators: ['IsRequired', 'IsNumber', { validation: 'Min', parameters: { min: 0 } }] },
	        { name: 'note' }
	    ]
	};
	exports.default = (0, createForm_1.createForm)(exports.ProjectVersionAreaFormDefinition, ClosedContent)(ProjectVersionAreaForm);


/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectVersionDoorFormDefinition = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var formUtils_1 = __webpack_require__(14);
	var fields_1 = __webpack_require__(20);
	var validate_1 = __webpack_require__(24);
	var createForm_1 = __webpack_require__(18);
	var blockComp_1 = __webpack_require__(30);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var closedForm_1 = __webpack_require__(82);
	var statusActiveComp_1 = __webpack_require__(261);
	var commonDataService_1 = __webpack_require__(41);
	var entityConstants_1 = __webpack_require__(145);
	var ProjectVersionDoorForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionDoorForm, _super);
	    function ProjectVersionDoorForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ProjectVersionDoorForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject;
	        var fields = dataObject.getFormFields(exports.ProjectVersionDoorFormDefinition.formName);
	        var name = fields.name, roomTo = fields.roomTo, roomFrom = fields.roomFrom, doorType = fields.doorType, height = fields.height, width = fields.width, reachableOnlyByLadder = fields.reachableOnlyByLadder, threshold = fields.threshold, remoteControl = fields.remoteControl, entranceAtLeast1250mmWide = fields.entranceAtLeast1250mmWide, suitableForHandicapped = fields.suitableForHandicapped, protectedAgainstWheelchair = fields.protectedAgainstWheelchair, lockNotMoreThen1000mmAbove = fields.lockNotMoreThen1000mmAbove, handleNotMoreThen1000mmAbove = fields.handleNotMoreThen1000mmAbove, markedContrastingly = fields.markedContrastingly, frameMaterial = fields.frameMaterial, frameMaterialMass = fields.frameMaterialMass, leafMaterial1 = fields.leafMaterial1, leafMaterial1Mass = fields.leafMaterial1Mass, leafMaterial2 = fields.leafMaterial2, leafMaterial2Mass = fields.leafMaterial2Mass, leafMaterial3 = fields.leafMaterial3, leafMaterial3Mass = fields.leafMaterial3Mass;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-6" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-3 col-sm-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, roomFrom.props, { async: true, asterixForAll: true, loadOptions: commonDataService_1.optionsSearch.bind(this, entityConstants_1.PROJECT_VERSION_ROOM_ENTITY, { projectVersionId: rootObject.versionId }), clearable: true }))),
	                react_1.default.createElement("div", { className: "fx col-xs-3 col-sm-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, roomTo.props, { async: true, asterixForAll: true, loadOptions: commonDataService_1.optionsSearch.bind(this, entityConstants_1.PROJECT_VERSION_ROOM_ENTITY, { projectVersionId: rootObject.versionId }), clearable: true })))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, doorType.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: doorType, value: doorType.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, height.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: height, value: height.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, width.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: width, value: width.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-3 col-sm-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, frameMaterial.props, { async: true, asterixForAll: true, clearable: true, loadOptions: commonDataService_1.optionsSearch.bind(this, entityConstants_1.PROJECT_MATERIAL_ENTITY, { projectVersionId: (0, formUtils_1.lovValue)(dataObject.projectVersion) }) })),
	                    react_1.default.createElement(validate_1.Validate, { field: frameMaterial, value: frameMaterial.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-3 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, frameMaterialMass.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: frameMaterialMass, value: frameMaterialMass.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-3 col-sm-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, leafMaterial1.props, { async: true, asterixForAll: true, clearable: true, loadOptions: commonDataService_1.optionsSearch.bind(this, entityConstants_1.PROJECT_MATERIAL_ENTITY, { projectVersionId: (0, formUtils_1.lovValue)(dataObject.projectVersion) }) })),
	                    react_1.default.createElement(validate_1.Validate, { field: leafMaterial1, value: leafMaterial1.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-3 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, leafMaterial1Mass.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: leafMaterial1Mass, value: leafMaterial1Mass.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-3 col-sm-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, leafMaterial2.props, { async: true, asterixForAll: true, clearable: true, loadOptions: commonDataService_1.optionsSearch.bind(this, entityConstants_1.PROJECT_MATERIAL_ENTITY, { projectVersionId: (0, formUtils_1.lovValue)(dataObject.projectVersion) }) }))),
	                react_1.default.createElement("div", { className: "fx col-xs-3 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, leafMaterial2Mass.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: leafMaterial2Mass, value: leafMaterial2Mass.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-3 col-sm-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, leafMaterial3.props, { async: true, asterixForAll: true, clearable: true, loadOptions: commonDataService_1.optionsSearch.bind(this, entityConstants_1.PROJECT_MATERIAL_ENTITY, { projectVersionId: (0, formUtils_1.lovValue)(dataObject.projectVersion) }) }))),
	                react_1.default.createElement("div", { className: "fx col-xs-3 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, leafMaterial3Mass.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: leafMaterial3Mass, value: leafMaterial3Mass.props.value }))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, reachableOnlyByLadder.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, threshold.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, remoteControl.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, entranceAtLeast1250mmWide.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, suitableForHandicapped.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, protectedAgainstWheelchair.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, lockNotMoreThen1000mmAbove.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, handleNotMoreThen1000mmAbove.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, markedContrastingly.props))))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true }, openContent));
	    };
	    ProjectVersionDoorForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionDoorForm);
	    return ProjectVersionDoorForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { width: '100%' } },
	        react_1.default.createElement("div", { style: { display: 'flex' } },
	            disabled ? null : react_1.default.createElement(statusActiveComp_1.StatusActiveComp, { activeObject: dataObject, entity: entity, id: dataObject.doorId }),
	            react_1.default.createElement("h5", { style: statusActiveComp_1.StatusActiveComp__h5_style },
	                " ",
	                dataObject.name,
	                " ")),
	        react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields },
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.name.textLabel, value: dataObject.name }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.roomFrom.textLabel, value: dataObject.roomFrom }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.roomTo.textLabel, value: dataObject.roomTo }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.doorType.textLabel, value: dataObject.doorType }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.height.textLabel, value: dataObject.height }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.width.textLabel, value: dataObject.width }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.reachableOnlyByLadder.textLabel, value: dataObject.reachableOnlyByLadder }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.threshold.textLabel, value: dataObject.threshold }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.remoteControl.textLabel, value: dataObject.remoteControl }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.entranceAtLeast1250mmWide.textLabel, value: dataObject.entranceAtLeast1250mmWide }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.suitableForHandicapped.textLabel, value: dataObject.suitableForHandicapped }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.protectedAgainstWheelchair.textLabel, value: dataObject.protectedAgainstWheelchair }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.lockNotMoreThen1000mmAbove.textLabel, value: dataObject.lockNotMoreThen1000mmAbove }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.handleNotMoreThen1000mmAbove.textLabel, value: dataObject.handleNotMoreThen1000mmAbove }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.markedContrastingly.textLabel, value: dataObject.markedContrastingly }))));
	};
	exports.ProjectVersionDoorFormDefinition = {
	    formName: 'ProjectVersionDoorForm',
	    fields: [
	        { name: 'name', validators: ['IsRequired'] },
	        { name: 'roomFrom' },
	        { name: 'roomTo' },
	        { name: 'doorType', validators: ['IsRequired'] },
	        { name: 'height', validators: ['IsRequired'] },
	        { name: 'width', validators: ['IsRequired'] },
	        { name: 'frameMaterial', validators: ['IsRequired'] },
	        { name: 'frameMaterialMass', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'leafMaterial1', validators: ['IsRequired'] },
	        { name: 'leafMaterial1Mass', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'leafMaterial2' },
	        { name: 'leafMaterial2Mass', validators: ['IsNumber'] },
	        { name: 'leafMaterial3' },
	        { name: 'leafMaterial3Mass', validators: ['IsNumber'] },
	        { name: 'reachableOnlyByLadder' },
	        { name: 'threshold' },
	        { name: 'remoteControl' },
	        { name: 'entranceAtLeast1250mmWide' },
	        { name: 'suitableForHandicapped' },
	        { name: 'protectedAgainstWheelchair' },
	        { name: 'lockNotMoreThen1000mmAbove' },
	        { name: 'handleNotMoreThen1000mmAbove' },
	        { name: 'markedContrastingly' },
	    ]
	};
	exports.default = (0, createForm_1.createForm)(exports.ProjectVersionDoorFormDefinition, ClosedContent)(ProjectVersionDoorForm);


/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var locales_1 = __webpack_require__(15);
	var ProjectVersionDoorMaterialExpandComp = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionDoorMaterialExpandComp, _super);
	    function ProjectVersionDoorMaterialExpandComp() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ProjectVersionDoorMaterialExpandComp.prototype.render = function () {
	        var item = this.props.item;
	        var door = item.rowObject;
	        return (react_1.default.createElement("div", null,
	            door.frameMaterial &&
	                react_1.default.createElement("div", null,
	                    react_1.default.createElement("p", null, locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Frame material"], ["Frame material"])))),
	                    react_1.default.createElement("ul", null,
	                        react_1.default.createElement("li", null,
	                            door.frameMaterial.label,
	                            " : ",
	                            door.frameMaterialMass,
	                            " kg"))),
	            (door.leafMaterial1 || door.leafMaterial2 || door.leafMaterial3) &&
	                react_1.default.createElement("div", null,
	                    react_1.default.createElement("p", null, locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Leaf materials"], ["Leaf materials"])))),
	                    react_1.default.createElement("ul", null,
	                        door.leafMaterial1 && react_1.default.createElement("li", null,
	                            door.leafMaterial1.label,
	                            " : ",
	                            door.leafMaterial1Mass,
	                            " kg"),
	                        door.leafMaterial2 && react_1.default.createElement("li", null,
	                            door.leafMaterial2.label,
	                            " : ",
	                            door.leafMaterial2Mass,
	                            " kg"),
	                        door.leafMaterial3 && react_1.default.createElement("li", null,
	                            door.leafMaterial3.label,
	                            " : ",
	                            door.leafMaterial3Mass,
	                            " kg")))));
	    };
	    ProjectVersionDoorMaterialExpandComp = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionDoorMaterialExpandComp);
	    return ProjectVersionDoorMaterialExpandComp;
	}(react_1.default.Component));
	exports.default = ProjectVersionDoorMaterialExpandComp;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectVersionEnergyCarrierFormDefinition = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var validate_1 = __webpack_require__(24);
	var fields_1 = __webpack_require__(20);
	var closedForm_1 = __webpack_require__(82);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var commonDataService_1 = __webpack_require__(41);
	var entityConstants_1 = __webpack_require__(145);
	var ProjectVersionEnergyCarrierForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionEnergyCarrierForm, _super);
	    function ProjectVersionEnergyCarrierForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ProjectVersionEnergyCarrierForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity;
	        var fields = dataObject.getFormFields(exports.ProjectVersionEnergyCarrierFormDefinition.formName);
	        var originalEnergyCarrier = fields.originalEnergyCarrier, energyConsumption = fields.energyConsumption, type = fields.type;
	        console.log("ProjectVersionEnergyCarrierForm props", this.props);
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, originalEnergyCarrier.props, { async: true, asterixForAll: true, loadOptions: commonDataService_1.optionsSearch.bind(this, entityConstants_1.ENERGY_CARRIER_ENTITY, {}), clearable: true })),
	                    react_1.default.createElement(validate_1.Validate, { field: originalEnergyCarrier, value: originalEnergyCarrier.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, type.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: type, value: type.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, energyConsumption.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: energyConsumption, value: energyConsumption.props.value })))));
	    };
	    ProjectVersionEnergyCarrierForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionEnergyCarrierForm);
	    return ProjectVersionEnergyCarrierForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { width: '100%' } },
	        react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields },
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.originalEnergyCarrier.textLabel, value: dataObject.originalEnergyCarrier }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.type.textLabel, value: dataObject.type }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.energyConsumption.textLabel, value: dataObject.energyConsumption }))));
	};
	exports.ProjectVersionEnergyCarrierFormDefinition = {
	    formName: 'ProjectEnergyCarrierForm',
	    fields: [{
	            name: 'type',
	            validators: ['IsRequired']
	        }, {
	            name: 'energyConsumption',
	            validators: ['IsRequired', 'IsNumber']
	        }, {
	            name: 'originalEnergyCarrier',
	            validators: ['IsRequired']
	        }]
	};
	exports.default = (0, createForm_1.createForm)(exports.ProjectVersionEnergyCarrierFormDefinition, ClosedContent)(ProjectVersionEnergyCarrierForm);


/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var validate_1 = __webpack_require__(24);
	var fields_1 = __webpack_require__(20);
	var blockComp_1 = __webpack_require__(30);
	var activeItem_1 = tslib_1.__importDefault(__webpack_require__(54));
	var closedForm_1 = __webpack_require__(82);
	var createForm_1 = __webpack_require__(18);
	var ProjectVersionForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionForm, _super);
	    function ProjectVersionForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ProjectVersionForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity;
	        var fields = dataObject.getFormFields(definition.formName);
	        var version = fields.version, description = fields.description, firstComment = fields.firstComment, secondComment = fields.secondComment, thirdComment = fields.thirdComment, fourthComment = fields.fourthComment;
	        var openContent = (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: 'fx col-xs-2 col-sm-2' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, version.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: version, value: version.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-10 col-sm-10' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, description.props)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, firstComment.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: firstComment, value: firstComment.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, secondComment.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: secondComment, value: secondComment.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, thirdComment.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: thirdComment, value: thirdComment.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, fourthComment.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: fourthComment, value: fourthComment.props.value })))));
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true, style: { margin: 0 } },
	            react_1.default.createElement(activeItem_1.default, tslib_1.__assign({ closedStyle: { padding: "0 10px" }, openContent: openContent, closedContent: react_1.default.createElement(ClosedContent, { dataObject: dataObject, entity: entity, entities: entities, fields: fields }), validate: this.props.validate }, this.props))));
	    };
	    ProjectVersionForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionForm);
	    return ProjectVersionForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { width: '100%' } },
	        react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields, style: { display: "flex", flexDirection: "column" } },
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.version.textLabel, value: dataObject.version }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.description.textLabel, value: dataObject.description }))));
	};
	var definition = {
	    formName: 'ProjectVersionForm',
	    fields: [
	        {
	            name: 'version',
	            validators: ['IsRequired', { validation: 'HasLength', parameters: { min: 1, max: 5 } }, 'IsNumber']
	        },
	        {
	            name: 'description',
	        },
	        {
	            name: 'firstComment',
	            validators: [{ validation: 'HasLength', parameters: { min: 1, max: 35 } }]
	        },
	        {
	            name: 'secondComment',
	            validators: [{ validation: 'HasLength', parameters: { min: 1, max: 35 } }]
	        },
	        {
	            name: 'thirdComment',
	            validators: [{ validation: 'HasLength', parameters: { min: 1, max: 35 } }]
	        },
	        {
	            name: 'fourthComment',
	            validators: [{ validation: 'HasLength', parameters: { min: 1, max: 35 } }]
	        },
	    ]
	};
	exports.default = (0, createForm_1.createForm)(definition, ClosedContent)(ProjectVersionForm);


/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectVersionLifespanFormDefinition = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var validate_1 = __webpack_require__(24);
	var createForm_1 = __webpack_require__(18);
	var ProjectVersionLifespanForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionLifespanForm, _super);
	    function ProjectVersionLifespanForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ProjectVersionLifespanForm.prototype.render = function () {
	        var dataObject = this.props.dataObject;
	        var fields = dataObject.getFormFields(exports.ProjectVersionLifespanFormDefinition.formName);
	        var groupName = fields.groupName, subgroupName = fields.subgroupName, elementName = fields.elementName, minimalLifespan = fields.minimalLifespan, maximalLifespan = fields.maximalLifespan, averageLifespan = fields.averageLifespan;
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: 'row' },
	                react_1.default.createElement("div", { className: 'fx col-xs-6 col-sm-6' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, groupName.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: groupName, value: groupName.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-6 col-sm-6' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, subgroupName.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: subgroupName, value: subgroupName.props.value })))));
	    };
	    ProjectVersionLifespanForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionLifespanForm);
	    return ProjectVersionLifespanForm;
	}(react_1.default.Component));
	exports.ProjectVersionLifespanFormDefinition = {
	    formName: 'ProjectVersionLifespanForm',
	    fields: [
	        { name: 'groupName' },
	        { name: 'subgroupName' },
	        { name: 'elementName' },
	        { name: 'minimalLifespan' },
	        { name: 'maximalLifespan' },
	        { name: 'averageLifespan' },
	    ]
	};
	exports.default = (0, createForm_1.createForm)(exports.ProjectVersionLifespanFormDefinition, null)(ProjectVersionLifespanForm);


/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectVersionLopFillingsFormDefinition = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var formUtils_1 = __webpack_require__(14);
	var fields_1 = __webpack_require__(20);
	var validate_1 = __webpack_require__(24);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var commonDataService_1 = __webpack_require__(41);
	var entityConstants_1 = __webpack_require__(145);
	var ProjectVersionLopFillingsForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionLopFillingsForm, _super);
	    function ProjectVersionLopFillingsForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ProjectVersionLopFillingsForm.prototype.render = function () {
	        var dataObject = this.props.dataObject;
	        var fields = dataObject.getFormFields(exports.ProjectVersionLopFillingsFormDefinition.formName);
	        var name = fields.name, width = fields.width, height = fields.height, glazingArea = fields.glazingArea, glazingMaterial = fields.glazingMaterial, glazingMass = fields.glazingMass, floorLevel = fields.floorLevel, reachableByLadder = fields.reachableByLadder, enduranceClass = fields.enduranceClass, acousticIsolation = fields.acousticIsolation, partiesOrientation = fields.partiesOrientation, angleAlpha = fields.angleAlpha, angleBeta = fields.angleBeta, angleGama = fields.angleGama, angleDelta = fields.angleDelta, angleEpsilon = fields.angleEpsilon, angleZeta = fields.angleZeta, angleEta = fields.angleEta, angleShieldingZ = fields.angleShieldingZ;
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: 'row' },
	                react_1.default.createElement("div", { className: 'fx col-xs-4 col-sm-4' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-2 col-sm-2' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, width.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: width, value: width.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-2 col-sm-2' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, height.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: height, value: height.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-2 col-sm-2' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, glazingArea.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: glazingArea, value: glazingArea.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-2 col-sm-2' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, glazingMass.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: glazingMass, value: glazingMass.props.value }))),
	            react_1.default.createElement("div", { className: 'row' },
	                react_1.default.createElement("div", { className: 'fx col-xs-2 col-sm-2' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, floorLevel.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: floorLevel, value: floorLevel.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-2 col-sm-2' },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, enduranceClass.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: enduranceClass, value: enduranceClass.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-4 col-sm-4' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, acousticIsolation.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: acousticIsolation, value: acousticIsolation.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-4 col-sm-4' },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, glazingMaterial.props, { async: true, asterixForAll: true, clearable: true, loadOptions: commonDataService_1.optionsSearch.bind(this, entityConstants_1.PROJECT_MATERIAL_ENTITY, { projectVersionId: (0, formUtils_1.lovValue)(dataObject.projectVersion) }) })),
	                    react_1.default.createElement(validate_1.Validate, { field: glazingMaterial, value: glazingMaterial.props.value }))),
	            react_1.default.createElement("div", { className: 'row' },
	                react_1.default.createElement("div", { className: 'fx col-xs-4 col-sm-4' },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, partiesOrientation.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: partiesOrientation, value: partiesOrientation.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-4 col-sm-4' },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, reachableByLadder.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: reachableByLadder, value: reachableByLadder.props.value }))),
	            react_1.default.createElement("div", { className: 'row' },
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, angleAlpha.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: angleAlpha, value: angleAlpha.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, angleBeta.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: angleBeta, value: angleBeta.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, angleGama.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: angleGama, value: angleGama.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, angleDelta.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: angleDelta, value: angleDelta.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, angleEpsilon.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: angleEpsilon, value: angleEpsilon.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, angleZeta.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: angleZeta, value: angleZeta.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, angleEta.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: angleEta, value: angleEta.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, angleShieldingZ.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: angleShieldingZ, value: angleShieldingZ.props.value })))));
	    };
	    ProjectVersionLopFillingsForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionLopFillingsForm);
	    return ProjectVersionLopFillingsForm;
	}(react_1.default.Component));
	exports.ProjectVersionLopFillingsFormDefinition = {
	    formName: 'ProjectVersionLopFillingsForm',
	    fields: [
	        { name: 'name', validators: ['IsRequired'] },
	        { name: 'width', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'height', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'glazingArea', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'glazingMaterial', validators: ['IsRequired'] },
	        { name: 'glazingMass', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'floorLevel', validators: ['IsRequired'] },
	        { name: 'reachableByLadder' },
	        { name: 'enduranceClass', validators: ['IsRequired'] },
	        { name: 'acousticIsolation', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'partiesOrientation' },
	        { name: 'angleAlpha', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'angleBeta', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'angleGama', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'angleDelta', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'angleEpsilon', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'angleZeta', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'angleEta', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'angleShieldingZ', validators: ['IsRequired', 'IsNumber'] },
	    ]
	};
	exports.default = (0, createForm_1.createForm)(exports.ProjectVersionLopFillingsFormDefinition, null)(ProjectVersionLopFillingsForm);


/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var locales_1 = __webpack_require__(15);
	var ProjectVersionLopMaterialExpandComp = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionLopMaterialExpandComp, _super);
	    function ProjectVersionLopMaterialExpandComp() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ProjectVersionLopMaterialExpandComp.prototype.render = function () {
	        var item = this.props.item;
	        var lop = item.rowObject;
	        var frameMaterial1 = lop.frameMaterial1, frameMaterial1Mass = lop.frameMaterial1Mass, frameMaterial2 = lop.frameMaterial2, frameMaterial2Mass = lop.frameMaterial2Mass, frameMaterial3 = lop.frameMaterial3, frameMaterial3Mass = lop.frameMaterial3Mass, frameMaterial4 = lop.frameMaterial4, frameMaterial4Mass = lop.frameMaterial4Mass, frameMaterial5 = lop.frameMaterial5, frameMaterial5Mass = lop.frameMaterial5Mass, glazingMaterial = lop.glazingMaterial, glazingMaterialMass = lop.glazingMaterialMass;
	        return (react_1.default.createElement("div", null,
	            frameMaterial1 &&
	                react_1.default.createElement("div", null,
	                    react_1.default.createElement("p", null, locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["LOP frame material"], ["LOP frame material"])))),
	                    react_1.default.createElement("ul", null,
	                        frameMaterial1 && frameMaterial1Mass &&
	                            react_1.default.createElement("li", null,
	                                frameMaterial1.label,
	                                " : ",
	                                frameMaterial1Mass,
	                                " kg"),
	                        frameMaterial2 && frameMaterial2Mass &&
	                            react_1.default.createElement("li", null,
	                                frameMaterial2.label,
	                                " : ",
	                                frameMaterial2Mass,
	                                " kg"),
	                        frameMaterial3 && frameMaterial3Mass &&
	                            react_1.default.createElement("li", null,
	                                frameMaterial3.label,
	                                " : ",
	                                frameMaterial3Mass,
	                                " kg"),
	                        frameMaterial4 && frameMaterial4Mass &&
	                            react_1.default.createElement("li", null,
	                                frameMaterial4.label,
	                                " : ",
	                                frameMaterial4Mass,
	                                " kg"),
	                        frameMaterial5 && frameMaterial5Mass &&
	                            react_1.default.createElement("li", null,
	                                frameMaterial5.label,
	                                " : ",
	                                frameMaterial5Mass,
	                                " kg"))),
	            glazingMaterial && glazingMaterialMass &&
	                react_1.default.createElement("div", null,
	                    react_1.default.createElement("p", null, locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["LOP glazing material"], ["LOP glazing material"])))),
	                    react_1.default.createElement("ul", null,
	                        react_1.default.createElement("li", null,
	                            glazingMaterial.label,
	                            " : ",
	                            glazingMaterialMass,
	                            " kg")))));
	    };
	    ProjectVersionLopMaterialExpandComp = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionLopMaterialExpandComp);
	    return ProjectVersionLopMaterialExpandComp;
	}(react_1.default.Component));
	exports.default = ProjectVersionLopMaterialExpandComp;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectVersionLopProfilesFormDefinition = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var formUtils_1 = __webpack_require__(14);
	var fields_1 = __webpack_require__(20);
	var validate_1 = __webpack_require__(24);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var commonDataService_1 = __webpack_require__(41);
	var entityConstants_1 = __webpack_require__(145);
	var createForm_1 = __webpack_require__(18);
	var ProjectVersionLopProfilesForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionLopProfilesForm, _super);
	    function ProjectVersionLopProfilesForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ProjectVersionLopProfilesForm.prototype.render = function () {
	        var dataObject = this.props.dataObject;
	        var fields = dataObject.getFormFields(exports.ProjectVersionLopProfilesFormDefinition.formName);
	        var type = fields.type, length = fields.length, profileDescription = fields.profileDescription, frameMaterial1 = fields.frameMaterial1, frameMaterialMass1 = fields.frameMaterialMass1, frameMaterial2 = fields.frameMaterial2, frameMaterialMass2 = fields.frameMaterialMass2, frameMaterial3 = fields.frameMaterial3, frameMaterialMass3 = fields.frameMaterialMass3;
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: 'row' },
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, length.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: length, value: length.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, type.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: type, value: type.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-6 col-sm-6' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, profileDescription.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: profileDescription, value: profileDescription.props.value }))),
	            react_1.default.createElement("div", { className: 'row' },
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, frameMaterial1.props, { async: true, asterixForAll: true, clearable: true, loadOptions: commonDataService_1.optionsSearch.bind(this, entityConstants_1.PROJECT_MATERIAL_ENTITY, { projectVersionId: (0, formUtils_1.lovValue)(dataObject.projectVersion) }) })),
	                    react_1.default.createElement(validate_1.Validate, { field: frameMaterial1, value: frameMaterial1.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, frameMaterialMass1.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: frameMaterialMass1, value: frameMaterialMass1.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, frameMaterial2.props, { async: true, asterixForAll: true, clearable: true, loadOptions: commonDataService_1.optionsSearch.bind(this, entityConstants_1.PROJECT_MATERIAL_ENTITY, { projectVersionId: (0, formUtils_1.lovValue)(dataObject.projectVersion) }) })),
	                    react_1.default.createElement(validate_1.Validate, { field: frameMaterial2, value: frameMaterial2.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, frameMaterialMass2.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: frameMaterialMass2, value: frameMaterialMass2.props.value }))),
	            react_1.default.createElement("div", { className: 'row' },
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, frameMaterial3.props, { async: true, asterixForAll: true, clearable: true, loadOptions: commonDataService_1.optionsSearch.bind(this, entityConstants_1.PROJECT_MATERIAL_ENTITY, { projectVersionId: (0, formUtils_1.lovValue)(dataObject.projectVersion) }) })),
	                    react_1.default.createElement(validate_1.Validate, { field: frameMaterial3, value: frameMaterial3.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-3 col-sm-3' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, frameMaterialMass3.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: frameMaterialMass3, value: frameMaterialMass3.props.value })))));
	    };
	    ProjectVersionLopProfilesForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionLopProfilesForm);
	    return ProjectVersionLopProfilesForm;
	}(react_1.default.Component));
	exports.ProjectVersionLopProfilesFormDefinition = {
	    formName: 'ProjectVersionLopProfilesForm',
	    fields: [
	        { name: 'type', validators: ['IsRequired'] },
	        { name: 'length', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'profileDescription', validators: ['IsRequired'] },
	        { name: 'frameMaterial1', validators: ['IsRequired'] },
	        { name: 'frameMaterialMass1', validators: ['IsNumber'] },
	        { name: 'frameMaterial2' },
	        { name: 'frameMaterialMass2', validators: ['IsNumber'] },
	        { name: 'frameMaterial3' },
	        { name: 'frameMaterialMass3', validators: ['IsNumber'] },
	    ]
	};
	exports.default = (0, createForm_1.createForm)(exports.ProjectVersionLopProfilesFormDefinition, null)(ProjectVersionLopProfilesForm);


/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var ProjectVersionMaterialExpandComp = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionMaterialExpandComp, _super);
	    function ProjectVersionMaterialExpandComp() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.fieldsRow1 = ['code', 'name', 'originalMaterial'];
	        _this.fieldsRow2 = ['volume', 'lifespan', 'area'];
	        _this.fieldsRow3 = ['primaryEnergy', 'lifespan', 'comment'];
	        _this.fieldsRow4 = ['co2Equivalent', 'so2Equivalent', 'po4Equivalent'];
	        _this.fieldsRow5 = ['r11Equivalent', 'c2h4Equivalent', 'thermalCoefficient'];
	        _this.fieldsRow6 = ['renewableWeight', 'recycledWeight', 'regionallyMadeWeight'];
	        _this.fieldsRow7 = ['epdcertification', 'pefcCertificationWeight', 'pefcRequestWeight'];
	        _this.fieldRows = [_this.fieldsRow1, _this.fieldsRow2, _this.fieldsRow3, _this.fieldsRow4, _this.fieldsRow5, _this.fieldsRow6, _this.fieldsRow7];
	        _this.getFormattedValue = function (field) {
	            var material = _this.props.item.rowObject;
	            if (field.fieldName === 'originalMaterial') {
	                return material.originalMaterial.label;
	            }
	            var value = material[field.fieldName];
	            if (value === undefined) {
	                return "-";
	            }
	            return field.formatValue(value);
	        };
	        _this.renderCell = function (field) {
	            return (react_1.default.createElement("div", { className: "fx col-xs-4" },
	                react_1.default.createElement("div", { className: "item-label", key: field.label },
	                    field.label,
	                    ": "),
	                _this.getFormattedValue(field)));
	        };
	        _this.renderRow = function (columnsNames) {
	            var material = _this.props.item.rowObject;
	            var fields = material.$mdEntityRef.getFields();
	            var cells = [];
	            var _loop_1 = function (column) {
	                var field = fields.find(function (f) { return f.fieldName === column; });
	                cells.push(_this.renderCell(field));
	            };
	            for (var _i = 0, columnsNames_1 = columnsNames; _i < columnsNames_1.length; _i++) {
	                var column = columnsNames_1[_i];
	                _loop_1(column);
	            }
	            return (react_1.default.createElement("div", { className: "row" }, cells));
	        };
	        return _this;
	    }
	    ProjectVersionMaterialExpandComp.prototype.render = function () {
	        var rows = [];
	        for (var _i = 0, _a = this.fieldRows; _i < _a.length; _i++) {
	            var row = _a[_i];
	            rows.push(this.renderRow(row));
	        }
	        return (react_1.default.createElement("div", { style: { paddingLeft: 25, marginBottom: 25 } }, rows));
	    };
	    ProjectVersionMaterialExpandComp = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionMaterialExpandComp);
	    return ProjectVersionMaterialExpandComp;
	}(react_1.default.Component));
	exports.default = ProjectVersionMaterialExpandComp;


/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectVersionMaterialFormDefinition = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var ProjectVersionMaterialForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionMaterialForm, _super);
	    function ProjectVersionMaterialForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // @observable custom : boolean = false;
	    //
	    // constructor(props: FormProps<ProjectVersionMaterial, ProjectVersion>, context: any) {
	    //   super(props, context);
	    //
	    //   reaction(
	    //     () => this.props.dataObject.woodBased,
	    //     woodBased => {
	    //       const form = props.dataObject.getForm(ProjectVersionMaterialFormDefinition.formName);
	    //       if (woodBased) {
	    //         props.dataObject.epdcertification = {label: "Certifikát není", value: EPDCERTIFICATION.NO_CERTIFICATION};
	    //         props.dataObject.epdCertificationWeight = undefined;
	    //         form.updateFieldsPropValue(props.dataObject, 'epdcertification', 'epdCertificationWeight');
	    //       }
	    //       else {
	    //         props.dataObject.fscRequestWeight = undefined;
	    //         props.dataObject.fscCertificationWeight = undefined;
	    //         props.dataObject.pefcRequestWeight = undefined;
	    //         props.dataObject.pefcCertificationWeight = undefined;
	    //         form.updateFieldsPropValue(props.dataObject, 'fscRequestWeight', 'fscCertificationWeight', 'pefcRequestWeight', 'pefcCertificationWeight');
	    //       }
	    //     }
	    //   );
	    //
	    //   reaction(
	    //     () => this.props.dataObject.epdcertification,
	    //     epdcertification => {
	    //       const form = props.dataObject.getForm(ProjectVersionMaterialFormDefinition.formName);
	    //       if (epdcertification && epdcertification.value !== EPDCERTIFICATION.NO_CERTIFICATION) {
	    //         props.dataObject.woodBased = false;
	    //         props.dataObject.pefcCertificationWeight = undefined;
	    //         props.dataObject.pefcRequestWeight = undefined;
	    //         props.dataObject.fscCertificationWeight = undefined;
	    //         props.dataObject.fscRequestWeight = undefined;
	    //         form.updateFieldsPropValue(props.dataObject, 'epdcertification', 'epdCertificationWeight');
	    //       }
	    //     }
	    //   );
	    //
	    // }
	    //
	    // @action onChangeCustom = (event: React.MouseEvent<{}>, checked: boolean) => {
	    //   let {dataObject} = this.props;
	    //   this.custom = checked;
	    //
	    //   if (checked === false) {
	    //     this.fillFieldsFromOriginal(dataObject.originalMaterial);
	    //   }
	    // };
	    //
	    // @action onChangeOriginal = (e) => {
	    //   let {dataObject} = this.props;
	    //   let form = dataObject.getForm(ProjectVersionMaterialFormDefinition.formName);
	    //   form.getField("originalMaterial").props.onChange(e);
	    //   this.fillFieldsFromOriginal(dataObject.originalMaterial);
	    // };
	    //
	    // @action onChangeUsageGroup = (e) => {
	    //   let {dataObject} = this.props;
	    //   let form = dataObject.getForm(ProjectVersionMaterialFormDefinition.formName);
	    //   form.getField("materialUsageGroup").props.onChange(e)
	    // };
	    //
	    //
	    // fillFieldsFromOriginal = (original : LovItem<Material>) => {
	    //   let {dataObject} = this.props;
	    //
	    //   if (!original) {
	    //     return;
	    //   }
	    //
	    //   materialsService.getMaterialById(Number(original.value)).then(
	    //     response => {
	    //       const originalMaterial = response;
	    //       if (originalMaterial) {
	    //         dataObject.code = originalMaterial.code;
	    //         dataObject.name = originalMaterial.name;
	    //         dataObject.density = originalMaterial.density;
	    //         dataObject.thermalCoefficient = originalMaterial.thermalCoefficient;
	    //         dataObject.primaryEnergy = originalMaterial.primaryEnergy;
	    //         dataObject.co2Equivalent = originalMaterial.co2Equivalent;
	    //         dataObject.so2Equivalent = originalMaterial.so2Equivalent;
	    //         dataObject.po4Equivalent = originalMaterial.po4Equivalent;
	    //         dataObject.r11Equivalent = originalMaterial.r11Equivalent;
	    //         dataObject.c2h4Equivalent = originalMaterial.c2h4Equivalent;
	    //         dataObject.healthSafetyRequirement = originalMaterial.healthSafetyRequirement;
	    //         dataObject.epdcertification = originalMaterial.epdcertification;
	    //
	    //         const form = dataObject.getForm(ProjectVersionMaterialFormDefinition.formName);
	    //         form.updateFieldsPropValue(dataObject, "code", "name", "density", "thermalCoefficient",
	    //           "primaryEnergy", "co2Equivalent", "so2Equivalent", "po4Equivalent", "r11Equivalent", "c2h4Equivalent", "healthSafetyRequirement", "epdcertification");
	    //       }
	    //     }
	    //   );
	    // };
	    ProjectVersionMaterialForm.prototype.render = function () {
	        var dataObject = this.props.dataObject;
	        var fields = dataObject.getFormFields(exports.ProjectVersionMaterialFormDefinition.formName);
	        var name = fields.name, materialUsageGroup = fields.materialUsageGroup, mass = fields.mass;
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-4 col-sm-4" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-6" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, materialUsageGroup.props))),
	                react_1.default.createElement("div", { className: "fx col-xs-2 col-sm-2" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, mass.props))))));
	    };
	    ProjectVersionMaterialForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionMaterialForm);
	    return ProjectVersionMaterialForm;
	}(react_1.default.Component));
	exports.ProjectVersionMaterialFormDefinition = {
	    formName: 'ProjectVersionMaterialForm',
	    fields: [
	        { name: 'name', validators: ['IsRequired'] },
	        { name: 'materialUsageGroup', validators: ['IsRequired'] },
	        { name: 'mass', validators: ['IsRequired', 'IsNumber'] },
	    ]
	};
	exports.default = (0, createForm_1.createForm)(exports.ProjectVersionMaterialFormDefinition, null)(ProjectVersionMaterialForm);


/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectVersionParkingFormDefinition = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var validate_1 = __webpack_require__(24);
	var createForm_1 = __webpack_require__(18);
	var ProjectVersionParkingForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionParkingForm, _super);
	    function ProjectVersionParkingForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ProjectVersionParkingForm.prototype.render = function () {
	        var dataObject = this.props.dataObject;
	        var fields = dataObject.getFormFields(exports.ProjectVersionParkingFormDefinition.formName);
	        var parkingName = fields.parkingName, value = fields.value, controlledCo = fields.controlledCo, chargingStations = fields.chargingStations, carsharing = fields.carsharing;
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: 'row' },
	                react_1.default.createElement("div", { className: 'fx col-xs-6 col-sm-6' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, parkingName.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: parkingName, value: parkingName.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-6 col-sm-6' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, value.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: value, value: value.props.value }))),
	            react_1.default.createElement("div", { className: 'row' },
	                react_1.default.createElement("div", { className: 'fx col-xs-4 col-sm-4' },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, controlledCo.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: controlledCo, value: controlledCo.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-4 col-sm-4' },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, chargingStations.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: chargingStations, value: chargingStations.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-4 col-sm-4' },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, carsharing.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: carsharing, value: carsharing.props.value })))));
	    };
	    ProjectVersionParkingForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionParkingForm);
	    return ProjectVersionParkingForm;
	}(react_1.default.Component));
	exports.ProjectVersionParkingFormDefinition = {
	    formName: 'ProjectVersionParkingForm',
	    fields: [
	        { name: 'parkingName', validators: ['IsRequired'] },
	        { name: 'value', validators: ['IsRequired'] },
	        { name: 'controlledCo' },
	        { name: 'chargingStations' },
	        { name: 'carsharing' },
	    ]
	};
	exports.default = (0, createForm_1.createForm)(exports.ProjectVersionParkingFormDefinition, null)(ProjectVersionParkingForm);


/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectVersionRoomFormDefinition = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var validate_1 = __webpack_require__(24);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var closedForm_1 = __webpack_require__(82);
	var createForm_1 = __webpack_require__(18);
	var mobx_react_1 = __webpack_require__(4);
	var commonDataService_1 = __webpack_require__(41);
	var entityConstants_1 = __webpack_require__(145);
	var ProjectVersionRoomForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionRoomForm, _super);
	    function ProjectVersionRoomForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ProjectVersionRoomForm.prototype.render = function () {
	        var dataObject = this.props.dataObject;
	        var fields = dataObject.getFormFields(exports.ProjectVersionRoomFormDefinition.formName);
	        var roomName = fields.roomName, roomNumber = fields.roomNumber, roomType = fields.roomType, radonExposureLevel = fields.radonExposureLevel, roomCategory = fields.roomCategory, area = fields.area;
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-2 col-sm-2" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, roomName.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: roomName, value: roomName.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-2 col-sm-2" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, roomNumber.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: roomNumber, value: roomNumber.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-2 col-sm-2" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, area.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: area, value: area.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-2 col-sm-2" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, roomType.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, entityConstants_1.PROJECT_VERSION_ROOM_TYPE_ENTITY, {}), clearable: true, asterixForAll: true })),
	                    react_1.default.createElement(validate_1.Validate, { field: roomType, value: roomType.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-2 col-sm-2" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, roomCategory.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, entityConstants_1.PROJECT_VERSION_ROOM_CATEGORY_ENTITY, {}), clearable: true, asterixForAll: true })),
	                    react_1.default.createElement(validate_1.Validate, { field: roomCategory, value: roomCategory.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-2 col-sm-2" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, radonExposureLevel.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: radonExposureLevel, value: radonExposureLevel.props.value })))));
	    };
	    ProjectVersionRoomForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionRoomForm);
	    return ProjectVersionRoomForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { width: '100%' } },
	        react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields },
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.roomName.textLabel, value: dataObject.roomName }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.roomType.textLabel, value: dataObject.roomType }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.roomCategory.textLabel, value: dataObject.roomCategory }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.radonExposureLevel.textLabel, value: dataObject.radonExposureLevel }))));
	};
	exports.ProjectVersionRoomFormDefinition = {
	    formName: 'ProjectVersionRoomForm',
	    fields: [
	        { name: 'roomName', validators: ['IsRequired'] },
	        { name: 'roomNumber', validators: ['IsRequired'] },
	        { name: 'roomType', validators: ['IsRequired'] },
	        { name: 'area', validators: ['IsRequired', 'IsNumber', { validation: 'Min', parameters: { min: 0 } }] },
	        { name: 'roomCategory', validators: ['IsRequired'] },
	        { name: 'radonExposureLevel', validators: ['IsRequired'] }
	    ]
	};
	exports.default = (0, createForm_1.createForm)(exports.ProjectVersionRoomFormDefinition, ClosedContent)(ProjectVersionRoomForm);


/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectVersionTreeFormDefinition = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var createForm_1 = __webpack_require__(18);
	var fields_1 = __webpack_require__(20);
	var validate_1 = __webpack_require__(24);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var mobx_1 = __webpack_require__(5);
	var ProjectVersionTreeForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionTreeForm, _super);
	    function ProjectVersionTreeForm(props, context) {
	        var _this = _super.call(this, props, context) || this;
	        (0, mobx_1.reaction)(function () { return props.dataObject.indigenous; }, function (indigenous) {
	            if (indigenous) {
	                var form = props.dataObject.getForm(exports.ProjectVersionTreeFormDefinition.formName);
	                props.dataObject.newlyPlanted = false;
	                props.dataObject.cutDown = false;
	                form.updateFieldsPropValue(props.dataObject, 'newlyPlanted', 'cutDown');
	            }
	        });
	        (0, mobx_1.reaction)(function () { return props.dataObject.newlyPlanted; }, function (newlyPlanted) {
	            if (newlyPlanted) {
	                var form = props.dataObject.getForm(exports.ProjectVersionTreeFormDefinition.formName);
	                props.dataObject.indigenous = false;
	                props.dataObject.cutDown = false;
	                form.updateFieldsPropValue(props.dataObject, 'indigenous', 'cutDown');
	            }
	        });
	        (0, mobx_1.reaction)(function () { return props.dataObject.cutDown; }, function (cutDown) {
	            if (cutDown) {
	                var form = props.dataObject.getForm(exports.ProjectVersionTreeFormDefinition.formName);
	                props.dataObject.indigenous = false;
	                props.dataObject.newlyPlanted = false;
	                form.updateFieldsPropValue(props.dataObject, 'indigenous', 'newlyPlanted');
	            }
	        });
	        return _this;
	    }
	    ProjectVersionTreeForm.prototype.render = function () {
	        var dataObject = this.props.dataObject;
	        var fields = dataObject.getFormFields(exports.ProjectVersionTreeFormDefinition.formName);
	        var name = fields.name, trunkCircumference = fields.trunkCircumference, crownDiameter = fields.crownDiameter, distanceFromFacade = fields.distanceFromFacade, facadeOrientation = fields.facadeOrientation, indigenous = fields.indigenous, newlyPlanted = fields.newlyPlanted, cutDown = fields.cutDown;
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", { className: 'row' },
	                react_1.default.createElement("div", { className: 'fx col-xs-4 col-sm-4' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-4 col-sm-4' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, trunkCircumference.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: trunkCircumference, value: trunkCircumference.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-4 col-sm-4' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, crownDiameter.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: crownDiameter, value: crownDiameter.props.value }))),
	            react_1.default.createElement("div", { className: 'row' },
	                react_1.default.createElement("div", { className: 'fx col-xs-6 col-sm-6' },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, distanceFromFacade.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: distanceFromFacade, value: distanceFromFacade.props.value })),
	                react_1.default.createElement("div", { className: 'fx col-xs-6 col-sm-6' },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, facadeOrientation.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: facadeOrientation, value: facadeOrientation.props.value }))),
	            react_1.default.createElement("div", { className: 'row' },
	                react_1.default.createElement("div", { className: 'fx col-xs-4 col-sm-4' },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, indigenous.props))),
	                react_1.default.createElement("div", { className: 'fx col-xs-4 col-sm-4' },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, newlyPlanted.props))),
	                react_1.default.createElement("div", { className: 'fx col-xs-4 col-sm-4' },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, cutDown.props))))));
	    };
	    ProjectVersionTreeForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionTreeForm);
	    return ProjectVersionTreeForm;
	}(react_1.default.Component));
	exports.ProjectVersionTreeFormDefinition = {
	    formName: 'ProjectVersionTreeForm',
	    fields: [
	        { name: 'name', validators: ['IsRequired'] },
	        { name: 'trunkCircumference', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'crownDiameter', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'distanceFromFacade', validators: ['IsRequired', 'IsNumber'] },
	        { name: 'facadeOrientation', validators: ['IsRequired'] },
	        { name: 'indigenous' },
	        { name: 'newlyPlanted' },
	        { name: 'cutDown' }
	    ]
	};
	exports.default = (0, createForm_1.createForm)(exports.ProjectVersionTreeFormDefinition, null)(ProjectVersionTreeForm);


/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var ProjectVersionWindowExpandComp = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionWindowExpandComp, _super);
	    function ProjectVersionWindowExpandComp() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.fieldsRow1 = ['name', 'displacement', 'room'];
	        _this.fieldsRow2 = ['reachableOnlyByLadder', 'securityType'];
	        _this.fieldsRow3 = ['height', 'width', 'glassArea', 'frameLength'];
	        _this.fieldsRow4 = ['angleAlpha', 'angleBeta', 'angleGama', 'angleDelta'];
	        _this.fieldsRow5 = ['angleEpsilon', 'angleZetta', 'angleEta', 'angleShadowZ'];
	        _this.fieldsRow6 = ['frameMaterial', 'frameMaterialWeight'];
	        _this.fieldsRow7 = ['glassMaterial', 'glassMaterialWeight'];
	        _this.fieldRows = [_this.fieldsRow1, _this.fieldsRow2, _this.fieldsRow3, _this.fieldsRow4, _this.fieldsRow5, _this.fieldsRow6, _this.fieldsRow7];
	        _this.getFormattedValue = function (field) {
	            var window = _this.props.item.rowObject;
	            if (field.fieldName === 'room') {
	                return window.room.label;
	            }
	            if (field.fieldName === 'frameMaterial') {
	                return window.frameMaterial.label;
	            }
	            if (field.fieldName === 'glassMaterial') {
	                return window.glassMaterial.label;
	            }
	            var value = window[field.fieldName];
	            if (value === undefined) {
	                return "-";
	            }
	            return field.formatValue(value);
	        };
	        _this.renderCell = function (field) {
	            return (react_1.default.createElement("div", { className: "fx col-xs-4" },
	                react_1.default.createElement("div", { className: "item-label", key: field.label },
	                    field.label,
	                    ": "),
	                _this.getFormattedValue(field)));
	        };
	        _this.renderRow = function (columnsNames) {
	            var material = _this.props.item.rowObject;
	            var fields = material.$mdEntityRef.getFields();
	            var cells = [];
	            var _loop_1 = function (column) {
	                var field = fields.find(function (f) { return f.fieldName === column; });
	                cells.push(_this.renderCell(field));
	            };
	            for (var _i = 0, columnsNames_1 = columnsNames; _i < columnsNames_1.length; _i++) {
	                var column = columnsNames_1[_i];
	                _loop_1(column);
	            }
	            return (react_1.default.createElement("div", { className: "row" }, cells));
	        };
	        return _this;
	    }
	    ProjectVersionWindowExpandComp.prototype.render = function () {
	        var rows = [];
	        for (var _i = 0, _a = this.fieldRows; _i < _a.length; _i++) {
	            var row = _a[_i];
	            rows.push(this.renderRow(row));
	        }
	        return (react_1.default.createElement("div", { style: { paddingLeft: 25, marginBottom: 25 } }, rows));
	    };
	    ProjectVersionWindowExpandComp = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionWindowExpandComp);
	    return ProjectVersionWindowExpandComp;
	}(react_1.default.Component));
	exports.default = ProjectVersionWindowExpandComp;


/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectVersionWindowFormDefinition = void 0;
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var validate_1 = __webpack_require__(24);
	var fields_1 = __webpack_require__(20);
	var closedForm_1 = __webpack_require__(82);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var commonDataService_1 = __webpack_require__(41);
	var entityConstants_1 = __webpack_require__(145);
	var rules_1 = __webpack_require__(56);
	var blockComp_1 = __webpack_require__(30);
	var ProjectVersionWindowForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionWindowForm, _super);
	    function ProjectVersionWindowForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ProjectVersionWindowForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, entity = _a.entity;
	        var fields = dataObject.getFormFields(exports.ProjectVersionWindowFormDefinition.formName);
	        var name = fields.name, displacement = fields.displacement, room = fields.room, reachableOnlyByLadder = fields.reachableOnlyByLadder, securityType = fields.securityType, height = fields.height, width = fields.width, glassArea = fields.glassArea, frameLength = fields.frameLength, angleAlpha = fields.angleAlpha, angleBeta = fields.angleBeta, angleDelta = fields.angleDelta, angleEpsilon = fields.angleEpsilon, angleGama = fields.angleGama, angleEta = fields.angleEta, angleZeta = fields.angleZeta, angleShadowZ = fields.angleShadowZ, frameMaterial = fields.frameMaterial, frameMaterialWeight = fields.frameMaterialWeight, glassMaterial = fields.glassMaterial, glassMaterialWeight = fields.glassMaterialWeight;
	        return (react_1.default.createElement(blockComp_1.BlockComp, { noPadding: true },
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, name.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: name, value: name.props.value },
	                        react_1.default.createElement(rules_1.IsRequired, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, displacement.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: displacement, value: displacement.props.value },
	                        react_1.default.createElement(rules_1.IsRequired, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, room.props, { async: true, asterixForAll: true, loadOptions: commonDataService_1.optionsSearch.bind(this, entityConstants_1.PROJECT_VERSION_ROOM_ENTITY, { projectVersionId: rootObject.versionId }), clearable: true })),
	                    react_1.default.createElement(validate_1.Validate, { field: room, value: room.props.value },
	                        react_1.default.createElement(rules_1.IsRequired, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2", style: { marginTop: "10px" } },
	                    react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, reachableOnlyByLadder.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: reachableOnlyByLadder, value: reachableOnlyByLadder.props.value })),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-1" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, securityType.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: securityType, value: securityType.props.value },
	                        react_1.default.createElement(rules_1.IsRequired, null)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, frameMaterial.props, { async: true, asterixForAll: true, loadOptions: commonDataService_1.optionsSearch.bind(this, entityConstants_1.PROJECT_MATERIAL_ENTITY, { projectVersionId: rootObject.versionId }), clearable: true })),
	                    react_1.default.createElement(validate_1.Validate, { field: frameMaterial, value: frameMaterial.props.value },
	                        react_1.default.createElement(rules_1.IsRequired, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, frameMaterialWeight.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: frameMaterialWeight, value: frameMaterialWeight.props.value },
	                        react_1.default.createElement(rules_1.IsRequired, null),
	                        react_1.default.createElement(rules_1.Min, { min: 0 }),
	                        react_1.default.createElement(rules_1.IsNumber, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, glassMaterial.props, { async: true, asterixForAll: true, loadOptions: commonDataService_1.optionsSearch.bind(this, entityConstants_1.PROJECT_MATERIAL_ENTITY, { projectVersionId: rootObject.versionId }), clearable: true })),
	                    react_1.default.createElement(validate_1.Validate, { field: glassMaterial, value: glassMaterial.props.value },
	                        react_1.default.createElement(rules_1.IsRequired, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, glassMaterialWeight.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: glassMaterialWeight, value: glassMaterialWeight.props.value },
	                        react_1.default.createElement(rules_1.IsRequired, null),
	                        react_1.default.createElement(rules_1.Min, { min: 0 }),
	                        react_1.default.createElement(rules_1.IsNumber, null)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, height.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: height, value: height.props.value },
	                        react_1.default.createElement(rules_1.IsRequired, null),
	                        react_1.default.createElement(rules_1.Min, { min: 0 }),
	                        react_1.default.createElement(rules_1.IsNumber, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, width.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: width, value: width.props.value },
	                        react_1.default.createElement(rules_1.IsRequired, null),
	                        react_1.default.createElement(rules_1.Min, { min: 0 }),
	                        react_1.default.createElement(rules_1.IsNumber, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, glassArea.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: glassArea, value: glassArea.props.value },
	                        react_1.default.createElement(rules_1.IsRequired, null),
	                        react_1.default.createElement(rules_1.Min, { min: 0 }),
	                        react_1.default.createElement(rules_1.IsNumber, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, frameLength.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: frameLength, value: frameLength.props.value },
	                        react_1.default.createElement(rules_1.IsRequired, null),
	                        react_1.default.createElement(rules_1.Min, { min: 0 }),
	                        react_1.default.createElement(rules_1.IsNumber, null)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, angleAlpha.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: angleAlpha, value: angleAlpha.props.value },
	                        react_1.default.createElement(rules_1.Min, { min: 0 }),
	                        react_1.default.createElement(rules_1.Max, { max: 360 }),
	                        react_1.default.createElement(rules_1.IsNumber, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, angleBeta.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: angleBeta, value: angleBeta.props.value },
	                        react_1.default.createElement(rules_1.Min, { min: 0 }),
	                        react_1.default.createElement(rules_1.Max, { max: 360 }),
	                        react_1.default.createElement(rules_1.IsNumber, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, angleGama.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: angleGama, value: angleGama.props.value },
	                        react_1.default.createElement(rules_1.Min, { min: 0 }),
	                        react_1.default.createElement(rules_1.Max, { max: 360 }),
	                        react_1.default.createElement(rules_1.IsNumber, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, angleDelta.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: angleDelta, value: angleDelta.props.value },
	                        react_1.default.createElement(rules_1.Min, { min: 0 }),
	                        react_1.default.createElement(rules_1.Max, { max: 360 }),
	                        react_1.default.createElement(rules_1.IsNumber, null)))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, angleEpsilon.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: angleEpsilon, value: angleEpsilon.props.value },
	                        react_1.default.createElement(rules_1.Min, { min: 0 }),
	                        react_1.default.createElement(rules_1.Max, { max: 360 }),
	                        react_1.default.createElement(rules_1.IsNumber, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, angleZeta.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: angleZeta, value: angleZeta.props.value },
	                        react_1.default.createElement(rules_1.Min, { min: 0 }),
	                        react_1.default.createElement(rules_1.Max, { max: 360 }),
	                        react_1.default.createElement(rules_1.IsNumber, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, angleEta.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: angleEta, value: angleEta.props.value },
	                        react_1.default.createElement(rules_1.Min, { min: 0 }),
	                        react_1.default.createElement(rules_1.Max, { max: 360 }),
	                        react_1.default.createElement(rules_1.IsNumber, null))),
	                react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                    react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, angleShadowZ.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: angleShadowZ, value: angleShadowZ.props.value },
	                        react_1.default.createElement(rules_1.Min, { min: 0 }),
	                        react_1.default.createElement(rules_1.Max, { max: 360 }),
	                        react_1.default.createElement(rules_1.IsNumber, null))))));
	    };
	    ProjectVersionWindowForm = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionWindowForm);
	    return ProjectVersionWindowForm;
	}(react_1.default.Component));
	var ClosedContent = function (_a) {
	    var dataObject = _a.dataObject, entity = _a.entity, entities = _a.entities, fields = _a.fields, disabled = _a.disabled;
	    return (react_1.default.createElement("div", { style: { width: '100%' } },
	        react_1.default.createElement(closedForm_1.ClosedFormBlock, { dataObject: dataObject, entity: entity, entities: entities, fields: fields },
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.name.textLabel, value: dataObject.name }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.displacement.textLabel, value: dataObject.displacement }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.room.textLabel, value: dataObject.room }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.reachableOnlyByLadder.textLabel, value: dataObject.reachableOnlyByLadder }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.securityType.textLabel, value: dataObject.securityType }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.height.textLabel, value: dataObject.height }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.glassArea.textLabel, value: dataObject.glassArea }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.frameLength.textLabel, value: dataObject.frameLength }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.angleAlpha.textLabel, value: dataObject.angleAlpha }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.angleBeta.textLabel, value: dataObject.angleBeta }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.angleGama.textLabel, value: dataObject.angleGama }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.angleDelta.textLabel, value: dataObject.angleDelta }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.angleEpsilon.textLabel, value: dataObject.angleEpsilon }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.angleZeta.textLabel, value: dataObject.angleZeta }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.angleEta.textLabel, value: dataObject.angleEta }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.angleShadowZ.textLabel, value: dataObject.angleShadowZ }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.frameMaterial.textLabel, value: dataObject.frameMaterial }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.frameMaterialWeight.textLabel, value: dataObject.frameMaterialWeight }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.glassMaterial.textLabel, value: dataObject.glassMaterial }),
	            react_1.default.createElement(closedForm_1.ClosedFormField, { label: fields.glassMaterialWeight.textLabel, value: dataObject.glassMaterialWeight }))));
	};
	exports.ProjectVersionWindowFormDefinition = {
	    formName: 'ProjectVersionWindowForm',
	    fields: [
	        { name: "name" },
	        { name: "displacement" },
	        { name: "room" },
	        { name: "reachableOnlyByLadder" },
	        { name: "securityType" },
	        { name: "height" },
	        { name: "width" },
	        { name: "glassArea" },
	        { name: "frameLength" },
	        { name: "angleAlpha" },
	        { name: "angleBeta" },
	        { name: "angleGama" },
	        { name: "angleDelta" },
	        { name: "angleEpsilon" },
	        { name: "angleZeta" },
	        { name: "angleEta" },
	        { name: "angleShadowZ" },
	        { name: "frameMaterial" },
	        { name: "frameMaterialWeight" },
	        { name: "glassMaterial" },
	        { name: "glassMaterialWeight" }
	    ]
	};
	exports.default = (0, createForm_1.createForm)(exports.ProjectVersionWindowFormDefinition, ClosedContent)(ProjectVersionWindowForm);


/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.CriterionScore = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var CriterionScore = /** @class */ (function (_super) {
	    tslib_1.__extends(CriterionScore, _super);
	    function CriterionScore(json) {
	        return _super.call(this, json) || this;
	    }
	    CriterionScore.prototype.getId = function () {
	        return this.scoreId;
	    };
	    CriterionScore.prototype.setId = function (id) {
	        this.scoreId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], CriterionScore.prototype, "scoreId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], CriterionScore.prototype, "fromValue", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], CriterionScore.prototype, "toValue", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], CriterionScore.prototype, "score", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], CriterionScore.prototype, "criterion", void 0);
	    CriterionScore = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], CriterionScore);
	    return CriterionScore;
	}(DomainAncestor_1.DomainAncestor));
	exports.CriterionScore = CriterionScore;


/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SubCriterionParameterValue = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var SubCriterionParameterValue = /** @class */ (function (_super) {
	    tslib_1.__extends(SubCriterionParameterValue, _super);
	    function SubCriterionParameterValue(json) {
	        return _super.call(this, json) || this;
	    }
	    SubCriterionParameterValue.prototype.getId = function () {
	        return this.valueId;
	    };
	    SubCriterionParameterValue.prototype.setId = function (id) {
	        this.valueId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SubCriterionParameterValue.prototype, "valueId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SubCriterionParameterValue.prototype, "label", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SubCriterionParameterValue.prototype, "value", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SubCriterionParameterValue.prototype, "countLimit", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], SubCriterionParameterValue.prototype, "dependsOn", void 0);
	    SubCriterionParameterValue = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], SubCriterionParameterValue);
	    return SubCriterionParameterValue;
	}(DomainAncestor_1.DomainAncestor));
	exports.SubCriterionParameterValue = SubCriterionParameterValue;


/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectCriterionVersion = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var ProjectCriterionVersion = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectCriterionVersion, _super);
	    function ProjectCriterionVersion(json) {
	        return _super.call(this, json) || this;
	    }
	    ProjectCriterionVersion.prototype.getId = function () {
	        return this.versionId;
	    };
	    ProjectCriterionVersion.prototype.setId = function (id) {
	        this.versionId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectCriterionVersion.prototype, "versionId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectCriterionVersion.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectCriterionVersion.prototype, "isDefault", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectCriterionVersion.prototype, "projectVersion", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectCriterionVersion.prototype, "criterion", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectCriterionVersion.prototype, "score", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectCriterionVersion.prototype, "groupResult", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectCriterionVersion.prototype, "totalResult", void 0);
	    ProjectCriterionVersion = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ProjectCriterionVersion);
	    return ProjectCriterionVersion;
	}(DomainAncestor_1.DomainAncestor));
	exports.ProjectCriterionVersion = ProjectCriterionVersion;


/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectVersionRunoffCoefficient = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var ProjectVersionRunoffCoefficient = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionRunoffCoefficient, _super);
	    function ProjectVersionRunoffCoefficient(json) {
	        return _super.call(this, json) || this;
	    }
	    ProjectVersionRunoffCoefficient.prototype.getId = function () {
	        return this.runoffCoefficientId;
	    };
	    ProjectVersionRunoffCoefficient.prototype.setId = function (id) {
	        this.runoffCoefficientId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionRunoffCoefficient.prototype, "runoffCoefficientId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionRunoffCoefficient.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionRunoffCoefficient.prototype, "lower", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionRunoffCoefficient.prototype, "between", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionRunoffCoefficient.prototype, "over", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionRunoffCoefficient.prototype, "projectVersion", void 0);
	    ProjectVersionRunoffCoefficient = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ProjectVersionRunoffCoefficient);
	    return ProjectVersionRunoffCoefficient;
	}(DomainAncestor_1.DomainAncestor));
	exports.ProjectVersionRunoffCoefficient = ProjectVersionRunoffCoefficient;


/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectVersionArea = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var ProjectVersionArea = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionArea, _super);
	    function ProjectVersionArea(json) {
	        return _super.call(this, json) || this;
	    }
	    ProjectVersionArea.prototype.getId = function () {
	        return this.areaId;
	    };
	    ProjectVersionArea.prototype.setId = function (id) {
	        this.areaId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionArea.prototype, "areaId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionArea.prototype, "projectVersion", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionArea.prototype, "area", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionArea.prototype, "m2", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionArea.prototype, "note", void 0);
	    ProjectVersionArea = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ProjectVersionArea);
	    return ProjectVersionArea;
	}(DomainAncestor_1.DomainAncestor));
	exports.ProjectVersionArea = ProjectVersionArea;


/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectVersionCapacity = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var ProjectVersionCapacity = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionCapacity, _super);
	    function ProjectVersionCapacity(json) {
	        return _super.call(this, json) || this;
	    }
	    ProjectVersionCapacity.prototype.getId = function () {
	        return this.capacityId;
	    };
	    ProjectVersionCapacity.prototype.setId = function (id) {
	        this.capacityId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionCapacity.prototype, "capacityId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionCapacity.prototype, "area", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionCapacity.prototype, "countOfHousingUnits", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionCapacity.prototype, "countOfPeople", void 0);
	    ProjectVersionCapacity = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ProjectVersionCapacity);
	    return ProjectVersionCapacity;
	}(DomainAncestor_1.DomainAncestor));
	exports.ProjectVersionCapacity = ProjectVersionCapacity;


/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var ProjectVersionLopFilling = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionLopFilling, _super);
	    function ProjectVersionLopFilling(json) {
	        return _super.call(this, json) || this;
	    }
	    ProjectVersionLopFilling.prototype.getId = function () {
	        return this.fillingId;
	    };
	    ProjectVersionLopFilling.prototype.setId = function (id) {
	        this.fillingId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "fillingId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "projectVersion", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "width", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "height", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "glazingArea", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "glazingMaterial", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "glazingMass", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "floorLevel", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "reachableByLadder", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "enduranceClass", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "acousticIsolation", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "partiesOrientation", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "angleAlpha", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "angleBeta", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "angleGama", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "angleDelta", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "angleEpsilon", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "angleZeta", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "angleEta", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopFilling.prototype, "angleShieldingZ", void 0);
	    ProjectVersionLopFilling = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ProjectVersionLopFilling);
	    return ProjectVersionLopFilling;
	}(DomainAncestor_1.DomainAncestor));
	exports.default = ProjectVersionLopFilling;


/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var ProjectVersionLopProfile = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionLopProfile, _super);
	    function ProjectVersionLopProfile(json) {
	        return _super.call(this, json) || this;
	    }
	    ProjectVersionLopProfile.prototype.getId = function () {
	        return this.profileId;
	    };
	    ProjectVersionLopProfile.prototype.setId = function (id) {
	        this.profileId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopProfile.prototype, "profileId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopProfile.prototype, "projectVersion", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopProfile.prototype, "length", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopProfile.prototype, "type", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopProfile.prototype, "profileDescription", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopProfile.prototype, "frameMaterial1", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopProfile.prototype, "frameMaterialMass1", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopProfile.prototype, "frameMaterial2", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopProfile.prototype, "frameMaterialMass2", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopProfile.prototype, "frameMaterial3", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionLopProfile.prototype, "frameMaterialMass3", void 0);
	    ProjectVersionLopProfile = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ProjectVersionLopProfile);
	    return ProjectVersionLopProfile;
	}(DomainAncestor_1.DomainAncestor));
	exports.default = ProjectVersionLopProfile;


/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var ProjectVersionParking = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionParking, _super);
	    function ProjectVersionParking(json) {
	        return _super.call(this, json) || this;
	    }
	    ProjectVersionParking.prototype.getId = function () {
	        return this.parkingId;
	    };
	    ProjectVersionParking.prototype.setId = function (id) {
	        this.parkingId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionParking.prototype, "parkingId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionParking.prototype, "projectVersion", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionParking.prototype, "parkingName", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionParking.prototype, "value", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionParking.prototype, "controlledCo", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionParking.prototype, "chargingStations", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionParking.prototype, "carsharing", void 0);
	    ProjectVersionParking = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ProjectVersionParking);
	    return ProjectVersionParking;
	}(DomainAncestor_1.DomainAncestor));
	exports.default = ProjectVersionParking;


/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var ProjectVersionTree = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionTree, _super);
	    function ProjectVersionTree(json) {
	        return _super.call(this, json) || this;
	    }
	    ProjectVersionTree.prototype.getId = function () {
	        return this.treeId;
	    };
	    ProjectVersionTree.prototype.setId = function (id) {
	        this.treeId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionTree.prototype, "treeId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionTree.prototype, "projectVersion", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionTree.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionTree.prototype, "trunkCircumference", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionTree.prototype, "crownDiameter", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionTree.prototype, "distanceFromFacade", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionTree.prototype, "facadeOrientation", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionTree.prototype, "indigenous", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionTree.prototype, "newlyPlanted", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionTree.prototype, "cutDown", void 0);
	    ProjectVersionTree = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ProjectVersionTree);
	    return ProjectVersionTree;
	}(DomainAncestor_1.DomainAncestor));
	exports.default = ProjectVersionTree;


/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProjectVersionWindow = void 0;
	var tslib_1 = __webpack_require__(3);
	var DomainAncestor_1 = __webpack_require__(33);
	var mobx_1 = __webpack_require__(5);
	var ProjectVersionWindow = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionWindow, _super);
	    function ProjectVersionWindow(json) {
	        return _super.call(this, json) || this;
	    }
	    ProjectVersionWindow.prototype.getId = function () {
	        return this.windowId;
	    };
	    ProjectVersionWindow.prototype.setId = function (id) {
	        this.windowId = id;
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "windowId", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "projectVersion", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "name", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "displacement", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "room", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "reachableOnlyByLadder", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "securityType", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "height", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "width", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "glassArea", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "frameLength", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "angleAlpha", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "angleBeta", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "angleGama", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "angleDelta", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "angleEpsilon", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "angleZeta", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "angleEta", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "angleShadowZ", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "frameMaterial", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "frameMaterialWeight", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "glassMaterial", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionWindow.prototype, "glassMaterialWeight", void 0);
	    ProjectVersionWindow = tslib_1.__decorate([
	        (0, DomainAncestor_1.entityConfig)()
	    ], ProjectVersionWindow);
	    return ProjectVersionWindow;
	}(DomainAncestor_1.DomainAncestor));
	exports.ProjectVersionWindow = ProjectVersionWindow;


/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var gridsContants_1 = __webpack_require__(121);
	var CriteriaList = /** @class */ (function (_super) {
	    tslib_1.__extends(CriteriaList, _super);
	    function CriteriaList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    CriteriaList.fetchData = function (routerParams) {
	        console.log("CriteriaList#fetchData(%s)", gridsContants_1.CRITERIA_LIST);
	        return gridService_1.default.fetchGrids(gridsContants_1.CRITERIA_LIST)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridsContants_1.CRITERIA_LIST);
	        });
	    };
	    CriteriaList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridsContants_1.CRITERIA_LIST), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query }));
	    };
	    CriteriaList.module = metaConstant_1.MODULE.sbtool;
	    CriteriaList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Criteria"], ["Criteria"])));
	    CriteriaList.icon = 'list';
	    CriteriaList.rootPage = true;
	    CriteriaList.protectedPage = true;
	    CriteriaList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], CriteriaList);
	    return CriteriaList;
	}(pageAncestor_1.default));
	exports.default = CriteriaList;
	var templateObject_1;


/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var metaConstant_1 = __webpack_require__(13);
	__webpack_require__(203);
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridUtils_1 = __webpack_require__(83);
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var gridComp_1 = tslib_1.__importStar(__webpack_require__(44));
	__webpack_require__(275);
	var criterionService_1 = tslib_1.__importDefault(__webpack_require__(964));
	var material_ui_1 = __webpack_require__(127);
	var variables_1 = __webpack_require__(96);
	var mui_theme_1 = __webpack_require__(119);
	var gridsContants_1 = __webpack_require__(121);
	var entityConstants_1 = __webpack_require__(145);
	var CriterionDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(CriterionDetail, _super);
	    function CriterionDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.renderTabs = function () {
	            var criterion = criterionService_1.default.criterionObject;
	            var subCriterionGrid = criterion.$movingBlocks.getBlock(gridsContants_1.SUB_CRITERIA_LIST);
	            var criterionScoreGrid = criterion.$movingBlocks.getBlock(gridsContants_1.CRITERION_SCORE_LIST);
	            var gridCompArray = [
	                react_1.default.createElement(gridComp_1.default, { grid: subCriterionGrid, uiLocation: gridComp_1.UILOCATION.tab, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true, key: 1 }),
	                react_1.default.createElement(gridComp_1.default, { grid: criterionScoreGrid, uiLocation: gridComp_1.UILOCATION.tab, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true, key: 2 })
	            ];
	            var tabArray = gridCompArray.map(function (gridComp) { return (react_1.default.createElement(material_ui_1.Tab, { label: gridComp.props.grid.label, style: variables_1.tabStyle, onActive: _this.activateTab.bind(_this, gridComp.props.grid), key: gridComp.props.grid.getBlockName(), value: gridComp.props.grid.getBlockName() }, gridComp)); });
	            return (tabArray.length) ? (react_1.default.createElement(material_ui_1.Tabs, { value: criterion.$movingBlocks.activeBlockTab, className: "detail-grid", tabTemplate: mui_theme_1.TabTemplate, inkBarStyle: { transition: 'inherit' }, contentContainerStyle: { width: '100%', flexGrow: 1, display: 'flex', minHeight: 0 }, onChange: _this.onTabChange }, tabArray)) : '';
	        };
	        return _this;
	    }
	    CriterionDetail.fetchData = function (routerParams, query) {
	        console.log("SbToolCriterionDetails#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata([entityConstants_1.CRITERION_ENTITY]);
	        var criterionPromise = criterionService_1.default.readCriterion(routerParams.id);
	        var gridPromise = gridService_1.default.fetchGrids(gridsContants_1.SUB_CRITERIA_LIST, gridsContants_1.CRITERION_SCORE_LIST);
	        return Promise.all([metadataPromise, criterionPromise, gridPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], sbToolCriterionObject = _a[1], gridLocationMap = _a[2];
	            criterionService_1.default.criterionObject = sbToolCriterionObject;
	            criterionService_1.default.criterionObject.$movingBlocks = new gridUtils_1.MovingBlocks(gridsContants_1.SUB_CRITERIA_LIST, true, query.tab, new grid_1.default(gridLocationMap.get(gridsContants_1.SUB_CRITERIA_LIST), criterionService_1.default.criterionObject.criterionId), new grid_1.default(gridLocationMap.get(gridsContants_1.CRITERION_SCORE_LIST), criterionService_1.default.criterionObject.criterionId));
	            criterionService_1.default.criterionObject = sbToolCriterionObject.initAfterRead(false);
	        });
	    };
	    CriterionDetail.prototype.componentDidUpdate = function (prevProps) {
	        if (this.idChanged(prevProps.params.id, this.props.params.id)) {
	            criterionService_1.default.criterionObject.$movingBlocks.searchExposedGrids(criterionService_1.default.criterionObject);
	        }
	    };
	    CriterionDetail.prototype.componentDidMount = function () {
	        console.debug("%c componentDidMount", "background-color: magenta");
	        criterionService_1.default.criterionObject.$movingBlocks.searchExposedGrids(criterionService_1.default.criterionObject);
	    };
	    CriterionDetail.prototype.componentWillUnmount = function () {
	        criterionService_1.default.criterionObject = null;
	    };
	    CriterionDetail.prototype.findRootObject = function () {
	        return criterionService_1.default.criterionObject;
	    };
	    CriterionDetail.prototype.render = function () {
	        var criterion = criterionService_1.default.criterionObject;
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column', padding: 20 } },
	            react_1.default.createElement("div", null,
	                react_1.default.createElement("h4", null, criterion.code + " " + criterion.name),
	                criterion.description),
	            react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'row' } }, this.renderTabs())));
	    };
	    CriterionDetail.module = metaConstant_1.MODULE.sbtool;
	    CriterionDetail.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Criterion"], ["Criterion"])));
	    CriterionDetail.icon = 'list';
	    CriterionDetail.protectedPage = true;
	    CriterionDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], CriterionDetail);
	    return CriterionDetail;
	}(pageAncestor_1.default));
	exports.default = CriterionDetail;
	var templateObject_1;


/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var metaConstant_1 = __webpack_require__(13);
	__webpack_require__(203);
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	__webpack_require__(275);
	var criterionService_1 = tslib_1.__importDefault(__webpack_require__(964));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var gridUtils_1 = __webpack_require__(83);
	var gridComp_1 = tslib_1.__importStar(__webpack_require__(44));
	var gridsContants_1 = __webpack_require__(121);
	var entityConstants_1 = __webpack_require__(145);
	var SbToolSubCriterionDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(SbToolSubCriterionDetail, _super);
	    function SbToolSubCriterionDetail() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SbToolSubCriterionDetail.fetchData = function (routerParams, query) {
	        console.log("SbToolSubCriterionDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata([entityConstants_1.SUB_CRITERION_ENTITY]);
	        var criterionPromise = criterionService_1.default.readSubCriterion(routerParams.id);
	        var gridPromise = gridService_1.default.fetchGrids(gridsContants_1.SUB_CRITERION_PARAM_VALUES_LIST);
	        return Promise.all([metadataPromise, criterionPromise, gridPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], subcriterion = _a[1], gridLocationMap = _a[2];
	            criterionService_1.default.subCriterionObject = subcriterion;
	            criterionService_1.default.subCriterionObject.$movingBlocks = new gridUtils_1.MovingBlocks(gridsContants_1.SUB_CRITERION_PARAM_VALUES_LIST, true, query.tab, new grid_1.default(gridLocationMap.get(gridsContants_1.SUB_CRITERION_PARAM_VALUES_LIST), criterionService_1.default.subCriterionObject.subCriterionId));
	            criterionService_1.default.subCriterionObject = subcriterion.initAfterRead(false);
	        });
	    };
	    SbToolSubCriterionDetail.prototype.componentDidUpdate = function (prevProps) {
	        if (this.idChanged(prevProps.params.id, this.props.params.id)) {
	            criterionService_1.default.subCriterionObject.$movingBlocks.searchExposedGrids(criterionService_1.default.subCriterionObject);
	        }
	    };
	    SbToolSubCriterionDetail.prototype.componentDidMount = function () {
	        console.debug("%c componentDidMount", "background-color: magenta");
	        criterionService_1.default.subCriterionObject.$movingBlocks.searchExposedGrids(criterionService_1.default.subCriterionObject);
	    };
	    SbToolSubCriterionDetail.prototype.componentWillUnmount = function () {
	        criterionService_1.default.subCriterionObject = null;
	    };
	    SbToolSubCriterionDetail.prototype.findRootObject = function () {
	        return criterionService_1.default.subCriterionObject;
	    };
	    SbToolSubCriterionDetail.prototype.render = function () {
	        var criterion = criterionService_1.default.subCriterionObject;
	        var paramsValuesGrid = criterion.$movingBlocks.getBlock(gridsContants_1.SUB_CRITERION_PARAM_VALUES_LIST);
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	            react_1.default.createElement("div", { style: { marginLeft: 20 } },
	                react_1.default.createElement("h4", null, criterion.name),
	                criterion.description),
	            react_1.default.createElement(gridComp_1.default, { grid: paramsValuesGrid, uiLocation: gridComp_1.UILOCATION.main, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true })));
	    };
	    SbToolSubCriterionDetail.module = metaConstant_1.MODULE.sbtool;
	    SbToolSubCriterionDetail.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Sub-criterion"], ["Sub-criterion"])));
	    SbToolSubCriterionDetail.icon = 'list';
	    SbToolSubCriterionDetail.protectedPage = true;
	    SbToolSubCriterionDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], SbToolSubCriterionDetail);
	    return SbToolSubCriterionDetail;
	}(pageAncestor_1.default));
	exports.default = SbToolSubCriterionDetail;
	var templateObject_1;


/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var gridsContants_1 = __webpack_require__(121);
	var EnergyCarriersList = /** @class */ (function (_super) {
	    tslib_1.__extends(EnergyCarriersList, _super);
	    function EnergyCarriersList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    EnergyCarriersList.fetchData = function (routerParams) {
	        console.log("EnergyCarriersList#fetchData(%s)", gridsContants_1.ENERGY_CARRIERS_LIST);
	        return gridService_1.default.fetchGrids(gridsContants_1.ENERGY_CARRIERS_LIST)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridsContants_1.ENERGY_CARRIERS_LIST);
	        });
	    };
	    EnergyCarriersList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridsContants_1.ENERGY_CARRIERS_LIST), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query }));
	    };
	    EnergyCarriersList.module = metaConstant_1.MODULE.sbtool;
	    EnergyCarriersList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Energy carriers"], ["Energy carriers"])));
	    EnergyCarriersList.icon = 'building-o';
	    EnergyCarriersList.rootPage = true;
	    EnergyCarriersList.protectedPage = true;
	    EnergyCarriersList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], EnergyCarriersList);
	    return EnergyCarriersList;
	}(pageAncestor_1.default));
	exports.default = EnergyCarriersList;
	var templateObject_1;


/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var metaConstant_1 = __webpack_require__(13);
	var locales_1 = __webpack_require__(15);
	var gridsContants_1 = __webpack_require__(121);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var LifespanList = /** @class */ (function (_super) {
	    tslib_1.__extends(LifespanList, _super);
	    function LifespanList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    LifespanList.fetchData = function (routerParams) {
	        console.log("LifespanList#fetchData(%s)", gridsContants_1.LIFESPAN_LIST);
	        return gridService_1.default.fetchGrids(gridsContants_1.LIFESPAN_LIST)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridsContants_1.LIFESPAN_LIST);
	        });
	    };
	    LifespanList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridsContants_1.LIFESPAN_LIST), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query }));
	    };
	    LifespanList.module = metaConstant_1.MODULE.sbtool;
	    LifespanList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Lifespan"], ["Lifespan"])));
	    LifespanList.icon = 'list';
	    LifespanList.rootPage = true;
	    LifespanList.protectedPage = true;
	    LifespanList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], LifespanList);
	    return LifespanList;
	}(pageAncestor_1.default));
	exports.default = LifespanList;
	var templateObject_1;


/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var metaConstant_1 = __webpack_require__(13);
	var locales_1 = __webpack_require__(15);
	var gridsContants_1 = __webpack_require__(121);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var MaterialUsageGroupsList = /** @class */ (function (_super) {
	    tslib_1.__extends(MaterialUsageGroupsList, _super);
	    function MaterialUsageGroupsList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MaterialUsageGroupsList.fetchData = function (routerParams) {
	        console.log("MaterialUsageGroupsList#fetchData(%s)", gridsContants_1.MATERIAL_USAGE_GROUPS_LIST);
	        return gridService_1.default.fetchGrids(gridsContants_1.MATERIAL_USAGE_GROUPS_LIST)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridsContants_1.MATERIAL_USAGE_GROUPS_LIST);
	        });
	    };
	    MaterialUsageGroupsList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridsContants_1.MATERIAL_USAGE_GROUPS_LIST), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query }));
	    };
	    MaterialUsageGroupsList.module = metaConstant_1.MODULE.sbtool;
	    MaterialUsageGroupsList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Usage groups"], ["Usage groups"])));
	    MaterialUsageGroupsList.icon = 'list';
	    MaterialUsageGroupsList.rootPage = true;
	    MaterialUsageGroupsList.protectedPage = true;
	    MaterialUsageGroupsList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], MaterialUsageGroupsList);
	    return MaterialUsageGroupsList;
	}(pageAncestor_1.default));
	exports.default = MaterialUsageGroupsList;
	var templateObject_1;


/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var gridsContants_1 = __webpack_require__(121);
	var MaterialsList = /** @class */ (function (_super) {
	    tslib_1.__extends(MaterialsList, _super);
	    function MaterialsList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MaterialsList.fetchData = function (routerParams) {
	        console.log("MaterialsList#fetchData(%s)", gridsContants_1.MATERIALS_LIST);
	        return gridService_1.default.fetchGrids(gridsContants_1.MATERIALS_LIST)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridsContants_1.MATERIALS_LIST);
	        });
	    };
	    MaterialsList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridsContants_1.MATERIALS_LIST), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query }));
	    };
	    MaterialsList.module = metaConstant_1.MODULE.sbtool;
	    MaterialsList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Materials"], ["Materials"])));
	    MaterialsList.icon = 'building-o';
	    MaterialsList.rootPage = true;
	    MaterialsList.protectedPage = true;
	    MaterialsList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], MaterialsList);
	    return MaterialsList;
	}(pageAncestor_1.default));
	exports.default = MaterialsList;
	var templateObject_1;


/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var metaConstant_1 = __webpack_require__(13);
	var locales_1 = __webpack_require__(15);
	var gridsContants_1 = __webpack_require__(121);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var AreaList = /** @class */ (function (_super) {
	    tslib_1.__extends(AreaList, _super);
	    function AreaList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    AreaList.fetchData = function (routerParams) {
	        console.log("AreaList#fetchData(%s)", gridsContants_1.AREA_LIST);
	        return gridService_1.default.fetchGrids(gridsContants_1.AREA_LIST)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridsContants_1.AREA_LIST);
	        });
	    };
	    AreaList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridsContants_1.AREA_LIST), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query }));
	    };
	    AreaList.module = metaConstant_1.MODULE.sbtool;
	    AreaList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Area"], ["Area"])));
	    AreaList.icon = 'list';
	    AreaList.rootPage = true;
	    AreaList.protectedPage = true;
	    AreaList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], AreaList);
	    return AreaList;
	}(pageAncestor_1.default));
	exports.default = AreaList;
	var templateObject_1;


/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var locales_1 = __webpack_require__(15);
	__webpack_require__(275);
	var projectDomain_1 = __webpack_require__(575);
	var projectService_1 = tslib_1.__importDefault(__webpack_require__(406));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var gridUtils_1 = __webpack_require__(83);
	var gridComp_1 = tslib_1.__importStar(__webpack_require__(44));
	var blockComp_1 = __webpack_require__(30);
	var projectForm_1 = tslib_1.__importDefault(__webpack_require__(2199));
	var buttons_1 = __webpack_require__(27);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var formUtils_1 = __webpack_require__(14);
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var routes_1 = __webpack_require__(75);
	var gridsContants_1 = __webpack_require__(121);
	var entityConstants_1 = __webpack_require__(145);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var ProjectDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectDetail, _super);
	    function ProjectDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onSave = function (evt) {
	            // console.log('onSave ');
	            uiService_1.default.showToolbarActionFlag();
	            var result = (0, formUtils_1.preSave)(projectService_1.default.projectObject);
	            if (!result) {
	                return;
	            }
	            var wasNew;
	            return projectService_1.default.saveProject(projectService_1.default.projectObject)
	                .then((0, mobx_1.action)("sbToolProjectSave-callback", function (productJson) {
	                wasNew = projectService_1.default.projectObject.cleanAfterSave(productJson);
	            })).then(function (x) {
	                if (wasNew) {
	                    _this.context.router.replaceWith('sbToolProjectDetail', { id: projectService_1.default.projectObject.projectId });
	                    window.location.reload(); // TODO : REMOVE IT
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            }).catch(function (error) {
	                projectService_1.default.projectObject.$errors = error.getMessages();
	            });
	        };
	        _this.onDelete = function () {
	            // console.log('onDelete');
	            var project = projectService_1.default.projectObject;
	            uiService_1.default.showToolbarActionFlag();
	            projectService_1.default.deleteProject(project.projectId)
	                .then(function () {
	                uiService_1.default.hideToolbarActionFlag();
	                _this.context.router.transitionTo("sbToolProjectsList");
	            }, function (error) {
	                project.$errors = error.getMessages();
	            });
	        };
	        _this.renderMainForm = function () {
	            var propsForCreateForm = {
	                dataObject: projectService_1.default.projectObject,
	                rootObject: projectService_1.default.projectObject,
	                entity: mdEntityService_1.default.getEntity(entityConstants_1.PROJECT_ENTITY),
	                entities: mdEntityService_1.default.entityMap
	            };
	            return (react_1.default.createElement("form", { style: { marginTop: 10 } },
	                react_1.default.createElement("h6", { style: { padding: 10, textTransform: "uppercase", textAlign: 'center', backgroundColor: 'rgb(236, 239, 241)' } }, "TP01_Identifikace"),
	                react_1.default.createElement(blockComp_1.MdBlockArray, { inset: true }, [
	                    react_1.default.createElement(projectForm_1.default, tslib_1.__assign({}, propsForCreateForm, { key: 1 })),
	                ])));
	        };
	        _this.renderVersions = function () {
	            var project = projectService_1.default.projectObject;
	            if (project.$new) {
	                return react_1.default.createElement("noscript", null);
	            }
	            var versionsGrid = project.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSIONS_LIST);
	            return (react_1.default.createElement(gridComp_1.default, { grid: versionsGrid, uiLocation: gridComp_1.UILOCATION.tab, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true, key: 1 },
	                react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "sbToolProjectVersionDetail", params: { id: 'new' }, query: { projectId: project.projectId }, label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["New project version"], ["New project version"]))), permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.sbToolProjectVersionDetail })));
	        };
	        _this.handleDeleteProject = function () {
	            _this.onDeletePopUp.open(function () {
	                _this.onDelete();
	            }, function (cancel) {
	                return;
	            }, "Chcete projekt vymazat? (Tuto akci nelze zastavit. Data budou trvale vymazána)");
	        };
	        _this.renderToolTipMenu = function () {
	            var query = _this.props.query;
	            var project = projectService_1.default.projectObject;
	            return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: query.gridLocation, backAction: function () {
	                    _this.context.router.transitionTo("sbToolProjectsList");
	                    window.location.reload();
	                }, activeTab: project.$movingBlocks.activeBlockTab },
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: _this.onSave, disabled: !project.$dirty, label: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Save"], ["Save"]))), permission: project.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: _this.handleDeleteProject, disabled: project.$new, label: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Delete"], ["Delete"]))), permission: metaConstant_1.PERMISSION.Delete })));
	        };
	        _this.submitDeleteDialogRefHandler = function (comp) { return _this.onDeletePopUp = comp; };
	        return _this;
	    }
	    ProjectDetail.fetchData = function (routerParams, query) {
	        console.log("sbToolProjectDetails#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata([entityConstants_1.PROJECT_ENTITY]);
	        var projectPromise;
	        if (routerParams.id === 'new') {
	            projectPromise = Promise.resolve(new projectDomain_1.Project(Object.assign({ $new: true, active: true }, query)));
	        }
	        else {
	            projectPromise = projectService_1.default.readProject(routerParams.id);
	        }
	        var gridPromise = gridService_1.default.fetchGrids(gridsContants_1.PROJECT_VERSIONS_LIST);
	        return Promise.all([metadataPromise, projectPromise, gridPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], sbToolProjectObject = _a[1], gridLocationMap = _a[2];
	            projectService_1.default.projectObject = sbToolProjectObject;
	            projectService_1.default.projectObject.$movingBlocks = new gridUtils_1.MovingBlocks(gridsContants_1.PROJECT_VERSIONS_LIST, true, query.tab, new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSIONS_LIST), projectService_1.default.projectObject.projectId));
	            projectService_1.default.projectObject = sbToolProjectObject.initAfterRead(routerParams.id === 'new');
	        });
	    };
	    ProjectDetail.prototype.componentDidUpdate = function (prevProps) {
	        if (this.idChanged(prevProps.params.id, this.props.params.id)) {
	            projectService_1.default.projectObject.$movingBlocks.searchExposedGrids(projectService_1.default.projectObject);
	        }
	    };
	    ProjectDetail.prototype.componentDidMount = function () {
	        console.debug("%c componentDidMount", "background-color: magenta");
	        projectService_1.default.projectObject.$movingBlocks.searchExposedGrids(projectService_1.default.projectObject);
	        console.log('project id', projectService_1.default.projectObject.projectId);
	    };
	    ProjectDetail.prototype.componentWillUnmount = function () {
	        projectService_1.default.projectObject = null;
	    };
	    ProjectDetail.prototype.findRootObject = function () {
	        return projectService_1.default.projectObject;
	    };
	    ProjectDetail.prototype.render = function () {
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column', padding: 20 } },
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.submitDeleteDialogRefHandler }),
	            react_1.default.createElement("div", null,
	                this.renderToolTipMenu(),
	                this.renderMainForm()),
	            this.renderVersions()));
	    };
	    ProjectDetail.module = metaConstant_1.MODULE.sbtool;
	    ProjectDetail.title = locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["Project"], ["Project"])));
	    ProjectDetail.icon = 'building-o';
	    ProjectDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectDetail.prototype, "onDelete", void 0);
	    ProjectDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectDetail);
	    return ProjectDetail;
	}(pageAncestor_1.default));
	exports.default = ProjectDetail;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var metaConstant_1 = __webpack_require__(13);
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var locales_1 = __webpack_require__(15);
	__webpack_require__(275);
	var projectVersionService_1 = tslib_1.__importDefault(__webpack_require__(111));
	var projectVersionService_2 = tslib_1.__importDefault(__webpack_require__(111));
	var projectVersionParamsForm_1 = tslib_1.__importDefault(__webpack_require__(2196));
	var projectVersionDomain_1 = __webpack_require__(959);
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var buttons_1 = __webpack_require__(27);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var formUtils_1 = __webpack_require__(14);
	var projectService_1 = tslib_1.__importDefault(__webpack_require__(406));
	var grid_1 = tslib_1.__importDefault(__webpack_require__(50));
	var gridComp_1 = tslib_1.__importStar(__webpack_require__(44));
	var material_ui_1 = __webpack_require__(127);
	var mui_theme_1 = __webpack_require__(119);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridUtils_1 = __webpack_require__(83);
	var entityConstants_1 = __webpack_require__(145);
	var gridsContants_1 = __webpack_require__(121);
	var projectVersionMaterialDomain_1 = __webpack_require__(962);
	var projectVersionMaterialForm_1 = tslib_1.__importStar(__webpack_require__(2212));
	var paramsService_1 = tslib_1.__importDefault(__webpack_require__(159));
	var projectVersionEnergyCarrierForm_1 = tslib_1.__importStar(__webpack_require__(2205));
	var projectVersionRoomForm_1 = tslib_1.__importStar(__webpack_require__(2214));
	var projectVersionRoomDomain_1 = __webpack_require__(963);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var projectVersionAreaForm_1 = tslib_1.__importStar(__webpack_require__(2202));
	var projectVersionAreaDomain_1 = __webpack_require__(2222);
	var projectVersionDoorDomain_1 = tslib_1.__importDefault(__webpack_require__(960));
	var projectVersionDoorForm_1 = tslib_1.__importStar(__webpack_require__(2203));
	var projectVersionDoorMaterialExpandComp_1 = tslib_1.__importDefault(__webpack_require__(2204));
	var projectVersionDoorService_1 = tslib_1.__importDefault(__webpack_require__(2242));
	var projectVersionWindowForm_1 = tslib_1.__importStar(__webpack_require__(2217));
	var projectVersionWindowExpandComp_1 = tslib_1.__importDefault(__webpack_require__(2216));
	var projectVersionLopMaterialExpandComp_1 = tslib_1.__importDefault(__webpack_require__(2209));
	var projectVersionWindowDomain_1 = __webpack_require__(2228);
	var projectVersionLopFillingsForm_1 = tslib_1.__importStar(__webpack_require__(2208));
	var projectVersionTreeForm_1 = tslib_1.__importStar(__webpack_require__(2215));
	var projectVersionTreeDomain_1 = tslib_1.__importDefault(__webpack_require__(2227));
	var projectVersionLopFillingDomain_1 = tslib_1.__importDefault(__webpack_require__(2224));
	var projectVersionLopProfilesForm_1 = tslib_1.__importStar(__webpack_require__(2210));
	var projectVersionLopProfileDomain_1 = tslib_1.__importDefault(__webpack_require__(2225));
	var projectVersionParkingForm_1 = tslib_1.__importStar(__webpack_require__(2213));
	var projectVersionParkingDomain_1 = tslib_1.__importDefault(__webpack_require__(2226));
	var projectVersionLifespanForm_1 = tslib_1.__importStar(__webpack_require__(2207));
	var projectMaterialsForm_1 = tslib_1.__importDefault(__webpack_require__(2200));
	var projectRunoffCoefficientForm_1 = tslib_1.__importStar(__webpack_require__(2201));
	var projectVersionForm_1 = tslib_1.__importDefault(__webpack_require__(2206));
	var routes_1 = __webpack_require__(75);
	var axios_config_1 = __webpack_require__(59);
	var projectService_2 = tslib_1.__importDefault(__webpack_require__(406));
	var loading_1 = __webpack_require__(262);
	var projectCapacitiesForm_1 = tslib_1.__importStar(__webpack_require__(2198));
	var projectVersionEnergyCarrierDomain_1 = __webpack_require__(961);
	var projectRunoffCoefficientDomain_1 = __webpack_require__(2221);
	var projectVersionCapacitiesDomain_1 = __webpack_require__(2223);
	var TabStyles = {
	    height: 50,
	    backgroundColor: '#F9F9F9',
	    borderRadius: 5,
	    boxShadow: " rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px"
	};
	var subTabsStyles = {
	    backgroundColor: '#F9F9F9',
	    borderRadius: 5,
	    boxShadow: " rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px"
	};
	var ProjectVersionDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionDetail, _super);
	    function ProjectVersionDetail() {
	        var _this = _super.call(this) || this;
	        // METHOD TABS
	        _this.renderGlobalMaterialsTab = function () {
	            var projectVersion = projectVersionService_1.default.projectVersion;
	            if (projectVersion.$new) {
	                return react_1.default.createElement("noscript", null);
	            }
	            var propsForForm = {
	                dataObject: projectVersionService_1.default.projectVersion,
	                rootObject: projectVersionService_1.default.projectVersion,
	                entity: mdEntityService_1.default.getEntity(entityConstants_1.PROJECT_MATERIAL_ENTITY),
	                entities: mdEntityService_1.default.entityMap
	            };
	            var rowMaterialsForm = (react_1.default.createElement(projectMaterialsForm_1.default, tslib_1.__assign({}, propsForForm)));
	            var projectMaterialsGrid = projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_MATERIAL_GRID);
	            var projectMaterialTabContent = (react_1.default.createElement(gridComp_1.default, { ref: gridsContants_1.PROJECT_MATERIAL_GRID, grid: projectMaterialsGrid, uiLocation: gridComp_1.UILOCATION.tab, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true, rootObject: projectVersion, key: 3.1 }));
	            return (react_1.default.createElement(material_ui_1.Tab, { label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Materials"], ["Materials"]))), style: subTabsStyles, key: gridsContants_1.PROJECT_MATERIAL_GRID }, projectMaterialTabContent));
	        };
	        _this.renderLifespanTab = function () {
	            var projectVersion = projectVersionService_1.default.projectVersion;
	            if (projectVersion.$new) {
	                return react_1.default.createElement("noscript", null);
	            }
	            var propsForForm = {
	                dataObject: projectVersionService_1.default.projectVersion,
	                rootObject: projectVersionService_1.default.projectVersion,
	                entity: mdEntityService_1.default.getEntity(entityConstants_1.PROJECT_VERSION_LIFESPAN_ENTITY),
	                entities: mdEntityService_1.default.entityMap
	            };
	            var rowLifespanForm = (react_1.default.createElement(projectVersionLifespanForm_1.default, tslib_1.__assign({}, propsForForm)));
	            var lifespanGrid = projectVersion.$movingBlocks.getBlock(gridsContants_1.LIFESPAN_LIST);
	            var lifespanTabContent = (react_1.default.createElement(gridComp_1.default, { ref: gridsContants_1.LIFESPAN_LIST, grid: lifespanGrid, uiLocation: gridComp_1.UILOCATION.tab, editFormName: projectVersionLifespanForm_1.ProjectVersionLifespanFormDefinition.formName, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true, rootObject: projectVersion, key: 2 }));
	            return (react_1.default.createElement(material_ui_1.Tab, { label: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Lifespan menu"], ["Lifespan menu"]))), style: subTabsStyles, key: gridsContants_1.LIFESPAN_LIST }, lifespanTabContent));
	        };
	        _this.renderEnergyCarriersTab = function () {
	            var projectVersion = projectVersionService_1.default.projectVersion;
	            if (projectVersion.$new) {
	                return react_1.default.createElement("noscript", null);
	            }
	            var propsForForm = {
	                dataObject: projectVersionService_1.default.projectVersion,
	                rootObject: projectVersionService_1.default.projectVersion,
	                entity: mdEntityService_1.default.getEntity(entityConstants_1.PROJECT_VERSION_ENERGY_CARRIER_ENTITY),
	                entities: mdEntityService_1.default.entityMap
	            };
	            var rowEnergyCarrierForm = (react_1.default.createElement(projectVersionEnergyCarrierForm_1.default, tslib_1.__assign({}, propsForForm)));
	            var energyCarriersGrid = projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_ENERGY_CARRIERS_LIST);
	            var energyCarriersTabContent = (react_1.default.createElement(gridComp_1.default, { ref: gridsContants_1.PROJECT_VERSION_ENERGY_CARRIERS_LIST, grid: energyCarriersGrid, uiLocation: gridComp_1.UILOCATION.tab, editFormName: projectVersionEnergyCarrierForm_1.ProjectVersionEnergyCarrierFormDefinition.formName, editForm: rowEnergyCarrierForm, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true, rootObject: projectVersion, editOverrideFn: _this.addEnergyCarrierCallback, showDelete: true, showEdit: true, deleteRowIcon: "fa fa-trash", key: 2 },
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onGridToolbar: true, label: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["New energy carrier"], ["New energy carrier"]))), permission: metaConstant_1.PERMISSION.New, onClick: _this.onAddEnergyCarrierClick, disabled: _this.state.isEnergyFormOpen })));
	            return (react_1.default.createElement(material_ui_1.Tab, { label: locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["Energy carriers"], ["Energy carriers"]))), style: subTabsStyles, key: gridsContants_1.PROJECT_VERSION_ENERGY_CARRIERS_LIST }, energyCarriersTabContent));
	        };
	        _this.onAddEnergyCarrierClick = function () {
	            console.log('addNewEnergyCarrier');
	            var materialsGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_ENERGY_CARRIERS_LIST);
	            if (materialsGrid.getEditedRows().length > 0) {
	                return;
	            }
	            var rowObject = new projectVersionEnergyCarrierDomain_1.ProjectVersionEnergyCarrier({
	                projectVersion: projectVersionService_1.default.projectVersion.createLov(),
	                $new: true,
	                $dirty: true,
	                $added: true,
	            });
	            materialsGrid.addFirstRow(rowObject);
	            var form = rowObject.getForm(projectVersionEnergyCarrierForm_1.ProjectVersionEnergyCarrierFormDefinition.formName);
	            _this.setState({ isEnergyFormOpen: true });
	            form.$open = true;
	        };
	        _this.addEnergyCarrierCallback = function (rootObject, modifiedRows, toDeleteRows, params) {
	            uiService_1.default.showToolbarActionFlag();
	            var energyCarriersGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_ENERGY_CARRIERS_LIST);
	            if (modifiedRows && modifiedRows.length === 1) {
	                var energyCarrier_1 = modifiedRows[0].rowObject;
	                return projectVersionService_2.default.saveProjectVersionEnergyCarrier(rootObject.versionId, energyCarrier_1).then(function (resp) {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    energyCarriersGrid.search(energyCarrier_1);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                    _this.setState({ isEnergyFormOpen: false });
	                });
	            }
	            if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
	                return projectVersionService_2.default.deleteProjectVersionEnergyCarrier(Number(toDeleteRows[0].rowObject.id)).then(function (resp) {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    energyCarriersGrid.search(null);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                });
	            }
	            projectVersionService_1.default.projectVersion.$dirty = false;
	            uiService_1.default.hideToolbarActionFlag();
	            _this.setState({ isEnergyFormOpen: false });
	            return energyCarriersGrid.search(null);
	        };
	        _this.renderRunoffCoefficientTab = function () {
	            var projectVersion = projectVersionService_1.default.projectVersion;
	            if (projectVersion.$new) {
	                return react_1.default.createElement("noscript", null);
	            }
	            var propsForForm = {
	                dataObject: projectVersionService_1.default.projectVersion,
	                rootObject: projectVersionService_1.default.projectVersion,
	                entity: mdEntityService_1.default.getEntity(entityConstants_1.PROJECT_RUNOFF_COEFFICIENT_ENTITY),
	                entities: mdEntityService_1.default.entityMap
	            };
	            var rowRunoffCoefficientForm = (react_1.default.createElement(projectRunoffCoefficientForm_1.default, tslib_1.__assign({}, propsForForm)));
	            var runoffGrid = projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_RUNOFF_COEFFICIENT_GRID);
	            var runoffCoefficientTabContent = (react_1.default.createElement(gridComp_1.default, { ref: gridsContants_1.PROJECT_RUNOFF_COEFFICIENT_GRID, grid: runoffGrid, uiLocation: gridComp_1.UILOCATION.tab, editFormName: projectRunoffCoefficientForm_1.ProjectRunoffCoefficientFormDefinition.formName, editForm: rowRunoffCoefficientForm, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true, rootObject: projectVersion, editOverrideFn: _this.addRunoffCoefficientCallback, showDelete: true, showEdit: true, deleteRowIcon: "fa fa-trash", key: 2 },
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onGridToolbar: true, label: locales_1.loc.i18n(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["New Runoff Coefficient"], ["New Runoff Coefficient"]))), permission: metaConstant_1.PERMISSION.New, onClick: _this.onAddRunoffCoefficientClick, disabled: _this.state.isRunoffCoefficientFormOpen })));
	            return (react_1.default.createElement(material_ui_1.Tab, { label: locales_1.loc.i18n(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["TM Runoff coefficients"], ["TM Runoff coefficients"]))), style: subTabsStyles, key: gridsContants_1.PROJECT_RUNOFF_COEFFICIENT_GRID }, runoffCoefficientTabContent));
	        };
	        _this.onAddRunoffCoefficientClick = function () {
	            console.log('AddRunoffCoefficient');
	            var runoffCoefficientGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_RUNOFF_COEFFICIENT_GRID);
	            if (runoffCoefficientGrid.getEditedRows().length > 0) {
	                return;
	            }
	            var rowObject = new projectRunoffCoefficientDomain_1.ProjectVersionRunoffCoefficient({
	                projectVersion: projectVersionService_1.default.projectVersion.createLov(),
	                $new: true,
	                $dirty: true,
	                $added: true,
	            });
	            runoffCoefficientGrid.addFirstRow(rowObject);
	            var form = rowObject.getForm(projectRunoffCoefficientForm_1.ProjectRunoffCoefficientFormDefinition.formName);
	            _this.setState({ isRunoffCoefficientFormOpen: true });
	            form.$open = true;
	        };
	        _this.addRunoffCoefficientCallback = function (rootObject, modifiedRows, toDeleteRows, params) {
	            uiService_1.default.showToolbarActionFlag();
	            var runoffCoefficientGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_RUNOFF_COEFFICIENT_GRID);
	            if (modifiedRows && modifiedRows.length === 1) {
	                var runoffCoefficient_1 = modifiedRows[0].rowObject;
	                return projectVersionService_2.default.saveProjectVersionRunoffCoefficient(rootObject.versionId, runoffCoefficient_1).then(function (resp) {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    runoffCoefficientGrid.search(runoffCoefficient_1);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                    _this.setState({ isRunoffCoefficientFormOpen: false });
	                });
	            }
	            if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
	                return projectVersionService_2.default.deleteProjectVersionRunoffCoefficient(Number(toDeleteRows[0].rowObject.id)).then(function (resp) {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    runoffCoefficientGrid.search(null);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                });
	            }
	            projectVersionService_1.default.projectVersion.$dirty = false;
	            uiService_1.default.hideToolbarActionFlag();
	            _this.setState({ isRunoffCoefficientFormOpen: false });
	            return runoffCoefficientGrid.search(null);
	        };
	        // PROJECT TABS
	        _this.renderCapacityTab = function () {
	            var projectVersion = projectVersionService_1.default.projectVersion;
	            if (projectVersion.$new) {
	                return react_1.default.createElement("noscript", null);
	            }
	            var propsForForm = {
	                dataObject: projectVersionService_1.default.projectVersion,
	                rootObject: projectVersionService_1.default.projectVersion,
	                entity: mdEntityService_1.default.getEntity(entityConstants_1.PROJECT_VERSION_CAPACITIES_ENTITY),
	                entities: mdEntityService_1.default.entityMap
	            };
	            var rowCapacitiesForm = (react_1.default.createElement(projectCapacitiesForm_1.default, tslib_1.__assign({}, propsForForm)));
	            var capacitiesGrid = projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_CAPACITIES_GRID);
	            var hasCapacity = capacitiesGrid.getTotalCount() > 0;
	            var capacitiesTabContent = (react_1.default.createElement(gridComp_1.default, { ref: gridsContants_1.PROJECT_VERSION_CAPACITIES_GRID, grid: capacitiesGrid, uiLocation: gridComp_1.UILOCATION.tab, editFormName: projectCapacitiesForm_1.ProjectVersionCapacitiesFormDefinition.formName, editForm: rowCapacitiesForm, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true, rootObject: projectVersion, editOverrideFn: _this.addCapacitiesCallback, showDelete: true, showEdit: true, deleteRowIcon: "fa fa-trash", key: 3 },
	                react_1.default.createElement(buttons_1.ZzFlatButton, { label: locales_1.loc.i18n(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["nastavit kapacity"], ["nastavit kapacity"]))), permission: metaConstant_1.PERMISSION.New, disabled: _this.state.isCapacitiesFormOpen || hasCapacity, onClick: _this.onAddCapacitiesClick })));
	            return (react_1.default.createElement(material_ui_1.Tab, { label: locales_1.loc.i18n(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["TP_01 Kapacity"], ["TP_01 Kapacity"]))), style: subTabsStyles, key: gridsContants_1.PROJECT_VERSION_CAPACITIES_GRID }, capacitiesTabContent));
	        };
	        _this.onAddCapacitiesClick = function () {
	            console.log('addNewCapacity');
	            var capacitiesGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_CAPACITIES_GRID);
	            if (capacitiesGrid.data && capacitiesGrid.getEditedRows().length > 0) {
	                return;
	            }
	            var rowObject = new projectVersionCapacitiesDomain_1.ProjectVersionCapacity({
	                projectVersion: projectVersionService_1.default.projectVersion.createLov(),
	                $new: true,
	                $dirty: true,
	                $added: true,
	            });
	            capacitiesGrid.addFirstRow(rowObject);
	            var form = rowObject.getForm(projectCapacitiesForm_1.ProjectVersionCapacitiesFormDefinition.formName);
	            _this.setState({ isCapacitiesFormOpen: true });
	            form.$open = true;
	        };
	        _this.addCapacitiesCallback = function (rootObject, modifiedRows, toDeleteRows) {
	            uiService_1.default.showToolbarActionFlag();
	            var capacitiesGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_CAPACITIES_GRID);
	            if (modifiedRows && modifiedRows.length === 1) {
	                var capacity_1 = modifiedRows[0].rowObject;
	                return projectVersionService_2.default.saveProjectVersionIdentification(rootObject.versionId, capacity_1).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    capacitiesGrid.search(capacity_1);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                    _this.setState({ isCapacitiesFormOpen: false });
	                });
	            }
	            if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
	                return projectVersionService_2.default.deleteProjectVersionIdentification(Number(toDeleteRows[0].rowObject.id)).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    capacitiesGrid.search(null);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                });
	            }
	            projectVersionService_1.default.projectVersion.$dirty = false;
	            uiService_1.default.hideToolbarActionFlag();
	            _this.setState({ isCapacitiesFormOpen: false });
	            return capacitiesGrid.search(null);
	        };
	        _this.renderMaterialsTab = function () {
	            var projectVersion = projectVersionService_1.default.projectVersion;
	            if (projectVersion.$new) {
	                return react_1.default.createElement("noscript", null);
	            }
	            var propsForForm = {
	                dataObject: projectVersionService_1.default.projectVersion,
	                rootObject: projectVersionService_1.default.projectVersion,
	                entity: mdEntityService_1.default.getEntity(entityConstants_1.PROJECT_VERSION_MATERIAL_ENTITY),
	                entities: mdEntityService_1.default.entityMap
	            };
	            var rowMaterialForm = (react_1.default.createElement(projectVersionMaterialForm_1.default, tslib_1.__assign({}, propsForForm)));
	            var materialsGrid = projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_MATERIALS_GRID);
	            var materialTabContent = (react_1.default.createElement(gridComp_1.default, { ref: gridsContants_1.PROJECT_VERSION_MATERIALS_GRID, grid: materialsGrid, uiLocation: gridComp_1.UILOCATION.tab, editFormName: projectVersionMaterialForm_1.ProjectVersionMaterialFormDefinition.formName, editForm: rowMaterialForm, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true, rootObject: projectVersion, editOverrideFn: _this.addMaterialCallback, showDelete: true, showEdit: true, deleteRowIcon: "fa fa-trash", key: 3 },
	                react_1.default.createElement(buttons_1.ZzFlatButton, { label: locales_1.loc.i18n(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["New material"], ["New material"]))), permission: metaConstant_1.PERMISSION.New, disabled: _this.state.isMaterialsFormOpen, onClick: _this.onAddMaterialClick })));
	            return (react_1.default.createElement(material_ui_1.Tab, { label: locales_1.loc.i18n(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["TP Materials"], ["TP Materials"]))), style: subTabsStyles, key: gridsContants_1.PROJECT_VERSION_MATERIALS_GRID }, materialTabContent));
	        };
	        _this.onAddMaterialClick = function () {
	            console.log('addNewMaterial');
	            var materialsGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_MATERIALS_GRID);
	            if (materialsGrid.data && materialsGrid.getEditedRows().length > 0) {
	                return;
	            }
	            var rowObject = new projectVersionMaterialDomain_1.ProjectVersionMaterial({
	                projectVersion: projectVersionService_1.default.projectVersion.createLov(),
	                $new: true,
	                $dirty: true,
	                $added: true,
	            });
	            materialsGrid.addFirstRow(rowObject);
	            var form = rowObject.getForm(projectVersionMaterialForm_1.ProjectVersionMaterialFormDefinition.formName);
	            _this.setState({ isMaterialsFormOpen: true });
	            form.$open = true;
	        };
	        _this.addMaterialCallback = function (rootObject, modifiedRows, toDeleteRows) {
	            uiService_1.default.showToolbarActionFlag();
	            var materialsGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_MATERIALS_GRID);
	            if (modifiedRows && modifiedRows.length === 1) {
	                var material_1 = modifiedRows[0].rowObject;
	                material_1.thermalCoefficient = 0;
	                material_1.code = "import";
	                material_1.so2Equivalent = 0;
	                material_1.c2h4Equivalent = 0;
	                material_1.co2Equivalent = 0;
	                material_1.po4Equivalent = 0;
	                material_1.lifespan = 0;
	                material_1.volume = 0;
	                material_1.r11Equivalent = 0;
	                material_1.area = 0;
	                material_1.primaryEnergy = 0;
	                return projectVersionService_2.default.saveProjectVersionMaterial(rootObject.versionId, material_1).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    materialsGrid.search(material_1);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                    _this.setState({ isMaterialsFormOpen: false });
	                });
	            }
	            if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
	                return projectVersionService_2.default.deleteProjectVersionMaterial(Number(toDeleteRows[0].rowObject.id)).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    materialsGrid.search(null);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                });
	            }
	            projectVersionService_1.default.projectVersion.$dirty = false;
	            uiService_1.default.hideToolbarActionFlag();
	            _this.setState({ isMaterialsFormOpen: false });
	            return materialsGrid.search(null);
	        };
	        _this.renderRoomsTab = function () {
	            var projectVersion = projectVersionService_1.default.projectVersion;
	            if (projectVersion.$new) {
	                return react_1.default.createElement("noscript", null);
	            }
	            var propsForForm = {
	                dataObject: projectVersionService_1.default.projectVersion,
	                rootObject: projectVersionService_1.default.projectVersion,
	                entity: mdEntityService_1.default.getEntity(entityConstants_1.PROJECT_VERSION_ROOM_ENTITY),
	                entities: mdEntityService_1.default.entityMap
	            };
	            var rowRoomForm = (react_1.default.createElement(projectVersionRoomForm_1.default, tslib_1.__assign({}, propsForForm)));
	            var roomsGrid = projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_ROOMS_LIST);
	            var roomsTabContent = (react_1.default.createElement(gridComp_1.default, { ref: gridsContants_1.PROJECT_VERSION_ROOMS_LIST, grid: roomsGrid, uiLocation: gridComp_1.UILOCATION.tab, editFormName: projectVersionRoomForm_1.ProjectVersionRoomFormDefinition.formName, editForm: rowRoomForm, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true, rootObject: projectVersion, editOverrideFn: _this.addRoomCallback, showDelete: true, showEdit: true, deleteRowIcon: "fa fa-trash", key: 4 },
	                react_1.default.createElement(buttons_1.ZzFlatButton, { label: locales_1.loc.i18n(templateObject_11 || (templateObject_11 = tslib_1.__makeTemplateObject(["New room"], ["New room"]))), permission: metaConstant_1.PERMISSION.New, disabled: _this.state.isRoomsFormOpen, onClick: _this.onAddRoomClick })));
	            return (react_1.default.createElement(material_ui_1.Tab, { label: locales_1.loc.i18n(templateObject_12 || (templateObject_12 = tslib_1.__makeTemplateObject(["Rooms"], ["Rooms"]))), style: subTabsStyles, key: gridsContants_1.PROJECT_VERSION_ROOMS_LIST }, roomsTabContent));
	        };
	        _this.onAddRoomClick = function () {
	            console.log('addNewProjectVersionRoom');
	            var roomsGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_ROOMS_LIST);
	            if (roomsGrid.data && roomsGrid.getEditedRows().length > 0) {
	                return;
	            }
	            var rowObject = new projectVersionRoomDomain_1.ProjectVersionRoom({
	                projectVersion: projectVersionService_1.default.projectVersion.createLov(),
	                $new: true,
	                $dirty: true,
	                $added: true,
	            });
	            roomsGrid.addFirstRow(rowObject);
	            var form = rowObject.getForm(projectVersionRoomForm_1.ProjectVersionRoomFormDefinition.formName);
	            _this.setState({ isRoomsFormOpen: true });
	            form.$open = true;
	        };
	        _this.addRoomCallback = function (rootObject, modifiedRows, toDeleteRows) {
	            uiService_1.default.showToolbarActionFlag();
	            var roomsGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_ROOMS_LIST);
	            if (modifiedRows && modifiedRows.length === 1) {
	                var room_1 = modifiedRows[0].rowObject;
	                return projectVersionService_2.default.saveProjectVersionRoom(rootObject.versionId, room_1).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    roomsGrid.search(room_1);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                    _this.setState({ isRoomsFormOpen: false });
	                });
	            }
	            if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
	                return projectVersionService_2.default.deleteProjectVersionRoom(Number(toDeleteRows[0].rowObject.id)).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    roomsGrid.search(null);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                });
	            }
	            projectVersionService_1.default.projectVersion.$dirty = false;
	            uiService_1.default.hideToolbarActionFlag();
	            _this.setState({ isRoomsFormOpen: false });
	            return roomsGrid.search(null);
	        };
	        _this.renderAreasTab = function () {
	            var projectVersion = projectVersionService_1.default.projectVersion;
	            if (projectVersion.$new) {
	                return react_1.default.createElement("noscript", null);
	            }
	            var propsForForm = {
	                dataObject: projectVersionService_1.default.projectVersion,
	                rootObject: projectVersionService_1.default.projectVersion,
	                entity: mdEntityService_1.default.getEntity(entityConstants_1.PROJECT_VERSION_AREA_ENTITY),
	                entities: mdEntityService_1.default.entityMap
	            };
	            var areasGrid = projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_AREA_LIST);
	            var rowAreaForm = (react_1.default.createElement(projectVersionAreaForm_1.default, tslib_1.__assign({}, propsForForm)));
	            var areasTabContent = (react_1.default.createElement(gridComp_1.default, { ref: gridsContants_1.PROJECT_VERSION_AREA_LIST, grid: areasGrid, uiLocation: gridComp_1.UILOCATION.tab, editFormName: projectVersionAreaForm_1.ProjectVersionAreaFormDefinition.formName, editForm: rowAreaForm, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true, rootObject: projectVersion, editOverrideFn: _this.addAreaCallback, showDelete: true, showEdit: true, deleteRowIcon: "fa fa-trash", key: 5 },
	                react_1.default.createElement(buttons_1.ZzFlatButton, { label: locales_1.loc.i18n(templateObject_13 || (templateObject_13 = tslib_1.__makeTemplateObject(["New area"], ["New area"]))), permission: metaConstant_1.PERMISSION.New, disabled: _this.state.isAreasFormOpen, onClick: _this.onAddAreaClick })));
	            return (react_1.default.createElement(material_ui_1.Tab, { label: locales_1.loc.i18n(templateObject_14 || (templateObject_14 = tslib_1.__makeTemplateObject(["Area"], ["Area"]))), style: subTabsStyles, key: gridsContants_1.PROJECT_VERSION_AREA_LIST }, areasTabContent));
	        };
	        _this.onAddAreaClick = function () {
	            console.log('addNewArea');
	            var areasGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_AREA_LIST);
	            if (areasGrid.getEditedRows().length > 0) {
	                return;
	            }
	            var rowObject = new projectVersionAreaDomain_1.ProjectVersionArea({
	                projectVersion: projectVersionService_1.default.projectVersion.createLov(),
	                $new: true,
	                $dirty: true,
	                $added: true,
	            });
	            areasGrid.addFirstRow(rowObject);
	            var form = rowObject.getForm(projectVersionAreaForm_1.ProjectVersionAreaFormDefinition.formName);
	            _this.setState({ isAreasFormOpen: true });
	            form.$open = true;
	        };
	        _this.addAreaCallback = function (rootObject, modifiedRows, toDeleteRows) {
	            uiService_1.default.showToolbarActionFlag();
	            var areasGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_AREA_LIST);
	            if (modifiedRows && modifiedRows.length === 1) {
	                var area_1 = modifiedRows[0].rowObject;
	                return projectVersionService_2.default.saveProjectVersionArea(rootObject.versionId, area_1).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    areasGrid.search(area_1);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                    _this.setState({ isAreasFormOpen: false });
	                });
	            }
	            if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
	                return projectVersionService_2.default.deleteProjectVersionArea(Number(toDeleteRows[0].rowObject.id)).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    areasGrid.search(null);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                });
	            }
	            projectVersionService_1.default.projectVersion.$dirty = false;
	            uiService_1.default.hideToolbarActionFlag();
	            _this.setState({ isAreasFormOpen: false });
	            return areasGrid.search(null);
	        };
	        _this.renderWindowsTab = function () {
	            var veryImportantWindow = new projectVersionWindowDomain_1.ProjectVersionWindow({});
	            var projectVersion = projectVersionService_1.default.projectVersion;
	            if (projectVersion.$new) {
	                return react_1.default.createElement("noscript", null);
	            }
	            var propsForForm = {
	                dataObject: projectVersionService_1.default.projectVersion,
	                rootObject: projectVersionService_1.default.projectVersion,
	                entity: mdEntityService_1.default.getEntity(entityConstants_1.PROJECT_VERSION_WINDOW_ENTITY),
	                entities: mdEntityService_1.default.entityMap
	            };
	            var rowWindowForm = (react_1.default.createElement(projectVersionWindowForm_1.default, tslib_1.__assign({}, propsForForm)));
	            var windowGrid = projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_WINDOW_LIST);
	            var windowTamContent = (react_1.default.createElement(gridComp_1.default, { ref: gridsContants_1.PROJECT_VERSION_WINDOW_LIST, grid: windowGrid, uiLocation: gridComp_1.UILOCATION.tab, editFormName: projectVersionWindowForm_1.ProjectVersionWindowFormDefinition.formName, editForm: rowWindowForm, editOverrideFn: _this.addWindowCallback, entities: mdEntityService_1.default.entityMap, ExpandComponent: projectVersionWindowExpandComp_1.default, hideGridConfig: true, hideCopyRow: true, rootObject: projectVersion, showDelete: true, showEdit: true, showExpand: true, deleteRowIcon: "fa fa-trash", key: 6 },
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onGridToolbar: true, label: locales_1.loc.i18n(templateObject_15 || (templateObject_15 = tslib_1.__makeTemplateObject(["New window"], ["New window"]))), permission: metaConstant_1.PERMISSION.New, disabled: _this.state.isWindowsFormOpen, onClick: _this.onAddWindowClick })));
	            return (react_1.default.createElement(material_ui_1.Tab, { label: locales_1.loc.i18n(templateObject_16 || (templateObject_16 = tslib_1.__makeTemplateObject(["Windows"], ["Windows"]))), style: subTabsStyles, key: gridsContants_1.PROJECT_VERSION_WINDOW_LIST }, windowTamContent));
	        };
	        _this.onAddWindowClick = function () {
	            console.log('onAddWindowClick');
	            var materialsGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_WINDOW_LIST);
	            if (materialsGrid.getEditedRows().length > 0) {
	                return;
	            }
	            var rowObject = new projectVersionWindowDomain_1.ProjectVersionWindow({
	                projectVersion: projectVersionService_1.default.projectVersion.createLov(),
	                $new: true,
	                $dirty: true,
	                $added: true,
	            });
	            materialsGrid.addFirstRow(rowObject);
	            var form = rowObject.getForm(projectVersionWindowForm_1.ProjectVersionWindowFormDefinition.formName);
	            _this.setState({ isWindowsFormOpen: true });
	            form.$open = true;
	        };
	        _this.addWindowCallback = function (rootObject, modifiedRows, toDeleteRows) {
	            uiService_1.default.showToolbarActionFlag();
	            var grid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_WINDOW_LIST);
	            if (modifiedRows && modifiedRows.length === 1) {
	                var window_1 = modifiedRows[0].rowObject;
	                return projectVersionService_2.default.saveProjectVersionWindow(rootObject.versionId, window_1).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    grid.search(window_1);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                    _this.setState({ isWindowsFormOpen: false });
	                });
	            }
	            if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
	                return projectVersionService_2.default.deleteProjectVersionWindow(Number(toDeleteRows[0].rowObject.id)).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    grid.search(null);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                });
	            }
	            projectVersionService_1.default.projectVersion.$dirty = false;
	            uiService_1.default.hideToolbarActionFlag();
	            _this.setState({ isWindowsFormOpen: false });
	            return grid.search(null);
	        };
	        _this.renderDoorsTab = function () {
	            var projectVersion = projectVersionService_1.default.projectVersion;
	            if (projectVersion.$new) {
	                return react_1.default.createElement("noscript", null);
	            }
	            // Nemazat, nevim jak, ale bez toho to nefunguje
	            var veryImportantDoor = new projectVersionDoorDomain_1.default({});
	            var propsForForm = {
	                dataObject: projectVersionService_1.default.projectVersion,
	                rootObject: projectVersionService_1.default.projectVersion,
	                entity: mdEntityService_1.default.getEntity(entityConstants_1.PROJECT_VERSION_DOOR_ENTITY),
	                entities: mdEntityService_1.default.entityMap
	            };
	            var rowDoorForm = (react_1.default.createElement(projectVersionDoorForm_1.default, tslib_1.__assign({}, propsForForm)));
	            var doorsGrid = projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_DOOR_LIST);
	            var doorsTabContent = (react_1.default.createElement(gridComp_1.default, { ref: gridsContants_1.PROJECT_VERSION_DOOR_LIST, grid: doorsGrid, uiLocation: gridComp_1.UILOCATION.tab, entities: mdEntityService_1.default.entityMap, editFormName: projectVersionDoorForm_1.ProjectVersionDoorFormDefinition.formName, editForm: rowDoorForm, hideGridConfig: true, hideCopyRow: true, rootObject: projectVersion, showDelete: true, deleteRowIcon: "fa fa-trash", showExpand: true, showEdit: true, editOverrideFn: _this.addDoorCallback, ExpandComponent: projectVersionDoorMaterialExpandComp_1.default, key: 7 },
	                react_1.default.createElement(buttons_1.ZzFlatButton, { label: locales_1.loc.i18n(templateObject_17 || (templateObject_17 = tslib_1.__makeTemplateObject(["New door"], ["New door"]))), permission: metaConstant_1.PERMISSION.New, onClick: _this.onAddDoorClick, disabled: _this.state.isDoorsFormOpen })));
	            return (react_1.default.createElement(material_ui_1.Tab, { label: locales_1.loc.i18n(templateObject_18 || (templateObject_18 = tslib_1.__makeTemplateObject(["Doors"], ["Doors"]))), style: subTabsStyles, key: gridsContants_1.PROJECT_VERSION_DOOR_LIST }, doorsTabContent));
	        };
	        _this.addDoorCallback = function (rootObject, modifiedRows, toDeleteRows) {
	            uiService_1.default.showToolbarActionFlag();
	            var doorGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_DOOR_LIST);
	            if (modifiedRows && modifiedRows.length === 1) {
	                var door_1 = modifiedRows[0].rowObject;
	                return projectVersionDoorService_1.default.saveProjectVersionDoor(rootObject.versionId, door_1).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    doorGrid.search(door_1);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                    _this.setState({ isDoorsFormOpen: false });
	                });
	            }
	            if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
	                return projectVersionDoorService_1.default.deleteProjectVersionDoor(Number(toDeleteRows[0].rowObject.id)).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    doorGrid.search(null);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                });
	            }
	            projectVersionService_1.default.projectVersion.$dirty = false;
	            uiService_1.default.hideToolbarActionFlag();
	            _this.setState({ isDoorsFormOpen: false });
	            return doorGrid.search(null);
	        };
	        _this.onAddDoorClick = function () {
	            console.log('addNewDoor');
	            var doorGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_DOOR_LIST);
	            if (doorGrid.getEditedRows().length > 0) {
	                return;
	            }
	            var rowObject = new projectVersionDoorDomain_1.default({
	                projectVersion: projectVersionService_1.default.projectVersion.createLov(),
	                $new: true,
	                $dirty: true,
	                $added: true,
	            });
	            doorGrid.addFirstRow(rowObject);
	            var form = rowObject.getForm(projectVersionDoorForm_1.ProjectVersionDoorFormDefinition.formName);
	            _this.setState({ isDoorsFormOpen: true });
	            form.$open = true;
	        };
	        _this.renderLopFillingTab = function () {
	            var projectVersion = projectVersionService_1.default.projectVersion;
	            if (projectVersion.$new) {
	                return react_1.default.createElement("noscript", null);
	            }
	            var propsForForm = {
	                dataObject: projectVersionService_1.default.projectVersion,
	                rootObject: projectVersionService_1.default.projectVersion,
	                entity: mdEntityService_1.default.getEntity(entityConstants_1.PROJECT_VERSION_LOP_FILLINGS_ENTITY),
	                entities: mdEntityService_1.default.entityMap
	            };
	            var rowLopFillingForm = (react_1.default.createElement(projectVersionLopFillingsForm_1.default, tslib_1.__assign({}, propsForForm)));
	            var lopFillingsGrid = projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_LOP_FILLINGS_GRID);
	            var lopFillingsTabContent = (react_1.default.createElement(gridComp_1.default, { ref: gridsContants_1.PROJECT_VERSION_LOP_FILLINGS_GRID, grid: lopFillingsGrid, uiLocation: gridComp_1.UILOCATION.tab, editFormName: projectVersionLopFillingsForm_1.ProjectVersionLopFillingsFormDefinition.formName, editForm: rowLopFillingForm, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true, rootObject: projectVersion, editOverrideFn: _this.addLopFillingsCallback, showDelete: true, showExpand: true, showEdit: true, deleteRowIcon: "fa fa-trash", key: 8 },
	                react_1.default.createElement(buttons_1.ZzFlatButton, { label: locales_1.loc.i18n(templateObject_19 || (templateObject_19 = tslib_1.__makeTemplateObject(["New LOP"], ["New LOP"]))), permission: metaConstant_1.PERMISSION.New, disabled: _this.state.isLopFillingsFormOpen, onClick: _this.onAddLopFillingsClick })));
	            return (react_1.default.createElement(material_ui_1.Tab, { label: locales_1.loc.i18n(templateObject_20 || (templateObject_20 = tslib_1.__makeTemplateObject(["Lop Fillings"], ["Lop Fillings"]))), style: subTabsStyles, key: gridsContants_1.PROJECT_VERSION_LOP_FILLINGS_GRID }, lopFillingsTabContent));
	        };
	        _this.addLopFillingsCallback = function (rootObject, modifiedRows, toDeleteRows) {
	            uiService_1.default.showToolbarActionFlag();
	            var grid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_LOP_FILLINGS_GRID);
	            if (modifiedRows && modifiedRows.length === 1) {
	                var lop_1 = modifiedRows[0].rowObject;
	                return projectVersionService_2.default.saveProjectVersionLopsFillings(rootObject.versionId, lop_1).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    grid.search(lop_1);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                    _this.setState({ isLopFillingsFormOpen: false });
	                });
	            }
	            if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
	                return projectVersionService_2.default.deleteProjectVersionLopsFillings(Number(toDeleteRows[0].rowObject.id)).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    grid.search(null);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                });
	            }
	            projectVersionService_1.default.projectVersion.$dirty = false;
	            uiService_1.default.hideToolbarActionFlag();
	            _this.setState({ isLopFillingsFormOpen: false });
	            return grid.search(null);
	        };
	        _this.onAddLopFillingsClick = function () {
	            var lopFillingsGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_LOP_FILLINGS_GRID);
	            if (lopFillingsGrid.getEditedRows().length > 0) {
	                return;
	            }
	            var rowObject = new projectVersionLopFillingDomain_1.default({
	                projectVersion: projectVersionService_1.default.projectVersion.createLov(),
	                $new: true,
	                $dirty: true,
	                $added: true,
	            });
	            lopFillingsGrid.addFirstRow(rowObject);
	            var form = rowObject.getForm(projectVersionLopFillingsForm_1.ProjectVersionLopFillingsFormDefinition.formName);
	            _this.setState({ isLopFillingsFormOpen: true });
	            form.$open = true;
	        };
	        _this.renderLopsProfilesTab = function () {
	            var projectVersion = projectVersionService_1.default.projectVersion;
	            if (projectVersion.$new) {
	                return react_1.default.createElement("noscript", null);
	            }
	            var propsForForm = {
	                dataObject: projectVersionService_1.default.projectVersion,
	                rootObject: projectVersionService_1.default.projectVersion,
	                entity: mdEntityService_1.default.getEntity(entityConstants_1.PROJECT_VERSION_LOP_PROFILES_ENTITY),
	                entities: mdEntityService_1.default.entityMap
	            };
	            var rowLopForm = (react_1.default.createElement(projectVersionLopProfilesForm_1.default, tslib_1.__assign({}, propsForForm)));
	            var lopProfilesGrid = projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_LOP_PROFILES_GRID);
	            var lopProfilesTabContent = (react_1.default.createElement(gridComp_1.default, { ref: gridsContants_1.PROJECT_VERSION_LOP_PROFILES_GRID, grid: lopProfilesGrid, uiLocation: gridComp_1.UILOCATION.tab, editFormName: projectVersionLopProfilesForm_1.ProjectVersionLopProfilesFormDefinition.formName, editForm: rowLopForm, entities: mdEntityService_1.default.entityMap, rootObject: projectVersion, editOverrideFn: _this.addLopProfilesCallback, showDelete: true, showExpand: true, showEdit: true, deleteRowIcon: "fa fa-trash", ExpandComponent: projectVersionLopMaterialExpandComp_1.default, key: 9 },
	                react_1.default.createElement(buttons_1.ZzFlatButton, { label: locales_1.loc.i18n(templateObject_21 || (templateObject_21 = tslib_1.__makeTemplateObject(["New LOP"], ["New LOP"]))), permission: metaConstant_1.PERMISSION.New, disabled: _this.state.isLopProfilesFormOpen, onClick: _this.onAddLopProfilesClick })));
	            return (react_1.default.createElement(material_ui_1.Tab, { label: locales_1.loc.i18n(templateObject_22 || (templateObject_22 = tslib_1.__makeTemplateObject(["Lop Profiles"], ["Lop Profiles"]))), style: subTabsStyles, key: gridsContants_1.PROJECT_VERSION_LOP_PROFILES_GRID }, lopProfilesTabContent));
	        };
	        _this.addLopProfilesCallback = function (rootObject, modifiedRows, toDeleteRows) {
	            uiService_1.default.showToolbarActionFlag();
	            var grid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_LOP_PROFILES_GRID);
	            if (modifiedRows && modifiedRows.length === 1) {
	                var lopProfiles_1 = modifiedRows[0].rowObject;
	                console.log("SENDING DATA FROM LOP PROFILES", lopProfiles_1);
	                return projectVersionService_2.default.saveProjectVersionLopsProfiles(rootObject.versionId, lopProfiles_1).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    grid.search(lopProfiles_1);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                    _this.setState({ isLopProfilesFormOpen: false });
	                });
	            }
	            if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
	                return projectVersionService_2.default.deleteProjectVersionLopsProfiles(Number(toDeleteRows[0].rowObject.id)).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    grid.search(null);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                });
	            }
	            projectVersionService_1.default.projectVersion.$dirty = false;
	            uiService_1.default.hideToolbarActionFlag();
	            _this.setState({ isLopProfilesFormOpen: false });
	            return grid.search(null);
	        };
	        _this.onAddLopProfilesClick = function () {
	            var lopProfilesGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_LOP_PROFILES_GRID);
	            if (lopProfilesGrid.getEditedRows().length > 0) {
	                return;
	            }
	            var rowObject = new projectVersionLopProfileDomain_1.default({
	                projectVersion: projectVersionService_1.default.projectVersion.createLov(),
	                $new: true,
	                $dirty: true,
	                $added: true,
	            });
	            lopProfilesGrid.addFirstRow(rowObject);
	            var form = rowObject.getForm(projectVersionLopProfilesForm_1.ProjectVersionLopProfilesFormDefinition.formName);
	            _this.setState({ isLopProfilesFormOpen: true });
	            form.$open = true;
	        };
	        _this.renderParkingTab = function () {
	            var projectVersion = projectVersionService_1.default.projectVersion;
	            if (projectVersion.$new) {
	                return react_1.default.createElement("noscript", null);
	            }
	            var propsForForm = {
	                dataObject: projectVersionService_1.default.projectVersion,
	                rootObject: projectVersionService_1.default.projectVersion,
	                entity: mdEntityService_1.default.getEntity(entityConstants_1.PROJECT_VERSION_PARKING_ENTITY),
	                entities: mdEntityService_1.default.entityMap
	            };
	            var rowLopForm = (react_1.default.createElement(projectVersionParkingForm_1.default, tslib_1.__assign({}, propsForForm)));
	            var parkingGrid = projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_PARKING_GRID);
	            var parkingTabContent = (react_1.default.createElement(gridComp_1.default, { ref: gridsContants_1.PROJECT_VERSION_PARKING_GRID, grid: parkingGrid, uiLocation: gridComp_1.UILOCATION.tab, editFormName: projectVersionParkingForm_1.ProjectVersionParkingFormDefinition.formName, editForm: rowLopForm, entities: mdEntityService_1.default.entityMap, rootObject: projectVersion, editOverrideFn: _this.addParkingCallback, showDelete: true, showExpand: true, showEdit: true, deleteRowIcon: "fa fa-trash", key: 10 },
	                react_1.default.createElement(buttons_1.ZzFlatButton, { label: locales_1.loc.i18n(templateObject_23 || (templateObject_23 = tslib_1.__makeTemplateObject(["New Parking"], ["New Parking"]))), permission: metaConstant_1.PERMISSION.New, disabled: _this.state.isParkingFormOpen, onClick: _this.onAddParkingClick })));
	            return (react_1.default.createElement(material_ui_1.Tab, { label: locales_1.loc.i18n(templateObject_24 || (templateObject_24 = tslib_1.__makeTemplateObject(["Parking"], ["Parking"]))), style: subTabsStyles, key: gridsContants_1.PROJECT_VERSION_PARKING_GRID }, parkingTabContent));
	        };
	        _this.addParkingCallback = function (rootObject, modifiedRows, toDeleteRows) {
	            uiService_1.default.showToolbarActionFlag();
	            var grid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_PARKING_GRID);
	            if (modifiedRows && modifiedRows.length === 1) {
	                var parking_1 = modifiedRows[0].rowObject;
	                return projectVersionService_2.default.saveProjectVersionParking(rootObject.versionId, parking_1).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    grid.search(parking_1);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                    _this.setState({ isLopParkingFormOpen: false });
	                });
	            }
	            if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
	                return projectVersionService_2.default.deleteProjectVersionParking(Number(toDeleteRows[0].rowObject.id)).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    grid.search(null);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                });
	            }
	            projectVersionService_1.default.projectVersion.$dirty = false;
	            uiService_1.default.hideToolbarActionFlag();
	            _this.setState({ isLopParkingFormOpen: false });
	            return grid.search(null);
	        };
	        _this.onAddParkingClick = function () {
	            var parkingGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_PARKING_GRID);
	            if (parkingGrid.getEditedRows().length > 0) {
	                return;
	            }
	            var rowObject = new projectVersionParkingDomain_1.default({
	                projectVersion: projectVersionService_1.default.projectVersion.createLov(),
	                $new: true,
	                $dirty: true,
	                $added: true,
	            });
	            parkingGrid.addFirstRow(rowObject);
	            var form = rowObject.getForm(projectVersionParkingForm_1.ProjectVersionParkingFormDefinition.formName);
	            _this.setState({ isLopParkingFormOpen: true });
	            form.$open = true;
	        };
	        _this.renderTreesTab = function () {
	            var projectVersion = projectVersionService_1.default.projectVersion;
	            if (projectVersion.$new) {
	                return react_1.default.createElement("noscript", null);
	            }
	            var propsForForm = {
	                dataObject: projectVersionService_1.default.projectVersion,
	                rootObject: projectVersionService_1.default.projectVersion,
	                entity: mdEntityService_1.default.getEntity(entityConstants_1.PROJECT_VERSION_TREE_ENTITY),
	                entities: mdEntityService_1.default.entityMap
	            };
	            var rowTreeForm = (react_1.default.createElement(projectVersionTreeForm_1.default, tslib_1.__assign({}, propsForForm)));
	            var treesGrid = projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_TREE_LIST);
	            var treesTabContent = (react_1.default.createElement(gridComp_1.default, { ref: gridsContants_1.PROJECT_VERSION_TREE_LIST, grid: treesGrid, uiLocation: gridComp_1.UILOCATION.tab, editFormName: projectVersionTreeForm_1.ProjectVersionTreeFormDefinition.formName, editForm: rowTreeForm, entities: mdEntityService_1.default.entityMap, hideGridConfig: true, hideCopyRow: true, rootObject: projectVersion, editOverrideFn: _this.addTreeCallback, showDelete: true, showEdit: true, deleteRowIcon: "fa fa-trash", key: 11 },
	                react_1.default.createElement(buttons_1.ZzFlatButton, { label: locales_1.loc.i18n(templateObject_25 || (templateObject_25 = tslib_1.__makeTemplateObject(["New tree"], ["New tree"]))), permission: metaConstant_1.PERMISSION.New, disabled: _this.state.isTreesFormOpen, onClick: _this.onAddTreeClick })));
	            return (react_1.default.createElement(material_ui_1.Tab, { label: locales_1.loc.i18n(templateObject_26 || (templateObject_26 = tslib_1.__makeTemplateObject(["Trees"], ["Trees"]))), style: subTabsStyles, key: gridsContants_1.PROJECT_VERSION_TREE_LIST }, treesTabContent));
	        };
	        _this.addTreeCallback = function (rootObject, modifiedRows, toDeleteRows) {
	            uiService_1.default.showToolbarActionFlag();
	            var grid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_TREE_LIST);
	            if (modifiedRows && modifiedRows.length === 1) {
	                var tree_1 = modifiedRows[0].rowObject;
	                return projectVersionService_2.default.saveProjectVersionTree(rootObject.versionId, tree_1).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    grid.search(tree_1);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                    _this.setState({ isTreesFormOpen: false });
	                });
	            }
	            if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
	                return projectVersionService_2.default.deleteProjectVersionTree(Number(toDeleteRows[0].rowObject.id)).then(function () {
	                    projectVersionService_1.default.projectVersion.$dirty = false;
	                    uiService_1.default.hideToolbarActionFlag();
	                    grid.search(null);
	                    paramsService_1.default.loadResults();
	                    paramsService_1.default.loadCriterionVersions();
	                });
	            }
	            projectVersionService_1.default.projectVersion.$dirty = false;
	            uiService_1.default.hideToolbarActionFlag();
	            _this.setState({ isTreesFormOpen: false });
	            return grid.search(null);
	        };
	        _this.onAddTreeClick = function () {
	            console.log('addNewTree');
	            var treesGrid = projectVersionService_1.default.projectVersion.$movingBlocks.getBlock(gridsContants_1.PROJECT_VERSION_TREE_LIST);
	            if (treesGrid.getEditedRows().length > 0) {
	                return;
	            }
	            var rowObject = new projectVersionTreeDomain_1.default({
	                projectVersion: projectVersionService_1.default.projectVersion.createLov(),
	                $new: true,
	                $dirty: true,
	                $added: true,
	            });
	            treesGrid.addFirstRow(rowObject);
	            var form = rowObject.getForm(projectVersionTreeForm_1.ProjectVersionTreeFormDefinition.formName);
	            _this.setState({ isTreesFormOpen: true });
	            form.$open = true;
	        };
	        _this.renderProjectVersionForm = function () {
	            var propsForCreateForm = {
	                dataObject: projectVersionService_1.default.projectVersion,
	                rootObject: projectVersionService_1.default.projectVersion,
	                entity: mdEntityService_1.default.getEntity(entityConstants_1.PROJECT_VERSION_ENTITY),
	                entities: mdEntityService_1.default.entityMap
	            };
	            return (react_1.default.createElement("form", { style: { borderBottom: "1px solid #e7e7e7", marginBottom: 2 } },
	                react_1.default.createElement(projectVersionForm_1.default, tslib_1.__assign({}, propsForCreateForm, { key: 1 }))));
	        };
	        _this.onSaveProjectVersion = function () {
	            console.log('onSave ');
	            uiService_1.default.showToolbarActionFlag();
	            var result = (0, formUtils_1.preSave)(projectVersionService_1.default.projectVersion);
	            if (!result) {
	                return;
	            }
	            var promise;
	            var copyId = _this.props.query.copyId;
	            if (projectVersionService_1.default.projectVersion.$new && _this.props.query.copyId) {
	                console.info("Copying project version with params");
	                promise = projectVersionService_1.default.copyProjectVersion(copyId, projectVersionService_1.default.projectVersion);
	            }
	            else {
	                console.info("Saving new project version");
	                promise = projectVersionService_1.default.saveProjectVersion(projectVersionService_1.default.projectVersion);
	            }
	            promise.then((0, mobx_1.action)("saveProjectVersion-action", function (domainObject) {
	                var wasNew = projectVersionService_1.default.projectVersion.cleanAfterSave(domainObject, true);
	                if (wasNew) {
	                    _this.context.router.replaceWith('sbToolProjectVersionDetail', { id: projectVersionService_1.default.projectVersion.versionId });
	                    // TODO: initiate fetch data without page reload
	                    window.location.reload(); // TODO : REMOVE IT
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            }), function (error) {
	                projectVersionService_1.default.projectVersion.$errors = error.getMessages();
	            });
	        };
	        _this.onCopyProjectVersion = function () {
	            console.log('onCopy');
	            _this.context.router.transitionTo("sbToolProjectVersionDetail", { id: 'copy' }, { copyId: projectVersionService_1.default.projectVersion.id });
	        };
	        _this.onDeleteProjectVersion = function () {
	            var projectVersion = projectVersionService_1.default.projectVersion;
	            projectVersionService_1.default.deleteProjectVersion(projectVersion.versionId)
	                .then(function () {
	                _this.context.router.transitionTo("sbToolProjectDetail", { id: projectVersion.project.projectId });
	            }, function (error) {
	                projectVersionService_1.default.projectVersion.$errors = error.getMessages();
	            });
	        };
	        _this.handleDeleteVersion = function () {
	            _this.modalWindow.open(function () {
	                _this.onDeleteProjectVersion();
	            }, function () {
	                return;
	            }, 'Chcete verzi vymazat? (Tuto akci nelze zastavit. Data budou trvale vymazána)');
	        };
	        _this.renderToolTipMenu = function () {
	            var query = _this.props.query;
	            var projectVersion = projectVersionService_1.default.projectVersion;
	            var greenButtonStyle = {
	                backgroundColor: projectVersion.$dirty ? 'PaleGreen' : ''
	            };
	            return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: query.gridLocation, backAction: _this.onBack, backDisabled: History.length <= 1, historize: true, entityName: entityConstants_1.PROJECT_VERSION_ENTITY, entityId: projectVersion.versionId },
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: _this.onSaveProjectVersion, disabled: !projectVersion.$dirty, label: locales_1.loc.i18n(templateObject_27 || (templateObject_27 = tslib_1.__makeTemplateObject(["Save Version"], ["Save Version"]))), permission: projectVersion.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update, style: greenButtonStyle }),
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: _this.onCopyProjectVersion, disabled: projectVersion.$new, label: locales_1.loc.i18n(templateObject_28 || (templateObject_28 = tslib_1.__makeTemplateObject(["Copy Version"], ["Copy Version"]))), permission: metaConstant_1.PERMISSION.New }),
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: _this.handleDeleteVersion, disabled: projectVersion.$new, label: locales_1.loc.i18n(templateObject_29 || (templateObject_29 = tslib_1.__makeTemplateObject(["Delete Version"], ["Delete Version"]))), permission: metaConstant_1.PERMISSION.Delete }),
	                _this.state.certificate ?
	                    react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: _this.downloadPDF, label: locales_1.loc.i18n(templateObject_30 || (templateObject_30 = tslib_1.__makeTemplateObject(["download certificate"], ["download certificate"]))) })
	                    :
	                        react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: _this.handleGenerateCertificate, label: locales_1.loc.i18n(templateObject_31 || (templateObject_31 = tslib_1.__makeTemplateObject(["vygenerovat certifik\u00E1t"], ["vygenerovat certifik\u00E1t"]))) }),
	                react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: function () { return _this.setState({ isProjectInfoOpen: !_this.state.isProjectInfoOpen }); }, label: !_this.state.isProjectInfoOpen ? (locales_1.loc.i18n(templateObject_32 || (templateObject_32 = tslib_1.__makeTemplateObject(["Otev\u0159\u00EDt informace o projektu"], ["Otev\u0159\u00EDt informace o projektu"])))) : (locales_1.loc.i18n(templateObject_33 || (templateObject_33 = tslib_1.__makeTemplateObject(["Zav\u0159\u00EDt informace o projektu"], ["Zav\u0159\u00EDt informace o projektu"])))) }),
	                react_1.default.createElement(buttons_1.SecuredZzUploadFlatButton, { label: locales_1.loc.i18n(templateObject_34 || (templateObject_34 = tslib_1.__makeTemplateObject(["Importovat materi\u00E1ly projektu"], ["Importovat materi\u00E1ly projektu"]))), permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.sbToolProjectDetail, handleFileUpload: _this.handleUploadMaterials, accept: ".xlsx, .xls" }),
	                react_1.default.createElement(buttons_1.SecuredZzUploadFlatButton, { label: locales_1.loc.i18n(templateObject_35 || (templateObject_35 = tslib_1.__makeTemplateObject(["importovat data projektu"], ["importovat data projektu"]))), permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.sbToolProjectDetail, handleFileUpload: _this.handleFileProjectData, accept: ".xlsx, .xls" }),
	                react_1.default.createElement(buttons_1.SecuredZzUploadFlatButton, { label: _this.state.image ? (locales_1.loc.i18n(templateObject_36 || (templateObject_36 = tslib_1.__makeTemplateObject(["nahr\u00E1t nove foto projektu"], ["nahr\u00E1t nove foto projektu"])))) : (locales_1.loc.i18n(templateObject_37 || (templateObject_37 = tslib_1.__makeTemplateObject(["nahr\u00E1t foto projektu"], ["nahr\u00E1t foto projektu"])))), permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.sbToolProjectDetail, handleFileUpload: _this.handleUploadProjectImage, accept: ".jpeg, .jpg" })));
	        };
	        _this.handleUploadMaterials = function (files) {
	            _this.setState({ isImportingMaterials: true });
	            var projectVersionId = projectVersionService_1.default.projectVersion.id;
	            var data = new FormData();
	            data.append("file", files.item(0), files.item(0).name);
	            return axios_config_1.uploadAxios.post("/sbtool/project-version/".concat(projectVersionId, "/import"), data, { showPrettyError: true })
	                .then(function (resp) {
	                var importRes = resp.data;
	                _this.setState({ isImportingMaterials: false });
	                if (importRes.importErrors.length === 0) {
	                    // TODO: initiate fetch data without page reload
	                    window.location.reload();
	                    return;
	                }
	            }).catch(function (e) {
	                console.error("error while import project materials--->", e);
	            });
	        };
	        _this.handleFileProjectData = function (files) {
	            _this.setState({ isImportingData: true });
	            var projectVersionId = projectVersionService_1.default.projectVersion.id;
	            var data = new FormData();
	            data.append("file", files.item(0), files.item(0).name);
	            return axios_config_1.uploadAxios.post("/sbtool/project-version/".concat(projectVersionId, "/import-project"), data, { showPrettyError: true })
	                .then(function (resp) {
	                var importRes = resp.data;
	                _this.setState({ isImportingData: false });
	                if (importRes.importErrors.length === 0) {
	                    // TODO: initiate fetch data without page reload
	                    window.location.reload();
	                    return;
	                }
	            }).catch(function (e) {
	                console.error("error while import project materials--->", e);
	            });
	        };
	        _this.handleGenerateCertificate = function () {
	            _this.modalWindow.open(function () {
	                var projectVersionId = projectVersionService_1.default.projectVersion.versionId;
	                projectVersionService_1.default.finishProject(projectVersionId)
	                    .then(function (resp) { return console.warn('handleGenerateCertificate resp', resp); })
	                    .then(function () { return _this.loadPDF(projectVersionId); })
	                    .catch(function (error) { return console.error(error); });
	            }, function () {
	                return;
	            }, 'Chcete vygenerovat certifikát? Po vygenerování nelze verzi projektu změnit (akci nelze zrušit).');
	        };
	        _this.loadPDF = function (id) {
	            projectVersionService_1.default.downloadCertificate(id).then(function (resp) {
	                if (resp.data) {
	                    _this.setState({ certificate: resp.data });
	                }
	            });
	        };
	        _this.downloadPDF = function () {
	            var certificate = _this.state.certificate;
	            var projectVersion = projectVersionService_1.default.projectVersion;
	            if (certificate) {
	                var url = window.URL.createObjectURL(new Blob([certificate]));
	                var link = document.createElement('a');
	                link.href = url;
	                link.setAttribute('download', 'Certificate-' + projectVersion.project.name + '-ver.' + projectVersion.version + '.pdf');
	                document.body.appendChild(link);
	                link.click();
	            }
	        };
	        _this.renderProjectInfoHeader = function () {
	            var project = projectVersionService_1.default.projectVersion.project;
	            var name = project.name, description = project.description, address = project.address, cadastralParcelNumber = project.cadastralParcelNumber, cadastralParcelArea = project.cadastralParcelArea, documentationCreator = project.documentationCreator, documentationCreated = project.documentationCreated, documentationLevel = project.documentationLevel, evaluator = project.evaluator, buildingType = project.buildingType, schoolLevel = project.schoolLevel, documentationVersion = project.documentationVersion, projectEvaluationFinished = project.projectEvaluationFinished, estimatedCosts = project.estimatedCosts, anticipatedCommissioning = project.anticipatedCommissioning, evaluationPhase = project.evaluationPhase, evaluationType = project.evaluationType, certified_person = project.certified_person, projectCreated = project.projectCreated;
	            function accentDataValue(value) {
	                var textStyle = {
	                    color: "#666"
	                };
	                if (typeof value === "boolean") {
	                    return react_1.default.createElement("span", { style: textStyle }, value ? "Ano" : "Ne");
	                }
	                else if (typeof value === "object") {
	                    return react_1.default.createElement("span", { style: textStyle }, value.label ? value.label : '-');
	                }
	                else {
	                    return react_1.default.createElement("span", { style: textStyle }, value ? value : '-');
	                }
	            }
	            return (react_1.default.createElement("div", { style: { display: "flex", justifyContent: "space-around", color: "#9e9e9e", borderBottom: "1px solid #E7E7E7" } },
	                react_1.default.createElement("ul", { style: { listStyle: "none" } },
	                    react_1.default.createElement("h5", { style: { paddingBottom: 10, borderBottom: "1px solid grey" } }, "Identifika\u010Dn\u00ED \u00FAdaje projektu"),
	                    react_1.default.createElement("li", null,
	                        "N\u00E1zev projektu: ",
	                        accentDataValue(name)),
	                    react_1.default.createElement("li", null,
	                        "M\u00EDsto stavby: ",
	                        accentDataValue(address)),
	                    react_1.default.createElement("li", null,
	                        "Katastr\u00E1ln\u00ED \u00FAzem\u00ED parcely: ",
	                        accentDataValue(cadastralParcelArea)),
	                    react_1.default.createElement("li", null,
	                        "Katastr\u00E1ln\u00ED \u010D\u00EDslo parcely: ",
	                        accentDataValue(cadastralParcelNumber)),
	                    react_1.default.createElement("li", null,
	                        "Typologick\u00FD druh: ",
	                        accentDataValue(buildingType),
	                        " "),
	                    buildingType.value === 3 && react_1.default.createElement("li", null,
	                        "Stupe\u0148 vzd\u011Bl\u00E1n\u00ED: ",
	                        accentDataValue(schoolLevel)),
	                    react_1.default.createElement("li", null,
	                        "Popis: ",
	                        accentDataValue(description)),
	                    react_1.default.createElement("li", null,
	                        "Odhadovan\u00E9 n\u00E1klady (mil CZK): ",
	                        accentDataValue(estimatedCosts)),
	                    react_1.default.createElement("li", null,
	                        "P\u0159edpokl\u00E1dan\u00E9 uveden\u00ED stavby do provozu: ",
	                        accentDataValue(anticipatedCommissioning))),
	                react_1.default.createElement("ul", { style: { listStyle: "none" } },
	                    react_1.default.createElement("h5", { style: { paddingBottom: 10, borderBottom: "1px solid grey" } }, "Informace k projektov\u00E9 dokumentaci"),
	                    react_1.default.createElement("li", null,
	                        "Zpracovatel PD: ",
	                        accentDataValue(documentationCreator)),
	                    react_1.default.createElement("li", null,
	                        "Datum zpracov\u00E1n\u00ED PD: ",
	                        accentDataValue(documentationCreated)),
	                    react_1.default.createElement("li", null,
	                        "Stupe\u0148 PD: ",
	                        accentDataValue(documentationLevel)),
	                    react_1.default.createElement("li", null,
	                        "Verze PD: ",
	                        accentDataValue(documentationVersion))),
	                react_1.default.createElement("ul", { style: { listStyle: "none" } },
	                    react_1.default.createElement("h5", { style: { paddingBottom: 10, borderBottom: "1px solid grey" } }, "Informace k hodnocen\u00ED"),
	                    react_1.default.createElement("li", null,
	                        "F\u00E1ze hodnocen\u00ED: ",
	                        accentDataValue(evaluationPhase)),
	                    react_1.default.createElement("li", null,
	                        "Typ hodnocen\u00ED: ",
	                        accentDataValue(evaluationType)),
	                    react_1.default.createElement("li", null,
	                        "Hodnotitel SBToolCZ: ",
	                        accentDataValue(evaluator)),
	                    react_1.default.createElement("li", null,
	                        "Certifikovan\u00E1 osoba: ",
	                        accentDataValue(certified_person)),
	                    react_1.default.createElement("li", null,
	                        "Datum zalo\u017Een\u00ED projektu: ",
	                        accentDataValue(projectCreated)),
	                    react_1.default.createElement("li", null,
	                        "Datum dokon\u010Den\u00ED procesu hodnocen\u00ED: ",
	                        accentDataValue(projectEvaluationFinished))),
	                react_1.default.createElement("img", { src: _this.state.image ? "data:image/png;base64,".concat(_this.state.image) : "https://www.allianceplast.com/wp-content/uploads/no-image-1024x1024.png", style: { objectFit: 'cover', width: 250, maxHeight: 250 }, alt: 'Project Image' })));
	        };
	        _this.handleUploadProjectImage = function (files) {
	            var fileSize = files[0].size;
	            if (fileSize > 1048576) {
	                alert(locales_1.loc.i18n(templateObject_38 || (templateObject_38 = tslib_1.__makeTemplateObject(["Image Size Error"], ["Image Size Error"]))));
	                return;
	            }
	            else {
	                var project_1 = projectVersionService_1.default.projectVersion.project;
	                var data = new FormData();
	                data.append("file", files.item(0), files.item(0).name);
	                projectService_2.default.uploadProjectImage(project_1.projectId, data)
	                    .then(function (resp) {
	                    var importRes = resp.data;
	                    if (resp.status === 200) {
	                        projectService_2.default.getProjectImage(project_1.projectId).then(function (res) {
	                            console.log('fetch Project Image');
	                            if (res) {
	                                _this.setState({ image: res });
	                            }
	                        });
	                    }
	                    if (!importRes.importErrors || importRes.importErrors.length === 0) {
	                        return;
	                    }
	                }).catch(function (e) {
	                    console.error("error while import project image--->", e);
	                });
	            }
	        };
	        _this.renderTabs = function () {
	            var projectVersion = projectVersionService_1.default.projectVersion;
	            if (projectVersion.$new) {
	                return react_1.default.createElement("noscript", null);
	            }
	            return (react_1.default.createElement(material_ui_1.Tabs, { className: "detail-grid", tabTemplate: mui_theme_1.TabTemplate, inkBarStyle: { transition: 'inherit' }, contentContainerStyle: { width: '100%', flexGrow: 1, display: 'flex', minHeight: 0 }, onChange: _this.onTabChange },
	                react_1.default.createElement(material_ui_1.Tab, { label: locales_1.loc.i18n(templateObject_39 || (templateObject_39 = tslib_1.__makeTemplateObject(["Criteria"], ["Criteria"]))), style: TabStyles, key: gridsContants_1.CRITERIA_LIST },
	                    react_1.default.createElement(projectVersionParamsForm_1.default, null)),
	                react_1.default.createElement(material_ui_1.Tab, { style: TabStyles, label: locales_1.loc.i18n(templateObject_40 || (templateObject_40 = tslib_1.__makeTemplateObject(["Methodological Tables"], ["Methodological Tables"]))) }, _this.state.isImportingMaterials ?
	                    react_1.default.createElement("div", { style: { margin: 'auto', paddingTop: 20 } },
	                        react_1.default.createElement(loading_1.LoadingIcon, null),
	                        react_1.default.createElement("span", { style: { fontWeight: 700, fontSize: "36px", marginLeft: 20 } }, "Chv\u00EDli pros\u00EDm po\u010Dkejte. Prob\u00EDh\u00E1 import soubor\u016F"))
	                    :
	                        (react_1.default.createElement(material_ui_1.Tabs, { className: "detail-grid", tabTemplate: mui_theme_1.TabTemplate, inkBarStyle: { transition: 'inherit' }, style: { marginTop: "1rem" }, contentContainerStyle: { width: '100%', display: 'flex', flexGrow: 1, minHeight: 0 }, onChange: _this.onTabChange },
	                            _this.renderGlobalMaterialsTab(),
	                            _this.renderLifespanTab(),
	                            _this.renderEnergyCarriersTab(),
	                            _this.renderRunoffCoefficientTab()))),
	                react_1.default.createElement(material_ui_1.Tab, { style: TabStyles, label: locales_1.loc.i18n(templateObject_41 || (templateObject_41 = tslib_1.__makeTemplateObject(["Project Data"], ["Project Data"]))) }, _this.state.isImportingData ?
	                    react_1.default.createElement("div", { style: { margin: 'auto', paddingTop: 20 } },
	                        react_1.default.createElement(loading_1.LoadingIcon, null),
	                        react_1.default.createElement("span", { style: { fontWeight: 700, fontSize: "36px", marginLeft: 20 } }, "Chv\u00EDli pros\u00EDm po\u010Dkejte. Prob\u00EDh\u00E1 import soubor\u016F"))
	                    :
	                        (react_1.default.createElement(material_ui_1.Tabs, { className: "detail-grid", tabTemplate: mui_theme_1.TabTemplate, inkBarStyle: { transition: 'inherit' }, style: { marginTop: "1rem" }, contentContainerStyle: { width: '100%', display: 'flex', flexGrow: 1, minHeight: 0 }, onChange: _this.onTabChange },
	                            _this.renderCapacityTab(),
	                            _this.renderMaterialsTab(),
	                            _this.renderRoomsTab(),
	                            _this.renderAreasTab(),
	                            _this.renderWindowsTab(),
	                            _this.renderDoorsTab(),
	                            _this.renderLopFillingTab(),
	                            _this.renderLopsProfilesTab(),
	                            _this.renderParkingTab(),
	                            _this.renderTreesTab())))));
	        };
	        _this.submitDeleteDialogRefHandler = function (comp) { return _this.modalWindow = comp; };
	        _this.state = {
	            isEnergyFormOpen: false,
	            isRunoffCoefficientFormOpen: false,
	            isMaterialsFormOpen: false,
	            isRoomsFormOpen: false,
	            isAreasFormOpen: false,
	            isWindowsFormOpen: false,
	            isDoorsFormOpen: false,
	            isLopFillingsFormOpen: false,
	            isLopProfilesFormOpen: false,
	            isLopParkingFormOpen: false,
	            isTreesFormOpen: false,
	            isProjectInfoOpen: false,
	            image: null,
	            isImportingData: false,
	            isImportingMaterials: false,
	            isCapacitiesFormOpen: false,
	            certificate: null
	        };
	        return _this;
	    }
	    ProjectVersionDetail.fetchData = function (routerParams, query) {
	        console.log("ProjectVersionDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata([
	            entityConstants_1.PROJECT_VERSION_ENTITY,
	            entityConstants_1.CRITERION_ENTITY,
	            entityConstants_1.SUB_CRITERION_ENTITY,
	            entityConstants_1.SUB_CRITERION_PARAM_ENTITY,
	            entityConstants_1.SUB_CRITERION_PARAM_VALUE_ENTITY,
	            entityConstants_1.PROJECT_CRITERION_VERSION_ENTITY,
	            entityConstants_1.PROJECT_MATERIAL_ENTITY,
	            entityConstants_1.PROJECT_VERSION_LIFESPAN_ENTITY,
	            entityConstants_1.PROJECT_VERSION_ENERGY_CARRIER_ENTITY,
	            entityConstants_1.PROJECT_VERSION_PARAM_VALUE_ENTITY,
	            entityConstants_1.PROJECT_VERSION_ROOM_ENTITY,
	            entityConstants_1.PROJECT_VERSION_AREA_ENTITY,
	            entityConstants_1.AREA_ENTITY,
	            entityConstants_1.PROJECT_VERSION_DOOR_ENTITY,
	            entityConstants_1.PROJECT_VERSION_WINDOW_ENTITY,
	            entityConstants_1.PROJECT_VERSION_TREE_ENTITY,
	            entityConstants_1.PROJECT_VERSION_LOP_PROFILES_ENTITY,
	            entityConstants_1.PROJECT_VERSION_LOP_FILLINGS_ENTITY,
	            entityConstants_1.PROJECT_VERSION_PARKING_ENTITY,
	            entityConstants_1.PROJECT_VERSION_MATERIAL_ENTITY,
	            entityConstants_1.PROJECT_RUNOFF_COEFFICIENT_ENTITY,
	            entityConstants_1.PROJECT_VERSION_CAPACITIES_ENTITY
	        ]);
	        var projectVersionPromise;
	        // Empty list of criterion versions, for case when project version is new
	        var projectCriterionVersionPromise = new Promise((function (resolve) {
	            resolve([]);
	        }));
	        // Empty list of criteria, for case when project version is new
	        var criteriaListPromise = new Promise((function (resolve) {
	            resolve([]);
	        }));
	        var gridPromise = gridService_1.default.fetchGrids(gridsContants_1.PROJECT_VERSION_MATERIALS_GRID, gridsContants_1.PROJECT_VERSION_ENERGY_CARRIERS_LIST, gridsContants_1.PROJECT_VERSION_ROOMS_LIST, gridsContants_1.PROJECT_VERSION_AREA_LIST, gridsContants_1.PROJECT_VERSION_DOOR_LIST, gridsContants_1.PROJECT_VERSION_WINDOW_LIST, gridsContants_1.PROJECT_VERSION_TREE_LIST, gridsContants_1.PROJECT_VERSION_RECYCLABLE_MATERIALS_LIST, gridsContants_1.PROJECT_VERSION_EPD_CERTIFIED_MATERIALS_LIST, gridsContants_1.PROJECT_VERSION_WOOD_BASED_MATERIALS_GRID, gridsContants_1.PROJECT_VERSION_AREA_ZELPO_GRID, gridsContants_1.PROJECT_VERSION_AREA_ZELZP_GRID, gridsContants_1.PROJECT_VERSION_AREA_ZELST_GRID, gridsContants_1.PROJECT_VERSION_AREA_ZELZS_GRID, gridsContants_1.PROJECT_VERSION_AREA_ZELZF_GRID, gridsContants_1.PROJECT_VERSION_AREA_VPREP_GRID, gridsContants_1.PROJECT_VERSION_AREA_PEFKE_GRID, gridsContants_1.PROJECT_VERSION_LOP_FILLINGS_GRID, gridsContants_1.PROJECT_VERSION_LOP_PROFILES_GRID, gridsContants_1.PROJECT_VERSION_PARKING_GRID, gridsContants_1.LIFESPAN_LIST, gridsContants_1.PROJECT_MATERIAL_GRID, gridsContants_1.PROJECT_RUNOFF_COEFFICIENT_GRID, gridsContants_1.PROJECT_VERSION_CAPACITIES_GRID);
	        if (routerParams.id === 'new') {
	            projectVersionPromise = Promise.resolve(new projectVersionDomain_1.ProjectVersion(Object.assign({
	                $new: true,
	                active: true
	            }, query)))
	                .then(function (res) {
	                return projectService_1.default.readProject(query.projectId).then(function (project) {
	                    res.project = project;
	                    return res;
	                });
	            });
	        }
	        else if (routerParams.id === 'copy') {
	            projectVersionPromise = projectVersionService_1.default.readProjectVersion(query.copyId)
	                .then(function (projectVersion) {
	                projectVersion.cleanOnCopy();
	                projectVersion.active = true;
	                return projectVersion;
	            });
	        }
	        else {
	            projectVersionPromise = projectVersionService_1.default.readProjectVersion(routerParams.id);
	            projectCriterionVersionPromise = projectVersionService_1.default.readProjectCriteriaVersions(routerParams.id);
	            criteriaListPromise = projectVersionService_1.default.readProjectsVersionCriteria(routerParams.id);
	        }
	        return Promise.all([metadataPromise, projectVersionPromise, criteriaListPromise, projectCriterionVersionPromise, gridPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], projectVersion = _a[1], criteria = _a[2], criterionVersions = _a[3], gridLocationMap = _a[4];
	            projectVersionService_1.default.projectVersion = projectVersion;
	            projectVersionService_1.default.projectVersion = projectVersion.initAfterRead(routerParams.id === 'new');
	            projectVersionService_1.default.criteriaList.replace(criteria);
	            projectVersionService_1.default.criterionVersions.replace(criterionVersions);
	            projectVersionService_1.default.projectVersion.$movingBlocks = new gridUtils_1.MovingBlocks(gridsContants_1.PROJECT_VERSION_MATERIALS_GRID, true, query.tab, new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_MATERIALS_GRID), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_ENERGY_CARRIERS_LIST), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_ROOMS_LIST), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_AREA_LIST), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_DOOR_LIST), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_WINDOW_LIST), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_TREE_LIST), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_RECYCLABLE_MATERIALS_LIST), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_EPD_CERTIFIED_MATERIALS_LIST), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_WOOD_BASED_MATERIALS_GRID), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_AREA_ZELPO_GRID), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_AREA_ZELZP_GRID), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_AREA_ZELST_GRID), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_AREA_ZELZF_GRID), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_AREA_ZELZS_GRID), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_AREA_VPREP_GRID), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_AREA_PEFKE_GRID), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_LOP_FILLINGS_GRID), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_LOP_PROFILES_GRID), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_PARKING_GRID), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.LIFESPAN_LIST), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_MATERIAL_GRID), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_RUNOFF_COEFFICIENT_GRID), projectVersionService_1.default.projectVersion.versionId), new grid_1.default(gridLocationMap.get(gridsContants_1.PROJECT_VERSION_CAPACITIES_GRID), projectVersionService_1.default.projectVersion.versionId));
	        });
	    };
	    ProjectVersionDetail.prototype.componentDidMount = function () {
	        var _this = this;
	        projectVersionService_1.default.projectVersion.$movingBlocks.blockArray.push();
	        console.debug("%c componentDidMount", "background-color: magenta");
	        projectVersionService_1.default.projectVersion.$movingBlocks.blockArray.forEach(function (v) {
	            v.search(projectVersionService_1.default.projectVersion, false);
	        });
	        var project = projectVersionService_1.default.projectVersion.project;
	        projectService_2.default.getProjectImage(project.projectId).then(function (res) {
	            console.log('fetch Project Image');
	            if (res) {
	                _this.setState({ image: res });
	            }
	        });
	        var projectVersionId = projectVersionService_1.default.projectVersion.id;
	        this.loadPDF(projectVersionId);
	    };
	    ProjectVersionDetail.prototype.componentWillUnmount = function () {
	        projectVersionService_1.default.projectVersion = null;
	        projectVersionService_1.default.criterionVersions.clear();
	        projectVersionService_1.default.criteriaList.clear();
	        projectVersionService_1.default.criterionResults = null;
	    };
	    ProjectVersionDetail.prototype.findRootObject = function () {
	        return projectVersionService_1.default.projectVersion;
	    };
	    ProjectVersionDetail.prototype.render = function () {
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column', padding: 20 } },
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.submitDeleteDialogRefHandler }),
	            react_1.default.createElement("div", null,
	                this.renderToolTipMenu(),
	                this.renderProjectVersionForm(),
	                this.state.isProjectInfoOpen && this.renderProjectInfoHeader()),
	            react_1.default.createElement("div", { style: { display: 'flex' } }, this.renderTabs())));
	    };
	    ProjectVersionDetail.module = metaConstant_1.MODULE.sbtool;
	    ProjectVersionDetail.title = locales_1.loc.i18n(templateObject_42 || (templateObject_42 = tslib_1.__makeTemplateObject(["Project version"], ["Project version"])));
	    ProjectVersionDetail.icon = 'building-o';
	    ProjectVersionDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "onAddEnergyCarrierClick", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "addEnergyCarrierCallback", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "onAddRunoffCoefficientClick", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "addRunoffCoefficientCallback", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "onAddCapacitiesClick", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "addCapacitiesCallback", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "onAddMaterialClick", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "addMaterialCallback", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "onAddRoomClick", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "addRoomCallback", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "onAddAreaClick", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "addAreaCallback", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "onAddWindowClick", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "addWindowCallback", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "addDoorCallback", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "onAddDoorClick", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "addLopFillingsCallback", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "onAddLopFillingsClick", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "addLopProfilesCallback", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "onAddLopProfilesClick", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "addParkingCallback", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "onAddParkingClick", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "addTreeCallback", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "onAddTreeClick", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "onSaveProjectVersion", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "onCopyProjectVersion", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "onDeleteProjectVersion", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "handleUploadMaterials", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "handleFileProjectData", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "handleGenerateCertificate", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "loadPDF", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "downloadPDF", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ProjectVersionDetail.prototype, "handleUploadProjectImage", void 0);
	    ProjectVersionDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionDetail);
	    return ProjectVersionDetail;
	}(pageAncestor_1.default));
	exports.default = ProjectVersionDetail;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42;


/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var routes_1 = __webpack_require__(75);
	var buttons_1 = __webpack_require__(27);
	var gridsContants_1 = __webpack_require__(121);
	var ProjectsList = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectsList, _super);
	    function ProjectsList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // private submitSaveDialog: ConfirmationDialog;
	    // private alertDialog: AlertDialog;
	    ProjectsList.fetchData = function (routerParams) {
	        console.log("ProjectsList#fetchData(%s)", gridsContants_1.PROJECTS_LIST);
	        return gridService_1.default.fetchGrids(gridsContants_1.PROJECTS_LIST)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridsContants_1.PROJECTS_LIST);
	        });
	    };
	    //  openErrorDialogToContinue = (importRes : ProjectImportResponse) => {
	    //   if (importRes.projectId) {
	    //     let title = loc.i18n`Do you want to save project with this errors: \n`
	    //     title += importRes.importErrors.join("\n");
	    //
	    //     this.submitSaveDialog.open(success => {
	    //       this.redirectToImportedProject(importRes.projectId);
	    //     }, cancel => {
	    //       SbToolProjectService.deleteProject(importRes.projectId);
	    //       window.location.reload();
	    //     }, title);
	    //   } else {
	    //     let title = loc.i18n`Critical errors: \n`
	    //     title += importRes.importErrors.join("\n")
	    //     this.alertDialog.open(success => {}, title);
	    //   }
	    // };
	    // redirectToImportedProject = (projectId : number) => {
	    //   this.context.router.replaceWith('sbToolProjectDetail', {id: projectId});
	    //   window.location.reload();
	    // };
	    // submitSaveDialogRefHandler = comp => this.submitSaveDialog = comp;
	    // submitAlertDialogRefHandler = comp => this.alertDialog = comp;
	    ProjectsList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridsContants_1.PROJECTS_LIST), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query },
	                react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "sbToolProjectDetail", params: { id: 'new' }, label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["New Project"], ["New Project"]))), permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.sbToolProjectDetail }))));
	    };
	    ProjectsList.module = metaConstant_1.MODULE.sbtool;
	    ProjectsList.title = locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Projects"], ["Projects"])));
	    ProjectsList.icon = 'building-o';
	    ProjectsList.rootPage = true;
	    ProjectsList.protectedPage = true;
	    ProjectsList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectsList);
	    return ProjectsList;
	}(pageAncestor_1.default));
	exports.default = ProjectsList;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mobx_react_1 = __webpack_require__(4);
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var metaConstant_1 = __webpack_require__(13);
	var locales_1 = __webpack_require__(15);
	var gridsContants_1 = __webpack_require__(121);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var typesGrid, categoriesGrid;
	var ProjectVersionRoomList = /** @class */ (function (_super) {
	    tslib_1.__extends(ProjectVersionRoomList, _super);
	    function ProjectVersionRoomList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ProjectVersionRoomList.fetchData = function (routerParams) {
	        console.log("ProjectVersionRoomList#fetchData(%s, %s)", gridsContants_1.PROJECT_VERSION_ROOM_TYPES_LIST, gridsContants_1.PROJECT_VERSION_ROOM_CATEGORIES_LIST);
	        return gridService_1.default.fetchGrids(gridsContants_1.PROJECT_VERSION_ROOM_TYPES_LIST, gridsContants_1.PROJECT_VERSION_ROOM_CATEGORIES_LIST)
	            .then(function (gridLocationMap) {
	            typesGrid = gridService_1.default.getOrCreateGrid(gridsContants_1.PROJECT_VERSION_ROOM_TYPES_LIST);
	            categoriesGrid = gridService_1.default.getOrCreateGrid(gridsContants_1.PROJECT_VERSION_ROOM_CATEGORIES_LIST);
	        });
	    };
	    ProjectVersionRoomList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement(gridCompConnected_1.default, { grid: typesGrid, entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query }),
	            react_1.default.createElement(gridCompConnected_1.default, { grid: categoriesGrid, entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query })));
	    };
	    ProjectVersionRoomList.module = metaConstant_1.MODULE.sbtool;
	    ProjectVersionRoomList.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Room types"], ["Room types"])));
	    ProjectVersionRoomList.icon = 'list';
	    ProjectVersionRoomList.rootPage = true;
	    ProjectVersionRoomList.protectedPage = true;
	    ProjectVersionRoomList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ProjectVersionRoomList);
	    return ProjectVersionRoomList;
	}(pageAncestor_1.default));
	exports.default = ProjectVersionRoomList;
	var templateObject_1;


/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importStar(__webpack_require__(1));
	var projectVersionService_1 = tslib_1.__importDefault(__webpack_require__(111));
	var Table_1 = __webpack_require__(761);
	var SubCriterionAreaList = /** @class */ (function (_super) {
	    tslib_1.__extends(SubCriterionAreaList, _super);
	    function SubCriterionAreaList() {
	        var _this = _super.call(this) || this;
	        _this.showExtCreditsSubCriteria = ['EXTMB', 'EXTMA', 'EXTPR'];
	        _this.bdSubCriterionCode = 'EXTMB';
	        _this.abSubCriterionCode = 'EXTMA';
	        _this.extCredits = 10;
	        _this.renderTable = function () {
	            return (react_1.default.createElement(Table_1.Table, { selectable: false },
	                react_1.default.createElement(Table_1.TableHeader, { displaySelectAll: false, adjustForCheckbox: false, key: 0 }, _this.renderTableHeader()),
	                react_1.default.createElement(Table_1.TableBody, { displayRowCheckbox: false }, _this.renderTableBody(_this.state.areas))));
	        };
	        _this.renderTableHeader = function () {
	            var subCriterionCode = _this.props.subCriterionCode;
	            var header = _this.showExtCreditsSubCriteria.includes(subCriterionCode) ?
	                _this.renderExpCriterionTableHeader() : _this.renderDefaultTableHeader();
	            return header;
	        };
	        _this.renderExpCriterionTableHeader = function () { return (react_1.default.createElement(Table_1.TableRow, null,
	            react_1.default.createElement(Table_1.TableHeaderColumn, { style: { textAlign: 'center', width: '60%' } }, "N\u00E1zev plochy"),
	            react_1.default.createElement(Table_1.TableHeaderColumn, { style: { textAlign: 'center', width: '20%' } }, "V\u00FDm\u011Bra"),
	            react_1.default.createElement(Table_1.TableHeaderColumn, { style: { textAlign: 'center', width: '20%' } }, "Kredity"))); };
	        _this.renderDefaultTableHeader = function () { return (react_1.default.createElement(Table_1.TableRow, null,
	            react_1.default.createElement(Table_1.TableHeaderColumn, { style: { textAlign: 'center', width: '80%' } }, "N\u00E1zev plochy"),
	            react_1.default.createElement(Table_1.TableHeaderColumn, { style: { textAlign: 'center', width: '20%' } }, "V\u00FDm\u011Bra"))); };
	        _this.renderTableBody = function (areas) {
	            var subCriterionCode = _this.props.subCriterionCode;
	            var body = _this.showExtCreditsSubCriteria.includes(subCriterionCode) ?
	                _this.renderExpCriterionTableBody(areas) : _this.renderDefaultTableBody(areas);
	            return body;
	        };
	        _this.renderExpCriterionTableBody = function (areas) {
	            var subCriterionCode = _this.props.subCriterionCode;
	            var projectVersion = _this.state.projectVersion;
	            if (subCriterionCode === _this.bdSubCriterionCode) {
	                var minimalM2_1 = projectVersion.project.countOfHousingUnits * 0.5;
	                minimalM2_1 = (minimalM2_1 < 10) ? 10 : minimalM2_1;
	                areas = areas.filter(function (area) { return (area.areaM2 >= minimalM2_1); });
	            }
	            else if (subCriterionCode === _this.abSubCriterionCode) {
	                var minimalM2_2 = (Number(projectVersion.project.cadastralParcelNumber) <= 10000) ?
	                    (10 + 0.002 * Number(projectVersion.project.cadastralParcelNumber)) :
	                    (30);
	                areas = areas.filter(function (area) { return (area.areaM2 >= minimalM2_2); });
	            }
	            return areas.map(function (areaInfo) { return (react_1.default.createElement(Table_1.TableRow, { key: areaInfo.areaId },
	                react_1.default.createElement(Table_1.TableRowColumn, null,
	                    react_1.default.createElement("div", { style: { width: '60%' } },
	                        react_1.default.createElement("p", { style: { overflow: 'auto' } }, areaInfo.areaLabel))),
	                react_1.default.createElement(Table_1.TableRowColumn, { style: { textAlign: 'center', width: '20%' } }, areaInfo.areaM2),
	                react_1.default.createElement(Table_1.TableRowColumn, { style: { textAlign: 'center', width: '20%' } }, _this.extCredits))); });
	        };
	        _this.renderDefaultTableBody = function (areas) {
	            return areas.map(function (areaInfo) { return (react_1.default.createElement(Table_1.TableRow, { key: areaInfo.areaId },
	                react_1.default.createElement(Table_1.TableRowColumn, null,
	                    react_1.default.createElement("div", { style: { width: '80%' } },
	                        react_1.default.createElement("p", { style: { overflow: 'auto' } }, areaInfo.areaLabel))),
	                react_1.default.createElement(Table_1.TableRowColumn, { style: { textAlign: 'center', width: '20%' } }, areaInfo.areaM2))); });
	        };
	        _this.renderTableBody.bind(_this);
	        return _this;
	    }
	    SubCriterionAreaList.prototype.componentDidMount = function () {
	        var _this = this;
	        var _a = this.props, projectVersionId = _a.projectVersionId, subCriterionCode = _a.subCriterionCode;
	        projectVersionService_1.default.getProjectVersionAreaBySubCriterionCode(projectVersionId, subCriterionCode)
	            .then(function (response) {
	            var areaInfo = [];
	            Object.values(response).forEach(function (entry) {
	                var newInfo = { areaId: entry.id, areaLabel: entry.area.label, areaM2: entry.m2 };
	                areaInfo.push(newInfo);
	            });
	            areaInfo.sort(function (a, b) { return (a.areaId - b.areaId); });
	            _this.setState({ areas: areaInfo, projectVersion: projectVersionService_1.default.projectVersion });
	        });
	    };
	    SubCriterionAreaList.prototype.render = function () {
	        var state = this.state;
	        return (state && state.areas && state.areas.length > 0) ? this.renderTable() : null;
	    };
	    return SubCriterionAreaList;
	}(react_1.Component));
	exports.default = SubCriterionAreaList;


/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var mobx_1 = __webpack_require__(5);
	var projectVersionDoorDomain_1 = tslib_1.__importDefault(__webpack_require__(960));
	var axios_config_1 = tslib_1.__importDefault(__webpack_require__(59));
	var ProjectVersionDoorService = /** @class */ (function () {
	    function ProjectVersionDoorService() {
	    }
	    ProjectVersionDoorService.prototype.readProjectVersionDoor = function (projectVersionDoorId) {
	        return axios_config_1.default.get("sbtool/project-version/doors/" + projectVersionDoorId)
	            .then(function (response) { return new projectVersionDoorDomain_1.default(response.data); });
	    };
	    ProjectVersionDoorService.prototype.saveProjectVersionDoor = function (projectVersionId, door) {
	        return axios_config_1.default.post('sbtool/project-version/' + projectVersionId + "/doors", door)
	            .then(function (response) { return response.data; });
	    };
	    ProjectVersionDoorService.prototype.deleteProjectVersionDoor = function (doorId) {
	        return axios_config_1.default.delete("sbtool/project-version/doors/" + doorId)
	            .then(function (response) { });
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ProjectVersionDoorService.prototype, "projectVersionDoorObject", void 0);
	    return ProjectVersionDoorService;
	}());
	var projectVersionDoorService = new ProjectVersionDoorService();
	exports.default = projectVersionDoorService;


/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var form_1 = tslib_1.__importStar(__webpack_require__(52));
	var createForm_1 = __webpack_require__(18);
	var formUtils_1 = __webpack_require__(14);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var blockComp_1 = __webpack_require__(30);
	var validate_1 = __webpack_require__(24);
	var rules_1 = __webpack_require__(56);
	var commonDataService_1 = __webpack_require__(41);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var partyDomain_1 = __webpack_require__(48);
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var shipmentDomain_1 = __webpack_require__(132);
	var colors_1 = __webpack_require__(29);
	var radioButtonField_1 = tslib_1.__importDefault(__webpack_require__(144));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var shipmentVisitDriverForm_1 = __webpack_require__(407);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var shipmentService_1 = tslib_1.__importDefault(__webpack_require__(176));
	var locales_1 = __webpack_require__(15);
	var productService_1 = tslib_1.__importDefault(__webpack_require__(131));
	var shipmentRequestedTime_1 = __webpack_require__(965);
	var ShipmentIncomingForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentIncomingForm, _super);
	    function ShipmentIncomingForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onChangeTime = function (timeStart, timeEnd) {
	            console.log("onChangeTime: timeStart " + timeStart + ", timeEnd " + timeEnd);
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject;
	            dataObject.requestedUnloadingStart = timeStart;
	            dataObject.requestedUnloadingEnd = timeEnd;
	            rootObject.$dirty = true;
	        };
	        _this.shipmentDetailsFilled = function () {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            var result = dataObject.plannedPaletteCount - dataObject.unloadedPaletteCount;
	            if (!(dataObject.unloadedPaletteCount == null)) {
	                console.log(dataObject.plannedPaletteCount - dataObject.unloadedPaletteCount);
	                form.getField("notUnloadedPaletteCount").props.value = result;
	                dataObject.notUnloadedPaletteCount = result;
	                form.updateFieldsPropValue(dataObject, "notUnloadedPaletteCount");
	                if (result < 0) {
	                    form.getField("notUnloadedPaletteCount").props.value = 0;
	                    dataObject.notUnloadedPaletteCount = 0;
	                    form.updateFieldsPropValue(dataObject, "notUnloadedPaletteCount");
	                }
	            }
	        };
	        _this.onShippedFromSuccess = function () {
	            var _a = _this.props, entities = _a.entities, dataObject = _a.dataObject, form = _a.form;
	            console.log('onShippedFromSuccess ', dataObject.shippedFrom);
	            var partyId = (0, formUtils_1.lovValue)(dataObject.shippedFrom);
	            return ((partyId != null) ? Promise.all([shipmentService_1.default.computeField("shippedToPlace", { shippedFrom: (0, formUtils_1.lovValue)(dataObject.shippedFrom) }),
	                shipmentService_1.default.computeField("hauler", { partyId: partyId })]) : Promise.all([Promise.resolve(null), Promise.resolve(null)]))
	                .then((0, mobx_1.action)("onShippedToChange-cb1", function (_a) {
	                var shippedToPlaceValue = _a[0], haulerLov = _a[1];
	                var fieldsToUpdate = [];
	                if (shippedToPlaceValue) {
	                    dataObject.shippedToPlace = form.getField("shippedToPlace").props.options.find(function (lov) { return lov.value === shippedToPlaceValue; });
	                    fieldsToUpdate.push("shippedToPlace");
	                }
	                if (haulerLov) {
	                    dataObject.hauler = haulerLov;
	                    fieldsToUpdate.push("hauler");
	                }
	                form.updateFieldsPropValue.apply(form, tslib_1.__spreadArray([dataObject], fieldsToUpdate, false));
	            }));
	        };
	        _this.onShipmentVisitSuccess = function () {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            console.log("onShipmentVisitSuccess");
	            var visitPromise = (dataObject.shipmentVisit) ? shipmentService_1.default.readShipmentVisit((0, formUtils_1.lovValue)(dataObject.shipmentVisit)) : Promise.resolve(null);
	            visitPromise.then(function (visit) {
	                dataObject.$shipmentVisit = visit;
	                if (!dataObject.registrationNumber && !!visit) {
	                    dataObject.registrationNumber = visit.registrationNumber;
	                    form.updateFieldsPropValue(dataObject, "registrationNumber");
	                }
	            });
	        };
	        _this.onHaulerSuccess = function () {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            dataObject.vehicle = undefined;
	            form.updateFieldsPropValue(dataObject, "vehicle");
	        };
	        _this.onVehicleSuccess = function () {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            if (dataObject.vehicle) {
	                productService_1.default.readVehicle((0, formUtils_1.lovValue)(dataObject.vehicle))
	                    .then((0, mobx_1.action)("onVehicleSuccessA", function (vehicle) {
	                    dataObject.registrationNumber = vehicle.registrationNumber;
	                    form.updateFieldsPropValue(dataObject, "registrationNumber");
	                }));
	            }
	        };
	        return _this;
	    }
	    ShipmentIncomingForm.prototype.componentDidMount = function () {
	        var _a = this.props, dataObject = _a.dataObject, form = _a.form;
	        return this.populateDropdowns(form, dataObject);
	    };
	    ShipmentIncomingForm.prototype.componentDidUpdate = function (prevProps) {
	        var _a = this.props, dataObject = _a.dataObject, form = _a.form;
	        if (prevProps.dataObject.shipmentId !== dataObject.shipmentId) { // kvuli copy nebo horizontalnimu posunu
	            console.debug("componentDidUpdate - populateDropdowns");
	            return this.populateDropdowns(form, dataObject);
	        }
	    };
	    ShipmentIncomingForm.prototype.populateDropdowns = function (form, dataObject) {
	        return (0, commonDataService_1.optionsSearch)('AddressPlace', {
	            partyId: securityService_1.default.currentTenant.party.value,
	            placeType: partyDomain_1.ADDRESSPLACETYPE.INCOMING
	        }).then((0, mobx_1.action)("onShippedToChange-cb1", function (_a) {
	            var placeOptions = _a.options;
	            placeOptions.unshift({ value: null, label: '---' });
	            form.getField("shippedToPlace").props.options = mobx_1.observable.shallowArray(placeOptions);
	            form.updateFieldsPropValue(dataObject, "shippedToPlace");
	        }));
	    };
	    ShipmentIncomingForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entity = _a.entity, entities = _a.entities, form = _a.form, formName = _a.formName;
	        var fields = form.fields;
	        var _b = dataObject.getFormFields(formName), shipmentDate = _b.shipmentDate, shipmentStatus = _b.shipmentStatus, comment = _b.comment, shippedFrom = _b.shippedFrom, registrationNumber = _b.registrationNumber, shippedToPlace = _b.shippedToPlace, plannedPaletteCount = _b.plannedPaletteCount, unloadedPaletteCount = _b.unloadedPaletteCount, notUnloadedPaletteCount = _b.notUnloadedPaletteCount, unloadingNumber = _b.unloadingNumber, loadingTruckCount = _b.loadingTruckCount, unloadingTruckCount = _b.unloadingTruckCount, shipmentVisit = _b.shipmentVisit, maxWaitingTime = _b.maxWaitingTime, hauler = _b.hauler, vehicle = _b.vehicle, visitOrder = _b.visitOrder;
	        var shipmentVisitEntity = mdEntityService_1.default.entityMap.get('ShipmentVisit');
	        console.debug("dataObject.$shipmentVisit ", dataObject.$shipmentVisit);
	        return (react_1.default.createElement("form", { style: { marginTop: 10 } },
	            react_1.default.createElement(blockComp_1.BlockComp, null,
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-3" },
	                        react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, shipmentDate.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: shipmentDate, value: shipmentDate.props.value })),
	                    react_1.default.createElement("div", { className: "col-xs-8 col-xs-offset-1" },
	                        react_1.default.createElement("div", { style: { color: colors_1.grey400, marginBottom: 5 } }, shipmentStatus.mdField.formLabelActive),
	                        react_1.default.createElement(radioButtonField_1.default, tslib_1.__assign({}, shipmentStatus.props, { groupStyle: { display: 'flex' }, optionStyle: { width: 'initial', marginRight: 15 }, labelStyle: { whiteSpace: 'nowrap', marginLeft: -10 }, iconStyleFn: function (v) { return ({ fill: shipmentDomain_1.SHIPMENTSTATUS_COLORS[v] }); } })),
	                        react_1.default.createElement(validate_1.Validate, { field: shipmentStatus, value: shipmentStatus.props.value })))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                    react_1.default.createElement(blockComp_1.BlockComp, { className: "block-comp-right-border", header: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Supplier"], ["Supplier"]))), style: { marginBottom: 0 } },
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-12" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, shippedFrom.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.SUPPLIER_ROLE] }), clearable: true })),
	                                react_1.default.createElement(validate_1.Validate, { field: shippedFrom, value: shippedFrom.props.value, onSuccess: this.onShippedFromSuccess }))),
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-12" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, hauler.props, { async: true, asterixForAll: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.HAULER] }), clearable: true })),
	                                react_1.default.createElement(validate_1.Validate, { field: hauler, value: hauler.props.value, onSuccess: this.onHaulerSuccess }))),
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-12" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, shippedToPlace.props, { floatingLabelText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Unloading place"], ["Unloading place"]))), clearable: false }))))),
	                    react_1.default.createElement(blockComp_1.BlockComp, { className: "block-comp-right-border", header: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Car"], ["Car"]))), style: { marginBottom: 0 } },
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, vehicle.props, { asterixForAll: true, async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Vehicle', { partyId: dataObject.hauler ? (0, formUtils_1.lovValue)(dataObject.hauler) : -1 }) })),
	                                react_1.default.createElement(validate_1.Validate, { field: vehicle, value: vehicle.props.value, onSuccess: this.onVehicleSuccess })),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, registrationNumber.props)))))),
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                    react_1.default.createElement(blockComp_1.BlockComp, { header: locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["Unloading"], ["Unloading"]))), style: { marginBottom: 0 } },
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, plannedPaletteCount.props)),
	                                react_1.default.createElement(validate_1.Validate, { field: plannedPaletteCount, value: plannedPaletteCount.props.value, onSuccess: this.shipmentDetailsFilled },
	                                    react_1.default.createElement(rules_1.NumberFormat, { precision: 4, scale: 0 }),
	                                    react_1.default.createElement(rules_1.Min, { min: 0 }))),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, unloadedPaletteCount.props)),
	                                react_1.default.createElement(validate_1.Validate, { field: unloadedPaletteCount, value: unloadedPaletteCount.props.value, onSuccess: this.shipmentDetailsFilled },
	                                    react_1.default.createElement(rules_1.NumberFormat, { precision: 4, scale: 0 }),
	                                    react_1.default.createElement(rules_1.Min, { min: 0 }))),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, notUnloadedPaletteCount.props)),
	                                react_1.default.createElement(validate_1.Validate, { field: notUnloadedPaletteCount, value: notUnloadedPaletteCount.props.value },
	                                    react_1.default.createElement(rules_1.NumberFormat, { precision: 4, scale: 0 }),
	                                    react_1.default.createElement(rules_1.Min, { min: 0 }))),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, unloadingNumber.props)))),
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, loadingTruckCount.props)),
	                                react_1.default.createElement(validate_1.Validate, { field: loadingTruckCount, value: loadingTruckCount.props.value },
	                                    react_1.default.createElement(rules_1.NumberFormat, { precision: 4, scale: 0 }),
	                                    react_1.default.createElement(rules_1.Min, { min: 0 }))),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, unloadingTruckCount.props)),
	                                react_1.default.createElement(validate_1.Validate, { field: loadingTruckCount, value: unloadingTruckCount.props.value },
	                                    react_1.default.createElement(rules_1.NumberFormat, { precision: 4, scale: 0 }),
	                                    react_1.default.createElement(rules_1.Min, { min: 0 })))),
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-3" },
	                                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, maxWaitingTime.props)),
	                                react_1.default.createElement(validate_1.Validate, { field: maxWaitingTime, value: maxWaitingTime.props.value },
	                                    react_1.default.createElement(rules_1.NumberFormat, { precision: 4, scale: 0 }),
	                                    react_1.default.createElement(rules_1.Min, { min: 0 }))),
	                            react_1.default.createElement("div", { className: "fx col-xs-3" },
	                                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, visitOrder.props)),
	                                react_1.default.createElement(validate_1.Validate, { field: visitOrder, value: visitOrder.props.value },
	                                    react_1.default.createElement(rules_1.NumberFormat, { precision: 2, scale: 0 }),
	                                    react_1.default.createElement(rules_1.Min, { min: 1 }))),
	                            react_1.default.createElement("div", { className: "col-xs-6" },
	                                react_1.default.createElement("div", { style: { color: colors_1.grey400, marginBottom: 5 } }, locales_1.loc.i18n(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["Requested unloading time"], ["Requested unloading time"])))),
	                                react_1.default.createElement(shipmentRequestedTime_1.ShipmentRequestedTime, { timeStart: dataObject.requestedUnloadingStart, timeEnd: dataObject.requestedUnloadingEnd, changeTimeFn: this.onChangeTime, dialogTitle: locales_1.loc.i18n(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["Requested unloading time"], ["Requested unloading time"]))) })))),
	                    react_1.default.createElement(blockComp_1.BlockComp, { style: { marginBottom: 0, paddingBottom: 0 } },
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-12" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, shipmentVisit.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'ShipmentVisit', { unassigned: true }), clearable: true, asterixForAll: true })),
	                                react_1.default.createElement(validate_1.Validate, { field: shipmentVisit, value: shipmentVisit.props.value, onSuccess: this.onShipmentVisitSuccess }))),
	                        (dataObject.$shipmentVisit) ? react_1.default.createElement(shipmentVisitDriverForm_1.ShipmentVisitClosedContent, { dataObject: dataObject.$shipmentVisit, entities: entities, entity: shipmentVisitEntity, fields: new form_1.default("ShipmentVisitDriverForm", mdEntityService_1.default.getFormDefinition("ShipmentVisitDriverForm")).setupFields(dataObject.$shipmentVisit, dataObject.$shipmentVisit, shipmentVisitEntity, entities, null) }) : null))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12" },
	                    react_1.default.createElement(blockComp_1.BlockComp, { style: { marginBottom: 0, marginTop: 0 } },
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-12" },
	                                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props, { multiLine: true, rows: 3 })))))))));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentIncomingForm.prototype, "onChangeTime", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentIncomingForm.prototype, "shipmentDetailsFilled", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentIncomingForm.prototype, "onShippedFromSuccess", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentIncomingForm.prototype, "onShipmentVisitSuccess", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentIncomingForm.prototype, "onHaulerSuccess", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentIncomingForm.prototype, "onVehicleSuccess", void 0);
	    ShipmentIncomingForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'ShipmentIncomingForm',
	            fields: [{
	                    name: 'shipmentDate',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'shipmentStatus',
	                    validators: ['IsRequired'],
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.radioButton
	                }, {
	                    name: 'comment',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	                }, {
	                    name: 'shippedFrom',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'registrationNumber'
	                }, {
	                    name: 'driverPhone'
	                }, {
	                    name: 'shippedToPlace'
	                }, {
	                    name: 'gateArrivalTime'
	                }, {
	                    name: 'vendorArrivalTime'
	                }, {
	                    name: 'endOfLoadingTime'
	                }, {
	                    name: 'plannedPaletteCount',
	                    validators: ['IsNumber']
	                }, {
	                    name: 'unloadedPaletteCount',
	                    validators: ['IsNumber']
	                }, {
	                    name: 'notUnloadedPaletteCount',
	                    validators: ['IsNumber'],
	                }, {
	                    name: 'unloadingNumber'
	                }, {
	                    name: 'loadingTruckCount',
	                    validators: ['IsNumber']
	                }, {
	                    name: 'unloadingTruckCount',
	                    validators: ['IsNumber']
	                }, {
	                    name: 'gateLoadingDuration'
	                }, {
	                    name: 'vendorLoadingDuration'
	                }, {
	                    name: 'shipmentVisit'
	                }, {
	                    name: 'maxWaitingTime'
	                }, {
	                    name: 'hauler'
	                }, {
	                    name: 'vehicle'
	                }, {
	                    name: 'visitOrder',
	                    validators: ['IsNumber', 'IsRequired']
	                }]
	        }, function () { return react_1.default.createElement("noscript", null); }),
	        mobx_react_1.observer
	    ], ShipmentIncomingForm);
	    return ShipmentIncomingForm;
	}(react_1.default.Component));
	exports.default = ShipmentIncomingForm;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;


/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var form_1 = tslib_1.__importStar(__webpack_require__(52));
	var createForm_1 = __webpack_require__(18);
	var formUtils_1 = __webpack_require__(14);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var blockComp_1 = __webpack_require__(30);
	var validate_1 = __webpack_require__(24);
	var rules_1 = __webpack_require__(56);
	var commonDataService_1 = __webpack_require__(41);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var partyDomain_1 = __webpack_require__(48);
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var shipmentDomain_1 = __webpack_require__(132);
	var colors_1 = __webpack_require__(29);
	var radioButtonField_1 = tslib_1.__importDefault(__webpack_require__(144));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var shipmentService_1 = tslib_1.__importDefault(__webpack_require__(176));
	var shipmentVisitDriverForm_1 = __webpack_require__(407);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var locales_1 = __webpack_require__(15);
	var productService_1 = tslib_1.__importDefault(__webpack_require__(131));
	var shipmentRequestedTime_1 = __webpack_require__(965);
	var ShipmentOutgoingForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentOutgoingForm, _super);
	    function ShipmentOutgoingForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onChangeTime = function (timeStart, timeEnd) {
	            console.log("onChangeTime: timeStart " + timeStart + ", timeEnd " + timeEnd);
	            var _a = _this.props, dataObject = _a.dataObject, rootObject = _a.rootObject;
	            dataObject.requestedLoadingStart = timeStart;
	            dataObject.requestedLoadingEnd = timeEnd;
	            rootObject.$dirty = true;
	        };
	        _this.shipmentDetailsFilled = function () {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            var result = dataObject.plannedPaletteCount - dataObject.loadedPaletteCount;
	            if (!(dataObject.loadedPaletteCount == null)) {
	                console.log(dataObject.plannedPaletteCount - dataObject.loadedPaletteCount);
	                form.getField("notLoadedPaletteCount").props.value = result;
	                dataObject.notLoadedPaletteCount = result;
	                form.updateFieldsPropValue(dataObject, "notLoadedPaletteCount");
	                if (result < 0) {
	                    form.getField("notLoadedPaletteCount").props.value = 0;
	                    dataObject.notLoadedPaletteCount = 0;
	                    form.updateFieldsPropValue(dataObject, "notLoadedPaletteCount");
	                }
	            }
	        };
	        _this.onShippedToSuccess = function () {
	            var _a = _this.props, entities = _a.entities, dataObject = _a.dataObject, form = _a.form;
	            console.log('onShippedToSuccess ', dataObject.shippedTo);
	            var partyId = (0, formUtils_1.lovValue)(dataObject.shippedTo);
	            return ((partyId != null) ? Promise.all([(0, commonDataService_1.optionsSearch)('Address', { partyId: partyId }),
	                shipmentService_1.default.computeField("shippedFromPlace", { shippedTo: partyId }),
	                shipmentService_1.default.computeField("hauler", { partyId: partyId })])
	                : Promise.all([Promise.resolve({ options: [] }), Promise.resolve(null), Promise.resolve(null)]))
	                .then((0, mobx_1.action)("onShippedToChange-cb1", function (_a) {
	                var addressOptions = _a[0].options, shippedFromPlaceValue = _a[1], haulerLov = _a[2];
	                form.getField("shippedToAddress").props.options = mobx_1.observable.shallowArray(addressOptions);
	                dataObject.shippedToAddress = (addressOptions.length === 1) ? addressOptions[0] : null;
	                var fieldsToUpdate = ["shippedToAddress"];
	                if (shippedFromPlaceValue) {
	                    dataObject.shippedFromPlace = form.getField("shippedFromPlace").props.options.find(function (lov) { return lov.value === shippedFromPlaceValue; });
	                    fieldsToUpdate.push("shippedFromPlace");
	                }
	                if (haulerLov) {
	                    dataObject.hauler = haulerLov;
	                    fieldsToUpdate.push("hauler");
	                }
	                form.updateFieldsPropValue.apply(form, tslib_1.__spreadArray([dataObject], fieldsToUpdate, false));
	                if (dataObject.shippedToAddress != null) {
	                    return _this.updateDisponentParty(dataObject, form);
	                }
	            }));
	        };
	        _this.onShippedToAddressSuccess = function () {
	            var _a = _this.props, entities = _a.entities, dataObject = _a.dataObject, form = _a.form;
	            console.log('onShippedToAddressSuccess ', dataObject.shippedToAddress);
	            return Promise.all([_this.computeMaxWaitingTime(dataObject, form),
	                _this.updateDisponentParty(dataObject, form)]);
	        };
	        _this.onTransportationTypeSuccess = function () {
	            var _a = _this.props, entities = _a.entities, dataObject = _a.dataObject, form = _a.form;
	            console.log('onTransportationTypeSuccess ', dataObject.transportationType);
	            return _this.computeMaxWaitingTime(dataObject, form);
	        };
	        _this.onShipmentVisitSuccess = function () {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            var visitPromise = (dataObject.shipmentVisit) ? shipmentService_1.default.readShipmentVisit((0, formUtils_1.lovValue)(dataObject.shipmentVisit)) : Promise.resolve(null);
	            visitPromise.then(function (visit) {
	                _this.shipmentVisit = visit;
	                if (!dataObject.registrationNumber && !!visit) {
	                    dataObject.registrationNumber = visit.registrationNumber;
	                    form.updateFieldsPropValue(dataObject, "registrationNumber");
	                }
	            });
	        };
	        _this.onHaulerSuccess = function () {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            dataObject.vehicle = undefined;
	            form.updateFieldsPropValue(dataObject, "vehicle");
	        };
	        _this.onVehicleSuccess = function () {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            if (dataObject.vehicle) {
	                productService_1.default.readVehicle((0, formUtils_1.lovValue)(dataObject.vehicle))
	                    .then((0, mobx_1.action)("onVehicleSuccessA", function (vehicle) {
	                    dataObject.registrationNumber = vehicle.registrationNumber;
	                    form.updateFieldsPropValue(dataObject, "registrationNumber");
	                }));
	            }
	        };
	        return _this;
	    }
	    ShipmentOutgoingForm.prototype.componentDidMount = function () {
	        var _a = this.props, dataObject = _a.dataObject, form = _a.form;
	        var partyId = (0, formUtils_1.lovValue)(dataObject.shippedTo);
	        console.debug("componentDidMount = populateDropdowns, partyId ", partyId);
	        return this.populateDropdowns(partyId, dataObject, form);
	    };
	    ShipmentOutgoingForm.prototype.componentDidUpdate = function (prevProps) {
	        var _a = this.props, dataObject = _a.dataObject, form = _a.form;
	        if (prevProps.dataObject.shipmentId !== dataObject.shipmentId) { // kvuli copy nebo horizontalnimu posunu
	            var partyId = (0, formUtils_1.lovValue)(dataObject.shippedTo);
	            console.debug("componentDidUpdate - populateDropdowns, partyId ", partyId);
	            return this.populateDropdowns(partyId, dataObject, form);
	        }
	    };
	    ShipmentOutgoingForm.prototype.populateDropdowns = function (partyId, dataObject, form) {
	        var _this = this;
	        return (Promise.all([((partyId != null) ? (0, commonDataService_1.optionsSearch)('Address', { partyId: partyId }) : Promise.resolve({ options: [] })),
	            (0, commonDataService_1.optionsSearch)('AddressPlace', {
	                partyId: securityService_1.default.currentTenant.party.value,
	                placeType: partyDomain_1.ADDRESSPLACETYPE.EXPEDITION
	            }),
	            (dataObject.shipmentVisit) ? shipmentService_1.default.readShipmentVisit((0, formUtils_1.lovValue)(dataObject.shipmentVisit)) : Promise.resolve(null)]))
	            .then((0, mobx_1.action)("onShippedToChange-cb1", function (_a) {
	            var addressOptions = _a[0].options, placeOptions = _a[1].options, shipmentVisit = _a[2];
	            form.getField("shippedToAddress").props.options = mobx_1.observable.shallowArray(addressOptions);
	            placeOptions.unshift({ value: null, label: '---' });
	            form.getField("shippedFromPlace").props.options = mobx_1.observable.shallowArray(placeOptions);
	            form.updateFieldsPropValue(dataObject, "shippedToAddress", "shippedFromPlace");
	            _this.shipmentVisit = shipmentVisit;
	        }));
	    };
	    ShipmentOutgoingForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entity = _a.entity, entities = _a.entities, form = _a.form, formName = _a.formName;
	        var fields = form.fields;
	        var _b = dataObject.getFormFields(formName), shipmentDate = _b.shipmentDate, shipmentStatus = _b.shipmentStatus, comment = _b.comment, shippedTo = _b.shippedTo, shippedToAddress = _b.shippedToAddress, shippedToPlaceDesc = _b.shippedToPlaceDesc, registrationNumber = _b.registrationNumber, shippedFromPlace = _b.shippedFromPlace, plannedPaletteCount = _b.plannedPaletteCount, loadedPaletteCount = _b.loadedPaletteCount, notLoadedPaletteCount = _b.notLoadedPaletteCount, loadingNumber = _b.loadingNumber, loadingTruckCount = _b.loadingTruckCount, unloadingTruckCount = _b.unloadingTruckCount, shipmentVisit = _b.shipmentVisit, transportationType = _b.transportationType, maxWaitingTime = _b.maxWaitingTime, disponentParty = _b.disponentParty, pickingList = _b.pickingList, hauler = _b.hauler, vehicle = _b.vehicle, visitOrder = _b.visitOrder;
	        var shipmentVisitEntity = mdEntityService_1.default.entityMap.get('ShipmentVisit');
	        return (react_1.default.createElement("form", { style: { marginTop: 10 } },
	            react_1.default.createElement(blockComp_1.BlockComp, null,
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-3" },
	                        react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, shipmentDate.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: shipmentDate, value: shipmentDate.props.value })),
	                    react_1.default.createElement("div", { className: "col-xs-8 col-xs-offset-1" },
	                        react_1.default.createElement("div", { style: { color: colors_1.grey400, marginBottom: 5 } }, shipmentStatus.mdField.formLabelActive),
	                        react_1.default.createElement(radioButtonField_1.default, tslib_1.__assign({}, shipmentStatus.props, { groupStyle: { display: 'flex' }, optionStyle: { width: 'initial', marginRight: 15 }, labelStyle: { whiteSpace: 'nowrap', marginLeft: -10 }, iconStyleFn: function (v) { return ({ fill: shipmentDomain_1.SHIPMENTSTATUS_COLORS[v] }); } })),
	                        react_1.default.createElement(validate_1.Validate, { field: shipmentStatus, value: shipmentStatus.props.value })))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                    react_1.default.createElement(blockComp_1.BlockComp, { className: "block-comp-right-border", header: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Customer"], ["Customer"]))), style: { marginBottom: 0 } },
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-12" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, shippedTo.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.CUSTOMER_ROLE] }), clearable: true })),
	                                react_1.default.createElement(validate_1.Validate, { field: shippedTo, value: shippedTo.props.value, onSuccess: this.onShippedToSuccess })),
	                            react_1.default.createElement("div", { className: "fx col-xs-12" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, shippedToAddress.props, { clearable: false })),
	                                react_1.default.createElement(validate_1.Validate, { field: shippedToAddress, value: shippedToAddress.props.value, onSuccess: this.onShippedToAddressSuccess })),
	                            react_1.default.createElement("div", { className: "fx col-xs-12" },
	                                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, shippedToPlaceDesc.props)))),
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, shippedFromPlace.props, { clearable: false }))),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, disponentParty.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', {
	                                        role: [partyDomain_1.PARTYROLE.CONTACT_ROLE],
	                                        disponent: true
	                                    }), clearable: true })),
	                                react_1.default.createElement(validate_1.Validate, { field: disponentParty, value: disponentParty.props.value }))),
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-12" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, hauler.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.HAULER] }), clearable: true, asterixForAll: true })),
	                                react_1.default.createElement(validate_1.Validate, { field: hauler, value: hauler.props.value, onSuccess: this.onHaulerSuccess })))),
	                    react_1.default.createElement(blockComp_1.BlockComp, { className: "block-comp-right-border", header: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Car"], ["Car"]))), style: { marginBottom: 0 } },
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, vehicle.props, { asterixForAll: true, async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Vehicle', { partyId: dataObject.hauler ? (0, formUtils_1.lovValue)(dataObject.hauler) : -1 }) })),
	                                react_1.default.createElement(validate_1.Validate, { field: vehicle, value: vehicle.props.value, onSuccess: this.onVehicleSuccess })),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, registrationNumber.props)))))),
	                react_1.default.createElement("div", { className: "col-xs-12 col-sm-6" },
	                    react_1.default.createElement(blockComp_1.BlockComp, { header: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Loading"], ["Loading"]))), style: { marginBottom: 0 } },
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, plannedPaletteCount.props)),
	                                react_1.default.createElement(validate_1.Validate, { field: plannedPaletteCount, value: plannedPaletteCount.props.value, onSuccess: this.shipmentDetailsFilled },
	                                    react_1.default.createElement(rules_1.NumberFormat, { precision: 4, scale: 0 }),
	                                    react_1.default.createElement(rules_1.Min, { min: 0 }))),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, loadedPaletteCount.props)),
	                                react_1.default.createElement(validate_1.Validate, { field: loadedPaletteCount, value: loadedPaletteCount.props.value, onSuccess: this.shipmentDetailsFilled },
	                                    react_1.default.createElement(rules_1.NumberFormat, { precision: 4, scale: 0 }),
	                                    react_1.default.createElement(rules_1.Min, { min: 0 }))),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, notLoadedPaletteCount.props)),
	                                react_1.default.createElement(validate_1.Validate, { field: notLoadedPaletteCount, value: notLoadedPaletteCount.props.value },
	                                    react_1.default.createElement(rules_1.NumberFormat, { precision: 4, scale: 0 }),
	                                    react_1.default.createElement(rules_1.Min, { min: 0 }))),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, loadingNumber.props)))),
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, loadingTruckCount.props)),
	                                react_1.default.createElement(validate_1.Validate, { field: loadingTruckCount, value: loadingTruckCount.props.value },
	                                    react_1.default.createElement(rules_1.NumberFormat, { precision: 4, scale: 0 }),
	                                    react_1.default.createElement(rules_1.Min, { min: 0 }))),
	                            react_1.default.createElement("div", { className: "fx col-xs-6" },
	                                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, unloadingTruckCount.props)),
	                                react_1.default.createElement(validate_1.Validate, { field: loadingTruckCount, value: unloadingTruckCount.props.value },
	                                    react_1.default.createElement(rules_1.NumberFormat, { precision: 4, scale: 0 }),
	                                    react_1.default.createElement(rules_1.Min, { min: 0 })))),
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "col-xs-6" },
	                                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, pickingList.props)),
	                                react_1.default.createElement(validate_1.Validate, { field: pickingList, value: pickingList.props.value },
	                                    react_1.default.createElement(rules_1.HasLength, { max: 12 }),
	                                    react_1.default.createElement(rules_1.IsNumber, null))),
	                            react_1.default.createElement("div", { className: "fx col-xs-3" },
	                                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, maxWaitingTime.props)),
	                                react_1.default.createElement(validate_1.Validate, { field: maxWaitingTime, value: maxWaitingTime.props.value },
	                                    react_1.default.createElement(rules_1.NumberFormat, { precision: 4, scale: 0 }),
	                                    react_1.default.createElement(rules_1.Min, { min: 0 }))),
	                            react_1.default.createElement("div", { className: "fx col-xs-3" },
	                                react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, visitOrder.props)),
	                                react_1.default.createElement(validate_1.Validate, { field: visitOrder, value: visitOrder.props.value },
	                                    react_1.default.createElement(rules_1.NumberFormat, { precision: 2, scale: 0 }),
	                                    react_1.default.createElement(rules_1.Min, { min: 1 })))),
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "col-xs-3" },
	                                react_1.default.createElement("div", { style: { color: colors_1.grey400, marginBottom: 5 } }, transportationType.mdField.formLabelActive),
	                                react_1.default.createElement(radioButtonField_1.default, tslib_1.__assign({}, transportationType.props, { groupStyle: { display: 'flex' }, optionStyle: { width: 'initial', marginRight: 15 }, labelStyle: { whiteSpace: 'nowrap', marginLeft: -10 } })),
	                                react_1.default.createElement(validate_1.Validate, { field: transportationType, value: transportationType.props.value, onSuccess: this.onTransportationTypeSuccess })),
	                            react_1.default.createElement("div", { className: "col-xs-9" },
	                                react_1.default.createElement("div", { style: { color: colors_1.grey400, marginBottom: 5 } }, locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["Requested loading time"], ["Requested loading time"])))),
	                                react_1.default.createElement(shipmentRequestedTime_1.ShipmentRequestedTime, { timeStart: dataObject.requestedLoadingStart, timeEnd: dataObject.requestedLoadingEnd, changeTimeFn: this.onChangeTime, dialogTitle: locales_1.loc.i18n(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["Requested loading time"], ["Requested loading time"]))) })))),
	                    react_1.default.createElement(blockComp_1.BlockComp, { style: { marginBottom: 0, paddingBottom: 0 } },
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-12" },
	                                react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, shipmentVisit.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'ShipmentVisit', { unassigned: true }), clearable: true, asterixForAll: true })),
	                                react_1.default.createElement(validate_1.Validate, { field: shipmentVisit, value: shipmentVisit.props.value, onSuccess: this.onShipmentVisitSuccess }))),
	                        (this.shipmentVisit) ? react_1.default.createElement(shipmentVisitDriverForm_1.ShipmentVisitClosedContent, { dataObject: this.shipmentVisit, entities: entities, entity: shipmentVisitEntity, fields: new form_1.default("ShipmentVisitDriverForm", mdEntityService_1.default.getFormDefinition("ShipmentVisitDriverForm")).setupFields(this.shipmentVisit, this.shipmentVisit, shipmentVisitEntity, entities, null) }) : null))),
	            react_1.default.createElement("div", { className: "row" },
	                react_1.default.createElement("div", { className: "col-xs-12" },
	                    react_1.default.createElement(blockComp_1.BlockComp, { style: { marginBottom: 0, marginTop: 0 } },
	                        react_1.default.createElement("div", { className: "row" },
	                            react_1.default.createElement("div", { className: "fx col-xs-12" },
	                                react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props, { multiLine: true, rows: 3 })))))))));
	    };
	    ShipmentOutgoingForm.prototype.computeMaxWaitingTime = function (dataObject, form) {
	        return shipmentService_1.default.computeField("maxWaitingTime", {
	            shippedToAddress: (0, formUtils_1.lovValue)(dataObject.shippedToAddress),
	            transportationType: (0, formUtils_1.lovValue)(dataObject.transportationType)
	        })
	            .then((0, mobx_1.action)("computeField-cb", function (v) {
	            if (v) {
	                dataObject.maxWaitingTime = v;
	                form.updateFieldsPropValue(dataObject, "maxWaitingTime");
	            }
	        }));
	    };
	    ShipmentOutgoingForm.prototype.updateDisponentParty = function (dataObject, form) {
	        return shipmentService_1.default.computeField("disponentParty", {
	            shippedToAddress: (0, formUtils_1.lovValue)(dataObject.shippedToAddress)
	        })
	            .then((0, mobx_1.action)("computeDisponent", function (v) {
	            dataObject.disponentParty = v;
	            form.updateFieldsPropValue(dataObject, "disponentParty");
	        }));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentOutgoingForm.prototype, "shipmentVisit", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentOutgoingForm.prototype, "onChangeTime", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentOutgoingForm.prototype, "shipmentDetailsFilled", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentOutgoingForm.prototype, "onShippedToSuccess", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentOutgoingForm.prototype, "onShippedToAddressSuccess", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentOutgoingForm.prototype, "onTransportationTypeSuccess", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentOutgoingForm.prototype, "onShipmentVisitSuccess", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentOutgoingForm.prototype, "onHaulerSuccess", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentOutgoingForm.prototype, "onVehicleSuccess", void 0);
	    ShipmentOutgoingForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'ShipmentOutgoingForm',
	            fields: [{
	                    name: 'shipmentDate',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'shipmentStatus',
	                    validators: ['IsRequired'],
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.radioButton
	                }, {
	                    name: 'comment',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	                }, {
	                    name: 'shippedTo',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'shippedToAddress',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'shippedToPlaceDesc'
	                }, {
	                    name: 'registrationNumber'
	                }, {
	                    name: 'shippedFromPlace'
	                }, {
	                    name: 'plannedPaletteCount',
	                    validators: ['IsNumber']
	                }, {
	                    name: 'loadedPaletteCount',
	                    validators: ['IsNumber']
	                }, {
	                    name: 'notLoadedPaletteCount',
	                    validators: ['IsNumber'],
	                }, {
	                    name: 'loadingNumber'
	                }, {
	                    name: 'loadingTruckCount',
	                    validators: ['IsNumber']
	                }, {
	                    name: 'unloadingTruckCount',
	                    validators: ['IsNumber']
	                }, {
	                    name: 'shipmentVisit'
	                }, {
	                    name: 'transportationType',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.radioButton
	                }, {
	                    name: 'maxWaitingTime'
	                }, {
	                    name: 'disponentParty'
	                }, {
	                    name: 'hauler'
	                }, {
	                    name: 'pickingList'
	                }, {
	                    name: 'vehicle'
	                }, {
	                    name: 'visitOrder',
	                    validators: ['IsNumber', 'IsRequired']
	                }]
	        }, function () { return react_1.default.createElement("noscript", null); }),
	        mobx_react_1.observer
	    ], ShipmentOutgoingForm);
	    return ShipmentOutgoingForm;
	}(react_1.default.Component));
	exports.default = ShipmentOutgoingForm;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var fields_1 = __webpack_require__(20);
	var form_1 = __webpack_require__(52);
	var createForm_1 = __webpack_require__(18);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var blockComp_1 = __webpack_require__(30);
	var validate_1 = __webpack_require__(24);
	var rules_1 = __webpack_require__(56);
	var commonDataService_1 = __webpack_require__(41);
	var mobx_react_1 = __webpack_require__(4);
	var partyDomain_1 = __webpack_require__(48);
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var colors_1 = __webpack_require__(29);
	var radioButtonField_1 = tslib_1.__importDefault(__webpack_require__(144));
	var dateUtils_1 = __webpack_require__(49);
	var mobx_1 = __webpack_require__(5);
	var formUtils_1 = __webpack_require__(14);
	var ShipmentRepackagingForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentRepackagingForm, _super);
	    function ShipmentRepackagingForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onShippedToSuccess = function () {
	            var _a = _this.props, entities = _a.entities, dataObject = _a.dataObject, form = _a.form;
	            console.log('onShippedToChange ', dataObject.shippedTo);
	            var partyId = (0, formUtils_1.lovValue)(dataObject.shippedTo);
	            return _this.populateShippedToAddress(partyId, true);
	        };
	        return _this;
	    }
	    ShipmentRepackagingForm.prototype.componentDidMount = function () {
	        var partyId = (0, formUtils_1.lovValue)(this.props.dataObject.shippedTo);
	        return this.populateShippedToAddress(partyId, false);
	    };
	    ShipmentRepackagingForm.prototype.componentDidUpdate = function () {
	        var _a = this.props, form = _a.form, dataObject = _a.dataObject;
	        var shippedToAddressField = form.getField("shippedToAddress");
	        var partyId = (0, formUtils_1.lovValue)(dataObject.shippedTo);
	        if (shippedToAddressField && partyId && (!shippedToAddressField.props.options || !shippedToAddressField.props.options.length)) {
	            console.debug("componentDidUpdate, no dropdown data filling");
	            return this.populateShippedToAddress(partyId, false);
	        }
	    };
	    ShipmentRepackagingForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entity = _a.entity, entities = _a.entities, form = _a.form, formName = _a.formName;
	        var fields = form.fields;
	        var _b = dataObject.getFormFields(formName), shipmentDate = _b.shipmentDate, shipmentTime = _b.shipmentTime, comment = _b.comment, shippedTo = _b.shippedTo, shippedToAddress = _b.shippedToAddress, product = _b.product, repackagingStatus = _b.repackagingStatus, packageType = _b.packageType, customerNumber = _b.customerNumber, repackagingCode = _b.repackagingCode, boxQuantity = _b.boxQuantity, paletteCount = _b.paletteCount, paletteItemCount = _b.paletteItemCount, priority = _b.priority;
	        return (react_1.default.createElement("form", { style: { marginTop: 10 } },
	            react_1.default.createElement(blockComp_1.BlockComp, null,
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                        react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, shipmentDate.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: shipmentDate, value: shipmentDate.props.value })),
	                    react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-2" },
	                        react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, shipmentTime.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: shipmentTime, value: shipmentTime.props.value },
	                            react_1.default.createElement(rules_1.Pattern, { pattern: dateUtils_1.TIME_PATTERN_HH_mm }))),
	                    react_1.default.createElement("div", { className: "col-xs-12 col-sm-7 col-sm-offset-1" },
	                        react_1.default.createElement("div", { style: { color: colors_1.grey400, marginBottom: 5 } }, repackagingStatus.mdField.formLabelActive),
	                        react_1.default.createElement(radioButtonField_1.default, tslib_1.__assign({}, repackagingStatus.props, { groupStyle: { display: 'flex' }, optionStyle: { width: 'initial', marginRight: 15 }, labelStyle: { whiteSpace: 'nowrap', marginLeft: -10 }, iconStyleFn: function (v) { return ({ fill: dataObject.getRepackagingStatusIconClass((0, moment_1.default)().startOf('day'), v) }); } })),
	                        react_1.default.createElement(validate_1.Validate, { field: repackagingStatus, value: repackagingStatus.props.value }))),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-1" },
	                        react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, priority.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: priority, value: priority.props.value },
	                            react_1.default.createElement(rules_1.NumberFormat, { precision: 1, scale: 0 }),
	                            react_1.default.createElement(rules_1.Min, { min: 1 }),
	                            react_1.default.createElement(rules_1.Max, { max: 9 }))),
	                    react_1.default.createElement("div", { className: "fx col-xs-13 col-sm-11" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, shippedTo.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Party', { role: [partyDomain_1.PARTYROLE.CUSTOMER_ROLE] }), clearable: true })),
	                        react_1.default.createElement(validate_1.Validate, { field: shippedTo, value: shippedTo.props.value, onSuccess: this.onShippedToSuccess })),
	                    react_1.default.createElement("div", { className: "fx col-xs-13 col-sm-11" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, shippedToAddress.props, { clearable: false })),
	                        react_1.default.createElement(validate_1.Validate, { field: shippedToAddress, value: shippedToAddress.props.value }))),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, packageType.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: packageType, value: packageType.props.value })),
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, product.props, { async: true, loadOptions: commonDataService_1.optionsSearch.bind(this, 'Product', {}), clearable: true })),
	                        react_1.default.createElement(validate_1.Validate, { field: product, value: product.props.value })),
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, repackagingCode.props))),
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, boxQuantity.props))),
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, customerNumber.props)))),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, paletteCount.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: paletteCount, value: paletteCount.props.value },
	                            react_1.default.createElement(rules_1.NumberFormat, { precision: 4, scale: 0 }),
	                            react_1.default.createElement(rules_1.Min, { min: 0 }))),
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-4" },
	                        react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, paletteItemCount.props)),
	                        react_1.default.createElement(validate_1.Validate, { field: paletteItemCount, value: paletteItemCount.props.value },
	                            react_1.default.createElement(rules_1.NumberFormat, { precision: 4, scale: 0 }),
	                            react_1.default.createElement(rules_1.Min, { min: 0 })))),
	                react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12" },
	                        react_1.default.createElement("div", { className: "fx col-xs-12" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, comment.props, { multiLine: true, rows: 4 }))))))));
	    };
	    ShipmentRepackagingForm.prototype.populateShippedToAddress = function (partyId, reset) {
	        var _a = this.props, dataObject = _a.dataObject, form = _a.form;
	        return ((partyId != null) ? (0, commonDataService_1.optionsSearch)('Address', { partyId: partyId }) : Promise.resolve({ options: [] }))
	            .then((0, mobx_1.action)("onShippedToChange-cb1", function (_a) {
	            var options = _a.options;
	            form.getField("shippedToAddress").props.options = options;
	            if (reset) {
	                dataObject.shippedToAddress = (options.length === 1) ? options[0] : null;
	                form.updateFieldsPropValue(dataObject, "shippedToAddress");
	            }
	        }));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentRepackagingForm.prototype, "onShippedToSuccess", void 0);
	    ShipmentRepackagingForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'ShipmentRepackagingForm',
	            fields: [{
	                    name: 'shipmentDate',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'shipmentTime'
	                }, {
	                    name: 'repackagingStatus',
	                    validators: ['IsRequired'],
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.radioButton
	                }, {
	                    name: 'comment',
	                    displayType: form_1.FIELDDEFDISPLAYTYPE.textArea
	                }, {
	                    name: 'shippedTo',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'shippedToAddress',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'paletteCount',
	                    validators: ['IsNumber']
	                }, {
	                    name: 'paletteItemCount',
	                    validators: ['IsNumber']
	                }, {
	                    name: 'product'
	                }, {
	                    name: 'repackagingCode'
	                }, {
	                    name: 'boxQuantity'
	                }, {
	                    name: 'customerNumber'
	                }, {
	                    name: 'packageType',
	                    validators: ['IsRequired']
	                }, {
	                    name: 'priority',
	                    validators: ['IsNumber']
	                }]
	        }, function () { return react_1.default.createElement("noscript", null); }),
	        mobx_react_1.observer
	    ], ShipmentRepackagingForm);
	    return ShipmentRepackagingForm;
	}(react_1.default.Component));
	exports.default = ShipmentRepackagingForm;


/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ShipmentRepackagingResourceDialog = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var createForm_1 = __webpack_require__(18);
	var validate_1 = __webpack_require__(24);
	var errorComp_1 = __webpack_require__(34);
	var mobx_1 = __webpack_require__(5);
	var mobx_react_1 = __webpack_require__(4);
	var dialogAncestor_1 = __webpack_require__(87);
	var numberField_1 = tslib_1.__importDefault(__webpack_require__(88));
	var rules_1 = __webpack_require__(56);
	var dateUtils_1 = __webpack_require__(49);
	var shipmentService_1 = tslib_1.__importDefault(__webpack_require__(176));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var metaConstant_1 = __webpack_require__(13);
	/* ************************************************************************************************
	 * ***********   DIALOG  *************************************************************
	 * ********************************************************************************************** */
	var ShipmentRepackagingResourceDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentRepackagingResourceDialog, _super);
	    function ShipmentRepackagingResourceDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.ok = function () {
	            _this.$errors = [];
	            var form = _this.resource.getForm("ShipmentRepackagingResourceDialogForm");
	            form.validateForm(_this.resource, _this.$errors);
	            if (!_this.$errors.length) {
	                shipmentService_1.default.saveShipmentRepackagingResource(_this.resource)
	                    .then(function () {
	                    _this.dialogOpen = false;
	                    _this.resolve("OK");
	                }, function (error) {
	                    _this.$errors = error.getMessages();
	                });
	            }
	        };
	        _this.cancel = function () {
	            _this.dialogOpen = false;
	            _this.reject("cancel");
	        };
	        return _this;
	    }
	    ShipmentRepackagingResourceDialog.prototype.open = function (resolve, reject, toolbarDate, resource) {
	        console.log('ShipmentRepackagingResourceDialog: Opening dialog for toolbarDate', toolbarDate);
	        this.resource = resource;
	        this.resolve = resolve;
	        this.reject = reject;
	        this.dialogOpen = true;
	        this.toolbarDate = toolbarDate;
	    };
	    ShipmentRepackagingResourceDialog.prototype.render = function () {
	        if (!(this.dialogOpen))
	            return null;
	        console.log('MultiUpdateDialog: rendering dialog');
	        var actions = [
	            react_1.default.createElement(FlatButton_1.default, { label: "Cancel", primary: true, onClick: this.cancel }),
	            react_1.default.createElement(FlatButton_1.default, { label: "Save", disabled: (0, moment_1.default)(this.resource.workDate).isBefore((0, dateUtils_1.stripTime)(new Date())), secondary: true, onClick: this.ok }),
	        ];
	        return (react_1.default.createElement(Dialog_1.default, { title: "Norma na ".concat((0, dateUtils_1.formatDate)(this.toolbarDate)), actions: actions, modal: true, open: this.dialogOpen, contentStyle: { width: '60%', maxWidth: 'none' }, bodyStyle: { overflow: 'visible' } },
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: this.$errors }),
	            (this.resource) ? (react_1.default.createElement(ShipmentRepackagingResourceDialogForm, { entities: mdEntityService_1.default.entityMap, entity: mdEntityService_1.default.getEntity("ShipmentRepackagingResource"), dataObject: this.resource, rootObject: this.resource, toolbarDate: this.toolbarDate })) : null));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackagingResourceDialog.prototype, "toolbarDate", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackagingResourceDialog.prototype, "resource", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentRepackagingResourceDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentRepackagingResourceDialog.prototype, "ok", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentRepackagingResourceDialog.prototype, "cancel", void 0);
	    ShipmentRepackagingResourceDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ShipmentRepackagingResourceDialog);
	    return ShipmentRepackagingResourceDialog;
	}(dialogAncestor_1.DialogAncestor));
	exports.ShipmentRepackagingResourceDialog = ShipmentRepackagingResourceDialog;
	var ShipmentRepackagingResourceDialogForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentRepackagingResourceDialogForm, _super);
	    function ShipmentRepackagingResourceDialogForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ShipmentRepackagingResourceDialogForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, index = _a.index, form = _a.form, toolbarDate = _a.toolbarDate;
	        var _b = form.fields, availableResources = _b.availableResources, dailyPalleteNorm = _b.dailyPalleteNorm;
	        var hasRightForNorm = securityService_1.default.hasRight(metaConstant_1.SECURABLE.shipmentRepackagingSetNorm.name, metaConstant_1.PERMISSION.Execute);
	        return (react_1.default.createElement("div", { style: { display: 'flex' } },
	            react_1.default.createElement("div", { style: { marginRight: 10 } },
	                react_1.default.createElement("div", null,
	                    react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, availableResources.props)),
	                    react_1.default.createElement(validate_1.Validate, { field: availableResources, value: availableResources.props.value },
	                        react_1.default.createElement(rules_1.NumberFormat, { precision: 10, scale: 2 }),
	                        react_1.default.createElement(rules_1.Min, { min: 0 })))),
	            react_1.default.createElement("div", { style: { marginRight: 10 } },
	                react_1.default.createElement("div", null,
	                    react_1.default.createElement(numberField_1.default, tslib_1.__assign({}, dailyPalleteNorm.props, { disabled: !hasRightForNorm })),
	                    react_1.default.createElement(validate_1.Validate, { field: dailyPalleteNorm, value: dailyPalleteNorm.props.value },
	                        react_1.default.createElement(rules_1.NumberFormat, { precision: 4, scale: 0 }),
	                        react_1.default.createElement(rules_1.Min, { min: 0 }))))));
	    };
	    ShipmentRepackagingResourceDialogForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'ShipmentRepackagingResourceDialogForm',
	            fields: [{
	                    name: 'availableResources',
	                    validators: ['IsNumber', 'IsRequired'],
	                }, {
	                    name: 'dailyPalleteNorm',
	                    validators: ['IsNumber', 'IsRequired'],
	                }]
	        }, function () { return react_1.default.createElement("noscript", null); }),
	        mobx_react_1.observer
	    ], ShipmentRepackagingResourceDialogForm);
	    return ShipmentRepackagingResourceDialogForm;
	}(react_1.default.Component));


/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ShipmentRepackagingUpdateDialog = void 0;
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var Dialog_1 = tslib_1.__importDefault(__webpack_require__(76));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var createForm_1 = __webpack_require__(18);
	var validate_1 = __webpack_require__(24);
	var errorComp_1 = __webpack_require__(34);
	var mobx_1 = __webpack_require__(5);
	var commonService_1 = tslib_1.__importDefault(__webpack_require__(79));
	var mobx_react_1 = __webpack_require__(4);
	var dialogAncestor_1 = __webpack_require__(87);
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var multiUpdateDialog_1 = __webpack_require__(568);
	var shipmentDomain_1 = __webpack_require__(132);
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var util_1 = __webpack_require__(2263);
	var locales_1 = __webpack_require__(15);
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	/* ************************************************************************************************
	 * ***********   DIALOG  *************************************************************
	 * ********************************************************************************************** */
	var ShipmentRepackagingUpdateDialog = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentRepackagingUpdateDialog, _super);
	    function ShipmentRepackagingUpdateDialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.ok = function () {
	            var shipmentRepackagingEntity = mdEntityService_1.default.getEntity("ShipmentRepackaging");
	            if (_this.shipmentRepackaging.repackedDate) {
	                if ((0, util_1.isString)(_this.shipmentRepackaging.repackedDate))
	                    _this.shipmentRepackaging.repackedDate = new Date(_this.shipmentRepackaging.repackedDate);
	                _this.shipmentRepackaging.repackedDate.setMilliseconds(0);
	            }
	            var multiUpdateDto = multiUpdateDialog_1.MultiUpdateDto.newInstance(_this.grid.$entityRef, [
	                new multiUpdateDialog_1.MultiUpdateField(shipmentRepackagingEntity, _this.shipmentRepackaging.repackedDate, "repackedDate")
	            ], _this.grid.createFullParams());
	            multiUpdateDto.customName = "ShipmentRepackagingUpdateDialog";
	            _this.$errors = [];
	            var form = _this.shipmentRepackaging.getForm("ShipmentRepackagingUpdateFieldForm");
	            form.validateForm(_this.shipmentRepackaging, _this.$errors);
	            if (!_this.$errors.length) {
	                commonService_1.default.loading(true);
	                gridService_1.default.multiUpdate(multiUpdateDto)
	                    .then(function (mud) {
	                    commonService_1.default.loading(false);
	                    _this.dialogOpen = false;
	                    _this.resolve("OK");
	                    commonService_1.default.notifySuccess("Bylo aktualizov\u00E1no ".concat(mud.count, "  z\u00E1znam\u016F"));
	                }, function (error) {
	                    _this.$errors = error.getMessages();
	                });
	            }
	        };
	        _this.cancel = function () {
	            _this.dialogOpen = false;
	            _this.reject("cancel");
	        };
	        return _this;
	    }
	    ShipmentRepackagingUpdateDialog.prototype.open = function (resolve, reject, grid) {
	        var gridParams = grid.createFullParams();
	        console.log('ShipmentRepackagingUpdateDialog: Opening dialog for gridParams', gridParams);
	        this.shipmentRepackaging = new shipmentDomain_1.ShipmentRepackaging({ $new: true, repackedDate: (0, moment_1.default)().millisecond(0).toDate() });
	        this.resolve = resolve;
	        this.reject = reject;
	        this.dialogOpen = true;
	        this.grid = grid;
	        this.$errors = [];
	    };
	    ShipmentRepackagingUpdateDialog.prototype.render = function () {
	        if (!(this.dialogOpen))
	            return null;
	        console.log('ShipmentRepackagingUpdateDialog: rendering dialog');
	        var actions = [
	            react_1.default.createElement(FlatButton_1.default, { label: "Cancel", primary: true, onClick: this.cancel }),
	            react_1.default.createElement(FlatButton_1.default, { label: "Update", secondary: true, onClick: this.ok }),
	        ];
	        return (react_1.default.createElement(Dialog_1.default, { title: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Advance ", " repackagings"], ["Advance ", " repackagings"])), this.grid.getSelectedCount()), actions: actions, modal: true, open: this.dialogOpen, contentStyle: { width: '60%', maxWidth: 'none' }, bodyStyle: { overflow: 'visible' } },
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: this.$errors }),
	            react_1.default.createElement(ShipmentRepackagingUpdateFieldForm, { entities: mdEntityService_1.default.entityMap, entity: mdEntityService_1.default.getEntity("ShipmentRepackaging"), dataObject: this.shipmentRepackaging, rootObject: this.shipmentRepackaging })));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackagingUpdateDialog.prototype, "shipmentRepackaging", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentRepackagingUpdateDialog.prototype, "open", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentRepackagingUpdateDialog.prototype, "ok", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentRepackagingUpdateDialog.prototype, "cancel", void 0);
	    ShipmentRepackagingUpdateDialog = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ShipmentRepackagingUpdateDialog);
	    return ShipmentRepackagingUpdateDialog;
	}(dialogAncestor_1.DialogAncestor));
	exports.ShipmentRepackagingUpdateDialog = ShipmentRepackagingUpdateDialog;
	/* ************************************************************************************************
	 * ***********   FORM  *************************************************************
	 * ********************************************************************************************** */
	var ShipmentRepackagingUpdateFieldForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentRepackagingUpdateFieldForm, _super);
	    function ShipmentRepackagingUpdateFieldForm() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ShipmentRepackagingUpdateFieldForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entities = _a.entities, index = _a.index, form = _a.form;
	        var repackedDate = form.fields.repackedDate;
	        return (react_1.default.createElement("div", null,
	            react_1.default.createElement("div", null,
	                react_1.default.createElement(styledDatePicker_1.default, tslib_1.__assign({}, repackedDate.props, { time: true })),
	                react_1.default.createElement(validate_1.Validate, { field: repackedDate, value: repackedDate.props.value }))));
	    };
	    ShipmentRepackagingUpdateFieldForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'ShipmentRepackagingUpdateFieldForm',
	            fields: [{
	                    name: 'repackedDate',
	                    validators: ['IsRequired']
	                }]
	        }, function () { return react_1.default.createElement("noscript", null); }),
	        mobx_react_1.observer
	    ], ShipmentRepackagingUpdateFieldForm);
	    return ShipmentRepackagingUpdateFieldForm;
	}(react_1.default.Component));
	var templateObject_1;


/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var fields_1 = __webpack_require__(20);
	var createForm_1 = __webpack_require__(18);
	var formUtils_1 = __webpack_require__(14);
	var blockComp_1 = __webpack_require__(30);
	var validate_1 = __webpack_require__(24);
	var mobx_react_1 = __webpack_require__(4);
	var shipmentDomain_1 = __webpack_require__(132);
	var form_1 = tslib_1.__importStar(__webpack_require__(52));
	var mobx_1 = __webpack_require__(5);
	var locales_1 = __webpack_require__(15);
	var styledSelect_1 = tslib_1.__importDefault(__webpack_require__(23));
	var commonDataService_1 = __webpack_require__(41);
	var mdField_1 = tslib_1.__importStar(__webpack_require__(57));
	var colors_1 = __webpack_require__(29);
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var partyDomain_1 = __webpack_require__(48);
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var radioButtonField_1 = tslib_1.__importDefault(__webpack_require__(144));
	var FlatButton_1 = tslib_1.__importDefault(__webpack_require__(36));
	var gridComp_1 = tslib_1.__importStar(__webpack_require__(44));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var shipmentService_1 = tslib_1.__importDefault(__webpack_require__(176));
	var dateUtils_1 = __webpack_require__(49);
	var grid_1 = __webpack_require__(50);
	var selectSearchDialog_1 = tslib_1.__importDefault(__webpack_require__(311));
	var gridConfigCondition_1 = tslib_1.__importDefault(__webpack_require__(194));
	var shipmentVisitComps_1 = __webpack_require__(966);
	var styledDatePicker_1 = tslib_1.__importDefault(__webpack_require__(80));
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var rules_1 = __webpack_require__(56);
	var constant_1 = __webpack_require__(399);
	var shipmentVisitDriverForm_1 = __webpack_require__(407);
	var SvgEdit = __webpack_require__(379);
	var SvgClear = __webpack_require__(248);
	var visitNewShipmentGridLocation = 'visitNewShipmentList';
	var ShipmentVisitPrepareForm = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentVisitPrepareForm, _super);
	    function ShipmentVisitPrepareForm() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.selectSearchDialogRefHandler = function (comp) { return _this.selectSearchDialogRef = comp; };
	        _this.onSave = function (e) {
	            var _a = _this.props, dataObject = _a.dataObject, entities = _a.entities, onSubmit = _a.onSubmit;
	            return onSubmit(dataObject).then(function () {
	                console.log("After onSave shipment statuses: ", shipmentService_1.default.shipmentVisitObject.shipments.map(function (s) { return (0, formUtils_1.lovValue)(s.shipmentStatus); }).join(", "));
	                shipmentService_1.default.shipmentVisitObject.$shipmentVisitShipmentsGrid.selectAllRows(false);
	                return shipmentService_1.default.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService_1.default.shipmentVisitObject);
	            });
	        };
	        _this.onNextVehicleArrived = function (e) {
	            var _a = _this.props, dataObject = _a.dataObject, entities = _a.entities, onSubmit = _a.onSubmit;
	            return onSubmit(dataObject, function () {
	                dataObject.step = entities.get("SHIPMENTVISITSTEP").getLovItem(shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_ARRIVED);
	                dataObject.visitTime = (dataObject.$nextTime) ? dataObject.$nextTime : new Date().toISOString();
	                dataObject.$nextTime = undefined;
	            }).then(function () {
	                shipmentService_1.default.shipmentVisitObject.$shipmentVisitShipmentsGrid.selectAllRows(false);
	                return shipmentService_1.default.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService_1.default.shipmentVisitObject);
	            });
	        };
	        _this.onNextVehicleEntered = function (e) {
	            var _a = _this.props, dataObject = _a.dataObject, entities = _a.entities, onSubmit = _a.onSubmit;
	            return onSubmit(dataObject, function () {
	                dataObject.step = entities.get("SHIPMENTVISITSTEP").getLovItem(shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_ENTERED);
	                dataObject.entranceTime = (dataObject.$nextTime) ? dataObject.$nextTime : new Date().toISOString();
	                dataObject.$nextTime = undefined;
	                if (!dataObject.$showSmsToDriver)
	                    dataObject.setTuple("SHIPMENT_GATE_ARRIVAL_TO_DRIVER_SMS_TEXT", undefined);
	            }).then(function () {
	                shipmentService_1.default.shipmentVisitObject.$shipmentVisitShipmentsGrid.selectAllRows(false);
	                return shipmentService_1.default.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService_1.default.shipmentVisitObject);
	            });
	        };
	        _this.onNextVehicleLeft = function (e) {
	            var _a = _this.props, dataObject = _a.dataObject, entities = _a.entities, onSubmit = _a.onSubmit;
	            return onSubmit(dataObject, function () {
	                dataObject.step = entities.get("SHIPMENTVISITSTEP").getLovItem(shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_LEFT);
	                dataObject.visitEnd = (dataObject.$nextTime) ? dataObject.$nextTime : new Date().toISOString();
	                dataObject.$nextTime = undefined;
	            }).then(function () {
	                shipmentService_1.default.shipmentVisitObject.$shipmentVisitShipmentsGrid.selectAllRows(false);
	                return shipmentService_1.default.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService_1.default.shipmentVisitObject);
	            });
	        };
	        _this.handleDirectionChange = function (newLov) {
	            var dataObject = _this.props.dataObject;
	            dataObject.$direction = newLov;
	            dataObject.directionOutgoing = ((0, formUtils_1.lovValue)(newLov) === shipmentDomain_1.SHIPMENTDIRECTION.OUTGOING);
	            dataObject.directionIncoming = ((0, formUtils_1.lovValue)(newLov) === shipmentDomain_1.SHIPMENTDIRECTION.INCOMING);
	            dataObject.directionPackaging = false;
	            dataObject.$visitsToDelete = [];
	            var _prev = dataObject.shipments;
	            dataObject.shipments = (dataObject.$previousShipments) ? dataObject.$previousShipments.filter(function (sh) { return sh.shipmentDirection === (0, formUtils_1.lovValue)(newLov); }) : [];
	            dataObject.$previousShipments = _prev;
	            return shipmentService_1.default.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService_1.default.shipmentVisitObject);
	        };
	        _this.findShipmentsSpz = function (evt) {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            var shipmentDate = (0, dateUtils_1.formatDateIso)(dataObject.dateCreated ? dataObject.dateCreated : new Date());
	            return shipmentService_1.default.readShipments(dataObject.registrationNumber, shipmentDate, grid_1.FILTEROPERATOR.LESSOREQUALTHAN, undefined, dataObject.$direction.value, dataObject, false)
	                .then((0, mobx_1.action)("readShipments-acb", function (shipments) {
	                dataObject.shipments = shipments;
	                dataObject.$syncRegistrationNumber = dataObject.shipments.some(function (sh) { return sh.registrationNumber !== dataObject.registrationNumber; });
	                return shipmentService_1.default.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService_1.default.shipmentVisitObject);
	            }));
	        };
	        _this.findShipmentsSupplier = function (evt) {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            var shipmentDate = (0, dateUtils_1.formatDateIso)(dataObject.dateCreated ? dataObject.dateCreated : new Date());
	            return shipmentService_1.default.readShipments(undefined, shipmentDate, grid_1.FILTEROPERATOR.LESSOREQUALTHAN, (0, formUtils_1.lovValue)(dataObject.$supplierId), dataObject.$direction.value, dataObject, true)
	                .then((0, mobx_1.action)("readShipments-acb", function (shipments) {
	                dataObject.shipments = shipments;
	                dataObject.$syncRegistrationNumber = dataObject.shipments.some(function (sh) { return sh.registrationNumber !== dataObject.registrationNumber; });
	                return shipmentService_1.default.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService_1.default.shipmentVisitObject);
	            }));
	        };
	        _this.handleDirectionPackaging = function (evt) {
	            var _a = _this.props, entities = _a.entities, dataObject = _a.dataObject, form = _a.form, rootObject = _a.rootObject;
	            form.getField("directionPackaging").props.onCheck(evt);
	            if (!dataObject.directionPackaging) {
	                dataObject.packagingSender = undefined;
	                form.updateFieldsPropValue(dataObject, "packagingSender");
	            }
	        };
	        _this.handleSyncSpz = function (evt) {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            dataObject.$syncRegistrationNumber = evt.target.checked;
	        };
	        _this.handleRegistrationNumberSuccess = function () {
	            var dataObject = _this.props.dataObject;
	            dataObject.$syncRegistrationNumber = dataObject.shipments.some(function (sh) { return sh.registrationNumber !== dataObject.registrationNumber; });
	        };
	        _this.handleSyncShippedFromPlace = function (value) {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            dataObject.$syncShippedFromPlace = value;
	        };
	        _this.onCheckAllReady = function (evt) {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            dataObject.$syncShipmentStatus = (evt.target.checked) ? shipmentDomain_1.SHIPMENTSTATUS.READY : undefined;
	        };
	        _this.onCheckPartiallyReady = function (evt) {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            dataObject.$syncShipmentStatus = (evt.target.checked) ? shipmentDomain_1.SHIPMENTSTATUS.PARTIALLYREADY : undefined;
	        };
	        _this.onCheckDocument = function (evt) {
	            var _a = _this.props, dataObject = _a.dataObject, form = _a.form;
	            dataObject.$syncShipmentStatus = (evt.target.checked) ? shipmentDomain_1.SHIPMENTSTATUS.DOCUMENT : undefined;
	        };
	        _this.handleShowSmsToDriver = function (evt) {
	            var dataObject = _this.props.dataObject;
	            dataObject.$showSmsToDriver = evt.target.checked;
	        };
	        _this.handleSmsToDriverText = function (evt) {
	            var dataObject = _this.props.dataObject;
	            dataObject.setTuple("SHIPMENT_GATE_ARRIVAL_TO_DRIVER_SMS_TEXT", evt.target.value);
	        };
	        _this.addShipments = function () {
	            var _a = _this.props, dataObject = _a.dataObject, entity = _a.entity, rootObject = _a.rootObject, entities = _a.entities;
	            console.log('addShipments');
	            var shipmentEntity = entities.get("Shipment");
	            new Promise(function (resolve, reject) {
	                return _this.selectSearchDialogRef.open(resolve, reject, function (grid) {
	                    if (!grid.conditionArray)
	                        grid.conditionArray = [];
	                    // vyloucime jiz pridane
	                    if (dataObject.shipments && dataObject.shipments.length) {
	                        grid.conditionArray.push(new gridConfigCondition_1.default(grid.$gridLocationRef, {
	                            field: shipmentEntity.getField("shipmentId"),
	                            operator: grid_1.FILTEROPERATOR.NOTIN,
	                            values: dataObject.shipments.map(function (s) { return s.shipmentId; })
	                        }));
	                    }
	                    // vyloucime podle DIRECTION
	                    grid.conditionArray.push(new gridConfigCondition_1.default(grid.$gridLocationRef, {
	                        field: shipmentEntity.getField("shipmentDirection"),
	                        operator: grid_1.FILTEROPERATOR.EQUAL,
	                        values: [dataObject.$direction]
	                    }));
	                });
	            }).then((0, mobx_1.action)("close-new-party-diaglog", function (shipments) {
	                console.log("adding %o", shipments);
	                dataObject.shipments = tslib_1.__spreadArray(tslib_1.__spreadArray([], dataObject.shipments || [], true), shipments, true);
	                dataObject.$syncRegistrationNumber = dataObject.shipments.some(function (sh) { return sh.registrationNumber !== dataObject.registrationNumber; });
	                rootObject.$dirty = true;
	                return shipmentService_1.default.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService_1.default.shipmentVisitObject);
	            })).catch(function (e) {
	            });
	        };
	        _this.gridDeleteOverrideFn = function (rootObject, modifiedRows, toDeleteRows, params) {
	            var dataObject = _this.props.dataObject;
	            if (toDeleteRows && toDeleteRows.length) {
	                var shipmentIds_1 = toDeleteRows.map(function (v) { return v.rowId; });
	                dataObject.shipments = dataObject.shipments.filter(function (sh) { return !shipmentIds_1.includes(sh.shipmentId); });
	                _this.props.rootObject.$dirty = true;
	                return shipmentService_1.default.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService_1.default.shipmentVisitObject);
	            }
	            else {
	                return Promise.resolve(null);
	            }
	        };
	        return _this;
	    }
	    ShipmentVisitPrepareForm.prototype.componentWillMount = function () {
	        var dataObject = this.props.dataObject;
	        this.setPlus(dataObject);
	        dataObject.$shipmentVisitShipmentsGrid.showSelection = true;
	    };
	    ShipmentVisitPrepareForm.prototype.componentDidMount = function () {
	        var _this = this;
	        return (0, commonDataService_1.optionsSearch)('AddressPlace', {
	            partyId: securityService_1.default.currentTenant.party.value,
	            placeType: partyDomain_1.ADDRESSPLACETYPE.EXPEDITION
	        }).then(function (_a) {
	            var placeOptions = _a.options;
	            placeOptions.unshift({ value: null, label: '---' });
	            _this.placeOptions = placeOptions;
	        });
	    };
	    ShipmentVisitPrepareForm.prototype.componentDidUpdate = function (prevProps, prevState, prevContext) {
	        this.setPlus(this.props.dataObject);
	        this.props.dataObject.$shipmentVisitShipmentsGrid.showSelection = true;
	    };
	    ShipmentVisitPrepareForm.prototype.setPlus = function (dataObject) {
	        if (!dataObject.driverPhone && [shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_ARRIVED, shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_ENTERED].includes((0, formUtils_1.lovValue)(dataObject.step))) {
	            dataObject.driverPhone = "+";
	            this.props.form.updateFieldsPropValue(dataObject, "driverPhone");
	        }
	    };
	    ShipmentVisitPrepareForm.prototype.render = function () {
	        var _a = this.props, dataObject = _a.dataObject, rootObject = _a.rootObject, entity = _a.entity, entities = _a.entities, form = _a.form, formName = _a.formName, disabled = _a.disabled;
	        var _b = dataObject.getFormFields(formName), registrationNumber = _b.registrationNumber, directionPackaging = _b.directionPackaging, visitTime = _b.visitTime, visitEnd = _b.visitEnd, $supplierId = _b.$supplierId, packagingSender = _b.packagingSender, entranceTime = _b.entranceTime, driverPhone = _b.driverPhone;
	        console.log("Rendering ShipmentVisitPrepareForm, shipments count %s", (dataObject.shipments) ? dataObject.shipments.length : 0);
	        var updateRight = securityService_1.default.hasRight(metaConstant_1.SECURABLE.shipmentVisitDetail.name, metaConstant_1.PERMISSION.Update);
	        var shipmentdirectionEntity = entities.get("SHIPMENTDIRECTION");
	        var shipmentVisitStepEntity = entities.get("SHIPMENTVISITSTEP");
	        //let activeStepNumber = shipmentVisitStepLovs.map(lov => lov.value).indexOf(lovValue(dataObject.step));
	        var showSyncSpz = dataObject.shipments && !!dataObject.shipments.some(function (sh) { return sh.registrationNumber !== dataObject.registrationNumber; }) && !disabled;
	        var showSyncStatus = dataObject.shipments && !!dataObject.shipments.length && [shipmentDomain_1.SHIPMENTVISITSTEP.PREPARED_VISIT, shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_ARRIVED, shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_ENTERED, shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_LEFT].includes((0, formUtils_1.lovValue)(dataObject.step)) && !disabled;
	        return (react_1.default.createElement("form", { style: { marginTop: 10 }, autoComplete: "off" },
	            react_1.default.createElement(blockComp_1.BlockComp, null,
	                react_1.default.createElement(selectSearchDialog_1.default, { ref: this.selectSearchDialogRefHandler, gridLocation: "shipmentSearch", showGridConfig: true, title: "Add Shipments", showOk: true }),
	                react_1.default.createElement(shipmentVisitComps_1.ShipmentVisitStepper, { dataObject: dataObject, entities: entities }),
	                ((0, formUtils_1.lovValue)(dataObject.step) === shipmentDomain_1.SHIPMENTVISITSTEP.PREPARED_VISIT) && (react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "col-xs-12" },
	                        react_1.default.createElement(radioButtonField_1.default, { value: dataObject.$direction, onChange: this.handleDirectionChange, options: shipmentdirectionEntity.lovItems, disabled: disabled, style: { marginTop: 20 }, groupStyle: { display: 'flex', height: 50, justifyContent: "center" }, optionStyle: { width: 'initial', marginRight: 15, fontSize: 25, height: 40 }, labelStyle: { whiteSpace: 'nowrap', marginLeft: -10 }, iconStyleFn: function (v) { return ({ fill: v === shipmentDomain_1.SHIPMENTDIRECTION.OUTGOING ? colors_1.blue500 : colors_1.red500, height: 30, width: 30 }); } })))),
	                ((0, formUtils_1.lovValue)(dataObject.step) !== shipmentDomain_1.SHIPMENTVISITSTEP.PREPARED_VISIT) && (react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-12", style: { justifyContent: "center" } },
	                        react_1.default.createElement("span", { style: { fontSize: 25, color: colors_1.grey500 } },
	                            (0, formUtils_1.lovLabel)(dataObject.$direction),
	                            " ", locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Visit"], ["Visit"]))),
	                            " ")))),
	                dataObject.$direction && (react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-6 col-sm-3" },
	                        react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, registrationNumber.props, { floatingLabelFixed: true, disabled: disabled, floatingLabelStyle: tslib_1.__assign(tslib_1.__assign({}, registrationNumber.props.floatingLabelStyle), { fontSize: 25, top: 25, color: colors_1.grey900 }), autoComplete: "off" })),
	                        react_1.default.createElement(validate_1.Validate, { field: registrationNumber, value: registrationNumber.props.value, onSuccess: this.handleRegistrationNumberSuccess, dataObject: dataObject })),
	                    react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                        !disabled && react_1.default.createElement(FlatButton_1.default, { label: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Find shipments"], ["Find shipments"]))), primary: true, onClick: this.findShipmentsSpz, disabled: !registrationNumber.valid, style: { alignSelf: "flex-end" }, labelStyle: { fontSize: 16 } }),
	                        !disabled && (react_1.default.createElement("div", { style: { display: "flex" } },
	                            react_1.default.createElement(FlatButton_1.default, { label: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Add shipments manually"], ["Add shipments manually"]))), primary: true, onClick: this.addShipments, style: { alignSelf: "flex-end" }, labelStyle: { fontSize: 16 } })))),
	                    !dataObject.$new &&
	                        react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-3" },
	                            react_1.default.createElement(fields_1.MdTextField, tslib_1.__assign({}, driverPhone.props, { floatingLabelFixed: true, floatingLabelStyle: tslib_1.__assign(tslib_1.__assign({}, driverPhone.props.floatingLabelStyle), { fontSize: 25, top: 25, color: colors_1.grey900 }), disabled: disabled, autoComplete: "off" })),
	                            react_1.default.createElement(validate_1.Validate, { field: driverPhone, value: driverPhone.props.value, dataObject: dataObject },
	                                react_1.default.createElement(rules_1.CountryPhoneFormat, { pattern: constant_1.PHONE_PATTERN }),
	                                react_1.default.createElement(rules_1.IsRequired, { condition: [shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_ARRIVED, shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_ENTERED].includes((0, formUtils_1.lovValue)(dataObject.step)) }))))),
	                ((0, formUtils_1.lovValue)(dataObject.$direction) === shipmentDomain_1.SHIPMENTDIRECTION.OUTGOING) && (react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-12" },
	                        react_1.default.createElement(fields_1.MdCheckbox, tslib_1.__assign({}, directionPackaging.props, { onCheck: this.handleDirectionPackaging, disabled: disabled, style: { height: 30, width: 'auto', marginRight: 20, marginTop: 20 }, labelStyle: { whiteSpace: 'nowrap', fontSize: 16, color: colors_1.grey900 } }))),
	                    (dataObject.directionPackaging) && (react_1.default.createElement("div", { className: "fx col-xs-12 col-sm-6" },
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, packagingSender.props, { disabled: disabled, async: true, clearable: true, asterixForAll: true, floatingLabelText: ".", loadOptions: commonDataService_1.optionsSearch.bind(this, (0, formUtils_1.lovValue)('Party'), { role: [partyDomain_1.PARTYROLE.PACKAGING] }) })),
	                        react_1.default.createElement(validate_1.Validate, { field: packagingSender, value: packagingSender.props.value }))))),
	                ((0, formUtils_1.lovValue)(dataObject.$direction) === shipmentDomain_1.SHIPMENTDIRECTION.INCOMING) && (react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-4" },
	                        react_1.default.createElement("div", { style: { width: "100%", marginTop: 5 } },
	                            react_1.default.createElement("span", { style: { fontSize: 18, color: colors_1.grey900, position: "relative", top: 15, zIndex: 2 } }, "Supplier"),
	                            react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, $supplierId.props, { floatingLabelText: ".", disabled: disabled, async: true, clearable: true, asterixForAll: true, floatingLabelStyle: tslib_1.__assign(tslib_1.__assign({}, $supplierId.props.floatingLabelStyle), { fontSize: 1, color: 'white' }), loadOptions: commonDataService_1.optionsSearch.bind(this, "Shipment", { potentialSuppliers: true }) })))),
	                    react_1.default.createElement("div", { className: "fx col-xs-3" }, !disabled && react_1.default.createElement(FlatButton_1.default, { label: locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["Find shipments"], ["Find shipments"]))), primary: true, onClick: this.findShipmentsSupplier, disabled: !$supplierId.props.value, style: { alignSelf: "flex-end" }, labelStyle: { fontSize: 16 } })))),
	                (showSyncSpz || showSyncStatus) &&
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "fx col-xs-12" },
	                            react_1.default.createElement("span", { style: { fontSize: 20, marginTop: 20, color: colors_1.grey400 } }, locales_1.loc.i18n(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["Synchronize data on linked shipments"], ["Synchronize data on linked shipments"])))))),
	                showSyncSpz && (react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-12" },
	                        react_1.default.createElement(fields_1.MdCheckbox, { checked: dataObject.$syncRegistrationNumber, onCheck: this.handleSyncSpz, label: locales_1.loc.i18n(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["Update Registration number"], ["Update Registration number"]))), style: { height: 30, width: 'auto', marginRight: 20, marginTop: 20 }, labelStyle: { whiteSpace: 'nowrap', fontSize: 16, color: colors_1.grey900 } })))),
	                showSyncStatus && (react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-12" },
	                        react_1.default.createElement(fields_1.MdCheckbox, { name: "allReadyCK", checked: (0, formUtils_1.lovValue)(dataObject.$syncShipmentStatus) === shipmentDomain_1.SHIPMENTSTATUS.READY, label: "V\u0161e p\u0159ipraveno", onCheck: this.onCheckAllReady, style: { height: 30, width: 'auto', marginRight: 20, marginTop: 20 }, labelStyle: { whiteSpace: 'nowrap', fontSize: 16, color: colors_1.grey900 } }),
	                        react_1.default.createElement(fields_1.MdCheckbox, { name: "partaillyReadyCK", checked: (0, formUtils_1.lovValue)(dataObject.$syncShipmentStatus) === shipmentDomain_1.SHIPMENTSTATUS.PARTIALLYREADY, label: "\u010C\u00E1ste\u010Dn\u011B p\u0159ipraveno", onCheck: this.onCheckPartiallyReady, style: { height: 30, width: 'auto', marginRight: 20, marginTop: 20 }, labelStyle: { whiteSpace: 'nowrap', fontSize: 16, color: colors_1.grey900 } }),
	                        react_1.default.createElement(fields_1.MdCheckbox, { name: "documentCK", checked: (0, formUtils_1.lovValue)(dataObject.$syncShipmentStatus) === shipmentDomain_1.SHIPMENTSTATUS.DOCUMENT, label: "Dokument", onCheck: this.onCheckDocument, style: { height: 30, width: 'auto', marginRight: 20, marginTop: 20 }, labelStyle: { whiteSpace: 'nowrap', fontSize: 16, color: colors_1.grey900 } })))),
	                showSyncStatus && (react_1.default.createElement("div", { className: "row" },
	                    react_1.default.createElement("div", { className: "fx col-xs-12" },
	                        react_1.default.createElement("span", { style: { alignSelf: "flex-end", marginRight: 10, fontSize: 18 } }, entities.get("Shipment").getField("shippedFromPlace").formLabelActive),
	                        react_1.default.createElement(styledSelect_1.default, tslib_1.__assign({}, createForm_1.fieldStyles.big.styledSelect, { name: "syncShippedFromPlace", value: dataObject.$syncShippedFromPlace, options: this.placeOptions, onChange: this.handleSyncShippedFromPlace, clearable: false }))))),
	                dataObject.$direction && (react_1.default.createElement("div", { style: { marginTop: 20 } },
	                    react_1.default.createElement(gridComp_1.default, { ref: visitNewShipmentGridLocation, grid: dataObject.$shipmentVisitShipmentsGrid, uiLocation: gridComp_1.UILOCATION.main, entities: mdEntityService_1.default.entityMap, rootObject: dataObject, showDelete: true, deleteRowIcon: "fa fa-trash", disableDeleteFn: function (sh) { return disabled; }, editOverrideFn: this.gridDeleteOverrideFn, hideToolbar: true }))),
	                dataObject.$visitsToDelete && !!dataObject.$visitsToDelete.length &&
	                    react_1.default.createElement("div", { className: "row" },
	                        react_1.default.createElement("div", { className: "fx col-xs-12" },
	                            react_1.default.createElement("span", { style: { fontSize: 20, color: colors_1.grey400 } }, "Merged visits to delete"))),
	                dataObject.$visitsToDelete && !!dataObject.$visitsToDelete.length &&
	                    react_1.default.createElement("div", { className: "row", style: { marginBottom: 30 } },
	                        react_1.default.createElement("div", { className: "fx col-xs-12" }, dataObject.$visitsToDelete.map(function (visit) { return (react_1.default.createElement(shipmentVisitDriverForm_1.ShipmentVisitClosedContent, { dataObject: visit, entities: entities, entity: entity, fields: new form_1.default("ShipmentVisitDriverForm", mdEntityService_1.default.getFormDefinition("ShipmentVisitDriverForm")).setupFields(visit, visit, entity, entities, null) })); }))),
	                (dataObject.$direction && (0, formUtils_1.lovValue)(dataObject.step) === shipmentDomain_1.SHIPMENTVISITSTEP.PREPARED_VISIT) && dataObject.$new && !disabled && (react_1.default.createElement("div", { className: "row", style: { marginTop: 10 } },
	                    react_1.default.createElement(buttons_1.SecuredZzRaisedButton, { onClick: this.onSave, label: locales_1.loc.i18n(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["Create prepared visit"], ["Create prepared visit"]))), disabled: !registrationNumber.valid || !dataObject.$dirty, permission: metaConstant_1.PERMISSION.New, secondary: true, style: { height: 60 }, labelStyle: { fontSize: 20 } }))),
	                (!dataObject.$new && (0, formUtils_1.lovValue)(dataObject.step) === shipmentDomain_1.SHIPMENTVISITSTEP.PREPARED_VISIT) && !disabled && (react_1.default.createElement("div", { className: "row", style: { marginTop: 10, display: "flex" } },
	                    react_1.default.createElement(buttons_1.SecuredZzFlatButton, { label: locales_1.loc.i18n(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["Update visit"], ["Update visit"]))), disabled: uiService_1.default.getToolbarActionFlag(), onClick: this.onSave, permission: metaConstant_1.PERMISSION.Update, primary: true, style: { height: 60, width: 200, marginRight: 10 }, labelStyle: { fontSize: 20 } }),
	                    react_1.default.createElement(buttons_1.SecuredZzRaisedButton, { onClick: this.onNextVehicleArrived, label: shipmentVisitStepEntity.getLovItem(shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_ARRIVED).label, disabled: !registrationNumber.valid, securable: metaConstant_1.SECURABLE.shipmentVisitDetail, permission: metaConstant_1.PERMISSION.Update, primary: true, style: { height: 60 }, labelStyle: { fontSize: 20 } }),
	                    react_1.default.createElement(NextTimeComp, { shipmentVisit: dataObject, label: visitTime.props.floatingLabelText }))),
	                (!dataObject.$new && (0, formUtils_1.lovValue)(dataObject.step) === shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_ARRIVED) && !disabled && (react_1.default.createElement("div", { className: "row", style: { marginTop: 10, display: "flex" } },
	                    react_1.default.createElement(buttons_1.SecuredZzFlatButton, { label: locales_1.loc.i18n(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["Update visit"], ["Update visit"]))), disabled: uiService_1.default.getToolbarActionFlag(), onClick: this.onSave, permission: metaConstant_1.PERMISSION.Update, primary: true, style: { height: 60, width: 200, marginRight: 10 }, labelStyle: { fontSize: 20 } }),
	                    react_1.default.createElement(buttons_1.SecuredZzRaisedButton, { onClick: this.onNextVehicleEntered, label: shipmentVisitStepEntity.getLovItem(shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_ENTERED).label, disabled: !registrationNumber.valid, securable: metaConstant_1.SECURABLE.shipmentVisitDetail, permission: metaConstant_1.PERMISSION.Update, primary: true, style: { height: 60 }, labelStyle: { fontSize: 20 } }),
	                    react_1.default.createElement(NextTimeComp, { shipmentVisit: dataObject, label: entranceTime.props.floatingLabelText }),
	                    !disabled && react_1.default.createElement(fields_1.MdCheckbox, { checked: dataObject.$showSmsToDriver, onCheck: this.handleShowSmsToDriver, label: locales_1.loc.i18n(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["Send SMS to driver"], ["Send SMS to driver"]))), style: { width: 'auto', marginLeft: 20, marginRight: 20, alignSelf: "flex-end" }, labelStyle: { whiteSpace: 'nowrap', fontSize: 16, color: colors_1.grey900, marginLeft: -10 } }),
	                    !disabled && dataObject.$showSmsToDriver &&
	                        react_1.default.createElement(fields_1.MdTextField, { floatingLabelFixed: true, value: dataObject.getTuple("SHIPMENT_GATE_ARRIVAL_TO_DRIVER_SMS_TEXT"), onChange: this.handleSmsToDriverText, autoComplete: "off", style: { alignSelf: "flex-end", flexGrow: 1 } }))),
	                (!dataObject.$new && (0, formUtils_1.lovValue)(dataObject.step) === shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_ENTERED) && !disabled && (react_1.default.createElement("div", { className: "row", style: { marginTop: 10, display: "flex" } },
	                    react_1.default.createElement(buttons_1.SecuredZzFlatButton, { label: locales_1.loc.i18n(templateObject_11 || (templateObject_11 = tslib_1.__makeTemplateObject(["Update visit"], ["Update visit"]))), disabled: uiService_1.default.getToolbarActionFlag(), onClick: this.onSave, permission: metaConstant_1.PERMISSION.Update, primary: true, style: { height: 60, width: 200, marginRight: 10 }, labelStyle: { fontSize: 20 } }),
	                    react_1.default.createElement(buttons_1.SecuredZzRaisedButton, { onClick: this.onNextVehicleLeft, label: shipmentVisitStepEntity.getLovItem(shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_LEFT).label, disabled: !registrationNumber.valid, securable: metaConstant_1.SECURABLE.shipmentVisitDetail, permission: metaConstant_1.PERMISSION.Update, primary: true, style: { height: 60 }, labelStyle: { fontSize: 20 } }),
	                    react_1.default.createElement(NextTimeComp, { shipmentVisit: dataObject, label: visitEnd.props.floatingLabelText }))))));
	    };
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentVisitPrepareForm.prototype, "placeOptions", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitPrepareForm.prototype, "setPlus", null);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitPrepareForm.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitPrepareForm.prototype, "onNextVehicleArrived", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitPrepareForm.prototype, "onNextVehicleEntered", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitPrepareForm.prototype, "onNextVehicleLeft", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitPrepareForm.prototype, "handleDirectionChange", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitPrepareForm.prototype, "findShipmentsSpz", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitPrepareForm.prototype, "findShipmentsSupplier", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitPrepareForm.prototype, "handleDirectionPackaging", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitPrepareForm.prototype, "handleSyncSpz", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitPrepareForm.prototype, "handleRegistrationNumberSuccess", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitPrepareForm.prototype, "handleSyncShippedFromPlace", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitPrepareForm.prototype, "onCheckAllReady", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitPrepareForm.prototype, "onCheckPartiallyReady", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitPrepareForm.prototype, "onCheckDocument", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitPrepareForm.prototype, "handleShowSmsToDriver", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitPrepareForm.prototype, "handleSmsToDriverText", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitPrepareForm.prototype, "addShipments", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitPrepareForm.prototype, "gridDeleteOverrideFn", void 0);
	    ShipmentVisitPrepareForm = tslib_1.__decorate([
	        (0, createForm_1.createForm)({
	            formName: 'ShipmentVisitPrepareForm',
	            fields: [
	                {
	                    name: 'registrationNumber',
	                    validators: ['IsRequired'],
	                    size: form_1.FIELDDEFSIZE.big
	                }, {
	                    name: 'driverPhone',
	                    size: form_1.FIELDDEFSIZE.big
	                }, {
	                    name: 'visitTime'
	                }, {
	                    name: 'visitEnd'
	                }, {
	                    name: "directionPackaging"
	                }, {
	                    name: "$supplierId",
	                    mdField: new mdField_1.default({ valueSourceType: mdField_1.VALUESOURCETYPE.ASYNC }),
	                    size: form_1.FIELDDEFSIZE.big
	                }, {
	                    name: "packagingSender",
	                    size: form_1.FIELDDEFSIZE.big
	                }, {
	                    name: "entranceTime"
	                }
	            ]
	        }, undefined),
	        mobx_react_1.observer
	    ], ShipmentVisitPrepareForm);
	    return ShipmentVisitPrepareForm;
	}(react_1.default.Component));
	exports.default = ShipmentVisitPrepareForm;
	var NextTimeComp = /** @class */ (function (_super) {
	    tslib_1.__extends(NextTimeComp, _super);
	    function NextTimeComp() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleNextTime = function (newTime) {
	            var shipmentVisit = _this.props.shipmentVisit;
	            shipmentVisit.$nextTime = newTime;
	            console.log("handleNextTime %s", shipmentVisit.$nextTime);
	        };
	        _this.handleEdit = function () {
	            var shipmentVisit = _this.props.shipmentVisit;
	            shipmentVisit.$nextTime = new Date().toISOString();
	            ;
	            console.log("handleEdit %s", shipmentVisit.$nextTime);
	        };
	        _this.handleClear = function () {
	            var shipmentVisit = _this.props.shipmentVisit;
	            shipmentVisit.$nextTime = undefined;
	            console.log("handleClear %s", shipmentVisit.$nextTime);
	        };
	        return _this;
	    }
	    NextTimeComp.prototype.render = function () {
	        var _a = this.props, shipmentVisit = _a.shipmentVisit, label = _a.label;
	        console.debug("NextTimeComp $nextTime = %s", shipmentVisit.$nextTime);
	        return (react_1.default.createElement("div", { style: { marginLeft: 20, display: "flex" } },
	            react_1.default.createElement("span", { style: { alignSelf: "flex-end", marginRight: 10, fontSize: 18 } },
	                label,
	                ":"),
	            !shipmentVisit.$nextTime && (react_1.default.createElement("div", { style: { paddingLeft: 10, marginRight: 5, alignSelf: "flex-end", display: "flex", backgroundColor: colors_1.blueGrey100, borderRadius: 4, overflow: "hidden" } },
	                react_1.default.createElement("span", { style: { alignSelf: "flex-end", marginRight: 5, fontSize: 18 } }, locales_1.loc.i18n(templateObject_12 || (templateObject_12 = tslib_1.__makeTemplateObject(["Current time"], ["Current time"])))),
	                react_1.default.createElement(SvgEdit, { style: { alignSelf: "flex-end", fontSize: 18 }, className: "active-item--check", onClick: this.handleEdit }))),
	            shipmentVisit.$nextTime && react_1.default.createElement(styledDatePicker_1.default, { value: shipmentVisit.$nextTime, onChange: this.handleNextTime, time: true }),
	            shipmentVisit.$nextTime && react_1.default.createElement(SvgClear, { style: { alignSelf: "flex-end", fontSize: 18 }, className: "active-item--check", onClick: this.handleClear })));
	    };
	    tslib_1.__decorate([
	        mobx_1.action
	    ], NextTimeComp.prototype, "handleNextTime", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], NextTimeComp.prototype, "handleEdit", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], NextTimeComp.prototype, "handleClear", void 0);
	    NextTimeComp = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], NextTimeComp);
	    return NextTimeComp;
	}(react_1.default.Component));
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;


/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var buttons_1 = __webpack_require__(27);
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var errorComp_1 = __webpack_require__(34);
	var formUtils_1 = __webpack_require__(14);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var metaConstant_1 = __webpack_require__(13);
	__webpack_require__(203);
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var shipmentDomain_1 = __webpack_require__(132);
	var shipmentService_1 = tslib_1.__importDefault(__webpack_require__(176));
	var shipmentOutgoingForm_1 = tslib_1.__importDefault(__webpack_require__(2244));
	var locales_1 = __webpack_require__(15);
	var shipmentIncomingForm_1 = tslib_1.__importDefault(__webpack_require__(2243));
	var gridUtils_1 = __webpack_require__(83);
	var gridDocument_1 = __webpack_require__(313);
	var gridDocumentComp_1 = tslib_1.__importDefault(__webpack_require__(312));
	var shipmentGridDocument = 'shipmentGridDocument';
	var ShipmentDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentDetail, _super);
	    function ShipmentDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.customValidate = function (shipmentObject) {
	            var errors = [];
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave shipmentId = %s, $new = %s', shipmentService_1.default.shipmentObject.shipmentId, shipmentService_1.default.shipmentObject.$new);
	            uiService_1.default.showToolbarActionFlag();
	            var result = (0, formUtils_1.preSave)(shipmentService_1.default.shipmentObject, _this.customValidate, true);
	            if (!result) {
	                return;
	            }
	            if (shipmentService_1.default.shipmentObject.$shipmentVisit && !shipmentService_1.default.shipmentObject.$shipmentVisit.shipmentVisitId) {
	                shipmentService_1.default.shipmentObject.setTuple("shipmentVisit", shipmentService_1.default.shipmentObject.$shipmentVisit);
	            }
	            var wasNew;
	            shipmentService_1.default.saveShipment(shipmentService_1.default.shipmentObject)
	                .then((0, mobx_1.action)("saveShipment-action", function (shipmentJson) {
	                wasNew = shipmentService_1.default.shipmentObject.cleanAfterSave(shipmentJson, true, "$shipmentVisit");
	                return _this.docSavingPromise(shipmentService_1.default.shipmentObject.$movingBlocks.getBlock(shipmentGridDocument), { shipmentId: shipmentService_1.default.shipmentObject.shipmentId });
	            })).then(function (x) {
	                if (wasNew) {
	                    _this.context.router.replaceWith('shipmentDetail', { id: shipmentService_1.default.shipmentObject.shipmentId });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            }).catch(function (error) {
	                console.log("Error %O", error);
	                shipmentService_1.default.shipmentObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            _this.context.router.transitionTo("shipmentDetail", { id: 'new' }, { shipmentDirection: shipmentService_1.default.shipmentObject.shipmentDirection });
	        };
	        _this.onCopy = function (evt) {
	            console.log('onCopy');
	            _this.context.router.transitionTo("shipmentDetail", { id: 'copy' }, { copyId: shipmentService_1.default.shipmentObject.shipmentId });
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            shipmentService_1.default.deleteShipment(shipmentService_1.default.shipmentObject.shipmentId)
	                .then(function (response) {
	                _this.goBackOrHome();
	            }, function (error) {
	                shipmentService_1.default.shipmentObject.$errors = error.getMessages();
	            });
	        };
	        _this.createShipmentVisit = function (evt) {
	            console.log('createShipmentVisit');
	            var params = {
	                shipmentId: shipmentService_1.default.shipmentObject.shipmentId,
	            };
	            _this.context.router.transitionTo("shipmentVisitDetail", { id: 'new' }, params);
	        };
	        return _this;
	    }
	    ShipmentDetail.fetchData = function (routerParams, query) {
	        console.log("ShipmentDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['Shipment', 'ShipmentVisit'], [{ entity: 'SHIPMENTSTATUS', lov: true }, 'Document']);
	        var shipmentPromise;
	        if (routerParams.id === 'new') {
	            var shippedTo = (query.partyId) ? { value: query.partyId, label: query.partyLabel } : null;
	            var shipmentDirection = query.shipmentDirection;
	            var today = (0, moment_1.default)().startOf('day');
	            shipmentPromise = Promise.resolve(new shipmentDomain_1.Shipment({
	                $new: true,
	                shipmentDate: today,
	                shippedTo: shippedTo,
	                shipmentDirection: shipmentDirection,
	                visitOrder: 1
	            }));
	        }
	        else if (routerParams.id === 'copy') {
	            shipmentPromise = shipmentService_1.default.readShipment(query.copyId, { mode: 'copy' })
	                .then(function (shipmentObject) {
	                shipmentObject.cleanOnCopy();
	                shipmentObject.shipmentId = undefined;
	                shipmentObject.shipmentVisit = undefined;
	                shipmentObject.visitOrder = 1;
	                return shipmentService_1.default.computeField("disponentParty", {
	                    shippedToAddress: (0, formUtils_1.lovValue)(shipmentObject.shippedToAddress)
	                })
	                    .then((0, mobx_1.action)("computeDisponent", function (v) {
	                    shipmentObject.disponentParty = v;
	                    return shipmentObject;
	                }));
	            });
	        }
	        else {
	            shipmentPromise = shipmentService_1.default.readShipment(routerParams.id);
	        }
	        return Promise.all([metadataPromise, shipmentPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], shipmentObject = _a[1];
	            shipmentObject.$new = !shipmentObject.shipmentId;
	            if (!shipmentObject.shipmentStatus)
	                shipmentObject.shipmentStatus = entityMap.get("SHIPMENTSTATUS").getLovItem(shipmentDomain_1.SHIPMENTSTATUS.NOTREADY);
	            shipmentObject.$movingBlocks = new gridUtils_1.MovingBlocks(null, false, null, new gridDocument_1.GridDocument(shipmentGridDocument, "Docs", { shipmentId: shipmentObject.shipmentId }, false, null, (shipmentObject.$new) ? [] : null));
	            shipmentService_1.default.shipmentObject = shipmentObject.initAfterRead(routerParams.id === 'new');
	            return (shipmentObject.shipmentVisit) ? shipmentService_1.default.readShipmentVisit((0, formUtils_1.lovValue)(shipmentObject.shipmentVisit)) : Promise.resolve(null);
	        }).then(function (shipmentVisit) {
	            shipmentService_1.default.shipmentObject.$shipmentVisit = shipmentVisit;
	        });
	    };
	    ShipmentDetail.prototype.componentDidUpdate = function (prevProps) {
	        if (this.idChanged(prevProps.params.id, this.props.params.id)) {
	            shipmentService_1.default.shipmentObject.$movingBlocks.searchExposedGrids(shipmentService_1.default.shipmentObject);
	        }
	    };
	    ShipmentDetail.prototype.componentDidMount = function () {
	        console.debug("%c componentDidMount", "background-color: magenta");
	        shipmentService_1.default.shipmentObject.$movingBlocks.searchExposedGrids(shipmentService_1.default.shipmentObject);
	    };
	    ShipmentDetail.prototype.componentWillUnmount = function () {
	        shipmentService_1.default.shipmentObject = null;
	    };
	    ShipmentDetail.prototype.findRootObject = function () {
	        return shipmentService_1.default.shipmentObject;
	    };
	    ShipmentDetail.prototype.render = function () {
	        var query = this.props.query;
	        var shipmentObject = shipmentService_1.default.shipmentObject;
	        var shipmentEntity = mdEntityService_1.default.getEntity('Shipment');
	        var propsForCreateForm = {
	            dataObject: shipmentObject,
	            rootObject: shipmentObject,
	            entity: shipmentEntity,
	            entities: mdEntityService_1.default.entityMap
	        };
	        console.log('shipmentDetail render shipmentId = %s, $new = %s', shipmentObject.shipmentId, shipmentObject.$new);
	        var movingBlocks = shipmentService_1.default.shipmentObject.$movingBlocks;
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	            this._createToolMenu(shipmentObject, query.gridLocation),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: shipmentObject.$errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	            (shipmentObject.shipmentDirection === shipmentDomain_1.SHIPMENTDIRECTION.OUTGOING) ? react_1.default.createElement(shipmentOutgoingForm_1.default, tslib_1.__assign({}, propsForCreateForm)) : react_1.default.createElement(shipmentIncomingForm_1.default, tslib_1.__assign({}, propsForCreateForm)),
	            react_1.default.createElement(gridDocumentComp_1.default, { uiLocation: movingBlocks.getUiLocation(shipmentGridDocument), grid: movingBlocks.getBlock(shipmentGridDocument), entities: mdEntityService_1.default.entityMap, rootObject: shipmentService_1.default.shipmentObject })));
	    };
	    ShipmentDetail.prototype._createToolMenu = function (shipmentObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: History.length <= 1, historize: true, entityName: "Shipment", entityId: shipmentObject.shipmentId },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !shipmentObject.$dirty, label: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Save"], ["Save"]))), permission: shipmentObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, disabled: shipmentObject.$new, label: locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["New"], ["New"]))), permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onCopy, disabled: shipmentObject.$new, label: locales_1.loc.i18n(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["Copy"], ["Copy"]))), permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "Shipment", pageAncestor: this, onClick: this.onDelete, disabled: shipmentObject.$new, label: locales_1.loc.i18n(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["Delete"], ["Delete"]))), permission: metaConstant_1.PERMISSION.Delete }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.createShipmentVisit, disabled: shipmentObject.$new || shipmentObject.shipmentVisit, label: locales_1.loc.i18n(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["Create shipment visit"], ["Create shipment visit"]))), securable: metaConstant_1.SECURABLE.shipmentVisitDetail, permission: metaConstant_1.PERMISSION.New })));
	    };
	    ShipmentDetail.module = metaConstant_1.MODULE.shipment;
	    ShipmentDetail.title = locales_1.loc.i18n(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["Shipment"], ["Shipment"])));
	    ShipmentDetail.icon = 'fighter-jet';
	    ShipmentDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentDetail.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentDetail.prototype, "createShipmentVisit", void 0);
	    ShipmentDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ShipmentDetail);
	    return ShipmentDetail;
	}(pageAncestor_1.default));
	exports.default = ShipmentDetail;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;


/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var routes_1 = __webpack_require__(75);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var gridComp_1 = __webpack_require__(44);
	var shipmentDomain_1 = __webpack_require__(132);
	var gridLocation = 'shipmentIncomingList';
	var ShipmentIncomingList = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentIncomingList, _super);
	    function ShipmentIncomingList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.newShipmentVisit = function (grid) {
	            var gridParams = grid.createFullParams();
	            gridParams.includeRowObject = true;
	            _this.context.router.transitionTo("shipmentVisitDetail", { id: 'new' }, gridParams);
	        };
	        return _this;
	    }
	    ShipmentIncomingList.fetchData = function (routerParams) {
	        console.log("ShipmentIncomingList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    ShipmentIncomingList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        var bulkActions = [
	            { type: gridComp_1.BULKACTIONTYPE.ACTION, label: 'Create Shipment visit', fn: this.newShipmentVisit, that: this, securable: metaConstant_1.SECURABLE.shipmentVisitDetail }
	        ];
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query, bulkActions: bulkActions, multiUpdateSecurable: metaConstant_1.SECURABLE.shipmentGridUpdate },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "shipmentDetail", params: { id: 'new' }, query: { shipmentDirection: shipmentDomain_1.SHIPMENTDIRECTION.INCOMING }, label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["New In Shipment"], ["New In Shipment"]))), permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.shipmentDetail })));
	    };
	    ShipmentIncomingList.module = metaConstant_1.MODULE.shipment;
	    ShipmentIncomingList.title = locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Incoming Shipments"], ["Incoming Shipments"])));
	    ShipmentIncomingList.icon = 'fighter-jet';
	    ShipmentIncomingList.rootPage = true;
	    ShipmentIncomingList.protectedPage = true;
	    ShipmentIncomingList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ShipmentIncomingList);
	    return ShipmentIncomingList;
	}(pageAncestor_1.default));
	exports.default = ShipmentIncomingList;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var routes_1 = __webpack_require__(75);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var gridComp_1 = __webpack_require__(44);
	var shipmentDomain_1 = __webpack_require__(132);
	var gridLocation = 'shipmentOutgoingList';
	var ShipmentOutgoingList = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentOutgoingList, _super);
	    function ShipmentOutgoingList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.newShipmentVisit = function (grid) {
	            var gridParams = grid.createFullParams();
	            gridParams.includeRowObject = true;
	            _this.context.router.transitionTo("shipmentVisitDetail", { id: 'new' }, gridParams);
	        };
	        return _this;
	    }
	    ShipmentOutgoingList.fetchData = function (routerParams) {
	        console.log("ShipmentOutgoingList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    ShipmentOutgoingList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        var bulkActions = [
	            { type: gridComp_1.BULKACTIONTYPE.ACTION, label: 'Create Shipment visit', fn: this.newShipmentVisit, that: this, securable: metaConstant_1.SECURABLE.shipmentVisitDetail }
	        ];
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query, bulkActions: bulkActions, multiUpdateSecurable: metaConstant_1.SECURABLE.shipmentGridUpdate },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "shipmentDetail", params: { id: 'new' }, query: { shipmentDirection: shipmentDomain_1.SHIPMENTDIRECTION.OUTGOING }, label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["New Out Shipment"], ["New Out Shipment"]))), permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.shipmentDetail })));
	    };
	    ShipmentOutgoingList.module = metaConstant_1.MODULE.shipment;
	    ShipmentOutgoingList.title = locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Outgoing Shipments"], ["Outgoing Shipments"])));
	    ShipmentOutgoingList.icon = 'fighter-jet';
	    ShipmentOutgoingList.rootPage = true;
	    ShipmentOutgoingList.protectedPage = true;
	    ShipmentOutgoingList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ShipmentOutgoingList);
	    return ShipmentOutgoingList;
	}(pageAncestor_1.default));
	exports.default = ShipmentOutgoingList;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var buttons_1 = __webpack_require__(27);
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var errorComp_1 = __webpack_require__(34);
	var formUtils_1 = __webpack_require__(14);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var metaConstant_1 = __webpack_require__(13);
	__webpack_require__(203);
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var shipmentDomain_1 = __webpack_require__(132);
	var shipmentService_1 = tslib_1.__importDefault(__webpack_require__(176));
	var shipmentRepackagingForm_1 = tslib_1.__importDefault(__webpack_require__(2245));
	var locales_1 = __webpack_require__(15);
	var ShipmentRepackagingDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentRepackagingDetail, _super);
	    function ShipmentRepackagingDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.customValidate = function (shipmentRepackagingObject) {
	            var errors = [];
	            return errors;
	        };
	        _this.onSave = function (evt) {
	            console.log('onSave shipmentRepackagingId = %s, $new = %s', shipmentService_1.default.shipmentRepackagingObject.shipmentRepackagingId, shipmentService_1.default.shipmentRepackagingObject.$new);
	            uiService_1.default.showToolbarActionFlag();
	            var result = (0, formUtils_1.preSave)(shipmentService_1.default.shipmentRepackagingObject, _this.customValidate, true);
	            if (!result) {
	                return;
	            }
	            shipmentService_1.default.saveShipmentRepackaging(shipmentService_1.default.shipmentRepackagingObject)
	                .then((0, mobx_1.action)("saveShipmentRepackaging-action", function (shipmentRepackagingJson) {
	                var wasNew = shipmentService_1.default.shipmentRepackagingObject.cleanAfterSave(shipmentRepackagingJson);
	                if (wasNew) {
	                    _this.context.router.replaceWith('shipmentRepackagingDetail', { id: shipmentService_1.default.shipmentRepackagingObject.shipmentRepackagingId });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	            }), function (error) {
	                shipmentService_1.default.shipmentRepackagingObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            var query = {};
	            _this.context.router.transitionTo("shipmentRepackagingDetail", { id: 'new' }, query);
	        };
	        _this.onCopy = function (evt) {
	            console.log('onCopy');
	            _this.context.router.transitionTo("shipmentRepackagingDetail", { id: 'copy' }, { copyId: shipmentService_1.default.shipmentRepackagingObject.shipmentRepackagingId });
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            shipmentService_1.default.deleteShipmentRepackaging(shipmentService_1.default.shipmentRepackagingObject.shipmentRepackagingId)
	                .then(function (response) {
	                _this.goBackOrHome();
	            }, function (error) {
	                shipmentService_1.default.shipmentRepackagingObject.$errors = error.getMessages();
	            });
	        };
	        return _this;
	    }
	    ShipmentRepackagingDetail.fetchData = function (routerParams, query) {
	        console.log("ShipmentRepackagingDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['ShipmentRepackaging'], [{ entity: 'SHIPMENTREPACKAGINGSTATUS', lov: true }]);
	        var shipmentRepackagingPromise;
	        if (routerParams.id === 'new') {
	            var shippedTo = (query.partyId) ? { value: query.partyId, label: query.partyLabel } : null;
	            shipmentRepackagingPromise = Promise.resolve(new shipmentDomain_1.ShipmentRepackaging({
	                $new: true,
	                shipmentDate: (0, moment_1.default)().startOf('day'),
	                shipmentTime: (0, moment_1.default)().format("HH:mm"),
	                shippedTo: shippedTo
	            }));
	        }
	        else if (routerParams.id === 'copy') {
	            shipmentRepackagingPromise = shipmentService_1.default.readShipmentRepackaging(query.copyId, { mode: 'copy' })
	                .then(function (shipmentRepackagingObject) {
	                shipmentRepackagingObject.cleanOnCopy();
	                shipmentRepackagingObject.shipmentRepackagingId = undefined;
	                return shipmentRepackagingObject;
	            });
	        }
	        else {
	            shipmentRepackagingPromise = shipmentService_1.default.readShipmentRepackaging(routerParams.id);
	        }
	        return Promise.all([metadataPromise, shipmentRepackagingPromise])
	            .then(function (_a) {
	            var entityMap = _a[0], shipmentRepackagingObject = _a[1];
	            shipmentRepackagingObject.$new = !shipmentRepackagingObject.shipmentRepackagingId;
	            if (!shipmentRepackagingObject.repackagingStatus)
	                shipmentRepackagingObject.repackagingStatus = entityMap.get("SHIPMENTREPACKAGINGSTATUS").getLovItem(shipmentDomain_1.SHIPMENTREPACKAGINGSTATUS.REPACKAGE);
	            shipmentService_1.default.shipmentRepackagingObject = shipmentRepackagingObject.initAfterRead(routerParams.id === 'new');
	        });
	    };
	    ShipmentRepackagingDetail.prototype.componentWillUnmount = function () {
	        shipmentService_1.default.shipmentRepackagingObject = null;
	    };
	    ShipmentRepackagingDetail.prototype.findRootObject = function () {
	        return shipmentService_1.default.shipmentRepackagingObject;
	    };
	    ShipmentRepackagingDetail.prototype.render = function () {
	        var query = this.props.query;
	        var shipmentRepackagingObject = shipmentService_1.default.shipmentRepackagingObject;
	        var shipmentRepackagingEntity = mdEntityService_1.default.getEntity('ShipmentRepackaging');
	        var propsForCreateForm = {
	            dataObject: shipmentRepackagingObject,
	            rootObject: shipmentRepackagingObject,
	            entity: shipmentRepackagingEntity,
	            entities: mdEntityService_1.default.entityMap
	        };
	        console.log('shipmentRepackagingDetail render shipmentRepackagingId = %s, $new = %s', shipmentRepackagingObject.shipmentRepackagingId, shipmentRepackagingObject.$new);
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	            this._createToolMenu(shipmentRepackagingObject, query.gridLocation),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: shipmentRepackagingObject.$errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	            react_1.default.createElement(shipmentRepackagingForm_1.default, tslib_1.__assign({}, propsForCreateForm))));
	    };
	    ShipmentRepackagingDetail.prototype._createToolMenu = function (shipmentRepackagingObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: History.length <= 1, historize: true, entityName: "ShipmentRepackaging", entityId: shipmentRepackagingObject.shipmentRepackagingId },
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onSave, disabled: !shipmentRepackagingObject.$dirty, label: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Save"], ["Save"]))), permission: shipmentRepackagingObject.$new ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onAdd, disabled: shipmentRepackagingObject.$new, label: locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["New"], ["New"]))), permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onCopy, disabled: shipmentRepackagingObject.$new, label: locales_1.loc.i18n(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["Copy"], ["Copy"]))), permission: metaConstant_1.PERMISSION.New }),
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "ShipmentRepackaging", pageAncestor: this, onClick: this.onDelete, disabled: shipmentRepackagingObject.$new, label: locales_1.loc.i18n(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["Delete"], ["Delete"]))), permission: metaConstant_1.PERMISSION.Delete })));
	    };
	    ShipmentRepackagingDetail.module = metaConstant_1.MODULE.shipment;
	    ShipmentRepackagingDetail.title = locales_1.loc.i18n(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["Repackaging"], ["Repackaging"])));
	    ShipmentRepackagingDetail.icon = 'suitcase';
	    ShipmentRepackagingDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentRepackagingDetail.prototype, "onSave", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentRepackagingDetail.prototype, "onDelete", void 0);
	    ShipmentRepackagingDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ShipmentRepackagingDetail);
	    return ShipmentRepackagingDetail;
	}(pageAncestor_1.default));
	exports.default = ShipmentRepackagingDetail;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;


/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var DatePicker_1 = tslib_1.__importDefault(__webpack_require__(746));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var buttons_1 = __webpack_require__(27);
	var metaConstant_1 = __webpack_require__(13);
	var routes_1 = __webpack_require__(75);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var mobx_1 = __webpack_require__(5);
	var dateUtils_1 = __webpack_require__(49);
	__webpack_require__(668);
	var shipmentService_1 = tslib_1.__importDefault(__webpack_require__(176));
	var shipmentRepackagingResourceDialog_1 = __webpack_require__(2246);
	var colors_1 = __webpack_require__(29);
	var moment_1 = tslib_1.__importDefault(__webpack_require__(39));
	var shipmentRepackagingUpdateDialog_1 = __webpack_require__(2247);
	var gridComp_1 = __webpack_require__(44);
	var gridLocation = 'shipmentRepackagingList';
	var ShipmentRepackagingList = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentRepackagingList, _super);
	    function ShipmentRepackagingList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.shipmentRepackagingResourceDialogRefHandler = function (comp) { return _this.shipmentRepackagingResourceDialogRef = comp; };
	        _this.shipmentRepackagingUpdateDialogRefHandler = function (comp) { return _this.shipmentRepackagingUpdateDialogRef = comp; };
	        _this.toolbarDate = (0, dateUtils_1.stripTime)(new Date());
	        _this.advanceShipmentRepackagings = function (grid) {
	            new Promise(function (resolve, reject) {
	                _this.shipmentRepackagingUpdateDialogRef.open(resolve, reject, grid);
	            }).then(function (res) {
	                return Promise.all([grid.search(null), shipmentService_1.default.readShipmentRepackagingResource(_this.toolbarDate, { fillStatistics: true })]);
	            }).then(function (_a) {
	                var x = _a[0], srr = _a[1];
	                _this.resource = srr;
	            }).catch(function (error) {
	                console.log('rejecting ShipmentRepackagingUpdateDialog with ', error);
	            });
	        };
	        _this.onToolbarDateChange = function (event, date) {
	            _this.toolbarDate = date;
	            return shipmentService_1.default.readShipmentRepackagingResource(_this.toolbarDate, { fillStatistics: true })
	                .then(function (srr) {
	                _this.resource = srr;
	            });
	        };
	        _this.onSetNorm = function (e) {
	            console.log('onSetNorm');
	            new Promise(function (resolve, reject) {
	                _this.shipmentRepackagingResourceDialogRef.open(resolve, reject, _this.toolbarDate, _this.resource);
	            }).then(function (res) {
	                return shipmentService_1.default.readShipmentRepackagingResource(_this.toolbarDate, { fillStatistics: true })
	                    .then(function (srr) {
	                    _this.resource = srr;
	                });
	            })
	                .catch(function (error) {
	                console.log('rejecting shipmentRepackagingResourceDialog with ', error);
	                return shipmentService_1.default.readShipmentRepackagingResource(_this.toolbarDate, { fillStatistics: true })
	                    .then(function (srr) {
	                    _this.resource = srr;
	                });
	            });
	        };
	        return _this;
	    }
	    ShipmentRepackagingList.fetchData = function (routerParams) {
	        console.log("ShipmentRepackagingList#fetchData(%s)", gridLocation);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['ShipmentRepackagingResource']);
	        var gridPromise = gridService_1.default.fetchGrids(gridLocation);
	        return Promise.all([metadataPromise, gridPromise])
	            .then(function (_a) {
	            var mdEntityMap = _a[0], gridLocationMap = _a[1];
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    ShipmentRepackagingList.prototype.componentDidMount = function () {
	        var _this = this;
	        return shipmentService_1.default.readShipmentRepackagingResource(this.toolbarDate, { fillStatistics: true })
	            .then(function (srr) {
	            _this.resource = srr;
	        });
	    };
	    ShipmentRepackagingList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        var normLabel = (this.resource && this.resource.availableResources != null) ? ("Norma: " + this.resource.availableResources + " lidí * " + this.resource.dailyPalleteNorm + " palet = " + this.resource.getDailyNorm()) : "Nastavte normu";
	        var normaCss = "";
	        if (this.resource && this.resource.availableResources != null) {
	            if (this.resource.completedThisDay >= this.resource.toRepackThisDay && this.resource.completedThisDay >= this.resource.getDailyNorm()) {
	                // IF COMPLETED THIS DAY >= TO REPACK THIS DAY AND COMPLETED THIS DAY >= DAILY NORM - tak je zelená
	                normaCss = "repackaging-norma-green repackaging-norma";
	            }
	            else if (this.resource.toRepackThisDay > this.resource.getDailyNorm() && this.resource.toRepackThisDay >= this.resource.completedThisDay) {
	                // IF TO REPACK THIS DAY > DAILY NORM AND TO REPACK THIS DAY > COMPLETED THIS DAY (neboli že bude potřeba přesčas), tak oranžovou
	                normaCss = "repackaging-norma-orange repackaging-norma";
	            }
	            else if (this.resource.toRepackThisDay >= this.resource.completedThisDay || this.resource.getDailyNorm() >= this.resource.completedThisDay) {
	                // IF TO REPACK THIS DAY > COMPLETED THIS DAY OR DAILY NORM > COMPLETED THIS DAY, je červená
	                normaCss = "repackaging-norma-red repackaging-norma";
	            }
	            if ((0, moment_1.default)(this.resource.workDate).isBefore((0, dateUtils_1.stripTime)(new Date()))) {
	                normaCss += " repackaging-norma-past";
	            }
	        }
	        var bulkActions = [
	            { type: gridComp_1.BULKACTIONTYPE.ACTION, label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Advance Repackagings"], ["Advance Repackagings"]))), fn: this.advanceShipmentRepackagings, that: this, securable: metaConstant_1.SECURABLE.shipmentRepackagingAdvance }
	        ];
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query, bulkActions: bulkActions, multiUpdateSecurable: metaConstant_1.SECURABLE.shipmentRepackagingGridUpdate },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "shipmentRepackagingDetail", params: { id: 'new' }, label: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["New Repackaging"], ["New Repackaging"]))), permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.shipmentRepackagingDetail }),
	            (this.resource) ? (react_1.default.createElement("div", { className: "repackaging-info-box" },
	                react_1.default.createElement("div", { style: { display: 'flex' }, className: normaCss },
	                    react_1.default.createElement(DatePicker_1.default, { name: "toolbarDate", container: "inline", mode: "landscape", autoOk: true, DateTimeFormat: global.Intl.DateTimeFormat, locale: locales_1.loc.lang, value: this.toolbarDate, onChange: this.onToolbarDateChange, style: { width: 90, marginLeft: 10 }, inputStyle: (normaCss) ? { color: colors_1.grey100 } : {}, textFieldStyle: { height: 40, fontSize: 14, cursor: 'pointer', width: 90 } }),
	                    react_1.default.createElement("div", { style: { lineHeight: "40px", marginRight: 10 }, title: "Dnes hotovo / Dne\u0161n\u00ED pl\u00E1n k p\u0159ebalu" }, this.resource.completedThisDay + " / " + this.resource.toRepackThisDay),
	                    react_1.default.createElement(buttons_1.SecuredZzFlatButton, { name: "setNorm", label: normLabel, permission: metaConstant_1.PERMISSION.Execute, style: (normaCss) ? { color: colors_1.grey100 } : {}, securable: metaConstant_1.SECURABLE.shipmentRepackagingSetResource, onClick: this.onSetNorm })))) : null,
	            react_1.default.createElement(shipmentRepackagingResourceDialog_1.ShipmentRepackagingResourceDialog, { ref: this.shipmentRepackagingResourceDialogRefHandler, entities: mdEntityService_1.default.entityMap }),
	            react_1.default.createElement(shipmentRepackagingUpdateDialog_1.ShipmentRepackagingUpdateDialog, { ref: this.shipmentRepackagingUpdateDialogRefHandler, entities: mdEntityService_1.default.entityMap })));
	    };
	    ShipmentRepackagingList.module = metaConstant_1.MODULE.shipment;
	    ShipmentRepackagingList.title = locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["Repackagings"], ["Repackagings"])));
	    ShipmentRepackagingList.icon = 'suitcase';
	    ShipmentRepackagingList.rootPage = true;
	    ShipmentRepackagingList.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackagingList.prototype, "resource", void 0);
	    tslib_1.__decorate([
	        mobx_1.observable
	    ], ShipmentRepackagingList.prototype, "toolbarDate", void 0);
	    ShipmentRepackagingList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ShipmentRepackagingList);
	    return ShipmentRepackagingList;
	}(pageAncestor_1.default));
	exports.default = ShipmentRepackagingList;
	var templateObject_1, templateObject_2, templateObject_3;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	var gridLocation = 'shipmentReport';
	var ShipmentReport = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentReport, _super);
	    function ShipmentReport() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ShipmentReport.fetchData = function (routerParams) {
	        console.log("ShipmentReport#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    ShipmentReport.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query }));
	    };
	    ShipmentReport.module = metaConstant_1.MODULE.shipment;
	    ShipmentReport.title = locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Reports"], ["Reports"])));
	    ShipmentReport.icon = 'line-chart';
	    ShipmentReport.rootPage = true;
	    ShipmentReport.protectedPage = true;
	    ShipmentReport = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ShipmentReport);
	    return ShipmentReport;
	}(pageAncestor_1.default));
	exports.default = ShipmentReport;
	var templateObject_1;


/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var buttons_1 = __webpack_require__(27);
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var toolmenu_1 = tslib_1.__importDefault(__webpack_require__(51));
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var errorComp_1 = __webpack_require__(34);
	var formUtils_1 = __webpack_require__(14);
	var confirmationDialog_1 = tslib_1.__importDefault(__webpack_require__(47));
	var metaConstant_1 = __webpack_require__(13);
	__webpack_require__(203);
	var mobx_react_1 = __webpack_require__(4);
	var mobx_1 = __webpack_require__(5);
	var uiService_1 = tslib_1.__importDefault(__webpack_require__(32));
	var shipmentDomain_1 = __webpack_require__(132);
	var shipmentService_1 = tslib_1.__importDefault(__webpack_require__(176));
	var locales_1 = __webpack_require__(15);
	var shipmentVisitDriverForm_1 = tslib_1.__importDefault(__webpack_require__(407));
	var securityService_1 = tslib_1.__importDefault(__webpack_require__(35));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var grid_1 = __webpack_require__(50);
	__webpack_require__(275);
	var securityDomain_1 = __webpack_require__(97);
	var shipmentVisitPrepareForm_1 = tslib_1.__importDefault(__webpack_require__(2248));
	var selectSearchDialog_1 = tslib_1.__importDefault(__webpack_require__(311));
	var gridConfigCondition_1 = tslib_1.__importDefault(__webpack_require__(194));
	var visitNewShipmentGridLocation = 'visitNewShipmentList';
	var ShipmentVisitDetail = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentVisitDetail, _super);
	    function ShipmentVisitDetail() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.selectVisitDialogRefHandler = function (comp) { return _this.selectVisitDialogRef = comp; };
	        _this.customValidate = function (shipmentVisitObject) {
	            var errors = [];
	            if (!shipmentVisitObject.directionIncoming && !shipmentVisitObject.directionOutgoing) {
	                errors.push({ message: "Alespoň jeden směr musí být zaškrtnut." });
	            }
	            if ([shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_ARRIVED, shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_ENTERED].includes((0, formUtils_1.lovValue)(shipmentVisitObject.step)) && !shipmentVisitObject.driverPhone) {
	                errors.push({ message: "Driver phone is required." });
	            }
	            return errors;
	        };
	        _this.onSaveFromSubmit = function (shipmentVisitObject, afterValidateFn) {
	            if (!securityService_1.default.hasRight(metaConstant_1.SECURABLE.shipmentVisitDetail.name, (shipmentVisitObject.$new) ? metaConstant_1.PERMISSION.New : metaConstant_1.PERMISSION.Update)) {
	                return Promise.resolve(null);
	            }
	            console.log('onSave shipmentVisitId = %s, $new = %s', shipmentVisitObject.shipmentVisitId, shipmentVisitObject.$new);
	            uiService_1.default.showToolbarActionFlag();
	            if (shipmentVisitObject.driverPhone === '+')
	                shipmentVisitObject.driverPhone = undefined;
	            var result = (0, formUtils_1.preSave)(shipmentVisitObject, _this.customValidate, true);
	            if (!result) {
	                return Promise.resolve(null);
	            }
	            if (afterValidateFn) {
	                afterValidateFn();
	            }
	            var gridParams = shipmentVisitObject.$shipmentVisitShipmentsGrid.createFullParams();
	            return shipmentService_1.default.saveShipmentVisit(shipmentVisitObject, shipmentVisitObject.$syncRegistrationNumber, shipmentVisitObject.$syncShipmentStatus, (0, formUtils_1.lovValue)(shipmentVisitObject.$syncShippedFromPlace), gridParams, shipmentVisitObject.$visitsToDelete ? shipmentVisitObject.$visitsToDelete.map(function (v) { return v.shipmentVisitId; }) : undefined)
	                .then((0, mobx_1.action)("saveShipmentVisit-action", function (shipmentVisitJson) {
	                var wasNew = shipmentVisitObject.cleanAfterSave(shipmentVisitJson, true, "$direction");
	                shipmentVisitObject.$previousShipments = undefined;
	                shipmentVisitObject.$visitsToDelete = undefined;
	                shipmentVisitObject.$syncShippedFromPlace = undefined;
	                shipmentVisitObject.$syncShipmentStatus = undefined;
	                if (wasNew) {
	                    _this.context.router.replaceWith("shipmentVisitDetail", { id: shipmentVisitObject.shipmentVisitId });
	                }
	                uiService_1.default.hideToolbarActionFlag();
	                return Promise.resolve(null);
	            }), function (error) {
	                shipmentVisitObject.$errors = error.getMessages();
	            });
	        };
	        _this.onAdd = function (evt) {
	            console.log('onAdd');
	            var query = {};
	            _this.context.router.transitionTo("shipmentVisitDetail", { id: 'new' }, query);
	        };
	        _this.onDelete = function (evt) {
	            console.log('onDelete');
	            uiService_1.default.showToolbarActionFlag();
	            shipmentService_1.default.deleteShipmentVisit(shipmentService_1.default.shipmentVisitObject.shipmentVisitId)
	                .then(function (response) {
	                uiService_1.default.hideToolbarActionFlag();
	                _this.goBackOrHome();
	            }, function (error) {
	                shipmentService_1.default.shipmentVisitObject.$errors = error.getMessages();
	            });
	        };
	        _this.onMerge = function (evt) {
	            console.log('onMerge');
	            var shipmentVisitEntity = mdEntityService_1.default.getEntity('ShipmentVisit');
	            var shipmentVisitObject = shipmentService_1.default.shipmentVisitObject;
	            new Promise(function (resolve, reject) {
	                return _this.selectVisitDialogRef.open(resolve, reject, function (grid) {
	                    if (!grid.conditionArray)
	                        grid.conditionArray = [];
	                    // pouze stavy PREPARED_VISIT a VEHICLE_ARRIVED
	                    grid.conditionArray.push(new gridConfigCondition_1.default(grid.$gridLocationRef, {
	                        field: shipmentVisitEntity.getField("step"),
	                        operator: grid_1.FILTEROPERATOR.IN,
	                        values: [shipmentDomain_1.SHIPMENTVISITSTEP.PREPARED_VISIT, shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_ARRIVED]
	                    }));
	                    // vyloucime jiz pridane
	                    grid.conditionArray.push(new gridConfigCondition_1.default(grid.$gridLocationRef, {
	                        field: shipmentVisitEntity.getField("shipmentVisitId"),
	                        operator: grid_1.FILTEROPERATOR.NOTIN,
	                        values: tslib_1.__spreadArray(tslib_1.__spreadArray([], (shipmentVisitObject.$visitsToDelete || []).map(function (sv) { return sv.shipmentVisitId; }), true), (shipmentVisitObject.shipmentVisitId ? [shipmentVisitObject.shipmentVisitId] : []), true)
	                    }));
	                });
	            }).then(function (visit) {
	                console.log("merging visit id %s", visit.shipmentVisitId);
	                return shipmentService_1.default.readShipmentVisit(visit.shipmentVisitId, true);
	            }).then(function (visitWithShipments) {
	                shipmentVisitObject.shipments = tslib_1.__spreadArray(tslib_1.__spreadArray([], shipmentVisitObject.shipments || [], true), visitWithShipments.shipments.filter(function (sh) { return sh.shipmentDirection == (0, formUtils_1.lovValue)(shipmentVisitObject.$direction); }), true);
	                shipmentVisitObject.$visitsToDelete = tslib_1.__spreadArray(tslib_1.__spreadArray([], shipmentVisitObject.$visitsToDelete || [], true), [visitWithShipments], false);
	                shipmentVisitObject.$dirty = true;
	                return shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentVisitObject);
	            }).catch(function (e) { });
	        };
	        return _this;
	    }
	    ShipmentVisitDetail.fetchData = function (routerParams, query) {
	        console.log("ShipmentVisitDetail#fetchData(%O)", query);
	        var metadataPromise = mdEntityService_1.default.fetchEntityMetadata(['ShipmentVisit'], ["Shipment", { entity: "SHIPMENTDIRECTION", lov: true }]);
	        var shipmentVisitPromise;
	        var gridPromise = gridService_1.default.fetchGrids(visitNewShipmentGridLocation);
	        var shipmentGridSearch;
	        var shipmentPromise;
	        if (routerParams.id === 'new') {
	            shipmentVisitPromise = Promise.resolve(new shipmentDomain_1.ShipmentVisit({
	                $new: true
	            }));
	            if (query.gridId) {
	                shipmentGridSearch = gridService_1.default.innerSearch(query.gridId, query);
	            }
	            else if (query.shipmentId) {
	                shipmentPromise = shipmentService_1.default.readShipment(query.shipmentId);
	            }
	        }
	        else {
	            shipmentVisitPromise = shipmentService_1.default.readShipmentVisit(routerParams.id, true);
	        }
	        if (!shipmentGridSearch)
	            shipmentGridSearch = Promise.resolve(null);
	        if (!shipmentPromise)
	            shipmentPromise = Promise.resolve(null);
	        return Promise.all([metadataPromise, shipmentVisitPromise, gridPromise, shipmentGridSearch, shipmentPromise])
	            .then((0, mobx_1.action)("action-fetcgdara", function (_a) {
	            var entityMap = _a[0], shipmentVisitObject = _a[1], gridLocationMap = _a[2], gridSearchResult = _a[3], shipment = _a[4];
	            var shipmentdirectionEntity = entityMap.get("SHIPMENTDIRECTION");
	            shipmentVisitObject.$shipmentVisitShipmentsGrid = new grid_1.ClientGrid(gridLocationMap.get(visitNewShipmentGridLocation), "shipments", undefined, { shipmentStatusIcon: function (sh) { return (0, formUtils_1.lovLabel)(sh.shipmentStatus); } }, { shipmentStatusIcon: function (sh) { return shipmentDomain_1.SHIPMENTSTATUS_GRID_CSS[(0, formUtils_1.lovValue)(sh.shipmentStatus)]; } });
	            shipmentService_1.default.shipmentVisitObject = shipmentVisitObject.initAfterRead(routerParams.id === 'new');
	            if (routerParams.id === 'new') {
	                shipmentVisitObject.step = entityMap.get("SHIPMENTVISITSTEP").getLovItem(shipmentDomain_1.SHIPMENTVISITSTEP.PREPARED_VISIT);
	            }
	            else {
	                if ((0, formUtils_1.lovValue)(shipmentVisitObject.step) === shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_ARRIVED || (0, formUtils_1.lovValue)(shipmentVisitObject.step) === shipmentDomain_1.SHIPMENTVISITSTEP.PREPARED_VISIT) {
	                    shipmentVisitObject.$showSmsToDriver = true;
	                }
	            }
	            if (gridSearchResult) {
	                shipmentVisitObject.shipments = gridSearchResult.data.rows.map(function (r) { return new shipmentDomain_1.Shipment(r.rowObject); }).filter(function (sh) { return !sh.shipmentVisit; });
	            }
	            else if (shipment) {
	                shipmentVisitObject.shipments = [shipment];
	            }
	            if (gridSearchResult || shipment) {
	                shipmentVisitObject.directionOutgoing = shipmentVisitObject.shipments.some(function (sh) { return sh.shipmentDirection === shipmentDomain_1.SHIPMENTDIRECTION.OUTGOING; });
	                shipmentVisitObject.directionIncoming = shipmentVisitObject.shipments.some(function (sh) { return sh.shipmentDirection === shipmentDomain_1.SHIPMENTDIRECTION.INCOMING; });
	                var shipmentWithSpz = shipmentVisitObject.shipments.filter(function (sh) { return !!sh.registrationNumber; }).shift();
	                if (shipmentWithSpz)
	                    shipmentVisitObject.registrationNumber = shipmentWithSpz.registrationNumber;
	            }
	            if (shipmentVisitObject.directionOutgoing) {
	                shipmentVisitObject.$direction = shipmentdirectionEntity.lovItems.find(function (lov) { return lov.value === shipmentDomain_1.SHIPMENTDIRECTION.OUTGOING; });
	            }
	            else if (shipmentVisitObject.directionIncoming) {
	                shipmentVisitObject.$direction = shipmentdirectionEntity.lovItems.find(function (lov) { return lov.value === shipmentDomain_1.SHIPMENTDIRECTION.INCOMING; });
	            }
	            shipmentVisitObject.$syncRegistrationNumber = shipmentVisitObject.shipments && shipmentVisitObject.shipments.some(function (sh) { return sh.registrationNumber !== shipmentVisitObject.registrationNumber; });
	            if (shipmentVisitObject.shipments) {
	                return shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentVisitObject);
	            }
	        }));
	    };
	    ShipmentVisitDetail.willTransitionFrom = function (transition, component, callback) {
	        console.log('shipmentVisitDetail willTransitionFrom: transition = %O, component = %O', transition, component);
	        if (component.selectVisitDialogRef && component.selectVisitDialogRef.dialogOpen) {
	            console.log("canceling transition");
	            transition.cancel();
	            component.context.router.goBack();
	        }
	        else {
	            _super.willTransitionFrom.call(this, transition, component, callback);
	        }
	    };
	    ShipmentVisitDetail.prototype.componentWillUnmount = function () {
	        shipmentService_1.default.shipmentVisitObject = null;
	    };
	    ShipmentVisitDetail.prototype.findRootObject = function () {
	        return shipmentService_1.default.shipmentVisitObject;
	    };
	    ShipmentVisitDetail.prototype.render = function () {
	        var query = this.props.query;
	        var shipmentVisitObject = shipmentService_1.default.shipmentVisitObject;
	        var shipmentVisitEntity = mdEntityService_1.default.getEntity('ShipmentVisit');
	        var propsForCreateForm = {
	            dataObject: shipmentVisitObject,
	            rootObject: shipmentVisitObject,
	            entity: shipmentVisitEntity,
	            entities: mdEntityService_1.default.entityMap
	        };
	        console.log('shipmentVisitDetail render shipmentVisitId = %s, $new = %s', shipmentVisitObject.shipmentVisitId, shipmentVisitObject.$new);
	        return (react_1.default.createElement("main", { className: "main-content", style: { display: 'flex', flexDirection: 'column' } },
	            this._createToolMenu(shipmentVisitObject, query.gridLocation),
	            react_1.default.createElement(errorComp_1.ErrorComp, { messages: shipmentVisitObject.$errors }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.dirtyDialogRefHandler }),
	            react_1.default.createElement(confirmationDialog_1.default, { ref: this.deleteDialogRefHandler, okButtonText: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["Yes"], ["Yes"]))), cancelButtonText: locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["No"], ["No"]))) }),
	            (!securityService_1.default.currentUser.hasRestriction(securityDomain_1.RESTRICTION.SIMPLE_SHIPMENT_VISIT)) &&
	                react_1.default.createElement(selectSearchDialog_1.default, { ref: this.selectVisitDialogRefHandler, gridLocation: "shipmentVisitSearch2", masterId: (0, formUtils_1.lovValue)(shipmentVisitObject.$direction), showGridConfig: false, title: "Select Visit to merge and delete" }),
	            (!securityService_1.default.currentUser.hasRestriction(securityDomain_1.RESTRICTION.SIMPLE_SHIPMENT_VISIT)) ? (react_1.default.createElement(shipmentVisitPrepareForm_1.default, tslib_1.__assign({}, propsForCreateForm, { onSubmit: this.onSaveFromSubmit, disabled: (0, formUtils_1.lovValue)(shipmentVisitObject.step) === shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_LEFT }))) : ((shipmentVisitObject.$new || (0, formUtils_1.lovValue)(shipmentVisitObject.step) === shipmentDomain_1.SHIPMENTVISITSTEP.PREPARED_VISIT) ? (react_1.default.createElement(shipmentVisitDriverForm_1.default, tslib_1.__assign({}, propsForCreateForm, { onSubmit: this.onSaveFromSubmit }))) : (react_1.default.createElement(shipmentVisitPrepareForm_1.default, tslib_1.__assign({}, propsForCreateForm, { disabled: true }))))));
	    };
	    ShipmentVisitDetail.prototype._createToolMenu = function (shipmentVisitObject, gridLocation) {
	        return (react_1.default.createElement(toolmenu_1.default, { chainGridLocation: gridLocation, backAction: this.onBack, backDisabled: History.length <= 1, entityName: "ShipmentVisit", entityId: shipmentVisitObject.shipmentVisitId, historize: true },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { routeName: "shipmentVisitDetail", params: { id: 'new' }, label: locales_1.loc.i18n(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["New Shipment visit"], ["New Shipment visit"]))), permission: metaConstant_1.PERMISSION.New, disabled: shipmentVisitObject.$new }),
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { routeName: "shipmentVisitList", label: locales_1.loc.i18n(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["Back to visits"], ["Back to visits"]))) }),
	            react_1.default.createElement(buttons_1.WithDeleteDialogZzFlatButton, { entityName: "ShipmentVisit", pageAncestor: this, onClick: this.onDelete, disabled: shipmentVisitObject.$new, label: locales_1.loc.i18n(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["Delete"], ["Delete"]))), permission: metaConstant_1.PERMISSION.Delete }),
	            (!securityService_1.default.currentUser.hasRestriction(securityDomain_1.RESTRICTION.SIMPLE_SHIPMENT_VISIT)) && !!shipmentVisitObject.$direction && react_1.default.createElement(buttons_1.ZzFlatButton, { onClick: this.onMerge, disabled: (0, formUtils_1.lovValue)(shipmentVisitObject.step) === shipmentDomain_1.SHIPMENTVISITSTEP.VEHICLE_LEFT, label: locales_1.loc.i18n(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["Merge Visit"], ["Merge Visit"]))), permission: metaConstant_1.PERMISSION.Delete })));
	    };
	    ShipmentVisitDetail.module = metaConstant_1.MODULE.shipment;
	    ShipmentVisitDetail.title = locales_1.loc.i18n(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["Shipment visit"], ["Shipment visit"])));
	    ShipmentVisitDetail.icon = 'blind';
	    ShipmentVisitDetail.protectedPage = true;
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitDetail.prototype, "onSaveFromSubmit", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitDetail.prototype, "onDelete", void 0);
	    tslib_1.__decorate([
	        mobx_1.action
	    ], ShipmentVisitDetail.prototype, "onMerge", void 0);
	    ShipmentVisitDetail = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ShipmentVisitDetail);
	    return ShipmentVisitDetail;
	}(pageAncestor_1.default));
	exports.default = ShipmentVisitDetail;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;


/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(3);
	var react_1 = tslib_1.__importDefault(__webpack_require__(1));
	var pageAncestor_1 = tslib_1.__importDefault(__webpack_require__(21));
	var gridService_1 = tslib_1.__importDefault(__webpack_require__(22));
	var gridCompConnected_1 = tslib_1.__importDefault(__webpack_require__(38));
	var metaConstant_1 = __webpack_require__(13);
	var mdEntityService_1 = tslib_1.__importDefault(__webpack_require__(11));
	var mobx_react_1 = __webpack_require__(4);
	var locales_1 = __webpack_require__(15);
	__webpack_require__(668);
	var routes_1 = __webpack_require__(75);
	var buttons_1 = __webpack_require__(27);
	var gridLocation = 'shipmentVisitList';
	var ShipmentVisitList = /** @class */ (function (_super) {
	    tslib_1.__extends(ShipmentVisitList, _super);
	    function ShipmentVisitList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ShipmentVisitList.fetchData = function (routerParams) {
	        console.log("ShipmentVisitList#fetchData(%s)", gridLocation);
	        return gridService_1.default.fetchGrids(gridLocation)
	            .then(function (gridLocationMap) {
	            return gridService_1.default.getOrCreateGrid(gridLocation);
	        });
	    };
	    ShipmentVisitList.prototype.render = function () {
	        var _a = this.props, params = _a.params, query = _a.query;
	        return (react_1.default.createElement(gridCompConnected_1.default, { grid: gridService_1.default.getOrCreateGrid(gridLocation), entities: mdEntityService_1.default.entityMap, gridId: params.gridId, query: query, refreshEntities: ["Shipment", "ShipmentVisit"] },
	            react_1.default.createElement(buttons_1.ZzFlatButtonRoute, { onGridToolbar: true, routeName: "shipmentVisitDetail", params: { id: 'new' }, label: locales_1.loc.i18n(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["New Shipment visit"], ["New Shipment visit"]))), permission: metaConstant_1.PERMISSION.New, securable: routes_1.PAGE.shipmentVisitDetail })));
	    };
	    ShipmentVisitList.module = metaConstant_1.MODULE.shipment;
	    ShipmentVisitList.title = locales_1.loc.i18n(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["Shipment visits"], ["Shipment visits"])));
	    ShipmentVisitList.icon = 'blind';
	    ShipmentVisitList.rootPage = true;
	    ShipmentVisitList.protectedPage = true;
	    ShipmentVisitList = tslib_1.__decorate([
	        mobx_react_1.observer
	    ], ShipmentVisitList);
	    return ShipmentVisitList;
	}(pageAncestor_1.default));
	exports.default = ShipmentVisitList;
	var templateObject_1, templateObject_2;


/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2016 Palantir Technologies, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2258);
	var shownWarnings = new Set();
	/**
	 * Used to exit the program and display a friendly message without the callstack.
	 */
	var FatalError = /** @class */ (function (_super) {
	    tslib_1.__extends(FatalError, _super);
	    function FatalError(message, innerError) {
	        var _this = _super.call(this, message) || this;
	        _this.message = message;
	        _this.innerError = innerError;
	        _this.name = FatalError.NAME;
	        // Fix prototype chain for target ES5
	        Object.setPrototypeOf(_this, FatalError.prototype);
	        return _this;
	    }
	    FatalError.NAME = "FatalError";
	    return FatalError;
	}(Error));
	exports.FatalError = FatalError;
	function isError(possibleError) {
	    return possibleError != undefined && possibleError.message !== undefined;
	}
	exports.isError = isError;
	function showWarningOnce(message) {
	    if (!shownWarnings.has(message)) {
	        console.warn(message);
	        shownWarnings.add(message);
	    }
	}
	exports.showWarningOnce = showWarningOnce;
	function showRuleCrashWarning(message, ruleName, fileName) {
	    console.warn("The '" + ruleName + "' rule threw an error in '" + fileName + "':\n" + message);
	}
	exports.showRuleCrashWarning = showRuleCrashWarning;


/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __createBinding = function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(2260);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createUncontrollable(mixin, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var _class, _temp;
	
	    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        controlledProps = Object.keys(controlledValues),
	        propTypes;
	
	    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = (_temp = _class = function (_React$Component) {
	      _inherits(component, _React$Component);
	
	      function component() {
	        _classCallCheck(this, component);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	      }
	
	      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
	      };
	
	      component.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        var props = this.props;
	
	        this._values = {};
	
	        controlledProps.forEach(function (key) {
	          _this2._values[key] = props[utils.defaultKey(key)];
	        });
	      };
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	
	
	      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        var _this3 = this;
	
	        var props = this.props;
	
	        if (mixin.componentWillReceiveProps) {
	          mixin.componentWillReceiveProps.call(this, nextProps);
	        }
	
	        controlledProps.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this3._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      };
	
	      component.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.unmounted = true;
	      };
	
	      component.prototype.getControlledInstance = function getControlledInstance() {
	        return this.refs.inner;
	      };
	
	      component.prototype.render = function render() {
	        var _this4 = this;
	
	        var newProps = {},
	            props = omitProps(this.props);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this4.props[propName];
	
	          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
	            prop = _this4.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this4, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      };
	
	      return component;
	    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);
	
	    _extends(component.prototype, methods);
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	
	    function omitProps(props) {
	      var result = {};
	
	      utils.each(props, function (value, key) {
	        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
	      });
	
	      return result;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.has = has;
	exports.isReactComponent = isReactComponent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(68);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = readOnlyPropType(handler, displayName);
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}

/***/ }),
/* 2261 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 2262 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(2262);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(2261);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(140)))

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = contains;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	var _toString = _interopRequireDefault(__webpack_require__(580));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function contains(str, elem) {
	  (0, _assertString.default)(str);
	  return str.indexOf((0, _toString.default)(elem)) >= 0;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = equals;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function equals(str, comparison) {
	  (0, _assertString.default)(str);
	  return str === comparison;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = escape;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escape(str) {
	  (0, _assertString.default)(str);
	  return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\//g, '&#x2F;').replace(/\\/g, '&#x5C;').replace(/`/g, '&#96;');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	var _toDate = _interopRequireDefault(__webpack_require__(578));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAfter(str) {
	  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
	  (0, _assertString.default)(str);
	  var comparison = (0, _toDate.default)(date);
	  var original = (0, _toDate.default)(str);
	  return !!(original && comparison && original > comparison);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAlpha;
	exports.locales = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	var _alpha = __webpack_require__(408);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAlpha(str) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
	  (0, _assertString.default)(str);
	
	  if (locale in _alpha.alpha) {
	    return _alpha.alpha[locale].test(str);
	  }
	
	  throw new Error("Invalid locale '".concat(locale, "'"));
	}
	
	var locales = Object.keys(_alpha.alpha);
	exports.locales = locales;

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAlphanumeric;
	exports.locales = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	var _alpha = __webpack_require__(408);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAlphanumeric(str) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
	  (0, _assertString.default)(str);
	
	  if (locale in _alpha.alphanumeric) {
	    return _alpha.alphanumeric[locale].test(str);
	  }
	
	  throw new Error("Invalid locale '".concat(locale, "'"));
	}
	
	var locales = Object.keys(_alpha.alphanumeric);
	exports.locales = locales;

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAscii;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-control-regex */
	var ascii = /^[\x00-\x7F]+$/;
	/* eslint-enable no-control-regex */
	
	function isAscii(str) {
	  (0, _assertString.default)(str);
	  return ascii.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBase64;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var notBase64 = /[^A-Z0-9+\/=]/i;
	
	function isBase64(str) {
	  (0, _assertString.default)(str);
	  var len = str.length;
	
	  if (!len || len % 4 !== 0 || notBase64.test(str)) {
	    return false;
	  }
	
	  var firstPaddingChar = str.indexOf('=');
	  return firstPaddingChar === -1 || firstPaddingChar === len - 1 || firstPaddingChar === len - 2 && str[len - 1] === '=';
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	var _toDate = _interopRequireDefault(__webpack_require__(578));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBefore(str) {
	  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
	  (0, _assertString.default)(str);
	  var comparison = (0, _toDate.default)(date);
	  var original = (0, _toDate.default)(str);
	  return !!(original && comparison && original < comparison);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBoolean;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBoolean(str) {
	  (0, _assertString.default)(str);
	  return ['true', 'false', '1', '0'].indexOf(str) >= 0;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isCreditCard;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14})$/;
	/* eslint-enable max-len */
	
	function isCreditCard(str) {
	  (0, _assertString.default)(str);
	  var sanitized = str.replace(/[- ]+/g, '');
	
	  if (!creditCard.test(sanitized)) {
	    return false;
	  }
	
	  var sum = 0;
	  var digit;
	  var tmpNum;
	  var shouldDouble;
	
	  for (var i = sanitized.length - 1; i >= 0; i--) {
	    digit = sanitized.substring(i, i + 1);
	    tmpNum = parseInt(digit, 10);
	
	    if (shouldDouble) {
	      tmpNum *= 2;
	
	      if (tmpNum >= 10) {
	        sum += tmpNum % 10 + 1;
	      } else {
	        sum += tmpNum;
	      }
	    } else {
	      sum += tmpNum;
	    }
	
	    shouldDouble = !shouldDouble;
	  }
	
	  return !!(sum % 10 === 0 ? sanitized : false);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isCurrency;
	
	var _merge = _interopRequireDefault(__webpack_require__(222));
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function currencyRegex(options) {
	  var decimal_digits = "\\d{".concat(options.digits_after_decimal[0], "}");
	  options.digits_after_decimal.forEach(function (digit, index) {
	    if (index !== 0) decimal_digits = "".concat(decimal_digits, "|\\d{").concat(digit, "}");
	  });
	  var symbol = "(\\".concat(options.symbol.replace(/\./g, '\\.'), ")").concat(options.require_symbol ? '' : '?'),
	      negative = '-?',
	      whole_dollar_amount_without_sep = '[1-9]\\d*',
	      whole_dollar_amount_with_sep = "[1-9]\\d{0,2}(\\".concat(options.thousands_separator, "\\d{3})*"),
	      valid_whole_dollar_amounts = ['0', whole_dollar_amount_without_sep, whole_dollar_amount_with_sep],
	      whole_dollar_amount = "(".concat(valid_whole_dollar_amounts.join('|'), ")?"),
	      decimal_amount = "(\\".concat(options.decimal_separator, "(").concat(decimal_digits, "))").concat(options.require_decimal ? '' : '?');
	  var pattern = whole_dollar_amount + (options.allow_decimal || options.require_decimal ? decimal_amount : ''); // default is negative sign before symbol, but there are two other options (besides parens)
	
	  if (options.allow_negatives && !options.parens_for_negatives) {
	    if (options.negative_sign_after_digits) {
	      pattern += negative;
	    } else if (options.negative_sign_before_digits) {
	      pattern = negative + pattern;
	    }
	  } // South African Rand, for example, uses R 123 (space) and R-123 (no space)
	
	
	  if (options.allow_negative_sign_placeholder) {
	    pattern = "( (?!\\-))?".concat(pattern);
	  } else if (options.allow_space_after_symbol) {
	    pattern = " ?".concat(pattern);
	  } else if (options.allow_space_after_digits) {
	    pattern += '( (?!$))?';
	  }
	
	  if (options.symbol_after_digits) {
	    pattern += symbol;
	  } else {
	    pattern = symbol + pattern;
	  }
	
	  if (options.allow_negatives) {
	    if (options.parens_for_negatives) {
	      pattern = "(\\(".concat(pattern, "\\)|").concat(pattern, ")");
	    } else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) {
	      pattern = negative + pattern;
	    }
	  } // ensure there's a dollar and/or decimal amount, and that
	  // it doesn't start with a space or a negative sign followed by a space
	
	
	  return new RegExp("^(?!-? )(?=.*\\d)".concat(pattern, "$"));
	}
	
	var default_currency_options = {
	  symbol: '$',
	  require_symbol: false,
	  allow_space_after_symbol: false,
	  symbol_after_digits: false,
	  allow_negatives: true,
	  parens_for_negatives: false,
	  negative_sign_before_digits: false,
	  negative_sign_after_digits: false,
	  allow_negative_sign_placeholder: false,
	  thousands_separator: ',',
	  decimal_separator: '.',
	  allow_decimal: true,
	  require_decimal: false,
	  digits_after_decimal: [2],
	  allow_space_after_digits: false
	};
	
	function isCurrency(str, options) {
	  (0, _assertString.default)(str);
	  options = (0, _merge.default)(options, default_currency_options);
	  return currencyRegex(options).test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDataURI;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validMediaType = /^[a-z]+\/[a-z0-9\-\+]+$/i;
	var validAttribute = /^[a-z\-]+=[a-z0-9\-]+$/i;
	var validData = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;
	
	function isDataURI(str) {
	  (0, _assertString.default)(str);
	  var data = str.split(',');
	
	  if (data.length < 2) {
	    return false;
	  }
	
	  var attributes = data.shift().trim().split(';');
	  var schemeAndMediaType = attributes.shift();
	
	  if (schemeAndMediaType.substr(0, 5) !== 'data:') {
	    return false;
	  }
	
	  var mediaType = schemeAndMediaType.substr(5);
	
	  if (mediaType !== '' && !validMediaType.test(mediaType)) {
	    return false;
	  }
	
	  for (var i = 0; i < attributes.length; i++) {
	    if (i === attributes.length - 1 && attributes[i].toLowerCase() === 'base64') {// ok
	    } else if (!validAttribute.test(attributes[i])) {
	      return false;
	    }
	  }
	
	  for (var _i = 0; _i < data.length; _i++) {
	    if (!validData.test(data[_i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDecimal;
	
	var _merge = _interopRequireDefault(__webpack_require__(222));
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	var _includes = _interopRequireDefault(__webpack_require__(579));
	
	var _alpha = __webpack_require__(408);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function decimalRegExp(options) {
	  var regExp = new RegExp("^[-+]?([0-9]+)?(\\".concat(_alpha.decimal[options.locale], "[0-9]{").concat(options.decimal_digits, "})").concat(options.force_decimal ? '' : '?', "$"));
	  return regExp;
	}
	
	var default_decimal_options = {
	  force_decimal: false,
	  decimal_digits: '1,',
	  locale: 'en-US'
	};
	var blacklist = ['', '-', '+'];
	
	function isDecimal(str, options) {
	  (0, _assertString.default)(str);
	  options = (0, _merge.default)(options, default_decimal_options);
	
	  if (options.locale in _alpha.decimal) {
	    return !(0, _includes.default)(blacklist, str.replace(/ /g, '')) && decimalRegExp(options).test(str);
	  }
	
	  throw new Error("Invalid locale '".concat(options.locale, "'"));
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDivisibleBy;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	var _toFloat = _interopRequireDefault(__webpack_require__(976));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isDivisibleBy(str, num) {
	  (0, _assertString.default)(str);
	  return (0, _toFloat.default)(str) % parseInt(num, 10) === 0;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmail;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	var _merge = _interopRequireDefault(__webpack_require__(222));
	
	var _isByteLength = _interopRequireDefault(__webpack_require__(969));
	
	var _isFQDN = _interopRequireDefault(__webpack_require__(577));
	
	var _isIP = _interopRequireDefault(__webpack_require__(409));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_email_options = {
	  allow_display_name: false,
	  require_display_name: false,
	  allow_utf8_local_part: true,
	  require_tld: true
	};
	/* eslint-disable max-len */
	
	/* eslint-disable no-control-regex */
	
	var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
	var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
	var gmailUserPart = /^[a-z\d]+$/;
	var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
	var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
	var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
	/* eslint-enable max-len */
	
	/* eslint-enable no-control-regex */
	
	function isEmail(str, options) {
	  (0, _assertString.default)(str);
	  options = (0, _merge.default)(options, default_email_options);
	
	  if (options.require_display_name || options.allow_display_name) {
	    var display_email = str.match(displayName);
	
	    if (display_email) {
	      str = display_email[1];
	    } else if (options.require_display_name) {
	      return false;
	    }
	  }
	
	  var parts = str.split('@');
	  var domain = parts.pop();
	  var user = parts.join('@');
	  var lower_domain = domain.toLowerCase();
	
	  if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
	    /*
	      Previously we removed dots for gmail addresses before validating.
	      This was removed because it allows `multiple..dots@gmail.com`
	      to be reported as valid, but it is not.
	      Gmail only normalizes single dots, removing them from here is pointless,
	      should be done in normalizeEmail
	    */
	    user = user.toLowerCase(); // Removing sub-address from username before gmail validation
	
	    var username = user.split('+')[0]; // Dots are not included in gmail length restriction
	
	    if (!(0, _isByteLength.default)(username.replace('.', ''), {
	      min: 6,
	      max: 30
	    })) {
	      return false;
	    }
	
	    var _user_parts = username.split('.');
	
	    for (var i = 0; i < _user_parts.length; i++) {
	      if (!gmailUserPart.test(_user_parts[i])) {
	        return false;
	      }
	    }
	  }
	
	  if (!(0, _isByteLength.default)(user, {
	    max: 64
	  }) || !(0, _isByteLength.default)(domain, {
	    max: 254
	  })) {
	    return false;
	  }
	
	  if (!(0, _isFQDN.default)(domain, {
	    require_tld: options.require_tld
	  })) {
	    if (!options.allow_ip_domain) {
	      return false;
	    }
	
	    if (!(0, _isIP.default)(domain)) {
	      if (!domain.startsWith('[') || !domain.endsWith(']')) {
	        return false;
	      }
	
	      var noBracketdomain = domain.substr(1, domain.length - 2);
	
	      if (noBracketdomain.length === 0 || !(0, _isIP.default)(noBracketdomain)) {
	        return false;
	      }
	    }
	  }
	
	  if (user[0] === '"') {
	    user = user.slice(1, user.length - 1);
	    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
	  }
	
	  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
	  var user_parts = user.split('.');
	
	  for (var _i = 0; _i < user_parts.length; _i++) {
	    if (!pattern.test(user_parts[_i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmpty;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	var _merge = _interopRequireDefault(__webpack_require__(222));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_is_empty_options = {
	  ignore_whitespace: false
	};
	
	function isEmpty(str, options) {
	  (0, _assertString.default)(str);
	  options = (0, _merge.default)(options, default_is_empty_options);
	  return (options.ignore_whitespace ? str.trim().length : str.length) === 0;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFloat;
	exports.locales = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	var _alpha = __webpack_require__(408);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isFloat(str, options) {
	  (0, _assertString.default)(str);
	  options = options || {};
	  var float = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(options.locale ? _alpha.decimal[options.locale] : '.', "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
	
	  if (str === '' || str === '.' || str === '-' || str === '+') {
	    return false;
	  }
	
	  var value = parseFloat(str.replace(',', '.'));
	  return float.test(str) && (!options.hasOwnProperty('min') || value >= options.min) && (!options.hasOwnProperty('max') || value <= options.max) && (!options.hasOwnProperty('lt') || value < options.lt) && (!options.hasOwnProperty('gt') || value > options.gt);
	}
	
	var locales = Object.keys(_alpha.decimal);
	exports.locales = locales;

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHash;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lengths = {
	  md5: 32,
	  md4: 32,
	  sha1: 40,
	  sha256: 64,
	  sha384: 96,
	  sha512: 128,
	  ripemd128: 32,
	  ripemd160: 40,
	  tiger128: 32,
	  tiger160: 40,
	  tiger192: 48,
	  crc32: 8,
	  crc32b: 8
	};
	
	function isHash(str, algorithm) {
	  (0, _assertString.default)(str);
	  var hash = new RegExp("^[a-f0-9]{".concat(lengths[algorithm], "}$"));
	  return hash.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHexColor;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{6})$/i;
	
	function isHexColor(str) {
	  (0, _assertString.default)(str);
	  return hexcolor.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isIPRange;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	var _isIP = _interopRequireDefault(__webpack_require__(409));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subnetMaybe = /^\d{1,2}$/;
	
	function isIPRange(str) {
	  (0, _assertString.default)(str);
	  var parts = str.split('/'); // parts[0] -> ip, parts[1] -> subnet
	
	  if (parts.length !== 2) {
	    return false;
	  }
	
	  if (!subnetMaybe.test(parts[1])) {
	    return false;
	  } // Disallow preceding 0 i.e. 01, 02, ...
	
	
	  if (parts[1].length > 1 && parts[1].startsWith('0')) {
	    return false;
	  }
	
	  return (0, _isIP.default)(parts[0], 4) && parts[1] <= 32 && parts[1] >= 0;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISBN;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isbn10Maybe = /^(?:[0-9]{9}X|[0-9]{10})$/;
	var isbn13Maybe = /^(?:[0-9]{13})$/;
	var factor = [1, 3];
	
	function isISBN(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  (0, _assertString.default)(str);
	  version = String(version);
	
	  if (!version) {
	    return isISBN(str, 10) || isISBN(str, 13);
	  }
	
	  var sanitized = str.replace(/[\s-]+/g, '');
	  var checksum = 0;
	  var i;
	
	  if (version === '10') {
	    if (!isbn10Maybe.test(sanitized)) {
	      return false;
	    }
	
	    for (i = 0; i < 9; i++) {
	      checksum += (i + 1) * sanitized.charAt(i);
	    }
	
	    if (sanitized.charAt(9) === 'X') {
	      checksum += 10 * 10;
	    } else {
	      checksum += 10 * sanitized.charAt(9);
	    }
	
	    if (checksum % 11 === 0) {
	      return !!sanitized;
	    }
	  } else if (version === '13') {
	    if (!isbn13Maybe.test(sanitized)) {
	      return false;
	    }
	
	    for (i = 0; i < 12; i++) {
	      checksum += factor[i % 2] * sanitized.charAt(i);
	    }
	
	    if (sanitized.charAt(12) - (10 - checksum % 10) % 10 === 0) {
	      return !!sanitized;
	    }
	  }
	
	  return false;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISIN;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
	
	function isISIN(str) {
	  (0, _assertString.default)(str);
	
	  if (!isin.test(str)) {
	    return false;
	  }
	
	  var checksumStr = str.replace(/[A-Z]/g, function (character) {
	    return parseInt(character, 36);
	  });
	  var sum = 0;
	  var digit;
	  var tmpNum;
	  var shouldDouble = true;
	
	  for (var i = checksumStr.length - 2; i >= 0; i--) {
	    digit = checksumStr.substring(i, i + 1);
	    tmpNum = parseInt(digit, 10);
	
	    if (shouldDouble) {
	      tmpNum *= 2;
	
	      if (tmpNum >= 10) {
	        sum += tmpNum + 1;
	      } else {
	        sum += tmpNum;
	      }
	    } else {
	      sum += tmpNum;
	    }
	
	    shouldDouble = !shouldDouble;
	  }
	
	  return parseInt(str.substr(str.length - 1), 10) === (10000 - sum) % 10;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISO31661Alpha2;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	var _includes = _interopRequireDefault(__webpack_require__(579));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
	var validISO31661Alpha2CountriesCodes = ['AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AW', 'AX', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT', 'BV', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'EH', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GW', 'GY', 'HK', 'HM', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PM', 'PN', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'UM', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'YE', 'YT', 'ZA', 'ZM', 'ZW'];
	
	function isISO31661Alpha2(str) {
	  (0, _assertString.default)(str);
	  return (0, _includes.default)(validISO31661Alpha2CountriesCodes, str.toUpperCase());
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISO31661Alpha3;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	var _includes = _interopRequireDefault(__webpack_require__(579));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3
	var validISO31661Alpha3CountriesCodes = ['AFG', 'ALA', 'ALB', 'DZA', 'ASM', 'AND', 'AGO', 'AIA', 'ATA', 'ATG', 'ARG', 'ARM', 'ABW', 'AUS', 'AUT', 'AZE', 'BHS', 'BHR', 'BGD', 'BRB', 'BLR', 'BEL', 'BLZ', 'BEN', 'BMU', 'BTN', 'BOL', 'BES', 'BIH', 'BWA', 'BVT', 'BRA', 'IOT', 'BRN', 'BGR', 'BFA', 'BDI', 'KHM', 'CMR', 'CAN', 'CPV', 'CYM', 'CAF', 'TCD', 'CHL', 'CHN', 'CXR', 'CCK', 'COL', 'COM', 'COG', 'COD', 'COK', 'CRI', 'CIV', 'HRV', 'CUB', 'CUW', 'CYP', 'CZE', 'DNK', 'DJI', 'DMA', 'DOM', 'ECU', 'EGY', 'SLV', 'GNQ', 'ERI', 'EST', 'ETH', 'FLK', 'FRO', 'FJI', 'FIN', 'FRA', 'GUF', 'PYF', 'ATF', 'GAB', 'GMB', 'GEO', 'DEU', 'GHA', 'GIB', 'GRC', 'GRL', 'GRD', 'GLP', 'GUM', 'GTM', 'GGY', 'GIN', 'GNB', 'GUY', 'HTI', 'HMD', 'VAT', 'HND', 'HKG', 'HUN', 'ISL', 'IND', 'IDN', 'IRN', 'IRQ', 'IRL', 'IMN', 'ISR', 'ITA', 'JAM', 'JPN', 'JEY', 'JOR', 'KAZ', 'KEN', 'KIR', 'PRK', 'KOR', 'KWT', 'KGZ', 'LAO', 'LVA', 'LBN', 'LSO', 'LBR', 'LBY', 'LIE', 'LTU', 'LUX', 'MAC', 'MKD', 'MDG', 'MWI', 'MYS', 'MDV', 'MLI', 'MLT', 'MHL', 'MTQ', 'MRT', 'MUS', 'MYT', 'MEX', 'FSM', 'MDA', 'MCO', 'MNG', 'MNE', 'MSR', 'MAR', 'MOZ', 'MMR', 'NAM', 'NRU', 'NPL', 'NLD', 'NCL', 'NZL', 'NIC', 'NER', 'NGA', 'NIU', 'NFK', 'MNP', 'NOR', 'OMN', 'PAK', 'PLW', 'PSE', 'PAN', 'PNG', 'PRY', 'PER', 'PHL', 'PCN', 'POL', 'PRT', 'PRI', 'QAT', 'REU', 'ROU', 'RUS', 'RWA', 'BLM', 'SHN', 'KNA', 'LCA', 'MAF', 'SPM', 'VCT', 'WSM', 'SMR', 'STP', 'SAU', 'SEN', 'SRB', 'SYC', 'SLE', 'SGP', 'SXM', 'SVK', 'SVN', 'SLB', 'SOM', 'ZAF', 'SGS', 'SSD', 'ESP', 'LKA', 'SDN', 'SUR', 'SJM', 'SWZ', 'SWE', 'CHE', 'SYR', 'TWN', 'TJK', 'TZA', 'THA', 'TLS', 'TGO', 'TKL', 'TON', 'TTO', 'TUN', 'TUR', 'TKM', 'TCA', 'TUV', 'UGA', 'UKR', 'ARE', 'GBR', 'USA', 'UMI', 'URY', 'UZB', 'VUT', 'VEN', 'VNM', 'VGB', 'VIR', 'WLF', 'ESH', 'YEM', 'ZMB', 'ZWE'];
	
	function isISO31661Alpha3(str) {
	  (0, _assertString.default)(str);
	  return (0, _includes.default)(validISO31661Alpha3CountriesCodes, str.toUpperCase());
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISO8601;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	// from http://goo.gl/0ejHHW
	var iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
	/* eslint-enable max-len */
	
	var isValidDate = function isValidDate(str) {
	  // str must have passed the ISO8601 check
	  // this check is meant to catch invalid dates
	  // like 2009-02-31
	  // first check for ordinal dates
	  var ordinalMatch = str.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
	
	  if (ordinalMatch) {
	    var oYear = Number(ordinalMatch[1]);
	    var oDay = Number(ordinalMatch[2]); // if is leap year
	
	    if (oYear % 4 === 0 && oYear % 100 !== 0) return oDay <= 366;
	    return oDay <= 365;
	  }
	
	  var match = str.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number);
	  var year = match[1];
	  var month = match[2];
	  var day = match[3];
	  var monthString = month ? "0".concat(month).slice(-2) : month;
	  var dayString = day ? "0".concat(day).slice(-2) : day; // create a date object and compare
	
	  var d = new Date("".concat(year, "-").concat(monthString || '01', "-").concat(dayString || '01'));
	  if (isNaN(d.getUTCFullYear())) return false;
	
	  if (month && day) {
	    return d.getUTCFullYear() === year && d.getUTCMonth() + 1 === month && d.getUTCDate() === day;
	  }
	
	  return true;
	};
	
	function isISO8601(str, options) {
	  (0, _assertString.default)(str);
	  var check = iso8601.test(str);
	  if (!options) return check;
	  if (check && options.strict) return isValidDate(str);
	  return check;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISRC;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// see http://isrc.ifpi.org/en/isrc-standard/code-syntax
	var isrc = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
	
	function isISRC(str) {
	  (0, _assertString.default)(str);
	  return isrc.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISSN;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var issn = '^\\d{4}-?\\d{3}[\\dX]$';
	
	function isISSN(str) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  (0, _assertString.default)(str);
	  var testIssn = issn;
	  testIssn = options.require_hyphen ? testIssn.replace('?', '') : testIssn;
	  testIssn = options.case_sensitive ? new RegExp(testIssn) : new RegExp(testIssn, 'i');
	
	  if (!testIssn.test(str)) {
	    return false;
	  }
	
	  var digits = str.replace('-', '').toUpperCase();
	  var checksum = 0;
	
	  for (var i = 0; i < digits.length; i++) {
	    var digit = digits[i];
	    checksum += (digit === 'X' ? 10 : +digit) * (8 - i);
	  }
	
	  return checksum % 11 === 0;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isIdentityCard;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validators = {
	  ES: function ES(str) {
	    (0, _assertString.default)(str);
	    var DNI = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/;
	    var charsValue = {
	      X: 0,
	      Y: 1,
	      Z: 2
	    };
	    var controlDigits = ['T', 'R', 'W', 'A', 'G', 'M', 'Y', 'F', 'P', 'D', 'X', 'B', 'N', 'J', 'Z', 'S', 'Q', 'V', 'H', 'L', 'C', 'K', 'E']; // sanitize user input
	
	    var sanitized = str.trim().toUpperCase(); // validate the data structure
	
	    if (!DNI.test(sanitized)) {
	      return false;
	    } // validate the control digit
	
	
	    var number = sanitized.slice(0, -1).replace(/[X,Y,Z]/g, function (char) {
	      return charsValue[char];
	    });
	    return sanitized.endsWith(controlDigits[number % 23]);
	  }
	};
	
	function isIdentityCard(str) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'any';
	  (0, _assertString.default)(str);
	
	  if (locale in validators) {
	    return validators[locale](str);
	  } else if (locale === 'any') {
	    for (var key in validators) {
	      if (validators.hasOwnProperty(key)) {
	        var validator = validators[key];
	
	        if (validator(str)) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  throw new Error("Invalid locale '".concat(locale, "'"));
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isIn;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	var _toString = _interopRequireDefault(__webpack_require__(580));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function isIn(str, options) {
	  (0, _assertString.default)(str);
	  var i;
	
	  if (Object.prototype.toString.call(options) === '[object Array]') {
	    var array = [];
	
	    for (i in options) {
	      if ({}.hasOwnProperty.call(options, i)) {
	        array[i] = (0, _toString.default)(options[i]);
	      }
	    }
	
	    return array.indexOf(str) >= 0;
	  } else if (_typeof(options) === 'object') {
	    return options.hasOwnProperty(str);
	  } else if (options && typeof options.indexOf === 'function') {
	    return options.indexOf(str) >= 0;
	  }
	
	  return false;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isJSON;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function isJSON(str) {
	  (0, _assertString.default)(str);
	
	  try {
	    var obj = JSON.parse(str);
	    return !!obj && _typeof(obj) === 'object';
	  } catch (e) {
	    /* ignore */
	  }
	
	  return false;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isJWT;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jwt = /^([A-Za-z0-9\-_~+\/]+[=]{0,2})\.([A-Za-z0-9\-_~+\/]+[=]{0,2})(?:\.([A-Za-z0-9\-_~+\/]+[=]{0,2}))?$/;
	
	function isJWT(str) {
	  (0, _assertString.default)(str);
	  return jwt.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lat = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
	var long = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;
	
	function _default(str) {
	  (0, _assertString.default)(str);
	  if (!str.includes(',')) return false;
	  var pair = str.split(',');
	  return lat.test(pair[0]) && long.test(pair[1]);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLength;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	/* eslint-disable prefer-rest-params */
	function isLength(str, options) {
	  (0, _assertString.default)(str);
	  var min;
	  var max;
	
	  if (_typeof(options) === 'object') {
	    min = options.min || 0;
	    max = options.max;
	  } else {
	    // backwards compatibility: isLength(str, min [, max])
	    min = arguments[1];
	    max = arguments[2];
	  }
	
	  var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
	  var len = str.length - surrogatePairs.length;
	  return len >= min && (typeof max === 'undefined' || len <= max);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLowercase;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isLowercase(str) {
	  (0, _assertString.default)(str);
	  return str === str.toLowerCase();
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMACAddress;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var macAddress = /^([0-9a-fA-F][0-9a-fA-F]:){5}([0-9a-fA-F][0-9a-fA-F])$/;
	var macAddressNoColons = /^([0-9a-fA-F]){12}$/;
	
	function isMACAddress(str, options) {
	  (0, _assertString.default)(str);
	
	  if (options && options.no_colons) {
	    return macAddressNoColons.test(str);
	  }
	
	  return macAddress.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMD5;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var md5 = /^[a-f0-9]{32}$/;
	
	function isMD5(str) {
	  (0, _assertString.default)(str);
	  return md5.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMagnetURI;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var magnetURI = /^magnet:\?xt=urn:[a-z0-9]+:[a-z0-9]{32,40}&dn=.+&tr=.+$/i;
	
	function isMagnetURI(url) {
	  (0, _assertString.default)(url);
	  return magnetURI.test(url.trim());
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMimeType;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	  Checks if the provided string matches to a correct Media type format (MIME type)
	
	  This function only checks is the string format follows the
	  etablished rules by the according RFC specifications.
	  This function supports 'charset' in textual media types
	  (https://tools.ietf.org/html/rfc6657).
	
	  This function does not check against all the media types listed
	  by the IANA (https://www.iana.org/assignments/media-types/media-types.xhtml)
	  because of lightness purposes : it would require to include
	  all these MIME types in this librairy, which would weigh it
	  significantly. This kind of effort maybe is not worth for the use that
	  this function has in this entire librairy.
	
	  More informations in the RFC specifications :
	  - https://tools.ietf.org/html/rfc2045
	  - https://tools.ietf.org/html/rfc2046
	  - https://tools.ietf.org/html/rfc7231#section-3.1.1.1
	  - https://tools.ietf.org/html/rfc7231#section-3.1.1.5
	*/
	// Match simple MIME types
	// NB :
	//   Subtype length must not exceed 100 characters.
	//   This rule does not comply to the RFC specs (what is the max length ?).
	var mimeTypeSimple = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+]{1,100}$/i; // eslint-disable-line max-len
	// Handle "charset" in "text/*"
	
	var mimeTypeText = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i; // eslint-disable-line max-len
	// Handle "boundary" in "multipart/*"
	
	var mimeTypeMultipart = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i; // eslint-disable-line max-len
	
	function isMimeType(str) {
	  (0, _assertString.default)(str);
	  return mimeTypeSimple.test(str) || mimeTypeText.test(str) || mimeTypeMultipart.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMobilePhone;
	exports.locales = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	var phones = {
	  'ar-AE': /^((\+?971)|0)?5[024568]\d{7}$/,
	  'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
	  'ar-EG': /^((\+?20)|0)?1[012]\d{8}$/,
	  'ar-IQ': /^(\+?964|0)?7[0-9]\d{8}$/,
	  'ar-JO': /^(\+?962|0)?7[789]\d{7}$/,
	  'ar-KW': /^(\+?965)[569]\d{7}$/,
	  'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
	  'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
	  'ar-TN': /^(\+?216)?[2459]\d{7}$/,
	  'be-BY': /^(\+?375)?(24|25|29|33|44)\d{7}$/,
	  'bg-BG': /^(\+?359|0)?8[789]\d{7}$/,
	  'bn-BD': /\+?(88)?0?1[356789][0-9]{8}\b/,
	  'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
	  'da-DK': /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
	  'de-DE': /^(\+49)?0?1(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7}$/,
	  'el-GR': /^(\+?30|0)?(69\d{8})$/,
	  'en-AU': /^(\+?61|0)4\d{8}$/,
	  'en-GB': /^(\+?44|0)7\d{9}$/,
	  'en-GH': /^(\+233|0)(20|50|24|54|27|57|26|56|23|28)\d{7}$/,
	  'en-HK': /^(\+?852\-?)?[456789]\d{3}\-?\d{4}$/,
	  'en-IE': /^(\+?353|0)8[356789]\d{7}$/,
	  'en-IN': /^(\+?91|0)?[6789]\d{9}$/,
	  'en-KE': /^(\+?254|0)?[7]\d{8}$/,
	  'en-MU': /^(\+?230|0)?\d{8}$/,
	  'en-NG': /^(\+?234|0)?[789]\d{9}$/,
	  'en-NZ': /^(\+?64|0)[28]\d{7,9}$/,
	  'en-PK': /^((\+92)|(0092))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$/,
	  'en-RW': /^(\+?250|0)?[7]\d{8}$/,
	  'en-SG': /^(\+65)?[89]\d{7}$/,
	  'en-TZ': /^(\+?255|0)?[67]\d{8}$/,
	  'en-UG': /^(\+?256|0)?[7]\d{8}$/,
	  'en-US': /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
	  'en-ZA': /^(\+?27|0)\d{9}$/,
	  'en-ZM': /^(\+?26)?09[567]\d{7}$/,
	  'es-ES': /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
	  'es-MX': /^(\+?52)?(1|01)?\d{10,11}$/,
	  'es-UY': /^(\+598|0)9[1-9][\d]{6}$/,
	  'et-EE': /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
	  'fa-IR': /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
	  'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5|6)?|50)\s?(\d\s?){4,8}\d$/,
	  'fo-FO': /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
	  'fr-FR': /^(\+?33|0)[67]\d{8}$/,
	  'he-IL': /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
	  'hu-HU': /^(\+?36)(20|30|70)\d{7}$/,
	  'id-ID': /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
	  'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
	  'ja-JP': /^(\+?81|0)[789]0[ \-]?[1-9]\d{2}[ \-]?\d{5}$/,
	  'kk-KZ': /^(\+?7|8)?7\d{9}$/,
	  'kl-GL': /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
	  'ko-KR': /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
	  'lt-LT': /^(\+370|8)\d{8}$/,
	  'ms-MY': /^(\+?6?01){1}(([0145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
	  'nb-NO': /^(\+?47)?[49]\d{7}$/,
	  'nl-BE': /^(\+?32|0)4?\d{8}$/,
	  'nn-NO': /^(\+?47)?[49]\d{7}$/,
	  'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
	  'pt-BR': /(?=^(\+?5{2}\-?|0)[1-9]{2}\-?\d{4}\-?\d{4}$)(^(\+?5{2}\-?|0)[1-9]{2}\-?[6-9]{1}\d{3}\-?\d{4}$)|(^(\+?5{2}\-?|0)[1-9]{2}\-?9[6-9]{1}\d{3}\-?\d{4}$)/,
	  'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
	  'ro-RO': /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
	  'ru-RU': /^(\+?7|8)?9\d{9}$/,
	  'sl-SI': /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
	  'sk-SK': /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
	  'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
	  'sv-SE': /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
	  'th-TH': /^(\+66|66|0)\d{9}$/,
	  'tr-TR': /^(\+?90|0)?5\d{9}$/,
	  'uk-UA': /^(\+?38|8)?0\d{9}$/,
	  'vi-VN': /^(\+?84|0)((3([2-9]))|(5([689]))|(7([0|6-9]))|(8([1-5]))|(9([0-9])))([0-9]{7})$/,
	  'zh-CN': /^((\+|00)86)?1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/,
	  'zh-TW': /^(\+?886\-?|0)?9\d{8}$/
	};
	/* eslint-enable max-len */
	// aliases
	
	phones['en-CA'] = phones['en-US'];
	phones['fr-BE'] = phones['nl-BE'];
	phones['zh-HK'] = phones['en-HK'];
	
	function isMobilePhone(str, locale, options) {
	  (0, _assertString.default)(str);
	
	  if (options && options.strictMode && !str.startsWith('+')) {
	    return false;
	  }
	
	  if (Array.isArray(locale)) {
	    return locale.some(function (key) {
	      if (phones.hasOwnProperty(key)) {
	        var phone = phones[key];
	
	        if (phone.test(str)) {
	          return true;
	        }
	      }
	
	      return false;
	    });
	  } else if (locale in phones) {
	    return phones[locale].test(str); // alias falsey locale as 'any'
	  } else if (!locale || locale === 'any') {
	    for (var key in phones) {
	      if (phones.hasOwnProperty(key)) {
	        var phone = phones[key];
	
	        if (phone.test(str)) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  throw new Error("Invalid locale '".concat(locale, "'"));
	}
	
	var locales = Object.keys(phones);
	exports.locales = locales;

/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMongoId;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	var _isHexadecimal = _interopRequireDefault(__webpack_require__(972));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isMongoId(str) {
	  (0, _assertString.default)(str);
	  return (0, _isHexadecimal.default)(str) && str.length === 24;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMultibyte;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-control-regex */
	var multibyte = /[^\x00-\x7F]/;
	/* eslint-enable no-control-regex */
	
	function isMultibyte(str) {
	  (0, _assertString.default)(str);
	  return multibyte.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isNumeric;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numeric = /^[+-]?([0-9]*[.])?[0-9]+$/;
	var numericNoSymbols = /^[0-9]+$/;
	
	function isNumeric(str, options) {
	  (0, _assertString.default)(str);
	
	  if (options && options.no_symbols) {
	    return numericNoSymbols.test(str);
	  }
	
	  return numeric.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPort;
	
	var _isInt = _interopRequireDefault(__webpack_require__(973));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isPort(str) {
	  return (0, _isInt.default)(str, {
	    min: 0,
	    max: 65535
	  });
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	exports.locales = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// common patterns
	var threeDigit = /^\d{3}$/;
	var fourDigit = /^\d{4}$/;
	var fiveDigit = /^\d{5}$/;
	var sixDigit = /^\d{6}$/;
	var patterns = {
	  AD: /^AD\d{3}$/,
	  AT: fourDigit,
	  AU: fourDigit,
	  BE: fourDigit,
	  BG: fourDigit,
	  CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
	  CH: fourDigit,
	  CZ: /^\d{3}\s?\d{2}$/,
	  DE: fiveDigit,
	  DK: fourDigit,
	  DZ: fiveDigit,
	  EE: fiveDigit,
	  ES: fiveDigit,
	  FI: fiveDigit,
	  FR: /^\d{2}\s?\d{3}$/,
	  GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
	  GR: /^\d{3}\s?\d{2}$/,
	  HR: /^([1-5]\d{4}$)/,
	  HU: fourDigit,
	  IL: fiveDigit,
	  IN: sixDigit,
	  IS: threeDigit,
	  IT: fiveDigit,
	  JP: /^\d{3}\-\d{4}$/,
	  KE: fiveDigit,
	  LI: /^(948[5-9]|949[0-7])$/,
	  LT: /^LT\-\d{5}$/,
	  LU: fourDigit,
	  LV: /^LV\-\d{4}$/,
	  MX: fiveDigit,
	  NL: /^\d{4}\s?[a-z]{2}$/i,
	  NO: fourDigit,
	  PL: /^\d{2}\-\d{3}$/,
	  PT: /^\d{4}\-\d{3}?$/,
	  RO: sixDigit,
	  RU: sixDigit,
	  SA: fiveDigit,
	  SE: /^\d{3}\s?\d{2}$/,
	  SI: fourDigit,
	  SK: /^\d{3}\s?\d{2}$/,
	  TN: fourDigit,
	  TW: /^\d{3}(\d{2})?$/,
	  UA: fiveDigit,
	  US: /^\d{5}(-\d{4})?$/,
	  ZA: fourDigit,
	  ZM: fiveDigit
	};
	var locales = Object.keys(patterns);
	exports.locales = locales;
	
	function _default(str, locale) {
	  (0, _assertString.default)(str);
	
	  if (locale in patterns) {
	    return patterns[locale].test(str);
	  } else if (locale === 'any') {
	    for (var key in patterns) {
	      if (patterns.hasOwnProperty(key)) {
	        var pattern = patterns[key];
	
	        if (pattern.test(str)) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  throw new Error("Invalid locale '".concat(locale, "'"));
	}

/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isRFC3339;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Based on https://tools.ietf.org/html/rfc3339#section-5.6 */
	var dateFullYear = /[0-9]{4}/;
	var dateMonth = /(0[1-9]|1[0-2])/;
	var dateMDay = /([12]\d|0[1-9]|3[01])/;
	var timeHour = /([01][0-9]|2[0-3])/;
	var timeMinute = /[0-5][0-9]/;
	var timeSecond = /([0-5][0-9]|60)/;
	var timeSecFrac = /(\.[0-9]+)?/;
	var timeNumOffset = new RegExp("[-+]".concat(timeHour.source, ":").concat(timeMinute.source));
	var timeOffset = new RegExp("([zZ]|".concat(timeNumOffset.source, ")"));
	var partialTime = new RegExp("".concat(timeHour.source, ":").concat(timeMinute.source, ":").concat(timeSecond.source).concat(timeSecFrac.source));
	var fullDate = new RegExp("".concat(dateFullYear.source, "-").concat(dateMonth.source, "-").concat(dateMDay.source));
	var fullTime = new RegExp("".concat(partialTime.source).concat(timeOffset.source));
	var rfc3339 = new RegExp("".concat(fullDate.source, "[ tT]").concat(fullTime.source));
	
	function isRFC3339(str) {
	  (0, _assertString.default)(str);
	  return rfc3339.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSurrogatePair;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
	
	function isSurrogatePair(str) {
	  (0, _assertString.default)(str);
	  return surrogatePair.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isURL;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	var _isFQDN = _interopRequireDefault(__webpack_require__(577));
	
	var _isIP = _interopRequireDefault(__webpack_require__(409));
	
	var _merge = _interopRequireDefault(__webpack_require__(222));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_url_options = {
	  protocols: ['http', 'https', 'ftp'],
	  require_tld: true,
	  require_protocol: false,
	  require_host: true,
	  require_valid_protocol: true,
	  allow_underscores: false,
	  allow_trailing_dot: false,
	  allow_protocol_relative_urls: false
	};
	var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;
	
	function isRegExp(obj) {
	  return Object.prototype.toString.call(obj) === '[object RegExp]';
	}
	
	function checkHost(host, matches) {
	  for (var i = 0; i < matches.length; i++) {
	    var match = matches[i];
	
	    if (host === match || isRegExp(match) && match.test(host)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function isURL(url, options) {
	  (0, _assertString.default)(url);
	
	  if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
	    return false;
	  }
	
	  if (url.indexOf('mailto:') === 0) {
	    return false;
	  }
	
	  options = (0, _merge.default)(options, default_url_options);
	  var protocol, auth, host, hostname, port, port_str, split, ipv6;
	  split = url.split('#');
	  url = split.shift();
	  split = url.split('?');
	  url = split.shift();
	  split = url.split('://');
	
	  if (split.length > 1) {
	    protocol = split.shift().toLowerCase();
	
	    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
	      return false;
	    }
	  } else if (options.require_protocol) {
	    return false;
	  } else if (url.substr(0, 2) === '//') {
	    if (!options.allow_protocol_relative_urls) {
	      return false;
	    }
	
	    split[0] = url.substr(2);
	  }
	
	  url = split.join('://');
	
	  if (url === '') {
	    return false;
	  }
	
	  split = url.split('/');
	  url = split.shift();
	
	  if (url === '' && !options.require_host) {
	    return true;
	  }
	
	  split = url.split('@');
	
	  if (split.length > 1) {
	    if (options.disallow_auth) {
	      return false;
	    }
	
	    auth = split.shift();
	
	    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
	      return false;
	    }
	  }
	
	  hostname = split.join('@');
	  port_str = null;
	  ipv6 = null;
	  var ipv6_match = hostname.match(wrapped_ipv6);
	
	  if (ipv6_match) {
	    host = '';
	    ipv6 = ipv6_match[1];
	    port_str = ipv6_match[2] || null;
	  } else {
	    split = hostname.split(':');
	    host = split.shift();
	
	    if (split.length) {
	      port_str = split.join(':');
	    }
	  }
	
	  if (port_str !== null) {
	    port = parseInt(port_str, 10);
	
	    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
	      return false;
	    }
	  }
	
	  if (!(0, _isIP.default)(host) && !(0, _isFQDN.default)(host, options) && (!ipv6 || !(0, _isIP.default)(ipv6, 6))) {
	    return false;
	  }
	
	  host = host || ipv6;
	
	  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
	    return false;
	  }
	
	  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
	    return false;
	  }
	
	  return true;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isUUID;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uuid = {
	  3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
	  4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
	  5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
	  all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
	};
	
	function isUUID(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
	  (0, _assertString.default)(str);
	  var pattern = uuid[version];
	  return pattern && pattern.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isUppercase;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isUppercase(str) {
	  (0, _assertString.default)(str);
	  return str === str.toUpperCase();
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isVariableWidth;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	var _isFullWidth = __webpack_require__(970);
	
	var _isHalfWidth = __webpack_require__(971);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isVariableWidth(str) {
	  (0, _assertString.default)(str);
	  return _isFullWidth.fullWidth.test(str) && _isHalfWidth.halfWidth.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWhitelisted;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isWhitelisted(str, chars) {
	  (0, _assertString.default)(str);
	
	  for (var i = str.length - 1; i >= 0; i--) {
	    if (chars.indexOf(str[i]) === -1) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = matches;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function matches(str, pattern, modifiers) {
	  (0, _assertString.default)(str);
	
	  if (Object.prototype.toString.call(pattern) !== '[object RegExp]') {
	    pattern = new RegExp(pattern, modifiers);
	  }
	
	  return pattern.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = normalizeEmail;
	
	var _merge = _interopRequireDefault(__webpack_require__(222));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_normalize_email_options = {
	  // The following options apply to all email addresses
	  // Lowercases the local part of the email address.
	  // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
	  // The domain is always lowercased, as per RFC 1035
	  all_lowercase: true,
	  // The following conversions are specific to GMail
	  // Lowercases the local part of the GMail address (known to be case-insensitive)
	  gmail_lowercase: true,
	  // Removes dots from the local part of the email address, as that's ignored by GMail
	  gmail_remove_dots: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  gmail_remove_subaddress: true,
	  // Conversts the googlemail.com domain to gmail.com
	  gmail_convert_googlemaildotcom: true,
	  // The following conversions are specific to Outlook.com / Windows Live / Hotmail
	  // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
	  outlookdotcom_lowercase: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  outlookdotcom_remove_subaddress: true,
	  // The following conversions are specific to Yahoo
	  // Lowercases the local part of the Yahoo address (known to be case-insensitive)
	  yahoo_lowercase: true,
	  // Removes the subaddress (e.g. "-foo") from the email address
	  yahoo_remove_subaddress: true,
	  // The following conversions are specific to Yandex
	  // Lowercases the local part of the Yandex address (known to be case-insensitive)
	  yandex_lowercase: true,
	  // The following conversions are specific to iCloud
	  // Lowercases the local part of the iCloud address (known to be case-insensitive)
	  icloud_lowercase: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  icloud_remove_subaddress: true
	}; // List of domains used by iCloud
	
	var icloud_domains = ['icloud.com', 'me.com']; // List of domains used by Outlook.com and its predecessors
	// This list is likely incomplete.
	// Partial reference:
	// https://blogs.office.com/2013/04/17/outlook-com-gets-two-step-verification-sign-in-by-alias-and-new-international-domains/
	
	var outlookdotcom_domains = ['hotmail.at', 'hotmail.be', 'hotmail.ca', 'hotmail.cl', 'hotmail.co.il', 'hotmail.co.nz', 'hotmail.co.th', 'hotmail.co.uk', 'hotmail.com', 'hotmail.com.ar', 'hotmail.com.au', 'hotmail.com.br', 'hotmail.com.gr', 'hotmail.com.mx', 'hotmail.com.pe', 'hotmail.com.tr', 'hotmail.com.vn', 'hotmail.cz', 'hotmail.de', 'hotmail.dk', 'hotmail.es', 'hotmail.fr', 'hotmail.hu', 'hotmail.id', 'hotmail.ie', 'hotmail.in', 'hotmail.it', 'hotmail.jp', 'hotmail.kr', 'hotmail.lv', 'hotmail.my', 'hotmail.ph', 'hotmail.pt', 'hotmail.sa', 'hotmail.sg', 'hotmail.sk', 'live.be', 'live.co.uk', 'live.com', 'live.com.ar', 'live.com.mx', 'live.de', 'live.es', 'live.eu', 'live.fr', 'live.it', 'live.nl', 'msn.com', 'outlook.at', 'outlook.be', 'outlook.cl', 'outlook.co.il', 'outlook.co.nz', 'outlook.co.th', 'outlook.com', 'outlook.com.ar', 'outlook.com.au', 'outlook.com.br', 'outlook.com.gr', 'outlook.com.pe', 'outlook.com.tr', 'outlook.com.vn', 'outlook.cz', 'outlook.de', 'outlook.dk', 'outlook.es', 'outlook.fr', 'outlook.hu', 'outlook.id', 'outlook.ie', 'outlook.in', 'outlook.it', 'outlook.jp', 'outlook.kr', 'outlook.lv', 'outlook.my', 'outlook.ph', 'outlook.pt', 'outlook.sa', 'outlook.sg', 'outlook.sk', 'passport.com']; // List of domains used by Yahoo Mail
	// This list is likely incomplete
	
	var yahoo_domains = ['rocketmail.com', 'yahoo.ca', 'yahoo.co.uk', 'yahoo.com', 'yahoo.de', 'yahoo.fr', 'yahoo.in', 'yahoo.it', 'ymail.com']; // List of domains used by yandex.ru
	
	var yandex_domains = ['yandex.ru', 'yandex.ua', 'yandex.kz', 'yandex.com', 'yandex.by', 'ya.ru']; // replace single dots, but not multiple consecutive dots
	
	function dotsReplacer(match) {
	  if (match.length > 1) {
	    return match;
	  }
	
	  return '';
	}
	
	function normalizeEmail(email, options) {
	  options = (0, _merge.default)(options, default_normalize_email_options);
	  var raw_parts = email.split('@');
	  var domain = raw_parts.pop();
	  var user = raw_parts.join('@');
	  var parts = [user, domain]; // The domain is always lowercased, as it's case-insensitive per RFC 1035
	
	  parts[1] = parts[1].toLowerCase();
	
	  if (parts[1] === 'gmail.com' || parts[1] === 'googlemail.com') {
	    // Address is GMail
	    if (options.gmail_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	
	    if (options.gmail_remove_dots) {
	      // this does not replace consecutive dots like example..email@gmail.com
	      parts[0] = parts[0].replace(/\.+/g, dotsReplacer);
	    }
	
	    if (!parts[0].length) {
	      return false;
	    }
	
	    if (options.all_lowercase || options.gmail_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	
	    parts[1] = options.gmail_convert_googlemaildotcom ? 'gmail.com' : parts[1];
	  } else if (icloud_domains.indexOf(parts[1]) >= 0) {
	    // Address is iCloud
	    if (options.icloud_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	
	    if (!parts[0].length) {
	      return false;
	    }
	
	    if (options.all_lowercase || options.icloud_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (outlookdotcom_domains.indexOf(parts[1]) >= 0) {
	    // Address is Outlook.com
	    if (options.outlookdotcom_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	
	    if (!parts[0].length) {
	      return false;
	    }
	
	    if (options.all_lowercase || options.outlookdotcom_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (yahoo_domains.indexOf(parts[1]) >= 0) {
	    // Address is Yahoo
	    if (options.yahoo_remove_subaddress) {
	      var components = parts[0].split('-');
	      parts[0] = components.length > 1 ? components.slice(0, -1).join('-') : components[0];
	    }
	
	    if (!parts[0].length) {
	      return false;
	    }
	
	    if (options.all_lowercase || options.yahoo_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (yandex_domains.indexOf(parts[1]) >= 0) {
	    if (options.all_lowercase || options.yandex_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	
	    parts[1] = 'yandex.ru'; // all yandex domains are equal, 1st preffered
	  } else if (options.all_lowercase) {
	    // Any other address
	    parts[0] = parts[0].toLowerCase();
	  }
	
	  return parts.join('@');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stripLow;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	var _blacklist = _interopRequireDefault(__webpack_require__(968));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function stripLow(str, keep_new_lines) {
	  (0, _assertString.default)(str);
	  var chars = keep_new_lines ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
	  return (0, _blacklist.default)(str, chars);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toBoolean;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toBoolean(str, strict) {
	  (0, _assertString.default)(str);
	
	  if (strict) {
	    return str === '1' || str === 'true';
	  }
	
	  return str !== '0' && str !== 'false' && str !== '';
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toInt;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toInt(str, radix) {
	  (0, _assertString.default)(str);
	  return parseInt(str, radix || 10);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trim;
	
	var _rtrim = _interopRequireDefault(__webpack_require__(975));
	
	var _ltrim = _interopRequireDefault(__webpack_require__(974));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function trim(str, chars) {
	  return (0, _rtrim.default)((0, _ltrim.default)(str, chars), chars);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = unescape;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function unescape(str) {
	  (0, _assertString.default)(str);
	  return str.replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#x2F;/g, '/').replace(/&#x5C;/g, '\\').replace(/&#96;/g, '`');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = whitelist;
	
	var _assertString = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function whitelist(str, chars) {
	  (0, _assertString.default)(str);
	  return str.replace(new RegExp("[^".concat(chars, "]+"), 'g'), '');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ }),
/* 2324 */,
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(921);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2326 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var toLength = __webpack_require__(__webpack_module_template_argument_1__);
	var toAbsoluteIndex = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	var TAG = __webpack_require__(__webpack_module_template_argument_1__)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(__webpack_module_template_argument_0__)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 2333 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var document = __webpack_require__(__webpack_module_template_argument_1__).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 2334 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 2335 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var document = __webpack_require__(__webpack_module_template_argument_0__).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	module.exports = !__webpack_require__(__webpack_module_template_argument_0__) && !__webpack_require__(__webpack_module_template_argument_1__)(function () {
	  return Object.defineProperty(__webpack_require__(__webpack_module_template_argument_2__)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ITERATOR = __webpack_require__(__webpack_module_template_argument_0__)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var dPs = __webpack_require__(__webpack_module_template_argument_1__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_2__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(__webpack_module_template_argument_4__)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(__webpack_module_template_argument_5__).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_1__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_2__);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var pIE = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_5__);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_6__) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var hiddenKeys = __webpack_require__(__webpack_module_template_argument_1__).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	var arrayIndexOf = __webpack_require__(__webpack_module_template_argument_2__)(false);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_0__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var isEnum = __webpack_require__(__webpack_module_template_argument_3__).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(__webpack_module_template_argument_2__)(Function.call, __webpack_require__(__webpack_module_template_argument_3__).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var shared = __webpack_require__(__webpack_module_template_argument_0__)('keys');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var core = __webpack_require__(__webpack_module_template_argument_0__);
	var global = __webpack_require__(__webpack_module_template_argument_1__);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(__webpack_module_template_argument_2__) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var store = __webpack_require__(__webpack_module_template_argument_0__)('wks');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	var Symbol = __webpack_require__(__webpack_module_template_argument_2__).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var classof = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = __webpack_require__(__webpack_module_template_argument_3__).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var toObject = __webpack_require__(__webpack_module_template_argument_2__);
	var call = __webpack_require__(__webpack_module_template_argument_3__);
	var isArrayIter = __webpack_require__(__webpack_module_template_argument_4__);
	var toLength = __webpack_require__(__webpack_module_template_argument_5__);
	var createProperty = __webpack_require__(__webpack_module_template_argument_6__);
	var getIterFn = __webpack_require__(__webpack_module_template_argument_7__);
	
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_8__)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var $entries = __webpack_require__(__webpack_module_template_argument_1__)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var $values = __webpack_require__(__webpack_module_template_argument_1__)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _draftJs = __webpack_require__(202);
	
	var _getSelectedBlocks = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Calls a provided `modifier` function with a selection for each
	 * selected block in the current editor selection. Passes through additional
	 * arguments to the modifier.
	 *
	 * Note: At the moment it will retain the original selection and override
	 * possible selection changes from modifiers
	 *
	 * @param  {object} editorState The current draft.js editor state object
	 *
	 * @param  {function} modifier  A modifier function to be executed.
	 *                              Must have the signature (editorState, selection, ...)
	 *
	 * @param  {mixed} ...args      Additional arguments to be passed through to the modifier
	 *
	 * @return {object} The new editor state
	 */
	var _default = function _default(editorState, modifier) {
	  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var contentState = editorState.getCurrentContent();
	  var currentSelection = editorState.getSelection();
	  var startKey = currentSelection.getStartKey();
	  var endKey = currentSelection.getEndKey();
	  var startOffset = currentSelection.getStartOffset();
	  var endOffset = currentSelection.getEndOffset();
	  var isSameBlock = startKey === endKey;
	  var selectedBlocks = (0, _getSelectedBlocks["default"])(contentState, startKey, endKey);
	  var finalEditorState = editorState;
	  selectedBlocks.forEach(function (block) {
	    var currentBlockKey = block.getKey();
	    var selectionStart = startOffset;
	    var selectionEnd = endOffset;
	
	    if (currentBlockKey === startKey) {
	      selectionStart = startOffset;
	      selectionEnd = isSameBlock ? endOffset : block.getText().length;
	    } else if (currentBlockKey === endKey) {
	      selectionStart = isSameBlock ? startOffset : 0;
	      selectionEnd = endOffset;
	    } else {
	      selectionStart = 0;
	      selectionEnd = block.getText().length;
	    }
	
	    var selection = new _draftJs.SelectionState({
	      anchorKey: currentBlockKey,
	      anchorOffset: selectionStart,
	      focusKey: currentBlockKey,
	      focusOffset: selectionEnd
	    });
	    finalEditorState = modifier.apply(void 0, [finalEditorState, selection].concat(args));
	  });
	  return _draftJs.EditorState.forceSelection(finalEditorState, currentSelection);
	};
	
	exports["default"] = _default;

/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  Constants: true,
	  getEntityRanges: true,
	  getSelectedBlocks: true,
	  selectionContainsEntity: true,
	  callModifierForSelectedBlocks: true
	};
	Object.defineProperty(exports, "Constants", {
	  enumerable: true,
	  get: function get() {
	    return _Constants["default"];
	  }
	});
	Object.defineProperty(exports, "getEntityRanges", {
	  enumerable: true,
	  get: function get() {
	    return _getEntityRanges["default"];
	  }
	});
	Object.defineProperty(exports, "getSelectedBlocks", {
	  enumerable: true,
	  get: function get() {
	    return _getSelectedBlocks["default"];
	  }
	});
	Object.defineProperty(exports, "selectionContainsEntity", {
	  enumerable: true,
	  get: function get() {
	    return _selectionContainsEntity["default"];
	  }
	});
	Object.defineProperty(exports, "callModifierForSelectedBlocks", {
	  enumerable: true,
	  get: function get() {
	    return _callModifierForSelectedBlocks["default"];
	  }
	});
	
	var _Constants = _interopRequireWildcard(__webpack_require__(__webpack_module_template_argument_0__));
	
	Object.keys(_Constants).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Constants[key];
	    }
	  });
	});
	
	var _getEntityRanges = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _getSelectedBlocks = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	var _selectionContainsEntity = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_3__));
	
	var _callModifierForSelectedBlocks = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_4__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _getSelectedBlocks = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = function _default(strategy) {
	  return function (editorState, selection) {
	    var contentState = editorState.getCurrentContent();
	    var currentSelection = selection || editorState.getSelection();
	    var startKey = currentSelection.getStartKey();
	    var endKey = currentSelection.getEndKey();
	    var startOffset = currentSelection.getStartOffset();
	    var endOffset = currentSelection.getEndOffset();
	    var isSameBlock = startKey === endKey;
	    var selectedBlocks = (0, _getSelectedBlocks["default"])(contentState, startKey, endKey);
	    var entityFound = false; // We have to shift the offset to not get false positives when selecting
	    // a character just before or after an entity
	
	    var finalStartOffset = startOffset + 1;
	    var finalEndOffset = endOffset - 1;
	    selectedBlocks.forEach(function (block) {
	      strategy(block, function (start, end) {
	        if (entityFound) {
	          return;
	        }
	
	        var blockKey = block.getKey();
	
	        if (isSameBlock && (end < finalStartOffset || start > finalEndOffset)) {
	          return;
	        } else if (blockKey === startKey && end < finalStartOffset) {
	          return;
	        } else if (blockKey === endKey && start > finalEndOffset) {
	          return;
	        }
	
	        entityFound = true;
	      }, contentState);
	    });
	    return entityFound;
	  };
	};
	
	exports["default"] = _default;

/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(438);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	var _isPrefixedValue = __webpack_require__(135);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _capitalizeString = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var prefixMapping = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  ms: '-ms-'
	};
	
	function prefixValue(value, propertyPrefixMap) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  for (var i = 0, len = multipleValues.length; i < len; ++i) {
	    var singleValue = multipleValues[i];
	    var values = [singleValue];
	    for (var property in propertyPrefixMap) {
	      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);
	
	      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	        var prefixes = propertyPrefixMap[property];
	        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
	          // join all prefixes and create a new value
	          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
	        }
	      }
	    }
	
	    multipleValues[i] = values.join(',');
	  }
	
	  return multipleValues.join(',');
	}
	
	function transition(property, value, style, propertyPrefixMap) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    var outputValue = prefixValue(value, propertyPrefixMap);
	    // if the property is already prefixed
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-moz-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Webkit') > -1) {
	      return webkitOutput;
	    }
	
	    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-webkit-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Moz') > -1) {
	      return mozOutput;
	    }
	
	    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
	    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
	    return outputValue;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2366 */,
/* 2367 */,
/* 2368 */,
/* 2369 */,
/* 2370 */,
/* 2371 */,
/* 2372 */,
/* 2373 */,
/* 2374 */,
/* 2375 */,
/* 2376 */,
/* 2377 */,
/* 2378 */,
/* 2379 */,
/* 2380 */,
/* 2381 */,
/* 2382 */,
/* 2383 */,
/* 2384 */,
/* 2385 */,
/* 2386 */,
/* 2387 */,
/* 2388 */,
/* 2389 */,
/* 2390 */,
/* 2391 */,
/* 2392 */,
/* 2393 */,
/* 2394 */,
/* 2395 */,
/* 2396 */,
/* 2397 */,
/* 2398 */,
/* 2399 */,
/* 2400 */,
/* 2401 */,
/* 2402 */,
/* 2403 */,
/* 2404 */,
/* 2405 */,
/* 2406 */,
/* 2407 */,
/* 2408 */,
/* 2409 */,
/* 2410 */,
/* 2411 */,
/* 2412 */,
/* 2413 */,
/* 2414 */,
/* 2415 */,
/* 2416 */,
/* 2417 */,
/* 2418 */,
/* 2419 */,
/* 2420 */,
/* 2421 */,
/* 2422 */,
/* 2423 */,
/* 2424 */,
/* 2425 */,
/* 2426 */,
/* 2427 */,
/* 2428 */,
/* 2429 */,
/* 2430 */,
/* 2431 */,
/* 2432 */,
/* 2433 */,
/* 2434 */,
/* 2435 */,
/* 2436 */,
/* 2437 */,
/* 2438 */,
/* 2439 */,
/* 2440 */,
/* 2441 */,
/* 2442 */,
/* 2443 */,
/* 2444 */,
/* 2445 */,
/* 2446 */,
/* 2447 */,
/* 2448 */,
/* 2449 */,
/* 2450 */,
/* 2451 */,
/* 2452 */,
/* 2453 */,
/* 2454 */,
/* 2455 */,
/* 2456 */,
/* 2457 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(28);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// module-6f8fe77d.js